(function () {
    'use strict';

    angular
        .module('investhryApp', [
            'ngStorage',
            'textAngular',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'chart.js',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'btorfs.multiselect',
            'infinite-scroll',
            'angular.filter',
            'checklist-model',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar'
        ])
        .run(run);

    run.$inject = ['stateHandler', 'translationHandler', '$translate', 'translationStorageProvider', '$rootScope'];

    function run(stateHandler, translationHandler, $translate, translationStorageProvider, $rootScope) {
        // Initialize state and translation handlers
        stateHandler.initialize();
        translationHandler.initialize();
        // Retrieve preferred language
        var preferredLanguage = translationStorageProvider.get('NG_TRANSLATE_LANG_KEY') || 'en';
        $translate.use(preferredLanguage);
        // Force re-translation when language changes
        $rootScope.$on('$translateChangeSuccess', function () {
            console.log("Translation successfully changed to:", $translate.use());
        });

        // Google Analytics initialization (unchanged)
        (function (b, o, i, l, e, r) {
            b.GoogleAnalyticsObject = l;
            b[l] || (b[l] =
                function () {
                    (b[l].q = b[l].q || []).push(arguments)
                });
            b[l].l = +new Date;
            e = o.createElement(i);
            r = o.getElementsByTagName(i)[0];
            e.src = '//www.google-analytics.com/analytics.js';
            r.parentNode.insertBefore(e, r)
        }(window, document, 'script', 'ga'));
        ga('create', 'UA-138860801-1', 'auto');
    }


    function appRun($rootScope) {

        $rootScope.appLoading = true;

        $rootScope.$on('$stateChangeStart', function () {
            $rootScope.appLoading = true;
        });

        $rootScope.$on('$stateChangeSuccess', function () {
            $rootScope.appLoading = false;
        });

        $rootScope.$on('$stateChangeError', function () {
            $rootScope.appLoading = false;
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ViewUserServiceStatusController', ViewUserServiceStatusController);

    ViewUserServiceStatusController.$inject = ['$scope', '$filter', 'Principal', 'LoginService', '$state', 'ViewServiceStatus','ServiceStatus','ServiceLevel'];

    function ViewUserServiceStatusController ($scope, $filter, Principal, LoginService, $state, ViewServiceStatus , ServiceStatus, ServiceLevel) {
        var vm = this;
        vm.loadAll=loadAll();

        vm.service = false;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        var isCafSearch = true;
        vm.serviceLevels = [];
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        vm.more = function (index, serviceId) {
            $scope.activeParentIndex = index;
            if (serviceId != null){
                vm.serviceLevelsByServiceId = $filter('filter')(vm.serviceLevels,{serviceId: serviceId});
                vm.serviceLevelsSelected = [];
                vm.serviceLevelsByServiceId.forEach(function (servicelevel) {
                    vm.serviceLevelsSelected[servicelevel.level] = servicelevel.levelDescription;
                });
            }
        };

        $scope.isShowing = function(index){
            return  $scope.activeParentIndex === index;
        };


        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });

        }
        function register () {
            $state.go('register');
        }


        function loadAll() {
            ServiceStatus.query({userName:'user'},function(result) {
                vm.serviceStatuses = result;
                vm.searchQuery = null;
            });

            ServiceLevel.query(function (serviceLevels) {
                vm.serviceLevels = serviceLevels;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('viewServiceStatus', {
            parent: 'app',
            url: '/viewServiceStatus',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/viewServiceStatus/viewServiceStatus.html',
                    controller: 'ViewServiceStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        })
    .state('viewUserServiceStatus', {
            parent: 'app',
            url: '/myServiceStatus',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/viewServiceStatus/viewUsersServiceStatus.html',
                    controller: 'ViewUserServiceStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        })
        .state('feedback-ratings', {
            parent: 'app',
            url: '/feedback-ratings',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/feedbackratingdashboard/feedbacks.html',
                    controller: 'FeedbackDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        });

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ViewServiceStatus', ViewServiceStatus);

    ViewServiceStatus.$inject = ['$resource'];

    function ViewServiceStatus ($resource) {
        var resourceUrl =  '/api/service-statuses/:id/:cafPin';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ViewServiceStatusController', ViewServiceStatusController);

    ViewServiceStatusController.$inject = ['$scope', 'Principal','$filter', 'LoginService', '$state', 'ViewServiceStatus','ServiceStatus','Department','DepartmentService','ServiceLevel'];

    function ViewServiceStatusController ($scope, Principal,$filter , LoginService, $state, ViewServiceStatus , ServiceStatus ,Department ,DepartmentService, ServiceLevel) {
        var vm = this;
        vm.loadAll=loadAll();

        vm.service = false;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.getProject = getProject;
        vm.serviceStatus=[];
        vm.showtable=false;
        vm.departments = [];
        vm.selectedObj={};
        vm.departmentservices = [];
        vm.serviceStatusByService = [];
        vm.showRecord = false;
        vm.findservice = findservice;
        vm.deptservice = deptservice;
        vm.projectbyservice = projectbyservice;
        vm.projectbycafPin = projectbycafPin;
        var isCafSearch = true;

        vm.serviceLevels = [];

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        vm.more = function (index, serviceId) {
            $scope.activeParentIndex = index;
            if (serviceId != null){
                vm.serviceLevelsByServiceId = $filter('filter')(vm.serviceLevels,{serviceId: serviceId});
                vm.serviceLevelsSelected = [];
                vm.serviceLevelsByServiceId.forEach(function (servicelevel) {
                    vm.serviceLevelsSelected[servicelevel.level] = servicelevel.levelDescription;
                });
            }

        };

        $scope.isShowing = function(index){
            return  $scope.activeParentIndex === index;
        };


        function deptservice() {

            vm.service = true;
        }
        function projectbycafPin() {

            vm.service = false;
        }
        function loadAll() {
            Department.query(function(result) {
                angular.forEach(result, function(value, key){
                    if(( value.departmentname === 'LABOUR DEPARTMENT - LABOUR WING' || value.departmentname === 'DAKSHIN HARYANA BIJLI VITRAN NIGAM' || value.departmentname === 'Haryana Shehri Vikas Pradhikaran'
                        || value.departmentname === 'TOWN & COUNTRY PLANNING' || value.departmentname === 'HARYANA STATE POLLUTION CONTROL BOARD' || value.departmentname ==='UTTAR HARYANA BIJLI VITRAN NIGAM' || value.departmentname === 'URBAN LOCAL BODIES'
                        || value.departmentname === 'DEPARTMENT OF INDUSTRIES & COMMERCE' || value.departmentname === 'PUBLIC HEALTH ENGINEERING DEPARTMENT' || value.departmentname === 'HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD'
                        || value.departmentname === 'LABOUR DEPARTMENT - FACTORY WING' || value.departmentname === 'PWD (B & R) DEPARTMENT'
                        || value.departmentname === 'Food and Drug Administration' || value.departmentname === 'FOOD & SUPPLIES DEPARTMENT'
                        || value.departmentname === 'DEPARTMENT OF FORESTS & WILDLIFE')){
                        vm.departments.push(value);
                    }
                });

                vm.searchQuery = null;
            });
            ServiceLevel.query(function (serviceLevels) {
                vm.serviceLevels = serviceLevels;
            });

        }

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });

        }
        function register () {
            $state.go('register');
        }
        function getProject()
        {
            ViewServiceStatus.query({id:"1",cafPin:vm.cafPin},function(result){
                vm.serviceStatus = result;
                if(vm.serviceStatus.length==0) {
                    vm.showtable=false;
                } else {
                    vm.showtable=true;
                }
            });
        }

        function findservice(){
            DepartmentService.query({id:'1', departmentid:vm.deptName},function(result) {
                vm.departmentservices = $filter('filter')(result,{active:true});
                vm.searchQuery = null;
            });

        }

        function projectbyservice()
        {
            ViewServiceStatus.query({serviceId:vm.serviceId},function(result){
                vm.serviceStatusByService = result;
                isCafSearch = false;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('viewprojectdetail', {
            parent: 'app',
            url: '/viewprojectdetail/{status}',
            data: {
                authorities: ['ROLE_RM','ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_ACCOUNT_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/viewprojectdetail/viewprojectdetail.html',
                    controller: 'viewprojectdetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('viewprojectdetail');
                    return $translate.refresh();
                }]
            }
        })
        .state('nodalofficerviewprojectdetail', {
            parent: 'app',
            url: '/nodalofficerviewprojectdetail/{status}',
            data: {
                authorities: ['ROLE_NODAL_OFFICER','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/viewprojectdetail/nodalofficerviewprojectdetail.html',
                    controller: 'nodalofficerviewprojectdetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('viewprojectdetail');
                    return $translate.refresh();
                }]
            }
        })
        .state('showDLCC', {
                    parent: 'viewprojectdetail',
                    url: 'nodalofficerviewprojectdetail/showDLCC/{status}',
                    data: {
                        authorities: ['ROLE_NODAL_OFFICER','ROLE_FILM_OFFICER']
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/viewprojectdetail/showDLCC.html',
                            controller: 'showdlccController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('viewprojectdetail');
                            return $translate.refresh();
                        }]
                    }
                });
    }
})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('viewprojectdetailController', addprojectController);

    addprojectController.$inject = ['$scope', '$stateParams', 'Principal', 'LoginService', '$state','Projectlist', 'Projectbycafpin'];

    function addprojectController ($scope, $stateParams, Principal, LoginService, $state,Projectlist, Projectbycafpin) {
        var vm = this;

        // $scope.currentPage = 1;
        // $scope.pageSize = 100;
        // vm.selectedValue = "100";
        vm.projectlist = [];
        vm.allprojectlist = [];
        vm.loadAll=loadAll;
        vm.findByCafpin=findByCafpin;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        vm.page = 0;
        loadAll(vm.page);
        function loadAll(page) {
            vm.page = page;
            Projectlist.projectList.query({
                id:"1",status:$stateParams.status,
                page: page,
                size: 100
            },function(result) {
                vm.projectlist = result;
                vm.allprojectlist = vm.projectlist.content;
            });
        }

        function findByCafpin(searchText){
            vm.cafpin = searchText;
            Projectbycafpin.query({
                cafpin:vm.cafpin,
            },function(result) {
                vm.allprojectlist = result;
                 // vm.allprojectlist = vm.projectlist.content;
            });
        }

        // $scope.setPageSize = function (pageSizeVal) {
        //     $scope.pageSize = pageSizeVal;
        // }
        //
        // $scope.pageChangedHandler = function(num) {
        //     loadAll();
        // };
    }


})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ShowDLCC', ShowDLCC);

    ShowDLCC.$inject = ['$resource'];

    function ShowDLCC ($resource) {
        var resourceUrl =  '/api/ServiceCafSummaryNodal/showDLCC/:status';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('showdlccController', showdlccController);

    showdlccController.$inject = ['$scope', '$stateParams', 'Principal', 'LoginService', '$state','ServiceCafSummaryNodal','ShowDLCC','ShowButton'];

    function showdlccController ($scope, $stateParams, Principal, LoginService, $state,ServiceCafSummaryNodal,ShowDLCC,ShowButton) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.loadAll = loadAll;

        vm.status = 'Pending';

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        loadAll();

        function loadAll() {
            vm.districtsList = [];
            vm.servicesList = [];

            ShowDLCC.get({
                status: vm.status,
                page: $scope.currentPage - 1,
                size: $scope.pageSize
            },function(result) {
                vm.projectlistDLCC = result;

                angular.forEach(result.content, function(value, key){
                    if(vm.districtsList.indexOf(value.district) === -1){
                        vm.districtsList.push(value.district);
                    }
                    if(vm.servicesList.indexOf(value.serviceName) === -1){
                        vm.servicesList.push(value.serviceName);
                    }
                });

            });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        }

        $scope.pageChangedHandler = function(num) {
            loadAll();
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ShowButton', ShowButton);

    ShowButton.$inject = ['$resource'];

    function ShowButton ($resource) {
        var resourceUrl =  '/api/district-nodal-officers/showDLCC';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceCafSummaryNodal', ServiceCafSummaryNodal);

    ServiceCafSummaryNodal.$inject = ['$resource'];

    function ServiceCafSummaryNodal ($resource) {
        var resourceUrl =  '/api/ServiceCafSummaryNodal/:status';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SearchCafByCafpin', SearchCafByCafpin);

    SearchCafByCafpin.$inject = ['$resource'];

    function SearchCafByCafpin ($resource) {
        var resourceUrl =  '/api/SearchServiceCafSummaryNodalByCafpin/:cafpin';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectbycafpin', Projectbycafpin);

    Projectbycafpin.$inject = ['$resource'];

    function Projectbycafpin ($resource) {
        var resourceUrl =  '/api/ProjectByCafpin/:cafpin';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('nodalofficerviewprojectdetailController', nodalofficerviewprojectdetailController);

    nodalofficerviewprojectdetailController.$inject = ['$scope', '$stateParams', 'Principal', 'LoginService', '$state','ServiceCafSummaryNodal','ShowDLCC','ShowButton', 'District', 'SearchCafByCafpin'];

    function nodalofficerviewprojectdetailController ($scope, $stateParams, Principal, LoginService, $state,ServiceCafSummaryNodal,ShowDLCC,ShowButton, District, SearchCafByCafpin) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.status = $stateParams.status;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        showButton();

        function showButton(){
            ShowButton.get(function(result)
            {
                vm.showButton = result.showbutton;
            });
        }

        loadAll();

        function loadAll() {
            vm.districtsList = [];
            vm.servicesList = [];
            ServiceCafSummaryNodal.get({
                status: vm.status,
                page: $scope.currentPage - 1,
                size: $scope.pageSize
            },function(result) {
                vm.projectlist = result;

                angular.forEach(vm.projectlist.content, function(value, key){
                    if(vm.districtsList.indexOf(value.district) === -1){
                        vm.districtsList.push(value.district);
                    }
                    if(vm.servicesList.indexOf(value.serviceName) === -1){
                        vm.servicesList.push(value.serviceName);
                    }
                });
            });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        };

        $scope.pageChangedHandler = function(num) {
            loadAll();
        };

        vm.getDataByCafpin = function () {
            SearchCafByCafpin.get({cafpin: vm.cafpin}, function (result) {
                vm.projectlist = result
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('viewProjectAdmin', {
            parent: 'app',
            url: '/viewProjectAdmin',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/viewProjectAdmin/viewProjectAdmin.html',
                    controller: 'viewProjectAdminController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        });

        }
        })();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ViewProjectAdmin', ViewProjectAdmin);

    ViewProjectAdmin.$inject = ['$resource'];

    function ViewProjectAdmin ($resource) {
        var resourceUrl =  '/api/ViewProjectAdmin/:type/:Status';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('viewProjectAdminController', viewProjectAdminController);

    viewProjectAdminController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'ViewProjectAdmin'];

    function viewProjectAdminController ($scope, Principal, LoginService, $state, ViewProjectAdmin) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.viewcafs = viewcafs;
        vm.isloadingrequest=false;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        vm.type="new";
        vm.status="All";
        loadall();
        function loadall()
        {
           $scope.message = "All New Cafs";
           vm.isloadingrequest=true;
           ViewProjectAdmin.query({type:vm.type,Status:vm.status},function(result)
           {
              vm.projectlist = result;
              vm.isloadingrequest=false;
           });
        }

        function viewcafs(status)
        {
            vm.projectlist=[];
            vm.status=status;
            if(vm.type==="new")
            {
                if(vm.status==="All")
                {
                    $scope.message = "All New Cafs";
                }
                if(vm.status==="Pending")
                {
                    $scope.message = "Pending New Cafs";
                }
                if(vm.status==="Completed")
                {
                    $scope.message = "Completed New Cafs";
                }
                if(vm.status==="DeemedClear")
                {
                    $scope.message = "DeemedClear New Cafs";
                }
            }
            if(vm.type==="Renewable")
            {
                if(vm.status==="All")
                {
                    $scope.message = "All Renewable Cafs";
                }
                if(vm.status==="Pending")
                {
                    $scope.message = "Pending Renewable Cafs";
                }
                if(vm.status==="Completed")
                {
                    $scope.message = "Completed Renewable Cafs";
                }
                if(vm.status==="DeemedClear")
                {
                    $scope.message = "DeemedClear Renewable Cafs";
                }
            }
            if(vm.type==="ShopCaf")
            {
                if(vm.status==="All")
                {
                    $scope.message = "All Shop Cafs";
                }
                if(vm.status==="Pending")
                {
                    $scope.message = "Pending Shop Cafs";
                }
                if(vm.status==="Completed")
                {
                    $scope.message = "Completed Shop Cafs";
                }
                if(vm.status==="DeemedClear")
                {
                    $scope.message = "DeemedClear Shop Cafs";
                }
            }
            if(vm.type==="LandRequirementCaf")
            {
                if(vm.status==="All")
                {
                    $scope.message = "All Land Requirement Cafs";
                }
                if(vm.status==="Pending")
                {
                    $scope.message = "Pending Land Requirement Cafs";
                }
                if(vm.status==="Completed")
                {
                    $scope.message = "Completed Land Requirement Cafs";
                }
                if(vm.status==="DeemedClear")
                {
                    $scope.message = "DeemedClear Land Requirement Cafs";
                }
            }
            vm.isloadingrequest=true;
            ViewProjectAdmin.query({type:vm.type,Status:vm.status},function(result)
            {
                vm.projectlist = result;
                vm.isloadingrequest=false;
            });
        }

        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerInstallationBelowService', TowerInstallationBelowService);

    TowerInstallationBelowService.$inject = ['$resource'];

    function TowerInstallationBelowService ($resource) {
        var resourceUrl =  'api/get-BelowTowerRequests';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();


(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerInstallationAboveService', TowerInstallationAboveService);

    TowerInstallationAboveService.$inject = ['$resource'];

    function TowerInstallationAboveService ($resource) {
        var resourceUrl =  'api/get-AboveTowerRequests';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('towerInstallation', {
            parent: 'app',
            url: '/towerInstallation',
            data: {
                authorities: ['ROLE_TOWER_DC', 'ROLE_TOWER_NODAL_OFFICER', 'ROLE_TOWER_DEPARTMENT'],
                pageTitle: 'global.menu.towerInstallation'
            },
            views: {
                'content@': {
                    templateUrl: 'app/towerInstallation/towerInstallation.html',
                    controller: 'TowerInstallationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerInstallation');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerInstallationService', TowerInstallationService);

    TowerInstallationService.$inject = ['$resource'];

    function TowerInstallationService ($resource) {
        var resourceUrl =  'api/get-TowerRequests/:type/:filter';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();


(function () {
    'use strict';

    angular
        .module('investhryApp')
        .directive('aboutToday', aboutToday);

    aboutToday.$inject = ['TowerInstallationService'];

    function aboutToday(TowerInstallationService) {

        var directive = {
            restrict: 'A',
            template: 'Today is {{weekday}}, the {{dateWithOrdinal}} of {{month}}, {{fullYear}}',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {

            element.addClass('text-left');

            var today = new Date();
            var date = today.getDate();

            scope.weekday = today.toLocaleString('en-us', {weekday: 'long'});
            scope.dateWithOrdinal = date + TowerInstallationService.getOrdinalIndicator(date);
            scope.month = today.toLocaleString('en-us', {month: 'long'});
            scope.fullYear = today.getFullYear();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerInstallationController', TowerInstallationController);

    TowerInstallationController.$inject = ['$scope', '$state', 'Principal', 'TowerInstallationAboveService', 'TowerInstallationBelowService', 'TowerInstallationService', 'Above_ground', 'Below_ground', 'Tower_log','downloadserviceformattachment','FileManagement'];

    function TowerInstallationController($scope, $state, Principal , TowerInstallationAboveService, TowerInstallationBelowService, TowerInstallationService, Above_ground, Below_ground, Tower_log,downloadserviceformattachment,FileManagement) {
        var vm = this;
        vm.save= save;

        vm.show_type=show_type;
        vm.show_status=show_status;

        vm.action= action;
        vm.detail= detail;
        vm.download=download;
        vm.view_log=view_log;
        vm.disableSave=disableSave;
        vm.towerLog={};
        vm.show_request=show_request;

        vm.towertype='Above';
        vm.status='N';
        vm.requesttype='false';

        $scope.file={};

        vm.forward=forward;
        // vm.get_TowerRequests=get_TowerRequests;

        loadAll(vm.towertype,vm.status,vm.requesttype);

        function loadAll(towertype,status,requesttype) {
            if(towertype==='Above'){
                vm.show1= false;
                vm.show2= false;
                console.log(status);
                console.log(requesttype);
                TowerInstallationAboveService.query({status:status,request:requesttype},function (result) {
                    vm.above_grounds = result;
                    vm.searchQuery = null;
                })
            }
            else {
                vm.show1= true;
                vm.show2= true;
                TowerInstallationBelowService.query({status:status,request:requesttype},function (result) {
                    vm.below_grounds = result;
                    vm.searchQuery = null;
                })
            }

        }

        function save (id) {
            vm.isSaving = true;
            vm.id=id;

            if (vm.comment_title==='clear'){
                uploadFiles();
            }
            else {
                if (vm.option==='Above'){
                    Above_ground.update(vm.result, onSaveSuccess, onSaveError);
                }else if(vm.option==='Below'){
                    if (vm.comment_title==='clear'){}
                    Below_ground.update(vm.result, onSaveSuccess, onSaveError);
                }
            }

        }

        function onSaveSuccess (result) {
            vm.tower_log.tower_id= vm.id;
            vm.tower_log.action= vm.comment_title;
            // vm.tower_log.action_by=vm.username;
            Tower_log.save(vm.tower_log,onLogSaveSuccess);

            vm.isSaving = false;
        }
        function onLogSaveSuccess (result) {
            UIkit.modal('#modal5').hide();
            vm.tower_log.comment =null;
            $state.reload();
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function action(i,object,option) {
            vm.applicant_id= object.id;
            vm.name_applicant= object.name_applicant;

            var result=angular.copy(object);
            vm.option=option;
            if(i===1){
                vm.comment_title= "clear";
                result.status= 'Cleared';
            }
            else if(i===2) {
                vm.comment_title= "comment";
            }
            else if(i===3){
                vm.comment_title= "reject";
                result.status = 'Rejected';
            }
            vm.result= result;
        }

        function detail(i,id) {
            if(i===1){
               vm.above_ground = Above_ground.get({id : id});
            }
            else if(i===2){
               vm.below_ground = Below_ground.get({id : id});
            }
        }

        function download(serverfilename,clientfilename) {
            console.log(serverfilename);
            downloadserviceformattachment.download(serverfilename,clientfilename);
        }

        function view_log(id) {
            console.log(id);
           Tower_log.query({towerId: id},function (result){
               vm.towerLog=result;
               console.log(result);
            });
        }

        function uploadFiles() {
            var fileNameArray = vm.clearancefile1.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var filename = vm.result.id+'_'+ 'clearancefile1';
            vm.result.clearancefile1=filename+ "." + fileextension;
            var file =vm.clearancefile1;
            FileManagement.saveFile(file,filename,onFile1UploadSuccess,onFile1UploadError);
        }

        function onFile1UploadSuccess() {
           UIkit.notification("File Uploaded Successfully . . .",{timeout: 2000});
            var fileNameArray = vm.clearancefile2.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var filename = vm.result.id+'_'+ 'clearancefile2';
            vm.result.clearancefile2=filename+ "." + fileextension;
            var file =vm.clearancefile2;
            FileManagement.saveFile(file,filename,onFile2UploadSuccess,onFile2UploadError);

        }
        function onFile2UploadSuccess() {
           UIkit.notification("File Uploaded Successfully . . .",{timeout: 2000});
            var fileNameArray = vm.clearancefile3.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var filename = vm.result.id+'_'+ 'clearancefile3';
            vm.result.clearancefile3=filename+ "." + fileextension;
            var file =vm.clearancefile3;
            FileManagement.saveFile(file,filename,onFile3UploadSuccess,onFile3UploadError);

        }
        function onFile3UploadSuccess() {
           UIkit.notification("File Uploaded Successfully . . .",{timeout: 2000});
            if (vm.option==='Above'){
                Above_ground.update(vm.result, onSaveSuccess, onSaveError);
                console.log('updated above');
            }else if(vm.option==='Below'){
                Below_ground.update(vm.result, onSaveSuccess, onSaveError);
                console.log('updated below');
            }
        }
        function onFile1UploadError() {
            UIkit.notification("Unexpected Error Occurred! Try Again . .",{timeout: 2000,status: 'danger'});
        }

        function onFile2UploadError() {
            UIkit.notification("Unexpected Error Occurred! Try Again . .",{timeout: 2000,status: 'danger'});
        }

        function onFile3UploadError() {
            UIkit.notification("Unexpected Error Occurred! Try Again . .",{timeout: 2000,status: 'danger'});
        }

        function forward(object,option,role) {
            vm.applicant_id= object.id;
            vm.name_applicant= object.name_applicant;

            var result=angular.copy(object);
            vm.option=option;

            if(role==='DC'){
                vm.comment_title= "Forward ( TO DIO )";
               result.isforwardedtodio=true;
            }
            else if(role==='DIO'){
                vm.comment_title= "Forward ( TO DC )";
                result.isforwardedtodept=true;
            }
            else if(role==='DEPT'){
                vm.comment_title= "Forward ( TO DEPT )";
                result.isforwardedtodc=true;
            }
            vm.result= result;
        }

        // function get_TowerRequests() {
        //     TowerInstallationService.query({type: 'Above', filter: 'new'},function(result){
        //         vm.towerRequests= result;
        //         console.log(result);
        //     });
        // }

        function show_type(towertype) {
           vm.towertype=towertype;
           loadAll(vm.towertype,vm.status,vm.requesttype);
        }

        function show_request(requesttype){
            vm.requesttype= requesttype;
            loadAll(vm.towertype,vm.status,vm.requesttype);
        }

        function show_status(status) {
            vm.status=status;
            loadAll(vm.towertype,vm.status,vm.requesttype);
        }

        function disableSave() {
            return (!angular.isDefined(vm.clearancefile3)) || (!angular.isDefined(vm.clearancefile2)) || (!angular.isDefined(vm.clearancefile1));
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerClearedDocumentController', TowerClearedDocumentController);

    TowerClearedDocumentController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'SearchTowerCAF', 'downloadService'];

    function TowerClearedDocumentController ($scope, Principal, LoginService, $state, SearchTowerCAF, downloadService) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.getProject = getProject;
        vm.project=[];

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });


        // getAccount();
        //
        // function getAccount() {
        //     Principal.identity().then(function(account) {
        //         vm.account = account;
        //         vm.isAuthenticated = Principal.isAuthenticated;
        //     });
        // }
        function register () {
            $state.go('register');
        }
        function getProject()
        {
            vm.project=null;
            vm.showtable=false;
            SearchTowerCAF.query({CAFPIN:vm.CAFPIN},function(result){
                vm.project = result;
                if(vm.project.length !==0){
                    vm.noProject = false;
                    vm.showtable=true;
                }
                else{
                    vm.noProject = true;
                }
            });
        }


        vm.downFile = function(project) {
            downloadService.download(project.fileName)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('searchTowerCAF', {
            parent: 'app',
            url: '/searchTowerServiceClearanceCAFWise',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/towerClearedServiceDocument/searchClearedTowerCAF.html',
                    controller: 'TowerClearedDocumentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });

        }
        })();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SearchTowerCAF', SearchTowerCAF);

    SearchTowerCAF.$inject = ['$resource'];

    function SearchTowerCAF ($resource) {
        var resourceUrl =  '/api/searchTowerClearedCAF/:CAFPIN';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
         .state('towerServiceCAF', {
          parent: 'app',
          url: '/towerServiceCAF/{status}',
          data: {
              authorities: ['ROLE_ADMIN','ROLE_TOWER_MONITORING_OFFICER']
          },
             views: {
                 'content@': {
                     templateUrl: 'app/towerCafServices/towerCafsServices.html',
                     controller: 'TowerCAFServicesController',
                     controllerAs: 'vm'
                 }
             },
             resolve: {
                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                     $translatePartialLoader.addPart('state');
                     return $translate.refresh();
                 }]
             }
      })
    .state('serviceLogTower', {
            parent: 'towerServiceCAF',
            url: '/{projectserviceid}/{projectid}/{serviceid}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TOWER_MONITORING_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/serviceclearanceactions/serviceLog.html',
                    controller: 'serviceLogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }],
                        serviceLogList: ['GetServiceLog', function(GetServiceLog) {
                            return GetServiceLog.query({projectid:$stateParams.projectid,serviceid:$stateParams.serviceid});
                        }],
                        service: ['DepartmentService', function(DepartmentService) {
                            return DepartmentService.get({id : $stateParams.serviceid}).$promise;
                        }],
                        projectService: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('towerServiceCAF', null, { reload: 'towerServiceCAF' });
                }, function() {
                    $state.go('towerServiceCAF');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerServiceAllCAF', TowerServiceAllCAF);

    TowerServiceAllCAF.$inject = ['$resource'];

    function TowerServiceAllCAF ($resource) {
        var resourceUrl =  'api/allTowerServiceCAF/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerCAFServicesController', TowerCAFServicesController);

    TowerCAFServicesController.$inject = ['$timeout', '$scope', '$stateParams', 'TowerServiceAllCAF', 'DownloadTowerCafs', 'DownloadCafCsv', 'SearchTowerCafs'];
    function TowerCAFServicesController ($timeout, $scope, $stateParams, TowerServiceAllCAF, DownloadTowerCafs, DownloadCafCsv, SearchTowerCafs) {
        var vm = this;
        vm.towerData = [];
        vm.status='Pending';
        // vm.searchText = null;
        // vm.status=$stateParams.status;
        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.downloadAllData = downloadAllData;
        vm.getTowerCafs = getTowerCafs;
        vm.cafPin = null;

        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        loadAllCafs();
        function loadAllCafs() {
            vm.dashboardcafs=TowerServiceAllCAF.get({
                status: vm.status,
                page: $scope.currentPage - 1,
                size: $scope.pageSize}, function(result) {
                vm.towerData = result;
                console.log(vm.towerData);
                vm.show = true;
            });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        }
        $scope.pageChanged = function(num) {
            loadAllCafs();
        };

        vm.statusSelected=function () {
            loadAllCafs();
            vm.cafPin = null;
        };

        function downloadAllData() {
            DownloadTowerCafs.query({
                status: vm.status
            },function (result) {
                DownloadCafCsv.download(result[0].status).then(function (success) {
                    console.log(success);
                }, function (error) {
                    alert('error : ' + error);
                });
            });
        }

        function getTowerCafs(cafPin) {
            SearchTowerCafs.query({
                status: vm.status,
                cafPin: cafPin}, function (result) {
                vm.towerData.content = result;
                vm.show = true;
            });
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SearchTowerCafs', SearchTowerCafs);

    SearchTowerCafs.$inject = ['$resource'];

    function SearchTowerCafs ($resource) {
        var resourceUrl =  'api/allTowerServiceCAFByCafPin/:status/:cafPin';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DownloadTowerCafs', DownloadTowerCafs);

    DownloadTowerCafs.$inject = ['$resource'];

    function DownloadTowerCafs ($resource) {
        var resourceUrl =  'api/downloadTowerCafsByElastic/status';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

// (function () {
//     'use strict';
//
//     angular
//         .module('investhryApp')
//         .controller('TowerRemovalViewController', TowerRemovalViewController);
//
//     TowerRemovalViewController.$inject = ['$scope', 'TowerRemovalApplyService', 'District', 'Project'];
//
//     function TowerRemovalViewController($scope, TowerRemovalApplyService, District, Project) {
//         var vm = this;
//         vm.businessEntities = [];
//
//
//         loadApplicationAppliedBy();
//
//
//
//
//         function loadApplicationAppliedBy() {
//             TowerRemovalApplyService.queryByBusinessEntityUser(function (result) {
//                 vm.applications = result;
//             });
//         };
//
//
//
//         vm.openEditModal = function (row) {
//             vm.editData = angular.copy(row);  // load row into modal
//
//             $('#editTowerModal').modal('show');   // open modal
//         };
//
//         vm.ApproveTower = function () {
//
//             vm.editData.status = "Approved";
//
//             TowerRemovalApplyService.update(vm.editData,
//                 function success() {
//                     alert("Approved successfully!");
//                     $('#editTowerModal').modal('hide');
//                     loadApplicationAppliedBy(); // refresh table
//                 },
//                 function error(err) {
//                     console.log("Error updating:", err);
//                 }
//             );
//         };
//
//
//
//     }
// })();



(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerRemovalViewController', TowerRemovalViewController);

    TowerRemovalViewController.$inject = [
        '$scope',
        'TowerRemovalApplyService',
        'District',
        'Project',
        'TowerRemovalStatus'
    ];

    function TowerRemovalViewController($scope, TowerRemovalApplyService, District, Project, TowerRemovalStatus) {
        var vm = this;
        $scope.file = {};
        $scope.removalPlanRemark = {};
        vm.form = {};  // IMPORTANT



        vm.Status = TowerRemovalStatus;  // <-- expose constants

        vm.businessEntities = [];

        loadApplicationAppliedBy();

        function loadApplicationAppliedBy() {
            TowerRemovalApplyService.queryByBusinessEntityUser(function (result) {
                vm.applications = result;
            });
        }



        vm.openEditModal = function (app) {
            vm.selectedApp = app;  // <--- save selected row object
            vm.form = {};          // reset form
            $('#submitPlan').modal('show');
        }


        vm.submitPlan = function () {


            var id = vm.selectedApp.id;   // <--- GET THE ID HERE

            var formData = new FormData();

            // Append JSON data as a Blob
            var dto = {
                id: id,
                remark: vm.form.removalPlanRemark,
                file: vm.form.file
            };

            formData.append('data', new Blob([angular.toJson(dto)], { type: "application/json" }));

            console.log("formdataaa" + formData);



            // Append file if present
            if (vm.form.file) {
                formData.append('file', vm.form.file);
            }

            console.log("formdataaa" + dto);

            // Send the request
            TowerRemovalApplyService.submitPlan(formData,
                function success() {

                    alert(" Request Submitted successfully!");
                    $('#submitPlan').modal('hide');


                    loadApplicationAppliedBy();

                    // 🔥 RESET ALL MODELS
                    vm.form = {};

                    // 🔥 RESET FILE INPUT MANUALLY
                    document.querySelector('input[type="file"]').value = null;

                    // 🔥 RESET ANGULAR FORM STATE
                    if ($scope.inspectionForm) {
                        $scope.inspectionForm.$setPristine();
                        $scope.inspectionForm.$setUntouched();
                    }
                },
                function error(err) {
                    console.log("Error in submitting:", err);
                });

        };

        // It set the field value null on close button and cancel button
        $('#submitPlan').on('hidden.bs.modal', function () {
            if (vm && vm.form) {
                vm.form.file = null;
                vm.form.removalPlanRemark = null;
            }

            // Reset the file input in UI
            $(this).find('input[type="file"]').val('');
        });
        $('#submitConfirmationPlan').on('hidden.bs.modal', function () {
            if (vm && vm.form) {
                vm.form.file = null;
                vm.form.removalPlanRemark = null;
            }

            // Reset the file input in UI
            $(this).find('input[type="file"]').val('');
        });



        vm.openModalForConfirmationPlan = function (app) {
            vm.selectedApp = app;  // <--- save selected row object
            vm.form = {};          // reset form
            $('#submitConfirmationPlan').modal('show');
        }

        vm.submitConfimationPlan = function () {


            var id = vm.selectedApp.id;   // <--- GET THE ID HERE

            var formData = new FormData();

            // Append JSON data as a Blob
            var dto = {
                id: id,
                remark: vm.form.removalPlanRemark,
                file: vm.form.file
            };

            formData.append('data', new Blob([angular.toJson(dto)], { type: "application/json" }));

            console.log("formdataaa" + formData);



            // Append file if present
            if (vm.form.file) {
                formData.append('file', vm.form.file);
            }

            console.log("formdataaa" + dto);


            // Send the request
            TowerRemovalApplyService.submitConfirmationPlan(formData,
                function success() {
                    alert(" Request for confrimation plan Submitted successfully!");
                    $('#submitConfirmationPlan').modal('hide');

                    loadApplicationAppliedBy();

                    // 🔥 RESET ALL MODELS
                    vm.form = {};

                    // 🔥 RESET FILE INPUT MANUALLY
                    document.querySelector('input[type="file"]').value = null;

                    // 🔥 RESET ANGULAR FORM STATE
                    if ($scope.inspectionForm) {
                        $scope.inspectionForm.$setPristine();
                        $scope.inspectionForm.$setUntouched();
                    }
                },
                function error(err) {
                    console.log("Error in submitting:", err);
                });

        };




    }
})();

angular.module('investhryApp')
    .constant('TowerRemovalStatus', {
        PENDING: "PENDING",
        OVERDUE: "OVERDUE",
        REMOVAL_OVERDUE: "REMOVAL_OVERDUE",
        REMOVAL_PLAN_SUBMITTED: "REMOVAL_PLAN_SUBMITTED",
        CONFIRMATION_PLAN_SUBMITTED: "CONFIRMATION_PLAN_SUBMITTED"
    });

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tower-removal-apply', {
            parent: 'app',
            url: '/tower-removal-apply',
            data: {
                authorities: [],
                pageTitle: 'global.menu.third-party-inspection'
            },
            views: {
                'content@': {
                    templateUrl: 'app/tower-removal/tower-removal-apply.html',
                    controller: 'TowerRemovalApplyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tower-removal-apply');
                    return $translate.refresh();
                }]
            }
        }),
            $stateProvider.state('tower-removal-view', {
                parent: 'app',
                url: '/tower-removal-view',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.tower-removal-view'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/tower-removal/tower-removal-view.html',
                        controller: 'TowerRemovalViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tower-removal-view');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('TowerRemovalApplyService', TowerRemovalApplyService);

    TowerRemovalApplyService.$inject = ['$resource'];

    function TowerRemovalApplyService($resource) {

        var resourceUrl = 'api/tower-removal/:id';

        return $resource(resourceUrl, {}, {

            save: {
                method: 'POST',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined } // Let browser set multipart boundary
            },

            submitPlan: {
                method: 'POST',
                url: 'api/tower-removal/submitPlan',   // New backend API endpoint
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined } // Let browser set multipart boundary
            },
            submitConfirmationPlan: {
                method: 'POST',
                url: 'api/tower-removal/submitConfirmationPlan',   // New backend API endpoint
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined } // Let browser set multipart boundary
            },



            // Existing APIs
            // 'save':   { method: 'POST' },
            'update': { method: 'PUT' },
            'get':    { method: 'GET' },
            'query':  { method: 'GET', isArray: true },
            'delete': { method: 'DELETE' },

            // ⭐ New API to fetch by district and cafType
            'findByDistrictAndCafType': {
                method: 'GET',
                url: 'api/projectByDistrictAndCafType',   // New backend API endpoint
                isArray: true,
                params: {
                    district: '@district',
                    cafType: '@cafType'
                }
            },

            'findByDistrictAndCafTypeWithApprovedTower': {
                method: 'GET',
                url: 'api/projectByDistrictAndCafTypeAndApprovedServices',   // New backend API endpoint
                isArray: true,
                params: {
                    district: '@district',
                    cafType: '@cafType'
                }
            },




            'findAllApprovedTowerByProjectId': {
                method: 'GET',
                url: 'api/approvedTowers',   // New backend API endpoint
                isArray: true,
                params: {
                    projectId: '@projectId',
                }
            },


            'findByCafType': {
                method: 'GET',
                url: 'api/projectByCafType',   // New backend API endpoint
                isArray: true,
                params: {
                    cafType: '@cafType'
                }
            },


            'findAllApprovedTowersFromProjectServiceDetails': {
                method: 'GET',
                url: 'api/approvedTowers',   // New backend API endpoint
                isArray: true,
                params: {
                    projectId: '@projectId'
                }
            },


            'queryByUser': {
                method: 'GET',
                isArray: true,
                url: 'api/tower-removal/findByAppliedBy'
            } ,

            'queryByBusinessEntityUser': {
                method: 'GET',
                isArray: true,
                url: 'api/tower-removal/findByBusinessEntityUser'
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerRemovalApplyController', TowerRemovalApplyController);

    TowerRemovalApplyController.$inject = ['$scope', 'TowerRemovalApplyService', 'District', 'Project'];

    function TowerRemovalApplyController($scope, TowerRemovalApplyService, District, Project) {
        var vm = this;

        // --------------------------
        // STATIC DISTRICT LIST
        // // --------------------------
        // vm.districts = [
        //     { id: 1, name: "Gurugram" },
        //     { id: 2, name: "Faridabad" },
        //     { id: 3, name: "Hisar" },
        //     { id: 4, name: "Sonipat" },
        //     { id: 5, name: "Rohtak" }
        // ];

        // --------------------------
        // BUSINESS ENTITIES BY DISTRICT
        // --------------------------
        // vm.entitiesByDistrict = {
        //     TemporaryTowerApplyService.findByDistrictAndCafType({
        //         district: vm.selectedDistrict,
        //         cafType: vm.selectedCafType
        //     }, function (response) {
        //         vm.searchResults = response;
        //     });
        // };

        vm.businessEntities = [];
        vm.services = [];
        $scope.file = {};
        vm.form = {};  // IMPORTANT



        loadAllDistrict();
        // loadUserApplications()
        loadApplicationAppliedBy();

        vm.districts = [];
        function loadAllDistrict(){
            District.query(function(result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

        vm.load = function(id) {
            TowerRemovalApplyService.get({ id: id }, function(result) {
                // vm.form = result;
                // vm.selectedDistrict = result.district;
            });
        };




        function loadApplicationAppliedBy() {
            TowerRemovalApplyService.queryByUser(function (result) {
                vm.applications = result;
            });
        };

        // --------------------------
        // WHEN DISTRICT CHANGES
        // --------------------------
        vm.loadBusinessEntities = function () {

            TowerRemovalApplyService.findByDistrictAndCafTypeWithApprovedTower({
                district: vm.selectedDistrict.districtname,
                cafType: "Tower",
            }, function (response) {
                vm.businessEntities = response;

            });

        };




        vm.loadServices = function () {


            var selected = vm.form.selectedEntity;

            console.log("Selected ID:", selected.id);

            TowerRemovalApplyService.findAllApprovedTowerByProjectId({
                projectId: selected.id
            }, function (response) {
                vm.services = response;
            });
        };

        // vm.loadServices = function () {
        //     var selected = vm.form.selectedEntity;
        //
        //     console.log("Selected ID:", selected.id);
        //     console.log("Selected CAF:", selected.cafpin);
        //
        //     MyService.getServices({
        //         entityId: selected.id,
        //         cafpin: selected.cafpin
        //     }, function (response) {
        //         vm.services = response;
        //     });
        // };
        //





        vm.applyTowerRemoval = function () {

            // Create FormData object
            var formData = new FormData();

            // Append JSON data as a Blob
            var dto = {
                district: vm.selectedDistrict.districtname,
                businessEntity: vm.form.selectedEntity.id,
                serviceName:vm.form.service,
                remark: vm.form.remark,
                status: "Pending"
            };


            formData.append('data', new Blob([angular.toJson(dto)], { type: "application/json" }));

            // Append file if present
            if (vm.form.file) {
                formData.append('file', vm.form.file);
            }

            console.log("formdataaa" + formData);

            // Send the request
            TowerRemovalApplyService.save(formData,
                function success() {
                    alert(" Request Submitted successfully!");
                    loadApplicationAppliedBy();

                    // 🔥 RESET ALL MODELS
                    vm.form = {};
                    vm.selectedDistrict = null;
                    vm.businessEntities = [];
                    vm.services = [];

                    // 🔥 RESET FILE INPUT MANUALLY
                    document.querySelector('input[type="file"]').value = null;

                    // 🔥 RESET ANGULAR FORM STATE
                    if ($scope.inspectionForm) {
                        $scope.inspectionForm.$setPristine();
                        $scope.inspectionForm.$setUntouched();
                    }
                },
                function error(err) {
                    console.log("Error in submitting:", err);
                });

        };

        vm.openEditModal = function (row) {
            vm.editData = angular.copy(row);  // load row into modal

            $('#editTowerModal').modal('show');   // open modal
        };




        vm.updateLocation = function () {

            TowerRemovalApplyService.update(vm.editData,
                function success() {
                    alert("Location updated successfully!");
                    $('#editTowerModal').modal('hide');
                    loadApplicationAppliedBy(); // refresh table
                },
                function error(err) {
                    console.log("Error updating:", err);
                }
            );
        };



    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TotalDownloadDetailYearly', TotalDownloadDetailYearly);

    TotalDownloadDetailYearly.$inject = ['$resource'];

    function TotalDownloadDetailYearly ($resource) {
        var resourceUrl =  'api/servicedashboardcafsYearlyListByElasticByStatus/departmentName/district/projectLevel/serviceId/status/fromdate/todate';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
         .state('totaldeptservicesdetailyearly', {
          parent: 'servicedashboardyearly',
          url: '/servicedashboardcafsYearlyByElasticByStatus/{departmentName}/{district}/{projectLevel}/{serviceId}/{status}',
          data: {
              authorities: []
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'app/totaldeptservicesdetailyearly/totaldeptservicesdetailyearly.html',
                  controller: 'TotalDeptServicesDetailYearlyController',
                  controllerAs: 'vm',
                  backdrop: 'static',
                  size: 'lg',
                  windowClass: 'app-modal-window',
                  resolve: {
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                          $translatePartialLoader.addPart('dashboard');
                          return $translate.refresh();
                      }]
                  }
              }).result.then(function() {
                  $state.go('servicedashboardyearly', null, { reload: 'servicedashboardyearly' });
              }, function() {
                  $state.go('servicedashboardyearly');
              });
          }]
      }).state('newtotaldeptservicesdetailyearly', {
          parent: 'newservicedashboardyearly',
          url: '/newservicedashboardcafsYearlyByElasticByStatus/{departmentName}/{district}/{projectLevel}/{serviceId}/{status}',
          data: {
              authorities: []
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'app/totaldeptservicesdetailyearly/newtotaldeptservicesdetailyearly.html',
                  controller: 'NewTotalDeptServicesDetailYearlyController',
                  controllerAs: 'vm',
                  backdrop: 'static',
                  size: 'lg',
                  windowClass: 'app-modal-window',
                  resolve: {
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                          $translatePartialLoader.addPart('dashboard');
                          return $translate.refresh();
                      }]
                  }
              }).result.then(function() {
                  $state.go('newservicedashboardyearly', null, { reload: 'newservicedashboardyearly' });
              }, function() {
                  $state.go('newservicedashboardyearly');
              });
          }]
      });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TotalDeptServicesDetailYearly', TotalDeptServicesDetailYearly);

    TotalDeptServicesDetailYearly.$inject = ['$resource'];

    function TotalDeptServicesDetailYearly ($resource) {
        var resourceUrl =  'api/totaldeptservicesdetail/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TotalDeptServicesDetailYearlyController', TotalDeptServicesDetailYearlyController);

    TotalDeptServicesDetailYearlyController.$inject = ['$scope', '$window', '$stateParams','$filter', 'Principal', '$uibModalInstance', 'LoginService', '$state', 'TotalDasboardDetailYearly', 'TotalDeptServicesDetailYearly','TotalDownloadDetailYearly'];

    function TotalDeptServicesDetailYearlyController ($scope, $window, $stateParams,$filter, Principal, $uibModalInstance, LoginService, $state, TotalDasboardDetailYearly, TotalDeptServicesDetailYearly,TotalDownloadDetailYearly) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.download = download;
        vm.downloadReport = downloadReport;

        vm.status = $stateParams.status;
        vm.clear = clear;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        var args = [];

        vm.spiner =true;
        vm.datePickerOpenStatus = {};
        vm.sortingdates={};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        vm.selectedDate=selectedDate;
        var d=null;
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dateOptions = {
            minDate: new Date("05-01-2017"),
            maxDate: Date.now()
        };

        function selectedDate(dateSelected){
            var newDate = new Date(dateSelected);
            newDate.setDate(newDate.getDate()+365);

            if(newDate > Date.now()){
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: Date.now()
                };
            }
            else {
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: newDate
                };
            }
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();


        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        loadAllCafs();
        function loadAllCafs() {
            vm.totaldeptservicesdetail=TotalDasboardDetailYearly.get(
                {status:$stateParams.status,
                    page: $scope.currentPage - 1,
                    size: $scope.pageSize
                },
                function (result) {
                    vm.show=true;
                vm.spiner=false;
            });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        }
        $scope.pageChanged = function(num) {
            loadAllCafs();
        };

        function convertJsonsToArrays(args){
            var dataArray = [];
            var header = [ "CAFPin",
                "Status",
                "RTS > 30",
                "RTS > 45",
                "RTS > 65",
                "Within RTS",
                "District",
                "Department",
                "Investor Name",
                "Investor Contact",
                "Investor Email",
                "Project Level",
                "Proposed Employment",
                "Project Investment" ,
                "Applied Date",
                // "Address",
                "Land Zone Use Type",
                "Service Name",
                "Business Entity"
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                var appliedDate=$filter('date')(row.formFilledOn, 'dd-MM-yyyy');
                rowAr.push(row.cafpin);
                rowAr.push(row.status);
                rowAr.push(row.rtsGreaterThan30);
                rowAr.push(row.rtsGreaterThan45);
                rowAr.push(row.rtsGreaterThan65);
                rowAr.push(row.withinRts);
                rowAr.push(row.district);
                rowAr.push(row.departmentName);
                rowAr.push(row.investorName);
                rowAr.push(row.investorMobilenumber);
                rowAr.push(row.investorEmail);
                rowAr.push(row.projectLevel);
                rowAr.push(row.proposedEmployment);
                rowAr.push(row.proposedInvestment);
                rowAr.push(appliedDate);
                // rowAr.push(row.investorAddress);
                rowAr.push(row.landZoneUseType);
                rowAr.push(row.serviceName);
                rowAr.push(row.businessEntity);
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function convertJsonsToArrays1(args){
            var dataArray = [];
            var header = [ "CAFPin",
                "Business Entity",
                "District",
                "Department",
                "Investor Name",
                "Investor Contact",
                "Investor Email",
                "Project Level",
                "Proposed Employment",
                "Project Investment" ,
                "Applied Date",
                "Completion Date",
                "Address",
                "Land Zone Use Type",
                "Service Name"
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                var appliedDate=$filter('date')(row.formFilledOn, 'dd-MM-yyyy');
                var clearedDate=$filter('date')(row.clearedDate, 'dd-MM-yyyy');
                rowAr.push(row.cafpin);
                var modifiedBusinessEntity = row.businessEntity.replace("[,;. ]+$", "").toUpperCase();
                rowAr.push(modifiedBusinessEntity);
                rowAr.push(row.district);
                rowAr.push(row.departmentName);
                rowAr.push(row.investorName);
                rowAr.push(row.investorMobilenumber);
                rowAr.push(row.investorEmail);
                rowAr.push(row.projectLevel);
                rowAr.push(row.proposedEmployment);
                rowAr.push(row.proposedInvestment);
                rowAr.push(appliedDate);
                rowAr.push(clearedDate);
                rowAr.push(row.investorAddress);
                rowAr.push(row.landZoneUseType);
                var modifiedServiceName = row.serviceName.replace(/[HOBPAS]+$/, "Hobpas");
                rowAr.push(modifiedServiceName);
                // rowAr.push(row.serviceName).replaceAll("[HOBPAS]+$", "Hobpas");
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function download(status) {
            var fromdate=$filter('date')(vm.fromdate, "dd-MM-yyyy");
            var todate=$filter('date')(vm.todate, "dd-MM-yyyy");
            TotalDownloadDetailYearly.query({status: status, fromdate:fromdate,todate:todate}, function (data) {
                    args = data;
                if(status === "Required" || status === "Pending" || status === "Applied"){
                    var rowsCleared= convertJsonsToArrays(args);
                }
                else{
                    var rows = convertJsonsToArrays1(args);

                }
                var lineArray = [];
                var lineArrayCleared = [];
                if(status === "Required" || status === "Pending" || status === "Applied"){
                    for(var i = 0; i < rowsCleared.length; i++){
                        var lineCleared = rowsCleared[i].join("\t");
                        lineArrayCleared.push(lineCleared);
                    }
                    lineArrayCleared = lineArrayCleared.join("\n");
                    var a = document.createElement('a');
                    var blob = new Blob([lineArrayCleared],{type: 'data:text/plain;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    $window.location.href = url;
                }
                else{
                    for(var i = 0; i < rows.length; i++){
                        var line = rows[i].join("\t");
                        lineArray.push(line);
                    }
                    lineArray = lineArray.join("\n");
                    var a = document.createElement('a');
                    var blob = new Blob([lineArray],{type: 'data:text/plain;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    $window.location.href = url;
                }

            });
        }

        function downloadReport(status) {
            var fromdate=$filter('date')(vm.fromdate, "dd-MM-yyyy");
            var todate=$filter('date')(vm.todate, "dd-MM-yyyy");
            var departmentName = vm.departmentName;

            TotalDownloadDetailYearly.query({departmentName: departmentName,status: status, fromdate:fromdate,todate:todate}, function (data) {
                    args = data;
                if(status === "Required" || status === "Pending" || status === "Applied"){
                    var rowsCleared= convertJsonsToArrays(args);
                }
                else{
                    var rows = convertJsonsToArrays1(args);

                }
                var lineArray = [];
                var lineArrayCleared = [];
                if(status === "Required" || status === "Pending" || status === "Applied"){
                    for(var i = 0; i < rowsCleared.length; i++){
                        var lineCleared = rowsCleared[i].join("\t");
                        lineArrayCleared.push(lineCleared);
                    }
                    lineArrayCleared = lineArrayCleared.join("\n");
                    var a = document.createElement('a');
                    var blob = new Blob([lineArrayCleared],{type: 'data:text/plain;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    $window.location.href = url;
                }
                else{
                    for(var i = 0; i < rows.length; i++){
                        var line = rows[i].join("\t");
                        lineArray.push(line);
                    }
                    lineArray = lineArray.join("\n");
                    var a = document.createElement('a');
                    var blob = new Blob([lineArray],{type: 'data:text/plain;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    $window.location.href = url;
                }

            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TotalDasboardDetailYearly', TotalDasboardDetailYearly);

    TotalDasboardDetailYearly.$inject = ['$resource'];

    function TotalDasboardDetailYearly ($resource) {
        // var resourceUrl =  'api/totalservicedashboarddetailsbystatusyearly/:status/:serviceid';
        var resourceUrl =  'api/servicedashboardcafsYearlyByElasticByStatus/departmentName/district/projectLevel/serviceId/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewTotalDeptServicesDetailYearlyController', NewTotalDeptServicesDetailYearlyController);

    NewTotalDeptServicesDetailYearlyController.$inject = ['$scope', '$window', '$stateParams','$filter', 'Principal', '$uibModalInstance', 'LoginService', '$state', 'TotalDasboardDetailYearly', 'TotalDeptServicesDetailYearly','TotalDownloadDetailYearly'];

    function NewTotalDeptServicesDetailYearlyController ($scope, $window, $stateParams,$filter, Principal, $uibModalInstance, LoginService, $state, TotalDasboardDetailYearly, TotalDeptServicesDetailYearly,TotalDownloadDetailYearly) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.download = download;
        vm.downloadReport = downloadReport;

        vm.status = $stateParams.status;
        vm.clear = clear;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        var args = [];

        vm.spiner =true;
        vm.datePickerOpenStatus = {};
        vm.sortingdates={};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        vm.selectedDate=selectedDate;
        var d=null;
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dateOptions = {
            minDate: new Date("05-01-2017"),
            maxDate: Date.now()
        };

        function selectedDate(dateSelected){
            var newDate = new Date(dateSelected);
            newDate.setDate(newDate.getDate()+365);

            if(newDate > Date.now()){
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: Date.now()
                };
            }
            else {
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: newDate
                };
            }
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();


        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        loadAllCafs();
        function loadAllCafs() {
            vm.totaldeptservicesdetail=TotalDasboardDetailYearly.get(
                {status:$stateParams.status,
                    page: $scope.currentPage - 1,
                    size: $scope.pageSize
                },
                function (result) {
                    vm.show=true;
                vm.spiner=false;
            });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        }
        $scope.pageChanged = function(num) {
            loadAllCafs();
        };

        function convertJsonsToArrays(args){
            var dataArray = [];
            var header = [ "CAFPin",
                "Status",
                "RTS > 30",
                "RTS > 45",
                "RTS > 65",
                "Within RTS",
                "District",
                "Department",
                "Investor Name",
                "Investor Contact",
                "Investor Email",
                "Project Level",
                "Proposed Employment",
                "Project Investment" ,
                "Applied Date",
                // "Address",
                "Land Zone Use Type",
                "Service Name",
                "Business Entity"
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                var appliedDate=$filter('date')(row.formFilledOn, 'dd-MM-yyyy');
                rowAr.push(row.cafpin);
                rowAr.push(row.status);
                rowAr.push(row.rtsGreaterThan30);
                rowAr.push(row.rtsGreaterThan45);
                rowAr.push(row.rtsGreaterThan65);
                rowAr.push(row.withinRts);
                rowAr.push(row.district);
                rowAr.push(row.departmentName);
                rowAr.push(row.investorName);
                rowAr.push(row.investorMobilenumber);
                rowAr.push(row.investorEmail);
                rowAr.push(row.projectLevel);
                rowAr.push(row.proposedEmployment);
                rowAr.push(row.proposedInvestment);
                rowAr.push(appliedDate);
                // rowAr.push(row.investorAddress);
                rowAr.push(row.landZoneUseType);
                rowAr.push(row.serviceName);
                rowAr.push(row.businessEntity);
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function convertJsonsToArrays1(args){
            var dataArray = [];
            var header = [ "CAFPin",
                "Business Entity",
                "District",
                "Department",
                "Investor Name",
                "Investor Contact",
                "Investor Email",
                "Project Level",
                "Proposed Employment",
                "Project Investment" ,
                "Applied Date",
                "Completion Date",
                "Address",
                "Land Zone Use Type",
                "Service Name"
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                var appliedDate=$filter('date')(row.formFilledOn, 'dd-MM-yyyy');
                var clearedDate=$filter('date')(row.clearedDate, 'dd-MM-yyyy');
                rowAr.push(row.cafpin);
                var modifiedBusinessEntity = row.businessEntity.replace("[,;. ]+$", "").toUpperCase();
                rowAr.push(modifiedBusinessEntity);
                rowAr.push(row.district);
                rowAr.push(row.departmentName);
                rowAr.push(row.investorName);
                rowAr.push(row.investorMobilenumber);
                rowAr.push(row.investorEmail);
                rowAr.push(row.projectLevel);
                rowAr.push(row.proposedEmployment);
                rowAr.push(row.proposedInvestment);
                rowAr.push(appliedDate);
                rowAr.push(clearedDate);
                rowAr.push(row.investorAddress);
                rowAr.push(row.landZoneUseType);
                var modifiedServiceName = row.serviceName.replace(/[HOBPAS]+$/, "Hobpas");
                rowAr.push(modifiedServiceName);
                // rowAr.push(row.serviceName).replaceAll("[HOBPAS]+$", "Hobpas");
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function download(status) {
            var fromdate=$filter('date')(vm.fromdate, "dd-MM-yyyy");
            var todate=$filter('date')(vm.todate, "dd-MM-yyyy");
            TotalDownloadDetailYearly.query({status: status, fromdate:fromdate,todate:todate}, function (data) {
                    args = data;
                if(status === "Required" || status === "Pending" || status === "Applied"){
                    var rowsCleared= convertJsonsToArrays(args);
                }
                else{
                    var rows = convertJsonsToArrays1(args);

                }
                var lineArray = [];
                var lineArrayCleared = [];
                if(status === "Required" || status === "Pending" || status === "Applied"){
                    for(var i = 0; i < rowsCleared.length; i++){
                        var lineCleared = rowsCleared[i].join("\t");
                        lineArrayCleared.push(lineCleared);
                    }
                    lineArrayCleared = lineArrayCleared.join("\n");
                    var a = document.createElement('a');
                    var blob = new Blob([lineArrayCleared],{type: 'data:text/plain;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    $window.location.href = url;
                }
                else{
                    for(var i = 0; i < rows.length; i++){
                        var line = rows[i].join("\t");
                        lineArray.push(line);
                    }
                    lineArray = lineArray.join("\n");
                    var a = document.createElement('a');
                    var blob = new Blob([lineArray],{type: 'data:text/plain;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    $window.location.href = url;
                }

            });
        }

        function downloadReport(status) {
            var fromdate=$filter('date')(vm.fromdate, "dd-MM-yyyy");
            var todate=$filter('date')(vm.todate, "dd-MM-yyyy");
            var departmentName = vm.departmentName;

            TotalDownloadDetailYearly.query({departmentName: departmentName,status: status, fromdate:fromdate,todate:todate}, function (data) {
                    args = data;
                if(status === "Required" || status === "Pending" || status === "Applied"){
                    var rowsCleared= convertJsonsToArrays(args);
                }
                else{
                    var rows = convertJsonsToArrays1(args);

                }
                var lineArray = [];
                var lineArrayCleared = [];
                if(status === "Required" || status === "Pending" || status === "Applied"){
                    for(var i = 0; i < rowsCleared.length; i++){
                        var lineCleared = rowsCleared[i].join("\t");
                        lineArrayCleared.push(lineCleared);
                    }
                    lineArrayCleared = lineArrayCleared.join("\n");
                    var a = document.createElement('a');
                    var blob = new Blob([lineArrayCleared],{type: 'data:text/plain;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    $window.location.href = url;
                }
                else{
                    for(var i = 0; i < rows.length; i++){
                        var line = rows[i].join("\t");
                        lineArray.push(line);
                    }
                    lineArray = lineArray.join("\n");
                    var a = document.createElement('a');
                    var blob = new Blob([lineArray],{type: 'data:text/plain;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    $window.location.href = url;
                }

            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TotalDasboardDetailYearly', TotalDasboardDetailYearly);

    TotalDasboardDetailYearly.$inject = ['$resource'];

    function TotalDasboardDetailYearly ($resource) {
        // var resourceUrl =  'api/totalservicedashboarddetailsbystatusyearly/:status/:serviceid';
        var resourceUrl =  'api/newservicedashboardcafsYearlyByElasticByStatus/departmentName/district/projectLevel/serviceId/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
         .state('totaldeptservicesdetail', {
          parent: 'servicedashboard',
          url: '/totaldeptservicesdetail/{status}',
          data: {
              authorities: []
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'app/totaldeptservicesdetail/totaldeptservicesdetail.html',
                  controller: 'TotalDeptServicesDetailController',
                  controllerAs: 'vm',
                  backdrop: 'static',
                  size: 'lg',
                  windowClass: 'app-modal-window',
                  resolve: {
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                          $translatePartialLoader.addPart('dashboard');
                          return $translate.refresh();
                      }]
                  }
              }).result.then(function() {
                  $state.go('servicedashboard', null, { reload: 'servicedashboard' });
              }, function() {
                  $state.go('servicedashboard');
              });
          }]
      });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TotalDeptServicesDetail', TotalDeptServicesDetail);

    TotalDeptServicesDetail.$inject = ['$resource'];

    function TotalDeptServicesDetail ($resource) {
        var resourceUrl =  'api/totaldeptservicesdetail/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TotalDeptServicesDetailController', TotalDeptServicesDetailController);

    TotalDeptServicesDetailController.$inject = ['$scope', '$window', '$stateParams','$filter', 'Principal', '$uibModalInstance', 'LoginService', '$state', 'TotalDasboardDetail'];

    function TotalDeptServicesDetailController ($scope, $window, $stateParams,$filter, Principal, $uibModalInstance, LoginService, $state, TotalDasboardDetail) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.download = download;

        vm.status = $stateParams.status;
        vm.clear = clear;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        var args = [];

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        loadAllCafs();
        function loadAllCafs() {
            vm.totaldeptservicesdetail=TotalDasboardDetail.query({status:$stateParams.status},function (result) {
                vm.show=true;
            });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        }
        $scope.pageChangeHandler = function(num) {
        };

        function convertJsonsToArrays(args){
            var dataArray = [];
            var header = [ "CAFPin",
                "Business Entity",
                "District",
                "Department",
                "Investor Name",
                "Investor Contact",
                "Investor Email",
                "Service Name",
                "Project Level",
                "Proposed Employment",
                "Project Investment" ,
                "Applied Date",
                "Address",
                "Land Zone Use Type"
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                var appliedDate=$filter('date')(row.formfilleddate, 'dd-MM-yyyy');
                rowAr.push(row.cafpin);
                rowAr.push(row.businessentity);
                rowAr.push(row.district);
                rowAr.push(row.departmentname);
                rowAr.push(row.investorName);
                rowAr.push(row.investorContact);
                rowAr.push(row.investorEmail);
                rowAr.push(row.servicename);
                rowAr.push(row.projectlevel);
                rowAr.push(row.proposedemployement);
                rowAr.push(row.projectinvestment);
                rowAr.push(appliedDate);
                rowAr.push(row.address);
                rowAr.push(row.landZoneUseType);
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function convertJsonsToArrays1(args){
            var dataArray = [];
            var header = [ "CAFPin",
                "Business Entity",
                "District",
                "Department",
                "Investor Name",
                "Investor Contact",
                "Investor Email",
                "Service Name",
                "Project Level",
                "Proposed Employment",
                "Project Investment" ,
                "Applied Date",
                "Completion Date",
                "Address",
                "Land Zone Use Type"
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                var appliedDate=$filter('date')(row.formfilleddate, 'dd-MM-yyyy');
                var clearedDate=$filter('date')(row.serviceClearedDate, 'dd-MM-yyyy');
                rowAr.push(row.cafpin);
                rowAr.push(row.businessentity);
                rowAr.push(row.district);
                rowAr.push(row.departmentname);
                rowAr.push(row.investorName);
                rowAr.push(row.investorContact);
                rowAr.push(row.investorEmail);
                rowAr.push(row.servicename);
                rowAr.push(row.projectlevel);
                rowAr.push(row.proposedemployement);
                rowAr.push(row.projectinvestment);
                rowAr.push(appliedDate);
                rowAr.push(clearedDate);
                rowAr.push(row.address);
                rowAr.push(row.landZoneUseType);
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function download(args,status) {

            if(status === "Required" || status === "Pending" || status === "Applied"){
                var rowsCleared= convertJsonsToArrays(args);
            }
            else{
                var rows = convertJsonsToArrays1(args);

            }
            var lineArray = [];
            var lineArrayCleared = [];
            if(status === "Required" || status === "Pending" || status === "Applied"){
                for(var i = 0; i < rowsCleared.length; i++){
                    var lineCleared = rowsCleared[i].join("\t");
                    lineArrayCleared.push(lineCleared);
                }
                lineArrayCleared = lineArrayCleared.join("\n");
                var a = document.createElement('a');
                var blob = new Blob([lineArrayCleared],{type: 'data:text/plain;charset=utf-8;'});
                var url = URL.createObjectURL(blob);
                $window.location.href = url;
            }
            else{
                for(var i = 0; i < rows.length; i++){
                    var line = rows[i].join("\t");
                    lineArray.push(line);
                }
                lineArray = lineArray.join("\n");
                var a = document.createElement('a');
                var blob = new Blob([lineArray],{type: 'data:text/plain;charset=utf-8;'});
                var url = URL.createObjectURL(blob);
                $window.location.href = url;
            }

        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TotalDasboardDetail', TotalDasboardDetail);

    TotalDasboardDetail.$inject = ['$resource'];

    function TotalDasboardDetail ($resource) {
        var resourceUrl =  'api/totalservicedashboarddetailsbystatus/:status/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('totaldeptdashboarddetail', {
          parent: 'dashboard',
          url: '/totaldeptdashboarddetail/{status}',
          data: {
              authorities: []
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'app/totaldeptdashboarddetail/totaldeptdashboarddetail.html',
                  controller: 'TotalDeptDashboardDetailController',
                  controllerAs: 'vm',
                  backdrop: 'static',
                  size: 'lg',
                  resolve: {
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                          $translatePartialLoader.addPart('dashboard');
                          return $translate.refresh();
                      }]
                  }
              }).result.then(function() {
                  $state.go('dashboard', null, { reload: 'dashboard' });
              }, function() {
                  $state.go('dashboard');
              });
          }]
      });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TotalDeptDashboardDetail', TotalDeptDashboardDetail);

    TotalDeptDashboardDetail.$inject = ['$resource'];

    function TotalDeptDashboardDetail ($resource) {
        var resourceUrl =  'api/totaldeptdashboarddetail/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TotalDeptDashboardDetailController', TotalDeptDashboardDetailController);

    TotalDeptDashboardDetailController.$inject = ['$scope', '$stateParams', 'Principal', '$uibModalInstance', 'LoginService', '$state', 'TotalDeptDashboardDetail'];

    function TotalDeptDashboardDetailController ($scope, $stateParams, Principal, $uibModalInstance, LoginService, $state, TotalDeptDashboardDetail) {
        var vm = this;
        vm.status = $stateParams.status;
        vm.clear = clear;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        function clear () {
        $uibModalInstance.dismiss('cancel');
        }

        loadAllCafs();
        function loadAllCafs() {
            vm.totaldeptdashboarddetail=TotalDeptDashboardDetail.query({status:$stateParams.status},function (result) {
                vm.show= true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('third-party-inspection', {
            parent: 'app',
            url: '/third-party-inspection',
            data: {
                authorities: [],
                pageTitle: 'global.menu.third-party-inspection'
            },
            views: {
                'content@': {
                    templateUrl: 'app/third-party-inspection/third-party-inspection.html',
                    controller: 'ThirdPartyInspectionController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('third-party-inspection');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('ThirdPartyInspectionService', ThirdPartyInspectionService);

    ThirdPartyInspectionService.$inject = ['$resource'];

    function ThirdPartyInspectionService($resource) {
        var service = {
            getOrdinalIndicator: getOrdinalIndicator
        };

        return service;

        function getOrdinalIndicator(n) {

            if (n || n === 0) {

                if (hasANonGenericOrdinalIndicator(n)) {
                    return 'th';
                }

                var decimal = n % 10;
                switch (decimal) {
                    case 1:
                        return 'st';
                        break;
                    case 2:
                        return 'nd';
                        break;
                    case 3:
                        return 'rd';
                        break;
                    default:
                        return 'th';
                        break;
                }
            }

            return '';
        }

        function hasANonGenericOrdinalIndicator(n) {
            var lastTwoDigits = n % 100;
            return lastTwoDigits > 10 && lastTwoDigits < 14;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ThirdPartyInspectionController', ThirdPartyInspectionController);

    ThirdPartyInspectionController.$inject = ['$scope', 'ThirdPartyInspectionService'];

    function ThirdPartyInspectionController($scope, ThirdPartyInspectionService) {
        var vm = this;

    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TemporaryTowerViewController', TemporaryTowerViewController);

    TemporaryTowerViewController.$inject = ['$scope', 'TemporaryTowerApplyService', 'District', 'Project'];

    function TemporaryTowerViewController($scope, TemporaryTowerApplyService, District, Project) {
        var vm = this;
        vm.businessEntities = [];


        loadApplicationAppliedBy();

        vm.isDateInRange = isDateInRange;

        function isDateInRange(startDate, endDate) {
            if (!startDate || !endDate) {
                return false;
            }

            var today = new Date();
            today.setHours(0, 0, 0, 0);

            var start = new Date(startDate);
            start.setHours(0, 0, 0, 0);

            var end = new Date(endDate);
            end.setHours(23, 59, 59, 999);

            return today >= start && today <= end;
        }





        function loadApplicationAppliedBy() {
            TemporaryTowerApplyService.queryByBusinessEntityUser(function (result) {
                vm.applications = result;
            });
        };



        vm.openEditModal = function (row) {
            vm.editData = angular.copy(row);  // load row into modal

            $('#editTowerModal').modal('show');   // open modal
        };

        vm.ApproveTower = function () {

            vm.editData.status = "Approved";

            TemporaryTowerApplyService.update(vm.editData,
                function success() {
                    alert("Approved successfully!");
                    $('#editTowerModal').modal('hide');
                    loadApplicationAppliedBy(); // refresh table
                },
                function error(err) {
                    console.log("Error updating:", err);
                }
            );
        };



    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('temporary-tower-apply', {
            parent: 'app',
            url: '/temporary-tower-apply',
            data: {
                authorities: [],
                pageTitle: 'global.menu.third-party-inspection'
            },
            views: {
                'content@': {
                    templateUrl: 'app/temporary-tower-apply/temporary-tower-apply.html',
                    controller: 'TemporaryTowerApplyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('temporary-tower-apply');
                    return $translate.refresh();
                }]
            }
        }),
            $stateProvider.state('temporary-tower-view', {
                parent: 'app',
                url: '/temporary-tower-view',
                data: {
                    authorities: [],
                    pageTitle: 'global.menu.temporary-tower-view'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/temporary-tower-apply/temporary-tower-view.html',
                        controller: 'TemporaryTowerViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('temporary-tower-view');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('TemporaryTowerApplyService', TemporaryTowerApplyService);

    TemporaryTowerApplyService.$inject = ['$resource'];

    function TemporaryTowerApplyService($resource) {

        var resourceUrl = 'api/temporary-tower/:id';

        return $resource(resourceUrl, {}, {

            // Existing APIs
            'save':   { method: 'POST' },
            'update': { method: 'PUT' },
            'get':    { method: 'GET' },
            'query':  { method: 'GET', isArray: true },
            'delete': { method: 'DELETE' },

            // ⭐ New API to fetch by district and cafType
            'findByDistrictAndCafType': {
                method: 'GET',
                url: 'api/projectByDistrictAndCafType',   // New backend API endpoint
                isArray: true,
                params: {
                    district: '@district',
                    cafType: '@cafType'
                }
            },

            'queryByUser': {
                method: 'GET',
                isArray: true,
                url: 'api/temporary-tower/findByAppliedBy'
            } ,

            'queryByBusinessEntityUser': {
                method: 'GET',
                isArray: true,
                url: 'api/temporary-tower/findByBusinessEntityUser'
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TemporaryTowerApplyController', TemporaryTowerApplyController);

    TemporaryTowerApplyController.$inject = ['$scope', 'TemporaryTowerApplyService', 'District', 'Project'];

    function TemporaryTowerApplyController($scope, TemporaryTowerApplyService, District, Project) {
        var vm = this;

        // --------------------------
        // STATIC DISTRICT LIST
        // // --------------------------
        // vm.districts = [
        //     { id: 1, name: "Gurugram" },
        //     { id: 2, name: "Faridabad" },
        //     { id: 3, name: "Hisar" },
        //     { id: 4, name: "Sonipat" },
        //     { id: 5, name: "Rohtak" }
        // ];

        // --------------------------
        // BUSINESS ENTITIES BY DISTRICT
        // --------------------------
        // vm.entitiesByDistrict = {
        //     TemporaryTowerApplyService.findByDistrictAndCafType({
        //         district: vm.selectedDistrict,
        //         cafType: vm.selectedCafType
        //     }, function (response) {
        //         vm.searchResults = response;
        //     });
        // };

        vm.businessEntities = [];

        loadAllDistrict();
        // loadUserApplications()
        loadApplicationAppliedBy();

        vm.districts = [];
        function loadAllDistrict(){
            District.query(function(result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

        vm.load = function(id) {
            TemporaryTowerApplyService.get({ id: id }, function(result) {
               // vm.form = result;
               // vm.selectedDistrict = result.district;
            });
        };


        function loadApplicationAppliedBy() {
            TemporaryTowerApplyService.queryByUser(function (result) {
                vm.applications = result;
            });
        };

        // --------------------------
        // WHEN DISTRICT CHANGES
        // --------------------------
        vm.loadBusinessEntities = function () {

            TemporaryTowerApplyService.findByDistrictAndCafType({
                district: vm.selectedDistrict.districtname,
                cafType: "Tower",
            }, function (response) {
                vm.businessEntities = response;
            });

        };

        // --------------------------
        // SUBMIT FORM
        // --------------------------
        vm.applyTemporaryTower = function () {

            var request = {
                district: vm.selectedDistrict.districtname,
                businessEntity: vm.form.businessEntity,
                latitude: vm.form.latitude,
                longitude: vm.form.longitude,
                startDate: vm.form.startDate,
                endDate: vm.form.endDate,
                remark: vm.form.remark,
                status: "Pending"
            };

            console.log("Submitting JSON:", request);

           // Uncomment when API is ready
            TemporaryTowerApplyService.save(request,
                function success() {
                    alert("Tower Request Submitted successfully!");
                    loadApplicationAppliedBy()
                },
                function error(err) {
                    console.log("Error in submitting:", err);
                });

        };

        vm.openEditModal = function (row) {
            vm.editData = angular.copy(row);  // load row into modal

            $('#editTowerModal').modal('show');   // open modal
        };

        vm.updateLocation = function () {

            TemporaryTowerApplyService.update(vm.editData,
                function success() {
                    alert("Location updated successfully!");
                    $('#editTowerModal').modal('hide');
                    loadApplicationAppliedBy(); // refresh table
                },
                function error(err) {
                    console.log("Error updating:", err);
                }
            );
        };



    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('temp-tower-by-user', {
            parent: 'app',
            url: '/temp-tower-by-user',
            data: {
                authorities: [],
                pageTitle: 'global.menu.temp-tower-by-user'
            },
            views: {
                'content@': {
                    templateUrl: 'app/temp-tower-by-user/temp-tower-by-user.html',
                    controller: 'TempTowerByUserController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('temp-tower-by-user');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('TempTowerByUserService', TempTowerByUserService);

    TempTowerByUserService.$inject = ['$resource'];

    function TempTowerByUserService($resource) {

        var resourceUrl = 'api/temp-tower-by-user/:id';

        return $resource(resourceUrl, {}, {

            'save':   { method: 'POST' },
            'update': { method: 'PUT' },
            'get':    { method: 'GET' },
            'query':  { method: 'GET', isArray: true },
            'delete': { method: 'DELETE' },

            // records created by the logged in user
            'queryByCreatedBy': {
                method: 'GET',
                isArray: true,
                url: 'api/temp-tower-by-user/findByCreatedBy'
            },

            // records the logged in user has to see - filled by him, or routed
            // to him through tempTowerByUserLogin as the nodal officer
            'queryByCurrentLogin': {
                method: 'GET',
                isArray: true,
                url: 'api/temp-tower-by-user/findByCurrentLogin'
            },

            // records assigned to the logged in user
            'queryByAssignedTo': {
                method: 'GET',
                isArray: true,
                url: 'api/temp-tower-by-user/findByAssignedTo'
            },

            // source for the Business Entity dropdown - the projects of the logged in
            // user, each row carries businessentity / businessentitytype / pan_number / emailprimary
            'businessEntities': {
                method: 'GET',
                isArray: true,
                url: 'api/projectByCurrentLogin'
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TempTowerByUserController', TempTowerByUserController);

    TempTowerByUserController.$inject = ['$filter', 'TempTowerByUserService', 'District', 'Department', 'Municipals', 'DateUtils'];

    function TempTowerByUserController($filter, TempTowerByUserService, District, Department, Municipals, DateUtils) {
        var vm = this;

        // departments that are municipal bodies - selecting one pulls the municipal list
        var MUNICIPAL_DEPARTMENTS = ['MUNICIPAL COUNCIL', 'MUNICIPAL COMMITTEE', 'MUNICIPAL CORPORATION'];

        // the license dates are stored as plain text, so they are converted to/from
        // a Date around the calendar popup using the app wide format
        var DATE_FIELDS = ['licenseRegistrationDate', 'licenseExpiryDate'];

        vm.form = {};
        vm.records = [];
        // every project of the logged in user, the dropdown shows the district wise subset
        var allBusinessEntities = [];
        vm.businessEntities = [];
        vm.districts = [];
        vm.departments = [];
        vm.municipals = [];
        vm.isMunicipalDepartment = false;
        vm.isSaving = false;
        vm.dateformat = DateUtils.dateformat();
        vm.datePickerOpenStatus = {};

        vm.openCalendar = openCalendar;
        vm.onBusinessEntityChange = onBusinessEntityChange;
        vm.onDistrictChange = onDistrictChange;
        vm.onDepartmentChange = onDepartmentChange;
        vm.save = save;
        vm.clear = clear;
        vm.edit = edit;
        vm.remove = remove;

        loadBusinessEntities();
        loadDistricts();
        loadDepartments();
        loadRecords();

        /**
         * Opens the calendar popup of the given date field.
         */
        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        /**
         * The calendar binds a Date, the entity column is text - format it back
         * to the app wide 'yyyy-MM-dd' before it goes to the server.
         */
        function dateToString(value) {
            return value ? $filter('date')(value, vm.dateformat) : value;
        }

        /**
         * Reverse of dateToString, so an edited record opens the calendar on the
         * stored day instead of showing an unparsed string.
         */
        function stringToDate(value) {
            if (!value || value instanceof Date) {
                return value;
            }
            var parsed = new Date(value);
            return isNaN(parsed.getTime()) ? null : parsed;
        }

        /**
         * District dropdown source - GET /api/districts
         */
        function loadDistricts() {
            District.query(function (result) {
                vm.districts = result;
            }, function (err) {
                console.log('Error loading districts:', err);
            });
        }

        /**
         * Changing the district invalidates any municipality already picked -
         * reload the list when the selected department is a municipal body.
         */
        function onDistrictChange() {
            vm.municipals = [];
            vm.form.municipality = null;

            // the business entities belong to a district, so the picked one may
            // no longer be valid - rebuild the list for the new district
            applyBusinessEntityFilter();

            if (vm.isMunicipalDepartment && vm.form.district) {
                loadMunicipals(vm.form.district, vm.form.department);
            }
        }

        /**
         * Department dropdown source - GET /api/departments, restricted to the
         * tower departments (istower === true), same list the Require flow shows.
         */
        function loadDepartments() {
            Department.query(function (result) {
                vm.departments = $filter('filter')(result, { istower: true });
            }, function (err) {
                console.log('Error loading departments:', err);
            });
        }

        /**
         * Same flow the "Require" button uses: when the chosen department is a
         * municipal body, fetch the municipals for the entered district.
         */
        function onDepartmentChange() {
            vm.municipals = [];
            vm.form.municipality = null;

            var departmentName = vm.form.department;
            vm.isMunicipalDepartment = MUNICIPAL_DEPARTMENTS.indexOf(departmentName) !== -1;

            if (!vm.isMunicipalDepartment) {
                return;
            }

            if (!vm.form.district) {
                alert('Please select the District before selecting a municipal department.');
                return;
            }

            alert('Kindly exercise due diligence before selecting the entity under which your tower land falls, since the fee regarding the same shall be directly transferred to the selected entity only');

            loadMunicipals(vm.form.district, departmentName);
        }

        function loadMunicipals(district, departmentName) {
            Municipals.query({ district: district, name: departmentName }, function (result) {
                vm.municipals = result;
            }, function (err) {
                console.log('Error loading municipals:', err);
            });
        }

        /**
         * Business Entity dropdown source - the projects belonging to the logged in
         * user (project.userlogin). Each option is a ProjectDTO, so the related
         * PAN / email / entity type travel with the selection.
         */
        function loadBusinessEntities() {
            TempTowerByUserService.businessEntities(function (result) {
                // one user can have many CAFs, keep only the ones that actually
                // carry a business entity name so the dropdown has no blank rows
                allBusinessEntities = $filter('filter')(result, function (project) {
                    return !!project.businessentity;
                });
                applyBusinessEntityFilter();
            }, function (err) {
                console.log('Error loading business entities:', err);
            });
        }

        /**
         * The dropdown only offers the logged in user's projects of the selected
         * district (project.district holds the district name, same value the
         * district dropdown binds). Without a district there is nothing to show.
         */
        function applyBusinessEntityFilter() {
            var district = normalize(vm.form.district);

            if (!district) {
                vm.businessEntities = [];
            } else {
                vm.businessEntities = $filter('filter')(allBusinessEntities, function (project) {
                    return normalize(project.district) === district;
                });
            }

            // drop a selection that does not belong to the new district
            if (vm.selectedBusinessEntity && vm.businessEntities.indexOf(vm.selectedBusinessEntity) === -1) {
                vm.selectedBusinessEntity = null;
                onBusinessEntityChange();
            }
        }

        function normalize(value) {
            return value ? String(value).trim().toLowerCase() : '';
        }

        /**
         * The table shows what the logged in user filled himself (createdBy)
         * plus the applications where his login sits in tempTowerByUserLogin,
         * ie. he is a nodal officer of the picked district / department.
         * GET /api/temp-tower-by-user/findByCurrentLogin merges both.
         */
        function loadRecords() {
            TempTowerByUserService.queryByCurrentLogin(function (result) {
                vm.records = result;
            }, function (err) {
                console.log('Error loading records:', err);
            });
        }

        /**
         * When a business entity is picked, auto-populate the dependent fields.
         * These stay read-only in the form - they always mirror the selected entity.
         */
        function onBusinessEntityChange() {
            var project = vm.selectedBusinessEntity;

            if (!project) {
                vm.form.projectId = null;
                vm.form.businessEntity = null;
                vm.form.businessEntityType = null;
                vm.form.panNo = null;
                vm.form.email = null;
                return;
            }

            // the acknowledgement pulls the address / district / caf number off
            // this project, so the link has to travel with the application
            vm.form.projectId = project.id;
            vm.form.businessEntity = project.businessentity;
            vm.form.businessEntityType = project.businessentitytype;
            vm.form.panNo = project.pan_number;
            vm.form.email = project.emailprimary;
        }

        function save() {
            vm.isSaving = true;

            var payload = {
                id: vm.form.id,

                // the project of the picked business entity, the acknowledgement
                // reads the address / district / caf number from it
                projectId: vm.form.projectId,

                // Geographical Level
                district: vm.form.district,
                department: vm.form.department,
                municipality: vm.form.municipality,

                // User Data
                name: vm.form.name,
                email: vm.form.email,
                panNo: vm.form.panNo,
                businessEntity: vm.form.businessEntity,
                businessEntityType: vm.form.businessEntityType,
                licenseNumber: vm.form.licenseNumber,
                licenseRegistrationDate: dateToString(vm.form.licenseRegistrationDate),
                licenseExpiryDate: dateToString(vm.form.licenseExpiryDate),

                // App Info Data
                remarks: vm.form.remarks,
                formType: vm.form.formType,
                latitude: vm.form.latitude,
                longitude: vm.form.longitude,

                // Workflow - createdBy / createdAt are stamped on the server
                assignedTo: vm.form.assignedTo,
                status: vm.form.status,
                action: vm.form.action
            };

            var onSuccess = function () {
                vm.isSaving = false;
                clear();
                loadRecords();
            };

            var onError = function (err) {
                vm.isSaving = false;
                console.log('Error saving TempTowerByUser:', err);
            };

            if (payload.id) {
                TempTowerByUserService.update(payload, onSuccess, onError);
            } else {
                TempTowerByUserService.save(payload, onSuccess, onError);
            }
        }

        function edit(record) {
            vm.form = angular.copy(record);

            // the stored dates are text, the calendar needs real Dates
            angular.forEach(DATE_FIELDS, function (field) {
                vm.form[field] = stringToDate(vm.form[field]);
            });

            // re-link the dropdown selection to the matching business entity,
            // rebuilding the list for the district of the saved record first
            vm.selectedBusinessEntity = null;
            applyBusinessEntityFilter();
            angular.forEach(vm.businessEntities, function (project) {
                // rows saved before the project link existed only carry the name
                var matches = record.projectId
                    ? project.id === record.projectId
                    : project.businessentity === record.businessEntity;
                if (matches) {
                    vm.selectedBusinessEntity = project;
                }
            });

            // restore the municipal list for the saved department, keeping the saved municipality
            vm.municipals = [];
            vm.isMunicipalDepartment = MUNICIPAL_DEPARTMENTS.indexOf(record.department) !== -1;
            if (vm.isMunicipalDepartment && record.district) {
                Municipals.query({ district: record.district, name: record.department }, function (result) {
                    vm.municipals = result;
                    // ng-options rebuilds the list, so re-apply the saved value
                    vm.form.municipality = record.municipality;
                });
            }
        }

        function remove(record) {
            TempTowerByUserService.delete({ id: record.id }, function () {
                loadRecords();
            }, function (err) {
                console.log('Error deleting record:', err);
            });
        }

        function clear() {
            vm.form = {};
            vm.selectedBusinessEntity = null;
            vm.municipals = [];
            vm.isMunicipalDepartment = false;
            // no district selected any more, so no business entity can be offered
            applyBusinessEntityFilter();
        }
    }
})();

// tat.state.js
(function () {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tat-dashboard', {
                parent: 'app',
                url: '/tat-dashboard',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/tat/tat-dashboard.html',
                        controller: 'TatController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

// tat.service.js
(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('TatService', TatService);

    TatService.$inject = ['$http'];

    function TatService($http) {

        var service = {
            getTatData: getTatData,
            getTatDataOptimised: getTatDataOptimised

        };

        return service;

        function getTatData(fromDate, toDate) {
            return $http.get('/api/tat/calculate', {
                params: {
                    fromDate: fromDate,
                    toDate: toDate
                }
            });
        }

        function getTatDataOptimised(fromDate, toDate) {
            return $http.get('/api/tat/calculate-optimised', {
                params: {
                    fromDate: fromDate,
                    toDate: toDate
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TatController', TatController);


    TatController.$inject = ['TatService', '$filter','$http'];

    function TatController(TatService, $filter, $http) {

        var vm = this;

        vm.tatList = [];
        vm.fromDate = null;
        vm.toDate = null;
        vm.loadData = loadData;
        vm.loadDataOptimised = loadDataOptimised;


        vm.preServiceList = [];
        vm.postServiceList = [];
        vm.selectedCafpin = null;
        vm.selectedProjectId=null;
        vm.selectedServiceId=null;
        vm.selectedServiceName=null;

        //
        // vm.loadPreServices = function(item) {
        //
        //     alert("clicked");
        //
        //     console.log("Clicked CAF:", item.cafpin);
        //
        //     vm.selectedCafpin = item.cafpin;
        //     alert(item.projectId)
        //
        //     // 🔥 CALL API (use projectId ideally)
        //     $http.get('/api/tat/pre-services/' + item.projectId)
        //         .then(function(response) {
        //
        //             console.log("API RESPONSE:", response.data);
        //
        //             vm.preServiceList = response.data;
        //
        //         }, function(error) {
        //
        //             console.error("API ERROR:", error);
        //         });
        // };

        vm.loadPreServices = function(item) {

            console.log("Clicked CAF:", item.cafpin);

            vm.selectedCafpin = item.cafpin;

            $http.get('/api/tat/pre-services/' + item.projectId)
                .then(function(response) {

                    vm.preServiceList = response.data;

                    // 🔥 OPEN MODAL
                    $('#preServiceModal').modal('show');

                }, function(error) {

                    console.error("API ERROR:", error);
                    alert("Failed to load data");
                });
        };


        vm.loadPostServices = function(item) {

            console.log("Clicked CAF:", item.cafpin);

            vm.selectedCafpin = item.cafpin;

            $http.get('/api/tat/post-services/' + item.projectId)
                .then(function(response) {

                    vm.postServiceList = response.data;

                    // 🔥 OPEN MODAL
                    $('#postServiceModal').modal('show');

                }, function(error) {

                    console.error("API ERROR:", error);
                    alert("Failed to load data");
                });
        };

        // vm.loadQueries = function(item) {
        //     // alert("hovered")
        //
        //     // 🔥 Prevent multiple API calls
        //     if (item.queriesLoaded) {
        //         item.showQueries = true;
        //         return;
        //     }
        //
        //     item.loading = true;
        //     item.showQueries = true;
        //
        //     $http.get('/api/tat/query-count/' + item.projectId)
        //         .then(function(response) {
        //
        //             console.log("Queries API:", response.data);
        //
        //             item.queries = response.data; // array of strings or objects
        //             item.queriesLoaded = true;
        //             item.loading = false;
        //
        //         }, function(error) {
        //
        //             console.error("Error loading queries", error);
        //             item.loading = false;
        //         });
        // };


        vm.loadServiceDetails = function(item) {

            vm.selectedCafpin = item.cafpin;
            vm.selectedProjectId=item.projectId;
            vm.loadingDetails = true;

            console.log("CAF CLICKED:", item.cafpin);
            console.log("PROJECT ID:", item.projectId);

            $http.get('/api/tat/service-details/' + item.projectId)
                .then(function(response) {

                    console.log("SERVICE DETAILS API:", response.data);

                    vm.serviceDetailsList = response.data;
                    vm.loadingDetails = false;

                    // 🔥 OPEN MODAL
                    $('#serviceDetailsModal').modal('show');

                }, function(error) {

                    console.error("ERROR:", error);
                    vm.loadingDetails = false;
                });
        };


        vm.loadQueryDetails = function(service) {

            console.log("Clicked Service:", service.serviceName);

            vm.loadingQueries = true;
            vm.queryList = [];
            vm.applicantCount = 0;
            vm.departmentCount = 0;

            // already available from parent modal
            // vm.selectedProjectId
            // vm.selectedCafpin

            $http.get('/api/tat/query-details/'
                + vm.selectedProjectId + '/'
                + service.serviceId)
                .then(function(response) {

                console.log("Query Details Response:", response.data);

                vm.queryList = response.data.queries;
                vm.applicantCount = response.data.applicantCount;
                vm.departmentCount = response.data.departmentCount;
                vm.selectedServiceName=service.serviceName;

                vm.loadingQueries = false;

                // 🔥 OPEN MODAL
                $('#queryDetailsModal').modal('show');

            }, function(error) {

                console.error("Error fetching query details", error);
                vm.loadingQueries = false;
            });
        };
        vm.loadQueries = function(item) {

            if (item.queriesLoaded) {
                item.showQueries = true;
                return;
            }

            item.loading = true;
            item.showQueries = true;

            $http.get('/api/tat/query-count/' + item.projectId)
                .then(function(response) {

                    console.log("Queries API:", response.data);

                    item.queries = response.data; // now it's NUMBER
                    item.queryCount = response.data; // keep default also in sync
                    item.queriesLoaded = true;
                    item.loading = false;

                }, function(error) {
                    console.error("Error loading queries", error);
                    item.loading = false;
                });
        };

        vm.hideQueries = function(item) {
            item.showQueries = false;
        };

        function loadData() {

            if (!vm.fromDate || !vm.toDate) {
                alert("Please select dates");
                return;
            }

            // 🔥 FORMAT DATE HERE
            var formattedFromDate = $filter('date')(vm.fromDate, 'yyyy-MM-dd');
            var formattedToDate = $filter('date')(vm.toDate, 'yyyy-MM-dd');

            TatService.getTatData(formattedFromDate, formattedToDate)
                .then(function (response) {
                    vm.tatList = response.data;
                })
                .catch(function (error) {
                    console.error("Error fetching data", error);
                });
        }

        function loadDataOptimised() {

            if (!vm.fromDate || !vm.toDate) {
                alert("Please select dates");
                return;
            }

            // 🔥 FORMAT DATE HERE
            var formattedFromDate = $filter('date')(vm.fromDate, 'yyyy-MM-dd');
            var formattedToDate = $filter('date')(vm.toDate, 'yyyy-MM-dd');

            TatService.getTatDataOptimised(formattedFromDate, formattedToDate)
                .then(function (response) {
                    vm.tatList = response.data;
                })
                .catch(function (error) {
                    console.error("Error fetching data", error);
                });
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SurveyFormViewController', SurveyFormViewController);

    SurveyFormViewController.$inject = ['$scope', '$state', '$stateParams', '$http', 'Principal', 'LoginService', 'SurveyForm'];

    function SurveyFormViewController($scope, $state, $stateParams, $http, Principal, LoginService, SurveyForm) {
        var vm = this;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.formData = {};
        vm.success = false;
        vm.projectserviceid = $stateParams.projectserviceid;
        vm.showSurveyForm = true;

        vm.login = function() {
            LoginService.open();
        };

        // 🔽 Call this on controller load
        loadAllProjectData(vm.projectserviceid);

        function loadAllProjectData(projectServiceId) {
            // First get project service detail to extract projectid
            $http.get('https://investharyana.in/api/survey-forms/' + projectServiceId)
                .then(function(response) {
                    vm.projectServiceDetail = response.data;

                })
                .catch(function(err) {
                    console.error("Failed to load projectServiceDetail:", err);
                });
        }

        vm.closeForm = function () {
            window.history.back();
        };

        // vm.openApprovePopup = function (id) {
        //     alert("inside this openApprovePopup")
        //     vm.selectedCafId = id;
        //     vm.approvalComment = '';
        //     $('#approveModal').modal('show');
        // };
        //
        // vm.submitApproval = function () {
        //     var payload = {
        //         id: vm.selectedCafId,
        //         comment: vm.approvalComment,
        //         status: 'Cleared'
        //     };
        //
        //     console.log('Submitting payload:', payload);
        //
        //     // // Send it to backend
        //     // $http.post('http://your-api-endpoint/approve-survey', payload)
        //     //     .then(function (response) {
        //     //         alert('Survey approved successfully!');
        //     //         $('#approveModal').modal('hide');
        //     //     })
        //     //     .catch(function (error) {
        //     //         console.error('Approval failed:', error);
        //     //         alert('Failed to approve.');
        //     //     });
        // };


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SurveyFormForTowerOfficerController', SurveyFormForTowerOfficerController);

    SurveyFormForTowerOfficerController.$inject = ['$scope', '$state', '$stateParams', '$http', 'Principal', 'LoginService', 'SurveyForm'];

    function SurveyFormForTowerOfficerController($scope, $state, $stateParams, $http, Principal, LoginService, SurveyForm) {
        var vm = this;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.formData = {};
        vm.success = false;
        vm.projectserviceid = $stateParams.projectserviceid;

        vm.login = function() {
            LoginService.open();
        };


        // 🔥 Correct call
        loadAllProjectData();

        function loadAllProjectData() {
            SurveyForm.getSurveyFormsTowerOfficer().$promise.then(function(list) {
                vm.surveyFormsList = list;  // ✅ Save API response
                console.log("Survey forms:", list);
            }).catch(function(error) {
                console.error("Error fetching survey forms:", error);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SurveyFormForDCController', SurveyFormForDCController);

    SurveyFormForDCController.$inject = ['$scope', '$state', '$stateParams', '$http', 'Principal', 'LoginService', 'SurveyForm'];

    function SurveyFormForDCController($scope, $state, $stateParams, $http, Principal, LoginService, SurveyForm) {
        var vm = this;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.formData = {};
        vm.success = false;
        vm.projectserviceid = $stateParams.projectserviceid;

        vm.login = function() {
            LoginService.open();
        };

        // 🔽 Call this on controller load
        loadAllProjectData();

        function loadAllProjectData() {
            SurveyForm.getSurveyFormsDC().$promise.then(function(list) {
                vm.surveyFormsList = list;  // 🔥 Save the response in vm
                console.log("Survey forms:", list);
            }).catch(function(error) {
                console.error("Error fetching survey forms:", error);
            });
        }



    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('surveyFormView', {
            parent: 'app',
            url: '/surveyForm/view/:id',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/surveyForm/surveyForm-view.html', // Create this file
                    controller: 'SurveyFormController',             // Create this controller
                    controllerAs: 'vm'
                }
            },
            resolve: {
                surveyData: ['SurveyForm', '$stateParams', function(SurveyForm, $stateParams) {
                    return SurveyForm.get({ id: $stateParams.id }).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('SurveyForm', SurveyForm);

    SurveyForm.$inject = ['$resource'];

    function SurveyForm($resource) {
        var resourceUrl = 'api/survey-forms/:id';

        return $resource(resourceUrl, { id: '@id' }, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    try {
                        return angular.fromJson(data);
                    } catch (e) {
                        // Log and return the raw string
                        console.warn("Invalid JSON response:", data);
                        return data;
                    }
                }
            },
            'save': { method: 'POST' },
            'update': { method: 'PUT' },
            'getSurveyFormsDC': {
                url: 'api/survey-forms/survey-forms-dc/update',
                method: 'GET',
                isArray: true
            },
            'getSurveyFormsTowerOfficer': {
                url: 'api/survey-forms/surveyFormViewby-towerOfficer',
                method: 'GET',
                isArray: true
            }

        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SurveyFormController', SurveyFormController);

    SurveyFormController.$inject = ['$scope', '$state', '$stateParams', '$http', 'Principal', 'LoginService', 'SurveyForm'];

    function SurveyFormController($scope, $state, $stateParams, $http, Principal, LoginService, SurveyForm) {
        var vm = this;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.formData = {};
        vm.success = false;
        vm.projectserviceid = $stateParams.projectserviceid;

        vm.login = function() {
            LoginService.open();
        };

        // 🔽 Call this on controller load
        loadAllProjectData(vm.projectserviceid);

        function loadAllProjectData(projectServiceId) {
            // First get project service detail to extract projectid
            $http.get('https://investharyana.in/api/projectservicedetails/' + projectServiceId)
                .then(function(response) {
                    vm.projectServiceDetail = response.data;

                    var projectId = vm.projectServiceDetail.projectid;

                    // Now call Project Details
                    $http.get('https://investharyana.in/api/projects/' + projectId)
                        .then(function(res) {
                            vm.projectDetails = res.data;
                            console.log("Project Details:", vm.projectDetails);
                        });

                    // And Project Service List
                    $http.get('https://investharyana.in/api/projectservicelistforclearance/project/' + projectId + '/required')
                        .then(function(res) {
                            vm.projectServiceList = res.data;
                            console.log("Project Service List:", vm.projectServiceList);
                        });
                })
                .catch(function(err) {
                    console.error("Failed to load projectServiceDetail:", err);
                });
        }
        vm.loading = true;
        vm.submitForm = function () {
            var payload = {
                id: vm.projectServiceDetail.id,
                districtName: vm.projectDetails.district,
                pincode: vm.formData.pincode,
                landType: vm.projectDetails.landusetype,
                areaType: vm.formData.areaType,
                departmentName: vm.projectServiceDetail.departmentName,
                applicantName: vm.projectDetails.firstname + ' ' + (vm.projectDetails.middlename || '') + ' ' + (vm.projectDetails.lastname || ''),
                businessEntity: vm.projectDetails.businessentity,
                mobileNumber: vm.projectDetails.mobilenumber,
                email: vm.projectDetails.emailprimary,
                address: vm.formData.address,
                serviceName: vm.projectServiceDetail.serviceName,
                projectServiceDetailId: vm.projectServiceDetail.id,
                serviceId:vm.projectServiceDetail.serviceid,
                projectId: vm.projectDetails.id,
                status: 'Pending',
                approve: false,
                userLogin: vm.projectServiceDetail.userlogin,
                latitude: vm.formData.latitude,
                longitude: vm.formData.longitude,
                survey: true
            };

            console.log('Submitting payload:', payload); // Optional

            $http.post('https://investharyana.in/api/survey-forms', payload)
                .then(function (response) {
                    vm.loading = false;
                    console.log('Form submitted successfully:', response.data);
                    alert("Form submitted successfully")

                    $state.go('serviceclearanceaction', {
                       // projectid: vm.projectDetails.id,
                        district: vm.projectDetails.district
                    });
                    // You can show a success message here
                })
                .catch(function (error) {
                    console.error('Error submitting form:', error);
                    // You can show an error message here
                });
        };


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CommentforofficerController', CommentforofficerController);

    CommentforofficerController.$inject = ['$scope', '$http', '$stateParams', 'SurveyForm', 'projectService', '$uibModalInstance','Principal','$state'];

    function CommentforofficerController($scope, $http, $stateParams, SurveyForm, projectService, $uibModalInstance,Principal,$state) {
        var vm = this;
        vm.status = $stateParams.action;


        vm.comments = ''; // initialize empty

        vm.projectserviceid = $stateParams.projectserviceid;
        vm.projectService = projectService; // if you need resolved service

        // Close modal
        vm.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };

        // Submit form
        vm.clearService = function() {
            if (vm.status === 'clearance') {

                vm.status = 'Cleared';
            } else if (vm.status === 'reject') {

                vm.status = 'Rejected';
            }
            var payload = {
                id: vm.projectserviceid,
                remark: vm.comments,
                status: vm.status,
                approvalType: 'manual',
                approve: true
            };
            console.log("payload::", payload);

            $http.post('https://investharyana.in/api/survey-forms/updateSurveyform', payload)
                .then(function(response) {
                    console.log("this is response"+response)
                    alert('Form approved successfully!');
                    $uibModalInstance.close(); // Close modal on success
                    Principal.identity().then(function(account) {
                        var roles = account.authorities;
                        if (roles.includes('ROLE_TOWER_OFFICER')) {
                            $state.go('viewsurveyformfortowerofficer', null, { reload: true });
                        } else if (roles.includes('ROLE_TOWER_DC')) {

                            $state.go('viewsurveyformfordc', null, { reload: true });
                        }
                    });
                })
                .catch(function(error) {
                    console.error('Approval failed:', error);
                    alert('Failed to approve.');
                });
        };

        // vm.clear=function () {
        //     $uibModalInstance.close();
        // };

        vm.rejectService = function() {
            vm.status = 'Rejected';
            vm.clearService(); // reuse clearService logic
        };

        vm.clear = function() {
            $scope.$dismiss('cancel');
        };

        // Similarly you can add vm.rejectService if needed
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SupplyDisposalViewByElastic', SupplyDisposalViewByElastic);

    SupplyDisposalViewByElastic.$inject = ['$resource'];

    function SupplyDisposalViewByElastic ($resource) {
        var resourceUrl =  'api/supply-and-disposals-ByStatus/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('SupplyDisposalViewController', SupplyDisposalViewController);

    SupplyDisposalViewController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'ServiceViewCafYearly', 'TowerserviceNO','SupplyDisposalViewByElastic'];
    function SupplyDisposalViewController ($timeout, $scope, $stateParams, $uibModalInstance, ServiceViewCafYearly, TowerserviceNO, SupplyDisposalViewByElastic) {
        var vm = this;
        vm.clear = clear;
        vm.status=$stateParams.status;
        vm.spiner= true;

        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
            /*appliedDate=new Date(result[i].appliedDate.toDateString());
            clearedDate=new Date(result[i].clearedDate.toDateString());
            dayDiff= (clearedDate - appliedDate)  / 1000 / 60 / 60 / 24;
*/
        loadAllCafs();
        function loadAllCafs() {
            var data = {
                status: $stateParams.status,
            };
            Object.keys(data).forEach(function (k) {
                if (!data[k] && data[k] !== undefined) {
                    delete data[k];
                }
            });

            vm.dashboardcafs = SupplyDisposalViewByElastic.query(data, function (result) {
                alert(data.status);
                console.log(vm.dashboardcafs);
                vm.show = true;
                vm.spiner = false;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('supplyDisposal', {
            parent: 'app',
            url: '/supplyDisposal',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/supplyDisposal/supplyDisposal.html',
                    controller: 'SupplyDisposalController',
                    controllerAs: 'vm'
                }
            },
            // resolve: {
            //     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
            //         $translatePartialLoader.addPart('dashboard');
            //         return $translate.refresh();
            //     }]
            // }
        }).state('supplyAndDisposaldashboard', {
            parent: 'supplyDisposal',
            url: '/supplyDisposalView/{status}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/supplyDisposal/supplyDisposalView.html',
                    controller: 'SupplyDisposalViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('supplyDisposal', null, { reload: 'supplyDisposal' });
                }, function() {
                    $state.go('supplyDisposal');
                });
            }]
        });

        }
        })();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SupplyDisposal', SupplyDisposal);

    SupplyDisposal.$inject = ['$resource'];

    function SupplyDisposal ($resource) {
        var resourceUrl =  '/api/supply-and-disposalsByStatus';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SupplyDisposalController', SupplyDisposalController);

    SupplyDisposalController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'SupplyAndDisposal', 'SupplyDisposal', '$location'];

    function SupplyDisposalController ($scope, Principal, LoginService, $state, SupplyAndDisposal, SupplyDisposal, $location) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.showtable=false;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
            ga('set', 'page', $location.path());
            ga('send','pageview');
        });

        // dataByStatus(status);

        vm.supplyAndDisposals = {};

        // loadAll();
        //
        // function loadAll() {
        //     SupplyAndDisposal.query(function(result) {
        //         vm.supplyAndDisposals = result;
        //     });
        // }

        dataByStatus();
        function dataByStatus () {
            SupplyDisposal.get(function(result) {
                vm.supplyAndDisposals = result;
                console.log(vm.supplyAndDisposals);
            });
        }


        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('StartupPoliciesLoginController', StartupPoliciesLoginController);

    StartupPoliciesLoginController.$inject = ['$stateParams', '$scope', '$state', '$translate', 'IncentiveForm', 'Principal', 'LoginService', '$timeout', '$location'];

    function StartupPoliciesLoginController($stateParams, $scope, $state, $translate, IncentiveForm, Principal, LoginService, $timeout, $location) {
        var vm = this;
        vm.isAuthenticated = Principal.isAuthenticated;

        // Manually refresh translations after page load
        $translate.refresh().then(function() {
            console.log("Translations refreshed in controller");
        });

        IncentiveForm.query(function(result) {
            vm.userdetails = result;
        });

        vm.login = function() {
            LoginService.open();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('startupPolicies', {
            parent: 'app',
            url: '/startupPolicies',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/startupPolicies/startupPolicies.html',
                    controller: 'StartupPoliciesController',
                    controllerAs: 'vm'
                }
            }
        })
    .state('withoutlogin', {
            parent: 'startupPolicies',
            url: '/withoutlogin',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/startupPolicies/startupPolicies-login.html',
                    controller: 'StartupPoliciesLoginController',
                    controllerAs: 'vm'
                }
            }
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EvPolicies', EvPolicies);

    EvPolicies.$inject = ['$resource'];

    function EvPolicies ($resource) {
        var resourceUrl =  'api/evPolicies';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('StartupPoliciesController', StartupPoliciesController);

    StartupPoliciesController.$inject = ['$stateParams','$scope', '$state','IncentiveForm', 'Principal', 'LoginService', '$timeout', '$location','$translate'];

    function StartupPoliciesController($stateParams,$scope, $state, IncentiveForm, Principal, LoginService, $timeout , $location,$translate) {

        var vm = this;
        // Manually refresh translations after page load
        $translate.refresh().then(function() {
            console.log("Translations refreshed in controller");
        });
        vm.url = null;
        vm.isAuthenticated = Principal.isAuthenticated;
        IncentiveForm.query(function(result){
            vm.userdetails=result;

        });
        vm.setUrl = function (url) {
            vm.url = $sce.trustAsResourceUrl(url);
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('startup-support', {
            parent: 'app',
            url: '/startup-support',
            data: {
                authorities: [],
                pageTitle: 'global.menu.startup-support'
            },
            views: {
                'content@': {
                    templateUrl: 'app/startup-support/startup-support.html',
                    controller: 'StartupSupport',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('startup-support');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('StartupSupportService', StartupSupportService);

    StartupSupportService.$inject = ['$resource'];

    function StartupSupportService($resource) {
        var service = {
            getOrdinalIndicator: getOrdinalIndicator
        };

        return service;

        function getOrdinalIndicator(n) {

            if (n || n === 0) {

                if (hasANonGenericOrdinalIndicator(n)) {
                    return 'th';
                }

                var decimal = n % 10;
                switch (decimal) {
                    case 1:
                        return 'st';
                        break;
                    case 2:
                        return 'nd';
                        break;
                    case 3:
                        return 'rd';
                        break;
                    default:
                        return 'th';
                        break;
                }
            }

            return '';
        }

        function hasANonGenericOrdinalIndicator(n) {
            var lastTwoDigits = n % 100;
            return lastTwoDigits > 10 && lastTwoDigits < 14;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('StartupSupport', StartupSupport);

    StartupSupport.$inject = ['$scope', 'StartupSupportService'];

    function StartupSupport($scope, StartupSupportService) {
        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('showprojectsTowerofficer', {
        parent: 'app',
        url: '/showprojectsTowerofficer',
        data: {
            authorities: [],
            pageTitle: 'global.menu.showprojectsTowerofficer'
        },
        views: {
            'content@': {
                templateUrl: 'app/showprojects-towerofficer/showprojectsTowerofficer.html',
                controller: 'ShowprojectsTowerofficerController',
                controllerAs: 'vm'
            }
        },
        resolve: {
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                $translatePartialLoader.addPart('showprojectsTowerofficer');
                return $translate.refresh();
            }]
        }
    })
        .state('towerofficer-action', {
            parent: 'showprojectsTowerofficer',
            url: '/action/{action}/{projectserviceid}',
            data: {
                authorities: ['ROLE_TOWER_OFFICER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/showprojects-towerofficer/projects-dialog.html',
                    controller: 'TowerOfficerProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        projectAttachemnt: function () {
                            return {
                                fileName: null,
                                description: null,
                                fileExtension: null,
                                serverFileName: null,
                                id: null
                            };
                        },
                        projectServiceLog: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                comments: null,
                                commentDate: null,
                                commentByUserLogin: null,
                                actionTaken: null,
                                id: null
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }],
                        projectService: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                        }]
//                            projectservicereportinfo: ['ProjectServiceReportInfoForClearance', function(ProjectServiceReportInfoForClearance) {
//                                return ProjectServiceReportInfoForClearance.get({department:$stateParams.projectService.departmentName,projectid:$stateParams.projectService.projectid,service:$stateParams.projectService.serviceName});
//                            }]
                    }
                }).result.then(function() {
                    $state.go('showprojectsTowerofficer', null, { reload: 'showprojectsTowerofficer' });
                }, function() {
                    $state.go('showprojectsTowerofficer');
                });
            }]
        })
            .state('towerofficer-clarification-dialog', {
                parent: 'showprojectsTowerofficer',
                url: 'towerofficer-clarification/{projectserviceid}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_ACCOUNT_OFFICER','ROLE_NODAL_OFFICER','ROLE_USER','ROLE_FIELD_OFFICER','ROLE_TOWER_OFFICER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/showprojects-towerofficer/projects-dialog.html',
                        controller: 'TowerOfficerProjectDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            projectAttachemnt: function () {
                                return {
                                    fileName: null,
                                    description: null,
                                    fileExtension: null,
                                    serverFileName: null,
                                    id: null
                                };
                            },
                            projectServiceLog: function () {
                                return {
                                    projectid: null,
                                    serviceid: null,
                                    comments: null,
                                    commentDate: null,
                                    commentByUserLogin: null,
                                    actionTaken: null,
                                    id: null
                                };
                            },
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                $translatePartialLoader.addPart('home');
                                return $translate.refresh();
                            }],
                            projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                            }]
                            //                            projectservicereportinfo: ['ProjectServiceReportInfoForClearance', function(ProjectServiceReportInfoForClearance) {
                            //                                return ProjectServiceReportInfoForClearance.get({department:$stateParams.projectService.departmentName,projectid:$stateParams.projectService.projectid,service:$stateParams.projectService.serviceName});
                            //                            }]
                        }
                    }).result.then(function() {
                        $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                    }, function() {
                        $state.go('serviceclearanceaction');
                    });
                }]
            })
        .state('towerofficer-action-verifyOtherPayment', {
                    parent: 'showprojectsTowerofficer',
                    url: '/towerofficer-action-verifyOtherPayment/{projectserviceid}',
                    data: {
                        authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_ACCOUNT_OFFICER','ROLE_NODAL_OFFICER','ROLE_USER','ROLE_FIELD_OFFICER','ROLE_TOWER_OFFICER']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/serviceclearanceactions/verifyOtherPayment.html',
                            controller: 'verifyOtherPaymentController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                                projectServiceLog: function () {
                                      return {
                                          projectid: null,
                                          serviceid: null,
                                          comments: null,
                                          commentDate: null,
                                          commentByUserLogin: null,
                                          actionTaken: null,
                                          id: null
                                      };
                                  },
                                  projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                       return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                                  }],
                                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                    $translatePartialLoader.addPart('home');
                                    return $translate.refresh();
                                }]
                            }
                        }).result.then(function() {
                            $state.go('showprojectsTowerofficer', null, { reload: 'showprojectsTowerofficer' });
                        }, function() {
                            $state.go('showprojectsTowerofficer');
                        });
                    }]
                })
       .state('assignserviceforbankgurantee', {
            parent: 'showprojectsTowerofficer',
            url: '/assignserviceforbankgurantee/{projectserviceid}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_TOWER_OFFICER', 'ROLE_TOWER_DC']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/projectBankGuarantee/assignfeeforbankgurantee.html',
                    controller: 'assignfeeforbankgurantee',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        projectAttachemnt: function () {
                            return {
                                fileName: null,
                                description: null,
                                fileExtension: null,
                                serverFileName: null,
                                id: null
                            };
                        },
                        projectServiceLog: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                comments: null,
                                commentDate: null,
                                commentByUserLogin: null,
                                actionTaken: null,
                                id: null
                            };
                        },
                        projectService: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('showprojectsTowerofficer', null, { reload: 'showprojectsTowerofficer' });
                }, function() {
                    $state.go('showprojectsTowerofficer');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('ShowprojectsTowerofficerService', ShowprojectsTowerofficerService);

    ShowprojectsTowerofficerService.$inject = ['$resource'];

    function ShowprojectsTowerofficerService($resource) {
        var resourceUrl =  'api/viewby-towerOfficer/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ShowprojectsTowerofficerController', ShowprojectsTowerofficerController);

    ShowprojectsTowerofficerController.$inject = ['$scope', '$filter', 'ShowprojectsTowerofficerService', 'ForceMajeureService'];

    function ShowprojectsTowerofficerController($scope, $filter , ShowprojectsTowerofficerService, ForceMajeureService) {

        /**
         * The only service that is intimated rather than cleared -
         * Communication and Connectivity Permissions/Renewal(Above Ground).
         */
        var ABOVE_GROUND_SERVICE_ID = '58d75fd4-f360-4931-a484-ff9be0adc12c';

        /** ..and only when the tower does not stand on a public property. */
        var OTHER_THAN_PUBLIC_PROPERTY = 'other than public property';

        /** The form filled on date counts as the first of the 15 days. */
        var CLARIFY_WINDOW_DAYS = 15;

        /** The status an intimation of such a tower is acknowledged on. */
        var STATUS_ACKNOWLEDGED = 'Acknowledged';

        var vm = this;
        vm.projects = [];
        vm.status='Pending';
        vm.projects.isForceMajeure = false;
        vm.showFormFilledOnDate = false;
        vm.isTowerServiceForClarification = isTowerServiceForClarification;

        loadAll();

        function loadAll() {
            ShowprojectsTowerofficerService.query({ status: vm.status }, function (result) {

                vm.projects = $filter('filter')(result, { formfilledstatus: true });

                // Form filled on date is only relevant once the service was acknowledged.
                vm.showFormFilledOnDate = vm.status === 'Acknowledged';

                angular.forEach(vm.projects, function (project) {
                    checkForceMajeure(project);
                    project.canClarify = canClarify(project);
                    project.canDecideIntimation = canDecideIntimation(project);
                });
            });
        }

        function checkForceMajeure(project) {

            ForceMajeureService.checkForceMajeure(
                { district: project.district },
                function (responseArray) {

                    if (responseArray && responseArray.length > 0) {
                        project.isForceMajeure = true;
                    } else {
                        project.isForceMajeure = false;
                    }
                }
            );
        }


        /**
         * The application may be clarified for 15 days from the day its service form
         * was filled - that day included, so a form filled today leaves 14 more days.
         *
         * Only once: an application that has already been clarified keeps that stamp for
         * good, so the button does not come back when the applicant answers and the
         * reverted flag is taken off again.
         */
        function canClarify(project) {
            if (!isAboveGroundIntimation(project)) {
                return false;
            }
            if (project.clarifiedOnce) {
                return false;
            }
            if (project.reverted) {
                return false;
            }
            if (!project.formFilledOnDate) {
                return false;
            }

            var filledOn = new Date(project.formFilledOnDate);
            if (isNaN(filledOn.getTime())) {
                return false;
            }

            return daysSince(filledOn) < CLARIFY_WINDOW_DAYS;
        }

        /**
         * An acknowledged intimation is the officer's to approve or reject - approving
         * it stands it as valid, rejecting it takes it away, and either way the
         * application leaves the acknowledged state and the buttons go with it.
         */
        function canDecideIntimation(project) {
            return isAboveGroundIntimation(project) && project.status === STATUS_ACKNOWLEDGED;
        }

        /** Above Ground, on a property the applicant does not share with a public entity. */
        function isAboveGroundIntimation(project) {
            if (!project.serviceid || project.serviceid.toLowerCase() !== ABOVE_GROUND_SERVICE_ID) {
                return false;
            }

            return !!project.property
                && project.property.trim().toLowerCase() === OTHER_THAN_PUBLIC_PROPERTY;
        }

        /**
         * Whole days between the two dates, counted on the calendar - a form filled
         * late in the evening still gets every one of its days.
         */
        function daysSince(date) {
            var from = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

            return Math.round((today - from) / 86400000);
        }

        function isTowerServiceForClarification(serviceId) {

                return !!((serviceId === '5f8e0757-e88b-4ef1-bb15-00a9e984b9b1' || serviceId === '58d75fd4-f360-4931-a484-ff9be0adc12c' || serviceId === '741f0f60-cf69-4659-8b19-19d96ffe0103' || serviceId === 'fc1b1635-d3dc-4d30-a5fd-5abf6381594d' || serviceId === '6f81801c-59c6-4773-9f37-a5d81172a1bf' || serviceId === '240d2c66-b6cc-4a0c-b5f0-3f6717177810'));

        }


        vm.statusSelected=function () {
            loadAll();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerOfficerProjectDialogController', TowerOfficerProjectDialogController);

    TowerOfficerProjectDialogController.$inject = ['$scope','$stateParams','GetServiceLog','serviceFormFieldDataCollection','ServiceFormAttachments','$uibModalInstance','downloadserviceformattachment','ProjectAction','projectService', 'ReasonCategory','TowerRejectionReasonByCategory', 'ProjectServiceLogUpdated', 'Projectservicedetail', 'ProjectAttachemnt', 'FileManagement'];

    function TowerOfficerProjectDialogController ($scope,$stateParams,GetServiceLog,serviceFormFieldDataCollection,ServiceFormAttachments,$uibModalInstance,downloadserviceformattachment,ProjectAction,projectService, ReasonCategory, TowerRejectionReasonByCategory, ProjectServiceLogUpdated, Projectservicedetail, ProjectAttachemnt, FileManagement) {

        /**
         * The only service that is intimated rather than cleared -
         * Communication and Connectivity Permissions/Renewal(Above Ground).
         */
        var ABOVE_GROUND_SERVICE_ID = '58d75fd4-f360-4931-a484-ff9be0adc12c';

        /** ..and only when the tower does not stand on a public property. */
        var OTHER_THAN_PUBLIC_PROPERTY = 'other than public property';

        /** Status an approved intimation of an Above Ground tower carries. */
        var STATUS_INTIMATION_VALID = 'Intimation Valid';

        /** ..and a rejected one. */
        var STATUS_INTIMATION_INVALID = 'Intimation Invalid';

        var vm = this;
        vm.projects=[];
        vm.downloadFile=downloadFile;
        vm.addComment=addComment;
        vm.addClarification=addClarification;
        vm.assignServiceFee=assignServiceFee;
        vm.status=$stateParams.action;
        vm.projectAttachemnt={};
        vm.pdfconverter= pdfconverter;
        vm.chooseCommentType=chooseCommentType;
        vm.getRejectionReason = getRejectionReason;
        vm.getReasons = getReasons;
        vm.addRevert=addRevert;
        vm.addIntimationDecision=addIntimationDecision;
        var projectServiceLogid=null;
        vm.projectService = projectService;
        var projectAttachmentResultObject=null;
        /** What the attachment of the action being taken is filed under. */
        var attachmentDescription="Revert";

        $scope.file = {};
        vm.rejectionReasons = [];
        vm.reasonCategories = [];

        loadProject();

        function loadProject() {
            vm.project=projectService;
           switch (vm.status){
               case 'service-logs':
                   viewlogs(vm.project);
                   break;
               case 'view-form':
                   loadFilledForm(vm.project);
                   break;
           }

            ReasonCategory.query(function(result) {
                vm.reasonCategories = result;
                vm.searchQuery = null;
            });
        }

        function pdfconverter() {
            var element = document.getElementById('pdf_logs');
            html2pdf(element,{
                margin:  0.5,
                html2canvas: { dpi:192, letterRendering: true },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            });
        };

        function viewlogs(project) {
            vm.project=project;
            GetServiceLog.query({projectid:project.projectid,serviceid:project.serviceid},function (result) {
                vm.ServiceLog=result;
            });
        }

        function loadFilledForm(project) {
            vm.project=project;
            vm.serviceFormFieldData= serviceFormFieldDataCollection.query({serviceid:project.serviceid, projectid:project.projectid});
            vm.serviceformattachments=ServiceFormAttachments.query({id:"1",serviceid:project.serviceid, projectid:project.projectid});
        }

        function addComment() {
            ProjectAction.comment(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function chooseCommentType(value) {

            vm.commentType = value;

        }
        function getRejectionReason(category) {
            TowerRejectionReasonByCategory.query({category: category.category}, function(result) {
                vm.rejectionReasons = result;
                vm.searchQuery = null;
            });
        }

        function getReasons() {
            var reasons = [];
            angular.forEach(vm.selectedReason, function (value, key) {
                reasons.push(value.reason);
            }, reasons);
            var rejection = reasons.join();

            var code = [];
            angular.forEach(vm.selectedReason, function (value, key) {
                code.push(value.code);
            }, code);
            vm.rejectionReason = rejection;
            vm.rejectedProjectServiceLog.reasonCode = code;
        }



        function addClarification(role) {

            if (vm.commentType===undefined){
                alert("Please Choose Comment Type");
                return;
            }
            if (vm.commentType==='Comment'){
                addComment();
            } else {
                ProjectAction.clarification(vm.project,vm.projectAttachemnt,vm.comments, role, onsuccess,onerror, vm.selectedCategory.category, vm.rejectionReason);
            }
        }

        function assignServiceFee(){
            ProjectAction.assignFee(vm.project,vm.projectAttachemnt,vm.comments,vm.serviceFee,onsuccess,onerror);
        }

        function downloadFile(serverfilename,downloadfilename)
        {
            downloadserviceformattachment.download(serverfilename,downloadfilename)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }

        vm.clear=function () {
            $uibModalInstance.dismiss('cancel');
        };

        function onsuccess(result) {
            $uibModalInstance.close();
        }

        function addRevert(){
            vm.projectServiceLog.projectid = vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="Reverted";
            attachmentDescription="Revert";

            ProjectServiceLogUpdated.save(vm.projectServiceLog,onRevertServiceLogSaveSuccess,onServiceLogSaveError);

        }

        /**
         * The officer's word on an acknowledged Above Ground intimation - Approve stands
         * it as valid, Reject takes it away. Which of the two is being answered is the
         * action the dialog was opened on.
         *
         * The log is written first and the application stamped after it, the way the
         * revert does it - a status nobody can see the reason for would leave the
         * applicant with no way of telling what happened.
         */
        function addIntimationDecision(){
            var status = vm.status === 'Approve' ? STATUS_INTIMATION_VALID : STATUS_INTIMATION_INVALID;

            // The comment box of the form is what creates the log, so it is only there
            // once something was typed into it.
            vm.projectServiceLog = vm.projectServiceLog || {};
            vm.projectServiceLog.projectid = vm.projectService.projectid;
            vm.projectServiceLog.serviceid = vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken = status;
            attachmentDescription = vm.status;

            ProjectServiceLogUpdated.save(vm.projectServiceLog, function (result) {
                onIntimationDecisionLogSaveSuccess(result, status);
            }, onServiceLogSaveError);
        }

        function onIntimationDecisionLogSaveSuccess(result, status)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status=status;
            // Decided either way, so nothing is owed by the applicant any more - an
            // intimation that went back for a clarification stops waiting on one here.
            vm.projectService.reverted=false;
            vm.projectService.statusdate=result.commentDate;
            // The save counts re-applications of the service and an old application
            // carries no such flag - it is read there as a plain boolean.
            if(vm.projectService.reApply===undefined || vm.projectService.reApply===null){
                vm.projectService.reApply=false;
            }
            // Last action date is stamped by the update itself.
            Projectservicedetail.update(vm.projectService, onUpdateProjectServiceReportInfoSuccess, onUpdateProjectServiceError);
        }

        function onRevertServiceLogSaveSuccess(result)
        {

            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="Reverted";
            vm.projectService.reverted=true;
            vm.projectService.revertedDate = result.commentDate;
            // An Above Ground intimation on a property other than public gets one
            // clarification only - stamped here so the button stays gone even after the
            // applicant has responded and the reverted flag is taken off again.
            if(isAboveGroundIntimation(vm.projectService)){
                vm.projectService.clarifiedOnce=true;
            }
            //vm.projectService.countTotalDays = 0;
            //  vm.projectService.departmentLevel = false;
            Projectservicedetail.update(vm.projectService, onUpdateProjectServiceReportInfoSuccess, onUpdateProjectServiceError);

        }

        /** Above Ground, on a property the applicant does not share with a public entity. */
        function isAboveGroundIntimation(project) {
            if (!project.serviceid || String(project.serviceid).toLowerCase() !== ABOVE_GROUND_SERVICE_ID) {
                return false;
            }

            return !!project.property
                && project.property.trim().toLowerCase() === OTHER_THAN_PUBLIC_PROPERTY;
        }

        function onUpdateProjectServiceReportInfoSuccess(result)
        {

            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }


        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }

        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }

        function saveProjectAttachment()
        {

            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description=attachmentDescription;
            vm.projectAttachemnt.fileExtension =file.type;
            console.log('attactt' + vm.projectAttachemnt);
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }

        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }

            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }


        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }



        function onerror() {

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerDioProjectDialogController', TowerDioProjectDialogController);

    TowerDioProjectDialogController.$inject = ['$scope','$stateParams','GetServiceLog','serviceFormFieldDataCollection','ServiceFormAttachments','$uibModalInstance','downloadserviceformattachment','ProjectActionTowerDio','projectService'];

    function TowerDioProjectDialogController ($scope,$stateParams,GetServiceLog,serviceFormFieldDataCollection,ServiceFormAttachments,$uibModalInstance,downloadserviceformattachment,ProjectActionTowerDio,projectService) {
        var vm = this;
        vm.projects=[];
        vm.downloadFile=downloadFile;
        vm.clearService=clearService;
        vm.addComment=addComment;
        vm.deactivateService=deactivateService;
        vm.rejectService=rejectService;
        vm.reactivate=reactivate;
        vm.undoreject=undoreject;
        vm.status=$stateParams.action;
        vm.projectAttachemnt={};

        $scope.file = {};

        loadProject();

        function loadProject() {
            vm.project=projectService;
           switch (vm.status){
               case 'service-logs':
                   viewlogs(vm.project);
                   break;
               case 'view-form':
                   loadFilledForm(vm.project);
                   break;
           }
        }

        vm.pdfconverter= function  () {
            console.log("called");
            var element = document.getElementById('pdf_data');
            html2pdf(element,{
                margin: 4
            });
        };

        function viewlogs(project) {
            vm.project=project;
            GetServiceLog.query({projectid:project.projectid,serviceid:project.serviceid},function (result) {
                vm.ServiceLog=result;
            });
        }

        function loadFilledForm(project) {
            vm.project=project;
            vm.serviceFormFieldData= serviceFormFieldDataCollection.query({serviceid:project.serviceid, projectid:project.projectid});
            vm.serviceformattachments=ServiceFormAttachments.query({id:"1",serviceid:project.serviceid, projectid:project.projectid});
        }


        function clearService() {
            ProjectActionTowerDio.clear(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function addComment() {
            console.log(vm.projectAttachemnt);
            ProjectActionTowerDio.comment(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function deactivateService() {
            ProjectActionTowerDio.deactivate(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function rejectService() {
            ProjectActionTowerDio.reject(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function reactivate() {
            ProjectActionTowerDio.reactivate(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function undoreject() {
            ProjectActionTowerDio.undoreject(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function downloadFile(serverfilename,downloadfilename)
        {
            downloadserviceformattachment.download(serverfilename,downloadfilename)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }

        vm.clear=function () {
            $uibModalInstance.close();
        }

        function onsuccess(result) {
            console.log(result);
            $uibModalInstance.close();
        }

        function onerror() {

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('projects-towerdio', {
            parent: 'app',
            url: '/projects-towerdio',
            data: {
                authorities: ['ROLE_TOWER_DIO','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/showprojects-towerdio/projects_towerdio.html',
                    controller: 'TowerDioProjectsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                projectAttachemnt: function () {
                    return {
                        fileName: null,
                        description: null,
                        fileExtension: null,
                        serverFileName: null,
                        id: null
                    };
                },
                projectServiceLog: function () {
                    return {
                        projectid: null,
                        serviceid: null,
                        comments: null,
                        commentDate: null,
                        commentByUserLogin: null,
                        actionTaken: null,
                        id: null
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        })
            .state('action-towerdio', {
                parent: 'projects-towerdio',
                url: '/{action}/{projectserviceid}',
                data: {
                    authorities: ['ROLE_TOWER_DIO','ROLE_ADMIN','ROLE_SUB_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/showprojects-towerdio/projects-dialog_towerdio.html',
                        controller: 'TowerDioProjectDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            projectAttachemnt: function () {
                                return {
                                    fileName: null,
                                    description: null,
                                    fileExtension: null,
                                    serverFileName: null,
                                    id: null
                                };
                            },
                            projectServiceLog: function () {
                                return {
                                    projectid: null,
                                    serviceid: null,
                                    comments: null,
                                    commentDate: null,
                                    commentByUserLogin: null,
                                    actionTaken: null,
                                    id: null
                                };
                            },
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                $translatePartialLoader.addPart('home');
                                return $translate.refresh();
                            }],
                            projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            });

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerDioProjects', TowerDioProjects);

    TowerDioProjects.$inject = ['$resource'];

    function TowerDioProjects ($resource) {
        var resourceUrl =  'api/getProjectsForTowerDio/:status/:departmentName';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerDioProjectsController', TowerDioProjectsController);

    TowerDioProjectsController.$inject = ['$scope','TowerDioProjects', 'Department', '$filter'];

    function TowerDioProjectsController($scope, TowerDioProjects, Department, $filter) {
        var vm = this;
        vm.projects = [];
        vm.status='Pending';
        vm.currentDepartment="All";
        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";


        loadAll();

        function loadAll() {
            TowerDioProjects.get({
                status:vm.status,
                departmentName: vm.currentDepartment,
                page: $scope.currentPage - 1,
                size: $scope.pageSize
            },function (result) {
                vm.projects = result;
            });
            Department.query(function(result){
                vm.departments = $filter('filter')(result,{ istower : true });
            });
        }

        vm.statusSelected=function () {
          loadAll();
        };

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        };

        $scope.pageChangedHandler = function(num) {
            loadAll();
        };

    }
})();

(function () {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectActionTowerDio', ProjectActionTowerDio);

    ProjectActionTowerDio.$inject = ['Projectservicedetail', 'ProjectServiceLogUpdated', 'ProjectServiceReportInfoForClearance', 'ProjectAttachemnt', 'FileManagement','CheckContentFile'];

    function ProjectActionTowerDio(Projectservicedetail, ProjectServiceLogUpdated, ProjectServiceReportInfoForClearance, ProjectAttachemnt, FileManagement,CheckContentFile) {

        function performAction(project, attachment, comments, onsuccess, onerror, actiontaken, description,status) {
            var projectServiceLog = {};
            var projectAttachment = {};
            var projectAttachmentResultObject = null;
            var projectServiceLogid = null;
            var projectService = Projectservicedetail.get({id: project.id}, function () {
                var projectservicereportinfo = ProjectServiceReportInfoForClearance.get({
                    projectid: project.projectid,
                    department: project.departmentName,
                    service: project.serviceName
                }, function () {

                    projectServiceLog.projectid = project.projectid;
                    projectServiceLog.serviceid = project.serviceid;
                    projectServiceLog.comments = comments;
                    projectServiceLog.actionTaken = actiontaken;
                    ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                    function onServiceLogSaveSuccess(result) {
                        projectServiceLogid = result.id;
                        projectService.latestComments = projectServiceLog.comments;
                        projectService.status = status;
                        Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                    }

                    function onUpdateProjectServiceSuccess(result) {
                        projectservicereportinfo.status = status;
                        ProjectServiceReportInfoForClearance.update(projectservicereportinfo, onUpdateProjectServiceReportInfoSuccess, onUpdateProjectServiceReportInfoError);
                    }

                    function onUpdateProjectServiceReportInfoSuccess(result) {
                        if (angular.isDefined(attachment.file)) {
                            saveProjectAttachment();
                        }
                        else {
                            onsuccess(result);
                        }
                    }

                    function onUpdateProjectServiceError() {
                        onerror();

                    }

                    function onServiceLogSaveError() {
                        onerror();
                    }

                    function saveProjectAttachment() {
                        var file = attachment.file;
                        projectAttachment.id = projectServiceLogid;
                        projectAttachment.fileName = file.name;
                        projectAttachment.description = description;
                        projectAttachment.fileExtension = file.type;
                        ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                    }

                    function onSaveProjectAttachmentSuccess(result) {
                        var filename = result.id;
                        var file = attachment.file;
                        FileManagement.saveFile(file, filename);
                        projectAttachmentResultObject = result;

                        var fileNameArray = attachment.file.name.split(".");
                        var fileextension = "";
                        if ((fileNameArray.length > 1)) {
                            fileextension = fileNameArray[(fileNameArray.length - 1)];
                        }
                        var inputFileName = result.id;
                        if (fileextension !== "") {
                            inputFileName = inputFileName + "." + fileextension;
                        }
                        projectAttachmentResultObject.serverFileName = inputFileName;

                        ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                    }

                    function onSaveProjectAttachmentError() {
                        onerror();
                    }

                    function onUpdateProjectAttachmentSuccess(result) {
                        onsuccess(result);
                    }

                    function onUpdateProjectServiceReportInfoError() {

                        onerror();
                    }

                    function onUpdateProjectAttachmentError() {
                        onerror();
                    }

                });
            });
        }

        return {
            clear: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Cleared';
                var status = 'Cleared';
                var description = 'Clearance Attachment';
                if(CheckContentFile.checkFile(attachment.file.name)){
                    performAction(project, attachment, comments, onsuccess, onerror, actiontaken, description,status);
                }
                else {
                    alert("Invalid File");
                }
            },
            reject: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Declined';
                var status = 'Declined';
                var description = 'Rejection Attachment';
                if(CheckContentFile.checkFile(attachment.file.name)){
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }
                else {
                    alert("Invalid File");
                }
            },
            deactivate: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Rejected';
                var status = 'Rejected';
                var description = 'Rejection Attachment';

                performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
            },
            reactivate: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Re-Activated';
                var status = 'Pending';
                var description = 'Reactivation Attachment';

                performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
            },
            undoreject: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Undo-Rejected';
                var status = 'Pending';
                var description = 'Undo-Rejected Attachment';

                if (angular.isDefined(attachment.file)) {
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else {
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }

            },
            comment: function (project, attachment, comments, onsuccess, onerror) {
                if (angular.isDefined(attachment.file)) {
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        addComment();
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else {
                    addComment();
                }

                function addComment(){
                    var projectServiceLog = {};
                    var projectAttachment = {};
                    var projectAttachmentResultObject = null;
                    var projectServiceLogid = null;
                    var projectService = Projectservicedetail.get({id: project.id}, function () {
                        projectServiceLog.projectid = project.projectid;
                        projectServiceLog.serviceid = project.serviceid;
                        projectServiceLog.comments = comments;
                        projectServiceLog.actionTaken = "OpenComment";
                        ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                        function onServiceLogSaveSuccess(result) {
                            projectServiceLogid = result.id;
                            projectService.latestComments = projectServiceLog.comments;
                            Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                        }

                        function onUpdateProjectServiceSuccess(result) {
                            if (angular.isDefined(attachment.file)) {
                                saveProjectAttachment();
                            }
                            else {
                                onsuccess(result);
                            }
                        }

                        function onUpdateProjectServiceError() {

                        }

                        function onServiceLogSaveError() {
                        }

                        function saveProjectAttachment() {
                            var file = attachment.file;
                            projectAttachment.id = projectServiceLogid;
                            projectAttachment.fileName = file.name;
                            projectAttachment.description = "Clearance Attachment";
                            projectAttachment.fileExtension = file.type;
                            ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentSuccess(result) {
                            var filename = result.id;
                            var file = attachment.file;
                            FileManagement.saveFile(file, filename);
                            projectAttachmentResultObject = result;

                            var fileNameArray = attachment.file.name.split(".");
                            var fileextension = "";
                            if ((fileNameArray.length > 1)) {
                                fileextension = fileNameArray[(fileNameArray.length - 1)];
                            }
                            var inputFileName = result.id;
                            if (fileextension !== "") {
                                inputFileName = inputFileName + "." + fileextension;
                            }
                            projectAttachmentResultObject.serverFileName = inputFileName;

                            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentError() {
                            onerror();
                        }

                        function onUpdateProjectAttachmentSuccess(result) {
                            onsuccess(result);
                        }

                        function onUpdateProjectServiceReportInfoError() {

                            onerror();
                        }

                        function onUpdateProjectAttachmentError() {
                            onerror();
                        }

                    });
                }

            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerDcProjectDialogController', TowerDcProjectDialogController);

    TowerDcProjectDialogController.$inject = ['$scope','$stateParams','GetServiceLog','serviceFormFieldDataCollection','ServiceFormAttachments','$uibModalInstance','downloadserviceformattachment','ProjectAction','projectService', 'ProjectServiceLogUpdated', 'Projectservicedetail', 'ProjectServiceReportInfoForClearance', 'ProjectAttachemnt', 'FileManagement','CheckContentFile','ProjectServicePaymentDetailsByProjectAndService', 'TowerRejectionReason', 'RejectedProjectServiceLog', 'ReasonCategory','TowerRejectionReasonByCategory'];

    function TowerDcProjectDialogController ($scope,$stateParams,GetServiceLog,serviceFormFieldDataCollection,ServiceFormAttachments,$uibModalInstance,downloadserviceformattachment,ProjectAction,projectService, ProjectServiceLogUpdated, Projectservicedetail, ProjectServiceReportInfoForClearance, ProjectAttachemnt, FileManagement,CheckContentFile ,ProjectServicePaymentDetailsByProjectAndService, TowerRejectionReason, RejectedProjectServiceLog, ReasonCategory, TowerRejectionReasonByCategory) {
        var vm = this;
        vm.projects=[];
        vm.downloadFile=downloadFile;
        vm.clearService=clearService;
        vm.addComment=addComment;
        vm.deactivateService=deactivateService;
        vm.rejectService=rejectService;
        vm.reactivate=reactivate;
        vm.undoreject=undoreject;
        vm.deemedClearService = deemedClearService;
        vm.addClarification=addClarification;
        vm.chooseCommentType=chooseCommentType;
        vm.addRevert=addRevert;
        vm.rejectIntimation=rejectIntimation;

        vm.projectService = projectService                                                                      ;

        vm.status=$stateParams.action;
        vm.projectAttachemnt={};
        var projectServiceLogid=null;
        var projectAttachmentResultObject=null;
        vm.rejectedProjectServiceLog = {};
        vm.getReasons = getReasons;
        vm.getRejectionReason = getRejectionReason;
        vm.selectedCategory = {};
        vm.rejectionReason = "";

        $scope.file = {};

        vm.rejectionReasons = [];
        vm.reasonCategories = [];

        loadAll();

        function loadAll() {
            ReasonCategory.query(function(result) {
                vm.reasonCategories = result;
                vm.searchQuery = null;
            });
        }

        function getRejectionReason(category) {
            TowerRejectionReasonByCategory.query({category: category.category}, function(result) {
                vm.rejectionReasons = result;
                vm.searchQuery = null;
            });
        }

        function getReasons() {
            var reasons = [];
            angular.forEach(vm.selectedReason, function (value, key) {
                reasons.push(value.reason);
            }, reasons);
            var rejection = reasons.join();

            var code = [];
            angular.forEach(vm.selectedReason, function (value, key) {
                code.push(value.code);
            }, code);
            vm.rejectionReason = rejection;
            vm.rejectedProjectServiceLog.reasonCode = code;
        }


        loadProject();

        function loadProject() {
            vm.project=projectService;
           switch (vm.status){
               case 'service-logs':
                   viewlogs(vm.project);
                   break;
               case 'view-form':
                   loadFilledForm(vm.project);
                   break;
           }
        }

        vm.pdfconverter= function  () {
            console.log("called");
            var element = document.getElementById('pdf_data');
            html2pdf(element,{
                margin: 4
            });
        };

        function viewlogs(project) {
            vm.project=project;
            GetServiceLog.query({projectid:project.projectid,serviceid:project.serviceid},function (result) {
                vm.ServiceLog=result;
            });
        }

        function loadFilledForm(project) {
            vm.project=project;
            vm.serviceFormFieldData= serviceFormFieldDataCollection.query({serviceid:project.serviceid, projectid:project.projectid});
            vm.serviceformattachments=ServiceFormAttachments.query({id:"1",serviceid:project.serviceid, projectid:project.projectid});
        }

        loadAllPayments();

        function loadAllPayments() {
            vm.assignFeeDetail=ProjectServicePaymentDetailsByProjectAndService.query({projectid: vm.projectService.projectid,serviceid: vm.projectService.serviceid});
        }


        function clearService() {
            ProjectAction.clear(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function addComment() {
            ProjectAction.comment(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }


         function addClarification(role) {
             if (vm.commentType===undefined){
                 alert("Please Choose Comment Type");
                 return;
             }
             if (vm.commentType==='Comment'){

                 //addComment();
             } else {
                 alert(vm.vm.selectedCategory.category);
                 alert(vm.rejectionReason);
                 //ProjectAction.clarification(vm.project,vm.projectAttachemnt,vm.comments, role, onsuccess,onerror, vm.selectedCategory.category, vm.rejectionReason);
             }
                }

        function deactivateService() {
            ProjectAction.deactivate(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function rejectService() {
            ProjectAction.reject(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror, vm.selectedCategory.category, vm.rejectionReason);
        }

        function reactivate() {
            ProjectAction.reactivate(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function undoreject() {
            ProjectAction.undoreject(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function deemedClearService(){
                if(CheckContentFile.checkFile(vm.projectAttachemnt.file.name)){
                    vm.projectServiceLog.projectid = vm.projectService.projectid;
                    vm.projectServiceLog.serviceid=vm.projectService.serviceid;
                    vm.projectServiceLog.actionTaken="DeemedCleared";
                    ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
                }
                else{
                    alert("Invalid File");

            }
        }

        function addRevert(){
                    vm.projectServiceLog.projectid = vm.projectService.projectid;
                    vm.projectServiceLog.serviceid=vm.projectService.serviceid;
                    vm.projectServiceLog.actionTaken="Reverted";

                   ProjectServiceLogUpdated.save(vm.projectServiceLog,onRevertServiceLogSaveSuccess,onServiceLogSaveError);

        }


   function rejectIntimation(){
                    vm.projectServiceLog.projectid = vm.projectService.projectid;
                    vm.projectServiceLog.serviceid=vm.projectService.serviceid;
                    vm.projectServiceLog.actionTaken="RejectIntimated";

                   ProjectServiceLogUpdated.save(vm.projectServiceLog,onRejectIntematedServiceLogSaveSuccess,onServiceLogSaveError);

        }

        function chooseCommentType(value) {

            vm.commentType = value;

        }

        function onServiceLogSaveSuccess(result)
        {

            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="DeemedCleared";
            vm.projectService.deemedClearedDate = result.commentDate;
            vm.projectService.countTotalDays = 0;
            vm.projectService.departmentLevel = false;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }

        function onRevertServiceLogSaveSuccess(result)
        {

            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="Reverted";
            vm.projectService.reverted=true;
            vm.projectService.revertedDate = result.commentDate;
            //vm.projectService.countTotalDays = 0;
          //  vm.projectService.departmentLevel = false;
            Projectservicedetail.update(vm.projectService, onUpdateProjectServiceReportInfoSuccess, onUpdateProjectServiceError);
        }

        function onRejectIntematedServiceLogSaveSuccess(result)
        {

            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="RejectIntimated";
            vm.projectService.rejectIntimated=true;
            vm.projectService.rejectIntimationDate = result.commentDate;
            //vm.projectService.countTotalDays = 0;
          //  vm.projectService.departmentLevel = false;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceError);
        }

        function onUpdateProjectServiceSuccess(result)
        {

            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({projectid:vm.projectService.projectid,department:vm.projectService.departmentName,service:vm.projectService.serviceName});
            vm.projectservicereportinfo.status='DeemedCleared';
            vm.projectservicereportinfo.projectid = result.projectid;
            vm.projectservicereportinfo.departmentname = result.departmentName;
            vm.projectservicereportinfo.servicename = result.serviceName;
            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
        }

        function onUpdateProjectServiceReportInfoSuccess(result)
        {

            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }

        function saveProjectAttachment()
        {

            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description=vm.projectservicereportinfo.status;
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }

        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }

            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }

        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }

        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }

        function onUpdateProjectServiceReportInfoError()
        {
            vm.isSaving = false;
        }

        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function downloadFile(serverfilename,downloadfilename)
        {
            downloadserviceformattachment.download(serverfilename,downloadfilename)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }

        vm.clear=function () {
            $uibModalInstance.close();
        };

        function onsuccess(result) {
            console.log(result);
            vm.rejectedProjectServiceLog.projectServiceLogId = result.id;
            RejectedProjectServiceLog.save(vm.rejectedProjectServiceLog);
            $uibModalInstance.close();
        }

        function onerror() {

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('projects', {
            parent: 'app',
            url: '/projects',
            data: {
                authorities: ['ROLE_TOWER_DC','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/showprojects-towerdc/projects.html',
                    controller: 'TowerDcProjectsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                projectAttachemnt: function () {
                    return {
                        fileName: null,
                        description: null,
                        fileExtension: null,
                        serverFileName: null,
                        id: null
                    };
                },
                projectServiceLog: function () {
                    return {
                        projectid: null,
                        serviceid: null,
                        comments: null,
                        commentDate: null,
                        commentByUserLogin: null,
                        actionTaken: null,
                        id: null
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        })
            .state('action', {
                parent: 'projects',
                url: '/{action}/{projectserviceid}',
                data: {
                    authorities: ['ROLE_TOWER_DC','ROLE_ADMIN','ROLE_SUB_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/showprojects-towerdc/projects-dialog.html',
                        controller: 'TowerDcProjectDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            projectAttachemnt: function () {
                                return {
                                    fileName: null,
                                    description: null,
                                    fileExtension: null,
                                    serverFileName: null,
                                    id: null
                                };
                            },
                            projectServiceLog: function () {
                                return {
                                    projectid: null,
                                    serviceid: null,
                                    comments: null,
                                    commentDate: null,
                                    commentByUserLogin: null,
                                    actionTaken: null,
                                    id: null
                                };
                            },
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                $translatePartialLoader.addPart('home');
                                return $translate.refresh();
                            }],
                            projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                            }]
//                            projectservicereportinfo: ['ProjectServiceReportInfoForClearance', function(ProjectServiceReportInfoForClearance) {
//                                return ProjectServiceReportInfoForClearance.get({department:$stateParams.projectService.departmentName,projectid:$stateParams.projectService.projectid,service:$stateParams.projectService.serviceName});
//                            }]
                        }
                    }).result.then(function() {
                        $state.go('^', {}, { reload: false });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
            .state('actionForSurvey', {
                parent: 'app',
                url: '/actionforsurvey/{action}/{projectserviceid}',
                data: {
                    authorities: ['ROLE_TOWER_DC', 'ROLE_ADMIN', 'ROLE_SUB_ADMIN', 'ROLE_TOWER_OFFICER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    // Open the modal but ensure no unintended state transitions happen
                    $uibModal.open({
                        templateUrl: 'app/surveyForm/commentForSurvey.html',
                        controller: 'CommentforofficerController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('home');
                                return $translate.refresh();
                            }],
                            projectService: ['SurveyForm', function (SurveyForm) {
                                return SurveyForm.get({ id: $stateParams.projectserviceid }).$promise;
                            }]
                        }
                    });

                }]
            });


    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerDcProjects', TowerDcProjects);

    TowerDcProjects.$inject = ['$resource'];

    function TowerDcProjects ($resource) {
        var resourceUrl =  'api/get-projects/:status/:departmentName';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerDcProjectsController', TowerDcProjectsController);

    TowerDcProjectsController.$inject = ['$scope', '$stateParams', 'TowerDcProjects', 'Department', '$filter', 'TowerserviceNO', 'Municipals', 'ForceMajeureService'];

    function TowerDcProjectsController($scope, $stateParams, TowerDcProjects, Department, $filter, TowerserviceNO, Municipals, ForceMajeureService) {
        var vm = this;
        vm.projects = [];
        vm.status='Pending';
        vm.currentDepartment="All";
        vm.municipals = [];
        vm.isForceMajeure = false;
        vm.isTowerServiceForClarification = isTowerServiceForClarification;
        $scope.required={
            department: {},
            municipal:{}
        };
        $scope.requiredMunicipal = [];
        vm.towerserviceNO = {};

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.tower_departments = tower_departments;

        loadAll();

        function loadAll() {
            TowerDcProjects.get({
                status: vm.status,
                departmentName: vm.currentDepartment,
                page: $scope.currentPage - 1,
                size: $scope.pageSize
            },function (result) {
                vm.projects = result;
                vm.projectsCheck = result.content[0];


                // angular.forEach(vm.projectsCheck, function (project) {
                    checkForceMajeure(vm.projectsCheck);
                // });
            });
            Department.query(function(result){
                vm.departments = $filter('filter')(result,{ istower : true });
            });
        }

        function checkForceMajeure(project) {
            ForceMajeureService.checkForceMajeure(
                { district: project.district },
                function (responseArray) {

                    // If array has entries → Force Majeure exists
                    if (responseArray && responseArray.length > 0) {
                        vm.isForceMajeure = true;

                    }
                }
            );
        }

        function tower_departments(service,type) {
            $scope.required.department=[];
            vm.tower_service = service;
            vm.required_type = type;
            Department.query(function(result) {
                vm.tower_departmentlist = result;
            });
        }

        vm.updateCheck = function (check) {
            $scope.required.department=[];
            $scope.required.department.push(check);
            if(check==='MUNICIPAL COUNCIL' || check==='MUNICIPAL COMMITTEE'|| check==='MUNICIPAL CORPORATION'){
                Municipals.query({district:vm.tower_service.district,name:$scope.required.department},function(result) {
                    vm.municipals = result;
                    vm.searchQuery = null;
                });
                $('#tower_department2').modal('hide');
                $('#YourModalId').modal('show');
            }
        };

        vm.markRequiredForMunicipal = function (service,department,municipal) {
            if ($scope.requiredMunicipal.indexOf(municipal) < 0) {
                $scope.requiredMunicipal.push(municipal);
            }
            vm.updateTowerServiceNO(service);

        };

        vm.updateTowerServiceNO= function (id) {
            vm.towerserviceNO.projectdetailId = id;
            vm.towerserviceNO.district = vm.tower_service.district;
            vm.towerserviceNO.officerList = $scope.required.department;
            if($scope.requiredMunicipal.length !== 0) {
                for (var i = 0; i < $scope.requiredMunicipal.length; i++ ) {
                    if(vm.towerserviceNO.subname) {
                        vm.towerserviceNO.subname = vm.towerserviceNO.subname + "," + $scope.requiredMunicipal[i];
                    } else {
                        vm.towerserviceNO.subname = $scope.requiredMunicipal[i];
                    }
                }
            }
            // Projectservicedetail.get({id: vm.towerserviceNO.projectdetailId},function (data) {
            //     vm.projectServiceLog.projectid = $stateParams.projectid;
            //     vm.projectServiceLog.serviceid = data.serviceid;
            //     vm.projectServiceLog.comments = vm.towerserviceNO.subname;
            //     vm.projectServiceLog.actionTaken = vm.towerserviceNO.subname;
            //     Projectlogupdated.save(vm.projectServiceLog, function (data) {
            //         console.log(data);
            //     }, function (error) {
            //         console.log(error);
            //     });
            // });
            TowerserviceNO.save({id: '1'}, vm.towerserviceNO);
            vm.requiredMunicipal= [];
            location.reload();
            vm.towerserviceNO = {};
        };


        vm.statusSelected=function () {
          loadAll();
        };

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        };

        $scope.pageChangedHandler = function(num) {
            loadAll();
        };

        vm.closeModal = function () {
            $scope.required.department=[];
            $('#YourModalId').modal('hide');
            $('#tower_department2').modal('hide');
            vm.aboveMunicipal = null;
            $scope.requiredMunicipal = [];
        };

        vm.closeBelow = function () {
            $scope.required.department=[];
            $scope.requiredMunicipal = [];
            $scope.required.belowMunicipal =null;
            $('#belowGround').modal('hide');
            $('#tower_department3').modal('hide');
            vm.aboveMunicipal = null;
        };

        function isTowerServiceForClarification(serviceId) {

            return !!((serviceId === '5f8e0757-e88b-4ef1-bb15-00a9e984b9b1' || serviceId === '58d75fd4-f360-4931-a484-ff9be0adc12c' || serviceId === '741f0f60-cf69-4659-8b19-19d96ffe0103' || serviceId === 'fc1b1635-d3dc-4d30-a5fd-5abf6381594d' || serviceId === '6f81801c-59c6-4773-9f37-a5d81172a1bf'));

        }

    }
})();

(function () {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectAction', ProjectAction);

    ProjectAction.$inject = ['Projectservicedetail', 'ProjectServiceLogUpdated', 'ProjectServiceReportInfoForClearance', 'ProjectAttachemnt', 'FileManagement','CheckContentFile'];

    function ProjectAction(Projectservicedetail, ProjectServiceLogUpdated, ProjectServiceReportInfoForClearance, ProjectAttachemnt, FileManagement,CheckContentFile) {

        function performAction(project, attachment, comments, onsuccess, onerror, actiontaken, description,status, category, rejectionReason) {
            var projectServiceLog = {};
            var projectAttachment = {};
            var projectAttachmentResultObject = null;
            var projectServiceLogid = null;
            var projectService = Projectservicedetail.get({id: project.id}, function () {
                projectServiceLog.projectid = project.projectid;
                projectServiceLog.serviceid = project.serviceid;
                projectServiceLog.comments = comments;
                projectServiceLog.actionTaken = actiontaken;
                projectServiceLog.reasonCategory = category;
                projectServiceLog.rejectionReason = rejectionReason;
                ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                function onServiceLogSaveSuccess(result) {
                    projectServiceLogid = result.id;
                    projectService.latestComments = projectServiceLog.comments;
                    projectService.status = status;
                    if(actiontaken === 'Cleared'){
                       projectService.clearedDate = result.commentDate;
                       projectService.departmentLevel = false;
                       projectService.countTotalDays = 0;
                    }
                    if(actiontaken === 'Declined'){
                       projectService.rejectionDate = result.commentDate;
                        projectService.departmentLevel = false;
                        projectService.countTotalDays = 0;
                    }
                    Projectservicedetail.update(projectService, onUpdateProjectServiceReportInfoSuccess, onUpdateProjectServiceReportInfoError);
                }

                function onUpdateProjectServiceReportInfoSuccess(result) {
                    if (angular.isDefined(attachment.file)) {
                        saveProjectAttachment();
                    }
                    else {
                        onsuccess(result);
                    }
                }

                function onUpdateProjectServiceError() {
                    onerror();

                }

                function onServiceLogSaveError() {
                    onerror();
                }

                function saveProjectAttachment() {
                    var file = attachment.file;
                    projectAttachment.id = projectServiceLogid;
                    projectAttachment.fileName = file.name;
                    projectAttachment.description = description;
                    projectAttachment.fileExtension = file.type;
                    ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                }

                function onSaveProjectAttachmentSuccess(result) {
                    var filename = result.id;
                    var file = attachment.file;
                    FileManagement.saveFile(file, filename);
                    projectAttachmentResultObject = result;

                    var fileNameArray = attachment.file.name.split(".");
                    var fileextension = "";
                    if ((fileNameArray.length > 1)) {
                        fileextension = fileNameArray[(fileNameArray.length - 1)];
                    }
                    var inputFileName = result.id;
                    if (fileextension !== "") {
                        inputFileName = inputFileName + "." + fileextension;
                    }
                    projectAttachmentResultObject.serverFileName = inputFileName;

                    ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                }

                function onSaveProjectAttachmentError() {
                    onerror();
                }

                function onUpdateProjectAttachmentSuccess(result) {
                    onsuccess(result);
                }

                function onUpdateProjectServiceReportInfoError() {

                    onerror();
                }

                function onUpdateProjectAttachmentError() {
                    onerror();
                }
            });
        }

        return {
            clear: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Cleared';
                var status = 'Cleared';
                var description = 'Clearance Attachment';
                if(CheckContentFile.checkFile(attachment.file.name)){
                    performAction(project, attachment, comments, onsuccess, onerror, actiontaken, description,status);
                }
                else{
                    alert("Invalid File");
                }
            },
            assignFee: function (project, attachment, comments,assignFee, onsuccess, onerror) {
                if(angular.isDefined(attachment.file)){
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        assignedFees();
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else{
                    assignedFees();
                }

                function assignedFees() {

                    var projectServiceLog = {};
                    var projectAttachment = {};
                    var projectAttachmentResultObject = null;
                    var projectServiceLogid = null;
                    var projectService = Projectservicedetail.get({id: project.id}, function () {
                        projectServiceLog.projectid = project.projectid;
                        projectServiceLog.serviceid = project.serviceid;
                        projectServiceLog.comments = comments;
                        projectServiceLog.actionTaken = "Assigned Service Fee";
                        ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                        function onServiceLogSaveSuccess(result) {
                            projectServiceLogid = result.id;
                            projectService.latestComments = projectServiceLog.comments;
                            projectService.isAssigned=true;
                            projectService.serviceFee=assignFee;
                            Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                        }

                        function onUpdateProjectServiceSuccess(result) {
                            if (angular.isDefined(attachment.file)) {
                                saveProjectAttachment();
                            }
                            else {
                                onsuccess(result);
                            }
                        }

                        function onUpdateProjectServiceError() {

                        }

                        function onServiceLogSaveError() {
                        }

                        function saveProjectAttachment() {
                            var file = attachment.file;
                            projectAttachment.id = projectServiceLogid;
                            projectAttachment.fileName = file.name;
                            projectAttachment.description = "Service Assign Attachment";
                            projectAttachment.fileExtension = file.type;
                            ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentSuccess(result) {
                            var filename = result.id;
                            var file = attachment.file;
                            FileManagement.saveFile(file, filename);
                            projectAttachmentResultObject = result;

                            var fileNameArray = attachment.file.name.split(".");
                            var fileextension = "";
                            if ((fileNameArray.length > 1)) {
                                fileextension = fileNameArray[(fileNameArray.length - 1)];
                            }
                            var inputFileName = result.id;
                            if (fileextension !== "") {
                                inputFileName = inputFileName + "." + fileextension;
                            }
                            projectAttachmentResultObject.serverFileName = inputFileName;

                            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentError() {
                            onerror();
                        }

                        function onUpdateProjectAttachmentSuccess(result) {
                            onsuccess(result);
                        }

                        function onUpdateProjectServiceReportInfoError() {

                            onerror();
                        }

                        function onUpdateProjectAttachmentError() {
                            onerror();
                        }

                    });
                }
            },
            reject: function (project, attachment, comments, onsuccess, onerror, category, rejectionReason) {
                var actiontaken = 'Declined';
                var status = 'Declined';
                var description = 'Rejection Attachment';
                if(CheckContentFile.checkFile(attachment.file.name)){
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status, category, rejectionReason);
                }
                else {
                    alert("Invalid File");
                }
            },
            deactivate: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Rejected';
                var status = 'Rejected';
                var description = 'Rejection Attachment';
                if (angular.isDefined(attachment.file)) {
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else {
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }

            },
            reactivate: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Re-Activated';
                var status = 'Pending';
                var description = 'Reactivation Attachment';
                if (angular.isDefined(attachment.file)) {
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else {
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }
            },
            undoreject: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Undo-Rejected';
                var status = 'Pending';
                var description = 'Undo-Rejected Attachment';
                if (angular.isDefined(attachment.file)) {
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else {
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }
            },
            comment: function (project, attachment, comments, onsuccess, onerror) {
                if(angular.isDefined(attachment.file)){
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        commentAdded();
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else{
                    commentAdded();
                }

                function commentAdded() {
                    var projectServiceLog = {};
                    var projectAttachment = {};
                    var projectAttachmentResultObject = null;
                    var projectServiceLogid = null;
                    var projectService = Projectservicedetail.get({id: project.id}, function () {
                        projectServiceLog.projectid = project.projectid;
                        projectServiceLog.serviceid = project.serviceid;
                        projectServiceLog.comments = comments;
                        projectServiceLog.actionTaken = "OpenComment";
                        ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                        function onServiceLogSaveSuccess(result) {
                            projectServiceLogid = result.id;
                            projectService.latestComments = projectServiceLog.comments;
                            Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                        }

                        function onUpdateProjectServiceSuccess(result) {
                            if (angular.isDefined(attachment.file)) {
                                saveProjectAttachment();
                            }
                            else {
                                onsuccess(result);
                            }
                        }

                        function onUpdateProjectServiceError() {

                        }

                        function onServiceLogSaveError() {
                        }

                        function saveProjectAttachment() {
                            var file = attachment.file;
                            projectAttachment.id = projectServiceLogid;
                            projectAttachment.fileName = file.name;
                            projectAttachment.description = "Clearance Attachment";
                            projectAttachment.fileExtension = file.type;
                            ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentSuccess(result) {
                            var filename = result.id;
                            var file = attachment.file;
                            FileManagement.saveFile(file, filename);
                            projectAttachmentResultObject = result;

                            var fileNameArray = attachment.file.name.split(".");
                            var fileextension = "";
                            if ((fileNameArray.length > 1)) {
                                fileextension = fileNameArray[(fileNameArray.length - 1)];
                            }
                            var inputFileName = result.id;
                            if (fileextension !== "") {
                                inputFileName = inputFileName + "." + fileextension;
                            }
                            projectAttachmentResultObject.serverFileName = inputFileName;

                            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentError() {
                            onerror();
                        }

                        function onUpdateProjectAttachmentSuccess(result) {
                            onsuccess(result);
                        }

                        function onUpdateProjectServiceReportInfoError() {

                            onerror();
                        }

                        function onUpdateProjectAttachmentError() {
                            onerror();
                        }

                    });
                }

            },

            clarification: function (project, attachment, comments, role, onsuccess, onerror, category, rejectionReason) {
                if(angular.isDefined(attachment.file)){
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        commentAdded(role, category, rejectionReason);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else{
                    commentAdded(role, category, rejectionReason);
                }

                function commentAdded(role, category, rejectionReason) {
                    var projectServiceLog = {};
                    var projectAttachment = {};
                    var projectAttachmentResultObject = null;
                    var projectServiceLogid = null;
                    var projectService = Projectservicedetail.get({id: project.id}, function () {
                        projectServiceLog.projectid = project.projectid;
                        projectServiceLog.serviceid = project.serviceid;
                        projectServiceLog.comments = comments;
                        projectServiceLog.actionTaken = "Clarification";
                        projectServiceLog.reasonCategory = category;
                        projectServiceLog.rejectionReason = rejectionReason;
                        ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                        function onServiceLogSaveSuccess(result) {
                            projectServiceLogid = result.id;
                            projectService.latestComments = projectServiceLog.comments;
                            projectService.departmentLevel = false;
                            if (role==='TO'){
                                projectService.clarificationByTo = true;
                            }
                            if (role==='DC'){

                                projectService.clarificationByDc = true;
                            }
                            Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                        }

                        function onUpdateProjectServiceSuccess(result) {
                            if (angular.isDefined(attachment.file)) {
                                saveProjectAttachment();
                            }
                            else {
                                onsuccess(result);
                            }
                        }

                        function onUpdateProjectServiceError() {

                        }

                        function onServiceLogSaveError() {
                        }

                        function saveProjectAttachment() {
                            var file = attachment.file;
                            projectAttachment.id = projectServiceLogid;
                            projectAttachment.fileName = file.name;
                            projectAttachment.description = "Clearance Attachment";
                            projectAttachment.fileExtension = file.type;
                            ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentSuccess(result) {
                            var filename = result.id;
                            var file = attachment.file;
                            FileManagement.saveFile(file, filename);
                            projectAttachmentResultObject = result;

                            var fileNameArray = attachment.file.name.split(".");
                            var fileextension = "";
                            if ((fileNameArray.length > 1)) {
                                fileextension = fileNameArray[(fileNameArray.length - 1)];
                            }
                            var inputFileName = result.id;
                            if (fileextension !== "") {
                                inputFileName = inputFileName + "." + fileextension;
                            }
                            projectAttachmentResultObject.serverFileName = inputFileName;

                            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentError() {
                            onerror();
                        }

                        function onUpdateProjectAttachmentSuccess(result) {
                            onsuccess(result);
                        }

                        function onUpdateProjectServiceReportInfoError() {

                            onerror();
                        }

                        function onUpdateProjectAttachmentError() {
                            onerror();
                        }

                    });
                }

            },

            clarificationReply: function (project, attachment, comments, role, onsuccess, onerror) {
                if(angular.isDefined(attachment.file)){
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        commentAdded(role);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else{
                    commentAddedReply(role);
                }

                function commentAddedReply(role) {
                    var projectServiceLog = {};
                    var projectAttachment = {};
                    var projectAttachmentResultObject = null;
                    var projectServiceLogid = null;
                    var projectService = Projectservicedetail.get({id: project.id}, function () {
                        projectServiceLog.projectid = project.projectid;
                        projectServiceLog.serviceid = project.serviceid;
                        projectServiceLog.comments = comments;
                        projectServiceLog.actionTaken = "Clarification Reply";
                        ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                        function onServiceLogSaveSuccess(result) {
                            projectServiceLogid = result.id;
                            projectService.latestComments = projectServiceLog.comments;

                            projectService.clarificationByTo = false;
                            projectService.clarificationByDc = false;
                            projectService.departmentLevel = true;


                           Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                        }

                        function onUpdateProjectServiceSuccess(result) {
                            if (angular.isDefined(attachment.file)) {
                                saveProjectAttachment();
                            }
                            else {
                                onsuccess(result);
                            }
                        }

                        function onUpdateProjectServiceError() {

                        }

                        function onServiceLogSaveError() {
                        }

                        function saveProjectAttachment() {
                            var file = attachment.file;
                            projectAttachment.id = projectServiceLogid;
                            projectAttachment.fileName = file.name;
                            projectAttachment.description = "Clearance Attachment";
                            projectAttachment.fileExtension = file.type;
                            ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentSuccess(result) {
                            var filename = result.id;
                            var file = attachment.file;
                            FileManagement.saveFile(file, filename);
                            projectAttachmentResultObject = result;

                            var fileNameArray = attachment.file.name.split(".");
                            var fileextension = "";
                            if ((fileNameArray.length > 1)) {
                                fileextension = fileNameArray[(fileNameArray.length - 1)];
                            }
                            var inputFileName = result.id;
                            if (fileextension !== "") {
                                inputFileName = inputFileName + "." + fileextension;
                            }
                            projectAttachmentResultObject.serverFileName = inputFileName;

                            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentError() {
                            onerror();
                        }

                        function onUpdateProjectAttachmentSuccess(result) {
                            onsuccess(result);
                        }

                        function onUpdateProjectServiceReportInfoError() {

                            onerror();
                        }

                        function onUpdateProjectAttachmentError() {
                            onerror();
                        }

                    });
                }

            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomeProjectDialogController', HomeProjectDialogController);

    HomeProjectDialogController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','downloadserviceformattachment','GetServiceLog','ProjectAction','serviceFormFieldDataCollection','ServiceFormAttachments','HomeProjectServiceDetails','homeProjectService','projectService','projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServiceReportInfoForClearance'];

    function HomeProjectDialogController ($timeout, $scope, $stateParams, $uibModalInstance, downloadserviceformattachment, GetServiceLog, ProjectAction, serviceFormFieldDataCollection,ServiceFormAttachments, HomeProjectServiceDetails, homeProjectService,  projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail,ProjectServiceReportInfoForClearance) {
        var vm = this;
        vm.projects=[];

        vm.status=$stateParams.action;
        vm.addComment=addComment;
        vm.rejectService=rejectService;
        vm.downloadFile=downloadFile;
        $scope.file = {};
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService = projectService;
        vm.homeProjectService = homeProjectService;
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        $scope.file = {};
        vm.clear = clear;
        vm.clearService = clearService;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function clearService (){
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="Cleared";
            vm.projectServiceLog.comments="Cleared"
            if(angular.isDefined(vm.projectAttachemnt.file)){
                var fileNameArray = vm.projectAttachemnt.file.name.split(".");
                if ((fileNameArray.length == 2)) {
                    if(fileNameArray[0] != ""){
                        ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);

                    }
                    else {
                        alert("Invalid File Name");
                    }
                }
                else{
                    alert("Please select correct file format")
                }
            }
            else {
                ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);

            }
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="Cleared";
            vm.projectService.clearedDate=result.commentDate;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }

        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            vm.homeProjectService.status = "Cleared";
            vm.homeProjectService.lastComments = "Cleared";
            HomeProjectServiceDetails.update(vm.homeProjectService,function () {
                // vm.projects.splice(index, 1);
            });
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Clearance Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        loadProject();

        function loadProject() {
            vm.project=projectService;
            switch (vm.status){
                case 'service-logs':
                    viewlogs(vm.project);
                    break;
                case 'view-form':
                    loadFilledForm(vm.project);
                    break;
            }
        }

        function viewlogs(project) {
            vm.project=project;
            GetServiceLog.query({projectid:project.projectid,serviceid:project.serviceid},function (result) {
                vm.ServiceLog=result;
            });
        }

        function loadFilledForm(project) {
            vm.project=project;
            vm.serviceFormFieldData= serviceFormFieldDataCollection.query({serviceid:project.serviceid, projectid:project.projectid});
            vm.serviceformattachments=ServiceFormAttachments.query({id:"1",serviceid:project.serviceid, projectid:project.projectid});
        }

        function addComment() {
            ProjectAction.comment(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function rejectService() {
            ProjectAction.reject(vm.project,vm.projectAttachemnt,vm.comments,onRejectsuccess,onerror);
        }

        function onRejectsuccess(result) {
            vm.homeProjectService.status = "Rejected";
            vm.homeProjectService.lastComments = vm.projectServiceLog.comments;
            HomeProjectServiceDetails.update(vm.homeProjectService,function () {
                vm.projects.splice(index, 1);
            });
            $uibModalInstance.close();
        }

        function onsuccess(result) {
            $uibModalInstance.close();
        }

        function onerror() {

        }
        function downloadFile(serverfilename,downloadfilename)
        {
            downloadserviceformattachment.download(serverfilename,downloadfilename)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }

        vm.pdfconverter= function  () {
            console.log("called");
            var element = document.getElementById('pdf_data');
            html2pdf(element,{
                margin: 4
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('projects-home', {
            parent: 'app',
            url: '/projects-home',
            data: {
                authorities: ['ROLE_HOME_CTM','ROLE_ADMIN', 'ROLE_HOME_SUPERINTENDENT','ROLE_HOME_DC','ROLE_HOME_ASSISTANT']
            },
            views: {
                'content@': {
                    templateUrl: 'app/showprojects-home/projects_home.html',
                    controller: 'HomeProjectsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                projectAttachemnt: function () {
                    return {
                        fileName: null,
                        description: null,
                        fileExtension: null,
                        serverFileName: null,
                        id: null
                    };
                },
                projectServiceLog: function () {
                    return {
                        projectid: null,
                        serviceid: null,
                        comments: null,
                        commentDate: null,
                        commentByUserLogin: null,
                        actionTaken: null,
                        id: null
                    };
                },
                entity: function () {
                    return {
                        projectId: null,
                        serviceId: null,
                        cafPin: null,
                        district: null,
                        status: null,
                        serviceName: null,
                        businessEntity: null,
                        departmentName: null,
                        ageing: null,
                        lastComments: null,
                        lastActionDate: null,
                        id: null
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        })
            .state('action-home', {
                parent: 'projects-home',
                url: '/{action}/{projectserviceid}',
                data: {
                    authorities: ['ROLE_HOME_CTM','ROLE_ADMIN', 'ROLE_HOME_ASSISTANT', 'ROLE_HOME_SUPERINTENDENT','ROLE_HOME_DC']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/showprojects-home/projects-dialog_home.html',
                        controller: 'HomeProjectDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            projectAttachemnt: function () {
                                return {
                                    fileName: null,
                                    description: null,
                                    fileExtension: null,
                                    serverFileName: null,
                                    id: null
                                };
                            },
                            projectServiceLog: function () {
                                return {
                                    projectid: null,
                                    serviceid: null,
                                    comments: null,
                                    commentDate: null,
                                    commentByUserLogin: null,
                                    actionTaken: null,
                                    id: null
                                };
                            },
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                $translatePartialLoader.addPart('home');
                                return $translate.refresh();
                            }],
                            projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                            }],
                            homeProjectService: ['HomeProjectServiceDetails', function(HomeProjectServiceDetails) {
                                return HomeProjectServiceDetails.get({id : $stateParams.projectserviceid}).$promise;
                            }],

//                            projectservicereportinfo: ['ProjectServiceReportInfoForClearance', function(ProjectServiceReportInfoForClearance) {
//                                return ProjectServiceReportInfoForClearance.get({department:$stateParams.projectService.departmentName,projectid:$stateParams.projectService.projectid,service:$stateParams.projectService.serviceName});
//                            }]
                        }
                    }).result.then(function() {
                        $state.go('projects-home', null, { reload: 'projects-home' });
                    }, function() {
                        $state.go('projects-home');
                    });
                }]
            });

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('HomeProjects', HomeProjects);

    HomeProjects.$inject = ['$resource'];

    function HomeProjects ($resource) {
        var resourceUrl =  'api/get-projects-byStatus/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomeProjectsController', HomeProjectsController);

    HomeProjectsController.$inject = ['$scope', 'Principal','HomeProjects', 'Department', '$filter', 'HomeProjectServiceDetails', 'NewHomeProjectServiceDetails'];

    function HomeProjectsController($scope, Principal, HomeProjects, Department, $filter, HomeProjectServiceDetails, NewHomeProjectServiceDetails) {
        var vm = this;
        vm.projects = [];
        vm.status='Pending';
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                loadAll();
            });
        }

        function loadAll() {
            if(vm.account.authorities[0] === 'ROLE_HOME_CTM') {
                if (vm.status === 'Pending') {
                    HomeProjects.query({status:'Pending'},function (result) {
                        vm.projects = result;
                    });
                } else {
                    HomeProjects.query({status: 'Reverted to CTM'},function (result) {
                        vm.projects = result;
                    });
                }
            } else if (vm.account.authorities[0] === 'ROLE_HOME_SUPERINTENDENT') {
                if (vm.status === 'Pending') {
                    HomeProjects.query({status: 'Marked to Superintendent'},function (result) {
                        vm.projects = result;
                    });
                } else {
                    HomeProjects.query({status: 'Reverted to Superintendent'},function (result) {
                        vm.projects = result;
                    });
                }
            } else if (vm.account.authorities[0] === 'ROLE_HOME_ASSISTANT') {
                if (vm.status === 'Pending') {
                    HomeProjects.query({status: 'Marked to Assistant'},function (result) {
                        vm.projects = result;
                    });
                } else {
                    HomeProjects.query({status: 'Approved'},function (result) {
                        vm.projects = result;
                    });
                }
            } else if (vm.account.authorities[0] === 'ROLE_HOME_DC') {
                HomeProjects.query({status: 'Mark to DC'},function (result) {
                    vm.projects = result;
                });
            }
            // else if (vm.account.authorities[0] === 'ROLE_HOME_ASSISTANT') {
            //     HomeProjects.query({status: 'Approved'},function (result) {
            //         vm.projects = result;
            //     });
            // }
        }

        vm.mark = function(project, status, index) {
            project.status = status;
            project.lastComments = status;
            NewHomeProjectServiceDetails.update(project,function () {
                vm.projects.splice(index, 1);
            });
        };

        vm.statusSelected=function () {
            loadAll();
        };
    }
})();

(function () {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectActionHome', ProjectActionHome);

    ProjectActionHome.$inject = ['Projectservicedetail', 'ProjectServiceLogUpdated', 'ProjectServiceReportInfoForClearance', 'ProjectAttachemnt', 'FileManagement','CheckContentFile'];

    function ProjectActionHome(Projectservicedetail, ProjectServiceLogUpdated, ProjectServiceReportInfoForClearance, ProjectAttachemnt, FileManagement,CheckContentFile) {

        function performAction(project, attachment, comments, onsuccess, onerror, actiontaken, description,status) {
            var projectServiceLog = {};
            var projectAttachment = {};
            var projectAttachmentResultObject = null;
            var projectServiceLogid = null;
            var projectService = Projectservicedetail.get({id: project.id}, function () {
                projectServiceLog.projectid = project.projectid;
                projectServiceLog.serviceid = project.serviceid;
                projectServiceLog.comments = comments;
                projectServiceLog.actionTaken = actiontaken;
                ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                function onServiceLogSaveSuccess(result) {
                    projectServiceLogid = result.id;
                    projectService.latestComments = projectServiceLog.comments;
                    projectService.status = status;
                    Projectservicedetail.update(projectService, onUpdateProjectServiceReportInfoSuccess, onUpdateProjectServiceReportInfoError);
                }

                function onUpdateProjectServiceReportInfoSuccess(result) {
                    if (angular.isDefined(attachment.file)) {
                        saveProjectAttachment();
                    }
                    else {
                        onsuccess(result);
                    }
                }

                function onUpdateProjectServiceError() {
                    onerror();

                }

                function onServiceLogSaveError() {
                    onerror();
                }

                function saveProjectAttachment() {
                    var file = attachment.file;
                    projectAttachment.id = projectServiceLogid;
                    projectAttachment.fileName = file.name;
                    projectAttachment.description = description;
                    projectAttachment.fileExtension = file.type;
                    ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                }

                function onSaveProjectAttachmentSuccess(result) {
                    var filename = result.id;
                    var file = attachment.file;
                    FileManagement.saveFile(file, filename);
                    projectAttachmentResultObject = result;

                    var fileNameArray = attachment.file.name.split(".");
                    var fileextension = "";
                    if ((fileNameArray.length > 1)) {
                        fileextension = fileNameArray[(fileNameArray.length - 1)];
                    }
                    var inputFileName = result.id;
                    if (fileextension !== "") {
                        inputFileName = inputFileName + "." + fileextension;
                    }
                    projectAttachmentResultObject.serverFileName = inputFileName;

                    ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                }

                function onSaveProjectAttachmentError() {
                    onerror();
                }

                function onUpdateProjectAttachmentSuccess(result) {
                    onsuccess(result);
                }

                function onUpdateProjectServiceReportInfoError() {

                    onerror();
                }

                function onUpdateProjectAttachmentError() {
                    onerror();
                }
            });
        }

        return {
            clear: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Cleared';
                var status = 'Cleared';
                var description = 'Clearance Attachment';
                if(CheckContentFile.checkFile(attachment.file.name)){
                    performAction(project, attachment, comments, onsuccess, onerror, actiontaken, description,status);
                }
                else{
                    alert("Invalid File");
                }
            },
            assignFee: function (project, attachment, comments,assignFee, onsuccess, onerror) {
                if(angular.isDefined(attachment.file)){
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        assignedFees();
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else{
                    assignedFees();
                }

                function assignedFees() {

                    var projectServiceLog = {};
                    var projectAttachment = {};
                    var projectAttachmentResultObject = null;
                    var projectServiceLogid = null;
                    var projectService = Projectservicedetail.get({id: project.id}, function () {
                        projectServiceLog.projectid = project.projectid;
                        projectServiceLog.serviceid = project.serviceid;
                        projectServiceLog.comments = comments;
                        projectServiceLog.actionTaken = "Assigned Service Fee";
                        ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                        function onServiceLogSaveSuccess(result) {
                            projectServiceLogid = result.id;
                            projectService.latestComments = projectServiceLog.comments;
                            projectService.isAssigned=true;
                            projectService.serviceFee=assignFee;
                            Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                        }

                        function onUpdateProjectServiceSuccess(result) {
                            if (angular.isDefined(attachment.file)) {
                                saveProjectAttachment();
                            }
                            else {
                                onsuccess(result);
                            }
                        }

                        function onUpdateProjectServiceError() {

                        }

                        function onServiceLogSaveError() {
                        }

                        function saveProjectAttachment() {
                            var file = attachment.file;
                            projectAttachment.id = projectServiceLogid;
                            projectAttachment.fileName = file.name;
                            projectAttachment.description = "Service Assign Attachment";
                            projectAttachment.fileExtension = file.type;
                            ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentSuccess(result) {
                            var filename = result.id;
                            var file = attachment.file;
                            FileManagement.saveFile(file, filename);
                            projectAttachmentResultObject = result;

                            var fileNameArray = attachment.file.name.split(".");
                            var fileextension = "";
                            if ((fileNameArray.length > 1)) {
                                fileextension = fileNameArray[(fileNameArray.length - 1)];
                            }
                            var inputFileName = result.id;
                            if (fileextension !== "") {
                                inputFileName = inputFileName + "." + fileextension;
                            }
                            projectAttachmentResultObject.serverFileName = inputFileName;

                            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentError() {
                            onerror();
                        }

                        function onUpdateProjectAttachmentSuccess(result) {
                            onsuccess(result);
                        }

                        function onUpdateProjectServiceReportInfoError() {

                            onerror();
                        }

                        function onUpdateProjectAttachmentError() {
                            onerror();
                        }

                    });
                }
            },
            reject: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Declined';
                var status = 'Declined';
                var description = 'Rejection Attachment';
                if(CheckContentFile.checkFile(attachment.file.name)){
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }
                else {
                    alert("Invalid File");
                }
            },
            deactivate: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Rejected';
                var status = 'Rejected';
                var description = 'Rejection Attachment';
                if (angular.isDefined(attachment.file)) {
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else {
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }

            },
            reactivate: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Re-Activated';
                var status = 'Pending';
                var description = 'Reactivation Attachment';
                if (angular.isDefined(attachment.file)) {
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else {
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }
            },
            undoreject: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Undo-Rejected';
                var status = 'Pending';
                var description = 'Undo-Rejected Attachment';
                if (angular.isDefined(attachment.file)) {
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else {
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }
            },
            comment: function (project, attachment, comments, onsuccess, onerror) {
                if(angular.isDefined(attachment.file)){
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        commentAdded();
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else{
                    commentAdded();
                }

                function commentAdded() {
                    var projectServiceLog = {};
                    var projectAttachment = {};
                    var projectAttachmentResultObject = null;
                    var projectServiceLogid = null;
                    var projectService = Projectservicedetail.get({id: project.id}, function () {
                        projectServiceLog.projectid = project.projectid;
                        projectServiceLog.serviceid = project.serviceid;
                        projectServiceLog.comments = comments;
                        projectServiceLog.actionTaken = "OpenComment";
                        ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                        function onServiceLogSaveSuccess(result) {
                            projectServiceLogid = result.id;
                            projectService.latestComments = projectServiceLog.comments;
                            Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                        }

                        function onUpdateProjectServiceSuccess(result) {
                            if (angular.isDefined(attachment.file)) {
                                saveProjectAttachment();
                            }
                            else {
                                onsuccess(result);
                            }
                        }

                        function onUpdateProjectServiceError() {

                        }

                        function onServiceLogSaveError() {
                        }

                        function saveProjectAttachment() {
                            var file = attachment.file;
                            projectAttachment.id = projectServiceLogid;
                            projectAttachment.fileName = file.name;
                            projectAttachment.description = "Clearance Attachment";
                            projectAttachment.fileExtension = file.type;
                            ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentSuccess(result) {
                            var filename = result.id;
                            var file = attachment.file;
                            FileManagement.saveFile(file, filename);
                            projectAttachmentResultObject = result;

                            var fileNameArray = attachment.file.name.split(".");
                            var fileextension = "";
                            if ((fileNameArray.length > 1)) {
                                fileextension = fileNameArray[(fileNameArray.length - 1)];
                            }
                            var inputFileName = result.id;
                            if (fileextension !== "") {
                                inputFileName = inputFileName + "." + fileextension;
                            }
                            projectAttachmentResultObject.serverFileName = inputFileName;

                            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentError() {
                            onerror();
                        }

                        function onUpdateProjectAttachmentSuccess(result) {
                            onsuccess(result);
                        }

                        function onUpdateProjectServiceReportInfoError() {

                            onerror();
                        }

                        function onUpdateProjectAttachmentError() {
                            onerror();
                        }

                    });
                }

            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('deativatedCafs', {
            parent: 'app',
            url: '/deativatedCafs',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_STATE_NODAL_OFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/showcafs-stateNodalOfficer/showcafs-state-nodal-officer.html',
                    controller: 'ShowCafsStateNodalOfficer',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        })

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ShowCafsStateNodalOfficerService', ShowCafsStateNodalOfficerService);

    ShowCafsStateNodalOfficerService.$inject = ['$resource'];

    function ShowCafsStateNodalOfficerService ($resource) {
        var resourceUrl = 'api/getDeativatedCafs';
        var rejectUrl = 'api/rejectDeativatedCafs/:id';

        return {
            getDeactivatedCafs: $resource(resourceUrl, {}, {
                'query': { method: 'GET', isArray: true },
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                'update': { method: 'PUT' }
            }),
            rejectDeactivatedCaf: $resource(rejectUrl, { id: '@id' }, {
                'reject': {
                    method: 'GET',
                    transformResponse: function (data) {
                        // if (data) {
                        //     data = angular.fromJson(data);
                        // }
                        return data;
                    }
                }
            })  // New service method
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ShowCafsStateNodalOfficer', ShowCafsStateNodalOfficer);

    ShowCafsStateNodalOfficer.$inject = ['$scope', '$stateParams', 'TowerDcProjects', 'Department', '$filter', 'TowerserviceNO', 'Municipals', 'ShowCafsStateNodalOfficerService'];

    function ShowCafsStateNodalOfficer($scope, $stateParams, TowerDcProjects, Department, $filter, TowerserviceNO, Municipals, ShowCafsStateNodalOfficerService) {
        var vm = this;
        vm.projects = [];
        vm.status='Pending';
        vm.currentDepartment="All";
        vm.municipals = [];

        $scope.required={
            department: {},
            municipal:{}
        };
        $scope.requiredMunicipal = [];
        vm.towerserviceNO = {};

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";


        loadAll();

        function loadAll() {
            ShowCafsStateNodalOfficerService.getDeactivatedCafs.query(function (result) {
                vm.projects = result;
            });
        }


        vm.rejectCaf = function (cafId) {
            ShowCafsStateNodalOfficerService.rejectDeactivatedCaf.reject({ id: cafId }, function (response) {
                console.log("Application CAF rejected successfully:", response);
                alert("Applications related to this particular CAF rejected successfully");
               // loadAll(); // Reload the list after rejection
            }, function (response) {
               // console.error("Error rejecting CAF:", error);
                alert(response.message);
            });
        };




        vm.updateTowerServiceNO= function (id) {
            vm.towerserviceNO.projectdetailId = id;
            vm.towerserviceNO.district = vm.tower_service.district;
            vm.towerserviceNO.officerList = $scope.required.department;
            if($scope.requiredMunicipal.length !== 0) {
                for (var i = 0; i < $scope.requiredMunicipal.length; i++ ) {
                    if(vm.towerserviceNO.subname) {
                        vm.towerserviceNO.subname = vm.towerserviceNO.subname + "," + $scope.requiredMunicipal[i];
                    } else {
                        vm.towerserviceNO.subname = $scope.requiredMunicipal[i];
                    }
                }
            }
            // Projectservicedetail.get({id: vm.towerserviceNO.projectdetailId},function (data) {
            //     vm.projectServiceLog.projectid = $stateParams.projectid;
            //     vm.projectServiceLog.serviceid = data.serviceid;
            //     vm.projectServiceLog.comments = vm.towerserviceNO.subname;
            //     vm.projectServiceLog.actionTaken = vm.towerserviceNO.subname;
            //     Projectlogupdated.save(vm.projectServiceLog, function (data) {
            //         console.log(data);
            //     }, function (error) {
            //         console.log(error);
            //     });
            // });
            TowerserviceNO.save({id: '1'}, vm.towerserviceNO);
            vm.requiredMunicipal= [];
            location.reload();
            vm.towerserviceNO = {};
        };




    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('StateNodalOfficerProjectDialogController', StateNodalOfficerProjectDialogController);

    StateNodalOfficerProjectDialogController.$inject = ['$scope','$stateParams','GetServiceLog','serviceFormFieldDataCollection','ServiceFormAttachments','$uibModalInstance','downloadserviceformattachment','ProjectAction','projectService', 'ProjectServiceLogUpdated', 'Projectservicedetail', 'ProjectServiceReportInfoForClearance', 'ProjectAttachemnt', 'FileManagement','CheckContentFile','ProjectServicePaymentDetailsByProjectAndService', 'TowerRejectionReason', 'RejectedProjectServiceLog', 'ReasonCategory','TowerRejectionReasonByCategory'];

    function StateNodalOfficerProjectDialogController ($scope,$stateParams,GetServiceLog,serviceFormFieldDataCollection,ServiceFormAttachments,$uibModalInstance,downloadserviceformattachment,ProjectAction,projectService, ProjectServiceLogUpdated, Projectservicedetail, ProjectServiceReportInfoForClearance, ProjectAttachemnt, FileManagement,CheckContentFile ,ProjectServicePaymentDetailsByProjectAndService, TowerRejectionReason, RejectedProjectServiceLog, ReasonCategory, TowerRejectionReasonByCategory) {
        var vm = this;
        vm.projects=[];
        vm.downloadFile=downloadFile;
        vm.clearService=clearService;
        vm.addComment=addComment;
        vm.deactivateService=deactivateService;
        vm.rejectService=rejectService;
        vm.reactivate=reactivate;
        vm.undoreject=undoreject;
        vm.deemedClearService = deemedClearService;
        vm.addClarification=addClarification;

        vm.projectService = projectService;

        vm.status=$stateParams.action;
        vm.projectAttachemnt={};
        var projectServiceLogid=null;
        var projectAttachmentResultObject=null;
        vm.rejectedProjectServiceLog = {};
        vm.getReasons = getReasons;
        vm.getRejectionReason = getRejectionReason;
        vm.selectedCategory = {};
        vm.rejectionReason = "";

        $scope.file = {};

        vm.rejectionReasons = [];
        vm.reasonCategories = [];

        loadAll();

        function loadAll() {
            ReasonCategory.query(function(result) {
                vm.reasonCategories = result;
                vm.searchQuery = null;
            });
        }

        function getRejectionReason(category) {
            TowerRejectionReasonByCategory.query({category: category.category}, function(result) {
                vm.rejectionReasons = result;
                vm.searchQuery = null;
            });
        }

        function getReasons() {
            var reasons = [];
            angular.forEach(vm.selectedReason, function (value, key) {
                reasons.push(value.reason);
            }, reasons);
            var rejection = reasons.join();

            var code = [];
            angular.forEach(vm.selectedReason, function (value, key) {
                code.push(value.code);
            }, code);
            vm.rejectionReason = rejection;
            vm.rejectedProjectServiceLog.reasonCode = code;
        }


        loadProject();

        function loadProject() {
            vm.project=projectService;
           switch (vm.status){
               case 'service-logs':
                   viewlogs(vm.project);
                   break;
               case 'view-form':
                   loadFilledForm(vm.project);
                   break;
           }
        }


        vm.pdfconverter= function  () {
            console.log("called");
            var element = document.getElementById('pdf_data');
            html2pdf(element,{
                margin: 4
            });
        };

        function viewlogs(project) {
            vm.project=project;
            GetServiceLog.query({projectid:project.projectid,serviceid:project.serviceid},function (result) {
                vm.ServiceLog=result;
            });
        }

        function loadFilledForm(project) {
            vm.project=project;
            vm.serviceFormFieldData= serviceFormFieldDataCollection.query({serviceid:project.serviceid, projectid:project.projectid});
            vm.serviceformattachments=ServiceFormAttachments.query({id:"1",serviceid:project.serviceid, projectid:project.projectid});
        }

        loadAllPayments();

        function loadAllPayments() {
            vm.assignFeeDetail=ProjectServicePaymentDetailsByProjectAndService.query({projectid: vm.projectService.projectid,serviceid: vm.projectService.serviceid});
        }


        function clearService() {
            ProjectAction.clear(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function addComment() {
            ProjectAction.comment(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

         function addClarification(role) {
                    ProjectAction.clarification(vm.project,vm.projectAttachemnt,vm.comments, role, onsuccess,onerror,vm.selectedCategory.category, vm.rejectionReason);
                }

        function deactivateService() {
            ProjectAction.deactivate(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function rejectService() {
            ProjectAction.reject(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror, vm.selectedCategory.category, vm.rejectionReason);
        }

        function reactivate() {
            ProjectAction.reactivate(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function undoreject() {
            ProjectAction.undoreject(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function deemedClearService(){
                if(CheckContentFile.checkFile(vm.projectAttachemnt.file.name)){
                    vm.projectServiceLog.projectid = vm.projectService.projectid;
                    vm.projectServiceLog.serviceid=vm.projectService.serviceid;
                    vm.projectServiceLog.actionTaken="DeemedCleared";
                    ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
                }
                else{
                    alert("Invalid File");

            }
        }

        function onServiceLogSaveSuccess(result)
        {

            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="DeemedCleared";
            vm.projectService.deemedClearedDate = result.commentDate;
            vm.projectService.countTotalDays = 0;
            vm.projectService.departmentLevel = false;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }

        function onUpdateProjectServiceSuccess(result)
        {

            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({projectid:vm.projectService.projectid,department:vm.projectService.departmentName,service:vm.projectService.serviceName});
            vm.projectservicereportinfo.status='DeemedCleared';
            vm.projectservicereportinfo.projectid = result.projectid;
            vm.projectservicereportinfo.departmentname = result.departmentName;
            vm.projectservicereportinfo.servicename = result.serviceName;
            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
        }

        function onUpdateProjectServiceReportInfoSuccess(result)
        {

            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }

        function saveProjectAttachment()
        {

            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Deemed Clearance Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }

        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }

            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }

        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }

        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }

        function onUpdateProjectServiceReportInfoError()
        {
            vm.isSaving = false;
        }

        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function downloadFile(serverfilename,downloadfilename)
        {
            downloadserviceformattachment.download(serverfilename,downloadfilename)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }

        vm.clear=function () {
            $uibModalInstance.close();
        };

        function onsuccess(result) {
            console.log(result);
            vm.rejectedProjectServiceLog.projectServiceLogId = result.id;
            RejectedProjectServiceLog.save(vm.rejectedProjectServiceLog);
            $uibModalInstance.close();
        }

        function onerror() {

        }
    }
})();

(function () {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectAction', ProjectAction);

    ProjectAction.$inject = ['Projectservicedetail', 'ProjectServiceLogUpdated', 'ProjectServiceReportInfoForClearance', 'ProjectAttachemnt', 'FileManagement','CheckContentFile'];

    function ProjectAction(Projectservicedetail, ProjectServiceLogUpdated, ProjectServiceReportInfoForClearance, ProjectAttachemnt, FileManagement,CheckContentFile) {

        function performAction(project, attachment, comments, onsuccess, onerror, actiontaken, description,status, category, rejectionReason) {
            var projectServiceLog = {};
            var projectAttachment = {};
            var projectAttachmentResultObject = null;
            var projectServiceLogid = null;
            var projectService = Projectservicedetail.get({id: project.id}, function () {
                projectServiceLog.projectid = project.projectid;
                projectServiceLog.serviceid = project.serviceid;
                projectServiceLog.comments = comments;
                projectServiceLog.actionTaken = actiontaken;
                projectServiceLog.reasonCategory = category;
                projectServiceLog.rejectionReason = rejectionReason;
                ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                function onServiceLogSaveSuccess(result) {
                    projectServiceLogid = result.id;
                    projectService.latestComments = projectServiceLog.comments;
                    projectService.status = status;
                    if(actiontaken === 'Cleared'){
                       projectService.clearedDate = result.commentDate;
                       projectService.departmentLevel = false;
                       projectService.countTotalDays = 0;
                    }
                    if(actiontaken === 'Declined'){
                       projectService.rejectionDate = result.commentDate;
                        projectService.departmentLevel = false;
                        projectService.countTotalDays = 0;
                    }
                    Projectservicedetail.update(projectService, onUpdateProjectServiceReportInfoSuccess, onUpdateProjectServiceReportInfoError);
                }

                function onUpdateProjectServiceReportInfoSuccess(result) {
                    if (angular.isDefined(attachment.file)) {
                        saveProjectAttachment();
                    }
                    else {
                        onsuccess(result);
                    }
                }

                function onUpdateProjectServiceError() {
                    onerror();

                }

                function onServiceLogSaveError() {
                    onerror();
                }

                function saveProjectAttachment() {
                    var file = attachment.file;
                    projectAttachment.id = projectServiceLogid;
                    projectAttachment.fileName = file.name;
                    projectAttachment.description = description;
                    projectAttachment.fileExtension = file.type;
                    ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                }

                function onSaveProjectAttachmentSuccess(result) {
                    var filename = result.id;
                    var file = attachment.file;
                    FileManagement.saveFile(file, filename);
                    projectAttachmentResultObject = result;

                    var fileNameArray = attachment.file.name.split(".");
                    var fileextension = "";
                    if ((fileNameArray.length > 1)) {
                        fileextension = fileNameArray[(fileNameArray.length - 1)];
                    }
                    var inputFileName = result.id;
                    if (fileextension !== "") {
                        inputFileName = inputFileName + "." + fileextension;
                    }
                    projectAttachmentResultObject.serverFileName = inputFileName;

                    ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                }

                function onSaveProjectAttachmentError() {
                    onerror();
                }

                function onUpdateProjectAttachmentSuccess(result) {
                    onsuccess(result);
                }

                function onUpdateProjectServiceReportInfoError() {

                    onerror();
                }

                function onUpdateProjectAttachmentError() {
                    onerror();
                }
            });
        }

        return {
            clear: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Cleared';
                var status = 'Cleared';
                var description = 'Clearance Attachment';
                if(CheckContentFile.checkFile(attachment.file.name)){
                    performAction(project, attachment, comments, onsuccess, onerror, actiontaken, description,status);
                }
                else{
                    alert("Invalid File");
                }
            },
            assignFee: function (project, attachment, comments,assignFee, onsuccess, onerror) {
                if(angular.isDefined(attachment.file)){
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        assignedFees();
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else{
                    assignedFees();
                }

                function assignedFees() {

                    var projectServiceLog = {};
                    var projectAttachment = {};
                    var projectAttachmentResultObject = null;
                    var projectServiceLogid = null;
                    var projectService = Projectservicedetail.get({id: project.id}, function () {
                        projectServiceLog.projectid = project.projectid;
                        projectServiceLog.serviceid = project.serviceid;
                        projectServiceLog.comments = comments;
                        projectServiceLog.actionTaken = "Assigned Service Fee";
                        ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                        function onServiceLogSaveSuccess(result) {
                            projectServiceLogid = result.id;
                            projectService.latestComments = projectServiceLog.comments;
                            projectService.isAssigned=true;
                            projectService.serviceFee=assignFee;
                            Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                        }

                        function onUpdateProjectServiceSuccess(result) {
                            if (angular.isDefined(attachment.file)) {
                                saveProjectAttachment();
                            }
                            else {
                                onsuccess(result);
                            }
                        }

                        function onUpdateProjectServiceError() {

                        }

                        function onServiceLogSaveError() {
                        }

                        function saveProjectAttachment() {
                            var file = attachment.file;
                            projectAttachment.id = projectServiceLogid;
                            projectAttachment.fileName = file.name;
                            projectAttachment.description = "Service Assign Attachment";
                            projectAttachment.fileExtension = file.type;
                            ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentSuccess(result) {
                            var filename = result.id;
                            var file = attachment.file;
                            FileManagement.saveFile(file, filename);
                            projectAttachmentResultObject = result;

                            var fileNameArray = attachment.file.name.split(".");
                            var fileextension = "";
                            if ((fileNameArray.length > 1)) {
                                fileextension = fileNameArray[(fileNameArray.length - 1)];
                            }
                            var inputFileName = result.id;
                            if (fileextension !== "") {
                                inputFileName = inputFileName + "." + fileextension;
                            }
                            projectAttachmentResultObject.serverFileName = inputFileName;

                            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentError() {
                            onerror();
                        }

                        function onUpdateProjectAttachmentSuccess(result) {
                            onsuccess(result);
                        }

                        function onUpdateProjectServiceReportInfoError() {

                            onerror();
                        }

                        function onUpdateProjectAttachmentError() {
                            onerror();
                        }

                    });
                }
            },
            reject: function (project, attachment, comments, onsuccess, onerror, category, rejectionReason) {
                var actiontaken = 'Declined';
                var status = 'Declined';
                var description = 'Rejection Attachment';
                if(CheckContentFile.checkFile(attachment.file.name)){
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status, category, rejectionReason);
                }
                else {
                    alert("Invalid File");
                }
            },
            deactivate: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Rejected';
                var status = 'Rejected';
                var description = 'Rejection Attachment';
                if (angular.isDefined(attachment.file)) {
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else {
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }

            },
            reactivate: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Re-Activated';
                var status = 'Pending';
                var description = 'Reactivation Attachment';
                if (angular.isDefined(attachment.file)) {
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else {
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }
            },
            undoreject: function (project, attachment, comments, onsuccess, onerror) {
                var actiontaken = 'Undo-Rejected';
                var status = 'Pending';
                var description = 'Undo-Rejected Attachment';
                if (angular.isDefined(attachment.file)) {
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else {
                    performAction(project, attachment, comments, onsuccess, onerror,actiontaken,description,status);
                }
            },
            comment: function (project, attachment, comments, onsuccess, onerror) {
                if(angular.isDefined(attachment.file)){
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        commentAdded();
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else{
                    commentAdded();
                }

                function commentAdded() {
                    var projectServiceLog = {};
                    var projectAttachment = {};
                    var projectAttachmentResultObject = null;
                    var projectServiceLogid = null;
                    var projectService = Projectservicedetail.get({id: project.id}, function () {
                        projectServiceLog.projectid = project.projectid;
                        projectServiceLog.serviceid = project.serviceid;
                        projectServiceLog.comments = comments;
                        projectServiceLog.actionTaken = "OpenComment";
                        ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                        function onServiceLogSaveSuccess(result) {
                            projectServiceLogid = result.id;
                            projectService.latestComments = projectServiceLog.comments;
                            Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                        }

                        function onUpdateProjectServiceSuccess(result) {
                            if (angular.isDefined(attachment.file)) {
                                saveProjectAttachment();
                            }
                            else {
                                onsuccess(result);
                            }
                        }

                        function onUpdateProjectServiceError() {

                        }

                        function onServiceLogSaveError() {
                        }

                        function saveProjectAttachment() {
                            var file = attachment.file;
                            projectAttachment.id = projectServiceLogid;
                            projectAttachment.fileName = file.name;
                            projectAttachment.description = "Clearance Attachment";
                            projectAttachment.fileExtension = file.type;
                            ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentSuccess(result) {
                            var filename = result.id;
                            var file = attachment.file;
                            FileManagement.saveFile(file, filename);
                            projectAttachmentResultObject = result;

                            var fileNameArray = attachment.file.name.split(".");
                            var fileextension = "";
                            if ((fileNameArray.length > 1)) {
                                fileextension = fileNameArray[(fileNameArray.length - 1)];
                            }
                            var inputFileName = result.id;
                            if (fileextension !== "") {
                                inputFileName = inputFileName + "." + fileextension;
                            }
                            projectAttachmentResultObject.serverFileName = inputFileName;

                            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentError() {
                            onerror();
                        }

                        function onUpdateProjectAttachmentSuccess(result) {
                            onsuccess(result);
                        }

                        function onUpdateProjectServiceReportInfoError() {

                            onerror();
                        }

                        function onUpdateProjectAttachmentError() {
                            onerror();
                        }

                    });
                }

            },

            clarification: function (project, attachment, comments, role, onsuccess, onerror, category, rejectionReason) {
                if(angular.isDefined(attachment.file)){
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        commentAdded(role, category, rejectionReason);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else{
                    commentAdded(role, category, rejectionReason);
                }

                function commentAdded(role, category, rejectionReason) {
                    var projectServiceLog = {};
                    var projectAttachment = {};
                    var projectAttachmentResultObject = null;
                    var projectServiceLogid = null;
                    var projectService = Projectservicedetail.get({id: project.id}, function () {
                        projectServiceLog.projectid = project.projectid;
                        projectServiceLog.serviceid = project.serviceid;
                        projectServiceLog.comments = comments;
                        projectServiceLog.actionTaken = "Clarification";
                        projectServiceLog.reasonCategory = category;
                        projectServiceLog.rejectionReason = rejectionReason;
                        ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                        function onServiceLogSaveSuccess(result) {
                            projectServiceLogid = result.id;
                            projectService.latestComments = projectServiceLog.comments;
                            projectService.departmentLevel = false;
                            if (role==='TO'){
                                projectService.clarificationByTo = true;
                            }
                            if (role==='DC'){

                                projectService.clarificationByDc = true;
                            }
                            Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                        }

                        function onUpdateProjectServiceSuccess(result) {
                            if (angular.isDefined(attachment.file)) {
                                saveProjectAttachment();
                            }
                            else {
                                onsuccess(result);
                            }
                        }

                        function onUpdateProjectServiceError() {

                        }

                        function onServiceLogSaveError() {
                        }

                        function saveProjectAttachment() {
                            var file = attachment.file;
                            projectAttachment.id = projectServiceLogid;
                            projectAttachment.fileName = file.name;
                            projectAttachment.description = "Clearance Attachment";
                            projectAttachment.fileExtension = file.type;
                            ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentSuccess(result) {
                            var filename = result.id;
                            var file = attachment.file;
                            FileManagement.saveFile(file, filename);
                            projectAttachmentResultObject = result;

                            var fileNameArray = attachment.file.name.split(".");
                            var fileextension = "";
                            if ((fileNameArray.length > 1)) {
                                fileextension = fileNameArray[(fileNameArray.length - 1)];
                            }
                            var inputFileName = result.id;
                            if (fileextension !== "") {
                                inputFileName = inputFileName + "." + fileextension;
                            }
                            projectAttachmentResultObject.serverFileName = inputFileName;

                            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentError() {
                            onerror();
                        }

                        function onUpdateProjectAttachmentSuccess(result) {
                            onsuccess(result);
                        }

                        function onUpdateProjectServiceReportInfoError() {

                            onerror();
                        }

                        function onUpdateProjectAttachmentError() {
                            onerror();
                        }

                    });
                }

            },

            clarificationReply: function (project, attachment, comments, role, onsuccess, onerror) {
                if(angular.isDefined(attachment.file)){
                    if(CheckContentFile.checkFile(attachment.file.name)){
                        commentAdded(role);
                    }
                    else{
                        alert("Invalid File");
                    }
                }
                else{
                    commentAddedReply(role);
                }

                function commentAddedReply(role) {
                    var projectServiceLog = {};
                    var projectAttachment = {};
                    var projectAttachmentResultObject = null;
                    var projectServiceLogid = null;
                    var projectService = Projectservicedetail.get({id: project.id}, function () {
                        projectServiceLog.projectid = project.projectid;
                        projectServiceLog.serviceid = project.serviceid;
                        projectServiceLog.comments = comments;
                        projectServiceLog.actionTaken = "Clarification Reply";
                        ProjectServiceLogUpdated.save(projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                        function onServiceLogSaveSuccess(result) {
                            projectServiceLogid = result.id;
                            projectService.latestComments = projectServiceLog.comments;

                            projectService.clarificationByTo = false;
                            projectService.clarificationByDc = false;
                            projectService.departmentLevel = true;


                           Projectservicedetail.update(projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
                        }

                        function onUpdateProjectServiceSuccess(result) {
                            if (angular.isDefined(attachment.file)) {
                                saveProjectAttachment();
                            }
                            else {
                                onsuccess(result);
                            }
                        }

                        function onUpdateProjectServiceError() {

                        }

                        function onServiceLogSaveError() {
                        }

                        function saveProjectAttachment() {
                            var file = attachment.file;
                            projectAttachment.id = projectServiceLogid;
                            projectAttachment.fileName = file.name;
                            projectAttachment.description = "Clearance Attachment";
                            projectAttachment.fileExtension = file.type;
                            ProjectAttachemnt.update(projectAttachment, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentSuccess(result) {
                            var filename = result.id;
                            var file = attachment.file;
                            FileManagement.saveFile(file, filename);
                            projectAttachmentResultObject = result;

                            var fileNameArray = attachment.file.name.split(".");
                            var fileextension = "";
                            if ((fileNameArray.length > 1)) {
                                fileextension = fileNameArray[(fileNameArray.length - 1)];
                            }
                            var inputFileName = result.id;
                            if (fileextension !== "") {
                                inputFileName = inputFileName + "." + fileextension;
                            }
                            projectAttachmentResultObject.serverFileName = inputFileName;

                            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
                        }

                        function onSaveProjectAttachmentError() {
                            onerror();
                        }

                        function onUpdateProjectAttachmentSuccess(result) {
                            onsuccess(result);
                        }

                        function onUpdateProjectServiceReportInfoError() {

                            onerror();
                        }

                        function onUpdateProjectAttachmentError() {
                            onerror();
                        }

                    });
                }

            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('UserByRole', UserByRole);

    UserByRole.$inject = ['$resource'];

    function UserByRole ($resource) {
        var service = $resource('api/users/hasrole/:role', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });
        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('UserById', UserById);

    UserById.$inject = ['$resource'];

    function UserById ($resource) {
            var resourceUrl =  '/api/users/userbyid/:id';


            return $resource(resourceUrl, {}, {
                'query': { method: 'GET', isArray: true},
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        if (data) {
                            data = angular.fromJson(data);
                        }
                        return data;
                    }
                },
                'update': { method:'PUT' }
            });
        }
    })();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectlogupdated', Projectlogupdated);

    Projectlogupdated.$inject = ['$resource', 'DateUtils'];

    function Projectlogupdated ($resource, DateUtils) {
        var resourceUrl =  'api/projectlogsupdated/:projectid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.actiontakendate = DateUtils.convertDateTimeFromServer(data.actiontakendate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectdetailupdated', Projectdetailupdated);

    Projectdetailupdated.$inject = ['$resource', 'DateUtils'];

    function Projectdetailupdated ($resource, DateUtils) {
        var resourceUrl =  'api/projectdetailsupdated/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                        data.deactivateddate = DateUtils.convertDateTimeFromServer(data.deactivateddate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectServiceLogUpdated', ProjectServiceLogUpdated);

    ProjectServiceLogUpdated.$inject = ['$resource', 'DateUtils'];

    function ProjectServiceLogUpdated ($resource, DateUtils) {
        var resourceUrl =  'api/project-service-logs-updated/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.commentDate = DateUtils.convertDateTimeFromServer(data.commentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();


(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('NotificationUpdated', NotificationUpdated);

    NotificationUpdated.$inject = ['$resource', 'DateUtils'];

    function NotificationUpdated ($resource, DateUtils) {
        var resourceUrl =  'api/notificationsupdated/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.latestactiondate = DateUtils.convertDateTimeFromServer(data.latestactiondate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ReplaceRm', ReplaceRm);

    ReplaceRm.$inject = ['$resource'];

    function ReplaceRm ($resource) {
        var resourceUrl =  'api/replaceRm/:rmOld/:rmNew';
            return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    var data1 = {"value": data}
                    return data1;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('CheckRm', CheckRm);

    CheckRm.$inject = ['$resource'];

    function CheckRm ($resource) {
        var resourceUrl =  'api/rmlistCheck/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                      data = angular.fromJson(data);
                    }
                    var data1 = {"value": data}
                    return data1;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Payment', Payment);

    Payment.$inject = ['$resource'];

    function Payment ($resource) {
        var resourceUrl =  'api/PaymentParameters/:id/:projectid/:amount/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('FeePayment', FeePayment);

    FeePayment.$inject = ['$resource'];

    function FeePayment ($resource) {
        var resourceUrl =  'api/PaymentParam/:id/:projectid/:amount/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
//    var moduleName = 'angularUtils.directives.dirPagination';
        var DEFAULT_ID = '__default';

    angular
        .module('investhryApp')
        .directive('dirPaginate', ['$compile', '$parse', 'paginationService', dirPaginateDirective])
        .directive('dirPaginateNoCompile', noCompileDirective)
        .directive('dirPaginationControls', ['paginationService', 'paginationTemplate', dirPaginationControlsDirective])
        .filter('itemsPerPage', ['paginationService', itemsPerPageFilter])
        .service('paginationService', paginationService)
        .provider('paginationTemplate', paginationTemplateProvider)
        .run(['$templateCache',dirPaginationControlsTemplateInstaller]);

//    pageRibbon.$inject = ['ProfileService', '$rootScope'];

    function dirPaginateDirective($compile, $parse, paginationService) {

        return  {
            terminal: true,
            multiElement: true,
            priority: 100,
            compile: dirPaginationCompileFn
        };

        function dirPaginationCompileFn(tElement, tAttrs){

            var expression = tAttrs.dirPaginate;
            // regex taken directly from https://github.com/angular/angular.js/blob/v1.4.x/src/ng/directive/ngRepeat.js#L339
            var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);

            var filterPattern = /\|\s*itemsPerPage\s*:\s*(.*\(\s*\w*\)|([^\)]*?(?=\s+as\s+))|[^\)]*)/;
            if (match[2].match(filterPattern) === null) {
                throw 'pagination directive: the \'itemsPerPage\' filter must be set.';
            }
            var itemsPerPageFilterRemoved = match[2].replace(filterPattern, '');
            var collectionGetter = $parse(itemsPerPageFilterRemoved);

            addNoCompileAttributes(tElement);

            // If any value is specified for paginationId, we register the un-evaluated expression at this stage for the benefit of any
            // dir-pagination-controls directives that may be looking for this ID.
            var rawId = tAttrs.paginationId || DEFAULT_ID;
            paginationService.registerInstance(rawId);

            return function dirPaginationLinkFn(scope, element, attrs){

                // Now that we have access to the `scope` we can interpolate any expression given in the paginationId attribute and
                // potentially register a new ID if it evaluates to a different value than the rawId.
                var paginationId = $parse(attrs.paginationId)(scope) || attrs.paginationId || DEFAULT_ID;
                // In case rawId != paginationId we deregister using rawId for the sake of general cleanliness
                // before registering using paginationId
                paginationService.deregisterInstance(rawId);
                paginationService.registerInstance(paginationId);

                var repeatExpression = getRepeatExpression(expression, paginationId);
                addNgRepeatToElement(element, attrs, repeatExpression);

                removeTemporaryAttributes(element);
                var compiled =  $compile(element);

                var currentPageGetter = makeCurrentPageGetterFn(scope, attrs, paginationId);
                paginationService.setCurrentPageParser(paginationId, currentPageGetter, scope);

                if (typeof attrs.totalItems !== 'undefined') {
                    paginationService.setAsyncModeTrue(paginationId);
                    scope.$watch(function() {
                        return $parse(attrs.totalItems)(scope);
                    }, function (result) {
                        if (0 <= result) {
                            paginationService.setCollectionLength(paginationId, result);
                        }
                    });
                } else {
                    paginationService.setAsyncModeFalse(paginationId);
                    scope.$watchCollection(function() {
                        return collectionGetter(scope);
                    }, function(collection) {
                        if (collection) {
                            var collectionLength = (collection instanceof Array) ? collection.length : Object.keys(collection).length;
                            paginationService.setCollectionLength(paginationId, collectionLength);
                        }
                    });
                }

                // Delegate to the link function returned by the new compilation of the ng-repeat
                compiled(scope);

                // When the scope is destroyed, we make sure to remove the reference to it in paginationService
                // so that it can be properly garbage collected
                scope.$on('$destroy', function destroyDirPagination() {
                    paginationService.deregisterInstance(paginationId);
                });
            };
        }

        /**
         * If a pagination id has been specified, we need to check that it is present as the second argument passed to
         * the itemsPerPage filter. If it is not there, we add it and return the modified expression.
         *
         * @param expression
         * @param paginationId
         * @returns {*}
         */
        function getRepeatExpression(expression, paginationId) {
            var repeatExpression,
                idDefinedInFilter = !!expression.match(/(\|\s*itemsPerPage\s*:[^|]*:[^|]*)/);

            if (paginationId !== DEFAULT_ID && !idDefinedInFilter) {
                repeatExpression = expression.replace(/(\|\s*itemsPerPage\s*:\s*[^|\s]*)/, "$1 : '" + paginationId + "'");
            } else {
                repeatExpression = expression;
            }

            return repeatExpression;
        }

        /**
         * Adds the ng-repeat directive to the element. In the case of multi-element (-start, -end) it adds the
         * appropriate multi-element ng-repeat to the first and last element in the range.
         * @param element
         * @param attrs
         * @param repeatExpression
         */
        function addNgRepeatToElement(element, attrs, repeatExpression) {
            if (element[0].hasAttribute('dir-paginate-start') || element[0].hasAttribute('data-dir-paginate-start')) {
                // using multiElement mode (dir-paginate-start, dir-paginate-end)
                attrs.$set('ngRepeatStart', repeatExpression);
                element.eq(element.length - 1).attr('ng-repeat-end', true);
            } else {
                attrs.$set('ngRepeat', repeatExpression);
            }
        }

        /**
         * Adds the dir-paginate-no-compile directive to each element in the tElement range.
         * @param tElement
         */
        function addNoCompileAttributes(tElement) {
            angular.forEach(tElement, function(el) {
                if (el.nodeType === 1) {
                    angular.element(el).attr('dir-paginate-no-compile', true);
                }
            });
        }

        /**
         * Removes the variations on dir-paginate (data-, -start, -end) and the dir-paginate-no-compile directives.
         * @param element
         */
        function removeTemporaryAttributes(element) {
            angular.forEach(element, function(el) {
                if (el.nodeType === 1) {
                    angular.element(el).removeAttr('dir-paginate-no-compile');
                }
            });
            element.eq(0).removeAttr('dir-paginate-start').removeAttr('dir-paginate').removeAttr('data-dir-paginate-start').removeAttr('data-dir-paginate');
            element.eq(element.length - 1).removeAttr('dir-paginate-end').removeAttr('data-dir-paginate-end');
        }

        /**
         * Creates a getter function for the current-page attribute, using the expression provided or a default value if
         * no current-page expression was specified.
         *
         * @param scope
         * @param attrs
         * @param paginationId
         * @returns {*}
         */
        function makeCurrentPageGetterFn(scope, attrs, paginationId) {
            var currentPageGetter;
            if (attrs.currentPage) {
                currentPageGetter = $parse(attrs.currentPage);
            } else {
                // If the current-page attribute was not set, we'll make our own.
                // Replace any non-alphanumeric characters which might confuse
                // the $parse service and give unexpected results.
                // See https://github.com/michaelbromley/angularUtils/issues/233
                var defaultCurrentPage = (paginationId + '__currentPage').replace(/\W/g, '_');
                scope[defaultCurrentPage] = 1;
                currentPageGetter = $parse(defaultCurrentPage);
            }
            return currentPageGetter;
        }
    }

    /**
     * This is a helper directive that allows correct compilation when in multi-element mode (ie dir-paginate-start, dir-paginate-end).
     * It is dynamically added to all elements in the dir-paginate compile function, and it prevents further compilation of
     * any inner directives. It is then removed in the link function, and all inner directives are then manually compiled.
     */
    function noCompileDirective() {
        return {
            priority: 5000,
            terminal: true
        };
    }

    function dirPaginationControlsTemplateInstaller($templateCache) {
        $templateCache.put('angularUtils.directives.dirPagination.template', '<ul class="pagination" ng-if="1 < pages.length || !autoHide"><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(1)">&laquo;</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a></li><li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' || ( ! autoHide && pages.length === 1 ) }"><a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a></li><li ng-if="boundaryLinks"  ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)">&raquo;</a></li></ul>');
    }

    function dirPaginationControlsDirective(paginationService, paginationTemplate) {

        var numberRegex = /^\d+$/;

        var DDO = {
            restrict: 'AE',
            scope: {
                maxSize: '=?',
                onPageChange: '&?',
                paginationId: '=?',
                autoHide: '=?'
            },
            link: dirPaginationControlsLinkFn
        };

        // We need to check the paginationTemplate service to see whether a template path or
        // string has been specified, and add the `template` or `templateUrl` property to
        // the DDO as appropriate. The order of priority to decide which template to use is
        // (highest priority first):
        // 1. paginationTemplate.getString()
        // 2. attrs.templateUrl
        // 3. paginationTemplate.getPath()
        var templateString = paginationTemplate.getString();
        if (templateString !== undefined) {
            DDO.template = templateString;
        } else {
            DDO.templateUrl = function(elem, attrs) {
                return attrs.templateUrl || paginationTemplate.getPath();
            };
        }
        return DDO;

        function dirPaginationControlsLinkFn(scope, element, attrs) {

            // rawId is the un-interpolated value of the pagination-id attribute. This is only important when the corresponding dir-paginate directive has
            // not yet been linked (e.g. if it is inside an ng-if block), and in that case it prevents this controls directive from assuming that there is
            // no corresponding dir-paginate directive and wrongly throwing an exception.
            var rawId = attrs.paginationId ||  DEFAULT_ID;
            var paginationId = scope.paginationId || attrs.paginationId ||  DEFAULT_ID;

            if (!paginationService.isRegistered(paginationId) && !paginationService.isRegistered(rawId)) {
                var idMessage = (paginationId !== DEFAULT_ID) ? ' (id: ' + paginationId + ') ' : ' ';
                if (window.console) {
                    console.warn('Pagination directive: the pagination controls' + idMessage + 'cannot be used without the corresponding pagination directive, which was not found at link time.');
                }
            }

            if (!scope.maxSize) { scope.maxSize = 9; }
            scope.autoHide = scope.autoHide === undefined ? true : scope.autoHide;
            scope.directionLinks = angular.isDefined(attrs.directionLinks) ? scope.$parent.$eval(attrs.directionLinks) : true;
            scope.boundaryLinks = angular.isDefined(attrs.boundaryLinks) ? scope.$parent.$eval(attrs.boundaryLinks) : false;

            var paginationRange = Math.max(scope.maxSize, 5);
            scope.pages = [];
            scope.pagination = {
                last: 1,
                current: 1
            };
            scope.range = {
                lower: 1,
                upper: 1,
                total: 1
            };

            scope.$watch('maxSize', function(val) {
                if (val) {
                    paginationRange = Math.max(scope.maxSize, 5);
                    generatePagination();
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return (paginationService.getCollectionLength(paginationId) + 1) * paginationService.getItemsPerPage(paginationId);
                }
            }, function(length) {
                if (0 < length) {
                    generatePagination();
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return (paginationService.getItemsPerPage(paginationId));
                }
            }, function(current, previous) {
                if (current != previous && typeof previous !== 'undefined') {
                    goToPage(scope.pagination.current);
                }
            });

            scope.$watch(function() {
                if (paginationService.isRegistered(paginationId)) {
                    return paginationService.getCurrentPage(paginationId);
                }
            }, function(currentPage, previousPage) {
                if (currentPage != previousPage) {
                    goToPage(currentPage);
                }
            });

            scope.setCurrent = function(num) {
                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
                    num = parseInt(num, 10);
                    paginationService.setCurrentPage(paginationId, num);
                }
            };

            /**
             * Custom "track by" function which allows for duplicate "..." entries on long lists,
             * yet fixes the problem of wrongly-highlighted links which happens when using
             * "track by $index" - see https://github.com/michaelbromley/angularUtils/issues/153
             * @param id
             * @param index
             * @returns {string}
             */
            scope.tracker = function(id, index) {
                return id + '_' + index;
            };

            function goToPage(num) {
                if (paginationService.isRegistered(paginationId) && isValidPageNumber(num)) {
                    var oldPageNumber = scope.pagination.current;

                    scope.pages = generatePagesArray(num, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                    scope.pagination.current = num;
                    updateRangeValues();

                    // if a callback has been set, then call it with the page number as the first argument
                    // and the previous page number as a second argument
                    if (scope.onPageChange) {
                        scope.onPageChange({
                            newPageNumber : num,
                            oldPageNumber : oldPageNumber
                        });
                    }
                }
            }

            function generatePagination() {
                if (paginationService.isRegistered(paginationId)) {
                    var page = parseInt(paginationService.getCurrentPage(paginationId)) || 1;
                    scope.pages = generatePagesArray(page, paginationService.getCollectionLength(paginationId), paginationService.getItemsPerPage(paginationId), paginationRange);
                    scope.pagination.current = page;
                    scope.pagination.last = scope.pages[scope.pages.length - 1];
                    if (scope.pagination.last < scope.pagination.current) {
                        scope.setCurrent(scope.pagination.last);
                    } else {
                        updateRangeValues();
                    }
                }
            }

            /**
             * This function updates the values (lower, upper, total) of the `scope.range` object, which can be used in the pagination
             * template to display the current page range, e.g. "showing 21 - 40 of 144 results";
             */
            function updateRangeValues() {
                if (paginationService.isRegistered(paginationId)) {
                    var currentPage = paginationService.getCurrentPage(paginationId),
                        itemsPerPage = paginationService.getItemsPerPage(paginationId),
                        totalItems = paginationService.getCollectionLength(paginationId);

                    scope.range.lower = (currentPage - 1) * itemsPerPage + 1;
                    scope.range.upper = Math.min(currentPage * itemsPerPage, totalItems);
                    scope.range.total = totalItems;
                }
            }
            function isValidPageNumber(num) {
                return (numberRegex.test(num) && (0 < num && num <= scope.pagination.last));
            }
        }

        /**
         * Generate an array of page numbers (or the '...' string) which is used in an ng-repeat to generate the
         * links used in pagination
         *
         * @param currentPage
         * @param rowsPerPage
         * @param paginationRange
         * @param collectionLength
         * @returns {Array}
         */
        function generatePagesArray(currentPage, collectionLength, rowsPerPage, paginationRange) {
            var pages = [];
            var totalPages = Math.ceil(collectionLength / rowsPerPage);
            var halfWay = Math.ceil(paginationRange / 2);
            var position;

            if (currentPage <= halfWay) {
                position = 'start';
            } else if (totalPages - halfWay < currentPage) {
                position = 'end';
            } else {
                position = 'middle';
            }

            var ellipsesNeeded = paginationRange < totalPages;
            var i = 1;
            while (i <= totalPages && i <= paginationRange) {
                var pageNumber = calculatePageNumber(i, currentPage, paginationRange, totalPages);

                var openingEllipsesNeeded = (i === 2 && (position === 'middle' || position === 'end'));
                var closingEllipsesNeeded = (i === paginationRange - 1 && (position === 'middle' || position === 'start'));
                if (ellipsesNeeded && (openingEllipsesNeeded || closingEllipsesNeeded)) {
                    pages.push('...');
                } else {
                    pages.push(pageNumber);
                }
                i ++;
            }
            return pages;
        }

        /**
         * Given the position in the sequence of pagination links [i], figure out what page number corresponds to that position.
         *
         * @param i
         * @param currentPage
         * @param paginationRange
         * @param totalPages
         * @returns {*}
         */
        function calculatePageNumber(i, currentPage, paginationRange, totalPages) {
            var halfWay = Math.ceil(paginationRange/2);
            if (i === paginationRange) {
                return totalPages;
            } else if (i === 1) {
                return i;
            } else if (paginationRange < totalPages) {
                if (totalPages - halfWay < currentPage) {
                    return totalPages - paginationRange + i;
                } else if (halfWay < currentPage) {
                    return currentPage - halfWay + i;
                } else {
                    return i;
                }
            } else {
                return i;
            }
        }
    }

    /**
     * This filter slices the collection into pages based on the current page number and number of items per page.
     * @param paginationService
     * @returns {Function}
     */
    function itemsPerPageFilter(paginationService) {

        return function(collection, itemsPerPage, paginationId) {
            if (typeof (paginationId) === 'undefined') {
                paginationId = DEFAULT_ID;
            }
            if (!paginationService.isRegistered(paginationId)) {
                throw 'pagination directive: the itemsPerPage id argument (id: ' + paginationId + ') does not match a registered pagination-id.';
            }
            var end;
            var start;
            if (angular.isObject(collection)) {
                itemsPerPage = parseInt(itemsPerPage) || 9999999999;
                if (paginationService.isAsyncMode(paginationId)) {
                    start = 0;
                } else {
                    start = (paginationService.getCurrentPage(paginationId) - 1) * itemsPerPage;
                }
                end = start + itemsPerPage;
                paginationService.setItemsPerPage(paginationId, itemsPerPage);

                if (collection instanceof Array) {
                    // the array just needs to be sliced
                    return collection.slice(start, end);
                } else {
                    // in the case of an object, we need to get an array of keys, slice that, then map back to
                    // the original object.
                    var slicedObject = {};
                    angular.forEach(keys(collection).slice(start, end), function(key) {
                        slicedObject[key] = collection[key];
                    });
                    return slicedObject;
                }
            } else {
                return collection;
            }
        };
    }

    /**
     * Shim for the Object.keys() method which does not exist in IE < 9
     * @param obj
     * @returns {Array}
     */
    function keys(obj) {
        if (!Object.keys) {
            var objKeys = [];
            for (var i in obj) {
                if (obj.hasOwnProperty(i)) {
                    objKeys.push(i);
                }
            }
            return objKeys;
        } else {
            return Object.keys(obj);
        }
    }

    /**
     * This service allows the various parts of the module to communicate and stay in sync.
     */
    function paginationService() {

        var instances = {};
        var lastRegisteredInstance;

        this.registerInstance = function(instanceId) {
            if (typeof instances[instanceId] === 'undefined') {
                instances[instanceId] = {
                    asyncMode: false
                };
                lastRegisteredInstance = instanceId;
            }
        };

        this.deregisterInstance = function(instanceId) {
            delete instances[instanceId];
        };

        this.isRegistered = function(instanceId) {
            return (typeof instances[instanceId] !== 'undefined');
        };

        this.getLastInstanceId = function() {
            return lastRegisteredInstance;
        };

        this.setCurrentPageParser = function(instanceId, val, scope) {
            instances[instanceId].currentPageParser = val;
            instances[instanceId].context = scope;
        };
        this.setCurrentPage = function(instanceId, val) {
            instances[instanceId].currentPageParser.assign(instances[instanceId].context, val);
        };
        this.getCurrentPage = function(instanceId) {
            var parser = instances[instanceId].currentPageParser;
            return parser ? parser(instances[instanceId].context) : 1;
        };

        this.setItemsPerPage = function(instanceId, val) {
            instances[instanceId].itemsPerPage = val;
        };
        this.getItemsPerPage = function(instanceId) {
            return instances[instanceId].itemsPerPage;
        };

        this.setCollectionLength = function(instanceId, val) {
            instances[instanceId].collectionLength = val;
        };
        this.getCollectionLength = function(instanceId) {
            return instances[instanceId].collectionLength;
        };

        this.setAsyncModeTrue = function(instanceId) {
            instances[instanceId].asyncMode = true;
        };

        this.setAsyncModeFalse = function(instanceId) {
            instances[instanceId].asyncMode = false;
        };

        this.isAsyncMode = function(instanceId) {
            return instances[instanceId].asyncMode;
        };
    }

    /**
     * This provider allows global configuration of the template path used by the dir-pagination-controls directive.
     */
    function paginationTemplateProvider() {

        var templatePath = 'angularUtils.directives.dirPagination.template';
        var templateString;

        /**
         * Set a templateUrl to be used by all instances of <dir-pagination-controls>
         * @param {String} path
         */
        this.setPath = function(path) {
            templatePath = path;
        };

        /**
         * Set a string of HTML to be used as a template by all instances
         * of <dir-pagination-controls>. If both a path *and* a string have been set,
         * the string takes precedence.
         * @param {String} str
         */
        this.setString = function(str) {
            templateString = str;
        };

        this.$get = function() {
            return {
                getPath: function() {
                    return templatePath;
                },
                getString: function() {
                    return templateString;
                }
            };
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ExistingCafToZero', ExistingCafToZero);

    ExistingCafToZero.$inject = ['$resource', 'DateUtils'];

    function ExistingCafToZero ($resource, DateUtils) {
        var resourceUrl =  'api/existingCafMigrationResource';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET'
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Locations', Locations);

    Locations.$inject = ['$resource'];

    function Locations ($resource) {
        var locations=[
            {
                "cities": [
                    "Baksa",
                    "Barpeta",
                    "Bongaigaon",
                    "Cachar",
                    "Chirang",
                    "Darrang",
                    "Dhemaji",
                    "Dhubri",
                    "Dibrugarh",
                    "Dima Hasao",
                    "Goalpara",
                    "Golaghat",
                    "Hailakandi",
                    "Jorhat",
                    "Kamrup",
                    "Kamrup Metropolitan",
                    "Karbi Anglong",
                    "Karimganj",
                    "Kokrajhar",
                    "Lakhimpur",
                    "Morigaon",
                    "Nagaon",
                    "Nalbari",
                    "Sibsagar",
                    "Sonitpur",
                    "Tinsukia",
                    "Udalguri"
                ],
                "state": "Assam"
            },
            {
                "cities": [
                    "North Goa",
                    "South Goa"
                ],
                "state": "Goa"
            },
            {
                "cities": [
                    "Alirajpur",
                    "Anuppur",
                    "Ashoknagar",
                    "Balaghat",
                    "Barwani",
                    "Betul",
                    "Bhind",
                    "Bhopal",
                    "Burhanpur",
                    "Chhatarpur",
                    "Chhindwara",
                    "Damoh",
                    "Datia",
                    "Dewas",
                    "Dhar",
                    "Dindori",
                    "East Nimar",
                    "Guna",
                    "Gwalior",
                    "Harda",
                    "Hoshangabad",
                    "Indore",
                    "Jabalpur",
                    "Jhabua",
                    "Katni",
                    "Khargone",
                    "Mandla",
                    "Mandsaur",
                    "Morena",
                    "Narsimhapur",
                    "Neemuch",
                    "Panna",
                    "Raisen",
                    "Rajgarh",
                    "Ratlam",
                    "Rewa",
                    "Sagar",
                    "Satna",
                    "Sehore",
                    "Seoni",
                    "Shahdol",
                    "Shajapur",
                    "Sheopur",
                    "Shivpuri",
                    "Sidhi",
                    "Singrauli",
                    "Tikamgarh",
                    "Ujjain",
                    "Umaria",
                    "Vidisha"
                ],
                "state": "Madhya Pradesh"
            },
            {
                "cities": [
                    "Bishnupur",
                    "Chandel",
                    "Churachandpur",
                    "Imphal East",
                    "Imphal West",
                    "Senapati",
                    "Tamenglong",
                    "Thoubal",
                    "Ukhrul"
                ],
                "state": "Manipur"
            },
            {
                "cities": [
                    "East Garo Hills",
                    "East Khasi Hills",
                    "Jaintia Hills",
                    "Ri-Bhoi",
                    "South Garo Hills",
                    "West Garo Hills",
                    "West Khasi Hills"
                ],
                "state": "Meghalaya"
            },
            {
                "cities": [
                    "Aizawl",
                    "Champhai",
                    "Kolasib",
                    "Lawngtlai",
                    "Lunglei",
                    "Mamit",
                    "Saiha",
                    "Serchhip"
                ],
                "state": "Mizoram"
            },
            {
                "cities": [
                    "Central Delhi",
                    "East Delhi",
                    "New Delhi",
                    "North Delhi",
                    "North East Delhi",
                    "North West Delhi",
                    "South Delhi",
                    "South West Delhi",
                    "West Delhi"
                ],
                "state": "Delhi"
            },
            {
                "cities": [
                    "East",
                    "North",
                    "South",
                    "West"
                ],
                "state": "Sikkim"
            },
            {
                "cities": [
                    "Anantapur",
                    "Chittoor",
                    "Cuddapah",
                    "East Godavari",
                    "Guntur",
                    "Krishna",
                    "Kurnool",
                    "Nellore",
                    "Prakasam",
                    "Srikakulam",
                    "Vishakhapatnam",
                    "Vizianagaram",
                    "West Godavari"
                ],
                "state": "Andhra Pradesh"
            },
            {
                "cities": [
                    "Anjaw",
                    "Changlang",
                    "Dibang Valley",
                    "East Kameng",
                    "East Siang",
                    "Kurung Kumey",
                    "Lohit",
                    "Lower Dibang Valley",
                    "Lower Subansiri",
                    "Papum Pare",
                    "Tawang",
                    "Tirap",
                    "Upper Siang",
                    "Upper Subansiri",
                    "West Kameng",
                    "West Siang"
                ],
                "state": "Arunachal Pradesh"
            },
            {
                "cities": [
                    "Araria",
                    "Arwal",
                    "Aurangabad",
                    "Banka",
                    "Begusarai",
                    "Bhagalpur",
                    "Bhojpur",
                    "Buxar",
                    "Darbhanga",
                    "Gaya",
                    "Gopalganj",
                    "Jamui",
                    "Jehanabad",
                    "Kaimur",
                    "Katihar",
                    "Khagaria",
                    "Kishanganj",
                    "Lakhisarai",
                    "Madhepura",
                    "Madhubani",
                    "Munger",
                    "Muzaffarpur",
                    "Nalanda",
                    "Nawada",
                    "Pashchim Champaran",
                    "Patna",
                    "Purba Champaran",
                    "Purnia",
                    "Rohtas",
                    "Saharsa",
                    "Samastipur",
                    "Saran",
                    "Sheikhpura",
                    "Sheohar",
                    "Sitamarhi",
                    "Siwan",
                    "Supaul",
                    "Vaishali"
                ],
                "state": "Bihar"
            },
            {
                "cities": [
                    "Bastar",
                    "Bijapur",
                    "Bilaspur",
                    "Dakshin Bastar Dantewada",
                    "Dhamtari",
                    "Durg",
                    "Janjgir-Champa",
                    "Jashpur",
                    "Kabeerdham",
                    "Korba",
                    "Koriya",
                    "Mahasamund",
                    "Narayanpur",
                    "Raigarh",
                    "Raipur",
                    "Raj Nandgaon",
                    "Surguja",
                    "Uttar Bastar Kanker"
                ],
                "state": "Chhattisgarh"
            },
            {
                "cities": [
                    "Ahmadabad",
                    "Amreli",
                    "Anand",
                    "Banas Kantha",
                    "Bharuch",
                    "Bhavnagar",
                    "Dohad",
                    "Gandhinagar",
                    "Jamnagar",
                    "Junagadh",
                    "Kachchh",
                    "Kheda",
                    "Mahesana",
                    "Narmada",
                    "Navsari",
                    "Panch Mahals",
                    "Patan",
                    "Porbandar",
                    "Rajkot",
                    "Sabar Kantha",
                    "Surat",
                    "Surendranagar",
                    "Tapi",
                    "The Dangs",
                    "Vadodara",
                    "Valsad"
                ],
                "state": "Gujarat"
            },
            {
                "cities": [
                    "Ambala",
                    "Bhiwani",
                    "Faridabad",
                    "Fatehabad",
                    "Gurgaon",
                    "Hisar",
                    "Jhajjar",
                    "Jind",
                    "Kaithal",
                    "Karnal",
                    "Kurukshetra",
                    "Mahendragarh",
                    "Mewat",
                    "Palwal",
                    "Panchkula",
                    "Panipat",
                    "Rewari",
                    "Rohtak",
                    "Sirsa",
                    "Sonipat",
                    "Yamunanagar"
                ],
                "state": "Haryana"
            },
            {
                "cities": [
                    "Bilaspur",
                    "Chamba",
                    "Hamirpur",
                    "Kangra",
                    "Kinnaur",
                    "Kulu",
                    "Lahul and Spiti",
                    "Mandi",
                    "Shimla",
                    "Sirmaur",
                    "Solan",
                    "Una"
                ],
                "state": "Himachal Pradesh"
            },
            {
                "cities": [
                    "Anantnag",
                    "Badgam",
                    "Bandipore",
                    "Baramula",
                    "Doda",
                    "Ganderbal",
                    "Jammu",
                    "Kargil",
                    "Kathua",
                    "Kishtwar",
                    "Kulgam",
                    "Kupwara",
                    "Ladakh",
                    "Pulwama",
                    "Punch",
                    "Rajauri",
                    "Ramban",
                    "Reasi",
                    "Samba",
                    "Shupiyan",
                    "Srinagar",
                    "Udhampur"
                ],
                "state": "Jammu and Kashmir"
            },
            {
                "cities": [
                    "Bokaro",
                    "Chatra",
                    "Deogarh",
                    "Dhanbad",
                    "Dumka",
                    "Garhwa",
                    "Giridih",
                    "Godda",
                    "Gumla",
                    "Hazaribag",
                    "Jamtara",
                    "Khunti",
                    "Kodarma",
                    "Latehar",
                    "Lohardaga",
                    "Pakur",
                    "Palamu",
                    "Pashchim Singhbhum",
                    "Purba Singhbhum",
                    "Ramgarh",
                    "Ranchi",
                    "Sahibganj",
                    "Saraikela",
                    "Simdega"
                ],
                "state": "Jharkhand"
            },
            {
                "cities": [
                    "Bagalkot",
                    "Bangalore Rural",
                    "Bangalore Urban",
                    "Belgaum",
                    "Bellary",
                    "Bidar",
                    "Bijapur",
                    "Chamrajnagar",
                    "Chikkaballapur",
                    "Chikmagalur",
                    "Chitradurga",
                    "Dakshina Kannada",
                    "Davanagere",
                    "Dharwad",
                    "Gadag",
                    "Gulbarga",
                    "Hassan",
                    "Haveri",
                    "Kodagu",
                    "Kolar",
                    "Koppal",
                    "Mandya",
                    "Mysore",
                    "Raichur",
                    "Ramanagara",
                    "Shimoga",
                    "Tumkur",
                    "Udupi",
                    "Uttar Kannada",
                    "Yadgir"
                ],
                "state": "Karnataka"
            },
            {
                "cities": [
                    "Alappuzha",
                    "Ernakulam",
                    "Idukki",
                    "Kannur",
                    "Kasaragod",
                    "Kollam",
                    "Kottayam",
                    "Kozhikode",
                    "Malappuram",
                    "Palakkad",
                    "Pattanamtitta",
                    "Thiruvananthapuram",
                    "Thrissur",
                    "Wayanad"
                ],
                "state": "Kerala"
            },
            {
                "cities": [
                    "Ahmadnagar",
                    "Akola",
                    "Amravati Division",
                    "Aurangabad Division",
                    "Bhandara",
                    "Bid",
                    "Buldana",
                    "Chandrapur",
                    "Dhule",
                    "Gadchiroli",
                    "Gondiya",
                    "Hingoli",
                    "Jalgaon",
                    "Jalna",
                    "Kolhapur",
                    "Latur",
                    "Mumbai",
                    "Mumbai Suburban",
                    "Nagpur Division",
                    "Nanded",
                    "Nandurbar",
                    "Nashik Division",
                    "Osmanabad",
                    "Parbhani",
                    "Pune Division",
                    "Raigarh",
                    "Ratnagiri",
                    "Sangli",
                    "Satara Division",
                    "Sindhudurg",
                    "Solapur",
                    "Thane",
                    "Wardha",
                    "Washim",
                    "Yavatmal"
                ],
                "state": "Maharashtra"
            },
            {
                "cities": [
                    "Dimapur",
                    "Kiphire",
                    "Kohima",
                    "Longleng",
                    "Mokokchung",
                    "Mon",
                    "Peren",
                    "Phek",
                    "Tuensang",
                    "Wokha",
                    "Zunheboto"
                ],
                "state": "Nagaland"
            },
            {
                "cities": [
                    "Angul",
                    "Balangir",
                    "Baleshwar",
                    "Baragarh",
                    "Baudh",
                    "Bhadrak",
                    "Cuttack",
                    "Debagarh",
                    "Dhenkanal",
                    "Gajapati",
                    "Ganjam",
                    "Jagatsinghpur",
                    "Jajpur",
                    "Jharsuguda",
                    "Kalahandi",
                    "Kandhamal",
                    "Kendrapara",
                    "Kendujhar",
                    "Khordha",
                    "Koraput",
                    "Malkangiri",
                    "Mayurbhanj",
                    "Nabarangpur",
                    "Nayagarh",
                    "Nuapada",
                    "Puri",
                    "Rayagada",
                    "Sambalpur",
                    "Subarnapur",
                    "Sundargarh"
                ],
                "state": "Odisha"
            },
            {
                "cities": [
                    "Ajitgarh",
                    "Amritsar",
                    "Barnala",
                    "Bathinda",
                    "Faridkot",
                    "Fatehgarh Sahib",
                    "Fazilka",
                    "Ferozepur",
                    "Gurdaspur",
                    "Hoshiarpur",
                    "Jalandhar",
                    "Kapurthala",
                    "Ludhiana",
                    "Mansa",
                    "Moga",
                    "Muktsar",
                    "Pathankot",
                    "Patiala",
                    "Rupnagar",
                    "Sangrur",
                    "Shahid Bhagat Singh Nagar",
                    "Tarn Taran"
                ],
                "state": "Punjab"
            },
            {
                "cities": [
                    "Ajmer",
                    "Alwar",
                    "Banswara",
                    "Baran",
                    "Barmer",
                    "Bharatpur",
                    "Bhilwara",
                    "Bikaner",
                    "Bundi",
                    "Chittaurgarh",
                    "Churu",
                    "Dausa",
                    "Dhaulpur",
                    "Dungarpur",
                    "Ganganagar",
                    "Hanumangarh",
                    "Jaipur",
                    "Jaisalmer",
                    "Jalore",
                    "Jhalawar",
                    "Jhunjhunun",
                    "Jodhpur",
                    "Karauli",
                    "Kota",
                    "Nagaur",
                    "Pali",
                    "Pratapgarh",
                    "Rajsamand",
                    "Sawai Madhopur",
                    "Sikar",
                    "Sirohi",
                    "Tonk",
                    "Udaipur"
                ],
                "state": "Rajasthan"
            },
            {
                "cities": [
                    "Ariyalur",
                    "Chennai",
                    "Coimbatore",
                    "Cuddalore",
                    "Dharmapuri",
                    "Dindigul",
                    "Erode",
                    "Kancheepuram",
                    "Kanniyakumari",
                    "Karur",
                    "Krishnagiri",
                    "Madurai",
                    "Nagapattinam",
                    "Namakkal",
                    "Nilgiris",
                    "Perambalur",
                    "Pudukkottai",
                    "Ramanathapuram",
                    "Salem",
                    "Sivaganga",
                    "Thanjavur",
                    "Theni",
                    "Thiruvallur",
                    "Thiruvarur",
                    "Thoothukkudi",
                    "Tiruchchirappalli",
                    "Tirunelveli Kattabo",
                    "Tiruppur",
                    "Tiruvannamalai",
                    "Vellore",
                    "Villupuram",
                    "Virudhunagar"
                ],
                "state": "Tamil Nadu"
            },
            {
                "cities": [
                    "Almora",
                    "Bageshwar",
                    "Chamoli",
                    "Champawat",
                    "Dehradun",
                    "Garhwal",
                    "Haridwar",
                    "Naini Tal",
                    "Pithoragarh",
                    "Rudraprayag",
                    "Tehri-Garhwal",
                    "Udham Singh Nagar",
                    "Uttarkashi"
                ],
                "state": "Uttarakhand"
            },
            {
                "cities": [
                    "Adilabad",
                    "Hyderabad",
                    "Karimnagar",
                    "Khammam",
                    "Mahbubnagar",
                    "Medak",
                    "Nalgonda",
                    "Nizamabad",
                    "Rangareddi",
                    "Warangal"
                ],
                "state": "Telangana"
            },
            {
                "cities": [
                    "Dhalai",
                    "North Tripura",
                    "South Tripura",
                    "West Tripura"
                ],
                "state": "Tripura"
            },
            {
                "cities": [
                    "Nicobar",
                    "North  & Middle Andaman",
                    "South Andaman"
                ],
                "state": "Union Territory of Andaman and Nicobar Islands"
            },
            {
                "cities": [
                    "Chandigarh"
                ],
                "state": "Union Territory of Chandigarh"
            },
            {
                "cities": [
                    "Dadra & Nagar Haveli"
                ],
                "state": "Union Territory of Dadra and Nagar Haveli"
            },
            {
                "cities": [
                    "Daman",
                    "Diu"
                ],
                "state": "Union Territory of Daman and Diu"
            },
            {
                "cities": [
                    "Lakshadweep"
                ],
                "state": "Union Territory of Lakshadweep"
            },
            {
                "cities": [
                    "Karaikal",
                    "Mahe",
                    "Puducherry",
                    "Yanam"
                ],
                "state": "Union Territory of Puducherry"
            },
            {
                "cities": [
                    "Agra",
                    "Aligarh",
                    "Allahabad",
                    "Ambedkar Nagar",
                    "Auraiya",
                    "Azamgarh",
                    "Baghpat",
                    "Bahraich",
                    "Ballia",
                    "Balrampur",
                    "Banda",
                    "Bara Banki",
                    "Bareilly",
                    "Basti",
                    "Bijnor",
                    "Budaun",
                    "Bulandshahr",
                    "Chandauli",
                    "Chitrakoot",
                    "Deoria",
                    "Etah",
                    "Etawah",
                    "Faizabad",
                    "Farrukhabad",
                    "Fatehpur",
                    "Firozabad",
                    "Gautam Buddha Nagar",
                    "Ghaziabad",
                    "Ghazipur",
                    "Gonda",
                    "Gorakhpur",
                    "Hamirpur",
                    "Hardoi",
                    "Hathras",
                    "Jalaun",
                    "Jaunpur",
                    "Jhansi",
                    "Jyotiba Phule Nagar",
                    "Kannauj",
                    "Kanpur",
                    "Kanpur Dehat",
                    "Kasganj",
                    "Kaushambi",
                    "Kheri",
                    "Kushinagar",
                    "Lalitpur",
                    "Lucknow",
                    "Maharajganj",
                    "Mahoba",
                    "Mainpuri",
                    "Mathura",
                    "Mau",
                    "Meerut",
                    "Mirzapur",
                    "Moradabad",
                    "Muzaffarnagar",
                    "Pilibhit",
                    "Pratapgarh",
                    "Rae Bareli",
                    "Rampur",
                    "Saharanpur",
                    "Sant Kabir Nagar",
                    "Sant Ravi Das Nagar",
                    "Shahjahanpur",
                    "Shrawasti",
                    "Siddharthangar",
                    "Sitapur",
                    "Sonbhadra",
                    "Sultanpur",
                    "Unnao",
                    "Varanasi"
                ],
                "state": "Uttar Pradesh"
            },
            {
                "cities": [
                    "Bankura",
                    "Barddhaman",
                    "Birbhum",
                    "Dakshin Dinajpur",
                    "Darjiling",
                    "Haora",
                    "Hugli",
                    "Jalpaiguri",
                    "Koch Bihar",
                    "Kolkata",
                    "Maldah",
                    "Murshidabad",
                    "Nadia",
                    "North 24 Parganas",
                    "Paschim Medinipur",
                    "Purba Medinipur",
                    "Puruliya",
                    "South 24 Parganas",
                    "Uttar Dinajpur"
                ],
                "state": "West Bengal"
            }
        ];

        return {
            getAllStates:function () {
                return locations;
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('investhryApp')
        .factory('CountryService', CountryService);

    CountryService.$inject = [];

    function CountryService() {
        return {
            getAllCountries: function () {
                var countries = [{"name": "Afghanistan", "code": "af"}, {
                    "name": "Albania",
                    "code": "al"
                }, {"name": "Algeria", "code": "dz"}, {"name": "Andorra", "code": "ad"}, {
                    "name": "Angola",
                    "code": "ao"
                }, {"name": "Anguilla", "code": "ai"}, {
                    "name": "Antigua and Barbuda",
                    "code": "ag"
                }, {"name": "Argentina", "code": "ar"}, {"name": "Armenia", "code": "am"}, {
                    "name": "Aruba",
                    "code": "aw"
                }, {"name": "Australia", "code": "au"}, {"name": "Austria", "code": "at"}, {
                    "name": "Azerbaijan",
                    "code": "az"
                }, {"name": "Bahamas", "code": "bs"}, {"name": "Bahrain", "code": "bh"}, {
                    "name": "Bangladesh",
                    "code": "bd"
                }, {"name": "Barbados", "code": "bb"}, {"name": "Belarus", "code": "by"}, {
                    "name": "Belgium",
                    "code": "be"
                }, {"name": "Belize", "code": "bz"}, {"name": "Benin", "code": "bj"}, {
                    "name": "Bermuda",
                    "code": "bm"
                }, {"name": "Bhutan", "code": "bt"}, {
                    "name": "Bolivia",
                    "code": "bo"
                }, {"name": "Bosnia and Herzegovina", "code": "ba"}, {
                    "name": "Botswana",
                    "code": "bw"
                }, {"name": "Brazil", "code": "br"}, {"name": "Brunei Darussalam", "code": "bn"}, {
                    "name": "Bulgaria",
                    "code": "bg"
                }, {"name": "Burkina Faso", "code": "bf"}, {"name": "Burundi", "code": "bi"}, {
                    "name": "Cambodia",
                    "code": "kh"
                }, {"name": "Cameroon", "code": "cm"}, {"name": "Canada", "code": "ca"}, {
                    "name": "Cape Verde",
                    "code": "cv"
                }, {"name": "Cayman Islands", "code": "ky"}, {
                    "name": "Central African Republic",
                    "code": "cf"
                }, {"name": "Chad", "code": "td"}, {"name": "Chile", "code": "cl"}, {
                    "name": "China",
                    "code": "cn"
                }, {"name": "Christmas Island", "code": "cx"}, {
                    "name": "Cocos (Keeling) Islands",
                    "code": "cc"
                }, {"name": "Colombia", "code": "co"}, {"name": "Comoros", "code": "km"}, {
                    "name": "Congo",
                    "code": "cg"
                }, {"name": "Cook Islands", "code": "ck"}, {
                    "name": "Costa Rica",
                    "code": "cr"
                }, {"name": "Cote D\u0027Ivoire (Ivory Coast)", "code": "ci"}, {
                    "name": "Croatia (Hrvatska)",
                    "code": "hr"
                }, {"name": "Cuba", "code": "cu"}, {"name": "Cyprus", "code": "cy"}, {
                    "name": "Czech Republic",
                    "code": "cz"
                }, {"name": "Democratic Republic of the Congo", "code": "cd"}, {
                    "name": "Denmark",
                    "code": "dk"
                }, {"name": "Djibouti", "code": "dj"}, {
                    "name": "Dominica",
                    "code": "dm"
                }, {"name": "Dominican Republic", "code": "do"}, {"name": "Ecuador", "code": "ec"}, {
                    "name": "Egypt",
                    "code": "eg"
                }, {"name": "El Salvador", "code": "sv"}, {
                    "name": "Equatorial Guinea",
                    "code": "gq"
                }, {"name": "Eritrea", "code": "er"}, {"name": "Estonia", "code": "ee"}, {
                    "name": "Ethiopia",
                    "code": "et"
                }, {"name": "Falkland Islands (Malvinas)", "code": "fk"}, {
                    "name": "Faroe Islands",
                    "code": "fo"
                }, {"name": "Federated States of Micronesia", "code": "fm"}, {
                    "name": "Fiji",
                    "code": "fj"
                }, {"name": "Finland", "code": "fi"}, {"name": "France", "code": "fr"}, {
                    "name": "French Guiana",
                    "code": "gf"
                }, {"name": "French Polynesia", "code": "pf"}, {
                    "name": "French Southern Territories",
                    "code": "tf"
                }, {"name": "Gabon", "code": "ga"}, {"name": "Gambia", "code": "gm"}, {
                    "name": "Georgia",
                    "code": "ge"
                }, {"name": "Germany", "code": "de"}, {"name": "Ghana", "code": "gh"}, {
                    "name": "Gibraltar",
                    "code": "gi"
                }, {"name": "Great Britain (UK)", "code": "gb"}, {"name": "Greece", "code": "gr"}, {
                    "name": "Greenland",
                    "code": "gl"
                }, {"name": "Grenada", "code": "gd"}, {"name": "Guadeloupe", "code": "gp"}, {
                    "name": "Guatemala",
                    "code": "gt"
                }, {"name": "Guinea", "code": "gn"}, {"name": "Guinea-Bissau", "code": "gw"}, {
                    "name": "Guyana",
                    "code": "gy"
                }, {"name": "Haiti", "code": "ht"}, {"name": "Honduras", "code": "hn"}, {
                    "name": "Hong Kong",
                    "code": "hk"
                }, {"name": "Hungary", "code": "hu"}, {"name": "Iceland", "code": "is"}, {
                    "name": "India",
                    "code": "in"
                }, {"name": "Indonesia", "code": "id"}, {"name": "Iran", "code": "ir"}, {
                    "name": "Iraq",
                    "code": "iq"
                }, {"name": "Ireland", "code": "ie"}, {"name": "Israel", "code": "il"}, {
                    "name": "Italy",
                    "code": "it"
                }, {"name": "Jamaica", "code": "jm"}, {"name": "Japan", "code": "jp"}, {
                    "name": "Jordan",
                    "code": "jo"
                }, {"name": "Kazakhstan", "code": "kz"}, {"name": "Kenya", "code": "ke"}, {
                    "name": "Kiribati",
                    "code": "ki"
                }, {"name": "Korea (North)", "code": "kp"}, {"name": "Korea (South)", "code": "kr"}, {
                    "name": "Kuwait",
                    "code": "kw"
                }, {"name": "Kyrgyzstan", "code": "kg"}, {"name": "Laos", "code": "la"}, {
                    "name": "Latvia",
                    "code": "lv"
                }, {"name": "Lebanon", "code": "lb"}, {"name": "Lesotho", "code": "ls"}, {
                    "name": "Liberia",
                    "code": "lr"
                }, {"name": "Libya", "code": "ly"}, {"name": "Liechtenstein", "code": "li"}, {
                    "name": "Lithuania",
                    "code": "lt"
                }, {"name": "Luxembourg", "code": "lu"}, {"name": "Macao", "code": "mo"}, {
                    "name": "Macedonia",
                    "code": "mk"
                }, {"name": "Madagascar", "code": "mg"}, {"name": "Malawi", "code": "mw"}, {
                    "name": "Malaysia",
                    "code": "my"
                }, {"name": "Maldives", "code": "mv"}, {"name": "Mali", "code": "ml"}, {
                    "name": "Malta",
                    "code": "mt"
                }, {"name": "Marshall Islands", "code": "mh"}, {
                    "name": "Martinique",
                    "code": "mq"
                }, {"name": "Mauritania", "code": "mr"}, {"name": "Mauritius", "code": "mu"}, {
                    "name": "Mayotte",
                    "code": "yt"
                }, {"name": "Mexico", "code": "mx"}, {"name": "Moldova", "code": "md"}, {
                    "name": "Monaco",
                    "code": "mc"
                }, {"name": "Mongolia", "code": "mn"}, {"name": "Montserrat", "code": "ms"}, {
                    "name": "Morocco",
                    "code": "ma"
                }, {"name": "Mozambique", "code": "mz"}, {"name": "Myanmar", "code": "mm"}, {
                    "name": "Namibia",
                    "code": "na"
                }, {"name": "Nauru", "code": "nr"}, {"name": "Nepal", "code": "np"}, {
                    "name": "Netherlands",
                    "code": "nl"
                }, {"name": "Netherlands Antilles", "code": "an"}, {
                    "name": "New Caledonia",
                    "code": "nc"
                }, {"name": "New Zealand (Aotearoa)", "code": "nz"}, {
                    "name": "Nicaragua",
                    "code": "ni"
                }, {"name": "Niger", "code": "ne"}, {"name": "Nigeria", "code": "ng"}, {
                    "name": "Niue",
                    "code": "nu"
                }, {"name": "Norfolk Island", "code": "nf"}, {
                    "name": "Northern Mariana Islands",
                    "code": "mp"
                }, {"name": "Norway", "code": "no"}, {"name": "NULL", "code": "gg"}, {
                    "name": "Oman",
                    "code": "om"
                }, {"name": "Pakistan", "code": "pk"}, {
                    "name": "Palau",
                    "code": "pw"
                }, {"name": "Palestinian Territory", "code": "ps"}, {
                    "name": "Panama",
                    "code": "pa"
                }, {"name": "Papua New Guinea", "code": "pg"}, {"name": "Paraguay", "code": "py"}, {
                    "name": "Peru",
                    "code": "pe"
                }, {"name": "Philippines", "code": "ph"}, {"name": "Pitcairn", "code": "pn"}, {
                    "name": "Poland",
                    "code": "pl"
                }, {"name": "Portugal", "code": "pt"}, {"name": "Qatar", "code": "qa"}, {
                    "name": "Reunion",
                    "code": "re"
                }, {"name": "Romania", "code": "ro"}, {"name": "Russian Federation", "code": "ru"}, {
                    "name": "Rwanda",
                    "code": "rw"
                }, {"name": "S. Georgia and S. Sandwich Islands", "code": "gs"}, {
                    "name": "Saint Helena",
                    "code": "sh"
                }, {"name": "Saint Kitts and Nevis", "code": "kn"}, {
                    "name": "Saint Lucia",
                    "code": "lc"
                }, {"name": "Saint Pierre and Miquelon", "code": "pm"}, {
                    "name": "Saint Vincent and the Grenadines",
                    "code": "vc"
                }, {"name": "Samoa", "code": "ws"}, {
                    "name": "San Marino",
                    "code": "sm"
                }, {"name": "Sao Tome and Principe", "code": "st"}, {
                    "name": "Saudi Arabia",
                    "code": "sa"
                }, {"name": "Senegal", "code": "sn"}, {"name": "Seychelles", "code": "sc"}, {
                    "name": "Sierra Leone",
                    "code": "sl"
                }, {"name": "Singapore", "code": "sg"}, {"name": "Slovakia", "code": "sk"}, {
                    "name": "Slovenia",
                    "code": "si"
                }, {"name": "Solomon Islands", "code": "sb"}, {
                    "name": "Somalia",
                    "code": "so"
                }, {"name": "South Africa", "code": "za"}, {"name": "Spain", "code": "es"}, {
                    "name": "Sri Lanka",
                    "code": "lk"
                }, {"name": "Sudan", "code": "sd"}, {
                    "name": "Suriname",
                    "code": "sr"
                }, {"name": "Svalbard and Jan Mayen", "code": "sj"}, {
                    "name": "Swaziland",
                    "code": "sz"
                }, {"name": "Sweden", "code": "se"}, {"name": "Switzerland", "code": "ch"}, {
                    "name": "Syria",
                    "code": "sy"
                }, {"name": "Taiwan", "code": "tw"}, {"name": "Tajikistan", "code": "tj"}, {
                    "name": "Tanzania",
                    "code": "tz"
                }, {"name": "Thailand", "code": "th"}, {"name": "Togo", "code": "tg"}, {
                    "name": "Tokelau",
                    "code": "tk"
                }, {"name": "Tonga", "code": "to"}, {"name": "Trinidad and Tobago", "code": "tt"}, {
                    "name": "Tunisia",
                    "code": "tn"
                }, {"name": "Turkey", "code": "tr"}, {
                    "name": "Turkmenistan",
                    "code": "tm"
                }, {"name": "Turks and Caicos Islands", "code": "tc"}, {
                    "name": "Tuvalu",
                    "code": "tv"
                }, {"name": "Uganda", "code": "ug"}, {"name": "Ukraine", "code": "ua"}, {
                    "name": "United Arab Emirates",
                    "code": "ae"
                }, {"name": "United States of America", "code": "us"}, {
                    "name": "Uruguay",
                    "code": "uy"
                }, {"name": "Uzbekistan", "code": "uz"}, {"name": "Vanuatu", "code": "vu"}, {
                    "name": "Venezuela",
                    "code": "ve"
                }, {"name": "Viet Nam", "code": "vn"}, {
                    "name": "Virgin Islands (British)",
                    "code": "vg"
                }, {"name": "Virgin Islands (U.S.)", "code": "vi"}, {
                    "name": "Wallis and Futuna",
                    "code": "wf"
                }, {"name": "Western Sahara", "code": "eh"}, {"name": "Yemen", "code": "ye"}, {
                    "name": "Zaire (former)",
                    "code": "zr"
                }, {"name": "Zambia", "code": "zm"}, {"name": "Zimbabwe", "code": "zw"}];

                return countries;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('CheckContentFile', CheckContentFile);

    CheckContentFile.$inject = [];

    function CheckContentFile () {
        var service = {
            checkFile: checkFile,
            checkInput : checkInput,
            getExtension: getExtension
        };

        return service;

        function checkFile(fileName) {
            if(fileName!=null){
                var splitArr = fileName.split(".");
                if(splitArr[0]!=""){
                    return splitArr.length == 2;
                }
            } return false;
        }

        function getExtension(fileName) {
            if(fileName!=null){
                var splitArr = fileName.split(".");
                if(splitArr[0]!=""){
                    if(splitArr.length == 2) {
                        return splitArr[1];
                    }else return false
                }else return false;
            } return false;
        }

        function checkInput (elem) {
            elem.bind("propertychange change click keyup input paste", function(){
                if(elem.val().includes('<script') || elem.val().includes('alert(') || elem.val().includes('.js') || elem.val().includes('.exe')
                    || elem.val().includes('.sh') || elem.val().includes('.jar')
                    || elem.val().includes('bash') || elem.val().includes('./') || elem.val().includes('.tar.gz') || elem.val().includes('.deb')
                    || elem.val().includes('.rpm') || elem.val().includes('.ko') || elem.val().includes('.php') || elem.val().includes('.py')
                    || elem.val().includes('.tar')){
                    elem.val('');
                    alert('Please insert relevant information in this field.');
                }
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('HepcRecruitmentQualificationsByRefId', HepcRecruitmentQualificationsByRefId);

    HepcRecruitmentQualificationsByRefId.$inject = ['$resource'];

    function HepcRecruitmentQualificationsByRefId ($resource) {
        var resourceUrl =  'api/hepc-recruitment-qualification/qualification';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('HepcRecruitmentExperienceByRefId', HepcRecruitmentExperienceByRefId);

    HepcRecruitmentExperienceByRefId.$inject = ['$resource'];

    function HepcRecruitmentExperienceByRefId ($resource) {
        var resourceUrl =  'api/hepc-recruitment-experience/experience';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('viewRecruitmentFile', ['$q', '$timeout', '$window',
            function($q, $timeout, $window, $http) {
                return {
                    view: function(serverfilename) {
                        var defer = $q.defer();
                        $timeout(function() {
                            $window.location = 'api/viewReqruitment?name=' + serverfilename;
                        }, 1000)
                            .then(function() {
                                defer.resolve('success');
                            }, function() {
                                defer.reject('error');
                            });
                        return defer.promise;
                    }
                };
            }
        ]);
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('UploadTicketAttachment',['$http', function($http){
        return {
            saveFile: function(file,onsuccess,onerror){
                var resourceUrl =  'api/uploadTicketAttachment';
                var fd = new FormData();
                fd.append('file', file);
                return $http.post(resourceUrl, fd, {
                    transformRequest : angular.identity,
                    headers : {
                        'Content-Type' : undefined
                    }
                }).success(function(result){
                    if (onsuccess!==undefined){
                        onsuccess(result);
                    }
                }).error(function(){
                    if (onerror!==undefined){
                        onerror();
                    }
                });
            }
            }
        }]);
})();

(function() {
    'use strict';

    angular
    .module('investhryApp')
    .factory('GetImageForView', ['$q', '$timeout', '$window',
        function($q, $timeout, $window, $http) {
            return {
                getImageSource: function(name) {
                    return 'api/download?name=' + name;
                }
            };
        }
    ]);
})();

(function() {
    'use strict';

    angular
    .module('investhryApp')
    .factory('GetImageForApplicant', ['$q', '$timeout', '$window',
        function($q, $timeout, $window, $http) {
            return {
                getImageApplicant: function(name) {
                    return 'api/getimage?name=' + name;
                }
            };
        }
    ]);
})();

(function() {
    'use strict';

    angular
    .module('investhryApp')
    .factory('downloadService', ['$q', '$timeout', '$window',
        function($q, $timeout, $window, $http) {
            return {
                download: function(name) {
                    var defer = $q.defer();
                    $timeout(function() {
                        $window.location = 'api/download?name=' + name;
                        }, 1000)
                        .then(function() {
                            defer.resolve('success');
                        }, function() {
                            defer.reject('error');
                        });
                    return defer.promise;
                }
            };
        }
    ]);
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('FileManagement', ['$http', function($http) {
            function saveFile(file, filename, onsuccess, onerror) {
                var resourceUrl = 'api/FileManagement';
                var fd = new FormData();
                fd.append('file', file);
                fd.append('filename', filename);
                $http.post(resourceUrl, fd, {
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined
                    }
                }).then(function(response) {
                    console.log('File uploaded successfully', response);
                    if (onsuccess !== undefined) {
                        onsuccess(response);
                    }
                }).catch(function(error) {
                    console.error('Error uploading file', error);
                    if (onerror !== undefined) {
                        onerror(error);
                    }
                });
            }

            function saveFileForBrapCheckList(file, filename, onsuccess, onerror) {
                var resourceUrl = 'api/FileManagementBrapChecklist';
                var fd = new FormData();
                fd.append('file', file);
                fd.append('filename', filename);
                $http.post(resourceUrl, fd, {
                    transformRequest: angular.identity,
                    headers: {
                        'Content-Type': undefined
                    }
                }).then(function(response) {
                    console.log('File uploaded successfully', response);
                    if (onsuccess !== undefined) {
                        onsuccess(response);
                    }
                }).catch(function(error) {
                    console.error('Error uploading file', error);
                    if (onerror !== undefined) {
                        onerror(error);
                    }
                });
            }

            return {
                saveFile: saveFile,
                saveFileForBrapCheckList: saveFileForBrapCheckList
            };
        }]);
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .directive('fileModel', ['$parse', function ($parse) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    var model = $parse(attrs.fileModel);
                    var modelSetter = model.assign;
                    var maxSize = 1024*1024; //1 MB

                    element.bind('change', function(){
                        scope.$apply(function(){
                            scope.file.maxSizeError = false;
                            if (element[0].files.length > 1) {
                                modelSetter(scope, element[0].files);
                                } else {
                                modelSetter(scope, element[0].files[0]);
                                }
                            var fileSize = element[0].files[0].size;
                            if (fileSize > maxSize) {
                                scope.file.maxSizeError = true;
                            }
                        });
                    });
                }
            };
        }])
        // .directive('fileModelTwoMb', ['$parse', function ($parse) {
        //     return {
        //         restrict: 'A',
        //         link: function(scope, element, attrs) {
        //
        //             var model = $parse(attrs.fileModelTwoMb);
        //             var modelSetter = model.assign;
        //             var maxSize = 2 * 1024 * 1024; // 2 MB
        //
        //             element.bind('change', function(){
        //                 scope.$apply(function(){
        //
        //                     scope.file.maxSizeError2mb = false;
        //
        //                     modelSetter(scope, element[0].files[0]);
        //
        //                     var fileSize = element[0].files[0].size;
        //
        //                     if (fileSize > maxSize) {
        //                         scope.file.maxSizeError2mb = true;
        //                     }
        //
        //                 });
        //             });
        //         }
        //     };
        // }])

        .directive('fileModelTwoMb', ['$parse', function ($parse) {

            return {
                restrict: 'A',
                link: function(scope, element, attrs) {

                    var model = $parse(attrs.fileModelTwoMb);
                    var modelSetter = model.assign;

                    element.bind('change', function(){

                        scope.$apply(function(){

                            var file = element[0].files[0];

                            scope.vm.maxSizeError2mbtest = false;
                            scope.vm.fileTypeErrortest = false;

                            if(file){

                                var maxSize = 2 * 1024 * 1024;
                                var allowedType = "application/pdf";

                                if(file.size > maxSize){
                                    scope.vm.maxSizeError2mbtest = true;
                                    element.val(null);
                                    return;
                                }

                                if(file.type !== allowedType){
                                    scope.vm.fileTypeErrortest = true;
                                    element.val(null);
                                    return;
                                }

                                if(modelSetter){
                                    modelSetter(scope, file);
                                }

                            }

                        });

                    });

                }
            };

        }])
        .directive('fileChange', fileChange);
        function fileChange() {
            return {
                restrict: 'A',
                require: 'ngModel',
                scope: {
                    fileChange: '&'
                },
                link: function link(scope, element, attrs, ctrl) {
                    element.on('change', onChange);

                    scope.$on('destroy', function () {
                        element.off('change', onChange);
                    });

                    function onChange() {
                        attrs.multiple ? ctrl.$setViewValue(element[0].files) : ctrl.$setViewValue(element[0].files[0]);
                        scope.$apply(function () {
                            scope.fileChange();
                        });
                    }
                }
            };
        }
})();

(function() {
    'use strict';

    angular
    .module('investhryApp')
    .factory('downloadticketattachment', ['$q', '$timeout', '$window',
        function($q, $timeout, $window, $http) {
            return {
                download: function(name) {
                    var defer = $q.defer();
                    $timeout(function() {
                        $window.location = 'api/downloadticketattachment?name=' + name;
                        }, 1000)
                        .then(function() {
                            defer.resolve('success');
                        }, function() {
                            defer.reject('error');
                        });
                    return defer.promise;
                }
            };
        }
    ]);
})();

(function() {
    'use strict';

    angular
    .module('investhryApp')
    .factory('downloadserviceformattachment', ['$q', '$timeout', '$window',
        function($q, $timeout, $window, $http) {
            return {
                download: function(serverfilename,downloadfilename) {
                    var defer = $q.defer();
                    $timeout(function() {
                        $window.location = 'api/downloadserviceformattachment?serverfilename=' + serverfilename +'&downloadfilename='+downloadfilename;
                        }, 1000)
                        .then(function() {
                            defer.resolve('success');
                        }, function() {
                            defer.reject('error');
                        });
                    return defer.promise;
                }
            };
        }
    ]);
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DownloadExternalServiceFiles', ['$q', '$timeout', '$window',
            function($q, $timeout, $window, $http) {
                return {
                    download: function(projectid, serviceid, reApplyCounter, url) {
                        var defer = $q.defer();
                        $timeout(function() {
                            //pollution
                            if((serviceid==='6bd18359-09f4-4c71-85d9-e4f313ccfb8d')||(serviceid==='b27b79b9-a3ec-4eb1-9f70-3e275dd13cd6')||
                                (serviceid==='bcf33589-b4ab-468d-aafc-921d6754c236') || (serviceid==='3e5652fc-4aeb-4ddf-8af0-72e6f94ccb1e')
                                || (serviceid==='60da1053-0e39-4151-bbbf-d6ee41d0185f') || (serviceid==='d8607e7b-7c35-42ec-812c-c20253e22b10')
                                || (serviceid==='596c9059-7e28-49ca-a790-c79714d24f0c') || (serviceid==='8ed2d405-1651-4253-bbe9-84e869902ed2')
                                || (serviceid==='d700ca84-18e9-4126-ba11-ee57c3ba5693') || (serviceid==='aad383df-03d6-4104-9f2a-69b992919566'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid;
                            }
                            //tcp
                            else if((serviceid==='c8981bea-c376-4e65-9d43-9650989a7bb7') || (serviceid === 'dd2ca94a-1091-4290-b518-507a28d253ec') || (serviceid === 'a267e5a1-6da8-4c7b-9689-49a0ca61b692') || (serviceid === '06099ce7-a9dd-49e4-9b53-640f6dd31a20') || (serviceid === '159a0331-87c3-407d-9c6c-559455d4b6ab')
                                || (serviceid === '8b44a3ef-e336-4fb4-bdf6-24e6e157a202') || (serviceid === 'bf9caa30-5dcf-455e-85b3-28ab4fe1488e') || (serviceid === 'fa4682ac-045f-4748-849f-ad8e03317be5')
                                || (serviceid === 'c8050fed-7707-4ae2-82b4-09f6ae9bdff6') || (serviceid === '39f412f2-9248-4589-bff6-77e565131891'))
                            {
                                $window.location = url + projectid+'_'+serviceid+'_'+reApplyCounter+'.pdf';
                            }
                            //forest department
                            else if((serviceid==='c63bd059-6b32-4c17-974e-20917cdaa5ab')||(serviceid==='1f8db0c1-da38-454d-8224-3f89e622b7fb'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid;
                            }
                            //UHBVN
                            else if((serviceid==='363ecdcf-90ee-4700-9fe4-9a73081517b3') || (serviceid==='04b2a851-70f2-4223-982e-3982f6f63ea4') || (serviceid==='57fa837c-0897-4c7a-8225-74323823c890') || (serviceid==='32d7ff3c-4347-4dc9-b558-65853108610f') || (serviceid==='b4bfdc90-c1cc-44f6-9a8d-35317930b58f')
                                || (serviceid==='e2d1e569-3ee9-4cc7-ba6f-9bd7d446e9ba') || (serviceid==='8ff2374e-2d60-4d12-9aae-e9d89a4916d3') || (serviceid==='f43dc9df-1ef5-4209-be68-c989d009b83d')
                                || (serviceid==='7bd6a58a-e2a5-435f-9f48-d4a6afc35076') || (serviceid==='7ddcfe57-048f-4839-b36b-55dcc537d596')
                                || (serviceid==='a251b23d-e1c0-4ad5-ab82-23cd250855df') || (serviceid==='e9f0ee6d-5c4c-4f07-857d-7d23acec632d'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid+'&reApplyCounter='+reApplyCounter;
                            }
                            //DHBVN
                            else if((serviceid==='0577cfbb-77e3-4022-8b13-ec100e7094e0') || (serviceid==='71866fad-2959-447a-93bd-bd94dab54dd0') || (serviceid==='82924c69-73fc-4071-a2a9-45e8e4fa20c5') || (serviceid==='ac042b18-6c28-44a9-aea3-5a841b5a01be') || (serviceid==='553240db-9c19-45c8-b63a-beb3e6a1df41')
                                || (serviceid==='fb721b52-b0ec-460d-820e-05b741f6c34b') || (serviceid==='2d8fd723-bff1-4332-bbae-0d6ed600dd77') || (serviceid==='bf577a2d-2a9e-4039-9cec-1b5bd17bc079')
                                || (serviceid==='c0347070-4fb8-4d5b-ae26-b05ee70fe6c4') || (serviceid==='88aadb31-3f6f-4f89-b39b-20478a0428ea')|| (serviceid==='583ae2de-650f-4184-afbc-0a6bd178e8cc')|| (serviceid==='63673183-8f9b-474a-bf84-d06d5507e96d')|| (serviceid==='5bec2446-5f8c-449c-bdaf-05a494ad937b'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid+'&reApplyCounter='+reApplyCounter;
                            }
                            //ULB
                            else if((serviceid==='9d063f53-5e50-4b05-b543-bfa0fcb6da58') || (serviceid==='7b1bb81c-51b3-43cd-95bf-1980e84ef6fd') || (serviceid==='b1dcd895-4c99-4e86-a8b1-97793e189c63') || (serviceid==='5cdd8209-5daf-40d2-a9ea-47048b141fc8')
                                || (serviceid==='1c90c949-f2d1-4997-84b0-e6b2d40fe5e6') || (serviceid==='2c520622-d89a-42a1-ae85-efa54ee3630f') || (serviceid==='6c3b5015-2251-404a-bf94-166ed093a23b') || (serviceid==='429a67a7-e607-41e3-a5e1-2e071e01dd3d') || (serviceid==='7e6e6f13-d78b-4f36-9b82-5623e0602975'))
                            {
                                $window.location = url + '?Projectid='+projectid+'&ServiceId='+serviceid+'&reApplyCounter='+reApplyCounter;
                            }
                            //Labour
                            else if((serviceid==='ceb9286c-d5a9-4309-8505-c70279b88b4c') || (serviceid==='fbb359c8-e545-4a92-a57d-85ac14541e73') || (serviceid==='2b9b27f0-28b3-4d1d-baf1-037a0ce53c67') || (serviceid==='ead00143-65ac-415b-8ebd-7f3d44fdfe34')
                                || (serviceid==='4d85842e-79ed-4c02-98b4-d561f19b2b85') || (serviceid==='eeb5f718-76a7-49ff-af69-7ce67106ca61') || (serviceid==='bcbe8c5b-32e7-4181-b931-eea2cac22708') || (serviceid==='30a78b54-1016-4779-9197-0883eaf43d22') || (serviceid==='a2172fbe-dcd5-4aef-9154-4d3b5ca16d7f'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid+'&reApplyCounter='+reApplyCounter;
                            }
                            //DEPARTMENT OF INDUSTRIES & COMMERCE - Boiler Registration
                            else if((serviceid==='cd7a35d5-d697-468c-94c8-f773cd8bb262'))
                            {
                                $window.location = url + projectid+'_'+serviceid+'_'+reApplyCounter+'.pdf';
                            }
                            //DEPARTMENT OF INDUSTRIES & COMMERCE - Renewal of Boiler Registration
                            else if((serviceid==='f82dce85-acb3-49f9-b3a5-85522c483f6b'))
                            {
                                $window.location = url + projectid+'_'+serviceid+'_'+reApplyCounter+'.pdf';
                            }
                            //DEPARTMENT OF INDUSTRIES & COMMERCE - Lubricating license for manufacturing
                            else if((serviceid==='0ad4260f-99df-4cc9-98e9-65d58e1e2069'))
                            {
                                $window.location = url + projectid+'_'+serviceid+'_'+reApplyCounter+'.pdf';
                            }
                            //DEPARTMENT OF INDUSTRIES & COMMERCE - Lubricating license for trading
                            else if((serviceid==='4ad9c76b-c05f-4b35-ba91-0a764dcaa1a5') || (serviceid==='bf199052-f819-4bf6-88f2-004f49ed238b'))
                            {
                                $window.location = url + projectid+'_'+serviceid+'_'+reApplyCounter+'.pdf';
                            }
                            //HSIIDC
                            else if((serviceid==='077f3112-69e6-41ea-a2e5-75b4925d6900') || (serviceid==='a69786f5-c674-4de9-8807-8689c7ef86b5') || (serviceid==='b3b554c2-6869-4330-bd6b-bfccf100f498') || (serviceid==='22b0f2ab-c7b7-436c-8cd5-fa4b5295159b') || (serviceid==='ed1de49f-62e4-48a8-b332-389ecbaecb01'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid+'&reApplyCounter='+reApplyCounter+'.pdf';
                            }
                            //HSVP
                            else if((serviceid==='43575ec0-7dd3-40bd-b3c4-47638d17bf3c') || (serviceid==='b04665ae-00db-4c2e-b872-9c113b3b0e70') || (serviceid==='c5baea92-079d-44d3-9980-8b7d7d568f98') || (serviceid==='9b8f4307-4f88-4821-aec7-2dd2668041ab') || (serviceid==='a8ed9b41-68cc-4cdf-b393-6ae0302fca4b  '))
                            {
                                $window.location = url + projectid+'_'+serviceid+'_'+reApplyCounter+'.pdf';
                            }
                            //PHED
                            else if((serviceid==='c9570baf-a399-46e8-912b-b25f0d58066a') || (serviceid==='ccd073c3-e354-4722-90a7-71abaac3a036'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid+'&reApplyCounter='+reApplyCounter;
                            }
                            //MGD
                            else if((serviceid==='0f37cdd6-9816-4df2-89bf-40da4bd44a1c') || (serviceid==='dc98dff2-4efc-4638-9797-0c9c0f31a6c2')
                                || (serviceid==='fc45e0bb-0b60-44d4-ba14-0b85396cc653') || (serviceid==='62a65a72-c140-474e-9e05-8ed506d10db6')
                                || (serviceid==='79f8d127-577e-4140-ac89-7fb7a951904f') || (serviceid==='099ace9f-fb7f-4a75-bce2-343bb4e89261')
                                || (serviceid==='882c2e8c-f1e7-4a64-a4b1-fef2e053d7cb'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid+'&reApplyCounter='+reApplyCounter;
                            }
                            //DEPARTMENT OF AYUSH
                            else if((serviceid==='3468419f-d667-4abd-bf79-ae444b67ffa7') || (serviceid==='ca617a3d-048e-4684-8b67-6df84e8ae2a4') || (serviceid==='6e39ccec-1a2d-4f39-bf6d-e3b63f77dbb5') || (serviceid==='b04423c7-492a-4e00-90d0-e35573c6db2c')
                                || (serviceid==='f139928f-2c86-4412-8e9e-e528651eaeb2'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid+'&reApplyCounter='+reApplyCounter;
                            }
                            //Food & Drug
                            else if((serviceid==='f3264440-59b9-4069-a819-189a68e722da') || (serviceid==='6701d812-3e17-4ba3-97de-41dffa5c56b6') || (serviceid==='79714bde-edce-44e2-a911-04c2c6b90127') || (serviceid==='9d7d4fe7-7f0c-4650-93ce-18718d0cbf76') || (serviceid==='094a07bc-11d4-428c-95f3-e49d6a062d00'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid+'&reApplyCounter='+reApplyCounter;
                            }
                            //Food & Supply
                            else if((serviceid==='ee48492a-a335-4c26-98e9-b654240c1774') || (serviceid==='1c67a3b9-1396-491a-b82e-9afa16f34093') || (serviceid==='071a7ee8-0606-4583-b30b-7c761b9941a2') || (serviceid==='ed9e795c-ef58-4a57-8f66-8c814feccd74') || (serviceid==='c870e3a1-d080-4a38-8cff-5425c9e4454b') || (serviceid==='09efed7f-49a7-43cb-9c1f-1c86a5535ae0')
                                || (serviceid==='9a37e49e-8d6f-4c11-8e4b-0fe1dbd7ae1a'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid+'&reApplyCounter='+reApplyCounter;
                            }
                            //Information, Public Relations and Language	
                            else if((serviceid==='935dc4c7-e7c8-4398-a9ce-4bd5ab491476'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid+'&reApplyCounter='+reApplyCounter;
                            }
                            //Agriculuture Dept
                            else if((serviceid==='1af4cdaf-0c51-4e57-bb0a-6a2a77ccbfe7') || (serviceid==='54e8e70a-4ee6-4863-af7f-769f92f43796'))
                            {
                                $window.location = url + '?projectid='+projectid+'&serviceid='+serviceid+'&reApplyCounter='+reApplyCounter;
                            }
                        }, 1000)
                            .then(function() {
                                defer.resolve('success');
                            }, function() {
                                defer.reject('error');
                            });
                        return defer.promise;
                    }
                };
            }
        ]);
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Encryption', Encryption);

    Encryption.$inject = ['$resource'];

    function Encryption ($resource) {
        var resourceUrl =  'api/datewisedeptdashboard/:fromdate/:todate/:amount/:area/:caftype/:sectortype';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account'];

    function Principal ($q, Account) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate (identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority (authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority (authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function(){
                return false;
            });
        }

        function identity (force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen (account) {
                var iv = "a407e444cd6179be5ced97caf0ff11cb";
                var salt = "a826254e90f626b011eb21aca9a79b65";
                var keySize = 128;
                var iterationCount = 10000;
                var passPhrase = "NAimIodPNkqOyHQXmEpoFA==Sdty=jHY";
                var aesUtil = new AesUtil(keySize, iterationCount);
                var decryptedString = aesUtil.decrypt(salt, iv, passPhrase, account.data.encryptedAuthorities);
                account.data.authorities = decryptedString;
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
            }

            function getAccountCatch () {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated () {
            return _authenticated;
        }

        function isIdentityResolved () {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {

              var authority = attrs.hasAuthority.replace(/\s+/g, '');

                var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

                if (authority.length > 0) {
                    defineVisibility(true);

                    scope.$watch(function() {
                        return Principal.isAuthenticated();
                    }, function() {
                        defineVisibility(true);
                    });
                }

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'LoginService', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, LoginService, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            checkPassword: checkPassword,
            loginWithToken: loginWithToken,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register' || $rootScope.toState.name === 'social-auth')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }

        function loginWithToken(jwt, rememberMe) {
            return AuthServerProvider.loginWithToken(jwt, rememberMe);
        }

        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }

        function checkPassword (credentials, callback) {
            return AuthServerProvider.checkPassword(credentials)
                .then(function(result){
                    callback(result.data);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage', '$sessionStorage', '$q'];

    function AuthServerProvider ($http, $localStorage, $sessionStorage, $q) {
        var service = {
            getToken: getToken,
            login: login,
            loginWithToken: loginWithToken,
            storeAuthenticationToken: storeAuthenticationToken,
            logout: logout,
            checkPassword: checkPassword
        };

        return service;

        function getToken () {
            return $localStorage.authenticationToken || $sessionStorage.authenticationToken;
        }

        function login (credentials) {

            var data = {
                username: credentials.username,
                password: credentials.password,
                rememberMe: credentials.rememberMe
            };
            return $http.post('api/authenticate', data).success(authenticateSuccess);

            function authenticateSuccess (data, status, headers) {
                var bearerToken = headers('Authorization');
                if (angular.isDefined(bearerToken) && bearerToken.slice(0, 7) === 'Bearer ') {
                    var jwt = bearerToken.slice(7, bearerToken.length);
                    service.storeAuthenticationToken(jwt, credentials.rememberMe);
                    return jwt;
                }
            }
        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                this.storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }

        function storeAuthenticationToken(jwt, rememberMe) {
            if(rememberMe){
                $localStorage.authenticationToken = jwt;
            } else {
                $sessionStorage.authenticationToken = jwt;
            }
        }
        function logout () {
            delete $localStorage.authenticationToken;
            delete $sessionStorage.authenticationToken;
            // window.location.href = '/api/entity-locker/logout';

        }

        function checkPassword (credentials) {
            var data = {
                username: credentials.username,
                password: credentials.password
            };
            return $http.post('api/checkPassword', data);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account ($resource) {
        var service = $resource('api/account', {}, {
            'get': { method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function(response) {
                        // expose response
                        return response;
                    }
                }
            }
        });

        return service;
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceViewCafYearlyByElastic', ServiceViewCafYearlyByElastic);

    ServiceViewCafYearlyByElastic.$inject = ['$resource'];

    function ServiceViewCafYearlyByElastic ($resource) {
        var resourceUrl =  'api/servicedashboardcafsYearlyByElastic/departmentName/district/projectLevel/serviceId/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceViewCafYearly', ServiceViewCafYearly);

    ServiceViewCafYearly.$inject = ['$resource'];

    function ServiceViewCafYearly ($resource) {
        var resourceUrl =  'api/servicedashboardcafsYearly/:serviceid/:status/:department/:servicename';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceViewCafYearlyController', ServiceViewCafYearlyController);

    ServiceViewCafYearlyController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'ServiceViewCafYearly', 'TowerserviceNO','ServiceViewCafYearlyByElastic','DownloadServiceViewCafYearlyByElastic','DownloadCafCsv'];
    function ServiceViewCafYearlyController ($timeout, $scope, $stateParams, $uibModalInstance, ServiceViewCafYearly, TowerserviceNO, ServiceViewCafYearlyByElastic,DownloadServiceViewCafYearlyByElastic,DownloadCafCsv) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.clear = clear;
        vm.servicename=$stateParams.servicename;
        vm.status=$stateParams.status;
        vm.serviceid=$stateParams.serviceid;
        var initDate=new Date('05-01-2017');
        var totalTime=0;
        var totalCleared=0;
        vm.showDepartments=showDepartments;
        vm.departmentName=[];
        vm.downloadAllData = downloadAllData;

        vm.spiner= true;

        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
            /*appliedDate=new Date(result[i].appliedDate.toDateString());
            clearedDate=new Date(result[i].clearedDate.toDateString());
            dayDiff= (clearedDate - appliedDate)  / 1000 / 60 / 60 / 24;
*/
        loadAllCafs();
        function loadAllCafs() {
            var appliedDate;
            var clearedDate;
            var dayDiff;
            if (!$stateParams.departmentName) {
                vm.deptName = null;
            } else {
                vm.deptName = $stateParams.departmentName;
            }

            if (!$stateParams.district) {
                vm.districtName = null;
            } else {
                vm.districtName = $stateParams.district;
            }

            if (!$stateParams.projectLevel) {
                vm.levelfiled = null;
            } else {
                vm.levelfiled = $stateParams.projectLevel;
            }
            var data = {
                departmentName: vm.deptName,
                district: vm.districtName,
                projectLevel: vm.levelfiled,
                serviceId: $stateParams.serviceid,
                status: $stateParams.status,
                page: $scope.currentPage - 1,
                size: $scope.pageSize
            };
            Object.keys(data).forEach(function (k) {
                if (!data[k] && data[k] !== undefined) {
                    delete data[k];
                }
            });

            //   vm.dashboardcafs=ServiceViewCafYearly.query({serviceid:$stateParams.serviceid,status:$stateParams.status},function(result){
            //     vm.show=true;
            //     vm.spiner=false;
            //     console.log(result);
            // });
            vm.dashboardcafs = ServiceViewCafYearlyByElastic.get(data,
                function (result) {
                vm.show = true;
                vm.spiner = false;
            });
        }

        function downloadAllData() {
            DownloadServiceViewCafYearlyByElastic.query({
                    departmentName: vm.deptName,
                    district: vm.districtName,
                    projectLevel: vm.levelfiled,
                    serviceId: $stateParams.serviceid,
                    status: $stateParams.status
                },function (result) {
                console.log(result[0].status)

                DownloadCafCsv.download(result[0].status).then(function (success) {
                }, function (error) {
                });
            });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        }

        $scope.pageChangedHandler = function(num) {
            loadAllCafs();
        };

        function showDepartments(data) {
            TowerserviceNO.query({id:'1',projectdetailid:data.projectdetailid},function (result) {
                if(result.length===0){
                    vm.departmentName=[];
                    vm.departmentName[0] = "NA";
                }
                else {
                    vm.departmentName = result;
                }
            });

        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceDashboardYearlyByElatsic', ServiceDashboardYearlyByElatsic);

    ServiceDashboardYearlyByElatsic.$inject = ['$resource'];

    function ServiceDashboardYearlyByElatsic ($resource) {
        var resourceUrl =  'api/service-dashboard-statsYearly-elastic';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceDashboardYearlyByFilter', ServiceDashboardYearlyByFilter);

    ServiceDashboardYearlyByFilter.$inject = ['$resource'];

    function ServiceDashboardYearlyByFilter ($resource) {
        var resourceUrl =  'api/servicedashboardcafsYearlyFilters/departmentName/district/projectLevel';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('servicedashboardyearly', {
            parent: 'app',
            url: '/service-dashboard',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/servicedashboardyearly/servicedashboardyearly.html',
                    controller: 'DeptServiceDashboardYearlyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        }).state('servicedashboardyearlycafs', {
            parent: 'servicedashboardyearly',
            url: '/service-dashboard-yearly/{servicename}/{departmentName}/{district}/{projectLevel}/{serviceid}/{status}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/servicedashboardyearly/serviceviewcafsyearly.html',
                    controller: 'ServiceViewCafYearlyController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('servicedashboardyearly', null, { reload: 'servicedashboardyearly' });
                }, function() {
                    $state.go('servicedashboardyearly');
                });
            }]
        }).state('averagefee', {
            parent: 'servicedashboardyearly',
            url: '/averagefee-dashboard-yearly/{servicename}/{departmentName}/{district}/{projectLevel}/{serviceid}/{status}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/servicedashboardyearly/averagefeeyearly.html',
                    controller: 'AverageFeeYearlyController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('servicedashboardyearly', null, { reload: 'servicedashboardyearly' });
                }, function() {
                    $state.go('servicedashboardyearly');
                });
            }]
        }).state('newservicedashboardyearly', {
            parent: 'app',
            url: '/service-dashboard-new',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/servicedashboardyearly/newservicedashboardyearly.html',
                    controller: 'NewDeptServiceDashboardYearlyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        }).state('newservicedashboardyearlycafs', {
            parent: 'newservicedashboardyearly',
            url: '/new-service-dashboard-yearly/{servicename}/{departmentName}/{district}/{projectLevel}/{serviceid}/{status}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/servicedashboardyearly/newserviceviewcafsyearly.html',
                    controller: 'NewServiceViewCafYearlyController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('newservicedashboardyearly', null, { reload: 'newservicedashboardyearly' });
                }, function() {
                    $state.go('newservicedashboardyearly');
                });
            }]
        })
        ;
    }
})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DeptServiceDashboardYearlyController', DeptServiceDashboardYearlyController);

    DeptServiceDashboardYearlyController.$inject = ['$scope','$filter', 'Principal', 'LoginService', '$state', 'DeptServiceDashboard', 'DeptServiceStats','ServiceViewCaf','ServiceDashboardStats' ,'ServiceDashboardYearlyByElatsic','District','ServiceDashboardYearlyByFilter'];

    function DeptServiceDashboardYearlyController ($scope,$filter, Principal, LoginService, $state, DeptServiceDashboard, DeptServiceStats, ServiceViewCaf, ServiceDashboardStats ,ServiceDashboardYearlyByElatsic,District,ServiceDashboardYearlyByFilter) {
        var vm = this;
        vm.account = null;
        vm.districts = [];
        vm.departments =[];
        vm.filter = {};
        vm.deptName = null;
        vm.districtName = null;
        vm.levelfiled = null;
        vm.hideClear = false;
        $scope.CurrentDate = new Date();

        loadAll();
        function loadAll() {
        Principal.identity().then(function(account) {
            vm.account = account;
        });

        District.query(function(result) {
            vm.districts = result;
            vm.searchQuery = null;
        });


        // ServiceDashboardStats.query(function(result) {
            ServiceDashboardYearlyByElatsic.query(function(result) {
          vm.deptservicedashboard = result;
           vm.totalappliedservices=0;
           vm.totalrequiredservices=0;
           vm.totalpendingservices=0;
           vm.totalcompletedservices=0;
           vm.totalrejectedservices=0;
            for(var i=0;i<vm.deptservicedashboard.length;i++)
            {
              vm.totalappliedservices=vm.totalappliedservices + parseInt(vm.deptservicedashboard[i].applied);
              vm.totalrequiredservices=vm.totalrequiredservices+ parseInt(vm.deptservicedashboard[i].required);
              vm.totalpendingservices=vm.totalpendingservices+ parseInt(vm.deptservicedashboard[i].pending_total);
              vm.totalcompletedservices=vm.totalcompletedservices+ parseInt(vm.deptservicedashboard[i].cleared);
              vm.totalrejectedservices=vm.totalrejectedservices+ parseInt(vm.deptservicedashboard[i].rejected);
            }
           vm.searchQuery = null;
                vm.departments = [];

                angular.forEach(vm.deptservicedashboard, function(value, key){
                    if(vm.departments.indexOf(value.department_name) === -1){
                        if(value.department_name != "Communication and Connectivity Permissions"){
                            vm.departments.push(value.department_name);
                        }
                    }
                });
         });
        }

        vm.FilterWiseDat = function () {
            ServiceDashboardYearlyByFilter.query(vm.filter,function (result) {
                vm.hideClear = true;
                vm.deptservicedashboard =result;
            })
        };
        vm.clearFilter = function () {
            vm.filter ={};
            loadAll();
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('NewServiceViewCafYearlyByElastic', NewServiceViewCafYearlyByElastic);

    NewServiceViewCafYearlyByElastic.$inject = ['$resource'];

    function NewServiceViewCafYearlyByElastic ($resource) {
        var resourceUrl =  'api/newServicedashboardcafsYearlyByElastic/departmentName/district/projectLevel/serviceId/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewServiceViewCafYearlyController', NewServiceViewCafYearlyController);

    NewServiceViewCafYearlyController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'ServiceViewCafYearly', 'TowerserviceNO','NewServiceViewCafYearlyByElastic','DownloadCafCsv','NewDashboardDownloadServiceViewCafYearlyByElastic'];
    function NewServiceViewCafYearlyController ($timeout, $scope, $stateParams, $uibModalInstance, ServiceViewCafYearly, TowerserviceNO, NewServiceViewCafYearlyByElastic,DownloadCafCsv,NewDashboardDownloadServiceViewCafYearlyByElastic) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.clear = clear;
        vm.servicename=$stateParams.servicename;
        vm.status=$stateParams.status;
        vm.serviceid=$stateParams.serviceid;
        var initDate=new Date('05-01-2017');
        var totalTime=0;
        var totalCleared=0;
        vm.showDepartments=showDepartments;
        vm.departmentName=[];
        vm.downloadAllData = downloadAllData;

        vm.spiner= true;

        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
            /*appliedDate=new Date(result[i].appliedDate.toDateString());
            clearedDate=new Date(result[i].clearedDate.toDateString());
            dayDiff= (clearedDate - appliedDate)  / 1000 / 60 / 60 / 24;
*/
        loadAllCafs();
        function loadAllCafs() {
            var appliedDate;
            var clearedDate;
            var dayDiff;
            if (!$stateParams.departmentName) {
                vm.deptName = null;
            } else {
                vm.deptName = $stateParams.departmentName;
            }

            if (!$stateParams.district) {
                vm.districtName = null;
            } else {
                vm.districtName = $stateParams.district;
            }

            if (!$stateParams.projectLevel) {
                vm.levelfiled = null;
            } else {
                vm.levelfiled = $stateParams.projectLevel;
            }
            var data = {
                departmentName: vm.deptName,
                district: vm.districtName,
                projectLevel: vm.levelfiled,
                serviceId: $stateParams.serviceid,
                status: $stateParams.status,
                page: $scope.currentPage - 1,
                size: $scope.pageSize
            };
            Object.keys(data).forEach(function (k) {
                if (!data[k] && data[k] !== undefined) {
                    delete data[k];
                }
            });

            //   vm.dashboardcafs=ServiceViewCafYearly.query({serviceid:$stateParams.serviceid,status:$stateParams.status},function(result){
            //     vm.show=true;
            //     vm.spiner=false;
            //     console.log(result);
            // });
            vm.dashboardcafs = NewServiceViewCafYearlyByElastic.get(data,
                function (result) {
                vm.show = true;
                vm.spiner = false;
            });
        }

        function downloadAllData() {
            NewDashboardDownloadServiceViewCafYearlyByElastic.query({
                    departmentName: vm.deptName,
                    district: vm.districtName,
                    projectLevel: vm.levelfiled,
                    serviceId: $stateParams.serviceid,
                    status: $stateParams.status
                },function (result) {

                DownloadCafCsv.download(result[0].status).then(function (success) {
                    console.log(success);
                }, function (error) {
                    alert('error : ' + error);
                });
            });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        }

        $scope.pageChangedHandler = function(num) {
            loadAllCafs();
        };

        function showDepartments(data) {
            TowerserviceNO.query({id:'1',projectdetailid:data.projectdetailid},function (result) {
                if(result.length===0){
                    vm.departmentName=[];
                    vm.departmentName[0] = "NA";
                }
                else {
                    vm.departmentName = result;
                }
            });

        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('NewServiceDashboardYearlyByElatsic', NewServiceDashboardYearlyByElatsic);

    NewServiceDashboardYearlyByElatsic.$inject = ['$resource'];

    function NewServiceDashboardYearlyByElatsic ($resource) {
        var resourceUrl =  'api/new-service-dashboard-statsYearly-elastic';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDeptServiceDashboardYearlyController', NewDeptServiceDashboardYearlyController);

    NewDeptServiceDashboardYearlyController.$inject = ['$scope','$filter', 'Principal', 'LoginService', '$state', 'DeptServiceDashboard', 'DeptServiceStats','ServiceViewCaf','ServiceDashboardStats' ,'NewServiceDashboardYearlyByElatsic','District','ServiceDashboardYearlyByFilter'];

    function NewDeptServiceDashboardYearlyController ($scope,$filter, Principal, LoginService, $state, DeptServiceDashboard, DeptServiceStats, ServiceViewCaf, ServiceDashboardStats ,NewServiceDashboardYearlyByElatsic,District,ServiceDashboardYearlyByFilter) {
        var vm = this;
        vm.account = null;
        vm.districts = [];
        vm.departments =[];
        vm.filter = {};
        vm.deptName = null;
        vm.districtName = null;
        vm.levelfiled = null;
        vm.hideClear = false;
        $scope.CurrentDate = new Date();

        loadAll();
        function loadAll() {
        Principal.identity().then(function(account) {
            vm.account = account;
        });

        District.query(function(result) {
            vm.districts = result;
            vm.searchQuery = null;
        });


        // ServiceDashboardStats.query(function(result) {
            NewServiceDashboardYearlyByElatsic.query(function(result) {
          vm.deptservicedashboard = result;
           vm.totalappliedservices=0;
           vm.totalrequiredservices=0;
           vm.totalpendingservices=0;
           vm.totalcompletedservices=0;
           vm.totalrejectedservices=0;
            for(var i=0;i<vm.deptservicedashboard.length;i++)
            {
              vm.totalappliedservices=vm.totalappliedservices + parseInt(vm.deptservicedashboard[i].applied);
              vm.totalrequiredservices=vm.totalrequiredservices+ parseInt(vm.deptservicedashboard[i].required);
              vm.totalpendingservices=vm.totalpendingservices+ parseInt(vm.deptservicedashboard[i].pending_total);
              vm.totalcompletedservices=vm.totalcompletedservices+ parseInt(vm.deptservicedashboard[i].cleared);
              vm.totalrejectedservices=vm.totalrejectedservices+ parseInt(vm.deptservicedashboard[i].rejected);
            }
           vm.searchQuery = null;
                vm.departments = [];

                angular.forEach(vm.deptservicedashboard, function(value, key){
                    if(vm.departments.indexOf(value.department_name) === -1){
                        if(value.department_name != "Communication and Connectivity Permissions"){
                            vm.departments.push(value.department_name);
                        }
                    }
                });
         });
        }

        vm.FilterWiseDat = function () {
            ServiceDashboardYearlyByFilter.query(vm.filter,function (result) {
                vm.hideClear = true;
                vm.deptservicedashboard =result;
            })
        };
        vm.clearFilter = function () {
            vm.filter ={};
            loadAll();
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('NewDashboardDownloadServiceViewCafYearlyByElastic', NewDashboardDownloadServiceViewCafYearlyByElastic);

    NewDashboardDownloadServiceViewCafYearlyByElastic.$inject = ['$resource'];

    function NewDashboardDownloadServiceViewCafYearlyByElastic($resource) {
        var resourceUrl = 'api/findListByStatusByElasticForNewDashboard/departmentName/district/projectLevel/serviceId/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    return data;
                }
            },
            'update': { method: 'PUT' },
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DownloadServiceViewCafYearlyByElastic', DownloadServiceViewCafYearlyByElastic);

    DownloadServiceViewCafYearlyByElastic.$inject = ['$resource'];

    function DownloadServiceViewCafYearlyByElastic($resource) {
        var resourceUrl = 'api/servicedashboardcafsYearlyListByElastic/departmentName/district/projectLevel/serviceId/status';
        var averageFeeUrl = 'api/servicedashboardcafsYearlyListByElasticForAverageFee/departmentName/district/projectLevel/serviceId/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    return data;
                }
            },
            'update': { method: 'PUT' },
            'getAverageFee': {
                method: 'GET',
                url: averageFeeUrl,
                transformResponse: function(data) {
                    return data; // Process the response if needed
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DownloadCafCsv', ['$q', '$timeout', '$window',
            function($q, $timeout, $window, $http) {
                return {
                    download: function(serverfilename) {
                        var defer = $q.defer();
                        $timeout(function() {
                            $window.location = 'api/downloadcafattachment?serverfilename='+serverfilename;
                        }, 1000)
                            .then(function() {
                                defer.resolve('success');
                            }, function() {
                                defer.reject('error');
                            });
                        return defer.promise;
                    }
                };
            }
        ]);
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('AveragefeeYearlyByElatsic', AveragefeeYearlyByElatsic);

    AveragefeeYearlyByElatsic.$inject = ['$resource'];

    function AveragefeeYearlyByElatsic($resource) {
        var resourceUrl = 'api/averagefee-dashboard-statsYearly-elastic/departmentName/district/projectLevel/serviceId/status';
        var averageFeeUrl = 'api/servicedashboardcafsYearlyListByElasticForAverageFee/departmentName/district/projectLevel/serviceId/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    return angular.fromJson(data);
                }
            },
            'update': { method: 'PUT' },
            'getAverageFee': {
                method: 'GET',
                isArray: true,
                url: averageFeeUrl,
                transformResponse: function(data) {
                    // Parse the response and ensure it returns an array
                    var parsedData = angular.fromJson(data);
                    if (!Array.isArray(parsedData)) {
                        return [parsedData]; // Wrap the object in an array if it isn't already
                    }
                    return parsedData;
                }
            }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('AverageFeeYearlyController', AverageFeeYearlyController);

    AverageFeeYearlyController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'ServiceViewCafYearly', 'TowerserviceNO','ServiceViewCafYearlyByElastic','DownloadServiceViewCafYearlyByElastic','DownloadCafCsv', 'AveragefeeYearlyByElatsic'];
    function AverageFeeYearlyController ($timeout, $scope, $stateParams, $uibModalInstance, ServiceViewCafYearly, TowerserviceNO, ServiceViewCafYearlyByElastic,DownloadServiceViewCafYearlyByElastic,DownloadCafCsv, AveragefeeYearlyByElatsic) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.clear = clear;
        vm.servicename=$stateParams.servicename;
        vm.status=$stateParams.status;
        vm.serviceid=$stateParams.serviceid;
        var initDate=new Date('05-01-2017');
        var totalTime=0;
        var totalCleared=0;
        vm.showDepartments=showDepartments;
        vm.departmentName=[];
        vm.downloadAllData = downloadAllData;

        vm.spiner= true;

        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        /*appliedDate=new Date(result[i].appliedDate.toDateString());
        clearedDate=new Date(result[i].clearedDate.toDateString());
        dayDiff= (clearedDate - appliedDate)  / 1000 / 60 / 60 / 24;
*/
        loadAllCafs();
        function loadAllCafs() {
            var appliedDate;
            var clearedDate;
            var dayDiff;
            if (!$stateParams.departmentName) {
                vm.deptName = null;
            } else {
                vm.deptName = $stateParams.departmentName;
            }

            if (!$stateParams.district) {
                vm.districtName = null;
            } else {
                vm.districtName = $stateParams.district;
            }

            if (!$stateParams.projectLevel) {
                vm.levelfiled = null;
            } else {
                vm.levelfiled = $stateParams.projectLevel;
            }
            var data = {
                departmentName: vm.deptName,
                district: vm.districtName,
                projectLevel: vm.levelfiled,
                serviceId: $stateParams.serviceid,
                status: $stateParams.status,
                page: $scope.currentPage - 1,
                size: $scope.pageSize
            };
            Object.keys(data).forEach(function (k) {
                if (!data[k] && data[k] !== undefined) {
                    delete data[k];
                }
            });

            //   vm.dashboardcafs=ServiceViewCafYearly.query({serviceid:$stateParams.serviceid,status:$stateParams.status},function(result){
            //     vm.show=true;
            //     vm.spiner=false;
            //     console.log(result);
            // });
            vm.dashboardcafs = AveragefeeYearlyByElatsic.get(data,
                function (result) {
                    vm.show = true;
                    vm.spiner = false;
                });
        }

        vm.getTotalPhaseFee = function(averageFeeApiList) {
            return averageFeeApiList.reduce(function(total, feeApi) {
                return total + feeApi.phasefee;
            }, 0);
        };

        function downloadAllData() {
            AveragefeeYearlyByElatsic.getAverageFee({
                departmentName: vm.deptName,
                district: vm.districtName,
                projectLevel: vm.levelfiled,
                serviceId: $stateParams.serviceid,
                status: $stateParams.status
            }, function(result) {
                try {
                    // Check if result is an array and has at least one item
                    if (Array.isArray(result) && result.length > 0) {
                        // Access the first object's status property
                        var filename = result[0].status; // This gets the status value from the first object in the array

                        // Call the download function with the filename
                        DownloadCafCsv.download(filename).then(function(success) {
                            console.log(success);
                        }, function(error) {
                            alert('error : ' + error);
                        });
                    } else {
                        alert('No data received or result is empty.');
                    }
                } catch (e) {
                    console.error("Error processing response:", e);
                }
            }, function(error) {
                console.error("Error fetching data:", error);
            });
        }



        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        }

        $scope.pageChangedHandler = function(num) {
            loadAllCafs();
        };

        function showDepartments(data) {
            TowerserviceNO.query({id:'1',projectdetailid:data.projectdetailid},function (result) {
                if(result.length===0){
                    vm.departmentName=[];
                    vm.departmentName[0] = "NA";
                }
                else {
                    vm.departmentName = result;
                }
            });

        }

    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('withdrawDialogController', withdrawDialogController);

    withdrawDialogController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService', 'projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServiceReportInfoForClearance', 'TowerRejectionReason', 'RejectedProjectServiceLog', 'ReasonCategory','TowerRejectionReasonByCategory'];
    function withdrawDialogController ($timeout, $scope, $stateParams, $uibModalInstance,projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail,ProjectServiceReportInfoForClearance, TowerRejectionReason, RejectedProjectServiceLog, ReasonCategory, TowerRejectionReasonByCategory) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService=projectService;
//        vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({department:vm.projectService.departmentName,projectid:vm.projectService.projectid,service:vm.projectService.serviceName});
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        $scope.file = {};
        vm.clear = clear;
        // vm.declineService = declineService;
        vm.withdrawService = withdrawService;
        vm.confirmWithdraw = confirmWithdraw;
        vm.rejectedProjectServiceLog = {};
       // vm.getReasons = getReasons;
        //vm.getRejectionReason = getRejectionReason;
        vm.selectedCategory = {};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.rejectionReasons = [];
        vm.reasonCategories = [];

        loadAll();

        function loadAll() {
            ReasonCategory.query(function(result) {
                vm.reasonCategories = result;
                vm.searchQuery = null;
            });
        }



         function confirmWithdraw() {
            if (window.confirm("Are you sure to withdraw the application?")) {
               this.withdrawService();
            }
        }


        function withdrawService(){
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
          //  vm.projectServiceLog.reasonCategory = vm.selectedCategory.category;
            vm.projectServiceLog.actionTaken="Withdraw";

            if(angular.isDefined(vm.projectAttachemnt.file)){
                var fileNameArray = vm.projectAttachemnt.file.name.split(".");
                if ((fileNameArray.length == 2)) {
                    if(fileNameArray[0] != ""){
                        ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);

                    }
                    else {
                        alert("Invalid File Name");
                    }
                }
                else{
                    alert("Please select correct file format")
                }
            }
            else {
                ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);

            }


            // ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="Withdraw";
            vm.projectService.rejectionDate=result.commentDate;
            vm.rejectedProjectServiceLog.projectServiceLogId = projectServiceLogid;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
            RejectedProjectServiceLog.save(vm.rejectedProjectServiceLog);

        }
//        function onUpdateProjectServiceSuccess(result)
//        {
//            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
//            vm.projectservicereportinfo.status='Declined';
//            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
//        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Withdraw Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

//        function onUpdateProjectServiceReportInfoError()
//        {
//            vm.isSaving = false;
//        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('verifyPaymentController', verifyPaymentController);

    verifyPaymentController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'projectService', 'ProjectServicePaymentDetailsByProjectAndService','Projectservicedetail','projectServiceLog','ProjectServiceLogUpdated'];
    function verifyPaymentController ($timeout, $scope, $stateParams, $uibModalInstance, projectService, ProjectServicePaymentDetailsByProjectAndService,Projectservicedetail,projectServiceLog,ProjectServiceLogUpdated) {
        var vm = this;
        vm.clear = clear;
        vm.projectService=projectService;
        vm.projectServiceLog=projectServiceLog;
        vm.verifyPayment = verifyPayment;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        loadAllPayments();

        function loadAllPayments() {
            vm.projectServicePaymentDetails=ProjectServicePaymentDetailsByProjectAndService.query({projectid: vm.projectService.projectid,serviceid: vm.projectService.serviceid});
        }

        function verifyPayment(){
            vm.projectService.isPaymentVerified=true;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceDetailSuccess,onUpdateProjectServiceDetailError);
        }
        function onUpdateProjectServiceDetailSuccess(result)
        {
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="PaymentVerified";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
        function onUpdateProjectServiceDetailError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {}
    }

})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('verifyOtherPaymentController', verifyOtherPaymentController);

    verifyOtherPaymentController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'projectService','projectServiceLog','AssignServiceFee','ProjectServicePaymentDetailsByProjectAndService'];
    function verifyOtherPaymentController ($timeout, $scope, $stateParams, $uibModalInstance, projectService,projectServiceLog,AssignServiceFee,ProjectServicePaymentDetailsByProjectAndService) {
        var vm = this;
        vm.clear = clear;
        vm.projectService=projectService;
        vm.projectServiceLog=projectServiceLog;
        vm.assignFeeDetail=[];

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        loadAllPayments();

        function loadAllPayments() {
          vm.assignFeeDetail=ProjectServicePaymentDetailsByProjectAndService.query({projectid: vm.projectService.projectid,serviceid: vm.projectService.serviceid});
        }

        }
        })();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('undoRejectDialogController', undoRejectDialogController);

    undoRejectDialogController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService', 'projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServiceReportInfoForClearance','CheckContentFile'];
    function undoRejectDialogController ($timeout, $scope, $stateParams, $uibModalInstance, projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail,ProjectServiceReportInfoForClearance,CheckContentFile) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService=projectService;
        vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({department:vm.projectService.departmentName,projectid:vm.projectService.projectid,service:vm.projectService.serviceName});
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        $scope.file = {};
        vm.clear = clear;
        vm.undoRejectService = undoRejectService;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function undoRejectService(){
            console.log(projectAttachemnt.file);
            if(angular.isDefined(projectAttachemnt.file)){
                if(CheckContentFile.checkFile(projectAttachemnt.file.name)){
                    undoService();
                }
                else{
                    alert("Invalid File");
                }
            }
            else{
                undoService();
            }

        }

        function undoService() {
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="Undo-Rejected";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }

        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="Pending";
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            vm.projectservicereportinfo.status='Undo-Rejected';
            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
        }
        function onUpdateProjectServiceReportInfoSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Undo-Rejected Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onUpdateProjectServiceReportInfoError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('servicePaymentController', servicePaymentController);

    servicePaymentController.$inject = ['$window', '$timeout','$scope','$stateParams','$uibModalInstance','projectService','projectServicePayment','projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServicePaymentDetails','Payment'];
    function servicePaymentController ($window, $timeout, $scope, $stateParams, $uibModalInstance,projectService, projectServicePayment, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail, ProjectServicePaymentDetails,Payment) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectServicePayment = projectServicePayment;
        vm.projectService = projectService;
        vm.projectServicePayment.paymentMade = vm.projectService.serviceFee;
        vm.paymentparameters = Payment.get({projectid:vm.projectService.projectid,amount:vm.projectService.serviceFee,serviceid:vm.projectService.serviceid});

        vm.doPayment=doPayment;
        var projectServiceLogid=null;
        var projectAttachmentResultObject=null;
        vm.clear = clear;
        vm.makePayment = makePayment;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function doPayment()
        {
            var paymenturlwithparams='https://test.payu.in/_payment/firstname='+vm.paymentparameters.firstname+'&surl='+vm.paymentparameters.surl+'&phone='+vm.paymentparameters.phone+'&key='+vm.paymentparameters.key+'&hash='+vm.paymentparameters.hash;
            console.log(paymenturlwithparams);
            $window.location = paymenturlwithparams;
        }

        function makePayment(){
            vm.projectServicePayment.projectid=vm.projectService.projectid;
            vm.projectServicePayment.serviceid=vm.projectService.serviceid;
            ProjectServicePaymentDetails.save(vm.projectServicePayment,onServicePaymentSaveSuccess,onServicePaymentSaveError);
        }
        function onServicePaymentSaveSuccess(result)
        {
            alert('servicepaymentsaved');
            $scope.$emit('investhryApp:projectServicePaymentDetailsUpdate', result);
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="FeePaid";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
        function onServicePaymentSaveError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments
            vm.projectService.isPaymentMade=true;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Service Payment Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('serviceLogController', serviceLogController);

    serviceLogController.$inject = ['$timeout', '$scope', '$state','$stateParams', '$uibModalInstance', '$filter', 'serviceLogList','downloadService','service','DownloadExternalServiceFiles','projectService','Rating', 'Principal', 'Nmatoken', 'Applicationstatus', 'DepartmentService'];
    function serviceLogController ($timeout, $scope, $state ,$stateParams, $uibModalInstance, $filter, serviceLogList, downloadService,service,DownloadExternalServiceFiles,projectService,Rating, Principal, Nmatoken, Applicationstatus, DepartmentService) {
        var vm = this;
        vm.clear = clear;
        vm.downloadFile=downloadFile;
        vm.ServiceLog = serviceLogList;
        vm.projectService=projectService;
        vm.service=service;
        vm.pdfconverter= pdfconverter;
        vm.actionLabel= actionLabel;
        vm.commentText= commentText;
        vm.downFile= downFile;
        vm.saveRating= saveRating;
        vm.rating = {
            isFeeManuallySubmit: '',
            isDocPhysicallySubmit: '',
            isApprovalOnTime: '',
            isCertificateDownload: '',
            isPhysicallyVisit: ''
        };
        vm.rating.rating ="Excellent";
        vm.userFile= userFile;
        vm.rating.serviceId=$stateParams.serviceid;
        vm.rating.projectId=$stateParams.projectid;
        vm.rating.id= $stateParams.projectserviceid;


        getAccount();
        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
            })
        }

        var ACTION_LABELS = {
            Rejected: 'Deactivated',
            Declined: 'Rejected',
            MarkedRequired: 'Required',
            ServiceFormEdited: 'Service Form Filled',
            OpenComment: 'Comment'
        };

        function actionLabel (servicelog) {
            return ACTION_LABELS[servicelog.actionTaken] || servicelog.actionTaken || '';
        }

        function commentText (servicelog) {
            if (servicelog.comments === 'MarkedRequired') {
                return 'The Investor has indicated his desire for this service';
            }
            return servicelog.comments || '';
        }

        // The log is written as PDF text rather than screenshotted: a rasterised log
        // longer than a few dozen rows overflows the browser's maximum canvas size,
        // which yields a PDF of blank pages.
        function pdfconverter () {
            var margin = 40;
            var doc = new window.jspdf.jsPDF({ unit: 'pt', format: 'letter', orientation: 'landscape' });
            var pageWidth = doc.internal.pageSize.getWidth();
            var cursorY = margin + 4;

            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.text('Service Log', margin, cursorY);
            cursorY += 22;

            doc.setFontSize(12);
            var titleLines = doc.splitTextToSize(vm.service.serviceName || '', pageWidth - 2 * margin);
            doc.text(titleLines, pageWidth / 2, cursorY, { align: 'center' });
            cursorY += titleLines.length * 15;

            doc.setFont(undefined, 'normal');
            doc.setFontSize(10);
            if (vm.tokenFound && vm.nmatoken) {
                cursorY += 6;
                doc.text('Unique Id: ' + (vm.nmatoken.cafpin || ''), margin, cursorY);
                doc.text('Token: ' + (vm.nmatoken.nmatoken || ''), pageWidth - margin, cursorY, { align: 'right' });
                cursorY += 8;
            }

            var logs = $filter('orderBy')(vm.ServiceLog, '-commentDate') || [];
            var rows = logs.map(function (servicelog) {
                return [
                    actionLabel(servicelog),
                    $filter('date')(servicelog.commentDate, 'dd-MM-yyyy') || '',
                    servicelog.commentByUserLogin || '',
                    commentText(servicelog),
                    servicelog.rejectionReason || '',
                    servicelog.reasonCategory || '',
                    servicelog.fileName ? 'Attached' : ''
                ];
            });

            doc.autoTable({
                startY: cursorY + 12,
                margin: { top: margin, right: margin, bottom: margin, left: margin },
                head: [['Action Taken', 'Date', 'Action By', 'Comments', 'Rejection Reason', 'Reason Category', 'Attachment']],
                body: rows,
                styles: { fontSize: 9, cellPadding: 4, overflow: 'linebreak', valign: 'top' },
                headStyles: { fillColor: [123, 76, 175], textColor: 255 },
                columnStyles: {
                    0: { cellWidth: 72 },
                    1: { cellWidth: 60 },
                    2: { cellWidth: 80 },
                    4: { cellWidth: 95 },
                    5: { cellWidth: 95 },
                    6: { cellWidth: 60 }
                }
            });

            var pageCount = doc.internal.getNumberOfPages();
            for (var page = 1; page <= pageCount; page++) {
                doc.setPage(page);
                doc.setFontSize(9);
                doc.text('Page ' + page + ' of ' + pageCount,
                    pageWidth - margin, doc.internal.pageSize.getHeight() - 20, { align: 'right' });
            }

            doc.save('ServiceLog_' + (vm.service.serviceName || 'service').replace(/[^a-zA-Z0-9]+/g, '_') + '.pdf');
        }

        if (vm.projectService.serviceid==='bdb451cb-f12b-4352-8360-e6e3a715386f'){
            vm.nmatoken=Nmatoken.get({id:vm.projectService.id},function () {
                vm.tokenFound=true;
            });
            vm.applicationstatus=Applicationstatus.get({id:vm.projectService.id},function () {
                vm.nocFound=true;
            });
        }

        $scope.isDateExceed=function()
        {
         if(vm.projectService.isDateExceeded===true){
            return true;
         }
         else{
            return false;
         }
        };

        var isdateexceeded = $scope.isDateExceed();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.isServiceInList=function() {
           return vm.projectService.isIntegrated === true;
        };

        function downFile(servicelog) {
            vm.reApplyCounter = servicelog.reApplyCounter;
            vm.dwnFile = servicelog.fileName;
            vm.act = servicelog.actionTaken;
            downloadFile();
        }

        function userFile(servicelog){
            vm.reApplyCounter = servicelog.reApplyCounter;
            vm.dwnFile = servicelog.fileName;
            vm.act = servicelog.actionTaken;
            if(vm.act === "Cleared"){

                Rating.get({id: $stateParams.projectserviceid}, onGetSuccess, onGetError)
            }
            else {
                downloadFile();
            }
        }

        function onGetSuccess(){
            downloadFile();
        }

        function onGetError(){
            $("#ratings").modal('show');
        }

        function saveRating() {
            vm.isSaving = true;
            vm.rating.serviceId=$stateParams.serviceid;
            vm.rating.projectId=$stateParams.projectid;
            vm.rating.id= $stateParams.projectserviceid;
           Rating.update(vm.rating);
          downloadFile();
          $("#ratings").modal('hide');
        }

        function downloadFile()
        {
            if(($scope.isServiceInList()) && (vm.act!=='OpenComment'))
            {
                if(isdateexceeded){
                    downloadExt();
                }
                else {
                    if(vm.reApplyCounter > 1){
                        downloadExt();
                    }
                    else {
                        downloadHEPC();
                    }
                }
            }
            else
            {
                downloadHEPC();
            }
        }

        function downloadHEPC() {
            downloadService.download(vm.dwnFile)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
            });
        }

        function downloadExt() {
            DepartmentService.get({id: $stateParams.serviceid}, function (result) {
                if(result.downloadUrl == null){
                    alert("Download URL not found! Kindly contact concerned department.");
                    return;
                }
                DownloadExternalServiceFiles.download($stateParams.projectid, $stateParams.serviceid, vm.reApplyCounter, result.downloadUrl);
            });
        }
    }
})();



(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('serviceFormFilledController', serviceFormFilledController);

    serviceFormFilledController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'projectService', 'serviceFormFieldDataCollection','ServiceFormAttachments','downloadserviceformattachment','DepartmentService', 'Project'];
    function serviceFormFilledController ($timeout, $scope, $stateParams, $uibModalInstance, projectService, serviceFormFieldDataCollection,ServiceFormAttachments,downloadserviceformattachment,DepartmentService, Project) {
        var vm = this;
        vm.clear = clear;
        vm.projectService= projectService;
        vm.downloadFile=downloadFile;
        vm.pdfconverter= pdfconverter;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function pdfconverter () {
            var element = document.getElementById('pdf_data');
            html2pdf(element,{
                margin: 4
            });
        }


        function clear ()
        {
            $uibModalInstance.dismiss('cancel');
        }
        function downloadFile(serverfilename,downloadfilename)
        {
            downloadserviceformattachment.download(serverfilename,downloadfilename)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }

        vm.departmentservice= DepartmentService.get({id:vm.projectService.serviceid});
        loadServiceFormFields();
        function loadServiceFormFields() {
            vm.serviceFormFieldData= serviceFormFieldDataCollection.query({serviceid:vm.projectService.serviceid, projectid:vm.projectService.projectid});
            vm.serviceformattachments=ServiceFormAttachments.query({id:"1",serviceid:vm.projectService.serviceid, projectid:vm.projectService.projectid});
            vm.project = Project.get({id:vm.projectService.projectid});
        }

    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('serviceFormController', serviceFormController);

   serviceFormController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService','projectServiceFormFieldData','projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','Projectserviceformfielddata','serviceFormFieldDataCollection','ServiceFormAttachments','DepartmentService','Serviceformdocs','downloadserviceformattachment','Project','CheckContent','NewHomeProjectServiceDetails'];
   function serviceFormController ($timeout, $scope, $stateParams, $uibModalInstance,projectService,projectServiceFormFieldData, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail, Projectserviceformfielddata,serviceFormFieldDataCollection,ServiceFormAttachments,DepartmentService,Serviceformdocs,downloadserviceformattachment, Project,CheckContent,NewHomeProjectServiceDetails) {
        var vm = this;
        vm.download_appendix = download_appendix;

        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectServiceFormFieldData=projectServiceFormFieldData;
        vm.projectService = projectService;
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        var formfielddataObjectArrayLength = 0;
        var formfieldCount = 0;
        var saveLogFlag = false;
        vm.clear = clear;
        vm.saveAsDraft=saveAsDraft;
        vm.saveFormFieldData = saveFormFieldData;
        vm.downloadFile=downloadFile;
        vm.isSavedDraft=false;
        vm.doubleextension = true;
        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        show();


        function show(){
         switch (vm.projectService.serviceid) {
            case '58d75fd4-f360-4931-a484-ff9be0adc12c':
                vm.show=true;
                break;
            case '5f8e0757-e88b-4ef1-bb15-00a9e984b9b1':
                vm.show=true;
                break;
            case '741f0f60-cf69-4659-8b19-19d96ffe0103':
            vm.show=true;
                break;
             case 'fc1b1635-d3dc-4d30-a5fd-5abf6381594d':
                 vm.show=true;
                 break;
             case '6f81801c-59c6-4773-9f37-a5d81172a1bf':
                 vm.show=true;
                 break;
            default:
            vm.show=false;
         }
        }

        function download_appendix() {
          downloadserviceformattachment.download('Appendix7.docx','Appendix7.docx');
        }

        function clear()
        {
             $uibModalInstance.dismiss('cancel');
        }

        vm.departmentservice= DepartmentService.get({id:vm.projectService.serviceid});
        Serviceformdocs.query({id:"1",serviceid:vm.projectService.serviceid},function(result) {
            vm.serviceformdocs = result;
            vm.searchQuery = null;
        });

        Project.get({ id : vm.projectService.projectid }, function(result){
            vm.project = result;
        });


        loadServiceFormFields();
        function loadServiceFormFields() {
            vm.serviceFormFieldData = serviceFormFieldDataCollection.query({serviceid:vm.projectService.serviceid, projectid:vm.projectService.projectid});
        }


        var combineFilledForm="";
        function saveFormFieldData()
        {
            vm.isSaving = true;
            var vmlength = vm.serviceFormFieldData.length;
            formfielddataObjectArrayLength = vmlength;
            formfieldCount = 0;
            for(var i= 0; i<vmlength;i++)
            {
                var data = vm.serviceFormFieldData[i];
                combineFilledForm=combineFilledForm + vm.serviceFormFieldData[i].formfieldvalue+" | ";
                data.projectid = vm.projectService.projectid;
                if (data.id !== null)
                {
                    Projectserviceformfielddata.update(data, onSaveServiceFormFieldDataSuccess, onSaveServiceFormFieldDataError);
                } else
                {
                    Projectserviceformfielddata.save(data, onSaveServiceFormFieldDataSuccess, onSaveServiceFormFieldDataError);
                }
            }
             for( var j = 0; j < vm.fileattach.length; j++ ) {
                 if(vm.fileattach[j].isSaved===false)
                  {
                    vm.fileattach[j].isSaved=true;
                  }
                  ServiceFormAttachments.update(vm.fileattach[j],onUpdatefieldServiceFormAttachmentsSuccess);
             }
        }
        function onUpdatefieldServiceFormAttachmentsSuccess()
        {}
        vm.fileattach = ServiceFormAttachments.query({id:"1", projectid:vm.projectService.projectid, serviceid:vm.projectService.serviceid});
        vm.addfileattachment=addfileattachment;
        vm.addfileattachment5G=addfileattachment5G;

        function addfileattachment()
        {
            if (angular.isDefined(vm.serviceformfile.name)) {
                var fileNameArray = vm.serviceformfile.name.split(".");
                var fileextension = "";

                if ((fileNameArray.length < 3)) {
                    if (fileNameArray[0] != "") {
                        if ((fileNameArray.length > 1)) {
                            fileextension = fileNameArray[(fileNameArray.length - 1)];
                        }
                        var inputFileName = vm.serviceformattachment.description;
                        if (fileextension !== "") {
                            inputFileName = inputFileName + "." + fileextension;
                        }

                        vm.serviceformattachment.isSaved = false;
                        vm.serviceformattachment.downloadfilename = inputFileName;
                        vm.serviceformattachment.clientfilename = vm.serviceformfile.name;
                        vm.serviceformattachment.projectID = vm.projectService.projectid;
                        vm.serviceformattachment.serviceID = vm.projectService.serviceid;
                        ServiceFormAttachments.save(vm.serviceformattachment, onSaveServiceFormAttachmentsSuccess);

                    }
                    else {
                        alert("Invalid File Name");
                    }

                }
                else {
                    alert("Please select correct file format");
                    vm.doubleextension = false;

                }
            }
            else {
                alert("Please Select a file first");
            }
        }

       function addfileattachment5G()
       {

           if (angular.isDefined(vm.serviceformfile5G.name)) {
               var fileNameArray = vm.serviceformfile5G.name.split(".");
               var fileextension = "";

               if ((fileNameArray.length < 3)) {
                   if (fileNameArray[0] != "") {
                       if ((fileNameArray.length > 1)) {
                           fileextension = fileNameArray[(fileNameArray.length - 1)];
                       }
                       var inputFileName = "5G Execl";
                       if (fileextension !== "") {
                           inputFileName = inputFileName + "." + fileextension;
                       }

                       vm.serviceformattachment.isSaved = false;
                       vm.serviceformattachment.downloadfilename = inputFileName;
                       vm.serviceformattachment.clientfilename = vm.serviceformfile5G.name;
                       vm.serviceformattachment.projectID = vm.projectService.projectid;
                       vm.serviceformattachment.serviceID = vm.projectService.serviceid;
                       ServiceFormAttachments.save(vm.serviceformattachment, onSaveServiceFormAttachmentsSuccess);

                   }
                   else {
                       alert("Invalid File Name");
                   }

               }
               else {
                   alert("Please select correct file format");
                   vm.doubleextension = false;

               }
           }
           else {
               alert("Please Select a file first");
           }
       }



       function onSaveServiceFormAttachmentsSuccess (result)
        {
            var filename = result.id;
            var file =vm.serviceformfile;
            FileManagement.saveFile(file,filename);
            var fileNameArray = vm.serviceformfile.name.split(".");
                var fileextension="";
                if((fileNameArray.length>1))
                {
                    fileextension=fileNameArray[(fileNameArray.length-1)];
                }
                var inputFileName=result.id;
                if(fileextension!=="")
                {
                    inputFileName=inputFileName+"."+fileextension;
                }
                result.serverfilename=inputFileName;
                ServiceFormAttachments.update(result,onUpdateServiceFormAttachmentsSuccess);

        }
        function onUpdateServiceFormAttachmentsSuccess(result)
        {

            vm.fileattach.push(result);
            vm.fileattachment={};
            vm.serviceformattachment.description="";
            $('#browsefile').val('');
            vm.serviceformfile = {};

        }
        vm.removeRawRow = function(id)
        {
             ServiceFormAttachments.delete({id: id});
             var index = -1;
             var comArray =eval(vm.fileattach);
             for( var i = 0; i < comArray.length; i++ )
             {
                 if( comArray[i].id=== id)
                 {
                     index = i;
                     break;
                 }
             }
             vm.fileattach.splice( index, 1 );
        }
        function onSaveServiceFormFieldDataSuccess(result)
        {
            onServiceFormFieldDataSettled(result);
        }
        function onSaveServiceFormFieldDataError()
        {
            onServiceFormFieldDataSettled();
        }
        /**
         * The log - and with it the update of the application - is only written once
         * every field of the form came back. The server reads the filled form to
         * decide whether the application can be acknowledged straight away, so it
         * must not be updated while some of the fields are still in flight.
         */
        function onServiceFormFieldDataSettled(result)
        {
            formfieldCount++;
            if(!saveLogFlag && formfieldCount >= formfielddataObjectArrayLength)
            {
                saveLogFlag = true;
                saveProjectServiceLog(result);
            }
        }
        function saveProjectServiceLog(result){
            if (vm.isSavedDraft===true){
                $uibModalInstance.close(result);
                vm.isSaving = false;
                return;
            }
            $scope.$emit('investhryApp:projectserviceformfielddataUpdate', result);
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.comments=vm.projectServiceLog.comments + " | " +combineFilledForm;
            vm.projectServiceLog.actionTaken="ServiceFormEdited";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments="Service form edited";
            vm.projectService.formFilledStatus=true;
            // Says that this update is the submit of the form itself - the server issues
            // the acknowledgement of an intimated tower on it, and on nothing else.
            vm.projectService.serviceFormSubmitted=true;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            NewHomeProjectServiceDetails.query({projectServiceDetailId: vm.projectService.id, projectId: vm.projectService.projectid, serviceId: vm.projectService.serviceid}, function () {
                console.log('success');
            }, function (error) {
                console.log(error);
            });
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Service Form Field Data Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function downloadFile(serverfilename,downloadfilename)
        {
            downloadserviceformattachment.download(serverfilename,downloadfilename)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }

        function saveAsDraft() {
            vm.isSavedDraft=true;
            saveFormFieldData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
         .state("aai-state",{
                parent: 'constructionpermit',
                url: '/aai/{CPid}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/entities/aai/aai-dialog.html',
                        controller: 'AaiDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            height_clearance: null,
                            nameOfAplicant: null,
                            addressOfApplicant: null,
                            mobile_no: null,
                            email_id: null,
                            nameOfOwner: null,
                            addressOfCommunication: null,
                            typeOfStructure: null,
                            usesOfStructure: null,
                            siteDescription: null,
                            sizeOfPlot: null,
                            state: null,
                            areaName: null,
                            latitude1: null,
                            latitude2: null,
                            latitude3: null,
                            longitude1: null,
                            longitude2: null,
                            longitude3: null,
                            siteElevation: null,
                            buildingHeight: null,
                            maxSiteElevation: null,
                            question1: null,
                            question2: null,
                            question3: null,
                            file1: null,
                            city: null,
                            id: null
                        };
                    }
                }
            })
         .state("aai-detailPage",{
                parent: 'constructionpermit',
                url: '/aaiDetail/{aaiId}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/aai-detailPage.html',
                        controller: 'aaiDetailPageController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
         .state("nma-detailPage",{
                parent: 'constructionpermit',
                url: '/nmaDetail/{nmaId}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/nma-detailPage.html',
                        controller: 'nmaDetailPageController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
         .state("ffs",{
                parent: 'constructionpermit',
                url: '/ffs',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/ffs.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
         .state("twc",{
                parent: 'constructionpermit',
                url: '/twc',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/twc.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state("twc_huda",{
                parent: 'constructionpermit',
                url: '/twc(huda)',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/twc_huda.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state("twc_ulb",{
                parent: 'constructionpermit',
                url: '/twc(ulb)',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/twc_ulb.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })


            .state("tec",{
                parent: 'constructionpermit',
                url: '/tec/{deptID}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/tec.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
         .state("huda",{
                parent: 'constructionpermit',
                url: '/huda',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/huda.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hudaForm');
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state("labour",{
                parent: 'constructionpermit',
                url: '/labourDepartment',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/labour.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('factotyPlan');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state("hsidc",{
                parent: 'constructionpermit',
                url: '/hsidc',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/hsidc.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
         .state("tcp",{
                parent: 'constructionpermit',
                url: '/tcp',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/tcp.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
         .state("tcp-oc",{
                parent: 'constructionpermit',
                url: '/tcp-oc',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/tcp-oc.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
         .state("ulb-oc",{
                parent: 'constructionpermit',
                url: '/ulb-oc',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/ulb-oc.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
         .state("ulb",{
                parent: 'constructionpermit',
                url: '/ulb',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/ulb.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
         .state("hsiidc-oc",{
                parent: 'constructionpermit',
                url: '/hsiidc-oc',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/hsiidc-oc.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
         .state("huda-oc",{
                parent: 'constructionpermit',
                url: '/huda-oc',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/huda-oc.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('hudaformOc');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state("fireNOC",{
                parent: 'constructionpermit',
                url: '/fireNOC',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/fireNOC.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state("inspectionOfficer",{
                parent: 'app',
                url: '/pendingInspectionReports',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/ConstructionPermit/inspectionOfficer.html',
                        controller: 'inspectionOfficerDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
         })
            .state("labour-oc",{
                parent: 'constructionpermit',
                url: '/labour-oc',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'nestedForm@constructionpermit': {
                        templateUrl: 'app/ConstructionPermit/labour-oc.html',
                        controller: 'constructionPermitDeptController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('aai');
                        $translatePartialLoader.addPart('nma');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })




            .state('serviceclearanceaction', {
                parent: 'projectdetailjist',
                url: '/serviceclearanceaction/{district}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD', 'ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN','ROLE_CAF_STATUS_OFFICER','ROLE_STATE_NODAL_OFFICER']
                },
                views: {
                    'sideView@projectdetailjist': {
                        templateUrl: 'app/serviceclearanceactions/serviceclearanceactions.html',
                        controller: 'serviceClearanceActionController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    projectServiceReportInfo: function () {
                        return {
                            projectid: null,
                            projecttype: null,
                            departmentname: null,
                            servicename: null,
                            assignDate: null,
                            requireDate: null,
                            status: null,
                            stage: null,
                            investorName: null,
                            cafPin: null,
                            finalAction: null,
                            finalActionDate: null,
                            projectInvestment: null,
                            projectEmployment: null,
                            id: null
                        };
                    },
                    projectServiceLog: function () {
                        return {
                            projectid: null,
                            serviceid: null,
                            comments: null,
                            commentDate: null,
                            commentByUserLogin: null,
                            actionTaken: null,
                            id: null
                        };
                    },
                    projectservicelist: ['$stateParams', 'ProjectservicedetailbyProject', function($stateParams, ProjectservicedetailbyProject) {
                        return ProjectservicedetailbyProject.get({
                            id: $stateParams.projectid,
                            status: "required"
                        }).$promise;
                    }],

                    // projectservicedetail: ['projectservicelist', '$http', '$q', function(projectservicelist, $http, $q) {
                    //     var serviceDetails = projectservicelist.projectservicedetailDTOS || [];
                    //
                    //     if (!serviceDetails.length) {
                    //         console.log("No service details found, skipping survey-forms API calls.");
                    //         return $q.resolve([]);
                    //     }
                    //
                    //     var validServiceDetails = serviceDetails.filter(function(item) {
                    //         return item && item.id;
                    //     });
                    //
                    //     if (!validServiceDetails.length) {
                    //         return $q.resolve([]);
                    //     }
                    //
                    //     var promises = [];
                    //
                    //     for (var i = 0; i < validServiceDetails.length; i++) {
                    //         (function(item) {
                    //             var url = 'http://localhost:9090/api/survey-forms/' + item.id;
                    //             var promise = $http.get(url).then(function(res) {
                    //                 if (typeof res.data === 'string' && res.data.indexOf('No data found for ID') !== -1) {
                    //                     console.warn("Skipping all survey-form calls due to: " + res.data);
                    //                     // Reject all to skip
                    //                     throw new Error("SkipSurveyForms");
                    //                 }
                    //                 return res.data;
                    //             });
                    //             promises.push(promise);
                    //         })(validServiceDetails[i]);
                    //     }
                    //
                    //     return $q.all(promises).catch(function(err) {
                    //         if (err.message === "SkipSurveyForms") {
                    //             return []; // return empty array and continue with other APIs
                    //         } else {
                    //             throw err; // rethrow other errors
                    //         }
                    //     });
                    // }],

                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })

            .state('serviceclearanceactionforsurvey', {
                parent: 'projectdetailjist',
                url: '/surveyForm/{projectserviceid}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD', 'ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN','ROLE_CAF_STATUS_OFFICER']
                },
                views: {
                    'sideView@projectdetailjist': {
                        templateUrl: 'app/surveyForm/surveyFormView.html',
                        controller: 'SurveyFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    projectServiceReportInfo: function () {
                        return {
                            projectid: null,
                            projecttype: null,
                            departmentname: null,
                            servicename: null,
                            assignDate: null,
                            requireDate: null,
                            status: null,
                            stage: null,
                            investorName: null,
                            cafPin: null,
                            finalAction: null,
                            finalActionDate: null,
                            projectInvestment: null,
                            projectEmployment: null,
                            id: null
                        };
                    },
                    projectServiceLog: function () {
                        return {
                            projectid: null,
                            serviceid: null,
                            comments: null,
                            commentDate: null,
                            commentByUserLogin: null,
                            actionTaken: null,
                            id: null
                        };
                    },
                    projectservicelist: ['$stateParams', 'ProjectservicedetailbyProject', function($stateParams, ProjectservicedetailbyProject) {
                        return ProjectservicedetailbyProject.get({id : $stateParams.projectid, status:"required"});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })

            .state('serviceclearanceactionforsurveyformview', {
                parent: 'projectdetailjist',
                url: '/surveyFormView/{projectserviceid}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD', 'ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN','ROLE_CAF_STATUS_OFFICER','ROLE_TOWER_OFFICER']
                },
                views: {
                    'sideView@projectdetailjist': {
                        templateUrl: 'app/surveyForm/surveyFormFilledView.html',
                        controller: 'SurveyFormViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    projectservicelist: ['$stateParams', 'ProjectservicedetailbyProject', function($stateParams, ProjectservicedetailbyProject) {
                        return ProjectservicedetailbyProject.get({id : $stateParams.projectid, status:"required"});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })

            .state('showsurveyform', {
                url: '/showsurveyform/{projectserviceid}',
                data: {
                    authorities: [
                        'ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM',
                        'ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER','ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE',
                        'ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT',
                        'ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES',
                        'ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN','ROLE_CAF_STATUS_OFFICER','ROLE_TOWER_OFFICER','ROLE_TOWER_DC'
                    ]
                },
                views: {
                    'content@': { // 👈 loads into main view
                        templateUrl: 'app/surveyForm/surveyFormFilledView.html',
                        controller: 'SurveyFormViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })

            .state('serviceclearanceactionforbankguranteeusingprojectserviceid', {
                parent: 'projectdetailjist',
                url: '/bankGuranteeView/{projectserviceid}/{district}/{projectid}/{serviceid}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD', 'ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN','ROLE_CAF_STATUS_OFFICER']
                },
                views: {
                    'sideView@projectdetailjist': {
                        templateUrl: 'app/projectBankGuarantee/projectBankGuranteeView.html',
                        controller: 'ProjectBankGuaranteeViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    projectServiceReportInfo: function () {
                        return {
                            projectid: null,
                            projecttype: null,
                            departmentname: null,
                            servicename: null,
                            assignDate: null,
                            requireDate: null,
                            status: null,
                            stage: null,
                            investorName: null,
                            cafPin: null,
                            finalAction: null,
                            finalActionDate: null,
                            projectInvestment: null,
                            projectEmployment: null,
                            id: null
                        };
                    },
                    projectServiceLog: function () {
                        return {
                            projectid: null,
                            serviceid: null,
                            comments: null,
                            commentDate: null,
                            commentByUserLogin: null,
                            actionTaken: null,
                            id: null
                        };
                    },
                    projectservicelist: ['$stateParams', 'ProjectservicedetailbyProject', function($stateParams, ProjectservicedetailbyProject) {
                        return ProjectservicedetailbyProject.get({id : $stateParams.projectid, status:"required"});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })

            .state('serviceclearanceactionforbankguranteeusingprojectserviceidforedit', {
                parent: 'projectdetailjist',
                url: '/bankGuranteeEdit/{projectserviceid}/{district}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD', 'ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN','ROLE_CAF_STATUS_OFFICER']
                },
                views: {
                    'sideView@projectdetailjist': {
                        templateUrl: 'app/projectBankGuarantee/projectBankGuranteeEdit.html',
                        controller: 'ProjectBankGuaranteeEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    projectServiceReportInfo: function () {
                        return {
                            projectid: null,
                            projecttype: null,
                            departmentname: null,
                            servicename: null,
                            assignDate: null,
                            requireDate: null,
                            status: null,
                            stage: null,
                            investorName: null,
                            cafPin: null,
                            finalAction: null,
                            finalActionDate: null,
                            projectInvestment: null,
                            projectEmployment: null,
                            id: null
                        };
                    },
                    projectServiceLog: function () {
                        return {
                            projectid: null,
                            serviceid: null,
                            comments: null,
                            commentDate: null,
                            commentByUserLogin: null,
                            actionTaken: null,
                            id: null
                        };
                    },
                    projectservicelist: ['$stateParams', 'ProjectservicedetailbyProject', function($stateParams, ProjectservicedetailbyProject) {
                        return ProjectservicedetailbyProject.get({id : $stateParams.projectid, status:"required"});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })

            .state('serviceclearanceactionforbankgurantee', {
                parent: 'projectdetailjist',
                url: '/bankGurantee/{projectserviceid}/{district}/{projectid}/{serviceid}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD', 'ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN','ROLE_CAF_STATUS_OFFICER']
                },
                views: {
                    'sideView@projectdetailjist': {
                        templateUrl: 'app/projectBankGuarantee/projectBankGuarantee.html',
                        controller: 'ProjectBankGuaranteeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    projectServiceReportInfo: function () {
                        return {
                            projectid: null,
                            projecttype: null,
                            departmentname: null,
                            servicename: null,
                            assignDate: null,
                            requireDate: null,
                            status: null,
                            stage: null,
                            investorName: null,
                            cafPin: null,
                            finalAction: null,
                            finalActionDate: null,
                            projectInvestment: null,
                            projectEmployment: null,
                            id: null
                        };
                    },
                    projectAttachemnt: function () {
                        return {
                            fileName: null,
                            description: null,
                            fileExtension: null,
                            serverFileName: null,
                            id: null
                        };
                    },
                    projectServiceLog: function () {
                        return {
                            projectid: null,
                            serviceid: null,
                            comments: null,
                            commentDate: null,
                            commentByUserLogin: null,
                            actionTaken: null,
                            id: null
                        };
                    },
                    // projectService: ['Projectservicedetail', function(Projectservicedetail) {
                    //     return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                    // }],
                    projectservicelist: ['$stateParams', 'ProjectservicedetailbyProject', function($stateParams, ProjectservicedetailbyProject) {
                        return ProjectservicedetailbyProject.get({id : $stateParams.projectid, status:"required"});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })

            .state('showcomment', {
                parent: 'app',
                url: '/comment/{projectserviceid}',
                data: {
                    authorities: [
                        'ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM',
                        'ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER','ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE',
                        'ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT',
                        'ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES',
                        'ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN','ROLE_CAF_STATUS_OFFICER','ROLE_TOWER_OFFICER'
                    ]
                },
                views: {
                    'content@': { // 👈 loads into main view
                        templateUrl: 'app/surveyForm/commentForSurvey.html',
                        controller: 'CommentforofficerController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })


    .state('constructionpermit', {
                parent: 'app',
                url: '/constructionpermit/{id}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/serviceclearanceactions/constructionpermit.html',
                        controller: 'constructionPermitController',
                        controllerAs: 'vm'
                    }
                }
            })

        .state('assignservice', {
            parent: 'serviceclearanceaction',
            url: '/assignservice/{projectserviceid}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER','ROLE_DESK_OFFICER','ROLE_FILM_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/serviceclearanceactions/assignServiceDialog.html',
                    controller: 'assignServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        projectAttachemnt: function () {
                              return {
                                  fileName: null,
                                  description: null,
                                  fileExtension: null,
                                  serverFileName: null,
                                  id: null
                              };
                          },
                          projectServiceLog: function () {
                              return {
                                  projectid: null,
                                  serviceid: null,
                                  comments: null,
                                  commentDate: null,
                                  commentByUserLogin: null,
                                  actionTaken: null,
                                  id: null
                              };
                          },
                              projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                              }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                }, function() {
                    $state.go('serviceclearanceaction');
                });
            }]
        })

            .state('assignserviceforbankguranteee', {
                parent: 'serviceclearanceaction',
                url: '/assignserviceforbankgurantee/{projectserviceid}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_TOWER_OFFICER', 'ROLE_TOWER_DC']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/projectBankGuarantee/assignfeeforbankgurantee.html',
                        controller: 'assignfeeforbankgurantee',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            projectAttachemnt: function () {
                                return {
                                    fileName: null,
                                    description: null,
                                    fileExtension: null,
                                    serverFileName: null,
                                    id: null
                                };
                            },
                            projectServiceLog: function () {
                                return {
                                    projectid: null,
                                    serviceid: null,
                                    comments: null,
                                    commentDate: null,
                                    commentByUserLogin: null,
                                    actionTaken: null,
                                    id: null
                                };
                            },
                            projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                $translatePartialLoader.addPart('home');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                    }, function() {
                        $state.go('serviceclearanceaction');
                    });
                }]
            })

        .state('assignotherservice', {
        parent: 'serviceclearanceaction',
        url: '/assignotherservice/{projectserviceid}',
        data: {
            authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER','ROLE_DESK_OFFICER','ROLE_FILM_OFFICER']
        },
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
                templateUrl: 'app/serviceclearanceactions/assignOtherServiceDialog.html',
                controller: 'assignOtherServiceDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    projectAttachemnt: function () {
                          return {
                              fileName: null,
                              description: null,
                              fileExtension: null,
                              serverFileName: null,
                              id: null
                          };
                      },
                      projectServiceLog: function () {
                          return {
                              projectid: null,
                              serviceid: null,
                              comments: null,
                              commentDate: null,
                              commentByUserLogin: null,
                              actionTaken: null,
                              id: null
                          };
                      },
                      projectService: ['Projectservicedetail', function(Projectservicedetail) {
                        return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                      }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function() {
                $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
            }, function() {
                $state.go('serviceclearanceaction');
            });
        }]
    })
    .state('serviceForm-fillform', {
        parent: 'serviceclearanceaction',
        url: '/fillform/{projectserviceid}',
        data: {
            authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_RM','ROLE_FILM_OFFICER']
        },
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
                templateUrl: 'app/serviceclearanceactions/serviceForm.html',
                controller: 'serviceFormController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    projectServiceFormFieldData: function () {
                        return {
                            serviceid: null,
                            formfieldvalue: null,
                            projectid: null,
                            formfieldName: null,
                            id: null
                        };
                    },
                    projectAttachemnt: function () {
                          return {
                              fileName: null,
                              description: null,
                              fileExtension: null,
                              serverFileName: null,
                              id: null
                          };
                      },
                      projectServiceLog: function () {
                          return {
                              projectid: null,
                              serviceid: null,
                              comments: null,
                              commentDate: null,
                              commentByUserLogin: null,
                              actionTaken: null,
                              id: null
                          };
                      },
                      projectService: ['Projectservicedetail', function(Projectservicedetail) {
                        return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                      }],
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                      }]
                }
            }).result.then(function() {
                $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
            }, function() {
                $state.go('serviceclearanceaction');
            });
        }]
    })
    .state('servicePayment', {
          parent: 'serviceclearanceaction',
          url: '/payFee/{projectserviceid}',
          data: {
              authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_FILM_OFFICER']
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'app/serviceclearanceactions/servicePayment.html',
                  controller: 'servicePaymentController',
                  controllerAs: 'vm',
                  backdrop: 'static',
                  size: 'lg',
                  resolve: {
                      projectServicePayment: function () {
                          return {
                              projectid: null,
                              serviceid: null,
                              paymentMade: null,
                              paymentMadeBy: null,
                              paymentDate: null,
                              id: null
                          };
                      },
                      projectAttachemnt: function () {
                        return {
                            fileName: null,
                            description: null,
                            fileExtension: null,
                            serverFileName: null,
                            id: null
                        };
                      },
                      projectServiceLog: function () {
                        return {
                            projectid: null,
                            serviceid: null,
                            comments: null,
                            commentDate: null,
                            commentByUserLogin: null,
                            actionTaken: null,
                            id: null
                        };
                      },
                      projectService: ['Projectservicedetail', function(Projectservicedetail) {
                          return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                      }],
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                          $translatePartialLoader.addPart('home');
                          return $translate.refresh();
                      }]
                  }
              }).result.then(function() {
                  $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
              }, function() {
                  $state.go('serviceclearanceaction');
              });
          }]
      })
 .state('otherServicePayment', {
          parent: 'serviceclearanceaction',
          url: '/payOtherFee/{projectserviceid}',
          data: {
              authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER']
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'app/serviceclearanceactions/otherServicePayment.html',
                  controller: 'otherServicePaymentController',
                  controllerAs: 'vm',
                  backdrop: 'static',
                  size: 'lg',
                  resolve: {
                      projectServicePayment: function () {
                          return {
                              projectid: null,
                              serviceid: null,
                              paymentMade: null,
                              paymentMadeBy: null,
                              paymentDate: null,
                              isPaymentMade: null,
                              id: null
                          };
                      },
                      projectServiceLog: function () {
                        return {
                            projectid: null,
                            serviceid: null,
                            comments: null,
                            commentDate: null,
                            commentByUserLogin: null,
                            actionTaken: null,
                            id: null
                        };
                      },
                      projectService: ['Projectservicedetail', function(Projectservicedetail) {
                          return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                      }],
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                          $translatePartialLoader.addPart('home');
                          return $translate.refresh();
                      }]
                  }
              }).result.then(function() {
                  $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
              }, function() {
                  $state.go('serviceclearanceaction');
              });
          }]
      })

    .state('verifyPayment', {
            parent: 'serviceclearanceaction',
            url: '/verify/{projectserviceid}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_ACCOUNT_OFFICER','ROLE_NODAL_OFFICER','ROLE_USER','ROLE_FIELD_OFFICER','ROLE_FILM_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/serviceclearanceactions/verifyPayment.html',
                    controller: 'verifyPaymentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        projectServiceLog: function () {
                              return {
                                  projectid: null,
                                  serviceid: null,
                                  comments: null,
                                  commentDate: null,
                                  commentByUserLogin: null,
                                  actionTaken: null,
                                  id: null
                              };
                          },
                          projectService: ['Projectservicedetail', function(Projectservicedetail) {
                               return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                          }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                }, function() {
                    $state.go('serviceclearanceaction');
                });
            }]
        })
.state('verifyOtherPayment', {
            parent: 'serviceclearanceaction',
            url: '/verifyOtherPay/{projectserviceid}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_ACCOUNT_OFFICER','ROLE_NODAL_OFFICER','ROLE_USER','ROLE_FIELD_OFFICER','ROLE_FILM_OFFICER','ROLE_TOWER_DC']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/serviceclearanceactions/verifyOtherPayment.html',
                    controller: 'verifyOtherPaymentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        projectServiceLog: function () {
                              return {
                                  projectid: null,
                                  serviceid: null,
                                  comments: null,
                                  commentDate: null,
                                  commentByUserLogin: null,
                                  actionTaken: null,
                                  id: null
                              };
                          },
                          projectService: ['Projectservicedetail', function(Projectservicedetail) {
                               return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                          }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                }, function() {
                    $state.go('serviceclearanceaction');
                });
            }]
        })
    .state('viewFormFilled', {
        parent: 'serviceclearanceaction',
        url: '/ViewFilledForm/{projectserviceid}',
        data: {
            authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_RM','ROLE_USER','ROLE_NODAL_OFFICER','ROLE_FIELD_OFFICER','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER']
        },
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
                templateUrl: 'app/serviceclearanceactions/serviceFormFilled.html',
                controller: 'serviceFormFilledController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    projectServiceLog: function () {
                          return {
                              projectid: null,
                              serviceid: null,
                              comments: null,
                              commentDate: null,
                              commentByUserLogin: null,
                              actionTaken: null,
                              id: null
                        };
                    },
                    projectService: ['Projectservicedetail', function(Projectservicedetail) {
                       return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            }).result.then(function() {
                $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
            }, function() {
                $state.go('serviceclearanceaction');
            });
        }]
    })

    .state('serviceLog', {
        parent: 'serviceclearanceaction',
        url: '/serviceLog/{projectserviceid}/{projectid}/{serviceid}',
        data: {
            authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_RM','ROLE_DESK_OFFICER','ROLE_NODAL_OFFICER','ROLE_FIELD_OFFICER','ROLE_ACCOUNT_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN']
        },
        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            $uibModal.open({
                templateUrl: 'app/serviceclearanceactions/serviceLog.html',
                controller: 'serviceLogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],
                    serviceLogList: ['GetServiceLog', function(GetServiceLog) {
                        return GetServiceLog.query({projectid:$stateParams.projectid,serviceid:$stateParams.serviceid});
                    }],
                    service: ['DepartmentService', function(DepartmentService) {
                        return DepartmentService.get({id : $stateParams.serviceid}).$promise;
                    }],
                    projectService: ['Projectservicedetail', function(Projectservicedetail) {
                      return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                    }]
                }
            }).result.then(function() {
                $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
            }, function() {
                $state.go('serviceclearanceaction');
            });
        }]
    })
  .state('serviceClearance-action', {
          parent: 'serviceclearanceaction',
          url: '/clear/{projectserviceid}',
          data: {
              authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER','ROLE_FILM_OFFICER']
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'app/serviceclearanceactions/serviceclearance.html',
                  controller: 'serviceClearanceController',
                  controllerAs: 'vm',
                  backdrop: 'static',
                  size: 'lg',
                  resolve: {
                       projectAttachemnt: function () {
                            return {
                                fileName: null,
                                description: null,
                                fileExtension: null,
                                serverFileName: null,
                                id: null
                            };
                       },
                       projectServiceLog: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                comments: null,
                                commentDate: null,
                                commentByUserLogin: null,
                                actionTaken: null,
                                id: null
                            };
                       },
                       projectService: ['Projectservicedetail', function(Projectservicedetail) {
                          return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                       }],
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                          $translatePartialLoader.addPart('home');
                          return $translate.refresh();
                      }]
                  }
              }).result.then(function() {
                  $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
              }, function() {
                  $state.go('serviceclearanceaction');
              });
          }]
      })
  .state('deemedClearance', {
            parent: 'serviceclearanceaction',
            url: '/deemed/{projectserviceid}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER','ROLE_FILM_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/serviceclearanceactions/deemedClearance.html',
                    controller: 'deemedClearanceController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        projectAttachemnt: function () {
                            return {
                              fileName: null,
                              description: null,
                              fileExtension: null,
                              serverFileName: null,
                              id: null
                        };
                        },
                        projectServiceLog: function () {
                            return {
                              projectid: null,
                              serviceid: null,
                              comments: null,
                              commentDate: null,
                              commentByUserLogin: null,
                              actionTaken: null,
                              id: null
                            };
                        },
                        projectService: ['Projectservicedetail', function(Projectservicedetail) {
                          return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                }, function() {
                    $state.go('serviceclearanceaction');
                });
            }]
        })
        .state('comment-dialog', {
              parent: 'serviceclearanceaction',
              url: '/comment/{projectserviceid}',
              data: {
                  authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_RM','ROLE_DESK_OFFICER','ROLE_NODAL_OFFICER','ROLE_FIELD_OFFICER','ROLE_ACCOUNT_OFFICER','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER']
              },
              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                  $uibModal.open({
                      templateUrl: 'app/serviceclearanceactions/commentDialog.html',
                      controller: 'commentDialogController',
                      controllerAs: 'vm',
                      backdrop: 'static',
                      size: 'lg',
                      resolve: {
                          projectAttachemnt: function () {
                              return {
                                  fileName: null,
                                  description: null,
                                  fileExtension: null,
                                  serverFileName: null,
                                  id: null
                              };
                          },
                          projectServiceLog: function () {
                              return {
                                  projectid: null,
                                  serviceid: null,
                                  comments: null,
                                  commentDate: null,
                                  commentByUserLogin: null,
                                  actionTaken: null,
                                  id: null
                              };
                          },
                          projectService: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                          }],
                          translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                              $translatePartialLoader.addPart('home');
                              return $translate.refresh();
                          }]
                      }
                  }).result.then(function() {
                      $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                  }, function() {
                      $state.go('serviceclearanceaction');
                  });
              }]
          })
          .state('reject-dialog', {
                parent: 'serviceclearanceaction',
                url: '/reject/{projectserviceid}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER','ROLE_NODAL_OFFICER','ROLE_FILM_OFFICER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/serviceclearanceactions/rejectDialog.html',
                        controller: 'rejectDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            projectAttachemnt: function () {
                                return {
                                    fileName: null,
                                    description: null,
                                    fileExtension: null,
                                    serverFileName: null,
                                    id: null
                                };
                            },
                            projectServiceLog: function () {
                                return {
                                    projectid: null,
                                    serviceid: null,
                                    comments: null,
                                    commentDate: null,
                                    commentByUserLogin: null,
                                    actionTaken: null,
                                    id: null
                                };
                            },
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                $translatePartialLoader.addPart('home');
                                return $translate.refresh();
                            }],
                            projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                            }]
//                            projectservicereportinfo: ['ProjectServiceReportInfoForClearance', function(ProjectServiceReportInfoForClearance) {
//                                return ProjectServiceReportInfoForClearance.get({department:$stateParams.projectService.departmentName,projectid:$stateParams.projectService.projectid,service:$stateParams.projectService.serviceName});
//                            }]
                        }
                    }).result.then(function() {
                        $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                    }, function() {
                        $state.go('serviceclearanceaction');
                    });
                }]
            })
            .state('decline-dialog', {
                            parent: 'serviceclearanceaction',
                            url: '/decline/{projectserviceid}',
                            data: {
                                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER','ROLE_NODAL_OFFICER','ROLE_FILM_OFFICER']
                            },
                            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                                $uibModal.open({
                                    templateUrl: 'app/serviceclearanceactions/declineDialog.html',
                                    controller: 'declineDialogController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'lg',
                                    resolve: {
                                        projectAttachemnt: function () {
                                            return {
                                                fileName: null,
                                                description: null,
                                                fileExtension: null,
                                                serverFileName: null,
                                                id: null
                                            };
                                        },
                                        projectServiceLog: function () {
                                            return {
                                                projectid: null,
                                                serviceid: null,
                                                comments: null,
                                                commentDate: null,
                                                commentByUserLogin: null,
                                                actionTaken: null,
                                                id: null
                                            };
                                        },
                                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                            $translatePartialLoader.addPart('home');
                                            return $translate.refresh();
                                        }],
                                        projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                            return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                                        }]
            //                            projectservicereportinfo: ['ProjectServiceReportInfoForClearance', function(ProjectServiceReportInfoForClearance) {
            //                                return ProjectServiceReportInfoForClearance.get({department:$stateParams.projectService.departmentName,projectid:$stateParams.projectService.projectid,service:$stateParams.projectService.serviceName});
            //                            }]
                                    }
                                }).result.then(function() {
                                    $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                                }, function() {
                                    $state.go('serviceclearanceaction');
                                });
                            }]
                        })
            /**
             * The nodal officer's actions on an Above Ground intimation of a tower on a
             * property other than public property - Revert asks the applicant for a
             * clarification, Approve stands the intimation as valid and Reject takes it
             * away. All three are answered on the dialog the tower officer answers them
             * on, which is the same form filed by the same service log.
             */
            .state('nodalofficer-intimation-action', {
                parent: 'serviceclearanceaction',
                url: '/intimationaction/{action}/{projectserviceid}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/showprojects-towerofficer/projects-dialog.html',
                        controller: 'TowerOfficerProjectDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            projectAttachemnt: function () {
                                return {
                                    fileName: null,
                                    description: null,
                                    fileExtension: null,
                                    serverFileName: null,
                                    id: null
                                };
                            },
                            projectServiceLog: function () {
                                return {
                                    projectid: null,
                                    serviceid: null,
                                    comments: null,
                                    commentDate: null,
                                    commentByUserLogin: null,
                                    actionTaken: null,
                                    id: null
                                };
                            },
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                $translatePartialLoader.addPart('home');
                                return $translate.refresh();
                            }],
                            projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                    }, function() {
                        $state.go('serviceclearanceaction');
                    });
                }]
            })

            .state('reactivate', {
                parent: 'serviceclearanceaction',
                url: '/reactivate/{projectserviceid}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER','ROLE_NODAL_OFFICER','ROLE_FILM_OFFICER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/serviceclearanceactions/reactivateDialog.html',
                        controller: 'reactivateDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            projectAttachemnt: function () {
                                return {
                                    fileName: null,
                                    description: null,
                                    fileExtension: null,
                                    serverFileName: null,
                                    id: null
                                };
                            },
                            projectServiceLog: function () {
                                return {
                                    projectid: null,
                                    serviceid: null,
                                    comments: null,
                                    commentDate: null,
                                    commentByUserLogin: null,
                                    actionTaken: null,
                                    id: null
                                };
                            },
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                $translatePartialLoader.addPart('home');
                                return $translate.refresh();
                            }],
                            projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                            }]
        //                            projectservicereportinfo: ['ProjectServiceReportInfoForClearance', function(ProjectServiceReportInfoForClearance) {
        //                                return ProjectServiceReportInfoForClearance.get({department:$stateParams.projectService.departmentName,projectid:$stateParams.projectService.projectid,service:$stateParams.projectService.serviceName});
        //                            }]
                        }
                    }).result.then(function() {
                        $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                    }, function() {
                        $state.go('serviceclearanceaction');
                    });
                }]
        })

        .state('undoreject', {
                        parent: 'serviceclearanceaction',
                        url: '/undoreject/{projectserviceid}',
                        data: {
                            authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER','ROLE_NODAL_OFFICER','ROLE_FILM_OFFICER']
                        },
                        onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                            $uibModal.open({
                                templateUrl: 'app/serviceclearanceactions/undoRejectDialog.html',
                                controller: 'undoRejectDialogController',
                                controllerAs: 'vm',
                                backdrop: 'static',
                                size: 'lg',
                                resolve: {
                                    projectAttachemnt: function () {
                                        return {
                                            fileName: null,
                                            description: null,
                                            fileExtension: null,
                                            serverFileName: null,
                                            id: null
                                        };
                                    },
                                    projectServiceLog: function () {
                                        return {
                                            projectid: null,
                                            serviceid: null,
                                            comments: null,
                                            commentDate: null,
                                            commentByUserLogin: null,
                                            actionTaken: null,
                                            id: null
                                        };
                                    },
                                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                        $translatePartialLoader.addPart('home');
                                        return $translate.refresh();
                                    }],
                                    projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                        return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                                    }]
                //                            projectservicereportinfo: ['ProjectServiceReportInfoForClearance', function(ProjectServiceReportInfoForClearance) {
                //                                return ProjectServiceReportInfoForClearance.get({department:$stateParams.projectService.departmentName,projectid:$stateParams.projectService.projectid,service:$stateParams.projectService.serviceName});
                //                            }]
                                }
                            }).result.then(function() {
                                $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                            }, function() {
                                $state.go('serviceclearanceaction');
                            });
                        }]
                })

        .state('i-serviceform', {
            parent: 'app',
            url: '/i-serviceform/{projectid}/{serviceid}/{projectserviceid}/{id}/{markeddate}/{requestType}',

            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_FIELD_OFFICER','ROLE_FILM_OFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/serviceclearanceactions/i-serviceform.html',
                    controller: 'iServiceFormController',
                    controllerAs: 'vm'
                }
            },
            resolve : {
              translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                }],
                Project:['$stateParams','Project',function ($stateParams,Project) {
                   return Project.get({id:$stateParams.projectid}).$promise;
                }],
                Users:['$stateParams','UserById',function ($stateParams,UserById) {
                   return UserById.get({id: $stateParams.id}).$promise;
                }],
                ExtendedUsers:['$stateParams','ExtendedUserInformation',function ($stateParams,ExtendedUserInformation) {
                return ExtendedUserInformation.get({id: $stateParams.id}).$promise;
                }],
                Projectservicedetail:['$stateParams','Projectservicedetail',function ($stateParams,Projectservicedetail) {
                   return Projectservicedetail.get({id:$stateParams.projectserviceid}).$promise;
                }]
            }
        })
        .state('paymentResponse', {
            parent: 'app',
            url: '/paymentResponse',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/serviceclearanceactions/paymentResponse.html',
                    controller: 'paymentResponseController',
                    controllerAs: 'vm'
                }
            },
            resolve : {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                }]
            }
        })
        .state('landexchange-form', {
            parent: 'serviceclearanceaction',
            url: '/landexchange-form/{projectserviceid}',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/serviceclearanceactions/landexchange-dialog.html',
                    controller: 'LandexchangeDialogController2',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                investor_name: null,
                                address: null,
                                contact: null,
                                reason: null,
                                owner_name: null,
                                tehsil: null,
                                block: null,
                                village: null,
                                khasra: null,
                                area_of_land: null,
                                market_value: null,
                                owner_name_offered: null,
                                tehsil_offered: null,
                                block_offered: null,
                                village_offered: null,
                                khasra_offered: null,
                                area_of_land_offered: null,
                                market_value_offered: null,
                                email: null,
                                name_of_gramPanchayat: null,
                                gramPanchayat_code: null,
                                district: null,
                                khewat: null,
                                khatoni: null,
                                type_of_land: null,
                                district_offered: null,
                                hadbast_offered: null,
                                khewat_offered: null,
                                khatoni_offered: null,
                                type_of_land_offered: null,
                                hadbast: null,
                                id: null
                            };
                        },
                        projectServiceFormFieldData: function () {
                            return {
                                serviceid: null,
                                formfieldvalue: null,
                                projectid: null,
                                formfieldName: null,
                                id: null
                            };
                        },
                        projectAttachemnt: function () {
                            return {
                                fileName: null,
                                description: null,
                                fileExtension: null,
                                serverFileName: null,
                                id: null
                            };
                        },
                        projectServiceLog: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                comments: null,
                                commentDate: null,
                                commentByUserLogin: null,
                                actionTaken: null,
                                id: null
                            };
                        },
                        projectService: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            $translatePartialLoader.addPart('landexchange');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                }, function() {
                    $state.go('serviceclearanceaction');
                });
            }]
        })
        .state('ULBlandexchange-form', {
            parent: 'serviceclearanceaction',
            url: '/ULBlandexchange-form/{projectserviceid}',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/serviceclearanceactions/ULBlandexchange-dialog.html',
                    controller: 'LandexchangeDialogController2',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                investor_name: null,
                                address: null,
                                contact: null,
                                reason: null,
                                owner_name: null,
                                tehsil: null,
                                block: null,
                                village: null,
                                khasra: null,
                                area_of_land: null,
                                market_value: null,
                                owner_name_offered: null,
                                tehsil_offered: null,
                                block_offered: null,
                                village_offered: null,
                                khasra_offered: null,
                                area_of_land_offered: null,
                                market_value_offered: null,
                                email: null,
                                name_of_gramPanchayat: null,
                                gramPanchayat_code: null,
                                district: null,
                                khewat: null,
                                khatoni: null,
                                type_of_land: null,
                                district_offered: null,
                                hadbast_offered: null,
                                khewat_offered: null,
                                khatoni_offered: null,
                                type_of_land_offered: null,
                                hadbast: null,
                                id: null
                            };
                        },
                        projectServiceFormFieldData: function () {
                            return {
                                serviceid: null,
                                formfieldvalue: null,
                                projectid: null,
                                formfieldName: null,
                                id: null
                            };
                        },
                        projectAttachemnt: function () {
                            return {
                                fileName: null,
                                description: null,
                                fileExtension: null,
                                serverFileName: null,
                                id: null
                            };
                        },
                        projectServiceLog: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                comments: null,
                                commentDate: null,
                                commentByUserLogin: null,
                                actionTaken: null,
                                id: null
                            };
                        },
                        projectService: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            $translatePartialLoader.addPart('landexchange');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                }, function() {
                    $state.go('serviceclearanceaction');
                });
            }]
        })

    .state('landexchange-viewform', {
    parent: 'serviceclearanceaction',
    url: '/landexchange-viewform/{projectserviceid}/{projectid}/{serviceid}',
    data: {
        authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN'],
        pageTitle: 'investhryApp.landexchange.detail.title'
    },
    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
        $uibModal.open({
            templateUrl: 'app/serviceclearanceactions/landexchange-detail.html',
            controller: 'LandexchangeDetailController2',
            controllerAs: 'vm',
            backdrop: 'static',
            size: 'lg',
            resolve: {
                entity: ['Landexchange', function(Landexchange) {
                    return Landexchange.get({id : $stateParams.projectserviceid}).$promise;
                }],
                serviceFormAttachments: ['ServiceFormAttachments', function(ServiceFormAttachments) {
                    return ServiceFormAttachments.query({id:"1",serviceid:$stateParams.serviceid, projectid:$stateParams.projectid}).$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('landexchange');
                    return $translate.refresh();
                }]
            }
        }).result.then(function() {
            $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
        }, function() {
            $state.go('serviceclearanceaction');
        });
    }]
})
    .state('ULBlandexchange-viewform', {
            parent: 'serviceclearanceaction',
            url: '/ULBlandexchange-viewform/{projectserviceid}/{projectid}/{serviceid}',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.landexchange.detail.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/serviceclearanceactions/ULBlandexchange-detail.html',
                    controller: 'LandexchangeDetailController2',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Landexchange', function(Landexchange) {
                            return Landexchange.get({id : $stateParams.projectserviceid}).$promise;
                        }],
                        serviceFormAttachments: ['ServiceFormAttachments', function(ServiceFormAttachments) {
                            return ServiceFormAttachments.query({id:"1",serviceid:$stateParams.serviceid, projectid:$stateParams.projectid}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            $translatePartialLoader.addPart('landexchange');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                }, function() {
                    $state.go('serviceclearanceaction');
                });
            }]
        })

    .state('view-checklist', {
            parent: 'app',
            url: '/checklist/{serviceid}',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_FILM_OFFICER'],
                pageTitle: 'checklist'
            },
            views: {
                'content@': {
                    templateUrl: 'app/serviceclearanceactions/checklist.html',
                    controller: 'ChecklistViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    .state('serviceclearanceaction.required', {
        parent: 'projectdetailjist',
        url: '/required-services/{district}',
        data: {
            authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD', 'ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_CAF_STATUS_OFFICER','ROLE_STATE_NODAL_OFFICER']
        },
        views: {
            'sideView@projectdetailjist': {
                templateUrl: 'app/serviceclearanceactions/requiredList.html',
                controller: 'RequiredListController',
                controllerAs: 'vm'
            }
        },
        resolve: {
            projectServiceLog: function () {
                return {
                    projectid: null,
                    serviceid: null,
                    comments: null,
                    commentDate: null,
                    commentByUserLogin: null,
                    actionTaken: null,
                    id: null
                };
            },
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                $translatePartialLoader.addPart('home');
                return $translate.refresh();
            }],
            // Project:['$stateParams','Project',function ($stateParams,Project) {
            //     return Project.get({id:$stateParams.projectid}).$promise;
            // }]
        }
    })
    .state('withdraw-dialog', {
            parent: 'serviceclearanceaction',
            url: '/withdraw/{projectserviceid}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/serviceclearanceactions/withdrawDialog.html',
                    controller: 'withdrawDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        projectAttachemnt: function () {
                            return {
                                fileName: null,
                                description: null,
                                fileExtension: null,
                                serverFileName: null,
                                id: null
                            };
                        },
                        projectServiceLog: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                comments: null,
                                commentDate: null,
                                commentByUserLogin: null,
                                actionTaken: null,
                                id: null
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }],
                        projectService: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                        }]
                        //                            projectservicereportinfo: ['ProjectServiceReportInfoForClearance', function(ProjectServiceReportInfoForClearance) {
                        //                                return ProjectServiceReportInfoForClearance.get({department:$stateParams.projectService.departmentName,projectid:$stateParams.projectService.projectid,service:$stateParams.projectService.serviceName});
                        //                            }]
                    }
                }).result.then(function() {
                    $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                }, function() {
                    $state.go('serviceclearanceaction');
                });
            }]
        })
            .state('acknowledgement', {
                parent: 'serviceclearanceaction',
                url: '/acknowledgement/{projectserviceid}/{projectid}/{serviceid}/{cafpin}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_RM','ROLE_DESK_OFFICER','ROLE_NODAL_OFFICER','ROLE_FIELD_OFFICER','ROLE_ACCOUNT_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/serviceclearanceactions/acknowledgement.html',
                        controller: 'acknowledgementController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                $translatePartialLoader.addPart('home');
                                return $translate.refresh();
                            }],
                            serviceLogList: ['GetServiceLog', function(GetServiceLog) {
                                return GetServiceLog.query({projectid:$stateParams.projectid,serviceid:$stateParams.serviceid});
                            }],
                            service: ['DepartmentService', function(DepartmentService) {
                                return DepartmentService.get({id : $stateParams.serviceid}).$promise;
                            }],
                            projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                    }, function() {
                        $state.go('serviceclearanceaction');
                    });
                }]
            })
        .state('clarification-dialog', {
            parent: 'serviceclearanceaction',
            url: '/clarification/{role}/{projectserviceid}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/serviceclearanceactions/clarificationDialog.html',
                    controller: 'clarificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        projectAttachemnt: function () {
                            return {
                                fileName: null,
                                description: null,
                                fileExtension: null,
                                serverFileName: null,
                                id: null
                            };
                        },
                        projectServiceLog: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                comments: null,
                                commentDate: null,
                                commentByUserLogin: null,
                                actionTaken: null,
                                id: null
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }],
                        projectService: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                        }]
                        //                            projectservicereportinfo: ['ProjectServiceReportInfoForClearance', function(ProjectServiceReportInfoForClearance) {
                        //                                return ProjectServiceReportInfoForClearance.get({department:$stateParams.projectService.departmentName,projectid:$stateParams.projectService.projectid,service:$stateParams.projectService.serviceName});
                        //                            }]
                    }
                }).result.then(function() {
                    $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                }, function() {
                    $state.go('serviceclearanceaction');
                });
            }]
        });



    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('serviceClearanceActionController', serviceClearanceActionController);

    //
    // serviceClearanceActionController.$inject = ['$scope', '$stateParams','$state','projectServiceReportInfo', 'Projectcompletedetail', 'Auth', 'Principal', 'DepartmentService', 'Projectservicedetail','ProjectServiceReportInfoForClearance','projectservicelist','projectServiceLog','ProjectServiceLogUpdated','ProjectservicedetailbyProject','Department', 'TowerserviceNO', 'Project', '$sce','Municipals','$http','SurveyForm'];
    //
    // function serviceClearanceActionController ($scope, $stateParams, $state, projectServiceReportInfo, Projectcompletedetail, Auth, Principal, DepartmentService, Projectservicedetail,ProjectServiceReportInfoForClearance,projectservicelist,projectServiceLog,ProjectServiceLogUpdated,ProjectservicedetailbyProject,Department, TowerserviceNO, Project, $sce,Municipalsl,$http,SurveyForm) {

    serviceClearanceActionController.$inject = ['$scope', '$stateParams','$state','projectServiceReportInfo', 'Projectcompletedetail', 'Auth', 'Principal', 'DepartmentService', 'Projectservicedetail','ProjectServiceReportInfoForClearance','projectservicelist','projectServiceLog','ProjectServiceLogUpdated','ProjectservicedetailbyProject','Department', 'TowerserviceNO', 'Project', '$sce','Municipals', 'ForceMajeureService', '$http','SurveyForm'];

    function serviceClearanceActionController ($scope, $stateParams, $state, projectServiceReportInfo, Projectcompletedetail, Auth, Principal, DepartmentService, Projectservicedetail,ProjectServiceReportInfoForClearance,projectservicelist,projectServiceLog,ProjectServiceLogUpdated,ProjectservicedetailbyProject,Department, TowerserviceNO, Project, $sce,Municipals, ForceMajeureService, $http, SurveyForm) {

        /** Statuses whose stored name is not the one the page shows for them. */
        var STATUS_NAMES = {
            Declined: 'Rejected',
            Rejected: 'Deactivated',
            DeemedCleared: 'Deemed Cleared'
        };

        /** Colour of the status tag, default (grey) for anything still in process. */
        var STATUS_TAG_CLASSES = {
            Cleared: 'uk-label-success',
            DeemedCleared: 'uk-label-success',
            Acknowledged: 'uk-label-success',
            Declined: 'uk-label-danger',
            Rejected: 'uk-label-danger',
            Withdraw: 'uk-label-warning',
            'Intimation Valid': 'uk-label-success',
            'Intimation Invalid': 'uk-label-danger'
        };

        /**
         * The only service that is intimated rather than cleared -
         * Communication and Connectivity Permissions/Renewal(Above Ground).
         */
        var ABOVE_GROUND_SERVICE_ID = '58d75fd4-f360-4931-a484-ff9be0adc12c';

        /** ..and only when the tower does not stand on a public property. */
        var OTHER_THAN_PUBLIC_PROPERTY = 'other than public property';

        /** The form filled on date counts as the first of the 15 days. */
        var CLARIFY_WINDOW_DAYS = 15;

        /** The status an intimation of such a tower is acknowledged on. */
        var STATUS_ACKNOWLEDGED = 'Acknowledged';

        var vm = this;
        vm.projectid = $stateParams.projectid;
        vm.district = $stateParams.district;
        //vm.projectservicedetail = projectservicedetail;
        //console.log("projectServiceDetails",vm.projectservicedetail)

        vm.title = "Service Clearances in Process";
        vm.statusOnPage = 'All';
        vm.selectedprojectservice = {};
        vm.towerserviceNO = {};
        vm.isDeskof = false;

        vm.constructionpermits=[{id:'PRE',name:'Pre Establishment'},{id:'POST',name:'Post Establishment'}];
        vm.loadProjectServices = loadProjectServices;
        vm.showFillServiceForm = showFillServiceForm;
        vm.showTrackServiceForm = showTrackServiceForm;
        vm.tower_departments = tower_departments;
        vm.isTowerService = isTowerService;
        vm.isTowerServiceForWithdraw = isTowerServiceForWithdraw;
        vm.canClarifyIntimation = canClarifyIntimation;
        vm.canDecideIntimation = canDecideIntimation;
        vm.projectServiceReportInfo = projectServiceReportInfo;
        vm.projectservicelist = projectservicelist;
        console.log("dto is here ::",projectservicelist.projectservicedetailDTOS)
        vm.projectServiceLog = projectServiceLog;
        vm.formStatus = true;
        vm.statusFilter = vm.statusOnPage;
        vm.statusChange = statusChange;
        vm.statusName = statusName;
        vm.statusTagClass = statusTagClass;
        vm.municipals = [];
        $scope.requiredMunicipal = [];
        vm.caftype = '';
        vm.cafpinNew = '';
        vm.isForceMajeure = false;


       // vm.surveyFormStatusMap = {}; // id -> true (found) or false (not found)
        //vm.surveyFormDetailMap = {}; // id -> survey form object

        // vm.checkSurveyFormStatus = function () {
        //     vm.projectservicelist.projectservicedetailDTOS.forEach(function (projectservice) {
        //         SurveyForm.get({ id: projectservice.id }).$promise
        //             .then(function (response) {
        //                 console.log("✅ Found for ID:", projectservice.id);
        //                 vm.surveyFormStatusMap[projectservice.id] = true;
        //                 //vm.surveyFormDetailMap[projectservice.id] = response; // store full response
        //             })
        //             .catch(function (error) {
        //                 if (error.status === 404 || (typeof error.data === 'string' && error.data.startsWith("No data"))) {
        //                     console.log("❌ Not found for ID:", projectservice.id);
        //                     vm.surveyFormStatusMap[projectservice.id] = false;
        //                    // vm.surveyFormDetailMap[projectservice.id] = null;
        //                 } else {
        //                     console.error("API error for ID:", projectservice.id, error);
        //                     vm.surveyFormStatusMap[projectservice.id] = false;
        //                    // vm.surveyFormDetailMap[projectservice.id] = null;
        //                 }
        //             });
        //     });
        // };
        //console.log("here is what i am finding :",vm.surveyFormDetailMap[projectservice.id].status);
        //
        // vm.isSurveyCleared = function (projectservice) {
        //     var formData = vm.surveyFormDetailMap[projectservice.id];
        //     console.log("message::",formData)
        //     console.log("message::",formData.status)
        //     return formData && formData.status === 'Cleared';
        // };

        // vm.checkSurveyFormStatus = function () {
        //     vm.projectservicelist.projectservicedetailDTOS.forEach(function (projectservice) {
        //         vm.surveyFormStatusMap[projectservice.id] = projectservice.surveyFormFilled === true;
        //     });
        // };
        //
        //
        //
        //
        vm.checkSurveyFormStatus = function () {
            vm.surveyFormStatusMap = {}; // clear before populating
            vm.projectservicelist.projectservicedetailDTOS.forEach(function (projectservice, index) {
                vm.surveyFormStatusMap[index] = projectservice.surveyFormFilled === true;
            });
        };

        vm.checkSurveyFormStatus();


        /** Status of the application, worded the way the status filter words it. */
        function statusName(status) {
            return STATUS_NAMES[status] || status;
        }

        function statusTagClass(status) {
            return STATUS_TAG_CLASSES[status] || '';
        }

        function statusChange (status){
            if(status ==="All") {
                status="";
            }
            vm.formStatus =true;
           vm.statusFilter =status;
           if(status===""){
            vm.formStatus= "";
           }
            if(status === "Required"){
                vm.statusFilter = "Pending";
                vm.formStatus = false;
            }

        }
        console.log('All Details:', vm.projectServiceDetails);

        loadAllDepartments();

        $scope.required={
            department: {},
            municipal:{}
        };

        $scope.clear= function () {
            $scope.required.department=[];
            vm.aboveMunicipal = null;
            $scope.requiredMunicipal = [];
            $scope.required.belowMunicipal = null

        };

        $scope.cancel= function () {
            $scope.required.department=[];
            vm.aboveMunicipal = null;
            $scope.requiredMunicipal = [];
            $scope.required.belowMunicipal = null

        };

        Project.get({id: vm.projectid},function (result) {
            vm.caftype = result.caftype;
            vm.cafpinNew = result.cafpin;
            checkForceMajeure(result.district);
        });

        function checkForceMajeure(district) {
            ForceMajeureService.checkForceMajeure(
                { district: district },
                function (responseArray) {

                    // If array has entries → Force Majeure exists
                    if (responseArray && responseArray.length > 0) {
                        vm.isForceMajeure = true;

                    }
                }
            );
        }

        vm.updateCheck = function (check) {
            $scope.required.department=[];
            $scope.required.department.push(check);
            if(check==='MUNICIPAL COUNCIL' || check==='MUNICIPAL COMMITTEE'|| check==='MUNICIPAL CORPORATION'){
                Municipals.query({district:$stateParams.district,name:$scope.required.department},function(result) {
                    vm.municipals = result;
                    vm.searchQuery = null;
                });
                $('#tower_department2').modal('hide');
                $('#YourModalId').modal('show');
            }
        };

        vm.BelowGround = function(check){
            if(check==='MUNICIPAL COUNCIL' || check==='MUNICIPAL COMMITTEE'|| check==='MUNICIPAL CORPORATION'){
                Municipals.query({district:$stateParams.district,name:check},function(result) {
                    vm.municipals = result;
                    vm.searchQuery = null;
                    if($scope.required.department.indexOf(check) != -1) {
                        $('#tower_department3').modal('hide');
                        $('#belowGround').modal('show');
                    } else {
                        for (var im = 0; im < vm.municipals.length; im++) {
                            var indexvalue = $scope.requiredMunicipal.indexOf(vm.municipals[im].name) ;
                            if(indexvalue != -1) {
                                $scope.requiredMunicipal.splice(indexvalue, 1);
                            }
                        }
                    }
                });

            }
        };

        vm.markRequiredForBelow = function(service,department,municipal){
            for(var i = 0; i<municipal.length; i++ ) {
                if ($scope.requiredMunicipal.indexOf(municipal[i]) < 0) {
                    $scope.requiredMunicipal.push(municipal[i]);
                }
            }
            $scope.required.belowMunicipal =null;

            $('#belowGround').modal('hide');
            $('#tower_department3').modal('show');
        };

        // vm.updateMunicipal = function (munici) {
        //     $scope.required.municipal=[];
        //     $scope.required.municipal.push(munici);
        //
        // };

        vm.markRequiredForMunicipal = function (service,department,municipal) {
            if ($scope.requiredMunicipal.indexOf(municipal) < 0) {
                $scope.requiredMunicipal.push(municipal);
            }
            vm.updateTowerServiceNO(service);

        };

        Principal.identity().then(function(account) {
            vm.account = account;
            if(angular.equals(vm.account.login,"deskof")){
                vm.isDeskof = true;
            }
        });

        vm.selectedDepartment =function(){
         vm.department=vm.department || 'all';
         vm.constructionpermit=vm.constructionpermit||'all';

            vm.projectservicelist.projectservicedetailDTOS=[];
         if (vm.department==='all' && vm.constructionpermit==='all') {
            vm.projectservicelist.projectservicedetailDTOS=vm.tempDataHandler.projectservicedetailDTOS;
            return;
         }
         else if (vm.department==='all' && vm.constructionpermit!=='all'){
             for (var i = 0; i < vm.tempDataHandler.projectservicedetailDTOS.length; i++) {
                 if (vm.tempDataHandler.projectservicedetailDTOS[i].constructionPermit===vm.constructionpermit) {
                     vm.projectservicelist.projectservicedetailDTOS.push(vm.tempDataHandler.projectservicedetailDTOS[i])
                 }
             }
         }
         else if (vm.department!=='all' && vm.constructionpermit==='all'){
             for (var i = 0; i < vm.tempDataHandler.projectservicedetailDTOS.length; i++) {
                 if (vm.tempDataHandler.projectservicedetailDTOS[i].departmentName===vm.department) {
                     vm.projectservicelist.projectservicedetailDTOS.push(vm.tempDataHandler.projectservicedetailDTOS[i])
                 }
             }
         }else {
             for (var i = 0; i < vm.tempDataHandler.projectservicedetailDTOS.length; i++) {
                 if (vm.tempDataHandler.projectservicedetailDTOS[i].departmentName===vm.department && vm.tempDataHandler.projectservicedetailDTOS[i].constructionPermit===vm.constructionpermit) {
                     vm.projectservicelist.projectservicedetailDTOS.push(vm.tempDataHandler.projectservicedetailDTOS[i])
                 }
             }
         }
        };

        vm.selectedPermit =function(){
            vm.department=vm.department || 'all';
            vm.constructionpermit=vm.constructionpermit||'all';

            vm.projectservicelist.projectservicedetailDTOS=[];
            if (vm.department==='all' && vm.constructionpermit==='all') {
                vm.projectservicelist.projectservicedetailDTOS=vm.tempDataHandler.projectservicedetailDTOS;
                return;
            }
            else if (vm.department==='all' && vm.constructionpermit!=='all'){
                for (var i = 0; i < vm.tempDataHandler.projectservicedetailDTOS.length; i++) {
                    if (vm.tempDataHandler.projectservicedetailDTOS[i].constructionPermit===vm.constructionpermit) {
                        vm.projectservicelist.projectservicedetailDTOS.push(vm.tempDataHandler.projectservicedetailDTOS[i])
                    }
                }
            }
            else if (vm.department!=='all' && vm.constructionpermit==='all'){
                for (var i = 0; i < vm.tempDataHandler.projectservicedetailDTOS.length; i++) {
                    if (vm.tempDataHandler.projectservicedetailDTOS[i].departmentName===vm.department) {
                        vm.projectservicelist.projectservicedetailDTOS.push(vm.tempDataHandler.projectservicedetailDTOS[i])
                    }
                }
            }else {
                for (var i = 0; i < vm.tempDataHandler.projectservicedetailDTOS.length; i++) {
                    if (vm.tempDataHandler.projectservicedetailDTOS[i].departmentName===vm.department && vm.tempDataHandler.projectservicedetailDTOS[i].constructionPermit===vm.constructionpermit) {
                        vm.projectservicelist.projectservicedetailDTOS.push(vm.tempDataHandler.projectservicedetailDTOS[i])
                    }
                }
            }
        };

        vm.fillform=fillform;
        function fillform(projectservice,requestType)
        {
            if(projectservice.serviceid === '16b4d378-5723-4adc-85e9-de55da296008'){
                $state.go('aai-fillform', {projectserviceid:projectservice.id});
            }
            else if (projectservice.serviceid === 'bdb451cb-f12b-4352-8360-e6e3a715386f'){
                Project.get({id: vm.projectid},function (result) {
                    $state.go('nma-serviceForm-fillform', {projectserviceid:projectservice.id,cafpin: result.cafpin});
                })
            }
            else if(projectservice.serviceid === 'ee348d5a-48c9-484c-81db-76fa10938e82'){
                $state.go('landexchange-form', {projectserviceid:projectservice.id});
            }
            else if(projectservice.serviceid === 'f2c426f3-33a3-4a20-8065-6e6a553c1af1'){
                $state.go('ULBlandexchange-form', {projectserviceid:projectservice.id});
            }
            else if((projectservice.isIntegrated === true))
            {
                getAccount(projectservice,requestType);
            }
            else
            {
                $state.go('serviceForm-fillform', {projectserviceid: projectservice.id});
            }
        }

        function getAccount(projectservice,requestType) {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.id=vm.account.id;
                $state.go('i-serviceform',{projectid:vm.projectservicelist.projectid,serviceid:projectservice.serviceid,projectserviceid:projectservice.id,id:vm.id,markeddate:projectservice.requireMarkedOnDate,requestType: requestType});
            });
        }

        function showFillServiceForm(projectservice)
        {
            if((projectservice.isRequired === true))
            {
                if (vm.caftype === 'Shop' && projectservice.departmentName==='EXCISE & TAXATION - EXCISE') {
                    return false
                }
                
                if((projectservice.status==='Cleared')||(projectservice.status==='Declined')||(projectservice.status==='Rejected')||projectservice.status === 'DeemedCleared' )
                {
                    return false;
                }
                else if(projectservice.isIntegrated === true)
                {

                    if(projectservice.formFilledStatus !== true){
                        if((projectservice.renewable || projectservice.shop || projectservice.istowerservice || projectservice.islandexchange || projectservice.rowService || projectservice.newService || projectservice.landRequirement || projectservice.isprojectfilm || projectservice.exciseService)){
                           return true;
                        }else{
                            return false;
                        }
                    }
//                    return projectservice.formFilledStatus !== true;
                    return false;
                }
                else
                {
                    if ((projectservice.renewable || projectservice.shop || projectservice.istowerservice || projectservice.islandexchange || projectservice.rowService || projectservice.newService || projectservice.landRequirement || projectservice.isprojectfilm || projectservice.exciseService)) {
                        return true;
                    }

                    return false;
                }

            }
            return false;
        }

        function showTrackServiceForm(projectservice)
        {
            if((projectservice.isRequired === true))
            {
                if (vm.caftype === 'Shop' && projectservice.departmentName==='EXCISE & TAXATION - EXCISE') {
                    return false
                }
                return (projectservice.isIntegrated === true && projectservice.formFilledStatus === true);
            }
            return false;
        }

        getServiceCount();
        function getServiceCount()
        {
           vm.departmentServices =  DepartmentService.query();
            vm.count =vm.projectservicelist=ProjectservicedetailbyProject.get({id : vm.projectid, status:"inProcess"},function(result){

            vm.tempDataHandler=angular.copy(vm.projectservicelist);

           });
           vm.totalServicesInProcess = vm.count.length;
           vm.totalserviceRequired = (vm.departmentServices.length)-(vm.totalServicesInProcess);
        }
        function loadProjectServices(status)
        {
             vm.department='all';
             vm.constructionpermit='all';

            vm.projectservicelist=ProjectservicedetailbyProject.get({id : vm.projectid, status:status},function(result){

                vm.tempDataHandler=angular.copy(vm.projectservicelist);
            });
            if(status =="required")
                vm.title = "Service Required";
            else
                vm.title = "Service Clearances in Process";
        }

        function loadAllDepartments(){
          Department.query(function(result){
            vm.departments=result;
          });
            if(vm.statusOnPage === 'All') {
                vm.statusFilter ="";
                vm.formStatus= "";
            }
        }

        function tower_departments(service,type) {
            $scope.required.department=[];
            vm.tower_service = service;
            vm.required_type = type;
            Department.query(function(result) {
                vm.tower_departmentlist = result;
            });
        }

        vm.updateTowerServiceNO= function (id) {
           vm.towerserviceNO.projectdetailId = id;
           vm.towerserviceNO.district = vm.district;
           vm.towerserviceNO.officerList = $scope.required.department;
           if($scope.requiredMunicipal.length !== 0) {
                for (var i = 0; i < $scope.requiredMunicipal.length; i++ ) {
                    if(vm.towerserviceNO.subname) {
                        vm.towerserviceNO.subname = vm.towerserviceNO.subname + "," + $scope.requiredMunicipal[i];
                    } else {
                        vm.towerserviceNO.subname = $scope.requiredMunicipal[i];
                    }
                }
            }
            // Projectservicedetail.get({id: vm.towerserviceNO.projectdetailId},function (data) {
            //     vm.projectServiceLog.projectid = $stateParams.projectid;
            //     vm.projectServiceLog.serviceid = data.serviceid;
            //     vm.projectServiceLog.comments = vm.towerserviceNO.subname;
            //     vm.projectServiceLog.actionTaken = vm.towerserviceNO.subname;
            //     Projectlogupdated.save(vm.projectServiceLog, function (data) {
            //         console.log(data);
            //     }, function (error) {
            //         console.log(error);
            //     });
            // });
           TowerserviceNO.save({id: '1'}, vm.towerserviceNO);
            vm.requiredMunicipal= [];
            location.reload();
            vm.towerserviceNO = {};

        };

        function isTowerService(projectservice) {
            var isNodalOfficer=Principal.hasAnyAuthority(['ROLE_NODAL_OFFICER']);
            return !!(isNodalOfficer && (projectservice.serviceid === '5f8e0757-e88b-4ef1-bb15-00a9e984b9b1' || projectservice.serviceid === '58d75fd4-f360-4931-a484-ff9be0adc12c' || projectservice.serviceid === '741f0f60-cf69-4659-8b19-19d96ffe0103' || projectservice.serviceid === 'fc1b1635-d3dc-4d30-a5fd-5abf6381594d' || projectservice.serviceid === '6f81801c-59c6-4773-9f37-a5d81172a1bf'));

        }

        /**
         * The application may be clarified for 15 days from the day its service form
         * was filled - that day included, so a form filled today leaves 14 more days.
         *
         * Only once: an application that has already been clarified keeps that stamp for
         * good, so the button does not come back when the applicant answers and the
         * reverted flag is taken off again.
         */
        function canClarifyIntimation(projectservice) {
            if (!isAboveGroundIntimation(projectservice)) {
                return false;
            }
            if (projectservice.clarifiedOnce) {
                return false;
            }
            if (projectservice.reverted) {
                return false;
            }
            if (!projectservice.formFilledOnDate) {
                return false;
            }

            var filledOn = new Date(projectservice.formFilledOnDate);
            if (isNaN(filledOn.getTime())) {
                return false;
            }

            return daysSince(filledOn) < CLARIFY_WINDOW_DAYS;
        }

        /**
         * An acknowledged intimation is the officer's to approve or reject - approving
         * it stands it as valid, rejecting it takes it away, and either way the
         * application leaves the acknowledged state and the buttons go with it.
         */
        function canDecideIntimation(projectservice) {
            return isAboveGroundIntimation(projectservice) && projectservice.status === STATUS_ACKNOWLEDGED;
        }

        /** Above Ground, on a property the applicant does not share with a public entity. */
        function isAboveGroundIntimation(projectservice) {
            if (!projectservice.serviceid || String(projectservice.serviceid).toLowerCase() !== ABOVE_GROUND_SERVICE_ID) {
                return false;
            }

            return !!projectservice.property
                && projectservice.property.trim().toLowerCase() === OTHER_THAN_PUBLIC_PROPERTY;
        }

        /**
         * Whole days between the two dates, counted on the calendar - a form filled
         * late in the evening still gets every one of its days.
         */
        function daysSince(date) {
            var from = new Date(date.getFullYear(), date.getMonth(), date.getDate());
            var now = new Date();
            var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

            return Math.round((today - from) / 86400000);
        }

        function isTowerServiceForWithdraw(projectservice) {

            return !!((projectservice.serviceid === '5f8e0757-e88b-4ef1-bb15-00a9e984b9b1' || projectservice.serviceid === '58d75fd4-f360-4931-a484-ff9be0adc12c' || projectservice.serviceid === '741f0f60-cf69-4659-8b19-19d96ffe0103' || projectservice.serviceid === 'fc1b1635-d3dc-4d30-a5fd-5abf6381594d' || projectservice.serviceid === '6f81801c-59c6-4773-9f37-a5d81172a1bf'));

        }

        vm.showReApply = function (projectservice) {
            //for Land Allotment Service
            if(projectservice.serviceId ==='077f3112-69e6-41ea-a2e5-75b4925d6900'){
                return false;
            }
            if((projectservice.status ==='Cleared' || projectservice.status ==='Declined') && projectservice.isIntegrated && projectservice.serviceActive===true && (projectservice.renewable || projectservice.shop || projectservice.istowerservice || projectservice.islandexchange || projectservice.rowService || projectservice.newService)){
                return true;
            }else {
                return false;
            }
        };
        vm.closeModal = function () {
            $scope.required.department=[];
            $('#YourModalId').modal('hide');
            $('#tower_department2').modal('hide');
            vm.aboveMunicipal = null;
            $scope.requiredMunicipal = [];
        };

        vm.closeBelow = function () {
            $scope.required.department=[];
            $scope.requiredMunicipal = [];
            $scope.required.belowMunicipal =null;
            $('#belowGround').modal('hide');
            $('#tower_department3').modal('hide');
            vm.aboveMunicipal = null;
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('serviceClearanceController', serviceClearanceController);

    serviceClearanceController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService','projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServiceReportInfoForClearance'];
    function serviceClearanceController ($timeout, $scope, $stateParams, $uibModalInstance, projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail,ProjectServiceReportInfoForClearance) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService = projectService;
//        vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({projectid:vm.projectService.projectid,department:vm.projectService.departmentName,service:vm.projectService.serviceName});
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        $scope.file = {};
        vm.clear = clear;
        vm.clearService = clearService;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function clearService (){
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="Cleared";

            if(angular.isDefined(vm.projectAttachemnt.file)){
                var fileNameArray = vm.projectAttachemnt.file.name.split(".");
                if ((fileNameArray.length == 2)) {
                    if(fileNameArray[0] != ""){
                        ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);

                    }
                    else {
                        alert("Invalid File Name");
                    }
                }
                else{
                    alert("Please select correct file format")
                }
            }
            else {
                ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);

            }
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="Cleared";
            vm.projectService.clearedDate=result.commentDate;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }
//        function onUpdateProjectServiceSuccess(result)
//        {
//            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
//            vm.projectservicereportinfo.status='Cleared';
//            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
//        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Clearance Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

//        function onUpdateProjectServiceReportInfoError()
//        {
//            vm.isSaving = false;
//        }
        function onUpdateProjectAttachmentError()
        {
//            alert('file attachment not updated');
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RequiredListController', RequiredListController);

    RequiredListController.$inject = ['$scope', '$stateParams','$state','$filter', 'Principal', 'Projectservicedetail', 'projectServiceLog', 'ProjectServiceLogUpdated', 'ProjectservicedetailbyProject', 'Department', 'TowerserviceNO','Municipals', 'TowerServiceNoRequire'];

    function RequiredListController ($scope, $stateParams, $state,$filter, Principal, Projectservicedetail, projectServiceLog, ProjectServiceLogUpdated, ProjectservicedetailbyProject, Department, TowerserviceNO,Municipals, TowerServiceNoRequire ) {
        var vm = this;
        vm.projectid = $stateParams.projectid;

        vm.projectServiceLog = projectServiceLog;
        vm.selectedprojectservice = {};
        vm.tower_departments = tower_departments;
        vm.saveTowerServiceNO = saveTowerServiceNO;
        vm.markRequired = markRequired;
        vm.municipals = [];
        $scope.requiredMunicipal = [];
        // vm.tower_departmentlist =[];

        $scope.required = {
            department: {},
            municipals: {}
        };

        $scope.clear = function () {
            $scope.required.belowMunicipal = null;
            $scope.required.department = [];
            $scope.requiredMunicipal = [];
            vm.aboveMunicipal = null;
        };
        $scope.cancel = function () {
            $scope.requiredMunicipal = [];
            $scope.required.department = [];
            vm.aboveMunicipal = null;
            $scope.required.belowMunicipal = null;

        };
        vm.towerserviceNO = {};

        getAccount();
        loadProjectServices();

        vm.selectedDepartment = function () {
            vm.department = vm.department || 'all';
            vm.constructionpermit = vm.constructionpermit || 'all';

            vm.projectservicelist.projectservicedetailDTOS = [];
            if (vm.department === 'all' && vm.constructionpermit === 'all') {
                vm.projectservicelist.projectservicedetailDTOS = vm.tempDataHandler.projectservicedetailDTOS;
                return;
            }
            else if (vm.department === 'all' && vm.constructionpermit !== 'all') {
                for (var i = 0; i < vm.tempDataHandler.projectservicedetailDTOS.length; i++) {
                    if (vm.tempDataHandler.projectservicedetailDTOS[i].constructionPermit === vm.constructionpermit) {
                        vm.projectservicelist.projectservicedetailDTOS.push(vm.tempDataHandler.projectservicedetailDTOS[i])
                    }
                }
            }
            else if (vm.department !== 'all' && vm.constructionpermit === 'all') {
                for (var i = 0; i < vm.tempDataHandler.projectservicedetailDTOS.length; i++) {
                    if (vm.tempDataHandler.projectservicedetailDTOS[i].departmentName === vm.department) {
                        vm.projectservicelist.projectservicedetailDTOS.push(vm.tempDataHandler.projectservicedetailDTOS[i])
                    }
                }
            } else {

                for (var i = 0; i < vm.tempDataHandler.projectservicedetailDTOS.length; i++) {
                    if (vm.tempDataHandler.projectservicedetailDTOS[i].departmentName === vm.department && vm.tempDataHandler.projectservicedetailDTOS[i].constructionPermit === vm.constructionpermit) {
                        vm.projectservicelist.projectservicedetailDTOS.push(vm.tempDataHandler.projectservicedetailDTOS[i])
                    }
                }
            }
        };


        vm.updateCheck = function (check) {
            $scope.required.department = [];
            $scope.required.department.push(check);
            if (check === 'MUNICIPAL COUNCIL' || check === 'MUNICIPAL COMMITTEE' || check === 'MUNICIPAL CORPORATION') {
                alert('Kindly exercise due diligence before selecting the entity under which your tower land falls, since the fee regarding the same shall be directly transferred to the selected entity only');
                Municipals.query({district: $stateParams.district, name: $scope.required.department}, function (result) {
                    vm.municipals = result;
                    vm.searchQuery = null;
                });
                $('#tower_department1').modal('hide');
                $('#YourModalId').modal('show');
            }
        };

        vm.BelowGround = function (check) {
            if (check === 'MUNICIPAL COUNCIL' || check === 'MUNICIPAL COMMITTEE' || check === 'MUNICIPAL CORPORATION') {
                Municipals.query({district: $stateParams.district, name: check}, function (result) {
                    vm.municipals = result;
                    vm.searchQuery = null;
                // )};
                    if($scope.required.department.indexOf(check) != -1) {
                        $('#tower_department').modal('hide');
                        $('#belowGround').modal('show');
                    } else {
                        for (var im = 0; im < vm.municipals.length; im++) {
                            var indexvalue = $scope.requiredMunicipal.indexOf(vm.municipals[im].name) ;
                            if(indexvalue != -1) {
                                $scope.requiredMunicipal.splice(indexvalue, 1);
                            }
                        }
                    }
                });
            }
        };

        // vm.updateMunicipalForBelow = function (munici) {
        //     $scope.required.belowMunicipal = null;
        //     $scope.required.belowMunicipal = munici;
        // };

        // vm.updateMunicipal = function (munici) {
        //     // $scope.requiredMunicipal=[];
        //     $scope.requiredMunicipal = null;
        //     $scope.requiredMunicipal = munici;
        //
        // };

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.id = vm.account.id;
            });
        }

        function loadProjectServices() {
            ProjectservicedetailbyProject.get({id: vm.projectid, status: 'required'}, function (result) {
                vm.projectservicelist = result;
                checkBusinessEntity();
            });
        }

        function checkBusinessEntity() {

            ProjectservicedetailbyProject.checkBusinessEntity({
                id: vm.projectid
            }).$promise.then(function(response) {

                if (response.valid) {
                    vm.showCentreScheme = true;

                } else {
                    vm.showCentreScheme = true;
                    removeCentreSchemeDepartment();
                }

            });

        }

        function removeCentreSchemeDepartment() {

            angular.forEach(vm.projectservicelist.projectservicedetailDTOS,function(item,index){

                if(item.departmentName === 'Centre Scheme'){

                    vm.projectservicelist.projectservicedetailDTOS.splice(index,1);

                }

            });

        }

        vm.markRequiredForBelow = function (service, department, municipal) {
            for (var i = 0; i < municipal.length; i++) {
                if ($scope.requiredMunicipal.indexOf(municipal[i]) < 0) {
                    $scope.requiredMunicipal.push(municipal[i]);
                }
            }
            $scope.required.belowMunicipal =null;

            $('#belowGround').modal('hide');
                $('#tower_department').modal('show');
        };

        vm.markRequiredForMunicipal = function (service, department, municipal) {
            if ($scope.requiredMunicipal.indexOf(municipal) < 0) {
                $scope.requiredMunicipal.push(municipal);
            }
            // $('#tower_department1').modal('hide');
            markRequired(service, department);
            $('#YourModalId').modal('hide');

        };

        function markRequired(projectservice, departmentName) {
            vm.isSaving = true;
            vm.selectedprojectservice = projectservice;
            projectservice.isRequired = true;
            if (departmentName != null) {
                projectservice.departmentName = "" + departmentName;
            }

            vm.towerServiceNORequire = {};
            vm.towerServiceNORequire.projectId = projectservice.projectid;
            vm.towerServiceNORequire.serviceId = projectservice.serviceid;
            vm.towerServiceNORequire.officerList = $scope.required.department || [];
            if ($scope.requiredMunicipal.length != 0) {
                for (var i = 0; i < $scope.requiredMunicipal.length; i++) {
                    if (vm.towerServiceNORequire.subname) {
                        vm.towerServiceNORequire.subname = vm.towerserviceNO.subname + "," + $scope.requiredMunicipal[i];
                    } else {
                        vm.towerServiceNORequire.subname = $scope.requiredMunicipal[i];
                    }
                }

            }
            if (Object.keys($scope.required.department).length === 0) {
                Projectservicedetail.save(projectservice, onMarkSuccess, onMarkError);
            } else {
                TowerServiceNoRequire.save(vm.towerServiceNORequire, function () {
                    Projectservicedetail.save(projectservice, onMarkSuccess, onMarkError);
                });
            }
        }

        function onMarkSuccess(result) {
            if (vm.required_type === 'tower') {
                saveTowerServiceNO(result.id);
                $scope.clear();
            }
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            onSaveSuccess();
        }

        function onSaveSuccess(result) {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            vm.projectServiceLog.projectid = vm.selectedprojectservice.projectid;
            vm.projectServiceLog.serviceid = vm.selectedprojectservice.serviceid;
            vm.projectServiceLog.comments = "MarkedRequired";
            vm.projectServiceLog.actionTaken = "MarkedRequired";
            ProjectServiceLogUpdated.save(vm.projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);
        }

        function onMarkError() {
        }

        function onServiceLogSaveSuccess(result) {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            vm.isSaving = false;
        }

        function onServiceLogSaveError() {
        }


        function tower_departments(service, type,name) {
            $scope.required.department = [];
            vm.tower_service = service;
            vm.required_type = type;
            Department.query(function (result) {
                vm.tower_departmentlist = result;
            });
            if(name==='above'){
                $('#tower_department1').modal('show');
            }
            if(name==='below'){
                $('#tower_department').modal('show');
            }
        }


        function saveTowerServiceNO(id) {
            vm.towerserviceNO.projectdetailId = id;
            vm.towerserviceNO.district = $stateParams.district;
            vm.towerserviceNO.officerList = $scope.required.department;
            if ($scope.requiredMunicipal.length != 0) {
                for (var i = 0; i < $scope.requiredMunicipal.length; i++) {
                    if (vm.towerserviceNO.subname) {
                        vm.towerserviceNO.subname = vm.towerserviceNO.subname + "," + $scope.requiredMunicipal[i];
                    } else {
                        vm.towerserviceNO.subname = $scope.requiredMunicipal[i];
                    }
                }

            }
            TowerserviceNO.save(vm.towerserviceNO, saveSuccess);

            vm.towerserviceNO = {};
        }

        function saveSuccess(result) {
            vm.towerserviceNO = {};
            $scope.requiredMunicipal = [];
            $scope.required.department = [];
            vm.aboveMunicipal = null;
        }

        vm.closeModal = function () {
            vm.aboveMunicipal = null;
            $scope.requiredMunicipal = [];
            $scope.required.belowMunicipal =null;
            $('#YourModalId').modal('hide');
            $('#tower_department').modal('hide');
        };

        vm.closeBelow = function () {
            $scope.requiredMunicipal = [];
            $scope.required.belowMunicipal =null;
            vm.aboveMunicipal = null;
            $('#belowGround').modal('hide');
            $('#tower_department1').modal('hide');

        }
    }

})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('rejectDialogController', rejectDialogController);

    rejectDialogController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService', 'projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServiceReportInfoForClearance'];
    function rejectDialogController ($timeout, $scope, $stateParams, $uibModalInstance,projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail,ProjectServiceReportInfoForClearance) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService=projectService;
//        vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({department:vm.projectService.departmentName,projectid:vm.projectService.projectid,service:vm.projectService.serviceName});
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        $scope.file = {};
        vm.clear = clear;
        vm.rejectService = rejectService;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function rejectService(){
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="Rejected";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="Rejected";
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }
//        function onUpdateProjectServiceSuccess(result)
//        {
//            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
//            vm.projectservicereportinfo.status='Rejected';
//            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
//        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Rejection Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

//        function onUpdateProjectServiceReportInfoError()
//        {
//            vm.isSaving = false;
//        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('reactivateDialogController', reactivateDialogController);

    reactivateDialogController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService', 'projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServiceReportInfoForClearance'];
    function reactivateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail,ProjectServiceReportInfoForClearance) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService=projectService;
        vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({department:vm.projectService.departmentName,projectid:vm.projectService.projectid,service:vm.projectService.serviceName});
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        $scope.file = {};
        vm.clear = clear;
        vm.reactivateService = reactivateService;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function reactivateService(){
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="Re-Activate";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="Pending";
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            vm.projectservicereportinfo.status='Re-Activate';
            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
        }
        function onUpdateProjectServiceReportInfoSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Re-Activate Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onUpdateProjectServiceReportInfoError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('paymentResponseController', paymentResponseController);

    paymentResponseController.$inject = ['$timeout', '$scope', '$stateParams','$state', 'Auth', 'Principal','$location'];

    function paymentResponseController ($timeout, $scope, $stateParams, $state, Auth, Principal, $location) {
        var vm = this;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        vm.response= $location.search();
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('otherServicePaymentController', otherServicePaymentController);

    otherServicePaymentController.$inject = ['$window', '$timeout','$scope','$sce','$stateParams', '$filter','$uibModalInstance','AssignServiceFee', 'projectService', 'projectServiceLog','ProjectServiceLogUpdated','FeePayment','projectServicePayment','Projectservicedetail','ProjectServicePaymentDetails','Payment','TowerserviceNO','MunicipalPaymentParams', 'Project'];
    function otherServicePaymentController ($window, $timeout, $scope, $sce, $stateParams, $filter, $uibModalInstance, AssignServiceFee, projectService, projectServiceLog, ProjectServiceLogUpdated, FeePayment,projectServicePayment,Projectservicedetail,ProjectServicePaymentDetails,Payment,TowerserviceNO, MunicipalPaymentParams, Project) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectService=projectService;
        vm.projectServicePayment=projectServicePayment;
        vm.servicePaymentList=null;
        vm.municipalPaymentParams = [];
        vm.projectDistrict = {};

        vm.servicePaymentList=AssignServiceFee.query({id:vm.projectService.id, projectid:vm.projectService.projectid, serviceid:vm.projectService.serviceid});
        var projectServiceLogid=null;
        vm.clear = clear;
        vm.enableButton=[];
        vm.enableButton1=[];
        vm.enableButton2=[];
        vm.towerserviceNOS = [];
        vm.individualPay=individualPay;
        vm.get_chart=get_chart;
        vm.loadServiceFee=loadServiceFee;
        loadServiceFee();
        vm.projectDistrict = $stateParams.district;


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function get_chart()
        {

      //  example_chart=vm.paymentparameters;
        //console.log(example_chart);

        }


        function loadServiceFee()
        {
            {
                if (vm.projectService.serviceFee != null) {
                    vm.projectServicePayment.paymentMade = vm.projectService.serviceFee;
                    vm.projectServicePayment.isPaymentMade = vm.projectService.isPaymentMade;
                }
                else
                    vm.projectServicePayment.paymentMade = 0;
            }

            TowerserviceNO.query({id: '1', projectdetailid: '1', projectdservicedetailid: vm.projectService.id},function(result) {
                vm.towerserviceNOS = result;
                vm.searchQuery = null;
                vm.show = true;
                payment();
            });

        }
        function payment(){
            if(vm.towerserviceNOS[0].subname != null){
                MunicipalPaymentParams.query({name:vm.towerserviceNOS[0].subname},function(result) {
                    vm.municipalPaymentParams = result;
                    vm.searchQuery = null;
                });
            }
            if(vm.towerserviceNOS[0].subname == null) {
                if (vm.projectService.departmentName === 'ZILA PARISHAD') {
                    MunicipalPaymentParams.query({
                        name: vm.projectService.departmentName,
                        district: $stateParams.district
                    }, function (result) {
                        vm.municipalPaymentParams = result;
                        vm.searchQuery = null;
                    });
                }
                else {
                    if(!(vm.projectService.departmentName === 'ZILA PARISHAD' || vm.projectService.departmentName === "MUNICIPAL COUNCIL" || vm.projectService.departmentName === 'MUNICIPAL COMMITTEE'
                        || vm.projectService.departmentName === 'MUNICIPAL CORPORATION'))
                    {
                        MunicipalPaymentParams.query({name: vm.projectService.departmentName}, function (result) {
                            vm.municipalPaymentParams = result;
                            vm.searchQuery = null;
                        });
                    }
                }
            }
        }

        function individualPay(id,amount)
        {

            vm.enableButton='value';
                if(vm.municipalPaymentParams.length !==0) {
                    Payment.get({id: id, projectid: vm.projectService.projectid, amount: amount, serviceid: vm.projectService.serviceid}, function (result) {
                        vm.paymentparameters = result;
                        vm.enableButton1 = 'value';
                        var check = vm.paymentparameters.formPostUrl;
                        $scope.actionURL = $sce.trustAsResourceUrl(check);
                    });

                }
                else{
                    allPayment(id, amount);
                }



//            vm.paymentparameters = FeePayment.get({id:id, projectid:vm.projectService.projectid,amount:amount,serviceid:vm.projectService.serviceid});
//            $scope.actionURL = $sce.trustAsResourceUrl(vm.paymentparameters.formPostUrl);
//             else{
//                 // FeePayment.get({id:id, projectid:vm.projectService.projectid,amount:amount,serviceid:vm.projectService.serviceid},function(result) {
//                 //     vm.paymentparameters = result;
//                 //     vm.enableButton2='value';
//                 //     console.log(vm.paymentparameters);
//                 //     var check = vm.paymentparameters.formPostUrl;
//                 //     console.log(check);
//                 //     $scope.actionURL = $sce.trustAsResourceUrl(check);
//                 // });
//                 allPayment(id,amount);
//         }
    }

        function allPayment(id,amount){
            FeePayment.get({id:id, projectid:vm.projectService.projectid,amount:amount,serviceid:vm.projectService.serviceid},function(result) {
                vm.paymentparameters = result;
                vm.enableButton2='value';
                var check = vm.paymentparameters.formPostUrl;
                $scope.actionURL = $sce.trustAsResourceUrl(check);
            });
        }


    }
})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandexchangeDialogController2', LandexchangeDialogController2);

    LandexchangeDialogController2.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Landexchange', 'projectServiceLog', 'projectAttachemnt', 'projectServiceFormFieldData', 'projectService', 'ProjectServiceLogUpdated', 'Projectservicedetail', 'FileManagement', 'ServiceFormAttachments', 'District', 'Block', 'Tehsil_subtehsil'];
    function LandexchangeDialogController2 ($timeout, $scope, $stateParams, $uibModalInstance, entity, Landexchange, projectServiceLog, projectAttachemnt, projectServiceFormFieldData, projectService, ProjectServiceLogUpdated, Projectservicedetail, FileManagement, ServiceFormAttachments, District, Block, Tehsil_subtehsil) {
        var vm = this;

        vm.landexchange = entity;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectServiceFormFieldData=projectServiceFormFieldData;
        vm.projectService = projectService;

        vm.clear = clear;
        vm.save = save;
        var projectServiceLogid=null;
        vm.serviceformattachment={};
        $scope.file = {};
        loadAll();

        function loadAll() {
            District.query(function(result) {
                vm.districts = result;
                vm.searchQuery = null;
            });
            Block.query(function(result) {
                vm.blocks = result;
                vm.searchQuery = null;
            });
            Tehsil_subtehsil.query(function(result) {
                vm.tehsil_subtehsils = result;
                vm.searchQuery = null;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.landexchange.id= projectService.id;
            Landexchange.update(vm.landexchange, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:landexchangeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.comments="Form Edited";
            vm.projectServiceLog.actionTaken="Service Form Filled";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }

        function onServiceLogSaveSuccess(result) {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments="Service form edited";
            vm.projectService.formFilledStatus=true;
            Projectservicedetail.update(vm.projectService);
        }

        vm.upload= function(attachment) {
            var fileNameArray = attachment.name.split(".");
            var description="";
            if((fileNameArray.length>1))
            {
                description=fileNameArray[(fileNameArray.length-2)];
            }
            var filename = attachment.name;
            vm.serviceformfile = attachment;

            vm.serviceformattachment.isSaved=false;
            vm.serviceformattachment.description=description;
            vm.serviceformattachment.downloadfilename=filename;
            vm.serviceformattachment.clientfilename=filename;
            vm.serviceformattachment.projectID=vm.projectService.projectid;
            vm.serviceformattachment.serviceID=vm.projectService.serviceid;
            ServiceFormAttachments.save(vm.serviceformattachment,onSaveServiceFormAttachmentsSuccess);
        };

        function onSaveServiceFormAttachmentsSuccess(result) {
            console.log(result.id);
            var filename = result.id;
            var file = vm.serviceformfile;
            FileManagement.saveFile(file,filename);
            var fileNameArray = vm.serviceformfile.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            result.isSaved=true;
            result.serverfilename=inputFileName;
            ServiceFormAttachments.update(result,onServiceFormAttachmentUpdateSuccess);
        }

        function onServiceFormAttachmentUpdateSuccess() {
            alert("File Uploaded Successfully");
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }




    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandexchangeDetailController2', LandexchangeDetailController2);

    LandexchangeDetailController2.$inject = ['$scope', '$rootScope', '$stateParams', '$uibModalInstance', 'entity', 'Landexchange', 'serviceFormAttachments', 'downloadserviceformattachment'];

    function LandexchangeDetailController2($scope, $rootScope, $stateParams, $uibModalInstance, entity, Landexchange, serviceFormAttachments, downloadserviceformattachment) {
        var vm = this;

        vm.landexchange = entity;
        vm.serviceformattachments=serviceFormAttachments;
        console.log(serviceFormAttachments);
        vm.clear=clear;
        vm.pdfconverter=pdfconverter;
        vm.downloadFile=downloadFile;

        var unsubscribe = $rootScope.$on('investhryApp:landexchangeUpdate', function(event, result) {
            vm.landexchange = result;
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function pdfconverter () {
            var element = document.getElementById('pdf_data');
            html2pdf(element,{
                margin: 4
            });
        }

        function downloadFile(serverfilename,downloadfilename)
        {
            downloadserviceformattachment.download(serverfilename,downloadfilename)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    alert('Error : ' + error);
                });
        }

        $scope.$on('$destroy', unsubscribe);
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('iServiceFormController', iServiceFormController);

    iServiceFormController.$inject = ['$timeout', '$scope','Principal', '$stateParams', '$sce','Project','ExtendedUserInformation','Users','ExtendedUsers','Projectservicedetail'];

     function iServiceFormController($timeout, $scope,Principal, $stateParams, $sce, Project, ExtendedUserInformation,Users,ExtendedUsers,Projectservicedetail) {

        var vm = this;
        vm.urlsource = '';
        vm.methodType = 'GET';
        vm.projectid = $stateParams.projectid;
        vm.requestType = $stateParams.requestType;
        vm.uname = Users.login;//login
        vm.useremail = Users.email;
        vm.address=Project.address1+' '+Project.address2+' '+Project.address3;//investor address
        vm.mobile=Project.mobilenumber;
        vm.serviceid = $stateParams.serviceid;
        vm.projectserviceid = $stateParams.projectserviceid;
        vm.city = Project.cityname;
        vm.investorname = Project.firstname;
        vm.state = Project.statename;
        vm.country = Project.countryname;
        vm.niccode = Project.niccode;
        vm.cafType = Project.caftype;
        vm.projecttype = Project.projecttype;
        vm.pannumber = Project.pan_number;
        vm.gstnumber = Project.gstnumber;
        vm.projecttype = Project.projectype;
        vm.aadhar_number = Project.aadhar_number;
        vm.proposedbuilt_up_area = Project.proposedbuilt_up_area;
        vm.totalproposedprojectarea = Project.totalproposedprojectarea;
        vm.totalpurposedemployment = Project.totalpurposedemployment;
        vm.total_project_cost = Project.total_project_cost;
        vm.district = Project.district;
        vm.landzoneuse_type = Project.landzoneuse_type;
        vm.businessentity = Project.businessentity;
        vm.cafpin = Project.cafpin;
        vm.projectlevel = Project.projectlevel;
        vm.projectservicedetail=Projectservicedetail;

         if (Project.lastname!=null){
                    vm.investorname = Project.firstname+' '+Project.lastname;

                } else {
                     vm.investorname = Project.firstname;
       }
         if(vm.projectservicedetail.departmentName === 'EXCISE & TAXATION - EXCISE'){
             vm.methodType = 'POST';
         }

        vm.actionURL = $sce.trustAsResourceUrl(vm.projectservicedetail.url);
        alert("Redirecting to the URL: " + vm.projectservicedetail.url);

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
            angular.element(document.getElementById('fillform')).trigger('click')

        });

    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('deemedClearanceController', deemedClearanceController);

    deemedClearanceController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService','projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServiceReportInfoForClearance'];
    function deemedClearanceController ($timeout, $scope, $stateParams, $uibModalInstance, projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail,ProjectServiceReportInfoForClearance) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService = projectService;
        vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({projectid:vm.projectService.projectid,department:vm.projectService.departmentName,service:vm.projectService.serviceName});
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        vm.clear = clear;
        vm.deemedClearService = deemedClearService;
        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function deemedClearService(){
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="DeemedCleared";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="DeemedCleared";
            vm.projectService.deemedClearedDate = result.commentDate;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            vm.projectservicereportinfo.status='DeemedCleared';
            vm.projectservicereportinfo.projectid = result.projectid;
            vm.projectservicereportinfo.departmentname = result.departmentName;
            vm.projectservicereportinfo.servicename = result.serviceName;
            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
        }
        function onUpdateProjectServiceReportInfoSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Deemed Clearance Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }

            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onUpdateProjectServiceReportInfoError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('declineDialogController', declineDialogController);

    declineDialogController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService', 'projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServiceReportInfoForClearance', 'TowerRejectionReason', 'RejectedProjectServiceLog', 'ReasonCategory','TowerRejectionReasonByCategory'];
    function declineDialogController ($timeout, $scope, $stateParams, $uibModalInstance,projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail,ProjectServiceReportInfoForClearance, TowerRejectionReason, RejectedProjectServiceLog, ReasonCategory, TowerRejectionReasonByCategory) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService=projectService;
//        vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({department:vm.projectService.departmentName,projectid:vm.projectService.projectid,service:vm.projectService.serviceName});
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        $scope.file = {};
        vm.clear = clear;
        vm.declineService = declineService;
        vm.rejectedProjectServiceLog = {};
        vm.getReasons = getReasons;
        vm.getRejectionReason = getRejectionReason;
        vm.selectedCategory = {};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.rejectionReasons = [];
        vm.reasonCategories = [];

        loadAll();

        function loadAll() {
            ReasonCategory.query(function(result) {
                vm.reasonCategories = result;
                vm.searchQuery = null;
            });
        }

        function getRejectionReason(category) {
            TowerRejectionReasonByCategory.query({category: category.category}, function(result) {
                vm.rejectionReasons = result;
                vm.searchQuery = null;
            });
        }

        function getReasons() {
            var reasons = [];
            angular.forEach(vm.selectedReason, function (value, key) {
                reasons.push(value.reason);
            }, reasons);
            var rejection = reasons.join();

            var code = [];
            angular.forEach(vm.selectedReason, function (value, key) {
                code.push(value.code);
            }, code);
            vm.projectServiceLog.rejectionReason = rejection;
            vm.rejectedProjectServiceLog.reasonCode = code;
        }


        function declineService(){
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.reasonCategory = vm.selectedCategory.category;
            vm.projectServiceLog.actionTaken="Declined";

            if(angular.isDefined(vm.projectAttachemnt.file)){
                var fileNameArray = vm.projectAttachemnt.file.name.split(".");
                if ((fileNameArray.length == 2)) {
                    if(fileNameArray[0] != ""){
                        ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);

                    }
                    else {
                        alert("Invalid File Name");
                    }
                }
                else{
                    alert("Please select correct file format")
                }
            }
            else {
                ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);

            }


            // ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="Declined";
            vm.projectService.rejectionDate=result.commentDate;
            vm.rejectedProjectServiceLog.projectServiceLogId = projectServiceLogid;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
            RejectedProjectServiceLog.save(vm.rejectedProjectServiceLog);

        }
//        function onUpdateProjectServiceSuccess(result)
//        {
//            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
//            vm.projectservicereportinfo.status='Declined';
//            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
//        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Rejection Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

//        function onUpdateProjectServiceReportInfoError()
//        {
//            vm.isSaving = false;
//        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('constructionPermitController', constructionPermitController);

    constructionPermitController.$inject = ['$rootScope', '$timeout', '$scope', '$stateParams','$state', 'ConstructionPermitApprovalSteps', 'ConstructionPermitLog', 'ConstructionPermitApproval', 'FileManagement', 'InspectionReport', 'downloadserviceformattachment', 'Aai_service', 'Nma'];

    function constructionPermitController ($rootScope, $timeout, $scope, $stateParams, $state, ConstructionPermitApprovalSteps, ConstructionPermitLog, ConstructionPermitApproval, FileManagement, InspectionReport, downloadserviceformattachment, Aai_service, Nma) {
        var vm = this;
        vm.constructionPermit={};
        vm.inspectionReport={};
        vm.projectid = $stateParams.id;
        vm.constructionPermitLog={};
        vm.aai={};
        vm.nma={};
        vm.filesdata=[];
        // vm.constructionPermit.serviceId=null;

        $scope.creation_date= new Date();

        loadAll();

        $scope.$on("investhry: constructionPermitEvent",function (event) {
            loadAll();
        });

        function loadAll() {
            ConstructionPermitApproval.query({projectId: $stateParams.id},function (result) {
                vm.constructionPermit= result;
                // console.log(result);
            })
        }

        vm.viewNMA= function (id) {
            Nma.get({id: id},function (result) {
                console.log(result);
                vm.nma=result;
            })
        };

        vm.toggleShow=function () {
          vm.show=!vm.show;
        };

        vm.savePlinth= function () {
            vm.constructionPermitLog.projectid = vm.projectid;
            vm.constructionPermitLog.serviceid = vm.constructionPermit.serviceId;
            vm.constructionPermitLog.action = "Plinth Inspection Scheduled";
            ConstructionPermitLog.save(vm.constructionPermitLog,onplinthSaveSuccess);
        };

        function onplinthSaveSuccess(result) {
            vm.constructionPermit.pIflag=true;
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onCPsaveSuccess);
        }

        function onCPsaveSuccess() {
            loadAll();
        }

        vm.showInspectionReport= function () {
            console.log("called");
            if(vm.constructionPermit.serviceIdEC ===null){
                console.log("if");
                onfindOneError();
            }
            else {
                console.log("else");
                InspectionReport.query({id:'1', projectid:vm.constructionPermit.projectId},onfindOneSuccess,onfindOneError);
            }
        };

        function onfindOneSuccess(result) {
            vm.filesdata= result;
            console.log(result);
            // downloadserviceformattachment.download(result.reportURL,"Inspection Report.pdf");
        }

        function onfindOneError() {
            alert("Inspection Report Not Uploaded ! !  \n\nCheck Again Later");
        }

        vm.OccupationCertificate= function () {
            if(vm.constructionPermit.serviceId==='43575ec0-7dd3-40bd-b3c4-47638d17bf3c'){
                $state.go('huda-oc');
            }
            else if(vm.constructionPermit.serviceId='a69786f5-c674-4de9-8807-8689c7ef86b5'){
                $state.go('hsiidc-oc');
            }
            else if(vm.constructionPermit.serviceId='159a0331-87c3-407d-9c6c-559455d4b6ab'){
                $state.go('tcp-oc');
            }
            else if(vm.constructionPermit.serviceId='1c90c949-f2d1-4997-84b0-e6b2d40fe5e6'){
                $state.go('ulb-oc');
            }
            // else if(vm.constructionPermit.serviceId='1c90c949-f2d1-4997-84b0-e6b2d40fe5e6'){
            //     $state.go('labour-oc');
            // }
        };

        vm.showLog=function () {
            ConstructionPermitLog.query({id: '1',projectid:vm.projectid},function(result) {
                vm.constructionPermitLogs = result;
                vm.searchQuery = null;
            });
        };

        vm.fireNOC= function () {
            vm.constructionPermit.oCflag=true;
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onFireNOCsaveSuccess);
        };

        function onFireNOCsaveSuccess() {
            vm.OccupationCertificate();
        }

        vm.downloadReport=function (result) {
            downloadserviceformattachment.download(result,"Inspection Report.pdf");
        };

        vm.downloadReportInspection=function (result) {
            downloadserviceformattachment.download(result+"_10.pdf","Inspection Report.pdf");
        }

    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('commentDialogController', commentDialogController);

    commentDialogController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService','projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','CheckContent'];
    function commentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail,CheckContent) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService = projectService;
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        $scope.file = {};
        vm.clear = clear;
        vm.saveComments = saveComments;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function saveComments() {
            vm.projectServiceLog.projectid = vm.projectService.projectid;
            vm.projectServiceLog.serviceid = vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken = "OpenComment";
            if(angular.isDefined(vm.projectAttachemnt.file)){
                var fileNameArray = vm.projectAttachemnt.file.name.split(".");
                if ((fileNameArray.length == 2)) {
                    if(fileNameArray[0] != ""){
                        ProjectServiceLogUpdated.save(vm.projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

                    }
                    else {
                        alert("Invalid File Name");
                    }
                }
                else{
                    alert("Please select correct file format")
                }
            }
            else {
                ProjectServiceLogUpdated.save(vm.projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);

            }

        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);

        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Open Comments";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }

            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
//            alert('project attachment not saved');
            vm.isSaving = false;
        }

        function onUpdateProjectAttachmentSuccess(result)
        {
//            alert('file attachment updated');
            $uibModalInstance.close(result);
        }
        function onUpdateProjectAttachmentError()
        {
//            alert('file attachment not updated');
            vm.isSaving = false;
        }
        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});

    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('clarificationDialogController', clarificationDialogController);

    clarificationDialogController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService', 'projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServiceReportInfoForClearance', 'TowerRejectionReason', 'RejectedProjectServiceLog', 'ReasonCategory','TowerRejectionReasonByCategory','ProjectAction'];
    function clarificationDialogController ($timeout, $scope, $stateParams, $uibModalInstance,projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail,ProjectServiceReportInfoForClearance, TowerRejectionReason, RejectedProjectServiceLog, ReasonCategory, TowerRejectionReasonByCategory, ProjectAction) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService=projectService;
//        vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({department:vm.projectService.departmentName,projectid:vm.projectService.projectid,service:vm.projectService.serviceName});
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        $scope.file = {};
        vm.clear = clear;
        // vm.declineService = declineService;

        vm.clarify = clarify;
        vm.rejectedProjectServiceLog = {};
        // vm.getReasons = getReasons;
        //vm.getRejectionReason = getRejectionReason;
        vm.selectedCategory = {};
        vm.role = $stateParams.role;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.rejectionReasons = [];
        vm.reasonCategories = [];

        loadAll();

        function loadAll() {
            ReasonCategory.query(function(result) {
                vm.reasonCategories = result;
                vm.searchQuery = null;
            });
        }



        function clarify(role) {
            ProjectAction.clarificationReply(vm.projectService,vm.projectAttachemnt,vm.comments, role, onsuccess,onerror)
        }



        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.status="Withdraw";
            vm.projectService.rejectionDate=result.commentDate;
            vm.rejectedProjectServiceLog.projectServiceLogId = projectServiceLogid;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
            RejectedProjectServiceLog.save(vm.rejectedProjectServiceLog);

        }
//        function onUpdateProjectServiceSuccess(result)
//        {
//            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
//            vm.projectservicereportinfo.status='Declined';
//            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
//        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Withdraw Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

//        function onUpdateProjectServiceReportInfoError()
//        {
//            vm.isSaving = false;
//        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function onsuccess(result) {
            $uibModalInstance.close();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ChecklistViewController', ChecklistViewController);

    ChecklistViewController.$inject = ['$scope','$stateParams', '$sce', 'Checklist'];

    function ChecklistViewController($scope, $stateParams, $sce, Checklist) {

        var vm = this;
        $scope.urlpdf='';

        loadAll();

        function loadAll() {
            Checklist.get({id: $stateParams.serviceid},onFindSuccess,OnFindError);
        }

        function onFindSuccess(result) {
            $('#dislayCheckList').modal('show');

            // UIkit.modal("#dislayCheckList").show();
            $scope.urlpdf = $sce.trustAsResourceUrl(result.serverFileName);
        }
        function OnFindError() {
            alert("Checklist Not Available");
        }

    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('assignServiceDialogController', assignServiceDialogController);

    assignServiceDialogController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService','projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServiceReportInfoForClearance','CheckContentFile'];
    function assignServiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail, ProjectServiceReportInfoForClearance,CheckContentFile) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService = projectService;
//        vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({projectid:vm.projectService.projectid,department:vm.projectService.departmentName,service:vm.projectService.serviceName});
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        $scope.file = {};
        vm.clear = clear;
        vm.assignService = assignService;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        function assignService(){
            if(angular.isDefined(vm.projectAttachemnt.file)){
                if(CheckContentFile.checkFile(vm.projectAttachemnt.file.name)){
                    assignServiceFeeAftercheck();
                }
                else{
                    alert("File Format Should be Correct");
                }
            }
            else{
                assignServiceFeeAftercheck();
            }
        }
        function onServiceLogSaveSuccess(result)
        {
            projectServiceLogid=result.id;
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            vm.projectService.isAssigned=true;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.serviceFee=vm.projectservicedetail.serviceFee;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }
//        function onUpdateProjectServiceSuccess(result)
//        {
//            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
//            vm.projectservicereportinfo.assignDate=result.assigOnDate;
//            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
//        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
//        function onUpdateProjectServiceReportInfoError()
//        {
//            vm.isSaving = false;
//        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Service Assign Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;
            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function assignServiceFeeAftercheck(){
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="Assigned Service Fee";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('assignOtherServiceDialogController', assignOtherServiceDialogController);

    assignOtherServiceDialogController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService','projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','AssignServiceFee','ProjectServiceReportInfoForClearance'];
    function assignOtherServiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, AssignServiceFee , ProjectServiceReportInfoForClearance) {
        var vm = this;
        vm.actionflag=false;
        vm.assignServiceFee= {};
        vm.projectServiceLog={};
        vm.projectService = projectService;

        vm.addfeeDetail = AssignServiceFee.query({id:"1", projectid:vm.projectService.projectid, serviceid:vm.projectService.serviceid});
        var projectServiceLogid=null;
        var isDelete=null;
        var deleteID=[];
        vm.clear = clear;
        vm.assignOtherService = assignOtherService;
        vm.addOtherService = addOtherService;
        vm.deleteRow = deleteRow;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        function assignOtherService(){
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="Assigned Other Fee";
            vm.projectServiceLog.comments="Assigned Other Fee";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess);
        }
       function onServiceLogSaveSuccess(result)
       {
            projectServiceLogid=result.id;
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            vm.projectService.isAssigned=true;
            saveOtherService();
       }
        function saveOtherService(result)
        {
           var vmlength=vm.addfeeDetail.length;
           for(var i=0; i < vmlength; i++)
           {
              vm.addfeeDetail[i].projectid=vm.projectServiceLog.projectid;
              vm.addfeeDetail[i].serviceid=vm.projectServiceLog.serviceid;
              if(vm.addfeeDetail[i].isSaved===false)
              {
                vm.addfeeDetail[i].isSaved=true;
                AssignServiceFee.save(vm.addfeeDetail[i]);
              }
            }
           if(isDelete==1)
           {
             for(var j=0; j < deleteID.length; j++)
             {
              AssignServiceFee.delete({id: deleteID[j]});
             }
           }
           vm.addfeeDetail=[];
         $uibModalInstance.close(result);
        }
        function deleteRow(id)
         {
           var index = -1;
           var comArray =eval(vm.addfeeDetail);
           for( var i = 0; i < comArray.length; i++ )
           {
              if( comArray[i].id=== id)
               {
                   index = i;
                   vm.addfeeDetail.splice(index, 1 );
                   deleteID.push(id);
                   isDelete=1;
               }
           }
           vm.actionflag=true;
         }
        function addOtherService()
        {
         vm.assignServiceFee.isPaymentMade=false;
         vm.assignServiceFee.isSaved=false;
         vm.addfeeDetail.push(vm.assignServiceFee);
         vm.assignServiceFee={};
         document.getElementById("resetForm").reset();
         vm.actionflag=true;
        }

    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('acknowledgementController', serviceLogController);

    serviceLogController.$inject = ['$timeout', '$scope', '$state','$stateParams', '$uibModalInstance', 'serviceLogList','downloadService','service','DownloadExternalServiceFiles','projectService','Rating', 'Principal', 'Nmatoken', 'Applicationstatus', 'DepartmentService', 'Project'];
    function serviceLogController ($timeout, $scope, $state ,$stateParams, $uibModalInstance, serviceLogList, downloadService,service,DownloadExternalServiceFiles,projectService,Rating, Principal, Nmatoken, Applicationstatus, DepartmentService, Project) {
        var vm = this;
        vm.clear = clear;
        vm.downloadFile=downloadFile;
        vm.ServiceLog = serviceLogList;
        vm.projectService=projectService;
        vm.project=Project;
        vm.service=service;
        vm.pdfconverter= pdfconverter;
        vm.downFile= downFile;
        vm.saveRating= saveRating;
        vm.rtsDueDate = Date;
        vm.rating = {
            isFeeManuallySubmit: '',
            isDocPhysicallySubmit: '',
            isApprovalOnTime: '',
            isCertificateDownload: '',
            isPhysicallyVisit: ''
        };
        vm.rating.rating ="Excellent";
        vm.userFile= userFile;
        vm.rating.serviceId=$stateParams.serviceid;
        vm.rating.projectId=$stateParams.projectid;
        vm.rating.id= $stateParams.projectserviceid;
        vm.cafpin = $stateParams.cafpin;
        vm.rts = 0;


        getAccount();
        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
            })
        }


        // function pdfconverter () {
        //     var element = document.getElementById('pdf_data');
        //     html2pdf(element,{
        //           margin:  0.5,
        //           html2canvas: { dpi:192, letterRendering: true },
        //           jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
        //     });
        // }

       function pdfconverter() {
            var printContents = document.getElementById('pdf_data').innerHTML;
        if (printContents) {
            var originalContents = document.body.innerHTML;
            document.body.innerHTML = printContents;
            window.print();
            document.body.innerHTML = originalContents;
            window.location.reload(); // to reload the Angular view after restoring
        }
    }

        if (this.projectService.formFilledOnDate) {
            this.rtsDueDate = new Date(this.projectService.formFilledOnDate);
            DepartmentService.get({id: $stateParams.serviceid}, function (result) {
                vm.rts = result.rtsDays;
            });
            this.rtsDueDate.setDate(this.rtsDueDate.getDate() + vm.rts); // Adds 45 days
        }

        if (vm.projectService.serviceid==='bdb451cb-f12b-4352-8360-e6e3a715386f'){
            vm.nmatoken=Nmatoken.get({id:vm.projectService.id},function () {
                vm.tokenFound=true;
            });
            vm.applicationstatus=Applicationstatus.get({id:vm.projectService.id},function () {
                vm.nocFound=true;
            });
        }

        $scope.isDateExceed=function()
        {
         if(vm.projectService.isDateExceeded===true){
            return true;
         }
         else{
            return false;
         }
        };

        var isdateexceeded = $scope.isDateExceed();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.isServiceInList=function() {
           return vm.projectService.isIntegrated === true;
        };

        function downFile(servicelog) {
            vm.reApplyCounter = servicelog.reApplyCounter;
            vm.dwnFile = servicelog.fileName;
            vm.act = servicelog.actionTaken;
            downloadFile();
        }

        function userFile(servicelog){
            vm.reApplyCounter = servicelog.reApplyCounter;
            vm.dwnFile = servicelog.fileName;
            vm.act = servicelog.actionTaken;
            if(vm.act === "Cleared"){

                Rating.get({id: $stateParams.projectserviceid}, onGetSuccess, onGetError)
            }
            else {
                downloadFile();
            }
        }

        function onGetSuccess(){
            downloadFile();
        }

        function onGetError(){
            $("#ratings").modal('show');
        }

        function saveRating() {
            vm.isSaving = true;
            vm.rating.serviceId=$stateParams.serviceid;
            vm.rating.projectId=$stateParams.projectid;
            vm.rating.id= $stateParams.projectserviceid;
           Rating.update(vm.rating);
          downloadFile();
          $("#ratings").modal('hide');
        }

        function downloadFile()
        {
            if(($scope.isServiceInList()) && (vm.act!=='OpenComment'))
            {
                if(isdateexceeded){
                    downloadExt();
                }
                else {
                    if(vm.reApplyCounter > 1){
                        downloadExt();
                    }
                    else {
                        downloadHEPC();
                    }
                }
            }
            else
            {
                downloadHEPC();
            }
        }

        function downloadHEPC() {
            downloadService.download(vm.dwnFile)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
            });
        }

        function downloadExt() {
            DepartmentService.get({id: $stateParams.serviceid}, function (result) {
                if(result.downloadUrl == null){
                    alert("Download URL not found! Kindly contact concerned department.");
                    return;
                }
                DownloadExternalServiceFiles.download($stateParams.projectid, $stateParams.serviceid, vm.reApplyCounter, result.downloadUrl);
            });
        }
    }
})();



(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('searchCAF', {
            parent: 'app',
            url: '/searchCAF',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DESK_OFFICER','ROLE_DEPT_CHANGE','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_NODAL_OFFICER','ROLE_TICKET_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/searchCAF/searchCAF.html',
                    controller: 'SearchCAFController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        })
            .state('searchBusinessEntity', {
                parent: 'app',
                url: '/searchBusinessEntity',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_STATE_NODAL_OFFICER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/searchCAF/searchBusinessEntity.html',
                        controller: 'SearchBusinessEntity',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        return $translate.refresh();
                    }]
                }
            });

        }
        })();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SearchCAF', SearchCAF);

    SearchCAF.$inject = ['$resource'];

    function SearchCAF ($resource) {
        var resourceUrl = '/api/searchCAF/:CAFPIN';
        var businessEntityUrl = '/api/searchBusinessEntity/:businessEntityName';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method: 'PUT' },

            // New method for fetching by businessEntityName
            'getByBusinessEntityName': {
                url: businessEntityUrl,
                method: 'GET',
                params: { businessEntityName: '@businessEntityName' },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SearchCAFController', SearchCAFController);

    SearchCAFController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'SearchCAF', '$location'];

    function SearchCAFController ($scope, Principal, LoginService, $state, SearchCAF, $location) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.getProject = getProject;
        vm.project={};
        vm.showtable=false;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
            ga('set', 'page', $location.path());
            ga('send','pageview');
        });


        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
        function getProject()
        {
            vm.project=null;
            vm.showtable=false;
            SearchCAF.get({CAFPIN:vm.CAFPIN},function(result){
                vm.project = result;
                if(vm.project.caftype === 'FILMCAF'){
                    vm.project.caftype = 'Film'
                }
                if(vm.project.caftype === 'LandExchange'){
                    vm.project.caftype = 'Land'
                }
                if(vm.project.caftype === 'Renewable'){
                    vm.project.caftype = 'Renew'
                }
                if(!(angular.isDefined(vm.project.cafpin)))
                {
                    vm.showtable=false;
                }
                else
                {
                    vm.showtable=true;
                }
        });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SearchCAFDownload', SearchCAFDownload);

    SearchCAFDownload.$inject = ['$http'];

    function SearchCAFDownload($http) {
        return {
            downloadCSVAsExcel: function (financialYear, sizeOfIndusry) {
                var url = '';

                if (financialYear && sizeOfIndusry) {
                    url = '/api/findByFinancialYearAndSizeOfIndusry/' + encodeURIComponent(financialYear) + '/' + encodeURIComponent(sizeOfIndusry);
                } else if (financialYear) {
                    url = '/api/findByFinancialYear/' + encodeURIComponent(financialYear);
                } else if (sizeOfIndusry) {
                    url = '/api/findByIndustryType/' + encodeURIComponent(sizeOfIndusry);
                }

                if (url) {
                    return downloadFile(url);
                }
            },

            downloadByBusinessEntityName: function(businessEntityName) {
                if (!businessEntityName) {
                    alert('Business Entity Name is required');
                    return;
                }

                var url = '/api/searchBusinessEntity/' + encodeURIComponent(businessEntityName);
                return downloadFile(url);
            }
        };

        // Common method to handle download logic
        function downloadFile(url) {
            return $http({
                method: 'GET',
                url: url,
                responseType: 'arraybuffer'
            }).then(function (response) {
                var blob = new Blob([response.data], { type: 'text/csv' });
                var link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = 'records.xls';
                link.click();
                URL.revokeObjectURL(link.href);
            }).catch(function (error) {
                console.error('CSV Download Failed:', error);
                alert('Failed to download the CSV file.');
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SearchBusinessEntity', SearchBusinessEntity);

    SearchBusinessEntity.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'SearchCAF', '$location','SearchCAFDownload','Industrysize'];

    function SearchBusinessEntity ($scope, Principal, LoginService, $state, SearchCAF, $location, SearchCAFDownload,Industrysize) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.searchByFinancialYearOrIndustry = searchByFinancialYearOrIndustry;  // new function
        vm.getByBusinessEntityName=getByBusinessEntityName;
        vm.project = {};
        vm.showtable = false;
        vm.CAFPIN = ''; // Holds the input value

        $scope.$on('authenticationSuccess', function() {
            getAccount();
            ga('set', 'page', $location.path());
            ga('send','pageview');
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        Industrysize.query(function(result) {
            vm.industrysizes = result;
            vm.searchQuery = null;
        });

        function register () {
            $state.go('register');
        }

        function getByBusinessEntityName() {
            if (!vm.businessEntityName) {
                alert('Please enter business entity name first');
                return;
            }
            SearchCAFDownload.downloadByBusinessEntityName(vm.businessEntityName);
        }


        // New: search and download CSV based on financialYear and size_of_industry
        function searchByFinancialYearOrIndustry() {
            if (!vm.financialYear && !vm.size_of_industry) {
                alert('Please select at least one filter: Financial Year or Size of Industry.');
                return;
            }
            SearchCAFDownload.downloadCSVAsExcel(vm.financialYear, vm.size_of_industry);
        }

        // Function to download all as CSV (unchanged)
        vm.downloadAll = function() {
            SearchCAFDownload.downloadCSVAsExcel();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ScheduledPendingDetailController', ScheduledPendingDetailController);

    ScheduledPendingDetailController.$inject = ['$scope','$stateParams','GetServiceLog','serviceFormFieldDataCollection','ServiceFormAttachments','$uibModalInstance','downloadserviceformattachment','ProjectAction','projectService'];

    function ScheduledPendingDetailController ($scope,$stateParams,GetServiceLog,serviceFormFieldDataCollection,ServiceFormAttachments,$uibModalInstance,downloadserviceformattachment,ProjectAction,projectService) {
        var vm = this;
        vm.projects=[];
        vm.downloadFile=downloadFile;
        vm.addComment=addComment;
        vm.assignServiceFee=assignServiceFee;
        vm.status=$stateParams.action;
        vm.projectAttachemnt={};

        $scope.file = {};

        loadProject();

        function loadProject() {
            vm.project=projectService;
           switch (vm.status){
               case 'service-logs':
                   viewlogs(vm.project);
                   break;
               case 'view-form':
                   loadFilledForm(vm.project);
                   break;
           }
        }

        vm.pdfconverter= function  () {
            var element = document.getElementById('pdf_data');
            html2pdf(element,{
                margin: 4
            });
        };

        function viewlogs(project) {
            vm.project=project;
            GetServiceLog.query({projectid:project.projectid,serviceid:project.serviceid},function (result) {
                vm.ServiceLog=result;
            });
        }

        function loadFilledForm(project) {
            vm.project=project;
            vm.serviceFormFieldData= serviceFormFieldDataCollection.query({serviceid:project.serviceid, projectid:project.projectid});
            vm.serviceformattachments=ServiceFormAttachments.query({id:"1",serviceid:project.serviceid, projectid:project.projectid});
        }

        function addComment() {
            ProjectAction.comment(vm.project,vm.projectAttachemnt,vm.comments,onsuccess,onerror);
        }

        function assignServiceFee(){
            ProjectAction.assignFee(vm.project,vm.projectAttachemnt,vm.comments,vm.serviceFee,onsuccess,onerror);
        }

        function downloadFile(serverfilename,downloadfilename)
        {
            downloadserviceformattachment.download(serverfilename,downloadfilename)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }

        vm.clear=function () {
            $uibModalInstance.close();
        };

        function onsuccess(result) {
            $uibModalInstance.close();
        }

        function onerror() {

        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ScheduledListwise', ScheduledListwise);

    ScheduledListwise.$inject = ['$resource'];

    function ScheduledListwise ($resource) {
        var resourceUrl =  '/api/scheduled-array';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    // copy.created_on = DateUtils.convertLocalDateToServer(copy.created_on);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('scheduledList', {
            parent: 'app',
            url: '/scheduledVisits',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/scheduledService/scheduledList.html',
                    controller: 'ScheduledListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('listproject');
                    return $translate.refresh();
                }]
            }
        })
    .state('service-action', {
            parent: 'scheduledList',
            url: '/{action}/{projectserviceid}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'  ]
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/scheduledService/projectDetail-dialog.html',
                    controller: 'ScheduledPendingDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        projectAttachemnt: function () {
                            return {
                                fileName: null,
                                description: null,
                                fileExtension: null,
                                serverFileName: null,
                                id: null
                            };
                        },
                        projectServiceLog: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                comments: null,
                                commentDate: null,
                                commentByUserLogin: null,
                                actionTaken: null,
                                id: null
                            };
                        },
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }],
                        projectService: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                        }]
                           // projectservicereportinfo: ['ProjectServiceReportInfoForClearance', function(ProjectServiceReportInfoForClearance) {
                           //     return ProjectServiceReportInfoForClearance.get({department:$stateParams.projectService.departmentName,projectid:$stateParams.projectService.projectid,service:$stateParams.projectService.serviceName});
                           // }]
                    }
                }).result.then(function() {
                    $state.go('scheduledList', null);
                }, function() {
                    $state.go('scheduledList');
                });

            }]
        })
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ScheduledList', ScheduledList);

    ScheduledList.$inject = ['$resource'];

    function ScheduledList ($resource) {
        var resourceUrl =  '/api/scheduled-visit/';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ScheduledListController', ScheduledListController);

    ScheduledListController.$inject = ['$scope','$state','ScheduledList','ScheduledVisits','InspectorDetails'];

    function ScheduledListController($scope, $state, ScheduledList,ScheduledVisits,InspectorDetails) {
        var vm = this;
        vm.scheduledList = null;
        vm.inspectorDetails =[];
        vm.datePickerOpenStatus = {};
        vm.statusFilter = "Pending";
        vm.statusSelected = statusSelected;
        vm.pending = pending;
        pending();
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.repeatValue = repeatValue;
        vm.value = true;
        vm.prdtl = {};
        vm.datePickerOpenStatus.scheduledDate = false;

        function repeatValue(values) {
            vm.scheduledVisits = values;
               var ds = vm.scheduledVisits[0].district;
            InspectorDetails.query({district: vm.scheduledVisits[0].district},function(result) {
                vm.inspectorDetails = result;
                vm.searchQuery = null;
            });

        }

        $scope.options = {
            minDate: new Date(),
        }

        function openCalendar(date, prdtl1) {
            vm.datePickerOpenStatus[date] = true;
        }

        function save() {
            vm.isSaving = true;
            for (var i = 0; i < vm.scheduledVisits.length; i++) {
                vm.scheduledVisits[i].scheduledDate = vm.prdtl.scheduledDate;
                vm.scheduledVisits[i].assignedToOfficer=vm.prdtl.fireOfficer;
                vm.scheduledVisits[i].assignedOfficerMail=vm.prdtl.ocOfficer;
                ScheduledVisits.save(vm.scheduledVisits[i]);
            }
            location.reload();
        }

        function statusSelected(status1) {
            if(status1 ==="Pending"){
                ScheduledList.query({status: "Pending"}, function (result) {
                    vm.scheduledList = result;
                    vm.searchQuery = null;
                    vm.value=true;
                });
            }
            else if(status1 ==="Scheduled"){
                ScheduledVisits.query(function (result) {
                vm.scheduledVisits = result;
                vm.searchQuery = null;
                vm.scheduledList = vm.scheduledVisits;
                vm.value=false;
            });
            }
        }

        function pending() {
            ScheduledList.query({status: "Pending"}, function (result) {
                vm.scheduledList = result;
                vm.searchQuery = null;
                vm.value=true;
            });
        }

    }
    
})();




(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rejectionReason', {
            parent: 'app',
            url: '/rejectionReason',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/rejectionReason/rejectionReasonPage.html',
                    controller: 'rejectionReasonController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('RejectionReason', RejectionReason);

    RejectionReason.$inject = ['$resource'];

    function RejectionReason ($resource) {
        var resourceUrl =  '/api/projectServiceLog/:status';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('rejectionReasonController', rejectionReasonController);

    rejectionReasonController.$inject = ['$scope','$state', 'Projectlist', 'Principal','ProjectServiceLog'];

    function rejectionReasonController($scope, $state, Projectlist ,Principal,ProjectServiceLog) {
        var vm = this;
        vm.accout = null;
        vm.projectlist ={};

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        

        getProjectServiceLog();
        function getProjectServiceLog() {
            ProjectServiceLog.query({status:'Declined'},function (result) {
                vm.projectlist = result;
            })

        }

    }
})();




(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ReApplyReDashboardViewStats', ReApplyReDashboardViewStats);

    ReApplyReDashboardViewStats.$inject = ['$resource'];

    function ReApplyReDashboardViewStats ($resource) {
        var resourceUrl =  'api/re-apply-dashboards/projects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ReApplyReDashboardMigrate', ReApplyReDashboardMigrate);

    ReApplyReDashboardMigrate.$inject = ['$resource'];

    function ReApplyReDashboardMigrate ($resource) {
        var resourceUrl =  'api/re-apply-dashboards/migrate-data';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReApplyDashboardView', ReApplyDashboardView);

    ReApplyDashboardView.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance','ReApplyReDashboardViewStats'];
    function ReApplyDashboardView ($timeout, $scope, $stateParams, $uibModalInstance,ReApplyReDashboardViewStats) {
        var vm = this;
        vm.clear = clear;
        vm.serviceName = $stateParams.servicename;
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        loadAll();
        function loadAll() {
            ReApplyReDashboardViewStats.query({id:$stateParams.serviceid},function(result){
                vm.dashboardcafs = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('reApplyDashboard', {
            parent: 'app',
            url: '/reApplyDashboard',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/reApplyDashboard/reApplyDashboard.html',
                    controller: 'ReAppliedDashboardController',
                    controllerAs: 'vm'
                }
            }
        }).state('reApplyDashboard-view', {
            parent: 'reApplyDashboard',
            url: '/view/{serviceid}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/reApplyDashboard/reApplyDashboard-view.html',
                    controller: 'ReApplyDashboardView',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                }).result.then(function() {
                    $state.go('reApplyDashboard', null, { reload: 'reApplyDashboard' });
                }, function() {
                    $state.go('reApplyDashboard');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ReApplyReDashboardStats', ReApplyReDashboardStats);

    ReApplyReDashboardStats.$inject = ['$resource'];

    function ReApplyReDashboardStats ($resource) {
        var resourceUrl =  'api/re-apply-redashboards';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReAppliedDashboardController', ReAppliedDashboardController);

    ReAppliedDashboardController.$inject = ['ReApplyReDashboardStats'];

    function ReAppliedDashboardController (ReApplyReDashboardStats) {
        var vm = this;
        vm.reApplyDashboardData = [];
        loadAll();
        function loadAll() {
            ReApplyReDashboardStats.query(function(result) {
                vm.reApplyDashboardData = result;
            });
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RatingViewController', RatingViewController);

    RatingViewController.$inject = [
        '$timeout',
        '$scope',
        '$stateParams',
        '$uibModalInstance',
        'ServiceViewCafYearly',
        'TowerserviceNO',
        'ServiceViewCafYearlyByElastic',
        'DownloadServiceViewCafYearlyByElastic',
        'DownloadCafCsv',
        'RatingSummaryService'
    ];

    function RatingViewController(
        $timeout,
        $scope,
        $stateParams,
        $uibModalInstance,
        ServiceViewCafYearly,
        TowerserviceNO,
        ServiceViewCafYearlyByElastic,
        DownloadServiceViewCafYearlyByElastic,
        DownloadCafCsv,
        RatingSummaryService
    ) {
        var vm = this;
        vm.clear = clear;

        // Masking function
        function maskContact(contact) {
            if (!contact) return '';
            // Example: Phone numbers → keep first 2 and last 2 characters
            if (contact.length <= 4) return '****';
            var visibleStart = contact.substring(0, 2);
            var visibleEnd = contact.substring(contact.length - 2);
            var masked = new Array(contact.length - 3).join('*'); // same as '*'.repeat()
            return visibleStart + masked + visibleEnd;
        }

        vm.loadAllCafs = function () {
            RatingSummaryService
                .getRecordById($stateParams.serviceid, $stateParams.departmentid)
                .then(function (result) {
                    console.log("Fetched Record:", result);

                    // Apply masking to investorContact for each record
                    result.forEach(function (r) {
                        if (r.investorContact) {
                            r.investorContact = maskContact(r.investorContact);
                        }
                    });

                    vm.ratingSummaries = result;
                })
                .catch(function (error) {
                    console.error("Error fetching record:", error);
                });
        };

        // Call on init
        vm.loadAllCafs();

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('rating-summary', {
            parent: 'app',
            url: '/rating-summary',
            data: {
                authorities: [],
                pageTitle: 'global.menu.rating-summary'
            },
            views: {
                'content@': {
                    templateUrl: 'app/rating-summary/rating-summary.html',
                    controller: 'RatingSummaryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rating-summary');
                    return $translate.refresh();
                }]
            }
        }).state('rating-view', {
            parent: 'rating-summary',
            url: '/rating-detail/{serviceid}/{departmentid}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/rating-summary/rating-view.html',
                    controller: 'RatingViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('rating-summary', null, { reload: 'rating-summary' });
                }, function() {
                    $state.go('rating-summary');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('RatingSummaryService', RatingSummaryService);

    RatingSummaryService.$inject = ['$resource'];

    function RatingSummaryService($resource) {
        var resourceUrl = 'api/rating-summary-by-serviceid/:id/:departmentid'; // adjust to your backend endpoint

        var resource = $resource(resourceUrl, { id: '@id' }, {
            'get': { method: 'GET', isArray: true }
        });

        // Expose methods
        return {
            getOrdinalIndicator: getOrdinalIndicator,
            getRecordById: getRecordById
        };

        // ---------- existing ----------
        function getOrdinalIndicator(n) {
            if (n || n === 0) {
                if (hasANonGenericOrdinalIndicator(n)) {
                    return 'th';
                }
                var decimal = n % 10;
                switch (decimal) {
                    case 1: return 'st';
                    case 2: return 'nd';
                    case 3: return 'rd';
                    default: return 'th';
                }
            }
            return '';
        }

        function hasANonGenericOrdinalIndicator(n) {
            var lastTwoDigits = n % 100;
            return lastTwoDigits > 10 && lastTwoDigits < 14;
        }

        // ---------- new ----------
        function getRecordById(id, departmentid) {
            return resource.get({ id: id, departmentid: departmentid}).$promise;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RatingSummaryController', RatingSummaryController);

    RatingSummaryController.$inject = ['$scope', 'RatingSummaryService', 'Rating'];

    function RatingSummaryController($scope, RatingSummaryService, Rating) {
        var vm = this;


        Rating.getSummary(function(result){
            vm.feedbackratings = result;
          //  vm.allRatings = result;

      console.log("rrrrrrr" + result);
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('Questionnaire', {
            parent: 'app',
            url: '/questionnaire',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/questionnaire.html',
                    controller: 'QuestionnaireController',
                    controllerAs: 'vm'
                }
            },
              resolve: {
                  translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                      $translatePartialLoader.addPart('home');
                      return $translate.refresh();
                  }],
                  questionnaire: function () {
                      return {
                          typeofoperation: null,
                          investment: null,
                          typeofownership: null,
                          sector: null,
                          product: null,
                          category: null,
                          natureofland: null,
                          sourceofwater: null,
                          loadrequired: null,
                          contractedload: null,
                          totalworker: null,
                          migrantworker: null,
                          contractworker: null,
                          operatingboilers: false,
                          petrolium: false,
                          hazardouswaste: false,
                          biomedicalwaste: false,
                          ewaste: false,
                          solidwaste: false,
                          rectifiedspirit: false,
                          motortransport: false,
                          involveallopathic: false,
                          involveayurvedic: false,
                          lubricatinglicense: false,
                          commercial: false,
                          involvepesticides: false,
                          underbocwact: false,
                          requireexcavation: false,
                          neednoc: false,
                          involveenergy: false,
                          underaravali: false,
                          undereia: false,
                          pollutioncontrolboard: false,
                          taxation: false
                      };
                  }
              }
        })
        .state('clearances', {
            parent: 'Questionnaire',
            url: '/clearances/{questionnaire:json}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/clearances.html',
                    controller: 'clearancesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
              translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                  $translatePartialLoader.addPart('home');
                  return $translate.refresh();
            }]
           }
       })
        .state('page1', {
            parent: 'clearances',
            url: '/page1',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page1/page1.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page2', {
            parent: 'clearances',
            url: '/page2',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page2/page2.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page3', {
            parent: 'clearances',
            url: '/page3',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page3/page3.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page4', {
            parent: 'clearances',
            url: '/page4',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page4/page4.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page5', {
            parent: 'clearances',
            url: '/page5',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page5/page5.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page6', {
            parent: 'clearances',
            url: '/page6',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page6/page6.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page7', {
            parent: 'clearances',
            url: '/page7',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page7/page7.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page14', {
            parent: 'clearances',
            url: '/page14',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page14/page14.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page16', {
            parent: 'clearances',
            url: '/page16',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page16/page16.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page17', {
            parent: 'clearances',
            url: '/page17',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page17/page17.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page21', {
            parent: 'clearances',
            url: '/page21',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page21/page21.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page22', {
            parent: 'clearances',
            url: '/page22',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page22/page22.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page23', {
            parent: 'clearances',
            url: '/page23',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page23/page23.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page24', {
            parent: 'clearances',
            url: '/page24',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page24/page24.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page25', {
            parent: 'clearances',
            url: '/page25',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page25/page25.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page26', {
            parent: 'clearances',
            url: '/page26',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page26/page26.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page56', {
            parent: 'clearances',
            url: '/page56',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page56/page56.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page57', {
            parent: 'clearances',
            url: '/page57',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page57/page57.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page58', {
            parent: 'clearances',
            url: '/page58',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page58/page58.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('page60', {
            parent: 'clearances',
            url: '/page60',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page60/page60.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table31', {
            parent: 'clearances',
            url: '/table31',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table31/table31.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table32', {
            parent: 'clearances',
            url: '/table32',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table32/table32.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table33', {
            parent: 'clearances',
            url: '/table33',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table33/table33.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table34', {
            parent: 'clearances',
            url: '/table34',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table34/table34.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table36', {
            parent: 'clearances',
            url: '/table36',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table36/table36.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table37', {
            parent: 'clearances',
            url: '/table37',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table37/table37.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table41', {
            parent: 'clearances',
            url: '/table41',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table41/table41.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table42', {
            parent: 'clearances',
            url: '/table42',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table42/table42.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table43', {
            parent: 'clearances',
            url: '/table43',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table43/table43.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table44', {
            parent: 'clearances',
            url: '/table44',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table44/table44.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table45', {
            parent: 'clearances',
            url: '/table45',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table45/table45.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table46', {
            parent: 'clearances',
            url: '/table46',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table46/table46.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table47', {
            parent: 'clearances',
            url: '/table47',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table47/table47.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table48', {
            parent: 'clearances',
            url: '/table48',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table48/table48.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table49', {
            parent: 'clearances',
            url: '/table49',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table49/table49.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table52', {
            parent: 'clearances',
            url: '/table52',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table52/table52.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table53', {
            parent: 'clearances',
            url: '/table53',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table53/table53.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('table54', {
            parent: 'clearances',
            url: '/table54',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table54/table54.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('uhbvn2', {
            parent: 'clearances',
            url: '/uhbvn2',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/uhbvn2/uhbvn2.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('hsiidc1', {
            parent: 'clearances',
            url: '/hsiidc1',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/hsiidc1.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('hsiidc2', {
            parent: 'clearances',
            url: '/hsiidc2',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/hsiidc2.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('hsiidc3', {
            parent: 'clearances',
            url: '/hsiidc3',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/hsiidc3.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('hsiidc4', {
            parent: 'clearances',
            url: '/hsiidc4',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/hsiidc4.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('hsiidc5', {
            parent: 'clearances',
            url: '/hsiidc5',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/hsiidc5.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })

        .state('dradm', {
            parent: 'clearances',
            url: '/dradm',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/dradm.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })

        .state('inds1', {
            parent: 'clearances',
            url: '/inds1',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds1.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('inds2', {
            parent: 'clearances',
            url: '/inds2',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds2.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('inds3', {
            parent: 'clearances',
            url: '/inds3',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds3.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('inds4', {
            parent: 'clearances',
            url: '/inds4',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds4.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('inds5', {
            parent: 'clearances',
            url: '/inds5',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds5.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('forest2', {
            parent: 'clearances',
            url: '/forest2',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/forest2.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('factlicense', {
            parent: 'clearances',
            url: '/factlicense',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/factlicense.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })

        .state('inds6', {
            parent: 'clearances',
            url: '/inds6',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds6.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('inds7', {
            parent: 'clearances',
            url: '/inds7',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds7.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allclearances', {
            parent: 'Questionnaire',
            url: '/allclearances',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/allclearances.html',
                    controller: 'allclearancesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
              translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                  $translatePartialLoader.addPart('home');
                  return $translate.refresh();
            }]
           }
       })
        ;
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('QuestionnaireController', QuestionnaireController);

    QuestionnaireController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'questionnaire', 'District'];

    function QuestionnaireController ($scope, Principal, LoginService, $state, questionnaire,Disctict) {
        var vm = this;
        vm.questionnaire=questionnaire;
       // vm.questionnaire = {};
        vm.questionnaire.investorType = 'Domestic';
        vm.questionnaire.odop = 'No';

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();
        loadAll();
        function loadAll(){
            ga('set', 'page', '/Know-Your-Clearance');ga('send','pageview');
            loadAllDistrict();
            function loadAllDistrict() {
                vm.districts=Disctict.query();
            }
        }

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Clearance', Clearance);

    Clearance.$inject = ['$resource', 'DateUtils'];

    function Clearance ($resource, DateUtils) {
        var resourceUrl =  'api/clearances';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('clearancesController', clearancesController);

    clearancesController.$inject = ['$scope', '$stateParams','Principal', 'LoginService', '$state', 'Clearance'];

    function clearancesController ($scope, $stateParams, Principal, LoginService, $state, Clearance) {
        var vm = this;
        vm.questionnaire = $stateParams.questionnaire;
        vm.answers=[];
        loadAll();
       function loadAll(){ga('set', 'page', '/Know-Your-Clearance-Show-my-clearances');ga('send','pageview');}
        if(vm.questionnaire.typeofestablishment=='Pre-Operational')
        {
            Str_txt={
                "clearance": "GST/CST/VAT registration",
                "stage": '',
                "department": "Excie & taxatation",
                "url": "page25"
            };
            vm.answers.push(Str_txt);
            if(vm.questionnaire.category=='Red' || vm.questionnaire.category=='Orange' || vm.questionnaire.category=='Green')
            {
                var Str_txt3=    {
                    "clearance": "Consent to operate under Water Act, 1974 and the Air Act, 1981",
                    "stage": 3,
                    "department": "HSPCB",
                    "url":"page3"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.hazardouswaste=='E-waste') {
                var Str_txt3=    {
                    "clearance": "Registration/ Authorization under e-waste (Management & Handing) Rules, 2011",
                    "stage": 3,
                    "department": "Haryana state pollution controll board",
                    "url": "page4"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.hazardouswaste=='hazardous waste') {
                var Str_txt3=    {
                    "clearance": "Registration under hazardous waste rule 2016",
                    "stage": 3,
                    "department": "Haryana state pollution controll board",
                    "url":"page5"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.hazardouswaste=='bio-medical waste') {
                var Str_txt3=    {
                    "clearance": "Authorization under bio medical waste ( management & handling )rules, 2016",
                    "stage": 3,
                    "department": "Haryana state pollution controll board",
                    "url": "page7"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.electrictype == 'Permanent Connection') {
                var Str_txt3=    {
                    "clearance": "Release of permanent/regular electric connection,Indian electricity Act, 2003",
                    "stage": 1,
                    "department": "UHBVN/DHBVN",
                    "url":"page14"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.natureofland=='Within Controlled Area & Urban Area') {
                var Str_txt2={
                        "clearance": "Building Plan Approval",
                        "stage": 2,
                        "department": "Town and Country Planning",
                        "url": "page24"
                    };
                vm.answers.push(Str_txt2);
            }
            if(vm.questionnaire.natureofland=='Industrial')
            {
                vm.answers.push(Str_txt1);
                var Str_txt2={
                    "clearance": "Building Plan Approval",
                    "stage": 2,
                    "department": "HSIIDC",
                    "url": "hsiidc2"
                };
                vm.answers.push(Str_txt2);
                var Str_txt4={
                    "clearance": "Issue of completion/occupation certificate",
                    "stage": 3,
                    "department": "HSIIDC",
                    "url": "hsiidc1"
                };
                vm.answers.push(Str_txt4);
                var Str_txt5={
                    "clearance": "Release of permanent sewarage connection",
                    "stage": 3,
                    "department": "HSIIDC",
                    "url": "hsiidc4"
                };
                vm.answers.push(Str_txt5);
            }
        }

        if(vm.questionnaire.typeofestablishment=='Post-Establishment')
        {
            Str_txt={
                "clearance": "Factory registration/ license under Factories Act, 1948-Safety Wing",
                "stage": '',
                "department": "Labour department",
                "url": "factlicense"
            };
            vm.answers.push(Str_txt);
        }

        if(vm.questionnaire.typeofestablishment=='Pre-Establishment')
        {
            Str_txt={
                "clearance": "NOC for fire service",
                "stage": '',
                "department": "Fire Department",
                "url": "table33"
            };
            vm.answers.push(Str_txt);
            Str_txt={
                "clearance": "	Forest clearance for approach public entry/exit and diversion of forest land-under Forest Conservation Act,1980",
                "stage": '',
                "department": "Forest Department",
                "url": "page26"
            };
            vm.answers.push(Str_txt);
            Str_txt={
                "clearance": "Approval of factory plan under the Factories Act, 1948",
                "stage": '',
                "department": "Labour department",
                "url": "table45"
            };
            vm.answers.push(Str_txt);
            if(vm.questionnaire.category=='Red' || vm.questionnaire.category=='Orange' || vm.questionnaire.category=='Green')
            {
                var Str_txt3=    {
                    "clearance": "Consent for establishment under Water Act, 1974 and the Air Act, 1981",
                    "stage": 1,
                    "department": "HSPCB",
                    "url":"page1"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.natureofland=='Under Controlled area & outside extended Mc limit') {
                var Str_txt1 = {
                    "clearance": "Change of land use under Controlled Area Act 1963",
                    "stage": 1,
                    "department": "Town and Country Planning",
                    "url":"page16"
                };
                vm.answers.push(Str_txt1);
            }
            if(vm.questionnaire.requireexcavation==true) {
                var Str_txt3=    {
                    "clearance": "License for brick klin",
                    "stage": 3,
                    "department": "Town and Country Planning",
                    "url": "page17"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.natureofland=='Outside MC limit & beyond controlled area') {
                var Str_txt1 = {
                    "clearance": "NOC for establishment of unit under Urban Area Act",
                    "stage": 1,
                    "department": "Town and Country Planning",
                    "url": "page21"
                };
                vm.answers.push(Str_txt1);
            }
            if(vm.questionnaire.natureofland=='Within Controlled Area & Urban Area') {
                var Str_txt1= {
                    "clearance": "NOC for establishment of unit under Urban Area Act",
                    "stage": 1,
                    "department": "Town and Country Planning",
                    "url":"page22"
                };
                vm.answers.push(Str_txt1);
                var Str_txt3={
                    "clearance": "Occupation/completion certificate",
                    "stage": 3,
                    "department": "Town and Country Planning",
                    "url":"page23"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.underaravali==true) {
                var Str_txt3=    {
                    "clearance": "Environmental clearance (EC) under Aravali Notification 1992 & 1999",
                    "stage": 1,
                    "department": "Enviornment Department",
                    "url":"page56"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.typeofoperation=='Service Business')
            {
                Str_txt={
                    "clearance": "Shop registration under Shops and Establishment Act-Labour Wing",
                    "stage": '',
                    "department": "Labour",
                    "url": "table47"
                };
                vm.answers.push(Str_txt);
            }
            if(vm.questionnaire.typeofoperation=='Trade Business')
            {
                Str_txt={
                    "clearance": "Shop registration under Shops and Establishment Act-Labour Wing",
                    "stage": '',
                    "department": "Labour",
                    "url":"table47"
                };
                vm.answers.push(Str_txt);
            }

            if(vm.questionnaire.typeofownership=='Partnership')
            {

                var Str_txt={
                    "clearance": "Registration of Firms under Indian Partnership Act. 1932",
                    "stage": 1,
                    "department": "Industries & Commerce Department",
                    "url": "inds4"
                };
                vm.answers.push(Str_txt);
            }

            if(vm.questionnaire.natureofland=='Industrial')
            {
                var Str_txt1={
                    "clearance": "Allotment of Plot",
                    "stage": 1,
                    "department": "HSIIDC"
                };
                vm.answers.push(Str_txt1);
                var Str_txt3={
                    "clearance": "Release of permanent water connection",
                    "stage": 2,
                    "department": "HSIIDC",
                    "url": "hsiidc3"
                };
                vm.answers.push(Str_txt3);

                var Str_txt7={
                    "clearance": "Issuance of Trade License Under section 330 for factory, workshop or trade remises. In which it is intended to employ steam, electricity, water or other mechanical power.",
                    "stage": 3,
                    "department": "Urban & local Bodies",
                    "url":"table34"
                };
                vm.answers.push(Str_txt7);

            }
            if(vm.questionnaire.natureofland=='Within Controlled Area & Urban Area') {
                var Str_txt1= {
                    "clearance": "NOC for establishment of unit under Urban Area Act",
                    "stage": 1,
                    "department": "Town and Country Planning",
                    "url":"page22"
                    };
                vm.answers.push(Str_txt1);
                var Str_txt3={
                        "clearance": "Occupation/completion certificate",
                        "stage": 3,
                        "department": "Town and Country Planning",
                        "url":"page23"
                    };
                vm.answers.push(Str_txt3);

            }
            if(vm.questionnaire.natureofland=='With in MC Limit') {
                var Str_txt1 = {
                    "clearance": "Change of land use Within Municipal Limit",
                    "stage": 1,
                    "department": "Urban & local Bodies"
                };
                vm.answers.push(Str_txt1);
                var Str_txt2= {
                        "clearance": "Approval of building plan",
                        "stage": 2,
                        "department": "Urban & local Bodies",
                        "url": "table37"
                    };
                vm.answers.push(Str_txt2);
                var Str_txt4= {
                        "clearance": "Issuance of Water connection",
                        "stage": 2,
                        "department": "Urban & local Bodies"
                    };
                vm.answers.push(Str_txt4);

                var Str_txt6=   {
                        "clearance": "Issuance of Trade License Under section 330 for factory, workshop or trade remises. In which it is intended to employ steam, electricity, water or other mechanical power.",
                        "stage": 3,
                        "department": "Urban & local Bodies",
                        "url": "table34"
                    };
                vm.answers.push(Str_txt6);
                var Str_txt7=    {
                        "clearance": "Occupation/completion certificate",
                        "stage": 3,
                        "department": "Urban & local Bodies",
                        "url":"table36"
                    };
                vm.answers.push(Str_txt7);
                var Str_txt8=    {
                        "clearance": "Issuance of sewarage connection",
                        "stage": 3,
                        "department": "Urban & local Bodies",
                        "url": "table41"
                };
                vm.answers.push(Str_txt8);
            }
            if(vm.questionnaire.natureofland=='Under Controlled area & within extended Mc limit') {
                var Str_txt1 = {
                    "clearance": "Change of land use Within Municipal Limit",
                    "stage": 1,
                    "department": "Urban & local Bodies"
                };
                vm.answers.push(Str_txt1);
                var Str_txt2=    {
                        "clearance": "Approval of building plan",
                        "stage": 2,
                        "department": "Urban & local Bodies",
                        "url":"table37"
                    };
                vm.answers.push(Str_txt2);

                var Str_txt4=    {
                        "clearance": "Issuance of Water connection",
                        "stage": 2,
                        "department": "Urban & local Bodies"
                    };
                vm.answers.push(Str_txt4);
                var Str_txt6=    {
                        "clearance": "Issuance of Trade License Under section 330 for factory, workshop or trade remises. In which it is intended to employ steam, electricity, water or other mechanical power.",
                        "stage": 3,
                        "department": "Urban & local Bodies",
                        "url": "table34"
                    };
                vm.answers.push(Str_txt6);
                var Str_txt7=    {
                        "clearance": "Occupation/completion certificate",
                        "stage": 3,
                        "department": "Urban & local Bodies",
                        "url":"table36"
                    };
                vm.answers.push(Str_txt7);
                var Str_txt8=    {
                        "clearance": "Issuance of sewarage connection",
                        "stage": 3,
                        "department": "Urban & local Bodies",
                        "url":"table41"
                    };
                vm.answers.push(Str_txt8);
            }
            if(vm.questionnaire.natureofland=='Under Controlled area & outside extended Mc limit') {
                var Str_txt1 = {
                    "clearance": "Change of land use under Controlled Area Act 1963",
                    "stage": 1,
                    "department": "Town and Country Planning",
                    "url":"page16"
                };
                vm.answers.push(Str_txt1);
                var Str_txt3=    {
                        "clearance": "Occupation/completion certificate",
                        "stage": 3,
                        "department": "Town and Country Planning",
                        "url": "page23"
                    };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.natureofland=='Outside MC limit & beyond controlled area') {
                var Str_txt1 = {
                    "clearance": "NOC for establishment of unit under Urban Area Act",
                    "stage": 1,
                    "department": "Town and Country Planning",
                    "url": "page21"
                };
                vm.answers.push(Str_txt1);

                var Str_txt3=    {
                        "clearance": "Occupation/completion certificate",
                        "stage": 3,
                        "department": "Town and Country Planning",
                        "url": "page23"
                    };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.natureofland=='Outside controlled area & urban area') {
                var Str_txt1 = {
                    "clearance": "NOC for unit falling outside controlled/urban area",
                    "stage": 1,
                    "department": "Town and Country Planning",
                    "url":"page21"
                };
                vm.answers.push(Str_txt1);

                var Str_txt3=    {
                    "clearance": "Occupation/completion certificate",
                    "stage": 3,
                    "department": "Town and Country Planning",
                    "url": "page23"
                };
                vm.answers.push(Str_txt3);
            }

            if(vm.questionnaire.natureofland=='Forest land') {
                var Str_txt2=    {
                    "clearance": "Tree felling irrespective of location of land",
                    "stage": 1,
                    "department": "Forest Department",
                    "url": "forest2"
                };
                vm.answers.push(Str_txt2);
            }
            if(vm.questionnaire.sourceofwater=='Ground Water') {
                var Str_txt1 = {
                    "clearance": "Permission to Dig New Wells",
                    "stage": 1,
                    "department": "Irrigation Department"
                };
                vm.answers.push(Str_txt1);
            }
            if(vm.questionnaire.sourceofwater=='Municiple Corporation') {
                var Str_txt2 = {
                    "clearance": "Issuance of Water connection",
                    "stage": 2,
                    "department": "Urban & local Bodies"
                };
                vm.answers.push(Str_txt2);
            }
            if(vm.questionnaire.sourceofwater=='River & Public Tank') {
                var Str_txt3=    {
                    "clearance": "Permission ro draw water from River / Public Tank",
                    "stage": 1,
                    "department": "Irrigation Department"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.sourceofwater=='Urban water supply') {
                var Str_txt3=    {
                    "clearance": "Issuance of Water connection",
                    "stage": 2,
                    "department": "Urban & local Bodies"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.sourceofwater=='HSIIDC') {
                var Str_txt3=    {
                    "clearance": "Release of permanent water connection",
                    "stage": 2,
                    "department": "HSIIDC",
                    "url": "hsiidc3"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.loadrequired >=11) {
                var Str_txt3=    {
                    "clearance": "Certification of Electrical installation by Chief Electrical Inspector",
                    "stage": 3,
                    "department": "Power Department(11kv to 33kv:- certification by Charted Engineer / Chief elcetrical Engineer, " +
                    "Above 33 kv:- Certification Only by Chief Electical Engineer of Department)"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.migrantworker=='Yes') {
                var Str_txt3=    {
                    "clearance": "Establishment inter state migrant workmen (RE&CS) Act 1979",
                    "stage": 3,
                    "department": "labour department",
                    "url":"table48"
                };
                vm.answers.push(Str_txt3);
            }

            if(vm.questionnaire.contractworker=='Yes') {
                var Str_txt3=    {
                    "clearance": "Registration of the Principal Employer (Who is engaging the workers)under the Contracts Labour (Regulation & Abolition)Act,1970",
                    "stage": 3,
                    "department": "labour department",
                    "url":"table43"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.operatingboilers==true) {
                var Str_txt3=    {
                    "clearance": "Registration under boiler act",
                    "stage": 3,
                    "department": "Industries and commerce department",
                    "url": "inds1"
                };
                vm.answers.push(Str_txt3);
            }

            if(vm.questionnaire.purchaseland == true) {
                var Str_txt3=    {
                    "clearance": "Land/Plot allotment",
                    "stage": 1,
                    "department": "HSIIDC",
                    "url": "hsiidc5"
                };
                vm.answers.push(Str_txt3);
            }
            else{
                var Str_txt3=    {
                    "clearance": "Registration of Land/Property",
                    "stage": 1,
                    "department": "Department of Revenue and Disaster Management",
                    "url": "dradm"
                };
                vm.answers.push(Str_txt3);
            }





            if(vm.questionnaire.hazardouswaste=='municipal solid waste') {
                var Str_txt3=    {
                    "clearance": "Authorization under Municiple Solid Waste ( management & handling )rules, 2016",
                    "stage": 3,
                    "department": "Haryana state pollution controll board"
                };
                vm.answers.push(Str_txt3);
            }

            if(vm.questionnaire.motortransport==true) {
                var Str_txt3=    {
                    "clearance": "Registration under the Motor Transport Workers Act, 1961",
                    "stage": 3,
                    "department": "labour department",
                    "url":"table49"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.involveallopathic=='Allopathic  medicine') {
                var Str_txt3=    {
                    "clearance": "Drug license for allopathic medicine",
                    "stage": 3,
                    "department": "Department of health services",
                    "url":"page60"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.involveallopathic=='Ayurvedic medicine') {
                var Str_txt3=    {
                    "clearance": "Drug license for ayurvedic medicine",
                    "stage": 3,
                    "department": "Ayush department",
                    "url":"page58"
                };
                vm.answers.push(Str_txt3);
            }

            if(vm.questionnaire.lubricatinglicense==true) {
                var Str_txt3=    {
                    "clearance": "Lubricant license",
                    "stage": 3,
                    "department": "Industries and commerce department",
                    "url": "inds2"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.commercial==true) {
                var Str_txt3=    {
                    "clearance": "Shop registration under Shops and Establishment Act",
                    "stage": 3,
                    "department": "labour department",
                    "url": "table47"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.involvepesticides=='Pesticide or Insecticide') {
                var Str_txt3=    {
                    "clearance": "License to manufacture Insecticides/Pesticides",
                    "stage": 1,
                    "department": "Agriculture department",
                    "url": "table54"
                };
                vm.answers.push(Str_txt3);
            }
            if(vm.questionnaire.involvepesticides=='Fertilizer') {
                var Str_txt3=    {
                    "clearance": "Licence for manufacturing fertilizer",
                    "stage": 1,
                    "department": "Agriculture department",
                    "url":"table53"
                };
                vm.answers.push(Str_txt3);
            }

            if(vm.questionnaire.underbocwact==true) {
                var Str_txt3=    {
                    "clearance": "Registration of Establishment engaged in Building & other Construction activity under Building and Other Construction Workers (RE&CS) Act, 1996",
                    "stage": 2,
                    "department": "Labour department",
                    "url": "table42"
                };
                vm.answers.push(Str_txt3);
            }


            if(vm.questionnaire.involveenergy==true) {
                var Str_txt3=    {
                    "clearance": "Registration & approval for setting up of Biomass based power projects in the State",
                    "stage": 1,
                    "department": "Non-Conventional Energy/ Renewal Energy Deptt"
                };
                vm.answers.push(Str_txt3);
            }



            if(vm.questionnaire.undereia==true) {
                var Str_txt3=    {
                    "clearance": "Environment clearance plan from State/Central Environment Impact Assessment Authority- EIA notification 2006.",
                    "stage": 1,
                    "department": "Enviornment Department",
                    "url":"page57"
                };
                vm.answers.push(Str_txt3);
            }

            if(vm.questionnaire.electrictype=='Temporary Connection') {
                var Str_txt3=    {
                    "clearance": "Agreement for temporary connection and load sanctioning, Indian electricity Act, 2003",
                    "stage": 1,
                    "department": "UHBVN/DHBVN",
                    "url":"uhbvn2"
                };
                vm.answers.push(Str_txt3);
            }
        }
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('allpage1', {
            parent: 'allclearances',
            url: '/page1',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page1/page1.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage2', {
            parent: 'allclearances',
            url: '/page2',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page2/page2.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage3', {
            parent: 'allclearances',
            url: '/page3',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page3/page3.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage4', {
            parent: 'allclearances',
            url: '/page4',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page4/page4.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage5', {
            parent: 'allclearances',
            url: '/page5',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page5/page5.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage6', {
            parent: 'allclearances',
            url: '/page6',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page6/page6.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage7', {
            parent: 'allclearances',
            url: '/page7',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page7/page7.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage14', {
            parent: 'allclearances',
            url: '/page14',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page14/page14.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage16', {
            parent: 'allclearances',
            url: '/page16',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page16/page16.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage17', {
            parent: 'allclearances',
            url: '/page17',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page17/page17.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage21', {
            parent: 'allclearances',
            url: '/page21',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page21/page21.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage22', {
            parent: 'allclearances',
            url: '/page22',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page22/page22.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage23', {
            parent: 'allclearances',
            url: '/page23',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page23/page23.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage24', {
            parent: 'allclearances',
            url: '/page24',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page24/page24.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage25', {
            parent: 'allclearances',
            url: '/page25',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page25/page25.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage26', {
            parent: 'allclearances',
            url: '/page26',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page26/page26.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage56', {
            parent: 'allclearances',
            url: '/page56',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page56/page56.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage57', {
            parent: 'allclearances',
            url: '/page57',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page57/page57.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage58', {
            parent: 'allclearances',
            url: '/page58',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page58/page58.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allpage60', {
            parent: 'allclearances',
            url: '/page60',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/page60/page60.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable31', {
            parent: 'allclearances',
            url: '/table31',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table31/table31.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable32', {
            parent: 'allclearances',
            url: '/table32',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table32/table32.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable33', {
            parent: 'allclearances',
            url: '/table33',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table33/table33.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable34', {
            parent: 'allclearances',
            url: '/table34',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table34/table34.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable36', {
            parent: 'allclearances',
            url: '/table36',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table36/table36.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable37', {
            parent: 'allclearances',
            url: '/table37',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table37/table37.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable41', {
            parent: 'allclearances',
            url: '/table41',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table41/table41.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable42', {
            parent: 'allclearances',
            url: '/table42',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table42/table42.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable43', {
            parent: 'allclearances',
            url: '/table43',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table43/table43.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable44', {
            parent: 'allclearances',
            url: '/table44',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table44/table44.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable45', {
            parent: 'allclearances',
            url: '/table45',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table45/table45.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable46', {
            parent: 'allclearances',
            url: '/table46',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table46/table46.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable47', {
            parent: 'allclearances',
            url: '/table47',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table47/table47.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable48', {
            parent: 'allclearances',
            url: '/table48',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table48/table48.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable49', {
            parent: 'allclearances',
            url: '/table49',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table49/table49.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable52', {
            parent: 'allclearances',
            url: '/table52',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table52/table52.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable53', {
            parent: 'allclearances',
            url: '/table53',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table53/table53.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alltable54', {
            parent: 'allclearances',
            url: '/table54',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/table54/table54.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('alluhbvn2', {
            parent: 'allclearances',
            url: '/uhbvn2',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/uhbvn2/uhbvn2.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allhsiidc1', {
            parent: 'allclearances',
            url: '/hsiidc1',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/hsiidc1.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allhsiidc2', {
            parent: 'allclearances',
            url: '/hsiidc2',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/hsiidc2.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allhsiidc3', {
            parent: 'allclearances',
            url: '/hsiidc3',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/hsiidc3.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allhsiidc4', {
            parent: 'allclearances',
            url: '/hsiidc4',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/hsiidc4.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allhsiidc5', {
            parent: 'allclearances',
            url: '/hsiidc5',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/hsiidc5.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allinds1', {
            parent: 'allclearances',
            url: '/inds1',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds1.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allinds2', {
            parent: 'allclearances',
            url: '/inds2',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds2.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allinds3', {
            parent: 'allclearances',
            url: '/inds3',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds3.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allinds4', {
            parent: 'allclearances',
            url: '/inds4',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds4.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allinds5', {
            parent: 'allclearances',
            url: '/inds5',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds5.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allforest2', {
            parent: 'allclearances',
            url: '/forest2',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/forest2.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allfactlicense', {
            parent: 'allclearances',
            url: '/factlicense',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/factlicense.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })

        .state('allinds6', {
            parent: 'allclearances',
            url: '/inds6',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds6.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('allinds7', {
            parent: 'allclearances',
            url: '/inds7',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/questionnaire/table/inds7.html',
                    controller: '',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        ;
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('allclearancesController', allclearancesController);

    allclearancesController.$inject = ['$scope', '$stateParams','Principal', 'LoginService', '$state', 'Clearance'];

    function allclearancesController ($scope, $stateParams, Principal, LoginService, $state, Clearance) {
        var vm = this;
        vm.answerspreestablish=[];
        vm.answerspostestablish=[];
        vm.answerspreoperational=[];
        loadAll()
        function loadAll(){
            ga('set', 'page', '/Know-Your-Clearance-All-Clearances');ga('send','pageview');
        }

            var Str_txt2={
                "clearance": "Building Plan Approval",
                "stage": 2,
                "department": "Town and Country Planning",
                "url": "allpage24"
            };
            vm.answerspreoperational.push(Str_txt2);

            var Str_txt2={
                "clearance": "Building Plan Approval",
                "stage": 2,
                "department": "HSIIDC",
                "url": "allhsiidc2"
            };
            vm.answerspreoperational.push(Str_txt2);

            var Str_txt5={
                "clearance": "Release of permanent sewarage connection",
                "stage": 3,
                "department": "HSIIDC",
                "url": "allhsiidc4"
            };
            vm.answerspreoperational.push(Str_txt5);

//        if(vm.questionnaire.typeofestablishment=='Post-Establishment')
//        {
            Str_txt={
                "clearance": "Factory registration/ license under Factories Act, 1948-Safety Wing",
                "stage": '',
                "department": "Labour department",
                "url": "allfactlicense"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt={
                "clearance": "Occupation/completion certificate",
                "stage": 3,
                "department": "Town and Country Planning",
                 "url":"allpage23"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt = {
                "clearance": "Change of land use Within Municipal Limit",
                "stage": 1,
                "department": "Urban & local Bodies",
                "url": ""
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Occupation/completion certificate",
                "stage": 3,
                "department": "Urban & local Bodies",
                 "url":"alltable36"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Certification of Electrical installation by Chief Electrical Inspector",
                "stage": 3,
                "department": "Power Department(11kv to 33kv:- certification by Charted Engineer / Chief elcetrical Engineer, " +
                "Above 33 kv:- Certification Only by Chief Electical Engineer of Department)",
                "url": ""
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Establishment inter state migrant workmen (RE&CS) Act 1979",
                "stage": 3,
                "department": "labour department",
                "url":"alltable48"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Registration of the Principal Employer (Who is engaging the workers)under the Contracts Labour (Regulation & Abolition)Act,1970",
                "stage": 3,
                "department": "labour department",
                "url":"alltable43"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Registration under boiler act",
                "stage": 3,
                "department": "Industries and commerce department",
                "url": "allinds1"
             };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Drug license for allopathic medicine",
                "stage": 3,
                "department": "Food and Drug Administration",
                "url":"allpage60"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Drug license for ayurvedic medicine",
                "stage": 3,
                "department": "Ayush department",
                "url":"allpage58"
            };
            vm.answerspostestablish.push(Str_txt);


            Str_txt=    {
                "clearance": "Lubricant license",
                "stage": 3,
                "department": "Industries and commerce department",
                "url": "allinds2"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "License to manufacture Insecticides/Pesticides",
                "stage": 1,
                "department": "Agriculture department",
                "url": "alltable54"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Licence for manufacturing fertilizer",
                "stage": 1,
                "department": "Agriculture department",
                "url":"alltable53"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Consent to operate under Water Act, 1974 and the Air Act, 1981",
                "stage": 3,
                "department": "HSPCB",
                "url":"allpage3"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Registration/ Authorization under e-waste (Management & Handing) Rules, 2011",
                "stage": 3,
                "department": "Haryana state pollution controll board",
                "url": "allpage4"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Registration under hazardous waste rule 2016",
                "stage": 3,
                "department": "Haryana state pollution controll board",
                "url":"allpage5"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Authorization under bio medical waste ( management & handling )rules, 2016",
                "stage": 3,
                "department": "Haryana state pollution controll board",
                "url": "allpage7"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt=    {
                "clearance": "Release of permanent/regular electric connection,Indian electricity Act, 2003",
                "stage": 1,
                "department": "UHBVN/DHBVN",
                "url":"allpage14"
            };
            vm.answerspostestablish.push(Str_txt);

            Str_txt={
                "clearance": "Issue of completion/occupation certificate",
                "stage": 3,
                "department": "HSIIDC",
                "url": "allhsiidc1"
            };
            vm.answerspostestablish.push(Str_txt);

//        }

//        if(vm.questionnaire.typeofestablishment=='Pre-Establishment')
//        {
            Str_txt={
                "clearance": "NOC for fire service",
                "stage": '',
                "department": "Urban Local Bodies",
                "url": "alltable33"
            };
            // vm.answerspreestablish.push(Str_txt);
            // Str_txt={
            //     "clearance": "	Forest clearance for approach public entry/exit and diversion of forest land-under Forest Conservation Act,1980",
            //     "stage": '',
            //     "department": "Forest Department",
            //     "url": "allpage26"
            // };
            vm.answerspreestablish.push(Str_txt);
            Str_txt={
                "clearance": "Approval of factory plan under the Factories Act, 1948",
                "stage": '',
                "department": "Labour department",
                "url": "alltable45"
            };
            vm.answerspreestablish.push(Str_txt);

                var Str_txt3=    {
                    "clearance": "Consent for establishment under Water Act, 1974 and the Air Act, 1981",
                    "stage": 1,
                    "department": "HSPCB",
                    "url":"allpage1"
                };
                vm.answerspreestablish.push(Str_txt3);


                var Str_txt1 = {
                    "clearance": "Change of land use under Controlled Area Act 1963",
                    "stage": 1,
                    "department": "Town and Country Planning",
                    "url":"allpage16"
                };
                vm.answerspreestablish.push(Str_txt1);


                var Str_txt3=    {
                    "clearance": "License for brick klin",
                    "stage": 3,
                    "department": "Town and Country Planning",
                    "url": "allpage17"
                };
                vm.answerspreestablish.push(Str_txt3);

                var Str_txt1 = {
                    "clearance": "NOC for establishment of unit under Urban Area Act",
                    "stage": 1,
                    "department": "Town and Country Planning",
                    "url": "allpage21"
                };
                vm.answerspreestablish.push(Str_txt1);

                var Str_txt1= {
                    "clearance": "NOC for establishment of unit under Urban Area Act",
                    "stage": 1,
                    "department": "Town and Country Planning",
                    "url":"allpage22"
                };
                vm.answerspreestablish.push(Str_txt1);

                var Str_txt3=    {
                    "clearance": "Environmental clearance (EC) under Aravali Notification 1992 & 1999",
                    "stage": 1,
                    "department": "Enviornment Department",
                    "url":"allpage56"
                };
                vm.answerspreestablish.push(Str_txt3);

                Str_txt={
                    "clearance": "Shop registration under Shops and Establishment Act-Labour Wing",
                    "stage": '',
                    "department": "Labour",
                    "url": "alltable47"
                };
                vm.answerspreestablish.push(Str_txt);

                var Str_txt={
                    "clearance": "Registration of Firms under Indian Partnership Act. 1932",
                    "stage": 1,
                    "department": "Industries & Commerce Department",
                    "url": "allinds4"
                };
                vm.answerspreestablish.push(Str_txt);


                var Str_txt1={
                    "clearance": "Allotment of Plot",
                    "stage": 1,
                    "department": "HSIIDC",
                    "url": "allhsiidc5"
                };
                vm.answerspreestablish.push(Str_txt1);
                var Str_txt3={
                    "clearance": "Release of permanent water connection",
                    "stage": 2,
                    "department": "HSIIDC",
                    "url": "allhsiidc3"
                };
                vm.answerspreestablish.push(Str_txt3);

                var Str_txt7={
                    "clearance": "Issuance of Trade License Under section 330 for factory, workshop or trade remises. In which it is intended to employ steam, electricity, water or other mechanical power.",
                    "stage": 3,
                    "department": "Urban & local Bodies",
                    "url":"alltable34"
                };
                vm.answerspreestablish.push(Str_txt7);

                var Str_txt2= {
                        "clearance": "Approval of building plan",
                        "stage": 2,
                        "department": "Urban & local Bodies",
                        "url": "alltable37"
                    };
                vm.answerspreestablish.push(Str_txt2);
                var Str_txt4= {
                        "clearance": "Issuance of Water connection",
                        "stage": 2,
                        "department": "Urban & local Bodies",
                        "url": ""
                    };
                vm.answerspreestablish.push(Str_txt4);

                var Str_txt6=   {
                        "clearance": "Issuance of Trade License Under section 330 for factory, workshop or trade remises. In which it is intended to employ steam, electricity, water or other mechanical power.",
                        "stage": 3,
                        "department": "Urban & local Bodies",
                        "url": "alltable34"
                    };
                vm.answerspreestablish.push(Str_txt6);

                var Str_txt8=    {
                    "clearance": "Issuance of sewarage connection",
                    "stage": 3,
                    "department": "Urban & local Bodies",
                    "url": "alltable41"
                };
                vm.answerspreestablish.push(Str_txt8);

                var Str_txt1 = {
                    "clearance": "Change of land use Within Municipal Limit",
                    "stage": 1,
                    "department": "Urban & local Bodies",
                    "url": ""
                };
                vm.answerspreestablish.push(Str_txt1);
                var Str_txt2=    {
                    "clearance": "Approval of building plan",
                    "stage": 2,
                    "department": "Urban & local Bodies",
                    "url":"alltable37"
                };
                vm.answerspreestablish.push(Str_txt2);

                var Str_txt4= {
                    "clearance": "Issuance of Water connection",
                    "stage": 2,
                    "department": "Urban & local Bodies",
                    "url": ""
                };
                vm.answerspreestablish.push(Str_txt4);

                var Str_txt2=    {
                    "clearance": "Tree felling irrespective of location of land",
                    "stage": 1,
                    "department": "Forest Department",
                    "url": "allforest2"
                };
                vm.answerspreestablish.push(Str_txt2);

                var Str_txt3=    {
                    "clearance": "Release of permanent water connection",
                    "stage": 2,
                    "department": "HSIIDC",
                    "url": "allhsiidc3"
                };
                vm.answerspreestablish.push(Str_txt3);

                var Str_txt3=    {
                    "clearance": "Shop registration under Shops and Establishment Act",
                    "stage": 3,
                    "department": "labour department",
                    "url": "alltable47"
                };
                vm.answerspreestablish.push(Str_txt3);

                var Str_txt3=    {
                    "clearance": "Registration of Establishment engaged in Building & other Construction activity under Building and Other Construction Workers (RE&CS) Act, 1996",
                    "stage": 2,
                    "department": "Labour department",
                    "url": "alltable42"
                };
                vm.answerspreestablish.push(Str_txt3);

                var Str_txt3=    {
                    "clearance": "Environment clearance plan from State/Central Environment Impact Assessment Authority- EIA notification 2006.",
                    "stage": 1,
                    "department": "Enviornment Department",
                    "url":"allpage57"
                };
                vm.answerspreestablish.push(Str_txt3);

                var Str_txt3=    {
                    "clearance": "Release of Temporary Connection",
                    "stage": 1,
                    "department": "UHBVN/DHBVN",
                    "url":"alluhbvn2"
                };
                vm.answerspreestablish.push(Str_txt3);

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('public-feedback', {
            parent: 'app',
            url: '/public-feedback',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/publicFeedback/publicFeedback.html',
                    controller: 'PublicFeedbackController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        });

    }
})();


(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PublicFeedback', PublicFeedback);

    PublicFeedback.$inject = ['$resource'];

    function PublicFeedback ($resource) {
        var resourceUrl =  'api/public-feedback/:id/:policyName';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'countByPolicy': {
                method: 'GET',
                url: 'api/public-feedback/count/:policyName',
                transformResponse: function (data) {
                    try {
                        return parseInt(data, 10);
                    } catch (e) {
                        return 0;
                    }
                },
                interceptor: {
                    response: function (response) {
                        // Extract the plain number
                        return response.data ? parseInt(response.data, 10) : 0;
                    }
                }
            },
            'feedbackByPolicy': {
                method: 'GET',
                url: 'api/public-feedback/feedbackByPolicy/:policyName',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PublicFeedbackController', PublicFeedbackController);

    PublicFeedbackController.$inject = ['$scope','$state', 'PublicFeedback'];

    function PublicFeedbackController($scope,$state, PublicFeedback ) {

        var vm = this;
        // vm.clear = clear;
        loadAll();
        // vm.submitForm = submitForm;

        vm.feedbackCounts = {};



        function loadAll()
        {
           // var policyName = 'Draft MAKE IN HARYANA INDUSTRIAL POLICY 2025';


            vm.policyList = [
                { policyName: 'Draft MAKE IN HARYANA INDUSTRIAL POLICY 2025', pdfUrl: '../../content/pdfs/Make in Haryana Industrial Policy 2025 - 15.09.2025.pdf' },
                { policyName: 'Draft Haryana Electronics Waste Recycling Policy, 2024', pdfUrl: '../../content/pdfs/E-Waste Policy 27.06.pdf' },
                { policyName: 'Draft Haryana AVGC-XR Policy, 2024', pdfUrl: '../../content/pdfs/AVGCXR Policy 27.06.pdf' },
                { policyName: 'Draft Haryana IT & ITeS Policy, 2024', pdfUrl: '../../content/pdfs/IT-ITeS Policy 27.06.pdf' },
                { policyName: 'Draft Haryana Electronic Toys Manufacturing Policy, 2024', pdfUrl: '../../content/pdfs/Electronic Toys Policy 14.3.pdf' },
                { policyName: 'Draft Haryana Electronic System Design & Manufacturing (ESDM) Policy, 2024', pdfUrl: '../../content/pdfs/ESDM Policy 14.3.pdf' },
                { policyName: 'Draft Haryana Medical Devices Manufacturing Policy, 2024', pdfUrl: '../../content/pdfs/Medical Devices Policy 16.2 (1).pdf' },
                { policyName: 'Communication & Connectivity Infrastructure Policy - 2023', pdfUrl: '../../content/pdfs/Revised Communication Connectivity Infrastructure Policy 2023.pdf' },
                { policyName: 'EV policy 2022', pdfUrl: '../../content/pdfs/EV Policy 2022.pdf' },
                { policyName: 'HARYANA ENTERPRISES AND EMPLOYMENT POLICY, 2020', pdfUrl: '../../content/pdfs/2020_HEEP.pdf' }
                // add more if needed
            ];

            vm.feedbackCounts = {};

            vm.policyList.forEach(function (policy) {
                PublicFeedback.countByPolicy({ policyName: policy.policyName }).$promise
                    .then(function (response) {
                        console.log('Raw response for', policy.policyName, ':', response);

                        // Check if response has 'data' or numeric value
                        var count = 0;

                        if (typeof response === 'number') {
                            count = response;
                        } else if (response && typeof response.valueOf() === 'number') {
                            count = response.valueOf();
                        } else if (response.data) {
                            count = response.data;
                        } else if (response.count) {
                            count = response.count;
                        }

                        console.log('Resolved count for', policy.policyName, '=>', count);
                        vm.feedbackCounts[policy.policyName] = count || 0;
                    })
                    .catch(function (error) {
                        console.error('Error fetching feedback count for', policy.policyName, error);
                        vm.feedbackCounts[policy.policyName] = 0;
                    });
            });

        }


        vm.openFeedbackModal = function(policyName) {
            vm.selectedPolicy = policyName;
            vm.feedback = { policyName: policyName, comment: '' };
            $('#feedbackModal').modal('show');
        };

        vm.viewAllFeedback = function(policyName) {
            vm.selectedPolicy = policyName;
            //vm.feedback = { policyName: policyName, comment: '' };
            $('#feedbackViewModal').modal('show');
          vm.policyFeedbacks =   PublicFeedback.feedbackByPolicy({policyName: policyName});
        };

        vm.submitFeedback = function() {
            if (vm.feedback.comment === '') {
                alert('Please enter your feedback before submitting.');
                return;
            }
            console.log("feddbackkkk", vm.feedback);
            PublicFeedback.save(vm.feedback, onSaveSuccess, onSaveError);
          //  alert("Your feedback submitted successfully");
          //  $('#feedbackModal').modal('hide');
        }

        function onSaveSuccess (result) {
            alert('Thank you for submitting your Feedback.');
            vm.isSaving = false;
            window.location.reload();
        }

        function onSaveError () {
            alert('Error while saving the form. Please try again');
            vm.isSaving = false;
            // window.location.reload();
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceViewCafYearly', ServiceViewCafYearly);

    ServiceViewCafYearly.$inject = ['$resource'];

    function ServiceViewCafYearly ($resource) {
        var resourceUrl =  'api/servicedashboardcafsYearly/:serviceid/:status/:department/:servicename';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PsTowerServiceViewByElastic', PsTowerServiceViewByElastic);

    PsTowerServiceViewByElastic.$inject = ['$resource'];

    function PsTowerServiceViewByElastic ($resource) {
        var resourceUrl =  'api/psTowerServiceViewByElastic/departmentName/district/projectLevel/serviceId/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('PsTowerServiceViewController', PsTowerServiceViewController);

    PsTowerServiceViewController.$inject = ['$timeout','$filter', '$scope', '$stateParams', '$uibModalInstance', 'ServiceViewCafYearly', 'TowerserviceNO','ServiceViewCafYearlyByElastic','DownloadServiceViewCafYearlyByElastic','DownloadCafCsv', 'PsTowerServiceViewByElastic', 'PsTowerDashboardDatewise', 'DownloadRejectionReason'];
    function PsTowerServiceViewController ($timeout,$filter, $scope, $stateParams, $uibModalInstance, ServiceViewCafYearly, TowerserviceNO, ServiceViewCafYearlyByElastic,DownloadServiceViewCafYearlyByElastic,DownloadCafCsv, PsTowerServiceViewByElastic, PsTowerDashboardDatewise, DownloadRejectionReason) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.clear = clear;
        vm.servicename=$stateParams.servicename;
        vm.status=$stateParams.status;
        vm.serviceid=$stateParams.serviceid;
        var initDate=new Date('05-01-2017');
        var totalTime=0;
        var totalCleared=0;
        vm.showDepartments=showDepartments;
        vm.departmentName=[];
        vm.toDate = null;
        vm.fromDate = null;
        vm.downloadAllData = downloadAllData;
        vm.openCalendar = openCalendar;
        vm.hideClear = false;

        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        // vm.clearFilterButton = false;
        vm.selectedDate=selectedDate;



        vm.spiner= true;

        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
            /*appliedDate=new Date(result[i].appliedDate.toDateString());
            clearedDate=new Date(result[i].clearedDate.toDateString());
            dayDiff= (clearedDate - appliedDate)  / 1000 / 60 / 60 / 24;
*/
        loadAllCafs();
        function loadAllCafs() {
            var appliedDate;
            var clearedDate;
            var dayDiff;
            if (!$stateParams.departmentName) {
                vm.deptName = null;
            } else {
                vm.deptName = $stateParams.departmentName;
            }

            if (!$stateParams.district) {
                vm.districtName = null;
            } else {
                vm.districtName = $stateParams.district;
            }

            if (!$stateParams.projectLevel) {
                vm.levelfiled = null;
            } else {
                vm.levelfiled = $stateParams.projectLevel;
            }
            var data = {
                departmentName: vm.deptName,
                district: vm.districtName,
                projectLevel: vm.levelfiled,
                serviceId: $stateParams.serviceid,
                status: $stateParams.status,
                page: $scope.currentPage - 1,
                size: $scope.pageSize
            };
            Object.keys(data).forEach(function (k) {
                if (!data[k] && data[k] !== undefined) {
                    delete data[k];
                }
            });

            //   vm.dashboardcafs=ServiceViewCafYearly.query({serviceid:$stateParams.serviceid,status:$stateParams.status},function(result){
            //     vm.show=true;
            //     vm.spiner=false;
            //     console.log(result);
            // });
            vm.dashboardcafs = PsTowerServiceViewByElastic.get(data,
                function (result) {
                    vm.show = true;
                    vm.spiner = false;
                });
        }

        vm.loadAllCafsByDate=function () {
            var f=$filter('date')(vm.fromdate, "yyyy-MM-dd");
            var t=$filter('date')(vm.todate, "yyyy-MM-dd");
            var fromdate=$filter('date')(vm.fromdate, "yyyy-MM-dd");
            var todate=$filter('date')(vm.todate, "yyyy-MM-dd");

            if (!$stateParams.departmentName) {
                vm.deptName = null;
            } else {
                vm.deptName = $stateParams.departmentName;
            }

            if (!$stateParams.district) {
                vm.districtName = null;
            } else {
                vm.districtName = $stateParams.district;
            }

            if (!$stateParams.projectLevel) {
                vm.levelfiled = null;
            } else {
                vm.levelfiled = $stateParams.projectLevel;
            }
            var data = {
                departmentName: vm.deptName,
                district: vm.districtName,
                projectLevel: vm.levelfiled,
                serviceId: $stateParams.serviceid,
                status: $stateParams.status,
                fromDate: fromdate,
                toDate: todate,
                page: $scope.currentPage - 1,
                size: $scope.pageSize
            };
            console.log(data);

            Object.keys(data).forEach(function (k) {
                if (!data[k] && data[k] !== undefined) {
                    delete data[k];
                }
            });

            vm.dashboardcafs = PsTowerDashboardDatewise.get(data,
                function (result) {
                vm.show = true;
                vm.hideClear = true;
                vm.spiner = false;
            });
        };

        function downloadAllData() {
            DownloadServiceViewCafYearlyByElastic.query({
                    departmentName: vm.deptName,
                    district: vm.districtName,
                    projectLevel: vm.levelfiled,
                    serviceId: $stateParams.serviceid,
                    status: $stateParams.status
                },function (result) {
                DownloadCafCsv.download(result[0].status).then(function (success) {
                    console.log(success);
                }, function (error) {
                    alert('error : ' + error);
                });
            });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        };

        $scope.pageChangedHandler = function(num) {
            loadAllCafs();
        };

        function showDepartments(data) {
            TowerserviceNO.query({id:'1',projectdetailid:data.projectdetailid},function (result) {
                if(result.length===0){
                    vm.departmentName=[];
                    vm.departmentName[0] = "NA";
                }
                else {
                    vm.departmentName = result;
                }
            });

        }



        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dateOptions = {
            minDate: new Date("05-01-2017"),
            maxDate: Date.now()
        };

        function selectedDate(dateSelected){
            var newDate = new Date(dateSelected);
            newDate.setDate(newDate.getDate()+1200);
            if(newDate > Date.now()){
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: Date.now()
                };
            }
            else {
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: newDate
                };
            }
        }
        vm.clearFilter = function () {
            vm.filter ={};
            loadAll();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PSTowerDownloadService', PSTowerDownloadService);

    PSTowerDownloadService.$inject = ['$resource'];

    function PSTowerDownloadService ($resource) {
        var resourceUrl =  'api/psTowerDownloadDashboard/status/fromDate/toDate';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'getPdf': {
                method: 'GET',
                url: 'api/psTowerDownloadDashboardPdf/status/fromDate/toDate',
                isArray: false, // Set isArray to false to expect an object response
                transformResponse: function(data, headers) {
                    // Parse the response data if necessary
                    var responseData = angular.fromJson(data);
                    // Return the data as an object or modify it as needed
                    return responseData;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PSTowerDepartment', PSTowerDepartment);

    PSTowerDepartment.$inject = ['$resource'];

    function PSTowerDepartment ($resource) {
        var resourceUrl =  'api/psdepartments';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
         .state('psTowerDashboard', {
          parent: 'pstowerdashboard',
          url: '/psTowerServiceViewByElasticByStatus/{status}',
          data: {
              authorities: []
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'app/psTowerDashboard/psTowerDashboardView.html',
                  controller: 'PsTowerDashboardViewController',
                  controllerAs: 'vm',
                  backdrop: 'static',
                  size: 'lg',
                  windowClass: 'app-modal-window',
                  resolve: {
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                          $translatePartialLoader.addPart('dashboard');
                          return $translate.refresh();
                      }]
                  }
              }).result.then(function() {
                  $state.go('pstowerdashboard', null, { reload: 'pstowerdashboard' });
              }, function() {
                  $state.go('pstowerdashboard');
              });
          }]
      });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PsTowerDashboardView', PsTowerDashboardView);

    PsTowerDashboardView.$inject = ['$resource'];

    function PsTowerDashboardView ($resource) {
        var resourceUrl =  'api/psTowerServiceViewByElasticByStatus/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PsTowerDashboardViewController', PsTowerDashboardViewController);

    PsTowerDashboardViewController.$inject = ['$scope', '$window', '$stateParams','$filter', 'Principal', '$uibModalInstance', 'LoginService', '$state', 'PsTowerDashboardView','PSTowerDownloadService', 'downloadService'];

    function PsTowerDashboardViewController ($scope, $window, $stateParams,$filter, Principal, $uibModalInstance, LoginService, $state, PsTowerDashboardView, PSTowerDownloadService, downloadService) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.download = download;
        vm.downloadPdf = downloadPdf;

        vm.status = $stateParams.status;
        vm.clear = clear;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        var args = [];

        vm.spiner =true;
        vm.datePickerOpenStatus = {};
        vm.sortingdates={};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        vm.selectedDate=selectedDate;
        var d=null;
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dateOptions = {
            minDate: "04-01-2018",
            maxDate: Date.now()
        };

        function selectedDate(dateSelected){
            var newDate = new Date(dateSelected);
            newDate.setDate(Date.now());

            if(newDate > Date.now()){
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: Date.now()
                };
            }
            else {
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: newDate
                };
            }
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        loadAllCafs();
        function loadAllCafs() {
            vm.psTowerDashboard=PsTowerDashboardView.get(
                {status:$stateParams.status,
                    page: $scope.currentPage - 1,
                    size: $scope.pageSize
                },
                function (result) {
                    vm.show=true;
                vm.spiner=false;
            });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        };
        $scope.pageChanged = function(num) {
            loadAllCafs();
        };

        function convertJsonsToArrays(args){
            var dataArray = [];
            var header = [ "CAFPin",
                "Status",
                "RTS > 30",
                "RTS > 45",
                "RTS > 65",
                "Within RTS",
                "District",
                "Department",
                "Investor Name",
                "Investor Contact",
                "Investor Email",
                "Project Level",
                "Proposed Employment",
                "Project Investment" ,
                "Applied Date",
                "Pending At",
                "Land Zone Use Type",
                "Service Name",
                "Business Entity",
                "Service Fee",
                "Project Id",
                "Deemed Cleared Date"
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                var appliedDate=$filter('date')(row.formFilledOn, 'dd-MM-yyyy');
                rowAr.push(row.cafpin);
                rowAr.push(row.status);
                rowAr.push(row.rtsGreaterThan30);
                rowAr.push(row.rtsGreaterThan45);
                rowAr.push(row.rtsGreaterThan65);
                rowAr.push(row.withinRts);
                rowAr.push(row.district);
                rowAr.push(row.departmentName);
                rowAr.push(row.investorName);
                rowAr.push(row.investorMobilenumber);
                rowAr.push(row.investorEmail);
                rowAr.push(row.projectLevel);
                rowAr.push(row.proposedEmployment);
                rowAr.push(row.proposedInvestment);
                rowAr.push(appliedDate);
                rowAr.push(row.pendingAt);
                rowAr.push(row.landZoneUseType);
                rowAr.push(row.serviceName);
                rowAr.push(row.businessEntity);
                rowAr.push(row.serviceFee);
                rowAr.push(row.projectId);
                if (row.deemedClearedDate){
                    rowAr.push(row.deemedClearedDate);
                }else {
                    rowAr.push("NA");
                }
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function convertJsonsToArrays1(args){
            var dataArray = [];
            var header = [ "CAFPin",
                "Business Entity",
                "District",
                "Department",
                "Investor Name",
                "Investor Contact",
                "Investor Email",
                "Service Name",
                "Project Level",
                "Proposed Employment",
                "Project Investment" ,
                "Applied Date",
                "Completion Date",
                "Address",
                "Land Zone Use Type"
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                var appliedDate=$filter('date')(row.formFilledOn, 'dd-MM-yyyy');
                var clearedDate=$filter('date')(row.clearedDate, 'dd-MM-yyyy');
                rowAr.push(row.cafpin);
                rowAr.push(row.businessEntity);
                rowAr.push(row.district);
                rowAr.push(row.departmentName);
                rowAr.push(row.investorName);
                rowAr.push(row.investorMobilenumber);
                rowAr.push(row.investorEmail);
                rowAr.push(row.serviceName);
                rowAr.push(row.projectLevel);
                rowAr.push(row.proposedEmployment);
                rowAr.push(row.proposedInvestment);
                rowAr.push(appliedDate);
                rowAr.push(clearedDate);
                rowAr.push(row.investorAddress);
                rowAr.push(row.landZoneUseType);
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function download(status) {
            var fromdate=$filter('date')(vm.fromdate, "dd-MM-yyyy");
            var todate=$filter('date')(vm.todate, "dd-MM-yyyy");

            PSTowerDownloadService.query({status: status, fromdate:fromdate,todate:todate}, function (data) {
                    args = data;
                // if(status === "Pending"){
                    var rowsCleared= convertJsonsToArrays(args);
                // }
                // else{
                //     var rows = convertJsonsToArrays1(args);
                //
                // }
                var lineArray = [];
                var lineArrayCleared = [];
                // if(status === "Required" || status === "Pending" || status === "Applied"){
                    for(var i = 0; i < rowsCleared.length; i++){
                        var lineCleared = rowsCleared[i].join("\t");
                        lineArrayCleared.push(lineCleared);
                    }
                    lineArrayCleared = lineArrayCleared.join("\n");
                    var a = document.createElement('a');
                    var blob = new Blob([lineArrayCleared],{type: 'data:text/plain;charset=utf-8;'});
                    var url = URL.createObjectURL(blob);
                    $window.location.href = url;
                // }
                // else{
                //     for(var i = 0; i < rows.length; i++){
                //         var line = rows[i].join("\t");
                //         lineArray.push(line);
                //     }
                //     lineArray = lineArray.join("\n");
                //     var a = document.createElement('a');
                //     var blob = new Blob([lineArray],{type: 'data:text/plain;charset=utf-8;'});
                //     var url = URL.createObjectURL(blob);
                //     $window.location.href = url;
                // }

            });
        }



        function downloadPdf(status) {
            var fromdate = $filter('date')(vm.fromdate, "dd-MM-yyyy");
            var todate = $filter('date')(vm.todate, "dd-MM-yyyy");

            PSTowerDownloadService.getPdf({ status: status, fromdate: fromdate, todate: todate }, function(response) {
                if (response && response.success) {
                    // Display success message and the name of the generated PDF
                   if (response.message === "Pdf Created") {
                       downloadHEPC(response.pdfFileName);
                   } else {
                       alert(response.message);
                   }
                } else {
                    // Display failure message
                    alert("Error: Failed to generate PDF");
                }
            }, function(error) {
                // Handle error response
                alert("Error: " + error.data.message);
            });
        }

        function downloadHEPC(filename) {
            downloadService.download(filename)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PsTowerDashboardDatewise', PsTowerDashboardDatewise);

    PsTowerDashboardDatewise.$inject = ['$resource'];

    function PsTowerDashboardDatewise ($resource) {
        var resourceUrl =  'api/psTowerServiceDataByDate/departmentName/district/projectLevel/serviceId/status/fromDate/toDate';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PsTowerDashboardByFilter', PsTowerDashboardByFilter);

    PsTowerDashboardByFilter.$inject = ['$resource'];

    function PsTowerDashboardByFilter ($resource) {
        var resourceUrl =  'api/psTowerDashboardFilter/departmentName/district/projectLevel';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pstowerdashboard', {
            parent: 'app',
            url: '/ps-tower-dashboard',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/psTowerDashboard/pstowerdashboard.html',
                    controller: 'PsTowerDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        }).state('pstowerdashboardcafs', {
            parent: 'pstowerdashboard',
            url: '/{servicename}/{departmentName}/{district}/{projectLevel}/{serviceid}/{status}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/psTowerDashboard/pstowerserviceview.html',
                    controller: 'PsTowerServiceViewController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('pstowerdashboard', null, { reload: 'pstowerdashboard' });
                }, function() {
                    $state.go('pstowerdashboard');
                });
            }]
        })
            .state('viewsurveyform', {
            parent: 'app',
            url: '/viewsurveyform',
            data: {
                authorities: [],
                pageTitle: 'global.menu.Survey Form Dashboard'
            },
            views: {
                'content@': {
                    templateUrl: 'app/surveyForm/surveyFormDashboard.html',
                    controller: 'SurveyFormForTowerOfficerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        })
            .state('viewsurveyformfordc', {
                parent: 'app',
                url: '/viewsurveyformfordc',
                data: {
                    authorities: ['ROLE_TOWER_DC']
                   // pageTitle: 'global.menu.Survey Form Dashboard'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/surveyForm/surveyFormForDc.html',
                        controller: 'SurveyFormForDCController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        return $translate.refresh();
                    }]
                }
            })
            .state('viewsurveyformfortowerofficer', {
                parent: 'app',
                url: '/viewsurveyformfortower',
                data: {
                    authorities: ['ROLE_TOWER_OFFICER']
                    //pageTitle: 'global.menu.Survey Form Dashboard'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/surveyForm/surveyFormDashboard.html',
                        controller: 'SurveyFormForTowerOfficerController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        return $translate.refresh();
                    }]
                }
            });


    }
})();


(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PSTowerDashboardService', PSTowerDashboardService);

    PSTowerDashboardService.$inject = ['$resource'];

    function PSTowerDashboardService ($resource) {
        var resourceUrl =  'api/psTowerDashboard';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PsTowerDashboardController', PsTowerDashboardController);

    PsTowerDashboardController.$inject = ['$scope','$filter', 'Principal', 'LoginService', '$state', 'DeptServiceDashboard', 'DeptServiceStats','ServiceViewCaf','ServiceDashboardStats' ,'PSTowerDashboardService','District','PsTowerDashboardByFilter', 'Department', 'PSTowerDepartment', 'DownloadRejectionReason', 'DownloadCafCsv', '$window'];

    function PsTowerDashboardController ($scope,$filter, Principal, LoginService, $state, DeptServiceDashboard, DeptServiceStats, ServiceViewCaf, ServiceDashboardStats ,PSTowerDashboardService,District,PsTowerDashboardByFilter, Department, PSTowerDepartment, DownloadRejectionReason, DownloadCafCsv, $window) {
        var vm = this;
        vm.account = null;
        vm.districts = [];
        vm.departments =[];
        vm.filter = {};
        vm.deptName = null;
        vm.districtName = null;
        vm.levelfiled = null;
        vm.hideClear = false;

        var args = [];


        loadAll();
        function loadAll() {
        Principal.identity().then(function(account) {
            vm.account = account;
        });

        District.query(function(result) {
            vm.districts = result;
            vm.searchQuery = null;
        });

            PSTowerDepartment.query(function(result) {
                vm.departments = $filter('filter')(result,{ istower : true });
                console.log(vm.departments);
                vm.searchQuery = null;
            });


        // ServiceDashboardStats.query(function(result) {
            PSTowerDashboardService.query(function(result) {

          vm.deptservicedashboard = result;
           vm.totalappliedservices=0;
           vm.totalrequiredservices=0;
           vm.totalpendingservices=0;
           vm.totalcompletedservices=0;
           vm.totalrejectedservices=0;
           vm.totaldeemedclearedservices=0;
           vm.totalWithdrawServices=0;
            for(var i=0;i<vm.deptservicedashboard.length;i++)
            {
                console.log(vm.deptservicedashboard[i]);
                console.log(vm.deptservicedashboard[i].withdraw);


              vm.totalappliedservices=vm.totalappliedservices + parseInt(vm.deptservicedashboard[i].applied);
              vm.totalrequiredservices=vm.totalrequiredservices+ parseInt(vm.deptservicedashboard[i].required);
              vm.totalpendingservices=vm.totalpendingservices+ parseInt(vm.deptservicedashboard[i].pending_total);
              vm.totalcompletedservices=vm.totalcompletedservices+ parseInt(vm.deptservicedashboard[i].cleared);
              vm.totalrejectedservices=vm.totalrejectedservices+ parseInt(vm.deptservicedashboard[i].rejected);
              vm.totaldeemedclearedservices=vm.totaldeemedclearedservices+ parseInt(vm.deptservicedashboard[i].deemed_cleared);
              vm.totalWithdrawServices=vm.totalWithdrawServices+ parseInt(vm.deptservicedashboard[i].withDraw);
            }
           vm.searchQuery = null;
         });
        }

        vm.FilterWiseDat = function () {
            console.log(vm.filter);
            PsTowerDashboardByFilter.query(vm.filter,function (result) {
                vm.hideClear = true;
                vm.deptservicedashboard =result;
            })
        };
        vm.clearFilter = function () {
            vm.filter ={};
            loadAll();
        };


    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DownloadServiceViewCafYearlyByElastic', DownloadServiceViewCafYearlyByElastic);

    DownloadServiceViewCafYearlyByElastic.$inject = ['$resource'];

    function DownloadServiceViewCafYearlyByElastic ($resource) {
        var resourceUrl =  'api/servicedashboardcafsYearlyListByElastic/departmentName/district/projectLevel/serviceId/status';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DownloadRejectionReason', DownloadRejectionReason);

    DownloadRejectionReason.$inject = ['$resource'];

    function DownloadRejectionReason ($resource) {
        var resourceUrl =  'api/psTowerDownloadDashboardByStatusRejection';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DownloadCafCsv', ['$q', '$timeout', '$window',
            function($q, $timeout, $window, $http) {
                return {
                    download: function(serverfilename) {
                        var defer = $q.defer();
                        $timeout(function() {
                            $window.location = 'api/downloadcafattachment?serverfilename='+serverfilename;
                        }, 1000)
                            .then(function() {
                                defer.resolve('success');
                            }, function() {
                                defer.reject('error');
                            });
                        return defer.promise;
                    }
                };
            }
        ]);
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TotalSkillsController', TotalSkillsController);

    TotalSkillsController.$inject = ['ProjectSkills'];

    function TotalSkillsController(ProjectSkills) {

        var vm = this;

        vm.projectSkills = [];

        loadAll();

        function loadAll() {
            ProjectSkills.query({skillsData:'skillsData'},function(result) {
                vm.projectSkills = result;
                console.log(vm.projectSkills);
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SkillsRequiredController', SkillsRequiredController);
    SkillsRequiredController.$inject = ['$stateParams', '$scope','$filter','$uibModalInstance', 'Principal', 'LoginService', '$state', 'projectInfo', 'SkillsData', 'ProjectSkills', 'Projectlogupdated', 'ProjectLogNewCaf', 'Project'];

    function SkillsRequiredController ($stateParams, $scope,$filter ,$uibModalInstance , Principal, LoginService, $state, projectInfo, SkillsData , ProjectSkills, Projectlogupdated, ProjectLogNewCaf, Project) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.sectorResult=sectorResult;
        vm.mySectorData = [];
        vm.requiredPerson = [];
        vm.project = projectInfo;

        vm.projectLogNewCaf ={};
        vm.projectlog ={};

        vm.clear = clear;


        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register () {
            $state.go('register');
        }
        vm.skillsData = [];

        loadAll();

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


        function loadAll() {
            SkillsData.query(function(result) {
                vm.skillsData = result;
                vm.searchQuery = null;
            });
        }

        function sectorResult(sectorName) {
            vm.requiredPerson = $filter('filter')(vm.skillsData, {sector: sectorName});
            vm.mySectorData=[];
        }


        vm.saveSkillsRequried = function (sector) {
            vm.projectSkills = {};
            vm.projectSkills.cafPin = vm.project.cafpin;
            vm.projectSkills.projectId = vm.project.id;

            for(var i=0;i<vm.mySectorData.length;i++){
                vm.isSaving = true;
                vm.projectSkills.cafPin = vm.project.cafpin;
                vm.projectSkills.projectId = vm.project.id;
                vm.projectSkills.sector = vm.mySectorData[i].sector;
                vm.projectSkills.district = vm.project.district;
                vm.projectSkills.jobRole = vm.mySectorData[i].jobRole;
                vm.projectSkills.requiredLabour = vm.mySectorData[i].requiredLabour;

                ProjectSkills.save(vm.projectSkills,onSaveError);
                vm.projectSkills = {};

            }
            onSaveSuccess();

        };
        function onSaveSuccess (result) {
            vm.project.id = $stateParams.projectid;
            vm.project.isskillsFilled = true;

            Project.update(vm.project);

            if(vm.project.caftype!=='New'){
                vm.projectlog.projectid = $stateParams.projectid;
                vm.projectlog.actiontaken = "Skills Required";
                vm.projectlog.actiontype = "Skills Added";
                Projectlogupdated.save(vm.projectlog, onProjectLogSaveSuccess, onProjectLogSaveError);
            }
            if(vm.project.caftype==='New'){
                vm.projectLogNewCaf.projectId = $stateParams.projectid;
                vm.projectLogNewCaf.actionTaken = "added Required Skills for Project";
                vm.projectLogNewCaf.actionType = "Skills Added";

                ProjectLogNewCaf.save(vm.projectLogNewCaf, onProjectLogSaveSuccess, onProjectLogSaveError);
            }
            $uibModalInstance.close(result);
            $state.go('projectdetailjist');


            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function onProjectLogSaveSuccess(result)
        {

        }
        function onProjectLogSaveError()
        {

        }


    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceLogController', ServiceLogController);
    ServiceLogController.$inject = ['$stateParams', '$scope', 'Principal', 'LoginService', '$state', 'Projectlogupdated', 'ProjectLogNewCaf'];

    function ServiceLogController ($stateParams, $scope, Principal, LoginService, $state, Projectlogupdated, ProjectLogNewCaf) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        $scope.projectId = $stateParams.projectid;
        $scope.cafType = $stateParams.cafType;

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();
        loadProjectLog();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register () {
            $state.go('register');
        }

        function loadProjectLog() {
            if($scope.cafType === 'New'){
                ProjectLogNewCaf.query({projectid: $scope.projectId}, function(result) {
                    vm.projectlogsnewcaf = result;
                });
            }
            else {
                Projectlogupdated.query({projectid: $scope.projectId}, function(result) {
                    vm.projectlogs = result;
                    console.log(result)
                });
            }
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('projectdetailjist', {
            parent: 'app',
            url: '/projectdetailjist/{projectid}',
            data: {
                authorities: ['ROLE_ADMIN','ROLROLE_DEPT_CHANGEE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER','ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT',"ROLE_L2_DEPARTMENT_HEAD",'ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN','ROLE_CAF_STATUS_OFFICER','ROLE_STATE_NODAL_OFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/projectdetailjist/projectdetailjist.html',
                    controller: 'projectdetailjistController',
                    controllerAs: 'vm'
                },
                'sideView@projectdetailjist': {
                    templateUrl: 'app/projectdetailjist/cafSummary.html',
                    controller: 'CafSummaryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                projectLog: function () {
                    return {
                        projectid: null,
                        actiontaken: null,
                        actiontakenby: null,
                        actiontakendate: null,
                        actiontype: null,
                        id: null
                    };
                },
                projectLogNewCaf: function () {
                    return {
                        projectId: null,
                        actionTaken: null,
                        actionTakenBy: null,
                        actionTakenDate: null,
                        actionType: null,
                        fieldUpdated: null,
                        oldValue: null,
                        newValue: null,
                        id: null
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('projectdetailjist');
                    return $translate.refresh();
                }],
                projectInfo: ['$stateParams', 'Project', function ($stateParams, Project) {
                    return Project.get({id : $stateParams.projectid}).$promise;
                }]
            }
        })
        .state('projectdetailjist-fillform', {
            parent: 'projectdetailjist',
            url: '/fillform/:serviceID?projectid',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/projectdetailjist/fillform.html',
                    controller: 'fillformController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('projectdetailjist', null, { reload: 'projectdetailjist' });
                }, function() {
                    $state.go('projectdetailjist');
                });
            }]
        })
        .state('projectdetailjist-payfee', {
            parent: 'projectdetailjist',
            url: '/payfee/:serviceID?projectid',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/projectdetailjist/payfee.html',
                    controller: 'payfeeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('projectdetailjist', null, { reload: 'projectdetailjist' });
                }, function() {
                    $state.go('projectdetailjist');
                });
            }]
        });
        $stateProvider.state('viewServiceLog', {
            parent: 'projectdetailjist',
            url: '/service-log/{cafType}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DEPT_CHANGE','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT',"ROLE_L2_DEPARTMENT_HEAD",'ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_CAF_STATUS_OFFICER','ROLE_STATE_NODAL_OFFICER']
            },
            views: {
                'sideView@projectdetailjist': {
                    templateUrl: 'app/projectdetailjist/serviceLog.html',
                    controller: 'ServiceLogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]

            }
        });

        $stateProvider.state('skills', {
            parent: 'projectdetailjist',
            url: '/skills-Required/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_STATE_NODAL_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/projectdetailjist/skillsRequired.html',
                    controller: 'SkillsRequiredController',
                    controllerAs: 'vm',
                    backdrop: 'static',

                    resolve: {
                        projectInfo: ['$stateParams', 'Project', function ($stateParams, Project) {
                            return Project.get({id : $stateParams.projectid}).$promise;
                        }]
                    }

                }).result.then(function() {
                    $state.go('projectdetailjist', null, { reload: 'projectdetailjist' });
                }, function() {
                    $state.go('projectdetailjist');
                });
            }]
        }),

        $stateProvider.state('noInfo', {
            parent: 'projectdetailjist',
            url: '/NOInfo',
            data: {
                authorities: []
            },
            views: {
                'sideView@projectdetailjist': {
                    templateUrl: 'app/projectdetailjist/NoInfo.html',
                    controller: 'NoInfoController',
                    controllerAs: 'vm'
                }
            },

            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectdetailjist');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }

        })
            .state('totalSkills', {
                parent: 'app',
                url: '/total-Skills',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_SKILLS_REQUIREMENT_OFFICER'],
                    pageTitle: 'investhryApp.projectSkills.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/projectdetailjist/totalskills.html',
                        controller: 'TotalSkillsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('projectSkills');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

// (function () {
//     'use strict';
//
//     angular
//         .module('investhryApp')
//         .controller('projectdetailjistController', projectdetailjistController);
//     projectdetailjistController.$inject = ['$stateParams', '$scope', 'Principal', 'LoginService', '$state', 'projectInfo'];
//
//     function projectdetailjistController($stateParams, $scope, Principal, LoginService, $state, projectInfo) {
//         var vm = this;
//         vm.account = null;
//         vm.isAuthenticated = null;
//         vm.login = LoginService.open;
//         vm.register = register;
//         vm.project = projectInfo;
//
//         if (vm.project.caftype === 'FILMCAF') {
//             vm.project.caftype = 'Film'
//         }
//         if (vm.project.caftype === 'LandExchange') {
//             vm.project.caftype = 'Land'
//         }
//         if (vm.project.caftype === 'Renewable') {
//             vm.project.caftype = 'Renew'
//         }
//
//         $scope.currentstate = $state.current.name;
//         $scope.projectId = $stateParams.projectid;
//
//         $scope.$on('authenticationSuccess', function () {
//             getAccount();
//         });
//
//         getAccount();
//
//         vm.openEntityLocker = function () {
//
//             // 1️⃣ Hit backend API
//             $http.get('/authorisation-request')
//                 .then(function (response) {
//                     console.log('Authorization request API hit successfully');
//                 })
//                 .catch(function (error) {
//                     console.error('Authorization API error', error);
//                 });
//
//             // 2️⃣ Open DigiLocker link
//             $window.open(
//                 'https://entityaccounts.dl6.in/signin/smart_v2/772185487842322d40ff12f7b2c693aea742a3f66eb38031972b3022cd94a2e4--en',
//                 '_self'   // use '_blank' if you want new tab
//             );
//         };
//
//         function getAccount() {
//             Principal.identity().then(function (account) {
//                 vm.account = account;
//                 vm.isAuthenticated = Principal.isAuthenticated;
//             });
//         }
//
//
//         function register() {
//             $state.go('register');
//         }
//
//         vm.view_form = function () {
//             if (projectInfo.caftype === 'New') {
//                 $state.go('ProjectCompleteDetailNew', {id: $scope.projectId}, {reload: true});
//             } else if (projectInfo.caftype === 'Shop') {
//                 $state.go('ProjectCompleteDetailShop', {id: $scope.projectId}, {reload: true});
//             } else if (projectInfo.caftype === 'Excise') {
//                 $state.go('ProjectCompleteDetailExcise', {id: $scope.projectId}, {reload: true});
//             } else if (projectInfo.caftype === 'Renew') {
//                 $state.go('ProjectCompleteDetailRenewable', {id: $scope.projectId}, {reload: true});
//             } else if (projectInfo.caftype === 'LandRequirement' || projectInfo.caftype === 'Land') {
//                 $state.go('ProjectCompleteDetailLandRequirement', {id: $scope.projectId}, {reload: true});
//             } else if (projectInfo.caftype === 'Tower' || projectInfo.caftype === 'ROW') {
//                 $state.go('ProjectCompleteDetailTower', {id: $scope.projectId}, {reload: true});
//             } else if (projectInfo.caftype === 'Film') {
//                 $state.go('ProjectCompleteDetailFilm', {id: $scope.projectId}, {reload: true});
//             } else {
//                 alert("unexpected error occured");
//             }
//         }
//     }
//
// })();
//

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('projectdetailjistController', [
            '$stateParams',
            '$scope',
            'Principal',
            'LoginService',
            '$state',
            'projectInfo',
            '$http',
            '$window',
            function (
                $stateParams,
                $scope,
                Principal,
                LoginService,
                $state,
                projectInfo,
                $http,
                $window
            ) {

                console.log('projectdetailjistController LOADED');

                var vm = this;
                vm.account = null;
                vm.isAuthenticated = null;
                vm.login = LoginService.open;
                vm.register = register;
                vm.project = projectInfo;

                // ✅ CAF TYPE NORMALIZATION
                if (vm.project.caftype === 'FILMCAF') {
                    vm.project.caftype = 'Film';
                }
                if (vm.project.caftype === 'LandExchange') {
                    vm.project.caftype = 'Land';
                }
                if (vm.project.caftype === 'Renewable') {
                    vm.project.caftype = 'Renew';
                }

                $scope.currentstate = $state.current.name;
                $scope.projectId = $stateParams.projectid;

                $scope.$on('authenticationSuccess', function () {
                    getAccount();
                });

                getAccount();

                // ✅ ENTITY LOCKER BUTTON HANDLER
                // vm.openEntityLocker = function () {
                //       alert("hello 1");
                //
                //     $http.get('/api/entity-locker/authorisation-request')
                //         .then(function (response) {
                //
                //             var authorizeUrl = response.data;
                //             alert("hello");
                //             alert(authorizeUrl);
                //
                //             // 2️⃣ Redirect browser (THIS IS KEY)
                //             $window.location.href = authorizeUrl;
                //
                //         })
                //         .catch(function (error) {
                //             console.error('Authorization URL error', error);
                //         });
                //
                //
                //     // // 2️⃣ Redirect to DigiLocker Entity login
                //     // $window.location.href =
                //     //     'https://entityaccounts.dl6.in/signin/smart_v2/772185487842322d40ff12f7b2c693aea742a3f66eb38031972b3022cd94a2e4--en';
                // };


                //
                // vm.openEntityLocker = function () {
                //     alert("hello 1");
                //
                //     // $http.get('/api/entity-locker/authorisation-request')
                //     //     .then(function (response) {
                //     //         alert("hello 2");
                //     //         console.log("AUTH URL:", response.data);
                //     //         $window.location.href = response.data;
                //     //     })
                //     //     .catch(function (error) {
                //     //         alert("ERROR");
                //     //         console.error("Authorization API error:", error);
                //     //     });
                //
                //     $http.get('/api/entity-locker/authorisation-request', {
                //         responseType: 'text'
                //     })
                //         .then(function (response) {
                //             console.log("AUTH URL:", response.data);
                //             $window.location.href = response.data;
                //         })
                //         .catch(function (error) {
                //             console.error("Authorization API error:", error);
                //         });
                //
                // };


                // ✅ ACCOUNT FETCH
                function getAccount() {
                    Principal.identity().then(function (account) {
                        vm.account = account;
                        vm.isAuthenticated = Principal.isAuthenticated;
                    });
                }

                // ✅ REGISTER
                function register() {
                    $state.go('register');
                }

                // ✅ VIEW FORM NAVIGATION (UNCHANGED)
                vm.view_form = function () {
                    if (projectInfo.caftype === 'New') {
                        $state.go('ProjectCompleteDetailNew', { id: $scope.projectId }, { reload: true });
                    } else if (projectInfo.caftype === 'Shop') {
                        $state.go('ProjectCompleteDetailShop', { id: $scope.projectId }, { reload: true });
                    } else if (projectInfo.caftype === 'Excise') {
                        $state.go('ProjectCompleteDetailExcise', { id: $scope.projectId }, { reload: true });
                    } else if (projectInfo.caftype === 'Renew') {
                        $state.go('ProjectCompleteDetailRenewable', { id: $scope.projectId }, { reload: true });
                    } else if (projectInfo.caftype === 'LandRequirement' || projectInfo.caftype === 'Land') {
                        $state.go('ProjectCompleteDetailLandRequirement', { id: $scope.projectId }, { reload: true });
                    } else if (projectInfo.caftype === 'Tower' || projectInfo.caftype === 'ROW') {
                        $state.go('ProjectCompleteDetailTower', { id: $scope.projectId }, { reload: true });
                    } else if (projectInfo.caftype === 'Film') {
                        $state.go('ProjectCompleteDetailFilm', { id: $scope.projectId }, { reload: true });
                    } else {
                        alert("Unexpected error occurred");
                    }
                };

            }
        ]);
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NoInfoController', NoInfoController);

    NoInfoController.$inject = ['$scope', '$stateParams','$state','$filter'];

    function NoInfoController ($scope, $stateParams, $state, $filter) {
        var vm = this;
        vm.projectid = $stateParams.projectid;
        vm.district = $stateParams.district;
        vm.NOInfo = [
              {
                deptName:"LABOUR DEPARTMENT - LABOUR WING",
                name :"Ms. Suman Kundu, Addl. Labour Commissioner",
                phoneNumber : '-',
                landlineNumber: '2587101-105'
            },
            {
                deptName:"LABOUR DEPARTMENT - FACTORY WING",
                name :"Sh. Sunil Kumar,Dy. Director",
                phoneNumber : '9896677104',
                landlineNumber: '2587101-105'
            },
            {
                deptName:"LABOUR DEPARTMENT - FACTORY WING",
                name :"Sh. Dharmender Singh, Dy. Director (Industrial safety and Health) ",
                phoneNumber : '2587101-105',
                landlineNumber: '2587101-105'
            },
            {
                deptName:"Town & Country Planning",
                name :"Sh. Hitesh Sharma, DTP",
                phoneNumber : '9417463002',
                landlineNumber: '2587101-105'
            },
            {
                deptName:"HSPCB (Haryana State Pollution Control Board)",
                name :"Sh. Bhupender Rinwa",
                landlineNumber : '01722587101-05'
            },
            {
                deptName:"HSIIDC",
                name :"Sh. Mahavir Singh, G.M.",
                phoneNumber : '9814112596',
                landlineNumber: '2587101-105'
            },
            {
                deptName:"HSIIDC",
                name :"Ms. Mamta Joshi, DGM",
                phoneNumber : '8558829220',
                landlineNumber: '2587101-105'
            },
            {
                deptName:"Excise & Taxation Department",
                name :"Sh. N.K. Lamba, Dy. ETC",
                phoneNumber : '9991640966',
                landlineNumber: '2587101-105'
            },
            {
                deptName:"Forest Department",
                name :"Ajay Pal, DFO",
                phoneNumber : '9416745128',
                landlineNumber: '2587101-105'
            },
            {
                deptName:"UHBVN/ DHBVN",
                name :"Smt. Manju Bala, SE, UHBVN",
                phoneNumber : '1800-180-2132'
            },
            {
                deptName:"Revenue Department",
                name :"Sh. Rajesh Khyalia, DRO",
                phoneNumber : '9996920567',
                landlineNumber: '2587101-105'
            },

            {
                deptName:"Urban Locan Bodies",
                name :"Sh. Chirag Singh, Assistant Town Planner",
                phoneNumber : '9468411510'
            },
            {
                deptName:"Environment Department",
                name :"Dr. Radhey Shyam, Scientist-1",
                phoneNumber : '9417153589'
            },
            {
                deptName:"Food & Drug Administration (FDA)",
                name :"Sh. N.K. Ahooja, State Drug Controller",
                phoneNumber : '9878748899'
            },
            {
                deptName:"Mines & Geology",
                name :"Sh. R. K. Sharma, Mining Engineer",
                phoneNumber : '9416906565'
            },
            {
                deptName:"Public Health",
                name :"Sh. Amardeep Dahiya, Executive Engineer",
                phoneNumber : '8607519207'
            },
            {
                deptName:"Agriculture Department",
                name :"Sh. Parveen Kumar, Deputy Director (Plant Protection)",
                phoneNumber : '9896245943'
            },
            {
                deptName:"HAREDA",
                name :"Sh. R.S. Poonia, Project Officer ",
                phoneNumber : '9417350243'
            },
            {
                deptName:"Food Civil Supplies & Consumer Affairs ",
                name :"Dr. Ghanshyam Singh, Deputy Director",
                phoneNumber : '9416076423,9416915848'
            },
            {
                deptName:"Chief Electrical Inspector",
                name :"Sh. Hoshiar Singh, AE",
                phoneNumber : '9468178404'
            },
            {
                deptName:"PW(B&R) Department",
                name :"Sh. Romit Chug, XEN",
                phoneNumber : '9215928090, 7696921142'
            },
            {
                deptName:"DEPARTMENT OF AYUSH",
                name :"Dr. Satish Kathkar, District Ayurvedic Officer",
                phoneNumber : '9416070800'
            },
            {
                deptName:"Irrigation Department",
                name :"Sh. Sanjay Rahar, SE Project",
                phoneNumber : '9416322922'
            },
            {
                deptName:"HARYANA URBAN DEVELOPMENT AUTHORITY (HUDA)",
                name :"Sh. Satyavir Sabharwal, STP",
                phoneNumber : '9992211555'
            },
            {
                deptName:"Industries Department",
                name :"Sh. Sanjay Sharma, Deputy CIB",
                phoneNumber : '9891221818'
            },
            {
                deptName:"ULB-Fire Service-cum",
                name :"Sh. Gulshan Kalra, Assistant Divisional Fire Officer",
                phoneNumber : '7015091697'
            },
            {
                deptName:"DIPR",
                name :"Aman Kumar",
                phoneNumber : '9250765615',
                landlineNumber: '0172-2722018'
            }
        ];

        vm.findNO = function (value) {
            vm.NOContact = $filter('filter')(vm.NOInfo,{deptName : value});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafSummaryController', CafSummaryController);
    CafSummaryController.$inject = ['$window','$scope', 'Principal','$filter', 'LoginService', '$state', '$stateParams','Projectlist','downloadService', 'Projectlog', 'Projectdetailupdated', 'Projectlogupdated', 'Project', 'ConstructionPermitApprovalSteps', 'ConstructionPermitApproval', 'AddCAF', 'projectLog', 'ProjectLogNewCaf', 'projectLogNewCaf'];

    function CafSummaryController ($window,$scope, Principal,$filter, LoginService, $state, $stateParams,Projectlist,downloadService, Projectlog, Projectdetailupdated, Projectlogupdated, Project, ConstructionPermitApprovalSteps, ConstructionPermitApproval, AddCAF, projectLog, ProjectLogNewCaf, projectLogNewCaf) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.projectdetail = null;
        vm.existingproject = false;
        vm.login = LoginService.open;
        vm.register = register;
        vm.edit_form = edit_form;
        vm.edit_formForUser=edit_formForUser;
        vm.editInvestment = editInvestment;
        vm.constructionPermitData= {};
        vm.project = [];
        vm.projectlog = projectLog;
        vm.projectLogNewCaf = projectLogNewCaf;
        vm.REDetails = null;
//        vm.total_project_cost = 0;
//        vm.project.totalpurposedemployment=0;
        vm.deactivateCAF = deactivateCAF;
        vm.activateCAF = activateCAF;
        vm.REInfo = [
            {
                REName:"Sahil Chaudhary",
                RMname :"Mamta Joshi",
                REphoneNumber : '9988227626',
                EmailId:'sahiltoor227@gmail.com'
            },
            {
                REName:"Sahil Chaudhary",
                RMname :"Kapil kumar mittAL",
                REphoneNumber : '9988227626',
                EmailId:'sahiltoor227@gmail.com'
            },
            {
                REName:"Sahil Chaudhary",
                RMname :"Kshitij",
                REphoneNumber : '9988227626',
                EmailId:'sahiltoor227@gmail.com'
            },
            {
                REName:"Aditi Sharma",
                RMname :"Ashwani Gupta",
                REphoneNumber : '8284942555',
                EmailId:'aditish135@gmail.com'
            },
            {
                REName:"Aditi Sharma",
                RMname :"S.N Singh",
                REphoneNumber : '8284942555',
                EmailId:'aditish135@gmail.com'
            },
            {
                REName:"Aditi Sharma",
                RMname :"J.D Kapoor",
                REphoneNumber : '8284942555',
                EmailId:'aditish135@gmail.com'
            },
            {
                REName:"Aditi Sharma",
                RMname :"Rajneesh Mittal",
                REphoneNumber : '8284942555',
                EmailId:'aditish135@gmail.com'
            },
            {
                REName:"Aditi Sharma",
                RMname :"Sanjay Rohilla",
                REphoneNumber : '8284942555',
                EmailId:'aditish135@gmail.com'
            },
            {
                REName:"Aditi Sharma",
                RMname :"Digvijay Singh",
                REphoneNumber : '8284942555',
                EmailId:'aditish135@gmail.com'
            },
            {
                REName:"Shilpa Pandey ",
                RMname :"Sunil Chopra",
                REphoneNumber : '9041198392',
                EmailId:'shiplahepc@gmail.com'
            },
            {
                REName:"Harjot Singh Reen",
                RMname :"Ajay Bansal",
                REphoneNumber : '9876914995',
                EmailId:'harjot.hsiidc@gmail.com'
            },
            {
                REName:"Harjot Singh Reen",
                RMname :"Aseem Tandon",
                REphoneNumber : '9876914995',
                EmailId:'harjot.hsiidc@gmail.com'
            },
            {
                REName:"Navjot Vashisht",
                RMname :"Satya Nairan",
                REphoneNumber : '7347003604',
                EmailId:'navjotvashisht.hsiidc@gmail.com'
            },
            {
                REName:"Navjot Vashisht",
                RMname :"Sanjay Kumar",
                REphoneNumber : '7347003604',
                EmailId:'navjotvashisht.hsiidc@gmail.com'
            },

            {
                REName:"Hitesh sharma",
                RMname :"Sanjay Mittal",
                REphoneNumber : '7837922459',
                EmailId:'hiteshsharma.hsiidc@gmail.com'
            },
            {
                REName:"Hitesh sharma",
                RMname :"Yogesh Kaushik",
                REphoneNumber : '7837922459',
                EmailId:'hiteshsharma.hsiidc@gmail.com'
            },
            {
                REName:"Komal sharma",
                RMname :"Gulshan Kumar",
                REphoneNumber : '9717802530',
                EmailId:'komalhsiidc@gmail.com'
            },
            {
                REName:"Vandna",
                RMname :"Manoj Pal",
                REphoneNumber : '7347003660',
                EmailId:'vandnabist.hsiidc@gmail.com'
            },
            {
                REName:"Salivia Rathore",
                RMname :"Bharat Bhushan",
                REphoneNumber : '8427795846',
                EmailId:'salivia.hsiidc@gmail.com'
            },
            {
                REName:"Salivia Rathore",
                RMname :"Priyanka Rani",
                REphoneNumber : '8427795846',
                EmailId:'salivia.hsiidc@gmail.com'
            },
            {
                REName:"Amit Gautam",
                RMname :"Dheeraj Joshi",
                REphoneNumber : '9355573939',
                EmailId:''
            },
            {
                REName:"Amit Gautam",
                RMname :"Surinder Singh",
                REphoneNumber : '9355573939',
                EmailId:''
            },
            {
                REName:"Prinkle",
                RMname :"O.D Vashisht",
                REphoneNumber : '9996608866',
                EmailId:''
            },
            {
                REName:"Prinkle",
                RMname :"Vijay Godara",
                REphoneNumber : '9996608866',
                EmailId:''
            },

            {
                REName:"Pallavi Batra",
                RMname :"Aninderbir Kaur",
                REphoneNumber : '8950477447',
                EmailId:''
            },
            {
                REName:"Pallavi Batra",
                RMname :"Ravish Jani",
                REphoneNumber : '8950477447',
                EmailId:''
            },
            {
                REName:"Manpreet",
                RMname :"R C Dhara",
                REphoneNumber : '9646336699',
                EmailId:'manpreetsingh.hsiidc@gmail.com'
            },
            {
                REName:"Manpreet",
                RMname :"Mahavir Singh",
                REphoneNumber : '9646336699',
                EmailId:'manpreetsingh.hsiidc@gmail.com'
            },
            {
                REName:"Manpreet",
                RMname :"Rajiv Sharma",
                REphoneNumber : '9646336699',
                EmailId:'manpreetsingh.hsiidc@gmail.com'
            },
            {
                REName:"Aditi Sharma",
                RMname :"Jaideep Kapoor",
                REphoneNumber : '8284942555',
                EmailId:'aditish135@gmail.com'
            },
            {
                REName:"Aditi Sharma",
                RMname :"S N Singh",
                REphoneNumber : '8284942555',
                EmailId:'aditish135@gmail.com'
            },
            {
                REName:"Shilpa Pandey",
                RMname :"Deepak ",
                REphoneNumber : '7888997391',
                EmailId:'Shilpahepc@gmail.com'
            },
            {
                REName:"Shilpa Pandey",
                RMname :"DIC Faridabad",
                REphoneNumber : '7888997391',
                EmailId:'Shilpahepc@gmail.com'
            },
            {
                REName:"Shilpa Pandey",
                RMname :"DIC Palwal",
                REphoneNumber : '7888997391',
                EmailId:'Shilpahepc@gmail.com'
            },
            {
                REName:"Ashish Bansal",
                RMname :"Harinder Pal Singh",
                REphoneNumber : '9416073624',
                EmailId:'ashishbansal020@gmail.com'
            },
            {
                REName:"Ashish Bansal",
                RMname :"Anoop Kumar",
                REphoneNumber : '9416073624',
                EmailId:'ashishbansal020@gmail.com'
            },
            {
                REName:"Shilpa Pandey",
                RMname :"Kapil Mittal",
                REphoneNumber : '7888997391',
                EmailId:'Shilpahepc@gmail.com'
            }
        ];

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });
        getAccount();

        getProjectDetail();

        vm.proposedEmployment = function(domicile){
                    if(domicile === 'haryana'){
                        vm.project.nonharyanadomicile = vm.project.totalpurposedemployment - vm.project.haryanadomicile;
                        if(vm.project.nonharyanadomicile < 0){
                            vm.project.haryanadomicile = 0;
                            vm.project.nonharyanadomicile = 0;
                            alert("Your Value Is Not Valid");
                        }
                    }else{
                        vm.project.haryanadomicile = vm.project.totalpurposedemployment - vm.project.nonharyanadomicile;
                        if(vm.project.haryanadomicile < 0){
                            vm.project.nonharyanadomicile = 0;
                            vm.project.haryanadomicile = 0;
                            alert("Your Value Is Not Valid");
                        }
                    }
                };

        function getProjectDetail(){
            vm.projectdetail = Project.get({id : $stateParams.projectid});

            Projectlist.projectList.query({id : $stateParams.projectid},  function (result) {
                vm.investorsummarydetails = result;

                 if(vm.investorsummarydetails.caftype=== 'New'){
                    if(vm.investorsummarydetails.rm !==''){
                        var value = vm.investorsummarydetails.rm.split(',');
                        vm.REDetails = $filter('filter')(vm.REInfo,{RMname : value[0]},true);
                    }
                }

                if(vm.investorsummarydetails.caftype === 'FILMCAF'){
                    vm.investorsummarydetails.caftype = 'Film'
                }
                if(vm.investorsummarydetails.caftype === 'LandExchange'){
                    vm.investorsummarydetails.caftype = 'Land'
                }
                if(vm.investorsummarydetails.caftype === 'Renewable'){
                    vm.investorsummarydetails.caftype = 'Renew'
                }
            });
        }

        function deactivateCAF() {
            vm.projectdetail.isdeactivated =true;
            vm.projectdetail.deactivateddate=new Date();
            Projectdetailupdated.update(vm.projectdetail, onDeactivateSaveSuccess, onDeactivateSaveError);
        }

        function activateCAF() {
            vm.projectdetail.isdeactivated =false;
            vm.projectdetail.deactivateddate=new Date();
            Projectdetailupdated.update(vm.projectdetail, onActivateSaveSuccess, onActivateSaveError);
        }

        function onDeactivateSaveSuccess (result) {
            if(vm.projectdetail.caftype!=='New'){
                $scope.$emit('investhryApp:projectUpdate', result);
                vm.projectlog.projectid = $stateParams.projectid;
                vm.projectlog.actiontaken = "De-Activated the CAF.";
                vm.projectlog.actiontype = "CAF Deactivated";
                Projectlogupdated.save(vm.projectlog, onProjectLogSaveSuccess, onProjectLogSaveError);
            }
            if(vm.projectdetail.caftype==='New'){
                vm.projectLogNewCaf.projectId = $stateParams.projectid;
                vm.projectLogNewCaf.actionTaken = "De-Activated the CAF.";
                vm.projectLogNewCaf.actionType = "CAF Deactivated";
                ProjectLogNewCaf.save(vm.projectLogNewCaf, onProjectLogSaveSuccess, onProjectLogSaveError);
            }
            $window.location.reload();
        }

        function onDeactivateSaveError () {
            vm.isSaving = false;
        }
        function onActivateSaveSuccess (result) {
            if(vm.projectdetail.caftype!=='New'){
                $scope.$emit('investhryApp:projectUpdate', result);
                vm.projectlog.projectid = $stateParams.projectid;
                vm.projectlog.actiontaken = "Re-activated the CAF.";
                vm.projectlog.actiontype = "CAF Re-Activated";
                Projectlogupdated.save(vm.projectlog, onProjectLogSaveSuccess, onProjectLogSaveError);
            }
            if(vm.projectdetail.caftype==='New'){
                vm.projectLogNewCaf.projectId = $stateParams.projectid;
                vm.projectLogNewCaf.actionTaken = "Re-activated the CAF.";
                vm.projectLogNewCaf.actionType = "CAF Re-Activated";
                ProjectLogNewCaf.save(vm.projectLogNewCaf, onProjectLogSaveSuccess, onProjectLogSaveError);
            }
            $window.location.reload();
        }

        function onActivateSaveError () {
            vm.isSaving = false;
        }

        function onProjectLogSaveSuccess(result)
        {

        }
        function onProjectLogSaveError()
        {

        }
        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        function downloadFile(filename) {
            downloadService.download(filename)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }

        function edit_form(){
         if(vm.projectdetail.caftype=='New'){
          $state.go('editnewCAF',{id:vm.investorsummarydetails.projectid});
         }
         else if(vm.projectdetail.caftype=='Shop'){
          $state.go('editshopCAF',{id:vm.investorsummarydetails.projectid});
         }
         else if(vm.projectdetail.caftype=='Renewable'){
          $state.go('editrenewableCAF',{id:vm.investorsummarydetails.projectid});
         }
         else if(vm.projectdetail.caftype=='LandRequirement'){
          $state.go('editlandreqCAF',{id:vm.investorsummarydetails.projectid});
         }
         else if(vm.projectdetail.caftype=='Tower'){
          $state.go('editTowerCAF',{id:vm.investorsummarydetails.projectid});
         }
         else if(vm.projectdetail.caftype=='FILMCAF'){
          $state.go('editFilmCAF',{id:vm.investorsummarydetails.projectid});
         }
         else if(vm.projectdetail.caftype=='Excise'){
             $state.go('editExciseCAF',{id:vm.investorsummarydetails.projectid});
         }
         else{
          alert("unexpected error occured");
         }
        }

        //
        // function edit_formForUser(){
        //         $state.go('editCafForUser',{id:vm.investorsummarydetails.projectid},{cafType:vm.projectdetail.caftype});
        //
        //
        // }


        function edit_formForUser() {
            $state.go('editCafForUser', {
                id: vm.investorsummarydetails.projectid,
                cafType: vm.projectdetail.caftype
            });
        }

        vm.createConstructionPermit=function () {
            ConstructionPermitApproval.query({projectId: $stateParams.projectid},function (result) {
                // console.log(result.projectId !== $stateParams.projectid);
                vm.result = result;
                if(result.projectId !== $stateParams.projectid){
                    // console.log("if");
                    vm.constructionPermitData.projectId=$stateParams.projectid;
                    ConstructionPermitApprovalSteps.save(vm.constructionPermitData,onCPsaveSuccess);
                }
                else {
                    // console.log("else");
                    $state.go('constructionpermit',{id: $stateParams.projectid});
                }
            });
        };

        function onCPsaveSuccess(result) {
            $state.go('constructionpermit',{id: $stateParams.projectid});
        }

        function editInvestment() {
            Project.get({id: vm.investorsummarydetails.projectid},function (result) {
                vm.project = result;
                console.log(vm.project.investmentType);
                if(vm.project.investmentType == 'Existing Project (not a new investment in state)' && vm.project.caftype=='New'){
                    vm.existingproject=true;
                    console.log("existing project");
                }

                vm.project_cost_in_crore = calculateCostInCrore(vm.project);
                vm.project_cost_in_lacs = calculateCostInLacs(vm.project);
                vm.project_cost_in_thousands = calculateCostInThousands(vm.project);
            });
        }

        vm.changeInCost = function(){
            var projectCostInCrore=vm.project_cost_in_crore || '00';
            var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
            var projectCostInThousands=vm.project_cost_in_thousands||'00';
            if(vm.project_cost_in_lacs<10){
                projectCostInLacs='0'+vm.project_cost_in_lacs;
            }
            if(vm.project_cost_in_thousands<10){
                projectCostInThousands='0'+vm.project_cost_in_thousands;
            }
            return vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
        };

        function calculateCostInCrore(project){
            return parseInt(project.total_project_cost.toString().split('.')[0]);
        }

        function calculateCostInLacs(project){
            if(project.total_project_cost.toString().indexOf('.') !== -1){
                return parseInt(project.total_project_cost.toString().split('.')[1].substring(0,2));
            }
            return 0;
        }

        function calculateCostInThousands(project){
            if(project.total_project_cost.toString().indexOf('.') !== -1){
                return parseInt(project.total_project_cost.toString().split('.')[1].substring(2,4));
            }
            return 0;
        }

        vm.changeInvestment = function (project) {
        if(vm.project.totalpurposedemployment > 0 && (vm.project.haryanadomicile + vm.project.nonharyanadomicile != vm.project.totalpurposedemployment)){
                    alert("Total of employment with Haryana Domicile and Non-Haryana Domicile must be equal to Total Proposed Employment!!");
                    vm.project.haryanadomicile = 0;
                    vm.project.nonharyanadomicile = 0;
                    return;
               }
               if(vm.project.totalpurposedemployment === 0){
                    vm.project.haryanadomicile = 0;
                    vm.project.nonharyanadomicile = 0;
               }
           project.totalpurposedemployment = vm.project.totalpurposedemployment;
           project.haryanadomicile = vm.project.haryanadomicile;
           project.nonharyanadomicile = vm.project.nonharyanadomicile;
           if(vm.total_project_cost==null){
            vm.total_project_cost = vm.project.total_project_cost;
           }
           project.total_project_cost = vm.total_project_cost;
           AddCAF.update(project,onUpdateProjectSuccess,onUpdateProjectError);
        };

        function onUpdateProjectSuccess(result) {
            $('#editCAFmodal').modal('hide');
        }

        function onUpdateProjectError() {
            alert("Unexpected Error Occurred! ");
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ProjectCompleteDetailNew', {
            parent: 'projectdetailjist',
            url: '/ProjectCompleteDetailNew/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT', 'ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN','ROLE_CAF_STATUS_OFFICER','ROLE_STATE_NODAL_OFFICER']
            },
            views: {
                'sideView@projectdetailjist': {
                    templateUrl: 'app/ProjectCompleteDetail/ProjectCompleteDetailNew.html',
                    controller: 'ProjectCompleteDetailController',
                    controllerAs: 'vm'
                }
            },
              resolve: {
                  translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                      $translatePartialLoader.addPart('home');
                      return $translate.refresh();
                  }],
                  entity: ['$stateParams', 'Projectcompletedetail', function($stateParams,Projectcompletedetail) {
                          return Projectcompletedetail.get({id : $stateParams.id}).$promise;
                  }],
                  cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                          return CAFAttachment.query({id : $stateParams.id,projectid : $stateParams.id}).$promise;
                  }]
              }
        })
        .state('ProjectCompleteDetailShop', {
            parent: 'projectdetailjist',
            url: '/ProjectCompleteDetailShop/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN']
            },
            views: {
                'sideView@projectdetailjist': {
                    templateUrl: 'app/ProjectCompleteDetail/ProjectCompleteDetailShop.html',
                    controller: 'ProjectCompleteDetailController',
                    controllerAs: 'vm'
                }
            },
              resolve: {
                  translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                      $translatePartialLoader.addPart('home');
                      return $translate.refresh();
                  }],
                  entity: ['$stateParams', 'Projectcompletedetail', function($stateParams,Projectcompletedetail) {
                          return Projectcompletedetail.get({id : $stateParams.id}).$promise;
                  }],
                  cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                          return CAFAttachment.query({id : $stateParams.id,projectid : $stateParams.id}).$promise;
                  }]
              }
        })
            .state('ProjectCompleteDetailExcise', {
                parent: 'projectdetailjist',
                url: '/ProjectCompleteDetailExcise/{id}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN']
                },
                views: {
                    'sideView@projectdetailjist': {
                        templateUrl: 'app/ProjectCompleteDetail/ProjectCompleteDetailExcise.html',
                        controller: 'ProjectCompleteDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Projectcompletedetail', function($stateParams,Projectcompletedetail) {
                        return Projectcompletedetail.get({id : $stateParams.id}).$promise;
                    }],
                    cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                        return CAFAttachment.query({id : $stateParams.id,projectid : $stateParams.id}).$promise;
                    }]
                }
            })
        .state('ProjectCompleteDetailRenewable', {
         parent: 'projectdetailjist',
         url: '/ProjectCompleteDetailRenewable/{id}',
         data: {
             authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN']
         },
         views: {
             'sideView@projectdetailjist': {
                 templateUrl: 'app/ProjectCompleteDetail/ProjectCompleteDetailRenewable.html',
                 controller: 'ProjectCompleteDetailController',
                 controllerAs: 'vm'
             }
         },
           resolve: {
               translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                   $translatePartialLoader.addPart('home');
                   return $translate.refresh();
               }],
               entity: ['$stateParams', 'Projectcompletedetail', function($stateParams,Projectcompletedetail) {
                       return Projectcompletedetail.get({id : $stateParams.id}).$promise;
               }],
               cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                       return CAFAttachment.query({id : $stateParams.id,projectid : $stateParams.id}).$promise;
               }]
           }
     })
        .state('ProjectCompleteDetailLandRequirement', {
          parent: 'projectdetailjist',
          url: '/ProjectCompleteDetailLandRequirement/{id}',
          data: {
              authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN']
          },
          views: {
              'sideView@projectdetailjist': {
                  templateUrl: 'app/ProjectCompleteDetail/ProjectCompleteDetailLandRequirement.html',
                  controller: 'ProjectCompleteDetailController',
                  controllerAs: 'vm'
              }
          },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectcompletedetail', function($stateParams,Projectcompletedetail) {
                        return Projectcompletedetail.get({id : $stateParams.id}).$promise;
                }],
                cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                        return CAFAttachment.query({id : $stateParams.id,projectid : $stateParams.id}).$promise;
                }]
            }
      })
        .state('ProjectCompleteDetailTower', {
           parent: 'projectdetailjist',
           url: '/ProjectCompleteDetailMix/{id}',
           data: {
               authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN', 'ROLE_DEPT_CHANGE']
           },
           views: {
               'sideView@projectdetailjist': {
                   templateUrl: 'app/ProjectCompleteDetail/ProjectCompleteDetailTower.html',
                   controller: 'ProjectCompleteDetailController',
                   controllerAs: 'vm'
               }
           },
             resolve: {
                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                     $translatePartialLoader.addPart('home');
                     return $translate.refresh();
                 }],
                 entity: ['$stateParams', 'Projectcompletedetail', function($stateParams,Projectcompletedetail) {
                         return Projectcompletedetail.get({id : $stateParams.id}).$promise;
                 }],
                 cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                         return CAFAttachment.query({id : $stateParams.id,projectid : $stateParams.id}).$promise;
                 }]
             }
       })
       .state('ProjectCompleteDetailFilm', {
          parent: 'projectdetailjist',
          url: '/ProjectCompleteDetailFilm/{id}',
          data: {
              authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT','ROLE_L2_IT_MANAGER','ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_L2_INCENTIVES','ROLE_TICKET_NODAL_OFFICER','ROLE_TICKET_ADMIN']
          },
          views: {
              'sideView@projectdetailjist': {
                  templateUrl: 'app/ProjectCompleteDetail/ProjectCompleteDetailFilm.html',
                  controller: 'ProjectCompleteDetailController',
                  controllerAs: 'vm'
              }
          },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectcompletedetail', function($stateParams,Projectcompletedetail) {
                        return Projectcompletedetail.get({id : $stateParams.id}).$promise;
                }],
                cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                        return CAFAttachment.query({id : $stateParams.id,projectid : $stateParams.id}).$promise;
                }]
            }
      });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectCompleteDetailController', ProjectCompleteDetailController);

    ProjectCompleteDetailController.$inject = ['$scope', 'Principal', 'LoginService', '$state','entity','cafAttachments','Projectcompletedetail','Projectcompletedetaildata', 'GetImageForView','downloadService', 'District'];

    function ProjectCompleteDetailController ($scope, Principal, LoginService, $state, entity, cafAttachments, Projectcompletedetail,Projectcompletedetaildata, GetImageForView, downloadService, District) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.CompleteProjectDetail=entity;
        vm.cafAttachments=cafAttachments;
        vm.investorphoto=null;
        vm.investorsign=null;
        vm.downloadFile=downloadFile;

    
        for(var cafAttachmentscounter=0;cafAttachmentscounter<vm.cafAttachments.length;cafAttachmentscounter++)
        {
            if(vm.cafAttachments[cafAttachmentscounter].docName=="Applicant Photo")
            {
                var filename=vm.cafAttachments[cafAttachmentscounter].fileName;
                vm.investorphoto=GetImageForView.getImageSource(filename);
            }
            if(vm.cafAttachments[cafAttachmentscounter].docName=="Signature")
            {
                var filename=vm.cafAttachments[cafAttachmentscounter].fileName;
                vm.investorsign=GetImageForView.getImageSource(filename);
            }
        }

        function downloadFile(filename)
        {
            downloadService.download(filename)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }

        vm.project = vm.CompleteProjectDetail.projectDTO;
//        vm.investor=vm.CompleteProjectDetail.investorDTO;
//        vm.companydetail=vm.CompleteProjectDetail.companydetailDTO;
//        vm.projectdetail=vm.CompleteProjectDetail.projectdetailDTO;
//        vm.projectsitedetail=vm.CompleteProjectDetail.projectsitedetailDTO;
//        vm.project_finance_investment=vm.CompleteProjectDetail.project_finance_investmentDTO;
//        vm.manufacturing_detail=vm.CompleteProjectDetail.manufacturingdetailDTO;
//        vm.term_declaration_accept=vm.CompleteProjectDetail.term_declaration_acceptDTO;
//        vm.electricrequirement=vm.CompleteProjectDetail.electricrequirementDTO;
//        vm.projectcombinecodes=vm.CompleteProjectDetail.projectdetailcombinecodesDTO;
//        vm.environmentimpactdetail=vm.CompleteProjectDetail.environment_impactdetailDTO;
        vm.project_phase=vm.CompleteProjectDetail.project_phaseDTOList;
        vm.projectrawmaterial=vm.CompleteProjectDetail.projectrawmaterialDTOList;
        vm.projectproduct=vm.CompleteProjectDetail.projectproductDTOList;
        vm.projectprocessflowsteps=vm.CompleteProjectDetail.projectprocessflowstepsDTOList;
        vm.emissiondetail=vm.CompleteProjectDetail.emissiondetailDTOList;
        vm.wastewaterdetail=vm.CompleteProjectDetail.wastewaterdetailDTOList;

//        if(vm.projectsitedetail.district !== null)
//        {
//             District.query({id:vm.projectsitedetail.district,districtName:vm.projectsitedetail.district},function(result) {
//                 vm.districts = result;
//                 vm.electricrequirement.powercompany = vm.districts[0].powercompany;
//             });
//        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectBankGuaranteeViewController', ProjectBankGuaranteeViewController);

    ProjectBankGuaranteeViewController.$inject = ['projectBankGurantee', '$scope','$stateParams','$state','GetServiceLog','downloadService'];

    function ProjectBankGuaranteeViewController(projectBankGurantee, $scope,$stateParams,$state,GetServiceLog,downloadService) {
        var vm = this;
        vm.downFile= downFile;
        vm.projectserviceid = $stateParams.projectserviceid;
        vm.district = $stateParams.district;
        vm.ServiceLog = null;
        GetServiceLog.query({
            projectid: $stateParams.projectid,
            serviceid: $stateParams.serviceid
        }, function(response) {
            vm.ServiceLog = response;
        }, function(error) {
            console.error("Error fetching service logs", error);
        });

        function downFile(servicelog) {
            vm.reApplyCounter = servicelog.reApplyCounter;
            vm.dwnFile = servicelog.fileName;
            vm.act = servicelog.actionTaken;
            downloadFile();
        }

        function downloadFile()
        {
                downloadHEPC();

        }
        function downloadHEPC() {
            downloadService.download(vm.dwnFile)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }



        projectBankGurantee.getByProjectServiceId({ projectServiceId: vm.projectserviceid }, function(response) {
            vm.projectGuaranteeData = response;
            vm.pbgForm = angular.copy(response); // This will prefill the form fields
        }, function(error) {
            console.error("Error fetching guarantee by service ID", error);
        });

        vm.close = function () {
            $state.go('serviceclearanceaction', {
                // projectid: vm.projectserviceid, // optionally set this
                district: vm.district

            });
        }






    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectBankGuaranteeEditController', ProjectBankGuaranteeEditController);

    ProjectBankGuaranteeEditController.$inject = ['projectBankGurantee', '$scope', '$stateParams', '$state'];

    function ProjectBankGuaranteeEditController(projectBankGurantee, $scope, $stateParams, $state) {
        var vm = this;
        vm.projectserviceid = $stateParams.projectserviceid;
        vm.district = $stateParams.district;

        vm.pbgForm = {};

        // Load existing data
        projectBankGurantee.getByProjectServiceId({ projectServiceId: vm.projectserviceid }, function(response) {
            vm.projectGuaranteeData = response;
            vm.pbgForm = angular.copy(response);
        }, function(error) {
            console.error("Error fetching guarantee by service ID", error);
        });

        // Save logic (POST all in body, no ID in URL)
        vm.updateProjectBankGuarantee = function () {
            if (!vm.projectGuaranteeData.id) {
                console.error("Missing ID for update");
                return;
            }

            projectBankGurantee.update(
                { id: vm.projectGuaranteeData.id },
                vm.projectGuaranteeData,
                function (response) {
                    alert("Updated successfully");
                    // Show success alert or navigate
                    $state.go('serviceclearanceaction', {
                        district: vm.district
                    });
                },
                function (error) {
                    console.error("Update failed:", error);
                    // Show error alert
                }
            );
        };


        vm.close = function() {
            $state.go('serviceclearanceaction', {
                district: vm.district
            });
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('projectBankGurantee', projectBankGurantee);

    projectBankGurantee.$inject = ['$resource'];

    function projectBankGurantee($resource) {
        var resourceUrl = 'api/projectBankGuarantee/:id';

        return $resource(resourceUrl, { id: '@id' }, {
            'query': { method: 'GET', isArray: true },
            'get': {
                method: 'GET',
                transformResponse: function(data) {
                    try {
                        return angular.fromJson(data);
                    } catch (e) {
                        console.warn("Invalid JSON response:", data);
                        return data;
                    }
                }
            },
            'save': { method: 'POST' },

            // ✅ Custom update method pointing to /update endpoint
            'update': {
                method: 'PUT',
                url: 'api/projectBankGuarantee/update'
            },

            'getByProjectServiceId': {
                method: 'GET',
                url: 'api/projectBankGuarantee/by-project-service-id/:projectServiceId',
                params: { projectServiceId: '@projectServiceId' },
                transformResponse: function(data) {
                    try {
                        return angular.fromJson(data);
                    } catch (e) {
                        console.warn("Invalid JSON response:", data);
                        return data;
                    }
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectBankGuaranteeController', ProjectBankGuaranteeController);

    ProjectBankGuaranteeController.$inject = ['projectBankGurantee','FileManagement','$scope', '$stateParams', '$state','ProjectServiceLogUpdated','Projectservicedetail','ProjectAttachemnt'];

    function ProjectBankGuaranteeController(projectBankGurantee ,FileManagement ,$scope, $stateParams, $state,ProjectServiceLogUpdated,Projectservicedetail,ProjectAttachemnt) {
        var vm = this;

        // var locals = $state.current.locals.globals;
        // vm.projectServiceLog = locals.projectServiceLog;
        // vm.projectAttachemnt = locals.projectAttachemnt;
        //
        // console.log("Resolved from $state:", vm.projectServiceLog); // ✅ This should print the object from resolve
        //
        // // Example usage:
        // vm.projectServiceLog.projectid = $stateParams.projectid;
        // vm.projectServiceLog.serviceid = $stateParams.serviceid;
        vm.projectserviceid = $stateParams.projectserviceid;
        vm.projectid=$stateParams.projectid;
        vm.serviceid=$stateParams.serviceid;
        var projectAttachmentResultObject=null;



        vm.projectServiceLog = {
            projectid: vm.projectid,
            serviceid: vm.serviceid,
            actionTaken: "Bank Gurantee Logs"
        };

        vm.projectAttachemnt = {
            id: null,
            fileName: '',
            description: "Bank Gurantee Attachment",
            fileExtension:""
        };

        var projectServiceLogid=null;

        $scope.file = {};  // ← Important for file size validation via directive

        vm.pbgForm = {
            pbgNumber: '',
            bankName: '',
            expiryDate: null,
            uploadDocument: '',
            projectServiceId: vm.projectserviceid,
            createdAt: new Date().toISOString()
        };


        vm.save = function() {
            var file = vm.pbgForm.uploadDocument;

            console.log("Upload Document:", vm.pbgForm.uploadDocument);
            if (vm.pbgForm.uploadDocument) {
                assignServiceFeeAftercheck();
            } else {
                alert("No file selected.");
            }

        };

        function assignServiceFeeAftercheck(){
            console.log("projectServiceLog::"+vm.projectServiceLog);
            console.log("Project ID:", vm.projectServiceLog.projectid);
            console.log("Service ID:", vm.projectServiceLog.serviceid);
            console.log("Action Taken:", vm.projectServiceLog.actionTaken);
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }

        function onServiceLogSaveSuccess(result) {
            projectServiceLogid = result.id;

            // Emit the update event
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);

            // Call the API to get the latest projectService before updating it
            Projectservicedetail.get({ id: vm.projectserviceid }).$promise.then(function(response) {
                vm.projectService = response; // assign fetched data

                // Now safely update with latest data
                vm.projectService.latestComments = vm.projectServiceLog.comments;

                // Optionally update serviceFee or other fields here
                // vm.projectService.serviceFee = vm.projectservicedetail.serviceFee;

                // Call update after fetching
                Projectservicedetail.update(vm.projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
            }).catch(function(error) {
                console.error("Failed to fetch latest projectService:", error);
                alert("Error fetching updated Project Service before update.");
            });
        }

        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.pbgForm.uploadDocument)){
                saveProjectAttachment();
            }
            else
            {
               // $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }

        function saveProjectAttachment()
        {
            var file=vm.pbgForm.uploadDocument;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            //vm.projectAttachemnt.description="Service Assign Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }

        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }

        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.pbgForm.uploadDocument;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.pbgForm.uploadDocument.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;
            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }

        function onUpdateProjectAttachmentSuccess(result)
        {
            vm.pbgForm.uploadDocument=vm.pbgForm.uploadDocument.name;
            projectBankGurantee.save(vm.pbgForm, function(response) {
                // If it's a valid object, assume success
                alert("Form submitted successfully!");
                console.log(response);
                $state.go('serviceclearanceaction', {
                    // projectid: vm.projectserviceid, // optionally set this
                    district: vm.district
                });
            }, function(error) {
                if (error && error.data === "ProjectBankGuarantee already saved for this ProjectServiceId") {
                    alert("Already Exist.");
                } else {
                    alert("Error occurred during submission.");
                }
                console.error(error);
            });
            //$uibModalInstance.close(result);
        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }



    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('assignfeeforbankgurantee', assignfeeforbankgurantee);

    assignfeeforbankgurantee.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService','projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','ProjectServiceReportInfoForClearance','CheckContentFile'];
    function assignfeeforbankgurantee ($timeout, $scope, $stateParams, $uibModalInstance, projectService, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail, ProjectServiceReportInfoForClearance,CheckContentFile) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectService = projectService;
//        vm.projectservicereportinfo = ProjectServiceReportInfoForClearance.get({projectid:vm.projectService.projectid,department:vm.projectService.departmentName,service:vm.projectService.serviceName});
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        $scope.file = {};
        vm.clear = clear;
        vm.assignService = assignService;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        function assignService(){
            if(angular.isDefined(vm.projectAttachemnt.file)){
                if(CheckContentFile.checkFile(vm.projectAttachemnt.file.name)){
                    assignServiceFeeAftercheck();
                }
                else{
                    alert("File Format Should be Correct");
                }
            }
            else{
                assignServiceFeeAftercheck();
            }
        }
        function onServiceLogSaveSuccess(result)
        {
            projectServiceLogid=result.id;
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            vm.projectService.isAssigned=true;
            vm.projectService.latestComments=vm.projectServiceLog.comments;
            vm.projectService.serviceFee=vm.projectservicedetail.serviceFee;
            vm.projectService.bankguranteeassigned=true;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }
//        function onUpdateProjectServiceSuccess(result)
//        {
//            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
//            vm.projectservicereportinfo.assignDate=result.assigOnDate;
//            ProjectServiceReportInfoForClearance.update(vm.projectservicereportinfo,onUpdateProjectServiceReportInfoSuccess,onUpdateProjectServiceReportInfoError);
//        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
//        function onUpdateProjectServiceReportInfoError()
//        {
//            vm.isSaving = false;
//        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Bank Gurantee Assign Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;
            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }
        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function assignServiceFeeAftercheck(){
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.actionTaken="Assigned Bank Gurantee Fee";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('processapplication', {
            parent: 'app',
            url: '/processapplication{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/processapplication/processapplication.html',
                    controller: 'processapplicationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('processapplication');
                    return $translate.refresh();
                }]
            }
        })
         .state('processapplication.payment', {
            parent: 'processapplication',
            url: '/process',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                   templateUrl: 'app/processapplication/paymentservice.html',
                    controller: 'paymentserviceController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                }).result.then(function() {
                    $state.go('processapplication', null, { reload: 'processapplication' });
                }, function() {
                    $state.go('processapplication');
                });
            }]
        });
//        .state('processapplication.payment', {
//            parent: 'app',
//            url: '/process',
//            data: {
//                authorities: []
//            },
//             onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
//                $uibModal.open({
//                    templateUrl: 'app/processapplication/paymentservice.html',
//                    controller: 'processapplicationController',
//                    controllerAs: 'vm',
//                    backdrop: 'static',
//                    size: 'lg'
//                }).result.then(function() {
//                    $state.go('processapplication', null, { reload: 'processapplication' });
//                }, function() {
//                    $state.go('processapplication');
//                });
//            }]
//
//        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('processapplicationController', processapplicationController);

    processapplicationController.$inject = ['$timeout', '$scope', '$stateParams','$state'];

    function processapplicationController ($timeout, $scope, $stateParams,$state) {
        var vm = this;

//        vm.block = entity;
        vm.clear = clear;
      //  vm.save = save;

//        $timeout(function (){
//            angular.element('.form-group:eq(1)>input').focus();
//        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
            $state.go('processapplication', null, { reload: 'processapplication' });
        }

//        function save () {
//            vm.isSaving = true;
//            if (vm.processapplication.id !== null) {
//                processapplication.update(vm.block, onSaveSuccess, onSaveError);
//            } else {
//                processapplication.save(vm.block, onSaveSuccess, onSaveError);
//            }
//        }
//
//        function onSaveSuccess (result) {
//            $scope.$emit('investhryApp:blockUpdate', result);
//            $uibModalInstance.close(result);
//            vm.isSaving = false;
//        }
//
//        function onSaveError () {
//            vm.isSaving = false;
//        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('paymentserviceController', paymentserviceController);

    paymentserviceController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance'];

    function paymentserviceController ($timeout, $scope, $stateParams, $uibModalInstance) {
        var vm = this;

      //  vm.block = entity;
        vm.clear = clear;
        //vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

//        function save () {
//            vm.isSaving = true;
//            if (vm.block.id !== null) {
//                Block.update(vm.block, onSaveSuccess, onSaveError);
//            } else {
//                Block.save(vm.block, onSaveSuccess, onSaveError);
//            }
//        }
//
//        function onSaveSuccess (result) {
//            $scope.$emit('investhryApp:blockUpdate', result);
//            $uibModalInstance.close(result);
//            vm.isSaving = false;
//        }
//
//        function onSaveError () {
//            vm.isSaving = false;
//        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('policyFeedbackDashboard', {
            parent: 'app',
            url: '/policyFeedbackDashboard',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/policyFeedbackDashboard/feedbacks.html',
                    controller: 'PolicyFeedbackDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PolicyFeedbackDashboardController', PolicyFeedbackDashboardController);

    PolicyFeedbackDashboardController.$inject = ['$scope','DraftPolicy','PolicyDetails'];

    function PolicyFeedbackDashboardController($scope, DraftPolicy, PolicyDetails) {
        var vm = this;
        vm.draftPolicies = [];
        vm.statusSelected = statusSelected;
        vm.statusFilter = 'All';
        vm.policyFilter = 'All';
        vm.showPolicyForm = false;
        vm.save = save;

        PolicyDetails.query(function(result) {
            vm.policyDetails = result;
            vm.searchQuery = null;
            statusSelected('Pending',result[0].name);
        });

        function statusSelected (statusFilterobj,policyFilterobj) {
            vm.statusFilter = statusFilterobj;
            vm.policyFilter = policyFilterobj;
            DraftPolicy.query({id:'1',status:statusFilterobj,policy:policyFilterobj},function(result) {
                vm.draftPolicies = result;
                vm.searchQuery = null;
            });
        }

        $scope.setTempItem = function(item) {
            $scope.policyName = item.name;
            $scope.serverFileName = item.file;
            vm.showPolicyForm = true;
        }

        function save() {
            DraftPolicy.save(vm.draftPolicy,onSaveSuccess,onSaveError);
        }

        function onSaveSuccess() {
            UIkit.modal('#draft_policy').hide();
            location.reload();
        }

        function onSaveError() {

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('policy-dashboard', {
            parent: 'app',
            url: '/policy-dashboard',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/policyDashboard/policydashboard.html',
                    controller: 'PolicyDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        });

    }
})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PolicyDashboardController', PolicyDashboardController);

    PolicyDashboardController.$inject = ['$scope','$state', 'Sector', 'Country', 'CountryService'];

    function PolicyDashboardController($scope,$state, Sector, Country, CountryService) {

        var vm = this;
        // vm.clear = clear;
        loadAll();
        // vm.submitForm = submitForm;

        function loadAll()
        {
            Sector.query(function(result) {
                vm.sectors = result;
                vm.searchQuery = null;
            });

            loadAllCountries();
            function loadAllCountries() {
                vm.allcountries=CountryService.getAllCountries();
            }
        }

        vm.submitForm = function () {
            alert("Thank you for submitting your intent to invest. Our team will contact you shortly.");

            window.location.reload();
        }



    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectServicePaymentByTransaction', Projectlist);

    Projectlist.$inject = ['$resource'];

    function Projectlist ($resource) {
        var resourceUrl =  '/api/project-service-payment-transactionId/:disbursed/:transactionId';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectServicePaymentBetweenDate', Projectlist);

    Projectlist.$inject = ['$resource'];

    function Projectlist ($resource) {
        var resourceUrl =  '/api/project-service-payment/:disbursed/:fromdate/:todate';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('viewpayments', {
            parent: 'app',
            url: '/viewpayments/{disbursed}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_ACCOUNT_OFFICER','ROLE_DESK_OFFICER','ROLE_HEPC_MONITORING_OFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/payments/viewpayments.html',
                    controller: 'viewpaymentsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('disbursePayment', {
            parent: 'viewpayments',
            url: '/disbursePayment/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_ACCOUNT_OFFICER','ROLE_HEPC_MONITORING_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/payments/disbursePayment.html',
                    controller: 'disbursePaymentController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        projectServiceLog: function () {
                              return {
                                  projectid: null,
                                  serviceid: null,
                                  comments: null,
                                  commentDate: null,
                                  commentByUserLogin: null,
                                  actionTaken: null,
                                  id: null
                              };
                        },
                        entity: ['ProjectServicePaymentDetails', function(ProjectServicePaymentDetails) {
                            return ProjectServicePaymentDetails.get({id:$stateParams.id}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }]

                    }
                }).result.then(function() {
                    $state.go('viewpayments', null, { reload: 'viewpayments' });
                }, function() {
                    $state.go('viewpayments');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectServicePayment', Projectlist);

    Projectlist.$inject = ['$resource'];

    function Projectlist ($resource) {
        var resourceUrl =  '/api/project-service-payment/:disbursed';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('viewpaymentsController', viewpaymentsController);

    viewpaymentsController.$inject = ['$filter', '$scope','$state', 'Principal', '$stateParams', 'ProjectServicePayment','ProjectServicePaymentBetweenDate', 'ProjectServicePaymentByTransaction'];

    function viewpaymentsController($filter, $scope, $state, Principal, $stateParams, ProjectServicePayment, ProjectServicePaymentBetweenDate, ProjectServicePaymentByTransaction) {
        var vm = this;
        vm.viewstatus=$stateParams.disbursed;
       // vm.selectedDate=selectedDate;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        vm.showDateFilter = false;
        vm.clearFilterButton = false;
        vm.transId = null;

        vm.openCalendar = openCalendar;
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        getAccount();
        // loadAll($stateParams.disbursed);

        // function loadAll(disbursed) {
        //     ProjectServicePayment.query({disbursed:disbursed},function(result){
        //         vm.projectservicepayments=result;
        //         if (vm.projectservicepayments!==""){
        //             vm.showDateFilter = true;
        //         }
        //     });
        //
        // }

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        vm.dateOptions = {
            minDate: new Date("01-01-2000"),
            maxDate: Date.now()
        };

        
        function getPaymentBetweenDates(disbursed) {
            ProjectServicePayment.query({disbursed:disbursed, },function(result){
                vm.projectservicepayments=result;
            });
        }

        vm.getPaymentBetweenDates=function(disbursed){
            var fromdate=$filter('date')(vm.fromdate, "yyyy-MM-dd");
            var todate=$filter('date')(vm.todate, "yyyy-MM-dd");

            ProjectServicePaymentBetweenDate.query({disbursed:disbursed,fromdate:fromdate,todate:todate},function(result){
                vm.projectservicepayments=result;
                vm.clearFilterButton = true;
            });
        };

        vm.getPaymentByTransactionId=function(disbursed, transactionId){
            ProjectServicePaymentByTransaction.query({disbursed:disbursed, transactionId:transactionId},function(result){
                vm.projectservicepayments=result;
                vm.clearFilterButton = true;
            });
        };

        vm.clearFilter = function () {
             vm.fromdate = null;
             vm.todate = null;
            vm.clearFilterButton = false;
            vm.transId = null;
            loadAll($stateParams.disbursed);
            // loadAll($stateParams.disbursed);
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('disbursePaymentController', disbursePaymentController);

    disbursePaymentController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','entity','projectServiceLog','ProjectServiceLogUpdated','ProjectServicePaymentDetails'];
    function disbursePaymentController ($timeout, $scope, $stateParams, $uibModalInstance,entity,projectServiceLog,ProjectServiceLogUpdated,ProjectServicePaymentDetails) {
        var vm = this;
        vm.clear = clear;
        vm.projectServiceLog=projectServiceLog;
        vm.projectServicePaymentDetail=entity;
        vm.disbursePayment=disbursePayment;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function disbursePayment()
        {
            vm.projectServicePaymentDetail.paymentdisbursed=true;
            ProjectServicePaymentDetails.update(vm.projectServicePaymentDetail,onSaveSuccess,onSaveError);
        }
        function onSaveError()
        {}
        function onSaveSuccess(result)
        {
            vm.projectServiceLog.projectid=result.projectid;
            vm.projectServiceLog.serviceid=result.serviceid;
            vm.projectServiceLog.actionTaken="PaymentDisbursed";
            vm.projectServiceLog.comments=(result.feedescription==null?"Service Fee":result.feedescription);
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onSaveServiceLogSuccess,onSaveServiceLogError);
        }
        function onSaveServiceLogSuccess(result)
        {
            $uibModalInstance.close(true);
        }
        function onSaveServiceLogError()
        {}
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NswsRedirectUrlController', NswsRedirectUrlController);

    NswsRedirectUrlController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$stateParams', '$sessionStorage', '$location', '$q'];

    function NswsRedirectUrlController ($scope, Principal, LoginService, $state, $stateParams, $sessionStorage, $location, $q) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;

        vm.token = $location.search().token;

        vm.url =  $location.search().redirectparam;
        login();

        function login() {
            var defer = loginWithToken(vm.token, false);
            defer.then(function () {
                getAccount();
            });
        }

        function getAccount() {
            Principal.identity(true).then(function(account) {
                $state.go("listproject");
            }, function (error) {

            });
        }

         function storeAuthenticationToken(jwt) {
            $sessionStorage.authenticationToken = jwt;

        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('nswsURL', {
            parent: 'app',
            url: '/nswsURL',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/nswsRedirectPage/searchCAF.html',
                    controller: 'NswsRedirectUrlController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        // .state('backtocentral', {
        //     parent: 'app',
        //     url: '/backtocentral',
        //     data: {
        //         authorities: []
        //     },
        //     views: {
        //         'content@': {
        //             templateUrl: 'app/centerRedirectPage/centralForm.html',
        //             controller: 'RedirectToCentralPortalController',
        //             controllerAs: 'vm'
        //         }
        //     },
        //     resolve: {
        //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
        //             $translatePartialLoader.addPart('home');
        //             return $translate.refresh();
        //         }]
        //     }
        // });

        }
        })();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('nma-serviceForm-fillform', {
            parent: 'serviceclearanceaction',
            url: '/nma-fillform/{projectserviceid}/{cafpin}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_RM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/nmaserviceform/nmaserviceform.html',
                    controller: 'NMAserviceFormController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        projectServiceFormFieldData: function () {
                            return {
                                serviceid: null,
                                formfieldvalue: null,
                                projectid: null,
                                formfieldName: null,
                                id: null
                            };
                        },
                        projectAttachemnt: function () {
                            return {
                                fileName: null,
                                description: null,
                                fileExtension: null,
                                serverFileName: null,
                                id: null
                            };
                        },
                        projectServiceLog: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                comments: null,
                                commentDate: null,
                                commentByUserLogin: null,
                                actionTaken: null,
                                id: null
                            };
                        },
                        projectService: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                }, function() {
                    $state.go('serviceclearanceaction');
                });
            }]
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NMAserviceFormController', NMAserviceFormController);

    NMAserviceFormController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'projectService', 'projectServiceFormFieldData', 'projectAttachemnt', 'projectServiceLog', 'ProjectAttachemnt', 'ProjectServiceLogUpdated', 'FileManagement', 'Projectservicedetail', 'Projectserviceformfielddata', 'serviceFormFieldDataCollection', 'ServiceFormAttachments', 'DepartmentService', 'Serviceformdocs', 'downloadserviceformattachment', 'NMARequest', '$filter', 'Serviceformdraftsaved'];

    function NMAserviceFormController($timeout, $scope, $stateParams, $uibModalInstance, projectService, projectServiceFormFieldData, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail, Projectserviceformfielddata, serviceFormFieldDataCollection, ServiceFormAttachments, DepartmentService, Serviceformdocs, downloadserviceformattachment, NMARequest, $filter, Serviceformdraftsaved) {
        var vm = this;
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectServiceFormFieldData = projectServiceFormFieldData;
        vm.projectService = projectService;
        vm.uploadNMAFiles = uploadNMAFiles;
        var projectAttachmentResultObject = null;
        var projectServiceLogid = null;
        var formfielddataObjectArrayLength = 0;
        var formfieldCount = 0;
        var vmlength = 0;
        vm.serviceformdraftsaved = {};
        vm.isSaved = false;
        vm.finalsubmit = false;
        vm.NMAfiles = [];
        var eventname;
        var saveLogFlag = false;
        vm.clear = clear;
        vm.saveFormFieldData = saveFormFieldData;
        vm.downloadFile = downloadFile;
        $scope.file = {};
        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        vm.departmentservice = DepartmentService.get({id: vm.projectService.serviceid});
        Serviceformdocs.query({id: "1", serviceid: vm.projectService.serviceid}, function (result) {
            vm.serviceformdocs = result;
            vm.searchQuery = null;
        });
        loadServiceFormFields();

        function loadServiceFormFields() {
            Serviceformdraftsaved.get({id: vm.projectService.id}, function () {
                vm.isDraftSaved = true;
            });

            vm.serviceFormFieldData = serviceFormFieldDataCollection.query({
                serviceid: vm.projectService.serviceid,
                projectid: vm.projectService.projectid
            });
        }

        var combineFilledForm = "";

        function saveFormFieldData() {
            if (!vm.finalsubmit) {
                alert('Your Form is temporarily Submitted.\n\nInorder to make corrections re-open the form and save again.For Final submission click on the Final Submit button.\n\nNote: After final submission no more updations will be accepted');
            }
            vm.isSaving = true;
            vmlength = vm.serviceFormFieldData.length;
            formfielddataObjectArrayLength = vmlength;
            for (var i = 0; i < vmlength; i++) {
                var data = vm.serviceFormFieldData[i];
                combineFilledForm = combineFilledForm + vm.serviceFormFieldData[i].formfieldvalue + " | ";
                data.projectid = vm.projectService.projectid;
                if (data.id !== null) {
                    Projectserviceformfielddata.update(data, onSaveServiceFormFieldDataSuccess, onSaveServiceFormFieldDataError);
                } else {
                    Projectserviceformfielddata.save(data, onSaveServiceFormFieldDataSuccess, onSaveServiceFormFieldDataError);
                }
                formfieldCount = i;
            }

            for (var j = 0; j < vm.fileattach.length; j++) {
                if (vm.fileattach[j].isSaved === false) {
                    vm.fileattach[j].isSaved = true;
                }
                ServiceFormAttachments.update(vm.fileattach[j], onUpdatefieldServiceFormAttachmentsSuccess);
            }

            if (vm.finalsubmit) {
                createNMAObject();
            }
        }

        function onUpdatefieldServiceFormAttachmentsSuccess() {
        }

        vm.fileattach = ServiceFormAttachments.query({
            id: "1",
            projectid: vm.projectService.projectid,
            serviceid: vm.projectService.serviceid
        }, function (result) {
            loadFileAttachments(result);
        });
        vm.addfileattachment = addfileattachment;

        function addfileattachment(documentType) {
            eventname = documentType;
            var fileNameArray = vm.serviceformfile.name.split(".");
            var fileextension = "";
            if ((fileNameArray.length > 1)) {
                fileextension = fileNameArray[(fileNameArray.length - 1)];
            }
            var inputFileName = vm.serviceformattachment.description;
            if (fileextension !== "") {
                inputFileName = inputFileName + "." + fileextension;
            }
            vm.serviceformattachment.isSaved = false;
            vm.serviceformattachment.downloadfilename = inputFileName;
            vm.serviceformattachment.clientfilename = vm.serviceformfile.name;
            vm.serviceformattachment.projectID = vm.projectService.projectid;
            vm.serviceformattachment.serviceID = vm.projectService.serviceid;
            ServiceFormAttachments.save(vm.serviceformattachment, onSaveServiceFormAttachmentsSuccess);
        }

        function onSaveServiceFormAttachmentsSuccess(result) {
            var filename = result.id;
            var file = vm.serviceformfile;
            FileManagement.saveFile(file, filename);
            var fileNameArray = vm.serviceformfile.name.split(".");
            var fileextension = "";
            if ((fileNameArray.length > 1)) {
                fileextension = fileNameArray[(fileNameArray.length - 1)];
            }
            var inputFileName = result.id;
            if (fileextension !== "") {
                inputFileName = inputFileName + "." + fileextension;
            }
            result.serverfilename = inputFileName;
            eventname(result);


            ServiceFormAttachments.update(result, onUpdateServiceFormAttachmentsSuccess);
        }

        function onUpdateServiceFormAttachmentsSuccess(result) {
            vm.fileattach.push(result);
            vm.fileattachment = {};
            vm.serviceformattachment.description = "";
            $('#browsefile').val('');
        }

        vm.removeRawRow = function (id) {
            ServiceFormAttachments.delete({id: id});
            var index = -1;
            var comArray = eval(vm.fileattach);
            for (var i = 0; i < comArray.length; i++) {
                if (comArray[i].id === id) {
                    index = i;
                    break;
                }
            }
            vm.fileattach.splice(index, 1);
        };

        function onSaveServiceFormFieldDataSuccess(result) {
            if (!vm.finalsubmit && !saveLogFlag && formfieldCount === (formfielddataObjectArrayLength - 1)) {
                saveProjectServiceLog();
                saveLogFlag = true;
            }
        }

        function onSaveServiceFormFieldDataError() {
        }

        function saveProjectServiceLog(result) {
            $scope.$emit('investhryApp:projectserviceformfielddataUpdate', result);
            vm.projectServiceLog.projectid = vm.projectService.projectid;
            vm.projectServiceLog.serviceid = vm.projectService.serviceid;
            vm.projectServiceLog.comments = vm.projectServiceLog.comments + " | " + combineFilledForm;

            if (!vm.finalsubmit) {
                vm.projectServiceLog.actionTaken = "ServiceFormDraftSaved";
            } else {
                vm.projectServiceLog.actionTaken = "ServiceFormEdited";
            }
            ProjectServiceLogUpdated.save(vm.projectServiceLog, onServiceLogSaveSuccess, onServiceLogSaveError);
        }

        function onServiceLogSaveSuccess(result) {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            if (!vm.finalsubmit) {
                vm.serviceformdraftsaved.id = vm.projectService.id;
                vm.serviceformdraftsaved.draftsaved = true;
                Serviceformdraftsaved.update(vm.serviceformdraftsaved);
                $uibModalInstance.close();
                return;
            }
            projectServiceLogid = result.id;
            vm.projectService.latestComments = "Service form edited";
            vm.projectService.formFilledStatus = true;
            Projectservicedetail.update(vm.projectService, onUpdateProjectServiceSuccess, onUpdateProjectServiceError);
        }

        function onUpdateProjectServiceSuccess(result) {
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            if (angular.isDefined(vm.projectAttachemnt.file)) {
                saveProjectAttachment();
            }
            else {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }

        function onUpdateProjectServiceError() {
            vm.isSaving = false;
        }

        function onServiceLogSaveError() {
            vm.isSaving = false;
        }

        function saveProjectAttachment() {
            var file = vm.projectAttachemnt.file;
            vm.projectAttachemnt.id = projectServiceLogid;
            vm.projectAttachemnt.fileName = file.name;
            vm.projectAttachemnt.description = "Service Form Field Data Attachment";
            vm.projectAttachemnt.fileExtension = file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt, onSaveProjectAttachmentSuccess, onSaveProjectAttachmentError);
        }

        function onSaveProjectAttachmentSuccess(result) {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file = vm.projectAttachemnt.file;
            FileManagement.saveFile(file, filename);
            projectAttachmentResultObject = result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension = "";
            if ((fileNameArray.length > 1)) {
                fileextension = fileNameArray[(fileNameArray.length - 1)];
            }
            var inputFileName = result.id;
            if (fileextension !== "") {
                inputFileName = inputFileName + "." + fileextension;
            }
            projectAttachmentResultObject.serverFileName = inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject, onUpdateProjectAttachmentSuccess, onUpdateProjectAttachmentError);
        }

        function onSaveProjectAttachmentError() {
            vm.isSaving = false;
        }

        function onUpdateProjectAttachmentSuccess(result) {
            $uibModalInstance.close(result);
        }

        function onUpdateProjectAttachmentError() {
            vm.isSaving = false;
        }

        function downloadFile(serverfilename, downloadfilename) {
            downloadserviceformattachment.download(serverfilename, downloadfilename)
                .then(function (success) {
                    console.log('success : ' + success);
                }, function (error) {
                    console.log('error : ' + error);
                });
        }

        $scope.firmFiles = [];
        vm.firmFiles = [];
        $scope.propertyDocument = [];
        vm.propertyDocument = [];
        $scope.typicalfloorplans = [];
        vm.typicalfloorplans = [];
        $scope.ownershipdocuments = [];
        vm.ownershipdocuments = [];
        $scope.sectionDocuments = [];
        vm.sectionDocuments = [];
        $scope.elevationDocuments = [];
        vm.elevationDocuments = [];
        $scope.repairsDocuments = [];
        vm.repairsDocuments = [];
        $scope.googleEarthImage = [];
        vm.googleEarthImage = [];
        $scope.modernconstructionImage = [];
        vm.modernconstructionImage = [];
        $scope.signature = [];
        vm.sign = [];
        vm.otherDocuments = [];
        $scope.otherDocuments = [];
        vm.serviceformattachment = {};

        vm.createNMAObject = createNMAObject;

        function createNMAObject() {
            var sampleObject = {};
            vm.NMAfiles = [$scope.propertyDocument, $scope.elevationDocuments, $scope.typicalfloorplans, $scope.sectionDocuments, $scope.otherDocuments, $scope.repairsDocuments, $scope.googleEarthImage, $scope.modernconstructionImage, $scope.ownershipdocuments, $scope.firmFiles, $scope.signature];
            vm.testData = $filter('orderBy')(vm.serviceFormFieldData, 'formfieldOrder');
            $scope.data = NMARequest.createNMAObject(vm.testData, vm.NMAfiles, $stateParams.cafpin, vm.projectService.id,onNmaObjectSaveSuccess,onNmaObjectSaveError);

        }

        function onNmaObjectSaveSuccess(result) {
            if (!saveLogFlag && formfieldCount === (formfielddataObjectArrayLength - 1)) {
                saveProjectServiceLog();
                saveLogFlag = true;
            }
        }

        function onNmaObjectSaveError(result) {
            alert(result.data.errorMessage);
            vm.isSaving = false;
        }

        function uploadNMAFiles(documentType) {
            var baseAddress = 'https://investharyana.in/api/downloadserviceformattachment?serverfilename=';
            switch (documentType) {

                case 'Property':
                    vm.serviceformfile = vm.propertydocument;
                    vm.serviceformattachment.description = documentType;
                    addfileattachment(function (result) {
                        vm.propertyDocument.push(result);
                        $scope.propertyDocument.push({file: baseAddress + result.serverfilename + '&downloadfilename=' + result.clientfilename});
                    });
                    vm.propertydocument = null;
                    vm.propertydocumentdescription = '';
                    $('#propertydocs').val('');

                    break;

                case 'Elevation':
                    vm.serviceformfile = vm.elevationdocument;
                    vm.serviceformattachment.description = documentType;
                    addfileattachment(function (result) {
                        vm.elevationDocuments.push(result);
                        $scope.elevationDocuments.push({file: baseAddress + result.serverfilename + '&downloadfilename=' + result.clientfilename});
                    });
                    vm.elevationdocument = null;
                    vm.elevationdocumentdescription = '';
                    $('#elevationdocs').val('');
                    break;
                case 'FloorPlan':
                    vm.serviceformattachment.description = documentType;
                    vm.serviceformfile = vm.typicalfloorplan;
                    addfileattachment(function (result) {
                        vm.typicalfloorplans.push(result);
                        $scope.typicalfloorplans.push({file: baseAddress + result.serverfilename + '&downloadfilename=' + result.clientfilename});
                    });
                    vm.typicalfloorplan = null;
                    vm.typicalfloorplandescription = '';
                    $('#floorplan').val('');
                    break;


                case 'Repairs':
                    vm.serviceformfile = vm.repairsdocument;
                    vm.serviceformattachment.description = documentType;
                    addfileattachment(function (result) {
                        vm.repairsDocuments.push(result);
                        $scope.repairsDocuments.push({file: baseAddress + result.serverfilename + '&downloadfilename=' + result.clientfilename});
                    });
                    vm.repairsdocument = null;
                    vm.repairsdescrption = '';
                    $('#repairdocs').val('');
                    break;
                case 'Section':
                    vm.serviceformfile = vm.sectiondocument;
                    vm.serviceformattachment.description = documentType;
                    addfileattachment(function (result) {
                        vm.sectionDocuments.push(result);
                        $scope.sectionDocuments.push({file: baseAddress + result.serverfilename + '&downloadfilename=' + result.clientfilename});
                    });
                    vm.sectiondocument = null;
                    vm.sectiondocumentdescription = '';
                    $('#sectiondocs').val('');
                    break;
                case 'ModernConstructionsImage':
                    vm.serviceformfile = vm.constructionimg;
                    vm.serviceformattachment.description = documentType;
                    addfileattachment(function (result) {
                        vm.modernconstructionImage.push(result);
                        $scope.modernconstructionImage.push({file: baseAddress + result.serverfilename + '&downloadfilename=' + result.clientfilename});
                    });
                    vm.constructionimg = null;
                    vm.constructionimgdesc = '';
                    $('#constructiondocs').val('');
                    break;
                case 'GoogleEarthImage':
                    vm.serviceformfile = vm.googlearth;
                    vm.serviceformattachment.description = documentType;
                    addfileattachment(function (result) {
                        vm.googleEarthImage.push(result);
                        $scope.googleEarthImage.push({file: baseAddress + result.serverfilename + '&downloadfilename=' + result.clientfilename});
                    });
                    vm.googlearth = null;
                    vm.googlearthdesc = '';
                    $('#earthimage').val('');
                    break;
                case 'Ownership':
                    vm.serviceformfile = vm.ownership;
                    vm.serviceformattachment.description = documentType;
                    addfileattachment(function (result) {
                        vm.ownershipdocuments.push(result);
                        $scope.ownershipdocuments.push({file: baseAddress + result.serverfilename + '&downloadfilename=' + result.clientfilename});
                    });
                    vm.ownership = null;
                    vm.ownershipdesc = '';
                    $('#ownership').val('');
                    break;
                case 'Firm':
                    vm.serviceformfile = vm.firmfile;
                    vm.serviceformattachment.description = documentType;
                    addfileattachment(function (result) {
                        vm.firmFiles.push(result);
                        $scope.firmFiles.push({file: baseAddress + result.serverfilename + '&downloadfilename=' + result.clientfilename});
                    });
                    vm.firmfile = null;
                    vm.firmfiledesc = '';
                    $('#firmfiles').val('');
                    break;
                case 'Other':
                    vm.serviceformfile = vm.otherdocument;
                    vm.serviceformattachment.description = documentType;
                    addfileattachment(function (result) {
                        vm.otherDocuments.push(result);
                        $scope.otherDocuments.push({file: baseAddress + result.serverfilename + '&downloadfilename=' + result.clientfilename});
                    });
                    vm.otherdocument = null;
                    vm.others = '';
                    $('#others').val('');
                    break;
                case 'Signature':
                    vm.serviceformfile = vm.signature;
                    vm.serviceformattachment.description = documentType;
                    addfileattachment(function (result) {
                        vm.sign.push(result);
                        $scope.signature.push({file: baseAddress + result.serverfilename + '&downloadfilename=' + result.clientfilename});
                    });
                    vm.otherdocument = null;
                    $('#signature').val('');
                    break;
            }
        }

        vm.removeRow = function (patharray, data, id, $index) {
            ServiceFormAttachments.delete({id: id});
            data.splice($index, 1);
            patharray.splice($index, 1);
        };
        vm.finalsubmitted = function () {
            vm.finalsubmit = true;
            saveFormFieldData();
        };

        function loadFileAttachments(result) {
            var baseAddress = 'https://investharyana.in/api/downloadserviceformattachment?serverfilename=';
            for (var i = 0; i < result.length; i++) {
                switch (result[i].description) {
                    case 'Property':
                        vm.propertyDocument.push(result[i]);
                        $scope.propertyDocument.push({file: baseAddress + result[i].serverfilename + '&downloadfilename=' + result[i].clientfilename});
                        break;
                    case 'Elevation':
                        vm.elevationDocuments.push(result[i]);
                        $scope.elevationDocuments.push({file: baseAddress + result[i].serverfilename + '&downloadfilename=' + result[i].clientfilename});
                        break;
                    case 'FloorPlan':
                        vm.typicalfloorplans.push(result[i]);
                        $scope.typicalfloorplans.push({file: baseAddress + result[i].serverfilename + '&downloadfilename=' + result[i].clientfilename});
                        break;
                    case 'Repairs':
                        vm.repairsDocuments.push(result[i]);
                        $scope.repairsDocuments.push({file: baseAddress + result[i].serverfilename + '&downloadfilename=' + result[i].clientfilename});
                        break;
                    case 'Section':
                        vm.sectionDocuments.push(result[i]);
                        $scope.sectionDocuments.push({file: baseAddress + result[i].serverfilename + '&downloadfilename=' + result[i].clientfilename});
                        break;
                    case 'ModernConstructionsImage':
                        vm.modernconstructionImage.push(result[i]);
                        $scope.modernconstructionImage.push({file: baseAddress + result[i].serverfilename + '&downloadfilename=' + result[i].clientfilename});
                        break;
                    case 'GoogleEarthImage':
                        vm.googleEarthImage.push(result[i]);
                        $scope.googleEarthImage.push({file: baseAddress + result[i].serverfilename + '&downloadfilename=' + result[i].clientfilename});
                        break;
                    case 'Ownership':
                        vm.ownershipdocuments.push(result[i]);
                        $scope.ownershipdocuments.push({file: baseAddress + result[i].serverfilename + '&downloadfilename=' + result[i].clientfilename});
                        break;
                    case 'Firm':
                        vm.firmFiles.push(result[i]);
                        $scope.firmFiles.push({file: baseAddress + result[i].serverfilename + '&downloadfilename=' + result[i].clientfilename});
                        break;
                    case 'Other':
                        vm.otherDocuments.push(result[i]);
                        $scope.otherDocuments.push({file: baseAddress + result[i].serverfilename + '&downloadfilename=' + result[i].clientfilename});
                        break;
                    case 'Signature':
                        vm.sign.push(result[i]);
                        $scope.signature.push({file: baseAddress + result[i].serverfilename + '&downloadfilename=' + result[i].clientfilename});
                        break;
                }
            }
        }



    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('NMARequest', NMARequest);

    NMARequest.$inject = ['$http'];

    function NMARequest ($http) {
        var NMAObject={};
        var requestObject={};
        requestObject.user={};
        requestObject.nmaobject={};
        var NMARegistration={};
        var NMARegistrationObject={};
        NMARegistration.Users=[];
        NMAObject.ApplicantDetails={};
        NMAObject.OwnerDetails={};
        NMAObject.ProposedWorkLocalityDtails={};
        NMAObject.ProposedWorkDetails={};
        NMAObject.Documents={};
        NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf={};
        NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.InCaseOfRepairsOrRenovationReportFromDulyAuthorisedOrLicencedArchitectSubmittedByApplicant=[];
        NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.Signature=[];
        NMAObject.ProposedWorkLocalityDtails.LocalityOfTheProposedConstruction={};
        NMAObject.ProposedWorkLocalityDtails.NameOfTheNearestMonumentOrSite={};
        NMAObject.ProposedWorkLocalityDtails.DistanceOfTheSiteOfTheConstructionFromProtectedBoundaryOfMonument={};

        return {
            createNMAObject:function (formfielddata,files,uniqueid,projectid,onSuccess,onError) {
                for (var i=0;i<formfielddata.length;i++){
                    switch (formfielddata[i].formfieldName){
                        case'Department':
                            formfielddata[i].formfieldvalue=formfielddata[i].formfieldvalue.split(' ').join('_');
                            NMAObject.Department=formfielddata[i].formfieldvalue;
                            NMARegistrationObject.Department=formfielddata[i].formfieldvalue;
                            NMARegistrationObject.UniqueId=uniqueid;
                            break;
                        case'Architect Name':
                            NMAObject.ArchitectName=formfielddata[i].formfieldvalue;
                            NMARegistrationObject.ArchitectName=formfielddata[i].formfieldvalue;
                            break;
                        case'Architect Email':
                            NMAObject.ArchitectEmailId=formfielddata[i].formfieldvalue;
                            NMARegistrationObject.ArchitectEmailId=formfielddata[i].formfieldvalue;
                            break;
                        case'Architect Mobile':
                            NMAObject.ArchitectMobileNo=formfielddata[i].formfieldvalue;
                            NMARegistrationObject.ArchitectMobileNo=formfielddata[i].formfieldvalue;
                            break;
                        case'NOC Request Screen':
                            NMAObject.NOCRequestScreen = getNOCValue(formfielddata[i].formfieldvalue);
                            break;
                        case'Name of The Applicant':
                            NMAObject.ApplicantDetails.ApplicantName=formfielddata[i].formfieldvalue;
                            break;
                        case'Present Address':
                            NMAObject.ApplicantDetails.PresentAddress=formfielddata[i].formfieldvalue;
                            break;
                        case'Permanent Address':
                            NMAObject.ApplicantDetails.PermanentAddress=formfielddata[i].formfieldvalue;
                            break;
                        case'The Applicant is other than the Owner?':
                            NMAObject.OwnerDetails.ApplicantIsOtherThanOwner=formfielddata[i].formfieldvalue;
                            break;
                        case'If Yes, Name of the Owner ':
                            NMAObject.OwnerDetails.NameOfTheOwner=formfielddata[i].formfieldvalue;
                            break;
                        case'If Yes, Present Address':
                            NMAObject.OwnerDetails.PresentAddress=formfielddata[i].formfieldvalue;
                            break;
                        case'If Yes, Permanent Address':
                            NMAObject.OwnerDetails.PermanentAddress=formfielddata[i].formfieldvalue;
                            break;
                        case'Whether the Property is Owned by':
                            NMAObject.OwnerDetails.WhetherThePropertyIsOwnedBy=formfielddata[i].formfieldvalue;
                            break;
                        case'Whether The Property is Owned by':
                            NMAObject.OwnerDetails.WhetherThePropertyIsOwnedBySecond=formfielddata[i].formfieldvalue;
                            break;
                        case'If Other,Please Specify':
                            NMAObject.OwnerDetails.Other=formfielddata[i].formfieldvalue;
                            break;
                        case'Plot/ Survey No':
                            NMAObject.ProposedWorkLocalityDtails.LocalityOfTheProposedConstruction.PlotSurveyNo=formfielddata[i].formfieldvalue;
                            break;
                        case'State':
                            if (formfielddata[i].formfieldOrder===22){
                                NMAObject.ProposedWorkLocalityDtails.LocalityOfTheProposedConstruction.State=formfielddata[i].formfieldvalue;
                            }

                            if (formfielddata[i].formfieldOrder===28){
                                NMAObject.ProposedWorkLocalityDtails.NameOfTheNearestMonumentOrSite.State=formfielddata[i].formfieldvalue;
                            }
                            break;
                        case'District':
                            if (formfielddata[i].formfieldOrder===23){
                                NMAObject.ProposedWorkLocalityDtails.LocalityOfTheProposedConstruction.District=formfielddata[i].formfieldvalue;
                            }

                            if (formfielddata[i].formfieldOrder===29){
                                NMAObject.ProposedWorkLocalityDtails.NameOfTheNearestMonumentOrSite.District=formfielddata[i].formfieldvalue;
                            }
                            break;
                        case'Taluk':
                            if (formfielddata[i].formfieldOrder===24){
                                NMAObject.ProposedWorkLocalityDtails.LocalityOfTheProposedConstruction.Taluk=formfielddata[i].formfieldvalue;
                            }

                            if (formfielddata[i].formfieldOrder===30){
                                NMAObject.ProposedWorkLocalityDtails.NameOfTheNearestMonumentOrSite.Taluk=formfielddata[i].formfieldvalue;
                            }
                            break;
                        case'Monument Name':
                            NMAObject.ProposedWorkLocalityDtails.NameOfTheNearestMonumentOrSite.MonumentName=formfielddata[i].formfieldvalue;
                            break;
                        case'Locality':
                            if (formfielddata[i].formfieldOrder===25){
                                NMAObject.ProposedWorkLocalityDtails.LocalityOfTheProposedConstruction.Locality=formfielddata[i].formfieldvalue;
                            }

                            if (formfielddata[i].formfieldOrder===31){
                                NMAObject.ProposedWorkLocalityDtails.NameOfTheNearestMonumentOrSite.Locality=formfielddata[i].formfieldvalue;
                            }
                            break;
                        case'Distance From the Main Monument (in Meters)':
                            NMAObject.ProposedWorkLocalityDtails.DistanceOfTheSiteOfTheConstructionFromProtectedBoundaryOfMonument.DistanceFromTheMainMonument=formfielddata[i].formfieldvalue;
                            break;
                        case'Distance From the Protected Boundary Wall (in Meters)':
                            NMAObject.ProposedWorkLocalityDtails.DistanceOfTheSiteOfTheConstructionFromProtectedBoundaryOfMonument.DistanceFromTheProtectedBoundaryWall=formfielddata[i].formfieldvalue;
                            break;
                        case'Nature of  Work Proposed':
                            NMAObject.ProposedWorkDetails.NatureOfWorkProposed=formfielddata[i].formfieldvalue;
                            break;
                        case'Details of Repair/ Renovation/Other':
                            NMAObject.ProposedWorkDetails.DetailsOfRepairAndRenovation=formfielddata[i].formfieldvalue;
                            break;
                        case'Number of Storeys':
                            NMAObject.ProposedWorkDetails.NumberOfStoreys=formfielddata[i].formfieldvalue;
                            break;
                        case'Floor Area .toString()(In Square Metres/Storey-wise)':
                            NMAObject.ProposedWorkDetails.FloorAreaInSquareMetresStoreyWise=formfielddata[i].formfieldvalue;
                            break;
                        case'Height(Excluding, Mumly, Parapet, Water-storage Tank, etc)':
                            NMAObject.ProposedWorkDetails.HeightInMetresExcludingMumtyParapetWaterStorageTankEtc=formfielddata[i].formfieldvalue;
                            break;
                        case'Height(Including Mumty, Parapet, Water-storage Tank, etc)':
                            NMAObject.ProposedWorkDetails.HeightInMetresIncludingMumtyParapetWaterStorageTankEtc=formfielddata[i].formfieldvalue;
                            break;
                        case'Basement, if any Proposed with Details':
                            NMAObject.ProposedWorkDetails.BasementIfAnyProposedWithDetails=formfielddata[i].formfieldvalue;
                            break;
                        case'Nature Of Work Proposed Other':
                            NMAObject.ProposedWorkDetails.NatureOfWorkProposedOther=formfielddata[i].formfieldvalue;
                            break;
                        case'Purpose of Proposed Work':
                            NMAObject.ProposedWorkDetails.PurposeOfProposedWork=formfielddata[i].formfieldvalue;
                            break;
                        case'If Other ,Please Specify':
                            NMAObject.ProposedWorkDetails.PurposeOfProposedWorkOther=formfielddata[i].formfieldvalue;
                            break;
                        case'Approximate Date of Commencement of the Proposed Works':
                            NMAObject.ProposedWorkDetails.ApproximateDateOfCommencementOfWorks=formfielddata[i].formfieldvalue;
                            break;
                        case'Approximate Duration for Completion of the Proposed  Works (in Years/Months)':
                            NMAObject.ProposedWorkDetails.ApproximateDurationOfCommencementOfWorks=formfielddata[i].formfieldvalue;
                            break;
                        case'Near the Monument':
                            NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.NearTheMonument=formfielddata[i].formfieldvalue;
                            break;
                        case'Near the Site of  Construction  Related Activity':
                            NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.NearTheSiteConstructionRelatedActivity=formfielddata[i].formfieldvalue;
                            break;
                        case'Whether the Monument is Located within limit of':
                            NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.WhetherMonumentIsLocatedWithinLimitOf=formfielddata[i].formfieldvalue;
                            break;
                        case'Does the master Plan/Zonal Development Plan/Layout Plan  Approved by Concerned  Local Authorities Exists for the City /Town/ Village':
                            NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.DoesMasterPlanApprovedByConcernedAuthoritiesExistsForTheCityTownVillage=formfielddata[i].formfieldvalue;
                            break;
                        case'Status of Modern Constructions in the Vicinity of the Monument and the Proposed Site of the Construction/Reconstruction':
                            NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.StatusOfModernConstructions=formfielddata[i].formfieldvalue;
                            break;
                        case'Open Space/ Park / Green Area Close To Protected Monument / Protected Area':
                            NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.OpenSpaceOrParkOrGreenAreaCloseToProtectedMonumentOrProtectedArea=formfielddata[i].formfieldvalue;
                            break;
                        case'Whether any Road(s) Exists Between the Monument and the Site of Construction/Reconstruction':
                            NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.WhetherAnyRoadExistsBetweenTheMonumentAndTheSiteOfConstruction=formfielddata[i].formfieldvalue;
                            break;
                        case'Remarks/Additional Information,If Any':
                            NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.Remarks=formfielddata[i].formfieldvalue;
                            break;
                    }
                }

                NMAObject.OwnerDetails.PropertyDocument=files[0];
                NMAObject.ApplicationUniqueNumebr=uniqueid;
                NMAObject.ProposedWorkDetails.ElevationDocument=files[1];
                NMAObject.ProposedWorkDetails.SectionDocument=files[3];
                NMAObject.ProposedWorkDetails.TypicalFloorPlan=files[2];
                NMAObject.ProposedWorkDetails.OtherDocument=files[4];
                NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.InCaseOfRepairsOrRenovationReportFromDulyAuthorisedOrLicencedArchitectSubmittedByApplicant=files[5];
                NMAObject.ProposedWorkDetails.MaximumHeightOfExistingModernBuildingInCloseVicinityOf.Signature=files[10];
                NMAObject.Documents.GoogleEarthImage=files[6];
                NMAObject.Documents.ModernConstructionsImage=files[7];
                NMAObject.Documents.OwnershipDocuments=files[8];
                NMAObject.Documents.FirmFiles=files[9];
                NMAObject.Documents.TermAndCondition="Yes";
                NMARegistration.Users.push(NMARegistrationObject);
                requestObject.user=NMARegistration;
                requestObject.nmaobject=NMAObject;
                requestObject.projectid=projectid;
                requestObject.cafpin=uniqueid;
                function getNOCValue(data) {
                    var value="";
                    switch (data){
                        case "Sanction of building plan":
                            value="S";
                            break;
                        case "Revise sanction of plan":
                            value="R";
                            break;
                        case "Completion Certificate":
                            value="SC";
                            break;
                        case "Saral Sanction of building plan":
                            value="SS";
                            break;
                        case "Revise Saral Sanction of building plan":
                            value="RS";
                            break;
                        case "Sanction Saral Completion":
                            value="SSC";
                            break;
                        case "Addition Alteration (1st sanction)":
                            value="A";
                            break;
                        case "Addition Alteration ( 2nd sanction)":
                            value="A1";
                            break;
                        case "Addition Alteration ( 3rd sanction)":
                            value="A2";
                            break;
                        case "Addition Alteration ( 4rth sanction)":
                            value="A3";
                            break;
                        case "Addition Alteration ( 5th sanction)":
                            value="A4";
                            break;
                        case "Addition alteration Revise sanction of plan":
                            value="RA";
                            break;
                        case "Addition alteration Revise sanction of plan (after 2nd sanction)":
                            value="RA1";
                            break;
                        case "Addition alteration Revise sanction of plan (after 3rd sanction)":
                            value="RA2";
                            break;
                        case "Addition alteration Revise sanction of plan (after 4th sanction)":
                            value="RA3";
                            break;
                        case "Addition alteration Revise sanction of plan (after 5th  sanction)":
                            value="RA4";
                            break;
                        case "Completion Addition alteration":
                            value="AC";
                            break;
                        case "Completion Addition alteration ( 2nd sanction)":
                            value="AC1";
                            break;
                        case "Completion Addition alteration ( 3rd sanction)":
                            value="AC2";
                            break;
                        case "Completion Addition alteration( 4th sanction)":
                            value="Ac3";
                            break;
                        case "Completion Addition alteration( 5th sanction)":
                            value="AC4";
                            break;
                    }
                    return value;
                }
                $http.post('/api/nma',requestObject).then(function (result) {
                    console.log('success');
                    if (onSuccess!==undefined){
                        onSuccess(result);
                    }
                    return NMAObject;
                },function (error) {
                    if (onError!==undefined){
                        onError(error);
                    }
                    console.log('error');
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('newservicedashboard', {
            parent: 'app',
            url: '/newservicedashboard',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_DESK_OFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/newservicedashboard/newservicedashboard.html',
                    controller: 'NewservicedashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        })
        .state('clearancecharts', {
                    parent: 'newservicedashboard',
                    url: '/clearancecharts/{departmentid}',
                    data: {
                        authorities: []
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/newservicedashboard/clearancecharts.html',
                            controller: 'ClearancechartsController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                    $translatePartialLoader.addPart('dashboard');
                                    return $translate.refresh();
                                }]
                            }
                        }).result.then(function() {
                            $state.go('newservicedashboard', null, { reload: 'servicedashboard' });
                        }, function() {
                            $state.go('newservicedashboard');
                        });
                    }]
                });

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Newservicedashboard', Newservicedashboard);

    Newservicedashboard.$inject = ['$resource'];

    function Newservicedashboard ($resource) {
        var resourceUrl =  'api/newdeptservicedashboard/:fromdate/:todate';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();



(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewservicedashboardController', NewservicedashboardController);

   NewservicedashboardController.$inject = ['$filter','Newservicedashboard','Clearancecharts'];

    function NewservicedashboardController ($filter,Newservicedashboard,Clearancecharts) {
        var vm = this;

        vm.datePickerOpenStatus = {};
        vm.sortingdates={};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        vm.selectedDate=selectedDate;
        var d=null;
        function openCalendar (date) {
        vm.datePickerOpenStatus[date] = true;
        }

        vm.dateOptions = {
            minDate: new Date("05-01-2017"),
            maxDate: Date.now()
        };

        function selectedDate(dateSelected){
            var newDate = new Date(dateSelected);
            newDate.setDate(newDate.getDate()+30);

            if(newDate > Date.now()){
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: Date.now()
                };
            }
            else {
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: newDate
                };
            }
        }




        vm.getAverageClearance=function (deptdata,status) {
            Clearancecharts.putClearanceData(null,deptdata,status);
        };
       vm.viewcharts=function(departmentname,servicestats,status){
       Clearancecharts.putClearanceData(departmentname,servicestats,status);
       };

        vm.getServicesBetweenDates=function(){
            vm.newdashboards = null;
            var fromdate=$filter('date')(vm.fromdate, "dd-MM-yyyy");
            var todate=$filter('date')(vm.todate, "dd-MM-yyyy");
            Newservicedashboard.query({fromdate:fromdate,todate:todate},onSuccess,OnError);
        }

        function onSuccess(result) {
            vm.newdashboards=result;
            for (var i=0;i<vm.newdashboards.length;i++){
                if (vm.newdashboards[i].deptname==='DAKSHIN HARYANA BIJLI VITRAN NIGAM'){
                    vm.newdashboards[i].deptorder=1;

                }
                if (vm.newdashboards[i].deptname==='UTTAR HARYANA BIJLI VITRAN NIGAM'){
                    vm.newdashboards[i].deptorder=2;

                }
                if (vm.newdashboards[i].deptname==='HARYANA URBAN DEVELOPMENT AUTHORITY'){
                    vm.newdashboards[i].deptorder=3;

                }
                if (vm.newdashboards[i].deptname==='LABOUR DEPARTMENT - FACTORY WING'){
                    vm.newdashboards[i].deptorder=10;

                }
                if (vm.newdashboards[i].deptname==='LABOUR DEPARTMENT - LABOUR WING'){
                    vm.newdashboards[i].deptorder=11;

                }
                if (vm.newdashboards[i].deptname==='TOWN & COUNTRY PLANNING'){
                    vm.newdashboards[i].deptorder=6;

                }
                if (vm.newdashboards[i].deptname==='HARYANA STATE POLLUTION CONTROL BOARD'){
                    vm.newdashboards[i].deptorder=8;

                }
                if (vm.newdashboards[i].deptname==='URBAN LOCAL BODIES'){
                    vm.newdashboards[i].deptorder=9;

                }
                if (vm.newdashboards[i].deptname==='DEPARTMENT OF INDUSTRIES & COMMERCE'){
                    vm.newdashboards[i].deptorder=4;
                }

                if (vm.newdashboards[i].deptname==='HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD'){
                    vm.newdashboards[i].deptorder=5;
                }
            }

        }

        function OnError() {
            alert("Please enter a period  between 31 days ");
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Clearancecharts', Clearancecharts);

    Clearancecharts.$inject = [];

    function Clearancecharts () {
        var deptname;
        var serviceStats;
        var Status;
        return {
            putClearanceData:function(departmentname,servicestats,status){
               deptname=departmentname;
               serviceStats=servicestats;
               Status=status;
            },
            getdepartmentname:function(){
                return deptname;
            },
            getservicestats:function(){
                return serviceStats;
            },
            getStatus:function(){
                return Status;
            }

        }
    }
})();

(function () {
        'use strict';

        angular
            .module('investhryApp')
            .controller('ClearancechartsController', ClearancechartsController);

        ClearancechartsController.$inject = ['Clearancecharts', '$uibModalInstance'];

        function ClearancechartsController(Clearancecharts, $uibModalInstance) {
            var vm = this;
            vm.services = [];
            vm.isService = false;
            vm.isTotal = false;
            vm.averageTime = [];
            vm.clear = clear;
            vm.options = {legend: {display: true, position: 'bottom'}};
            loadCharts();

            function loadCharts() {
                if (Clearancecharts.getStatus() === 'SERVICE') {
                    loadServices();
                } else {
                    loadDept();
                }
            }

            function clear() {
                $uibModalInstance.close();
            }

            function loadServices() {
                vm.departmentname = Clearancecharts.getdepartmentname();
                vm.servicestats = Clearancecharts.getservicestats();
                vm.isService = true;
                for (var i = 0; i < vm.servicestats.length; i++) {
                    vm.services.push(vm.servicestats[i].servicename);
                    if (vm.servicestats[i].averageClearanceTime === 'NA') {
                        vm.averageTime.push(0);
                    } else {
                        vm.averageTime.push(parseInt(vm.servicestats[i].averageClearanceTime));
                    }
                }
            }

            function loadDept() {
                vm.deptData = Clearancecharts.getservicestats();
                vm.isTotal = true;
                for (var i=0;i<vm.deptData.length;i++){
                    vm.services.push(vm.deptData[i].deptname);
                    var sum=0;
                    var totalCleared=0;
                    for (var j=0;j<vm.deptData[i].newServiceStats.length;j++){
                        if (vm.deptData[i].newServiceStats[j].averageClearanceTime!=='NA'){
                            sum=sum+parseInt(vm.deptData[i].newServiceStats[j].averageClearanceTime);
                            totalCleared++;
                        }
                    }
                    vm.averageTime.push(Math.round(sum/totalCleared));
                }
            }
        }
    })();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('newdeptservicedashboard', {
            parent: 'app',
            url: '/newdeptservicedashboard',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/newdeptservicedashboard/newdeptservicedashboard.html',
                    controller: 'NewDeptservicedashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        });
       
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Newdeptservicedashboard', Newdeptservicedashboard);

    Newdeptservicedashboard.$inject = ['$resource'];

    function Newdeptservicedashboard ($resource) {
        var resourceUrl =  'api/newservicedashboards/:name';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();



(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDeptservicedashboardController', NewDeptservicedashboardController);

   NewDeptservicedashboardController.$inject = ['$scope', 'Principal', 'LoginService', '$state','Newdeptservicedashboard'];

    function NewDeptservicedashboardController ($scope, Principal, LoginService, $state,Newdeptservicedashboard) {
        var vm = this;

       vm.account=null;
       vm.isLabourActive=true;
       vm.Department='HSPCB';
       vm.loadAll=loadAll;
       loadAll('HSPCB');

       function loadAll(name){
            vm.Department=name + " Department";
            vm.newdeptservicedashboard={};
            Newdeptservicedashboard.query({name:name},function(result){
                vm.newdeptservicedashboard= result;
            });
       }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('newDashboard', {
            parent: 'app',
            url: '/newDashboard',
            data: {
                authorities: ["ROLE_ADMIN","ROLE_SUB_ADMIN"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/newDashboard/mainView.html',
                    controller: 'NewDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('newDashboard');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('NewDashboardStats', NewDashboardStats);

    NewDashboardStats.$inject = ['$resource'];

    function NewDashboardStats ($resource) {
        var resourceUrl =  'api/newDashboard';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDashboardController', NewDashboardController);

    NewDashboardController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'NewDashboardStats', 'NewDasboardAllCompletedStats'];

    function NewDashboardController ($scope, Principal, LoginService, $state, NewDashboardStats, NewDasboardAllCompletedStats) {
        var vm = this;
//        vm.yesterday = new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1);
        vm.newDashboardStats = [];
        vm.newDashboardAllCompleteStats = [];
        NewDashboardStats.query(function(result){
            vm.newDashboardStats = result;
        });
        NewDasboardAllCompletedStats.query(function(result){
            vm.newDashboardAllCompleteStats = result;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('msmePolicies', {
            parent: 'app',
            url: '/msmePolicies',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/msmePolicies/msmePolicies.html',
                    controller: 'MsmePoliciesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MsmePolicies', MsmePolicies);

    MsmePolicies.$inject = ['$resource'];

    function MsmePolicies ($resource) {
        var resourceUrl =  'api/msmePolicies';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MsmePoliciesController', MsmePoliciesController);

    MsmePoliciesController.$inject = ['MsmePolicies', '$stateParams','$scope', '$state','IncentiveForm', 'Principal', 'LoginService'];

    function MsmePoliciesController(MsmePolicies, $stateParams,$scope, $state, IncentiveForm, Principal, LoginService) {

        var vm = this;
        vm.url = null;
        vm.isAuthenticated = Principal.isAuthenticated;
        IncentiveForm.query(function(result){
            vm.userdetails=result;
        });

        vm.setUrl = function (url) {
            vm.url = $sce.trustAsResourceUrl(url);
        };

        vm.login = function login() {
            LoginService.open();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('moveCaf', {
            parent: 'app',
            url: '/move/{type}',
            data: {
                authorities: ['ROLE_ADMIN', 'ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/moveCafLogin/moveCafLogin.html',
                    controller: 'MoveCafLoginController',
                    controllerAs: 'vm'
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MoveCafLoginService', MoveCafLoginService);

    MoveCafLoginService.$inject = ['$resource'];

    function MoveCafLoginService ($resource) {
        var resourceUrl =  'api/moveCafLogin/:login/:cafpin';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MoveGrievanceLoginService', MoveGrievanceLoginService);

    MoveGrievanceLoginService.$inject = ['$resource'];

    function MoveGrievanceLoginService ($resource) {
        var resourceUrl =  'api/moveGrievanceLogin/:login/:grievance';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MoveCafLoginController', MoveCafLoginController);

    MoveCafLoginController.$inject = ['$scope','$filter', 'Principal','MoveCafLoginService','User','SearchCAF', 'SearchGrievance','MoveGrievanceLoginService','$stateParams'];

    function MoveCafLoginController ($scope,$filter, Principal, MoveCafLoginService, User,SearchCAF, SearchGrievance,MoveGrievanceLoginService,$stateParams) {
        var vm = this;
        vm.user = {};
        vm.tabSelected = $stateParams.type;
        vm.showCafpinBlock = false;
        vm.showGrievanceBlock = false;
        vm.grievanceID = '';
        loadAll();
        function loadAll() {
            Principal.identity().then(function (account) {
                vm.account = account;
            });
        }
        vm.findUser = function (user) {
            vm.user = {};
            User.get({login: user},function (result) {
                vm.user = result;
            }, function (error) {
                alert('User Not Found');
                console.log(error);
            })
        };
        vm.confirm = function () {
             vm.showCafpinBlock = true;
        }
        vm.grievanceConfirm = function () {
             vm.showGrievanceBlock = true;
        }
        vm.moveCaf = function (cafPin) {
            MoveCafLoginService.get({login: vm.user.login, cafpin: cafPin}, function (result) {
                if(result.success){
                    $('#confirmCaf').modal('hide');
                    alert('Caf Successfully Moved');
                    vm.user = {};
                    vm.showCafpinBlock = false;
                    vm.cafPin = '';
                    vm.userLogin = '';
                }
            })
        }
        vm.moveGrievance = function () {
            MoveGrievanceLoginService.get({login: vm.user.login, grievance:vm.grievanceID}, function (result) {
                if(result.success){
                    $('#confirmgrievance').modal('hide');
                    alert('Grievance Successfully Moved');
                    vm.user = {};
                    vm.showGrievanceBlock = false;
                    vm.grievanceID = '';
                    vm.userLogin = '';
                }
            })
        }
        vm.confirmProject = function () {
            SearchCAF.get({CAFPIN:vm.cafPin},function(result) {
                vm.cafresult = result;
                if(vm.cafresult.userLogin !== vm.user.login){
                    $('#confirmCaf').modal('show');
                }else {
                    alert(vm.cafresult.userLogin + " already has a caf with cafpin " + vm.cafPin)
                }
            });
        };
        vm.confirmGrievance = function () {
            SearchGrievance.get({grievance:vm.grievanceID},function(result){
                vm.grievance = result;
                if(vm.grievance.grievanceBy !== vm.user.login){
                    $('#confirmgrievance').modal('show');
                }else {
                    alert(vm.grievance.grievanceBy + " already has a grievance with id " + vm.grievanceID)
                }
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('UHBVNAutoRequiredRecord', UHBVNAutoRequiredRecord);

    UHBVNAutoRequiredRecord.$inject = ['$resource'];

    function UHBVNAutoRequiredRecord ($resource) {
        var resourceUrl =  '/api/UHBVNmigrationAutoRequired/:projectId/:serviceId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UHBVNAutoRequired', UHBVNAutoRequired);

    UHBVNAutoRequired.$inject = ['$scope', 'Principal', 'LoginService', '$state','UHBVNAutoRequiredRecord'];

    function UHBVNAutoRequired($scope, Principal, LoginService, $state, UHBVNAutoRequiredRecord ) {

        var vm = this;
        vm.record = {};
        vm.projectId = null;
        vm.serviceId = null;
        vm.migrateDataUHBVN = migrateDataUHBVN;

        function migrateDataUHBVN () {
            vm.record= UHBVNAutoRequiredRecord.get({projectId:vm.projectId,serviceId:vm.serviceId},function () {
               console.log(vm.record);
            });



        }
    }
 })();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TicketScheduler', TicketScheduler);

    TicketScheduler.$inject = ['$resource'];

    function TicketScheduler ($resource) {
        var resourceUrl =  'api/ticketscheduler/:action';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ShareAllDataMOU', ShareAllDataMOU);

    ShareAllDataMOU.$inject = ['$resource'];

    function ShareAllDataMOU ($resource) {
        var resourceUrl =  '/api/sharealldatamou';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SetTowerDatesToNull', SetTowerDatesToNull);

    SetTowerDatesToNull.$inject = ['$resource'];

    function SetTowerDatesToNull ($resource) {
        var resourceUrl =  '/api/settowerdatestonull';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SetStatusDates', SetStatusDates);

    SetStatusDates.$inject = ['$resource'];

    function SetStatusDates ($resource) {
        var resourceUrl =  '/api/setstatusdates';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SetGrievanceAttachmentNull', SetGrievanceAttachmentNull);

    SetGrievanceAttachmentNull.$inject = ['$resource'];

    function SetGrievanceAttachmentNull ($resource) {
        var resourceUrl =  '/api/setgrievanceattachmentnull';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateServiceDahboradToElastic', MigrateServiceDahboradToElastic);

    MigrateServiceDahboradToElastic.$inject = ['$resource'];

    function MigrateServiceDahboradToElastic ($resource) {
        var resourceUrl =  '/api/migrateservicedashboardtoelastic';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SaveMultipleUserWithSingleMail', SaveMultipleUserWithSingleMail);

    SaveMultipleUserWithSingleMail.$inject = ['$resource'];

    function SaveMultipleUserWithSingleMail ($resource) {
        var resourceUrl =  '/api/saveuserswithsamemail';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectElasticData', ProjectElasticData);

    ProjectElasticData.$inject = ['$resource'];

    function ProjectElasticData ($resource) {
        var resourceUrl =  '/api/migrateprojectstoelastic';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MultipleUserWithSingleMailWithoutCaf', MultipleUserWithSingleMailWithoutCaf);

    MultipleUserWithSingleMailWithoutCaf.$inject = ['$resource'];

    function MultipleUserWithSingleMailWithoutCaf ($resource) {
        var resourceUrl =  '/api/userswithsamemailandwithoutcaf';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MultipleUserWithSingleMailWithCaf', MultipleUserWithSingleMailWithCaf);

    MultipleUserWithSingleMailWithCaf.$inject = ['$resource'];

    function MultipleUserWithSingleMailWithCaf ($resource) {
        var resourceUrl =  '/api/userswithsamemailandwithcaf';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateTicketDashboard', MigrateTicketDashboard);

    MigrateTicketDashboard.$inject = ['$resource'];

    function MigrateTicketDashboard ($resource) {
        var resourceUrl =  '/api/migrateMinMaxData';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateServicelogToReappliedservices', MigrateServicelogToReappliedservices);

    MigrateServicelogToReappliedservices.$inject = ['$resource'];

    function MigrateServicelogToReappliedservices ($resource) {
        var resourceUrl =  '/api/migratedatafromservicelogtoreappliedservices';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateServiceDashboardFlagservices', MigrateServiceDashboardFlagservices);

    MigrateServiceDashboardFlagservices.$inject = ['$resource'];

    function MigrateServiceDashboardFlagservices ($resource) {
        var resourceUrl =  '/api/migrateServiceDashboardFlag';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateRejectionReason', MigrateRejectionReason);

    MigrateRejectionReason.$inject = ['$resource'];

    function MigrateRejectionReason ($resource) {
        var resourceUrl =  '/api/migrateRejectionReason';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateRatingsData', MigrateRatingsData);

    MigrateRatingsData.$inject = ['$resource'];

    function MigrateRatingsData ($resource) {
        var resourceUrl =  '/api/migrateratingsdata';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateRatings', MigrateRatings);

    MigrateRatings.$inject = ['$resource'];

    function MigrateRatings ($resource) {
        var resourceUrl =  '/api/migrateratings';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectToExistingCafSearch', ProjectToExistingCafSearch);

    ProjectToExistingCafSearch.$inject = ['$resource'];

    function ProjectToExistingCafSearch ($resource) {
        var resourceUrl =  '/api/migrateprojecttoexistingcafsearch';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET'
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateProjectServiceCcip', MigrateProjectServiceCcip);

    MigrateProjectServiceCcip.$inject = ['$resource'];

    function MigrateProjectServiceCcip ($resource) {
        var resourceUrl =  '/api/migrateDataForServiceTowerCcip';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateProjectByEmail', MigrateProjectByEmail);

    MigrateProjectByEmail.$inject = ['$resource'];

    function MigrateProjectByEmail ($resource) {
        var resourceUrl =  '/api/projects';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateProjectAssignedData', MigrateProjectAssignedData);

    MigrateProjectAssignedData.$inject = ['$resource'];

    function MigrateProjectAssignedData ($resource) {
        var resourceUrl =  '/api/migrateProjectAssignedData';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateNewDashboardStats', MigrateNewDashboardStats);

    MigrateNewDashboardStats.$inject = ['$resource'];

    function MigrateNewDashboardStats ($resource) {
        var resourceUrl =  '/api/migrateNewDashboardStats';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateNewCafLogs', MigrateNewCafLogs);

    MigrateNewCafLogs.$inject = ['$resource'];

    function MigrateNewCafLogs ($resource) {
        var resourceUrl =  '/api/migratenewcaflogs';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateGrievanceLog', MigrateGrievanceLog);

    MigrateGrievanceLog.$inject = ['$resource'];

    function MigrateGrievanceLog ($resource) {
        var resourceUrl =  '/api/migrategrievancelog';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateGrievanceDashboardOutput', MigrateGrievanceDashboardOutput);

    MigrateGrievanceDashboardOutput.$inject = ['$resource'];

    function MigrateGrievanceDashboardOutput ($resource) {
        var resourceUrl =  '/api/migrate-grievance-dashboard-output';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateGrievance', MigrateGrievance);

    MigrateGrievance.$inject = ['$resource'];

    function MigrateGrievance ($resource) {
        var resourceUrl =  '/api/migrategrievance';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateDuplicateRM', MigrateDuplicateRM);

    MigrateDuplicateRM.$inject = ['$resource'];

    function MigrateDuplicateRM ($resource) {
        var resourceUrl =  '/api/duplicateRecord';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateDistrictNodalOfficer', MigrateDistrictNodalOfficer);

    MigrateDistrictNodalOfficer.$inject = ['$resource'];

    function MigrateDistrictNodalOfficer ($resource) {
        var resourceUrl =  '/api/migratedistrictnodalofficertoindexingtable';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateDatesToServiceDetailFromLog', MigrateDatesToServiceDetailFromLog);

    MigrateDatesToServiceDetailFromLog.$inject = ['$resource'];

    function MigrateDatesToServiceDetailFromLog ($resource) {
        var resourceUrl =  '/api/migratedatestoservicedetailfromlog';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateProjectServiceDetailToIndex', MigrateProjectServiceDetailToIndex);

    MigrateProjectServiceDetailToIndex.$inject = ['$resource'];

    function MigrateProjectServiceDetailToIndex ($resource) {
        var resourceUrl =  '/api/migrateDataFromProjectServiceDetailToIndex';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateProjectServiceDetailToElastic', MigrateProjectServiceDetailToElastic);

    MigrateProjectServiceDetailToElastic.$inject = ['$resource'];

    function MigrateProjectServiceDetailToElastic ($resource) {
        var resourceUrl =  '/api/migrateDataFromProjectServiceDetailToElasticIndex';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('migratedata', {
            parent: 'app',
            url: '/migratedata',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/migratedata/migratedata.html',
                    controller: 'MigrateDataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('indexMigrateData', {
                    parent: 'app',
                    url: '/indexMigrateData',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/migratedata/indexMigrateData.html',
                            controller: 'IndexMigrateDataController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                 }]
             }
        })
    .state('uhbvnAutoRequired', {
            parent: 'app',
            url: '/uhbvnAutoRequired',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/migratedata/uhbvnAutoRequired.html',
                    controller: 'UHBVNAutoRequired',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateData', MigrateData);

    MigrateData.$inject = ['$resource'];

    function MigrateData ($resource) {
        var resourceUrl =  '/api/migratedata';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MigrateDataController', MigrateDataController);

    MigrateDataController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'MigrateData', 'MigrateApplicationDate', 'Service_dashboard_output', 'MigrateDashboardBetweenDatesCAFs', 'GrievanceDashboardOutput', 'MigrateDashboardBetweenDates', 'SetTrue', 'Totalservicedashboarddetails', 'SetGrievanceAttachmentNull', 'Tower_service_dashboard', 'ShareAllDataMOU', 'District', 'Department', 'filterFilter', 'Towerofficerlist', 'ManageDuplicate', 'grievanceReAssign', 'MigrateNewDashboardStats', 'BulkEmail', 'Cafservicestatus', 'ViewServiceStatus', 'MigrateRatingsData','ReApplyReDashboardMigrate', 'MigrateRatings','MigrateProjectByEmail', 'SaveMultipleUserWithSingleMail', 'MultipleUserWithSingleMailWithoutCaf', 'TicketsLogs','MultipleUserWithSingleMailWithCaf','ExistingCafToZero','MigrateNewCafLogs', 'MigrateDistrictNodalOfficer','ProjectToExistingCafSearch','MigrateHomePageCounts','MigrateDatesToServiceDetailFromLog', 'MigrateServicelogToReappliedservices','MigrateServiceDashboardFlagservices', 'ServiceDashboardStats','MigrateProjectServiceDetailToIndex', 'DraftHavingServices', 'SetTowerDatesToNull', 'SetStatusDates','MigrateRejectionReason','ProjectElasticData','MigrateDuplicateRM', 'AssignProjectToRM', 'TicketScheduler','MigrateProjectServiceDetailToElastic','MigrateServiceDahboradToElastic', 'MigrateTicketDashboard','MigrateCcip', 'MigrateProjectServiceCcip'];

    function MigrateDataController($scope, Principal, LoginService, $state, MigrateData, MigrateApplicationDate, Service_dashboard_output, MigrateDashboardBetweenDatesCAFs, GrievanceDashboardOutput, MigrateDashboardBetweenDates, SetTrue, Totalservicedashboarddetails, SetGrievanceAttachmentNull, Tower_service_dashboard, ShareAllDataMOU, District, Department, filterFilter, Towerofficerlist, ManageDuplicate, grievanceReAssign, MigrateNewDashboardStats, BulkEmail, Cafservicestatus, ViewServiceStatus, MigrateRatingsData,ReApplyReDashboardMigrate, MigrateRatings,MigrateProjectByEmail, SaveMultipleUserWithSingleMail, MultipleUserWithSingleMailWithoutCaf, TicketsLogs,MultipleUserWithSingleMailWithCaf, ExistingCafToZero,MigrateNewCafLogs, MigrateDistrictNodalOfficer, ProjectToExistingCafSearch, MigrateHomePageCounts,MigrateDatesToServiceDetailFromLog, MigrateServicelogToReappliedservices,MigrateServiceDashboardFlagservices, ServiceDashboardStats,MigrateProjectServiceDetailToIndex, DraftHavingServices, SetTowerDatesToNull, SetStatusDates,MigrateRejectionReason,ProjectElasticData , MigrateDuplicateRM, AssignProjectToRM, TicketScheduler,MigrateProjectServiceDetailToElastic, MigrateServiceDahboradToElastic, MigrateTicketDashboard, MigrateCcip, MigrateProjectServiceCcip) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.migrate_project_elastic_data = migrate_project_elastic_data;
        vm.migratedashboardbetweendatescafsdata = migratedashboardbetweendatescafsdata;
        vm.migratedashboardbetweendatesdata = migratedashboardbetweendatesdata;
        vm.setAttachmentNull = setAttachmentNull;
        vm.migrate_reapply_dashboard_data = migrate_reapply_dashboard_data;

        //vm.migrate_ticket_dashboard_elastic_data = migrate_ticket_dashboard_elastic_data;

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });
        loadAll();

        vm.migratedata = migratedata;
        vm.migrate_service_dashboard_data = migrate_service_dashboard_data;

        vm.migrateGrievanceDashboardData = migrateGrievanceDashboardData;

        vm.migrate_nodalofficer_dashboard_data = migrate_nodalofficer_dashboard_data;

        vm.setisrequiredtotrue = setisrequiredtotrue;

        vm.migrateCafServiceStatus = migrateCafServiceStatus;

        vm.migrateApplicationDate = migrateApplicationDate;

        function loadAll() {
            District.query(function (result) {
                vm.districts = result;
                vm.searchQuery = null;
            });
            Department.query(function (result) {
                vm.departments = filterFilter(result, {istower: true});
                vm.searchQuery = null;
            });
            Towerofficerlist.query(function (result) {
                vm.towerofficerlists = result;
                vm.searchQuery = null;
            });
        }

        function migratedata() {
            MigrateData.save();
        }

        function migrate_service_dashboard_data() {
            Service_dashboard_output.query({migrate: 'migrate'});
        }
        function migrate_project_elastic_data() {
            ProjectElasticData.query({migrate: 'migrate'});
        }

        function migrateGrievanceDashboardData() {
            GrievanceDashboardOutput.query({migrate: 'migrate'});
        }

        function migrate_nodalofficer_dashboard_data() {
            MigrateData.get();
        }
        function migrate_reapply_dashboard_data() {
            ReApplyReDashboardMigrate.get();
        }

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register() {
            $state.go('register');
        }

        function migratedashboardbetweendatescafsdata() {
            MigrateDashboardBetweenDatesCAFs.get();
        }

        function migratedashboardbetweendatesdata() {
            MigrateDashboardBetweenDates.get();
        }

        function setisrequiredtotrue() {
            SetTrue.get();
        }


        vm.migrate_min_max_to_Elastic = function () {
            MigrateTicketDashboard.query();
        };

        vm.migrateTotalDashboardData = function () {
            Totalservicedashboarddetails.query({migrate: 'migrate'});
        };

        vm.migrate_tower_service_dashboard_data1 = function () {
            Tower_service_dashboard.query({migrate: 'migrate1'});
        };

        vm.migrate_tower_service_dashboard_data2 = function () {
            Tower_service_dashboard.query({migrate: 'migrate2'});
        };

        vm.setReapplyCounter = function () {
            Tower_service_dashboard.query({migrate: 'migrate3'});
        };

        vm.setDepartmentByChoice = function () {
            Tower_service_dashboard.save({id: '1'}, vm.data);
        };

        vm.migrateIntegrationData = function () {
            Tower_service_dashboard.query({migrate: 'migrate4'});
        };

        function setAttachmentNull() {
            SetGrievanceAttachmentNull.query();
        }

        vm.shareAllDataToMou = function () {
            ShareAllDataMOU.get();
        };

        vm.showDuplicate = function (dept) {
            vm.duplicateIds = null;
            ManageDuplicate.query(function (result) {
                vm.duplicateIds = result;
            });
        };

        vm.reAssignGrievance = function () {
            grievanceReAssign.get({
                assignby: vm.assignBy,
                grievanceId: vm.grievanceid,
                assignto: vm.assignto,
                assigndate: vm.assigndate
            }, onsuccess);
        };

        vm.migrateGrievancewithAssignBy = function () {
            grievanceReAssign.query(onsuccess);
        };

        function onsuccess(result) {
            vm.duplicateIds = result;
            console.log(result);
        }

        vm.migrateNewDashboardStats = function () {
            console.log("now migrating...");
            MigrateNewDashboardStats.get();
        }

        function migrateCafServiceStatus() {
            console.log("now migrating...");
            Cafservicestatus.query({cafpin: '678789'});

            vm.fireBulkEmails = function () {
                console.log("fired bulk emails...");
                BulkEmail.get();
            }

            vm.testFireBulkEmails = function () {
                console.log("test fire bulk email...");
                BulkEmail.get({test: "test"});
            }
        }

        function migrateApplicationDate() {
            MigrateApplicationDate.get();
        }


        vm.migratePreviousServiceStats = function () {
            ViewServiceStatus.query({migrateData: 'migrateData'});
        }

        vm.migrateServiceStatusData = function () {
            ViewServiceStatus.query({serviceStatusTable:'serviceStatusTable'})

        }

        vm.migrateRatingsData = function(){
            MigrateRatingsData.get();
        }

        vm.migrateRatings = function(){
            MigrateRatings.get();
        }

        vm.saveMultipleUsersWithSingleMail = function(){
            SaveMultipleUserWithSingleMail.query();
        }
        vm.saveMultipleUserWithSingleMailWithoutCaf = function(){
            MultipleUserWithSingleMailWithoutCaf.query();
        }
        vm.saveMultipleUserWithSingleMailWithCaf = function(){
            MultipleUserWithSingleMailWithCaf.query();
        }


        vm.migrateProjectByEmail = function () {
            MigrateProjectByEmail.query({migrateProjectByEmail:'migrateProjectByEmail'});
        }

        vm.migrateHepcTicketlogsData = function (action) {
            TicketsLogs.query({migrateData: action}, function (result) {
                    vm.migrateData = result;
                    alert("success");
                }, function () {
                    alert("error");
                });
        };

        vm.migrateExistingCafsToZero = function () {
            ExistingCafToZero.get(function (data) {
                alert('Migration Done');
            });
        };

        vm.migrateNewCafLogs = function(){
            MigrateNewCafLogs.get();
        };
        vm.migrateHomePageCounts = function() {
            MigrateHomePageCounts.get(function (data) {
                alert('Migration Done');
            });
        };
        vm.migrateDistrictNodalOfficer = function(){
            MigrateDistrictNodalOfficer.get();
        };

        vm.projectToExistingCafSearch = function(){
            ProjectToExistingCafSearch.get(function (data) {
                alert('Migration Done');
            });
        };
        vm.migrateDatesToServiceDetailfromLog = function(){
            MigrateDatesToServiceDetailFromLog.get();
        };
        vm.migrateServicelogToReappliedservices = function(){
            MigrateServicelogToReappliedservices.get();
        };
        vm.migrate_service_dashboard_april_2018 = function () {
            ServiceDashboardStats.query({migrate: 'NA'}, function (data) {
                alert('Migration Done');
                console.log(data);
            })
        };
        vm.migrateProjectServiceDetailToIndex = function () {
            MigrateProjectServiceDetailToIndex.query(function () {
                alert('Migration Done');
            })
        };

        vm.migrate_projectservicedetail_elastic_data = function (){
            MigrateProjectServiceDetailToElastic.query(function () {
                alert('Migration Done');
            })
        };
        vm.removeServiceFromDashboardFlag = function(){
            MigrateServiceDashboardFlagservices.get();
        };
        vm.setTowerDatesToNull = function(){
           SetTowerDatesToNull.get();
        };

        vm.calculateDraftsHavingServices = function () {
            DraftHavingServices.get();
        };
        vm.setStatusDates = function(){
            SetStatusDates.get();
        };
        vm.saveRejectionReason = function () {
            MigrateRejectionReason.query({status:'Declined'});
        };

        vm.migrateAssignedRM = function () {
            MigrateDuplicateRM.query({delete:'Duplicate'});
        };

        vm.deleteMultipleRecordsWithSameProjectid = function () {
            AssignProjectToRM.get({multiplerecords:'multiplerecords'});
        };

        vm.openTicketSchedular = function () {
            TicketScheduler.get({ action: "open"}, function () {
                swal("Success!", "Schedular execution completed.!", "success");
            }, function () {
                swal("Error!", "Something bad happened!", "error");
            });
        };

        vm.closeTicketSchedular = function () {
            TicketScheduler.get({ action: "close"}, function () {
                swal("Success!", "Schedular execution completed.!", "success");
            }, function () {
                swal("Error!", "Something bad happened!", "error");
            });
        }

        vm.ccipdata = function () {
            MigrateCcip.get({ action: "close"}, function () {
                swal("Success!", "Schedular execution completed.!", "success");
            }, function () {
                swal("Error!", "Something bad happened!", "error");
            });
        }
        vm.projectServiceCcipdata = function () {
            MigrateProjectServiceCcip.get({ action: "close"}, function () {
                swal("Success!", "Schedular execution completed.!", "success");
            }, function () {
                swal("Error!", "Something bad happened!", "error");
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateDashboardBetweenDatesCAFs', MigrateDashboardBetweenDatesCAFs);

    MigrateDashboardBetweenDatesCAFs.$inject = ['$resource'];

    function MigrateDashboardBetweenDatesCAFs ($resource) {
        var resourceUrl =  '/api/migratedashboardbetweendatescafs';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
//                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateDashboardBetweenDates', MigrateDashboardBetweenDates);

    MigrateDashboardBetweenDates.$inject = ['$resource'];

    function MigrateDashboardBetweenDates ($resource) {
        var resourceUrl =  '/api/migratedashboardbetweendates';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
//                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateCcip', MigrateCcip);

    MigrateCcip.$inject = ['$resource'];

    function MigrateCcip ($resource) {
        var resourceUrl =  '/api/MigrateCcip';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateApplicationDate', MigrateApplicationDate);

    MigrateApplicationDate.$inject = ['$resource'];

    function MigrateApplicationDate ($resource) {
        var resourceUrl =  '/api/migrateApplicationDate';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ManageDuplicate', ManageDuplicate);

    ManageDuplicate.$inject = ['$resource'];

    function ManageDuplicate ($resource) {
        var resourceUrl =  '/api/getprojectids';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SetTrue', SetTrue);

    SetTrue.$inject = ['$resource'];

    function SetTrue ($resource) {
        var resourceUrl =  '/api/settrue';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IndexMigrateDataController', IndexMigrateDataController);

    IndexMigrateDataController.$inject = ['$scope', 'Principal', 'LoginService', '$state','MigrateGrievanceLog', 'MigrateGrievance', 'MigrateGrievanceDashboardOutput' , 'MigrateProjectAssignedData'];

    function IndexMigrateDataController($scope, Principal, LoginService, $state, MigrateGrievanceLog, MigrateGrievance, MigrateGrievanceDashboardOutput, MigrateProjectAssignedData) {

        var vm = this;
        vm.migrate_grievance_log = migrate_grievance_log;
        vm.migrate_grievance = migrate_grievance;
        vm.migrate_grievance_dashboard_output = migrate_grievance_dashboard_output;
        vm.migrate_project_assigned_data = migrate_project_assigned_data ;

        function migrate_grievance_log(){
            MigrateGrievanceLog.save();
        }
        function migrate_grievance(){
            MigrateGrievance.save();
        }
        function migrate_grievance_dashboard_output(){
            MigrateGrievanceDashboardOutput.save();
        }

        function migrate_project_assigned_data (){
            MigrateProjectAssignedData.save();
        }
    }
 })();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateHomePageCounts', MigrateHomePageCounts);

    MigrateHomePageCounts.$inject = ['$resource'];

    function MigrateHomePageCounts ($resource) {
        var resourceUrl =  '/api/home-outputs';

        return $resource(resourceUrl, {}, {
            'get': { method: 'GET', isArray: false},
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('grievanceReAssign', grievanceReAssign);

    grievanceReAssign.$inject = ['$resource'];

    function grievanceReAssign ($resource) {
        var resourceUrl =  '/api/grievancesList/:assignby/:grievanceId/:assignto/:assigndate';

        return $resource(resourceUrl, {}, {
            'get': { method: 'GET', isArray: false},
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DraftHavingServices', DraftHavingServices);

    DraftHavingServices.$inject = ['$resource'];

    function DraftHavingServices ($resource) {
        var resourceUrl =  'api/drafthavingservices';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('BulkEmail', BulkEmail);

    BulkEmail.$inject = ['$resource'];

    function BulkEmail ($resource) {
        var resourceUrl =  'api/firebulkemails/:test';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectcompletedetaildata', Projectcompletedetaildata);

    Projectcompletedetaildata.$inject = ['$resource'];

    function Projectcompletedetaildata ($resource) {
        var resourceUrl =  '/api/CompleteProjectDetailData/:id';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectcompletedetail', Projectcompletedetail);

    Projectcompletedetail.$inject = ['$resource'];

    function Projectcompletedetail ($resource) {
        var resourceUrl =  '/api/CompleteProjectDetail/:id';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('listproject', {
            parent: 'app',
            url: '/listproject',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/listproject/listproject.html',
                    controller: 'listprojectController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('listproject');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('listprojectController', listprojectController);

    listprojectController.$inject = ['$scope','$state', 'Projectlist', 'Project', 'Survey', 'Sector', 'DistrictVillageBlockMapping', 'Principal', '$filter'];

    function listprojectController($scope, $state, Projectlist , Project, Survey, Sector, DistrictVillageBlockMapping, Principal, $filter) {
        var vm = this;
        vm.accout = null;
        vm.project=Project;
        vm.onBack = onBack;
        vm.hideApp=hideApp;
        vm.project = {};
        vm.survey = {};
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.currentProject = currentProject;
        vm.total_ground_investment = null;
        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";

        vm.datePickerOpenStatus.prodctionStartDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        loadAll();

        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;

                if (account.authorities.includes("ROLE_ADMIN") || account.authorities.includes("ROLE_SUB_ADMIN")) {
                    return;
                }

                if (account.authorities.includes("ROLE_USER")) {
                    if (!Projectlist.projectListUser || !Projectlist.projectListUser.query) {
                        console.error("Projectlist.projectListUser.query is undefined!");
                        return;
                    }

                    Projectlist.projectListUser.query({ page: $scope.currentPage - 1, size: $scope.pageSize }, function(result) {
                        processProjectList(result);
                    });
                } else {
                    if (!Projectlist.projectList || !Projectlist.projectList.query) {
                        console.error("Projectlist.projectList.query is undefined!");
                        return;
                    }

                    Projectlist.projectList.query({ id: "1", status: "All" }, function(result) {
                        processProjectList(result);
                    });
                }
            });
        }

        function processProjectList(result) {
            vm.totalElements = result.totalElements;
            if (result.content) {
                for (var i = 0; i < result.content.length; i++) {
                    if (result.content[i].caftype === 'FILMCAF') {
                        result.content[i].caftype = 'Film';
                    } else if (result.content[i].caftype === 'LandExchange') {
                        result.content[i].caftype = 'Land';
                    } else if (result.content[i].caftype === 'Renewable') {
                        result.content[i].caftype = 'Renew';
                    }
                }

                vm.projectlistNA = $filter('filter')(result.content, { isdraft: true });
                vm.projectlistFinal = $filter('filter')(result.content, { isdraft: false });
            } else {
                console.error("Result content is undefined!");
            }
        }



        vm.surveyFormOptions = function (projectObj) {

            if(projectObj.caftype === 'New' && projectObj.applicationDate < "2018-09-18"){
                Survey.get({id: projectObj.projectid},OnSurveyFindSuccess, OnSurveyFindError);
                currentProject(projectObj);
            }
            else {

                $state.go('projectdetailjist',{projectid:projectObj.projectid});
            }
        };

        function OnSurveyFindSuccess(result) {
            if(result.investmentDate !== null){
                $state.go('projectdetailjist',{projectid:result.id})
            }
            else {
                UIkit.modal('#Next-modal').show();
            }
        }

        function OnSurveyFindError() {
            UIkit.modal('#details-modal').show();
        }

        function currentProject(projectObj){
            vm.survey = {};
            Project.get({id: projectObj.projectid},function(result){
                vm.project = result;
                vm.project.prodctionStartDate = new Date(result.prodctionStartDate);

                DistrictVillageBlockMapping.query({id: '1',districtName: result.district},function(result) {
                    vm.villages = result;
                    vm.searchQuery = null;
                });
                vm.foreigninvestment_in_crores = calculateforeignInvestmentInCrore(vm.project);
                vm.foreigninvestment_in_lacs = calculateforeignInvestmentInlacs(vm.project);
                vm.foreigninvestment_in_thousands = calculateforeignInvestmentInThousands(vm.project);
                showForeign_investment(vm.project);
            });
            Sector.query(function(result) {
                vm.sectors = result;
                vm.searchQuery = null;
            });
        }

        function showForeign_investment(project) {
            if(project.foreign_investment !== null && project.foreign_investment !== 0){
                vm.radioToggle = 'Yes';
                vm.showFDI = true;
            }
            else if(project.foreign_investment === null || project.foreign_investment === 0){
                vm.radioToggle = 'No';
                vm.showFDI = false;
            }
        }

        function calculateforeignInvestmentInCrore (project) {
            if((project.foreign_investment !== 0) && (project.foreign_investment !== null)){
                return parseInt(project.foreign_investment.toString().split('.')[0]);
            }
        }

        function calculateforeignInvestmentInlacs (project) {
            if((project.foreign_investment !== 0) && (project.foreign_investment !== null)){
                if (project.foreign_investment.toString().indexOf('.') !== -1) {
                    return parseInt(project.foreign_investment.toString().split('.')[1].substring(0, 2));
                }
                return 0;
            }
        }

        function calculateforeignInvestmentInThousands (project) {
            if((project.foreign_investment !== 0) && (project.foreign_investment !== null)){
                if (project.foreign_investment.toString().indexOf('.') !== -1) {
                    return parseInt(project.foreign_investment.toString().split('.')[1].substring(2, 4));
                }
                return 0;
            }
        }

        vm.setBlockCategory = function (villageName, villageList) {
            vm.villageNames =[];
            angular.forEach(villageList, function(value, key){
                vm.villageNames.push(value.village);
            });
            if(vm.villageNames.indexOf(villageName) !== -1){
                vm.invalidVillage = false;
                vm.project.blockCategory = villageList[vm.villageNames.indexOf(villageName)].category;
            }
            else {
                vm.invalidVillage = true;
            }
        };

        vm.changeInForeignInvestment = function(){
            var projectCostInCrore = vm.foreigninvestment_in_crores || '00';
            var projectCostInLacs = vm.foreigninvestment_in_lacs || '00' ;
            var projectCostInThousands = vm.foreigninvestment_in_thousands ||'00';
            if(vm.foreigninvestment_in_lacs<10){
                projectCostInLacs = '0'+vm.foreigninvestment_in_lacs;
            }
            if(vm.foreigninvestment_in_thousands<10){
                projectCostInThousands = '0'+vm.foreigninvestment_in_thousands;
            }
            return vm.total_foreign_investment = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
        };

        vm.changeInGroundInvestment =function () {
            var projectCostInCrore = vm.ground_investment_in_crore || '00';
            var projectCostInLacs = vm.ground_investment_in_lacs || '00' ;
            var projectCostInThousands = vm.ground_investment_in_thousands ||'00';
            if(vm.ground_investment_in_lacs<10){
                projectCostInLacs = '0'+ vm.ground_investment_in_lacs;
            }
            if(vm.ground_investment_in_thousands<10){
                projectCostInThousands = '0'+ vm.ground_investment_in_thousands;
            }
            return vm.total_ground_investment = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
        };

        vm.save = function (){
            vm.project.foreign_investment = vm.total_foreign_investment;
            Project.update(vm.project, onSaveSuccess, OnSaveError);
        };

        function onSaveSuccess(result){
            UIkit.modal('#Next-modal').show();
            UIkit.modal('#details-modal').hide();
            vm.survey.id = result.id;
            Survey.update(vm.survey);
            vm.isSaving = false;
        }

        function onBack(){
            UIkit.modal('#Next-modal').hide();
            UIkit.modal('#details-modal').show();
        }

        function hideApp(){
            UIkit.modal('#details-modal').hide();
            UIkit.modal('#Next-modal').hide();
        }

        vm.saveSurvey = function(){
            vm.survey.id = vm.project.id;
            vm.survey.groundedInvestment = vm.total_ground_investment;
            Survey.update(vm.survey,onSaveSurveySuccess,OnSaveError);
        };

        function onSaveSurveySuccess(result) {
            UIkit.modal('#Next-modal').hide();
            UIkit.modal('#details-modal').hide();
            $scope.$emit('investhryApp:SurveyUpdate', result);
            vm.isSaving = false;
        }

        function OnSaveError(){
            vm.isSaving = false;
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
            loadAll();
        };

        $scope.pageChangedHandler = function(num) {
            loadAll();
        };

    }
})();




(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectlist', Projectlist);

    Projectlist.$inject = ['$resource'];

    function Projectlist ($resource) {
        var resourceUrl =  '/api/ProjectList/:id/:status';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectcompletedetaildata', Projectcompletedetaildata);

    Projectcompletedetaildata.$inject = ['$resource'];

    function Projectcompletedetaildata ($resource) {
        var resourceUrl =  '/api/CompleteProjectDetailData/:id';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectcompletedetail', Projectcompletedetail);

    Projectcompletedetail.$inject = ['$resource'];

    function Projectcompletedetail ($resource) {
        var resourceUrl =  '/api/CompleteProjectDetail/:id';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectlist', Projectlist);

    Projectlist.$inject = ['$resource'];

    function Projectlist($resource) {
        var resourceUrl = '/api/ProjectList/:id/:status';
        var userResourceUrl = '/api/ProjectListUser/:id/:status';

        return {
            projectList: $resource(resourceUrl, {}, {
                'query': { method: 'GET', isArray: false },
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        return data ? angular.fromJson(data) : data;
                    }
                }
            }),
            projectListUser: $resource(userResourceUrl, {}, {
                'query': { method: 'GET', isArray: false, params: { page: '@page', size: '@size' } },
                'get': {
                    method: 'GET',
                    transformResponse: function (data) {
                        return data ? angular.fromJson(data) : data;
                    }
                }
            })
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('listcompliances', {
            parent: 'app',
            url: '/listcompliances',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/listcompliances/listcompliances.html',
                    controller: 'listcompliancesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('listcompliances');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('listcompliancesController', listcompliancesController);

    listcompliancesController.$inject = ['$scope','$state', 'Projectlist', 'Project', 'Survey', 'Sector', 'DistrictVillageBlockMapping', 'Principal', '$filter'];

    function listcompliancesController($scope, $state, Projectlist , Project, Survey, Sector, DistrictVillageBlockMapping, Principal, $filter) {
        var vm = this;
        vm.accout = null;
        vm.onBack = onBack;
        vm.hideApp=hideApp;
        vm.project = {};
        vm.survey = {};
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.currentProject = currentProject;
        vm.total_ground_investment = null;
        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";

        vm.datePickerOpenStatus.prodctionStartDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        loadAll();

        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;

                if (account.authorities.includes("ROLE_ADMIN") || account.authorities.includes("ROLE_SUB_ADMIN")) {
                    return;
                }

                if (account.authorities.includes("ROLE_USER")) {
                    if (!Projectlist.projectListUser || !Projectlist.projectListUser.query) {
                        console.error("Projectlist.projectListUser.query is undefined!");
                        return;
                    }

                    Projectlist.projectListUser.query({ page: $scope.currentPage - 1, size: $scope.pageSize }, function(result) {
                        processProjectList(result);
                    });
                } else {
                    if (!Projectlist.projectList || !Projectlist.projectList.query) {
                        console.error("Projectlist.projectList.query is undefined!");
                        return;
                    }

                    Projectlist.projectList.query({ id: "1", status: "All" }, function(result) {
                        processProjectList(result);
                    });
                }
            });
        }

        function processProjectList(result) {
            vm.totalElements = result.totalElements;
            if (result.content) {
                for (var i = 0; i < result.content.length; i++) {
                    if (result.content[i].caftype === 'FILMCAF') {
                        result.content[i].caftype = 'Film';
                    } else if (result.content[i].caftype === 'LandExchange') {
                        result.content[i].caftype = 'Land';
                    } else if (result.content[i].caftype === 'Renewable') {
                        result.content[i].caftype = 'Renew';
                    }
                }

                vm.projectlistNA = $filter('filter')(result.content, { isdraft: true });
                vm.projectlistFinal = $filter('filter')(result.content, { isdraft: false });
            } else {
                console.error("Result content is undefined!");
            }
        }

        vm.getYearRange = function(dateString) {
            if (!dateString) return '';

            var date = new Date(dateString);
            var year = date.getFullYear();
            return year + '-' + (year + 1);
        };


        vm.goToProjectDetail = function(id) {
            window.location.href = '/#/complianceprojectdetaillist/' + id;
        };

        vm.surveyFormOptions = function (projectObj) {
            if(projectObj.caftype === 'New' && projectObj.applicationDate < "2018-09-18"){
                Survey.get({id: projectObj.projectid},OnSurveyFindSuccess, OnSurveyFindError);
                currentProject(projectObj);
            }
            else {
                $state.go('projectdetailjist',{projectid:projectObj.projectid});
            }
        };

        function OnSurveyFindSuccess(result) {
            if(result.investmentDate !== null){
                $state.go('projectdetailjist',{projectid:result.id})
            }
            else {
                UIkit.modal('#Next-modal').show();
            }
        }

        function OnSurveyFindError() {
            UIkit.modal('#details-modal').show();
        }

        function currentProject(projectObj){
            vm.survey = {};
            Project.get({id: projectObj.projectid},function(result){
                vm.project = result;
                vm.project.prodctionStartDate = new Date(result.prodctionStartDate);

                DistrictVillageBlockMapping.query({id: '1',districtName: result.district},function(result) {
                    vm.villages = result;
                    vm.searchQuery = null;
                });
                vm.foreigninvestment_in_crores = calculateforeignInvestmentInCrore(vm.project);
                vm.foreigninvestment_in_lacs = calculateforeignInvestmentInlacs(vm.project);
                vm.foreigninvestment_in_thousands = calculateforeignInvestmentInThousands(vm.project);
                showForeign_investment(vm.project);
            });
            Sector.query(function(result) {
                vm.sectors = result;
                vm.searchQuery = null;
            });
        }

        function showForeign_investment(project) {
            if(project.foreign_investment !== null && project.foreign_investment !== 0){
                vm.radioToggle = 'Yes';
                vm.showFDI = true;
            }
            else if(project.foreign_investment === null || project.foreign_investment === 0){
                vm.radioToggle = 'No';
                vm.showFDI = false;
            }
        }

        function calculateforeignInvestmentInCrore (project) {
            if((project.foreign_investment !== 0) && (project.foreign_investment !== null)){
                return parseInt(project.foreign_investment.toString().split('.')[0]);
            }
        }

        function calculateforeignInvestmentInlacs (project) {
            if((project.foreign_investment !== 0) && (project.foreign_investment !== null)){
                if (project.foreign_investment.toString().indexOf('.') !== -1) {
                    return parseInt(project.foreign_investment.toString().split('.')[1].substring(0, 2));
                }
                return 0;
            }
        }

        function calculateforeignInvestmentInThousands (project) {
            if((project.foreign_investment !== 0) && (project.foreign_investment !== null)){
                if (project.foreign_investment.toString().indexOf('.') !== -1) {
                    return parseInt(project.foreign_investment.toString().split('.')[1].substring(2, 4));
                }
                return 0;
            }
        }

        vm.setBlockCategory = function (villageName, villageList) {
            vm.villageNames =[];
            angular.forEach(villageList, function(value, key){
                vm.villageNames.push(value.village);
            });
            if(vm.villageNames.indexOf(villageName) !== -1){
                vm.invalidVillage = false;
                vm.project.blockCategory = villageList[vm.villageNames.indexOf(villageName)].category;
            }
            else {
                vm.invalidVillage = true;
            }
        };

        vm.changeInForeignInvestment = function(){
            var projectCostInCrore = vm.foreigninvestment_in_crores || '00';
            var projectCostInLacs = vm.foreigninvestment_in_lacs || '00' ;
            var projectCostInThousands = vm.foreigninvestment_in_thousands ||'00';
            if(vm.foreigninvestment_in_lacs<10){
                projectCostInLacs = '0'+vm.foreigninvestment_in_lacs;
            }
            if(vm.foreigninvestment_in_thousands<10){
                projectCostInThousands = '0'+vm.foreigninvestment_in_thousands;
            }
            return vm.total_foreign_investment = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
        };

        vm.changeInGroundInvestment =function () {
            var projectCostInCrore = vm.ground_investment_in_crore || '00';
            var projectCostInLacs = vm.ground_investment_in_lacs || '00' ;
            var projectCostInThousands = vm.ground_investment_in_thousands ||'00';
            if(vm.ground_investment_in_lacs<10){
                projectCostInLacs = '0'+ vm.ground_investment_in_lacs;
            }
            if(vm.ground_investment_in_thousands<10){
                projectCostInThousands = '0'+ vm.ground_investment_in_thousands;
            }
            return vm.total_ground_investment = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
        };

        vm.save = function (){
            vm.project.foreign_investment = vm.total_foreign_investment;
            Project.update(vm.project, onSaveSuccess, OnSaveError);
        };

        function onSaveSuccess(result){
            UIkit.modal('#Next-modal').show();
            UIkit.modal('#details-modal').hide();
            vm.survey.id = result.id;
            Survey.update(vm.survey);
            vm.isSaving = false;
        }

        function onBack(){
            UIkit.modal('#Next-modal').hide();
            UIkit.modal('#details-modal').show();
        }

        function hideApp(){
            UIkit.modal('#details-modal').hide();
            UIkit.modal('#Next-modal').hide();
        }

        vm.saveSurvey = function(){
            vm.survey.id = vm.project.id;
            vm.survey.groundedInvestment = vm.total_ground_investment;
            Survey.update(vm.survey,onSaveSurveySuccess,OnSaveError);
        };

        function onSaveSurveySuccess(result) {
            UIkit.modal('#Next-modal').hide();
            UIkit.modal('#details-modal').hide();
            $scope.$emit('investhryApp:SurveyUpdate', result);
            vm.isSaving = false;
        }

        function OnSaveError(){
            vm.isSaving = false;
        }
        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
            loadAll();
        };

        $scope.pageChangedHandler = function(num) {
            loadAll();
        };

    }
})();




(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProceduresController', ProceduresController);

    ProceduresController.$inject = [];

    function ProceduresController () {
        var vm = this;


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('tracklicense', {
            parent: 'app',
            url: '/tracklicense',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/licensetrack/licensetrack.html',
                    controller: 'LicenseTrackController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })

    .state('procedures&Checklist', {
            parent: 'app',
            url: '/procedures&Checklist',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/licensetrack/procedures.html',
                    controller: 'ProceduresController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });

        }
        })();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LicenseTrackController', LicenseTrackController);

    LicenseTrackController.$inject = [];

    function LicenseTrackController () {
        var vm = this;


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('imposedlevies', {
            parent: 'app',
            url: '/imposedlevies',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/leviesimposed/leviesimposed.html',
                    controller: 'ImposedLeviesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ImposedLeviesController', ImposedLeviesController);

    ImposedLeviesController.$inject = [];

    function ImposedLeviesController () {
        var vm = this;
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$location', '$scope', '$state', 'Auth', 'Principal', 'ProfileService', 'LoginService','Minutesofmeeting','downloadserviceformattachment', 'Visitor_count','translationHandler','translationStorageProvider'];

    function NavbarController ($location, $scope, $state, Auth, Principal, ProfileService, LoginService,Minutesofmeeting,downloadserviceformattachment, Visitor_count,translationHandler,translationStorageProvider) {
        var vm = this;
        vm.more = more;
        $scope.selectedLanguage = translationStorageProvider.get('NG_TRANSLATE_LANG_KEY') || 'en'; // Load saved language

        setCookie();

        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

        $scope.changeLanguage = function(langKey) {
            translationHandler.changeLanguage(langKey); // Change language globally
        };

        vm.login = login;
        vm.logout = logout;
        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.$state = $state;
        vm.viewproject = viewproject;

        $scope.isActive = function (viewLocation) {
            return viewLocation === $location.path();
        };
        getcurrentuser();

        function getcurrentuser() {
            Principal.identity().then(function (account) {
                if (account !== null) {
                    vm.account = account;
                    vm.username = account.login;
                    if ((account.firstName === '' || account.firstName === undefined || account.firstName === null) && (account.lastName === '' || account.lastName === undefined || account.lastName === null)) {
                        vm.currentuser = null;
                        return;
                    }
                    vm.currentuser = account.firstName + ' ' + account.lastName;
                }
            });
        }

        // idleTime();
        // function idleTime() {
        //
        //     var idleTime = 0;
        //     $(document).ready(function () {
        //         //Increment the idle time counter every minute.
        //         var idleInterval = setInterval(timerIncrement,60000); // 1 minute
        //
        //         //Zero the idle timer on mouse movement.
        //         $(this).mousemove(function (e) {
        //             idleTime = 0;
        //         });
        //         $(this).keypress(function (e) {
        //             idleTime = 0;
        //         });
        //     });
        //
        //     function timerIncrement() {
        //         idleTime = idleTime + 1;
        //         if (idleTime > 15) {// 30 minutes
        //         logout();
        //         }
        //     }
        // }

        function login() {
            collapseNavbar();
            LoginService.open();
        }

        function viewproject() {
            getAccount();

            function getAccount() {
                Principal.identity().then(function (account) {
                    vm.account = account;
//                        console.log(vm.account);
                    if ((vm.account.id == 3) || (vm.account.id == 'fd782532-e971-4eab-9420-ce2da2538b2f')) {
                        $state.go('viewProjectAdmin');
                    } else {
                        $state.go('viewprojectdetail', {status: 'Pending'});
                    }
                    vm.isAuthenticated = Principal.isAuthenticated;
                });
            }
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('home');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        loadAllMinutesofMeeting();

        function loadAllMinutesofMeeting() {
            Minutesofmeeting.query(function (result) {
                vm.minutesofmeetings = result;
                vm.searchQuery = null;
            });
        }

        vm.downloadFile = downloadFile;

        function downloadFile(serverfilename, downloadfilename) {
            downloadserviceformattachment.download(serverfilename, downloadfilename)
                .then(function (success) {
                    console.log('success : ' + success);
                }, function (error) {
                    console.log('error : ' + error);
                });
        }

        function setCookie() {
            // $.removeCookie('count');
            if ($.cookie('count') === undefined) {
                $.cookie('count', 0);
            } else {
                $.cookie('count', 1);
            }
            setCounter();
        }

        function setCounter() {
            if ($.cookie('count') === '0') {
                Visitor_count.get({id: '1628837e-b177-43d4-8eac-e8e3798dd777'}, function (result) {
                    vm.visitor_count = result;
                    vm.searchQuery = null;
                    vm.visitor_count.count = ++vm.visitor_count.count;
                    Visitor_count.update(vm.visitor_count);
                });
            }
        }

        vm.meeting_view = function (type) {
            console.log(type);
            if (type === 'HEPB') {
                vm.show = true;
                vm.show1 = false;
            } else if (type === 'EEC') {
                vm.show1 = true;
                vm.show = false;
            }
        };
        vm.toggleMenu = function () {
            jQuery('.toggle_menu').toggleClass('mobile-active');
            jQuery('.page_header').first().toggleClass('mobile-active');

        }

        function more(value) {
            if (value === "true") {
                vm.isShowEPP = true
            } else {
                vm.isShowEPP = false
            }

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FooterController', FooterController);

    FooterController.$inject = ['$scope', 'Principal'];

    function FooterController ($scope, Principal) {
        var vm = this;
        vm.isAuthenticated = Principal.isAuthenticated;
        jQuery('.side-container').each(function() {
            var $container = jQuery(this);
            var $openButton = $container.find('.side-container-open');
            var $closeButton = $container.find('.side-container-close');

            $openButton.on('click', function() {
                $container.addClass('active');
            });

            $closeButton.on('click', function() {
                $container.removeClass('active');
            });

            window.onkeydown = function(event) {
                if(event.keyCode == 27)	{
                    $container.removeClass('active');
                }
            }
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ViewIntentToInvestController', ViewIntentToInvestController);

    ViewIntentToInvestController.$inject = ['$scope','$state', 'Sector', 'Country', 'CountryService', 'IntentToInvest'];

    function ViewIntentToInvestController($scope,$state, Sector, Country, CountryService, IntentToInvest) {

        var vm = this;
        // vm.clear = clear;
        loadAll();
        // vm.submitForm = submitForm;

        function loadAll()
        {
            vm.allIntentToInvest = IntentToInvest.query();
            console.log("iiiiii" + vm.allIntentToInvest);
        }



    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IntentToInvestDetailController', IntentToInvestDetailController);

    IntentToInvestDetailController.$inject = ['$scope','$state', 'Sector', 'Country', 'CountryService', 'IntentToInvest', '$stateParams'];

    function IntentToInvestDetailController($scope, $state, Sector, Country, CountryService, IntentToInvest, $stateParams) {

        var vm = this;
        loadAll();

        vm.data = {};

       // alert($stateParams.id);

        function loadAll() {

            IntentToInvest.get({ id: $stateParams.id }, function(response) {
                vm.data = response;
            });
        }



    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('intent-to-invest', {
            parent: 'app',
            url: '/intent-to-invest',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/intentToInvest/IntentToInvest.html',
                    controller: 'IntentToInvestController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        }),
            $stateProvider.state('intent-to-invest-dashboard', {
                parent: 'app',
                url: '/intent-to-invest-dashboard',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/intentToInvest/viewIntentToInvest.html',
                        controller: 'ViewIntentToInvestController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('state');
                        return $translate.refresh();
                    }]
                }
            }),
            $stateProvider.state('intent-to-invest-detail', {
                parent: 'app',
                url: '/intent-to-invest-detail/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/intentToInvest/intentToInvestDetail.html',
                        controller: 'IntentToInvestDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('state');
                        return $translate.refresh();
                    }]
                }
            })
        ;

    }
})();


(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('IntentToInvest', IntentToInvest);

    IntentToInvest.$inject = ['$resource'];

    function IntentToInvest ($resource) {
        var resourceUrl =  'api/intent-to-invest/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IntentToInvestController', IntentToInvestController);

    IntentToInvestController.$inject = ['$scope','$state', 'Sector', 'Country', 'CountryService', 'IntentToInvest'];

    function IntentToInvestController($scope,$state, Sector, Country, CountryService, IntentToInvest) {

        var vm = this;
        // vm.clear = clear;
        loadAll();
        // vm.submitForm = submitForm;

        function loadAll()
        {
            Sector.query(function(result) {
                vm.sectors = result;
                vm.searchQuery = null;
            });

            loadAllCountries();
            function loadAllCountries() {
                vm.allcountries=CountryService.getAllCountries();
            }
        }

        vm.submitForm = function () {
            //alert("Thank you for submitting your intent to invest. Our team will contact you shortly.");

            if (vm.investorProjectForm.$invalid) {
                vm.submitted = true;
                return;
            }

            // prepare DTO consistent with server DTO fields
            var payload = {
                fullName: vm.form.fullName,
                businessEntity: vm.form.businessEntity,
                phoneNumber: vm.form.phoneNumber,
                mobileNumber: vm.form.mobileNumber,
                email: vm.form.email,
                country: vm.form.country,
                sector: vm.form.sector,
                projectName: vm.form.projectName,
                investmentLand: vm.form.landInvestment ? parseFloat(vm.form.landInvestment) : 0,
                investmentBuilding: vm.form.buildingInvestment ? parseFloat(vm.form.buildingInvestment) : 0,
                investmentPlantMachinery: vm.form.plantMachineryInvestment ? parseFloat(vm.form.plantMachineryInvestment) : 0,
                totalInvestment: vm.form.totalInvestment ? parseFloat(vm.form.totalInvestment) : 0,
                landRequired: vm.form.landRequired ? parseFloat(vm.form.landRequired) : null,
                approximateDirectEmployment: vm.form.employment ? parseInt(vm.form.employment) : null,
                productActivity: vm.form.productActivity,
                infoSource: vm.form.infoSource,
                description: vm.form.description
            };

            vm.isSaving = true;
            IntentToInvest.save(payload, onSaveSuccess, onSaveError);


        };

        function onSaveSuccess (result) {
           alert('Thank you for submitting your intent to invest. Our team will contact you shortly.');
            vm.isSaving = false;
            window.location.reload();
        }

        function onSaveError () {
            alert('Error while saving the form. Please try again');
            vm.isSaving = false;
           // window.location.reload();
        }


        vm.calculateTotalInvestment = function() {
            var land = parseFloat(vm.form.landInvestment) || 0;
            var building = parseFloat(vm.form.buildingInvestment) || 0;
            var plant = parseFloat(vm.form.plantMachineryInvestment) || 0;

            vm.form.totalInvestment = (land + building + plant);
        };



    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('incentiveform', {
            parent: 'app',
            url: '/incentiveform',
            data: {
                authorities: ['ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/incentiveforms/incentiveform.html',
                    controller: 'IncentiveFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    .state('incentiveforms', {
            parent: 'app',
            url: '/incentiveforms',
            data: {
                authorities: ['ROLE_USER']
            },
        params: {
            param: ""
        },
            views: {
                'content@': {
                    templateUrl: 'app/incentiveforms/incentiveformNewScheme.html',
                    controller: 'IncentiveFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('incentiveformsmega', {
                    parent: 'app',
                    url: '/incentiveformsmega',
                    data: {
                        authorities: ['ROLE_USER']
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/incentiveforms/incentiveformsmega.html',
                            controller: 'IncentiveFormController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        entity: [ function() {
                            return false;
                        }],
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                }).state('incentivedashboard', {
                    parent: 'app',
                    url: '/incentivedashboard',
                    data: {
                        authorities: []
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/incentiveforms/incentivedashboard.html',
                            controller: 'IncentiveFormController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('global');
                            return $translate.refresh();
                        }]
                    }
                });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IncentiveFormController', IncentiveFormController);

    IncentiveFormController.$inject = ['$stateParams','$scope', '$state','IncentiveForm'];

    function IncentiveFormController ($stateParams,$scope, $state, IncentiveForm) {
        var vm = this;
        vm.param = $stateParams.param;


        IncentiveForm.query(function(result){
            vm.userdetails=result;
        });

        vm.goToIncentiveForm = function () {
            $state.go("incentiveforms");
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('IncentiveForm', IncentiveForm);

    IncentiveForm.$inject = ['$resource'];

    function IncentiveForm ($resource) {
        var resourceUrl =  '/api/getcurrentuser';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IncentiveDashboardController', IncentiveDashboardController);

    IncentiveDashboardController.$inject = [];

    function IncentiveDashboardController () {
        var vm = this;

    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('OldIncentiveWizardController', OldIncentiveWizardController);

    OldIncentiveWizardController.$inject = ['$scope', '$state','$filter','districts','sectors','Block','Incentives','$location'];

    function OldIncentiveWizardController($scope,$state,$filter,districts,sectors,Block,Incentives,$location) {
        var vm = this;
        vm.calculateIncentives=calculateIncentives;
        vm.districts = [];
        vm.projecttype = null;
        vm.showServiceTypes = true;
        vm.showIncentives = false;
        vm.selectedSector = null;
        $scope.projecttype = null;
        vm.calculatedProjectType = null;
        vm.selectedProjectType = null;
        vm.projecttype = 'services';
        vm.isConfirmed=false;
        loadAll();
        var manufacturingProjectTypes = ['Ultra Mega Project','Mega Project','Large Project','Medium Enterprise','Small Enterprise','Micro Enterprise'];
        var servicesProjectTypes = ['Ultra Mega Project','Mega Project','Large Service Enterprise','Medium Service Enterprise','Small Service Enterprise','Micro Service Enterprise'];
        vm.isEPPOnly = true;
        angular.forEach(districts, function(value, key){
            if((value.districtname!== 'Chandigarh HQ')){
                vm.districts.push(value);
            }
        });
        function loadAll(){
            ga('set', 'page', $location.path());ga('send','pageview');
        }

        vm.sectors=sectors;
        vm.incentives={};
        vm.incentives.projectsector='All';
        vm.result={};
        vm.result.incentives=[];
        vm.result.sectorincentives=[];
        vm.loadBlocksByDistrict=loadBlocksByDistrict;
        vm.sectorSpecificeResult = {};
        vm.eppWithSector = {};

        function loadBlocksByDistrict() {
            Block.query({id:1, districtname:vm.incentives.projectdistrict},function (result) {
                vm.blocks=result;
            });
        }

        vm.getConfirmation = function(){
            vm.isConfirmed = true;
            if(vm.isConfirmed){
                vm.calculateIncentives();
            }
            vm.showIncentives = true;
        }

        vm.dismiss=function(){
            vm.showIncentives = false;
            $("#incentivesModal").modal('hide');
        }

        function calculateIncentives() {
            ga('set', 'page', "/calculated-incentives");ga('send','pageview');

            vm.calculateProjectType(vm.getProjectType);
            if(vm.selectedTextile != null){
                vm.incentives.projectsector = vm.selectedTextile;
            }else if(vm.selectedAgro != null){
                vm.incentives.projectsector = vm.selectedAgro;
            }
        }

        vm.getProjectType = function() {
            var result=Incentives.getIncentives(vm.result.projectsize,vm.block.blocktype,vm.incentives.projectsector,vm.projecttype);
//            vm.result.incentives=result[0]===undefined?[]:result[0].incentives;
            vm.result.incentives=result[0].incentives;
            var sectorSpecificeResult = Incentives.getSectorSpecificIncentives(vm.incentives.projectsector,vm.block.blocktype);
            vm.sectorSpecificeResult.incentives=sectorSpecificeResult[0]===undefined?[]:sectorSpecificeResult[0].incentives;
            vm.eppWithSector.incentives = clubResults(vm.result.incentives, vm.sectorSpecificeResult.incentives);
        }


        vm.getSelectedSector = function(selectedSector){
            if(selectedSector == 'Agro' || selectedSector == 'Footwear' || selectedSector == 'Textiles'){
                vm.isEPPOnly = false;
            }else{
                vm.isEPPOnly = true;
            }
        }

        vm.loadProjectType = function(selectedProjectType){
            $scope.projecttype = selectedProjectType;
            if(selectedProjectType == 'services'){
                vm.showServiceTypes = true;
                vm.showManufacturingTypes = false;
            }else if(selectedProjectType == 'manufacturing'){
                vm.showServiceTypes = false;
                vm.showManufacturingTypes = true;
            }
        }

        vm.loadBlockType = function(){
            vm.block=$filter('filter')(vm.blocks,{districtname:vm.incentives.projectdistrict,blockname:vm.incentives.projectblock})[0];
        }
        function clubResults(eppincentives, sectorIncentives){
            var newItems = [];
            var itemsToBeChanged = [];
            var indexForItemsToBeChanged = [];
            var incentiveIndexesForNewItems = [];
            eppincentives.forEach(function(e1,index){
                for(var i = 0; i < sectorIncentives.length; i++){
                    if(e1.name === sectorIncentives[i].name){
                        indexForItemsToBeChanged.push(index);
                        if(sectorIncentives[i].value1 !== null){
                            e1.value3 = sectorIncentives[i].value1;
                            if(sectorIncentives[i].constraints1 !== null){
                                e1.constraints3 = sectorIncentives[i].constraints1;
                            }
                            if(sectorIncentives[i].value2 !== null){
                                e1.value4 = sectorIncentives[i].value2;
                                if(sectorIncentives[i].constraints2 !== null){
                                    e1.constraints4 = sectorIncentives[i].constraints2;
                                }
                            }
                        }
                        e1.remarks1 = e1.remarks;
                        e1.remarks2 = sectorIncentives[i].remarks;
                        itemsToBeChanged.push(e1);
                    }else if(sectorIncentives[i].name.includes(e1.name)){
                        incentiveIndexesForNewItems.push(index);
                        newItems.push(sectorIncentives[i]);
                    }
                }
            });
            for(var j = 0; j < indexForItemsToBeChanged.length; j++){
                eppincentives[indexForItemsToBeChanged[j]] = itemsToBeChanged[j];
            }
            for(var k = 0; k < incentiveIndexesForNewItems.length; k++){
                eppincentives.splice(incentiveIndexesForNewItems[k],0,newItems.shift());
            }
            return eppincentives;
        }

        vm.calculateProjectType = function(callback){

            if(vm.projecttype === 'services'){
                if(vm.total_project_cost > 6000 && vm.landArea >= 500){
                    vm.calculatedProjectType = 'Ultra Mega Project';
                }else if(vm.total_project_cost >= 100 || (vm.employment  >= 200 && vm.block.blocktype === 'D') ||
                    (vm.employment >= 500 && (vm.block.blocktype === 'B' || vm.block.blocktype === 'C'))){
                    vm.calculatedProjectType = 'Mega Project';
                }else if(vm.total_project_cost > 5){
                    vm.calculatedProjectType = 'Large Service Enterprise';
                }else if(vm.total_project_cost > 2 && vm.total_project_cost <=5){
                    vm.calculatedProjectType = 'Medium Service Enterprise';
                }else if(vm.total_project_cost > 0.1000 && vm.total_project_cost <= 2){
                    vm.calculatedProjectType = 'Small Service Enterprise';
                }else if(vm.total_project_cost < 0.1000){
                    vm.calculatedProjectType = 'Micro Service Enterprise';
                }
            }else if(vm.projecttype === 'manufacturing'){
                if(vm.total_project_cost > 6000 && vm.landArea >= 500){
                    vm.calculatedProjectType = 'Ultra Mega Project';
                }else if(vm.total_project_cost >= 100 || (vm.employment  >= 200 && vm.block.blocktype === 'D') ||
                    (vm.employment >= 500 && (vm.block.blocktype === 'B' || vm.block.blocktype === 'C'))){
                    vm.calculatedProjectType = 'Mega Project';
                }else if(vm.total_project_cost > 10 && vm.total_project_cost <= 100){
                    vm.calculatedProjectType = 'Large Project';
                }else if(vm.total_project_cost > 5 && vm.total_project_cost <= 10){
                    vm.calculatedProjectType = 'Medium Enterprise';
                }else if(vm.total_project_cost > 0.2500 && vm.total_project_cost <= 5){
                    vm.calculatedProjectType = 'Small Enterprise';
                }else if(vm.total_project_cost < 0.2500){
                    vm.calculatedProjectType = 'Micro Enterprise';
                }
            }

            var selectedProjectType = vm.calculatedProjectType;

            if(selectedProjectType == 'Mega Project'){
                vm.result.projectsize = 'MEGA';
            }else if(selectedProjectType == 'Micro Project' || selectedProjectType == 'Medium Enterprise' ||
                selectedProjectType == 'Small Enterprise' || selectedProjectType == 'Micro Enterprise' ||
                selectedProjectType == 'Medium Service Enterprise' || selectedProjectType == 'Small Service Enterprise' ||
                selectedProjectType == 'Micro Service Enterprise'){
                vm.result.projectsize = 'MSME';

            }else if(selectedProjectType == 'Large Project'){
                vm.result.projectsize = 'LARGE';
            }else if(selectedProjectType == 'Large Service Enterprise'){
                vm.result.projectsize = 'Large Service Enterprise';
            }

            callback();
        }

        vm.changeInCost=function(){
            var projectCostInCrore=vm.project_cost_in_crore || '00';
            var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
            var projectCostInThousands=vm.project_cost_in_thousands||'00';
            if(vm.project_cost_in_lacs<10){
                projectCostInLacs='0'+vm.project_cost_in_lacs;
            }
            if(vm.project_cost_in_thousands<10){
                projectCostInThousands='0'+vm.project_cost_in_thousands;
            }
            vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
            vm.calculateProjectType(function(){
            });
        };


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('newincentiveswizard', {
            parent: 'app',
           url: '/new-incentive-wizard',
            data: {
                authorities: [],
            },
            views: {
                'content@': {
                    templateUrl: 'app/incentive-wizard/incentivewizard.html',
                    controller: 'IncentiveWizardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                districts: ['District', function(District) {
                    return District.query().$promise;
                }],
                sectors: ['Sector', function(Sector) {
                    return Sector.query().$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eodb');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('incentiveswizard', {
            parent: 'app',
           url: '/incentive-wizard',
            data: {
                authorities: [],
            },
            views: {
                'content@': {
                    templateUrl: 'app/incentive-wizard/oldincentivewizard.html',
                    controller: 'OldIncentiveWizardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                districts: ['District', function(District) {
                    return District.query().$promise;
                }],
                sectors: ['Sector', function(Sector) {
                    return Sector.query().$promise;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eodb');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Incentives', Incentives);

    Incentives.$inject = ['$filter'];

    function Incentives($filter) {
        var incentives = [
            {
                projecttype: 'MEGA',
                block: 'B',
                incentives:
                    [
                        {
                            name: 'Investment Subsidy on SGST',
                            value1: '30%',
                            value2: '15%',
                            constraints1: '30% of net SGST paid for first 5 years',
                            constraints2: '15% of net SGST paid for next 3 years',
                            ismultiple: true,
                            remarks: 'Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment'
                        },
                        {
                            name: 'Employment Generation Subsidy (Rs/year)',
                            value1: 'Rs.36000 Per Year and Rs. 30000 Per Year OR 20%',
                            value2: null,
                            constraints1: 'Rs. 36,000 per year for SC/Women and Rs. 30,000/- per year for General Category for 5 years for capacity building of persons belonging to Haryana or 20% of the SGST deposited whichever is less,  for 5 years ',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Minimum 50% of total employment of persons belonging to Haryana b) Evidence for employment would be related statutory returns such as returns filed under the Employees Provident Fund Act'
                        },
                        {
                            name: 'Electricity Duty Exemption',
                            value1: '100%',
                            value2: null,
                            constraints1: '100% Exemption from payment of Electricity duty for 5 years',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Only for new Mega Projects b) Applicable from date of release of electricity connection'
                        },
                        {
                            name: 'Stamp Duty Refund',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% refund of stamp duty within 5 years of filing of IEM',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Applicable on land area meant for industrial use'
                        },
                        {
                            name: 'EDC charges exemption',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption towards EDC charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        }
                    ]
            },
            {
                projecttype: 'MEGA',
                block: 'C',
                incentives:
                    [
                        {
                            name: 'Investment Subsidy on SGST',
                            value1: '50% and 25%',
                            value2: null,
                            constraints1: '50% of net SGST paid for first 5 years and 25% of net SGST paid for next 3 years',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment'

                        },
                        {
                            name: 'Employment Generation Subsidy (Rs/year)',
                            value1: 'Rs.36000 Per Year and Rs. 30000 Per Year',
                            value2: '20%',
                            constraints1: 'Rs. 36,000 per year for SC/Women and Rs. 30,000/- per year for General Category for 5 years for capacity building of persons belonging to Haryana',
                            constraints2: '20% of the SGST deposited whichever is less,  for 5 years ',
                            ismultiple: true,
                            remarks: 'a) Minimum 50% of total employment of persons belonging to Haryana b) Evidence for employment would be related statutory returns such as returns filed under the Employees Provident Fund Act'
                        },
                        {
                            name: 'Electricity Duty Exemption',
                            value1: '100%',
                            value2: null,
                            constraints1: '100% Exemption from payment of Electricity duty for 5 years',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Only for new Mega Projects b) Applicable from date of release of electricity connection'
                        },
                        {
                            name: 'Stamp Duty Refund',
                            value1: '75%',
                            value2: null,
                            constraints1: '75% refund of stamp duty within 5 years of filing of IEM',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Applicable on land area meant for industrial use'
                        },
                        {
                            name: 'EDC charges exemption',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption towards EDC charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        }
                    ]
            },
            {
                projecttype: 'MEGA',
                block: 'D',
                incentives:
                    [
                        {
                            name: 'Investment Subsidy on SGST',
                            value1: '75% and 35%',
                            value2: null,
                            constraints1: '75% of net SGST paid for first 5 years and 35% of net SGST paid for next 3 years',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment'
                        },
                        {
                            name: 'Employment Generation Subsidy (Rs/year)',
                            value1: 'Rs.36000 Per Year and Rs. 30000 Per Year',
                            value2: '20%',
                            constraints1: 'Rs. 36,000 per year for SC/Women and Rs. 30,000/- per year for General Category for 5 years for capacity building of persons belonging to Haryana',
                            constraints2: '20% of the SGST deposited whichever is less,  for 5 years ',
                            ismultiple: true,
                            remarks: 'a) Minimum 50% of total employment of persons belonging to Haryana b) Evidence for employment would be related statutory returns such as returns filed under the Employees Provident Fund Act'
                        },
                        {
                            name: 'Electricity Duty Exemption',
                            value1: '100%',
                            value2: null,
                            constraints1: '100% Exemption from payment of Electricity duty for 7 years',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Only for new Mega Projects b) Applicable from date of release of electricity connection'
                        },
                        {
                            name: 'Stamp Duty Refund',
                            value1: '100%',
                            value2: null,
                            constraints1: '100% refund of stamp duty within 5 years of filing of IEM',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Applicable on land area meant for industrial use'
                        },
                        {
                            name: 'EDC charges exemption',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption towards EDC charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        }
                    ]
            },
            {
                projecttype: 'LARGE',
                block: 'B',
                incentives:
                    [
                        {
                            name: 'EDC Charges',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption towards EDC charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        }
                    ]
            },
            {
                projecttype: 'LARGE',
                block: 'C',
                incentives:
                    [
                        {
                            name: 'VAT/SGST Subsidy',
                            value1: '50% and 25%',
                            value2: '50%',
                            constraints1: '50% of net SGST paid for first 5 years and 25% of net SGST paid for next 3 years',
                            constraints2: '50% of net SGST paid for  5 years on 50% additional investment in plant and machineryfor expansion/ diversification',
                            ismultiple: true,
                            remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI'
                        },
                        {
                            name: 'Employment Generation Subsidy (Rs/year)',
                            value1: 'Rs.36000 Per Year/Rs.30000 Per Year',
                            value2: '20%',
                            constraints1: 'Rs. 36,000 per year for SC/Women and Rs. 30,000/- per year for General Category for 5 years for capacity building of persons belonging to Haryana',
                            constraints2: '20% of the SGST deposited whichever is less,  for 5 years ',
                            ismultiple: true,
                            remarks: 'a) Minimum 50% of total employment of persons belonging to Haryana'
                        },
                        {
                            name: 'Electricity Duty Exemption',
                            value1: '100%',
                            value2: null,
                            constraints1: '100% Exemption from payment of Electricity duty for 5 years',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                        },
                        {
                            name: 'Stamp Duty Refund',
                            value1: '75%',
                            value2: null,
                            constraints1: '75% refund of stamp duty within 5 years of filing of IEM',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Applicable on land area meant for industrial use'
                        },
                        {
                            name: 'EDC Charges',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption towards EDC charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        }
                    ]
            },
            {
                projecttype: 'LARGE',
                block: 'D',
                incentives:
                    [
                        {
                            name: 'VAT/SGST Subsidy',
                            value1: '75% and 35%',
                            value2: '75%',
                            constraints1: '75% of net SGST paid for first 7 years and 35% of net SGST paid for next 3 years',
                            constraints2: '75% of net SGST paid for 7 years on 50% additional investment in plant and machineryfor expansion/ diversification',
                            ismultiple: true,
                            remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI'
                        },
                        {
                            name: 'Employment Generation Subsidy (Rs/year)',
                            value1: 'Rs.36000 Per Year/Rs.30000 Per Year',
                            value2: '20%',
                            constraints1: 'Rs. 36,000 per year for SC/Women and Rs. 30,000/- per year for General Category for 5 years for capacity building of persons belonging to Haryana',
                            constraints2: '20% of the SGST deposited whichever is less,  for 5 years ',
                            ismultiple: true,
                            remarks: 'a) Minimum 50% of total employment of persons belonging to Haryana'
                        },
                        {
                            name: 'Electricity Duty Exemption',
                            value1: '100%',
                            value2: null,
                            constraints1: '100% Exemption from payment of Electricity duty for 7 years',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                        },
                        {
                            name: 'Stamp Duty Refund',
                            value1: '100%',
                            value2: null,
                            constraints1: '100% refund of stamp duty within 5 years of filing of IEM',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Applicable on land area meant for industrial use'
                        },
                        {
                            name: 'EDC Charges',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption towards EDC charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        }
                    ]
            },
            {
                projecttype: 'MSME',
                block: 'A',
                incentives:
                    [
                        {
                            name: 'Testing Equipment Assistance',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% as subsidy for the purchase of testing equipments ',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 5 Lakhs'
                        },
                        {
                            name: 'Environment Compliance Assistance',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% financial support on capital cost for setting up of Effluent Treatment Plant and for installation of Air Pollution Control Devices ',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Upto a maximum of INR 25 lakh b) Units adopting zero effluent will be considered for higher subsidy on case to case basis'
                        },
                        {
                            name: 'Technology Acquisition Assistance',
                            value1: 'Misc',
                            value2: null,
                            constraints1: 'Upto a maximum of INR 25 Lakhs',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        },
                        {
                            name: 'Patent Cost',
                            value1: '50%',
                            value2: null,
                            constraints1: 'Reimbursement of the actual expenses (including filing fees, consultancy fees, search fees and maintenance fees) for domestic and international patent registration.',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 25 lakh'
                        },
                        {
                            name: 'Energy Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement for conducting energy audit',
                            constraints2: '50% subsidy on cost of capital equipments required for undertaking measures to conserve energy',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 2 lakh b)Upto a maximum of INR 20 lakh'
                        },
                        {
                            name: 'Water Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement of cost of Water audit',
                            constraints2: '50% subsidy on the cost of capital equipments required for Water Conservation/ Harvesting System. ',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 1 lakh b)Upto a maximum of INR 20 lakh'
                        },
                        {
                            name: 'Safety Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement of expenses incurred on safety audit ',
                            constraints2: '50% subsidy on cost of capital equipments required for undertaking safety measures',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 1 lakh b)Upto a maximum of INR 5 lakh'
                        },
                        {
                            name: 'Quality Certification',
                            value1: '75%',
                            value2: null,
                            constraints1: '75% reimbursement for obtaining ISO certifications',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 1 lakh'
                        },
                        {
                            name: 'MSME State Awards',
                            value1: 'Rs.3 lakh',
                            value2: null,
                            constraints1: 'Rs. 3 lakh each separately for growth in production and profit, for innovation & development of new products, quality products and lean manufacturing techniques in the field of Agro and Food processing, Automobiles and auto parts, Textiles, Engineering, Pharmaceuticals, IT & Electronics etc.',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'The unit once selected for award shall not be considered again during next 5 years.'
                        },
                        {
                            name: 'Credit Rating',
                            value1: '75%',
                            value2: null,
                            constraints1: '75% reimbursement of expenses incurred towards the credit rating carried out by SIDBI /Govt. accredited credit rating agency',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 2 lakh'
                        },
                        {
                            name: 'Market Development Assistance',
                            value1: 'Misc',
                            value2: 'Misc',
                            constraints1: 'For exhibitions within the country: 100% reimbursment of participation charges for space of maximum size up to 9 sq.m and Second class AC travelling charges and Boarding charges at the rate of Rs.1000 per day',
                            constraints2: 'For International Exhibitions: 75% space charges, shipment of exhibits, cost of product literature, display material or maximum up to Rs. 5 lakh and Air fare by economy class up to Rs. 1 lakh',
                            ismultiple: true,
                            remarks: null
                        },
                        {
                            name: 'Credit Linked Capital Subsidy for Technology Up-gradation',
                            value1: '15%',
                            value2: '5%',
                            constraints1: '15% capital subsidy for facilitating technology up-gradation in specified sectors/products of the Industry provided by Government of India',
                            constraints2: '5% Interest subsidy @ 5% for a period of 3 years provided by Govt. of Haryana for units eligible in the scheme',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 15 lakh b)Upto a maximum of INR 5 lakh'
                        },
                        {
                            name: 'Design Clinic Scheme',
                            value1: 'Misc',
                            value2: 'Misc',
                            constraints1: 'Gol provides Rs. 3 lakh with contribution of Rs. 1 lakh by industries for conducting Design Awareness Program (DAP) in the various clusters by National Institute of Design, Ahmadabad. The State would refund the contribution of industries of Rs. 1 lakh per program',
                            constraints2: 'Gol provides funding support@ 60% of the designing cost upto a maximum of Rs. 15 lakh under this scheme. The State Government would provide 20% of the designing cost out of the 40% contribution to be made by the industry',
                            ismultiple: true,
                            remarks: null
                        }
                    ]
            },
            {
                projecttype: 'MSME',
                block: 'B',
                incentives:
                    [
                        {
                            name: 'VAT/SGST Subsidy',
                            value1: '50% and 25%',
                            value2: '50%',
                            constraints1: '50% of net SGST paid for first 5 years and 25% of net SGST paid for next 3 years',
                            constraints2: '25% of net SGST paid for 5 years AND 25% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification',
                            ismultiple: true,
                            remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI'
                        },
                        {
                            name: 'Electricity Duty Expemption',
                            value1: '100%',
                            value2: null,
                            constraints1: '100% from payment of Electricity duty for 7 years',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                        },
                        {
                            name: 'Stamp Duty Refund',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% refund of stamp duty within 5 years of filing of IEM',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer'
                        },
                        {
                            name: 'EDC Charges',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption of Conversion charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        },
                        {
                            name: 'CLU Refund',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption of Conversion charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        },
                        {
                            name: 'Interest Subsidy',
                            value1: '5%',
                            value2: '5%',
                            constraints1: '5% on term loan OR maximum upto Rs. 10.00 lakh per year for 3 years',
                            constraints2: '5% on term loan for expansion/diversification or maximum upto Rs. 10.00 lakh per year for 3 years',
                            ismultiple: true,
                            remarks: 'a)Cap of net SGST paid during the relevant year b)Expansion/diversification should not be covered under CLCSS of Gol c) Cap of net SGST paid during the relevant year'
                        },
                        {
                            name: 'Testing Equipment Assistance',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% as subsidy for the purchase of testing equipments ',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 5 Lakhs'
                        },
                        {
                            name: 'Environment Compliance Assistance',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% financial support on capital cost for setting up of Effluent Treatment Plant and for installation of Air Pollution Control Devices ',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Upto a maximum of INR 25 lakh b) Units adopting zero effluent will be considered for higher subsidy on case to case basis'
                        },
                        {
                            name: 'Technology Acquisition Assistance',
                            value1: 'Misc',
                            value2: null,
                            constraints1: 'Upto a maximum of INR 25 Lakhs',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        },
                        {
                            name: 'Patent Cost',
                            value1: '50%',
                            value2: null,
                            constraints1: 'Reimbursement of the actual expenses (including filing fees, consultancy fees, search fees and maintenance fees) for domestic and international patent registration.',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 25 lakh'
                        },
                        {
                            name: 'Energy Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement for conducting energy audit',
                            constraints2: '50% subsidy on cost of capital equipments required for undertaking measures to conserve energy',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 2 lakh b)Upto a maximum of INR 20 lakh'
                        },
                        {
                            name: 'Water Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement of cost of Water audit',
                            constraints2: '50% subsidy on the cost of capital equipments required for Water Conservation/ Harvesting System. ',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 1 lakh b)Upto a maximum of INR 20 lakh'
                        },
                        {
                            name: 'Safety Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement of expenses incurred on safety audit ',
                            constraints2: '50% subsidy on cost of capital equipments required for undertaking safety measures',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 1 lakh b)Upto a maximum of INR 5 lakh'
                        },
                        {
                            name: 'Quality Certification',
                            value1: '75%',
                            value2: null,
                            constraints1: '75% reimbursement for obtaining ISO certifications',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 1 lakh'
                        },
                        {
                            name: 'MSME State Awards',
                            value1: 'Rs.3 lakh',
                            value2: null,
                            constraints1: 'Rs. 3 lakh each separately for growth in production and profit, for innovation & development of new products, quality products and lean manufacturing techniques in the field of Agro and Food processing, Automobiles and auto parts, Textiles, Engineering, Pharmaceuticals, IT & Electronics etc.',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'The unit once selected for award shall not be considered again during next 5 years.'
                        },
                        {
                            name: 'Credit Rating',
                            value1: '75%',
                            value2: null,
                            constraints1: '75% reimbursement of expenses incurred towards the credit rating carried out by SIDBI /Govt. accredited credit rating agency',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 2 lakh'
                        },
                        {
                            name: 'Market Development Assistance',
                            value1: 'Misc',
                            value2: 'Misc',
                            constraints1: 'For exhibitions within the country: 100% reimbursment of participation charges for space of maximum size up to 9 sq.m and Second class AC travelling charges and Boarding charges at the rate of Rs.1000 per day',
                            constraints2: 'For International Exhibitions: 75% space charges, shipment of exhibits, cost of product literature, display material or maximum up to Rs. 5 lakh and Air fare by economy class up to Rs. 1 lakh',
                            ismultiple: true,
                            remarks: null
                        },
                        {
                            name: 'Credit Linked Capital Subsidy for Technology Up-gradation',
                            value1: '15%',
                            value2: '5%',
                            constraints1: '15% capital subsidy for facilitating technology up-gradation in specified sectors/products of the Industry provided by Government of India',
                            constraints2: '5% Interest subsidy @ 5% for a period of 3 years provided by Govt. of Haryana for units eligible in the scheme',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 15 lakh b)Upto a maximum of INR 5 lakh'
                        },
                        {
                            name: 'Design Clinic Scheme',
                            value1: 'Misc',
                            value2: 'Misc',
                            constraints1: 'Gol provides Rs. 3 lakh with contribution of Rs. 1 lakh by industries for conducting Design Awareness Program (DAP) in the various clusters by National Institute of Design, Ahmadabad. The State would refund the contribution of industries of Rs. 1 lakh per program',
                            constraints2: 'Gol provides funding support@ 60% of the designing cost upto a maximum of Rs. 15 lakh under this scheme. The State Government would provide 20% of the designing cost out of the 40% contribution to be made by the industry',
                            ismultiple: true,
                            remarks: null
                        }
                    ]
            },
            {
                projecttype: 'MSME',
                block: 'C',
                incentives:
                    [
                        {
                            name: 'VAT/SGST Subsidy',
                            value1: '75% and 35%',
                            value2: '75%',
                            constraints1: '75% of net SGST paid for first 7 years and 35% of net SGST paid for next 3 years',
                            constraints2: '75% of net SGST paid for 7 years AND 35% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification',
                            ismultiple: true,
                            remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI'
                        },
                        {
                            name: 'Electricity Duty Expemption',
                            value1: '100%',
                            value2: null,
                            constraints1: '100% exemption from payment of Electricity duty for 7 years',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                        },
                        {
                            name: 'Stamp Duty Refund',
                            value1: '75%',
                            value2: null,
                            constraints1: '75% refund of stamp duty within 5 years of filing of IEM',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer'
                        },
                        {
                            name: 'EDC Charges',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption of Conversion charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        },
                        {
                            name: 'CLU Refund',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption of Conversion charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        },
                        // {
                        //     name: 'Power Tariff Subsidy (Only for Micro & Small)',
                        //     value1: 'Rs.2 per unit',
                        //     value2: null,
                        //     constraints1: 'Rs. 2 per unit for 3 years',
                        //     constraints2: null,
                        //     ismultiple: false,
                        //     remarks: 'Applicable from date of release of electricity connection'
                        // },
                        {
                            name: 'Interest Subsidy',
                            value1: '5%',
                            value2: '5%',
                            constraints1: '5% on term loan OR maximum upto Rs. 10.00 lakh per year for 3 years',
                            constraints2: '5% on term loan for expansion/diversification or maximum upto Rs. 10.00 lakh per year for 3 years',
                            ismultiple: true,
                            remarks: 'a)Cap of net SGST paid during the relevant year b)Expansion/diversification should not be covered under CLCSS of Gol c) Cap of net SGST paid during the relevant year'
                        },
                        {
                            name: 'Testing Equipment Assistance',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% as subsidy for the purchase of testing equipments ',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 5 Lakhs'
                        },
                        {
                            name: 'Environment Compliance Assistance',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% financial support on capital cost for setting up of Effluent Treatment Plant and for installation of Air Pollution Control Devices ',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Upto a maximum of INR 25 lakh b) Units adopting zero effluent will be considered for higher subsidy on case to case basis'
                        },
                        {
                            name: 'Technology Acquisition Assistance',
                            value1: 'Misc',
                            value2: null,
                            constraints1: 'Upto a maximum of INR 25 Lakhs',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        },
                        {
                            name: 'Patent Cost',
                            value1: '50%',
                            value2: null,
                            constraints1: 'Reimbursement of the actual expenses (including filing fees, consultancy fees, search fees and maintenance fees) for domestic and international patent registration.',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 25 lakh'
                        },
                        {
                            name: 'Energy Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement for conducting energy audit',
                            constraints2: '50% subsidy on cost of capital equipments required for undertaking measures to conserve energy',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 2 lakh b)Upto a maximum of INR 20 lakh'
                        },
                        {
                            name: 'Water Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement of cost of Water audit',
                            constraints2: '50% subsidy on the cost of capital equipments required for Water Conservation/ Harvesting System. ',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 1 lakh b)Upto a maximum of INR 20 lakh'
                        },
                        {
                            name: 'Safety Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement of expenses incurred on safety audit ',
                            constraints2: '50% subsidy on cost of capital equipments required for undertaking safety measures',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 1 lakh b)Upto a maximum of INR 5 lakh'
                        },
                        {
                            name: 'Quality Certification',
                            value1: '75%',
                            value2: null,
                            constraints1: '75% reimbursement for obtaining ISO certifications',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 1 lakh'
                        },
                        {
                            name: 'MSME State Awards',
                            value1: 'Rs.3 lakh',
                            value2: null,
                            constraints1: 'Rs. 3 lakh each separately for growth in production and profit, for innovation & development of new products, quality products and lean manufacturing techniques in the field of Agro and Food processing, Automobiles and auto parts, Textiles, Engineering, Pharmaceuticals, IT & Electronics etc.',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'The unit once selected for award shall not be considered again during next 5 years.'
                        },
                        {
                            name: 'Credit Rating',
                            value1: '75%',
                            value2: null,
                            constraints1: '75% reimbursement of expenses incurred towards the credit rating carried out by SIDBI /Govt. accredited credit rating agency',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 2 lakh'
                        },
                        {
                            name: 'Market Development Assistance',
                            value1: 'Misc',
                            value2: 'Misc',
                            constraints1: 'For exhibitions within the country: 100% reimbursment of participation charges for space of maximum size up to 9 sq.m and Second class AC travelling charges and Boarding charges at the rate of Rs.1000 per day',
                            constraints2: 'For International Exhibitions: 75% space charges, shipment of exhibits, cost of product literature, display material or maximum up to Rs. 5 lakh and Air fare by economy class up to Rs. 1 lakh',
                            ismultiple: true,
                            remarks: null
                        },
                        {
                            name: 'Credit Linked Capital Subsidy for Technology Up-gradation',
                            value1: '15%',
                            value2: '5%',
                            constraints1: '15% capital subsidy for facilitating technology up-gradation in specified sectors/products of the Industry provided by Government of India',
                            constraints2: '5% Interest subsidy @ 5% for a period of 3 years provided by Govt. of Haryana for units eligible in the scheme',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 15 lakh b)Upto a maximum of INR 5 lakh'
                        },
                        {
                            name: 'Design Clinic Scheme',
                            value1: 'Misc',
                            value2: 'Misc',
                            constraints1: 'Gol provides Rs. 3 lakh with contribution of Rs. 1 lakh by industries for conducting Design Awareness Program (DAP) in the various clusters by National Institute of Design, Ahmadabad. The State would refund the contribution of industries of Rs. 1 lakh per program',
                            constraints2: 'Gol provides funding support@ 60% of the designing cost upto a maximum of Rs. 15 lakh under this scheme. The State Government would provide 20% of the designing cost out of the 40% contribution to be made by the industry',
                            ismultiple: true,
                            remarks: null
                        }
                    ]
            },
            {
                projecttype: 'MSME',
                block: 'D',
                incentives:
                    [
                        {
                            name: 'VAT/SGST Subsidy',
                            value1: '50% and 25%',
                            value2: '50%',
                            constraints1: '50% of net SGST paid for first 5 years and 25% of net SGST paid for next 3 years',
                            constraints2: '50% of net SGST paid for 5 years AND 25% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification',
                            ismultiple: true,
                            remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI.'
                        },
                        {
                            name: 'Electricity Duty Expemption',
                            value1: '100%',
                            value2: null,
                            constraints1: '100% exemption from payment of Electricity duty for 7 years',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                        },
                        {
                            name: 'Stamp Duty Refund',
                            value1: '100%',
                            value2: null,
                            constraints1: '100% refund of stamp duty within 5 years of filing of IEM',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer'
                        },
                        {
                            name: 'EDC Charges',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption of Conversion charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        },
                        {
                            name: 'CLU Refund',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% exemption of Conversion charges',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        },
                        // {
                        //     name: 'Power Tariff Subsidy (Only for Micro & Small)',
                        //     value1: 'Rs.2 per unit',
                        //     value2: null,
                        //     constraints1: 'Rs. 2 per unit for 3 years',
                        //     constraints2: null,
                        //     ismultiple: false,
                        //     remarks: 'Applicable from date of release of electricity connection'
                        // },
                        {
                            name: 'Interest Subsidy',
                            value1: '5%',
                            value2: '5%',
                            constraints1: '5% on term loan OR maximum upto Rs. 10.00 lakh per year for 3 years',
                            constraints2: '5% on term loan for expansion/diversification or maximum upto Rs. 10.00 lakh per year for 3 years',
                            ismultiple: true,
                            remarks: 'a)Cap of net SGST paid during the relevant year b)Expansion/diversification should not be covered under CLCSS of Gol c) Cap of net SGST paid during the relevant year'
                        },
                        {
                            name: 'Testing Equipment Assistance',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% as subsidy for the purchase of testing equipments ',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 5 Lakhs'
                        },
                        {
                            name: 'Environment Compliance Assistance',
                            value1: '50%',
                            value2: null,
                            constraints1: '50% financial support on capital cost for setting up of Effluent Treatment Plant and for installation of Air Pollution Control Devices ',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'a) Upto a maximum of INR 25 lakh b) Units adopting zero effluent will be considered for higher subsidy on case to case basis'
                        },
                        {
                            name: 'Technology Acquisition Assistance',
                            value1: 'Misc',
                            value2: null,
                            constraints1: 'Upto a maximum of INR 25 Lakhs',
                            constraints2: null,
                            ismultiple: false,
                            remarks: null
                        },
                        {
                            name: 'Patent Cost',
                            value1: '50%',
                            value2: null,
                            constraints1: 'Reimbursement of the actual expenses (including filing fees, consultancy fees, search fees and maintenance fees) for domestic and international patent registration.',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 25 lakh'
                        },
                        {
                            name: 'Energy Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement for conducting energy audit',
                            constraints2: '50% subsidy on cost of capital equipments required for undertaking measures to conserve energy',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 2 lakh b)Upto a maximum of INR 20 lakh'
                        },
                        {
                            name: 'Water Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement of cost of Water audit',
                            constraints2: '50% subsidy on the cost of capital equipments required for Water Conservation/ Harvesting System. ',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 1 lakh b)Upto a maximum of INR 20 lakh'
                        },
                        {
                            name: 'Safety Audit',
                            value1: '75%',
                            value2: '50%',
                            constraints1: '75% reimbursement of expenses incurred on safety audit ',
                            constraints2: '50% subsidy on cost of capital equipments required for undertaking safety measures',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 1 lakh b)Upto a maximum of INR 5 lakh'
                        },
                        {
                            name: 'Quality Certification',
                            value1: '75%',
                            value2: null,
                            constraints1: '75% reimbursement for obtaining ISO certifications',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 1 lakh'
                        },
                        {
                            name: 'MSME State Awards',
                            value1: 'Rs.3 lakh',
                            value2: null,
                            constraints1: 'Rs. 3 lakh each separately for growth in production and profit, for innovation & development of new products, quality products and lean manufacturing techniques in the field of Agro and Food processing, Automobiles and auto parts, Textiles, Engineering, Pharmaceuticals, IT & Electronics etc.',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'The unit once selected for award shall not be considered again during next 5 years.'
                        },
                        {
                            name: 'Credit Rating',
                            value1: '75%',
                            value2: null,
                            constraints1: '75% reimbursement of expenses incurred towards the credit rating carried out by SIDBI /Govt. accredited credit rating agency',
                            constraints2: null,
                            ismultiple: false,
                            remarks: 'Upto a maximum of INR 2 lakh'
                        },
                        {
                            name: 'Market Development Assistance',
                            value1: 'Misc',
                            value2: 'Misc',
                            constraints1: 'For exhibitions within the country: 100% reimbursment of participation charges for space of maximum size up to 9 sq.m and Second class AC travelling charges and Boarding charges at the rate of Rs.1000 per day',
                            constraints2: 'For International Exhibitions: 75% space charges, shipment of exhibits, cost of product literature, display material or maximum up to Rs. 5 lakh and Air fare by economy class up to Rs. 1 lakh',
                            ismultiple: true,
                            remarks: null
                        },
                        {
                            name: 'Credit Linked Capital Subsidy for Technology Up-gradation',
                            value1: '15%',
                            value2: '5%',
                            constraints1: '15% capital subsidy for facilitating technology up-gradation in specified sectors/products of the Industry provided by Government of India',
                            constraints2: '5% Interest subsidy @ 5% for a period of 3 years provided by Govt. of Haryana for units eligible in the scheme',
                            ismultiple: true,
                            remarks: 'a)Upto a maximum of INR 15 lakh b)Upto a maximum of INR 5 lakh'
                        },
                        {
                            name: 'Design Clinic Scheme',
                            value1: 'Misc',
                            value2: 'Misc',
                            constraints1: 'Gol provides Rs. 3 lakh with contribution of Rs. 1 lakh by industries for conducting Design Awareness Program (DAP) in the various clusters by National Institute of Design, Ahmadabad. The State would refund the contribution of industries of Rs. 1 lakh per program',
                            constraints2: 'Gol provides funding support@ 60% of the designing cost upto a maximum of Rs. 15 lakh under this scheme. The State Government would provide 20% of the designing cost out of the 40% contribution to be made by the industry',
                            ismultiple: true,
                            remarks: null
                        }
                    ]
            },
            {
                projecttype: 'Large Service Enterprises',
                block: 'B',
                incentives: [
                    {
                       name: 'Investment Subsidy on SGST',
                       value1: '50%',
                       value2: null,
                       constraints1: '50% of net VAT/SGST paid for a period of 5 years ',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'a) Only for new enterprise b) Applicable from date of commencement of service'
                    },
                    {
                       name: 'Entertainment Tax/ SGST (except cinema halls)',
                       value1: '50%',
                       value2: null,
                       constraints1: '50% tax exemption for 5 years',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'a) Only for new enterprise b) Cap of 100% of fixed capital investment'
                    },
                    {
                       name: 'Stamp Duty Exemption',
                       value1: '30%',
                       value2: null,
                       constraints1: '30% stamp duty within 5 years of filing of IEM',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'Only for new enterprise'
                    },
                    {
                       name: 'Electricity Duty Expemption',
                       value1: '50%',
                       value2: null,
                       constraints1: '50% payment of Electricity duty for 5 years',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'Only for new enterprise'
                    }
                ]
            },
            {
                projecttype: 'Large Service Enterprises',
                block: 'C',
                incentives: [
                    {
                       name: 'Investment Subsidy on SGST',
                       value1: '50%',
                       value2: null,
                       constraints1: '50% of net VAT/SGST paid for a period of 5 years ',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'a) Only for new enterprise b) Applicable from date of commencement of service'
                    },
                    {
                       name: 'Entertainment Tax/ SGST (except cinema halls)',
                       value1: '50%',
                       value2: null,
                       constraints1: '50% tax exemption for 5 years',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'a) Only for new enterprise b) Cap of 100% of fixed capital investment'
                    },
                    {
                       name: 'Stamp Duty Exemption',
                       value1: '50%',
                       value2: null,
                       constraints1: 'stamp duty within 5 years of filing of IEM',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'Only for new enterprise'
                    },
                    {
                       name: 'Electricity Duty Expemption',
                       value1: '75%',
                       value2: null,
                       constraints1: 'payment of Electricity duty for 5 years',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'Only for new enterprise'
                    }
                ]
            },
            {
                projecttype: 'Large Service Enterprises',
                block: 'D',
                incentives: [
                    {
                       name: 'Investment Subsidy on SGST',
                       value1: '50%',
                       value2: null,
                       constraints1: '50% of net VAT/SGST paid for a period of 5 years ',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'a) Only for new enterprise b) Applicable from date of commencement of service'
                    },
                    {
                       name: 'Entertainment Tax/ SGST (except cinema halls)',
                       value1: '50%',
                       value2: null,
                       constraints1: '50% tax exemption for 5 years',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'a) Only for new enterprise b) Cap of 100% of fixed capital investment'
                    },
                    {
                       name: 'Stamp Duty Exemption',
                       value1: '50%',
                       value2: null,
                       constraints1: 'stamp duty within 5 years of filing of IEM',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'Only for new enterprise'
                    },
                    {
                       name: 'Electricity Duty Expemption',
                       value1: '75%',
                       value2: null,
                       constraints1: 'payment of Electricity duty for 5 years',
                       constraints2: null,
                       ismultiple: false,
                       remarks: 'Only for new enterprise'
                    }
                ]
            }
        ];

        var incentivesBySector = [
            {
                sectortype: 'Agro',
                block: 'A',
                incentives: [
                    {
                        name: 'Market Fee Exemption',
                        value1: 'Misc',
                        value2: 'Misc',
                        constraints1: 'No market fee would be charged on the vegetables and fruits grown in the State and consumed as raw material by the food processing industry located within the State of Haryana.',
                        constraints2: 'No market fee would be charged on agriculture and horticulture produce used as raw material by food processing industries within the State except paddy, sugar, oil-seeds, til, toria, taramira.',
                        ismultiple: true,
                        remarks: null
                    }
                ]
            },
            {
                sectortype: 'Agro',
                block: 'B',
                incentives: [
                    {
                        name: 'VAT/SGST Subsidy',
                        value1: '75% and 35%',
                        value2: '75% and 50%',
                        constraints1: '75% of net SGST paid for first 7 years 35% of net SGST paid for next 3 years',
                        constraints2: '75% of net SGST paid for  7 years AND 35% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification.',
                        ismultiple: true,
                        remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI.'
                    },
                    {
                        name: 'Interest Subsidy',
                        value1: '6%',
                        value2: null,
                        constraints1: '6% on term loan for for 5 years',
                        ismultiple: false,
                        remarks: 'a) Upto a maximum of INR 10 Lakhs b) Shall not exceed the amount of net VAT/ SGST paid in the State by the enterprise during the relevant year.',
                    },
                    {
                        name: 'Stamp Duty Refund',
                        value1: '80%',
                        value2: null,
                        constraints1: '80% refund of stamp duty within 5 years of filing of IEM',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer.',
                    },
                    {
                        name: 'EDC Charges',
                        value1: '50%',
                        value2: null,
                        constraints1: '50% exemption of External Development Charges ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    // {
                    //     name: 'Power Tariff Subsidy(Only for Medium & Large Enterprise)',
                    //     value1: 'Misc',
                    //     value2: null,
                    //     constraints1: 'Exemption from open excess charges of 93 paisa per unit',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: null
                    // },
                    {
                        name: 'Electricity Duty Exemption',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% Exemption from payment of Electricity duty for 10 years',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                    },
                    {
                        name: 'Primary Processing Center',
                        value1: '50%',
                        value2: null,
                        constraints1: 'Capital subsidy @ 50% of FCI on plant & machinery and technical works,  for eligible entrepreneurs engaged in washing, grading, waxing, drying, packaging, cold chain and processing of fruits & vegetables using local produce as raw material',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Upto a maximum of Rs. 1.75 crore'
                    },
                    {
                        name: 'Excise Duty Exemption',
                        value1: 'Misc',
                        value2: null,
                        constraints1: 'Wines/ Liquors/ Brandy etc. made from 100% fruits and Barley produced in the State will be exempted from the Excise Duty',
                        ismultiple: false,
                        remarks: null

                    },
                    {
                        name: 'Market Fee Exemption',
                        value1: 'Misc',
                        value2: 'Misc',
                        constraints1: 'No market fee would be charged on the vegetables and fruits grown in the State and consumed as raw material by the food processing industry located within the State of Haryana.',
                        constraints2: 'No market fee would be charged on agriculture and horticulture produce used as raw material by food processing industries within the State except paddy, sugar, oil-seeds, til, toria, taramira.',
                        ismultiple: false,
                        remarks: null
                    }
                ]
            },
            {
                sectortype: 'Agro',
                block: 'C',
                incentives: [
                    {
                        name: 'VAT/SGST Subsidy',
                        value1: '75% and 35%',
                        value2: '75% and 50%',
                        constraints1: '75% of net SGST paid for first 7 years 35% of net SGST paid for next 3 years',
                        constraints2: '75% of net SGST paid for  7 years AND 35% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification.',
                        ismultiple: true,
                        remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI.'
                    },
                    {
                        name: 'Interest Subsidy',
                        value1: '6%',
                        value2: null,
                        constraints1: '6% on term loan for for 5 years',
                        ismultiple: false,
                        remarks: 'a) Upto a maximum of INR 10 Lakhs b) Shall not exceed the amount of net VAT/ SGST paid in the State by the enterprise during the relevant year.',
                    },
                    {
                        name: 'Stamp Duty Refund',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% refund of stamp duty within 5 years of filing of IEM',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer.',
                    },
                    {
                        name: 'EDC Charges',
                        value1: '50%',
                        value2: null,
                        constraints1: '50% exemption of External Development Charges ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Micro & Small)',
                    //     value1: 'Rs.2 per unit',
                    //     value2: null,
                    //     constraints1: 'Rs. 2 per unit for 3 years',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: 'Applicable from date of release of electricity connection'
                    // },
                    // {
                    //     name: 'Power Tariff Subsidy(Only for Medium & Large Enterprise)',
                    //     value1: 'Misc',
                    //     value2: null,
                    //     constraints1: 'Exemption from open excess charges of 93 paisa per unit',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: null
                    // },
                    {
                        name: 'Electricity Duty Exemption',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% Exemption from payment of Electricity duty for 10 years',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                    },
                    {
                        name: 'Primary Processing Center',
                        value1: '50%',
                        value2: null,
                        constraints1: 'Capital subsidy @ 50% of FCI on plant & machinery and technical works,  for eligible entrepreneurs engaged in washing, grading, waxing, drying, packaging, cold chain and processing of fruits & vegetables using local produce as raw material',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Upto a maximum of Rs. 1.75 crore'
                    },
                    {
                        name: 'Excise Duty Exemption',
                        value1: 'Misc',
                        value2: null,
                        constraints1: 'Wines/ Liquors/ Brandy etc. made from 100% fruits and Barley produced in the State will be exempted from the Excise Duty',
                        ismultiple: false,
                        remarks: null

                    },
                    {
                        name: 'Market Fee Exemption',
                        value1: 'Misc',
                        value2: 'Misc',
                        constraints1: 'No market fee would be charged on the vegetables and fruits grown in the State and consumed as raw material by the food processing industry located within the State of Haryana.',
                        constraints2: 'No market fee would be charged on agriculture and horticulture produce used as raw material by food processing industries within the State except paddy, sugar, oil-seeds, til, toria, taramira.',
                        ismultiple: false,
                        remarks: null
                    }
                ]
            },
            {
                sectortype: 'Agro',
                block: 'D',
                incentives: [
                    {
                        name: 'VAT/SGST Subsidy',
                        value1: '75% and 35%',
                        value2: '75% and 50%',
                        constraints1: '75% of net SGST paid for first 7 years 35% of net SGST paid for next 3 years',
                        constraints2: '75% of net SGST paid for  7 years AND 35% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification.',
                        ismultiple: true,
                        remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI.'
                    },
                    {
                        name: 'Interest Subsidy',
                        value1: '6%',
                        value2: null,
                        constraints1: '6% on term loan for for 5 years',
                        ismultiple: false,
                        remarks: 'a) Upto a maximum of INR 10 Lakhs b) Shall not exceed the amount of net VAT/ SGST paid in the State by the enterprise during the relevant year.',
                    },
                    {
                        name: 'Stamp Duty Refund',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% refund of stamp duty within 5 years of filing of IEM',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer.',
                    },
                    {
                        name: 'EDC Charges',
                        value1: '50%',
                        value2: null,
                        constraints1: '50% exemption of External Development Charges ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Micro & Small)',
                    //     value1: 'Rs.2 per unit',
                    //     value2: null,
                    //     constraints1: 'Rs. 2 per unit for 3 years',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: 'Applicable from date of release of electricity connection'
                    // },
                    // {
                    //     name: 'Power Tariff Subsidy(Only for Medium & Large Enterprise)',
                    //     value1: 'Misc',
                    //     value2: null,
                    //     constraints1: 'Exemption from open excess charges of 93 paisa per unit',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: null
                    // },
                    {
                        name: 'Electricity Duty Exemption',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% Exemption from payment of Electricity duty for 10 years',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                    },
                    {
                        name: 'Primary Processing Center',
                        value1: '50%',
                        value2: null,
                        constraints1: 'Capital subsidy @ 50% of FCI on plant & machinery and technical works,  for eligible entrepreneurs engaged in washing, grading, waxing, drying, packaging, cold chain and processing of fruits & vegetables using local produce as raw material',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Upto a maximum of Rs. 1.75 crore'
                    },
                    {
                        name: 'Excise Duty Exemption',
                        value1: 'Misc',
                        value2: null,
                        constraints1: 'Wines/ Liquors/ Brandy etc. made from 100% fruits and Barley produced in the State will be exempted from the Excise Duty',
                        ismultiple: false,
                        remarks: null

                    },
                    {
                        name: 'Market Fee Exemption',
                        value1: 'Misc',
                        value2: 'Misc',
                        constraints1: 'No market fee would be charged on the vegetables and fruits grown in the State and consumed as raw material by the food processing industry located within the State of Haryana.',
                        constraints2: 'No market fee would be charged on agriculture and horticulture produce used as raw material by food processing industries within the State except paddy, sugar, oil-seeds, til, toria, taramira.',
                        ismultiple: false,
                        remarks: null
                    }
                ]
            },
            {
                sectortype: 'Textile',
                block: 'A',
                incentives: [
                    {
                        name: 'VAT Exemption on cotton yarn',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% VAT exemption of VAT@ 5.25% on cotton yarn manufactured in the State',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    }
                ]
            },
            {
                sectortype: 'Textile',
                block: 'B',
                incentives: [
                    {
                        name: 'VAT/SGST Subsidy',
                        value1: '50% and 25%',
                        value2: '50% and 50%',
                        constraints1: '50% of net SGST paid for first 5 years and 25% of net SGST paid for next 3 years',
                        constraints2: '50% of net SGST paid for 5 years AND 25% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification',
                        ismultiple: true,
                        remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI.'
                    },
                    {
                        name: 'Employment Generation Subsidy',
                        value1: 'Rs.10000',
                        value2: null,
                        constraints1: 'One time support of INR 10,000/- for capacity building of persons belonging to Haryana engaged in apparel rural functional clusters',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'Interest Subsidy (only for MSME)',
                        value1: '6%',
                        value2: '5%',
                        constraints1: '6% on term loan for new/ expansion/ diversification for 5 years for garments/ knitting/ embroidery/ technical textiles',
                        constraints2: '5% for ginning, cotton spinning and power loom MSMEs maximum of Rs. 10 lakh for 5 years',
                        ismultiple: true,
                        remarks: 'a) Upto a maximum of INR 10 Lakhs b) Shall not exceed the amount of net VAT/ SGST paid in the State by the enterprise during the relevant year.'
                    },
                    {
                        name: 'Stamp Duty Refund',
                        value1: '80%',
                        value2: null,
                        constraints1: '80% refund of stamp duty within 5 years of filing of IEM',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer'
                    },
                    {
                        name: 'EDC Charges',
                        value1: '50%',
                        value2: null,
                        constraints1: '50% exemption of External Development Charges ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Medium & Large Enterprise)',
                    //     value1: 'Misc',
                    //     value2: null,
                    //     constraints1: 'Exemption from open excess charges of 93 paisa per unit',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: null
                    // },
                    {
                        name: 'Electricity Duty Exemption',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% Exemption from payment of Electricity duty for 10 years',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                    },
                    {
                        name: 'Mandi Fees Exemption',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% exemption in case of ginning enterprises',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'Transfer Property Tax Exemption',
                        value1: 'Misc',
                        value2: null,
                        constraints1: 'Exemption from Transfer Property Tax in case of Dyes & Chemicals purchased from outside the state being used in process house. ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'VAT Exemption on cotton yarn',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% VAT exemption of VAT@ 5.25% on cotton yarn manufactured in the State',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    }
                ]
            },
            {
                sectortype: 'Textile',
                block: 'C',
                incentives: [
                    {
                        name: 'VAT/SGST Subsidy',
                        value1: '75% and 35%',
                        value2: '75% and 50%',
                        constraints1: '75% of net SGST paid for first 7 years and 35% of net SGST paid for next 3 years',
                        constraints2: '75% of net SGST paid for 7 years AND 35% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification',
                        ismultiple: true,
                        remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI.'
                    },
                    {
                        name: 'Employment Generation Subsidy',
                        value1: 'Rs.10000',
                        value2: null,
                        constraints1: 'One time support of INR 10,000/- for capacity building of persons belonging to Haryana engaged in apparel rural functional clusters',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'Interest Subsidy (only for MSME)',
                        value1: '6%',
                        value2: '5%',
                        constraints1: '6% on term loan for new/ expansion/ diversification for 5 years for garments/ knitting/ embroidery/ technical textiles',
                        constraints2: '5% for ginning, cotton spinning and power loom MSMEs maximum of Rs. 10 lakh for 5 years',
                        ismultiple: true,
                        remarks: 'a) Upto a maximum of INR 10 Lakhs b) Shall not exceed the amount of net VAT/ SGST paid in the State by the enterprise during the relevant year.'
                    },
                    {
                        name: 'Stamp Duty Refund',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% refund of stamp duty within 5 years of filing of IEM',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer'
                    },
                    {
                        name: 'EDC Charges',
                        value1: '50%',
                        value2: null,
                        constraints1: '50% exemption of External Development Charges ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Micro & Small)',
                    //     value1: 'Rs.2 per unit',
                    //     value2: null,
                    //     constraints1: 'Rs. 2 per unit for 3 years',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: 'Applicable from date of release of electricity connection'
                    // },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Medium & Large Enterprise)',
                    //     value1: 'Misc',
                    //     value2: null,
                    //     constraints1: 'Exemption from open excess charges of 93 paisa per unit',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: null
                    // },
                    {
                        name: 'Electricity Duty Exemption',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% Exemption from payment of Electricity duty for 10 years',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                    },
                    {
                        name: 'Mandi Fees Exemption',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% exemption in case of ginning enterprises',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'Transfer Property Tax Exemption',
                        value1: 'Misc',
                        value2: null,
                        constraints1: 'Exemption from Transfer Property Tax in case of Dyes & Chemicals purchased from outside the state being used in process house. ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'VAT Exemption on cotton yarn',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% VAT exemption of VAT@ 5.25% on cotton yarn manufactured in the State',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    }
                ]
            },
            {
                sectortype: 'Textile',
                block: 'D',
                incentives: [
                    {
                        name: 'VAT/SGST Subsidy',
                        value1: '75% and 35%',
                        value2: '75% and 50%',
                        constraints1: '75% of net SGST paid for first 7 years and 35% of net SGST paid for next 3 years',
                        constraints2: '75% of net SGST paid for 7 years AND 35% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification',
                        ismultiple: true,
                        remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI.'
                    },
                    {
                        name: 'Employment Generation Subsidy',
                        value1: 'Rs.10000',
                        value2: null,
                        constraints1: 'One time support of INR 10,000/- for capacity building of persons belonging to Haryana engaged in apparel rural functional clusters',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'Interest Subsidy (only for MSME)',
                        value1: '6%',
                        value2: '5%',
                        constraints1: '6% on term loan for new/ expansion/ diversification for 5 years for garments/ knitting/ embroidery/ technical textiles',
                        constraints2: '5% for ginning, cotton spinning and power loom MSMEs maximum of Rs. 10 lakh for 5 years',
                        ismultiple: true,
                        remarks: 'a) Upto a maximum of INR 10 Lakhs b) Shall not exceed the amount of net VAT/ SGST paid in the State by the enterprise during the relevant year.'
                    },
                    {
                        name: 'Stamp Duty Refund',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% refund of stamp duty within 5 years of filing of IEM',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer'
                    },
                    {
                        name: 'EDC Charges',
                        value1: '50%',
                        value2: null,
                        constraints1: '50% exemption of External Development Charges ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Micro & Small)',
                    //     value1: 'Rs.2 per unit',
                    //     value2: null,
                    //     constraints1: 'Rs. 2 per unit for 3 years',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: 'Applicable from date of release of electricity connection'
                    // },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Medium & Large Enterprise)',
                    //     value1: 'Misc',
                    //     value2: null,
                    //     constraints1: 'Exemption from open excess charges of 93 paisa per unit',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: null
                    // },
                    {
                        name: 'Electricity Duty Exemption',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% Exemption from payment of Electricity duty for 10 years',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                    },
                    {
                        name: 'Mandi Fees Exemption',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% exemption in case of ginning enterprises',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'Transfer Property Tax Exemption',
                        value1: 'Misc',
                        value2: null,
                        constraints1: 'Exemption from Transfer Property Tax in case of Dyes & Chemicals purchased from outside the state being used in process house. ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'VAT Exemption on cotton yarn',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% VAT exemption of VAT@ 5.25% on cotton yarn manufactured in the State',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    }
                ]
            },
            {
                sectortype: 'Footwear',
                block: 'A',
                incentives: [
                    {
                        name: 'VAT Exemption',
                        value1: '5%',
                        value2: null,
                        constraints1: '5% VAT in place of existing 12.5% on the footwear above Rs. 500/-.',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    }
                ]
            },
            {
                sectortype: 'Footwear',
                block: 'B',
                incentives: [
                    {
                        name: 'VAT/SGST Subsidy',
                        value1: '50% and 25%',
                        value2: '50% and 50%',
                        constraints1: '50% of net SGST paid for first 5 years and 25% of net SGST paid for next 3 years',
                        constraints2: '50% of net SGST paid for 5 years AND 25% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification',
                        ismultiple: true,
                        remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI.'
                    },
                    {
                        name: 'Employment Generation Subsidy',
                        value1: 'Rs.10000',
                        value2: null,
                        constraints1: 'One time support of INR 10,000/- for capacity building of persons belonging to Haryana engaged in apparel rural functional clusters',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'Interest Subsidy (only for MSME)',
                        value1: '6%',
                        value2: null,
                        constraints1: '6% for 5 years',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'a) Upto a maximum of INR 10 Lakhs b) Shall not exceed the amount of net VAT/ SGST paid in the State by the enterprise during the relevant year.'
                    },
                    {
                        name: 'Stamp Duty Refund',
                        value1: '80%',
                        value2: null,
                        constraints1: '80% refund of stamp duty within 5 years of filing of IEM',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer'
                    },
                    {
                        name: 'EDC Charges',
                        value1: '50%',
                        value2: null,
                        constraints1: '50% exemption of External Development Charges ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Medium & Large Enterprise)',
                    //     value1: 'Misc',
                    //     value2: null,
                    //     constraints1: 'Exemption from open excess charges of 93 paisa per unit',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: null
                    // },
                    {
                        name: 'VAT Exemption',
                        value1: '5%',
                        value2: null,
                        constraints1: '5% VAT in place of existing 12.5% on the footwear above Rs. 500/-.',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    }
                ]
            },
            {
                sectortype: 'Footwear',
                block: 'C',
                incentives: [
                    {
                        name: 'VAT/SGST Subsidy',
                        value1: '75% and 35%',
                        value2: '75% and 50%',
                        constraints1: '75% of net SGST paid for first 7 years and 35% of net SGST paid for next 3 years',
                        constraints2: '75% of net SGST paid for 7 years AND 35% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification',
                        ismultiple: true,
                        remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI.'
                    },
                    {
                        name: 'Employment Generation Subsidy',
                        value1: 'Rs.10000',
                        value2: null,
                        constraints1: 'One time support of INR 10,000/- for capacity building of persons belonging to Haryana engaged in apparel rural functional clusters',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'Interest Subsidy (only for MSME)',
                        value1: '6%',
                        value2: null,
                        constraints1: '6% for 5 years',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'a) Upto a maximum of INR 10 Lakhs b) Shall not exceed the amount of net VAT/ SGST paid in the State by the enterprise during the relevant year.'
                    },
                    {
                        name: 'Stamp Duty Refund',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% refund of stamp duty within 5 years of filing of IEM',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer'
                    },
                    {
                        name: 'EDC Charges',
                        value1: '50%',
                        value2: null,
                        constraints1: '50% exemption of External Development Charges ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Micro & Small)',
                    //     value1: 'Rs.2 per unit',
                    //     value2: null,
                    //     constraints1: 'Rs. 2 per unit for 3 years',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: 'Applicable from date of release of electricity connection'
                    // },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Medium & Large Enterprise)',
                    //     value1: 'Misc',
                    //     value2: null,
                    //     constraints1: 'Exemption from open excess charges of 93 paisa per unit',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: null
                    // },
                    {
                        name: 'Electricity Duty Exemption',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% Exemption from payment of Electricity duty for 10 years',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                    },
                    {
                        name: 'VAT Exemption',
                        value1: '5%',
                        value2: null,
                        constraints1: '5% VAT in place of existing 12.5% on the footwear above Rs. 500/-.',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    }
                ]
            },
            {
                sectortype: 'Footwear',
                block: 'D',
                incentives: [
                    {
                        name: 'VAT/SGST Subsidy',
                        value1: '75% and 35%',
                        value2: '75% and 50%',
                        constraints1: '75% of net SGST paid for first 7 years and 35% of net SGST paid for next 3 years',
                        constraints2: '75% of net SGST paid for 7 years AND 35% of net SGST paid for next 3 years on atleast 50% additional investment in plant and machineryfor expansion/ diversification',
                        ismultiple: true,
                        remarks: 'a)Applicable from date of commencement of commercial production with cap of 100% of fixed capital investment b)Cap of 100% of fixed capital investment on expanded FCI.'
                    },
                    {
                        name: 'Employment Generation Subsidy',
                        value1: 'Rs.10000',
                        value2: null,
                        constraints1: 'One time support of INR 10,000/- for capacity building of persons belonging to Haryana engaged in apparel rural functional clusters',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    {
                        name: 'Interest Subsidy (only for MSME)',
                        value1: '6%',
                        value2: null,
                        constraints1: '6% for 5 years',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'a) Upto a maximum of INR 10 Lakhs b) Shall not exceed the amount of net VAT/ SGST paid in the State by the enterprise during the relevant year.'
                    },
                    {
                        name: 'Stamp Duty Refund',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% refund of stamp duty within 5 years of filing of IEM',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'Applicable on purchase/ leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/ private developer'
                    },
                    {
                        name: 'EDC Charges',
                        value1: '50%',
                        value2: null,
                        constraints1: '50% exemption of External Development Charges ',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Micro & Small)',
                    //     value1: 'Rs.2 per unit',
                    //     value2: null,
                    //     constraints1: 'Rs. 2 per unit for 3 years',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: 'Applicable from date of release of electricity connection'
                    // },
                    // {
                    //     name: 'Power Tariff Subsidy (Only for Medium & Large Enterprise)',
                    //     value1: 'Misc',
                    //     value2: null,
                    //     constraints1: 'Exemption from open excess charges of 93 paisa per unit',
                    //     constraints2: null,
                    //     ismultiple: false,
                    //     remarks: null
                    // },
                    {
                        name: 'Electricity Duty Exemption',
                        value1: '100%',
                        value2: null,
                        constraints1: '100% Exemption from payment of Electricity duty for 10 years',
                        constraints2: null,
                        ismultiple: false,
                        remarks: 'a) Only for new Enterprises b) Applicable from date of release of electricity connection'
                    },
                    {
                        name: 'VAT Exemption',
                        value1: '5%',
                        value2: null,
                        constraints1: '5% VAT in place of existing 12.5% on the footwear above Rs. 500/-.',
                        constraints2: null,
                        ismultiple: false,
                        remarks: null
                    }
                ]
            }

        ]
        var projectSize;
        return {
            getIncentives: function (projectsize, block, sector, type) {
                return $filter('filter')(incentives, {projecttype: projectsize, block: block});
            },
            getITSectorIncentives: function (block) {

            },
            getSectorSpecificIncentives: function (sector, block) {
                return $filter('filter')(incentivesBySector, {sectortype: sector, block: block});
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IncentiveWizardController', IncentiveWizardController);

    IncentiveWizardController.$inject = ['$scope', '$state','$filter','districts','sectors','IncentiveBlockMapping','Incentives','$location', 'IncentiveWizardProps'];

    function IncentiveWizardController($scope,$state,$filter,districts,sectors,Block,Incentives,$location, IncentiveWizardProps) {
        var vm = this;
        vm.calculateIncentives=calculateIncentives;
        vm.districts = [];
        vm.projecttype = null;
        vm.total_project_turnover = 0;
        vm.showTurnOverInput = false;
        vm.showServiceTypes = true;
        vm.showIncentives = false;
        vm.selectedSector = null;
        $scope.projecttype = null;
        vm.calculatedProjectType = null;
        vm.isLoadingIncentives = false;
        vm.notIncentivesFound = false;
        vm.incentivesData = null;
        vm.selectedProjectType = null;
        vm.projecttype = 'services';
        vm.isConfirmed=false;
        vm.showStartup = false;
        loadAll();
        vm.isEPPOnly = true;
        angular.forEach(districts, function(value, key){
            if((value.districtname!== 'Chandigarh HQ')){
                vm.districts.push(value);
            }
        });
            function loadAll(){
                       ga('set', 'page', $location.path());ga('send','pageview');
                    }

        vm.sectors=sectors;
        vm.incentives={};
        vm.incentives.projectsector='All';
        vm.result={};
        vm.result.incentives=[];
        vm.result.sectorincentives=[];
        vm.loadBlocksByDistrict=loadBlocksByDistrict;
        vm.sectorSpecificeResult = {};
        vm.eppWithSector = {};
        vm.incentiveResult = vm.incentives;

        function loadBlocksByDistrict() {
            if(vm.incentives.projectdistrict === "Hissar") {
                vm.incentives.district = "Hisar";
            } else {
                vm.incentives.district = vm.incentives.projectdistrict;
            }
            Block.query({districtName: vm.incentives.district},function (result) {
                vm.blocks=result;
            });
        }

        vm.getConfirmation = function(){
            vm.isConfirmed = true;
            if(vm.isConfirmed){
                vm.calculateIncentives();
            }
            vm.showIncentives = true;
        }

        vm.dismiss=function(){
            vm.showIncentives = false;
            $("#incentivesModal").modal('hide');
        }

        function calculateIncentives() {
            ga('set', 'page', "/calculated-incentives");ga('send','pageview');

            vm.calculateProjectType(vm.getProjectType);
            if(vm.selectedTextile != null){
                vm.incentives.projectsector = vm.selectedTextile;
            }else if(vm.selectedAgro != null){
                vm.incentives.projectsector = vm.selectedAgro;
            }
            vm.loadIncentives();
        }

        vm.getProjectType = function() {
            var result=Incentives.getIncentives(vm.result.projectsize,vm.block.blocktype,vm.incentives.projectsector,vm.projecttype);
//            vm.result.incentives=result[0]===undefined?[]:result[0].incentives;
            vm.result.incentives=result[0].incentives;
            var sectorSpecificeResult = Incentives.getSectorSpecificIncentives(vm.incentives.projectsector,vm.block.blocktype);
            vm.sectorSpecificeResult.incentives=sectorSpecificeResult[0]===undefined?[]:sectorSpecificeResult[0].incentives;
            vm.eppWithSector.incentives = clubResults(vm.result.incentives, vm.sectorSpecificeResult.incentives);
        }


        vm.getSelectedSector = function(selectedSector){
            if(selectedSector == 'Agro' || selectedSector == 'Footwear' || selectedSector == 'Textiles'){
                vm.isEPPOnly = false;
            }else{
                vm.isEPPOnly = true;
            }
        }

        vm.loadProjectType = function(selectedProjectType){
            $scope.projecttype = selectedProjectType;
            if(selectedProjectType == 'services'){
                vm.showServiceTypes = true;
                vm.showManufacturingTypes = false;
            }else if(selectedProjectType == 'manufacturing'){
                vm.showServiceTypes = false;
                vm.showManufacturingTypes = true;
            }
        }

        vm.loadBlockType = function(){
            vm.block=$filter('filter')(vm.blocks,{districtName: vm.incentives.district,blockName:vm.incentives.projectblock}, true)[0];
            vm.incentives.blockType = vm.block.blockType;
        };
        function clubResults(eppincentives, sectorIncentives){
            var newItems = [];
            var itemsToBeChanged = [];
            var indexForItemsToBeChanged = [];
            var incentiveIndexesForNewItems = [];
            eppincentives.forEach(function(e1,index){
                for(var i = 0; i < sectorIncentives.length; i++){
                    if(e1.name === sectorIncentives[i].name){
                        indexForItemsToBeChanged.push(index);
                       if(sectorIncentives[i].value1 !== null){
                           e1.value3 = sectorIncentives[i].value1;
                           if(sectorIncentives[i].constraints1 !== null){
                               e1.constraints3 = sectorIncentives[i].constraints1;
                           }
                           if(sectorIncentives[i].value2 !== null){
                               e1.value4 = sectorIncentives[i].value2;
                               if(sectorIncentives[i].constraints2 !== null){
                                   e1.constraints4 = sectorIncentives[i].constraints2;
                               }
                           }
                       }
                       e1.remarks1 = e1.remarks;
                       e1.remarks2 = sectorIncentives[i].remarks;
                       itemsToBeChanged.push(e1);
                    }else if(sectorIncentives[i].name.includes(e1.name)){
                       incentiveIndexesForNewItems.push(index);
                       newItems.push(sectorIncentives[i]);
                    }
                }
            });
            for(var j = 0; j < indexForItemsToBeChanged.length; j++){
                eppincentives[indexForItemsToBeChanged[j]] = itemsToBeChanged[j];
            }
            for(var k = 0; k < incentiveIndexesForNewItems.length; k++){
                eppincentives.splice(incentiveIndexesForNewItems[k],0,newItems.shift());
            }
            return eppincentives;
        }

        vm.calculateProjectType = function(callback){
            if (!vm.incentives.blockType) {
                return 'Ivalid Block type';
            }
            if (vm.incentives.blockType === 'A') {
                if (vm.total_project_cost >= 6000) {
                   return  vm.incentives.projectSize = 'Ultra-Mega';
                } else {
                    return getProjectTypeMappingWithoutBlockType();
                }
            } else if (vm.incentives.blockType === 'B') {
                if (vm.total_project_cost >= 4500) {
                    return  vm.incentives.projectSize = 'Ultra-Mega';
                } else if (vm.total_project_cost < 4500 && vm.total_project_cost >= 200) {
                    return vm.incentives.projectSize = 'Mega';
                } else {
                    return getProjectTypeMappingWithoutBlockType();
                }
            } else if (vm.incentives.blockType === 'C') {
                if (vm.total_project_cost >= 3000) {
                    return  vm.incentives.projectSize = 'Ultra-Mega';
                } else if (vm.total_project_cost < 3000 && vm.total_project_cost >= 100) {
                    return vm.incentives.projectSize = 'Mega';
                } else {
                    return getProjectTypeMappingWithoutBlockType();
                }
            }  else if (vm.incentives.blockType === 'D') {
                if (vm.total_project_cost >= 1500) {
                    return  vm.incentives.projectSize = 'Ultra-Mega';
                } else if (vm.total_project_cost < 1500 && vm.total_project_cost >= 75) {
                    return vm.incentives.projectSize = 'Mega';
                } else {
                    return getProjectTypeMappingWithoutBlockType();
                }
            }
        };

        vm.set_projectTurnover = function() {
            vm.incentives.trunover = vm.total_project_turnover;
            if (vm.total_project_turnover > 0 && vm.total_project_turnover < 50) {
                vm.showStartup = true;
            }

        };

        vm.loadIncentives = function() {
            vm.incentivesData = [];
            vm.notIncentivesFound = false;
            vm.incentivesData = null;
            vm.isLoadingIncentives = true;
            vm.incentiveResult.projectType = vm.incentiveResult.projectSize;
            vm.incentiveResult.businessType = vm.projecttype;
            IncentiveWizardProps.save(vm.incentiveResult, function (result) {
               vm.incentivesData = result;
               if (result.length === 0) {
                   vm.notIncentivesFound = true;
               }
                vm.isLoadingIncentives = false;
            });
        }


        vm.toggleTurnOverInput = function() {
            vm.showTurnOverInput = false;
            if (vm.total_project_cost < 75) {
                vm.showTurnOverInput = true;
            }
        };

        vm.toggleStartupInput = function(){
            vm.showStartup = false;
            if (vm.project_turnover_in_crore > 0 && vm.project_turnover_in_crore < 50){
                vm.showStartup = true;
            }
        };

        vm.changeInCost=function(){
              var projectCostInCrore=vm.project_cost_in_crore || '00';
              var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
              var projectCostInThousands=vm.project_cost_in_thousands||'00';
              if(vm.project_cost_in_lacs && vm.project_cost_in_lacs<10){
                 projectCostInLacs='0' + vm.project_cost_in_lacs;
              }
              if(vm.project_cost_in_thousands && vm.project_cost_in_thousands<10){
                 projectCostInThousands='0'+vm.project_cost_in_thousands;
              }
              vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
              vm.toggleTurnOverInput();
              vm.calculateProjectType(function(){
              });
        };

        vm.changeInTurnover = function(){
            var projectCostInCrore = vm.project_turnover_in_crore || '00';
            var projectCostInLacs = vm.project_turnover_in_lacs|| '00' ;
            var projectCostInThousands = vm.project_turnover_in_thousands||'00';
            if(vm.project_turnover_in_lacs && vm.project_turnover_in_lacs<10){
                projectCostInLacs='0'+vm.project_turnover_in_lacs;
            }
            if(vm.project_turnover_in_thousands && vm.project_turnover_in_thousands<10){
                projectCostInThousands='0'+vm.project_turnover_in_thousands;
            }
            vm.total_project_turnover = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
            vm.set_projectTurnover();
            vm.calculateProjectType(function(){
            });
            vm.toggleStartupInput();

        };

        function getProjectTypeMappingWithoutBlockType() {
            if (vm.total_project_cost > 50 || (vm.total_project_turnover > 250)) {
                vm.incentives.projectSize = 'Large';
            } else if (vm.total_project_cost <= 50 && vm.total_project_cost > 10 || (vm.total_project_turnover <= 250 && vm.total_project_turnover > 50)) {
                vm.incentives.projectSize = 'Medium';
            } else if (vm.total_project_cost <=10 && vm.total_project_cost > 1 || (vm.total_project_turnover <= 50 && vm.total_project_turnover > 5)) {
                vm.incentives.projectSize = 'Small';
            }  else if (vm.total_project_cost <= 1  || (vm.total_project_turnover <= 5)) {
                vm.incentives.projectSize = 'Micro';
            }
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('IncentiveWizardProps', IncentiveWizardProps);

    IncentiveWizardProps.$inject = ['$resource'];

    function IncentiveWizardProps ($resource) {
        var resourceUrl =  'api/incentive-wizard-rules/props/load';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {
                method: 'POST',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('searchHomeCAF', {
            parent: 'app',
            url: '/thirdPartyVerification',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/homeClearedServiceDocument/searchClearedHome.html',
                    controller: 'HomeClearedDocumentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });

        }
        })();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SearchHomeCAF', SearchHomeCAF);

    SearchHomeCAF.$inject = ['$resource'];

    function SearchHomeCAF ($resource) {
        var resourceUrl =  '/api/third-party-clearances/:CAFPIN';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomeClearedDocumentController', HomeClearedDocumentController);

    HomeClearedDocumentController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'SearchHomeCAF', 'downloadService'];

    function HomeClearedDocumentController ($scope, Principal, LoginService, $state, SearchHomeCAF, downloadService) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.getProject = getProject;
        vm.project=[];

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });


        // getAccount();
        //
        // function getAccount() {
        //     Principal.identity().then(function(account) {
        //         vm.account = account;
        //         vm.isAuthenticated = Principal.isAuthenticated;
        //     });
        // }
        function register () {
            $state.go('register');
        }
        function getProject()
        {
            vm.project=null;
            vm.showtable=false;
            SearchHomeCAF.query({CAFPIN:vm.CAFPIN},function(result){
                vm.project = result;
                if(vm.project.length !==0){
                    vm.noProject = false;
                    vm.showtable=true;
                }
                else{
                    vm.noProject = true;
                }
            });
        }
        $('.select_location').on('change', function(){
            window.location = $(this).val();
        });


        vm.downFile = function(project) {
            downloadService.download(project.fileName)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }
    }
})();

/*
 * SystemJS Polyfills for URL and Promise providing IE8+ Support
 */
!function(t){!function(t){function e(t,n){if("string"!=typeof t)throw new TypeError("URL must be a string");var o=String(t).replace(/^\s+|\s+$/g,"").match(/^([^:\/?#]+:)?(?:\/\/(?:([^:@\/?#]*)(?::([^:@\/?#]*))?@)?(([^:\/?#]*)(?::(\d*))?))?([^?#]*)(\?[^#]*)?(#[\s\S]*)?/);if(!o)throw new RangeError;var r=o[1]||"",i=o[2]||"",u=o[3]||"",c=o[4]||"",s=o[5]||"",f=o[6]||"",a=o[7]||"",h=o[8]||"",p=o[9]||"";if(void 0!==n){var l=n instanceof e?n:new e(n),d=""===r&&""===c&&""===i;d&&""===a&&""===h&&(h=l.search),d&&"/"!==a.charAt(0)&&(a=""!==a?(""===l.host&&""===l.username||""!==l.pathname?"":"/")+l.pathname.slice(0,l.pathname.lastIndexOf("/")+1)+a:l.pathname);var y=[];a.replace(/^(\.\.?(\/|$))+/,"").replace(/\/(\.(\/|$))+/g,"/").replace(/\/\.\.$/,"/../").replace(/\/?[^\/]*/g,function(t){"/.."===t?y.pop():y.push(t)}),a=y.join("").replace(/^\//,"/"===a.charAt(0)?"/":""),d&&(f=l.port,s=l.hostname,c=l.host,u=l.password,i=l.username),""===r&&(r=l.protocol)}"file:"==r&&(a=a.replace(/\\/g,"/")),this.origin=r+(""!==r||""!==c?"//":"")+c,this.href=r+(""!==r||""!==c?"//":"")+(""!==i?i+(""!==u?":"+u:"")+"@":"")+c+a+h+p,this.protocol=r,this.username=i,this.password=u,this.host=c,this.hostname=s,this.port=f,this.pathname=a,this.search=h,this.hash=p}t.URLPolyfill=e}("undefined"!=typeof self?self:global),!function(e){"object"==typeof exports?module.exports=e():"function"==typeof t&&t.amd?t(e):"undefined"!=typeof window?window.Promise=e():"undefined"!=typeof global?global.Promise=e():"undefined"!=typeof self&&(self.Promise=e())}(function(){var t;return function e(t,n,o){function r(u,c){if(!n[u]){if(!t[u]){var s="function"==typeof require&&require;if(!c&&s)return s(u,!0);if(i)return i(u,!0);throw new Error("Cannot find module '"+u+"'")}var f=n[u]={exports:{}};t[u][0].call(f.exports,function(e){var n=t[u][1][e];return r(n?n:e)},f,f.exports,e,t,n,o)}return n[u].exports}for(var i="function"==typeof require&&require,u=0;u<o.length;u++)r(o[u]);return r}({1:[function(t,e,n){var o=t("../lib/decorators/unhandledRejection"),r=o(t("../lib/Promise"));e.exports="undefined"!=typeof global?global.Promise=r:"undefined"!=typeof self?self.Promise=r:r},{"../lib/Promise":2,"../lib/decorators/unhandledRejection":4}],2:[function(e,n,o){!function(t){"use strict";t(function(t){var e=t("./makePromise"),n=t("./Scheduler"),o=t("./env").asap;return e({scheduler:new n(o)})})}("function"==typeof t&&t.amd?t:function(t){n.exports=t(e)})},{"./Scheduler":3,"./env":5,"./makePromise":7}],3:[function(e,n,o){!function(t){"use strict";t(function(){function t(t){this._async=t,this._running=!1,this._queue=this,this._queueLen=0,this._afterQueue={},this._afterQueueLen=0;var e=this;this.drain=function(){e._drain()}}return t.prototype.enqueue=function(t){this._queue[this._queueLen++]=t,this.run()},t.prototype.afterQueue=function(t){this._afterQueue[this._afterQueueLen++]=t,this.run()},t.prototype.run=function(){this._running||(this._running=!0,this._async(this.drain))},t.prototype._drain=function(){for(var t=0;t<this._queueLen;++t)this._queue[t].run(),this._queue[t]=void 0;for(this._queueLen=0,this._running=!1,t=0;t<this._afterQueueLen;++t)this._afterQueue[t].run(),this._afterQueue[t]=void 0;this._afterQueueLen=0},t})}("function"==typeof t&&t.amd?t:function(t){n.exports=t()})},{}],4:[function(e,n,o){!function(t){"use strict";t(function(t){function e(t){throw t}function n(){}var o=t("../env").setTimer,r=t("../format");return function(t){function i(t){t.handled||(l.push(t),a("Potentially unhandled rejection ["+t.id+"] "+r.formatError(t.value)))}function u(t){var e=l.indexOf(t);e>=0&&(l.splice(e,1),h("Handled previous rejection ["+t.id+"] "+r.formatObject(t.value)))}function c(t,e){p.push(t,e),null===d&&(d=o(s,0))}function s(){for(d=null;p.length>0;)p.shift()(p.shift())}var f,a=n,h=n;"undefined"!=typeof console&&(f=console,a="undefined"!=typeof f.error?function(t){f.error(t)}:function(t){f.log(t)},h="undefined"!=typeof f.info?function(t){f.info(t)}:function(t){f.log(t)}),t.onPotentiallyUnhandledRejection=function(t){c(i,t)},t.onPotentiallyUnhandledRejectionHandled=function(t){c(u,t)},t.onFatalRejection=function(t){c(e,t.value)};var p=[],l=[],d=null;return t}})}("function"==typeof t&&t.amd?t:function(t){n.exports=t(e)})},{"../env":5,"../format":6}],5:[function(e,n,o){!function(t){"use strict";t(function(t){function e(){return"undefined"!=typeof process&&"[object process]"===Object.prototype.toString.call(process)}function n(){return"function"==typeof MutationObserver&&MutationObserver||"function"==typeof WebKitMutationObserver&&WebKitMutationObserver}function o(t){function e(){var t=n;n=void 0,t()}var n,o=document.createTextNode(""),r=new t(e);r.observe(o,{characterData:!0});var i=0;return function(t){n=t,o.data=i^=1}}var r,i="undefined"!=typeof setTimeout&&setTimeout,u=function(t,e){return setTimeout(t,e)},c=function(t){return clearTimeout(t)},s=function(t){return i(t,0)};if(e())s=function(t){return process.nextTick(t)};else if(r=n())s=o(r);else if(!i){var f=t,a=f("vertx");u=function(t,e){return a.setTimer(e,t)},c=a.cancelTimer,s=a.runOnLoop||a.runOnContext}return{setTimer:u,clearTimer:c,asap:s}})}("function"==typeof t&&t.amd?t:function(t){n.exports=t(e)})},{}],6:[function(e,n,o){!function(t){"use strict";t(function(){function t(t){var n="object"==typeof t&&null!==t&&(t.stack||t.message)?t.stack||t.message:e(t);return t instanceof Error?n:n+" (WARNING: non-Error used)"}function e(t){var e=String(t);return"[object Object]"===e&&"undefined"!=typeof JSON&&(e=n(t,e)),e}function n(t,e){try{return JSON.stringify(t)}catch(n){return e}}return{formatError:t,formatObject:e,tryStringify:n}})}("function"==typeof t&&t.amd?t:function(t){n.exports=t()})},{}],7:[function(e,n,o){!function(t){"use strict";t(function(){return function(t){function e(t,e){this._handler=t===j?e:n(t)}function n(t){function e(t){r.resolve(t)}function n(t){r.reject(t)}function o(t){r.notify(t)}var r=new b;try{t(e,n,o)}catch(i){n(i)}return r}function o(t){return U(t)?t:new e(j,new g(v(t)))}function r(t){return new e(j,new g(new q(t)))}function i(){return Z}function u(){return new e(j,new b)}function c(t,e){var n=new b(t.receiver,t.join().context);return new e(j,n)}function s(t){return a(z,null,t)}function f(t,e){return a(J,t,e)}function a(t,n,o){function r(e,r,u){u.resolved||h(o,i,e,t(n,r,e),u)}function i(t,e,n){a[t]=e,0===--f&&n.become(new R(a))}for(var u,c="function"==typeof n?r:i,s=new b,f=o.length>>>0,a=new Array(f),p=0;p<o.length&&!s.resolved;++p)u=o[p],void 0!==u||p in o?h(o,c,p,u,s):--f;return 0===f&&s.become(new R(a)),new e(j,s)}function h(t,e,n,o,r){if(k(o)){var i=m(o),u=i.state();0===u?i.fold(e,n,void 0,r):u>0?e(n,i.value,r):(r.become(i),p(t,n+1,i))}else e(n,o,r)}function p(t,e,n){for(var o=e;o<t.length;++o)l(v(t[o]),n)}function l(t,e){if(t!==e){var n=t.state();0===n?t.visit(t,void 0,t._unreport):0>n&&t._unreport()}}function d(t){return"object"!=typeof t||null===t?r(new TypeError("non-iterable passed to race()")):0===t.length?i():1===t.length?o(t[0]):y(t)}function y(t){var n,o,r,i=new b;for(n=0;n<t.length;++n)if(o=t[n],void 0!==o||n in t){if(r=v(o),0!==r.state()){i.become(r),p(t,n+1,r);break}r.visit(i,i.resolve,i.reject)}return new e(j,i)}function v(t){return U(t)?t._handler.join():k(t)?w(t):new R(t)}function m(t){return U(t)?t._handler.join():w(t)}function w(t){try{var e=t.then;return"function"==typeof e?new x(e,t):new R(t)}catch(n){return new q(n)}}function j(){}function _(){}function b(t,n){e.createContext(this,n),this.consumers=void 0,this.receiver=t,this.handler=void 0,this.resolved=!1}function g(t){this.handler=t}function x(t,e){b.call(this),K.enqueue(new L(t,e,this))}function R(t){e.createContext(this),this.value=t}function q(t){e.createContext(this),this.id=++X,this.value=t,this.handled=!1,this.reported=!1,this._report()}function P(t,e){this.rejection=t,this.context=e}function C(t){this.rejection=t}function O(){return new q(new TypeError("Promise cycle"))}function T(t,e){this.continuation=t,this.handler=e}function E(t,e){this.handler=e,this.value=t}function L(t,e,n){this._then=t,this.thenable=e,this.resolver=n}function Q(t,e,n,o,r){try{t.call(e,n,o,r)}catch(i){o(i)}}function S(t,e,n,o){this.f=t,this.z=e,this.c=n,this.to=o,this.resolver=V,this.receiver=this}function U(t){return t instanceof e}function k(t){return("object"==typeof t||"function"==typeof t)&&null!==t}function H(t,n,o,r){return"function"!=typeof t?r.become(n):(e.enterContext(n),M(t,n.value,o,r),void e.exitContext())}function N(t,n,o,r,i){return"function"!=typeof t?i.become(o):(e.enterContext(o),$(t,n,o.value,r,i),void e.exitContext())}function A(t,n,o,r,i){return"function"!=typeof t?i.notify(n):(e.enterContext(o),F(t,n,r,i),void e.exitContext())}function J(t,e,n){try{return t(e,n)}catch(o){return r(o)}}function M(t,e,n,o){try{o.become(v(t.call(n,e)))}catch(r){o.become(new q(r))}}function $(t,e,n,o,r){try{t.call(o,e,n,r)}catch(i){r.become(new q(i))}}function F(t,e,n,o){try{o.notify(t.call(n,e))}catch(r){o.notify(r)}}function W(t,e){e.prototype=G(t.prototype),e.prototype.constructor=e}function z(t,e){return e}function B(){}function I(){return"undefined"!=typeof process&&null!==process&&"function"==typeof process.emit?function(t,e){return"unhandledRejection"===t?process.emit(t,e.value,e):process.emit(t,e)}:"undefined"!=typeof self&&"function"==typeof CustomEvent?function(t,e,n){var o=!1;try{var r=new n("unhandledRejection");o=r instanceof n}catch(i){}return o?function(t,o){var r=new n(t,{detail:{reason:o.value,key:o},bubbles:!1,cancelable:!0});return!e.dispatchEvent(r)}:t}(B,self,CustomEvent):B}var K=t.scheduler,D=I(),G=Object.create||function(t){function e(){}return e.prototype=t,new e};e.resolve=o,e.reject=r,e.never=i,e._defer=u,e._handler=v,e.prototype.then=function(t,e,n){var o=this._handler,r=o.join().state();if("function"!=typeof t&&r>0||"function"!=typeof e&&0>r)return new this.constructor(j,o);var i=this._beget(),u=i._handler;return o.chain(u,o.receiver,t,e,n),i},e.prototype["catch"]=function(t){return this.then(void 0,t)},e.prototype._beget=function(){return c(this._handler,this.constructor)},e.all=s,e.race=d,e._traverse=f,e._visitRemaining=p,j.prototype.when=j.prototype.become=j.prototype.notify=j.prototype.fail=j.prototype._unreport=j.prototype._report=B,j.prototype._state=0,j.prototype.state=function(){return this._state},j.prototype.join=function(){for(var t=this;void 0!==t.handler;)t=t.handler;return t},j.prototype.chain=function(t,e,n,o,r){this.when({resolver:t,receiver:e,fulfilled:n,rejected:o,progress:r})},j.prototype.visit=function(t,e,n,o){this.chain(V,t,e,n,o)},j.prototype.fold=function(t,e,n,o){this.when(new S(t,e,n,o))},W(j,_),_.prototype.become=function(t){t.fail()};var V=new _;W(j,b),b.prototype._state=0,b.prototype.resolve=function(t){this.become(v(t))},b.prototype.reject=function(t){this.resolved||this.become(new q(t))},b.prototype.join=function(){if(!this.resolved)return this;for(var t=this;void 0!==t.handler;)if(t=t.handler,t===this)return this.handler=O();return t},b.prototype.run=function(){var t=this.consumers,e=this.handler;this.handler=this.handler.join(),this.consumers=void 0;for(var n=0;n<t.length;++n)e.when(t[n])},b.prototype.become=function(t){this.resolved||(this.resolved=!0,this.handler=t,void 0!==this.consumers&&K.enqueue(this),void 0!==this.context&&t._report(this.context))},b.prototype.when=function(t){this.resolved?K.enqueue(new T(t,this.handler)):void 0===this.consumers?this.consumers=[t]:this.consumers.push(t)},b.prototype.notify=function(t){this.resolved||K.enqueue(new E(t,this))},b.prototype.fail=function(t){var e="undefined"==typeof t?this.context:t;this.resolved&&this.handler.join().fail(e)},b.prototype._report=function(t){this.resolved&&this.handler.join()._report(t)},b.prototype._unreport=function(){this.resolved&&this.handler.join()._unreport()},W(j,g),g.prototype.when=function(t){K.enqueue(new T(t,this))},g.prototype._report=function(t){this.join()._report(t)},g.prototype._unreport=function(){this.join()._unreport()},W(b,x),W(j,R),R.prototype._state=1,R.prototype.fold=function(t,e,n,o){N(t,e,this,n,o)},R.prototype.when=function(t){H(t.fulfilled,this,t.receiver,t.resolver)};var X=0;W(j,q),q.prototype._state=-1,q.prototype.fold=function(t,e,n,o){o.become(this)},q.prototype.when=function(t){"function"==typeof t.rejected&&this._unreport(),H(t.rejected,this,t.receiver,t.resolver)},q.prototype._report=function(t){K.afterQueue(new P(this,t))},q.prototype._unreport=function(){this.handled||(this.handled=!0,K.afterQueue(new C(this)))},q.prototype.fail=function(t){this.reported=!0,D("unhandledRejection",this),e.onFatalRejection(this,void 0===t?this.context:t)},P.prototype.run=function(){this.rejection.handled||this.rejection.reported||(this.rejection.reported=!0,D("unhandledRejection",this.rejection)||e.onPotentiallyUnhandledRejection(this.rejection,this.context))},C.prototype.run=function(){this.rejection.reported&&(D("rejectionHandled",this.rejection)||e.onPotentiallyUnhandledRejectionHandled(this.rejection))},e.createContext=e.enterContext=e.exitContext=e.onPotentiallyUnhandledRejection=e.onPotentiallyUnhandledRejectionHandled=e.onFatalRejection=B;var Y=new j,Z=new e(j,Y);return T.prototype.run=function(){this.handler.join().when(this.continuation)},E.prototype.run=function(){var t=this.handler.consumers;if(void 0!==t)for(var e,n=0;n<t.length;++n)e=t[n],A(e.progress,this.value,this.handler,e.receiver,e.resolver)},L.prototype.run=function(){function t(t){o.resolve(t)}function e(t){o.reject(t)}function n(t){o.notify(t)}var o=this.resolver;Q(this._then,this.thenable,t,e,n)},S.prototype.fulfilled=function(t){this.f.call(this.c,this.z,t,this.to)},S.prototype.rejected=function(t){this.to.reject(t)},S.prototype.progress=function(t){this.to.notify(t)},e}})}("function"==typeof t&&t.amd?t:function(t){n.exports=t()})},{}]},{},[1])(1)}),"undefined"!=typeof systemJSBootstrap&&systemJSBootstrap()}();


// function.name (all IE)
/*! @source http://stackoverflow.com/questions/6903762/function-name-not-supported-in-ie*/
if (!Object.hasOwnProperty('name')) {
  Object.defineProperty(Function.prototype, 'name', {
    get: function() {
      var matches = this.toString().match(/^\s*function\s*(\S*)\s*\(/);
      var name = matches && matches.length > 1 ? matches[1] : "";
      // For better performance only parse once, and then cache the
      // result through a new accessor for repeated access.
      Object.defineProperty(this, 'name', {value: name});
      return name;
    }
  });
}

// URL polyfill for SystemJS (all IE)
/*! @source https://github.com/ModuleLoader/es6-module-loader/blob/master/src/url-polyfill.js*/
// from https://gist.github.com/Yaffle/1088850
(function(global) {
  function URLPolyfill(url, baseURL) {
    if (typeof url != 'string') {
      throw new TypeError('URL must be a string');
    }
    var m = String(url).replace(/^\s+|\s+$/g, "").match(/^([^:\/?#]+:)?(?:\/\/(?:([^:@\/?#]*)(?::([^:@\/?#]*))?@)?(([^:\/?#]*)(?::(\d*))?))?([^?#]*)(\?[^#]*)?(#[\s\S]*)?/);
    if (!m) {
      throw new RangeError();
    }
    var protocol = m[1] || "";
    var username = m[2] || "";
    var password = m[3] || "";
    var host = m[4] || "";
    var hostname = m[5] || "";
    var port = m[6] || "";
    var pathname = m[7] || "";
    var search = m[8] || "";
    var hash = m[9] || "";
    if (baseURL !== undefined) {
      var base = baseURL instanceof URLPolyfill ? baseURL : new URLPolyfill(baseURL);
      var flag = protocol === "" && host === "" && username === "";
      if (flag && pathname === "" && search === "") {
        search = base.search;
      }
      if (flag && pathname.charAt(0) !== "/") {
        pathname = (pathname !== "" ? (((base.host !== "" || base.username !== "") && base.pathname === "" ? "/" : "") + base.pathname.slice(0, base.pathname.lastIndexOf("/") + 1) + pathname) : base.pathname);
      }
      // dot segments removal
      var output = [];
      pathname.replace(/^(\.\.?(\/|$))+/, "")
        .replace(/\/(\.(\/|$))+/g, "/")
        .replace(/\/\.\.$/, "/../")
        .replace(/\/?[^\/]*/g, function (p) {
          if (p === "/..") {
            output.pop();
          } else {
            output.push(p);
          }
        });
      pathname = output.join("").replace(/^\//, pathname.charAt(0) === "/" ? "/" : "");
      if (flag) {
        port = base.port;
        hostname = base.hostname;
        host = base.host;
        password = base.password;
        username = base.username;
      }
      if (protocol === "") {
        protocol = base.protocol;
      }
    }

    // convert windows file URLs to use /
    if (protocol == 'file:')
      pathname = pathname.replace(/\\/g, '/');

    this.origin = protocol + (protocol !== "" || host !== "" ? "//" : "") + host;
    this.href = protocol + (protocol !== "" || host !== "" ? "//" : "") + (username !== "" ? username + (password !== "" ? ":" + password : "") + "@" : "") + host + pathname + search + hash;
    this.protocol = protocol;
    this.username = username;
    this.password = password;
    this.host = host;
    this.hostname = hostname;
    this.port = port;
    this.pathname = pathname;
    this.search = search;
    this.hash = hash;
  }
global.URLPolyfill = URLPolyfill;
})(typeof self != 'undefined' ? self : global);

//classList (IE9)
/*! @license please refer to http://unlicense.org/ */
/*! @author Eli Grey */
/*! @source https://github.com/eligrey/classList.js */
;if("document" in self&&!("classList" in document.createElement("_"))){(function(j){"use strict";if(!("Element" in j)){return}var a="classList",f="prototype",m=j.Element[f],b=Object,k=String[f].trim||function(){return this.replace(/^\s+|\s+$/g,"")},c=Array[f].indexOf||function(q){var p=0,o=this.length;for(;p<o;p++){if(p in this&&this[p]===q){return p}}return -1},n=function(o,p){this.name=o;this.code=DOMException[o];this.message=p},g=function(p,o){if(o===""){throw new n("SYNTAX_ERR","An invalid or illegal string was specified")}if(/\s/.test(o)){throw new n("INVALID_CHARACTER_ERR","String contains an invalid character")}return c.call(p,o)},d=function(s){var r=k.call(s.getAttribute("class")||""),q=r?r.split(/\s+/):[],p=0,o=q.length;for(;p<o;p++){this.push(q[p])}this._updateClassName=function(){s.setAttribute("class",this.toString())}},e=d[f]=[],i=function(){return new d(this)};n[f]=Error[f];e.item=function(o){return this[o]||null};e.contains=function(o){o+="";return g(this,o)!==-1};e.add=function(){var s=arguments,r=0,p=s.length,q,o=false;do{q=s[r]+"";if(g(this,q)===-1){this.push(q);o=true}}while(++r<p);if(o){this._updateClassName()}};e.remove=function(){var t=arguments,s=0,p=t.length,r,o=false;do{r=t[s]+"";var q=g(this,r);if(q!==-1){this.splice(q,1);o=true}}while(++s<p);if(o){this._updateClassName()}};e.toggle=function(p,q){p+="";var o=this.contains(p),r=o?q!==true&&"remove":q!==false&&"add";if(r){this[r](p)}return !o};e.toString=function(){return this.join(" ")};if(b.defineProperty){var l={get:i,enumerable:true,configurable:true};try{b.defineProperty(m,a,l)}catch(h){if(h.number===-2146823252){l.enumerable=false;b.defineProperty(m,a,l)}}}else{if(b[f].__defineGetter__){m.__defineGetter__(a,i)}}}(self))};

//console mock (IE9)
if (!window.console) window.console = {};
if (!window.console.log) window.console.log = function () { };
if (!window.console.error) window.console.error = function () { };
if (!window.console.warn) window.console.warn = function () { };
if (!window.console.assert) window.console.assert = function () { };

//RequestAnimationFrame (IE9, Android 4.1, 4.2, 4.3)
/*! @author Paul Irish */
/*! @source https://gist.github.com/paulirish/1579671 */
// http://paulirish.com/2011/requestanimationframe-for-smart-animating/
// http://my.opera.com/emoller/blog/2011/12/20/requestanimationframe-for-smart-er-animating

// requestAnimationFrame polyfill by Erik Möller. fixes from Paul Irish and Tino Zijdel

// MIT license

(function() {
    var lastTime = 0;

    if (!window.requestAnimationFrame)
        window.requestAnimationFrame = function(callback, element) {
            var currTime = Date.now();
            var timeToCall = Math.max(0, 16 - (currTime - lastTime));
            var id = window.setTimeout(function() { callback(currTime + timeToCall); },
              timeToCall);
            lastTime = currTime + timeToCall;
            return id;
        };

    if (!window.cancelAnimationFrame)
        window.cancelAnimationFrame = function(id) {
            clearTimeout(id);
        };
}());

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewsController', NewsController);

    NewsController.$inject = ['$scope', '$http', 'Principal', 'LoginService', '$state','Newsandgallery'];

    function NewsController ($scope, $http, Principal, LoginService, $state, Newsandgallery) {
        var vm = this;
        vm.imageFiles = [];
        vm.images = [];
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        $scope.x = "";
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        loadImageFiles();
        function loadImageFiles(){
            Newsandgallery.query(function(result){
                vm.imageFiles = result;
                vm.imageFiles.reverse();
            });
        }
        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }



    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: [ function() {
                    return true;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })

        .state('about', {
                    parent: 'home',
                    url: 'AboutUs',
                    data: {
                        authorities: []
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/home/about.html',
                            controller: 'HomeController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        entity: [ function() {
                            return false;
                        }],
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                          $translatePartialLoader.addPart('home');
                          return $translate.refresh();
                    }]
                   }
               })

               .state('aboutHEPC', {
                                   parent: 'home',
                                   url: 'AboutHEPC',
                                   data: {
                                       authorities: []
                                   },
                                   views: {
                                       'content@': {
                                           templateUrl: 'app/home/about.html',
                                           controller: 'HomeController',
                                           controllerAs: 'vm'
                                       }
                                   },
                                   resolve: {
                                       entity: [ function() {
                                           return false;
                                       }],
                                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                         $translatePartialLoader.addPart('home');
                                         return $translate.refresh();
                                   }]
                                  }
                              })


           .state('CM_Message', {
                                   parent: 'home',
                                   url: 'CM_Message',
                                   data: {
                                       authorities: []
                                   },
                                   views: {
                                       'content@': {
                                           templateUrl: 'app/home/cmMessage.html',
                                           controller: 'HomeController',
                                           controllerAs: 'vm'
                                       }
                                   },
                                   resolve: {
                                       entity: [ function() {
                                           return false;
                                       }],
                                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                         $translatePartialLoader.addPart('home');
                                         return $translate.refresh();
                                   }]
                                  }
                              })

         .state('mission', {
                                           parent: 'home',
                                           url: 'Mission',
                                           data: {
                                               authorities: []
                                           },
                                           views: {
                                               'content@': {
                                                   templateUrl: 'app/home/Mission.html',
                                                   controller: 'HomeController',
                                                   controllerAs: 'vm'
                                               }
                                           },
                                           resolve: {
                                               entity: [ function() {
                                                   return false;
                                               }],
                                             translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                                 $translatePartialLoader.addPart('home');
                                                 return $translate.refresh();
                                           }]
                                          }
                                      })

        .state('participating_department', {
                                       parent: 'home',
                                       url: 'Participating_Department',
                                       data: {
                                           authorities: []
                                       },
                                       views: {
                                           'content@': {
                                               templateUrl: 'app/home/participating_department.html',
                                               controller: 'HomeController',
                                               controllerAs: 'vm'
                                           }
                                       },
                                       resolve: {
                                           entity: [ function() {
                                               return false;
                                           }],
                                         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                             $translatePartialLoader.addPart('home');
                                             return $translate.refresh();
                                       }]
                                      }
                                  })

                 .state('haryana', {
                                       parent: 'home',
                                       url: 'Haryana',
                                       data: {
                                           authorities: []
                                       },
                                       views: {
                                           'content@': {
                                               templateUrl: 'app/home/haryana.html',
                                               controller: 'HomeController',
                                               controllerAs: 'vm'
                                           }
                                       },
                                       resolve: {
                                           entity: [ function() {
                                               return false;
                                           }],
                                         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                             $translatePartialLoader.addPart('home');
                                             return $translate.refresh();
                                       }]
                                      }
                                  })
                       .state('states', {
                                       parent: 'home',
                                       url: 'States',
                                       data: {
                                           authorities: []
                                       },
                                       views: {
                                           'content@': {
                                               templateUrl: 'app/home/states.html',
                                               controller: 'HomeController',
                                               controllerAs: 'vm'
                                           }
                                       },
                                       resolve: {
                                           entity: [ function() {
                                               return false;
                                           }],
                                         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                             $translatePartialLoader.addPart('home');
                                             return $translate.refresh();
                                       }]
                                      }
                                  })

                .state('Enabling_infrastructure', {
                                       parent: 'home',
                                       url: 'Enabling_Infrastructure',
                                       data: {
                                           authorities: []
                                       },
                                       views: {
                                           'content@': {
                                               templateUrl: 'app/home/Enabling_infrastructure.html',
                                               controller: 'HomeController',
                                               controllerAs: 'vm'
                                           }
                                       },
                                       resolve: {
                                           entity: [ function() {
                                               return false;
                                           }],
                                         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                             $translatePartialLoader.addPart('home');
                                             return $translate.refresh();
                                       }]
                                      }
                                  })

                   .state('urban_infrastructure', {
                                       parent: 'home',
                                       url: 'Urban_Infrastructure',
                                       data: {
                                           authorities: []
                                       },
                                       views: {
                                           'content@': {
                                               templateUrl: 'app/home/urban_infrastructure.html',
                                               controller: 'HomeController',
                                               controllerAs: 'vm'
                                           }
                                       },
                                       resolve: {
                                           entity: [ function() {
                                               return false;
                                           }],
                                         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                             $translatePartialLoader.addPart('home');
                                             return $translate.refresh();
                                       }]
                                      }
                                  })

                    .state('industrial_powerhouse', {
                                       parent: 'home',
                                       url: 'Industrial_Powerhouse',
                                       data: {
                                           authorities: []
                                       },
                                       views: {
                                           'content@': {
                                               templateUrl: 'app/home/industrial_powerhouse.html',
                                               controller: 'HomeController',
                                               controllerAs: 'vm'
                                           }
                                       },
                                       resolve: {
                                           entity: [ function() {
                                               return false;
                                           }],
                                         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                             $translatePartialLoader.addPart('home');
                                             return $translate.refresh();
                                       }]
                                      }
                                  })
            .state('electronicsAndInfo', {
                parent: 'home',
                url: 'electronicsAndInfo',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/electronicsAndInfo.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })

            .state('footwearAndAccessory', {
                parent: 'home',
                url: 'footwearAndAccessory',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/footwearAndAccessory.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })

            .state('pharmaceuticalAndChemical', {
                parent: 'home',
                url: 'pharmaceuticalAndChemical',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/pharmaceuticalAndChemical.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agriculture', {
                parent: 'home',
                url: 'agriculture',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/agriculture.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('conducive_ecosystem', {
                parent: 'home',
                url: 'Conducive_Ecosystem',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/conducive_ecosystem.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('booming_economy', {
                parent: 'home',
                url: 'Booming_Economy',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/booming_economy.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('supportive_government', {
                parent: 'home',
                url: 'Supportive_Government',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/supportive_government.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('org_structure', {
                parent: 'home',
                url: 'org_structure',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/org_structure.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('gurugram', {
                parent: 'home',
                url: 'gurugram',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/gurugram.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('iMultiModalLogisticsHub', {
                parent: 'home',
                url: 'iMultiModalLogisticsHub',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/iMultiModalLogisticsHub.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('integratedAviationHub', {
                parent: 'home',
                url: 'integratedAviationHub',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/integratedAviationHub.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('industrialModalTownship', {
                parent: 'home',
                url: 'industrialModalTownship',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/industrialModalTownship.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('qualityOfLife', {
                parent: 'home',
                url: 'qualityOfLife',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/qualityOfLife.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('defence', {
                parent: 'home',
                url: 'defence',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/defence.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('textile', {
                parent: 'home',
                url: 'textile',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/textile.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            // .state('meetOurExperts', {
            //     parent: 'home',
            //     url: 'meetOurExperts',
            //     data: {
            //         authorities: []
            //     },
            //     views: {
            //         'content@': {
            //             templateUrl: 'app/home/meetOurExperts.html'
            //         }
            //     },
            //     resolve: {
            //         entity: [ function() {
            //             return false;
            //         }],
            //         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
            //             $translatePartialLoader.addPart('home');
            //             return $translate.refresh();
            //         }]
            //     }
            // })
            .state('renewable', {
                parent: 'home',
                url: 'renewable',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/renewable.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('kmpGlobalCorridor', {
                parent: 'home',
                url: 'kmpGlobalCorridor',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/home/kmpGlobalCorridor.html',
                        controller: 'HomeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: [ function() {
                        return false;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })

                 .state('investor_service', {
                                       parent: 'home',
                                       url: 'Investor_Service',
                                       data: {
                                           authorities: []
                                       },
                                       views: {
                                           'content@': {
                                               templateUrl: 'app/home/investor_services.html',
                                               controller: 'HomeController',
                                               controllerAs: 'vm'
                                           }
                                       },
                                       resolve: {
                                           entity: [ function() {
                                               return false;
                                           }],
                                         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                             $translatePartialLoader.addPart('home');
                                             return $translate.refresh();
                                       }]
                                      }
                                  })


                    .state('information', {
                                       parent: 'home',
                                       url: 'Information',
                                       data: {
                                           authorities: []
                                       },
                                       views: {
                                           'content@': {
                                               templateUrl: 'app/home/information.html',
                                               controller: 'HomeController',
                                               controllerAs: 'vm'
                                           }
                                       },
                                       resolve: {
                                           entity: [ function() {
                                               return false;
                                           }],
                                         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                             $translatePartialLoader.addPart('home');
                                             return $translate.refresh();
                                       }]
                                      }
                                  })

                        .state('news_gallery', {
                                       parent: 'home',
                                       url: 'News_Gallery',
                                       data: {
                                           authorities: []
                                       },
                                       views: {
                                           'content@': {
                                               templateUrl: 'app/home/news_gallery.html',
                                               controller: 'NewsController',
                                               controllerAs: 'vm'
                                           }
                                       },
                                       resolve: {
                                           entity: [ function() {
                                               return false;
                                           }],
                                         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                             $translatePartialLoader.addPart('home');
                                             return $translate.refresh();
                                       }]
                                      }
                                  })

                    .state('contact_us', {
                                       parent: 'home',
                                       url: 'contact_us',
                                       data: {
                                           authorities: []
                                       },
                                       views: {
                                           'content@': {
                                               templateUrl: 'app/home/contact.html',
                                               controller: 'HomeController',
                                               controllerAs: 'vm'
                                           }
                                       },
                                       resolve: {
                                           entity: [ function() {
                                               return false;
                                           }],
                                         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                             $translatePartialLoader.addPart('home');
                                             return $translate.refresh();
                                       }]
                                      }
                                  })
                      .state('caffillingguide', {
                                     parent: 'home',
                                     url: 'caffillingguide',
                                     data: {
                                         authorities: []
                                     },
                                     views: {
                                         'content@': {
                                             templateUrl: 'app/home/caffillingguide.html',
                                             controller: 'HomeController',
                                             controllerAs: 'vm'
                                         }
                                     },
                                     resolve: {
                                         entity: [ function() {
                                             return false;
                                         }],
                                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                           $translatePartialLoader.addPart('home');
                                           return $translate.refresh();
                                     }]
                                    }
                                })
                                .state('serviceapplicationguide', {
                                     parent: 'home',
                                     url: 'serviceapplicationguide',
                                     data: {
                                         authorities: []
                                     },
                                     views: {
                                         'content@': {
                                             templateUrl: 'app/home/serviceapplicationguide.html',
                                             controller: 'HomeController',
                                             controllerAs: 'vm'
                                         }
                                     },
                                     resolve: {
                                         entity: [ function() {
                                             return false;
                                         }],
                                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                           $translatePartialLoader.addPart('home');
                                           return $translate.refresh();
                                     }]
                                    }
                                })
                                 .state('investorfacilitationcell', {
                                     parent: 'home',
                                     url: 'investorfacilitationcell',
                                     data: {
                                         authorities: []
                                     },
                                     views: {
                                         'content@': {
                                             templateUrl: 'app/home/investorfacilitationcell.html',
                                             controller: 'HomeController',
                                             controllerAs: 'vm'
                                         }
                                     },
                                     resolve: {
                                         entity: [ function() {
                                             return false;
                                         }],
                                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                           $translatePartialLoader.addPart('home');
                                           return $translate.refresh();
                                     }]
                                    }
                                })

                                .state('focusarea', {
                                     parent: 'home',
                                     url: 'focusarea',
                                     data: {
                                         authorities: []
                                     },
                                     views: {
                                         'content@': {
                                             templateUrl: 'app/home/focusarea.html',
                                             controller: 'HomeController',
                                             controllerAs: 'vm'
                                         }
                                     },
                                     resolve: {
                                         entity: [ function() {
                                             return false;
                                         }],
                                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                           $translatePartialLoader.addPart('home');
                                           return $translate.refresh();
                                     }]
                                    }
                                })
                                .state('feedbacksbyofficer', {
                                     parent: 'app',
                                     url: '/feedbacksbyofficer',
                                     data: {
                                         authorities: ['ROLE_FEEDBACK_OFFICER','ROLE_NODAL_OFFICER']
                                     },
                                     views: {
                                         'content@': {
                                             templateUrl: 'app/feedbacksbyofficer/feedbacksbyofficer.html',
                                             controller: 'FeedbacksByOfficerController',
                                             controllerAs: 'vm'
                                         }
                                     },
                                     resolve: {
                                         entity: [ function() {
                                             return false;
                                         }],
                                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                           $translatePartialLoader.addPart('home');
                                           return $translate.refresh();
                                     }]
                                    }
                                })
                            .state('advertisement', {
                                parent: 'home',
                                url: 'advertisement',
                                data: {
                                    authorities: []
                                },
                                views: {
                                    'content@': {
                                        templateUrl: 'app/home/advertisment.html',
                                        controller: 'HomeController',
                                        controllerAs: 'vm'
                                    }
                                },
                                resolve: {
                                    entity: [ function() {
                                        return false;
                                    }],
                                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                        $translatePartialLoader.addPart('home');
                                        return $translate.refresh();
                                    }]
                                }
                            });

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$timeout', '$scope', 'Principal', 'LoginService', '$state', '$uibModal', 'Visitor_count', 'downloadserviceformattachment', 'DraftPolicy', 'PolicyDetails','entity','HomePageCountOutput'];

    function HomeController ($timeout, $scope, Principal, LoginService, $state, $uibModal, Visitor_count, downloadserviceformattachment, DraftPolicy, PolicyDetails,entity,HomePageCountOutput) {
        var vm = this;
        loadAll();
        vm.city = 'gurugram';
        vm.showModal=entity;
        vm.isModelOpenedPreviously = sessionStorage.getItem('modalOpened');
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.save = save;
        vm.draftPolicy = {};
        vm.draftPolicy.isReplied = false;
        vm.draftPolicy.policy = 'Policy 1';
        vm.homePageCountOutputs = {};

        vm.chatVisible = false;
        vm.selectedTopic = null;
        vm.selectedQuestion = null;

        // Toggle chat visibility
        vm.toggleChat = function () {
            vm.chatVisible = !vm.chatVisible;
            vm.selectedTopic = null;
            vm.selectedQuestion = null;
        };

        vm.topics = [
            {
                name: 'Common Application Form (CAF) Details',
                questions: [
                    { q: 'What is the Common Application Form (CAF)?', a: 'The Common Application Form (CAF) is a unified digital form that allows investors to apply for multiple clearances and approvals required to start and operate a business in Haryana through a single submission on the Haryana Single Window System.' },
                    { q: 'How can I fill out the CAF?', a: 'You can fill the CAF online by visiting https://investharyana.in and logging into the Single Window System. After registration, select “Apply for CAF” and follow the instructions.' },
                    { q: 'What documents are required for CAF submission?', a: 'The required documents depend on your business type but typically include company incorporation certificate, project report, land documents, and identity proof of the applicant.' },
                    { q: 'Can I edit my CAF after submission?', a: 'No, once submitted, the CAF cannot be edited. However, you can raise a request through the portal or contact HEPC support for assistance.' },
                    { q: 'Is there any fee for submitting CAF?', a: 'No separate fee is charged for CAF submission. However, individual services applied through CAF may have their respective processing fees.' }
                ]
            },
            {
                name: 'Tracking of Services',
                questions: [
                    { q: 'How can I track the status of my application?', a: 'You can track your service application by visiting https://investharyana.in and logging into the Single Window System.' },
                    { q: 'Will I receive updates on my application?', a: 'Yes, you will receive email notifications at each stage of your application processing.' },
                    { q: 'What should I do if my CAF ID is not working?', a: 'Ensure that you are entering the correct CAF ID. If the problem persists, contact the technical helpdesk via “Contact Us”.' }
                ]
            },
            {
                name: 'FAQs Related to HEPC',
                questions: [
                    { q: 'What is HEPC?', a: 'The Haryana Enterprise Promotion Center (HEPC) is the nodal agency responsible for facilitating and monitoring all industrial approvals under the Haryana Enterprises and Employment Policy.' },
                    { q: 'How does HEPC assist investors?', a: 'HEPC coordinates with multiple departments to ensure timely clearances, provides grievance redressal, and assists investors in setting up businesses in Haryana.' },
                    { q: 'How can I contact HEPC?', a: 'You can contact HEPC via email at hepc.helpdesk@gmail.com or call the helpline at 1800-180-2132.' },
                    { q: 'Where is HEPC located?', a: 'HEPC operates from Bay No. 63-66, Level-II, Sector 2, Panchkula 134112.' }
                ]
            },
            {
                name: 'Contact Us',
                questions: [
                    { q: 'How can I contact the Invest Haryana team?', a: 'Visit the Contact Us page on https://investharyana.in or email hepc.helpdesk@gmail.com for assistance.' },
                    { q: 'What are the working hours for support?', a: 'Support is available from 9:00 AM to 5:00 PM (Monday to Friday), excluding government holidays.' },
                    { q: 'Can I visit the office in person?', a: 'Yes, you can visit the Invest Haryana office at Bay No. 63-66, Level-II, Sector 2, Panchkula 134112, during working hours.' }
                ]
            },
            {
                name: 'Another Query',
                questions: [
                    { q: 'I have a query not listed here. What should I do?', a: 'You can raise a custom query through the chatbot by selecting “Other Query” or submit your question through the Feedback/Helpdesk section on the portal.' },
                    { q: 'I’m facing a technical issue on the portal. What should I do?', a: 'For technical issues, please email the support team at hepc.helpdesk@gmail.com with a screenshot of the problem.' }
                ]
            }
        ];
        vm.selectTopic = function (topic) {
            vm.selectedTopic = topic;
        };

        // Select question
        vm.selectQuestion = function (question) {
            vm.selectedQuestion = question;
        };

        // Back navigation
        vm.backToTopics = function () {
            vm.selectedTopic = null;
        };
        vm.backToQuestions = function () {
            vm.selectedQuestion = null;
        };

        $scope.eodbModal = {};
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        // if(vm.showModal){
        //     if (!vm.isModelOpenedPreviously) {
        //         UIkit.modal('#advModal').show();
        //     }
        //
        // }
        // $timeout(function (){
        //     UIkit.modal('#advModal').hide();
        //     sessionStorage.setItem('modalOpened', true);
        // },10000);

        if(vm.showModal) {
            UIkit.modal('#advModal').show();
        }

        $timeout(function (){
            UIkit.modal('#advModal').hide();
        },50000000);

        getAccount();
        //
        // Initialize modal visibility state
        vm.isModalVisible = true;

        vm.clear = function () {
            // Hide the modal by changing the visibility state
            vm.isModalVisible = false;

            // Re-enable scrolling on the body
            document.documentElement.style.overflow = "auto";  // Ensures the html element is scrollable as well.
            // This will allow scrolling again.

            // Optional: Store the modal state in session storage so it doesn't open again on page reload
            sessionStorage.setItem('modalOpened', true);
        };


        // code for banner on home screen
        //  var modalins =$uibModal.open({
        //     animation: $scope.animationsEnabled,
        //     imageUrl: 'content/images/bandash.jpg',
        //     size: 'lg'
        // });

        function getAccount() {
            // setTimeout(function(){
            //     modalins.close();
            // }, 8000);

            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
            HomePageCountOutput.query(function(result) {
                vm.homePageCountOutputs = result[0];
                vm.searchQuery = null;
            })
        }

        function register () {
            $state.go('register');
        }

        function loadAll() {
            PolicyDetails.query(function(result) {
                vm.policyDetails = result;
                vm.searchQuery = null;
            });
        }

        vm.downloadAdvertisement = function(serverfilename,downloadfilename){
            downloadserviceformattachment.download(serverfilename, downloadfilename);
        };

        function save() {
            DraftPolicy.save(vm.draftPolicy,onSaveSuccess,onSaveError);
        }

        function onSaveSuccess() {
            UIkit.modal('#draft_policy').hide();
            location.reload();
        }

        function onSaveError() {

        }

        $scope.setTempItem = function(item) {
            $scope.policyName = item.name;
            $scope.serverFileName = item.file;
        };
        vm.commingSoonPages = function () {
            alert("Coming Soon");
        }
    }
})();

/*!
  * https://github.com/paulmillr/es6-shim
  * @license es6-shim Copyright 2013-2015 by Paul Miller (http://paulmillr.com)
  *   and contributors,  MIT License
  * es6-shim: v0.33.3
  * see https://github.com/paulmillr/es6-shim/blob/0.33.3/LICENSE
  * Details and documentation:
  * https://github.com/paulmillr/es6-shim/
  */
(function(e,t){if(typeof define==="function"&&define.amd){define(t)}else if(typeof exports==="object"){module.exports=t()}else{e.returnExports=t()}})(this,function(){"use strict";var e=Function.call.bind(Function.apply);var t=Function.call.bind(Function.call);var r=function notThunker(t){return function notThunk(){return!e(t,this,arguments)}};var n=function(e){try{e();return false}catch(t){return true}};var o=function valueOrFalseIfThrows(e){try{return e()}catch(t){return false}};var i=r(n);var a=function(){return!n(function(){Object.defineProperty({},"x",{})})};var u=!!Object.defineProperty&&a();var s=function foo(){}.name==="foo";var f=Function.call.bind(Array.prototype.forEach);var c=Function.call.bind(Array.prototype.reduce);var l=Function.call.bind(Array.prototype.filter);var p=Function.call.bind(Array.prototype.every);var v=function createDataProperty(e,t,r){if(u){Object.defineProperty(e,t,{configurable:true,enumerable:true,writable:true,value:r})}else{e[t]=r}};var h=function createDataPropertyOrThrow(e,t,r){v(e,t,r);if(!te.SameValue(e[t],r)){throw new TypeError("property is nonconfigurable")}};var y=function(e,t,r,n){if(!n&&t in e){return}if(u){Object.defineProperty(e,t,{configurable:true,enumerable:false,writable:true,value:r})}else{e[t]=r}};var b=function(e,t){f(Object.keys(t),function(r){var n=t[r];y(e,r,n,false)})};var g=Object.create||function(e,t){var r=function Prototype(){};r.prototype=e;var n=new r;if(typeof t!=="undefined"){Object.keys(t).forEach(function(e){B.defineByDescriptor(n,e,t[e])})}return n};var d=function(e,t){if(!Object.setPrototypeOf){return false}return o(function(){var r=function Subclass(t){var r=new e(t);Object.setPrototypeOf(r,Subclass.prototype);return r};Object.setPrototypeOf(r,e);r.prototype=g(e.prototype,{constructor:{value:r}});return t(r)})};var m=function(){return String.prototype.startsWith&&n(function(){"/a/".startsWith(/a/)})};var O=function(){return String.prototype.startsWith&&"abc".startsWith("a",Infinity)===false}();var w=function(){if(typeof self!=="undefined"){return self}if(typeof window!=="undefined"){return window}if(typeof global!=="undefined"){return global}throw new Error("unable to locate global object")};var j=w();var S=j.isFinite;var T=function(){return this===null}.call(null);var I=m()&&O;var E=Function.call.bind(String.prototype.indexOf);var M=Function.call.bind(Object.prototype.toString);var P=Function.call.bind(Array.prototype.concat);var x=Function.call.bind(String.prototype.slice);var N=Function.call.bind(Array.prototype.push);var C=Function.apply.bind(Array.prototype.push);var A=Function.call.bind(Array.prototype.shift);var _=Math.max;var k=Math.min;var R=Math.floor;var F=Math.abs;var D=Math.log;var z=Math.sqrt;var L=Function.call.bind(Object.prototype.hasOwnProperty);var q;var G=function(){};var W=j.Symbol||{};var H=W.species||"@@species";var B={getter:function(e,t,r){if(!u){throw new TypeError("getters require true ES5 support")}Object.defineProperty(e,t,{configurable:true,enumerable:false,get:r})},proxy:function(e,t,r){if(!u){throw new TypeError("getters require true ES5 support")}var n=Object.getOwnPropertyDescriptor(e,t);Object.defineProperty(r,t,{configurable:n.configurable,enumerable:n.enumerable,get:function getKey(){return e[t]},set:function setKey(r){e[t]=r}})},redefine:function(e,t,r){if(u){var n=Object.getOwnPropertyDescriptor(e,t);n.value=r;Object.defineProperty(e,t,n)}else{e[t]=r}},defineByDescriptor:function(e,t,r){if(u){Object.defineProperty(e,t,r)}else if("value"in r){e[t]=r.value}},preserveToString:function(e,t){y(e,"toString",t.toString.bind(t),true)}};var V=function wrapConstructor(e,t,r){B.preserveToString(t,e);if(Object.setPrototypeOf){Object.setPrototypeOf(e,t)}f(Object.getOwnPropertyNames(e),function(n){if(n in G||r[n]){return}B.proxy(e,n,t)});t.prototype=e.prototype;B.redefine(e.prototype,"constructor",t)};var $=function(){return this};var U=function(e){if(u&&!L(e,H)){B.getter(e,H,$)}};var K={primitive:function(e){return e===null||typeof e!=="function"&&typeof e!=="object"},object:function(e){return e!==null&&typeof e==="object"},string:function(e){return M(e)==="[object String]"},regex:function(e){return M(e)==="[object RegExp]"},symbol:function(e){return typeof j.Symbol==="function"&&typeof e==="symbol"}};var X=Number.isNaN||function isNaN(e){return e!==e};var Z=Number.isFinite||function isFinite(e){return typeof e==="number"&&S(e)};var J=function overrideNative(e,t,r){var n=e[t];y(e,t,r,true);B.preserveToString(e[t],n)};var Q=K.symbol(W.iterator)?W.iterator:"_es6-shim iterator_";if(j.Set&&typeof(new j.Set)["@@iterator"]==="function"){Q="@@iterator"}var Y=function(e,t){var r=t||function iterator(){return this};y(e,Q,r);if(!e[Q]&&K.symbol(Q)){e[Q]=r}};var ee=function isArguments(e){var t=M(e);var r=t==="[object Arguments]";if(!r){r=t!=="[object Array]"&&e!==null&&typeof e==="object"&&typeof e.length==="number"&&e.length>=0&&M(e.callee)==="[object Function]"}return r};var te={Call:function Call(t,r){var n=arguments.length>2?arguments[2]:[];if(!te.IsCallable(t)){throw new TypeError(t+" is not a function")}return e(t,r,n)},RequireObjectCoercible:function(e,t){if(e==null){throw new TypeError(t||"Cannot call method on "+e)}},TypeIsObject:function(e){return e!=null&&Object(e)===e},ToObject:function(e,t){te.RequireObjectCoercible(e,t);return Object(e)},IsCallable:function(e){return typeof e==="function"&&M(e)==="[object Function]"},IsConstructor:function(e){return te.IsCallable(e)},ToInt32:function(e){return te.ToNumber(e)>>0},ToUint32:function(e){return te.ToNumber(e)>>>0},ToNumber:function(e){if(M(e)==="[object Symbol]"){throw new TypeError("Cannot convert a Symbol value to a number")}return+e},ToInteger:function(e){var t=te.ToNumber(e);if(X(t)){return 0}if(t===0||!Z(t)){return t}return(t>0?1:-1)*R(F(t))},ToLength:function(e){var t=te.ToInteger(e);if(t<=0){return 0}if(t>Number.MAX_SAFE_INTEGER){return Number.MAX_SAFE_INTEGER}return t},SameValue:function(e,t){if(e===t){if(e===0){return 1/e===1/t}return true}return X(e)&&X(t)},SameValueZero:function(e,t){return e===t||X(e)&&X(t)},IsIterable:function(e){return te.TypeIsObject(e)&&(typeof e[Q]!=="undefined"||ee(e))},GetIterator:function(e){if(ee(e)){return new q(e,"value")}var r=te.GetMethod(e,Q);if(!te.IsCallable(r)){throw new TypeError("value is not an iterable")}var n=t(r,e);if(!te.TypeIsObject(n)){throw new TypeError("bad iterator")}return n},GetMethod:function(e,t){var r=te.ToObject(e)[t];if(r===void 0||r===null){return void 0}if(!te.IsCallable(r)){throw new TypeError("Method not callable: "+t)}return r},IteratorComplete:function(e){return!!e.done},IteratorClose:function(e,r){var n=te.GetMethod(e,"return");if(n===void 0){return}var o,i;try{o=t(n,e)}catch(a){i=a}if(r){return}if(i){throw i}if(!te.TypeIsObject(o)){throw new TypeError("Iterator's return method returned a non-object.")}},IteratorNext:function(e){var t=arguments.length>1?e.next(arguments[1]):e.next();if(!te.TypeIsObject(t)){throw new TypeError("bad iterator")}return t},IteratorStep:function(e){var t=te.IteratorNext(e);var r=te.IteratorComplete(t);return r?false:t},Construct:function(e,t,r,n){if(r===void 0){r=e}if(!n){return vr.construct(e,t,r)}var o=r.prototype;if(!te.TypeIsObject(o)){o=Object.prototype}var i=g(o);var a=te.Call(e,i,t);return te.TypeIsObject(a)?a:i},SpeciesConstructor:function(e,t){var r=e.constructor;if(r===void 0){return t}if(!te.TypeIsObject(r)){throw new TypeError("Bad constructor")}var n=r[H];if(n===void 0||n===null){return t}if(!te.IsConstructor(n)){throw new TypeError("Bad @@species")}return n},CreateHTML:function(e,t,r,n){var o=String(e);var i="<"+t;if(r!==""){var a=String(n);var u=a.replace(/"/g,"&quot;");i+=" "+r+'="'+u+'"'}var s=i+">";var f=s+o;return f+"</"+t+">"}};var re=function(e,t,r,n){if(!te.TypeIsObject(e)){throw new TypeError("Constructor requires `new`: "+t.name)}var o=t.prototype;if(!te.TypeIsObject(o)){o=r}e=g(o);for(var i in n){if(L(n,i)){var a=n[i];y(e,i,a,true)}}return e};if(String.fromCodePoint&&String.fromCodePoint.length!==1){var ne=String.fromCodePoint;J(String,"fromCodePoint",function fromCodePoint(t){return e(ne,this,arguments)})}var oe={fromCodePoint:function fromCodePoint(e){var t=[];var r;for(var n=0,o=arguments.length;n<o;n++){r=Number(arguments[n]);if(!te.SameValue(r,te.ToInteger(r))||r<0||r>1114111){throw new RangeError("Invalid code point "+r)}if(r<65536){N(t,String.fromCharCode(r))}else{r-=65536;N(t,String.fromCharCode((r>>10)+55296));N(t,String.fromCharCode(r%1024+56320))}}return t.join("")},raw:function raw(e){var t=te.ToObject(e,"bad callSite");var r=te.ToObject(t.raw,"bad raw value");var n=r.length;var o=te.ToLength(n);if(o<=0){return""}var i=[];var a=0;var u,s,f,c;while(a<o){u=String(a);f=String(r[u]);N(i,f);if(a+1>=o){break}s=a+1<arguments.length?arguments[a+1]:"";c=String(s);N(i,c);a++}return i.join("")}};b(String,oe);if(String.raw({raw:{0:"x",1:"y",length:2}})!=="xy"){J(String,"raw",oe.raw)}var ie=function repeat(e,t){if(t<1){return""}if(t%2){return repeat(e,t-1)+e}var r=repeat(e,t/2);return r+r};var ae=Infinity;var ue={repeat:function repeat(e){te.RequireObjectCoercible(this);var t=String(this);var r=te.ToInteger(e);if(r<0||r>=ae){throw new RangeError("repeat count must be less than infinity and not overflow maximum string size")}return ie(t,r)},startsWith:function startsWith(e){te.RequireObjectCoercible(this);var t=String(this);if(K.regex(e)){throw new TypeError('Cannot call method "startsWith" with a regex')}var r=String(e);var n=arguments.length>1?arguments[1]:void 0;var o=_(te.ToInteger(n),0);return x(t,o,o+r.length)===r},endsWith:function endsWith(e){te.RequireObjectCoercible(this);var t=String(this);if(K.regex(e)){throw new TypeError('Cannot call method "endsWith" with a regex')}var r=String(e);var n=t.length;var o=arguments.length>1?arguments[1]:void 0;var i=typeof o==="undefined"?n:te.ToInteger(o);var a=k(_(i,0),n);return x(t,a-r.length,a)===r},includes:function includes(e){if(K.regex(e)){throw new TypeError('"includes" does not accept a RegExp')}var t;if(arguments.length>1){t=arguments[1]}return E(this,e,t)!==-1},codePointAt:function codePointAt(e){te.RequireObjectCoercible(this);var t=String(this);var r=te.ToInteger(e);var n=t.length;if(r>=0&&r<n){var o=t.charCodeAt(r);var i=r+1===n;if(o<55296||o>56319||i){return o}var a=t.charCodeAt(r+1);if(a<56320||a>57343){return o}return(o-55296)*1024+(a-56320)+65536}}};b(String.prototype,ue);if("a".includes("a",Infinity)!==false){J(String.prototype,"includes",ue.includes)}var se="\x85".trim().length!==1;if(se){delete String.prototype.trim;var fe=["	\n\f\r \xa0\u1680\u180e\u2000\u2001\u2002\u2003","\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u202f\u205f\u3000\u2028","\u2029\ufeff"].join("");var ce=new RegExp("(^["+fe+"]+)|(["+fe+"]+$)","g");b(String.prototype,{trim:function trim(){if(typeof this==="undefined"||this===null){throw new TypeError("can't convert "+this+" to object")}return String(this).replace(ce,"")}})}var le=function(e){te.RequireObjectCoercible(e);this._s=String(e);this._i=0};le.prototype.next=function(){var e=this._s,t=this._i;if(typeof e==="undefined"||t>=e.length){this._s=void 0;return{value:void 0,done:true}}var r=e.charCodeAt(t),n,o;if(r<55296||r>56319||t+1===e.length){o=1}else{n=e.charCodeAt(t+1);o=n<56320||n>57343?1:2}this._i=t+o;return{value:e.substr(t,o),done:false}};Y(le.prototype);Y(String.prototype,function(){return new le(this)});if(!I){J(String.prototype,"startsWith",ue.startsWith);J(String.prototype,"endsWith",ue.endsWith)}var pe={from:function from(e){var r=this;var n=arguments.length>1?arguments[1]:void 0;var o,i;if(n===void 0){o=false}else{if(!te.IsCallable(n)){throw new TypeError("Array.from: when provided, the second argument must be a function")}i=arguments.length>2?arguments[2]:void 0;o=true}var a=ee(e)||te.GetMethod(e,Q);var u,s,f;if(a!==void 0){s=te.IsConstructor(r)?Object(new r):[];var c=te.GetIterator(e);var l,p;f=0;while(true){l=te.IteratorStep(c);if(l===false){break}p=l.value;try{if(o){p=i!==undefined?t(n,i,p,f):n(p,f)}s[f]=p}catch(v){te.IteratorClose(c,true);throw v}f+=1}u=f}else{var h=te.ToObject(e);u=te.ToLength(h.length);s=te.IsConstructor(r)?Object(new r(u)):new Array(u);var y;for(f=0;f<u;++f){y=h[f];if(o){y=i!==undefined?t(n,i,y,f):n(y,f)}s[f]=y}}s.length=u;return s},of:function of(){var e=arguments.length;var t=this;var r=Array.isArray(t)||!te.IsCallable(t)?new Array(e):te.Construct(t,[e]);for(var n=0;n<e;++n){h(r,n,arguments[n])}r.length=e;return r}};b(Array,pe);U(Array);var ve=function(e){return{value:e,done:arguments.length===0}};q=function(e,t){this.i=0;this.array=e;this.kind=t};b(q.prototype,{next:function(){var e=this.i,t=this.array;if(!(this instanceof q)){throw new TypeError("Not an ArrayIterator")}if(typeof t!=="undefined"){var r=te.ToLength(t.length);for(;e<r;e++){var n=this.kind;var o;if(n==="key"){o=e}else if(n==="value"){o=t[e]}else if(n==="entry"){o=[e,t[e]]}this.i=e+1;return{value:o,done:false}}}this.array=void 0;return{value:void 0,done:true}}});Y(q.prototype);var he=function(e,t){b(this,{object:e,array:ye(e),kind:t})};var ye=function getAllKeys(e){var t=[];for(var r in e){N(t,r)}return t};b(he.prototype,{next:function next(){var e;var t=this.array;if(!(this instanceof he)){throw new TypeError("Not an ObjectIterator")}while(t.length>0){e=A(t);if(!(e in this.object)){continue}if(this.kind==="key"){return ve(e)}else if(this.kind==="value"){return ve(this.object[e])}else{return ve([e,this.object[e]])}}return ve()}});Y(he.prototype);var be=Array.of===pe.of||function(){var e=function Foo(e){this.length=e};e.prototype=[];var t=Array.of.apply(e,[1,2]);return t instanceof e&&t.length===2}();if(!be){J(Array,"of",pe.of)}var ge={copyWithin:function copyWithin(e,t){var r=arguments[2];var n=te.ToObject(this);var o=te.ToLength(n.length);var i=te.ToInteger(e);var a=te.ToInteger(t);var u=i<0?_(o+i,0):k(i,o);var s=a<0?_(o+a,0):k(a,o);r=typeof r==="undefined"?o:te.ToInteger(r);var f=r<0?_(o+r,0):k(r,o);var c=k(f-s,o-u);var l=1;if(s<u&&u<s+c){l=-1;s+=c-1;u+=c-1}while(c>0){if(L(n,s)){n[u]=n[s]}else{delete n[s]}s+=l;u+=l;c-=1}return n},fill:function fill(e){var t=arguments.length>1?arguments[1]:void 0;var r=arguments.length>2?arguments[2]:void 0;var n=te.ToObject(this);var o=te.ToLength(n.length);t=te.ToInteger(typeof t==="undefined"?0:t);r=te.ToInteger(typeof r==="undefined"?o:r);var i=t<0?_(o+t,0):k(t,o);var a=r<0?o+r:r;for(var u=i;u<o&&u<a;++u){n[u]=e}return n},find:function find(e){var r=te.ToObject(this);var n=te.ToLength(r.length);if(!te.IsCallable(e)){throw new TypeError("Array#find: predicate must be a function")}var o=arguments.length>1?arguments[1]:null;for(var i=0,a;i<n;i++){a=r[i];if(o){if(t(e,o,a,i,r)){return a}}else if(e(a,i,r)){return a}}},findIndex:function findIndex(e){var r=te.ToObject(this);var n=te.ToLength(r.length);if(!te.IsCallable(e)){throw new TypeError("Array#findIndex: predicate must be a function")}var o=arguments.length>1?arguments[1]:null;for(var i=0;i<n;i++){if(o){if(t(e,o,r[i],i,r)){return i}}else if(e(r[i],i,r)){return i}}return-1},keys:function keys(){return new q(this,"key")},values:function values(){return new q(this,"value")},entries:function entries(){return new q(this,"entry")}};if(Array.prototype.keys&&!te.IsCallable([1].keys().next)){delete Array.prototype.keys}if(Array.prototype.entries&&!te.IsCallable([1].entries().next)){delete Array.prototype.entries}if(Array.prototype.keys&&Array.prototype.entries&&!Array.prototype.values&&Array.prototype[Q]){b(Array.prototype,{values:Array.prototype[Q]});if(K.symbol(W.unscopables)){Array.prototype[W.unscopables].values=true}}if(s&&Array.prototype.values&&Array.prototype.values.name!=="values"){var de=Array.prototype.values;J(Array.prototype,"values",function values(){return t(de,this)});y(Array.prototype,Q,Array.prototype.values,true)}b(Array.prototype,ge);Y(Array.prototype,function(){return this.values()});if(Object.getPrototypeOf){Y(Object.getPrototypeOf([].values()))}var me=function(){return o(function(){return Array.from({length:-1}).length===0})}();var Oe=function(){var e=Array.from([0].entries());return e.length===1&&Array.isArray(e[0])&&e[0][0]===0&&e[0][1]===0}();if(!me||!Oe){J(Array,"from",pe.from)}var we=function(){return o(function(){return Array.from([0],undefined)})}();if(!we){var je=Array.from;J(Array,"from",function from(r){if(arguments.length>0&&typeof arguments[1]!=="undefined"){return e(je,this,arguments)}else{return t(je,this,r)}})}var Se=function(e,r){var n={length:-1};n[r?(-1>>>0)-1:0]=true;return o(function(){t(e,n,function(){throw new RangeError("should not reach here")},[])})};if(!Se(Array.prototype.forEach)){var Te=Array.prototype.forEach;J(Array.prototype,"forEach",function forEach(t){return e(Te,this.length>=0?this:[],arguments)},true)}if(!Se(Array.prototype.map)){var Ie=Array.prototype.map;J(Array.prototype,"map",function map(t){return e(Ie,this.length>=0?this:[],arguments)},true)}if(!Se(Array.prototype.filter)){var Ee=Array.prototype.filter;J(Array.prototype,"filter",function filter(t){return e(Ee,this.length>=0?this:[],arguments)},true)}if(!Se(Array.prototype.some)){var Me=Array.prototype.some;J(Array.prototype,"some",function some(t){return e(Me,this.length>=0?this:[],arguments)},true)}if(!Se(Array.prototype.every)){var Pe=Array.prototype.every;J(Array.prototype,"every",function every(t){return e(Pe,this.length>=0?this:[],arguments)},true)}if(!Se(Array.prototype.reduce)){var xe=Array.prototype.reduce;J(Array.prototype,"reduce",function reduce(t){return e(xe,this.length>=0?this:[],arguments)},true)}if(!Se(Array.prototype.reduceRight,true)){var Ne=Array.prototype.reduceRight;J(Array.prototype,"reduceRight",function reduceRight(t){return e(Ne,this.length>=0?this:[],arguments)},true)}if(Number("0o10")!==8||Number("0b10")!==2){var Ce=Number;var Ae=Function.bind.call(Function.call,RegExp.prototype.test,/^0b/i);var _e=Function.bind.call(Function.call,RegExp.prototype.test,/^0o/i);var ke=function(e){var t;if(typeof e.valueOf==="function"){t=e.valueOf();if(K.primitive(t)){return t}}if(typeof e.toString==="function"){t=e.toString();if(K.primitive(t)){return t}}throw new TypeError("No default value")};var Re=function Number(e){var t=K.primitive(e)?e:ke(e,"number");if(typeof t==="string"){if(Ae(t)){t=parseInt(x(t,2),2)}else if(_e(t)){t=parseInt(x(t,2),8)}}if(this instanceof Number){return new Ce(t)}return Ce(t)};V(Ce,Re,{});Number=Re;B.redefine(j,"Number",Re)}var Fe=Math.pow(2,53)-1;b(Number,{MAX_SAFE_INTEGER:Fe,MIN_SAFE_INTEGER:-Fe,EPSILON:2.220446049250313e-16,parseInt:j.parseInt,parseFloat:j.parseFloat,isFinite:Z,isInteger:function isInteger(e){return Z(e)&&te.ToInteger(e)===e},isSafeInteger:function isSafeInteger(e){return Number.isInteger(e)&&F(e)<=Number.MAX_SAFE_INTEGER},isNaN:X});y(Number,"parseInt",j.parseInt,Number.parseInt!==j.parseInt);if(![,1].find(function(e,t){return t===0})){J(Array.prototype,"find",ge.find)}if([,1].findIndex(function(e,t){return t===0})!==0){J(Array.prototype,"findIndex",ge.findIndex)}var De=Function.bind.call(Function.bind,Object.prototype.propertyIsEnumerable);var ze=function sliceArgs(){var e=Number(this);var t=arguments.length;var r=t-e;var n=new Array(r<0?0:r);for(var o=e;o<t;++o){n[o-e]=arguments[o]}return n};var Le=function assignTo(e){return function assignToSource(t,r){t[r]=e[r];return t}};var qe=function(e,t){var r=Object.keys(Object(t));var n;if(te.IsCallable(Object.getOwnPropertySymbols)){n=l(Object.getOwnPropertySymbols(Object(t)),De(t))}return c(P(r,n||[]),Le(t),e)};var Ge={assign:function(t,r){var n=te.ToObject(t,"Cannot convert undefined or null to object");return c(e(ze,1,arguments),qe,n)},is:function is(e,t){return te.SameValue(e,t)}};var We=Object.assign&&Object.preventExtensions&&function(){var e=Object.preventExtensions({1:2});try{Object.assign(e,"xy")}catch(t){return e[1]==="y"}}();if(We){J(Object,"assign",Ge.assign)}b(Object,Ge);if(u){var He={setPrototypeOf:function(e,r){var n;var o=function(e,t){if(!te.TypeIsObject(e)){throw new TypeError("cannot set prototype on a non-object")}if(!(t===null||te.TypeIsObject(t))){throw new TypeError("can only set prototype to an object or null"+t)}};var i=function(e,r){o(e,r);t(n,e,r);return e};try{n=e.getOwnPropertyDescriptor(e.prototype,r).set;t(n,{},null)}catch(a){if(e.prototype!=={}[r]){return}n=function(e){this[r]=e};i.polyfill=i(i({},null),e.prototype)instanceof e}return i}(Object,"__proto__")};b(Object,He)}if(Object.setPrototypeOf&&Object.getPrototypeOf&&Object.getPrototypeOf(Object.setPrototypeOf({},null))!==null&&Object.getPrototypeOf(Object.create(null))===null){(function(){var e=Object.create(null);var t=Object.getPrototypeOf,r=Object.setPrototypeOf;Object.getPrototypeOf=function(r){var n=t(r);return n===e?null:n};Object.setPrototypeOf=function(t,n){var o=n===null?e:n;return r(t,o)};Object.setPrototypeOf.polyfill=false})()}var Be=!n(function(){Object.keys("foo")});if(!Be){var Ve=Object.keys;J(Object,"keys",function keys(e){return Ve(te.ToObject(e))})}if(Object.getOwnPropertyNames){var $e=!n(function(){Object.getOwnPropertyNames("foo")});if(!$e){var Ue=typeof window==="object"?Object.getOwnPropertyNames(window):[];var Ke=Object.getOwnPropertyNames;J(Object,"getOwnPropertyNames",function getOwnPropertyNames(e){var t=te.ToObject(e);if(M(t)==="[object Window]"){try{return Ke(t)}catch(r){return P([],Ue)}}return Ke(t)})}}if(Object.getOwnPropertyDescriptor){var Xe=!n(function(){Object.getOwnPropertyDescriptor("foo","bar")});if(!Xe){var Ze=Object.getOwnPropertyDescriptor;J(Object,"getOwnPropertyDescriptor",function getOwnPropertyDescriptor(e,t){return Ze(te.ToObject(e),t)})}}if(Object.seal){var Je=!n(function(){Object.seal("foo")});if(!Je){var Qe=Object.seal;J(Object,"seal",function seal(e){if(!K.object(e)){return e}return Qe(e)})}}if(Object.isSealed){var Ye=!n(function(){Object.isSealed("foo")});if(!Ye){var et=Object.isSealed;J(Object,"isSealed",function isSealed(e){if(!K.object(e)){return true}return et(e)})}}if(Object.freeze){var tt=!n(function(){Object.freeze("foo")});if(!tt){var rt=Object.freeze;J(Object,"freeze",function freeze(e){if(!K.object(e)){return e}return rt(e)})}}if(Object.isFrozen){var nt=!n(function(){Object.isFrozen("foo")});if(!nt){var ot=Object.isFrozen;J(Object,"isFrozen",function isFrozen(e){if(!K.object(e)){return true}return ot(e)})}}if(Object.preventExtensions){var it=!n(function(){Object.preventExtensions("foo")});if(!it){var at=Object.preventExtensions;J(Object,"preventExtensions",function preventExtensions(e){if(!K.object(e)){return e}return at(e)})}}if(Object.isExtensible){var ut=!n(function(){Object.isExtensible("foo")});if(!ut){var st=Object.isExtensible;J(Object,"isExtensible",function isExtensible(e){if(!K.object(e)){return false}return st(e)})}}if(Object.getPrototypeOf){var ft=!n(function(){Object.getPrototypeOf("foo")});if(!ft){var ct=Object.getPrototypeOf;J(Object,"getPrototypeOf",function getPrototypeOf(e){return ct(te.ToObject(e))})}}if(!RegExp.prototype.flags&&u){var lt=function flags(){if(!te.TypeIsObject(this)){throw new TypeError("Method called on incompatible type: must be an object.")}var e="";if(this.global){e+="g"}if(this.ignoreCase){e+="i"}if(this.multiline){e+="m"}if(this.unicode){e+="u"}if(this.sticky){e+="y"}return e};B.getter(RegExp.prototype,"flags",lt)}var pt=o(function(){return String(new RegExp(/a/g,"i"))==="/a/i"});if(!pt&&u){var vt=RegExp;var ht=function RegExp(e,t){var r=this instanceof RegExp;if(!r&&(K.regex(e)||e&&e.constructor===RegExp)){return e}if(K.regex(e)&&K.string(t)){return new RegExp(e.source,t)}return new vt(e,t)};V(vt,ht,{$input:true});RegExp=ht;B.redefine(j,"RegExp",ht)}if(u){var yt={input:"$_",lastMatch:"$&",lastParen:"$+",leftContext:"$`",rightContext:"$'"};f(Object.keys(yt),function(e){if(e in RegExp&&!(yt[e]in RegExp)){B.getter(RegExp,yt[e],function get(){return RegExp[e]})}})}U(RegExp);var bt=1/Number.EPSILON;var gt=function roundTiesToEven(e){return e+bt-bt};var dt=Math.pow(2,-23);var mt=Math.pow(2,127)*(2-dt);var Ot=Math.pow(2,-126);var wt=Number.prototype.clz;delete Number.prototype.clz;var jt={acosh:function acosh(e){var t=Number(e);if(Number.isNaN(t)||e<1){return NaN}if(t===1){return 0}if(t===Infinity){return t}return D(t/Math.E+z(t+1)*z(t-1)/Math.E)+1},asinh:function asinh(e){var t=Number(e);if(t===0||!S(t)){return t}return t<0?-Math.asinh(-t):D(t+z(t*t+1))},atanh:function atanh(e){var t=Number(e);if(Number.isNaN(t)||t<-1||t>1){return NaN}if(t===-1){return-Infinity}if(t===1){return Infinity}if(t===0){return t}return.5*D((1+t)/(1-t))},cbrt:function cbrt(e){var t=Number(e);if(t===0){return t}var r=t<0,n;if(r){t=-t}if(t===Infinity){n=Infinity}else{n=Math.exp(D(t)/3);n=(t/(n*n)+2*n)/3}return r?-n:n},clz32:function clz32(e){var r=Number(e);var n=te.ToUint32(r);if(n===0){return 32}return wt?t(wt,n):31-R(D(n+.5)*Math.LOG2E)},cosh:function cosh(e){var t=Number(e);if(t===0){return 1}if(Number.isNaN(t)){return NaN}if(!S(t)){return Infinity}if(t<0){t=-t}if(t>21){return Math.exp(t)/2}return(Math.exp(t)+Math.exp(-t))/2},expm1:function expm1(e){var t=Number(e);if(t===-Infinity){return-1}if(!S(t)||t===0){return t}if(F(t)>.5){return Math.exp(t)-1}var r=t;var n=0;var o=1;while(n+r!==n){n+=r;o+=1;r*=t/o}return n},hypot:function hypot(e,t){var r=0;var n=0;for(var o=0;o<arguments.length;++o){var i=F(Number(arguments[o]));if(n<i){r*=n/i*(n/i);r+=1;n=i}else{r+=i>0?i/n*(i/n):i}}return n===Infinity?Infinity:n*z(r)},log2:function log2(e){return D(e)*Math.LOG2E},log10:function log10(e){return D(e)*Math.LOG10E},log1p:function log1p(e){var t=Number(e);if(t<-1||Number.isNaN(t)){return NaN}if(t===0||t===Infinity){return t}if(t===-1){return-Infinity}return 1+t-1===0?t:t*(D(1+t)/(1+t-1))},sign:function sign(e){var t=Number(e);if(t===0){return t}if(Number.isNaN(t)){return t}return t<0?-1:1},sinh:function sinh(e){var t=Number(e);if(!S(t)||t===0){return t}if(F(t)<1){return(Math.expm1(t)-Math.expm1(-t))/2}return(Math.exp(t-1)-Math.exp(-t-1))*Math.E/2},tanh:function tanh(e){var t=Number(e);if(Number.isNaN(t)||t===0){return t}if(t===Infinity){return 1}if(t===-Infinity){return-1}var r=Math.expm1(t);var n=Math.expm1(-t);if(r===Infinity){return 1}if(n===Infinity){return-1}return(r-n)/(Math.exp(t)+Math.exp(-t))},trunc:function trunc(e){var t=Number(e);return t<0?-R(-t):R(t)},imul:function imul(e,t){var r=te.ToUint32(e);var n=te.ToUint32(t);var o=r>>>16&65535;var i=r&65535;var a=n>>>16&65535;var u=n&65535;return i*u+(o*u+i*a<<16>>>0)|0},fround:function fround(e){var t=Number(e);if(t===0||t===Infinity||t===-Infinity||X(t)){return t}var r=Math.sign(t);var n=F(t);if(n<Ot){return r*gt(n/Ot/dt)*Ot*dt}var o=(1+dt/Number.EPSILON)*n;var i=o-(o-n);if(i>mt||X(i)){return r*Infinity}return r*i}};b(Math,jt);y(Math,"log1p",jt.log1p,Math.log1p(-1e-17)!==-1e-17);y(Math,"asinh",jt.asinh,Math.asinh(-1e7)!==-Math.asinh(1e7));y(Math,"tanh",jt.tanh,Math.tanh(-2e-17)!==-2e-17);y(Math,"acosh",jt.acosh,Math.acosh(Number.MAX_VALUE)===Infinity);y(Math,"cbrt",jt.cbrt,Math.abs(1-Math.cbrt(1e-300)/1e-100)/Number.EPSILON>8);y(Math,"sinh",jt.sinh,Math.sinh(-2e-17)!==-2e-17);var St=Math.expm1(10);y(Math,"expm1",jt.expm1,St>22025.465794806718||St<22025.465794806718);var Tt=Math.round;var It=Math.round(.5-Number.EPSILON/4)===0&&Math.round(-.5+Number.EPSILON/3.99)===1;var Et=bt+1;var Mt=2*bt-1;var Pt=[Et,Mt].every(function(e){return Math.round(e)===e});y(Math,"round",function round(e){var t=R(e);var r=t===-1?-0:t+1;return e-t<.5?t:r},!It||!Pt);B.preserveToString(Math.round,Tt);var xt=Math.imul;if(Math.imul(4294967295,5)!==-5){Math.imul=jt.imul;B.preserveToString(Math.imul,xt)}if(Math.imul.length!==2){J(Math,"imul",function imul(t,r){return e(xt,Math,arguments)})}var Nt=function(){var e=j.setTimeout;if(typeof e!=="function"){return}te.IsPromise=function(e){if(!te.TypeIsObject(e)){return false}if(typeof e._promise==="undefined"){return false}return true};var r=function(e){if(!te.IsConstructor(e)){throw new TypeError("Bad promise constructor")}var t=this;var r=function(e,r){if(t.resolve!==void 0||t.reject!==void 0){throw new TypeError("Bad Promise implementation!")}t.resolve=e;t.reject=r};t.promise=new e(r);if(!(te.IsCallable(t.resolve)&&te.IsCallable(t.reject))){throw new TypeError("Bad promise constructor")}};var n;if(typeof window!=="undefined"&&te.IsCallable(window.postMessage)){n=function(){var e=[];var t="zero-timeout-message";var r=function(r){N(e,r);window.postMessage(t,"*")};var n=function(r){if(r.source===window&&r.data===t){r.stopPropagation();if(e.length===0){return}var n=A(e);n()}};window.addEventListener("message",n,true);return r}}var o=function(){var e=j.Promise;return e&&e.resolve&&function(t){return e.resolve().then(t)}};var i=te.IsCallable(j.setImmediate)?j.setImmediate.bind(j):typeof process==="object"&&process.nextTick?process.nextTick:o()||(te.IsCallable(n)?n():function(t){e(t,0)});var a=1;var u=2;var s=3;var c=4;var l=5;var p=function(e,t){var r=e.capabilities;var n=e.handler;var o,i=false,s;if(n===a){o=t}else if(n===u){o=t;i=true}else{try{o=n(t)}catch(f){o=f;i=true}}s=i?r.reject:r.resolve;s(o)};var v=function(e,t){f(e,function(e){i(function(){p(e,t)})})};var h=function(e,t){var r=e._promise;var n=r.fulfillReactions;r.result=t;r.fulfillReactions=void 0;r.rejectReactions=void 0;r.state=c;v(n,t)};var y=function(e,t){var r=e._promise;var n=r.rejectReactions;r.result=t;r.fulfillReactions=void 0;r.rejectReactions=void 0;r.state=l;v(n,t)};var g=function(e){var t=false;var r=function(r){var n;if(t){return}t=true;if(r===e){return y(e,new TypeError("Self resolution"))}if(!te.TypeIsObject(r)){return h(e,r)}try{n=r.then}catch(o){return y(e,o)}if(!te.IsCallable(n)){return h(e,r)}i(function(){d(e,r,n)})};var n=function(r){if(t){return}t=true;return y(e,r)};return{resolve:r,reject:n}};var d=function(e,r,n){var o=g(e);var i=o.resolve;var a=o.reject;try{t(n,r,i,a)}catch(u){a(u)}};var m=function(e){if(!te.TypeIsObject(e)){throw new TypeError("Promise is not object")}var t=e[H];if(t!==void 0&&t!==null){return t}return e};var O=function Promise(e){if(!(this instanceof Promise)){throw new TypeError('Constructor Promise requires "new"')}if(this&&this._promise){throw new TypeError("Bad construction")}if(!te.IsCallable(e)){throw new TypeError("not a valid resolver")}var t=re(this,Promise,w,{_promise:{result:void 0,state:s,fulfillReactions:[],rejectReactions:[]}});var r=g(t);var n=r.reject;try{e(r.resolve,n)}catch(o){n(o)}return t};var w=O.prototype;var S=function(e,t,r,n){var o=false;return function(i){if(o){return}o=true;t[e]=i;if(--n.count===0){var a=r.resolve;a(t)}}};var T=function(e,t,r){var n=e.iterator;var o=[],i={count:1},a,u;var s=0;while(true){try{a=te.IteratorStep(n);if(a===false){e.done=true;break}u=a.value}catch(f){e.done=true;throw f}o[s]=void 0;var c=t.resolve(u);var l=S(s,o,r,i);i.count++;c.then(l,r.reject);s+=1}if(--i.count===0){var p=r.resolve;p(o)}return r.promise};var I=function(e,t,r){var n=e.iterator,o,i,a;while(true){try{o=te.IteratorStep(n);if(o===false){e.done=true;break}i=o.value}catch(u){e.done=true;throw u}a=t.resolve(i);a.then(r.resolve,r.reject)}return r.promise};b(O,{all:function all(e){var t=m(this);var n=new r(t);var o,i;try{o=te.GetIterator(e);i={iterator:o,done:false};return T(i,t,n)}catch(a){if(i&&!i.done){try{te.IteratorClose(o,true)}catch(u){a=u}}var s=n.reject;s(a);return n.promise}},race:function race(e){var t=m(this);var n=new r(t);var o,i;try{o=te.GetIterator(e);i={iterator:o,done:false};return I(i,t,n)}catch(a){if(i&&!i.done){try{te.IteratorClose(o,true)}catch(u){a=u}}var s=n.reject;s(a);return n.promise}},reject:function reject(e){var t=this;var n=new r(t);var o=n.reject;o(e);return n.promise},resolve:function resolve(e){var t=this;if(te.IsPromise(e)){var n=e.constructor;if(n===t){return e}}var o=new r(t);var i=o.resolve;i(e);return o.promise}});b(w,{"catch":function(e){return this.then(void 0,e)},then:function then(e,t){var n=this;if(!te.IsPromise(n)){throw new TypeError("not a promise")}var o=te.SpeciesConstructor(n,O);var f=new r(o);if(!te.IsCallable(e)){e=a}if(!te.IsCallable(t)){t=u}var v={capabilities:f,handler:e};var h={capabilities:f,handler:t};var y=n._promise,b;if(y.state===s){N(y.fulfillReactions,v);
N(y.rejectReactions,h)}else if(y.state===c){b=y.result;i(function(){p(v,b)})}else if(y.state===l){b=y.result;i(function(){p(h,b)})}else{throw new TypeError("unexpected Promise state")}return f.promise}});return O}();if(j.Promise){delete j.Promise.accept;delete j.Promise.defer;delete j.Promise.prototype.chain}if(typeof Nt==="function"){b(j,{Promise:Nt});var Ct=d(j.Promise,function(e){return e.resolve(42).then(function(){})instanceof e});var At=!n(function(){j.Promise.reject(42).then(null,5).then(null,G)});var _t=n(function(){j.Promise.call(3,G)});var kt=function(e){var t=e.resolve(5);t.constructor={};var r=e.resolve(t);return t===r}(j.Promise);if(!Ct||!At||!_t||kt){Promise=Nt;J(j,"Promise",Nt)}U(Promise)}var Rt=function(e){var t=Object.keys(c(e,function(e,t){e[t]=true;return e},{}));return e.join(":")===t.join(":")};var Ft=Rt(["z","a","bb"]);var Dt=Rt(["z",1,"a","3",2]);if(u){var zt=function fastkey(e){if(!Ft){return null}var t=typeof e;if(t==="undefined"||e===null){return"^"+String(e)}else if(t==="string"){return"$"+e}else if(t==="number"){if(!Dt){return"n"+e}return e}else if(t==="boolean"){return"b"+e}return null};var Lt=function emptyObject(){return Object.create?Object.create(null):{}};var qt=function addIterableToMap(e,r,n){if(Array.isArray(n)||K.string(n)){f(n,function(e){r.set(e[0],e[1])})}else if(n instanceof e){t(e.prototype.forEach,n,function(e,t){r.set(t,e)})}else{var o,i;if(n!==null&&typeof n!=="undefined"){i=r.set;if(!te.IsCallable(i)){throw new TypeError("bad map")}o=te.GetIterator(n)}if(typeof o!=="undefined"){while(true){var a=te.IteratorStep(o);if(a===false){break}var u=a.value;try{if(!te.TypeIsObject(u)){throw new TypeError("expected iterable of pairs")}t(i,r,u[0],u[1])}catch(s){te.IteratorClose(o,true);throw s}}}}};var Gt=function addIterableToSet(e,r,n){if(Array.isArray(n)||K.string(n)){f(n,function(e){r.add(e)})}else if(n instanceof e){t(e.prototype.forEach,n,function(e){r.add(e)})}else{var o,i;if(n!==null&&typeof n!=="undefined"){i=r.add;if(!te.IsCallable(i)){throw new TypeError("bad set")}o=te.GetIterator(n)}if(typeof o!=="undefined"){while(true){var a=te.IteratorStep(o);if(a===false){break}var u=a.value;try{t(i,r,u)}catch(s){te.IteratorClose(o,true);throw s}}}}};var Wt={Map:function(){var e={};var r=function MapEntry(e,t){this.key=e;this.value=t;this.next=null;this.prev=null};r.prototype.isRemoved=function isRemoved(){return this.key===e};var n=function isMap(e){return!!e._es6map};var o=function requireMapSlot(e,t){if(!te.TypeIsObject(e)||!n(e)){throw new TypeError("Method Map.prototype."+t+" called on incompatible receiver "+String(e))}};var i=function MapIterator(e,t){o(e,"[[MapIterator]]");this.head=e._head;this.i=this.head;this.kind=t};i.prototype={next:function next(){var e=this.i,t=this.kind,r=this.head,n;if(typeof this.i==="undefined"){return{value:void 0,done:true}}while(e.isRemoved()&&e!==r){e=e.prev}while(e.next!==r){e=e.next;if(!e.isRemoved()){if(t==="key"){n=e.key}else if(t==="value"){n=e.value}else{n=[e.key,e.value]}this.i=e;return{value:n,done:false}}}this.i=void 0;return{value:void 0,done:true}}};Y(i.prototype);var a=function Map(){if(!(this instanceof Map)){throw new TypeError('Constructor Map requires "new"')}if(this&&this._es6map){throw new TypeError("Bad construction")}var e=re(this,Map,u,{_es6map:true,_head:null,_storage:Lt(),_size:0});var t=new r(null,null);t.next=t.prev=t;e._head=t;if(arguments.length>0){qt(Map,e,arguments[0])}return e};var u=a.prototype;B.getter(u,"size",function(){if(typeof this._size==="undefined"){throw new TypeError("size method called on incompatible Map")}return this._size});b(u,{get:function get(e){o(this,"get");var t=zt(e);if(t!==null){var r=this._storage[t];if(r){return r.value}else{return}}var n=this._head,i=n;while((i=i.next)!==n){if(te.SameValueZero(i.key,e)){return i.value}}},has:function has(e){o(this,"has");var t=zt(e);if(t!==null){return typeof this._storage[t]!=="undefined"}var r=this._head,n=r;while((n=n.next)!==r){if(te.SameValueZero(n.key,e)){return true}}return false},set:function set(e,t){o(this,"set");var n=this._head,i=n,a;var u=zt(e);if(u!==null){if(typeof this._storage[u]!=="undefined"){this._storage[u].value=t;return this}else{a=this._storage[u]=new r(e,t);i=n.prev}}while((i=i.next)!==n){if(te.SameValueZero(i.key,e)){i.value=t;return this}}a=a||new r(e,t);if(te.SameValue(-0,e)){a.key=+0}a.next=this._head;a.prev=this._head.prev;a.prev.next=a;a.next.prev=a;this._size+=1;return this},"delete":function(t){o(this,"delete");var r=this._head,n=r;var i=zt(t);if(i!==null){if(typeof this._storage[i]==="undefined"){return false}n=this._storage[i].prev;delete this._storage[i]}while((n=n.next)!==r){if(te.SameValueZero(n.key,t)){n.key=n.value=e;n.prev.next=n.next;n.next.prev=n.prev;this._size-=1;return true}}return false},clear:function clear(){o(this,"clear");this._size=0;this._storage=Lt();var t=this._head,r=t,n=r.next;while((r=n)!==t){r.key=r.value=e;n=r.next;r.next=r.prev=t}t.next=t.prev=t},keys:function keys(){o(this,"keys");return new i(this,"key")},values:function values(){o(this,"values");return new i(this,"value")},entries:function entries(){o(this,"entries");return new i(this,"key+value")},forEach:function forEach(e){o(this,"forEach");var r=arguments.length>1?arguments[1]:null;var n=this.entries();for(var i=n.next();!i.done;i=n.next()){if(r){t(e,r,i.value[1],i.value[0],this)}else{e(i.value[1],i.value[0],this)}}}});Y(u,u.entries);return a}(),Set:function(){var e=function isSet(e){return e._es6set&&typeof e._storage!=="undefined"};var r=function requireSetSlot(t,r){if(!te.TypeIsObject(t)||!e(t)){throw new TypeError("Set.prototype."+r+" called on incompatible receiver "+String(t))}};var n=function Set(){if(!(this instanceof Set)){throw new TypeError('Constructor Set requires "new"')}if(this&&this._es6set){throw new TypeError("Bad construction")}var e=re(this,Set,o,{_es6set:true,"[[SetData]]":null,_storage:Lt()});if(!e._es6set){throw new TypeError("bad set")}if(arguments.length>0){Gt(Set,e,arguments[0])}return e};var o=n.prototype;var i=function ensureMap(e){if(!e["[[SetData]]"]){var t=e["[[SetData]]"]=new Wt.Map;f(Object.keys(e._storage),function(e){if(e==="^null"){e=null}else if(e==="^undefined"){e=void 0}else{var r=e.charAt(0);if(r==="$"){e=x(e,1)}else if(r==="n"){e=+x(e,1)}else if(r==="b"){e=e==="btrue"}else{e=+e}}t.set(e,e)});e._storage=null}};B.getter(n.prototype,"size",function(){r(this,"size");i(this);return this["[[SetData]]"].size});b(n.prototype,{has:function has(e){r(this,"has");var t;if(this._storage&&(t=zt(e))!==null){return!!this._storage[t]}i(this);return this["[[SetData]]"].has(e)},add:function add(e){r(this,"add");var t;if(this._storage&&(t=zt(e))!==null){this._storage[t]=true;return this}i(this);this["[[SetData]]"].set(e,e);return this},"delete":function(e){r(this,"delete");var t;if(this._storage&&(t=zt(e))!==null){var n=L(this._storage,t);return delete this._storage[t]&&n}i(this);return this["[[SetData]]"]["delete"](e)},clear:function clear(){r(this,"clear");if(this._storage){this._storage=Lt()}else{this["[[SetData]]"].clear()}},values:function values(){r(this,"values");i(this);return this["[[SetData]]"].values()},entries:function entries(){r(this,"entries");i(this);return this["[[SetData]]"].entries()},forEach:function forEach(e){r(this,"forEach");var n=arguments.length>1?arguments[1]:null;var o=this;i(o);this["[[SetData]]"].forEach(function(r,i){if(n){t(e,n,i,i,o)}else{e(i,i,o)}})}});y(n.prototype,"keys",n.prototype.values,true);Y(n.prototype,n.prototype.values);return n}()};if(j.Map||j.Set){var Ht=o(function(){return new Map([[1,2]]).get(1)===2});if(!Ht){var Bt=j.Map;j.Map=function Map(){if(!(this instanceof Map)){throw new TypeError('Constructor Map requires "new"')}var e=new Bt;if(arguments.length>0){qt(Map,e,arguments[0])}Object.setPrototypeOf(e,j.Map.prototype);y(e,"constructor",Map,true);return e};j.Map.prototype=g(Bt.prototype);B.preserveToString(j.Map,Bt)}var Vt=new Map;var $t=function(e){e["delete"](0);e["delete"](-0);e.set(0,3);e.get(-0,4);return e.get(0)===3&&e.get(-0)===4}(Vt);var Ut=Vt.set(1,2)===Vt;if(!$t||!Ut){var Kt=Map.prototype.set;J(Map.prototype,"set",function set(e,r){t(Kt,this,e===0?0:e,r);return this})}if(!$t){var Xt=Map.prototype.get;var Zt=Map.prototype.has;b(Map.prototype,{get:function get(e){return t(Xt,this,e===0?0:e)},has:function has(e){return t(Zt,this,e===0?0:e)}},true);B.preserveToString(Map.prototype.get,Xt);B.preserveToString(Map.prototype.has,Zt)}var Jt=new Set;var Qt=function(e){e["delete"](0);e.add(-0);return!e.has(0)}(Jt);var Yt=Jt.add(1)===Jt;if(!Qt||!Yt){var er=Set.prototype.add;Set.prototype.add=function add(e){t(er,this,e===0?0:e);return this};B.preserveToString(Set.prototype.add,er)}if(!Qt){var tr=Set.prototype.has;Set.prototype.has=function has(e){return t(tr,this,e===0?0:e)};B.preserveToString(Set.prototype.has,tr);var rr=Set.prototype["delete"];Set.prototype["delete"]=function SetDelete(e){return t(rr,this,e===0?0:e)};B.preserveToString(Set.prototype["delete"],rr)}var nr=d(j.Map,function(e){var t=new e([]);t.set(42,42);return t instanceof e});var or=Object.setPrototypeOf&&!nr;var ir=function(){try{return!(j.Map()instanceof j.Map)}catch(e){return e instanceof TypeError}}();if(j.Map.length!==0||or||!ir){var ar=j.Map;j.Map=function Map(){if(!(this instanceof Map)){throw new TypeError('Constructor Map requires "new"')}var e=new ar;if(arguments.length>0){qt(Map,e,arguments[0])}Object.setPrototypeOf(e,Map.prototype);y(e,"constructor",Map,true);return e};j.Map.prototype=ar.prototype;B.preserveToString(j.Map,ar)}var ur=d(j.Set,function(e){var t=new e([]);t.add(42,42);return t instanceof e});var sr=Object.setPrototypeOf&&!ur;var fr=function(){try{return!(j.Set()instanceof j.Set)}catch(e){return e instanceof TypeError}}();if(j.Set.length!==0||sr||!fr){var cr=j.Set;j.Set=function Set(){if(!(this instanceof Set)){throw new TypeError('Constructor Set requires "new"')}var e=new cr;if(arguments.length>0){Gt(Set,e,arguments[0])}Object.setPrototypeOf(e,Set.prototype);y(e,"constructor",Set,true);return e};j.Set.prototype=cr.prototype;B.preserveToString(j.Set,cr)}var lr=!o(function(){return(new Map).keys().next().done});if(typeof j.Map.prototype.clear!=="function"||(new j.Set).size!==0||(new j.Map).size!==0||typeof j.Map.prototype.keys!=="function"||typeof j.Set.prototype.keys!=="function"||typeof j.Map.prototype.forEach!=="function"||typeof j.Set.prototype.forEach!=="function"||i(j.Map)||i(j.Set)||typeof(new j.Map).keys().next!=="function"||lr||!nr){delete j.Map;delete j.Set;b(j,{Map:Wt.Map,Set:Wt.Set},true)}if(j.Set.prototype.keys!==j.Set.prototype.values){y(j.Set.prototype,"keys",j.Set.prototype.values,true)}Y(Object.getPrototypeOf((new j.Map).keys()));Y(Object.getPrototypeOf((new j.Set).keys()));if(s&&j.Set.prototype.has.name!=="has"){var pr=j.Set.prototype.has;J(j.Set.prototype,"has",function has(e){return t(pr,this,e)})}}b(j,Wt);U(j.Map);U(j.Set)}if(!j.Reflect){y(j,"Reflect",{})}var vr=j.Reflect;var hr=function throwUnlessTargetIsObject(e){if(!te.TypeIsObject(e)){throw new TypeError("target must be an object")}};var yr={apply:function apply(){return e(te.Call,null,arguments)},construct:function construct(e,t){if(!te.IsConstructor(e)){throw new TypeError("First argument must be a constructor.")}var r=arguments.length<3?e:arguments[2];if(!te.IsConstructor(r)){throw new TypeError("new.target must be a constructor.")}return te.Construct(e,t,r,"internal")},deleteProperty:function deleteProperty(e,t){hr(e);if(u){var r=Object.getOwnPropertyDescriptor(e,t);if(r&&!r.configurable){return false}}return delete e[t]},enumerate:function enumerate(e){hr(e);return new he(e,"key")},has:function has(e,t){hr(e);return t in e}};if(Object.getOwnPropertyNames){Object.assign(yr,{ownKeys:function ownKeys(e){hr(e);var t=Object.getOwnPropertyNames(e);if(te.IsCallable(Object.getOwnPropertySymbols)){C(t,Object.getOwnPropertySymbols(e))}return t}})}var br=function ConvertExceptionToBoolean(e){return!n(e)};if(Object.preventExtensions){Object.assign(yr,{isExtensible:function isExtensible(e){hr(e);return Object.isExtensible(e)},preventExtensions:function preventExtensions(e){hr(e);return br(function(){Object.preventExtensions(e)})}})}if(u){var gr=function get(e,r,n){var o=Object.getOwnPropertyDescriptor(e,r);if(!o){var i=Object.getPrototypeOf(e);if(i===null){return undefined}return gr(i,r,n)}if("value"in o){return o.value}if(o.get){return t(o.get,n)}return undefined};var dr=function set(e,r,n,o){var i=Object.getOwnPropertyDescriptor(e,r);if(!i){var a=Object.getPrototypeOf(e);if(a!==null){return dr(a,r,n,o)}i={value:void 0,writable:true,enumerable:true,configurable:true}}if("value"in i){if(!i.writable){return false}if(!te.TypeIsObject(o)){return false}var u=Object.getOwnPropertyDescriptor(o,r);if(u){return vr.defineProperty(o,r,{value:n})}else{return vr.defineProperty(o,r,{value:n,writable:true,enumerable:true,configurable:true})}}if(i.set){t(i.set,o,n);return true}return false};Object.assign(yr,{defineProperty:function defineProperty(e,t,r){hr(e);return br(function(){Object.defineProperty(e,t,r)})},getOwnPropertyDescriptor:function getOwnPropertyDescriptor(e,t){hr(e);return Object.getOwnPropertyDescriptor(e,t)},get:function get(e,t){hr(e);var r=arguments.length>2?arguments[2]:e;return gr(e,t,r)},set:function set(e,t,r){hr(e);var n=arguments.length>3?arguments[3]:e;return dr(e,t,r,n)}})}if(Object.getPrototypeOf){var mr=Object.getPrototypeOf;yr.getPrototypeOf=function getPrototypeOf(e){hr(e);return mr(e)}}if(Object.setPrototypeOf&&yr.getPrototypeOf){var Or=function(e,t){while(t){if(e===t){return true}t=yr.getPrototypeOf(t)}return false};Object.assign(yr,{setPrototypeOf:function setPrototypeOf(e,t){hr(e);if(t!==null&&!te.TypeIsObject(t)){throw new TypeError("proto must be an object or null")}if(t===vr.getPrototypeOf(e)){return true}if(vr.isExtensible&&!vr.isExtensible(e)){return false}if(Or(e,t)){return false}Object.setPrototypeOf(e,t);return true}})}var wr=function(e,t){if(!te.IsCallable(j.Reflect[e])){y(j.Reflect,e,t)}else{var r=o(function(){j.Reflect[e](1);j.Reflect[e](NaN);j.Reflect[e](true);return true});if(r){J(j.Reflect,e,t)}}};Object.keys(yr).forEach(function(e){wr(e,yr[e])});if(s&&j.Reflect.getPrototypeOf.name!=="getPrototypeOf"){var jr=j.Reflect.getPrototypeOf;J(j.Reflect,"getPrototypeOf",function getPrototypeOf(e){return t(jr,j.Reflect,e)})}if(j.Reflect.setPrototypeOf){if(o(function(){j.Reflect.setPrototypeOf(1,{});return true})){J(j.Reflect,"setPrototypeOf",yr.setPrototypeOf)}}if(j.Reflect.defineProperty){if(o(function(){j.Reflect.defineProperty(1,"test",{value:1});return true})){J(j.Reflect,"defineProperty",yr.defineProperty)}}if(j.Reflect.construct){if(!o(function(){var e=function F(){};return j.Reflect.construct(function(){},[],e)instanceof e})){J(j.Reflect,"construct",yr.construct)}}if(String(new Date(NaN))!=="Invalid Date"){var Sr=Date.prototype.toString;var Tr=function toString(){var e=+this;if(e!==e){return"Invalid Date"}return t(Sr,this)};J(Date.prototype,"toString",Tr)}var Ir={anchor:function anchor(e){return te.CreateHTML(this,"a","name",e)},big:function big(){return te.CreateHTML(this,"big","","")},blink:function blink(){return te.CreateHTML(this,"blink","","")},bold:function bold(){return te.CreateHTML(this,"b","","")},fixed:function fixed(){return te.CreateHTML(this,"tt","","")},fontcolor:function fontcolor(e){return te.CreateHTML(this,"font","color",e)},fontsize:function fontsize(e){return te.CreateHTML(this,"font","size",e)},italics:function italics(){return te.CreateHTML(this,"i","","")},link:function link(e){return te.CreateHTML(this,"a","href",e)},small:function small(){return te.CreateHTML(this,"small","","")},strike:function strike(){return te.CreateHTML(this,"strike","","")},sub:function sub(){return te.CreateHTML(this,"sub","","")},sup:function sub(){return te.CreateHTML(this,"sup","","")}};f(Object.keys(Ir),function(e){var r=String.prototype[e];var n=false;if(te.IsCallable(r)){var o=t(r,"",' " ');var i=P([],o.match(/"/g)).length;n=o!==o.toLowerCase()||i>2}else{n=true}if(n){y(String.prototype,e,Ir[e],true)}});return j});


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketDetailController', TicketDetailController);

    TicketDetailController.$inject = ['$state', '$scope', '$window', 'Tickets', 'entity', 'HepcTicketTask', 'Principal', 'TicketsLogs', 'UploadTicketAttachment', 'downloadticketattachment', 'TicketsCustomer','DepartmentService'];

    function TicketDetailController($state, $scope, $window, Tickets, entity, HepcTicketTask, Principal, TicketsLogs, UploadTicketAttachment, downloadticketattachment, TicketsCustomer ,DepartmentService) {
        var vm = this;
        vm.tickets = entity;
        vm.ticketsLogs = {};
        vm.account= {};
        vm.hepcTicketTask = {};
        vm.changeStatus = changeStatus;
        vm.changeLevel = changeLevel;
        vm.uploadFile = uploadFile;
        vm.downloadAttachment = downloadAttachment;
        vm.levelChange= false;
        vm.statusChange= false;
        vm.timeStatus=false;
        $scope.file = {};
        vm.service = {};

        loadAll();

        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;
            });
            
            if(vm.tickets.serviceid !==null)
            {
                DepartmentService.get({id:vm.tickets.serviceid},function(result) {
                    vm.service = result;
                    console.log(vm.departmentServices);
                    vm.searchQuery = null;
                });

            }

            if(entity.cafpin.length===10){
                TicketsCustomer.get({columnKey: "cafpin", columnValue: entity.cafpin},function (result) {
                    vm.complainant=result;
                });
            }
            else if(entity.cafpin.length>10){
                if(entity.investorDetail.includes("@")){
                    TicketsCustomer.get({columnKey: "email", columnValue: entity.investorDetail},function (result) {
                        vm.complainant=result;
                    });
                }
                else{
                    TicketsCustomer.get({columnKey: "mobileNumber", columnValue: entity.investorDetail},function (result) {
                        vm.complainant=result;
                    });
                }

            }


            HepcTicketTask.query(function (result) {
                vm.hepcTicketTask = result[0];
                if(vm.hepcTicketTask.isWorkingDay){
                    if(vm.hepcTicketTask.isWorkingHours){
                        vm.workingStatus=true;
                        if(entity.timeLeft>0) {
                            vm.timeStatus=true;
                            var clock = $('.countDown').FlipClock(entity.timeLeft, {
                                clockFace: 'HourCounter',
                                countdown: true,
                                autoStart: true
                            });
                        }
                    }
                    else{
                        vm.workingStatus=false;
                        if(entity.timeLeft>0) {
                            vm.timeStatus=true;
                            var clock = $('.countDown').FlipClock(entity.timeLeft, {
                                clockFace: 'HourCounter',
                                countdown: false,
                                autoStart: false
                            });
                        }
                    }
                }
                else {
                    vm.workingStatus = false;
                    if(entity.timeLeft>0) {
                        vm.timeStatus=true;
                        var clock = $('.countDown').FlipClock(entity.timeLeft, {
                            clockFace: 'HourCounter',
                            countdown: false,
                            autoStart: false
                        });
                    }
                }
            });
        }

        function changeStatus () {
            vm.statusChange= true;
            vm.tickets.status = "Closed";
            vm.tickets.latestRemark = vm.latestRemark;
            Tickets.update(vm.tickets, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess (result) {
            alert("Ticket Closed successfully");
            vm.statusChange= false;
            $state.go('ticketview');
            location.reload();
        }

        function onSaveError () {
            alert("Error while closing ticket");
            $("#setStatus").modal("hide");
            vm.statusChange= false;
            location.reload();
        }

        function changeLevel () {
            vm.levelChange= true;
            vm.tickets.latestRemark = vm.latestRemark;
            Tickets.update(vm.tickets, onAssignSuccess, onAssignError);
        }

        function onAssignSuccess (result) {
            alert("Assigned to next level successfully");
            vm.levelChange= false;
            $state.go('ticketview');
            location.reload();
        }

        function onAssignError () {
            alert("Error while assigning");
            vm.levelChange= false;
            $("#changeLevel").modal("hide");
            location.reload();
        }

        function uploadFile () {
            vm.ticketsLogs.ticketId = vm.tickets.id;
            vm.ticketsLogs.ticketNumber = vm.tickets.ticketNumber;
            vm.ticketsLogs.creationDate = vm.tickets.creationDate;
            vm.ticketsLogs.actionBy = vm.account.login;
            vm.ticketsLogs.actionByName = vm.account.firstName+" "+vm.account.lastName;
            vm.ticketsLogs.departmentName = vm.tickets.departmentName;
            vm.ticketsLogs.departmentId = vm.tickets.departmentId;
            vm.ticketsLogs.projectid = vm.tickets.projectid;
            vm.ticketsLogs.serviceid = vm.tickets.serviceid;
            vm.ticketsLogs.remark = vm.ticketComment;
            vm.ticketsLogs.cafpin = vm.tickets.cafpin;
            vm.ticketsLogs.status = vm.tickets.status;
            vm.ticketsLogs.assignedMember = vm.tickets.assignedMemberName;
            vm.ticketsLogs.assignedMemberName = vm.tickets.assignedMemberUserName;

            if(angular.isDefined(vm.file)){
                var file =  vm.file;
                UploadTicketAttachment.saveFile(file,onUploadSuccess,onUploadError);
            }else {
                vm.ticketsLogs.actionType = "Comment";
                TicketsLogs.save(vm.ticketsLogs, onLogSuccess, onLogError);
            }
        }

        function onUploadSuccess (result) {
            vm.ticketsLogs.actionType = "Comment And Attachment";
            vm.ticketsLogs.attachment = result.filename;

            TicketsLogs.save(vm.ticketsLogs, onLogSuccess, onLogError);
        }

        function onUploadError () {
            alert("Error while adding comment and file");
            $("#commentUpload").modal("hide");
            location.reload();
        }

        function onLogSuccess (result) {
            alert("Comment added successfully");
            $("#commentUpload").modal("hide");
            location.reload();
        }

        function onLogError () {
            alert("Error while adding comment");
            $("#commentUpload").modal("hide");
            location.reload();
        }

        function downloadAttachment(attachment) {
            downloadticketattachment.download(attachment)
                .then(function(success) {
                }, function(error) {
                    alert('error : ' + error);
                });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('ticketview', {
                parent: 'hepcticket',
                url: '/ticketview',
                data: {
                    authorities: ["ROLE_L1_SUPPORT","ROLE_L2_IT_MANAGER","ROLE_L2_DEPARTMENT","ROLE_L2_DEPARTMENT_HEAD","ROLE_L2_INCENTIVES","ROLE_TICKET_NODAL_OFFICER","ROLE_TICKET_OPERATION_MANAGER","ROLE_NODAL_OFFICER","ROLE_ADMIN","ROLE_SUB_ADMIN","ROLE_TICKET_HOBPAS"]
                },
                views: {
                    'content_section@hepcticket': {
                        templateUrl: 'app/hepcTickets/viewTicket/viewMyOpenTicket.html',
                        controller: 'TicketViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('allticketview', {
                parent: 'hepcticket',
                url: '/allTickets',
                data: {
                    authorities: ["ROLE_L1_SUPPORT","ROLE_TICKET_OPERATION_MANAGER","ROLE_ADMIN","ROLE_SUB_ADMIN", "ROLE_TICKET_HOBPAS"]
                },
                views: {
                    'content_section@hepcticket': {
                        templateUrl: 'app/hepcTickets/viewTicket/viewTicketCreatedBy.html',
                        controller: 'TicketViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('timeoutTickets', {
                parent: 'hepcticket',
                url: '/escalatedTickets',
                data: {
                    authorities: ["ROLE_L2_DEPARTMENT_HEAD"]
                },
                views: {
                    'content_section@hepcticket': {
                        templateUrl: 'app/hepcTickets/viewTicket/escalatedTickets.html',
                        controller: 'EscalatedTicketController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('depTicketsView', {
                parent: 'hepcticket',
                url: '/deptarmentTickets',
                data: {
                    authorities: ["ROLE_L2_DEPARTMENT_HEAD"]
                },
                views: {
                    'content_section@hepcticket': {
                        templateUrl: 'app/hepcTickets/viewTicket/departmentTickets.html',
                        controller: 'DepartmentTicketsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('closedticketview', {
                parent: 'hepcticket',
                url: '/closedticketview',
                data: {
                    authorities: ["ROLE_L1_SUPPORT","ROLE_L2_IT_MANAGER","ROLE_L2_DEPARTMENT","ROLE_L2_DEPARTMENT_HEAD","ROLE_L2_INCENTIVES","ROLE_TICKET_NODAL_OFFICER","ROLE_TICKET_OPERATION_MANAGER","ROLE_NODAL_OFFICER","ROLE_ADMIN","ROLE_SUB_ADMIN","ROLE_TICKET_HOBPAS"]
                },
                views: {
                    'content_section@hepcticket': {
                        templateUrl: 'app/hepcTickets/viewTicket/viewClosedTicket.html',
                        controller: 'ClosedTicketViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('hepcticketadmin', {
                parent: 'hepcticket',
                url: '/hepcticketadmin',
                data: {
                    authorities: ["ROLE_ADMIN","ROLE_SUB_ADMIN","ROLE_TICKET_OPERATION_MANAGER","ROLE_TICKET_ADMIN"]
                },
                views: {
                    'content_section@hepcticket': {
                        templateUrl: 'app/hepcTickets/viewTicket/adminTicketView.html',
                        controller: 'AdminTicketViewController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
            .state('ticketdetail', {
                parent: 'hepcticket',
                url: 'view-ticket-details/{id}',
                data: {
                    authorities: ["ROLE_L1_SUPPORT","ROLE_L2_IT_MANAGER","ROLE_L2_DEPARTMENT","ROLE_L2_DEPARTMENT_HEAD","ROLE_L2_INCENTIVES","ROLE_TICKET_NODAL_OFFICER","ROLE_TICKET_OPERATION_MANAGER","ROLE_NODAL_OFFICER","ROLE_ADMIN","ROLE_SUB_ADMIN","ROLE_TICKET_ADMIN","ROLE_TICKET_HOBPAS"]
                },
                views: {
                    'content_section@hepcticket': {
                        templateUrl: 'app/hepcTickets/viewTicket/viewTicketDetail.html',
                        controller: 'TicketDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Tickets', function($stateParams, Tickets) {
                        return Tickets.get({id : $stateParams.id}).$promise;
                    }]
                }
            });
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketViewController', TicketViewController);

    TicketViewController.$inject = ['Principal', '$state','Tickets', 'TicketsLogs', 'downloadticketattachment', 'AdminTickets'];

    function TicketViewController(Principal, $state, Tickets, TicketsLogs, downloadticketattachment, AdminTickets) {
        var vm = this;
        vm.tickets = [];
        vm.allTickets = [];
        vm.getLogs=getLogs;
        vm.redirect=redirect;
        vm.downloadAttachment=downloadAttachment;
        vm.show = false;
        loadAll();

        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;
                Tickets.query({assignedMember: vm.account.login, status: "Open"},function(result){
                   vm.tickets = result;
                    vm.show = true;
                   vm.searchQuery = null;
                });
                Tickets.query({createdBy: vm.account.login},function(result){
                   vm.allTickets = result;
                   vm.searchQuery = null;
                });
            });
        }

        function getLogs(ticketDetails) {
            TicketsLogs.query({ticketNumber: ticketDetails.ticketNumber},function (result) {
                vm.ticketsLogs=result;
            })
        }

        function downloadAttachment(attachment) {
            downloadticketattachment.download(attachment)
                .then(function(success) {
                }, function(error) {
                   alert('error : ' + error);
                });
        }

        function redirect(tkt) {
            if(!tkt.isOpen){
                tkt.isOpen = true;
                tkt.adminSaveWithLogs="Direct Save";
                AdminTickets.update(tkt, onUpdateSuccess, onUpdateError)
            }
            else {
                $state.go('ticketdetail',{id:tkt.id});
            }
        }

        function onUpdateSuccess(result) {
            $state.go('ticketdetail',{id:result.id});
        }

        function onUpdateError() {
            alert("Error While Validating Ticket");
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ClosedTicketViewController', ClosedTicketViewController);

    ClosedTicketViewController.$inject = ['Principal','Tickets', 'TicketsLogs', 'downloadticketattachment'];

    function ClosedTicketViewController(Principal,Tickets, TicketsLogs, downloadticketattachment) {
        var vm = this;
        vm.tickets = [];
        vm.getLogs=getLogs;
        vm.downloadAttachment=downloadAttachment;
        loadAll();

        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;
                Tickets.query({assignedMember: vm.account.login, status: "Closed"},function(result){
                   vm.tickets = result;
                   vm.searchQuery = null;
                });
            });
        }

        function getLogs(ticketDetails) {
            TicketsLogs.query({ticketNumber: ticketDetails.ticketNumber},function (result) {
                vm.ticketsLogs=result;
            })
        }

        function downloadAttachment(attachment) {
            downloadticketattachment.download(attachment)
                .then(function(success) {

                }, function(error) {
                    alert('error : ' + error);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('AdminTickets', AdminTickets);

    AdminTickets.$inject = ['$resource', 'DateUtils'];

    function AdminTickets ($resource, DateUtils) {
        var resourceUrl =  'api/adminTickets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.resolveDate = DateUtils.convertDateTimeFromServer(data.resolveDate);
                        data.assignDate = DateUtils.convertDateTimeFromServer(data.assignDate);
                        data.expectedResoluation = DateUtils.convertDateTimeFromServer(data.expectedResoluation);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EscalatedTicketController', EscalatedTicketController);

    EscalatedTicketController.$inject = ['Principal','Tickets', 'TicketsLogs', 'downloadticketattachment', 'TicketMember'];

    function EscalatedTicketController(Principal,Tickets, TicketsLogs, downloadticketattachment, TicketMember) {
        var vm = this;
        vm.account=null;
        vm.allEscalatedTickets = [];
        vm.getTicketByDepartment=getTicketByDepartment;
        vm.getLogs=getLogs;
        vm.downloadAttachment=downloadAttachment;
        loadAll();

        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;
                TicketMember.get({login: vm.account.login}, function (result) {
                    vm.ticketmember = result;
                });
            });
        }

        function getTicketByDepartment(key) {
            Tickets.query({columnKey: "EscalatedTickets", columnValue: key},function(result){
               vm.allEscalatedTickets = result;
               vm.searchQuery = null;
            });
        }

        function getLogs(ticketDetails) {
            TicketsLogs.query({ticketNumber: ticketDetails.ticketNumber},function (result) {
                vm.ticketsLogs=result;
            })
        }

        function downloadAttachment(attachment) {
            downloadticketattachment.download(attachment)
                .then(function(success) {}, function(error) {
                    alert('error : ' + error);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentTicketsController', DepartmentTicketsController);

    DepartmentTicketsController.$inject = ['Principal','Tickets', 'TicketsLogs', 'downloadticketattachment', 'TicketMember'];

    function DepartmentTicketsController(Principal,Tickets, TicketsLogs, downloadticketattachment, TicketMember) {
        var vm = this;
        vm.account=null;
        vm.pendingDepartmentTickets = [];
        vm.getLogs=getLogs;
        vm.downloadAttachment=downloadAttachment;
        loadAll();
        getPendingTicketByDepartment();

        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;
                TicketMember.get({login: vm.account.login}, function (result) {
                    vm.ticketmember = result;
                });

            });
        }

        function getPendingTicketByDepartment() {
            Tickets.query({columnKey: "DeptPendingTickets", columnValue: "HOD And Nodal"},function(result){
                vm.pendingDepartmentTickets = result;
                vm.searchQuery = null;
            });
        }

        function getLogs(ticketDetails) {
            TicketsLogs.query({ticketNumber: ticketDetails.ticketNumber},function (result) {
                vm.ticketsLogs=result;
            })
        }

        function downloadAttachment(attachment) {
            downloadticketattachment.download(attachment)
                .then(function(success) {}, function(error) {
                    alert('error : ' + error);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AdminTicketViewController', AdminTicketViewController);

    AdminTicketViewController.$inject = ['Principal', '$window', 'Tickets', 'TicketsLogs', 'downloadticketattachment', 'TicketsPagination'];

    function AdminTicketViewController(Principal, $window, Tickets, TicketsLogs, downloadticketattachment, TicketsPagination) {
        var vm = this;
        vm.tickets = [];
        vm.allTickets = [];
        vm.loadAll=loadAll;
        vm.getLogs=getLogs;
        vm.downloadAttachment = downloadAttachment;
        vm.loadAllTickets = loadAllTickets;
        vm.tickets1 = [];
        vm.ticketList1 = [];
        vm.download_all_table_data = download_all_table_data;


        vm.page = 0;
        loadAll(vm.page);



        function loadAll(page) {
            Principal.identity().then(function(account) {
                vm.account = account;
                    vm.page = page;
                    TicketsPagination.get({page: page, size: 1000}, function (result) {
                        vm.tickets = result.content;
                        vm.allTickets = vm.tickets;
                        vm.searchQuery = null;
                    });
        })
        }
        loadAllTickets();

        function loadAllTickets() {
            Tickets.query(function(result) {
                vm.tickets1 = result;
                vm.ticketList1=vm.tickets1;

            });
        }

        function convertJsonsToArrays(args){
            var dataArray = [];
            var header = [ "Ticket Number",
                "Subject",
                "Category",
                "Department",
                "Assigned Member",
                "Priority",
                "Creation By",
                "Creation On",
                "Closing Date",
                "Ticket Status"
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];

                var rowAr=[];
                rowAr.push(row.ticketNumber);
                rowAr.push(row.subject);
                rowAr.push(row.incidentCategory);
                rowAr.push(row.assignedDepartmentName);
                rowAr.push(row.assignedMemberUserName);
                rowAr.push(row.priority);
                rowAr.push(row.createdByName);
                rowAr.push(row.creationDate);
                rowAr.push(row.resolveDate);
                rowAr.push(row.status);
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function download_all_table_data(args) {
            var rowsCleared= convertJsonsToArrays(args);
            var lineArray = [];
            var lineArrayCleared = [];


            for(var i = 0; i < rowsCleared.length; i++){
                var lineCleared = rowsCleared[i].join("\t");
                lineArrayCleared.push(lineCleared);
            }
            lineArrayCleared = lineArrayCleared.join("\n");


            var title = [];
            var rows = [];
            title = title.join(",");
            rows = rows.join("\n");
            var csv = title + rows;
            var blob = new Blob([lineArrayCleared],{type: 'data:text/csv;charset=utf-8,'+ encodeURIComponent(csv)});
            var url = URL.createObjectURL(blob);
            $window.location.href = url;

        }



        function getLogs(ticketDetails) {
            TicketsLogs.query({ticketNumber: ticketDetails.ticketNumber},function (result) {
                vm.ticketsLogs=result;
            })
        }

        function downloadAttachment(attachment) {
            downloadticketattachment.download(attachment)
                .then(function(success) {}, function(error) {
                    alert('error : ' + error);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketFeedbackDetailController', TicketFeedbackDetailController);

    TicketFeedbackDetailController.$inject = ['$state', '$scope', 'entity', 'Principal', 'downloadticketattachment', 'TicketsCustomer', 'TicketsFeedback'];

    function TicketFeedbackDetailController($state, $scope, entity, Principal, downloadticketattachment, TicketsCustomer, TicketsFeedback) {
        var vm = this;
        vm.tickets = entity[0];
        vm.account= {};
        vm.downloadAttachment = downloadAttachment;
        $scope.file = {};
        loadAll();

        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;
            });

            if(vm.tickets.cafpin.length===10){
                TicketsCustomer.get({columnKey: "cafpin", columnValue: vm.tickets.cafpin},function (result) {
                    vm.complainant=result;
                });
            }
            else if(vm.tickets.cafpin.length>10){
                if(vm.tickets.investorDetail.includes("@")){
                    TicketsCustomer.get({columnKey: "email", columnValue: vm.tickets.investorDetail},function (result) {
                        vm.complainant=result;
                    });
                }
                else{
                    TicketsCustomer.get({columnKey: "mobileNumber", columnValue: vm.tickets.investorDetail},function (result) {
                        vm.complainant=result;
                    });
                }

            }
        }

        function downloadAttachment(attachment) {
            downloadticketattachment.download(attachment)
                .then(function(success) {
                }, function(error) {
                    alert('error : ' + error);
                });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ratingViewAdmin', {
            parent: 'hepcticket',
            url: '/feedbackView',
            data: {
                authorities: ["ROLE_ADMIN","ROLE_SUB_ADMIN","ROLE_TICKET_ADMIN"]
            },
            views: {
                'content_section@hepcticket': {
                    templateUrl: 'app/hepcTickets/ticketsFeedBackView/viewTicketFeedBack.html',
                    controller: 'FeedBackViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticketFeedbackdetail', {
                parent: 'ratingViewAdmin',
                url: '/{id}',
                data: {
                    authorities: ["ROLE_L1_SUPPORT","ROLE_L2_IT_MANAGER","ROLE_L2_DEPARTMENT","ROLE_L2_DEPARTMENT_HEAD","ROLE_L2_INCENTIVES","ROLE_TICKET_NODAL_OFFICER","ROLE_TICKET_OPERATION_MANAGER","ROLE_NODAL_OFFICER","ROLE_ADMIN","ROLE_SUB_ADMIN","ROLE_TICKET_ADMIN"]
                },
                views: {
                    'content_section@hepcticket': {
                        templateUrl: 'app/hepcTickets/ticketsFeedBackView/viewTicketFeedBackDetail.html',
                        controller: 'TicketFeedbackDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Tickets', function($stateParams, Tickets) {
                        return Tickets.query({columnKey : 'ticketNumber', columnValue:$stateParams.id}).$promise;
                    }]
                }
            });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FeedBackViewController', FeedBackViewController);

    FeedBackViewController.$inject = ['$state','$window' , '$filter','TicketsFeedback'];

    function FeedBackViewController ($state, $window, $filter, TicketsFeedback) {
        var vm = this;
        vm.searchBy='All';
        vm.feedbacks=[];
        vm.selectedFeedback=selectedFeedback;
        vm.changeUserBy=changeUserBy;

        vm.download = download;

        loadAll();

        function loadAll() {
            TicketsFeedback.query(function (result) {
                vm.feedbacks=result;
            })
        }

        function selectedFeedback(result) {
            vm.feed=result;
        }

        function changeUserBy(searchBy) {
            if(searchBy!='All'){
                TicketsFeedback.query({rating: searchBy},function (result) {
                    vm.feedbacks=result;
                })
            }else{
                loadAll();
            }
        }

        function convertJsonsToArrays(args){
            var dataArray = [];
            var header = ["Ticket Number    ",
                "Category   ",
                "ClosedBy  ",
                "Closing Date         ",
                "Investor Name  ",
                "Rating  "
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                var closingDate=$filter('date')(row.closingDate, 'dd-MMM-yyyy h:mm a');
                rowAr.push(row.ticketNumber);
                rowAr.push(row.category);
                rowAr.push(row.closedBy);
                rowAr.push(closingDate);
                rowAr.push(row.investorName);
                rowAr.push(row.rating);
                dataArray.push(rowAr);
            }
            return dataArray;
        }


        function download(args,status) {

            var rows = convertJsonsToArrays(args);
            var lineArray = [];

            for(var i = 0; i < rows.length; i++){
                var line = rows[i].join("\t");
                lineArray.push(line);
            }
            lineArray = lineArray.join("\n");
            var a = document.createElement('a');
            var blob = new Blob([lineArray],{type: 'data:text/plain;charset=utf-8;'});
            var url = URL.createObjectURL(blob);
            $window.location.href = url;


        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('view-member', {
            parent: 'hepcticket',
            url: '/view-member',
            data: {
                authorities: ["ROLE_TICKET_OPERATION_MANAGER","ROLE_ADMIN","ROLE_SUB_ADMIN","ROLE_TICKET_ADMIN"]
            },
            views: {
                'content_section@hepcticket': {
                    templateUrl: 'app/hepcTickets/ticketMember/viewMembers.html',
                    controller: 'ViewMemberController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ViewMemberController', ViewMemberController);

    ViewMemberController.$inject = ['$state', 'Principal', 'TicketMember', 'Department', 'TicketMemberDepartmentAssign'];

    function ViewMemberController($state, Principal, TicketMember, Department, TicketMemberDepartmentAssign) {

        var vm = this;

        vm.ticketMembers = [];
        vm.selectedMember=selectedMember;
        vm.addDeparmentHead=addDeparmentHead;
        vm.selectedTicketMember={};
        loadAll();

        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
            TicketMember.query(function(result) {
                vm.ticketMembers = result;
                vm.searchQuery = null;
            });
            Department.query(function (result) {
                vm.deparment=result;
            });
        }

        function selectedMember(ticketMember) {
            vm.selectedTicketMember = ticketMember;
            if(vm.selectedTicketMember.departmentList != null) {
                if (Object.keys(vm.selectedTicketMember.departmentList).length == 0) {
                    vm.selectedTicketMember.departmentList = null;
                }
            }
        }

        function addDeparmentHead() {
            vm.map = {};
            angular.forEach(vm.departmentDetail, function (item) {
                vm.map[item.id] = item.departmentname;
            }) ;
            vm.selectedTicketMember.departmentList = vm.map;
            TicketMemberDepartmentAssign.update(vm.selectedTicketMember, onUpdateSuccess, onUpdateError);
        }

        function onUpdateSuccess(result) {
            $("#AssigndepartmentModel").modal("hide");
            alert("Successfully Updated");
            location.reload();
        }

        function onUpdateError(result) {
            $("#AssigndepartmentModel").modal("hide");
            if(result.data.departmentName!=null && result.statusText=="Bad Request"){
                alert("HOD of "+result.data.departmentName+ " is already assigned!");
            }else{
                alert("Error while assigning department! Please try again after sometime.");
            }
            location.reload();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TicketMemberDepartmentAssign', TicketMemberDepartmentAssign);

    TicketMemberDepartmentAssign.$inject = ['$resource'];

    function TicketMemberDepartmentAssign ($resource) {
        var resourceUrl =  'api/ticket-members/assignDepartment/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ticket-generate', {
            parent: 'hepcticket',
            url: '/ticket-generate',
            data: {
                authorities: ["ROLE_L1_SUPPORT","ROLE_TICKET_OPERATION_MANAGER","ROLE_TICKET_HOBPAS"]
            },
            views: {
                'content_section@hepcticket': {
                    templateUrl: 'app/hepcTickets/ticket-generate/ticket-generate.html',
                    controller: 'TicketGenerateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketGenerateController', TicketGenerateController);

    TicketGenerateController.$inject = ['$scope', '$state', 'Tickets', 'TicketDepartments', 'DepartmentService', 'TicketsCustomer', 'District', 'UploadTicketAttachment', 'TicketMember'];

    function TicketGenerateController ($scope, $state, Tickets, TicketDepartments, DepartmentService, TicketsCustomer, District, UploadTicketAttachment, TicketMember) {
        var vm = this;
        vm.customerMobile = null;
        vm.isCustomerMobileSearch = false;
        vm.isSearchedCustomerAdded = false;
        vm.isShowSearchByMobile= false;
        vm.newCustomer=false;
        vm.isSearchResult=false;
        vm.registered={};
        vm.tickets = {};
        vm.ticketsCustomer = {};
        vm.ticketsCustomer.email = null;
        vm.deparment=[];
        vm.districts=[];
        vm.services=[];
        vm.serviceDetails={};
        vm.save = save;
        vm.clear = clear;
        vm.search = search;
        vm.searchByMobile = searchByMobile;
        vm.addCustomerSearchByMobile=addCustomerSearchByMobile;
        vm.departmnetService = departmnetService;
        vm.addCustomer = addCustomer;
        vm.uploadFile = uploadFile;
        vm.changeUserBy=changeUserBy;
        vm.otherField = null;
        vm.HOBPASRole = [];
        vm.incentivesRole = [];
        $scope.file = {};

        loadAll();

        function loadAll() {
            TicketDepartments.query({hepcTicketDepartment:"HODNODAL"},function (result) {
                vm.deparment=result;
            });

            District.query(function(result) {
                var other = {
                    districtname: "Other",
                    id: "2c4709e1-0b26-4348-b6fb-e2ab85449cf9",
                    powercompany: "DHBVN",
                    stateID: "c8305487-aba6-461c-898c-3efe85a9d5e5",
                    statename: "Other"
                };
                vm.districts = result;
                vm.districts.push(other);
            });
            TicketMember.query({role: "ROLE_L2_IT_MANAGER"}, function (result) {
                vm.ticketsMember = result;
            });
            TicketMember.query({role: "ROLE_TICKET_HOBPAS"}, function (result) {
                vm.HOBPASRole = result;
            })
            TicketMember.query({role: "ROLE_L2_INCENTIVES"}, function (result) {
                vm.incentivesRole = result;
            })
        }

        function search(key , value) {
            TicketsCustomer.get({columnKey: key, columnValue: value},function (result) {
                vm.isSearchResult=true;
                vm.registered=result;
            }, function () {
                vm.isSearchResult=false;
                vm.registered={};
            });
        }

        function searchByMobile(key , value) {
            TicketsCustomer.get({columnKey: key, columnValue: value},function (result) {
                vm.isCustomerMobileSearch = true;
                result.mobileNumber = parseInt(result.mobileNumber);
                vm.oldTicketCustomer=result;
            }, function (result) {
                vm.isCustomerMobileSearch = false;
                vm.ticketsCustomer= {};
                vm.customerMobile = null;
            });
        }

        function changeUserBy() {
            vm.isSearchResult=false;
            vm.searchValue=null;
            vm.registered={};
        }

        function departmnetService(deparment) {
            DepartmentService.query({id:'1', departmentid: deparment.id}, function (result) {
                vm.services=result;
            });
        }

        function addCustomerSearchByMobile() {
            vm.isSearchedCustomerAdded = true;
            $("#addCustomer").modal("hide");
        }

        function addCustomer(customer) {
            var infoEmail = null;
            var infoMobile = null;

            if(customer.email && customer.email.includes("@") && customer.mobileNumber ) {
                infoEmail=customer.email;
                infoMobile=customer.mobileNumber;
                TicketsCustomer.get({columnData: infoEmail}, function (result) {
                    TicketsCustomer.get({columnData: infoMobile}, function (result) {
                        vm.newCustomer = true;
                        $("#addCustomer").modal("hide");
                    });
                });
            } else if (customer.email && customer.email.includes("@") && !customer.mobileNumber) {
                infoEmail = customer.email;
                TicketsCustomer.get({columnData: infoEmail}, function (result) {
                    vm.newCustomer = true;
                    $("#addCustomer").modal("hide");
                });
            } else if(!customer.email && customer.mobileNumber) {
                infoMobile = customer.mobileNumber;
                TicketsCustomer.get({columnData: infoMobile}, function (result) {
                    vm.newCustomer = true;
                    $("#addCustomer").modal("hide");
                });
            } else if(customer.email && !customer.email.includes("@") && customer.mobileNumber) {
                infoMobile = customer.mobileNumber;
                TicketsCustomer.get({columnData: infoMobile}, function (result) {
                    vm.newCustomer = true;
                    $("#addCustomer").modal("hide");
                });
            }
        }

        function uploadFile () {
            if(angular.isDefined(vm.file)){
                var file =  vm.file;
                UploadTicketAttachment.saveFile(file,onUploadSuccess,onUploadError);
            }else {
                save();
            }
        }

        function onUploadSuccess (result) {
            vm.tickets.attachment = result.filename;
            if(vm.tickets.attachment!=null){
                save();
            }
        }

        function onUploadError () {
            alert("Error while uploading file");
            $state.reload();
        }

        function save () {
            vm.isSaving = true;
            if (vm.tickets.incidentCategory==='Process Related' || vm.tickets.incidentCategory==='Grievances' || vm.tickets.incidentCategory==='HOBPAS') {
                vm.tickets.assignedDepartmentId=vm.departmentDetail.id;
                vm.tickets.assignedDepartmentName=vm.departmentDetail.departmentName;
                if(vm.serviceDetails!==null){
                    vm.tickets.serviceid=vm.serviceDetails.id;
                }
            }

            if (vm.tickets.incidentCategory==='Technical') {
                vm.tickets.nextLevelMemberId=vm.ticketsMemberDetail.id;
                vm.tickets.nextLevelMember=vm.ticketsMemberDetail.login;
                vm.tickets.nextLevelMemberName=vm.ticketsMemberDetail.firstName+" "+vm.ticketsMemberDetail.lastName;
            }

            if (vm.tickets.incidentCategory==='HOBPAS') {
                vm.tickets.nextLevelMemberId=vm.ticketsMemberDetail.id;
                vm.tickets.nextLevelMember=vm.ticketsMemberDetail.login;
                vm.tickets.nextLevelMemberName=vm.ticketsMemberDetail.firstName+" "+vm.ticketsMemberDetail.lastName;
            }
            if (vm.tickets.incidentCategory==='Incentives') {
                vm.tickets.nextLevelMemberId=vm.ticketsMemberDetail.id;
                vm.tickets.nextLevelMember=vm.ticketsMemberDetail.login;
                vm.tickets.nextLevelMemberName=vm.ticketsMemberDetail.firstName+" "+vm.ticketsMemberDetail.lastName;
            }

                if(vm.isSearchResult){
                if(vm.registered.cafpin===null){
                    vm.tickets.cafpin = vm.registered.id;
                } else {
                    vm.tickets.cafpin = vm.registered.cafpin;
                }
                if(vm.registered.email!=null){
                    vm.tickets.investorDetail=vm.registered.email;
                }
                else{
                    vm.tickets.investorDetail=vm.registered.mobileNumber;
                }
                vm.tickets.investorType=vm.registered.customerType;
            }
            if(vm.isSearchedCustomerAdded){
                vm.tickets.cafpin = vm.oldTicketCustomer.id;

                if(vm.oldTicketCustomer.email!=null){
                    vm.tickets.investorDetail=vm.oldTicketCustomer.email;
                }
                else{
                    vm.tickets.investorDetail=vm.oldTicketCustomer.mobileNumber;
                }
                vm.tickets.investorType=vm.oldTicketCustomer.customerType;
            }
            if(vm.newCustomer){
                if(vm.ticketsCustomer.email!=null){
                    if(!vm.ticketsCustomer.email.includes("@")){
                        vm.ticketsCustomer.email = null;
                    }
                }
                if(vm.ticketsCustomer.district === "Other"){
                    vm.ticketsCustomer.district=vm.otherField;
                }
                TicketsCustomer.save(vm.ticketsCustomer, onCustomerSave, onCustomerError);
            }else{
                Tickets.save(vm.tickets, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            vm.isSaving = false;
            alert("Ticket added successfully with Ticket Number:"+result.ticketNumber);
            $state.reload();
        }

        function onSaveError () {
            vm.isSaving = false;
            alert("Error while generating ticket");
            $state.reload();
        }

        function onCustomerSave (result) {
            if(result.email!=null){
                vm.tickets.investorDetail=result.email;
            } else {
                vm.tickets.investorDetail=result.mobileNumber;
            }
            vm.tickets.investorType = "HepcTicketCustomer";
            vm.tickets.cafpin=result.id;
            Tickets.save(vm.tickets, onSaveSuccess, onSaveError);
        }

        function onCustomerError () {
            alert("Error while adding customer");
            $state.reload();
        }

        function clear(){
            vm.customerMobile = null;
            vm.isCustomerMobileSearch = false;
            vm.isSearchedCustomerAdded = false;
            vm.searchBy=null;
            vm.searchValue=null;
            vm.otherField=null;
            vm.newCustomer=false;
            vm.isShowSearchByMobile= false;
            vm.isSearchResult=false;
            vm.ticketsCustomer = {};
            vm.ticketsCustomer.email = null;
            vm.registered={};
        }
    }
})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sentTickets', {
            parent: 'hepcticket',
            url: '/sentTickets',
            data: {
                authorities: ["ROLE_L1_SUPPORT", "ROLE_L2_IT_MANAGER", "ROLE_L2_DEPARTMENT", "ROLE_L2_DEPARTMENT_HEAD", "ROLE_L2_INCENTIVES", "ROLE_TICKET_NODAL_OFFICER", "ROLE_TICKET_OPERATION_MANAGER", "ROLE_NODAL_OFFICER", "ROLE_ADMIN", "ROLE_SUB_ADMIN"]
            },
            views: {
                'content_section@hepcticket': {
                    templateUrl: 'app/hepcTickets/sendTickets/sentTickets.html',
                    controller: 'SentTicketsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SentTicketsController', SentTicketsController);

    SentTicketsController.$inject = ['Principal','Tickets','$filter', 'TicketsLogs', 'downloadticketattachment'];

    function SentTicketsController(Principal,Tickets,$filter ,TicketsLogs, downloadticketattachment) {
        var vm = this;
        vm.sentTicketsLogs = [];
        vm.getLogs=getLogs;
        vm.downloadAttachment=downloadAttachment;
        loadAll();

        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;
                TicketsLogs.query({assignedLogin: vm.account.login},function(result){
                   vm.sentTicketsLogs = result;
                   vm.searchQuery = null;
                });
            });
        }

        function getLogs(ticketDetails) {
            TicketsLogs.query({ticketNumber: ticketDetails.ticketNumber},function (result) {
                vm.ticketsLogs=result;
            })
        }

        function downloadAttachment(attachment) {
            downloadticketattachment.download(attachment)
                .then(function(success) {

                }, function(error) {
                    alert('error : ' + error);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticketsearch', {
            parent: 'hepcticket',
            url: '/ticketsearch',
            data: {
                authorities: ["ROLE_L1_SUPPORT","ROLE_L2_IT_MANAGER","ROLE_L2_DEPARTMENT","ROLE_L2_DEPARTMENT_HEAD","ROLE_L2_INCENTIVES","ROLE_TICKET_NODAL_OFFICER","ROLE_TICKET_OPERATION_MANAGER","ROLE_NODAL_OFFICER","ROLE_ADMIN","ROLE_SUB_ADMIN","ROLE_TICKET_ADMIN"]
            },
            views: {
                'content_section@hepcticket': {
                    templateUrl: 'app/hepcTickets/searchTicket/searchTicket.html',
                    controller: 'SearchTicketController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SearchTicketController', SearchTicketController);

    SearchTicketController.$inject = ['Tickets', 'TicketsLogs', 'downloadticketattachment'];

    function SearchTicketController(Tickets, TicketsLogs, downloadticketattachment) {
        var vm = this;
        vm.search=false;
        vm.searchTicket=searchTicket;
        vm.getLogs=getLogs;
        vm.downloadAttachment=downloadAttachment;

        function searchTicket(columnKeys,columnValues) {
            vm.search=true;
            Tickets.query({columnKey: columnKeys, columnValue: columnValues }, function (result) {
               vm.tickets=result;
            });
        }

        function getLogs(tickets) {
            TicketsLogs.query({ticketNumber: tickets.ticketNumber},function (result) {
                vm.ticketsLogs=result;
            })
        }

        function downloadAttachment(attachment) {
            downloadticketattachment.download(attachment)
                .then(function(success) {}, function(error) {
                    alert('error : ' + error);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcTicketSidebarController', HepcTicketSidebarController);

    HepcTicketSidebarController.$inject = [];

    function HepcTicketSidebarController() {
        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hepcticket', {
            parent: 'app',
            url: '/hepcticket',
            data: {
                authorities: ["ROLE_L1_SUPPORT","ROLE_L2_IT_MANAGER","ROLE_L2_DEPARTMENT","ROLE_L2_DEPARTMENT_HEAD","ROLE_L2_INCENTIVES","ROLE_TICKET_NODAL_OFFICER","ROLE_TICKET_OPERATION_MANAGER","ROLE_NODAL_OFFICER","ROLE_ADMIN","ROLE_SUB_ADMIN","ROLE_TICKET_ADMIN","ROLE_TICKET_HOBPAS"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/hepcTickets/hepcTickets.html',
                    controller: 'HepcTicketsController',
                    controllerAs: 'vm'
                },
                'content_section@hepcticket': {
                    templateUrl: 'app/hepcTickets/viewTicket/viewMyOpenTicket.html',
                    controller: 'TicketViewController',
                    controllerAs: 'vm'
                },
                'tktSidebar@hepcticket': {
                    templateUrl: 'app/hepcTickets/hepcTktSidebar/hepcTktSidebar.html',
                    controller: 'HepcTicketSidebarController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcTicketsController', HepcTicketsController);

    HepcTicketsController.$inject = ['Tickets', 'Principal'];

    function HepcTicketsController(Tickets, Principal) {

        var vm = this;
        loadAll();

        function loadAll() {
            vm.authenticated = Principal.isAuthenticated();
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TicketsMean', TicketsMean);

    TicketsMean.$inject = ['$resource'];

    function TicketsMean ($resource) {
        var resourceUrl =  '/api/findMean';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcOpenDashboardController', HepcOpenDashboardController);

    HepcOpenDashboardController.$inject = ['$scope', 'Tickets', '$window', 'TicketsPagination', '$filter', 'TicketsLogs', 'downloadticketattachment', 'TicketsMean'];

    function HepcOpenDashboardController($scope, Tickets, $window, TicketsPagination, $filter, TicketsLogs, downloadticketattachment, TicketsMean) {
        var vm = this;
        vm.getLogs=getLogs;
        vm.loadAll=loadAll;
        vm.filterAll=filterAll;
        vm.tickets = [];
        vm.tickets1 = [];
        vm.filterBy="All";
        vm.page = 0;
        vm.downloadAttachment=downloadAttachment;
        vm.loadAllTickets = loadAllTickets;
        vm.download_all_table_data = download_all_table_data;
        loadAllTickets(vm.page);
        loadAll();
        $scope.CurrentDate = new Date();


        function loadAll() {
            TicketsMean.get(function(result) {
                vm.tickets1 = result;
                if(vm.tickets1.median === "0"){
                    vm.tickets1.median = 1;
                }
            });
        }



        function convertJsonsToArrays(args){
            var dataArray = [];
            var header = [ "Ticket Number",
                "Subject",
                "Category",
                "Department",
                "Assigned Member",
                "Priority",
                "Creation By",
                "Creation On",
                "Closing Date",
                "Ticket Status"
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                rowAr.push(row.ticketNumber);
                rowAr.push(row.subject);
                rowAr.push(row.incidentCategory);
                rowAr.push(row.assignedDepartmentName);
                rowAr.push(row.assignedMemberUserName);
                rowAr.push(row.priority);
                rowAr.push(row.createdByName);
                rowAr.push(row.creationDate);
                rowAr.push(row.resolveDate);
                rowAr.push(row.status);
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function download_all_table_data(args) {
                var rowsCleared= convertJsonsToArrays(args);
                var lineArray = [];
                var lineArrayCleared = [];


                for(var i = 0; i < rowsCleared.length; i++){
                    var lineCleared = rowsCleared[i].join("\t");
                    lineArrayCleared.push(lineCleared);
                }
                lineArrayCleared = lineArrayCleared.join("\n");


            var title = [];
            var rows = [];
            title = title.join(",");
            rows = rows.join("\n");
            var csv = title + rows;
            var blob = new Blob([lineArrayCleared],{type: 'data:text/csv;charset=utf-8,'+ encodeURIComponent(csv)});
            var url = URL.createObjectURL(blob);
            $window.location.href = url;

        }

        function loadAllTickets(page) {
            if(page >= 0) {
                vm.page = page;
                TicketsPagination.get({page: page, size: 200}, function(result) {
                    vm.tickets = result.content;
                    vm.ticketList=vm.tickets;
                    vm.openTickets = $filter('filter')(vm.tickets, { status: 'Open'});
                    vm.closedTickets = $filter('filter')(vm.tickets, { status: 'Closed'});
                    vm.timeoutLevel = $filter('filter')(vm.tickets, { level: 'LEVEL_3'});
                    vm.timeoutTickets = $filter('filter')(vm.timeoutLevel, { incidentCategory: '!Grievances'});
                    vm.technical = $filter('filter')(vm.tickets, { incidentCategory: 'Technical'});
                    vm.processRelated = $filter('filter')(vm.tickets, { incidentCategory: 'Process Related'});
                    vm.grievances = $filter('filter')(vm.tickets, { incidentCategory: 'Grievances'});
                    vm.suggestion = $filter('filter')(vm.tickets, { incidentCategory: 'Suggestion/Feedback'});
                    vm.generalEnquiry = $filter('filter')(vm.tickets, { incidentCategory: 'General Enquiry'});
                    vm.incentives = $filter('filter')(vm.tickets, { incidentCategory: 'Incentives'});
                    vm.hobPas = $filter('filter')(vm.tickets, { incidentCategory: 'HOBPAS'});
                });
            }
        }

        function filterAll(filterTickets) {
            if (filterTickets==="All"){
                vm.ticketList = vm.tickets;
                vm.filterBy="All";
            } else if(filterTickets==="Open"){
                vm.ticketList = vm.openTickets;
            } else if(filterTickets==="Closed"){
                vm.ticketList = vm.closedTickets;
            } else if(filterTickets==="Timeout"){
                vm.ticketList = vm.timeoutTickets;
            } else if(filterTickets==="Technical"){
                vm.ticketList = vm.technical;
            } else if(filterTickets==="Process Related"){
                vm.ticketList = vm.processRelated;
            } else if(filterTickets==="Grievances"){
                vm.ticketList = vm.grievances;
            } else if(filterTickets==="Suggestion/Feedback"){
                vm.ticketList = vm.suggestion;
            } else if(filterTickets==="General Enquiry"){
                vm.ticketList = vm.generalEnquiry;
            } else if(filterTickets==="Incentives"){
                vm.ticketList = vm.incentives
            }
            else if(filterTickets==="HOBPAS"){
                vm.ticketList = vm.hobPas;
            }
        }

        function getLogs(ticketDetails) {
            TicketsLogs.query({ticketNumber: ticketDetails.ticketNumber},function (result) {
                vm.ticketsLogs=result;
            })
        }

        function downloadAttachment(attachment) {
            downloadticketattachment.download(attachment)
                .then(function(success) {}, function(error) {
                    alert('error : ' + error);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hepcDashboard', {
            parent: 'hepcticket',
            url: '/HEPC-dashboard',
            data: {
                authorities: ["ROLE_ADMIN","ROLE_SUB_ADMIN","ROLE_TICKET_ADMIN"]
            },
            views: {
                'content_section@hepcticket': {
                    templateUrl: 'app/hepcTickets/hepcDashboard/hepcDashBoard.html',
                    controller: 'HepcDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
            .state('hepcdashboard', {
                parent: 'hepcticket',
                url: '/HEPCdashboard',
                data: {
                    authorities: []
                },
                views: {
                    'content_section@hepcticket': {
                        templateUrl: 'app/hepcTickets/hepcDashboard/hepcOpenDashBoard.html',
                        controller: 'HepcOpenDashboardController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TicketsPagination', Projectlist);

    Projectlist.$inject = ['$resource'];

    function Projectlist ($resource) {
        var resourceUrl =  '/api/findByAllTickets';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcDashboardController', HepcDashboardController);

    HepcDashboardController.$inject = ['$scope', 'Tickets', '$window', 'TicketsPagination', '$filter', 'TicketsLogs', 'downloadticketattachment', 'TicketsMean'];

    function HepcDashboardController($scope, Tickets, $window, TicketsPagination, $filter, TicketsLogs, downloadticketattachment, TicketsMean) {
        var vm = this;
        vm.getLogs=getLogs;
        vm.loadAll=loadAll;
        vm.filterAll=filterAll;
        vm.tickets = [];
        vm.tickets1 = [];
        vm.filterBy="All";
        vm.page = 0;
        vm.downloadAttachment=downloadAttachment;
        vm.loadAllTickets = loadAllTickets;
        vm.download_all_table_data = download_all_table_data;
        loadAllTickets(vm.page);
        loadAll();
        $scope.CurrentDate = new Date();


        // function loadAll() {
        //     Tickets.query(function(result) {
        //         vm.tickets1 = result;
        //         console.log(result);
        //         vm.ticketList1=vm.tickets1;
        //         vm.openTickets1 = $filter('filter')(vm.tickets1, { status: 'Open'});
        //         vm.closedTickets1 = $filter('filter')(vm.tickets1, { status: 'Closed'});
        //         vm.timeoutLevel = $filter('filter')(vm.tickets, { level: 'LEVEL_3'});
        //         vm.timeoutTickets = $filter('filter')(vm.timeoutLevel, { incidentCategory: '!Grievances'});
        //         vm.technical = $filter('filter')(vm.tickets, { incidentCategory: 'Technical'});
        //         vm.processRelated = $filter('filter')(vm.tickets, { incidentCategory: 'Process Related'});
        //         vm.grievances = $filter('filter')(vm.tickets, { incidentCategory: 'Grievances'});
        //         vm.suggestion = $filter('filter')(vm.tickets, { incidentCategory: 'Suggestion/Feedback'});
        //         vm.generalEnquiry = $filter('filter')(vm.tickets, { incidentCategory: 'General Enquiry'});
        //         vm.incentives = $filter('filter')(vm.tickets, { incidentCategory: 'Incentives'});
        //         vm.hobPas = $filter('filter')(vm.tickets, { incidentCategory: 'HOBPAS'});
        //     });
        // }

        function loadAll() {
            TicketsMean.get(function(result) {
                vm.tickets1 = result;
            });
        }




        function convertJsonsToArrays(args){
            var dataArray = [];
            var header = [ "Ticket Number",
                "Subject",
                "Category",
                "Department",
                "Assigned Member",
                "Priority",
                "Creation By",
                "Creation On",
                "Closing Date",
                "Ticket Status"
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                rowAr.push(row.ticketNumber);
                rowAr.push(row.subject);
                rowAr.push(row.incidentCategory);
                rowAr.push(row.assignedDepartmentName);
                rowAr.push(row.assignedMemberUserName);
                rowAr.push(row.priority);
                rowAr.push(row.createdByName);
                rowAr.push(row.creationDate);
                rowAr.push(row.resolveDate);
                rowAr.push(row.status);
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function download_all_table_data(args) {
                var rowsCleared= convertJsonsToArrays(args);
                var lineArray = [];
                var lineArrayCleared = [];


                for(var i = 0; i < rowsCleared.length; i++){
                    var lineCleared = rowsCleared[i].join("\t");
                    lineArrayCleared.push(lineCleared);
                }
                lineArrayCleared = lineArrayCleared.join("\n");


            var title = [];
            var rows = [];
            title = title.join(",");
            rows = rows.join("\n");
            var csv = title + rows;
            var blob = new Blob([lineArrayCleared],{type: 'data:text/csv;charset=utf-8,'+ encodeURIComponent(csv)});
            var url = URL.createObjectURL(blob);
            $window.location.href = url;

        }

        function loadAllTickets(page) {
            if(page >= 0) {
                vm.page = page;
                TicketsPagination.get({page: page, size: 200}, function(result) {
                    vm.tickets = result.content;
                    vm.ticketList=vm.tickets;
                    vm.openTickets = $filter('filter')(vm.tickets, { status: 'Open'});
                    vm.closedTickets = $filter('filter')(vm.tickets, { status: 'Closed'});
                    vm.timeoutLevel = $filter('filter')(vm.tickets, { level: 'LEVEL_3'});
                    vm.timeoutTickets = $filter('filter')(vm.timeoutLevel, { incidentCategory: '!Grievances'});
                    vm.technical = $filter('filter')(vm.tickets, { incidentCategory: 'Technical'});
                    vm.processRelated = $filter('filter')(vm.tickets, { incidentCategory: 'Process Related'});
                    vm.grievances = $filter('filter')(vm.tickets, { incidentCategory: 'Grievances'});
                    vm.suggestion = $filter('filter')(vm.tickets, { incidentCategory: 'Suggestion/Feedback'});
                    vm.generalEnquiry = $filter('filter')(vm.tickets, { incidentCategory: 'General Enquiry'});
                    vm.incentives = $filter('filter')(vm.tickets, { incidentCategory: 'Incentives'});
                    vm.hobPas = $filter('filter')(vm.tickets, { incidentCategory: 'HOBPAS'});
                });
            }
        }

        function filterAll(filterTickets) {
            if (filterTickets==="All"){
                vm.ticketList = vm.tickets;
                vm.filterBy="All";
            } else if(filterTickets==="Open"){
                vm.ticketList = vm.openTickets;
            } else if(filterTickets==="Closed"){
                vm.ticketList = vm.closedTickets;
            } else if(filterTickets==="Timeout"){
                vm.ticketList = vm.timeoutTickets;
            } else if(filterTickets==="Technical"){
                vm.ticketList = vm.technical;
            } else if(filterTickets==="Process Related"){
                vm.ticketList = vm.processRelated;
            } else if(filterTickets==="Grievances"){
                vm.ticketList = vm.grievances;
            } else if(filterTickets==="Suggestion/Feedback"){
                vm.ticketList = vm.suggestion;
            } else if(filterTickets==="General Enquiry"){
                vm.ticketList = vm.generalEnquiry;
            } else if(filterTickets==="Incentives"){
                vm.ticketList = vm.incentives
            }
            else if(filterTickets==="HOBPAS"){
                vm.ticketList = vm.hobPas;
            }
        }

        function getLogs(ticketDetails) {
            TicketsLogs.query({ticketNumber: ticketDetails.ticketNumber},function (result) {
                vm.ticketsLogs=result;
            })
        }

        function downloadAttachment(attachment) {
            downloadticketattachment.download(attachment)
                .then(function(success) {}, function(error) {
                    alert('error : ' + error);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TicketsForFeedBack', TicketsForFeedBack);

    TicketsForFeedBack.$inject = ['$resource', 'DateUtils'];

    function TicketsForFeedBack ($resource, DateUtils) {
        var resourceUrl =  'api/ticketsforfeedback/:ticketNumber';

        return $resource(resourceUrl, {}, {
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.resolveDate = DateUtils.convertDateTimeFromServer(data.resolveDate);
                        data.assignDate = DateUtils.convertDateTimeFromServer(data.assignDate);
                        data.expectedResoluation = DateUtils.convertDateTimeFromServer(data.expectedResoluation);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('ratingTicket', {
            parent: 'app',
            url: '/ticketRating?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/hepcTickets/feedBack/ticketFeedBack.html',
                    controller: 'InvestorTicketFeedBackController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InvestorTicketFeedBackController', InvestorTicketFeedBackController);

    InvestorTicketFeedBackController.$inject = ['$state', '$stateParams', 'TicketsForFeedBack', 'TicketsFeedback'];

    function InvestorTicketFeedBackController ($state, $stateParams, TicketsForFeedBack, TicketsFeedback) {
        var vm = this;
        vm.rating="Excellent";
        vm.ticketDetail={};
        vm.ticketFeedback={};
        vm.isSaving = false;
        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.saveFeedback=saveFeedback;
        loadAll();

        function loadAll() {
            TicketsForFeedBack.get({ticketNumber: $stateParams.key}, function (result) {
                vm.ticketDetail = result;
            })
        }

        function saveFeedback() {
            vm.isSaving = true;
            vm.ticketFeedback.id = vm.ticketDetail.id;
            vm.ticketFeedback.ticketNumber = vm.ticketDetail.ticketNumber;
            vm.ticketFeedback.category = vm.ticketDetail.incidentCategory;
            vm.ticketFeedback.investorDetail = vm.ticketDetail.investorDetail;
            vm.ticketFeedback.rating = vm.rating;
            vm.ticketFeedback.ratingRemark = vm.ratingRemark;
            if(vm.ticketDetail.assignedDepartmentId!=null){
                vm.ticketFeedback.departmentName = vm.ticketDetail.assignedDepartmentName;
            }
            if(vm.ticketDetail.assignedMemberUserName == null) {
                vm.ticketFeedback.closedBy = vm.ticketDetail.assignedMemberName;
            } else {
                vm.ticketFeedback.closedBy = vm.ticketDetail.assignedMemberUserName;
            }
            vm.ticketFeedback.closingDate = vm.ticketDetail.resolveDate;
            TicketsFeedback.update(vm.ticketFeedback, onSaveSuccess, onError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            alert("Thank you for your feedback!");
            $state.go('home');
        }

        function onError(result) {
            vm.isSaving = false;
            if(result) {
                alert(result.data.ratingRemark);
            } else {
                alert("Please Try after some time!");
            }
            $state.go('home');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('hepc-startupharyana', {
            parent: 'app',
            url: '/hepc-startupharyana/{schemeName}/{email}/{name}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/hepc-startupharyana/hepc-startupharyana.html',
                    controller: 'HepcStartupHaryanaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: [ function() {
                    return true;
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });        ;

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcStartupHaryanaController', HepcStartupHaryanaController);

    HepcStartupHaryanaController.$inject = ['$scope', '$rootScope', 'LoginService', '$state', '$stateParams', '$timeout'];

    function HepcStartupHaryanaController ($scope, $rootScope, LoginService, $state, $stateParams, $timeout) {
        var vm = this;

        vm.account = null;
        vm.login = LoginService.open;


          vm.schemeName= $stateParams.schemeName;
          vm.email=$stateParams.email;
          vm.name=$stateParams.name;
         //  vm.startupUrl = "https://startupharyana.gov.in/invest-haryana/apply-scheme";
         // var searchObject = $location.search();
         // alert( searchObject.schemeName );
          // Function to add hidden fields to the form
          function addHiddenField(form, name, value) {
              var input = document.createElement('input');
              input.type = 'hidden';
              input.name = name;
              input.value = value;
              form.appendChild(input);
          }

          vm.urlStartup = "https://startupharyana.gov.in/invest-haryana/sso-login" + "?schemeName=" + vm.schemeName;

        //  alert(vm.schemeName);
          $timeout(function () {
              var submitButton = document.querySelector('#myForm input[type="submit"]');
              var form = document.querySelector('#myForm');

              if (form && submitButton) {
                  console.log("Adding hidden fields and triggering click on submit button...");


                  // Add the parameters as hidden fields
                  addHiddenField(form, "schemeName", vm.schemeName);
                  addHiddenField(form, 'email', vm.email);
                  addHiddenField(form, 'name', vm.name);
                  // Simulate a click on the submit button
                  submitButton.click();
              } else {
                  alert("Form or Submit button not found!");
              }
          }, 100);


        vm.login = function login() {
            LoginService.open();
        };

        vm.reload = function reload() {
          window.location.reload();
        };

        vm.setUrl = function (url) {
            vm.url = $sce.trustAsResourceUrl(url);
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ViewLogController', ViewLogController);

    ViewLogController.$inject = ['$scope', '$state', '$uibModalInstance', '$stateParams', 'Principal', 'LoginService', 'Grievance', 'grievance', 'GrievanceLog', 'downloadService'];

    function ViewLogController ($scope, $state, $uibModalInstance, $stateParams, Principal, LoginService, Grievance, grievance, GrievanceLog, downloadService) {
        var vm = this;
        vm.grievance = grievance;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.downloadFile = downloadFile;
        vm.grievanceId= $stateParams.grievanceId;
        vm.pdfconverter= pdfconverter;

        vm.clear = clear;

        GrievanceLog.query({id:"1",grievanceId: $stateParams.grievanceId}, function(result) {
                    vm.grievancelog = result;
                    vm.searchQuery = null;
            });

        function clear ()
        {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        function downloadFile(attachment)
        {
         downloadService.download(attachment + ".pdf")
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }

        function pdfconverter () {
            var element = document.getElementById('pdf_data');
            html2pdf(element,{
                margin:  0.5,
                html2canvas: { dpi:192, letterRendering: true },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            });
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('ViewGrievanceFormFilledController', ViewGrievanceFormFilledController);

    ViewGrievanceFormFilledController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'grievance','downloadserviceformattachment', 'viewRecruitmentFile'];
    function ViewGrievanceFormFilledController ($timeout, $scope, $stateParams, $uibModalInstance, grievance, downloadserviceformattachment, viewRecruitmentFile) {
        var vm = this;
        vm.clear = clear;
        vm.grievancedata = grievance;
        vm.downloadFile=downloadFile;
        vm.pdfconverter= pdfconverter;


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function pdfconverter () {
            var element = document.getElementById('pdf_data');
            html2pdf(element,{
                margin: 4
            });
        }


        function clear ()
        {
            $uibModalInstance.dismiss('cancel');
        }
        function downloadFile(id)
        {
            viewRecruitmentFile.view(id)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }

        // loadServiceFormFields();
        // function loadServiceFormFields() {
        //     vm.serviceFormFieldData= serviceFormFieldDataCollection.query({serviceid:vm.projectService.serviceid, projectid:vm.projectService.projectid});
        //     vm.serviceformattachments=ServiceFormAttachments.query({id:"1",serviceid:vm.projectService.serviceid, projectid:vm.projectService.projectid});
        //     vm.project = Project.get({id:vm.projectService.projectid});
        // }

    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('UserListToAssignGrievance', UserListToAssignGrievance);

    UserListToAssignGrievance.$inject = ['$resource'];

    function UserListToAssignGrievance ($resource) {
        var service = $resource('api/userlisttoassigngrievance/:role', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });
        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ResolveboxController', ResolveboxController);

    ResolveboxController.$inject = ['$scope', '$state','$uibModalInstance', 'Principal', 'LoginService', 'Grievance', 'grievance'];

    function ResolveboxController ($scope, $state, $uibModalInstance, Principal, LoginService, Grievance, grievance) {
        var vm = this;

        vm.grievance = grievance;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        vm.clear = clear;
        vm.saveResolveData = saveResolveData;


        function saveResolveData()
        {
            vm.grievance.status="Resolved";
            vm.grievance.isResolved=true;
            Grievance.update(vm.grievance,onSaveSuccess);

        }
        function onSaveSuccess(result)
        {
            $uibModalInstance.close(result);
        }
        function clear ()
        {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievancelistofficerController', GrievancelistofficerController);

    GrievancelistofficerController.$inject = ['$scope', '$state', 'Principal', 'LoginService', 'Grievancelist', 'GrievanceLog', 'Grievance'];

    function GrievancelistofficerController ($scope, $state, Principal, LoginService, Grievancelist, GrievanceLog, Grievance) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.status='pending';
        vm.grievanceLog={};

        loadAll();

        function loadAll() {
            Grievancelist.query({status:vm.status},function(result) {
                vm.grievance= result;
                vm.searchQuery = null;
                console.log(vm.grievance);

            });
        }

        // vm.grievance=Grievance.query();

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        vm.statusSelected=function () {
            loadAll();
        };

        vm.commentContent= function (data) {
            vm.commentData = data;
        };

        vm.comment = function () {
            vm.grievanceLog.grievanceId= vm.commentData.grievanceId;
            vm.grievanceLog.action= "Comment";
            vm.grievanceLog.actionComment= vm.commentValue;
            console.log(vm.grievanceLog);
            GrievanceLog.save(vm.grievanceLog,onSaveSuccess);
        };

        function onSaveSuccess() {
            vm.grievanceLog={};
            vm.commentValue=null;
        }

        vm.showPersonalDetail= function (id) {
            Grievance.get({id: id},function(result) {
                swal({
                    title: '<u>Applicant Details</u><br/><br/>',
                    animation: true,
                    html:
                    '<b>Name: </b> ' + result.firstNameLastName + '<br/><br/>' +
                    '<b>Phone: </b> ' + result.phone + '<br/><br/>' +
                    '<b>Email: </b> ' + result.email + '<br/><br/>' +
                    '<b>Address: </b> ' + result.address + '<br/><br/>'
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievancelistadminController', GrievancelistadminController);

    GrievancelistadminController.$inject = ['$scope', '$state', 'Principal', 'LoginService', 'Grievancelist', 'GrievanceLog', 'Grievance'];

    function GrievancelistadminController ($scope, $state, Principal, LoginService, Grievancelist, GrievanceLog, Grievance) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.status= 'unassigned';
        vm.grievanceLog={};

        loadAll();

        function loadAll() {
            Grievancelist.query({status:vm.status},function(result) {
                vm.grievance = result;
                vm.searchQuery = null;
            });
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        vm.statusSelected=function () {
            loadAll();
        };

        vm.commentContent= function (data) {
            vm.commentData = data;
        };

        vm.comment = function () {
            vm.grievanceLog.grievanceId= vm.commentData.grievanceId;
            vm.grievanceLog.action= "Comment";
            vm.grievanceLog.actionComment= vm.commentValue;
            console.log(vm.grievanceLog);
            GrievanceLog.save(vm.grievanceLog,onSaveSuccess);
        };

        function onSaveSuccess() {
            vm.grievanceLog={};
            vm.commentValue=null;
        }

        vm.showPersonalDetail= function (id) {
            Grievance.get({id: id},function(result) {
                swal({
                    title: '<u>Applicant Details</u><br/><br/>',
                    animation: true,
                    html:
                        '<b>Name: </b> ' + result.grievanceBy + '<br/><br/>' +
                        '<b>Phone: </b> ' + result.phone + '<br/><br/>' +
                        '<b>Email: </b> ' + result.email + '<br/><br/>' +
                        '<b>Address: </b> ' + result.address + '<br/><br/>'
                })
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Grievancelist', Grievancelist);

    Grievancelist.$inject = ['$resource', 'DateUtils'];

    function Grievancelist ($resource, DateUtils) {
        var resourceUrl =  'api/grievances/list/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.grievanceDate = DateUtils.convertDateTimeFromServer(data.grievanceDate);
                        data.resolveDate = DateUtils.convertDateTimeFromServer(data.resolveDate);
                        data.assignDate = DateUtils.convertDateTimeFromServer(data.assignDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievancelistController', GrievancelistController);

    GrievancelistController.$inject = ['$scope', '$state', 'Principal', 'LoginService', 'Grievance', 'GrievanceLog'];

    function GrievancelistController ($scope, $state, Principal, LoginService, Grievance, GrievanceLog) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.grievanceLog={};

        Grievance.query({id:"1",user:"1"},function(result) {
                        vm.grievances = result;
                        vm.searchQuery = null;
                    });

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        vm.commentContent= function (data) {
            vm.commentData = data;
        };

        vm.comment = function () {
            vm.grievanceLog.grievanceId= vm.commentData.grievanceId;
            vm.grievanceLog.action= "Comment";
            vm.grievanceLog.actionComment= vm.commentValue;
            GrievanceLog.save(vm.grievanceLog,onSaveSuccess);
        };

        function onSaveSuccess() {
            vm.grievanceLog={};
            vm.commentValue=null;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
         .state('grievancelist', {
              parent: 'app',
              url: '/grievancelist',
             data: {
                 authorities: ['ROLE_ADMIN']
             },
             views: {
                 'content@': {
                     templateUrl: 'app/grievancedetail/grievancelist.html',
                     controller: 'GrievancelistController',
                     controllerAs: 'vm'
                 }
             },
             resolve: {
               translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                   $translatePartialLoader.addPart('home');
                   return $translate.refresh();
             }]
            }
        })

        .state('grievancedetail', {
            parent: 'grievancelist',
            url: '/grievancedetail',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                templateUrl: 'app/grievancedetail/grievancedetail.html',
                controller: 'GrievancedetailController',
                controllerAs: 'vm',
                backdrop: 'static',
                keyboard: 'false',

                resolve: {
                grievancedetail: function () {
                    return {
                        grievanceId: null,
                        grievanceDate: null,
                        grievanceBy: null,
                        grievance: null,
                        status: 'Pending',
                        resolveComment: null,
                        resolveDate: null,
                        resolveBy: null,
                        assignTo: null,
                        assignDate: null,
                        assignBy: null,
                        assignStatus: false,
                        id: null,
                        district: null,
                        department: null,
                        distrcitId: null,
                        departmentId: null,
                        isResolved: false,
                        nameOfEnterprise: null,
                        factoryAddress: null,
                        correspondenceAddress: null,
                        activityOfEnterprise: null,
                        adhaarNumber: null,
                        nameOfPartner: null,
                        officeBearerIndustriesAssociation: null,
                        contactNumber: null,
                        emailAddress: null,
                        categoryOfGrievance: null,
                        otherCategory: null,
                        grievanceRefferedToDept: false,
                        dateOfCommunication: null,
                        attachemnt1: null,
                        attachemnt2: null

                };
                    }
            }
            }).result.then(function() {
                         $state.go('grievancelist', null, { reload: 'grievancelist' });
                     }, function() {
                         $state.go('grievancelist');
                     });
             }]
        })

        .state('grievancelistadmin', {
                     parent: 'app',
                     url: '/grievancelistadmin',
                     data: {
                         authorities: ['ROLE_ADMIN']
                     },
                     views: {
                         'content@': {
                             templateUrl: 'app/grievancedetail/grievancelistadmin.html',
                             controller: 'GrievancelistadminController',
                             controllerAs: 'vm'
                         }
                     },
                     resolve: {
                       translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                           $translatePartialLoader.addPart('home');
                           return $translate.refresh();
                     }]
                    }
                })

        .state('grievanceassign', {
                parent: 'grievancelistadmin',
                url: '/grievanceassign/{id}',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                    templateUrl: 'app/grievancedetail/grievanceassign.html',
                    controller: 'GrievanceassignController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        grievance: ['Grievance', function(Grievance) {
                             return Grievance.get({id : $stateParams.id}).$promise;
                        }]
                   }

                }).result.then(function() {
                             $state.go('grievancelistadmin', null , { reload: 'grievancelistadmin' });
                         }, function() {
                             $state.go('grievancelistadmin');
                         });
                 }]
            })

        .state('grievanceassignofficer', {
                 parent: 'grievancelistofficer',
                 url: '/grievanceassign/{id}',
                 data: {
                     authorities: ['ROLE_ADMIN']
                 },
                 onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                     $uibModal.open({
                     templateUrl: 'app/grievancedetail/grievanceassign.html',
                     controller: 'GrievanceassignController',
                     controllerAs: 'vm',
                     backdrop: 'static',
                     resolve: {
                         grievance: ['Grievance', function(Grievance) {
                              return Grievance.get({id : $stateParams.id}).$promise;
                         }]
                    }
                 }).result.then(function() {
                              $state.go('grievancelistofficer', null , { reload: 'grievancelistofficer' });
                          }, function() {
                              $state.go('grievancelistofficer');
                          });
                  }]
             })

        .state('grievancelistofficer', {
                     parent: 'app',
                     url: '/grievancelistofficer',
                     data: {
                         authorities: ['ROLE_ADMIN']
                     },
                     views: {
                         'content@': {
                             templateUrl: 'app/grievancedetail/grievancelistofficer.html',
                             controller: 'GrievancelistofficerController',
                             controllerAs: 'vm'
                         }
                     },
                     resolve: {
                         translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                           $translatePartialLoader.addPart('home');
                           return $translate.refresh();
                     }]

                    }
                })

        .state('resolvebox', {
                    parent: 'grievancelistofficer',
                    url: '/resolvebox/{id}',
                    data: {
                        authorities: ['ROLE_ADMIN']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                        templateUrl: 'app/grievancedetail/resolvebox.html',
                        controller: 'ResolveboxController',
                        controllerAs: 'vm',
                        resolve: {
                            grievance: ['Grievance', function(Grievance) {
                                   return Grievance.get({id : $stateParams.id}).$promise;
                            }]
                           }

                        }).result.then(function() {
                                     $state.go('grievancelistofficer', null, { reload: 'grievancelistofficer' });
                                 }, function() {
                                     $state.go('grievancelistofficer');
                                 });
                     }]
                })

        .state('viewlog-userlist', {
             parent: 'grievancelist',
             url: '/viewlog/{grievanceId}',
             data: {
                 authorities: ['ROLE_ADMIN']
             },
             onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                     $uibModal.open({
                     templateUrl: 'app/grievancedetail/viewlog.html',
                     controller: 'ViewLogController',
                     controllerAs: 'vm',
                     size:'lg',

                         resolve: {
               grievance: ['$stateParams', 'Grievance', function($stateParams, Grievance) {
                      return Grievance.query({grievanceId : $stateParams.grievanceId}).$promise;
               }]
             }
           }).result.then(function() {
                        $state.go('grievancelist', null, { reload: 'grievancelist' });
                   }, function() {
                        $state.go('grievancelist');
                   });
            }]
        })

        .state('viewlog-adminlist', {
             parent: 'grievancelistadmin',
             url: '/viewlog/{grievanceId}',
             data: {
                 authorities: ['ROLE_ADMIN']
             },
             onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                     $uibModal.open({
                     templateUrl: 'app/grievancedetail/viewlog.html',
                     controller: 'ViewLogController',
                     controllerAs: 'vm',
                     size:'lg',

                         resolve: {
               grievance: ['$stateParams', 'Grievance', function($stateParams, Grievance) {
                      return Grievance.query({grievanceId : $stateParams.grievanceId}).$promise;
               }]
             }
           }).result.then(function() {
                        $state.go('grievancelistadmin', null, { reload: 'grievancelistadmin' });
                   }, function() {
                        $state.go('grievancelistadmin');
                   });
            }]
        })

        .state('viewlog-officer', {
             parent: 'grievancelistofficer',
             url: '/viewlog/{grievanceId}',
             data: {
                 authorities: ['ROLE_ADMIN']
             },
             onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                     $uibModal.open({
                     templateUrl: 'app/grievancedetail/viewlog.html',
                     controller: 'ViewLogController',
                     controllerAs: 'vm',
                     size:'lg',

                         resolve: {
               grievance: ['$stateParams', 'Grievance', function($stateParams, Grievance) {
                      return Grievance.query({grievanceId : $stateParams.grievanceId}).$promise;
               }]
             }
           }).result.then(function() {
                        $state.go('grievancelistofficer', null, { reload: 'grievancelistofficer' });
                   }, function() {
                        $state.go('grievancelistofficer');
                   });
            }]
        })
            .state('viewFilledForm-admin', {
                parent: 'grievancelistadmin',
                url: '/viewFilledForm/{id}',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/grievancedetail/ViewGrievanceFormFilled.html',
                        controller: 'ViewGrievanceFormFilledController',
                        controllerAs: 'vm',
                        size:'lg',
                        backdrop: 'static',

                        resolve: {
                            grievance: ['Grievance', function(Grievance) {
                                return Grievance.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('grievancelistadmin', null, { reload: 'grievancelistadmin' });
                    }, function() {
                        $state.go('grievancelistadmin');
                    });
                }]
            })
            .state('viewMyFilledForm', {
                parent: 'grievancelist',
                url: '/viewFilledForm/{id}',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/grievancedetail/ViewGrievanceFormFilled.html',
                        controller: 'ViewGrievanceFormFilledController',
                        controllerAs: 'vm',
                        size:'lg',
                        backdrop: 'static',

                        resolve: {
                            grievance: ['Grievance', function(Grievance) {
                                return Grievance.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('grievancelist', null, { reload: 'grievancelist' });
                    }, function() {
                        $state.go('grievancelist');
                    });
                }]
            })

            .state('viewFilledForm-Officer', {
            parent: 'grievancelistofficer',
            url: '/viewFilledForm/{id}',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/grievancedetail/ViewGrievanceFormFilled.html',
                    controller: 'ViewGrievanceFormFilledController',
                    controllerAs: 'vm',
                    size:'lg',
                    backdrop: 'static',

                    resolve: {
                        grievance: ['Grievance', function(Grievance) {
                            return Grievance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('grievancelistofficer', null, { reload: 'grievancelistofficer' });
                }, function() {
                    $state.go('grievancelistofficer');
                });
            }]
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievancedetailController', GrievancedetailController);

    GrievancedetailController.$inject = ['$scope', '$state','$uibModalInstance', 'Principal', 'LoginService', 'Grievance','grievancedetail', 'District', 'Department','FileManagement'];

    function GrievancedetailController ($scope, $state, $uibModalInstance, Principal, LoginService, Grievance, grievancedetail, District, Department,FileManagement) {
        var vm = this;
        vm.grievancedata = grievancedetail;
        vm.grievancedata.isUserAttachmentPresent = false;

        vm.account = null;
        vm.isAuthenticated = null;
        $scope.file = {};
        vm.login = LoginService.open;
        vm.register = register;
        vm.datePickerOpenStatus = {};

        vm.fileattachment = [];
        vm.openCalendar = openCalendar;

        vm.clear = clear;
        vm.saveGrievanceData = saveGrievanceData;
        console.log(vm.grievancedata);

        District.query(function(result) {
           vm.districts = result;
           vm.searchQuery = null;
       });

        Department.query(function(result) {
            vm.departments = result;
            vm.searchQuery = null;
        });

        function saveGrievanceData()
        {
            vm.grievancedata.department = vm.grievancedata.selecteddepartment.departmentname;
            vm.grievancedata.departmentId = vm.grievancedata.selecteddepartment.id;
            vm.grievancedata.district = vm.grievancedata.selecteddistrict.districtname;
            vm.grievancedata.districtId = vm.grievancedata.selecteddistrict.id;
            Grievance.save(vm.grievancedata,onSaveSuccess,onSaveError);
        }
        function onSaveSuccess(result)
        {
            vm.fileattachment = [];
            $uibModalInstance.close(result);
        }
        function onSaveError()
        {
            vm.fileattachment = [];

            $uibModalInstance.close();
        }
        function clear ()
        {
            vm.fileattachment = [];
            $uibModalInstance.dismiss('cancel');
        }
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();
        vm.addfileattachment = function(){
            if(!vm.grievancedata.grievanceRefferedToDept){
                vm.dispute.dateOfCommunication = null;
            }

            if(vm.attachment1 != null){
                vm.fileattachment.push({file:vm.attachment1,name:"Attachment1"})
            }
            if(vm.attachment2 != null){
                vm.fileattachment.push({file:vm.attachment2,name:"Attachment2"})
            }
            if(vm.fileattachment.length != 0){
                // var fileNameArray = vm.attachment.name.split(".");
                // var fileextension="";
                // if((fileNameArray.length>1)){
                //     fileextension=fileNameArray[(fileNameArray.length-1)];
                // }
                // var inputFileName=vm.attachment.name.split(".")[0];
                // if(fileextension!==""){
                //     inputFileName=inputFileName+"."+fileextension;
                // }
                vm.grievancedata.isUserAttachmentPresent = true;
            }
            vm.grievancedata.department = vm.grievancedata.selecteddepartment.departmentname;
            vm.grievancedata.departmentId = vm.grievancedata.selecteddepartment.id;
            vm.grievancedata.district = vm.grievancedata.selecteddistrict.districtname;
            vm.grievancedata.districtId = vm.grievancedata.selecteddistrict.id;
//            vm.grievancedata.isSaving = true;
            Grievance.save(vm.grievancedata,onSaveAttachmentSuccess,onSaveError);
        }

        function onSaveAttachmentSuccess (result){
            if(vm.fileattachment.length !==0) {
                // var filename = result.id;
                // var file =vm.attachment;
                for (var i = 0; i < vm.fileattachment.length; i++) {
                    var filename = result.id + "_" +i;
                    var file = vm.fileattachment[i].file;
                    FileManagement.saveFile(file, filename);
                    var fileNameArray = vm.fileattachment[i].file.name.split(".");
                    var fileextension = "";
                    if ((fileNameArray.length > 1)) {
                        fileextension = fileNameArray[(fileNameArray.length - 1)];
                    }
                    var inputFileName = result.id;
                    if (fileextension !== "") {
                        inputFileName = inputFileName + "." + fileextension;
                    }
                    if (vm.fileattachment[i].name === "Attachment1") {
                        result.attachment1 = filename + "." + fileextension
                    }
                    if (vm.fileattachment[i].name === "Attachment2") {
                        result.attachment2 = filename + "." + fileextension
                    }

                    // result.description = result.id+"."+fileextension;
                }
                Grievance.update(result, onSaveSuccess, onSaveError);
            }
            $uibModalInstance.close(result);
        }

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
        vm.datePickerOpenStatus.dateOfFiling =false;
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceassignController', GrievanceassignController);

    GrievanceassignController.$inject = ['$scope', '$state','$uibModalInstance', 'Principal', 'LoginService', 'Grievance', 'grievance', 'UserListToAssignGrievance'];

    function GrievanceassignController ($scope, $state, $uibModalInstance, Principal, LoginService, Grievance, grievance, UserListToAssignGrievance) {
        var vm = this;

        vm.grievance = grievance;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        vm.clear = clear;
        vm.updateAssignGrievance = updateAssignGrievance;

        UserListToAssignGrievance.query({role:"ROLE_GRIEVANCE_OFFICER"}, function(result) {
            vm.users = result;
            vm.searchQuery = null;
        });

        function updateAssignGrievance()
        {
            vm.grievance.assignTo=vm.grievance.selectedassignTo.login;
            vm.grievance.assignStatus=true;
            Grievance.update(vm.grievance,onUpdateGrievanceSuccess,onUpdateGrievanceError);
        }
        function onUpdateGrievanceSuccess(result)
        {
              $uibModalInstance.close(result);
        }
        function onUpdateGrievanceError()
        {
        alert("Grievance not updated");
        }
        function clear ()
        {
            $uibModalInstance.dismiss('cancel');
        }


        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SearchGrievance', SearchGrievance);

    SearchGrievance.$inject = ['$resource'];

    function SearchGrievance ($resource) {
        var resourceUrl =  'api/searchGrievance/:grievance';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SearchGrievanceController', SearchGrievanceController);

    SearchGrievanceController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'SearchGrievance','Grievance','GrievanceLog'];

    function SearchGrievanceController ($scope, Principal, LoginService, $state, SearchGrievance,Grievance,GrievanceLog) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.getGrievance = getGrievance;
        vm.grievance={};
        vm.showtable=false;
        vm.grievanceLog={};

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });


        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register () {
            $state.go('register');
        }

        function getGrievance() {
            vm.grievance=null;
            vm.showtable=false;
            SearchGrievance.get({grievance:vm.grievanceID},function(result){
                vm.grievance = result;
                vm.showtable=true;
            });
        }

        vm.commentContent= function (data) {
            vm.commentData = data;
        };

        vm.comment = function () {
            vm.grievanceLog.grievanceId= vm.commentData.grievanceId;
            vm.grievanceLog.action= "Comment";
            vm.grievanceLog.actionComment= vm.commentValue;
            GrievanceLog.save(vm.grievanceLog,onSaveSuccess);
        };

        function onSaveSuccess() {
            vm.grievanceLog={};
            vm.commentValue=null;
        }
        vm.showPersonalDetail= function (id) {
            Grievance.get({id: id},function(result) {
                swal({
                    title: '<u>Applicant Details</u><br/><br/>',
                    animation: true,
                    html:
                        '<b>Name: </b> ' + result.grievanceBy + '<br/><br/>' +
                        '<b>Phone: </b> ' + result.phone + '<br/><br/>' +
                        '<b>Email: </b> ' + result.email + '<br/><br/>' +
                        '<b>Address: </b> ' + result.address + '<br/><br/>'
                })
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('GrievanceViewStatsDetail', GrievanceViewStatsDetail);

    GrievanceViewStatsDetail.$inject = ['$resource'];

    function GrievanceViewStatsDetail ($resource) {
        var resourceUrl =  'api/grievanceviewstatsdetail/:departmentId/:districtId/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceViewStatsDetailController', GrievanceViewStatsDetailController);

    GrievanceViewStatsDetailController.$inject = ['$scope', 'Principal', '$uibModalInstance', '$stateParams', 'LoginService', '$state', 'GrievanceViewStatsDetail'];

    function GrievanceViewStatsDetailController ($scope, Principal, $uibModalInstance, $stateParams, LoginService, $state, GrievanceViewStatsDetail) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        vm.district=$stateParams.district;
        vm.status=$stateParams.status;

        vm.clear = clear;

        loadAllGrievancesStatus();
        function loadAllGrievancesStatus() {
            vm.grievancestats=GrievanceViewStatsDetail.query({departmentId:$stateParams.departmentId,districtId:$stateParams.districtId,status:$stateParams.status});
            vm.show=true;
        }

        function clear ()
        {
            $uibModalInstance.dismiss('cancel');
        }



        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('grievancedashboard', {
            parent: 'app',
            url: '/grievancedashboard',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/grievancedashboard/grievancedashboard.html',
                    controller: 'GrievanceDashboardController',
                    controllerAs: 'vm'
                }
                },
                resolve: {
                   translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                       $translatePartialLoader.addPart('home');
                       return $translate.refresh();
                 }]
                }
        })
            .state('searchGrievance', {
                parent: 'app',
                url: '/searchGrievance',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/grievancedashboard/searchgrievance.html',
                        controller: 'SearchGrievanceController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('dashboard');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

            .state('viewlog', {
                parent: 'searchGrievance',
                url: '/viewlog/{grievanceId}',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/grievancedetail/viewlog.html',
                        controller: 'ViewLogController',
                        controllerAs: 'vm',
                        size:'lg',

                        resolve: {
                            grievance: ['$stateParams', 'Grievance', function($stateParams, Grievance) {
                                return Grievance.query({grievanceId : $stateParams.grievanceId}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('searchGrievance', null, { reload: 'searchGrievance' });
                    }, function() {
                        $state.go('searchGrievance');
                    });
                }]
            })



            .state('grievanceviewstatsdetail', {
            parent: 'grievancedashboard',
            url: '/grieavanceviewstatsdetail/{departmentId}/{district}/{districtId}/{status}',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/grievancedashboard/grievanceviewstatsdetail.html',
                    controller: 'GrievanceViewStatsDetailController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('grievancedashboard', null, { reload: 'grievancedashboard' });
                }, function() {
                    $state.go('grievancedashboard');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('GrievanceDashboard', GrievanceDashboard);

    GrievanceDashboard.$inject = ['$resource'];

    function GrievanceDashboard ($resource) {
        var resourceUrl =  'api/grievancedashboard';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceDashboardController', GrievanceDashboardController);

    GrievanceDashboardController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'GrievanceDashboard', 'GrievanceDashboardOutput'];

    function GrievanceDashboardController ($scope, Principal, LoginService, $state, GrievanceDashboard, GrievanceDashboardOutput) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        loadAll();
        function loadAll() {
        GrievanceDashboardOutput.query(function(result) {
              vm.grievancedashboard = result;
                vm.totalunassignedgrievances=0;
                vm.totalassignedgrievances=0;
                vm.totalpendinggrievances=0;
                vm.totalresolvedgrievances=0;
                 for(var i=0;i<vm.grievancedashboard.length;i++)
                 {
                   vm.totalunassignedgrievances=vm.totalunassignedgrievances + parseInt(vm.grievancedashboard[i].unassigned);
                   vm.totalassignedgrievances=vm.totalassignedgrievances+ parseInt(vm.grievancedashboard[i].assigned);
                   vm.totalpendinggrievances=vm.totalpendinggrievances+ parseInt(vm.grievancedashboard[i].pending);
                   vm.totalresolvedgrievances=vm.totalresolvedgrievances+ parseInt(vm.grievancedashboard[i].resolved);
                 }
                 vm.searchQuery = null;
        });
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gallery', {
            parent: 'app',
            url: '/gallery',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/Gallery/gallery.html',
                    controller: 'GalleryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('gallery');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')   // use your app module name
        .controller('GalleryController', GalleryController);

    GalleryController.$inject = [];

    function GalleryController() {
        var vm = this;



        // ✅ Function to open selected image (modal/lightbox logic can be added later)
        vm.viewImage = function (image) {
            vm.selectedImage = image;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('force-majeure', {
            parent: 'app',
            url: '/force-majeure',
            data: {
                authorities: [],
                pageTitle: 'global.menu.force-majeure'
            },
            views: {
                'content@': {
                    templateUrl: 'app/force-majeure/force-majeure.html',
                    controller: 'ForceMajeureController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('temporary-tower-apply');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('ForceMajeureService', ForceMajeureService);

    ForceMajeureService.$inject = ['$resource'];

    function ForceMajeureService($resource) {

        var resourceUrl = 'api/force-majeure/:id';

        return $resource(resourceUrl, {}, {
            save: {
                method: 'POST',
                transformRequest: angular.identity,
                headers: { 'Content-Type': undefined } // Let browser set multipart boundary
            },

            // Existing APIs
            // 'save':   { method: 'POST' },
            'update': { method: 'PUT' },
            'get':    { method: 'GET' },
            'query':  { method: 'GET', isArray: true },
            'delete': { method: 'DELETE' },

            // ⭐ New API to fetch by district and cafType
            'findByDistrictAndCafType': {
                method: 'GET',
                url: 'api/projectByDistrictAndCafType',   // New backend API endpoint
                isArray: true,
                params: {
                    district: '@district',
                    cafType: '@cafType'
                }
            },

            'queryByUser': {
                method: 'GET',
                isArray: true,
                url: 'api/force-majeure/findByAppliedBy'
            } ,

            'checkForceMajeure': {
                method: 'GET',
                isArray: true,
                url: 'api/force-majeure/findByDistrict'
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ForceMajeureController', ForceMajeureController);

    ForceMajeureController.$inject = ['$scope', 'ForceMajeureService', 'District', 'Project'];

    function ForceMajeureController($scope, ForceMajeureService, District, Project) {
        var vm = this;
        $scope.file = {};
        vm.businessEntities = [];

        loadAllDistrict();
        // loadUserApplications()
       loadApplicationAppliedBy();

        vm.minDate = new Date();

        vm.districts = [];
        function loadAllDistrict(){
            District.query(function(result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

        vm.load = function(id) {
            TemporaryTowerApplyService.get({ id: id }, function(result) {
               // vm.form = result;
               // vm.selectedDistrict = result.district;
            });
        };


        function loadApplicationAppliedBy() {
            ForceMajeureService.queryByUser(function (result) {
                vm.applications = result;
            });
        };



        // --------------------------
        // SUBMIT FORM
        // --------------------------
        vm.applyTemporaryTower = function () {
            console.log(vm.form.file);

            // Create FormData object
            var formData = new FormData();

            // Append JSON data as a Blob
            var dto = {
                district: vm.selectedDistrict.districtname,
                startDate: vm.form.startDate,
                endDate: vm.form.endDate,
                remark: vm.form.remark,
                status: "ServiceStopped"
            };
            formData.append('data', new Blob([angular.toJson(dto)], { type: "application/json" }));

            // Append file if present
            if (vm.form.file) {
                formData.append('file', vm.form.file);
            }

            console.log("formdataaa" + formData);

            // Send the request
            ForceMajeureService.save(formData,
                function success() {
                    alert("Force Majeure Request Submitted successfully!");
                    loadApplicationAppliedBy();
                },
                function error(err) {
                    console.log("Error in submitting:", err);
                });

        };

        vm.openEditModal = function (row) {
            vm.editData = angular.copy(row);  // load row into modal

            $('#editTowerModal').modal('show');   // open modal
        };



        vm.Resume = function () {

            vm.editData.status = "ServiceResumed";

            ForceMajeureService.update(vm.editData,
                function success() {
                    alert("Resumed successfully!");
                    $('#editTowerModal').modal('hide');
                    loadApplicationAppliedBy(); // refresh table
                },
                function error(err) {
                    console.log("Error updating:", err);
                }
            );
        };



    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('resolveRating', {
            parent: 'feedbacksbyofficer',
            url: '/resolveRating/{ratingId}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_FEEDBACK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/feedbacksbyofficer/actiontaken.html',
                        controller: 'ActionTakenController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            rating: ['Rating', function(Rating) {
                                return Rating.get({id : $stateParams.ratingId}).$promise;
                            }],
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                $translatePartialLoader.addPart('feedbacksbyofficer');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        $state.go('feedbacksbyofficer', null, { reload: 'feedbacksbyofficer' });
                    }, function() {
                        $state.go('feedbacksbyofficer');
                    });
                }]
            })
        }
    })();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FeedbacksByOfficerController', FeedbacksByOfficerController);

    FeedbacksByOfficerController.$inject = ['$scope', '$filter','$state','Principal','Rating', 'DepartmentService', 'District','RatingsByDepartmentId','RatingsByDepartmentIdAndRating'];

    function FeedbacksByOfficerController($scope, $filter, $state,Principal, Rating, DepartmentService, District, RatingsByDepartmentId, RatingsByDepartmentIdAndRating) {
        var vm = this;
        vm.account= {};
        vm.feedbacks = [];
        vm.allFeedbacks = [];
        vm.departmentNames = [];
        vm.ratingType = "All";
        vm.getWorkListType="";
        vm.getWorkType = "pending";
        vm.getPoorAverage = getPoorAverage;
        vm.resolve = false;
        vm.ResolveFeedback=[];
        vm.filter = false;
        vm.back = back;
        vm.HODFeedback = [];

        $scope.averageOrPoor = function(feedback){
            return feedback.rating === 'Average' || feedback.rating === 'Poor';
        };
        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                for(var i=0;i<=vm.account.authorities.length; i++){
                    if(vm.account.authorities[i]==="ROLE_NODAL_OFFICER"){
                        vm.ratingType = "Average";
                        vm.getRatingsByRating(vm.ratingType);
                    }else if(vm.account.authorities[i]==="ROLE_FEEDBACK_OFFICER"){
                        vm.ratingType = "All";
                        vm.getRatingsByRating(vm.ratingType);
                        loadAll();
                    }
                }
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }


            function loadAll() {
                RatingsByDepartmentIdAndRating.query({rating: "All"}, function (result) {
                    vm.HODFeedback = $filter('filter')(result, {isResolved: false});
                    if (result.length > 0) {
                        vm.departmentNames = getUniqueDepartmentNames(result);
                    }
                });
            }



        function getPoorAverage(){
            vm.resolve=true;
            vm.filter= true;
            vm.ResolveFeedback = vm.HODFeedback;
        }


        vm.getRatingsByRating = function(ratingType){
            vm.resolve = false;
            vm.ResolveFeedback = [];
            RatingsByDepartmentIdAndRating.query({ rating: ratingType },function(result){
                vm.feedbacks = result;
                vm.allFeedbacks = result;
                if(result.length > 0){
                    vm.departmentNames = getUniqueDepartmentNames(result);
                }
                vm.getWorkList(vm.getWorkType);
            });
        }



        vm.getWorkList = function(selection){
            vm.getWorkType = selection;
            vm.resolve = false;
            if(selection === 'pending'){
                vm.feedbacks=$filter('filter')(vm.allFeedbacks,{ isResolved : false });
            }else if(selection === 'resolved'){
                vm.filter= true;
                vm.feedbacks=$filter('filter')(vm.allFeedbacks,{ isResolved : true });
            }
        };

        function getUniqueDepartmentNames(array){
            var unique = {};
            var distinct = [];
            for( var i in array ){
                if( typeof(unique[array[i].departmentName]) == "undefined"){
                    distinct.push(array[i].departmentName);
                }
                unique[array[i].departmentName] = 0;
            }
            return filter_array(distinct);
        }

        function filter_array(test_array) {
            var index = -1,
                arr_length = test_array ? test_array.length : 0,
                resIndex = -1,
                result = [];

            while (++index < arr_length) {
                var value = test_array[index];

                if (value) {
                    result[++resIndex] = value;
                }
            }

            return result;
        }
        function back() {
            $state.reload();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ActionTakenController', ActionTakenController);

    ActionTakenController.$inject = ['$scope', '$uibModalInstance', '$stateParams', '$filter', 'rating', 'Rating'];

    function ActionTakenController($scope, $uibModalInstance, $stateParams, $filter, rating, Rating) {
        var vm = this;
        vm.rating = rating;
        vm.actionTaken = "";
        vm.clear = clear;
        vm.saveActionTaken = function(){
            rating.isResolved = true;
            rating.actionTaken = vm.actionTaken;
            Rating.update(vm.rating, function(result){
                $uibModalInstance.close(result);
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('RatingStats', RatingStats);

    RatingStats.$inject = ['$resource', 'DateUtils'];

    function RatingStats ($resource, DateUtils) {
        var resourceUrl =  'api/ratingstats';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpadte = DateUtils.convertDateTimeFromServer(data.lastUpadte);
                        data.appliedDate = DateUtils.convertDateTimeFromServer(data.appliedDate);
                        data.clearedDate = DateUtils.convertDateTimeFromServer(data.clearedDate);
                        data.actionTakenDate = DateUtils.convertDateTimeFromServer(data.actionTakenDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('allratingsummary', {
            parent: 'feedback-ratings',
            url: '/feedback-ratings/all/{status}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/feedbackratingdashboard/allratingsummary.html',
                    controller: 'AllRatingSummaryController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    windowClass: 'app-modal-window',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('feedback-ratings');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('feedback-ratings', null, { reload: 'feedback-ratings' });
                }, function() {
                    $state.go('feedback-ratings');
                });
            }]
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FeedbackDashboardController', FeedbackDashboardController);

    FeedbackDashboardController.$inject = ['$scope', '$filter', 'Rating', 'DepartmentService', 'District','Department','RatingsByRating', 'RatingStats'];

    function FeedbackDashboardController($scope, $filter, Rating, DepartmentService, District,Department, RatingsByRating, RatingStats) {
        var vm = this;
        vm.allRatingsCounter = 0;
        vm.allExcellentCounter = 0;
        vm.allVeryGoodCounter = 0;
        vm.allGoodCounter = 0;
        vm.allAverageCounter = 0;
        vm.allPoorCounter = 0;
        vm.allPoorRatings = [];
        vm.allAverageRatings = [];
        vm.allResolvedCounter = 0;
        vm.allUnresolvedCounter = 0;
        vm.allRatingStats = {};
        vm.allRatings = [];
        vm.districts = [];
        vm.departments = [];
        vm.selectedDepartmentId = null;
        vm.departmentratings = [];

        vm.selectedFilter = 'service';
        console.log(vm.selectedDepartmentId);
        Rating.query(function(result){
            vm.feedbackratings = result;
            vm.allRatings = result;
            angular.forEach(vm.feedbackratings, function(value, key){
                if(vm.departments.indexOf(value.departmentName) === -1){
                    vm.departments.push(value.departmentName);
                }
            });
            getResolvedAndUnresolved();
        });

//        DepartmentService.query({id:'',departmentid:selectedDepartmentId},function(result){
//            vm.departmentservices = result;
//        });

        // Department.query(function(result) {
        //     vm.departments = result;
        // });

        District.query(function(result){
            vm.districts = result;
        });

        vm.departmentSelected = function(selectedDepartmentId){

            vm.departmentservices = [];
            if(vm.selectedDepartmentId ===null){
                vm.showService = true;
            }

            vm.feedbackratings = $filter('filter')(vm.allRatings,{ departmentName : selectedDepartmentId });
            angular.forEach(vm.feedbackratings, function(value, key) {
                if (vm.departmentservices.indexOf(value.serviceName) === -1) {
                    vm.departmentservices.push(value.serviceName);
                }
            });
            vm.departmentratings = vm.feedbackratings;
        }
        vm.serviceSelected = function(selectedServiceId){
            vm.feedbackratings = $filter('filter')(vm.departmentratings,{ serviceName : selectedServiceId });

        }

        vm.selectFilter = function(selectedFilter){
            vm.selectedFilter = selectedFilter;
            if(selectedFilter === 'service'){
                vm.serviceSelected(vm.selectedServiceId);
            } else if (selectedFilter === 'district') {
                vm.districtSelected(vm.selectedDistrict);
            }else if (selectedFilter === 'department') {
                vm.departmentSelected(vm.selectedDepartmentId);
            }
        }
        vm.districtSelected = function(selectedDistrict){
            vm.feedbackratings = $filter('filter')(vm.allRatings,{ district : selectedDistrict });
        }

        RatingStats.get(function(result){
            vm.allRatingStats = result;
        });

        function getResolvedAndUnresolved(){
            vm.unresolvedPoorCounter=$filter('filter')(vm.allRatings,{ isResolved : false, rating: 'Poor'}).length;
            vm.unresolvedAverageCounter=$filter('filter')(vm.allRatings,{ isResolved : false, rating: 'Average'}).length;
            vm.resolvedPoorCounter=$filter('filter')(vm.allRatings,{ isResolved : true, rating: 'Poor'}).length;
            vm.resolvedAverageCounter=$filter('filter')(vm.allRatings,{ isResolved : true, rating: 'Average'}).length;
        }

        vm.clear = function clear () {
            $uibModalInstance.dismiss('cancel');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AllRatingSummaryController', AllRatingSummaryController);

    AllRatingSummaryController.$inject = ['$scope', '$stateParams', '$uibModalInstance', '$filter', 'Rating'];

    function AllRatingSummaryController($scope, $stateParams, $uibModalInstance, $filter, Rating) {
        var vm = this;
        vm.allRatings = [];
        vm.feedbacks = [];
        vm.status = $stateParams.status;
        Rating.query(function(result){
            vm.allRatings = result;
            filterFeedbacks($stateParams.status);
        });
        function filterFeedbacks(status){
            if(status === 'Resolved'){
                vm.resolvedPoorFeedbacks = $filter('filter')(vm.allRatings,{ isResolved : true, rating: 'Poor'});
                vm.resolvedAverageFeedbacks = $filter('filter')(vm.allRatings,{ isResolved : true, rating: 'Average'});
                vm.feedbacks = vm.resolvedAverageFeedbacks.concat(vm.resolvedPoorFeedbacks);
            }else if(status === 'Unresolved'){
                vm.unResolvedPoorFeedbacks = $filter('filter')(vm.allRatings,{ isResolved : false, rating: 'Poor'});
                vm.unResolvedAverageFeedbacks = $filter('filter')(vm.allRatings,{ isResolved : false, rating: 'Average'});
                vm.feedbacks = vm.unResolvedAverageFeedbacks.concat(vm.unResolvedPoorFeedbacks);
            }
        }
        vm.clear = function clear () {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ExportDistrictController', ExportDistrictController);

    ExportDistrictController.$inject = ['$scope', 'ExportService'];

    function ExportDistrictController($scope, ExportService) {
        var vm = this;
        vm.submitFeedback =  submitFeedback;
        $scope.CurrentDate = new Date();
        $scope.openForm = function() {
            $('#feedbackModal').modal('show');
        };
// Submit Feedback
       function submitFeedback() {

            console.log("Feedback submitted:", $scope.feedback);

            // Example: send to backend via $http
            // $http.post('/api/feedback', $scope.feedback).then(...);

            alert("Thank you for your feedback!");
            $('#feedbackModal').modal('hide');
            $scope.feedback = {}; // Reset form
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('export', {
            parent: 'app',
            url: '/export',
            data: {
                authorities: [],
                pageTitle: 'global.menu.export'
            },
            views: {
                'content@': {
                    templateUrl: 'app/export/export.html',
                    controller: 'ExportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('export');
                    return $translate.refresh();
                }]
            }
        }).state('exportdistrict', {
            parent: 'export',
            url: '/exportdistrict',
            data: {
                authorities: [],
                pageTitle: 'global.menu.export'
            },
            views: {
                'content@': {
                    templateUrl: 'app/export/exportdistrict.html',
                    controller: 'ExportDistrictController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('export');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('ExportService', ExportService);

    ExportService.$inject = ['$resource'];

    function ExportService($resource) {
        var service = {
            getOrdinalIndicator: getOrdinalIndicator
        };

        return service;

        function getOrdinalIndicator(n) {

            if (n || n === 0) {

                if (hasANonGenericOrdinalIndicator(n)) {
                    return 'th';
                }

                var decimal = n % 10;
                switch (decimal) {
                    case 1:
                        return 'st';
                        break;
                    case 2:
                        return 'nd';
                        break;
                    case 3:
                        return 'rd';
                        break;
                    default:
                        return 'th';
                        break;
                }
            }

            return '';
        }

        function hasANonGenericOrdinalIndicator(n) {
            var lastTwoDigits = n % 100;
            return lastTwoDigits > 10 && lastTwoDigits < 14;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ExportController', ExportController);

    ExportController.$inject = ['$scope', 'ExportService'];

    function ExportController($scope, ExportService) {
        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('shopMoveCaf', {
            parent: 'app',
            url: '/shopMoveCaf',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/exciseMoveCaf/ShopMoveToExcise.html',
                    controller: 'ShopMoveCaftoExciseController',
                    controllerAs: 'vm',
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        })
    }})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ShopExciseCaf', ShopExciseCaf);

    ShopExciseCaf.$inject = ['$resource'];

    function ShopExciseCaf ($resource) {
        var resourceUrl =  'api/allShopExciseCaf';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ShopMoveCaftoExciseController', ShopMoveCaftoExciseController);


    ShopMoveCaftoExciseController.$inject = ['$scope', '$state', 'ShopExciseCaf','MigrateCafType'];

    function ShopMoveCaftoExciseController($scope, $state, ShopExciseCaf , MigrateCafType) {
        var vm = this;
        vm.projects = [];
        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.deleteId = null;
        vm.deleteCaf=deleteCaf;



        loadAll();

        function loadAll() {
            ShopExciseCaf.query(function (result) {
                vm.projects = result;
            });
        }

        vm.details = function (projectid) {
            $state.go('projectdetailjist',{projectid:projectid});
        };

        vm.modalCaf = function(id){
            $('#deleteModal').modal('show');
            vm.deleteId = id;
        };

       function deleteCaf(id){
           $('#deleteModal').modal('hide');
           MigrateCafType.get({projectId:vm.deleteId},function (result) {
                alert("CAF TYPE has been updated for"+result.cafpin);
            }, function (error) {
               alert("CAF already exists"+error);
           });

           loadAll();
       }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MigrateCafType', MigrateCafType);

    MigrateCafType.$inject = ['$resource'];

    function MigrateCafType ($resource) {
        var resourceUrl =  'api/moveCafShopToExcise/projectId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('evPolicies', {
            parent: 'app',
            url: '/evPolicies',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/evPolicies/evPolicies.html',
                    controller: 'EvPoliciesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EvPolicies', EvPolicies);

    EvPolicies.$inject = ['$resource'];

    function EvPolicies ($resource) {
        var resourceUrl =  'api/evPolicies';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EvPoliciesController', EvPoliciesController);

    EvPoliciesController.$inject = ['EvPolicies', '$stateParams','$scope', '$state','IncentiveForm', 'Principal', 'LoginService'];

    function EvPoliciesController(EvPolicies, $stateParams,$scope, $state, IncentiveForm, Principal, LoginService) {

        var vm = this;
        vm.url = null;
        vm.isAuthenticated = Principal.isAuthenticated;
        IncentiveForm.query(function(result){
            vm.userdetails=result;
        });

        vm.setUrl = function (url) {
            vm.url = $sce.trustAsResourceUrl(url);
        };

        vm.login = function login() {
            LoginService.open();
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EodbTotalDownloadDetailYearly', EodbTotalDownloadDetailYearly);

    EodbTotalDownloadDetailYearly.$inject = ['$resource'];

    function EodbTotalDownloadDetailYearly ($resource) {
        var resourceUrl =  'api/servicedashboardcafsYearlyListByElasticByStatus/departmentName/district/projectLevel/serviceId/status/fromdate/todate';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
         .state('eodbtotaldeptservicesdetailyearly', {
          parent: 'eodbdashboardyearly',
          url: '/eodbdashboardcafsYearlyByElasticByStatus/{departmentName}/{district}/{projectLevel}/{serviceId}/{status}',
          data: {
              authorities: []
          },
          onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
              $uibModal.open({
                  templateUrl: 'app/eodbtotaldeptservicesdetailyearly/eodbtotaldeptservicesdetailyearly.html',
                  controller: 'EodbTotalDeptServicesDetailYearlyController',
                  controllerAs: 'vm',
                  backdrop: 'static',
                  size: 'lg',
                  windowClass: 'app-modal-window',
                  resolve: {
                      translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                          $translatePartialLoader.addPart('dashboard');
                          return $translate.refresh();
                      }]
                  }
              }).result.then(function() {
                  $state.go('eodbdashboardyearly', null, { reload: 'eodbdashboardyearly' });
              }, function() {
                  $state.go('eodbdashboardyearly');
              });
          }]
      });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EodbTotalDeptServicesDetailYearly', EodbTotalDeptServicesDetailYearly);

    EodbTotalDeptServicesDetailYearly.$inject = ['$resource'];

    function EodbTotalDeptServicesDetailYearly ($resource) {
        var resourceUrl =  'api/totaldeptservicesdetail/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EodbTotalDeptServicesDetailYearlyController', EodbTotalDeptServicesDetailYearlyController);

    EodbTotalDeptServicesDetailYearlyController.$inject = ['$scope', '$window', '$stateParams','$filter', 'Principal', '$uibModalInstance', 'LoginService', '$state', 'EodbTotalDasboardDetailYearly', 'EodbTotalDeptServicesDetailYearly'];

    function EodbTotalDeptServicesDetailYearlyController ($scope, $window, $stateParams,$filter, Principal, $uibModalInstance, LoginService, $state, EodbTotalDasboardDetailYearly, EodbTotalDeptServicesDetailYearly) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        // vm.download = download;

        vm.status = $stateParams.status;
        vm.clear = clear;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        var args = [];

        vm.spiner =true;
        vm.datePickerOpenStatus = {};
        vm.sortingdates={};
        vm.openCalendar = openCalendar;
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        vm.selectedDate=selectedDate;
        var d=null;
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dateOptions = {
            minDate: new Date("05-01-2017"),
            maxDate: Date.now()
        };

        function selectedDate(dateSelected){
            var newDate = new Date(dateSelected);
            newDate.setDate(newDate.getDate()+365);

            if(newDate > Date.now()){
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: Date.now()
                };
            }
            else {
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: newDate
                };
            }
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        loadAllCafs();
        function loadAllCafs() {
            vm.totaldeptservicesdetail=EodbTotalDasboardDetailYearly.get(
                {status:$stateParams.status,
                    page: $scope.currentPage - 1,
                    size: $scope.pageSize
                },
                function (result) {
                    vm.show=true;
                vm.spiner=false;
            });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        }
        $scope.pageChanged = function(num) {
            loadAllCafs();
        };

        // function convertJsonsToArrays(args){
        //     var dataArray = [];
        //     var header = [ "CAFPin",
        //         "Status",
        //         "RTS > 30",
        //         "RTS > 45",
        //         "RTS > 65",
        //         "Within RTS",
        //         "District",
        //         "Department",
        //         "Investor Name",
        //         "Investor Contact",
        //         "Investor Email",
        //         "Project Level",
        //         "Proposed Employment",
        //         "Project Investment" ,
        //         "Applied Date",
        //         // "Address",
        //         "Land Zone Use Type",
        //         "Service Name",
        //         "Business Entity"
        //     ];
        //     dataArray.push(header);
        //     for( var i = 0; i < args.length; i++ ){
        //         var row = args[i];
        //         var rowAr=[];
        //         var appliedDate=$filter('date')(row.formFilledOn, 'dd-MM-yyyy');
        //         rowAr.push(row.cafpin);
        //         rowAr.push(row.status);
        //         rowAr.push(row.rtsGreaterThan30);
        //         rowAr.push(row.rtsGreaterThan45);
        //         rowAr.push(row.rtsGreaterThan65);
        //         rowAr.push(row.withinRts);
        //         rowAr.push(row.district);
        //         rowAr.push(row.departmentName);
        //         rowAr.push(row.investorName);
        //         rowAr.push(row.investorMobilenumber);
        //         rowAr.push(row.investorEmail);
        //         rowAr.push(row.projectLevel);
        //         rowAr.push(row.proposedEmployment);
        //         rowAr.push(row.proposedInvestment);
        //         rowAr.push(appliedDate);
        //         // rowAr.push(row.investorAddress);
        //         rowAr.push(row.landZoneUseType);
        //         rowAr.push(row.serviceName);
        //         rowAr.push(row.businessEntity);
        //         dataArray.push(rowAr);
        //     }
        //     return dataArray;
        // }
        //
        // function convertJsonsToArrays1(args){
        //     var dataArray = [];
        //     var header = [ "CAFPin",
        //         "Business Entity",
        //         "District",
        //         "Department",
        //         "Investor Name",
        //         "Investor Contact",
        //         "Investor Email",
        //         "Service Name",
        //         "Project Level",
        //         "Proposed Employment",
        //         "Project Investment" ,
        //         "Applied Date",
        //         "Completion Date",
        //         "Address",
        //         "Land Zone Use Type"
        //     ];
        //     dataArray.push(header);
        //     for( var i = 0; i < args.length; i++ ){
        //         var row = args[i];
        //         var rowAr=[];
        //         var appliedDate=$filter('date')(row.formFilledOn, 'dd-MM-yyyy');
        //         var clearedDate=$filter('date')(row.clearedDate, 'dd-MM-yyyy');
        //         rowAr.push(row.cafpin);
        //         rowAr.push(row.businessEntity);
        //         rowAr.push(row.district);
        //         rowAr.push(row.departmentName);
        //         rowAr.push(row.investorName);
        //         rowAr.push(row.investorMobilenumber);
        //         rowAr.push(row.investorEmail);
        //         rowAr.push(row.serviceName);
        //         rowAr.push(row.projectLevel);
        //         rowAr.push(row.proposedEmployment);
        //         rowAr.push(row.proposedInvestment);
        //         rowAr.push(appliedDate);
        //         rowAr.push(clearedDate);
        //         rowAr.push(row.investorAddress);
        //         rowAr.push(row.landZoneUseType);
        //         dataArray.push(rowAr);
        //     }
        //     return dataArray;
        // }

        // function download(status) {
        //     var fromdate=$filter('date')(vm.fromdate, "dd-MM-yyyy");
        //     var todate=$filter('date')(vm.todate, "dd-MM-yyyy");
        //     EodbTotalDownloadDetailYearly.query({status: status, fromdate:fromdate,todate:todate}, function (data) {
        //             args = data;
        //         if(status === "Required" || status === "Pending" || status === "Applied"){
        //             var rowsCleared= convertJsonsToArrays(args);
        //         }
        //         else{
        //             var rows = convertJsonsToArrays1(args);
        //
        //         }
        //         var lineArray = [];
        //         var lineArrayCleared = [];
        //         if(status === "Required" || status === "Pending" || status === "Applied"){
        //             for(var i = 0; i < rowsCleared.length; i++){
        //                 var lineCleared = rowsCleared[i].join("\t");
        //                 lineArrayCleared.push(lineCleared);
        //             }
        //             lineArrayCleared = lineArrayCleared.join("\n");
        //             var a = document.createElement('a');
        //             var blob = new Blob([lineArrayCleared],{type: 'data:text/plain;charset=utf-8;'});
        //             var url = URL.createObjectURL(blob);
        //             $window.location.href = url;
        //         }
        //         else{
        //             for(var i = 0; i < rows.length; i++){
        //                 var line = rows[i].join("\t");
        //                 lineArray.push(line);
        //             }
        //             lineArray = lineArray.join("\n");
        //             var a = document.createElement('a');
        //             var blob = new Blob([lineArray],{type: 'data:text/plain;charset=utf-8;'});
        //             var url = URL.createObjectURL(blob);
        //             $window.location.href = url;
        //         }
        //
        //     });
        // }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EodbTotalDasboardDetailYearly', EodbTotalDasboardDetailYearly);

    EodbTotalDasboardDetailYearly.$inject = ['$resource'];

    function EodbTotalDasboardDetailYearly ($resource) {
        // var resourceUrl =  'api/totalservicedashboarddetailsbystatusyearly/:status/:serviceid';
        var resourceUrl =  'api/eodbdashboardcafsYearlyByElasticByStatus/departmentName/district/projectLevel/serviceId/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EodbPublicDashboardByElastic', EodbPublicDashboardByElastic);

    EodbPublicDashboardByElastic.$inject = ['$resource'];

    function EodbPublicDashboardByElastic ($resource) {
        var resourceUrl =  'api/eodb-public-dashboard-statsYearly-elastic';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EodbPublicDashboardByFilter', EodbPublicDashboardByFilter);

    EodbPublicDashboardByFilter.$inject = ['$resource'];

    function EodbPublicDashboardByFilter ($resource) {
        var resourceUrl =  'api/eodb-public-dashboard-statsYearly-filters/departmentName/district/projectLevel';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('eodbpublicdashboard', {
            parent: 'app',
            url: '/eodb-public-dashboard',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/eodbpublicdashboard/eodbpublicdashboard.html',
                    controller: 'EodbPublicDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EodbPublicDashboardController', EodbPublicDashboardController);

    EodbPublicDashboardController.$inject = ['$scope','$filter', 'Principal', '$state', 'EodbPublicDashboardByElastic', 'District', 'EodbPublicDashboardByFilter'];

    function EodbPublicDashboardController ($scope, $filter, Principal, $state, EodbPublicDashboardByElastic, District, EodbPublicDashboardByFilter) {
        var vm = this;

        // SLA Status indicator bands: green >= 90%, yellow 75-89%, red < 75%.
        var SLA_GREEN_FROM = 90;
        var SLA_YELLOW_FROM = 75;

        // The Met/Unmet filter follows the same line as the green band, so "Met" is exactly the
        // set of services showing green and "Unmet" is everything measurable below it.
        var SLA_MET_THRESHOLD = SLA_GREEN_FROM;

        vm.account = null;
        vm.districts = [];
        vm.departments = [];
        vm.services = [];

        // Everything the loaded rows can answer on their own is filtered here in the browser -
        // department, service, SLA status and application status all apply instantly.
        vm.clientFilter = {};

        // District is the exception. A row is one service totalled over every district and carries
        // no district of its own, so the district has to go back to the server, which recomputes
        // all the counts for that district. Level rides along on the same call.
        vm.filter = {};
        vm.hideClear = false;

        // True while a dashboard request is in flight. Every filter control is disabled against
        // this, so nothing can be changed against data that is about to be replaced.
        vm.loading = false;

        // What the District column shows. Deliberately NOT vm.filter.district: that is the live
        // ng-model of the dropdown, so binding the column to it made the column change the moment
        // a district was picked, before the request had even been sent. This is only assigned once
        // a response has come back, so the column always describes the data on screen.
        vm.appliedDistrict = null;
        $scope.CurrentDate = new Date();

        // Time Period column. The rows this dashboard reads are built with the 01-April-2018
        // window (see /api/updateNewDashboardDataFromStats), so the period runs from that date up
        // to the current month.
        vm.dataStartDate = new Date(2018, 3, 1);
        vm.timePeriod = $filter('date')(vm.dataStartDate, 'MMM yyyy') + ' - ' + $filter('date')($scope.CurrentDate, 'MMM yyyy');

        loadAll();
        function loadAll() {
            Principal.identity().then(function(account) {
                vm.account = account;
            });

            District.query(function(result) {
                vm.districts = result;
            });

            vm.loading = true;
            EodbPublicDashboardByElastic.query(function(result) {
                vm.appliedDistrict = null;
                applyResult(result);
                vm.loading = false;
            }, function () {
                // Released on failure too, otherwise a single failed call leaves the filters
                // disabled for good with no way back.
                vm.loading = false;
            });
        }

        function applyResult(result) {
            vm.deptservicedashboard = result;
            vm.departments = [];
            angular.forEach(result, function(value){
                if (value.department_name
                    && vm.departments.indexOf(value.department_name) === -1
                    && value.department_name != "Communication and Connectivity Permissions") {
                    vm.departments.push(value.department_name);
                }
            });
            vm.departments.sort();
            vm.rebuildServiceList();
            vm.applyClientFilters();
        }

        /**
         * Services offered in the Service dropdown, narrowed to the chosen department so the list
         * stays usable. Clears the chosen service if it is no longer on offer.
         */
        vm.rebuildServiceList = function () {
            vm.services = [];
            angular.forEach(vm.deptservicedashboard, function(value){
                if (vm.clientFilter.departmentName && value.department_name !== vm.clientFilter.departmentName) {
                    return;
                }
                if (value.service_name && vm.services.indexOf(value.service_name) === -1) {
                    vm.services.push(value.service_name);
                }
            });
            vm.services.sort();
            if (vm.clientFilter.serviceName && vm.services.indexOf(vm.clientFilter.serviceName) === -1) {
                vm.clientFilter.serviceName = null;
            }
        };

        vm.onDepartmentChange = function () {
            vm.rebuildServiceList();
            vm.applyClientFilters();
        };

        // i. Department
        function matchesDepartment(row) {
            return !vm.clientFilter.departmentName || row.department_name === vm.clientFilter.departmentName;
        }

        // ii. Service
        function matchesService(row) {
            return !vm.clientFilter.serviceName || row.service_name === vm.clientFilter.serviceName;
        }

        // iv. SLA Status
        function matchesSlaStatus(row) {
            if (!vm.clientFilter.slaStatus) {
                return true;
            }
            var pct = parseFloat(row.slaMet);
            // "NA" rows have no measurable SLA, so they belong to neither Met nor Unmet.
            if (isNaN(pct)) {
                return false;
            }
            return vm.clientFilter.slaStatus === 'Met'
                ? pct >= SLA_MET_THRESHOLD
                : pct < SLA_MET_THRESHOLD;
        }

        function toNumber(value) {
            var parsed = parseInt(value, 10);
            return isNaN(parsed) ? 0 : parsed;
        }

        // v. Application Status - a row is kept when it has applications in the chosen status.
        function matchesApplicationStatus(row) {
            var status = vm.clientFilter.applicationStatus;
            if (!status) {
                return true;
            }
            if (status === 'Received') {
                return toNumber(row.applied) > 0;
            }
            if (status === 'Approved') {
                return toNumber(row.cleared) > 0;
            }
            if (status === 'Rejected') {
                return toNumber(row.rejected) > 0;
            }
            return true;
        }

        /**
         * Colour band for the SLA Met % cell: green at or above 90, yellow from 75 to 89, red
         * below 75. Services with no measurable SLA (rtsDays not configured, or no cleared
         * application carrying both dates) show as NA and stay grey rather than being coloured
         * red, which would read as a bad score rather than an absent one.
         */
        vm.slaIndicatorClass = function (row) {
            var pct = parseFloat(row.slaMet);
            if (isNaN(pct)) {
                return 'sla-na';
            }
            if (pct >= SLA_GREEN_FROM) {
                return 'sla-green';
            }
            if (pct >= SLA_YELLOW_FROM) {
                return 'sla-yellow';
            }
            return 'sla-red';
        };

        vm.applyClientFilters = function () {
            if (!vm.deptservicedashboard) {
                vm.visibleDashboard = [];
                return;
            }
            vm.visibleDashboard = vm.deptservicedashboard.filter(function (row) {
                return matchesDepartment(row)
                    && matchesService(row)
                    && matchesSlaStatus(row)
                    && matchesApplicationStatus(row);
            });
        };

        /**
         * Drops blank entries before the call. Selecting "All Districts" sets the model to "", and
         * the server side check is `getDistrict() != null` - an empty string passes that check and
         * would narrow the query to a district named "", i.e. nothing at all.
         */
        function cleanFilter(filter) {
            var cleaned = {};
            angular.forEach(filter, function (value, key) {
                if (value !== null && value !== undefined && value !== '') {
                    cleaned[key] = value;
                }
            });
            return cleaned;
        }

        // iii. District (and Level) - the only round trip, because the server recomputes every
        // count for the chosen district instead of just hiding rows.
        vm.FilterWiseDat = function () {
            // Captured at request time, not read in the callback - the user is free to change the
            // dropdown again while the call is in flight, and the column must describe the rows
            // that actually came back.
            var requested = cleanFilter(vm.filter);
            vm.loading = true;
            EodbPublicDashboardByFilter.query(requested, function (result) {
                vm.hideClear = true;
                vm.appliedDistrict = requested.district || null;
                applyResult(result);
                vm.loading = false;
            }, function () {
                vm.loading = false;
            })
        };

        vm.clearFilter = function () {
            vm.filter = {};
            vm.clientFilter = {};
            vm.hideClear = false;
            loadAll();
        };

        // ---------------------------------------------------------------------------------
        // Export. Both formats write exactly what is on screen - the rows left after the
        // filters, in the same column order - so a download always matches what was seen.
        // ---------------------------------------------------------------------------------

        var EXPORT_HEADERS = ['Service', 'Department', 'District', 'Time Period',
            'Applications Received', 'Applications Approved', 'Applications Rejected',
            'SLA Met (%)', 'Average Time (Days)', 'Fees Collected (INR)', 'Feedback Score (1-5)'];

        function exportRows() {
            return (vm.visibleDashboard || []).map(function (row) {
                return [
                    row.service_name || '',
                    row.department_name || '',
                    vm.appliedDistrict || 'All Districts',
                    vm.timePeriod,
                    row.applied || '0',
                    row.cleared || '0',
                    row.rejected || '0',
                    row.slaMet || 'NA',
                    row.avgTime || 'NA',
                    row.feesCollected || 'NA',
                    row.feedbackScore || 'NA'
                ];
            });
        }

        function exportFileName(extension) {
            return 'EODB-Public-Dashboard-' + $filter('date')(new Date(), 'yyyy-MM-dd-HHmm') + '.' + extension;
        }

        vm.canExport = function () {
            return !vm.loading && vm.visibleDashboard && vm.visibleDashboard.length > 0;
        };

        function saveBlob(blob, filename) {
            // Older IE / Edge cannot follow a blob: href on an anchor.
            if (window.navigator && window.navigator.msSaveBlob) {
                window.navigator.msSaveBlob(blob, filename);
                return;
            }
            var url = window.URL.createObjectURL(blob);
            var link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        }

        // ---- xlsx writer -----------------------------------------------------------------
        // A .xlsx file is a ZIP of XML parts. There is no SheetJS or JSZip in this project, so
        // the few parts Excel needs are written here and stored (not deflated) into a ZIP, which
        // keeps this dependency free while still producing a genuine Excel workbook rather than a
        // CSV or an HTML table renamed .xls.

        function utf8Bytes(str) {
            var out = [], i, c, cp;
            for (i = 0; i < str.length; i++) {
                c = str.charCodeAt(i);
                if (c < 0x80) {
                    out.push(c);
                } else if (c < 0x800) {
                    out.push(0xC0 | (c >> 6), 0x80 | (c & 0x3F));
                } else if (c < 0xD800 || c >= 0xE000) {
                    out.push(0xE0 | (c >> 12), 0x80 | ((c >> 6) & 0x3F), 0x80 | (c & 0x3F));
                } else {
                    i++;
                    cp = 0x10000 + (((c & 0x3FF) << 10) | (str.charCodeAt(i) & 0x3FF));
                    out.push(0xF0 | (cp >> 18), 0x80 | ((cp >> 12) & 0x3F), 0x80 | ((cp >> 6) & 0x3F), 0x80 | (cp & 0x3F));
                }
            }
            return new Uint8Array(out);
        }

        var CRC_TABLE = null;
        function crc32(bytes) {
            if (!CRC_TABLE) {
                CRC_TABLE = [];
                for (var i = 0; i < 256; i++) {
                    var c = i;
                    for (var k = 0; k < 8; k++) {
                        c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1);
                    }
                    CRC_TABLE[i] = c >>> 0;
                }
            }
            var crc = 0xFFFFFFFF;
            for (var n = 0; n < bytes.length; n++) {
                crc = (crc >>> 8) ^ CRC_TABLE[(crc ^ bytes[n]) & 0xFF];
            }
            return (crc ^ 0xFFFFFFFF) >>> 0;
        }

        function zipStore(files) {
            var now = new Date();
            var dosTime = (now.getHours() << 11) | (now.getMinutes() << 5) | (Math.floor(now.getSeconds() / 2));
            var dosDate = ((now.getFullYear() - 1980) << 9) | ((now.getMonth() + 1) << 5) | now.getDate();
            var parts = [], central = [], offset = 0;
            files.forEach(function (file) {
                var nameBytes = utf8Bytes(file.name), crc = crc32(file.data), size = file.data.length;
                var local = new Uint8Array(30 + nameBytes.length), dv = new DataView(local.buffer);
                dv.setUint32(0, 0x04034b50, true); dv.setUint16(4, 20, true); dv.setUint16(6, 0x0800, true);
                dv.setUint16(8, 0, true); dv.setUint16(10, dosTime, true); dv.setUint16(12, dosDate, true);
                dv.setUint32(14, crc, true); dv.setUint32(18, size, true); dv.setUint32(22, size, true);
                dv.setUint16(26, nameBytes.length, true); dv.setUint16(28, 0, true);
                local.set(nameBytes, 30);
                parts.push(local, file.data);

                var cd = new Uint8Array(46 + nameBytes.length), cv = new DataView(cd.buffer);
                cv.setUint32(0, 0x02014b50, true); cv.setUint16(4, 20, true); cv.setUint16(6, 20, true);
                cv.setUint16(8, 0x0800, true); cv.setUint16(10, 0, true); cv.setUint16(12, dosTime, true);
                cv.setUint16(14, dosDate, true); cv.setUint32(16, crc, true);
                cv.setUint32(20, size, true); cv.setUint32(24, size, true);
                cv.setUint16(28, nameBytes.length, true); cv.setUint16(30, 0, true); cv.setUint16(32, 0, true);
                cv.setUint16(34, 0, true); cv.setUint16(36, 0, true); cv.setUint32(38, 0, true);
                cv.setUint32(42, offset, true);
                cd.set(nameBytes, 46);
                central.push(cd);

                offset += local.length + size;
            });
            var centralSize = central.reduce(function (n, c) { return n + c.length; }, 0);
            var end = new Uint8Array(22), ev = new DataView(end.buffer);
            ev.setUint32(0, 0x06054b50, true); ev.setUint16(8, files.length, true);
            ev.setUint16(10, files.length, true); ev.setUint32(12, centralSize, true);
            ev.setUint32(16, offset, true); ev.setUint16(20, 0, true);
            return new Blob(parts.concat(central).concat([end]),
                { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        }

        function xmlEscape(value) {
            return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;').replace(/'/g, '&apos;');
        }

        function columnName(index) {
            var name = '';
            while (index > 0) {
                var rem = (index - 1) % 26;
                name = String.fromCharCode(65 + rem) + name;
                index = Math.floor((index - 1) / 26);
            }
            return name;
        }

        // Written as a real number so Excel can sort and total the column. "NA" stays text.
        function isNumericCell(value) {
            return value !== '' && value !== null && value !== undefined && /^-?\d+(\.\d+)?$/.test(String(value));
        }

        function buildSheetXml(headers, rows, slaColumnIndex) {
            var xml = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
                '<worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">' +
                '<cols><col min="1" max="1" width="42"/><col min="2" max="2" width="34"/>' +
                '<col min="3" max="3" width="16"/><col min="4" max="4" width="20"/>' +
                '<col min="5" max="11" width="15"/></cols><sheetData>';
            xml += '<row r="1">';
            headers.forEach(function (header, i) {
                xml += '<c r="' + columnName(i + 1) + '1" t="inlineStr" s="1"><is><t>' + xmlEscape(header) + '</t></is></c>';
            });
            xml += '</row>';
            rows.forEach(function (row, r) {
                var rowNumber = r + 2;
                xml += '<row r="' + rowNumber + '">';
                row.forEach(function (cell, i) {
                    var ref = columnName(i + 1) + rowNumber, style = 0;
                    if (i === slaColumnIndex) {
                        var pct = parseFloat(cell);
                        if (!isNaN(pct)) {
                            style = pct >= SLA_GREEN_FROM ? 2 : (pct >= SLA_YELLOW_FROM ? 3 : 4);
                        }
                    }
                    var styleAttr = style ? ' s="' + style + '"' : '';
                    if (isNumericCell(cell)) {
                        xml += '<c r="' + ref + '"' + styleAttr + '><v>' + cell + '</v></c>';
                    } else {
                        xml += '<c r="' + ref + '" t="inlineStr"' + styleAttr + '><is><t>' + xmlEscape(cell) + '</t></is></c>';
                    }
                });
                xml += '</row>';
            });
            return xml + '</sheetData></worksheet>';
        }

        // Style 1 = header, 2/3/4 = the green / yellow / red SLA bands.
        var XLSX_STYLES = '<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
            '<styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">' +
            '<fonts count="2"><font><sz val="11"/><name val="Calibri"/></font>' +
            '<font><b/><color rgb="FFFFFFFF"/><sz val="11"/><name val="Calibri"/></font></fonts>' +
            '<fills count="6"><fill><patternFill patternType="none"/></fill>' +
            '<fill><patternFill patternType="gray125"/></fill>' +
            '<fill><patternFill patternType="solid"><fgColor rgb="FF7B4CAF"/><bgColor indexed="64"/></patternFill></fill>' +
            '<fill><patternFill patternType="solid"><fgColor rgb="FFD4EDDA"/><bgColor indexed="64"/></patternFill></fill>' +
            '<fill><patternFill patternType="solid"><fgColor rgb="FFFFF3CD"/><bgColor indexed="64"/></patternFill></fill>' +
            '<fill><patternFill patternType="solid"><fgColor rgb="FFF8D7DA"/><bgColor indexed="64"/></patternFill></fill></fills>' +
            '<borders count="1"><border><left/><right/><top/><bottom/><diagonal/></border></borders>' +
            '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs>' +
            '<cellXfs count="5">' +
            '<xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>' +
            '<xf numFmtId="0" fontId="1" fillId="2" borderId="0" xfId="0" applyFont="1" applyFill="1"/>' +
            '<xf numFmtId="0" fontId="0" fillId="3" borderId="0" xfId="0" applyFill="1"/>' +
            '<xf numFmtId="0" fontId="0" fillId="4" borderId="0" xfId="0" applyFill="1"/>' +
            '<xf numFmtId="0" fontId="0" fillId="5" borderId="0" xfId="0" applyFill="1"/>' +
            '</cellXfs>' +
            '<cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>' +
            '</styleSheet>';

        /**
         * Downloads the rows currently on screen as a real .xlsx workbook.
         */
        vm.exportExcel = function () {
            if (!vm.canExport()) {
                return;
            }
            var sheetXml = buildSheetXml(EXPORT_HEADERS, exportRows(), 7);
            var files = [
                { name: '[Content_Types].xml', data: utf8Bytes('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
                    '<Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types">' +
                    '<Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/>' +
                    '<Default Extension="xml" ContentType="application/xml"/>' +
                    '<Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/>' +
                    '<Override PartName="/xl/worksheets/sheet1.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>' +
                    '<Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>' +
                    '</Types>') },
                { name: '_rels/.rels', data: utf8Bytes('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
                    '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
                    '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/>' +
                    '</Relationships>') },
                { name: 'xl/workbook.xml', data: utf8Bytes('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
                    '<workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">' +
                    '<sheets><sheet name="EODB Dashboard" sheetId="1" r:id="rId1"/></sheets></workbook>') },
                { name: 'xl/_rels/workbook.xml.rels', data: utf8Bytes('<?xml version="1.0" encoding="UTF-8" standalone="yes"?>' +
                    '<Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">' +
                    '<Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet1.xml"/>' +
                    '<Relationship Id="rId2" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/>' +
                    '</Relationships>') },
                { name: 'xl/styles.xml', data: utf8Bytes(XLSX_STYLES) },
                { name: 'xl/worksheets/sheet1.xml', data: utf8Bytes(sheetXml) }
            ];
            saveBlob(zipStore(files), exportFileName('xlsx'));
        };

        /**
         * PDF via the jsPDF autoTable plugin already bundled in index.html. Landscape, because
         * eleven columns do not fit portrait, and the SLA cells keep their colour bands.
         */
        vm.exportPdf = function () {
            if (!vm.canExport()) {
                return;
            }
            var rows = exportRows();
            var margin = 24;
            var doc = new window.jspdf.jsPDF({ unit: 'pt', format: 'a4', orientation: 'landscape' });
            var pageWidth = doc.internal.pageSize.getWidth();

            doc.setFontSize(14);
            doc.setFont(undefined, 'bold');
            doc.text('EODB PUBLIC DASHBOARD', margin, margin + 6);

            doc.setFont(undefined, 'normal');
            doc.setFontSize(9);
            doc.text('Time Period: ' + vm.timePeriod
                + '   |   District: ' + (vm.appliedDistrict || 'All Districts')
                + '   |   Services: ' + rows.length,
                margin, margin + 22);
            doc.text('Generated on ' + $filter('date')(new Date(), 'dd/MM/yyyy HH:mm'),
                pageWidth - margin, margin + 22, { align: 'right' });

            doc.autoTable({
                startY: margin + 34,
                margin: { top: margin, right: margin, bottom: margin, left: margin },
                head: [EXPORT_HEADERS],
                body: rows,
                styles: { fontSize: 7, cellPadding: 3, overflow: 'linebreak', valign: 'middle' },
                headStyles: { fillColor: [123, 76, 175], textColor: 255, fontSize: 7 },
                columnStyles: {
                    0: { cellWidth: 118 },
                    1: { cellWidth: 92 },
                    3: { cellWidth: 68 }
                },
                // Carry the on screen SLA colour bands into the PDF.
                didParseCell: function (data) {
                    if (data.section !== 'body' || data.column.index !== 7) {
                        return;
                    }
                    var pct = parseFloat(data.cell.raw);
                    if (isNaN(pct)) {
                        return;
                    }
                    if (pct >= SLA_GREEN_FROM) {
                        data.cell.styles.fillColor = [212, 237, 218];
                    } else if (pct >= SLA_YELLOW_FROM) {
                        data.cell.styles.fillColor = [255, 243, 205];
                    } else {
                        data.cell.styles.fillColor = [248, 215, 218];
                    }
                }
            });

            var pageCount = doc.internal.getNumberOfPages();
            for (var page = 1; page <= pageCount; page++) {
                doc.setPage(page);
                doc.setFontSize(8);
                doc.text('Page ' + page + ' of ' + pageCount,
                    pageWidth - margin, doc.internal.pageSize.getHeight() - 12, { align: 'right' });
            }
            doc.save(exportFileName('pdf'));
        };

        vm.hasAnyFilter = function () {
            return !!(vm.filter.district || vm.filter.projectLevel
                || vm.clientFilter.departmentName || vm.clientFilter.serviceName
                || vm.clientFilter.slaStatus || vm.clientFilter.applicationStatus);
        };
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EodbViewCafYearlyByElastic', EodbViewCafYearlyByElastic);

    EodbViewCafYearlyByElastic.$inject = ['$resource'];

    function EodbViewCafYearlyByElastic ($resource) {
        var resourceUrl =  'api/eodbdashboardcafsYearlyByElastic/departmentName/district/projectLevel/serviceId/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EodbViewCafYearly', EodbViewCafYearly);

    EodbViewCafYearly.$inject = ['$resource'];

    function EodbViewCafYearly ($resource) {
        var resourceUrl =  'api/servicedashboardcafsYearly/:serviceid/:status/:department/:servicename';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('EodbViewCafYearlyController', EodbViewCafYearlyController);

    EodbViewCafYearlyController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'ServiceViewCafYearly', 'TowerserviceNO','EodbViewCafYearlyByElastic'];
    function EodbViewCafYearlyController ($timeout, $scope, $stateParams, $uibModalInstance, ServiceViewCafYearly, TowerserviceNO, EodbViewCafYearlyByElastic) {
        var vm = this;

        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";
        vm.clear = clear;
        vm.servicename=$stateParams.servicename;
        vm.status=$stateParams.status;
        vm.serviceid=$stateParams.serviceid;
        var initDate=new Date('05-01-2017');
        var totalTime=0;
        var totalCleared=0;
        vm.showDepartments=showDepartments;
        vm.departmentName=[];
        // vm.downloadAllData = downloadAllData;

        vm.spiner= true;

        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
            /*appliedDate=new Date(result[i].appliedDate.toDateString());
            clearedDate=new Date(result[i].clearedDate.toDateString());
            dayDiff= (clearedDate - appliedDate)  / 1000 / 60 / 60 / 24;
*/
        loadAllCafs();
        function loadAllCafs() {
            var appliedDate;
            var clearedDate;
            var dayDiff;
            if (!$stateParams.departmentName) {
                vm.deptName = null;
            } else {
                vm.deptName = $stateParams.departmentName;
            }

            if (!$stateParams.district) {
                vm.districtName = null;
            } else {
                vm.districtName = $stateParams.district;
            }

            if (!$stateParams.projectLevel) {
                vm.levelfiled = null;
            } else {
                vm.levelfiled = $stateParams.projectLevel;
            }
            var data = {
                departmentName: vm.deptName,
                district: vm.districtName,
                projectLevel: vm.levelfiled,
                serviceId: $stateParams.serviceid,
                status: $stateParams.status,
                page: $scope.currentPage - 1,
                size: $scope.pageSize
            };
            Object.keys(data).forEach(function (k) {
                if (!data[k] && data[k] !== undefined) {
                    delete data[k];
                }
            });

            //   vm.dashboardcafs=ServiceViewCafYearly.query({serviceid:$stateParams.serviceid,status:$stateParams.status},function(result){
            //     vm.show=true;
            //     vm.spiner=false;
            //     console.log(result);
            // });
            vm.dashboardcafs = EodbViewCafYearlyByElastic.get(data,
                function (result) {
                vm.show = true;
                vm.spiner = false;
            });
        }

        // function downloadAllData() {
        //     EodbDownloadServiceViewCafYearlyByElastic.query({
        //             departmentName: vm.deptName,
        //             district: vm.districtName,
        //             projectLevel: vm.levelfiled,
        //             serviceId: $stateParams.serviceid,
        //             status: $stateParams.status
        //         },function (result) {
        //         EodbDownloadCafCsv.download(result[0].status).then(function (success) {
        //             console.log(success);
        //         }, function (error) {
        //             alert('error : ' + error);
        //         });
        //     });
        // }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        }

        $scope.pageChangedHandler = function(num) {
            loadAllCafs();
        };

        function showDepartments(data) {
            TowerserviceNO.query({id:'1',projectdetailid:data.projectdetailid},function (result) {
                if(result.length===0){
                    vm.departmentName=[];
                    vm.departmentName[0] = "NA";
                }
                else {
                    vm.departmentName = result;
                }
            });

        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EodbDownloadServiceViewCafYearlyByElastic', EodbDownloadServiceViewCafYearlyByElastic);

    EodbDownloadServiceViewCafYearlyByElastic.$inject = ['$resource'];

    function EodbDownloadServiceViewCafYearlyByElastic ($resource) {
        var resourceUrl =  'api/servicedashboardcafsYearlyListByElastic/departmentName/district/projectLevel/serviceId/status';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EodbDownloadCafCsv', ['$q', '$timeout', '$window',
            function($q, $timeout, $window, $http) {
                return {
                    download: function(serverfilename) {
                        var defer = $q.defer();
                        $timeout(function() {
                            $window.location = 'api/downloadcafattachment?serverfilename='+serverfilename;
                        }, 1000)
                            .then(function() {
                                defer.resolve('success');
                            }, function() {
                                defer.reject('error');
                            });
                        return defer.promise;
                    }
                };
            }
        ]);
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EodbDashboardYearlyByElatsic', EodbDashboardYearlyByElatsic);

    EodbDashboardYearlyByElatsic.$inject = ['$resource'];

    function EodbDashboardYearlyByElatsic ($resource) {
        var resourceUrl =  'api/eodb-dashboard-statsYearly-elastic';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EodbDashboardYearlyByFilter', EodbDashboardYearlyByFilter);

    EodbDashboardYearlyByFilter.$inject = ['$resource'];

    function EodbDashboardYearlyByFilter ($resource) {
        var resourceUrl =  'api/eodb-dashboard-statsYearly-filters/departmentName/district/projectLevel';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('eodbdashboardyearly', {
            parent: 'app',
            url: '/service-dashboard-yearly',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/eodbdashboardyearly/eodbdashboardyearly.html',
                    controller: 'EodbDashboardYearlyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        }).state('eodbdashboardyearlycafs', {
            parent: 'eodbdashboardyearly',
            url: '/eodb-dashboard-yearly/{servicename}/{departmentName}/{district}/{projectLevel}/{serviceid}/{status}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/eodbdashboardyearly/eodbviewcafsyearly.html',
                    controller: 'EodbViewCafYearlyController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('eodbdashboardyearly', null, { reload: 'eodbdashboardyearly' });
                }, function() {
                    $state.go('eodbdashboardyearly');
                });
            }]
        });
    }
})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EodbDashboardYearlyController', EodbDashboardYearlyController);

    EodbDashboardYearlyController.$inject = ['$scope','$filter', 'Principal', 'LoginService', '$state', 'DeptServiceDashboard', 'DeptServiceStats','ServiceViewCaf','ServiceDashboardStats' ,'EodbDashboardYearlyByElatsic','District','EodbDashboardYearlyByFilter'];

    function EodbDashboardYearlyController ($scope,$filter, Principal, LoginService, $state, DeptServiceDashboard, DeptServiceStats, ServiceViewCaf, ServiceDashboardStats ,EodbDashboardYearlyByElatsic,District,EodbDashboardYearlyByFilter) {
        var vm = this;
        vm.account = null;
        vm.districts = [];
        vm.departments =[];
        vm.filter = {};
        vm.deptName = null;
        vm.districtName = null;
        vm.levelfiled = null;
        vm.hideClear = false;
        $scope.CurrentDate = new Date();

        // Time Period shown in the summary table. The EODB dataset covers services
        // applied on/after 01-January-2022 (see the note in the page header), so the
        // period runs from that date up to the current month.
        vm.dataStartDate = new Date(2022, 0, 1);
        vm.timePeriod = $filter('date')(vm.dataStartDate, 'MMM yyyy') + ' - ' + $filter('date')($scope.CurrentDate, 'MMM yyyy');

        loadAll();
        function loadAll() {
        Principal.identity().then(function(account) {
            vm.account = account;
        });

        District.query(function(result) {
            vm.districts = result;
            vm.searchQuery = null;
        });


        // ServiceDashboardStats.query(function(result) {
            EodbDashboardYearlyByElatsic.query(function(result) {
          vm.deptservicedashboard = result;
           vm.totalappliedservices=0;
           vm.totalrequiredservices=0;
           vm.totalpendingservices=0;
           vm.totalcompletedservices=0;
           vm.totalrejectedservices=0;
            for(var i=0;i<vm.deptservicedashboard.length;i++)
            {
              vm.totalappliedservices=vm.totalappliedservices + parseInt(vm.deptservicedashboard[i].applied);
              vm.totalrequiredservices=vm.totalrequiredservices+ parseInt(vm.deptservicedashboard[i].required);
              vm.totalpendingservices=vm.totalpendingservices+ parseInt(vm.deptservicedashboard[i].pending_total);
              vm.totalcompletedservices=vm.totalcompletedservices+ parseInt(vm.deptservicedashboard[i].cleared);
              vm.totalrejectedservices=vm.totalrejectedservices+ parseInt(vm.deptservicedashboard[i].rejected);
            }
           vm.searchQuery = null;
                vm.departments = [];

                angular.forEach(vm.deptservicedashboard, function(value, key){
                    if(vm.departments.indexOf(value.department_name) === -1){
                        if(value.department_name != "Communication and Connectivity Permissions"){
                            vm.departments.push(value.department_name);
                        }
                    }
                });
         });
        }

        vm.FilterWiseDat = function () {
            EodbDashboardYearlyByFilter.query(vm.filter,function (result) {
                vm.hideClear = true;
                vm.deptservicedashboard =result;
            })
        };
        vm.clearFilter = function () {
            vm.filter ={};
            loadAll();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('eodb-notifications', {
            parent: 'app',
            url: '/eodb-notifications',
            data: {
                authorities: [],
                pageTitle: 'global.menu.eodb'
            },
            views: {
                'content@': {
                    templateUrl: 'app/eodb-notifications/eodb-notifications.html',
                    controller: 'EodbNotificationsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eodb-notifications');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('EodbNotificationsService', EodbNotificationsService);

    EodbNotificationsService.$inject = ['$resource'];

    function EodbNotificationsService($resource) {
        var service = {
            getOrdinalIndicator: getOrdinalIndicator
        };

        return service;

        function getOrdinalIndicator(n) {

            if (n || n === 0) {

                if (hasANonGenericOrdinalIndicator(n)) {
                    return 'th';
                }

                var decimal = n % 10;
                switch (decimal) {
                    case 1:
                        return 'st';
                        break;
                    case 2:
                        return 'nd';
                        break;
                    case 3:
                        return 'rd';
                        break;
                    default:
                        return 'th';
                        break;
                }
            }

            return '';
        }

        function hasANonGenericOrdinalIndicator(n) {
            var lastTwoDigits = n % 100;
            return lastTwoDigits > 10 && lastTwoDigits < 14;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EodbNotificationsController', EodbNotificationsController);

    EodbNotificationsController.$inject = ['$scope', 'EodbNotificationsService'];

    function EodbNotificationsController($scope, EodbNotificationsService) {
        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('eodb', {
            parent: 'app',
            url: '/eodb',
            data: {
                authorities: [],
                pageTitle: 'global.menu.eodb'
            },
            views: {
                'content@': {
                    templateUrl: 'app/eodb/eodb.html',
                    controller: 'EodbController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('eodb');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('EodbService', EodbService);

    EodbService.$inject = ['$resource'];

    function EodbService($resource) {
        var service = {
            getOrdinalIndicator: getOrdinalIndicator
        };

        return service;

        function getOrdinalIndicator(n) {

            if (n || n === 0) {

                if (hasANonGenericOrdinalIndicator(n)) {
                    return 'th';
                }

                var decimal = n % 10;
                switch (decimal) {
                    case 1:
                        return 'st';
                        break;
                    case 2:
                        return 'nd';
                        break;
                    case 3:
                        return 'rd';
                        break;
                    default:
                        return 'th';
                        break;
                }
            }

            return '';
        }

        function hasANonGenericOrdinalIndicator(n) {
            var lastTwoDigits = n % 100;
            return lastTwoDigits > 10 && lastTwoDigits < 14;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EodbController', EodbController);

    EodbController.$inject = ['$scope', 'EodbService'];

    function EodbController($scope, EodbService) {
        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ZoneDialogController', ZoneDialogController);

    ZoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Zone'];

    function ZoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Zone) {
        var vm = this;

        vm.zone = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.zone.id !== null) {
                Zone.update(vm.zone, onSaveSuccess, onSaveError);
            } else {
                Zone.save(vm.zone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:zoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ZoneDetailController', ZoneDetailController);

    ZoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Zone'];

    function ZoneDetailController($scope, $rootScope, $stateParams, previousState, entity, Zone) {
        var vm = this;

        vm.zone = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:zoneUpdate', function(event, result) {
            vm.zone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ZoneDeleteController',ZoneDeleteController);

    ZoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Zone'];

    function ZoneDeleteController($uibModalInstance, entity, Zone) {
        var vm = this;

        vm.zone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Zone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('zone', {
            parent: 'entity',
            url: '/zone',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.zone.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zone/zones.html',
                    controller: 'ZoneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zone');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('zone-detail', {
            parent: 'zone',
            url: '/zone/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.zone.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/zone/zone-detail.html',
                    controller: 'ZoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('zone');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Zone', function($stateParams, Zone) {
                    return Zone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'zone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('zone-detail.edit', {
            parent: 'zone-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-dialog.html',
                    controller: 'ZoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zone', function(Zone) {
                            return Zone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zone.new', {
            parent: 'zone',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-dialog.html',
                    controller: 'ZoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                zone_name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('zone', null, { reload: 'zone' });
                }, function() {
                    $state.go('zone');
                });
            }]
        })
        .state('zone.edit', {
            parent: 'zone',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-dialog.html',
                    controller: 'ZoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Zone', function(Zone) {
                            return Zone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zone', null, { reload: 'zone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('zone.delete', {
            parent: 'zone',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/zone/zone-delete-dialog.html',
                    controller: 'ZoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Zone', function(Zone) {
                            return Zone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('zone', null, { reload: 'zone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Zone', Zone);

    Zone.$inject = ['$resource'];

    function Zone ($resource) {
        var resourceUrl =  'api/zones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ZoneController', ZoneController);

    ZoneController.$inject = ['Zone'];

    function ZoneController(Zone) {

        var vm = this;

        vm.zones = [];

        loadAll();

        function loadAll() {
            Zone.query(function(result) {
                vm.zones = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmenttwoDialogController', WwtreatmenttwoDialogController);

    WwtreatmenttwoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Wwtreatmenttwo'];

    function WwtreatmenttwoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Wwtreatmenttwo) {
        var vm = this;

        vm.wwtreatmenttwo = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.wwtreatmenttwo.id !== null) {
                Wwtreatmenttwo.update(vm.wwtreatmenttwo, onSaveSuccess, onSaveError);
            } else {
                Wwtreatmenttwo.save(vm.wwtreatmenttwo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:wwtreatmenttwoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmenttwoDetailController', WwtreatmenttwoDetailController);

    WwtreatmenttwoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Wwtreatmenttwo'];

    function WwtreatmenttwoDetailController($scope, $rootScope, $stateParams, previousState, entity, Wwtreatmenttwo) {
        var vm = this;

        vm.wwtreatmenttwo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:wwtreatmenttwoUpdate', function(event, result) {
            vm.wwtreatmenttwo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmenttwoDeleteController',WwtreatmenttwoDeleteController);

    WwtreatmenttwoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Wwtreatmenttwo'];

    function WwtreatmenttwoDeleteController($uibModalInstance, entity, Wwtreatmenttwo) {
        var vm = this;

        vm.wwtreatmenttwo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Wwtreatmenttwo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('wwtreatmenttwo', {
            parent: 'entity',
            url: '/wwtreatmenttwo',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.wwtreatmenttwo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/wwtreatmenttwo/wwtreatmenttwos.html',
                    controller: 'WwtreatmenttwoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('wwtreatmenttwo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('wwtreatmenttwo-detail', {
            parent: 'wwtreatmenttwo',
            url: '/wwtreatmenttwo/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.wwtreatmenttwo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/wwtreatmenttwo/wwtreatmenttwo-detail.html',
                    controller: 'WwtreatmenttwoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('wwtreatmenttwo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Wwtreatmenttwo', function($stateParams, Wwtreatmenttwo) {
                    return Wwtreatmenttwo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'wwtreatmenttwo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('wwtreatmenttwo-detail.edit', {
            parent: 'wwtreatmenttwo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmenttwo/wwtreatmenttwo-dialog.html',
                    controller: 'WwtreatmenttwoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Wwtreatmenttwo', function(Wwtreatmenttwo) {
                            return Wwtreatmenttwo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('wwtreatmenttwo.new', {
            parent: 'wwtreatmenttwo',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmenttwo/wwtreatmenttwo-dialog.html',
                    controller: 'WwtreatmenttwoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                treatment2: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('wwtreatmenttwo', null, { reload: 'wwtreatmenttwo' });
                }, function() {
                    $state.go('wwtreatmenttwo');
                });
            }]
        })
        .state('wwtreatmenttwo.edit', {
            parent: 'wwtreatmenttwo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmenttwo/wwtreatmenttwo-dialog.html',
                    controller: 'WwtreatmenttwoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Wwtreatmenttwo', function(Wwtreatmenttwo) {
                            return Wwtreatmenttwo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('wwtreatmenttwo', null, { reload: 'wwtreatmenttwo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('wwtreatmenttwo.delete', {
            parent: 'wwtreatmenttwo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmenttwo/wwtreatmenttwo-delete-dialog.html',
                    controller: 'WwtreatmenttwoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Wwtreatmenttwo', function(Wwtreatmenttwo) {
                            return Wwtreatmenttwo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('wwtreatmenttwo', null, { reload: 'wwtreatmenttwo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Wwtreatmenttwo', Wwtreatmenttwo);

    Wwtreatmenttwo.$inject = ['$resource'];

    function Wwtreatmenttwo ($resource) {
        var resourceUrl =  'api/wwtreatmenttwos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmenttwoController', WwtreatmenttwoController);

    WwtreatmenttwoController.$inject = ['Wwtreatmenttwo'];

    function WwtreatmenttwoController(Wwtreatmenttwo) {

        var vm = this;

        vm.wwtreatmenttwos = [];

        loadAll();

        function loadAll() {
            Wwtreatmenttwo.query(function(result) {
                vm.wwtreatmenttwos = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmentthreeDialogController', WwtreatmentthreeDialogController);

    WwtreatmentthreeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Wwtreatmentthree'];

    function WwtreatmentthreeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Wwtreatmentthree) {
        var vm = this;

        vm.wwtreatmentthree = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.wwtreatmentthree.id !== null) {
                Wwtreatmentthree.update(vm.wwtreatmentthree, onSaveSuccess, onSaveError);
            } else {
                Wwtreatmentthree.save(vm.wwtreatmentthree, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:wwtreatmentthreeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmentthreeDetailController', WwtreatmentthreeDetailController);

    WwtreatmentthreeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Wwtreatmentthree'];

    function WwtreatmentthreeDetailController($scope, $rootScope, $stateParams, previousState, entity, Wwtreatmentthree) {
        var vm = this;

        vm.wwtreatmentthree = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:wwtreatmentthreeUpdate', function(event, result) {
            vm.wwtreatmentthree = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmentthreeDeleteController',WwtreatmentthreeDeleteController);

    WwtreatmentthreeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Wwtreatmentthree'];

    function WwtreatmentthreeDeleteController($uibModalInstance, entity, Wwtreatmentthree) {
        var vm = this;

        vm.wwtreatmentthree = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Wwtreatmentthree.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('wwtreatmentthree', {
            parent: 'entity',
            url: '/wwtreatmentthree',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.wwtreatmentthree.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/wwtreatmentthree/wwtreatmentthrees.html',
                    controller: 'WwtreatmentthreeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('wwtreatmentthree');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('wwtreatmentthree-detail', {
            parent: 'wwtreatmentthree',
            url: '/wwtreatmentthree/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.wwtreatmentthree.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/wwtreatmentthree/wwtreatmentthree-detail.html',
                    controller: 'WwtreatmentthreeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('wwtreatmentthree');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Wwtreatmentthree', function($stateParams, Wwtreatmentthree) {
                    return Wwtreatmentthree.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'wwtreatmentthree',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('wwtreatmentthree-detail.edit', {
            parent: 'wwtreatmentthree-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmentthree/wwtreatmentthree-dialog.html',
                    controller: 'WwtreatmentthreeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Wwtreatmentthree', function(Wwtreatmentthree) {
                            return Wwtreatmentthree.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('wwtreatmentthree.new', {
            parent: 'wwtreatmentthree',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmentthree/wwtreatmentthree-dialog.html',
                    controller: 'WwtreatmentthreeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                treatment3: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('wwtreatmentthree', null, { reload: 'wwtreatmentthree' });
                }, function() {
                    $state.go('wwtreatmentthree');
                });
            }]
        })
        .state('wwtreatmentthree.edit', {
            parent: 'wwtreatmentthree',
            url: '{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmentthree/wwtreatmentthree-dialog.html',
                    controller: 'WwtreatmentthreeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Wwtreatmentthree', function(Wwtreatmentthree) {
                            return Wwtreatmentthree.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('wwtreatmentthree', null, { reload: 'wwtreatmentthree' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('wwtreatmentthree.delete', {
            parent: 'wwtreatmentthree',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmentthree/wwtreatmentthree-delete-dialog.html',
                    controller: 'WwtreatmentthreeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Wwtreatmentthree', function(Wwtreatmentthree) {
                            return Wwtreatmentthree.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('wwtreatmentthree', null, { reload: 'wwtreatmentthree' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Wwtreatmentthree', Wwtreatmentthree);

    Wwtreatmentthree.$inject = ['$resource'];

    function Wwtreatmentthree ($resource) {
        var resourceUrl =  'api/wwtreatmentthrees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmentthreeController', WwtreatmentthreeController);

    WwtreatmentthreeController.$inject = ['Wwtreatmentthree'];

    function WwtreatmentthreeController(Wwtreatmentthree) {

        var vm = this;

        vm.wwtreatmentthrees = [];

        loadAll();

        function loadAll() {
            Wwtreatmentthree.query(function(result) {
                vm.wwtreatmentthrees = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmentoneDialogController', WwtreatmentoneDialogController);

    WwtreatmentoneDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Wwtreatmentone'];

    function WwtreatmentoneDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Wwtreatmentone) {
        var vm = this;

        vm.wwtreatmentone = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.wwtreatmentone.id !== null) {
                Wwtreatmentone.update(vm.wwtreatmentone, onSaveSuccess, onSaveError);
            } else {
                Wwtreatmentone.save(vm.wwtreatmentone, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:wwtreatmentoneUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmentoneDetailController', WwtreatmentoneDetailController);

    WwtreatmentoneDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Wwtreatmentone'];

    function WwtreatmentoneDetailController($scope, $rootScope, $stateParams, previousState, entity, Wwtreatmentone) {
        var vm = this;

        vm.wwtreatmentone = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:wwtreatmentoneUpdate', function(event, result) {
            vm.wwtreatmentone = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmentoneDeleteController',WwtreatmentoneDeleteController);

    WwtreatmentoneDeleteController.$inject = ['$uibModalInstance', 'entity', 'Wwtreatmentone'];

    function WwtreatmentoneDeleteController($uibModalInstance, entity, Wwtreatmentone) {
        var vm = this;

        vm.wwtreatmentone = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Wwtreatmentone.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('wwtreatmentone', {
            parent: 'entity',
            url: '/wwtreatmentone',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.wwtreatmentone.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/wwtreatmentone/wwtreatmentones.html',
                    controller: 'WwtreatmentoneController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('wwtreatmentone');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('wwtreatmentone-detail', {
            parent: 'wwtreatmentone',
            url: '/wwtreatmentone/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.wwtreatmentone.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/wwtreatmentone/wwtreatmentone-detail.html',
                    controller: 'WwtreatmentoneDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('wwtreatmentone');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Wwtreatmentone', function($stateParams, Wwtreatmentone) {
                    return Wwtreatmentone.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'wwtreatmentone',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('wwtreatmentone-detail.edit', {
            parent: 'wwtreatmentone-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmentone/wwtreatmentone-dialog.html',
                    controller: 'WwtreatmentoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Wwtreatmentone', function(Wwtreatmentone) {
                            return Wwtreatmentone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('wwtreatmentone.new', {
            parent: 'wwtreatmentone',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmentone/wwtreatmentone-dialog.html',
                    controller: 'WwtreatmentoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                treatment1: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('wwtreatmentone', null, { reload: 'wwtreatmentone' });
                }, function() {
                    $state.go('wwtreatmentone');
                });
            }]
        })
        .state('wwtreatmentone.edit', {
            parent: 'wwtreatmentone',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmentone/wwtreatmentone-dialog.html',
                    controller: 'WwtreatmentoneDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Wwtreatmentone', function(Wwtreatmentone) {
                            return Wwtreatmentone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('wwtreatmentone', null, { reload: 'wwtreatmentone' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('wwtreatmentone.delete', {
            parent: 'wwtreatmentone',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wwtreatmentone/wwtreatmentone-delete-dialog.html',
                    controller: 'WwtreatmentoneDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Wwtreatmentone', function(Wwtreatmentone) {
                            return Wwtreatmentone.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('wwtreatmentone', null, { reload: 'wwtreatmentone' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Wwtreatmentone', Wwtreatmentone);

    Wwtreatmentone.$inject = ['$resource'];

    function Wwtreatmentone ($resource) {
        var resourceUrl =  'api/wwtreatmentones/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WwtreatmentoneController', WwtreatmentoneController);

    WwtreatmentoneController.$inject = ['Wwtreatmentone'];

    function WwtreatmentoneController(Wwtreatmentone) {

        var vm = this;

        vm.wwtreatmentones = [];

        loadAll();

        function loadAll() {
            Wwtreatmentone.query(function(result) {
                vm.wwtreatmentones = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WatersupplysourceDialogController', WatersupplysourceDialogController);

    WatersupplysourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Watersupplysource'];

    function WatersupplysourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Watersupplysource) {
        var vm = this;

        vm.watersupplysource = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.watersupplysource.id !== null) {
                Watersupplysource.update(vm.watersupplysource, onSaveSuccess, onSaveError);
            } else {
                Watersupplysource.save(vm.watersupplysource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:watersupplysourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WatersupplysourceDetailController', WatersupplysourceDetailController);

    WatersupplysourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Watersupplysource'];

    function WatersupplysourceDetailController($scope, $rootScope, $stateParams, previousState, entity, Watersupplysource) {
        var vm = this;

        vm.watersupplysource = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:watersupplysourceUpdate', function(event, result) {
            vm.watersupplysource = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WatersupplysourceDeleteController',WatersupplysourceDeleteController);

    WatersupplysourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Watersupplysource'];

    function WatersupplysourceDeleteController($uibModalInstance, entity, Watersupplysource) {
        var vm = this;

        vm.watersupplysource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Watersupplysource.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('watersupplysource', {
            parent: 'entity',
            url: '/watersupplysource',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.watersupplysource.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/watersupplysource/watersupplysources.html',
                    controller: 'WatersupplysourceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('watersupplysource');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('watersupplysource-detail', {
            parent: 'watersupplysource',
            url: '/watersupplysource/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.watersupplysource.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/watersupplysource/watersupplysource-detail.html',
                    controller: 'WatersupplysourceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('watersupplysource');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Watersupplysource', function($stateParams, Watersupplysource) {
                    return Watersupplysource.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'watersupplysource',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('watersupplysource-detail.edit', {
            parent: 'watersupplysource-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/watersupplysource/watersupplysource-dialog.html',
                    controller: 'WatersupplysourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Watersupplysource', function(Watersupplysource) {
                            return Watersupplysource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('watersupplysource.new', {
            parent: 'watersupplysource',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/watersupplysource/watersupplysource-dialog.html',
                    controller: 'WatersupplysourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                watersupplysourcetype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('watersupplysource', null, { reload: 'watersupplysource' });
                }, function() {
                    $state.go('watersupplysource');
                });
            }]
        })
        .state('watersupplysource.edit', {
            parent: 'watersupplysource',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/watersupplysource/watersupplysource-dialog.html',
                    controller: 'WatersupplysourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Watersupplysource', function(Watersupplysource) {
                            return Watersupplysource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('watersupplysource', null, { reload: 'watersupplysource' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('watersupplysource.delete', {
            parent: 'watersupplysource',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/watersupplysource/watersupplysource-delete-dialog.html',
                    controller: 'WatersupplysourceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Watersupplysource', function(Watersupplysource) {
                            return Watersupplysource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('watersupplysource', null, { reload: 'watersupplysource' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Watersupplysource', Watersupplysource);

    Watersupplysource.$inject = ['$resource'];

    function Watersupplysource ($resource) {
        var resourceUrl =  'api/watersupplysources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WatersupplysourceController', WatersupplysourceController);

    WatersupplysourceController.$inject = ['Watersupplysource'];

    function WatersupplysourceController(Watersupplysource) {

        var vm = this;

        vm.watersupplysources = [];

        loadAll();

        function loadAll() {
            Watersupplysource.query(function(result) {
                vm.watersupplysources = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WastewaterdetailDialogController', WastewaterdetailDialogController);

    WastewaterdetailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Wastewaterdetail'];

    function WastewaterdetailDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Wastewaterdetail) {
        var vm = this;

        vm.wastewaterdetail = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.wastewaterdetail.id !== null) {
                Wastewaterdetail.update(vm.wastewaterdetail, onSaveSuccess, onSaveError);
            } else {
                Wastewaterdetail.save(vm.wastewaterdetail, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:wastewaterdetailUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WastewaterdetailDetailController', WastewaterdetailDetailController);

    WastewaterdetailDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Wastewaterdetail'];

    function WastewaterdetailDetailController($scope, $rootScope, $stateParams, previousState, entity, Wastewaterdetail) {
        var vm = this;

        vm.wastewaterdetail = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:wastewaterdetailUpdate', function(event, result) {
            vm.wastewaterdetail = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WastewaterdetailDeleteController',WastewaterdetailDeleteController);

    WastewaterdetailDeleteController.$inject = ['$uibModalInstance', 'entity', 'Wastewaterdetail'];

    function WastewaterdetailDeleteController($uibModalInstance, entity, Wastewaterdetail) {
        var vm = this;

        vm.wastewaterdetail = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Wastewaterdetail.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('wastewaterdetail', {
            parent: 'entity',
            url: '/wastewaterdetail',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.wastewaterdetail.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/wastewaterdetail/wastewaterdetails.html',
                    controller: 'WastewaterdetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('wastewaterdetail');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('wastewaterdetail-detail', {
            parent: 'wastewaterdetail',
            url: '/wastewaterdetail/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.wastewaterdetail.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/wastewaterdetail/wastewaterdetail-detail.html',
                    controller: 'WastewaterdetailDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('wastewaterdetail');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Wastewaterdetail', function($stateParams, Wastewaterdetail) {
                    return Wastewaterdetail.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'wastewaterdetail',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('wastewaterdetail-detail.edit', {
            parent: 'wastewaterdetail-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wastewaterdetail/wastewaterdetail-dialog.html',
                    controller: 'WastewaterdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Wastewaterdetail', function(Wastewaterdetail) {
                            return Wastewaterdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('wastewaterdetail.new', {
            parent: 'wastewaterdetail',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wastewaterdetail/wastewaterdetail-dialog.html',
                    controller: 'WastewaterdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                source_of_generation: null,
                                quantity: null,
                                naturetype: null,
                                mode_of_disposal: null,
                                createdate: null,
                                updatedate: null,
                                projectid: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('wastewaterdetail', null, { reload: 'wastewaterdetail' });
                }, function() {
                    $state.go('wastewaterdetail');
                });
            }]
        })
        .state('wastewaterdetail.edit', {
            parent: 'wastewaterdetail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wastewaterdetail/wastewaterdetail-dialog.html',
                    controller: 'WastewaterdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Wastewaterdetail', function(Wastewaterdetail) {
                            return Wastewaterdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('wastewaterdetail', null, { reload: 'wastewaterdetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('wastewaterdetail.delete', {
            parent: 'wastewaterdetail',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/wastewaterdetail/wastewaterdetail-delete-dialog.html',
                    controller: 'WastewaterdetailDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Wastewaterdetail', function(Wastewaterdetail) {
                            return Wastewaterdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('wastewaterdetail', null, { reload: 'wastewaterdetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Wastewaterdetail', Wastewaterdetail);

    Wastewaterdetail.$inject = ['$resource', 'DateUtils'];

    function Wastewaterdetail ($resource, DateUtils) {
        var resourceUrl =  'api/wastewaterdetails/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('WastewaterdetailController', WastewaterdetailController);

    WastewaterdetailController.$inject = ['Wastewaterdetail'];

    function WastewaterdetailController(Wastewaterdetail) {

        var vm = this;

        vm.wastewaterdetails = [];

        loadAll();

        function loadAll() {
            Wastewaterdetail.query(function(result) {
                vm.wastewaterdetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Waste_water_naturetypeDialogController', Waste_water_naturetypeDialogController);

    Waste_water_naturetypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Waste_water_naturetype'];

    function Waste_water_naturetypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Waste_water_naturetype) {
        var vm = this;

        vm.waste_water_naturetype = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.waste_water_naturetype.id !== null) {
                Waste_water_naturetype.update(vm.waste_water_naturetype, onSaveSuccess, onSaveError);
            } else {
                Waste_water_naturetype.save(vm.waste_water_naturetype, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:waste_water_naturetypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Waste_water_naturetypeDetailController', Waste_water_naturetypeDetailController);

    Waste_water_naturetypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Waste_water_naturetype'];

    function Waste_water_naturetypeDetailController($scope, $rootScope, $stateParams, previousState, entity, Waste_water_naturetype) {
        var vm = this;

        vm.waste_water_naturetype = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:waste_water_naturetypeUpdate', function(event, result) {
            vm.waste_water_naturetype = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Waste_water_naturetypeDeleteController',Waste_water_naturetypeDeleteController);

    Waste_water_naturetypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Waste_water_naturetype'];

    function Waste_water_naturetypeDeleteController($uibModalInstance, entity, Waste_water_naturetype) {
        var vm = this;

        vm.waste_water_naturetype = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Waste_water_naturetype.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('waste-water-naturetype', {
            parent: 'entity',
            url: '/waste-water-naturetype',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.waste_water_naturetype.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/waste-water-naturetype/waste-water-naturetypes.html',
                    controller: 'Waste_water_naturetypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('waste_water_naturetype');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('waste-water-naturetype-detail', {
            parent: 'waste-water-naturetype',
            url: '/waste-water-naturetype/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.waste_water_naturetype.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/waste-water-naturetype/waste-water-naturetype-detail.html',
                    controller: 'Waste_water_naturetypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('waste_water_naturetype');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Waste_water_naturetype', function($stateParams, Waste_water_naturetype) {
                    return Waste_water_naturetype.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'waste-water-naturetype',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('waste-water-naturetype-detail.edit', {
            parent: 'waste-water-naturetype-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/waste-water-naturetype/waste-water-naturetype-dialog.html',
                    controller: 'Waste_water_naturetypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Waste_water_naturetype', function(Waste_water_naturetype) {
                            return Waste_water_naturetype.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('waste-water-naturetype.new', {
            parent: 'waste-water-naturetype',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/waste-water-naturetype/waste-water-naturetype-dialog.html',
                    controller: 'Waste_water_naturetypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                naturetype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('waste-water-naturetype', null, { reload: 'waste-water-naturetype' });
                }, function() {
                    $state.go('waste-water-naturetype');
                });
            }]
        })
        .state('waste-water-naturetype.edit', {
            parent: 'waste-water-naturetype',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/waste-water-naturetype/waste-water-naturetype-dialog.html',
                    controller: 'Waste_water_naturetypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Waste_water_naturetype', function(Waste_water_naturetype) {
                            return Waste_water_naturetype.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('waste-water-naturetype', null, { reload: 'waste-water-naturetype' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('waste-water-naturetype.delete', {
            parent: 'waste-water-naturetype',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/waste-water-naturetype/waste-water-naturetype-delete-dialog.html',
                    controller: 'Waste_water_naturetypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Waste_water_naturetype', function(Waste_water_naturetype) {
                            return Waste_water_naturetype.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('waste-water-naturetype', null, { reload: 'waste-water-naturetype' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Waste_water_naturetype', Waste_water_naturetype);

    Waste_water_naturetype.$inject = ['$resource'];

    function Waste_water_naturetype ($resource) {
        var resourceUrl =  'api/waste-water-naturetypes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Waste_water_naturetypeController', Waste_water_naturetypeController);

    Waste_water_naturetypeController.$inject = ['Waste_water_naturetype'];

    function Waste_water_naturetypeController(Waste_water_naturetype) {

        var vm = this;

        vm.waste_water_naturetypes = [];

        loadAll();

        function loadAll() {
            Waste_water_naturetype.query(function(result) {
                vm.waste_water_naturetypes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Waste_water_disposal_modeDialogController', Waste_water_disposal_modeDialogController);

    Waste_water_disposal_modeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Waste_water_disposal_mode'];

    function Waste_water_disposal_modeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Waste_water_disposal_mode) {
        var vm = this;

        vm.waste_water_disposal_mode = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.waste_water_disposal_mode.id !== null) {
                Waste_water_disposal_mode.update(vm.waste_water_disposal_mode, onSaveSuccess, onSaveError);
            } else {
                Waste_water_disposal_mode.save(vm.waste_water_disposal_mode, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:waste_water_disposal_modeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Waste_water_disposal_modeDetailController', Waste_water_disposal_modeDetailController);

    Waste_water_disposal_modeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Waste_water_disposal_mode'];

    function Waste_water_disposal_modeDetailController($scope, $rootScope, $stateParams, previousState, entity, Waste_water_disposal_mode) {
        var vm = this;

        vm.waste_water_disposal_mode = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:waste_water_disposal_modeUpdate', function(event, result) {
            vm.waste_water_disposal_mode = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Waste_water_disposal_modeDeleteController',Waste_water_disposal_modeDeleteController);

    Waste_water_disposal_modeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Waste_water_disposal_mode'];

    function Waste_water_disposal_modeDeleteController($uibModalInstance, entity, Waste_water_disposal_mode) {
        var vm = this;

        vm.waste_water_disposal_mode = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Waste_water_disposal_mode.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('waste-water-disposal-mode', {
            parent: 'entity',
            url: '/waste-water-disposal-mode',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.waste_water_disposal_mode.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/waste-water-disposal-mode/waste-water-disposal-modes.html',
                    controller: 'Waste_water_disposal_modeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('waste_water_disposal_mode');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('waste-water-disposal-mode-detail', {
            parent: 'waste-water-disposal-mode',
            url: '/waste-water-disposal-mode/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.waste_water_disposal_mode.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/waste-water-disposal-mode/waste-water-disposal-mode-detail.html',
                    controller: 'Waste_water_disposal_modeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('waste_water_disposal_mode');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Waste_water_disposal_mode', function($stateParams, Waste_water_disposal_mode) {
                    return Waste_water_disposal_mode.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'waste-water-disposal-mode',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('waste-water-disposal-mode-detail.edit', {
            parent: 'waste-water-disposal-mode-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/waste-water-disposal-mode/waste-water-disposal-mode-dialog.html',
                    controller: 'Waste_water_disposal_modeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Waste_water_disposal_mode', function(Waste_water_disposal_mode) {
                            return Waste_water_disposal_mode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('waste-water-disposal-mode.new', {
            parent: 'waste-water-disposal-mode',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/waste-water-disposal-mode/waste-water-disposal-mode-dialog.html',
                    controller: 'Waste_water_disposal_modeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                mode_of_disposal: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('waste-water-disposal-mode', null, { reload: 'waste-water-disposal-mode' });
                }, function() {
                    $state.go('waste-water-disposal-mode');
                });
            }]
        })
        .state('waste-water-disposal-mode.edit', {
            parent: 'waste-water-disposal-mode',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/waste-water-disposal-mode/waste-water-disposal-mode-dialog.html',
                    controller: 'Waste_water_disposal_modeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Waste_water_disposal_mode', function(Waste_water_disposal_mode) {
                            return Waste_water_disposal_mode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('waste-water-disposal-mode', null, { reload: 'waste-water-disposal-mode' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('waste-water-disposal-mode.delete', {
            parent: 'waste-water-disposal-mode',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/waste-water-disposal-mode/waste-water-disposal-mode-delete-dialog.html',
                    controller: 'Waste_water_disposal_modeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Waste_water_disposal_mode', function(Waste_water_disposal_mode) {
                            return Waste_water_disposal_mode.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('waste-water-disposal-mode', null, { reload: 'waste-water-disposal-mode' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Waste_water_disposal_mode', Waste_water_disposal_mode);

    Waste_water_disposal_mode.$inject = ['$resource'];

    function Waste_water_disposal_mode ($resource) {
        var resourceUrl =  'api/waste-water-disposal-modes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Waste_water_disposal_modeController', Waste_water_disposal_modeController);

    Waste_water_disposal_modeController.$inject = ['Waste_water_disposal_mode'];

    function Waste_water_disposal_modeController(Waste_water_disposal_mode) {

        var vm = this;

        vm.waste_water_disposal_modes = [];

        loadAll();

        function loadAll() {
            Waste_water_disposal_mode.query(function(result) {
                vm.waste_water_disposal_modes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Visitor_countDialogController', Visitor_countDialogController);

    Visitor_countDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Visitor_count'];

    function Visitor_countDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Visitor_count) {
        var vm = this;

        vm.visitor_count = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.visitor_count.id !== null) {
                Visitor_count.update(vm.visitor_count, onSaveSuccess, onSaveError);
            } else {
                Visitor_count.save(vm.visitor_count, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:visitor_countUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Visitor_countDetailController', Visitor_countDetailController);

    Visitor_countDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Visitor_count'];

    function Visitor_countDetailController($scope, $rootScope, $stateParams, previousState, entity, Visitor_count) {
        var vm = this;

        vm.visitor_count = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:visitor_countUpdate', function(event, result) {
            vm.visitor_count = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Visitor_countDeleteController',Visitor_countDeleteController);

    Visitor_countDeleteController.$inject = ['$uibModalInstance', 'entity', 'Visitor_count'];

    function Visitor_countDeleteController($uibModalInstance, entity, Visitor_count) {
        var vm = this;

        vm.visitor_count = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Visitor_count.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('visitor-count', {
            parent: 'entity',
            url: '/visitor-count',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.visitor_count.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/visitor-count/visitor-counts.html',
                    controller: 'Visitor_countController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('visitor_count');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('visitor-count-detail', {
            parent: 'visitor-count',
            url: '/visitor-count/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.visitor_count.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/visitor-count/visitor-count-detail.html',
                    controller: 'Visitor_countDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('visitor_count');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Visitor_count', function($stateParams, Visitor_count) {
                    return Visitor_count.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'visitor-count',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('visitor-count-detail.edit', {
            parent: 'visitor-count-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/visitor-count/visitor-count-dialog.html',
                    controller: 'Visitor_countDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Visitor_count', function(Visitor_count) {
                            return Visitor_count.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('visitor-count.new', {
            parent: 'visitor-count',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/visitor-count/visitor-count-dialog.html',
                    controller: 'Visitor_countDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                count: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('visitor-count', null, { reload: 'visitor-count' });
                }, function() {
                    $state.go('visitor-count');
                });
            }]
        })
        .state('visitor-count.edit', {
            parent: 'visitor-count',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/visitor-count/visitor-count-dialog.html',
                    controller: 'Visitor_countDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Visitor_count', function(Visitor_count) {
                            return Visitor_count.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('visitor-count', null, { reload: 'visitor-count' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('visitor-count.delete', {
            parent: 'visitor-count',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/visitor-count/visitor-count-delete-dialog.html',
                    controller: 'Visitor_countDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Visitor_count', function(Visitor_count) {
                            return Visitor_count.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('visitor-count', null, { reload: 'visitor-count' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Visitor_count', Visitor_count);

    Visitor_count.$inject = ['$resource'];

    function Visitor_count ($resource) {
        var resourceUrl =  'api/visitor-counts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Visitor_countController', Visitor_countController);

    Visitor_countController.$inject = ['Visitor_count'];

    function Visitor_countController(Visitor_count) {

        var vm = this;

        vm.visitor_counts = [];

        loadAll();

        function loadAll() {
            Visitor_count.query(function(result) {
                vm.visitor_counts = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserFeedbackDialogController', UserFeedbackDialogController);

    UserFeedbackDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'UserFeedback'];

    function UserFeedbackDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, UserFeedback) {
        var vm = this;

        vm.userFeedback = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.userFeedback.id !== null) {
                UserFeedback.update(vm.userFeedback, onSaveSuccess, onSaveError);
            } else {
                UserFeedback.save(vm.userFeedback, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:userFeedbackUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserFeedbackDetailController', UserFeedbackDetailController);

    UserFeedbackDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'UserFeedback'];

    function UserFeedbackDetailController($scope, $rootScope, $stateParams, previousState, entity, UserFeedback) {
        var vm = this;

        vm.userFeedback = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:userFeedbackUpdate', function(event, result) {
            vm.userFeedback = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserFeedbackDeleteController',UserFeedbackDeleteController);

    UserFeedbackDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserFeedback'];

    function UserFeedbackDeleteController($uibModalInstance, entity, UserFeedback) {
        var vm = this;

        vm.userFeedback = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UserFeedback.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-feedback', {
            parent: 'entity',
            url: '/user-feedback',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.userFeedback.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-feedback/user-feedbacks.html',
                    controller: 'UserFeedbackController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userFeedback');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-feedback-detail', {
            parent: 'user-feedback',
            url: '/user-feedback/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.userFeedback.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-feedback/user-feedback-detail.html',
                    controller: 'UserFeedbackDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userFeedback');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'UserFeedback', function($stateParams, UserFeedback) {
                    return UserFeedback.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'user-feedback',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('user-feedback-detail.edit', {
            parent: 'user-feedback-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-feedback/user-feedback-dialog.html',
                    controller: 'UserFeedbackDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserFeedback', function(UserFeedback) {
                            return UserFeedback.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-feedback.new', {
            parent: 'user-feedback',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-feedback/user-feedback-dialog.html',
                    controller: 'UserFeedbackDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                contactNumber: null,
                                email: null,
                                stateId: null,
                                rasDeptId: null,
                                rasServiceId: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-feedback', null, { reload: 'user-feedback' });
                }, function() {
                    $state.go('user-feedback');
                });
            }]
        })
        .state('user-feedback.edit', {
            parent: 'user-feedback',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-feedback/user-feedback-dialog.html',
                    controller: 'UserFeedbackDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserFeedback', function(UserFeedback) {
                            return UserFeedback.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-feedback', null, { reload: 'user-feedback' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-feedback.delete', {
            parent: 'user-feedback',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-feedback/user-feedback-delete-dialog.html',
                    controller: 'UserFeedbackDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserFeedback', function(UserFeedback) {
                            return UserFeedback.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-feedback', null, { reload: 'user-feedback' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('UserFeedback', UserFeedback);

    UserFeedback.$inject = ['$resource'];

    function UserFeedback ($resource) {
        var resourceUrl =  'api/user-feedbacks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserFeedbackController', UserFeedbackController);

    UserFeedbackController.$inject = ['UserFeedback'];

    function UserFeedbackController(UserFeedback) {

        var vm = this;

        vm.userFeedbacks = [];

        loadAll();

        function loadAll() {
            UserFeedback.query(function(result) {
                vm.userFeedbacks = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserAuthorizationDialogController', UserAuthorizationDialogController);

    UserAuthorizationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'UserAuthorization', 'Department'];

    function UserAuthorizationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, UserAuthorization, Department) {
        var vm = this;

        vm.userAuthorization = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        loadAll();

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function loadAll() {
            Department.query(function(result) {
                vm.departments = result;
                vm.searchQuery = null;
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            vm.userAuthorization.department = vm.userAuthorization.selectedDepartment.id;
            if (vm.userAuthorization.id !== null) {
                UserAuthorization.update(vm.userAuthorization, onSaveSuccess, onSaveError);
            } else {
                UserAuthorization.save(vm.userAuthorization, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:userAuthorizationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.generationDate = false;
        vm.datePickerOpenStatus.expirationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserAuthorizationDetailController', UserAuthorizationDetailController);

    UserAuthorizationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'UserAuthorization'];

    function UserAuthorizationDetailController($scope, $rootScope, $stateParams, previousState, entity, UserAuthorization) {
        var vm = this;

        vm.userAuthorization = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:userAuthorizationUpdate', function(event, result) {
            vm.userAuthorization = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserAuthorizationDeleteController',UserAuthorizationDeleteController);

    UserAuthorizationDeleteController.$inject = ['$uibModalInstance', 'entity', 'UserAuthorization'];

    function UserAuthorizationDeleteController($uibModalInstance, entity, UserAuthorization) {
        var vm = this;

        vm.userAuthorization = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            UserAuthorization.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-authorization', {
            parent: 'entity',
            url: '/user-authorization',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.userAuthorization.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-authorization/user-authorizations.html',
                    controller: 'UserAuthorizationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userAuthorization');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-authorization-detail', {
            parent: 'user-authorization',
            url: '/user-authorization/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.userAuthorization.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/user-authorization/user-authorization-detail.html',
                    controller: 'UserAuthorizationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('userAuthorization');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'UserAuthorization', function($stateParams, UserAuthorization) {
                    return UserAuthorization.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'user-authorization',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('user-authorization-detail.edit', {
            parent: 'user-authorization-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-authorization/user-authorization-dialog.html',
                    controller: 'UserAuthorizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserAuthorization', function(UserAuthorization) {
                            return UserAuthorization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-authorization.new', {
            parent: 'user-authorization',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-authorization/user-authorization-dialog.html',
                    controller: 'UserAuthorizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                clientId: null,
                                clientSecret: null,
                                generationDate: null,
                                expirationDate: null,
                                department: null,
                                refreshToken: null,
                                login: null,
                                password: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-authorization', null, { reload: 'user-authorization' });
                }, function() {
                    $state.go('user-authorization');
                });
            }]
        })
        .state('user-authorization.edit', {
            parent: 'user-authorization',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-authorization/user-authorization-dialog.html',
                    controller: 'UserAuthorizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['UserAuthorization', function(UserAuthorization) {
                            return UserAuthorization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-authorization', null, { reload: 'user-authorization' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-authorization.delete', {
            parent: 'user-authorization',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/user-authorization/user-authorization-delete-dialog.html',
                    controller: 'UserAuthorizationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['UserAuthorization', function(UserAuthorization) {
                            return UserAuthorization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-authorization', null, { reload: 'user-authorization' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('UserAuthorization', UserAuthorization);

    UserAuthorization.$inject = ['$resource', 'DateUtils'];

    function UserAuthorization ($resource, DateUtils) {
        var resourceUrl =  'api/user-authorizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.generationDate = DateUtils.convertDateTimeFromServer(data.generationDate);
                        data.expirationDate = DateUtils.convertDateTimeFromServer(data.expirationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserAuthorizationController', UserAuthorizationController);

    UserAuthorizationController.$inject = ['UserAuthorization'];

    function UserAuthorizationController(UserAuthorization) {

        var vm = this;

        vm.userAuthorizations = [];

        loadAll();

        function loadAll() {
            UserAuthorization.query(function(result) {
                vm.userAuthorizations = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerserviceNODialogController', TowerserviceNODialogController);

    TowerserviceNODialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TowerserviceNO'];

    function TowerserviceNODialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TowerserviceNO) {
        var vm = this;

        vm.towerserviceNO = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            console.log(vm.towerserviceNO);
            vm.isSaving = true;
            if (vm.towerserviceNO.id !== null) {
                TowerserviceNO.update(vm.towerserviceNO, onSaveSuccess, onSaveError);
            } else {
                TowerserviceNO.save(vm.towerserviceNO, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:towerserviceNOUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerserviceNODetailController', TowerserviceNODetailController);

    TowerserviceNODetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TowerserviceNO'];

    function TowerserviceNODetailController($scope, $rootScope, $stateParams, previousState, entity, TowerserviceNO) {
        var vm = this;

        vm.towerserviceNO = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:towerserviceNOUpdate', function(event, result) {
            vm.towerserviceNO = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerserviceNODeleteController',TowerserviceNODeleteController);

    TowerserviceNODeleteController.$inject = ['$uibModalInstance', 'entity', 'TowerserviceNO'];

    function TowerserviceNODeleteController($uibModalInstance, entity, TowerserviceNO) {
        var vm = this;

        vm.towerserviceNO = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TowerserviceNO.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('towerservice-no', {
            parent: 'entity',
            url: '/towerservice-no',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.towerserviceNO.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/towerservice-no/towerservice-nos.html',
                    controller: 'TowerserviceNOController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerserviceNO');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('towerservice-no-detail', {
            parent: 'towerservice-no',
            url: '/towerservice-no/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.towerserviceNO.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/towerservice-no/towerservice-no-detail.html',
                    controller: 'TowerserviceNODetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerserviceNO');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TowerserviceNO', function($stateParams, TowerserviceNO) {
                    return TowerserviceNO.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'towerservice-no',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('towerservice-no-detail.edit', {
            parent: 'towerservice-no-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerservice-no/towerservice-no-dialog.html',
                    controller: 'TowerserviceNODialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TowerserviceNO', function(TowerserviceNO) {
                            return TowerserviceNO.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('towerservice-no.new', {
            parent: 'towerservice-no',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerservice-no/towerservice-no-dialog.html',
                    controller: 'TowerserviceNODialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nodal_officer: null,
                                projectdetailId: null,
                                id: null,
                                subname: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('towerservice-no', null, { reload: 'towerservice-no' });
                }, function() {
                    $state.go('towerservice-no');
                });
            }]
        })
        .state('towerservice-no.edit', {
            parent: 'towerservice-no',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerservice-no/towerservice-no-dialog.html',
                    controller: 'TowerserviceNODialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TowerserviceNO', function(TowerserviceNO) {
                            return TowerserviceNO.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('towerservice-no', null, { reload: 'towerservice-no' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('towerservice-no.delete', {
            parent: 'towerservice-no',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerservice-no/towerservice-no-delete-dialog.html',
                    controller: 'TowerserviceNODeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TowerserviceNO', function(TowerserviceNO) {
                            return TowerserviceNO.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('towerservice-no', null, { reload: 'towerservice-no' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerserviceNO', TowerserviceNO);

    TowerserviceNO.$inject = ['$resource'];

    function TowerserviceNO ($resource) {
        var resourceUrl =  'api/towerservice-nos/:id/:projectdetailid/:projectdservicedetailid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerserviceNOController', TowerserviceNOController);

    TowerserviceNOController.$inject = ['TowerserviceNO'];

    function TowerserviceNOController(TowerserviceNO) {

        var vm = this;

        vm.towerserviceNOS = [];

        vm.getProject = function () {
            TowerserviceNO.query({id: '1', projectdetailid: '1', projectdservicedetailid: vm.projectdetailid},function(result) {
                vm.towerserviceNOS = result;
                vm.searchQuery = null;
                vm.show = true;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerofficerlistDialogController', TowerofficerlistDialogController);

    TowerofficerlistDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Towerofficerlist','District'];

    function TowerofficerlistDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Towerofficerlist,District) {
        var vm = this;

        vm.towerofficerlist = entity;
        vm.clear = clear;
        vm.save = save;
        loadAll();

        function loadAll() {
            District.query(function(result) {
                vm.districts = result;
                vm.searchQuery = null;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.towerofficerlist.id !== null) {
                Towerofficerlist.update(vm.towerofficerlist, onSaveSuccess, onSaveError);
            } else {
                Towerofficerlist.save(vm.towerofficerlist, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:towerofficerlistUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerofficerlistDetailController', TowerofficerlistDetailController);

    TowerofficerlistDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Towerofficerlist'];

    function TowerofficerlistDetailController($scope, $rootScope, $stateParams, previousState, entity, Towerofficerlist) {
        var vm = this;

        vm.towerofficerlist = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:towerofficerlistUpdate', function(event, result) {
            vm.towerofficerlist = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerofficerlistDeleteController',TowerofficerlistDeleteController);

    TowerofficerlistDeleteController.$inject = ['$uibModalInstance', 'entity', 'Towerofficerlist'];

    function TowerofficerlistDeleteController($uibModalInstance, entity, Towerofficerlist) {
        var vm = this;

        vm.towerofficerlist = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Towerofficerlist.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('towerofficerlist', {
            parent: 'entity',
            url: '/towerofficerlist',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.towerofficerlist.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/towerofficerlist/towerofficerlists.html',
                    controller: 'TowerofficerlistController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerofficerlist');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('towerofficerlist-detail', {
            parent: 'towerofficerlist',
            url: '/towerofficerlist/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.towerofficerlist.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/towerofficerlist/towerofficerlist-detail.html',
                    controller: 'TowerofficerlistDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerofficerlist');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Towerofficerlist', function($stateParams, Towerofficerlist) {
                    return Towerofficerlist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'towerofficerlist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('towerofficerlist-detail.edit', {
            parent: 'towerofficerlist-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerofficerlist/towerofficerlist-dialog.html',
                    controller: 'TowerofficerlistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Towerofficerlist', function(Towerofficerlist) {
                            return Towerofficerlist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('towerofficerlist.new', {
            parent: 'towerofficerlist',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerofficerlist/towerofficerlist-dialog.html',
                    controller: 'TowerofficerlistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                towerofficerLogin: null,
                                district: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('towerofficerlist', null, { reload: 'towerofficerlist' });
                }, function() {
                    $state.go('towerofficerlist');
                });
            }]
        })
        .state('towerofficerlist.edit', {
            parent: 'towerofficerlist',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerofficerlist/towerofficerlist-dialog.html',
                    controller: 'TowerofficerlistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Towerofficerlist', function(Towerofficerlist) {
                            return Towerofficerlist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('towerofficerlist', null, { reload: 'towerofficerlist' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('towerofficerlist.delete', {
            parent: 'towerofficerlist',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerofficerlist/towerofficerlist-delete-dialog.html',
                    controller: 'TowerofficerlistDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Towerofficerlist', function(Towerofficerlist) {
                            return Towerofficerlist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('towerofficerlist', null, { reload: 'towerofficerlist' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Towerofficerlist', Towerofficerlist);

    Towerofficerlist.$inject = ['$resource'];

    function Towerofficerlist ($resource) {
        var resourceUrl =  'api/towerofficerlists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerofficerlistController', TowerofficerlistController);

    TowerofficerlistController.$inject = ['Towerofficerlist'];

    function TowerofficerlistController(Towerofficerlist) {

        var vm = this;

        vm.towerofficerlists = [];

        loadAll();

        function loadAll() {
            Towerofficerlist.query(function(result) {
                vm.towerofficerlists = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerdiolistDialogController', TowerdiolistDialogController);

    TowerdiolistDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Towerdiolist', 'District'];

    function TowerdiolistDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Towerdiolist, District) {
        var vm = this;

        vm.towerdiolist = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        loadAllDistricts();
        function loadAllDistricts() {
            District.query(function (result) {
                vm.districts=result;
            });
        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.towerdiolist.id !== null) {
                Towerdiolist.update(vm.towerdiolist, onSaveSuccess, onSaveError);
            } else {
                Towerdiolist.save(vm.towerdiolist, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:towerdiolistUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerdiolistDetailController', TowerdiolistDetailController);

    TowerdiolistDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Towerdiolist'];

    function TowerdiolistDetailController($scope, $rootScope, $stateParams, previousState, entity, Towerdiolist) {
        var vm = this;

        vm.towerdiolist = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:towerdiolistUpdate', function(event, result) {
            vm.towerdiolist = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerdiolistDeleteController',TowerdiolistDeleteController);

    TowerdiolistDeleteController.$inject = ['$uibModalInstance', 'entity', 'Towerdiolist'];

    function TowerdiolistDeleteController($uibModalInstance, entity, Towerdiolist) {
        var vm = this;

        vm.towerdiolist = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Towerdiolist.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('towerdiolist', {
            parent: 'entity',
            url: '/towerdiolist',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.towerdiolist.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/towerdiolist/towerdiolists.html',
                    controller: 'TowerdiolistController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerdiolist');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('towerdiolist-detail', {
            parent: 'towerdiolist',
            url: '/towerdiolist/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.towerdiolist.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/towerdiolist/towerdiolist-detail.html',
                    controller: 'TowerdiolistDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerdiolist');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Towerdiolist', function($stateParams, Towerdiolist) {
                    return Towerdiolist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'towerdiolist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('towerdiolist-detail.edit', {
            parent: 'towerdiolist-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerdiolist/towerdiolist-dialog.html',
                    controller: 'TowerdiolistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Towerdiolist', function(Towerdiolist) {
                            return Towerdiolist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('towerdiolist.new', {
            parent: 'towerdiolist',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerdiolist/towerdiolist-dialog.html',
                    controller: 'TowerdiolistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                towerdioLogin: null,
                                district: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('towerdiolist', null, { reload: 'towerdiolist' });
                }, function() {
                    $state.go('towerdiolist');
                });
            }]
        })
        .state('towerdiolist.edit', {
            parent: 'towerdiolist',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerdiolist/towerdiolist-dialog.html',
                    controller: 'TowerdiolistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Towerdiolist', function(Towerdiolist) {
                            return Towerdiolist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('towerdiolist', null, { reload: 'towerdiolist' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('towerdiolist.delete', {
            parent: 'towerdiolist',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerdiolist/towerdiolist-delete-dialog.html',
                    controller: 'TowerdiolistDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Towerdiolist', function(Towerdiolist) {
                            return Towerdiolist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('towerdiolist', null, { reload: 'towerdiolist' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Towerdiolist', Towerdiolist);

    Towerdiolist.$inject = ['$resource'];

    function Towerdiolist ($resource) {
        var resourceUrl =  'api/towerdiolists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerdiolistController', TowerdiolistController);

    TowerdiolistController.$inject = ['Towerdiolist'];

    function TowerdiolistController(Towerdiolist) {

        var vm = this;

        vm.towerdiolists = [];

        loadAll();

        function loadAll() {
            Towerdiolist.query(function(result) {
                vm.towerdiolists = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerdclistDialogController', TowerdclistDialogController);

    TowerdclistDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Towerdclist','District'];

    function TowerdclistDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Towerdclist,District) {
        var vm = this;

        vm.towerdclist = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        loadAllDistricts();
        function loadAllDistricts() {
            District.query(function (result) {
                vm.districts=result;
            });
        }
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.towerdclist.id !== null) {
                Towerdclist.update(vm.towerdclist, onSaveSuccess, onSaveError);
            } else {
                Towerdclist.save(vm.towerdclist, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:towerdclistUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerdclistDetailController', TowerdclistDetailController);

    TowerdclistDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Towerdclist'];

    function TowerdclistDetailController($scope, $rootScope, $stateParams, previousState, entity, Towerdclist) {
        var vm = this;

        vm.towerdclist = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:towerdclistUpdate', function(event, result) {
            vm.towerdclist = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerdclistDeleteController',TowerdclistDeleteController);

    TowerdclistDeleteController.$inject = ['$uibModalInstance', 'entity', 'Towerdclist'];

    function TowerdclistDeleteController($uibModalInstance, entity, Towerdclist) {
        var vm = this;

        vm.towerdclist = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Towerdclist.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('towerdclist', {
            parent: 'entity',
            url: '/towerdclist',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.towerdclist.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/towerdclist/towerdclists.html',
                    controller: 'TowerdclistController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerdclist');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('towerdclist-detail', {
            parent: 'towerdclist',
            url: '/towerdclist/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.towerdclist.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/towerdclist/towerdclist-detail.html',
                    controller: 'TowerdclistDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerdclist');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Towerdclist', function($stateParams, Towerdclist) {
                    return Towerdclist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'towerdclist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('towerdclist-detail.edit', {
            parent: 'towerdclist-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerdclist/towerdclist-dialog.html',
                    controller: 'TowerdclistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Towerdclist', function(Towerdclist) {
                            return Towerdclist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('towerdclist.new', {
            parent: 'towerdclist',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerdclist/towerdclist-dialog.html',
                    controller: 'TowerdclistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                towerdc_login: null,
                                district: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('towerdclist', null, { reload: 'towerdclist' });
                }, function() {
                    $state.go('towerdclist');
                });
            }]
        })
        .state('towerdclist.edit', {
            parent: 'towerdclist',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerdclist/towerdclist-dialog.html',
                    controller: 'TowerdclistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Towerdclist', function(Towerdclist) {
                            return Towerdclist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('towerdclist', null, { reload: 'towerdclist' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('towerdclist.delete', {
            parent: 'towerdclist',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/towerdclist/towerdclist-delete-dialog.html',
                    controller: 'TowerdclistDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Towerdclist', function(Towerdclist) {
                            return Towerdclist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('towerdclist', null, { reload: 'towerdclist' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Towerdclist', Towerdclist);

    Towerdclist.$inject = ['$resource'];

    function Towerdclist ($resource) {
        var resourceUrl =  'api/towerdclists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerdclistController', TowerdclistController);

    TowerdclistController.$inject = ['Towerdclist'];

    function TowerdclistController(Towerdclist) {

        var vm = this;

        vm.towerdclists = [];

        loadAll();

        function loadAll() {
            Towerdclist.query(function(result) {
                vm.towerdclists = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerUpdateDepartmentDialogController', TowerUpdateDepartmentDialogController);

    TowerUpdateDepartmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TowerUpdateDepartment'];

    function TowerUpdateDepartmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TowerUpdateDepartment) {
        var vm = this;

        vm.towerUpdateDepartment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.towerUpdateDepartment.id !== null) {
                TowerUpdateDepartment.update(vm.towerUpdateDepartment, onSaveSuccess, onSaveError);
            } else {
                TowerUpdateDepartment.save(vm.towerUpdateDepartment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:towerUpdateDepartmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.updatedAt = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerUpdateDepartmentDetailController', TowerUpdateDepartmentDetailController);

    TowerUpdateDepartmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TowerUpdateDepartment'];

    function TowerUpdateDepartmentDetailController($scope, $rootScope, $stateParams, previousState, entity, TowerUpdateDepartment) {
        var vm = this;

        vm.towerUpdateDepartment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:towerUpdateDepartmentUpdate', function(event, result) {
            vm.towerUpdateDepartment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerUpdateDepartmentDeleteController',TowerUpdateDepartmentDeleteController);

    TowerUpdateDepartmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'TowerUpdateDepartment'];

    function TowerUpdateDepartmentDeleteController($uibModalInstance, entity, TowerUpdateDepartment) {
        var vm = this;

        vm.towerUpdateDepartment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TowerUpdateDepartment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tower-update-department', {
            parent: 'entity',
            url: '/tower-update-department',
            data: {
                authorities: ["ROLE_USER"],
                pageTitle: 'investhryApp.towerUpdateDepartment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-update-department/tower-update-departments.html',
                    controller: 'TowerUpdateDepartmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerUpdateDepartment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tower-update-department-detail', {
            parent: 'tower-update-department',
            url: '/tower-update-department/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.towerUpdateDepartment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-update-department/tower-update-department-detail.html',
                    controller: 'TowerUpdateDepartmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerUpdateDepartment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TowerUpdateDepartment', function($stateParams, TowerUpdateDepartment) {
                    return TowerUpdateDepartment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tower-update-department',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tower-update-department-detail.edit', {
            parent: 'tower-update-department-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-update-department/tower-update-department-dialog.html',
                    controller: 'TowerUpdateDepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TowerUpdateDepartment', function(TowerUpdateDepartment) {
                            return TowerUpdateDepartment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-update-department.new', {
            parent: 'tower-update-department',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-update-department/tower-update-department-dialog.html',
                    controller: 'TowerUpdateDepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectId: null,
                                serviceId: null,
                                oldDepartment: null,
                                newDepartment: null,
                                updatedAt: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tower-update-department', null, { reload: 'tower-update-department' });
                }, function() {
                    $state.go('tower-update-department');
                });
            }]
        })
        .state('tower-update-department.edit', {
            parent: 'tower-update-department',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-update-department/tower-update-department-dialog.html',
                    controller: 'TowerUpdateDepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TowerUpdateDepartment', function(TowerUpdateDepartment) {
                            return TowerUpdateDepartment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-update-department', null, { reload: 'tower-update-department' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-update-department.delete', {
            parent: 'tower-update-department',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-update-department/tower-update-department-delete-dialog.html',
                    controller: 'TowerUpdateDepartmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TowerUpdateDepartment', function(TowerUpdateDepartment) {
                            return TowerUpdateDepartment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-update-department', null, { reload: 'tower-update-department' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerUpdateDepartment', TowerUpdateDepartment);

    TowerUpdateDepartment.$inject = ['$resource', 'DateUtils'];

    function TowerUpdateDepartment ($resource, DateUtils) {
        var resourceUrl =  'api/tower-update-departments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.updatedAt = DateUtils.convertDateTimeFromServer(data.updatedAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerUpdateDepartmentController', TowerUpdateDepartmentController);

    TowerUpdateDepartmentController.$inject = ['TowerUpdateDepartment'];

    function TowerUpdateDepartmentController(TowerUpdateDepartment) {

        var vm = this;

        vm.towerUpdateDepartments = [];

        loadAll();

        function loadAll() {
            TowerUpdateDepartment.query(function(result) {
                vm.towerUpdateDepartments = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerServiceNoRequireDialogController', TowerServiceNoRequireDialogController);

    TowerServiceNoRequireDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TowerServiceNoRequire'];

    function TowerServiceNoRequireDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TowerServiceNoRequire) {
        var vm = this;

        vm.towerServiceNoRequire = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.towerServiceNoRequire.id !== null) {
                TowerServiceNoRequire.update(vm.towerServiceNoRequire, onSaveSuccess, onSaveError);
            } else {
                TowerServiceNoRequire.save(vm.towerServiceNoRequire, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:towerServiceNoRequireUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerServiceNoRequireDetailController', TowerServiceNoRequireDetailController);

    TowerServiceNoRequireDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TowerServiceNoRequire'];

    function TowerServiceNoRequireDetailController($scope, $rootScope, $stateParams, previousState, entity, TowerServiceNoRequire) {
        var vm = this;

        vm.towerServiceNoRequire = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:towerServiceNoRequireUpdate', function(event, result) {
            vm.towerServiceNoRequire = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerServiceNoRequireDeleteController',TowerServiceNoRequireDeleteController);

    TowerServiceNoRequireDeleteController.$inject = ['$uibModalInstance', 'entity', 'TowerServiceNoRequire'];

    function TowerServiceNoRequireDeleteController($uibModalInstance, entity, TowerServiceNoRequire) {
        var vm = this;

        vm.towerServiceNoRequire = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TowerServiceNoRequire.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tower-service-no-require', {
            parent: 'entity',
            url: '/tower-service-no-require',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.towerServiceNoRequire.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-service-no-require/tower-service-no-requires.html',
                    controller: 'TowerServiceNoRequireController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerServiceNoRequire');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tower-service-no-require-detail', {
            parent: 'tower-service-no-require',
            url: '/tower-service-no-require/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.towerServiceNoRequire.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-service-no-require/tower-service-no-require-detail.html',
                    controller: 'TowerServiceNoRequireDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerServiceNoRequire');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TowerServiceNoRequire', function($stateParams, TowerServiceNoRequire) {
                    return TowerServiceNoRequire.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tower-service-no-require',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tower-service-no-require-detail.edit', {
            parent: 'tower-service-no-require-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-service-no-require/tower-service-no-require-dialog.html',
                    controller: 'TowerServiceNoRequireDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TowerServiceNoRequire', function(TowerServiceNoRequire) {
                            return TowerServiceNoRequire.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-service-no-require.new', {
            parent: 'tower-service-no-require',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-service-no-require/tower-service-no-require-dialog.html',
                    controller: 'TowerServiceNoRequireDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectId: null,
                                serviceId: null,
                                officerList: null,
                                subname: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tower-service-no-require', null, { reload: 'tower-service-no-require' });
                }, function() {
                    $state.go('tower-service-no-require');
                });
            }]
        })
        .state('tower-service-no-require.edit', {
            parent: 'tower-service-no-require',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-service-no-require/tower-service-no-require-dialog.html',
                    controller: 'TowerServiceNoRequireDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TowerServiceNoRequire', function(TowerServiceNoRequire) {
                            return TowerServiceNoRequire.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-service-no-require', null, { reload: 'tower-service-no-require' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-service-no-require.delete', {
            parent: 'tower-service-no-require',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-service-no-require/tower-service-no-require-delete-dialog.html',
                    controller: 'TowerServiceNoRequireDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TowerServiceNoRequire', function(TowerServiceNoRequire) {
                            return TowerServiceNoRequire.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-service-no-require', null, { reload: 'tower-service-no-require' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerServiceNoRequire', TowerServiceNoRequire);

    TowerServiceNoRequire.$inject = ['$resource'];

    function TowerServiceNoRequire ($resource) {
        var resourceUrl =  'api/tower-service-no-requires/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerServiceNoRequireController', TowerServiceNoRequireController);

    TowerServiceNoRequireController.$inject = ['TowerServiceNoRequire'];

    function TowerServiceNoRequireController(TowerServiceNoRequire) {

        var vm = this;

        vm.towerServiceNoRequires = [];

        loadAll();

        function loadAll() {
            TowerServiceNoRequire.query(function(result) {
                vm.towerServiceNoRequires = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_service_dashboardDialogController', Tower_service_dashboardDialogController);

    Tower_service_dashboardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Tower_service_dashboard'];

    function Tower_service_dashboardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Tower_service_dashboard) {
        var vm = this;

        vm.tower_service_dashboard = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tower_service_dashboard.id !== null) {
                Tower_service_dashboard.update(vm.tower_service_dashboard, onSaveSuccess, onSaveError);
            } else {
                Tower_service_dashboard.save(vm.tower_service_dashboard, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:tower_service_dashboardUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_service_dashboardDetailController', Tower_service_dashboardDetailController);

    Tower_service_dashboardDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tower_service_dashboard'];

    function Tower_service_dashboardDetailController($scope, $rootScope, $stateParams, previousState, entity, Tower_service_dashboard) {
        var vm = this;

        vm.tower_service_dashboard = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:tower_service_dashboardUpdate', function(event, result) {
            vm.tower_service_dashboard = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_service_dashboardDeleteController',Tower_service_dashboardDeleteController);

    Tower_service_dashboardDeleteController.$inject = ['$uibModalInstance', 'entity', 'Tower_service_dashboard'];

    function Tower_service_dashboardDeleteController($uibModalInstance, entity, Tower_service_dashboard) {
        var vm = this;

        vm.tower_service_dashboard = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tower_service_dashboard.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tower-service-dashboard', {
            parent: 'entity',
            url: '/tower-service-dashboard',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.tower_service_dashboard.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-service-dashboard/tower-service-dashboards.html',
                    controller: 'Tower_service_dashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tower_service_dashboard');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tower-service-dashboard-detail', {
            parent: 'tower-service-dashboard',
            url: '/tower-service-dashboard/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.tower_service_dashboard.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-service-dashboard/tower-service-dashboard-detail.html',
                    controller: 'Tower_service_dashboardDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tower_service_dashboard');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tower_service_dashboard', function($stateParams, Tower_service_dashboard) {
                    return Tower_service_dashboard.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tower-service-dashboard',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tower-service-dashboard-detail.edit', {
            parent: 'tower-service-dashboard-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-service-dashboard/tower-service-dashboard-dialog.html',
                    controller: 'Tower_service_dashboardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tower_service_dashboard', function(Tower_service_dashboard) {
                            return Tower_service_dashboard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-service-dashboard.new', {
            parent: 'tower-service-dashboard',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-service-dashboard/tower-service-dashboard-dialog.html',
                    controller: 'Tower_service_dashboardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                service_name: null,
                                department_name: null,
                                required: null,
                                applied: null,
                                pending_total: null,
                                pending_30: null,
                                pending_45: null,
                                cleared: null,
                                deactivated: null,
                                deemed: null,
                                rejected: null,
                                departmentOrder: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tower-service-dashboard', null, { reload: 'tower-service-dashboard' });
                }, function() {
                    $state.go('tower-service-dashboard');
                });
            }]
        })
        .state('tower-service-dashboard.edit', {
            parent: 'tower-service-dashboard',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-service-dashboard/tower-service-dashboard-dialog.html',
                    controller: 'Tower_service_dashboardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tower_service_dashboard', function(Tower_service_dashboard) {
                            return Tower_service_dashboard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-service-dashboard', null, { reload: 'tower-service-dashboard' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-service-dashboard.delete', {
            parent: 'tower-service-dashboard',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-service-dashboard/tower-service-dashboard-delete-dialog.html',
                    controller: 'Tower_service_dashboardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tower_service_dashboard', function(Tower_service_dashboard) {
                            return Tower_service_dashboard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-service-dashboard', null, { reload: 'tower-service-dashboard' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Tower_service_dashboard', Tower_service_dashboard);

    Tower_service_dashboard.$inject = ['$resource'];

    function Tower_service_dashboard ($resource) {
        var resourceUrl =  'api/tower-service-dashboards/:id/';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_service_dashboardController', Tower_service_dashboardController);

    Tower_service_dashboardController.$inject = ['Tower_service_dashboard'];

    function Tower_service_dashboardController(Tower_service_dashboard) {

        var vm = this;

        vm.tower_service_dashboards = [];

        loadAll();

        function loadAll() {
            Tower_service_dashboard.query(function(result) {
                vm.tower_service_dashboards = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerRejectionReasonDialogController', TowerRejectionReasonDialogController);

    TowerRejectionReasonDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TowerRejectionReason'];

    function TowerRejectionReasonDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TowerRejectionReason) {
        var vm = this;

        vm.towerRejectionReason = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.towerRejectionReason.id !== null) {
                TowerRejectionReason.update(vm.towerRejectionReason, onSaveSuccess, onSaveError);
            } else {
                TowerRejectionReason.save(vm.towerRejectionReason, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:towerRejectionReasonUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerRejectionReasonDetailController', TowerRejectionReasonDetailController);

    TowerRejectionReasonDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TowerRejectionReason'];

    function TowerRejectionReasonDetailController($scope, $rootScope, $stateParams, previousState, entity, TowerRejectionReason) {
        var vm = this;

        vm.towerRejectionReason = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:towerRejectionReasonUpdate', function(event, result) {
            vm.towerRejectionReason = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerRejectionReasonDeleteController',TowerRejectionReasonDeleteController);

    TowerRejectionReasonDeleteController.$inject = ['$uibModalInstance', 'entity', 'TowerRejectionReason'];

    function TowerRejectionReasonDeleteController($uibModalInstance, entity, TowerRejectionReason) {
        var vm = this;

        vm.towerRejectionReason = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TowerRejectionReason.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerRejectionReasonByCategory', TowerRejectionReasonByCategory);

    TowerRejectionReasonByCategory.$inject = ['$resource'];

    function TowerRejectionReasonByCategory ($resource) {
        var resourceUrl =  'api/tower-rejection-reasons-by-category/:category';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tower-rejection-reason', {
            parent: 'entity',
            url: '/tower-rejection-reason',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.towerRejectionReason.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-rejection-reason/tower-rejection-reasons.html',
                    controller: 'TowerRejectionReasonController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerRejectionReason');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tower-rejection-reason-detail', {
            parent: 'tower-rejection-reason',
            url: '/tower-rejection-reason/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.towerRejectionReason.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-rejection-reason/tower-rejection-reason-detail.html',
                    controller: 'TowerRejectionReasonDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('towerRejectionReason');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TowerRejectionReason', function($stateParams, TowerRejectionReason) {
                    return TowerRejectionReason.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tower-rejection-reason',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tower-rejection-reason-detail.edit', {
            parent: 'tower-rejection-reason-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-rejection-reason/tower-rejection-reason-dialog.html',
                    controller: 'TowerRejectionReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TowerRejectionReason', function(TowerRejectionReason) {
                            return TowerRejectionReason.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-rejection-reason.new', {
            parent: 'tower-rejection-reason',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-rejection-reason/tower-rejection-reason-dialog.html',
                    controller: 'TowerRejectionReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                code: null,
                                category: null,
                                reason: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tower-rejection-reason', null, { reload: 'tower-rejection-reason' });
                }, function() {
                    $state.go('tower-rejection-reason');
                });
            }]
        })
        .state('tower-rejection-reason.edit', {
            parent: 'tower-rejection-reason',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-rejection-reason/tower-rejection-reason-dialog.html',
                    controller: 'TowerRejectionReasonDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TowerRejectionReason', function(TowerRejectionReason) {
                            return TowerRejectionReason.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-rejection-reason', null, { reload: 'tower-rejection-reason' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-rejection-reason.delete', {
            parent: 'tower-rejection-reason',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-rejection-reason/tower-rejection-reason-delete-dialog.html',
                    controller: 'TowerRejectionReasonDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TowerRejectionReason', function(TowerRejectionReason) {
                            return TowerRejectionReason.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-rejection-reason', null, { reload: 'tower-rejection-reason' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerRejectionReason', TowerRejectionReason);

    TowerRejectionReason.$inject = ['$resource'];

    function TowerRejectionReason ($resource) {
        var resourceUrl =  'api/tower-rejection-reasons/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerRejectionReasonController', TowerRejectionReasonController);

    TowerRejectionReasonController.$inject = ['TowerRejectionReason'];

    function TowerRejectionReasonController(TowerRejectionReason) {

        var vm = this;

        vm.towerRejectionReasons = [];

        loadAll();

        function loadAll() {
            TowerRejectionReason.query(function(result) {
                vm.towerRejectionReasons = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_logDialogController', Tower_logDialogController);

    Tower_logDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Tower_log'];

    function Tower_logDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Tower_log) {
        var vm = this;

        vm.tower_log = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tower_log.id !== null) {
                Tower_log.update(vm.tower_log, onSaveSuccess, onSaveError);
            } else {
                Tower_log.save(vm.tower_log, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:tower_logUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.action_date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_logDetailController', Tower_logDetailController);

    Tower_logDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tower_log'];

    function Tower_logDetailController($scope, $rootScope, $stateParams, previousState, entity, Tower_log) {
        var vm = this;

        vm.tower_log = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:tower_logUpdate', function(event, result) {
            vm.tower_log = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_logDeleteController',Tower_logDeleteController);

    Tower_logDeleteController.$inject = ['$uibModalInstance', 'entity', 'Tower_log'];

    function Tower_logDeleteController($uibModalInstance, entity, Tower_log) {
        var vm = this;

        vm.tower_log = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tower_log.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tower-log', {
            parent: 'entity',
            url: '/tower-log',
            data: {
                authorities: ['TOWER_USER','TOWER_ADMIN'],
                pageTitle: 'investhryApp.tower_log.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-log/tower-logs.html',
                    controller: 'Tower_logController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tower_log');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tower-log-detail', {
            parent: 'tower-log',
            url: '/tower-log/{id}',
            data: {
                authorities: ['TOWER_USER','TOWER_ADMIN'],
                pageTitle: 'investhryApp.tower_log.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-log/tower-log-detail.html',
                    controller: 'Tower_logDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tower_log');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tower_log', function($stateParams, Tower_log) {
                    return Tower_log.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tower-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tower-log-detail.edit', {
            parent: 'tower-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['TOWER_USER','TOWER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-log/tower-log-dialog.html',
                    controller: 'Tower_logDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tower_log', function(Tower_log) {
                            return Tower_log.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-log.new', {
            parent: 'tower-log',
            url: '/new',
            data: {
                authorities: ['TOWER_USER','TOWER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-log/tower-log-dialog.html',
                    controller: 'Tower_logDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                action: null,
                                action_by: null,
                                comment: null,
                                tower_id: null,
                                action_date: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tower-log', null, { reload: 'tower-log' });
                }, function() {
                    $state.go('tower-log');
                });
            }]
        })
        .state('tower-log.edit', {
            parent: 'tower-log',
            url: '/{id}/edit',
            data: {
                authorities: ['TOWER_USER','TOWER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-log/tower-log-dialog.html',
                    controller: 'Tower_logDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tower_log', function(Tower_log) {
                            return Tower_log.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-log', null, { reload: 'tower-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-log.delete', {
            parent: 'tower-log',
            url: '/{id}/delete',
            data: {
                authorities: ['TOWER_USER','TOWER_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-log/tower-log-delete-dialog.html',
                    controller: 'Tower_logDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tower_log', function(Tower_log) {
                            return Tower_log.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-log', null, { reload: 'tower-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Tower_log', Tower_log);

    Tower_log.$inject = ['$resource', 'DateUtils'];

    function Tower_log ($resource, DateUtils) {
        var resourceUrl =  'api/tower-logs/:id/';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.action_date = DateUtils.convertDateTimeFromServer(data.action_date);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_logController', Tower_logController);

    Tower_logController.$inject = ['Tower_log'];

    function Tower_logController(Tower_log) {

        var vm = this;

        vm.tower_logs = [];

        loadAll();

        function loadAll() {
            Tower_log.query(function(result) {
                vm.tower_logs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_dcDialogController', Tower_dcDialogController);

    Tower_dcDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Tower_dc','District'];

    function Tower_dcDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Tower_dc, District) {
        var vm = this;

        vm.tower_dc = entity;
        vm.clear = clear;
        vm.save = save;

        loadAll();

        function loadAll() {
            District.query(function(result) {
                vm.districts = result;
                vm.searchQuery = null;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tower_dc.id !== null) {
                Tower_dc.update(vm.tower_dc, onSaveSuccess, onSaveError);
            } else {
                Tower_dc.save(vm.tower_dc, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:tower_dcUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_dcDetailController', Tower_dcDetailController);

    Tower_dcDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tower_dc'];

    function Tower_dcDetailController($scope, $rootScope, $stateParams, previousState, entity, Tower_dc) {
        var vm = this;

        vm.tower_dc = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:tower_dcUpdate', function(event, result) {
            vm.tower_dc = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_dcDeleteController',Tower_dcDeleteController);

    Tower_dcDeleteController.$inject = ['$uibModalInstance', 'entity', 'Tower_dc'];

    function Tower_dcDeleteController($uibModalInstance, entity, Tower_dc) {
        var vm = this;

        vm.tower_dc = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tower_dc.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tower-dc', {
            parent: 'entity',
            url: '/tower-dc',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.tower_dc.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-dc/tower-dcs.html',
                    controller: 'Tower_dcController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tower_dc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tower-dc-detail', {
            parent: 'tower-dc',
            url: '/tower-dc/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.tower_dc.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tower-dc/tower-dc-detail.html',
                    controller: 'Tower_dcDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tower_dc');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tower_dc', function($stateParams, Tower_dc) {
                    return Tower_dc.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tower-dc',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tower-dc-detail.edit', {
            parent: 'tower-dc-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-dc/tower-dc-dialog.html',
                    controller: 'Tower_dcDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tower_dc', function(Tower_dc) {
                            return Tower_dc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-dc.new', {
            parent: 'tower-dc',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-dc/tower-dc-dialog.html',
                    controller: 'Tower_dcDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                username_dc: null,
                                district: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tower-dc', null, { reload: 'tower-dc' });
                }, function() {
                    $state.go('tower-dc');
                });
            }]
        })
        .state('tower-dc.edit', {
            parent: 'tower-dc',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-dc/tower-dc-dialog.html',
                    controller: 'Tower_dcDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tower_dc', function(Tower_dc) {
                            return Tower_dc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-dc', null, { reload: 'tower-dc' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tower-dc.delete', {
            parent: 'tower-dc',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tower-dc/tower-dc-delete-dialog.html',
                    controller: 'Tower_dcDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tower_dc', function(Tower_dc) {
                            return Tower_dc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tower-dc', null, { reload: 'tower-dc' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Tower_dc', Tower_dc);

    Tower_dc.$inject = ['$resource'];

    function Tower_dc ($resource) {
        var resourceUrl =  'api/tower-dcs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tower_dcController', Tower_dcController);

    Tower_dcController.$inject = ['Tower_dc'];

    function Tower_dcController(Tower_dc) {

        var vm = this;

        vm.tower_dcs = [];

        loadAll();

        function loadAll() {
            Tower_dc.query(function(result) {
                vm.tower_dcs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TotalservicedashboarddetailsDialogController', TotalservicedashboarddetailsDialogController);

    TotalservicedashboarddetailsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Totalservicedashboarddetails'];

    function TotalservicedashboarddetailsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Totalservicedashboarddetails) {
        var vm = this;

        vm.totalservicedashboarddetails = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.totalservicedashboarddetails.id !== null) {
                Totalservicedashboarddetails.update(vm.totalservicedashboarddetails, onSaveSuccess, onSaveError);
            } else {
                Totalservicedashboarddetails.save(vm.totalservicedashboarddetails, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:totalservicedashboarddetailsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.formfilleddate = false;
        vm.datePickerOpenStatus.serviceAppliedDate = false;
        vm.datePickerOpenStatus.serviceClearedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TotalservicedashboarddetailsDetailController', TotalservicedashboarddetailsDetailController);

    TotalservicedashboarddetailsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Totalservicedashboarddetails'];

    function TotalservicedashboarddetailsDetailController($scope, $rootScope, $stateParams, previousState, entity, Totalservicedashboarddetails) {
        var vm = this;

        vm.totalservicedashboarddetails = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:totalservicedashboarddetailsUpdate', function(event, result) {
            vm.totalservicedashboarddetails = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TotalservicedashboarddetailsDeleteController',TotalservicedashboarddetailsDeleteController);

    TotalservicedashboarddetailsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Totalservicedashboarddetails'];

    function TotalservicedashboarddetailsDeleteController($uibModalInstance, entity, Totalservicedashboarddetails) {
        var vm = this;

        vm.totalservicedashboarddetails = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Totalservicedashboarddetails.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('totalservicedashboarddetails', {
            parent: 'entity',
            url: '/totalservicedashboarddetails',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.totalservicedashboarddetails.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/totalservicedashboarddetails/totalservicedashboarddetails.html',
                    controller: 'TotalservicedashboarddetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('totalservicedashboarddetails');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('totalservicedashboarddetails-detail', {
            parent: 'totalservicedashboarddetails',
            url: '/totalservicedashboarddetails/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.totalservicedashboarddetails.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/totalservicedashboarddetails/totalservicedashboarddetails-detail.html',
                    controller: 'TotalservicedashboarddetailsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('totalservicedashboarddetails');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Totalservicedashboarddetails', function($stateParams, Totalservicedashboarddetails) {
                    return Totalservicedashboarddetails.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'totalservicedashboarddetails',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('totalservicedashboarddetails-detail.edit', {
            parent: 'totalservicedashboarddetails-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/totalservicedashboarddetails/totalservicedashboarddetails-dialog.html',
                    controller: 'TotalservicedashboarddetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Totalservicedashboarddetails', function(Totalservicedashboarddetails) {
                            return Totalservicedashboarddetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('totalservicedashboarddetails.new', {
            parent: 'totalservicedashboarddetails',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/totalservicedashboarddetails/totalservicedashboarddetails-dialog.html',
                    controller: 'TotalservicedashboarddetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                cafpin: null,
                                businessentity: null,
                                district: null,
                                projectlevel: null,
                                proposedemployement: null,
                                projectinvestment: null,
                                deactivated: null,
                                status: null,
                                formfilleddate: null,
                                formfilledstatus: null,
                                isapplied: null,
                                servicename: null,
                                departmentname: null,
                                investorName: null,
                                investorEmail: null,
                                investorContact: null,
                                serviceAppliedDate: null,
                                serviceClearedDate: null,
                                address: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('totalservicedashboarddetails', null, { reload: 'totalservicedashboarddetails' });
                }, function() {
                    $state.go('totalservicedashboarddetails');
                });
            }]
        })
        .state('totalservicedashboarddetails.edit', {
            parent: 'totalservicedashboarddetails',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/totalservicedashboarddetails/totalservicedashboarddetails-dialog.html',
                    controller: 'TotalservicedashboarddetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Totalservicedashboarddetails', function(Totalservicedashboarddetails) {
                            return Totalservicedashboarddetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('totalservicedashboarddetails', null, { reload: 'totalservicedashboarddetails' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('totalservicedashboarddetails.delete', {
            parent: 'totalservicedashboarddetails',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/totalservicedashboarddetails/totalservicedashboarddetails-delete-dialog.html',
                    controller: 'TotalservicedashboarddetailsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Totalservicedashboarddetails', function(Totalservicedashboarddetails) {
                            return Totalservicedashboarddetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('totalservicedashboarddetails', null, { reload: 'totalservicedashboarddetails' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Totalservicedashboarddetails', Totalservicedashboarddetails);

    Totalservicedashboarddetails.$inject = ['$resource', 'DateUtils'];

    function Totalservicedashboarddetails ($resource, DateUtils) {
        var resourceUrl =  'api/totalservicedashboarddetails/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.formfilleddate = DateUtils.convertDateTimeFromServer(data.formfilleddate);
                        data.serviceAppliedDate = DateUtils.convertLocalDateFromServer(data.serviceAppliedDate);
                        data.serviceClearedDate = DateUtils.convertLocalDateFromServer(data.serviceClearedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.serviceAppliedDate = DateUtils.convertLocalDateToServer(copy.serviceAppliedDate);
                    copy.serviceClearedDate = DateUtils.convertLocalDateToServer(copy.serviceClearedDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.serviceAppliedDate = DateUtils.convertLocalDateToServer(copy.serviceAppliedDate);
                    copy.serviceClearedDate = DateUtils.convertLocalDateToServer(copy.serviceClearedDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TotalservicedashboarddetailsController', TotalservicedashboarddetailsController);

    TotalservicedashboarddetailsController.$inject = ['Totalservicedashboarddetails'];

    function TotalservicedashboarddetailsController(Totalservicedashboarddetails) {

        var vm = this;

        vm.totalservicedashboarddetails = [];

        loadAll();

        function loadAll() {
            Totalservicedashboarddetails.query(function(result) {
                vm.totalservicedashboarddetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsLogsDialogController', TicketsLogsDialogController);

    TicketsLogsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TicketsLogs'];

    function TicketsLogsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TicketsLogs) {
        var vm = this;

        vm.ticketsLogs = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticketsLogs.id !== null) {
                TicketsLogs.update(vm.ticketsLogs, onSaveSuccess, onSaveError);
            } else {
                TicketsLogs.save(vm.ticketsLogs, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:ticketsLogsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.actionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsLogsDetailController', TicketsLogsDetailController);

    TicketsLogsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TicketsLogs'];

    function TicketsLogsDetailController($scope, $rootScope, $stateParams, previousState, entity, TicketsLogs) {
        var vm = this;

        vm.ticketsLogs = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:ticketsLogsUpdate', function(event, result) {
            vm.ticketsLogs = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsLogsDeleteController',TicketsLogsDeleteController);

    TicketsLogsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TicketsLogs'];

    function TicketsLogsDeleteController($uibModalInstance, entity, TicketsLogs) {
        var vm = this;

        vm.ticketsLogs = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TicketsLogs.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tickets-logs', {
            parent: 'entity',
            url: '/tickets-logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.ticketsLogs.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tickets-logs/tickets-logs.html',
                    controller: 'TicketsLogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketsLogs');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tickets-logs-detail', {
            parent: 'tickets-logs',
            url: '/tickets-logs/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.ticketsLogs.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tickets-logs/tickets-logs-detail.html',
                    controller: 'TicketsLogsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketsLogs');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TicketsLogs', function($stateParams, TicketsLogs) {
                    return TicketsLogs.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tickets-logs',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tickets-logs-detail.edit', {
            parent: 'tickets-logs-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-logs/tickets-logs-dialog.html',
                    controller: 'TicketsLogsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketsLogs', function(TicketsLogs) {
                            return TicketsLogs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tickets-logs.new', {
            parent: 'tickets-logs',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-logs/tickets-logs-dialog.html',
                    controller: 'TicketsLogsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ticketId: null,
                                ticketNumber: null,
                                creationDate: null,
                                actionBy: null,
                                actionDate: null,
                                actionType: null,
                                departmentName: null,
                                departmentId: null,
                                projectid: null,
                                serviceid: null,
                                remark: null,
                                cafpin: null,
                                status: null,
                                assignedMember: null,
                                attachment: null,
                                actionByName: null,
                                assignedMemberName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tickets-logs', null, { reload: 'tickets-logs' });
                }, function() {
                    $state.go('tickets-logs');
                });
            }]
        })
        .state('tickets-logs.edit', {
            parent: 'tickets-logs',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-logs/tickets-logs-dialog.html',
                    controller: 'TicketsLogsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketsLogs', function(TicketsLogs) {
                            return TicketsLogs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tickets-logs', null, { reload: 'tickets-logs' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tickets-logs.delete', {
            parent: 'tickets-logs',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-logs/tickets-logs-delete-dialog.html',
                    controller: 'TicketsLogsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TicketsLogs', function(TicketsLogs) {
                            return TicketsLogs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tickets-logs', null, { reload: 'tickets-logs' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TicketsLogs', TicketsLogs);

    TicketsLogs.$inject = ['$resource', 'DateUtils'];

    function TicketsLogs ($resource, DateUtils) {
        var resourceUrl =  'api/tickets-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.actionDate = DateUtils.convertDateTimeFromServer(data.actionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsLogsController', TicketsLogsController);

    TicketsLogsController.$inject = ['TicketsLogs'];

    function TicketsLogsController(TicketsLogs) {

        var vm = this;
        vm.ticketsLogs = [];
        vm.search = false;
        vm.searchTicketLogs = searchTicketLogs;

        function searchTicketLogs(columnValues) {
            vm.search = true;
            TicketsLogs.query({ticketNumber: columnValues},function (result) {
                vm.ticketsLogs=result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsFeedbackDialogController', TicketsFeedbackDialogController);

    TicketsFeedbackDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TicketsFeedback'];

    function TicketsFeedbackDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TicketsFeedback) {
        var vm = this;

        vm.ticketsFeedback = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticketsFeedback.id !== null) {
                TicketsFeedback.update(vm.ticketsFeedback, onSaveSuccess, onSaveError);
            } else {
                TicketsFeedback.save(vm.ticketsFeedback, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:ticketsFeedbackUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.ratingDate = false;
        vm.datePickerOpenStatus.closingDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsFeedbackDetailController', TicketsFeedbackDetailController);

    TicketsFeedbackDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TicketsFeedback'];

    function TicketsFeedbackDetailController($scope, $rootScope, $stateParams, previousState, entity, TicketsFeedback) {
        var vm = this;

        vm.ticketsFeedback = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:ticketsFeedbackUpdate', function(event, result) {
            vm.ticketsFeedback = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsFeedbackDeleteController',TicketsFeedbackDeleteController);

    TicketsFeedbackDeleteController.$inject = ['$uibModalInstance', 'entity', 'TicketsFeedback'];

    function TicketsFeedbackDeleteController($uibModalInstance, entity, TicketsFeedback) {
        var vm = this;

        vm.ticketsFeedback = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TicketsFeedback.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tickets-feedback', {
            parent: 'entity',
            url: '/tickets-feedback',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.ticketsFeedback.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tickets-feedback/tickets-feedbacks.html',
                    controller: 'TicketsFeedbackController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketsFeedback');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tickets-feedback-detail', {
            parent: 'tickets-feedback',
            url: '/tickets-feedback/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.ticketsFeedback.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tickets-feedback/tickets-feedback-detail.html',
                    controller: 'TicketsFeedbackDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketsFeedback');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TicketsFeedback', function($stateParams, TicketsFeedback) {
                    return TicketsFeedback.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tickets-feedback',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tickets-feedback-detail.edit', {
            parent: 'tickets-feedback-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-feedback/tickets-feedback-dialog.html',
                    controller: 'TicketsFeedbackDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketsFeedback', function(TicketsFeedback) {
                            return TicketsFeedback.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tickets-feedback.new', {
            parent: 'tickets-feedback',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-feedback/tickets-feedback-dialog.html',
                    controller: 'TicketsFeedbackDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ticketNumber: null,
                                category: null,
                                investorDetail: null,
                                investorName: null,
                                rating: null,
                                ratingRemark: null,
                                ratingDate: null,
                                departmentName: null,
                                closedBy: null,
                                closingDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tickets-feedback', null, { reload: 'tickets-feedback' });
                }, function() {
                    $state.go('tickets-feedback');
                });
            }]
        })
        .state('tickets-feedback.edit', {
            parent: 'tickets-feedback',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-feedback/tickets-feedback-dialog.html',
                    controller: 'TicketsFeedbackDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketsFeedback', function(TicketsFeedback) {
                            return TicketsFeedback.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tickets-feedback', null, { reload: 'tickets-feedback' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tickets-feedback.delete', {
            parent: 'tickets-feedback',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-feedback/tickets-feedback-delete-dialog.html',
                    controller: 'TicketsFeedbackDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TicketsFeedback', function(TicketsFeedback) {
                            return TicketsFeedback.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tickets-feedback', null, { reload: 'tickets-feedback' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TicketsFeedback', TicketsFeedback);

    TicketsFeedback.$inject = ['$resource', 'DateUtils'];

    function TicketsFeedback ($resource, DateUtils) {
        var resourceUrl =  'api/tickets-feedbacks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.ratingDate = DateUtils.convertDateTimeFromServer(data.ratingDate);
                        data.closingDate = DateUtils.convertDateTimeFromServer(data.closingDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsFeedbackController', TicketsFeedbackController);

    TicketsFeedbackController.$inject = ['$state', 'TicketsFeedback'];

    function TicketsFeedbackController($state, TicketsFeedback) {

        var vm = this;
        vm.ticketFeedback={};
        vm.selectedFeedback=selectedFeedback;
        vm.deleteFeedback=deleteFeedback;
        vm.ticketsFeedbacks = [];

        loadAll();

        function loadAll() {
            TicketsFeedback.query(function(result) {
                vm.ticketsFeedbacks = result;
                vm.searchQuery = null;
            });
        }

        function selectedFeedback(tktsFeedback) {
            vm.ticketFeedback = tktsFeedback;
        }

        function deleteFeedback(feedback) {
            TicketsFeedback.delete({id:feedback.id, ticketNumber: feedback.ticketNumber}, function (result) {
                alert("SuccessFully Delete");
                location.reload();
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsCustomerDialogController', TicketsCustomerDialogController);

    TicketsCustomerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TicketsCustomer'];

    function TicketsCustomerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TicketsCustomer) {
        var vm = this;

        vm.ticketsCustomer = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticketsCustomer.id !== null) {
                TicketsCustomer.update(vm.ticketsCustomer, onSaveSuccess, onSaveError);
            } else {
                TicketsCustomer.save(vm.ticketsCustomer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:ticketsCustomerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsCustomerDetailController', TicketsCustomerDetailController);

    TicketsCustomerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TicketsCustomer'];

    function TicketsCustomerDetailController($scope, $rootScope, $stateParams, previousState, entity, TicketsCustomer) {
        var vm = this;

        vm.ticketsCustomer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:ticketsCustomerUpdate', function(event, result) {
            vm.ticketsCustomer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsCustomerDeleteController',TicketsCustomerDeleteController);

    TicketsCustomerDeleteController.$inject = ['$uibModalInstance', 'entity', 'TicketsCustomer'];

    function TicketsCustomerDeleteController($uibModalInstance, entity, TicketsCustomer) {
        var vm = this;

        vm.ticketsCustomer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TicketsCustomer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tickets-customer', {
            parent: 'entity',
            url: '/tickets-customer',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.ticketsCustomer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tickets-customer/tickets-customers.html',
                    controller: 'TicketsCustomerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketsCustomer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tickets-customer-detail', {
            parent: 'tickets-customer',
            url: '/tickets-customer/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.ticketsCustomer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tickets-customer/tickets-customer-detail.html',
                    controller: 'TicketsCustomerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketsCustomer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TicketsCustomer', function($stateParams, TicketsCustomer) {
                    return TicketsCustomer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tickets-customer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tickets-customer-detail.edit', {
            parent: 'tickets-customer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-customer/tickets-customer-dialog.html',
                    controller: 'TicketsCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketsCustomer', function(TicketsCustomer) {
                            return TicketsCustomer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tickets-customer.new', {
            parent: 'tickets-customer',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-customer/tickets-customer-dialog.html',
                    controller: 'TicketsCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                firstName: null,
                                lastName: null,
                                mobileNumber: null,
                                email: null,
                                district: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tickets-customer', null, { reload: 'tickets-customer' });
                }, function() {
                    $state.go('tickets-customer');
                });
            }]
        })
        .state('tickets-customer.edit', {
            parent: 'tickets-customer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-customer/tickets-customer-dialog.html',
                    controller: 'TicketsCustomerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketsCustomer', function(TicketsCustomer) {
                            return TicketsCustomer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tickets-customer', null, { reload: 'tickets-customer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tickets-customer.delete', {
            parent: 'tickets-customer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets-customer/tickets-customer-delete-dialog.html',
                    controller: 'TicketsCustomerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TicketsCustomer', function(TicketsCustomer) {
                            return TicketsCustomer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tickets-customer', null, { reload: 'tickets-customer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TicketsCustomer', TicketsCustomer);

    TicketsCustomer.$inject = ['$resource'];

    function TicketsCustomer ($resource) {
        var resourceUrl =  'api/tickets-customers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsCustomerController', TicketsCustomerController);

    TicketsCustomerController.$inject = ['TicketsCustomer'];

    function TicketsCustomerController(TicketsCustomer) {

        var vm = this;

        vm.ticketsCustomers = [];

        loadAll();

        function loadAll() {
            TicketsCustomer.query(function(result) {
                vm.ticketsCustomers = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsDialogController', TicketsDialogController);

    TicketsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Tickets', 'AdminTickets'];

    function TicketsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Tickets, AdminTickets) {
        var vm = this;
        vm.saveWithLogs = false;
        vm.tickets = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tickets.id !== null) {
                if(vm.saveWithLogs === true) {
                    vm.tickets.adminSaveWithLogs = "Add-Logs";
                } else {
                    vm.tickets.adminSaveWithLogs = "No-Logs";
                }

                AdminTickets.update(vm.tickets, onSaveSuccess, onSaveError);
            } else {
                Tickets.save(vm.tickets, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:ticketsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.resolveDate = false;
        vm.datePickerOpenStatus.assignDate = false;
        vm.datePickerOpenStatus.expectedResoluation = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsDetailController', TicketsDetailController);

    TicketsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tickets'];

    function TicketsDetailController($scope, $rootScope, $stateParams, previousState, entity, Tickets) {
        var vm = this;

        vm.tickets = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:ticketsUpdate', function(event, result) {
            vm.tickets = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsDeleteController',TicketsDeleteController);

    TicketsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Tickets'];

    function TicketsDeleteController($uibModalInstance, entity, Tickets) {
        var vm = this;

        vm.tickets = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tickets.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tickets', {
            parent: 'entity',
            url: '/tickets',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.tickets.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tickets/tickets.html',
                    controller: 'TicketsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tickets');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tickets-detail', {
            parent: 'tickets',
            url: '/tickets/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.tickets.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tickets/tickets-detail.html',
                    controller: 'TicketsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tickets');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tickets', function($stateParams, Tickets) {
                    return Tickets.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tickets',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tickets-detail.edit', {
            parent: 'tickets-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets/tickets-dialog.html',
                    controller: 'TicketsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tickets', function(Tickets) {
                            return Tickets.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tickets.new', {
            parent: 'tickets',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets/tickets-dialog.html',
                    controller: 'TicketsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                ticketNumber: null,
                                cafpin: null,
                                investorDetail: null,
                                latestRemark: null,
                                creationDate: null,
                                resolveDate: null,
                                assignDate: null,
                                assignedDepartmentId: null,
                                assignedDepartmentName: null,
                                assignedMemberId: null,
                                assignedMemberName: null,
                                subject: null,
                                description: null,
                                status: null,
                                projectid: null,
                                serviceid: null,
                                priority: null,
                                incidentCategory: null,
                                level: null,
                                investorType: null,
                                nextLevelMember: null,
                                timeLeft: null,
                                expectedResoluation: null,
                                nextLevelMemberId: null,
                                createdBy: null,
                                attachment: null,
                                assignedMemberUserName: null,
                                nextLevelMemberName: null,
                                createdByName: null,
                                isOpen: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tickets', null, { reload: 'tickets' });
                }, function() {
                    $state.go('tickets');
                });
            }]
        })
        .state('tickets.edit', {
            parent: 'tickets',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets/tickets-dialog.html',
                    controller: 'TicketsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tickets', function(Tickets) {
                            return Tickets.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tickets', null, { reload: 'tickets' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tickets.delete', {
            parent: 'tickets',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tickets/tickets-delete-dialog.html',
                    controller: 'TicketsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tickets', function(Tickets) {
                            return Tickets.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tickets', null, { reload: 'tickets' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Tickets', Tickets);

    Tickets.$inject = ['$resource', 'DateUtils'];

    function Tickets ($resource, DateUtils) {
        var resourceUrl =  'api/tickets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.resolveDate = DateUtils.convertDateTimeFromServer(data.resolveDate);
                        data.assignDate = DateUtils.convertDateTimeFromServer(data.assignDate);
                        data.expectedResoluation = DateUtils.convertDateTimeFromServer(data.expectedResoluation);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketsController', TicketsController);

    TicketsController.$inject = ['Tickets'];

    function TicketsController(Tickets) {

        var vm = this;
        vm.tickets = [];
        vm.search = false;
        vm.searchTicket = searchTicket;

        function searchTicket(columnValues) {
            vm.search = true;
            Tickets.query({columnKey: "ticketNumber", columnValue: columnValues }, function (result) {
                vm.tickets=result;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketMemberDialogController', TicketMemberDialogController);

    TicketMemberDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TicketMember'];

    function TicketMemberDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TicketMember) {
        var vm = this;

        vm.ticketMember = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticketMember.id !== null) {
                TicketMember.update(vm.ticketMember, onSaveSuccess, onSaveError);
            } else {
                TicketMember.save(vm.ticketMember, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:ticketMemberUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketMemberDetailController', TicketMemberDetailController);

    TicketMemberDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TicketMember'];

    function TicketMemberDetailController($scope, $rootScope, $stateParams, previousState, entity, TicketMember) {
        var vm = this;

        vm.ticketMember = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:ticketMemberUpdate', function(event, result) {
            vm.ticketMember = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketMemberDeleteController',TicketMemberDeleteController);

    TicketMemberDeleteController.$inject = ['$uibModalInstance', 'entity', 'TicketMember'];

    function TicketMemberDeleteController($uibModalInstance, entity, TicketMember) {
        var vm = this;

        vm.ticketMember = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TicketMember.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket-member', {
            parent: 'entity',
            url: '/ticket-member',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.ticketMember.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-member/ticket-members.html',
                    controller: 'TicketMemberController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketMember');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticket-member-detail', {
            parent: 'ticket-member',
            url: '/ticket-member/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.ticketMember.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-member/ticket-member-detail.html',
                    controller: 'TicketMemberDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketMember');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TicketMember', function($stateParams, TicketMember) {
                    return TicketMember.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticket-member',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ticket-member-detail.edit', {
            parent: 'ticket-member-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-member/ticket-member-dialog.html',
                    controller: 'TicketMemberDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketMember', function(TicketMember) {
                            return TicketMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-member.new', {
            parent: 'ticket-member',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-member/ticket-member-dialog.html',
                    controller: 'TicketMemberDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                login: null,
                                firstName: null,
                                lastName: null,
                                email: null,
                                authorities: null,
                                mobile: null,
                                address: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ticket-member', null, { reload: 'ticket-member' });
                }, function() {
                    $state.go('ticket-member');
                });
            }]
        })
        .state('ticket-member.edit', {
            parent: 'ticket-member',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-member/ticket-member-dialog.html',
                    controller: 'TicketMemberDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketMember', function(TicketMember) {
                            return TicketMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-member', null, { reload: 'ticket-member' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-member.delete', {
            parent: 'ticket-member',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-member/ticket-member-delete-dialog.html',
                    controller: 'TicketMemberDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TicketMember', function(TicketMember) {
                            return TicketMember.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-member', null, { reload: 'ticket-member' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TicketMember', TicketMember);

    TicketMember.$inject = ['$resource'];

    function TicketMember ($resource) {
        var resourceUrl =  'api/ticket-members/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketMemberController', TicketMemberController);

    TicketMemberController.$inject = ['TicketMember'];

    function TicketMemberController(TicketMember) {

        var vm = this;

        vm.ticketMembers = [];

        loadAll();

        function loadAll() {
            TicketMember.query(function(result) {
                vm.ticketMembers = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketDepartmentsDialogController', TicketDepartmentsDialogController);

    TicketDepartmentsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'TicketDepartments'];

    function TicketDepartmentsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, TicketDepartments) {
        var vm = this;

        vm.ticketDepartments = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.ticketDepartments.id !== null) {
                TicketDepartments.update(vm.ticketDepartments, onSaveSuccess, onSaveError);
            } else {
                TicketDepartments.save(vm.ticketDepartments, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:ticketDepartmentsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketDepartmentsDetailController', TicketDepartmentsDetailController);

    TicketDepartmentsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'TicketDepartments'];

    function TicketDepartmentsDetailController($scope, $rootScope, $stateParams, previousState, entity, TicketDepartments) {
        var vm = this;

        vm.ticketDepartments = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:ticketDepartmentsUpdate', function(event, result) {
            vm.ticketDepartments = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketDepartmentsDeleteController',TicketDepartmentsDeleteController);

    TicketDepartmentsDeleteController.$inject = ['$uibModalInstance', 'entity', 'TicketDepartments'];

    function TicketDepartmentsDeleteController($uibModalInstance, entity, TicketDepartments) {
        var vm = this;

        vm.ticketDepartments = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            TicketDepartments.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ticket-departments', {
            parent: 'entity',
            url: '/ticket-departments',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.ticketDepartments.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-departments/ticket-departments.html',
                    controller: 'TicketDepartmentsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketDepartments');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ticket-departments-detail', {
            parent: 'ticket-departments',
            url: '/ticket-departments/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.ticketDepartments.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ticket-departments/ticket-departments-detail.html',
                    controller: 'TicketDepartmentsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ticketDepartments');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'TicketDepartments', function($stateParams, TicketDepartments) {
                    return TicketDepartments.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ticket-departments',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ticket-departments-detail.edit', {
            parent: 'ticket-departments-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-departments/ticket-departments-dialog.html',
                    controller: 'TicketDepartmentsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketDepartments', function(TicketDepartments) {
                            return TicketDepartments.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-departments.new', {
            parent: 'ticket-departments',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-departments/ticket-departments-dialog.html',
                    controller: 'TicketDepartmentsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                departmentName: null,
                                hodLogin: null,
                                nodalLogin: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ticket-departments', null, { reload: 'ticket-departments' });
                }, function() {
                    $state.go('ticket-departments');
                });
            }]
        })
        .state('ticket-departments.edit', {
            parent: 'ticket-departments',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-departments/ticket-departments-dialog.html',
                    controller: 'TicketDepartmentsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['TicketDepartments', function(TicketDepartments) {
                            return TicketDepartments.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-departments', null, { reload: 'ticket-departments' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ticket-departments.delete', {
            parent: 'ticket-departments',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ticket-departments/ticket-departments-delete-dialog.html',
                    controller: 'TicketDepartmentsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['TicketDepartments', function(TicketDepartments) {
                            return TicketDepartments.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ticket-departments', null, { reload: 'ticket-departments' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TicketDepartments', TicketDepartments);

    TicketDepartments.$inject = ['$resource'];

    function TicketDepartments ($resource) {
        var resourceUrl =  'api/ticket-departments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TicketDepartmentsController', TicketDepartmentsController);

    TicketDepartmentsController.$inject = ['TicketDepartments'];

    function TicketDepartmentsController(TicketDepartments) {

        var vm = this;

        vm.ticketDepartments = [];

        loadAll();

        function loadAll() {
            TicketDepartments.query(function(result) {
                vm.ticketDepartments = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Term_declaration_acceptDialogController', Term_declaration_acceptDialogController);

    Term_declaration_acceptDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Term_declaration_accept'];

    function Term_declaration_acceptDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Term_declaration_accept) {
        var vm = this;

        vm.term_declaration_accept = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.term_declaration_accept.id !== null) {
                Term_declaration_accept.update(vm.term_declaration_accept, onSaveSuccess, onSaveError);
            } else {
                Term_declaration_accept.save(vm.term_declaration_accept, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:term_declaration_acceptUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.applicationdate = false;
        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Term_declaration_acceptDetailController', Term_declaration_acceptDetailController);

    Term_declaration_acceptDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Term_declaration_accept'];

    function Term_declaration_acceptDetailController($scope, $rootScope, $stateParams, previousState, entity, Term_declaration_accept) {
        var vm = this;

        vm.term_declaration_accept = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:term_declaration_acceptUpdate', function(event, result) {
            vm.term_declaration_accept = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Term_declaration_acceptDeleteController',Term_declaration_acceptDeleteController);

    Term_declaration_acceptDeleteController.$inject = ['$uibModalInstance', 'entity', 'Term_declaration_accept'];

    function Term_declaration_acceptDeleteController($uibModalInstance, entity, Term_declaration_accept) {
        var vm = this;

        vm.term_declaration_accept = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Term_declaration_accept.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('term-declaration-accept', {
            parent: 'entity',
            url: '/term-declaration-accept',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.term_declaration_accept.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/term-declaration-accept/term-declaration-accepts.html',
                    controller: 'Term_declaration_acceptController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('term_declaration_accept');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('term-declaration-accept-detail', {
            parent: 'term-declaration-accept',
            url: '/term-declaration-accept/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.term_declaration_accept.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/term-declaration-accept/term-declaration-accept-detail.html',
                    controller: 'Term_declaration_acceptDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('term_declaration_accept');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Term_declaration_accept', function($stateParams, Term_declaration_accept) {
                    return Term_declaration_accept.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'term-declaration-accept',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('term-declaration-accept-detail.edit', {
            parent: 'term-declaration-accept-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/term-declaration-accept/term-declaration-accept-dialog.html',
                    controller: 'Term_declaration_acceptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Term_declaration_accept', function(Term_declaration_accept) {
                            return Term_declaration_accept.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('term-declaration-accept.new', {
            parent: 'term-declaration-accept',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/term-declaration-accept/term-declaration-accept-dialog.html',
                    controller: 'Term_declaration_acceptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                acceptance: null,
                                applicationdate: null,
                                place: null,
                                createdate: null,
                                updatedate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('term-declaration-accept', null, { reload: 'term-declaration-accept' });
                }, function() {
                    $state.go('term-declaration-accept');
                });
            }]
        })
        .state('term-declaration-accept.edit', {
            parent: 'term-declaration-accept',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/term-declaration-accept/term-declaration-accept-dialog.html',
                    controller: 'Term_declaration_acceptDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Term_declaration_accept', function(Term_declaration_accept) {
                            return Term_declaration_accept.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('term-declaration-accept', null, { reload: 'term-declaration-accept' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('term-declaration-accept.delete', {
            parent: 'term-declaration-accept',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/term-declaration-accept/term-declaration-accept-delete-dialog.html',
                    controller: 'Term_declaration_acceptDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Term_declaration_accept', function(Term_declaration_accept) {
                            return Term_declaration_accept.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('term-declaration-accept', null, { reload: 'term-declaration-accept' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Term_declaration_accept', Term_declaration_accept);

    Term_declaration_accept.$inject = ['$resource', 'DateUtils'];

    function Term_declaration_accept ($resource, DateUtils) {
        var resourceUrl =  'api/term-declaration-accepts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.applicationdate = DateUtils.convertDateTimeFromServer(data.applicationdate);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Term_declaration_acceptController', Term_declaration_acceptController);

    Term_declaration_acceptController.$inject = ['Term_declaration_accept'];

    function Term_declaration_acceptController(Term_declaration_accept) {

        var vm = this;

        vm.term_declaration_accepts = [];

        loadAll();

        function loadAll() {
            Term_declaration_accept.query(function(result) {
                vm.term_declaration_accepts = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tehsil_subtehsilDialogController', Tehsil_subtehsilDialogController);

    Tehsil_subtehsilDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Tehsil_subtehsil'];

    function Tehsil_subtehsilDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Tehsil_subtehsil) {
        var vm = this;

        vm.tehsil_subtehsil = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.tehsil_subtehsil.id !== null) {
                Tehsil_subtehsil.update(vm.tehsil_subtehsil, onSaveSuccess, onSaveError);
            } else {
                Tehsil_subtehsil.save(vm.tehsil_subtehsil, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:tehsil_subtehsilUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tehsil_subtehsilDetailController', Tehsil_subtehsilDetailController);

    Tehsil_subtehsilDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Tehsil_subtehsil'];

    function Tehsil_subtehsilDetailController($scope, $rootScope, $stateParams, previousState, entity, Tehsil_subtehsil) {
        var vm = this;

        vm.tehsil_subtehsil = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:tehsil_subtehsilUpdate', function(event, result) {
            vm.tehsil_subtehsil = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tehsil_subtehsilDeleteController',Tehsil_subtehsilDeleteController);

    Tehsil_subtehsilDeleteController.$inject = ['$uibModalInstance', 'entity', 'Tehsil_subtehsil'];

    function Tehsil_subtehsilDeleteController($uibModalInstance, entity, Tehsil_subtehsil) {
        var vm = this;

        vm.tehsil_subtehsil = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Tehsil_subtehsil.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('tehsil-subtehsil', {
            parent: 'entity',
            url: '/tehsil-subtehsil',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.tehsil_subtehsil.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tehsil-subtehsil/tehsil-subtehsils.html',
                    controller: 'Tehsil_subtehsilController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tehsil_subtehsil');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('tehsil-subtehsil-detail', {
            parent: 'tehsil-subtehsil',
            url: '/tehsil-subtehsil/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.tehsil_subtehsil.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/tehsil-subtehsil/tehsil-subtehsil-detail.html',
                    controller: 'Tehsil_subtehsilDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('tehsil_subtehsil');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Tehsil_subtehsil', function($stateParams, Tehsil_subtehsil) {
                    return Tehsil_subtehsil.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'tehsil-subtehsil',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('tehsil-subtehsil-detail.edit', {
            parent: 'tehsil-subtehsil-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tehsil-subtehsil/tehsil-subtehsil-dialog.html',
                    controller: 'Tehsil_subtehsilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tehsil_subtehsil', function(Tehsil_subtehsil) {
                            return Tehsil_subtehsil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tehsil-subtehsil.new', {
            parent: 'tehsil-subtehsil',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tehsil-subtehsil/tehsil-subtehsil-dialog.html',
                    controller: 'Tehsil_subtehsilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                tehsil_subtehsilname: null,
                                districtname: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('tehsil-subtehsil', null, { reload: 'tehsil-subtehsil' });
                }, function() {
                    $state.go('tehsil-subtehsil');
                });
            }]
        })
        .state('tehsil-subtehsil.edit', {
            parent: 'tehsil-subtehsil',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tehsil-subtehsil/tehsil-subtehsil-dialog.html',
                    controller: 'Tehsil_subtehsilDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Tehsil_subtehsil', function(Tehsil_subtehsil) {
                            return Tehsil_subtehsil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tehsil-subtehsil', null, { reload: 'tehsil-subtehsil' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('tehsil-subtehsil.delete', {
            parent: 'tehsil-subtehsil',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/tehsil-subtehsil/tehsil-subtehsil-delete-dialog.html',
                    controller: 'Tehsil_subtehsilDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Tehsil_subtehsil', function(Tehsil_subtehsil) {
                            return Tehsil_subtehsil.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('tehsil-subtehsil', null, { reload: 'tehsil-subtehsil' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Tehsil_subtehsil', Tehsil_subtehsil);

    Tehsil_subtehsil.$inject = ['$resource'];

    function Tehsil_subtehsil ($resource) {
        var resourceUrl =  'api/tehsil-subtehsils/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Tehsil_subtehsilController', Tehsil_subtehsilController);

    Tehsil_subtehsilController.$inject = ['Tehsil_subtehsil'];

    function Tehsil_subtehsilController(Tehsil_subtehsil) {

        var vm = this;

        vm.tehsil_subtehsils = [];

        loadAll();

        function loadAll() {
            Tehsil_subtehsil.query(function(result) {
                vm.tehsil_subtehsils = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SurveyDialogController', SurveyDialogController);

    SurveyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Survey'];

    function SurveyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Survey) {
        var vm = this;

        vm.survey = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.survey.id !== null) {
                Survey.update(vm.survey, onSaveSuccess, onSaveError);
            } else {
                Survey.save(vm.survey, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:surveyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.investmentDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SurveyDetailController', SurveyDetailController);

    SurveyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Survey'];

    function SurveyDetailController($scope, $rootScope, $stateParams, previousState, entity, Survey) {
        var vm = this;

        vm.survey = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:surveyUpdate', function(event, result) {
            vm.survey = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SurveyDeleteController',SurveyDeleteController);

    SurveyDeleteController.$inject = ['$uibModalInstance', 'entity', 'Survey'];

    function SurveyDeleteController($uibModalInstance, entity, Survey) {
        var vm = this;

        vm.survey = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Survey.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('survey', {
            parent: 'entity',
            url: '/survey',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.survey.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/survey/surveys.html',
                    controller: 'SurveyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('survey');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('survey-detail', {
            parent: 'survey',
            url: '/survey/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.survey.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/survey/survey-detail.html',
                    controller: 'SurveyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('survey');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Survey', function($stateParams, Survey) {
                    return Survey.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'survey',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('survey-detail.edit', {
            parent: 'survey-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey/survey-dialog.html',
                    controller: 'SurveyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Survey', function(Survey) {
                            return Survey.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('survey.new', {
            parent: 'survey',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey/survey-dialog.html',
                    controller: 'SurveyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                investmentDate: null,
                                groundedInvestment: null,
                                groundedEmployement: null,
                                isEmployed: null,
                                isSubsidy: null,
                                isAppliedSubsidy: null,
                                isKnowledgePolicy: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('survey', null, { reload: 'survey' });
                }, function() {
                    $state.go('survey');
                });
            }]
        })
        .state('survey.edit', {
            parent: 'survey',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey/survey-dialog.html',
                    controller: 'SurveyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Survey', function(Survey) {
                            return Survey.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('survey', null, { reload: 'survey' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('survey.delete', {
            parent: 'survey',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/survey/survey-delete-dialog.html',
                    controller: 'SurveyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Survey', function(Survey) {
                            return Survey.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('survey', null, { reload: 'survey' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Survey', Survey);

    Survey.$inject = ['$resource', 'DateUtils'];

    function Survey ($resource, DateUtils) {
        var resourceUrl =  'api/surveys/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.investmentDate = DateUtils.convertDateTimeFromServer(data.investmentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SurveyController', SurveyController);

    SurveyController.$inject = ['Survey'];

    function SurveyController(Survey) {

        var vm = this;

        vm.surveys = [];

        loadAll();

        function loadAll() {
            Survey.query(function(result) {
                vm.surveys = result;
                vm.show = true;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SupplyAndDisposalDialogController', SupplyAndDisposalDialogController);

    SupplyAndDisposalDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SupplyAndDisposal'];

    function SupplyAndDisposalDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SupplyAndDisposal) {
        var vm = this;

        vm.supplyAndDisposal = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.supplyAndDisposal.id !== null) {
                SupplyAndDisposal.update(vm.supplyAndDisposal, onSaveSuccess, onSaveError);
            } else {
                SupplyAndDisposal.save(vm.supplyAndDisposal, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:supplyAndDisposalUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.appliedDate = false;
        vm.datePickerOpenStatus.rejectedDate = false;
        vm.datePickerOpenStatus.clearedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SupplyAndDisposalDetailController', SupplyAndDisposalDetailController);

    SupplyAndDisposalDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SupplyAndDisposal'];

    function SupplyAndDisposalDetailController($scope, $rootScope, $stateParams, previousState, entity, SupplyAndDisposal) {
        var vm = this;

        vm.supplyAndDisposal = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:supplyAndDisposalUpdate', function(event, result) {
            vm.supplyAndDisposal = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SupplyAndDisposalDeleteController',SupplyAndDisposalDeleteController);

    SupplyAndDisposalDeleteController.$inject = ['$uibModalInstance', 'entity', 'SupplyAndDisposal'];

    function SupplyAndDisposalDeleteController($uibModalInstance, entity, SupplyAndDisposal) {
        var vm = this;

        vm.supplyAndDisposal = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SupplyAndDisposal.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('supply-and-disposal', {
            parent: 'entity',
            url: '/supply-and-disposal',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.supplyAndDisposal.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/supply-and-disposal/supply-and-disposals.html',
                    controller: 'SupplyAndDisposalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('supplyAndDisposal');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('supply-and-disposal-detail', {
            parent: 'supply-and-disposal',
            url: '/supply-and-disposal/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.supplyAndDisposal.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/supply-and-disposal/supply-and-disposal-detail.html',
                    controller: 'SupplyAndDisposalDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('supplyAndDisposal');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SupplyAndDisposal', function($stateParams, SupplyAndDisposal) {
                    return SupplyAndDisposal.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'supply-and-disposal',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('supply-and-disposal-detail.edit', {
            parent: 'supply-and-disposal-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/supply-and-disposal/supply-and-disposal-dialog.html',
                    controller: 'SupplyAndDisposalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SupplyAndDisposal', function(SupplyAndDisposal) {
                            return SupplyAndDisposal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('supply-and-disposal.new', {
            parent: 'supply-and-disposal',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/supply-and-disposal/supply-and-disposal-dialog.html',
                    controller: 'SupplyAndDisposalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                applicationNumber: null,
                                name: null,
                                appliedDate: null,
                                rejectedDate: null,
                                clearedDate: null,
                                lastAction: null,
                                lastActionBy: null,
                                appliedBy: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('supply-and-disposal', null, { reload: 'supply-and-disposal' });
                }, function() {
                    $state.go('supply-and-disposal');
                });
            }]
        })
        .state('supply-and-disposal.edit', {
            parent: 'supply-and-disposal',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/supply-and-disposal/supply-and-disposal-dialog.html',
                    controller: 'SupplyAndDisposalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SupplyAndDisposal', function(SupplyAndDisposal) {
                            return SupplyAndDisposal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('supply-and-disposal', null, { reload: 'supply-and-disposal' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('supply-and-disposal.delete', {
            parent: 'supply-and-disposal',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/supply-and-disposal/supply-and-disposal-delete-dialog.html',
                    controller: 'SupplyAndDisposalDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SupplyAndDisposal', function(SupplyAndDisposal) {
                            return SupplyAndDisposal.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('supply-and-disposal', null, { reload: 'supply-and-disposal' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SupplyAndDisposal', SupplyAndDisposal);

    SupplyAndDisposal.$inject = ['$resource', 'DateUtils'];

    function SupplyAndDisposal ($resource, DateUtils) {
        var resourceUrl =  'api/supply-and-disposals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.appliedDate = DateUtils.convertDateTimeFromServer(data.appliedDate);
                        data.rejectedDate = DateUtils.convertDateTimeFromServer(data.rejectedDate);
                        data.clearedDate = DateUtils.convertDateTimeFromServer(data.clearedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SupplyAndDisposalController', SupplyAndDisposalController);

    SupplyAndDisposalController.$inject = ['SupplyAndDisposal'];

    function SupplyAndDisposalController(SupplyAndDisposal) {

        var vm = this;

        vm.supplyAndDisposals = [];

        loadAll();

        function loadAll() {
            SupplyAndDisposal.query(function(result) {
                vm.supplyAndDisposals = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('StateDialogController', StateDialogController);

    StateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'State', 'Country'];

    function StateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, State, Country) {
        var vm = this;

        vm.state = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

         Country.query(function(result) {
                   vm.countries = result;
                   vm.searchQuery = null;
               });



        load();
        function load()
        {
        vm.id=$stateParams.countryID;
        Country.get({id: vm.id},function(result)
        {
        $scope.selected= {id: result.id, countryname: result.countryname}
        });
        }


        function save () {
            vm.isSaving = true;
            vm.state.countryID = $scope.selected.id;
            vm.state.countryname = $scope.selected.countryname;
            if (vm.state.id !== null) {
                State.update(vm.state, onSaveSuccess, onSaveError);
            } else {
                State.save(vm.state, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:stateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('StateDetailController', StateDetailController);

    StateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'State'];

    function StateDetailController($scope, $rootScope, $stateParams, previousState, entity, State) {
        var vm = this;

        vm.state = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:stateUpdate', function(event, result) {
            vm.state = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('StateDeleteController',StateDeleteController);

    StateDeleteController.$inject = ['$uibModalInstance', 'entity', 'State'];

    function StateDeleteController($uibModalInstance, entity, State) {
        var vm = this;

        vm.state = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            State.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('state', {
            parent: 'entity',
            url: '/state',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.state.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/state/states.html',
                    controller: 'StateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('state-detail', {
            parent: 'state',
            url: '/state/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.state.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/state/state-detail.html',
                    controller: 'StateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'State', function($stateParams, State) {
                    return State.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'state',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('state-detail.edit', {
            parent: 'state-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-dialog.html',
                    controller: 'StateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['State', function(State) {
                            return State.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('state.new', {
            parent: 'state',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-dialog.html',
                    controller: 'StateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                statename: null,
                                countryname: null,
                                countryID: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('state', null, { reload: 'state' });
                }, function() {
                    $state.go('state');
                });
            }]
        })
        .state('state.edit', {
            parent: 'state',
            url: '/?{id}/{countryID}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-dialog.html',
                    controller: 'StateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['State', function(State) {
                            return State.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('state', null, { reload: 'state' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('state.delete', {
            parent: 'state',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/state/state-delete-dialog.html',
                    controller: 'StateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['State', function(State) {
                            return State.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('state', null, { reload: 'state' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('State', State);

    State.$inject = ['$resource'];

    function State ($resource) {
        var resourceUrl =  'api/states/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('StateController', StateController);

    StateController.$inject = ['State','$stateParams','Country'];

    function StateController(State, $stateParams, Country) {

        var vm = this;

        vm.states = [];

        loadAll();

        function loadAll() {
            State.query(function(result) {
                vm.states = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('countrystateController', countrystateController);

    countrystateController.$inject = ['$scope','$http'];

    function countrystateController($scope, $http) {
        $http.get("/api/countries").then(function(response) {
           return $scope.students = response.data;
       });
    }
//    function distcountryController($scope, $http) {
//       // $http.get("country.js").then(function(response) {
//           return $scope.students = [
//            {
//            "id":"20c7501a-b84a-4f32-891c-289a0d76eeb8",
//            "cname":"INDIA"
//            },
//            {
//                "id":"7f2bbaa1-c6b0-4310-9d27-b013e20f5c70",
//                "cname":"ENGLAND"
//            }
//        ];
       //});
    //}



})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SkillsDataDialogController', SkillsDataDialogController);

    SkillsDataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SkillsData'];

    function SkillsDataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SkillsData) {
        var vm = this;

        vm.skillsData = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.skillsData.id !== null) {
                SkillsData.update(vm.skillsData, onSaveSuccess, onSaveError);
            } else {
                SkillsData.save(vm.skillsData, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:skillsDataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SkillsDataDetailController', SkillsDataDetailController);

    SkillsDataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SkillsData'];

    function SkillsDataDetailController($scope, $rootScope, $stateParams, previousState, entity, SkillsData) {
        var vm = this;

        vm.skillsData = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:skillsDataUpdate', function(event, result) {
            vm.skillsData = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SkillsDataDeleteController',SkillsDataDeleteController);

    SkillsDataDeleteController.$inject = ['$uibModalInstance', 'entity', 'SkillsData'];

    function SkillsDataDeleteController($uibModalInstance, entity, SkillsData) {
        var vm = this;

        vm.skillsData = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SkillsData.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('skills-data', {
            parent: 'entity',
            url: '/skills-data',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.skillsData.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/skills-data/skills-data.html',
                    controller: 'SkillsDataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('skillsData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('skills-data-detail', {
            parent: 'skills-data',
            url: '/skills-data/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.skillsData.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/skills-data/skills-data-detail.html',
                    controller: 'SkillsDataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('skillsData');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SkillsData', function($stateParams, SkillsData) {
                    return SkillsData.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'skills-data',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('skills-data-detail.edit', {
            parent: 'skills-data-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skills-data/skills-data-dialog.html',
                    controller: 'SkillsDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SkillsData', function(SkillsData) {
                            return SkillsData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('skills-data.new', {
            parent: 'skills-data',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skills-data/skills-data-dialog.html',
                    controller: 'SkillsDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                district: null,
                                sector: null,
                                jobRole: null,
                                requiredLabour: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('skills-data', null, { reload: 'skills-data' });
                }, function() {
                    $state.go('skills-data');
                });
            }]
        })
        .state('skills-data.edit', {
            parent: 'skills-data',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skills-data/skills-data-dialog.html',
                    controller: 'SkillsDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SkillsData', function(SkillsData) {
                            return SkillsData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('skills-data', null, { reload: 'skills-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('skills-data.delete', {
            parent: 'skills-data',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/skills-data/skills-data-delete-dialog.html',
                    controller: 'SkillsDataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SkillsData', function(SkillsData) {
                            return SkillsData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('skills-data', null, { reload: 'skills-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SkillsData', SkillsData);

    SkillsData.$inject = ['$resource'];

    function SkillsData ($resource) {
        var resourceUrl =  'api/skills-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SkillsDataController', SkillsDataController);

    SkillsDataController.$inject = ['SkillsData'];

    function SkillsDataController(SkillsData) {

        var vm = this;

        vm.skillsData = [];

        loadAll();

        function loadAll() {
            SkillsData.query(function(result) {
                vm.skillsData = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ShopULbDepartmentLogsDialogController', ShopULbDepartmentLogsDialogController);

    ShopULbDepartmentLogsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ShopULbDepartmentLogs'];

    function ShopULbDepartmentLogsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ShopULbDepartmentLogs) {
        var vm = this;

        vm.shopULbDepartmentLogs = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.shopULbDepartmentLogs.id !== null) {
                ShopULbDepartmentLogs.update(vm.shopULbDepartmentLogs, onSaveSuccess, onSaveError);
            } else {
                ShopULbDepartmentLogs.save(vm.shopULbDepartmentLogs, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:shopULbDepartmentLogsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.commentDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ShopULbDepartmentLogsDetailController', ShopULbDepartmentLogsDetailController);

    ShopULbDepartmentLogsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ShopULbDepartmentLogs'];

    function ShopULbDepartmentLogsDetailController($scope, $rootScope, $stateParams, previousState, entity, ShopULbDepartmentLogs) {
        var vm = this;

        vm.shopULbDepartmentLogs = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:shopULbDepartmentLogsUpdate', function(event, result) {
            vm.shopULbDepartmentLogs = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ShopULbDepartmentLogsDeleteController',ShopULbDepartmentLogsDeleteController);

    ShopULbDepartmentLogsDeleteController.$inject = ['$uibModalInstance', 'entity', 'ShopULbDepartmentLogs'];

    function ShopULbDepartmentLogsDeleteController($uibModalInstance, entity, ShopULbDepartmentLogs) {
        var vm = this;

        vm.shopULbDepartmentLogs = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ShopULbDepartmentLogs.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('shop-u-lb-department-logs', {
            parent: 'entity',
            url: '/shop-u-lb-department-logs',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.shopULbDepartmentLogs.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/shop-u-lb-department-logs/shop-u-lb-department-logs.html',
                    controller: 'ShopULbDepartmentLogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('shopULbDepartmentLogs');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('shop-u-lb-department-logs-detail', {
            parent: 'shop-u-lb-department-logs',
            url: '/shop-u-lb-department-logs/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.shopULbDepartmentLogs.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/shop-u-lb-department-logs/shop-u-lb-department-logs-detail.html',
                    controller: 'ShopULbDepartmentLogsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('shopULbDepartmentLogs');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ShopULbDepartmentLogs', function($stateParams, ShopULbDepartmentLogs) {
                    return ShopULbDepartmentLogs.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'shop-u-lb-department-logs',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('shop-u-lb-department-logs-detail.edit', {
            parent: 'shop-u-lb-department-logs-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/shop-u-lb-department-logs/shop-u-lb-department-logs-dialog.html',
                    controller: 'ShopULbDepartmentLogsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ShopULbDepartmentLogs', function(ShopULbDepartmentLogs) {
                            return ShopULbDepartmentLogs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('shop-u-lb-department-logs.new', {
            parent: 'shop-u-lb-department-logs',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/shop-u-lb-department-logs/shop-u-lb-department-logs-dialog.html',
                    controller: 'ShopULbDepartmentLogsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                actionTaken: null,
                                commentByUserLogin: null,
                                commentDate: null,
                                comments: null,
                                projectId: null,
                                serviceId: null,
                                reapplycounter: null,
                                rejectionreason: null,
                                departmentName: null,
                                projectServiceDetailId: null,
                                dashboardBetweenDatesCafId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('shop-u-lb-department-logs', null, { reload: 'shop-u-lb-department-logs' });
                }, function() {
                    $state.go('shop-u-lb-department-logs');
                });
            }]
        })
        .state('shop-u-lb-department-logs.edit', {
            parent: 'shop-u-lb-department-logs',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/shop-u-lb-department-logs/shop-u-lb-department-logs-dialog.html',
                    controller: 'ShopULbDepartmentLogsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ShopULbDepartmentLogs', function(ShopULbDepartmentLogs) {
                            return ShopULbDepartmentLogs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('shop-u-lb-department-logs', null, { reload: 'shop-u-lb-department-logs' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('shop-u-lb-department-logs.delete', {
            parent: 'shop-u-lb-department-logs',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/shop-u-lb-department-logs/shop-u-lb-department-logs-delete-dialog.html',
                    controller: 'ShopULbDepartmentLogsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ShopULbDepartmentLogs', function(ShopULbDepartmentLogs) {
                            return ShopULbDepartmentLogs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('shop-u-lb-department-logs', null, { reload: 'shop-u-lb-department-logs' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ShopULbDepartmentLogs', ShopULbDepartmentLogs);

    ShopULbDepartmentLogs.$inject = ['$resource', 'DateUtils'];

    function ShopULbDepartmentLogs ($resource, DateUtils) {
        var resourceUrl =  'api/shop-u-lb-department-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.commentDate = DateUtils.convertDateTimeFromServer(data.commentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ShopULbDepartmentLogsController', ShopULbDepartmentLogsController);

    ShopULbDepartmentLogsController.$inject = ['ShopULbDepartmentLogs'];

    function ShopULbDepartmentLogsController(ShopULbDepartmentLogs) {

        var vm = this;

        vm.shopULbDepartmentLogs = [];

        loadAll();

        function loadAll() {
            ShopULbDepartmentLogs.query(function(result) {
                vm.shopULbDepartmentLogs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SharedPendingCAFDialogController', SharedPendingCAFDialogController);

    SharedPendingCAFDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'SharedPendingCAF'];

    function SharedPendingCAFDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, SharedPendingCAF) {
        var vm = this;

        vm.sharedPendingCAF = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sharedPendingCAF.id !== null) {
                SharedPendingCAF.update(vm.sharedPendingCAF, onSaveSuccess, onSaveError);
            } else {
                SharedPendingCAF.save(vm.sharedPendingCAF, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:sharedPendingCAFUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SharedPendingCAFDetailController', SharedPendingCAFDetailController);

    SharedPendingCAFDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'SharedPendingCAF'];

    function SharedPendingCAFDetailController($scope, $rootScope, $stateParams, previousState, entity, SharedPendingCAF) {
        var vm = this;

        vm.sharedPendingCAF = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:sharedPendingCAFUpdate', function(event, result) {
            vm.sharedPendingCAF = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SharedPendingCAFDeleteController',SharedPendingCAFDeleteController);

    SharedPendingCAFDeleteController.$inject = ['$uibModalInstance', 'entity', 'SharedPendingCAF'];

    function SharedPendingCAFDeleteController($uibModalInstance, entity, SharedPendingCAF) {
        var vm = this;

        vm.sharedPendingCAF = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SharedPendingCAF.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('shared-pending-caf', {
            parent: 'entity',
            url: '/shared-pending-caf',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.sharedPendingCAF.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/shared-pending-caf/shared-pending-cafs.html',
                    controller: 'SharedPendingCAFController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sharedPendingCAF');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('shared-pending-caf-detail', {
            parent: 'shared-pending-caf',
            url: '/shared-pending-caf/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.sharedPendingCAF.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/shared-pending-caf/shared-pending-caf-detail.html',
                    controller: 'SharedPendingCAFDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sharedPendingCAF');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'SharedPendingCAF', function($stateParams, SharedPendingCAF) {
                    return SharedPendingCAF.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'shared-pending-caf',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('shared-pending-caf-detail.edit', {
            parent: 'shared-pending-caf-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/shared-pending-caf/shared-pending-caf-dialog.html',
                    controller: 'SharedPendingCAFDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SharedPendingCAF', function(SharedPendingCAF) {
                            return SharedPendingCAF.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('shared-pending-caf.new', {
            parent: 'shared-pending-caf',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/shared-pending-caf/shared-pending-caf-dialog.html',
                    controller: 'SharedPendingCAFDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectId: null,
                                cafPin: null,
                                responseCode: null,
                                returnMsg: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('shared-pending-caf', null, { reload: 'shared-pending-caf' });
                }, function() {
                    $state.go('shared-pending-caf');
                });
            }]
        })
        .state('shared-pending-caf.edit', {
            parent: 'shared-pending-caf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/shared-pending-caf/shared-pending-caf-dialog.html',
                    controller: 'SharedPendingCAFDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SharedPendingCAF', function(SharedPendingCAF) {
                            return SharedPendingCAF.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('shared-pending-caf', null, { reload: 'shared-pending-caf' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('shared-pending-caf.delete', {
            parent: 'shared-pending-caf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/shared-pending-caf/shared-pending-caf-delete-dialog.html',
                    controller: 'SharedPendingCAFDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['SharedPendingCAF', function(SharedPendingCAF) {
                            return SharedPendingCAF.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('shared-pending-caf', null, { reload: 'shared-pending-caf' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SharedPendingCAF', SharedPendingCAF);

    SharedPendingCAF.$inject = ['$resource'];

    function SharedPendingCAF ($resource) {
        var resourceUrl =  'api/shared-pending-cafs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SharedPendingCAFController', SharedPendingCAFController);

    SharedPendingCAFController.$inject = ['SharedPendingCAF'];

    function SharedPendingCAFController(SharedPendingCAF) {

        var vm = this;

        vm.sharedPendingCAFS = [];

        loadAll();

        function loadAll() {
            SharedPendingCAF.query(function(result) {
                vm.sharedPendingCAFS = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServicetokenDialogController', ServicetokenDialogController);

    ServicetokenDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Servicetoken'];

    function ServicetokenDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Servicetoken) {
        var vm = this;

        vm.servicetoken = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.servicetoken.id !== null) {
                Servicetoken.update(vm.servicetoken, onSaveSuccess, onSaveError);
            } else {
                Servicetoken.save(vm.servicetoken, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:servicetokenUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServicetokenDetailController', ServicetokenDetailController);

    ServicetokenDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Servicetoken'];

    function ServicetokenDetailController($scope, $rootScope, $stateParams, previousState, entity, Servicetoken) {
        var vm = this;

        vm.servicetoken = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:servicetokenUpdate', function(event, result) {
            vm.servicetoken = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServicetokenDeleteController',ServicetokenDeleteController);

    ServicetokenDeleteController.$inject = ['$uibModalInstance', 'entity', 'Servicetoken'];

    function ServicetokenDeleteController($uibModalInstance, entity, Servicetoken) {
        var vm = this;

        vm.servicetoken = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Servicetoken.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('servicetoken', {
            parent: 'entity',
            url: '/servicetoken',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.servicetoken.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/servicetoken/servicetokens.html',
                    controller: 'ServicetokenController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('servicetoken');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('servicetoken-detail', {
            parent: 'servicetoken',
            url: '/servicetoken/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.servicetoken.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/servicetoken/servicetoken-detail.html',
                    controller: 'ServicetokenDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('servicetoken');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Servicetoken', function($stateParams, Servicetoken) {
                    return Servicetoken.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'servicetoken',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('servicetoken-detail.edit', {
            parent: 'servicetoken-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/servicetoken/servicetoken-dialog.html',
                    controller: 'ServicetokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Servicetoken', function(Servicetoken) {
                            return Servicetoken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('servicetoken.new', {
            parent: 'servicetoken',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/servicetoken/servicetoken-dialog.html',
                    controller: 'ServicetokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                uniqueid: null,
                                tokennumber: null,
                                nocurl: null,
                                currentstatus: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('servicetoken', null, { reload: 'servicetoken' });
                }, function() {
                    $state.go('servicetoken');
                });
            }]
        })
        .state('servicetoken.edit', {
            parent: 'servicetoken',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/servicetoken/servicetoken-dialog.html',
                    controller: 'ServicetokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Servicetoken', function(Servicetoken) {
                            return Servicetoken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('servicetoken', null, { reload: 'servicetoken' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('servicetoken.delete', {
            parent: 'servicetoken',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/servicetoken/servicetoken-delete-dialog.html',
                    controller: 'ServicetokenDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Servicetoken', function(Servicetoken) {
                            return Servicetoken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('servicetoken', null, { reload: 'servicetoken' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Servicetoken', Servicetoken);

    Servicetoken.$inject = ['$resource'];

    function Servicetoken ($resource) {
        var resourceUrl =  'api/servicetokens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServicetokenController', ServicetokenController);

    ServicetokenController.$inject = ['Servicetoken'];

    function ServicetokenController(Servicetoken) {

        var vm = this;

        vm.servicetokens = [];

        loadAll();

        function loadAll() {
            Servicetoken.query(function(result) {
                vm.servicetokens = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceformdraftsavedDialogController', ServiceformdraftsavedDialogController);

    ServiceformdraftsavedDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Serviceformdraftsaved'];

    function ServiceformdraftsavedDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Serviceformdraftsaved) {
        var vm = this;

        vm.serviceformdraftsaved = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.serviceformdraftsaved.id !== null) {
                Serviceformdraftsaved.update(vm.serviceformdraftsaved, onSaveSuccess, onSaveError);
            } else {
                Serviceformdraftsaved.save(vm.serviceformdraftsaved, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:serviceformdraftsavedUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceformdraftsavedDetailController', ServiceformdraftsavedDetailController);

    ServiceformdraftsavedDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Serviceformdraftsaved'];

    function ServiceformdraftsavedDetailController($scope, $rootScope, $stateParams, previousState, entity, Serviceformdraftsaved) {
        var vm = this;

        vm.serviceformdraftsaved = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:serviceformdraftsavedUpdate', function(event, result) {
            vm.serviceformdraftsaved = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceformdraftsavedDeleteController',ServiceformdraftsavedDeleteController);

    ServiceformdraftsavedDeleteController.$inject = ['$uibModalInstance', 'entity', 'Serviceformdraftsaved'];

    function ServiceformdraftsavedDeleteController($uibModalInstance, entity, Serviceformdraftsaved) {
        var vm = this;

        vm.serviceformdraftsaved = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Serviceformdraftsaved.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('serviceformdraftsaved', {
            parent: 'entity',
            url: '/serviceformdraftsaved',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.serviceformdraftsaved.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/serviceformdraftsaved/serviceformdraftsaveds.html',
                    controller: 'ServiceformdraftsavedController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceformdraftsaved');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('serviceformdraftsaved-detail', {
            parent: 'serviceformdraftsaved',
            url: '/serviceformdraftsaved/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.serviceformdraftsaved.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/serviceformdraftsaved/serviceformdraftsaved-detail.html',
                    controller: 'ServiceformdraftsavedDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceformdraftsaved');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Serviceformdraftsaved', function($stateParams, Serviceformdraftsaved) {
                    return Serviceformdraftsaved.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'serviceformdraftsaved',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('serviceformdraftsaved-detail.edit', {
            parent: 'serviceformdraftsaved-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/serviceformdraftsaved/serviceformdraftsaved-dialog.html',
                    controller: 'ServiceformdraftsavedDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Serviceformdraftsaved', function(Serviceformdraftsaved) {
                            return Serviceformdraftsaved.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('serviceformdraftsaved.new', {
            parent: 'serviceformdraftsaved',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/serviceformdraftsaved/serviceformdraftsaved-dialog.html',
                    controller: 'ServiceformdraftsavedDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                draftsaved: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('serviceformdraftsaved', null, { reload: 'serviceformdraftsaved' });
                }, function() {
                    $state.go('serviceformdraftsaved');
                });
            }]
        })
        .state('serviceformdraftsaved.edit', {
            parent: 'serviceformdraftsaved',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/serviceformdraftsaved/serviceformdraftsaved-dialog.html',
                    controller: 'ServiceformdraftsavedDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Serviceformdraftsaved', function(Serviceformdraftsaved) {
                            return Serviceformdraftsaved.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceformdraftsaved', null, { reload: 'serviceformdraftsaved' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('serviceformdraftsaved.delete', {
            parent: 'serviceformdraftsaved',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/serviceformdraftsaved/serviceformdraftsaved-delete-dialog.html',
                    controller: 'ServiceformdraftsavedDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Serviceformdraftsaved', function(Serviceformdraftsaved) {
                            return Serviceformdraftsaved.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceformdraftsaved', null, { reload: 'serviceformdraftsaved' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Serviceformdraftsaved', Serviceformdraftsaved);

    Serviceformdraftsaved.$inject = ['$resource'];

    function Serviceformdraftsaved ($resource) {
        var resourceUrl =  'api/serviceformdraftsaveds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceformdraftsavedController', ServiceformdraftsavedController);

    ServiceformdraftsavedController.$inject = ['Serviceformdraftsaved'];

    function ServiceformdraftsavedController(Serviceformdraftsaved) {

        var vm = this;

        vm.serviceformdraftsaveds = [];

        loadAll();

        function loadAll() {
            Serviceformdraftsaved.query(function(result) {
                vm.serviceformdraftsaveds = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceformdocsDialogController', ServiceformdocsDialogController);

    ServiceformdocsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Serviceformdocs','DepartmentService','FileManagement'];

    function ServiceformdocsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Serviceformdocs,DepartmentService, FileManagement) {
        var vm = this;

        vm.serviceformdocs = entity;
        vm.clear = clear;
        vm.save = save;
        vm.updateDepartmentName=updateDepartmentName;
        vm.selectedservicedepartment="";
        $scope.file = {};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.serviceformdocs.id !== null) {
                Serviceformdocs.update(vm.serviceformdocs, onSaveSuccess, onSaveError);
            } else {
                Serviceformdocs.save(vm.serviceformdocs, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:serviceformdocsUpdate', result);
            var filename = result.id;
            var file =vm.servicedoc.file;
            FileManagement.saveFile(file,filename);

            var fileNameArray = vm.servicedoc.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            result.downloadfilename=inputFileName;
            Serviceformdocs.update(result,onUpdateSuccess,onUpdateError);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function onUpdateSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        function onUpdateError () {
            vm.isSaving = false;
        }

        loadAllService();
        function loadAllService() {
            DepartmentService.query(function(result) {
                vm.departmentServices = result;
                vm.searchQuery = null;
            });
        }
        function updateDepartmentName()
        {
            vm.selectedservicedepartment=$scope.selectedservice.departmentname;
            vm.serviceformdocs.serviceid=$scope.selectedservice.id;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceformdocsDetailController', ServiceformdocsDetailController);

    ServiceformdocsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Serviceformdocs'];

    function ServiceformdocsDetailController($scope, $rootScope, $stateParams, previousState, entity, Serviceformdocs) {
        var vm = this;

        vm.serviceformdocs = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:serviceformdocsUpdate', function(event, result) {
            vm.serviceformdocs = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceformdocsDeleteController',ServiceformdocsDeleteController);

    ServiceformdocsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Serviceformdocs'];

    function ServiceformdocsDeleteController($uibModalInstance, entity, Serviceformdocs) {
        var vm = this;

        vm.serviceformdocs = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Serviceformdocs.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('serviceformdocs', {
            parent: 'entity',
            url: '/serviceformdocs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.serviceformdocs.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/serviceformdocs/serviceformdocs.html',
                    controller: 'ServiceformdocsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceformdocs');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('serviceformdocs-detail', {
            parent: 'serviceformdocs',
            url: '/serviceformdocs/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.serviceformdocs.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/serviceformdocs/serviceformdocs-detail.html',
                    controller: 'ServiceformdocsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceformdocs');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Serviceformdocs', function($stateParams, Serviceformdocs) {
                    return Serviceformdocs.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'serviceformdocs',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('serviceformdocs-detail.edit', {
            parent: 'serviceformdocs-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/serviceformdocs/serviceformdocs-dialog.html',
                    controller: 'ServiceformdocsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Serviceformdocs', function(Serviceformdocs) {
                            return Serviceformdocs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('serviceformdocs.new', {
            parent: 'serviceformdocs',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/serviceformdocs/serviceformdocs-dialog.html',
                    controller: 'ServiceformdocsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                serviceid: null,
                                docname: null,
                                docdescription: null,
                                downloadfilename: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('serviceformdocs', null, { reload: 'serviceformdocs' });
                }, function() {
                    $state.go('serviceformdocs');
                });
            }]
        })
        .state('serviceformdocs.edit', {
            parent: 'serviceformdocs',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/serviceformdocs/serviceformdocs-dialog.html',
                    controller: 'ServiceformdocsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Serviceformdocs', function(Serviceformdocs) {
                            return Serviceformdocs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceformdocs', null, { reload: 'serviceformdocs' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('serviceformdocs.delete', {
            parent: 'serviceformdocs',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/serviceformdocs/serviceformdocs-delete-dialog.html',
                    controller: 'ServiceformdocsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Serviceformdocs', function(Serviceformdocs) {
                            return Serviceformdocs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('serviceformdocs', null, { reload: 'serviceformdocs' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Serviceformdocs', Serviceformdocs);

    Serviceformdocs.$inject = ['$resource'];

    function Serviceformdocs ($resource) {
        var resourceUrl =  'api/serviceformdocs/:id/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceformdocsController', ServiceformdocsController);

    ServiceformdocsController.$inject = ['Serviceformdocs'];

    function ServiceformdocsController(Serviceformdocs) {

        var vm = this;

        vm.serviceformdocs = [];

        loadAll();

        function loadAll() {
            Serviceformdocs.query(function(result) {
                vm.serviceformdocs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceStatusDialogController', ServiceStatusDialogController);

    ServiceStatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceStatus'];

    function ServiceStatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceStatus) {
        var vm = this;

        vm.serviceStatus = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.serviceStatus.id !== null) {
                ServiceStatus.update(vm.serviceStatus, onSaveSuccess, onSaveError);
            } else {
                ServiceStatus.save(vm.serviceStatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:serviceStatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.level1Date = false;
        vm.datePickerOpenStatus.level2Date = false;
        vm.datePickerOpenStatus.level3Date = false;
        vm.datePickerOpenStatus.level4Date = false;
        vm.datePickerOpenStatus.level5Date = false;
        vm.datePickerOpenStatus.level6Date = false;
        vm.datePickerOpenStatus.level7Date = false;
        vm.datePickerOpenStatus.level8Date = false;
        vm.datePickerOpenStatus.level9Date = false;
        vm.datePickerOpenStatus.level10Date = false;
        vm.datePickerOpenStatus.level0Date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceStatusDetailController', ServiceStatusDetailController);

    ServiceStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ServiceStatus'];

    function ServiceStatusDetailController($scope, $rootScope, $stateParams, previousState, entity, ServiceStatus) {
        var vm = this;

        vm.serviceStatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:serviceStatusUpdate', function(event, result) {
            vm.serviceStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceStatusDeleteController',ServiceStatusDeleteController);

    ServiceStatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceStatus'];

    function ServiceStatusDeleteController($uibModalInstance, entity, ServiceStatus) {
        var vm = this;

        vm.serviceStatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ServiceStatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service-status', {
            parent: 'entity',
            url: '/service-status',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.serviceStatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-status/service-statuses.html',
                    controller: 'ServiceStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceStatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-status-detail', {
            parent: 'service-status',
            url: '/service-status/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.serviceStatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-status/service-status-detail.html',
                    controller: 'ServiceStatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceStatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ServiceStatus', function($stateParams, ServiceStatus) {
                    return ServiceStatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-status',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-status-detail.edit', {
            parent: 'service-status-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-status/service-status-dialog.html',
                    controller: 'ServiceStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ServiceStatus', function(ServiceStatus) {
                            return ServiceStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-status.new', {
            parent: 'service-status',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-status/service-status-dialog.html',
                    controller: 'ServiceStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                cafPin: null,
                                projectId: null,
                                serviceId: null,
                                serviceName: null,
                                level1: null,
                                level2: null,
                                level3: null,
                                level4: null,
                                level5: null,
                                level6: null,
                                level7: null,
                                level8: null,
                                level9: null,
                                level10: null,
                                reApplyCounter: null,
                                percentageCompleted: null,
                                departmentName: null,
                                previousLevel: null,
                                projectLevel: null,
                                level0: null,
                                level1Date: null,
                                level2Date: null,
                                level3Date: null,
                                level4Date: null,
                                level5Date: null,
                                level6Date: null,
                                level7Date: null,
                                level8Date: null,
                                level9Date: null,
                                level10Date: null,
                                level0Date: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('service-status', null, { reload: 'service-status' });
                }, function() {
                    $state.go('service-status');
                });
            }]
        })
        .state('service-status.edit', {
            parent: 'service-status',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-status/service-status-dialog.html',
                    controller: 'ServiceStatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ServiceStatus', function(ServiceStatus) {
                            return ServiceStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-status', null, { reload: 'service-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-status.delete', {
            parent: 'service-status',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-status/service-status-delete-dialog.html',
                    controller: 'ServiceStatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ServiceStatus', function(ServiceStatus) {
                            return ServiceStatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-status', null, { reload: 'service-status' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceStatus', ServiceStatus);

    ServiceStatus.$inject = ['$resource', 'DateUtils'];

    function ServiceStatus ($resource, DateUtils) {
        var resourceUrl =  'api/service-statuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.level1Date = DateUtils.convertLocalDateFromServer(data.level1Date);
                        data.level2Date = DateUtils.convertLocalDateFromServer(data.level2Date);
                        data.level3Date = DateUtils.convertLocalDateFromServer(data.level3Date);
                        data.level4Date = DateUtils.convertLocalDateFromServer(data.level4Date);
                        data.level5Date = DateUtils.convertLocalDateFromServer(data.level5Date);
                        data.level6Date = DateUtils.convertLocalDateFromServer(data.level6Date);
                        data.level7Date = DateUtils.convertLocalDateFromServer(data.level7Date);
                        data.level8Date = DateUtils.convertLocalDateFromServer(data.level8Date);
                        data.level9Date = DateUtils.convertLocalDateFromServer(data.level9Date);
                        data.level10Date = DateUtils.convertLocalDateFromServer(data.level10Date);
                        data.level0Date = DateUtils.convertLocalDateFromServer(data.level0Date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.level1Date = DateUtils.convertLocalDateToServer(copy.level1Date);
                    copy.level2Date = DateUtils.convertLocalDateToServer(copy.level2Date);
                    copy.level3Date = DateUtils.convertLocalDateToServer(copy.level3Date);
                    copy.level4Date = DateUtils.convertLocalDateToServer(copy.level4Date);
                    copy.level5Date = DateUtils.convertLocalDateToServer(copy.level5Date);
                    copy.level6Date = DateUtils.convertLocalDateToServer(copy.level6Date);
                    copy.level7Date = DateUtils.convertLocalDateToServer(copy.level7Date);
                    copy.level8Date = DateUtils.convertLocalDateToServer(copy.level8Date);
                    copy.level9Date = DateUtils.convertLocalDateToServer(copy.level9Date);
                    copy.level10Date = DateUtils.convertLocalDateToServer(copy.level10Date);
                    copy.level0Date = DateUtils.convertLocalDateToServer(copy.level0Date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.level1Date = DateUtils.convertLocalDateToServer(copy.level1Date);
                    copy.level2Date = DateUtils.convertLocalDateToServer(copy.level2Date);
                    copy.level3Date = DateUtils.convertLocalDateToServer(copy.level3Date);
                    copy.level4Date = DateUtils.convertLocalDateToServer(copy.level4Date);
                    copy.level5Date = DateUtils.convertLocalDateToServer(copy.level5Date);
                    copy.level6Date = DateUtils.convertLocalDateToServer(copy.level6Date);
                    copy.level7Date = DateUtils.convertLocalDateToServer(copy.level7Date);
                    copy.level8Date = DateUtils.convertLocalDateToServer(copy.level8Date);
                    copy.level9Date = DateUtils.convertLocalDateToServer(copy.level9Date);
                    copy.level10Date = DateUtils.convertLocalDateToServer(copy.level10Date);
                    copy.level0Date = DateUtils.convertLocalDateToServer(copy.level0Date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceStatusController', ServiceStatusController);

    ServiceStatusController.$inject = ['ServiceStatus'];

    function ServiceStatusController(ServiceStatus) {

        var vm = this;

        vm.serviceStatuses = [];

        loadAll();

        function loadAll() {
            ServiceStatus.query(function(result) {
                vm.serviceStatuses = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceLevelDialogController', ServiceLevelDialogController);

    ServiceLevelDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceLevel'];

    function ServiceLevelDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceLevel) {
        var vm = this;

        vm.serviceLevel = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.serviceLevel.id !== null) {
                ServiceLevel.update(vm.serviceLevel, onSaveSuccess, onSaveError);
            } else {
                ServiceLevel.save(vm.serviceLevel, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:serviceLevelUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceLevelDetailController', ServiceLevelDetailController);

    ServiceLevelDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ServiceLevel'];

    function ServiceLevelDetailController($scope, $rootScope, $stateParams, previousState, entity, ServiceLevel) {
        var vm = this;

        vm.serviceLevel = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:serviceLevelUpdate', function(event, result) {
            vm.serviceLevel = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceLevelDeleteController',ServiceLevelDeleteController);

    ServiceLevelDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceLevel'];

    function ServiceLevelDeleteController($uibModalInstance, entity, ServiceLevel) {
        var vm = this;

        vm.serviceLevel = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ServiceLevel.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service-level', {
            parent: 'entity',
            url: '/service-level',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.serviceLevel.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-level/service-levels.html',
                    controller: 'ServiceLevelController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceLevel');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-level-detail', {
            parent: 'service-level',
            url: '/service-level/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.serviceLevel.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-level/service-level-detail.html',
                    controller: 'ServiceLevelDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceLevel');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ServiceLevel', function($stateParams, ServiceLevel) {
                    return ServiceLevel.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-level',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-level-detail.edit', {
            parent: 'service-level-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-level/service-level-dialog.html',
                    controller: 'ServiceLevelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ServiceLevel', function(ServiceLevel) {
                            return ServiceLevel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-level.new', {
            parent: 'service-level',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-level/service-level-dialog.html',
                    controller: 'ServiceLevelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                serviceId: null,
                                serviceName: null,
                                departmentName: null,
                                levelDescription: null,
                                level: null,
                                departmentId: null,
                                projectLevel: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('service-level', null, { reload: 'service-level' });
                }, function() {
                    $state.go('service-level');
                });
            }]
        })
        .state('service-level.edit', {
            parent: 'service-level',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-level/service-level-dialog.html',
                    controller: 'ServiceLevelDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ServiceLevel', function(ServiceLevel) {
                            return ServiceLevel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-level', null, { reload: 'service-level' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-level.delete', {
            parent: 'service-level',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-level/service-level-delete-dialog.html',
                    controller: 'ServiceLevelDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ServiceLevel', function(ServiceLevel) {
                            return ServiceLevel.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-level', null, { reload: 'service-level' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceLevel', ServiceLevel);

    ServiceLevel.$inject = ['$resource'];

    function ServiceLevel ($resource) {
        var resourceUrl =  'api/service-levels/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceLevelController', ServiceLevelController);

    ServiceLevelController.$inject = ['ServiceLevel'];

    function ServiceLevelController(ServiceLevel) {

        var vm = this;

        vm.serviceLevels = [];

        loadAll();

        function loadAll() {
            ServiceLevel.query(function(result) {
                vm.serviceLevels = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('serviceformfielsbyService', serviceformfielsbyService);

    serviceformfielsbyService.$inject = ['$resource', 'DateUtils'];

    function serviceformfielsbyService ($resource, DateUtils) {
        var resourceUrl =  'api/servieformfield/service/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
//                        data.requireMarkedOnDate = DateUtils.convertDateTimeFromServer(data.requireMarkedOnDate);
//                        data.assigOnDate = DateUtils.convertDateTimeFromServer(data.assigOnDate);
//                        data.formFilledOnDate = DateUtils.convertDateTimeFromServer(data.formFilledOnDate);
//                        data.paymentMadeOnDate = DateUtils.convertDateTimeFromServer(data.paymentMadeOnDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('serviceformController', serviceformController);

    serviceformController.$inject = ['$scope','$http'];

    function serviceformController($scope, $http) {
        $http.get("/api/department-services").then(function(response) {
           return $scope.students = response.data;
       });
    }
//    function distcountryController($scope, $http) {
//       // $http.get("country.js").then(function(response) {
//           return $scope.students = [
//            {
//            "id":"20c7501a-b84a-4f32-891c-289a0d76eeb8",
//            "cname":"INDIA"
//            },
//            {
//                "id":"7f2bbaa1-c6b0-4310-9d27-b013e20f5c70",
//                "cname":"ENGLAND"
//            }
//        ];
       //});
    //}



})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceFormFieldDialogController', ServiceFormFieldDialogController);

    ServiceFormFieldDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceFormField'];

    function ServiceFormFieldDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceFormField) {
        var vm = this;

        vm.serviceFormField = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.serviceFormField.id !== null) {
                ServiceFormField.update(vm.serviceFormField, onSaveSuccess, onSaveError);
            } else {
                ServiceFormField.save(vm.serviceFormField, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:serviceFormFieldUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceFormFieldDetailController', ServiceFormFieldDetailController);

    ServiceFormFieldDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ServiceFormField'];

    function ServiceFormFieldDetailController($scope, $rootScope, $stateParams, previousState, entity, ServiceFormField) {
        var vm = this;

        vm.serviceFormField = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:serviceFormFieldUpdate', function(event, result) {
            vm.serviceFormField = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceFormFieldDeleteController',ServiceFormFieldDeleteController);

    ServiceFormFieldDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceFormField'];

    function ServiceFormFieldDeleteController($uibModalInstance, entity, ServiceFormField) {
        var vm = this;

        vm.serviceFormField = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ServiceFormField.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service-form-field', {
            parent: 'entity',
            url: '/service-form-field',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.serviceFormField.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-form-field/service-form-fields.html',
                    controller: 'ServiceFormFieldController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceFormField');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-form-field-detail', {
            parent: 'service-form-field',
            url: '/service-form-field/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.serviceFormField.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-form-field/service-form-field-detail.html',
                    controller: 'ServiceFormFieldDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceFormField');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ServiceFormField', function($stateParams, ServiceFormField) {
                    return ServiceFormField.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-form-field',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-form-field-detail.edit', {
            parent: 'service-form-field-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-form-field/service-form-field-dialog.html',
                    controller: 'ServiceFormFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ServiceFormField', function(ServiceFormField) {
                            return ServiceFormField.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-form-field.new', {
            parent: 'service-form-field',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-form-field/service-form-field-dialog.html',
                    controller: 'ServiceFormFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fieldName: null,
                                fieldType: null,
                                serviceID: null,
                                fieldTypeOption: null,
                                fieldRenderingOrder: null,
                                autofillflag: null,
                                isRequired: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('service-form-field', null, { reload: 'service-form-field' });
                }, function() {
                    $state.go('service-form-field');
                });
            }]
        })
        .state('service-form-field.edit', {
            parent: 'service-form-field',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-form-field/service-form-field-dialog.html',
                    controller: 'ServiceFormFieldDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ServiceFormField', function(ServiceFormField) {
                            return ServiceFormField.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-form-field', null, { reload: 'service-form-field' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-form-field.delete', {
            parent: 'service-form-field',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-form-field/service-form-field-delete-dialog.html',
                    controller: 'ServiceFormFieldDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ServiceFormField', function(ServiceFormField) {
                            return ServiceFormField.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-form-field', null, { reload: 'service-form-field' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceFormField', ServiceFormField);

    ServiceFormField.$inject = ['$resource'];

    function ServiceFormField ($resource) {
        var resourceUrl =  'api/service-form-fields/:id/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceFormFieldController', ServiceFormFieldController);

    ServiceFormFieldController.$inject = ['$scope','ServiceFormField','DepartmentService'];

    function ServiceFormFieldController($scope,ServiceFormField,DepartmentService) {

        var vm = this;
        vm.selectedservicedepartment="";
        vm.serviceFormFields = [];
        vm.updateDepartmentName = updateDepartmentName;

        function loadAll() {
            ServiceFormField.query(function(result) {
                vm.serviceFormFields = result;
                vm.searchQuery = null;
            });
        }

        loadAllService();
        function loadAllService() {
            DepartmentService.query(function(result) {
                vm.departmentServices = result;
                vm.searchQuery = null;
            });
        }

        function updateDepartmentName()
        {
            vm.selectedservicedepartment=$scope.selectedservice.departmentname;
            var serviceid=$scope.selectedservice.id;
            ServiceFormField.query({id:"1",serviceid:serviceid},function(result) {
                vm.serviceFormFields = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceFormAttachmentsDialogController', ServiceFormAttachmentsDialogController);

    ServiceFormAttachmentsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceFormAttachments'];

    function ServiceFormAttachmentsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceFormAttachments) {
        var vm = this;

        vm.serviceFormAttachments = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.serviceFormAttachments.id !== null) {
                ServiceFormAttachments.update(vm.serviceFormAttachments, onSaveSuccess, onSaveError);
            } else {
                ServiceFormAttachments.save(vm.serviceFormAttachments, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:serviceFormAttachmentsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceFormAttachmentsDetailController', ServiceFormAttachmentsDetailController);

    ServiceFormAttachmentsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ServiceFormAttachments'];

    function ServiceFormAttachmentsDetailController($scope, $rootScope, $stateParams, previousState, entity, ServiceFormAttachments) {
        var vm = this;

        vm.serviceFormAttachments = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:serviceFormAttachmentsUpdate', function(event, result) {
            vm.serviceFormAttachments = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceFormAttachmentsDeleteController',ServiceFormAttachmentsDeleteController);

    ServiceFormAttachmentsDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceFormAttachments'];

    function ServiceFormAttachmentsDeleteController($uibModalInstance, entity, ServiceFormAttachments) {
        var vm = this;

        vm.serviceFormAttachments = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ServiceFormAttachments.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service-form-attachments', {
            parent: 'entity',
            url: '/service-form-attachments',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.serviceFormAttachments.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-form-attachments/service-form-attachments.html',
                    controller: 'ServiceFormAttachmentsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceFormAttachments');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-form-attachments-detail', {
            parent: 'service-form-attachments',
            url: '/service-form-attachments/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.serviceFormAttachments.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-form-attachments/service-form-attachments-detail.html',
                    controller: 'ServiceFormAttachmentsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceFormAttachments');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ServiceFormAttachments', function($stateParams, ServiceFormAttachments) {
                    return ServiceFormAttachments.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-form-attachments',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-form-attachments-detail.edit', {
            parent: 'service-form-attachments-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-form-attachments/service-form-attachments-dialog.html',
                    controller: 'ServiceFormAttachmentsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ServiceFormAttachments', function(ServiceFormAttachments) {
                            return ServiceFormAttachments.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-form-attachments.new', {
            parent: 'service-form-attachments',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-form-attachments/service-form-attachments-dialog.html',
                    controller: 'ServiceFormAttachmentsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                description: null,
                                clientfilename: null,
                                serviceID: null,
                                projectID: null,
                                serverfilename: null,
                                downloadfilename: null,
                                isSaved: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('service-form-attachments', null, { reload: 'service-form-attachments' });
                }, function() {
                    $state.go('service-form-attachments');
                });
            }]
        })
        .state('service-form-attachments.edit', {
            parent: 'service-form-attachments',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-form-attachments/service-form-attachments-dialog.html',
                    controller: 'ServiceFormAttachmentsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ServiceFormAttachments', function(ServiceFormAttachments) {
                            return ServiceFormAttachments.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-form-attachments', null, { reload: 'service-form-attachments' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-form-attachments.delete', {
            parent: 'service-form-attachments',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-form-attachments/service-form-attachments-delete-dialog.html',
                    controller: 'ServiceFormAttachmentsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ServiceFormAttachments', function(ServiceFormAttachments) {
                            return ServiceFormAttachments.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-form-attachments', null, { reload: 'service-form-attachments' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceFormAttachments', ServiceFormAttachments);

    ServiceFormAttachments.$inject = ['$resource'];

    function ServiceFormAttachments ($resource) {
        var resourceUrl =  'api/service-form-attachments/:id/:projectid/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceFormAttachmentsController', ServiceFormAttachmentsController);

    ServiceFormAttachmentsController.$inject = ['ServiceFormAttachments'];

    function ServiceFormAttachmentsController(ServiceFormAttachments) {

        var vm = this;

        vm.serviceFormAttachments = [];

        loadAll();

        function loadAll() {
            ServiceFormAttachments.query(function(result) {
                vm.serviceFormAttachments = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceDashboardStatsDialogController', ServiceDashboardStatsDialogController);

    ServiceDashboardStatsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ServiceDashboardStats'];

    function ServiceDashboardStatsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ServiceDashboardStats) {
        var vm = this;

        vm.serviceDashboardStats = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.serviceDashboardStats.id !== null) {
                ServiceDashboardStats.update(vm.serviceDashboardStats, onSaveSuccess, onSaveError);
            } else {
                ServiceDashboardStats.save(vm.serviceDashboardStats, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:serviceDashboardStatsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceDashboardStatsDetailController', ServiceDashboardStatsDetailController);

    ServiceDashboardStatsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ServiceDashboardStats'];

    function ServiceDashboardStatsDetailController($scope, $rootScope, $stateParams, previousState, entity, ServiceDashboardStats) {
        var vm = this;

        vm.serviceDashboardStats = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:serviceDashboardStatsUpdate', function(event, result) {
            vm.serviceDashboardStats = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceDashboardStatsDeleteController',ServiceDashboardStatsDeleteController);

    ServiceDashboardStatsDeleteController.$inject = ['$uibModalInstance', 'entity', 'ServiceDashboardStats'];

    function ServiceDashboardStatsDeleteController($uibModalInstance, entity, ServiceDashboardStats) {
        var vm = this;

        vm.serviceDashboardStats = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ServiceDashboardStats.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service-dashboard-stats', {
            parent: 'entity',
            url: '/service-dashboard-stats',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.serviceDashboardStats.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-dashboard-stats/service-dashboard-stats.html',
                    controller: 'ServiceDashboardStatsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceDashboardStats');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-dashboard-stats-detail', {
            parent: 'service-dashboard-stats',
            url: '/service-dashboard-stats/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.serviceDashboardStats.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-dashboard-stats/service-dashboard-stats-detail.html',
                    controller: 'ServiceDashboardStatsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('serviceDashboardStats');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ServiceDashboardStats', function($stateParams, ServiceDashboardStats) {
                    return ServiceDashboardStats.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-dashboard-stats',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-dashboard-stats-detail.edit', {
            parent: 'service-dashboard-stats-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-dashboard-stats/service-dashboard-stats-dialog.html',
                    controller: 'ServiceDashboardStatsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ServiceDashboardStats', function(ServiceDashboardStats) {
                            return ServiceDashboardStats.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-dashboard-stats.new', {
            parent: 'service-dashboard-stats',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-dashboard-stats/service-dashboard-stats-dialog.html',
                    controller: 'ServiceDashboardStatsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                department_name: null,
                                service_name: null,
                                required: null,
                                applied: null,
                                pending_total: null,
                                pending_30days: null,
                                pending_45days: null,
                                cleared: null,
                                deactivated: null,
                                deemed_cleared: null,
                                rejected: null,
                                service_id: null,
                                withDraw: null,
                                departmentorder: null,
                                pending_60days: null,
                                pending_75days: null,
                                pending_90days: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('service-dashboard-stats', null, { reload: 'service-dashboard-stats' });
                }, function() {
                    $state.go('service-dashboard-stats');
                });
            }]
        })
        .state('service-dashboard-stats.edit', {
            parent: 'service-dashboard-stats',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-dashboard-stats/service-dashboard-stats-dialog.html',
                    controller: 'ServiceDashboardStatsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ServiceDashboardStats', function(ServiceDashboardStats) {
                            return ServiceDashboardStats.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-dashboard-stats', null, { reload: 'service-dashboard-stats' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-dashboard-stats.delete', {
            parent: 'service-dashboard-stats',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-dashboard-stats/service-dashboard-stats-delete-dialog.html',
                    controller: 'ServiceDashboardStatsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ServiceDashboardStats', function(ServiceDashboardStats) {
                            return ServiceDashboardStats.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-dashboard-stats', null, { reload: 'service-dashboard-stats' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceDashboardStats', ServiceDashboardStats);

    ServiceDashboardStats.$inject = ['$resource'];

    function ServiceDashboardStats ($resource) {
        var resourceUrl =  'api/service-dashboard-stats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceDashboardStatsController', ServiceDashboardStatsController);

    ServiceDashboardStatsController.$inject = ['ServiceDashboardStats'];

    function ServiceDashboardStatsController(ServiceDashboardStats) {

        var vm = this;

        vm.serviceDashboardStats = [];

        loadAll();

        function loadAll() {
            ServiceDashboardStats.query(function(result) {
                vm.serviceDashboardStats = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Service_dashboard_outputDialogController', Service_dashboard_outputDialogController);

    Service_dashboard_outputDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Service_dashboard_output'];

    function Service_dashboard_outputDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Service_dashboard_output) {
        var vm = this;

        vm.service_dashboard_output = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.service_dashboard_output.id !== null) {
                Service_dashboard_output.update(vm.service_dashboard_output, onSaveSuccess, onSaveError);
            } else {
                Service_dashboard_output.save(vm.service_dashboard_output, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:service_dashboard_outputUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Service_dashboard_outputDetailController', Service_dashboard_outputDetailController);

    Service_dashboard_outputDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Service_dashboard_output'];

    function Service_dashboard_outputDetailController($scope, $rootScope, $stateParams, previousState, entity, Service_dashboard_output) {
        var vm = this;

        vm.service_dashboard_output = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:service_dashboard_outputUpdate', function(event, result) {
            vm.service_dashboard_output = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Service_dashboard_outputDeleteController',Service_dashboard_outputDeleteController);

    Service_dashboard_outputDeleteController.$inject = ['$uibModalInstance', 'entity', 'Service_dashboard_output'];

    function Service_dashboard_outputDeleteController($uibModalInstance, entity, Service_dashboard_output) {
        var vm = this;

        vm.service_dashboard_output = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Service_dashboard_output.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('service-dashboard-output', {
            parent: 'entity',
            url: '/service-dashboard-output',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.service_dashboard_output.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-dashboard-output/service-dashboard-outputs.html',
                    controller: 'Service_dashboard_outputController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('service_dashboard_output');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('service-dashboard-output-detail', {
            parent: 'service-dashboard-output',
            url: '/service-dashboard-output/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.service_dashboard_output.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/service-dashboard-output/service-dashboard-output-detail.html',
                    controller: 'Service_dashboard_outputDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('service_dashboard_output');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Service_dashboard_output', function($stateParams, Service_dashboard_output) {
                    return Service_dashboard_output.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'service-dashboard-output',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('service-dashboard-output-detail.edit', {
            parent: 'service-dashboard-output-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-dashboard-output/service-dashboard-output-dialog.html',
                    controller: 'Service_dashboard_outputDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Service_dashboard_output', function(Service_dashboard_output) {
                            return Service_dashboard_output.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-dashboard-output.new', {
            parent: 'service-dashboard-output',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-dashboard-output/service-dashboard-output-dialog.html',
                    controller: 'Service_dashboard_outputDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                department_name: null,
                                service_name: null,
                                required: null,
                                applied: null,
                                pending_total: null,
                                pending_30days: null,
                                pending_45days: null,
                                cleared: null,
                                deactivated: null,
                                deemed_cleared: null,
                                rejected: null,
                                service_id: null,
                                departmentorder: null,
                                pending_60days: null,
                                pending_75days: null,
                                pending_90days: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('service-dashboard-output', null, { reload: 'service-dashboard-output' });
                }, function() {
                    $state.go('service-dashboard-output');
                });
            }]
        })
        .state('service-dashboard-output.edit', {
            parent: 'service-dashboard-output',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-dashboard-output/service-dashboard-output-dialog.html',
                    controller: 'Service_dashboard_outputDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Service_dashboard_output', function(Service_dashboard_output) {
                            return Service_dashboard_output.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-dashboard-output', null, { reload: 'service-dashboard-output' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('service-dashboard-output.delete', {
            parent: 'service-dashboard-output',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/service-dashboard-output/service-dashboard-output-delete-dialog.html',
                    controller: 'Service_dashboard_outputDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Service_dashboard_output', function(Service_dashboard_output) {
                            return Service_dashboard_output.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('service-dashboard-output', null, { reload: 'service-dashboard-output' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Service_dashboard_output', Service_dashboard_output);

    Service_dashboard_output.$inject = ['$resource'];

    function Service_dashboard_output ($resource) {
        var resourceUrl =  'api/service-dashboard-outputs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Service_dashboard_outputController', Service_dashboard_outputController);

    Service_dashboard_outputController.$inject = ['Service_dashboard_output'];

    function Service_dashboard_outputController(Service_dashboard_output) {

        var vm = this;

        vm.service_dashboard_outputs = [];

        loadAll();

        function loadAll() {
            Service_dashboard_output.query(function(result) {
                vm.service_dashboard_outputs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SectorDialogController', SectorDialogController);

    SectorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Sector'];

    function SectorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Sector) {
        var vm = this;

        vm.sector = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.sector.id !== null) {
                Sector.update(vm.sector, onSaveSuccess, onSaveError);
            } else {
                Sector.save(vm.sector, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:sectorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SectorDetailController', SectorDetailController);

    SectorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Sector'];

    function SectorDetailController($scope, $rootScope, $stateParams, previousState, entity, Sector) {
        var vm = this;

        vm.sector = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:sectorUpdate', function(event, result) {
            vm.sector = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SectorDeleteController',SectorDeleteController);

    SectorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Sector'];

    function SectorDeleteController($uibModalInstance, entity, Sector) {
        var vm = this;

        vm.sector = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Sector.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sector', {
            parent: 'entity',
            url: '/sector',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.sector.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector/sectors.html',
                    controller: 'SectorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sector');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sector-detail', {
            parent: 'sector',
            url: '/sector/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.sector.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sector/sector-detail.html',
                    controller: 'SectorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sector');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Sector', function($stateParams, Sector) {
                    return Sector.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sector',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sector-detail.edit', {
            parent: 'sector-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector/sector-dialog.html',
                    controller: 'SectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sector', function(Sector) {
                            return Sector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector.new', {
            parent: 'sector',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector/sector-dialog.html',
                    controller: 'SectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sectortype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sector', null, { reload: 'sector' });
                }, function() {
                    $state.go('sector');
                });
            }]
        })
        .state('sector.edit', {
            parent: 'sector',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector/sector-dialog.html',
                    controller: 'SectorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sector', function(Sector) {
                            return Sector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector', null, { reload: 'sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sector.delete', {
            parent: 'sector',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sector/sector-delete-dialog.html',
                    controller: 'SectorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Sector', function(Sector) {
                            return Sector.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sector', null, { reload: 'sector' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Sector', Sector);

    Sector.$inject = ['$resource'];

    function Sector ($resource) {
        var resourceUrl =  'api/sectors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SectorController', SectorController);

    SectorController.$inject = ['Sector'];

    function SectorController(Sector) {

        var vm = this;

        vm.sectors = [];

        loadAll();

        function loadAll() {
            Sector.query(function(result) {
                vm.sectors = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ScheduledVisitsDialogController', ScheduledVisitsDialogController);

    ScheduledVisitsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ScheduledVisits'];

    function ScheduledVisitsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ScheduledVisits) {
        var vm = this;

        vm.scheduledVisits = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.scheduledVisits.id !== null) {
                ScheduledVisits.update(vm.scheduledVisits, onSaveSuccess, onSaveError);
            } else {
                ScheduledVisits.save(vm.scheduledVisits, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:scheduledVisitsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.scheduledDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ScheduledVisitsDetailController', ScheduledVisitsDetailController);

    ScheduledVisitsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ScheduledVisits'];

    function ScheduledVisitsDetailController($scope, $rootScope, $stateParams, previousState, entity, ScheduledVisits) {
        var vm = this;

        vm.scheduledVisits = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:scheduledVisitsUpdate', function(event, result) {
            vm.scheduledVisits = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ScheduledVisitsDeleteController',ScheduledVisitsDeleteController);

    ScheduledVisitsDeleteController.$inject = ['$uibModalInstance', 'entity', 'ScheduledVisits'];

    function ScheduledVisitsDeleteController($uibModalInstance, entity, ScheduledVisits) {
        var vm = this;

        vm.scheduledVisits = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ScheduledVisits.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('scheduled-visits', {
            parent: 'entity',
            url: '/scheduled-visits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.scheduledVisits.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/scheduled-visits/scheduled-visits.html',
                    controller: 'ScheduledVisitsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('scheduledVisits');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('scheduled-visits-detail', {
            parent: 'scheduled-visits',
            url: '/scheduled-visits/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.scheduledVisits.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/scheduled-visits/scheduled-visits-detail.html',
                    controller: 'ScheduledVisitsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('scheduledVisits');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ScheduledVisits', function($stateParams, ScheduledVisits) {
                    return ScheduledVisits.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'scheduled-visits',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('scheduled-visits-detail.edit', {
            parent: 'scheduled-visits-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/scheduled-visits/scheduled-visits-dialog.html',
                    controller: 'ScheduledVisitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ScheduledVisits', function(ScheduledVisits) {
                            return ScheduledVisits.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('scheduled-visits.new', {
            parent: 'scheduled-visits',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/scheduled-visits/scheduled-visits-dialog.html',
                    controller: 'ScheduledVisitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectId: null,
                                serviceId: null,
                                status: null,
                                scheduledDate: null,
                                assignedToOfficer: null,
                                assignedOfficerMail: null,
                                officerContact: null,
                                userName: null,
                                userEmail: null,
                                userContact: null,
                                cafPin: null,
                                serviceName: null,
                                businessEntity: null,
                                district: null,
                                departmentName: null,
                                ocDepartmentName: null,
                                ocServiceId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('scheduled-visits', null, { reload: 'scheduled-visits' });
                }, function() {
                    $state.go('scheduled-visits');
                });
            }]
        })
        .state('scheduled-visits.edit', {
            parent: 'scheduled-visits',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/scheduled-visits/scheduled-visits-dialog.html',
                    controller: 'ScheduledVisitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ScheduledVisits', function(ScheduledVisits) {
                            return ScheduledVisits.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('scheduled-visits', null, { reload: 'scheduled-visits' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('scheduled-visits.delete', {
            parent: 'scheduled-visits',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/scheduled-visits/scheduled-visits-delete-dialog.html',
                    controller: 'ScheduledVisitsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ScheduledVisits', function(ScheduledVisits) {
                            return ScheduledVisits.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('scheduled-visits', null, { reload: 'scheduled-visits' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ScheduledVisits', ScheduledVisits);

    ScheduledVisits.$inject = ['$resource', 'DateUtils'];

    function ScheduledVisits ($resource, DateUtils) {
        var resourceUrl =  'api/scheduled-visits/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.scheduledDate = DateUtils.convertLocalDateFromServer(data.scheduledDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.scheduledDate = DateUtils.convertLocalDateToServer(copy.scheduledDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.scheduledDate = DateUtils.convertLocalDateToServer(copy.scheduledDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ScheduledVisitsController', ScheduledVisitsController);

    ScheduledVisitsController.$inject = ['ScheduledVisits'];

    function ScheduledVisitsController(ScheduledVisits) {

        var vm = this;

        vm.scheduledVisits = [];

        loadAll();

        function loadAll() {
            ScheduledVisits.query(function(result) {
                vm.scheduledVisits = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RowBusinessEntityDialogController', RowBusinessEntityDialogController);

    RowBusinessEntityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RowBusinessEntity'];

    function RowBusinessEntityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RowBusinessEntity) {
        var vm = this;

        vm.rowBusinessEntity = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rowBusinessEntity.id !== null) {
                RowBusinessEntity.update(vm.rowBusinessEntity, onSaveSuccess, onSaveError);
            } else {
                RowBusinessEntity.save(vm.rowBusinessEntity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:rowBusinessEntityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RowBusinessEntityDetailController', RowBusinessEntityDetailController);

    RowBusinessEntityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RowBusinessEntity'];

    function RowBusinessEntityDetailController($scope, $rootScope, $stateParams, previousState, entity, RowBusinessEntity) {
        var vm = this;

        vm.rowBusinessEntity = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:rowBusinessEntityUpdate', function(event, result) {
            vm.rowBusinessEntity = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RowBusinessEntityDeleteController',RowBusinessEntityDeleteController);

    RowBusinessEntityDeleteController.$inject = ['$uibModalInstance', 'entity', 'RowBusinessEntity'];

    function RowBusinessEntityDeleteController($uibModalInstance, entity, RowBusinessEntity) {
        var vm = this;

        vm.rowBusinessEntity = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RowBusinessEntity.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('row-business-entity', {
            parent: 'entity',
            url: '/row-business-entity',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.rowBusinessEntity.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/row-business-entity/row-business-entities.html',
                    controller: 'RowBusinessEntityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rowBusinessEntity');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('row-business-entity-detail', {
            parent: 'row-business-entity',
            url: '/row-business-entity/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.rowBusinessEntity.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/row-business-entity/row-business-entity-detail.html',
                    controller: 'RowBusinessEntityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rowBusinessEntity');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RowBusinessEntity', function($stateParams, RowBusinessEntity) {
                    return RowBusinessEntity.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'row-business-entity',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('row-business-entity-detail.edit', {
            parent: 'row-business-entity-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/row-business-entity/row-business-entity-dialog.html',
                    controller: 'RowBusinessEntityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RowBusinessEntity', function(RowBusinessEntity) {
                            return RowBusinessEntity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('row-business-entity.new', {
            parent: 'row-business-entity',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/row-business-entity/row-business-entity-dialog.html',
                    controller: 'RowBusinessEntityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                be_code: null,
                                createdDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('row-business-entity', null, { reload: 'row-business-entity' });
                }, function() {
                    $state.go('row-business-entity');
                });
            }]
        })
        .state('row-business-entity.edit', {
            parent: 'row-business-entity',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/row-business-entity/row-business-entity-dialog.html',
                    controller: 'RowBusinessEntityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RowBusinessEntity', function(RowBusinessEntity) {
                            return RowBusinessEntity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('row-business-entity', null, { reload: 'row-business-entity' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('row-business-entity.delete', {
            parent: 'row-business-entity',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/row-business-entity/row-business-entity-delete-dialog.html',
                    controller: 'RowBusinessEntityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RowBusinessEntity', function(RowBusinessEntity) {
                            return RowBusinessEntity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('row-business-entity', null, { reload: 'row-business-entity' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('RowBusinessEntity', RowBusinessEntity);

    RowBusinessEntity.$inject = ['$resource', 'DateUtils'];

    function RowBusinessEntity ($resource, DateUtils) {
        var resourceUrl =  'api/row-business-entities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RowBusinessEntityController', RowBusinessEntityController);

    RowBusinessEntityController.$inject = ['RowBusinessEntity'];

    function RowBusinessEntityController(RowBusinessEntity) {

        var vm = this;

        vm.rowBusinessEntities = [];

        loadAll();

        function loadAll() {
            RowBusinessEntity.query(function(result) {
                vm.rowBusinessEntities = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RmlistDialogController', RmlistDialogController);

    RmlistDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Rmlist','District'];

    function RmlistDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Rmlist,District) {
        var vm = this;

        vm.rmlist = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        loadAllDistricts();
        function loadAllDistricts() {
            District.query(function (result) {
               vm.districts=result;
               var obj={districtname:'Haryana',
                       powercompany:null,
                       stateID:null,
                       id:null,
                       statename:'Haryana'};
               vm.districts.push(obj);
               for( var i = 0; i < vm.districts.length-1; i++){
                                 if ( vm.districts[i].districtname === 'Chandigarh HQ') {
                                   vm.districts.splice(i, 1);
                                 }
                              }
            });
        }
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rmlist.id !== null) {
                Rmlist.update(vm.rmlist, onSaveSuccess, onSaveError);
            } else {
                Rmlist.save(vm.rmlist, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:rmlistUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RmlistDetailController', RmlistDetailController);

    RmlistDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Rmlist'];

    function RmlistDetailController($scope, $rootScope, $stateParams, previousState, entity, Rmlist) {
        var vm = this;

        vm.rmlist = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:rmlistUpdate', function(event, result) {
            vm.rmlist = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RmlistDeleteController',RmlistDeleteController);

    RmlistDeleteController.$inject = ['$uibModalInstance', 'entity', 'Rmlist','CheckRm','ReplaceRm'];

    function RmlistDeleteController($uibModalInstance, entity, Rmlist, CheckRm, ReplaceRm) {
        var vm = this;

        vm.rmlist = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        vm.loadAll =loadAll;
        vm.replaceRm =replaceRm;

        loadAll();
        function loadAll(){
            CheckRm.get({ id : vm.rmlist.id}, function(res){
                vm.replacement=!(res.value);
            });
            Rmlist.query(function(result) {
                            vm.rmlists = result;
                            var list = vm.rmlists;
                                        vm.rmloginList = list.filter(function(obj){
                                            return obj.district=='Haryana';
                                        });
                            vm.searchQuery = null;

                       });

        }

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function replaceRm(id,newRm) {
            vm.rmForbidden =false;
            vm.showRMStatus =false;
            var newRm1 = newRm.split('.').join('#');
            ReplaceRm.get({rmOld : vm.rmlist.rmlogin, rmNew: newRm1 },function(result){
            vm.showConfirmation=true;
           }, function(err){
                if(err.status === 404){
                vm.showRMStatus=true;
               }
               if(err.status===403){
                vm.rmForbidden =true;
               }
           });
        }

        function confirmDelete (id) {
            Rmlist.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rmlist', {
            parent: 'entity',
            url: '/rmlist',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.rmlist.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rmlist/rmlists.html',
                    controller: 'RmlistController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rmlist');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('rmlist-detail', {
            parent: 'rmlist',
            url: '/rmlist/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.rmlist.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rmlist/rmlist-detail.html',
                    controller: 'RmlistDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rmlist');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Rmlist', function($stateParams, Rmlist) {
                    return Rmlist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rmlist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rmlist-detail.edit', {
            parent: 'rmlist-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rmlist/rmlist-dialog.html',
                    controller: 'RmlistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Rmlist', function(Rmlist) {
                            return Rmlist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rmlist.new', {
            parent: 'rmlist',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rmlist/rmlist-dialog.html',
                    controller: 'RmlistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                rmlogin: null,
                                district: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rmlist', null, { reload: 'rmlist' });
                }, function() {
                    $state.go('rmlist');
                });
            }]
        })
        .state('rmlist.edit', {
            parent: 'rmlist',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rmlist/rmlist-dialog.html',
                    controller: 'RmlistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Rmlist', function(Rmlist) {
                            return Rmlist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rmlist', null, { reload: 'rmlist' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rmlist.delete', {
            parent: 'rmlist',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rmlist/rmlist-delete-dialog.html',
                    controller: 'RmlistDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Rmlist', function(Rmlist) {
                            return Rmlist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rmlist', null, { reload: 'rmlist' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Rmlist', Rmlist);

    Rmlist.$inject = ['$resource'];

    function Rmlist ($resource) {
        var resourceUrl =  'api/rmlists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RmlistController', RmlistController);

    RmlistController.$inject = ['Rmlist'];

    function RmlistController(Rmlist) {

        var vm = this;

        vm.rmlists = [];

        loadAll();

        function loadAll() {
            Rmlist.query(function(result) {
                vm.rmlists = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectionBucketDialogController', RejectionBucketDialogController);

    RejectionBucketDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RejectionBucket'];

    function RejectionBucketDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RejectionBucket) {
        var vm = this;

        vm.rejectionBucket = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rejectionBucket.id !== null) {
                RejectionBucket.update(vm.rejectionBucket, onSaveSuccess, onSaveError);
            } else {
                RejectionBucket.save(vm.rejectionBucket, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:rejectionBucketUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.rejectionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectionBucketDetailController', RejectionBucketDetailController);

    RejectionBucketDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RejectionBucket'];

    function RejectionBucketDetailController($scope, $rootScope, $stateParams, previousState, entity, RejectionBucket) {
        var vm = this;

        vm.rejectionBucket = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:rejectionBucketUpdate', function(event, result) {
            vm.rejectionBucket = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectionBucketDeleteController',RejectionBucketDeleteController);

    RejectionBucketDeleteController.$inject = ['$uibModalInstance', 'entity', 'RejectionBucket'];

    function RejectionBucketDeleteController($uibModalInstance, entity, RejectionBucket) {
        var vm = this;

        vm.rejectionBucket = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RejectionBucket.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rejection-bucket', {
            parent: 'entity',
            url: '/rejection-bucket',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.rejectionBucket.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rejection-bucket/rejection-buckets.html',
                    controller: 'RejectionBucketController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rejectionBucket');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('rejection-bucket-detail', {
            parent: 'rejection-bucket',
            url: '/rejection-bucket/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.rejectionBucket.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rejection-bucket/rejection-bucket-detail.html',
                    controller: 'RejectionBucketDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rejectionBucket');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RejectionBucket', function($stateParams, RejectionBucket) {
                    return RejectionBucket.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rejection-bucket',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rejection-bucket-detail.edit', {
            parent: 'rejection-bucket-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejection-bucket/rejection-bucket-dialog.html',
                    controller: 'RejectionBucketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RejectionBucket', function(RejectionBucket) {
                            return RejectionBucket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rejection-bucket.new', {
            parent: 'rejection-bucket',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejection-bucket/rejection-bucket-dialog.html',
                    controller: 'RejectionBucketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectId: null,
                                serviceId: null,
                                projectServiceDetailId: null,
                                serviceName: null,
                                departmentName: null,
                                reApplyCounter: null,
                                rejectionReason: null,
                                rejectionDate: null,
                                cafPin: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rejection-bucket', null, { reload: 'rejection-bucket' });
                }, function() {
                    $state.go('rejection-bucket');
                });
            }]
        })
        .state('rejection-bucket.edit', {
            parent: 'rejection-bucket',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejection-bucket/rejection-bucket-dialog.html',
                    controller: 'RejectionBucketDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RejectionBucket', function(RejectionBucket) {
                            return RejectionBucket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rejection-bucket', null, { reload: 'rejection-bucket' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rejection-bucket.delete', {
            parent: 'rejection-bucket',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejection-bucket/rejection-bucket-delete-dialog.html',
                    controller: 'RejectionBucketDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RejectionBucket', function(RejectionBucket) {
                            return RejectionBucket.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rejection-bucket', null, { reload: 'rejection-bucket' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('RejectionBucket', RejectionBucket);

    RejectionBucket.$inject = ['$resource', 'DateUtils'];

    function RejectionBucket ($resource, DateUtils) {
        var resourceUrl =  'api/rejection-buckets/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.rejectionDate = DateUtils.convertDateTimeFromServer(data.rejectionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectionBucketController', RejectionBucketController);

    RejectionBucketController.$inject = ['RejectionBucket'];

    function RejectionBucketController(RejectionBucket) {

        var vm = this;

        vm.rejectionBuckets = [];

        loadAll();

        function loadAll() {
            RejectionBucket.query(function(result) {
                vm.rejectionBuckets = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectedServicesDialogController', RejectedServicesDialogController);

    RejectedServicesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RejectedServices'];

    function RejectedServicesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RejectedServices) {
        var vm = this;

        vm.rejectedServices = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rejectedServices.id !== null) {
                RejectedServices.update(vm.rejectedServices, onSaveSuccess, onSaveError);
            } else {
                RejectedServices.save(vm.rejectedServices, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:rejectedServicesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.rejectionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectedServicesDetailController', RejectedServicesDetailController);

    RejectedServicesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RejectedServices'];

    function RejectedServicesDetailController($scope, $rootScope, $stateParams, previousState, entity, RejectedServices) {
        var vm = this;

        vm.rejectedServices = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:rejectedServicesUpdate', function(event, result) {
            vm.rejectedServices = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectedServicesDeleteController',RejectedServicesDeleteController);

    RejectedServicesDeleteController.$inject = ['$uibModalInstance', 'entity', 'RejectedServices'];

    function RejectedServicesDeleteController($uibModalInstance, entity, RejectedServices) {
        var vm = this;

        vm.rejectedServices = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RejectedServices.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rejected-services', {
            parent: 'entity',
            url: '/rejected-services',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.rejectedServices.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rejected-services/rejected-services.html',
                    controller: 'RejectedServicesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rejectedServices');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('rejected-services-detail', {
            parent: 'rejected-services',
            url: '/rejected-services/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.rejectedServices.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rejected-services/rejected-services-detail.html',
                    controller: 'RejectedServicesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rejectedServices');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RejectedServices', function($stateParams, RejectedServices) {
                    return RejectedServices.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rejected-services',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rejected-services-detail.edit', {
            parent: 'rejected-services-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejected-services/rejected-services-dialog.html',
                    controller: 'RejectedServicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RejectedServices', function(RejectedServices) {
                            return RejectedServices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rejected-services.new', {
            parent: 'rejected-services',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejected-services/rejected-services-dialog.html',
                    controller: 'RejectedServicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                rejectionDate: null,
                                serviceId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rejected-services', null, { reload: 'rejected-services' });
                }, function() {
                    $state.go('rejected-services');
                });
            }]
        })
        .state('rejected-services.edit', {
            parent: 'rejected-services',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejected-services/rejected-services-dialog.html',
                    controller: 'RejectedServicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RejectedServices', function(RejectedServices) {
                            return RejectedServices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rejected-services', null, { reload: 'rejected-services' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rejected-services.delete', {
            parent: 'rejected-services',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejected-services/rejected-services-delete-dialog.html',
                    controller: 'RejectedServicesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RejectedServices', function(RejectedServices) {
                            return RejectedServices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rejected-services', null, { reload: 'rejected-services' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('RejectedServices', RejectedServices);

    RejectedServices.$inject = ['$resource', 'DateUtils'];

    function RejectedServices ($resource, DateUtils) {
        var resourceUrl =  'api/rejected-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.rejectionDate = DateUtils.convertLocalDateFromServer(data.rejectionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.rejectionDate = DateUtils.convertLocalDateToServer(copy.rejectionDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.rejectionDate = DateUtils.convertLocalDateToServer(copy.rejectionDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectedServicesController', RejectedServicesController);

    RejectedServicesController.$inject = ['RejectedServices'];

    function RejectedServicesController(RejectedServices) {

        var vm = this;

        vm.rejectedServices = [];

        loadAll();

        function loadAll() {
            RejectedServices.query(function(result) {
                vm.rejectedServices = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectedProjectServiceLogDialogController', RejectedProjectServiceLogDialogController);

    RejectedProjectServiceLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RejectedProjectServiceLog'];

    function RejectedProjectServiceLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RejectedProjectServiceLog) {
        var vm = this;

        vm.rejectedProjectServiceLog = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rejectedProjectServiceLog.id !== null) {
                RejectedProjectServiceLog.update(vm.rejectedProjectServiceLog, onSaveSuccess, onSaveError);
            } else {
                RejectedProjectServiceLog.save(vm.rejectedProjectServiceLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:rejectedProjectServiceLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectedProjectServiceLogDetailController', RejectedProjectServiceLogDetailController);

    RejectedProjectServiceLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RejectedProjectServiceLog'];

    function RejectedProjectServiceLogDetailController($scope, $rootScope, $stateParams, previousState, entity, RejectedProjectServiceLog) {
        var vm = this;

        vm.rejectedProjectServiceLog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:rejectedProjectServiceLogUpdate', function(event, result) {
            vm.rejectedProjectServiceLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectedProjectServiceLogDeleteController',RejectedProjectServiceLogDeleteController);

    RejectedProjectServiceLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'RejectedProjectServiceLog'];

    function RejectedProjectServiceLogDeleteController($uibModalInstance, entity, RejectedProjectServiceLog) {
        var vm = this;

        vm.rejectedProjectServiceLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RejectedProjectServiceLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rejected-project-service-log', {
            parent: 'entity',
            url: '/rejected-project-service-log',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.rejectedProjectServiceLog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rejected-project-service-log/rejected-project-service-logs.html',
                    controller: 'RejectedProjectServiceLogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rejectedProjectServiceLog');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('rejected-project-service-log-detail', {
            parent: 'rejected-project-service-log',
            url: '/rejected-project-service-log/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.rejectedProjectServiceLog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rejected-project-service-log/rejected-project-service-log-detail.html',
                    controller: 'RejectedProjectServiceLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rejectedProjectServiceLog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RejectedProjectServiceLog', function($stateParams, RejectedProjectServiceLog) {
                    return RejectedProjectServiceLog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rejected-project-service-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rejected-project-service-log-detail.edit', {
            parent: 'rejected-project-service-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejected-project-service-log/rejected-project-service-log-dialog.html',
                    controller: 'RejectedProjectServiceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RejectedProjectServiceLog', function(RejectedProjectServiceLog) {
                            return RejectedProjectServiceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rejected-project-service-log.new', {
            parent: 'rejected-project-service-log',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejected-project-service-log/rejected-project-service-log-dialog.html',
                    controller: 'RejectedProjectServiceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectServiceLogId: null,
                                reasonCode: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rejected-project-service-log', null, { reload: 'rejected-project-service-log' });
                }, function() {
                    $state.go('rejected-project-service-log');
                });
            }]
        })
        .state('rejected-project-service-log.edit', {
            parent: 'rejected-project-service-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejected-project-service-log/rejected-project-service-log-dialog.html',
                    controller: 'RejectedProjectServiceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RejectedProjectServiceLog', function(RejectedProjectServiceLog) {
                            return RejectedProjectServiceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rejected-project-service-log', null, { reload: 'rejected-project-service-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rejected-project-service-log.delete', {
            parent: 'rejected-project-service-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rejected-project-service-log/rejected-project-service-log-delete-dialog.html',
                    controller: 'RejectedProjectServiceLogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RejectedProjectServiceLog', function(RejectedProjectServiceLog) {
                            return RejectedProjectServiceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rejected-project-service-log', null, { reload: 'rejected-project-service-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('RejectedProjectServiceLog', RejectedProjectServiceLog);

    RejectedProjectServiceLog.$inject = ['$resource'];

    function RejectedProjectServiceLog ($resource) {
        var resourceUrl =  'api/rejected-project-service-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RejectedProjectServiceLogController', RejectedProjectServiceLogController);

    RejectedProjectServiceLogController.$inject = ['RejectedProjectServiceLog'];

    function RejectedProjectServiceLogController(RejectedProjectServiceLog) {

        var vm = this;

        vm.rejectedProjectServiceLogs = [];

        loadAll();

        function loadAll() {
            RejectedProjectServiceLog.query(function(result) {
                vm.rejectedProjectServiceLogs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Regular_electrict_load_typeDialogController', Regular_electrict_load_typeDialogController);

    Regular_electrict_load_typeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Regular_electrict_load_type'];

    function Regular_electrict_load_typeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Regular_electrict_load_type) {
        var vm = this;

        vm.regular_electrict_load_type = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.regular_electrict_load_type.id !== null) {
                Regular_electrict_load_type.update(vm.regular_electrict_load_type, onSaveSuccess, onSaveError);
            } else {
                Regular_electrict_load_type.save(vm.regular_electrict_load_type, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:regular_electrict_load_typeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Regular_electrict_load_typeDetailController', Regular_electrict_load_typeDetailController);

    Regular_electrict_load_typeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Regular_electrict_load_type'];

    function Regular_electrict_load_typeDetailController($scope, $rootScope, $stateParams, previousState, entity, Regular_electrict_load_type) {
        var vm = this;

        vm.regular_electrict_load_type = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:regular_electrict_load_typeUpdate', function(event, result) {
            vm.regular_electrict_load_type = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Regular_electrict_load_typeDeleteController',Regular_electrict_load_typeDeleteController);

    Regular_electrict_load_typeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Regular_electrict_load_type'];

    function Regular_electrict_load_typeDeleteController($uibModalInstance, entity, Regular_electrict_load_type) {
        var vm = this;

        vm.regular_electrict_load_type = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Regular_electrict_load_type.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('regular-electrict-load-type', {
            parent: 'entity',
            url: '/regular-electrict-load-type',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.regular_electrict_load_type.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/regular-electrict-load-type/regular-electrict-load-types.html',
                    controller: 'Regular_electrict_load_typeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('regular_electrict_load_type');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('regular-electrict-load-type-detail', {
            parent: 'regular-electrict-load-type',
            url: '/regular-electrict-load-type/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.regular_electrict_load_type.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/regular-electrict-load-type/regular-electrict-load-type-detail.html',
                    controller: 'Regular_electrict_load_typeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('regular_electrict_load_type');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Regular_electrict_load_type', function($stateParams, Regular_electrict_load_type) {
                    return Regular_electrict_load_type.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'regular-electrict-load-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('regular-electrict-load-type-detail.edit', {
            parent: 'regular-electrict-load-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-electrict-load-type/regular-electrict-load-type-dialog.html',
                    controller: 'Regular_electrict_load_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Regular_electrict_load_type', function(Regular_electrict_load_type) {
                            return Regular_electrict_load_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('regular-electrict-load-type.new', {
            parent: 'regular-electrict-load-type',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-electrict-load-type/regular-electrict-load-type-dialog.html',
                    controller: 'Regular_electrict_load_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                typeofload: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('regular-electrict-load-type', null, { reload: 'regular-electrict-load-type' });
                }, function() {
                    $state.go('regular-electrict-load-type');
                });
            }]
        })
        .state('regular-electrict-load-type.edit', {
            parent: 'regular-electrict-load-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-electrict-load-type/regular-electrict-load-type-dialog.html',
                    controller: 'Regular_electrict_load_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Regular_electrict_load_type', function(Regular_electrict_load_type) {
                            return Regular_electrict_load_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('regular-electrict-load-type', null, { reload: 'regular-electrict-load-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('regular-electrict-load-type.delete', {
            parent: 'regular-electrict-load-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/regular-electrict-load-type/regular-electrict-load-type-delete-dialog.html',
                    controller: 'Regular_electrict_load_typeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Regular_electrict_load_type', function(Regular_electrict_load_type) {
                            return Regular_electrict_load_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('regular-electrict-load-type', null, { reload: 'regular-electrict-load-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Regular_electrict_load_type', Regular_electrict_load_type);

    Regular_electrict_load_type.$inject = ['$resource'];

    function Regular_electrict_load_type ($resource) {
        var resourceUrl =  'api/regular-electrict-load-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Regular_electrict_load_typeController', Regular_electrict_load_typeController);

    Regular_electrict_load_typeController.$inject = ['Regular_electrict_load_type'];

    function Regular_electrict_load_typeController(Regular_electrict_load_type) {

        var vm = this;

        vm.regular_electrict_load_types = [];

        loadAll();

        function loadAll() {
            Regular_electrict_load_type.query(function(result) {
                vm.regular_electrict_load_types = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReasonCategoryDialogController', ReasonCategoryDialogController);

    ReasonCategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ReasonCategory'];

    function ReasonCategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ReasonCategory) {
        var vm = this;

        vm.reasonCategory = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reasonCategory.id !== null) {
                ReasonCategory.update(vm.reasonCategory, onSaveSuccess, onSaveError);
            } else {
                ReasonCategory.save(vm.reasonCategory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:reasonCategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReasonCategoryDetailController', ReasonCategoryDetailController);

    ReasonCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ReasonCategory'];

    function ReasonCategoryDetailController($scope, $rootScope, $stateParams, previousState, entity, ReasonCategory) {
        var vm = this;

        vm.reasonCategory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:reasonCategoryUpdate', function(event, result) {
            vm.reasonCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReasonCategoryDeleteController',ReasonCategoryDeleteController);

    ReasonCategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReasonCategory'];

    function ReasonCategoryDeleteController($uibModalInstance, entity, ReasonCategory) {
        var vm = this;

        vm.reasonCategory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ReasonCategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reason-category', {
            parent: 'entity',
            url: '/reason-category',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.reasonCategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/reason-category/reason-categories.html',
                    controller: 'ReasonCategoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reasonCategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('reason-category-detail', {
            parent: 'reason-category',
            url: '/reason-category/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.reasonCategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/reason-category/reason-category-detail.html',
                    controller: 'ReasonCategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reasonCategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ReasonCategory', function($stateParams, ReasonCategory) {
                    return ReasonCategory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'reason-category',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('reason-category-detail.edit', {
            parent: 'reason-category-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reason-category/reason-category-dialog.html',
                    controller: 'ReasonCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReasonCategory', function(ReasonCategory) {
                            return ReasonCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('reason-category.new', {
            parent: 'reason-category',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reason-category/reason-category-dialog.html',
                    controller: 'ReasonCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                category: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('reason-category', null, { reload: 'reason-category' });
                }, function() {
                    $state.go('reason-category');
                });
            }]
        })
        .state('reason-category.edit', {
            parent: 'reason-category',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reason-category/reason-category-dialog.html',
                    controller: 'ReasonCategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReasonCategory', function(ReasonCategory) {
                            return ReasonCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reason-category', null, { reload: 'reason-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('reason-category.delete', {
            parent: 'reason-category',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reason-category/reason-category-delete-dialog.html',
                    controller: 'ReasonCategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ReasonCategory', function(ReasonCategory) {
                            return ReasonCategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reason-category', null, { reload: 'reason-category' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ReasonCategory', ReasonCategory);

    ReasonCategory.$inject = ['$resource'];

    function ReasonCategory ($resource) {
        var resourceUrl =  'api/reason-categories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReasonCategoryController', ReasonCategoryController);

    ReasonCategoryController.$inject = ['ReasonCategory'];

    function ReasonCategoryController(ReasonCategory) {

        var vm = this;

        vm.reasonCategories = [];

        loadAll();

        function loadAll() {
            ReasonCategory.query(function(result) {
                vm.reasonCategories = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReappliedservicesDialogController', ReappliedservicesDialogController);

    ReappliedservicesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Reappliedservices'];

    function ReappliedservicesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Reappliedservices) {
        var vm = this;

        vm.reappliedservices = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reappliedservices.id !== null) {
                Reappliedservices.update(vm.reappliedservices, onSaveSuccess, onSaveError);
            } else {
                Reappliedservices.save(vm.reappliedservices, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:reappliedservicesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.requireMarkedOnDate = false;
        vm.datePickerOpenStatus.assigOnDate = false;
        vm.datePickerOpenStatus.formFilledOnDate = false;
        vm.datePickerOpenStatus.paymentMadeOnDate = false;
        vm.datePickerOpenStatus.lastactiondate = false;
        vm.datePickerOpenStatus.statusdate = false;
        vm.datePickerOpenStatus.integrationDate = false;
        vm.datePickerOpenStatus.clearedDate = false;
        vm.datePickerOpenStatus.rejectionDate = false;
        vm.datePickerOpenStatus.deemedClearedDate = false;
        vm.datePickerOpenStatus.reAppliedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReappliedservicesDetailController', ReappliedservicesDetailController);

    ReappliedservicesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Reappliedservices'];

    function ReappliedservicesDetailController($scope, $rootScope, $stateParams, previousState, entity, Reappliedservices) {
        var vm = this;

        vm.reappliedservices = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:reappliedservicesUpdate', function(event, result) {
            vm.reappliedservices = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReappliedservicesDeleteController',ReappliedservicesDeleteController);

    ReappliedservicesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Reappliedservices'];

    function ReappliedservicesDeleteController($uibModalInstance, entity, Reappliedservices) {
        var vm = this;

        vm.reappliedservices = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Reappliedservices.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('reappliedservices', {
            parent: 'entity',
            url: '/reappliedservices',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.reappliedservices.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/reappliedservices/reappliedservices.html',
                    controller: 'ReappliedservicesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reappliedservices');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('reappliedservices-detail', {
            parent: 'reappliedservices',
            url: '/reappliedservices/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.reappliedservices.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/reappliedservices/reappliedservices-detail.html',
                    controller: 'ReappliedservicesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reappliedservices');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Reappliedservices', function($stateParams, Reappliedservices) {
                    return Reappliedservices.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'reappliedservices',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('reappliedservices-detail.edit', {
            parent: 'reappliedservices-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reappliedservices/reappliedservices-dialog.html',
                    controller: 'ReappliedservicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Reappliedservices', function(Reappliedservices) {
                            return Reappliedservices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('reappliedservices.new', {
            parent: 'reappliedservices',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reappliedservices/reappliedservices-dialog.html',
                    controller: 'ReappliedservicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                isRequired: null,
                                requireMarkedOnDate: null,
                                requireMarkedBy: null,
                                isAssigned: null,
                                assigOnDate: null,
                                assignBy: null,
                                formFilledStatus: null,
                                isPaymentMade: null,
                                isPaymentVerified: null,
                                formFilledOnDate: null,
                                formFilledBy: null,
                                paymentMadeOnDate: null,
                                status: null,
                                latestComments: null,
                                departmentName: null,
                                serviceName: null,
                                serviceStage: null,
                                isDimmed: null,
                                serviceDuration: null,
                                serviceFee: null,
                                lastactiondate: null,
                                statusdate: null,
                                isIntegrated: null,
                                integrationDate: null,
                                isDateExceeded: null,
                                url: null,
                                isShowchoosedept: null,
                                reApply: null,
                                constructionPermit: null,
                                reApplyCounter: null,
                                clearedDate: null,
                                rejectionDate: null,
                                deemedClearedDate: null,
                                reAppliedDate: null,
                                projectservicedetailId: null,
                                cafpin: null,
                                projectservicelogid: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('reappliedservices', null, { reload: 'reappliedservices' });
                }, function() {
                    $state.go('reappliedservices');
                });
            }]
        })
        .state('reappliedservices.edit', {
            parent: 'reappliedservices',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reappliedservices/reappliedservices-dialog.html',
                    controller: 'ReappliedservicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Reappliedservices', function(Reappliedservices) {
                            return Reappliedservices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reappliedservices', null, { reload: 'reappliedservices' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('reappliedservices.delete', {
            parent: 'reappliedservices',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/reappliedservices/reappliedservices-delete-dialog.html',
                    controller: 'ReappliedservicesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Reappliedservices', function(Reappliedservices) {
                            return Reappliedservices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('reappliedservices', null, { reload: 'reappliedservices' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Reappliedservices', Reappliedservices);

    Reappliedservices.$inject = ['$resource', 'DateUtils'];

    function Reappliedservices ($resource, DateUtils) {
        var resourceUrl =  'api/reappliedservices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.requireMarkedOnDate = DateUtils.convertDateTimeFromServer(data.requireMarkedOnDate);
                        data.assigOnDate = DateUtils.convertDateTimeFromServer(data.assigOnDate);
                        data.formFilledOnDate = DateUtils.convertDateTimeFromServer(data.formFilledOnDate);
                        data.paymentMadeOnDate = DateUtils.convertDateTimeFromServer(data.paymentMadeOnDate);
                        data.lastactiondate = DateUtils.convertDateTimeFromServer(data.lastactiondate);
                        data.statusdate = DateUtils.convertDateTimeFromServer(data.statusdate);
                        data.integrationDate = DateUtils.convertDateTimeFromServer(data.integrationDate);
                        data.clearedDate = DateUtils.convertDateTimeFromServer(data.clearedDate);
                        data.rejectionDate = DateUtils.convertDateTimeFromServer(data.rejectionDate);
                        data.deemedClearedDate = DateUtils.convertDateTimeFromServer(data.deemedClearedDate);
                        data.reAppliedDate = DateUtils.convertDateTimeFromServer(data.reAppliedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReappliedservicesController', ReappliedservicesController);

    ReappliedservicesController.$inject = ['Reappliedservices'];

    function ReappliedservicesController(Reappliedservices) {

        var vm = this;

        vm.reappliedservices = [];
        vm.loadByProjectservicedetailid = loadByProjectservicedetailid;

//        loadAll();
//
//        function loadAll() {
//            Reappliedservices.query(function(result) {
//                vm.reappliedservices = result;
//                vm.searchQuery = null;
//            });
//        }

        function loadByProjectservicedetailid(projectservicedetailid) {
            vm.reappliedservices = null;
            Reappliedservices.query({projectservicedetailid:projectservicedetailid}, function(result) {
                vm.reappliedservices = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReApplyDashboardDialogController', ReApplyDashboardDialogController);

    ReApplyDashboardDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ReApplyDashboard'];

    function ReApplyDashboardDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ReApplyDashboard) {
        var vm = this;

        vm.reApplyDashboard = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.reApplyDashboard.id !== null) {
                ReApplyDashboard.update(vm.reApplyDashboard, onSaveSuccess, onSaveError);
            } else {
                ReApplyDashboard.save(vm.reApplyDashboard, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:reApplyDashboardUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.reApplyDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReApplyDashboardDetailController', ReApplyDashboardDetailController);

    ReApplyDashboardDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ReApplyDashboard'];

    function ReApplyDashboardDetailController($scope, $rootScope, $stateParams, previousState, entity, ReApplyDashboard) {
        var vm = this;

        vm.reApplyDashboard = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:reApplyDashboardUpdate', function(event, result) {
            vm.reApplyDashboard = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReApplyDashboardDeleteController',ReApplyDashboardDeleteController);

    ReApplyDashboardDeleteController.$inject = ['$uibModalInstance', 'entity', 'ReApplyDashboard'];

    function ReApplyDashboardDeleteController($uibModalInstance, entity, ReApplyDashboard) {
        var vm = this;

        vm.reApplyDashboard = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ReApplyDashboard.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('re-apply-dashboard', {
            parent: 'entity',
            url: '/re-apply-dashboard',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.reApplyDashboard.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/re-apply-dashboard/re-apply-dashboards.html',
                    controller: 'ReApplyDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reApplyDashboard');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('re-apply-dashboard-detail', {
            parent: 're-apply-dashboard',
            url: '/re-apply-dashboard/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.reApplyDashboard.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/re-apply-dashboard/re-apply-dashboard-detail.html',
                    controller: 'ReApplyDashboardDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reApplyDashboard');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ReApplyDashboard', function($stateParams, ReApplyDashboard) {
                    return ReApplyDashboard.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 're-apply-dashboard',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('re-apply-dashboard-detail.edit', {
            parent: 're-apply-dashboard-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/re-apply-dashboard/re-apply-dashboard-dialog.html',
                    controller: 'ReApplyDashboardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReApplyDashboard', function(ReApplyDashboard) {
                            return ReApplyDashboard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('re-apply-dashboard.new', {
            parent: 're-apply-dashboard',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/re-apply-dashboard/re-apply-dashboard-dialog.html',
                    controller: 'ReApplyDashboardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                cafpin: null,
                                projectservicedetailId: null,
                                previousStatus: null,
                                reApplyDate: null,
                                projectId: null,
                                serviceId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('re-apply-dashboard', null, { reload: 're-apply-dashboard' });
                }, function() {
                    $state.go('re-apply-dashboard');
                });
            }]
        })
        .state('re-apply-dashboard.edit', {
            parent: 're-apply-dashboard',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/re-apply-dashboard/re-apply-dashboard-dialog.html',
                    controller: 'ReApplyDashboardDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ReApplyDashboard', function(ReApplyDashboard) {
                            return ReApplyDashboard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('re-apply-dashboard', null, { reload: 're-apply-dashboard' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('re-apply-dashboard.delete', {
            parent: 're-apply-dashboard',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/re-apply-dashboard/re-apply-dashboard-delete-dialog.html',
                    controller: 'ReApplyDashboardDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ReApplyDashboard', function(ReApplyDashboard) {
                            return ReApplyDashboard.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('re-apply-dashboard', null, { reload: 're-apply-dashboard' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ReApplyDashboard', ReApplyDashboard);

    ReApplyDashboard.$inject = ['$resource', 'DateUtils'];

    function ReApplyDashboard ($resource, DateUtils) {
        var resourceUrl =  'api/re-apply-dashboards/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.reApplyDate = DateUtils.convertDateTimeFromServer(data.reApplyDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ReApplyDashboardController', ReApplyDashboardController);

    ReApplyDashboardController.$inject = ['ReApplyDashboard'];

    function ReApplyDashboardController(ReApplyDashboard) {

        var vm = this;

        vm.reApplyDashboards = [];

        loadAll();

        function loadAll() {
            ReApplyDashboard.query(function(result) {
                vm.reApplyDashboards = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('RatingsByRating', RatingsByRating);

    RatingsByRating.$inject = ['$resource', 'DateUtils'];

    function RatingsByRating ($resource, DateUtils) {
        var resourceUrl =  'api/ratingsbyrating/:rating';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpadte = DateUtils.convertDateTimeFromServer(data.lastUpadte);
                        data.appliedDate = DateUtils.convertDateTimeFromServer(data.appliedDate);
                        data.clearedDate = DateUtils.convertDateTimeFromServer(data.clearedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('RatingsByDepartmentIdAndRating', RatingsByDepartmentIdAndRating);

    RatingsByDepartmentIdAndRating.$inject = ['$resource', 'DateUtils'];

    function RatingsByDepartmentIdAndRating ($resource, DateUtils) {
        var resourceUrl =  'api/ratingsByDepartmentIdAndRating/:rating';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpadte = DateUtils.convertDateTimeFromServer(data.lastUpadte);
                        data.appliedDate = DateUtils.convertDateTimeFromServer(data.appliedDate);
                        data.clearedDate = DateUtils.convertDateTimeFromServer(data.clearedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('RatingsByDepartmentId', RatingsByDepartmentId);

    RatingsByDepartmentId.$inject = ['$resource', 'DateUtils'];

    function RatingsByDepartmentId ($resource, DateUtils) {
        var resourceUrl =  'api/ratingsbydepartmentid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpadte = DateUtils.convertDateTimeFromServer(data.lastUpadte);
                        data.appliedDate = DateUtils.convertDateTimeFromServer(data.appliedDate);
                        data.clearedDate = DateUtils.convertDateTimeFromServer(data.clearedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RatingDialogController', RatingDialogController);

    RatingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Rating'];

    function RatingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Rating) {
        var vm = this;

        vm.rating = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rating.id !== null) {
                Rating.update(vm.rating, onSaveSuccess, onSaveError);
            } else {
                Rating.save(vm.rating, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:ratingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastUpadte = false;
        vm.datePickerOpenStatus.appliedDate = false;
        vm.datePickerOpenStatus.clearedDate = false;
        vm.datePickerOpenStatus.actionTakenDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RatingDetailController', RatingDetailController);

    RatingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Rating'];

    function RatingDetailController($scope, $rootScope, $stateParams, previousState, entity, Rating) {
        var vm = this;

        vm.rating = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:ratingUpdate', function(event, result) {
            vm.rating = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RatingDeleteController',RatingDeleteController);

    RatingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Rating'];

    function RatingDeleteController($uibModalInstance, entity, Rating) {
        var vm = this;

        vm.rating = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Rating.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rating', {
            parent: 'entity',
            url: '/rating',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.rating.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rating/ratings.html',
                    controller: 'RatingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rating');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('rating-detail', {
            parent: 'rating',
            url: '/rating/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.rating.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rating/rating-detail.html',
                    controller: 'RatingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rating');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Rating', function($stateParams, Rating) {
                    return Rating.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rating',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rating-detail.edit', {
            parent: 'rating-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rating/rating-dialog.html',
                    controller: 'RatingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Rating', function(Rating) {
                            return Rating.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rating.new', {
            parent: 'rating',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rating/rating-dialog.html',
                    controller: 'RatingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectId: null,
                                serviceId: null,
                                cafPin: null,
                                userName: null,
                                departmentName: null,
                                serviceName: null,
                                rating: null,
                                departmentId: null,
                                investorEmail: null,
                                investorContact: null,
                                comment: null,
                                name: null,
                                businessEntity: null,
                                lastUpadte: null,
                                district: null,
                                appliedDate: null,
                                clearedDate: null,
                                projectLevel: null,
                                actionTaken: null,
                                actionTakenDate: null,
                                isResolved: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rating', null, { reload: 'rating' });
                }, function() {
                    $state.go('rating');
                });
            }]
        })
        .state('rating.edit', {
            parent: 'rating',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rating/rating-dialog.html',
                    controller: 'RatingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Rating', function(Rating) {
                            return Rating.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rating', null, { reload: 'rating' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rating.delete', {
            parent: 'rating',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rating/rating-delete-dialog.html',
                    controller: 'RatingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Rating', function(Rating) {
                            return Rating.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rating', null, { reload: 'rating' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Rating', Rating);

    Rating.$inject = ['$resource', 'DateUtils'];

    function Rating ($resource, DateUtils) {
        var resourceUrl =  'api/ratings/:id';
        var resourceUrlSummary =  'api/ratingSummary';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastUpadte = DateUtils.convertDateTimeFromServer(data.lastUpadte);
                        data.appliedDate = DateUtils.convertDateTimeFromServer(data.appliedDate);
                        data.clearedDate = DateUtils.convertDateTimeFromServer(data.clearedDate);
                        data.actionTakenDate = DateUtils.convertDateTimeFromServer(data.actionTakenDate);
                    }
                    return data;
                }
            },
            'getSummary': {
                method: 'GET',
                url: resourceUrlSummary,
                isArray: true // Set to false if the response is an object instead of an array
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RatingController', RatingController);

    RatingController.$inject = ['Rating'];

    function RatingController(Rating) {

        var vm = this;

        vm.ratings = [];

        loadAll();

        function loadAll() {
            Rating.query(function(result) {
                vm.ratings = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RasCredentialsDialogController', RasCredentialsDialogController);

    RasCredentialsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'RasCredentials'];

    function RasCredentialsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, RasCredentials) {
        var vm = this;

        vm.rasCredentials = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.rasCredentials.id !== null) {
                RasCredentials.update(vm.rasCredentials, onSaveSuccess, onSaveError);
            } else {
                RasCredentials.save(vm.rasCredentials, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:rasCredentialsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RasCredentialsDetailController', RasCredentialsDetailController);

    RasCredentialsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RasCredentials'];

    function RasCredentialsDetailController($scope, $rootScope, $stateParams, previousState, entity, RasCredentials) {
        var vm = this;

        vm.rasCredentials = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:rasCredentialsUpdate', function(event, result) {
            vm.rasCredentials = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RasCredentialsDeleteController',RasCredentialsDeleteController);

    RasCredentialsDeleteController.$inject = ['$uibModalInstance', 'entity', 'RasCredentials'];

    function RasCredentialsDeleteController($uibModalInstance, entity, RasCredentials) {
        var vm = this;

        vm.rasCredentials = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            RasCredentials.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ras-credentials', {
            parent: 'entity',
            url: '/ras-credentials',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.rasCredentials.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ras-credentials/ras-credentials.html',
                    controller: 'RasCredentialsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rasCredentials');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ras-credentials-detail', {
            parent: 'ras-credentials',
            url: '/ras-credentials/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.rasCredentials.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ras-credentials/ras-credentials-detail.html',
                    controller: 'RasCredentialsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('rasCredentials');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RasCredentials', function($stateParams, RasCredentials) {
                    return RasCredentials.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'ras-credentials',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('ras-credentials-detail.edit', {
            parent: 'ras-credentials-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ras-credentials/ras-credentials-dialog.html',
                    controller: 'RasCredentialsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RasCredentials', function(RasCredentials) {
                            return RasCredentials.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ras-credentials.new', {
            parent: 'ras-credentials',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ras-credentials/ras-credentials-dialog.html',
                    controller: 'RasCredentialsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                serviceId: null,
                                rasDeptId: null,
                                rasServiceId: null,
                                deptName: null,
                                serviceName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ras-credentials', null, { reload: 'ras-credentials' });
                }, function() {
                    $state.go('ras-credentials');
                });
            }]
        })
        .state('ras-credentials.edit', {
            parent: 'ras-credentials',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ras-credentials/ras-credentials-dialog.html',
                    controller: 'RasCredentialsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RasCredentials', function(RasCredentials) {
                            return RasCredentials.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ras-credentials', null, { reload: 'ras-credentials' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('ras-credentials.delete', {
            parent: 'ras-credentials',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ras-credentials/ras-credentials-delete-dialog.html',
                    controller: 'RasCredentialsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RasCredentials', function(RasCredentials) {
                            return RasCredentials.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ras-credentials', null, { reload: 'ras-credentials' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('RasCredentials', RasCredentials);

    RasCredentials.$inject = ['$resource'];

    function RasCredentials ($resource) {
        var resourceUrl =  'api/ras-credentials/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RasCredentialsController', RasCredentialsController);

    RasCredentialsController.$inject = ['RasCredentials'];

    function RasCredentialsController(RasCredentials) {

        var vm = this;

        vm.rasCredentials = [];

        loadAll();

        function loadAll() {
            RasCredentials.query(function(result) {
                vm.rasCredentials = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PublicHolidayDialogController', PublicHolidayDialogController);

    PublicHolidayDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PublicHoliday'];

    function PublicHolidayDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PublicHoliday) {
        var vm = this;

        vm.publicHoliday = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.publicHoliday.id !== null) {
                PublicHoliday.update(vm.publicHoliday, onSaveSuccess, onSaveError);
            } else {
                PublicHoliday.save(vm.publicHoliday, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:publicHolidayUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.holidayDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PublicHolidayDetailController', PublicHolidayDetailController);

    PublicHolidayDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PublicHoliday'];

    function PublicHolidayDetailController($scope, $rootScope, $stateParams, previousState, entity, PublicHoliday) {
        var vm = this;

        vm.publicHoliday = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:publicHolidayUpdate', function(event, result) {
            vm.publicHoliday = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PublicHolidayDeleteController',PublicHolidayDeleteController);

    PublicHolidayDeleteController.$inject = ['$uibModalInstance', 'entity', 'PublicHoliday'];

    function PublicHolidayDeleteController($uibModalInstance, entity, PublicHoliday) {
        var vm = this;

        vm.publicHoliday = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PublicHoliday.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('public-holiday', {
            parent: 'entity',
            url: '/public-holiday',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.publicHoliday.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-holiday/public-holidays.html',
                    controller: 'PublicHolidayController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicHoliday');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('public-holiday-detail', {
            parent: 'public-holiday',
            url: '/public-holiday/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.publicHoliday.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/public-holiday/public-holiday-detail.html',
                    controller: 'PublicHolidayDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('publicHoliday');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PublicHoliday', function($stateParams, PublicHoliday) {
                    return PublicHoliday.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'public-holiday',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('public-holiday-detail.edit', {
            parent: 'public-holiday-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-holiday/public-holiday-dialog.html',
                    controller: 'PublicHolidayDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicHoliday', function(PublicHoliday) {
                            return PublicHoliday.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-holiday.new', {
            parent: 'public-holiday',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-holiday/public-holiday-dialog.html',
                    controller: 'PublicHolidayDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                holidayTitle: null,
                                holidayDate: null,
                                dayOfWeek: null,
                                additionalNote: null,
                                financialYear: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('public-holiday', null, { reload: 'public-holiday' });
                }, function() {
                    $state.go('public-holiday');
                });
            }]
        })
        .state('public-holiday.edit', {
            parent: 'public-holiday',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-holiday/public-holiday-dialog.html',
                    controller: 'PublicHolidayDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PublicHoliday', function(PublicHoliday) {
                            return PublicHoliday.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-holiday', null, { reload: 'public-holiday' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('public-holiday.delete', {
            parent: 'public-holiday',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/public-holiday/public-holiday-delete-dialog.html',
                    controller: 'PublicHolidayDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PublicHoliday', function(PublicHoliday) {
                            return PublicHoliday.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('public-holiday', null, { reload: 'public-holiday' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PublicHoliday', PublicHoliday);

    PublicHoliday.$inject = ['$resource', 'DateUtils'];

    function PublicHoliday ($resource, DateUtils) {
        var resourceUrl =  'api/public-holidays/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.holidayDate = DateUtils.convertLocalDateFromServer(data.holidayDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.holidayDate = DateUtils.convertLocalDateToServer(copy.holidayDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.holidayDate = DateUtils.convertLocalDateToServer(copy.holidayDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PublicHolidayController', PublicHolidayController);

    PublicHolidayController.$inject = ['PublicHoliday'];

    function PublicHolidayController(PublicHoliday) {

        var vm = this;

        vm.publicHolidays = [];

        loadAll();

        function loadAll() {
            PublicHoliday.query(function(result) {
                vm.publicHolidays = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectypeDialogController', ProjectypeDialogController);

    ProjectypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Projectype'];

    function ProjectypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Projectype) {
        var vm = this;

        vm.projectype = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectype.id !== null) {
                Projectype.update(vm.projectype, onSaveSuccess, onSaveError);
            } else {
                Projectype.save(vm.projectype, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectypeDetailController', ProjectypeDetailController);

    ProjectypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Projectype'];

    function ProjectypeDetailController($scope, $rootScope, $stateParams, previousState, entity, Projectype) {
        var vm = this;

        vm.projectype = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectypeUpdate', function(event, result) {
            vm.projectype = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectypeDeleteController',ProjectypeDeleteController);

    ProjectypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Projectype'];

    function ProjectypeDeleteController($uibModalInstance, entity, Projectype) {
        var vm = this;

        vm.projectype = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Projectype.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectype', {
            parent: 'entity',
            url: '/projectype',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectype.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectype/projectypes.html',
                    controller: 'ProjectypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectype');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectype-detail', {
            parent: 'projectype',
            url: '/projectype/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectype.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectype/projectype-detail.html',
                    controller: 'ProjectypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectype');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectype', function($stateParams, Projectype) {
                    return Projectype.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectype',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectype-detail.edit', {
            parent: 'projectype-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectype/projectype-dialog.html',
                    controller: 'ProjectypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectype', function(Projectype) {
                            return Projectype.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectype.new', {
            parent: 'projectype',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectype/projectype-dialog.html',
                    controller: 'ProjectypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectypes: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectype', null, { reload: 'projectype' });
                }, function() {
                    $state.go('projectype');
                });
            }]
        })
        .state('projectype.edit', {
            parent: 'projectype',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectype/projectype-dialog.html',
                    controller: 'ProjectypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectype', function(Projectype) {
                            return Projectype.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectype', null, { reload: 'projectype' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectype.delete', {
            parent: 'projectype',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectype/projectype-delete-dialog.html',
                    controller: 'ProjectypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectype', function(Projectype) {
                            return Projectype.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectype', null, { reload: 'projectype' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectype', Projectype);

    Projectype.$inject = ['$resource'];

    function Projectype ($resource) {
        var resourceUrl =  'api/projectypes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectypeController', ProjectypeController);

    ProjectypeController.$inject = ['Projectype'];

    function ProjectypeController(Projectype) {

        var vm = this;

        vm.projectypes = [];

        loadAll();

        function loadAll() {
            Projectype.query(function(result) {
                vm.projectypes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectsitedetailDialogController', ProjectsitedetailDialogController);

    ProjectsitedetailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Projectsitedetail'];

    function ProjectsitedetailDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Projectsitedetail) {
        var vm = this;

        vm.projectsitedetail = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectsitedetail.id !== null) {
                Projectsitedetail.update(vm.projectsitedetail, onSaveSuccess, onSaveError);
            } else {
                Projectsitedetail.save(vm.projectsitedetail, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectsitedetailUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectsitedetailDetailController', ProjectsitedetailDetailController);

    ProjectsitedetailDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Projectsitedetail'];

    function ProjectsitedetailDetailController($scope, $rootScope, $stateParams, previousState, entity, Projectsitedetail) {
        var vm = this;

        vm.projectsitedetail = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectsitedetailUpdate', function(event, result) {
            vm.projectsitedetail = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectsitedetailDeleteController',ProjectsitedetailDeleteController);

    ProjectsitedetailDeleteController.$inject = ['$uibModalInstance', 'entity', 'Projectsitedetail'];

    function ProjectsitedetailDeleteController($uibModalInstance, entity, Projectsitedetail) {
        var vm = this;

        vm.projectsitedetail = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Projectsitedetail.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectsitedetail', {
            parent: 'entity',
            url: '/projectsitedetail',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectsitedetail.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectsitedetail/projectsitedetails.html',
                    controller: 'ProjectsitedetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectsitedetail');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectsitedetail-detail', {
            parent: 'projectsitedetail',
            url: '/projectsitedetail/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectsitedetail.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectsitedetail/projectsitedetail-detail.html',
                    controller: 'ProjectsitedetailDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectsitedetail');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectsitedetail', function($stateParams, Projectsitedetail) {
                    return Projectsitedetail.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectsitedetail',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectsitedetail-detail.edit', {
            parent: 'projectsitedetail-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectsitedetail/projectsitedetail-dialog.html',
                    controller: 'ProjectsitedetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectsitedetail', function(Projectsitedetail) {
                            return Projectsitedetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectsitedetail.new', {
            parent: 'projectsitedetail',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectsitedetail/projectsitedetail-dialog.html',
                    controller: 'ProjectsitedetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                siteaddress: null,
                                multyvillageinvolved: null,
                                villageinvolved: null,
                                falls_in_aravalli: null,
                                islandprocured: null,
                                allotedbyhsiidc: null,
                                estate: null,
                                cluster: null,
                                phase: null,
                                sector: null,
                                plotno: null,
                                hadbastno: null,
                                liesunder_mc: null,
                                distance_from_mc: null,
                                islocated_in_urban: null,
                                totalproposedprojectarea: null,
                                proposedbuilt_up_area: null,
                                certifiedownership: null,
                                leaseapplicable: null,
                                landagreementapplicable: null,
                                intersectiondistance: null,
                                railwaydistance: null,
                                confirmitylanduse: null,
                                existing_building_applicable: null,
                                site_situated_in_controlled_area: null,
                                buildingexisted: null,
                                district: null,
                                block: null,
                                city_town_village: null,
                                connectingroad: null,
                                landzoneuse_type: null,
                                tehsil_subtehsil: null,
                                createdate: null,
                                updatedate: null,
                                clurequired: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectsitedetail', null, { reload: 'projectsitedetail' });
                }, function() {
                    $state.go('projectsitedetail');
                });
            }]
        })
        .state('projectsitedetail.edit', {
            parent: 'projectsitedetail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectsitedetail/projectsitedetail-dialog.html',
                    controller: 'ProjectsitedetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectsitedetail', function(Projectsitedetail) {
                            return Projectsitedetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectsitedetail', null, { reload: 'projectsitedetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectsitedetail.delete', {
            parent: 'projectsitedetail',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectsitedetail/projectsitedetail-delete-dialog.html',
                    controller: 'ProjectsitedetailDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectsitedetail', function(Projectsitedetail) {
                            return Projectsitedetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectsitedetail', null, { reload: 'projectsitedetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectsitedetail', Projectsitedetail);

    Projectsitedetail.$inject = ['$resource', 'DateUtils'];

    function Projectsitedetail ($resource, DateUtils) {
        var resourceUrl =  'api/projectsitedetails/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectsitedetailController', ProjectsitedetailController);

    ProjectsitedetailController.$inject = ['Projectsitedetail'];

    function ProjectsitedetailController(Projectsitedetail) {

        var vm = this;

        vm.projectsitedetails = [];

        loadAll();

        function loadAll() {
            Projectsitedetail.query(function(result) {
                vm.projectsitedetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('serviceFormFieldDataCollection', serviceFormFieldDataCollection);

    serviceFormFieldDataCollection.$inject = ['$resource', 'DateUtils'];

    function serviceFormFieldDataCollection ($resource, DateUtils) {
        var resourceUrl =  'api/serviceFormFieldDtaCollection/service/:serviceid/:projectid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
//                        data.requireMarkedOnDate = DateUtils.convertDateTimeFromServer(data.requireMarkedOnDate);
//                        data.assigOnDate = DateUtils.convertDateTimeFromServer(data.assigOnDate);
//                        data.formFilledOnDate = DateUtils.convertDateTimeFromServer(data.formFilledOnDate);
//                        data.paymentMadeOnDate = DateUtils.convertDateTimeFromServer(data.paymentMadeOnDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectserviceformfielddataDialogController', ProjectserviceformfielddataDialogController);

    ProjectserviceformfielddataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Projectserviceformfielddata'];

    function ProjectserviceformfielddataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Projectserviceformfielddata) {
        var vm = this;

        vm.projectserviceformfielddata = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectserviceformfielddata.id !== null) {
                Projectserviceformfielddata.update(vm.projectserviceformfielddata, onSaveSuccess, onSaveError);
            } else {
                Projectserviceformfielddata.save(vm.projectserviceformfielddata, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectserviceformfielddataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectserviceformfielddataDetailController', ProjectserviceformfielddataDetailController);

    ProjectserviceformfielddataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Projectserviceformfielddata'];

    function ProjectserviceformfielddataDetailController($scope, $rootScope, $stateParams, previousState, entity, Projectserviceformfielddata) {
        var vm = this;

        vm.projectserviceformfielddata = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectserviceformfielddataUpdate', function(event, result) {
            vm.projectserviceformfielddata = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectserviceformfielddataDeleteController',ProjectserviceformfielddataDeleteController);

    ProjectserviceformfielddataDeleteController.$inject = ['$uibModalInstance', 'entity', 'Projectserviceformfielddata'];

    function ProjectserviceformfielddataDeleteController($uibModalInstance, entity, Projectserviceformfielddata) {
        var vm = this;

        vm.projectserviceformfielddata = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Projectserviceformfielddata.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectserviceformfielddata', {
            parent: 'entity',
            url: '/projectserviceformfielddata',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectserviceformfielddata.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectserviceformfielddata/projectserviceformfielddata.html',
                    controller: 'ProjectserviceformfielddataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectserviceformfielddata');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectserviceformfielddata-detail', {
            parent: 'projectserviceformfielddata',
            url: '/projectserviceformfielddata/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectserviceformfielddata.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectserviceformfielddata/projectserviceformfielddata-detail.html',
                    controller: 'ProjectserviceformfielddataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectserviceformfielddata');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectserviceformfielddata', function($stateParams, Projectserviceformfielddata) {
                    return Projectserviceformfielddata.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectserviceformfielddata',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectserviceformfielddata-detail.edit', {
            parent: 'projectserviceformfielddata-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectserviceformfielddata/projectserviceformfielddata-dialog.html',
                    controller: 'ProjectserviceformfielddataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectserviceformfielddata', function(Projectserviceformfielddata) {
                            return Projectserviceformfielddata.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectserviceformfielddata.new', {
            parent: 'projectserviceformfielddata',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectserviceformfielddata/projectserviceformfielddata-dialog.html',
                    controller: 'ProjectserviceformfielddataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                serviceid: null,
                                formfieldvalue: null,
                                projectid: null,
                                formfieldName: null,
                                serviceformfieldid: null,
                                formfieldtype: null,
                                formfieldOrder: null,
                                formtypeOption: null,
                                isRequired: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectserviceformfielddata', null, { reload: 'projectserviceformfielddata' });
                }, function() {
                    $state.go('projectserviceformfielddata');
                });
            }]
        })
        .state('projectserviceformfielddata.edit', {
            parent: 'projectserviceformfielddata',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectserviceformfielddata/projectserviceformfielddata-dialog.html',
                    controller: 'ProjectserviceformfielddataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectserviceformfielddata', function(Projectserviceformfielddata) {
                            return Projectserviceformfielddata.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectserviceformfielddata', null, { reload: 'projectserviceformfielddata' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectserviceformfielddata.delete', {
            parent: 'projectserviceformfielddata',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectserviceformfielddata/projectserviceformfielddata-delete-dialog.html',
                    controller: 'ProjectserviceformfielddataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectserviceformfielddata', function(Projectserviceformfielddata) {
                            return Projectserviceformfielddata.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectserviceformfielddata', null, { reload: 'projectserviceformfielddata' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectserviceformfielddata', Projectserviceformfielddata);

    Projectserviceformfielddata.$inject = ['$resource'];

    function Projectserviceformfielddata ($resource) {
        var resourceUrl =  'api/projectserviceformfielddata/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectserviceformfielddataController', ProjectserviceformfielddataController);

    ProjectserviceformfielddataController.$inject = ['Projectserviceformfielddata'];

    function ProjectserviceformfielddataController(Projectserviceformfielddata) {

        var vm = this;

        vm.projectserviceformfielddata = [];

        loadAll();

        function loadAll() {
            Projectserviceformfielddata.query(function(result) {
                vm.projectserviceformfielddata = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectservicedetailByProjectId', ProjectservicedetailByProjectId);

    ProjectservicedetailByProjectId.$inject = ['$resource', 'DateUtils'];

    function ProjectservicedetailByProjectId ($resource, DateUtils) {
        var resourceUrl =  'api/projectservicedetails/byprojectid/:projectid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.requireMarkedOnDate = DateUtils.convertDateTimeFromServer(data.requireMarkedOnDate);
                        data.assigOnDate = DateUtils.convertDateTimeFromServer(data.assigOnDate);
                        data.formFilledOnDate = DateUtils.convertDateTimeFromServer(data.formFilledOnDate);
                        data.paymentMadeOnDate = DateUtils.convertDateTimeFromServer(data.paymentMadeOnDate);
                        data.lastactiondate = DateUtils.convertDateTimeFromServer(data.lastactiondate);
                        data.statusdate = DateUtils.convertDateTimeFromServer(data.statusdate);
                        data.integrationDate = DateUtils.convertDateTimeFromServer(data.integrationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectservicedetailbyProject', ProjectservicedetailbyProject);

    ProjectservicedetailbyProject.$inject = ['$resource', 'DateUtils'];

    function ProjectservicedetailbyProject ($resource, DateUtils) {
        var resourceUrl =  'api/projectservicelistforclearance/project/:id/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.requireMarkedOnDate = DateUtils.convertDateTimeFromServer(data.requireMarkedOnDate);
                        data.assigOnDate = DateUtils.convertDateTimeFromServer(data.assigOnDate);
                        data.formFilledOnDate = DateUtils.convertDateTimeFromServer(data.formFilledOnDate);
                        data.paymentMadeOnDate = DateUtils.convertDateTimeFromServer(data.paymentMadeOnDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'checkBusinessEntity': {
                method: 'GET',
                url: 'api/check-central-business-entity',
                params: {
                    id: '@id'
                },
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectservicedetailDialogController', ProjectservicedetailDialogController);

    ProjectservicedetailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Projectservicedetail'];

    function ProjectservicedetailDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Projectservicedetail) {
        var vm = this;

        vm.projectservicedetail = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectservicedetail.id !== null) {
                Projectservicedetail.update(vm.projectservicedetail, onSaveSuccess, onSaveError);
            } else {
                Projectservicedetail.save(vm.projectservicedetail, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.requireMarkedOnDate = false;
        vm.datePickerOpenStatus.assigOnDate = false;
        vm.datePickerOpenStatus.formFilledOnDate = false;
        vm.datePickerOpenStatus.paymentMadeOnDate = false;
        vm.datePickerOpenStatus.lastactiondate = false;
        vm.datePickerOpenStatus.statusdate = false;
        vm.datePickerOpenStatus.integrationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectservicedetailDetailController', ProjectservicedetailDetailController);

    ProjectservicedetailDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Projectservicedetail'];

    function ProjectservicedetailDetailController($scope, $rootScope, $stateParams, previousState, entity, Projectservicedetail) {
        var vm = this;

        vm.projectservicedetail = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectservicedetailUpdate', function(event, result) {
            vm.projectservicedetail = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectservicedetailDeleteController',ProjectservicedetailDeleteController);

    ProjectservicedetailDeleteController.$inject = ['$uibModalInstance', 'entity', 'Projectservicedetail'];

    function ProjectservicedetailDeleteController($uibModalInstance, entity, Projectservicedetail) {
        var vm = this;

        vm.projectservicedetail = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Projectservicedetail.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectservicedetail', {
            parent: 'entity',
            url: '/projectservicedetail',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectservicedetail.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectservicedetail/projectservicedetails.html',
                    controller: 'ProjectservicedetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectservicedetail');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectservicedetail-detail', {
            parent: 'projectservicedetail',
            url: '/projectservicedetail/{id}',
            data: {
                authorities: [''],
                pageTitle: 'investhryApp.projectservicedetail.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectservicedetail/projectservicedetail-detail.html',
                    controller: 'ProjectservicedetailDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectservicedetail');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectservicedetail', function($stateParams, Projectservicedetail) {
                    return Projectservicedetail.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectservicedetail',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectservicedetail-detail.edit', {
            parent: 'projectservicedetail-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectservicedetail/projectservicedetail-dialog.html',
                    controller: 'ProjectservicedetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectservicedetail.new', {
            parent: 'projectservicedetail',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectservicedetail/projectservicedetail-dialog.html',
                    controller: 'ProjectservicedetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                isRequired: null,
                                requireMarkedOnDate: null,
                                requireMarkedBy: null,
                                isAssigned: null,
                                assigOnDate: null,
                                assignBy: null,
                                formFilledStatus: null,
                                isPaymentMade: null,
                                isPaymentVerified: null,
                                formFilledOnDate: null,
                                formFilledBy: null,
                                paymentMadeOnDate: null,
                                status: null,
                                latestComments: null,
                                departmentName: null,
                                serviceName: null,
                                serviceStage: null,
                                isDimmed: null,
                                serviceDuration: null,
                                serviceFee: null,
                                lastactiondate: null,
                                statusdate: null,
                                isIntegrated: null,
                                integrationDate: null,
                                isDateExceeded: null,
                                url: null,
                                isShowchoosedept: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectservicedetail', null, { reload: 'projectservicedetail' });
                }, function() {
                    $state.go('projectservicedetail');
                });
            }]
        })
        .state('projectservicedetail.edit', {
            parent: 'projectservicedetail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectservicedetail/projectservicedetail-dialog.html',
                    controller: 'ProjectservicedetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectservicedetail', null, { reload: 'projectservicedetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectservicedetail.delete', {
            parent: 'projectservicedetail',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectservicedetail/projectservicedetail-delete-dialog.html',
                    controller: 'ProjectservicedetailDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectservicedetail', function(Projectservicedetail) {
                            return Projectservicedetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectservicedetail', null, { reload: 'projectservicedetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectservicedetail', Projectservicedetail);

    Projectservicedetail.$inject = ['$resource', 'DateUtils'];

    function Projectservicedetail ($resource, DateUtils) {
        var resourceUrl =  'api/projectservicedetails/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.requireMarkedOnDate = DateUtils.convertDateTimeFromServer(data.requireMarkedOnDate);
                        data.assigOnDate = DateUtils.convertDateTimeFromServer(data.assigOnDate);
                        data.formFilledOnDate = DateUtils.convertDateTimeFromServer(data.formFilledOnDate);
                        data.paymentMadeOnDate = DateUtils.convertDateTimeFromServer(data.paymentMadeOnDate);
                        data.lastactiondate = DateUtils.convertDateTimeFromServer(data.lastactiondate);
                        data.statusdate = DateUtils.convertDateTimeFromServer(data.statusdate);
                        data.integrationDate = DateUtils.convertDateTimeFromServer(data.integrationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectservicedetailController', ProjectservicedetailController);

    ProjectservicedetailController.$inject = ['Projectservicedetail','ProjectservicedetailByProjectId'];

    function ProjectservicedetailController(Projectservicedetail,ProjectservicedetailByProjectId) {

        var vm = this;

        vm.projectservicedetails = undefined;
        vm.loadByProjectid=loadByProjectid;


//        loadAll();

//        function loadAll() {
//            Projectservicedetail.query(function(result) {
//                vm.projectservicedetails = result;
//                vm.searchQuery = null;
//            });
//        }


        function loadByProjectid() {
            vm.projectservicedetails=null;
            ProjectservicedetailByProjectId.query({projectid:vm.projectservicedetail.projectid}, function(result) {
                vm.projectservicedetails = result;
                vm.searchQuery = null;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectrawmaterialDialogController', ProjectrawmaterialDialogController);

    ProjectrawmaterialDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Projectrawmaterial'];

    function ProjectrawmaterialDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Projectrawmaterial) {
        var vm = this;

        vm.projectrawmaterial = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectrawmaterial.id !== null) {
                Projectrawmaterial.update(vm.projectrawmaterial, onSaveSuccess, onSaveError);
            } else {
                Projectrawmaterial.save(vm.projectrawmaterial, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectrawmaterialUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectrawmaterialDetailController', ProjectrawmaterialDetailController);

    ProjectrawmaterialDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Projectrawmaterial'];

    function ProjectrawmaterialDetailController($scope, $rootScope, $stateParams, previousState, entity, Projectrawmaterial) {
        var vm = this;

        vm.projectrawmaterial = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectrawmaterialUpdate', function(event, result) {
            vm.projectrawmaterial = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectrawmaterialDeleteController',ProjectrawmaterialDeleteController);

    ProjectrawmaterialDeleteController.$inject = ['$uibModalInstance', 'entity', 'Projectrawmaterial'];

    function ProjectrawmaterialDeleteController($uibModalInstance, entity, Projectrawmaterial) {
        var vm = this;

        vm.projectrawmaterial = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Projectrawmaterial.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectrawmaterial', {
            parent: 'entity',
            url: '/projectrawmaterial',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectrawmaterial.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectrawmaterial/projectrawmaterials.html',
                    controller: 'ProjectrawmaterialController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectrawmaterial');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectrawmaterial-detail', {
            parent: 'projectrawmaterial',
            url: '/projectrawmaterial/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectrawmaterial.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectrawmaterial/projectrawmaterial-detail.html',
                    controller: 'ProjectrawmaterialDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectrawmaterial');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectrawmaterial', function($stateParams, Projectrawmaterial) {
                    return Projectrawmaterial.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectrawmaterial',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectrawmaterial-detail.edit', {
            parent: 'projectrawmaterial-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectrawmaterial/projectrawmaterial-dialog.html',
                    controller: 'ProjectrawmaterialDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectrawmaterial', function(Projectrawmaterial) {
                            return Projectrawmaterial.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectrawmaterial.new', {
            parent: 'projectrawmaterial',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectrawmaterial/projectrawmaterial-dialog.html',
                    controller: 'ProjectrawmaterialDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                rawmaterial: null,
                                quantity: null,
                                units: null,
                                createdate: null,
                                updatedate: null,
                                projectid: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectrawmaterial', null, { reload: 'projectrawmaterial' });
                }, function() {
                    $state.go('projectrawmaterial');
                });
            }]
        })
        .state('projectrawmaterial.edit', {
            parent: 'projectrawmaterial',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectrawmaterial/projectrawmaterial-dialog.html',
                    controller: 'ProjectrawmaterialDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectrawmaterial', function(Projectrawmaterial) {
                            return Projectrawmaterial.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectrawmaterial', null, { reload: 'projectrawmaterial' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectrawmaterial.delete', {
            parent: 'projectrawmaterial',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectrawmaterial/projectrawmaterial-delete-dialog.html',
                    controller: 'ProjectrawmaterialDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectrawmaterial', function(Projectrawmaterial) {
                            return Projectrawmaterial.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectrawmaterial', null, { reload: 'projectrawmaterial' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectrawmaterial', Projectrawmaterial);

    Projectrawmaterial.$inject = ['$resource', 'DateUtils'];

    function Projectrawmaterial ($resource, DateUtils) {
        var resourceUrl =  'api/projectrawmaterials/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectrawmaterialController', ProjectrawmaterialController);

    ProjectrawmaterialController.$inject = ['Projectrawmaterial'];

    function ProjectrawmaterialController(Projectrawmaterial) {

        var vm = this;

        vm.projectrawmaterials = [];

        loadAll();

        function loadAll() {
            Projectrawmaterial.query(function(result) {
                vm.projectrawmaterials = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectproductDialogController', ProjectproductDialogController);

    ProjectproductDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Projectproduct'];

    function ProjectproductDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Projectproduct) {
        var vm = this;

        vm.projectproduct = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectproduct.id !== null) {
                Projectproduct.update(vm.projectproduct, onSaveSuccess, onSaveError);
            } else {
                Projectproduct.save(vm.projectproduct, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectproductUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectproductDetailController', ProjectproductDetailController);

    ProjectproductDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Projectproduct'];

    function ProjectproductDetailController($scope, $rootScope, $stateParams, previousState, entity, Projectproduct) {
        var vm = this;

        vm.projectproduct = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectproductUpdate', function(event, result) {
            vm.projectproduct = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectproductDeleteController',ProjectproductDeleteController);

    ProjectproductDeleteController.$inject = ['$uibModalInstance', 'entity', 'Projectproduct'];

    function ProjectproductDeleteController($uibModalInstance, entity, Projectproduct) {
        var vm = this;

        vm.projectproduct = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Projectproduct.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectproduct', {
            parent: 'entity',
            url: '/projectproduct',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectproduct.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectproduct/projectproducts.html',
                    controller: 'ProjectproductController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectproduct');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectproduct-detail', {
            parent: 'projectproduct',
            url: '/projectproduct/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectproduct.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectproduct/projectproduct-detail.html',
                    controller: 'ProjectproductDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectproduct');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectproduct', function($stateParams, Projectproduct) {
                    return Projectproduct.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectproduct',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectproduct-detail.edit', {
            parent: 'projectproduct-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectproduct/projectproduct-dialog.html',
                    controller: 'ProjectproductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectproduct', function(Projectproduct) {
                            return Projectproduct.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectproduct.new', {
            parent: 'projectproduct',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectproduct/projectproduct-dialog.html',
                    controller: 'ProjectproductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                mainproduct: null,
                                quantity: null,
                                units: null,
                                createdate: null,
                                updatedate: null,
                                projectid: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectproduct', null, { reload: 'projectproduct' });
                }, function() {
                    $state.go('projectproduct');
                });
            }]
        })
        .state('projectproduct.edit', {
            parent: 'projectproduct',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectproduct/projectproduct-dialog.html',
                    controller: 'ProjectproductDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectproduct', function(Projectproduct) {
                            return Projectproduct.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectproduct', null, { reload: 'projectproduct' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectproduct.delete', {
            parent: 'projectproduct',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectproduct/projectproduct-delete-dialog.html',
                    controller: 'ProjectproductDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectproduct', function(Projectproduct) {
                            return Projectproduct.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectproduct', null, { reload: 'projectproduct' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectproduct', Projectproduct);

    Projectproduct.$inject = ['$resource', 'DateUtils'];

    function Projectproduct ($resource, DateUtils) {
        var resourceUrl =  'api/projectproducts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectproductController', ProjectproductController);

    ProjectproductController.$inject = ['Projectproduct'];

    function ProjectproductController(Projectproduct) {

        var vm = this;

        vm.projectproducts = [];

        loadAll();

        function loadAll() {
            Projectproduct.query(function(result) {
                vm.projectproducts = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectprocessflowstepsDialogController', ProjectprocessflowstepsDialogController);

    ProjectprocessflowstepsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Projectprocessflowsteps'];

    function ProjectprocessflowstepsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Projectprocessflowsteps) {
        var vm = this;

        vm.projectprocessflowsteps = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectprocessflowsteps.id !== null) {
                Projectprocessflowsteps.update(vm.projectprocessflowsteps, onSaveSuccess, onSaveError);
            } else {
                Projectprocessflowsteps.save(vm.projectprocessflowsteps, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectprocessflowstepsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectprocessflowstepsDetailController', ProjectprocessflowstepsDetailController);

    ProjectprocessflowstepsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Projectprocessflowsteps'];

    function ProjectprocessflowstepsDetailController($scope, $rootScope, $stateParams, previousState, entity, Projectprocessflowsteps) {
        var vm = this;

        vm.projectprocessflowsteps = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectprocessflowstepsUpdate', function(event, result) {
            vm.projectprocessflowsteps = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectprocessflowstepsDeleteController',ProjectprocessflowstepsDeleteController);

    ProjectprocessflowstepsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Projectprocessflowsteps'];

    function ProjectprocessflowstepsDeleteController($uibModalInstance, entity, Projectprocessflowsteps) {
        var vm = this;

        vm.projectprocessflowsteps = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Projectprocessflowsteps.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectprocessflowsteps', {
            parent: 'entity',
            url: '/projectprocessflowsteps',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectprocessflowsteps.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectprocessflowsteps/projectprocessflowsteps.html',
                    controller: 'ProjectprocessflowstepsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectprocessflowsteps');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectprocessflowsteps-detail', {
            parent: 'projectprocessflowsteps',
            url: '/projectprocessflowsteps/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectprocessflowsteps.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectprocessflowsteps/projectprocessflowsteps-detail.html',
                    controller: 'ProjectprocessflowstepsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectprocessflowsteps');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectprocessflowsteps', function($stateParams, Projectprocessflowsteps) {
                    return Projectprocessflowsteps.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectprocessflowsteps',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectprocessflowsteps-detail.edit', {
            parent: 'projectprocessflowsteps-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectprocessflowsteps/projectprocessflowsteps-dialog.html',
                    controller: 'ProjectprocessflowstepsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectprocessflowsteps', function(Projectprocessflowsteps) {
                            return Projectprocessflowsteps.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectprocessflowsteps.new', {
            parent: 'projectprocessflowsteps',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectprocessflowsteps/projectprocessflowsteps-dialog.html',
                    controller: 'ProjectprocessflowstepsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                steps: null,
                                createdate: null,
                                updatedate: null,
                                projectid: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectprocessflowsteps', null, { reload: 'projectprocessflowsteps' });
                }, function() {
                    $state.go('projectprocessflowsteps');
                });
            }]
        })
        .state('projectprocessflowsteps.edit', {
            parent: 'projectprocessflowsteps',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectprocessflowsteps/projectprocessflowsteps-dialog.html',
                    controller: 'ProjectprocessflowstepsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectprocessflowsteps', function(Projectprocessflowsteps) {
                            return Projectprocessflowsteps.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectprocessflowsteps', null, { reload: 'projectprocessflowsteps' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectprocessflowsteps.delete', {
            parent: 'projectprocessflowsteps',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectprocessflowsteps/projectprocessflowsteps-delete-dialog.html',
                    controller: 'ProjectprocessflowstepsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectprocessflowsteps', function(Projectprocessflowsteps) {
                            return Projectprocessflowsteps.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectprocessflowsteps', null, { reload: 'projectprocessflowsteps' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectprocessflowsteps', Projectprocessflowsteps);

    Projectprocessflowsteps.$inject = ['$resource', 'DateUtils'];

    function Projectprocessflowsteps ($resource, DateUtils) {
        var resourceUrl =  'api/projectprocessflowsteps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectprocessflowstepsController', ProjectprocessflowstepsController);

    ProjectprocessflowstepsController.$inject = ['Projectprocessflowsteps'];

    function ProjectprocessflowstepsController(Projectprocessflowsteps) {

        var vm = this;

        vm.projectprocessflowsteps = [];

        loadAll();

        function loadAll() {
            Projectprocessflowsteps.query(function(result) {
                vm.projectprocessflowsteps = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectlogDialogController', ProjectlogDialogController);

    ProjectlogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Projectlog'];

    function ProjectlogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Projectlog) {
        var vm = this;

        vm.projectlog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectlog.id !== null) {
                Projectlog.update(vm.projectlog, onSaveSuccess, onSaveError);
            } else {
                Projectlog.save(vm.projectlog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectlogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.actiontakendate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectlogDetailController', ProjectlogDetailController);

    ProjectlogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Projectlog'];

    function ProjectlogDetailController($scope, $rootScope, $stateParams, previousState, entity, Projectlog) {
        var vm = this;

        vm.projectlog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectlogUpdate', function(event, result) {
            vm.projectlog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectlogDeleteController',ProjectlogDeleteController);

    ProjectlogDeleteController.$inject = ['$uibModalInstance', 'entity', 'Projectlog'];

    function ProjectlogDeleteController($uibModalInstance, entity, Projectlog) {
        var vm = this;

        vm.projectlog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Projectlog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectlog', {
            parent: 'entity',
            url: '/projectlog',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectlog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectlog/projectlogs.html',
                    controller: 'ProjectlogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectlog');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectlog-detail', {
            parent: 'projectlog',
            url: '/projectlog/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectlog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectlog/projectlog-detail.html',
                    controller: 'ProjectlogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectlog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectlog', function($stateParams, Projectlog) {
                    return Projectlog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectlog',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectlog-detail.edit', {
            parent: 'projectlog-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectlog/projectlog-dialog.html',
                    controller: 'ProjectlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectlog', function(Projectlog) {
                            return Projectlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectlog.new', {
            parent: 'projectlog',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectlog/projectlog-dialog.html',
                    controller: 'ProjectlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                actiontaken: null,
                                actiontakenby: null,
                                actiontakendate: null,
                                actiontype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectlog', null, { reload: 'projectlog' });
                }, function() {
                    $state.go('projectlog');
                });
            }]
        })
        .state('projectlog.edit', {
            parent: 'projectlog',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectlog/projectlog-dialog.html',
                    controller: 'ProjectlogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectlog', function(Projectlog) {
                            return Projectlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectlog', null, { reload: 'projectlog' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectlog.delete', {
            parent: 'projectlog',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectlog/projectlog-delete-dialog.html',
                    controller: 'ProjectlogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectlog', function(Projectlog) {
                            return Projectlog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectlog', null, { reload: 'projectlog' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectlog', Projectlog);

    Projectlog.$inject = ['$resource', 'DateUtils'];

    function Projectlog ($resource, DateUtils) {
        var resourceUrl =  'api/projectlogs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.actiontakendate = DateUtils.convertDateTimeFromServer(data.actiontakendate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectlogController', ProjectlogController);

    ProjectlogController.$inject = ['Projectlog'];

    function ProjectlogController(Projectlog) {

        var vm = this;

        vm.projectlogs = [];

        loadAll();

        function loadAll() {
            Projectlog.query(function(result) {
                vm.projectlogs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectdetailcombinecodesDialogController', ProjectdetailcombinecodesDialogController);

    ProjectdetailcombinecodesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Projectdetailcombinecodes'];

    function ProjectdetailcombinecodesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Projectdetailcombinecodes) {
        var vm = this;

        vm.projectdetailcombinecodes = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectdetailcombinecodes.id !== null) {
                Projectdetailcombinecodes.update(vm.projectdetailcombinecodes, onSaveSuccess, onSaveError);
            } else {
                Projectdetailcombinecodes.save(vm.projectdetailcombinecodes, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectdetailcombinecodesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectdetailcombinecodesDetailController', ProjectdetailcombinecodesDetailController);

    ProjectdetailcombinecodesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Projectdetailcombinecodes'];

    function ProjectdetailcombinecodesDetailController($scope, $rootScope, $stateParams, previousState, entity, Projectdetailcombinecodes) {
        var vm = this;

        vm.projectdetailcombinecodes = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectdetailcombinecodesUpdate', function(event, result) {
            vm.projectdetailcombinecodes = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectdetailcombinecodesDeleteController',ProjectdetailcombinecodesDeleteController);

    ProjectdetailcombinecodesDeleteController.$inject = ['$uibModalInstance', 'entity', 'Projectdetailcombinecodes'];

    function ProjectdetailcombinecodesDeleteController($uibModalInstance, entity, Projectdetailcombinecodes) {
        var vm = this;

        vm.projectdetailcombinecodes = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Projectdetailcombinecodes.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectdetailcombinecodes', {
            parent: 'entity',
            url: '/projectdetailcombinecodes',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectdetailcombinecodes.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectdetailcombinecodes/projectdetailcombinecodes.html',
                    controller: 'ProjectdetailcombinecodesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectdetailcombinecodes');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectdetailcombinecodes-detail', {
            parent: 'projectdetailcombinecodes',
            url: '/projectdetailcombinecodes/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectdetailcombinecodes.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectdetailcombinecodes/projectdetailcombinecodes-detail.html',
                    controller: 'ProjectdetailcombinecodesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectdetailcombinecodes');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectdetailcombinecodes', function($stateParams, Projectdetailcombinecodes) {
                    return Projectdetailcombinecodes.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectdetailcombinecodes',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectdetailcombinecodes-detail.edit', {
            parent: 'projectdetailcombinecodes-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectdetailcombinecodes/projectdetailcombinecodes-dialog.html',
                    controller: 'ProjectdetailcombinecodesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectdetailcombinecodes', function(Projectdetailcombinecodes) {
                            return Projectdetailcombinecodes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectdetailcombinecodes.new', {
            parent: 'projectdetailcombinecodes',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectdetailcombinecodes/projectdetailcombinecodes-dialog.html',
                    controller: 'ProjectdetailcombinecodesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                investorid: null,
                                companydetailid: null,
                                projectsitedetailid: null,
                                projectfinanceid: null,
                                manufacturingid: null,
                                electricityrequirementid: null,
                                environmentimpactdetailid: null,
                                termdeclarationacceptid: null,
                                isprojectrenewable: null,
                                projectshop: null,
                                landrequirementcaf: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectdetailcombinecodes', null, { reload: 'projectdetailcombinecodes' });
                }, function() {
                    $state.go('projectdetailcombinecodes');
                });
            }]
        })
        .state('projectdetailcombinecodes.edit', {
            parent: 'projectdetailcombinecodes',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectdetailcombinecodes/projectdetailcombinecodes-dialog.html',
                    controller: 'ProjectdetailcombinecodesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectdetailcombinecodes', function(Projectdetailcombinecodes) {
                            return Projectdetailcombinecodes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectdetailcombinecodes', null, { reload: 'projectdetailcombinecodes' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectdetailcombinecodes.delete', {
            parent: 'projectdetailcombinecodes',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectdetailcombinecodes/projectdetailcombinecodes-delete-dialog.html',
                    controller: 'ProjectdetailcombinecodesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectdetailcombinecodes', function(Projectdetailcombinecodes) {
                            return Projectdetailcombinecodes.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectdetailcombinecodes', null, { reload: 'projectdetailcombinecodes' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectdetailcombinecodes', Projectdetailcombinecodes);

    Projectdetailcombinecodes.$inject = ['$resource'];

    function Projectdetailcombinecodes ($resource) {
        var resourceUrl =  'api/projectdetailcombinecodes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectdetailcombinecodesController', ProjectdetailcombinecodesController);

    ProjectdetailcombinecodesController.$inject = ['Projectdetailcombinecodes'];

    function ProjectdetailcombinecodesController(Projectdetailcombinecodes) {

        var vm = this;

        vm.projectdetailcombinecodes = [];

        loadAll();

        function loadAll() {
            Projectdetailcombinecodes.query(function(result) {
                vm.projectdetailcombinecodes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectdetailDialogController', ProjectdetailDialogController);

    ProjectdetailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Projectdetail'];

    function ProjectdetailDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Projectdetail) {
        var vm = this;

        vm.projectdetail = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectdetail.id !== null) {
                Projectdetail.update(vm.projectdetail, onSaveSuccess, onSaveError);
            } else {
                Projectdetail.save(vm.projectdetail, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectdetailUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;
        vm.datePickerOpenStatus.deactivateddate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

    (function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectdetailDetailController', ProjectdetailDetailController);

    ProjectdetailDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Projectdetail'];

    function ProjectdetailDetailController($scope, $rootScope, $stateParams, previousState, entity, Projectdetail) {
        var vm = this;

        vm.projectdetail = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectdetailUpdate', function(event, result) {
            vm.projectdetail = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectdetailDeleteController',ProjectdetailDeleteController);

    ProjectdetailDeleteController.$inject = ['$uibModalInstance', 'entity', 'Projectdetail'];

    function ProjectdetailDeleteController($uibModalInstance, entity, Projectdetail) {
        var vm = this;

        vm.projectdetail = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Projectdetail.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectdetail', {
            parent: 'entity',
            url: '/projectdetail',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectdetail.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectdetail/projectdetails.html',
                    controller: 'ProjectdetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectdetail');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectdetail-detail', {
            parent: 'projectdetail',
            url: '/projectdetail/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectdetail.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectdetail/projectdetail-detail.html',
                    controller: 'ProjectdetailDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectdetail');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectdetail', function($stateParams, Projectdetail) {
                    return Projectdetail.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectdetail',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectdetail-detail.edit', {
            parent: 'projectdetail-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectdetail/projectdetail-dialog.html',
                    controller: 'ProjectdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectdetail', function(Projectdetail) {
                            return Projectdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectdetail.new', {
            parent: 'projectdetail',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectdetail/projectdetail-dialog.html',
                    controller: 'ProjectdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectpurpose: null,
                                niccode: null,
                                existing_regulatory_approval: null,
                                edc_sif_clu_fee_paid_applicable: null,
                                approval_application_form: null,
                                category_of_project: null,
                                collaboration_with_foreign_country: null,
                                projectype: null,
                                sectorname: null,
                                size_of_industry: null,
                                createdate: null,
                                updatedate: null,
                                sectorother: null,
                                assignedRM: null,
                                isdeactivated: null,
                                deactivatedby: null,
                                deactivateddate: null,
                                projectlevel: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectdetail', null, { reload: 'projectdetail' });
                }, function() {
                    $state.go('projectdetail');
                });
            }]
        })
        .state('projectdetail.edit', {
            parent: 'projectdetail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectdetail/projectdetail-dialog.html',
                    controller: 'ProjectdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectdetail', function(Projectdetail) {
                            return Projectdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectdetail', null, { reload: 'projectdetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectdetail.delete', {
            parent: 'projectdetail',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectdetail/projectdetail-delete-dialog.html',
                    controller: 'ProjectdetailDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectdetail', function(Projectdetail) {
                            return Projectdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectdetail', null, { reload: 'projectdetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectdetail', Projectdetail);

    Projectdetail.$inject = ['$resource', 'DateUtils'];

    function Projectdetail ($resource, DateUtils) {
        var resourceUrl =  'api/projectdetails/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                        data.deactivateddate = DateUtils.convertDateTimeFromServer(data.deactivateddate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectdetailController', ProjectdetailController);

    ProjectdetailController.$inject = ['Projectdetail'];

    function ProjectdetailController(Projectdetail) {

        var vm = this;

        vm.projectdetails = [];

        loadAll();

        function loadAll() {
            Projectdetail.query(function(result) {
                vm.projectdetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectcategoryDialogController', ProjectcategoryDialogController);

    ProjectcategoryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Projectcategory'];

    function ProjectcategoryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Projectcategory) {
        var vm = this;

        vm.projectcategory = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectcategory.id !== null) {
                Projectcategory.update(vm.projectcategory, onSaveSuccess, onSaveError);
            } else {
                Projectcategory.save(vm.projectcategory, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectcategoryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectcategoryDetailController', ProjectcategoryDetailController);

    ProjectcategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Projectcategory'];

    function ProjectcategoryDetailController($scope, $rootScope, $stateParams, previousState, entity, Projectcategory) {
        var vm = this;

        vm.projectcategory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectcategoryUpdate', function(event, result) {
            vm.projectcategory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectcategoryDeleteController',ProjectcategoryDeleteController);

    ProjectcategoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Projectcategory'];

    function ProjectcategoryDeleteController($uibModalInstance, entity, Projectcategory) {
        var vm = this;

        vm.projectcategory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Projectcategory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('projectcategory', {
            parent: 'entity',
            url: '/projectcategory',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectcategory.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectcategory/projectcategories.html',
                    controller: 'ProjectcategoryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectcategory');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('projectcategory-detail', {
            parent: 'projectcategory',
            url: '/projectcategory/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectcategory.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/projectcategory/projectcategory-detail.html',
                    controller: 'ProjectcategoryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectcategory');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Projectcategory', function($stateParams, Projectcategory) {
                    return Projectcategory.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'projectcategory',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('projectcategory-detail.edit', {
            parent: 'projectcategory-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectcategory/projectcategory-dialog.html',
                    controller: 'ProjectcategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectcategory', function(Projectcategory) {
                            return Projectcategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectcategory.new', {
            parent: 'projectcategory',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectcategory/projectcategory-dialog.html',
                    controller: 'ProjectcategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                categorytype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('projectcategory', null, { reload: 'projectcategory' });
                }, function() {
                    $state.go('projectcategory');
                });
            }]
        })
        .state('projectcategory.edit', {
            parent: 'projectcategory',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectcategory/projectcategory-dialog.html',
                    controller: 'ProjectcategoryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Projectcategory', function(Projectcategory) {
                            return Projectcategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectcategory', null, { reload: 'projectcategory' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('projectcategory.delete', {
            parent: 'projectcategory',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/projectcategory/projectcategory-delete-dialog.html',
                    controller: 'ProjectcategoryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Projectcategory', function(Projectcategory) {
                            return Projectcategory.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('projectcategory', null, { reload: 'projectcategory' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Projectcategory', Projectcategory);

    Projectcategory.$inject = ['$resource'];

    function Projectcategory ($resource) {
        var resourceUrl =  'api/projectcategories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectcategoryController', ProjectcategoryController);

    ProjectcategoryController.$inject = ['Projectcategory'];

    function ProjectcategoryController(Projectcategory) {

        var vm = this;

        vm.projectcategories = [];

        loadAll();

        function loadAll() {
            Projectcategory.query(function(result) {
                vm.projectcategories = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectSkillsDialogController', ProjectSkillsDialogController);

    ProjectSkillsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProjectSkills'];

    function ProjectSkillsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProjectSkills) {
        var vm = this;

        vm.projectSkills = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectSkills.id !== null) {
                ProjectSkills.update(vm.projectSkills, onSaveSuccess, onSaveError);
            } else {
                ProjectSkills.save(vm.projectSkills, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectSkillsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.creationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectSkillsDetailController', ProjectSkillsDetailController);

    ProjectSkillsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProjectSkills'];

    function ProjectSkillsDetailController($scope, $rootScope, $stateParams, previousState, entity, ProjectSkills) {
        var vm = this;

        vm.projectSkills = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectSkillsUpdate', function(event, result) {
            vm.projectSkills = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectSkillsDeleteController',ProjectSkillsDeleteController);

    ProjectSkillsDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProjectSkills'];

    function ProjectSkillsDeleteController($uibModalInstance, entity, ProjectSkills) {
        var vm = this;

        vm.projectSkills = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProjectSkills.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-skills', {
            parent: 'entity',
            url: '/project-skills',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectSkills.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-skills/project-skills.html',
                    controller: 'ProjectSkillsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectSkills');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-skills-detail', {
            parent: 'project-skills',
            url: '/project-skills/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectSkills.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-skills/project-skills-detail.html',
                    controller: 'ProjectSkillsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectSkills');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProjectSkills', function($stateParams, ProjectSkills) {
                    return ProjectSkills.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-skills',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('project-skills-detail.edit', {
            parent: 'project-skills-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-skills/project-skills-dialog.html',
                    controller: 'ProjectSkillsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectSkills', function(ProjectSkills) {
                            return ProjectSkills.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-skills.new', {
            parent: 'project-skills',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-skills/project-skills-dialog.html',
                    controller: 'ProjectSkillsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                district: null,
                                sector: null,
                                jobRole: null,
                                requiredLabour: null,
                                cafPin: null,
                                projectId: null,
                                creationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project-skills', null, { reload: 'project-skills' });
                }, function() {
                    $state.go('project-skills');
                });
            }]
        })
        .state('project-skills.edit', {
            parent: 'project-skills',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-skills/project-skills-dialog.html',
                    controller: 'ProjectSkillsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectSkills', function(ProjectSkills) {
                            return ProjectSkills.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-skills', null, { reload: 'project-skills' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-skills.delete', {
            parent: 'project-skills',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-skills/project-skills-delete-dialog.html',
                    controller: 'ProjectSkillsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProjectSkills', function(ProjectSkills) {
                            return ProjectSkills.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-skills', null, { reload: 'project-skills' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectSkills', ProjectSkills);

    ProjectSkills.$inject = ['$resource', 'DateUtils'];

    function ProjectSkills ($resource, DateUtils) {
        var resourceUrl =  'api/project-skills/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectSkillsController', ProjectSkillsController);

    ProjectSkillsController.$inject = ['ProjectSkills'];

    function ProjectSkillsController(ProjectSkills) {

        var vm = this;

        vm.projectSkills = [];

        loadAll();

        function loadAll() {
            ProjectSkills.query(function(result) {
                vm.projectSkills = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectServiceReportInfoForClearance', ProjectServiceReportInfoForClearance);

    ProjectServiceReportInfoForClearance.$inject = ['$resource', 'DateUtils'];

    function ProjectServiceReportInfoForClearance ($resource, DateUtils) {
        var resourceUrl =  'api/project-service-report-infos/forclearance/:department/:projectid/:service';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.assignDate = DateUtils.convertDateTimeFromServer(data.assignDate);
                        data.requireDate = DateUtils.convertDateTimeFromServer(data.requireDate);
                        data.finalActionDate = DateUtils.convertDateTimeFromServer(data.finalActionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServiceReportInfoDialogController', ProjectServiceReportInfoDialogController);

    ProjectServiceReportInfoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProjectServiceReportInfo'];

    function ProjectServiceReportInfoDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProjectServiceReportInfo) {
        var vm = this;

        vm.projectServiceReportInfo = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectServiceReportInfo.id !== null) {
                ProjectServiceReportInfo.update(vm.projectServiceReportInfo, onSaveSuccess, onSaveError);
            } else {
                ProjectServiceReportInfo.save(vm.projectServiceReportInfo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectServiceReportInfoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.assignDate = false;
        vm.datePickerOpenStatus.requireDate = false;
        vm.datePickerOpenStatus.finalActionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServiceReportInfoDetailController', ProjectServiceReportInfoDetailController);

    ProjectServiceReportInfoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProjectServiceReportInfo'];

    function ProjectServiceReportInfoDetailController($scope, $rootScope, $stateParams, previousState, entity, ProjectServiceReportInfo) {
        var vm = this;

        vm.projectServiceReportInfo = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectServiceReportInfoUpdate', function(event, result) {
            vm.projectServiceReportInfo = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServiceReportInfoDeleteController',ProjectServiceReportInfoDeleteController);

    ProjectServiceReportInfoDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProjectServiceReportInfo'];

    function ProjectServiceReportInfoDeleteController($uibModalInstance, entity, ProjectServiceReportInfo) {
        var vm = this;

        vm.projectServiceReportInfo = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProjectServiceReportInfo.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-service-report-info', {
            parent: 'entity',
            url: '/project-service-report-info',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectServiceReportInfo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-service-report-info/project-service-report-infos.html',
                    controller: 'ProjectServiceReportInfoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectServiceReportInfo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-service-report-info-detail', {
            parent: 'project-service-report-info',
            url: '/project-service-report-info/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectServiceReportInfo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-service-report-info/project-service-report-info-detail.html',
                    controller: 'ProjectServiceReportInfoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectServiceReportInfo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProjectServiceReportInfo', function($stateParams, ProjectServiceReportInfo) {
                    return ProjectServiceReportInfo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-service-report-info',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('project-service-report-info-detail.edit', {
            parent: 'project-service-report-info-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-report-info/project-service-report-info-dialog.html',
                    controller: 'ProjectServiceReportInfoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectServiceReportInfo', function(ProjectServiceReportInfo) {
                            return ProjectServiceReportInfo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-service-report-info.new', {
            parent: 'project-service-report-info',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-report-info/project-service-report-info-dialog.html',
                    controller: 'ProjectServiceReportInfoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                projecttype: null,
                                departmentname: null,
                                servicename: null,
                                assignDate: null,
                                requireDate: null,
                                status: null,
                                stage: null,
                                investorName: null,
                                cafPin: null,
                                finalAction: null,
                                finalActionDate: null,
                                projectInvestment: null,
                                projectEmployment: null,
                                proposedprojectarea: null,
                                confirmitylanduse: null,
                                landzoneusetype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project-service-report-info', null, { reload: 'project-service-report-info' });
                }, function() {
                    $state.go('project-service-report-info');
                });
            }]
        })
        .state('project-service-report-info.edit', {
            parent: 'project-service-report-info',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-report-info/project-service-report-info-dialog.html',
                    controller: 'ProjectServiceReportInfoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectServiceReportInfo', function(ProjectServiceReportInfo) {
                            return ProjectServiceReportInfo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-service-report-info', null, { reload: 'project-service-report-info' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-service-report-info.delete', {
            parent: 'project-service-report-info',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-report-info/project-service-report-info-delete-dialog.html',
                    controller: 'ProjectServiceReportInfoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProjectServiceReportInfo', function(ProjectServiceReportInfo) {
                            return ProjectServiceReportInfo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-service-report-info', null, { reload: 'project-service-report-info' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectServiceReportInfo', ProjectServiceReportInfo);

    ProjectServiceReportInfo.$inject = ['$resource', 'DateUtils'];

    function ProjectServiceReportInfo ($resource, DateUtils) {
        var resourceUrl =  'api/project-service-report-infos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.assignDate = DateUtils.convertDateTimeFromServer(data.assignDate);
                        data.requireDate = DateUtils.convertDateTimeFromServer(data.requireDate);
                        data.finalActionDate = DateUtils.convertDateTimeFromServer(data.finalActionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServiceReportInfoController', ProjectServiceReportInfoController);

    ProjectServiceReportInfoController.$inject = ['ProjectServiceReportInfo'];

    function ProjectServiceReportInfoController(ProjectServiceReportInfo) {

        var vm = this;

        vm.projectServiceReportInfos = [];

        loadAll();

        function loadAll() {
            ProjectServiceReportInfo.query(function(result) {
                vm.projectServiceReportInfos = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectServicePaymentDetailsByProjectAndService', ProjectServicePaymentDetailsByProjectAndService);

    ProjectServicePaymentDetailsByProjectAndService.$inject = ['$resource', 'DateUtils'];

    function ProjectServicePaymentDetailsByProjectAndService ($resource, DateUtils) {
        var resourceUrl =  'api/project-service-payment/projectandservice/:projectid/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.paymentDate = DateUtils.convertDateTimeFromServer(data.paymentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServicePaymentDetailsDialogController', ProjectServicePaymentDetailsDialogController);

    ProjectServicePaymentDetailsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProjectServicePaymentDetails'];

    function ProjectServicePaymentDetailsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProjectServicePaymentDetails) {
        var vm = this;

        vm.projectServicePaymentDetails = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectServicePaymentDetails.id !== null) {
                ProjectServicePaymentDetails.update(vm.projectServicePaymentDetails, onSaveSuccess, onSaveError);
            } else {
                ProjectServicePaymentDetails.save(vm.projectServicePaymentDetails, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectServicePaymentDetailsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.paymentDate = false;
        vm.datePickerOpenStatus.disbursementdate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServicePaymentDetailsDetailController', ProjectServicePaymentDetailsDetailController);

    ProjectServicePaymentDetailsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProjectServicePaymentDetails'];

    function ProjectServicePaymentDetailsDetailController($scope, $rootScope, $stateParams, previousState, entity, ProjectServicePaymentDetails) {
        var vm = this;

        vm.projectServicePaymentDetails = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectServicePaymentDetailsUpdate', function(event, result) {
            vm.projectServicePaymentDetails = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServicePaymentDetailsDeleteController',ProjectServicePaymentDetailsDeleteController);

    ProjectServicePaymentDetailsDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProjectServicePaymentDetails'];

    function ProjectServicePaymentDetailsDeleteController($uibModalInstance, entity, ProjectServicePaymentDetails) {
        var vm = this;

        vm.projectServicePaymentDetails = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProjectServicePaymentDetails.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-service-payment-details', {
            parent: 'entity',
            url: '/project-service-payment-details',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectServicePaymentDetails.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-service-payment-details/project-service-payment-details.html',
                    controller: 'ProjectServicePaymentDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectServicePaymentDetails');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-service-payment-details-detail', {
            parent: 'project-service-payment-details',
            url: '/project-service-payment-details/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectServicePaymentDetails.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-service-payment-details/project-service-payment-details-detail.html',
                    controller: 'ProjectServicePaymentDetailsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectServicePaymentDetails');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProjectServicePaymentDetails', function($stateParams, ProjectServicePaymentDetails) {
                    return ProjectServicePaymentDetails.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-service-payment-details',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('project-service-payment-details-detail.edit', {
            parent: 'project-service-payment-details-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-payment-details/project-service-payment-details-dialog.html',
                    controller: 'ProjectServicePaymentDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectServicePaymentDetails', function(ProjectServicePaymentDetails) {
                            return ProjectServicePaymentDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-service-payment-details.new', {
            parent: 'project-service-payment-details',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-payment-details/project-service-payment-details-dialog.html',
                    controller: 'ProjectServicePaymentDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                paymentMadeBy: null,
                                paymentDate: null,
                                transactionId: null,
                                paymentResponse: null,
                                paymentStatus: null,
                                paymentMade: null,
                                feeDescription: null,
                                paymentdisbursed: null,
                                disbursedby: null,
                                disbursementdate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project-service-payment-details', null, { reload: 'project-service-payment-details' });
                }, function() {
                    $state.go('project-service-payment-details');
                });
            }]
        })
        .state('project-service-payment-details.edit', {
            parent: 'project-service-payment-details',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-payment-details/project-service-payment-details-dialog.html',
                    controller: 'ProjectServicePaymentDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectServicePaymentDetails', function(ProjectServicePaymentDetails) {
                            return ProjectServicePaymentDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-service-payment-details', null, { reload: 'project-service-payment-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-service-payment-details.delete', {
            parent: 'project-service-payment-details',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-payment-details/project-service-payment-details-delete-dialog.html',
                    controller: 'ProjectServicePaymentDetailsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProjectServicePaymentDetails', function(ProjectServicePaymentDetails) {
                            return ProjectServicePaymentDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-service-payment-details', null, { reload: 'project-service-payment-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectServicePaymentDetails', ProjectServicePaymentDetails);

    ProjectServicePaymentDetails.$inject = ['$resource', 'DateUtils'];

    function ProjectServicePaymentDetails ($resource, DateUtils) {
        var resourceUrl =  'api/project-service-payment-details/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.paymentDate = DateUtils.convertDateTimeFromServer(data.paymentDate);
                        data.disbursementdate = DateUtils.convertDateTimeFromServer(data.disbursementdate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServicePaymentDetailsController', ProjectServicePaymentDetailsController);

    ProjectServicePaymentDetailsController.$inject = ['ProjectServicePaymentDetails'];

    function ProjectServicePaymentDetailsController(ProjectServicePaymentDetails) {

        var vm = this;

        vm.projectServicePaymentDetails = [];

        loadAll();

        function loadAll() {
            ProjectServicePaymentDetails.query(function(result) {
                vm.projectServicePaymentDetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('GetServiceLogByProjectId', GetServiceLogByProjectId);

    GetServiceLogByProjectId.$inject = ['$resource', 'DateUtils'];

    function GetServiceLogByProjectId ($resource, DateUtils) {
        var resourceUrl =  'api/ServiceLogByProjectId/:projectid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.commentDate = DateUtils.convertDateTimeFromServer(data.commentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServiceLogDialogController', ProjectServiceLogDialogController);

    ProjectServiceLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProjectServiceLog'];

    function ProjectServiceLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProjectServiceLog) {
        var vm = this;

        vm.projectServiceLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectServiceLog.id !== null) {
                ProjectServiceLog.update(vm.projectServiceLog, onSaveSuccess, onSaveError);
            } else {
                ProjectServiceLog.save(vm.projectServiceLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.commentDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServiceLogDetailController', ProjectServiceLogDetailController);

    ProjectServiceLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProjectServiceLog'];

    function ProjectServiceLogDetailController($scope, $rootScope, $stateParams, previousState, entity, ProjectServiceLog) {
        var vm = this;

        vm.projectServiceLog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectServiceLogUpdate', function(event, result) {
            vm.projectServiceLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServiceLogDeleteController',ProjectServiceLogDeleteController);

    ProjectServiceLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProjectServiceLog'];

    function ProjectServiceLogDeleteController($uibModalInstance, entity, ProjectServiceLog) {
        var vm = this;

        vm.projectServiceLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProjectServiceLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-service-log', {
            parent: 'entity',
            url: '/project-service-log',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectServiceLog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-service-log/project-service-logs.html',
                    controller: 'ProjectServiceLogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectServiceLog');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-service-log-detail', {
            parent: 'project-service-log',
            url: '/project-service-log/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectServiceLog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-service-log/project-service-log-detail.html',
                    controller: 'ProjectServiceLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectServiceLog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProjectServiceLog', function($stateParams, ProjectServiceLog) {
                    return ProjectServiceLog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-service-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('project-service-log-detail.edit', {
            parent: 'project-service-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-log/project-service-log-dialog.html',
                    controller: 'ProjectServiceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectServiceLog', function(ProjectServiceLog) {
                            return ProjectServiceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-service-log.new', {
            parent: 'project-service-log',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-log/project-service-log-dialog.html',
                    controller: 'ProjectServiceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                comments: null,
                                commentDate: null,
                                commentByUserLogin: null,
                                actionTaken: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project-service-log', null, { reload: 'project-service-log' });
                }, function() {
                    $state.go('project-service-log');
                });
            }]
        })
        .state('project-service-log.edit', {
            parent: 'project-service-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-log/project-service-log-dialog.html',
                    controller: 'ProjectServiceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectServiceLog', function(ProjectServiceLog) {
                            return ProjectServiceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-service-log', null, { reload: 'project-service-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-service-log.delete', {
            parent: 'project-service-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-service-log/project-service-log-delete-dialog.html',
                    controller: 'ProjectServiceLogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProjectServiceLog', function(ProjectServiceLog) {
                            return ProjectServiceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-service-log', null, { reload: 'project-service-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectServiceLog', ProjectServiceLog);

    ProjectServiceLog.$inject = ['$resource', 'DateUtils'];

    function ProjectServiceLog ($resource, DateUtils) {
        var resourceUrl =  'api/project-service-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.commentDate = DateUtils.convertDateTimeFromServer(data.commentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectServiceLogController', ProjectServiceLogController);

    ProjectServiceLogController.$inject = ['ProjectServiceLog', 'GetServiceLogByProjectId'];

    function ProjectServiceLogController(ProjectServiceLog, GetServiceLogByProjectId) {

        var vm = this;

        vm.projectServiceLogs = undefined;
        vm.loadByProjectid=loadByProjectid;

//        loadAll();

        function loadAll() {
            ProjectServiceLog.query(function(result) {
                vm.projectServiceLogs = result;
                vm.searchQuery = null;
            });
        }

        function loadByProjectid() {
            vm.projectServiceLogs=null;
            GetServiceLogByProjectId.query({projectid:vm.projectServiceLog.projectid}, function(result) {
                vm.projectServiceLogs = result;
                vm.searchQuery = null;
            });
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('GetServiceLog', GetServiceLog);

    GetServiceLog.$inject = ['$resource', 'DateUtils'];

    function GetServiceLog ($resource, DateUtils) {
        var resourceUrl =  'api/GetServiceLogResource/:projectid/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.commentDate = DateUtils.convertDateTimeFromServer(data.commentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Project_phaseDialogController', Project_phaseDialogController);

    Project_phaseDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Project_phase'];

    function Project_phaseDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Project_phase) {
        var vm = this;

        vm.project_phase = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.project_phase.id !== null) {
                Project_phase.update(vm.project_phase, onSaveSuccess, onSaveError);
            } else {
                Project_phase.save(vm.project_phase, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:project_phaseUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.implementationdate = false;
        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Project_phaseDetailController', Project_phaseDetailController);

    Project_phaseDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Project_phase'];

    function Project_phaseDetailController($scope, $rootScope, $stateParams, previousState, entity, Project_phase) {
        var vm = this;

        vm.project_phase = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:project_phaseUpdate', function(event, result) {
            vm.project_phase = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Project_phaseDeleteController',Project_phaseDeleteController);

    Project_phaseDeleteController.$inject = ['$uibModalInstance', 'entity', 'Project_phase'];

    function Project_phaseDeleteController($uibModalInstance, entity, Project_phase) {
        var vm = this;

        vm.project_phase = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Project_phase.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-phase', {
            parent: 'entity',
            url: '/project-phase',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.project_phase.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-phase/project-phases.html',
                    controller: 'Project_phaseController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project_phase');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-phase-detail', {
            parent: 'project-phase',
            url: '/project-phase/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.project_phase.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-phase/project-phase-detail.html',
                    controller: 'Project_phaseDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project_phase');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Project_phase', function($stateParams, Project_phase) {
                    return Project_phase.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-phase',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('project-phase-detail.edit', {
            parent: 'project-phase-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-phase/project-phase-dialog.html',
                    controller: 'Project_phaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Project_phase', function(Project_phase) {
                            return Project_phase.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-phase.new', {
            parent: 'project-phase',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-phase/project-phase-dialog.html',
                    controller: 'Project_phaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                phase: null,
                                productcategory: null,
                                fci: null,
                                implementationdate: null,
                                createdate: null,
                                updatedate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project-phase', null, { reload: 'project-phase' });
                }, function() {
                    $state.go('project-phase');
                });
            }]
        })
        .state('project-phase.edit', {
            parent: 'project-phase',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-phase/project-phase-dialog.html',
                    controller: 'Project_phaseDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Project_phase', function(Project_phase) {
                            return Project_phase.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-phase', null, { reload: 'project-phase' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-phase.delete', {
            parent: 'project-phase',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-phase/project-phase-delete-dialog.html',
                    controller: 'Project_phaseDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Project_phase', function(Project_phase) {
                            return Project_phase.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-phase', null, { reload: 'project-phase' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Project_phase', Project_phase);

    Project_phase.$inject = ['$resource', 'DateUtils'];

    function Project_phase ($resource, DateUtils) {
        var resourceUrl =  'api/project-phases/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.implementationdate = DateUtils.convertDateTimeFromServer(data.implementationdate);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Project_phaseController', Project_phaseController);

    Project_phaseController.$inject = ['Project_phase'];

    function Project_phaseController(Project_phase) {

        var vm = this;

        vm.project_phases = [];

        loadAll();

        function loadAll() {
            Project_phase.query(function(result) {
                vm.project_phases = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectLogNewCafDialogController', ProjectLogNewCafDialogController);

    ProjectLogNewCafDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProjectLogNewCaf'];

    function ProjectLogNewCafDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProjectLogNewCaf) {
        var vm = this;

        vm.projectLogNewCaf = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectLogNewCaf.id !== null) {
                ProjectLogNewCaf.update(vm.projectLogNewCaf, onSaveSuccess, onSaveError);
            } else {
                ProjectLogNewCaf.save(vm.projectLogNewCaf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectLogNewCafUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.actionTakenDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectLogNewCafDetailController', ProjectLogNewCafDetailController);

    ProjectLogNewCafDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProjectLogNewCaf'];

    function ProjectLogNewCafDetailController($scope, $rootScope, $stateParams, previousState, entity, ProjectLogNewCaf) {
        var vm = this;

        vm.projectLogNewCaf = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectLogNewCafUpdate', function(event, result) {
            vm.projectLogNewCaf = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectLogNewCafDeleteController',ProjectLogNewCafDeleteController);

    ProjectLogNewCafDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProjectLogNewCaf'];

    function ProjectLogNewCafDeleteController($uibModalInstance, entity, ProjectLogNewCaf) {
        var vm = this;

        vm.projectLogNewCaf = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProjectLogNewCaf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-log-new-caf', {
            parent: 'entity',
            url: '/project-log-new-caf',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectLogNewCaf.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-log-new-caf/project-log-new-cafs.html',
                    controller: 'ProjectLogNewCafController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectLogNewCaf');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-log-new-caf-detail', {
            parent: 'project-log-new-caf',
            url: '/project-log-new-caf/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectLogNewCaf.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-log-new-caf/project-log-new-caf-detail.html',
                    controller: 'ProjectLogNewCafDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectLogNewCaf');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProjectLogNewCaf', function($stateParams, ProjectLogNewCaf) {
                    return ProjectLogNewCaf.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-log-new-caf',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('project-log-new-caf-detail.edit', {
            parent: 'project-log-new-caf-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-log-new-caf/project-log-new-caf-dialog.html',
                    controller: 'ProjectLogNewCafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectLogNewCaf', function(ProjectLogNewCaf) {
                            return ProjectLogNewCaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-log-new-caf.new', {
            parent: 'project-log-new-caf',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-log-new-caf/project-log-new-caf-dialog.html',
                    controller: 'ProjectLogNewCafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectId: null,
                                actionTaken: null,
                                actionTakenBy: null,
                                actionTakenDate: null,
                                actionType: null,
                                fieldUpdated: null,
                                oldValue: null,
                                newValue: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project-log-new-caf', null, { reload: 'project-log-new-caf' });
                }, function() {
                    $state.go('project-log-new-caf');
                });
            }]
        })
        .state('project-log-new-caf.edit', {
            parent: 'project-log-new-caf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-log-new-caf/project-log-new-caf-dialog.html',
                    controller: 'ProjectLogNewCafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectLogNewCaf', function(ProjectLogNewCaf) {
                            return ProjectLogNewCaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-log-new-caf', null, { reload: 'project-log-new-caf' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-log-new-caf.delete', {
            parent: 'project-log-new-caf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-log-new-caf/project-log-new-caf-delete-dialog.html',
                    controller: 'ProjectLogNewCafDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProjectLogNewCaf', function(ProjectLogNewCaf) {
                            return ProjectLogNewCaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-log-new-caf', null, { reload: 'project-log-new-caf' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectLogNewCaf', ProjectLogNewCaf);

    ProjectLogNewCaf.$inject = ['$resource', 'DateUtils'];

    function ProjectLogNewCaf ($resource, DateUtils) {
        var resourceUrl =  'api/project-log-new-cafs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.actionTakenDate = DateUtils.convertDateTimeFromServer(data.actionTakenDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectLogNewCafController', ProjectLogNewCafController);

    ProjectLogNewCafController.$inject = ['ProjectLogNewCaf'];

    function ProjectLogNewCafController(ProjectLogNewCaf) {

        var vm = this;

        vm.projectLogNewCafs = [];

        loadAll();

        function loadAll() {
            ProjectLogNewCaf.query(function(result) {
                vm.projectLogNewCafs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Project_finance_investmentDialogController', Project_finance_investmentDialogController);

    Project_finance_investmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Project_finance_investment'];

    function Project_finance_investmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Project_finance_investment) {
        var vm = this;

        vm.project_finance_investment = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.project_finance_investment.id !== null) {
                Project_finance_investment.update(vm.project_finance_investment, onSaveSuccess, onSaveError);
            } else {
                Project_finance_investment.save(vm.project_finance_investment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:project_finance_investmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.project_construction_start_date = false;
        vm.datePickerOpenStatus.commercial_activity_start_date = false;
        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Project_finance_investmentDetailController', Project_finance_investmentDetailController);

    Project_finance_investmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Project_finance_investment'];

    function Project_finance_investmentDetailController($scope, $rootScope, $stateParams, previousState, entity, Project_finance_investment) {
        var vm = this;

        vm.project_finance_investment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:project_finance_investmentUpdate', function(event, result) {
            vm.project_finance_investment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Project_finance_investmentDeleteController',Project_finance_investmentDeleteController);

    Project_finance_investmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Project_finance_investment'];

    function Project_finance_investmentDeleteController($uibModalInstance, entity, Project_finance_investment) {
        var vm = this;

        vm.project_finance_investment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Project_finance_investment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-finance-investment', {
            parent: 'entity',
            url: '/project-finance-investment',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.project_finance_investment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-finance-investment/project-finance-investments.html',
                    controller: 'Project_finance_investmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project_finance_investment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-finance-investment-detail', {
            parent: 'project-finance-investment',
            url: '/project-finance-investment/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.project_finance_investment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-finance-investment/project-finance-investment-detail.html',
                    controller: 'Project_finance_investmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project_finance_investment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Project_finance_investment', function($stateParams, Project_finance_investment) {
                    return Project_finance_investment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-finance-investment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('project-finance-investment-detail.edit', {
            parent: 'project-finance-investment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-finance-investment/project-finance-investment-dialog.html',
                    controller: 'Project_finance_investmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Project_finance_investment', function(Project_finance_investment) {
                            return Project_finance_investment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-finance-investment.new', {
            parent: 'project-finance-investment',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-finance-investment/project-finance-investment-dialog.html',
                    controller: 'Project_finance_investmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                land_cost: null,
                                building_cost: null,
                                machinery_cost: null,
                                misc_assests: null,
                                total_project_cost: null,
                                isfdi: null,
                                fdivalue: null,
                                project_construction_start_date: null,
                                commercial_activity_start_date: null,
                                fdi_country: null,
                                foreign_funding_source: null,
                                totalpurposedemployment: null,
                                createdate: null,
                                updatedate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project-finance-investment', null, { reload: 'project-finance-investment' });
                }, function() {
                    $state.go('project-finance-investment');
                });
            }]
        })
        .state('project-finance-investment.edit', {
            parent: 'project-finance-investment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-finance-investment/project-finance-investment-dialog.html',
                    controller: 'Project_finance_investmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Project_finance_investment', function(Project_finance_investment) {
                            return Project_finance_investment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-finance-investment', null, { reload: 'project-finance-investment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-finance-investment.delete', {
            parent: 'project-finance-investment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-finance-investment/project-finance-investment-delete-dialog.html',
                    controller: 'Project_finance_investmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Project_finance_investment', function(Project_finance_investment) {
                            return Project_finance_investment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-finance-investment', null, { reload: 'project-finance-investment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Project_finance_investment', Project_finance_investment);

    Project_finance_investment.$inject = ['$resource', 'DateUtils'];

    function Project_finance_investment ($resource, DateUtils) {
        var resourceUrl =  'api/project-finance-investments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.project_construction_start_date = DateUtils.convertDateTimeFromServer(data.project_construction_start_date);
                        data.commercial_activity_start_date = DateUtils.convertDateTimeFromServer(data.commercial_activity_start_date);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Project_finance_investmentController', Project_finance_investmentController);

    Project_finance_investmentController.$inject = ['Project_finance_investment'];

    function Project_finance_investmentController(Project_finance_investment) {

        var vm = this;

        vm.project_finance_investments = [];

        loadAll();

        function loadAll() {
            Project_finance_investment.query(function(result) {
                vm.project_finance_investments = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectAttachemntDialogController', ProjectAttachemntDialogController);

    ProjectAttachemntDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ProjectAttachemnt'];

    function ProjectAttachemntDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ProjectAttachemnt) {
        var vm = this;

        vm.projectAttachemnt = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.projectAttachemnt.id !== null) {
                ProjectAttachemnt.update(vm.projectAttachemnt, onSaveSuccess, onSaveError);
            } else {
                ProjectAttachemnt.save(vm.projectAttachemnt, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectAttachemntDetailController', ProjectAttachemntDetailController);

    ProjectAttachemntDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ProjectAttachemnt'];

    function ProjectAttachemntDetailController($scope, $rootScope, $stateParams, previousState, entity, ProjectAttachemnt) {
        var vm = this;

        vm.projectAttachemnt = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectAttachemntUpdate', function(event, result) {
            vm.projectAttachemnt = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectAttachemntDeleteController',ProjectAttachemntDeleteController);

    ProjectAttachemntDeleteController.$inject = ['$uibModalInstance', 'entity', 'ProjectAttachemnt'];

    function ProjectAttachemntDeleteController($uibModalInstance, entity, ProjectAttachemnt) {
        var vm = this;

        vm.projectAttachemnt = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ProjectAttachemnt.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project-attachemnt', {
            parent: 'entity',
            url: '/project-attachemnt',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectAttachemnt.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-attachemnt/project-attachemnts.html',
                    controller: 'ProjectAttachemntController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectAttachemnt');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-attachemnt-detail', {
            parent: 'project-attachemnt',
            url: '/project-attachemnt/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.projectAttachemnt.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project-attachemnt/project-attachemnt-detail.html',
                    controller: 'ProjectAttachemntDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('projectAttachemnt');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ProjectAttachemnt', function($stateParams, ProjectAttachemnt) {
                    return ProjectAttachemnt.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project-attachemnt',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('project-attachemnt-detail.edit', {
            parent: 'project-attachemnt-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-attachemnt/project-attachemnt-dialog.html',
                    controller: 'ProjectAttachemntDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectAttachemnt', function(ProjectAttachemnt) {
                            return ProjectAttachemnt.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-attachemnt.new', {
            parent: 'project-attachemnt',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-attachemnt/project-attachemnt-dialog.html',
                    controller: 'ProjectAttachemntDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fileName: null,
                                description: null,
                                fileExtension: null,
                                serverFileName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project-attachemnt', null, { reload: 'project-attachemnt' });
                }, function() {
                    $state.go('project-attachemnt');
                });
            }]
        })
        .state('project-attachemnt.edit', {
            parent: 'project-attachemnt',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-attachemnt/project-attachemnt-dialog.html',
                    controller: 'ProjectAttachemntDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ProjectAttachemnt', function(ProjectAttachemnt) {
                            return ProjectAttachemnt.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-attachemnt', null, { reload: 'project-attachemnt' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project-attachemnt.delete', {
            parent: 'project-attachemnt',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project-attachemnt/project-attachemnt-delete-dialog.html',
                    controller: 'ProjectAttachemntDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ProjectAttachemnt', function(ProjectAttachemnt) {
                            return ProjectAttachemnt.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project-attachemnt', null, { reload: 'project-attachemnt' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectAttachemnt', ProjectAttachemnt);

    ProjectAttachemnt.$inject = ['$resource'];

    function ProjectAttachemnt ($resource) {
        var resourceUrl =  'api/project-attachemnts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectAttachemntController', ProjectAttachemntController);

    ProjectAttachemntController.$inject = ['ProjectAttachemnt'];

    function ProjectAttachemntController(ProjectAttachemnt) {

        var vm = this;

        vm.projectAttachemnts = [];

        loadAll();

        function loadAll() {
            ProjectAttachemnt.query(function(result) {
                vm.projectAttachemnts = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('SearchProject', SearchProject);

    SearchProject.$inject = ['$resource','DateUtils'];

    function SearchProject ($resource,DateUtils) {
        var resourceUrl =  '/api/searchProject/:CAFPIN';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                        data.project_construction_start_date = DateUtils.convertDateTimeFromServer(data.project_construction_start_date);
                        data.commercial_activity_start_date = DateUtils.convertDateTimeFromServer(data.commercial_activity_start_date);
                        data.temp_load_demand_date = DateUtils.convertDateTimeFromServer(data.temp_load_demand_date);
                        data.regular_load_demand_date = DateUtils.convertDateTimeFromServer(data.regular_load_demand_date);
                        data.applicationdate = DateUtils.convertDateTimeFromServer(data.applicationdate);
                        data.deactivateddate = DateUtils.convertDateTimeFromServer(data.deactivateddate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectDialogController', ProjectDialogController);

    ProjectDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Project'];

    function ProjectDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Project) {
        var vm = this;

        vm.project = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.project.id !== null) {
                Project.update(vm.project, onSaveSuccess, onSaveError);
            } else {
                Project.save(vm.project, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;
        vm.datePickerOpenStatus.project_construction_start_date = false;
        vm.datePickerOpenStatus.commercial_activity_start_date = false;
        vm.datePickerOpenStatus.temp_load_demand_date = false;
        vm.datePickerOpenStatus.regular_load_demand_date = false;
        vm.datePickerOpenStatus.applicationdate = false;
        vm.datePickerOpenStatus.deactivateddate = false;
        vm.datePickerOpenStatus.prodctionStartDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectDetailController', ProjectDetailController);

    ProjectDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Project'];

    function ProjectDetailController($scope, $rootScope, $stateParams, previousState, entity, Project) {
        var vm = this;

        vm.project = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:projectUpdate', function(event, result) {
            vm.project = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectDeleteController',ProjectDeleteController);

    ProjectDeleteController.$inject = ['$uibModalInstance', 'entity', 'Project'];

    function ProjectDeleteController($uibModalInstance, entity, Project) {
        var vm = this;

        vm.project = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Project.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('project', {
            parent: 'entity',
            url: '/project',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_TICKET_OPERATION_MANAGER','ROLE_L1_SUPPORT'],
                pageTitle: 'investhryApp.project.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project/projects.html',
                    controller: 'ProjectController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('project-detail', {
            parent: 'project',
            url: '/project/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.project.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/project/project-detail.html',
                    controller: 'ProjectDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('project');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Project', function($stateParams, Project) {
                    return Project.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'project',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('project-detail.edit', {
            parent: 'project-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project.new', {
            parent: 'project',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                mouapplicable: null,
                                mousignyear: null,
                                mouidnumber: null,
                                firstname: null,
                                middlename: null,
                                lastname: null,
                                address1: null,
                                address2: null,
                                address3: null,
                                emailprimary: null,
                                emailsecondary: null,
                                userlogin: null,
                                cityname: null,
                                countryname: null,
                                statename: null,
                                createdate: null,
                                updatedate: null,
                                cafpin: null,
                                pincode: null,
                                phonenumber: null,
                                mobilenumber: null,
                                promoter_md_director: null,
                                designation: null,
                                businessentity: null,
                                director_promoter_md_ceo_number: null,
                                pan_number: null,
                                aadhar_number: null,
                                nri: null,
                                tin_vat_number: null,
                                cst_number: null,
                                businessentitytype: null,
                                gstnumber: null,
                                siteaddress: null,
                                multyvillageinvolved: null,
                                villageinvolved: null,
                                falls_in_aravalli: null,
                                islandprocured: null,
                                allotedbyhsiidc: null,
                                estate: null,
                                cluster: null,
                                phase: null,
                                sector: null,
                                plotno: null,
                                hadbastno: null,
                                liesunder_mc: null,
                                distance_from_mc: null,
                                islocated_in_urban: null,
                                totalproposedprojectarea: null,
                                proposedbuilt_up_area: null,
                                certifiedownership: null,
                                leaseapplicable: null,
                                landagreementapplicable: null,
                                intersectiondistance: null,
                                railwaydistance: null,
                                confirmitylanduse: null,
                                existing_building_applicable: null,
                                site_situated_in_controlled_area: null,
                                buildingexisted: null,
                                district: null,
                                block: null,
                                city_town_village: null,
                                connectingroad: null,
                                landzoneuse_type: null,
                                tehsil_subtehsil: null,
                                clurequired: null,
                                land_cost: null,
                                building_cost: null,
                                machinery_cost: null,
                                misc_assests: null,
                                total_project_cost: null,
                                isfdi: null,
                                fdivalue: null,
                                project_construction_start_date: null,
                                commercial_activity_start_date: null,
                                fdi_country: null,
                                foreign_funding_source: null,
                                totalpurposedemployment: null,
                                projectrawmaterialid: null,
                                productid: null,
                                processid: null,
                                manufacturing_flow_document: null,
                                temporaryrequired: null,
                                tem_load_existing: null,
                                tem_account_number: null,
                                temp_existing_load_demand_kw: null,
                                temp_existing_load_demand_kva: null,
                                temp_new_load_demand_kw: null,
                                temp_new_load_demand_kva: null,
                                temp_load_demand_date: null,
                                regular_load_required: null,
                                regular_existing_connection: null,
                                regular_account_number: null,
                                regular_existing_load_ifany_kw: null,
                                regular_existing_load_ifany_kva: null,
                                regular_new_load_demand_kw: null,
                                regular_new_load_demand_kva: null,
                                regular_load_demand_date: null,
                                customertype: null,
                                source_of_water_supply: null,
                                mode_of_disposal_for_discharge: null,
                                recycling_process: null,
                                recycling_cooling: null,
                                recycling_domestic: null,
                                recycling_other: null,
                                sourcewatersupplyother: null,
                                modedisposalother: null,
                                water_process: null,
                                water_cooling: null,
                                water_domestic: null,
                                water_other: null,
                                waste_water_process: null,
                                waste_water_cooling: null,
                                waste_water_domesting: null,
                                waste_water_other: null,
                                acceptance: null,
                                applicationdate: null,
                                place: null,
                                projectpurpose: null,
                                niccode: null,
                                existing_regulatory_approval: null,
                                edc_sif_clu_fee_paid_applicable: null,
                                approval_application_form: null,
                                category_of_project: null,
                                collaboration_with_foreign_country: null,
                                projectype: null,
                                sectorname: null,
                                size_of_industry: null,
                                sectorother: null,
                                assignedRM: null,
                                isdeactivated: null,
                                deactivatedby: null,
                                deactivateddate: null,
                                projectlevel: null,
                                isdraft: null,
                                caftype: null,
                                landrequired: null,
                                plotsize: null,
                                estatename: null,
                                purchaserate: null,
                                estatelocation: null,
                                agencyname: null,
                                village: null,
                                tehsil: null,
                                landusetype: null,
                                landrequirementindistrict: null,
                                product: null,
                                uamnumber: null,
                                nri_investment: null,
                                foreign_investment: null,
                                isulb: null,
                                mc: null,
                                blockCategory: null,
                                investmentType: null,
                                otherInvestmetType: null,
                                otherFDI: null,
                                prodctionStartDate: null,
                                haryanadomicile: null,
                                nonharyanadomicile: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: 'project' });
                }, function() {
                    $state.go('project');
                });
            }]
        })
        .state('project.edit', {
            parent: 'project',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-dialog.html',
                    controller: 'ProjectDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: 'project' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('project.delete', {
            parent: 'project',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/project/project-delete-dialog.html',
                    controller: 'ProjectDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Project', function(Project) {
                            return Project.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('project', null, { reload: 'project' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Project', Project);

    Project.$inject = ['$resource', 'DateUtils'];

    function Project ($resource, DateUtils) {
        var resourceUrl =  'api/projects/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                        data.project_construction_start_date = DateUtils.convertDateTimeFromServer(data.project_construction_start_date);
                        data.commercial_activity_start_date = DateUtils.convertDateTimeFromServer(data.commercial_activity_start_date);
                        data.temp_load_demand_date = DateUtils.convertDateTimeFromServer(data.temp_load_demand_date);
                        data.regular_load_demand_date = DateUtils.convertDateTimeFromServer(data.regular_load_demand_date);
                        data.applicationdate = DateUtils.convertDateTimeFromServer(data.applicationdate);
                        data.deactivateddate = DateUtils.convertDateTimeFromServer(data.deactivateddate);
                        data.prodctionStartDate = DateUtils.convertDateTimeFromServer(data.prodctionStartDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ProjectController', ProjectController);

    ProjectController.$inject = ['Project','SearchProject'];

    function ProjectController(Project,SearchProject) {

        var vm = this;

        vm.projects = [];
        vm.seachedProject= [];

//        loadAll();

        vm.getProject = function(){
            var newString =vm.CAFPIN.split('.').join('#');
            SearchProject.query({CAFPIN:newString},function(result){
                vm.seachedProject = result;
                vm.showtable=true;
            });
        };

//        function loadAll() {
//            Project.query(function(result) {
//                vm.projects = result;
//                vm.searchQuery = null;
//            });
//        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PolicyDetailsDialogController', PolicyDetailsDialogController);

    PolicyDetailsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'PolicyDetails', 'FileManagement'];

    function PolicyDetailsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, PolicyDetails, FileManagement) {
        var vm = this;

        vm.policyDetails = entity;
        vm.clear = clear;
        vm.save = save;
        $scope.file = {};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.policyDetails.id !== null) {
                PolicyDetails.update(vm.policyDetails, onSaveSuccess, onSaveError);
            } else {
                PolicyDetails.save(vm.policyDetails, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:policyDetailsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            UploadAttachment(result);
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function UploadAttachment(result)
        {
            var serverFileName = result.id;
            var file= vm.fileAttachemnt;

            var fileNameArray = file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension = fileNameArray[(fileNameArray.length-1)];
            }

            if(fileextension!=="" && fileextension === 'pdf')
            {
                FileManagement.saveFile(file,serverFileName,onFileSaveSuccess,OnFileSaveEror);
                serverFileName = serverFileName+"."+fileextension;
                vm.policyDetails1 = result;
                vm.policyDetails1.file = serverFileName;
            }
            else {
                alert('only pdf are allowed');
                PolicyDetails.delete({id: result.id});
            }
        }

        function onFileSaveSuccess(result) {
            PolicyDetails.update(vm.policyDetails1, onSaveSuccess1);
        }

        function OnFileSaveEror() {
            PolicyDetails.delete({id: vm.policyDetails1.id});
        }

        function onSaveSuccess1() {
            location.reload();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PolicyDetailsDetailController', PolicyDetailsDetailController);

    PolicyDetailsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'PolicyDetails'];

    function PolicyDetailsDetailController($scope, $rootScope, $stateParams, previousState, entity, PolicyDetails) {
        var vm = this;

        vm.policyDetails = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:policyDetailsUpdate', function(event, result) {
            vm.policyDetails = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PolicyDetailsDeleteController',PolicyDetailsDeleteController);

    PolicyDetailsDeleteController.$inject = ['$uibModalInstance', 'entity', 'PolicyDetails'];

    function PolicyDetailsDeleteController($uibModalInstance, entity, PolicyDetails) {
        var vm = this;

        vm.policyDetails = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PolicyDetails.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('policy-details', {
            parent: 'entity',
            url: '/policy-details',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER'],
                pageTitle: 'investhryApp.policyDetails.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/policy-details/policy-details.html',
                    controller: 'PolicyDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('policyDetails');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('policy-details-detail', {
            parent: 'policy-details',
            url: '/policy-details/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER'],
                pageTitle: 'investhryApp.policyDetails.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/policy-details/policy-details-detail.html',
                    controller: 'PolicyDetailsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('policyDetails');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'PolicyDetails', function($stateParams, PolicyDetails) {
                    return PolicyDetails.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'policy-details',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('policy-details-detail.edit', {
            parent: 'policy-details-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-details/policy-details-dialog.html',
                    controller: 'PolicyDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PolicyDetails', function(PolicyDetails) {
                            return PolicyDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('policy-details.new', {
            parent: 'policy-details',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-details/policy-details-dialog.html',
                    controller: 'PolicyDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                file: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('policy-details', null, { reload: 'policy-details' });
                }, function() {
                    $state.go('policy-details');
                });
            }]
        })
        .state('policy-details.edit', {
            parent: 'policy-details',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-details/policy-details-dialog.html',
                    controller: 'PolicyDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['PolicyDetails', function(PolicyDetails) {
                            return PolicyDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('policy-details', null, { reload: 'policy-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('policy-details.delete', {
            parent: 'policy-details',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/policy-details/policy-details-delete-dialog.html',
                    controller: 'PolicyDetailsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['PolicyDetails', function(PolicyDetails) {
                            return PolicyDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('policy-details', null, { reload: 'policy-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PolicyDetails', PolicyDetails);

    PolicyDetails.$inject = ['$resource'];

    function PolicyDetails ($resource) {
        var resourceUrl =  'api/policy-details/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PolicyDetailsController', PolicyDetailsController);

    PolicyDetailsController.$inject = ['PolicyDetails'];

    function PolicyDetailsController(PolicyDetails) {

        var vm = this;

        vm.policyDetails = [];

        loadAll();

        function loadAll() {
            PolicyDetails.query(function(result) {
                vm.policyDetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ParticularDialogController', ParticularDialogController);

    ParticularDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Particular'];

    function ParticularDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Particular) {
        var vm = this;

        vm.particular = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.particular.id !== null) {
                Particular.update(vm.particular, onSaveSuccess, onSaveError);
            } else {
                Particular.save(vm.particular, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:particularUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ParticularDetailController', ParticularDetailController);

    ParticularDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Particular'];

    function ParticularDetailController($scope, $rootScope, $stateParams, previousState, entity, Particular) {
        var vm = this;

        vm.particular = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:particularUpdate', function(event, result) {
            vm.particular = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ParticularDeleteController',ParticularDeleteController);

    ParticularDeleteController.$inject = ['$uibModalInstance', 'entity', 'Particular'];

    function ParticularDeleteController($uibModalInstance, entity, Particular) {
        var vm = this;

        vm.particular = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Particular.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('particular', {
            parent: 'entity',
            url: '/particular',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.particular.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/particular/particulars.html',
                    controller: 'ParticularController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('particular');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('particular-detail', {
            parent: 'particular',
            url: '/particular/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.particular.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/particular/particular-detail.html',
                    controller: 'ParticularDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('particular');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Particular', function($stateParams, Particular) {
                    return Particular.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'particular',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('particular-detail.edit', {
            parent: 'particular-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/particular/particular-dialog.html',
                    controller: 'ParticularDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Particular', function(Particular) {
                            return Particular.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('particular.new', {
            parent: 'particular',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/particular/particular-dialog.html',
                    controller: 'ParticularDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                particulars: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('particular', null, { reload: 'particular' });
                }, function() {
                    $state.go('particular');
                });
            }]
        })
        .state('particular.edit', {
            parent: 'particular',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/particular/particular-dialog.html',
                    controller: 'ParticularDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Particular', function(Particular) {
                            return Particular.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('particular', null, { reload: 'particular' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('particular.delete', {
            parent: 'particular',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/particular/particular-delete-dialog.html',
                    controller: 'ParticularDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Particular', function(Particular) {
                            return Particular.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('particular', null, { reload: 'particular' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Particular', Particular);

    Particular.$inject = ['$resource'];

    function Particular ($resource) {
        var resourceUrl =  'api/particulars/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ParticularController', ParticularController);

    ParticularController.$inject = ['Particular'];

    function ParticularController(Particular) {

        var vm = this;

        vm.particulars = [];

        loadAll();

        function loadAll() {
            Particular.query(function(result) {
                vm.particulars = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NswsUserDetailsDialogController', NswsUserDetailsDialogController);

    NswsUserDetailsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NswsUserDetails'];

    function NswsUserDetailsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NswsUserDetails) {
        var vm = this;

        vm.nswsUserDetails = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.nswsUserDetails.id !== null) {
                NswsUserDetails.update(vm.nswsUserDetails, onSaveSuccess, onSaveError);
            } else {
                NswsUserDetails.save(vm.nswsUserDetails, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:nswsUserDetailsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NswsUserDetailsDetailController', NswsUserDetailsDetailController);

    NswsUserDetailsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'NswsUserDetails'];

    function NswsUserDetailsDetailController($scope, $rootScope, $stateParams, previousState, entity, NswsUserDetails) {
        var vm = this;

        vm.nswsUserDetails = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:nswsUserDetailsUpdate', function(event, result) {
            vm.nswsUserDetails = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NswsUserDetailsDeleteController',NswsUserDetailsDeleteController);

    NswsUserDetailsDeleteController.$inject = ['$uibModalInstance', 'entity', 'NswsUserDetails'];

    function NswsUserDetailsDeleteController($uibModalInstance, entity, NswsUserDetails) {
        var vm = this;

        vm.nswsUserDetails = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NswsUserDetails.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('nsws-user-details', {
            parent: 'entity',
            url: '/nsws-user-details',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.nswsUserDetails.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/nsws-user-details/nsws-user-details.html',
                    controller: 'NswsUserDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nswsUserDetails');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('nsws-user-details-detail', {
            parent: 'nsws-user-details',
            url: '/nsws-user-details/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.nswsUserDetails.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/nsws-user-details/nsws-user-details-detail.html',
                    controller: 'NswsUserDetailsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nswsUserDetails');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NswsUserDetails', function($stateParams, NswsUserDetails) {
                    return NswsUserDetails.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'nsws-user-details',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('nsws-user-details-detail.edit', {
            parent: 'nsws-user-details-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nsws-user-details/nsws-user-details-dialog.html',
                    controller: 'NswsUserDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NswsUserDetails', function(NswsUserDetails) {
                            return NswsUserDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nsws-user-details.new', {
            parent: 'nsws-user-details',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nsws-user-details/nsws-user-details-dialog.html',
                    controller: 'NswsUserDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                mobile: null,
                                email: null,
                                investorSwsId: null,
                                firstName: null,
                                lastName: null,
                                projectId: null,
                                investorreqId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('nsws-user-details', null, { reload: 'nsws-user-details' });
                }, function() {
                    $state.go('nsws-user-details');
                });
            }]
        })
        .state('nsws-user-details.edit', {
            parent: 'nsws-user-details',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nsws-user-details/nsws-user-details-dialog.html',
                    controller: 'NswsUserDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NswsUserDetails', function(NswsUserDetails) {
                            return NswsUserDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nsws-user-details', null, { reload: 'nsws-user-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nsws-user-details.delete', {
            parent: 'nsws-user-details',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nsws-user-details/nsws-user-details-delete-dialog.html',
                    controller: 'NswsUserDetailsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NswsUserDetails', function(NswsUserDetails) {
                            return NswsUserDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nsws-user-details', null, { reload: 'nsws-user-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('NswsUserDetails', NswsUserDetails);

    NswsUserDetails.$inject = ['$resource'];

    function NswsUserDetails ($resource) {
        var resourceUrl =  'api/nsws-user-details/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NswsUserDetailsController', NswsUserDetailsController);

    NswsUserDetailsController.$inject = ['NswsUserDetails'];

    function NswsUserDetailsController(NswsUserDetails) {

        var vm = this;

        vm.nswsUserDetails = [];

        loadAll();

        function loadAll() {
            NswsUserDetails.query(function(result) {
                vm.nswsUserDetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NotificationDialogController', NotificationDialogController);

    NotificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Notification'];

    function NotificationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Notification) {
        var vm = this;

        vm.notification = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.notification.id !== null) {
                Notification.update(vm.notification, onSaveSuccess, onSaveError);
            } else {
                Notification.save(vm.notification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:notificationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.latestactiondate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NotificationDetailController', NotificationDetailController);

    NotificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Notification'];

    function NotificationDetailController($scope, $rootScope, $stateParams, previousState, entity, Notification) {
        var vm = this;

        vm.notification = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:notificationUpdate', function(event, result) {
            vm.notification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NotificationDeleteController',NotificationDeleteController);

    NotificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Notification'];

    function NotificationDeleteController($uibModalInstance, entity, Notification) {
        var vm = this;

        vm.notification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Notification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notification', {
            parent: 'entity',
            url: '/notification',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.notification.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notification/notifications.html',
                    controller: 'NotificationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('notification');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('notification-detail', {
            parent: 'notification',
            url: '/notification/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.notification.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notification/notification-detail.html',
                    controller: 'NotificationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('notification');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Notification', function($stateParams, Notification) {
                    return Notification.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'notification',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('notification-detail.edit', {
            parent: 'notification-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification/notification-dialog.html',
                    controller: 'NotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Notification', function(Notification) {
                            return Notification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('notification.new', {
            parent: 'notification',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification/notification-dialog.html',
                    controller: 'NotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                nodalofficer: null,
                                fieldofficer: null,
                                accountofficer: null,
                                investor: null,
                                deskofficer: null,
                                rm: null,
                                executive: null,
                                admin: null,
                                latestaction: null,
                                latestactiondate: null,
                                action: null,
                                latestactionby: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('notification', null, { reload: 'notification' });
                }, function() {
                    $state.go('notification');
                });
            }]
        })
        .state('notification.edit', {
            parent: 'notification',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification/notification-dialog.html',
                    controller: 'NotificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Notification', function(Notification) {
                            return Notification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('notification', null, { reload: 'notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('notification.delete', {
            parent: 'notification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/notification/notification-delete-dialog.html',
                    controller: 'NotificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Notification', function(Notification) {
                            return Notification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('notification', null, { reload: 'notification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Notification', Notification);

    Notification.$inject = ['$resource', 'DateUtils'];

    function Notification ($resource, DateUtils) {
        var resourceUrl =  'api/notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.latestactiondate = DateUtils.convertDateTimeFromServer(data.latestactiondate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NotificationController', NotificationController);

    NotificationController.$inject = ['Notification'];

    function NotificationController(Notification) {

        var vm = this;

        vm.notifications = [];

        loadAll();

        function loadAll() {
            Notification.query(function(result) {
                vm.notifications = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NmatokenDialogController', NmatokenDialogController);

    NmatokenDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Nmatoken'];

    function NmatokenDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Nmatoken) {
        var vm = this;

        vm.nmatoken = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.nmatoken.id !== null) {
                Nmatoken.update(vm.nmatoken, onSaveSuccess, onSaveError);
            } else {
                Nmatoken.save(vm.nmatoken, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:nmatokenUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NmatokenDetailController', NmatokenDetailController);

    NmatokenDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Nmatoken'];

    function NmatokenDetailController($scope, $rootScope, $stateParams, previousState, entity, Nmatoken) {
        var vm = this;

        vm.nmatoken = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:nmatokenUpdate', function(event, result) {
            vm.nmatoken = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NmatokenDeleteController',NmatokenDeleteController);

    NmatokenDeleteController.$inject = ['$uibModalInstance', 'entity', 'Nmatoken'];

    function NmatokenDeleteController($uibModalInstance, entity, Nmatoken) {
        var vm = this;

        vm.nmatoken = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Nmatoken.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('nmatoken', {
            parent: 'entity',
            url: '/nmatoken',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.nmatoken.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/nmatoken/nmatokens.html',
                    controller: 'NmatokenController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nmatoken');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('nmatoken-detail', {
            parent: 'nmatoken',
            url: '/nmatoken/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.nmatoken.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/nmatoken/nmatoken-detail.html',
                    controller: 'NmatokenDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nmatoken');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Nmatoken', function($stateParams, Nmatoken) {
                    return Nmatoken.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'nmatoken',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('nmatoken-detail.edit', {
            parent: 'nmatoken-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nmatoken/nmatoken-dialog.html',
                    controller: 'NmatokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Nmatoken', function(Nmatoken) {
                            return Nmatoken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nmatoken.new', {
            parent: 'nmatoken',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nmatoken/nmatoken-dialog.html',
                    controller: 'NmatokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nmatoken: null,
                                cafpin: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('nmatoken', null, { reload: 'nmatoken' });
                }, function() {
                    $state.go('nmatoken');
                });
            }]
        })
        .state('nmatoken.edit', {
            parent: 'nmatoken',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nmatoken/nmatoken-dialog.html',
                    controller: 'NmatokenDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Nmatoken', function(Nmatoken) {
                            return Nmatoken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nmatoken', null, { reload: 'nmatoken' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nmatoken.delete', {
            parent: 'nmatoken',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nmatoken/nmatoken-delete-dialog.html',
                    controller: 'NmatokenDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Nmatoken', function(Nmatoken) {
                            return Nmatoken.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nmatoken', null, { reload: 'nmatoken' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Nmatoken', Nmatoken);

    Nmatoken.$inject = ['$resource'];

    function Nmatoken ($resource) {
        var resourceUrl =  'api/nmatokens/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NmatokenController', NmatokenController);

    NmatokenController.$inject = ['Nmatoken'];

    function NmatokenController(Nmatoken) {

        var vm = this;

        vm.nmatokens = [];

        loadAll();

        function loadAll() {
            Nmatoken.query(function(result) {
                vm.nmatokens = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NmaDialogController', NmaDialogController);

    NmaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Nma'];

    function NmaDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Nma) {
        var vm = this;

        vm.nma = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.nma.id !== null) {
                Nma.update(vm.nma, onSaveSuccess, onSaveError);
            } else {
                Nma.save(vm.nma, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:nmaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NmaDetailController', NmaDetailController);

    NmaDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Nma'];

    function NmaDetailController($scope, $rootScope, $stateParams, previousState, entity, Nma) {
        var vm = this;

        vm.nma = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:nmaUpdate', function(event, result) {
            vm.nma = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NmaDeleteController',NmaDeleteController);

    NmaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Nma'];

    function NmaDeleteController($uibModalInstance, entity, Nma) {
        var vm = this;

        vm.nma = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Nma.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('nma', {
            parent: 'entity',
            url: '/nma',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.nma.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/nma/nmas.html',
                    controller: 'NmaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nma');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('nma-detail', {
            parent: 'nma',
            url: '/nma/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.nma.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/nma/nma-detail.html',
                    controller: 'NmaDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('nma');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Nma', function($stateParams, Nma) {
                    return Nma.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'nma',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('nma-detail.edit', {
            parent: 'nma-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nma/nma-dialog.html',
                    controller: 'NmaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Nma', function(Nma) {
                            return Nma.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nma.new', {
            parent: 'nma',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nma/nma-dialog.html',
                    controller: 'NmaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                department: null,
                                architectName: null,
                                architectEmail: null,
                                architectMobile: null,
                                nocRequestScreen: null,
                                nameOfApplicant: null,
                                presentAddress: null,
                                permanentAddress: null,
                                isOwner: null,
                                nameOfOwner: null,
                                presentAddressOwner: null,
                                permanentAddressOwner: null,
                                typeOwner1: null,
                                typeOwner2: null,
                                typeOwner3: null,
                                plotNo: null,
                                state: null,
                                district: null,
                                taulk: null,
                                locality: null,
                                monumentName: null,
                                stateMonument: null,
                                districtMonument: null,
                                taulkMonument: null,
                                localityMonument: null,
                                distance1: null,
                                distance2: null,
                                workDetails1: null,
                                workDetails2: null,
                                workDetails3: null,
                                workDetails4: null,
                                workDetails5: null,
                                workDetails6: null,
                                workDetails7: null,
                                workDetails8: null,
                                workDetails9: null,
                                workDetails10: null,
                                workDetails11: null,
                                workDetails12: null,
                                otherWorkDetails1: null,
                                otherWorkDetails2: null,
                                otherWorkDetails3: null,
                                otherWorkDetails4: null,
                                otherWorkDetails5: null,
                                otherWorkDetails6: null,
                                otherWorkDetails7: null,
                                otherWorkDetails8: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('nma', null, { reload: 'nma' });
                }, function() {
                    $state.go('nma');
                });
            }]
        })
        .state('nma.edit', {
            parent: 'nma',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nma/nma-dialog.html',
                    controller: 'NmaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Nma', function(Nma) {
                            return Nma.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nma', null, { reload: 'nma' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('nma.delete', {
            parent: 'nma',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/nma/nma-delete-dialog.html',
                    controller: 'NmaDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Nma', function(Nma) {
                            return Nma.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('nma', null, { reload: 'nma' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Nma', Nma);

    Nma.$inject = ['$resource'];

    function Nma ($resource) {
        var resourceUrl =  'api/nmas/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NmaController', NmaController);

    NmaController.$inject = ['Nma'];

    function NmaController(Nma) {

        var vm = this;

        vm.nmas = [];

        loadAll();

        function loadAll() {
            Nma.query(function(result) {
                vm.nmas = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewsandgalleryDialogController', NewsandgalleryDialogController);

    NewsandgalleryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Newsandgallery', 'FileManagement'];

    function NewsandgalleryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Newsandgallery, FileManagement) {
        var vm = this;

        vm.newsandgallery = entity;
        $scope.file = {};
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.addfileattachment = function()
        {
            var fileNameArray = vm.imageFile.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=vm.newsandgallery.description;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            vm.newsandgallery.isSaved=false;
            Newsandgallery.save(vm.newsandgallery,onSaveImageFileSuccess);

        }

        function onSaveImageFileSuccess (result)
        {
            var filename = result.id;
            var file =vm.imageFile;
            FileManagement.saveFile(file,filename);
            var fileNameArray = vm.imageFile.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                 fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            result.description = result.id+"."+fileextension;
            Newsandgallery.update(result,onSaveSuccess,onSaveError);
        }

        function save () {
            vm.isSaving = true;
            if (vm.newsandgallery.id !== null) {
                Newsandgallery.update(vm.newsandgallery, onSaveSuccess, onSaveError);
            } else {
                Newsandgallery.save(vm.newsandgallery, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:newsandgalleryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastmodified = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewsandgalleryDetailController', NewsandgalleryDetailController);

    NewsandgalleryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Newsandgallery'];

    function NewsandgalleryDetailController($scope, $rootScope, $stateParams, previousState, entity, Newsandgallery) {
        var vm = this;

        vm.newsandgallery = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:newsandgalleryUpdate', function(event, result) {
            vm.newsandgallery = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewsandgalleryDeleteController',NewsandgalleryDeleteController);

    NewsandgalleryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Newsandgallery'];

    function NewsandgalleryDeleteController($uibModalInstance, entity, Newsandgallery) {
        var vm = this;

        vm.newsandgallery = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Newsandgallery.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('newsandgallery', {
            parent: 'entity',
            url: '/newsandgallery',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER'],
                pageTitle: 'investhryApp.newsandgallery.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/newsandgallery/newsandgalleries.html',
                    controller: 'NewsandgalleryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('newsandgallery');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('newsandgallery-detail', {
            parent: 'newsandgallery',
            url: '/newsandgallery/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER'],
                pageTitle: 'investhryApp.newsandgallery.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/newsandgallery/newsandgallery-detail.html',
                    controller: 'NewsandgalleryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('newsandgallery');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Newsandgallery', function($stateParams, Newsandgallery) {
                    return Newsandgallery.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'newsandgallery',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('newsandgallery-detail.edit', {
            parent: 'newsandgallery-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/newsandgallery/newsandgallery-dialog.html',
                    controller: 'NewsandgalleryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Newsandgallery', function(Newsandgallery) {
                            return Newsandgallery.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('newsandgallery.new', {
            parent: 'newsandgallery',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/newsandgallery/newsandgallery-dialog.html',
                    controller: 'NewsandgalleryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                description: null,
                                lastmodified: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('newsandgallery', null, { reload: 'newsandgallery' });
                }, function() {
                    $state.go('newsandgallery');
                });
            }]
        })
        .state('newsandgallery.edit', {
            parent: 'newsandgallery',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/newsandgallery/newsandgallery-dialog.html',
                    controller: 'NewsandgalleryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Newsandgallery', function(Newsandgallery) {
                            return Newsandgallery.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('newsandgallery', null, { reload: 'newsandgallery' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('newsandgallery.delete', {
            parent: 'newsandgallery',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/newsandgallery/newsandgallery-delete-dialog.html',
                    controller: 'NewsandgalleryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Newsandgallery', function(Newsandgallery) {
                            return Newsandgallery.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('newsandgallery', null, { reload: 'newsandgallery' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Newsandgallery', Newsandgallery);

    Newsandgallery.$inject = ['$resource', 'DateUtils'];

    function Newsandgallery ($resource, DateUtils) {
        var resourceUrl =  'api/newsandgalleries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastmodified = DateUtils.convertDateTimeFromServer(data.lastmodified);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewsandgalleryController', NewsandgalleryController);

    NewsandgalleryController.$inject = ['Newsandgallery'];

    function NewsandgalleryController(Newsandgallery) {

        var vm = this;

        vm.newsandgalleries = [];

        loadAll();

        function loadAll() {
            Newsandgallery.query(function(result) {
                vm.newsandgalleries = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDasboardStatsDialogController', NewDasboardStatsDialogController);

    NewDasboardStatsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NewDasboardStats'];

    function NewDasboardStatsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NewDasboardStats) {
        var vm = this;

        vm.newDasboardStats = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.newDasboardStats.id !== null) {
                NewDasboardStats.update(vm.newDasboardStats, onSaveSuccess, onSaveError);
            } else {
                NewDasboardStats.save(vm.newDasboardStats, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:newDasboardStatsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDasboardStatsDetailController', NewDasboardStatsDetailController);

    NewDasboardStatsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'NewDasboardStats'];

    function NewDasboardStatsDetailController($scope, $rootScope, $stateParams, previousState, entity, NewDasboardStats) {
        var vm = this;

        vm.newDasboardStats = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:newDasboardStatsUpdate', function(event, result) {
            vm.newDasboardStats = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDasboardStatsDeleteController',NewDasboardStatsDeleteController);

    NewDasboardStatsDeleteController.$inject = ['$uibModalInstance', 'entity', 'NewDasboardStats'];

    function NewDasboardStatsDeleteController($uibModalInstance, entity, NewDasboardStats) {
        var vm = this;

        vm.newDasboardStats = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NewDasboardStats.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('new-dasboard-stats', {
            parent: 'entity',
            url: '/new-dasboard-stats',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.newDasboardStats.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/new-dasboard-stats/new-dasboard-stats.html',
                    controller: 'NewDasboardStatsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('newDasboardStats');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('new-dasboard-stats-detail', {
            parent: 'new-dasboard-stats',
            url: '/new-dasboard-stats/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.newDasboardStats.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/new-dasboard-stats/new-dasboard-stats-detail.html',
                    controller: 'NewDasboardStatsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('newDasboardStats');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NewDasboardStats', function($stateParams, NewDasboardStats) {
                    return NewDasboardStats.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'new-dasboard-stats',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('new-dasboard-stats-detail.edit', {
            parent: 'new-dasboard-stats-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/new-dasboard-stats/new-dasboard-stats-dialog.html',
                    controller: 'NewDasboardStatsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NewDasboardStats', function(NewDasboardStats) {
                            return NewDasboardStats.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('new-dasboard-stats.new', {
            parent: 'new-dasboard-stats',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/new-dasboard-stats/new-dasboard-stats-dialog.html',
                    controller: 'NewDasboardStatsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectType: null,
                                projectLevel: null,
                                total: null,
                                totalInvestment: null,
                                totalEmployment: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('new-dasboard-stats', null, { reload: 'new-dasboard-stats' });
                }, function() {
                    $state.go('new-dasboard-stats');
                });
            }]
        })
        .state('new-dasboard-stats.edit', {
            parent: 'new-dasboard-stats',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/new-dasboard-stats/new-dasboard-stats-dialog.html',
                    controller: 'NewDasboardStatsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NewDasboardStats', function(NewDasboardStats) {
                            return NewDasboardStats.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('new-dasboard-stats', null, { reload: 'new-dasboard-stats' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('new-dasboard-stats.delete', {
            parent: 'new-dasboard-stats',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/new-dasboard-stats/new-dasboard-stats-delete-dialog.html',
                    controller: 'NewDasboardStatsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NewDasboardStats', function(NewDasboardStats) {
                            return NewDasboardStats.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('new-dasboard-stats', null, { reload: 'new-dasboard-stats' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('NewDasboardStats', NewDasboardStats);

    NewDasboardStats.$inject = ['$resource'];

    function NewDasboardStats ($resource) {
        var resourceUrl =  'api/new-dasboard-stats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDasboardStatsController', NewDasboardStatsController);

    NewDasboardStatsController.$inject = ['NewDasboardStats'];

    function NewDasboardStatsController(NewDasboardStats) {

        var vm = this;

        vm.newDasboardStats = [];

        loadAll();

        function loadAll() {
            NewDasboardStats.query(function(result) {
                vm.newDasboardStats = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDasboardAllCompletedStatsDialogController', NewDasboardAllCompletedStatsDialogController);

    NewDasboardAllCompletedStatsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'NewDasboardAllCompletedStats'];

    function NewDasboardAllCompletedStatsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, NewDasboardAllCompletedStats) {
        var vm = this;

        vm.newDasboardAllCompletedStats = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.newDasboardAllCompletedStats.id !== null) {
                NewDasboardAllCompletedStats.update(vm.newDasboardAllCompletedStats, onSaveSuccess, onSaveError);
            } else {
                NewDasboardAllCompletedStats.save(vm.newDasboardAllCompletedStats, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:newDasboardAllCompletedStatsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDasboardAllCompletedStatsDetailController', NewDasboardAllCompletedStatsDetailController);

    NewDasboardAllCompletedStatsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'NewDasboardAllCompletedStats'];

    function NewDasboardAllCompletedStatsDetailController($scope, $rootScope, $stateParams, previousState, entity, NewDasboardAllCompletedStats) {
        var vm = this;

        vm.newDasboardAllCompletedStats = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:newDasboardAllCompletedStatsUpdate', function(event, result) {
            vm.newDasboardAllCompletedStats = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDasboardAllCompletedStatsDeleteController',NewDasboardAllCompletedStatsDeleteController);

    NewDasboardAllCompletedStatsDeleteController.$inject = ['$uibModalInstance', 'entity', 'NewDasboardAllCompletedStats'];

    function NewDasboardAllCompletedStatsDeleteController($uibModalInstance, entity, NewDasboardAllCompletedStats) {
        var vm = this;

        vm.newDasboardAllCompletedStats = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            NewDasboardAllCompletedStats.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('new-dasboard-all-completed-stats', {
            parent: 'entity',
            url: '/new-dasboard-all-completed-stats',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.newDasboardAllCompletedStats.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/new-dasboard-all-completed-stats/new-dasboard-all-completed-stats.html',
                    controller: 'NewDasboardAllCompletedStatsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('newDasboardAllCompletedStats');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('new-dasboard-all-completed-stats-detail', {
            parent: 'new-dasboard-all-completed-stats',
            url: '/new-dasboard-all-completed-stats/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.newDasboardAllCompletedStats.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/new-dasboard-all-completed-stats/new-dasboard-all-completed-stats-detail.html',
                    controller: 'NewDasboardAllCompletedStatsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('newDasboardAllCompletedStats');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'NewDasboardAllCompletedStats', function($stateParams, NewDasboardAllCompletedStats) {
                    return NewDasboardAllCompletedStats.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'new-dasboard-all-completed-stats',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('new-dasboard-all-completed-stats-detail.edit', {
            parent: 'new-dasboard-all-completed-stats-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/new-dasboard-all-completed-stats/new-dasboard-all-completed-stats-dialog.html',
                    controller: 'NewDasboardAllCompletedStatsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NewDasboardAllCompletedStats', function(NewDasboardAllCompletedStats) {
                            return NewDasboardAllCompletedStats.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('new-dasboard-all-completed-stats.new', {
            parent: 'new-dasboard-all-completed-stats',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/new-dasboard-all-completed-stats/new-dasboard-all-completed-stats-dialog.html',
                    controller: 'NewDasboardAllCompletedStatsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                caftype: null,
                                projectLevel: null,
                                total: null,
                                totalEmployment: null,
                                totalInvestment: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('new-dasboard-all-completed-stats', null, { reload: 'new-dasboard-all-completed-stats' });
                }, function() {
                    $state.go('new-dasboard-all-completed-stats');
                });
            }]
        })
        .state('new-dasboard-all-completed-stats.edit', {
            parent: 'new-dasboard-all-completed-stats',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/new-dasboard-all-completed-stats/new-dasboard-all-completed-stats-dialog.html',
                    controller: 'NewDasboardAllCompletedStatsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['NewDasboardAllCompletedStats', function(NewDasboardAllCompletedStats) {
                            return NewDasboardAllCompletedStats.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('new-dasboard-all-completed-stats', null, { reload: 'new-dasboard-all-completed-stats' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('new-dasboard-all-completed-stats.delete', {
            parent: 'new-dasboard-all-completed-stats',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/new-dasboard-all-completed-stats/new-dasboard-all-completed-stats-delete-dialog.html',
                    controller: 'NewDasboardAllCompletedStatsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['NewDasboardAllCompletedStats', function(NewDasboardAllCompletedStats) {
                            return NewDasboardAllCompletedStats.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('new-dasboard-all-completed-stats', null, { reload: 'new-dasboard-all-completed-stats' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('NewDasboardAllCompletedStats', NewDasboardAllCompletedStats);

    NewDasboardAllCompletedStats.$inject = ['$resource'];

    function NewDasboardAllCompletedStats ($resource) {
        var resourceUrl =  'api/new-dasboard-all-completed-stats/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDasboardAllCompletedStatsController', NewDasboardAllCompletedStatsController);

    NewDasboardAllCompletedStatsController.$inject = ['NewDasboardAllCompletedStats'];

    function NewDasboardAllCompletedStatsController(NewDasboardAllCompletedStats) {

        var vm = this;

        vm.newDasboardAllCompletedStats = [];

        loadAll();

        function loadAll() {
            NewDasboardAllCompletedStats.query(function(result) {
                vm.newDasboardAllCompletedStats = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalsDialogController', MunicipalsDialogController);

    MunicipalsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Municipals'];

    function MunicipalsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Municipals) {
        var vm = this;

        vm.municipals = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.municipals.id !== null) {
                Municipals.update(vm.municipals, onSaveSuccess, onSaveError);
            } else {
                Municipals.save(vm.municipals, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:municipalsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalsDetailController', MunicipalsDetailController);

    MunicipalsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Municipals'];

    function MunicipalsDetailController($scope, $rootScope, $stateParams, previousState, entity, Municipals) {
        var vm = this;

        vm.municipals = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:municipalsUpdate', function(event, result) {
            vm.municipals = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalsDeleteController',MunicipalsDeleteController);

    MunicipalsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Municipals'];

    function MunicipalsDeleteController($uibModalInstance, entity, Municipals) {
        var vm = this;

        vm.municipals = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Municipals.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('municipals', {
            parent: 'entity',
            url: '/municipals',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.municipals.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/municipals/municipals.html',
                    controller: 'MunicipalsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('municipals');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('municipals-detail', {
            parent: 'municipals',
            url: '/municipals/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.municipals.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/municipals/municipals-detail.html',
                    controller: 'MunicipalsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('municipals');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Municipals', function($stateParams, Municipals) {
                    return Municipals.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'municipals',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('municipals-detail.edit', {
            parent: 'municipals-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipals/municipals-dialog.html',
                    controller: 'MunicipalsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Municipals', function(Municipals) {
                            return Municipals.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('municipals.new', {
            parent: 'municipals',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipals/municipals-dialog.html',
                    controller: 'MunicipalsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                district: null,
                                name: null,
                                departmentName: null,
                                lgdCode: null,
                                locationName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('municipals', null, { reload: 'municipals' });
                }, function() {
                    $state.go('municipals');
                });
            }]
        })
        .state('municipals.edit', {
            parent: 'municipals',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipals/municipals-dialog.html',
                    controller: 'MunicipalsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Municipals', function(Municipals) {
                            return Municipals.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('municipals', null, { reload: 'municipals' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('municipals.delete', {
            parent: 'municipals',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipals/municipals-delete-dialog.html',
                    controller: 'MunicipalsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Municipals', function(Municipals) {
                            return Municipals.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('municipals', null, { reload: 'municipals' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Municipals', Municipals);

    Municipals.$inject = ['$resource'];

    function Municipals ($resource) {
        var resourceUrl =  'api/municipals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalsController', MunicipalsController);

    MunicipalsController.$inject = ['Municipals'];

    function MunicipalsController(Municipals) {

        var vm = this;

        vm.municipals = [];

        loadAll();

        function loadAll() {
            Municipals.query(function(result) {
                vm.municipals = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalityDialogController', MunicipalityDialogController);

    MunicipalityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Municipality'];

    function MunicipalityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Municipality) {
        var vm = this;

        vm.municipality = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.municipality.id !== null) {
                Municipality.update(vm.municipality, onSaveSuccess, onSaveError);
            } else {
                Municipality.save(vm.municipality, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:municipalityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalityDetailController', MunicipalityDetailController);

    MunicipalityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Municipality'];

    function MunicipalityDetailController($scope, $rootScope, $stateParams, previousState, entity, Municipality) {
        var vm = this;

        vm.municipality = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:municipalityUpdate', function(event, result) {
            vm.municipality = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalityDeleteController',MunicipalityDeleteController);

    MunicipalityDeleteController.$inject = ['$uibModalInstance', 'entity', 'Municipality'];

    function MunicipalityDeleteController($uibModalInstance, entity, Municipality) {
        var vm = this;

        vm.municipality = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Municipality.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('municipality', {
            parent: 'entity',
            url: '/municipality',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.municipality.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/municipality/municipalities.html',
                    controller: 'MunicipalityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('municipality');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('municipality-detail', {
            parent: 'municipality',
            url: '/municipality/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.municipality.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/municipality/municipality-detail.html',
                    controller: 'MunicipalityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('municipality');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Municipality', function($stateParams, Municipality) {
                    return Municipality.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'municipality',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('municipality-detail.edit', {
            parent: 'municipality-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipality/municipality-dialog.html',
                    controller: 'MunicipalityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Municipality', function(Municipality) {
                            return Municipality.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('municipality.new', {
            parent: 'municipality',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipality/municipality-dialog.html',
                    controller: 'MunicipalityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                district: null,
                                municipality_name: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('municipality', null, { reload: 'municipality' });
                }, function() {
                    $state.go('municipality');
                });
            }]
        })
        .state('municipality.edit', {
            parent: 'municipality',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipality/municipality-dialog.html',
                    controller: 'MunicipalityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Municipality', function(Municipality) {
                            return Municipality.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('municipality', null, { reload: 'municipality' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('municipality.delete', {
            parent: 'municipality',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipality/municipality-delete-dialog.html',
                    controller: 'MunicipalityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Municipality', function(Municipality) {
                            return Municipality.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('municipality', null, { reload: 'municipality' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Municipality', Municipality);

    Municipality.$inject = ['$resource'];

    function Municipality ($resource) {
        var resourceUrl =  'api/municipalities/:id/:districtname';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalityController', MunicipalityController);

    MunicipalityController.$inject = ['Municipality'];

    function MunicipalityController(Municipality) {

        var vm = this;

        vm.municipalities = [];

        loadAll();

        function loadAll() {
            Municipality.query(function(result) {
                vm.municipalities = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalPaymentParamsDialogController', MunicipalPaymentParamsDialogController);

    MunicipalPaymentParamsDialogController.$inject = ['$timeout', '$scope','$filter', '$stateParams', '$uibModalInstance', 'entity', 'MunicipalPaymentParams','District' ,'Department'];

    function MunicipalPaymentParamsDialogController ($timeout, $scope,$filter, $stateParams, $uibModalInstance, entity, MunicipalPaymentParams,District ,Department) {
        var vm = this;

        vm.municipalPaymentParams = entity;
        vm.clear = clear;
        vm.save = save;
        vm.districts = [];
        vm.departments= [];


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        loadAll();
        function loadAll(){
        District.query(function(result) {
            vm.districts = result;
            vm.searchQuery = null;
        });
            Department.query(function (result) {
                console.log(result);

                vm.departments = $filter('filter')(result,{istower : true});
                vm.searchQuery = null;
            });
    }


        function save () {
            vm.isSaving = true;
            if (vm.municipalPaymentParams.id !== null) {
                MunicipalPaymentParams.update(vm.municipalPaymentParams, onSaveSuccess, onSaveError);
            } else {
                MunicipalPaymentParams.save(vm.municipalPaymentParams, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:municipalPaymentParamsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalPaymentParamsDetailController', MunicipalPaymentParamsDetailController);

    MunicipalPaymentParamsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MunicipalPaymentParams'];

    function MunicipalPaymentParamsDetailController($scope, $rootScope, $stateParams, previousState, entity, MunicipalPaymentParams) {
        var vm = this;

        vm.municipalPaymentParams = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:municipalPaymentParamsUpdate', function(event, result) {
            vm.municipalPaymentParams = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalPaymentParamsDeleteController',MunicipalPaymentParamsDeleteController);

    MunicipalPaymentParamsDeleteController.$inject = ['$uibModalInstance', 'entity', 'MunicipalPaymentParams'];

    function MunicipalPaymentParamsDeleteController($uibModalInstance, entity, MunicipalPaymentParams) {
        var vm = this;

        vm.municipalPaymentParams = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MunicipalPaymentParams.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('municipal-payment-params', {
            parent: 'entity',
            url: '/municipal-payment-params',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.municipalPaymentParams.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/municipal-payment-params/municipal-payment-params.html',
                    controller: 'MunicipalPaymentParamsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('municipalPaymentParams');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('municipal-payment-params-detail', {
            parent: 'municipal-payment-params',
            url: '/municipal-payment-params/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.municipalPaymentParams.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/municipal-payment-params/municipal-payment-params-detail.html',
                    controller: 'MunicipalPaymentParamsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('municipalPaymentParams');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MunicipalPaymentParams', function($stateParams, MunicipalPaymentParams) {
                    return MunicipalPaymentParams.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'municipal-payment-params',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('municipal-payment-params-detail.edit', {
            parent: 'municipal-payment-params-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipal-payment-params/municipal-payment-params-dialog.html',
                    controller: 'MunicipalPaymentParamsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MunicipalPaymentParams', function(MunicipalPaymentParams) {
                            return MunicipalPaymentParams.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('municipal-payment-params.new', {
            parent: 'municipal-payment-params',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipal-payment-params/municipal-payment-params-dialog.html',
                    controller: 'MunicipalPaymentParamsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                salt: null,
                                key: null,
                                subDepartmentName: null,
                                url: null,
                                district: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('municipal-payment-params', null, { reload: 'municipal-payment-params' });
                }, function() {
                    $state.go('municipal-payment-params');
                });
            }]
        })
        .state('municipal-payment-params.edit', {
            parent: 'municipal-payment-params',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipal-payment-params/municipal-payment-params-dialog.html',
                    controller: 'MunicipalPaymentParamsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MunicipalPaymentParams', function(MunicipalPaymentParams) {
                            return MunicipalPaymentParams.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('municipal-payment-params', null, { reload: 'municipal-payment-params' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('municipal-payment-params.delete', {
            parent: 'municipal-payment-params',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/municipal-payment-params/municipal-payment-params-delete-dialog.html',
                    controller: 'MunicipalPaymentParamsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MunicipalPaymentParams', function(MunicipalPaymentParams) {
                            return MunicipalPaymentParams.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('municipal-payment-params', null, { reload: 'municipal-payment-params' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MunicipalPaymentParams', MunicipalPaymentParams);

    MunicipalPaymentParams.$inject = ['$resource'];

    function MunicipalPaymentParams ($resource) {
        var resourceUrl =  'api/municipal-payment-params/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MunicipalPaymentParamsController', MunicipalPaymentParamsController);

    MunicipalPaymentParamsController.$inject = ['MunicipalPaymentParams'];

    function MunicipalPaymentParamsController(MunicipalPaymentParams) {

        var vm = this;

        vm.municipalPaymentParams = [];

        loadAll();

        function loadAll() {
            MunicipalPaymentParams.query(function(result) {
                vm.municipalPaymentParams = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleuserDialogController', MultipleuserDialogController);

    MultipleuserDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Multipleuser'];

    function MultipleuserDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Multipleuser) {
        var vm = this;

        vm.multipleuser = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.multipleuser.id !== null) {
                Multipleuser.update(vm.multipleuser, onSaveSuccess, onSaveError);
            } else {
                Multipleuser.save(vm.multipleuser, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:multipleuserUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleuserDetailController', MultipleuserDetailController);

    MultipleuserDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Multipleuser'];

    function MultipleuserDetailController($scope, $rootScope, $stateParams, previousState, entity, Multipleuser) {
        var vm = this;

        vm.multipleuser = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:multipleuserUpdate', function(event, result) {
            vm.multipleuser = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleuserDeleteController',MultipleuserDeleteController);

    MultipleuserDeleteController.$inject = ['$uibModalInstance', 'entity', 'Multipleuser'];

    function MultipleuserDeleteController($uibModalInstance, entity, Multipleuser) {
        var vm = this;

        vm.multipleuser = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Multipleuser.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('multipleuser', {
            parent: 'entity',
            url: '/multipleuser',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.multipleuser.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/multipleuser/multipleusers.html',
                    controller: 'MultipleuserController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('multipleuser');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('multipleuser-detail', {
            parent: 'multipleuser',
            url: '/multipleuser/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.multipleuser.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/multipleuser/multipleuser-detail.html',
                    controller: 'MultipleuserDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('multipleuser');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Multipleuser', function($stateParams, Multipleuser) {
                    return Multipleuser.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'multipleuser',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('multipleuser-detail.edit', {
            parent: 'multipleuser-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleuser/multipleuser-dialog.html',
                    controller: 'MultipleuserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Multipleuser', function(Multipleuser) {
                            return Multipleuser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('multipleuser.new', {
            parent: 'multipleuser',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleuser/multipleuser-dialog.html',
                    controller: 'MultipleuserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                userId: null,
                                login: null,
                                email: null,
                                count: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('multipleuser', null, { reload: 'multipleuser' });
                }, function() {
                    $state.go('multipleuser');
                });
            }]
        })
        .state('multipleuser.edit', {
            parent: 'multipleuser',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleuser/multipleuser-dialog.html',
                    controller: 'MultipleuserDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Multipleuser', function(Multipleuser) {
                            return Multipleuser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('multipleuser', null, { reload: 'multipleuser' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('multipleuser.delete', {
            parent: 'multipleuser',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleuser/multipleuser-delete-dialog.html',
                    controller: 'MultipleuserDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Multipleuser', function(Multipleuser) {
                            return Multipleuser.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('multipleuser', null, { reload: 'multipleuser' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Multipleuser', Multipleuser);

    Multipleuser.$inject = ['$resource'];

    function Multipleuser ($resource) {
        var resourceUrl =  'api/multipleusers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleuserController', MultipleuserController);

    MultipleuserController.$inject = ['Multipleuser'];

    function MultipleuserController(Multipleuser) {

        var vm = this;

        vm.multipleusers = [];

        loadAll();

        function loadAll() {
            Multipleuser.query(function(result) {
                vm.multipleusers = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleactiveaccountwithoutcafDialogController', MultipleactiveaccountwithoutcafDialogController);

    MultipleactiveaccountwithoutcafDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Multipleactiveaccountwithoutcaf'];

    function MultipleactiveaccountwithoutcafDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Multipleactiveaccountwithoutcaf) {
        var vm = this;

        vm.multipleactiveaccountwithoutcaf = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.multipleactiveaccountwithoutcaf.id !== null) {
                Multipleactiveaccountwithoutcaf.update(vm.multipleactiveaccountwithoutcaf, onSaveSuccess, onSaveError);
            } else {
                Multipleactiveaccountwithoutcaf.save(vm.multipleactiveaccountwithoutcaf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:multipleactiveaccountwithoutcafUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleactiveaccountwithoutcafDetailController', MultipleactiveaccountwithoutcafDetailController);

    MultipleactiveaccountwithoutcafDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Multipleactiveaccountwithoutcaf'];

    function MultipleactiveaccountwithoutcafDetailController($scope, $rootScope, $stateParams, previousState, entity, Multipleactiveaccountwithoutcaf) {
        var vm = this;

        vm.multipleactiveaccountwithoutcaf = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:multipleactiveaccountwithoutcafUpdate', function(event, result) {
            vm.multipleactiveaccountwithoutcaf = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleactiveaccountwithoutcafDeleteController',MultipleactiveaccountwithoutcafDeleteController);

    MultipleactiveaccountwithoutcafDeleteController.$inject = ['$uibModalInstance', 'entity', 'Multipleactiveaccountwithoutcaf'];

    function MultipleactiveaccountwithoutcafDeleteController($uibModalInstance, entity, Multipleactiveaccountwithoutcaf) {
        var vm = this;

        vm.multipleactiveaccountwithoutcaf = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Multipleactiveaccountwithoutcaf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('multipleactiveaccountwithoutcaf', {
            parent: 'entity',
            url: '/multipleactiveaccountwithoutcaf',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.multipleactiveaccountwithoutcaf.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/multipleactiveaccountwithoutcaf/multipleactiveaccountwithoutcafs.html',
                    controller: 'MultipleactiveaccountwithoutcafController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('multipleactiveaccountwithoutcaf');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('multipleactiveaccountwithoutcaf-detail', {
            parent: 'multipleactiveaccountwithoutcaf',
            url: '/multipleactiveaccountwithoutcaf/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.multipleactiveaccountwithoutcaf.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/multipleactiveaccountwithoutcaf/multipleactiveaccountwithoutcaf-detail.html',
                    controller: 'MultipleactiveaccountwithoutcafDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('multipleactiveaccountwithoutcaf');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Multipleactiveaccountwithoutcaf', function($stateParams, Multipleactiveaccountwithoutcaf) {
                    return Multipleactiveaccountwithoutcaf.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'multipleactiveaccountwithoutcaf',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('multipleactiveaccountwithoutcaf-detail.edit', {
            parent: 'multipleactiveaccountwithoutcaf-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleactiveaccountwithoutcaf/multipleactiveaccountwithoutcaf-dialog.html',
                    controller: 'MultipleactiveaccountwithoutcafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Multipleactiveaccountwithoutcaf', function(Multipleactiveaccountwithoutcaf) {
                            return Multipleactiveaccountwithoutcaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('multipleactiveaccountwithoutcaf.new', {
            parent: 'multipleactiveaccountwithoutcaf',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleactiveaccountwithoutcaf/multipleactiveaccountwithoutcaf-dialog.html',
                    controller: 'MultipleactiveaccountwithoutcafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                email: null,
                                userId: null,
                                login: null,
                                sNo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('multipleactiveaccountwithoutcaf', null, { reload: 'multipleactiveaccountwithoutcaf' });
                }, function() {
                    $state.go('multipleactiveaccountwithoutcaf');
                });
            }]
        })
        .state('multipleactiveaccountwithoutcaf.edit', {
            parent: 'multipleactiveaccountwithoutcaf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleactiveaccountwithoutcaf/multipleactiveaccountwithoutcaf-dialog.html',
                    controller: 'MultipleactiveaccountwithoutcafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Multipleactiveaccountwithoutcaf', function(Multipleactiveaccountwithoutcaf) {
                            return Multipleactiveaccountwithoutcaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('multipleactiveaccountwithoutcaf', null, { reload: 'multipleactiveaccountwithoutcaf' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('multipleactiveaccountwithoutcaf.delete', {
            parent: 'multipleactiveaccountwithoutcaf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleactiveaccountwithoutcaf/multipleactiveaccountwithoutcaf-delete-dialog.html',
                    controller: 'MultipleactiveaccountwithoutcafDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Multipleactiveaccountwithoutcaf', function(Multipleactiveaccountwithoutcaf) {
                            return Multipleactiveaccountwithoutcaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('multipleactiveaccountwithoutcaf', null, { reload: 'multipleactiveaccountwithoutcaf' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Multipleactiveaccountwithoutcaf', Multipleactiveaccountwithoutcaf);

    Multipleactiveaccountwithoutcaf.$inject = ['$resource'];

    function Multipleactiveaccountwithoutcaf ($resource) {
        var resourceUrl =  'api/multipleactiveaccountwithoutcafs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleactiveaccountwithoutcafController', MultipleactiveaccountwithoutcafController);

    MultipleactiveaccountwithoutcafController.$inject = ['Multipleactiveaccountwithoutcaf'];

    function MultipleactiveaccountwithoutcafController(Multipleactiveaccountwithoutcaf) {

        var vm = this;
        vm.deactivateAll = deactivateAll;

        vm.multipleactiveaccountwithoutcafs = [];

        loadAll();

        function loadAll() {
            Multipleactiveaccountwithoutcaf.query(function(result) {
                vm.multipleactiveaccountwithoutcafs = result;
                vm.searchQuery = null;
            });
        }

        function deactivateAll(){
            Multipleactiveaccountwithoutcaf.get({deactivateAll:''},function (result){
            if(result=true){
                alert("Deactivated Successfully.");
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleactiveaccountwithcafDialogController', MultipleactiveaccountwithcafDialogController);

    MultipleactiveaccountwithcafDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Multipleactiveaccountwithcaf'];

    function MultipleactiveaccountwithcafDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Multipleactiveaccountwithcaf) {
        var vm = this;

        vm.multipleactiveaccountwithcaf = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.multipleactiveaccountwithcaf.id !== null) {
                Multipleactiveaccountwithcaf.update(vm.multipleactiveaccountwithcaf, onSaveSuccess, onSaveError);
            } else {
                Multipleactiveaccountwithcaf.save(vm.multipleactiveaccountwithcaf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:multipleactiveaccountwithcafUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleactiveaccountwithcafDetailController', MultipleactiveaccountwithcafDetailController);

    MultipleactiveaccountwithcafDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Multipleactiveaccountwithcaf'];

    function MultipleactiveaccountwithcafDetailController($scope, $rootScope, $stateParams, previousState, entity, Multipleactiveaccountwithcaf) {
        var vm = this;

        vm.multipleactiveaccountwithcaf = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:multipleactiveaccountwithcafUpdate', function(event, result) {
            vm.multipleactiveaccountwithcaf = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleactiveaccountwithcafDeleteController',MultipleactiveaccountwithcafDeleteController);

    MultipleactiveaccountwithcafDeleteController.$inject = ['$uibModalInstance', 'entity', 'Multipleactiveaccountwithcaf'];

    function MultipleactiveaccountwithcafDeleteController($uibModalInstance, entity, Multipleactiveaccountwithcaf) {
        var vm = this;

        vm.multipleactiveaccountwithcaf = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Multipleactiveaccountwithcaf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('multipleactiveaccountwithcaf', {
            parent: 'entity',
            url: '/multipleactiveaccountwithcaf',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.multipleactiveaccountwithcaf.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/multipleactiveaccountwithcaf/multipleactiveaccountwithcafs.html',
                    controller: 'MultipleactiveaccountwithcafController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('multipleactiveaccountwithcaf');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('multipleactiveaccountwithcaf-detail', {
            parent: 'multipleactiveaccountwithcaf',
            url: '/multipleactiveaccountwithcaf/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.multipleactiveaccountwithcaf.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/multipleactiveaccountwithcaf/multipleactiveaccountwithcaf-detail.html',
                    controller: 'MultipleactiveaccountwithcafDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('multipleactiveaccountwithcaf');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Multipleactiveaccountwithcaf', function($stateParams, Multipleactiveaccountwithcaf) {
                    return Multipleactiveaccountwithcaf.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'multipleactiveaccountwithcaf',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('multipleactiveaccountwithcaf-detail.edit', {
            parent: 'multipleactiveaccountwithcaf-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleactiveaccountwithcaf/multipleactiveaccountwithcaf-dialog.html',
                    controller: 'MultipleactiveaccountwithcafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Multipleactiveaccountwithcaf', function(Multipleactiveaccountwithcaf) {
                            return Multipleactiveaccountwithcaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('multipleactiveaccountwithcaf.new', {
            parent: 'multipleactiveaccountwithcaf',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleactiveaccountwithcaf/multipleactiveaccountwithcaf-dialog.html',
                    controller: 'MultipleactiveaccountwithcafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                email: null,
                                login: null,
                                userId: null,
                                cafpin: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('multipleactiveaccountwithcaf', null, { reload: 'multipleactiveaccountwithcaf' });
                }, function() {
                    $state.go('multipleactiveaccountwithcaf');
                });
            }]
        })
        .state('multipleactiveaccountwithcaf.edit', {
            parent: 'multipleactiveaccountwithcaf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleactiveaccountwithcaf/multipleactiveaccountwithcaf-dialog.html',
                    controller: 'MultipleactiveaccountwithcafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Multipleactiveaccountwithcaf', function(Multipleactiveaccountwithcaf) {
                            return Multipleactiveaccountwithcaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('multipleactiveaccountwithcaf', null, { reload: 'multipleactiveaccountwithcaf' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('multipleactiveaccountwithcaf.delete', {
            parent: 'multipleactiveaccountwithcaf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multipleactiveaccountwithcaf/multipleactiveaccountwithcaf-delete-dialog.html',
                    controller: 'MultipleactiveaccountwithcafDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Multipleactiveaccountwithcaf', function(Multipleactiveaccountwithcaf) {
                            return Multipleactiveaccountwithcaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('multipleactiveaccountwithcaf', null, { reload: 'multipleactiveaccountwithcaf' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Multipleactiveaccountwithcaf', Multipleactiveaccountwithcaf);

    Multipleactiveaccountwithcaf.$inject = ['$resource'];

    function Multipleactiveaccountwithcaf ($resource) {
        var resourceUrl =  'api/multipleactiveaccountwithcafs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleactiveaccountwithcafController', MultipleactiveaccountwithcafController);

    MultipleactiveaccountwithcafController.$inject = ['Multipleactiveaccountwithcaf'];

    function MultipleactiveaccountwithcafController(Multipleactiveaccountwithcaf) {

        var vm = this;

        vm.multipleactiveaccountwithcafs = [];

        loadAll();

        function loadAll() {
            Multipleactiveaccountwithcaf.query(function(result) {
                vm.multipleactiveaccountwithcafs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleUserWithoutCafDialogController', MultipleUserWithoutCafDialogController);

    MultipleUserWithoutCafDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MultipleUserWithoutCaf'];

    function MultipleUserWithoutCafDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MultipleUserWithoutCaf) {
        var vm = this;

        vm.multipleUserWithoutCaf = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.multipleUserWithoutCaf.id !== null) {
                MultipleUserWithoutCaf.update(vm.multipleUserWithoutCaf, onSaveSuccess, onSaveError);
            } else {
                MultipleUserWithoutCaf.save(vm.multipleUserWithoutCaf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:multipleUserWithoutCafUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleUserWithoutCafDetailController', MultipleUserWithoutCafDetailController);

    MultipleUserWithoutCafDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MultipleUserWithoutCaf'];

    function MultipleUserWithoutCafDetailController($scope, $rootScope, $stateParams, previousState, entity, MultipleUserWithoutCaf) {
        var vm = this;

        vm.multipleUserWithoutCaf = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:multipleUserWithoutCafUpdate', function(event, result) {
            vm.multipleUserWithoutCaf = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleUserWithoutCafDeleteController',MultipleUserWithoutCafDeleteController);

    MultipleUserWithoutCafDeleteController.$inject = ['$uibModalInstance', 'entity', 'MultipleUserWithoutCaf'];

    function MultipleUserWithoutCafDeleteController($uibModalInstance, entity, MultipleUserWithoutCaf) {
        var vm = this;

        vm.multipleUserWithoutCaf = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MultipleUserWithoutCaf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('multiple-user-without-caf', {
            parent: 'entity',
            url: '/multiple-user-without-caf',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.multipleUserWithoutCaf.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/multiple-user-without-caf/multiple-user-without-cafs.html',
                    controller: 'MultipleUserWithoutCafController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('multipleUserWithoutCaf');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('multiple-user-without-caf-detail', {
            parent: 'multiple-user-without-caf',
            url: '/multiple-user-without-caf/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.multipleUserWithoutCaf.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/multiple-user-without-caf/multiple-user-without-caf-detail.html',
                    controller: 'MultipleUserWithoutCafDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('multipleUserWithoutCaf');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MultipleUserWithoutCaf', function($stateParams, MultipleUserWithoutCaf) {
                    return MultipleUserWithoutCaf.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'multiple-user-without-caf',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('multiple-user-without-caf-detail.edit', {
            parent: 'multiple-user-without-caf-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multiple-user-without-caf/multiple-user-without-caf-dialog.html',
                    controller: 'MultipleUserWithoutCafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MultipleUserWithoutCaf', function(MultipleUserWithoutCaf) {
                            return MultipleUserWithoutCaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('multiple-user-without-caf.new', {
            parent: 'multiple-user-without-caf',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multiple-user-without-caf/multiple-user-without-caf-dialog.html',
                    controller: 'MultipleUserWithoutCafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                userId: null,
                                login: null,
                                email: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('multiple-user-without-caf', null, { reload: 'multiple-user-without-caf' });
                }, function() {
                    $state.go('multiple-user-without-caf');
                });
            }]
        })
        .state('multiple-user-without-caf.edit', {
            parent: 'multiple-user-without-caf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multiple-user-without-caf/multiple-user-without-caf-dialog.html',
                    controller: 'MultipleUserWithoutCafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MultipleUserWithoutCaf', function(MultipleUserWithoutCaf) {
                            return MultipleUserWithoutCaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('multiple-user-without-caf', null, { reload: 'multiple-user-without-caf' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('multiple-user-without-caf.delete', {
            parent: 'multiple-user-without-caf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multiple-user-without-caf/multiple-user-without-caf-delete-dialog.html',
                    controller: 'MultipleUserWithoutCafDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MultipleUserWithoutCaf', function(MultipleUserWithoutCaf) {
                            return MultipleUserWithoutCaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('multiple-user-without-caf', null, { reload: 'multiple-user-without-caf' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MultipleUserWithoutCaf', MultipleUserWithoutCaf);

    MultipleUserWithoutCaf.$inject = ['$resource'];

    function MultipleUserWithoutCaf ($resource) {
        var resourceUrl =  'api/multiple-user-without-cafs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleUserWithoutCafController', MultipleUserWithoutCafController);

    MultipleUserWithoutCafController.$inject = ['MultipleUserWithoutCaf'];

    function MultipleUserWithoutCafController(MultipleUserWithoutCaf) {

        var vm = this;

        vm.multipleUserWithoutCafs = [];

        loadAll();

        function loadAll() {
            MultipleUserWithoutCaf.query(function(result) {
                vm.multipleUserWithoutCafs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleUserWithCafDialogController', MultipleUserWithCafDialogController);

    MultipleUserWithCafDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'MultipleUserWithCaf'];

    function MultipleUserWithCafDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, MultipleUserWithCaf) {
        var vm = this;

        vm.multipleUserWithCaf = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.multipleUserWithCaf.id !== null) {
                MultipleUserWithCaf.update(vm.multipleUserWithCaf, onSaveSuccess, onSaveError);
            } else {
                MultipleUserWithCaf.save(vm.multipleUserWithCaf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:multipleUserWithCafUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleUserWithCafDetailController', MultipleUserWithCafDetailController);

    MultipleUserWithCafDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'MultipleUserWithCaf'];

    function MultipleUserWithCafDetailController($scope, $rootScope, $stateParams, previousState, entity, MultipleUserWithCaf) {
        var vm = this;

        vm.multipleUserWithCaf = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:multipleUserWithCafUpdate', function(event, result) {
            vm.multipleUserWithCaf = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleUserWithCafDeleteController',MultipleUserWithCafDeleteController);

    MultipleUserWithCafDeleteController.$inject = ['$uibModalInstance', 'entity', 'MultipleUserWithCaf'];

    function MultipleUserWithCafDeleteController($uibModalInstance, entity, MultipleUserWithCaf) {
        var vm = this;

        vm.multipleUserWithCaf = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            MultipleUserWithCaf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('multiple-user-with-caf', {
            parent: 'entity',
            url: '/multiple-user-with-caf',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.multipleUserWithCaf.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/multiple-user-with-caf/multiple-user-with-cafs.html',
                    controller: 'MultipleUserWithCafController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('multipleUserWithCaf');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('multiple-user-with-caf-detail', {
            parent: 'multiple-user-with-caf',
            url: '/multiple-user-with-caf/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.multipleUserWithCaf.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/multiple-user-with-caf/multiple-user-with-caf-detail.html',
                    controller: 'MultipleUserWithCafDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('multipleUserWithCaf');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'MultipleUserWithCaf', function($stateParams, MultipleUserWithCaf) {
                    return MultipleUserWithCaf.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'multiple-user-with-caf',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('multiple-user-with-caf-detail.edit', {
            parent: 'multiple-user-with-caf-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multiple-user-with-caf/multiple-user-with-caf-dialog.html',
                    controller: 'MultipleUserWithCafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MultipleUserWithCaf', function(MultipleUserWithCaf) {
                            return MultipleUserWithCaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('multiple-user-with-caf.new', {
            parent: 'multiple-user-with-caf',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multiple-user-with-caf/multiple-user-with-caf-dialog.html',
                    controller: 'MultipleUserWithCafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                userId: null,
                                login: null,
                                email: null,
                                cafpin: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('multiple-user-with-caf', null, { reload: 'multiple-user-with-caf' });
                }, function() {
                    $state.go('multiple-user-with-caf');
                });
            }]
        })
        .state('multiple-user-with-caf.edit', {
            parent: 'multiple-user-with-caf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multiple-user-with-caf/multiple-user-with-caf-dialog.html',
                    controller: 'MultipleUserWithCafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['MultipleUserWithCaf', function(MultipleUserWithCaf) {
                            return MultipleUserWithCaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('multiple-user-with-caf', null, { reload: 'multiple-user-with-caf' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('multiple-user-with-caf.delete', {
            parent: 'multiple-user-with-caf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/multiple-user-with-caf/multiple-user-with-caf-delete-dialog.html',
                    controller: 'MultipleUserWithCafDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['MultipleUserWithCaf', function(MultipleUserWithCaf) {
                            return MultipleUserWithCaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('multiple-user-with-caf', null, { reload: 'multiple-user-with-caf' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('MultipleUserWithCaf', MultipleUserWithCaf);

    MultipleUserWithCaf.$inject = ['$resource'];

    function MultipleUserWithCaf ($resource) {
        var resourceUrl =  'api/multiple-user-with-cafs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MultipleUserWithCafController', MultipleUserWithCafController);

    MultipleUserWithCafController.$inject = ['MultipleUserWithCaf'];

    function MultipleUserWithCafController(MultipleUserWithCaf) {

        var vm = this;

        vm.multipleUserWithCafs = [];

        loadAll();

        function loadAll() {
            MultipleUserWithCaf.query(function(result) {
                vm.multipleUserWithCafs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Modeofdisposalfor_dischargeDialogController', Modeofdisposalfor_dischargeDialogController);

    Modeofdisposalfor_dischargeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Modeofdisposalfor_discharge'];

    function Modeofdisposalfor_dischargeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Modeofdisposalfor_discharge) {
        var vm = this;

        vm.modeofdisposalfor_discharge = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.modeofdisposalfor_discharge.id !== null) {
                Modeofdisposalfor_discharge.update(vm.modeofdisposalfor_discharge, onSaveSuccess, onSaveError);
            } else {
                Modeofdisposalfor_discharge.save(vm.modeofdisposalfor_discharge, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:modeofdisposalfor_dischargeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Modeofdisposalfor_dischargeDetailController', Modeofdisposalfor_dischargeDetailController);

    Modeofdisposalfor_dischargeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Modeofdisposalfor_discharge'];

    function Modeofdisposalfor_dischargeDetailController($scope, $rootScope, $stateParams, previousState, entity, Modeofdisposalfor_discharge) {
        var vm = this;

        vm.modeofdisposalfor_discharge = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:modeofdisposalfor_dischargeUpdate', function(event, result) {
            vm.modeofdisposalfor_discharge = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Modeofdisposalfor_dischargeDeleteController',Modeofdisposalfor_dischargeDeleteController);

    Modeofdisposalfor_dischargeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Modeofdisposalfor_discharge'];

    function Modeofdisposalfor_dischargeDeleteController($uibModalInstance, entity, Modeofdisposalfor_discharge) {
        var vm = this;

        vm.modeofdisposalfor_discharge = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Modeofdisposalfor_discharge.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modeofdisposalfor-discharge', {
            parent: 'entity',
            url: '/modeofdisposalfor-discharge',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.modeofdisposalfor_discharge.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modeofdisposalfor-discharge/modeofdisposalfor-discharges.html',
                    controller: 'Modeofdisposalfor_dischargeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modeofdisposalfor_discharge');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('modeofdisposalfor-discharge-detail', {
            parent: 'modeofdisposalfor-discharge',
            url: '/modeofdisposalfor-discharge/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.modeofdisposalfor_discharge.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modeofdisposalfor-discharge/modeofdisposalfor-discharge-detail.html',
                    controller: 'Modeofdisposalfor_dischargeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modeofdisposalfor_discharge');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Modeofdisposalfor_discharge', function($stateParams, Modeofdisposalfor_discharge) {
                    return Modeofdisposalfor_discharge.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'modeofdisposalfor-discharge',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('modeofdisposalfor-discharge-detail.edit', {
            parent: 'modeofdisposalfor-discharge-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modeofdisposalfor-discharge/modeofdisposalfor-discharge-dialog.html',
                    controller: 'Modeofdisposalfor_dischargeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modeofdisposalfor_discharge', function(Modeofdisposalfor_discharge) {
                            return Modeofdisposalfor_discharge.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modeofdisposalfor-discharge.new', {
            parent: 'modeofdisposalfor-discharge',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modeofdisposalfor-discharge/modeofdisposalfor-discharge-dialog.html',
                    controller: 'Modeofdisposalfor_dischargeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                disposal_for_discharge: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modeofdisposalfor-discharge', null, { reload: 'modeofdisposalfor-discharge' });
                }, function() {
                    $state.go('modeofdisposalfor-discharge');
                });
            }]
        })
        .state('modeofdisposalfor-discharge.edit', {
            parent: 'modeofdisposalfor-discharge',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modeofdisposalfor-discharge/modeofdisposalfor-discharge-dialog.html',
                    controller: 'Modeofdisposalfor_dischargeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modeofdisposalfor_discharge', function(Modeofdisposalfor_discharge) {
                            return Modeofdisposalfor_discharge.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modeofdisposalfor-discharge', null, { reload: 'modeofdisposalfor-discharge' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('modeofdisposalfor-discharge.delete', {
            parent: 'modeofdisposalfor-discharge',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modeofdisposalfor-discharge/modeofdisposalfor-discharge-delete-dialog.html',
                    controller: 'Modeofdisposalfor_dischargeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Modeofdisposalfor_discharge', function(Modeofdisposalfor_discharge) {
                            return Modeofdisposalfor_discharge.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modeofdisposalfor-discharge', null, { reload: 'modeofdisposalfor-discharge' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Modeofdisposalfor_discharge', Modeofdisposalfor_discharge);

    Modeofdisposalfor_discharge.$inject = ['$resource'];

    function Modeofdisposalfor_discharge ($resource) {
        var resourceUrl =  'api/modeofdisposalfor-discharges/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Modeofdisposalfor_dischargeController', Modeofdisposalfor_dischargeController);

    Modeofdisposalfor_dischargeController.$inject = ['Modeofdisposalfor_discharge'];

    function Modeofdisposalfor_dischargeController(Modeofdisposalfor_discharge) {

        var vm = this;

        vm.modeofdisposalfor_discharges = [];

        loadAll();

        function loadAll() {
            Modeofdisposalfor_discharge.query(function(result) {
                vm.modeofdisposalfor_discharges = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MinutesofmeetingDialogController', MinutesofmeetingDialogController);

    MinutesofmeetingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Minutesofmeeting','FileManagement'];

    function MinutesofmeetingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Minutesofmeeting,FileManagement) {
        var vm = this;

        vm.minutesofmeeting = entity;
        vm.clear = clear;
        vm.save = save;
        $scope.file = {};

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;


        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            // console.log(vm.minutesofmeeting);
            vm.isSaving = true;
            if (vm.minutesofmeeting.id !== null) {
                Minutesofmeeting.update(vm.minutesofmeeting, onSaveSuccess, onSaveError);
            } else {
                Minutesofmeeting.save(vm.minutesofmeeting, onSaveSuccess, onSaveError);
            }
        }

        vm.update= function () {
            // console.log(vm.minutesofmeeting);
            Minutesofmeeting.update(vm.minutesofmeeting);
            $uibModalInstance.dismiss('cancel');
        };

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:minutesofmeetingUpdate', result);
            var filename = result.id;
            var file = vm.mintuesofmeeting.file;
            FileManagement.saveFile(file,filename);

            var fileNameArray = vm.mintuesofmeeting.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var downloadfilename=result.momdescription;
            var serverfilename=result.id;

            if(fileextension!=="")
            {
                downloadfilename=downloadfilename+"."+fileextension;
                serverfilename=serverfilename+"."+fileextension;
            }
            console.log(downloadfilename);
            result.downloadfilename=downloadfilename;

            console.log(serverfilename);
            result.serverfilename=serverfilename;

            console.log(result);

            Minutesofmeeting.update(result,onUpdateSuccess,onUpdateError);
        }

        function onUpdateSuccess(result)
        {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }
        function onUpdateError () {
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MinutesofmeetingDetailController', MinutesofmeetingDetailController);

    MinutesofmeetingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Minutesofmeeting'];

    function MinutesofmeetingDetailController($scope, $rootScope, $stateParams, previousState, entity, Minutesofmeeting) {
        var vm = this;

        vm.minutesofmeeting = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:minutesofmeetingUpdate', function(event, result) {
            vm.minutesofmeeting = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MinutesofmeetingDeleteController',MinutesofmeetingDeleteController);

    MinutesofmeetingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Minutesofmeeting'];

    function MinutesofmeetingDeleteController($uibModalInstance, entity, Minutesofmeeting) {
        var vm = this;

        vm.minutesofmeeting = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Minutesofmeeting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('minutesofmeeting', {
            parent: 'entity',
            url: '/minutesofmeeting',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER'],
                pageTitle: 'investhryApp.minutesofmeeting.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/minutesofmeeting/minutesofmeetings.html',
                    controller: 'MinutesofmeetingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('minutesofmeeting');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('minutesofmeeting-detail', {
            parent: 'minutesofmeeting',
            url: '/minutesofmeeting/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER'],
                pageTitle: 'investhryApp.minutesofmeeting.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/minutesofmeeting/minutesofmeeting-detail.html',
                    controller: 'MinutesofmeetingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('minutesofmeeting');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Minutesofmeeting', function($stateParams, Minutesofmeeting) {
                    return Minutesofmeeting.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'minutesofmeeting',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('minutesofmeeting-detail.edit', {
            parent: 'minutesofmeeting-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/minutesofmeeting/minutesofmeeting-dialog.html',
                    controller: 'MinutesofmeetingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Minutesofmeeting', function(Minutesofmeeting) {
                            return Minutesofmeeting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('minutesofmeeting.new', {
            parent: 'minutesofmeeting',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/minutesofmeeting/minutesofmeeting-dialog.html',
                    controller: 'MinutesofmeetingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                momdescription: null,
                                downloadfilename: null,
                                serverfilename: null,
                                meeting_type: null,
                                date: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('minutesofmeeting', null, { reload: 'minutesofmeeting' });
                }, function() {
                    $state.go('minutesofmeeting');
                });
            }]
        })
        .state('minutesofmeeting.edit', {
            parent: 'minutesofmeeting',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/minutesofmeeting/minutesofmeeting-edit.html',
                    controller: 'MinutesofmeetingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Minutesofmeeting', function(Minutesofmeeting) {
                            return Minutesofmeeting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('minutesofmeeting', null, { reload: 'minutesofmeeting' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('minutesofmeeting.delete', {
            parent: 'minutesofmeeting',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/minutesofmeeting/minutesofmeeting-delete-dialog.html',
                    controller: 'MinutesofmeetingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Minutesofmeeting', function(Minutesofmeeting) {
                            return Minutesofmeeting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('minutesofmeeting', null, { reload: 'minutesofmeeting' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Minutesofmeeting', Minutesofmeeting);

    Minutesofmeeting.$inject = ['$resource'];

    function Minutesofmeeting ($resource) {
        var resourceUrl =  'api/minutesofmeetings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('MinutesofmeetingController', MinutesofmeetingController);

    MinutesofmeetingController.$inject = ['Minutesofmeeting'];

    function MinutesofmeetingController(Minutesofmeeting) {

        var vm = this;

        vm.minutesofmeetings = [];

        loadAll();

        function loadAll() {
            Minutesofmeeting.query(function(result) {
                vm.minutesofmeetings = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Meeting_attendeeDialogController', Meeting_attendeeDialogController);

    Meeting_attendeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Meeting_attendee'];

    function Meeting_attendeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Meeting_attendee) {
        var vm = this;

        vm.meeting_attendee = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.meeting_attendee.id !== null) {
                Meeting_attendee.update(vm.meeting_attendee, onSaveSuccess, onSaveError);
            } else {
                Meeting_attendee.save(vm.meeting_attendee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:meeting_attendeeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Meeting_attendeeDetailController', Meeting_attendeeDetailController);

    Meeting_attendeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Meeting_attendee'];

    function Meeting_attendeeDetailController($scope, $rootScope, $stateParams, previousState, entity, Meeting_attendee) {
        var vm = this;

        vm.meeting_attendee = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:meeting_attendeeUpdate', function(event, result) {
            vm.meeting_attendee = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Meeting_attendeeDeleteController',Meeting_attendeeDeleteController);

    Meeting_attendeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Meeting_attendee'];

    function Meeting_attendeeDeleteController($uibModalInstance, entity, Meeting_attendee) {
        var vm = this;

        vm.meeting_attendee = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Meeting_attendee.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('meeting-attendee', {
            parent: 'entity',
            url: '/meeting-attendee',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER'],
                pageTitle: 'investhryApp.meeting_attendee.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/meeting-attendee/meeting-attendees.html',
                    controller: 'Meeting_attendeeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('meeting_attendee');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('meeting-attendee-detail', {
            parent: 'meeting-attendee',
            url: '/meeting-attendee/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER'],
                pageTitle: 'investhryApp.meeting_attendee.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/meeting-attendee/meeting-attendee-detail.html',
                    controller: 'Meeting_attendeeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('meeting_attendee');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Meeting_attendee', function($stateParams, Meeting_attendee) {
                    return Meeting_attendee.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'meeting-attendee',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('meeting-attendee-detail.edit', {
            parent: 'meeting-attendee-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/meeting-attendee/meeting-attendee-dialog.html',
                    controller: 'Meeting_attendeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Meeting_attendee', function(Meeting_attendee) {
                            return Meeting_attendee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('meeting-attendee.new', {
            parent: 'meeting-attendee',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/meeting-attendee/meeting-attendee-dialog.html',
                    controller: 'Meeting_attendeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                attendee_name: null,
                                department: null,
                                mobile_no: null,
                                email_id: null,
                                team: null,
                                id: null,
                                isinvited: true,
                                ispresent: false
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('meeting-attendee', null, { reload: 'meeting-attendee' });
                }, function() {
                    $state.go('meeting-attendee');
                });
            }]
        })
        .state('meeting-attendee.edit', {
            parent: 'meeting-attendee',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/meeting-attendee/meeting-attendee-dialog.html',
                    controller: 'Meeting_attendeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Meeting_attendee', function(Meeting_attendee) {
                            return Meeting_attendee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('meeting-attendee', null, { reload: 'meeting-attendee' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('meeting-attendee.delete', {
            parent: 'meeting-attendee',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/meeting-attendee/meeting-attendee-delete-dialog.html',
                    controller: 'Meeting_attendeeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Meeting_attendee', function(Meeting_attendee) {
                            return Meeting_attendee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('meeting-attendee', null, { reload: 'meeting-attendee' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Meeting_attendee', Meeting_attendee);

    Meeting_attendee.$inject = ['$resource'];

    function Meeting_attendee ($resource) {
        var resourceUrl =  'api/meeting-attendees/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Meeting_attendeeController', Meeting_attendeeController);

    Meeting_attendeeController.$inject = ['Meeting_attendee'];

    function Meeting_attendeeController(Meeting_attendee) {

        var vm = this;

        vm.meeting_attendees = [];

        loadAll();

        function loadAll() {
            Meeting_attendee.query(function(result) {
                vm.meeting_attendees = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Meeting_attendanceDialogController', Meeting_attendanceDialogController);

    Meeting_attendanceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Meeting_attendance', 'Meeting_attendee','$filter'];

    function Meeting_attendanceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Meeting_attendance, Meeting_attendee,$filter) {
        var vm = this;

        vm.meeting_attendance = entity;
        vm.clear = clear;

        loadAll();

        function loadAll() {
            Meeting_attendee.query(function(result) {
                vm.meeting_attendees = result;
                vm.searchQuery = null;
            });
        }

        // $scope.toggleAll = function() {
        //     var toggleStatus = $scope.isAllSelected;
        //     angular.forEach( vm.meeting_attendees, function(itm){ itm.ispresent = toggleStatus; });
        //     console.log(vm.meeting_attendees);
        // };

        $scope.optionToggled = function(type,index){
            if(type==='present'){
                    vm.meeting_attendees[index].ispresent = true;
                    vm.meeting_attendees[index].onleave = false;
                    vm.meeting_attendees[index].ontour = false;
            }
            else if(type==='leave'){
                vm.meeting_attendees[index].ispresent = false;
                vm.meeting_attendees[index].onleave = true;
                vm.meeting_attendees[index].ontour = false;
            }
            else if(type==='tour'){
                vm.meeting_attendees[index].ispresent = false;
                vm.meeting_attendees[index].onleave = false;
                vm.meeting_attendees[index].ontour = true;
            }
        };

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            var meeting_date= $filter('date')(vm.meeting_attendance.meeting_date,'dd-MM-yyyy');
            Meeting_attendance.save({date: meeting_date}, vm.meeting_attendees,onSaveSuccess(),onSaveError());
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:meeting_attendanceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false ;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.meeting_date = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Meeting_attendanceDetailController', Meeting_attendanceDetailController);

    Meeting_attendanceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Meeting_attendance'];

    function Meeting_attendanceDetailController($scope, $rootScope, $stateParams, previousState, entity, Meeting_attendance) {
        var vm = this;

        vm.meeting_attendance = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:meeting_attendanceUpdate', function(event, result) {
            vm.meeting_attendance = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Meeting_attendanceDeleteController',Meeting_attendanceDeleteController);

    Meeting_attendanceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Meeting_attendance'];

    function Meeting_attendanceDeleteController($uibModalInstance, entity, Meeting_attendance) {
        var vm = this;

        vm.meeting_attendance = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Meeting_attendance.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('meeting-attendance', {
            parent: 'entity',
            url: '/meeting-attendance',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER'],
                pageTitle: 'investhryApp.meeting_attendance.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/meeting-attendance/meeting-attendances.html',
                    controller: 'Meeting_attendanceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('meeting_attendance');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('meeting-attendance-detail', {
            parent: 'meeting-attendance',
            url: '/meeting-attendance/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER'],
                pageTitle: 'investhryApp.meeting_attendance.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/meeting-attendance/meeting-attendance-detail.html',
                    controller: 'Meeting_attendanceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('meeting_attendance');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Meeting_attendance', function($stateParams, Meeting_attendance) {
                    return Meeting_attendance.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'meeting-attendance',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('meeting-attendance-detail.edit', {
            parent: 'meeting-attendance-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/meeting-attendance/meeting-attendance-dialog.html',
                    controller: 'Meeting_attendanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Meeting_attendance', function(Meeting_attendance) {
                            return Meeting_attendance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('meeting-attendance.new', {
            parent: 'meeting-attendance',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/meeting-attendance/meeting-attendance-dialog.html',
                    controller: 'Meeting_attendanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                attendee_id: null,
                                meeting_date: null,
                                ispresent: false,
                                isinvited: true,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('meeting-attendance', null, { reload: 'meeting-attendance' });
                }, function() {
                    $state.go('meeting-attendance');
                });
            }]
        })
        .state('meeting-attendance.edit', {
            parent: 'meeting-attendance',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/meeting-attendance/meeting-attendance-dialog.html',
                    controller: 'Meeting_attendanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Meeting_attendance', function(Meeting_attendance) {
                            return Meeting_attendance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('meeting-attendance', null, { reload: 'meeting-attendance' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('meeting-attendance.delete', {
            parent: 'meeting-attendance',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/meeting-attendance/meeting-attendance-delete-dialog.html',
                    controller: 'Meeting_attendanceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Meeting_attendance', function(Meeting_attendance) {
                            return Meeting_attendance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('meeting-attendance', null, { reload: 'meeting-attendance' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Meeting_attendance', Meeting_attendance);

    Meeting_attendance.$inject = ['$resource', 'DateUtils'];

    function Meeting_attendance ($resource, DateUtils) {
        var resourceUrl =  'api/meeting-attendances';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.meeting_date = DateUtils.convertLocalDateFromServer(data.meeting_date);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.meeting_date = DateUtils.convertLocalDateToServer(copy.meeting_date);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.meeting_date = DateUtils.convertLocalDateToServer(copy.meeting_date);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Meeting_attendanceController', Meeting_attendanceController);

    Meeting_attendanceController.$inject = ['Meeting_attendance', '$filter', '$scope'];

    function Meeting_attendanceController(Meeting_attendance, $filter, $scope) {

        var vm = this;
        vm.AttendanceByDate= AttendanceByDate;
        vm.AttendanceDate = 'empty';

        vm.meeting_attendances = [];

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;

        $scope.toggle_attendance='present';

        $scope.toggle_attendance_function= function (value) {
            $scope.toggle_attendance= value;
        };

        loadAll();

        function loadAll() {
            Meeting_attendance.query(function(result) {
                vm.meeting_attendances = result;
                vm.searchQuery = null;
            });
        }

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function AttendanceByDate() {
            var meeting_date= $filter('date')(vm.AttendanceDate,'dd-MM-yyyy');
            Meeting_attendance.query({date: meeting_date},function (result) {
               vm.meeting_attendees=result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ManufacturingunitsDialogController', ManufacturingunitsDialogController);

    ManufacturingunitsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Manufacturingunits'];

    function ManufacturingunitsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Manufacturingunits) {
        var vm = this;

        vm.manufacturingunits = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.manufacturingunits.id !== null) {
                Manufacturingunits.update(vm.manufacturingunits, onSaveSuccess, onSaveError);
            } else {
                Manufacturingunits.save(vm.manufacturingunits, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:manufacturingunitsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ManufacturingunitsDetailController', ManufacturingunitsDetailController);

    ManufacturingunitsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Manufacturingunits'];

    function ManufacturingunitsDetailController($scope, $rootScope, $stateParams, previousState, entity, Manufacturingunits) {
        var vm = this;

        vm.manufacturingunits = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:manufacturingunitsUpdate', function(event, result) {
            vm.manufacturingunits = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ManufacturingunitsDeleteController',ManufacturingunitsDeleteController);

    ManufacturingunitsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Manufacturingunits'];

    function ManufacturingunitsDeleteController($uibModalInstance, entity, Manufacturingunits) {
        var vm = this;

        vm.manufacturingunits = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Manufacturingunits.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manufacturingunits', {
            parent: 'entity',
            url: '/manufacturingunits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.manufacturingunits.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manufacturingunits/manufacturingunits.html',
                    controller: 'ManufacturingunitsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manufacturingunits');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('manufacturingunits-detail', {
            parent: 'manufacturingunits',
            url: '/manufacturingunits/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.manufacturingunits.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manufacturingunits/manufacturingunits-detail.html',
                    controller: 'ManufacturingunitsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manufacturingunits');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Manufacturingunits', function($stateParams, Manufacturingunits) {
                    return Manufacturingunits.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'manufacturingunits',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('manufacturingunits-detail.edit', {
            parent: 'manufacturingunits-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manufacturingunits/manufacturingunits-dialog.html',
                    controller: 'ManufacturingunitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Manufacturingunits', function(Manufacturingunits) {
                            return Manufacturingunits.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manufacturingunits.new', {
            parent: 'manufacturingunits',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manufacturingunits/manufacturingunits-dialog.html',
                    controller: 'ManufacturingunitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                unittypes: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('manufacturingunits', null, { reload: 'manufacturingunits' });
                }, function() {
                    $state.go('manufacturingunits');
                });
            }]
        })
        .state('manufacturingunits.edit', {
            parent: 'manufacturingunits',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manufacturingunits/manufacturingunits-dialog.html',
                    controller: 'ManufacturingunitsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Manufacturingunits', function(Manufacturingunits) {
                            return Manufacturingunits.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manufacturingunits', null, { reload: 'manufacturingunits' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manufacturingunits.delete', {
            parent: 'manufacturingunits',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manufacturingunits/manufacturingunits-delete-dialog.html',
                    controller: 'ManufacturingunitsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Manufacturingunits', function(Manufacturingunits) {
                            return Manufacturingunits.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manufacturingunits', null, { reload: 'manufacturingunits' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Manufacturingunits', Manufacturingunits);

    Manufacturingunits.$inject = ['$resource'];

    function Manufacturingunits ($resource) {
        var resourceUrl =  'api/manufacturingunits/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ManufacturingunitsController', ManufacturingunitsController);

    ManufacturingunitsController.$inject = ['Manufacturingunits'];

    function ManufacturingunitsController(Manufacturingunits) {

        var vm = this;

        vm.manufacturingunits = [];

        loadAll();

        function loadAll() {
            Manufacturingunits.query(function(result) {
                vm.manufacturingunits = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ManufacturingdetailDialogController', ManufacturingdetailDialogController);

    ManufacturingdetailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Manufacturingdetail'];

    function ManufacturingdetailDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Manufacturingdetail) {
        var vm = this;

        vm.manufacturingdetail = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.manufacturingdetail.id !== null) {
                Manufacturingdetail.update(vm.manufacturingdetail, onSaveSuccess, onSaveError);
            } else {
                Manufacturingdetail.save(vm.manufacturingdetail, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:manufacturingdetailUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ManufacturingdetailDetailController', ManufacturingdetailDetailController);

    ManufacturingdetailDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Manufacturingdetail'];

    function ManufacturingdetailDetailController($scope, $rootScope, $stateParams, previousState, entity, Manufacturingdetail) {
        var vm = this;

        vm.manufacturingdetail = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:manufacturingdetailUpdate', function(event, result) {
            vm.manufacturingdetail = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ManufacturingdetailDeleteController',ManufacturingdetailDeleteController);

    ManufacturingdetailDeleteController.$inject = ['$uibModalInstance', 'entity', 'Manufacturingdetail'];

    function ManufacturingdetailDeleteController($uibModalInstance, entity, Manufacturingdetail) {
        var vm = this;

        vm.manufacturingdetail = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Manufacturingdetail.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('manufacturingdetail', {
            parent: 'entity',
            url: '/manufacturingdetail',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.manufacturingdetail.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manufacturingdetail/manufacturingdetails.html',
                    controller: 'ManufacturingdetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manufacturingdetail');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('manufacturingdetail-detail', {
            parent: 'manufacturingdetail',
            url: '/manufacturingdetail/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.manufacturingdetail.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/manufacturingdetail/manufacturingdetail-detail.html',
                    controller: 'ManufacturingdetailDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('manufacturingdetail');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Manufacturingdetail', function($stateParams, Manufacturingdetail) {
                    return Manufacturingdetail.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'manufacturingdetail',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('manufacturingdetail-detail.edit', {
            parent: 'manufacturingdetail-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manufacturingdetail/manufacturingdetail-dialog.html',
                    controller: 'ManufacturingdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Manufacturingdetail', function(Manufacturingdetail) {
                            return Manufacturingdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manufacturingdetail.new', {
            parent: 'manufacturingdetail',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manufacturingdetail/manufacturingdetail-dialog.html',
                    controller: 'ManufacturingdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                projectrawmaterialid: null,
                                productid: null,
                                processid: null,
                                manufacturing_flow_document: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('manufacturingdetail', null, { reload: 'manufacturingdetail' });
                }, function() {
                    $state.go('manufacturingdetail');
                });
            }]
        })
        .state('manufacturingdetail.edit', {
            parent: 'manufacturingdetail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manufacturingdetail/manufacturingdetail-dialog.html',
                    controller: 'ManufacturingdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Manufacturingdetail', function(Manufacturingdetail) {
                            return Manufacturingdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manufacturingdetail', null, { reload: 'manufacturingdetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('manufacturingdetail.delete', {
            parent: 'manufacturingdetail',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/manufacturingdetail/manufacturingdetail-delete-dialog.html',
                    controller: 'ManufacturingdetailDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Manufacturingdetail', function(Manufacturingdetail) {
                            return Manufacturingdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('manufacturingdetail', null, { reload: 'manufacturingdetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Manufacturingdetail', Manufacturingdetail);

    Manufacturingdetail.$inject = ['$resource'];

    function Manufacturingdetail ($resource) {
        var resourceUrl =  'api/manufacturingdetails/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ManufacturingdetailController', ManufacturingdetailController);

    ManufacturingdetailController.$inject = ['Manufacturingdetail'];

    function ManufacturingdetailController(Manufacturingdetail) {

        var vm = this;

        vm.manufacturingdetails = [];

        loadAll();

        function loadAll() {
            Manufacturingdetail.query(function(result) {
                vm.manufacturingdetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandusezoneclassificationDialogController', LandusezoneclassificationDialogController);

    LandusezoneclassificationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Landusezoneclassification'];

    function LandusezoneclassificationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Landusezoneclassification) {
        var vm = this;

        vm.landusezoneclassification = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.landusezoneclassification.id !== null) {
                Landusezoneclassification.update(vm.landusezoneclassification, onSaveSuccess, onSaveError);
            } else {
                Landusezoneclassification.save(vm.landusezoneclassification, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:landusezoneclassificationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandusezoneclassificationDetailController', LandusezoneclassificationDetailController);

    LandusezoneclassificationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Landusezoneclassification'];

    function LandusezoneclassificationDetailController($scope, $rootScope, $stateParams, previousState, entity, Landusezoneclassification) {
        var vm = this;

        vm.landusezoneclassification = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:landusezoneclassificationUpdate', function(event, result) {
            vm.landusezoneclassification = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandusezoneclassificationDeleteController',LandusezoneclassificationDeleteController);

    LandusezoneclassificationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Landusezoneclassification'];

    function LandusezoneclassificationDeleteController($uibModalInstance, entity, Landusezoneclassification) {
        var vm = this;

        vm.landusezoneclassification = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Landusezoneclassification.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('landusezoneclassification', {
            parent: 'entity',
            url: '/landusezoneclassification',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.landusezoneclassification.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/landusezoneclassification/landusezoneclassifications.html',
                    controller: 'LandusezoneclassificationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('landusezoneclassification');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('landusezoneclassification-detail', {
            parent: 'landusezoneclassification',
            url: '/landusezoneclassification/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.landusezoneclassification.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/landusezoneclassification/landusezoneclassification-detail.html',
                    controller: 'LandusezoneclassificationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('landusezoneclassification');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Landusezoneclassification', function($stateParams, Landusezoneclassification) {
                    return Landusezoneclassification.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'landusezoneclassification',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('landusezoneclassification-detail.edit', {
            parent: 'landusezoneclassification-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landusezoneclassification/landusezoneclassification-dialog.html',
                    controller: 'LandusezoneclassificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Landusezoneclassification', function(Landusezoneclassification) {
                            return Landusezoneclassification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('landusezoneclassification.new', {
            parent: 'landusezoneclassification',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landusezoneclassification/landusezoneclassification-dialog.html',
                    controller: 'LandusezoneclassificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                landzoneclassificationtype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('landusezoneclassification', null, { reload: 'landusezoneclassification' });
                }, function() {
                    $state.go('landusezoneclassification');
                });
            }]
        })
        .state('landusezoneclassification.edit', {
            parent: 'landusezoneclassification',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landusezoneclassification/landusezoneclassification-dialog.html',
                    controller: 'LandusezoneclassificationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Landusezoneclassification', function(Landusezoneclassification) {
                            return Landusezoneclassification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('landusezoneclassification', null, { reload: 'landusezoneclassification' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('landusezoneclassification.delete', {
            parent: 'landusezoneclassification',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landusezoneclassification/landusezoneclassification-delete-dialog.html',
                    controller: 'LandusezoneclassificationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Landusezoneclassification', function(Landusezoneclassification) {
                            return Landusezoneclassification.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('landusezoneclassification', null, { reload: 'landusezoneclassification' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Landusezoneclassification', Landusezoneclassification);

    Landusezoneclassification.$inject = ['$resource'];

    function Landusezoneclassification ($resource) {
        var resourceUrl =  'api/landusezoneclassifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandusezoneclassificationController', LandusezoneclassificationController);

    LandusezoneclassificationController.$inject = ['Landusezoneclassification'];

    function LandusezoneclassificationController(Landusezoneclassification) {

        var vm = this;

        vm.landusezoneclassifications = [];

        loadAll();

        function loadAll() {
            Landusezoneclassification.query(function(result){
                vm.landusezoneclassifications = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandrequirementcafDialogController', LandrequirementcafDialogController);

    LandrequirementcafDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Landrequirementcaf'];

    function LandrequirementcafDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Landrequirementcaf) {
        var vm = this;

        vm.landrequirementcaf = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.landrequirementcaf.id !== null) {
                Landrequirementcaf.update(vm.landrequirementcaf, onSaveSuccess, onSaveError);
            } else {
                Landrequirementcaf.save(vm.landrequirementcaf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:landrequirementcafUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandrequirementcafDetailController', LandrequirementcafDetailController);

    LandrequirementcafDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Landrequirementcaf'];

    function LandrequirementcafDetailController($scope, $rootScope, $stateParams, previousState, entity, Landrequirementcaf) {
        var vm = this;

        vm.landrequirementcaf = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:landrequirementcafUpdate', function(event, result) {
            vm.landrequirementcaf = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandrequirementcafDeleteController',LandrequirementcafDeleteController);

    LandrequirementcafDeleteController.$inject = ['$uibModalInstance', 'entity', 'Landrequirementcaf'];

    function LandrequirementcafDeleteController($uibModalInstance, entity, Landrequirementcaf) {
        var vm = this;

        vm.landrequirementcaf = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Landrequirementcaf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('landrequirementcaf', {
            parent: 'entity',
            url: '/landrequirementcaf',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.landrequirementcaf.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/landrequirementcaf/landrequirementcafs.html',
                    controller: 'LandrequirementcafController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('landrequirementcaf');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('landrequirementcaf-detail', {
            parent: 'landrequirementcaf',
            url: '/landrequirementcaf/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.landrequirementcaf.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/landrequirementcaf/landrequirementcaf-detail.html',
                    controller: 'LandrequirementcafDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('landrequirementcaf');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Landrequirementcaf', function($stateParams, Landrequirementcaf) {
                    return Landrequirementcaf.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'landrequirementcaf',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('landrequirementcaf-detail.edit', {
            parent: 'landrequirementcaf-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landrequirementcaf/landrequirementcaf-dialog.html',
                    controller: 'LandrequirementcafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Landrequirementcaf', function(Landrequirementcaf) {
                            return Landrequirementcaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('landrequirementcaf.new', {
            parent: 'landrequirementcaf',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landrequirementcaf/landrequirementcaf-dialog.html',
                    controller: 'LandrequirementcafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                landrequired: null,
                                plotsize: null,
                                estatename: null,
                                purchaserate: null,
                                estatelocation: null,
                                agencyname: null,
                                village: null,
                                tehsil: null,
                                district: null,
                                landusetype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('landrequirementcaf', null, { reload: 'landrequirementcaf' });
                }, function() {
                    $state.go('landrequirementcaf');
                });
            }]
        })
        .state('landrequirementcaf.edit', {
            parent: 'landrequirementcaf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landrequirementcaf/landrequirementcaf-dialog.html',
                    controller: 'LandrequirementcafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Landrequirementcaf', function(Landrequirementcaf) {
                            return Landrequirementcaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('landrequirementcaf', null, { reload: 'landrequirementcaf' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('landrequirementcaf.delete', {
            parent: 'landrequirementcaf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landrequirementcaf/landrequirementcaf-delete-dialog.html',
                    controller: 'LandrequirementcafDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Landrequirementcaf', function(Landrequirementcaf) {
                            return Landrequirementcaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('landrequirementcaf', null, { reload: 'landrequirementcaf' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Landrequirementcaf', Landrequirementcaf);

    Landrequirementcaf.$inject = ['$resource'];

    function Landrequirementcaf ($resource) {
        var resourceUrl =  'api/landrequirementcafs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandrequirementcafController', LandrequirementcafController);

    LandrequirementcafController.$inject = ['Landrequirementcaf'];

    function LandrequirementcafController(Landrequirementcaf) {

        var vm = this;

        vm.landrequirementcafs = [];

        loadAll();

        function loadAll() {
            Landrequirementcaf.query(function(result) {
                vm.landrequirementcafs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandexchangeDialogController', LandexchangeDialogController);

    LandexchangeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Landexchange'];

    function LandexchangeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Landexchange) {
        var vm = this;

        vm.landexchange = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.landexchange.id !== null) {
                Landexchange.update(vm.landexchange, onSaveSuccess, onSaveError);
            } else {
                Landexchange.save(vm.landexchange, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:landexchangeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandexchangeDetailController', LandexchangeDetailController);

    LandexchangeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Landexchange'];

    function LandexchangeDetailController($scope, $rootScope, $stateParams, previousState, entity, Landexchange) {
        var vm = this;

        vm.landexchange = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:landexchangeUpdate', function(event, result) {
            vm.landexchange = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandexchangeDeleteController',LandexchangeDeleteController);

    LandexchangeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Landexchange'];

    function LandexchangeDeleteController($uibModalInstance, entity, Landexchange) {
        var vm = this;

        vm.landexchange = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Landexchange.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('landexchange', {
            parent: 'entity',
            url: '/landexchange',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.landexchange.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/landexchange/landexchanges.html',
                    controller: 'LandexchangeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('landexchange');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('landexchange-detail', {
            parent: 'landexchange',
            url: '/landexchange/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.landexchange.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/landexchange/landexchange-detail.html',
                    controller: 'LandexchangeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('landexchange');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Landexchange', function($stateParams, Landexchange) {
                    return Landexchange.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'landexchange',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('landexchange-detail.edit', {
            parent: 'landexchange-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landexchange/landexchange-dialog.html',
                    controller: 'LandexchangeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Landexchange', function(Landexchange) {
                            return Landexchange.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('landexchange.new', {
            parent: 'landexchange',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landexchange/landexchange-dialog.html',
                    controller: 'LandexchangeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                investor_name: null,
                                address: null,
                                contact: null,
                                reason: null,
                                owner_name: null,
                                tehsil: null,
                                block: null,
                                village: null,
                                khasra: null,
                                area_of_land: null,
                                market_value: null,
                                owner_name_offered: null,
                                tehsil_offered: null,
                                block_offered: null,
                                village_offered: null,
                                khasra_offered: null,
                                area_of_land_offered: null,
                                market_value_offered: null,
                                email: null,
                                name_of_gramPanchayat: null,
                                district: null,
                                type_of_land: null,
                                district_offered: null,
                                type_of_land_offered: null,
                                dimension_of_site: null,
                                location_of_site: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('landexchange', null, { reload: 'landexchange' });
                }, function() {
                    $state.go('landexchange');
                });
            }]
        })
        .state('landexchange.edit', {
            parent: 'landexchange',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landexchange/landexchange-dialog.html',
                    controller: 'LandexchangeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Landexchange', function(Landexchange) {
                            return Landexchange.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('landexchange', null, { reload: 'landexchange' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('landexchange.delete', {
            parent: 'landexchange',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/landexchange/landexchange-delete-dialog.html',
                    controller: 'LandexchangeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Landexchange', function(Landexchange) {
                            return Landexchange.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('landexchange', null, { reload: 'landexchange' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Landexchange', Landexchange);

    Landexchange.$inject = ['$resource'];

    function Landexchange ($resource) {
        var resourceUrl =  'api/landexchanges/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LandexchangeController', LandexchangeController);

    LandexchangeController.$inject = ['Landexchange'];

    function LandexchangeController(Landexchange) {

        var vm = this;

        vm.landexchanges = [];

        loadAll();

        function loadAll() {
            Landexchange.query(function(result) {
                vm.landexchanges = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InvestorDialogController', InvestorDialogController);

    InvestorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Investor'];

    function InvestorDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Investor) {
        var vm = this;

        vm.investor = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.investor.id !== null) {
                Investor.update(vm.investor, onSaveSuccess, onSaveError);
            } else {
                Investor.save(vm.investor, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:investorUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InvestorDetailController', InvestorDetailController);

    InvestorDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Investor'];

    function InvestorDetailController($scope, $rootScope, $stateParams, previousState, entity, Investor) {
        var vm = this;

        vm.investor = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:investorUpdate', function(event, result) {
            vm.investor = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InvestorDeleteController',InvestorDeleteController);

    InvestorDeleteController.$inject = ['$uibModalInstance', 'entity', 'Investor'];

    function InvestorDeleteController($uibModalInstance, entity, Investor) {
        var vm = this;

        vm.investor = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Investor.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('investor', {
            parent: 'entity',
            url: '/investor',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.investor.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/investor/investors.html',
                    controller: 'InvestorController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('investor');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('investor-detail', {
            parent: 'investor',
            url: '/investor/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.investor.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/investor/investor-detail.html',
                    controller: 'InvestorDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('investor');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Investor', function($stateParams, Investor) {
                    return Investor.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'investor',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('investor-detail.edit', {
            parent: 'investor-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/investor/investor-dialog.html',
                    controller: 'InvestorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Investor', function(Investor) {
                            return Investor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('investor.new', {
            parent: 'investor',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/investor/investor-dialog.html',
                    controller: 'InvestorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                mouapplicable: null,
                                mousignyear: null,
                                mouidnumber: null,
                                firstname: null,
                                middlename: null,
                                lastname: null,
                                address1: null,
                                address2: null,
                                address3: null,
                                emailprimary: null,
                                emailsecondary: null,
                                userlogin: null,
                                cityname: null,
                                countryname: null,
                                statename: null,
                                createdate: null,
                                updatedate: null,
                                cafpin: null,
                                pincode: null,
                                phonenumber: null,
                                mobilenumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('investor', null, { reload: 'investor' });
                }, function() {
                    $state.go('investor');
                });
            }]
        })
        .state('investor.edit', {
            parent: 'investor',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/investor/investor-dialog.html',
                    controller: 'InvestorDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Investor', function(Investor) {
                            return Investor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('investor', null, { reload: 'investor' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('investor.delete', {
            parent: 'investor',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/investor/investor-delete-dialog.html',
                    controller: 'InvestorDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Investor', function(Investor) {
                            return Investor.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('investor', null, { reload: 'investor' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Investor', Investor);

    Investor.$inject = ['$resource', 'DateUtils'];

    function Investor ($resource, DateUtils) {
        var resourceUrl =  'api/investors/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InvestorController', InvestorController);

    InvestorController.$inject = ['Investor'];

    function InvestorController(Investor) {

        var vm = this;

        vm.investors = [];

        loadAll();

        function loadAll() {
            Investor.query(function(result) {
                vm.investors = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InspectorDetailsDialogController', InspectorDetailsDialogController);

    InspectorDetailsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InspectorDetails'];

    function InspectorDetailsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InspectorDetails) {
        var vm = this;

        vm.inspectorDetails = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.inspectorDetails.id !== null) {
                InspectorDetails.update(vm.inspectorDetails, onSaveSuccess, onSaveError);
            } else {
                InspectorDetails.save(vm.inspectorDetails, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:inspectorDetailsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InspectorDetailsDetailController', InspectorDetailsDetailController);

    InspectorDetailsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InspectorDetails'];

    function InspectorDetailsDetailController($scope, $rootScope, $stateParams, previousState, entity, InspectorDetails) {
        var vm = this;

        vm.inspectorDetails = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:inspectorDetailsUpdate', function(event, result) {
            vm.inspectorDetails = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InspectorDetailsDeleteController',InspectorDetailsDeleteController);

    InspectorDetailsDeleteController.$inject = ['$uibModalInstance', 'entity', 'InspectorDetails'];

    function InspectorDetailsDeleteController($uibModalInstance, entity, InspectorDetails) {
        var vm = this;

        vm.inspectorDetails = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InspectorDetails.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('inspector-details', {
            parent: 'entity',
            url: '/inspector-details',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.inspectorDetails.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/inspector-details/inspector-details.html',
                    controller: 'InspectorDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('inspectorDetails');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('inspector-details-detail', {
            parent: 'inspector-details',
            url: '/inspector-details/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.inspectorDetails.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/inspector-details/inspector-details-detail.html',
                    controller: 'InspectorDetailsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('inspectorDetails');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'InspectorDetails', function($stateParams, InspectorDetails) {
                    return InspectorDetails.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'inspector-details',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('inspector-details-detail.edit', {
            parent: 'inspector-details-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inspector-details/inspector-details-dialog.html',
                    controller: 'InspectorDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InspectorDetails', function(InspectorDetails) {
                            return InspectorDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('inspector-details.new', {
            parent: 'inspector-details',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inspector-details/inspector-details-dialog.html',
                    controller: 'InspectorDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                inspectorId: null,
                                inspectorName: null,
                                estateName: null,
                                districtName: null,
                                contactNo: null,
                                inspectorEmail: null,
                                departmentName: null,
                                inspectorService: null,
                                serviceId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('inspector-details', null, { reload: 'inspector-details' });
                }, function() {
                    $state.go('inspector-details');
                });
            }]
        })
        .state('inspector-details.edit', {
            parent: 'inspector-details',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inspector-details/inspector-details-dialog.html',
                    controller: 'InspectorDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InspectorDetails', function(InspectorDetails) {
                            return InspectorDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('inspector-details', null, { reload: 'inspector-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('inspector-details.delete', {
            parent: 'inspector-details',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inspector-details/inspector-details-delete-dialog.html',
                    controller: 'InspectorDetailsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InspectorDetails', function(InspectorDetails) {
                            return InspectorDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('inspector-details', null, { reload: 'inspector-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('InspectorDetails', InspectorDetails);

    InspectorDetails.$inject = ['$resource'];

    function InspectorDetails ($resource) {
        var resourceUrl =  'api/inspector-details/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InspectorDetailsController', InspectorDetailsController);

    InspectorDetailsController.$inject = ['InspectorDetails'];

    function InspectorDetailsController(InspectorDetails) {

        var vm = this;

        vm.inspectorDetails = [];

        loadAll();

        function loadAll() {
            InspectorDetails.query(function(result) {
                vm.inspectorDetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InspectionReportDialogController', InspectionReportDialogController);

    InspectionReportDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'InspectionReport'];

    function InspectionReportDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, InspectionReport) {
        var vm = this;

        vm.inspectionReport = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.inspectionReport.id !== null) {
                InspectionReport.update(vm.inspectionReport, onSaveSuccess, onSaveError);
            } else {
                InspectionReport.save(vm.inspectionReport, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:inspectionReportUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InspectionReportDetailController', InspectionReportDetailController);

    InspectionReportDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'InspectionReport'];

    function InspectionReportDetailController($scope, $rootScope, $stateParams, previousState, entity, InspectionReport) {
        var vm = this;

        vm.inspectionReport = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:inspectionReportUpdate', function(event, result) {
            vm.inspectionReport = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InspectionReportDeleteController',InspectionReportDeleteController);

    InspectionReportDeleteController.$inject = ['$uibModalInstance', 'entity', 'InspectionReport'];

    function InspectionReportDeleteController($uibModalInstance, entity, InspectionReport) {
        var vm = this;

        vm.inspectionReport = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            InspectionReport.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('inspection-report', {
            parent: 'entity',
            url: '/inspection-report',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.inspectionReport.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/inspection-report/inspection-reports.html',
                    controller: 'InspectionReportController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('inspectionReport');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('inspection-report-detail', {
            parent: 'inspection-report',
            url: '/inspection-report/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.inspectionReport.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/inspection-report/inspection-report-detail.html',
                    controller: 'InspectionReportDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('inspectionReport');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'InspectionReport', function($stateParams, InspectionReport) {
                    return InspectionReport.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'inspection-report',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('inspection-report-detail.edit', {
            parent: 'inspection-report-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inspection-report/inspection-report-dialog.html',
                    controller: 'InspectionReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InspectionReport', function(InspectionReport) {
                            return InspectionReport.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('inspection-report.new', {
            parent: 'inspection-report',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inspection-report/inspection-report-dialog.html',
                    controller: 'InspectionReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                reportDescription: null,
                                file1: null,
                                file2: null,
                                file3: null,
                                file4: null,
                                file5: null,
                                file6: null,
                                file7: null,
                                file8: null,
                                file9: null,
                                file10: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('inspection-report', null, { reload: 'inspection-report' });
                }, function() {
                    $state.go('inspection-report');
                });
            }]
        })
        .state('inspection-report.edit', {
            parent: 'inspection-report',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inspection-report/inspection-report-dialog.html',
                    controller: 'InspectionReportDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['InspectionReport', function(InspectionReport) {
                            return InspectionReport.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('inspection-report', null, { reload: 'inspection-report' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('inspection-report.delete', {
            parent: 'inspection-report',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/inspection-report/inspection-report-delete-dialog.html',
                    controller: 'InspectionReportDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['InspectionReport', function(InspectionReport) {
                            return InspectionReport.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('inspection-report', null, { reload: 'inspection-report' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('InspectionReport', InspectionReport);

    InspectionReport.$inject = ['$resource'];

    function InspectionReport ($resource) {
        var resourceUrl =  'api/inspection-reports/:id/:projectid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('InspectionReportController', InspectionReportController);

    InspectionReportController.$inject = ['InspectionReport'];

    function InspectionReportController(InspectionReport) {

        var vm = this;

        vm.inspectionReports = [];

        loadAll();

        function loadAll() {
            InspectionReport.query(function(result) {
                vm.inspectionReports = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IndustrysizeDialogController', IndustrysizeDialogController);

    IndustrysizeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Industrysize'];

    function IndustrysizeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Industrysize) {
        var vm = this;

        vm.industrysize = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.industrysize.id !== null) {
                Industrysize.update(vm.industrysize, onSaveSuccess, onSaveError);
            } else {
                Industrysize.save(vm.industrysize, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:industrysizeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IndustrysizeDetailController', IndustrysizeDetailController);

    IndustrysizeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Industrysize'];

    function IndustrysizeDetailController($scope, $rootScope, $stateParams, previousState, entity, Industrysize) {
        var vm = this;

        vm.industrysize = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:industrysizeUpdate', function(event, result) {
            vm.industrysize = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IndustrysizeDeleteController',IndustrysizeDeleteController);

    IndustrysizeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Industrysize'];

    function IndustrysizeDeleteController($uibModalInstance, entity, Industrysize) {
        var vm = this;

        vm.industrysize = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Industrysize.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('industrysize', {
            parent: 'entity',
            url: '/industrysize',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.industrysize.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/industrysize/industrysizes.html',
                    controller: 'IndustrysizeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('industrysize');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('industrysize-detail', {
            parent: 'industrysize',
            url: '/industrysize/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.industrysize.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/industrysize/industrysize-detail.html',
                    controller: 'IndustrysizeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('industrysize');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Industrysize', function($stateParams, Industrysize) {
                    return Industrysize.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'industrysize',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('industrysize-detail.edit', {
            parent: 'industrysize-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/industrysize/industrysize-dialog.html',
                    controller: 'IndustrysizeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Industrysize', function(Industrysize) {
                            return Industrysize.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('industrysize.new', {
            parent: 'industrysize',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/industrysize/industrysize-dialog.html',
                    controller: 'IndustrysizeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                sizeofindustry: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('industrysize', null, { reload: 'industrysize' });
                }, function() {
                    $state.go('industrysize');
                });
            }]
        })
        .state('industrysize.edit', {
            parent: 'industrysize',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/industrysize/industrysize-dialog.html',
                    controller: 'IndustrysizeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Industrysize', function(Industrysize) {
                            return Industrysize.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('industrysize', null, { reload: 'industrysize' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('industrysize.delete', {
            parent: 'industrysize',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/industrysize/industrysize-delete-dialog.html',
                    controller: 'IndustrysizeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Industrysize', function(Industrysize) {
                            return Industrysize.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('industrysize', null, { reload: 'industrysize' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Industrysize', Industrysize);

    Industrysize.$inject = ['$resource'];

    function Industrysize ($resource) {
        var resourceUrl =  'api/industrysizes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IndustrysizeController', IndustrysizeController);

    IndustrysizeController.$inject = ['Industrysize'];

    function IndustrysizeController(Industrysize) {

        var vm = this;

        vm.industrysizes = [];

        loadAll();

        function loadAll() {
            Industrysize.query(function(result) {
                vm.industrysizes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IncentiveWizardRuleDialogController', IncentiveWizardRuleDialogController);

    IncentiveWizardRuleDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'IncentiveWizardRule'];

    function IncentiveWizardRuleDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, IncentiveWizardRule) {
        var vm = this;

        vm.incentiveWizardRule = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.incentiveWizardRule.id !== null) {
                IncentiveWizardRule.update(vm.incentiveWizardRule, onSaveSuccess, onSaveError);
            } else {
                IncentiveWizardRule.save(vm.incentiveWizardRule, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:incentiveWizardRuleUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IncentiveWizardRuleDetailController', IncentiveWizardRuleDetailController);

    IncentiveWizardRuleDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'IncentiveWizardRule'];

    function IncentiveWizardRuleDetailController($scope, $rootScope, $stateParams, previousState, entity, IncentiveWizardRule) {
        var vm = this;

        vm.incentiveWizardRule = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:incentiveWizardRuleUpdate', function(event, result) {
            vm.incentiveWizardRule = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IncentiveWizardRuleDeleteController',IncentiveWizardRuleDeleteController);

    IncentiveWizardRuleDeleteController.$inject = ['$uibModalInstance', 'entity', 'IncentiveWizardRule'];

    function IncentiveWizardRuleDeleteController($uibModalInstance, entity, IncentiveWizardRule) {
        var vm = this;

        vm.incentiveWizardRule = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            IncentiveWizardRule.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('incentive-wizard-rule', {
            parent: 'entity',
            url: '/incentive-wizard-rule',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.incentiveWizardRule.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/incentive-wizard-rule/incentive-wizard-rules.html',
                    controller: 'IncentiveWizardRuleController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('incentiveWizardRule');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('incentive-wizard-rule-detail', {
            parent: 'incentive-wizard-rule',
            url: '/incentive-wizard-rule/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.incentiveWizardRule.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/incentive-wizard-rule/incentive-wizard-rule-detail.html',
                    controller: 'IncentiveWizardRuleDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('incentiveWizardRule');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'IncentiveWizardRule', function($stateParams, IncentiveWizardRule) {
                    return IncentiveWizardRule.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'incentive-wizard-rule',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('incentive-wizard-rule-detail.edit', {
            parent: 'incentive-wizard-rule-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/incentive-wizard-rule/incentive-wizard-rule-dialog.html',
                    controller: 'IncentiveWizardRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IncentiveWizardRule', function(IncentiveWizardRule) {
                            return IncentiveWizardRule.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('incentive-wizard-rule.new', {
            parent: 'incentive-wizard-rule',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/incentive-wizard-rule/incentive-wizard-rule-dialog.html',
                    controller: 'IncentiveWizardRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                businessType: null,
                                conformsToRestrictiveList: null,
                                thrustSector: null,
                                startupCompany: null,
                                sectorEnterPrise: null,
                                importSubstitutionEnterprise: null,
                                exportOriented: null,
                                outsideMunicipalLimits: null,
                                infrastructureRelated: null,
                                renewable: null,
                                projectType: null,
                                subSector: null,
                                blockType: null,
                                referenceNumber: null,
                                incentiveCategory: null,
                                rawNote: null,
                                displayPriority: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('incentive-wizard-rule', null, { reload: 'incentive-wizard-rule' });
                }, function() {
                    $state.go('incentive-wizard-rule');
                });
            }]
        })
        .state('incentive-wizard-rule.edit', {
            parent: 'incentive-wizard-rule',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/incentive-wizard-rule/incentive-wizard-rule-dialog.html',
                    controller: 'IncentiveWizardRuleDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IncentiveWizardRule', function(IncentiveWizardRule) {
                            return IncentiveWizardRule.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('incentive-wizard-rule', null, { reload: 'incentive-wizard-rule' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('incentive-wizard-rule.delete', {
            parent: 'incentive-wizard-rule',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/incentive-wizard-rule/incentive-wizard-rule-delete-dialog.html',
                    controller: 'IncentiveWizardRuleDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['IncentiveWizardRule', function(IncentiveWizardRule) {
                            return IncentiveWizardRule.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('incentive-wizard-rule', null, { reload: 'incentive-wizard-rule' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('IncentiveWizardRule', IncentiveWizardRule);

    IncentiveWizardRule.$inject = ['$resource'];

    function IncentiveWizardRule ($resource) {
        var resourceUrl =  'api/incentive-wizard-rules/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IncentiveWizardRuleController', IncentiveWizardRuleController);

    IncentiveWizardRuleController.$inject = ['IncentiveWizardRule'];

    function IncentiveWizardRuleController(IncentiveWizardRule) {

        var vm = this;

        vm.incentiveWizardRules = [];

        loadAll();

        function loadAll() {
            IncentiveWizardRule.query(function(result) {
                vm.incentiveWizardRules = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IncentiveBlockMappingDialogController', IncentiveBlockMappingDialogController);

    IncentiveBlockMappingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'IncentiveBlockMapping'];

    function IncentiveBlockMappingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, IncentiveBlockMapping) {
        var vm = this;

        vm.incentiveBlockMapping = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.incentiveBlockMapping.id !== null) {
                IncentiveBlockMapping.update(vm.incentiveBlockMapping, onSaveSuccess, onSaveError);
            } else {
                IncentiveBlockMapping.save(vm.incentiveBlockMapping, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:incentiveBlockMappingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IncentiveBlockMappingDetailController', IncentiveBlockMappingDetailController);

    IncentiveBlockMappingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'IncentiveBlockMapping'];

    function IncentiveBlockMappingDetailController($scope, $rootScope, $stateParams, previousState, entity, IncentiveBlockMapping) {
        var vm = this;

        vm.incentiveBlockMapping = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:incentiveBlockMappingUpdate', function(event, result) {
            vm.incentiveBlockMapping = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IncentiveBlockMappingDeleteController',IncentiveBlockMappingDeleteController);

    IncentiveBlockMappingDeleteController.$inject = ['$uibModalInstance', 'entity', 'IncentiveBlockMapping'];

    function IncentiveBlockMappingDeleteController($uibModalInstance, entity, IncentiveBlockMapping) {
        var vm = this;

        vm.incentiveBlockMapping = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            IncentiveBlockMapping.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('incentive-block-mapping', {
            parent: 'entity',
            url: '/incentive-block-mapping',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.incentiveBlockMapping.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/incentive-block-mapping/incentive-block-mappings.html',
                    controller: 'IncentiveBlockMappingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('incentiveBlockMapping');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('incentive-block-mapping-detail', {
            parent: 'incentive-block-mapping',
            url: '/incentive-block-mapping/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.incentiveBlockMapping.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/incentive-block-mapping/incentive-block-mapping-detail.html',
                    controller: 'IncentiveBlockMappingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('incentiveBlockMapping');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'IncentiveBlockMapping', function($stateParams, IncentiveBlockMapping) {
                    return IncentiveBlockMapping.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'incentive-block-mapping',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('incentive-block-mapping-detail.edit', {
            parent: 'incentive-block-mapping-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/incentive-block-mapping/incentive-block-mapping-dialog.html',
                    controller: 'IncentiveBlockMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IncentiveBlockMapping', function(IncentiveBlockMapping) {
                            return IncentiveBlockMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('incentive-block-mapping.new', {
            parent: 'incentive-block-mapping',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/incentive-block-mapping/incentive-block-mapping-dialog.html',
                    controller: 'IncentiveBlockMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                districtName: null,
                                blockName: null,
                                blockType: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('incentive-block-mapping', null, { reload: 'incentive-block-mapping' });
                }, function() {
                    $state.go('incentive-block-mapping');
                });
            }]
        })
        .state('incentive-block-mapping.edit', {
            parent: 'incentive-block-mapping',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/incentive-block-mapping/incentive-block-mapping-dialog.html',
                    controller: 'IncentiveBlockMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['IncentiveBlockMapping', function(IncentiveBlockMapping) {
                            return IncentiveBlockMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('incentive-block-mapping', null, { reload: 'incentive-block-mapping' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('incentive-block-mapping.delete', {
            parent: 'incentive-block-mapping',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/incentive-block-mapping/incentive-block-mapping-delete-dialog.html',
                    controller: 'IncentiveBlockMappingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['IncentiveBlockMapping', function(IncentiveBlockMapping) {
                            return IncentiveBlockMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('incentive-block-mapping', null, { reload: 'incentive-block-mapping' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('IncentiveBlockMapping', IncentiveBlockMapping);

    IncentiveBlockMapping.$inject = ['$resource'];

    function IncentiveBlockMapping ($resource) {
        var resourceUrl =  'api/incentive-block-mappings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('IncentiveBlockMappingController', IncentiveBlockMappingController);

    IncentiveBlockMappingController.$inject = ['IncentiveBlockMapping'];

    function IncentiveBlockMappingController(IncentiveBlockMapping) {

        var vm = this;

        vm.incentiveBlockMappings = [];

        loadAll();

        function loadAll() {
            IncentiveBlockMapping.query(function(result) {
                vm.incentiveBlockMappings = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HudaformOcDialogController', HudaformOcDialogController);

    HudaformOcDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HudaformOc'];

    function HudaformOcDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HudaformOc) {
        var vm = this;

        vm.hudaformOc = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.hudaformOc.id !== null) {
                HudaformOc.update(vm.hudaformOc, onSaveSuccess, onSaveError);
            } else {
                HudaformOc.save(vm.hudaformOc, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:hudaformOcUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HudaformOcDetailController', HudaformOcDetailController);

    HudaformOcDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HudaformOc'];

    function HudaformOcDetailController($scope, $rootScope, $stateParams, previousState, entity, HudaformOc) {
        var vm = this;

        vm.hudaformOc = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:hudaformOcUpdate', function(event, result) {
            vm.hudaformOc = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HudaformOcDeleteController',HudaformOcDeleteController);

    HudaformOcDeleteController.$inject = ['$uibModalInstance', 'entity', 'HudaformOc'];

    function HudaformOcDeleteController($uibModalInstance, entity, HudaformOc) {
        var vm = this;

        vm.hudaformOc = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HudaformOc.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hudaform-oc', {
            parent: 'entity',
            url: '/hudaform-oc',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.hudaformOc.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hudaform-oc/hudaform-ocs.html',
                    controller: 'HudaformOcController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hudaformOc');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hudaform-oc-detail', {
            parent: 'hudaform-oc',
            url: '/hudaform-oc/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.hudaformOc.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hudaform-oc/hudaform-oc-detail.html',
                    controller: 'HudaformOcDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hudaformOc');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HudaformOc', function($stateParams, HudaformOc) {
                    return HudaformOc.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'hudaform-oc',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('hudaform-oc-detail.edit', {
            parent: 'hudaform-oc-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hudaform-oc/hudaform-oc-dialog.html',
                    controller: 'HudaformOcDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HudaformOc', function(HudaformOc) {
                            return HudaformOc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hudaform-oc.new', {
            parent: 'hudaform-oc',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hudaform-oc/hudaform-oc-dialog.html',
                    controller: 'HudaformOcDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                certificateFrom: null,
                                orderNo: null,
                                dated: null,
                                completedOn: null,
                                anyModifications: null,
                                plotNo: null,
                                phase: null,
                                estate: null,
                                sector: null,
                                colony: null,
                                city: null,
                                khasra: null,
                                village: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hudaform-oc', null, { reload: 'hudaform-oc' });
                }, function() {
                    $state.go('hudaform-oc');
                });
            }]
        })
        .state('hudaform-oc.edit', {
            parent: 'hudaform-oc',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hudaform-oc/hudaform-oc-dialog.html',
                    controller: 'HudaformOcDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HudaformOc', function(HudaformOc) {
                            return HudaformOc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hudaform-oc', null, { reload: 'hudaform-oc' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hudaform-oc.delete', {
            parent: 'hudaform-oc',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hudaform-oc/hudaform-oc-delete-dialog.html',
                    controller: 'HudaformOcDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HudaformOc', function(HudaformOc) {
                            return HudaformOc.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hudaform-oc', null, { reload: 'hudaform-oc' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('HudaformOc', HudaformOc);

    HudaformOc.$inject = ['$resource'];

    function HudaformOc ($resource) {
        var resourceUrl =  'api/hudaform-ocs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HudaformOcController', HudaformOcController);

    HudaformOcController.$inject = ['HudaformOc'];

    function HudaformOcController(HudaformOc) {

        var vm = this;

        vm.hudaformOcs = [];

        loadAll();

        function loadAll() {
            HudaformOc.query(function(result) {
                vm.hudaformOcs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HudaFormDialogController', HudaFormDialogController);

    HudaFormDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HudaForm'];

    function HudaFormDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HudaForm) {
        var vm = this;

        vm.hudaForm = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.hudaForm.id !== null) {
                HudaForm.update(vm.hudaForm, onSaveSuccess, onSaveError);
            } else {
                HudaForm.save(vm.hudaForm, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:hudaFormUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HudaFormDetailController', HudaFormDetailController);

    HudaFormDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HudaForm'];

    function HudaFormDetailController($scope, $rootScope, $stateParams, previousState, entity, HudaForm) {
        var vm = this;

        vm.hudaForm = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:hudaFormUpdate', function(event, result) {
            vm.hudaForm = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HudaFormDeleteController',HudaFormDeleteController);

    HudaFormDeleteController.$inject = ['$uibModalInstance', 'entity', 'HudaForm'];

    function HudaFormDeleteController($uibModalInstance, entity, HudaForm) {
        var vm = this;

        vm.hudaForm = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HudaForm.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('huda-form', {
            parent: 'entity',
            url: '/huda-form',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.hudaForm.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/huda-form/huda-forms.html',
                    controller: 'HudaFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hudaForm');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('huda-form-detail', {
            parent: 'huda-form',
            url: '/huda-form/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.hudaForm.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/huda-form/huda-form-detail.html',
                    controller: 'HudaFormDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hudaForm');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HudaForm', function($stateParams, HudaForm) {
                    return HudaForm.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'huda-form',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('huda-form-detail.edit', {
            parent: 'huda-form-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/huda-form/huda-form-dialog.html',
                    controller: 'HudaFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HudaForm', function(HudaForm) {
                            return HudaForm.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('huda-form.new', {
            parent: 'huda-form',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/huda-form/huda-form-dialog.html',
                    controller: 'HudaFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                caseType: null,
                                estateOffice: null,
                                projectType: null,
                                sector: null,
                                existingFAR: null,
                                basementArea: null,
                                zoningLayout: null,
                                plotNumber: null,
                                applicationType: null,
                                applicantEmail: null,
                                applicantMobile: null,
                                ownerName: null,
                                ownerAddress: null,
                                aadhaarCardNumber: null,
                                fatherName: null,
                                pinCode: null,
                                applicantName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('huda-form', null, { reload: 'huda-form' });
                }, function() {
                    $state.go('huda-form');
                });
            }]
        })
        .state('huda-form.edit', {
            parent: 'huda-form',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/huda-form/huda-form-dialog.html',
                    controller: 'HudaFormDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HudaForm', function(HudaForm) {
                            return HudaForm.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('huda-form', null, { reload: 'huda-form' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('huda-form.delete', {
            parent: 'huda-form',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/huda-form/huda-form-delete-dialog.html',
                    controller: 'HudaFormDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HudaForm', function(HudaForm) {
                            return HudaForm.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('huda-form', null, { reload: 'huda-form' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('HudaForm', HudaForm);

    HudaForm.$inject = ['$resource'];

    function HudaForm ($resource) {
        var resourceUrl =  'api/huda-forms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HudaFormController', HudaFormController);

    HudaFormController.$inject = ['HudaForm'];

    function HudaFormController(HudaForm) {

        var vm = this;

        vm.hudaForms = [];

        loadAll();

        function loadAll() {
            HudaForm.query(function(result) {
                vm.hudaForms = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('NewHomeProjectServiceDetails', NewHomeProjectServiceDetails);

    NewHomeProjectServiceDetails.$inject = ['$resource', 'DateUtils'];

    function NewHomeProjectServiceDetails ($resource, DateUtils) {
        var resourceUrl =  'api/home-project-service-details/new/:projectServiceDetailId/:projectId/:serviceId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastActionDate = DateUtils.convertDateTimeFromServer(data.lastActionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomeProjectServiceDetailsDialogController', HomeProjectServiceDetailsDialogController);

    HomeProjectServiceDetailsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HomeProjectServiceDetails'];

    function HomeProjectServiceDetailsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HomeProjectServiceDetails) {
        var vm = this;

        vm.homeProjectServiceDetails = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.homeProjectServiceDetails.id !== null) {
                HomeProjectServiceDetails.update(vm.homeProjectServiceDetails, onSaveSuccess, onSaveError);
            } else {
                HomeProjectServiceDetails.save(vm.homeProjectServiceDetails, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:homeProjectServiceDetailsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastActionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomeProjectServiceDetailsDetailController', HomeProjectServiceDetailsDetailController);

    HomeProjectServiceDetailsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HomeProjectServiceDetails'];

    function HomeProjectServiceDetailsDetailController($scope, $rootScope, $stateParams, previousState, entity, HomeProjectServiceDetails) {
        var vm = this;

        vm.homeProjectServiceDetails = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:homeProjectServiceDetailsUpdate', function(event, result) {
            vm.homeProjectServiceDetails = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomeProjectServiceDetailsDeleteController',HomeProjectServiceDetailsDeleteController);

    HomeProjectServiceDetailsDeleteController.$inject = ['$uibModalInstance', 'entity', 'HomeProjectServiceDetails'];

    function HomeProjectServiceDetailsDeleteController($uibModalInstance, entity, HomeProjectServiceDetails) {
        var vm = this;

        vm.homeProjectServiceDetails = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HomeProjectServiceDetails.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('home-project-service-details', {
            parent: 'entity',
            url: '/home-project-service-details',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.homeProjectServiceDetails.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details.html',
                    controller: 'HomeProjectServiceDetailsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('homeProjectServiceDetails');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('home-project-service-details-detail', {
            parent: 'home-project-service-details',
            url: '/home-project-service-details/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.homeProjectServiceDetails.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details-detail.html',
                    controller: 'HomeProjectServiceDetailsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('homeProjectServiceDetails');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HomeProjectServiceDetails', function($stateParams, HomeProjectServiceDetails) {
                    return HomeProjectServiceDetails.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'home-project-service-details',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('home-project-service-details-detail.edit', {
            parent: 'home-project-service-details-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details-dialog.html',
                    controller: 'HomeProjectServiceDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HomeProjectServiceDetails', function(HomeProjectServiceDetails) {
                            return HomeProjectServiceDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('home-project-service-details.new', {
            parent: 'home-project-service-details',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details-dialog.html',
                    controller: 'HomeProjectServiceDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectId: null,
                                serviceId: null,
                                cafPin: null,
                                district: null,
                                status: null,
                                serviceName: null,
                                businessEntity: null,
                                departmentName: null,
                                ageing: null,
                                lastComments: null,
                                lastActionDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('home-project-service-details', null, { reload: 'home-project-service-details' });
                }, function() {
                    $state.go('home-project-service-details');
                });
            }]
        })
        .state('home-project-service-details.edit', {
            parent: 'home-project-service-details',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details-dialog.html',
                    controller: 'HomeProjectServiceDetailsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HomeProjectServiceDetails', function(HomeProjectServiceDetails) {
                            return HomeProjectServiceDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('home-project-service-details', null, { reload: 'home-project-service-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('home-project-service-details.delete', {
            parent: 'home-project-service-details',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-project-service-details/home-project-service-details-delete-dialog.html',
                    controller: 'HomeProjectServiceDetailsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HomeProjectServiceDetails', function(HomeProjectServiceDetails) {
                            return HomeProjectServiceDetails.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('home-project-service-details', null, { reload: 'home-project-service-details' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('HomeProjectServiceDetails', HomeProjectServiceDetails);

    HomeProjectServiceDetails.$inject = ['$resource', 'DateUtils'];

    function HomeProjectServiceDetails ($resource, DateUtils) {
        var resourceUrl =  'api/home-project-service-details/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastActionDate = DateUtils.convertDateTimeFromServer(data.lastActionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomeProjectServiceDetailsController', HomeProjectServiceDetailsController);

    HomeProjectServiceDetailsController.$inject = ['HomeProjectServiceDetails'];

    function HomeProjectServiceDetailsController(HomeProjectServiceDetails) {

        var vm = this;

        vm.homeProjectServiceDetails = [];

        loadAll();

        function loadAll() {
            HomeProjectServiceDetails.query(function(result) {
                vm.homeProjectServiceDetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomePageCountOutputDialogController', HomePageCountOutputDialogController);

    HomePageCountOutputDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HomePageCountOutput'];

    function HomePageCountOutputDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HomePageCountOutput) {
        var vm = this;

        vm.homePageCountOutput = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.homePageCountOutput.id !== null) {
                HomePageCountOutput.update(vm.homePageCountOutput, onSaveSuccess, onSaveError);
            } else {
                HomePageCountOutput.save(vm.homePageCountOutput, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:homePageCountOutputUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomePageCountOutputDetailController', HomePageCountOutputDetailController);

    HomePageCountOutputDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HomePageCountOutput'];

    function HomePageCountOutputDetailController($scope, $rootScope, $stateParams, previousState, entity, HomePageCountOutput) {
        var vm = this;

        vm.homePageCountOutput = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:homePageCountOutputUpdate', function(event, result) {
            vm.homePageCountOutput = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomePageCountOutputDeleteController',HomePageCountOutputDeleteController);

    HomePageCountOutputDeleteController.$inject = ['$uibModalInstance', 'entity', 'HomePageCountOutput'];

    function HomePageCountOutputDeleteController($uibModalInstance, entity, HomePageCountOutput) {
        var vm = this;

        vm.homePageCountOutput = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HomePageCountOutput.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('home-page-count-output', {
            parent: 'entity',
            url: '/home-page-count-output',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.homePageCountOutput.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/home-page-count-output/home-page-count-outputs.html',
                    controller: 'HomePageCountOutputController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('homePageCountOutput');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('home-page-count-output-detail', {
            parent: 'home-page-count-output',
            url: '/home-page-count-output/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.homePageCountOutput.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/home-page-count-output/home-page-count-output-detail.html',
                    controller: 'HomePageCountOutputDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('homePageCountOutput');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HomePageCountOutput', function($stateParams, HomePageCountOutput) {
                    return HomePageCountOutput.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'home-page-count-output',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('home-page-count-output-detail.edit', {
            parent: 'home-page-count-output-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-page-count-output/home-page-count-output-dialog.html',
                    controller: 'HomePageCountOutputDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HomePageCountOutput', function(HomePageCountOutput) {
                            return HomePageCountOutput.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('home-page-count-output.new', {
            parent: 'home-page-count-output',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-page-count-output/home-page-count-output-dialog.html',
                    controller: 'HomePageCountOutputDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                totalCafs: null,
                                totalServicesApplied: null,
                                totalServicesGranted: null,
                                totalCompletedCafs: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('home-page-count-output', null, { reload: 'home-page-count-output' });
                }, function() {
                    $state.go('home-page-count-output');
                });
            }]
        })
        .state('home-page-count-output.edit', {
            parent: 'home-page-count-output',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-page-count-output/home-page-count-output-dialog.html',
                    controller: 'HomePageCountOutputDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HomePageCountOutput', function(HomePageCountOutput) {
                            return HomePageCountOutput.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('home-page-count-output', null, { reload: 'home-page-count-output' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('home-page-count-output.delete', {
            parent: 'home-page-count-output',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/home-page-count-output/home-page-count-output-delete-dialog.html',
                    controller: 'HomePageCountOutputDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HomePageCountOutput', function(HomePageCountOutput) {
                            return HomePageCountOutput.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('home-page-count-output', null, { reload: 'home-page-count-output' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('HomePageCountOutput', HomePageCountOutput);

    HomePageCountOutput.$inject = ['$resource'];

    function HomePageCountOutput ($resource) {
        var resourceUrl =  'api/home-page-count-new';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HomePageCountOutputController', HomePageCountOutputController);

    HomePageCountOutputController.$inject = ['HomePageCountOutput'];

    function HomePageCountOutputController(HomePageCountOutput) {

        var vm = this;

        vm.homePageCountOutputs = [];

        loadAll();

        function loadAll() {
            HomePageCountOutput.query(function(result) {
                vm.homePageCountOutputs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcTicketTaskDialogController', HepcTicketTaskDialogController);

    HepcTicketTaskDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HepcTicketTask'];

    function HepcTicketTaskDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HepcTicketTask) {
        var vm = this;

        vm.hepcTicketTask = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.hepcTicketTask.id !== null) {
                HepcTicketTask.update(vm.hepcTicketTask, onSaveSuccess, onSaveError);
            } else {
                HepcTicketTask.save(vm.hepcTicketTask, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:hepcTicketTaskUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.openingTime = false;
        vm.datePickerOpenStatus.closingTime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcTicketTaskDetailController', HepcTicketTaskDetailController);

    HepcTicketTaskDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HepcTicketTask'];

    function HepcTicketTaskDetailController($scope, $rootScope, $stateParams, previousState, entity, HepcTicketTask) {
        var vm = this;

        vm.hepcTicketTask = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:hepcTicketTaskUpdate', function(event, result) {
            vm.hepcTicketTask = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcTicketTaskDeleteController',HepcTicketTaskDeleteController);

    HepcTicketTaskDeleteController.$inject = ['$uibModalInstance', 'entity', 'HepcTicketTask'];

    function HepcTicketTaskDeleteController($uibModalInstance, entity, HepcTicketTask) {
        var vm = this;

        vm.hepcTicketTask = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HepcTicketTask.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hepc-ticket-task', {
            parent: 'entity',
            url: '/hepc-ticket-task',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.hepcTicketTask.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hepc-ticket-task/hepc-ticket-tasks.html',
                    controller: 'HepcTicketTaskController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hepcTicketTask');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hepc-ticket-task-detail', {
            parent: 'hepc-ticket-task',
            url: '/hepc-ticket-task/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.hepcTicketTask.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hepc-ticket-task/hepc-ticket-task-detail.html',
                    controller: 'HepcTicketTaskDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hepcTicketTask');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HepcTicketTask', function($stateParams, HepcTicketTask) {
                    return HepcTicketTask.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'hepc-ticket-task',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('hepc-ticket-task-detail.edit', {
            parent: 'hepc-ticket-task-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-ticket-task/hepc-ticket-task-dialog.html',
                    controller: 'HepcTicketTaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HepcTicketTask', function(HepcTicketTask) {
                            return HepcTicketTask.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hepc-ticket-task.new', {
            parent: 'hepc-ticket-task',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-ticket-task/hepc-ticket-task-dialog.html',
                    controller: 'HepcTicketTaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                openingTime: null,
                                closingTime: null,
                                isWorkingDay: null,
                                isWorkingHours: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hepc-ticket-task', null, { reload: 'hepc-ticket-task' });
                }, function() {
                    $state.go('hepc-ticket-task');
                });
            }]
        })
        .state('hepc-ticket-task.edit', {
            parent: 'hepc-ticket-task',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-ticket-task/hepc-ticket-task-dialog.html',
                    controller: 'HepcTicketTaskDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HepcTicketTask', function(HepcTicketTask) {
                            return HepcTicketTask.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hepc-ticket-task', null, { reload: 'hepc-ticket-task' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hepc-ticket-task.delete', {
            parent: 'hepc-ticket-task',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-ticket-task/hepc-ticket-task-delete-dialog.html',
                    controller: 'HepcTicketTaskDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HepcTicketTask', function(HepcTicketTask) {
                            return HepcTicketTask.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hepc-ticket-task', null, { reload: 'hepc-ticket-task' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('HepcTicketTask', HepcTicketTask);

    HepcTicketTask.$inject = ['$resource', 'DateUtils'];

    function HepcTicketTask ($resource, DateUtils) {
        var resourceUrl =  'api/hepc-ticket-tasks/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.openingTime = DateUtils.convertDateTimeFromServer(data.openingTime);
                        data.closingTime = DateUtils.convertDateTimeFromServer(data.closingTime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcTicketTaskController', HepcTicketTaskController);

    HepcTicketTaskController.$inject = ['HepcTicketTask'];

    function HepcTicketTaskController(HepcTicketTask) {

        var vm = this;

        vm.hepcTicketTasks = [];

        loadAll();

        function loadAll() {
            HepcTicketTask.query(function(result) {
                vm.hepcTicketTasks = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentQualificationsDialogController', HepcRecruitmentQualificationsDialogController);

    HepcRecruitmentQualificationsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HepcRecruitmentQualifications'];

    function HepcRecruitmentQualificationsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HepcRecruitmentQualifications) {
        var vm = this;

        vm.hepcRecruitmentQualifications = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.hepcRecruitmentQualifications.id !== null) {
                HepcRecruitmentQualifications.update(vm.hepcRecruitmentQualifications, onSaveSuccess, onSaveError);
            } else {
                HepcRecruitmentQualifications.save(vm.hepcRecruitmentQualifications, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:hepcRecruitmentQualificationsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentQualificationsDetailController', HepcRecruitmentQualificationsDetailController);

    HepcRecruitmentQualificationsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HepcRecruitmentQualifications'];

    function HepcRecruitmentQualificationsDetailController($scope, $rootScope, $stateParams, previousState, entity, HepcRecruitmentQualifications) {
        var vm = this;

        vm.hepcRecruitmentQualifications = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:hepcRecruitmentQualificationsUpdate', function(event, result) {
            vm.hepcRecruitmentQualifications = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentQualificationsDeleteController',HepcRecruitmentQualificationsDeleteController);

    HepcRecruitmentQualificationsDeleteController.$inject = ['$uibModalInstance', 'entity', 'HepcRecruitmentQualifications'];

    function HepcRecruitmentQualificationsDeleteController($uibModalInstance, entity, HepcRecruitmentQualifications) {
        var vm = this;

        vm.hepcRecruitmentQualifications = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HepcRecruitmentQualifications.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hepc-recruitment-qualifications', {
            parent: 'entity',
            url: '/hepc-recruitment-qualifications',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.hepcRecruitmentQualifications.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hepc-recruitment-qualifications/hepc-recruitment-qualifications.html',
                    controller: 'HepcRecruitmentQualificationsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hepcRecruitmentQualifications');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hepc-recruitment-qualifications-detail', {
            parent: 'hepc-recruitment-qualifications',
            url: '/hepc-recruitment-qualifications/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.hepcRecruitmentQualifications.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hepc-recruitment-qualifications/hepc-recruitment-qualifications-detail.html',
                    controller: 'HepcRecruitmentQualificationsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hepcRecruitmentQualifications');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HepcRecruitmentQualifications', function($stateParams, HepcRecruitmentQualifications) {
                    return HepcRecruitmentQualifications.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'hepc-recruitment-qualifications',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('hepc-recruitment-qualifications-detail.edit', {
            parent: 'hepc-recruitment-qualifications-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-recruitment-qualifications/hepc-recruitment-qualifications-dialog.html',
                    controller: 'HepcRecruitmentQualificationsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HepcRecruitmentQualifications', function(HepcRecruitmentQualifications) {
                            return HepcRecruitmentQualifications.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hepc-recruitment-qualifications.new', {
            parent: 'hepc-recruitment-qualifications',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-recruitment-qualifications/hepc-recruitment-qualifications-dialog.html',
                    controller: 'HepcRecruitmentQualificationsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                degree: null,
                                stream: null,
                                session: null,
                                passingYear: null,
                                schoolUniversity: null,
                                specialization: null,
                                marksObtained: null,
                                marksPercentage: null,
                                regularCorrespondance: null,
                                division: null,
                                documentName: null,
                                documentType: null,
                                refId: null,
                                applicationId: null,
                                preferredLocation: null,
                                totalExperience: null,
                                jobProfile: null,
                                name: null,
                                sortIndex: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hepc-recruitment-qualifications', null, { reload: 'hepc-recruitment-qualifications' });
                }, function() {
                    $state.go('hepc-recruitment-qualifications');
                });
            }]
        })
        .state('hepc-recruitment-qualifications.edit', {
            parent: 'hepc-recruitment-qualifications',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-recruitment-qualifications/hepc-recruitment-qualifications-dialog.html',
                    controller: 'HepcRecruitmentQualificationsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HepcRecruitmentQualifications', function(HepcRecruitmentQualifications) {
                            return HepcRecruitmentQualifications.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hepc-recruitment-qualifications', null, { reload: 'hepc-recruitment-qualifications' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hepc-recruitment-qualifications.delete', {
            parent: 'hepc-recruitment-qualifications',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-recruitment-qualifications/hepc-recruitment-qualifications-delete-dialog.html',
                    controller: 'HepcRecruitmentQualificationsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HepcRecruitmentQualifications', function(HepcRecruitmentQualifications) {
                            return HepcRecruitmentQualifications.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hepc-recruitment-qualifications', null, { reload: 'hepc-recruitment-qualifications' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('HepcRecruitmentQualifications', HepcRecruitmentQualifications);

    HepcRecruitmentQualifications.$inject = ['$resource'];

    function HepcRecruitmentQualifications ($resource) {
        var resourceUrl =  'api/hepc-recruitment-qualifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentQualificationsController', HepcRecruitmentQualificationsController);

    HepcRecruitmentQualificationsController.$inject = ['HepcRecruitmentQualifications'];

    function HepcRecruitmentQualificationsController(HepcRecruitmentQualifications) {

        var vm = this;

        vm.hepcRecruitmentQualifications = [];

        loadAll();

        function loadAll() {
            HepcRecruitmentQualifications.query(function(result) {
                vm.hepcRecruitmentQualifications = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentExperienceDialogController', HepcRecruitmentExperienceDialogController);

    HepcRecruitmentExperienceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'HepcRecruitmentExperience'];

    function HepcRecruitmentExperienceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, HepcRecruitmentExperience) {
        var vm = this;

        vm.hepcRecruitmentExperience = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.hepcRecruitmentExperience.id !== null) {
                HepcRecruitmentExperience.update(vm.hepcRecruitmentExperience, onSaveSuccess, onSaveError);
            } else {
                HepcRecruitmentExperience.save(vm.hepcRecruitmentExperience, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:hepcRecruitmentExperienceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.startDate = false;
        vm.datePickerOpenStatus.endDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentExperienceDetailController', HepcRecruitmentExperienceDetailController);

    HepcRecruitmentExperienceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HepcRecruitmentExperience'];

    function HepcRecruitmentExperienceDetailController($scope, $rootScope, $stateParams, previousState, entity, HepcRecruitmentExperience) {
        var vm = this;

        vm.hepcRecruitmentExperience = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:hepcRecruitmentExperienceUpdate', function(event, result) {
            vm.hepcRecruitmentExperience = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentExperienceDeleteController',HepcRecruitmentExperienceDeleteController);

    HepcRecruitmentExperienceDeleteController.$inject = ['$uibModalInstance', 'entity', 'HepcRecruitmentExperience'];

    function HepcRecruitmentExperienceDeleteController($uibModalInstance, entity, HepcRecruitmentExperience) {
        var vm = this;

        vm.hepcRecruitmentExperience = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HepcRecruitmentExperience.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hepc-recruitment-experience', {
            parent: 'entity',
            url: '/hepc-recruitment-experience',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.hepcRecruitmentExperience.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hepc-recruitment-experience/hepc-recruitment-experiences.html',
                    controller: 'HepcRecruitmentExperienceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hepcRecruitmentExperience');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hepc-recruitment-experience-detail', {
            parent: 'hepc-recruitment-experience',
            url: '/hepc-recruitment-experience/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.hepcRecruitmentExperience.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hepc-recruitment-experience/hepc-recruitment-experience-detail.html',
                    controller: 'HepcRecruitmentExperienceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hepcRecruitmentExperience');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HepcRecruitmentExperience', function($stateParams, HepcRecruitmentExperience) {
                    return HepcRecruitmentExperience.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'hepc-recruitment-experience',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('hepc-recruitment-experience-detail.edit', {
            parent: 'hepc-recruitment-experience-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-recruitment-experience/hepc-recruitment-experience-dialog.html',
                    controller: 'HepcRecruitmentExperienceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HepcRecruitmentExperience', function(HepcRecruitmentExperience) {
                            return HepcRecruitmentExperience.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hepc-recruitment-experience.new', {
            parent: 'hepc-recruitment-experience',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-recruitment-experience/hepc-recruitment-experience-dialog.html',
                    controller: 'HepcRecruitmentExperienceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                organization: null,
                                designation: null,
                                startDate: null,
                                endDate: null,
                                totalExperience: null,
                                workField: null,
                                documentName: null,
                                documentType: null,
                                refId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('hepc-recruitment-experience', null, { reload: 'hepc-recruitment-experience' });
                }, function() {
                    $state.go('hepc-recruitment-experience');
                });
            }]
        })
        .state('hepc-recruitment-experience.edit', {
            parent: 'hepc-recruitment-experience',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-recruitment-experience/hepc-recruitment-experience-dialog.html',
                    controller: 'HepcRecruitmentExperienceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HepcRecruitmentExperience', function(HepcRecruitmentExperience) {
                            return HepcRecruitmentExperience.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hepc-recruitment-experience', null, { reload: 'hepc-recruitment-experience' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hepc-recruitment-experience.delete', {
            parent: 'hepc-recruitment-experience',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-recruitment-experience/hepc-recruitment-experience-delete-dialog.html',
                    controller: 'HepcRecruitmentExperienceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HepcRecruitmentExperience', function(HepcRecruitmentExperience) {
                            return HepcRecruitmentExperience.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hepc-recruitment-experience', null, { reload: 'hepc-recruitment-experience' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('HepcRecruitmentExperience', HepcRecruitmentExperience);

    HepcRecruitmentExperience.$inject = ['$resource', 'DateUtils'];

    function HepcRecruitmentExperience ($resource, DateUtils) {
        var resourceUrl =  'api/hepc-recruitment-experiences/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.startDate = DateUtils.convertLocalDateFromServer(data.startDate);
                        data.endDate = DateUtils.convertLocalDateFromServer(data.endDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.startDate = DateUtils.convertLocalDateToServer(copy.startDate);
                    copy.endDate = DateUtils.convertLocalDateToServer(copy.endDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentExperienceController', HepcRecruitmentExperienceController);

    HepcRecruitmentExperienceController.$inject = ['HepcRecruitmentExperience'];

    function HepcRecruitmentExperienceController(HepcRecruitmentExperience) {

        var vm = this;

        vm.hepcRecruitmentExperiences = [];

        loadAll();

        function loadAll() {
            HepcRecruitmentExperience.query(function(result) {
                vm.hepcRecruitmentExperiences = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentDialogController', HepcRecruitmentDialogController);

    HepcRecruitmentDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'HepcRecruitment', 'HepcRecruitmentQualifications', 'FileManagement', 'HepcRecruitmentExperience', 'District', 'State'];

    function HepcRecruitmentDialogController($timeout, $scope, $state, $stateParams, entity, HepcRecruitment, HepcRecruitmentQualifications, FileManagement, HepcRecruitmentExperience, District, State) {
        var vm = this;

        vm.hepcRecruitment = entity;
        vm.hepcRecruitment.locationsPreferred = [];
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.counter = 0;
        var uploadedExperience = 0;
        var totalExperience = 0;
        var totalQualifications = 0;
        var uploadedQualifications = 0;
        vm.maxFileSize = 1024*1024;
        vm.isSaving = false;
        var totalExperienceCount = 0;
        vm.states = [];
        vm.tc1 = false;
        vm.tc2 = false;
        vm.tc3 = false;
        vm.districts = [];
        vm.qualifications = {};
        $scope.file = {
            maxSizeError: false
        };
        vm.options = {
          maxDate: new Date()
        };
        $scope.more = [];
        $scope.addmore = function () {
            $scope.more.push({
                organization: null,
                designation: null,
                startDate: null,
                endDate: null,
                totalExperience: null,
                workField: null,
                documentName: null,
                documentType: null,
                refId: null,
                id: null
            });
        };

        $scope.more.push({
            organization: null,
            designation: null,
            startDate: null,
            endDate: null,
            totalExperience: null,
            workField: null,
            documentName: null,
            documentType: null,
            refId: null,
            id: null
        });

        $scope.remove_more = function (index) {
            if (index > 0) {
                $scope.more.splice(index, 1);
            } else alert("Last Row")
        };
        loadAll();

        function loadAll() {
            District.query(function (result) {
                angular.forEach(result, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value.districtname);
                    }
                });
                vm.firstLocations = copy(vm.districts);
                vm.secondLocations = copy(vm.districts);
                vm.thirdLocations = copy(vm.districts);
                vm.searchQuery = null;
            });
            State.query(function (result) {
                vm.states = result;
                vm.searchQuery = null;
            });
        }
        vm.firstLocationChanged = function(location) {
            var index1 = vm.secondLocations.indexOf(location);
            var index2 = vm.thirdLocations.indexOf(location);
            vm.secondLocations.splice(index1,1);
            vm.thirdLocations.splice(index2,1);
        };

        vm.secondLocationChanged = function(location) {
            var index1 = vm.firstLocations.indexOf(location);
            var index2 = vm.thirdLocations.indexOf(location);
            vm.firstLocations.splice(index1,1);
            vm.thirdLocations.splice(index2,1);
        };

        vm.thirdLocationChanged = function(location) {
            var index1 = vm.secondLocations.indexOf(location);
            var index2 = vm.firstLocations.indexOf(location);
            vm.secondLocations.splice(index1,1);
            vm.firstLocations.splice(index2,1);
        };

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function save() {
            if(vm.hepcRecruitment.jobProfile !== 'Relationship Executive'){
                vm.hepcRecruitment.preferredLocation = '';
                vm.hepcRecruitment.preferredLocationSecond = '';
                vm.hepcRecruitment.preferredLocationThree = '';
            }
            vm.qualificationsArray = [];
            uploadedExperience = 0;
            totalExperience = $scope.more.length;
            totalQualifications = Object.keys(vm.qualifications).length;
            uploadedQualifications = 0;
            totalExperienceCount = 0;
            for(var i=0; i < totalExperience; i++){
                totalExperienceCount = totalExperienceCount + parseInt($scope.more[i].totalExperience);
            }
            vm.hepcRecruitment.totalExperience = totalExperienceCount;
            HepcRecruitment.update(vm.hepcRecruitment, function (result) {
                FileManagement.saveFile(vm.photograph, result.id + '_photograph');
                FileManagement.saveFile(vm.signature, result.id + '_signature');
                var photographextension = getFileExtension(vm.photograph);
                var signatureextension = getFileExtension(vm.signature);
                if (vm.resume !== null && vm.resume !== undefined) {
                    FileManagement.saveFile(vm.resume, result.id + '_resume');
                    var resumeextension = getFileExtension(vm.resume);
                    result.resume = resumeextension === "" ? result.id + '_resume' : result.id + '_resume' + "." + resumeextension;
                }
                result.photograph = photographextension === "" ? result.id + '_photograph' : result.id + '_photograph' + "." + photographextension;
                result.signature = signatureextension === "" ? result.id + '_signature' : result.id + '_signature' + "." + signatureextension;
                HepcRecruitment.update(result);
                angular.forEach(vm.qualifications, function (value, key) {
                    var variable = {};
                    variable.degree = key;
                    variable.refId = result.id;
                    angular.forEach(value, function (v1, k1) {
                        variable[k1] = v1;
                    });
                    variable.name = result.name;
                    variable.jobProfile = result.jobProfile;
                    variable.preferredLocation = result.preferredLocation;
                    variable.applicationId = result.applicationId;
                    HepcRecruitmentQualifications.update(variable, function (qualificationResult) {
                        qualificationResult.documentName = qualificationResult.id;
                        if (variable.document !== null && variable.document !== undefined) {
                            FileManagement.saveFile(variable.document, qualificationResult.documentName);
                            var extension = getFileExtension(variable.document);
                            qualificationResult.documentName = extension === "" ? qualificationResult.id : qualificationResult.id + "." + extension;
                            HepcRecruitmentQualifications.update(qualificationResult, function () {
                                ++uploadedQualifications;
                                console.log(uploadedQualifications);
                                console.log('uploadexp',uploadedExperience,'totalexp', totalExperience,'uploadQuals', uploadedQualifications ,'totalquals', totalQualifications);
                                if (uploadedExperience === totalExperience && uploadedQualifications === totalQualifications) {
                                    alert('Your Form Is Saved');
                                    $scope.$emit('investhryApp:hepcRecruitmentUpdate', result);
                                    vm.isSaving = false;
                                    $state.go('home');
                                }
                            }, function (err) {
                                vm.isSaving = false;
                            });
                        }
                    }, function (err) {
                        vm.isSaving = false;
                    });
                });
                angular.forEach($scope.more, function (experience) {
                    experience.refId = result.id;
                    HepcRecruitmentExperience.save(experience, function (savedExperience) {
                        if (experience.document !== null && experience.document !== undefined) {
                            FileManagement.saveFile(experience.document, savedExperience.id);
                            var extension = getFileExtension(experience.document);
                            savedExperience.documentName = extension === "" ? savedExperience.id : savedExperience.id + "." + extension;
                            HepcRecruitmentExperience.update(savedExperience, function () {
                                ++uploadedExperience;
                                console.log(uploadedExperience);
                                console.log('uploadexp',uploadedExperience,'totalexp', totalExperience,'uploadQuals', uploadedQualifications ,'totalquals', totalQualifications);
                                if (uploadedExperience === totalExperience && uploadedQualifications === totalQualifications) {
                                    console.log('here');
                                    alert('your form is saved');
                                    $scope.$emit('investhryApp:hepcRecruitmentUpdate', result);
                                    vm.isSaving = false;
                                    $state.go('home');
                                }
                            }, function (err) {
                                vm.isSaving = false;
                            })
                        }
                    }, function (err) {
                        vm.isSaving = false;
                    });
                });
            }, function (err) {
                vm.isSaving = false;
            });
        }

        function onSaveSuccess(result) {
            $scope.$emit('investhryApp:hepcRecruitmentUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateOfBirth = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
            console.log(date);
        }

        $scope.imageToBase = function (input) {
            console.log(input);
            var file = $scope + '.' + input;
            console.log(file);
            var reader = new FileReader();
            reader.onloadend = function () {
                console.log('RESULT', reader.result)
            };
            reader.readAsDataURL(file);
        };


        function getFileExtension(file) {
            var fileNameArray = file.name.split(".");
            var fileextension = "";
            if ((fileNameArray.length > 1)) {
                fileextension = fileNameArray[(fileNameArray.length - 1)];
                return fileextension;
            }
            return "";
        }
        vm.degreeDateOptions = {};
        $scope.getDate = function(degree, nextDegree, minTime){
            var year = new Date(degree).getFullYear() + minTime;
            var nextDegreeDate = new Date(year, new Date(degree).getMonth(), new Date(degree).getDate());
            vm.degreeDateOptions[nextDegree] = {
                minDate: nextDegreeDate
            };
            vm.degreeDateOptions.others = vm.degreeDateOptions.twelveth;
        };

        function copy(value) {
            var a = [];
            value.forEach(function (val) {
               a.push(val);
            });
            return a;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentDetailController', HepcRecruitmentDetailController);

    HepcRecruitmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'HepcRecruitment','viewRecruitmentFile','HepcRecruitmentQualificationsByRefId','HepcRecruitmentExperienceByRefId'];

    function HepcRecruitmentDetailController($scope, $rootScope, $stateParams, previousState, entity, HepcRecruitment,viewRecruitmentFile,HepcRecruitmentQualificationsByRefId,HepcRecruitmentExperienceByRefId) {
        var vm = this;

        vm.hepcRecruitment = entity;
        vm.previousState = previousState.name;
        vm.viewDocument = viewDocument;
        var unsubscribe = $rootScope.$on('investhryApp:hepcRecruitmentUpdate', function(event, result) {
            vm.hepcRecruitment = result;
        });
        vm.hepcRecruitmentQualifications = [];
        vm.hepcRecruitmentExperiences = [];
        $scope.$on('$destroy', unsubscribe);

        function viewDocument(document){
            if(document === 'photo'){
                viewRecruitmentFile.view(entity.photograph);
            }else if(document === 'sign'){
                viewRecruitmentFile.view(entity.signature);
            }else if(document === 'resume'){
                viewRecruitmentFile.view(entity.resume);
            }else viewRecruitmentFile.view(document);
        }
        loadAll();
        function loadAll() {
            HepcRecruitmentQualificationsByRefId.query({refId: vm.hepcRecruitment.id}, function (data) {
                vm.hepcRecruitmentQualifications = data;
            });
            HepcRecruitmentExperienceByRefId.query({refId: vm.hepcRecruitment.id}, function (data) {
                console.log(data);
                vm.hepcRecruitmentExperiences = data;
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentDeleteController',HepcRecruitmentDeleteController);

    HepcRecruitmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'HepcRecruitment'];

    function HepcRecruitmentDeleteController($uibModalInstance, entity, HepcRecruitment) {
        var vm = this;

        vm.hepcRecruitment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            HepcRecruitment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('hepc-recruitment', {
            parent: 'entity',
            url: '/hepc-recruitment',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.hepcRecruitment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hepc-recruitment/hepc-recruitments.html',
                    controller: 'HepcRecruitmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hepcRecruitment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('hepc-recruitment-detail', {
            parent: 'hepc-recruitment',
            url: '/hepc-recruitment/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.hepcRecruitment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hepc-recruitment/hepc-recruitment-detail.html',
                    controller: 'HepcRecruitmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('hepcRecruitment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'HepcRecruitment', function($stateParams, HepcRecruitment) {
                    return HepcRecruitment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'hepc-recruitment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('hepc-recruitment-detail.edit', {
            parent: 'hepc-recruitment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-recruitment/hepc-recruitment-dialog.html',
                    controller: 'HepcRecruitmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HepcRecruitment', function(HepcRecruitment) {
                            return HepcRecruitment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hepc-recruitment.new', {
            parent: 'hepc-recruitment',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/hepc-recruitment/hepc-recruitment-dialog.html',
                    controller: 'HepcRecruitmentDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        fatherHusbandName: null,
                        gender: null,
                        dateOfBirth: null,
                        aadharNumber: null,
                        correspondenceAddress: null,
                        correspondenceDistrict: null,
                        correspondenceState: null,
                        permanentAddress: null,
                        permanentDistrict: null,
                        permanentState: null,
                        contactNumber: null,
                        alternateContactNumber: null,
                        email: null,
                        preferredLocation: null,
                        id: null
                    };
                }
            }
        })
        .state('hepc-recruitment.edit', {
            parent: 'hepc-recruitment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-recruitment/hepc-recruitment-dialog.html',
                    controller: 'HepcRecruitmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['HepcRecruitment', function(HepcRecruitment) {
                            return HepcRecruitment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hepc-recruitment', null, { reload: 'hepc-recruitment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('hepc-recruitment.delete', {
            parent: 'hepc-recruitment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/hepc-recruitment/hepc-recruitment-delete-dialog.html',
                    controller: 'HepcRecruitmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['HepcRecruitment', function(HepcRecruitment) {
                            return HepcRecruitment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('hepc-recruitment', null, { reload: 'hepc-recruitment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('HepcRecruitment', HepcRecruitment);

    HepcRecruitment.$inject = ['$resource', 'DateUtils'];

    function HepcRecruitment ($resource, DateUtils) {
        var resourceUrl =  'api/hepc-recruitments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfBirth = DateUtils.convertDateTimeFromServer(data.dateOfBirth);
                        data.signatureDate = DateUtils.convertLocalDateFromServer(data.signatureDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.signatureDate = DateUtils.convertLocalDateToServer(copy.signatureDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.signatureDate = DateUtils.convertLocalDateToServer(copy.signatureDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HepcRecruitmentController', HepcRecruitmentController);

    HepcRecruitmentController.$inject = ['HepcRecruitment'];

    function HepcRecruitmentController(HepcRecruitment) {

        var vm = this;

        vm.hepcRecruitments = [];

        loadAll();

        function loadAll() {
            HepcRecruitment.query(function(result) {
                vm.hepcRecruitments = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceLogDialogController', GrievanceLogDialogController);

    GrievanceLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GrievanceLog'];

    function GrievanceLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GrievanceLog) {
        var vm = this;

        vm.grievanceLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.grievanceLog.id !== null) {
                GrievanceLog.update(vm.grievanceLog, onSaveSuccess, onSaveError);
            } else {
                GrievanceLog.save(vm.grievanceLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:grievanceLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.actionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceLogDetailController', GrievanceLogDetailController);

    GrievanceLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GrievanceLog'];

    function GrievanceLogDetailController($scope, $rootScope, $stateParams, previousState, entity, GrievanceLog) {
        var vm = this;

        vm.grievanceLog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:grievanceLogUpdate', function(event, result) {
            vm.grievanceLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceLogDeleteController',GrievanceLogDeleteController);

    GrievanceLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'GrievanceLog'];

    function GrievanceLogDeleteController($uibModalInstance, entity, GrievanceLog) {
        var vm = this;

        vm.grievanceLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GrievanceLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('grievance-log', {
            parent: 'entity',
            url: '/grievance-log',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.grievanceLog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/grievance-log/grievance-logs.html',
                    controller: 'GrievanceLogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('grievanceLog');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('grievance-log-detail', {
            parent: 'grievance-log',
            url: '/grievance-log/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.grievanceLog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/grievance-log/grievance-log-detail.html',
                    controller: 'GrievanceLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('grievanceLog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GrievanceLog', function($stateParams, GrievanceLog) {
                    return GrievanceLog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'grievance-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('grievance-log-detail.edit', {
            parent: 'grievance-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-log/grievance-log-dialog.html',
                    controller: 'GrievanceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GrievanceLog', function(GrievanceLog) {
                            return GrievanceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('grievance-log.new', {
            parent: 'grievance-log',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-log/grievance-log-dialog.html',
                    controller: 'GrievanceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                grievanceId: null,
                                action: null,
                                actionDate: null,
                                actionComment: null,
                                actionBy: null,
                                attachment: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('grievance-log', null, { reload: 'grievance-log' });
                }, function() {
                    $state.go('grievance-log');
                });
            }]
        })
        .state('grievance-log.edit', {
            parent: 'grievance-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-log/grievance-log-dialog.html',
                    controller: 'GrievanceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GrievanceLog', function(GrievanceLog) {
                            return GrievanceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('grievance-log', null, { reload: 'grievance-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('grievance-log.delete', {
            parent: 'grievance-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-log/grievance-log-delete-dialog.html',
                    controller: 'GrievanceLogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GrievanceLog', function(GrievanceLog) {
                            return GrievanceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('grievance-log', null, { reload: 'grievance-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('GrievanceLog', GrievanceLog);

    GrievanceLog.$inject = ['$resource', 'DateUtils'];

    function GrievanceLog ($resource, DateUtils) {
        var resourceUrl =  'api/grievance-logs/:id/:grievanceId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.actionDate = DateUtils.convertDateTimeFromServer(data.actionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceLogController', GrievanceLogController);

    GrievanceLogController.$inject = ['GrievanceLog'];

    function GrievanceLogController(GrievanceLog) {

        var vm = this;

        vm.grievanceLogs = [];

        loadAll();

        function loadAll() {
            GrievanceLog.query(function(result) {
                vm.grievanceLogs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceDashboardOutputDialogController', GrievanceDashboardOutputDialogController);

    GrievanceDashboardOutputDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GrievanceDashboardOutput'];

    function GrievanceDashboardOutputDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GrievanceDashboardOutput) {
        var vm = this;

        vm.grievanceDashboardOutput = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.grievanceDashboardOutput.id !== null) {
                GrievanceDashboardOutput.update(vm.grievanceDashboardOutput, onSaveSuccess, onSaveError);
            } else {
                GrievanceDashboardOutput.save(vm.grievanceDashboardOutput, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:grievanceDashboardOutputUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceDashboardOutputDetailController', GrievanceDashboardOutputDetailController);

    GrievanceDashboardOutputDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GrievanceDashboardOutput'];

    function GrievanceDashboardOutputDetailController($scope, $rootScope, $stateParams, previousState, entity, GrievanceDashboardOutput) {
        var vm = this;

        vm.grievanceDashboardOutput = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:grievanceDashboardOutputUpdate', function(event, result) {
            vm.grievanceDashboardOutput = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceDashboardOutputDeleteController',GrievanceDashboardOutputDeleteController);

    GrievanceDashboardOutputDeleteController.$inject = ['$uibModalInstance', 'entity', 'GrievanceDashboardOutput'];

    function GrievanceDashboardOutputDeleteController($uibModalInstance, entity, GrievanceDashboardOutput) {
        var vm = this;

        vm.grievanceDashboardOutput = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GrievanceDashboardOutput.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('grievance-dashboard-output', {
            parent: 'entity',
            url: '/grievance-dashboard-output',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.grievanceDashboardOutput.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/grievance-dashboard-output/grievance-dashboard-outputs.html',
                    controller: 'GrievanceDashboardOutputController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('grievanceDashboardOutput');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('grievance-dashboard-output-detail', {
            parent: 'grievance-dashboard-output',
            url: '/grievance-dashboard-output/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.grievanceDashboardOutput.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/grievance-dashboard-output/grievance-dashboard-output-detail.html',
                    controller: 'GrievanceDashboardOutputDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('grievanceDashboardOutput');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GrievanceDashboardOutput', function($stateParams, GrievanceDashboardOutput) {
                    return GrievanceDashboardOutput.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'grievance-dashboard-output',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('grievance-dashboard-output-detail.edit', {
            parent: 'grievance-dashboard-output-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-dashboard-output/grievance-dashboard-output-dialog.html',
                    controller: 'GrievanceDashboardOutputDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GrievanceDashboardOutput', function(GrievanceDashboardOutput) {
                            return GrievanceDashboardOutput.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('grievance-dashboard-output.new', {
            parent: 'grievance-dashboard-output',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-dashboard-output/grievance-dashboard-output-dialog.html',
                    controller: 'GrievanceDashboardOutputDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                deptname: null,
                                districtname: null,
                                total: null,
                                unassigned: null,
                                assigned: null,
                                pending: null,
                                resolved: null,
                                deptid: null,
                                districtid: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('grievance-dashboard-output', null, { reload: 'grievance-dashboard-output' });
                }, function() {
                    $state.go('grievance-dashboard-output');
                });
            }]
        })
        .state('grievance-dashboard-output.edit', {
            parent: 'grievance-dashboard-output',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-dashboard-output/grievance-dashboard-output-dialog.html',
                    controller: 'GrievanceDashboardOutputDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GrievanceDashboardOutput', function(GrievanceDashboardOutput) {
                            return GrievanceDashboardOutput.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('grievance-dashboard-output', null, { reload: 'grievance-dashboard-output' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('grievance-dashboard-output.delete', {
            parent: 'grievance-dashboard-output',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-dashboard-output/grievance-dashboard-output-delete-dialog.html',
                    controller: 'GrievanceDashboardOutputDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GrievanceDashboardOutput', function(GrievanceDashboardOutput) {
                            return GrievanceDashboardOutput.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('grievance-dashboard-output', null, { reload: 'grievance-dashboard-output' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('GrievanceDashboardOutput', GrievanceDashboardOutput);

    GrievanceDashboardOutput.$inject = ['$resource'];

    function GrievanceDashboardOutput ($resource) {
        var resourceUrl =  'api/grievance-dashboard-outputs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceDashboardOutputController', GrievanceDashboardOutputController);

    GrievanceDashboardOutputController.$inject = ['GrievanceDashboardOutput'];

    function GrievanceDashboardOutputController(GrievanceDashboardOutput) {

        var vm = this;

        vm.grievanceDashboardOutputs = [];

        loadAll();

        function loadAll() {
            GrievanceDashboardOutput.query(function(result) {
                vm.grievanceDashboardOutputs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceAssignDialogController', GrievanceAssignDialogController);

    GrievanceAssignDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'GrievanceAssign'];

    function GrievanceAssignDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, GrievanceAssign) {
        var vm = this;

        vm.grievanceAssign = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.grievanceAssign.id !== null) {
                GrievanceAssign.update(vm.grievanceAssign, onSaveSuccess, onSaveError);
            } else {
                GrievanceAssign.save(vm.grievanceAssign, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:grievanceAssignUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.assignDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceAssignDetailController', GrievanceAssignDetailController);

    GrievanceAssignDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'GrievanceAssign'];

    function GrievanceAssignDetailController($scope, $rootScope, $stateParams, previousState, entity, GrievanceAssign) {
        var vm = this;

        vm.grievanceAssign = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:grievanceAssignUpdate', function(event, result) {
            vm.grievanceAssign = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceAssignDeleteController',GrievanceAssignDeleteController);

    GrievanceAssignDeleteController.$inject = ['$uibModalInstance', 'entity', 'GrievanceAssign'];

    function GrievanceAssignDeleteController($uibModalInstance, entity, GrievanceAssign) {
        var vm = this;

        vm.grievanceAssign = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            GrievanceAssign.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('grievance-assign', {
            parent: 'entity',
            url: '/grievance-assign',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.grievanceAssign.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/grievance-assign/grievance-assigns.html',
                    controller: 'GrievanceAssignController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('grievanceAssign');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('grievance-assign-detail', {
            parent: 'grievance-assign',
            url: '/grievance-assign/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.grievanceAssign.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/grievance-assign/grievance-assign-detail.html',
                    controller: 'GrievanceAssignDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('grievanceAssign');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'GrievanceAssign', function($stateParams, GrievanceAssign) {
                    return GrievanceAssign.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'grievance-assign',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('grievance-assign-detail.edit', {
            parent: 'grievance-assign-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-assign/grievance-assign-dialog.html',
                    controller: 'GrievanceAssignDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GrievanceAssign', function(GrievanceAssign) {
                            return GrievanceAssign.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('grievance-assign.new', {
            parent: 'grievance-assign',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-assign/grievance-assign-dialog.html',
                    controller: 'GrievanceAssignDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                grievanceId: null,
                                assignBy: null,
                                assignDate: null,
                                assignTo: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('grievance-assign', null, { reload: 'grievance-assign' });
                }, function() {
                    $state.go('grievance-assign');
                });
            }]
        })
        .state('grievance-assign.edit', {
            parent: 'grievance-assign',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-assign/grievance-assign-dialog.html',
                    controller: 'GrievanceAssignDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['GrievanceAssign', function(GrievanceAssign) {
                            return GrievanceAssign.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('grievance-assign', null, { reload: 'grievance-assign' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('grievance-assign.delete', {
            parent: 'grievance-assign',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance-assign/grievance-assign-delete-dialog.html',
                    controller: 'GrievanceAssignDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['GrievanceAssign', function(GrievanceAssign) {
                            return GrievanceAssign.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('grievance-assign', null, { reload: 'grievance-assign' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('GrievanceAssign', GrievanceAssign);

    GrievanceAssign.$inject = ['$resource', 'DateUtils'];

    function GrievanceAssign ($resource, DateUtils) {
        var resourceUrl =  'api/grievance-assigns/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.assignDate = DateUtils.convertDateTimeFromServer(data.assignDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceAssignController', GrievanceAssignController);

    GrievanceAssignController.$inject = ['GrievanceAssign'];

    function GrievanceAssignController(GrievanceAssign) {

        var vm = this;

        vm.grievanceAssigns = [];

        loadAll();

        function loadAll() {
            GrievanceAssign.query(function(result) {
                vm.grievanceAssigns = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceDialogController', GrievanceDialogController);

    GrievanceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Grievance'];

    function GrievanceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Grievance) {
        var vm = this;

        vm.grievance = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.grievance.id !== null) {
                Grievance.update(vm.grievance, onSaveSuccess, onSaveError);
            } else {
                Grievance.save(vm.grievance, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:grievanceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.grievanceDate = false;
        vm.datePickerOpenStatus.resolveDate = false;
        vm.datePickerOpenStatus.assignDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceDetailController', GrievanceDetailController);

    GrievanceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Grievance'];

    function GrievanceDetailController($scope, $rootScope, $stateParams, previousState, entity, Grievance) {
        var vm = this;

        vm.grievance = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:grievanceUpdate', function(event, result) {
            vm.grievance = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceDeleteController',GrievanceDeleteController);

    GrievanceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Grievance'];

    function GrievanceDeleteController($uibModalInstance, entity, Grievance) {
        var vm = this;

        vm.grievance = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Grievance.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('grievance', {
            parent: 'entity',
            url: '/grievance',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.grievance.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/grievance/grievances.html',
                    controller: 'GrievanceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('grievance');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('grievance-detail', {
            parent: 'grievance',
            url: '/grievance/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.grievance.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/grievance/grievance-detail.html',
                    controller: 'GrievanceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('grievance');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Grievance', function($stateParams, Grievance) {
                    return Grievance.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'grievance',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('grievance-detail.edit', {
            parent: 'grievance-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance/grievance-dialog.html',
                    controller: 'GrievanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Grievance', function(Grievance) {
                            return Grievance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('grievance.new', {
            parent: 'grievance',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance/grievance-dialog.html',
                    controller: 'GrievanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                grievanceId: null,
                                grievanceDate: null,
                                grievanceBy: null,
                                grievance: null,
                                status: null,
                                resolveComment: null,
                                resolveDate: null,
                                resolveBy: null,
                                assignTo: null,
                                assignDate: null,
                                assignBy: null,
                                assignStatus: null,
                                district: null,
                                department: null,
                                districtId: null,
                                departmentId: null,
                                isResolved: null,
                                isUserAttachmentPresent: false,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('grievance', null, { reload: 'grievance' });
                }, function() {
                    $state.go('grievance');
                });
            }]
        })
        .state('grievance.edit', {
            parent: 'grievance',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance/grievance-dialog.html',
                    controller: 'GrievanceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Grievance', function(Grievance) {
                            return Grievance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('grievance', null, { reload: 'grievance' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('grievance.delete', {
            parent: 'grievance',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/grievance/grievance-delete-dialog.html',
                    controller: 'GrievanceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Grievance', function(Grievance) {
                            return Grievance.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('grievance', null, { reload: 'grievance' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Grievance', Grievance);

    Grievance.$inject = ['$resource', 'DateUtils'];

    function Grievance ($resource, DateUtils) {
        var resourceUrl =  'api/grievances/:id/:user/:admin';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.grievanceDate = DateUtils.convertDateTimeFromServer(data.grievanceDate);
                        data.resolveDate = DateUtils.convertDateTimeFromServer(data.resolveDate);
                        data.assignDate = DateUtils.convertDateTimeFromServer(data.assignDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('GrievanceController', GrievanceController);

    GrievanceController.$inject = ['Grievance'];

    function GrievanceController(Grievance) {

        var vm = this;

        vm.grievances = [];

        loadAll();

        function loadAll() {
            Grievance.query(function(result) {
                vm.grievances = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ForeignfundingresourceDialogController', ForeignfundingresourceDialogController);

    ForeignfundingresourceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Foreignfundingresource'];

    function ForeignfundingresourceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Foreignfundingresource) {
        var vm = this;

        vm.foreignfundingresource = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.foreignfundingresource.id !== null) {
                Foreignfundingresource.update(vm.foreignfundingresource, onSaveSuccess, onSaveError);
            } else {
                Foreignfundingresource.save(vm.foreignfundingresource, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:foreignfundingresourceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ForeignfundingresourceDetailController', ForeignfundingresourceDetailController);

    ForeignfundingresourceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Foreignfundingresource'];

    function ForeignfundingresourceDetailController($scope, $rootScope, $stateParams, previousState, entity, Foreignfundingresource) {
        var vm = this;

        vm.foreignfundingresource = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:foreignfundingresourceUpdate', function(event, result) {
            vm.foreignfundingresource = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ForeignfundingresourceDeleteController',ForeignfundingresourceDeleteController);

    ForeignfundingresourceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Foreignfundingresource'];

    function ForeignfundingresourceDeleteController($uibModalInstance, entity, Foreignfundingresource) {
        var vm = this;

        vm.foreignfundingresource = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Foreignfundingresource.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('foreignfundingresource', {
            parent: 'entity',
            url: '/foreignfundingresource',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.foreignfundingresource.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/foreignfundingresource/foreignfundingresources.html',
                    controller: 'ForeignfundingresourceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('foreignfundingresource');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('foreignfundingresource-detail', {
            parent: 'foreignfundingresource',
            url: '/foreignfundingresource/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.foreignfundingresource.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/foreignfundingresource/foreignfundingresource-detail.html',
                    controller: 'ForeignfundingresourceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('foreignfundingresource');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Foreignfundingresource', function($stateParams, Foreignfundingresource) {
                    return Foreignfundingresource.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'foreignfundingresource',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('foreignfundingresource-detail.edit', {
            parent: 'foreignfundingresource-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/foreignfundingresource/foreignfundingresource-dialog.html',
                    controller: 'ForeignfundingresourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Foreignfundingresource', function(Foreignfundingresource) {
                            return Foreignfundingresource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('foreignfundingresource.new', {
            parent: 'foreignfundingresource',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/foreignfundingresource/foreignfundingresource-dialog.html',
                    controller: 'ForeignfundingresourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                foreignfundingtypes: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('foreignfundingresource', null, { reload: 'foreignfundingresource' });
                }, function() {
                    $state.go('foreignfundingresource');
                });
            }]
        })
        .state('foreignfundingresource.edit', {
            parent: 'foreignfundingresource',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/foreignfundingresource/foreignfundingresource-dialog.html',
                    controller: 'ForeignfundingresourceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Foreignfundingresource', function(Foreignfundingresource) {
                            return Foreignfundingresource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('foreignfundingresource', null, { reload: 'foreignfundingresource' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('foreignfundingresource.delete', {
            parent: 'foreignfundingresource',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/foreignfundingresource/foreignfundingresource-delete-dialog.html',
                    controller: 'ForeignfundingresourceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Foreignfundingresource', function(Foreignfundingresource) {
                            return Foreignfundingresource.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('foreignfundingresource', null, { reload: 'foreignfundingresource' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Foreignfundingresource', Foreignfundingresource);

    Foreignfundingresource.$inject = ['$resource'];

    function Foreignfundingresource ($resource) {
        var resourceUrl =  'api/foreignfundingresources/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ForeignfundingresourceController', ForeignfundingresourceController);

    ForeignfundingresourceController.$inject = ['Foreignfundingresource'];

    function ForeignfundingresourceController(Foreignfundingresource) {

        var vm = this;

        vm.foreignfundingresources = [];

        loadAll();

        function loadAll() {
            Foreignfundingresource.query(function(result) {
                vm.foreignfundingresources = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FiletestingDialogController', FiletestingDialogController);

    FiletestingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Filetesting','FileManagement','$http'];

    function FiletestingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Filetesting,FileManagement,$http) {
        var vm = this;

        vm.filetesting = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            console.log(vm.filetesting.file);
            vm.isSaving = true;
            if (vm.filetesting.id !== null) {
                Filetesting.update(vm.filetesting, onSaveSuccess, onSaveError);
            } else {
                Filetesting.save(vm.filetesting, onSaveSuccess, onSaveError);
            }
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        function onSaveSuccess (result)
        {
            var file = vm.filetesting.file;
            var uploadUrl = "api/FileManagement";
            var fd = new FormData();
            fd.append('file', file);
            fd.append('filename',result.id);

            $http.post(uploadUrl, fd, {
            transformRequest : angular.identity,
            headers : {
            'Content-Type' : undefined
            }
            }).success(function() {
            console.log('success');
            }).error(function() {
            console.log('error');
            });

            vm.isSaving = false;
            $scope.$emit('investhryApp:filetestingUpdate', result);
            $uibModalInstance.close(result);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FiletestingDetailController', FiletestingDetailController);

    FiletestingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Filetesting'];

    function FiletestingDetailController($scope, $rootScope, $stateParams, previousState, entity, Filetesting) {
        var vm = this;

        vm.filetesting = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:filetestingUpdate', function(event, result) {
            vm.filetesting = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FiletestingDeleteController',FiletestingDeleteController);

    FiletestingDeleteController.$inject = ['$uibModalInstance', 'entity', 'Filetesting'];

    function FiletestingDeleteController($uibModalInstance, entity, Filetesting) {
        var vm = this;

        vm.filetesting = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Filetesting.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('filetesting', {
            parent: 'entity',
            url: '/filetesting',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.filetesting.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/filetesting/filetestings.html',
                    controller: 'FiletestingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('filetesting');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('filetesting-detail', {
            parent: 'filetesting',
            url: '/filetesting/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.filetesting.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/filetesting/filetesting-detail.html',
                    controller: 'FiletestingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('filetesting');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Filetesting', function($stateParams, Filetesting) {
                    return Filetesting.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'filetesting',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('filetesting-detail.edit', {
            parent: 'filetesting-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/filetesting/filetesting-dialog.html',
                    controller: 'FiletestingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Filetesting', function(Filetesting) {
                            return Filetesting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('filetesting.new', {
            parent: 'filetesting',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/filetesting/filetesting-dialog.html',
                    controller: 'FiletestingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                filename: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('filetesting', null, { reload: 'filetesting' });
                }, function() {
                    $state.go('filetesting');
                });
            }]
        })
        .state('filetesting.edit', {
            parent: 'filetesting',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/filetesting/filetesting-dialog.html',
                    controller: 'FiletestingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Filetesting', function(Filetesting) {
                            return Filetesting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('filetesting', null, { reload: 'filetesting' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('filetesting.delete', {
            parent: 'filetesting',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/filetesting/filetesting-delete-dialog.html',
                    controller: 'FiletestingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Filetesting', function(Filetesting) {
                            return Filetesting.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('filetesting', null, { reload: 'filetesting' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Filetesting', Filetesting);

    Filetesting.$inject = ['$resource'];

    function Filetesting ($resource) {
        var resourceUrl =  'api/filetestings/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FiletestingController', FiletestingController);

    FiletestingController.$inject = ['Filetesting'];

    function FiletestingController(Filetesting) {

        var vm = this;

        vm.filetestings = [];

        loadAll();

        function loadAll() {
            Filetesting.query(function(result) {
                vm.filetestings = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FeedbackOfficerDialogController', FeedbackOfficerDialogController);

    FeedbackOfficerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FeedbackOfficer', 'District', 'Department'];

    function FeedbackOfficerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FeedbackOfficer, District, Department) {
        var vm = this;

        vm.feedbackOfficer = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.onDepartmentChange = function(department){
            vm.feedbackOfficer.departmentId = department.id;
            vm.departmentName = department.departmentname;
        }

        function save () {
            vm.isSaving = true;
            vm.feedbackOfficer.departmentName = vm.departmentName;
            if (vm.feedbackOfficer.id !== null) {
                FeedbackOfficer.update(vm.feedbackOfficer, onSaveSuccess, onSaveError);
            } else {
                FeedbackOfficer.save(vm.feedbackOfficer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:feedbackOfficerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.districts = [];
        loadAllDistricts();
        function loadAllDistricts() {
            District.query(function(result) {
                vm.districts = result;
                vm.searchQuery = null;
                var obj={districtname:'Haryana',
                        powercompany:null,
                        stateID:null,
                        id:null,
                        statename:'Haryana'};
                vm.districts.push(obj);
            });
        }

        vm.departments = [];
        loadAllDepartments();
        function loadAllDepartments() {
            Department.query(function(result) {
                vm.departmentstemp = result;
                angular.forEach(vm.departmentstemp, function(value, key){
                    if(value.departmentname!=='Development and Panchayats'){
                        vm.departments.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FeedbackOfficerDetailController', FeedbackOfficerDetailController);

    FeedbackOfficerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FeedbackOfficer'];

    function FeedbackOfficerDetailController($scope, $rootScope, $stateParams, previousState, entity, FeedbackOfficer) {
        var vm = this;

        vm.feedbackOfficer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:feedbackOfficerUpdate', function(event, result) {
            vm.feedbackOfficer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FeedbackOfficerDeleteController',FeedbackOfficerDeleteController);

    FeedbackOfficerDeleteController.$inject = ['$uibModalInstance', 'entity', 'FeedbackOfficer'];

    function FeedbackOfficerDeleteController($uibModalInstance, entity, FeedbackOfficer) {
        var vm = this;

        vm.feedbackOfficer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FeedbackOfficer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('feedback-officer', {
            parent: 'entity',
            url: '/feedback-officer',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.feedbackOfficer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/feedback-officer/feedback-officers.html',
                    controller: 'FeedbackOfficerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feedbackOfficer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('feedback-officer-detail', {
            parent: 'feedback-officer',
            url: '/feedback-officer/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.feedbackOfficer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/feedback-officer/feedback-officer-detail.html',
                    controller: 'FeedbackOfficerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feedbackOfficer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FeedbackOfficer', function($stateParams, FeedbackOfficer) {
                    return FeedbackOfficer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'feedback-officer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('feedback-officer-detail.edit', {
            parent: 'feedback-officer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feedback-officer/feedback-officer-dialog.html',
                    controller: 'FeedbackOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FeedbackOfficer', function(FeedbackOfficer) {
                            return FeedbackOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('feedback-officer.new', {
            parent: 'feedback-officer',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feedback-officer/feedback-officer-dialog.html',
                    controller: 'FeedbackOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                login: null,
                                departmentName: null,
                                departmentId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('feedback-officer', null, { reload: 'feedback-officer' });
                }, function() {
                    $state.go('feedback-officer');
                });
            }]
        })
        .state('feedback-officer.edit', {
            parent: 'feedback-officer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feedback-officer/feedback-officer-dialog.html',
                    controller: 'FeedbackOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FeedbackOfficer', function(FeedbackOfficer) {
                            return FeedbackOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('feedback-officer', null, { reload: 'feedback-officer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('feedback-officer.delete', {
            parent: 'feedback-officer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/feedback-officer/feedback-officer-delete-dialog.html',
                    controller: 'FeedbackOfficerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FeedbackOfficer', function(FeedbackOfficer) {
                            return FeedbackOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('feedback-officer', null, { reload: 'feedback-officer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('FeedbackOfficer', FeedbackOfficer);

    FeedbackOfficer.$inject = ['$resource'];

    function FeedbackOfficer ($resource) {
        var resourceUrl =  'api/feedback-officers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FeedbackOfficerController', FeedbackOfficerController);

    FeedbackOfficerController.$inject = ['FeedbackOfficer'];

    function FeedbackOfficerController(FeedbackOfficer) {

        var vm = this;

        vm.feedbackOfficers = [];

        loadAll();

        function loadAll() {
            FeedbackOfficer.query(function(result) {
                vm.feedbackOfficers = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FactotyPlanDialogController', FactotyPlanDialogController);

    FactotyPlanDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FactotyPlan'];

    function FactotyPlanDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, FactotyPlan) {
        var vm = this;

        vm.factotyPlan = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.factotyPlan.id !== null) {
                FactotyPlan.update(vm.factotyPlan, onSaveSuccess, onSaveError);
            } else {
                FactotyPlan.save(vm.factotyPlan, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:factotyPlanUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.datePlant = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FactotyPlanDetailController', FactotyPlanDetailController);

    FactotyPlanDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'FactotyPlan'];

    function FactotyPlanDetailController($scope, $rootScope, $stateParams, previousState, entity, FactotyPlan) {
        var vm = this;

        vm.factotyPlan = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:factotyPlanUpdate', function(event, result) {
            vm.factotyPlan = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FactotyPlanDeleteController',FactotyPlanDeleteController);

    FactotyPlanDeleteController.$inject = ['$uibModalInstance', 'entity', 'FactotyPlan'];

    function FactotyPlanDeleteController($uibModalInstance, entity, FactotyPlan) {
        var vm = this;

        vm.factotyPlan = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            FactotyPlan.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('factoty-plan', {
            parent: 'entity',
            url: '/factoty-plan',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.factotyPlan.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/factoty-plan/factoty-plans.html',
                    controller: 'FactotyPlanController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('factotyPlan');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('factoty-plan-detail', {
            parent: 'factoty-plan',
            url: '/factoty-plan/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.factotyPlan.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/factoty-plan/factoty-plan-detail.html',
                    controller: 'FactotyPlanDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('factotyPlan');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'FactotyPlan', function($stateParams, FactotyPlan) {
                    return FactotyPlan.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'factoty-plan',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('factoty-plan-detail.edit', {
            parent: 'factoty-plan-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/factoty-plan/factoty-plan-dialog.html',
                    controller: 'FactotyPlanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FactotyPlan', function(FactotyPlan) {
                            return FactotyPlan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('factoty-plan.new', {
            parent: 'factoty-plan',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/factoty-plan/factoty-plan-dialog.html',
                    controller: 'FactotyPlanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nameApplicant: null,
                                applicantAddress: null,
                                factoryAddress: null,
                                factorySituation: null,
                                state: null,
                                district: null,
                                town: null,
                                nearestRailwayStation: null,
                                perticularPlant: null,
                                datePlant: null,
                                factoryName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('factoty-plan', null, { reload: 'factoty-plan' });
                }, function() {
                    $state.go('factoty-plan');
                });
            }]
        })
        .state('factoty-plan.edit', {
            parent: 'factoty-plan',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/factoty-plan/factoty-plan-dialog.html',
                    controller: 'FactotyPlanDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['FactotyPlan', function(FactotyPlan) {
                            return FactotyPlan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('factoty-plan', null, { reload: 'factoty-plan' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('factoty-plan.delete', {
            parent: 'factoty-plan',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/factoty-plan/factoty-plan-delete-dialog.html',
                    controller: 'FactotyPlanDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['FactotyPlan', function(FactotyPlan) {
                            return FactotyPlan.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('factoty-plan', null, { reload: 'factoty-plan' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('FactotyPlan', FactotyPlan);

    FactotyPlan.$inject = ['$resource', 'DateUtils'];

    function FactotyPlan ($resource, DateUtils) {
        var resourceUrl =  'api/factoty-plans/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.datePlant = DateUtils.convertLocalDateFromServer(data.datePlant);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datePlant = DateUtils.convertLocalDateToServer(copy.datePlant);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.datePlant = DateUtils.convertLocalDateToServer(copy.datePlant);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('FactotyPlanController', FactotyPlanController);

    FactotyPlanController.$inject = ['FactotyPlan'];

    function FactotyPlanController(FactotyPlan) {

        var vm = this;

        vm.factotyPlans = [];

        loadAll();

        function loadAll() {
            FactotyPlan.query(function(result) {
                vm.factotyPlans = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ExtendedUserInformationDialogController', ExtendedUserInformationDialogController);

    ExtendedUserInformationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ExtendedUserInformation'];

    function ExtendedUserInformationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ExtendedUserInformation) {
        var vm = this;

        vm.extendedUserInformation = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.extendedUserInformation.id !== null) {
                ExtendedUserInformation.update(vm.extendedUserInformation, onSaveSuccess, onSaveError);
            } else {
                ExtendedUserInformation.save(vm.extendedUserInformation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:extendedUserInformationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ExtendedUserInformationDetailController', ExtendedUserInformationDetailController);

    ExtendedUserInformationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ExtendedUserInformation'];

    function ExtendedUserInformationDetailController($scope, $rootScope, $stateParams, previousState, entity, ExtendedUserInformation) {
        var vm = this;

        vm.extendedUserInformation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:extendedUserInformationUpdate', function(event, result) {
            vm.extendedUserInformation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ExtendedUserInformationDeleteController',ExtendedUserInformationDeleteController);

    ExtendedUserInformationDeleteController.$inject = ['$uibModalInstance', 'entity', 'ExtendedUserInformation'];

    function ExtendedUserInformationDeleteController($uibModalInstance, entity, ExtendedUserInformation) {
        var vm = this;

        vm.extendedUserInformation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ExtendedUserInformation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('extended-user-information', {
            parent: 'entity',
            url: '/extended-user-information',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.extendedUserInformation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/extended-user-information/extended-user-informations.html',
                    controller: 'ExtendedUserInformationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('extendedUserInformation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('extended-user-information-detail', {
            parent: 'extended-user-information',
            url: '/extended-user-information/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.extendedUserInformation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/extended-user-information/extended-user-information-detail.html',
                    controller: 'ExtendedUserInformationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('extendedUserInformation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ExtendedUserInformation', function($stateParams, ExtendedUserInformation) {
                    return ExtendedUserInformation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'extended-user-information',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('extended-user-information-detail.edit', {
            parent: 'extended-user-information-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/extended-user-information/extended-user-information-dialog.html',
                    controller: 'ExtendedUserInformationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExtendedUserInformation', function(ExtendedUserInformation) {
                            return ExtendedUserInformation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('extended-user-information.new', {
            parent: 'extended-user-information',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/extended-user-information/extended-user-information-dialog.html',
                    controller: 'ExtendedUserInformationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                userAddress: null,
                                userMobile: null,
                                userid: null,
                                userlogin: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('extended-user-information', null, { reload: 'extended-user-information' });
                }, function() {
                    $state.go('extended-user-information');
                });
            }]
        })
        .state('extended-user-information.edit', {
            parent: 'extended-user-information',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/extended-user-information/extended-user-information-dialog.html',
                    controller: 'ExtendedUserInformationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExtendedUserInformation', function(ExtendedUserInformation) {
                            return ExtendedUserInformation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('extended-user-information', null, { reload: 'extended-user-information' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('extended-user-information.delete', {
            parent: 'extended-user-information',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/extended-user-information/extended-user-information-delete-dialog.html',
                    controller: 'ExtendedUserInformationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ExtendedUserInformation', function(ExtendedUserInformation) {
                            return ExtendedUserInformation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('extended-user-information', null, { reload: 'extended-user-information' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ExtendedUserInformation', ExtendedUserInformation);
    ExtendedUserInformation.$inject = ['$resource'];

    function ExtendedUserInformation ($resource) {
        var resourceUrl =  'api/extended-user-informations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ExtendedUserInformationController', ExtendedUserInformationController);

    ExtendedUserInformationController.$inject = ['ExtendedUserInformation'];

    function ExtendedUserInformationController(ExtendedUserInformation) {

        var vm = this;

        vm.extendedUserInformations = [];

        loadAll();

        function loadAll() {
            ExtendedUserInformation.query(function(result) {
                vm.extendedUserInformations = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ExciseServiceFormFilledDialogController', ExciseServiceFormFilledDialogController);

    ExciseServiceFormFilledDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ExciseServiceFormFilled'];

    function ExciseServiceFormFilledDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ExciseServiceFormFilled) {
        var vm = this;

        vm.exciseServiceFormFilled = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.exciseServiceFormFilled.id !== null) {
                ExciseServiceFormFilled.update(vm.exciseServiceFormFilled, onSaveSuccess, onSaveError);
            } else {
                ExciseServiceFormFilled.save(vm.exciseServiceFormFilled, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:exciseServiceFormFilledUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastActionDate = false;
        vm.datePickerOpenStatus.formFilledDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ExciseServiceFormFilledDetailController', ExciseServiceFormFilledDetailController);

    ExciseServiceFormFilledDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ExciseServiceFormFilled'];

    function ExciseServiceFormFilledDetailController($scope, $rootScope, $stateParams, previousState, entity, ExciseServiceFormFilled) {
        var vm = this;

        vm.exciseServiceFormFilled = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:exciseServiceFormFilledUpdate', function(event, result) {
            vm.exciseServiceFormFilled = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ExciseServiceFormFilledDeleteController',ExciseServiceFormFilledDeleteController);

    ExciseServiceFormFilledDeleteController.$inject = ['$uibModalInstance', 'entity', 'ExciseServiceFormFilled'];

    function ExciseServiceFormFilledDeleteController($uibModalInstance, entity, ExciseServiceFormFilled) {
        var vm = this;

        vm.exciseServiceFormFilled = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ExciseServiceFormFilled.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('excise-service-form-filled', {
            parent: 'entity',
            url: '/excise-service-form-filled',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.exciseServiceFormFilled.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/excise-service-form-filled/excise-service-form-filleds.html',
                    controller: 'ExciseServiceFormFilledController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exciseServiceFormFilled');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('excise-service-form-filled-detail', {
            parent: 'excise-service-form-filled',
            url: '/excise-service-form-filled/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.exciseServiceFormFilled.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/excise-service-form-filled/excise-service-form-filled-detail.html',
                    controller: 'ExciseServiceFormFilledDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('exciseServiceFormFilled');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ExciseServiceFormFilled', function($stateParams, ExciseServiceFormFilled) {
                    return ExciseServiceFormFilled.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'excise-service-form-filled',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('excise-service-form-filled-detail.edit', {
            parent: 'excise-service-form-filled-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/excise-service-form-filled/excise-service-form-filled-dialog.html',
                    controller: 'ExciseServiceFormFilledDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExciseServiceFormFilled', function(ExciseServiceFormFilled) {
                            return ExciseServiceFormFilled.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('excise-service-form-filled.new', {
            parent: 'excise-service-form-filled',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/excise-service-form-filled/excise-service-form-filled-dialog.html',
                    controller: 'ExciseServiceFormFilledDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectId: null,
                                serviceId: null,
                                status: null,
                                lastActionDate: null,
                                formFilledDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('excise-service-form-filled', null, { reload: 'excise-service-form-filled' });
                }, function() {
                    $state.go('excise-service-form-filled');
                });
            }]
        })
        .state('excise-service-form-filled.edit', {
            parent: 'excise-service-form-filled',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/excise-service-form-filled/excise-service-form-filled-dialog.html',
                    controller: 'ExciseServiceFormFilledDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ExciseServiceFormFilled', function(ExciseServiceFormFilled) {
                            return ExciseServiceFormFilled.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('excise-service-form-filled', null, { reload: 'excise-service-form-filled' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('excise-service-form-filled.delete', {
            parent: 'excise-service-form-filled',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/excise-service-form-filled/excise-service-form-filled-delete-dialog.html',
                    controller: 'ExciseServiceFormFilledDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ExciseServiceFormFilled', function(ExciseServiceFormFilled) {
                            return ExciseServiceFormFilled.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('excise-service-form-filled', null, { reload: 'excise-service-form-filled' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ExciseServiceFormFilled', ExciseServiceFormFilled);

    ExciseServiceFormFilled.$inject = ['$resource', 'DateUtils'];

    function ExciseServiceFormFilled ($resource, DateUtils) {
        var resourceUrl =  'api/excise-service-form-filleds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastActionDate = DateUtils.convertDateTimeFromServer(data.lastActionDate);
                        data.formFilledDate = DateUtils.convertDateTimeFromServer(data.formFilledDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ExciseServiceFormFilledController', ExciseServiceFormFilledController);

    ExciseServiceFormFilledController.$inject = ['ExciseServiceFormFilled'];

    function ExciseServiceFormFilledController(ExciseServiceFormFilled) {

        var vm = this;

        vm.exciseServiceFormFilleds = [];

        loadAll();

        function loadAll() {
            ExciseServiceFormFilled.query(function(result) {
                vm.exciseServiceFormFilleds = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EstateManagerDialogController', EstateManagerDialogController);

    EstateManagerDialogController.$inject = ['$timeout', '$scope', '$filter', '$stateParams', '$uibModalInstance', 'entity', 'EstateManager', 'District', 'Estate'];

    function EstateManagerDialogController ($timeout, $scope, $filter, $stateParams, $uibModalInstance, entity, EstateManager, District, Estate) {
        var vm = this;

        vm.estateManager = entity;
        vm.clear = clear;
        vm.save = save;
        vm.districts = [];
        vm.estates = [];

        loadAllDistricts();
        function loadAllDistricts() {
            District.query(function (result) {
                vm.districts=result;
                for( var i = 0; i < vm.districts.length-1; i++){
                    if ( vm.districts[i].districtname === 'Chandigarh HQ') {
                        vm.districts.splice(i, 1);
                    }
                }
            });
        }

        vm.loadEstates = function(){
            Estate.query(function (estates) {
                vm.estates = $filter('filter')(estates, {district: vm.estateManager.district});
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.estateManager.id !== null) {
                EstateManager.update(vm.estateManager, onSaveSuccess, onSaveError);
            } else {
                EstateManager.save(vm.estateManager, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:estateManagerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError (error) {
            vm.isSaving = false;
            if(error.status == 400)
                alert("Login does not exist. Please recheck or create the same.");
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EstateManagerDetailController', EstateManagerDetailController);

    EstateManagerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'EstateManager'];

    function EstateManagerDetailController($scope, $rootScope, $stateParams, previousState, entity, EstateManager) {
        var vm = this;

        vm.estateManager = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:estateManagerUpdate', function(event, result) {
            vm.estateManager = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EstateManagerDeleteController',EstateManagerDeleteController);

    EstateManagerDeleteController.$inject = ['$uibModalInstance', 'entity', 'EstateManager'];

    function EstateManagerDeleteController($uibModalInstance, entity, EstateManager) {
        var vm = this;

        vm.estateManager = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            EstateManager.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('estate-manager', {
            parent: 'entity',
            url: '/estate-manager',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.estateManager.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/estate-manager/estate-managers.html',
                    controller: 'EstateManagerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('estateManager');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('estate-manager-detail', {
            parent: 'estate-manager',
            url: '/estate-manager/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.estateManager.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/estate-manager/estate-manager-detail.html',
                    controller: 'EstateManagerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('estateManager');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'EstateManager', function($stateParams, EstateManager) {
                    return EstateManager.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'estate-manager',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('estate-manager-detail.edit', {
            parent: 'estate-manager-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estate-manager/estate-manager-dialog.html',
                    controller: 'EstateManagerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EstateManager', function(EstateManager) {
                            return EstateManager.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('estate-manager.new', {
            parent: 'estate-manager',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estate-manager/estate-manager-dialog.html',
                    controller: 'EstateManagerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                login: null,
                                estate: null,
                                district: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('estate-manager', null, { reload: 'estate-manager' });
                }, function() {
                    $state.go('estate-manager');
                });
            }]
        })
        .state('estate-manager.edit', {
            parent: 'estate-manager',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estate-manager/estate-manager-dialog.html',
                    controller: 'EstateManagerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['EstateManager', function(EstateManager) {
                            return EstateManager.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('estate-manager', null, { reload: 'estate-manager' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('estate-manager.delete', {
            parent: 'estate-manager',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estate-manager/estate-manager-delete-dialog.html',
                    controller: 'EstateManagerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['EstateManager', function(EstateManager) {
                            return EstateManager.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('estate-manager', null, { reload: 'estate-manager' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('EstateManager', EstateManager);

    EstateManager.$inject = ['$resource'];

    function EstateManager ($resource) {
        var resourceUrl =  'api/estate-managers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EstateManagerController', EstateManagerController);

    EstateManagerController.$inject = ['EstateManager'];

    function EstateManagerController(EstateManager) {

        var vm = this;

        vm.estateManagers = [];

        loadAll();

        function loadAll() {
            EstateManager.query(function(result) {
                vm.estateManagers = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EstateDialogController', EstateDialogController);

    EstateDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Estate', 'District'];

    function EstateDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Estate, District) {
        var vm = this;

        vm.estate = entity;
        vm.clear = clear;
        vm.save = save;
        vm.district = [];


        loadAllDistricts();
        function loadAllDistricts() {
            District.query(function (result) {
                vm.districts=result;
                for( var i = 0; i < vm.districts.length-1; i++){
                    if ( vm.districts[i].districtname === 'Chandigarh HQ') {
                        vm.districts.splice(i, 1);
                    }
                }
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.estate.id !== null) {
                Estate.update(vm.estate, onSaveSuccess, onSaveError);
            } else {
                Estate.save(vm.estate, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:estateUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EstateDetailController', EstateDetailController);

    EstateDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Estate'];

    function EstateDetailController($scope, $rootScope, $stateParams, previousState, entity, Estate) {
        var vm = this;

        vm.estate = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:estateUpdate', function(event, result) {
            vm.estate = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EstateDeleteController',EstateDeleteController);

    EstateDeleteController.$inject = ['$uibModalInstance', 'entity', 'Estate'];

    function EstateDeleteController($uibModalInstance, entity, Estate) {
        var vm = this;

        vm.estate = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Estate.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('estate', {
            parent: 'entity',
            url: '/estate',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.estate.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/estate/estates.html',
                    controller: 'EstateController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('estate');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('estate-detail', {
            parent: 'estate',
            url: '/estate/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.estate.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/estate/estate-detail.html',
                    controller: 'EstateDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('estate');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Estate', function($stateParams, Estate) {
                    return Estate.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'estate',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('estate-detail.edit', {
            parent: 'estate-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estate/estate-dialog.html',
                    controller: 'EstateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Estate', function(Estate) {
                            return Estate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('estate.new', {
            parent: 'estate',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estate/estate-dialog.html',
                    controller: 'EstateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                estate: null,
                                district: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('estate', null, { reload: 'estate' });
                }, function() {
                    $state.go('estate');
                });
            }]
        })
        .state('estate.edit', {
            parent: 'estate',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estate/estate-dialog.html',
                    controller: 'EstateDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Estate', function(Estate) {
                            return Estate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('estate', null, { reload: 'estate' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('estate.delete', {
            parent: 'estate',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/estate/estate-delete-dialog.html',
                    controller: 'EstateDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Estate', function(Estate) {
                            return Estate.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('estate', null, { reload: 'estate' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Estate', Estate);

    Estate.$inject = ['$resource'];

    function Estate ($resource) {
        var resourceUrl =  'api/estates/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EstateController', EstateController);

    EstateController.$inject = ['Estate'];

    function EstateController(Estate) {

        var vm = this;

        vm.estates = [];

        loadAll();

        function loadAll() {
            Estate.query(function(result) {
                vm.estates = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Environment_impactdetailDialogController', Environment_impactdetailDialogController);

    Environment_impactdetailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Environment_impactdetail'];

    function Environment_impactdetailDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Environment_impactdetail) {
        var vm = this;

        vm.environment_impactdetail = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.environment_impactdetail.id !== null) {
                Environment_impactdetail.update(vm.environment_impactdetail, onSaveSuccess, onSaveError);
            } else {
                Environment_impactdetail.save(vm.environment_impactdetail, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:environment_impactdetailUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Environment_impactdetailDetailController', Environment_impactdetailDetailController);

    Environment_impactdetailDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Environment_impactdetail'];

    function Environment_impactdetailDetailController($scope, $rootScope, $stateParams, previousState, entity, Environment_impactdetail) {
        var vm = this;

        vm.environment_impactdetail = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:environment_impactdetailUpdate', function(event, result) {
            vm.environment_impactdetail = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Environment_impactdetailDeleteController',Environment_impactdetailDeleteController);

    Environment_impactdetailDeleteController.$inject = ['$uibModalInstance', 'entity', 'Environment_impactdetail'];

    function Environment_impactdetailDeleteController($uibModalInstance, entity, Environment_impactdetail) {
        var vm = this;

        vm.environment_impactdetail = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Environment_impactdetail.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('environment-impactdetail', {
            parent: 'entity',
            url: '/environment-impactdetail',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.environment_impactdetail.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/environment-impactdetail/environment-impactdetails.html',
                    controller: 'Environment_impactdetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('environment_impactdetail');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('environment-impactdetail-detail', {
            parent: 'environment-impactdetail',
            url: '/environment-impactdetail/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.environment_impactdetail.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/environment-impactdetail/environment-impactdetail-detail.html',
                    controller: 'Environment_impactdetailDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('environment_impactdetail');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Environment_impactdetail', function($stateParams, Environment_impactdetail) {
                    return Environment_impactdetail.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'environment-impactdetail',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('environment-impactdetail-detail.edit', {
            parent: 'environment-impactdetail-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-impactdetail/environment-impactdetail-dialog.html',
                    controller: 'Environment_impactdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Environment_impactdetail', function(Environment_impactdetail) {
                            return Environment_impactdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('environment-impactdetail.new', {
            parent: 'environment-impactdetail',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-impactdetail/environment-impactdetail-dialog.html',
                    controller: 'Environment_impactdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                source_of_water_supply: null,
                                mode_of_disposal_for_discharge: null,
                                recycling_process: null,
                                recycling_cooling: null,
                                recycling_domestic: null,
                                recycling_other: null,
                                createdate: null,
                                updatedate: null,
                                sourcewatersupplyother: null,
                                modedisposalother: null,
                                water_process: null,
                                water_cooling: null,
                                water_domestic: null,
                                water_other: null,
                                waste_water_process: null,
                                waste_water_cooling: null,
                                waste_water_domesting: null,
                                waste_water_other: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('environment-impactdetail', null, { reload: 'environment-impactdetail' });
                }, function() {
                    $state.go('environment-impactdetail');
                });
            }]
        })
        .state('environment-impactdetail.edit', {
            parent: 'environment-impactdetail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-impactdetail/environment-impactdetail-dialog.html',
                    controller: 'Environment_impactdetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Environment_impactdetail', function(Environment_impactdetail) {
                            return Environment_impactdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('environment-impactdetail', null, { reload: 'environment-impactdetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('environment-impactdetail.delete', {
            parent: 'environment-impactdetail',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/environment-impactdetail/environment-impactdetail-delete-dialog.html',
                    controller: 'Environment_impactdetailDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Environment_impactdetail', function(Environment_impactdetail) {
                            return Environment_impactdetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('environment-impactdetail', null, { reload: 'environment-impactdetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Environment_impactdetail', Environment_impactdetail);

    Environment_impactdetail.$inject = ['$resource', 'DateUtils'];

    function Environment_impactdetail ($resource, DateUtils) {
        var resourceUrl =  'api/environment-impactdetails/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Environment_impactdetailController', Environment_impactdetailController);

    Environment_impactdetailController.$inject = ['Environment_impactdetail'];

    function Environment_impactdetailController(Environment_impactdetail) {

        var vm = this;

        vm.environment_impactdetails = [];

        loadAll();

        function loadAll() {
            Environment_impactdetail.query(function(result) {
                vm.environment_impactdetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Emmision_pollution_controllDialogController', Emmision_pollution_controllDialogController);

    Emmision_pollution_controllDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Emmision_pollution_controll'];

    function Emmision_pollution_controllDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Emmision_pollution_controll) {
        var vm = this;

        vm.emmision_pollution_controll = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.emmision_pollution_controll.id !== null) {
                Emmision_pollution_controll.update(vm.emmision_pollution_controll, onSaveSuccess, onSaveError);
            } else {
                Emmision_pollution_controll.save(vm.emmision_pollution_controll, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:emmision_pollution_controllUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Emmision_pollution_controllDetailController', Emmision_pollution_controllDetailController);

    Emmision_pollution_controllDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Emmision_pollution_controll'];

    function Emmision_pollution_controllDetailController($scope, $rootScope, $stateParams, previousState, entity, Emmision_pollution_controll) {
        var vm = this;

        vm.emmision_pollution_controll = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:emmision_pollution_controllUpdate', function(event, result) {
            vm.emmision_pollution_controll = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Emmision_pollution_controllDeleteController',Emmision_pollution_controllDeleteController);

    Emmision_pollution_controllDeleteController.$inject = ['$uibModalInstance', 'entity', 'Emmision_pollution_controll'];

    function Emmision_pollution_controllDeleteController($uibModalInstance, entity, Emmision_pollution_controll) {
        var vm = this;

        vm.emmision_pollution_controll = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Emmision_pollution_controll.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('emmision-pollution-controll', {
            parent: 'entity',
            url: '/emmision-pollution-controll',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.emmision_pollution_controll.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/emmision-pollution-controll/emmision-pollution-controlls.html',
                    controller: 'Emmision_pollution_controllController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('emmision_pollution_controll');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('emmision-pollution-controll-detail', {
            parent: 'emmision-pollution-controll',
            url: '/emmision-pollution-controll/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.emmision_pollution_controll.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/emmision-pollution-controll/emmision-pollution-controll-detail.html',
                    controller: 'Emmision_pollution_controllDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('emmision_pollution_controll');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Emmision_pollution_controll', function($stateParams, Emmision_pollution_controll) {
                    return Emmision_pollution_controll.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'emmision-pollution-controll',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('emmision-pollution-controll-detail.edit', {
            parent: 'emmision-pollution-controll-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emmision-pollution-controll/emmision-pollution-controll-dialog.html',
                    controller: 'Emmision_pollution_controllDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Emmision_pollution_controll', function(Emmision_pollution_controll) {
                            return Emmision_pollution_controll.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('emmision-pollution-controll.new', {
            parent: 'emmision-pollution-controll',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emmision-pollution-controll/emmision-pollution-controll-dialog.html',
                    controller: 'Emmision_pollution_controllDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                airpollutioncontroldevice: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('emmision-pollution-controll', null, { reload: 'emmision-pollution-controll' });
                }, function() {
                    $state.go('emmision-pollution-controll');
                });
            }]
        })
        .state('emmision-pollution-controll.edit', {
            parent: 'emmision-pollution-controll',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emmision-pollution-controll/emmision-pollution-controll-dialog.html',
                    controller: 'Emmision_pollution_controllDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Emmision_pollution_controll', function(Emmision_pollution_controll) {
                            return Emmision_pollution_controll.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('emmision-pollution-controll', null, { reload: 'emmision-pollution-controll' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('emmision-pollution-controll.delete', {
            parent: 'emmision-pollution-controll',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emmision-pollution-controll/emmision-pollution-controll-delete-dialog.html',
                    controller: 'Emmision_pollution_controllDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Emmision_pollution_controll', function(Emmision_pollution_controll) {
                            return Emmision_pollution_controll.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('emmision-pollution-controll', null, { reload: 'emmision-pollution-controll' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Emmision_pollution_controll', Emmision_pollution_controll);

    Emmision_pollution_controll.$inject = ['$resource'];

    function Emmision_pollution_controll ($resource) {
        var resourceUrl =  'api/emmision-pollution-controlls/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Emmision_pollution_controllController', Emmision_pollution_controllController);

    Emmision_pollution_controllController.$inject = ['Emmision_pollution_controll'];

    function Emmision_pollution_controllController(Emmision_pollution_controll) {

        var vm = this;

        vm.emmision_pollution_controlls = [];

        loadAll();

        function loadAll() {
            Emmision_pollution_controll.query(function(result) {
                vm.emmision_pollution_controlls = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Emmision_fuel_typeDialogController', Emmision_fuel_typeDialogController);

    Emmision_fuel_typeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Emmision_fuel_type'];

    function Emmision_fuel_typeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Emmision_fuel_type) {
        var vm = this;

        vm.emmision_fuel_type = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.emmision_fuel_type.id !== null) {
                Emmision_fuel_type.update(vm.emmision_fuel_type, onSaveSuccess, onSaveError);
            } else {
                Emmision_fuel_type.save(vm.emmision_fuel_type, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:emmision_fuel_typeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Emmision_fuel_typeDetailController', Emmision_fuel_typeDetailController);

    Emmision_fuel_typeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Emmision_fuel_type'];

    function Emmision_fuel_typeDetailController($scope, $rootScope, $stateParams, previousState, entity, Emmision_fuel_type) {
        var vm = this;

        vm.emmision_fuel_type = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:emmision_fuel_typeUpdate', function(event, result) {
            vm.emmision_fuel_type = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Emmision_fuel_typeDeleteController',Emmision_fuel_typeDeleteController);

    Emmision_fuel_typeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Emmision_fuel_type'];

    function Emmision_fuel_typeDeleteController($uibModalInstance, entity, Emmision_fuel_type) {
        var vm = this;

        vm.emmision_fuel_type = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Emmision_fuel_type.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('emmision-fuel-type', {
            parent: 'entity',
            url: '/emmision-fuel-type',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.emmision_fuel_type.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/emmision-fuel-type/emmision-fuel-types.html',
                    controller: 'Emmision_fuel_typeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('emmision_fuel_type');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('emmision-fuel-type-detail', {
            parent: 'emmision-fuel-type',
            url: '/emmision-fuel-type/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.emmision_fuel_type.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/emmision-fuel-type/emmision-fuel-type-detail.html',
                    controller: 'Emmision_fuel_typeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('emmision_fuel_type');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Emmision_fuel_type', function($stateParams, Emmision_fuel_type) {
                    return Emmision_fuel_type.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'emmision-fuel-type',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('emmision-fuel-type-detail.edit', {
            parent: 'emmision-fuel-type-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emmision-fuel-type/emmision-fuel-type-dialog.html',
                    controller: 'Emmision_fuel_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Emmision_fuel_type', function(Emmision_fuel_type) {
                            return Emmision_fuel_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('emmision-fuel-type.new', {
            parent: 'emmision-fuel-type',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emmision-fuel-type/emmision-fuel-type-dialog.html',
                    controller: 'Emmision_fuel_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                typeoffuel: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('emmision-fuel-type', null, { reload: 'emmision-fuel-type' });
                }, function() {
                    $state.go('emmision-fuel-type');
                });
            }]
        })
        .state('emmision-fuel-type.edit', {
            parent: 'emmision-fuel-type',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emmision-fuel-type/emmision-fuel-type-dialog.html',
                    controller: 'Emmision_fuel_typeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Emmision_fuel_type', function(Emmision_fuel_type) {
                            return Emmision_fuel_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('emmision-fuel-type', null, { reload: 'emmision-fuel-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('emmision-fuel-type.delete', {
            parent: 'emmision-fuel-type',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emmision-fuel-type/emmision-fuel-type-delete-dialog.html',
                    controller: 'Emmision_fuel_typeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Emmision_fuel_type', function(Emmision_fuel_type) {
                            return Emmision_fuel_type.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('emmision-fuel-type', null, { reload: 'emmision-fuel-type' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Emmision_fuel_type', Emmision_fuel_type);

    Emmision_fuel_type.$inject = ['$resource'];

    function Emmision_fuel_type ($resource) {
        var resourceUrl =  'api/emmision-fuel-types/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Emmision_fuel_typeController', Emmision_fuel_typeController);

    Emmision_fuel_typeController.$inject = ['Emmision_fuel_type'];

    function Emmision_fuel_typeController(Emmision_fuel_type) {

        var vm = this;

        vm.emmision_fuel_types = [];

        loadAll();

        function loadAll() {
            Emmision_fuel_type.query(function(result) {
                vm.emmision_fuel_types = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EmissiondetailDialogController', EmissiondetailDialogController);

    EmissiondetailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Emissiondetail'];

    function EmissiondetailDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Emissiondetail) {
        var vm = this;

        vm.emissiondetail = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.emissiondetail.id !== null) {
                Emissiondetail.update(vm.emissiondetail, onSaveSuccess, onSaveError);
            } else {
                Emissiondetail.save(vm.emissiondetail, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:emissiondetailUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EmissiondetailDetailController', EmissiondetailDetailController);

    EmissiondetailDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Emissiondetail'];

    function EmissiondetailDetailController($scope, $rootScope, $stateParams, previousState, entity, Emissiondetail) {
        var vm = this;

        vm.emissiondetail = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:emissiondetailUpdate', function(event, result) {
            vm.emissiondetail = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EmissiondetailDeleteController',EmissiondetailDeleteController);

    EmissiondetailDeleteController.$inject = ['$uibModalInstance', 'entity', 'Emissiondetail'];

    function EmissiondetailDeleteController($uibModalInstance, entity, Emissiondetail) {
        var vm = this;

        vm.emissiondetail = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Emissiondetail.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('emissiondetail', {
            parent: 'entity',
            url: '/emissiondetail',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.emissiondetail.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/emissiondetail/emissiondetails.html',
                    controller: 'EmissiondetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('emissiondetail');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('emissiondetail-detail', {
            parent: 'emissiondetail',
            url: '/emissiondetail/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.emissiondetail.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/emissiondetail/emissiondetail-detail.html',
                    controller: 'EmissiondetailDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('emissiondetail');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Emissiondetail', function($stateParams, Emissiondetail) {
                    return Emissiondetail.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'emissiondetail',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('emissiondetail-detail.edit', {
            parent: 'emissiondetail-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emissiondetail/emissiondetail-dialog.html',
                    controller: 'EmissiondetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Emissiondetail', function(Emissiondetail) {
                            return Emissiondetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('emissiondetail.new', {
            parent: 'emissiondetail',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emissiondetail/emissiondetail-dialog.html',
                    controller: 'EmissiondetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                capacity: null,
                                particulars: null,
                                type_of_fuel: null,
                                air_pollution_control_device: null,
                                createdate: null,
                                updatedate: null,
                                projectid: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('emissiondetail', null, { reload: 'emissiondetail' });
                }, function() {
                    $state.go('emissiondetail');
                });
            }]
        })
        .state('emissiondetail.edit', {
            parent: 'emissiondetail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emissiondetail/emissiondetail-dialog.html',
                    controller: 'EmissiondetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Emissiondetail', function(Emissiondetail) {
                            return Emissiondetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('emissiondetail', null, { reload: 'emissiondetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('emissiondetail.delete', {
            parent: 'emissiondetail',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/emissiondetail/emissiondetail-delete-dialog.html',
                    controller: 'EmissiondetailDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Emissiondetail', function(Emissiondetail) {
                            return Emissiondetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('emissiondetail', null, { reload: 'emissiondetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Emissiondetail', Emissiondetail);

    Emissiondetail.$inject = ['$resource', 'DateUtils'];

    function Emissiondetail ($resource, DateUtils) {
        var resourceUrl =  'api/emissiondetails/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EmissiondetailController', EmissiondetailController);

    EmissiondetailController.$inject = ['Emissiondetail'];

    function EmissiondetailController(Emissiondetail) {

        var vm = this;

        vm.emissiondetails = [];

        loadAll();

        function loadAll() {
            Emissiondetail.query(function(result) {
                vm.emissiondetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ElectricrequirementDialogController', ElectricrequirementDialogController);

    ElectricrequirementDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Electricrequirement'];

    function ElectricrequirementDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Electricrequirement) {
        var vm = this;

        vm.electricrequirement = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.electricrequirement.id !== null) {
                Electricrequirement.update(vm.electricrequirement, onSaveSuccess, onSaveError);
            } else {
                Electricrequirement.save(vm.electricrequirement, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:electricrequirementUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.temp_load_demand_date = false;
        vm.datePickerOpenStatus.regular_load_demand_date = false;
        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ElectricrequirementDetailController', ElectricrequirementDetailController);

    ElectricrequirementDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Electricrequirement'];

    function ElectricrequirementDetailController($scope, $rootScope, $stateParams, previousState, entity, Electricrequirement) {
        var vm = this;

        vm.electricrequirement = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:electricrequirementUpdate', function(event, result) {
            vm.electricrequirement = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ElectricrequirementDeleteController',ElectricrequirementDeleteController);

    ElectricrequirementDeleteController.$inject = ['$uibModalInstance', 'entity', 'Electricrequirement'];

    function ElectricrequirementDeleteController($uibModalInstance, entity, Electricrequirement) {
        var vm = this;

        vm.electricrequirement = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Electricrequirement.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('electricrequirement', {
            parent: 'entity',
            url: '/electricrequirement',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.electricrequirement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/electricrequirement/electricrequirements.html',
                    controller: 'ElectricrequirementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('electricrequirement');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('electricrequirement-detail', {
            parent: 'electricrequirement',
            url: '/electricrequirement/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.electricrequirement.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/electricrequirement/electricrequirement-detail.html',
                    controller: 'ElectricrequirementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('electricrequirement');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Electricrequirement', function($stateParams, Electricrequirement) {
                    return Electricrequirement.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'electricrequirement',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('electricrequirement-detail.edit', {
            parent: 'electricrequirement-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/electricrequirement/electricrequirement-dialog.html',
                    controller: 'ElectricrequirementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Electricrequirement', function(Electricrequirement) {
                            return Electricrequirement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('electricrequirement.new', {
            parent: 'electricrequirement',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/electricrequirement/electricrequirement-dialog.html',
                    controller: 'ElectricrequirementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                temporaryrequired: null,
                                tem_load_existing: null,
                                tem_account_number: null,
                                temp_existing_load_demand_kw: null,
                                temp_existing_load_demand_kva: null,
                                temp_new_load_demand_kw: null,
                                temp_new_load_demand_kva: null,
                                temp_load_demand_date: null,
                                regular_load_required: null,
                                regular_existing_connection: null,
                                regular_account_number: null,
                                regular_existing_load_ifany_kw: null,
                                regular_existing_load_ifany_kva: null,
                                regular_new_load_demand_kw: null,
                                regular_new_load_demand_kva: null,
                                regular_load_demand_date: null,
                                customertype: null,
                                createdate: null,
                                updatedate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('electricrequirement', null, { reload: 'electricrequirement' });
                }, function() {
                    $state.go('electricrequirement');
                });
            }]
        })
        .state('electricrequirement.edit', {
            parent: 'electricrequirement',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/electricrequirement/electricrequirement-dialog.html',
                    controller: 'ElectricrequirementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Electricrequirement', function(Electricrequirement) {
                            return Electricrequirement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('electricrequirement', null, { reload: 'electricrequirement' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('electricrequirement.delete', {
            parent: 'electricrequirement',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/electricrequirement/electricrequirement-delete-dialog.html',
                    controller: 'ElectricrequirementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Electricrequirement', function(Electricrequirement) {
                            return Electricrequirement.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('electricrequirement', null, { reload: 'electricrequirement' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Electricrequirement', Electricrequirement);

    Electricrequirement.$inject = ['$resource', 'DateUtils'];

    function Electricrequirement ($resource, DateUtils) {
        var resourceUrl =  'api/electricrequirements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.temp_load_demand_date = DateUtils.convertDateTimeFromServer(data.temp_load_demand_date);
                        data.regular_load_demand_date = DateUtils.convertDateTimeFromServer(data.regular_load_demand_date);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ElectricrequirementController', ElectricrequirementController);

    ElectricrequirementController.$inject = ['Electricrequirement'];

    function ElectricrequirementController(Electricrequirement) {

        var vm = this;

        vm.electricrequirements = [];

        loadAll();

        function loadAll() {
            Electricrequirement.query(function(result) {
                vm.electricrequirements = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DraftPolicyDialogController', DraftPolicyDialogController);

    DraftPolicyDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DraftPolicy'];

    function DraftPolicyDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DraftPolicy) {
        var vm = this;

        vm.draftPolicy = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.draftPolicy.id !== null) {
                DraftPolicy.update(vm.draftPolicy, onSaveSuccess, onSaveError);
            } else {
                DraftPolicy.save(vm.draftPolicy, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:draftPolicyUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.remarkDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DraftPolicyDetailController', DraftPolicyDetailController);

    DraftPolicyDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DraftPolicy'];

    function DraftPolicyDetailController($scope, $rootScope, $stateParams, previousState, entity, DraftPolicy) {
        var vm = this;

        vm.draftPolicy = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:draftPolicyUpdate', function(event, result) {
            vm.draftPolicy = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DraftPolicyDeleteController',DraftPolicyDeleteController);

    DraftPolicyDeleteController.$inject = ['$uibModalInstance', 'entity', 'DraftPolicy'];

    function DraftPolicyDeleteController($uibModalInstance, entity, DraftPolicy) {
        var vm = this;

        vm.draftPolicy = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DraftPolicy.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('draft-policy', {
            parent: 'entity',
            url: '/draft-policy',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER'],
                pageTitle: 'investhryApp.draftPolicy.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/draft-policy/draft-policies.html',
                    controller: 'DraftPolicyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('draftPolicy');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('draft-policy-detail', {
            parent: 'draft-policy',
            url: '/draft-policy/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER'],
                pageTitle: 'investhryApp.draftPolicy.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/draft-policy/draft-policy-detail.html',
                    controller: 'DraftPolicyDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('draftPolicy');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DraftPolicy', function($stateParams, DraftPolicy) {
                    return DraftPolicy.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'draft-policy',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('draft-policy-detail.edit', {
            parent: 'draft-policy-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/draft-policy/draft-policy-dialog.html',
                    controller: 'DraftPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DraftPolicy', function(DraftPolicy) {
                            return DraftPolicy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('draft-policy.new', {
            parent: 'draft-policy',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/draft-policy/draft-policy-dialog.html',
                    controller: 'DraftPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                policy: null,
                                name: null,
                                email: null,
                                phone: null,
                                remarks: null,
                                remarks_admin: null,
                                isReplied: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('draft-policy', null, { reload: 'draft-policy' });
                }, function() {
                    $state.go('draft-policy');
                });
            }]
        })
        .state('draft-policy.edit', {
            parent: 'draft-policy',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/draft-policy/draft-policy-dialog.html',
                    controller: 'DraftPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DraftPolicy', function(DraftPolicy) {
                            return DraftPolicy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('draft-policy', null, { reload: 'draft-policy' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('draft-policy.delete', {
            parent: 'draft-policy',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/draft-policy/draft-policy-delete-dialog.html',
                    controller: 'DraftPolicyDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DraftPolicy', function(DraftPolicy) {
                            return DraftPolicy.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('draft-policy', null, { reload: 'draft-policy' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DraftPolicy', DraftPolicy);

    DraftPolicy.$inject = ['$resource'];

    function DraftPolicy ($resource) {
        var resourceUrl =  'api/draft-policies/:id/:status/:policy';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DraftPolicyController', DraftPolicyController);

    DraftPolicyController.$inject = ['DraftPolicy', 'PolicyDetails'];

    function DraftPolicyController(DraftPolicy, PolicyDetails) {

        var vm = this;

        vm.draftPolicies = [];
        vm.statusSelected = statusSelected;

        loadAll();

        function loadAll() {
            PolicyDetails.query(function(result) {
                vm.policyDetails = result;
                vm.searchQuery = null;
                statusSelected('Pending',result[0].name);
            });
        }

        vm.save = function (data) {
            data.isReplied = true;
            DraftPolicy.update(data,onSaveSuccess,onSaveError)
        };

        function onSaveSuccess() {
            UIkit.modal('#remarkAdmin').hide();
            location.reload();
        }

        function onSaveError() {

        }

        function statusSelected (statusFilterobj,policyFilterobj) {
            vm.statusFilter = statusFilterobj;
            vm.policyFilter = policyFilterobj;
            console.log(statusFilterobj);
            console.log(policyFilterobj);
            DraftPolicy.query({id:'1',status:statusFilterobj,policy:policyFilterobj},function(result) {
                vm.draftPolicies = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictVillageBlockMappingDialogController', DistrictVillageBlockMappingDialogController);

    DistrictVillageBlockMappingDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DistrictVillageBlockMapping'];

    function DistrictVillageBlockMappingDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DistrictVillageBlockMapping) {
        var vm = this;

        vm.districtVillageBlockMapping = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.districtVillageBlockMapping.id !== null) {
                DistrictVillageBlockMapping.update(vm.districtVillageBlockMapping, onSaveSuccess, onSaveError);
            } else {
                DistrictVillageBlockMapping.save(vm.districtVillageBlockMapping, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:districtVillageBlockMappingUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictVillageBlockMappingDetailController', DistrictVillageBlockMappingDetailController);

    DistrictVillageBlockMappingDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DistrictVillageBlockMapping'];

    function DistrictVillageBlockMappingDetailController($scope, $rootScope, $stateParams, previousState, entity, DistrictVillageBlockMapping) {
        var vm = this;

        vm.districtVillageBlockMapping = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:districtVillageBlockMappingUpdate', function(event, result) {
            vm.districtVillageBlockMapping = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictVillageBlockMappingDeleteController',DistrictVillageBlockMappingDeleteController);

    DistrictVillageBlockMappingDeleteController.$inject = ['$uibModalInstance', 'entity', 'DistrictVillageBlockMapping'];

    function DistrictVillageBlockMappingDeleteController($uibModalInstance, entity, DistrictVillageBlockMapping) {
        var vm = this;

        vm.districtVillageBlockMapping = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DistrictVillageBlockMapping.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('district-village-block-mapping', {
            parent: 'entity',
            url: '/district-village-block-mapping',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.districtVillageBlockMapping.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mappings.html',
                    controller: 'DistrictVillageBlockMappingController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('districtVillageBlockMapping');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('district-village-block-mapping-detail', {
            parent: 'district-village-block-mapping',
            url: '/district-village-block-mapping/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.districtVillageBlockMapping.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mapping-detail.html',
                    controller: 'DistrictVillageBlockMappingDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('districtVillageBlockMapping');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DistrictVillageBlockMapping', function($stateParams, DistrictVillageBlockMapping) {
                    return DistrictVillageBlockMapping.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'district-village-block-mapping',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('district-village-block-mapping-detail.edit', {
            parent: 'district-village-block-mapping-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mapping-dialog.html',
                    controller: 'DistrictVillageBlockMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DistrictVillageBlockMapping', function(DistrictVillageBlockMapping) {
                            return DistrictVillageBlockMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district-village-block-mapping.new', {
            parent: 'district-village-block-mapping',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mapping-dialog.html',
                    controller: 'DistrictVillageBlockMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                districtName: null,
                                category: null,
                                village: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('district-village-block-mapping', null, { reload: 'district-village-block-mapping' });
                }, function() {
                    $state.go('district-village-block-mapping');
                });
            }]
        })
        .state('district-village-block-mapping.edit', {
            parent: 'district-village-block-mapping',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mapping-dialog.html',
                    controller: 'DistrictVillageBlockMappingDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DistrictVillageBlockMapping', function(DistrictVillageBlockMapping) {
                            return DistrictVillageBlockMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district-village-block-mapping', null, { reload: 'district-village-block-mapping' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district-village-block-mapping.delete', {
            parent: 'district-village-block-mapping',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-village-block-mapping/district-village-block-mapping-delete-dialog.html',
                    controller: 'DistrictVillageBlockMappingDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DistrictVillageBlockMapping', function(DistrictVillageBlockMapping) {
                            return DistrictVillageBlockMapping.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district-village-block-mapping', null, { reload: 'district-village-block-mapping' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DistrictVillageBlockMapping', DistrictVillageBlockMapping);

    DistrictVillageBlockMapping.$inject = ['$resource'];

    function DistrictVillageBlockMapping ($resource) {
        var resourceUrl =  'api/district-village-block-mappings/:id/:districtName';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictVillageBlockMappingController', DistrictVillageBlockMappingController);

    DistrictVillageBlockMappingController.$inject = ['DistrictVillageBlockMapping'];

    function DistrictVillageBlockMappingController(DistrictVillageBlockMapping) {

        var vm = this;

        vm.districtVillageBlockMappings = [];

        loadAll();

        function loadAll() {
            DistrictVillageBlockMapping.query(function(result) {
                vm.districtVillageBlockMappings = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictNodalOfficerDialogController', DistrictNodalOfficerDialogController);

    DistrictNodalOfficerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DistrictNodalOfficer','District', 'Department', '$filter'];

    function DistrictNodalOfficerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DistrictNodalOfficer, District, Department, $filter) {
        var vm = this;

        vm.districtNodalOfficer = entity;
        vm.clear = clear;
        vm.save = save;
        var selecteddistrict=null;
        var selecteddepartment=null;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
//            vm.districtNodalOfficer.districtid= vm.districtNodalOfficer.selecteddistrict.id;
//            vm.districtNodalOfficer.districtName= vm.districtNodalOfficer.selecteddistrict.districtname;
//            vm.districtNodalOfficer.departmentid= vm.districtNodalOfficer.selecteddepartment.id;
//            vm.districtNodalOfficer.departmentname= vm.districtNodalOfficer.selecteddepartment.departmentname;
            selecteddistrict = $filter('filter')(vm.districts,{id:vm.districtNodalOfficer.districtid});
            selecteddepartment = $filter('filter')(vm.departments,{id:vm.districtNodalOfficer.departmentid});

            vm.districtNodalOfficer.districtName = selecteddistrict[0].districtname;
            vm.districtNodalOfficer.departmentname = selecteddepartment[0].departmentname;

            vm.isSaving = true;
            if (vm.districtNodalOfficer.id !== null) {
                DistrictNodalOfficer.update(vm.districtNodalOfficer, onSaveSuccess, onSaveError);
            } else {
                DistrictNodalOfficer.save(vm.districtNodalOfficer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:districtNodalOfficerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError (error) {
            vm.isSaving = false;
            if(error.status == 400)
               alert("Login does not exist. Please recheck or create the same.");
        }

        vm.districts = [];
        loadAllDistricts();
        function loadAllDistricts() {
            District.query(function(result) {
                vm.districts = result;
                vm.searchQuery = null;
                var obj={districtname:'Haryana',
                        powercompany:null,
                        stateID:null,
                        id:null,
                        statename:'Haryana'};
                vm.districts.push(obj);
                for( var i = 0; i < vm.districts.length-1; i++){
                     if ( vm.districts[i].districtname === 'Chandigarh HQ') {
                       vm.districts.splice(i, 1);
                     }
                  }
            });
        }

        vm.departments = [];
        loadAllDepartments();
        function loadAllDepartments() {
            Department.query(function(result) {
                vm.departmentstemp = result;
                angular.forEach(vm.departmentstemp, function(value, key){
                    if(value.departmentname!=='Development and Panchayats'){
                        vm.departments.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictNodalOfficerDetailController', DistrictNodalOfficerDetailController);

    DistrictNodalOfficerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DistrictNodalOfficer'];

    function DistrictNodalOfficerDetailController($scope, $rootScope, $stateParams, previousState, entity, DistrictNodalOfficer) {
        var vm = this;

        vm.districtNodalOfficer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:districtNodalOfficerUpdate', function(event, result) {
            vm.districtNodalOfficer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictNodalOfficerDeleteController',DistrictNodalOfficerDeleteController);

    DistrictNodalOfficerDeleteController.$inject = ['$uibModalInstance', 'entity', 'DistrictNodalOfficer'];

    function DistrictNodalOfficerDeleteController($uibModalInstance, entity, DistrictNodalOfficer) {
        var vm = this;

        vm.districtNodalOfficer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DistrictNodalOfficer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('district-nodal-officer', {
            parent: 'entity',
            url: '/district-nodal-officer',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.districtNodalOfficer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district-nodal-officer/district-nodal-officers.html',
                    controller: 'DistrictNodalOfficerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('districtNodalOfficer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('district-nodal-officer-detail', {
            parent: 'district-nodal-officer',
            url: '/district-nodal-officer/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.districtNodalOfficer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district-nodal-officer/district-nodal-officer-detail.html',
                    controller: 'DistrictNodalOfficerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('districtNodalOfficer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DistrictNodalOfficer', function($stateParams, DistrictNodalOfficer) {
                    return DistrictNodalOfficer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'district-nodal-officer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('district-nodal-officer-detail.edit', {
            parent: 'district-nodal-officer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-nodal-officer/district-nodal-officer-dialog.html',
                    controller: 'DistrictNodalOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DistrictNodalOfficer', function(DistrictNodalOfficer) {
                            return DistrictNodalOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district-nodal-officer.new', {
            parent: 'district-nodal-officer',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-nodal-officer/district-nodal-officer-dialog.html',
                    controller: 'DistrictNodalOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nodalOfficerLogin: null,
                                districtName: null,
                                departmentid: null,
                                districtid: null,
                                departmentname: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('district-nodal-officer', null, { reload: 'district-nodal-officer' });
                }, function() {
                    $state.go('district-nodal-officer');
                });
            }]
        })
        .state('district-nodal-officer.edit', {
            parent: 'district-nodal-officer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-nodal-officer/district-nodal-officer-dialog.html',
                    controller: 'DistrictNodalOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DistrictNodalOfficer', function(DistrictNodalOfficer) {
                            return DistrictNodalOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district-nodal-officer', null, { reload: 'district-nodal-officer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district-nodal-officer.delete', {
            parent: 'district-nodal-officer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-nodal-officer/district-nodal-officer-delete-dialog.html',
                    controller: 'DistrictNodalOfficerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DistrictNodalOfficer', function(DistrictNodalOfficer) {
                            return DistrictNodalOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district-nodal-officer', null, { reload: 'district-nodal-officer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DistrictNodalOfficer', DistrictNodalOfficer);

    DistrictNodalOfficer.$inject = ['$resource'];

    function DistrictNodalOfficer ($resource) {
        var resourceUrl =  'api/district-nodal-officers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictNodalOfficerController', DistrictNodalOfficerController);

    DistrictNodalOfficerController.$inject = ['DistrictNodalOfficer'];

    function DistrictNodalOfficerController(DistrictNodalOfficer) {

        var vm = this;

        vm.districtNodalOfficers = [];

        loadAll();

        function loadAll() {
            DistrictNodalOfficer.query(function(result) {
                vm.districtNodalOfficers = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictFieldOfficerDialogController', DistrictFieldOfficerDialogController);

    DistrictFieldOfficerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DistrictFieldOfficer', 'District', 'Department'];

    function DistrictFieldOfficerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DistrictFieldOfficer, District, Department) {
        var vm = this;

        vm.districtFieldOfficer = entity;
        vm.clear = clear;
        vm.save = save;
        var selecteddistrict=null;
        var selecteddepartment=null;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.districtFieldOfficer.districtid= vm.districtFieldOfficer.selecteddistrict.id;
            vm.districtFieldOfficer.districtName= vm.districtFieldOfficer.selecteddistrict.districtname;
            vm.districtFieldOfficer.departmentid= vm.districtFieldOfficer.selecteddepartment.id;
            vm.districtFieldOfficer.departmentName= vm.districtFieldOfficer.selecteddepartment.departmentname;
            vm.isSaving = true;
            if (vm.districtFieldOfficer.id !== null) {
                DistrictFieldOfficer.update(vm.districtFieldOfficer, onSaveSuccess, onSaveError);
            } else {
                DistrictFieldOfficer.save(vm.districtFieldOfficer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:districtFieldOfficerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.districts = [];
        loadAllDistricts();
        function loadAllDistricts() {
            District.query(function(result) {
                vm.districts = result;
                vm.searchQuery = null;
            });
        }

        vm.departments = [];
        loadAllDepartments();
        function loadAllDepartments() {
            Department.query(function(result) {
                vm.departments = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictFieldOfficerDetailController', DistrictFieldOfficerDetailController);

    DistrictFieldOfficerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DistrictFieldOfficer'];

    function DistrictFieldOfficerDetailController($scope, $rootScope, $stateParams, previousState, entity, DistrictFieldOfficer) {
        var vm = this;

        vm.districtFieldOfficer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:districtFieldOfficerUpdate', function(event, result) {
            vm.districtFieldOfficer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictFieldOfficerDeleteController',DistrictFieldOfficerDeleteController);

    DistrictFieldOfficerDeleteController.$inject = ['$uibModalInstance', 'entity', 'DistrictFieldOfficer'];

    function DistrictFieldOfficerDeleteController($uibModalInstance, entity, DistrictFieldOfficer) {
        var vm = this;

        vm.districtFieldOfficer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DistrictFieldOfficer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('district-field-officer', {
            parent: 'entity',
            url: '/district-field-officer',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.districtFieldOfficer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district-field-officer/district-field-officers.html',
                    controller: 'DistrictFieldOfficerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('districtFieldOfficer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('district-field-officer-detail', {
            parent: 'district-field-officer',
            url: '/district-field-officer/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.districtFieldOfficer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district-field-officer/district-field-officer-detail.html',
                    controller: 'DistrictFieldOfficerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('districtFieldOfficer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DistrictFieldOfficer', function($stateParams, DistrictFieldOfficer) {
                    return DistrictFieldOfficer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'district-field-officer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('district-field-officer-detail.edit', {
            parent: 'district-field-officer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-field-officer/district-field-officer-dialog.html',
                    controller: 'DistrictFieldOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DistrictFieldOfficer', function(DistrictFieldOfficer) {
                            return DistrictFieldOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district-field-officer.new', {
            parent: 'district-field-officer',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-field-officer/district-field-officer-dialog.html',
                    controller: 'DistrictFieldOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                districtid: null,
                                districtName: null,
                                departmentid: null,
                                departmentName: null,
                                designation: null,
                                fieldofficerlogin: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('district-field-officer', null, { reload: 'district-field-officer' });
                }, function() {
                    $state.go('district-field-officer');
                });
            }]
        })
        .state('district-field-officer.edit', {
            parent: 'district-field-officer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-field-officer/district-field-officer-dialog.html',
                    controller: 'DistrictFieldOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DistrictFieldOfficer', function(DistrictFieldOfficer) {
                            return DistrictFieldOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district-field-officer', null, { reload: 'district-field-officer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district-field-officer.delete', {
            parent: 'district-field-officer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-field-officer/district-field-officer-delete-dialog.html',
                    controller: 'DistrictFieldOfficerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DistrictFieldOfficer', function(DistrictFieldOfficer) {
                            return DistrictFieldOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district-field-officer', null, { reload: 'district-field-officer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DistrictFieldOfficer', DistrictFieldOfficer);

    DistrictFieldOfficer.$inject = ['$resource'];

    function DistrictFieldOfficer ($resource) {
        var resourceUrl =  'api/district-field-officers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictFieldOfficerController', DistrictFieldOfficerController);

    DistrictFieldOfficerController.$inject = ['DistrictFieldOfficer'];

    function DistrictFieldOfficerController(DistrictFieldOfficer) {

        var vm = this;

        vm.districtFieldOfficers = [];

        loadAll();

        function loadAll() {
            DistrictFieldOfficer.query(function(result) {
                vm.districtFieldOfficers = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictDeskOfficerDialogController', DistrictDeskOfficerDialogController);

    DistrictDeskOfficerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DistrictDeskOfficer','District'];

    function DistrictDeskOfficerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DistrictDeskOfficer, District) {
        var vm = this;

        vm.districtDeskOfficer = entity;
        vm.clear = clear;
        vm.save = save;
        vm.districts = [];

        loadAllDistricts();
        function loadAllDistricts() {
            District.query(function (result) {
                vm.districts=result;
                for( var i = 0; i < vm.districts.length-1; i++){
                    if ( vm.districts[i].districtname === 'Chandigarh HQ') {
                        vm.districts.splice(i, 1);
                    }
                }
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.districtDeskOfficer.id !== null) {
                DistrictDeskOfficer.update(vm.districtDeskOfficer, onSaveSuccess, onSaveError);
            } else {
                DistrictDeskOfficer.save(vm.districtDeskOfficer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:districtDeskOfficerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError (error) {
            vm.isSaving = false;
            if(error.status == 400)
                alert("Login does not exist. Please recheck or create the same.");
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictDeskOfficerDetailController', DistrictDeskOfficerDetailController);

    DistrictDeskOfficerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DistrictDeskOfficer'];

    function DistrictDeskOfficerDetailController($scope, $rootScope, $stateParams, previousState, entity, DistrictDeskOfficer) {
        var vm = this;

        vm.districtDeskOfficer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:districtDeskOfficerUpdate', function(event, result) {
            vm.districtDeskOfficer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictDeskOfficerDeleteController',DistrictDeskOfficerDeleteController);

    DistrictDeskOfficerDeleteController.$inject = ['$uibModalInstance', 'entity', 'DistrictDeskOfficer'];

    function DistrictDeskOfficerDeleteController($uibModalInstance, entity, DistrictDeskOfficer) {
        var vm = this;

        vm.districtDeskOfficer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DistrictDeskOfficer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('district-desk-officer', {
            parent: 'entity',
            url: '/district-desk-officer',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.districtDeskOfficer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district-desk-officer/district-desk-officers.html',
                    controller: 'DistrictDeskOfficerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('districtDeskOfficer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('district-desk-officer-detail', {
            parent: 'district-desk-officer',
            url: '/district-desk-officer/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.districtDeskOfficer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district-desk-officer/district-desk-officer-detail.html',
                    controller: 'DistrictDeskOfficerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('districtDeskOfficer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DistrictDeskOfficer', function($stateParams, DistrictDeskOfficer) {
                    return DistrictDeskOfficer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'district-desk-officer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('district-desk-officer-detail.edit', {
            parent: 'district-desk-officer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-desk-officer/district-desk-officer-dialog.html',
                    controller: 'DistrictDeskOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DistrictDeskOfficer', function(DistrictDeskOfficer) {
                            return DistrictDeskOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district-desk-officer.new', {
            parent: 'district-desk-officer',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-desk-officer/district-desk-officer-dialog.html',
                    controller: 'DistrictDeskOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                deskOfficerLogin: null,
                                districtid: null,
                                districtName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('district-desk-officer', null, { reload: 'district-desk-officer' });
                }, function() {
                    $state.go('district-desk-officer');
                });
            }]
        })
        .state('district-desk-officer.edit', {
            parent: 'district-desk-officer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-desk-officer/district-desk-officer-dialog.html',
                    controller: 'DistrictDeskOfficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DistrictDeskOfficer', function(DistrictDeskOfficer) {
                            return DistrictDeskOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district-desk-officer', null, { reload: 'district-desk-officer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district-desk-officer.delete', {
            parent: 'district-desk-officer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district-desk-officer/district-desk-officer-delete-dialog.html',
                    controller: 'DistrictDeskOfficerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DistrictDeskOfficer', function(DistrictDeskOfficer) {
                            return DistrictDeskOfficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district-desk-officer', null, { reload: 'district-desk-officer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DistrictDeskOfficer', DistrictDeskOfficer);

    DistrictDeskOfficer.$inject = ['$resource'];

    function DistrictDeskOfficer ($resource) {
        var resourceUrl =  'api/district-desk-officers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictDeskOfficerController', DistrictDeskOfficerController);

    DistrictDeskOfficerController.$inject = ['DistrictDeskOfficer'];

    function DistrictDeskOfficerController(DistrictDeskOfficer) {

        var vm = this;

        vm.districtDeskOfficers = [];

        loadAll();

        function loadAll() {
            DistrictDeskOfficer.query(function(result) {
                vm.districtDeskOfficers = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictDialogController', DistrictDialogController);

    DistrictDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'District', 'State'];

    function DistrictDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, District, State) {
        var vm = this;

        vm.district = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


        load();
               function load()
               {
               vm.id=$stateParams.stateID;
               State.get({id: vm.id},function(result)
               {
               $scope.selected= {id: result.id, statename: result.statename}
               });
               }



         State.query(function(result) {
                   vm.states = result;
                   vm.searchQuery = null;
               });

        function save () {
            vm.isSaving = true;
            vm.district.stateID=$scope.selected.id;
            vm.district.statename=$scope.selected.statename;
            if (vm.district.id !== null) {
                District.update(vm.district, onSaveSuccess, onSaveError);
            } else {
                District.save(vm.district, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:districtUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictDetailController', DistrictDetailController);

    DistrictDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'District'];

    function DistrictDetailController($scope, $rootScope, $stateParams, previousState, entity, District) {
        var vm = this;

        vm.district = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:districtUpdate', function(event, result) {
            vm.district = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictDeleteController',DistrictDeleteController);

    DistrictDeleteController.$inject = ['$uibModalInstance', 'entity', 'District'];

    function DistrictDeleteController($uibModalInstance, entity, District) {
        var vm = this;

        vm.district = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            District.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('district', {
            parent: 'entity',
            url: '/district',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.district.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district/districts.html',
                    controller: 'DistrictController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('district');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('district-detail', {
            parent: 'district',
            url: '/district/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.district.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/district/district-detail.html',
                    controller: 'DistrictDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('district');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'District', function($stateParams, District) {
                    return District.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'district',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('district-detail.edit', {
            parent: 'district-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district/district-dialog.html',
                    controller: 'DistrictDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['District', function(District) {
                            return District.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district.new', {
            parent: 'district',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district/district-dialog.html',
                    controller: 'DistrictDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                districtname: null,
                                statename: null,
                                powercompany: null,
                                stateID: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('district', null, { reload: 'district' });
                }, function() {
                    $state.go('district');
                });
            }]
        })
        .state('district.edit', {
            parent: 'district',
            url: '/?{id}/{stateID}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district/district-dialog.html',
                    controller: 'DistrictDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['District', function(District) {
                            return District.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district', null, { reload: 'district' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('district.delete', {
            parent: 'district',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/district/district-delete-dialog.html',
                    controller: 'DistrictDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['District', function(District) {
                            return District.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('district', null, { reload: 'district' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('District', District);

    District.$inject = ['$resource'];

    function District ($resource) {
        var resourceUrl =  'api/districts/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DistrictController', DistrictController);

    DistrictController.$inject = ['District'];

    function DistrictController(District) {

        var vm = this;

        vm.districts = [];

        loadAll();

        function loadAll() {
            District.query(function(result) {
                vm.districts = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputelogDialogController', DisputelogDialogController);

    DisputelogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Disputelog'];

    function DisputelogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Disputelog) {
        var vm = this;

        vm.disputelog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.disputelog.id !== null) {
                Disputelog.update(vm.disputelog, onSaveSuccess, onSaveError);
            } else {
                Disputelog.save(vm.disputelog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:disputelogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.actionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputelogDetailController', DisputelogDetailController);

    DisputelogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Disputelog'];

    function DisputelogDetailController($scope, $rootScope, $stateParams, previousState, entity, Disputelog) {
        var vm = this;

        vm.disputelog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:disputelogUpdate', function(event, result) {
            vm.disputelog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputelogDeleteController',DisputelogDeleteController);

    DisputelogDeleteController.$inject = ['$uibModalInstance', 'entity', 'Disputelog'];

    function DisputelogDeleteController($uibModalInstance, entity, Disputelog) {
        var vm = this;

        vm.disputelog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Disputelog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('disputelog', {
            parent: 'entity',
            url: '/disputelog',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.disputelog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disputelog/disputelogs.html',
                    controller: 'DisputelogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disputelog');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('disputelog-detail', {
            parent: 'disputelog',
            url: '/disputelog/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.disputelog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/disputelog/disputelog-detail.html',
                    controller: 'DisputelogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disputelog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Disputelog', function($stateParams, Disputelog) {
                    return Disputelog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'disputelog',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('disputelog-detail.edit', {
            parent: 'disputelog-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disputelog/disputelog-dialog.html',
                    controller: 'DisputelogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Disputelog', function(Disputelog) {
                            return Disputelog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('disputelog.new', {
            parent: 'disputelog',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disputelog/disputelog-dialog.html',
                    controller: 'DisputelogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                action: null,
                                actionBy: null,
                                actionComment: null,
                                actionDate: null,
                                disputeID: null,
                                disputeMainId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('disputelog', null, { reload: 'disputelog' });
                }, function() {
                    $state.go('disputelog');
                });
            }]
        })
        .state('disputelog.edit', {
            parent: 'disputelog',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disputelog/disputelog-dialog.html',
                    controller: 'DisputelogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Disputelog', function(Disputelog) {
                            return Disputelog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('disputelog', null, { reload: 'disputelog' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('disputelog.delete', {
            parent: 'disputelog',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/disputelog/disputelog-delete-dialog.html',
                    controller: 'DisputelogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Disputelog', function(Disputelog) {
                            return Disputelog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('disputelog', null, { reload: 'disputelog' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Disputelog', Disputelog);

    Disputelog.$inject = ['$resource', 'DateUtils'];

    function Disputelog ($resource, DateUtils) {
        var resourceUrl =  'api/disputelogs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.actionDate = DateUtils.convertDateTimeFromServer(data.actionDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputelogController', DisputelogController);

    DisputelogController.$inject = ['Disputelog'];

    function DisputelogController(Disputelog) {

        var vm = this;

        vm.disputelogs = [];

        loadAll();

        function loadAll() {
            Disputelog.query(function(result) {
                vm.disputelogs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeAttachmentDialogController', DisputeAttachmentDialogController);

    DisputeAttachmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DisputeAttachment'];

    function DisputeAttachmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DisputeAttachment) {
        var vm = this;

        vm.disputeAttachment = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.disputeAttachment.id !== null) {
                DisputeAttachment.update(vm.disputeAttachment, onSaveSuccess, onSaveError);
            } else {
                DisputeAttachment.save(vm.disputeAttachment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:disputeAttachmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeAttachmentDetailController', DisputeAttachmentDetailController);

    DisputeAttachmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DisputeAttachment'];

    function DisputeAttachmentDetailController($scope, $rootScope, $stateParams, previousState, entity, DisputeAttachment) {
        var vm = this;

        vm.disputeAttachment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:disputeAttachmentUpdate', function(event, result) {
            vm.disputeAttachment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeAttachmentDeleteController',DisputeAttachmentDeleteController);

    DisputeAttachmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'DisputeAttachment'];

    function DisputeAttachmentDeleteController($uibModalInstance, entity, DisputeAttachment) {
        var vm = this;

        vm.disputeAttachment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DisputeAttachment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dispute-attachment', {
            parent: 'entity',
            url: '/dispute-attachment',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.disputeAttachment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispute-attachment/dispute-attachments.html',
                    controller: 'DisputeAttachmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disputeAttachment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dispute-attachment-detail', {
            parent: 'dispute-attachment',
            url: '/dispute-attachment/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.disputeAttachment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispute-attachment/dispute-attachment-detail.html',
                    controller: 'DisputeAttachmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('disputeAttachment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DisputeAttachment', function($stateParams, DisputeAttachment) {
                    return DisputeAttachment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dispute-attachment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dispute-attachment-detail.edit', {
            parent: 'dispute-attachment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispute-attachment/dispute-attachment-dialog.html',
                    controller: 'DisputeAttachmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DisputeAttachment', function(DisputeAttachment) {
                            return DisputeAttachment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispute-attachment.new', {
            parent: 'dispute-attachment',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispute-attachment/dispute-attachment-dialog.html',
                    controller: 'DisputeAttachmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                fileName: null,
                                disputeId: null,
                                disputeMainId: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dispute-attachment', null, { reload: 'dispute-attachment' });
                }, function() {
                    $state.go('dispute-attachment');
                });
            }]
        })
        .state('dispute-attachment.edit', {
            parent: 'dispute-attachment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispute-attachment/dispute-attachment-dialog.html',
                    controller: 'DisputeAttachmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DisputeAttachment', function(DisputeAttachment) {
                            return DisputeAttachment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispute-attachment', null, { reload: 'dispute-attachment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispute-attachment.delete', {
            parent: 'dispute-attachment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispute-attachment/dispute-attachment-delete-dialog.html',
                    controller: 'DisputeAttachmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DisputeAttachment', function(DisputeAttachment) {
                            return DisputeAttachment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispute-attachment', null, { reload: 'dispute-attachment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DisputeAttachment', DisputeAttachment);

    DisputeAttachment.$inject = ['$resource'];

    function DisputeAttachment ($resource) {
        var resourceUrl =  'api/dispute-attachments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeAttachmentController', DisputeAttachmentController);

    DisputeAttachmentController.$inject = ['DisputeAttachment'];

    function DisputeAttachmentController(DisputeAttachment) {

        var vm = this;

        vm.disputeAttachments = [];

        loadAll();

        function loadAll() {
            DisputeAttachment.query(function(result) {
                vm.disputeAttachments = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeDialogController', DisputeDialogController);

    DisputeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dispute'];

    function DisputeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dispute) {
        var vm = this;

        vm.dispute = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dispute.id !== null) {
                Dispute.update(vm.dispute, onSaveSuccess, onSaveError);
            } else {
                Dispute.save(vm.dispute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:disputeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.dateOfFiling = false;
        vm.datePickerOpenStatus.creationDate = false;
        vm.datePickerOpenStatus.lastActionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeDetailController', DisputeDetailController);

    DisputeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Dispute'];

    function DisputeDetailController($scope, $rootScope, $stateParams, previousState, entity, Dispute) {
        var vm = this;

        vm.dispute = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:disputeUpdate', function(event, result) {
            vm.dispute = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeDeleteController',DisputeDeleteController);

    DisputeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dispute'];

    function DisputeDeleteController($uibModalInstance, entity, Dispute) {
        var vm = this;

        vm.dispute = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dispute.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dispute', {
            parent: 'entity',
            url: '/dispute',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.dispute.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispute/disputes.html',
                    controller: 'DisputeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dispute');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dispute-detail', {
            parent: 'dispute',
            url: '/dispute/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.dispute.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dispute/dispute-detail.html',
                    controller: 'DisputeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dispute');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dispute', function($stateParams, Dispute) {
                    return Dispute.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dispute',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dispute-detail.edit', {
            parent: 'dispute-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispute/dispute-dialog.html',
                    controller: 'DisputeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dispute', function(Dispute) {
                            return Dispute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispute.new', {
            parent: 'dispute',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispute/dispute-dialog.html',
                    controller: 'DisputeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nameOfEnterprise: null,
                                activity: null,
                                nameOfPartner: null,
                                mobileNumber: null,
                                emailAddress: null,
                                fixedInvestement: null,
                                categoryOfDispute: null,
                                detailOfDispute: null,
                                statusPendingLevel: null,
                                isResolved: null,
                                disputeID: null,
                                gotReliefLevel: null,
                                levelOfRelief: null,
                                departmentName: null,
                                departmentAppeals: null,
                                address: null,
                                officeAddress: null,
                                resolveComment: null,
                                userlogin: null,
                                dateOfFilingPetition: null,
                                replyOfDepartment: null,
                                detailsOfDecision: null,
                                orderOfReliefAttachemnt: null,
                                appealsDocument: null,
                                distrcit: null,
                                dateOfFiling: null,
                                durationOfPendency: null,
                                otherCategoryDispute: null,
                                creationDate: null,
                                lastActionDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dispute', null, { reload: 'dispute' });
                }, function() {
                    $state.go('dispute');
                });
            }]
        })
        .state('dispute.edit', {
            parent: 'dispute',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispute/dispute-dialog.html',
                    controller: 'DisputeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dispute', function(Dispute) {
                            return Dispute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispute', null, { reload: 'dispute' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dispute.delete', {
            parent: 'dispute',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dispute/dispute-delete-dialog.html',
                    controller: 'DisputeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dispute', function(Dispute) {
                            return Dispute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dispute', null, { reload: 'dispute' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Dispute', Dispute);

    Dispute.$inject = ['$resource', 'DateUtils'];

    function Dispute ($resource, DateUtils) {
        var resourceUrl =  'api/disputes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.dateOfFiling = DateUtils.convertLocalDateFromServer(data.dateOfFiling);
                        data.creationDate = DateUtils.convertDateTimeFromServer(data.creationDate);
                        data.lastActionDate = DateUtils.convertDateTimeFromServer(data.lastActionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfFiling = DateUtils.convertLocalDateToServer(copy.dateOfFiling);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.dateOfFiling = DateUtils.convertLocalDateToServer(copy.dateOfFiling);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeController', DisputeController);

    DisputeController.$inject = ['Dispute'];

    function DisputeController(Dispute) {

        var vm = this;

        vm.disputes = [];

        loadAll();

        function loadAll() {
            Dispute.query(function(result) {
                vm.disputes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentserviceDialogController', DepartmentserviceDialogController);

    DepartmentserviceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Departmentservice'];

    function DepartmentserviceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Departmentservice) {
        var vm = this;

        vm.departmentservice = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.departmentservice.id !== null) {
                Departmentservice.update(vm.departmentservice, onSaveSuccess, onSaveError);
            } else {
                Departmentservice.save(vm.departmentservice, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:departmentserviceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentserviceDetailController', DepartmentserviceDetailController);

    DepartmentserviceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Departmentservice'];

    function DepartmentserviceDetailController($scope, $rootScope, $stateParams, previousState, entity, Departmentservice) {
        var vm = this;

        vm.departmentservice = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:departmentserviceUpdate', function(event, result) {
            vm.departmentservice = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentserviceDeleteController',DepartmentserviceDeleteController);

    DepartmentserviceDeleteController.$inject = ['$uibModalInstance', 'entity', 'Departmentservice'];

    function DepartmentserviceDeleteController($uibModalInstance, entity, Departmentservice) {
        var vm = this;

        vm.departmentservice = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Departmentservice.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('departmentservice', {
            parent: 'entity',
            url: '/departmentservice',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.departmentservice.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/departmentservice/departmentservices.html',
                    controller: 'DepartmentserviceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('departmentservice');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('departmentservice-detail', {
            parent: 'departmentservice',
            url: '/departmentservice/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.departmentservice.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/departmentservice/departmentservice-detail.html',
                    controller: 'DepartmentserviceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('departmentservice');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Departmentservice', function($stateParams, Departmentservice) {
                    return Departmentservice.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'departmentservice',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('departmentservice-detail.edit', {
            parent: 'departmentservice-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/departmentservice/departmentservice-dialog.html',
                    controller: 'DepartmentserviceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Departmentservice', function(Departmentservice) {
                            return Departmentservice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('departmentservice.new', {
            parent: 'departmentservice',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/departmentservice/departmentservice-dialog.html',
                    controller: 'DepartmentserviceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                duration: null,
                                stage: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('departmentservice', null, { reload: 'departmentservice' });
                }, function() {
                    $state.go('departmentservice');
                });
            }]
        })
        .state('departmentservice.edit', {
            parent: 'departmentservice',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/departmentservice/departmentservice-dialog.html',
                    controller: 'DepartmentserviceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Departmentservice', function(Departmentservice) {
                            return Departmentservice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('departmentservice', null, { reload: 'departmentservice' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('departmentservice.delete', {
            parent: 'departmentservice',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/departmentservice/departmentservice-delete-dialog.html',
                    controller: 'DepartmentserviceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Departmentservice', function(Departmentservice) {
                            return Departmentservice.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('departmentservice', null, { reload: 'departmentservice' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Departmentservice', Departmentservice);

    Departmentservice.$inject = ['$resource'];

    function Departmentservice ($resource) {
        var resourceUrl =  'api/departmentservices/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentserviceController', DepartmentserviceController);

    DepartmentserviceController.$inject = ['Departmentservice'];

    function DepartmentserviceController(Departmentservice) {

        var vm = this;

        vm.departmentservices = [];

        loadAll();

        function loadAll() {
            Departmentservice.query(function(result) {
                vm.departmentservices = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('depserviceController', depserviceController);

    depserviceController.$inject = ['$scope','$http'];

    function depserviceController($scope, $http) {
        $http.get("/api/departments").then(function(response) {
           return $scope.students = response.data;
       });
    }
//    function distcountryController($scope, $http) {
//       // $http.get("country.js").then(function(response) {
//           return $scope.students = [
//            {
//            "id":"20c7501a-b84a-4f32-891c-289a0d76eeb8",
//            "cname":"INDIA"
//            },
//            {
//                "id":"7f2bbaa1-c6b0-4310-9d27-b013e20f5c70",
//                "cname":"ENGLAND"
//            }
//        ];
       //});
    //}



})();


(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentServiceDialogController', DepartmentServiceDialogController);

    DepartmentServiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DepartmentService'];

    function DepartmentServiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DepartmentService) {
        var vm = this;

        vm.departmentService = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            console.log(vm.departmentService);

            if (vm.departmentService.id !== null) {
                DepartmentService.update(vm.departmentService, onSaveSuccess, onSaveError);
            } else {
                DepartmentService.save(vm.departmentService, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:departmentServiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.integrationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentServiceDetailController', DepartmentServiceDetailController);

    DepartmentServiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DepartmentService'];

    function DepartmentServiceDetailController($scope, $rootScope, $stateParams, previousState, entity, DepartmentService) {
        var vm = this;

        vm.departmentService = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:departmentServiceUpdate', function(event, result) {
            vm.departmentService = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentServiceDeleteController',DepartmentServiceDeleteController);

    DepartmentServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'DepartmentService'];

    function DepartmentServiceDeleteController($uibModalInstance, entity, DepartmentService) {
        var vm = this;

        vm.departmentService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DepartmentService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DepartmentServiceData', DepartmentServiceData);

    DepartmentServiceData.$inject = ['$resource'];

    function DepartmentServiceData ($resource) {
        var resourceUrl =  'api/department-servicesdata/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('department-service', {
            parent: 'entity',
            url: '/department-service',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.departmentService.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/department-service/department-services.html',
                    controller: 'DepartmentServiceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('departmentService');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('department-service-detail', {
            parent: 'department-service',
            url: '/department-service/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.departmentService.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/department-service/department-service-detail.html',
                    controller: 'DepartmentServiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('departmentService');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DepartmentService', function($stateParams, DepartmentService) {
                    return DepartmentService.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'department-service',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('department-service-detail.edit', {
            parent: 'department-service-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department-service/department-service-dialog.html',
                    controller: 'DepartmentServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DepartmentService', function(DepartmentService) {
                            return DepartmentService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('department-service.new', {
            parent: 'department-service',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department-service/department-service-dialog.html',
                    controller: 'DepartmentServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                serviceName: null,
                                serviceDescription: null,
                                duration: null,
                                stage: null,
                                rtsDays: null,
                                departmentname: null,
                                approvalId: null,
                                departmentid: null,
                                isRenewable: false,
                                isShop: false,
                                constructionpermit: null,
                                active: false,
                                isRemoveFromDashboards: false,
                                istowerservice: false,
                                integrationDate: null,
                                url: null,
                                isIntegrated: false,
                                islandexchange: false,
                                isRowService: false,
                                isNewService: false,
                                isFilm: false,
                                isLandRequirement: false,
                                downloadUrl: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('department-service', null, { reload: 'department-service' });
                }, function() {
                    $state.go('department-service');
                });
            }]
        })
        .state('department-service.edit', {
            parent: 'department-service',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department-service/department-service-dialog.html',
                    controller: 'DepartmentServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DepartmentService', function(DepartmentService) {
                            return DepartmentService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('department-service', null, { reload: 'department-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('department-service.delete', {
            parent: 'department-service',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department-service/department-service-delete-dialog.html',
                    controller: 'DepartmentServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DepartmentService', function(DepartmentService) {
                            return DepartmentService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('department-service', null, { reload: 'department-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DepartmentService', DepartmentService);

    DepartmentService.$inject = ['$resource', 'DateUtils'];

    function DepartmentService ($resource, DateUtils) {
        var resourceUrl =  'api/department-services/:id/:departmentid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.integrationDate = DateUtils.convertDateTimeFromServer(data.integrationDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentServiceController', DepartmentServiceController);

    DepartmentServiceController.$inject = ['DepartmentService'];

    function DepartmentServiceController(DepartmentService) {

        var vm = this;

        vm.departmentServices = [];

        loadAll();

        function loadAll() {
            DepartmentService.query(function(result) {
                vm.departmentServices = result;
                console.log(vm.departmentServices);
                vm.searchQuery = null;
            });
        }
        console.log(vm.departmentServices);

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentHodDialogController', DepartmentHodDialogController);

    DepartmentHodDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DepartmentHod','Department'];

    function DepartmentHodDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DepartmentHod,Department) {
        var vm = this;

        vm.departmentHod = entity;
        vm.clear = clear;
        vm.save = save;
        vm.selectedDepartment = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.departmentHod.id !== null) {
                DepartmentHod.update(vm.departmentHod, onSaveSuccess, onSaveError);
            } else {
                DepartmentHod.save(vm.departmentHod, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:departmentHodUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }
        vm.departments = [];
        loadAllDepartments();
        function loadAllDepartments() {
            Department.query(function(result) {
                vm.departmentstemp = result;
                angular.forEach(vm.departmentstemp, function(value, key){
                    if(value.departmentname!=='Development and Panchayats'){
                        vm.departments.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }
        vm.onDepartmentChange = function(department){
            console.log(department);
            vm.departmentHod.departmentId = department.id;
            vm.departmentHod.departmentName = department.departmentname;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentHodDetailController', DepartmentHodDetailController);

    DepartmentHodDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DepartmentHod'];

    function DepartmentHodDetailController($scope, $rootScope, $stateParams, previousState, entity, DepartmentHod) {
        var vm = this;

        vm.departmentHod = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:departmentHodUpdate', function(event, result) {
            vm.departmentHod = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentHodDeleteController',DepartmentHodDeleteController);

    DepartmentHodDeleteController.$inject = ['$uibModalInstance', 'entity', 'DepartmentHod'];

    function DepartmentHodDeleteController($uibModalInstance, entity, DepartmentHod) {
        var vm = this;

        vm.departmentHod = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DepartmentHod.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('department-hod', {
            parent: 'entity',
            url: '/department-hod',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.departmentHod.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/department-hod/department-hods.html',
                    controller: 'DepartmentHodController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('departmentHod');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('department-hod-detail', {
            parent: 'department-hod',
            url: '/department-hod/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'investhryApp.departmentHod.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/department-hod/department-hod-detail.html',
                    controller: 'DepartmentHodDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('departmentHod');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DepartmentHod', function($stateParams, DepartmentHod) {
                    return DepartmentHod.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'department-hod',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('department-hod-detail.edit', {
            parent: 'department-hod-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department-hod/department-hod-dialog.html',
                    controller: 'DepartmentHodDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DepartmentHod', function(DepartmentHod) {
                            return DepartmentHod.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('department-hod.new', {
            parent: 'department-hod',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department-hod/department-hod-dialog.html',
                    controller: 'DepartmentHodDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                departmentId: null,
                                departmentName: null,
                                login: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('department-hod', null, { reload: 'department-hod' });
                }, function() {
                    $state.go('department-hod');
                });
            }]
        })
        .state('department-hod.edit', {
            parent: 'department-hod',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department-hod/department-hod-dialog.html',
                    controller: 'DepartmentHodDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DepartmentHod', function(DepartmentHod) {
                            return DepartmentHod.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('department-hod', null, { reload: 'department-hod' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('department-hod.delete', {
            parent: 'department-hod',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department-hod/department-hod-delete-dialog.html',
                    controller: 'DepartmentHodDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DepartmentHod', function(DepartmentHod) {
                            return DepartmentHod.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('department-hod', null, { reload: 'department-hod' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DepartmentHod', DepartmentHod);

    DepartmentHod.$inject = ['$resource'];

    function DepartmentHod ($resource) {
        var resourceUrl =  'api/department-hods/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentHodController', DepartmentHodController);

    DepartmentHodController.$inject = ['DepartmentHod'];

    function DepartmentHodController(DepartmentHod) {

        var vm = this;

        vm.departmentHods = [];

        loadAll();

        function loadAll() {
            DepartmentHod.query(function(result) {
                vm.departmentHods = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('NodalOfficerList', NodalOfficerList);

    NodalOfficerList.$inject = ['$resource'];

    function NodalOfficerList ($resource) {
        var resourceUrl =  'api/users/Nodal_Officer';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentDialogController', DepartmentDialogController);

    DepartmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Department'];

    function DepartmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Department) {
        var vm = this;

        vm.department = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.department.id !== null) {
                Department.update(vm.department, onSaveSuccess, onSaveError);
            } else {
                Department.save(vm.department, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:departmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentDetailController', DepartmentDetailController);

    DepartmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Department'];

    function DepartmentDetailController($scope, $rootScope, $stateParams, previousState, entity, Department) {
        var vm = this;

        vm.department = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:departmentUpdate', function(event, result) {
            vm.department = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentDeleteController',DepartmentDeleteController);

    DepartmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'Department'];

    function DepartmentDeleteController($uibModalInstance, entity, Department) {
        var vm = this;

        vm.department = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Department.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('department', {
            parent: 'entity',
            url: '/department',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.department.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/department/departments.html',
                    controller: 'DepartmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('department');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('department-detail', {
            parent: 'department',
            url: '/department/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.department.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/department/department-detail.html',
                    controller: 'DepartmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('department');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Department', function($stateParams, Department) {
                    return Department.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'department',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('department-detail.edit', {
            parent: 'department-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department/department-dialog.html',
                    controller: 'DepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Department', function(Department) {
                            return Department.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('department.new', {
            parent: 'department',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department/department-dialog.html',
                    controller: 'DepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                departmentname: null,
                                description: null,
                                hod: null,
                                email: null,
                                hodmobile: null,
                                nodalofficer: null,
                                departmentorder: null,
                                istower: null,
                                isrow: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('department', null, { reload: 'department' });
                }, function() {
                    $state.go('department');
                });
            }]
        })
        .state('department.edit', {
            parent: 'department',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department/department-dialog.html',
                    controller: 'DepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Department', function(Department) {
                            return Department.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('department', null, { reload: 'department' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('department.delete', {
            parent: 'department',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/department/department-delete-dialog.html',
                    controller: 'DepartmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Department', function(Department) {
                            return Department.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('department', null, { reload: 'department' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Department', Department);

    Department.$inject = ['$resource'];

    function Department ($resource) {
        var resourceUrl =  'api/departments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentController', DepartmentController);

    DepartmentController.$inject = ['Department'];

    function DepartmentController(Department) {

        var vm = this;

        vm.departments = [];

        loadAll();

        function loadAll() {
            Department.query(function(result) {
                vm.departments = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DeemedClearanceApprovalDialogController', DeemedClearanceApprovalDialogController);

    DeemedClearanceApprovalDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'DeemedClearanceApproval'];

    function DeemedClearanceApprovalDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, DeemedClearanceApproval) {
        var vm = this;

        vm.deemedClearanceApproval = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.deemedClearanceApproval.id !== null) {
                DeemedClearanceApproval.update(vm.deemedClearanceApproval, onSaveSuccess, onSaveError);
            } else {
                DeemedClearanceApproval.save(vm.deemedClearanceApproval, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:deemedClearanceApprovalUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DeemedClearanceApprovalDetailController', DeemedClearanceApprovalDetailController);

    DeemedClearanceApprovalDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'DeemedClearanceApproval'];

    function DeemedClearanceApprovalDetailController($scope, $rootScope, $stateParams, previousState, entity, DeemedClearanceApproval) {
        var vm = this;

        vm.deemedClearanceApproval = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:deemedClearanceApprovalUpdate', function(event, result) {
            vm.deemedClearanceApproval = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DeemedClearanceApprovalDeleteController',DeemedClearanceApprovalDeleteController);

    DeemedClearanceApprovalDeleteController.$inject = ['$uibModalInstance', 'entity', 'DeemedClearanceApproval'];

    function DeemedClearanceApprovalDeleteController($uibModalInstance, entity, DeemedClearanceApproval) {
        var vm = this;

        vm.deemedClearanceApproval = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            DeemedClearanceApproval.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('deemed-clearance-approval', {
            parent: 'entity',
            url: '/deemed-clearance-approval',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.deemedClearanceApproval.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/deemed-clearance-approval/deemed-clearance-approvals.html',
                    controller: 'DeemedClearanceApprovalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('deemedClearanceApproval');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('deemed-clearance-approval-detail', {
            parent: 'deemed-clearance-approval',
            url: '/deemed-clearance-approval/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.deemedClearanceApproval.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/deemed-clearance-approval/deemed-clearance-approval-detail.html',
                    controller: 'DeemedClearanceApprovalDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('deemedClearanceApproval');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'DeemedClearanceApproval', function($stateParams, DeemedClearanceApproval) {
                    return DeemedClearanceApproval.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'deemed-clearance-approval',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('deemed-clearance-approval-detail.edit', {
            parent: 'deemed-clearance-approval-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/deemed-clearance-approval/deemed-clearance-approval-dialog.html',
                    controller: 'DeemedClearanceApprovalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DeemedClearanceApproval', function(DeemedClearanceApproval) {
                            return DeemedClearanceApproval.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('deemed-clearance-approval.new', {
            parent: 'deemed-clearance-approval',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/deemed-clearance-approval/deemed-clearance-approval-dialog.html',
                    controller: 'DeemedClearanceApprovalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                cafpin: null,
                                serviceName: null,
                                departmentName: null,
                                forwardedToDO: null,
                                fowardedtoADI: null,
                                forwardedtoDI: null,
                                forwardedtoCEO: null,
                                approved: null,
                                discarded: null,
                                discardedby: null,
                                discardcomment: null,
                                status: null,
                                projectlevel: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('deemed-clearance-approval', null, { reload: 'deemed-clearance-approval' });
                }, function() {
                    $state.go('deemed-clearance-approval');
                });
            }]
        })
        .state('deemed-clearance-approval.edit', {
            parent: 'deemed-clearance-approval',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/deemed-clearance-approval/deemed-clearance-approval-dialog.html',
                    controller: 'DeemedClearanceApprovalDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['DeemedClearanceApproval', function(DeemedClearanceApproval) {
                            return DeemedClearanceApproval.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('deemed-clearance-approval', null, { reload: 'deemed-clearance-approval' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('deemed-clearance-approval.delete', {
            parent: 'deemed-clearance-approval',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/deemed-clearance-approval/deemed-clearance-approval-delete-dialog.html',
                    controller: 'DeemedClearanceApprovalDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['DeemedClearanceApproval', function(DeemedClearanceApproval) {
                            return DeemedClearanceApproval.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('deemed-clearance-approval', null, { reload: 'deemed-clearance-approval' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DeemedClearanceApproval', DeemedClearanceApproval);

    DeemedClearanceApproval.$inject = ['$resource'];

    function DeemedClearanceApproval ($resource) {
        var resourceUrl =  'api/deemed-clearance-approvals/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DeemedClearanceApprovalController', DeemedClearanceApprovalController);

    DeemedClearanceApprovalController.$inject = ['DeemedClearanceApproval'];

    function DeemedClearanceApprovalController(DeemedClearanceApproval) {

        var vm = this;

        vm.deemedClearanceApprovals = [];

        loadAll();

        function loadAll() {
            DeemedClearanceApproval.query(function(result) {
                vm.deemedClearanceApprovals = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DecriminalizationDialogController', DecriminalizationDialogController);

    DecriminalizationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Decriminalization'];

    function DecriminalizationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Decriminalization) {
        var vm = this;

        vm.decriminalization = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.decriminalization.id !== null) {
                Decriminalization.update(vm.decriminalization, onSaveSuccess, onSaveError);
            } else {
                Decriminalization.save(vm.decriminalization, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:decriminalizationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DecriminalizationDetailController', DecriminalizationDetailController);

    DecriminalizationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Decriminalization'];

    function DecriminalizationDetailController($scope, $rootScope, $stateParams, previousState, entity, Decriminalization) {
        var vm = this;

        vm.decriminalization = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:decriminalizationUpdate', function(event, result) {
            vm.decriminalization = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DecriminalizationDeleteController',DecriminalizationDeleteController);

    DecriminalizationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Decriminalization'];

    function DecriminalizationDeleteController($uibModalInstance, entity, Decriminalization) {
        var vm = this;

        vm.decriminalization = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Decriminalization.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('decriminalization', {
            parent: 'entity',
            url: '/decriminalization',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.decriminalization.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/decriminalization/decriminalizations.html',
                    controller: 'DecriminalizationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('decriminalization');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('decriminalization-detail', {
            parent: 'decriminalization',
            url: '/decriminalization/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.decriminalization.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/decriminalization/decriminalization-detail.html',
                    controller: 'DecriminalizationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('decriminalization');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Decriminalization', function($stateParams, Decriminalization) {
                    return Decriminalization.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'decriminalization',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('decriminalization-detail.edit', {
            parent: 'decriminalization-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decriminalization/decriminalization-dialog.html',
                    controller: 'DecriminalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Decriminalization', function(Decriminalization) {
                            return Decriminalization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('decriminalization.new', {
            parent: 'decriminalization',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decriminalization/decriminalization-dialog.html',
                    controller: 'DecriminalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                complianceRequest: null,
                                departmentName: null,
                                departmentId: null,
                                serviceType: null,
                                otherServiceType: null,
                                serviceSchemeName: null,
                                actName: null,
                                ruleRegulation: null,
                                ruleRegulationName: null,
                                sectionRuleNumber: null,
                                sectionRuleNumberCriminalProvision: null,
                                criminalPunishmentDescription: null,
                                sector: null,
                                otherSector: null,
                                offence: null,
                                criminalPunishmentTenureInMonths: null,
                                minimumTenure: null,
                                maximumTenure: null,
                                criminalPunishmentAmountInInr: null,
                                minimumAmount: null,
                                maximumAmount: null,
                                createDate: null,
                                updateDate: null,
                                sectorId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('decriminalization', null, { reload: 'decriminalization' });
                }, function() {
                    $state.go('decriminalization');
                });
            }]
        })
        .state('decriminalization.edit', {
            parent: 'decriminalization',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decriminalization/decriminalization-dialog.html',
                    controller: 'DecriminalizationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Decriminalization', function(Decriminalization) {
                            return Decriminalization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('decriminalization', null, { reload: 'decriminalization' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('decriminalization.delete', {
            parent: 'decriminalization',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/decriminalization/decriminalization-delete-dialog.html',
                    controller: 'DecriminalizationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Decriminalization', function(Decriminalization) {
                            return Decriminalization.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('decriminalization', null, { reload: 'decriminalization' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Decriminalization', Decriminalization);

    Decriminalization.$inject = ['$resource', 'DateUtils'];

    function Decriminalization ($resource, DateUtils) {
        var resourceUrl =  'api/decriminalizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.updateDate = DateUtils.convertDateTimeFromServer(data.updateDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DecriminalizationController', DecriminalizationController);

    DecriminalizationController.$inject = ['Decriminalization'];

    function DecriminalizationController(Decriminalization) {

        var vm = this;

        vm.decriminalizations = [];

        loadAll();

        function loadAll() {
            Decriminalization.query(function(result) {
                vm.decriminalizations = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DashboardbetweendatescafDialogController', DashboardbetweendatescafDialogController);

    DashboardbetweendatescafDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Dashboardbetweendatescaf'];

    function DashboardbetweendatescafDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Dashboardbetweendatescaf) {
        var vm = this;

        vm.dashboardbetweendatescaf = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.dashboardbetweendatescaf.id !== null) {
                Dashboardbetweendatescaf.update(vm.dashboardbetweendatescaf, onSaveSuccess, onSaveError);
            } else {
                Dashboardbetweendatescaf.save(vm.dashboardbetweendatescaf, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:dashboardbetweendatescafUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.statusDate = false;
        vm.datePickerOpenStatus.formFilledOn = false;
        vm.datePickerOpenStatus.appliedDate = false;
        vm.datePickerOpenStatus.clearedDate = false;
        vm.datePickerOpenStatus.rejectionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DashboardbetweendatescafDetailController', DashboardbetweendatescafDetailController);

    DashboardbetweendatescafDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Dashboardbetweendatescaf'];

    function DashboardbetweendatescafDetailController($scope, $rootScope, $stateParams, previousState, entity, Dashboardbetweendatescaf) {
        var vm = this;

        vm.dashboardbetweendatescaf = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:dashboardbetweendatescafUpdate', function(event, result) {
            vm.dashboardbetweendatescaf = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DashboardbetweendatescafDeleteController',DashboardbetweendatescafDeleteController);

    DashboardbetweendatescafDeleteController.$inject = ['$uibModalInstance', 'entity', 'Dashboardbetweendatescaf'];

    function DashboardbetweendatescafDeleteController($uibModalInstance, entity, Dashboardbetweendatescaf) {
        var vm = this;

        vm.dashboardbetweendatescaf = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Dashboardbetweendatescaf.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('dashboardbetweendatescaf', {
            parent: 'entity',
            url: '/dashboardbetweendatescaf',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.dashboardbetweendatescaf.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dashboardbetweendatescaf/dashboardbetweendatescafs.html',
                    controller: 'DashboardbetweendatescafController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboardbetweendatescaf');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('dashboardbetweendatescaf-detail', {
            parent: 'dashboardbetweendatescaf',
            url: '/dashboardbetweendatescaf/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.dashboardbetweendatescaf.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/dashboardbetweendatescaf/dashboardbetweendatescaf-detail.html',
                    controller: 'DashboardbetweendatescafDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboardbetweendatescaf');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Dashboardbetweendatescaf', function($stateParams, Dashboardbetweendatescaf) {
                    return Dashboardbetweendatescaf.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'dashboardbetweendatescaf',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('dashboardbetweendatescaf-detail.edit', {
            parent: 'dashboardbetweendatescaf-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dashboardbetweendatescaf/dashboardbetweendatescaf-dialog.html',
                    controller: 'DashboardbetweendatescafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dashboardbetweendatescaf', function(Dashboardbetweendatescaf) {
                            return Dashboardbetweendatescaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dashboardbetweendatescaf.new', {
            parent: 'dashboardbetweendatescaf',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dashboardbetweendatescaf/dashboardbetweendatescaf-dialog.html',
                    controller: 'DashboardbetweendatescafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                serviceId: null,
                                statusDate: null,
                                status: null,
                                projectId: null,
                                cafpin: null,
                                businessEntity: null,
                                district: null,
                                projectLevel: null,
                                proposedEmployment: null,
                                proposedInvestment: null,
                                duration: null,
                                ageing: null,
                                formFilledOn: null,
                                appliedDate: null,
                                clearedDate: null,
                                serviceName: null,
                                rejectionDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('dashboardbetweendatescaf', null, { reload: 'dashboardbetweendatescaf' });
                }, function() {
                    $state.go('dashboardbetweendatescaf');
                });
            }]
        })
        .state('dashboardbetweendatescaf.edit', {
            parent: 'dashboardbetweendatescaf',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dashboardbetweendatescaf/dashboardbetweendatescaf-dialog.html',
                    controller: 'DashboardbetweendatescafDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Dashboardbetweendatescaf', function(Dashboardbetweendatescaf) {
                            return Dashboardbetweendatescaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dashboardbetweendatescaf', null, { reload: 'dashboardbetweendatescaf' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('dashboardbetweendatescaf.delete', {
            parent: 'dashboardbetweendatescaf',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/dashboardbetweendatescaf/dashboardbetweendatescaf-delete-dialog.html',
                    controller: 'DashboardbetweendatescafDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Dashboardbetweendatescaf', function(Dashboardbetweendatescaf) {
                            return Dashboardbetweendatescaf.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('dashboardbetweendatescaf', null, { reload: 'dashboardbetweendatescaf' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Dashboardbetweendatescaf', Dashboardbetweendatescaf);

    Dashboardbetweendatescaf.$inject = ['$resource', 'DateUtils'];

    function Dashboardbetweendatescaf ($resource, DateUtils) {
        var resourceUrl =  'api/dashboardbetweendatescafs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.statusDate = DateUtils.convertLocalDateFromServer(data.statusDate);
                        data.formFilledOn = DateUtils.convertLocalDateFromServer(data.formFilledOn);
                        data.appliedDate = DateUtils.convertLocalDateFromServer(data.appliedDate);
                        data.clearedDate = DateUtils.convertLocalDateFromServer(data.clearedDate);
                        data.rejectionDate = DateUtils.convertLocalDateFromServer(data.rejectionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.statusDate = DateUtils.convertLocalDateToServer(copy.statusDate);
                    copy.formFilledOn = DateUtils.convertLocalDateToServer(copy.formFilledOn);
                    copy.appliedDate = DateUtils.convertLocalDateToServer(copy.appliedDate);
                    copy.clearedDate = DateUtils.convertLocalDateToServer(copy.clearedDate);
                    copy.rejectionDate = DateUtils.convertLocalDateToServer(copy.rejectionDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.statusDate = DateUtils.convertLocalDateToServer(copy.statusDate);
                    copy.formFilledOn = DateUtils.convertLocalDateToServer(copy.formFilledOn);
                    copy.appliedDate = DateUtils.convertLocalDateToServer(copy.appliedDate);
                    copy.clearedDate = DateUtils.convertLocalDateToServer(copy.clearedDate);
                    copy.rejectionDate = DateUtils.convertLocalDateToServer(copy.rejectionDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DashboardbetweendatescafController', DashboardbetweendatescafController);

    DashboardbetweendatescafController.$inject = ['Dashboardbetweendatescaf'];

    function DashboardbetweendatescafController(Dashboardbetweendatescaf) {

        var vm = this;

        vm.dashboardbetweendatescafs = [];

        loadAll();

        function loadAll() {
            Dashboardbetweendatescaf.query(function(result) {
                vm.dashboardbetweendatescafs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CustomertypeDialogController', CustomertypeDialogController);

    CustomertypeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Customertype'];

    function CustomertypeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Customertype) {
        var vm = this;

        vm.customertype = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.customertype.id !== null) {
                Customertype.update(vm.customertype, onSaveSuccess, onSaveError);
            } else {
                Customertype.save(vm.customertype, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:customertypeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CustomertypeDetailController', CustomertypeDetailController);

    CustomertypeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Customertype'];

    function CustomertypeDetailController($scope, $rootScope, $stateParams, previousState, entity, Customertype) {
        var vm = this;

        vm.customertype = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:customertypeUpdate', function(event, result) {
            vm.customertype = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CustomertypeDeleteController',CustomertypeDeleteController);

    CustomertypeDeleteController.$inject = ['$uibModalInstance', 'entity', 'Customertype'];

    function CustomertypeDeleteController($uibModalInstance, entity, Customertype) {
        var vm = this;

        vm.customertype = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Customertype.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customertype', {
            parent: 'entity',
            url: '/customertype',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.customertype.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customertype/customertypes.html',
                    controller: 'CustomertypeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customertype');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('customertype-detail', {
            parent: 'customertype',
            url: '/customertype/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.customertype.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customertype/customertype-detail.html',
                    controller: 'CustomertypeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('customertype');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Customertype', function($stateParams, Customertype) {
                    return Customertype.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'customertype',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('customertype-detail.edit', {
            parent: 'customertype-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customertype/customertype-dialog.html',
                    controller: 'CustomertypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Customertype', function(Customertype) {
                            return Customertype.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customertype.new', {
            parent: 'customertype',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customertype/customertype-dialog.html',
                    controller: 'CustomertypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                customertype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('customertype', null, { reload: 'customertype' });
                }, function() {
                    $state.go('customertype');
                });
            }]
        })
        .state('customertype.edit', {
            parent: 'customertype',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customertype/customertype-dialog.html',
                    controller: 'CustomertypeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Customertype', function(Customertype) {
                            return Customertype.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customertype', null, { reload: 'customertype' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('customertype.delete', {
            parent: 'customertype',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/customertype/customertype-delete-dialog.html',
                    controller: 'CustomertypeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Customertype', function(Customertype) {
                            return Customertype.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('customertype', null, { reload: 'customertype' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Customertype', Customertype);

    Customertype.$inject = ['$resource'];

    function Customertype ($resource) {
        var resourceUrl =  'api/customertypes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CustomertypeController', CustomertypeController);

    CustomertypeController.$inject = ['Customertype'];

    function CustomertypeController(Customertype) {

        var vm = this;

        vm.customertypes = [];

        loadAll();

        function loadAll() {
            Customertype.query(function(result) {
                vm.customertypes = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CountryDialogController', CountryDialogController);

    CountryDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Country'];

    function CountryDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.country.id !== null) {
                Country.update(vm.country, onSaveSuccess, onSaveError);
            } else {
                Country.save(vm.country, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:countryUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CountryDetailController', CountryDetailController);

    CountryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Country'];

    function CountryDetailController($scope, $rootScope, $stateParams, previousState, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:countryUpdate', function(event, result) {
            vm.country = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CountryDeleteController',CountryDeleteController);

    CountryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Country'];

    function CountryDeleteController($uibModalInstance, entity, Country) {
        var vm = this;

        vm.country = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Country.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('country', {
            parent: 'entity',
            url: '/country',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.country.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/countries.html',
                    controller: 'CountryController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('country-detail', {
            parent: 'country',
            url: '/country/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.country.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/country/country-detail.html',
                    controller: 'CountryDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('country');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Country', function($stateParams, Country) {
                    return Country.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'country',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('country-detail.edit', {
            parent: 'country-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.new', {
            parent: 'country',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                countryname: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('country');
                });
            }]
        })
        .state('country.edit', {
            parent: 'country',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-dialog.html',
                    controller: 'CountryDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('country.delete', {
            parent: 'country',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/country/country-delete-dialog.html',
                    controller: 'CountryDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Country', function(Country) {
                            return Country.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('country', null, { reload: 'country' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Country', Country);

    Country.$inject = ['$resource'];

    function Country ($resource) {
        var resourceUrl =  'api/countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CountryController', CountryController);

    CountryController.$inject = ['Country'];

    function CountryController(Country) {

        var vm = this;

        vm.countries = [];

        loadAll();
        function loadAll() {
            Country.query(function(result) {
                vm.countries = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConstructionPermitLogDialogController', ConstructionPermitLogDialogController);

    ConstructionPermitLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ConstructionPermitLog'];

    function ConstructionPermitLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ConstructionPermitLog) {
        var vm = this;

        vm.constructionPermitLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.constructionPermitLog.id !== null) {
                ConstructionPermitLog.update(vm.constructionPermitLog, onSaveSuccess, onSaveError);
            } else {
                ConstructionPermitLog.save(vm.constructionPermitLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:constructionPermitLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.actiondate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConstructionPermitLogDetailController', ConstructionPermitLogDetailController);

    ConstructionPermitLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ConstructionPermitLog'];

    function ConstructionPermitLogDetailController($scope, $rootScope, $stateParams, previousState, entity, ConstructionPermitLog) {
        var vm = this;

        vm.constructionPermitLog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:constructionPermitLogUpdate', function(event, result) {
            vm.constructionPermitLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConstructionPermitLogDeleteController',ConstructionPermitLogDeleteController);

    ConstructionPermitLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'ConstructionPermitLog'];

    function ConstructionPermitLogDeleteController($uibModalInstance, entity, ConstructionPermitLog) {
        var vm = this;

        vm.constructionPermitLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ConstructionPermitLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('construction-permit-log', {
            parent: 'entity',
            url: '/construction-permit-log',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.constructionPermitLog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/construction-permit-log/construction-permit-logs.html',
                    controller: 'ConstructionPermitLogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('constructionPermitLog');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('construction-permit-log-detail', {
            parent: 'construction-permit-log',
            url: '/construction-permit-log/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.constructionPermitLog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/construction-permit-log/construction-permit-log-detail.html',
                    controller: 'ConstructionPermitLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('constructionPermitLog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ConstructionPermitLog', function($stateParams, ConstructionPermitLog) {
                    return ConstructionPermitLog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'construction-permit-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('construction-permit-log-detail.edit', {
            parent: 'construction-permit-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/construction-permit-log/construction-permit-log-dialog.html',
                    controller: 'ConstructionPermitLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConstructionPermitLog', function(ConstructionPermitLog) {
                            return ConstructionPermitLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('construction-permit-log.new', {
            parent: 'construction-permit-log',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/construction-permit-log/construction-permit-log-dialog.html',
                    controller: 'ConstructionPermitLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                actiondate: null,
                                action: null,
                                clearanceURL: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('construction-permit-log', null, { reload: 'construction-permit-log' });
                }, function() {
                    $state.go('construction-permit-log');
                });
            }]
        })
        .state('construction-permit-log.edit', {
            parent: 'construction-permit-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/construction-permit-log/construction-permit-log-dialog.html',
                    controller: 'ConstructionPermitLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConstructionPermitLog', function(ConstructionPermitLog) {
                            return ConstructionPermitLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('construction-permit-log', null, { reload: 'construction-permit-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('construction-permit-log.delete', {
            parent: 'construction-permit-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/construction-permit-log/construction-permit-log-delete-dialog.html',
                    controller: 'ConstructionPermitLogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ConstructionPermitLog', function(ConstructionPermitLog) {
                            return ConstructionPermitLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('construction-permit-log', null, { reload: 'construction-permit-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ConstructionPermitLog', ConstructionPermitLog);

    ConstructionPermitLog.$inject = ['$resource', 'DateUtils'];

    function ConstructionPermitLog ($resource, DateUtils) {
        var resourceUrl =  'api/construction-permit-logs/:id/:projectid';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.actiondate = DateUtils.convertLocalDateFromServer(data.actiondate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.actiondate = DateUtils.convertLocalDateToServer(copy.actiondate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.actiondate = DateUtils.convertLocalDateToServer(copy.actiondate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConstructionPermitLogController', ConstructionPermitLogController);

    ConstructionPermitLogController.$inject = ['ConstructionPermitLog'];

    function ConstructionPermitLogController(ConstructionPermitLog) {

        var vm = this;

        vm.constructionPermitLogs = [];

        loadAll();

        function loadAll() {
            ConstructionPermitLog.query(function(result) {
                vm.constructionPermitLogs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConstructionPermitApprovalStepsDialogController', ConstructionPermitApprovalStepsDialogController);

    ConstructionPermitApprovalStepsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ConstructionPermitApprovalSteps'];

    function ConstructionPermitApprovalStepsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ConstructionPermitApprovalSteps) {
        var vm = this;

        vm.constructionPermitApprovalSteps = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.constructionPermitApprovalSteps.id !== null) {
                ConstructionPermitApprovalSteps.update(vm.constructionPermitApprovalSteps, onSaveSuccess, onSaveError);
            } else {
                ConstructionPermitApprovalSteps.save(vm.constructionPermitApprovalSteps, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:constructionPermitApprovalStepsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConstructionPermitApprovalStepsDetailController', ConstructionPermitApprovalStepsDetailController);

    ConstructionPermitApprovalStepsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ConstructionPermitApprovalSteps'];

    function ConstructionPermitApprovalStepsDetailController($scope, $rootScope, $stateParams, previousState, entity, ConstructionPermitApprovalSteps) {
        var vm = this;

        vm.constructionPermitApprovalSteps = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:constructionPermitApprovalStepsUpdate', function(event, result) {
            vm.constructionPermitApprovalSteps = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConstructionPermitApprovalStepsDeleteController',ConstructionPermitApprovalStepsDeleteController);

    ConstructionPermitApprovalStepsDeleteController.$inject = ['$uibModalInstance', 'entity', 'ConstructionPermitApprovalSteps'];

    function ConstructionPermitApprovalStepsDeleteController($uibModalInstance, entity, ConstructionPermitApprovalSteps) {
        var vm = this;

        vm.constructionPermitApprovalSteps = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ConstructionPermitApprovalSteps.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('construction-permit-approval-steps', {
            parent: 'entity',
            url: '/construction-permit-approval-steps',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.constructionPermitApprovalSteps.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/construction-permit-approval-steps/construction-permit-approval-steps.html',
                    controller: 'ConstructionPermitApprovalStepsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('constructionPermitApprovalSteps');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('construction-permit-approval-steps-detail', {
            parent: 'construction-permit-approval-steps',
            url: '/construction-permit-approval-steps/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.constructionPermitApprovalSteps.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/construction-permit-approval-steps/construction-permit-approval-steps-detail.html',
                    controller: 'ConstructionPermitApprovalStepsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('constructionPermitApprovalSteps');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ConstructionPermitApprovalSteps', function($stateParams, ConstructionPermitApprovalSteps) {
                    return ConstructionPermitApprovalSteps.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'construction-permit-approval-steps',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('construction-permit-approval-steps-detail.edit', {
            parent: 'construction-permit-approval-steps-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/construction-permit-approval-steps/construction-permit-approval-steps-dialog.html',
                    controller: 'ConstructionPermitApprovalStepsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConstructionPermitApprovalSteps', function(ConstructionPermitApprovalSteps) {
                            return ConstructionPermitApprovalSteps.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('construction-permit-approval-steps.new', {
            parent: 'construction-permit-approval-steps',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/construction-permit-approval-steps/construction-permit-approval-steps-dialog.html',
                    controller: 'ConstructionPermitApprovalStepsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                bPflag: null,
                                aAIflag: null,
                                nMAflag: null,
                                fFSflag: null,
                                tWCflag: null,
                                tECflag: null,
                                projectId: null,
                                serviceId: null,
                                serviceIdEC: null,
                                pIflag: null,
                                oCflag: null,
                                isFileUploaded: null,
                                aAIid: null,
                                nMAid: null,
                                tECid: null,
                                fireNOCflag: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('construction-permit-approval-steps', null, { reload: 'construction-permit-approval-steps' });
                }, function() {
                    $state.go('construction-permit-approval-steps');
                });
            }]
        })
        .state('construction-permit-approval-steps.edit', {
            parent: 'construction-permit-approval-steps',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/construction-permit-approval-steps/construction-permit-approval-steps-dialog.html',
                    controller: 'ConstructionPermitApprovalStepsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ConstructionPermitApprovalSteps', function(ConstructionPermitApprovalSteps) {
                            return ConstructionPermitApprovalSteps.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('construction-permit-approval-steps', null, { reload: 'construction-permit-approval-steps' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('construction-permit-approval-steps.delete', {
            parent: 'construction-permit-approval-steps',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/construction-permit-approval-steps/construction-permit-approval-steps-delete-dialog.html',
                    controller: 'ConstructionPermitApprovalStepsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ConstructionPermitApprovalSteps', function(ConstructionPermitApprovalSteps) {
                            return ConstructionPermitApprovalSteps.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('construction-permit-approval-steps', null, { reload: 'construction-permit-approval-steps' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ConstructionPermitApprovalSteps', ConstructionPermitApprovalSteps);

    ConstructionPermitApprovalSteps.$inject = ['$resource'];

    function ConstructionPermitApprovalSteps ($resource) {
        var resourceUrl =  'api/construction-permit-approval-steps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConstructionPermitApprovalStepsController', ConstructionPermitApprovalStepsController);

    ConstructionPermitApprovalStepsController.$inject = ['ConstructionPermitApprovalSteps'];

    function ConstructionPermitApprovalStepsController(ConstructionPermitApprovalSteps) {

        var vm = this;

        vm.constructionPermitApprovalSteps = [];

        loadAll();

        function loadAll() {
            ConstructionPermitApprovalSteps.query(function(result) {
                vm.constructionPermitApprovalSteps = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ConstructionPermitApproval', ConstructionPermitApproval);

    ConstructionPermitApproval.$inject = ['$resource'];

    function ConstructionPermitApproval ($resource) {
        var resourceUrl =  'api/construction-permit-approval/:projectId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConnectingroadDialogController', ConnectingroadDialogController);

    ConnectingroadDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Connectingroad'];

    function ConnectingroadDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Connectingroad) {
        var vm = this;

        vm.connectingroad = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.connectingroad.id !== null) {
                Connectingroad.update(vm.connectingroad, onSaveSuccess, onSaveError);
            } else {
                Connectingroad.save(vm.connectingroad, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:connectingroadUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConnectingroadDetailController', ConnectingroadDetailController);

    ConnectingroadDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Connectingroad'];

    function ConnectingroadDetailController($scope, $rootScope, $stateParams, previousState, entity, Connectingroad) {
        var vm = this;

        vm.connectingroad = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:connectingroadUpdate', function(event, result) {
            vm.connectingroad = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConnectingroadDeleteController',ConnectingroadDeleteController);

    ConnectingroadDeleteController.$inject = ['$uibModalInstance', 'entity', 'Connectingroad'];

    function ConnectingroadDeleteController($uibModalInstance, entity, Connectingroad) {
        var vm = this;

        vm.connectingroad = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Connectingroad.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('connectingroad', {
            parent: 'entity',
            url: '/connectingroad',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.connectingroad.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/connectingroad/connectingroads.html',
                    controller: 'ConnectingroadController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('connectingroad');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('connectingroad-detail', {
            parent: 'connectingroad',
            url: '/connectingroad/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.connectingroad.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/connectingroad/connectingroad-detail.html',
                    controller: 'ConnectingroadDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('connectingroad');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Connectingroad', function($stateParams, Connectingroad) {
                    return Connectingroad.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'connectingroad',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('connectingroad-detail.edit', {
            parent: 'connectingroad-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/connectingroad/connectingroad-dialog.html',
                    controller: 'ConnectingroadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Connectingroad', function(Connectingroad) {
                            return Connectingroad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('connectingroad.new', {
            parent: 'connectingroad',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/connectingroad/connectingroad-dialog.html',
                    controller: 'ConnectingroadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                connectingraodtype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('connectingroad', null, { reload: 'connectingroad' });
                }, function() {
                    $state.go('connectingroad');
                });
            }]
        })
        .state('connectingroad.edit', {
            parent: 'connectingroad',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/connectingroad/connectingroad-dialog.html',
                    controller: 'ConnectingroadDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Connectingroad', function(Connectingroad) {
                            return Connectingroad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('connectingroad', null, { reload: 'connectingroad' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('connectingroad.delete', {
            parent: 'connectingroad',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/connectingroad/connectingroad-delete-dialog.html',
                    controller: 'ConnectingroadDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Connectingroad', function(Connectingroad) {
                            return Connectingroad.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('connectingroad', null, { reload: 'connectingroad' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Connectingroad', Connectingroad);

    Connectingroad.$inject = ['$resource'];

    function Connectingroad ($resource) {
        var resourceUrl =  'api/connectingroads/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConnectingroadController', ConnectingroadController);

    ConnectingroadController.$inject = ['Connectingroad'];

    function ConnectingroadController(Connectingroad) {

        var vm = this;

        vm.connectingroads = [];

        loadAll();

        function loadAll() {
            Connectingroad.query(function(result) {
                vm.connectingroads = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CompanydetailDialogController', CompanydetailDialogController);

    CompanydetailDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Companydetail'];

    function CompanydetailDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Companydetail) {
        var vm = this;

        vm.companydetail = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.companydetail.id !== null) {
                Companydetail.update(vm.companydetail, onSaveSuccess, onSaveError);
            } else {
                Companydetail.save(vm.companydetail, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:companydetailUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createdate = false;
        vm.datePickerOpenStatus.updatedate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CompanydetailDetailController', CompanydetailDetailController);

    CompanydetailDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Companydetail'];

    function CompanydetailDetailController($scope, $rootScope, $stateParams, previousState, entity, Companydetail) {
        var vm = this;

        vm.companydetail = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:companydetailUpdate', function(event, result) {
            vm.companydetail = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CompanydetailDeleteController',CompanydetailDeleteController);

    CompanydetailDeleteController.$inject = ['$uibModalInstance', 'entity', 'Companydetail'];

    function CompanydetailDeleteController($uibModalInstance, entity, Companydetail) {
        var vm = this;

        vm.companydetail = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Companydetail.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('companydetail', {
            parent: 'entity',
            url: '/companydetail',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.companydetail.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/companydetail/companydetails.html',
                    controller: 'CompanydetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('companydetail');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('companydetail-detail', {
            parent: 'companydetail',
            url: '/companydetail/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.companydetail.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/companydetail/companydetail-detail.html',
                    controller: 'CompanydetailDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('companydetail');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Companydetail', function($stateParams, Companydetail) {
                    return Companydetail.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'companydetail',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('companydetail-detail.edit', {
            parent: 'companydetail-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/companydetail/companydetail-dialog.html',
                    controller: 'CompanydetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Companydetail', function(Companydetail) {
                            return Companydetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('companydetail.new', {
            parent: 'companydetail',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/companydetail/companydetail-dialog.html',
                    controller: 'CompanydetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                promoter_md_director: null,
                                designation: null,
                                businessentity: null,
                                director_promoter_md_ceo_number: null,
                                pan_number: null,
                                aadhar_number: null,
                                nri: null,
                                tin_vat_number: null,
                                cst_number: null,
                                businessentitytype: null,
                                createdate: null,
                                updatedate: null,
                                gstnumber: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('companydetail', null, { reload: 'companydetail' });
                }, function() {
                    $state.go('companydetail');
                });
            }]
        })
        .state('companydetail.edit', {
            parent: 'companydetail',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/companydetail/companydetail-dialog.html',
                    controller: 'CompanydetailDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Companydetail', function(Companydetail) {
                            return Companydetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('companydetail', null, { reload: 'companydetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('companydetail.delete', {
            parent: 'companydetail',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/companydetail/companydetail-delete-dialog.html',
                    controller: 'CompanydetailDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Companydetail', function(Companydetail) {
                            return Companydetail.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('companydetail', null, { reload: 'companydetail' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Companydetail', Companydetail);

    Companydetail.$inject = ['$resource', 'DateUtils'];

    function Companydetail ($resource, DateUtils) {
        var resourceUrl =  'api/companydetails/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdate = DateUtils.convertDateTimeFromServer(data.createdate);
                        data.updatedate = DateUtils.convertDateTimeFromServer(data.updatedate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CompanydetailController', CompanydetailController);

    CompanydetailController.$inject = ['Companydetail'];

    function CompanydetailController(Companydetail) {

        var vm = this;

        vm.companydetails = [];

        loadAll();

        function loadAll() {
            Companydetail.query(function(result) {
                vm.companydetails = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ClearedServicesDialogController', ClearedServicesDialogController);

    ClearedServicesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ClearedServices'];

    function ClearedServicesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ClearedServices) {
        var vm = this;

        vm.clearedServices = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.clearedServices.id !== null) {
                ClearedServices.update(vm.clearedServices, onSaveSuccess, onSaveError);
            } else {
                ClearedServices.save(vm.clearedServices, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:clearedServicesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.clearedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ClearedServicesDetailController', ClearedServicesDetailController);

    ClearedServicesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ClearedServices'];

    function ClearedServicesDetailController($scope, $rootScope, $stateParams, previousState, entity, ClearedServices) {
        var vm = this;

        vm.clearedServices = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:clearedServicesUpdate', function(event, result) {
            vm.clearedServices = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ClearedServicesDeleteController',ClearedServicesDeleteController);

    ClearedServicesDeleteController.$inject = ['$uibModalInstance', 'entity', 'ClearedServices'];

    function ClearedServicesDeleteController($uibModalInstance, entity, ClearedServices) {
        var vm = this;

        vm.clearedServices = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ClearedServices.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cleared-services', {
            parent: 'entity',
            url: '/cleared-services',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.clearedServices.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cleared-services/cleared-services.html',
                    controller: 'ClearedServicesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clearedServices');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cleared-services-detail', {
            parent: 'cleared-services',
            url: '/cleared-services/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.clearedServices.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cleared-services/cleared-services-detail.html',
                    controller: 'ClearedServicesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('clearedServices');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ClearedServices', function($stateParams, ClearedServices) {
                    return ClearedServices.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cleared-services',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cleared-services-detail.edit', {
            parent: 'cleared-services-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cleared-services/cleared-services-dialog.html',
                    controller: 'ClearedServicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClearedServices', function(ClearedServices) {
                            return ClearedServices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cleared-services.new', {
            parent: 'cleared-services',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cleared-services/cleared-services-dialog.html',
                    controller: 'ClearedServicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                clearedDate: null,
                                serviceId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cleared-services', null, { reload: 'cleared-services' });
                }, function() {
                    $state.go('cleared-services');
                });
            }]
        })
        .state('cleared-services.edit', {
            parent: 'cleared-services',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cleared-services/cleared-services-dialog.html',
                    controller: 'ClearedServicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ClearedServices', function(ClearedServices) {
                            return ClearedServices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cleared-services', null, { reload: 'cleared-services' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cleared-services.delete', {
            parent: 'cleared-services',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cleared-services/cleared-services-delete-dialog.html',
                    controller: 'ClearedServicesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ClearedServices', function(ClearedServices) {
                            return ClearedServices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cleared-services', null, { reload: 'cleared-services' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ClearedServices', ClearedServices);

    ClearedServices.$inject = ['$resource', 'DateUtils'];

    function ClearedServices ($resource, DateUtils) {
        var resourceUrl =  'api/cleared-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.clearedDate = DateUtils.convertLocalDateFromServer(data.clearedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.clearedDate = DateUtils.convertLocalDateToServer(copy.clearedDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.clearedDate = DateUtils.convertLocalDateToServer(copy.clearedDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ClearedServicesController', ClearedServicesController);

    ClearedServicesController.$inject = ['ClearedServices'];

    function ClearedServicesController(ClearedServices) {

        var vm = this;

        vm.clearedServices = [];

        loadAll();

        function loadAll() {
            ClearedServices.query(function(result) {
                vm.clearedServices = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('City_town_villageDialogController', City_town_villageDialogController);

    City_town_villageDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'City_town_village'];

    function City_town_villageDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, City_town_village) {
        var vm = this;

        vm.city_town_village = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.city_town_village.id !== null) {
                City_town_village.update(vm.city_town_village, onSaveSuccess, onSaveError);
            } else {
                City_town_village.save(vm.city_town_village, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:city_town_villageUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('City_town_villageDetailController', City_town_villageDetailController);

    City_town_villageDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'City_town_village'];

    function City_town_villageDetailController($scope, $rootScope, $stateParams, previousState, entity, City_town_village) {
        var vm = this;

        vm.city_town_village = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:city_town_villageUpdate', function(event, result) {
            vm.city_town_village = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('City_town_villageDeleteController',City_town_villageDeleteController);

    City_town_villageDeleteController.$inject = ['$uibModalInstance', 'entity', 'City_town_village'];

    function City_town_villageDeleteController($uibModalInstance, entity, City_town_village) {
        var vm = this;

        vm.city_town_village = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            City_town_village.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('city-town-village', {
            parent: 'entity',
            url: '/city-town-village',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.city_town_village.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/city-town-village/city-town-villages.html',
                    controller: 'City_town_villageController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('city_town_village');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('city-town-village-detail', {
            parent: 'city-town-village',
            url: '/city-town-village/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.city_town_village.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/city-town-village/city-town-village-detail.html',
                    controller: 'City_town_villageDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('city_town_village');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'City_town_village', function($stateParams, City_town_village) {
                    return City_town_village.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'city-town-village',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('city-town-village-detail.edit', {
            parent: 'city-town-village-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city-town-village/city-town-village-dialog.html',
                    controller: 'City_town_villageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['City_town_village', function(City_town_village) {
                            return City_town_village.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('city-town-village.new', {
            parent: 'city-town-village',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city-town-village/city-town-village-dialog.html',
                    controller: 'City_town_villageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                city_town_village_name: null,
                                blockname: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('city-town-village', null, { reload: 'city-town-village' });
                }, function() {
                    $state.go('city-town-village');
                });
            }]
        })
        .state('city-town-village.edit', {
            parent: 'city-town-village',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city-town-village/city-town-village-dialog.html',
                    controller: 'City_town_villageDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['City_town_village', function(City_town_village) {
                            return City_town_village.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('city-town-village', null, { reload: 'city-town-village' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('city-town-village.delete', {
            parent: 'city-town-village',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/city-town-village/city-town-village-delete-dialog.html',
                    controller: 'City_town_villageDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['City_town_village', function(City_town_village) {
                            return City_town_village.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('city-town-village', null, { reload: 'city-town-village' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('City_town_village', City_town_village);

    City_town_village.$inject = ['$resource'];

    function City_town_village ($resource) {
        var resourceUrl =  'api/city-town-villages/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('City_town_villageController', City_town_villageController);

    City_town_villageController.$inject = ['City_town_village'];

    function City_town_villageController(City_town_village) {

        var vm = this;

        vm.city_town_villages = [];

        loadAll();

        function loadAll() {
            City_town_village.query(function(result) {
                vm.city_town_villages = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ChecklistDialogController', ChecklistDialogController);

    ChecklistDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Checklist', 'DepartmentService', 'FileManagement', 'Department', 'filterFilter'];

    function ChecklistDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Checklist, DepartmentService, FileManagement, Department, filterFilter) {
        var vm = this;

        vm.checklist = entity;
        vm.clear = clear;
        vm.save = save;
        vm.UploadAttachment = UploadAttachment;
        $scope.file = {};

        loadAll();

        function loadAll(){
            Department.query(function (result) {
                vm.departments = result;
            });
        }

        $scope.serviceByDepartment = function(){
            DepartmentService.query(function (result) {
                vm.departmentServices = filterFilter(result, {departmentid: vm.departmentId});
            })
        };

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.checklist.id !== null) {
                Checklist.update(vm.checklist, onSaveSuccess, onSaveError);
            } else {
                Checklist.save(vm.checklist, onSaveSuccess, onSaveError);
            }
        }


        function UploadAttachment()
        {
            var serverFileName = vm.checklist.id + '_a';
            var file= vm.serviceAttachemnt;

            var fileNameArray = file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension = fileNameArray[(fileNameArray.length-1)];
            }

            if(fileextension!=="" && fileextension === 'pdf')
            {
                FileManagement.saveFile(file,serverFileName,onFileSaveSuccess());
                serverFileName = serverFileName+"."+fileextension;
                vm.checklist.serverFileName = serverFileName;
                vm.checklist.clientFileName = file.name;
            }
            else {
                alert('only pdf are allowed');
            }
        }

        function onFileSaveSuccess() {
            save();
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:checklistUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ChecklistDetailController', ChecklistDetailController);

    ChecklistDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Checklist'];

    function ChecklistDetailController($scope, $rootScope, $stateParams, previousState, entity, Checklist) {
        var vm = this;

        vm.checklist = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:checklistUpdate', function(event, result) {
            vm.checklist = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ChecklistDeleteController',ChecklistDeleteController);

    ChecklistDeleteController.$inject = ['$uibModalInstance', 'entity', 'Checklist'];

    function ChecklistDeleteController($uibModalInstance, entity, Checklist) {
        var vm = this;

        vm.checklist = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Checklist.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('checklist', {
            parent: 'entity',
            url: '/checklist',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.checklist.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/checklist/checklists.html',
                    controller: 'ChecklistController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('checklist');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('checklist-detail', {
            parent: 'checklist',
            url: '/checklist/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.checklist.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/checklist/checklist-detail.html',
                    controller: 'ChecklistDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('checklist');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Checklist', function($stateParams, Checklist) {
                    return Checklist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'checklist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('checklist-detail.edit', {
            parent: 'checklist-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/checklist/checklist-dialog.html',
                    controller: 'ChecklistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Checklist', function(Checklist) {
                            return Checklist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('checklist.new', {
            parent: 'checklist',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/checklist/checklist-dialog.html',
                    controller: 'ChecklistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        entity: function () {
                            return {
                                serverFileName: null,
                                clientFileName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('checklist', null, { reload: 'checklist' });
                }, function() {
                    $state.go('checklist');
                });
            }]
        })
        .state('checklist.edit', {
            parent: 'checklist',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/checklist/checklist-dialog.html',
                    controller: 'ChecklistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Checklist', function(Checklist) {
                            return Checklist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('checklist', null, { reload: 'checklist' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('checklist.delete', {
            parent: 'checklist',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/checklist/checklist-delete-dialog.html',
                    controller: 'ChecklistDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Checklist', function(Checklist) {
                            return Checklist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('checklist', null, { reload: 'checklist' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Checklist', Checklist);

    Checklist.$inject = ['$resource'];

    function Checklist ($resource) {
        var resourceUrl =  'api/checklists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ChecklistController', ChecklistController);

    ChecklistController.$inject = ['Checklist'];

    function ChecklistController(Checklist) {

        var vm = this;

        vm.checklists = [];

        loadAll();

        function loadAll() {
            Checklist.query(function(result) {
                vm.checklists = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CenterTowerUserDataDialogController', CenterTowerUserDataDialogController);

    CenterTowerUserDataDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CenterTowerUserData'];

    function CenterTowerUserDataDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CenterTowerUserData) {
        var vm = this;

        vm.centerTowerUserData = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.centerTowerUserData.id !== null) {
                CenterTowerUserData.update(vm.centerTowerUserData, onSaveSuccess, onSaveError);
            } else {
                CenterTowerUserData.save(vm.centerTowerUserData, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:centerTowerUserDataUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.licenseExpiryDate = false;
        vm.datePickerOpenStatus.createdDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CenterTowerUserDataDetailController', CenterTowerUserDataDetailController);

    CenterTowerUserDataDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CenterTowerUserData'];

    function CenterTowerUserDataDetailController($scope, $rootScope, $stateParams, previousState, entity, CenterTowerUserData) {
        var vm = this;

        vm.centerTowerUserData = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:centerTowerUserDataUpdate', function(event, result) {
            vm.centerTowerUserData = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CenterTowerUserDataDeleteController',CenterTowerUserDataDeleteController);

    CenterTowerUserDataDeleteController.$inject = ['$uibModalInstance', 'entity', 'CenterTowerUserData'];

    function CenterTowerUserDataDeleteController($uibModalInstance, entity, CenterTowerUserData) {
        var vm = this;

        vm.centerTowerUserData = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CenterTowerUserData.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('center-tower-user-data', {
            parent: 'entity',
            url: '/center-tower-user-data',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.centerTowerUserData.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/center-tower-user-data/center-tower-user-data.html',
                    controller: 'CenterTowerUserDataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('centerTowerUserData');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('center-tower-user-data-detail', {
            parent: 'center-tower-user-data',
            url: '/center-tower-user-data/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.centerTowerUserData.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/center-tower-user-data/center-tower-user-data-detail.html',
                    controller: 'CenterTowerUserDataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('centerTowerUserData');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CenterTowerUserData', function($stateParams, CenterTowerUserData) {
                    return CenterTowerUserData.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'center-tower-user-data',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('center-tower-user-data-detail.edit', {
            parent: 'center-tower-user-data-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/center-tower-user-data/center-tower-user-data-dialog.html',
                    controller: 'CenterTowerUserDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CenterTowerUserData', function(CenterTowerUserData) {
                            return CenterTowerUserData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('center-tower-user-data.new', {
            parent: 'center-tower-user-data',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/center-tower-user-data/center-tower-user-data-dialog.html',
                    controller: 'CenterTowerUserDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                stateCode: null,
                                userId: null,
                                requestId: null,
                                applicationType: null,
                                applicationName: null,
                                email: null,
                                mobileNumber: null,
                                username: null,
                                districtCode: null,
                                applicantAddress: null,
                                organisationType: null,
                                organisationName: null,
                                licenseNumber: null,
                                licenseExpiryDate: null,
                                licenseCertificationPath: null,
                                authorizationLetterPath: null,
                                isView: null,
                                applicationNumber: null,
                                zipCode: null,
                                createdDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('center-tower-user-data', null, { reload: 'center-tower-user-data' });
                }, function() {
                    $state.go('center-tower-user-data');
                });
            }]
        })
        .state('center-tower-user-data.edit', {
            parent: 'center-tower-user-data',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/center-tower-user-data/center-tower-user-data-dialog.html',
                    controller: 'CenterTowerUserDataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CenterTowerUserData', function(CenterTowerUserData) {
                            return CenterTowerUserData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('center-tower-user-data', null, { reload: 'center-tower-user-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('center-tower-user-data.delete', {
            parent: 'center-tower-user-data',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/center-tower-user-data/center-tower-user-data-delete-dialog.html',
                    controller: 'CenterTowerUserDataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CenterTowerUserData', function(CenterTowerUserData) {
                            return CenterTowerUserData.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('center-tower-user-data', null, { reload: 'center-tower-user-data' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('CenterTowerUserData', CenterTowerUserData);

    CenterTowerUserData.$inject = ['$resource', 'DateUtils'];

    function CenterTowerUserData ($resource, DateUtils) {
        var resourceUrl =  'api/center-tower-user-data/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.licenseExpiryDate = DateUtils.convertLocalDateFromServer(data.licenseExpiryDate);
                        data.createdDate = DateUtils.convertLocalDateFromServer(data.createdDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.licenseExpiryDate = DateUtils.convertLocalDateToServer(copy.licenseExpiryDate);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.licenseExpiryDate = DateUtils.convertLocalDateToServer(copy.licenseExpiryDate);
                    copy.createdDate = DateUtils.convertLocalDateToServer(copy.createdDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CenterTowerUserDataController', CenterTowerUserDataController);

    CenterTowerUserDataController.$inject = ['CenterTowerUserData'];

    function CenterTowerUserDataController(CenterTowerUserData) {

        var vm = this;

        vm.centerTowerUserData = [];

        loadAll();

        function loadAll() {
            CenterTowerUserData.query(function(result) {
                vm.centerTowerUserData = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafsscheduledfordeactivationDialogController', CafsscheduledfordeactivationDialogController);

    CafsscheduledfordeactivationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Cafsscheduledfordeactivation'];

    function CafsscheduledfordeactivationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Cafsscheduledfordeactivation) {
        var vm = this;

        vm.cafsscheduledfordeactivation = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cafsscheduledfordeactivation.id !== null) {
                Cafsscheduledfordeactivation.update(vm.cafsscheduledfordeactivation, onSaveSuccess, onSaveError);
            } else {
                Cafsscheduledfordeactivation.save(vm.cafsscheduledfordeactivation, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:cafsscheduledfordeactivationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.scheduledDeactivationDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafsscheduledfordeactivationDetailController', CafsscheduledfordeactivationDetailController);

    CafsscheduledfordeactivationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Cafsscheduledfordeactivation'];

    function CafsscheduledfordeactivationDetailController($scope, $rootScope, $stateParams, previousState, entity, Cafsscheduledfordeactivation) {
        var vm = this;

        vm.cafsscheduledfordeactivation = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:cafsscheduledfordeactivationUpdate', function(event, result) {
            vm.cafsscheduledfordeactivation = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafsscheduledfordeactivationDeleteController',CafsscheduledfordeactivationDeleteController);

    CafsscheduledfordeactivationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Cafsscheduledfordeactivation'];

    function CafsscheduledfordeactivationDeleteController($uibModalInstance, entity, Cafsscheduledfordeactivation) {
        var vm = this;

        vm.cafsscheduledfordeactivation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Cafsscheduledfordeactivation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cafsscheduledfordeactivation', {
            parent: 'entity',
            url: '/cafsscheduledfordeactivation',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.cafsscheduledfordeactivation.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cafsscheduledfordeactivation/cafsscheduledfordeactivations.html',
                    controller: 'CafsscheduledfordeactivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cafsscheduledfordeactivation');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cafsscheduledfordeactivation-detail', {
            parent: 'cafsscheduledfordeactivation',
            url: '/cafsscheduledfordeactivation/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.cafsscheduledfordeactivation.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cafsscheduledfordeactivation/cafsscheduledfordeactivation-detail.html',
                    controller: 'CafsscheduledfordeactivationDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cafsscheduledfordeactivation');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Cafsscheduledfordeactivation', function($stateParams, Cafsscheduledfordeactivation) {
                    return Cafsscheduledfordeactivation.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cafsscheduledfordeactivation',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cafsscheduledfordeactivation-detail.edit', {
            parent: 'cafsscheduledfordeactivation-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cafsscheduledfordeactivation/cafsscheduledfordeactivation-dialog.html',
                    controller: 'CafsscheduledfordeactivationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cafsscheduledfordeactivation', function(Cafsscheduledfordeactivation) {
                            return Cafsscheduledfordeactivation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cafsscheduledfordeactivation.new', {
            parent: 'cafsscheduledfordeactivation',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cafsscheduledfordeactivation/cafsscheduledfordeactivation-dialog.html',
                    controller: 'CafsscheduledfordeactivationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                scheduledDeactivationDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cafsscheduledfordeactivation', null, { reload: 'cafsscheduledfordeactivation' });
                }, function() {
                    $state.go('cafsscheduledfordeactivation');
                });
            }]
        })
        .state('cafsscheduledfordeactivation.edit', {
            parent: 'cafsscheduledfordeactivation',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cafsscheduledfordeactivation/cafsscheduledfordeactivation-dialog.html',
                    controller: 'CafsscheduledfordeactivationDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cafsscheduledfordeactivation', function(Cafsscheduledfordeactivation) {
                            return Cafsscheduledfordeactivation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cafsscheduledfordeactivation', null, { reload: 'cafsscheduledfordeactivation' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cafsscheduledfordeactivation.delete', {
            parent: 'cafsscheduledfordeactivation',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cafsscheduledfordeactivation/cafsscheduledfordeactivation-delete-dialog.html',
                    controller: 'CafsscheduledfordeactivationDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Cafsscheduledfordeactivation', function(Cafsscheduledfordeactivation) {
                            return Cafsscheduledfordeactivation.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cafsscheduledfordeactivation', null, { reload: 'cafsscheduledfordeactivation' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Cafsscheduledfordeactivation', Cafsscheduledfordeactivation);

    Cafsscheduledfordeactivation.$inject = ['$resource', 'DateUtils'];

    function Cafsscheduledfordeactivation ($resource, DateUtils) {
        var resourceUrl =  'api/cafsscheduledfordeactivations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.scheduledDeactivationDate = DateUtils.convertLocalDateFromServer(data.scheduledDeactivationDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.scheduledDeactivationDate = DateUtils.convertLocalDateToServer(copy.scheduledDeactivationDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.scheduledDeactivationDate = DateUtils.convertLocalDateToServer(copy.scheduledDeactivationDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafsscheduledfordeactivationController', CafsscheduledfordeactivationController);

    CafsscheduledfordeactivationController.$inject = ['Cafsscheduledfordeactivation'];

    function CafsscheduledfordeactivationController(Cafsscheduledfordeactivation) {

        var vm = this;

        vm.cafsscheduledfordeactivations = [];

        loadAll();

        function loadAll() {
            Cafsscheduledfordeactivation.query(function(result) {
                vm.cafsscheduledfordeactivations = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Cafsfornodalofficerbyprojectid', Cafsfornodalofficerbyprojectid);

    Cafsfornodalofficerbyprojectid.$inject = ['$resource', 'DateUtils'];

    function Cafsfornodalofficerbyprojectid ($resource, DateUtils) {
        var resourceUrl =  'api/cafsfornodalofficersbyprojectid/projectId';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.applicationDate = DateUtils.convertLocalDateFromServer(data.applicationDate);
                        data.lastActionDate = DateUtils.convertLocalDateFromServer(data.lastActionDate);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafsfornodalofficerDialogController', CafsfornodalofficerDialogController);

    CafsfornodalofficerDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Cafsfornodalofficer'];

    function CafsfornodalofficerDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Cafsfornodalofficer) {
        var vm = this;

        vm.cafsfornodalofficer = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cafsfornodalofficer.id !== null) {
                Cafsfornodalofficer.update(vm.cafsfornodalofficer, onSaveSuccess, onSaveError);
            } else {
                Cafsfornodalofficer.save(vm.cafsfornodalofficer, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:cafsfornodalofficerUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.applicationDate = false;
        vm.datePickerOpenStatus.lastActionDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafsfornodalofficerDetailController', CafsfornodalofficerDetailController);

    CafsfornodalofficerDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Cafsfornodalofficer'];

    function CafsfornodalofficerDetailController($scope, $rootScope, $stateParams, previousState, entity, Cafsfornodalofficer) {
        var vm = this;

        vm.cafsfornodalofficer = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:cafsfornodalofficerUpdate', function(event, result) {
            vm.cafsfornodalofficer = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafsfornodalofficerDeleteController',CafsfornodalofficerDeleteController);

    CafsfornodalofficerDeleteController.$inject = ['$uibModalInstance', 'entity', 'Cafsfornodalofficer'];

    function CafsfornodalofficerDeleteController($uibModalInstance, entity, Cafsfornodalofficer) {
        var vm = this;

        vm.cafsfornodalofficer = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Cafsfornodalofficer.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cafsfornodalofficer', {
            parent: 'entity',
            url: '/cafsfornodalofficer',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.cafsfornodalofficer.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cafsfornodalofficer/cafsfornodalofficers.html',
                    controller: 'CafsfornodalofficerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cafsfornodalofficer');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cafsfornodalofficer-detail', {
            parent: 'cafsfornodalofficer',
            url: '/cafsfornodalofficer/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.cafsfornodalofficer.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cafsfornodalofficer/cafsfornodalofficer-detail.html',
                    controller: 'CafsfornodalofficerDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cafsfornodalofficer');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Cafsfornodalofficer', function($stateParams, Cafsfornodalofficer) {
                    return Cafsfornodalofficer.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'cafsfornodalofficer',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('cafsfornodalofficer-detail.edit', {
            parent: 'cafsfornodalofficer-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cafsfornodalofficer/cafsfornodalofficer-dialog.html',
                    controller: 'CafsfornodalofficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cafsfornodalofficer', function(Cafsfornodalofficer) {
                            return Cafsfornodalofficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cafsfornodalofficer.new', {
            parent: 'cafsfornodalofficer',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cafsfornodalofficer/cafsfornodalofficer-dialog.html',
                    controller: 'CafsfornodalofficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                serviceName: null,
                                cafpin: null,
                                rmInfo: null,
                                totalProjectCost: null,
                                proposedEmployment: null,
                                district: null,
                                projectLevel: null,
                                applicationDate: null,
                                lastActionDate: null,
                                lastActionComment: null,
                                departmentName: null,
                                status: null,
                                businessEntity: null,
                                projectId: null,
                                formfillstatus: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cafsfornodalofficer', null, { reload: 'cafsfornodalofficer' });
                }, function() {
                    $state.go('cafsfornodalofficer');
                });
            }]
        })
        .state('cafsfornodalofficer.edit', {
            parent: 'cafsfornodalofficer',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cafsfornodalofficer/cafsfornodalofficer-dialog.html',
                    controller: 'CafsfornodalofficerDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cafsfornodalofficer', function(Cafsfornodalofficer) {
                            return Cafsfornodalofficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cafsfornodalofficer', null, { reload: 'cafsfornodalofficer' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('cafsfornodalofficer.delete', {
            parent: 'cafsfornodalofficer',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cafsfornodalofficer/cafsfornodalofficer-delete-dialog.html',
                    controller: 'CafsfornodalofficerDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Cafsfornodalofficer', function(Cafsfornodalofficer) {
                            return Cafsfornodalofficer.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cafsfornodalofficer', null, { reload: 'cafsfornodalofficer' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Cafsfornodalofficer', Cafsfornodalofficer);

    Cafsfornodalofficer.$inject = ['$resource', 'DateUtils'];

    function Cafsfornodalofficer ($resource, DateUtils) {
        var resourceUrl =  'api/cafsfornodalofficers/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.applicationDate = DateUtils.convertLocalDateFromServer(data.applicationDate);
                        data.lastActionDate = DateUtils.convertLocalDateFromServer(data.lastActionDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.applicationDate = DateUtils.convertLocalDateToServer(copy.applicationDate);
                    copy.lastActionDate = DateUtils.convertLocalDateToServer(copy.lastActionDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.applicationDate = DateUtils.convertLocalDateToServer(copy.applicationDate);
                    copy.lastActionDate = DateUtils.convertLocalDateToServer(copy.lastActionDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafsfornodalofficerController', CafsfornodalofficerController);

    CafsfornodalofficerController.$inject = ['Cafsfornodalofficer'];

    function CafsfornodalofficerController(Cafsfornodalofficer) {

        var vm = this;

        vm.cafsfornodalofficers = [];

        loadAll();

        function loadAll() {
            Cafsfornodalofficer.query(function(result) {
                vm.cafsfornodalofficers = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafWithNoServiceDialogController', CafWithNoServiceDialogController);

    CafWithNoServiceDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CafWithNoService'];

    function CafWithNoServiceDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CafWithNoService) {
        var vm = this;

        vm.cafWithNoService = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cafWithNoService.id !== null) {
                CafWithNoService.update(vm.cafWithNoService, onSaveSuccess, onSaveError);
            } else {
                CafWithNoService.save(vm.cafWithNoService, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:cafWithNoServiceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.applicationdate = false;
        vm.datePickerOpenStatus.createddate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafWithNoServiceDetailController', CafWithNoServiceDetailController);

    CafWithNoServiceDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CafWithNoService'];

    function CafWithNoServiceDetailController($scope, $rootScope, $stateParams, previousState, entity, CafWithNoService) {
        var vm = this;

        vm.cafWithNoService = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:cafWithNoServiceUpdate', function(event, result) {
            vm.cafWithNoService = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafWithNoServiceDeleteController',CafWithNoServiceDeleteController);

    CafWithNoServiceDeleteController.$inject = ['$uibModalInstance', 'entity', 'CafWithNoService'];

    function CafWithNoServiceDeleteController($uibModalInstance, entity, CafWithNoService) {
        var vm = this;

        vm.cafWithNoService = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CafWithNoService.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('caf-with-no-service', {
            parent: 'entity',
            url: '/caf-with-no-service',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.cafWithNoService.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/caf-with-no-service/caf-with-no-services.html',
                    controller: 'CafWithNoServiceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cafWithNoService');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('caf-with-no-service-detail', {
            parent: 'caf-with-no-service',
            url: '/caf-with-no-service/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.cafWithNoService.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/caf-with-no-service/caf-with-no-service-detail.html',
                    controller: 'CafWithNoServiceDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cafWithNoService');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CafWithNoService', function($stateParams, CafWithNoService) {
                    return CafWithNoService.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'caf-with-no-service',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('caf-with-no-service-detail.edit', {
            parent: 'caf-with-no-service-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caf-with-no-service/caf-with-no-service-dialog.html',
                    controller: 'CafWithNoServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CafWithNoService', function(CafWithNoService) {
                            return CafWithNoService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('caf-with-no-service.new', {
            parent: 'caf-with-no-service',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caf-with-no-service/caf-with-no-service-dialog.html',
                    controller: 'CafWithNoServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                address: null,
                                applicationdate: null,
                                businessentity: null,
                                cafpin: null,
                                caftype: null,
                                emailprimary: null,
                                investorName: null,
                                projectlevel: null,
                                district: null,
                                createddate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('caf-with-no-service', null, { reload: 'caf-with-no-service' });
                }, function() {
                    $state.go('caf-with-no-service');
                });
            }]
        })
        .state('caf-with-no-service.edit', {
            parent: 'caf-with-no-service',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caf-with-no-service/caf-with-no-service-dialog.html',
                    controller: 'CafWithNoServiceDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CafWithNoService', function(CafWithNoService) {
                            return CafWithNoService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('caf-with-no-service', null, { reload: 'caf-with-no-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('caf-with-no-service.delete', {
            parent: 'caf-with-no-service',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caf-with-no-service/caf-with-no-service-delete-dialog.html',
                    controller: 'CafWithNoServiceDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CafWithNoService', function(CafWithNoService) {
                            return CafWithNoService.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('caf-with-no-service', null, { reload: 'caf-with-no-service' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('CafWithNoService', CafWithNoService);

    CafWithNoService.$inject = ['$resource', 'DateUtils'];

    function CafWithNoService ($resource, DateUtils) {
        var resourceUrl =  'api/caf-with-no-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.applicationdate = DateUtils.convertDateTimeFromServer(data.applicationdate);
                        data.createddate = DateUtils.convertDateTimeFromServer(data.createddate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafWithNoServiceController', CafWithNoServiceController);

    CafWithNoServiceController.$inject = ['CafWithNoService'];

    function CafWithNoServiceController(CafWithNoService) {

        var vm = this;

        vm.cafWithNoServices = [];

        loadAll();

        function loadAll() {
            CafWithNoService.query(function(result) {
                vm.cafWithNoServices = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafOtpDialogController', CafOtpDialogController);

    CafOtpDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CafOtp'];

    function CafOtpDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CafOtp) {
        var vm = this;

        vm.cafOtp = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cafOtp.id !== null) {
                CafOtp.update(vm.cafOtp, onSaveSuccess, onSaveError);
            } else {
                CafOtp.save(vm.cafOtp, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:cafOtpUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.requestTimeOut = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafOtpDetailController', CafOtpDetailController);

    CafOtpDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CafOtp'];

    function CafOtpDetailController($scope, $rootScope, $stateParams, previousState, entity, CafOtp) {
        var vm = this;

        vm.cafOtp = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:cafOtpUpdate', function(event, result) {
            vm.cafOtp = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafOtpDeleteController',CafOtpDeleteController);

    CafOtpDeleteController.$inject = ['$uibModalInstance', 'entity', 'CafOtp'];

    function CafOtpDeleteController($uibModalInstance, entity, CafOtp) {
        var vm = this;

        vm.cafOtp = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CafOtp.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('caf-otp', {
            parent: 'entity',
            url: '/caf-otp',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.cafOtp.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/caf-otp/caf-otps.html',
                    controller: 'CafOtpController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cafOtp');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('caf-otp-detail', {
            parent: 'caf-otp',
            url: '/caf-otp/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.cafOtp.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/caf-otp/caf-otp-detail.html',
                    controller: 'CafOtpDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cafOtp');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CafOtp', function($stateParams, CafOtp) {
                    return CafOtp.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'caf-otp',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('caf-otp-detail.edit', {
            parent: 'caf-otp-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caf-otp/caf-otp-dialog.html',
                    controller: 'CafOtpDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CafOtp', function(CafOtp) {
                            return CafOtp.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('caf-otp.new', {
            parent: 'caf-otp',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caf-otp/caf-otp-dialog.html',
                    controller: 'CafOtpDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                cafMobileNo: null,
                                otp: null,
                                userLogin: null,
                                requestTimeOut: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('caf-otp', null, { reload: 'caf-otp' });
                }, function() {
                    $state.go('caf-otp');
                });
            }]
        })
        .state('caf-otp.edit', {
            parent: 'caf-otp',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caf-otp/caf-otp-dialog.html',
                    controller: 'CafOtpDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CafOtp', function(CafOtp) {
                            return CafOtp.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('caf-otp', null, { reload: 'caf-otp' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('caf-otp.delete', {
            parent: 'caf-otp',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/caf-otp/caf-otp-delete-dialog.html',
                    controller: 'CafOtpDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CafOtp', function(CafOtp) {
                            return CafOtp.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('caf-otp', null, { reload: 'caf-otp' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('CafOtp', CafOtp);

    CafOtp.$inject = ['$resource', 'DateUtils'];

    function CafOtp ($resource, DateUtils) {
        var resourceUrl =  'api/caf-otps/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.requestTimeOut = DateUtils.convertDateTimeFromServer(data.requestTimeOut);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafOtpController', CafOtpController);

    CafOtpController.$inject = ['CafOtp'];

    function CafOtpController(CafOtp) {

        var vm = this;

        vm.cafOtps = [];

        loadAll();

        function loadAll() {
            CafOtp.query(function(result) {
                vm.cafOtps = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CAFAttachmentDialogController', CAFAttachmentDialogController);

    CAFAttachmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'CAFAttachment'];

    function CAFAttachmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, CAFAttachment) {
        var vm = this;

        vm.cAFAttachment = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.cAFAttachment.id !== null) {
                CAFAttachment.update(vm.cAFAttachment, onSaveSuccess, onSaveError);
            } else {
                CAFAttachment.save(vm.cAFAttachment, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:cAFAttachmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CAFAttachmentDetailController', CAFAttachmentDetailController);

    CAFAttachmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'CAFAttachment'];

    function CAFAttachmentDetailController($scope, $rootScope, $stateParams, previousState, entity, CAFAttachment) {
        var vm = this;

        vm.cAFAttachment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:cAFAttachmentUpdate', function(event, result) {
            vm.cAFAttachment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CAFAttachmentDeleteController',CAFAttachmentDeleteController);

    CAFAttachmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'CAFAttachment'];

    function CAFAttachmentDeleteController($uibModalInstance, entity, CAFAttachment) {
        var vm = this;

        vm.cAFAttachment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            CAFAttachment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('caf-attachment', {
            parent: 'entity',
            url: '/caf-attachment',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.cAFAttachment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/c-af-attachment/c-af-attachments.html',
                    controller: 'CAFAttachmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cAFAttachment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('caf-attachment-detail', {
            parent: 'caf-attachment',
            url: '/caf-attachment/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.cAFAttachment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/c-af-attachment/caf-attachment-detail.html',
                    controller: 'CAFAttachmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cAFAttachment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'CAFAttachment', function($stateParams, CAFAttachment) {
                    return CAFAttachment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'caf-attachment',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('caf-attachment-detail.edit', {
            parent: 'caf-attachment-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/c-af-attachment/caf-attachment-dialog.html',
                    controller: 'CAFAttachmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CAFAttachment', function(CAFAttachment) {
                            return CAFAttachment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('caf-attachment.new', {
            parent: 'caf-attachment',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/c-af-attachment/caf-attachment-dialog.html',
                    controller: 'CAFAttachmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                docName: null,
                                fileName: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('caf-attachment', null, { reload: 'caf-attachment' });
                }, function() {
                    $state.go('caf-attachment');
                });
            }]
        })
        .state('caf-attachment.edit', {
            parent: 'caf-attachment',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/c-af-attachment/caf-attachment-dialog.html',
                    controller: 'CAFAttachmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['CAFAttachment', function(CAFAttachment) {
                            return CAFAttachment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('caf-attachment', null, { reload: 'caf-attachment' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('caf-attachment.delete', {
            parent: 'caf-attachment',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/c-af-attachment/caf-attachment-delete-dialog.html',
                    controller: 'CAFAttachmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['CAFAttachment', function(CAFAttachment) {
                            return CAFAttachment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('caf-attachment', null, { reload: 'caf-attachment' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('CAFAttachment', CAFAttachment);

    CAFAttachment.$inject = ['$resource'];

    function CAFAttachment ($resource) {
        var resourceUrl =  'api/caf-attachments/:id/:projectid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            // New API
            'getBusinessEntities': {
                method: 'GET',
                url: 'api/central-business-entity',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CAFAttachmentController', CAFAttachmentController);

    CAFAttachmentController.$inject = ['CAFAttachment'];

    function CAFAttachmentController(CAFAttachment) {

        var vm = this;

        vm.cAFAttachments = [];

        loadAll();

        function loadAll() {
            CAFAttachment.query(function(result) {
                vm.cAFAttachments = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BusinessentitysDialogController', BusinessentitysDialogController);

    BusinessentitysDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Businessentitys'];

    function BusinessentitysDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Businessentitys) {
        var vm = this;

        vm.businessentitys = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.businessentitys.id !== null) {
                Businessentitys.update(vm.businessentitys, onSaveSuccess, onSaveError);
            } else {
                Businessentitys.save(vm.businessentitys, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:businessentitysUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BusinessentitysDetailController', BusinessentitysDetailController);

    BusinessentitysDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Businessentitys'];

    function BusinessentitysDetailController($scope, $rootScope, $stateParams, previousState, entity, Businessentitys) {
        var vm = this;

        vm.businessentitys = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:businessentitysUpdate', function(event, result) {
            vm.businessentitys = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BusinessentitysDeleteController',BusinessentitysDeleteController);

    BusinessentitysDeleteController.$inject = ['$uibModalInstance', 'entity', 'Businessentitys'];

    function BusinessentitysDeleteController($uibModalInstance, entity, Businessentitys) {
        var vm = this;

        vm.businessentitys = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Businessentitys.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('businessentitys', {
            parent: 'entity',
            url: '/businessentitys',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.businessentitys.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/businessentitys/businessentitys.html',
                    controller: 'BusinessentitysController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('businessentitys');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('businessentitys-detail', {
            parent: 'businessentitys',
            url: '/businessentitys/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.businessentitys.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/businessentitys/businessentitys-detail.html',
                    controller: 'BusinessentitysDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('businessentitys');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Businessentitys', function($stateParams, Businessentitys) {
                    return Businessentitys.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'businessentitys',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('businessentitys-detail.edit', {
            parent: 'businessentitys-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/businessentitys/businessentitys-dialog.html',
                    controller: 'BusinessentitysDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Businessentitys', function(Businessentitys) {
                            return Businessentitys.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('businessentitys.new', {
            parent: 'businessentitys',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/businessentitys/businessentitys-dialog.html',
                    controller: 'BusinessentitysDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                businessentitytype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('businessentitys', null, { reload: 'businessentitys' });
                }, function() {
                    $state.go('businessentitys');
                });
            }]
        })
        .state('businessentitys.edit', {
            parent: 'businessentitys',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/businessentitys/businessentitys-dialog.html',
                    controller: 'BusinessentitysDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Businessentitys', function(Businessentitys) {
                            return Businessentitys.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('businessentitys', null, { reload: 'businessentitys' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('businessentitys.delete', {
            parent: 'businessentitys',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/businessentitys/businessentitys-delete-dialog.html',
                    controller: 'BusinessentitysDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Businessentitys', function(Businessentitys) {
                            return Businessentitys.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('businessentitys', null, { reload: 'businessentitys' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Businessentitys', Businessentitys);

    Businessentitys.$inject = ['$resource'];

    function Businessentitys ($resource) {
        var resourceUrl =  'api/businessentitys/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BusinessentitysController', BusinessentitysController);

    BusinessentitysController.$inject = ['Businessentitys'];

    function BusinessentitysController(Businessentitys) {

        var vm = this;

        vm.businessentitys = [];

        loadAll();

        function loadAll() {
            Businessentitys.query(function(result) {
                vm.businessentitys = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BusinessentityDialogController', BusinessentityDialogController);

    BusinessentityDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Businessentity'];

    function BusinessentityDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Businessentity) {
        var vm = this;

        vm.businessentity = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.businessentity.id !== null) {
                Businessentity.update(vm.businessentity, onSaveSuccess, onSaveError);
            } else {
                Businessentity.save(vm.businessentity, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:businessentityUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BusinessentityDetailController', BusinessentityDetailController);

    BusinessentityDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Businessentity'];

    function BusinessentityDetailController($scope, $rootScope, $stateParams, previousState, entity, Businessentity) {
        var vm = this;

        vm.businessentity = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:businessentityUpdate', function(event, result) {
            vm.businessentity = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BusinessentityDeleteController',BusinessentityDeleteController);

    BusinessentityDeleteController.$inject = ['$uibModalInstance', 'entity', 'Businessentity'];

    function BusinessentityDeleteController($uibModalInstance, entity, Businessentity) {
        var vm = this;

        vm.businessentity = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Businessentity.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('businessentity', {
            parent: 'entity',
            url: '/businessentity',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.businessentity.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/businessentity/businessentities.html',
                    controller: 'BusinessentityController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('businessentity');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('businessentity-detail', {
            parent: 'businessentity',
            url: '/businessentity/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.businessentity.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/businessentity/businessentity-detail.html',
                    controller: 'BusinessentityDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('businessentity');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Businessentity', function($stateParams, Businessentity) {
                    return Businessentity.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'businessentity',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('businessentity-detail.edit', {
            parent: 'businessentity-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/businessentity/businessentity-dialog.html',
                    controller: 'BusinessentityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Businessentity', function(Businessentity) {
                            return Businessentity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('businessentity.new', {
            parent: 'businessentity',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/businessentity/businessentity-dialog.html',
                    controller: 'BusinessentityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                businessentitytype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('businessentity', null, { reload: 'businessentity' });
                }, function() {
                    $state.go('businessentity');
                });
            }]
        })
        .state('businessentity.edit', {
            parent: 'businessentity',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/businessentity/businessentity-dialog.html',
                    controller: 'BusinessentityDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Businessentity', function(Businessentity) {
                            return Businessentity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('businessentity', null, { reload: 'businessentity' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('businessentity.delete', {
            parent: 'businessentity',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/businessentity/businessentity-delete-dialog.html',
                    controller: 'BusinessentityDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Businessentity', function(Businessentity) {
                            return Businessentity.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('businessentity', null, { reload: 'businessentity' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Businessentity', Businessentity);

    Businessentity.$inject = ['$resource'];

    function Businessentity ($resource) {
        var resourceUrl =  'api/businessentities/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BusinessentityController', BusinessentityController);

    BusinessentityController.$inject = ['Businessentity'];

    function BusinessentityController(Businessentity) {

        var vm = this;

        vm.businessentities = [];

        loadAll();

        function loadAll() {
            Businessentity.query(function(result) {
                vm.businessentities = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BrapChecklistDialogController', BrapChecklistDialogController);

    BrapChecklistDialogController.$inject = ['$uibModalInstance', 'entity', 'BrapChecklist', 'FileManagement'];

    function BrapChecklistDialogController($uibModalInstance, entity, BrapChecklist, FileManagement) {
        var vm = this;

        vm.brapChecklist = entity;
        vm.isSaving = false;
        vm.save = save;
        vm.addfileattachment = addfileattachment;
        vm.submitForm = submitForm;
        vm.clear = clear;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function submitForm() {
            vm.isSaving = true;
            save().then(function(result) {
                return addfileattachment(result);
            }).then(function(updatedResult) {
                $uibModalInstance.close(updatedResult);
            }).catch(function(error) {
                console.error('Error in form submission', error);
                vm.isSaving = false;
            });
        }

        function save() {
            return new Promise(function(resolve, reject) {
                if (vm.brapChecklist.id !== null) {
                    BrapChecklist.update(vm.brapChecklist, function(result) {
                        resolve(result);
                    }, function(error) {
                        reject(error);
                    });
                } else {
                    BrapChecklist.save(vm.brapChecklist, function(result) {
                        resolve(result);
                    }, function(error) {
                        reject(error);
                    });
                }
            });
        }

        function addfileattachment(result) {
            return new Promise(function(resolve, reject) {
                var fileMappings = [
                    { inputId: 'field_feeStructureDoc', field: 'feeStructureDoc' },
                    { inputId: 'field_sopDoc', field: 'sopDoc' },
                    { inputId: 'field_timelineDoc', field: 'timelineDoc' },
                    { inputId: 'field_inspectionDoc', field: 'inspectionDoc' },
                    { inputId: 'field_riskCategoryDoc', field: 'riskCategoryDoc' }
                    // 👉 add more if you have more fields
                ];

                var totalFiles = fileMappings.length;
                var completed = 0;


             fileMappings.forEach(function (mapping, index) {
                        var fileInput = document.getElementById(mapping.inputId);
                        var file = fileInput && fileInput.files[0];

                        if (file) {
                            var filename = result.id + "_file" + (index + 1);

                            console.log("filenameee" + filename);

                            FileManagement.saveFileForBrapCheckList(file, filename, function () {
                                // Assign file to corresponding result field
                                result[mapping.field] = filename;

                                completed++;
                                if (completed === totalFiles) {
                                    // Save after processing all inputs
                                    BrapChecklist.update(result, function (updatedResult) {
                                        resolve(updatedResult);
                                    }, function (error) {
                                        reject(error);
                                    });
                                }
                            }, function (error) {
                                reject(error);
                            });
                        } else {
                            completed++;
                            if (completed === totalFiles) {
                                BrapChecklist.update(result, function (updatedResult) {
                                    resolve(updatedResult);
                                }, function (error) {
                                    reject(error);
                                });
                            }
                        }
                    });
                });

    }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BrapChecklistDetailController', BrapChecklistDetailController);

    BrapChecklistDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BrapChecklist'];

    function BrapChecklistDetailController($scope, $rootScope, $stateParams, previousState, entity, BrapChecklist) {
        var vm = this;

        vm.brapChecklist = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:brapChecklistUpdate', function(event, result) {
            vm.brapChecklist = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BrapChecklistDeleteController',BrapChecklistDeleteController);

    BrapChecklistDeleteController.$inject = ['$uibModalInstance', 'entity', 'BrapChecklist'];

    function BrapChecklistDeleteController($uibModalInstance, entity, BrapChecklist) {
        var vm = this;

        vm.brapChecklist = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BrapChecklist.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('brap-checklist', {
            parent: 'entity',
            url: '/brap-checklist',
            data: {
                authorities: [],
                pageTitle: 'investhryApp.brapChecklist.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brap-checklist/brap-checklists.html',
                    controller: 'BrapChecklistController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brapChecklist');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('brap-checklist-detail', {
            parent: 'brap-checklist',
            url: '/brap-checklist/{id}',
            data: {
                authorities: [],
                pageTitle: 'investhryApp.brapChecklist.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/brap-checklist/brap-checklist-detail.html',
                    controller: 'BrapChecklistDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('brapChecklist');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BrapChecklist', function($stateParams, BrapChecklist) {
                    return BrapChecklist.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'brap-checklist',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('brap-checklist-detail.edit', {
            parent: 'brap-checklist-detail',
            url: '/detail/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brap-checklist/brap-checklist-dialog.html',
                    controller: 'BrapChecklistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BrapChecklist', function(BrapChecklist) {
                            return BrapChecklist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('brap-checklist.new', {
            parent: 'brap-checklist',
            url: '/new',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brap-checklist/brap-checklist-dialog.html',
                    controller: 'BrapChecklistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                departmentId: null,
                                riskCategory: null,
                                sizeOfFirm: null,
                                businessLocation: null,
                                investerType: null,
                                createdAt: null,
                                updatedAt: null,
                                documentUrl: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('brap-checklist', null, { reload: 'brap-checklist' });
                }, function() {
                    $state.go('brap-checklist');
                });
            }]
        })
        .state('brap-checklist.edit', {
            parent: 'brap-checklist',
            url: '/{id}/edit',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brap-checklist/brap-checklist-dialog.html',
                    controller: 'BrapChecklistDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BrapChecklist', function(BrapChecklist) {
                            return BrapChecklist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('brap-checklist', null, { reload: 'brap-checklist' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('brap-checklist.delete', {
            parent: 'brap-checklist',
            url: '/{id}/delete',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/brap-checklist/brap-checklist-delete-dialog.html',
                    controller: 'BrapChecklistDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BrapChecklist', function(BrapChecklist) {
                            return BrapChecklist.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('brap-checklist', null, { reload: 'brap-checklist' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('BrapChecklist', BrapChecklist);

    BrapChecklist.$inject = ['$resource', 'DateUtils'];

    function BrapChecklist ($resource, DateUtils) {
        var resourceUrl =  'api/brap-checklists/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdAt = DateUtils.convertDateTimeFromServer(data.createdAt);
                        data.updatedAt = DateUtils.convertDateTimeFromServer(data.updatedAt);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getDocumentUrl': {
                method: 'POST',
                url: 'api/getFiltedBrapDocument',
                transformResponse: function(data) {
                    return data;
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BrapChecklistController', BrapChecklistController);

    BrapChecklistController.$inject = ['BrapChecklist'];

    function BrapChecklistController(BrapChecklist) {

        var vm = this;

        vm.brapChecklists = [];

        loadAll();

        function loadAll() {
            BrapChecklist.query(function(result) {
                vm.brapChecklists = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BlockDialogController', BlockDialogController);

    BlockDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Block'];

    function BlockDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Block) {
        var vm = this;

        vm.block = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.block.id !== null) {
                Block.update(vm.block, onSaveSuccess, onSaveError);
            } else {
                Block.save(vm.block, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:blockUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BlockDetailController', BlockDetailController);

    BlockDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Block'];

    function BlockDetailController($scope, $rootScope, $stateParams, previousState, entity, Block) {
        var vm = this;

        vm.block = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:blockUpdate', function(event, result) {
            vm.block = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BlockDeleteController',BlockDeleteController);

    BlockDeleteController.$inject = ['$uibModalInstance', 'entity', 'Block'];

    function BlockDeleteController($uibModalInstance, entity, Block) {
        var vm = this;

        vm.block = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Block.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('block', {
            parent: 'entity',
            url: '/block',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.block.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/block/blocks.html',
                    controller: 'BlockController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('block');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('block-detail', {
            parent: 'block',
            url: '/block/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.block.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/block/block-detail.html',
                    controller: 'BlockDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('block');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Block', function($stateParams, Block) {
                    return Block.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'block',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('block-detail.edit', {
            parent: 'block-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/block/block-dialog.html',
                    controller: 'BlockDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Block', function(Block) {
                            return Block.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('block.new', {
            parent: 'block',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/block/block-dialog.html',
                    controller: 'BlockDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                blockname: null,
                                districtname: null,
                                blocktype: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('block', null, { reload: 'block' });
                }, function() {
                    $state.go('block');
                });
            }]
        })
        .state('block.edit', {
            parent: 'block',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/block/block-dialog.html',
                    controller: 'BlockDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Block', function(Block) {
                            return Block.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('block', null, { reload: 'block' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('block.delete', {
            parent: 'block',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/block/block-delete-dialog.html',
                    controller: 'BlockDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Block', function(Block) {
                            return Block.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('block', null, { reload: 'block' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Block', Block);

    Block.$inject = ['$resource'];

    function Block ($resource) {
        var resourceUrl =  'api/blocks/:id/:districtname';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BlockController', BlockController);

    BlockController.$inject = ['Block'];

    function BlockController(Block) {

        var vm = this;

        vm.blocks = [];

        loadAll();

        function loadAll() {
            Block.query(function(result) {
                vm.blocks = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Below_groundDialogController', Below_groundDialogController);

    Below_groundDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Below_ground'];

    function Below_groundDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Below_ground) {
        var vm = this;

        vm.below_ground = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.below_ground.id !== null) {
                Below_ground.update(vm.below_ground, onSaveSuccess, onSaveError);
            } else {
                Below_ground.save(vm.below_ground, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:below_groundUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created_on = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Below_groundDetailController', Below_groundDetailController);

    Below_groundDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Below_ground'];

    function Below_groundDetailController($scope, $rootScope, $stateParams, previousState, entity, Below_ground) {
        var vm = this;

        vm.below_ground = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:below_groundUpdate', function(event, result) {
            vm.below_ground = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Below_groundDeleteController',Below_groundDeleteController);

    Below_groundDeleteController.$inject = ['$uibModalInstance', 'entity', 'Below_ground'];

    function Below_groundDeleteController($uibModalInstance, entity, Below_ground) {
        var vm = this;

        vm.below_ground = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Below_ground.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('below-ground', {
            parent: 'entity',
            url: '/below-ground',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.below_ground.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/below-ground/below-grounds.html',
                    controller: 'Below_groundController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('below_ground');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('below-ground-detail', {
            parent: 'below-ground',
            url: '/below-ground/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.below_ground.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/below-ground/below-ground-detail.html',
                    controller: 'Below_groundDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('below_ground');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Below_ground', function($stateParams, Below_ground) {
                    return Below_ground.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'below-ground',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('below-ground-detail.edit', {
            parent: 'below-ground-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/below-ground/below-ground-dialog.html',
                    controller: 'Below_groundDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Below_ground', function(Below_ground) {
                            return Below_ground.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('below-ground.new', {
            parent: 'below-ground',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/below-ground/below-ground-dialog.html',
                    controller: 'Below_groundDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name: null,
                                reg_add: null,
                                har_office_add: null,
                                name_auth: null,
                                designation_auth: null,
                                phone_auth: null,
                                email: null,
                                lenth: null,
                                route: null,
                                nature: null,
                                methodology: null,
                                address1: null,
                                district: null,
                                zone: null,
                                details1: null,
                                details2: null,
                                other_info1: null,
                                other_info2: null,
                                other_info3: null,
                                other_info4: null,
                                other_info5: null,
                                other_info6: null,
                                other_info7: null,
                                address2: null,
                                document1: null,
                                document2: null,
                                document3: null,
                                document4: null,
                                document5: null,
                                document6: null,
                                document7: null,
                                document8: null,
                                isfullyfilled: null,
                                status: null,
                                isforwardedtodio: null,
                                isforwardedtodept: null,
                                isforwardedtodc: null,
                                clearancefile1: null,
                                clearancefile2: null,
                                clearancefile3: null,
                                created_by: null,
                                created_on: null,
                                isforwarded: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('below-ground', null, { reload: 'below-ground' });
                }, function() {
                    $state.go('below-ground');
                });
            }]
        })
        .state('below-ground.edit', {
            parent: 'below-ground',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/below-ground/below-ground-dialog.html',
                    controller: 'Below_groundDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Below_ground', function(Below_ground) {
                            return Below_ground.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('below-ground', null, { reload: 'below-ground' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('below-ground.delete', {
            parent: 'below-ground',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/below-ground/below-ground-delete-dialog.html',
                    controller: 'Below_groundDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Below_ground', function(Below_ground) {
                            return Below_ground.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('below-ground', null, { reload: 'below-ground' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Below_ground', Below_ground);

    Below_ground.$inject = ['$resource', 'DateUtils'];

    function Below_ground ($resource, DateUtils) {
        var resourceUrl =  'api/below-grounds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created_on = DateUtils.convertLocalDateFromServer(data.created_on);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.created_on = DateUtils.convertLocalDateToServer(copy.created_on);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.created_on = DateUtils.convertLocalDateToServer(copy.created_on);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Below_groundController', Below_groundController);

    Below_groundController.$inject = ['Below_ground'];

    function Below_groundController(Below_ground) {

        var vm = this;

        vm.below_grounds = [];

        loadAll();

        function loadAll() {
            Below_ground.query(function(result) {
                vm.below_grounds = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BackupProjectServiceLogDialogController', BackupProjectServiceLogDialogController);

    BackupProjectServiceLogDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'BackupProjectServiceLog'];

    function BackupProjectServiceLogDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, BackupProjectServiceLog) {
        var vm = this;

        vm.backupProjectServiceLog = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.backupProjectServiceLog.id !== null) {
                BackupProjectServiceLog.update(vm.backupProjectServiceLog, onSaveSuccess, onSaveError);
            } else {
                BackupProjectServiceLog.save(vm.backupProjectServiceLog, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:backupProjectServiceLogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.commentDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BackupProjectServiceLogDetailController', BackupProjectServiceLogDetailController);

    BackupProjectServiceLogDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'BackupProjectServiceLog'];

    function BackupProjectServiceLogDetailController($scope, $rootScope, $stateParams, previousState, entity, BackupProjectServiceLog) {
        var vm = this;

        vm.backupProjectServiceLog = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:backupProjectServiceLogUpdate', function(event, result) {
            vm.backupProjectServiceLog = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BackupProjectServiceLogDeleteController',BackupProjectServiceLogDeleteController);

    BackupProjectServiceLogDeleteController.$inject = ['$uibModalInstance', 'entity', 'BackupProjectServiceLog'];

    function BackupProjectServiceLogDeleteController($uibModalInstance, entity, BackupProjectServiceLog) {
        var vm = this;

        vm.backupProjectServiceLog = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            BackupProjectServiceLog.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('backup-project-service-log', {
            parent: 'entity',
            url: '/backup-project-service-log',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.backupProjectServiceLog.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/backup-project-service-log/backup-project-service-logs.html',
                    controller: 'BackupProjectServiceLogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('backupProjectServiceLog');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('backup-project-service-log-detail', {
            parent: 'backup-project-service-log',
            url: '/backup-project-service-log/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.backupProjectServiceLog.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/backup-project-service-log/backup-project-service-log-detail.html',
                    controller: 'BackupProjectServiceLogDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('backupProjectServiceLog');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'BackupProjectServiceLog', function($stateParams, BackupProjectServiceLog) {
                    return BackupProjectServiceLog.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'backup-project-service-log',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('backup-project-service-log-detail.edit', {
            parent: 'backup-project-service-log-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/backup-project-service-log/backup-project-service-log-dialog.html',
                    controller: 'BackupProjectServiceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BackupProjectServiceLog', function(BackupProjectServiceLog) {
                            return BackupProjectServiceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('backup-project-service-log.new', {
            parent: 'backup-project-service-log',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/backup-project-service-log/backup-project-service-log-dialog.html',
                    controller: 'BackupProjectServiceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                projectid: null,
                                serviceid: null,
                                comments: null,
                                commentDate: null,
                                commentByUserLogin: null,
                                actionTaken: null,
                                reApplyCounter: null,
                                rejectionReason: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('backup-project-service-log', null, { reload: 'backup-project-service-log' });
                }, function() {
                    $state.go('backup-project-service-log');
                });
            }]
        })
        .state('backup-project-service-log.edit', {
            parent: 'backup-project-service-log',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/backup-project-service-log/backup-project-service-log-dialog.html',
                    controller: 'BackupProjectServiceLogDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['BackupProjectServiceLog', function(BackupProjectServiceLog) {
                            return BackupProjectServiceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('backup-project-service-log', null, { reload: 'backup-project-service-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('backup-project-service-log.delete', {
            parent: 'backup-project-service-log',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/backup-project-service-log/backup-project-service-log-delete-dialog.html',
                    controller: 'BackupProjectServiceLogDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['BackupProjectServiceLog', function(BackupProjectServiceLog) {
                            return BackupProjectServiceLog.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('backup-project-service-log', null, { reload: 'backup-project-service-log' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('BackupProjectServiceLog', BackupProjectServiceLog);

    BackupProjectServiceLog.$inject = ['$resource', 'DateUtils'];

    function BackupProjectServiceLog ($resource, DateUtils) {
        var resourceUrl =  'api/backup-project-service-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.commentDate = DateUtils.convertDateTimeFromServer(data.commentDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BackupProjectServiceLogController', BackupProjectServiceLogController);

    BackupProjectServiceLogController.$inject = ['BackupProjectServiceLog'];

    function BackupProjectServiceLogController(BackupProjectServiceLog) {

        var vm = this;

        vm.backupProjectServiceLogs = [];

        loadAll();

        function loadAll() {
            BackupProjectServiceLog.query(function(result) {
                vm.backupProjectServiceLogs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignServiceFeeDialogController', AssignServiceFeeDialogController);

    AssignServiceFeeDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AssignServiceFee'];

    function AssignServiceFeeDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AssignServiceFee) {
        var vm = this;

        vm.assignServiceFee = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.assignServiceFee.id !== null) {
                AssignServiceFee.update(vm.assignServiceFee, onSaveSuccess, onSaveError);
            } else {
                AssignServiceFee.save(vm.assignServiceFee, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:assignServiceFeeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignServiceFeeDetailController', AssignServiceFeeDetailController);

    AssignServiceFeeDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AssignServiceFee'];

    function AssignServiceFeeDetailController($scope, $rootScope, $stateParams, previousState, entity, AssignServiceFee) {
        var vm = this;

        vm.assignServiceFee = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:assignServiceFeeUpdate', function(event, result) {
            vm.assignServiceFee = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignServiceFeeDeleteController',AssignServiceFeeDeleteController);

    AssignServiceFeeDeleteController.$inject = ['$uibModalInstance', 'entity', 'AssignServiceFee'];

    function AssignServiceFeeDeleteController($uibModalInstance, entity, AssignServiceFee) {
        var vm = this;

        vm.assignServiceFee = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AssignServiceFee.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('assign-service-fee', {
            parent: 'entity',
            url: '/assign-service-fee',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.assignServiceFee.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/assign-service-fee/assign-service-fees.html',
                    controller: 'AssignServiceFeeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assignServiceFee');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('assign-service-fee-detail', {
            parent: 'assign-service-fee',
            url: '/assign-service-fee/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.assignServiceFee.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/assign-service-fee/assign-service-fee-detail.html',
                    controller: 'AssignServiceFeeDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assignServiceFee');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AssignServiceFee', function($stateParams, AssignServiceFee) {
                    return AssignServiceFee.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'assign-service-fee',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('assign-service-fee-detail.edit', {
            parent: 'assign-service-fee-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-service-fee/assign-service-fee-dialog.html',
                    controller: 'AssignServiceFeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AssignServiceFee', function(AssignServiceFee) {
                            return AssignServiceFee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('assign-service-fee.new', {
            parent: 'assign-service-fee',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-service-fee/assign-service-fee-dialog.html',
                    controller: 'AssignServiceFeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                feedescription: null,
                                feeamount: null,
                                projectid: null,
                                serviceid: null,
                                isSaved: null,
                                isPaymentMade: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('assign-service-fee', null, { reload: 'assign-service-fee' });
                }, function() {
                    $state.go('assign-service-fee');
                });
            }]
        })
        .state('assign-service-fee.edit', {
            parent: 'assign-service-fee',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-service-fee/assign-service-fee-dialog.html',
                    controller: 'AssignServiceFeeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AssignServiceFee', function(AssignServiceFee) {
                            return AssignServiceFee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('assign-service-fee', null, { reload: 'assign-service-fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('assign-service-fee.delete', {
            parent: 'assign-service-fee',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-service-fee/assign-service-fee-delete-dialog.html',
                    controller: 'AssignServiceFeeDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AssignServiceFee', function(AssignServiceFee) {
                            return AssignServiceFee.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('assign-service-fee', null, { reload: 'assign-service-fee' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('AssignServiceFee', AssignServiceFee);

    AssignServiceFee.$inject = ['$resource'];

    function AssignServiceFee ($resource) {
        var resourceUrl =  'api/assign-service-fees/:id/:projectid/:serviceid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignServiceFeeController', AssignServiceFeeController);

    AssignServiceFeeController.$inject = ['AssignServiceFee'];

    function AssignServiceFeeController(AssignServiceFee) {

        var vm = this;

        vm.assignServiceFees = [];

        loadAll();

        function loadAll() {
            AssignServiceFee.query(function(result) {
                vm.assignServiceFees = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignProjectToRMDialogController', AssignProjectToRMDialogController);

    AssignProjectToRMDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AssignProjectToRM'];

    function AssignProjectToRMDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AssignProjectToRM) {
        var vm = this;

        vm.assignProjectToRM = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.assignProjectToRM.id !== null) {
                AssignProjectToRM.update(vm.assignProjectToRM, onSaveSuccess, onSaveError);
            } else {
                AssignProjectToRM.save(vm.assignProjectToRM, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:assignProjectToRMUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.assignDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignProjectToRMDetailController', AssignProjectToRMDetailController);

    AssignProjectToRMDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AssignProjectToRM'];

    function AssignProjectToRMDetailController($scope, $rootScope, $stateParams, previousState, entity, AssignProjectToRM) {
        var vm = this;

        vm.assignProjectToRM = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:assignProjectToRMUpdate', function(event, result) {
            vm.assignProjectToRM = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignProjectToRMDeleteController',AssignProjectToRMDeleteController);

    AssignProjectToRMDeleteController.$inject = ['$uibModalInstance', 'entity', 'AssignProjectToRM'];

    function AssignProjectToRMDeleteController($uibModalInstance, entity, AssignProjectToRM) {
        var vm = this;

        vm.assignProjectToRM = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AssignProjectToRM.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('assign-project-to-rm', {
            parent: 'entity',
            url: '/assign-project-to-rm',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.assignProjectToRM.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/assign-project-to-rm/assign-project-to-rms.html',
                    controller: 'AssignProjectToRMController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assignProjectToRM');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('assign-project-to-rm-detail', {
            parent: 'assign-project-to-rm',
            url: '/assign-project-to-rm/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.assignProjectToRM.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/assign-project-to-rm/assign-project-to-rm-detail.html',
                    controller: 'AssignProjectToRMDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assignProjectToRM');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AssignProjectToRM', function($stateParams, AssignProjectToRM) {
                    return AssignProjectToRM.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'assign-project-to-rm',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('assign-project-to-rm-detail.edit', {
            parent: 'assign-project-to-rm-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-project-to-rm/assign-project-to-rm-dialog.html',
                    controller: 'AssignProjectToRMDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AssignProjectToRM', function(AssignProjectToRM) {
                            return AssignProjectToRM.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('assign-project-to-rm.new', {
            parent: 'assign-project-to-rm',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-project-to-rm/assign-project-to-rm-dialog.html',
                    controller: 'AssignProjectToRMDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                assignBy: null,
                                assignDate: null,
                                projectid: null,
                                assignedToRM: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('assign-project-to-rm', null, { reload: 'assign-project-to-rm' });
                }, function() {
                    $state.go('assign-project-to-rm');
                });
            }]
        })
        .state('assign-project-to-rm.edit', {
            parent: 'assign-project-to-rm',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-project-to-rm/assign-project-to-rm-dialog.html',
                    controller: 'AssignProjectToRMDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AssignProjectToRM', function(AssignProjectToRM) {
                            return AssignProjectToRM.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('assign-project-to-rm', null, { reload: 'assign-project-to-rm' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('assign-project-to-rm.delete', {
            parent: 'assign-project-to-rm',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-project-to-rm/assign-project-to-rm-delete-dialog.html',
                    controller: 'AssignProjectToRMDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AssignProjectToRM', function(AssignProjectToRM) {
                            return AssignProjectToRM.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('assign-project-to-rm', null, { reload: 'assign-project-to-rm' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('AssignProjectToRM', AssignProjectToRM);

    AssignProjectToRM.$inject = ['$resource', 'DateUtils'];

    function AssignProjectToRM ($resource, DateUtils) {
        var resourceUrl =  'api/assign-project-to-rms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.assignDate = DateUtils.convertDateTimeFromServer(data.assignDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignProjectToRMController', AssignProjectToRMController);

    AssignProjectToRMController.$inject = ['AssignProjectToRM'];

    function AssignProjectToRMController(AssignProjectToRM) {

        var vm = this;

        vm.assignProjectToRMS = [];

        loadAll();

        function loadAll() {
            AssignProjectToRM.query(function(result) {
                vm.assignProjectToRMS = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignFieldOfficerToDepartmentDialogController', AssignFieldOfficerToDepartmentDialogController);

    AssignFieldOfficerToDepartmentDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AssignFieldOfficerToDepartment'];

    function AssignFieldOfficerToDepartmentDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AssignFieldOfficerToDepartment) {
        var vm = this;

        vm.assignFieldOfficerToDepartment = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.assignFieldOfficerToDepartment.id !== null) {
                AssignFieldOfficerToDepartment.update(vm.assignFieldOfficerToDepartment, onSaveSuccess, onSaveError);
            } else {
                AssignFieldOfficerToDepartment.save(vm.assignFieldOfficerToDepartment, onSaveSuccess, onSaveError);
            }
        }
        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:assignFieldOfficerToDepartmentUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignFieldOfficerToDepartmentDetailController', AssignFieldOfficerToDepartmentDetailController);

    AssignFieldOfficerToDepartmentDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AssignFieldOfficerToDepartment'];

    function AssignFieldOfficerToDepartmentDetailController($scope, $rootScope, $stateParams, previousState, entity, AssignFieldOfficerToDepartment) {
        var vm = this;

        vm.assignFieldOfficerToDepartment = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:assignFieldOfficerToDepartmentUpdate', function(event, result) {
            vm.assignFieldOfficerToDepartment = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignFieldOfficerToDepartmentDeleteController',AssignFieldOfficerToDepartmentDeleteController);

    AssignFieldOfficerToDepartmentDeleteController.$inject = ['$uibModalInstance', 'entity', 'AssignFieldOfficerToDepartment'];

    function AssignFieldOfficerToDepartmentDeleteController($uibModalInstance, entity, AssignFieldOfficerToDepartment) {
        var vm = this;

        vm.assignFieldOfficerToDepartment = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AssignFieldOfficerToDepartment.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('assign-field-officer-to-department', {
            parent: 'entity',
            url: '/assign-field-officer-to-department',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.assignFieldOfficerToDepartment.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/assign-field-officer-to-department/assign-field-officer-to-departments.html',
                    controller: 'AssignFieldOfficerToDepartmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assignFieldOfficerToDepartment');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('assign-field-officer-to-department-detail', {
            parent: 'assign-field-officer-to-department',
            url: '/assign-field-officer-to-department/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.assignFieldOfficerToDepartment.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/assign-field-officer-to-department/assign-field-officer-to-department-detail.html',
                    controller: 'AssignFieldOfficerToDepartmentDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('assignFieldOfficerToDepartment');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AssignFieldOfficerToDepartment', function($stateParams, AssignFieldOfficerToDepartment) {
                    return AssignFieldOfficerToDepartment.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'assign-field-officer-to-department',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('assign-field-officer-to-department-detail.edit', {
            parent: 'assign-field-officer-to-department-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-field-officer-to-department/assign-field-officer-to-department-dialog.html',
                    controller: 'AssignFieldOfficerToDepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AssignFieldOfficerToDepartment', function(AssignFieldOfficerToDepartment) {
                            return AssignFieldOfficerToDepartment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('assign-field-officer-to-department.new', {
            parent: 'assign-field-officer-to-department',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-field-officer-to-department/assign-field-officer-to-department-dialog.html',
                    controller: 'AssignFieldOfficerToDepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                departmentid: null,
                                departmentname: null,
                                fieldOfficerid: null,
                                fieldofficerlogin: null,
                                fieldofficerdesignation: null,
                                fieldofficeraddress: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('assign-field-officer-to-department', null, { reload: 'assign-field-officer-to-department' });
                }, function() {
                    $state.go('assign-field-officer-to-department');
                });
            }]
        })
        .state('assign-field-officer-to-department.edit', {
            parent: 'assign-field-officer-to-department',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-field-officer-to-department/assign-field-officer-to-department-dialog.html',
                    controller: 'AssignFieldOfficerToDepartmentDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AssignFieldOfficerToDepartment', function(AssignFieldOfficerToDepartment) {
                            return AssignFieldOfficerToDepartment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('assign-field-officer-to-department', null, { reload: 'assign-field-officer-to-department' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('assign-field-officer-to-department.delete', {
            parent: 'assign-field-officer-to-department',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/assign-field-officer-to-department/assign-field-officer-to-department-delete-dialog.html',
                    controller: 'AssignFieldOfficerToDepartmentDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AssignFieldOfficerToDepartment', function(AssignFieldOfficerToDepartment) {
                            return AssignFieldOfficerToDepartment.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('assign-field-officer-to-department', null, { reload: 'assign-field-officer-to-department' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('AssignFieldOfficerToDepartment', AssignFieldOfficerToDepartment);

    AssignFieldOfficerToDepartment.$inject = ['$resource'];

    function AssignFieldOfficerToDepartment ($resource) {
        var resourceUrl =  'api/assign-field-officer-to-departments/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignFieldOfficerToDepartmentController', AssignFieldOfficerToDepartmentController);

    AssignFieldOfficerToDepartmentController.$inject = ['AssignFieldOfficerToDepartment'];

    function AssignFieldOfficerToDepartmentController(AssignFieldOfficerToDepartment) {

        var vm = this;

        vm.assignFieldOfficerToDepartments = [];

        loadAll();

        function loadAll() {
            AssignFieldOfficerToDepartment.query(function(result) {
                vm.assignFieldOfficerToDepartments = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApprovalformsDialogController', ApprovalformsDialogController);

    ApprovalformsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Approvalforms'];

    function ApprovalformsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Approvalforms) {
        var vm = this;

        vm.approvalforms = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.approvalforms.id !== null) {
                Approvalforms.update(vm.approvalforms, onSaveSuccess, onSaveError);
            } else {
                Approvalforms.save(vm.approvalforms, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:approvalformsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApprovalformsDetailController', ApprovalformsDetailController);

    ApprovalformsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Approvalforms'];

    function ApprovalformsDetailController($scope, $rootScope, $stateParams, previousState, entity, Approvalforms) {
        var vm = this;

        vm.approvalforms = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:approvalformsUpdate', function(event, result) {
            vm.approvalforms = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApprovalformsDeleteController',ApprovalformsDeleteController);

    ApprovalformsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Approvalforms'];

    function ApprovalformsDeleteController($uibModalInstance, entity, Approvalforms) {
        var vm = this;

        vm.approvalforms = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Approvalforms.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('approvalforms', {
            parent: 'entity',
            url: '/approvalforms',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.approvalforms.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/approvalforms/approvalforms.html',
                    controller: 'ApprovalformsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('approvalforms');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('approvalforms-detail', {
            parent: 'approvalforms',
            url: '/approvalforms/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.approvalforms.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/approvalforms/approvalforms-detail.html',
                    controller: 'ApprovalformsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('approvalforms');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Approvalforms', function($stateParams, Approvalforms) {
                    return Approvalforms.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'approvalforms',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('approvalforms-detail.edit', {
            parent: 'approvalforms-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approvalforms/approvalforms-dialog.html',
                    controller: 'ApprovalformsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Approvalforms', function(Approvalforms) {
                            return Approvalforms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('approvalforms.new', {
            parent: 'approvalforms',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approvalforms/approvalforms-dialog.html',
                    controller: 'ApprovalformsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                existingapprovalforms: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('approvalforms', null, { reload: 'approvalforms' });
                }, function() {
                    $state.go('approvalforms');
                });
            }]
        })
        .state('approvalforms.edit', {
            parent: 'approvalforms',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approvalforms/approvalforms-dialog.html',
                    controller: 'ApprovalformsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Approvalforms', function(Approvalforms) {
                            return Approvalforms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('approvalforms', null, { reload: 'approvalforms' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('approvalforms.delete', {
            parent: 'approvalforms',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/approvalforms/approvalforms-delete-dialog.html',
                    controller: 'ApprovalformsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Approvalforms', function(Approvalforms) {
                            return Approvalforms.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('approvalforms', null, { reload: 'approvalforms' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Approvalforms', Approvalforms);

    Approvalforms.$inject = ['$resource'];

    function Approvalforms ($resource) {
        var resourceUrl =  'api/approvalforms/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApprovalformsController', ApprovalformsController);

    ApprovalformsController.$inject = ['Approvalforms'];

    function ApprovalformsController(Approvalforms) {

        var vm = this;

        vm.approvalforms = [];

        loadAll();

        function loadAll() {
            Approvalforms.query(function(result) {
                vm.approvalforms = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AppliedServicesDialogController', AppliedServicesDialogController);

    AppliedServicesDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'AppliedServices'];

    function AppliedServicesDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, AppliedServices) {
        var vm = this;

        vm.appliedServices = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.appliedServices.id !== null) {
                AppliedServices.update(vm.appliedServices, onSaveSuccess, onSaveError);
            } else {
                AppliedServices.save(vm.appliedServices, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:appliedServicesUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.appliedDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AppliedServicesDetailController', AppliedServicesDetailController);

    AppliedServicesDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'AppliedServices'];

    function AppliedServicesDetailController($scope, $rootScope, $stateParams, previousState, entity, AppliedServices) {
        var vm = this;

        vm.appliedServices = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:appliedServicesUpdate', function(event, result) {
            vm.appliedServices = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AppliedServicesDeleteController',AppliedServicesDeleteController);

    AppliedServicesDeleteController.$inject = ['$uibModalInstance', 'entity', 'AppliedServices'];

    function AppliedServicesDeleteController($uibModalInstance, entity, AppliedServices) {
        var vm = this;

        vm.appliedServices = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AppliedServices.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('applied-services', {
            parent: 'entity',
            url: '/applied-services',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.appliedServices.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/applied-services/applied-services.html',
                    controller: 'AppliedServicesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appliedServices');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('applied-services-detail', {
            parent: 'applied-services',
            url: '/applied-services/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.appliedServices.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/applied-services/applied-services-detail.html',
                    controller: 'AppliedServicesDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('appliedServices');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'AppliedServices', function($stateParams, AppliedServices) {
                    return AppliedServices.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'applied-services',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('applied-services-detail.edit', {
            parent: 'applied-services-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applied-services/applied-services-dialog.html',
                    controller: 'AppliedServicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppliedServices', function(AppliedServices) {
                            return AppliedServices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('applied-services.new', {
            parent: 'applied-services',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applied-services/applied-services-dialog.html',
                    controller: 'AppliedServicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                appliedDate: null,
                                serviceId: null,
                                ageing: null,
                                status: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('applied-services', null, { reload: 'applied-services' });
                }, function() {
                    $state.go('applied-services');
                });
            }]
        })
        .state('applied-services.edit', {
            parent: 'applied-services',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applied-services/applied-services-dialog.html',
                    controller: 'AppliedServicesDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['AppliedServices', function(AppliedServices) {
                            return AppliedServices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('applied-services', null, { reload: 'applied-services' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('applied-services.delete', {
            parent: 'applied-services',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applied-services/applied-services-delete-dialog.html',
                    controller: 'AppliedServicesDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['AppliedServices', function(AppliedServices) {
                            return AppliedServices.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('applied-services', null, { reload: 'applied-services' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('AppliedServices', AppliedServices);

    AppliedServices.$inject = ['$resource', 'DateUtils'];

    function AppliedServices ($resource, DateUtils) {
        var resourceUrl =  'api/applied-services/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.appliedDate = DateUtils.convertLocalDateFromServer(data.appliedDate);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.appliedDate = DateUtils.convertLocalDateToServer(copy.appliedDate);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.appliedDate = DateUtils.convertLocalDateToServer(copy.appliedDate);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AppliedServicesController', AppliedServicesController);

    AppliedServicesController.$inject = ['AppliedServices'];

    function AppliedServicesController(AppliedServices) {

        var vm = this;

        vm.appliedServices = [];

        loadAll();

        function loadAll() {
            AppliedServices.query(function(result) {
                vm.appliedServices = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApplicationstatusDialogController', ApplicationstatusDialogController);

    ApplicationstatusDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Applicationstatus'];

    function ApplicationstatusDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Applicationstatus) {
        var vm = this;

        vm.applicationstatus = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.applicationstatus.id !== null) {
                Applicationstatus.update(vm.applicationstatus, onSaveSuccess, onSaveError);
            } else {
                Applicationstatus.save(vm.applicationstatus, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:applicationstatusUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApplicationstatusDetailController', ApplicationstatusDetailController);

    ApplicationstatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Applicationstatus'];

    function ApplicationstatusDetailController($scope, $rootScope, $stateParams, previousState, entity, Applicationstatus) {
        var vm = this;

        vm.applicationstatus = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:applicationstatusUpdate', function(event, result) {
            vm.applicationstatus = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApplicationstatusDeleteController',ApplicationstatusDeleteController);

    ApplicationstatusDeleteController.$inject = ['$uibModalInstance', 'entity', 'Applicationstatus'];

    function ApplicationstatusDeleteController($uibModalInstance, entity, Applicationstatus) {
        var vm = this;

        vm.applicationstatus = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Applicationstatus.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('applicationstatus', {
            parent: 'entity',
            url: '/applicationstatus',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.applicationstatus.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/applicationstatus/applicationstatuses.html',
                    controller: 'ApplicationstatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationstatus');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('applicationstatus-detail', {
            parent: 'applicationstatus',
            url: '/applicationstatus/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.applicationstatus.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/applicationstatus/applicationstatus-detail.html',
                    controller: 'ApplicationstatusDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationstatus');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Applicationstatus', function($stateParams, Applicationstatus) {
                    return Applicationstatus.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'applicationstatus',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('applicationstatus-detail.edit', {
            parent: 'applicationstatus-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applicationstatus/applicationstatus-dialog.html',
                    controller: 'ApplicationstatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Applicationstatus', function(Applicationstatus) {
                            return Applicationstatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('applicationstatus.new', {
            parent: 'applicationstatus',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applicationstatus/applicationstatus-dialog.html',
                    controller: 'ApplicationstatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                department: null,
                                applicationUniqueNumebr: null,
                                proximityStatus: null,
                                status: null,
                                responseTime: null,
                                remarks: null,
                                nocFileUrl: null,
                                nocNumber: null,
                                fileName: null,
                                uniqueId: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('applicationstatus', null, { reload: 'applicationstatus' });
                }, function() {
                    $state.go('applicationstatus');
                });
            }]
        })
        .state('applicationstatus.edit', {
            parent: 'applicationstatus',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applicationstatus/applicationstatus-dialog.html',
                    controller: 'ApplicationstatusDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Applicationstatus', function(Applicationstatus) {
                            return Applicationstatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('applicationstatus', null, { reload: 'applicationstatus' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('applicationstatus.delete', {
            parent: 'applicationstatus',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/applicationstatus/applicationstatus-delete-dialog.html',
                    controller: 'ApplicationstatusDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Applicationstatus', function(Applicationstatus) {
                            return Applicationstatus.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('applicationstatus', null, { reload: 'applicationstatus' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Applicationstatus', Applicationstatus);

    Applicationstatus.$inject = ['$resource'];

    function Applicationstatus ($resource) {
        var resourceUrl =  'api/applicationstatuses/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApplicationstatusController', ApplicationstatusController);

    ApplicationstatusController.$inject = ['Applicationstatus'];

    function ApplicationstatusController(Applicationstatus) {

        var vm = this;

        vm.applicationstatuses = [];

        loadAll();

        function loadAll() {
            Applicationstatus.query(function(result) {
                vm.applicationstatuses = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApplicationLogsDialogController', ApplicationLogsDialogController);

    ApplicationLogsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'ApplicationLogs'];

    function ApplicationLogsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, ApplicationLogs) {
        var vm = this;

        vm.applicationLogs = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.applicationLogs.id !== null) {
                ApplicationLogs.update(vm.applicationLogs, onSaveSuccess, onSaveError);
            } else {
                ApplicationLogs.save(vm.applicationLogs, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:applicationLogsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApplicationLogsDetailController', ApplicationLogsDetailController);

    ApplicationLogsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'ApplicationLogs'];

    function ApplicationLogsDetailController($scope, $rootScope, $stateParams, previousState, entity, ApplicationLogs) {
        var vm = this;

        vm.applicationLogs = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:applicationLogsUpdate', function(event, result) {
            vm.applicationLogs = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApplicationLogsDeleteController',ApplicationLogsDeleteController);

    ApplicationLogsDeleteController.$inject = ['$uibModalInstance', 'entity', 'ApplicationLogs'];

    function ApplicationLogsDeleteController($uibModalInstance, entity, ApplicationLogs) {
        var vm = this;

        vm.applicationLogs = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            ApplicationLogs.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('application-logs', {
            parent: 'entity',
            url: '/application-logs',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.applicationLogs.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-logs/application-logs.html',
                    controller: 'ApplicationLogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationLogs');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('application-logs-detail', {
            parent: 'application-logs',
            url: '/application-logs/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'investhryApp.applicationLogs.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/application-logs/application-logs-detail.html',
                    controller: 'ApplicationLogsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('applicationLogs');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'ApplicationLogs', function($stateParams, ApplicationLogs) {
                    return ApplicationLogs.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'application-logs',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('application-logs-detail.edit', {
            parent: 'application-logs-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-logs/application-logs-dialog.html',
                    controller: 'ApplicationLogsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ApplicationLogs', function(ApplicationLogs) {
                            return ApplicationLogs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('application-logs.new', {
            parent: 'application-logs',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-logs/application-logs-dialog.html',
                    controller: 'ApplicationLogsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                user_role: null,
                                user_details: null,
                                path: null,
                                requestBody: null,
                                responseBody: null,
                                status: null,
                                params: null,
                                header: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('application-logs', null, { reload: 'application-logs' });
                }, function() {
                    $state.go('application-logs');
                });
            }]
        })
        .state('application-logs.edit', {
            parent: 'application-logs',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-logs/application-logs-dialog.html',
                    controller: 'ApplicationLogsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['ApplicationLogs', function(ApplicationLogs) {
                            return ApplicationLogs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-logs', null, { reload: 'application-logs' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('application-logs.delete', {
            parent: 'application-logs',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/application-logs/application-logs-delete-dialog.html',
                    controller: 'ApplicationLogsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['ApplicationLogs', function(ApplicationLogs) {
                            return ApplicationLogs.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('application-logs', null, { reload: 'application-logs' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ApplicationLogs', ApplicationLogs);

    ApplicationLogs.$inject = ['$resource'];

    function ApplicationLogs ($resource) {
        var resourceUrl =  'api/application-logs/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ApplicationLogsController', ApplicationLogsController);

    ApplicationLogsController.$inject = ['ApplicationLogs'];

    function ApplicationLogsController(ApplicationLogs) {

        var vm = this;

        vm.applicationLogs = [];

        loadAll();

        function loadAll() {
            ApplicationLogs.query(function(result) {
                vm.applicationLogs = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AcknowledgementsDialogController', AcknowledgementsDialogController);

    AcknowledgementsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Acknowledgements'];

    function AcknowledgementsDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Acknowledgements) {
        var vm = this;

        vm.acknowledgements = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.acknowledgements.id !== null) {
                Acknowledgements.update(vm.acknowledgements, onSaveSuccess, onSaveError);
            } else {
                Acknowledgements.save(vm.acknowledgements, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:acknowledgementsUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.lastactiontime = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AcknowledgementsDetailController', AcknowledgementsDetailController);

    AcknowledgementsDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Acknowledgements'];

    function AcknowledgementsDetailController($scope, $rootScope, $stateParams, previousState, entity, Acknowledgements) {
        var vm = this;

        vm.acknowledgements = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:acknowledgementsUpdate', function(event, result) {
            vm.acknowledgements = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AcknowledgementsDeleteController',AcknowledgementsDeleteController);

    AcknowledgementsDeleteController.$inject = ['$uibModalInstance', 'entity', 'Acknowledgements'];

    function AcknowledgementsDeleteController($uibModalInstance, entity, Acknowledgements) {
        var vm = this;

        vm.acknowledgements = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Acknowledgements.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('acknowledgements', {
            parent: 'entity',
            url: '/acknowledgements',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.acknowledgements.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/acknowledgements/acknowledgements.html',
                    controller: 'AcknowledgementsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('acknowledgements');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('acknowledgements-detail', {
            parent: 'acknowledgements',
            url: '/acknowledgements/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.acknowledgements.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/acknowledgements/acknowledgements-detail.html',
                    controller: 'AcknowledgementsDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('acknowledgements');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Acknowledgements', function($stateParams, Acknowledgements) {
                    return Acknowledgements.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'acknowledgements',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('acknowledgements-detail.edit', {
            parent: 'acknowledgements-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/acknowledgements/acknowledgements-dialog.html',
                    controller: 'AcknowledgementsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Acknowledgements', function(Acknowledgements) {
                            return Acknowledgements.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('acknowledgements.new', {
            parent: 'acknowledgements',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/acknowledgements/acknowledgements-dialog.html',
                    controller: 'AcknowledgementsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                source: null,
                                content: null,
                                lastactiontime: null,
                                error: null,
                                isSent: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('acknowledgements', null, { reload: 'acknowledgements' });
                }, function() {
                    $state.go('acknowledgements');
                });
            }]
        })
        .state('acknowledgements.edit', {
            parent: 'acknowledgements',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/acknowledgements/acknowledgements-dialog.html',
                    controller: 'AcknowledgementsDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Acknowledgements', function(Acknowledgements) {
                            return Acknowledgements.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('acknowledgements', null, { reload: 'acknowledgements' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('acknowledgements.delete', {
            parent: 'acknowledgements',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/acknowledgements/acknowledgements-delete-dialog.html',
                    controller: 'AcknowledgementsDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Acknowledgements', function(Acknowledgements) {
                            return Acknowledgements.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('acknowledgements', null, { reload: 'acknowledgements' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Acknowledgements', Acknowledgements);

    Acknowledgements.$inject = ['$resource', 'DateUtils'];

    function Acknowledgements ($resource, DateUtils) {
        var resourceUrl =  'api/acknowledgements/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.lastactiontime = DateUtils.convertDateTimeFromServer(data.lastactiontime);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AcknowledgementsController', AcknowledgementsController);

    AcknowledgementsController.$inject = ['Acknowledgements'];

    function AcknowledgementsController(Acknowledgements) {

        var vm = this;
        var step=1000;
        vm.limit=1000;

        vm.acknowledgements = [];

        loadAll();

        function loadAll() {
            Acknowledgements.query(function(result) {
                vm.acknowledgements = result;
                vm.searchQuery = null;
            });
        }

        vm.incrementSize=function () {
            vm.limit+=step;
        };

        vm.decrementSize=function () {
            vm.limit-=step;
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Above_groundDialogController', Above_groundDialogController);

    Above_groundDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Above_ground'];

    function Above_groundDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Above_ground) {
        var vm = this;

        vm.above_ground = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.above_ground.id !== null) {
                Above_ground.update(vm.above_ground, onSaveSuccess, onSaveError);
            } else {
                Above_ground.save(vm.above_ground, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:above_groundUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.created_on = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Above_groundDetailController', Above_groundDetailController);

    Above_groundDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Above_ground'];

    function Above_groundDetailController($scope, $rootScope, $stateParams, previousState, entity, Above_ground) {
        var vm = this;

        vm.above_ground = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:above_groundUpdate', function(event, result) {
            vm.above_ground = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Above_groundDeleteController',Above_groundDeleteController);

    Above_groundDeleteController.$inject = ['$uibModalInstance', 'entity', 'Above_ground'];

    function Above_groundDeleteController($uibModalInstance, entity, Above_ground) {
        var vm = this;

        vm.above_ground = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Above_ground.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('above-ground', {
            parent: 'entity',
            url: '/above-ground',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.above_ground.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/above-ground/above-grounds.html',
                    controller: 'Above_groundController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('above_ground');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('above-ground-detail', {
            parent: 'above-ground',
            url: '/above-ground/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.above_ground.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/above-ground/above-ground-detail.html',
                    controller: 'Above_groundDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('above_ground');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Above_ground', function($stateParams, Above_ground) {
                    return Above_ground.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'above-ground',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('above-ground-detail.edit', {
            parent: 'above-ground-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/above-ground/above-ground-dialog.html',
                    controller: 'Above_groundDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Above_ground', function(Above_ground) {
                            return Above_ground.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('above-ground.new', {
            parent: 'above-ground',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/above-ground/above-ground-dialog.html',
                    controller: 'Above_groundDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                name_applicant: null,
                                registered_address: null,
                                har_office_address: null,
                                designation_auth_person: null,
                                phone_auth_person: null,
                                email_auth_person: null,
                                extent: null,
                                address_line_1: null,
                                address_line_2: null,
                                address_line_3: null,
                                address_line_4: null,
                                tehsil: null,
                                district: null,
                                latitude_longitude: null,
                                name_auth_person: null,
                                zone_area: null,
                                owner_name: null,
                                owner_address: null,
                                tower_height: null,
                                tower_weight: null,
                                tower_type1: null,
                                tower_type2: null,
                                tower_type3: null,
                                tower_antena_no: null,
                                tower_lat_long: null,
                                other_info1: null,
                                other_info2: null,
                                other_info3: null,
                                other_info4: null,
                                other_info5: null,
                                other_info6: null,
                                fee_details: null,
                                document1: null,
                                document2: null,
                                document3: null,
                                document4: null,
                                document5: null,
                                document6: null,
                                document7: null,
                                document8: null,
                                document9: null,
                                document10: null,
                                document11: null,
                                other_document1: null,
                                other_document2: null,
                                other_document3: null,
                                other_document4: null,
                                other_document5: null,
                                isfullyfilled: null,
                                status: null,
                                isforwardedtodio: null,
                                isforwardedtodept: null,
                                isforwardedtodc: null,
                                clearancefile1: null,
                                clearancefile2: null,
                                clearancefile3: null,
                                created_by: null,
                                created_on: null,
                                isexisting: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('above-ground', null, { reload: 'above-ground' });
                }, function() {
                    $state.go('above-ground');
                });
            }]
        })
        .state('above-ground.edit', {
            parent: 'above-ground',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/above-ground/above-ground-dialog.html',
                    controller: 'Above_groundDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Above_ground', function(Above_ground) {
                            return Above_ground.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('above-ground', null, { reload: 'above-ground' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('above-ground.delete', {
            parent: 'above-ground',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/above-ground/above-ground-delete-dialog.html',
                    controller: 'Above_groundDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Above_ground', function(Above_ground) {
                            return Above_ground.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('above-ground', null, { reload: 'above-ground' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Above_ground', Above_ground);

    Above_ground.$inject = ['$resource', 'DateUtils'];

    function Above_ground ($resource, DateUtils) {
        var resourceUrl =  'api/above-grounds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created_on = DateUtils.convertLocalDateFromServer(data.created_on);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.created_on = DateUtils.convertLocalDateToServer(copy.created_on);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.created_on = DateUtils.convertLocalDateToServer(copy.created_on);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('Above_groundController', Above_groundController);

    Above_groundController.$inject = ['Above_ground'];

    function Above_groundController(Above_ground) {

        var vm = this;

        vm.above_grounds = [];

        loadAll();

        function loadAll() {
            Above_ground.query(function(result) {
                vm.above_grounds = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AaiDialogController', AaiDialogController);

    AaiDialogController.$inject = ['$rootScope', '$state', '$timeout', '$scope', '$stateParams', 'entity', 'Aai_service', 'ConstructionPermitApprovalSteps', 'ConstructionPermitApproval', 'ConstructionPermitLog'];

    function AaiDialogController ($rootScope, $state, $timeout, $scope, $stateParams, entity, Aai_service, ConstructionPermitApprovalSteps, ConstructionPermitApproval, ConstructionPermitLog) {
        var vm = this;

        vm.aai = entity;
        vm.clear = clear;
        vm.save = save;
        vm.constructionPermit={};
        vm.constructionPermitLog={};
        vm.id = $stateParams.CPid;

        // console.log($stateParams);

        loadAll();

        function loadAll() {
            ConstructionPermitApproval.query({projectId: $stateParams.id},function (result) {
                vm.constructionPermit= result;
            })
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            // $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.aai.id !== null) {
                Aai_service.update(vm.aai, onSaveSuccess, onSaveError);
            } else {
                Aai_service.save(vm.aai, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            vm.constructionPermit.aAIflag=true;
            vm.constructionPermit.aAIid=result.id;
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onFirstSaveSuccess);
            // $uibModalInstance.close(result);
            // $state.go('nma-state');
            vm.isSaving = false;
        }

        function onFirstSaveSuccess() {
            vm.constructionPermitLog.action="Form Submitted";
            vm.constructionPermitLog.projectid= $stateParams.id;
            vm.constructionPermitLog.serviceid= '16b4d378-5723-4adc-85e9-de55da296008';
            ConstructionPermitLog.save(vm.constructionPermitLog,onSecondSaveSuccess)
        }

        function onSecondSaveSuccess() {
            vm.constructionPermitLog.action="Service Under Process";
            ConstructionPermitLog.save(vm.constructionPermitLog,onCPsavesuccess)
        }

        function onCPsavesuccess() {
            $rootScope.$broadcast("investhry: constructionPermitEvent");
        }

        function onSaveError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AaiDetailController', AaiDetailController);

    AaiDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Aai'];

    function AaiDetailController($scope, $rootScope, $stateParams, previousState, entity, Aai) {
        var vm = this;

        vm.aai = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:aaiUpdate', function(event, result) {
            vm.aai = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AaiDeleteController',AaiDeleteController);

    AaiDeleteController.$inject = ['$uibModalInstance', 'entity', 'Aai'];

    function AaiDeleteController($uibModalInstance, entity, Aai) {
        var vm = this;

        vm.aai = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Aai.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('aai', {
            parent: 'entity',
            url: '/aai',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.aai.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aai/aais.html',
                    controller: 'AaiController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aai');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('aai-detail', {
            parent: 'aai',
            url: '/aai/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'investhryApp.aai.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aai/aai-detail.html',
                    controller: 'AaiDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aai');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Aai', function($stateParams, Aai) {
                    return Aai.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'aai',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('aai-detail.edit', {
            parent: 'aai-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aai/aai-dialog.html',
                    controller: 'AaiDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aai', function(Aai) {
                            return Aai.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state("nma-state",{
            parent: 'constructionpermit',
            url: '/nma/{CPid}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_RM','ROLE_NODAL_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
            },
            views: {
                'nestedForm@constructionpermit': {
                    templateUrl: 'app/entities/nma/nma-dialog.html',
                    controller: 'NmaDialogController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        department: null,
                        architectName: null,
                        architectEmail: null,
                        architectMobile: null,
                        nocRequestScreen: null,
                        nameOfApplicant: null,
                        presentAddress: null,
                        permanentAddress: null,
                        isOwner: null,
                        nameOfOwner: null,
                        presentAddressOwner: null,
                        permanentAddressOwner: null,
                        typeOwner1: null,
                        typeOwner2: null,
                        typeOwner3: null,
                        plotNo: null,
                        state: null,
                        district: null,
                        taulk: null,
                        locality: null,
                        monumentName: null,
                        stateMonument: null,
                        districtMonument: null,
                        taulkMonument: null,
                        localityMonument: null,
                        distance1: null,
                        distance2: null,
                        workDetails1: null,
                        workDetails2: null,
                        workDetails3: null,
                        workDetails4: null,
                        workDetails5: null,
                        workDetails6: null,
                        workDetails7: null,
                        workDetails8: null,
                        workDetails9: null,
                        workDetails10: null,
                        workDetails11: null,
                        workDetails12: null,
                        otherWorkDetails1: null,
                        otherWorkDetails2: null,
                        otherWorkDetails3: null,
                        otherWorkDetails4: null,
                        otherWorkDetails5: null,
                        otherWorkDetails6: null,
                        otherWorkDetails7: null,
                        otherWorkDetails8: null,
                        id: null
                    };
                }
            }
        })
        .state('aai.new', {
            parent: 'aai',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aai/aai-dialog.html',
                    controller: 'AaiDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                height_clearance: null,
                                nameOfAplicant: null,
                                addressOfApplicant: null,
                                mobile_no: null,
                                email_id: null,
                                nameOfOwner: null,
                                addressOfCommunication: null,
                                typeOfStructure: null,
                                usesOfStructure: null,
                                siteDescription: null,
                                sizeOfPlot: null,
                                state: null,
                                areaName: null,
                                latitude1: null,
                                latitude2: null,
                                latitude3: null,
                                longitude1: null,
                                longitude2: null,
                                longitude3: null,
                                siteElevation: null,
                                buildingHeight: null,
                                maxSiteElevation: null,
                                question1: null,
                                question2: null,
                                question3: null,
                                file1: null,
                                city: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('aai', null, { reload: 'aai' });
                }, function() {
                    $state.go('aai');
                });
            }]
        })
        .state('aai.edit', {
            parent: 'aai',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aai/aai-dialog.html',
                    controller: 'AaiDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aai', function(Aai) {
                            return Aai.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aai', null, { reload: 'aai' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('aai.delete', {
            parent: 'aai',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aai/aai-delete-dialog.html',
                    controller: 'AaiDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Aai', function(Aai) {
                            return Aai.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aai', null, { reload: 'aai' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Aai_service', Aai_service);

    Aai_service.$inject = ['$resource'];

    function Aai_service ($resource) {
        var resourceUrl =  'api/aais/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AaiController', AaiController);

    AaiController.$inject = ['Aai'];

    function AaiController(Aai) {

        var vm = this;

        vm.aais = [];

        loadAll();

        function loadAll() {
            Aai.query(function(result) {
                vm.aais = result;
                vm.searchQuery = null;
            });
        }
    }
})();

// (function() {
//     'use strict';
//
//     angular
//         .module('investhryApp')
//         .config(stateConfig);
//
//     stateConfig.$inject = ['$stateProvider'];
//
//     function stateConfig($stateProvider) {
//         $stateProvider.state('tower-removal-apply', {
//             parent: 'app',
//             url: '/tower-removal-apply',
//             data: {
//                 authorities: [],
//                 pageTitle: 'global.menu.third-party-inspection'
//             },
//             views: {
//                 'content@': {
//                     templateUrl: 'app/tower-removal/tower-removal-apply.html',
//                     controller: 'TowerRemovalApplyController',
//                     controllerAs: 'vm'
//                 }
//             },
//             resolve: {
//                 translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                     $translatePartialLoader.addPart('tower-removal-apply');
//                     return $translate.refresh();
//                 }]
//             }
//         }),
//             $stateProvider.state('tower-removal-view', {
//                 parent: 'app',
//                 url: '/tower-removal-view',
//                 data: {
//                     authorities: [],
//                     pageTitle: 'global.menu.tower-removal-view'
//                 },
//                 views: {
//                     'content@': {
//                         templateUrl: 'app/tower-removal/tower-removal-view.html',
//                         controller: 'TowerRemovalViewController',
//                         controllerAs: 'vm'
//                     }
//                 },
//                 resolve: {
//                     translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
//                         $translatePartialLoader.addPart('tower-removal-view');
//                         return $translate.refresh();
//                     }]
//                 }
//             });
//     }
// })();
//






(function () {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        // ===============================
        // USER APPLY PAGE
        // ===============================
        $stateProvider.state('edit-caf-requests', {
            parent: 'app',
            url: '/edit-caf-requests',
            data: {
                authorities: [],
                // pageTitle: 'Caf Edit Requests'
                pageTitle: 'global.menu.caf.edit.requests'

            },
            views: {
                'content@': {
                    templateUrl: 'app/edit-caf-details/edit-caf-details.html',
                    controller: 'CafEditController',
                    controllerAs: 'vm'
                }
            }
        });

        // ===============================
        // ADMIN VIEW / APPROVAL PAGE
        // ===============================
        $stateProvider.state('project-edit-view', {
            parent: 'app',
            url: '/project-edit-view',
            data: {
                authorities: [],
                // pageTitle: 'Project Edit Approval'
                pageTitle: 'global.menu.project.edit.approval'

            },
            views: {
                'content@': {
                    templateUrl: 'app/project-edit/project-edit-view.html',
                    controller: 'ProjectEditApprovalController',
                    controllerAs: 'vm'
                }
            }
        });

    }

})();



(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('ProjectEditByUserService', ProjectEditByUserService);

    ProjectEditByUserService.$inject = ['$resource'];

    function ProjectEditByUserService($resource) {

        var resourceUrl = 'api/project-edit/:id';

        return $resource(resourceUrl, { id: '@id' }, {

            // =========================
            // GET ALL (Your API)
            // =========================
            'query': {
                method: 'GET',
                isArray: true
            },

            // =========================
            // GET SINGLE
            // =========================
            'get': {
                method: 'GET'
            },

            // =========================
            // CREATE
            // =========================
            'save': {
                method: 'POST'
            },

            // =========================
            // UPDATE
            // =========================



            'update': {
                method: 'PUT',
                url: 'api/project-edit'
            }
        });
    }
})();


(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafEditController', CafEditController);

    CafEditController.$inject = ['$scope', 'ProjectEditByUserService','$http','Principal']

    function CafEditController($scope, ProjectEditByUserService,$http,Principal) {

        var vm = this;
        vm.logs = [];


        vm.applications = [];

        // ==========================
        // LOAD ALL EDIT APPLICATIONS
        // ==========================
        vm.loadAll = function () {


            ProjectEditByUserService.query(function (result) {
                vm.applications = result;
                console.log("application are"+vm.applications);
                sortApplications()


                // alert(applications)
            });



            // $http.get('api/project-edit-log')
            //
            //     .then(function (response) {
            //
            //         vm.applications = response.data;
            //
            //         // open modal
            //
            //     }, function (error) {
            //
            //         console.error("Error fetching data:", error);
            //
            //     });
        };

        // Load on page open
        // vm.loadAll();


        // ==========================
        // APPROVE / REJECT FUNCTION
        // ==========================
        // vm.updateStatus = function (app, status) {
        //
        //     if (!confirm("Are you sure you want to " + status + " this application?")) {
        //         return;
        //     }
        //
        //     var payload = angular.copy(app);
        //     payload.status = status;
        //
        //     ProjectEditByUserService.update(payload,
        //         function success() {
        //             alert("Application " + status + " successfully");
        //             vm.loadAll(); // refresh table
        //         },
        //         function error(response) {
        //
        //             if (response.data && response.data.message) {
        //                 alert(response.data.message);
        //             } else {
        //                 alert("Status update failed");
        //
        //
        //             }
        //         }
        //     );
        // };
        //

        vm.updateStatus = function (app, status) {

            vm.selectedApp = app;
            vm.selectedStatus = status;
            vm.statusComments = '';

            $('#statusModal').modal('show');
        };



        vm.confirmStatusUpdate = function () {

            var payload = angular.copy(vm.selectedApp);
            payload.status = vm.selectedStatus;
            payload.comments = vm.statusComments;




            ProjectEditByUserService.update(payload,
                function success() {

                    alert("Application " + vm.selectedStatus + " successfully");

                    $('#statusModal').modal('hide');

                    vm.loadAll(); // refresh table
                },
                function error(response) {

                    if (response.data && response.data.message) {
                        alert(response.data.message);
                    } else {
                        alert("Status update failed");
                    }
                }
            );
        };




        Principal.identity().then(function(account) {

            vm.account = account;
            // alert(vm.account.authorities);

            // if (vm.account.authorities.includes("ROLE_USER")) {


                if (
                    vm.account.authorities.includes("ROLE_USER") &&
                    !vm.account.authorities.includes("ROLE_ADMIN") &&
                    !vm.account.authorities.includes("ROLE_SUB_ADMIN")
                ){
                $http.get('api/project-edit/findByLogin')

                    .then(function (response) {

                        vm.applications=response.data;
                        sortApplications()
                        console.log(vm.applications)

                        // open modal

                    }, function (error) {

                        console.error("Error fetching logs:", error);

                    });

            } else {
                // alert("admin else"+vm.account.authorities);
                vm.loadAll();


            }
        });

        function sortApplications() {

            var statusPriority = {
                'PENDING': 1,
                'APPROVED': 2,
                'REJECTED': 3
            };

            vm.applications.sort(function (a, b) {

                if (statusPriority[a.status] !== statusPriority[b.status]) {
                    return (statusPriority[a.status] || 99) - (statusPriority[b.status] || 99);
                }

                // Same status → latest first
                return new Date(b.createdat) - new Date(a.createdat);
            });
        }



        vm.viewLogs = function (cafpin) {

            vm.selectedCafpin = cafpin;   // ✅ store separately

            $http.get('api/project-edit-log/by-cafpin/' + cafpin)

                .then(function (response) {

                    vm.logs = response.data;
                    console.log(vm.logs)

                    // open modal
                    $('#logsModal').modal('show');

                }, function (error) {

                    console.error("Error fetching logs:", error);

                });
        };




        vm.downloadCSV = function () {

            if (!vm.applications || vm.applications.length === 0) {
                alert("No data available");
                return;
            }

            var csv = [];

            // Header Row
            var headers = [
                "CAF PIN",
                "CAF Type",
                "Old Business Entity",
                "New Business Entity",
                "Old Business Type",
                "New Business Type",
                "Old District",
                "New District",
                "Old Village",
                "New Village",
                "Old Block Category",
                "New Block Category",
                "Old Site Address",
                "New Site Address",
                "Status",
                "Applied Date"
            ];

            csv.push(headers.join(","));

            // Data Rows
            vm.applications.forEach(function (app) {

                var row = [
                    app.cafpin || "NA",
                    app.caftype || "NA",
                    app.oldbusinessentity || "NA",
                    app.newbusinessentity || "NA",
                    app.oldBusinessEntityType || "NA",
                    app.newBusinessEntityType || "NA",
                    app.oldDistrict || "NA",
                    app.newDistrict || "NA",
                    app.oldVillage || "NA",
                    app.newVillage || "NA",
                    app.oldBlockCategory || "NA",
                    app.newBlockCategory || "NA",
                    app.oldSiteAddress || "NA",
                    app.newSiteAddress || "NA",
                    app.status || "NA",
                    app.createdat ? new Date(app.createdat).toLocaleString() : "NA"
                ];

                csv.push(row.join(","));
            });

            // Create CSV File
            var csvContent = "data:text/csv;charset=utf-8," + csv.join("\n");

            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);


            var now = new Date();

// Format: YYYY-MM-DD_HH-MM-SS
            var timestamp = now.getFullYear() + "-" +
                String(now.getMonth() + 1).padStart(2, '0') + "-" +
                String(now.getDate()).padStart(2, '0') + "_" +
                String(now.getHours()).padStart(2, '0') + "-" +
                String(now.getMinutes()).padStart(2, '0') + "-" +
                String(now.getSeconds()).padStart(2, '0');

            link.setAttribute("download", "caf_change_requests_" + timestamp + ".csv");
            // link.setAttribute("download", "caf_change_requests.csv");

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };







        vm.downloadLogsCSV = function () {

            if (!vm.logs || vm.logs.length === 0) {
                alert("No logs available");
                return;
            }

            var csv = [];

            // Header Row
            var headers = [
                "Old Business Entity",
                "New Business Entity",
                "Old Business Type",
                "New Business Type",
                "Old District",
                "New District",
                "Old Village",
                "New Village",
                "Old Block Category",
                "New Block Category",
                "Old Site Address",
                "New Site Address",
                "Action Taken",
                "Action Taken By",
                "Created At",
                "Comments"
            ];

            csv.push(headers.join(","));

            // Data Rows
            vm.logs.forEach(function (log) {

                var row = [
                    log.oldbusinessentity || "NA",
                    log.newbusinessentity || "NA",
                    log.oldBusinessEntityType || "NA",
                    log.newBusinessEntityType || "NA",
                    log.oldDistrict || "NA",
                    log.newDistrict || "NA",
                    log.oldVillage || "NA",
                    log.newVillage || "NA",
                    log.oldBlockCategory || "NA",
                    log.newBlockCategory || "NA",
                    log.oldSiteAddress || "NA",
                    log.newSiteAddress || "NA",
                    log.actiontaken || "NA",
                    log.actiontakenby || "NA",
                    log.createdat ? new Date(log.createdat).toLocaleString() : "NA",
                    log.comments || "NA"
                ];

                // Wrap values in quotes (important for addresses/commas)
                csv.push(row.map(function(value){
                    return '"' + value + '"';
                }).join(","));
            });

            // Create CSV File
            var csvContent = "data:text/csv;charset=utf-8," + csv.join("\n");

            var encodedUri = encodeURI(csvContent);
            var link = document.createElement("a");
            link.setAttribute("href", encodedUri);



            var now = new Date();

// Format: YYYY-MM-DD_HH-MM-SS
            var timestamp = now.getFullYear() + "-" +
                String(now.getMonth() + 1).padStart(2, '0') + "-" +
                String(now.getDate()).padStart(2, '0') + "_" +
                String(now.getHours()).padStart(2, '0') + "-" +
                String(now.getMinutes()).padStart(2, '0') + "-" +
                String(now.getSeconds()).padStart(2, '0');

            link.setAttribute("download", "caf_edit_logs_" + timestamp + ".csv");

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        };

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('draftCAF', {
            parent: 'app',
            url: '/draftCAF',
            data: {
                authorities: ["ROLE_ADMIN","ROLE_SUB_ADMIN"]
            },
            views: {
                'content@': {
                    templateUrl: 'app/draftCAF/draftCAF.html',
                    controller: 'DraftCAFController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        });

        }
        })();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DraftCAF', DraftCAF);

    DraftCAF.$inject = ['$resource'];

    function DraftCAF ($resource) {
        var resourceUrl =  '/api/draftCAF';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DraftCAFController', DraftCAFController);

    DraftCAFController.$inject = ['$scope',  'Principal', 'LoginService',  '$state', 'DraftCAF','Project','DeleteDraftCAF'];

    function DraftCAFController ($scope,  Principal, LoginService, $state, DraftCAF, Project, DeleteDraftCAF) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.showtable=false;
        vm.project=[];
        vm.deleteId = null;
        vm.deleteCaf=deleteCaf;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });


        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        loadDraftCAF();
        function loadDraftCAF()
        {
            vm.project=null;
            vm.showtable=false;
            DraftCAF.query(function(result){
                vm.project = result;
                if(vm.project.length === 0){
                    vm.showtable=false;
                }
                else {
                    vm.showtable=true;
                }
        });
        }

        vm.modalCaf = function(id){
          $('#deleteModal').modal('show');
          vm.deleteId = id;
        };

        function deleteCaf(id) {
            $('#deleteModal').modal('hide');
            Project.delete({id: vm.deleteId},
            function(){
            loadDraftCAF();
                });
        }

        vm.DeleteCaf = function () {
               console.log(vm.project);
               DeleteDraftCAF.get();
               location.reload();
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DeleteDraftCAF', DeleteDraftCAF);

    DeleteDraftCAF.$inject = ['$resource'];

    function DeleteDraftCAF ($resource) {
        var resourceUrl =  '/api/deleteDraftCAF';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

// (function () {
//     'use strict';
//
//     angular
//         .module('investhryApp')
//         .config(stateConfig);
//
//     stateConfig.$inject = ['$stateProvider'];
//
//     function stateConfig($stateProvider) {
//
//         $stateProvider.state('document-center', {
//             parent: 'app',
//             url: '/document-center',
//             data: {
//                 authorities: [],
//                 pageTitle: 'Document Center'
//             },
//             views: {
//                 'content@': {
//                     templateUrl: 'app/document-center/document-center.html',
//                     controller: 'DocumentCenterController',
//                     controllerAs: 'vm'
//                 }
//             }
//         });
//     }
// })();



(function () {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {

        $stateProvider.state('document-center', {
            parent: 'app',
            url: '/document-center',
            data: {
                authorities: [],
                pageTitle: 'Document Center'
            },
            views: {
                'content@': {
                    templateUrl: 'app/document-center/document-center.html',
                    controller: 'DocumentCenterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: [
                    '$translate',
                    '$translatePartialLoader',
                    function ($translate, $translatePartialLoader) {

                        // 🔥 REQUIRED for navbar translations
                        $translatePartialLoader.addPart('global');

                        // (optional, if you create i18n for this page)
                        // $translatePartialLoader.addPart('document-center');

                        return $translate.refresh();
                    }
                ]
            }
        });
    }
})();

// (function () {
//     'use strict';
//
//     angular
//         .module('investhryApp')
//         .factory('DocumentCenterService', DocumentCenterService);
//
//     DocumentCenterService.$inject = ['$resource'];
//
//     function DocumentCenterService($resource) {
//
//         return $resource('', {}, {
//
//             // Fetch issued documents
//             getIssuedDocuments: {
//                 method: 'GET',
//                 url: 'api/entity-locker/issued-documents'
//             },
//
//             getSelfUploadedDocs: {
//                 method: 'GET',
//                 url: 'api/entity-locker/self-uploaded-docs'
//             },
//
//
//             // Download file by URI
//             downloadFile: {
//                 method: 'GET',
//                 url: 'api/file/:uri',
//                 responseType: 'arraybuffer',
//                 params: {
//                     uri: '@uri'
//                 }
//             }
//         });
//     }
// })();


(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('DocumentCenterService', DocumentCenterService);

    DocumentCenterService.$inject = ['$resource', '$http'];

    function DocumentCenterService($resource, $http) {

        var resource = $resource('', {}, {

            // Fetch issued documents
            getIssuedDocuments: {
                method: 'GET',
                url: 'api/entity-locker/issued-documents'
            },

            getIssuedDocumentsFromDigilocker: {
                method: 'GET',
                url: 'api/digilocker/issued-documents'
            },
            // Fetch self uploaded documents
            getSelfUploadedDocs: {
                method: 'GET',
                url: 'api/entity-locker/self-uploaded-docs'
            },


            getSelfUploadedDocsFromDigilocker: {
                method: 'GET',
                url: 'api/digilocker/self-uploaded-docs'
            },


        });


        resource.checkDLTokenStatus = function () {
            console.log("checkDLTokenStatus() called");
            return $http.get('/api/entity-locker/token-status');
        };

        resource.checkDLTokenStatusForDigilocker = function () {
            console.log("checkDLTokenStatus() called");
            return $http.get('/api/digilocker/token-status');
        };



        // ✅ ADD THIS METHOD
        resource.uploadFile = function (file, path) {

            var formData = new FormData();
            formData.append('file', file);

            return $http.post(
                'api/entity-locker/upload',
                formData,
                {
                    params: { path: path }, // sent as request param
                    headers: {
                        'Content-Type': undefined
                    },
                    transformRequest: angular.identity
                }
            );
        };

        return resource;
    }
})();



(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DocumentCenterController', DocumentCenterController);

    DocumentCenterController.$inject = ['DocumentCenterService','LoginService','$http','$window'
    ];


    function DocumentCenterController(DocumentCenterService,LoginService,$http,$window
    ) {
        // $window.location.reload();

        var vm = this;


        vm.documents = [];
        vm.loading = false;
        vm.documentType = ""; // <-- NEW
        vm.showEntityLocker = true; // default show
        vm.showDigiLocker = true; // default show
        vm.lastFetchSource = null; // 'ENTITY' | 'DIGI'





        DocumentCenterService.checkDLTokenStatus()
            .then(function (resp) {
                // hide menu if token exists
                vm.showEntityLocker = !resp.data;

            })
            .catch(function () {
                vm.showEntityLocker = true;
            });



        DocumentCenterService.checkDLTokenStatusForDigilocker()
            .then(function (resp) {
                // hide menu if token exists
                vm.showDigiLocker = !resp.data;

            })
            .catch(function () {
                vm.showDigiLocker = true;
            });






        vm.fetchIssuedDocuments = function () {
            vm.lastFetchSource = 'ENTITY';

            vm.loading = true;
            vm.documentType = "Issued Documents";

            DocumentCenterService.getIssuedDocuments(
                function (response) {
                    // ✅ Success case (200)
                    vm.documents = response.items || [];
                    vm.loading = false;
                    if (response.code === "DL_TOKEN_MISSING") {
                        alert("Please login to entity locker again");
                        // window.location.assign(response.redirectUrl);


                        vm.openEntityLocker()


                        return;
                    }
                },
                function (error) {
                    console.error("HTTP error", error);

                    vm.loading = false;
                    alert("Failed to fetch issued documents");
                }
            );
        };


        //
        // vm.fetchIssuedDocuments = function () {
        //     vm.lastFetchSource = 'ENTITY';
        //
        //     vm.loading = true;
        //     vm.documentType = "Issued Documents";
        //
        //     DocumentCenterService.getIssuedDocuments(
        //         function (response) {
        //             // ✅ Success case (200)
        //             vm.documents = response.items || [];
        //             vm.loading = false;
        //             if (response.code === "DL_TOKEN_MISSING") {
        //                 alert("Please login to entity locker again");
        //                 // window.location.assign(response.redirectUrl);
        //
        //
        //                 vm.openEntityLocker()
        //
        //
        //                 return;
        //             }
        //         },
        //         function (error) {
        //             console.error("HTTP error", error);
        //
        //             vm.loading = false;
        //             alert("Failed to fetch issued documents");
        //         }
        //     );
        // };



        vm.fetchIssuedDocumentsFromDigilcoker = function () {
            vm.lastFetchSource = 'DIGI';

            vm.loading = true;
            vm.documentType = "Issued Documents(DigiLocker)";

            DocumentCenterService.getIssuedDocumentsFromDigilocker(
                function (response) {
                    // ✅ Success case (200)
                    vm.documents = response.items || [];
                    vm.loading = false;
                    if (response.code === "DL_TOKEN_MISSING") {
                        alert("Please login to entity locker again");
                        // window.location.assign(response.redirectUrl);


                        vm.openDigiLocker()


                        return;
                    }
                },
                function (error) {
                    console.error("HTTP error", error);

                    vm.loading = false;
                    alert("Failed to fetch issued documents");
                }
            );
        };



        vm.fetchSelfUploaded = function () {
            vm.lastFetchSource = 'ENTITY';

            vm.loading = true;
            vm.documentType = "Enterprise Vault Documents";
            vm.documents = [];

            DocumentCenterService.getSelfUploadedDocs(
                function (response) {

                    // 🔐 DigiLocker token missing
                    if (response.code === "DL_TOKEN_MISSING") {
                        alert("Please login to digi locker again");
                        // window.location.assign(response.redirectUrl);


                        vm.openEntityLocker()


                        return;
                    }

                    vm.documents = response.items || [];
                    vm.loading = false;
                },
                function (error) {
                    console.error("HTTP error", error);
                    vm.loading = false;
                    alert("Failed to fetch issued documents");
                }
            );
        };




        vm.fetchSelfUploadedFromDigiLocker = function () {
            vm.lastFetchSource = 'DIGI';
            vm.loading = true;
            vm.documentType = " Drive Documents(Digilocker)";
            vm.documents = [];



            DocumentCenterService.getSelfUploadedDocsFromDigilocker(
                function (response) {

                    // 🔐 DigiLocker token missing
                    if (response.code === "DL_TOKEN_MISSING") {
                        alert("Please login to digilocker locker again");
                        // window.location.assign(response.redirectUrl);


                        vm.openDigiLocker()


                        return;
                    }

                    vm.documents = response.items || [];
                    vm.loading = false;
                },
                function (error) {
                    console.error("HTTP error", error);
                    vm.loading = false;
                    alert("Failed to fetch issued documents");
                }
            );
        };

        vm.openEntityLocker = function () {

            // $http.get('/api/entity-locker/authorisation-request')
            //     .then(function (response) {
            //         alert("hello 2");
            //         console.log("AUTH URL:", response.data);
            //         $window.location.href = response.data;
            //     })
            //     .catch(function (error) {
            //         alert("ERROR");
            //         console.error("Authorization API error:", error);
            //     });

            $http.get('/api/entity-locker/authorisation-request', {
                responseType: 'text'
            })
                .then(function (response) {
                    console.log("AUTH URL:", response.data);
                    $window.location.href = response.data;
                })
                .catch(function (error) {
                    console.error("Authorization API error:", error);
                });

        };


        vm.openDigiLocker = function () {


            $http.get('/api/digilocker/authorisation-request', {
                responseType: 'text'
            })
                .then(function (response) {
                    console.log("AUTH URL:", response.data);
                    $window.location.href = response.data;
                })
                .catch(function (error) {
                    console.error("Authorization API error:", error);
                });

        };



        vm.downloadFileFromEntitylocker = function (uri) {

            $http({
                method: 'GET',
                url: '/api/entity-locker/getdoc/' + encodeURIComponent(uri),
                responseType: 'blob'
            }).then(function (response) {

                var contentType = response.headers('Content-Type') || 'application/octet-stream';
                var blob = new Blob([response.data], { type: contentType });

                var fileName = null;

                var contentDisposition = response.headers('Content-Disposition');
                if (contentDisposition) {

                    // ✅ RFC 5987: filename*=UTF-8''file.name.pdf
                    var utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/i);
                    if (utf8Match && utf8Match[1]) {
                        fileName = decodeURIComponent(utf8Match[1]);
                    } else {
                        // ✅ Classic: filename="file.name.pdf"
                        var normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
                        if (normalMatch && normalMatch[1]) {
                            fileName = normalMatch[1];
                        }
                    }
                }

                // ✅ Fallback name
                if (!fileName) {
                    fileName = 'downloaded_file';
                }

                // 🔐 FINAL GUARANTEE (this fixes Windows issue)
                if (
                    contentType.toLowerCase().includes('application/pdf') &&
                    !fileName.toLowerCase().endsWith('.pdf')
                ) {
                    fileName += '.pdf';
                }

                var url = window.URL.createObjectURL(blob);

                var a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);

            }, function (error) {
                if (error.status === 401 || error.status === 302) {
                    window.location.href = '/api/entity-locker/authorisation-request';
                } else {
                    alert('Failed to download document');
                }
            });
        };


        vm.downloadFileFromDigilocker = function (uri) {

            $http({
                method: 'GET',
                url: '/api/digilocker/getdoc/' + encodeURIComponent(uri),
                responseType: 'blob'
            }).then(function (response) {

                var contentType = response.headers('Content-Type') || 'application/octet-stream';
                var blob = new Blob([response.data], { type: contentType });

                var fileName = null;

                var contentDisposition = response.headers('Content-Disposition');
                if (contentDisposition) {

                    // ✅ RFC 5987: filename*=UTF-8''file.name.pdf
                    var utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+)/i);
                    if (utf8Match && utf8Match[1]) {
                        fileName = decodeURIComponent(utf8Match[1]);
                    } else {
                        // ✅ Classic: filename="file.name.pdf"
                        var normalMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
                        if (normalMatch && normalMatch[1]) {
                            fileName = normalMatch[1];
                        }
                    }
                }

                // ✅ Fallback name
                if (!fileName) {
                    fileName = 'downloaded_file';
                }

                // 🔐 FINAL GUARANTEE (this fixes Windows issue)
                if (
                    contentType.toLowerCase().includes('application/pdf') &&
                    !fileName.toLowerCase().endsWith('.pdf')
                ) {
                    fileName += '.pdf';
                }

                var url = window.URL.createObjectURL(blob);

                var a = document.createElement('a');
                a.href = url;
                a.download = fileName;
                document.body.appendChild(a);
                a.click();

                document.body.removeChild(a);
                window.URL.revokeObjectURL(url);

            }, function (error) {
                if (error.status === 401 || error.status === 302) {
                    window.location.href = '/api/entity-locker/authorisation-request';
                } else {
                    alert('Failed to download document');
                }
            });
        };


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ViewDisputeLogController', ViewDisputeLogController);

    ViewDisputeLogController.$inject = ['$scope', '$state', '$uibModalInstance', '$stateParams', 'Principal', 'LoginService', 'Disputelog','dispute','downloadService','viewRecruitmentFile'];

    function ViewDisputeLogController ($scope, $state, $uibModalInstance, $stateParams, Principal, LoginService, Disputelog, dispute, downloadService, viewRecruitmentFile) {
        var vm = this;
        vm.dispute = dispute;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.downloadFile = downloadFile;
        vm.id= $stateParams.id;
        vm.pdfconverter= pdfconverter;

        vm.clear = clear;

        vm.disputeLog = [];

        Disputelog.query({disputeMainId:$stateParams.id}, function(result) {
            vm.disputeLog = result;
            vm.searchQuery = null;
        });

        function clear ()
        {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        function downloadFile(attachment)
        {
            viewRecruitmentFile.view(attachment)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }

        function pdfconverter () {
            var element = document.getElementById('pdf_data');
            html2pdf(element,{
                margin:  0.5,
                html2canvas: { dpi:192, letterRendering: true },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            });
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('ViewDisputeFormFilledController', ViewDisputeFormFilledController);

    ViewDisputeFormFilledController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'dispute', 'serviceFormFieldDataCollection','ServiceFormAttachments','downloadserviceformattachment', 'viewRecruitmentFile'];
    function ViewDisputeFormFilledController ($timeout, $scope, $stateParams, $uibModalInstance, dispute, serviceFormFieldDataCollection,ServiceFormAttachments,downloadserviceformattachment, viewRecruitmentFile) {
        var vm = this;
        vm.clear = clear;
        vm.dispute= dispute;
        vm.downloadFile=downloadFile;
        vm.pdfconverter= pdfconverter;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function pdfconverter () {
            var element = document.getElementById('pdf_data');
            html2pdf(element,{
                margin: 4
            });
        }


        function clear ()
        {
            $uibModalInstance.dismiss('cancel');
        }
        function downloadFile(id)
        {
            viewRecruitmentFile.view(id)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }

        // loadServiceFormFields();
        // function loadServiceFormFields() {
        //     vm.serviceFormFieldData= serviceFormFieldDataCollection.query({serviceid:vm.projectService.serviceid, projectid:vm.projectService.projectid});
        //     vm.serviceformattachments=ServiceFormAttachments.query({id:"1",serviceid:vm.projectService.serviceid, projectid:vm.projectService.projectid});
        //     vm.project = Project.get({id:vm.projectService.projectid});
        // }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserDisputeController', UserDisputeController);

    UserDisputeController.$inject = ['Principal','Dispute', 'viewRecruitmentFile'];

    function UserDisputeController(Principal ,Dispute ,viewRecruitmentFile) {

        var vm = this;

        vm.disputes = [];
        vm.account =[];

        loadAll();

        function loadAll() {
            Dispute.query({user:'User'},function(result) {
                vm.disputes = result;
                vm.searchQuery = null;
            });
        }
        UserRole();
        function UserRole() {
            Principal.identity().then(function(account) {
                vm.account = account;
            });
        }

        vm.DownloadFile = function (fileId) {
            viewRecruitmentFile.view(fileId);
        };

        vm.showPersonalDetail= function (id) {
            Dispute.get({id: id},function(result) {
                console.log(result);
                swal({
                    title: '<u>Applicant Details</u><br/><br/>',
                    animation: true,
                    html:
                        '<b>Name: </b> ' + result.nameOfEnterprise + '<br/><br/>' +
                        '<b>Phone: </b> ' + result.mobileNumber + '<br/><br/>' +
                        '<b>Email: </b> ' + result.emailAddress + '<br/><br/>' +
                        '<b>Address: </b> ' + result.address + '<br/><br/>'
                })
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ResolveDisputeController', ResolveDisputeController);

    ResolveDisputeController.$inject = ['$scope', '$state','$uibModalInstance', 'Principal', 'Dispute','dispute','Disputelog','FileManagement'];

    function ResolveDisputeController ($scope, $state, $uibModalInstance, Principal,  Dispute,dispute ,Disputelog ,FileManagement) {
        var vm = this;
       vm.dispute = dispute;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.register = register;

        $scope.file={};

        vm.clear = clear;
        vm.saveResolveData = saveResolveData;
        vm.disputelog={};

        function saveResolveData()
        {
            console.log(vm.dispute);
            vm.dispute.isResolved=true;
            Dispute.update(vm.dispute, onSaveSuccess);
        }
        function onSaveSuccess(result)
        {
            vm.disputelog.disputeID = vm.dispute.disputeID;
            vm.disputelog.disputeMainId = vm.dispute.id;
            vm.disputelog.action = "Resolved";
            if(angular.isDefined(vm.projectAttachemnt)){
                var fileNameArray = vm.projectAttachemnt.file.name.split(".");
                if ((fileNameArray.length == 2)) {
                    if(fileNameArray[0] != ""){
                        Disputelog.save(vm.disputelog, onServiceLogSaveSuccess);

                    }
                    else {
                        alert("Invalid File Name");
                    }
                }
                else{
                    alert("Please select correct file format")
                }
            }
            else {
                Disputelog.save(vm.disputelog, onServiceLogSaveSuccess);

            }
        }
        function onServiceLogSaveSuccess(result){

            if(angular.isDefined(vm.projectAttachemnt)) {

                // $scope.$emit('investhryApp:projectAttachemntUpdate', result);
                var filename = result.id;
                var file = vm.projectAttachemnt.file;
                FileManagement.saveFile(file, filename);

                var fileNameArray = vm.projectAttachemnt.file.name.split(".");
                var fileextension = "";
                if ((fileNameArray.length > 1)) {
                    fileextension = fileNameArray[(fileNameArray.length - 1)];
                }

                var inputFileName = result.id;
                if (fileextension !== "") {
                    inputFileName = inputFileName + "." + fileextension;
                }
                vm.disputelog.id = result.id;
                vm.disputelog.fileName = inputFileName;
                console.log(inputFileName);
                console.log(vm.disputelog);

                if (vm.disputelog.id !== null) {
                    Disputelog.update(vm.disputelog, onSaveSuccessLog);
                } else {
                    Disputelog.save(vm.disputelog, onSaveSuccessLog);
                }
            }
            $uibModalInstance.dismiss('cancel');

        }
        function clear ()
        {
            $uibModalInstance.dismiss('cancel');
        }

        function onSaveSuccessLog ()
        {
            $state.go('disputes');
            $uibModalInstance.dismiss('cancel');
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DepartemntEEC', DepartemntEEC);

    DepartemntEEC.$inject = ['$resource'];

    function DepartemntEEC ($resource) {
        var resourceUrl =  'api/district-nodal-officers/EEC/{NodalOfficer}';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('disputes', {
            parent: 'app',
            url: '/disputes',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN' ,'ROLE_DISPUTE_OFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/disputeForm/disputes.html',
                    controller: 'DisputeAllController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('myDisputes', {
                parent: 'app',
                url: '/myDisputes',
                data: {
                    authorities: ['ROLE_USER','ROLE_NODAL_OFFICER']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/disputeForm/userdisputes.html',
                        controller: 'UserDisputeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })

        .state('disputeForm', {
            parent: 'myDisputes',
            url: '/disputeForm',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/disputeForm/disputeForm.html',
                    controller: 'DisputeFormController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nameOfEnterprise: null,
                                activity: null,
                                nameOfPartner: null,
                                mobileNumber: null,
                                emailAddress: null,
                                fixedInvestement: null,
                                categoryOfDispute: null,
                                detailOfDispute: null,
                                statusPendingLevel: null,
                                isResolved: null,
                                disputeID: null,
                                gotReliefLevel: null,
                                levelOfRelief: null,
                                departmentName: null,
                                departmentAppeals: null,
                                address: null,
                                officeAddress: null,
                                resolveComment: null,
                                userlogin: null,
                                dateOfFilingPetition: null,
                                replyOfDepartment: null,
                                detailsOfDecision: null,
                                orderOfReliefAttachemnt: null,
                                appealsDocument: null,
                                distrcit: null,
                                dateOfFiling: null,
                                durationOfPendency: null,
                                otherCategoryDispute: null,
                                creationDate: null,
                                lastActionDate: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('myDisputes', null, { reload: 'myDisputes' });
                }, function() {
                    $state.go('myDisputes');
                });
            }]
        })
            .state('resolveDisputes', {
                parent: 'disputes',
                url: '/resolveDisputes/{id}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DISPUTE_OFFICER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/disputeForm/disputeResolve.html',
                        controller: 'ResolveDisputeController',
                        controllerAs: 'vm',
                        resolve: {
                            dispute: ['Dispute', function(Dispute) {
                                return Dispute.get({id : $stateParams.id}).$promise;
                            }]
                        }

                    }).result.then(function() {
                        $state.go('disputes', null, { reload: 'disputes' });
                    }, function() {
                        $state.go('disputes');
                    });
                }]
            })

    .state('assignDispute', {
            parent: 'disputes',
            url: '/assignDispute/{id}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DISPUTE_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/disputeForm/assignDispute.html',
                    controller: 'AssignDisputeController',
                    controllerAs: 'vm',
                    resolve: {
                        dispute: ['Dispute', function(Dispute) {
                            return Dispute.get({id : $stateParams.id}).$promise;
                        }]
                    }

                }).result.then(function() {
                    $state.go('disputes', null, { reload: 'disputes' });
                }, function() {
                    $state.go('disputes');
                });
            }]
        })
            .state('viewDisputeLog-NO', {
                parent: 'disputes',
                url: '/viewDisputeLog/{id}',
                data: {
                    authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER','ROLE_DISPUTE_OFFICER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/disputeForm/viewLog.html',
                        controller: 'ViewDisputeLogController',
                        controllerAs: 'vm',
                        size:'lg',

                        resolve: {
                            dispute: ['Dispute', function(Dispute) {
                                return Dispute.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('disputes', null, { reload: 'disputes' });
                    }, function() {
                        $state.go('disputes');
                    });
                }]
            })

            .state('myDisputeLog', {
                parent: 'myDisputes',
                url: '/myDisputeLog/{id}',
                data: {
                    authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER','ROLE_DISPUTE_OFFICER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/disputeForm/viewLog.html',
                        controller: 'ViewDisputeLogController',
                        controllerAs: 'vm',
                        size:'lg',

                        resolve: {
                            dispute: ['Dispute', function(Dispute) {
                                return Dispute.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('myDisputes', null, { reload: 'myDisputes' });
                    }, function() {
                        $state.go('myDisputes');
                    });
                }]
            })
            .state('commentDispute', {
            parent: 'myDisputes',
            url: '/comment/{id}',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/disputeForm/disputeComment.html',
                    controller: 'DisputeCommentController',
                    controllerAs: 'vm',
                    size:'lg',

                    resolve: {
                        dispute: ['Dispute', function(Dispute) {
                            return Dispute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('myDisputes', null, { reload: 'myDisputes' });
                }, function() {
                    $state.go('myDisputes');
                });
            }]
        })
            .state('commentDispute-DeskOfficer', {
                parent: 'disputes',
                url: '/comment/{id}',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DISPUTE_OFFICER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/disputeForm/disputeComment.html',
                        controller: 'DisputeCommentController',
                        controllerAs: 'vm',
                        size:'lg',

                        resolve: {
                            dispute: ['Dispute', function(Dispute) {
                                return Dispute.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('disputes', null, { reload: 'disputes' });
                    }, function() {
                        $state.go('disputes');
                    });
                }]
            })

            .state('viewDisputeFilledForm', {
            parent: 'disputes',
            url: '/viewFilledForm/{id}',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER','ROLE_DISPUTE_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/disputeForm/ViewDisputeFormFilled.html',
                    controller: 'ViewDisputeFormFilledController',
                    controllerAs: 'vm',
                    size:'lg',
                    backdrop:'static',
                    keyboard:'false',

                    resolve: {
                        dispute: ['Dispute', function(Dispute) {
                            return Dispute.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('disputes', null, { reload: 'disputes' });
                }, function() {
                    $state.go('disputes');
                });
            }]
        })
            .state('viewUserFilledForm', {
                parent: 'myDisputes',
                url: '/viewFilledForm/{id}',
                data: {
                    authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/disputeForm/ViewDisputeFormFilled.html',
                        controller: 'ViewDisputeFormFilledController',
                        controllerAs: 'vm',
                        size:'lg',
                        backdrop:'static',
                        keyboard:'false',

                        resolve: {
                            dispute: ['Dispute', function(Dispute) {
                                return Dispute.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('myDisputes', null, { reload: 'myDisputes' });
                    }, function() {
                        $state.go('myDisputes');
                    });
                }]
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DisputeForm', DisputeForm);

    DisputeForm.$inject = ['$resource'];

    function DisputeForm ($resource) {
        var resourceUrl =  'api/disputes/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeFormController', DisputeFormController);

    DisputeFormController.$inject = ['$timeout', '$scope', '$stateParams','$state', '$uibModalInstance', 'Dispute','Department','DisputeAttachment','FileManagement','District','Disputelog','CheckContent'];

    function DisputeFormController ($timeout, $scope, $stateParams, $state , $uibModalInstance, Dispute, Department, DisputeAttachment, FileManagement,District, Disputelog,CheckContent) {
        var vm = this;

        vm.clear = clear;
        vm.save = save;
        vm.departments = [];
        vm.datePickerOpenStatus = {};

        vm.openCalendar = openCalendar;

        vm.fileattach = [];
        var inputFileName = null;

        var fileextension="";
        $scope.file = {};
        vm.dispute = {};
        vm.disputelog ={};

        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        loadAll();

        function loadAll() {
            Department.query(function (result) {
                vm.departments = result;
                vm.searchQuery = null;
            });
            District.query(function(result) {
                vm.districts = result;
                vm.searchQuery = null;
            });
        }

        vm.districts = [];

        vm.checkPoint=function (value) {
            if(value !== true){
                alert("You are Not Eligible For this");
                $uibModalInstance.dismiss('cancel');
                $state.go('myDisputes');
            }
        };


        function save() {
            vm.isSaving = true;
            if(vm.dispute.gotReliefLevel ==='False'){
                vm.dispute.levelOfRelief = null;
                vm.orderOfReliefAttachemnt = null;
            }
            if(vm.dateOfFilingPetition !==null){
                vm.fileattach.push({file: vm.dateOfFilingPetition, name: "dateOfFilingPetition"});
            }
            if(vm.replyOfDepartment !==null){
                vm.fileattach.push({file:vm.replyOfDepartment, name: "replyOfDepartment"});
            }
            if(vm.detailsOfDecision !==null){
                vm.fileattach.push({file:vm.detailsOfDecision, name: "detailsOfDecision"});
            }
            if(vm.appealsDocument !==null){
                vm.fileattach.push({file:vm.appealsDocument,name: "appealsDocument"});
            }
            if(vm.orderOfReliefAttachemnt !==null){
                vm.fileattach.push({file:vm.orderOfReliefAttachemnt,name: "orderOfReliefAttachemnt"});
            }

            Dispute.save(vm.dispute, onSaveSuccess, onSaveError);

        }

        function onSaveSuccess(result) {
            $scope.$emit('investhryApp:disputeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
            vm.disputelog.disputeID = result.disputeID;
            vm.disputelog.disputeMainId = result.id;
            vm.disputelog.action = "Dispute Added";

            if (vm.disputelog.id !== null) {
                Disputelog.update(vm.disputelog,onSaveError);
            } else {
                Disputelog.save(vm.disputelog,onSaveError);
            }

            for(var i=0;i<vm.fileattach.length;i++){
                var filename = result.disputeID + "-" + Math.random().toString(36).substring(10);

                FileManagement.saveFile(vm.fileattach[i].file,filename);
                if(vm.fileattach[i].name=== 'dateOfFilingPetition'){
                    checkExtension(vm.dateOfFilingPetition,result);
                    result.dateOfFilingPetition = filename +"."+fileextension;
                }
                if(vm.fileattach[i].name=== 'replyOfDepartment'){
                    checkExtension(vm.replyOfDepartment,result);
                    result.replyOfDepartment = filename +"."+fileextension;

                }
                if(vm.fileattach[i].name=== 'detailsOfDecision'){
                    checkExtension(vm.detailsOfDecision,result);
                    result.detailsOfDecision = filename +"."+fileextension;
                }
                if(vm.fileattach[i].name=== 'appealsDocument'){
                    checkExtension(vm.appealsDocument,result);
                    result.appealsDocument = filename +"."+fileextension;
                }
                if(vm.fileattach[i].name=== 'orderOfReliefAttachemnt'){
                    checkExtension(vm.orderOfReliefAttachemnt,result);
                    result.orderOfReliefAttachemnt = filename +"."+fileextension;
                }
            }

            Dispute.update(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function checkExtension(File,result) {
            var fileNameArray = File.name.split(".");
            if((fileNameArray.length>1)){
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            // var inputFileName=result.disputeID;
            if(fileextension!=""){
                inputFileName=inputFileName+"."+fileextension;
            }
        }

        vm.datePickerOpenStatus.dateOfFiling =false;
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }


    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeCommentController', DisputeCommentController);

    DisputeCommentController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','dispute','Disputelog', 'CheckContent','FileManagement'];
    function DisputeCommentController ($timeout, $scope, $stateParams, $uibModalInstance, dispute , Disputelog, CheckContent ,FileManagement) {
        var vm = this;

        vm.dispute = dispute;

        $scope.file = {};
        vm.clear = clear;
        vm.saveComments = saveComments;
        vm.disputelog = {};
        vm.projectAttachemnt = [];

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }


        function saveComments() {
            console.log(vm.dispute);
            vm.disputelog.disputeID = vm.dispute.disputeID;
            vm.disputelog.disputeMainId = vm.dispute.id;
            vm.disputelog.action = "Comment";
            if(angular.isDefined(vm.projectAttachemnt.file)){
                var fileNameArray = vm.projectAttachemnt.file.name.split(".");
                if ((fileNameArray.length == 2)) {
                    if(fileNameArray[0] != ""){
                        Disputelog.save(vm.disputelog, onServiceLogSaveSuccess);

                    }
                    else {
                        alert("Invalid File Name");
                    }
                }
                else{
                    alert("Please select correct file format")
                }
            }
            else {
                Disputelog.save(vm.disputelog, onServiceLogSaveSuccess);

            }

        }

        function onServiceLogSaveSuccess(result){
            console.log(vm.disputelog);
            console.log(result);
            if(angular.isDefined(vm.projectAttachemnt.file)) {

                // $scope.$emit('investhryApp:projectAttachemntUpdate', result);
                var filename = result.id;
                var file = vm.projectAttachemnt.file;
                FileManagement.saveFile(file, filename);

                var fileNameArray = vm.projectAttachemnt.file.name.split(".");
                var fileextension = "";
                if ((fileNameArray.length > 1)) {
                    fileextension = fileNameArray[(fileNameArray.length - 1)];
                }

                var inputFileName = result.id;
                if (fileextension !== "") {
                    inputFileName = inputFileName + "." + fileextension;
                }
                vm.disputelog.id = result.id;
                vm.disputelog.fileName = inputFileName;
                console.log(inputFileName);
                console.log(vm.disputelog);

                if (vm.disputelog.id !== null) {
                    Disputelog.update(vm.disputelog, onSaveSuccess, onSaveError);
                } else {
                    Disputelog.save(vm.disputelog, onSaveSuccess, onSaveError);
                }
            }
            $uibModalInstance.close(result);

        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:disputelogUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function onSaveLog(){
            $uibModalInstance.dismiss('close');
        }


        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeAllController', DisputeAllController);

    DisputeAllController.$inject = ['Dispute','viewRecruitmentFile'];

    function DisputeAllController(Dispute,viewRecruitmentFile ) {

        var vm = this;

        vm.disputes = [];

        loadAll();

        function loadAll() {
            Dispute.query(function(result) {
                vm.disputes = result;
                vm.searchQuery = null;
            });
        }
        vm.DownloadFile = function (fileId) {
            viewRecruitmentFile.view(fileId);
        };

        vm.showPersonalDetail= function (id) {
            Dispute.get({id: id},function(result) {
                console.log(result);
                swal({
                    title: '<u>Applicant Details</u><br/><br/>',
                    animation: true,
                    html:
                        '<b>Name: </b> ' + result.nameOfEnterprise + '<br/><br/>' +
                        '<b>Phone: </b> ' + result.mobileNumber + '<br/><br/>' +
                        '<b>Email: </b> ' + result.emailAddress + '<br/><br/>' +
                        '<b>Address: </b> ' + result.address + '<br/><br/>'
                })
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AssignDisputeController', AssignDisputeController);

    AssignDisputeController.$inject = ['$scope', '$state','$uibModalInstance', 'Principal', 'Dispute','dispute','DepartemntEEC','Disputelog'];

    function AssignDisputeController ($scope, $state, $uibModalInstance, Principal,  Dispute, dispute, DepartemntEEC,Disputelog) {
        var vm = this;
       vm.dispute = dispute;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.register = register;

        vm.clear = clear;
        vm.saveResolveData = saveResolveData;

        vm.disputelog={};

        loadAll();
        vm.departments =[];

        function loadAll() {
            DepartemntEEC.query(function (result) {
                vm.departments = result;
                vm.searchQuery = null;
            });
        }
        function saveResolveData()
        {
            Dispute.update(vm.dispute, onSaveSuccess);
        }
        function onSaveSuccess(result)
        {
            vm.disputelog.disputeID = result.disputeID;
            vm.disputelog.disputeMainId = result.id;
            vm.disputelog.actionComment = result.concernedNo;
            vm.disputelog.action = "Dispute Assigned";

            if (vm.disputelog.id !== null) {
                Disputelog.update(vm.disputelog);
            } else {
                Disputelog.save(vm.disputelog);
            }
            $uibModalInstance.close(result);
        }
        function clear ()
        {
            $uibModalInstance.dismiss('cancel');
        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('disputeDashboard', {
            parent: 'app',
            url: '/disputeDashboard',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DISPUTE_OFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/disputeDashboard/disputeDashboard.html',
                    controller: 'DisputeDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
            .state('disputeDetails', {
                parent: 'disputeDashboard',
                url: '/disputeDetails/{departmentname}/{status}',
                data: {
                    authorities: []
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/disputeDashboard/disputeViewDetails.html',
                        controller: 'DisputeViewDetailController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                $translatePartialLoader.addPart('home');
                                return $translate.refresh();
                            }]
                        }
                    }).result.then(function() {
                        $state.go('disputeDetails', null, { reload: 'disputeDetails' });
                    }, function() {
                        $state.go('disputeDetails');
                    });
                }]
            });

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DisputeDashboard', DisputeDashboard);

    DisputeDashboard.$inject = ['$resource'];

    function DisputeDashboard ($resource) {
        var resourceUrl =  'api/getDipsuteDashboard';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DisputeDashboardController', DisputeDashboardController);

   DisputeDashboardController.$inject = ['$scope','$filter', 'Principal','Dispute' ,'Department', 'District', '$location'];

    function DisputeDashboardController ($scope,$filter, Principal, Dispute, Department, District, $location) {
        var vm = this;
        vm.account = null;
        vm.disputes = [];
        vm.departments = [];
        vm.deatils = details;
        vm.districts = [];

        loadAll();
        function loadAll() {
        Principal.identity().then(function(account) {
            vm.account = account;
            ga('set', 'page', $location.path());
            ga('send','pageview');
        });
            Dispute.query(function(result) {
                vm.disputes = result;
           vm.searchQuery = null;
            });

            Department.query(function(result){
                vm.departments = result;
            });
            District.query(function(result){
                vm.districts = result;
            });

        }

        vm.resultDistrictWise = function resultDistrictWise(value) {
            vm.resultList =[];
            vm.testing ={};
            vm.disputeResults = [];
            vm.finalResult = {};
            vm.finalObject = [];

            if(value==='District'){
                for (var i = 0; i < vm.districts.length; i++) {
                    vm.disputeResults = $filter('filter')(vm.disputes,{distrcit:vm.districts[i].districtname});
                    if(vm.disputeResults.length !=0){
                        vm.finalResult.total = vm.disputeResults.length;

                        vm.resolved = $filter('filter')(vm.disputeResults,{isResolved:true});

                        vm.pending = $filter('filter')(vm.disputeResults,{isResolved:false});

                        vm.finalResult.resolved = vm.resolved.length;

                        vm.finalResult.pending= vm.pending.length;
                        vm.finalResult.districtName = vm.districts[i].districtname;
                        vm.finalResult.records =  vm.disputeResults;

                        vm.finalObject.push(vm.finalResult);

                        vm.finalResult = {};
                    }

                }
            }
            if(value==='Department'){
                for (var i = 0; i < vm.departments.length; i++) {
                    vm.disputeResults = $filter('filter')(vm.disputes,{departmentName:vm.departments[i].departmentname});

                    if(vm.disputeResults.length !=0){
                        vm.finalResult.total = vm.disputeResults.length;

                        vm.resolved = $filter('filter')(vm.disputeResults,{isResolved:true});

                        vm.pending = $filter('filter')(vm.disputeResults,{isResolved:false});

                        vm.finalResult.resolved = vm.resolved.length;

                        vm.finalResult.pending= vm.pending.length;
                        vm.finalResult.departmentname = vm.departments[i].departmentname;
                        vm.finalResult.records =  vm.disputeResults;

                        vm.finalObject.push(vm.finalResult);

                        vm.finalResult = {};
                    }

                }
            }


        };
        vm.recordList = [];
        function details(records,value){

             if(value=== 'pending'){
                vm.recordList =$filter('filter')(records,{isResolved:false});
            }
            else if(value=== 'resolved'){
                vm.recordList =$filter('filter')(records,{isResolved:true});
            }
            else {
                vm.recordList = records;
            }

            $('#dispute').modal('show');
        }
    }

})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .directive('fileModel', fileModel);

    fileModel.$inject = ['$parse'];

    function fileModel($parse) {
        return {
            restrict: 'A',
            link: function (scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                element.on('change', function () {
                    scope.$apply(function () {
                        model.assign(scope, element[0].files[0]);
                    });
                });
            }
        };
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerServiceViewCafController', TowerServiceViewCafController);

    TowerServiceViewCafController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'ServiceViewCaf', 'TowerserviceNO'];
    function TowerServiceViewCafController ($timeout, $scope, $stateParams, $uibModalInstance, ServiceViewCaf, TowerserviceNO) {
        var vm = this;
        vm.clear = clear;
        vm.departmentname=$stateParams.departmentname;
        vm.servicename=$stateParams.servicename;
        vm.status=$stateParams.status;
        vm.showDepartments=showDepartments;
        vm.departmentName=[];

        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        loadAllCafs();
        function loadAllCafs() {

          vm.dashboardcafs=ServiceViewCaf.query({status:$stateParams.status,department:$stateParams.departmentname,servicename:$stateParams.servicename},function(result) {
              vm.show = true;
          })
        }

        function showDepartments(data) {
            TowerserviceNO.query({id:'1',projectdetailid:data.projectdetailid},function (result) {
                if(result.length===0){
                    vm.departmentName=[];
                    vm.departmentName[0] = "NA";
                }
                else {
                    vm.departmentName = result;
                }
            });

        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('TowerServiceForDashboard', TowerServiceForDashboard);

    TowerServiceForDashboard.$inject = ['$resource'];

        function TowerServiceForDashboard ($resource) {
        var resourceUrl = '/api/towerServiceForDashbaord/merged';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('TowerServiceDashboardController', TowerServiceDashboardController);

    TowerServiceDashboardController.$inject = ['Tower_service_dashboard','TowerServiceForDashboard'];

    function TowerServiceDashboardController(Tower_service_dashboard, TowerServiceForDashboard) {

        var vm = this;

        vm.tower_service_dashboards = [];

        vm.merged = 'mergedDepartments';

        loadAll();

        function loadAll() {
            TowerServiceForDashboard.query({merged :'mergedDepartments'},function(result) {
                vm.tower_service_dashboards = result;
                vm.searchQuery = null;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceViewCaf', ServiceViewCaf);

    ServiceViewCaf.$inject = ['$resource'];

    function ServiceViewCaf ($resource) {
        var resourceUrl =  'api/servicedashboardcafs/:serviceid/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('ServiceViewCafController', ServiceViewCafController);

    ServiceViewCafController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'ServiceViewCaf', 'TowerserviceNO','ServiceViewCafByElastic'];
    function ServiceViewCafController ($timeout, $scope, $stateParams, $uibModalInstance, ServiceViewCaf, TowerserviceNO,ServiceViewCafByElastic) {
        var vm = this;
        vm.clear = clear;
        vm.servicename=$stateParams.servicename;
        vm.status=$stateParams.status;
        var initDate=new Date('05-01-2017');
        var totalTime=0;
        var totalCleared=0;
        vm.showDepartments=showDepartments;
        vm.departmentName=[];
        vm.show = false;
        $scope.currentPage = 1;
        $scope.pageSize = 10;
        vm.selectedValue = "10";

        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
            /*appliedDate=new Date(result[i].appliedDate.toDateString());
            clearedDate=new Date(result[i].clearedDate.toDateString());
            dayDiff= (clearedDate - appliedDate)  / 1000 / 60 / 60 / 24;
*/
        loadAllCafs();
        function loadAllCafs() {
            var appliedDate;
            var clearedDate;
            var dayDiff;
            if(!$stateParams.departmentName){
                vm.deptName = null;
            } else {
                vm.deptName = $stateParams.departmentName;
            }

            if(!$stateParams.district){
                vm.districtName = null;
            } else {
                vm.districtName = $stateParams.district;
            }

            if(!$stateParams.projectLevel){
                vm.levelfiled = null;
            } else {
                vm.levelfiled = $stateParams.projectLevel;
            }
            var data = {departmentName: vm.deptName, district: vm.districtName, projectLevel: vm.levelfiled,serviceId:$stateParams.serviceid,status:$stateParams.status,
                page: $scope.currentPage - 1,
                size: $scope.pageSize};
            Object.keys(data).forEach(function (k) {
                if(!data[k] && data[k] !== undefined)
                {
                    delete data[k];
                }
            });
          vm.dashboardcafs=ServiceViewCafByElastic.get(data,function(result){
              vm.show=true;
          });
        }

        $scope.setPageSize = function (pageSizeVal) {
            $scope.pageSize = pageSizeVal;
        }

        $scope.pageChangedHandler = function(num) {
            loadAllCafs();
        };

        function showDepartments(data) {
            TowerserviceNO.query({id:'1',projectdetailid:data.projectdetailid},function (result) {
                if(result.length===0){
                    vm.departmentName=[];
                    vm.departmentName[0] = "NA";
                }
                else {
                    vm.departmentName = result;
                }
            });

        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ServiceViewCafByElastic', ServiceViewCafByElastic);

    ServiceViewCafByElastic.$inject = ['$resource'];

    function ServiceViewCafByElastic ($resource) {
        var resourceUrl =  'api/servicedashboardcafsElastic/departmentName/district/projectLevel/serviceId/status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('PowerRequiredCaf', PowerRequiredCaf);

    PowerRequiredCaf.$inject = ['$resource'];

    function PowerRequiredCaf ($resource) {
        var resourceUrl =  'api/powerCaf';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('PowerDashboardController', PowerDashboardController);

    PowerDashboardController.$inject = ['$timeout', '$scope', '$stateParams','$filter' , 'PowerRequiredCaf'];
    function PowerDashboardController ($timeout, $scope, $stateParams, $filter, PowerRequiredCaf) {
        var vm = this;

        var initDate=new Date('05-01-2017');
        vm.show = false;
        vm.requiredcaf = [];

        loadAllCafs();
        function loadAllCafs() {
            PowerRequiredCaf.query({date:initDate,power:'1'},function (result) {
                vm.requiredcaf =$filter('filter')(result,{isdeactivated:false});
                vm.show = true;
            })
        }



    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DeptServiceStatsElastic', DeptServiceStatsElastic);

    DeptServiceStatsElastic.$inject = ['$resource'];

        function DeptServiceStatsElastic ($resource) {
        var resourceUrl = '/api/service-dashboard-stats-elastic';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DeptServiceStats', DeptServiceStats);

    DeptServiceStats.$inject = ['$resource'];

        function DeptServiceStats ($resource) {
        var resourceUrl = '/api/deptserviceStats';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('GetFilterWiseDashboardData', GetFilterWiseDashboardData);

    GetFilterWiseDashboardData.$inject = ['$resource'];

    function GetFilterWiseDashboardData ($resource) {
        var resourceUrl =  'api/servicedashboardcafsFilters/departmentName/district/projectLevel';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('servicedashboard', {
            parent: 'app',
            url: '/servicedashboard/{auth}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER']
            },
            params: {
                auth: ""
            },
            views: {
                'content@': {
                    templateUrl: 'app/deptservicedashboard/deptservicedashboard.html',
                    controller: 'DeptServiceDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        }).state('servicedashboardcafs', {
            parent: 'servicedashboard',
            url: '/servicedashboard/{servicename}/{departmentName}/{district}/{projectLevel}/{serviceid}/{status}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/deptservicedashboard/serviceviewcafs.html',
                    controller: 'ServiceViewCafController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('servicedashboard', null, { reload: 'servicedashboard' });
                }, function() {
                    $state.go('servicedashboard');
                });
            }]
        })
        .state('towerservicedashboard', {
                parent: 'app',
                url: '/tower_service_dashboard',
                data: {
                    authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER','ROLE_DESK_OFFICER'],
                    pageTitle: 'investhryApp.tower_service_dashboard.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/deptservicedashboard/towerservicedashboard.html',
                        controller: 'TowerServiceDashboardController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tower_service_dashboard');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
        .state('tower-servicedashboardcafs', {
            parent: 'towerservicedashboard',
            url: '/servicedashboard/{departmentname}/{servicename}/{status}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER','ROLE_DESK_OFFICER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/deptservicedashboard/serviceviewcafsTower.html',
                    controller: 'TowerServiceViewCafController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('towerservicedashboard', null, { reload: 'towerservicedashboard' });
                }, function() {
                    $state.go('towerservicedashboard');
                });
            }]
        })
        .state('powerdashboard', {
            parent: 'app',
            url: '/powerdashboard',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_NODAL_OFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/deptservicedashboard/powerDashboard.html',
                    controller: 'PowerDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DeptServiceDashboard', DeptServiceDashboard);

    DeptServiceDashboard.$inject = ['$resource'];

    function DeptServiceDashboard ($resource) {
        var resourceUrl =  'api/service-dashboard-stats-elastic';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DeptServiceDashboardController', DeptServiceDashboardController);

    DeptServiceDashboardController.$inject = ['$scope','$filter', 'Principal', '$stateParams', 'LoginService', '$state', 'DeptServiceDashboard', 'DeptServiceStats','ServiceViewCaf','Service_dashboard_output','$location','DeptServiceStatsElastic','GetFilterWiseDashboardData','District'];

    function DeptServiceDashboardController ($scope,$filter, Principal,$stateParams , LoginService, $state, DeptServiceDashboard, DeptServiceStats, ServiceViewCaf, Service_dashboard_output,$location,DeptServiceStatsElastic, GetFilterWiseDashboardData,District) {
        var vm = this;
        vm.account = null;
        vm.districts = [];
        vm.departments =[];
        vm.filter = {};
        vm.deptName = null;
        vm.districtName = null;
        vm.levelfiled = null;

        loadAll();
        function loadAll() {
             vm.auth = $stateParams.auth;
        Principal.identity().then(function(account) {
            vm.account = account;
            ga('set', 'page', $location.path());
            ga('send','pageview');


        });


        District.query(function(result) {
            vm.districts = result;
            vm.searchQuery = null;
        });

            DeptServiceStatsElastic.query(function(result) {
                vm.hideClear = true;
                vm.deptservicedashboard = result;
          vm.totalappliedservices=0;
          vm.totalrequiredservices=0;
          vm.totalpendingservices=0;
          vm.totalcompletedservices=0;
          vm.totalrejectedservices=0;
          vm.totaldeemedclearedservices = 0;
          vm.totaldeactivatedservices = 0;
           for(var i=0;i<vm.deptservicedashboard.length;i++)
           {
             vm.totalappliedservices=vm.totalappliedservices + parseInt(vm.deptservicedashboard[i].applied);
             vm.totalrequiredservices=vm.totalrequiredservices+ parseInt(vm.deptservicedashboard[i].required);
             vm.totalpendingservices=vm.totalpendingservices+ parseInt(vm.deptservicedashboard[i].pending_total);
             vm.totalcompletedservices=vm.totalcompletedservices+ parseInt(vm.deptservicedashboard[i].cleared);
             vm.totalrejectedservices=vm.totalrejectedservices+ parseInt(vm.deptservicedashboard[i].rejected);
             vm.totaldeemedclearedservices=vm.totaldeemedclearedservices+ parseInt(vm.deptservicedashboard[i].deemed_cleared);
             vm.totaldeactivatedservices=vm.totaldeactivatedservices+ parseInt(vm.deptservicedashboard[i].deactivated);
           }
           vm.searchQuery = null;
                vm.departments = [];

                angular.forEach(vm.deptservicedashboard, function(value, key){
                    if(vm.departments.indexOf(value.department_name) === -1){
                        vm.departments.push(value.department_name);
                    }
                });
            });
        }
        vm.FilterWiseDat = function () {
            GetFilterWiseDashboardData.query(vm.filter,function (result) {
                vm.hideClear = false;
                vm.deptservicedashboard =result;
            })
        };
        vm.clearFilter = function () {
            vm.filter ={};
            loadAll();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('HodDashboardController', HodDashboardController);

    HodDashboardController.$inject = ['$scope','Principal','RatingsByDepartmentIdAndRating', 'Tickets','DeptHodServiceDashboard'];

    function HodDashboardController ($scope,Principal,RatingsByDepartmentIdAndRating, Tickets,DeptHodServiceDashboard) {
        var vm = this;

        loadAll();
        function loadAll(){
            RatingsByDepartmentIdAndRating.query({ rating: 'All' },function(result){
                vm.feedbacks = result.length;
            });
            Principal.identity().then(function(account) {
                vm.account = account;
                Tickets.query({assignedMember: vm.account.login, status: "Closed"},function(result){
                    vm.closedTickets = result.length;
                });
                Tickets.query({assignedMember: vm.account.login, status: "Open"},function(result){
                    vm.openTickets = result.length;
                });
                DeptHodServiceDashboard.query(function(result) {
                    vm.deptservicedashboard = result;
                    vm.totalPending45 = 0;
                    for(var i=0;i<vm.deptservicedashboard.length;i++)
                    {
                        vm.totalPending45 += parseInt(vm.deptservicedashboard[i].pending_45days);
                    }
                    vm.searchQuery = null;
                });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('servicedashboardhod', {
            parent: 'app',
            url: '/servicedashboardHod',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/deptHodServiceDashboard/deptHodServiceDashboard.html',
                    controller: 'DeptHodServiceDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        }).state('dashboardHod', {
            parent: 'app',
            url: '/dashboardHod',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/deptHodServiceDashboard/hodDashboard.html',
                    controller: 'HodDashboardController',
                    controllerAs: 'vm'
                }
            }
        })
        .state('servicedashboardcafsHod', {
            parent: 'servicedashboardhod',
            url: '/servicedashboardHod/{servicename}/{serviceid}/{status}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/deptservicedashboard/serviceviewcafs.html',
                    controller: 'ServiceViewCafController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('servicedashboardhod', null, { reload: 'servicedashboardhod' });
                }, function() {
                    $state.go('servicedashboardhod');
                });
            }]
        })
        }
    })();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DeptHodServiceDashboard', DeptHodServiceDashboard);

    DeptHodServiceDashboard.$inject = ['$resource'];

    function DeptHodServiceDashboard ($resource) {
        var resourceUrl =  'api/getPending45ForDeptHod';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DeptHodServiceDashboardController', DeptHodServiceDashboardController);

    DeptHodServiceDashboardController.$inject = ['$scope','$filter', 'Principal','DeptHodServiceDashboard','$location'];

    function DeptHodServiceDashboardController ($scope,$filter, Principal, DeptHodServiceDashboard,$location) {
        var vm = this;
        vm.account = null;

        loadAll();
        function loadAll() {
        Principal.identity().then(function(account) {
            vm.account = account;
            ga('set', 'page', $location.path());
            ga('send','pageview');
        });
        DeptHodServiceDashboard.query(function(result) {
          vm.deptservicedashboard = result;
          vm.totalappliedservices=0;
          vm.totalrequiredservices=0;
          vm.totalpendingservices=0;
          vm.totalcompletedservices=0;
          vm.totalrejectedservices=0;
           for(var i=0;i<vm.deptservicedashboard.length;i++)
           {
             vm.totalappliedservices=vm.totalappliedservices + parseInt(vm.deptservicedashboard[i].applied);
             vm.totalrequiredservices=vm.totalrequiredservices+ parseInt(vm.deptservicedashboard[i].required);
             vm.totalpendingservices=vm.totalpendingservices+ parseInt(vm.deptservicedashboard[i].pending_total);
             vm.totalcompletedservices=vm.totalcompletedservices+ parseInt(vm.deptservicedashboard[i].cleared);
             vm.totalrejectedservices=vm.totalrejectedservices+ parseInt(vm.deptservicedashboard[i].rejected);
           }
           vm.searchQuery = null;
         });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('department-best-practices', {
            parent: 'app',
            url: '/department-best-practices',
            data: {
                authorities: [],
                pageTitle: 'global.menu.department-best-practices'
            },
            views: {
                'content@': {
                    templateUrl: 'app/department-best-practices/department-best-practices.html',
                    controller: 'DepartmentsBestPracticeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('department-best-practices');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('DepartmentsBestPracticeService', DepartmentsBestPracticeService);

    DepartmentsBestPracticeService.$inject = ['$resource'];

    function DepartmentsBestPracticeService($resource) {
        var service = {
            getOrdinalIndicator: getOrdinalIndicator
        };

        return service;

        function getOrdinalIndicator(n) {

            if (n || n === 0) {

                if (hasANonGenericOrdinalIndicator(n)) {
                    return 'th';
                }

                var decimal = n % 10;
                switch (decimal) {
                    case 1:
                        return 'st';
                        break;
                    case 2:
                        return 'nd';
                        break;
                    case 3:
                        return 'rd';
                        break;
                    default:
                        return 'th';
                        break;
                }
            }

            return '';
        }

        function hasANonGenericOrdinalIndicator(n) {
            var lastTwoDigits = n % 100;
            return lastTwoDigits > 10 && lastTwoDigits < 14;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DepartmentsBestPracticeController', DepartmentsBestPracticeController);

    DepartmentsBestPracticeController.$inject = ['$scope', 'DepartmentsBestPracticeService'];

    function DepartmentsBestPracticeController($scope, DepartmentsBestPracticeService) {
        var vm = this;

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('deleteuser', {
                    parent: 'app',
                    url: '/deleteuser',
                    data: {
                        authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/deleteuser/deleteuser.html',
                            controller: 'DeleteUserController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                 }]
             }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DeleteUser', DeleteUser);

    DeleteUser.$inject = ['$resource'];

    function DeleteUser ($resource) {
        var resourceUrl =  '/api/deleteuserid/:deleteuserid';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DeleteUserController', DeleteUserController);

    DeleteUserController.$inject = ['User','UserById','DeleteUser'];

    function DeleteUserController(User,UserById,DeleteUser) {

        var vm = this;
        vm.getUser = getUser;
        function getUser(id){
            UserById.get({id:id},function(user){
                vm.user = user;
                vm.showButton = true;
            });
        }

        vm.deleteuser = deleteuser;
        function deleteuser(id){
            DeleteUser.delete({deleteuserid:id},onSuccess,onError);
        }
        function onSuccess(result){
            vm.showButton = false;
            alert("User Successfully Deleted");
        }
        function onError(){
            alert("User Not Deleted");
        }
    }
 })();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ViewDecriminalization', ViewDecriminalization);

    ViewDecriminalization.$inject = ['$resource', 'DateUtils'];

    function ViewDecriminalization ($resource, DateUtils) {
        var resourceUrl =  'api/decriminalizations/actName/departmentId/id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.updateDate = DateUtils.convertDateTimeFromServer(data.updateDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ViewDecriminalizationFormController', ViewDecriminalizationFormController);

    ViewDecriminalizationFormController.$inject = ['$scope', 'entity', 'Decriminalization', 'Department', 'ViewDecriminalization','District','DistrictVillageBlockMapping','$translate'];

    function ViewDecriminalizationFormController($scope, entity, Decriminalization, Department, ViewDecriminalization,District,DistrictVillageBlockMapping,$translate) {

        var vm = this;
        // Manually refresh translations after page load
        $translate.refresh().then(function() {
            console.log("Translations refreshed in controller");
        });

        vm.decriminalizations = [];

        vm.decriminalization = entity;
        vm.download=download;

        vm.downloadPDF = downloadPDF;
        vm.searchPerformed = false;

        loadAll();



        function loadAll() {
            getDecriminationzation();
            loadAllDistrict();
            Decriminalization.query(function(result) {
                vm.decriminalizations = result;
                vm.decriminalizationResult = result; // Display all data on load
                vm.searchQuery = null;
            });
        }

        $scope.searchForm = function() {
            console.log("clicked")
            // Reset searchPerformed
            vm.searchPerformed = true;

            // Filter the records based on search criteria
            vm.decriminalizationResult = vm.decriminalizations.filter(function(item) {
                return (!vm.decriminalization.departmentId || item.departmentId === vm.decriminalization.departmentId) &&
                    (!vm.decriminalization.actName || item.actName === vm.decriminalization.actName) &&
                    (!vm.decriminalization.id || item.id.includes(vm.decriminalization.id));
            });

            // Check if no data is found
            vm.noDataFound = vm.decriminalizationResult.length === 0;
        };



        // $scope.searchForm = function () {
        //     vm.decriminalizationResult = vm.decriminalizations.filter(function(item) {
        //         return (!vm.decriminalization.departmentId || item.departmentId === vm.decriminalization.departmentId) &&
        //             (!vm.decriminalization.actName || item.actName === vm.decriminalization.actName) &&
        //             (!vm.decriminalization.id || item.id.includes(vm.decriminalization.id));
        //     });
        // }






        function getDepartments() {
            Department.query().$promise.then(function(data) {
                vm.departments = data;

            });
        }

        function getDecriminationzation() {
            Decriminalization.query().$promise.then(function(data) {
                vm.decriminalization = data;

            });
        }
        vm.districts = [];
        function loadAllDistrict(){
            District.query(function(result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

        vm.getVillages = function (districtName) {
            vm.showEstateConfirmation =true;
            vm.isIndustrialEstate = "no";
            vm.showIndustrialEstates = false;
            DistrictVillageBlockMapping.query({id: '1',districtName: districtName},function(result) {
                vm.villages = result;
                vm.searchQuery = null;
                vm.decriminalization.village = null;
                vm.decriminalization.blockCategory = null;
            });
        };
        vm.setBlockCategory = function (villageName, villageList) {
            vm.showEstateConfirmation = true;
            vm.villageNames = [];
            angular.forEach(villageList, function (value, key) {
                vm.villageNames.push(value.village);
            });
            if (vm.villageNames.indexOf(villageName) !== -1) {
                vm.invalidVillage = false;
                vm.decriminalization.blockCategory = villageList[vm.villageNames.indexOf(villageName)].category;
            } else {
                vm.invalidVillage = true;
            }
        };

        function download() {
            // Pass parameters dynamically in the URL
            ViewDecriminalization.query({
                actName: vm.decriminalization.actName,
                departmentId: vm.decriminalization.departmentId,
                id: vm.decriminalization.id
            }, function(result) {
                vm.decriminalizationResult = result;

                // Convert JSON to an array of arrays
                var rowsCleared = convertJsonsToArrays(result);

                if (rowsCleared.length === 0) {
                    alert('No rows to export');  // Add error handling if no data is present
                    return;
                }

                // Define the headers
                var headers = [
                    "Sr. No.",
                    // "Compliance Request No.",
                    "Department",
                    "Act/Rule",
                    "Description",
                    "Frequency of Offense",
                    "Criminal Punishment Tenure Min Tenure (Months)",
                    "Criminal Punishment Tenure Max Tenure (Months)",
                    "Criminal Punishment Amount Min Amount (INR)",
                    "Criminal Punishment Amount Max Amount (INR)"
                ];

                var lineArrayCleared = [];

                // Add headers to the output
                lineArrayCleared.push(headers.join("\t"));

                // Add data rows to the output
                for (var i = 0; i < rowsCleared.length; i++) {
                    var lineCleared = rowsCleared[i].join("\t");
                    lineArrayCleared.push(lineCleared);
                }

                // Join all lines with a newline character
                lineArrayCleared = lineArrayCleared.join("\n");

                // Create a blob and initiate the download
                var a = document.createElement('a');
                var blob = new Blob([lineArrayCleared], { type: 'data:text/plain;charset=utf-8;' });
                var url = URL.createObjectURL(blob);
                a.href = url;
                a.download = 'DecriminalizationData.xls';  // specify the file name
                a.click();
            });
        }



        function downloadPDF() {
            ViewDecriminalization.query({
                actName: vm.decriminalization.actName,
                departmentId: vm.decriminalization.departmentId,
                id: vm.decriminalization.id
            }, function(result) {
                vm.decriminalizationResult = result;

                // Convert JSON to an array of arrays (without adding Sr. No.)
                var rowsCleared = convertJsonsToArrayss(result);

                // Define the headers
                var headers = [
                    "Sr. No.",
                    // "Compliance Request No.",
                    "Department",
                    "Act/Rule",
                    "Description",
                    "Frequency of Offense",
                    "Criminal Punishment Tenure Min Tenure (Months)",
                    "Criminal Punishment Tenure Max Tenure (Months)",
                    "Criminal Punishment Amount Min Amount (INR)",
                    "Criminal Punishment Amount Max Amount (INR)"
                ];


                // Create HTML content using concatenation
                var htmlContent =
                    '<!DOCTYPE html>' +
                    '<html>' +
                    '<head>' +
                    '<title>Decriminalization Data</title>' +
                    '<style>' +
                    'body { font-family: Arial, sans-serif; margin: 20px; }' +
                    'table { width: 100%; border-collapse: collapse; }' +
                    'th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }' +
                    'th { background-color: #f2f2f2; }' +
                    'h1 { text-align: center; margin-bottom: 20px; }' +
                    '</style>' +
                    '</head>' +
                    '<body>' +
                    '<h1>Decriminalization Form Data</h1>' +
                    '<table>' +
                    '<thead>' +
                    '<tr>' +
                    headers.map(function(header) {
                        return '<th>' + header + '</th>';
                    }).join('') +
                    '</tr>' +
                    '</thead>' +
                    '<tbody>' +
                    rowsCleared.map(function(row, index) {
                        return '<tr>' +
                            '<td>' + (index + 1) + '</td>' + // Sr. No. is added here
                            row.map(function(cell) {
                                return '<td>' + (cell !== undefined ? cell : '') + '</td>';
                            }).join('') +
                            '</tr>';
                    }).join('') +
                    '</tbody>' +
                    '</table>' +
                    '</body>' +
                    '</html>';

                // Open a new window and print
                var printWindow = window.open('', '', 'height=600,width=800');
                printWindow.document.open();
                printWindow.document.write(htmlContent);
                printWindow.document.close();
                printWindow.focus(); // Focus on the new window

                // Trigger print dialog
                printWindow.onload = function() {
                    printWindow.print();
                };
            });
        }


        function convertJsonsToArrays(json) {
            var rows = [];

            // Iterate through the JSON data and convert each entry into an array
            json.forEach(function(item, index) {
                // If 'Enter months' or 'Enter Amount' is selected, display min/max values, otherwise use default '--'
                var tenureMin = item.criminalPunishmentTenureInMonths && item.criminalPunishmentTenureInMonths === 'Enter months' ? item.minimumTenure : '--';
                var tenureMax = item.criminalPunishmentTenureInMonths && item.criminalPunishmentTenureInMonths === 'Enter months' ? item.maximumTenure : '--';
                var amountMin = item.criminalPunishmentAmountInInr && item.criminalPunishmentAmountInInr === 'Enter Amount' ? item.minimumAmount : '--';
                var amountMax = item.criminalPunishmentAmountInInr && item.criminalPunishmentAmountInInr === 'Enter Amount' ? item.maximumAmount : '--';


                // Push row data into the rows array
                rows.push([
                    index + 1,  // Sr. No.
                    // item.id,    // Compliance Request No.
                    item.departmentName,  // Department
                    item.actName,  // Act/Rule
                    item.criminalPunishmentDescription,  // Act/Rule
                    item.offence,  // Section/Rule Number that prescribe Criminal Punishment
                    item.criminalPunishmentTenureInMonths === 'Enter months' ? item.minimumTenure : '--',
                    item.criminalPunishmentTenureInMonths === 'Enter months' ? item.maximumTenure : '--',
                    item.criminalPunishmentAmountInInr === 'Enter Amount' ? item.minimumAmount : '--',
                    item.criminalPunishmentAmountInInr === 'Enter Amount' ? item.maximumAmount : '--'
                ]);
            });

            return rows;
        }


        function convertJsonsToArrayss(json) {
            var rows = [];

            json.forEach(function(item) {
                // If Min/Max Tenure or Amount is missing, fill it with '--'
                rows.push([
                    // item.id || '--',                                 // Compliance Request No.
                    item.departmentName || '--',                     // Department
                    item.actName || '--',                            // Act/Rule
                    item.criminalPunishmentDescription || '--',                            // Act/Rule
                    item.offence || '--', // Section/Rule Number
                    item.minimumTenure || '--',        // Min Tenure
                    item.maximumTenure || '--',        // Max Tenure
                    item.minimumAmount || '--',        // Min Amount
                    item.maximumAmount || '--'         // Max Amount
                ]);
            });

            return rows;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DecriminalizationDialogController', DecriminalizationDialogController);

    DecriminalizationDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Decriminalization'];

    function DecriminalizationDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Decriminalization) {
        var vm = this;

        vm.decriminalization = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.decriminalization.id !== null) {
                Decriminalization.update(vm.decriminalization, onSaveSuccess, onSaveError);
            } else {
                Decriminalization.save(vm.decriminalization, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:decriminalizationUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.createDate = false;
        vm.datePickerOpenStatus.updateDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DecriminalizationDetailController', DecriminalizationDetailController);

    DecriminalizationDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Decriminalization'];

    function DecriminalizationDetailController($scope, $rootScope, $stateParams, previousState, entity, Decriminalization) {
        var vm = this;

        vm.decriminalization = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('investhryApp:decriminalizationUpdate', function(event, result) {
            vm.decriminalization = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DecriminalizationDeleteController',DecriminalizationDeleteController);

    DecriminalizationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Decriminalization'];

    function DecriminalizationDeleteController($uibModalInstance, entity, Decriminalization) {
        var vm = this;

        vm.decriminalization = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Decriminalization.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('decriminalization-form', {
            parent: 'entity',
            url: '/decriminalization-form',
            data: {
                authorities: ['ROLE_NODAL_OFFICER','ROLE_TOWER_OFFICER']
               // pageTitle: 'investhryApp.decriminalization.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/decriminalization/decriminalizations.html',
                    controller: 'DecriminalizationFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        complianceRequest: null,
                        departmentName: null,
                        departmentId: null,
                        serviceType: null,
                        otherServiceType: null,
                        serviceSchemeName: null,
                        actName: null,
                        ruleRegulation: null,
                        ruleRegulationName: null,
                        sectionRuleNumber: null,
                        sectionRuleNumberCriminalProvision: null,
                        criminalPunishmentDescription: null,
                        sector: null,
                        otherSector: null,
                        offence: null,
                        criminalPunishmentTenureInMonths: null,
                        minimumTenure: null,
                        maximumTenure: null,
                        criminalPunishmentAmountInInr: null,
                        minimumAmount: null,
                        maximumAmount: null,
                        createDate: null,
                        updateDate: null,
                        sectorId: null,
                        id: null
                    };
                }
            }
        })
            .state('view-decriminalization-form', {
                parent: 'entity',
                url: '/view-decriminalization-form',
                data: {
                    authorities: []
                    // pageTitle: 'investhryApp.decriminalization.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/decriminalization/view-decriminalizations.html',
                        controller: 'ViewDecriminalizationFormController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {
                            complianceRequest: null,
                            departmentName: null,
                            departmentId: null,
                            serviceType: null,
                            otherServiceType: null,
                            serviceSchemeName: null,
                            actName: null,
                            ruleRegulation: null,
                            ruleRegulationName: null,
                            sectionRuleNumber: null,
                            sectionRuleNumberCriminalProvision: null,
                            criminalPunishmentDescription: null,
                            sector: null,
                            otherSector: null,
                            offence: null,
                            criminalPunishmentTenureInMonths: null,
                            minimumTenure: null,
                            maximumTenure: null,
                            criminalPunishmentAmountInInr: null,
                            minimumAmount: null,
                            maximumAmount: null,
                            createDate: null,
                            updateDate: null,
                            sectorId: null,
                            id: null
                        };
                    }
                }
            });
    }

})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Decriminalization', Decriminalization);

    Decriminalization.$inject = ['$resource', 'DateUtils'];

    function Decriminalization ($resource, DateUtils) {
        var resourceUrl =  'api/decriminalizations/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createDate = DateUtils.convertDateTimeFromServer(data.createDate);
                        data.updateDate = DateUtils.convertDateTimeFromServer(data.updateDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DecriminalizationFormController', DecriminalizationFormController);

    DecriminalizationFormController.$inject = ['$scope', 'entity', 'Decriminalization', 'Department'];

    function DecriminalizationFormController($scope, entity, Decriminalization, Department) {

        var vm = this;

        vm.decriminalizations = [];

        vm.save = save;


        vm.decriminalization = entity;

        vm.showServiceType = false;
        vm.showServiceName = false;
        vm.showSector = false;
        vm.showOtherSector = false;
        vm.showOtherServiceType = false;
        vm.disableMinTenure = true;
        vm.disableMaxTenure = true;
        vm.disableMinAmount = true;
        vm.disableMaxAmount = true;

        loadAll();

        function loadAll() {
            getDepartments();
            Decriminalization.query(function(result) {
                vm.decriminalizations = result;
                vm.searchQuery = null;
            });
        }

        function save () {

            // if (vm.decriminalization.complianceRequest==null){
            //     alert("Please Choose Compliance Request Interface");
            //     return;
            // }

            if (vm.decriminalization.departmentId==null){
                alert("Please Select Department");
                return;
            }
            // if (vm.decriminalization.complianceRequest === "Citizen") {
            //
            //
            //     if (vm.decriminalization.serviceType==null){
            //         alert("Please Select Service Type");
            //         return;
            //     }
            //
            //     if (vm.decriminalization.serviceSchemeName==null){
            //         alert("Please Fill Service Scheme Name");
            //         return;
            //     }
            //
            //     if (vm.decriminalization.serviceType==="Other" && vm.decriminalization.otherServiceType==null){
            //         alert("Please Enter Other Service Type");
            //         return;
            //     }
            //
            // } else {
                if (vm.decriminalization.actName==null){
                    alert("Please Enter ACT Name");
                    return;
                }

                // if (vm.decriminalization.sector==null){
                //     alert("Please Select Sector");
                //     return;
                // }
                //
                // if (vm.decriminalization.sector==="Other" && vm.decriminalization.otherSector==null){
                //     alert("Please Enter Other Sector");
                //     return;
                // }
            // }

            // if (vm.decriminalization.ruleRegulation==null){
            //     alert("Please Select Rule Regulation");
            //     return;
            // }
            //
            // if (vm.decriminalization.ruleRegulationName==null){
            //     alert("Please Enter Rule Regulation Name");
            //     return;
            // }
            //
            //
            //
            // if (vm.decriminalization.sectionRuleNumber==null){
            //     alert("Please Select Section/Rule number");
            //     return;
            // }
            //
            //
            //
            //
            // if (vm.decriminalization.sectionRuleNumberCriminalProvision==null){
            //     alert("Please Enter Section/Rule number of Criminal Provision");
            //     return;
            // }
            //


            if (vm.decriminalization.criminalPunishmentDescription==null){
                alert("Please Enter Criminal Punishment Description");
                return;
            }




            if (vm.decriminalization.offence==null){
                alert("Please Select Offence");
                return;
            }

            if (vm.decriminalization.criminalPunishmentTenureInMonths==null){
                alert("Please Select Criminal Punishment Tenure in months");
                return;
            }

            if (vm.decriminalization.criminalPunishmentTenureInMonths==="Enter months" && vm.decriminalization.minimumTenure==null){
                alert("Please Enter Minimum Tenure");
                return;
            }

            if (vm.decriminalization.criminalPunishmentTenureInMonths==="Enter months" && vm.decriminalization.maximumTenure==null){
                alert("Please Enter Maximum Tenure");
                return;
            }


            if (vm.decriminalization.criminalPunishmentAmountInInr==null){
                alert("Please Enter Criminal Punishment Amount in INR");
                return;
            }

            if (vm.decriminalization.criminalPunishmentAmountInInr==="Enter Amount" && vm.decriminalization.minimumAmount==null){
                alert("Please Enter Minimum Amount");
                return;
            }


            if (vm.decriminalization.criminalPunishmentAmountInInr==="Enter Amount" && vm.decriminalization.maximumAmount==null){
                alert("Please Enter Maximum Amount");
                return;
            }


            vm.isSaving = true;
            if (vm.decriminalization.id !== null) {
                Decriminalization.update(vm.decriminalization, onSaveSuccess, onSaveError);
            } else {
                Decriminalization.save(vm.decriminalization, onSaveSuccess, onSaveError);
            }
        }

        // $scope.requestInterface = function (value) {
        //     //If DIV is visible it will be hidden and vice versa.
        //    if (value==="Citizen"){
        //
        //        vm.showServiceType = true;
        //        vm.showServiceName = true;
        //        vm.showSector = false;
        //
        //    } else {
        //        vm.showServiceType = false;
        //        vm.showServiceName = false;
        //        vm.showSector = true;
        //    }
        // }
        //
        // $scope.serviceTypeCheck = function () {
        //     if (vm.decriminalization.serviceType==="Other"){
        //
        //         vm.showOtherServiceType = true;
        //
        //     } else {
        //         vm.showOtherServiceType = false;
        //     }
        //
        //
        // }
        //
        // $scope.otherSectorCheck = function () {
        //     if (vm.decriminalization.sector==="Other"){
        //
        //         vm.showOtherSector = true;
        //
        //     } else {
        //         vm.showOtherSector = false;
        //     }
        //
        //
        // }

        $scope.crimePunMonths = function() {

            // Trim whitespace and make the comparison case-insensitive
            if (vm.decriminalization.criminalPunishmentTenureInMonths === "Enter months") {
                vm.disableMinTenure = false;
                vm.disableMaxTenure = false;
            } else {
                vm.disableMinTenure = true;
                vm.disableMaxTenure = true;
            }
        }


        $scope.crimePunAmount = function () {
            if (vm.decriminalization.criminalPunishmentAmountInInr==="Enter Amount"){
                vm.disableMinAmount = false;
                vm.disableMaxAmount = false;

            } else {
                vm.disableMinAmount = true;
                vm.disableMaxAmount = true;
            }


        }


        function onSaveSuccess (result) {

            alert("Form Submitted Successfully");

            vm.isSaving = false;
            window.location.href = '/';
        }

        function onSaveError () {
            alert("Error While Submitting Form! Please try again");
            vm.isSaving = false;
        }


        function getDepartments() {
            Department.query().$promise.then(function(data) {
                vm.departments = data;

            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('deactivateuser', {
                    parent: 'app',
                    url: '/deactivateuser',
                    data: {
                        authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/deactivateduplicateusers/deactivateuser.html',
                            controller: 'DeactivateUsersWithoutCafController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                 }]
             }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DeactivateUser', DeactivateUser);

    DeactivateUser.$inject = ['$resource'];

    function DeactivateUser ($resource) {
        var resourceUrl =  '/api/deactivateuser';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DeactivateUsersWithoutCafController', DeactivateUsersWithoutCafController);

    DeactivateUsersWithoutCafController.$inject = ['User','UserById','DeactivateUser'];

    function DeactivateUsersWithoutCafController(User,UserById,DeactivateUser) {

        var vm = this;
        vm.getUser = getUser;
        function getUser(id){
            UserById.get({id:id},function(user){
                vm.user = user;
            });
        }

        vm.deactivate = deactivate;
        function deactivate(user){
            vm.user.activated = false;
            DeactivateUser.update(vm.user,onSuccess,onError);
        }
        function onSuccess(result){
            alert("User Successfully Deactivated with login: " + result.login);
        }
        function onError(){
            alert("User Not Deactivated");
        }
    }
 })();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('GetDeactivatedCAFs', GetDeactivatedCAFs);

    GetDeactivatedCAFs.$inject = ['$resource'];

    function GetDeactivatedCAFs ($resource) {
        var resourceUrl =  'api/datewisedeptdashboard/getdeactivatedCAFs';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('datewiseDeptDashboard', {
            parent: 'app',
            url: '/datewiseDeptDashboard',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/datewiseDeptDashboard/datewiseDeptDashboard.html',
                    controller: 'DatewiseDeptDashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DatewiseDeptDashboard', DatewiseDeptDashboard);

    DatewiseDeptDashboard.$inject = ['$resource'];

    function DatewiseDeptDashboard ($resource) {
        var resourceUrl =  'api/datewisedeptdashboard/:fromdate/:todate/:amount/:area/:caftype/:sectortype/:employees';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'

                // uncomment for cassandra////////////
                // ,
                // transformResponse: function (data) {
                //     if (data) {
                //         data = angular.fromJson(data);
                //     }
                //     return data;
                // }
                ////////////////////////////////////////
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DatewiseDeptDashboardController', DatewiseDeptDashboardController)
        .filter('decimalFormat', function () {
            return function (text) {
                return parseFloat(text).toFixed(4).replace(/0+$/,'');
            };
        });

    DatewiseDeptDashboardController.$inject = ['$scope', '$filter','$window', 'Principal', 'LoginService', '$state', 'DatewiseDeptDashboard', 'Sector', 'Encryption', 'GetDeactivatedCAFs', '$location'];

    function DatewiseDeptDashboardController ($scope, $filter, $window , Principal, LoginService, $state, DatewiseDeptDashboard, Sector, Encryption, GetDeactivatedCAFs, $location) {
        var vm = this;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.getDatewiseDeptStat = getDatewiseDeptStat;
        vm.sectors = [];
        vm.showDeactivationDate = false;
        vm.datewisestatcollection = [];
        vm.downloadDeactivatedCAFs = download;
        vm.deactivatedCAFsAvailable = false;

        vm.sectorObj =  {
            id: " ",
            sectortype: "All",
            $$hashKey: " "
        };
        $scope.optionsForDatePicker = {
            maxDate: new Date(), // set this to whatever date you want to set
        };

        vm.selectedDate = function(dateSelected){
            var newDate = new Date(dateSelected);
            newDate.setDate(newDate.getDate()+30);
            if(newDate > Date.now()){
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: Date.now()
                };
            }
            else {
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: newDate
                };
            }
        };

        vm.amount = "all";
        vm.area = "all";
        vm.caftype = "new";
        vm.sector = "All";
        vm.employees = "all";
        vm.isDeactivatedRequested = false;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        vm.datePickerOpenStatus.startdate = false;
        vm.datePickerOpenStatus.enddate = false;
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        Sector.query(function(result) {
            result.unshift(vm.sectorObj);
            vm.sectors = result;
            vm.searchQuery = null;
        });

        function getDatewiseDeptStat() {
            vm.datewisestatcollection = null;
            vm.showDeactivationDate = false;
            vm.isDeactivatedRequested = false;
            if(vm.sectorObj.sectortype.includes("/")){
                vm.sector = vm.sectorObj.sectortype.split("/").join("=");
            }
            else{
                vm.sector = vm.sectorObj.sectortype;
            }
            var startdate = $filter('date')(vm.cafdetail.startdate , 'dd-MM-yyyy');
            var enddate =  $filter('date')(vm.cafdetail.enddate , 'dd-MM-yyyy');
            DatewiseDeptDashboard.query({fromdate:startdate, todate:enddate, amount:vm.amount, area:vm.area, caftype:vm.caftype, sectortype:vm.sector, employees:vm.employees},function(result) {
                vm.datewisestatcollection = result;
                vm.searchQuery = null;
                vm.show= true;
            });
            // DatewiseDeptDashboard.get({fromdate:startdate, todate:enddate, amount:vm.amount, area:vm.area, caftype:vm.caftype, sectortype:vm.sector, employees:vm.employees},function(result) {
            //     vm.datewisestatcollection = result.hits.hits;
            //     vm.searchQuery = null;
            //     vm.show= true;
            // });
        }

        getAccount();
        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                ga('set', 'page', $location.path());
                ga('send','pageview');
            });
        }
        function register () {
            $state.go('register');
        }

    ////////////uncomment if you want to use cassandra instead of elasticsearch//////////////////
    // vm.getDeactivatedCAFs = function(){
    //     vm.datewisestatcollection = null;
    //     GetDeactivatedCAFs.query(function(result){
    //         vm.showDeactivationDate = true;
    //         vm.isDeactivatedRequested = true;
    //         vm.datewisestatcollection = result;
    //     });
    // }
    ////////////////////////////////////////////////////////////////////////////////////////////

        vm.getDeactivatedCAFs = function(){
            vm.datewisestatcollection = null;
            vm.deactivatedCAFsAvailable = true;
            GetDeactivatedCAFs.get(function(result){
                vm.showDeactivationDate = true;
                vm.isDeactivatedRequested = true;
            // vm.datewisestatcollection = result.hits.hits;
                vm.deactivatedCAFsAvailable = true;
                download(result.hits.hits);
            });


        };

        function convertJsonsToArrays(args){
            var dataArray = [];
            var header = [ "Sr.",
                "CAFPin",
                "Investor Name",
                "Investor Email",
                "Investor Contact",
                "Business Entity",
                "Site Address",
                "District",
                "Project Level",
                "Proposed Employment",
                "Haryana Domicile",
                "Non-Haryana Domicile",
                "Proposed Investment(in crore)" ,
                "Proposed Area (in acres)",
                "Sector",
                "Project Purpose",
                "Project ID",
                "Application Date",
                "Deactivation Date",
                "Category Of Block",
                "Investment Type",
                "Product",
                "Start Date of Production",
                "Foreign Direct Investment",
            ];
            dataArray.push(header);
            for( var i = 0; i < args.length; i++ ){
                var row = args[i];
                var rowAr=[];
                var appliedDate=$filter('date')(row.serviceAppliedDate, 'dd-MM-yyyy');
                var clearedDate=$filter('date')(row.serviceClearedDate, 'dd-MM-yyyy');
                rowAr.push(i);
                rowAr.push(row._source.cafpin);
                rowAr.push(row._source.firstname);
                rowAr.push(row._source.emailprimary);
                rowAr.push(row._source.mobilenumber);
                rowAr.push(row._source.businessentity == "Renewable" ? "Renew" : row._source.businessentity);
                rowAr.push(row._source.siteaddress);
                rowAr.push(row._source.district);
                rowAr.push(row._source.projectlevel=="d" ? "DLCC" : "EEC");
                rowAr.push(row._source.totalpurposedemployment);
                rowAr.push(row._source.haryanadomicile);
                rowAr.push(row._source.nonharyanadomicile);
                rowAr.push(row._source.total_project_cost);
                rowAr.push(row._source.totalproposedprojectarea);
                rowAr.push(row._source.sectorname === 'Other Industries' ? row._source.otherSector + " - "+ row._source.sectorname : row._source.sectorname);
                rowAr.push(row._source.projectpurpose);
                rowAr.push(row._source.id);
                rowAr.push(row._source.applicationdate);
                rowAr.push(row._source.deactivateddate);
                rowAr.push(row._source.blockCategory);
                rowAr.push(row._source.investmentType);
                rowAr.push(row._source.product);
                rowAr.push(row._source.prodctionStartDate);
                rowAr.push(row._source.foreign_investment);
                dataArray.push(rowAr);
            }
            return dataArray;
        }

        function download(args) {
            var rows = convertJsonsToArrays(args);
            var lineArray = [];
            var lineArrayCleared = [];
            for(var i = 0; i < rows.length; i++){
                var line = rows[i].join("\t");
                lineArray.push(line);
            }
            lineArray = lineArray.join("\n");
            var a = document.createElement('a');
            var blob = new Blob([lineArray],{type: 'data:text/plain;charset=utf-8;'});
            var url = URL.createObjectURL(blob);
            $window.location.href = url;
            vm.deactivatedCAFsAvailable = false;
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DashboardbetweendatesCAFs', DashboardbetweendatesCAFs);

    DashboardbetweendatesCAFs.$inject = ['$resource'];

    function DashboardbetweendatesCAFs ($resource) {
        var resourceUrl =  'api/dashboardbetweendatesCAFs/:from/:to/:status/:serviceid';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DashboardbetweendatesCAFsController', DashboardbetweendatesCAFsController);

    DashboardbetweendatesCAFsController.$inject = ['DashboardbetweendatesCAFs','$stateParams','$uibModalInstance','$filter'];

    function DashboardbetweendatesCAFsController(DashboardbetweendatesCAFs,$stateParams,$uibModalInstance,$filter) {
        var vm = this;

        vm.clear=clear;
        vm.serviceid=$stateParams.serviceid;
        vm.fromdate=$stateParams.from;
        vm.todate=$stateParams.to;
        vm.status=$stateParams.status;

        loadAll();

        function loadAll() {
            var fromdate=$filter('date')(vm.fromdate, "dd-MM-yyyy");
            var todate=$filter('date')(vm.todate, "dd-MM-yyyy");
            DashboardbetweendatesCAFs.query({from:fromdate,to:todate,status:vm.status,serviceid:vm.serviceid},function (result) {
               vm.servicecafs=result;
               vm.show=true;
            });
        }

        function clear() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DashboardbetweendatesAllServices', DashboardbetweendatesAllServices);

    DashboardbetweendatesAllServices.$inject = ['$resource'];

    function DashboardbetweendatesAllServices ($resource) {
        var resourceUrl =  'api/dashboardbetweendatesallservices/:from/:to/:status/:fromdate/:todate/:All';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DashboardbetweendatesAllServicesController', DashboardbetweendatesAllServicesController);

    DashboardbetweendatesAllServicesController.$inject = ['DashboardbetweendatesAllServices','$stateParams','$uibModalInstance','$filter'];

    function DashboardbetweendatesAllServicesController(DashboardbetweendatesAllServices,$stateParams,$uibModalInstance,$filter) {
        var vm = this;

        vm.clear=clear;
        vm.fromdate=$stateParams.from;
        vm.todate=$stateParams.to;
        vm.status=$stateParams.status;

        loadAllServicesData();

        function loadAllServicesData() {
            vm.fromdate = new Date(vm.fromdate);
            vm.todate = new Date(vm.todate);
            var f = $filter('date')(vm.fromdate, "yyyy-MM-dd");
            var t = $filter('date')(vm.todate, "yyyy-MM-dd");
            var fromdate = $filter('date')(vm.fromdate, "dd-MM-yyyy");
            var todate = $filter('date')(vm.todate, "dd-MM-yyyy");
            DashboardbetweendatesAllServices.query({from:f,to:t,status:vm.status,fromdate:fromdate,todate:todate,All:'All'},function (result) {
               vm.servicecafs=result;
                console.log(vm.servicecafs);

                vm.show=true;
            });
        }

        function clear() {
            $uibModalInstance.close();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('dashboardbetweendates', {
            parent: 'app',
            url: '/dashboardbetweendates',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/dashboardbetweendates/dashboardbetweendates.html',
                    controller: 'DashboardbetweendatesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        })
        .state('dashboardCAFs', {
            parent: 'dashboardbetweendates',
            url: '/dashboardCAFs/{serviceid}/{status}/{from}/{to}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dashboardbetweendates/dashboardbetweendatesCAFs.html',
                    controller: 'DashboardbetweendatesCAFsController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowClass: 'app-modal-window',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('dashboardbetweendates', {}, { reload: false });
                }, function() {
                    $state.go('dashboardbetweendates');
                });
            }]
        })

        .state('dashboardCAFAllServices', {
            parent: 'dashboardbetweendates',
            url: '/dashboardCAFAllServices/{from}/{to}/{status}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dashboardbetweendates/dashboardbetweendatesAllServices.html',
                    controller: 'DashboardbetweendatesAllServicesController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    windowClass: 'app-modal-window',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('dashboardbetweendates', {}, { reload: false });
                }, function() {
                    $state.go('dashboardbetweendates');
                });
            }]
        });

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Dashboardbetweendates', Dashboardbetweendates);

    Dashboardbetweendates.$inject = ['$resource'];

    function Dashboardbetweendates ($resource) {
        var resourceUrl =  'api/dashboardbetweendates/:from/:to/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DashboardbetweendatesController', DashboardbetweendatesController);

    DashboardbetweendatesController.$inject = ['Dashboardbetweendates','$filter','AlertService','DashboardbetweendatesCAFs'];

    function DashboardbetweendatesController (Dashboardbetweendates,$filter,AlertService,DashboardbetweendatesCAFs) {
        var vm = this;

        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.status=['Applied','Pending','Cleared','Rejected'];
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        vm.datePickerOpenStatus.forMonth = false;
        vm.selectedDate=selectedDate;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }
        vm.dateOptions = {
            minDate: new Date("05-01-2017"),
            maxDate: Date.now()
        };

        vm.dateOptionsOnlyMonth = {
            minMode: 'month'
        };

        function selectedDate(dateSelected){
            var newDate = new Date(dateSelected);
            newDate.setDate(newDate.getDate()+30);
            if(newDate > Date.now()){
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: Date.now()
                };
            }
            else {
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: newDate
                };
            }
        }

        function loadAll() {
            vm.isloading=true;
            vm.dashboardsbydate=null;
            var f=$filter('date')(vm.fromdate, "yyyy-MM-dd");
            var t=$filter('date')(vm.todate, "yyyy-MM-dd");
            var m=$filter('date')(vm.fromMonth, "yyyy-MM");
            var fromdate=$filter('date')(vm.fromdate, "dd-MM-yyyy");
            var fromMonth=$filter('date')(vm.fromMonth, "MM-yyyy");
            var todate=$filter('date')(vm.todate, "dd-MM-yyyy");
            vm.toDate=todate;
            vm.fromDate=fromdate;
            vm.fromMonth=fromMonth;
            Dashboardbetweendates.query({from:f,to:t,status:vm.selectedStatus},onSuccess,onError);
            console.log(vm.dashboardsbydate);

            function onSuccess(result) {
                vm.dashboardsbydate=result;
                console.log(vm.dashboardsbydate);
                for (var i=0;i<vm.dashboardsbydate.length;i++){
                    if (vm.dashboardsbydate[i].departmentName==='DAKSHIN HARYANA BIJLI VITRAN NIGAM'){
                        vm.dashboardsbydate[i].deptorder=1;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='UTTAR HARYANA BIJLI VITRAN NIGAM'){
                        vm.dashboardsbydate[i].deptorder=2;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='HARYANA URBAN DEVELOPMENT AUTHORITY'){
                        vm.dashboardsbydate[i].deptorder=3;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='LABOUR DEPARTMENT - FACTORY WING'){
                        vm.dashboardsbydate[i].deptorder=10;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='LABOUR DEPARTMENT - LABOUR WING'){
                        vm.dashboardsbydate[i].deptorder=11;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='TOWN & COUNTRY PLANNING'){
                        vm.dashboardsbydate[i].deptorder=6;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='HARYANA STATE POLLUTION CONTROL BOARD'){
                        vm.dashboardsbydate[i].deptorder=8;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='URBAN LOCAL BODIES'){
                        vm.dashboardsbydate[i].deptorder=9;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='DEPARTMENT OF INDUSTRIES & COMMERCE'){
                        vm.dashboardsbydate[i].deptorder=4;
                    }

                    if (vm.dashboardsbydate[i].departmentName==='HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD'){
                        vm.dashboardsbydate[i].deptorder=5;
                    }
                }
            vm.header=vm.selectedStatus;
            vm.isloading=false;
            };
        }

        function loadAllMonthWise() {
            vm.isloading=true;
            vm.dashboardsbydate=null;
            // vm.fromMonth is the selected month (Date object)
            var year = vm.fromMonth.getFullYear();
            var month = vm.fromMonth.getMonth(); // 0-based (0=Jan, 11=Dec)

            var fromDate = new Date(year, month, 1);

            var toDate = new Date(year, month + 1, 0);

            var f = $filter('date')(fromDate, "yyyy-MM-dd");
            var t = $filter('date')(toDate, "yyyy-MM-dd");

            var fromdate=$filter('date')(fromDate, "dd-MM-yyyy");
            var fromMonth=$filter('date')(vm.fromMonth, "MM-yyyy");
            var todate=$filter('date')(toDate, "dd-MM-yyyy");
            vm.toDate=todate;
            vm.fromDate=fromdate;
            vm.fromMonth=fromMonth;
            Dashboardbetweendates.query({from:f,to:t,status:vm.selectedStatusMonth},onSuccess);
            console.log(vm.dashboardsbydate);

            function onSuccess(result) {
                vm.dashboardsbydate=result;
                console.log(vm.dashboardsbydate);
                for (var i=0;i<vm.dashboardsbydate.length;i++){
                    if (vm.dashboardsbydate[i].departmentName==='DAKSHIN HARYANA BIJLI VITRAN NIGAM'){
                        vm.dashboardsbydate[i].deptorder=1;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='UTTAR HARYANA BIJLI VITRAN NIGAM'){
                        vm.dashboardsbydate[i].deptorder=2;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='HARYANA URBAN DEVELOPMENT AUTHORITY'){
                        vm.dashboardsbydate[i].deptorder=3;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='LABOUR DEPARTMENT - FACTORY WING'){
                        vm.dashboardsbydate[i].deptorder=10;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='LABOUR DEPARTMENT - LABOUR WING'){
                        vm.dashboardsbydate[i].deptorder=11;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='TOWN & COUNTRY PLANNING'){
                        vm.dashboardsbydate[i].deptorder=6;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='HARYANA STATE POLLUTION CONTROL BOARD'){
                        vm.dashboardsbydate[i].deptorder=8;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='URBAN LOCAL BODIES'){
                        vm.dashboardsbydate[i].deptorder=9;

                    }
                    if (vm.dashboardsbydate[i].departmentName==='DEPARTMENT OF INDUSTRIES & COMMERCE'){
                        vm.dashboardsbydate[i].deptorder=4;
                    }

                    if (vm.dashboardsbydate[i].departmentName==='HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD'){
                        vm.dashboardsbydate[i].deptorder=5;
                    }
                }
                vm.header=vm.selectedStatusMonth;
                vm.isloading=false;
            };
        }

        function onError(){
            alert("Please enter a period between 31 days");
        }

        vm.getServicesBetweenDates=function () {
            /*if (vm.todate.getTime()< vm.fromdate.getTime()){
                AlertService.error('Invalid Dates');
                return;
            }*/
            loadAll();
        }

        vm.getServicesBetweenDatesMonthWise=function () {
            /*if (vm.todate.getTime()< vm.fromdate.getTime()){
                AlertService.error('Invalid Dates');
                return;
            }*/
            loadAllMonthWise();
        }

        vm.statusChanged=function () {
            vm.dashboardsbydate=null;
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ViewCaf', ViewCaf);

    ViewCaf.$inject = ['$resource'];

    function ViewCaf ($resource) {
        var resourceUrl =  'api/dashboardcafs/:department/:status';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('ViewCafController', ViewCafController);

    ViewCafController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'ViewCaf'];
    function ViewCafController ($timeout, $scope, $stateParams, $uibModalInstance, ViewCaf) {
        var vm = this;
        vm.clear = clear;
        vm.department=$stateParams.department;
        vm.status=$stateParams.status;
        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        loadAllCafs();

        function loadAllCafs() {
            vm.dashboardcafs=ViewCaf.query({department:$stateParams.department,status:$stateParams.status},function (result) {
                vm.show= !vm.show;
            });


        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('dashboard', {
            parent: 'app',
//            url: '/dashboard',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_ACCOUNT_OFFICER','ROLE_ASSIGNRM_OFFICER','ROLE_DESK_OFFICER','ROLE_FIELD_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_NODAL_OFFICER','ROLE_RM']
            },
            views: {
                'content@': {
                    templateUrl: 'app/dashboard/dashboard.html',
                    controller: 'DashboardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        })
        .state('dashboardcafs', {
            parent: 'dashboard',
            url: '/dashboardcafs/{department}/{status}',
            data: {
                authorities: []
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/dashboard/viewcafs.html',
                    controller: 'ViewCafController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('dashboard');
                            return $translate.refresh();
                        }]
                    }
                }).result.then(function() {
                    $state.go('dashboard', null, { reload: 'dashboard' });
                }, function() {
                    $state.go('dashboard');
                });
            }]
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DepartmentStats', DepartmentStats);

    DepartmentStats.$inject = ['$resource'];

    function DepartmentStats ($resource) {
        var resourceUrl =  'api/deptstatscollection/:deptname/:secparam';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('DashboardController', DashboardController);

    DashboardController.$inject = ['$scope', 'Principal', 'LoginService', '$state','DepartmentStats', '$location'];

    function DashboardController ($scope, Principal, LoginService, $state,DepartmentStats, $location) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
            ga('set', 'page', $location.path());
            ga('send','pageview');
        });

        getAccount();

        loadTotalstatcollection();
        function loadTotalstatcollection() {
                    DepartmentStats.get({deptname:"A",secparam:"B"},function(result) {
                        vm.totalstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadTcpstatcollection();
        function loadTcpstatcollection() {
                    DepartmentStats.get({deptname:"TOWN & COUNTRY PLANNING"},function(result) {
                        vm.tcpstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadHsiidcstatcollection();
        function loadHsiidcstatcollection() {
                    DepartmentStats.get({deptname:"HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD"},function(result) {
                        vm.hsiidcstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadPwdstatcollection();
        function loadPwdstatcollection() {
                    DepartmentStats.get({deptname:"PWD (B & R) DEPARTMENT"},function(result) {
                        vm.pwdstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadLabourstatcollection();
        function loadLabourstatcollection() {
                    DepartmentStats.get({deptname:"LABOUR DEPARTMENT - LABOUR WING"},function(result) {
                        vm.labourstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadHudastatcollection();
        function loadHudastatcollection() {
                    DepartmentStats.get({deptname:"HARYANA URBAN DEVELOPMENT AUTHORITY"},function(result) {
                        vm.hudastatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadDhbvnstatcollection();
        function loadDhbvnstatcollection() {
                    DepartmentStats.get({deptname:"DAKSHIN HARYANA BIJLI VITRAN NIGAM"},function(result) {
                        vm.dhbvnstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadFoodnsupplystatcollection();
        function loadFoodnsupplystatcollection() {
                    DepartmentStats.get({deptname:"FOOD & SUPPLIES DEPARTMENT"},function(result) {
                        vm.foodnsupplystatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadHspcbstatcollection();
        function loadHspcbstatcollection() {
                    DepartmentStats.get({deptname:"HARYANA STATE POLLUTION CONTROL BOARD"},function(result) {
                        vm.hspcbstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadUhbvnstatcollection();
        function loadUhbvnstatcollection() {
                    DepartmentStats.get({deptname:"UTTAR HARYANA BIJLI VITRAN NIGAM"},function(result) {
                        vm.uhbvnstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadUlbstatcollection();
        function loadUlbstatcollection() {
                    DepartmentStats.get({deptname:"URBAN LOCAL BODIES"},function(result) {
                        vm.ulbstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadAyushstatcollection();
        function loadAyushstatcollection() {
                    DepartmentStats.get({deptname:"DEPARTMENT OF AYUSH"},function(result) {
                        vm.ayushstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadEnvironmentstatcollection();
        function loadEnvironmentstatcollection() {
                    DepartmentStats.get({deptname:"ENVIRONMENT"},function(result) {
                        vm.environmentstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadCeistatcollection();
        function loadCeistatcollection() {
                    DepartmentStats.get({deptname:"CHIEF ELECTRICAL INSPECTOR"},function(result) {
                        vm.ceistatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadDicstatcollection();
        function loadDicstatcollection() {
                    DepartmentStats.get({deptname:"DEPARTMENT OF INDUSTRIES & COMMERCE"},function(result) {
                        vm.dicstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadPhedstatcollection();
        function loadPhedstatcollection() {
                    DepartmentStats.get({deptname:"PUBLIC HEALTH ENGINEERING DEPARTMENT"},function(result) {
                        vm.phedstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadExcisestatcollection();
        function loadExcisestatcollection() {
                    DepartmentStats.get({deptname:"EXCISE & TAXATION - EXCISE"},function(result) {
                        vm.excisestatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadMinesstatcollection();
        function loadMinesstatcollection() {
                    DepartmentStats.get({deptname:"MINES & GEOLOGY DEPARTMENT"},function(result) {
                        vm.minesstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadFnWstatcollection();
        function loadFnWstatcollection() {
                    DepartmentStats.get({deptname:"DEPARTMENT OF FORESTS & WILDLIFE"},function(result) {
                        vm.fnwstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadFoodndrugstatcollection();
        function loadFoodndrugstatcollection() {
                    DepartmentStats.get({deptname:"Food and Drug Administration"},function(result) {
                        vm.foodndrugstatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadRenewablestatcollection();
        function loadRenewablestatcollection() {
                    DepartmentStats.get({deptname:"DEPARTMENT OF RENEWABLE ENERGY"},function(result) {
                        vm.renewablestatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadAgriculturestatcollection();
        function loadAgriculturestatcollection() {
                    DepartmentStats.get({deptname:"DEPARTMENT OF AGRICULTURE"},function(result) {
                        vm.agriculturestatcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadLabourfactorywingstatcollection();
        function loadLabourfactorywingstatcollection() {
                    DepartmentStats.get({deptname:"LABOUR DEPARTMENT - FACTORY WING"},function(result) {
                        vm.labourfactorywingstatcollection = result;
                        vm.searchQuery = null;
                    });
                }


        loadNationalMonumentAuthoruty();
        function loadNationalMonumentAuthoruty() {
                    DepartmentStats.get({deptname:"National Monument Authority"},function(result) {
                        vm.loadnationalmonumentcollection = result;
                        vm.searchQuery = null;
                    });
                }

        loadAirportAuthority();
        function loadAirportAuthority() {
                    DepartmentStats.get({deptname:"Airport Authority of India"},function(result) {
                        vm.loadairportauthoritycollection = result;
                        vm.searchQuery = null;
                    });
                }




        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

    }
})();

function download_table_data() {
    $("#result_table").tableToCSV();
}

function download_table_data1() {
    $("#result_table1").tableToCSV();
}

jQuery.fn.tableToCSV = function() {

    var clean_text = function(text){
        text = text.replace(/"/g, '""');
        return '"'+text+'"';
    };

    $(this).each(function(){
        var table = $(this);
        var caption = $(this).find('caption').text();
        var title = [];
        var rows = [];

        $(this).find('tr').each(function(){
            var data = [];
            $(this).find('th').each(function(){
                var text = clean_text($(this).text());
                if (text!=='""'){
                    title.push(text);
                }
            });
            $(this).find('td').each(function(){
                var text = clean_text($(this).text());
                if (text!=='"View Service Log"') {
                    data.push(text);
                }
            });
            data = data.join(",");
            rows.push(data);
        });
        title = title.join(",");
        rows = rows.join("\n");

        var csv = title + rows;
        var uri = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
        var download_link = document.createElement('a');
        download_link.href = uri;
        var ts = new Date().getTime();
        if(caption==""){
            download_link.download = ts+".csv";
        } else {
            download_link.download = caption+"-"+ts+".csv";
        }
        document.body.appendChild(download_link);
        download_link.click();
        document.body.removeChild(download_link);
    });

};

/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2006, 2014 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD (Register as an anonymous module)
        define(['jquery'], factory);
    } else if (typeof exports === 'object') {
        // Node/CommonJS
        module.exports = factory(require('jquery'));
    } else {
        // Browser globals
        factory(jQuery);
    }
}(function ($) {

    var pluses = /\+/g;

    function encode(s) {
        return config.raw ? s : encodeURIComponent(s);
    }

    function decode(s) {
        return config.raw ? s : decodeURIComponent(s);
    }

    function stringifyCookieValue(value) {
        return encode(config.json ? JSON.stringify(value) : String(value));
    }

    function parseCookieValue(s) {
        if (s.indexOf('"') === 0) {
            // This is a quoted cookie as according to RFC2068, unescape...
            s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
        }

        try {
            // Replace server-side written pluses with spaces.
            // If we can't decode the cookie, ignore it, it's unusable.
            // If we can't parse the cookie, ignore it, it's unusable.
            s = decodeURIComponent(s.replace(pluses, ' '));
            return config.json ? JSON.parse(s) : s;
        } catch(e) {}
    }

    function read(s, converter) {
        var value = config.raw ? s : parseCookieValue(s);
        return $.isFunction(converter) ? converter(value) : value;
    }

    var config = $.cookie = function (key, value, options) {

        // Write

        if (arguments.length > 1 && !$.isFunction(value)) {
            options = $.extend({}, config.defaults, options);

            if (typeof options.expires === 'number') {
                var days = options.expires, t = options.expires = new Date();
                t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
            }

            return (document.cookie = [
                encode(key), '=', stringifyCookieValue(value),
                options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                options.path    ? '; path=' + options.path : '',
                options.domain  ? '; domain=' + options.domain : '',
                options.secure  ? '; secure' : ''
            ].join(''));
        }

        // Read

        var result = key ? undefined : {},
            // To prevent the for loop in the first place assign an empty array
            // in case there are no cookies at all. Also prevents odd result when
            // calling $.cookie().
            cookies = document.cookie ? document.cookie.split('; ') : [],
            i = 0,
            l = cookies.length;

        for (; i < l; i++) {
            var parts = cookies[i].split('='),
                name = decode(parts.shift()),
                cookie = parts.join('=');

            if (key === name) {
                // If second argument (value) is a function it's a converter...
                result = read(cookie, value);
                break;
            }

            // Prevent storing a cookie that we couldn't decode.
            if (!key && (cookie = read(cookie)) !== undefined) {
                result[name] = cookie;
            }
        }

        return result;
    };

    config.defaults = {};

    $.removeCookie = function (key, options) {
        // Must not alter options, thus extending a fresh object...
        $.cookie(key, '', $.extend({}, options, { expires: -1 }));
        return !$.cookie(key);
    };

}));

/** @license
 *
 * jsPDF - PDF Document creation from JavaScript
 * Version 2.5.2 Built on 2024-09-17T13:29:57.856Z
 *                      CommitID 00000000
 *
 * Copyright (c) 2010-2021 James Hall <james@parall.ax>, https://github.com/MrRio/jsPDF
 *               2015-2021 yWorks GmbH, http://www.yworks.com
 *               2015-2021 Lukas Holländer <lukas.hollaender@yworks.com>, https://github.com/HackbrettXXX
 *               2016-2018 Aras Abbasi <aras.abbasi@gmail.com>
 *               2010 Aaron Spike, https://github.com/acspike
 *               2012 Willow Systems Corporation, https://github.com/willowsystems
 *               2012 Pablo Hess, https://github.com/pablohess
 *               2012 Florian Jenett, https://github.com/fjenett
 *               2013 Warren Weckesser, https://github.com/warrenweckesser
 *               2013 Youssef Beddad, https://github.com/lifof
 *               2013 Lee Driscoll, https://github.com/lsdriscoll
 *               2013 Stefan Slonevskiy, https://github.com/stefslon
 *               2013 Jeremy Morel, https://github.com/jmorel
 *               2013 Christoph Hartmann, https://github.com/chris-rock
 *               2014 Juan Pablo Gaviria, https://github.com/juanpgaviria
 *               2014 James Makes, https://github.com/dollaruw
 *               2014 Diego Casorran, https://github.com/diegocr
 *               2014 Steven Spungin, https://github.com/Flamenco
 *               2014 Kenneth Glassey, https://github.com/Gavvers
 *
 * Permission is hereby granted, free of charge, to any person obtaining
 * a copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to
 * permit persons to whom the Software is furnished to do so, subject to
 * the following conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
 * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
 * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
 * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
 *
 * Contributor(s):
 *    siefkenj, ahwolf, rickygu, Midnith, saintclair, eaparango,
 *    kim3er, mfo, alnorth, Flamenco
 */

!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t=t||self).jspdf={})}(this,(function(t){"use strict";function e(t){return(e="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}var r=function(){return"undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:this}();function n(){r.console&&"function"==typeof r.console.log&&r.console.log.apply(r.console,arguments)}var i={log:n,warn:function(t){r.console&&("function"==typeof r.console.warn?r.console.warn.apply(r.console,arguments):n.call(null,arguments))},error:function(t){r.console&&("function"==typeof r.console.error?r.console.error.apply(r.console,arguments):n(t))}};function a(t,e,r){var n=new XMLHttpRequest;n.open("GET",t),n.responseType="blob",n.onload=function(){l(n.response,e,r)},n.onerror=function(){i.error("could not download file")},n.send()}function o(t){var e=new XMLHttpRequest;e.open("HEAD",t,!1);try{e.send()}catch(t){}return e.status>=200&&e.status<=299}function s(t){try{t.dispatchEvent(new MouseEvent("click"))}catch(r){var e=document.createEvent("MouseEvents");e.initMouseEvent("click",!0,!0,window,0,0,0,80,20,!1,!1,!1,!1,0,null),t.dispatchEvent(e)}}var c,u,l=r.saveAs||("object"!==("undefined"==typeof window?"undefined":e(window))||window!==r?function(){}:"undefined"!=typeof HTMLAnchorElement&&"download"in HTMLAnchorElement.prototype?function(t,e,n){var i=r.URL||r.webkitURL,c=document.createElement("a");e=e||t.name||"download",c.download=e,c.rel="noopener","string"==typeof t?(c.href=t,c.origin!==location.origin?o(c.href)?a(t,e,n):s(c,c.target="_blank"):s(c)):(c.href=i.createObjectURL(t),setTimeout((function(){i.revokeObjectURL(c.href)}),4e4),setTimeout((function(){s(c)}),0))}:"msSaveOrOpenBlob"in navigator?function(t,r,n){if(r=r||t.name||"download","string"==typeof t)if(o(t))a(t,r,n);else{var c=document.createElement("a");c.href=t,c.target="_blank",setTimeout((function(){s(c)}))}else navigator.msSaveOrOpenBlob(function(t,r){return void 0===r?r={autoBom:!1}:"object"!==e(r)&&(i.warn("Deprecated: Expected third argument to be a object"),r={autoBom:!r}),r.autoBom&&/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(t.type)?new Blob([String.fromCharCode(65279),t],{type:t.type}):t}(t,n),r)}:function(t,n,i,o){if((o=o||open("","_blank"))&&(o.document.title=o.document.body.innerText="downloading..."),"string"==typeof t)return a(t,n,i);var s="application/octet-stream"===t.type,c=/constructor/i.test(r.HTMLElement)||r.safari,u=/CriOS\/[\d]+/.test(navigator.userAgent);if((u||s&&c)&&"object"===("undefined"==typeof FileReader?"undefined":e(FileReader))){var l=new FileReader;l.onloadend=function(){var t=l.result;t=u?t:t.replace(/^data:[^;]*;/,"data:attachment/file;"),o?o.location.href=t:location=t,o=null},l.readAsDataURL(t)}else{var h=r.URL||r.webkitURL,f=h.createObjectURL(t);o?o.location=f:location.href=f,o=null,setTimeout((function(){h.revokeObjectURL(f)}),4e4)}});
/**
   * A class to parse color values
   * @author Stoyan Stefanov <sstoo@gmail.com>
   * {@link   http://www.phpied.com/rgb-color-parser-in-javascript/}
   * @license Use it if you like it
   */function h(t){var e;t=t||"",this.ok=!1,"#"==t.charAt(0)&&(t=t.substr(1,6));t={aliceblue:"f0f8ff",antiquewhite:"faebd7",aqua:"00ffff",aquamarine:"7fffd4",azure:"f0ffff",beige:"f5f5dc",bisque:"ffe4c4",black:"000000",blanchedalmond:"ffebcd",blue:"0000ff",blueviolet:"8a2be2",brown:"a52a2a",burlywood:"deb887",cadetblue:"5f9ea0",chartreuse:"7fff00",chocolate:"d2691e",coral:"ff7f50",cornflowerblue:"6495ed",cornsilk:"fff8dc",crimson:"dc143c",cyan:"00ffff",darkblue:"00008b",darkcyan:"008b8b",darkgoldenrod:"b8860b",darkgray:"a9a9a9",darkgreen:"006400",darkkhaki:"bdb76b",darkmagenta:"8b008b",darkolivegreen:"556b2f",darkorange:"ff8c00",darkorchid:"9932cc",darkred:"8b0000",darksalmon:"e9967a",darkseagreen:"8fbc8f",darkslateblue:"483d8b",darkslategray:"2f4f4f",darkturquoise:"00ced1",darkviolet:"9400d3",deeppink:"ff1493",deepskyblue:"00bfff",dimgray:"696969",dodgerblue:"1e90ff",feldspar:"d19275",firebrick:"b22222",floralwhite:"fffaf0",forestgreen:"228b22",fuchsia:"ff00ff",gainsboro:"dcdcdc",ghostwhite:"f8f8ff",gold:"ffd700",goldenrod:"daa520",gray:"808080",green:"008000",greenyellow:"adff2f",honeydew:"f0fff0",hotpink:"ff69b4",indianred:"cd5c5c",indigo:"4b0082",ivory:"fffff0",khaki:"f0e68c",lavender:"e6e6fa",lavenderblush:"fff0f5",lawngreen:"7cfc00",lemonchiffon:"fffacd",lightblue:"add8e6",lightcoral:"f08080",lightcyan:"e0ffff",lightgoldenrodyellow:"fafad2",lightgrey:"d3d3d3",lightgreen:"90ee90",lightpink:"ffb6c1",lightsalmon:"ffa07a",lightseagreen:"20b2aa",lightskyblue:"87cefa",lightslateblue:"8470ff",lightslategray:"778899",lightsteelblue:"b0c4de",lightyellow:"ffffe0",lime:"00ff00",limegreen:"32cd32",linen:"faf0e6",magenta:"ff00ff",maroon:"800000",mediumaquamarine:"66cdaa",mediumblue:"0000cd",mediumorchid:"ba55d3",mediumpurple:"9370d8",mediumseagreen:"3cb371",mediumslateblue:"7b68ee",mediumspringgreen:"00fa9a",mediumturquoise:"48d1cc",mediumvioletred:"c71585",midnightblue:"191970",mintcream:"f5fffa",mistyrose:"ffe4e1",moccasin:"ffe4b5",navajowhite:"ffdead",navy:"000080",oldlace:"fdf5e6",olive:"808000",olivedrab:"6b8e23",orange:"ffa500",orangered:"ff4500",orchid:"da70d6",palegoldenrod:"eee8aa",palegreen:"98fb98",paleturquoise:"afeeee",palevioletred:"d87093",papayawhip:"ffefd5",peachpuff:"ffdab9",peru:"cd853f",pink:"ffc0cb",plum:"dda0dd",powderblue:"b0e0e6",purple:"800080",red:"ff0000",rosybrown:"bc8f8f",royalblue:"4169e1",saddlebrown:"8b4513",salmon:"fa8072",sandybrown:"f4a460",seagreen:"2e8b57",seashell:"fff5ee",sienna:"a0522d",silver:"c0c0c0",skyblue:"87ceeb",slateblue:"6a5acd",slategray:"708090",snow:"fffafa",springgreen:"00ff7f",steelblue:"4682b4",tan:"d2b48c",teal:"008080",thistle:"d8bfd8",tomato:"ff6347",turquoise:"40e0d0",violet:"ee82ee",violetred:"d02090",wheat:"f5deb3",white:"ffffff",whitesmoke:"f5f5f5",yellow:"ffff00",yellowgreen:"9acd32"}[t=(t=t.replace(/ /g,"")).toLowerCase()]||t;for(var r=[{re:/^rgb\((\d{1,3}),\s*(\d{1,3}),\s*(\d{1,3})\)$/,example:["rgb(123, 234, 45)","rgb(255,234,245)"],process:function(t){return[parseInt(t[1]),parseInt(t[2]),parseInt(t[3])]}},{re:/^(\w{2})(\w{2})(\w{2})$/,example:["#00ff00","336699"],process:function(t){return[parseInt(t[1],16),parseInt(t[2],16),parseInt(t[3],16)]}},{re:/^(\w{1})(\w{1})(\w{1})$/,example:["#fb0","f0f"],process:function(t){return[parseInt(t[1]+t[1],16),parseInt(t[2]+t[2],16),parseInt(t[3]+t[3],16)]}}],n=0;n<r.length;n++){var i=r[n].re,a=r[n].process,o=i.exec(t);o&&(e=a(o),this.r=e[0],this.g=e[1],this.b=e[2],this.ok=!0)}this.r=this.r<0||isNaN(this.r)?0:this.r>255?255:this.r,this.g=this.g<0||isNaN(this.g)?0:this.g>255?255:this.g,this.b=this.b<0||isNaN(this.b)?0:this.b>255?255:this.b,this.toRGB=function(){return"rgb("+this.r+", "+this.g+", "+this.b+")"},this.toHex=function(){var t=this.r.toString(16),e=this.g.toString(16),r=this.b.toString(16);return 1==t.length&&(t="0"+t),1==e.length&&(e="0"+e),1==r.length&&(r="0"+r),"#"+t+e+r}}
/**
   * @license
   * Joseph Myers does not specify a particular license for his work.
   *
   * Author: Joseph Myers
   * Accessed from: http://www.myersdaily.org/joseph/javascript/md5.js
   *
   * Modified by: Owen Leong
   */
function f(t,e){var r=t[0],n=t[1],i=t[2],a=t[3];r=p(r,n,i,a,e[0],7,-680876936),a=p(a,r,n,i,e[1],12,-389564586),i=p(i,a,r,n,e[2],17,606105819),n=p(n,i,a,r,e[3],22,-1044525330),r=p(r,n,i,a,e[4],7,-176418897),a=p(a,r,n,i,e[5],12,1200080426),i=p(i,a,r,n,e[6],17,-1473231341),n=p(n,i,a,r,e[7],22,-45705983),r=p(r,n,i,a,e[8],7,1770035416),a=p(a,r,n,i,e[9],12,-1958414417),i=p(i,a,r,n,e[10],17,-42063),n=p(n,i,a,r,e[11],22,-1990404162),r=p(r,n,i,a,e[12],7,1804603682),a=p(a,r,n,i,e[13],12,-40341101),i=p(i,a,r,n,e[14],17,-1502002290),r=g(r,n=p(n,i,a,r,e[15],22,1236535329),i,a,e[1],5,-165796510),a=g(a,r,n,i,e[6],9,-1069501632),i=g(i,a,r,n,e[11],14,643717713),n=g(n,i,a,r,e[0],20,-373897302),r=g(r,n,i,a,e[5],5,-701558691),a=g(a,r,n,i,e[10],9,38016083),i=g(i,a,r,n,e[15],14,-660478335),n=g(n,i,a,r,e[4],20,-405537848),r=g(r,n,i,a,e[9],5,568446438),a=g(a,r,n,i,e[14],9,-1019803690),i=g(i,a,r,n,e[3],14,-187363961),n=g(n,i,a,r,e[8],20,1163531501),r=g(r,n,i,a,e[13],5,-1444681467),a=g(a,r,n,i,e[2],9,-51403784),i=g(i,a,r,n,e[7],14,1735328473),r=m(r,n=g(n,i,a,r,e[12],20,-1926607734),i,a,e[5],4,-378558),a=m(a,r,n,i,e[8],11,-2022574463),i=m(i,a,r,n,e[11],16,1839030562),n=m(n,i,a,r,e[14],23,-35309556),r=m(r,n,i,a,e[1],4,-1530992060),a=m(a,r,n,i,e[4],11,1272893353),i=m(i,a,r,n,e[7],16,-155497632),n=m(n,i,a,r,e[10],23,-1094730640),r=m(r,n,i,a,e[13],4,681279174),a=m(a,r,n,i,e[0],11,-358537222),i=m(i,a,r,n,e[3],16,-722521979),n=m(n,i,a,r,e[6],23,76029189),r=m(r,n,i,a,e[9],4,-640364487),a=m(a,r,n,i,e[12],11,-421815835),i=m(i,a,r,n,e[15],16,530742520),r=v(r,n=m(n,i,a,r,e[2],23,-995338651),i,a,e[0],6,-198630844),a=v(a,r,n,i,e[7],10,1126891415),i=v(i,a,r,n,e[14],15,-1416354905),n=v(n,i,a,r,e[5],21,-57434055),r=v(r,n,i,a,e[12],6,1700485571),a=v(a,r,n,i,e[3],10,-1894986606),i=v(i,a,r,n,e[10],15,-1051523),n=v(n,i,a,r,e[1],21,-2054922799),r=v(r,n,i,a,e[8],6,1873313359),a=v(a,r,n,i,e[15],10,-30611744),i=v(i,a,r,n,e[6],15,-1560198380),n=v(n,i,a,r,e[13],21,1309151649),r=v(r,n,i,a,e[4],6,-145523070),a=v(a,r,n,i,e[11],10,-1120210379),i=v(i,a,r,n,e[2],15,718787259),n=v(n,i,a,r,e[9],21,-343485551),t[0]=S(r,t[0]),t[1]=S(n,t[1]),t[2]=S(i,t[2]),t[3]=S(a,t[3])}function d(t,e,r,n,i,a){return e=S(S(e,t),S(n,a)),S(e<<i|e>>>32-i,r)}function p(t,e,r,n,i,a,o){return d(e&r|~e&n,t,e,i,a,o)}function g(t,e,r,n,i,a,o){return d(e&n|r&~n,t,e,i,a,o)}function m(t,e,r,n,i,a,o){return d(e^r^n,t,e,i,a,o)}function v(t,e,r,n,i,a,o){return d(r^(e|~n),t,e,i,a,o)}function b(t){var e,r=t.length,n=[1732584193,-271733879,-1732584194,271733878];for(e=64;e<=t.length;e+=64)f(n,y(t.substring(e-64,e)));t=t.substring(e-64);var i=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];for(e=0;e<t.length;e++)i[e>>2]|=t.charCodeAt(e)<<(e%4<<3);if(i[e>>2]|=128<<(e%4<<3),e>55)for(f(n,i),e=0;e<16;e++)i[e]=0;return i[14]=8*r,f(n,i),n}function y(t){var e,r=[];for(e=0;e<64;e+=4)r[e>>2]=t.charCodeAt(e)+(t.charCodeAt(e+1)<<8)+(t.charCodeAt(e+2)<<16)+(t.charCodeAt(e+3)<<24);return r}c=r.atob.bind(r),u=r.btoa.bind(r);var w="0123456789abcdef".split("");function N(t){for(var e="",r=0;r<4;r++)e+=w[t>>8*r+4&15]+w[t>>8*r&15];return e}function L(t){return String.fromCharCode((255&t)>>0,(65280&t)>>8,(16711680&t)>>16,(4278190080&t)>>24)}function A(t){return function(t){return t.map(L).join("")}(b(t))}var x="5d41402abc4b2a76b9719d911017c592"!=function(t){for(var e=0;e<t.length;e++)t[e]=N(t[e]);return t.join("")}(b("hello"));function S(t,e){if(x){var r=(65535&t)+(65535&e);return(t>>16)+(e>>16)+(r>>16)<<16|65535&r}return t+e&4294967295}
/**
   * @license
   * FPDF is released under a permissive license: there is no usage restriction.
   * You may embed it freely in your application (commercial or not), with or
   * without modifications.
   *
   * Reference: http://www.fpdf.org/en/script/script37.php
   */function _(t,e){var r,n,i,a;if(t!==r){for(var o=(i=t,a=1+(256/t.length>>0),new Array(a+1).join(i)),s=[],c=0;c<256;c++)s[c]=c;var u=0;for(c=0;c<256;c++){var l=s[c];u=(u+l+o.charCodeAt(c))%256,s[c]=s[u],s[u]=l}r=t,n=s}else s=n;var h=e.length,f=0,d=0,p="";for(c=0;c<h;c++)d=(d+(l=s[f=(f+1)%256]))%256,s[f]=s[d],s[d]=l,o=s[(s[f]+s[d])%256],p+=String.fromCharCode(e.charCodeAt(c)^o);return p}
/**
   * @license
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   * Author: Owen Leong (@owenl131)
   * Date: 15 Oct 2020
   * References:
   * https://www.cs.cmu.edu/~dst/Adobe/Gallery/anon21jul01-pdf-encryption.txt
   * https://github.com/foliojs/pdfkit/blob/master/lib/security.js
   * http://www.fpdf.org/en/script/script37.php
   */var P={print:4,modify:8,copy:16,"annot-forms":32};function k(t,e,r,n){this.v=1,this.r=2;var i=192;t.forEach((function(t){if(void 0!==P.perm)throw new Error("Invalid permission: "+t);i+=P[t]})),this.padding="(¿N^NuAd\0NVÿú\b..\0¶Ðh>/\f©þdSiz";var a=(e+this.padding).substr(0,32),o=(r+this.padding).substr(0,32);this.O=this.processOwnerPassword(a,o),this.P=-(1+(255^i)),this.encryptionKey=A(a+this.O+this.lsbFirstWord(this.P)+this.hexToBytes(n)).substr(0,5),this.U=_(this.encryptionKey,this.padding)}function F(t){if(/[^\u0000-\u00ff]/.test(t))throw new Error("Invalid PDF Name Object: "+t+", Only accept ASCII characters.");for(var e="",r=t.length,n=0;n<r;n++){var i=t.charCodeAt(n);if(i<33||35===i||37===i||40===i||41===i||47===i||60===i||62===i||91===i||93===i||123===i||125===i||i>126)e+="#"+("0"+i.toString(16)).slice(-2);else e+=t[n]}return e}function I(t){if("object"!==e(t))throw new Error("Invalid Context passed to initialize PubSub (jsPDF-module)");var n={};this.subscribe=function(t,e,r){if(r=r||!1,"string"!=typeof t||"function"!=typeof e||"boolean"!=typeof r)throw new Error("Invalid arguments passed to PubSub.subscribe (jsPDF-module)");n.hasOwnProperty(t)||(n[t]={});var i=Math.random().toString(35);return n[t][i]=[e,!!r],i},this.unsubscribe=function(t){for(var e in n)if(n[e][t])return delete n[e][t],0===Object.keys(n[e]).length&&delete n[e],!0;return!1},this.publish=function(e){if(n.hasOwnProperty(e)){var a=Array.prototype.slice.call(arguments,1),o=[];for(var s in n[e]){var c=n[e][s];try{c[0].apply(t,a)}catch(t){r.console&&i.error("jsPDF PubSub Error",t.message,t)}c[1]&&o.push(s)}o.length&&o.forEach(this.unsubscribe)}},this.getTopics=function(){return n}}function C(t){if(!(this instanceof C))return new C(t);var e="opacity,stroke-opacity".split(",");for(var r in t)t.hasOwnProperty(r)&&e.indexOf(r)>=0&&(this[r]=t[r]);this.id="",this.objectNumber=-1}function j(t,e){this.gState=t,this.matrix=e,this.id="",this.objectNumber=-1}function O(t,e,r,n,i){if(!(this instanceof O))return new O(t,e,r,n,i);this.type="axial"===t?2:3,this.coords=e,this.colors=r,j.call(this,n,i)}function B(t,e,r,n,i){if(!(this instanceof B))return new B(t,e,r,n,i);this.boundingBox=t,this.xStep=e,this.yStep=r,this.stream="",this.cloneIndex=0,j.call(this,n,i)}function M(t){var n,a="string"==typeof arguments[0]?arguments[0]:"p",o=arguments[1],s=arguments[2],c=arguments[3],f=[],d=1,p=16,g="S",m=null;"object"===e(t=t||{})&&(a=t.orientation,o=t.unit||o,s=t.format||s,c=t.compress||t.compressPdf||c,null!==(m=t.encryption||null)&&(m.userPassword=m.userPassword||"",m.ownerPassword=m.ownerPassword||"",m.userPermissions=m.userPermissions||[]),d="number"==typeof t.userUnit?Math.abs(t.userUnit):1,void 0!==t.precision&&(n=t.precision),void 0!==t.floatPrecision&&(p=t.floatPrecision),g=t.defaultPathOperation||"S"),f=t.filters||(!0===c?["FlateEncode"]:f),o=o||"mm",a=(""+(a||"P")).toLowerCase();var v=t.putOnlyUsedFonts||!1,b={},y={internal:{},__private__:{}};y.__private__.PubSub=I;var w="1.3",N=y.__private__.getPdfVersion=function(){return w};y.__private__.setPdfVersion=function(t){w=t};var L={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};y.__private__.getPageFormats=function(){return L};var A=y.__private__.getPageFormat=function(t){return L[t]};s=s||"a4";var x={COMPAT:"compat",ADVANCED:"advanced"},S=x.COMPAT;function _(){this.saveGraphicsState(),ht(new Vt(_t,0,0,-_t,0,Rr()*_t).toString()+" cm"),this.setFontSize(this.getFontSize()/_t),g="n",S=x.ADVANCED}function P(){this.restoreGraphicsState(),g="S",S=x.COMPAT}var j=y.__private__.combineFontStyleAndFontWeight=function(t,e){if("bold"==t&&"normal"==e||"bold"==t&&400==e||"normal"==t&&"italic"==e||"bold"==t&&"italic"==e)throw new Error("Invalid Combination of fontweight and fontstyle");return e&&(t=400==e||"normal"===e?"italic"===t?"italic":"normal":700!=e&&"bold"!==e||"normal"!==t?(700==e?"bold":e)+""+t:"bold"),t};y.advancedAPI=function(t){var e=S===x.COMPAT;return e&&_.call(this),"function"!=typeof t||(t(this),e&&P.call(this)),this},y.compatAPI=function(t){var e=S===x.ADVANCED;return e&&P.call(this),"function"!=typeof t||(t(this),e&&_.call(this)),this},y.isAdvancedAPI=function(){return S===x.ADVANCED};var E,q=function(t){if(S!==x.ADVANCED)throw new Error(t+" is only available in 'advanced' API mode. You need to call advancedAPI() first.")},D=y.roundToPrecision=y.__private__.roundToPrecision=function(t,e){var r=n||e;if(isNaN(t)||isNaN(r))throw new Error("Invalid argument passed to jsPDF.roundToPrecision");return t.toFixed(r).replace(/0+$/,"")};E=y.hpf=y.__private__.hpf="number"==typeof p?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,p)}:"smart"===p?function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,t>-1&&t<1?16:5)}:function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.hpf");return D(t,16)};var R=y.f2=y.__private__.f2=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f2");return D(t,2)},T=y.__private__.f3=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.f3");return D(t,3)},U=y.scale=y.__private__.scale=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.scale");return S===x.COMPAT?t*_t:S===x.ADVANCED?t:void 0},z=function(t){return S===x.COMPAT?Rr()-t:S===x.ADVANCED?t:void 0},H=function(t){return U(z(t))};y.__private__.setPrecision=y.setPrecision=function(t){"number"==typeof parseInt(t,10)&&(n=parseInt(t,10))};var W,V="00000000000000000000000000000000",G=y.__private__.getFileId=function(){return V},Y=y.__private__.setFileId=function(t){return V=void 0!==t&&/^[a-fA-F0-9]{32}$/.test(t)?t.toUpperCase():V.split("").map((function(){return"ABCDEF0123456789".charAt(Math.floor(16*Math.random()))})).join(""),null!==m&&(Ye=new k(m.userPermissions,m.userPassword,m.ownerPassword,V)),V};y.setFileId=function(t){return Y(t),this},y.getFileId=function(){return G()};var J=y.__private__.convertDateToPDFDate=function(t){var e=t.getTimezoneOffset(),r=e<0?"+":"-",n=Math.floor(Math.abs(e/60)),i=Math.abs(e%60),a=[r,Q(n),"'",Q(i),"'"].join("");return["D:",t.getFullYear(),Q(t.getMonth()+1),Q(t.getDate()),Q(t.getHours()),Q(t.getMinutes()),Q(t.getSeconds()),a].join("")},X=y.__private__.convertPDFDateToDate=function(t){var e=parseInt(t.substr(2,4),10),r=parseInt(t.substr(6,2),10)-1,n=parseInt(t.substr(8,2),10),i=parseInt(t.substr(10,2),10),a=parseInt(t.substr(12,2),10),o=parseInt(t.substr(14,2),10);return new Date(e,r,n,i,a,o,0)},K=y.__private__.setCreationDate=function(t){var e;if(void 0===t&&(t=new Date),t instanceof Date)e=J(t);else{if(!/^D:(20[0-2][0-9]|203[0-7]|19[7-9][0-9])(0[0-9]|1[0-2])([0-2][0-9]|3[0-1])(0[0-9]|1[0-9]|2[0-3])(0[0-9]|[1-5][0-9])(0[0-9]|[1-5][0-9])(\+0[0-9]|\+1[0-4]|-0[0-9]|-1[0-1])'(0[0-9]|[1-5][0-9])'?$/.test(t))throw new Error("Invalid argument passed to jsPDF.setCreationDate");e=t}return W=e},Z=y.__private__.getCreationDate=function(t){var e=W;return"jsDate"===t&&(e=X(W)),e};y.setCreationDate=function(t){return K(t),this},y.getCreationDate=function(t){return Z(t)};var $,Q=y.__private__.padd2=function(t){return("0"+parseInt(t)).slice(-2)},tt=y.__private__.padd2Hex=function(t){return("00"+(t=t.toString())).substr(t.length)},et=0,rt=[],nt=[],it=0,at=[],ot=[],st=!1,ct=nt,ut=function(){et=0,it=0,nt=[],rt=[],at=[],Qt=Kt(),te=Kt()};y.__private__.setCustomOutputDestination=function(t){st=!0,ct=t};var lt=function(t){st||(ct=t)};y.__private__.resetCustomOutputDestination=function(){st=!1,ct=nt};var ht=y.__private__.out=function(t){return t=t.toString(),it+=t.length+1,ct.push(t),ct},ft=y.__private__.write=function(t){return ht(1===arguments.length?t.toString():Array.prototype.join.call(arguments," "))},dt=y.__private__.getArrayBuffer=function(t){for(var e=t.length,r=new ArrayBuffer(e),n=new Uint8Array(r);e--;)n[e]=t.charCodeAt(e);return r},pt=[["Helvetica","helvetica","normal","WinAnsiEncoding"],["Helvetica-Bold","helvetica","bold","WinAnsiEncoding"],["Helvetica-Oblique","helvetica","italic","WinAnsiEncoding"],["Helvetica-BoldOblique","helvetica","bolditalic","WinAnsiEncoding"],["Courier","courier","normal","WinAnsiEncoding"],["Courier-Bold","courier","bold","WinAnsiEncoding"],["Courier-Oblique","courier","italic","WinAnsiEncoding"],["Courier-BoldOblique","courier","bolditalic","WinAnsiEncoding"],["Times-Roman","times","normal","WinAnsiEncoding"],["Times-Bold","times","bold","WinAnsiEncoding"],["Times-Italic","times","italic","WinAnsiEncoding"],["Times-BoldItalic","times","bolditalic","WinAnsiEncoding"],["ZapfDingbats","zapfdingbats","normal",null],["Symbol","symbol","normal",null]];y.__private__.getStandardFonts=function(){return pt};var gt=t.fontSize||16;y.__private__.setFontSize=y.setFontSize=function(t){return gt=S===x.ADVANCED?t/_t:t,this};var mt,vt=y.__private__.getFontSize=y.getFontSize=function(){return S===x.COMPAT?gt:gt*_t},bt=t.R2L||!1;y.__private__.setR2L=y.setR2L=function(t){return bt=t,this},y.__private__.getR2L=y.getR2L=function(){return bt};var yt,wt=y.__private__.setZoomMode=function(t){var e=[void 0,null,"fullwidth","fullheight","fullpage","original"];if(/^(?:\d+\.\d*|\d*\.\d+|\d+)%$/.test(t))mt=t;else if(isNaN(t)){if(-1===e.indexOf(t))throw new Error('zoom must be Integer (e.g. 2), a percentage Value (e.g. 300%) or fullwidth, fullheight, fullpage, original. "'+t+'" is not recognized.');mt=t}else mt=parseInt(t,10)};y.__private__.getZoomMode=function(){return mt};var Nt,Lt=y.__private__.setPageMode=function(t){if(-1==[void 0,null,"UseNone","UseOutlines","UseThumbs","FullScreen"].indexOf(t))throw new Error('Page mode must be one of UseNone, UseOutlines, UseThumbs, or FullScreen. "'+t+'" is not recognized.');yt=t};y.__private__.getPageMode=function(){return yt};var At=y.__private__.setLayoutMode=function(t){if(-1==[void 0,null,"continuous","single","twoleft","tworight","two"].indexOf(t))throw new Error('Layout mode must be one of continuous, single, twoleft, tworight. "'+t+'" is not recognized.');Nt=t};y.__private__.getLayoutMode=function(){return Nt},y.__private__.setDisplayMode=y.setDisplayMode=function(t,e,r){return wt(t),At(e),Lt(r),this};var xt={title:"",subject:"",author:"",keywords:"",creator:""};y.__private__.getDocumentProperty=function(t){if(-1===Object.keys(xt).indexOf(t))throw new Error("Invalid argument passed to jsPDF.getDocumentProperty");return xt[t]},y.__private__.getDocumentProperties=function(){return xt},y.__private__.setDocumentProperties=y.setProperties=y.setDocumentProperties=function(t){for(var e in xt)xt.hasOwnProperty(e)&&t[e]&&(xt[e]=t[e]);return this},y.__private__.setDocumentProperty=function(t,e){if(-1===Object.keys(xt).indexOf(t))throw new Error("Invalid arguments passed to jsPDF.setDocumentProperty");return xt[t]=e};var St,_t,Pt,kt,Ft,It={},Ct={},jt=[],Ot={},Bt={},Mt={},Et={},qt=null,Dt=0,Rt=[],Tt=new I(y),Ut=t.hotfixes||[],zt={},Ht={},Wt=[],Vt=function t(e,r,n,i,a,o){if(!(this instanceof t))return new t(e,r,n,i,a,o);isNaN(e)&&(e=1),isNaN(r)&&(r=0),isNaN(n)&&(n=0),isNaN(i)&&(i=1),isNaN(a)&&(a=0),isNaN(o)&&(o=0),this._matrix=[e,r,n,i,a,o]};Object.defineProperty(Vt.prototype,"sx",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t}}),Object.defineProperty(Vt.prototype,"shy",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t}}),Object.defineProperty(Vt.prototype,"shx",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t}}),Object.defineProperty(Vt.prototype,"sy",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t}}),Object.defineProperty(Vt.prototype,"tx",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t}}),Object.defineProperty(Vt.prototype,"ty",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t}}),Object.defineProperty(Vt.prototype,"a",{get:function(){return this._matrix[0]},set:function(t){this._matrix[0]=t}}),Object.defineProperty(Vt.prototype,"b",{get:function(){return this._matrix[1]},set:function(t){this._matrix[1]=t}}),Object.defineProperty(Vt.prototype,"c",{get:function(){return this._matrix[2]},set:function(t){this._matrix[2]=t}}),Object.defineProperty(Vt.prototype,"d",{get:function(){return this._matrix[3]},set:function(t){this._matrix[3]=t}}),Object.defineProperty(Vt.prototype,"e",{get:function(){return this._matrix[4]},set:function(t){this._matrix[4]=t}}),Object.defineProperty(Vt.prototype,"f",{get:function(){return this._matrix[5]},set:function(t){this._matrix[5]=t}}),Object.defineProperty(Vt.prototype,"rotation",{get:function(){return Math.atan2(this.shx,this.sx)}}),Object.defineProperty(Vt.prototype,"scaleX",{get:function(){return this.decompose().scale.sx}}),Object.defineProperty(Vt.prototype,"scaleY",{get:function(){return this.decompose().scale.sy}}),Object.defineProperty(Vt.prototype,"isIdentity",{get:function(){return 1===this.sx&&(0===this.shy&&(0===this.shx&&(1===this.sy&&(0===this.tx&&0===this.ty))))}}),Vt.prototype.join=function(t){return[this.sx,this.shy,this.shx,this.sy,this.tx,this.ty].map(E).join(t)},Vt.prototype.multiply=function(t){var e=t.sx*this.sx+t.shy*this.shx,r=t.sx*this.shy+t.shy*this.sy,n=t.shx*this.sx+t.sy*this.shx,i=t.shx*this.shy+t.sy*this.sy,a=t.tx*this.sx+t.ty*this.shx+this.tx,o=t.tx*this.shy+t.ty*this.sy+this.ty;return new Vt(e,r,n,i,a,o)},Vt.prototype.decompose=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=Math.sqrt(t*t+e*e),s=(t/=o)*r+(e/=o)*n;r-=t*s,n-=e*s;var c=Math.sqrt(r*r+n*n);return s/=c,t*(n/=c)<e*(r/=c)&&(t=-t,e=-e,s=-s,o=-o),{scale:new Vt(o,0,0,c,0,0),translate:new Vt(1,0,0,1,i,a),rotate:new Vt(t,e,-e,t,0,0),skew:new Vt(1,0,s,1,0,0)}},Vt.prototype.toString=function(t){return this.join(" ")},Vt.prototype.inversed=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty,o=1/(t*n-e*r),s=n*o,c=-e*o,u=-r*o,l=t*o;return new Vt(s,c,u,l,-s*i-u*a,-c*i-l*a)},Vt.prototype.applyToPoint=function(t){var e=t.x*this.sx+t.y*this.shx+this.tx,r=t.x*this.shy+t.y*this.sy+this.ty;return new Cr(e,r)},Vt.prototype.applyToRectangle=function(t){var e=this.applyToPoint(t),r=this.applyToPoint(new Cr(t.x+t.w,t.y+t.h));return new jr(e.x,e.y,r.x-e.x,r.y-e.y)},Vt.prototype.clone=function(){var t=this.sx,e=this.shy,r=this.shx,n=this.sy,i=this.tx,a=this.ty;return new Vt(t,e,r,n,i,a)},y.Matrix=Vt;var Gt=y.matrixMult=function(t,e){return e.multiply(t)},Yt=new Vt(1,0,0,1,0,0);y.unitMatrix=y.identityMatrix=Yt;var Jt=function(t,e){if(!Bt[t]){var r=(e instanceof O?"Sh":"P")+(Object.keys(Ot).length+1).toString(10);e.id=r,Bt[t]=r,Ot[r]=e,Tt.publish("addPattern",e)}};y.ShadingPattern=O,y.TilingPattern=B,y.addShadingPattern=function(t,e){return q("addShadingPattern()"),Jt(t,e),this},y.beginTilingPattern=function(t){q("beginTilingPattern()"),Br(t.boundingBox[0],t.boundingBox[1],t.boundingBox[2]-t.boundingBox[0],t.boundingBox[3]-t.boundingBox[1],t.matrix)},y.endTilingPattern=function(t,e){q("endTilingPattern()"),e.stream=ot[$].join("\n"),Jt(t,e),Tt.publish("endTilingPattern",e),Wt.pop().restore()};var Xt=y.__private__.newObject=function(){var t=Kt();return Zt(t,!0),t},Kt=y.__private__.newObjectDeferred=function(){return et++,rt[et]=function(){return it},et},Zt=function(t,e){return e="boolean"==typeof e&&e,rt[t]=it,e&&ht(t+" 0 obj"),t},$t=y.__private__.newAdditionalObject=function(){var t={objId:Kt(),content:""};return at.push(t),t},Qt=Kt(),te=Kt(),ee=y.__private__.decodeColorString=function(t){var e=t.split(" ");if(2!==e.length||"g"!==e[1]&&"G"!==e[1]){if(5===e.length&&("k"===e[4]||"K"===e[4])){e=[(1-e[0])*(1-e[3]),(1-e[1])*(1-e[3]),(1-e[2])*(1-e[3]),"r"]}}else{var r=parseFloat(e[0]);e=[r,r,r,"r"]}for(var n="#",i=0;i<3;i++)n+=("0"+Math.floor(255*parseFloat(e[i])).toString(16)).slice(-2);return n},re=y.__private__.encodeColorString=function(t){var r;"string"==typeof t&&(t={ch1:t});var n=t.ch1,i=t.ch2,a=t.ch3,o=t.ch4,s="draw"===t.pdfColorType?["G","RG","K"]:["g","rg","k"];if("string"==typeof n&&"#"!==n.charAt(0)){var c=new h(n);if(c.ok)n=c.toHex();else if(!/^\d*\.?\d*$/.test(n))throw new Error('Invalid color "'+n+'" passed to jsPDF.encodeColorString.')}if("string"==typeof n&&/^#[0-9A-Fa-f]{3}$/.test(n)&&(n="#"+n[1]+n[1]+n[2]+n[2]+n[3]+n[3]),"string"==typeof n&&/^#[0-9A-Fa-f]{6}$/.test(n)){var u=parseInt(n.substr(1),16);n=u>>16&255,i=u>>8&255,a=255&u}if(void 0===i||void 0===o&&n===i&&i===a)if("string"==typeof n)r=n+" "+s[0];else switch(t.precision){case 2:r=R(n/255)+" "+s[0];break;case 3:default:r=T(n/255)+" "+s[0]}else if(void 0===o||"object"===e(o)){if(o&&!isNaN(o.a)&&0===o.a)return r=["1.","1.","1.",s[1]].join(" ");if("string"==typeof n)r=[n,i,a,s[1]].join(" ");else switch(t.precision){case 2:r=[R(n/255),R(i/255),R(a/255),s[1]].join(" ");break;default:case 3:r=[T(n/255),T(i/255),T(a/255),s[1]].join(" ")}}else if("string"==typeof n)r=[n,i,a,o,s[2]].join(" ");else switch(t.precision){case 2:r=[R(n),R(i),R(a),R(o),s[2]].join(" ");break;case 3:default:r=[T(n),T(i),T(a),T(o),s[2]].join(" ")}return r},ne=y.__private__.getFilters=function(){return f},ie=y.__private__.putStream=function(t){var e=(t=t||{}).data||"",r=t.filters||ne(),n=t.alreadyAppliedFilters||[],i=t.addLength1||!1,a=e.length,o=t.objectId,s=function(t){return t};if(null!==m&&void 0===o)throw new Error("ObjectId must be passed to putStream for file encryption");null!==m&&(s=Ye.encryptor(o,0));var c={};!0===r&&(r=["FlateEncode"]);var u=t.additionalKeyValues||[],l=(c=void 0!==M.API.processDataByFilters?M.API.processDataByFilters(e,r):{data:e,reverseChain:[]}).reverseChain+(Array.isArray(n)?n.join(" "):n.toString());if(0!==c.data.length&&(u.push({key:"Length",value:c.data.length}),!0===i&&u.push({key:"Length1",value:a})),0!=l.length)if(l.split("/").length-1==1)u.push({key:"Filter",value:l});else{u.push({key:"Filter",value:"["+l+"]"});for(var h=0;h<u.length;h+=1)if("DecodeParms"===u[h].key){for(var f=[],d=0;d<c.reverseChain.split("/").length-1;d+=1)f.push("null");f.push(u[h].value),u[h].value="["+f.join(" ")+"]"}}ht("<<");for(var p=0;p<u.length;p++)ht("/"+u[p].key+" "+u[p].value);ht(">>"),0!==c.data.length&&(ht("stream"),ht(s(c.data)),ht("endstream"))},ae=y.__private__.putPage=function(t){var e=t.number,r=t.data,n=t.objId,i=t.contentsObjId;Zt(n,!0),ht("<</Type /Page"),ht("/Parent "+t.rootDictionaryObjId+" 0 R"),ht("/Resources "+t.resourceDictionaryObjId+" 0 R"),ht("/MediaBox ["+parseFloat(E(t.mediaBox.bottomLeftX))+" "+parseFloat(E(t.mediaBox.bottomLeftY))+" "+E(t.mediaBox.topRightX)+" "+E(t.mediaBox.topRightY)+"]"),null!==t.cropBox&&ht("/CropBox ["+E(t.cropBox.bottomLeftX)+" "+E(t.cropBox.bottomLeftY)+" "+E(t.cropBox.topRightX)+" "+E(t.cropBox.topRightY)+"]"),null!==t.bleedBox&&ht("/BleedBox ["+E(t.bleedBox.bottomLeftX)+" "+E(t.bleedBox.bottomLeftY)+" "+E(t.bleedBox.topRightX)+" "+E(t.bleedBox.topRightY)+"]"),null!==t.trimBox&&ht("/TrimBox ["+E(t.trimBox.bottomLeftX)+" "+E(t.trimBox.bottomLeftY)+" "+E(t.trimBox.topRightX)+" "+E(t.trimBox.topRightY)+"]"),null!==t.artBox&&ht("/ArtBox ["+E(t.artBox.bottomLeftX)+" "+E(t.artBox.bottomLeftY)+" "+E(t.artBox.topRightX)+" "+E(t.artBox.topRightY)+"]"),"number"==typeof t.userUnit&&1!==t.userUnit&&ht("/UserUnit "+t.userUnit),Tt.publish("putPage",{objId:n,pageContext:Rt[e],pageNumber:e,page:r}),ht("/Contents "+i+" 0 R"),ht(">>"),ht("endobj");var a=r.join("\n");return S===x.ADVANCED&&(a+="\nQ"),Zt(i,!0),ie({data:a,filters:ne(),objectId:i}),ht("endobj"),n},oe=y.__private__.putPages=function(){var t,e,r=[];for(t=1;t<=Dt;t++)Rt[t].objId=Kt(),Rt[t].contentsObjId=Kt();for(t=1;t<=Dt;t++)r.push(ae({number:t,data:ot[t],objId:Rt[t].objId,contentsObjId:Rt[t].contentsObjId,mediaBox:Rt[t].mediaBox,cropBox:Rt[t].cropBox,bleedBox:Rt[t].bleedBox,trimBox:Rt[t].trimBox,artBox:Rt[t].artBox,userUnit:Rt[t].userUnit,rootDictionaryObjId:Qt,resourceDictionaryObjId:te}));Zt(Qt,!0),ht("<</Type /Pages");var n="/Kids [";for(e=0;e<Dt;e++)n+=r[e]+" 0 R ";ht(n+"]"),ht("/Count "+Dt),ht(">>"),ht("endobj"),Tt.publish("postPutPages")},se=function(t){Tt.publish("putFont",{font:t,out:ht,newObject:Xt,putStream:ie}),!0!==t.isAlreadyPutted&&(t.objectNumber=Xt(),ht("<<"),ht("/Type /Font"),ht("/BaseFont /"+F(t.postScriptName)),ht("/Subtype /Type1"),"string"==typeof t.encoding&&ht("/Encoding /"+t.encoding),ht("/FirstChar 32"),ht("/LastChar 255"),ht(">>"),ht("endobj"))},ce=function(){for(var t in It)It.hasOwnProperty(t)&&(!1===v||!0===v&&b.hasOwnProperty(t))&&se(It[t])},ue=function(t){t.objectNumber=Xt();var e=[];e.push({key:"Type",value:"/XObject"}),e.push({key:"Subtype",value:"/Form"}),e.push({key:"BBox",value:"["+[E(t.x),E(t.y),E(t.x+t.width),E(t.y+t.height)].join(" ")+"]"}),e.push({key:"Matrix",value:"["+t.matrix.toString()+"]"});var r=t.pages[1].join("\n");ie({data:r,additionalKeyValues:e,objectId:t.objectNumber}),ht("endobj")},le=function(){for(var t in zt)zt.hasOwnProperty(t)&&ue(zt[t])},he=function(t,e){var r,n=[],i=1/(e-1);for(r=0;r<1;r+=i)n.push(r);if(n.push(1),0!=t[0].offset){var a={offset:0,color:t[0].color};t.unshift(a)}if(1!=t[t.length-1].offset){var o={offset:1,color:t[t.length-1].color};t.push(o)}for(var s="",c=0,u=0;u<n.length;u++){for(r=n[u];r>t[c+1].offset;)c++;var l=t[c].offset,h=(r-l)/(t[c+1].offset-l),f=t[c].color,d=t[c+1].color;s+=tt(Math.round((1-h)*f[0]+h*d[0]).toString(16))+tt(Math.round((1-h)*f[1]+h*d[1]).toString(16))+tt(Math.round((1-h)*f[2]+h*d[2]).toString(16))}return s.trim()},fe=function(t,e){e||(e=21);var r=Xt(),n=he(t.colors,e),i=[];i.push({key:"FunctionType",value:"0"}),i.push({key:"Domain",value:"[0.0 1.0]"}),i.push({key:"Size",value:"["+e+"]"}),i.push({key:"BitsPerSample",value:"8"}),i.push({key:"Range",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),i.push({key:"Decode",value:"[0.0 1.0 0.0 1.0 0.0 1.0]"}),ie({data:n,additionalKeyValues:i,alreadyAppliedFilters:["/ASCIIHexDecode"],objectId:r}),ht("endobj"),t.objectNumber=Xt(),ht("<< /ShadingType "+t.type),ht("/ColorSpace /DeviceRGB");var a="/Coords ["+E(parseFloat(t.coords[0]))+" "+E(parseFloat(t.coords[1]))+" ";2===t.type?a+=E(parseFloat(t.coords[2]))+" "+E(parseFloat(t.coords[3])):a+=E(parseFloat(t.coords[2]))+" "+E(parseFloat(t.coords[3]))+" "+E(parseFloat(t.coords[4]))+" "+E(parseFloat(t.coords[5])),ht(a+="]"),t.matrix&&ht("/Matrix ["+t.matrix.toString()+"]"),ht("/Function "+r+" 0 R"),ht("/Extend [true true]"),ht(">>"),ht("endobj")},de=function(t,e){var r=Kt(),n=Xt();e.push({resourcesOid:r,objectOid:n}),t.objectNumber=n;var i=[];i.push({key:"Type",value:"/Pattern"}),i.push({key:"PatternType",value:"1"}),i.push({key:"PaintType",value:"1"}),i.push({key:"TilingType",value:"1"}),i.push({key:"BBox",value:"["+t.boundingBox.map(E).join(" ")+"]"}),i.push({key:"XStep",value:E(t.xStep)}),i.push({key:"YStep",value:E(t.yStep)}),i.push({key:"Resources",value:r+" 0 R"}),t.matrix&&i.push({key:"Matrix",value:"["+t.matrix.toString()+"]"}),ie({data:t.stream,additionalKeyValues:i,objectId:t.objectNumber}),ht("endobj")},pe=function(t){var e;for(e in Ot)Ot.hasOwnProperty(e)&&(Ot[e]instanceof O?fe(Ot[e]):Ot[e]instanceof B&&de(Ot[e],t))},ge=function(t){for(var e in t.objectNumber=Xt(),ht("<<"),t)switch(e){case"opacity":ht("/ca "+R(t[e]));break;case"stroke-opacity":ht("/CA "+R(t[e]))}ht(">>"),ht("endobj")},me=function(){var t;for(t in Mt)Mt.hasOwnProperty(t)&&ge(Mt[t])},ve=function(){for(var t in ht("/XObject <<"),zt)zt.hasOwnProperty(t)&&zt[t].objectNumber>=0&&ht("/"+t+" "+zt[t].objectNumber+" 0 R");Tt.publish("putXobjectDict"),ht(">>")},be=function(){Ye.oid=Xt(),ht("<<"),ht("/Filter /Standard"),ht("/V "+Ye.v),ht("/R "+Ye.r),ht("/U <"+Ye.toHexString(Ye.U)+">"),ht("/O <"+Ye.toHexString(Ye.O)+">"),ht("/P "+Ye.P),ht(">>"),ht("endobj")},ye=function(){for(var t in ht("/Font <<"),It)It.hasOwnProperty(t)&&(!1===v||!0===v&&b.hasOwnProperty(t))&&ht("/"+t+" "+It[t].objectNumber+" 0 R");ht(">>")},we=function(){if(Object.keys(Ot).length>0){for(var t in ht("/Shading <<"),Ot)Ot.hasOwnProperty(t)&&Ot[t]instanceof O&&Ot[t].objectNumber>=0&&ht("/"+t+" "+Ot[t].objectNumber+" 0 R");Tt.publish("putShadingPatternDict"),ht(">>")}},Ne=function(t){if(Object.keys(Ot).length>0){for(var e in ht("/Pattern <<"),Ot)Ot.hasOwnProperty(e)&&Ot[e]instanceof y.TilingPattern&&Ot[e].objectNumber>=0&&Ot[e].objectNumber<t&&ht("/"+e+" "+Ot[e].objectNumber+" 0 R");Tt.publish("putTilingPatternDict"),ht(">>")}},Le=function(){if(Object.keys(Mt).length>0){var t;for(t in ht("/ExtGState <<"),Mt)Mt.hasOwnProperty(t)&&Mt[t].objectNumber>=0&&ht("/"+t+" "+Mt[t].objectNumber+" 0 R");Tt.publish("putGStateDict"),ht(">>")}},Ae=function(t){Zt(t.resourcesOid,!0),ht("<<"),ht("/ProcSet [/PDF /Text /ImageB /ImageC /ImageI]"),ye(),we(),Ne(t.objectOid),Le(),ve(),ht(">>"),ht("endobj")},xe=function(){var t=[];ce(),me(),le(),pe(t),Tt.publish("putResources"),t.forEach(Ae),Ae({resourcesOid:te,objectOid:Number.MAX_SAFE_INTEGER}),Tt.publish("postPutResources")},Se=function(){Tt.publish("putAdditionalObjects");for(var t=0;t<at.length;t++){var e=at[t];Zt(e.objId,!0),ht(e.content),ht("endobj")}Tt.publish("postPutAdditionalObjects")},_e=function(t){Ct[t.fontName]=Ct[t.fontName]||{},Ct[t.fontName][t.fontStyle]=t.id},Pe=function(t,e,r,n,i){var a={id:"F"+(Object.keys(It).length+1).toString(10),postScriptName:t,fontName:e,fontStyle:r,encoding:n,isStandardFont:i||!1,metadata:{}};return Tt.publish("addFont",{font:a,instance:this}),It[a.id]=a,_e(a),a.id},ke=function(t){for(var e=0,r=pt.length;e<r;e++){var n=Pe.call(this,t[e][0],t[e][1],t[e][2],pt[e][3],!0);!1===v&&(b[n]=!0);var i=t[e][0].split("-");_e({id:n,fontName:i[0],fontStyle:i[1]||""})}Tt.publish("addFonts",{fonts:It,dictionary:Ct})},Fe=function(t){return t.foo=function(){try{return t.apply(this,arguments)}catch(t){var e=t.stack||"";~e.indexOf(" at ")&&(e=e.split(" at ")[1]);var n="Error in function "+e.split("\n")[0].split("<")[0]+": "+t.message;if(!r.console)throw new Error(n);r.console.error(n,t),r.alert&&alert(n)}},t.foo.bar=t,t.foo},Ie=function(t,e){var r,n,i,a,o,s,c,u,l;if(i=(e=e||{}).sourceEncoding||"Unicode",o=e.outputEncoding,(e.autoencode||o)&&It[St].metadata&&It[St].metadata[i]&&It[St].metadata[i].encoding&&(a=It[St].metadata[i].encoding,!o&&It[St].encoding&&(o=It[St].encoding),!o&&a.codePages&&(o=a.codePages[0]),"string"==typeof o&&(o=a[o]),o)){for(c=!1,s=[],r=0,n=t.length;r<n;r++)(u=o[t.charCodeAt(r)])?s.push(String.fromCharCode(u)):s.push(t[r]),s[r].charCodeAt(0)>>8&&(c=!0);t=s.join("")}for(r=t.length;void 0===c&&0!==r;)t.charCodeAt(r-1)>>8&&(c=!0),r--;if(!c)return t;for(s=e.noBOM?[]:[254,255],r=0,n=t.length;r<n;r++){if((l=(u=t.charCodeAt(r))>>8)>>8)throw new Error("Character at position "+r+" of string '"+t+"' exceeds 16bits. Cannot be encoded into UCS-2 BE");s.push(l),s.push(u-(l<<8))}return String.fromCharCode.apply(void 0,s)},Ce=y.__private__.pdfEscape=y.pdfEscape=function(t,e){return Ie(t,e).replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},je=y.__private__.beginPage=function(t){ot[++Dt]=[],Rt[Dt]={objId:0,contentsObjId:0,userUnit:Number(d),artBox:null,bleedBox:null,cropBox:null,trimBox:null,mediaBox:{bottomLeftX:0,bottomLeftY:0,topRightX:Number(t[0]),topRightY:Number(t[1])}},Me(Dt),lt(ot[$])},Oe=function(t,e){var r,n,o;switch(a=e||a,"string"==typeof t&&(r=A(t.toLowerCase()),Array.isArray(r)&&(n=r[0],o=r[1])),Array.isArray(t)&&(n=t[0]*_t,o=t[1]*_t),isNaN(n)&&(n=s[0],o=s[1]),(n>14400||o>14400)&&(i.warn("A page in a PDF can not be wider or taller than 14400 userUnit. jsPDF limits the width/height to 14400"),n=Math.min(14400,n),o=Math.min(14400,o)),s=[n,o],a.substr(0,1)){case"l":o>n&&(s=[o,n]);break;case"p":n>o&&(s=[o,n])}je(s),pr(fr),ht(Lr),0!==kr&&ht(kr+" J"),0!==Fr&&ht(Fr+" j"),Tt.publish("addPage",{pageNumber:Dt})},Be=function(t){t>0&&t<=Dt&&(ot.splice(t,1),Rt.splice(t,1),Dt--,$>Dt&&($=Dt),this.setPage($))},Me=function(t){t>0&&t<=Dt&&($=t)},Ee=y.__private__.getNumberOfPages=y.getNumberOfPages=function(){return ot.length-1},qe=function(t,e,r){var n,a=void 0;return r=r||{},t=void 0!==t?t:It[St].fontName,e=void 0!==e?e:It[St].fontStyle,n=t.toLowerCase(),void 0!==Ct[n]&&void 0!==Ct[n][e]?a=Ct[n][e]:void 0!==Ct[t]&&void 0!==Ct[t][e]?a=Ct[t][e]:!1===r.disableWarning&&i.warn("Unable to look up font label for font '"+t+"', '"+e+"'. Refer to getFontList() for available fonts."),a||r.noFallback||null==(a=Ct.times[e])&&(a=Ct.times.normal),a},De=y.__private__.putInfo=function(){var t=Xt(),e=function(t){return t};for(var r in null!==m&&(e=Ye.encryptor(t,0)),ht("<<"),ht("/Producer ("+Ce(e("jsPDF "+M.version))+")"),xt)xt.hasOwnProperty(r)&&xt[r]&&ht("/"+r.substr(0,1).toUpperCase()+r.substr(1)+" ("+Ce(e(xt[r]))+")");ht("/CreationDate ("+Ce(e(W))+")"),ht(">>"),ht("endobj")},Re=y.__private__.putCatalog=function(t){var e=(t=t||{}).rootDictionaryObjId||Qt;switch(Xt(),ht("<<"),ht("/Type /Catalog"),ht("/Pages "+e+" 0 R"),mt||(mt="fullwidth"),mt){case"fullwidth":ht("/OpenAction [3 0 R /FitH null]");break;case"fullheight":ht("/OpenAction [3 0 R /FitV null]");break;case"fullpage":ht("/OpenAction [3 0 R /Fit]");break;case"original":ht("/OpenAction [3 0 R /XYZ null null 1]");break;default:var r=""+mt;"%"===r.substr(r.length-1)&&(mt=parseInt(mt)/100),"number"==typeof mt&&ht("/OpenAction [3 0 R /XYZ null null "+R(mt)+"]")}switch(Nt||(Nt="continuous"),Nt){case"continuous":ht("/PageLayout /OneColumn");break;case"single":ht("/PageLayout /SinglePage");break;case"two":case"twoleft":ht("/PageLayout /TwoColumnLeft");break;case"tworight":ht("/PageLayout /TwoColumnRight")}yt&&ht("/PageMode /"+yt),Tt.publish("putCatalog"),ht(">>"),ht("endobj")},Te=y.__private__.putTrailer=function(){ht("trailer"),ht("<<"),ht("/Size "+(et+1)),ht("/Root "+et+" 0 R"),ht("/Info "+(et-1)+" 0 R"),null!==m&&ht("/Encrypt "+Ye.oid+" 0 R"),ht("/ID [ <"+V+"> <"+V+"> ]"),ht(">>")},Ue=y.__private__.putHeader=function(){ht("%PDF-"+w),ht("%ºß¬à")},ze=y.__private__.putXRef=function(){var t="0000000000";ht("xref"),ht("0 "+(et+1)),ht("0000000000 65535 f ");for(var e=1;e<=et;e++){"function"==typeof rt[e]?ht((t+rt[e]()).slice(-10)+" 00000 n "):void 0!==rt[e]?ht((t+rt[e]).slice(-10)+" 00000 n "):ht("0000000000 00000 n ")}},He=y.__private__.buildDocument=function(){ut(),lt(nt),Tt.publish("buildDocument"),Ue(),oe(),Se(),xe(),null!==m&&be(),De(),Re();var t=it;return ze(),Te(),ht("startxref"),ht(""+t),ht("%%EOF"),lt(ot[$]),nt.join("\n")},We=y.__private__.getBlob=function(t){return new Blob([dt(t)],{type:"application/pdf"})},Ve=y.output=y.__private__.output=Fe((function(t,e){switch("string"==typeof(e=e||{})?e={filename:e}:e.filename=e.filename||"generated.pdf",t){case void 0:return He();case"save":y.save(e.filename);break;case"arraybuffer":return dt(He());case"blob":return We(He());case"bloburi":case"bloburl":if(void 0!==r.URL&&"function"==typeof r.URL.createObjectURL)return r.URL&&r.URL.createObjectURL(We(He()))||void 0;i.warn("bloburl is not supported by your system, because URL.createObjectURL is not supported by your browser.");break;case"datauristring":case"dataurlstring":var n="",a=He();try{n=u(a)}catch(t){n=u(unescape(encodeURIComponent(a)))}return"data:application/pdf;filename="+e.filename+";base64,"+n;case"pdfobjectnewwindow":if("[object Window]"===Object.prototype.toString.call(r)){var o="https://cdnjs.cloudflare.com/ajax/libs/pdfobject/2.1.1/pdfobject.min.js",s=' integrity="sha512-4ze/a9/4jqu+tX9dfOqJYSvyYd5M6qum/3HpCLr+/Jqf0whc37VUbkpNGHR7/8pSnCFw47T1fmIpwBV7UySh3g==" crossorigin="anonymous"';e.pdfObjectUrl&&(o=e.pdfObjectUrl,s="");var c='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><script src="'+o+'"'+s+'><\/script><script >PDFObject.embed("'+this.output("dataurlstring")+'", '+JSON.stringify(e)+");<\/script></body></html>",l=r.open();return null!==l&&l.document.write(c),l}throw new Error("The option pdfobjectnewwindow just works in a browser-environment.");case"pdfjsnewwindow":if("[object Window]"===Object.prototype.toString.call(r)){var h='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe id="pdfViewer" src="'+(e.pdfJsUrl||"examples/PDF.js/web/viewer.html")+"?file=&downloadName="+e.filename+'" width="500px" height="400px" /></body></html>',f=r.open();if(null!==f){f.document.write(h);var d=this;f.document.documentElement.querySelector("#pdfViewer").onload=function(){f.document.title=e.filename,f.document.documentElement.querySelector("#pdfViewer").contentWindow.PDFViewerApplication.open(d.output("bloburl"))}}return f}throw new Error("The option pdfjsnewwindow just works in a browser-environment.");case"dataurlnewwindow":if("[object Window]"!==Object.prototype.toString.call(r))throw new Error("The option dataurlnewwindow just works in a browser-environment.");var p='<html><style>html, body { padding: 0; margin: 0; } iframe { width: 100%; height: 100%; border: 0;}  </style><body><iframe src="'+this.output("datauristring",e)+'"></iframe></body></html>',g=r.open();if(null!==g&&(g.document.write(p),g.document.title=e.filename),g||"undefined"==typeof safari)return g;break;case"datauri":case"dataurl":return r.document.location.href=this.output("datauristring",e);default:return null}})),Ge=function(t){return!0===Array.isArray(Ut)&&Ut.indexOf(t)>-1};switch(o){case"pt":_t=1;break;case"mm":_t=72/25.4;break;case"cm":_t=72/2.54;break;case"in":_t=72;break;case"px":_t=1==Ge("px_scaling")?.75:96/72;break;case"pc":case"em":_t=12;break;case"ex":_t=6;break;default:if("number"!=typeof o)throw new Error("Invalid unit: "+o);_t=o}var Ye=null;K(),Y();var Je=function(t){return null!==m?Ye.encryptor(t,0):function(t){return t}},Xe=y.__private__.getPageInfo=y.getPageInfo=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfo");return{objId:Rt[t].objId,pageNumber:t,pageContext:Rt[t]}},Ke=y.__private__.getPageInfoByObjId=function(t){if(isNaN(t)||t%1!=0)throw new Error("Invalid argument passed to jsPDF.getPageInfoByObjId");for(var e in Rt)if(Rt[e].objId===t)break;return Xe(e)},Ze=y.__private__.getCurrentPageInfo=y.getCurrentPageInfo=function(){return{objId:Rt[$].objId,pageNumber:$,pageContext:Rt[$]}};y.addPage=function(){return Oe.apply(this,arguments),this},y.setPage=function(){return Me.apply(this,arguments),lt.call(this,ot[$]),this},y.insertPage=function(t){return this.addPage(),this.movePage($,t),this},y.movePage=function(t,e){var r,n;if(t>e){r=ot[t],n=Rt[t];for(var i=t;i>e;i--)ot[i]=ot[i-1],Rt[i]=Rt[i-1];ot[e]=r,Rt[e]=n,this.setPage(e)}else if(t<e){r=ot[t],n=Rt[t];for(var a=t;a<e;a++)ot[a]=ot[a+1],Rt[a]=Rt[a+1];ot[e]=r,Rt[e]=n,this.setPage(e)}return this},y.deletePage=function(){return Be.apply(this,arguments),this},y.__private__.text=y.text=function(t,r,n,i,a){var o,s,c,u,l,h,f,d,p,g=(i=i||{}).scope||this;if("number"==typeof t&&"number"==typeof r&&("string"==typeof n||Array.isArray(n))){var m=n;n=r,r=t,t=m}if(arguments[3]instanceof Vt==!1?(c=arguments[4],u=arguments[5],"object"===e(f=arguments[3])&&null!==f||("string"==typeof c&&(u=c,c=null),"string"==typeof f&&(u=f,f=null),"number"==typeof f&&(c=f,f=null),i={flags:f,angle:c,align:u})):(q("The transform parameter of text() with a Matrix value"),p=a),isNaN(r)||isNaN(n)||null==t)throw new Error("Invalid arguments passed to jsPDF.text");if(0===t.length)return g;var v="",y=!1,w="number"==typeof i.lineHeightFactor?i.lineHeightFactor:hr,N=g.internal.scaleFactor;function L(t){return t=t.split("\t").join(Array(i.TabLen||9).join(" ")),Ce(t,f)}function A(t){for(var e,r=t.concat(),n=[],i=r.length;i--;)"string"==typeof(e=r.shift())?n.push(e):Array.isArray(t)&&(1===e.length||void 0===e[1]&&void 0===e[2])?n.push(e[0]):n.push([e[0],e[1],e[2]]);return n}function _(t,e){var r;if("string"==typeof t)r=e(t)[0];else if(Array.isArray(t)){for(var n,i,a=t.concat(),o=[],s=a.length;s--;)"string"==typeof(n=a.shift())?o.push(e(n)[0]):Array.isArray(n)&&"string"==typeof n[0]&&(i=e(n[0],n[1],n[2]),o.push([i[0],i[1],i[2]]));r=o}return r}var P=!1,k=!0;if("string"==typeof t)P=!0;else if(Array.isArray(t)){var F=t.concat();s=[];for(var I,C=F.length;C--;)("string"!=typeof(I=F.shift())||Array.isArray(I)&&"string"!=typeof I[0])&&(k=!1);P=k}if(!1===P)throw new Error('Type of text must be string or Array. "'+t+'" is not recognized.');"string"==typeof t&&(t=t.match(/[\r?\n]/)?t.split(/\r\n|\r|\n/g):[t]);var j=gt/g.internal.scaleFactor,O=j*(w-1);switch(i.baseline){case"bottom":n-=O;break;case"top":n+=j-O;break;case"hanging":n+=j-2*O;break;case"middle":n+=j/2-O}if((h=i.maxWidth||0)>0&&("string"==typeof t?t=g.splitTextToSize(t,h):"[object Array]"===Object.prototype.toString.call(t)&&(t=t.reduce((function(t,e){return t.concat(g.splitTextToSize(e,h))}),[]))),o={text:t,x:r,y:n,options:i,mutex:{pdfEscape:Ce,activeFontKey:St,fonts:It,activeFontSize:gt}},Tt.publish("preProcessText",o),t=o.text,c=(i=o.options).angle,p instanceof Vt==!1&&c&&"number"==typeof c){c*=Math.PI/180,0===i.rotationDirection&&(c=-c),S===x.ADVANCED&&(c=-c);var B=Math.cos(c),M=Math.sin(c);p=new Vt(B,M,-M,B,0,0)}else c&&c instanceof Vt&&(p=c);S!==x.ADVANCED||p||(p=Yt),void 0!==(l=i.charSpace||_r)&&(v+=E(U(l))+" Tc\n",this.setCharSpace(this.getCharSpace()||0)),void 0!==(d=i.horizontalScale)&&(v+=E(100*d)+" Tz\n");i.lang;var D=-1,R=void 0!==i.renderingMode?i.renderingMode:i.stroke,T=g.internal.getCurrentPageInfo().pageContext;switch(R){case 0:case!1:case"fill":D=0;break;case 1:case!0:case"stroke":D=1;break;case 2:case"fillThenStroke":D=2;break;case 3:case"invisible":D=3;break;case 4:case"fillAndAddForClipping":D=4;break;case 5:case"strokeAndAddPathForClipping":D=5;break;case 6:case"fillThenStrokeAndAddToPathForClipping":D=6;break;case 7:case"addToPathForClipping":D=7}var z=void 0!==T.usedRenderingMode?T.usedRenderingMode:-1;-1!==D?v+=D+" Tr\n":-1!==z&&(v+="0 Tr\n"),-1!==D&&(T.usedRenderingMode=D),u=i.align||"left";var H,W=gt*w,V=g.internal.pageSize.getWidth(),G=It[St];l=i.charSpace||_r,h=i.maxWidth||0,f=Object.assign({autoencode:!0,noBOM:!0},i.flags);var Y=[],J=function(t){return g.getStringUnitWidth(t,{font:G,charSpace:l,fontSize:gt,doKerning:!1})*gt/N};if("[object Array]"===Object.prototype.toString.call(t)){var X;s=A(t),"left"!==u&&(H=s.map(J));var K,Z=0;if("right"===u){r-=H[0],t=[],C=s.length;for(var $=0;$<C;$++)0===$?(K=br(r),X=yr(n)):(K=U(Z-H[$]),X=-W),t.push([s[$],K,X]),Z=H[$]}else if("center"===u){r-=H[0]/2,t=[],C=s.length;for(var Q=0;Q<C;Q++)0===Q?(K=br(r),X=yr(n)):(K=U((Z-H[Q])/2),X=-W),t.push([s[Q],K,X]),Z=H[Q]}else if("left"===u){t=[],C=s.length;for(var tt=0;tt<C;tt++)t.push(s[tt])}else if("justify"===u&&"Identity-H"===G.encoding){t=[],C=s.length,h=0!==h?h:V;for(var et=0,rt=0;rt<C;rt++)if(X=0===rt?yr(n):-W,K=0===rt?br(r):et,rt<C-1){var nt=U((h-H[rt])/(s[rt].split(" ").length-1)),it=s[rt].split(" ");t.push([it[0]+" ",K,X]),et=0;for(var at=1;at<it.length;at++){var ot=(J(it[at-1]+" "+it[at])-J(it[at]))*N+nt;at==it.length-1?t.push([it[at],ot,0]):t.push([it[at]+" ",ot,0]),et-=ot}}else t.push([s[rt],K,X]);t.push(["",et,0])}else{if("justify"!==u)throw new Error('Unrecognized alignment option, use "left", "center", "right" or "justify".');t=[],C=s.length,h=0!==h?h:V;for(rt=0;rt<C;rt++)X=0===rt?yr(n):-W,K=0===rt?br(r):0,rt<C-1?Y.push(E(U((h-H[rt])/(s[rt].split(" ").length-1)))):Y.push(0),t.push([s[rt],K,X])}}var st="boolean"==typeof i.R2L?i.R2L:bt;!0===st&&(t=_(t,(function(t,e,r){return[t.split("").reverse().join(""),e,r]}))),o={text:t,x:r,y:n,options:i,mutex:{pdfEscape:Ce,activeFontKey:St,fonts:It,activeFontSize:gt}},Tt.publish("postProcessText",o),t=o.text,y=o.mutex.isHex||!1;var ct=It[St].encoding;"WinAnsiEncoding"!==ct&&"StandardEncoding"!==ct||(t=_(t,(function(t,e,r){return[L(t),e,r]}))),s=A(t),t=[];for(var ut,lt,ft,dt=0,pt=1,mt=Array.isArray(s[0])?pt:dt,vt="",yt=function(t,e,r){var n="";return r instanceof Vt?(r="number"==typeof i.angle?Gt(r,new Vt(1,0,0,1,t,e)):Gt(new Vt(1,0,0,1,t,e),r),S===x.ADVANCED&&(r=Gt(new Vt(1,0,0,-1,0,0),r)),n=r.join(" ")+" Tm\n"):n=E(t)+" "+E(e)+" Td\n",n},wt=0;wt<s.length;wt++){switch(vt="",mt){case pt:ft=(y?"<":"(")+s[wt][0]+(y?">":")"),ut=parseFloat(s[wt][1]),lt=parseFloat(s[wt][2]);break;case dt:ft=(y?"<":"(")+s[wt]+(y?">":")"),ut=br(r),lt=yr(n)}void 0!==Y&&void 0!==Y[wt]&&(vt=Y[wt]+" Tw\n"),0===wt?t.push(vt+yt(ut,lt,p)+ft):mt===dt?t.push(vt+ft):mt===pt&&t.push(vt+yt(ut,lt,p)+ft)}t=mt===dt?t.join(" Tj\nT* "):t.join(" Tj\n"),t+=" Tj\n";var Nt="BT\n/";return Nt+=St+" "+gt+" Tf\n",Nt+=E(gt*w)+" TL\n",Nt+=xr+"\n",Nt+=v,Nt+=t,ht(Nt+="ET"),b[St]=!0,g};var $e=y.__private__.clip=y.clip=function(t){return ht("evenodd"===t?"W*":"W"),this};y.clipEvenOdd=function(){return $e("evenodd")},y.__private__.discardPath=y.discardPath=function(){return ht("n"),this};var Qe=y.__private__.isValidStyle=function(t){var e=!1;return-1!==[void 0,null,"S","D","F","DF","FD","f","f*","B","B*","n"].indexOf(t)&&(e=!0),e};y.__private__.setDefaultPathOperation=y.setDefaultPathOperation=function(t){return Qe(t)&&(g=t),this};var tr=y.__private__.getStyle=y.getStyle=function(t){var e=g;switch(t){case"D":case"S":e="S";break;case"F":e="f";break;case"FD":case"DF":e="B";break;case"f":case"f*":case"B":case"B*":e=t}return e},er=y.close=function(){return ht("h"),this};y.stroke=function(){return ht("S"),this},y.fill=function(t){return rr("f",t),this},y.fillEvenOdd=function(t){return rr("f*",t),this},y.fillStroke=function(t){return rr("B",t),this},y.fillStrokeEvenOdd=function(t){return rr("B*",t),this};var rr=function(t,r){"object"===e(r)?ar(r,t):ht(t)},nr=function(t){null===t||S===x.ADVANCED&&void 0===t||(t=tr(t),ht(t))};function ir(t,e,r,n,i){var a=new B(e||this.boundingBox,r||this.xStep,n||this.yStep,this.gState,i||this.matrix);a.stream=this.stream;var o=t+"$$"+this.cloneIndex+++"$$";return Jt(o,a),a}var ar=function(t,e){var r=Bt[t.key],n=Ot[r];if(n instanceof O)ht("q"),ht(or(e)),n.gState&&y.setGState(n.gState),ht(t.matrix.toString()+" cm"),ht("/"+r+" sh"),ht("Q");else if(n instanceof B){var i=new Vt(1,0,0,-1,0,Rr());t.matrix&&(i=i.multiply(t.matrix||Yt),r=ir.call(n,t.key,t.boundingBox,t.xStep,t.yStep,i).id),ht("q"),ht("/Pattern cs"),ht("/"+r+" scn"),n.gState&&y.setGState(n.gState),ht(e),ht("Q")}},or=function(t){switch(t){case"f":case"F":return"W n";case"f*":return"W* n";case"B":return"W S";case"B*":return"W* S";case"S":return"W S";case"n":return"W n"}},sr=y.moveTo=function(t,e){return ht(E(U(t))+" "+E(H(e))+" m"),this},cr=y.lineTo=function(t,e){return ht(E(U(t))+" "+E(H(e))+" l"),this},ur=y.curveTo=function(t,e,r,n,i,a){return ht([E(U(t)),E(H(e)),E(U(r)),E(H(n)),E(U(i)),E(H(a)),"c"].join(" ")),this};y.__private__.line=y.line=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.line");return S===x.COMPAT?this.lines([[r-t,n-e]],t,e,[1,1],i||"S"):this.lines([[r-t,n-e]],t,e,[1,1]).stroke()},y.__private__.lines=y.lines=function(t,e,r,n,i,a){var o,s,c,u,l,h,f,d,p,g,m,v;if("number"==typeof t&&(v=r,r=e,e=t,t=v),n=n||[1,1],a=a||!1,isNaN(e)||isNaN(r)||!Array.isArray(t)||!Array.isArray(n)||!Qe(i)||"boolean"!=typeof a)throw new Error("Invalid arguments passed to jsPDF.lines");for(sr(e,r),o=n[0],s=n[1],u=t.length,g=e,m=r,c=0;c<u;c++)2===(l=t[c]).length?(g=l[0]*o+g,m=l[1]*s+m,cr(g,m)):(h=l[0]*o+g,f=l[1]*s+m,d=l[2]*o+g,p=l[3]*s+m,g=l[4]*o+g,m=l[5]*s+m,ur(h,f,d,p,g,m));return a&&er(),nr(i),this},y.path=function(t){for(var e=0;e<t.length;e++){var r=t[e],n=r.c;switch(r.op){case"m":sr(n[0],n[1]);break;case"l":cr(n[0],n[1]);break;case"c":ur.apply(this,n);break;case"h":er()}}return this},y.__private__.rect=y.rect=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.rect");return S===x.COMPAT&&(n=-n),ht([E(U(t)),E(H(e)),E(U(r)),E(U(n)),"re"].join(" ")),nr(i),this},y.__private__.triangle=y.triangle=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Qe(o))throw new Error("Invalid arguments passed to jsPDF.triangle");return this.lines([[r-t,n-e],[i-r,a-n],[t-i,e-a]],t,e,[1,1],o,!0),this},y.__private__.roundedRect=y.roundedRect=function(t,e,r,n,i,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(i)||isNaN(a)||!Qe(o))throw new Error("Invalid arguments passed to jsPDF.roundedRect");var s=4/3*(Math.SQRT2-1);return i=Math.min(i,.5*r),a=Math.min(a,.5*n),this.lines([[r-2*i,0],[i*s,0,i,a-a*s,i,a],[0,n-2*a],[0,a*s,-i*s,a,-i,a],[2*i-r,0],[-i*s,0,-i,-a*s,-i,-a],[0,2*a-n],[0,-a*s,i*s,-a,i,-a]],t+i,e,[1,1],o,!0),this},y.__private__.ellipse=y.ellipse=function(t,e,r,n,i){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||!Qe(i))throw new Error("Invalid arguments passed to jsPDF.ellipse");var a=4/3*(Math.SQRT2-1)*r,o=4/3*(Math.SQRT2-1)*n;return sr(t+r,e),ur(t+r,e-o,t+a,e-n,t,e-n),ur(t-a,e-n,t-r,e-o,t-r,e),ur(t-r,e+o,t-a,e+n,t,e+n),ur(t+a,e+n,t+r,e+o,t+r,e),nr(i),this},y.__private__.circle=y.circle=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||!Qe(n))throw new Error("Invalid arguments passed to jsPDF.circle");return this.ellipse(t,e,r,r,n)},y.setFont=function(t,e,r){return r&&(e=j(e,r)),St=qe(t,e,{disableWarning:!1}),this};var lr=y.__private__.getFont=y.getFont=function(){return It[qe.apply(y,arguments)]};y.__private__.getFontList=y.getFontList=function(){var t,e,r={};for(t in Ct)if(Ct.hasOwnProperty(t))for(e in r[t]=[],Ct[t])Ct[t].hasOwnProperty(e)&&r[t].push(e);return r},y.addFont=function(t,e,r,n,i){var a=["StandardEncoding","MacRomanEncoding","Identity-H","WinAnsiEncoding"];return arguments[3]&&-1!==a.indexOf(arguments[3])?i=arguments[3]:arguments[3]&&-1==a.indexOf(arguments[3])&&(r=j(r,n)),i=i||"Identity-H",Pe.call(this,t,e,r,i)};var hr,fr=t.lineWidth||.200025,dr=y.__private__.getLineWidth=y.getLineWidth=function(){return fr},pr=y.__private__.setLineWidth=y.setLineWidth=function(t){return fr=t,ht(E(U(t))+" w"),this};y.__private__.setLineDash=M.API.setLineDash=M.API.setLineDashPattern=function(t,e){if(t=t||[],e=e||0,isNaN(e)||!Array.isArray(t))throw new Error("Invalid arguments passed to jsPDF.setLineDash");return t=t.map((function(t){return E(U(t))})).join(" "),e=E(U(e)),ht("["+t+"] "+e+" d"),this};var gr=y.__private__.getLineHeight=y.getLineHeight=function(){return gt*hr};y.__private__.getLineHeight=y.getLineHeight=function(){return gt*hr};var mr=y.__private__.setLineHeightFactor=y.setLineHeightFactor=function(t){return"number"==typeof(t=t||1.15)&&(hr=t),this},vr=y.__private__.getLineHeightFactor=y.getLineHeightFactor=function(){return hr};mr(t.lineHeight);var br=y.__private__.getHorizontalCoordinate=function(t){return U(t)},yr=y.__private__.getVerticalCoordinate=function(t){return S===x.ADVANCED?t:Rt[$].mediaBox.topRightY-Rt[$].mediaBox.bottomLeftY-U(t)},wr=y.__private__.getHorizontalCoordinateString=y.getHorizontalCoordinateString=function(t){return E(br(t))},Nr=y.__private__.getVerticalCoordinateString=y.getVerticalCoordinateString=function(t){return E(yr(t))},Lr=t.strokeColor||"0 G";y.__private__.getStrokeColor=y.getDrawColor=function(){return ee(Lr)},y.__private__.setStrokeColor=y.setDrawColor=function(t,e,r,n){return Lr=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"draw",precision:2}),ht(Lr),this};var Ar=t.fillColor||"0 g";y.__private__.getFillColor=y.getFillColor=function(){return ee(Ar)},y.__private__.setFillColor=y.setFillColor=function(t,e,r,n){return Ar=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"fill",precision:2}),ht(Ar),this};var xr=t.textColor||"0 g",Sr=y.__private__.getTextColor=y.getTextColor=function(){return ee(xr)};y.__private__.setTextColor=y.setTextColor=function(t,e,r,n){return xr=re({ch1:t,ch2:e,ch3:r,ch4:n,pdfColorType:"text",precision:3}),this};var _r=t.charSpace,Pr=y.__private__.getCharSpace=y.getCharSpace=function(){return parseFloat(_r||0)};y.__private__.setCharSpace=y.setCharSpace=function(t){if(isNaN(t))throw new Error("Invalid argument passed to jsPDF.setCharSpace");return _r=t,this};var kr=0;y.CapJoinStyles={0:0,butt:0,but:0,miter:0,1:1,round:1,rounded:1,circle:1,2:2,projecting:2,project:2,square:2,bevel:2},y.__private__.setLineCap=y.setLineCap=function(t){var e=y.CapJoinStyles[t];if(void 0===e)throw new Error("Line cap style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return kr=e,ht(e+" J"),this};var Fr=0;y.__private__.setLineJoin=y.setLineJoin=function(t){var e=y.CapJoinStyles[t];if(void 0===e)throw new Error("Line join style of '"+t+"' is not recognized. See or extend .CapJoinStyles property for valid styles");return Fr=e,ht(e+" j"),this},y.__private__.setLineMiterLimit=y.__private__.setMiterLimit=y.setLineMiterLimit=y.setMiterLimit=function(t){if(t=t||0,isNaN(t))throw new Error("Invalid argument passed to jsPDF.setLineMiterLimit");return ht(E(U(t))+" M"),this},y.GState=C,y.setGState=function(t){(t="string"==typeof t?Mt[Et[t]]:Ir(null,t)).equals(qt)||(ht("/"+t.id+" gs"),qt=t)};var Ir=function(t,e){if(!t||!Et[t]){var r=!1;for(var n in Mt)if(Mt.hasOwnProperty(n)&&Mt[n].equals(e)){r=!0;break}if(r)e=Mt[n];else{var i="GS"+(Object.keys(Mt).length+1).toString(10);Mt[i]=e,e.id=i}return t&&(Et[t]=e.id),Tt.publish("addGState",e),e}};y.addGState=function(t,e){return Ir(t,e),this},y.saveGraphicsState=function(){return ht("q"),jt.push({key:St,size:gt,color:xr}),this},y.restoreGraphicsState=function(){ht("Q");var t=jt.pop();return St=t.key,gt=t.size,xr=t.color,qt=null,this},y.setCurrentTransformationMatrix=function(t){return ht(t.toString()+" cm"),this},y.comment=function(t){return ht("#"+t),this};var Cr=function(t,e){var r=t||0;Object.defineProperty(this,"x",{enumerable:!0,get:function(){return r},set:function(t){isNaN(t)||(r=parseFloat(t))}});var n=e||0;Object.defineProperty(this,"y",{enumerable:!0,get:function(){return n},set:function(t){isNaN(t)||(n=parseFloat(t))}});var i="pt";return Object.defineProperty(this,"type",{enumerable:!0,get:function(){return i},set:function(t){i=t.toString()}}),this},jr=function(t,e,r,n){Cr.call(this,t,e),this.type="rect";var i=r||0;Object.defineProperty(this,"w",{enumerable:!0,get:function(){return i},set:function(t){isNaN(t)||(i=parseFloat(t))}});var a=n||0;return Object.defineProperty(this,"h",{enumerable:!0,get:function(){return a},set:function(t){isNaN(t)||(a=parseFloat(t))}}),this},Or=function(){this.page=Dt,this.currentPage=$,this.pages=ot.slice(0),this.pagesContext=Rt.slice(0),this.x=Pt,this.y=kt,this.matrix=Ft,this.width=qr($),this.height=Rr($),this.outputDestination=ct,this.id="",this.objectNumber=-1};Or.prototype.restore=function(){Dt=this.page,$=this.currentPage,Rt=this.pagesContext,ot=this.pages,Pt=this.x,kt=this.y,Ft=this.matrix,Dr($,this.width),Tr($,this.height),ct=this.outputDestination};var Br=function(t,e,r,n,i){Wt.push(new Or),Dt=$=0,ot=[],Pt=t,kt=e,Ft=i,je([r,n])},Mr=function(t){if(Ht[t])Wt.pop().restore();else{var e=new Or,r="Xo"+(Object.keys(zt).length+1).toString(10);e.id=r,Ht[t]=r,zt[r]=e,Tt.publish("addFormObject",e),Wt.pop().restore()}};for(var Er in y.beginFormObject=function(t,e,r,n,i){return Br(t,e,r,n,i),this},y.endFormObject=function(t){return Mr(t),this},y.doFormObject=function(t,e){var r=zt[Ht[t]];return ht("q"),ht(e.toString()+" cm"),ht("/"+r.id+" Do"),ht("Q"),this},y.getFormObject=function(t){var e=zt[Ht[t]];return{x:e.x,y:e.y,width:e.width,height:e.height,matrix:e.matrix}},y.save=function(t,e){return t=t||"generated.pdf",(e=e||{}).returnPromise=e.returnPromise||!1,!1===e.returnPromise?(l(We(He()),t),"function"==typeof l.unload&&r.setTimeout&&setTimeout(l.unload,911),this):new Promise((function(e,n){try{var i=l(We(He()),t);"function"==typeof l.unload&&r.setTimeout&&setTimeout(l.unload,911),e(i)}catch(t){n(t.message)}}))},M.API)M.API.hasOwnProperty(Er)&&("events"===Er&&M.API.events.length?function(t,e){var r,n,i;for(i=e.length-1;-1!==i;i--)r=e[i][0],n=e[i][1],t.subscribe.apply(t,[r].concat("function"==typeof n?[n]:n))}(Tt,M.API.events):y[Er]=M.API[Er]);var qr=y.getPageWidth=function(t){return(Rt[t=t||$].mediaBox.topRightX-Rt[t].mediaBox.bottomLeftX)/_t},Dr=y.setPageWidth=function(t,e){Rt[t].mediaBox.topRightX=e*_t+Rt[t].mediaBox.bottomLeftX},Rr=y.getPageHeight=function(t){return(Rt[t=t||$].mediaBox.topRightY-Rt[t].mediaBox.bottomLeftY)/_t},Tr=y.setPageHeight=function(t,e){Rt[t].mediaBox.topRightY=e*_t+Rt[t].mediaBox.bottomLeftY};return y.internal={pdfEscape:Ce,getStyle:tr,getFont:lr,getFontSize:vt,getCharSpace:Pr,getTextColor:Sr,getLineHeight:gr,getLineHeightFactor:vr,getLineWidth:dr,write:ft,getHorizontalCoordinate:br,getVerticalCoordinate:yr,getCoordinateString:wr,getVerticalCoordinateString:Nr,collections:{},newObject:Xt,newAdditionalObject:$t,newObjectDeferred:Kt,newObjectDeferredBegin:Zt,getFilters:ne,putStream:ie,events:Tt,scaleFactor:_t,pageSize:{getWidth:function(){return qr($)},setWidth:function(t){Dr($,t)},getHeight:function(){return Rr($)},setHeight:function(t){Tr($,t)}},encryptionOptions:m,encryption:Ye,getEncryptor:Je,output:Ve,getNumberOfPages:Ee,pages:ot,out:ht,f2:R,f3:T,getPageInfo:Xe,getPageInfoByObjId:Ke,getCurrentPageInfo:Ze,getPDFVersion:N,Point:Cr,Rectangle:jr,Matrix:Vt,hasHotfix:Ge},Object.defineProperty(y.internal.pageSize,"width",{get:function(){return qr($)},set:function(t){Dr($,t)},enumerable:!0,configurable:!0}),Object.defineProperty(y.internal.pageSize,"height",{get:function(){return Rr($)},set:function(t){Tr($,t)},enumerable:!0,configurable:!0}),ke.call(y,pt),St="F1",Oe(s,a),Tt.publish("initialized"),y}k.prototype.lsbFirstWord=function(t){return String.fromCharCode(t>>0&255,t>>8&255,t>>16&255,t>>24&255)},k.prototype.toHexString=function(t){return t.split("").map((function(t){return("0"+(255&t.charCodeAt(0)).toString(16)).slice(-2)})).join("")},k.prototype.hexToBytes=function(t){for(var e=[],r=0;r<t.length;r+=2)e.push(String.fromCharCode(parseInt(t.substr(r,2),16)));return e.join("")},k.prototype.processOwnerPassword=function(t,e){return _(A(e).substr(0,5),t)},k.prototype.encryptor=function(t,e){var r=A(this.encryptionKey+String.fromCharCode(255&t,t>>8&255,t>>16&255,255&e,e>>8&255)).substr(0,10);return function(t){return _(r,t)}},C.prototype.equals=function(t){var r,n="id,objectNumber,equals";if(!t||e(t)!==e(this))return!1;var i=0;for(r in this)if(!(n.indexOf(r)>=0)){if(this.hasOwnProperty(r)&&!t.hasOwnProperty(r))return!1;if(this[r]!==t[r])return!1;i++}for(r in t)t.hasOwnProperty(r)&&n.indexOf(r)<0&&i--;return 0===i},M.API={events:[]},M.version="2.5.2";var E=M.API,q=1,D=function(t){return t.replace(/\\/g,"\\\\").replace(/\(/g,"\\(").replace(/\)/g,"\\)")},R=function(t){return t.replace(/\\\\/g,"\\").replace(/\\\(/g,"(").replace(/\\\)/g,")")},T=function(t){return t.toFixed(2)},U=function(t){return t.toFixed(5)};E.__acroform__={};var z=function(t,e){t.prototype=Object.create(e.prototype),t.prototype.constructor=t},H=function(t){return t*q},W=function(t){var e=new ct,r=Lt.internal.getHeight(t)||0,n=Lt.internal.getWidth(t)||0;return e.BBox=[0,0,Number(T(n)),Number(T(r))],e},V=E.__acroform__.setBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBit");return t|=1<<e},G=E.__acroform__.clearBit=function(t,e){if(t=t||0,e=e||0,isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBit");return t&=~(1<<e)},Y=E.__acroform__.getBit=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBit");return 0==(t&1<<e)?0:1},J=E.__acroform__.getBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.getBitForPdf");return Y(t,e-1)},X=E.__acroform__.setBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.setBitForPdf");return V(t,e-1)},K=E.__acroform__.clearBitForPdf=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid arguments passed to jsPDF.API.__acroform__.clearBitForPdf");return G(t,e-1)},Z=E.__acroform__.calculateCoordinates=function(t,e){var r=e.internal.getHorizontalCoordinate,n=e.internal.getVerticalCoordinate,i=t[0],a=t[1],o=t[2],s=t[3],c={};return c.lowerLeft_X=r(i)||0,c.lowerLeft_Y=n(a+s)||0,c.upperRight_X=r(i+o)||0,c.upperRight_Y=n(a)||0,[Number(T(c.lowerLeft_X)),Number(T(c.lowerLeft_Y)),Number(T(c.upperRight_X)),Number(T(c.upperRight_Y))]},$=function(t){if(t.appearanceStreamContent)return t.appearanceStreamContent;if(t.V||t.DV){var e=[],r=t._V||t.DV,n=Q(t,r),i=t.scope.internal.getFont(t.fontName,t.fontStyle).id;e.push("/Tx BMC"),e.push("q"),e.push("BT"),e.push(t.scope.__private__.encodeColorString(t.color)),e.push("/"+i+" "+T(n.fontSize)+" Tf"),e.push("1 0 0 1 0 0 Tm"),e.push(n.text),e.push("ET"),e.push("Q"),e.push("EMC");var a=W(t);return a.scope=t.scope,a.stream=e.join("\n"),a}},Q=function(t,e){var r=0===t.fontSize?t.maxFontSize:t.fontSize,n={text:"",fontSize:""},i=(e=")"==(e="("==e.substr(0,1)?e.substr(1):e).substr(e.length-1)?e.substr(0,e.length-1):e).split(" ");i=t.multiline?i.map((function(t){return t.split("\n")})):i.map((function(t){return[t]}));var a=r,o=Lt.internal.getHeight(t)||0;o=o<0?-o:o;var s=Lt.internal.getWidth(t)||0;s=s<0?-s:s;var c=function(e,r,n){if(e+1<i.length){var a=r+" "+i[e+1][0];return tt(a,t,n).width<=s-4}return!1};a++;t:for(;a>0;){e="",a--;var u,l,h=tt("3",t,a).height,f=t.multiline?o-a:(o-h)/2,d=f+=2,p=0,g=0,m=0;if(a<=0){e="(...) Tj\n",e+="% Width of Text: "+tt(e,t,a=12).width+", FieldWidth:"+s+"\n";break}for(var v="",b=0,y=0;y<i.length;y++)if(i.hasOwnProperty(y)){var w=!1;if(1!==i[y].length&&m!==i[y].length-1){if((h+2)*(b+2)+2>o)continue t;v+=i[y][m],w=!0,g=y,y--}else{v=" "==(v+=i[y][m]+" ").substr(v.length-1)?v.substr(0,v.length-1):v;var N=parseInt(y),L=c(N,v,a),A=y>=i.length-1;if(L&&!A){v+=" ",m=0;continue}if(L||A){if(A)g=N;else if(t.multiline&&(h+2)*(b+2)+2>o)continue t}else{if(!t.multiline)continue t;if((h+2)*(b+2)+2>o)continue t;g=N}}for(var x="",S=p;S<=g;S++){var _=i[S];if(t.multiline){if(S===g){x+=_[m]+" ",m=(m+1)%_.length;continue}if(S===p){x+=_[_.length-1]+" ";continue}}x+=_[0]+" "}switch(x=" "==x.substr(x.length-1)?x.substr(0,x.length-1):x,l=tt(x,t,a).width,t.textAlign){case"right":u=s-l-2;break;case"center":u=(s-l)/2;break;case"left":default:u=2}e+=T(u)+" "+T(d)+" Td\n",e+="("+D(x)+") Tj\n",e+=-T(u)+" 0 Td\n",d=-(a+2),l=0,p=w?g:g+1,b++,v=""}else;break}return n.text=e,n.fontSize=a,n},tt=function(t,e,r){var n=e.scope.internal.getFont(e.fontName,e.fontStyle),i=e.scope.getStringUnitWidth(t,{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r);return{height:e.scope.getStringUnitWidth("3",{font:n,fontSize:parseFloat(r),charSpace:0})*parseFloat(r)*1.5,width:i}},et={fields:[],xForms:[],acroFormDictionaryRoot:null,printedOut:!1,internal:null,isInitialized:!1},rt=function(t,e){var r={type:"reference",object:t};void 0===e.internal.getPageInfo(t.page).pageContext.annotations.find((function(t){return t.type===r.type&&t.object===r.object}))&&e.internal.getPageInfo(t.page).pageContext.annotations.push(r)},nt=function(t,r){for(var n in t)if(t.hasOwnProperty(n)){var i=n,a=t[n];r.internal.newObjectDeferredBegin(a.objId,!0),"object"===e(a)&&"function"==typeof a.putStream&&a.putStream(),delete t[i]}},it=function(t,r){if(r.scope=t,void 0!==t.internal&&(void 0===t.internal.acroformPlugin||!1===t.internal.acroformPlugin.isInitialized)){if(lt.FieldNum=0,t.internal.acroformPlugin=JSON.parse(JSON.stringify(et)),t.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("Exception while creating AcroformDictionary");q=t.internal.scaleFactor,t.internal.acroformPlugin.acroFormDictionaryRoot=new ut,t.internal.acroformPlugin.acroFormDictionaryRoot.scope=t,t.internal.acroformPlugin.acroFormDictionaryRoot._eventID=t.internal.events.subscribe("postPutResources",(function(){!function(t){t.internal.events.unsubscribe(t.internal.acroformPlugin.acroFormDictionaryRoot._eventID),delete t.internal.acroformPlugin.acroFormDictionaryRoot._eventID,t.internal.acroformPlugin.printedOut=!0}(t)})),t.internal.events.subscribe("buildDocument",(function(){!function(t){t.internal.acroformPlugin.acroFormDictionaryRoot.objId=void 0;var e=t.internal.acroformPlugin.acroFormDictionaryRoot.Fields;for(var r in e)if(e.hasOwnProperty(r)){var n=e[r];n.objId=void 0,n.hasAnnotation&&rt(n,t)}}(t)})),t.internal.events.subscribe("putCatalog",(function(){!function(t){if(void 0===t.internal.acroformPlugin.acroFormDictionaryRoot)throw new Error("putCatalogCallback: Root missing.");t.internal.write("/AcroForm "+t.internal.acroformPlugin.acroFormDictionaryRoot.objId+" 0 R")}(t)})),t.internal.events.subscribe("postPutPages",(function(r){!function(t,r){var n=!t;for(var i in t||(r.internal.newObjectDeferredBegin(r.internal.acroformPlugin.acroFormDictionaryRoot.objId,!0),r.internal.acroformPlugin.acroFormDictionaryRoot.putStream()),t=t||r.internal.acroformPlugin.acroFormDictionaryRoot.Kids)if(t.hasOwnProperty(i)){var a=t[i],o=[],s=a.Rect;if(a.Rect&&(a.Rect=Z(a.Rect,r)),r.internal.newObjectDeferredBegin(a.objId,!0),a.DA=Lt.createDefaultAppearanceStream(a),"object"===e(a)&&"function"==typeof a.getKeyValueListForStream&&(o=a.getKeyValueListForStream()),a.Rect=s,a.hasAppearanceStream&&!a.appearanceStreamContent){var c=$(a);o.push({key:"AP",value:"<</N "+c+">>"}),r.internal.acroformPlugin.xForms.push(c)}if(a.appearanceStreamContent){var u="";for(var l in a.appearanceStreamContent)if(a.appearanceStreamContent.hasOwnProperty(l)){var h=a.appearanceStreamContent[l];if(u+="/"+l+" ",u+="<<",Object.keys(h).length>=1||Array.isArray(h)){for(var i in h)if(h.hasOwnProperty(i)){var f=h[i];"function"==typeof f&&(f=f.call(r,a)),u+="/"+i+" "+f+" ",r.internal.acroformPlugin.xForms.indexOf(f)>=0||r.internal.acroformPlugin.xForms.push(f)}}else"function"==typeof(f=h)&&(f=f.call(r,a)),u+="/"+i+" "+f,r.internal.acroformPlugin.xForms.indexOf(f)>=0||r.internal.acroformPlugin.xForms.push(f);u+=">>"}o.push({key:"AP",value:"<<\n"+u+">>"})}r.internal.putStream({additionalKeyValues:o,objectId:a.objId}),r.internal.out("endobj")}n&&nt(r.internal.acroformPlugin.xForms,r)}(r,t)})),t.internal.acroformPlugin.isInitialized=!0}},at=E.__acroform__.arrayToPdfArray=function(t,r,n){var i=function(t){return t};if(Array.isArray(t)){for(var a="[",o=0;o<t.length;o++)switch(0!==o&&(a+=" "),e(t[o])){case"boolean":case"number":case"object":a+=t[o].toString();break;case"string":"/"!==t[o].substr(0,1)?(void 0!==r&&n&&(i=n.internal.getEncryptor(r)),a+="("+D(i(t[o].toString()))+")"):a+=t[o].toString()}return a+="]"}throw new Error("Invalid argument passed to jsPDF.__acroform__.arrayToPdfArray")};var ot=function(t,e,r){var n=function(t){return t};return void 0!==e&&r&&(n=r.internal.getEncryptor(e)),(t=t||"").toString(),t="("+D(n(t))+")"},st=function(){this._objId=void 0,this._scope=void 0,Object.defineProperty(this,"objId",{get:function(){if(void 0===this._objId){if(void 0===this.scope)return;this._objId=this.scope.internal.newObjectDeferred()}return this._objId},set:function(t){this._objId=t}}),Object.defineProperty(this,"scope",{value:this._scope,writable:!0})};st.prototype.toString=function(){return this.objId+" 0 R"},st.prototype.putStream=function(){var t=this.getKeyValueListForStream();this.scope.internal.putStream({data:this.stream,additionalKeyValues:t,objectId:this.objId}),this.scope.internal.out("endobj")},st.prototype.getKeyValueListForStream=function(){var t=[],e=Object.getOwnPropertyNames(this).filter((function(t){return"content"!=t&&"appearanceStreamContent"!=t&&"scope"!=t&&"objId"!=t&&"_"!=t.substring(0,1)}));for(var r in e)if(!1===Object.getOwnPropertyDescriptor(this,e[r]).configurable){var n=e[r],i=this[n];i&&(Array.isArray(i)?t.push({key:n,value:at(i,this.objId,this.scope)}):i instanceof st?(i.scope=this.scope,t.push({key:n,value:i.objId+" 0 R"})):"function"!=typeof i&&t.push({key:n,value:i}))}return t};var ct=function(){st.call(this),Object.defineProperty(this,"Type",{value:"/XObject",configurable:!1,writable:!0}),Object.defineProperty(this,"Subtype",{value:"/Form",configurable:!1,writable:!0}),Object.defineProperty(this,"FormType",{value:1,configurable:!1,writable:!0});var t,e=[];Object.defineProperty(this,"BBox",{configurable:!1,get:function(){return e},set:function(t){e=t}}),Object.defineProperty(this,"Resources",{value:"2 0 R",configurable:!1,writable:!0}),Object.defineProperty(this,"stream",{enumerable:!1,configurable:!0,set:function(e){t=e.trim()},get:function(){return t||null}})};z(ct,st);var ut=function(){st.call(this);var t,e=[];Object.defineProperty(this,"Kids",{enumerable:!1,configurable:!0,get:function(){return e.length>0?e:void 0}}),Object.defineProperty(this,"Fields",{enumerable:!1,configurable:!1,get:function(){return e}}),Object.defineProperty(this,"DA",{enumerable:!1,configurable:!1,get:function(){if(t){var e=function(t){return t};return this.scope&&(e=this.scope.internal.getEncryptor(this.objId)),"("+D(e(t))+")"}},set:function(e){t=e}})};z(ut,st);var lt=function t(){st.call(this);var e=4;Object.defineProperty(this,"F",{enumerable:!1,configurable:!1,get:function(){return e},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute F supplied.');e=t}}),Object.defineProperty(this,"showWhenPrinted",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(e,3))},set:function(t){!0===Boolean(t)?this.F=X(e,3):this.F=K(e,3)}});var r=0;Object.defineProperty(this,"Ff",{enumerable:!1,configurable:!1,get:function(){return r},set:function(t){if(isNaN(t))throw new Error('Invalid value "'+t+'" for attribute Ff supplied.');r=t}});var n=[];Object.defineProperty(this,"Rect",{enumerable:!1,configurable:!1,get:function(){if(0!==n.length)return n},set:function(t){n=void 0!==t?t:[]}}),Object.defineProperty(this,"x",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[0])?0:n[0]},set:function(t){n[0]=t}}),Object.defineProperty(this,"y",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[1])?0:n[1]},set:function(t){n[1]=t}}),Object.defineProperty(this,"width",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[2])?0:n[2]},set:function(t){n[2]=t}}),Object.defineProperty(this,"height",{enumerable:!0,configurable:!0,get:function(){return!n||isNaN(n[3])?0:n[3]},set:function(t){n[3]=t}});var i="";Object.defineProperty(this,"FT",{enumerable:!0,configurable:!1,get:function(){return i},set:function(t){switch(t){case"/Btn":case"/Tx":case"/Ch":case"/Sig":i=t;break;default:throw new Error('Invalid value "'+t+'" for attribute FT supplied.')}}});var a=null;Object.defineProperty(this,"T",{enumerable:!0,configurable:!1,get:function(){if(!a||a.length<1){if(this instanceof bt)return;a="FieldObject"+t.FieldNum++}var e=function(t){return t};return this.scope&&(e=this.scope.internal.getEncryptor(this.objId)),"("+D(e(a))+")"},set:function(t){a=t.toString()}}),Object.defineProperty(this,"fieldName",{configurable:!0,enumerable:!0,get:function(){return a},set:function(t){a=t}});var o="helvetica";Object.defineProperty(this,"fontName",{enumerable:!0,configurable:!0,get:function(){return o},set:function(t){o=t}});var s="normal";Object.defineProperty(this,"fontStyle",{enumerable:!0,configurable:!0,get:function(){return s},set:function(t){s=t}});var c=0;Object.defineProperty(this,"fontSize",{enumerable:!0,configurable:!0,get:function(){return c},set:function(t){c=t}});var u=void 0;Object.defineProperty(this,"maxFontSize",{enumerable:!0,configurable:!0,get:function(){return void 0===u?50/q:u},set:function(t){u=t}});var l="black";Object.defineProperty(this,"color",{enumerable:!0,configurable:!0,get:function(){return l},set:function(t){l=t}});var h="/F1 0 Tf 0 g";Object.defineProperty(this,"DA",{enumerable:!0,configurable:!1,get:function(){if(!(!h||this instanceof bt||this instanceof wt))return ot(h,this.objId,this.scope)},set:function(t){t=t.toString(),h=t}});var f=null;Object.defineProperty(this,"DV",{enumerable:!1,configurable:!1,get:function(){if(f)return this instanceof gt==!1?ot(f,this.objId,this.scope):f},set:function(t){t=t.toString(),f=this instanceof gt==!1?"("===t.substr(0,1)?R(t.substr(1,t.length-2)):R(t):t}}),Object.defineProperty(this,"defaultValue",{enumerable:!0,configurable:!0,get:function(){return this instanceof gt==!0?R(f.substr(1,f.length-1)):f},set:function(t){t=t.toString(),f=this instanceof gt==!0?"/"+t:t}});var d=null;Object.defineProperty(this,"_V",{enumerable:!1,configurable:!1,get:function(){if(d)return d},set:function(t){this.V=t}}),Object.defineProperty(this,"V",{enumerable:!1,configurable:!1,get:function(){if(d)return this instanceof gt==!1?ot(d,this.objId,this.scope):d},set:function(t){t=t.toString(),d=this instanceof gt==!1?"("===t.substr(0,1)?R(t.substr(1,t.length-2)):R(t):t}}),Object.defineProperty(this,"value",{enumerable:!0,configurable:!0,get:function(){return this instanceof gt==!0?R(d.substr(1,d.length-1)):d},set:function(t){t=t.toString(),d=this instanceof gt==!0?"/"+t:t}}),Object.defineProperty(this,"hasAnnotation",{enumerable:!0,configurable:!0,get:function(){return this.Rect}}),Object.defineProperty(this,"Type",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Annot":null}}),Object.defineProperty(this,"Subtype",{enumerable:!0,configurable:!1,get:function(){return this.hasAnnotation?"/Widget":null}});var p,g=!1;Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return g},set:function(t){t=Boolean(t),g=t}}),Object.defineProperty(this,"page",{enumerable:!0,configurable:!0,get:function(){if(p)return p},set:function(t){p=t}}),Object.defineProperty(this,"readOnly",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,1))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,1):this.Ff=K(this.Ff,1)}}),Object.defineProperty(this,"required",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,2))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,2):this.Ff=K(this.Ff,2)}}),Object.defineProperty(this,"noExport",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,3))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,3):this.Ff=K(this.Ff,3)}});var m=null;Object.defineProperty(this,"Q",{enumerable:!0,configurable:!1,get:function(){if(null!==m)return m},set:function(t){if(-1===[0,1,2].indexOf(t))throw new Error('Invalid value "'+t+'" for attribute Q supplied.');m=t}}),Object.defineProperty(this,"textAlign",{get:function(){var t;switch(m){case 0:default:t="left";break;case 1:t="center";break;case 2:t="right"}return t},configurable:!0,enumerable:!0,set:function(t){switch(t){case"right":case 2:m=2;break;case"center":case 1:m=1;break;case"left":case 0:default:m=0}}})};z(lt,st);var ht=function(){lt.call(this),this.FT="/Ch",this.V="()",this.fontName="zapfdingbats";var t=0;Object.defineProperty(this,"TI",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"topIndex",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){t=e}});var e=[];Object.defineProperty(this,"Opt",{enumerable:!0,configurable:!1,get:function(){return at(e,this.objId,this.scope)},set:function(t){var r,n;n=[],"string"==typeof(r=t)&&(n=function(t,e,r){r||(r=1);for(var n,i=[];n=e.exec(t);)i.push(n[r]);return i}(r,/\((.*?)\)/g)),e=n}}),this.getOptions=function(){return e},this.setOptions=function(t){e=t,this.sort&&e.sort()},this.addOption=function(t){t=(t=t||"").toString(),e.push(t),this.sort&&e.sort()},this.removeOption=function(t,r){for(r=r||!1,t=(t=t||"").toString();-1!==e.indexOf(t)&&(e.splice(e.indexOf(t),1),!1!==r););},Object.defineProperty(this,"combo",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,18))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,18):this.Ff=K(this.Ff,18)}}),Object.defineProperty(this,"edit",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,19))},set:function(t){!0===this.combo&&(!0===Boolean(t)?this.Ff=X(this.Ff,19):this.Ff=K(this.Ff,19))}}),Object.defineProperty(this,"sort",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,20))},set:function(t){!0===Boolean(t)?(this.Ff=X(this.Ff,20),e.sort()):this.Ff=K(this.Ff,20)}}),Object.defineProperty(this,"multiSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,22))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,22):this.Ff=K(this.Ff,22)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,23):this.Ff=K(this.Ff,23)}}),Object.defineProperty(this,"commitOnSelChange",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,27))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,27):this.Ff=K(this.Ff,27)}}),this.hasAppearanceStream=!1};z(ht,lt);var ft=function(){ht.call(this),this.fontName="helvetica",this.combo=!1};z(ft,ht);var dt=function(){ft.call(this),this.combo=!0};z(dt,ft);var pt=function(){dt.call(this),this.edit=!0};z(pt,dt);var gt=function(){lt.call(this),this.FT="/Btn",Object.defineProperty(this,"noToggleToOff",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,15))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,15):this.Ff=K(this.Ff,15)}}),Object.defineProperty(this,"radio",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,16))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,16):this.Ff=K(this.Ff,16)}}),Object.defineProperty(this,"pushButton",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,17))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,17):this.Ff=K(this.Ff,17)}}),Object.defineProperty(this,"radioIsUnison",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,26):this.Ff=K(this.Ff,26)}});var t,r={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};if(this.scope&&(t=this.scope.internal.getEncryptor(this.objId)),0!==Object.keys(r).length){var e,n=[];for(e in n.push("<<"),r)n.push("/"+e+" ("+D(t(r[e]))+")");return n.push(">>"),n.join("\n")}},set:function(t){"object"===e(t)&&(r=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return r.CA||""},set:function(t){"string"==typeof t&&(r.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return t.substr(1,t.length-1)},set:function(e){t="/"+e}})};z(gt,lt);var mt=function(){gt.call(this),this.pushButton=!0};z(mt,gt);var vt=function(){gt.call(this),this.radio=!0,this.pushButton=!1;var t=[];Object.defineProperty(this,"Kids",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=void 0!==e?e:[]}})};z(vt,gt);var bt=function(){var t,r;lt.call(this),Object.defineProperty(this,"Parent",{enumerable:!1,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"optionName",{enumerable:!1,configurable:!0,get:function(){return r},set:function(t){r=t}});var n,i={};Object.defineProperty(this,"MK",{enumerable:!1,configurable:!1,get:function(){var t=function(t){return t};this.scope&&(t=this.scope.internal.getEncryptor(this.objId));var e,r=[];for(e in r.push("<<"),i)r.push("/"+e+" ("+D(t(i[e]))+")");return r.push(">>"),r.join("\n")},set:function(t){"object"===e(t)&&(i=t)}}),Object.defineProperty(this,"caption",{enumerable:!0,configurable:!0,get:function(){return i.CA||""},set:function(t){"string"==typeof t&&(i.CA=t)}}),Object.defineProperty(this,"AS",{enumerable:!1,configurable:!1,get:function(){return n},set:function(t){n=t}}),Object.defineProperty(this,"appearanceState",{enumerable:!0,configurable:!0,get:function(){return n.substr(1,n.length-1)},set:function(t){n="/"+t}}),this.caption="l",this.appearanceState="Off",this._AppearanceType=Lt.RadioButton.Circle,this.appearanceStreamContent=this._AppearanceType.createAppearanceStream(this.optionName)};z(bt,lt),vt.prototype.setAppearance=function(t){if(!("createAppearanceStream"in t)||!("getCA"in t))throw new Error("Couldn't assign Appearance to RadioButton. Appearance was Invalid!");for(var e in this.Kids)if(this.Kids.hasOwnProperty(e)){var r=this.Kids[e];r.appearanceStreamContent=t.createAppearanceStream(r.optionName),r.caption=t.getCA()}},vt.prototype.createOption=function(t){var e=new bt;return e.Parent=this,e.optionName=t,this.Kids.push(e),At.call(this.scope,e),e};var yt=function(){gt.call(this),this.fontName="zapfdingbats",this.caption="3",this.appearanceState="On",this.value="On",this.textAlign="center",this.appearanceStreamContent=Lt.CheckBox.createAppearanceStream()};z(yt,gt);var wt=function(){lt.call(this),this.FT="/Tx",Object.defineProperty(this,"multiline",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,13))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,13):this.Ff=K(this.Ff,13)}}),Object.defineProperty(this,"fileSelect",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,21))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,21):this.Ff=K(this.Ff,21)}}),Object.defineProperty(this,"doNotSpellCheck",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,23))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,23):this.Ff=K(this.Ff,23)}}),Object.defineProperty(this,"doNotScroll",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,24))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,24):this.Ff=K(this.Ff,24)}}),Object.defineProperty(this,"comb",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,25))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,25):this.Ff=K(this.Ff,25)}}),Object.defineProperty(this,"richText",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,26))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,26):this.Ff=K(this.Ff,26)}});var t=null;Object.defineProperty(this,"MaxLen",{enumerable:!0,configurable:!1,get:function(){return t},set:function(e){t=e}}),Object.defineProperty(this,"maxLength",{enumerable:!0,configurable:!0,get:function(){return t},set:function(e){Number.isInteger(e)&&(t=e)}}),Object.defineProperty(this,"hasAppearanceStream",{enumerable:!0,configurable:!0,get:function(){return this.V||this.DV}})};z(wt,lt);var Nt=function(){wt.call(this),Object.defineProperty(this,"password",{enumerable:!0,configurable:!0,get:function(){return Boolean(J(this.Ff,14))},set:function(t){!0===Boolean(t)?this.Ff=X(this.Ff,14):this.Ff=K(this.Ff,14)}}),this.password=!0};z(Nt,wt);var Lt={CheckBox:{createAppearanceStream:function(){return{N:{On:Lt.CheckBox.YesNormal},D:{On:Lt.CheckBox.YesPushDown,Off:Lt.CheckBox.OffPushDown}}},YesPushDown:function(t){var e=W(t);e.scope=t.scope;var r=[],n=t.scope.internal.getFont(t.fontName,t.fontStyle).id,i=t.scope.__private__.encodeColorString(t.color),a=Q(t,t.caption);return r.push("0.749023 g"),r.push("0 0 "+T(Lt.internal.getWidth(t))+" "+T(Lt.internal.getHeight(t))+" re"),r.push("f"),r.push("BMC"),r.push("q"),r.push("0 0 1 rg"),r.push("/"+n+" "+T(a.fontSize)+" Tf "+i),r.push("BT"),r.push(a.text),r.push("ET"),r.push("Q"),r.push("EMC"),e.stream=r.join("\n"),e},YesNormal:function(t){var e=W(t);e.scope=t.scope;var r=t.scope.internal.getFont(t.fontName,t.fontStyle).id,n=t.scope.__private__.encodeColorString(t.color),i=[],a=Lt.internal.getHeight(t),o=Lt.internal.getWidth(t),s=Q(t,t.caption);return i.push("1 g"),i.push("0 0 "+T(o)+" "+T(a)+" re"),i.push("f"),i.push("q"),i.push("0 0 1 rg"),i.push("0 0 "+T(o-1)+" "+T(a-1)+" re"),i.push("W"),i.push("n"),i.push("0 g"),i.push("BT"),i.push("/"+r+" "+T(s.fontSize)+" Tf "+n),i.push(s.text),i.push("ET"),i.push("Q"),e.stream=i.join("\n"),e},OffPushDown:function(t){var e=W(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+T(Lt.internal.getWidth(t))+" "+T(Lt.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}},RadioButton:{Circle:{createAppearanceStream:function(t){var e={D:{Off:Lt.RadioButton.Circle.OffPushDown},N:{}};return e.N[t]=Lt.RadioButton.Circle.YesNormal,e.D[t]=Lt.RadioButton.Circle.YesPushDown,e},getCA:function(){return"l"},YesNormal:function(t){var e=W(t);e.scope=t.scope;var r=[],n=Lt.internal.getWidth(t)<=Lt.internal.getHeight(t)?Lt.internal.getWidth(t)/4:Lt.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Lt.internal.Bezier_C,a=Number((n*i).toFixed(5));return r.push("q"),r.push("1 0 0 1 "+U(Lt.internal.getWidth(t)/2)+" "+U(Lt.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+a+" "+a+" "+n+" 0 "+n+" c"),r.push("-"+a+" "+n+" -"+n+" "+a+" -"+n+" 0 c"),r.push("-"+n+" -"+a+" -"+a+" -"+n+" 0 -"+n+" c"),r.push(a+" -"+n+" "+n+" -"+a+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=W(t);e.scope=t.scope;var r=[],n=Lt.internal.getWidth(t)<=Lt.internal.getHeight(t)?Lt.internal.getWidth(t)/4:Lt.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*Lt.internal.Bezier_C).toFixed(5)),o=Number((n*Lt.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+U(Lt.internal.getWidth(t)/2)+" "+U(Lt.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),r.push("0 g"),r.push("q"),r.push("1 0 0 1 "+U(Lt.internal.getWidth(t)/2)+" "+U(Lt.internal.getHeight(t)/2)+" cm"),r.push(n+" 0 m"),r.push(n+" "+o+" "+o+" "+n+" 0 "+n+" c"),r.push("-"+o+" "+n+" -"+n+" "+o+" -"+n+" 0 c"),r.push("-"+n+" -"+o+" -"+o+" -"+n+" 0 -"+n+" c"),r.push(o+" -"+n+" "+n+" -"+o+" "+n+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e},OffPushDown:function(t){var e=W(t);e.scope=t.scope;var r=[],n=Lt.internal.getWidth(t)<=Lt.internal.getHeight(t)?Lt.internal.getWidth(t)/4:Lt.internal.getHeight(t)/4;n=Number((.9*n).toFixed(5));var i=Number((2*n).toFixed(5)),a=Number((i*Lt.internal.Bezier_C).toFixed(5));return r.push("0.749023 g"),r.push("q"),r.push("1 0 0 1 "+U(Lt.internal.getWidth(t)/2)+" "+U(Lt.internal.getHeight(t)/2)+" cm"),r.push(i+" 0 m"),r.push(i+" "+a+" "+a+" "+i+" 0 "+i+" c"),r.push("-"+a+" "+i+" -"+i+" "+a+" -"+i+" 0 c"),r.push("-"+i+" -"+a+" -"+a+" -"+i+" 0 -"+i+" c"),r.push(a+" -"+i+" "+i+" -"+a+" "+i+" 0 c"),r.push("f"),r.push("Q"),e.stream=r.join("\n"),e}},Cross:{createAppearanceStream:function(t){var e={D:{Off:Lt.RadioButton.Cross.OffPushDown},N:{}};return e.N[t]=Lt.RadioButton.Cross.YesNormal,e.D[t]=Lt.RadioButton.Cross.YesPushDown,e},getCA:function(){return"8"},YesNormal:function(t){var e=W(t);e.scope=t.scope;var r=[],n=Lt.internal.calculateCross(t);return r.push("q"),r.push("1 1 "+T(Lt.internal.getWidth(t)-2)+" "+T(Lt.internal.getHeight(t)-2)+" re"),r.push("W"),r.push("n"),r.push(T(n.x1.x)+" "+T(n.x1.y)+" m"),r.push(T(n.x2.x)+" "+T(n.x2.y)+" l"),r.push(T(n.x4.x)+" "+T(n.x4.y)+" m"),r.push(T(n.x3.x)+" "+T(n.x3.y)+" l"),r.push("s"),r.push("Q"),e.stream=r.join("\n"),e},YesPushDown:function(t){var e=W(t);e.scope=t.scope;var r=Lt.internal.calculateCross(t),n=[];return n.push("0.749023 g"),n.push("0 0 "+T(Lt.internal.getWidth(t))+" "+T(Lt.internal.getHeight(t))+" re"),n.push("f"),n.push("q"),n.push("1 1 "+T(Lt.internal.getWidth(t)-2)+" "+T(Lt.internal.getHeight(t)-2)+" re"),n.push("W"),n.push("n"),n.push(T(r.x1.x)+" "+T(r.x1.y)+" m"),n.push(T(r.x2.x)+" "+T(r.x2.y)+" l"),n.push(T(r.x4.x)+" "+T(r.x4.y)+" m"),n.push(T(r.x3.x)+" "+T(r.x3.y)+" l"),n.push("s"),n.push("Q"),e.stream=n.join("\n"),e},OffPushDown:function(t){var e=W(t);e.scope=t.scope;var r=[];return r.push("0.749023 g"),r.push("0 0 "+T(Lt.internal.getWidth(t))+" "+T(Lt.internal.getHeight(t))+" re"),r.push("f"),e.stream=r.join("\n"),e}}},createDefaultAppearanceStream:function(t){var e=t.scope.internal.getFont(t.fontName,t.fontStyle).id,r=t.scope.__private__.encodeColorString(t.color);return"/"+e+" "+t.fontSize+" Tf "+r}};Lt.internal={Bezier_C:.551915024494,calculateCross:function(t){var e=Lt.internal.getWidth(t),r=Lt.internal.getHeight(t),n=Math.min(e,r);return{x1:{x:(e-n)/2,y:(r-n)/2+n},x2:{x:(e-n)/2+n,y:(r-n)/2},x3:{x:(e-n)/2,y:(r-n)/2},x4:{x:(e-n)/2+n,y:(r-n)/2+n}}}},Lt.internal.getWidth=function(t){var r=0;return"object"===e(t)&&(r=H(t.Rect[2])),r},Lt.internal.getHeight=function(t){var r=0;return"object"===e(t)&&(r=H(t.Rect[3])),r};var At=E.addField=function(t){if(it(this,t),!(t instanceof lt))throw new Error("Invalid argument passed to jsPDF.addField.");var e;return(e=t).scope.internal.acroformPlugin.printedOut&&(e.scope.internal.acroformPlugin.printedOut=!1,e.scope.internal.acroformPlugin.acroFormDictionaryRoot=null),e.scope.internal.acroformPlugin.acroFormDictionaryRoot.Fields.push(e),t.page=t.scope.internal.getCurrentPageInfo().pageNumber,this};E.AcroFormChoiceField=ht,E.AcroFormListBox=ft,E.AcroFormComboBox=dt,E.AcroFormEditBox=pt,E.AcroFormButton=gt,E.AcroFormPushButton=mt,E.AcroFormRadioButton=vt,E.AcroFormCheckBox=yt,E.AcroFormTextField=wt,E.AcroFormPasswordField=Nt,E.AcroFormAppearance=Lt,E.AcroForm={ChoiceField:ht,ListBox:ft,ComboBox:dt,EditBox:pt,Button:gt,PushButton:mt,RadioButton:vt,CheckBox:yt,TextField:wt,PasswordField:Nt,Appearance:Lt},M.AcroForm={ChoiceField:ht,ListBox:ft,ComboBox:dt,EditBox:pt,Button:gt,PushButton:mt,RadioButton:vt,CheckBox:yt,TextField:wt,PasswordField:Nt,Appearance:Lt};var xt=M.AcroForm;function St(t){return t.reduce((function(t,e,r){return t[e]=r,t}),{})}!function(t){t.__addimage__={};var r="UNKNOWN",n={PNG:[[137,80,78,71]],TIFF:[[77,77,0,42],[73,73,42,0]],JPEG:[[255,216,255,224,void 0,void 0,74,70,73,70,0],[255,216,255,225,void 0,void 0,69,120,105,102,0,0],[255,216,255,219],[255,216,255,238]],JPEG2000:[[0,0,0,12,106,80,32,32]],GIF87a:[[71,73,70,56,55,97]],GIF89a:[[71,73,70,56,57,97]],WEBP:[[82,73,70,70,void 0,void 0,void 0,void 0,87,69,66,80]],BMP:[[66,77],[66,65],[67,73],[67,80],[73,67],[80,84]]},i=t.__addimage__.getImageFileTypeByImageData=function(t,e){var i,a,o,s,c,u=r;if("RGBA"===(e=e||r)||void 0!==t.data&&t.data instanceof Uint8ClampedArray&&"height"in t&&"width"in t)return"RGBA";if(x(t))for(c in n)for(o=n[c],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t[a]){s=!1;break}if(!0===s){u=c;break}}else for(c in n)for(o=n[c],i=0;i<o.length;i+=1){for(s=!0,a=0;a<o[i].length;a+=1)if(void 0!==o[i][a]&&o[i][a]!==t.charCodeAt(a)){s=!1;break}if(!0===s){u=c;break}}return u===r&&e!==r&&(u=e),u},a=function t(e){for(var r=this.internal.write,n=this.internal.putStream,i=(0,this.internal.getFilters)();-1!==i.indexOf("FlateEncode");)i.splice(i.indexOf("FlateEncode"),1);e.objectId=this.internal.newObject();var a=[];if(a.push({key:"Type",value:"/XObject"}),a.push({key:"Subtype",value:"/Image"}),a.push({key:"Width",value:e.width}),a.push({key:"Height",value:e.height}),e.colorSpace===b.INDEXED?a.push({key:"ColorSpace",value:"[/Indexed /DeviceRGB "+(e.palette.length/3-1)+" "+("sMask"in e&&void 0!==e.sMask?e.objectId+2:e.objectId+1)+" 0 R]"}):(a.push({key:"ColorSpace",value:"/"+e.colorSpace}),e.colorSpace===b.DEVICE_CMYK&&a.push({key:"Decode",value:"[1 0 1 0 1 0 1 0]"})),a.push({key:"BitsPerComponent",value:e.bitsPerComponent}),"decodeParameters"in e&&void 0!==e.decodeParameters&&a.push({key:"DecodeParms",value:"<<"+e.decodeParameters+">>"}),"transparency"in e&&Array.isArray(e.transparency)){for(var o="",s=0,c=e.transparency.length;s<c;s++)o+=e.transparency[s]+" "+e.transparency[s]+" ";a.push({key:"Mask",value:"["+o+"]"})}void 0!==e.sMask&&a.push({key:"SMask",value:e.objectId+1+" 0 R"});var u=void 0!==e.filter?["/"+e.filter]:void 0;if(n({data:e.data,additionalKeyValues:a,alreadyAppliedFilters:u,objectId:e.objectId}),r("endobj"),"sMask"in e&&void 0!==e.sMask){var l="/Predictor "+e.predictor+" /Colors 1 /BitsPerComponent "+e.bitsPerComponent+" /Columns "+e.width,h={width:e.width,height:e.height,colorSpace:"DeviceGray",bitsPerComponent:e.bitsPerComponent,decodeParameters:l,data:e.sMask};"filter"in e&&(h.filter=e.filter),t.call(this,h)}if(e.colorSpace===b.INDEXED){var f=this.internal.newObject();n({data:_(new Uint8Array(e.palette)),objectId:f}),r("endobj")}},o=function(){var t=this.internal.collections.addImage_images;for(var e in t)a.call(this,t[e])},s=function(){var t,e=this.internal.collections.addImage_images,r=this.internal.write;for(var n in e)r("/I"+(t=e[n]).index,t.objectId,"0","R")},u=function(){this.internal.collections.addImage_images||(this.internal.collections.addImage_images={},this.internal.events.subscribe("putResources",o),this.internal.events.subscribe("putXobjectDict",s))},l=function(){var t=this.internal.collections.addImage_images;return u.call(this),t},h=function(){return Object.keys(this.internal.collections.addImage_images).length},f=function(e){return"function"==typeof t["process"+e.toUpperCase()]},d=function(t){return"object"===e(t)&&1===t.nodeType},p=function(e,r){if("IMG"===e.nodeName&&e.hasAttribute("src")){var n=""+e.getAttribute("src");if(0===n.indexOf("data:image/"))return c(unescape(n).split("base64,").pop());var i=t.loadFile(n,!0);if(void 0!==i)return i}if("CANVAS"===e.nodeName){if(0===e.width||0===e.height)throw new Error("Given canvas must have data. Canvas width: "+e.width+", height: "+e.height);var a;switch(r){case"PNG":a="image/png";break;case"WEBP":a="image/webp";break;case"JPEG":case"JPG":default:a="image/jpeg"}return c(e.toDataURL(a,1).split("base64,").pop())}},g=function(t){var e=this.internal.collections.addImage_images;if(e)for(var r in e)if(t===e[r].alias)return e[r]},m=function(t,e,r){return t||e||(t=-96,e=-96),t<0&&(t=-1*r.width*72/t/this.internal.scaleFactor),e<0&&(e=-1*r.height*72/e/this.internal.scaleFactor),0===t&&(t=e*r.width/r.height),0===e&&(e=t*r.height/r.width),[t,e]},v=function(t,e,r,n,i,a){var o=m.call(this,r,n,i),s=this.internal.getCoordinateString,c=this.internal.getVerticalCoordinateString,u=l.call(this);if(r=o[0],n=o[1],u[i.index]=i,a){a*=Math.PI/180;var h=Math.cos(a),f=Math.sin(a),d=function(t){return t.toFixed(4)},p=[d(h),d(f),d(-1*f),d(h),0,0,"cm"]}this.internal.write("q"),a?(this.internal.write([1,"0","0",1,s(t),c(e+n),"cm"].join(" ")),this.internal.write(p.join(" ")),this.internal.write([s(r),"0","0",s(n),"0","0","cm"].join(" "))):this.internal.write([s(r),"0","0",s(n),s(t),c(e+n),"cm"].join(" ")),this.isAdvancedAPI()&&this.internal.write([1,0,0,-1,0,0,"cm"].join(" ")),this.internal.write("/I"+i.index+" Do"),this.internal.write("Q")},b=t.color_spaces={DEVICE_RGB:"DeviceRGB",DEVICE_GRAY:"DeviceGray",DEVICE_CMYK:"DeviceCMYK",CAL_GREY:"CalGray",CAL_RGB:"CalRGB",LAB:"Lab",ICC_BASED:"ICCBased",INDEXED:"Indexed",PATTERN:"Pattern",SEPARATION:"Separation",DEVICE_N:"DeviceN"};t.decode={DCT_DECODE:"DCTDecode",FLATE_DECODE:"FlateDecode",LZW_DECODE:"LZWDecode",JPX_DECODE:"JPXDecode",JBIG2_DECODE:"JBIG2Decode",ASCII85_DECODE:"ASCII85Decode",ASCII_HEX_DECODE:"ASCIIHexDecode",RUN_LENGTH_DECODE:"RunLengthDecode",CCITT_FAX_DECODE:"CCITTFaxDecode"};var y=t.image_compression={NONE:"NONE",FAST:"FAST",MEDIUM:"MEDIUM",SLOW:"SLOW"},w=t.__addimage__.sHashCode=function(t){var e,r,n=0;if("string"==typeof t)for(r=t.length,e=0;e<r;e++)n=(n<<5)-n+t.charCodeAt(e),n|=0;else if(x(t))for(r=t.byteLength/2,e=0;e<r;e++)n=(n<<5)-n+t[e],n|=0;return n},N=t.__addimage__.validateStringAsBase64=function(t){(t=t||"").toString().trim();var e=!0;return 0===t.length&&(e=!1),t.length%4!=0&&(e=!1),!1===/^[A-Za-z0-9+/]+$/.test(t.substr(0,t.length-2))&&(e=!1),!1===/^[A-Za-z0-9/][A-Za-z0-9+/]|[A-Za-z0-9+/]=|==$/.test(t.substr(-2))&&(e=!1),e},L=t.__addimage__.extractImageFromDataUrl=function(t){var e=(t=t||"").split("base64,"),r=null;if(2===e.length){var n=/^data:(\w*\/\w*);*(charset=(?!charset=)[\w=-]*)*;*$/.exec(e[0]);Array.isArray(n)&&(r={mimeType:n[1],charset:n[2],data:e[1]})}return r},A=t.__addimage__.supportsArrayBuffer=function(){return"undefined"!=typeof ArrayBuffer&&"undefined"!=typeof Uint8Array};t.__addimage__.isArrayBuffer=function(t){return A()&&t instanceof ArrayBuffer};var x=t.__addimage__.isArrayBufferView=function(t){return A()&&"undefined"!=typeof Uint32Array&&(t instanceof Int8Array||t instanceof Uint8Array||"undefined"!=typeof Uint8ClampedArray&&t instanceof Uint8ClampedArray||t instanceof Int16Array||t instanceof Uint16Array||t instanceof Int32Array||t instanceof Uint32Array||t instanceof Float32Array||t instanceof Float64Array)},S=t.__addimage__.binaryStringToUint8Array=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r},_=t.__addimage__.arrayBufferToBinaryString=function(t){for(var e="",r=x(t)?t:new Uint8Array(t),n=0;n<r.length;n+=8192)e+=String.fromCharCode.apply(null,r.subarray(n,n+8192));return e};t.addImage=function(){var t,n,i,a,o,s,c,l,h;if("number"==typeof arguments[1]?(n=r,i=arguments[1],a=arguments[2],o=arguments[3],s=arguments[4],c=arguments[5],l=arguments[6],h=arguments[7]):(n=arguments[1],i=arguments[2],a=arguments[3],o=arguments[4],s=arguments[5],c=arguments[6],l=arguments[7],h=arguments[8]),"object"===e(t=arguments[0])&&!d(t)&&"imageData"in t){var f=t;t=f.imageData,n=f.format||n||r,i=f.x||i||0,a=f.y||a||0,o=f.w||f.width||o,s=f.h||f.height||s,c=f.alias||c,l=f.compression||l,h=f.rotation||f.angle||h}var p=this.internal.getFilters();if(void 0===l&&-1!==p.indexOf("FlateEncode")&&(l="SLOW"),isNaN(i)||isNaN(a))throw new Error("Invalid coordinates passed to jsPDF.addImage");u.call(this);var g=P.call(this,t,n,c,l);return v.call(this,i,a,o,s,g,h),this};var P=function(e,n,a,o){var s,c,u;if("string"==typeof e&&i(e)===r){e=unescape(e);var l=k(e,!1);(""!==l||void 0!==(l=t.loadFile(e,!0)))&&(e=l)}if(d(e)&&(e=p(e,n)),n=i(e,n),!f(n))throw new Error("addImage does not support files of type '"+n+"', please ensure that a plugin for '"+n+"' support is added.");if((null==(u=a)||0===u.length)&&(a=function(t){return"string"==typeof t||x(t)?w(t):x(t.data)?w(t.data):null}(e)),(s=g.call(this,a))||(A()&&(e instanceof Uint8Array||"RGBA"===n||(c=e,e=S(e))),s=this["process"+n.toUpperCase()](e,h.call(this),a,function(e){return e&&"string"==typeof e&&(e=e.toUpperCase()),e in t.image_compression?e:y.NONE}(o),c)),!s)throw new Error("An unknown error occurred whilst processing the image.");return s},k=t.__addimage__.convertBase64ToBinaryString=function(t,e){var r;e="boolean"!=typeof e||e;var n,i="";if("string"==typeof t){n=null!==(r=L(t))?r.data:t;try{i=c(n)}catch(t){if(e)throw N(n)?new Error("atob-Error in jsPDF.convertBase64ToBinaryString "+t.message):new Error("Supplied Data is not a valid base64-String jsPDF.convertBase64ToBinaryString ")}}return i};t.getImageProperties=function(e){var n,a,o="";if(d(e)&&(e=p(e)),"string"==typeof e&&i(e)===r&&(""===(o=k(e,!1))&&(o=t.loadFile(e)||""),e=o),a=i(e),!f(a))throw new Error("addImage does not support files of type '"+a+"', please ensure that a plugin for '"+a+"' support is added.");if(!A()||e instanceof Uint8Array||(e=S(e)),!(n=this["process"+a.toUpperCase()](e)))throw new Error("An unknown error occurred whilst processing the image");return n.fileType=a,n}}(M.API),
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var e=function(t){if(void 0!==t&&""!=t)return!0};M.API.events.push(["addPage",function(t){this.internal.getPageInfo(t.pageNumber).pageContext.annotations=[]}]),t.events.push(["putPage",function(t){for(var r,n,i,a=this.internal.getCoordinateString,o=this.internal.getVerticalCoordinateString,s=this.internal.getPageInfoByObjId(t.objId),c=t.pageContext.annotations,u=!1,l=0;l<c.length&&!u;l++)switch((r=c[l]).type){case"link":(e(r.options.url)||e(r.options.pageNumber))&&(u=!0);break;case"reference":case"text":case"freetext":u=!0}if(0!=u){this.internal.write("/Annots [");for(var h=0;h<c.length;h++){r=c[h];var f=this.internal.pdfEscape,d=this.internal.getEncryptor(t.objId);switch(r.type){case"reference":this.internal.write(" "+r.object.objId+" 0 R ");break;case"text":var p=this.internal.newAdditionalObject(),g=this.internal.newAdditionalObject(),m=this.internal.getEncryptor(p.objId),v=r.title||"Note";i="<</Type /Annot /Subtype /Text "+(n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y)+"] ")+"/Contents ("+f(m(r.contents))+")",i+=" /Popup "+g.objId+" 0 R",i+=" /P "+s.objId+" 0 R",i+=" /T ("+f(m(v))+") >>",p.content=i;var b=p.objId+" 0 R";i="<</Type /Annot /Subtype /Popup "+(n="/Rect ["+a(r.bounds.x+30)+" "+o(r.bounds.y+r.bounds.h)+" "+a(r.bounds.x+r.bounds.w+30)+" "+o(r.bounds.y)+"] ")+" /Parent "+b,r.open&&(i+=" /Open true"),i+=" >>",g.content=i,this.internal.write(p.objId,"0 R",g.objId,"0 R");break;case"freetext":n="/Rect ["+a(r.bounds.x)+" "+o(r.bounds.y)+" "+a(r.bounds.x+r.bounds.w)+" "+o(r.bounds.y+r.bounds.h)+"] ";var y=r.color||"#000000";i="<</Type /Annot /Subtype /FreeText "+n+"/Contents ("+f(d(r.contents))+")",i+=" /DS(font: Helvetica,sans-serif 12.0pt; text-align:left; color:#"+y+")",i+=" /Border [0 0 0]",i+=" >>",this.internal.write(i);break;case"link":if(r.options.name){var w=this.annotations._nameMap[r.options.name];r.options.pageNumber=w.page,r.options.top=w.y}else r.options.top||(r.options.top=0);if(n="/Rect ["+r.finalBounds.x+" "+r.finalBounds.y+" "+r.finalBounds.w+" "+r.finalBounds.h+"] ",i="",r.options.url)i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /A <</S /URI /URI ("+f(d(r.options.url))+") >>";else if(r.options.pageNumber){switch(i="<</Type /Annot /Subtype /Link "+n+"/Border [0 0 0] /Dest ["+this.internal.getPageInfo(r.options.pageNumber).objId+" 0 R",r.options.magFactor=r.options.magFactor||"XYZ",r.options.magFactor){case"Fit":i+=" /Fit]";break;case"FitH":i+=" /FitH "+r.options.top+"]";break;case"FitV":r.options.left=r.options.left||0,i+=" /FitV "+r.options.left+"]";break;case"XYZ":default:var N=o(r.options.top);r.options.left=r.options.left||0,void 0===r.options.zoom&&(r.options.zoom=0),i+=" /XYZ "+r.options.left+" "+N+" "+r.options.zoom+"]"}}""!=i&&(i+=" >>",this.internal.write(i))}}this.internal.write("]")}}]),t.createAnnotation=function(t){var e=this.internal.getCurrentPageInfo();switch(t.type){case"link":this.link(t.bounds.x,t.bounds.y,t.bounds.w,t.bounds.h,t);break;case"text":case"freetext":e.pageContext.annotations.push(t)}},t.link=function(t,e,r,n,i){var a=this.internal.getCurrentPageInfo(),o=this.internal.getCoordinateString,s=this.internal.getVerticalCoordinateString;a.pageContext.annotations.push({finalBounds:{x:o(t),y:s(e),w:o(t+r),h:s(e+n)},options:i,type:"link"})},t.textWithLink=function(t,e,r,n){var i,a,o=this.getTextWidth(t),s=this.internal.getLineHeight()/this.internal.scaleFactor;if(void 0!==n.maxWidth){a=n.maxWidth;var c=this.splitTextToSize(t,a).length;i=Math.ceil(s*c)}else a=o,i=s;return this.text(t,e,r,n),r+=.2*s,"center"===n.align&&(e-=o/2),"right"===n.align&&(e-=o),this.link(e,r-s,a,i,n),o},t.getTextWidth=function(t){var e=this.internal.getFontSize();return this.getStringUnitWidth(t)*e/this.internal.scaleFactor}}(M.API),
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var e={1569:[65152],1570:[65153,65154],1571:[65155,65156],1572:[65157,65158],1573:[65159,65160],1574:[65161,65162,65163,65164],1575:[65165,65166],1576:[65167,65168,65169,65170],1577:[65171,65172],1578:[65173,65174,65175,65176],1579:[65177,65178,65179,65180],1580:[65181,65182,65183,65184],1581:[65185,65186,65187,65188],1582:[65189,65190,65191,65192],1583:[65193,65194],1584:[65195,65196],1585:[65197,65198],1586:[65199,65200],1587:[65201,65202,65203,65204],1588:[65205,65206,65207,65208],1589:[65209,65210,65211,65212],1590:[65213,65214,65215,65216],1591:[65217,65218,65219,65220],1592:[65221,65222,65223,65224],1593:[65225,65226,65227,65228],1594:[65229,65230,65231,65232],1601:[65233,65234,65235,65236],1602:[65237,65238,65239,65240],1603:[65241,65242,65243,65244],1604:[65245,65246,65247,65248],1605:[65249,65250,65251,65252],1606:[65253,65254,65255,65256],1607:[65257,65258,65259,65260],1608:[65261,65262],1609:[65263,65264,64488,64489],1610:[65265,65266,65267,65268],1649:[64336,64337],1655:[64477],1657:[64358,64359,64360,64361],1658:[64350,64351,64352,64353],1659:[64338,64339,64340,64341],1662:[64342,64343,64344,64345],1663:[64354,64355,64356,64357],1664:[64346,64347,64348,64349],1667:[64374,64375,64376,64377],1668:[64370,64371,64372,64373],1670:[64378,64379,64380,64381],1671:[64382,64383,64384,64385],1672:[64392,64393],1676:[64388,64389],1677:[64386,64387],1678:[64390,64391],1681:[64396,64397],1688:[64394,64395],1700:[64362,64363,64364,64365],1702:[64366,64367,64368,64369],1705:[64398,64399,64400,64401],1709:[64467,64468,64469,64470],1711:[64402,64403,64404,64405],1713:[64410,64411,64412,64413],1715:[64406,64407,64408,64409],1722:[64414,64415],1723:[64416,64417,64418,64419],1726:[64426,64427,64428,64429],1728:[64420,64421],1729:[64422,64423,64424,64425],1733:[64480,64481],1734:[64473,64474],1735:[64471,64472],1736:[64475,64476],1737:[64482,64483],1739:[64478,64479],1740:[64508,64509,64510,64511],1744:[64484,64485,64486,64487],1746:[64430,64431],1747:[64432,64433]},r={65247:{65154:65269,65156:65271,65160:65273,65166:65275},65248:{65154:65270,65156:65272,65160:65274,65166:65276},65165:{65247:{65248:{65258:65010}}},1617:{1612:64606,1613:64607,1614:64608,1615:64609,1616:64610}},n={1612:64606,1613:64607,1614:64608,1615:64609,1616:64610},i=[1570,1571,1573,1575];t.__arabicParser__={};var a=t.__arabicParser__.isInArabicSubstitutionA=function(t){return void 0!==e[t.charCodeAt(0)]},o=t.__arabicParser__.isArabicLetter=function(t){return"string"==typeof t&&/^[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF\uFB50-\uFDFF\uFE70-\uFEFF]+$/.test(t)},s=t.__arabicParser__.isArabicEndLetter=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length<=2},c=t.__arabicParser__.isArabicAlfLetter=function(t){return o(t)&&i.indexOf(t.charCodeAt(0))>=0};t.__arabicParser__.arabicLetterHasIsolatedForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=1};var u=t.__arabicParser__.arabicLetterHasFinalForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=2};t.__arabicParser__.arabicLetterHasInitialForm=function(t){return o(t)&&a(t)&&e[t.charCodeAt(0)].length>=3};var l=t.__arabicParser__.arabicLetterHasMedialForm=function(t){return o(t)&&a(t)&&4==e[t.charCodeAt(0)].length},h=t.__arabicParser__.resolveLigatures=function(t){var e=0,n=r,i="",a=0;for(e=0;e<t.length;e+=1)void 0!==n[t.charCodeAt(e)]?(a++,"number"==typeof(n=n[t.charCodeAt(e)])&&(i+=String.fromCharCode(n),n=r,a=0),e===t.length-1&&(n=r,i+=t.charAt(e-(a-1)),e-=a-1,a=0)):(n=r,i+=t.charAt(e-a),e-=a,a=0);return i};t.__arabicParser__.isArabicDiacritic=function(t){return void 0!==t&&void 0!==n[t.charCodeAt(0)]};var f=t.__arabicParser__.getCorrectForm=function(t,e,r){return o(t)?!1===a(t)?-1:!u(t)||!o(e)&&!o(r)||!o(r)&&s(e)||s(t)&&!o(e)||s(t)&&c(e)||s(t)&&s(e)?0:l(t)&&o(e)&&!s(e)&&o(r)&&u(r)?3:s(t)||!o(r)?1:2:-1},d=function(t){var r=0,n=0,i=0,a="",s="",c="",u=(t=t||"").split("\\s+"),l=[];for(r=0;r<u.length;r+=1){for(l.push(""),n=0;n<u[r].length;n+=1)a=u[r][n],s=u[r][n-1],c=u[r][n+1],o(a)?(i=f(a,s,c),l[r]+=-1!==i?String.fromCharCode(e[a.charCodeAt(0)][i]):a):l[r]+=a;l[r]=h(l[r])}return l.join(" ")},p=t.__arabicParser__.processArabic=t.processArabic=function(){var t,e="string"==typeof arguments[0]?arguments[0]:arguments[0].text,r=[];if(Array.isArray(e)){var n=0;for(r=[],n=0;n<e.length;n+=1)Array.isArray(e[n])?r.push([d(e[n][0]),e[n][1],e[n][2]]):r.push([d(e[n])]);t=r}else t=d(e);return"string"==typeof arguments[0]?t:(arguments[0].text=t,arguments[0])};t.events.push(["preProcessText",p])}(M.API),
/** @license
   * jsPDF Autoprint Plugin
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){t.autoPrint=function(t){var e;switch((t=t||{}).variant=t.variant||"non-conform",t.variant){case"javascript":this.addJS("print({});");break;case"non-conform":default:this.internal.events.subscribe("postPutResources",(function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /Named"),this.internal.out("/Type /Action"),this.internal.out("/N /Print"),this.internal.out(">>"),this.internal.out("endobj")})),this.internal.events.subscribe("putCatalog",(function(){this.internal.out("/OpenAction "+e+" 0 R")}))}return this}}(M.API),
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var e=function(){var t=void 0;Object.defineProperty(this,"pdf",{get:function(){return t},set:function(e){t=e}});var e=150;Object.defineProperty(this,"width",{get:function(){return e},set:function(t){e=isNaN(t)||!1===Number.isInteger(t)||t<0?150:t,this.getContext("2d").pageWrapXEnabled&&(this.getContext("2d").pageWrapX=e+1)}});var r=300;Object.defineProperty(this,"height",{get:function(){return r},set:function(t){r=isNaN(t)||!1===Number.isInteger(t)||t<0?300:t,this.getContext("2d").pageWrapYEnabled&&(this.getContext("2d").pageWrapY=r+1)}});var n=[];Object.defineProperty(this,"childNodes",{get:function(){return n},set:function(t){n=t}});var i={};Object.defineProperty(this,"style",{get:function(){return i},set:function(t){i=t}}),Object.defineProperty(this,"parentNode",{})};e.prototype.getContext=function(t,e){var r;if("2d"!==(t=t||"2d"))return null;for(r in e)this.pdf.context2d.hasOwnProperty(r)&&(this.pdf.context2d[r]=e[r]);return this.pdf.context2d._canvas=this,this.pdf.context2d},e.prototype.toDataURL=function(){throw new Error("toDataURL is not implemented.")},t.events.push(["initialized",function(){this.canvas=new e,this.canvas.pdf=this}])}(M.API),function(t){var r={left:0,top:0,bottom:0,right:0},n=!1,i=function(){void 0===this.internal.__cell__&&(this.internal.__cell__={},this.internal.__cell__.padding=3,this.internal.__cell__.headerFunction=void 0,this.internal.__cell__.margins=Object.assign({},r),this.internal.__cell__.margins.width=this.getPageWidth(),a.call(this))},a=function(){this.internal.__cell__.lastCell=new o,this.internal.__cell__.pages=1},o=function(){var t=arguments[0];Object.defineProperty(this,"x",{enumerable:!0,get:function(){return t},set:function(e){t=e}});var e=arguments[1];Object.defineProperty(this,"y",{enumerable:!0,get:function(){return e},set:function(t){e=t}});var r=arguments[2];Object.defineProperty(this,"width",{enumerable:!0,get:function(){return r},set:function(t){r=t}});var n=arguments[3];Object.defineProperty(this,"height",{enumerable:!0,get:function(){return n},set:function(t){n=t}});var i=arguments[4];Object.defineProperty(this,"text",{enumerable:!0,get:function(){return i},set:function(t){i=t}});var a=arguments[5];Object.defineProperty(this,"lineNumber",{enumerable:!0,get:function(){return a},set:function(t){a=t}});var o=arguments[6];return Object.defineProperty(this,"align",{enumerable:!0,get:function(){return o},set:function(t){o=t}}),this};o.prototype.clone=function(){return new o(this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align)},o.prototype.toArray=function(){return[this.x,this.y,this.width,this.height,this.text,this.lineNumber,this.align]},t.setHeaderFunction=function(t){return i.call(this),this.internal.__cell__.headerFunction="function"==typeof t?t:void 0,this},t.getTextDimensions=function(t,e){i.call(this);var r=(e=e||{}).fontSize||this.getFontSize(),n=e.font||this.getFont(),a=e.scaleFactor||this.internal.scaleFactor,o=0,s=0,c=0,u=this;if(!Array.isArray(t)&&"string"!=typeof t){if("number"!=typeof t)throw new Error("getTextDimensions expects text-parameter to be of type String or type Number or an Array of Strings.");t=String(t)}var l=e.maxWidth;l>0?"string"==typeof t?t=this.splitTextToSize(t,l):"[object Array]"===Object.prototype.toString.call(t)&&(t=t.reduce((function(t,e){return t.concat(u.splitTextToSize(e,l))}),[])):t=Array.isArray(t)?t:[t];for(var h=0;h<t.length;h++)o<(c=this.getStringUnitWidth(t[h],{font:n})*r)&&(o=c);return 0!==o&&(s=t.length),{w:o/=a,h:Math.max((s*r*this.getLineHeightFactor()-r*(this.getLineHeightFactor()-1))/a,0)}},t.cellAddPage=function(){i.call(this),this.addPage();var t=this.internal.__cell__.margins||r;return this.internal.__cell__.lastCell=new o(t.left,t.top,void 0,void 0),this.internal.__cell__.pages+=1,this};var s=t.cell=function(){var t;t=arguments[0]instanceof o?arguments[0]:new o(arguments[0],arguments[1],arguments[2],arguments[3],arguments[4],arguments[5]),i.call(this);var e=this.internal.__cell__.lastCell,a=this.internal.__cell__.padding,s=this.internal.__cell__.margins||r,c=this.internal.__cell__.tableHeaderRow,u=this.internal.__cell__.printHeaders;return void 0!==e.lineNumber&&(e.lineNumber===t.lineNumber?(t.x=(e.x||0)+(e.width||0),t.y=e.y||0):e.y+e.height+t.height+s.bottom>this.getPageHeight()?(this.cellAddPage(),t.y=s.top,u&&c&&(this.printHeaderRow(t.lineNumber,!0),t.y+=c[0].height)):t.y=e.y+e.height||t.y),void 0!==t.text[0]&&(this.rect(t.x,t.y,t.width,t.height,!0===n?"FD":void 0),"right"===t.align?this.text(t.text,t.x+t.width-a,t.y+a,{align:"right",baseline:"top"}):"center"===t.align?this.text(t.text,t.x+t.width/2,t.y+a,{align:"center",baseline:"top",maxWidth:t.width-a-a}):this.text(t.text,t.x+a,t.y+a,{align:"left",baseline:"top",maxWidth:t.width-a-a})),this.internal.__cell__.lastCell=t,this};t.table=function(t,n,u,l,h){if(i.call(this),!u)throw new Error("No data for PDF table.");var f,d,p,g,m=[],v=[],b=[],y={},w={},N=[],L=[],A=(h=h||{}).autoSize||!1,x=!1!==h.printHeaders,S=h.css&&void 0!==h.css["font-size"]?16*h.css["font-size"]:h.fontSize||12,_=h.margins||Object.assign({width:this.getPageWidth()},r),P="number"==typeof h.padding?h.padding:3,k=h.headerBackgroundColor||"#c8c8c8",F=h.headerTextColor||"#000";if(a.call(this),this.internal.__cell__.printHeaders=x,this.internal.__cell__.margins=_,this.internal.__cell__.table_font_size=S,this.internal.__cell__.padding=P,this.internal.__cell__.headerBackgroundColor=k,this.internal.__cell__.headerTextColor=F,this.setFontSize(S),null==l)v=m=Object.keys(u[0]),b=m.map((function(){return"left"}));else if(Array.isArray(l)&&"object"===e(l[0]))for(m=l.map((function(t){return t.name})),v=l.map((function(t){return t.prompt||t.name||""})),b=l.map((function(t){return t.align||"left"})),f=0;f<l.length;f+=1)w[l[f].name]=l[f].width*(19.049976/25.4);else Array.isArray(l)&&"string"==typeof l[0]&&(v=m=l,b=m.map((function(){return"left"})));if(A||Array.isArray(l)&&"string"==typeof l[0])for(f=0;f<m.length;f+=1){for(y[g=m[f]]=u.map((function(t){return t[g]})),this.setFont(void 0,"bold"),N.push(this.getTextDimensions(v[f],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w),d=y[g],this.setFont(void 0,"normal"),p=0;p<d.length;p+=1)N.push(this.getTextDimensions(d[p],{fontSize:this.internal.__cell__.table_font_size,scaleFactor:this.internal.scaleFactor}).w);w[g]=Math.max.apply(null,N)+P+P,N=[]}if(x){var I={};for(f=0;f<m.length;f+=1)I[m[f]]={},I[m[f]].text=v[f],I[m[f]].align=b[f];var C=c.call(this,I,w);L=m.map((function(e){return new o(t,n,w[e],C,I[e].text,void 0,I[e].align)})),this.setTableHeaderRow(L),this.printHeaderRow(1,!1)}var j=l.reduce((function(t,e){return t[e.name]=e.align,t}),{});for(f=0;f<u.length;f+=1){"rowStart"in h&&h.rowStart instanceof Function&&h.rowStart({row:f,data:u[f]},this);var O=c.call(this,u[f],w);for(p=0;p<m.length;p+=1){var B=u[f][m[p]];"cellStart"in h&&h.cellStart instanceof Function&&h.cellStart({row:f,col:p,data:B},this),s.call(this,new o(t,n,w[m[p]],O,B,f+2,j[m[p]]))}}return this.internal.__cell__.table_x=t,this.internal.__cell__.table_y=n,this};var c=function(t,e){var r=this.internal.__cell__.padding,n=this.internal.__cell__.table_font_size,i=this.internal.scaleFactor;return Object.keys(t).map((function(n){var i=t[n];return this.splitTextToSize(i.hasOwnProperty("text")?i.text:i,e[n]-r-r)}),this).map((function(t){return this.getLineHeightFactor()*t.length*n/i+r+r}),this).reduce((function(t,e){return Math.max(t,e)}),0)};t.setTableHeaderRow=function(t){i.call(this),this.internal.__cell__.tableHeaderRow=t},t.printHeaderRow=function(t,e){if(i.call(this),!this.internal.__cell__.tableHeaderRow)throw new Error("Property tableHeaderRow does not exist.");var r;if(n=!0,"function"==typeof this.internal.__cell__.headerFunction){var a=this.internal.__cell__.headerFunction(this,this.internal.__cell__.pages);this.internal.__cell__.lastCell=new o(a[0],a[1],a[2],a[3],void 0,-1)}this.setFont(void 0,"bold");for(var c=[],u=0;u<this.internal.__cell__.tableHeaderRow.length;u+=1){r=this.internal.__cell__.tableHeaderRow[u].clone(),e&&(r.y=this.internal.__cell__.margins.top||0,c.push(r)),r.lineNumber=t;var l=this.getTextColor();this.setTextColor(this.internal.__cell__.headerTextColor),this.setFillColor(this.internal.__cell__.headerBackgroundColor),s.call(this,r),this.setTextColor(l)}c.length>0&&this.setTableHeaderRow(c),this.setFont(void 0,"normal"),n=!1}}(M.API);var _t={italic:["italic","oblique","normal"],oblique:["oblique","italic","normal"],normal:["normal","oblique","italic"]},Pt=["ultra-condensed","extra-condensed","condensed","semi-condensed","normal","semi-expanded","expanded","extra-expanded","ultra-expanded"],kt=St(Pt),Ft=[100,200,300,400,500,600,700,800,900],It=St(Ft);function Ct(t){var e=t.family.replace(/"|'/g,"").toLowerCase(),r=function(t){return _t[t=t||"normal"]?t:"normal"}(t.style),n=function(t){if(!t)return 400;if("number"==typeof t)return t>=100&&t<=900&&t%100==0?t:400;if(/^\d00$/.test(t))return parseInt(t);switch(t){case"bold":return 700;case"normal":default:return 400}}(t.weight),i=function(t){return"number"==typeof kt[t=t||"normal"]?t:"normal"}(t.stretch);return{family:e,style:r,weight:n,stretch:i,src:t.src||[],ref:t.ref||{name:e,style:[i,r,n].join(" ")}}}function jt(t,e,r,n){var i;for(i=r;i>=0&&i<e.length;i+=n)if(t[e[i]])return t[e[i]];for(i=r;i>=0&&i<e.length;i-=n)if(t[e[i]])return t[e[i]]}var Ot={"sans-serif":"helvetica",fixed:"courier",monospace:"courier",terminal:"courier",cursive:"times",fantasy:"times",serif:"times"},Bt={caption:"times",icon:"times",menu:"times","message-box":"times","small-caption":"times","status-bar":"times"};function Mt(t){return[t.stretch,t.style,t.weight,t.family].join(" ")}function Et(t,e,r){for(var n=(r=r||{}).defaultFontFamily||"times",i=Object.assign({},Ot,r.genericFontFamilies||{}),a=null,o=null,s=0;s<e.length;++s)if(i[(a=Ct(e[s])).family]&&(a.family=i[a.family]),t.hasOwnProperty(a.family)){o=t[a.family];break}if(!(o=o||t[n]))throw new Error("Could not find a font-family for the rule '"+Mt(a)+"' and default family '"+n+"'.");if(o=function(t,e){if(e[t])return e[t];var r=kt[t],n=r<=kt.normal?-1:1,i=jt(e,Pt,r,n);if(!i)throw new Error("Could not find a matching font-stretch value for "+t);return i}(a.stretch,o),o=function(t,e){if(e[t])return e[t];for(var r=_t[t],n=0;n<r.length;++n)if(e[r[n]])return e[r[n]];throw new Error("Could not find a matching font-style for "+t)}(a.style,o),!(o=function(t,e){if(e[t])return e[t];if(400===t&&e[500])return e[500];if(500===t&&e[400])return e[400];var r=It[t],n=jt(e,Ft,r,t<400?-1:1);if(!n)throw new Error("Could not find a matching font-weight for value "+t);return n}(a.weight,o)))throw new Error("Failed to resolve a font for the rule '"+Mt(a)+"'.");return o}function qt(t){return t.trimLeft()}function Dt(t,e){for(var r=0;r<t.length;){if(t.charAt(r)===e)return[t.substring(0,r),t.substring(r+1)];r+=1}return null}function Rt(t){var e=t.match(/^(-[a-z_]|[a-z_])[a-z0-9_-]*/i);return null===e?null:[e[0],t.substring(e[0].length)]}var Tt=["times"];!function(t){var r,n,a,o,s,c,u,l,f,d=function(t){return t=t||{},this.isStrokeTransparent=t.isStrokeTransparent||!1,this.strokeOpacity=t.strokeOpacity||1,this.strokeStyle=t.strokeStyle||"#000000",this.fillStyle=t.fillStyle||"#000000",this.isFillTransparent=t.isFillTransparent||!1,this.fillOpacity=t.fillOpacity||1,this.font=t.font||"10px sans-serif",this.textBaseline=t.textBaseline||"alphabetic",this.textAlign=t.textAlign||"left",this.lineWidth=t.lineWidth||1,this.lineJoin=t.lineJoin||"miter",this.lineCap=t.lineCap||"butt",this.path=t.path||[],this.transform=void 0!==t.transform?t.transform.clone():new l,this.globalCompositeOperation=t.globalCompositeOperation||"normal",this.globalAlpha=t.globalAlpha||1,this.clip_path=t.clip_path||[],this.currentPoint=t.currentPoint||new c,this.miterLimit=t.miterLimit||10,this.lastPoint=t.lastPoint||new c,this.lineDashOffset=t.lineDashOffset||0,this.lineDash=t.lineDash||[],this.margin=t.margin||[0,0,0,0],this.prevPageLastElemOffset=t.prevPageLastElemOffset||0,this.ignoreClearRect="boolean"!=typeof t.ignoreClearRect||t.ignoreClearRect,this};t.events.push(["initialized",function(){this.context2d=new p(this),r=this.internal.f2,n=this.internal.getCoordinateString,a=this.internal.getVerticalCoordinateString,o=this.internal.getHorizontalCoordinate,s=this.internal.getVerticalCoordinate,c=this.internal.Point,u=this.internal.Rectangle,l=this.internal.Matrix,f=new d}]);var p=function(t){Object.defineProperty(this,"canvas",{get:function(){return{parentNode:!1,style:!1}}});var e=t;Object.defineProperty(this,"pdf",{get:function(){return e}});var r=!1;Object.defineProperty(this,"pageWrapXEnabled",{get:function(){return r},set:function(t){r=Boolean(t)}});var n=!1;Object.defineProperty(this,"pageWrapYEnabled",{get:function(){return n},set:function(t){n=Boolean(t)}});var i=0;Object.defineProperty(this,"posX",{get:function(){return i},set:function(t){isNaN(t)||(i=t)}});var a=0;Object.defineProperty(this,"posY",{get:function(){return a},set:function(t){isNaN(t)||(a=t)}}),Object.defineProperty(this,"margin",{get:function(){return f.margin},set:function(t){var e;"number"==typeof t?e=[t,t,t,t]:((e=new Array(4))[0]=t[0],e[1]=t.length>=2?t[1]:e[0],e[2]=t.length>=3?t[2]:e[0],e[3]=t.length>=4?t[3]:e[1]),f.margin=e}});var o=!1;Object.defineProperty(this,"autoPaging",{get:function(){return o},set:function(t){o=t}});var s=0;Object.defineProperty(this,"lastBreak",{get:function(){return s},set:function(t){s=t}});var c=[];Object.defineProperty(this,"pageBreaks",{get:function(){return c},set:function(t){c=t}}),Object.defineProperty(this,"ctx",{get:function(){return f},set:function(t){t instanceof d&&(f=t)}}),Object.defineProperty(this,"path",{get:function(){return f.path},set:function(t){f.path=t}});var u=[];Object.defineProperty(this,"ctxStack",{get:function(){return u},set:function(t){u=t}}),Object.defineProperty(this,"fillStyle",{get:function(){return this.ctx.fillStyle},set:function(t){var e;e=g(t),this.ctx.fillStyle=e.style,this.ctx.isFillTransparent=0===e.a,this.ctx.fillOpacity=e.a,this.pdf.setFillColor(e.r,e.g,e.b,{a:e.a}),this.pdf.setTextColor(e.r,e.g,e.b,{a:e.a})}}),Object.defineProperty(this,"strokeStyle",{get:function(){return this.ctx.strokeStyle},set:function(t){var e=g(t);this.ctx.strokeStyle=e.style,this.ctx.isStrokeTransparent=0===e.a,this.ctx.strokeOpacity=e.a,0===e.a?this.pdf.setDrawColor(255,255,255):(e.a,this.pdf.setDrawColor(e.r,e.g,e.b))}}),Object.defineProperty(this,"lineCap",{get:function(){return this.ctx.lineCap},set:function(t){-1!==["butt","round","square"].indexOf(t)&&(this.ctx.lineCap=t,this.pdf.setLineCap(t))}}),Object.defineProperty(this,"lineWidth",{get:function(){return this.ctx.lineWidth},set:function(t){isNaN(t)||(this.ctx.lineWidth=t,this.pdf.setLineWidth(t))}}),Object.defineProperty(this,"lineJoin",{get:function(){return this.ctx.lineJoin},set:function(t){-1!==["bevel","round","miter"].indexOf(t)&&(this.ctx.lineJoin=t,this.pdf.setLineJoin(t))}}),Object.defineProperty(this,"miterLimit",{get:function(){return this.ctx.miterLimit},set:function(t){isNaN(t)||(this.ctx.miterLimit=t,this.pdf.setMiterLimit(t))}}),Object.defineProperty(this,"textBaseline",{get:function(){return this.ctx.textBaseline},set:function(t){this.ctx.textBaseline=t}}),Object.defineProperty(this,"textAlign",{get:function(){return this.ctx.textAlign},set:function(t){-1!==["right","end","center","left","start"].indexOf(t)&&(this.ctx.textAlign=t)}});var l=null;function h(t,e){if(null===l){var r=function(t){var e=[];return Object.keys(t).forEach((function(r){t[r].forEach((function(t){var n=null;switch(t){case"bold":n={family:r,weight:"bold"};break;case"italic":n={family:r,style:"italic"};break;case"bolditalic":n={family:r,weight:"bold",style:"italic"};break;case"":case"normal":n={family:r}}null!==n&&(n.ref={name:r,style:t},e.push(n))}))})),e}(t.getFontList());l=function(t){for(var e={},r=0;r<t.length;++r){var n=Ct(t[r]),i=n.family,a=n.stretch,o=n.style,s=n.weight;e[i]=e[i]||{},e[i][a]=e[i][a]||{},e[i][a][o]=e[i][a][o]||{},e[i][a][o][s]=n}return e}(r.concat(e))}return l}var p=null;Object.defineProperty(this,"fontFaces",{get:function(){return p},set:function(t){l=null,p=t}}),Object.defineProperty(this,"font",{get:function(){return this.ctx.font},set:function(t){var e;if(this.ctx.font=t,null!==(e=/^\s*(?=(?:(?:[-a-z]+\s*){0,2}(italic|oblique))?)(?=(?:(?:[-a-z]+\s*){0,2}(small-caps))?)(?=(?:(?:[-a-z]+\s*){0,2}(bold(?:er)?|lighter|[1-9]00))?)(?:(?:normal|\1|\2|\3)\s*){0,3}((?:xx?-)?(?:small|large)|medium|smaller|larger|[.\d]+(?:\%|in|[cem]m|ex|p[ctx]))(?:\s*\/\s*(normal|[.\d]+(?:\%|in|[cem]m|ex|p[ctx])))?\s*([-_,\"\'\sa-z]+?)\s*$/i.exec(t))){var r=e[1],n=(e[2],e[3]),i=e[4],a=(e[5],e[6]),o=/^([.\d]+)((?:%|in|[cem]m|ex|p[ctx]))$/i.exec(i)[2];i="px"===o?Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor):"em"===o?Math.floor(parseFloat(i)*this.pdf.getFontSize()):Math.floor(parseFloat(i)*this.pdf.internal.scaleFactor),this.pdf.setFontSize(i);var s=function(t){var e,r,n=[],i=t.trim();if(""===i)return Tt;if(i in Bt)return[Bt[i]];for(;""!==i;){switch(r=null,e=(i=qt(i)).charAt(0)){case'"':case"'":r=Dt(i.substring(1),e);break;default:r=Rt(i)}if(null===r)return Tt;if(n.push(r[0]),""!==(i=qt(r[1]))&&","!==i.charAt(0))return Tt;i=i.replace(/^,/,"")}return n}(a);if(this.fontFaces){var c=Et(h(this.pdf,this.fontFaces),s.map((function(t){return{family:t,stretch:"normal",weight:n,style:r}})));this.pdf.setFont(c.ref.name,c.ref.style)}else{var u="";("bold"===n||parseInt(n,10)>=700||"bold"===r)&&(u="bold"),"italic"===r&&(u+="italic"),0===u.length&&(u="normal");for(var l="",f={arial:"Helvetica",Arial:"Helvetica",verdana:"Helvetica",Verdana:"Helvetica",helvetica:"Helvetica",Helvetica:"Helvetica","sans-serif":"Helvetica",fixed:"Courier",monospace:"Courier",terminal:"Courier",cursive:"Times",fantasy:"Times",serif:"Times"},d=0;d<s.length;d++){if(void 0!==this.pdf.internal.getFont(s[d],u,{noFallback:!0,disableWarning:!0})){l=s[d];break}if("bolditalic"===u&&void 0!==this.pdf.internal.getFont(s[d],"bold",{noFallback:!0,disableWarning:!0}))l=s[d],u="bold";else if(void 0!==this.pdf.internal.getFont(s[d],"normal",{noFallback:!0,disableWarning:!0})){l=s[d],u="normal";break}}if(""===l)for(var p=0;p<s.length;p++)if(f[s[p]]){l=f[s[p]];break}l=""===l?"Times":l,this.pdf.setFont(l,u)}}}}),Object.defineProperty(this,"globalCompositeOperation",{get:function(){return this.ctx.globalCompositeOperation},set:function(t){this.ctx.globalCompositeOperation=t}}),Object.defineProperty(this,"globalAlpha",{get:function(){return this.ctx.globalAlpha},set:function(t){this.ctx.globalAlpha=t}}),Object.defineProperty(this,"lineDashOffset",{get:function(){return this.ctx.lineDashOffset},set:function(t){this.ctx.lineDashOffset=t,T.call(this)}}),Object.defineProperty(this,"lineDash",{get:function(){return this.ctx.lineDash},set:function(t){this.ctx.lineDash=t,T.call(this)}}),Object.defineProperty(this,"ignoreClearRect",{get:function(){return this.ctx.ignoreClearRect},set:function(t){this.ctx.ignoreClearRect=Boolean(t)}})};p.prototype.setLineDash=function(t){this.lineDash=t},p.prototype.getLineDash=function(){return this.lineDash.length%2?this.lineDash.concat(this.lineDash):this.lineDash.slice()},p.prototype.fill=function(){A.call(this,"fill",!1)},p.prototype.stroke=function(){A.call(this,"stroke",!1)},p.prototype.beginPath=function(){this.path=[{type:"begin"}]},p.prototype.moveTo=function(t,e){if(isNaN(t)||isNaN(e))throw i.error("jsPDF.context2d.moveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.moveTo");var r=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"mt",x:r.x,y:r.y}),this.ctx.lastPoint=new c(t,e)},p.prototype.closePath=function(){var t=new c(0,0),r=0;for(r=this.path.length-1;-1!==r;r--)if("begin"===this.path[r].type&&"object"===e(this.path[r+1])&&"number"==typeof this.path[r+1].x){t=new c(this.path[r+1].x,this.path[r+1].y);break}this.path.push({type:"close"}),this.ctx.lastPoint=new c(t.x,t.y)},p.prototype.lineTo=function(t,e){if(isNaN(t)||isNaN(e))throw i.error("jsPDF.context2d.lineTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.lineTo");var r=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"lt",x:r.x,y:r.y}),this.ctx.lastPoint=new c(r.x,r.y)},p.prototype.clip=function(){this.ctx.clip_path=JSON.parse(JSON.stringify(this.path)),A.call(this,null,!0)},p.prototype.quadraticCurveTo=function(t,e,r,n){if(isNaN(r)||isNaN(n)||isNaN(t)||isNaN(e))throw i.error("jsPDF.context2d.quadraticCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.quadraticCurveTo");var a=this.ctx.transform.applyToPoint(new c(r,n)),o=this.ctx.transform.applyToPoint(new c(t,e));this.path.push({type:"qct",x1:o.x,y1:o.y,x:a.x,y:a.y}),this.ctx.lastPoint=new c(a.x,a.y)},p.prototype.bezierCurveTo=function(t,e,r,n,a,o){if(isNaN(a)||isNaN(o)||isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw i.error("jsPDF.context2d.bezierCurveTo: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.bezierCurveTo");var s=this.ctx.transform.applyToPoint(new c(a,o)),u=this.ctx.transform.applyToPoint(new c(t,e)),l=this.ctx.transform.applyToPoint(new c(r,n));this.path.push({type:"bct",x1:u.x,y1:u.y,x2:l.x,y2:l.y,x:s.x,y:s.y}),this.ctx.lastPoint=new c(s.x,s.y)},p.prototype.arc=function(t,e,r,n,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(a))throw i.error("jsPDF.context2d.arc: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.arc");if(o=Boolean(o),!this.ctx.transform.isIdentity){var s=this.ctx.transform.applyToPoint(new c(t,e));t=s.x,e=s.y;var u=this.ctx.transform.applyToPoint(new c(0,r)),l=this.ctx.transform.applyToPoint(new c(0,0));r=Math.sqrt(Math.pow(u.x-l.x,2)+Math.pow(u.y-l.y,2))}Math.abs(a-n)>=2*Math.PI&&(n=0,a=2*Math.PI),this.path.push({type:"arc",x:t,y:e,radius:r,startAngle:n,endAngle:a,counterclockwise:o})},p.prototype.arcTo=function(t,e,r,n,i){throw new Error("arcTo not implemented.")},p.prototype.rect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw i.error("jsPDF.context2d.rect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rect");this.moveTo(t,e),this.lineTo(t+r,e),this.lineTo(t+r,e+n),this.lineTo(t,e+n),this.lineTo(t,e),this.lineTo(t+r,e),this.lineTo(t,e)},p.prototype.fillRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw i.error("jsPDF.context2d.fillRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillRect");if(!m.call(this)){var a={};"butt"!==this.lineCap&&(a.lineCap=this.lineCap,this.lineCap="butt"),"miter"!==this.lineJoin&&(a.lineJoin=this.lineJoin,this.lineJoin="miter"),this.beginPath(),this.rect(t,e,r,n),this.fill(),a.hasOwnProperty("lineCap")&&(this.lineCap=a.lineCap),a.hasOwnProperty("lineJoin")&&(this.lineJoin=a.lineJoin)}},p.prototype.strokeRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw i.error("jsPDF.context2d.strokeRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeRect");v.call(this)||(this.beginPath(),this.rect(t,e,r,n),this.stroke())},p.prototype.clearRect=function(t,e,r,n){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n))throw i.error("jsPDF.context2d.clearRect: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.clearRect");this.ignoreClearRect||(this.fillStyle="#ffffff",this.fillRect(t,e,r,n))},p.prototype.save=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("q");if(this.pdf.setPage(e),t){this.ctx.fontSize=this.pdf.internal.getFontSize();var n=new d(this.ctx);this.ctxStack.push(this.ctx),this.ctx=n}},p.prototype.restore=function(t){t="boolean"!=typeof t||t;for(var e=this.pdf.internal.getCurrentPageInfo().pageNumber,r=0;r<this.pdf.internal.getNumberOfPages();r++)this.pdf.setPage(r+1),this.pdf.internal.out("Q");this.pdf.setPage(e),t&&0!==this.ctxStack.length&&(this.ctx=this.ctxStack.pop(),this.fillStyle=this.ctx.fillStyle,this.strokeStyle=this.ctx.strokeStyle,this.font=this.ctx.font,this.lineCap=this.ctx.lineCap,this.lineWidth=this.ctx.lineWidth,this.lineJoin=this.ctx.lineJoin,this.lineDash=this.ctx.lineDash,this.lineDashOffset=this.ctx.lineDashOffset)},p.prototype.toDataURL=function(){throw new Error("toDataUrl not implemented.")};var g=function(t){var e,r,n,i;if(!0===t.isCanvasGradient&&(t=t.getColor()),!t)return{r:0,g:0,b:0,a:0,style:t};if(/transparent|rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*0+\s*\)/.test(t))e=0,r=0,n=0,i=0;else{var a=/rgb\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*\)/.exec(t);if(null!==a)e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=1;else if(null!==(a=/rgba\s*\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*,\s*([\d.]+)\s*\)/.exec(t)))e=parseInt(a[1]),r=parseInt(a[2]),n=parseInt(a[3]),i=parseFloat(a[4]);else{if(i=1,"string"==typeof t&&"#"!==t.charAt(0)){var o=new h(t);t=o.ok?o.toHex():"#000000"}4===t.length?(e=t.substring(1,2),e+=e,r=t.substring(2,3),r+=r,n=t.substring(3,4),n+=n):(e=t.substring(1,3),r=t.substring(3,5),n=t.substring(5,7)),e=parseInt(e,16),r=parseInt(r,16),n=parseInt(n,16)}}return{r:e,g:r,b:n,a:i,style:t}},m=function(){return this.ctx.isFillTransparent||0==this.globalAlpha},v=function(){return Boolean(this.ctx.isStrokeTransparent||0==this.globalAlpha)};p.prototype.fillText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw i.error("jsPDF.context2d.fillText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.fillText");if(n=isNaN(n)?void 0:n,!m.call(this)){var a=q(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;C.call(this,{text:t,x:e,y:r,scale:o,angle:a,align:this.textAlign,maxWidth:n})}},p.prototype.strokeText=function(t,e,r,n){if(isNaN(e)||isNaN(r)||"string"!=typeof t)throw i.error("jsPDF.context2d.strokeText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.strokeText");if(!v.call(this)){n=isNaN(n)?void 0:n;var a=q(this.ctx.transform.rotation),o=this.ctx.transform.scaleX;C.call(this,{text:t,x:e,y:r,scale:o,renderingMode:"stroke",angle:a,align:this.textAlign,maxWidth:n})}},p.prototype.measureText=function(t){if("string"!=typeof t)throw i.error("jsPDF.context2d.measureText: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.measureText");var e=this.pdf,r=this.pdf.internal.scaleFactor,n=e.internal.getFontSize(),a=e.getStringUnitWidth(t)*n/e.internal.scaleFactor,o=function(t){var e=(t=t||{}).width||0;return Object.defineProperty(this,"width",{get:function(){return e}}),this};return new o({width:a*=Math.round(96*r/72*1e4)/1e4})},p.prototype.scale=function(t,e){if(isNaN(t)||isNaN(e))throw i.error("jsPDF.context2d.scale: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.scale");var r=new l(t,0,0,e,0,0);this.ctx.transform=this.ctx.transform.multiply(r)},p.prototype.rotate=function(t){if(isNaN(t))throw i.error("jsPDF.context2d.rotate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.rotate");var e=new l(Math.cos(t),Math.sin(t),-Math.sin(t),Math.cos(t),0,0);this.ctx.transform=this.ctx.transform.multiply(e)},p.prototype.translate=function(t,e){if(isNaN(t)||isNaN(e))throw i.error("jsPDF.context2d.translate: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.translate");var r=new l(1,0,0,1,t,e);this.ctx.transform=this.ctx.transform.multiply(r)},p.prototype.transform=function(t,e,r,n,a,o){if(isNaN(t)||isNaN(e)||isNaN(r)||isNaN(n)||isNaN(a)||isNaN(o))throw i.error("jsPDF.context2d.transform: Invalid arguments",arguments),new Error("Invalid arguments passed to jsPDF.context2d.transform");var s=new l(t,e,r,n,a,o);this.ctx.transform=this.ctx.transform.multiply(s)},p.prototype.setTransform=function(t,e,r,n,i,a){t=isNaN(t)?1:t,e=isNaN(e)?0:e,r=isNaN(r)?0:r,n=isNaN(n)?1:n,i=isNaN(i)?0:i,a=isNaN(a)?0:a,this.ctx.transform=new l(t,e,r,n,i,a)};var b=function(){return this.margin[0]>0||this.margin[1]>0||this.margin[2]>0||this.margin[3]>0};p.prototype.drawImage=function(t,e,r,n,i,a,o,s,c){var h=this.pdf.getImageProperties(t),f=1,d=1,p=1,g=1;void 0!==n&&void 0!==s&&(p=s/n,g=c/i,f=h.width/n*s/n,d=h.height/i*c/i),void 0===a&&(a=e,o=r,e=0,r=0),void 0!==n&&void 0===s&&(s=n,c=i),void 0===n&&void 0===s&&(s=h.width,c=h.height);for(var m,v=this.ctx.transform.decompose(),w=q(v.rotate.shx),A=new l,S=(A=(A=(A=A.multiply(v.translate)).multiply(v.skew)).multiply(v.scale)).applyToRectangle(new u(a-e*p,o-r*g,n*f,i*d)),_=y.call(this,S),P=[],k=0;k<_.length;k+=1)-1===P.indexOf(_[k])&&P.push(_[k]);if(L(P),this.autoPaging)for(var F=P[0],I=P[P.length-1],C=F;C<I+1;C++){this.pdf.setPage(C);var j=this.pdf.internal.pageSize.width-this.margin[3]-this.margin[1],O=1===C?this.posY+this.margin[0]:this.margin[0],B=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],M=this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2],E=1===C?0:B+(C-2)*M;if(0!==this.ctx.clip_path.length){var D=this.path;m=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(m,this.posX+this.margin[3],-E+O+this.ctx.prevPageLastElemOffset),x.call(this,"fill",!0),this.path=D}var R=JSON.parse(JSON.stringify(S));R=N([R],this.posX+this.margin[3],-E+O+this.ctx.prevPageLastElemOffset)[0];var T=(C>F||C<I)&&b.call(this);T&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],j,M,null).clip().discardPath()),this.pdf.addImage(t,"JPEG",R.x,R.y,R.w,R.h,null,null,w),T&&this.pdf.restoreGraphicsState()}else this.pdf.addImage(t,"JPEG",S.x,S.y,S.w,S.h,null,null,w)};var y=function(t,e,r){var n=[];e=e||this.pdf.internal.pageSize.width,r=r||this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2];var i=this.posY+this.ctx.prevPageLastElemOffset;switch(t.type){default:case"mt":case"lt":n.push(Math.floor((t.y+i)/r)+1);break;case"arc":n.push(Math.floor((t.y+i-t.radius)/r)+1),n.push(Math.floor((t.y+i+t.radius)/r)+1);break;case"qct":var a=D(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x,t.y);n.push(Math.floor((a.y+i)/r)+1),n.push(Math.floor((a.y+a.h+i)/r)+1);break;case"bct":var o=R(this.ctx.lastPoint.x,this.ctx.lastPoint.y,t.x1,t.y1,t.x2,t.y2,t.x,t.y);n.push(Math.floor((o.y+i)/r)+1),n.push(Math.floor((o.y+o.h+i)/r)+1);break;case"rect":n.push(Math.floor((t.y+i)/r)+1),n.push(Math.floor((t.y+t.h+i)/r)+1)}for(var s=0;s<n.length;s+=1)for(;this.pdf.internal.getNumberOfPages()<n[s];)w.call(this);return n},w=function(){var t=this.fillStyle,e=this.strokeStyle,r=this.font,n=this.lineCap,i=this.lineWidth,a=this.lineJoin;this.pdf.addPage(),this.fillStyle=t,this.strokeStyle=e,this.font=r,this.lineCap=n,this.lineWidth=i,this.lineJoin=a},N=function(t,e,r){for(var n=0;n<t.length;n++)switch(t[n].type){case"bct":t[n].x2+=e,t[n].y2+=r;case"qct":t[n].x1+=e,t[n].y1+=r;case"mt":case"lt":case"arc":default:t[n].x+=e,t[n].y+=r}return t},L=function(t){return t.sort((function(t,e){return t-e}))},A=function(t,e){for(var r,n,i=this.fillStyle,a=this.strokeStyle,o=this.lineCap,s=this.lineWidth,c=Math.abs(s*this.ctx.transform.scaleX),u=this.lineJoin,l=JSON.parse(JSON.stringify(this.path)),h=JSON.parse(JSON.stringify(this.path)),f=[],d=0;d<h.length;d++)if(void 0!==h[d].x)for(var p=y.call(this,h[d]),g=0;g<p.length;g+=1)-1===f.indexOf(p[g])&&f.push(p[g]);for(var m=0;m<f.length;m++)for(;this.pdf.internal.getNumberOfPages()<f[m];)w.call(this);if(L(f),this.autoPaging)for(var v=f[0],A=f[f.length-1],S=v;S<A+1;S++){this.pdf.setPage(S),this.fillStyle=i,this.strokeStyle=a,this.lineCap=o,this.lineWidth=c,this.lineJoin=u;var _=this.pdf.internal.pageSize.width-this.margin[3]-this.margin[1],P=1===S?this.posY+this.margin[0]:this.margin[0],k=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],F=this.pdf.internal.pageSize.height-this.margin[0]-this.margin[2],I=1===S?0:k+(S-2)*F;if(0!==this.ctx.clip_path.length){var C=this.path;r=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(r,this.posX+this.margin[3],-I+P+this.ctx.prevPageLastElemOffset),x.call(this,t,!0),this.path=C}if(n=JSON.parse(JSON.stringify(l)),this.path=N(n,this.posX+this.margin[3],-I+P+this.ctx.prevPageLastElemOffset),!1===e||0===S){var j=(S>v||S<A)&&b.call(this);j&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],_,F,null).clip().discardPath()),x.call(this,t,e),j&&this.pdf.restoreGraphicsState()}this.lineWidth=s}else this.lineWidth=c,x.call(this,t,e),this.lineWidth=s;this.path=l},x=function(t,e){if(("stroke"!==t||e||!v.call(this))&&("stroke"===t||e||!m.call(this))){for(var r,n,i=[],a=this.path,o=0;o<a.length;o++){var s=a[o];switch(s.type){case"begin":i.push({begin:!0});break;case"close":i.push({close:!0});break;case"mt":i.push({start:s,deltas:[],abs:[]});break;case"lt":var c=i.length;if(a[o-1]&&!isNaN(a[o-1].x)&&(r=[s.x-a[o-1].x,s.y-a[o-1].y],c>0))for(;c>=0;c--)if(!0!==i[c-1].close&&!0!==i[c-1].begin){i[c-1].deltas.push(r),i[c-1].abs.push(s);break}break;case"bct":r=[s.x1-a[o-1].x,s.y1-a[o-1].y,s.x2-a[o-1].x,s.y2-a[o-1].y,s.x-a[o-1].x,s.y-a[o-1].y],i[i.length-1].deltas.push(r);break;case"qct":var u=a[o-1].x+2/3*(s.x1-a[o-1].x),l=a[o-1].y+2/3*(s.y1-a[o-1].y),h=s.x+2/3*(s.x1-s.x),f=s.y+2/3*(s.y1-s.y),d=s.x,p=s.y;r=[u-a[o-1].x,l-a[o-1].y,h-a[o-1].x,f-a[o-1].y,d-a[o-1].x,p-a[o-1].y],i[i.length-1].deltas.push(r);break;case"arc":i.push({deltas:[],abs:[],arc:!0}),Array.isArray(i[i.length-1].abs)&&i[i.length-1].abs.push(s)}}n=e?null:"stroke"===t?"stroke":"fill";for(var g=!1,b=0;b<i.length;b++)if(i[b].arc)for(var y=i[b].abs,w=0;w<y.length;w++){var N=y[w];"arc"===N.type?P.call(this,N.x,N.y,N.radius,N.startAngle,N.endAngle,N.counterclockwise,void 0,e,!g):j.call(this,N.x,N.y),g=!0}else if(!0===i[b].close)this.pdf.internal.out("h"),g=!1;else if(!0!==i[b].begin){var L=i[b].start.x,A=i[b].start.y;O.call(this,i[b].deltas,L,A),g=!0}n&&k.call(this,n),e&&F.call(this)}},S=function(t){var e=this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor,r=e*(this.pdf.internal.getLineHeightFactor()-1);switch(this.ctx.textBaseline){case"bottom":return t-r;case"top":return t+e-r;case"hanging":return t+e-2*r;case"middle":return t+e/2-r;case"ideographic":return t;case"alphabetic":default:return t}},_=function(t){return t+this.pdf.internal.getFontSize()/this.pdf.internal.scaleFactor*(this.pdf.internal.getLineHeightFactor()-1)};p.prototype.createLinearGradient=function(){var t=function(){};return t.colorStops=[],t.addColorStop=function(t,e){this.colorStops.push([t,e])},t.getColor=function(){return 0===this.colorStops.length?"#000000":this.colorStops[0][1]},t.isCanvasGradient=!0,t},p.prototype.createPattern=function(){return this.createLinearGradient()},p.prototype.createRadialGradient=function(){return this.createLinearGradient()};var P=function(t,e,r,n,i,a,o,s,c){for(var u=M.call(this,r,n,i,a),l=0;l<u.length;l++){var h=u[l];0===l&&(c?I.call(this,h.x1+t,h.y1+e):j.call(this,h.x1+t,h.y1+e)),B.call(this,t,e,h.x2,h.y2,h.x3,h.y3,h.x4,h.y4)}s?F.call(this):k.call(this,o)},k=function(t){switch(t){case"stroke":this.pdf.internal.out("S");break;case"fill":this.pdf.internal.out("f")}},F=function(){this.pdf.clip(),this.pdf.discardPath()},I=function(t,e){this.pdf.internal.out(n(t)+" "+a(e)+" m")},C=function(t){var e;switch(t.align){case"right":case"end":e="right";break;case"center":e="center";break;case"left":case"start":default:e="left"}var r=this.pdf.getTextDimensions(t.text),n=S.call(this,t.y),i=_.call(this,n)-r.h,a=this.ctx.transform.applyToPoint(new c(t.x,n)),o=this.ctx.transform.decompose(),s=new l;s=(s=(s=s.multiply(o.translate)).multiply(o.skew)).multiply(o.scale);for(var h,f,d,p=this.ctx.transform.applyToRectangle(new u(t.x,n,r.w,r.h)),g=s.applyToRectangle(new u(t.x,i,r.w,r.h)),m=y.call(this,g),v=[],w=0;w<m.length;w+=1)-1===v.indexOf(m[w])&&v.push(m[w]);if(L(v),this.autoPaging)for(var A=v[0],P=v[v.length-1],k=A;k<P+1;k++){this.pdf.setPage(k);var F=1===k?this.posY+this.margin[0]:this.margin[0],I=this.pdf.internal.pageSize.height-this.posY-this.margin[0]-this.margin[2],C=this.pdf.internal.pageSize.height-this.margin[2],j=C-this.margin[0],O=this.pdf.internal.pageSize.width-this.margin[1],B=O-this.margin[3],M=1===k?0:I+(k-2)*j;if(0!==this.ctx.clip_path.length){var E=this.path;h=JSON.parse(JSON.stringify(this.ctx.clip_path)),this.path=N(h,this.posX+this.margin[3],-1*M+F),x.call(this,"fill",!0),this.path=E}var q=N([JSON.parse(JSON.stringify(g))],this.posX+this.margin[3],-M+F+this.ctx.prevPageLastElemOffset)[0];t.scale>=.01&&(f=this.pdf.internal.getFontSize(),this.pdf.setFontSize(f*t.scale),d=this.lineWidth,this.lineWidth=d*t.scale);var D="text"!==this.autoPaging;if(D||q.y+q.h<=C){if(D||q.y>=F&&q.x<=O){var R=D?t.text:this.pdf.splitTextToSize(t.text,t.maxWidth||O-q.x)[0],T=N([JSON.parse(JSON.stringify(p))],this.posX+this.margin[3],-M+F+this.ctx.prevPageLastElemOffset)[0],U=D&&(k>A||k<P)&&b.call(this);U&&(this.pdf.saveGraphicsState(),this.pdf.rect(this.margin[3],this.margin[0],B,j,null).clip().discardPath()),this.pdf.text(R,T.x,T.y,{angle:t.angle,align:e,renderingMode:t.renderingMode}),U&&this.pdf.restoreGraphicsState()}}else q.y<C&&(this.ctx.prevPageLastElemOffset+=C-q.y);t.scale>=.01&&(this.pdf.setFontSize(f),this.lineWidth=d)}else t.scale>=.01&&(f=this.pdf.internal.getFontSize(),this.pdf.setFontSize(f*t.scale),d=this.lineWidth,this.lineWidth=d*t.scale),this.pdf.text(t.text,a.x+this.posX,a.y+this.posY,{angle:t.angle,align:e,renderingMode:t.renderingMode,maxWidth:t.maxWidth}),t.scale>=.01&&(this.pdf.setFontSize(f),this.lineWidth=d)},j=function(t,e,r,i){r=r||0,i=i||0,this.pdf.internal.out(n(t+r)+" "+a(e+i)+" l")},O=function(t,e,r){return this.pdf.lines(t,e,r,null,null)},B=function(t,e,n,i,a,c,u,l){this.pdf.internal.out([r(o(n+t)),r(s(i+e)),r(o(a+t)),r(s(c+e)),r(o(u+t)),r(s(l+e)),"c"].join(" "))},M=function(t,e,r,n){for(var i=2*Math.PI,a=Math.PI/2;e>r;)e-=i;var o=Math.abs(r-e);o<i&&n&&(o=i-o);for(var s=[],c=n?-1:1,u=e;o>1e-5;){var l=u+c*Math.min(o,a);s.push(E.call(this,t,u,l)),o-=Math.abs(l-u),u=l}return s},E=function(t,e,r){var n=(r-e)/2,i=t*Math.cos(n),a=t*Math.sin(n),o=i,s=-a,c=o*o+s*s,u=c+o*i+s*a,l=4/3*(Math.sqrt(2*c*u)-u)/(o*a-s*i),h=o-l*s,f=s+l*o,d=h,p=-f,g=n+e,m=Math.cos(g),v=Math.sin(g);return{x1:t*Math.cos(e),y1:t*Math.sin(e),x2:h*m-f*v,y2:h*v+f*m,x3:d*m-p*v,y3:d*v+p*m,x4:t*Math.cos(r),y4:t*Math.sin(r)}},q=function(t){return 180*t/Math.PI},D=function(t,e,r,n,i,a){var o=t+.5*(r-t),s=e+.5*(n-e),c=i+.5*(r-i),l=a+.5*(n-a),h=Math.min(t,i,o,c),f=Math.max(t,i,o,c),d=Math.min(e,a,s,l),p=Math.max(e,a,s,l);return new u(h,d,f-h,p-d)},R=function(t,e,r,n,i,a,o,s){var c,l,h,f,d,p,g,m,v,b,y,w,N,L,A=r-t,x=n-e,S=i-r,_=a-n,P=o-i,k=s-a;for(l=0;l<41;l++)v=(g=(h=t+(c=l/40)*A)+c*((d=r+c*S)-h))+c*(d+c*(i+c*P-d)-g),b=(m=(f=e+c*x)+c*((p=n+c*_)-f))+c*(p+c*(a+c*k-p)-m),0==l?(y=v,w=b,N=v,L=b):(y=Math.min(y,v),w=Math.min(w,b),N=Math.max(N,v),L=Math.max(L,b));return new u(Math.round(y),Math.round(w),Math.round(N-y),Math.round(L-w))},T=function(){if(this.prevLineDash||this.ctx.lineDash.length||this.ctx.lineDashOffset){var t,e,r=(t=this.ctx.lineDash,e=this.ctx.lineDashOffset,JSON.stringify({lineDash:t,lineDashOffset:e}));this.prevLineDash!==r&&(this.pdf.setLineDash(this.ctx.lineDash,this.ctx.lineDashOffset),this.prevLineDash=r)}}}(M.API);var Ut=Uint8Array,zt=Uint16Array,Ht=Int32Array,Wt=new Ut([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),Vt=new Ut([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),Gt=new Ut([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),Yt=function(t,e){for(var r=new zt(31),n=0;n<31;++n)r[n]=e+=1<<t[n-1];var i=new Ht(r[30]);for(n=1;n<30;++n)for(var a=r[n];a<r[n+1];++a)i[a]=a-r[n]<<5|n;return{b:r,r:i}},Jt=Yt(Wt,2),Xt=Jt.b,Kt=Jt.r;Xt[28]=258,Kt[258]=28;for(var Zt=Yt(Vt,0),$t=Zt.b,Qt=Zt.r,te=new zt(32768),ee=0;ee<32768;++ee){var re=(43690&ee)>>1|(21845&ee)<<1;re=(61680&(re=(52428&re)>>2|(13107&re)<<2))>>4|(3855&re)<<4,te[ee]=((65280&re)>>8|(255&re)<<8)>>1}var ne=function(t,e,r){for(var n=t.length,i=0,a=new zt(e);i<n;++i)t[i]&&++a[t[i]-1];var o,s=new zt(e);for(i=1;i<e;++i)s[i]=s[i-1]+a[i-1]<<1;if(r){o=new zt(1<<e);var c=15-e;for(i=0;i<n;++i)if(t[i])for(var u=i<<4|t[i],l=e-t[i],h=s[t[i]-1]++<<l,f=h|(1<<l)-1;h<=f;++h)o[te[h]>>c]=u}else for(o=new zt(n),i=0;i<n;++i)t[i]&&(o[i]=te[s[t[i]-1]++]>>15-t[i]);return o},ie=new Ut(288);for(ee=0;ee<144;++ee)ie[ee]=8;for(ee=144;ee<256;++ee)ie[ee]=9;for(ee=256;ee<280;++ee)ie[ee]=7;for(ee=280;ee<288;++ee)ie[ee]=8;var ae=new Ut(32);for(ee=0;ee<32;++ee)ae[ee]=5;var oe=ne(ie,9,0),se=ne(ie,9,1),ce=ne(ae,5,0),ue=ne(ae,5,1),le=function(t){for(var e=t[0],r=1;r<t.length;++r)t[r]>e&&(e=t[r]);return e},he=function(t,e,r){var n=e/8|0;return(t[n]|t[n+1]<<8)>>(7&e)&r},fe=function(t,e){var r=e/8|0;return(t[r]|t[r+1]<<8|t[r+2]<<16)>>(7&e)},de=function(t){return(t+7)/8|0},pe=function(t,e,r){return(null==e||e<0)&&(e=0),(null==r||r>t.length)&&(r=t.length),new Ut(t.subarray(e,r))},ge=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],me=function(t,e,r){var n=new Error(e||ge[t]);if(n.code=t,Error.captureStackTrace&&Error.captureStackTrace(n,me),!r)throw n;return n},ve=function(t,e,r){r<<=7&e;var n=e/8|0;t[n]|=r,t[n+1]|=r>>8},be=function(t,e,r){r<<=7&e;var n=e/8|0;t[n]|=r,t[n+1]|=r>>8,t[n+2]|=r>>16},ye=function(t,e){for(var r=[],n=0;n<t.length;++n)t[n]&&r.push({s:n,f:t[n]});var i=r.length,a=r.slice();if(!i)return{t:_e,l:0};if(1==i){var o=new Ut(r[0].s+1);return o[r[0].s]=1,{t:o,l:1}}r.sort((function(t,e){return t.f-e.f})),r.push({s:-1,f:25001});var s=r[0],c=r[1],u=0,l=1,h=2;for(r[0]={s:-1,f:s.f+c.f,l:s,r:c};l!=i-1;)s=r[r[u].f<r[h].f?u++:h++],c=r[u!=l&&r[u].f<r[h].f?u++:h++],r[l++]={s:-1,f:s.f+c.f,l:s,r:c};var f=a[0].s;for(n=1;n<i;++n)a[n].s>f&&(f=a[n].s);var d=new zt(f+1),p=we(r[l-1],d,0);if(p>e){n=0;var g=0,m=p-e,v=1<<m;for(a.sort((function(t,e){return d[e.s]-d[t.s]||t.f-e.f}));n<i;++n){var b=a[n].s;if(!(d[b]>e))break;g+=v-(1<<p-d[b]),d[b]=e}for(g>>=m;g>0;){var y=a[n].s;d[y]<e?g-=1<<e-d[y]++-1:++n}for(;n>=0&&g;--n){var w=a[n].s;d[w]==e&&(--d[w],++g)}p=e}return{t:new Ut(d),l:p}},we=function(t,e,r){return-1==t.s?Math.max(we(t.l,e,r+1),we(t.r,e,r+1)):e[t.s]=r},Ne=function(t){for(var e=t.length;e&&!t[--e];);for(var r=new zt(++e),n=0,i=t[0],a=1,o=function(t){r[n++]=t},s=1;s<=e;++s)if(t[s]==i&&s!=e)++a;else{if(!i&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(i),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(i);a=1,i=t[s]}return{c:r.subarray(0,n),n:e}},Le=function(t,e){for(var r=0,n=0;n<e.length;++n)r+=t[n]*e[n];return r},Ae=function(t,e,r){var n=r.length,i=de(e+2);t[i]=255&n,t[i+1]=n>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var a=0;a<n;++a)t[i+a+4]=r[a];return 8*(i+4+n)},xe=function(t,e,r,n,i,a,o,s,c,u,l){ve(e,l++,r),++i[256];for(var h=ye(i,15),f=h.t,d=h.l,p=ye(a,15),g=p.t,m=p.l,v=Ne(f),b=v.c,y=v.n,w=Ne(g),N=w.c,L=w.n,A=new zt(19),x=0;x<b.length;++x)++A[31&b[x]];for(x=0;x<N.length;++x)++A[31&N[x]];for(var S=ye(A,7),_=S.t,P=S.l,k=19;k>4&&!_[Gt[k-1]];--k);var F,I,C,j,O=u+5<<3,B=Le(i,ie)+Le(a,ae)+o,M=Le(i,f)+Le(a,g)+o+14+3*k+Le(A,_)+2*A[16]+3*A[17]+7*A[18];if(c>=0&&O<=B&&O<=M)return Ae(e,l,t.subarray(c,c+u));if(ve(e,l,1+(M<B)),l+=2,M<B){F=ne(f,d,0),I=f,C=ne(g,m,0),j=g;var E=ne(_,P,0);ve(e,l,y-257),ve(e,l+5,L-1),ve(e,l+10,k-4),l+=14;for(x=0;x<k;++x)ve(e,l+3*x,_[Gt[x]]);l+=3*k;for(var q=[b,N],D=0;D<2;++D){var R=q[D];for(x=0;x<R.length;++x){var T=31&R[x];ve(e,l,E[T]),l+=_[T],T>15&&(ve(e,l,R[x]>>5&127),l+=R[x]>>12)}}}else F=oe,I=ie,C=ce,j=ae;for(x=0;x<s;++x){var U=n[x];if(U>255){be(e,l,F[(T=U>>18&31)+257]),l+=I[T+257],T>7&&(ve(e,l,U>>23&31),l+=Wt[T]);var z=31&U;be(e,l,C[z]),l+=j[z],z>3&&(be(e,l,U>>5&8191),l+=Vt[z])}else be(e,l,F[U]),l+=I[U]}return be(e,l,F[256]),l+I[256]},Se=new Ht([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),_e=new Ut(0),Pe=function(){var t=1,e=0;return{p:function(r){for(var n=t,i=e,a=0|r.length,o=0;o!=a;){for(var s=Math.min(o+2655,a);o<s;++o)i+=n+=r[o];n=(65535&n)+15*(n>>16),i=(65535&i)+15*(i>>16)}t=n,e=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(e%=65521))<<8|e>>8}}},ke=function(t,e,r,n,i){if(!i&&(i={l:1},e.dictionary)){var a=e.dictionary.subarray(-32768),o=new Ut(a.length+t.length);o.set(a),o.set(t,a.length),t=o,i.w=a.length}return function(t,e,r,n,i,a){var o=a.z||t.length,s=new Ut(n+o+5*(1+Math.ceil(o/7e3))+i),c=s.subarray(n,s.length-i),u=a.l,l=7&(a.r||0);if(e){l&&(c[0]=a.r>>3);for(var h=Se[e-1],f=h>>13,d=8191&h,p=(1<<r)-1,g=a.p||new zt(32768),m=a.h||new zt(p+1),v=Math.ceil(r/3),b=2*v,y=function(e){return(t[e]^t[e+1]<<v^t[e+2]<<b)&p},w=new Ht(25e3),N=new zt(288),L=new zt(32),A=0,x=0,S=a.i||0,_=0,P=a.w||0,k=0;S+2<o;++S){var F=y(S),I=32767&S,C=m[F];if(g[I]=C,m[F]=I,P<=S){var j=o-S;if((A>7e3||_>24576)&&(j>423||!u)){l=xe(t,c,0,w,N,L,x,_,k,S-k,l),_=A=x=0,k=S;for(var O=0;O<286;++O)N[O]=0;for(O=0;O<30;++O)L[O]=0}var B=2,M=0,E=d,q=I-C&32767;if(j>2&&F==y(S-q))for(var D=Math.min(f,j)-1,R=Math.min(32767,S),T=Math.min(258,j);q<=R&&--E&&I!=C;){if(t[S+B]==t[S+B-q]){for(var U=0;U<T&&t[S+U]==t[S+U-q];++U);if(U>B){if(B=U,M=q,U>D)break;var z=Math.min(q,U-2),H=0;for(O=0;O<z;++O){var W=S-q+O&32767,V=W-g[W]&32767;V>H&&(H=V,C=W)}}}q+=(I=C)-(C=g[I])&32767}if(M){w[_++]=268435456|Kt[B]<<18|Qt[M];var G=31&Kt[B],Y=31&Qt[M];x+=Wt[G]+Vt[Y],++N[257+G],++L[Y],P=S+B,++A}else w[_++]=t[S],++N[t[S]]}}for(S=Math.max(S,P);S<o;++S)w[_++]=t[S],++N[t[S]];l=xe(t,c,u,w,N,L,x,_,k,S-k,l),u||(a.r=7&l|c[l/8|0]<<3,l-=7,a.h=m,a.p=g,a.i=S,a.w=P)}else{for(S=a.w||0;S<o+u;S+=65535){var J=S+65535;J>=o&&(c[l/8|0]=u,J=o),l=Ae(c,l+1,t.subarray(S,J))}a.i=o}return pe(s,0,n+de(l)+i)}(t,null==e.level?6:e.level,null==e.mem?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(t.length)))):12+e.mem,r,n,i)},Fe=function(t,e,r){for(;r;++e)t[e]=r,r>>>=8};function Ie(t,e){e||(e={});var r=Pe();r.p(t);var n=ke(t,e,e.dictionary?6:2,4);return function(t,e){var r=e.level,n=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=n<<6|(e.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,e.dictionary){var i=Pe();i.p(e.dictionary),Fe(t,2,i.d())}}(n,e),Fe(n,n.length-4,r.d()),n}function Ce(t,e){return function(t,e,r,n){var i=t.length,a=n?n.length:0;if(!i||e.f&&!e.l)return r||new Ut(0);var o=!r,s=o||2!=e.i,c=e.i;o&&(r=new Ut(3*i));var u=function(t){var e=r.length;if(t>e){var n=new Ut(Math.max(2*e,t));n.set(r),r=n}},l=e.f||0,h=e.p||0,f=e.b||0,d=e.l,p=e.d,g=e.m,m=e.n,v=8*i;do{if(!d){l=he(t,h,1);var b=he(t,h+1,3);if(h+=3,!b){var y=t[(I=de(h)+4)-4]|t[I-3]<<8,w=I+y;if(w>i){c&&me(0);break}s&&u(f+y),r.set(t.subarray(I,w),f),e.b=f+=y,e.p=h=8*w,e.f=l;continue}if(1==b)d=se,p=ue,g=9,m=5;else if(2==b){var N=he(t,h,31)+257,L=he(t,h+10,15)+4,A=N+he(t,h+5,31)+1;h+=14;for(var x=new Ut(A),S=new Ut(19),_=0;_<L;++_)S[Gt[_]]=he(t,h+3*_,7);h+=3*L;var P=le(S),k=(1<<P)-1,F=ne(S,P,1);for(_=0;_<A;){var I,C=F[he(t,h,k)];if(h+=15&C,(I=C>>4)<16)x[_++]=I;else{var j=0,O=0;for(16==I?(O=3+he(t,h,3),h+=2,j=x[_-1]):17==I?(O=3+he(t,h,7),h+=3):18==I&&(O=11+he(t,h,127),h+=7);O--;)x[_++]=j}}var B=x.subarray(0,N),M=x.subarray(N);g=le(B),m=le(M),d=ne(B,g,1),p=ne(M,m,1)}else me(1);if(h>v){c&&me(0);break}}s&&u(f+131072);for(var E=(1<<g)-1,q=(1<<m)-1,D=h;;D=h){var R=(j=d[fe(t,h)&E])>>4;if((h+=15&j)>v){c&&me(0);break}if(j||me(2),R<256)r[f++]=R;else{if(256==R){D=h,d=null;break}var T=R-254;if(R>264){var U=Wt[_=R-257];T=he(t,h,(1<<U)-1)+Xt[_],h+=U}var z=p[fe(t,h)&q],H=z>>4;z||me(3),h+=15&z;M=$t[H];if(H>3){U=Vt[H];M+=fe(t,h)&(1<<U)-1,h+=U}if(h>v){c&&me(0);break}s&&u(f+131072);var W=f+T;if(f<M){var V=a-M,G=Math.min(M,W);for(V+f<0&&me(3);f<G;++f)r[f]=n[V+f]}for(;f<W;++f)r[f]=r[f-M]}}e.l=d,e.p=D,e.b=f,e.f=l,d&&(l=1,e.m=g,e.d=p,e.n=m)}while(!l);return f!=r.length&&o?pe(r,0,f):r.subarray(0,f)}(t.subarray((r=t,n=e&&e.dictionary,(8!=(15&r[0])||r[0]>>4>7||(r[0]<<8|r[1])%31)&&me(6,"invalid zlib data"),(r[1]>>5&1)==+!n&&me(6,"invalid zlib data: "+(32&r[1]?"need":"unexpected")+" dictionary"),2+(r[1]>>3&4)),-4),{i:2},e&&e.out,e&&e.dictionary);var r,n}var je="undefined"!=typeof TextDecoder&&new TextDecoder;try{je.decode(_e,{stream:!0}),1}catch(t){}
/**
   * @license
   * jsPDF filters PlugIn
   * Copyright (c) 2014 Aras Abbasi
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */!function(t){var e=function(t){var e,r,n,i,a,o,s,c,u,l;for(/[^\x00-\xFF]/.test(t),r=[],n=0,i=(t+=e="\0\0\0\0".slice(t.length%4||4)).length;i>n;n+=4)0!==(a=(t.charCodeAt(n)<<24)+(t.charCodeAt(n+1)<<16)+(t.charCodeAt(n+2)<<8)+t.charCodeAt(n+3))?(o=(a=((a=((a=((a=(a-(l=a%85))/85)-(u=a%85))/85)-(c=a%85))/85)-(s=a%85))/85)%85,r.push(o+33,s+33,c+33,u+33,l+33)):r.push(122);return function(t,e){for(var r=e;r>0;r--)t.pop()}(r,e.length),String.fromCharCode.apply(String,r)+"~>"},r=function(t){var e,r,n,i,a,o=String,s="length",c=255,u="charCodeAt",l="slice",h="replace";for(t[l](-2),t=t[l](0,-2)[h](/\s/g,"")[h]("z","!!!!!"),n=[],i=0,a=(t+=e="uuuuu"[l](t[s]%5||5))[s];a>i;i+=5)r=52200625*(t[u](i)-33)+614125*(t[u](i+1)-33)+7225*(t[u](i+2)-33)+85*(t[u](i+3)-33)+(t[u](i+4)-33),n.push(c&r>>24,c&r>>16,c&r>>8,c&r);return function(t,e){for(var r=e;r>0;r--)t.pop()}(n,e[s]),o.fromCharCode.apply(o,n)},n=function(t){var e=new RegExp(/^([0-9A-Fa-f]{2})+$/);if(-1!==(t=t.replace(/\s/g,"")).indexOf(">")&&(t=t.substr(0,t.indexOf(">"))),t.length%2&&(t+="0"),!1===e.test(t))return"";for(var r="",n=0;n<t.length;n+=2)r+=String.fromCharCode("0x"+(t[n]+t[n+1]));return r},i=function(t){for(var e=new Uint8Array(t.length),r=t.length;r--;)e[r]=t.charCodeAt(r);return t=(e=Ie(e)).reduce((function(t,e){return t+String.fromCharCode(e)}),"")};t.processDataByFilters=function(t,a){var o=0,s=t||"",c=[];for("string"==typeof(a=a||[])&&(a=[a]),o=0;o<a.length;o+=1)switch(a[o]){case"ASCII85Decode":case"/ASCII85Decode":s=r(s),c.push("/ASCII85Encode");break;case"ASCII85Encode":case"/ASCII85Encode":s=e(s),c.push("/ASCII85Decode");break;case"ASCIIHexDecode":case"/ASCIIHexDecode":s=n(s),c.push("/ASCIIHexEncode");break;case"ASCIIHexEncode":case"/ASCIIHexEncode":s=s.split("").map((function(t){return("0"+t.charCodeAt().toString(16)).slice(-2)})).join("")+">",c.push("/ASCIIHexDecode");break;case"FlateEncode":case"/FlateEncode":s=i(s),c.push("/FlateDecode");break;default:throw new Error('The filter: "'+a[o]+'" is not implemented')}return{data:s,reverseChain:c.reverse().join(" ")}}}(M.API),
/**
   * @license
   * jsPDF fileloading PlugIn
   * Copyright (c) 2018 Aras Abbasi (aras.abbasi@gmail.com)
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){t.loadFile=function(t,e,r){return function(t,e,r){e=!1!==e,r="function"==typeof r?r:function(){};var n=void 0;try{n=function(t,e,r){var n=new XMLHttpRequest,i=0,a=function(t){var e=t.length,r=[],n=String.fromCharCode;for(i=0;i<e;i+=1)r.push(n(255&t.charCodeAt(i)));return r.join("")};if(n.open("GET",t,!e),n.overrideMimeType("text/plain; charset=x-user-defined"),!1===e&&(n.onload=function(){200===n.status?r(a(this.responseText)):r(void 0)}),n.send(null),e&&200===n.status)return a(n.responseText)}(t,e,r)}catch(t){}return n}(t,e,r)},t.loadImageFile=t.loadFile}(M.API),function(n){function i(){return(r.html2canvas?Promise.resolve(r.html2canvas):"object"===(void 0===t?"undefined":e(t))&&"undefined"!=typeof module?new Promise((function(t,e){try{t(require("html2canvas"))}catch(t){e(t)}})):"function"==typeof define&&define.amd?new Promise((function(t,e){try{require(["html2canvas"],t)}catch(t){e(t)}})):Promise.reject(new Error("Could not load html2canvas"))).catch((function(t){return Promise.reject(new Error("Could not load html2canvas: "+t))})).then((function(t){return t.default?t.default:t}))}function a(){return(r.DOMPurify?Promise.resolve(r.DOMPurify):"object"===(void 0===t?"undefined":e(t))&&"undefined"!=typeof module?new Promise((function(t,e){try{t(require("dompurify"))}catch(t){e(t)}})):"function"==typeof define&&define.amd?new Promise((function(t,e){try{require(["dompurify"],t)}catch(t){e(t)}})):Promise.reject(new Error("Could not load dompurify"))).catch((function(t){return Promise.reject(new Error("Could not load dompurify: "+t))})).then((function(t){return t.default?t.default:t}))}var o=function(t){var r=e(t);return"undefined"===r?"undefined":"string"===r||t instanceof String?"string":"number"===r||t instanceof Number?"number":"function"===r||t instanceof Function?"function":t&&t.constructor===Array?"array":t&&1===t.nodeType?"element":"object"===r?"object":"unknown"},s=function(t,e){var r=document.createElement(t);for(var n in e.className&&(r.className=e.className),e.innerHTML&&e.dompurify&&(r.innerHTML=e.dompurify.sanitize(e.innerHTML)),e.style)r.style[n]=e.style[n];return r},c=function t(e){var r=Object.assign(t.convert(Promise.resolve()),JSON.parse(JSON.stringify(t.template))),n=t.convert(Promise.resolve(),r);return n=(n=n.setProgress(1,t,1,[t])).set(e)};(c.prototype=Object.create(Promise.prototype)).constructor=c,c.convert=function(t,e){return t.__proto__=e||c.prototype,t},c.template={prop:{src:null,container:null,overlay:null,canvas:null,img:null,pdf:null,pageSize:null,callback:function(){}},progress:{val:0,state:null,n:0,stack:[]},opt:{filename:"file.pdf",margin:[0,0,0,0],enableLinks:!0,x:0,y:0,html2canvas:{},jsPDF:{},backgroundColor:"transparent"}},c.prototype.from=function(t,e){return this.then((function(){switch(e=e||function(t){switch(o(t)){case"string":return"string";case"element":return"canvas"===t.nodeName.toLowerCase()?"canvas":"element";default:return"unknown"}}(t)){case"string":return this.then(a).then((function(e){return this.set({src:s("div",{innerHTML:t,dompurify:e})})}));case"element":return this.set({src:t});case"canvas":return this.set({canvas:t});case"img":return this.set({img:t});default:return this.error("Unknown source type.")}}))},c.prototype.to=function(t){switch(t){case"container":return this.toContainer();case"canvas":return this.toCanvas();case"img":return this.toImg();case"pdf":return this.toPdf();default:return this.error("Invalid target.")}},c.prototype.toContainer=function(){return this.thenList([function(){return this.prop.src||this.error("Cannot duplicate - no source HTML.")},function(){return this.prop.pageSize||this.setPageSize()}]).then((function(){var t={position:"relative",display:"inline-block",width:("number"!=typeof this.opt.width||isNaN(this.opt.width)||"number"!=typeof this.opt.windowWidth||isNaN(this.opt.windowWidth)?Math.max(this.prop.src.clientWidth,this.prop.src.scrollWidth,this.prop.src.offsetWidth):this.opt.windowWidth)+"px",left:0,right:0,top:0,margin:"auto",backgroundColor:this.opt.backgroundColor},e=function t(e,r){for(var n=3===e.nodeType?document.createTextNode(e.nodeValue):e.cloneNode(!1),i=e.firstChild;i;i=i.nextSibling)!0!==r&&1===i.nodeType&&"SCRIPT"===i.nodeName||n.appendChild(t(i,r));return 1===e.nodeType&&("CANVAS"===e.nodeName?(n.width=e.width,n.height=e.height,n.getContext("2d").drawImage(e,0,0)):"TEXTAREA"!==e.nodeName&&"SELECT"!==e.nodeName||(n.value=e.value),n.addEventListener("load",(function(){n.scrollTop=e.scrollTop,n.scrollLeft=e.scrollLeft}),!0)),n}(this.prop.src,this.opt.html2canvas.javascriptEnabled);"BODY"===e.tagName&&(t.height=Math.max(document.body.scrollHeight,document.body.offsetHeight,document.documentElement.clientHeight,document.documentElement.scrollHeight,document.documentElement.offsetHeight)+"px"),this.prop.overlay=s("div",{className:"html2pdf__overlay",style:{position:"fixed",overflow:"hidden",zIndex:1e3,left:"-100000px",right:0,bottom:0,top:0}}),this.prop.container=s("div",{className:"html2pdf__container",style:t}),this.prop.container.appendChild(e),this.prop.container.firstChild.appendChild(s("div",{style:{clear:"both",border:"0 none transparent",margin:0,padding:0,height:0}})),this.prop.container.style.float="none",this.prop.overlay.appendChild(this.prop.container),document.body.appendChild(this.prop.overlay),this.prop.container.firstChild.style.position="relative",this.prop.container.height=Math.max(this.prop.container.firstChild.clientHeight,this.prop.container.firstChild.scrollHeight,this.prop.container.firstChild.offsetHeight)+"px"}))},c.prototype.toCanvas=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(i).then((function(t){var e=Object.assign({},this.opt.html2canvas);return delete e.onrendered,t(this.prop.container,e)})).then((function(t){(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)}))},c.prototype.toContext2d=function(){var t=[function(){return document.body.contains(this.prop.container)||this.toContainer()}];return this.thenList(t).then(i).then((function(t){var e=this.opt.jsPDF,r=this.opt.fontFaces,n="number"!=typeof this.opt.width||isNaN(this.opt.width)||"number"!=typeof this.opt.windowWidth||isNaN(this.opt.windowWidth)?1:this.opt.width/this.opt.windowWidth,i=Object.assign({async:!0,allowTaint:!0,scale:n,scrollX:this.opt.scrollX||0,scrollY:this.opt.scrollY||0,backgroundColor:"#ffffff",imageTimeout:15e3,logging:!0,proxy:null,removeContainer:!0,foreignObjectRendering:!1,useCORS:!1},this.opt.html2canvas);if(delete i.onrendered,e.context2d.autoPaging=void 0===this.opt.autoPaging||this.opt.autoPaging,e.context2d.posX=this.opt.x,e.context2d.posY=this.opt.y,e.context2d.margin=this.opt.margin,e.context2d.fontFaces=r,r)for(var a=0;a<r.length;++a){var o=r[a],s=o.src.find((function(t){return"truetype"===t.format}));s&&e.addFont(s.url,o.ref.name,o.ref.style)}return i.windowHeight=i.windowHeight||0,i.windowHeight=0==i.windowHeight?Math.max(this.prop.container.clientHeight,this.prop.container.scrollHeight,this.prop.container.offsetHeight):i.windowHeight,e.context2d.save(!0),t(this.prop.container,i)})).then((function(t){this.opt.jsPDF.context2d.restore(!0),(this.opt.html2canvas.onrendered||function(){})(t),this.prop.canvas=t,document.body.removeChild(this.prop.overlay)}))},c.prototype.toImg=function(){return this.thenList([function(){return this.prop.canvas||this.toCanvas()}]).then((function(){var t=this.prop.canvas.toDataURL("image/"+this.opt.image.type,this.opt.image.quality);this.prop.img=document.createElement("img"),this.prop.img.src=t}))},c.prototype.toPdf=function(){return this.thenList([function(){return this.toContext2d()}]).then((function(){this.prop.pdf=this.prop.pdf||this.opt.jsPDF}))},c.prototype.output=function(t,e,r){return"img"===(r=r||"pdf").toLowerCase()||"image"===r.toLowerCase()?this.outputImg(t,e):this.outputPdf(t,e)},c.prototype.outputPdf=function(t,e){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){return this.prop.pdf.output(t,e)}))},c.prototype.outputImg=function(t){return this.thenList([function(){return this.prop.img||this.toImg()}]).then((function(){switch(t){case void 0:case"img":return this.prop.img;case"datauristring":case"dataurlstring":return this.prop.img.src;case"datauri":case"dataurl":return document.location.href=this.prop.img.src;default:throw'Image output type "'+t+'" is not supported.'}}))},c.prototype.save=function(t){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).set(t?{filename:t}:null).then((function(){this.prop.pdf.save(this.opt.filename)}))},c.prototype.doCallback=function(){return this.thenList([function(){return this.prop.pdf||this.toPdf()}]).then((function(){this.prop.callback(this.prop.pdf)}))},c.prototype.set=function(t){if("object"!==o(t))return this;var e=Object.keys(t||{}).map((function(e){if(e in c.template.prop)return function(){this.prop[e]=t[e]};switch(e){case"margin":return this.setMargin.bind(this,t.margin);case"jsPDF":return function(){return this.opt.jsPDF=t.jsPDF,this.setPageSize()};case"pageSize":return this.setPageSize.bind(this,t.pageSize);default:return function(){this.opt[e]=t[e]}}}),this);return this.then((function(){return this.thenList(e)}))},c.prototype.get=function(t,e){return this.then((function(){var r=t in c.template.prop?this.prop[t]:this.opt[t];return e?e(r):r}))},c.prototype.setMargin=function(t){return this.then((function(){switch(o(t)){case"number":t=[t,t,t,t];case"array":if(2===t.length&&(t=[t[0],t[1],t[0],t[1]]),4===t.length)break;default:return this.error("Invalid margin array.")}this.opt.margin=t})).then(this.setPageSize)},c.prototype.setPageSize=function(t){function e(t,e){return Math.floor(t*e/72*96)}return this.then((function(){(t=t||M.getPageSize(this.opt.jsPDF)).hasOwnProperty("inner")||(t.inner={width:t.width-this.opt.margin[1]-this.opt.margin[3],height:t.height-this.opt.margin[0]-this.opt.margin[2]},t.inner.px={width:e(t.inner.width,t.k),height:e(t.inner.height,t.k)},t.inner.ratio=t.inner.height/t.inner.width),this.prop.pageSize=t}))},c.prototype.setProgress=function(t,e,r,n){return null!=t&&(this.progress.val=t),null!=e&&(this.progress.state=e),null!=r&&(this.progress.n=r),null!=n&&(this.progress.stack=n),this.progress.ratio=this.progress.val/this.progress.state,this},c.prototype.updateProgress=function(t,e,r,n){return this.setProgress(t?this.progress.val+t:null,e||null,r?this.progress.n+r:null,n?this.progress.stack.concat(n):null)},c.prototype.then=function(t,e){var r=this;return this.thenCore(t,e,(function(t,e){return r.updateProgress(null,null,1,[t]),Promise.prototype.then.call(this,(function(e){return r.updateProgress(null,t),e})).then(t,e).then((function(t){return r.updateProgress(1),t}))}))},c.prototype.thenCore=function(t,e,r){r=r||Promise.prototype.then;t&&(t=t.bind(this)),e&&(e=e.bind(this));var n=-1!==Promise.toString().indexOf("[native code]")&&"Promise"===Promise.name?this:c.convert(Object.assign({},this),Promise.prototype),i=r.call(n,t,e);return c.convert(i,this.__proto__)},c.prototype.thenExternal=function(t,e){return Promise.prototype.then.call(this,t,e)},c.prototype.thenList=function(t){var e=this;return t.forEach((function(t){e=e.thenCore(t)})),e},c.prototype.catch=function(t){t&&(t=t.bind(this));var e=Promise.prototype.catch.call(this,t);return c.convert(e,this)},c.prototype.catchExternal=function(t){return Promise.prototype.catch.call(this,t)},c.prototype.error=function(t){return this.then((function(){throw new Error(t)}))},c.prototype.using=c.prototype.set,c.prototype.saveAs=c.prototype.save,c.prototype.export=c.prototype.output,c.prototype.run=c.prototype.then,M.getPageSize=function(t,r,n){if("object"===e(t)){var i=t;t=i.orientation,r=i.unit||r,n=i.format||n}r=r||"mm",n=n||"a4",t=(""+(t||"P")).toLowerCase();var a,o=(""+n).toLowerCase(),s={a0:[2383.94,3370.39],a1:[1683.78,2383.94],a2:[1190.55,1683.78],a3:[841.89,1190.55],a4:[595.28,841.89],a5:[419.53,595.28],a6:[297.64,419.53],a7:[209.76,297.64],a8:[147.4,209.76],a9:[104.88,147.4],a10:[73.7,104.88],b0:[2834.65,4008.19],b1:[2004.09,2834.65],b2:[1417.32,2004.09],b3:[1000.63,1417.32],b4:[708.66,1000.63],b5:[498.9,708.66],b6:[354.33,498.9],b7:[249.45,354.33],b8:[175.75,249.45],b9:[124.72,175.75],b10:[87.87,124.72],c0:[2599.37,3676.54],c1:[1836.85,2599.37],c2:[1298.27,1836.85],c3:[918.43,1298.27],c4:[649.13,918.43],c5:[459.21,649.13],c6:[323.15,459.21],c7:[229.61,323.15],c8:[161.57,229.61],c9:[113.39,161.57],c10:[79.37,113.39],dl:[311.81,623.62],letter:[612,792],"government-letter":[576,756],legal:[612,1008],"junior-legal":[576,360],ledger:[1224,792],tabloid:[792,1224],"credit-card":[153,243]};switch(r){case"pt":a=1;break;case"mm":a=72/25.4;break;case"cm":a=72/2.54;break;case"in":a=72;break;case"px":a=.75;break;case"pc":case"em":a=12;break;case"ex":a=6;break;default:throw"Invalid unit: "+r}var c,u=0,l=0;if(s.hasOwnProperty(o))u=s[o][1]/a,l=s[o][0]/a;else try{u=n[1],l=n[0]}catch(t){throw new Error("Invalid format: "+n)}if("p"===t||"portrait"===t)t="p",l>u&&(c=l,l=u,u=c);else{if("l"!==t&&"landscape"!==t)throw"Invalid orientation: "+t;t="l",u>l&&(c=l,l=u,u=c)}return{width:l,height:u,unit:r,k:a,orientation:t}},n.html=function(t,e){(e=e||{}).callback=e.callback||function(){},e.html2canvas=e.html2canvas||{},e.html2canvas.canvas=e.html2canvas.canvas||this.canvas,e.jsPDF=e.jsPDF||this,e.fontFaces=e.fontFaces?e.fontFaces.map(Ct):null;var r=new c(e);return e.worker?r:r.from(t).doCallback()}}(M.API),
/**
   * @license
   * ====================================================================
   * Copyright (c) 2013 Youssef Beddad, youssef.beddad@gmail.com
   *
   * Permission is hereby granted, free of charge, to any person obtaining
   * a copy of this software and associated documentation files (the
   * "Software"), to deal in the Software without restriction, including
   * without limitation the rights to use, copy, modify, merge, publish,
   * distribute, sublicense, and/or sell copies of the Software, and to
   * permit persons to whom the Software is furnished to do so, subject to
   * the following conditions:
   *
   * The above copyright notice and this permission notice shall be
   * included in all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
   * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
   * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
   * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
   * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
   * ====================================================================
   */
function(t){var e,r,n;t.addJS=function(t){return n=t,this.internal.events.subscribe("postPutResources",(function(){e=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/Names [(EmbeddedJS) "+(e+1)+" 0 R]"),this.internal.out(">>"),this.internal.out("endobj"),r=this.internal.newObject(),this.internal.out("<<"),this.internal.out("/S /JavaScript"),this.internal.out("/JS ("+n+")"),this.internal.out(">>"),this.internal.out("endobj")})),this.internal.events.subscribe("putCatalog",(function(){void 0!==e&&void 0!==r&&this.internal.out("/Names <</JavaScript "+e+" 0 R>>")})),this}}(M.API),
/**
   * @license
   * Copyright (c) 2014 Steven Spungin (TwelveTone LLC)  steven@twelvetone.tv
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var e;t.events.push(["postPutResources",function(){var t=this,r=/^(\d+) 0 obj$/;if(this.outline.root.children.length>0)for(var n=t.outline.render().split(/\r\n/),i=0;i<n.length;i++){var a=n[i],o=r.exec(a);if(null!=o){var s=o[1];t.internal.newObjectDeferredBegin(s,!1)}t.internal.write(a)}if(this.outline.createNamedDestinations){var c=this.internal.pages.length,u=[];for(i=0;i<c;i++){var l=t.internal.newObject();u.push(l);var h=t.internal.getPageInfo(i+1);t.internal.write("<< /D["+h.objId+" 0 R /XYZ null null null]>> endobj")}var f=t.internal.newObject();t.internal.write("<< /Names [ ");for(i=0;i<u.length;i++)t.internal.write("(page_"+(i+1)+")"+u[i]+" 0 R");t.internal.write(" ] >>","endobj"),e=t.internal.newObject(),t.internal.write("<< /Dests "+f+" 0 R"),t.internal.write(">>","endobj")}}]),t.events.push(["putCatalog",function(){this.outline.root.children.length>0&&(this.internal.write("/Outlines",this.outline.makeRef(this.outline.root)),this.outline.createNamedDestinations&&this.internal.write("/Names "+e+" 0 R"))}]),t.events.push(["initialized",function(){var t=this;t.outline={createNamedDestinations:!1,root:{children:[]}},t.outline.add=function(t,e,r){var n={title:e,options:r,children:[]};return null==t&&(t=this.root),t.children.push(n),n},t.outline.render=function(){return this.ctx={},this.ctx.val="",this.ctx.pdf=t,this.genIds_r(this.root),this.renderRoot(this.root),this.renderItems(this.root),this.ctx.val},t.outline.genIds_r=function(e){e.id=t.internal.newObjectDeferred();for(var r=0;r<e.children.length;r++)this.genIds_r(e.children[r])},t.outline.renderRoot=function(t){this.objStart(t),this.line("/Type /Outlines"),t.children.length>0&&(this.line("/First "+this.makeRef(t.children[0])),this.line("/Last "+this.makeRef(t.children[t.children.length-1]))),this.line("/Count "+this.count_r({count:0},t)),this.objEnd()},t.outline.renderItems=function(e){for(var r=this.ctx.pdf.internal.getVerticalCoordinateString,n=0;n<e.children.length;n++){var i=e.children[n];this.objStart(i),this.line("/Title "+this.makeString(i.title)),this.line("/Parent "+this.makeRef(e)),n>0&&this.line("/Prev "+this.makeRef(e.children[n-1])),n<e.children.length-1&&this.line("/Next "+this.makeRef(e.children[n+1])),i.children.length>0&&(this.line("/First "+this.makeRef(i.children[0])),this.line("/Last "+this.makeRef(i.children[i.children.length-1])));var a=this.count=this.count_r({count:0},i);if(a>0&&this.line("/Count "+a),i.options&&i.options.pageNumber){var o=t.internal.getPageInfo(i.options.pageNumber);this.line("/Dest ["+o.objId+" 0 R /XYZ 0 "+r(0)+" 0]")}this.objEnd()}for(var s=0;s<e.children.length;s++)this.renderItems(e.children[s])},t.outline.line=function(t){this.ctx.val+=t+"\r\n"},t.outline.makeRef=function(t){return t.id+" 0 R"},t.outline.makeString=function(e){return"("+t.internal.pdfEscape(e)+")"},t.outline.objStart=function(t){this.ctx.val+="\r\n"+t.id+" 0 obj\r\n<<\r\n"},t.outline.objEnd=function(){this.ctx.val+=">> \r\nendobj\r\n"},t.outline.count_r=function(t,e){for(var r=0;r<e.children.length;r++)t.count++,this.count_r(t,e.children[r]);return t.count}}])}(M.API),
/**
   * @license
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var e=[192,193,194,195,196,197,198,199];t.processJPEG=function(t,r,n,i,a,o){var s,c=this.decode.DCT_DECODE,u=null;if("string"==typeof t||this.__addimage__.isArrayBuffer(t)||this.__addimage__.isArrayBufferView(t)){switch(t=a||t,t=this.__addimage__.isArrayBuffer(t)?new Uint8Array(t):t,(s=function(t){for(var r,n=256*t.charCodeAt(4)+t.charCodeAt(5),i=t.length,a={width:0,height:0,numcomponents:1},o=4;o<i;o+=2){if(o+=n,-1!==e.indexOf(t.charCodeAt(o+1))){r=256*t.charCodeAt(o+5)+t.charCodeAt(o+6),a={width:256*t.charCodeAt(o+7)+t.charCodeAt(o+8),height:r,numcomponents:t.charCodeAt(o+9)};break}n=256*t.charCodeAt(o+2)+t.charCodeAt(o+3)}return a}(t=this.__addimage__.isArrayBufferView(t)?this.__addimage__.arrayBufferToBinaryString(t):t)).numcomponents){case 1:o=this.color_spaces.DEVICE_GRAY;break;case 4:o=this.color_spaces.DEVICE_CMYK;break;case 3:o=this.color_spaces.DEVICE_RGB}u={data:t,width:s.width,height:s.height,colorSpace:o,bitsPerComponent:8,filter:c,index:r,alias:n}}return u}}(M.API);var Oe,Be,Me,Ee,qe,De=function(){var t,e,n;function i(t){var e,r,n,i,a,o,s,c,u,l,h,f,d,p;for(this.data=t,this.pos=8,this.palette=[],this.imgData=[],this.transparency={},this.animation=null,this.text={},o=null;;){switch(e=this.readUInt32(),u=function(){var t,e;for(e=[],t=0;t<4;++t)e.push(String.fromCharCode(this.data[this.pos++]));return e}.call(this).join("")){case"IHDR":this.width=this.readUInt32(),this.height=this.readUInt32(),this.bits=this.data[this.pos++],this.colorType=this.data[this.pos++],this.compressionMethod=this.data[this.pos++],this.filterMethod=this.data[this.pos++],this.interlaceMethod=this.data[this.pos++];break;case"acTL":this.animation={numFrames:this.readUInt32(),numPlays:this.readUInt32()||1/0,frames:[]};break;case"PLTE":this.palette=this.read(e);break;case"fcTL":o&&this.animation.frames.push(o),this.pos+=4,o={width:this.readUInt32(),height:this.readUInt32(),xOffset:this.readUInt32(),yOffset:this.readUInt32()},a=this.readUInt16(),i=this.readUInt16()||100,o.delay=1e3*a/i,o.disposeOp=this.data[this.pos++],o.blendOp=this.data[this.pos++],o.data=[];break;case"IDAT":case"fdAT":for("fdAT"===u&&(this.pos+=4,e-=4),t=(null!=o?o.data:void 0)||this.imgData,f=0;0<=e?f<e:f>e;0<=e?++f:--f)t.push(this.data[this.pos++]);break;case"tRNS":switch(this.transparency={},this.colorType){case 3:if(n=this.palette.length/3,this.transparency.indexed=this.read(e),this.transparency.indexed.length>n)throw new Error("More transparent colors than palette size");if((l=n-this.transparency.indexed.length)>0)for(d=0;0<=l?d<l:d>l;0<=l?++d:--d)this.transparency.indexed.push(255);break;case 0:this.transparency.grayscale=this.read(e)[0];break;case 2:this.transparency.rgb=this.read(e)}break;case"tEXt":s=(h=this.read(e)).indexOf(0),c=String.fromCharCode.apply(String,h.slice(0,s)),this.text[c]=String.fromCharCode.apply(String,h.slice(s+1));break;case"IEND":return o&&this.animation.frames.push(o),this.colors=function(){switch(this.colorType){case 0:case 3:case 4:return 1;case 2:case 6:return 3}}.call(this),this.hasAlphaChannel=4===(p=this.colorType)||6===p,r=this.colors+(this.hasAlphaChannel?1:0),this.pixelBitlength=this.bits*r,this.colorSpace=function(){switch(this.colors){case 1:return"DeviceGray";case 3:return"DeviceRGB"}}.call(this),void(this.imgData=new Uint8Array(this.imgData));default:this.pos+=e}if(this.pos+=4,this.pos>this.data.length)throw new Error("Incomplete or corrupt PNG file")}}i.prototype.read=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;0<=t?++e:--e)r.push(this.data[this.pos++]);return r},i.prototype.readUInt32=function(){return this.data[this.pos++]<<24|this.data[this.pos++]<<16|this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.readUInt16=function(){return this.data[this.pos++]<<8|this.data[this.pos++]},i.prototype.decodePixels=function(t){var e=this.pixelBitlength/8,r=new Uint8Array(this.width*this.height*e),n=0,i=this;if(null==t&&(t=this.imgData),0===t.length)return new Uint8Array(0);function a(a,o,s,c){var u,l,h,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,F,I=Math.ceil((i.width-a)/s),C=Math.ceil((i.height-o)/c),j=i.width==I&&i.height==C;for(L=e*I,w=j?r:new Uint8Array(L*C),p=t.length,N=0,l=0;N<C&&n<p;){switch(t[n++]){case 0:for(f=S=0;S<L;f=S+=1)w[l++]=t[n++];break;case 1:for(f=_=0;_<L;f=_+=1)u=t[n++],d=f<e?0:w[l-e],w[l++]=(u+d)%256;break;case 2:for(f=P=0;P<L;f=P+=1)u=t[n++],h=(f-f%e)/e,A=N&&w[(N-1)*L+h*e+f%e],w[l++]=(A+u)%256;break;case 3:for(f=k=0;k<L;f=k+=1)u=t[n++],h=(f-f%e)/e,d=f<e?0:w[l-e],A=N&&w[(N-1)*L+h*e+f%e],w[l++]=(u+Math.floor((d+A)/2))%256;break;case 4:for(f=F=0;F<L;f=F+=1)u=t[n++],h=(f-f%e)/e,d=f<e?0:w[l-e],0===N?A=x=0:(A=w[(N-1)*L+h*e+f%e],x=h&&w[(N-1)*L+(h-1)*e+f%e]),g=d+A-x,m=Math.abs(g-d),b=Math.abs(g-A),y=Math.abs(g-x),v=m<=b&&m<=y?d:b<=y?A:x,w[l++]=(u+v)%256;break;default:throw new Error("Invalid filter algorithm: "+t[n-1])}if(!j){var O=((o+N*c)*i.width+a)*e,B=N*L;for(f=0;f<I;f+=1){for(var M=0;M<e;M+=1)r[O++]=w[B++];O+=(s-1)*e}}N++}}return t=Ce(t),1==i.interlaceMethod?(a(0,0,8,8),a(4,0,8,8),a(0,4,4,8),a(2,0,4,4),a(0,2,2,4),a(1,0,2,2),a(0,1,1,2)):a(0,0,1,1),r},i.prototype.decodePalette=function(){var t,e,r,n,i,a,o,s,c;for(r=this.palette,a=this.transparency.indexed||[],i=new Uint8Array((a.length||0)+r.length),n=0,t=0,e=o=0,s=r.length;o<s;e=o+=3)i[n++]=r[e],i[n++]=r[e+1],i[n++]=r[e+2],i[n++]=null!=(c=a[t++])?c:255;return i},i.prototype.copyToImageData=function(t,e){var r,n,i,a,o,s,c,u,l,h,f;if(n=this.colors,l=null,r=this.hasAlphaChannel,this.palette.length&&(l=null!=(f=this._decodedPalette)?f:this._decodedPalette=this.decodePalette(),n=4,r=!0),u=(i=t.data||t).length,o=l||e,a=s=0,1===n)for(;a<u;)c=l?4*e[a/4]:s,h=o[c++],i[a++]=h,i[a++]=h,i[a++]=h,i[a++]=r?o[c++]:255,s=c;else for(;a<u;)c=l?4*e[a/4]:s,i[a++]=o[c++],i[a++]=o[c++],i[a++]=o[c++],i[a++]=r?o[c++]:255,s=c},i.prototype.decode=function(){var t;return t=new Uint8Array(this.width*this.height*4),this.copyToImageData(t,this.decodePixels()),t};var a=function(){if("[object Window]"===Object.prototype.toString.call(r)){try{e=r.document.createElement("canvas"),n=e.getContext("2d")}catch(t){return!1}return!0}return!1};return a(),t=function(t){var r;if(!0===a())return n.width=t.width,n.height=t.height,n.clearRect(0,0,t.width,t.height),n.putImageData(t,0,0),(r=new Image).src=e.toDataURL(),r;throw new Error("This method requires a Browser with Canvas-capability.")},i.prototype.decodeFrames=function(e){var r,n,i,a,o,s,c,u;if(this.animation){for(u=[],n=o=0,s=(c=this.animation.frames).length;o<s;n=++o)r=c[n],i=e.createImageData(r.width,r.height),a=this.decodePixels(new Uint8Array(r.data)),this.copyToImageData(i,a),r.imageData=i,u.push(r.image=t(i));return u}},i.prototype.renderFrame=function(t,e){var r,n,i;return r=(n=this.animation.frames)[e],i=n[e-1],0===e&&t.clearRect(0,0,this.width,this.height),1===(null!=i?i.disposeOp:void 0)?t.clearRect(i.xOffset,i.yOffset,i.width,i.height):2===(null!=i?i.disposeOp:void 0)&&t.putImageData(i.imageData,i.xOffset,i.yOffset),0===r.blendOp&&t.clearRect(r.xOffset,r.yOffset,r.width,r.height),t.drawImage(r.image,r.xOffset,r.yOffset)},i.prototype.animate=function(t){var e,r,n,i,a,o,s=this;return r=0,o=this.animation,i=o.numFrames,n=o.frames,a=o.numPlays,(e=function(){var o,c;if(o=r++%i,c=n[o],s.renderFrame(t,o),i>1&&r/i<a)return s.animation._timeout=setTimeout(e,c.delay)})()},i.prototype.stopAnimation=function(){var t;return clearTimeout(null!=(t=this.animation)?t._timeout:void 0)},i.prototype.render=function(t){var e,r;return t._png&&t._png.stopAnimation(),t._png=this,t.width=this.width,t.height=this.height,e=t.getContext("2d"),this.animation?(this.decodeFrames(e),this.animate(e)):(r=e.createImageData(this.width,this.height),this.copyToImageData(r,this.decodePixels()),e.putImageData(r,0,0))},i}();
/**
   * @license
   *
   * Copyright (c) 2014 James Robb, https://github.com/jamesbrobb
   *
   * Permission is hereby granted, free of charge, to any person obtaining
   * a copy of this software and associated documentation files (the
   * "Software"), to deal in the Software without restriction, including
   * without limitation the rights to use, copy, modify, merge, publish,
   * distribute, sublicense, and/or sell copies of the Software, and to
   * permit persons to whom the Software is furnished to do so, subject to
   * the following conditions:
   *
   * The above copyright notice and this permission notice shall be
   * included in all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
   * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
   * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
   * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
   * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
   * ====================================================================
   */
/**
   * @license
   * (c) Dean McNamee <dean@gmail.com>, 2013.
   *
   * https://github.com/deanm/omggif
   *
   * Permission is hereby granted, free of charge, to any person obtaining a copy
   * of this software and associated documentation files (the "Software"), to
   * deal in the Software without restriction, including without limitation the
   * rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
   * sell copies of the Software, and to permit persons to whom the Software is
   * furnished to do so, subject to the following conditions:
   *
   * The above copyright notice and this permission notice shall be included in
   * all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
   * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
   * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
   * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
   * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
   * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
   * IN THE SOFTWARE.
   *
   * omggif is a JavaScript implementation of a GIF 89a encoder and decoder,
   * including animation and compression.  It does not rely on any specific
   * underlying system, so should run in the browser, Node, or Plask.
   */
function Re(t){var e=0;if(71!==t[e++]||73!==t[e++]||70!==t[e++]||56!==t[e++]||56!=(t[e++]+1&253)||97!==t[e++])throw new Error("Invalid GIF 87a/89a header.");var r=t[e++]|t[e++]<<8,n=t[e++]|t[e++]<<8,i=t[e++],a=i>>7,o=1<<(7&i)+1;t[e++];t[e++];var s=null,c=null;a&&(s=e,c=o,e+=3*o);var u=!0,l=[],h=0,f=null,d=0,p=null;for(this.width=r,this.height=n;u&&e<t.length;)switch(t[e++]){case 33:switch(t[e++]){case 255:if(11!==t[e]||78==t[e+1]&&69==t[e+2]&&84==t[e+3]&&83==t[e+4]&&67==t[e+5]&&65==t[e+6]&&80==t[e+7]&&69==t[e+8]&&50==t[e+9]&&46==t[e+10]&&48==t[e+11]&&3==t[e+12]&&1==t[e+13]&&0==t[e+16])e+=14,p=t[e++]|t[e++]<<8,e++;else for(e+=12;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}break;case 249:if(4!==t[e++]||0!==t[e+4])throw new Error("Invalid graphics extension block.");var g=t[e++];h=t[e++]|t[e++]<<8,f=t[e++],0==(1&g)&&(f=null),d=g>>2&7,e++;break;case 254:for(;;){if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}break;default:throw new Error("Unknown graphic control label: 0x"+t[e-1].toString(16))}break;case 44:var m=t[e++]|t[e++]<<8,v=t[e++]|t[e++]<<8,b=t[e++]|t[e++]<<8,y=t[e++]|t[e++]<<8,w=t[e++],N=w>>6&1,L=1<<(7&w)+1,A=s,x=c,S=!1;if(w>>7){S=!0;A=e,x=L,e+=3*L}var _=e;for(e++;;){var P;if(!((P=t[e++])>=0))throw Error("Invalid block size");if(0===P)break;e+=P}l.push({x:m,y:v,width:b,height:y,has_local_palette:S,palette_offset:A,palette_size:x,data_offset:_,data_length:e-_,transparent_index:f,interlaced:!!N,delay:h,disposal:d});break;case 59:u=!1;break;default:throw new Error("Unknown gif block: 0x"+t[e-1].toString(16))}this.numFrames=function(){return l.length},this.loopCount=function(){return p},this.frameInfo=function(t){if(t<0||t>=l.length)throw new Error("Frame index out of range.");return l[t]},this.decodeAndBlitFrameBGRA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);Te(t,i.data_offset,o,a);var s=i.palette_offset,c=i.transparent_index;null===c&&(c=256);var u=i.width,l=r-u,h=u,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*l;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===h&&(h=u,(p+=g)>=d&&(g=4*l+4*r*(m-1),p=f+(u+l)*(m<<1),m>>=1)),y===c)p+=4;else{var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=L,n[p++]=N,n[p++]=w,n[p++]=255}--h}},this.decodeAndBlitFrameRGBA=function(e,n){var i=this.frameInfo(e),a=i.width*i.height,o=new Uint8Array(a);Te(t,i.data_offset,o,a);var s=i.palette_offset,c=i.transparent_index;null===c&&(c=256);var u=i.width,l=r-u,h=u,f=4*(i.y*r+i.x),d=4*((i.y+i.height)*r+i.x),p=f,g=4*l;!0===i.interlaced&&(g+=4*r*7);for(var m=8,v=0,b=o.length;v<b;++v){var y=o[v];if(0===h&&(h=u,(p+=g)>=d&&(g=4*l+4*r*(m-1),p=f+(u+l)*(m<<1),m>>=1)),y===c)p+=4;else{var w=t[s+3*y],N=t[s+3*y+1],L=t[s+3*y+2];n[p++]=w,n[p++]=N,n[p++]=L,n[p++]=255}--h}}}function Te(t,e,r,n){for(var a=t[e++],o=1<<a,s=o+1,c=s+1,u=a+1,l=(1<<u)-1,h=0,f=0,d=0,p=t[e++],g=new Int32Array(4096),m=null;;){for(;h<16&&0!==p;)f|=t[e++]<<h,h+=8,1===p?p=t[e++]:--p;if(h<u)break;var v=f&l;if(f>>=u,h-=u,v!==o){if(v===s)break;for(var b=v<c?v:m,y=0,w=b;w>o;)w=g[w]>>8,++y;var N=w;if(d+y+(b!==v?1:0)>n)return void i.log("Warning, gif stream longer than expected.");r[d++]=N;var L=d+=y;for(b!==v&&(r[d++]=N),w=b;y--;)w=g[w],r[--L]=255&w,w>>=8;null!==m&&c<4096&&(g[c++]=m<<8|N,c>=l+1&&u<12&&(++u,l=l<<1|1)),m=v}else c=s+1,l=(1<<(u=a+1))-1,m=null}return d!==n&&i.log("Warning, gif stream shorter than expected."),r}
/**
   * @license
    Copyright (c) 2008, Adobe Systems Incorporated
    All rights reserved.

    Redistribution and use in source and binary forms, with or without 
    modification, are permitted provided that the following conditions are
    met:

    * Redistributions of source code must retain the above copyright notice, 
      this list of conditions and the following disclaimer.
    
    * Redistributions in binary form must reproduce the above copyright
      notice, this list of conditions and the following disclaimer in the 
      documentation and/or other materials provided with the distribution.
    
    * Neither the name of Adobe Systems Incorporated nor the names of its 
      contributors may be used to endorse or promote products derived from 
      this software without specific prior written permission.

    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
    IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
    THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
    PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
    CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
    EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
    PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
    PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
    LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
    NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
    SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
  */function Ue(t){var e,r,n,i,a,o=Math.floor,s=new Array(64),c=new Array(64),u=new Array(64),l=new Array(64),h=new Array(65535),f=new Array(65535),d=new Array(64),p=new Array(64),g=[],m=0,v=7,b=new Array(64),y=new Array(64),w=new Array(64),N=new Array(256),L=new Array(2048),A=[0,1,5,6,14,15,27,28,2,4,7,13,16,26,29,42,3,8,12,17,25,30,41,43,9,11,18,24,31,40,44,53,10,19,23,32,39,45,52,54,20,22,33,38,46,51,55,60,21,34,37,47,50,56,59,61,35,36,48,49,57,58,62,63],x=[0,0,1,5,1,1,1,1,1,1,0,0,0,0,0,0,0],S=[0,1,2,3,4,5,6,7,8,9,10,11],_=[0,0,2,1,3,3,2,4,3,5,5,4,4,0,0,1,125],P=[1,2,3,0,4,17,5,18,33,49,65,6,19,81,97,7,34,113,20,50,129,145,161,8,35,66,177,193,21,82,209,240,36,51,98,114,130,9,10,22,23,24,25,26,37,38,39,40,41,42,52,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,225,226,227,228,229,230,231,232,233,234,241,242,243,244,245,246,247,248,249,250],k=[0,0,3,1,1,1,1,1,1,1,1,1,0,0,0,0,0],F=[0,1,2,3,4,5,6,7,8,9,10,11],I=[0,0,2,1,2,4,4,3,4,7,5,4,4,0,1,2,119],C=[0,1,2,3,17,4,5,33,49,6,18,65,81,7,97,113,19,34,50,129,8,20,66,145,161,177,193,9,35,51,82,240,21,98,114,209,10,22,36,52,225,37,241,23,24,25,26,38,39,40,41,42,53,54,55,56,57,58,67,68,69,70,71,72,73,74,83,84,85,86,87,88,89,90,99,100,101,102,103,104,105,106,115,116,117,118,119,120,121,122,130,131,132,133,134,135,136,137,138,146,147,148,149,150,151,152,153,154,162,163,164,165,166,167,168,169,170,178,179,180,181,182,183,184,185,186,194,195,196,197,198,199,200,201,202,210,211,212,213,214,215,216,217,218,226,227,228,229,230,231,232,233,234,242,243,244,245,246,247,248,249,250];function j(t,e){for(var r=0,n=0,i=new Array,a=1;a<=16;a++){for(var o=1;o<=t[a];o++)i[e[n]]=[],i[e[n]][0]=r,i[e[n]][1]=a,n++,r++;r*=2}return i}function O(t){for(var e=t[0],r=t[1]-1;r>=0;)e&1<<r&&(m|=1<<v),r--,--v<0&&(255==m?(B(255),B(0)):B(m),v=7,m=0)}function B(t){g.push(t)}function M(t){B(t>>8&255),B(255&t)}function E(t,e,r,n,i){for(var a,o=i[0],s=i[240],c=function(t,e){var r,n,i,a,o,s,c,u,l,h,f=0;for(l=0;l<8;++l){r=t[f],n=t[f+1],i=t[f+2],a=t[f+3],o=t[f+4],s=t[f+5],c=t[f+6];var p=r+(u=t[f+7]),g=r-u,m=n+c,v=n-c,b=i+s,y=i-s,w=a+o,N=a-o,L=p+w,A=p-w,x=m+b,S=m-b;t[f]=L+x,t[f+4]=L-x;var _=.707106781*(S+A);t[f+2]=A+_,t[f+6]=A-_;var P=.382683433*((L=N+y)-(S=v+g)),k=.5411961*L+P,F=1.306562965*S+P,I=.707106781*(x=y+v),C=g+I,j=g-I;t[f+5]=j+k,t[f+3]=j-k,t[f+1]=C+F,t[f+7]=C-F,f+=8}for(f=0,l=0;l<8;++l){r=t[f],n=t[f+8],i=t[f+16],a=t[f+24],o=t[f+32],s=t[f+40],c=t[f+48];var O=r+(u=t[f+56]),B=r-u,M=n+c,E=n-c,q=i+s,D=i-s,R=a+o,T=a-o,U=O+R,z=O-R,H=M+q,W=M-q;t[f]=U+H,t[f+32]=U-H;var V=.707106781*(W+z);t[f+16]=z+V,t[f+48]=z-V;var G=.382683433*((U=T+D)-(W=E+B)),Y=.5411961*U+G,J=1.306562965*W+G,X=.707106781*(H=D+E),K=B+X,Z=B-X;t[f+40]=Z+Y,t[f+24]=Z-Y,t[f+8]=K+J,t[f+56]=K-J,f++}for(l=0;l<64;++l)h=t[l]*e[l],d[l]=h>0?h+.5|0:h-.5|0;return d}(t,e),u=0;u<64;++u)p[A[u]]=c[u];var l=p[0]-r;r=p[0],0==l?O(n[0]):(O(n[f[a=32767+l]]),O(h[a]));for(var g=63;g>0&&0==p[g];)g--;if(0==g)return O(o),r;for(var m,v=1;v<=g;){for(var b=v;0==p[v]&&v<=g;)++v;var y=v-b;if(y>=16){m=y>>4;for(var w=1;w<=m;++w)O(s);y&=15}a=32767+p[v],O(i[(y<<4)+f[a]]),O(h[a]),v++}return 63!=g&&O(o),r}function q(t){(t=Math.min(Math.max(t,1),100),a!=t)&&(!function(t){for(var e=[16,11,10,16,24,40,51,61,12,12,14,19,26,58,60,55,14,13,16,24,40,57,69,56,14,17,22,29,51,87,80,62,18,22,37,56,68,109,103,77,24,35,55,64,81,104,113,92,49,64,78,87,103,121,120,101,72,92,95,98,112,100,103,99],r=0;r<64;r++){var n=o((e[r]*t+50)/100);n=Math.min(Math.max(n,1),255),s[A[r]]=n}for(var i=[17,18,24,47,99,99,99,99,18,21,26,66,99,99,99,99,24,26,56,99,99,99,99,99,47,66,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99,99],a=0;a<64;a++){var h=o((i[a]*t+50)/100);h=Math.min(Math.max(h,1),255),c[A[a]]=h}for(var f=[1,1.387039845,1.306562965,1.175875602,1,.785694958,.5411961,.275899379],d=0,p=0;p<8;p++)for(var g=0;g<8;g++)u[d]=1/(s[A[d]]*f[p]*f[g]*8),l[d]=1/(c[A[d]]*f[p]*f[g]*8),d++}(t<50?Math.floor(5e3/t):Math.floor(200-2*t)),a=t)}this.encode=function(t,a){a&&q(a),g=new Array,m=0,v=7,M(65496),M(65504),M(16),B(74),B(70),B(73),B(70),B(0),B(1),B(1),B(0),M(1),M(1),B(0),B(0),function(){M(65499),M(132),B(0);for(var t=0;t<64;t++)B(s[t]);B(1);for(var e=0;e<64;e++)B(c[e])}(),function(t,e){M(65472),M(17),B(8),M(e),M(t),B(3),B(1),B(17),B(0),B(2),B(17),B(1),B(3),B(17),B(1)}(t.width,t.height),function(){M(65476),M(418),B(0);for(var t=0;t<16;t++)B(x[t+1]);for(var e=0;e<=11;e++)B(S[e]);B(16);for(var r=0;r<16;r++)B(_[r+1]);for(var n=0;n<=161;n++)B(P[n]);B(1);for(var i=0;i<16;i++)B(k[i+1]);for(var a=0;a<=11;a++)B(F[a]);B(17);for(var o=0;o<16;o++)B(I[o+1]);for(var s=0;s<=161;s++)B(C[s])}(),M(65498),M(12),B(3),B(1),B(0),B(2),B(17),B(3),B(17),B(0),B(63),B(0);var o=0,h=0,f=0;m=0,v=7,this.encode.displayName="_encode_";for(var d,p,N,A,j,D,R,T,U,z=t.data,H=t.width,W=t.height,V=4*H,G=0;G<W;){for(d=0;d<V;){for(j=V*G+d,R=-1,T=0,U=0;U<64;U++)D=j+(T=U>>3)*V+(R=4*(7&U)),G+T>=W&&(D-=V*(G+1+T-W)),d+R>=V&&(D-=d+R-V+4),p=z[D++],N=z[D++],A=z[D++],b[U]=(L[p]+L[N+256>>0]+L[A+512>>0]>>16)-128,y[U]=(L[p+768>>0]+L[N+1024>>0]+L[A+1280>>0]>>16)-128,w[U]=(L[p+1280>>0]+L[N+1536>>0]+L[A+1792>>0]>>16)-128;o=E(b,u,o,e,n),h=E(y,l,h,r,i),f=E(w,l,f,r,i),d+=32}G+=8}if(v>=0){var Y=[];Y[1]=v+1,Y[0]=(1<<v+1)-1,O(Y)}return M(65497),new Uint8Array(g)},t=t||50,function(){for(var t=String.fromCharCode,e=0;e<256;e++)N[e]=t(e)}(),e=j(x,S),r=j(k,F),n=j(_,P),i=j(I,C),function(){for(var t=1,e=2,r=1;r<=15;r++){for(var n=t;n<e;n++)f[32767+n]=r,h[32767+n]=[],h[32767+n][1]=r,h[32767+n][0]=n;for(var i=-(e-1);i<=-t;i++)f[32767+i]=r,h[32767+i]=[],h[32767+i][1]=r,h[32767+i][0]=e-1+i;t<<=1,e<<=1}}(),function(){for(var t=0;t<256;t++)L[t]=19595*t,L[t+256>>0]=38470*t,L[t+512>>0]=7471*t+32768,L[t+768>>0]=-11059*t,L[t+1024>>0]=-21709*t,L[t+1280>>0]=32768*t+8421375,L[t+1536>>0]=-27439*t,L[t+1792>>0]=-5329*t}(),q(t)}
/**
   * @license
   * Copyright (c) 2017 Aras Abbasi
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */function ze(t,e){if(this.pos=0,this.buffer=t,this.datav=new DataView(t.buffer),this.is_with_alpha=!!e,this.bottom_up=!0,this.flag=String.fromCharCode(this.buffer[0])+String.fromCharCode(this.buffer[1]),this.pos+=2,-1===["BM","BA","CI","CP","IC","PT"].indexOf(this.flag))throw new Error("Invalid BMP File");this.parseHeader(),this.parseBGR()}function He(t){function e(t){if(!t)throw Error("assert :P")}function r(t,e,r){for(var n=0;4>n;n++)if(t[e+n]!=r.charCodeAt(n))return!0;return!1}function n(t,e,r,n,i){for(var a=0;a<i;a++)t[e+a]=r[n+a]}function i(t,e,r,n){for(var i=0;i<n;i++)t[e+i]=r}function a(t){return new Int32Array(t)}function o(t,e){for(var r=[],n=0;n<t;n++)r.push(new e);return r}function s(t,e){var r=[];return function t(r,n,i){for(var a=i[n],o=0;o<a&&(r.push(i.length>n+1?[]:new e),!(i.length<n+1));o++)t(r[o],n+1,i)}(r,0,t),r}var c=function(){var t=this;function c(t,e){for(var r=1<<e-1>>>0;t&r;)r>>>=1;return r?(t&r-1)+r:t}function u(t,r,n,i,a){e(!(i%n));do{t[r+(i-=n)]=a}while(0<i)}function l(t,r,n,i,o){if(e(2328>=o),512>=o)var s=a(512);else if(null==(s=a(o)))return 0;return function(t,r,n,i,o,s){var l,f,d=r,p=1<<n,g=a(16),m=a(16);for(e(0!=o),e(null!=i),e(null!=t),e(0<n),f=0;f<o;++f){if(15<i[f])return 0;++g[i[f]]}if(g[0]==o)return 0;for(m[1]=0,l=1;15>l;++l){if(g[l]>1<<l)return 0;m[l+1]=m[l]+g[l]}for(f=0;f<o;++f)l=i[f],0<i[f]&&(s[m[l]++]=f);if(1==m[15])return(i=new h).g=0,i.value=s[0],u(t,d,1,p,i),p;var v,b=-1,y=p-1,w=0,N=1,L=1,A=1<<n;for(f=0,l=1,o=2;l<=n;++l,o<<=1){if(N+=L<<=1,0>(L-=g[l]))return 0;for(;0<g[l];--g[l])(i=new h).g=l,i.value=s[f++],u(t,d+w,o,A,i),w=c(w,l)}for(l=n+1,o=2;15>=l;++l,o<<=1){if(N+=L<<=1,0>(L-=g[l]))return 0;for(;0<g[l];--g[l]){if(i=new h,(w&y)!=b){for(d+=A,v=1<<(b=l)-n;15>b&&!(0>=(v-=g[b]));)++b,v<<=1;p+=A=1<<(v=b-n),t[r+(b=w&y)].g=v+n,t[r+b].value=d-r-b}i.g=l-n,i.value=s[f++],u(t,d+(w>>n),o,A,i),w=c(w,l)}}return N!=2*m[15]-1?0:p}(t,r,n,i,o,s)}function h(){this.value=this.g=0}function f(){this.value=this.g=0}function d(){this.G=o(5,h),this.H=a(5),this.jc=this.Qb=this.qb=this.nd=0,this.pd=o(Dr,f)}function p(t,r,n,i){e(null!=t),e(null!=r),e(2147483648>i),t.Ca=254,t.I=0,t.b=-8,t.Ka=0,t.oa=r,t.pa=n,t.Jd=r,t.Yc=n+i,t.Zc=4<=i?n+i-4+1:n,_(t)}function g(t,e){for(var r=0;0<e--;)r|=k(t,128)<<e;return r}function m(t,e){var r=g(t,e);return P(t)?-r:r}function v(t,r,n,i){var a,o=0;for(e(null!=t),e(null!=r),e(4294967288>i),t.Sb=i,t.Ra=0,t.u=0,t.h=0,4<i&&(i=4),a=0;a<i;++a)o+=r[n+a]<<8*a;t.Ra=o,t.bb=i,t.oa=r,t.pa=n}function b(t){for(;8<=t.u&&t.bb<t.Sb;)t.Ra>>>=8,t.Ra+=t.oa[t.pa+t.bb]<<Ur-8>>>0,++t.bb,t.u-=8;A(t)&&(t.h=1,t.u=0)}function y(t,r){if(e(0<=r),!t.h&&r<=Tr){var n=L(t)&Rr[r];return t.u+=r,b(t),n}return t.h=1,t.u=0}function w(){this.b=this.Ca=this.I=0,this.oa=[],this.pa=0,this.Jd=[],this.Yc=0,this.Zc=[],this.Ka=0}function N(){this.Ra=0,this.oa=[],this.h=this.u=this.bb=this.Sb=this.pa=0}function L(t){return t.Ra>>>(t.u&Ur-1)>>>0}function A(t){return e(t.bb<=t.Sb),t.h||t.bb==t.Sb&&t.u>Ur}function x(t,e){t.u=e,t.h=A(t)}function S(t){t.u>=zr&&(e(t.u>=zr),b(t))}function _(t){e(null!=t&&null!=t.oa),t.pa<t.Zc?(t.I=(t.oa[t.pa++]|t.I<<8)>>>0,t.b+=8):(e(null!=t&&null!=t.oa),t.pa<t.Yc?(t.b+=8,t.I=t.oa[t.pa++]|t.I<<8):t.Ka?t.b=0:(t.I<<=8,t.b+=8,t.Ka=1))}function P(t){return g(t,1)}function k(t,e){var r=t.Ca;0>t.b&&_(t);var n=t.b,i=r*e>>>8,a=(t.I>>>n>i)+0;for(a?(r-=i,t.I-=i+1<<n>>>0):r=i+1,n=r,i=0;256<=n;)i+=8,n>>=8;return n=7^i+Hr[n],t.b-=n,t.Ca=(r<<n)-1,a}function F(t,e,r){t[e+0]=r>>24&255,t[e+1]=r>>16&255,t[e+2]=r>>8&255,t[e+3]=r>>0&255}function I(t,e){return t[e+0]<<0|t[e+1]<<8}function C(t,e){return I(t,e)|t[e+2]<<16}function j(t,e){return I(t,e)|I(t,e+2)<<16}function O(t,r){var n=1<<r;return e(null!=t),e(0<r),t.X=a(n),null==t.X?0:(t.Mb=32-r,t.Xa=r,1)}function B(t,r){e(null!=t),e(null!=r),e(t.Xa==r.Xa),n(r.X,0,t.X,0,1<<r.Xa)}function M(){this.X=[],this.Xa=this.Mb=0}function E(t,r,n,i){e(null!=n),e(null!=i);var a=n[0],o=i[0];return 0==a&&(a=(t*o+r/2)/r),0==o&&(o=(r*a+t/2)/t),0>=a||0>=o?0:(n[0]=a,i[0]=o,1)}function q(t,e){return t+(1<<e)-1>>>e}function D(t,e){return((4278255360&t)+(4278255360&e)>>>0&4278255360)+((16711935&t)+(16711935&e)>>>0&16711935)>>>0}function R(e,r){t[r]=function(r,n,i,a,o,s,c){var u;for(u=0;u<o;++u){var l=t[e](s[c+u-1],i,a+u);s[c+u]=D(r[n+u],l)}}}function T(){this.ud=this.hd=this.jd=0}function U(t,e){return((4278124286&(t^e))>>>1)+(t&e)>>>0}function z(t){return 0<=t&&256>t?t:0>t?0:255<t?255:void 0}function H(t,e){return z(t+(t-e+.5>>1))}function W(t,e,r){return Math.abs(e-r)-Math.abs(t-r)}function V(t,e,r,n,i,a,o){for(n=a[o-1],r=0;r<i;++r)a[o+r]=n=D(t[e+r],n)}function G(t,e,r,n,i){var a;for(a=0;a<r;++a){var o=t[e+a],s=o>>8&255,c=16711935&(c=(c=16711935&o)+((s<<16)+s));n[i+a]=(4278255360&o)+c>>>0}}function Y(t,e){e.jd=t>>0&255,e.hd=t>>8&255,e.ud=t>>16&255}function J(t,e,r,n,i,a){var o;for(o=0;o<n;++o){var s=e[r+o],c=s>>>8,u=s,l=255&(l=(l=s>>>16)+((t.jd<<24>>24)*(c<<24>>24)>>>5));u=255&(u=(u=u+((t.hd<<24>>24)*(c<<24>>24)>>>5))+((t.ud<<24>>24)*(l<<24>>24)>>>5));i[a+o]=(4278255360&s)+(l<<16)+u}}function X(e,r,n,i,a){t[r]=function(t,e,r,n,o,s,c,u,l){for(n=c;n<u;++n)for(c=0;c<l;++c)o[s++]=a(r[i(t[e++])])},t[e]=function(e,r,o,s,c,u,l){var h=8>>e.b,f=e.Ea,d=e.K[0],p=e.w;if(8>h)for(e=(1<<e.b)-1,p=(1<<h)-1;r<o;++r){var g,m=0;for(g=0;g<f;++g)g&e||(m=i(s[c++])),u[l++]=a(d[m&p]),m>>=h}else t["VP8LMapColor"+n](s,c,d,p,u,l,r,o,f)}}function K(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255}}function Z(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>16&255,n[i++]=a>>8&255,n[i++]=a>>0&255,n[i++]=a>>24&255}}function $(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&240|o>>12&15,o=o>>0&240|o>>28&15;n[i++]=a,n[i++]=o}}function Q(t,e,r,n,i){for(r=e+r;e<r;){var a=(o=t[e++])>>16&248|o>>13&7,o=o>>5&224|o>>3&31;n[i++]=a,n[i++]=o}}function tt(t,e,r,n,i){for(r=e+r;e<r;){var a=t[e++];n[i++]=a>>0&255,n[i++]=a>>8&255,n[i++]=a>>16&255}}function et(t,e,r,i,a,o){if(0==o)for(r=e+r;e<r;)F(i,((o=t[e++])[0]>>24|o[1]>>8&65280|o[2]<<8&16711680|o[3]<<24)>>>0),a+=32;else n(i,a,t,e,r)}function rt(e,r){t[r][0]=t[e+"0"],t[r][1]=t[e+"1"],t[r][2]=t[e+"2"],t[r][3]=t[e+"3"],t[r][4]=t[e+"4"],t[r][5]=t[e+"5"],t[r][6]=t[e+"6"],t[r][7]=t[e+"7"],t[r][8]=t[e+"8"],t[r][9]=t[e+"9"],t[r][10]=t[e+"10"],t[r][11]=t[e+"11"],t[r][12]=t[e+"12"],t[r][13]=t[e+"13"],t[r][14]=t[e+"0"],t[r][15]=t[e+"0"]}function nt(t){return t==Hn||t==Wn||t==Vn||t==Gn}function it(){this.eb=[],this.size=this.A=this.fb=0}function at(){this.y=[],this.f=[],this.ea=[],this.F=[],this.Tc=this.Ed=this.Cd=this.Fd=this.lb=this.Db=this.Ab=this.fa=this.J=this.W=this.N=this.O=0}function ot(){this.Rd=this.height=this.width=this.S=0,this.f={},this.f.RGBA=new it,this.f.kb=new at,this.sd=null}function st(){this.width=[0],this.height=[0],this.Pd=[0],this.Qd=[0],this.format=[0]}function ct(){this.Id=this.fd=this.Md=this.hb=this.ib=this.da=this.bd=this.cd=this.j=this.v=this.Da=this.Sd=this.ob=0}function ut(t){return alert("todo:WebPSamplerProcessPlane"),t.T}function lt(t,e){var r=t.T,i=e.ba.f.RGBA,a=i.eb,o=i.fb+t.ka*i.A,s=vi[e.ba.S],c=t.y,u=t.O,l=t.f,h=t.N,f=t.ea,d=t.W,p=e.cc,g=e.dc,m=e.Mc,v=e.Nc,b=t.ka,y=t.ka+t.T,w=t.U,N=w+1>>1;for(0==b?s(c,u,null,null,l,h,f,d,l,h,f,d,a,o,null,null,w):(s(e.ec,e.fc,c,u,p,g,m,v,l,h,f,d,a,o-i.A,a,o,w),++r);b+2<y;b+=2)p=l,g=h,m=f,v=d,h+=t.Rc,d+=t.Rc,o+=2*i.A,s(c,(u+=2*t.fa)-t.fa,c,u,p,g,m,v,l,h,f,d,a,o-i.A,a,o,w);return u+=t.fa,t.j+y<t.o?(n(e.ec,e.fc,c,u,w),n(e.cc,e.dc,l,h,N),n(e.Mc,e.Nc,f,d,N),r--):1&y||s(c,u,null,null,l,h,f,d,l,h,f,d,a,o+i.A,null,null,w),r}function ht(t,r,n){var i=t.F,a=[t.J];if(null!=i){var o=t.U,s=r.ba.S,c=s==Tn||s==Vn;r=r.ba.f.RGBA;var u=[0],l=t.ka;u[0]=t.T,t.Kb&&(0==l?--u[0]:(--l,a[0]-=t.width),t.j+t.ka+t.T==t.o&&(u[0]=t.o-t.j-l));var h=r.eb;l=r.fb+l*r.A;t=Sn(i,a[0],t.width,o,u,h,l+(c?0:3),r.A),e(n==u),t&&nt(s)&&An(h,l,c,o,u,r.A)}return 0}function ft(t){var e=t.ma,r=e.ba.S,n=11>r,i=r==qn||r==Rn||r==Tn||r==Un||12==r||nt(r);if(e.memory=null,e.Ib=null,e.Jb=null,e.Nd=null,!Mr(e.Oa,t,i?11:12))return 0;if(i&&nt(r)&&br(),t.da)alert("todo:use_scaling");else{if(n){if(e.Ib=ut,t.Kb){if(r=t.U+1>>1,e.memory=a(t.U+2*r),null==e.memory)return 0;e.ec=e.memory,e.fc=0,e.cc=e.ec,e.dc=e.fc+t.U,e.Mc=e.cc,e.Nc=e.dc+r,e.Ib=lt,br()}}else alert("todo:EmitYUV");i&&(e.Jb=ht,n&&mr())}if(n&&!Ci){for(t=0;256>t;++t)ji[t]=89858*(t-128)+_i>>Si,Mi[t]=-22014*(t-128)+_i,Bi[t]=-45773*(t-128),Oi[t]=113618*(t-128)+_i>>Si;for(t=Pi;t<ki;++t)e=76283*(t-16)+_i>>Si,Ei[t-Pi]=Vt(e,255),qi[t-Pi]=Vt(e+8>>4,15);Ci=1}return 1}function dt(t){var r=t.ma,n=t.U,i=t.T;return e(!(1&t.ka)),0>=n||0>=i?0:(n=r.Ib(t,r),null!=r.Jb&&r.Jb(t,r,n),r.Dc+=n,1)}function pt(t){t.ma.memory=null}function gt(t,e,r,n){return 47!=y(t,8)?0:(e[0]=y(t,14)+1,r[0]=y(t,14)+1,n[0]=y(t,1),0!=y(t,3)?0:!t.h)}function mt(t,e){if(4>t)return t+1;var r=t-2>>1;return(2+(1&t)<<r)+y(e,r)+1}function vt(t,e){return 120<e?e-120:1<=(r=((r=$n[e-1])>>4)*t+(8-(15&r)))?r:1;var r}function bt(t,e,r){var n=L(r),i=t[e+=255&n].g-8;return 0<i&&(x(r,r.u+8),n=L(r),e+=t[e].value,e+=n&(1<<i)-1),x(r,r.u+t[e].g),t[e].value}function yt(t,r,n){return n.g+=t.g,n.value+=t.value<<r>>>0,e(8>=n.g),t.g}function wt(t,r,n){var i=t.xc;return e((r=0==i?0:t.vc[t.md*(n>>i)+(r>>i)])<t.Wb),t.Ya[r]}function Nt(t,r,i,a){var o=t.ab,s=t.c*r,c=t.C;r=c+r;var u=i,l=a;for(a=t.Ta,i=t.Ua;0<o--;){var h=t.gc[o],f=c,d=r,p=u,g=l,m=(l=a,u=i,h.Ea);switch(e(f<d),e(d<=h.nc),h.hc){case 2:Gr(p,g,(d-f)*m,l,u);break;case 0:var v=f,b=d,y=l,w=u,N=(_=h).Ea;0==v&&(Wr(p,g,null,null,1,y,w),V(p,g+1,0,0,N-1,y,w+1),g+=N,w+=N,++v);for(var L=1<<_.b,A=L-1,x=q(N,_.b),S=_.K,_=_.w+(v>>_.b)*x;v<b;){var P=S,k=_,F=1;for(Vr(p,g,y,w-N,1,y,w);F<N;){var I=(F&~A)+L;I>N&&(I=N),(0,Zr[P[k++]>>8&15])(p,g+ +F,y,w+F-N,I-F,y,w+F),F=I}g+=N,w+=N,++v&A||(_+=x)}d!=h.nc&&n(l,u-m,l,u+(d-f-1)*m,m);break;case 1:for(m=p,b=g,N=(p=h.Ea)-(w=p&~(y=(g=1<<h.b)-1)),v=q(p,h.b),L=h.K,h=h.w+(f>>h.b)*v;f<d;){for(A=L,x=h,S=new T,_=b+w,P=b+p;b<_;)Y(A[x++],S),$r(S,m,b,g,l,u),b+=g,u+=g;b<P&&(Y(A[x++],S),$r(S,m,b,N,l,u),b+=N,u+=N),++f&y||(h+=v)}break;case 3:if(p==l&&g==u&&0<h.b){for(b=l,p=m=u+(d-f)*m-(w=(d-f)*q(h.Ea,h.b)),g=l,y=u,v=[],w=(N=w)-1;0<=w;--w)v[w]=g[y+w];for(w=N-1;0<=w;--w)b[p+w]=v[w];Yr(h,f,d,l,m,l,u)}else Yr(h,f,d,p,g,l,u)}u=a,l=i}l!=i&&n(a,i,u,l,s)}function Lt(t,r){var n=t.V,i=t.Ba+t.c*t.C,a=r-t.C;if(e(r<=t.l.o),e(16>=a),0<a){var o=t.l,s=t.Ta,c=t.Ua,u=o.width;if(Nt(t,a,n,i),a=c=[c],e((n=t.C)<(i=r)),e(o.v<o.va),i>o.o&&(i=o.o),n<o.j){var l=o.j-n;n=o.j;a[0]+=l*u}if(n>=i?n=0:(a[0]+=4*o.v,o.ka=n-o.j,o.U=o.va-o.v,o.T=i-n,n=1),n){if(c=c[0],11>(n=t.ca).S){var h=n.f.RGBA,f=(i=n.S,a=o.U,o=o.T,l=h.eb,h.A),d=o;for(h=h.fb+t.Ma*h.A;0<d--;){var p=s,g=c,m=a,v=l,b=h;switch(i){case En:Qr(p,g,m,v,b);break;case qn:tn(p,g,m,v,b);break;case Hn:tn(p,g,m,v,b),An(v,b,0,m,1,0);break;case Dn:nn(p,g,m,v,b);break;case Rn:et(p,g,m,v,b,1);break;case Wn:et(p,g,m,v,b,1),An(v,b,0,m,1,0);break;case Tn:et(p,g,m,v,b,0);break;case Vn:et(p,g,m,v,b,0),An(v,b,1,m,1,0);break;case Un:en(p,g,m,v,b);break;case Gn:en(p,g,m,v,b),xn(v,b,m,1,0);break;case zn:rn(p,g,m,v,b);break;default:e(0)}c+=u,h+=f}t.Ma+=o}else alert("todo:EmitRescaledRowsYUVA");e(t.Ma<=n.height)}}t.C=r,e(t.C<=t.i)}function At(t){var e;if(0<t.ua)return 0;for(e=0;e<t.Wb;++e){var r=t.Ya[e].G,n=t.Ya[e].H;if(0<r[1][n[1]+0].g||0<r[2][n[2]+0].g||0<r[3][n[3]+0].g)return 0}return 1}function xt(t,r,n,i,a,o){if(0!=t.Z){var s=t.qd,c=t.rd;for(e(null!=mi[t.Z]);r<n;++r)mi[t.Z](s,c,i,a,i,a,o),s=i,c=a,a+=o;t.qd=s,t.rd=c}}function St(t,r){var n=t.l.ma,i=0==n.Z||1==n.Z?t.l.j:t.C;i=t.C<i?i:t.C;if(e(r<=t.l.o),r>i){var a=t.l.width,o=n.ca,s=n.tb+a*i,c=t.V,u=t.Ba+t.c*i,l=t.gc;e(1==t.ab),e(3==l[0].hc),Xr(l[0],i,r,c,u,o,s),xt(n,i,r,o,s,a)}t.C=t.Ma=r}function _t(t,r,n,i,a,o,s){var c=t.$/i,u=t.$%i,l=t.m,h=t.s,f=n+t.$,d=f;a=n+i*a;var p=n+i*o,g=280+h.ua,m=t.Pb?c:16777216,v=0<h.ua?h.Wa:null,b=h.wc,y=f<p?wt(h,u,c):null;e(t.C<o),e(p<=a);var w=!1;t:for(;;){for(;w||f<p;){var N=0;if(c>=m){var _=f-n;e((m=t).Pb),m.wd=m.m,m.xd=_,0<m.s.ua&&B(m.s.Wa,m.s.vb),m=c+ti}if(u&b||(y=wt(h,u,c)),e(null!=y),y.Qb&&(r[f]=y.qb,w=!0),!w)if(S(l),y.jc){N=l,_=r;var P=f,k=y.pd[L(N)&Dr-1];e(y.jc),256>k.g?(x(N,N.u+k.g),_[P]=k.value,N=0):(x(N,N.u+k.g-256),e(256<=k.value),N=k.value),0==N&&(w=!0)}else N=bt(y.G[0],y.H[0],l);if(l.h)break;if(w||256>N){if(!w)if(y.nd)r[f]=(y.qb|N<<8)>>>0;else{if(S(l),w=bt(y.G[1],y.H[1],l),S(l),_=bt(y.G[2],y.H[2],l),P=bt(y.G[3],y.H[3],l),l.h)break;r[f]=(P<<24|w<<16|N<<8|_)>>>0}if(w=!1,++f,++u>=i&&(u=0,++c,null!=s&&c<=o&&!(c%16)&&s(t,c),null!=v))for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N}else if(280>N){if(N=mt(N-256,l),_=bt(y.G[4],y.H[4],l),S(l),_=vt(i,_=mt(_,l)),l.h)break;if(f-n<_||a-f<N)break t;for(P=0;P<N;++P)r[f+P]=r[f+P-_];for(f+=N,u+=N;u>=i;)u-=i,++c,null!=s&&c<=o&&!(c%16)&&s(t,c);if(e(f<=a),u&b&&(y=wt(h,u,c)),null!=v)for(;d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N}else{if(!(N<g))break t;for(w=N-280,e(null!=v);d<f;)N=r[d++],v.X[(506832829*N&4294967295)>>>v.Mb]=N;N=f,e(!(w>>>(_=v).Xa)),r[N]=_.X[w],w=!0}w||e(l.h==A(l))}if(t.Pb&&l.h&&f<a)e(t.m.h),t.a=5,t.m=t.wd,t.$=t.xd,0<t.s.ua&&B(t.s.vb,t.s.Wa);else{if(l.h)break t;null!=s&&s(t,c>o?o:c),t.a=0,t.$=f-n}return 1}return t.a=3,0}function Pt(t){e(null!=t),t.vc=null,t.yc=null,t.Ya=null;var r=t.Wa;null!=r&&(r.X=null),t.vb=null,e(null!=t)}function kt(){var e=new or;return null==e?null:(e.a=0,e.xb=gi,rt("Predictor","VP8LPredictors"),rt("Predictor","VP8LPredictors_C"),rt("PredictorAdd","VP8LPredictorsAdd"),rt("PredictorAdd","VP8LPredictorsAdd_C"),Gr=G,$r=J,Qr=K,tn=Z,en=$,rn=Q,nn=tt,t.VP8LMapColor32b=Jr,t.VP8LMapColor8b=Kr,e)}function Ft(t,r,n,s,c){var u=1,f=[t],p=[r],g=s.m,m=s.s,v=null,b=0;t:for(;;){if(n)for(;u&&y(g,1);){var w=f,N=p,A=s,_=1,P=A.m,k=A.gc[A.ab],F=y(P,2);if(A.Oc&1<<F)u=0;else{switch(A.Oc|=1<<F,k.hc=F,k.Ea=w[0],k.nc=N[0],k.K=[null],++A.ab,e(4>=A.ab),F){case 0:case 1:k.b=y(P,3)+2,_=Ft(q(k.Ea,k.b),q(k.nc,k.b),0,A,k.K),k.K=k.K[0];break;case 3:var I,C=y(P,8)+1,j=16<C?0:4<C?1:2<C?2:3;if(w[0]=q(k.Ea,j),k.b=j,I=_=Ft(C,1,0,A,k.K)){var B,M=C,E=k,R=1<<(8>>E.b),T=a(R);if(null==T)I=0;else{var U=E.K[0],z=E.w;for(T[0]=E.K[0][0],B=1;B<1*M;++B)T[B]=D(U[z+B],T[B-1]);for(;B<4*R;++B)T[B]=0;E.K[0]=null,E.K[0]=T,I=1}}_=I;break;case 2:break;default:e(0)}u=_}}if(f=f[0],p=p[0],u&&y(g,1)&&!(u=1<=(b=y(g,4))&&11>=b)){s.a=3;break t}var H;if(H=u)e:{var W,V,G,Y=s,J=f,X=p,K=b,Z=n,$=Y.m,Q=Y.s,tt=[null],et=1,rt=0,nt=Qn[K];r:for(;;){if(Z&&y($,1)){var it=y($,3)+2,at=q(J,it),ot=q(X,it),st=at*ot;if(!Ft(at,ot,0,Y,tt))break r;for(tt=tt[0],Q.xc=it,W=0;W<st;++W){var ct=tt[W]>>8&65535;tt[W]=ct,ct>=et&&(et=ct+1)}}if($.h)break r;for(V=0;5>V;++V){var ut=Xn[V];!V&&0<K&&(ut+=1<<K),rt<ut&&(rt=ut)}var lt=o(et*nt,h),ht=et,ft=o(ht,d);if(null==ft)var dt=null;else e(65536>=ht),dt=ft;var pt=a(rt);if(null==dt||null==pt||null==lt){Y.a=1;break r}var gt=lt;for(W=G=0;W<et;++W){var mt=dt[W],vt=mt.G,bt=mt.H,wt=0,Nt=1,Lt=0;for(V=0;5>V;++V){ut=Xn[V],vt[V]=gt,bt[V]=G,!V&&0<K&&(ut+=1<<K);n:{var At,xt=ut,St=Y,kt=pt,It=gt,Ct=G,jt=0,Ot=St.m,Bt=y(Ot,1);if(i(kt,0,0,xt),Bt){var Mt=y(Ot,1)+1,Et=y(Ot,1),qt=y(Ot,0==Et?1:8);kt[qt]=1,2==Mt&&(kt[qt=y(Ot,8)]=1);var Dt=1}else{var Rt=a(19),Tt=y(Ot,4)+4;if(19<Tt){St.a=3;var Ut=0;break n}for(At=0;At<Tt;++At)Rt[Zn[At]]=y(Ot,3);var zt=void 0,Ht=void 0,Wt=St,Vt=Rt,Gt=xt,Yt=kt,Jt=0,Xt=Wt.m,Kt=8,Zt=o(128,h);i:for(;l(Zt,0,7,Vt,19);){if(y(Xt,1)){var $t=2+2*y(Xt,3);if((zt=2+y(Xt,$t))>Gt)break i}else zt=Gt;for(Ht=0;Ht<Gt&&zt--;){S(Xt);var Qt=Zt[0+(127&L(Xt))];x(Xt,Xt.u+Qt.g);var te=Qt.value;if(16>te)Yt[Ht++]=te,0!=te&&(Kt=te);else{var ee=16==te,re=te-16,ne=Jn[re],ie=y(Xt,Yn[re])+ne;if(Ht+ie>Gt)break i;for(var ae=ee?Kt:0;0<ie--;)Yt[Ht++]=ae}}Jt=1;break i}Jt||(Wt.a=3),Dt=Jt}(Dt=Dt&&!Ot.h)&&(jt=l(It,Ct,8,kt,xt)),Dt&&0!=jt?Ut=jt:(St.a=3,Ut=0)}if(0==Ut)break r;if(Nt&&1==Kn[V]&&(Nt=0==gt[G].g),wt+=gt[G].g,G+=Ut,3>=V){var oe,se=pt[0];for(oe=1;oe<ut;++oe)pt[oe]>se&&(se=pt[oe]);Lt+=se}}if(mt.nd=Nt,mt.Qb=0,Nt&&(mt.qb=(vt[3][bt[3]+0].value<<24|vt[1][bt[1]+0].value<<16|vt[2][bt[2]+0].value)>>>0,0==wt&&256>vt[0][bt[0]+0].value&&(mt.Qb=1,mt.qb+=vt[0][bt[0]+0].value<<8)),mt.jc=!mt.Qb&&6>Lt,mt.jc){var ce,ue=mt;for(ce=0;ce<Dr;++ce){var le=ce,he=ue.pd[le],fe=ue.G[0][ue.H[0]+le];256<=fe.value?(he.g=fe.g+256,he.value=fe.value):(he.g=0,he.value=0,le>>=yt(fe,8,he),le>>=yt(ue.G[1][ue.H[1]+le],16,he),le>>=yt(ue.G[2][ue.H[2]+le],0,he),yt(ue.G[3][ue.H[3]+le],24,he))}}}Q.vc=tt,Q.Wb=et,Q.Ya=dt,Q.yc=lt,H=1;break e}H=0}if(!(u=H)){s.a=3;break t}if(0<b){if(m.ua=1<<b,!O(m.Wa,b)){s.a=1,u=0;break t}}else m.ua=0;var de=s,pe=f,ge=p,me=de.s,ve=me.xc;if(de.c=pe,de.i=ge,me.md=q(pe,ve),me.wc=0==ve?-1:(1<<ve)-1,n){s.xb=pi;break t}if(null==(v=a(f*p))){s.a=1,u=0;break t}u=(u=_t(s,v,0,f,p,p,null))&&!g.h;break t}return u?(null!=c?c[0]=v:(e(null==v),e(n)),s.$=0,n||Pt(m)):Pt(m),u}function It(t,r){var n=t.c*t.i,i=n+r+16*r;return e(t.c<=r),t.V=a(i),null==t.V?(t.Ta=null,t.Ua=0,t.a=1,0):(t.Ta=t.V,t.Ua=t.Ba+n+r,1)}function Ct(t,r){var n=t.C,i=r-n,a=t.V,o=t.Ba+t.c*n;for(e(r<=t.l.o);0<i;){var s=16<i?16:i,c=t.l.ma,u=t.l.width,l=u*s,h=c.ca,f=c.tb+u*n,d=t.Ta,p=t.Ua;Nt(t,s,a,o),_n(d,p,h,f,l),xt(c,n,n+s,h,f,u),i-=s,a+=s*t.c,n+=s}e(n==r),t.C=t.Ma=r}function jt(){this.ub=this.yd=this.td=this.Rb=0}function Ot(){this.Kd=this.Ld=this.Ud=this.Td=this.i=this.c=0}function Bt(){this.Fb=this.Bb=this.Cb=0,this.Zb=a(4),this.Lb=a(4)}function Mt(){this.Yb=function(){var t=[];return function t(e,r,n){for(var i=n[r],a=0;a<i&&(e.push(n.length>r+1?[]:0),!(n.length<r+1));a++)t(e[a],r+1,n)}(t,0,[3,11]),t}()}function Et(){this.jb=a(3),this.Wc=s([4,8],Mt),this.Xc=s([4,17],Mt)}function qt(){this.Pc=this.wb=this.Tb=this.zd=0,this.vd=new a(4),this.od=new a(4)}function Dt(){this.ld=this.La=this.dd=this.tc=0}function Rt(){this.Na=this.la=0}function Tt(){this.Sc=[0,0],this.Eb=[0,0],this.Qc=[0,0],this.ia=this.lc=0}function Ut(){this.ad=a(384),this.Za=0,this.Ob=a(16),this.$b=this.Ad=this.ia=this.Gc=this.Hc=this.Dd=0}function zt(){this.uc=this.M=this.Nb=0,this.wa=Array(new Dt),this.Y=0,this.ya=Array(new Ut),this.aa=0,this.l=new Gt}function Ht(){this.y=a(16),this.f=a(8),this.ea=a(8)}function Wt(){this.cb=this.a=0,this.sc="",this.m=new w,this.Od=new jt,this.Kc=new Ot,this.ed=new qt,this.Qa=new Bt,this.Ic=this.$c=this.Aa=0,this.D=new zt,this.Xb=this.Va=this.Hb=this.zb=this.yb=this.Ub=this.za=0,this.Jc=o(8,w),this.ia=0,this.pb=o(4,Tt),this.Pa=new Et,this.Bd=this.kc=0,this.Ac=[],this.Bc=0,this.zc=[0,0,0,0],this.Gd=Array(new Ht),this.Hd=0,this.rb=Array(new Rt),this.sb=0,this.wa=Array(new Dt),this.Y=0,this.oc=[],this.pc=0,this.sa=[],this.ta=0,this.qa=[],this.ra=0,this.Ha=[],this.B=this.R=this.Ia=0,this.Ec=[],this.M=this.ja=this.Vb=this.Fc=0,this.ya=Array(new Ut),this.L=this.aa=0,this.gd=s([4,2],Dt),this.ga=null,this.Fa=[],this.Cc=this.qc=this.P=0,this.Gb=[],this.Uc=0,this.mb=[],this.nb=0,this.rc=[],this.Ga=this.Vc=0}function Vt(t,e){return 0>t?0:t>e?e:t}function Gt(){this.T=this.U=this.ka=this.height=this.width=0,this.y=[],this.f=[],this.ea=[],this.Rc=this.fa=this.W=this.N=this.O=0,this.ma="void",this.put="VP8IoPutHook",this.ac="VP8IoSetupHook",this.bc="VP8IoTeardownHook",this.ha=this.Kb=0,this.data=[],this.hb=this.ib=this.da=this.o=this.j=this.va=this.v=this.Da=this.ob=this.w=0,this.F=[],this.J=0}function Yt(){var t=new Wt;return null!=t&&(t.a=0,t.sc="OK",t.cb=0,t.Xb=0,ni||(ni=Zt)),t}function Jt(t,e,r){return 0==t.a&&(t.a=e,t.sc=r,t.cb=0),0}function Xt(t,e,r){return 3<=r&&157==t[e+0]&&1==t[e+1]&&42==t[e+2]}function Kt(t,r){if(null==t)return 0;if(t.a=0,t.sc="OK",null==r)return Jt(t,2,"null VP8Io passed to VP8GetHeaders()");var n=r.data,a=r.w,o=r.ha;if(4>o)return Jt(t,7,"Truncated header.");var s=n[a+0]|n[a+1]<<8|n[a+2]<<16,c=t.Od;if(c.Rb=!(1&s),c.td=s>>1&7,c.yd=s>>4&1,c.ub=s>>5,3<c.td)return Jt(t,3,"Incorrect keyframe parameters.");if(!c.yd)return Jt(t,4,"Frame not displayable.");a+=3,o-=3;var u=t.Kc;if(c.Rb){if(7>o)return Jt(t,7,"cannot parse picture header");if(!Xt(n,a,o))return Jt(t,3,"Bad code word");u.c=16383&(n[a+4]<<8|n[a+3]),u.Td=n[a+4]>>6,u.i=16383&(n[a+6]<<8|n[a+5]),u.Ud=n[a+6]>>6,a+=7,o-=7,t.za=u.c+15>>4,t.Ub=u.i+15>>4,r.width=u.c,r.height=u.i,r.Da=0,r.j=0,r.v=0,r.va=r.width,r.o=r.height,r.da=0,r.ib=r.width,r.hb=r.height,r.U=r.width,r.T=r.height,i((s=t.Pa).jb,0,255,s.jb.length),e(null!=(s=t.Qa)),s.Cb=0,s.Bb=0,s.Fb=1,i(s.Zb,0,0,s.Zb.length),i(s.Lb,0,0,s.Lb)}if(c.ub>o)return Jt(t,7,"bad partition length");p(s=t.m,n,a,c.ub),a+=c.ub,o-=c.ub,c.Rb&&(u.Ld=P(s),u.Kd=P(s)),u=t.Qa;var l,h=t.Pa;if(e(null!=s),e(null!=u),u.Cb=P(s),u.Cb){if(u.Bb=P(s),P(s)){for(u.Fb=P(s),l=0;4>l;++l)u.Zb[l]=P(s)?m(s,7):0;for(l=0;4>l;++l)u.Lb[l]=P(s)?m(s,6):0}if(u.Bb)for(l=0;3>l;++l)h.jb[l]=P(s)?g(s,8):255}else u.Bb=0;if(s.Ka)return Jt(t,3,"cannot parse segment header");if((u=t.ed).zd=P(s),u.Tb=g(s,6),u.wb=g(s,3),u.Pc=P(s),u.Pc&&P(s)){for(h=0;4>h;++h)P(s)&&(u.vd[h]=m(s,6));for(h=0;4>h;++h)P(s)&&(u.od[h]=m(s,6))}if(t.L=0==u.Tb?0:u.zd?1:2,s.Ka)return Jt(t,3,"cannot parse filter header");var f=o;if(o=l=a,a=l+f,u=f,t.Xb=(1<<g(t.m,2))-1,f<3*(h=t.Xb))n=7;else{for(l+=3*h,u-=3*h,f=0;f<h;++f){var d=n[o+0]|n[o+1]<<8|n[o+2]<<16;d>u&&(d=u),p(t.Jc[+f],n,l,d),l+=d,u-=d,o+=3}p(t.Jc[+h],n,l,u),n=l<a?0:5}if(0!=n)return Jt(t,n,"cannot parse partitions");for(n=g(l=t.m,7),o=P(l)?m(l,4):0,a=P(l)?m(l,4):0,u=P(l)?m(l,4):0,h=P(l)?m(l,4):0,l=P(l)?m(l,4):0,f=t.Qa,d=0;4>d;++d){if(f.Cb){var v=f.Zb[d];f.Fb||(v+=n)}else{if(0<d){t.pb[d]=t.pb[0];continue}v=n}var b=t.pb[d];b.Sc[0]=ei[Vt(v+o,127)],b.Sc[1]=ri[Vt(v+0,127)],b.Eb[0]=2*ei[Vt(v+a,127)],b.Eb[1]=101581*ri[Vt(v+u,127)]>>16,8>b.Eb[1]&&(b.Eb[1]=8),b.Qc[0]=ei[Vt(v+h,117)],b.Qc[1]=ri[Vt(v+l,127)],b.lc=v+l}if(!c.Rb)return Jt(t,4,"Not a key frame.");for(P(s),c=t.Pa,n=0;4>n;++n){for(o=0;8>o;++o)for(a=0;3>a;++a)for(u=0;11>u;++u)h=k(s,ui[n][o][a][u])?g(s,8):si[n][o][a][u],c.Wc[n][o].Yb[a][u]=h;for(o=0;17>o;++o)c.Xc[n][o]=c.Wc[n][li[o]]}return t.kc=P(s),t.kc&&(t.Bd=g(s,8)),t.cb=1}function Zt(t,e,r,n,i,a,o){var s=e[i].Yb[r];for(r=0;16>i;++i){if(!k(t,s[r+0]))return i;for(;!k(t,s[r+1]);)if(s=e[++i].Yb[0],r=0,16==i)return 16;var c=e[i+1].Yb;if(k(t,s[r+2])){var u=t,l=0;if(k(u,(f=s)[(h=r)+3]))if(k(u,f[h+6])){for(s=0,h=2*(l=k(u,f[h+8]))+(f=k(u,f[h+9+l])),l=0,f=ii[h];f[s];++s)l+=l+k(u,f[s]);l+=3+(8<<h)}else k(u,f[h+7])?(l=7+2*k(u,165),l+=k(u,145)):l=5+k(u,159);else l=k(u,f[h+4])?3+k(u,f[h+5]):2;s=c[2]}else l=1,s=c[1];c=o+ai[i],0>(u=t).b&&_(u);var h,f=u.b,d=(h=u.Ca>>1)-(u.I>>f)>>31;--u.b,u.Ca+=d,u.Ca|=1,u.I-=(h+1&d)<<f,a[c]=((l^d)-d)*n[(0<i)+0]}return 16}function $t(t){var e=t.rb[t.sb-1];e.la=0,e.Na=0,i(t.zc,0,0,t.zc.length),t.ja=0}function Qt(t,r){if(null==t)return 0;if(null==r)return Jt(t,2,"NULL VP8Io parameter in VP8Decode().");if(!t.cb&&!Kt(t,r))return 0;if(e(t.cb),null==r.ac||r.ac(r)){r.ob&&(t.L=0);var s=Ri[t.L];if(2==t.L?(t.yb=0,t.zb=0):(t.yb=r.v-s>>4,t.zb=r.j-s>>4,0>t.yb&&(t.yb=0),0>t.zb&&(t.zb=0)),t.Va=r.o+15+s>>4,t.Hb=r.va+15+s>>4,t.Hb>t.za&&(t.Hb=t.za),t.Va>t.Ub&&(t.Va=t.Ub),0<t.L){var c=t.ed;for(s=0;4>s;++s){var u;if(t.Qa.Cb){var l=t.Qa.Lb[s];t.Qa.Fb||(l+=c.Tb)}else l=c.Tb;for(u=0;1>=u;++u){var h=t.gd[s][u],f=l;if(c.Pc&&(f+=c.vd[0],u&&(f+=c.od[0])),0<(f=0>f?0:63<f?63:f)){var d=f;0<c.wb&&((d=4<c.wb?d>>2:d>>1)>9-c.wb&&(d=9-c.wb)),1>d&&(d=1),h.dd=d,h.tc=2*f+d,h.ld=40<=f?2:15<=f?1:0}else h.tc=0;h.La=u}}}s=0}else Jt(t,6,"Frame setup failed"),s=t.a;if(s=0==s){if(s){t.$c=0,0<t.Aa||(t.Ic=Ui);t:{s=t.Ic;c=4*(d=t.za);var p=32*d,g=d+1,m=0<t.L?d*(0<t.Aa?2:1):0,v=(2==t.Aa?2:1)*d;if((h=c+832+(u=3*(16*s+Ri[t.L])/2*p)+(l=null!=t.Fa&&0<t.Fa.length?t.Kc.c*t.Kc.i:0))!=h)s=0;else{if(h>t.Vb){if(t.Vb=0,t.Ec=a(h),t.Fc=0,null==t.Ec){s=Jt(t,1,"no memory during frame initialization.");break t}t.Vb=h}h=t.Ec,f=t.Fc,t.Ac=h,t.Bc=f,f+=c,t.Gd=o(p,Ht),t.Hd=0,t.rb=o(g+1,Rt),t.sb=1,t.wa=m?o(m,Dt):null,t.Y=0,t.D.Nb=0,t.D.wa=t.wa,t.D.Y=t.Y,0<t.Aa&&(t.D.Y+=d),e(!0),t.oc=h,t.pc=f,f+=832,t.ya=o(v,Ut),t.aa=0,t.D.ya=t.ya,t.D.aa=t.aa,2==t.Aa&&(t.D.aa+=d),t.R=16*d,t.B=8*d,d=(p=Ri[t.L])*t.R,p=p/2*t.B,t.sa=h,t.ta=f+d,t.qa=t.sa,t.ra=t.ta+16*s*t.R+p,t.Ha=t.qa,t.Ia=t.ra+8*s*t.B+p,t.$c=0,f+=u,t.mb=l?h:null,t.nb=l?f:null,e(f+l<=t.Fc+t.Vb),$t(t),i(t.Ac,t.Bc,0,c),s=1}}if(s){if(r.ka=0,r.y=t.sa,r.O=t.ta,r.f=t.qa,r.N=t.ra,r.ea=t.Ha,r.Vd=t.Ia,r.fa=t.R,r.Rc=t.B,r.F=null,r.J=0,!Cn){for(s=-255;255>=s;++s)Pn[255+s]=0>s?-s:s;for(s=-1020;1020>=s;++s)kn[1020+s]=-128>s?-128:127<s?127:s;for(s=-112;112>=s;++s)Fn[112+s]=-16>s?-16:15<s?15:s;for(s=-255;510>=s;++s)In[255+s]=0>s?0:255<s?255:s;Cn=1}an=ue,on=ae,cn=oe,un=se,ln=ce,sn=ie,hn=Je,fn=Xe,dn=$e,pn=Qe,gn=Ke,mn=Ze,vn=tr,bn=er,yn=ze,wn=He,Nn=We,Ln=Ve,fi[0]=xe,fi[1]=he,fi[2]=Le,fi[3]=Ae,fi[4]=Se,fi[5]=Pe,fi[6]=_e,fi[7]=ke,fi[8]=Ie,fi[9]=Fe,hi[0]=ve,hi[1]=de,hi[2]=pe,hi[3]=ge,hi[4]=be,hi[5]=ye,hi[6]=we,di[0]=Be,di[1]=fe,di[2]=Ce,di[3]=je,di[4]=Ee,di[5]=Me,di[6]=qe,s=1}else s=0}s&&(s=function(t,r){for(t.M=0;t.M<t.Va;++t.M){var o,s=t.Jc[t.M&t.Xb],c=t.m,u=t;for(o=0;o<u.za;++o){var l=c,h=u,f=h.Ac,d=h.Bc+4*o,p=h.zc,g=h.ya[h.aa+o];if(h.Qa.Bb?g.$b=k(l,h.Pa.jb[0])?2+k(l,h.Pa.jb[2]):k(l,h.Pa.jb[1]):g.$b=0,h.kc&&(g.Ad=k(l,h.Bd)),g.Za=!k(l,145)+0,g.Za){var m=g.Ob,v=0;for(h=0;4>h;++h){var b,y=p[0+h];for(b=0;4>b;++b){y=ci[f[d+b]][y];for(var w=oi[k(l,y[0])];0<w;)w=oi[2*w+k(l,y[w])];y=-w,f[d+b]=y}n(m,v,f,d,4),v+=4,p[0+h]=y}}else y=k(l,156)?k(l,128)?1:3:k(l,163)?2:0,g.Ob[0]=y,i(f,d,y,4),i(p,0,y,4);g.Dd=k(l,142)?k(l,114)?k(l,183)?1:3:2:0}if(u.m.Ka)return Jt(t,7,"Premature end-of-partition0 encountered.");for(;t.ja<t.za;++t.ja){if(u=s,l=(c=t).rb[c.sb-1],f=c.rb[c.sb+c.ja],o=c.ya[c.aa+c.ja],d=c.kc?o.Ad:0)l.la=f.la=0,o.Za||(l.Na=f.Na=0),o.Hc=0,o.Gc=0,o.ia=0;else{var N,L;l=f,f=u,d=c.Pa.Xc,p=c.ya[c.aa+c.ja],g=c.pb[p.$b];if(h=p.ad,m=0,v=c.rb[c.sb-1],y=b=0,i(h,m,0,384),p.Za)var A=0,x=d[3];else{w=a(16);var S=l.Na+v.Na;if(S=ni(f,d[1],S,g.Eb,0,w,0),l.Na=v.Na=(0<S)+0,1<S)an(w,0,h,m);else{var _=w[0]+3>>3;for(w=0;256>w;w+=16)h[m+w]=_}A=1,x=d[0]}var P=15&l.la,F=15&v.la;for(w=0;4>w;++w){var I=1&F;for(_=L=0;4>_;++_)P=P>>1|(I=(S=ni(f,x,S=I+(1&P),g.Sc,A,h,m))>A)<<7,L=L<<2|(3<S?3:1<S?2:0!=h[m+0]),m+=16;P>>=4,F=F>>1|I<<7,b=(b<<8|L)>>>0}for(x=P,A=F>>4,N=0;4>N;N+=2){for(L=0,P=l.la>>4+N,F=v.la>>4+N,w=0;2>w;++w){for(I=1&F,_=0;2>_;++_)S=I+(1&P),P=P>>1|(I=0<(S=ni(f,d[2],S,g.Qc,0,h,m)))<<3,L=L<<2|(3<S?3:1<S?2:0!=h[m+0]),m+=16;P>>=2,F=F>>1|I<<5}y|=L<<4*N,x|=P<<4<<N,A|=(240&F)<<N}l.la=x,v.la=A,p.Hc=b,p.Gc=y,p.ia=43690&y?0:g.ia,d=!(b|y)}if(0<c.L&&(c.wa[c.Y+c.ja]=c.gd[o.$b][o.Za],c.wa[c.Y+c.ja].La|=!d),u.Ka)return Jt(t,7,"Premature end-of-file encountered.")}if($t(t),c=r,u=1,o=(s=t).D,l=0<s.L&&s.M>=s.zb&&s.M<=s.Va,0==s.Aa)t:{if(o.M=s.M,o.uc=l,Or(s,o),u=1,o=(L=s.D).Nb,l=(y=Ri[s.L])*s.R,f=y/2*s.B,w=16*o*s.R,_=8*o*s.B,d=s.sa,p=s.ta-l+w,g=s.qa,h=s.ra-f+_,m=s.Ha,v=s.Ia-f+_,F=0==(P=L.M),b=P>=s.Va-1,2==s.Aa&&Or(s,L),L.uc)for(I=(S=s).D.M,e(S.D.uc),L=S.yb;L<S.Hb;++L){A=L,x=I;var C=(j=(U=S).D).Nb;N=U.R;var j=j.wa[j.Y+A],O=U.sa,B=U.ta+16*C*N+16*A,M=j.dd,E=j.tc;if(0!=E)if(e(3<=E),1==U.L)0<A&&wn(O,B,N,E+4),j.La&&Ln(O,B,N,E),0<x&&yn(O,B,N,E+4),j.La&&Nn(O,B,N,E);else{var q=U.B,D=U.qa,R=U.ra+8*C*q+8*A,T=U.Ha,U=U.Ia+8*C*q+8*A;C=j.ld;0<A&&(fn(O,B,N,E+4,M,C),pn(D,R,T,U,q,E+4,M,C)),j.La&&(mn(O,B,N,E,M,C),bn(D,R,T,U,q,E,M,C)),0<x&&(hn(O,B,N,E+4,M,C),dn(D,R,T,U,q,E+4,M,C)),j.La&&(gn(O,B,N,E,M,C),vn(D,R,T,U,q,E,M,C))}}if(s.ia&&alert("todo:DitherRow"),null!=c.put){if(L=16*P,P=16*(P+1),F?(c.y=s.sa,c.O=s.ta+w,c.f=s.qa,c.N=s.ra+_,c.ea=s.Ha,c.W=s.Ia+_):(L-=y,c.y=d,c.O=p,c.f=g,c.N=h,c.ea=m,c.W=v),b||(P-=y),P>c.o&&(P=c.o),c.F=null,c.J=null,null!=s.Fa&&0<s.Fa.length&&L<P&&(c.J=hr(s,c,L,P-L),c.F=s.mb,null==c.F&&0==c.F.length)){u=Jt(s,3,"Could not decode alpha data.");break t}L<c.j&&(y=c.j-L,L=c.j,e(!(1&y)),c.O+=s.R*y,c.N+=s.B*(y>>1),c.W+=s.B*(y>>1),null!=c.F&&(c.J+=c.width*y)),L<P&&(c.O+=c.v,c.N+=c.v>>1,c.W+=c.v>>1,null!=c.F&&(c.J+=c.v),c.ka=L-c.j,c.U=c.va-c.v,c.T=P-L,u=c.put(c))}o+1!=s.Ic||b||(n(s.sa,s.ta-l,d,p+16*s.R,l),n(s.qa,s.ra-f,g,h+8*s.B,f),n(s.Ha,s.Ia-f,m,v+8*s.B,f))}if(!u)return Jt(t,6,"Output aborted.")}return 1}(t,r)),null!=r.bc&&r.bc(r),s&=1}return s?(t.cb=0,s):0}function te(t,e,r,n,i){i=t[e+r+32*n]+(i>>3),t[e+r+32*n]=-256&i?0>i?0:255:i}function ee(t,e,r,n,i,a){te(t,e,0,r,n+i),te(t,e,1,r,n+a),te(t,e,2,r,n-a),te(t,e,3,r,n-i)}function re(t){return(20091*t>>16)+t}function ne(t,e,r,n){var i,o=0,s=a(16);for(i=0;4>i;++i){var c=t[e+0]+t[e+8],u=t[e+0]-t[e+8],l=(35468*t[e+4]>>16)-re(t[e+12]),h=re(t[e+4])+(35468*t[e+12]>>16);s[o+0]=c+h,s[o+1]=u+l,s[o+2]=u-l,s[o+3]=c-h,o+=4,e++}for(i=o=0;4>i;++i)c=(t=s[o+0]+4)+s[o+8],u=t-s[o+8],l=(35468*s[o+4]>>16)-re(s[o+12]),te(r,n,0,0,c+(h=re(s[o+4])+(35468*s[o+12]>>16))),te(r,n,1,0,u+l),te(r,n,2,0,u-l),te(r,n,3,0,c-h),o++,n+=32}function ie(t,e,r,n){var i=t[e+0]+4,a=35468*t[e+4]>>16,o=re(t[e+4]),s=35468*t[e+1]>>16;ee(r,n,0,i+o,t=re(t[e+1]),s),ee(r,n,1,i+a,t,s),ee(r,n,2,i-a,t,s),ee(r,n,3,i-o,t,s)}function ae(t,e,r,n,i){ne(t,e,r,n),i&&ne(t,e+16,r,n+4)}function oe(t,e,r,n){on(t,e+0,r,n,1),on(t,e+32,r,n+128,1)}function se(t,e,r,n){var i;for(t=t[e+0]+4,i=0;4>i;++i)for(e=0;4>e;++e)te(r,n,e,i,t)}function ce(t,e,r,n){t[e+0]&&un(t,e+0,r,n),t[e+16]&&un(t,e+16,r,n+4),t[e+32]&&un(t,e+32,r,n+128),t[e+48]&&un(t,e+48,r,n+128+4)}function ue(t,e,r,n){var i,o=a(16);for(i=0;4>i;++i){var s=t[e+0+i]+t[e+12+i],c=t[e+4+i]+t[e+8+i],u=t[e+4+i]-t[e+8+i],l=t[e+0+i]-t[e+12+i];o[0+i]=s+c,o[8+i]=s-c,o[4+i]=l+u,o[12+i]=l-u}for(i=0;4>i;++i)s=(t=o[0+4*i]+3)+o[3+4*i],c=o[1+4*i]+o[2+4*i],u=o[1+4*i]-o[2+4*i],l=t-o[3+4*i],r[n+0]=s+c>>3,r[n+16]=l+u>>3,r[n+32]=s-c>>3,r[n+48]=l-u>>3,n+=64}function le(t,e,r){var n,i=e-32,a=Bn,o=255-t[i-1];for(n=0;n<r;++n){var s,c=a,u=o+t[e-1];for(s=0;s<r;++s)t[e+s]=c[u+t[i+s]];e+=32}}function he(t,e){le(t,e,4)}function fe(t,e){le(t,e,8)}function de(t,e){le(t,e,16)}function pe(t,e){var r;for(r=0;16>r;++r)n(t,e+32*r,t,e-32,16)}function ge(t,e){var r;for(r=16;0<r;--r)i(t,e,t[e-1],16),e+=32}function me(t,e,r){var n;for(n=0;16>n;++n)i(e,r+32*n,t,16)}function ve(t,e){var r,n=16;for(r=0;16>r;++r)n+=t[e-1+32*r]+t[e+r-32];me(n>>5,t,e)}function be(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e-1+32*r];me(n>>4,t,e)}function ye(t,e){var r,n=8;for(r=0;16>r;++r)n+=t[e+r-32];me(n>>4,t,e)}function we(t,e){me(128,t,e)}function Ne(t,e,r){return t+2*e+r+2>>2}function Le(t,e){var r,i=e-32;i=new Uint8Array([Ne(t[i-1],t[i+0],t[i+1]),Ne(t[i+0],t[i+1],t[i+2]),Ne(t[i+1],t[i+2],t[i+3]),Ne(t[i+2],t[i+3],t[i+4])]);for(r=0;4>r;++r)n(t,e+32*r,i,0,i.length)}function Ae(t,e){var r=t[e-1],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];F(t,e+0,16843009*Ne(t[e-1-32],r,n)),F(t,e+32,16843009*Ne(r,n,i)),F(t,e+64,16843009*Ne(n,i,a)),F(t,e+96,16843009*Ne(i,a,a))}function xe(t,e){var r,n=4;for(r=0;4>r;++r)n+=t[e+r-32]+t[e-1+32*r];for(n>>=3,r=0;4>r;++r)i(t,e+32*r,n,4)}function Se(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],c=t[e+2-32],u=t[e+3-32];t[e+0+96]=Ne(n,i,t[e-1+96]),t[e+1+96]=t[e+0+64]=Ne(r,n,i),t[e+2+96]=t[e+1+64]=t[e+0+32]=Ne(a,r,n),t[e+3+96]=t[e+2+64]=t[e+1+32]=t[e+0+0]=Ne(o,a,r),t[e+3+64]=t[e+2+32]=t[e+1+0]=Ne(s,o,a),t[e+3+32]=t[e+2+0]=Ne(c,s,o),t[e+3+0]=Ne(u,c,s)}function _e(t,e){var r=t[e+1-32],n=t[e+2-32],i=t[e+3-32],a=t[e+4-32],o=t[e+5-32],s=t[e+6-32],c=t[e+7-32];t[e+0+0]=Ne(t[e+0-32],r,n),t[e+1+0]=t[e+0+32]=Ne(r,n,i),t[e+2+0]=t[e+1+32]=t[e+0+64]=Ne(n,i,a),t[e+3+0]=t[e+2+32]=t[e+1+64]=t[e+0+96]=Ne(i,a,o),t[e+3+32]=t[e+2+64]=t[e+1+96]=Ne(a,o,s),t[e+3+64]=t[e+2+96]=Ne(o,s,c),t[e+3+96]=Ne(s,c,c)}function Pe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1-32],o=t[e+0-32],s=t[e+1-32],c=t[e+2-32],u=t[e+3-32];t[e+0+0]=t[e+1+64]=a+o+1>>1,t[e+1+0]=t[e+2+64]=o+s+1>>1,t[e+2+0]=t[e+3+64]=s+c+1>>1,t[e+3+0]=c+u+1>>1,t[e+0+96]=Ne(i,n,r),t[e+0+64]=Ne(n,r,a),t[e+0+32]=t[e+1+96]=Ne(r,a,o),t[e+1+32]=t[e+2+96]=Ne(a,o,s),t[e+2+32]=t[e+3+96]=Ne(o,s,c),t[e+3+32]=Ne(s,c,u)}function ke(t,e){var r=t[e+0-32],n=t[e+1-32],i=t[e+2-32],a=t[e+3-32],o=t[e+4-32],s=t[e+5-32],c=t[e+6-32],u=t[e+7-32];t[e+0+0]=r+n+1>>1,t[e+1+0]=t[e+0+64]=n+i+1>>1,t[e+2+0]=t[e+1+64]=i+a+1>>1,t[e+3+0]=t[e+2+64]=a+o+1>>1,t[e+0+32]=Ne(r,n,i),t[e+1+32]=t[e+0+96]=Ne(n,i,a),t[e+2+32]=t[e+1+96]=Ne(i,a,o),t[e+3+32]=t[e+2+96]=Ne(a,o,s),t[e+3+64]=Ne(o,s,c),t[e+3+96]=Ne(s,c,u)}function Fe(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96];t[e+0+0]=r+n+1>>1,t[e+2+0]=t[e+0+32]=n+i+1>>1,t[e+2+32]=t[e+0+64]=i+a+1>>1,t[e+1+0]=Ne(r,n,i),t[e+3+0]=t[e+1+32]=Ne(n,i,a),t[e+3+32]=t[e+1+64]=Ne(i,a,a),t[e+3+64]=t[e+2+64]=t[e+0+96]=t[e+1+96]=t[e+2+96]=t[e+3+96]=a}function Ie(t,e){var r=t[e-1+0],n=t[e-1+32],i=t[e-1+64],a=t[e-1+96],o=t[e-1-32],s=t[e+0-32],c=t[e+1-32],u=t[e+2-32];t[e+0+0]=t[e+2+32]=r+o+1>>1,t[e+0+32]=t[e+2+64]=n+r+1>>1,t[e+0+64]=t[e+2+96]=i+n+1>>1,t[e+0+96]=a+i+1>>1,t[e+3+0]=Ne(s,c,u),t[e+2+0]=Ne(o,s,c),t[e+1+0]=t[e+3+32]=Ne(r,o,s),t[e+1+32]=t[e+3+64]=Ne(n,r,o),t[e+1+64]=t[e+3+96]=Ne(i,n,r),t[e+1+96]=Ne(a,i,n)}function Ce(t,e){var r;for(r=0;8>r;++r)n(t,e+32*r,t,e-32,8)}function je(t,e){var r;for(r=0;8>r;++r)i(t,e,t[e-1],8),e+=32}function Oe(t,e,r){var n;for(n=0;8>n;++n)i(e,r+32*n,t,8)}function Be(t,e){var r,n=8;for(r=0;8>r;++r)n+=t[e+r-32]+t[e-1+32*r];Oe(n>>4,t,e)}function Me(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e+r-32];Oe(n>>3,t,e)}function Ee(t,e){var r,n=4;for(r=0;8>r;++r)n+=t[e-1+32*r];Oe(n>>3,t,e)}function qe(t,e){Oe(128,t,e)}function De(t,e,r){var n=t[e-r],i=t[e+0],a=3*(i-n)+jn[1020+t[e-2*r]-t[e+r]],o=On[112+(a+4>>3)];t[e-r]=Bn[255+n+On[112+(a+3>>3)]],t[e+0]=Bn[255+i-o]}function Re(t,e,r,n){var i=t[e+0],a=t[e+r];return Mn[255+t[e-2*r]-t[e-r]]>n||Mn[255+a-i]>n}function Te(t,e,r,n){return 4*Mn[255+t[e-r]-t[e+0]]+Mn[255+t[e-2*r]-t[e+r]]<=n}function Ue(t,e,r,n,i){var a=t[e-3*r],o=t[e-2*r],s=t[e-r],c=t[e+0],u=t[e+r],l=t[e+2*r],h=t[e+3*r];return 4*Mn[255+s-c]+Mn[255+o-u]>n?0:Mn[255+t[e-4*r]-a]<=i&&Mn[255+a-o]<=i&&Mn[255+o-s]<=i&&Mn[255+h-l]<=i&&Mn[255+l-u]<=i&&Mn[255+u-c]<=i}function ze(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)Te(t,e+n,r,i)&&De(t,e+n,r)}function He(t,e,r,n){var i=2*n+1;for(n=0;16>n;++n)Te(t,e+n*r,1,i)&&De(t,e+n*r,1)}function We(t,e,r,n){var i;for(i=3;0<i;--i)ze(t,e+=4*r,r,n)}function Ve(t,e,r,n){var i;for(i=3;0<i;--i)He(t,e+=4,r,n)}function Ge(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Re(t,e,r,s))De(t,e,r);else{var c=t,u=e,l=r,h=c[u-2*l],f=c[u-l],d=c[u+0],p=c[u+l],g=c[u+2*l],m=27*(b=jn[1020+3*(d-f)+jn[1020+h-p]])+63>>7,v=18*b+63>>7,b=9*b+63>>7;c[u-3*l]=Bn[255+c[u-3*l]+b],c[u-2*l]=Bn[255+h+v],c[u-l]=Bn[255+f+m],c[u+0]=Bn[255+d-m],c[u+l]=Bn[255+p-v],c[u+2*l]=Bn[255+g-b]}e+=n}}function Ye(t,e,r,n,i,a,o,s){for(a=2*a+1;0<i--;){if(Ue(t,e,r,a,o))if(Re(t,e,r,s))De(t,e,r);else{var c=t,u=e,l=r,h=c[u-l],f=c[u+0],d=c[u+l],p=On[112+((g=3*(f-h))+4>>3)],g=On[112+(g+3>>3)],m=p+1>>1;c[u-2*l]=Bn[255+c[u-2*l]+m],c[u-l]=Bn[255+h+g],c[u+0]=Bn[255+f-p],c[u+l]=Bn[255+d-m]}e+=n}}function Je(t,e,r,n,i,a){Ge(t,e,r,1,16,n,i,a)}function Xe(t,e,r,n,i,a){Ge(t,e,1,r,16,n,i,a)}function Ke(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4*r,r,1,16,n,i,a)}function Ze(t,e,r,n,i,a){var o;for(o=3;0<o;--o)Ye(t,e+=4,1,r,16,n,i,a)}function $e(t,e,r,n,i,a,o,s){Ge(t,e,i,1,8,a,o,s),Ge(r,n,i,1,8,a,o,s)}function Qe(t,e,r,n,i,a,o,s){Ge(t,e,1,i,8,a,o,s),Ge(r,n,1,i,8,a,o,s)}function tr(t,e,r,n,i,a,o,s){Ye(t,e+4*i,i,1,8,a,o,s),Ye(r,n+4*i,i,1,8,a,o,s)}function er(t,e,r,n,i,a,o,s){Ye(t,e+4,1,i,8,a,o,s),Ye(r,n+4,1,i,8,a,o,s)}function rr(){this.ba=new ot,this.ec=[],this.cc=[],this.Mc=[],this.Dc=this.Nc=this.dc=this.fc=0,this.Oa=new ct,this.memory=0,this.Ib="OutputFunc",this.Jb="OutputAlphaFunc",this.Nd="OutputRowFunc"}function nr(){this.data=[],this.offset=this.kd=this.ha=this.w=0,this.na=[],this.xa=this.gb=this.Ja=this.Sa=this.P=0}function ir(){this.nc=this.Ea=this.b=this.hc=0,this.K=[],this.w=0}function ar(){this.ua=0,this.Wa=new M,this.vb=new M,this.md=this.xc=this.wc=0,this.vc=[],this.Wb=0,this.Ya=new d,this.yc=new h}function or(){this.xb=this.a=0,this.l=new Gt,this.ca=new ot,this.V=[],this.Ba=0,this.Ta=[],this.Ua=0,this.m=new N,this.Pb=0,this.wd=new N,this.Ma=this.$=this.C=this.i=this.c=this.xd=0,this.s=new ar,this.ab=0,this.gc=o(4,ir),this.Oc=0}function sr(){this.Lc=this.Z=this.$a=this.i=this.c=0,this.l=new Gt,this.ic=0,this.ca=[],this.tb=0,this.qd=null,this.rd=0}function cr(t,e,r,n,i,a,o){for(t=null==t?0:t[e+0],e=0;e<o;++e)i[a+e]=t+r[n+e]&255,t=i[a+e]}function ur(t,e,r,n,i,a,o){var s;if(null==t)cr(null,null,r,n,i,a,o);else for(s=0;s<o;++s)i[a+s]=t[e+s]+r[n+s]&255}function lr(t,e,r,n,i,a,o){if(null==t)cr(null,null,r,n,i,a,o);else{var s,c=t[e+0],u=c,l=c;for(s=0;s<o;++s)u=l+(c=t[e+s])-u,l=r[n+s]+(-256&u?0>u?0:255:u)&255,u=c,i[a+s]=l}}function hr(t,r,i,o){var s=r.width,c=r.o;if(e(null!=t&&null!=r),0>i||0>=o||i+o>c)return null;if(!t.Cc){if(null==t.ga){var u;if(t.ga=new sr,(u=null==t.ga)||(u=r.width*r.o,e(0==t.Gb.length),t.Gb=a(u),t.Uc=0,null==t.Gb?u=0:(t.mb=t.Gb,t.nb=t.Uc,t.rc=null,u=1),u=!u),!u){u=t.ga;var l=t.Fa,h=t.P,f=t.qc,d=t.mb,p=t.nb,g=h+1,m=f-1,b=u.l;if(e(null!=l&&null!=d&&null!=r),mi[0]=null,mi[1]=cr,mi[2]=ur,mi[3]=lr,u.ca=d,u.tb=p,u.c=r.width,u.i=r.height,e(0<u.c&&0<u.i),1>=f)r=0;else if(u.$a=l[h+0]>>0&3,u.Z=l[h+0]>>2&3,u.Lc=l[h+0]>>4&3,h=l[h+0]>>6&3,0>u.$a||1<u.$a||4<=u.Z||1<u.Lc||h)r=0;else if(b.put=dt,b.ac=ft,b.bc=pt,b.ma=u,b.width=r.width,b.height=r.height,b.Da=r.Da,b.v=r.v,b.va=r.va,b.j=r.j,b.o=r.o,u.$a)t:{e(1==u.$a),r=kt();e:for(;;){if(null==r){r=0;break t}if(e(null!=u),u.mc=r,r.c=u.c,r.i=u.i,r.l=u.l,r.l.ma=u,r.l.width=u.c,r.l.height=u.i,r.a=0,v(r.m,l,g,m),!Ft(u.c,u.i,1,r,null))break e;if(1==r.ab&&3==r.gc[0].hc&&At(r.s)?(u.ic=1,l=r.c*r.i,r.Ta=null,r.Ua=0,r.V=a(l),r.Ba=0,null==r.V?(r.a=1,r=0):r=1):(u.ic=0,r=It(r,u.c)),!r)break e;r=1;break t}u.mc=null,r=0}else r=m>=u.c*u.i;u=!r}if(u)return null;1!=t.ga.Lc?t.Ga=0:o=c-i}e(null!=t.ga),e(i+o<=c);t:{if(r=(l=t.ga).c,c=l.l.o,0==l.$a){if(g=t.rc,m=t.Vc,b=t.Fa,h=t.P+1+i*r,f=t.mb,d=t.nb+i*r,e(h<=t.P+t.qc),0!=l.Z)for(e(null!=mi[l.Z]),u=0;u<o;++u)mi[l.Z](g,m,b,h,f,d,r),g=f,m=d,d+=r,h+=r;else for(u=0;u<o;++u)n(f,d,b,h,r),g=f,m=d,d+=r,h+=r;t.rc=g,t.Vc=m}else{if(e(null!=l.mc),r=i+o,e(null!=(u=l.mc)),e(r<=u.i),u.C>=r)r=1;else if(l.ic||mr(),l.ic){l=u.V,g=u.Ba,m=u.c;var y=u.i,w=(b=1,h=u.$/m,f=u.$%m,d=u.m,p=u.s,u.$),N=m*y,L=m*r,x=p.wc,_=w<L?wt(p,f,h):null;e(w<=N),e(r<=y),e(At(p));e:for(;;){for(;!d.h&&w<L;){if(f&x||(_=wt(p,f,h)),e(null!=_),S(d),256>(y=bt(_.G[0],_.H[0],d)))l[g+w]=y,++w,++f>=m&&(f=0,++h<=r&&!(h%16)&&St(u,h));else{if(!(280>y)){b=0;break e}y=mt(y-256,d);var P,k=bt(_.G[4],_.H[4],d);if(S(d),!(w>=(k=vt(m,k=mt(k,d)))&&N-w>=y)){b=0;break e}for(P=0;P<y;++P)l[g+w+P]=l[g+w+P-k];for(w+=y,f+=y;f>=m;)f-=m,++h<=r&&!(h%16)&&St(u,h);w<L&&f&x&&(_=wt(p,f,h))}e(d.h==A(d))}St(u,h>r?r:h);break e}!b||d.h&&w<N?(b=0,u.a=d.h?5:3):u.$=w,r=b}else r=_t(u,u.V,u.Ba,u.c,u.i,r,Ct);if(!r){o=0;break t}}i+o>=c&&(t.Cc=1),o=1}if(!o)return null;if(t.Cc&&(null!=(o=t.ga)&&(o.mc=null),t.ga=null,0<t.Ga))return alert("todo:WebPDequantizeLevels"),null}return t.nb+i*s}function fr(t,e,r,n,i,a){for(;0<i--;){var o,s=t,c=e+(r?1:0),u=t,l=e+(r?0:3);for(o=0;o<n;++o){var h=u[l+4*o];255!=h&&(h*=32897,s[c+4*o+0]=s[c+4*o+0]*h>>23,s[c+4*o+1]=s[c+4*o+1]*h>>23,s[c+4*o+2]=s[c+4*o+2]*h>>23)}e+=a}}function dr(t,e,r,n,i){for(;0<n--;){var a;for(a=0;a<r;++a){var o=t[e+2*a+0],s=15&(u=t[e+2*a+1]),c=4369*s,u=(240&u|u>>4)*c>>16;t[e+2*a+0]=(240&o|o>>4)*c>>16&240|(15&o|o<<4)*c>>16>>4&15,t[e+2*a+1]=240&u|s}e+=i}}function pr(t,e,r,n,i,a,o,s){var c,u,l=255;for(u=0;u<i;++u){for(c=0;c<n;++c){var h=t[e+c];a[o+4*c]=h,l&=h}e+=r,o+=s}return 255!=l}function gr(t,e,r,n,i){var a;for(a=0;a<i;++a)r[n+a]=t[e+a]>>8}function mr(){An=fr,xn=dr,Sn=pr,_n=gr}function vr(r,n,i){t[r]=function(t,r,a,o,s,c,u,l,h,f,d,p,g,m,v,b,y){var w,N=y-1>>1,L=s[c+0]|u[l+0]<<16,A=h[f+0]|d[p+0]<<16;e(null!=t);var x=3*L+A+131074>>2;for(n(t[r+0],255&x,x>>16,g,m),null!=a&&(x=3*A+L+131074>>2,n(a[o+0],255&x,x>>16,v,b)),w=1;w<=N;++w){var S=s[c+w]|u[l+w]<<16,_=h[f+w]|d[p+w]<<16,P=L+S+A+_+524296,k=P+2*(S+A)>>3;x=k+L>>1,L=(P=P+2*(L+_)>>3)+S>>1,n(t[r+2*w-1],255&x,x>>16,g,m+(2*w-1)*i),n(t[r+2*w-0],255&L,L>>16,g,m+(2*w-0)*i),null!=a&&(x=P+A>>1,L=k+_>>1,n(a[o+2*w-1],255&x,x>>16,v,b+(2*w-1)*i),n(a[o+2*w+0],255&L,L>>16,v,b+(2*w+0)*i)),L=S,A=_}1&y||(x=3*L+A+131074>>2,n(t[r+y-1],255&x,x>>16,g,m+(y-1)*i),null!=a&&(x=3*A+L+131074>>2,n(a[o+y-1],255&x,x>>16,v,b+(y-1)*i)))}}function br(){vi[En]=bi,vi[qn]=wi,vi[Dn]=yi,vi[Rn]=Ni,vi[Tn]=Li,vi[Un]=Ai,vi[zn]=xi,vi[Hn]=wi,vi[Wn]=Ni,vi[Vn]=Li,vi[Gn]=Ai}function yr(t){return t&~Ii?0>t?0:255:t>>Fi}function wr(t,e){return yr((19077*t>>8)+(26149*e>>8)-14234)}function Nr(t,e,r){return yr((19077*t>>8)-(6419*e>>8)-(13320*r>>8)+8708)}function Lr(t,e){return yr((19077*t>>8)+(33050*e>>8)-17685)}function Ar(t,e,r,n,i){n[i+0]=wr(t,r),n[i+1]=Nr(t,e,r),n[i+2]=Lr(t,e)}function xr(t,e,r,n,i){n[i+0]=Lr(t,e),n[i+1]=Nr(t,e,r),n[i+2]=wr(t,r)}function Sr(t,e,r,n,i){var a=Nr(t,e,r);e=a<<3&224|Lr(t,e)>>3,n[i+0]=248&wr(t,r)|a>>5,n[i+1]=e}function _r(t,e,r,n,i){var a=240&Lr(t,e)|15;n[i+0]=240&wr(t,r)|Nr(t,e,r)>>4,n[i+1]=a}function Pr(t,e,r,n,i){n[i+0]=255,Ar(t,e,r,n,i+1)}function kr(t,e,r,n,i){xr(t,e,r,n,i),n[i+3]=255}function Fr(t,e,r,n,i){Ar(t,e,r,n,i),n[i+3]=255}function Vt(t,e){return 0>t?0:t>e?e:t}function Ir(e,r,n){t[e]=function(t,e,i,a,o,s,c,u,l){for(var h=u+(-2&l)*n;u!=h;)r(t[e+0],i[a+0],o[s+0],c,u),r(t[e+1],i[a+0],o[s+0],c,u+n),e+=2,++a,++s,u+=2*n;1&l&&r(t[e+0],i[a+0],o[s+0],c,u)}}function Cr(t,e,r){return 0==r?0==t?0==e?6:5:0==e?4:0:r}function jr(t,e,r,n,i){switch(t>>>30){case 3:on(e,r,n,i,0);break;case 2:sn(e,r,n,i);break;case 1:un(e,r,n,i)}}function Or(t,e){var r,a,o=e.M,s=e.Nb,c=t.oc,u=t.pc+40,l=t.oc,h=t.pc+584,f=t.oc,d=t.pc+600;for(r=0;16>r;++r)c[u+32*r-1]=129;for(r=0;8>r;++r)l[h+32*r-1]=129,f[d+32*r-1]=129;for(0<o?c[u-1-32]=l[h-1-32]=f[d-1-32]=129:(i(c,u-32-1,127,21),i(l,h-32-1,127,9),i(f,d-32-1,127,9)),a=0;a<t.za;++a){var p=e.ya[e.aa+a];if(0<a){for(r=-1;16>r;++r)n(c,u+32*r-4,c,u+32*r+12,4);for(r=-1;8>r;++r)n(l,h+32*r-4,l,h+32*r+4,4),n(f,d+32*r-4,f,d+32*r+4,4)}var g=t.Gd,m=t.Hd+a,v=p.ad,b=p.Hc;if(0<o&&(n(c,u-32,g[m].y,0,16),n(l,h-32,g[m].f,0,8),n(f,d-32,g[m].ea,0,8)),p.Za){var y=c,w=u-32+16;for(0<o&&(a>=t.za-1?i(y,w,g[m].y[15],4):n(y,w,g[m+1].y,0,4)),r=0;4>r;r++)y[w+128+r]=y[w+256+r]=y[w+384+r]=y[w+0+r];for(r=0;16>r;++r,b<<=2)y=c,w=u+Di[r],fi[p.Ob[r]](y,w),jr(b,v,16*+r,y,w)}else if(y=Cr(a,o,p.Ob[0]),hi[y](c,u),0!=b)for(r=0;16>r;++r,b<<=2)jr(b,v,16*+r,c,u+Di[r]);for(r=p.Gc,y=Cr(a,o,p.Dd),di[y](l,h),di[y](f,d),b=v,y=l,w=h,255&(p=r>>0)&&(170&p?cn(b,256,y,w):ln(b,256,y,w)),p=f,b=d,255&(r>>=8)&&(170&r?cn(v,320,p,b):ln(v,320,p,b)),o<t.Ub-1&&(n(g[m].y,0,c,u+480,16),n(g[m].f,0,l,h+224,8),n(g[m].ea,0,f,d+224,8)),r=8*s*t.B,g=t.sa,m=t.ta+16*a+16*s*t.R,v=t.qa,p=t.ra+8*a+r,b=t.Ha,y=t.Ia+8*a+r,r=0;16>r;++r)n(g,m+r*t.R,c,u+32*r,16);for(r=0;8>r;++r)n(v,p+r*t.B,l,h+32*r,8),n(b,y+r*t.B,f,d+32*r,8)}}function Br(t,n,i,a,o,s,c,u,l){var h=[0],f=[0],d=0,p=null!=l?l.kd:0,g=null!=l?l:new nr;if(null==t||12>i)return 7;g.data=t,g.w=n,g.ha=i,n=[n],i=[i],g.gb=[g.gb];t:{var m=n,b=i,y=g.gb;if(e(null!=t),e(null!=b),e(null!=y),y[0]=0,12<=b[0]&&!r(t,m[0],"RIFF")){if(r(t,m[0]+8,"WEBP")){y=3;break t}var w=j(t,m[0]+4);if(12>w||4294967286<w){y=3;break t}if(p&&w>b[0]-8){y=7;break t}y[0]=w,m[0]+=12,b[0]-=12}y=0}if(0!=y)return y;for(w=0<g.gb[0],i=i[0];;){t:{var L=t;b=n,y=i;var A=h,x=f,S=m=[0];if((k=d=[d])[0]=0,8>y[0])y=7;else{if(!r(L,b[0],"VP8X")){if(10!=j(L,b[0]+4)){y=3;break t}if(18>y[0]){y=7;break t}var _=j(L,b[0]+8),P=1+C(L,b[0]+12);if(2147483648<=P*(L=1+C(L,b[0]+15))){y=3;break t}null!=S&&(S[0]=_),null!=A&&(A[0]=P),null!=x&&(x[0]=L),b[0]+=18,y[0]-=18,k[0]=1}y=0}}if(d=d[0],m=m[0],0!=y)return y;if(b=!!(2&m),!w&&d)return 3;if(null!=s&&(s[0]=!!(16&m)),null!=c&&(c[0]=b),null!=u&&(u[0]=0),c=h[0],m=f[0],d&&b&&null==l){y=0;break}if(4>i){y=7;break}if(w&&d||!w&&!d&&!r(t,n[0],"ALPH")){i=[i],g.na=[g.na],g.P=[g.P],g.Sa=[g.Sa];t:{_=t,y=n,w=i;var k=g.gb;A=g.na,x=g.P,S=g.Sa;P=22,e(null!=_),e(null!=w),L=y[0];var F=w[0];for(e(null!=A),e(null!=S),A[0]=null,x[0]=null,S[0]=0;;){if(y[0]=L,w[0]=F,8>F){y=7;break t}var I=j(_,L+4);if(4294967286<I){y=3;break t}var O=8+I+1&-2;if(P+=O,0<k&&P>k){y=3;break t}if(!r(_,L,"VP8 ")||!r(_,L,"VP8L")){y=0;break t}if(F[0]<O){y=7;break t}r(_,L,"ALPH")||(A[0]=_,x[0]=L+8,S[0]=I),L+=O,F-=O}}if(i=i[0],g.na=g.na[0],g.P=g.P[0],g.Sa=g.Sa[0],0!=y)break}i=[i],g.Ja=[g.Ja],g.xa=[g.xa];t:if(k=t,y=n,w=i,A=g.gb[0],x=g.Ja,S=g.xa,_=y[0],L=!r(k,_,"VP8 "),P=!r(k,_,"VP8L"),e(null!=k),e(null!=w),e(null!=x),e(null!=S),8>w[0])y=7;else{if(L||P){if(k=j(k,_+4),12<=A&&k>A-12){y=3;break t}if(p&&k>w[0]-8){y=7;break t}x[0]=k,y[0]+=8,w[0]-=8,S[0]=P}else S[0]=5<=w[0]&&47==k[_+0]&&!(k[_+4]>>5),x[0]=w[0];y=0}if(i=i[0],g.Ja=g.Ja[0],g.xa=g.xa[0],n=n[0],0!=y)break;if(4294967286<g.Ja)return 3;if(null==u||b||(u[0]=g.xa?2:1),c=[c],m=[m],g.xa){if(5>i){y=7;break}u=c,p=m,b=s,null==t||5>i?t=0:5<=i&&47==t[n+0]&&!(t[n+4]>>5)?(w=[0],k=[0],A=[0],v(x=new N,t,n,i),gt(x,w,k,A)?(null!=u&&(u[0]=w[0]),null!=p&&(p[0]=k[0]),null!=b&&(b[0]=A[0]),t=1):t=0):t=0}else{if(10>i){y=7;break}u=m,null==t||10>i||!Xt(t,n+3,i-3)?t=0:(p=t[n+0]|t[n+1]<<8|t[n+2]<<16,b=16383&(t[n+7]<<8|t[n+6]),t=16383&(t[n+9]<<8|t[n+8]),1&p||3<(p>>1&7)||!(p>>4&1)||p>>5>=g.Ja||!b||!t?t=0:(c&&(c[0]=b),u&&(u[0]=t),t=1))}if(!t)return 3;if(c=c[0],m=m[0],d&&(h[0]!=c||f[0]!=m))return 3;null!=l&&(l[0]=g,l.offset=n-l.w,e(4294967286>n-l.w),e(l.offset==l.ha-i));break}return 0==y||7==y&&d&&null==l?(null!=s&&(s[0]|=null!=g.na&&0<g.na.length),null!=a&&(a[0]=c),null!=o&&(o[0]=m),0):y}function Mr(t,e,r){var n=e.width,i=e.height,a=0,o=0,s=n,c=i;if(e.Da=null!=t&&0<t.Da,e.Da&&(s=t.cd,c=t.bd,a=t.v,o=t.j,11>r||(a&=-2,o&=-2),0>a||0>o||0>=s||0>=c||a+s>n||o+c>i))return 0;if(e.v=a,e.j=o,e.va=a+s,e.o=o+c,e.U=s,e.T=c,e.da=null!=t&&0<t.da,e.da){if(!E(s,c,r=[t.ib],a=[t.hb]))return 0;e.ib=r[0],e.hb=a[0]}return e.ob=null!=t&&t.ob,e.Kb=null==t||!t.Sd,e.da&&(e.ob=e.ib<3*n/4&&e.hb<3*i/4,e.Kb=0),1}function Er(t){if(null==t)return 2;if(11>t.S){var e=t.f.RGBA;e.fb+=(t.height-1)*e.A,e.A=-e.A}else e=t.f.kb,t=t.height,e.O+=(t-1)*e.fa,e.fa=-e.fa,e.N+=(t-1>>1)*e.Ab,e.Ab=-e.Ab,e.W+=(t-1>>1)*e.Db,e.Db=-e.Db,null!=e.F&&(e.J+=(t-1)*e.lb,e.lb=-e.lb);return 0}function qr(t,e,r,n){if(null==n||0>=t||0>=e)return 2;if(null!=r){if(r.Da){var i=r.cd,o=r.bd,s=-2&r.v,c=-2&r.j;if(0>s||0>c||0>=i||0>=o||s+i>t||c+o>e)return 2;t=i,e=o}if(r.da){if(!E(t,e,i=[r.ib],o=[r.hb]))return 2;t=i[0],e=o[0]}}n.width=t,n.height=e;t:{var u=n.width,l=n.height;if(t=n.S,0>=u||0>=l||!(t>=En&&13>t))t=2;else{if(0>=n.Rd&&null==n.sd){s=o=i=e=0;var h=(c=u*zi[t])*l;if(11>t||(o=(l+1)/2*(e=(u+1)/2),12==t&&(s=(i=u)*l)),null==(l=a(h+2*o+s))){t=1;break t}n.sd=l,11>t?((u=n.f.RGBA).eb=l,u.fb=0,u.A=c,u.size=h):((u=n.f.kb).y=l,u.O=0,u.fa=c,u.Fd=h,u.f=l,u.N=0+h,u.Ab=e,u.Cd=o,u.ea=l,u.W=0+h+o,u.Db=e,u.Ed=o,12==t&&(u.F=l,u.J=0+h+2*o),u.Tc=s,u.lb=i)}if(e=1,i=n.S,o=n.width,s=n.height,i>=En&&13>i)if(11>i)t=n.f.RGBA,e&=(c=Math.abs(t.A))*(s-1)+o<=t.size,e&=c>=o*zi[i],e&=null!=t.eb;else{t=n.f.kb,c=(o+1)/2,h=(s+1)/2,u=Math.abs(t.fa);l=Math.abs(t.Ab);var f=Math.abs(t.Db),d=Math.abs(t.lb),p=d*(s-1)+o;e&=u*(s-1)+o<=t.Fd,e&=l*(h-1)+c<=t.Cd,e=(e&=f*(h-1)+c<=t.Ed)&u>=o&l>=c&f>=c,e&=null!=t.y,e&=null!=t.f,e&=null!=t.ea,12==i&&(e&=d>=o,e&=p<=t.Tc,e&=null!=t.F)}else e=0;t=e?0:2}}return 0!=t||null!=r&&r.fd&&(t=Er(n)),t}var Dr=64,Rr=[0,1,3,7,15,31,63,127,255,511,1023,2047,4095,8191,16383,32767,65535,131071,262143,524287,1048575,2097151,4194303,8388607,16777215],Tr=24,Ur=32,zr=8,Hr=[0,0,1,1,2,2,2,2,3,3,3,3,3,3,3,3,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,4,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,6,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7,7];R("Predictor0","PredictorAdd0"),t.Predictor0=function(){return 4278190080},t.Predictor1=function(t){return t},t.Predictor2=function(t,e,r){return e[r+0]},t.Predictor3=function(t,e,r){return e[r+1]},t.Predictor4=function(t,e,r){return e[r-1]},t.Predictor5=function(t,e,r){return U(U(t,e[r+1]),e[r+0])},t.Predictor6=function(t,e,r){return U(t,e[r-1])},t.Predictor7=function(t,e,r){return U(t,e[r+0])},t.Predictor8=function(t,e,r){return U(e[r-1],e[r+0])},t.Predictor9=function(t,e,r){return U(e[r+0],e[r+1])},t.Predictor10=function(t,e,r){return U(U(t,e[r-1]),U(e[r+0],e[r+1]))},t.Predictor11=function(t,e,r){var n=e[r+0];return 0>=W(n>>24&255,t>>24&255,(e=e[r-1])>>24&255)+W(n>>16&255,t>>16&255,e>>16&255)+W(n>>8&255,t>>8&255,e>>8&255)+W(255&n,255&t,255&e)?n:t},t.Predictor12=function(t,e,r){var n=e[r+0];return(z((t>>24&255)+(n>>24&255)-((e=e[r-1])>>24&255))<<24|z((t>>16&255)+(n>>16&255)-(e>>16&255))<<16|z((t>>8&255)+(n>>8&255)-(e>>8&255))<<8|z((255&t)+(255&n)-(255&e)))>>>0},t.Predictor13=function(t,e,r){var n=e[r-1];return(H((t=U(t,e[r+0]))>>24&255,n>>24&255)<<24|H(t>>16&255,n>>16&255)<<16|H(t>>8&255,n>>8&255)<<8|H(t>>0&255,n>>0&255))>>>0};var Wr=t.PredictorAdd0;t.PredictorAdd1=V,R("Predictor2","PredictorAdd2"),R("Predictor3","PredictorAdd3"),R("Predictor4","PredictorAdd4"),R("Predictor5","PredictorAdd5"),R("Predictor6","PredictorAdd6"),R("Predictor7","PredictorAdd7"),R("Predictor8","PredictorAdd8"),R("Predictor9","PredictorAdd9"),R("Predictor10","PredictorAdd10"),R("Predictor11","PredictorAdd11"),R("Predictor12","PredictorAdd12"),R("Predictor13","PredictorAdd13");var Vr=t.PredictorAdd2;X("ColorIndexInverseTransform","MapARGB","32b",(function(t){return t>>8&255}),(function(t){return t})),X("VP8LColorIndexInverseTransformAlpha","MapAlpha","8b",(function(t){return t}),(function(t){return t>>8&255}));var Gr,Yr=t.ColorIndexInverseTransform,Jr=t.MapARGB,Xr=t.VP8LColorIndexInverseTransformAlpha,Kr=t.MapAlpha,Zr=t.VP8LPredictorsAdd=[];Zr.length=16,(t.VP8LPredictors=[]).length=16,(t.VP8LPredictorsAdd_C=[]).length=16,(t.VP8LPredictors_C=[]).length=16;var $r,Qr,tn,en,rn,nn,an,on,sn,cn,un,ln,hn,fn,dn,pn,gn,mn,vn,bn,yn,wn,Nn,Ln,An,xn,Sn,_n,Pn=a(511),kn=a(2041),Fn=a(225),In=a(767),Cn=0,jn=kn,On=Fn,Bn=In,Mn=Pn,En=0,qn=1,Dn=2,Rn=3,Tn=4,Un=5,zn=6,Hn=7,Wn=8,Vn=9,Gn=10,Yn=[2,3,7],Jn=[3,3,11],Xn=[280,256,256,256,40],Kn=[0,1,1,1,0],Zn=[17,18,0,1,2,3,4,5,16,6,7,8,9,10,11,12,13,14,15],$n=[24,7,23,25,40,6,39,41,22,26,38,42,56,5,55,57,21,27,54,58,37,43,72,4,71,73,20,28,53,59,70,74,36,44,88,69,75,52,60,3,87,89,19,29,86,90,35,45,68,76,85,91,51,61,104,2,103,105,18,30,102,106,34,46,84,92,67,77,101,107,50,62,120,1,119,121,83,93,17,31,100,108,66,78,118,122,33,47,117,123,49,63,99,109,82,94,0,116,124,65,79,16,32,98,110,48,115,125,81,95,64,114,126,97,111,80,113,127,96,112],Qn=[2954,2956,2958,2962,2970,2986,3018,3082,3212,3468,3980,5004],ti=8,ei=[4,5,6,7,8,9,10,10,11,12,13,14,15,16,17,17,18,19,20,20,21,21,22,22,23,23,24,25,25,26,27,28,29,30,31,32,33,34,35,36,37,37,38,39,40,41,42,43,44,45,46,46,47,48,49,50,51,52,53,54,55,56,57,58,59,60,61,62,63,64,65,66,67,68,69,70,71,72,73,74,75,76,76,77,78,79,80,81,82,83,84,85,86,87,88,89,91,93,95,96,98,100,101,102,104,106,108,110,112,114,116,118,122,124,126,128,130,132,134,136,138,140,143,145,148,151,154,157],ri=[4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29,30,31,32,33,34,35,36,37,38,39,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,57,58,60,62,64,66,68,70,72,74,76,78,80,82,84,86,88,90,92,94,96,98,100,102,104,106,108,110,112,114,116,119,122,125,128,131,134,137,140,143,146,149,152,155,158,161,164,167,170,173,177,181,185,189,193,197,201,205,209,213,217,221,225,229,234,239,245,249,254,259,264,269,274,279,284],ni=null,ii=[[173,148,140,0],[176,155,140,135,0],[180,157,141,134,130,0],[254,254,243,230,196,177,153,140,133,130,129,0]],ai=[0,1,4,8,5,2,3,6,9,12,13,10,7,11,14,15],oi=[-0,1,-1,2,-2,3,4,6,-3,5,-4,-5,-6,7,-7,8,-8,-9],si=[[[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]],[[253,136,254,255,228,219,128,128,128,128,128],[189,129,242,255,227,213,255,219,128,128,128],[106,126,227,252,214,209,255,255,128,128,128]],[[1,98,248,255,236,226,255,255,128,128,128],[181,133,238,254,221,234,255,154,128,128,128],[78,134,202,247,198,180,255,219,128,128,128]],[[1,185,249,255,243,255,128,128,128,128,128],[184,150,247,255,236,224,128,128,128,128,128],[77,110,216,255,236,230,128,128,128,128,128]],[[1,101,251,255,241,255,128,128,128,128,128],[170,139,241,252,236,209,255,255,128,128,128],[37,116,196,243,228,255,255,255,128,128,128]],[[1,204,254,255,245,255,128,128,128,128,128],[207,160,250,255,238,128,128,128,128,128,128],[102,103,231,255,211,171,128,128,128,128,128]],[[1,152,252,255,240,255,128,128,128,128,128],[177,135,243,255,234,225,128,128,128,128,128],[80,129,211,255,194,224,128,128,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[246,1,255,128,128,128,128,128,128,128,128],[255,128,128,128,128,128,128,128,128,128,128]]],[[[198,35,237,223,193,187,162,160,145,155,62],[131,45,198,221,172,176,220,157,252,221,1],[68,47,146,208,149,167,221,162,255,223,128]],[[1,149,241,255,221,224,255,255,128,128,128],[184,141,234,253,222,220,255,199,128,128,128],[81,99,181,242,176,190,249,202,255,255,128]],[[1,129,232,253,214,197,242,196,255,255,128],[99,121,210,250,201,198,255,202,128,128,128],[23,91,163,242,170,187,247,210,255,255,128]],[[1,200,246,255,234,255,128,128,128,128,128],[109,178,241,255,231,245,255,255,128,128,128],[44,130,201,253,205,192,255,255,128,128,128]],[[1,132,239,251,219,209,255,165,128,128,128],[94,136,225,251,218,190,255,255,128,128,128],[22,100,174,245,186,161,255,199,128,128,128]],[[1,182,249,255,232,235,128,128,128,128,128],[124,143,241,255,227,234,128,128,128,128,128],[35,77,181,251,193,211,255,205,128,128,128]],[[1,157,247,255,236,231,255,255,128,128,128],[121,141,235,255,225,227,255,255,128,128,128],[45,99,188,251,195,217,255,224,128,128,128]],[[1,1,251,255,213,255,128,128,128,128,128],[203,1,248,255,255,128,128,128,128,128,128],[137,1,177,255,224,255,128,128,128,128,128]]],[[[253,9,248,251,207,208,255,192,128,128,128],[175,13,224,243,193,185,249,198,255,255,128],[73,17,171,221,161,179,236,167,255,234,128]],[[1,95,247,253,212,183,255,255,128,128,128],[239,90,244,250,211,209,255,255,128,128,128],[155,77,195,248,188,195,255,255,128,128,128]],[[1,24,239,251,218,219,255,205,128,128,128],[201,51,219,255,196,186,128,128,128,128,128],[69,46,190,239,201,218,255,228,128,128,128]],[[1,191,251,255,255,128,128,128,128,128,128],[223,165,249,255,213,255,128,128,128,128,128],[141,124,248,255,255,128,128,128,128,128,128]],[[1,16,248,255,255,128,128,128,128,128,128],[190,36,230,255,236,255,128,128,128,128,128],[149,1,255,128,128,128,128,128,128,128,128]],[[1,226,255,128,128,128,128,128,128,128,128],[247,192,255,128,128,128,128,128,128,128,128],[240,128,255,128,128,128,128,128,128,128,128]],[[1,134,252,255,255,128,128,128,128,128,128],[213,62,250,255,255,128,128,128,128,128,128],[55,93,255,128,128,128,128,128,128,128,128]],[[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128],[128,128,128,128,128,128,128,128,128,128,128]]],[[[202,24,213,235,186,191,220,160,240,175,255],[126,38,182,232,169,184,228,174,255,187,128],[61,46,138,219,151,178,240,170,255,216,128]],[[1,112,230,250,199,191,247,159,255,255,128],[166,109,228,252,211,215,255,174,128,128,128],[39,77,162,232,172,180,245,178,255,255,128]],[[1,52,220,246,198,199,249,220,255,255,128],[124,74,191,243,183,193,250,221,255,255,128],[24,71,130,219,154,170,243,182,255,255,128]],[[1,182,225,249,219,240,255,224,128,128,128],[149,150,226,252,216,205,255,171,128,128,128],[28,108,170,242,183,194,254,223,255,255,128]],[[1,81,230,252,204,203,255,192,128,128,128],[123,102,209,247,188,196,255,233,128,128,128],[20,95,153,243,164,173,255,203,128,128,128]],[[1,222,248,255,216,213,128,128,128,128,128],[168,175,246,252,235,205,255,255,128,128,128],[47,116,215,255,211,212,255,255,128,128,128]],[[1,121,236,253,212,214,255,255,128,128,128],[141,84,213,252,201,202,255,219,128,128,128],[42,80,160,240,162,185,255,205,128,128,128]],[[1,1,255,128,128,128,128,128,128,128,128],[244,1,255,128,128,128,128,128,128,128,128],[238,1,255,128,128,128,128,128,128,128,128]]]],ci=[[[231,120,48,89,115,113,120,152,112],[152,179,64,126,170,118,46,70,95],[175,69,143,80,85,82,72,155,103],[56,58,10,171,218,189,17,13,152],[114,26,17,163,44,195,21,10,173],[121,24,80,195,26,62,44,64,85],[144,71,10,38,171,213,144,34,26],[170,46,55,19,136,160,33,206,71],[63,20,8,114,114,208,12,9,226],[81,40,11,96,182,84,29,16,36]],[[134,183,89,137,98,101,106,165,148],[72,187,100,130,157,111,32,75,80],[66,102,167,99,74,62,40,234,128],[41,53,9,178,241,141,26,8,107],[74,43,26,146,73,166,49,23,157],[65,38,105,160,51,52,31,115,128],[104,79,12,27,217,255,87,17,7],[87,68,71,44,114,51,15,186,23],[47,41,14,110,182,183,21,17,194],[66,45,25,102,197,189,23,18,22]],[[88,88,147,150,42,46,45,196,205],[43,97,183,117,85,38,35,179,61],[39,53,200,87,26,21,43,232,171],[56,34,51,104,114,102,29,93,77],[39,28,85,171,58,165,90,98,64],[34,22,116,206,23,34,43,166,73],[107,54,32,26,51,1,81,43,31],[68,25,106,22,64,171,36,225,114],[34,19,21,102,132,188,16,76,124],[62,18,78,95,85,57,50,48,51]],[[193,101,35,159,215,111,89,46,111],[60,148,31,172,219,228,21,18,111],[112,113,77,85,179,255,38,120,114],[40,42,1,196,245,209,10,25,109],[88,43,29,140,166,213,37,43,154],[61,63,30,155,67,45,68,1,209],[100,80,8,43,154,1,51,26,71],[142,78,78,16,255,128,34,197,171],[41,40,5,102,211,183,4,1,221],[51,50,17,168,209,192,23,25,82]],[[138,31,36,171,27,166,38,44,229],[67,87,58,169,82,115,26,59,179],[63,59,90,180,59,166,93,73,154],[40,40,21,116,143,209,34,39,175],[47,15,16,183,34,223,49,45,183],[46,17,33,183,6,98,15,32,183],[57,46,22,24,128,1,54,17,37],[65,32,73,115,28,128,23,128,205],[40,3,9,115,51,192,18,6,223],[87,37,9,115,59,77,64,21,47]],[[104,55,44,218,9,54,53,130,226],[64,90,70,205,40,41,23,26,57],[54,57,112,184,5,41,38,166,213],[30,34,26,133,152,116,10,32,134],[39,19,53,221,26,114,32,73,255],[31,9,65,234,2,15,1,118,73],[75,32,12,51,192,255,160,43,51],[88,31,35,67,102,85,55,186,85],[56,21,23,111,59,205,45,37,192],[55,38,70,124,73,102,1,34,98]],[[125,98,42,88,104,85,117,175,82],[95,84,53,89,128,100,113,101,45],[75,79,123,47,51,128,81,171,1],[57,17,5,71,102,57,53,41,49],[38,33,13,121,57,73,26,1,85],[41,10,67,138,77,110,90,47,114],[115,21,2,10,102,255,166,23,6],[101,29,16,10,85,128,101,196,26],[57,18,10,102,102,213,34,20,43],[117,20,15,36,163,128,68,1,26]],[[102,61,71,37,34,53,31,243,192],[69,60,71,38,73,119,28,222,37],[68,45,128,34,1,47,11,245,171],[62,17,19,70,146,85,55,62,70],[37,43,37,154,100,163,85,160,1],[63,9,92,136,28,64,32,201,85],[75,15,9,9,64,255,184,119,16],[86,6,28,5,64,255,25,248,1],[56,8,17,132,137,255,55,116,128],[58,15,20,82,135,57,26,121,40]],[[164,50,31,137,154,133,25,35,218],[51,103,44,131,131,123,31,6,158],[86,40,64,135,148,224,45,183,128],[22,26,17,131,240,154,14,1,209],[45,16,21,91,64,222,7,1,197],[56,21,39,155,60,138,23,102,213],[83,12,13,54,192,255,68,47,28],[85,26,85,85,128,128,32,146,171],[18,11,7,63,144,171,4,4,246],[35,27,10,146,174,171,12,26,128]],[[190,80,35,99,180,80,126,54,45],[85,126,47,87,176,51,41,20,32],[101,75,128,139,118,146,116,128,85],[56,41,15,176,236,85,37,9,62],[71,30,17,119,118,255,17,18,138],[101,38,60,138,55,70,43,26,142],[146,36,19,30,171,255,97,27,20],[138,45,61,62,219,1,81,188,64],[32,41,20,117,151,142,20,21,163],[112,19,12,61,195,128,48,4,24]]],ui=[[[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[176,246,255,255,255,255,255,255,255,255,255],[223,241,252,255,255,255,255,255,255,255,255],[249,253,253,255,255,255,255,255,255,255,255]],[[255,244,252,255,255,255,255,255,255,255,255],[234,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255]],[[255,246,254,255,255,255,255,255,255,255,255],[239,253,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[251,255,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[251,254,254,255,255,255,255,255,255,255,255],[254,255,254,255,255,255,255,255,255,255,255]],[[255,254,253,255,254,255,255,255,255,255,255],[250,255,254,255,254,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[217,255,255,255,255,255,255,255,255,255,255],[225,252,241,253,255,255,254,255,255,255,255],[234,250,241,250,253,255,253,254,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[223,254,254,255,255,255,255,255,255,255,255],[238,253,254,254,255,255,255,255,255,255,255]],[[255,248,254,255,255,255,255,255,255,255,255],[249,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,255,255,255,255,255,255,255,255,255],[247,254,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[252,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[253,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[186,251,250,255,255,255,255,255,255,255,255],[234,251,244,254,255,255,255,255,255,255,255],[251,251,243,253,254,255,254,255,255,255,255]],[[255,253,254,255,255,255,255,255,255,255,255],[236,253,254,255,255,255,255,255,255,255,255],[251,253,253,254,254,255,255,255,255,255,255]],[[255,254,254,255,255,255,255,255,255,255,255],[254,254,254,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,254,255,255,255,255,255,255,255,255,255],[254,254,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]],[[[248,255,255,255,255,255,255,255,255,255,255],[250,254,252,254,255,255,255,255,255,255,255],[248,254,249,253,255,255,255,255,255,255,255]],[[255,253,253,255,255,255,255,255,255,255,255],[246,253,253,255,255,255,255,255,255,255,255],[252,254,251,254,254,255,255,255,255,255,255]],[[255,254,252,255,255,255,255,255,255,255,255],[248,254,253,255,255,255,255,255,255,255,255],[253,255,254,254,255,255,255,255,255,255,255]],[[255,251,254,255,255,255,255,255,255,255,255],[245,251,254,255,255,255,255,255,255,255,255],[253,253,254,255,255,255,255,255,255,255,255]],[[255,251,253,255,255,255,255,255,255,255,255],[252,253,254,255,255,255,255,255,255,255,255],[255,254,255,255,255,255,255,255,255,255,255]],[[255,252,255,255,255,255,255,255,255,255,255],[249,255,254,255,255,255,255,255,255,255,255],[255,255,254,255,255,255,255,255,255,255,255]],[[255,255,253,255,255,255,255,255,255,255,255],[250,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]],[[255,255,255,255,255,255,255,255,255,255,255],[254,255,255,255,255,255,255,255,255,255,255],[255,255,255,255,255,255,255,255,255,255,255]]]],li=[0,1,2,3,6,4,5,6,6,6,6,6,6,6,6,7,0],hi=[],fi=[],di=[],pi=1,gi=2,mi=[],vi=[];vr("UpsampleRgbLinePair",Ar,3),vr("UpsampleBgrLinePair",xr,3),vr("UpsampleRgbaLinePair",Fr,4),vr("UpsampleBgraLinePair",kr,4),vr("UpsampleArgbLinePair",Pr,4),vr("UpsampleRgba4444LinePair",_r,2),vr("UpsampleRgb565LinePair",Sr,2);var bi=t.UpsampleRgbLinePair,yi=t.UpsampleBgrLinePair,wi=t.UpsampleRgbaLinePair,Ni=t.UpsampleBgraLinePair,Li=t.UpsampleArgbLinePair,Ai=t.UpsampleRgba4444LinePair,xi=t.UpsampleRgb565LinePair,Si=16,_i=1<<Si-1,Pi=-227,ki=482,Fi=6,Ii=(256<<Fi)-1,Ci=0,ji=a(256),Oi=a(256),Bi=a(256),Mi=a(256),Ei=a(ki-Pi),qi=a(ki-Pi);Ir("YuvToRgbRow",Ar,3),Ir("YuvToBgrRow",xr,3),Ir("YuvToRgbaRow",Fr,4),Ir("YuvToBgraRow",kr,4),Ir("YuvToArgbRow",Pr,4),Ir("YuvToRgba4444Row",_r,2),Ir("YuvToRgb565Row",Sr,2);var Di=[0,4,8,12,128,132,136,140,256,260,264,268,384,388,392,396],Ri=[0,2,8],Ti=[8,7,6,4,4,2,2,2,1,1,1,1],Ui=1;this.WebPDecodeRGBA=function(t,r,n,i,a){var o=qn,s=new rr,c=new ot;s.ba=c,c.S=o,c.width=[c.width],c.height=[c.height];var u=c.width,l=c.height,h=new st;if(null==h||null==t)var f=2;else e(null!=h),f=Br(t,r,n,h.width,h.height,h.Pd,h.Qd,h.format,null);if(0!=f?u=0:(null!=u&&(u[0]=h.width[0]),null!=l&&(l[0]=h.height[0]),u=1),u){c.width=c.width[0],c.height=c.height[0],null!=i&&(i[0]=c.width),null!=a&&(a[0]=c.height);t:{if(i=new Gt,(a=new nr).data=t,a.w=r,a.ha=n,a.kd=1,r=[0],e(null!=a),(0==(t=Br(a.data,a.w,a.ha,null,null,null,r,null,a))||7==t)&&r[0]&&(t=4),0==(r=t)){if(e(null!=s),i.data=a.data,i.w=a.w+a.offset,i.ha=a.ha-a.offset,i.put=dt,i.ac=ft,i.bc=pt,i.ma=s,a.xa){if(null==(t=kt())){s=1;break t}if(function(t,r){var n=[0],i=[0],a=[0];e:for(;;){if(null==t)return 0;if(null==r)return t.a=2,0;if(t.l=r,t.a=0,v(t.m,r.data,r.w,r.ha),!gt(t.m,n,i,a)){t.a=3;break e}if(t.xb=gi,r.width=n[0],r.height=i[0],!Ft(n[0],i[0],1,t,null))break e;return 1}return e(0!=t.a),0}(t,i)){if(i=0==(r=qr(i.width,i.height,s.Oa,s.ba))){e:{i=t;r:for(;;){if(null==i){i=0;break e}if(e(null!=i.s.yc),e(null!=i.s.Ya),e(0<i.s.Wb),e(null!=(n=i.l)),e(null!=(a=n.ma)),0!=i.xb){if(i.ca=a.ba,i.tb=a.tb,e(null!=i.ca),!Mr(a.Oa,n,Rn)){i.a=2;break r}if(!It(i,n.width))break r;if(n.da)break r;if((n.da||nt(i.ca.S))&&mr(),11>i.ca.S||(alert("todo:WebPInitConvertARGBToYUV"),null!=i.ca.f.kb.F&&mr()),i.Pb&&0<i.s.ua&&null==i.s.vb.X&&!O(i.s.vb,i.s.Wa.Xa)){i.a=1;break r}i.xb=0}if(!_t(i,i.V,i.Ba,i.c,i.i,n.o,Lt))break r;a.Dc=i.Ma,i=1;break e}e(0!=i.a),i=0}i=!i}i&&(r=t.a)}else r=t.a}else{if(null==(t=new Yt)){s=1;break t}if(t.Fa=a.na,t.P=a.P,t.qc=a.Sa,Kt(t,i)){if(0==(r=qr(i.width,i.height,s.Oa,s.ba))){if(t.Aa=0,n=s.Oa,e(null!=(a=t)),null!=n){if(0<(u=0>(u=n.Md)?0:100<u?255:255*u/100)){for(l=h=0;4>l;++l)12>(f=a.pb[l]).lc&&(f.ia=u*Ti[0>f.lc?0:f.lc]>>3),h|=f.ia;h&&(alert("todo:VP8InitRandom"),a.ia=1)}a.Ga=n.Id,100<a.Ga?a.Ga=100:0>a.Ga&&(a.Ga=0)}Qt(t,i)||(r=t.a)}}else r=t.a}0==r&&null!=s.Oa&&s.Oa.fd&&(r=Er(s.ba))}s=r}o=0!=s?null:11>o?c.f.RGBA.eb:c.f.kb.y}else o=null;return o};var zi=[3,4,3,4,4,2,2,4,4,4,2,1,1]};function u(t,e){for(var r="",n=0;n<4;n++)r+=String.fromCharCode(t[e++]);return r}function l(t,e){return(t[e+0]<<0|t[e+1]<<8|t[e+2]<<16)>>>0}function h(t,e){return(t[e+0]<<0|t[e+1]<<8|t[e+2]<<16|t[e+3]<<24)>>>0}new c;var f=[0],d=[0],p=[],g=new c,m=t,v=function(t,e){var r={},n=0,i=!1,a=0,o=0;if(r.frames=[],!
/** @license
     * Copyright (c) 2017 Dominik Homberger
    Permission is hereby granted, free of charge, to any person obtaining a copy of this software and associated documentation files (the "Software"), to deal in the Software without restriction, including without limitation the rights to use, copy, modify, merge, publish, distribute, sublicense, and/or sell copies of the Software, and to permit persons to whom the Software is furnished to do so, subject to the following conditions:
    The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
    THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
    https://webpjs.appspot.com
    WebPRiffParser dominikhlbg@gmail.com
    */
function(t,e,r,n){for(var i=0;i<n;i++)if(t[e+i]!=r.charCodeAt(i))return!0;return!1}(t,e,"RIFF",4)){var s,c;h(t,e+=4);for(e+=8;e<t.length;){var f=u(t,e),d=h(t,e+=4);e+=4;var p=d+(1&d);switch(f){case"VP8 ":case"VP8L":void 0===r.frames[n]&&(r.frames[n]={});(v=r.frames[n]).src_off=i?o:e-8,v.src_size=a+d+8,n++,i&&(i=!1,a=0,o=0);break;case"VP8X":(v=r.header={}).feature_flags=t[e];var g=e+4;v.canvas_width=1+l(t,g);g+=3;v.canvas_height=1+l(t,g);g+=3;break;case"ALPH":i=!0,a=p+8,o=e-8;break;case"ANIM":(v=r.header).bgcolor=h(t,e);g=e+4;v.loop_count=(s=t)[(c=g)+0]<<0|s[c+1]<<8;g+=2;break;case"ANMF":var m,v;(v=r.frames[n]={}).offset_x=2*l(t,e),e+=3,v.offset_y=2*l(t,e),e+=3,v.width=1+l(t,e),e+=3,v.height=1+l(t,e),e+=3,v.duration=l(t,e),e+=3,m=t[e++],v.dispose=1&m,v.blend=m>>1&1}"ANMF"!=f&&(e+=p)}return r}}(m,0);v.response=m,v.rgbaoutput=!0,v.dataurl=!1;var b=v.header?v.header:null,y=v.frames?v.frames:null;if(b){b.loop_counter=b.loop_count,f=[b.canvas_height],d=[b.canvas_width];for(var w=0;w<y.length&&0!=y[w].blend;w++);}var N=y[0],L=g.WebPDecodeRGBA(m,N.src_off,N.src_size,d,f);N.rgba=L,N.imgwidth=d[0],N.imgheight=f[0];for(var A=0;A<d[0]*f[0]*4;A++)p[A]=L[A];return this.width=d,this.height=f,this.data=p,this}!function(t){var e=function(){return!0},r=function(e,r,i,u){var l=4,h=o;switch(u){case t.image_compression.FAST:l=1,h=a;break;case t.image_compression.MEDIUM:l=6,h=s;break;case t.image_compression.SLOW:l=9,h=c}var f=Ie(e=n(e,r,i,h),{level:l});return t.__addimage__.arrayBufferToBinaryString(f)},n=function(t,e,r,n){for(var i,a,o,s=t.length/e,c=new Uint8Array(t.length+s),u=l(),f=0;f<s;f+=1){if(o=f*e,i=t.subarray(o,o+e),n)c.set(n(i,r,a),o+f);else{for(var d,p=u.length,g=[];d<p;d+=1)g[d]=u[d](i,r,a);var m=h(g.concat());c.set(g[m],o+f)}a=i}return c},i=function(t){var e=Array.apply([],t);return e.unshift(0),e},a=function(t,e){var r,n=[],i=t.length;n[0]=1;for(var a=0;a<i;a+=1)r=t[a-e]||0,n[a+1]=t[a]-r+256&255;return n},o=function(t,e,r){var n,i=[],a=t.length;i[0]=2;for(var o=0;o<a;o+=1)n=r&&r[o]||0,i[o+1]=t[o]-n+256&255;return i},s=function(t,e,r){var n,i,a=[],o=t.length;a[0]=3;for(var s=0;s<o;s+=1)n=t[s-e]||0,i=r&&r[s]||0,a[s+1]=t[s]+256-(n+i>>>1)&255;return a},c=function(t,e,r){var n,i,a,o,s=[],c=t.length;s[0]=4;for(var l=0;l<c;l+=1)n=t[l-e]||0,i=r&&r[l]||0,a=r&&r[l-e]||0,o=u(n,i,a),s[l+1]=t[l]-o+256&255;return s},u=function(t,e,r){if(t===e&&e===r)return t;var n=Math.abs(e-r),i=Math.abs(t-r),a=Math.abs(t+e-r-r);return n<=i&&n<=a?t:i<=a?e:r},l=function(){return[i,a,o,s,c]},h=function(t){var e=t.map((function(t){return t.reduce((function(t,e){return t+Math.abs(e)}),0)}));return e.indexOf(Math.min.apply(null,e))};t.processPNG=function(n,i,a,o){var s,c,u,l,h,f,d,p,g,m,v,b,y,w,N,L=this.decode.FLATE_DECODE,A="";if(this.__addimage__.isArrayBuffer(n)&&(n=new Uint8Array(n)),this.__addimage__.isArrayBufferView(n)){if(n=(u=new De(n)).imgData,c=u.bits,s=u.colorSpace,h=u.colors,-1!==[4,6].indexOf(u.colorType)){if(8===u.bits){g=(p=32==u.pixelBitlength?new Uint32Array(u.decodePixels().buffer):16==u.pixelBitlength?new Uint16Array(u.decodePixels().buffer):new Uint8Array(u.decodePixels().buffer)).length,v=new Uint8Array(g*u.colors),m=new Uint8Array(g);var x,S=u.pixelBitlength-u.bits;for(w=0,N=0;w<g;w++){for(y=p[w],x=0;x<S;)v[N++]=y>>>x&255,x+=u.bits;m[w]=y>>>x&255}}if(16===u.bits){g=(p=new Uint32Array(u.decodePixels().buffer)).length,v=new Uint8Array(g*(32/u.pixelBitlength)*u.colors),m=new Uint8Array(g*(32/u.pixelBitlength)),b=u.colors>1,w=0,N=0;for(var _=0;w<g;)y=p[w++],v[N++]=y>>>0&255,b&&(v[N++]=y>>>16&255,y=p[w++],v[N++]=y>>>0&255),m[_++]=y>>>16&255;c=8}o!==t.image_compression.NONE&&e()?(n=r(v,u.width*u.colors,u.colors,o),d=r(m,u.width,1,o)):(n=v,d=m,L=void 0)}if(3===u.colorType&&(s=this.color_spaces.INDEXED,f=u.palette,u.transparency.indexed)){var P=u.transparency.indexed,k=0;for(w=0,g=P.length;w<g;++w)k+=P[w];if((k/=255)===g-1&&-1!==P.indexOf(0))l=[P.indexOf(0)];else if(k!==g){for(p=u.decodePixels(),m=new Uint8Array(p.length),w=0,g=p.length;w<g;w++)m[w]=P[p[w]];d=r(m,u.width,1)}}var F=function(e){var r;switch(e){case t.image_compression.FAST:r=11;break;case t.image_compression.MEDIUM:r=13;break;case t.image_compression.SLOW:r=14;break;default:r=12}return r}(o);return L===this.decode.FLATE_DECODE&&(A="/Predictor "+F+" "),A+="/Colors "+h+" /BitsPerComponent "+c+" /Columns "+u.width,(this.__addimage__.isArrayBuffer(n)||this.__addimage__.isArrayBufferView(n))&&(n=this.__addimage__.arrayBufferToBinaryString(n)),(d&&this.__addimage__.isArrayBuffer(d)||this.__addimage__.isArrayBufferView(d))&&(d=this.__addimage__.arrayBufferToBinaryString(d)),{alias:a,data:n,index:i,filter:L,decodeParameters:A,transparency:l,palette:f,sMask:d,predictor:F,width:u.width,height:u.height,bitsPerComponent:c,colorSpace:s}}}}(M.API),function(t){t.processGIF89A=function(e,r,n,i){var a=new Re(e),o=a.width,s=a.height,c=[];a.decodeAndBlitFrameRGBA(0,c);var u={data:c,width:o,height:s},l=new Ue(100).encode(u,100);return t.processJPEG.call(this,l,r,n,i)},t.processGIF87A=t.processGIF89A}(M.API),ze.prototype.parseHeader=function(){if(this.fileSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.reserved=this.datav.getUint32(this.pos,!0),this.pos+=4,this.offset=this.datav.getUint32(this.pos,!0),this.pos+=4,this.headerSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.width=this.datav.getUint32(this.pos,!0),this.pos+=4,this.height=this.datav.getInt32(this.pos,!0),this.pos+=4,this.planes=this.datav.getUint16(this.pos,!0),this.pos+=2,this.bitPP=this.datav.getUint16(this.pos,!0),this.pos+=2,this.compress=this.datav.getUint32(this.pos,!0),this.pos+=4,this.rawSize=this.datav.getUint32(this.pos,!0),this.pos+=4,this.hr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.vr=this.datav.getUint32(this.pos,!0),this.pos+=4,this.colors=this.datav.getUint32(this.pos,!0),this.pos+=4,this.importantColors=this.datav.getUint32(this.pos,!0),this.pos+=4,16===this.bitPP&&this.is_with_alpha&&(this.bitPP=15),this.bitPP<15){var t=0===this.colors?1<<this.bitPP:this.colors;this.palette=new Array(t);for(var e=0;e<t;e++){var r=this.datav.getUint8(this.pos++,!0),n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0);this.palette[e]={red:i,green:n,blue:r,quad:a}}}this.height<0&&(this.height*=-1,this.bottom_up=!1)},ze.prototype.parseBGR=function(){this.pos=this.offset;try{var t="bit"+this.bitPP,e=this.width*this.height*4;this.data=new Uint8Array(e),this[t]()}catch(t){i.log("bit decode error:"+t)}},ze.prototype.bit1=function(){var t,e=Math.ceil(this.width/8),r=e%4;for(t=this.height-1;t>=0;t--){for(var n=this.bottom_up?t:this.height-1-t,i=0;i<e;i++)for(var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+8*i*4,s=0;s<8&&8*i+s<this.width;s++){var c=this.palette[a>>7-s&1];this.data[o+4*s]=c.blue,this.data[o+4*s+1]=c.green,this.data[o+4*s+2]=c.red,this.data[o+4*s+3]=255}0!==r&&(this.pos+=4-r)}},ze.prototype.bit4=function(){for(var t=Math.ceil(this.width/2),e=t%4,r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<t;i++){var a=this.datav.getUint8(this.pos++,!0),o=n*this.width*4+2*i*4,s=a>>4,c=15&a,u=this.palette[s];if(this.data[o]=u.blue,this.data[o+1]=u.green,this.data[o+2]=u.red,this.data[o+3]=255,2*i+1>=this.width)break;u=this.palette[c],this.data[o+4]=u.blue,this.data[o+4+1]=u.green,this.data[o+4+2]=u.red,this.data[o+4+3]=255}0!==e&&(this.pos+=4-e)}},ze.prototype.bit8=function(){for(var t=this.width%4,e=this.height-1;e>=0;e--){for(var r=this.bottom_up?e:this.height-1-e,n=0;n<this.width;n++){var i=this.datav.getUint8(this.pos++,!0),a=r*this.width*4+4*n;if(i<this.palette.length){var o=this.palette[i];this.data[a]=o.red,this.data[a+1]=o.green,this.data[a+2]=o.blue,this.data[a+3]=255}else this.data[a]=255,this.data[a+1]=255,this.data[a+2]=255,this.data[a+3]=255}0!==t&&(this.pos+=4-t)}},ze.prototype.bit15=function(){for(var t=this.width%3,e=parseInt("11111",2),r=this.height-1;r>=0;r--){for(var n=this.bottom_up?r:this.height-1-r,i=0;i<this.width;i++){var a=this.datav.getUint16(this.pos,!0);this.pos+=2;var o=(a&e)/e*255|0,s=(a>>5&e)/e*255|0,c=(a>>10&e)/e*255|0,u=a>>15?255:0,l=n*this.width*4+4*i;this.data[l]=c,this.data[l+1]=s,this.data[l+2]=o,this.data[l+3]=u}this.pos+=t}},ze.prototype.bit16=function(){for(var t=this.width%3,e=parseInt("11111",2),r=parseInt("111111",2),n=this.height-1;n>=0;n--){for(var i=this.bottom_up?n:this.height-1-n,a=0;a<this.width;a++){var o=this.datav.getUint16(this.pos,!0);this.pos+=2;var s=(o&e)/e*255|0,c=(o>>5&r)/r*255|0,u=(o>>11)/e*255|0,l=i*this.width*4+4*a;this.data[l]=u,this.data[l+1]=c,this.data[l+2]=s,this.data[l+3]=255}this.pos+=t}},ze.prototype.bit24=function(){for(var t=this.height-1;t>=0;t--){for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=e*this.width*4+4*r;this.data[o]=a,this.data[o+1]=i,this.data[o+2]=n,this.data[o+3]=255}this.pos+=this.width%4}},ze.prototype.bit32=function(){for(var t=this.height-1;t>=0;t--)for(var e=this.bottom_up?t:this.height-1-t,r=0;r<this.width;r++){var n=this.datav.getUint8(this.pos++,!0),i=this.datav.getUint8(this.pos++,!0),a=this.datav.getUint8(this.pos++,!0),o=this.datav.getUint8(this.pos++,!0),s=e*this.width*4+4*r;this.data[s]=a,this.data[s+1]=i,this.data[s+2]=n,this.data[s+3]=o}},ze.prototype.getData=function(){return this.data},
/**
   * @license
   * Copyright (c) 2018 Aras Abbasi
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){t.processBMP=function(e,r,n,i){var a=new ze(e,!1),o=a.width,s=a.height,c={data:a.getData(),width:o,height:s},u=new Ue(100).encode(c,100);return t.processJPEG.call(this,u,r,n,i)}}(M.API),He.prototype.getData=function(){return this.data},
/**
   * @license
   * Copyright (c) 2019 Aras Abbasi
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){t.processWEBP=function(e,r,n,i){var a=new He(e,!1),o=a.width,s=a.height,c={data:a.getData(),width:o,height:s},u=new Ue(100).encode(c,100);return t.processJPEG.call(this,u,r,n,i)}}(M.API),
/**
   * @license
   *
   * Copyright (c) 2021 Antti Palola, https://github.com/Pantura
   *
   * Permission is hereby granted, free of charge, to any person obtaining
   * a copy of this software and associated documentation files (the
   * "Software"), to deal in the Software without restriction, including
   * without limitation the rights to use, copy, modify, merge, publish,
   * distribute, sublicense, and/or sell copies of the Software, and to
   * permit persons to whom the Software is furnished to do so, subject to
   * the following conditions:
   *
   * The above copyright notice and this permission notice shall be
   * included in all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
   * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
   * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
   * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
   * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
   * ====================================================================
   */
function(t){t.processRGBA=function(t,e,r){for(var n=t.data,i=n.length,a=new Uint8Array(i/4*3),o=new Uint8Array(i/4),s=0,c=0,u=0;u<i;u+=4){var l=n[u],h=n[u+1],f=n[u+2],d=n[u+3];a[s++]=l,a[s++]=h,a[s++]=f,o[c++]=d}var p=this.__addimage__.arrayBufferToBinaryString(a);return{alpha:this.__addimage__.arrayBufferToBinaryString(o),data:p,index:e,alias:r,colorSpace:"DeviceRGB",bitsPerComponent:8,width:t.width,height:t.height}}}(M.API),
/**
   * @license
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){t.setLanguage=function(t){return void 0===this.internal.languageSettings&&(this.internal.languageSettings={},this.internal.languageSettings.isSubscribed=!1),void 0!=={af:"Afrikaans",sq:"Albanian",ar:"Arabic (Standard)","ar-DZ":"Arabic (Algeria)","ar-BH":"Arabic (Bahrain)","ar-EG":"Arabic (Egypt)","ar-IQ":"Arabic (Iraq)","ar-JO":"Arabic (Jordan)","ar-KW":"Arabic (Kuwait)","ar-LB":"Arabic (Lebanon)","ar-LY":"Arabic (Libya)","ar-MA":"Arabic (Morocco)","ar-OM":"Arabic (Oman)","ar-QA":"Arabic (Qatar)","ar-SA":"Arabic (Saudi Arabia)","ar-SY":"Arabic (Syria)","ar-TN":"Arabic (Tunisia)","ar-AE":"Arabic (U.A.E.)","ar-YE":"Arabic (Yemen)",an:"Aragonese",hy:"Armenian",as:"Assamese",ast:"Asturian",az:"Azerbaijani",eu:"Basque",be:"Belarusian",bn:"Bengali",bs:"Bosnian",br:"Breton",bg:"Bulgarian",my:"Burmese",ca:"Catalan",ch:"Chamorro",ce:"Chechen",zh:"Chinese","zh-HK":"Chinese (Hong Kong)","zh-CN":"Chinese (PRC)","zh-SG":"Chinese (Singapore)","zh-TW":"Chinese (Taiwan)",cv:"Chuvash",co:"Corsican",cr:"Cree",hr:"Croatian",cs:"Czech",da:"Danish",nl:"Dutch (Standard)","nl-BE":"Dutch (Belgian)",en:"English","en-AU":"English (Australia)","en-BZ":"English (Belize)","en-CA":"English (Canada)","en-IE":"English (Ireland)","en-JM":"English (Jamaica)","en-NZ":"English (New Zealand)","en-PH":"English (Philippines)","en-ZA":"English (South Africa)","en-TT":"English (Trinidad & Tobago)","en-GB":"English (United Kingdom)","en-US":"English (United States)","en-ZW":"English (Zimbabwe)",eo:"Esperanto",et:"Estonian",fo:"Faeroese",fj:"Fijian",fi:"Finnish",fr:"French (Standard)","fr-BE":"French (Belgium)","fr-CA":"French (Canada)","fr-FR":"French (France)","fr-LU":"French (Luxembourg)","fr-MC":"French (Monaco)","fr-CH":"French (Switzerland)",fy:"Frisian",fur:"Friulian",gd:"Gaelic (Scots)","gd-IE":"Gaelic (Irish)",gl:"Galacian",ka:"Georgian",de:"German (Standard)","de-AT":"German (Austria)","de-DE":"German (Germany)","de-LI":"German (Liechtenstein)","de-LU":"German (Luxembourg)","de-CH":"German (Switzerland)",el:"Greek",gu:"Gujurati",ht:"Haitian",he:"Hebrew",hi:"Hindi",hu:"Hungarian",is:"Icelandic",id:"Indonesian",iu:"Inuktitut",ga:"Irish",it:"Italian (Standard)","it-CH":"Italian (Switzerland)",ja:"Japanese",kn:"Kannada",ks:"Kashmiri",kk:"Kazakh",km:"Khmer",ky:"Kirghiz",tlh:"Klingon",ko:"Korean","ko-KP":"Korean (North Korea)","ko-KR":"Korean (South Korea)",la:"Latin",lv:"Latvian",lt:"Lithuanian",lb:"Luxembourgish",mk:"North Macedonia",ms:"Malay",ml:"Malayalam",mt:"Maltese",mi:"Maori",mr:"Marathi",mo:"Moldavian",nv:"Navajo",ng:"Ndonga",ne:"Nepali",no:"Norwegian",nb:"Norwegian (Bokmal)",nn:"Norwegian (Nynorsk)",oc:"Occitan",or:"Oriya",om:"Oromo",fa:"Persian","fa-IR":"Persian/Iran",pl:"Polish",pt:"Portuguese","pt-BR":"Portuguese (Brazil)",pa:"Punjabi","pa-IN":"Punjabi (India)","pa-PK":"Punjabi (Pakistan)",qu:"Quechua",rm:"Rhaeto-Romanic",ro:"Romanian","ro-MO":"Romanian (Moldavia)",ru:"Russian","ru-MO":"Russian (Moldavia)",sz:"Sami (Lappish)",sg:"Sango",sa:"Sanskrit",sc:"Sardinian",sd:"Sindhi",si:"Singhalese",sr:"Serbian",sk:"Slovak",sl:"Slovenian",so:"Somani",sb:"Sorbian",es:"Spanish","es-AR":"Spanish (Argentina)","es-BO":"Spanish (Bolivia)","es-CL":"Spanish (Chile)","es-CO":"Spanish (Colombia)","es-CR":"Spanish (Costa Rica)","es-DO":"Spanish (Dominican Republic)","es-EC":"Spanish (Ecuador)","es-SV":"Spanish (El Salvador)","es-GT":"Spanish (Guatemala)","es-HN":"Spanish (Honduras)","es-MX":"Spanish (Mexico)","es-NI":"Spanish (Nicaragua)","es-PA":"Spanish (Panama)","es-PY":"Spanish (Paraguay)","es-PE":"Spanish (Peru)","es-PR":"Spanish (Puerto Rico)","es-ES":"Spanish (Spain)","es-UY":"Spanish (Uruguay)","es-VE":"Spanish (Venezuela)",sx:"Sutu",sw:"Swahili",sv:"Swedish","sv-FI":"Swedish (Finland)","sv-SV":"Swedish (Sweden)",ta:"Tamil",tt:"Tatar",te:"Teluga",th:"Thai",tig:"Tigre",ts:"Tsonga",tn:"Tswana",tr:"Turkish",tk:"Turkmen",uk:"Ukrainian",hsb:"Upper Sorbian",ur:"Urdu",ve:"Venda",vi:"Vietnamese",vo:"Volapuk",wa:"Walloon",cy:"Welsh",xh:"Xhosa",ji:"Yiddish",zu:"Zulu"}[t]&&(this.internal.languageSettings.languageCode=t,!1===this.internal.languageSettings.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){this.internal.write("/Lang ("+this.internal.languageSettings.languageCode+")")})),this.internal.languageSettings.isSubscribed=!0)),this}}(M.API),Oe=M.API,Be=Oe.getCharWidthsArray=function(t,r){var n,i,a=(r=r||{}).font||this.internal.getFont(),o=r.fontSize||this.internal.getFontSize(),s=r.charSpace||this.internal.getCharSpace(),c=r.widths?r.widths:a.metadata.Unicode.widths,u=c.fof?c.fof:1,l=r.kerning?r.kerning:a.metadata.Unicode.kerning,h=l.fof?l.fof:1,f=!1!==r.doKerning,d=0,p=t.length,g=0,m=c[0]||u,v=[];for(n=0;n<p;n++)i=t.charCodeAt(n),"function"==typeof a.metadata.widthOfString?v.push((a.metadata.widthOfGlyph(a.metadata.characterToGlyph(i))+s*(1e3/o)||0)/1e3):(d=f&&"object"===e(l[i])&&!isNaN(parseInt(l[i][g],10))?l[i][g]/h:0,v.push((c[i]||m)/u+d)),g=i;return v},Me=Oe.getStringUnitWidth=function(t,e){var r=(e=e||{}).fontSize||this.internal.getFontSize(),n=e.font||this.internal.getFont(),i=e.charSpace||this.internal.getCharSpace();return Oe.processArabic&&(t=Oe.processArabic(t)),"function"==typeof n.metadata.widthOfString?n.metadata.widthOfString(t,r,i)/r:Be.apply(this,arguments).reduce((function(t,e){return t+e}),0)},Ee=function(t,e,r,n){for(var i=[],a=0,o=t.length,s=0;a!==o&&s+e[a]<r;)s+=e[a],a++;i.push(t.slice(0,a));var c=a;for(s=0;a!==o;)s+e[a]>n&&(i.push(t.slice(c,a)),s=0,c=a),s+=e[a],a++;return c!==a&&i.push(t.slice(c,a)),i},qe=function(t,e,r){r||(r={});var n,i,a,o,s,c,u,l=[],h=[l],f=r.textIndent||0,d=0,p=0,g=t.split(" "),m=Be.apply(this,[" ",r])[0];if(c=-1===r.lineIndent?g[0].length+2:r.lineIndent||0){var v=Array(c).join(" "),b=[];g.map((function(t){(t=t.split(/\s*\n/)).length>1?b=b.concat(t.map((function(t,e){return(e&&t.length?"\n":"")+t}))):b.push(t[0])})),g=b,c=Me.apply(this,[v,r])}for(a=0,o=g.length;a<o;a++){var y=0;if(n=g[a],c&&"\n"==n[0]&&(n=n.substr(1),y=1),f+d+(p=(i=Be.apply(this,[n,r])).reduce((function(t,e){return t+e}),0))>e||y){if(p>e){for(s=Ee.apply(this,[n,i,e-(f+d),e]),l.push(s.shift()),l=[s.pop()];s.length;)h.push([s.shift()]);p=i.slice(n.length-(l[0]?l[0].length:0)).reduce((function(t,e){return t+e}),0)}else l=[n];h.push(l),f=p+c,d=m}else l.push(n),f+=d+p,d=m}return u=c?function(t,e){return(e?v:"")+t.join(" ")}:function(t){return t.join(" ")},h.map(u)},Oe.splitTextToSize=function(t,e,r){var n,i=(r=r||{}).fontSize||this.internal.getFontSize(),a=function(t){if(t.widths&&t.kerning)return{widths:t.widths,kerning:t.kerning};var e=this.internal.getFont(t.fontName,t.fontStyle);return e.metadata.Unicode?{widths:e.metadata.Unicode.widths||{0:1},kerning:e.metadata.Unicode.kerning||{}}:{font:e.metadata,fontSize:this.internal.getFontSize(),charSpace:this.internal.getCharSpace()}}.call(this,r);n=Array.isArray(t)?t:String(t).split(/\r?\n/);var o=1*this.internal.scaleFactor*e/i;a.textIndent=r.textIndent?1*r.textIndent*this.internal.scaleFactor/i:0,a.lineIndent=r.lineIndent;var s,c,u=[];for(s=0,c=n.length;s<c;s++)u=u.concat(qe.apply(this,[n[s],o,a]));return u},function(t){t.__fontmetrics__=t.__fontmetrics__||{};for(var r="klmnopqrstuvwxyz",n={},i={},a=0;a<r.length;a++)n[r[a]]="0123456789abcdef"[a],i["0123456789abcdef"[a]]=r[a];var o=function(t){return"0x"+parseInt(t,10).toString(16)},s=t.__fontmetrics__.compress=function(t){var r,n,a,c,u=["{"];for(var l in t){if(r=t[l],isNaN(parseInt(l,10))?n="'"+l+"'":(l=parseInt(l,10),n=(n=o(l).slice(2)).slice(0,-1)+i[n.slice(-1)]),"number"==typeof r)r<0?(a=o(r).slice(3),c="-"):(a=o(r).slice(2),c=""),a=c+a.slice(0,-1)+i[a.slice(-1)];else{if("object"!==e(r))throw new Error("Don't know what to do with value type "+e(r)+".");a=s(r)}u.push(n+a)}return u.push("}"),u.join("")},c=t.__fontmetrics__.uncompress=function(t){if("string"!=typeof t)throw new Error("Invalid argument passed to uncompress.");for(var e,r,i,a,o={},s=1,c=o,u=[],l="",h="",f=t.length-1,d=1;d<f;d+=1)"'"==(a=t[d])?e?(i=e.join(""),e=void 0):e=[]:e?e.push(a):"{"==a?(u.push([c,i]),c={},i=void 0):"}"==a?((r=u.pop())[0][r[1]]=c,i=void 0,c=r[0]):"-"==a?s=-1:void 0===i?n.hasOwnProperty(a)?(l+=n[a],i=parseInt(l,16)*s,s=1,l=""):l+=a:n.hasOwnProperty(a)?(h+=n[a],c[i]=parseInt(h,16)*s,s=1,i=void 0,h=""):h+=a;return o},u={codePages:["WinAnsiEncoding"],WinAnsiEncoding:c("{19m8n201n9q201o9r201s9l201t9m201u8m201w9n201x9o201y8o202k8q202l8r202m9p202q8p20aw8k203k8t203t8v203u9v2cq8s212m9t15m8w15n9w2dw9s16k8u16l9u17s9z17x8y17y9y}")},l={Unicode:{Courier:u,"Courier-Bold":u,"Courier-BoldOblique":u,"Courier-Oblique":u,Helvetica:u,"Helvetica-Bold":u,"Helvetica-BoldOblique":u,"Helvetica-Oblique":u,"Times-Roman":u,"Times-Bold":u,"Times-BoldItalic":u,"Times-Italic":u}},h={Unicode:{"Courier-Oblique":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-BoldItalic":c("{'widths'{k3o2q4ycx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2r202m2n2n3m2o3m2p5n202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5n4l4m4m4m4n4m4o4s4p4m4q4m4r4s4s4y4t2r4u3m4v4m4w3x4x5t4y4s4z4s5k3x5l4s5m4m5n3r5o3x5p4s5q4m5r5t5s4m5t3x5u3x5v2l5w1w5x2l5y3t5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q2l6r3m6s3r6t1w6u1w6v3m6w1w6x4y6y3r6z3m7k3m7l3m7m2r7n2r7o1w7p3r7q2w7r4m7s3m7t2w7u2r7v2n7w1q7x2n7y3t202l3mcl4mal2ram3man3mao3map3mar3mas2lat4uau1uav3maw3way4uaz2lbk2sbl3t'fof'6obo2lbp3tbq3mbr1tbs2lbu1ybv3mbz3mck4m202k3mcm4mcn4mco4mcp4mcq5ycr4mcs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz2w203k6o212m6o2dw2l2cq2l3t3m3u2l17s3x19m3m}'kerning'{cl{4qu5kt5qt5rs17ss5ts}201s{201ss}201t{cks4lscmscnscoscpscls2wu2yu201ts}201x{2wu2yu}2k{201ts}2w{4qx5kx5ou5qx5rs17su5tu}2x{17su5tu5ou}2y{4qx5kx5ou5qx5rs17ss5ts}'fof'-6ofn{17sw5tw5ou5qw5rs}7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qs}3v{17su5tu5os5qs}7p{17su5tu}ck{4qu5kt5qt5rs17ss5ts}4l{4qu5kt5qt5rs17ss5ts}cm{4qu5kt5qt5rs17ss5ts}cn{4qu5kt5qt5rs17ss5ts}co{4qu5kt5qt5rs17ss5ts}cp{4qu5kt5qt5rs17ss5ts}6l{4qu5ou5qw5rt17su5tu}5q{ckuclucmucnucoucpu4lu}5r{ckuclucmucnucoucpu4lu}7q{cksclscmscnscoscps4ls}6p{4qu5ou5qw5rt17sw5tw}ek{4qu5ou5qw5rt17su5tu}el{4qu5ou5qw5rt17su5tu}em{4qu5ou5qw5rt17su5tu}en{4qu5ou5qw5rt17su5tu}eo{4qu5ou5qw5rt17su5tu}ep{4qu5ou5qw5rt17su5tu}es{17ss5ts5qs4qu}et{4qu5ou5qw5rt17sw5tw}eu{4qu5ou5qw5rt17ss5ts}ev{17ss5ts5qs4qu}6z{17sw5tw5ou5qw5rs}fm{17sw5tw5ou5qw5rs}7n{201ts}fo{17sw5tw5ou5qw5rs}fp{17sw5tw5ou5qw5rs}fq{17sw5tw5ou5qw5rs}7r{cksclscmscnscoscps4ls}fs{17sw5tw5ou5qw5rs}ft{17su5tu}fu{17su5tu}fv{17su5tu}fw{17su5tu}fz{cksclscmscnscoscps4ls}}}"),"Helvetica-Bold":c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),Courier:c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-BoldOblique":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Bold":c("{'widths'{k3q2q5ncx2r201n3m201o6o201s2l201t2l201u2l201w3m201x3m201y3m2k1t2l2l202m2n2n3m2o3m2p6o202q6o2r1w2s2l2t2l2u3m2v3t2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w3t3x3t3y3t3z3m4k5x4l4s4m4m4n4s4o4s4p4m4q3x4r4y4s4y4t2r4u3m4v4y4w4m4x5y4y4s4z4y5k3x5l4y5m4s5n3r5o4m5p4s5q4s5r6o5s4s5t4s5u4m5v2l5w1w5x2l5y3u5z3m6k2l6l3m6m3r6n2w6o3r6p2w6q2l6r3m6s3r6t1w6u2l6v3r6w1w6x5n6y3r6z3m7k3r7l3r7m2w7n2r7o2l7p3r7q3m7r4s7s3m7t3m7u2w7v2r7w1q7x2r7y3o202l3mcl4sal2lam3man3mao3map3mar3mas2lat4uau1yav3maw3tay4uaz2lbk2sbl3t'fof'6obo2lbp3rbr1tbs2lbu2lbv3mbz3mck4s202k3mcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw2r2m3rcy2rcz2rdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3rek3mel3mem3men3meo3mep3meq4ser2wes2wet2weu2wev2wew1wex1wey1wez1wfl3rfm3mfn3mfo3mfp3mfq3mfr3tfs3mft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3m3u2l17s4s19m3m}'kerning'{cl{4qt5ks5ot5qy5rw17sv5tv}201t{cks4lscmscnscoscpscls4wv}2k{201ts}2w{4qu5ku7mu5os5qx5ru17su5tu}2x{17su5tu5ou5qs}2y{4qv5kv7mu5ot5qz5ru17su5tu}'fof'-6o7t{cksclscmscnscoscps4ls}3u{17su5tu5os5qu}3v{17su5tu5os5qu}fu{17su5tu5ou5qu}7p{17su5tu5ou5qu}ck{4qt5ks5ot5qy5rw17sv5tv}4l{4qt5ks5ot5qy5rw17sv5tv}cm{4qt5ks5ot5qy5rw17sv5tv}cn{4qt5ks5ot5qy5rw17sv5tv}co{4qt5ks5ot5qy5rw17sv5tv}cp{4qt5ks5ot5qy5rw17sv5tv}6l{17st5tt5ou5qu}17s{ckuclucmucnucoucpu4lu4wu}5o{ckuclucmucnucoucpu4lu4wu}5q{ckzclzcmzcnzcozcpz4lz4wu}5r{ckxclxcmxcnxcoxcpx4lx4wu}5t{ckuclucmucnucoucpu4lu4wu}7q{ckuclucmucnucoucpu4lu}6p{17sw5tw5ou5qu}ek{17st5tt5qu}el{17st5tt5ou5qu}em{17st5tt5qu}en{17st5tt5qu}eo{17st5tt5qu}ep{17st5tt5ou5qu}es{17ss5ts5qu}et{17sw5tw5ou5qu}eu{17sw5tw5ou5qu}ev{17ss5ts5qu}6z{17sw5tw5ou5qu5rs}fm{17sw5tw5ou5qu5rs}fn{17sw5tw5ou5qu5rs}fo{17sw5tw5ou5qu5rs}fp{17sw5tw5ou5qu5rs}fq{17sw5tw5ou5qu5rs}7r{cktcltcmtcntcotcpt4lt5os}fs{17sw5tw5ou5qu5rs}ft{17su5tu5ou5qu}7m{5os}fv{17su5tu5ou5qu}fw{17su5tu5ou5qu}fz{cksclscmscnscoscps4ls}}}"),Symbol:c("{'widths'{k3uaw4r19m3m2k1t2l2l202m2y2n3m2p5n202q6o3k3m2s2l2t2l2v3r2w1t3m3m2y1t2z1wbk2sbl3r'fof'6o3n3m3o3m3p3m3q3m3r3m3s3m3t3m3u1w3v1w3w3r3x3r3y3r3z2wbp3t3l3m5v2l5x2l5z3m2q4yfr3r7v3k7w1o7x3k}'kerning'{'fof'-6o}}"),Helvetica:c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}"),"Helvetica-BoldOblique":c("{'widths'{k3s2q4scx1w201n3r201o6o201s1w201t1w201u1w201w3m201x3m201y3m2k1w2l2l202m2n2n3r2o3r2p5t202q6o2r1s2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v2l3w3u3x3u3y3u3z3x4k6l4l4s4m4s4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3r4v4s4w3x4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v2l5w1w5x2l5y3u5z3r6k2l6l3r6m3x6n3r6o3x6p3r6q2l6r3x6s3x6t1w6u1w6v3r6w1w6x5t6y3x6z3x7k3x7l3x7m2r7n3r7o2l7p3x7q3r7r4y7s3r7t3r7u3m7v2r7w1w7x2r7y3u202l3rcl4sal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3xbq3rbr1wbs2lbu2obv3rbz3xck4s202k3rcm4scn4sco4scp4scq6ocr4scs4mct4mcu4mcv4mcw1w2m2zcy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3res3ret3reu3rev3rew1wex1wey1wez1wfl3xfm3xfn3xfo3xfp3xfq3xfr3ufs3xft3xfu3xfv3xfw3xfz3r203k6o212m6o2dw2l2cq2l3t3r3u2l17s4m19m3r}'kerning'{cl{4qs5ku5ot5qs17sv5tv}201t{2ww4wy2yw}201w{2ks}201x{2ww4wy2yw}2k{201ts201xs}2w{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}2x{5ow5qs}2y{7qs4qu5kw5os5qw5rs17su5tu7tsfzs}'fof'-6o7p{17su5tu5ot}ck{4qs5ku5ot5qs17sv5tv}4l{4qs5ku5ot5qs17sv5tv}cm{4qs5ku5ot5qs17sv5tv}cn{4qs5ku5ot5qs17sv5tv}co{4qs5ku5ot5qs17sv5tv}cp{4qs5ku5ot5qs17sv5tv}6l{17st5tt5os}17s{2kwclvcmvcnvcovcpv4lv4wwckv}5o{2kucltcmtcntcotcpt4lt4wtckt}5q{2ksclscmscnscoscps4ls4wvcks}5r{2ks4ws}5t{2kwclvcmvcnvcovcpv4lv4wwckv}eo{17st5tt5os}fu{17su5tu5ot}6p{17ss5ts}ek{17st5tt5os}el{17st5tt5os}em{17st5tt5os}en{17st5tt5os}6o{201ts}ep{17st5tt5os}es{17ss5ts}et{17ss5ts}eu{17ss5ts}ev{17ss5ts}6z{17su5tu5os5qt}fm{17su5tu5os5qt}fn{17su5tu5os5qt}fo{17su5tu5os5qt}fp{17su5tu5os5qt}fq{17su5tu5os5qt}fs{17su5tu5os5qt}ft{17su5tu5ot}7m{5os}fv{17su5tu5ot}fw{17su5tu5ot}}}"),ZapfDingbats:c("{'widths'{k4u2k1w'fof'6o}'kerning'{'fof'-6o}}"),"Courier-Bold":c("{'widths'{k3w'fof'6o}'kerning'{'fof'-6o}}"),"Times-Italic":c("{'widths'{k3n2q4ycx2l201n3m201o5t201s2l201t2l201u2l201w3r201x3r201y3r2k1t2l2l202m2n2n3m2o3m2p5n202q5t2r1p2s2l2t2l2u3m2v4n2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v2l3w4n3x4n3y4n3z3m4k5w4l3x4m3x4n4m4o4s4p3x4q3x4r4s4s4s4t2l4u2w4v4m4w3r4x5n4y4m4z4s5k3x5l4s5m3x5n3m5o3r5p4s5q3x5r5n5s3x5t3r5u3r5v2r5w1w5x2r5y2u5z3m6k2l6l3m6m3m6n2w6o3m6p2w6q1w6r3m6s3m6t1w6u1w6v2w6w1w6x4s6y3m6z3m7k3m7l3m7m2r7n2r7o1w7p3m7q2w7r4m7s2w7t2w7u2r7v2s7w1v7x2s7y3q202l3mcl3xal2ram3man3mao3map3mar3mas2lat4wau1vav3maw4nay4waz2lbk2sbl4n'fof'6obo2lbp3mbq3obr1tbs2lbu1zbv3mbz3mck3x202k3mcm3xcn3xco3xcp3xcq5tcr4mcs3xct3xcu3xcv3xcw2l2m2ucy2lcz2ldl4mdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek3mel3mem3men3meo3mep3meq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr4nfs3mft3mfu3mfv3mfw3mfz2w203k6o212m6m2dw2l2cq2l3t3m3u2l17s3r19m3m}'kerning'{cl{5kt4qw}201s{201sw}201t{201tw2wy2yy6q-t}201x{2wy2yy}2k{201tw}2w{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}2x{17ss5ts5os}2y{7qs4qy7rs5ky7mw5os5qx5ru17su5tu}'fof'-6o6t{17ss5ts5qs}7t{5os}3v{5qs}7p{17su5tu5qs}ck{5kt4qw}4l{5kt4qw}cm{5kt4qw}cn{5kt4qw}co{5kt4qw}cp{5kt4qw}6l{4qs5ks5ou5qw5ru17su5tu}17s{2ks}5q{ckvclvcmvcnvcovcpv4lv}5r{ckuclucmucnucoucpu4lu}5t{2ks}6p{4qs5ks5ou5qw5ru17su5tu}ek{4qs5ks5ou5qw5ru17su5tu}el{4qs5ks5ou5qw5ru17su5tu}em{4qs5ks5ou5qw5ru17su5tu}en{4qs5ks5ou5qw5ru17su5tu}eo{4qs5ks5ou5qw5ru17su5tu}ep{4qs5ks5ou5qw5ru17su5tu}es{5ks5qs4qs}et{4qs5ks5ou5qw5ru17su5tu}eu{4qs5ks5qw5ru17su5tu}ev{5ks5qs4qs}ex{17ss5ts5qs}6z{4qv5ks5ou5qw5ru17su5tu}fm{4qv5ks5ou5qw5ru17su5tu}fn{4qv5ks5ou5qw5ru17su5tu}fo{4qv5ks5ou5qw5ru17su5tu}fp{4qv5ks5ou5qw5ru17su5tu}fq{4qv5ks5ou5qw5ru17su5tu}7r{5os}fs{4qv5ks5ou5qw5ru17su5tu}ft{17su5tu5qs}fu{17su5tu5qs}fv{17su5tu5qs}fw{17su5tu5qs}}}"),"Times-Roman":c("{'widths'{k3n2q4ycx2l201n3m201o6o201s2l201t2l201u2l201w2w201x2w201y2w2k1t2l2l202m2n2n3m2o3m2p5n202q6o2r1m2s2l2t2l2u3m2v3s2w1t2x2l2y1t2z1w3k3m3l3m3m3m3n3m3o3m3p3m3q3m3r3m3s3m203t2l203u2l3v1w3w3s3x3s3y3s3z2w4k5w4l4s4m4m4n4m4o4s4p3x4q3r4r4s4s4s4t2l4u2r4v4s4w3x4x5t4y4s4z4s5k3r5l4s5m4m5n3r5o3x5p4s5q4s5r5y5s4s5t4s5u3x5v2l5w1w5x2l5y2z5z3m6k2l6l2w6m3m6n2w6o3m6p2w6q2l6r3m6s3m6t1w6u1w6v3m6w1w6x4y6y3m6z3m7k3m7l3m7m2l7n2r7o1w7p3m7q3m7r4s7s3m7t3m7u2w7v3k7w1o7x3k7y3q202l3mcl4sal2lam3man3mao3map3mar3mas2lat4wau1vav3maw3say4waz2lbk2sbl3s'fof'6obo2lbp3mbq2xbr1tbs2lbu1zbv3mbz2wck4s202k3mcm4scn4sco4scp4scq5tcr4mcs3xct3xcu3xcv3xcw2l2m2tcy2lcz2ldl4sdm4sdn4sdo4sdp4sdq4sds4sdt4sdu4sdv4sdw4sdz3mek2wel2wem2wen2weo2wep2weq4mer2wes2wet2weu2wev2wew1wex1wey1wez1wfl3mfm3mfn3mfo3mfp3mfq3mfr3sfs3mft3mfu3mfv3mfw3mfz3m203k6o212m6m2dw2l2cq2l3t3m3u1w17s4s19m3m}'kerning'{cl{4qs5ku17sw5ou5qy5rw201ss5tw201ws}201s{201ss}201t{ckw4lwcmwcnwcowcpwclw4wu201ts}2k{201ts}2w{4qs5kw5os5qx5ru17sx5tx}2x{17sw5tw5ou5qu}2y{4qs5kw5os5qx5ru17sx5tx}'fof'-6o7t{ckuclucmucnucoucpu4lu5os5rs}3u{17su5tu5qs}3v{17su5tu5qs}7p{17sw5tw5qs}ck{4qs5ku17sw5ou5qy5rw201ss5tw201ws}4l{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cm{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cn{4qs5ku17sw5ou5qy5rw201ss5tw201ws}co{4qs5ku17sw5ou5qy5rw201ss5tw201ws}cp{4qs5ku17sw5ou5qy5rw201ss5tw201ws}6l{17su5tu5os5qw5rs}17s{2ktclvcmvcnvcovcpv4lv4wuckv}5o{ckwclwcmwcnwcowcpw4lw4wu}5q{ckyclycmycnycoycpy4ly4wu5ms}5r{cktcltcmtcntcotcpt4lt4ws}5t{2ktclvcmvcnvcovcpv4lv4wuckv}7q{cksclscmscnscoscps4ls}6p{17su5tu5qw5rs}ek{5qs5rs}el{17su5tu5os5qw5rs}em{17su5tu5os5qs5rs}en{17su5qs5rs}eo{5qs5rs}ep{17su5tu5os5qw5rs}es{5qs}et{17su5tu5qw5rs}eu{17su5tu5qs5rs}ev{5qs}6z{17sv5tv5os5qx5rs}fm{5os5qt5rs}fn{17sv5tv5os5qx5rs}fo{17sv5tv5os5qx5rs}fp{5os5qt5rs}fq{5os5qt5rs}7r{ckuclucmucnucoucpu4lu5os}fs{17sv5tv5os5qx5rs}ft{17ss5ts5qs}fu{17sw5tw5qs}fv{17sw5tw5qs}fw{17ss5ts5qs}fz{ckuclucmucnucoucpu4lu5os5rs}}}"),"Helvetica-Oblique":c("{'widths'{k3p2q4mcx1w201n3r201o6o201s1q201t1q201u1q201w2l201x2l201y2l2k1w2l1w202m2n2n3r2o3r2p5t202q6o2r1n2s2l2t2l2u2r2v3u2w1w2x2l2y1w2z1w3k3r3l3r3m3r3n3r3o3r3p3r3q3r3r3r3s3r203t2l203u2l3v1w3w3u3x3u3y3u3z3r4k6p4l4m4m4m4n4s4o4s4p4m4q3x4r4y4s4s4t1w4u3m4v4m4w3r4x5n4y4s4z4y5k4m5l4y5m4s5n4m5o3x5p4s5q4m5r5y5s4m5t4m5u3x5v1w5w1w5x1w5y2z5z3r6k2l6l3r6m3r6n3m6o3r6p3r6q1w6r3r6s3r6t1q6u1q6v3m6w1q6x5n6y3r6z3r7k3r7l3r7m2l7n3m7o1w7p3r7q3m7r4s7s3m7t3m7u3m7v2l7w1u7x2l7y3u202l3rcl4mal2lam3ran3rao3rap3rar3ras2lat4tau2pav3raw3uay4taz2lbk2sbl3u'fof'6obo2lbp3rbr1wbs2lbu2obv3rbz3xck4m202k3rcm4mcn4mco4mcp4mcq6ocr4scs4mct4mcu4mcv4mcw1w2m2ncy1wcz1wdl4sdm4ydn4ydo4ydp4ydq4yds4ydt4sdu4sdv4sdw4sdz3xek3rel3rem3ren3reo3rep3req5ter3mes3ret3reu3rev3rew1wex1wey1wez1wfl3rfm3rfn3rfo3rfp3rfq3rfr3ufs3xft3rfu3rfv3rfw3rfz3m203k6o212m6o2dw2l2cq2l3t3r3u1w17s4m19m3r}'kerning'{5q{4wv}cl{4qs5kw5ow5qs17sv5tv}201t{2wu4w1k2yu}201x{2wu4wy2yu}17s{2ktclucmucnu4otcpu4lu4wycoucku}2w{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}2x{17sy5ty5oy5qs}2y{7qs4qz5k1m17sy5ow5qx5rsfsu5ty7tufzu}'fof'-6o7p{17sv5tv5ow}ck{4qs5kw5ow5qs17sv5tv}4l{4qs5kw5ow5qs17sv5tv}cm{4qs5kw5ow5qs17sv5tv}cn{4qs5kw5ow5qs17sv5tv}co{4qs5kw5ow5qs17sv5tv}cp{4qs5kw5ow5qs17sv5tv}6l{17sy5ty5ow}do{17st5tt}4z{17st5tt}7s{fst}dm{17st5tt}dn{17st5tt}5o{ckwclwcmwcnwcowcpw4lw4wv}dp{17st5tt}dq{17st5tt}7t{5ow}ds{17st5tt}5t{2ktclucmucnu4otcpu4lu4wycoucku}fu{17sv5tv5ow}6p{17sy5ty5ow5qs}ek{17sy5ty5ow}el{17sy5ty5ow}em{17sy5ty5ow}en{5ty}eo{17sy5ty5ow}ep{17sy5ty5ow}es{17sy5ty5qs}et{17sy5ty5ow5qs}eu{17sy5ty5ow5qs}ev{17sy5ty5ow5qs}6z{17sy5ty5ow5qs}fm{17sy5ty5ow5qs}fn{17sy5ty5ow5qs}fo{17sy5ty5ow5qs}fp{17sy5ty5qs}fq{17sy5ty5ow5qs}7r{5ow}fs{17sy5ty5ow5qs}ft{17sv5tv5ow}7m{5ow}fv{17sv5tv5ow}fw{17sv5tv5ow}}}")}};t.events.push(["addFont",function(t){var e=t.font,r=h.Unicode[e.postScriptName];r&&(e.metadata.Unicode={},e.metadata.Unicode.widths=r.widths,e.metadata.Unicode.kerning=r.kerning);var n=l.Unicode[e.postScriptName];n&&(e.metadata.Unicode.encoding=n,e.encoding=n.codePages[0])}])}(M.API),
/**
   * @license
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var e=function(t){for(var e=t.length,r=new Uint8Array(e),n=0;n<e;n++)r[n]=t.charCodeAt(n);return r};t.API.events.push(["addFont",function(r){var n=void 0,i=r.font,a=r.instance;if(!i.isStandardFont){if(void 0===a)throw new Error("Font does not exist in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");if("string"!=typeof(n=!1===a.existsFileInVFS(i.postScriptName)?a.loadFile(i.postScriptName):a.getFileFromVFS(i.postScriptName)))throw new Error("Font is not stored as string-data in vFS, import fonts or remove declaration doc.addFont('"+i.postScriptName+"').");!function(r,n){n=/^\x00\x01\x00\x00/.test(n)?e(n):e(c(n)),r.metadata=t.API.TTFFont.open(n),r.metadata.Unicode=r.metadata.Unicode||{encoding:{},kerning:{},widths:[]},r.metadata.glyIdsUsed=[0]}(i,n)}}])}(M),function(n){function a(){return(r.canvg?Promise.resolve(r.canvg):"object"===(void 0===t?"undefined":e(t))&&"undefined"!=typeof module?new Promise((function(t,e){try{t(require("canvg"))}catch(t){e(t)}})):"function"==typeof define&&define.amd?new Promise((function(t,e){try{require(["canvg"],t)}catch(t){e(t)}})):Promise.reject(new Error("Could not load canvg"))).catch((function(t){return Promise.reject(new Error("Could not load canvg: "+t))})).then((function(t){return t.default?t.default:t}))}n.addSvgAsImage=function(t,e,r,n,o,s,c,u){if(isNaN(e)||isNaN(r))throw i.error("jsPDF.addSvgAsImage: Invalid coordinates",arguments),new Error("Invalid coordinates passed to jsPDF.addSvgAsImage");if(isNaN(n)||isNaN(o))throw i.error("jsPDF.addSvgAsImage: Invalid measurements",arguments),new Error("Invalid measurements (width and/or height) passed to jsPDF.addSvgAsImage");var l=document.createElement("canvas");l.width=n,l.height=o;var h=l.getContext("2d");h.fillStyle="#fff",h.fillRect(0,0,l.width,l.height);var f={ignoreMouse:!0,ignoreAnimation:!0,ignoreDimensions:!0},d=this;return a().then((function(e){return e.fromString(h,t,f)}),(function(){return Promise.reject(new Error("Could not load canvg."))})).then((function(t){return t.render(f)})).then((function(){d.addImage(l.toDataURL("image/jpeg",1),e,r,n,o,c,u)}))}}(M.API),
/**
   * @license
   * ====================================================================
   * Copyright (c) 2013 Eduardo Menezes de Morais, eduardo.morais@usp.br
   *
   * Permission is hereby granted, free of charge, to any person obtaining
   * a copy of this software and associated documentation files (the
   * "Software"), to deal in the Software without restriction, including
   * without limitation the rights to use, copy, modify, merge, publish,
   * distribute, sublicense, and/or sell copies of the Software, and to
   * permit persons to whom the Software is furnished to do so, subject to
   * the following conditions:
   *
   * The above copyright notice and this permission notice shall be
   * included in all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
   * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
   * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
   * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
   * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
   * ====================================================================
   */
function(t){t.putTotalPages=function(t){var e,r=0;parseInt(this.internal.getFont().id.substr(1),10)<15?(e=new RegExp(t,"g"),r=this.internal.getNumberOfPages()):(e=new RegExp(this.pdfEscape16(t,this.internal.getFont()),"g"),r=this.pdfEscape16(this.internal.getNumberOfPages()+"",this.internal.getFont()));for(var n=1;n<=this.internal.getNumberOfPages();n++)for(var i=0;i<this.internal.pages[n].length;i++)this.internal.pages[n][i]=this.internal.pages[n][i].replace(e,r);return this}}(M.API),function(t){t.viewerPreferences=function(t,r){var n;t=t||{},r=r||!1;var i,a,o,s={HideToolbar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideMenubar:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},HideWindowUI:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},FitWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},CenterWindow:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.3},DisplayDocTitle:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.4},NonFullScreenPageMode:{defaultValue:"UseNone",value:"UseNone",type:"name",explicitSet:!1,valueSet:["UseNone","UseOutlines","UseThumbs","UseOC"],pdfVersion:1.3},Direction:{defaultValue:"L2R",value:"L2R",type:"name",explicitSet:!1,valueSet:["L2R","R2L"],pdfVersion:1.3},ViewArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},ViewClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintArea:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintClip:{defaultValue:"CropBox",value:"CropBox",type:"name",explicitSet:!1,valueSet:["MediaBox","CropBox","TrimBox","BleedBox","ArtBox"],pdfVersion:1.4},PrintScaling:{defaultValue:"AppDefault",value:"AppDefault",type:"name",explicitSet:!1,valueSet:["AppDefault","None"],pdfVersion:1.6},Duplex:{defaultValue:"",value:"none",type:"name",explicitSet:!1,valueSet:["Simplex","DuplexFlipShortEdge","DuplexFlipLongEdge","none"],pdfVersion:1.7},PickTrayByPDFSize:{defaultValue:!1,value:!1,type:"boolean",explicitSet:!1,valueSet:[!0,!1],pdfVersion:1.7},PrintPageRange:{defaultValue:"",value:"",type:"array",explicitSet:!1,valueSet:null,pdfVersion:1.7},NumCopies:{defaultValue:1,value:1,type:"integer",explicitSet:!1,valueSet:null,pdfVersion:1.7}},c=Object.keys(s),u=[],l=0,h=0,f=0;function d(t,e){var r,n=!1;for(r=0;r<t.length;r+=1)t[r]===e&&(n=!0);return n}if(void 0===this.internal.viewerpreferences&&(this.internal.viewerpreferences={},this.internal.viewerpreferences.configuration=JSON.parse(JSON.stringify(s)),this.internal.viewerpreferences.isSubscribed=!1),n=this.internal.viewerpreferences.configuration,"reset"===t||!0===r){var p=c.length;for(f=0;f<p;f+=1)n[c[f]].value=n[c[f]].defaultValue,n[c[f]].explicitSet=!1}if("object"===e(t))for(a in t)if(o=t[a],d(c,a)&&void 0!==o){if("boolean"===n[a].type&&"boolean"==typeof o)n[a].value=o;else if("name"===n[a].type&&d(n[a].valueSet,o))n[a].value=o;else if("integer"===n[a].type&&Number.isInteger(o))n[a].value=o;else if("array"===n[a].type){for(l=0;l<o.length;l+=1)if(i=!0,1===o[l].length&&"number"==typeof o[l][0])u.push(String(o[l]-1));else if(o[l].length>1){for(h=0;h<o[l].length;h+=1)"number"!=typeof o[l][h]&&(i=!1);!0===i&&u.push([o[l][0]-1,o[l][1]-1].join(" "))}n[a].value="["+u.join(" ")+"]"}else n[a].value=n[a].defaultValue;n[a].explicitSet=!0}return!1===this.internal.viewerpreferences.isSubscribed&&(this.internal.events.subscribe("putCatalog",(function(){var t,e=[];for(t in n)!0===n[t].explicitSet&&("name"===n[t].type?e.push("/"+t+" /"+n[t].value):e.push("/"+t+" "+n[t].value));0!==e.length&&this.internal.write("/ViewerPreferences\n<<\n"+e.join("\n")+"\n>>")})),this.internal.viewerpreferences.isSubscribed=!0),this.internal.viewerpreferences.configuration=n,this}}(M.API),
/** ====================================================================
   * @license
   * jsPDF XMP metadata plugin
   * Copyright (c) 2016 Jussi Utunen, u-jussi@suomi24.fi
   *
   * Permission is hereby granted, free of charge, to any person obtaining
   * a copy of this software and associated documentation files (the
   * "Software"), to deal in the Software without restriction, including
   * without limitation the rights to use, copy, modify, merge, publish,
   * distribute, sublicense, and/or sell copies of the Software, and to
   * permit persons to whom the Software is furnished to do so, subject to
   * the following conditions:
   *
   * The above copyright notice and this permission notice shall be
   * included in all copies or substantial portions of the Software.
   *
   * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
   * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE
   * LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION
   * OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
   * WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
   * ====================================================================
   */
function(t){var e=function(){var t='<rdf:RDF xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#"><rdf:Description rdf:about="" xmlns:jspdf="'+this.internal.__metadata__.namespaceuri+'"><jspdf:metadata>',e=unescape(encodeURIComponent('<x:xmpmeta xmlns:x="adobe:ns:meta/">')),r=unescape(encodeURIComponent(t)),n=unescape(encodeURIComponent(this.internal.__metadata__.metadata)),i=unescape(encodeURIComponent("</jspdf:metadata></rdf:Description></rdf:RDF>")),a=unescape(encodeURIComponent("</x:xmpmeta>")),o=r.length+n.length+i.length+e.length+a.length;this.internal.__metadata__.metadata_object_number=this.internal.newObject(),this.internal.write("<< /Type /Metadata /Subtype /XML /Length "+o+" >>"),this.internal.write("stream"),this.internal.write(e+r+n+i+a),this.internal.write("endstream"),this.internal.write("endobj")},r=function(){this.internal.__metadata__.metadata_object_number&&this.internal.write("/Metadata "+this.internal.__metadata__.metadata_object_number+" 0 R")};t.addMetadata=function(t,n){return void 0===this.internal.__metadata__&&(this.internal.__metadata__={metadata:t,namespaceuri:n||"http://jspdf.default.namespaceuri/"},this.internal.events.subscribe("putCatalog",r),this.internal.events.subscribe("postPutResources",e)),this}}(M.API),function(t){var e=t.API,r=e.pdfEscape16=function(t,e){for(var r,n=e.metadata.Unicode.widths,i=["","0","00","000","0000"],a=[""],o=0,s=t.length;o<s;++o){if(r=e.metadata.characterToGlyph(t.charCodeAt(o)),e.metadata.glyIdsUsed.push(r),e.metadata.toUnicode[r]=t.charCodeAt(o),-1==n.indexOf(r)&&(n.push(r),n.push([parseInt(e.metadata.widthOfGlyph(r),10)])),"0"==r)return a.join("");r=r.toString(16),a.push(i[4-r.length],r)}return a.join("")},n=function(t){var e,r,n,i,a,o,s;for(a="/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange",n=[],o=0,s=(r=Object.keys(t).sort((function(t,e){return t-e}))).length;o<s;o++)e=r[o],n.length>=100&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar",n=[]),void 0!==t[e]&&null!==t[e]&&"function"==typeof t[e].toString&&(i=("0000"+t[e].toString(16)).slice(-4),e=("0000"+(+e).toString(16)).slice(-4),n.push("<"+e+"><"+i+">"));return n.length&&(a+="\n"+n.length+" beginbfchar\n"+n.join("\n")+"\nendbfchar\n"),a+="endcmap\nCMapName currentdict /CMap defineresource pop\nend\nend"};e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream;if(r.metadata instanceof t.API.TTFFont&&"Identity-H"===r.encoding){for(var s=r.metadata.Unicode.widths,c=r.metadata.subset.encode(r.metadata.glyIdsUsed,1),u="",l=0;l<c.length;l++)u+=String.fromCharCode(c[l]);var h=a();o({data:u,addLength1:!0,objectId:h}),i("endobj");var f=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:f}),i("endobj");var d=a();i("<<"),i("/Type /FontDescriptor"),i("/FontName /"+F(r.fontName)),i("/FontFile2 "+h+" 0 R"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/Flags "+r.metadata.flags),i("/StemV "+r.metadata.stemV),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i(">>"),i("endobj");var p=a();i("<<"),i("/Type /Font"),i("/BaseFont /"+F(r.fontName)),i("/FontDescriptor "+d+" 0 R"),i("/W "+t.API.PDFObject.convert(s)),i("/CIDToGIDMap /Identity"),i("/DW 1000"),i("/Subtype /CIDFontType2"),i("/CIDSystemInfo"),i("<<"),i("/Supplement 0"),i("/Registry (Adobe)"),i("/Ordering ("+r.encoding+")"),i(">>"),i(">>"),i("endobj"),r.objectNumber=a(),i("<<"),i("/Type /Font"),i("/Subtype /Type0"),i("/ToUnicode "+f+" 0 R"),i("/BaseFont /"+F(r.fontName)),i("/Encoding /"+r.encoding),i("/DescendantFonts ["+p+" 0 R]"),i(">>"),i("endobj"),r.isAlreadyPutted=!0}}(e)}]);e.events.push(["putFont",function(e){!function(e){var r=e.font,i=e.out,a=e.newObject,o=e.putStream;if(r.metadata instanceof t.API.TTFFont&&"WinAnsiEncoding"===r.encoding){for(var s=r.metadata.rawData,c="",u=0;u<s.length;u++)c+=String.fromCharCode(s[u]);var l=a();o({data:c,addLength1:!0,objectId:l}),i("endobj");var h=a();o({data:n(r.metadata.toUnicode),addLength1:!0,objectId:h}),i("endobj");var f=a();i("<<"),i("/Descent "+r.metadata.decender),i("/CapHeight "+r.metadata.capHeight),i("/StemV "+r.metadata.stemV),i("/Type /FontDescriptor"),i("/FontFile2 "+l+" 0 R"),i("/Flags 96"),i("/FontBBox "+t.API.PDFObject.convert(r.metadata.bbox)),i("/FontName /"+F(r.fontName)),i("/ItalicAngle "+r.metadata.italicAngle),i("/Ascent "+r.metadata.ascender),i(">>"),i("endobj"),r.objectNumber=a();for(var d=0;d<r.metadata.hmtx.widths.length;d++)r.metadata.hmtx.widths[d]=parseInt(r.metadata.hmtx.widths[d]*(1e3/r.metadata.head.unitsPerEm));i("<</Subtype/TrueType/Type/Font/ToUnicode "+h+" 0 R/BaseFont/"+F(r.fontName)+"/FontDescriptor "+f+" 0 R/Encoding/"+r.encoding+" /FirstChar 29 /LastChar 255 /Widths "+t.API.PDFObject.convert(r.metadata.hmtx.widths)+">>"),i("endobj"),r.isAlreadyPutted=!0}}(e)}]);var i=function(t){var e,n=t.text||"",i=t.x,a=t.y,o=t.options||{},s=t.mutex||{},c=s.pdfEscape,u=s.activeFontKey,l=s.fonts,h=u,f="",d=0,p="",g=l[h].encoding;if("Identity-H"!==l[h].encoding)return{text:n,x:i,y:a,options:o,mutex:s};for(p=n,h=u,Array.isArray(n)&&(p=n[0]),d=0;d<p.length;d+=1)l[h].metadata.hasOwnProperty("cmap")&&(e=l[h].metadata.cmap.unicode.codeMap[p[d].charCodeAt(0)]),e||p[d].charCodeAt(0)<256&&l[h].metadata.hasOwnProperty("Unicode")?f+=p[d]:f+="";var m="";return parseInt(h.slice(1))<14||"WinAnsiEncoding"===g?m=c(f,h).split("").map((function(t){return t.charCodeAt(0).toString(16)})).join(""):"Identity-H"===g&&(m=r(f,l[h])),s.isHex=!0,{text:m,x:i,y:a,options:o,mutex:s}};e.events.push(["postProcessText",function(t){var e=t.text||"",r=[],n={text:e,x:t.x,y:t.y,options:t.options,mutex:t.mutex};if(Array.isArray(e)){var a=0;for(a=0;a<e.length;a+=1)Array.isArray(e[a])&&3===e[a].length?r.push([i(Object.assign({},n,{text:e[a][0]})).text,e[a][1],e[a][2]]):r.push(i(Object.assign({},n,{text:e[a]})).text);t.text=r}else t.text=i(Object.assign({},n,{text:e})).text}])}(M),
/**
   * @license
   * jsPDF virtual FileSystem functionality
   *
   * Licensed under the MIT License.
   * http://opensource.org/licenses/mit-license
   */
function(t){var e=function(){return void 0===this.internal.vFS&&(this.internal.vFS={}),!0};t.existsFileInVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]},t.addFileToVFS=function(t,r){return e.call(this),this.internal.vFS[t]=r,this},t.getFileFromVFS=function(t){return e.call(this),void 0!==this.internal.vFS[t]?this.internal.vFS[t]:null}}(M.API),
/**
   * @license
   * Unicode Bidi Engine based on the work of Alex Shensis (@asthensis)
   * MIT License
   */
function(t){t.__bidiEngine__=t.prototype.__bidiEngine__=function(t){var r,n,i,a,o,s,c,u=e,l=[[0,3,0,1,0,0,0],[0,3,0,1,2,2,0],[0,3,0,17,2,0,1],[0,3,5,5,4,1,0],[0,3,21,21,4,0,1],[0,3,5,5,4,2,0]],h=[[2,0,1,1,0,1,0],[2,0,1,1,0,2,0],[2,0,2,1,3,2,0],[2,0,2,33,3,1,1]],f={L:0,R:1,EN:2,AN:3,N:4,B:5,S:6},d={0:0,5:1,6:2,7:3,32:4,251:5,254:6,255:7},p=["(",")","(","<",">","<","[","]","[","{","}","{","«","»","«","‹","›","‹","⁅","⁆","⁅","⁽","⁾","⁽","₍","₎","₍","≤","≥","≤","〈","〉","〈","﹙","﹚","﹙","﹛","﹜","﹛","﹝","﹞","﹝","﹤","﹥","﹤"],g=new RegExp(/^([1-4|9]|1[0-9]|2[0-9]|3[0168]|4[04589]|5[012]|7[78]|159|16[0-9]|17[0-2]|21[569]|22[03489]|250)$/),m=!1,v=0;this.__bidiEngine__={};var b=function(t){var e=t.charCodeAt(),r=e>>8,n=d[r];return void 0!==n?u[256*n+(255&e)]:252===r||253===r?"AL":g.test(r)?"L":8===r?"R":"N"},y=function(t){for(var e,r=0;r<t.length;r++){if("L"===(e=b(t.charAt(r))))return!1;if("R"===e)return!0}return!1},w=function(t,e,o,s){var c,u,l,h,f=e[s];switch(f){case"L":case"R":m=!1;break;case"N":case"AN":break;case"EN":m&&(f="AN");break;case"AL":m=!0,f="R";break;case"WS":f="N";break;case"CS":s<1||s+1>=e.length||"EN"!==(c=o[s-1])&&"AN"!==c||"EN"!==(u=e[s+1])&&"AN"!==u?f="N":m&&(u="AN"),f=u===c?u:"N";break;case"ES":f="EN"===(c=s>0?o[s-1]:"B")&&s+1<e.length&&"EN"===e[s+1]?"EN":"N";break;case"ET":if(s>0&&"EN"===o[s-1]){f="EN";break}if(m){f="N";break}for(l=s+1,h=e.length;l<h&&"ET"===e[l];)l++;f=l<h&&"EN"===e[l]?"EN":"N";break;case"NSM":if(i&&!a){for(h=e.length,l=s+1;l<h&&"NSM"===e[l];)l++;if(l<h){var d=t[s],p=d>=1425&&d<=2303||64286===d;if(c=e[l],p&&("R"===c||"AL"===c)){f="R";break}}}f=s<1||"B"===(c=e[s-1])?"N":o[s-1];break;case"B":m=!1,r=!0,f=v;break;case"S":n=!0,f="N";break;case"LRE":case"RLE":case"LRO":case"RLO":case"PDF":m=!1;break;case"BN":f="N"}return f},N=function(t,e,r){var n=t.split("");return r&&L(n,r,{hiLevel:v}),n.reverse(),e&&e.reverse(),n.join("")},L=function(t,e,i){var a,o,s,c,u,d=-1,p=t.length,g=0,y=[],N=v?h:l,L=[];for(m=!1,r=!1,n=!1,o=0;o<p;o++)L[o]=b(t[o]);for(s=0;s<p;s++){if(u=g,y[s]=w(t,L,y,s),a=240&(g=N[u][f[y[s]]]),g&=15,e[s]=c=N[g][5],a>0)if(16===a){for(o=d;o<s;o++)e[o]=1;d=-1}else d=-1;if(N[g][6])-1===d&&(d=s);else if(d>-1){for(o=d;o<s;o++)e[o]=c;d=-1}"B"===L[s]&&(e[s]=0),i.hiLevel|=c}n&&function(t,e,r){for(var n=0;n<r;n++)if("S"===t[n]){e[n]=v;for(var i=n-1;i>=0&&"WS"===t[i];i--)e[i]=v}}(L,e,p)},A=function(t,e,n,i,a){if(!(a.hiLevel<t)){if(1===t&&1===v&&!r)return e.reverse(),void(n&&n.reverse());for(var o,s,c,u,l=e.length,h=0;h<l;){if(i[h]>=t){for(c=h+1;c<l&&i[c]>=t;)c++;for(u=h,s=c-1;u<s;u++,s--)o=e[u],e[u]=e[s],e[s]=o,n&&(o=n[u],n[u]=n[s],n[s]=o);h=c}h++}}},x=function(t,e,r){var n=t.split(""),i={hiLevel:v};return r||(r=[]),L(n,r,i),function(t,e,r){if(0!==r.hiLevel&&c)for(var n,i=0;i<t.length;i++)1===e[i]&&(n=p.indexOf(t[i]))>=0&&(t[i]=p[n+1])}(n,r,i),A(2,n,e,r,i),A(1,n,e,r,i),n.join("")};return this.__bidiEngine__.doBidiReorder=function(t,e,r){if(function(t,e){if(e)for(var r=0;r<t.length;r++)e[r]=r;void 0===a&&(a=y(t)),void 0===s&&(s=y(t))}(t,e),i||!o||s)if(i&&o&&a^s)v=a?1:0,t=N(t,e,r);else if(!i&&o&&s)v=a?1:0,t=x(t,e,r),t=N(t,e);else if(!i||a||o||s){if(i&&!o&&a^s)t=N(t,e),a?(v=0,t=x(t,e,r)):(v=1,t=x(t,e,r),t=N(t,e));else if(i&&a&&!o&&s)v=1,t=x(t,e,r),t=N(t,e);else if(!i&&!o&&a^s){var n=c;a?(v=1,t=x(t,e,r),v=0,c=!1,t=x(t,e,r),c=n):(v=0,t=x(t,e,r),t=N(t,e),v=1,c=!1,t=x(t,e,r),c=n,t=N(t,e))}}else v=0,t=x(t,e,r);else v=a?1:0,t=x(t,e,r);return t},this.__bidiEngine__.setOptions=function(t){t&&(i=t.isInputVisual,o=t.isOutputVisual,a=t.isInputRtl,s=t.isOutputRtl,c=t.isSymmetricSwapping)},this.__bidiEngine__.setOptions(t),this.__bidiEngine__};var e=["BN","BN","BN","BN","BN","BN","BN","BN","BN","S","B","S","WS","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","B","B","B","S","WS","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","BN","BN","BN","BN","BN","BN","B","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","BN","CS","N","ET","ET","ET","ET","N","N","N","N","L","N","N","BN","N","N","ET","ET","EN","EN","N","L","N","N","N","EN","L","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","L","L","L","L","L","L","L","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","L","N","N","N","N","N","ET","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","NSM","R","NSM","NSM","R","NSM","NSM","R","NSM","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","N","N","N","N","N","R","R","R","R","R","N","N","N","N","N","N","N","N","N","N","N","AN","AN","AN","AN","AN","AN","N","N","AL","ET","ET","AL","CS","AL","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","AN","AN","AN","AN","AN","AN","AN","AN","AN","ET","AN","AN","AL","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AN","N","NSM","NSM","NSM","NSM","NSM","NSM","AL","AL","NSM","NSM","N","NSM","NSM","NSM","NSM","AL","AL","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","AL","AL","NSM","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","R","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","R","R","N","N","N","N","R","N","N","N","N","N","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","WS","BN","BN","BN","L","R","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","B","LRE","RLE","PDF","LRO","RLO","CS","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","WS","BN","BN","BN","BN","BN","N","LRI","RLI","FSI","PDI","BN","BN","BN","BN","BN","BN","EN","L","N","N","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","L","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","ES","ES","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","N","N","N","N","N","R","NSM","R","R","R","R","R","R","R","R","R","R","ES","R","R","R","R","R","R","R","R","R","R","R","R","R","N","R","R","R","R","R","N","R","N","R","R","N","R","R","N","R","R","R","R","R","R","R","R","R","R","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","NSM","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","CS","N","CS","N","N","CS","N","N","N","N","N","N","N","N","N","ET","N","N","ES","ES","N","N","N","N","N","ET","ET","N","N","N","N","N","AL","AL","AL","AL","AL","N","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","AL","N","N","BN","N","N","N","ET","ET","ET","N","N","N","N","N","ES","CS","ES","CS","CS","EN","EN","EN","EN","EN","EN","EN","EN","EN","EN","CS","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","N","N","N","N","N","N","N","N","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","L","N","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","L","L","L","N","N","L","L","L","N","N","N","ET","ET","N","N","N","ET","ET","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N","N"],r=new t.__bidiEngine__({isInputVisual:!0});t.API.events.push(["postProcessText",function(t){var e=t.text,n=(t.x,t.y,t.options||{}),i=(t.mutex,n.lang,[]);if(n.isInputVisual="boolean"!=typeof n.isInputVisual||n.isInputVisual,r.setOptions(n),"[object Array]"===Object.prototype.toString.call(e)){var a=0;for(i=[],a=0;a<e.length;a+=1)"[object Array]"===Object.prototype.toString.call(e[a])?i.push([r.doBidiReorder(e[a][0]),e[a][1],e[a][2]]):i.push([r.doBidiReorder(e[a])]);t.text=i}else t.text=r.doBidiReorder(e);r.setOptions({isInputVisual:!0})}])}(M),M.API.TTFFont=function(){function t(t){var e;if(this.rawData=t,e=this.contents=new Ve(t),this.contents.pos=4,"ttcf"===e.readString(4))throw new Error("TTCF not supported.");e.pos=0,this.parse(),this.subset=new lr(this),this.registerTTF()}return t.open=function(e){return new t(e)},t.prototype.parse=function(){return this.directory=new Ge(this.contents),this.head=new Xe(this),this.name=new rr(this),this.cmap=new Ze(this),this.toUnicode={},this.hhea=new $e(this),this.maxp=new nr(this),this.hmtx=new ir(this),this.post=new tr(this),this.os2=new Qe(this),this.loca=new ur(this),this.glyf=new or(this),this.ascender=this.os2.exists&&this.os2.ascender||this.hhea.ascender,this.decender=this.os2.exists&&this.os2.decender||this.hhea.decender,this.lineGap=this.os2.exists&&this.os2.lineGap||this.hhea.lineGap,this.bbox=[this.head.xMin,this.head.yMin,this.head.xMax,this.head.yMax]},t.prototype.registerTTF=function(){var t,e,r,n,i;if(this.scaleFactor=1e3/this.head.unitsPerEm,this.bbox=function(){var e,r,n,i;for(i=[],e=0,r=(n=this.bbox).length;e<r;e++)t=n[e],i.push(Math.round(t*this.scaleFactor));return i}.call(this),this.stemV=0,this.post.exists?(r=255&(n=this.post.italic_angle),0!=(32768&(e=n>>16))&&(e=-(1+(65535^e))),this.italicAngle=+(e+"."+r)):this.italicAngle=0,this.ascender=Math.round(this.ascender*this.scaleFactor),this.decender=Math.round(this.decender*this.scaleFactor),this.lineGap=Math.round(this.lineGap*this.scaleFactor),this.capHeight=this.os2.exists&&this.os2.capHeight||this.ascender,this.xHeight=this.os2.exists&&this.os2.xHeight||0,this.familyClass=(this.os2.exists&&this.os2.familyClass||0)>>8,this.isSerif=1===(i=this.familyClass)||2===i||3===i||4===i||5===i||7===i,this.isScript=10===this.familyClass,this.flags=0,this.post.isFixedPitch&&(this.flags|=1),this.isSerif&&(this.flags|=2),this.isScript&&(this.flags|=8),0!==this.italicAngle&&(this.flags|=64),this.flags|=32,!this.cmap.unicode)throw new Error("No unicode cmap for font")},t.prototype.characterToGlyph=function(t){var e;return(null!=(e=this.cmap.unicode)?e.codeMap[t]:void 0)||0},t.prototype.widthOfGlyph=function(t){var e;return e=1e3/this.head.unitsPerEm,this.hmtx.forGlyph(t).advance*e},t.prototype.widthOfString=function(t,e,r){var n,i,a,o;for(a=0,i=0,o=(t=""+t).length;0<=o?i<o:i>o;i=0<=o?++i:--i)n=t.charCodeAt(i),a+=this.widthOfGlyph(this.characterToGlyph(n))+r*(1e3/e)||0;return a*(e/1e3)},t.prototype.lineHeight=function(t,e){var r;return null==e&&(e=!1),r=e?this.lineGap:0,(this.ascender+r-this.decender)/1e3*t},t}();var We,Ve=function(){function t(t){this.data=null!=t?t:[],this.pos=0,this.length=this.data.length}return t.prototype.readByte=function(){return this.data[this.pos++]},t.prototype.writeByte=function(t){return this.data[this.pos++]=t},t.prototype.readUInt32=function(){return 16777216*this.readByte()+(this.readByte()<<16)+(this.readByte()<<8)+this.readByte()},t.prototype.writeUInt32=function(t){return this.writeByte(t>>>24&255),this.writeByte(t>>16&255),this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt32=function(){var t;return(t=this.readUInt32())>=2147483648?t-4294967296:t},t.prototype.writeInt32=function(t){return t<0&&(t+=4294967296),this.writeUInt32(t)},t.prototype.readUInt16=function(){return this.readByte()<<8|this.readByte()},t.prototype.writeUInt16=function(t){return this.writeByte(t>>8&255),this.writeByte(255&t)},t.prototype.readInt16=function(){var t;return(t=this.readUInt16())>=32768?t-65536:t},t.prototype.writeInt16=function(t){return t<0&&(t+=65536),this.writeUInt16(t)},t.prototype.readString=function(t){var e,r;for(r=[],e=0;0<=t?e<t:e>t;e=0<=t?++e:--e)r[e]=String.fromCharCode(this.readByte());return r.join("")},t.prototype.writeString=function(t){var e,r,n;for(n=[],e=0,r=t.length;0<=r?e<r:e>r;e=0<=r?++e:--e)n.push(this.writeByte(t.charCodeAt(e)));return n},t.prototype.readShort=function(){return this.readInt16()},t.prototype.writeShort=function(t){return this.writeInt16(t)},t.prototype.readLongLong=function(){var t,e,r,n,i,a,o,s;return t=this.readByte(),e=this.readByte(),r=this.readByte(),n=this.readByte(),i=this.readByte(),a=this.readByte(),o=this.readByte(),s=this.readByte(),128&t?-1*(72057594037927940*(255^t)+281474976710656*(255^e)+1099511627776*(255^r)+4294967296*(255^n)+16777216*(255^i)+65536*(255^a)+256*(255^o)+(255^s)+1):72057594037927940*t+281474976710656*e+1099511627776*r+4294967296*n+16777216*i+65536*a+256*o+s},t.prototype.writeLongLong=function(t){var e,r;return e=Math.floor(t/4294967296),r=4294967295&t,this.writeByte(e>>24&255),this.writeByte(e>>16&255),this.writeByte(e>>8&255),this.writeByte(255&e),this.writeByte(r>>24&255),this.writeByte(r>>16&255),this.writeByte(r>>8&255),this.writeByte(255&r)},t.prototype.readInt=function(){return this.readInt32()},t.prototype.writeInt=function(t){return this.writeInt32(t)},t.prototype.read=function(t){var e,r;for(e=[],r=0;0<=t?r<t:r>t;r=0<=t?++r:--r)e.push(this.readByte());return e},t.prototype.write=function(t){var e,r,n,i;for(i=[],r=0,n=t.length;r<n;r++)e=t[r],i.push(this.writeByte(e));return i},t}(),Ge=function(){var t;function e(t){var e,r,n;for(this.scalarType=t.readInt(),this.tableCount=t.readShort(),this.searchRange=t.readShort(),this.entrySelector=t.readShort(),this.rangeShift=t.readShort(),this.tables={},r=0,n=this.tableCount;0<=n?r<n:r>n;r=0<=n?++r:--r)e={tag:t.readString(4),checksum:t.readInt(),offset:t.readInt(),length:t.readInt()},this.tables[e.tag]=e}return e.prototype.encode=function(e){var r,n,i,a,o,s,c,u,l,h,f,d,p;for(p in f=Object.keys(e).length,s=Math.log(2),l=16*Math.floor(Math.log(f)/s),a=Math.floor(l/s),u=16*f-l,(n=new Ve).writeInt(this.scalarType),n.writeShort(f),n.writeShort(l),n.writeShort(a),n.writeShort(u),i=16*f,c=n.pos+i,o=null,d=[],e)for(h=e[p],n.writeString(p),n.writeInt(t(h)),n.writeInt(c),n.writeInt(h.length),d=d.concat(h),"head"===p&&(o=c),c+=h.length;c%4;)d.push(0),c++;return n.write(d),r=2981146554-t(n.data),n.pos=o+8,n.writeUInt32(r),n.data},t=function(t){var e,r,n,i;for(t=ar.call(t);t.length%4;)t.push(0);for(n=new Ve(t),r=0,e=0,i=t.length;e<i;e=e+=4)r+=n.readUInt32();return 4294967295&r},e}(),Ye={}.hasOwnProperty,Je=function(t,e){for(var r in e)Ye.call(e,r)&&(t[r]=e[r]);function n(){this.constructor=t}return n.prototype=e.prototype,t.prototype=new n,t.__super__=e.prototype,t},Xe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return Je(e,t),e.prototype.tag="head",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.revision=t.readInt(),this.checkSumAdjustment=t.readInt(),this.magicNumber=t.readInt(),this.flags=t.readShort(),this.unitsPerEm=t.readShort(),this.created=t.readLongLong(),this.modified=t.readLongLong(),this.xMin=t.readShort(),this.yMin=t.readShort(),this.xMax=t.readShort(),this.yMax=t.readShort(),this.macStyle=t.readShort(),this.lowestRecPPEM=t.readShort(),this.fontDirectionHint=t.readShort(),this.indexToLocFormat=t.readShort(),this.glyphDataFormat=t.readShort()},e.prototype.encode=function(t){var e;return(e=new Ve).writeInt(this.version),e.writeInt(this.revision),e.writeInt(this.checkSumAdjustment),e.writeInt(this.magicNumber),e.writeShort(this.flags),e.writeShort(this.unitsPerEm),e.writeLongLong(this.created),e.writeLongLong(this.modified),e.writeShort(this.xMin),e.writeShort(this.yMin),e.writeShort(this.xMax),e.writeShort(this.yMax),e.writeShort(this.macStyle),e.writeShort(this.lowestRecPPEM),e.writeShort(this.fontDirectionHint),e.writeShort(t),e.writeShort(this.glyphDataFormat),e.data},e}(We=function(){function t(t){var e;this.file=t,e=this.file.directory.tables[this.tag],this.exists=!!e,e&&(this.offset=e.offset,this.length=e.length,this.parse(this.file.contents))}return t.prototype.parse=function(){},t.prototype.encode=function(){},t.prototype.raw=function(){return this.exists?(this.file.contents.pos=this.offset,this.file.contents.read(this.length)):null},t}()),Ke=function(){function t(t,e){var r,n,i,a,o,s,c,u,l,h,f,d,p,g,m,v,b;switch(this.platformID=t.readUInt16(),this.encodingID=t.readShort(),this.offset=e+t.readInt(),l=t.pos,t.pos=this.offset,this.format=t.readUInt16(),this.length=t.readUInt16(),this.language=t.readUInt16(),this.isUnicode=3===this.platformID&&1===this.encodingID&&4===this.format||0===this.platformID&&4===this.format,this.codeMap={},this.format){case 0:for(s=0;s<256;++s)this.codeMap[s]=t.readByte();break;case 4:for(f=t.readUInt16(),h=f/2,t.pos+=6,i=function(){var e,r;for(r=[],s=e=0;0<=h?e<h:e>h;s=0<=h?++e:--e)r.push(t.readUInt16());return r}(),t.pos+=2,p=function(){var e,r;for(r=[],s=e=0;0<=h?e<h:e>h;s=0<=h?++e:--e)r.push(t.readUInt16());return r}(),c=function(){var e,r;for(r=[],s=e=0;0<=h?e<h:e>h;s=0<=h?++e:--e)r.push(t.readUInt16());return r}(),u=function(){var e,r;for(r=[],s=e=0;0<=h?e<h:e>h;s=0<=h?++e:--e)r.push(t.readUInt16());return r}(),n=(this.length-t.pos+this.offset)/2,o=function(){var e,r;for(r=[],s=e=0;0<=n?e<n:e>n;s=0<=n?++e:--e)r.push(t.readUInt16());return r}(),s=m=0,b=i.length;m<b;s=++m)for(g=i[s],r=v=d=p[s];d<=g?v<=g:v>=g;r=d<=g?++v:--v)0===u[s]?a=r+c[s]:0!==(a=o[u[s]/2+(r-d)-(h-s)]||0)&&(a+=c[s]),this.codeMap[r]=65535&a}t.pos=l}return t.encode=function(t,e){var r,n,i,a,o,s,c,u,l,h,f,d,p,g,m,v,b,y,w,N,L,A,x,S,_,P,k,F,I,C,j,O,B,M,E,q,D,R,T,U,z,H,W,V,G,Y;switch(F=new Ve,a=Object.keys(t).sort((function(t,e){return t-e})),e){case"macroman":for(p=0,g=function(){var t=[];for(d=0;d<256;++d)t.push(0);return t}(),v={0:0},i={},I=0,B=a.length;I<B;I++)null==v[W=t[n=a[I]]]&&(v[W]=++p),i[n]={old:t[n],new:v[t[n]]},g[n]=v[t[n]];return F.writeUInt16(1),F.writeUInt16(0),F.writeUInt32(12),F.writeUInt16(0),F.writeUInt16(262),F.writeUInt16(0),F.write(g),{charMap:i,subtable:F.data,maxGlyphID:p+1};case"unicode":for(P=[],l=[],b=0,v={},r={},m=c=null,C=0,M=a.length;C<M;C++)null==v[w=t[n=a[C]]]&&(v[w]=++b),r[n]={old:w,new:v[w]},o=v[w]-n,null!=m&&o===c||(m&&l.push(m),P.push(n),c=o),m=n;for(m&&l.push(m),l.push(65535),P.push(65535),S=2*(x=P.length),A=2*Math.pow(Math.log(x)/Math.LN2,2),h=Math.log(A/2)/Math.LN2,L=2*x-A,s=[],N=[],f=[],d=j=0,E=P.length;j<E;d=++j){if(_=P[d],u=l[d],65535===_){s.push(0),N.push(0);break}if(_-(k=r[_].new)>=32768)for(s.push(0),N.push(2*(f.length+x-d)),n=O=_;_<=u?O<=u:O>=u;n=_<=u?++O:--O)f.push(r[n].new);else s.push(k-_),N.push(0)}for(F.writeUInt16(3),F.writeUInt16(1),F.writeUInt32(12),F.writeUInt16(4),F.writeUInt16(16+8*x+2*f.length),F.writeUInt16(0),F.writeUInt16(S),F.writeUInt16(A),F.writeUInt16(h),F.writeUInt16(L),z=0,q=l.length;z<q;z++)n=l[z],F.writeUInt16(n);for(F.writeUInt16(0),H=0,D=P.length;H<D;H++)n=P[H],F.writeUInt16(n);for(V=0,R=s.length;V<R;V++)o=s[V],F.writeUInt16(o);for(G=0,T=N.length;G<T;G++)y=N[G],F.writeUInt16(y);for(Y=0,U=f.length;Y<U;Y++)p=f[Y],F.writeUInt16(p);return{charMap:r,subtable:F.data,maxGlyphID:b+1}}},t}(),Ze=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return Je(e,t),e.prototype.tag="cmap",e.prototype.parse=function(t){var e,r,n;for(t.pos=this.offset,this.version=t.readUInt16(),n=t.readUInt16(),this.tables=[],this.unicode=null,r=0;0<=n?r<n:r>n;r=0<=n?++r:--r)e=new Ke(t,this.offset),this.tables.push(e),e.isUnicode&&null==this.unicode&&(this.unicode=e);return!0},e.encode=function(t,e){var r,n;return null==e&&(e="macroman"),r=Ke.encode(t,e),(n=new Ve).writeUInt16(0),n.writeUInt16(1),r.table=n.data.concat(r.subtable),r},e}(We),$e=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return Je(e,t),e.prototype.tag="hhea",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.ascender=t.readShort(),this.decender=t.readShort(),this.lineGap=t.readShort(),this.advanceWidthMax=t.readShort(),this.minLeftSideBearing=t.readShort(),this.minRightSideBearing=t.readShort(),this.xMaxExtent=t.readShort(),this.caretSlopeRise=t.readShort(),this.caretSlopeRun=t.readShort(),this.caretOffset=t.readShort(),t.pos+=8,this.metricDataFormat=t.readShort(),this.numberOfMetrics=t.readUInt16()},e}(We),Qe=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return Je(e,t),e.prototype.tag="OS/2",e.prototype.parse=function(t){if(t.pos=this.offset,this.version=t.readUInt16(),this.averageCharWidth=t.readShort(),this.weightClass=t.readUInt16(),this.widthClass=t.readUInt16(),this.type=t.readShort(),this.ySubscriptXSize=t.readShort(),this.ySubscriptYSize=t.readShort(),this.ySubscriptXOffset=t.readShort(),this.ySubscriptYOffset=t.readShort(),this.ySuperscriptXSize=t.readShort(),this.ySuperscriptYSize=t.readShort(),this.ySuperscriptXOffset=t.readShort(),this.ySuperscriptYOffset=t.readShort(),this.yStrikeoutSize=t.readShort(),this.yStrikeoutPosition=t.readShort(),this.familyClass=t.readShort(),this.panose=function(){var e,r;for(r=[],e=0;e<10;++e)r.push(t.readByte());return r}(),this.charRange=function(){var e,r;for(r=[],e=0;e<4;++e)r.push(t.readInt());return r}(),this.vendorID=t.readString(4),this.selection=t.readShort(),this.firstCharIndex=t.readShort(),this.lastCharIndex=t.readShort(),this.version>0&&(this.ascent=t.readShort(),this.descent=t.readShort(),this.lineGap=t.readShort(),this.winAscent=t.readShort(),this.winDescent=t.readShort(),this.codePageRange=function(){var e,r;for(r=[],e=0;e<2;e=++e)r.push(t.readInt());return r}(),this.version>1))return this.xHeight=t.readShort(),this.capHeight=t.readShort(),this.defaultChar=t.readShort(),this.breakChar=t.readShort(),this.maxContext=t.readShort()},e}(We),tr=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return Je(e,t),e.prototype.tag="post",e.prototype.parse=function(t){var e,r,n;switch(t.pos=this.offset,this.format=t.readInt(),this.italicAngle=t.readInt(),this.underlinePosition=t.readShort(),this.underlineThickness=t.readShort(),this.isFixedPitch=t.readInt(),this.minMemType42=t.readInt(),this.maxMemType42=t.readInt(),this.minMemType1=t.readInt(),this.maxMemType1=t.readInt(),this.format){case 65536:break;case 131072:var i;for(r=t.readUInt16(),this.glyphNameIndex=[],i=0;0<=r?i<r:i>r;i=0<=r?++i:--i)this.glyphNameIndex.push(t.readUInt16());for(this.names=[],n=[];t.pos<this.offset+this.length;)e=t.readByte(),n.push(this.names.push(t.readString(e)));return n;case 151552:return r=t.readUInt16(),this.offsets=t.read(r);case 196608:break;case 262144:return this.map=function(){var e,r,n;for(n=[],i=e=0,r=this.file.maxp.numGlyphs;0<=r?e<r:e>r;i=0<=r?++e:--e)n.push(t.readUInt32());return n}.call(this)}},e}(We),er=function(t,e){this.raw=t,this.length=t.length,this.platformID=e.platformID,this.encodingID=e.encodingID,this.languageID=e.languageID},rr=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return Je(e,t),e.prototype.tag="name",e.prototype.parse=function(t){var e,r,n,i,a,o,s,c,u,l,h;for(t.pos=this.offset,t.readShort(),e=t.readShort(),o=t.readShort(),r=[],i=0;0<=e?i<e:i>e;i=0<=e?++i:--i)r.push({platformID:t.readShort(),encodingID:t.readShort(),languageID:t.readShort(),nameID:t.readShort(),length:t.readShort(),offset:this.offset+o+t.readShort()});for(s={},i=u=0,l=r.length;u<l;i=++u)n=r[i],t.pos=n.offset,c=t.readString(n.length),a=new er(c,n),null==s[h=n.nameID]&&(s[h]=[]),s[n.nameID].push(a);this.strings=s,this.copyright=s[0],this.fontFamily=s[1],this.fontSubfamily=s[2],this.uniqueSubfamily=s[3],this.fontName=s[4],this.version=s[5];try{this.postscriptName=s[6][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}catch(t){this.postscriptName=s[4][0].raw.replace(/[\x00-\x19\x80-\xff]/g,"")}return this.trademark=s[7],this.manufacturer=s[8],this.designer=s[9],this.description=s[10],this.vendorUrl=s[11],this.designerUrl=s[12],this.license=s[13],this.licenseUrl=s[14],this.preferredFamily=s[15],this.preferredSubfamily=s[17],this.compatibleFull=s[18],this.sampleText=s[19]},e}(We),nr=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return Je(e,t),e.prototype.tag="maxp",e.prototype.parse=function(t){return t.pos=this.offset,this.version=t.readInt(),this.numGlyphs=t.readUInt16(),this.maxPoints=t.readUInt16(),this.maxContours=t.readUInt16(),this.maxCompositePoints=t.readUInt16(),this.maxComponentContours=t.readUInt16(),this.maxZones=t.readUInt16(),this.maxTwilightPoints=t.readUInt16(),this.maxStorage=t.readUInt16(),this.maxFunctionDefs=t.readUInt16(),this.maxInstructionDefs=t.readUInt16(),this.maxStackElements=t.readUInt16(),this.maxSizeOfInstructions=t.readUInt16(),this.maxComponentElements=t.readUInt16(),this.maxComponentDepth=t.readUInt16()},e}(We),ir=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return Je(e,t),e.prototype.tag="hmtx",e.prototype.parse=function(t){var e,r,n,i,a,o,s;for(t.pos=this.offset,this.metrics=[],e=0,o=this.file.hhea.numberOfMetrics;0<=o?e<o:e>o;e=0<=o?++e:--e)this.metrics.push({advance:t.readUInt16(),lsb:t.readInt16()});for(n=this.file.maxp.numGlyphs-this.file.hhea.numberOfMetrics,this.leftSideBearings=function(){var r,i;for(i=[],e=r=0;0<=n?r<n:r>n;e=0<=n?++r:--r)i.push(t.readInt16());return i}(),this.widths=function(){var t,e,r,n;for(n=[],t=0,e=(r=this.metrics).length;t<e;t++)i=r[t],n.push(i.advance);return n}.call(this),r=this.widths[this.widths.length-1],s=[],e=a=0;0<=n?a<n:a>n;e=0<=n?++a:--a)s.push(this.widths.push(r));return s},e.prototype.forGlyph=function(t){return t in this.metrics?this.metrics[t]:{advance:this.metrics[this.metrics.length-1].advance,lsb:this.leftSideBearings[t-this.metrics.length]}},e}(We),ar=[].slice,or=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return Je(e,t),e.prototype.tag="glyf",e.prototype.parse=function(){return this.cache={}},e.prototype.glyphFor=function(t){var e,r,n,i,a,o,s,c,u,l;return t in this.cache?this.cache[t]:(i=this.file.loca,e=this.file.contents,r=i.indexOf(t),0===(n=i.lengthOf(t))?this.cache[t]=null:(e.pos=this.offset+r,a=(o=new Ve(e.read(n))).readShort(),c=o.readShort(),l=o.readShort(),s=o.readShort(),u=o.readShort(),this.cache[t]=-1===a?new cr(o,c,l,s,u):new sr(o,a,c,l,s,u),this.cache[t]))},e.prototype.encode=function(t,e,r){var n,i,a,o,s;for(a=[],i=[],o=0,s=e.length;o<s;o++)n=t[e[o]],i.push(a.length),n&&(a=a.concat(n.encode(r)));return i.push(a.length),{table:a,offsets:i}},e}(We),sr=function(){function t(t,e,r,n,i,a){this.raw=t,this.numberOfContours=e,this.xMin=r,this.yMin=n,this.xMax=i,this.yMax=a,this.compound=!1}return t.prototype.encode=function(){return this.raw.data},t}(),cr=function(){function t(t,e,r,n,i){var a,o;for(this.raw=t,this.xMin=e,this.yMin=r,this.xMax=n,this.yMax=i,this.compound=!0,this.glyphIDs=[],this.glyphOffsets=[],a=this.raw;o=a.readShort(),this.glyphOffsets.push(a.pos),this.glyphIDs.push(a.readUInt16()),32&o;)a.pos+=1&o?4:2,128&o?a.pos+=8:64&o?a.pos+=4:8&o&&(a.pos+=2)}return 1,8,32,64,128,t.prototype.encode=function(){var t,e,r;for(e=new Ve(ar.call(this.raw.data)),t=0,r=this.glyphIDs.length;t<r;++t)e.pos=this.glyphOffsets[t];return e.data},t}(),ur=function(t){function e(){return e.__super__.constructor.apply(this,arguments)}return Je(e,t),e.prototype.tag="loca",e.prototype.parse=function(t){var e,r;return t.pos=this.offset,e=this.file.head.indexToLocFormat,this.offsets=0===e?function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=2)n.push(2*t.readUInt16());return n}.call(this):function(){var e,n;for(n=[],r=0,e=this.length;r<e;r+=4)n.push(t.readUInt32());return n}.call(this)},e.prototype.indexOf=function(t){return this.offsets[t]},e.prototype.lengthOf=function(t){return this.offsets[t+1]-this.offsets[t]},e.prototype.encode=function(t,e){for(var r=new Uint32Array(this.offsets.length),n=0,i=0,a=0;a<r.length;++a)if(r[a]=n,i<e.length&&e[i]==a){++i,r[a]=n;var o=this.offsets[a],s=this.offsets[a+1]-o;s>0&&(n+=s)}for(var c=new Array(4*r.length),u=0;u<r.length;++u)c[4*u+3]=255&r[u],c[4*u+2]=(65280&r[u])>>8,c[4*u+1]=(16711680&r[u])>>16,c[4*u]=(4278190080&r[u])>>24;return c},e}(We),lr=function(){function t(t){this.font=t,this.subset={},this.unicodes={},this.next=33}return t.prototype.generateCmap=function(){var t,e,r,n,i;for(e in n=this.font.cmap.tables[0].codeMap,t={},i=this.subset)r=i[e],t[e]=n[r];return t},t.prototype.glyphsFor=function(t){var e,r,n,i,a,o,s;for(n={},a=0,o=t.length;a<o;a++)n[i=t[a]]=this.font.glyf.glyphFor(i);for(i in e=[],n)(null!=(r=n[i])?r.compound:void 0)&&e.push.apply(e,r.glyphIDs);if(e.length>0)for(i in s=this.glyphsFor(e))r=s[i],n[i]=r;return n},t.prototype.encode=function(t,e){var r,n,i,a,o,s,c,u,l,h,f,d,p,g,m;for(n in r=Ze.encode(this.generateCmap(),"unicode"),a=this.glyphsFor(t),f={0:0},m=r.charMap)f[(s=m[n]).old]=s.new;for(d in h=r.maxGlyphID,a)d in f||(f[d]=h++);return u=function(t){var e,r;for(e in r={},t)r[t[e]]=e;return r}(f),l=Object.keys(u).sort((function(t,e){return t-e})),p=function(){var t,e,r;for(r=[],t=0,e=l.length;t<e;t++)o=l[t],r.push(u[o]);return r}(),i=this.font.glyf.encode(a,p,f),c=this.font.loca.encode(i.offsets,p),g={cmap:this.font.cmap.raw(),glyf:i.table,loca:c,hmtx:this.font.hmtx.raw(),hhea:this.font.hhea.raw(),maxp:this.font.maxp.raw(),post:this.font.post.raw(),name:this.font.name.raw(),head:this.font.head.encode(e)},this.font.os2.exists&&(g["OS/2"]=this.font.os2.raw()),this.font.directory.encode(g)},t}();M.API.PDFObject=function(){var t;function e(){}return t=function(t,e){return(Array(e+1).join("0")+t).slice(-e)},e.convert=function(r){var n,i,a,o;if(Array.isArray(r))return"["+function(){var t,i,a;for(a=[],t=0,i=r.length;t<i;t++)n=r[t],a.push(e.convert(n));return a}().join(" ")+"]";if("string"==typeof r)return"/"+r;if(null!=r?r.isString:void 0)return"("+r+")";if(r instanceof Date)return"(D:"+t(r.getUTCFullYear(),4)+t(r.getUTCMonth(),2)+t(r.getUTCDate(),2)+t(r.getUTCHours(),2)+t(r.getUTCMinutes(),2)+t(r.getUTCSeconds(),2)+"Z)";if("[object Object]"==={}.toString.call(r)){for(i in a=["<<"],r)o=r[i],a.push("/"+i+" "+e.convert(o));return a.push(">>"),a.join("\n")}return""+r},e}(),t.AcroForm=xt,t.AcroFormAppearance=Lt,t.AcroFormButton=gt,t.AcroFormCheckBox=yt,t.AcroFormChoiceField=ht,t.AcroFormComboBox=dt,t.AcroFormEditBox=pt,t.AcroFormListBox=ft,t.AcroFormPasswordField=Nt,t.AcroFormPushButton=mt,t.AcroFormRadioButton=vt,t.AcroFormTextField=wt,t.GState=C,t.ShadingPattern=O,t.TilingPattern=B,t.default=M,t.jsPDF=M,Object.defineProperty(t,"__esModule",{value:!0})}));


/*!
 * 
 *               jsPDF AutoTable plugin v3.8.4
 *
 *               Copyright (c) 2024 Simon Bengtsson, https://github.com/simonbengtsson/jsPDF-AutoTable
 *               Licensed under the MIT License.
 *               http://opensource.org/licenses/mit-license
 *
 */
!function(t,e){if("object"==typeof exports&&"object"==typeof module)module.exports=e(function(){try{return require("jspdf")}catch(t){}}());else if("function"==typeof define&&define.amd)define(["jspdf"],e);else{var n="object"==typeof exports?e(function(){try{return require("jspdf")}catch(t){}}()):e(t.jspdf);for(var o in n)("object"==typeof exports?exports:t)[o]=n[o]}}("undefined"!=typeof globalThis?globalThis:void 0!==this?this:"undefined"!=typeof window?window:"undefined"!=typeof self?self:global,(function(t){return function(){"use strict";var e={172:function(t,e){var n,o=this&&this.__extends||(n=function(t,e){return n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n])},n(t,e)},function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Class extends value "+String(e)+" is not a constructor or null");function o(){this.constructor=t}n(t,e),t.prototype=null===e?Object.create(e):(o.prototype=e.prototype,new o)});Object.defineProperty(e,"__esModule",{value:!0}),e.CellHookData=e.HookData=void 0;var r=function(t,e,n){this.table=e,this.pageNumber=e.pageNumber,this.pageCount=this.pageNumber,this.settings=e.settings,this.cursor=n,this.doc=t.getDocument()};e.HookData=r;var i=function(t){function e(e,n,o,r,i,l){var a=t.call(this,e,n,l)||this;return a.cell=o,a.row=r,a.column=i,a.section=r.section,a}return o(e,t),e}(r);e.CellHookData=i},340:function(t,e,n){Object.defineProperty(e,"__esModule",{value:!0});var o=n(4),r=n(136),i=n(744),l=n(776),a=n(664),s=n(972);e.default=function(t){t.API.autoTable=function(){for(var t,e=[],n=0;n<arguments.length;n++)e[n]=arguments[n];1===e.length?t=e[0]:(console.error("Use of deprecated autoTable initiation"),(t=e[2]||{}).columns=e[0],t.body=e[1]);var o=(0,l.parseInput)(this,t),r=(0,s.createTable)(this,o);return(0,a.drawTable)(this,r),this},t.API.lastAutoTable=!1,t.API.previousAutoTable=!1,t.API.autoTable.previous=!1,t.API.autoTableText=function(t,e,n,o){(0,r.default)(t,e,n,o,this)},t.API.autoTableSetDefaults=function(t){return i.DocHandler.setDefaults(t,this),this},t.autoTableSetDefaults=function(t,e){i.DocHandler.setDefaults(t,e)},t.API.autoTableHtmlToJson=function(t,e){var n;if(void 0===e&&(e=!1),"undefined"==typeof window)return console.error("Cannot run autoTableHtmlToJson in non browser environment"),null;var r=new i.DocHandler(this),l=(0,o.parseHtml)(r,t,window,e,!1),a=l.head,s=l.body;return{columns:(null===(n=a[0])||void 0===n?void 0:n.map((function(t){return t.content})))||[],rows:s,data:s}},t.API.autoTableEndPosY=function(){console.error("Use of deprecated function: autoTableEndPosY. Use doc.lastAutoTable.finalY instead.");var t=this.lastAutoTable;return t&&t.finalY?t.finalY:0},t.API.autoTableAddPageContent=function(e){return console.error("Use of deprecated function: autoTableAddPageContent. Use jsPDF.autoTableSetDefaults({didDrawPage: () => {}}) instead."),t.API.autoTable.globalDefaults||(t.API.autoTable.globalDefaults={}),t.API.autoTable.globalDefaults.addPageContent=e,this},t.API.autoTableAddPage=function(){return console.error("Use of deprecated function: autoTableAddPage. Use doc.addPage()"),this.addPage(),this}}},136:function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e,n,o,r){o=o||{};var i=r.internal.scaleFactor,l=r.internal.getFontSize()/i,a=l*(r.getLineHeightFactor?r.getLineHeightFactor():1.15),s="",u=1;if("middle"!==o.valign&&"bottom"!==o.valign&&"center"!==o.halign&&"right"!==o.halign||(u=(s="string"==typeof t?t.split(/\r\n|\r|\n/g):t).length||1),n+=l*(2-1.15),"middle"===o.valign?n-=u/2*a:"bottom"===o.valign&&(n-=u*a),"center"===o.halign||"right"===o.halign){var d=l;if("center"===o.halign&&(d*=.5),s&&u>=1){for(var h=0;h<s.length;h++)r.text(s[h],e-r.getStringUnitWidth(s[h])*d,n),n+=a;return r}e-=r.getStringUnitWidth(t)*d}return"justify"===o.halign?r.text(t,e,n,{maxWidth:o.maxWidth||100,align:"justify"}):r.text(t,e,n),r}},420:function(t,e){function n(t,e){var n=t>0,o=e||0===e;return n&&o?"DF":n?"S":o?"F":null}function o(t,e){var n,o,r,i;if(t=t||e,Array.isArray(t)){if(t.length>=4)return{top:t[0],right:t[1],bottom:t[2],left:t[3]};if(3===t.length)return{top:t[0],right:t[1],bottom:t[2],left:t[1]};if(2===t.length)return{top:t[0],right:t[1],bottom:t[0],left:t[1]};t=1===t.length?t[0]:e}return"object"==typeof t?("number"==typeof t.vertical&&(t.top=t.vertical,t.bottom=t.vertical),"number"==typeof t.horizontal&&(t.right=t.horizontal,t.left=t.horizontal),{left:null!==(n=t.left)&&void 0!==n?n:e,top:null!==(o=t.top)&&void 0!==o?o:e,right:null!==(r=t.right)&&void 0!==r?r:e,bottom:null!==(i=t.bottom)&&void 0!==i?i:e}):("number"!=typeof t&&(t=e),{top:t,right:t,bottom:t,left:t})}Object.defineProperty(e,"__esModule",{value:!0}),e.getPageAvailableWidth=e.parseSpacing=e.getFillStyle=e.addTableBorder=e.getStringWidth=void 0,e.getStringWidth=function(t,e,n){return n.applyStyles(e,!0),(Array.isArray(t)?t:[t]).map((function(t){return n.getTextWidth(t)})).reduce((function(t,e){return Math.max(t,e)}),0)},e.addTableBorder=function(t,e,o,r){var i=e.settings.tableLineWidth,l=e.settings.tableLineColor;t.applyStyles({lineWidth:i,lineColor:l});var a=n(i,!1);a&&t.rect(o.x,o.y,e.getWidth(t.pageSize().width),r.y-o.y,a)},e.getFillStyle=n,e.parseSpacing=o,e.getPageAvailableWidth=function(t,e){var n=o(e.settings.margin,0);return t.pageSize().width-(n.left+n.right)}},796:function(t,e){var n,o=this&&this.__extends||(n=function(t,e){return n=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(t,e){t.__proto__=e}||function(t,e){for(var n in e)Object.prototype.hasOwnProperty.call(e,n)&&(t[n]=e[n])},n(t,e)},function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Class extends value "+String(e)+" is not a constructor or null");function o(){this.constructor=t}n(t,e),t.prototype=null===e?Object.create(e):(o.prototype=e.prototype,new o)});Object.defineProperty(e,"__esModule",{value:!0}),e.getTheme=e.defaultStyles=e.HtmlRowInput=void 0;var r=function(t){function e(e){var n=t.call(this)||this;return n._element=e,n}return o(e,t),e}(Array);e.HtmlRowInput=r,e.defaultStyles=function(t){return{font:"helvetica",fontStyle:"normal",overflow:"linebreak",fillColor:!1,textColor:20,halign:"left",valign:"top",fontSize:10,cellPadding:5/t,lineColor:200,lineWidth:0,cellWidth:"auto",minCellHeight:0,minCellWidth:0}},e.getTheme=function(t){return{striped:{table:{fillColor:255,textColor:80,fontStyle:"normal"},head:{textColor:255,fillColor:[41,128,185],fontStyle:"bold"},body:{},foot:{textColor:255,fillColor:[41,128,185],fontStyle:"bold"},alternateRow:{fillColor:245}},grid:{table:{fillColor:255,textColor:80,fontStyle:"normal",lineWidth:.1},head:{textColor:255,fillColor:[26,188,156],fontStyle:"bold",lineWidth:0},body:{},foot:{textColor:255,fillColor:[26,188,156],fontStyle:"bold",lineWidth:0},alternateRow:{}},plain:{head:{fontStyle:"bold"},foot:{fontStyle:"bold"}}}[t]}},903:function(t,e,n){Object.defineProperty(e,"__esModule",{value:!0}),e.parseCss=void 0;var o=n(420);function r(t,e){var n=i(t,e);if(!n)return null;var o=n.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d*\.?\d*))?\)$/);if(!o||!Array.isArray(o))return null;var r=[parseInt(o[1]),parseInt(o[2]),parseInt(o[3])];return 0===parseInt(o[4])||isNaN(r[0])||isNaN(r[1])||isNaN(r[2])?null:r}function i(t,e){var n=e(t);return"rgba(0, 0, 0, 0)"===n||"transparent"===n||"initial"===n||"inherit"===n?null==t.parentElement?null:i(t.parentElement,e):n}e.parseCss=function(t,e,n,i,l){var a={},s=96/72,u=r(e,(function(t){return l.getComputedStyle(t).backgroundColor}));null!=u&&(a.fillColor=u);var d=r(e,(function(t){return l.getComputedStyle(t).color}));null!=d&&(a.textColor=d);var h=function(t,e){var n=[t.paddingTop,t.paddingRight,t.paddingBottom,t.paddingLeft],r=96/(72/e),i=(parseInt(t.lineHeight)-parseInt(t.fontSize))/e/2,l=n.map((function(t){return parseInt(t||"0")/r})),a=(0,o.parseSpacing)(l,0);i>a.top&&(a.top=i);i>a.bottom&&(a.bottom=i);return a}(i,n);h&&(a.cellPadding=h);var c="borderTopColor",f=s*n,g=i.borderTopWidth;if(i.borderBottomWidth===g&&i.borderRightWidth===g&&i.borderLeftWidth===g){var p=(parseFloat(g)||0)/f;p&&(a.lineWidth=p)}else a.lineWidth={top:(parseFloat(i.borderTopWidth)||0)/f,right:(parseFloat(i.borderRightWidth)||0)/f,bottom:(parseFloat(i.borderBottomWidth)||0)/f,left:(parseFloat(i.borderLeftWidth)||0)/f},a.lineWidth.top||(a.lineWidth.right?c="borderRightColor":a.lineWidth.bottom?c="borderBottomColor":a.lineWidth.left&&(c="borderLeftColor"));var y=r(e,(function(t){return l.getComputedStyle(t)[c]}));null!=y&&(a.lineColor=y);var v=["left","right","center","justify"];-1!==v.indexOf(i.textAlign)&&(a.halign=i.textAlign),-1!==(v=["middle","bottom","top"]).indexOf(i.verticalAlign)&&(a.valign=i.verticalAlign);var m=parseInt(i.fontSize||"");isNaN(m)||(a.fontSize=m/s);var b=function(t){var e="";("bold"===t.fontWeight||"bolder"===t.fontWeight||parseInt(t.fontWeight)>=700)&&(e="bold");"italic"!==t.fontStyle&&"oblique"!==t.fontStyle||(e+="italic");return e}(i);b&&(a.fontStyle=b);var w=(i.fontFamily||"").toLowerCase();return-1!==t.indexOf(w)&&(a.font=w),a}},744:function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.DocHandler=void 0;var n={},o=function(){function t(t){this.jsPDFDocument=t,this.userStyles={textColor:t.getTextColor?this.jsPDFDocument.getTextColor():0,fontSize:t.internal.getFontSize(),fontStyle:t.internal.getFont().fontStyle,font:t.internal.getFont().fontName,lineWidth:t.getLineWidth?this.jsPDFDocument.getLineWidth():0,lineColor:t.getDrawColor?this.jsPDFDocument.getDrawColor():0}}return t.setDefaults=function(t,e){void 0===e&&(e=null),e?e.__autoTableDocumentDefaults=t:n=t},t.unifyColor=function(t){return Array.isArray(t)?t:"number"==typeof t?[t,t,t]:"string"==typeof t?[t]:null},t.prototype.applyStyles=function(e,n){var o,r,i;void 0===n&&(n=!1),e.fontStyle&&this.jsPDFDocument.setFontStyle&&this.jsPDFDocument.setFontStyle(e.fontStyle);var l=this.jsPDFDocument.internal.getFont(),a=l.fontStyle,s=l.fontName;if(e.font&&(s=e.font),e.fontStyle){a=e.fontStyle;var u=this.getFontList()[s];u&&-1===u.indexOf(a)&&(this.jsPDFDocument.setFontStyle&&this.jsPDFDocument.setFontStyle(u[0]),a=u[0])}if(this.jsPDFDocument.setFont(s,a),e.fontSize&&this.jsPDFDocument.setFontSize(e.fontSize),!n){var d=t.unifyColor(e.fillColor);d&&(o=this.jsPDFDocument).setFillColor.apply(o,d),(d=t.unifyColor(e.textColor))&&(r=this.jsPDFDocument).setTextColor.apply(r,d),(d=t.unifyColor(e.lineColor))&&(i=this.jsPDFDocument).setDrawColor.apply(i,d),"number"==typeof e.lineWidth&&this.jsPDFDocument.setLineWidth(e.lineWidth)}},t.prototype.splitTextToSize=function(t,e,n){return this.jsPDFDocument.splitTextToSize(t,e,n)},t.prototype.rect=function(t,e,n,o,r){return this.jsPDFDocument.rect(t,e,n,o,r)},t.prototype.getLastAutoTable=function(){return this.jsPDFDocument.lastAutoTable||null},t.prototype.getTextWidth=function(t){return this.jsPDFDocument.getTextWidth(t)},t.prototype.getDocument=function(){return this.jsPDFDocument},t.prototype.setPage=function(t){this.jsPDFDocument.setPage(t)},t.prototype.addPage=function(){return this.jsPDFDocument.addPage()},t.prototype.getFontList=function(){return this.jsPDFDocument.getFontList()},t.prototype.getGlobalOptions=function(){return n||{}},t.prototype.getDocumentOptions=function(){return this.jsPDFDocument.__autoTableDocumentDefaults||{}},t.prototype.pageSize=function(){var t=this.jsPDFDocument.internal.pageSize;return null==t.width&&(t={width:t.getWidth(),height:t.getHeight()}),t},t.prototype.scaleFactor=function(){return this.jsPDFDocument.internal.scaleFactor},t.prototype.getLineHeightFactor=function(){var t=this.jsPDFDocument;return t.getLineHeightFactor?t.getLineHeightFactor():1.15},t.prototype.getLineHeight=function(t){return t/this.scaleFactor()*this.getLineHeightFactor()},t.prototype.pageNumber=function(){var t=this.jsPDFDocument.internal.getCurrentPageInfo();return t?t.pageNumber:this.jsPDFDocument.internal.getNumberOfPages()},t}();e.DocHandler=o},4:function(t,e,n){Object.defineProperty(e,"__esModule",{value:!0}),e.parseHtml=void 0;var o=n(903),r=n(796);function i(t,e,n,i,a,s){for(var u=new r.HtmlRowInput(i),d=0;d<i.cells.length;d++){var h=i.cells[d],c=n.getComputedStyle(h);if(a||"none"!==c.display){var f=void 0;s&&(f=(0,o.parseCss)(t,h,e,c,n)),u.push({rowSpan:h.rowSpan,colSpan:h.colSpan,styles:f,_element:h,content:l(h)})}}var g=n.getComputedStyle(i);if(u.length>0&&(a||"none"!==g.display))return u}function l(t){var e=t.cloneNode(!0);return e.innerHTML=e.innerHTML.replace(/\n/g,"").replace(/ +/g," "),e.innerHTML=e.innerHTML.split(/<br.*?>/).map((function(t){return t.trim()})).join("\n"),e.innerText||e.textContent||""}e.parseHtml=function(t,e,n,o,r){var l,a,s;void 0===o&&(o=!1),void 0===r&&(r=!1),s="string"==typeof e?n.document.querySelector(e):e;var u=Object.keys(t.getFontList()),d=t.scaleFactor(),h=[],c=[],f=[];if(!s)return console.error("Html table could not be found with input: ",e),{head:h,body:c,foot:f};for(var g=0;g<s.rows.length;g++){var p=s.rows[g],y=null===(a=null===(l=null==p?void 0:p.parentElement)||void 0===l?void 0:l.tagName)||void 0===a?void 0:a.toLowerCase(),v=i(u,d,n,p,o,r);v&&("thead"===y?h.push(v):"tfoot"===y?f.push(v):c.push(v))}return{head:h,body:c,foot:f}}},776:function(t,e,n){Object.defineProperty(e,"__esModule",{value:!0}),e.parseInput=void 0;var o=n(4),r=n(356),i=n(420),l=n(744),a=n(792);e.parseInput=function(t,e){var n=new l.DocHandler(t),s=n.getDocumentOptions(),u=n.getGlobalOptions();(0,a.default)(n,u,s,e);var d,h=(0,r.assign)({},u,s,e);"undefined"!=typeof window&&(d=window);var c=function(t,e,n){for(var o={styles:{},headStyles:{},bodyStyles:{},footStyles:{},alternateRowStyles:{},columnStyles:{}},i=function(i){if("columnStyles"===i){var l=t[i],a=e[i],s=n[i];o.columnStyles=(0,r.assign)({},l,a,s)}else{var u=[t,e,n].map((function(t){return t[i]||{}}));o[i]=(0,r.assign)({},u[0],u[1],u[2])}},l=0,a=Object.keys(o);l<a.length;l++){i(a[l])}return o}(u,s,e),f=function(t,e,n){for(var o={didParseCell:[],willDrawCell:[],didDrawCell:[],willDrawPage:[],didDrawPage:[]},r=0,i=[t,e,n];r<i.length;r++){var l=i[r];l.didParseCell&&o.didParseCell.push(l.didParseCell),l.willDrawCell&&o.willDrawCell.push(l.willDrawCell),l.didDrawCell&&o.didDrawCell.push(l.didDrawCell),l.willDrawPage&&o.willDrawPage.push(l.willDrawPage),l.didDrawPage&&o.didDrawPage.push(l.didDrawPage)}return o}(u,s,e),g=function(t,e){var n,o,r,l,a,s,u,d,h,c,f,g,p,y,v=(0,i.parseSpacing)(e.margin,40/t.scaleFactor()),m=null!==(n=function(t,e){var n=t.getLastAutoTable(),o=t.scaleFactor(),r=t.pageNumber(),i=!1;if(n&&n.startPageNumber){i=n.startPageNumber+n.pageNumber-1===r}if("number"==typeof e)return e;if((null==e||!1===e)&&i&&null!=(null==n?void 0:n.finalY))return n.finalY+20/o;return null}(t,e.startY))&&void 0!==n?n:v.top;p=!0===e.showFoot?"everyPage":!1===e.showFoot?"never":null!==(o=e.showFoot)&&void 0!==o?o:"everyPage";y=!0===e.showHead?"everyPage":!1===e.showHead?"never":null!==(r=e.showHead)&&void 0!==r?r:"everyPage";var b=null!==(l=e.useCss)&&void 0!==l&&l,w=e.theme||(b?"plain":"striped"),P=!!e.horizontalPageBreak,S=null!==(a=e.horizontalPageBreakRepeat)&&void 0!==a?a:null;return{includeHiddenHtml:null!==(s=e.includeHiddenHtml)&&void 0!==s&&s,useCss:b,theme:w,startY:m,margin:v,pageBreak:null!==(u=e.pageBreak)&&void 0!==u?u:"auto",rowPageBreak:null!==(d=e.rowPageBreak)&&void 0!==d?d:"auto",tableWidth:null!==(h=e.tableWidth)&&void 0!==h?h:"auto",showHead:y,showFoot:p,tableLineWidth:null!==(c=e.tableLineWidth)&&void 0!==c?c:0,tableLineColor:null!==(f=e.tableLineColor)&&void 0!==f?f:200,horizontalPageBreak:P,horizontalPageBreakRepeat:S,horizontalPageBreakBehaviour:null!==(g=e.horizontalPageBreakBehaviour)&&void 0!==g?g:"afterAllRows"}}(n,h),p=function(t,e,n){var r=e.head||[],i=e.body||[],l=e.foot||[];if(e.html){var a=e.includeHiddenHtml;if(n){var s=(0,o.parseHtml)(t,e.html,n,a,e.useCss)||{};r=s.head||r,i=s.body||r,l=s.foot||r}else console.error("Cannot parse html in non browser environment")}var u=e.columns||function(t,e,n){var o=t[0]||e[0]||n[0]||[],r=[];return Object.keys(o).filter((function(t){return"_element"!==t})).forEach((function(t){var e,n=1;"object"!=typeof(e=Array.isArray(o)?o[parseInt(t)]:o[t])||Array.isArray(e)||(n=(null==e?void 0:e.colSpan)||1);for(var i=0;i<n;i++){var l={dataKey:Array.isArray(o)?r.length:t+(i>0?"_".concat(i):"")};r.push(l)}})),r}(r,i,l);return{columns:u,head:r,body:i,foot:l}}(n,h,d);return{id:e.tableId,content:p,hooks:f,styles:c,settings:g}}},792:function(t,e){function n(t){t.rowHeight?(console.error("Use of deprecated style rowHeight. It is renamed to minCellHeight."),t.minCellHeight||(t.minCellHeight=t.rowHeight)):t.columnWidth&&(console.error("Use of deprecated style columnWidth. It is renamed to cellWidth."),t.cellWidth||(t.cellWidth=t.columnWidth))}Object.defineProperty(e,"__esModule",{value:!0}),e.default=function(t,e,o,r){for(var i=function(e){e&&"object"!=typeof e&&console.error("The options parameter should be of type object, is: "+typeof e),void 0!==e.extendWidth&&(e.tableWidth=e.extendWidth?"auto":"wrap",console.error("Use of deprecated option: extendWidth, use tableWidth instead.")),void 0!==e.margins&&(void 0===e.margin&&(e.margin=e.margins),console.error("Use of deprecated option: margins, use margin instead.")),e.startY&&"number"!=typeof e.startY&&(console.error("Invalid value for startY option",e.startY),delete e.startY),!e.didDrawPage&&(e.afterPageContent||e.beforePageContent||e.afterPageAdd)&&(console.error("The afterPageContent, beforePageContent and afterPageAdd hooks are deprecated. Use didDrawPage instead"),e.didDrawPage=function(n){t.applyStyles(t.userStyles),e.beforePageContent&&e.beforePageContent(n),t.applyStyles(t.userStyles),e.afterPageContent&&e.afterPageContent(n),t.applyStyles(t.userStyles),e.afterPageAdd&&n.pageNumber>1&&n.afterPageAdd(n),t.applyStyles(t.userStyles)}),["createdHeaderCell","drawHeaderRow","drawRow","drawHeaderCell"].forEach((function(t){e[t]&&console.error('The "'.concat(t,'" hook has changed in version 3.0, check the changelog for how to migrate.'))})),[["showFoot","showFooter"],["showHead","showHeader"],["didDrawPage","addPageContent"],["didParseCell","createdCell"],["headStyles","headerStyles"]].forEach((function(t){var n=t[0],o=t[1];e[o]&&(console.error("Use of deprecated option ".concat(o,". Use ").concat(n," instead")),e[n]=e[o])})),[["padding","cellPadding"],["lineHeight","rowHeight"],"fontSize","overflow"].forEach((function(t){var n="string"==typeof t?t:t[0],o="string"==typeof t?t:t[1];void 0!==e[n]&&(void 0===e.styles[o]&&(e.styles[o]=e[n]),console.error("Use of deprecated option: "+n+", use the style "+o+" instead."))}));for(var o=0,r=["styles","bodyStyles","headStyles","footStyles"];o<r.length;o++){n(e[r[o]]||{})}for(var i=e.columnStyles||{},l=0,a=Object.keys(i);l<a.length;l++){n(i[a[l]]||{})}},l=0,a=[e,o,r];l<a.length;l++){i(a[l])}}},260:function(t,e,n){Object.defineProperty(e,"__esModule",{value:!0}),e.Column=e.Cell=e.Row=e.Table=void 0;var o=n(796),r=n(172),i=n(420),l=function(){function t(t,e){this.pageNumber=1,this.pageCount=1,this.id=t.id,this.settings=t.settings,this.styles=t.styles,this.hooks=t.hooks,this.columns=e.columns,this.head=e.head,this.body=e.body,this.foot=e.foot}return t.prototype.getHeadHeight=function(t){return this.head.reduce((function(e,n){return e+n.getMaxCellHeight(t)}),0)},t.prototype.getFootHeight=function(t){return this.foot.reduce((function(e,n){return e+n.getMaxCellHeight(t)}),0)},t.prototype.allRows=function(){return this.head.concat(this.body).concat(this.foot)},t.prototype.callCellHooks=function(t,e,n,o,i,l){for(var a=0,s=e;a<s.length;a++){var u=!1===(0,s[a])(new r.CellHookData(t,this,n,o,i,l));if(n.text=Array.isArray(n.text)?n.text:[n.text],u)return!1}return!0},t.prototype.callEndPageHooks=function(t,e){t.applyStyles(t.userStyles);for(var n=0,o=this.hooks.didDrawPage;n<o.length;n++){(0,o[n])(new r.HookData(t,this,e))}},t.prototype.callWillDrawPageHooks=function(t,e){for(var n=0,o=this.hooks.willDrawPage;n<o.length;n++){(0,o[n])(new r.HookData(t,this,e))}},t.prototype.getWidth=function(t){if("number"==typeof this.settings.tableWidth)return this.settings.tableWidth;if("wrap"===this.settings.tableWidth)return this.columns.reduce((function(t,e){return t+e.wrappedWidth}),0);var e=this.settings.margin;return t-e.left-e.right},t}();e.Table=l;var a=function(){function t(t,e,n,r,i){void 0===i&&(i=!1),this.height=0,this.raw=t,t instanceof o.HtmlRowInput&&(this.raw=t._element,this.element=t._element),this.index=e,this.section=n,this.cells=r,this.spansMultiplePages=i}return t.prototype.getMaxCellHeight=function(t){var e=this;return t.reduce((function(t,n){var o;return Math.max(t,(null===(o=e.cells[n.index])||void 0===o?void 0:o.height)||0)}),0)},t.prototype.hasRowSpan=function(t){var e=this;return t.filter((function(t){var n=e.cells[t.index];return!!n&&n.rowSpan>1})).length>0},t.prototype.canEntireRowFit=function(t,e){return this.getMaxCellHeight(e)<=t},t.prototype.getMinimumRowHeight=function(t,e){var n=this;return t.reduce((function(t,o){var r=n.cells[o.index];if(!r)return 0;var i=e.getLineHeight(r.styles.fontSize),l=r.padding("vertical")+i;return l>t?l:t}),0)},t}();e.Row=a;var s=function(){function t(t,e,n){var o,r;this.contentHeight=0,this.contentWidth=0,this.wrappedWidth=0,this.minReadableWidth=0,this.minWidth=0,this.width=0,this.height=0,this.x=0,this.y=0,this.styles=e,this.section=n,this.raw=t;var i=t;null==t||"object"!=typeof t||Array.isArray(t)?(this.rowSpan=1,this.colSpan=1):(this.rowSpan=t.rowSpan||1,this.colSpan=t.colSpan||1,i=null!==(r=null!==(o=t.content)&&void 0!==o?o:t.title)&&void 0!==r?r:t,t._element&&(this.raw=t._element));var l=null!=i?""+i:"";this.text=l.split(/\r\n|\r|\n/g)}return t.prototype.getTextPos=function(){var t,e;if("top"===this.styles.valign)t=this.y+this.padding("top");else if("bottom"===this.styles.valign)t=this.y+this.height-this.padding("bottom");else{var n=this.height-this.padding("vertical");t=this.y+n/2+this.padding("top")}if("right"===this.styles.halign)e=this.x+this.width-this.padding("right");else if("center"===this.styles.halign){var o=this.width-this.padding("horizontal");e=this.x+o/2+this.padding("left")}else e=this.x+this.padding("left");return{x:e,y:t}},t.prototype.getContentHeight=function(t,e){void 0===e&&(e=1.15);var n=(Array.isArray(this.text)?this.text.length:1)*(this.styles.fontSize/t*e)+this.padding("vertical");return Math.max(n,this.styles.minCellHeight)},t.prototype.padding=function(t){var e=(0,i.parseSpacing)(this.styles.cellPadding,0);return"vertical"===t?e.top+e.bottom:"horizontal"===t?e.left+e.right:e[t]},t}();e.Cell=s;var u=function(){function t(t,e,n){this.wrappedWidth=0,this.minReadableWidth=0,this.minWidth=0,this.width=0,this.dataKey=t,this.raw=e,this.index=n}return t.prototype.getMaxCustomCellWidth=function(t){for(var e=0,n=0,o=t.allRows();n<o.length;n++){var r=o[n].cells[this.index];r&&"number"==typeof r.styles.cellWidth&&(e=Math.max(e,r.styles.cellWidth))}return e},t}();e.Column=u},356:function(t,e){Object.defineProperty(e,"__esModule",{value:!0}),e.assign=void 0,e.assign=function(t,e,n,o,r){if(null==t)throw new TypeError("Cannot convert undefined or null to object");for(var i=Object(t),l=1;l<arguments.length;l++){var a=arguments[l];if(null!=a)for(var s in a)Object.prototype.hasOwnProperty.call(a,s)&&(i[s]=a[s])}return i}},972:function(t,e,n){Object.defineProperty(e,"__esModule",{value:!0}),e.createTable=void 0;var o=n(744),r=n(260),i=n(324),l=n(796),a=n(356);function s(t,e,n,o,i,l){var a={};return e.map((function(e,s){for(var u=0,h={},c=0,f=0,g=0,p=n;g<p.length;g++){var y=p[g];if(null==a[y.index]||0===a[y.index].left)if(0===f){var v=void 0,m={};"object"!=typeof(v=Array.isArray(e)?e[y.index-c-u]:e[y.dataKey])||Array.isArray(v)||(m=(null==v?void 0:v.styles)||{});var b=d(t,y,s,i,o,l,m),w=new r.Cell(v,b,t);h[y.dataKey]=w,h[y.index]=w,f=w.colSpan-1,a[y.index]={left:w.rowSpan-1,times:f}}else f--,c++;else a[y.index].left--,f=a[y.index].times,u++}return new r.Row(e,s,t,h)}))}function u(t,e){var n={};return t.forEach((function(t){if(null!=t.raw){var o=function(t,e){if("head"===t){if("object"==typeof e)return e.header||e.title||null;if("string"==typeof e||"number"==typeof e)return e}else if("foot"===t&&"object"==typeof e)return e.footer;return null}(e,t.raw);null!=o&&(n[t.dataKey]=o)}})),Object.keys(n).length>0?n:null}function d(t,e,n,o,r,i,s){var u,d=(0,l.getTheme)(o);"head"===t?u=r.headStyles:"body"===t?u=r.bodyStyles:"foot"===t&&(u=r.footStyles);var h=(0,a.assign)({},d.table,d[t],r.styles,u),c=r.columnStyles[e.dataKey]||r.columnStyles[e.index]||{},f="body"===t?c:{},g="body"===t&&n%2==0?(0,a.assign)({},d.alternateRow,r.alternateRowStyles):{},p=(0,l.defaultStyles)(i),y=(0,a.assign)({},p,h,g,f);return(0,a.assign)(y,s)}e.createTable=function(t,e){var n=new o.DocHandler(t),l=function(t,e){var n=t.content,o=function(t){return t.map((function(t,e){var n,o,i;return i="object"==typeof t&&null!==(o=null!==(n=t.dataKey)&&void 0!==n?n:t.key)&&void 0!==o?o:e,new r.Column(i,t,e)}))}(n.columns);if(0===n.head.length){(i=u(o,"head"))&&n.head.push(i)}if(0===n.foot.length){var i;(i=u(o,"foot"))&&n.foot.push(i)}var l=t.settings.theme,a=t.styles;return{columns:o,head:s("head",n.head,o,a,l,e),body:s("body",n.body,o,a,l,e),foot:s("foot",n.foot,o,a,l,e)}}(e,n.scaleFactor()),a=new r.Table(e,l);return(0,i.calculateWidths)(n,a),n.applyStyles(n.userStyles),a}},664:function(t,e,n){Object.defineProperty(e,"__esModule",{value:!0}),e.addPage=e.drawTable=void 0;var o=n(420),r=n(260),i=n(744),l=n(356),a=n(136),s=n(224);function u(t,e,n,o){var r=e.settings;t.applyStyles(t.userStyles),"firstPage"!==r.showHead&&"everyPage"!==r.showHead||e.head.forEach((function(r){return g(t,e,r,n,o)}))}function d(t,e,n,o,r,i){t.applyStyles(t.userStyles),i=null!=i?i:e.body.length;var l=Math.min(n+i,e.body.length),a=-1;return e.body.slice(n,l).forEach((function(i,l){var s=n+l===e.body.length-1,u=y(t,e,s,o);i.canEntireRowFit(u,r)&&(g(t,e,i,o,r),a=n+l)})),a}function h(t,e,n,o){var r=e.settings;t.applyStyles(t.userStyles),"lastPage"!==r.showFoot&&"everyPage"!==r.showFoot||e.foot.forEach((function(r){return g(t,e,r,n,o)}))}function c(t,e,n){var o=n.getLineHeight(t.styles.fontSize),r=t.padding("vertical"),i=Math.floor((e-r)/o);return Math.max(0,i)}function f(t,e,n,o,i,a,s){var u=y(t,e,o,a);if(n.canEntireRowFit(u,s))g(t,e,n,a,s);else if(function(t,e,n,o){var r=t.pageSize().height,i=o.settings.margin,l=r-(i.top+i.bottom);"body"===e.section&&(l-=o.getHeadHeight(o.columns)+o.getFootHeight(o.columns));var a=e.getMinimumRowHeight(o.columns,t),s=a<n;if(a>l)return console.error("Will not be able to print row ".concat(e.index," correctly since it's minimum height is larger than page height")),!0;if(!s)return!1;var u=e.hasRowSpan(o.columns);return e.getMaxCellHeight(o.columns)>l?(u&&console.error("The content of row ".concat(e.index," will not be drawn correctly since drawing rows with a height larger than the page height and has cells with rowspans is not supported.")),!0):!u&&"avoid"!==o.settings.rowPageBreak}(t,n,u,e)){var d=function(t,e,n,o){var i={};t.spansMultiplePages=!0,t.height=0;for(var a=0,s=0,u=n.columns;s<u.length;s++){var d=u[s];if(b=t.cells[d.index]){Array.isArray(b.text)||(b.text=[b.text]);var h=new r.Cell(b.raw,b.styles,b.section);(h=(0,l.assign)(h,b)).text=[];var f=c(b,e,o);b.text.length>f&&(h.text=b.text.splice(f,b.text.length));var g=o.scaleFactor(),p=o.getLineHeightFactor();b.contentHeight=b.getContentHeight(g,p),b.contentHeight>=e&&(b.contentHeight=e,h.styles.minCellHeight-=e),b.contentHeight>t.height&&(t.height=b.contentHeight),h.contentHeight=h.getContentHeight(g,p),h.contentHeight>a&&(a=h.contentHeight),i[d.index]=h}}var y=new r.Row(t.raw,-1,t.section,i,!0);y.height=a;for(var v=0,m=n.columns;v<m.length;v++){var b;d=m[v],(h=y.cells[d.index])&&(h.height=y.height),(b=t.cells[d.index])&&(b.height=t.height)}return y}(n,u,e,t);g(t,e,n,a,s),v(t,e,i,a,s),f(t,e,d,o,i,a,s)}else v(t,e,i,a,s),f(t,e,n,o,i,a,s)}function g(t,e,n,o,r){o.x=e.settings.margin.left;for(var i=0,l=r;i<l.length;i++){var s=l[i],u=n.cells[s.index];if(u)if(t.applyStyles(u.styles),u.x=o.x,u.y=o.y,!1!==e.callCellHooks(t,e.hooks.willDrawCell,u,n,s,o)){p(t,u,o);var d=u.getTextPos();(0,a.default)(u.text,d.x,d.y,{halign:u.styles.halign,valign:u.styles.valign,maxWidth:Math.ceil(u.width-u.padding("left")-u.padding("right"))},t.getDocument()),e.callCellHooks(t,e.hooks.didDrawCell,u,n,s,o),o.x+=s.width}else o.x+=s.width;else o.x+=s.width}o.y+=n.height}function p(t,e,n){var r=e.styles;if(t.getDocument().setFillColor(t.getDocument().getFillColor()),"number"==typeof r.lineWidth){var i=(0,o.getFillStyle)(r.lineWidth,r.fillColor);i&&t.rect(e.x,n.y,e.width,e.height,i)}else"object"==typeof r.lineWidth&&(r.fillColor&&t.rect(e.x,n.y,e.width,e.height,"F"),function(t,e,n,o){var r,i,l,a;o.top&&(r=n.x,i=n.y,l=n.x+e.width,a=n.y,o.right&&(l+=.5*o.right),o.left&&(r-=.5*o.left),s(o.top,r,i,l,a));o.bottom&&(r=n.x,i=n.y+e.height,l=n.x+e.width,a=n.y+e.height,o.right&&(l+=.5*o.right),o.left&&(r-=.5*o.left),s(o.bottom,r,i,l,a));o.left&&(r=n.x,i=n.y,l=n.x,a=n.y+e.height,o.top&&(i-=.5*o.top),o.bottom&&(a+=.5*o.bottom),s(o.left,r,i,l,a));o.right&&(r=n.x+e.width,i=n.y,l=n.x+e.width,a=n.y+e.height,o.top&&(i-=.5*o.top),o.bottom&&(a+=.5*o.bottom),s(o.right,r,i,l,a));function s(e,n,o,r,i){t.getDocument().setLineWidth(e),t.getDocument().line(n,o,r,i,"S")}}(t,e,n,r.lineWidth))}function y(t,e,n,o){var r=e.settings.margin.bottom,i=e.settings.showFoot;return("everyPage"===i||"lastPage"===i&&n)&&(r+=e.getFootHeight(e.columns)),t.pageSize().height-o.y-r}function v(t,e,n,r,i,l){void 0===i&&(i=[]),void 0===l&&(l=!1),t.applyStyles(t.userStyles),"everyPage"!==e.settings.showFoot||l||e.foot.forEach((function(n){return g(t,e,n,r,i)})),e.callEndPageHooks(t,r);var a=e.settings.margin;(0,o.addTableBorder)(t,e,n,r),m(t),e.pageNumber++,e.pageCount++,r.x=a.left,r.y=a.top,n.y=a.top,e.callWillDrawPageHooks(t,r),"everyPage"===e.settings.showHead&&(e.head.forEach((function(n){return g(t,e,n,r,i)})),t.applyStyles(t.userStyles))}function m(t){var e=t.pageNumber();return t.setPage(e+1),t.pageNumber()===e&&(t.addPage(),!0)}e.drawTable=function(t,e){var n=e.settings,r=n.startY,a=n.margin,c={x:a.left,y:r},p=e.getHeadHeight(e.columns)+e.getFootHeight(e.columns),y=r+a.bottom+p;"avoid"===n.pageBreak&&(y+=e.body.reduce((function(t,e){return t+e.height}),0));var b=new i.DocHandler(t);("always"===n.pageBreak||null!=n.startY&&y>b.pageSize().height)&&(m(b),c.y=a.top),e.callWillDrawPageHooks(b,c);var w=(0,l.assign)({},c);e.startPageNumber=b.pageNumber(),n.horizontalPageBreak?function(t,e,n,o){var r=(0,s.calculateAllColumnsCanFitInPage)(t,e),i=e.settings;if("afterAllRows"===i.horizontalPageBreakBehaviour)r.forEach((function(r,i){t.applyStyles(t.userStyles),i>0?v(t,e,n,o,r.columns,!0):u(t,e,o,r.columns),function(t,e,n,o,r){t.applyStyles(t.userStyles),e.body.forEach((function(i,l){var a=l===e.body.length-1;f(t,e,i,a,n,o,r)}))}(t,e,n,o,r.columns),h(t,e,o,r.columns)}));else for(var l=-1,a=r[0],c=function(){var i=l;if(a){t.applyStyles(t.userStyles);var s=a.columns;l>=0?v(t,e,n,o,s,!0):u(t,e,o,s),i=d(t,e,l+1,o,s),h(t,e,o,s)}var c=i-l;r.slice(1).forEach((function(r){t.applyStyles(t.userStyles),v(t,e,n,o,r.columns,!0),d(t,e,l+1,o,r.columns,c),h(t,e,o,r.columns)})),l=i};l<e.body.length-1;)c()}(b,e,w,c):(b.applyStyles(b.userStyles),"firstPage"!==n.showHead&&"everyPage"!==n.showHead||e.head.forEach((function(t){return g(b,e,t,c,e.columns)})),b.applyStyles(b.userStyles),e.body.forEach((function(t,n){var o=n===e.body.length-1;f(b,e,t,o,w,c,e.columns)})),b.applyStyles(b.userStyles),"lastPage"!==n.showFoot&&"everyPage"!==n.showFoot||e.foot.forEach((function(t){return g(b,e,t,c,e.columns)}))),(0,o.addTableBorder)(b,e,w,c),e.callEndPageHooks(b,c),e.finalY=c.y,t.lastAutoTable=e,t.previousAutoTable=e,t.autoTable&&(t.autoTable.previous=e),b.applyStyles(b.userStyles)},e.addPage=v},224:function(t,e,n){Object.defineProperty(e,"__esModule",{value:!0}),e.calculateAllColumnsCanFitInPage=void 0;var o=n(420);function r(t,e,n){var r;void 0===n&&(n={});var i=(0,o.getPageAvailableWidth)(t,e),l=new Map,a=[],s=[],u=[];e.settings.horizontalPageBreakRepeat,Array.isArray(e.settings.horizontalPageBreakRepeat)?u=e.settings.horizontalPageBreakRepeat:"string"!=typeof e.settings.horizontalPageBreakRepeat&&"number"!=typeof e.settings.horizontalPageBreakRepeat||(u=[e.settings.horizontalPageBreakRepeat]),u.forEach((function(t){var n=e.columns.find((function(e){return e.dataKey===t||e.index===t}));n&&!l.has(n.index)&&(l.set(n.index,!0),a.push(n.index),s.push(e.columns[n.index]),i-=n.wrappedWidth)}));for(var d=!0,h=null!==(r=null==n?void 0:n.start)&&void 0!==r?r:0;h<e.columns.length;)if(l.has(h))h++;else{var c=e.columns[h].wrappedWidth;if(!(d||i>=c))break;d=!1,a.push(h),s.push(e.columns[h]),i-=c,h++}return{colIndexes:a,columns:s,lastIndex:h-1}}e.calculateAllColumnsCanFitInPage=function(t,e){for(var n=[],o=0;o<e.columns.length;o++){var i=r(t,e,{start:o});i.columns.length&&(n.push(i),o=i.lastIndex)}return n}},324:function(t,e,n){Object.defineProperty(e,"__esModule",{value:!0}),e.ellipsize=e.resizeColumns=e.calculateWidths=void 0;var o=n(420);function r(t,e,n){for(var o=e,i=t.reduce((function(t,e){return t+e.wrappedWidth}),0),l=0;l<t.length;l++){var a=t[l],s=o*(a.wrappedWidth/i),u=a.width+s,d=n(a),h=u<d?d:u;e-=h-a.width,a.width=h}if(e=Math.round(1e10*e)/1e10){var c=t.filter((function(t){return!(e<0)||t.width>n(t)}));c.length&&(e=r(c,e,n))}return e}function i(t,e,n,r,i){return t.map((function(t){return function(t,e,n,r,i){var l=1e4*r.scaleFactor();if(e=Math.ceil(e*l)/l,e>=(0,o.getStringWidth)(t,n,r))return t;for(;e<(0,o.getStringWidth)(t+i,n,r)&&!(t.length<=1);)t=t.substring(0,t.length-1);return t.trim()+i}(t,e,n,r,i)}))}e.calculateWidths=function(t,e){!function(t,e){var n=t.scaleFactor(),r=e.settings.horizontalPageBreak,i=(0,o.getPageAvailableWidth)(t,e);e.allRows().forEach((function(l){for(var a=0,s=e.columns;a<s.length;a++){var u=s[a],d=l.cells[u.index];if(d){var h=e.hooks.didParseCell;e.callCellHooks(t,h,d,l,u,null);var c=d.padding("horizontal");d.contentWidth=(0,o.getStringWidth)(d.text,d.styles,t)+c;var f=(0,o.getStringWidth)(d.text.join(" ").split(/[^\S\u00A0]+/),d.styles,t);if(d.minReadableWidth=f+d.padding("horizontal"),"number"==typeof d.styles.cellWidth)d.minWidth=d.styles.cellWidth,d.wrappedWidth=d.styles.cellWidth;else if("wrap"===d.styles.cellWidth||!0===r)d.contentWidth>i?(d.minWidth=i,d.wrappedWidth=i):(d.minWidth=d.contentWidth,d.wrappedWidth=d.contentWidth);else{var g=10/n;d.minWidth=d.styles.minCellWidth||g,d.wrappedWidth=d.contentWidth,d.minWidth>d.wrappedWidth&&(d.wrappedWidth=d.minWidth)}}}})),e.allRows().forEach((function(t){for(var n=0,o=e.columns;n<o.length;n++){var r=o[n],i=t.cells[r.index];if(i&&1===i.colSpan)r.wrappedWidth=Math.max(r.wrappedWidth,i.wrappedWidth),r.minWidth=Math.max(r.minWidth,i.minWidth),r.minReadableWidth=Math.max(r.minReadableWidth,i.minReadableWidth);else{var l=e.styles.columnStyles[r.dataKey]||e.styles.columnStyles[r.index]||{},a=l.cellWidth||l.minCellWidth;a&&"number"==typeof a&&(r.minWidth=a,r.wrappedWidth=a)}i&&(i.colSpan>1&&!r.minWidth&&(r.minWidth=i.minWidth),i.colSpan>1&&!r.wrappedWidth&&(r.wrappedWidth=i.minWidth))}}))}(t,e);var n=[],l=0;e.columns.forEach((function(t){var o=t.getMaxCustomCellWidth(e);o?t.width=o:(t.width=t.wrappedWidth,n.push(t)),l+=t.width}));var a=e.getWidth(t.pageSize().width)-l;a&&(a=r(n,a,(function(t){return Math.max(t.minReadableWidth,t.minWidth)}))),a&&(a=r(n,a,(function(t){return t.minWidth}))),a=Math.abs(a),!e.settings.horizontalPageBreak&&a>.1/t.scaleFactor()&&(a=a<1?a:Math.round(a),console.warn("Of the table content, ".concat(a," units width could not fit page"))),function(t){for(var e=t.allRows(),n=0;n<e.length;n++)for(var o=e[n],r=null,i=0,l=0,a=0;a<t.columns.length;a++){var s=t.columns[a];if((l-=1)>1&&t.columns[a+1])i+=s.width,delete o.cells[s.index];else if(r){var u=r;delete o.cells[s.index],r=null,u.width=s.width+i}else{if(!(u=o.cells[s.index]))continue;if(l=u.colSpan,i=0,u.colSpan>1){r=u,i+=s.width;continue}u.width=s.width+i}}}(e),function(t,e){for(var n={count:0,height:0},o=0,r=t.allRows();o<r.length;o++){for(var l=r[o],a=0,s=t.columns;a<s.length;a++){var u=s[a],d=l.cells[u.index];if(d){e.applyStyles(d.styles,!0);var h=d.width-d.padding("horizontal");if("linebreak"===d.styles.overflow)d.text=e.splitTextToSize(d.text,h+1/e.scaleFactor(),{fontSize:d.styles.fontSize});else if("ellipsize"===d.styles.overflow)d.text=i(d.text,h,d.styles,e,"...");else if("hidden"===d.styles.overflow)d.text=i(d.text,h,d.styles,e,"");else if("function"==typeof d.styles.overflow){var c=d.styles.overflow(d.text,h);d.text="string"==typeof c?[c]:c}d.contentHeight=d.getContentHeight(e.scaleFactor(),e.getLineHeightFactor());var f=d.contentHeight/d.rowSpan;d.rowSpan>1&&n.count*n.height<f*d.rowSpan?n={height:f,count:d.rowSpan}:n&&n.count>0&&n.height>f&&(f=n.height),f>l.height&&(l.height=f)}}n.count--}}(e,t),function(t){for(var e={},n=1,o=t.allRows(),r=0;r<o.length;r++)for(var i=o[r],l=0,a=t.columns;l<a.length;l++){var s=a[l],u=e[s.index];if(n>1)n--,delete i.cells[s.index];else if(u)u.cell.height+=i.height,n=u.cell.colSpan,delete i.cells[s.index],u.left--,u.left<=1&&delete e[s.index];else{var d=i.cells[s.index];if(!d)continue;if(d.height=i.height,d.rowSpan>1){var h=o.length-r,c=d.rowSpan>h?h:d.rowSpan;e[s.index]={cell:d,left:c,row:i}}}}}(e)},e.resizeColumns=r,e.ellipsize=i},964:function(e){if(void 0===t){var n=new Error("Cannot find module 'undefined'");throw n.code="MODULE_NOT_FOUND",n}e.exports=t}},n={};function o(t){var r=n[t];if(void 0!==r)return r.exports;var i=n[t]={exports:{}};return e[t].call(i.exports,i,i.exports,o),i.exports}var r={};return function(){var t=r;Object.defineProperty(t,"__esModule",{value:!0}),t.Cell=t.Column=t.Row=t.Table=t.CellHookData=t.__drawTable=t.__createTable=t.applyPlugin=void 0;var e=o(340),n=o(776),i=o(664),l=o(972),a=o(260);Object.defineProperty(t,"Table",{enumerable:!0,get:function(){return a.Table}});var s=o(172);Object.defineProperty(t,"CellHookData",{enumerable:!0,get:function(){return s.CellHookData}});var u=o(260);function d(t){(0,e.default)(t)}Object.defineProperty(t,"Cell",{enumerable:!0,get:function(){return u.Cell}}),Object.defineProperty(t,"Column",{enumerable:!0,get:function(){return u.Column}}),Object.defineProperty(t,"Row",{enumerable:!0,get:function(){return u.Row}}),t.applyPlugin=d,t.__createTable=function(t,e){var o=(0,n.parseInput)(t,e);return(0,l.createTable)(t,o)},t.__drawTable=function(t,e){(0,i.drawTable)(t,e)};try{var h=o(964);h.jsPDF&&(h=h.jsPDF),d(h)}catch(t){}t.default=function(t,e){var o=(0,n.parseInput)(t,e),r=(0,l.createTable)(t,o);(0,i.drawTable)(t,r)}}(),r}()}));
/*! flipclock 2014-10-21 */
var Base=function(){};Base.extend=function(a,b){"use strict";var c=Base.prototype.extend;Base._prototyping=!0;var d=new this;c.call(d,a),d.base=function(){},delete Base._prototyping;var e=d.constructor,f=d.constructor=function(){if(!Base._prototyping)if(this._constructing||this.constructor==f)this._constructing=!0,e.apply(this,arguments),delete this._constructing;else if(null!==arguments[0])return(arguments[0].extend||c).call(arguments[0],d)};return f.ancestor=this,f.extend=this.extend,f.forEach=this.forEach,f.implement=this.implement,f.prototype=d,f.toString=this.toString,f.valueOf=function(a){return"object"==a?f:e.valueOf()},c.call(f,b),"function"==typeof f.init&&f.init(),f},Base.prototype={extend:function(a,b){if(arguments.length>1){var c=this[a];if(c&&"function"==typeof b&&(!c.valueOf||c.valueOf()!=b.valueOf())&&/\bbase\b/.test(b)){var d=b.valueOf();b=function(){var a=this.base||Base.prototype.base;this.base=c;var b=d.apply(this,arguments);return this.base=a,b},b.valueOf=function(a){return"object"==a?b:d},b.toString=Base.toString}this[a]=b}else if(a){var e=Base.prototype.extend;Base._prototyping||"function"==typeof this||(e=this.extend||e);for(var f={toSource:null},g=["constructor","toString","valueOf"],h=Base._prototyping?0:1;i=g[h++];)a[i]!=f[i]&&e.call(this,i,a[i]);for(var i in a)f[i]||e.call(this,i,a[i])}return this}},Base=Base.extend({constructor:function(){this.extend(arguments[0])}},{ancestor:Object,version:"1.1",forEach:function(a,b,c){for(var d in a)void 0===this.prototype[d]&&b.call(c,a[d],d,a)},implement:function(){for(var a=0;a<arguments.length;a++)"function"==typeof arguments[a]?arguments[a](this.prototype):this.prototype.extend(arguments[a]);return this},toString:function(){return String(this.valueOf())}});var FlipClock;!function(a){"use strict";FlipClock=function(a,b,c){return b instanceof Object&&b instanceof Date==!1&&(c=b,b=0),new FlipClock.Factory(a,b,c)},FlipClock.Lang={},FlipClock.Base=Base.extend({buildDate:"2014-10-06",version:"0.7.5",constructor:function(b,c){"object"!=typeof b&&(b={}),"object"!=typeof c&&(c={}),this.setOptions(a.extend(!0,{},b,c))},callback:function(a){if("function"==typeof a){for(var b=[],c=1;c<=arguments.length;c++)arguments[c]&&b.push(arguments[c]);a.apply(this,b)}},log:function(a){window.console&&console.log&&console.log(a)},getOption:function(a){return this[a]?this[a]:!1},getOptions:function(){return this},setOption:function(a,b){this[a]=b},setOptions:function(a){for(var b in a)"undefined"!=typeof a[b]&&this.setOption(b,a[b])}})}(jQuery),function(a){"use strict";FlipClock.Face=FlipClock.Base.extend({autoStart:!0,dividers:[],factory:!1,lists:[],constructor:function(a,b){this.dividers=[],this.lists=[],this.base(b),this.factory=a},build:function(){this.autoStart&&this.start()},createDivider:function(b,c,d){"boolean"!=typeof c&&c||(d=c,c=b);var e=['<span class="'+this.factory.classes.dot+' top"></span>','<span class="'+this.factory.classes.dot+' bottom"></span>'].join("");d&&(e=""),b=this.factory.localize(b);var f=['<span class="'+this.factory.classes.divider+" "+(c?c:"").toLowerCase()+'">','<span class="'+this.factory.classes.label+'">'+(b?b:"")+"</span>",e,"</span>"],g=a(f.join(""));return this.dividers.push(g),g},createList:function(a,b){"object"==typeof a&&(b=a,a=0);var c=new FlipClock.List(this.factory,a,b);return this.lists.push(c),c},reset:function(){this.factory.time=new FlipClock.Time(this.factor,this.factory.original?Math.round(this.factory.original):0,{minimumDigits:this.factory.minimumDigits}),this.flip(this.factory.original,!1)},appendDigitToClock:function(a){a.$el.append(!1)},addDigit:function(a){var b=this.createList(a,{classes:{active:this.factory.classes.active,before:this.factory.classes.before,flip:this.factory.classes.flip}});this.appendDigitToClock(b)},start:function(){},stop:function(){},autoIncrement:function(){this.factory.countdown?this.decrement():this.increment()},increment:function(){this.factory.time.addSecond()},decrement:function(){0==this.factory.time.getTimeSeconds()?this.factory.stop():this.factory.time.subSecond()},flip:function(b,c){var d=this;a.each(b,function(a,b){var e=d.lists[a];e?(c||b==e.digit||e.play(),e.select(b)):d.addDigit(b)})}})}(jQuery),function(a){"use strict";FlipClock.Factory=FlipClock.Base.extend({animationRate:1e3,autoStart:!0,callbacks:{destroy:!1,create:!1,init:!1,interval:!1,start:!1,stop:!1,reset:!1},classes:{active:"flip-clock-active",before:"flip-clock-before",divider:"flip-clock-divider",dot:"flip-clock-dot",label:"flip-clock-label",flip:"flip",play:"play",wrapper:"flip-clock-wrapper"},clockFace:"HourlyCounter",countdown:!1,defaultClockFace:"HourlyCounter",defaultLanguage:"english",$el:!1,face:!0,lang:!1,language:"english",minimumDigits:0,original:!1,running:!1,time:!1,timer:!1,$wrapper:!1,constructor:function(b,c,d){d||(d={}),this.lists=[],this.running=!1,this.base(d),this.$el=a(b).addClass(this.classes.wrapper),this.$wrapper=this.$el,this.original=c instanceof Date?c:c?Math.round(c):0,this.time=new FlipClock.Time(this,this.original,{minimumDigits:this.minimumDigits,animationRate:this.animationRate}),this.timer=new FlipClock.Timer(this,d),this.loadLanguage(this.language),this.loadClockFace(this.clockFace,d),this.autoStart&&this.start()},loadClockFace:function(a,b){var c,d="Face",e=!1;return a=a.ucfirst()+d,this.face.stop&&(this.stop(),e=!0),this.$el.html(""),this.time.minimumDigits=this.minimumDigits,c=FlipClock[a]?new FlipClock[a](this,b):new FlipClock[this.defaultClockFace+d](this,b),c.build(),this.face=c,e&&this.start(),this.face},loadLanguage:function(a){var b;return b=FlipClock.Lang[a.ucfirst()]?FlipClock.Lang[a.ucfirst()]:FlipClock.Lang[a]?FlipClock.Lang[a]:FlipClock.Lang[this.defaultLanguage],this.lang=b},localize:function(a,b){var c=this.lang;if(!a)return null;var d=a.toLowerCase();return"object"==typeof b&&(c=b),c&&c[d]?c[d]:a},start:function(a){var b=this;b.running||b.countdown&&!(b.countdown&&b.time.time>0)?b.log("Trying to start timer when countdown already at 0"):(b.face.start(b.time),b.timer.start(function(){b.flip(),"function"==typeof a&&a()}))},stop:function(a){this.face.stop(),this.timer.stop(a);for(var b in this.lists)this.lists.hasOwnProperty(b)&&this.lists[b].stop()},reset:function(a){this.timer.reset(a),this.face.reset()},setTime:function(a){this.time.time=a,this.flip(!0)},getTime:function(){return this.time},setCountdown:function(a){var b=this.running;this.countdown=a?!0:!1,b&&(this.stop(),this.start())},flip:function(a){this.face.flip(!1,a)}})}(jQuery),function(a){"use strict";FlipClock.List=FlipClock.Base.extend({digit:0,classes:{active:"flip-clock-active",before:"flip-clock-before",flip:"flip"},factory:!1,$el:!1,$obj:!1,items:[],lastDigit:0,constructor:function(a,b){this.factory=a,this.digit=b,this.lastDigit=b,this.$el=this.createList(),this.$obj=this.$el,b>0&&this.select(b),this.factory.$el.append(this.$el)},select:function(a){if("undefined"==typeof a?a=this.digit:this.digit=a,this.digit!=this.lastDigit){var b=this.$el.find("."+this.classes.before).removeClass(this.classes.before);this.$el.find("."+this.classes.active).removeClass(this.classes.active).addClass(this.classes.before),this.appendListItem(this.classes.active,this.digit),b.remove(),this.lastDigit=this.digit}},play:function(){this.$el.addClass(this.factory.classes.play)},stop:function(){var a=this;setTimeout(function(){a.$el.removeClass(a.factory.classes.play)},this.factory.timer.interval)},createListItem:function(a,b){return['<li class="'+(a?a:"")+'">','<a href="#">','<div class="up">','<div class="shadow"></div>','<div class="inn">'+(b?b:"")+"</div>","</div>",'<div class="down">','<div class="shadow"></div>','<div class="inn">'+(b?b:"")+"</div>","</div>","</a>","</li>"].join("")},appendListItem:function(a,b){var c=this.createListItem(a,b);this.$el.append(c)},createList:function(){var b=this.getPrevDigit()?this.getPrevDigit():this.digit,c=a(['<ul class="'+this.classes.flip+" "+(this.factory.running?this.factory.classes.play:"")+'">',this.createListItem(this.classes.before,b),this.createListItem(this.classes.active,this.digit),"</ul>"].join(""));return c},getNextDigit:function(){return 9==this.digit?0:this.digit+1},getPrevDigit:function(){return 0==this.digit?9:this.digit-1}})}(jQuery),function(a){"use strict";String.prototype.ucfirst=function(){return this.substr(0,1).toUpperCase()+this.substr(1)},a.fn.FlipClock=function(b,c){return new FlipClock(a(this),b,c)},a.fn.flipClock=function(b,c){return a.fn.FlipClock(b,c)}}(jQuery),function(a){"use strict";FlipClock.Time=FlipClock.Base.extend({time:0,factory:!1,minimumDigits:0,constructor:function(a,b,c){"object"!=typeof c&&(c={}),c.minimumDigits||(c.minimumDigits=a.minimumDigits),this.base(c),this.factory=a,b&&(this.time=b)},convertDigitsToArray:function(a){var b=[];a=a.toString();for(var c=0;c<a.length;c++)a[c].match(/^\d*$/g)&&b.push(a[c]);return b},digit:function(a){var b=this.toString(),c=b.length;return b[c-a]?b[c-a]:!1},digitize:function(b){var c=[];if(a.each(b,function(a,b){b=b.toString(),1==b.length&&(b="0"+b);for(var d=0;d<b.length;d++)c.push(b.charAt(d))}),c.length>this.minimumDigits&&(this.minimumDigits=c.length),this.minimumDigits>c.length)for(var d=c.length;d<this.minimumDigits;d++)c.unshift("0");return c},getDateObject:function(){return this.time instanceof Date?this.time:new Date((new Date).getTime()+1e3*this.getTimeSeconds())},getDayCounter:function(a){var b=[this.getDays(),this.getHours(!0),this.getMinutes(!0)];return a&&b.push(this.getSeconds(!0)),this.digitize(b)},getDays:function(a){var b=this.getTimeSeconds()/60/60/24;return a&&(b%=7),Math.floor(b)},getHourCounter:function(){var a=this.digitize([this.getHours(),this.getMinutes(!0),this.getSeconds(!0)]);return a},getHourly:function(){return this.getHourCounter()},getHours:function(a){var b=this.getTimeSeconds()/60/60;return a&&(b%=24),Math.floor(b)},getMilitaryTime:function(a,b){"undefined"==typeof b&&(b=!0),a||(a=this.getDateObject());var c=[a.getHours(),a.getMinutes()];return b===!0&&c.push(a.getSeconds()),this.digitize(c)},getMinutes:function(a){var b=this.getTimeSeconds()/60;return a&&(b%=60),Math.floor(b)},getMinuteCounter:function(){var a=this.digitize([this.getMinutes(),this.getSeconds(!0)]);return a},getTimeSeconds:function(a){return a||(a=new Date),this.time instanceof Date?this.factory.countdown?Math.max(this.time.getTime()/1e3-a.getTime()/1e3,0):a.getTime()/1e3-this.time.getTime()/1e3:this.time},getTime:function(a,b){"undefined"==typeof b&&(b=!0),a||(a=this.getDateObject()),console.log(a);var c=a.getHours(),d=[c>12?c-12:0===c?12:c,a.getMinutes()];return b===!0&&d.push(a.getSeconds()),this.digitize(d)},getSeconds:function(a){var b=this.getTimeSeconds();return a&&(60==b?b=0:b%=60),Math.ceil(b)},getWeeks:function(a){var b=this.getTimeSeconds()/60/60/24/7;return a&&(b%=52),Math.floor(b)},removeLeadingZeros:function(b,c){var d=0,e=[];return a.each(c,function(a){b>a?d+=parseInt(c[a],10):e.push(c[a])}),0===d?e:c},addSeconds:function(a){this.time instanceof Date?this.time.setSeconds(this.time.getSeconds()+a):this.time+=a},addSecond:function(){this.addSeconds(1)},subSeconds:function(a){this.time instanceof Date?this.time.setSeconds(this.time.getSeconds()-a):this.time-=a},subSecond:function(){this.subSeconds(1)},toString:function(){return this.getTimeSeconds().toString()}})}(jQuery),function(){"use strict";FlipClock.Timer=FlipClock.Base.extend({callbacks:{destroy:!1,create:!1,init:!1,interval:!1,start:!1,stop:!1,reset:!1},count:0,factory:!1,interval:1e3,animationRate:1e3,constructor:function(a,b){this.base(b),this.factory=a,this.callback(this.callbacks.init),this.callback(this.callbacks.create)},getElapsed:function(){return this.count*this.interval},getElapsedTime:function(){return new Date(this.time+this.getElapsed())},reset:function(a){clearInterval(this.timer),this.count=0,this._setInterval(a),this.callback(this.callbacks.reset)},start:function(a){this.factory.running=!0,this._createTimer(a),this.callback(this.callbacks.start)},stop:function(a){this.factory.running=!1,this._clearInterval(a),this.callback(this.callbacks.stop),this.callback(a)},_clearInterval:function(){clearInterval(this.timer)},_createTimer:function(a){this._setInterval(a)},_destroyTimer:function(a){this._clearInterval(),this.timer=!1,this.callback(a),this.callback(this.callbacks.destroy)},_interval:function(a){this.callback(this.callbacks.interval),this.callback(a),this.count++},_setInterval:function(a){var b=this;b._interval(a),b.timer=setInterval(function(){b._interval(a)},this.interval)}})}(jQuery),function(a){FlipClock.TwentyFourHourClockFace=FlipClock.Face.extend({constructor:function(a,b){this.base(a,b)},build:function(b){var c=this,d=this.factory.$el.find("ul");this.factory.time.time||(this.factory.original=new Date,this.factory.time=new FlipClock.Time(this.factory,this.factory.original));var b=b?b:this.factory.time.getMilitaryTime(!1,this.showSeconds);b.length>d.length&&a.each(b,function(a,b){c.createList(b)}),this.createDivider(),this.createDivider(),a(this.dividers[0]).insertBefore(this.lists[this.lists.length-2].$el),a(this.dividers[1]).insertBefore(this.lists[this.lists.length-4].$el),this.base()},flip:function(a,b){this.autoIncrement(),a=a?a:this.factory.time.getMilitaryTime(!1,this.showSeconds),this.base(a,b)}})}(jQuery),function(a){FlipClock.CounterFace=FlipClock.Face.extend({shouldAutoIncrement:!1,constructor:function(a,b){"object"!=typeof b&&(b={}),a.autoStart=b.autoStart?!0:!1,b.autoStart&&(this.shouldAutoIncrement=!0),a.increment=function(){a.countdown=!1,a.setTime(a.getTime().getTimeSeconds()+1)},a.decrement=function(){a.countdown=!0;var b=a.getTime().getTimeSeconds();b>0&&a.setTime(b-1)},a.setValue=function(b){a.setTime(b)},a.setCounter=function(b){a.setTime(b)},this.base(a,b)},build:function(){var b=this,c=this.factory.$el.find("ul"),d=this.factory.getTime().digitize([this.factory.getTime().time]);d.length>c.length&&a.each(d,function(a,c){var d=b.createList(c);d.select(c)}),a.each(this.lists,function(a,b){b.play()}),this.base()},flip:function(a,b){this.shouldAutoIncrement&&this.autoIncrement(),a||(a=this.factory.getTime().digitize([this.factory.getTime().time])),this.base(a,b)},reset:function(){this.factory.time=new FlipClock.Time(this.factory,this.factory.original?Math.round(this.factory.original):0),this.flip()}})}(jQuery),function(a){FlipClock.DailyCounterFace=FlipClock.Face.extend({showSeconds:!0,constructor:function(a,b){this.base(a,b)},build:function(b){var c=this,d=this.factory.$el.find("ul"),e=0;b=b?b:this.factory.time.getDayCounter(this.showSeconds),b.length>d.length&&a.each(b,function(a,b){c.createList(b)}),this.showSeconds?a(this.createDivider("Seconds")).insertBefore(this.lists[this.lists.length-2].$el):e=2,a(this.createDivider("Minutes")).insertBefore(this.lists[this.lists.length-4+e].$el),a(this.createDivider("Hours")).insertBefore(this.lists[this.lists.length-6+e].$el),a(this.createDivider("Days",!0)).insertBefore(this.lists[0].$el),this.base()},flip:function(a,b){a||(a=this.factory.time.getDayCounter(this.showSeconds)),this.autoIncrement(),this.base(a,b)}})}(jQuery),function(a){FlipClock.HourlyCounterFace=FlipClock.Face.extend({constructor:function(a,b){this.base(a,b)},build:function(b,c){var d=this,e=this.factory.$el.find("ul");c=c?c:this.factory.time.getHourCounter(),c.length>e.length&&a.each(c,function(a,b){d.createList(b)}),a(this.createDivider("Seconds")).insertBefore(this.lists[this.lists.length-2].$el),a(this.createDivider("Minutes")).insertBefore(this.lists[this.lists.length-4].$el),b||a(this.createDivider("Hours",!0)).insertBefore(this.lists[0].$el),this.base()},flip:function(a,b){a||(a=this.factory.time.getHourCounter()),this.autoIncrement(),this.base(a,b)},appendDigitToClock:function(a){this.base(a),this.dividers[0].insertAfter(this.dividers[0].next())}})}(jQuery),function(){FlipClock.MinuteCounterFace=FlipClock.HourlyCounterFace.extend({clearExcessDigits:!1,constructor:function(a,b){this.base(a,b)},build:function(){this.base(!0,this.factory.time.getMinuteCounter())},flip:function(a,b){a||(a=this.factory.time.getMinuteCounter()),this.base(a,b)}})}(jQuery),function(a){FlipClock.TwelveHourClockFace=FlipClock.TwentyFourHourClockFace.extend({meridium:!1,meridiumText:"AM",build:function(){var b=this.factory.time.getTime(!1,this.showSeconds);this.base(b),this.meridiumText=this.getMeridium(),this.meridium=a(['<ul class="flip-clock-meridium">',"<li>",'<a href="#">'+this.meridiumText+"</a>","</li>","</ul>"].join("")),this.meridium.insertAfter(this.lists[this.lists.length-1].$el)},flip:function(a,b){this.meridiumText!=this.getMeridium()&&(this.meridiumText=this.getMeridium(),this.meridium.find("a").html(this.meridiumText)),this.base(this.factory.time.getTime(!1,this.showSeconds),b)},getMeridium:function(){return(new Date).getHours()>=12?"PM":"AM"},isPM:function(){return"PM"==this.getMeridium()?!0:!1},isAM:function(){return"AM"==this.getMeridium()?!0:!1}})}(jQuery),function(){FlipClock.Lang.Arabic={years:"سنوات",months:"شهور",days:"أيام",hours:"ساعات",minutes:"دقائق",seconds:"ثواني"},FlipClock.Lang.ar=FlipClock.Lang.Arabic,FlipClock.Lang["ar-ar"]=FlipClock.Lang.Arabic,FlipClock.Lang.arabic=FlipClock.Lang.Arabic}(jQuery),function(){FlipClock.Lang.Danish={years:"År",months:"Måneder",days:"Dage",hours:"Timer",minutes:"Minutter",seconds:"Sekunder"},FlipClock.Lang.da=FlipClock.Lang.Danish,FlipClock.Lang["da-dk"]=FlipClock.Lang.Danish,FlipClock.Lang.danish=FlipClock.Lang.Danish}(jQuery),function(){FlipClock.Lang.German={years:"Jahre",months:"Monate",days:"Tage",hours:"Stunden",minutes:"Minuten",seconds:"Sekunden"},FlipClock.Lang.de=FlipClock.Lang.German,FlipClock.Lang["de-de"]=FlipClock.Lang.German,FlipClock.Lang.german=FlipClock.Lang.German}(jQuery),function(){FlipClock.Lang.English={years:"Years",months:"Months",days:"Days",hours:"Hours",minutes:"Minutes",seconds:"Seconds"},FlipClock.Lang.en=FlipClock.Lang.English,FlipClock.Lang["en-us"]=FlipClock.Lang.English,FlipClock.Lang.english=FlipClock.Lang.English}(jQuery),function(){FlipClock.Lang.Spanish={years:"A&#241;os",months:"Meses",days:"D&#205;as",hours:"Horas",minutes:"Minutos",seconds:"Segundo"},FlipClock.Lang.es=FlipClock.Lang.Spanish,FlipClock.Lang["es-es"]=FlipClock.Lang.Spanish,FlipClock.Lang.spanish=FlipClock.Lang.Spanish}(jQuery),function(){FlipClock.Lang.Finnish={years:"Vuotta",months:"Kuukautta",days:"Päivää",hours:"Tuntia",minutes:"Minuuttia",seconds:"Sekuntia"},FlipClock.Lang.fi=FlipClock.Lang.Finnish,FlipClock.Lang["fi-fi"]=FlipClock.Lang.Finnish,FlipClock.Lang.finnish=FlipClock.Lang.Finnish}(jQuery),function(){FlipClock.Lang.French={years:"Ans",months:"Mois",days:"Jours",hours:"Heures",minutes:"Minutes",seconds:"Secondes"},FlipClock.Lang.fr=FlipClock.Lang.French,FlipClock.Lang["fr-ca"]=FlipClock.Lang.French,FlipClock.Lang.french=FlipClock.Lang.French}(jQuery),function(){FlipClock.Lang.Italian={years:"Anni",months:"Mesi",days:"Giorni",hours:"Ore",minutes:"Minuti",seconds:"Secondi"},FlipClock.Lang.it=FlipClock.Lang.Italian,FlipClock.Lang["it-it"]=FlipClock.Lang.Italian,FlipClock.Lang.italian=FlipClock.Lang.Italian}(jQuery),function(){FlipClock.Lang.Latvian={years:"Gadi",months:"Mēneši",days:"Dienas",hours:"Stundas",minutes:"Minūtes",seconds:"Sekundes"},FlipClock.Lang.lv=FlipClock.Lang.Latvian,FlipClock.Lang["lv-lv"]=FlipClock.Lang.Latvian,FlipClock.Lang.latvian=FlipClock.Lang.Latvian}(jQuery),function(){FlipClock.Lang.Dutch={years:"Jaren",months:"Maanden",days:"Dagen",hours:"Uren",minutes:"Minuten",seconds:"Seconden"},FlipClock.Lang.nl=FlipClock.Lang.Dutch,FlipClock.Lang["nl-be"]=FlipClock.Lang.Dutch,FlipClock.Lang.dutch=FlipClock.Lang.Dutch}(jQuery),function(){FlipClock.Lang.Norwegian={years:"År",months:"Måneder",days:"Dager",hours:"Timer",minutes:"Minutter",seconds:"Sekunder"},FlipClock.Lang.no=FlipClock.Lang.Norwegian,FlipClock.Lang.nb=FlipClock.Lang.Norwegian,FlipClock.Lang["no-nb"]=FlipClock.Lang.Norwegian,FlipClock.Lang.norwegian=FlipClock.Lang.Norwegian}(jQuery),function(){FlipClock.Lang.Portuguese={years:"Anos",months:"Meses",days:"Dias",hours:"Horas",minutes:"Minutos",seconds:"Segundos"},FlipClock.Lang.pt=FlipClock.Lang.Portuguese,FlipClock.Lang["pt-br"]=FlipClock.Lang.Portuguese,FlipClock.Lang.portuguese=FlipClock.Lang.Portuguese}(jQuery),function(){FlipClock.Lang.Russian={years:"лет",months:"месяцев",days:"дней",hours:"часов",minutes:"минут",seconds:"секунд"},FlipClock.Lang.ru=FlipClock.Lang.Russian,FlipClock.Lang["ru-ru"]=FlipClock.Lang.Russian,FlipClock.Lang.russian=FlipClock.Lang.Russian}(jQuery),function(){FlipClock.Lang.Swedish={years:"År",months:"Månader",days:"Dagar",hours:"Timmar",minutes:"Minuter",seconds:"Sekunder"},FlipClock.Lang.sv=FlipClock.Lang.Swedish,FlipClock.Lang["sv-se"]=FlipClock.Lang.Swedish,FlipClock.Lang.swedish=FlipClock.Lang.Swedish}(jQuery);
/*!
 * Bootstrap v3.3.7 (http://getbootstrap.com)
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under the MIT license
 */

if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery')
}

+function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
  }
}(jQuery);

/* ========================================================================
 * Bootstrap: transition.js v3.3.7
 * http://getbootstrap.com/javascript/#transitions
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CSS TRANSITION SUPPORT (Shoutout: http://www.modernizr.com/)
  // ============================================================

  function transitionEnd() {
    var el = document.createElement('bootstrap')

    var transEndEventNames = {
      WebkitTransition : 'webkitTransitionEnd',
      MozTransition    : 'transitionend',
      OTransition      : 'oTransitionEnd otransitionend',
      transition       : 'transitionend'
    }

    for (var name in transEndEventNames) {
      if (el.style[name] !== undefined) {
        return { end: transEndEventNames[name] }
      }
    }

    return false // explicit for ie8 (  ._.)
  }

  // http://blog.alexmaccaw.com/css-transitions
  $.fn.emulateTransitionEnd = function (duration) {
    var called = false
    var $el = this
    $(this).one('bsTransitionEnd', function () { called = true })
    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
    setTimeout(callback, duration)
    return this
  }

  $(function () {
    $.support.transition = transitionEnd()

    if (!$.support.transition) return

    $.event.special.bsTransitionEnd = {
      bindType: $.support.transition.end,
      delegateType: $.support.transition.end,
      handle: function (e) {
        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
      }
    }
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: alert.js v3.3.7
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.7'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector === '#' ? [] : selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);

/* ========================================================================
 * Bootstrap: button.js v3.3.7
 * http://getbootstrap.com/javascript/#buttons
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // BUTTON PUBLIC CLASS DEFINITION
  // ==============================

  var Button = function (element, options) {
    this.$element  = $(element)
    this.options   = $.extend({}, Button.DEFAULTS, options)
    this.isLoading = false
  }

  Button.VERSION  = '3.3.7'

  Button.DEFAULTS = {
    loadingText: 'loading...'
  }

  Button.prototype.setState = function (state) {
    var d    = 'disabled'
    var $el  = this.$element
    var val  = $el.is('input') ? 'val' : 'html'
    var data = $el.data()

    state += 'Text'

    if (data.resetText == null) $el.data('resetText', $el[val]())

    // push to event loop to allow forms to submit
    setTimeout($.proxy(function () {
      $el[val](data[state] == null ? this.options[state] : data[state])

      if (state == 'loadingText') {
        this.isLoading = true
        $el.addClass(d).attr(d, d).prop(d, true)
      } else if (this.isLoading) {
        this.isLoading = false
        $el.removeClass(d).removeAttr(d).prop(d, false)
      }
    }, this), 0)
  }

  Button.prototype.toggle = function () {
    var changed = true
    var $parent = this.$element.closest('[data-toggle="buttons"]')

    if ($parent.length) {
      var $input = this.$element.find('input')
      if ($input.prop('type') == 'radio') {
        if ($input.prop('checked')) changed = false
        $parent.find('.active').removeClass('active')
        this.$element.addClass('active')
      } else if ($input.prop('type') == 'checkbox') {
        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
        this.$element.toggleClass('active')
      }
      $input.prop('checked', this.$element.hasClass('active'))
      if (changed) $input.trigger('change')
    } else {
      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
      this.$element.toggleClass('active')
    }
  }


  // BUTTON PLUGIN DEFINITION
  // ========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.button')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.button', (data = new Button(this, options)))

      if (option == 'toggle') data.toggle()
      else if (option) data.setState(option)
    })
  }

  var old = $.fn.button

  $.fn.button             = Plugin
  $.fn.button.Constructor = Button


  // BUTTON NO CONFLICT
  // ==================

  $.fn.button.noConflict = function () {
    $.fn.button = old
    return this
  }


  // BUTTON DATA-API
  // ===============

  $(document)
    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      var $btn = $(e.target).closest('.btn')
      Plugin.call($btn, 'toggle')
      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
        e.preventDefault()
        // The target component still receive the focus
        if ($btn.is('input,button')) $btn.trigger('focus')
        else $btn.find('input:visible,button:visible').first().trigger('focus')
      }
    })
    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
    })

}(jQuery);

/* ========================================================================
 * Bootstrap: carousel.js v3.3.7
 * http://getbootstrap.com/javascript/#carousel
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // CAROUSEL CLASS DEFINITION
  // =========================

  var Carousel = function (element, options) {
    this.$element    = $(element)
    this.$indicators = this.$element.find('.carousel-indicators')
    this.options     = options
    this.paused      = null
    this.sliding     = null
    this.interval    = null
    this.$active     = null
    this.$items      = null

    this.options.keyboard && this.$element.on('keydown.bs.carousel', $.proxy(this.keydown, this))

    this.options.pause == 'hover' && !('ontouchstart' in document.documentElement) && this.$element
      .on('mouseenter.bs.carousel', $.proxy(this.pause, this))
      .on('mouseleave.bs.carousel', $.proxy(this.cycle, this))
  }

  Carousel.VERSION  = '3.3.7'

  Carousel.TRANSITION_DURATION = 600

  Carousel.DEFAULTS = {
    interval: 5000,
    pause: 'hover',
    wrap: true,
    keyboard: true
  }

  Carousel.prototype.keydown = function (e) {
    if (/input|textarea/i.test(e.target.tagName)) return
    switch (e.which) {
      case 37: this.prev(); break
      case 39: this.next(); break
      default: return
    }

    e.preventDefault()
  }

  Carousel.prototype.cycle = function (e) {
    e || (this.paused = false)

    this.interval && clearInterval(this.interval)

    this.options.interval
      && !this.paused
      && (this.interval = setInterval($.proxy(this.next, this), this.options.interval))

    return this
  }

  Carousel.prototype.getItemIndex = function (item) {
    this.$items = item.parent().children('.item')
    return this.$items.index(item || this.$active)
  }

  Carousel.prototype.getItemForDirection = function (direction, active) {
    var activeIndex = this.getItemIndex(active)
    var willWrap = (direction == 'prev' && activeIndex === 0)
                || (direction == 'next' && activeIndex == (this.$items.length - 1))
    if (willWrap && !this.options.wrap) return active
    var delta = direction == 'prev' ? -1 : 1
    var itemIndex = (activeIndex + delta) % this.$items.length
    return this.$items.eq(itemIndex)
  }

  Carousel.prototype.to = function (pos) {
    var that        = this
    var activeIndex = this.getItemIndex(this.$active = this.$element.find('.item.active'))

    if (pos > (this.$items.length - 1) || pos < 0) return

    if (this.sliding)       return this.$element.one('slid.bs.carousel', function () { that.to(pos) }) // yes, "slid"
    if (activeIndex == pos) return this.pause().cycle()

    return this.slide(pos > activeIndex ? 'next' : 'prev', this.$items.eq(pos))
  }

  Carousel.prototype.pause = function (e) {
    e || (this.paused = true)

    if (this.$element.find('.next, .prev').length && $.support.transition) {
      this.$element.trigger($.support.transition.end)
      this.cycle(true)
    }

    this.interval = clearInterval(this.interval)

    return this
  }

  Carousel.prototype.next = function () {
    if (this.sliding) return
    return this.slide('next')
  }

  Carousel.prototype.prev = function () {
    if (this.sliding) return
    return this.slide('prev')
  }

  Carousel.prototype.slide = function (type, next) {
    var $active   = this.$element.find('.item.active')
    var $next     = next || this.getItemForDirection(type, $active)
    var isCycling = this.interval
    var direction = type == 'next' ? 'left' : 'right'
    var that      = this

    if ($next.hasClass('active')) return (this.sliding = false)

    var relatedTarget = $next[0]
    var slideEvent = $.Event('slide.bs.carousel', {
      relatedTarget: relatedTarget,
      direction: direction
    })
    this.$element.trigger(slideEvent)
    if (slideEvent.isDefaultPrevented()) return

    this.sliding = true

    isCycling && this.pause()

    if (this.$indicators.length) {
      this.$indicators.find('.active').removeClass('active')
      var $nextIndicator = $(this.$indicators.children()[this.getItemIndex($next)])
      $nextIndicator && $nextIndicator.addClass('active')
    }

    var slidEvent = $.Event('slid.bs.carousel', { relatedTarget: relatedTarget, direction: direction }) // yes, "slid"
    if ($.support.transition && this.$element.hasClass('slide')) {
      $next.addClass(type)
      $next[0].offsetWidth // force reflow
      $active.addClass(direction)
      $next.addClass(direction)
      $active
        .one('bsTransitionEnd', function () {
          $next.removeClass([type, direction].join(' ')).addClass('active')
          $active.removeClass(['active', direction].join(' '))
          that.sliding = false
          setTimeout(function () {
            that.$element.trigger(slidEvent)
          }, 0)
        })
        .emulateTransitionEnd(Carousel.TRANSITION_DURATION)
    } else {
      $active.removeClass('active')
      $next.addClass('active')
      this.sliding = false
      this.$element.trigger(slidEvent)
    }

    isCycling && this.cycle()

    return this
  }


  // CAROUSEL PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.carousel')
      var options = $.extend({}, Carousel.DEFAULTS, $this.data(), typeof option == 'object' && option)
      var action  = typeof option == 'string' ? option : options.slide

      if (!data) $this.data('bs.carousel', (data = new Carousel(this, options)))
      if (typeof option == 'number') data.to(option)
      else if (action) data[action]()
      else if (options.interval) data.pause().cycle()
    })
  }

  var old = $.fn.carousel

  $.fn.carousel             = Plugin
  $.fn.carousel.Constructor = Carousel


  // CAROUSEL NO CONFLICT
  // ====================

  $.fn.carousel.noConflict = function () {
    $.fn.carousel = old
    return this
  }


  // CAROUSEL DATA-API
  // =================

  var clickHandler = function (e) {
    var href
    var $this   = $(this)
    var $target = $($this.attr('data-target') || (href = $this.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
    if (!$target.hasClass('carousel')) return
    var options = $.extend({}, $target.data(), $this.data())
    var slideIndex = $this.attr('data-slide-to')
    if (slideIndex) options.interval = false

    Plugin.call($target, options)

    if (slideIndex) {
      $target.data('bs.carousel').to(slideIndex)
    }

    e.preventDefault()
  }

  $(document)
    .on('click.bs.carousel.data-api', '[data-slide]', clickHandler)
    .on('click.bs.carousel.data-api', '[data-slide-to]', clickHandler)

  $(window).on('load', function () {
    $('[data-ride="carousel"]').each(function () {
      var $carousel = $(this)
      Plugin.call($carousel, $carousel.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: collapse.js v3.3.7
 * http://getbootstrap.com/javascript/#collapse
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* jshint latedef: false */

+function ($) {
  'use strict';

  // COLLAPSE PUBLIC CLASS DEFINITION
  // ================================

  var Collapse = function (element, options) {
    this.$element      = $(element)
    this.options       = $.extend({}, Collapse.DEFAULTS, options)
    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
    this.transitioning = null

    if (this.options.parent) {
      this.$parent = this.getParent()
    } else {
      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
    }

    if (this.options.toggle) this.toggle()
  }

  Collapse.VERSION  = '3.3.7'

  Collapse.TRANSITION_DURATION = 350

  Collapse.DEFAULTS = {
    toggle: true
  }

  Collapse.prototype.dimension = function () {
    var hasWidth = this.$element.hasClass('width')
    return hasWidth ? 'width' : 'height'
  }

  Collapse.prototype.show = function () {
    if (this.transitioning || this.$element.hasClass('in')) return

    var activesData
    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')

    if (actives && actives.length) {
      activesData = actives.data('bs.collapse')
      if (activesData && activesData.transitioning) return
    }

    var startEvent = $.Event('show.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    if (actives && actives.length) {
      Plugin.call(actives, 'hide')
      activesData || actives.data('bs.collapse', null)
    }

    var dimension = this.dimension()

    this.$element
      .removeClass('collapse')
      .addClass('collapsing')[dimension](0)
      .attr('aria-expanded', true)

    this.$trigger
      .removeClass('collapsed')
      .attr('aria-expanded', true)

    this.transitioning = 1

    var complete = function () {
      this.$element
        .removeClass('collapsing')
        .addClass('collapse in')[dimension]('')
      this.transitioning = 0
      this.$element
        .trigger('shown.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    var scrollSize = $.camelCase(['scroll', dimension].join('-'))

    this.$element
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
  }

  Collapse.prototype.hide = function () {
    if (this.transitioning || !this.$element.hasClass('in')) return

    var startEvent = $.Event('hide.bs.collapse')
    this.$element.trigger(startEvent)
    if (startEvent.isDefaultPrevented()) return

    var dimension = this.dimension()

    this.$element[dimension](this.$element[dimension]())[0].offsetHeight

    this.$element
      .addClass('collapsing')
      .removeClass('collapse in')
      .attr('aria-expanded', false)

    this.$trigger
      .addClass('collapsed')
      .attr('aria-expanded', false)

    this.transitioning = 1

    var complete = function () {
      this.transitioning = 0
      this.$element
        .removeClass('collapsing')
        .addClass('collapse')
        .trigger('hidden.bs.collapse')
    }

    if (!$.support.transition) return complete.call(this)

    this.$element
      [dimension](0)
      .one('bsTransitionEnd', $.proxy(complete, this))
      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
  }

  Collapse.prototype.toggle = function () {
    this[this.$element.hasClass('in') ? 'hide' : 'show']()
  }

  Collapse.prototype.getParent = function () {
    return $(this.options.parent)
      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
      .each($.proxy(function (i, element) {
        var $element = $(element)
        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
      }, this))
      .end()
  }

  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
    var isOpen = $element.hasClass('in')

    $element.attr('aria-expanded', isOpen)
    $trigger
      .toggleClass('collapsed', !isOpen)
      .attr('aria-expanded', isOpen)
  }

  function getTargetFromTrigger($trigger) {
    var href
    var target = $trigger.attr('data-target')
      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7

    return $(target)
  }


  // COLLAPSE PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.collapse')
      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.collapse

  $.fn.collapse             = Plugin
  $.fn.collapse.Constructor = Collapse


  // COLLAPSE NO CONFLICT
  // ====================

  $.fn.collapse.noConflict = function () {
    $.fn.collapse = old
    return this
  }


  // COLLAPSE DATA-API
  // =================

  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
    var $this   = $(this)

    if (!$this.attr('data-target')) e.preventDefault()

    var $target = getTargetFromTrigger($this)
    var data    = $target.data('bs.collapse')
    var option  = data ? 'toggle' : $this.data()

    Plugin.call($target, option)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.7
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.7'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);

/* ========================================================================
 * Bootstrap: modal.js v3.3.7
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.7'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element.addClass('in')

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }

  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (document !== e.target &&
            this.$element[0] !== e.target &&
            !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $(document.createElement('div'))
        .addClass('modal-backdrop ' + animate)
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget || e.clientX != 'undefined') return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tooltip.js v3.3.7
 * http://getbootstrap.com/javascript/#tooltip
 * Inspired by the original jQuery.tipsy by Jason Frame
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TOOLTIP PUBLIC CLASS DEFINITION
  // ===============================

  var Tooltip = function (element, options) {
    this.type       = null
    this.options    = null
    this.enabled    = null
    this.timeout    = null
    this.hoverState = null
    this.$element   = null
    this.inState    = null

    this.init('tooltip', element, options)
  }

  Tooltip.VERSION  = '3.3.7'

  Tooltip.TRANSITION_DURATION = 150

  Tooltip.DEFAULTS = {
    animation: true,
    placement: 'top',
    selector: false,
    template: '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
    trigger: 'hover focus',
    title: '',
    delay: 0,
    html: false,
    container: false,
    viewport: {
      selector: 'body',
      padding: 0
    }
  }

  Tooltip.prototype.init = function (type, element, options) {
    this.enabled   = true
    this.type      = type
    this.$element  = $(element)
    this.options   = this.getOptions(options)
    this.$viewport = this.options.viewport && $($.isFunction(this.options.viewport) ? this.options.viewport.call(this, this.$element) : (this.options.viewport.selector || this.options.viewport))
    this.inState   = { click: false, hover: false, focus: false }

    if (this.$element[0] instanceof document.constructor && !this.options.selector) {
      throw new Error('`selector` option must be specified when initializing ' + this.type + ' on the window.document object!')
    }

    var triggers = this.options.trigger.split(' ')

    for (var i = triggers.length; i--;) {
      var trigger = triggers[i]

      if (trigger == 'click') {
        this.$element.on('click.' + this.type, this.options.selector, $.proxy(this.toggle, this))
      } else if (trigger != 'manual') {
        var eventIn  = trigger == 'hover' ? 'mouseenter' : 'focusin'
        var eventOut = trigger == 'hover' ? 'mouseleave' : 'focusout'

        this.$element.on(eventIn  + '.' + this.type, this.options.selector, $.proxy(this.enter, this))
        this.$element.on(eventOut + '.' + this.type, this.options.selector, $.proxy(this.leave, this))
      }
    }

    this.options.selector ?
      (this._options = $.extend({}, this.options, { trigger: 'manual', selector: '' })) :
      this.fixTitle()
  }

  Tooltip.prototype.getDefaults = function () {
    return Tooltip.DEFAULTS
  }

  Tooltip.prototype.getOptions = function (options) {
    options = $.extend({}, this.getDefaults(), this.$element.data(), options)

    if (options.delay && typeof options.delay == 'number') {
      options.delay = {
        show: options.delay,
        hide: options.delay
      }
    }

    return options
  }

  Tooltip.prototype.getDelegateOptions = function () {
    var options  = {}
    var defaults = this.getDefaults()

    this._options && $.each(this._options, function (key, value) {
      if (defaults[key] != value) options[key] = value
    })

    return options
  }

  Tooltip.prototype.enter = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusin' ? 'focus' : 'hover'] = true
    }

    if (self.tip().hasClass('in') || self.hoverState == 'in') {
      self.hoverState = 'in'
      return
    }

    clearTimeout(self.timeout)

    self.hoverState = 'in'

    if (!self.options.delay || !self.options.delay.show) return self.show()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'in') self.show()
    }, self.options.delay.show)
  }

  Tooltip.prototype.isInStateTrue = function () {
    for (var key in this.inState) {
      if (this.inState[key]) return true
    }

    return false
  }

  Tooltip.prototype.leave = function (obj) {
    var self = obj instanceof this.constructor ?
      obj : $(obj.currentTarget).data('bs.' + this.type)

    if (!self) {
      self = new this.constructor(obj.currentTarget, this.getDelegateOptions())
      $(obj.currentTarget).data('bs.' + this.type, self)
    }

    if (obj instanceof $.Event) {
      self.inState[obj.type == 'focusout' ? 'focus' : 'hover'] = false
    }

    if (self.isInStateTrue()) return

    clearTimeout(self.timeout)

    self.hoverState = 'out'

    if (!self.options.delay || !self.options.delay.hide) return self.hide()

    self.timeout = setTimeout(function () {
      if (self.hoverState == 'out') self.hide()
    }, self.options.delay.hide)
  }

  Tooltip.prototype.show = function () {
    var e = $.Event('show.bs.' + this.type)

    if (this.hasContent() && this.enabled) {
      this.$element.trigger(e)

      var inDom = $.contains(this.$element[0].ownerDocument.documentElement, this.$element[0])
      if (e.isDefaultPrevented() || !inDom) return
      var that = this

      var $tip = this.tip()

      var tipId = this.getUID(this.type)

      this.setContent()
      $tip.attr('id', tipId)
      this.$element.attr('aria-describedby', tipId)

      if (this.options.animation) $tip.addClass('fade')

      var placement = typeof this.options.placement == 'function' ?
        this.options.placement.call(this, $tip[0], this.$element[0]) :
        this.options.placement

      var autoToken = /\s?auto?\s?/i
      var autoPlace = autoToken.test(placement)
      if (autoPlace) placement = placement.replace(autoToken, '') || 'top'

      $tip
        .detach()
        .css({ top: 0, left: 0, display: 'block' })
        .addClass(placement)
        .data('bs.' + this.type, this)

      this.options.container ? $tip.appendTo(this.options.container) : $tip.insertAfter(this.$element)
      this.$element.trigger('inserted.bs.' + this.type)

      var pos          = this.getPosition()
      var actualWidth  = $tip[0].offsetWidth
      var actualHeight = $tip[0].offsetHeight

      if (autoPlace) {
        var orgPlacement = placement
        var viewportDim = this.getPosition(this.$viewport)

        placement = placement == 'bottom' && pos.bottom + actualHeight > viewportDim.bottom ? 'top'    :
                    placement == 'top'    && pos.top    - actualHeight < viewportDim.top    ? 'bottom' :
                    placement == 'right'  && pos.right  + actualWidth  > viewportDim.width  ? 'left'   :
                    placement == 'left'   && pos.left   - actualWidth  < viewportDim.left   ? 'right'  :
                    placement

        $tip
          .removeClass(orgPlacement)
          .addClass(placement)
      }

      var calculatedOffset = this.getCalculatedOffset(placement, pos, actualWidth, actualHeight)

      this.applyPlacement(calculatedOffset, placement)

      var complete = function () {
        var prevHoverState = that.hoverState
        that.$element.trigger('shown.bs.' + that.type)
        that.hoverState = null

        if (prevHoverState == 'out') that.leave(that)
      }

      $.support.transition && this.$tip.hasClass('fade') ?
        $tip
          .one('bsTransitionEnd', complete)
          .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
        complete()
    }
  }

  Tooltip.prototype.applyPlacement = function (offset, placement) {
    var $tip   = this.tip()
    var width  = $tip[0].offsetWidth
    var height = $tip[0].offsetHeight

    // manually read margins because getBoundingClientRect includes difference
    var marginTop = parseInt($tip.css('margin-top'), 10)
    var marginLeft = parseInt($tip.css('margin-left'), 10)

    // we must check for NaN for ie 8/9
    if (isNaN(marginTop))  marginTop  = 0
    if (isNaN(marginLeft)) marginLeft = 0

    offset.top  += marginTop
    offset.left += marginLeft

    // $.fn.offset doesn't round pixel values
    // so we use setOffset directly with our own function B-0
    $.offset.setOffset($tip[0], $.extend({
      using: function (props) {
        $tip.css({
          top: Math.round(props.top),
          left: Math.round(props.left)
        })
      }
    }, offset), 0)

    $tip.addClass('in')

    // check to see if placing tip in new offset caused the tip to resize itself
    var actualWidth  = $tip[0].offsetWidth
    var actualHeight = $tip[0].offsetHeight

    if (placement == 'top' && actualHeight != height) {
      offset.top = offset.top + height - actualHeight
    }

    var delta = this.getViewportAdjustedDelta(placement, offset, actualWidth, actualHeight)

    if (delta.left) offset.left += delta.left
    else offset.top += delta.top

    var isVertical          = /top|bottom/.test(placement)
    var arrowDelta          = isVertical ? delta.left * 2 - width + actualWidth : delta.top * 2 - height + actualHeight
    var arrowOffsetPosition = isVertical ? 'offsetWidth' : 'offsetHeight'

    $tip.offset(offset)
    this.replaceArrow(arrowDelta, $tip[0][arrowOffsetPosition], isVertical)
  }

  Tooltip.prototype.replaceArrow = function (delta, dimension, isVertical) {
    this.arrow()
      .css(isVertical ? 'left' : 'top', 50 * (1 - delta / dimension) + '%')
      .css(isVertical ? 'top' : 'left', '')
  }

  Tooltip.prototype.setContent = function () {
    var $tip  = this.tip()
    var title = this.getTitle()

    $tip.find('.tooltip-inner')[this.options.html ? 'html' : 'text'](title)
    $tip.removeClass('fade in top bottom left right')
  }

  Tooltip.prototype.hide = function (callback) {
    var that = this
    var $tip = $(this.$tip)
    var e    = $.Event('hide.bs.' + this.type)

    function complete() {
      if (that.hoverState != 'in') $tip.detach()
      if (that.$element) { // TODO: Check whether guarding this code with this `if` is really necessary.
        that.$element
          .removeAttr('aria-describedby')
          .trigger('hidden.bs.' + that.type)
      }
      callback && callback()
    }

    this.$element.trigger(e)

    if (e.isDefaultPrevented()) return

    $tip.removeClass('in')

    $.support.transition && $tip.hasClass('fade') ?
      $tip
        .one('bsTransitionEnd', complete)
        .emulateTransitionEnd(Tooltip.TRANSITION_DURATION) :
      complete()

    this.hoverState = null

    return this
  }

  Tooltip.prototype.fixTitle = function () {
    var $e = this.$element
    if ($e.attr('title') || typeof $e.attr('data-original-title') != 'string') {
      $e.attr('data-original-title', $e.attr('title') || '').attr('title', '')
    }
  }

  Tooltip.prototype.hasContent = function () {
    return this.getTitle()
  }

  Tooltip.prototype.getPosition = function ($element) {
    $element   = $element || this.$element

    var el     = $element[0]
    var isBody = el.tagName == 'BODY'

    var elRect    = el.getBoundingClientRect()
    if (elRect.width == null) {
      // width and height are missing in IE8, so compute them manually; see https://github.com/twbs/bootstrap/issues/14093
      elRect = $.extend({}, elRect, { width: elRect.right - elRect.left, height: elRect.bottom - elRect.top })
    }
    var isSvg = window.SVGElement && el instanceof window.SVGElement
    // Avoid using $.offset() on SVGs since it gives incorrect results in jQuery 3.
    // See https://github.com/twbs/bootstrap/issues/20280
    var elOffset  = isBody ? { top: 0, left: 0 } : (isSvg ? null : $element.offset())
    var scroll    = { scroll: isBody ? document.documentElement.scrollTop || document.body.scrollTop : $element.scrollTop() }
    var outerDims = isBody ? { width: $(window).width(), height: $(window).height() } : null

    return $.extend({}, elRect, scroll, outerDims, elOffset)
  }

  Tooltip.prototype.getCalculatedOffset = function (placement, pos, actualWidth, actualHeight) {
    return placement == 'bottom' ? { top: pos.top + pos.height,   left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'top'    ? { top: pos.top - actualHeight, left: pos.left + pos.width / 2 - actualWidth / 2 } :
           placement == 'left'   ? { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left - actualWidth } :
        /* placement == 'right' */ { top: pos.top + pos.height / 2 - actualHeight / 2, left: pos.left + pos.width }

  }

  Tooltip.prototype.getViewportAdjustedDelta = function (placement, pos, actualWidth, actualHeight) {
    var delta = { top: 0, left: 0 }
    if (!this.$viewport) return delta

    var viewportPadding = this.options.viewport && this.options.viewport.padding || 0
    var viewportDimensions = this.getPosition(this.$viewport)

    if (/right|left/.test(placement)) {
      var topEdgeOffset    = pos.top - viewportPadding - viewportDimensions.scroll
      var bottomEdgeOffset = pos.top + viewportPadding - viewportDimensions.scroll + actualHeight
      if (topEdgeOffset < viewportDimensions.top) { // top overflow
        delta.top = viewportDimensions.top - topEdgeOffset
      } else if (bottomEdgeOffset > viewportDimensions.top + viewportDimensions.height) { // bottom overflow
        delta.top = viewportDimensions.top + viewportDimensions.height - bottomEdgeOffset
      }
    } else {
      var leftEdgeOffset  = pos.left - viewportPadding
      var rightEdgeOffset = pos.left + viewportPadding + actualWidth
      if (leftEdgeOffset < viewportDimensions.left) { // left overflow
        delta.left = viewportDimensions.left - leftEdgeOffset
      } else if (rightEdgeOffset > viewportDimensions.right) { // right overflow
        delta.left = viewportDimensions.left + viewportDimensions.width - rightEdgeOffset
      }
    }

    return delta
  }

  Tooltip.prototype.getTitle = function () {
    var title
    var $e = this.$element
    var o  = this.options

    title = $e.attr('data-original-title')
      || (typeof o.title == 'function' ? o.title.call($e[0]) :  o.title)

    return title
  }

  Tooltip.prototype.getUID = function (prefix) {
    do prefix += ~~(Math.random() * 1000000)
    while (document.getElementById(prefix))
    return prefix
  }

  Tooltip.prototype.tip = function () {
    if (!this.$tip) {
      this.$tip = $(this.options.template)
      if (this.$tip.length != 1) {
        throw new Error(this.type + ' `template` option must consist of exactly 1 top-level element!')
      }
    }
    return this.$tip
  }

  Tooltip.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.tooltip-arrow'))
  }

  Tooltip.prototype.enable = function () {
    this.enabled = true
  }

  Tooltip.prototype.disable = function () {
    this.enabled = false
  }

  Tooltip.prototype.toggleEnabled = function () {
    this.enabled = !this.enabled
  }

  Tooltip.prototype.toggle = function (e) {
    var self = this
    if (e) {
      self = $(e.currentTarget).data('bs.' + this.type)
      if (!self) {
        self = new this.constructor(e.currentTarget, this.getDelegateOptions())
        $(e.currentTarget).data('bs.' + this.type, self)
      }
    }

    if (e) {
      self.inState.click = !self.inState.click
      if (self.isInStateTrue()) self.enter(self)
      else self.leave(self)
    } else {
      self.tip().hasClass('in') ? self.leave(self) : self.enter(self)
    }
  }

  Tooltip.prototype.destroy = function () {
    var that = this
    clearTimeout(this.timeout)
    this.hide(function () {
      that.$element.off('.' + that.type).removeData('bs.' + that.type)
      if (that.$tip) {
        that.$tip.detach()
      }
      that.$tip = null
      that.$arrow = null
      that.$viewport = null
      that.$element = null
    })
  }


  // TOOLTIP PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.tooltip')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.tooltip', (data = new Tooltip(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tooltip

  $.fn.tooltip             = Plugin
  $.fn.tooltip.Constructor = Tooltip


  // TOOLTIP NO CONFLICT
  // ===================

  $.fn.tooltip.noConflict = function () {
    $.fn.tooltip = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: popover.js v3.3.7
 * http://getbootstrap.com/javascript/#popovers
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // POPOVER PUBLIC CLASS DEFINITION
  // ===============================

  var Popover = function (element, options) {
    this.init('popover', element, options)
  }

  if (!$.fn.tooltip) throw new Error('Popover requires tooltip.js')

  Popover.VERSION  = '3.3.7'

  Popover.DEFAULTS = $.extend({}, $.fn.tooltip.Constructor.DEFAULTS, {
    placement: 'right',
    trigger: 'click',
    content: '',
    template: '<div class="popover" role="tooltip"><div class="arrow"></div><h3 class="popover-title"></h3><div class="popover-content"></div></div>'
  })


  // NOTE: POPOVER EXTENDS tooltip.js
  // ================================

  Popover.prototype = $.extend({}, $.fn.tooltip.Constructor.prototype)

  Popover.prototype.constructor = Popover

  Popover.prototype.getDefaults = function () {
    return Popover.DEFAULTS
  }

  Popover.prototype.setContent = function () {
    var $tip    = this.tip()
    var title   = this.getTitle()
    var content = this.getContent()

    $tip.find('.popover-title')[this.options.html ? 'html' : 'text'](title)
    $tip.find('.popover-content').children().detach().end()[ // we use append for html objects to maintain js events
      this.options.html ? (typeof content == 'string' ? 'html' : 'append') : 'text'
    ](content)

    $tip.removeClass('fade top bottom left right in')

    // IE8 doesn't accept hiding via the `:empty` pseudo selector, we have to do
    // this manually by checking the contents.
    if (!$tip.find('.popover-title').html()) $tip.find('.popover-title').hide()
  }

  Popover.prototype.hasContent = function () {
    return this.getTitle() || this.getContent()
  }

  Popover.prototype.getContent = function () {
    var $e = this.$element
    var o  = this.options

    return $e.attr('data-content')
      || (typeof o.content == 'function' ?
            o.content.call($e[0]) :
            o.content)
  }

  Popover.prototype.arrow = function () {
    return (this.$arrow = this.$arrow || this.tip().find('.arrow'))
  }


  // POPOVER PLUGIN DEFINITION
  // =========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.popover')
      var options = typeof option == 'object' && option

      if (!data && /destroy|hide/.test(option)) return
      if (!data) $this.data('bs.popover', (data = new Popover(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.popover

  $.fn.popover             = Plugin
  $.fn.popover.Constructor = Popover


  // POPOVER NO CONFLICT
  // ===================

  $.fn.popover.noConflict = function () {
    $.fn.popover = old
    return this
  }

}(jQuery);

/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.7
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    this.$body          = $(document.body)
    this.$scrollElement = $(element).is(document.body) ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', $.proxy(this.process, this))
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.7'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var that          = this
    var offsetMethod  = 'offset'
    var offsetBase    = 0

    this.offsets      = []
    this.targets      = []
    this.scrollHeight = this.getScrollHeight()

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        that.offsets.push(this[0])
        that.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (offsets[i + 1] === undefined || scrollTop < offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
      '[data-target="' + target + '"],' +
      this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);

/* ========================================================================
 * Bootstrap: tab.js v3.3.7
 * http://getbootstrap.com/javascript/#tabs
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // TAB CLASS DEFINITION
  // ====================

  var Tab = function (element) {
    // jscs:disable requireDollarBeforejQueryAssignment
    this.element = $(element)
    // jscs:enable requireDollarBeforejQueryAssignment
  }

  Tab.VERSION = '3.3.7'

  Tab.TRANSITION_DURATION = 150

  Tab.prototype.show = function () {
    var $this    = this.element
    var $ul      = $this.closest('ul:not(.dropdown-menu)')
    var selector = $this.data('target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    if ($this.parent('li').hasClass('active')) return

    var $previous = $ul.find('.active:last a')
    var hideEvent = $.Event('hide.bs.tab', {
      relatedTarget: $this[0]
    })
    var showEvent = $.Event('show.bs.tab', {
      relatedTarget: $previous[0]
    })

    $previous.trigger(hideEvent)
    $this.trigger(showEvent)

    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return

    var $target = $(selector)

    this.activate($this.closest('li'), $ul)
    this.activate($target, $target.parent(), function () {
      $previous.trigger({
        type: 'hidden.bs.tab',
        relatedTarget: $this[0]
      })
      $this.trigger({
        type: 'shown.bs.tab',
        relatedTarget: $previous[0]
      })
    })
  }

  Tab.prototype.activate = function (element, container, callback) {
    var $active    = container.find('> .active')
    var transition = callback
      && $.support.transition
      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)

    function next() {
      $active
        .removeClass('active')
        .find('> .dropdown-menu > .active')
          .removeClass('active')
        .end()
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', false)

      element
        .addClass('active')
        .find('[data-toggle="tab"]')
          .attr('aria-expanded', true)

      if (transition) {
        element[0].offsetWidth // reflow for transition
        element.addClass('in')
      } else {
        element.removeClass('fade')
      }

      if (element.parent('.dropdown-menu').length) {
        element
          .closest('li.dropdown')
            .addClass('active')
          .end()
          .find('[data-toggle="tab"]')
            .attr('aria-expanded', true)
      }

      callback && callback()
    }

    $active.length && transition ?
      $active
        .one('bsTransitionEnd', next)
        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
      next()

    $active.removeClass('in')
  }


  // TAB PLUGIN DEFINITION
  // =====================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.tab')

      if (!data) $this.data('bs.tab', (data = new Tab(this)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.tab

  $.fn.tab             = Plugin
  $.fn.tab.Constructor = Tab


  // TAB NO CONFLICT
  // ===============

  $.fn.tab.noConflict = function () {
    $.fn.tab = old
    return this
  }


  // TAB DATA-API
  // ============

  var clickHandler = function (e) {
    e.preventDefault()
    Plugin.call($(this), 'show')
  }

  $(document)
    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)

}(jQuery);

/* ========================================================================
 * Bootstrap: affix.js v3.3.7
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      = null
    this.unpin        = null
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.7'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = Math.max($(document).height(), $(document.body).height())

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('conversionOfBoiler', {
            parent: 'app',
            url: '/conversionOfBoiler',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/conversionOfBoiler/conversionOfBoiler.html',
                    controller: 'ConversionOfBoilerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ConversionOfBoiler', ConversionOfBoiler);

    ConversionOfBoiler.$inject = ['$resource'];

    function ConversionOfBoiler ($resource) {
        var resourceUrl =  'api/conversionOfBoiler';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ConversionOfBoilerController', ConversionOfBoilerController);

    ConversionOfBoilerController.$inject = ['ConversionOfBoiler', '$stateParams','$scope', '$state','IncentiveForm', 'Principal', 'LoginService'];

    function ConversionOfBoilerController(ConversionOfBoiler, $stateParams,$scope, $state, IncentiveForm, Principal, LoginService) {

        var vm = this;
        vm.url = null;
        vm.isAuthenticated = Principal.isAuthenticated;
        IncentiveForm.query(function(result){
            vm.userdetails=result;
        });

        vm.setUrl = function (url) {
            vm.url = $sce.trustAsResourceUrl(url);
        };

        vm.login = function login() {
            LoginService.open();
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('nmaDetailPageController', nmaDetailPageController);

    nmaDetailPageController.$inject = ['$stateParams', 'Nma'];

    function nmaDetailPageController ($stateParams, Nma) {
        var vm = this;

        vm.nma={};

        loadAll();

        function loadAll() {
            Nma.get({id: $stateParams.nmaId},function (result) {
                vm.nma=result;
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('inspectionOfficerDeptController', inspectionOfficerDeptController);

    inspectionOfficerDeptController.$inject = ['$rootScope', '$scope', '$stateParams','$state', 'ConstructionPermitApprovalSteps', 'ConstructionPermitLog', 'ConstructionPermitApproval', 'InspectionReport', 'FileManagement'];

    function inspectionOfficerDeptController ($rootScope, $scope, $stateParams, $state, ConstructionPermitApprovalSteps, ConstructionPermitLog, ConstructionPermitApproval, InspectionReport, FileManagement) {
        var vm = this;
        var savefilename=null;
        vm.constructionPermit={};
        vm.constructionPermitLog={};
        vm.inspectionReport={};
        $scope.file = {};
        vm.count=0;


        loadAll();

        function loadAll() {
            ConstructionPermitApprovalSteps.query(function (result) {
                vm.pendingConstructionPermits= result;
            });
        }

        function ontempSaveSuccess(result) {
            vm.inspectionReport=result;
            console.log(vm.inspectionReport);
        }

        vm.uploadInspectionReport= function (data) {
            ConstructionPermitApproval.query({projectId: data.projectId},function (result) {
                vm.constructionPermit = result;
                vm.inspectionReport.projectid = vm.constructionPermit.projectId;
                vm.inspectionReport.reportDescription = "Inspection Report Uploaded";
                vm.inspectionReport.serviceid = vm.constructionPermit.serviceId;
                InspectionReport.save(vm.inspectionReport,ontempSaveSuccess);
            })
        };

        vm.uploadfile= function (object,count) {
            vm.count=count;
            var fileNameArray = object.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var filename = vm.constructionPermit.id+"_"+count;
            savefilename=filename+ "." + fileextension;
            FileManagement.saveFile(object,filename,onFileSaveSuccess);
        };

        function onFileSaveSuccess() {
            InspectionReport.get({id:vm.inspectionReport.id},function (result) {
                console.log(result);
            });
            if(vm.count===1){
                vm.inspectionReport.file1 = savefilename;
            }
            else if(vm.count===2){
                vm.inspectionReport.file2 = savefilename;
            }
            else if(vm.count===3){
                vm.inspectionReport.file3 = savefilename;
            }
            else if(vm.count===4){
                vm.inspectionReport.file4 = savefilename;
            }
            else if(vm.count===5){
                vm.inspectionReport.file5 = savefilename;
            }
            else if(vm.count===6){
                vm.inspectionReport.file6 = savefilename;
            }
            else if(vm.count===7){
                vm.inspectionReport.file7 = savefilename;
            }
            else if(vm.count===8){
                vm.inspectionReport.file8 = savefilename;
            }
            else if(vm.count===9){
                vm.inspectionReport.file9 = savefilename;
            }
            else if(vm.count===10){
                vm.inspectionReport.file10 = savefilename;
            }
            InspectionReport.update(vm.inspectionReport,onIRSaveSuccess);
        }

        function onIRSaveSuccess(result) {
            console.log("onIRSaveSuccess");
            vm.constructionPermit.serviceIdEC=result.id;
            vm.constructionPermit.fireNOCflag=true;
            vm.constructionPermit.isFileUploaded=true;
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onCPstepsSaveSuccess);
        }

        function onCPstepsSaveSuccess(result) {
            vm.constructionPermitLog.action="Inspection Report Uploaded";
            vm.constructionPermitLog.projectid= vm.constructionPermit.projectId;
            vm.constructionPermitLog.serviceid= vm.constructionPermit.serviceId;
            ConstructionPermitLog.save(vm.constructionPermitLog);
        }

        vm.onDoneSaveSuccess= function () {
            loadAll();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('constructionPermitDeptController', constructionPermitDeptController);

    constructionPermitDeptController.$inject = ['$rootScope', '$timeout', '$scope', '$stateParams','$state', 'ConstructionPermitApprovalSteps', 'ConstructionPermitLog', 'ConstructionPermitApproval', 'FactotyPlan','$sce', 'HudaformOc', 'HudaForm'];

    function constructionPermitDeptController ($rootScope, $timeout, $scope, $stateParams, $state, ConstructionPermitApprovalSteps, ConstructionPermitLog, ConstructionPermitApproval, FactotyPlan,$sce, HudaformOc, HudaForm) {
        var vm = this;
        vm.constructionPermit={};
        vm.constructionPermitLog={};
        vm.projectid = $stateParams.id;
        vm.resourceurl=$sce.trustAsResourceUrl('https://online.ulbharyana.gov.in/eforms/HepcLinkPage1.aspx?projectid='+vm.projectid+'&serviceid=1c90c949-f2d1-4997-84b0-e6b2d40fe5e6');
        vm.resourceurl_ffs=$sce.trustAsResourceUrl('https://online.ulbharyana.gov.in/eforms/HepcLinkPage1.aspx?projectid='+vm.projectid+'&serviceid=2c520622-d89a-42a1-ae85-efa54ee3630f');
        vm.resourceurl_twc=$sce.trustAsResourceUrl('https://online.ulbharyana.gov.in/eforms/HepcLinkPage1.aspx?projectid='+vm.projectid+'&serviceid=c5baea92-079d-44d3-9980-8b7d7d568f98');
        vm.resourceurl_ulbOC=$sce.trustAsResourceUrl('https://online.ulbharyana.gov.in/eforms/HepcLinkPage1.aspx?projectid='+vm.projectid+'&serviceid=9d063f53-5e50-4b05-b543-bfa0fcb6da58');


        // console.log(vm.projectid);

        loadAll();

        function loadAll() {
            ConstructionPermitApproval.query({projectId: $stateParams.id},function (result) {
                vm.constructionPermit= result;
            })
        }

        // vm.viewLog = function (serviceId) {
        //     ConstructionPermitLog.query({projectId: vm.projectid,serviceId: serviceId},function (result) {
        //
        //     })
        // };

        vm.saveDepartment = function (type) {
            vm.constructionPermit.bPflag=true;
            vm.constructionPermit.projectId=$stateParams.id;
            // if(type==='huda'){
            //     vm.constructionPermit.serviceId='43575ec0-7dd3-40bd-b3c4-47638d17bf3c';
            // }
            if(type==='hsidc'){
                vm.constructionPermit.serviceId='a69786f5-c674-4de9-8807-8689c7ef86b5';
            }
            else if(type==='tcp'){
                vm.constructionPermit.serviceId='159a0331-87c3-407d-9c6c-559455d4b6ab';
            }
            else if(type==='ulb'){
                vm.constructionPermit.serviceId='1c90c949-f2d1-4997-84b0-e6b2d40fe5e6';
            }
            // else if(type==='labour'){
            //     vm.constructionPermit.serviceId='ead00143-65ac-415b-8ebd-7f3d44fdfe34';
            // }
            vm.constructionPermit.serviceIdEC= vm.projectid;
            vm.constructionPermitLog.serviceid= vm.constructionPermit.serviceId;
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onFirstSaveSuccess);
        };

        vm.saveDepartmenthuda= function () {
            vm.constructionPermit.bPflag=true;
            vm.constructionPermit.projectId=$stateParams.id;
            vm.constructionPermit.serviceIdEC= vm.projectid;
            vm.constructionPermit.serviceId='43575ec0-7dd3-40bd-b3c4-47638d17bf3c';
            vm.constructionPermitLog.serviceid= vm.constructionPermit.serviceId;
            HudaForm.save(vm.hudaForm, onhudaSaveSuccess);
        };

        function onhudaSaveSuccess() {
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onFirstSaveSuccess);
        }

        vm.saveLabour = function () {
            vm.constructionPermit.bPflag=true;
            vm.constructionPermit.projectId=$stateParams.id;
            vm.constructionPermit.serviceIdEC= vm.projectid;
            vm.constructionPermit.serviceId='ead00143-65ac-415b-8ebd-7f3d44fdfe34';
            vm.constructionPermitLog.serviceid= vm.constructionPermit.serviceId;
            FactotyPlan.save(vm.factotyPlan, onFactoryPlanSaveSuccess);
        };

        function onFactoryPlanSaveSuccess() {
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onFirstSaveSuccess);
        }

        vm.saveffs= function () {
            // console.log(vm.constructionPermit);
            vm.constructionPermit.fFSflag=true;
            vm.constructionPermit.nMAflag=true;
            vm.constructionPermit.aAIflag=true;
            vm.constructionPermitLog.serviceid= '2c520622-d89a-42a1-ae85-efa54ee3630f';
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onFirstSaveSuccess);
        };

        vm.saveTWC= function () {
            vm.constructionPermit.tWCflag=true;
            vm.constructionPermitLog.serviceid= 'c5baea92-079d-44d3-9980-8b7d7d568f98';
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onFirstSaveSuccess);
        };

        vm.saveTEC= function () {
            vm.constructionPermit.tECflag=true;
            vm.constructionPermitLog.serviceid= $stateParams.deptID;
            vm.constructionPermit.tECid= $stateParams.deptID;
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onFirstSaveSuccess);
            alert("You have successfully applied for Phase - 1 services");
        };

        vm.fireNOC= function () {
            console.log("called");
            vm.constructionPermit.oCflag=true;
            // vm.constructionPermitLog.serviceid= '2c520622-d89a-42a1-ae85-efa54ee3630f';
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onFirstSaveSuccess);
        };

        vm.saveOC= function (id) {
            vm.constructionPermitLog.serviceid= id;
            if(id==='9b8f4307-4f88-4821-aec7-2dd2668041ab'){
                HudaformOc.save(vm.hudaformOc,onOCsaveSuccess);
            }
            else {
                onOCsaveSuccess();
            }
        };

        function onOCsaveSuccess () {
            ConstructionPermitApprovalSteps.update(vm.constructionPermit,onFirstSaveSuccess);
        };

        function onFirstSaveSuccess() {
            vm.constructionPermitLog.action="Form Submitted";
            vm.constructionPermitLog.projectid= vm.projectid;
            ConstructionPermitLog.save(vm.constructionPermitLog,onSecondSaveSuccess)
        }

        function onSecondSaveSuccess() {
            vm.constructionPermitLog.action="Service Under Process";
            ConstructionPermitLog.save(vm.constructionPermitLog,onSaveSuccess)
        }

        function onSaveSuccess(result) {
            $rootScope.$broadcast("investhry: constructionPermitEvent");
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('aaiDetailPageController', aaiDetailPageController);

    aaiDetailPageController.$inject = ['$stateParams', 'Aai_service'];

    function aaiDetailPageController ($stateParams, Aai_service ) {
        var vm = this;

        vm.aai={};

        loadAll();

        function loadAll() {
            Aai_service.get({id: $stateParams.aaiId},function (result) {
                vm.aai=result;
            })
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('investhryApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils($filter) {

        var service = {
            convertDateTimeFromServer: convertDateTimeFromServer,
            convertLocalDateFromServer: convertLocalDateFromServer,
            convertLocalDateToServer: convertLocalDateToServer,
            dateformat: dateformat
        };

        return service;

        function convertDateTimeFromServer(date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer(date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer(date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat() {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('investhryApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('LoginService', LoginService);

    LoginService.$inject = ['$uibModal'];

    function LoginService ($uibModal) {
        var service = {
            open: open
        };

        var modalInstance = null;
        var resetModal = function () {
            modalInstance = null;
        };

        return service;

        function open () {
            if (modalInstance !== null) return;
            modalInstance = $uibModal.open({
                animation: true,
                templateUrl: 'app/components/login/login.html',
                controller: 'LoginController',
                controllerAs: 'vm',
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }]
                }
            });
            modalInstance.result.then(
                resetModal,
                resetModal
            );
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', '$uibModalInstance','Principal','CheckContent'];

    function LoginController($rootScope, $state, $timeout, Auth, $uibModalInstance, Principal, CheckContent) {
        var vm = this;
        vm.authenticationError = false;
        vm.cancel = cancel;
        vm.credentials = {};
        vm.roles = [];
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.captchaInput = '';
        vm.captchaError = false;
        vm.captchaCode = '';
        vm.refreshCaptcha = generateCaptcha;

        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});

        $timeout(function () {
            angular.element('#username').focus();
            generateCaptcha(); // Generate CAPTCHA on load
        });

        function cancel() {
            vm.credentials = {
                username: null,
                password: null,
                rememberMe: true
            };
            vm.authenticationError = false;
            $uibModalInstance.dismiss('cancel');
        }

        function login(event) {
            event.preventDefault();
            if (vm.captchaInput !== vm.captchaCode) {
                vm.captchaError = true;
                vm.refreshCaptcha(); // Refresh CAPTCHA on incorrect input
                return;
            } else {
                vm.captchaError = false;
            }

            var encPassword = encryptPassword(vm.password);
            Auth.login({
                username: vm.username,
                password: encPassword,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $uibModalInstance.close();
                if ($state.current.name === 'register' || $state.current.name === 'activate' ||
                    $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                    $state.go('home');
                }
                getCurrentRole();
                $rootScope.$broadcast('authenticationSuccess');
                if (Auth.getPreviousState()) {
                    var previousState = Auth.getPreviousState();
                    Auth.resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }
            }).catch(function () {
                vm.authenticationError = true;
            });
        }

        function register() {
            $uibModalInstance.dismiss('cancel');
            $state.go('register');
        }

        function requestResetPassword() {
            $uibModalInstance.dismiss('cancel');
            $state.go('requestReset');
        }

        function getCurrentRole(){
            Principal.identity().then(function(account){
                if (account.authorities.indexOf('ROLE_USER') > -1 && (account.authorities.indexOf('ROLE_ADMIN') < 0 || account.authorities.indexOf('ROLE_SUB_ADMIN') < 0)) {
                    $state.go('listproject', {}, { reload: true });
                } else if (account.authorities.indexOf('ROLE_NODAL_OFFICER') > -1) {
                    $state.go("nodalofficerviewprojectdetail", {status: 'Pending'}, { reload: true });
                } else if (account.authorities.indexOf('ROLE_TOWER_DC') > -1) {
                    $state.go("projects", {}, { reload: true });
                } else {
                    $state.go('home', {}, { reload: true });
                }
            });
        }

        vm.handleApplyNow = function (event) {
            // Close the login popup
            $uibModalInstance.dismiss('cancel');
            // Allow form submission to proceed
        };

        function encryptPassword(plainString) {
            var iv = "a407e444cd6179be5ced97caf0ff11cb";
            var salt = "a826254e90f626b011eb21aca9a79b65";
            var keySize = 128;
            var iterationCount = 10000;
            var passPhrase = "NAimIodPNkqOyHQXmEpoFA==Sdty=jHY";
            var aesUtil = new AesUtil(keySize, iterationCount);
            var encryptedString = aesUtil.encrypt(salt, iv, passPhrase, plainString);
            return encryptedString;
        }

        // Function to generate a random CAPTCHA code with at least one uppercase, one lowercase letter, and one number
        function generateCaptcha() {
            var canvas = document.getElementById('captchaCanvas');
            var ctx = canvas.getContext('2d');
            ctx.fillStyle = '#000000';
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Helper function to get random uppercase letter, lowercase letter, or digit
            function getRandomUppercaseLetter() {
                return String.fromCharCode(Math.floor(Math.random() * 26) + 65); // A-Z
            }

            function getRandomLowercaseLetter() {
                return String.fromCharCode(Math.floor(Math.random() * 26) + 97); // a-z
            }

            function getRandomDigit() {
                return String.fromCharCode(Math.floor(Math.random() * 10) + 48); // 0-9
            }

            // Generate a CAPTCHA code with at least one uppercase, one lowercase, and one digit
            var captchaArray = [];
            captchaArray.push(getRandomUppercaseLetter()); // Add one uppercase letter
            captchaArray.push(getRandomLowercaseLetter()); // Add one lowercase letter
            captchaArray.push(getRandomDigit());           // Add one digit

            // Fill the rest (3 characters) with random letters (upper/lower) or numbers
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            for (var i = 0; i < 3; i++) {
                var randomChar = characters.charAt(Math.floor(Math.random() * characters.length));
                captchaArray.push(randomChar);
            }

            // Shuffle the array to randomize the order
            for (var i = captchaArray.length - 1; i > 0; i--) {
                var j = Math.floor(Math.random() * (i + 1));
                var temp = captchaArray[i];
                captchaArray[i] = captchaArray[j];
                captchaArray[j] = temp;
            }

            // Convert array to string
            vm.captchaCode = captchaArray.join('');

            // Add random lines for distortion
            for (var i = 0; i < 10; i++) {
                var opacity = Math.random(); // Random opacity
                ctx.strokeStyle = 'rgba(255, 255, 255, ' + opacity + ')';
                ctx.lineWidth = Math.random() * 2;
                ctx.beginPath();
                ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
                ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
                ctx.stroke();
            }

            // Add background noise (dots)
            for (var i = 0; i < 100; i++) {
                var dotOpacity = Math.random(); // Random opacity for dots
                ctx.fillStyle = 'rgba(255, 255, 255, ' + dotOpacity + ')';
                ctx.beginPath();
                ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, Math.random() * 2, 0, Math.PI * 2);
                ctx.fill();
            }

            // Draw CAPTCHA text with a distorted effect
            ctx.font = 'bold 30px Arial';
            ctx.fillStyle = '#FFFFFF'; // White text color
            ctx.shadowColor = 'rgba(0, 0, 0, 0.5)'; // Black shadow with some transparency
            ctx.shadowBlur = 4; // Increase blur size as needed
            ctx.setTransform(1, 0, 0, 1, 0, 0);
            ctx.fillText(vm.captchaCode, 25, 40); // Position text in canvas
        }

        vm.close = function close() {
            alert("dd");
            window.location.reload();
        };


    }
})();


var AesUtil = function(keySize, iterationCount) {
  this.keySize = keySize / 32;
  this.iterationCount = iterationCount;
};

AesUtil.prototype.generateKey = function(salt, passPhrase) {
  var key = CryptoJS.PBKDF2(
      passPhrase,
      CryptoJS.enc.Hex.parse(salt),
      { keySize: this.keySize, iterations: this.iterationCount });
  return key;
}

AesUtil.prototype.encrypt = function(salt, iv, passPhrase, plainText) {
  var key = this.generateKey(salt, passPhrase);
  var encrypted = CryptoJS.AES.encrypt(
      plainText,
      key,
      { iv: CryptoJS.enc.Hex.parse(iv) });
  return encrypted.ciphertext.toString(CryptoJS.enc.Base64);
}

AesUtil.prototype.decrypt = function(salt, iv, passPhrase, cipherText) {
  var key = this.generateKey(salt, passPhrase);
  var cipherParams = CryptoJS.lib.CipherParams.create({
    ciphertext: CryptoJS.enc.Base64.parse(cipherText)
  });
  var decrypted = CryptoJS.AES.decrypt(
      cipherParams,
      key,
      { iv: CryptoJS.enc.Hex.parse(iv) });
  return decrypted.toString(CryptoJS.enc.Utf8);
}

/*
CryptoJS v3.0.2
code.google.com/p/crypto-js
(c) 2009-2012 by Jeff Mott. All rights reserved.
code.google.com/p/crypto-js/wiki/License
*/
var CryptoJS=CryptoJS||function(p,h){var i={},l=i.lib={},r=l.Base=function(){function a(){}return{extend:function(e){a.prototype=this;var c=new a;e&&c.mixIn(e);c.$super=this;return c},create:function(){var a=this.extend();a.init.apply(a,arguments);return a},init:function(){},mixIn:function(a){for(var c in a)a.hasOwnProperty(c)&&(this[c]=a[c]);a.hasOwnProperty("toString")&&(this.toString=a.toString)},clone:function(){return this.$super.extend(this)}}}(),o=l.WordArray=r.extend({init:function(a,e){a=
this.words=a||[];this.sigBytes=e!=h?e:4*a.length},toString:function(a){return(a||s).stringify(this)},concat:function(a){var e=this.words,c=a.words,b=this.sigBytes,a=a.sigBytes;this.clamp();if(b%4)for(var d=0;d<a;d++)e[b+d>>>2]|=(c[d>>>2]>>>24-8*(d%4)&255)<<24-8*((b+d)%4);else if(65535<c.length)for(d=0;d<a;d+=4)e[b+d>>>2]=c[d>>>2];else e.push.apply(e,c);this.sigBytes+=a;return this},clamp:function(){var a=this.words,e=this.sigBytes;a[e>>>2]&=4294967295<<32-8*(e%4);a.length=p.ceil(e/4)},clone:function(){var a=
r.clone.call(this);a.words=this.words.slice(0);return a},random:function(a){for(var e=[],c=0;c<a;c+=4)e.push(4294967296*p.random()|0);return o.create(e,a)}}),m=i.enc={},s=m.Hex={stringify:function(a){for(var e=a.words,a=a.sigBytes,c=[],b=0;b<a;b++){var d=e[b>>>2]>>>24-8*(b%4)&255;c.push((d>>>4).toString(16));c.push((d&15).toString(16))}return c.join("")},parse:function(a){for(var e=a.length,c=[],b=0;b<e;b+=2)c[b>>>3]|=parseInt(a.substr(b,2),16)<<24-4*(b%8);return o.create(c,e/2)}},n=m.Latin1={stringify:function(a){for(var e=
a.words,a=a.sigBytes,c=[],b=0;b<a;b++)c.push(String.fromCharCode(e[b>>>2]>>>24-8*(b%4)&255));return c.join("")},parse:function(a){for(var e=a.length,c=[],b=0;b<e;b++)c[b>>>2]|=(a.charCodeAt(b)&255)<<24-8*(b%4);return o.create(c,e)}},k=m.Utf8={stringify:function(a){try{return decodeURIComponent(escape(n.stringify(a)))}catch(e){throw Error("Malformed UTF-8 data");}},parse:function(a){return n.parse(unescape(encodeURIComponent(a)))}},f=l.BufferedBlockAlgorithm=r.extend({reset:function(){this._data=o.create();
this._nDataBytes=0},_append:function(a){"string"==typeof a&&(a=k.parse(a));this._data.concat(a);this._nDataBytes+=a.sigBytes},_process:function(a){var e=this._data,c=e.words,b=e.sigBytes,d=this.blockSize,q=b/(4*d),q=a?p.ceil(q):p.max((q|0)-this._minBufferSize,0),a=q*d,b=p.min(4*a,b);if(a){for(var j=0;j<a;j+=d)this._doProcessBlock(c,j);j=c.splice(0,a);e.sigBytes-=b}return o.create(j,b)},clone:function(){var a=r.clone.call(this);a._data=this._data.clone();return a},_minBufferSize:0});l.Hasher=f.extend({init:function(){this.reset()},
reset:function(){f.reset.call(this);this._doReset()},update:function(a){this._append(a);this._process();return this},finalize:function(a){a&&this._append(a);this._doFinalize();return this._hash},clone:function(){var a=f.clone.call(this);a._hash=this._hash.clone();return a},blockSize:16,_createHelper:function(a){return function(e,c){return a.create(c).finalize(e)}},_createHmacHelper:function(a){return function(e,c){return g.HMAC.create(a,c).finalize(e)}}});var g=i.algo={};return i}(Math);
(function(){var p=CryptoJS,h=p.lib.WordArray;p.enc.Base64={stringify:function(i){var l=i.words,h=i.sigBytes,o=this._map;i.clamp();for(var i=[],m=0;m<h;m+=3)for(var s=(l[m>>>2]>>>24-8*(m%4)&255)<<16|(l[m+1>>>2]>>>24-8*((m+1)%4)&255)<<8|l[m+2>>>2]>>>24-8*((m+2)%4)&255,n=0;4>n&&m+0.75*n<h;n++)i.push(o.charAt(s>>>6*(3-n)&63));if(l=o.charAt(64))for(;i.length%4;)i.push(l);return i.join("")},parse:function(i){var i=i.replace(/\s/g,""),l=i.length,r=this._map,o=r.charAt(64);o&&(o=i.indexOf(o),-1!=o&&(l=o));
for(var o=[],m=0,s=0;s<l;s++)if(s%4){var n=r.indexOf(i.charAt(s-1))<<2*(s%4),k=r.indexOf(i.charAt(s))>>>6-2*(s%4);o[m>>>2]|=(n|k)<<24-8*(m%4);m++}return h.create(o,m)},_map:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/="}})();
(function(p){function h(f,g,a,e,c,b,d){f=f+(g&a|~g&e)+c+d;return(f<<b|f>>>32-b)+g}function i(f,g,a,e,c,b,d){f=f+(g&e|a&~e)+c+d;return(f<<b|f>>>32-b)+g}function l(f,g,a,e,c,b,d){f=f+(g^a^e)+c+d;return(f<<b|f>>>32-b)+g}function r(f,g,a,e,c,b,d){f=f+(a^(g|~e))+c+d;return(f<<b|f>>>32-b)+g}var o=CryptoJS,m=o.lib,s=m.WordArray,m=m.Hasher,n=o.algo,k=[];(function(){for(var f=0;64>f;f++)k[f]=4294967296*p.abs(p.sin(f+1))|0})();n=n.MD5=m.extend({_doReset:function(){this._hash=s.create([1732584193,4023233417,
2562383102,271733878])},_doProcessBlock:function(f,g){for(var a=0;16>a;a++){var e=g+a,c=f[e];f[e]=(c<<8|c>>>24)&16711935|(c<<24|c>>>8)&4278255360}for(var e=this._hash.words,c=e[0],b=e[1],d=e[2],q=e[3],a=0;64>a;a+=4)16>a?(c=h(c,b,d,q,f[g+a],7,k[a]),q=h(q,c,b,d,f[g+a+1],12,k[a+1]),d=h(d,q,c,b,f[g+a+2],17,k[a+2]),b=h(b,d,q,c,f[g+a+3],22,k[a+3])):32>a?(c=i(c,b,d,q,f[g+(a+1)%16],5,k[a]),q=i(q,c,b,d,f[g+(a+6)%16],9,k[a+1]),d=i(d,q,c,b,f[g+(a+11)%16],14,k[a+2]),b=i(b,d,q,c,f[g+a%16],20,k[a+3])):48>a?(c=
l(c,b,d,q,f[g+(3*a+5)%16],4,k[a]),q=l(q,c,b,d,f[g+(3*a+8)%16],11,k[a+1]),d=l(d,q,c,b,f[g+(3*a+11)%16],16,k[a+2]),b=l(b,d,q,c,f[g+(3*a+14)%16],23,k[a+3])):(c=r(c,b,d,q,f[g+3*a%16],6,k[a]),q=r(q,c,b,d,f[g+(3*a+7)%16],10,k[a+1]),d=r(d,q,c,b,f[g+(3*a+14)%16],15,k[a+2]),b=r(b,d,q,c,f[g+(3*a+5)%16],21,k[a+3]));e[0]=e[0]+c|0;e[1]=e[1]+b|0;e[2]=e[2]+d|0;e[3]=e[3]+q|0},_doFinalize:function(){var f=this._data,g=f.words,a=8*this._nDataBytes,e=8*f.sigBytes;g[e>>>5]|=128<<24-e%32;g[(e+64>>>9<<4)+14]=(a<<8|a>>>
24)&16711935|(a<<24|a>>>8)&4278255360;f.sigBytes=4*(g.length+1);this._process();f=this._hash.words;for(g=0;4>g;g++)a=f[g],f[g]=(a<<8|a>>>24)&16711935|(a<<24|a>>>8)&4278255360}});o.MD5=m._createHelper(n);o.HmacMD5=m._createHmacHelper(n)})(Math);
(function(){var p=CryptoJS,h=p.lib,i=h.Base,l=h.WordArray,h=p.algo,r=h.EvpKDF=i.extend({cfg:i.extend({keySize:4,hasher:h.MD5,iterations:1}),init:function(i){this.cfg=this.cfg.extend(i)},compute:function(i,m){for(var h=this.cfg,n=h.hasher.create(),k=l.create(),f=k.words,g=h.keySize,h=h.iterations;f.length<g;){a&&n.update(a);var a=n.update(i).finalize(m);n.reset();for(var e=1;e<h;e++)a=n.finalize(a),n.reset();k.concat(a)}k.sigBytes=4*g;return k}});p.EvpKDF=function(i,l,h){return r.create(h).compute(i,
l)}})();
CryptoJS.lib.Cipher||function(p){var h=CryptoJS,i=h.lib,l=i.Base,r=i.WordArray,o=i.BufferedBlockAlgorithm,m=h.enc.Base64,s=h.algo.EvpKDF,n=i.Cipher=o.extend({cfg:l.extend(),createEncryptor:function(b,d){return this.create(this._ENC_XFORM_MODE,b,d)},createDecryptor:function(b,d){return this.create(this._DEC_XFORM_MODE,b,d)},init:function(b,d,a){this.cfg=this.cfg.extend(a);this._xformMode=b;this._key=d;this.reset()},reset:function(){o.reset.call(this);this._doReset()},process:function(b){this._append(b);return this._process()},
finalize:function(b){b&&this._append(b);return this._doFinalize()},keySize:4,ivSize:4,_ENC_XFORM_MODE:1,_DEC_XFORM_MODE:2,_createHelper:function(){return function(b){return{encrypt:function(a,q,j){return("string"==typeof q?c:e).encrypt(b,a,q,j)},decrypt:function(a,q,j){return("string"==typeof q?c:e).decrypt(b,a,q,j)}}}}()});i.StreamCipher=n.extend({_doFinalize:function(){return this._process(!0)},blockSize:1});var k=h.mode={},f=i.BlockCipherMode=l.extend({createEncryptor:function(b,a){return this.Encryptor.create(b,
a)},createDecryptor:function(b,a){return this.Decryptor.create(b,a)},init:function(b,a){this._cipher=b;this._iv=a}}),k=k.CBC=function(){function b(b,a,d){var c=this._iv;c?this._iv=p:c=this._prevBlock;for(var e=0;e<d;e++)b[a+e]^=c[e]}var a=f.extend();a.Encryptor=a.extend({processBlock:function(a,d){var c=this._cipher,e=c.blockSize;b.call(this,a,d,e);c.encryptBlock(a,d);this._prevBlock=a.slice(d,d+e)}});a.Decryptor=a.extend({processBlock:function(a,d){var c=this._cipher,e=c.blockSize,f=a.slice(d,d+
e);c.decryptBlock(a,d);b.call(this,a,d,e);this._prevBlock=f}});return a}(),g=(h.pad={}).Pkcs7={pad:function(b,a){for(var c=4*a,c=c-b.sigBytes%c,e=c<<24|c<<16|c<<8|c,f=[],g=0;g<c;g+=4)f.push(e);c=r.create(f,c);b.concat(c)},unpad:function(b){b.sigBytes-=b.words[b.sigBytes-1>>>2]&255}};i.BlockCipher=n.extend({cfg:n.cfg.extend({mode:k,padding:g}),reset:function(){n.reset.call(this);var b=this.cfg,a=b.iv,b=b.mode;if(this._xformMode==this._ENC_XFORM_MODE)var c=b.createEncryptor;else c=b.createDecryptor,
this._minBufferSize=1;this._mode=c.call(b,this,a&&a.words)},_doProcessBlock:function(b,a){this._mode.processBlock(b,a)},_doFinalize:function(){var b=this.cfg.padding;if(this._xformMode==this._ENC_XFORM_MODE){b.pad(this._data,this.blockSize);var a=this._process(!0)}else a=this._process(!0),b.unpad(a);return a},blockSize:4});var a=i.CipherParams=l.extend({init:function(a){this.mixIn(a)},toString:function(a){return(a||this.formatter).stringify(this)}}),k=(h.format={}).OpenSSL={stringify:function(a){var d=
a.ciphertext,a=a.salt,d=(a?r.create([1398893684,1701076831]).concat(a).concat(d):d).toString(m);return d=d.replace(/(.{64})/g,"$1\n")},parse:function(b){var b=m.parse(b),d=b.words;if(1398893684==d[0]&&1701076831==d[1]){var c=r.create(d.slice(2,4));d.splice(0,4);b.sigBytes-=16}return a.create({ciphertext:b,salt:c})}},e=i.SerializableCipher=l.extend({cfg:l.extend({format:k}),encrypt:function(b,d,c,e){var e=this.cfg.extend(e),f=b.createEncryptor(c,e),d=f.finalize(d),f=f.cfg;return a.create({ciphertext:d,
key:c,iv:f.iv,algorithm:b,mode:f.mode,padding:f.padding,blockSize:b.blockSize,formatter:e.format})},decrypt:function(a,c,e,f){f=this.cfg.extend(f);c=this._parse(c,f.format);return a.createDecryptor(e,f).finalize(c.ciphertext)},_parse:function(a,c){return"string"==typeof a?c.parse(a):a}}),h=(h.kdf={}).OpenSSL={compute:function(b,c,e,f){f||(f=r.random(8));b=s.create({keySize:c+e}).compute(b,f);e=r.create(b.words.slice(c),4*e);b.sigBytes=4*c;return a.create({key:b,iv:e,salt:f})}},c=i.PasswordBasedCipher=
e.extend({cfg:e.cfg.extend({kdf:h}),encrypt:function(a,c,f,j){j=this.cfg.extend(j);f=j.kdf.compute(f,a.keySize,a.ivSize);j.iv=f.iv;a=e.encrypt.call(this,a,c,f.key,j);a.mixIn(f);return a},decrypt:function(a,c,f,j){j=this.cfg.extend(j);c=this._parse(c,j.format);f=j.kdf.compute(f,a.keySize,a.ivSize,c.salt);j.iv=f.iv;return e.decrypt.call(this,a,c,f.key,j)}})}();
(function(){var p=CryptoJS,h=p.lib.BlockCipher,i=p.algo,l=[],r=[],o=[],m=[],s=[],n=[],k=[],f=[],g=[],a=[];(function(){for(var c=[],b=0;256>b;b++)c[b]=128>b?b<<1:b<<1^283;for(var d=0,e=0,b=0;256>b;b++){var j=e^e<<1^e<<2^e<<3^e<<4,j=j>>>8^j&255^99;l[d]=j;r[j]=d;var i=c[d],h=c[i],p=c[h],t=257*c[j]^16843008*j;o[d]=t<<24|t>>>8;m[d]=t<<16|t>>>16;s[d]=t<<8|t>>>24;n[d]=t;t=16843009*p^65537*h^257*i^16843008*d;k[j]=t<<24|t>>>8;f[j]=t<<16|t>>>16;g[j]=t<<8|t>>>24;a[j]=t;d?(d=i^c[c[c[p^i]]],e^=c[c[e]]):d=e=1}})();
var e=[0,1,2,4,8,16,32,64,128,27,54],i=i.AES=h.extend({_doReset:function(){for(var c=this._key,b=c.words,d=c.sigBytes/4,c=4*((this._nRounds=d+6)+1),i=this._keySchedule=[],j=0;j<c;j++)if(j<d)i[j]=b[j];else{var h=i[j-1];j%d?6<d&&4==j%d&&(h=l[h>>>24]<<24|l[h>>>16&255]<<16|l[h>>>8&255]<<8|l[h&255]):(h=h<<8|h>>>24,h=l[h>>>24]<<24|l[h>>>16&255]<<16|l[h>>>8&255]<<8|l[h&255],h^=e[j/d|0]<<24);i[j]=i[j-d]^h}b=this._invKeySchedule=[];for(d=0;d<c;d++)j=c-d,h=d%4?i[j]:i[j-4],b[d]=4>d||4>=j?h:k[l[h>>>24]]^f[l[h>>>
16&255]]^g[l[h>>>8&255]]^a[l[h&255]]},encryptBlock:function(a,b){this._doCryptBlock(a,b,this._keySchedule,o,m,s,n,l)},decryptBlock:function(c,b){var d=c[b+1];c[b+1]=c[b+3];c[b+3]=d;this._doCryptBlock(c,b,this._invKeySchedule,k,f,g,a,r);d=c[b+1];c[b+1]=c[b+3];c[b+3]=d},_doCryptBlock:function(a,b,d,e,f,h,i,g){for(var l=this._nRounds,k=a[b]^d[0],m=a[b+1]^d[1],o=a[b+2]^d[2],n=a[b+3]^d[3],p=4,r=1;r<l;r++)var s=e[k>>>24]^f[m>>>16&255]^h[o>>>8&255]^i[n&255]^d[p++],u=e[m>>>24]^f[o>>>16&255]^h[n>>>8&255]^
i[k&255]^d[p++],v=e[o>>>24]^f[n>>>16&255]^h[k>>>8&255]^i[m&255]^d[p++],n=e[n>>>24]^f[k>>>16&255]^h[m>>>8&255]^i[o&255]^d[p++],k=s,m=u,o=v;s=(g[k>>>24]<<24|g[m>>>16&255]<<16|g[o>>>8&255]<<8|g[n&255])^d[p++];u=(g[m>>>24]<<24|g[o>>>16&255]<<16|g[n>>>8&255]<<8|g[k&255])^d[p++];v=(g[o>>>24]<<24|g[n>>>16&255]<<16|g[k>>>8&255]<<8|g[m&255])^d[p++];n=(g[n>>>24]<<24|g[k>>>16&255]<<16|g[m>>>8&255]<<8|g[o&255])^d[p++];a[b]=s;a[b+1]=u;a[b+2]=v;a[b+3]=n},keySize:8});p.AES=h._createHelper(i)})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'hi'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('CheckContent', CheckContent);

    CheckContent.$inject = [];

    function CheckContent () {
        var service = {
            check: check
        };

        return service;

        function check (elem) {
            elem.bind("propertychange change click keyup input paste", function(){
                if(elem.val().includes('<script') || elem.val().includes('alert(') || elem.val().includes('.js') || elem.val().includes('.exe')
                    || elem.val().includes('.jar')
                    || elem.val().includes('bash') || elem.val().includes('./') || elem.val().includes('.tar.gz') || elem.val().includes('.deb')
                    || elem.val().includes('.rpm') || elem.val().includes('.ko') || elem.val().includes('.php') || elem.val().includes('.py')
                    || elem.val().includes('.tar'))
                {
                    elem.val('');
                    alert('Please insert relevant information');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('investhryApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('investhryApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('investhryApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('investhryApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('serviceFormController', serviceFormController);

    serviceFormController.$inject = ['$timeout','$scope','$stateParams','$uibModalInstance','projectService','projectServiceFormFieldData','projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','Projectserviceformfielddata','serviceFormFieldDataCollection','ServiceFormAttachments','DepartmentService','Serviceformdocs','downloadserviceformattachment','Project','CheckContent','NewHomeProjectServiceDetails'];
    function serviceFormController ($timeout, $scope, $stateParams, $uibModalInstance,projectService,projectServiceFormFieldData, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail, Projectserviceformfielddata,serviceFormFieldDataCollection,ServiceFormAttachments,DepartmentService,Serviceformdocs,downloadserviceformattachment, Project,CheckContent,NewHomeProjectServiceDetails) {
        var vm = this;
        vm.download_appendix = download_appendix;

        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectServiceFormFieldData=projectServiceFormFieldData;
        vm.projectService = projectService;
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        var formfielddataObjectArrayLength = 0;
        var formfieldCount = 0;
        var saveLogFlag = false;
        vm.clear = clear;
        vm.saveAsDraft=saveAsDraft;
        vm.saveFormFieldData = saveFormFieldData;
        vm.downloadFile=downloadFile;
        vm.isSavedDraft=false;
        var restorationByUserValue = null; // Global variable

        vm.doubleextension = true;
        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        show();


        function show(){
            switch (vm.projectService.serviceid) {
                case '58d75fd4-f360-4931-a484-ff9be0adc12c':
                    vm.show=true;
                    break;
                case '5f8e0757-e88b-4ef1-bb15-00a9e984b9b1':
                    vm.show=true;
                    break;
                case '741f0f60-cf69-4659-8b19-19d96ffe0103':
                    vm.show=true;
                    break;
                case 'fc1b1635-d3dc-4d30-a5fd-5abf6381594d':
                    vm.show=true;
                    break;
                case '6f81801c-59c6-4773-9f37-a5d81172a1bf':
                    vm.show=true;
                    break;
                default:
                    vm.show=false;
            }
        }

        function download_appendix() {
            downloadserviceformattachment.download('Appendix7.docx','Appendix7.docx');
        }

        function clear()
        {
            $uibModalInstance.dismiss('cancel');
        }

        vm.departmentservice= DepartmentService.get({id:vm.projectService.serviceid});
        Serviceformdocs.query({id:"1",serviceid:vm.projectService.serviceid},function(result) {
            vm.serviceformdocs = result;
            vm.searchQuery = null;
        });

        Project.get({ id : vm.projectService.projectid }, function(result){
            vm.project = result;
        });


        loadServiceFormFields();
        function loadServiceFormFields() {
            vm.serviceFormFieldData = serviceFormFieldDataCollection.query({serviceid:vm.projectService.serviceid, projectid:vm.projectService.projectid});
        }

        var combineFilledForm="";
        function saveFormFieldData()
        {
            vm.isSaving = true;
            var vmlength = vm.serviceFormFieldData.length;
            formfielddataObjectArrayLength = vmlength;
            for(var i= 0; i<vmlength;i++)
            {
                var data = vm.serviceFormFieldData[i];
                combineFilledForm=combineFilledForm + vm.serviceFormFieldData[i].formfieldvalue+" | ";
                data.projectid = vm.projectService.projectid;

                // for (var key in data) {
                //     if (data.hasOwnProperty(key) && data[key] !== null && data[key] !== undefined) {
                //         var fieldInfo = key + ': ' + data[key];
                //         alert(fieldInfo); // This will show each field name and value
                //         combineFilledForm += fieldInfo + ' | ';
                //     }
                // }


                
                if (data.serviceid === "5f8e0757-e88b-4ef1-bb15-00a9e984b9b1"){
                    if (data.formfieldName === "Who will restore?"){
                        restorationByUserValue = data.formfieldvalue;

                    }
                } 


                if (data.id !== null)
                {
                    Projectserviceformfielddata.update(data, onSaveServiceFormFieldDataSuccess, onSaveServiceFormFieldDataError);
                } else
                {
                    Projectserviceformfielddata.save(data, onSaveServiceFormFieldDataSuccess, onSaveServiceFormFieldDataError);
                }
                formfieldCount = i;
            }
            for( var j = 0; j < vm.fileattach.length; j++ ) {
                if(vm.fileattach[j].isSaved===false)
                {
                    vm.fileattach[j].isSaved=true;
                }
                ServiceFormAttachments.update(vm.fileattach[j],onUpdatefieldServiceFormAttachmentsSuccess);
            }
        }
        function onUpdatefieldServiceFormAttachmentsSuccess()
        {}
        vm.fileattach = ServiceFormAttachments.query({id:"1", projectid:vm.projectService.projectid, serviceid:vm.projectService.serviceid});
        vm.addfileattachment=addfileattachment;

        function addfileattachment()
        {
            if (angular.isDefined(vm.serviceformfile.name)) {
                var fileNameArray = vm.serviceformfile.name.split(".");
                var fileextension = "";

                if ((fileNameArray.length < 3)) {
                    if (fileNameArray[0] != "") {
                        if ((fileNameArray.length > 1)) {
                            fileextension = fileNameArray[(fileNameArray.length - 1)];
                        }
                        var inputFileName = vm.serviceformattachment.description;
                        if (fileextension !== "") {
                            inputFileName = inputFileName + "." + fileextension;
                        }

                        vm.serviceformattachment.isSaved = false;
                        vm.serviceformattachment.downloadfilename = inputFileName;
                        vm.serviceformattachment.clientfilename = vm.serviceformfile.name;
                        vm.serviceformattachment.projectID = vm.projectService.projectid;
                        vm.serviceformattachment.serviceID = vm.projectService.serviceid;
                        ServiceFormAttachments.save(vm.serviceformattachment, onSaveServiceFormAttachmentsSuccess);

                    }
                    else {
                        alert("Invalid File Name");
                    }

                }
                else {
                    alert("Please select correct file format");
                    vm.doubleextension = false;

                }
            }
            else {
                alert("Please Select a file first");
            }
        }


        function onSaveServiceFormAttachmentsSuccess (result)
        {
            var filename = result.id;
            var file =vm.serviceformfile;
            FileManagement.saveFile(file,filename);
            var fileNameArray = vm.serviceformfile.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            result.serverfilename=inputFileName;
            ServiceFormAttachments.update(result,onUpdateServiceFormAttachmentsSuccess);

        }
        function onUpdateServiceFormAttachmentsSuccess(result)
        {

            vm.fileattach.push(result);
            vm.fileattachment={};
            vm.serviceformattachment.description="";
            $('#browsefile').val('');
            vm.serviceformfile = {};

        }
        vm.removeRawRow = function(id)
        {
            ServiceFormAttachments.delete({id: id});
            var index = -1;
            var comArray =eval(vm.fileattach);
            for( var i = 0; i < comArray.length; i++ )
            {
                if( comArray[i].id=== id)
                {
                    index = i;
                    break;
                }
            }
            vm.fileattach.splice( index, 1 );
        }
        function onSaveServiceFormFieldDataSuccess(result)
        {
            if(!saveLogFlag)
            {
                if(formfieldCount === (formfielddataObjectArrayLength-1))
                {
                    saveProjectServiceLog();
                    saveLogFlag = true;
                }
            }
        }
        function onSaveServiceFormFieldDataError()
        {}
        function saveProjectServiceLog(result){
            if (vm.isSavedDraft===true){
                $uibModalInstance.close(result);
                vm.isSaving = false;
                return;
            }
            $scope.$emit('investhryApp:projectserviceformfielddataUpdate', result);
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.comments=vm.projectServiceLog.comments + " | " +combineFilledForm;
            vm.projectServiceLog.actionTaken="ServiceFormEdited";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            // for (var key in result) {
            //     if (result.hasOwnProperty(key)) {
            //         alert(key + ' : ' + result[key]);
            //     }
            // }
            vm.projectService.latestComments="Service form edited";
            vm.projectService.formFilledStatus=true;
            // Says that this update is the submit of the form itself - the server issues
            // the acknowledgement of an intimated tower on it, and on nothing else.
            vm.projectService.serviceFormSubmitted=true;
            vm.projectService.restorationByUser=restorationByUserValue;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            NewHomeProjectServiceDetails.query({projectServiceDetailId: vm.projectService.id, projectId: vm.projectService.projectid, serviceId: vm.projectService.serviceid}, function () {
                console.log('success');
            }, function (error) {
                console.log(error);
            });
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Service Form Field Data Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function onUpdateProjectAttachmentSuccess(result)
        {
            $uibModalInstance.close(result);
        }
        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function downloadFile(serverfilename,downloadfilename)
        {
            downloadserviceformattachment.download(serverfilename,downloadfilename)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }

        function saveAsDraft() {
            vm.isSavedDraft=true;
            saveFormFieldData();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider




            .state('complianceprojectdetaillist', {
                parent: 'app',
                url: '/complianceprojectdetaillist/{projectid}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/complianceprojectdetaillist/complianceprojectdetaillist.html',
                        controller: 'complianceProjectDetailListController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    projectServiceReportInfo: function () {
                        return {
                            projectid: null,
                            projecttype: null,
                            departmentname: null,
                            servicename: null,
                            assignDate: null,
                            requireDate: null,
                            status: null,
                            stage: null,
                            investorName: null,
                            cafPin: null,
                            finalAction: null,
                            finalActionDate: null,
                            projectInvestment: null,
                            projectEmployment: null,
                            id: null
                        };
                    },
                    projectServiceLog: function () {
                        return {
                            projectid: null,
                            serviceid: null,
                            comments: null,
                            commentDate: null,
                            commentByUserLogin: null,
                            actionTaken: null,
                            id: null
                        };
                    },
                    projectservicelist: ['$stateParams', 'ProjectservicedetailbyProject', function($stateParams, ProjectservicedetailbyProject) {
                        return ProjectservicedetailbyProject.get({id : $stateParams.projectid, status:"inProcess"});
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('home');
                        return $translate.refresh();
                    }]
                }
            })

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('complianceProjectDetailListController', complianceProjectDetailListController);

    complianceProjectDetailListController.$inject = ['$scope', '$stateParams','$state','projectServiceReportInfo', 'Projectcompletedetail', 'Auth', 'Principal', 'DepartmentService', 'Projectservicedetail','ProjectServiceReportInfoForClearance','projectservicelist','projectServiceLog','ProjectServiceLogUpdated','ProjectservicedetailbyProject','Department', 'TowerserviceNO', 'Project', '$sce','Municipals','GetServiceLog','downloadService','DownloadExternalServiceFiles'];

    function complianceProjectDetailListController ($scope, $stateParams, $state, projectServiceReportInfo, Projectcompletedetail, Auth, Principal, DepartmentService, Projectservicedetail,ProjectServiceReportInfoForClearance,projectservicelist,projectServiceLog,ProjectServiceLogUpdated,ProjectservicedetailbyProject,Department, TowerserviceNO, Project, $sce,Municipals,GetServiceLog,downloadService,DownloadExternalServiceFiles) {
        var vm = this;
        vm.projectid = $stateParams.projectid;
        vm.district = $stateParams.district;
        vm.GetServiceLog=GetServiceLog;
        vm.title = "Service Clearances in Process";
        vm.statusOnPage = 'All';
        vm.selectedprojectservice = {};
        vm.towerserviceNO = {};
        vm.isDeskof = false;

        vm.constructionpermits=[{id:'PRE',name:'Pre Establishment'},{id:'POST',name:'Post Establishment'}];
        vm.loadProjectServices = loadProjectServices;

        vm.projectservicelist = projectservicelist;

        vm.formStatus = true;

        vm.goToServiceDetail = goToServiceDetail;



        vm.municipals = [];
        $scope.requiredMunicipal = [];
        vm.caftype = '';


        function statusChange (status){
            if(status ==="All") {
                status="";
            }
            vm.formStatus =true;
           vm.statusFilter =status;
           if(status===""){
            vm.formStatus= "";
           }
            if(status === "Required"){
                vm.statusFilter = "Pending";
                vm.formStatus = false;
            }

        }

        vm.loadServiceLogs = function(projectid, serviceid) {
            return new Promise(function(resolve, reject) {
                // Call GetServiceLog API
                vm.GetServiceLog.query({ projectid: projectid, serviceid: serviceid }, function(result) {
                    console.log("Service logs: ", result);

                    // Initialize variables
                    var latestCommentDate = new Date(0); // Start with the earliest possible date
                    var latestFileName = null;
                    var latestReApplyCounter = null;
                    var latestActionTaken = null;

                    // Iterate through the result to find the latest fileName
                    result.forEach(function(log) {
                        if (log.fileName && new Date(log.commentDate) > latestCommentDate) {
                            latestCommentDate = new Date(log.commentDate);
                            latestFileName = log.fileName;
                            latestReApplyCounter = log.reApplyCounter;
                            latestActionTaken = log.actionTaken;
                        }
                    });

                    console.log("Latest file name: ", latestFileName);
                    console.log("Latest reApplyCounter: ", latestReApplyCounter);
                    console.log("Latest action taken: ", latestActionTaken);

                    // Store the result in a variable to be used in the view
                    vm.latestLogDetails = {
                        fileName: latestFileName,
                        reApplyCounter: latestReApplyCounter,
                        actionTaken: latestActionTaken
                    };

                    // Resolve the promise with the data
                    resolve(vm.latestLogDetails);
                }, function(error) {
                    console.log("Error loading service logs: ", error);
                    // Reject the promise in case of error
                    reject(error);
                });
            });
        };


        vm.handleButtonClick = function(projectservice) {
            // Call loadServiceLogs method
            vm.loadServiceLogs(projectservice.projectid, projectservice.serviceid).then(function(latestLogDetails) {
                // After loading service logs, check projectservice.isIntegrated and call other methods
                if (projectservice.isIntegrated) {
                    // Call method if isIntegrated is true, passing the latestLogDetails
                    downloadExt(projectservice.projectid, projectservice.serviceid,latestLogDetails.reApplyCounter);
                } else {
                    // Call method if isIntegrated is false, passing the latestLogDetails
                    downloadHEPC(latestLogDetails.fileName);
                }
            }).catch(function(error) {
                console.log("Error handling button click: ", error);
            });
        };


        function downloadHEPC(fileName) {
            downloadService.download(fileName)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }


        loadProjectServices("");

        function loadProjectServices(status)
        {

             vm.department='all';
             vm.constructionpermit='all';

            // Fetching the project service list
            vm.projectservicelist = ProjectservicedetailbyProject.get({ id: vm.projectid, status: "inProcess" }, function (result) {
                // Accessing the projectservicedetailDTOS array
                var serviceDetails = result.projectservicedetailDTOS;

                // Filtering the services where status is "Cleared"
                vm.projectservicelist = serviceDetails.filter(function(service) {

                    return service.status === "Cleared";
                });

                // Optional: If you still need a copy in tempDataHandler
                vm.tempDataHandler = angular.copy(vm.projectservicelist);

                console.log("Filtered Cleared Services: ", vm.projectservicelist);
            });
            if(status =="required")
                vm.title = "Service Required";
            else
                vm.title = "Service Clearances in Process";
        }


        function goToServiceDetail(projectid,serviceid,status,reApplyCounter) {
            downloadExt(projectid,serviceid,reApplyCounter);


        }

        function downloadHEPC(fileName) {
            downloadService.download(fileName)
                .then(function(success) {
                    console.log('success : ' + success);
                }, function(error) {
                    console.log('error : ' + error);
                });
        }

        function downloadExt(projectid,serviceid,reApplyCounter) {

            DepartmentService.get({id:serviceid}, function (result) {
                if(result.downloadUrl == null){
                    alert("Download URL not found! Kindly contact concerned department.");
                    return;
                }

                DownloadExternalServiceFiles.download(projectid, serviceid, reApplyCounter, result.downloadUrl);
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('completeprojectdetail', {
            parent: 'app',
            url: '/completeprojectdetail/{id}',
            data: {
                authorities: ['ROLE_USER','ROLE_DESK_OFFICER','ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_RM','ROLE_NODAL_OFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/completeprojectdetail/completeprojectdetail.html',
                    controller: 'completeprojectdetailController',
                    controllerAs: 'vm'
                }
            },
              resolve: {
                  translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                      $translatePartialLoader.addPart('completeprojectdetail');
                      return $translate.refresh();
                  }]
              }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('completeprojectdetailController', completeprojectdetailController);

    completeprojectdetailController.$inject = ['$scope', 'Principal', 'LoginService', '$state'];

    function completeprojectdetailController ($scope, Principal, LoginService, $state) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/checklistAvailabilityNew');

        $stateProvider
            .state('checklistAvailabilityNew', {
                parent: 'app',
                url: '/checklistAvailabilityNew',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/checklistAvailabilityNew/checklistAvailabilityNew.html',
                        controller: 'checklistAvailabilityNewController',
                        controllerAs: 'vm'
                    }
                }
            })
        $urlRouterProvider.otherwise('/');
    }
})();

// (function() {
//     'use strict';
//     angular
//         .module('investhryApp')
//         .factory('Clearance', Clearance);
//
//     Clearance.$inject = ['$resource', 'DateUtils'];
//
//     function Clearance ($resource, DateUtils) {
//         var resourceUrl =  'api/clearances';
//
//         return $resource(resourceUrl, {}, {
//             'query': { method: 'GET', isArray: true},
//             'get': {
//                 method: 'GET',
//                 transformResponse: function (data) {
//                     if (data) {
//                         data = angular.fromJson(data);
//                     }
//                     return data;
//                 }
//             },
//             'update': { method:'PUT' }
//         });
//     }
// })();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('checklistAvailabilityNewController', checklistAvailabilityNewController);

    checklistAvailabilityNewController.$inject = ['$scope', '$state', 'Department', 'BrapChecklist', 'District','DistrictVillageBlockMapping', 'DepartmentService','$translate'];

    function checklistAvailabilityNewController($scope, $state, Department, BrapChecklist, District,DistrictVillageBlockMapping,DepartmentService,$translate) {
        var vm = this;
        // Manually refresh translations after page load
        $translate.refresh().then(function() {
            console.log("Translations refreshed in controller");
        });
        vm.checklistAvailability = {};
        vm.departments = [];
        vm.applyFilters = applyFilters;
        vm.allRecords = [];
        vm.filteredRecords = [];

        vm.getDepartmentName = getDepartmentName;

        vm.loadAll = loadAll;

      //  vm.getServices = getServices();

        vm.serviceNames = {};
        vm.departmentNames = {};


        function applyFilters() {
            if (!vm.checklists) {
                console.warn("No checklists loaded yet.");
                vm.groupedChecklists = [];
                return;
            }

            console.log("Total raw checklists:", vm.checklists.length);

            // Step 1: Apply filters
            var filtered = vm.checklists.filter(function (item) {
                var deptMatch = true;
                var riskMatch = true;
                var sizeMatch = true;
                var investorMatch = true;
                var blockCategoryMatch = true;

                // Department filter
                if (vm.checklistAvailability.departmentId) {
                    deptMatch = item.departmentId &&
                        item.departmentId.trim().toLowerCase() === vm.checklistAvailability.departmentId.trim().toLowerCase();
                }

                // Risk category filter
                if (vm.checklistAvailability.riskCategory &&
                    vm.checklistAvailability.riskCategory !== "All") {
                    riskMatch = item.riskCategory &&
                        item.riskCategory.trim().toLowerCase() === vm.checklistAvailability.riskCategory.trim().toLowerCase();
                }

                // Size of firm filter
                if (vm.checklistAvailability.sizeOfFirm) {
                    sizeMatch = item.sizeOfFirm &&
                        item.sizeOfFirm.trim().toLowerCase() === vm.checklistAvailability.sizeOfFirm.trim().toLowerCase();
                }

                // Investor type filter
                if (vm.checklistAvailability.investorType) {
                    investorMatch = item.investerType &&
                        item.investerType.trim().toLowerCase() === vm.checklistAvailability.investorType.trim().toLowerCase();
                }

                // Location filter
                if (vm.checklistAvailability.blockCategory) {
                    blockCategoryMatch = item.businessLocation &&
                        item.businessLocation.trim().toLowerCase() === vm.checklistAvailability.blockCategory.trim().toLowerCase();
                }

                return deptMatch && riskMatch && sizeMatch && investorMatch && blockCategoryMatch;
            });

            console.log("Filtered records:", filtered.length, filtered);
            vm.groupedChecklists = filtered;

            if (vm.groupedChecklists.length <=0){
                    DepartmentService.query({id:1,departmentid: vm.checklistAvailability.departmentId},function(result) {
                        vm.services = result.filter(function(service) {
                            return service.active === true && service.isRemoveFromDashboards === false;
                        });
                        console.log("ssssss" + vm.services);

                    });

            }


            console.log("Grouped checklists:", vm.groupedChecklists);

            // Step 3: Load service & department names
            vm.loadServices();
        }




        loadAll();

        function loadAll() {
            BrapChecklist.query().$promise.then(function(response) {
                vm.filteredChecklists = response;   // store raw data
                vm.groupedChecklists = groupByService(vm.filteredChecklists); // group after loading
                console.log("Grouped:", vm.groupedChecklists);
            }).catch(function(error) {
                console.error('Error fetching checklist:', error);
            });
        }

        function groupByService(checklists) {
            if (!checklists || !checklists.length) {
                return []; // safeguard
            }

            var grouped = {};

            checklists.forEach(function(item) {
                var key = [
                    item.serviceId,
                    item.departmentId,
                    item.businessLocation || "NA",
                    item.sizeOfFirm || "NA",
                    item.investerType || "NA",
                    item.timelineDoc || "NA",
                    item.feeStructureDoc || "NA",
                    item.documentUrl || "NA",
                    item.inspectionDoc || "NA"
                ].join("_");
                if (!grouped[item.serviceId]) {
                    grouped[item.serviceId] = {
                        serviceId: item.serviceId,
                        departmentId: item.departmentId,
                        businessLocation: item.businessLocation || "NA",
                        investerType: item.investerType || "NA",
                        sizeOfFirm: item.sizeOfFirm || "NA",
                        timelineDoc: item.timelineDoc || "NA",
                        feeStructureDoc: item.feeStructureDoc || "NA",
                        documentUrl: item.documentUrl || "NA",
                        inspectionDoc: item.inspectionDoc || "NA",
                        riskDocs: {}
                    };
                }

                if (item.riskCategory) {
                    grouped[item.serviceId].riskDocs[item.riskCategory] = item.sopDoc;
                }
            });


            // ✅ load names after grouping
            vm.loadServices();

            vm.checklists = Object.values(grouped);

            return  Object.values(grouped);
        }

        // Fetch all data initially
        // function loadAll() {
        //     BrapChecklist.query().$promise.then(function (response) {
        //         console.log("All records loaded:", response);
        //
        //         // Save the full list from backend
        //         vm.checklists = response;
        //
        //         // Initially, show all records
        //         vm.filteredChecklists = angular.copy(vm.checklists);
        //         vm.loadServices();
        //     }).catch(function (error) {
        //         console.error('Error fetching document URL:', error);
        //     });
        //
        // }


        // Function to get department data
        function getDepartments() {
            Department.query().$promise.then(function(data) {
                vm.departments = data;
            }).catch(function(error) {
                console.error('Error fetching departments:', error);
            });
        }

        vm.loadServices = function() {
            vm.filteredChecklists.forEach(function(item) {
                if (item.serviceId && !vm.serviceNames[item.serviceId]) {
                    DepartmentService.get({id: item.serviceId}, function(result) {
                        vm.serviceNames[item.serviceId] = result.serviceName;
                        vm.departmentNames[item.departmentId] = result.departmentname;
                        // vm.departmentNames[item.departmentId] = result.departmentname;
                    });
                }
            });
        };


        function getDepartmentName(deptId) {
           // alert(deptId);
          //  if (!deptId || !vm.departments) return "N.A";
            var dept = vm.departments.find(function(d) {

                return d.id === deptId;
            });
          // alert(dept);
            return dept ? dept.departmentName : "N.A"; // assuming your API sends "departmentName"
        }

        // getDepartments();
        // loadAllDistrict();

        vm.updateDepartmentId = function() {
            var selectedDepartment = vm.departments.find(function(department) {
                return department.id === vm.selectedDepartment;
            });
            if (selectedDepartment) {
                vm.checklistAvailability.departmentId = selectedDepartment.id;
            } else {
                vm.checklistAvailability.departmentId = null; // Or handle as needed
            }
        };

        vm.submitForm = function() {
            var brapChecklistDTO = {
                departmentId: vm.checklistAvailability.departmentId,
                riskCategory: vm.checklistAvailability.riskCategory,
                sizeOfFirm: vm.checklistAvailability.sizeOfFirm,
                businessLocation: vm.checklistAvailability.businessLocation,
                investerType: vm.checklistAvailability.investorType
            };

            BrapChecklist.getDocumentUrl(brapChecklistDTO).$promise.then(function(response) {
                // Log the entire response to verify structure
                console.log('Full Response:', response);


                // Extract the document URL from the response object
                var cleanedDocumentUrl = Object.values(response).join('');
                var documentUrl = cleanedDocumentUrl.match(/^[^\[]+/)[0];
                // Log the URL to verify it is correct
                console.log('Document URL to pass:', documentUrl);
              

                // Pass the document URL to the state
                $state.go('searchResults', { responseData: documentUrl });
            }).catch(function(error) {
                console.error('Error fetching document URL:', error);
            });
        };

        vm.getVillages = function (districtName) {
            vm.showEstateConfirmation =true;
            vm.isIndustrialEstate = "no";
            vm.showIndustrialEstates = false;
            DistrictVillageBlockMapping.query({id: '1',districtName: districtName},function(result) {
                vm.villages = result;
                vm.searchQuery = null;
                vm.checklistAvailability.village = null;
                vm.checklistAvailability.blockCategory = null;
            });
        };

        vm.setBlockCategory = function (villageName, villageList) {
            vm.showEstateConfirmation = true;
            vm.villageNames = [];
            angular.forEach(villageList, function (value, key) {
                vm.villageNames.push(value.village);
            });
            if (vm.villageNames.indexOf(villageName) !== -1) {
                vm.invalidVillage = false;
                vm.checklistAvailability.blockCategory = villageList[vm.villageNames.indexOf(villageName)].category;
            } else {
                vm.invalidVillage = true;
            }
        };



        // vm.districts = [];
        // function loadAllDistrict(){
        //     District.query(function(result) {
        //         vm.districtstemp = result;
        //         angular.forEach(vm.districtstemp, function(value, key){
        //             if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
        //                 vm.districts.push(value);
        //             }
        //         });
        //         vm.searchQuery = null;
        //     });
        // }

         vm.getServices = function(id) {
          //  var id = '30a78b54-1016-4779-9197-0883eaf43d22';
            alert(id);
                DepartmentService.get({id: id},function(result) {
                vm.services = result;
                console.log("ssssss" + vm.services);

            });
        }

        // function groupByService(checklists) {
        //     var grouped = {};
        //
        //     checklists.forEach(function(item) {
        //         if (!grouped[item.serviceId]) {
        //             grouped[item.serviceId] = {
        //                 serviceId: item.serviceId,
        //                 departmentId: item.departmentId,
        //                 riskDocs: {} // store risk category → documentUrl mapping
        //             };
        //         }
        //
        //         // Example: riskCategory = "Red", documentUrl = "file.pdf"
        //         if (item.riskCategory && item.documentUrl) {
        //             grouped[item.serviceId].riskDocs[item.riskCategory] = item.documentUrl;
        //         }
        //     });
        //
        //     // Convert object back to array for ng-repeat
        //     return Object.values(grouped);
        // }
        //

        // vm.groupedChecklists = groupByService(vm.filteredChecklists);



    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('searchResultsController', searchResultsController);

    searchResultsController.$inject = ['$scope', '$stateParams', 'FileService'];

    function searchResultsController($scope, $stateParams, FileService) {
        var vm = this;

        var filename = $stateParams.responseData;


        vm.fileUrl = filename;

        // if (filename) {
        //     FileService.getFileUrl(filename).then(function(fileUrl) {
        //         vm.fileUrl = fileUrl;
        //     }).catch(function(error) {
        //         console.error('Error fetching file:', error);
        //     });
        // }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('FileService', FileService);

    FileService.$inject = ['$http'];

    function FileService($http) {
        var service = {
            getFileUrl: getFileUrl
        };

        return service;

        function getFileUrl(filename) {
            return $http.get('/api/files/' + filename, { responseType: 'arraybuffer' })
                .then(function(response) {
                    var blob = new Blob([response.data], { type: response.headers('Content-Type') });
                    var url = window.URL.createObjectURL(blob);
                    return url;
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

    function stateConfig($stateProvider, $urlRouterProvider) {
        $urlRouterProvider.otherwise('/checklistAvailability');

        $stateProvider
            .state('checklistAvailability', {
                parent: 'app',
                url: '/checklistAvailability',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/checklistAvailability/checklistAvailability.html',
                        controller: 'checklistAvailabilityController',
                        controllerAs: 'vm'
                    }
                }
            })
            .state('searchResults', {
                parent: 'app',
                url: '/search-results?responseData',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/checklistAvailability/searchResults.html',
                        controller: 'searchResultsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    documentUrl: ['$stateParams', function($stateParams) {
                        return $stateParams.documentUrl;
                    }]
                },
                params: {
                    responseData: null
                }
            });
        $urlRouterProvider.otherwise('/');
    }
})();

// (function() {
//     'use strict';
//     angular
//         .module('investhryApp')
//         .factory('Clearance', Clearance);
//
//     Clearance.$inject = ['$resource', 'DateUtils'];
//
//     function Clearance ($resource, DateUtils) {
//         var resourceUrl =  'api/clearances';
//
//         return $resource(resourceUrl, {}, {
//             'query': { method: 'GET', isArray: true},
//             'get': {
//                 method: 'GET',
//                 transformResponse: function (data) {
//                     if (data) {
//                         data = angular.fromJson(data);
//                     }
//                     return data;
//                 }
//             },
//             'update': { method:'PUT' }
//         });
//     }
// })();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('checklistAvailabilityController', checklistAvailabilityController);

    checklistAvailabilityController.$inject = ['$scope', '$state', 'Department', 'BrapChecklist','District','DistrictVillageBlockMapping', 'DepartmentService','$translate'];

    function checklistAvailabilityController($scope, $state, Department, BrapChecklist,District,DistrictVillageBlockMapping,DepartmentService,$translate) {
        var vm = this;
        // Manually refresh translations after page load
        $translate.refresh().then(function() {
            console.log("Translations refreshed in controller");
        });
        vm.checklistAvailability = {};
        vm.departments = [];

        // Function to get department data
        function getDepartments() {
            Department.query().$promise.then(function(data) {
                vm.departments = data;
            }).catch(function(error) {
                console.error('Error fetching departments:', error);
            });
        }

        getDepartments();
        loadAllDistrict();

        vm.updateDepartmentId = function() {
            var selectedDepartment = vm.departments.find(function(department) {
                return department.id === vm.selectedDepartment;
            });
            if (selectedDepartment) {
                vm.checklistAvailability.departmentId = selectedDepartment.id;
            } else {
                vm.checklistAvailability.departmentId = null; // Or handle as needed
            }
        };

        vm.submitForm = function() {
            var brapChecklistDTO = {
                departmentId: vm.checklistAvailability.departmentId,
                riskCategory: vm.checklistAvailability.riskCategory,
                sizeOfFirm: vm.checklistAvailability.sizeOfFirm,
                businessLocation: vm.checklistAvailability.businessLocation,
                investerType: vm.checklistAvailability.investorType
            };

            BrapChecklist.getDocumentUrl(brapChecklistDTO).$promise.then(function(response) {
                // Log the entire response to verify structure
                console.log('Full Response:', response);


                // Extract the document URL from the response object
                var cleanedDocumentUrl = Object.values(response).join('');
                var documentUrl = cleanedDocumentUrl.match(/^[^\[]+/)[0];
                // Log the URL to verify it is correct
                console.log('Document URL to pass:', documentUrl);


                // Pass the document URL to the state
                $state.go('searchResults', { responseData: documentUrl });
            }).catch(function(error) {
                console.error('Error fetching document URL:', error);
            });
        };

        vm.getVillages = function (districtName) {
            vm.showEstateConfirmation =true;
            vm.isIndustrialEstate = "no";
            vm.showIndustrialEstates = false;
            DistrictVillageBlockMapping.query({id: '1',districtName: districtName},function(result) {
                vm.villages = result;
                vm.searchQuery = null;
                vm.checklistAvailability.village = null;
                vm.checklistAvailability.blockCategory = null;
            });
        };

        vm.setBlockCategory = function (villageName, villageList) {
            vm.showEstateConfirmation = true;
            vm.villageNames = [];
            angular.forEach(villageList, function (value, key) {
                vm.villageNames.push(value.village);
            });
            if (vm.villageNames.indexOf(villageName) !== -1) {
                vm.invalidVillage = false;
                vm.checklistAvailability.blockCategory = villageList[vm.villageNames.indexOf(villageName)].category;
            } else {
                vm.invalidVillage = true;
            }
        };



        vm.districts = [];
        function loadAllDistrict(){
            District.query(function(result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

        vm.getServices = function (id) {
            DepartmentService.query({id: '1',departmentid: id},function(result) {
                vm.services = result;

            });
        }



    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RedirectToCentralPortalController', RedirectToCentralPortalController);

    RedirectToCentralPortalController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'CentralRecord', '$timeout'];

    function RedirectToCentralPortalController ($scope, Principal, LoginService, $state, CentralRecord, $timeout) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.project={};
        vm.showtable=false;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });


        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
            getRecord();
        }

        function getRecord() {
            CentralRecord.get(function(result){
                vm.project = result;
                console.log(vm.project);
                $timeout(function () {
                    angular.element('.form-group:eq(1)>input').focus();
                    angular.element(document.getElementById('fillform')).trigger('click')
                });
            });
        }


    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('CentralRecord', CentralRecord);

    CentralRecord.$inject = ['$resource'];

    function CentralRecord ($resource) {
        var resourceUrl =  '/api/centralTowerUserParams';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CenterRedirectUrlController', CenterRedirectUrlController);

    CenterRedirectUrlController.$inject = ['$scope', 'Principal', 'LoginService', '$state', '$stateParams', '$sessionStorage', '$location', '$q'];

    function CenterRedirectUrlController ($scope, Principal, LoginService, $state, $stateParams, $sessionStorage, $location, $q) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;

        vm.token = $location.search().token;
        vm.businessEntity = $location.search().businessEntity;
        vm.districtCode = $location.search().districtCode;
        vm.mobile = $location.search().mobile;
        vm.beCode = $location.search().beCode;
        if (vm.businessEntity){
            $sessionStorage.isFromCentralPortal = true;
        }

        vm.url =  $location.search().redirectparam;
        login();


        function login() {
            var defer = loginWithToken(vm.token, false);
            defer.then(function () {
                getAccount();
            });
        }

        function getAccount() {
            Principal.identity(true).then(function(account) {
                if (vm.businessEntity) {
                    $sessionStorage.businessEntity = vm.businessEntity;
                    $sessionStorage.districtCode = vm.districtCode;
                    $sessionStorage.mobile = vm.mobile;
                    $sessionStorage.beCode = vm.beCode;
                }
                $state.go(vm.url);
            }, function (error) {


            });
        }

        function storeAuthenticationToken(jwt) {
            $sessionStorage.authenticationToken = jwt;

        }

        function loginWithToken(jwt, rememberMe) {
            var deferred = $q.defer();

            if (angular.isDefined(jwt)) {
                storeAuthenticationToken(jwt, rememberMe);
                deferred.resolve(jwt);
            } else {
                deferred.reject();
            }

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('centreURL', {
            parent: 'app',
            url: '/centreURL',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/centerRedirectPage/searchCAF.html',
                    controller: 'CenterRedirectUrlController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        })
        .state('backtocentral', {
            parent: 'app',
            url: '/backtocentral',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/centerRedirectPage/centralForm.html',
                    controller: 'RedirectToCentralPortalController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('CAFwithNoService', {
            parent: 'app',
            url: '/CAFwithNoService',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_CAF_STATUS_OFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/CafwithNoService/CAFwithNoService.html',
                    controller: 'CAFwithNoServiceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('dashboard');
                    return $translate.refresh();
                }]
            }
        });

        }
        })();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CAFwithNoServiceController', CAFwithNoServiceController);

    CAFwithNoServiceController.$inject = ['$scope',  'Principal', 'LoginService',  '$state', 'CafWithNoService','$location'];

    function CAFwithNoServiceController ($scope,  Principal, LoginService, $state, CafWithNoService,$location) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.showtable=false;
        vm.cafWithNoServices = [];

        $scope.$on('authenticationSuccess', function() {
            getAccount();
            ga('set', 'page', $location.path());
            ga('send','pageview');
        });


        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }


        loadAll();

        function loadAll() {
            vm.showtable=false;
            CafWithNoService.query(function(result) {
            vm.cafWithNoServices = result;
            vm.searchQuery = null;
            vm.showtable = vm.cafWithNoServices.length !== 0;
            });
        }

        function register () {
            $state.go('register');
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('CafServiceStatusByFilter', CafServiceStatusByFilter);

    CafServiceStatusByFilter.$inject = ['$resource'];

    function CafServiceStatusByFilter ($resource) {
        var resourceUrl =  '/api/getCafServiceStatusByFilter/:perc';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('CafServiceStatusBetweenDate', CafServiceStatusBetweenDate);

    CafServiceStatusBetweenDate.$inject = ['$resource'];

    function CafServiceStatusBetweenDate ($resource) {
        var resourceUrl =  '/api/getDataByApplicationDate/:fromdate/:todate';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: false},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('cafservicestatus', {
            parent: 'app',
            url: '/cafservicestatus',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/cafservicestatus/cafservicestatus.html',
                    controller: 'CafservicestatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('state');
                    return $translate.refresh();
                }]
            }
        });

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Cafservicestatus', Cafservicestatus);

    Cafservicestatus.$inject = ['$resource'];

    function Cafservicestatus ($resource) {
        var resourceUrl =  'api/cafservicestatus';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();



(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CafservicestatusController', CafservicestatusController);

    CafservicestatusController.$inject = ['Cafservicestatus', '$scope', '$filter', 'CafServiceStatusBetweenDate'];

    function CafservicestatusController (Cafservicestatus, $scope, $filter, CafServiceStatusBetweenDate) {
        var vm = this;
        vm.filterResult = filterResult;
        vm.cafservicestatus = [];
        vm.percentfilter = 0;
        vm.datePickerOpenStatus = {};
        vm.datePickerOpenStatus.fromDate = false;
        vm.datePickerOpenStatus.toDate = false;
        vm.clearFilterButton = false;
        vm.selectedDate=selectedDate;

        vm.percentages=[{name:'100 %',value:100},{name:'>25 %',value:25},{name:'>50 %',value:50},{name:'>75 %',value:75},{name:'All ',value:0}];

        $scope.currentPage = 1;
        $scope.itemsPerPage = 1000;

        vm.changePage = function (index) {
            $scope.currentPage = index+1;
        };

        vm.openCalendar = openCalendar;
        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        vm.dateOptions = {
            minDate: new Date("01-01-2000"),
            maxDate: Date.now()
        };

        Cafservicestatus.query(function (result) {
            vm.cafservicestatus = result;
            filterResult(vm.percentfilter);
        });


        function selectedDate(dateSelected){
            var newDate = new Date(dateSelected);
            newDate.setDate(newDate.getDate()+181);
            if(newDate > Date.now()){
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: Date.now()
                };
            }
            else {
                vm.dateOptions1= {
                    minDate: dateSelected,
                    maxDate: newDate
                };
            }
        }

        vm.getCafBetweenDates=function(){
            var f=$filter('date')(vm.fromdate, "yyyy-MM-dd");
            var t=$filter('date')(vm.todate, "yyyy-MM-dd");
            var fromdate=$filter('date')(vm.fromdate, "yyyy-MM-dd");
            var todate=$filter('date')(vm.todate, "yyyy-MM-dd");

            CafServiceStatusBetweenDate.query({fromdate:f,todate:t},onSuccess,onError);
            function onSuccess(result){
                // vm.cafservicestatus = result;
                vm.cafservicestatus=result.cafservicestatusData.content;
                console.log("@@@@@@@@", vm.cafservicestatus);
                filterResult(vm.percentfilter);
                vm.clearFilterButton = true;
            };
        }

        function filterResult (percentage) {
            vm.totalcompleted= -1;
            vm.filteredResult = [];
            angular.forEach(vm.cafservicestatus , function(value, key){
                if(value.totalapplied > 0 && value.totalpending === 0){
                    vm.totalcompleted+=1;
                }
                if(value.percentagecompleted >= percentage){
                    vm.filteredResult.push(value);
                }
            });
            vm.show = true;

            $scope.maxSizeArray = function() {
                $scope.maxPageRound = Math.round(vm.filteredResult.length/$scope.itemsPerPage);
                $scope.maxPageAbs = Math.abs(vm.filteredResult.length/$scope.itemsPerPage);
                if($scope.maxPageRound > $scope.maxPageAbs){
                    return new Array($scope.maxPageRound);
                }
                else {
                    return new Array($scope.maxPageRound + 1);
                }
            };
        }

        vm.clearFilter = function () {
            vm.fromdate = null;
            vm.todate = null;
            vm.clearFilterButton = false;
            Cafservicestatus.query(function (result) {
                vm.cafservicestatus = result;
                filterResult(vm.percentfilter);
            });        }

        function onError(){
            alert("Please enter a period between 6 months");
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('investhryApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$localStorage', '$sessionStorage'];

    function authExpiredInterceptor($rootScope, $q, $injector, $localStorage, $sessionStorage) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            if (response.status === 401) {
                delete $localStorage.authenticationToken;
                delete $sessionStorage.authenticationToken;
                var Principal = $injector.get('Principal');
                if (Principal.isAuthenticated()) {
                    var Auth = $injector.get('Auth');
                    Auth.authorize(true);
                }
            }
            return $q.reject(response);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['$rootScope', '$q', '$location', '$localStorage', '$sessionStorage'];

    function authInterceptor ($rootScope, $q, $location, $localStorage, $sessionStorage) {
        var service = {
            request: request
        };

        return service;

        function request (config) {
            /*jshint camelcase: false */
            config.headers = config.headers || {};
            var token = $localStorage.authenticationToken || $sessionStorage.authenticationToken;
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
            }
            return config;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate','translationStorageProvider'];

    function translationHandler($rootScope, $window, $state, $translate,translationStorageProvider) {
        return {
            initialize: initialize,
            updateTitle: updateTitle,
            changeLanguage: changeLanguage // New method to switch languages
        };

        function initialize() {
            // Set the default or saved language
            var savedLanguage = translationStorageProvider.get('NG_TRANSLATE_LANG_KEY') || 'en';
            $translate.use(savedLanguage);

            // Update the title when the language changes
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            // Clean up listener on destroy
            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                    translateChangeSuccess();
                }
            });
        }

        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }

        // Dynamically change the language and save the preference
        function changeLanguage(langKey) {
            $translate.use(langKey);
            translationStorageProvider.set('NG_TRANSLATE_LANG_KEY', langKey); // Save the language preference
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            var storedLang = $cookies.getObject(name);
            if (LANGUAGES.indexOf(storedLang) === -1) {
                console.log("Invalid language in storage:", storedLang, "Resetting to 'en'");
                $cookies.putObject(name, 'en');
                return 'en';
            }
            return storedLang;
        }

        function put(name, value) {
            console.log("Storing language preference:", value);
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('en');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BelowGroundDialogController', BelowGroundDialogController);

    BelowGroundDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'Below_ground', 'FileManagement', 'District', 'Zone'];

    function BelowGroundDialogController ($timeout, $scope, $state, $stateParams, entity, Below_ground, FileManagement, District, Zone) {
        var vm = this;

        vm.below_ground = entity;
        vm.save = save;
        vm.onsubmit = onsubmit;
        vm.upload= upload;
        $scope.file = {};
        var savefilename=null;

        UIkit.modal("#modal-below2").show();


        loadAll();

        function loadAll() {
            District.query(function(result) {
                vm.districts = result;
                console.log(result);
                vm.searchQuery = null;
            });
            Zone.query(function(result) {
                vm.zones = result;
                vm.searchQuery = null;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function save () {
            vm.isSaving = true;
            vm.show= true;
            if (vm.below_ground.id !== null) {
                Below_ground.update(vm.below_ground, onSaveSuccess, onSaveError);
            } else {
                vm.below_ground.isfullyfilled= false;
                vm.below_ground.status = 'Pending';
                Below_ground.save(vm.below_ground, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            vm.result=result;
                $scope.$emit('investhryApp:below_groundUpdate', result);
                vm.isSaving = false;
            }

        function onSaveError() {
                vm.isSaving = false;
        }

        function  upload(i,object) {
            var fileNameArray = object.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var filename = vm.result.id+'_'+ i;
            savefilename=filename+ "." + fileextension;

            var file =object;
            FileManagement.saveFile(file,filename,onFileUploadedSuccess,onFileUploadedError);
            vm.vari=i;
        }

        function onsubmit() {
           $state.go("belowGround");
        }

        function onFileUploadedSuccess() {
            UIkit.notification("File Uploaded Successfully . . .",{timeout: 2000});
            if (vm.vari==1){
                vm.show_upload1=true;
                vm.result.document1= savefilename;
                Below_ground.update(vm.result);
            }
            else if(vm.vari==2){
                vm.show_upload2=true;
                vm.result.document2= savefilename;
                Below_ground.update(vm.result);
            }
            else if(vm.vari==3){
                vm.show_upload3=true;
                vm.result.document3= savefilename;
                Below_ground.update(vm.result);
            }
            else if(vm.vari==4){
                vm.show_upload4=true;
                vm.result.document4= savefilename;
                Below_ground.update(vm.result);
            }
            else if(vm.vari==5){
                vm.show_upload5=true;
                vm.result.document5= savefilename;
                Below_ground.update(vm.result);
            }
            else if(vm.vari==6){
                vm.show_upload6=true;
                vm.result.document6= savefilename;
                vm.result.isfullyfilled = true;
                Below_ground.update(vm.result);
            }
            else if(vm.vari==7){
                vm.show_upload7=true;
                vm.result.document7= savefilename;
                Below_ground.update(vm.result);
            }
            else if(vm.vari==8){
                vm.show_upload8=true;
                vm.result.document8= savefilename;
                Below_ground.update(vm.result);
            }
        }

        function onFileUploadedError() {
            UIkit.notification("Unexpected Error Occurred! Try Again . .",{timeout: 2000,status: 'danger'});
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BelowGroundDetailController', BelowGroundDetailController);

    BelowGroundDetailController.$inject = ['$scope', '$state', '$stateParams', 'entity', 'Below_ground', 'District', 'Zone','FileManagement','downloadserviceformattachment'];

    function BelowGroundDetailController($scope, $state, $stateParams, entity, Below_ground, District, Zone,FileManagement,downloadserviceformattachment) {
        var vm = this;
        vm.save= save;
        vm.download=download;
        vm.upload=upload;
        $scope.file={};
        var savefilename=null;

        vm.below_ground = entity;
        vm.edit_form= edit_form;
        $scope.isDisabled =true;

        loadAll();

        function loadAll() {
            District.query(function(result) {
                vm.districts = result;
                console.log(result);
                vm.searchQuery = null;
            });
            Zone.query(function(result) {
                vm.zones = result;
                vm.searchQuery = null;
            });
        }

        function save () {
            vm.isSaving = true;
            vm.show1= true;
            if (vm.below_ground.id !== null) {
                vm.below_ground.status = 'Pending';
                Below_ground.update(vm.below_ground, onSaveSuccess, onSaveError);
            } else {
                vm.below_ground.isfullyfilled = false;
                console.log(vm.below_ground.isfullyfilled);
                Below_ground.save(vm.below_ground, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $state.go("belowGround");
            //$scope.$emit('investhryApp:below_groundUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function edit_form() {
            vm.show= true;
            $scope.isDisabled =false;
        }

        function download(serverfilename,clientfilename) {
            downloadserviceformattachment.download(serverfilename,clientfilename);
        }

        function  upload(i,object) {
            var fileNameArray = object.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var filename = vm.below_ground.id+'_'+ i;
            savefilename=filename+ "." + fileextension;

            var file =object;
            FileManagement.saveFile(file,filename,onFileUploadedSuccess,onFileUploadedError);
            vm.vari=i;

        }
        function onFileUploadedSuccess() {
            UIkit.notification("File Uploaded Successfully . . .",{timeout: 2000});
            if (vm.vari==1){
                vm.show_upload1=true;
                vm.below_ground.document1= savefilename;
                Below_ground.update(vm.below_ground);
            }
            else if(vm.vari==2){
                vm.show_upload2=true;
                vm.below_ground.document2= savefilename;
                Below_ground.update(vm.below_ground);
            }
            else if(vm.vari==3){
                vm.show_upload3=true;
                vm.below_ground.document3= savefilename;
                Below_ground.update(vm.below_ground);
            }
            else if(vm.vari==4){
                vm.show_upload4=true;
                vm.below_ground.document4= savefilename;
                Below_ground.update(vm.below_ground);
            }
            else if(vm.vari==5){
                vm.show_upload5=true;
                vm.below_ground.document5= savefilename;
                Below_ground.update(vm.below_ground);
            }
            else if(vm.vari==6){
                vm.show_upload6=true;
                vm.below_ground.document6= savefilename;
                vm.below_ground.isfullyfilled = true;
                Below_ground.update(vm.below_ground);
            }
            else if(vm.vari==7){
                vm.show_upload7=true;
                vm.below_ground.document7= savefilename;
                Below_ground.update(vm.below_ground);
            }
            else if(vm.vari==8){
                vm.show_upload8=true;
                vm.below_ground.document8= savefilename;
                Below_ground.update(vm.below_ground);
            }
        }

        function onFileUploadedError() {
            UIkit.notification("Unexpected Error Occurred! Try Again . .",{timeout: 2000,status: 'danger'});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('belowGround', {
            parent: 'app',
            url: '/towerInstallation/belowGround',
            data: {
                authorities: ['ROLE_TOWER_USER'],
                pageTitle: 'global.menu.belowGround'
            },
            views: {
                'content@': {
                    templateUrl: 'app/belowGround/belowGround.html',
                    controller: 'BelowGroundController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('belowGround');
                    return $translate.refresh();
                }]
            }
        })
            .state('belowGround-dialog', {
            parent: 'belowGround',
            url: '/new',
            data: {
                authorities: ['ROLE_TOWER_USER']
            },
            views: {
                    'content@': {
                        templateUrl: 'app/belowGround/belowGround-dialog.html',
                        controller: 'BelowGroundDialogController',
                        controllerAs: 'vm'
                    }
                },
            resolve: {
                entity: function () {
                    return {
                        name: null,
                        reg_add: null,
                        har_office_add: null,
                        name_auth: null,
                        designation_auth: null,
                        phone_auth: null,
                        email: null,
                        lenth: null,
                        route: null,
                        nature: null,
                        methodology: null,
                        address1: null,
                        district: null,
                        zone: null,
                        details1: null,
                        details2: null,
                        other_info1: null,
                        other_info2: null,
                        other_info3: null,
                        other_info4: null,
                        other_info5: null,
                        other_info6: null,
                        other_info7: null,
                        address2: null,
                        document1: null,
                        document2: null,
                        document3: null,
                        document4: null,
                        document5: null,
                        document6: null,
                        document7: null,
                        document8: null,
                        isfullyfilled: false,
                        status: null,
                        isforwardedtodio: false,
                        isforwardedtodept: false,
                        isforwardedtodc: false,

                        clearancefile1: null,
                        clearancefile2: null,
                        clearancefile3: null,

                        created_by: null,
                        created_on: null,
                        isforwarded: null,

                        id: null
                    };
                }
                }
        })
            .state('belowGround-detail', {
                parent: 'belowGround',
                url: '/{id}',
                data: {
                    authorities: ['ROLE_TOWER_USER']
                    //pageTitle: 'investhryApp.belowGround.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/belowGround/belowGround-detail.html',
                        controller: 'BelowGroundDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('below_ground');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Below_ground', function($stateParams, Below_ground) {
                        return Below_ground.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'below-ground',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });;
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('BelowGroundService', BelowGroundService);

    BelowGroundService.$inject = ['$resource', 'DateUtils'];

    function BelowGroundService ($resource, DateUtils) {
        var resourceUrl =  'api/below-grounds-by-user';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created_on = DateUtils.convertLocalDateFromServer(data.created_on);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.created_on = DateUtils.convertLocalDateToServer(copy.created_on);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.created_on = DateUtils.convertLocalDateToServer(copy.created_on);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();



(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('BelowGroundController', BelowGroundController);

    BelowGroundController.$inject = ['$scope', 'Principal', 'BelowGroundService', 'Below_ground', 'Tower_log', 'downloadserviceformattachment','CheckContent'];

    function BelowGroundController($scope, Principal, BelowGroundService, Below_ground, Tower_log, downloadserviceformattachment,CheckContent) {
        var vm = this;
        vm.view_log=view_log;
        vm.comment= comment;
        vm.save= save;
        vm.download=download;
        vm.dowload_dialog=dowload_dialog;

        vm.below_grounds = [];

        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});

        loadAll();

        Principal.identity().then(function(account){
            vm.username=account.login;
        }   );

        function loadAll() {
            BelowGroundService.query(function(result) {
                vm.below_grounds = result;
                vm.searchQuery = null;
            });
        }
        function view_log(id) {
            console.log(id);
            Tower_log.query({towerId: id},function (result){
                vm.towerLog=result;
            });
        }
        function comment(result) {
            vm.applicant_id= result.id;
            vm.name_applicant= result.name;
        }
        function save() {
            vm.tower_log.tower_id= vm.applicant_id;
            vm.tower_log.action= "comment";
            // vm.tower_log.action_by=vm.username;
            Tower_log.save(vm.tower_log,onSaveSuccess);
        }

        function onSaveSuccess() {
            UIkit.modal('#modal_below3').hide();
            vm.tower_log.comment =null;
        }

        function dowload_dialog(file1,file2,file3) {
           vm.clearancefile1=file1;
           vm.clearancefile2=file2;
           vm.clearancefile3=file3;
        }

        function download(file_id,clientfilename) {
            if(file_id===1){
                downloadserviceformattachment.download(vm.clearancefile1,clientfilename);
            }
            else if(file_id===2){
                downloadserviceformattachment.download(vm.clearancefile2,clientfilename);
            }
            else if(file_id===3){
                downloadserviceformattachment.download(vm.clearancefile3,clientfilename);
            }

        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('unassignedProject', unassignedProject);

    unassignedProject.$inject = ['$resource'];

    function unassignedProject ($resource) {
        var resourceUrl =  'api/unassignedProject';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('RMDetails', RMDetails);

    RMDetails.$inject = ['$resource'];
    function RMDetails ($resource) {
        var resourceUrl =  'api/users/RM';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('assignRMController', assignRMController);

    assignRMController.$inject = ['$timeout', '$scope','entity', 'project', '$stateParams','assignedProjectDetail', 'RMDetails', 'Principal', 'AssignProjectToRM','Projectdetail','$state', 'Project', 'projectLog', 'projectLogNewCaf', 'ProjectLogNewCaf', 'Projectlogupdated'];

    function assignRMController ($timeout, $scope, entity, project, $stateParams, assignedProjectDetail, RMDetails, Principal, AssignProjectToRM, Projectdetail, $state, Project, projectLog, projectLogNewCaf, ProjectLogNewCaf, Projectlogupdated) {
        var vm = this;
        vm.save =save;
        vm.account = null;
        vm.investorsummarydetails = entity;
        vm.project = project;
        vm.isAuthenticated = null;
        vm.projectLog = projectLog;
        vm.projectLogNewCaf = projectLogNewCaf;
//        vm.assignProjectToRM = entity;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        loadAllRM();
        function loadAllRM() {
            vm.RMDetails= RMDetails.query()
        }
        function save (projectid, RMlogin) {
            vm.project.assignedRM = RMlogin;
            vm.project.isdeactivated = false;
            vm.project.deactivateddate = new Date();
            AssignProjectToRM.update(vm.project,onSaveSuccessRM);
        }

        function onSaveSuccessRM (result) {
            $scope.$emit('investhryApp:projectUpdate', result);
            if (vm.project.id !== null) {
                Project.update(vm.project, onSaveSuccess, onSaveError);
            }
            vm.isSaving = false;

        }

        function onSaveSuccess (result) {
            $scope.$emit('investhryApp:projectUpdate', result);
            vm.isSaving = false;
            if(result.caftype!=='New'){
                $scope.$emit('investhryApp:projectUpdate', result);
                vm.projectlog.projectid = $stateParams.projectid;
                vm.projectlog.actiontaken = "Changed RM.";
                vm.projectlog.actiontype = "RM Changed";
                Projectlogupdated.save(vm.projectlog, onProjectLogSaveSuccess, onProjectLogSaveError);
            }
            if(result.caftype==='New'){
                vm.projectLogNewCaf.projectId = $stateParams.projectid;
                vm.projectLogNewCaf.actionTaken = "Changed RM.";
                vm.projectLogNewCaf.actionType = "RM Changed";
                vm.projectLogNewCaf.oldValue = vm.investorsummarydetails.rmInfo;
                vm.projectLogNewCaf.newValue = result.assignedRM;
                ProjectLogNewCaf.save(vm.projectLogNewCaf, onProjectLogSaveSuccess, onProjectLogSaveError);
            }
            $state.go('assignProjectToRM');
        }

        function onProjectLogSaveSuccess(result)
        {

        }
        function onProjectLogSaveError()
        {

        }


        function onSaveError () {
            vm.isSaving = false;
             $state.go('assignProjectToRM');
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('assignProjectToRM', {
            parent: 'app',
            url: '/assignProject',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_ASSIGNRM_OFFICER'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/assignProjectToRM/assignProjectToRM.html',
                    controller: 'assignProjectToRMController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('block');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })

        .state('assignRM', {
            parent: 'assignProjectToRM',
            url: '/assign/{projectid}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_ASSIGNRM_OFFICER'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/assignProjectToRM/assignRM.html',
                    controller: 'assignRMController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'assignedProjectDetail', function($stateParams, assignedProjectDetail) {
                    return assignedProjectDetail.get({id : $stateParams.projectid}).$promise;
                }],
                project: ['$stateParams', 'Project', function($stateParams, Project) {
                    return Project.get({id : $stateParams.projectid}).$promise;
                }],
                projectLog: function () {
                    return {
                        projectid: null,
                        actiontaken: null,
                        actiontakenby: null,
                        actiontakendate: null,
                        actiontype: null,
                        id: null
                    };
                },
                projectLogNewCaf: function () {
                    return {
                        projectId: null,
                        actionTaken: null,
                        actionTakenBy: null,
                        actionTakenDate: null,
                        actionType: null,
                        fieldUpdated: null,
                        oldValue: null,
                        newValue: null,
                        id: null
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('block');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })

    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('assignProjectToRMController', assignProjectToRMController);

    assignProjectToRMController.$inject = ['$scope','$filter','Principal', 'LoginService', '$state','Projectlist', 'unassignedProject', 'assignedProjects','Rmlist'];

    function assignProjectToRMController ($scope,$filter, Principal, LoginService, $state,Projectlist, unassignedProject, assignedProjects,Rmlist) {
        var vm = this;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.rmlists = {};
        vm.assigned = false;
        vm.pagination = false;
        vm.projectlist = null;
        vm.getAssignedProject =getAssignedProject;
        vm.getUnassignedProject = getUnassignedProject;
        vm.getAssignedProjectByRm = getAssignedProjectByRm;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        $scope.currentPage = 1;
        $scope.itemsPerPage = 1000;

        vm.changePage = function (index) {
            $scope.currentPage = index+1;
        };

        getAccount();
        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                getUnassignedProject();
            });
        }

        loadAll();

        function loadAll() {
            Rmlist.query(function(result) {
                vm.rmlists = result;
                vm.searchQuery = null;
            });
        }

        function getAssignedProject() {
            vm.assigned = true;
            vm.pagination = true;
            vm.projectlist = null;
            vm.title ="";
            vm.selectedRm = null ;
            assignedProjects.query(function(result){
                vm.projectlist=result;
                vm.totalAssignedProject = result.length;
                $scope.maxSizeArray = function() {
                    $scope.maxPageRound = Math.round(result.length/$scope.itemsPerPage);
                    $scope.maxPageAbs = Math.abs(result.length/$scope.itemsPerPage);
                    if($scope.maxPageRound > $scope.maxPageAbs){
                        return new Array($scope.maxPageRound);
                    }
                    else {
                        return new Array($scope.maxPageRound + 1);
                    }
                };
                vm.title = "Total Asssigned Project";
            });
        }
        function getAssignedProjectByRm(value) {
            vm.pagination = false;
             vm.projectlistByRM = [];
                vm.projectlistByRM=$filter('filter')(vm.projectlist,{assignedToRM : value});

        }

        function getUnassignedProject() {
            vm.assigned = false;
            vm.pagination = false;
            vm.projectlistByRM = [];
            vm.title = "";
            unassignedProject.query(function(result){
                vm.projectlistByRM=result;
                vm.totalUnassignedProject = vm.projectlistByRM.length;
                vm.title = "Total Unasssigned Project";
            });
        }

        function register () {
            $state.go('register');
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('assignedProjectDetail', assignedProjectDetail);

    assignedProjectDetail.$inject = ['$resource'];

    function assignedProjectDetail ($resource) {
//        var resourceUrl =  'api/assignedProjectDetail/:projectid';
        var resourceUrl =  'api/assignedProjectDetail/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('assignedProjects', assignedProjects);

    assignedProjects.$inject = ['$resource'];

    function assignedProjects ($resource) {
        var resourceUrl =  'api/assignedProjects';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('assignedNewRM', assignedNewRM);

    assignedNewRM.$inject = ['$resource'];

    function assignedNewRM ($resource) {
        var resourceUrl =  'api/assign-project-to-rms';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('fieldOfficerList', fieldOfficerList);

    fieldOfficerList.$inject = ['$resource'];

    function fieldOfficerList ($resource) {
        var resourceUrl =  'api/users/Field_Officer';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);
    stateConfig.$inject = ['$stateProvider'];
    function stateConfig($stateProvider) {
        $stateProvider
        .state('assignFieldOfficerToDepartment', {
            parent: 'app',
            url: '/assignFieldOfficer/',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: ''
            },
            views: {
                'content@': {
                    templateUrl: 'app/assignFieldOfficerToDepartment/assignFieldOfficerToDepartment.html',
                    controller: 'assignFieldOfficerToDepartmentController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: function () {
                    return {
                        departmentid: null,
                        departmentname: null,
                        fieldOfficerid: null,
                        fieldofficerlogin: null,
                        fieldofficerdesignation: null,
                        fieldofficeraddress: null,
                        id: null
                    };
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('block');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('assignFieldOfficerToDepartmentController', assignFieldOfficerToDepartmentController);

    assignFieldOfficerToDepartmentController.$inject = ['$timeout', '$scope', '$stateParams', 'entity', 'fieldOfficerList', 'Principal', 'Department', 'AssignFieldOfficerToDepartment'];

    function assignFieldOfficerToDepartmentController ($timeout, $scope, $stateParams, entity, fieldOfficerList, Principal, Department, AssignFieldOfficerToDepartment) {
        var vm = this;
        vm.save =save;
        vm.account = null;
        vm.assignFieldOfficerToDepartment = entity;
            vm.isAuthenticated = null;
//                vm.login = LoginService.open;

            vm.register = register;
            $scope.$on('authenticationSuccess', function() {
                getAccount();
            });

            getAccount();

            function getAccount() {
                Principal.identity().then(function(account) {
                    vm.account = account;
                    vm.isAuthenticated = Principal.isAuthenticated;
                });
            }
            function register () {
                $state.go('register');
            }
        loadAllDepartment();

        function loadAllDepartment() {
            Department.query(function(result) {
                vm.departments = result;
                vm.searchQuery = null;
            });
        }
        loadAllFieldOfficer();
        function loadAllFieldOfficer() {
            vm.fieldofficerList= fieldOfficerList.query();
            console.log(vm.RMDetails);
        }
        function save (departmentid, fieldOfficer) {
            vm.isSaving = true;
            vm.assignFieldOfficerToDepartment.departmentid = departmentid;
            vm.assignFieldOfficerToDepartment.fieldofficerlogin = fieldOfficer.login;
            vm.assignFieldOfficerToDepartment.fieldOfficerid = fieldOfficer.id;
            if (vm.assignFieldOfficerToDepartment.id !== null) {
                AssignFieldOfficerToDepartment.update(vm.assignFieldOfficerToDepartment, onSaveSuccess, onSaveError);
            } else {
                AssignFieldOfficerToDepartment.save(vm.assignFieldOfficerToDepartment, onSaveSuccess, onSaveError);
            }
        }
        function onSaveSuccess (result) {
//            $scope.$emit('investhryApp:assignFieldOfficerToDepartmentUpdate', result);
//            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

    }
})();




(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html',
                    controller: 'FooterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                }]
            }
        });
    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('investhryApp')
        .constant('VERSION', "0.0.1-SNAPSHOT")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserManagementDialogController',UserManagementDialogController);

    UserManagementDialogController.$inject = ['$state', 'entity',  'User', 'extendedUserDetails', 'ExtendedUserInformationByUserID', 'ExtendedUserInformation', '$uibModalInstance', 'JhiLanguageService'];

    function UserManagementDialogController ($state, entity,  User, extendedUserDetails, ExtendedUserInformationByUserID, ExtendedUserInformation, $uibModalInstance, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_TOWER_MONITORING_OFFICER','ROLE_SUB_ADMIN', 'ROLE_RM', 'ROLE_DESK_OFFICER', 'ROLE_NODAL_OFFICER',
            'ROLE_ACCOUNT_OFFICER', 'ROLE_FIELD_OFFICER','ROLE_ASSIGNRM_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER',
            'ROLE_API_VIEWER','ROLE_GRIEVANCE_OFFICER','ROLE_GRIEVANCE_ADMIN', 'ROLE_TOWER_DC', 'ROLE_TOWER_DIO',
            'ROLE_TOWER_OFFICER','ROLE_DEPT_CHANGE', 'ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER', 'ROLE_L1_SUPPORT' ,
            'ROLE_L2_IT_MANAGER', 'ROLE_L2_DEPARTMENT', 'ROLE_L2_DEPARTMENT_HEAD', 'ROLE_L2_INCENTIVES','ROLE_TICKET_OPERATION_MANAGER',
            'ROLE_TICKET_NODAL_OFFICER', 'ROLE_FEEDBACK_OFFICER', 'ROLE_TICKET_ADMIN', 'ROLE_USER_EXT','ROLE_TICKET_HOBPAS',
            'ROLE_DISPUTE_OFFICER','ROLE_SKILLS_REQUIREMENT_OFFICER','ROLE_CAF_STATUS_OFFICER','ROLE_INCENTIVE_DISBURSEMENT_HEAD',
            'ROLE_HOME_CTM', 'ROLE_HOME_SUPERINTENDENT', 'ROLE_HOME_DC', 'ROLE_HOME_ASSISTANT','ROLE_STATE_NODAL_OFFICER', 'ROLE_NSWS_USER', 'ROLE_ACS'];
        vm.clear = clear;
        vm.languages = null;
        vm.ticketMember={};
        vm.save = save;
        vm.user = entity;
        vm.extendedUserInformation = extendedUserDetails;
        JhiLanguageService.getAll().then(function (languages) {
        vm.languages = languages;
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }
        function onSaveSuccess (result) {
            saveExtendedUserInformation(result);
            vm.isSaving = false;
        }
        function onSaveError () {
            vm.isSaving = false;
        }

        function save () {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function saveExtendedUserInformation (result) {
            vm.isSaving = true;
            vm.extendedUserInformation.id = result.id;
            vm.extendedUserInformation.userid = result.id;
            vm.extendedUserInformation.userlogin = result.login;
            ExtendedUserInformation.update(vm.extendedUserInformation, onSaveExtendedUserInformationSuccess, onSaveExtendedUserInformationError);
        }

        function onSaveExtendedUserInformationSuccess (result) {
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveExtendedUserInformationError () {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User'];

    function UserManagementDetailController ($stateParams, User) {
        var vm = this;

        vm.load = load;
        vm.user = {};

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('user-management', {
            parent: 'admin',
            url: '/user-management',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'userManagement.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management.html',
                    controller: 'UserManagementController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })

  .state('user-management.new', {
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                id: null, login: null, firstName: null, lastName: null, email: null,
                                activated: true, langKey: null, createdBy: null, createdDate: null,
                                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                                resetKey: null, authorities: null
                            };
                        },
                        extendedUserDetails: function () {
                            return {
                                userAddress: null,
                                userMobile: null,
                                userid: null,
                                userlogin: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('user-management');
                });
            }]
        })
        .state('user-management.edit', {
            url: '/{login}/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-dialog.html',
                    controller: 'UserManagementDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }],
                        extendedUserDetails: ['ExtendedUserInformation', function(ExtendedUserInformation) {
                            return ExtendedUserInformation.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-management-detail', {
            parent: 'user-management',
            url: '/user/{login}',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'user-management.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-management-detail.html',
                    controller: 'UserManagementDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })
        .state('user-management.delete', {
            url: '/{login}/delete',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                    controller: 'UserManagementDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['User', function(User) {
                            return User.get({login : $stateParams.login});
                        }]
                    }
                }).result.then(function() {
                    $state.go('user-management', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('user-list', {
            parent: 'user-management',
            url: '/user-list',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'user-list'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/user-list.html',
                    controller: 'UserListController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        })

        .state('newduplicates', {
            parent: 'user-management',
            url: '/newduplicates',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN'],
                pageTitle: 'New Duplicate User'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/user-management/newduplicateuser.html',
                    controller: 'NewDuplicatesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('user-management');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'ParseLinks', 'AlertService', 'JhiLanguageService','User','CheckContent'];

    function UserManagementController(Principal, ParseLinks, AlertService, JhiLanguageService,User,CheckContent) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN','ROLE_SUB_ADMIN', 'ROLE_RM', 'ROLE_DESK_OFFICER', 'ROLE_NODAL_OFFICER', 'ROLE_ACCOUNT_OFFICER', 'ROLE_FIELD_OFFICER','ROLE_ASSIGNRM_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_API_VIEWER','ROLE_GRIEVANCE_OFFICER','ROLE_GRIEVANCE_ADMIN', 'ROLE_TOWER_DC', 'ROLE_TOWER_USER', 'ROLE_TOWER_NODAL_OFFICER', 'ROLE_TOWER_DEPARTMENT', 'ROLE_CPUSER', 'ROLE_TOWER_DIO','ROLE_TOWER_OFFICER','ROLE_DEPT_CHANGE','ROLE_USER_EXT','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER', 'ROLE_L1_SUPPORT', 'ROLE_L2_IT_MANAGER', 'ROLE_L2_INCENTIVES', 'ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_TICKET_OPERATION_MANAGER', 'ROLE_TICKET_NODAL_OFFICER', 'ROLE_FEEDBACK_OFFICER', 'ROLE_TICKET_ADMIN' ,'ROLE_SKILLS_REQUIREMENT_OFFICER','ROLE_CAF_STATUS_OFFICER','ROLE_INCENTIVE_DISBURSEMENT_HEAD','ROLE_STATE_NODAL_OFFICER'];

        vm.currentAccount = null;
        vm.languages = null;
        vm.getUser = loadAll;
        vm.setActive = setActive;
        vm.users = undefined;

        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});


        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });

        function setActive (user, isActivated) {
            user.activated = isActivated;
            User.update(user.body, function () {
            });
        }

        function loadAll () {
            vm.users=undefined;
            User.query({userlogin:vm.userinfo},onSuccess, onError);
        }

        function onSuccess(data, headers) {
            if (data.length<=0){
                AlertService.error("User Not Found");
                return;
            }
            vm.users=data;
        }

        function onError(error) {

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('UserListController', UserListController);

    UserListController.$inject = ['User'];

    function UserListController (User) {
        var vm = this;

        vm.user = {};

        load();
        function load () {
            User.query({createDate: ''}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('NewDuplicatesController', NewDuplicatesController);

    NewDuplicatesController.$inject = ['User'];

    function NewDuplicatesController (User) {
        var vm = this;

        vm.user = {};

        load();
        function load () {
            User.query({newDuplicates: ''}, function(result) {
                vm.user = result;
            });
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ExtendedUserInformationByUserID', ExtendedUserInformationByUserID);
    ExtendedUserInformationByUserID.$inject = ['$resource'];

    function ExtendedUserInformationByUserID ($resource) {
        var resourceUrl =  'api/extended-user-informations/userInformation/:userlogin';
        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('investhryApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ["ROLE_ADMIN","ROLE_SUB_ADMIN","ROLE_MONITORING_OFFICER"],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('StateCountry', StateCountry);

    StateCountry.$inject = ['$resource'];

    function StateCountry ($resource) {
        var resourceUrl =  'api/states/country/:countryID';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ProjectType', ProjectType);

    ProjectType.$inject = [];

    function ProjectType () {
        var data;
        return {
            putProjectType:function(projectType){
                data=projectType;
            },
            getProjectType:function(){
                return data;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('projecttypeController', projecttypeController);

    projecttypeController.$inject = ['$scope','$state','$uibModalInstance','ProjectType'];

    function projecttypeController($scope,$state,$uibModalInstance,ProjectType) {

        var vm = this;
        vm.clear = clear;

        function clear () {
                    $uibModalInstance.dismiss('cancel');
                }

        vm.onprojectTypeSelected=function(){
        ProjectType.putProjectType(vm.projectType)
        $uibModalInstance.close();
        $state.go('addproject',{},{reload:true});
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('editprojectController', editprojectController);

    editprojectController.$inject = ['$scope', 'Principal','entity','cafAttachments','Projectcompletedetail','LoginService', '$state','State','City_town_village','Businessentitys','Sector',
    'Industrysize','Projectype','Projectcategory','Foreignfundingresource','Approvalforms','Block','Connectingroad','Landusezoneclassification',
    'Watersupplysource','Waste_water_disposal_mode','Emmision_pollution_controll','Emmision_fuel_type','District','Wwtreatmentone','Wwtreatmenttwo',
    'Wwtreatmentthree','Manufacturingunits','Modeofdisposalfor_discharge','Particular','Waste_water_naturetype','allcountries', 'allstates','allcity_town_villages','allbusinessentities','allsectors','allindustrysizes','allprojectypes','allprojectcategories','allapprovalforms','alldistricts','allblocks','allconnectingroads','alllandusezoneclassifications','allforeignfundingresources','allmanufacturingunits','allwatersupplysources','alltreatment1','alltreatment2','alltreatment3','allmodeofdisposalfor_discharge','allwaste_water_disposal_modes','allparticulars','allemmision_fuel_types','allemmision_pollution_controlls','allwaste_water_naturetype','allCustomerType','CAFAttachment','FileManagement','Customertype','Projectlog', 'projectLog','$stateParams', 'DistrictState', 'StateCountry'];

    function editprojectController ($scope, Principal, entity, cafAttachments, Projectcompletedetail, LoginService, $state,
    State,City_town_village,Businessentitys,Sector,Industrysize,Projectype,Projectcategory,
    Foreignfundingresource,Approvalforms,Block,Connectingroad,Landusezoneclassification,Watersupplysource,Waste_water_disposal_mode,
    Emmision_pollution_controll,Emmision_fuel_type,District,Wwtreatmentone,Wwtreatmenttwo,Wwtreatmentthree,Manufacturingunits,
    Modeofdisposalfor_discharge,Particular,Waste_water_naturetype,allcountries,allstates,allcity_town_villages,allbusinessentities,allsectors,allindustrysizes,allprojectypes,allprojectcategories,allapprovalforms,alldistricts,allblocks,allconnectingroads,alllandusezoneclassifications,allforeignfundingresources,allmanufacturingunits,allwatersupplysources,alltreatment1,alltreatment2,alltreatment3,allmodeofdisposalfor_discharge,allwaste_water_disposal_modes,allparticulars,allemmision_fuel_types,allemmision_pollution_controlls,allwaste_water_naturetype,allCustomerType,CAFAttachment,FileManagement,Customertype, Projectlog, projectLog, $stateParams, DistrictState, StateCountry)
    {
        var vm = this;
        vm.addingproject=false;
        vm.cafAttachments=cafAttachments;
        vm.uploadFiles=uploadFiles;
        vm.investorphoto=null;
        vm.investorsign=null;
        vm.projectlog=projectLog;
        vm.cAFAttachment="";
        vm.cAFAttachmentSign="";
        vm.cAFAttachmentPhoto="";
        var cafflag=0;
        $scope.file = {};

        for(var attachmentcounter=0;attachmentcounter<vm.cafAttachments.length;attachmentcounter++)
        {
            if(vm.cafAttachments[attachmentcounter].docName=="Applicant Photo")
            {
                vm.investorphoto=vm.cafAttachments[attachmentcounter];
            }
            if(vm.cafAttachments[attachmentcounter].docName=="Signature")
            {
                vm.investorsign=vm.cafAttachments[attachmentcounter];
            }
        }

        vm.completeprojectphasedata=[];
        vm.addProject_phaseData=addProject_phaseData;
        function addProject_phaseData(){
          vm.project_phase.projectid="";
          vm.completeprojectphasedata.push(vm.project_phase);
          vm.project_phase={};
        }
        vm.removeRow = function(phase){
            var index = -1;
            var comArr =eval(vm.completeprojectphasedata);

            for( var i = 0; i < comArr.length; i++ ) {
                if( comArr[i].phase=== phase) {
                    index = i;
                    break;
                }
            }
            vm.completeprojectphasedata.splice( index, 1 );
        };

        vm.projectrawmaterialdata=[];
        vm.addProject_rawmaterialData=addProject_rawmaterialData;
        function addProject_rawmaterialData(){
            if(angular.isDefined(vm.project_rawmaterial.selectedUnit))
            {
                vm.project_rawmaterial.units=vm.project_rawmaterial.selectedUnit.unittypes;
            }
            else
            {
                vm.project_rawmaterial.units="";
            }

           vm.projectrawmaterialdata.push(vm.project_rawmaterial);
                         //reinstantiate your $scope.formVariable so that your form is empty
           vm.project_rawmaterial={};
         }

         vm.removeRawRow = function(rawmaterial){
           var index = -1;
           var comArr =eval(vm.projectrawmaterialdata);

           for( var i = 0; i < comArr.length; i++ ) {
               if( comArr[i].rawmaterial=== rawmaterial) {
                   index = i;
                   break;
               }
           }
           vm.projectrawmaterialdata.splice( index, 1 );
         };

         // Start main product
         vm.projectmainproductdata=[];
         vm.addProject_mainproductData=addProject_mainproductData;

          function addProject_mainproductData(){
              if(angular.isDefined(vm.product.selectedUnit))
              {
                   vm.product.units=vm.product.selectedUnit.unittypes;
              }
              else
              {
                 vm.product.units="";
              }
              vm.projectmainproductdata.push(vm.product);
              //reinstantiate your $scope.formVariable so that your form is empty
              vm.product={};
          }
          vm.removeMainRow = function(mainproduct){
              var index = -1;
              var comArr =eval(vm.projectmainproductdata);

              for( var i = 0; i < comArr.length; i++ ) {
                  if(comArr[i].mainproduct=== mainproduct) {
                      index = i;
                      break;
                  }
              }
              vm.projectmainproductdata.splice( index, 1 );
           };

    //End main product

         vm.projectprocessflowstepdata=[];
         vm.addProject_processflowstepData=addProject_processflowstepData;
         function addProject_processflowstepData(){
             vm.projectprocessflowstepdata.push(vm.projectprocessflowstep);
             //reinstantiate your $scope.formVariable so that your form is empty
             vm.projectprocessflowstep={};
         }
          vm.removeStepRow = function(steps){
              var index = -1;
              var comArr =eval(vm.projectprocessflowstepdata);

              for( var i = 0; i < comArr.length; i++ ) {
                  if( comArr[i].steps=== steps) {
                      index = i;
                      break;
                  }
              }
              vm.projectprocessflowstepdata.splice( index, 1 );
          };

          // Start emission detail
            vm.emissiondetaildata=[];
            vm.addProject_emissiondetailData=addProject_emissiondetailData;
            function addProject_emissiondetailData() {
                if(angular.isDefined(vm.emissiondetail.selectedParticular))
                 {
                 vm.emissiondetail.particulars=vm.emissiondetail.selectedParticular.particulars;
                 }
                else
                 {
                vm.emissiondetail.particulars="";
                 }

                 if(angular.isDefined(vm.emissiondetail.selectedTypeoffuel))
                  {
                     vm.emissiondetail.type_of_fuel=vm.emissiondetail.selectedTypeoffuel.typeoffuel;
                  }
                 else
                  {
                    vm.emissiondetail.type_of_fuel="";
                  }

                 if(angular.isDefined(vm.emissiondetail.selectedAirpollutioncontroldevice))
                  {
                   vm.emissiondetail.air_pollution_control_device=vm.emissiondetail.selectedAirpollutioncontroldevice.airpollutioncontroldevice;
                   }
                 else
                  {
                 vm.emissiondetail.air_pollution_control_device="";
                  }

                    vm.emissiondetaildata.push(vm.emissiondetail);
                    vm.emissiondetail={};
                  }

               vm.removeEmissionRow = function(selectedParticular){
                     var index = -1;
                     var comArr =eval(vm.emissiondetaildata);

                     for( var i = 0; i < comArr.length; i++ ) {
                         if( comArr[i].selectedParticular=== selectedParticular) {
                             index = i;
                             break;
                         }
                     }
                     vm.emissiondetaildata.splice( index, 1 );
                 };

                // End emission detail

                // Start waste water detail

                   vm.wastewaterdetaildata=[];
                   vm.addProject_wastewaterdetailData=addProject_wastewaterdetailData;
                   function addProject_wastewaterdetailData(){
                        if(angular.isDefined(vm.wastewaterdetail.selectedNaturetype))
                             {
                         vm.wastewaterdetail.naturetype=vm.wastewaterdetail.selectedNaturetype.naturetype;
                             }
                         else
                           {
                          vm.wastewaterdetail.naturetype="";
                            }

                         if(angular.isDefined(vm.wastewaterdetail.selectedModeofdisposal))
                         {
                           vm.wastewaterdetail.mode_of_disposal=vm.wastewaterdetail.selectedModeofdisposal.disposal_for_discharge
                            }
                         else
                           {
                         vm.wastewaterdetail.mode_of_disposal="";
                            }
                       vm.wastewaterdetaildata.push(vm.wastewaterdetail);
                       vm.wastewaterdetail={};
                   }
                       vm.removeSourceRow = function(source_of_generation){
                            var index = -1;
                            var comArr =eval(vm.wastewaterdetaildata);

                            for( var i = 0; i < comArr.length; i++ ) {
                                if( comArr[i].source_of_generation=== source_of_generation) {
                                    index = i;
                                    break;
                                }
                            }
                        vm.wastewaterdetaildata.splice( index, 1 );
                                                };

         //End waste water

        vm.CompleteProjectDetail=entity;
        vm.investor=vm.CompleteProjectDetail.investorDTO;
        vm.companydetail=vm.CompleteProjectDetail.companydetailDTO;
        vm.projectdetail=vm.CompleteProjectDetail.projectdetailDTO;
        vm.projectsitedetail=vm.CompleteProjectDetail.projectsitedetailDTO;

        if(vm.projectsitedetail.clurequired===null)
        {
            vm.projectsitedetail.clurequired=false;
        }

        vm.project_finance_investment=vm.CompleteProjectDetail.project_finance_investmentDTO;
        vm.manufacturing_detail=vm.CompleteProjectDetail.manufacturingdetailDTO;
        vm.environmentimpactdetail=vm.CompleteProjectDetail.environment_impactdetailDTO;
        vm.term_declaration_accept=vm.CompleteProjectDetail.term_declaration_acceptDTO;
        vm.electricrequirement=vm.CompleteProjectDetail.electricrequirementDTO;
        vm.projectcombinecodes=vm.CompleteProjectDetail.projectdetailcombinecodesDTO;

        vm.completeprojectphasedata=vm.CompleteProjectDetail.project_phaseDTOList;
        vm.projectrawmaterialdata=vm.CompleteProjectDetail.projectrawmaterialDTOList;
        vm.projectmainproductdata=vm.CompleteProjectDetail.projectproductDTOList;
        vm.projectprocessflowstepdata=vm.CompleteProjectDetail.projectprocessflowstepsDTOList;
        vm.emissiondetaildata=vm.CompleteProjectDetail.emissiondetailDTOList;
        vm.wastewaterdetaildata=vm.CompleteProjectDetail.wastewaterdetailDTOList;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        vm.saveCompleteProjectDetail=saveCompleteProjectDetail;

             vm.changeInCrore=function(){
             var projectCostInCrore=vm.project_cost_in_crore || '00';
             var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
               var projectCostInThousands=vm.project_cost_in_thousands||'00';
               if( vm.project_cost_in_lacs<10){
              projectCostInLacs='0'+vm.project_cost_in_lacs;
               }
               if( vm.project_cost_in_thousands<10){
              projectCostInThousands='0'+vm.project_cost_in_thousands;
               }
        return vm.project_finance_investment.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
        }
        vm.changeInLacs=function(){
         var projectCostInCrore=vm.project_cost_in_crore || '00';
             var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
               var projectCostInThousands=vm.project_cost_in_thousands||'00';
        if( vm.project_cost_in_lacs<10){
              projectCostInLacs='0'+vm.project_cost_in_lacs;
               }
               if( vm.project_cost_in_thousands<10){
              projectCostInThousands='0'+vm.project_cost_in_thousands;
               }
        return vm.project_finance_investment.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
        }
        vm.changeInThousands=function(){
         var projectCostInCrore=vm.project_cost_in_crore || '00';
             var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
               var projectCostInThousands=vm.project_cost_in_thousands||'00';
          if( vm.project_cost_in_lacs<10){
              projectCostInLacs='0'+vm.project_cost_in_lacs;
               }
               if( vm.project_cost_in_thousands<10){
              projectCostInThousands='0'+vm.project_cost_in_thousands;
               }
        return vm.project_finance_investment.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;

        }

         var calculateCostInCrore=function(){
          return parseInt(vm.project_finance_investment.total_project_cost.toString().split('.')[0]);
        }

        var calculateCostInLacs=function(){
        if(vm.project_finance_investment.total_project_cost.toString().indexOf('.')!=-1){
        return parseInt(vm.project_finance_investment.total_project_cost.toString().split('.')[1].substring(0,2));
        }
        return 0;
        }

        var calculateCostInThousands=function(){
        if(vm.project_finance_investment.total_project_cost.toString().indexOf('.')!=-1){
         return parseInt(vm.project_finance_investment.total_project_cost.toString().split('.')[1].substring(2,4));
        }
        return 0;
        }
        vm.changeinAcres=function(){
                  var projectAreaInAcres=vm.project_area_in_acres || 0;
                  var projectAreaInKanal=vm.project_area_in_kanal|| 0 ;
                  var projectAreaInMarla=vm.project_area_in_marla|| 0;
                  vm.projectsitedetail.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);

              }

              vm.changeinKanal=function(){
                   var projectAreaInAcres=vm.project_area_in_acres || 0;
                   var projectAreaInKanal=vm.project_area_in_kanal|| 0 ;
                   var projectAreaInMarla=vm.project_area_in_marla|| 0;
                   vm.projectsitedetail.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);      }

              vm.changeInMarla=function(){
                  var projectAreaInAcres=vm.project_area_in_acres || 0;
                  var projectAreaInKanal=vm.project_area_in_kanal|| 0 ;
                  var projectAreaInMarla=vm.project_area_in_marla|| 0;
                  vm.projectsitedetail.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);
        }

        function calculateAreaInAcre(){
        return vm.projectsitedetail.totalproposedprojectarea;
        }

        function calculateAreaInKanal(){
        var areainkanal=vm.projectsitedetail.totalproposedprojectarea-Math.floor(vm.projectsitedetail.totalproposedprojectarea);
        var areaInKanal=areainkanal*8;
        return areaInKanal;
        }

        function calculateAreaInMarla(){
        var areainmarla=Math.floor(calculateAreaInKanal());
        var areaInMarla=(calculateAreaInKanal()-areainmarla)*20;

        return Math.round(areaInMarla);
        }
                        vm.project_cost_in_crore=calculateCostInCrore();
                        vm.project_cost_in_lacs= calculateCostInLacs();
                        vm.project_cost_in_thousands=calculateCostInThousands();
                        vm.project_area_in_acres=Math.floor(calculateAreaInAcre());
                        vm.project_area_in_kanal= Math.floor(calculateAreaInKanal());
                        vm.project_area_in_marla=Math.floor(calculateAreaInMarla());

        function checkDropDowns()
        {
            if (angular.isDefined(vm.investor.selectedCountry))
                vm.investor.countryname=vm.investor.selectedCountry.countryname;
            if (angular.isDefined(vm.investor.selectedState))
                vm.investor.statename=vm.investor.selectedState.statename;
            if (angular.isDefined(vm.investor.selectedCity))
                vm.investor.cityname=vm.investor.selectedCity.districtname;
            if (angular.isDefined(vm.companydetail.selectedBusiness))
                vm.companydetail.businessentitytype=vm.companydetail.selectedBusiness.businessentitytype;

            if (angular.isDefined(vm.projectdetail.selectedSector))
                vm.projectdetail.sectorname=vm.projectdetail.selectedSector.sectortype;
            if (angular.isDefined(vm.projectdetail.selectedSizeOfIndustry))
                vm.projectdetail.size_of_industry=vm.projectdetail.selectedSizeOfIndustry.sizeofindustry;
            if (angular.isDefined(vm.projectdetail.selectedProjectType))
                vm.projectdetail.projectype=vm.projectdetail.selectedProjectType.projectypes;
            if (angular.isDefined(vm.projectdetail.selectedProjectCategory))
                vm.projectdetail.category_of_project=vm.projectdetail.selectedProjectCategory.categorytype;
            if (angular.isDefined(vm.projectdetail.selectedCountry))
                vm.projectdetail.collaboration_with_foreign_country=vm.projectdetail.selectedCountry.countryname;
            if (angular.isDefined(vm.projectdetail.selectedApprovalForm))
                vm.projectdetail.approval_application_form=vm.projectdetail.selectedApprovalForm.existingapprovalforms;

            if (angular.isDefined(vm.projectsitedetail.selectedDistrict))
                vm.projectsitedetail.district=vm.projectsitedetail.selectedDistrict.districtname;
            if (angular.isDefined(vm.projectsitedetail.selectedBlock))
                vm.projectsitedetail.block=vm.projectsitedetail.selectedBlock.blockname;
            if (angular.isDefined(vm.projectsitedetail.selectedCityTownVillage))
                vm.projectsitedetail.city_town_village=vm.projectsitedetail.selectedCityTownVillage.city_town_village_name;
            if (angular.isDefined(vm.projectsitedetail.selectedConnectingRoad))
                vm.projectsitedetail.connectingroad=vm.projectsitedetail.selectedConnectingRoad.connectingraodtype;
            if (angular.isDefined(vm.projectsitedetail.selectedLandZoneUseType))
                vm.projectsitedetail.landzoneuse_type=vm.projectsitedetail.selectedLandZoneUseType.landzoneclassificationtype;

            if (angular.isDefined(vm.project_finance_investment.selectedcountryid))
                vm.project_finance_investment.fdi_country=vm.project_finance_investment.selectedcountryid.countryname;
            if (angular.isDefined(vm.foreignfundingresources.selectedforeignfundingresourceid))
                vm.project_finance_investment.foreign_funding_source= vm.foreignfundingresources.selectedforeignfundingresourceid.foreignfundingtypes;

            if (angular.isDefined(vm.environmentimpactdetail.selectedWatersource))
                vm.environmentimpactdetail.source_of_water_supply=vm.environmentimpactdetail.selectedWatersource.watersupplysourcetype;
            if (angular.isDefined(vm.environmentimpactdetail.selectedTreatmentone))
                vm.environmentimpactdetail.recycling_process= vm.environmentimpactdetail.selectedTreatmentone.treatment1;
            if (angular.isDefined(vm.environmentimpactdetail.selectedTreatmenttwo))
                vm.environmentimpactdetail.recycling_cooling=vm.environmentimpactdetail.selectedTreatmenttwo.treatment2;
            if (angular.isDefined(vm.environmentimpactdetail.selectedTreatmentthree))
                vm.environmentimpactdetail.recycling_domestic= vm.environmentimpactdetail.selectedTreatmentthree.treatment3;
            if (angular.isDefined(vm.environmentimpactdetail.selectedDischarge))
                vm.environmentimpactdetail.mode_of_disposal_for_discharge= vm.environmentimpactdetail.selectedDischarge.disposal_for_discharge;

            if (angular.isDefined(vm.electricrequirement.selectedCustomerType))
                vm.electricrequirement.customertype= vm.electricrequirement.selectedCustomerType.customertype;
        }

        function saveCompleteProjectDetail(flag)
        {
            vm.isSaving = true;
            checkDropDowns();

            if(flag=='Final')
            {
                if(vm.investor.cafpin !== null)
                {
                    if(vm.investor.cafpin.length !== 10)
                    {
                        vm.investor.cafpin=1;
                        cafflag=1;
                    }
                }
                else
                {
                    vm.investor.cafpin=1;
                    cafflag=1;
                }
            }
            vm.CompleteProjectDetail.investorDTO=vm.investor;
            vm.CompleteProjectDetail.companydetailDTO=vm.companydetail;
            vm.CompleteProjectDetail.projectdetailDTO=vm.projectdetail;
            vm.CompleteProjectDetail.projectsitedetailDTO=vm.projectsitedetail;
            vm.CompleteProjectDetail.project_finance_investmentDTO=vm.project_finance_investment;
            vm.CompleteProjectDetail.manufacturingdetailDTO=vm.manufacturing_detail;
            vm.CompleteProjectDetail.environment_impactdetailDTO=vm.environmentimpactdetail;
            vm.CompleteProjectDetail.term_declaration_acceptDTO=vm.term_declaration_accept;
            vm.CompleteProjectDetail.electricrequirementDTO=vm.electricrequirement;
            vm.CompleteProjectDetail.projectdetailcombinecodesDTO =vm.projectcombinecodes;

            vm.CompleteProjectDetail.project_phaseDTOList=vm.completeprojectphasedata;
            vm.CompleteProjectDetail.projectrawmaterialDTOList=vm.projectrawmaterialdata;
            vm.CompleteProjectDetail.projectproductDTOList=vm.projectmainproductdata;
            vm.CompleteProjectDetail.projectprocessflowstepsDTOList=vm.projectprocessflowstepdata;
            vm.CompleteProjectDetail.emissiondetailDTOList=vm.emissiondetaildata;
            vm.CompleteProjectDetail.wastewaterdetailDTOList=vm.wastewaterdetaildata;

            Projectcompletedetail.update(vm.CompleteProjectDetail,onUpdateCompleteProjectSuccess,onUpdateCompleteProjectError)
        }
        function onUpdateCompleteProjectSuccess (resultCompleteProject) {
            $scope.$emit('investhryApp:projectdetailUpdate', resultCompleteProject);
            vm.resultCompleteProject=resultCompleteProject;
            vm.isSaving = false;
            vm.uploadFiles(vm.resultCompleteProject.projectdetailDTO.id);
            if(resultCompleteProject.investorDTO.cafpin.length == 10)
            {
                if(cafflag == 1)
                {
                    vm.projectlog.actiontype = "CAF Added";
                }
                else
                {
                    vm.projectlog.actiontype = "CAF Edited";
                }

                vm.projectlog.projectid = vm.resultCompleteProject.projectdetailDTO.id;
                vm.projectlog.actiontaken = "Edited CAF.";
                Projectlog.save(vm.projectlog, onProjectLogSaveSuccess, onProjectLogSaveError);
            }
            alert('updated');
            $state.go('listproject');
        }
        function onUpdateCompleteProjectError () {
            vm.isSaving = false;
            alert('not updated');
        }

        function onProjectLogSaveSuccess(result)
        {

        }
        function onProjectLogSaveError()
        {

        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }


        $scope.loadStates = function (obj) {
        vm.statebycountry=StateCountry.query({countryID : obj.id});
        }
        $scope.loadDistrict = function(obj)
        {
        vm.districtbystate=DistrictState.query({stateID : obj.id});
        }

        function register () {
            $state.go('register');
        }
        vm.IsVisible = false;
        vm.ShowPassport = function (value) {
            vm.IsVisible = value == "Y";
        }

       fillFormDataFromEntities();
       function fillFormDataFromEntities()
       {
            vm.countries = allcountries;
            vm.states = allstates;
            vm.city_town_villages = allcity_town_villages;
            vm.businessentities = allbusinessentities;
            vm.sectors = allsectors;
            vm.industrysizes = allindustrysizes;
            vm.projectypes = allprojectypes;
            vm.projectcategories = allprojectcategories;
            vm.approvalforms = allapprovalforms;
            vm.districts = alldistricts;
            vm.blocks = allblocks;
            vm.connectingroads = allconnectingroads;
            vm.landusezoneclassifications = alllandusezoneclassifications;
            vm.foreignfundingresources = allforeignfundingresources;
            vm.manufacturingunits = allmanufacturingunits;
            vm.watersupplysources = allwatersupplysources;
            vm.treatment1 = alltreatment1;
            vm.treatment2 = alltreatment2;
            vm.treatment3 = alltreatment3;
            vm.modeofdisposalfor_discharge = allmodeofdisposalfor_discharge;
            vm.particulars = allparticulars;
            vm.emmision_fuel_types = allemmision_fuel_types;
            vm.emmision_pollution_controlls = allemmision_pollution_controlls;
            vm.waste_water_naturetype = allwaste_water_naturetype;
            vm.customerType= allCustomerType;
       }

       angular.element(function (){
           for( var i = 0; i < vm.countries.length; i++ ) {
             if(vm.countries[i].countryname===vm.investor.countryname) {
                 vm.investor.selectedCountry=vm.countries[i];
                 vm.statebycountry=StateCountry.query({countryID : vm.investor.selectedCountry.id},function(result)
                 {
                 for( var j = 0; j < result.length; j++ )
                 {
                 if(result[j].statename===vm.investor.selectedState)
                 {
                 vm.investor.selectedState = result[j];
                 }
                 }

                 });
                 break;
             }
          }

          for( var i = 0; i < vm.states.length; i++ ) {
           if(vm.states[i].statename===vm.investor.statename) {
              vm.investor.selectedState=vm.states[i];
               vm.districtbystate=DistrictState.query({stateID : vm.investor.selectedState.id},function(result){
               for( var k = 0; k < result.length; k++ ){
               if(result[k].districtname===vm.investor.cityname){
               vm.investor.selectedCity = result[k];

               }
               }
              });
               break;
           }

         }

//             for(var i = 0; i < vm.city_town_villages.length; i++ ) {
//              if(vm.city_town_villages[i].city_town_village_name===vm.investor.cityname) {
//                  vm.investor.selectedCity=vm.city_town_villages[i];
//                  break;
//              }
//            }
         for( var i = 0; i < vm.businessentities.length; i++ ) {
             if(vm.businessentities[i].businessentitytype===vm.companydetail.businessentitytype) {
                 vm.companydetail.selectedBusiness=vm.businessentities[i];
                 break;
             }
           }
         for( var i = 0; i < vm.sectors.length; i++ ) {
            if(vm.sectors[i].sectortype===vm.projectdetail.sectorname) {
                vm.projectdetail.selectedSector=vm.sectors[i];
                break;
            }
          }
          for( var i = 0; i < vm.industrysizes.length; i++ ) {
              if(vm.industrysizes[i].sizeofindustry===vm.projectdetail.size_of_industry) {
                  vm.projectdetail.selectedSizeOfIndustry=vm.industrysizes[i];
                  break;
              }
            }
         for( var i = 0; i < vm.projectypes.length; i++ ) {
           if(vm.projectypes[i].projectypes===vm.projectdetail.projectype) {
               vm.projectdetail.selectedProjectType=vm.projectypes[i];
               break;
           }
         }
        for( var i = 0; i < vm.projectcategories.length; i++ ) {
           if(vm.projectcategories[i].categorytype===vm.projectdetail.category_of_project) {
               vm.projectdetail.selectedProjectCategory=vm.projectcategories[i];
               break;
           }
         }
        for( var i = 0; i < vm.countries.length; i++ ) {
            if(vm.countries[i].countryname===vm.projectdetail.collaboration_with_foreign_country) {
                vm.projectdetail.selectedCountry=vm.countries[i];
                break;
            }
        }
        for( var i = 0; i < vm.approvalforms.length; i++ ) {
            if(vm.approvalforms[i].existingapprovalforms===vm.projectdetail.approval_application_form) {
                vm.projectdetail.selectedApprovalForm=vm.approvalforms[i];
                break;
            }
        }
         for( var i = 0; i < vm.districts.length; i++ ) {
          if(vm.districts[i].districtname===vm.projectsitedetail.district) {
              vm.projectsitedetail.selectedDistrict=vm.districts[i];
              break;
          }
         }
         for( var i = 0; i < vm.blocks.length; i++ ) {
           if(vm.blocks[i].blockname===vm.projectsitedetail.block) {
               vm.projectsitedetail.selectedBlock=vm.blocks[i];
               break;
           }
          }
          for( var i = 0; i < vm.city_town_villages.length; i++ ) {
             if(vm.city_town_villages[i].city_town_village_name===vm.projectsitedetail.city_town_village) {
                 vm.projectsitedetail.selectedCityTownVillage=vm.city_town_villages[i];
                 break;
             }
            }
          for( var i = 0; i < vm.connectingroads.length; i++ ) {
           if(vm.connectingroads[i].connectingraodtype===vm.projectsitedetail.connectingroad) {
               vm.projectsitedetail.selectedConnectingRoad=vm.connectingroads[i];
               break;
           }
          }
          for( var i = 0; i < vm.landusezoneclassifications.length; i++ ) {
             if(vm.landusezoneclassifications[i].landzoneclassificationtype===vm.projectsitedetail.landzoneuse_type) {
                 vm.projectsitedetail.selectedLandZoneUseType=vm.landusezoneclassifications[i];
                 break;
             }
          }
          for( var i = 0; i < vm.countries.length; i++ ) {
           if(vm.countries[i].countryname===vm.project_finance_investment.fdi_country) {
               vm.project_finance_investment.selectedcountryid=vm.countries[i];
               break;
           }
          }
          for( var i = 0; i < vm.foreignfundingresources.length; i++ ) {
             if(vm.foreignfundingresources[i].foreignfundingtypes===vm.project_finance_investment.foreign_funding_source) {
                 vm.foreignfundingresources.selectedforeignfundingresourceid=vm.foreignfundingresources[i];
                 break;
             }
            }
          for( var i = 0; i < vm.watersupplysources.length; i++ ) {
           if(vm.watersupplysources[i].watersupplysourcetype===vm.environmentimpactdetail.source_of_water_supply) {
               vm.environmentimpactdetail.selectedWatersource=vm.watersupplysources[i];
               break;
           }
          }
          for( var i = 0; i < vm.treatment1.length; i++ ) {
             if(vm.treatment1[i].treatment1===vm.environmentimpactdetail.recycling_process) {
                 vm.environmentimpactdetail.selectedTreatmentone=vm.treatment1[i];
                 break;
             }
            }
          for( var i = 0; i < vm.treatment2.length; i++ ) {
           if(vm.treatment2[i].treatment2===vm.environmentimpactdetail.recycling_cooling) {
               vm.environmentimpactdetail.selectedTreatmenttwo=vm.treatment2[i];
               break;
           }
          }
          for( var i = 0; i < vm.treatment3.length; i++ ) {
             if(vm.treatment3[i].treatment3===vm.environmentimpactdetail.recycling_domestic) {
                 vm.environmentimpactdetail.selectedTreatmentthree=vm.treatment3[i];
                 break;
             }
            }
          for( var i = 0; i < vm.modeofdisposalfor_discharge.length; i++ ) {
           if(vm.modeofdisposalfor_discharge[i].disposal_for_discharge===vm.environmentimpactdetail.mode_of_disposal_for_discharge) {
               vm.environmentimpactdetail.selectedDischarge=vm.modeofdisposalfor_discharge[i];
               break;
           }
          }
          for( var i = 0; i < vm.customerType.length; i++ ) {
            if(vm.customerType[i].customertype===vm.electricrequirement.customertype) {
                vm.electricrequirement.selectedCustomerType=vm.customerType[i];
                break;
            }
           }

       });

       function uploadFiles(projectid)
        {
           if(angular.isDefined(vm.cAFAttachmentPhoto.investorphoto)){
               var file=vm.cAFAttachmentPhoto.investorphoto;
               vm.cAFAttachmentPhoto.id=null;
               vm.cAFAttachmentPhoto.docName="Applicant Photo";
               vm.cAFAttachmentPhoto.projectid=projectid;
               if(vm.investorphoto!==null)
                    onSaveCAFAttachmentPhotoSuccess(vm.investorphoto);
               else
                    CAFAttachment.save(vm.cAFAttachmentPhoto,onSaveCAFAttachmentPhotoSuccess,onSaveCAFAttachmentPhotoError);
           }
           if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
               var file=vm.cAFAttachmentSign.investorsign;
               vm.cAFAttachmentSign.id=null;
               vm.cAFAttachmentSign.docName="Signature";
               vm.cAFAttachmentSign.projectid=projectid;

               if(vm.investorsign!==null)
               {
                    onSaveCAFAttachmentSignSuccess(vm.investorsign);
               }
               else
               {
                    CAFAttachment.save(vm.cAFAttachmentSign,onSaveCAFAttachmentSignSuccess,onSaveCAFAttachmentSignError);
               }
           }

           function onSaveCAFAttachmentPhotoSuccess (result) {
               $scope.$emit('investhryApp:cAFAttachmentUpdate', result);

               var filename = result.id;
               var file=vm.cAFAttachmentPhoto.investorphoto;

               FileManagement.saveFile(file,filename);

               var CAFAttachmentResultObject=result;

               var fileNameArray = file.name.split(".");
               var fileextension="";
               if((fileNameArray.length>1))
               {
                   fileextension=fileNameArray[(fileNameArray.length-1)];
               }

               var inputFileName=result.id;
               if(fileextension!=="")
               {
                   inputFileName=inputFileName+"."+fileextension;
               }
               CAFAttachmentResultObject.fileName=inputFileName;
               CAFAttachment.update(CAFAttachmentResultObject,onUpdateCAFAttachmentPhotoSuccess,onUpdateCAFAttachmentPhotoError);
               vm.isSaving = false;
           }
           function onSaveCAFAttachmentSignSuccess (result) {
               $scope.$emit('investhryApp:cAFAttachmentUpdate', result);

               var filename = result.id;
               var file=vm.cAFAttachmentSign.investorsign;

               FileManagement.saveFile(file,filename);
               var CAFAttachmentResultObject=result;

               var fileNameArray = file.name.split(".");
               var fileextension="";
               if((fileNameArray.length>1))
               {
                   fileextension=fileNameArray[(fileNameArray.length-1)];
               }

               var inputFileName=result.id;
               if(fileextension!=="")
               {
                   inputFileName=inputFileName+"."+fileextension;
               }
               CAFAttachmentResultObject.fileName=inputFileName;
               CAFAttachment.update(CAFAttachmentResultObject,onUpdateCAFAttachmentPhotoSuccess,onUpdateCAFAttachmentPhotoError);
               vm.isSaving = false;
           }

           function onSaveCAFAttachmentPhotoError()
           {
               vm.isSaving = false;
           }

           function onUpdateCAFAttachmentPhotoSuccess(result)
           {
               $scope.$emit('investhryApp:cAFAttachmentUpdate', result);
               vm.isSaving = false;
           }

           function onUpdateCAFAttachmentPhotoError()
           {
               vm.isSaving = false;
           }

           function onSaveCAFAttachmentSignError()
           {
               vm.isSaving = false;
           }

           function onSaveCAFAttachmentError () {
               vm.isSaving = false;
           }
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('DistrictState', DistrictState);

    DistrictState.$inject = ['$resource'];

    function DistrictState ($resource) {
        var resourceUrl =  'api/districts/state/:stateID';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('addproject', {
            parent: 'app',
            url: '/addproject',
            data: {
                authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER']
            },
            views: {
                'content@': {
                    templateUrl: 'app/addproject/addproject.html',
                    controller: 'addprojectController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                investor: function () {
                        return {
                            mouapplicable: null,
                            mousignyear: null,
                            mouidnumber: null,
                            firstname: null,
                            middlename: null,
                            lastname: null,
                            address1: null,
                            address2: null,
                            address3: null,
                            emailprimary: null,
                            emailsecondary: null,
                            moudocument: null,
                            investorpicpath: null,
                            userlogin: null,
                            cityname: null,
                            countryname: null,
                            statename: null,
                            id: null
                        };
                    },
                landrequirementcaf: function () {
                    return {
                        landrequired: null,
                        plotsize: null,
                        estatename: null,
                        purchaserate: null,
                        estatelocation: null,
                        agencyname: null,
                        village: null,
                        tehsil: null,
                        district: null,
                        landusetype:null,
                        id: null
                    };
                },
                 companydetail: function () {
                     return {
                         investorid: null,
                         promoter_md_director: null,
                         designation: null,
                         businessentity: null,
                         director_promoter_md_ceo_number: null,
                         pan_number: null,
                         aadhar_number: null,
                         nri: null,
                         tin_vat_number: null,
                         cst_number: null,
                         director_md_ceo_list: null,
                         pancard: null,
                         aadharcard: null,
                         tin_vat_document: null,
                         cst_document: null,
                         moa_partnershipdeed: null,
                         registration_document: null,
                         businessentitytype: null,
                         gstnumber: null,
                         id: null
                     };
                 },
                 projectdetail: function () {
                     return {
                         projectpurpose: null,
                         niccode: null,
                         existing_regulatory_approval: null,
                         edc_sif_clu_fee_paid_applicable: null,
                         detail_project_report: null,
                         approval_document: null,
                         edc_sif_clu_fee_paid_document: null,
                         investorid: null,
                         approval_application_form: null,
                         category_of_project: null,
                         collaboration_with_foreign_country: null,
                         projectype: null,
                         sectorname: null,
                         size_of_industry: null,
                         cafPIN: null,
                         isdeactivated: false,
                         id: null
                     };
                 },
                     projectsitedetail: function () {
                         return {
                             projectid: null,
                             siteaddress: null,
                             tehsil_subtehsil: null,
                             multyvillageinvolved: null,
                             villageinvolved: null,
                             falls_in_aravalli: null,
                             islandprocured: null,
                             allotedbyhsiidc: null,
                             estate: null,
                             cluster: null,
                             phase: null,
                             sector: null,
                             plotno: null,
                             hadbastno: null,
                             liesunder_mc: null,
                             distance_from_mc: null,
                             islocated_in_urban: null,
                             totalproposedprojectarea: null,
                             proposedbuilt_up_area: null,
                             certifiedownership: null,
                             leaseapplicable: null,
                             landagreementapplicable: null,
                             intersectiondistance: null,
                             railwaydistance: null,
                             confirmitylanduse: null,
                             existing_building_applicable: null,
                             site_situated_in_controlled_area: null,
                             khasra_document: null,
                             revenu_shajra_document: null,
                             jamabandi: null,
                             nonencumbrance_certificate: null,
                             ownership_document: null,
                             lease_document: null,
                             landagreement_document: null,
                             sitelayoutplan: null,
                             locationplan: null,
                             linearstripplan: null,
                             sitesituated_document: null,
                             controlledarea_document: null,
                             buildingexisted: null,
                             district: null,
                             block: null,
                             city_town_village: null,
                             connectingroad: null,
                             landzoneuse_type: null,
                             clurequired: false,
                             id: null
                         };
                     },
                     project_finance_investment: function () {
                             return {
                                 projectid: null,
                                 land_cost: null,
                                 building_cost: null,
                                 machinery_cost: null,
                                 misc_assests: null,
                                 total_project_cost: null,
                                 isfdi: null,
                                 fdivalue: null,
                                 project_construction_start_date: null,
                                 commercial_activity_start_date: null,
                                 proposedproject_scheduleid: null,
                                 fdi_country: null,
                                 foreign_funding_source: null,
                                 id: null
                             };
                         },
                         manufacturingdetail: function() {
                             return {
                                 projectid: null,
                                 projectrawmaterialid: null,
                                 productid: null,
                                 processid: null,
                                 manufacturing_flow_document: null,
                                 id: null
                             };
                          },
                          projectrawmaterial: function () {
                              return {
                                  rawmaterial: null,
                                  quantity: null,
                                  units: null,
                                  createdate: null,
                                  updatedate: null,
                                  projectid: null,
                                  id: null
                              };
                          },
                          projectproduct: function () {
                              return {
                                  projectid: null,
                                  mainproduct: null,
                                  quantity: null,
                                  units: null,
                                  id: null
                              };
                          },
                          projectprocessflowstep: function () {
                              return {
                                  projectid: null,
                                  steps: null,
                                  id: null
                              };
                          },
                          environmentimpactdetail: function () {
                              return {
                                  water_process: null,
                                  water_cooling: null,
                                  water_domestic: null,
                                  water_other: null,
                                  waste_water_process: null,
                                  waste_water_cooling: null,
                                  waste_water_domesting: null,
                                  waste_water_other: null,
                                  source_of_water_supply: null,
                                  mode_of_disposal_for_discharge: null,
                                  recycling_process: null,
                                  recycling_cooling: null,
                                  recycling_domestic: null,
                                  recycling_other: null,
                                  createdate: null,
                                  updatedate: null,
                                  sourcewatersupplyother: null,
                                  modedisposalother: null,
                                  id: null
                              };
                          },

                          modeofdisposalfor_discharge: function () {
                              return {
                                  disposal_for_discharge: null,
                                  id: null
                              };
                          },

                          emissiondetail: function () {
                              return {
                                  projectid: null,
                                  particulars: null,
                                  capacity: null,
                                  type_of_fuel: null,
                                  air_pollution_control_device: null,
                                  id: null
                              };
                          },

                          wastewaterdetail: function () {
                              return {
                                  projectid: null,
                                  source_of_generation: null,
                                  naturetype: null,
                                  quantity: null,
                                  mode_of_disposal: null,
                                  description: null,
                                  id: null
                              };
                         },
                         electricrequirement: function () {
                            return {
                                projectid: null,
                                temporaryrequired: null,
                                tem_load_existing: null,
                                tem_account_number: null,
                                temp_existing_load_demand_kw: null,
                                temp_existing_load_demand_kva: null,
                                temp_new_load_demand_kw: null,
                                temp_new_load_demand_kva: null,
                                temp_load_demand_date: null,
                                regular_load_required: null,
                                regular_existing_connection: null,
                                customertype: null,
                                regular_account_number: null,
                                regular_existing_load_ifany_kw: null,
                                regular_existing_load_ifany_kva: null,
                                regular_new_load_demand_kw: null,
                                regular_new_load_demand_kva: null,
                                regular_load_demand_date: null,
                                temporaryconnection: null,
                                regular_connection_doc: null,
                                id: null
                            };
                        },
                        projectcombinecodes: function () {
                            return {
                                investorid: null,
                                companydetailid: null,
                                projectsitedetailid: null,
                                projectfinanceid: null,
                                manufacturingid: null,
                                electricityrequirementid: null,
                                isprojectrenewable: false,
                                projectshop: false,
                                id: null
                            };
                        },
                        treatment1: function () {
                            return {
                                treatment1: null,
                                id: null
                            };
                        },
                        treatment2: function () {
                            return {
                                treatment2: null,
                                id: null
                            };
                        },
                        treatment3: function () {
                            return {
                                treatment3: null,
                                id: null
                            };
                        },
                        term_declaration_accept: function () {
                            return {
                                acceptance: null,
                                applicationdate: null,
                                place: null,
                                createdate: null,
                                updatedate: null,
                                id: null
                            };
                        },
                        cAFAttachment: function () {
                            return {
                                projectid: null,
                                docName: null,
                                fileName: null,
                                id: null
                            };
                        },
                        projectLog: function () {
                            return {
                                projectid: null,
                                actiontaken: null,
                                actiontakenby: null,
                                actiontakendate: null,
                                actiontype: null,
                                id: null
                            };
                        },
            }
        })
        .state('projectedit', {
            parent: 'app',
            url: '/addproject/edit/{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/addproject/addproject.html',
                    controller: 'editprojectController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            projectLog: function () {
                return {
                    projectid: null,
                    actiontaken: null,
                    actiontakenby: null,
                    actiontakendate: null,
                    actiontype: null,
                    id: null
                };
            },
            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                $translatePartialLoader.addPart('addproject');
                return $translate.refresh();
            }],
            entity: ['$stateParams', 'Projectcompletedetail', function($stateParams,Projectcompletedetail) {
                    return Projectcompletedetail.get({id : $stateParams.id}).$promise;
            }],
            cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                    return CAFAttachment.query({id : $stateParams.id,projectid : $stateParams.id}).$promise;
            }],
            allcountries: ['Country', function(Country) {
                return Country.query(function(result) {
                   return result;
               });
            }],
              allstates: ['State', function(State) {
                  return State.query(function(result) {
                      return result;
                  });
              }],
              allcity_town_villages: ['City_town_village', function(City_town_village) {
                  return City_town_village.query(function(result) {
                    return result;
                  });
              }],
              allbusinessentities: ['Businessentitys', function(Businessentitys) {
                  return Businessentitys.query(function(result) {
                      return result;
                  });
              }],
              allsectors: ['Sector', function(Sector) {
                  return Sector.query(function(result) {
                      return result;
                  });
              }],
              allindustrysizes: ['Industrysize', function(Industrysize) {
                  return Industrysize.query(function(result) {
                      return result;
                  });
              }],
              allprojectypes: ['Projectype', function(Projectype) {
                  return Projectype.query(function(result) {
                      return result;
                  });
              }],
              allprojectcategories: ['Projectcategory', function(Projectcategory) {
                  return Projectcategory.query(function(result) {
                      return result;
                  });
              }],
              allapprovalforms: ['Approvalforms', function(Approvalforms) {
                  return Approvalforms.query(function(result) {
                      return result;
                  });
              }],
              alldistricts: ['District', function(District) {
                  return District.query(function(result) {
                      return result;
                  });
              }],
              allblocks: ['Block', function(Block) {
                  return Block.query(function(result) {
                      return result;
                  });
              }],
              allconnectingroads: ['Connectingroad', function(Connectingroad) {
                  return Connectingroad.query(function(result) {
                      return result;
                  });
              }],
              alllandusezoneclassifications: ['Landusezoneclassification', function(Landusezoneclassification) {
                  return Landusezoneclassification.query(function(result) {
                      return result;
                  });
              }],
              allforeignfundingresources: ['Foreignfundingresource', function(Foreignfundingresource) {
                  return Foreignfundingresource.query(function(result) {
                      return result;
                  });
              }],
              allmanufacturingunits: ['Manufacturingunits', function(Manufacturingunits) {
                  return Manufacturingunits.query(function(result) {
                      return result;
                  });
              }],
              allwatersupplysources: ['Watersupplysource', function(Watersupplysource) {
                  return Watersupplysource.query(function(result) {
                      return result;
                  });
              }],
              alltreatment1: ['Wwtreatmentone', function(Wwtreatmentone) {
                  return Wwtreatmentone.query(function(result) {
                      return result;
                  });
              }],
              alltreatment2: ['Wwtreatmenttwo', function(Wwtreatmenttwo) {
                  return Wwtreatmenttwo.query(function(result) {
                      return result;
                  });
              }],
              alltreatment3: ['Wwtreatmentthree', function(Wwtreatmentthree) {
                  return Wwtreatmentthree.query(function(result) {
                      return result;
                  });
              }],
                allwaste_water_disposal_modes: ['Waste_water_disposal_mode', function(Waste_water_disposal_mode) {
                    return Waste_water_disposal_mode.query(function(result) {
                        return result;
                    });
                }],
              allmodeofdisposalfor_discharge: ['Modeofdisposalfor_discharge', function(Modeofdisposalfor_discharge) {
                  return Modeofdisposalfor_discharge.query(function(result) {
                      return result;
                  });
              }],
              allparticulars: ['Particular', function(Particular) {
                  return Particular.query(function(result) {
                      return result;
                  });
              }],
              allemmision_fuel_types: ['Emmision_fuel_type', function(Emmision_fuel_type) {
                  return Emmision_fuel_type.query(function(result) {
                      return result;
                  });
              }],
              allemmision_pollution_controlls: ['Emmision_pollution_controll', function(Emmision_pollution_controll) {
                  return Emmision_pollution_controll.query(function(result) {
                      return result;
                  });
              }],
              allwaste_water_naturetype: ['Waste_water_naturetype', function(Waste_water_naturetype) {
                  return Waste_water_naturetype.query(function(result) {
                      return result;
                  });
              }],
              allCustomerType: ['Customertype', function(Customertype) {
                  return Customertype.query(function(result) {
                      return result;
                  });
              }]
        }
      })
      .state('projecttype', {
            parent: 'app',
            url: '/projecttype',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/addproject/projecttype.html',
                    controller: 'projecttypeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('addproject', {}, { reload: false });
                }, function() {
                    $state.go('home');
                });
            }]
        })

        .state('projecttypeNewEnterprise', {
                    parent: 'app',
                    url: '/NewEnterpriseservies',
                    data: {
                        authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/addproject/ProjectypeNewEnterprise.html',
                            controller: 'projecttypeController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                            }
                        }).result.then(function() {
                            $state.go('addproject', {}, { reload: false });
                        }, function() {
                            $state.go('home');
                        });
                    }]
                })

        .state('projecttypeShopEnterprise', {
                            parent: 'app',
                            url: '/ShopEnterpriseservies',
                            data: {
                                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
                            },
                            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                                $uibModal.open({
                                    templateUrl: 'app/addproject/projectTypeShopReg.html',
                                    controller: 'projecttypeController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'lg',
                                    resolve: {
                                    }
                                }).result.then(function() {
                                    $state.go('addproject', {}, { reload: false });
                                }, function() {
                                    $state.go('home');
                                });
                            }]
                        })


        .state('projecttypeRenewEnterprise', {
                            parent: 'app',
                            url: '/RenewEnterpriseservies',
                            data: {
                                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
                            },
                            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                                $uibModal.open({
                                    templateUrl: 'app/addproject/ProjectTypeRenew.html',
                                    controller: 'projecttypeController',
                                    controllerAs: 'vm',
                                    backdrop: 'static',
                                    size: 'lg',
                                    resolve: {
                                    }
                                }).result.then(function() {
                                    $state.go('addproject', {}, { reload: false });
                                }, function() {
                                    $state.go('home');
                                });
                            }]
                        });

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('addprojectController', addprojectController);

    addprojectController.$inject = ['$scope', 'Principal', 'cAFAttachment', 'investor','companydetail','projectdetail','projectsitedetail',
    'electricrequirement','manufacturingdetail','project_finance_investment','projectcombinecodes','LoginService', '$state', 'Investor',
    'Companydetail','Projectdetail','Projectcompletedetail','Country','State','City_town_village','Businessentitys','Sector',
    'Industrysize','Projectype','Projectcategory','Foreignfundingresource','Approvalforms','Block','Connectingroad','Landusezoneclassification',
    'Watersupplysource','Waste_water_disposal_mode','Emmision_pollution_controll','Emmision_fuel_type','District','Wwtreatmentone','Wwtreatmenttwo',
    'Wwtreatmentthree','Manufacturingunits','Modeofdisposalfor_discharge','Particular','Waste_water_naturetype','environmentimpactdetail','term_declaration_accept','CAFAttachment','FileManagement','Customertype', 'Projectlog', 'projectLog','StateCountry','DistrictState','ProjectType','landrequirementcaf'];

    function addprojectController ($scope, Principal,cAFAttachment, investor, companydetail, projectdetail,projectsitedetail,electricrequirement,
    manufacturingdetail,project_finance_investment,projectcombinecodes, LoginService, $state, Investor, Companydetail, Projectdetail,
    Projectcompletedetail,Country,State,City_town_village,Businessentitys,Sector,Industrysize,Projectype,Projectcategory,
    Foreignfundingresource,Approvalforms,Block,Connectingroad,Landusezoneclassification,Watersupplysource,Waste_water_disposal_mode,
    Emmision_pollution_controll,Emmision_fuel_type,District,Wwtreatmentone,Wwtreatmenttwo,Wwtreatmentthree,Manufacturingunits,
    Modeofdisposalfor_discharge,Particular,Waste_water_naturetype,environmentimpactdetail,term_declaration_accept,CAFAttachment,FileManagement,Customertype, Projectlog, projectLog, StateCountry, DistrictState,ProjectType,landrequirementcaf)
    {
        var vm = this;
        vm.renewproject=false;
        vm.addingproject=true;
        var isrenewable=ProjectType.getProjectType();
        Principal.identity().then(function(account){
        vm.account=account;
        vm.landusetypes=['In Controlled Area','Outside Controlled Area'];
        vm.landrequiredoptions=['In Industrial Estate/Area','Outside Developed Industrial Estate/Area']
        vm.investor.firstname=account.firstName;
        vm.agencies=['HSIIDC','HUDA','Other developer'];
        vm.investor.lastname=account.lastName;
        vm.investor.emailprimary=account.email;
        vm.investor.mobilenumber=account.phone;
        });
        function checkRenewedProject(){
           if(isrenewable==='EXIST')
           {
               vm.renewproject=true;
               vm.companydetail.businessentity="Renewable";
               vm.projectsitedetail.selectedLandZoneUseType={id:"f87e2000-8072-4502-b77b-6f046fd63ccf",landzoneclassificationtype:"Industrial"};
               vm.projectsitedetail.landzoneuse_type=vm.projectsitedetail.selectedLandZoneUseType.landzoneclassificationtype;
               vm.project_area_in_acres=0;
               vm.project_area_in_kanal=0;
               vm.project_area_in_marla=0;
               vm.project_cost_in_crore=0;
               vm.project_cost_in_lacs=0;
               vm.project_cost_in_thousands=0;
               vm.project_finance_investment.totalpurposedemployment=0;
               vm.projectsitedetail.totalproposedprojectarea=0;
               vm.project_finance_investment.total_project_cost=0;
               projectcombinecodes.isprojectrenewable=true;
               vm.numberoffields=5;
               projectcombinecodes.projectshop=false;
               projectcombinecodes.landrequirementcaf=false;
           }
           else if (isrenewable==='SHOP')
           {
               vm.shopcaf=true;
               vm.renewproject=true;
               vm.companydetail.businessentity="ShopCaf";
               vm.projectsitedetail.selectedLandZoneUseType={id:"9370b1a8-0137-4ae8-8c42-44b9a3402964",landzoneclassificationtype:"Commercial"};
               vm.projectsitedetail.landzoneuse_type=vm.projectsitedetail.landzoneuse_type=vm.projectsitedetail.selectedLandZoneUseType.landzoneclassificationtype;
               vm.project_area_in_acres=0;
               vm.project_area_in_kanal=0;
               vm.project_area_in_marla=0;
               vm.projectsitedetail.totalproposedprojectarea=0;
               vm.project_finance_investment.total_project_cost=0;
               projectcombinecodes.isprojectrenewable=false;
               vm.numberoffields=5;
               projectcombinecodes.projectshop= true;
               projectcombinecodes.landrequirementcaf=false;
           }
           else if (isrenewable==='LAND_REQUIREMENT')
           {
               vm.renewproject=false;
               vm.landrequired=true;
               vm.projectsitedetail.selectedLandZoneUseType={id:"9370b1a8-0137-4ae8-8c42-44b9a3402964",landzoneclassificationtype:"Commercial"};
               vm.projectsitedetail.landzoneuse_type=vm.projectsitedetail.landzoneuse_type=vm.projectsitedetail.selectedLandZoneUseType.landzoneclassificationtype;
               vm.companydetail.businessentity="Land Requirement CAF";
               projectcombinecodes.isprojectrenewable=false;
               vm.numberoffields=10;
               projectcombinecodes.projectshop= false;
               projectcombinecodes.landrequirementcaf=true;
           }
           else
           {
               vm.renewproject=false;
               projectcombinecodes.isprojectrenewable=false;
               projectcombinecodes.projectshop= false;
               vm.companydetail.businessentity="";
               vm.numberoffields=9;
           }
        }
      vm.changeinAcres=function(){
          var projectAreaInAcres=vm.project_area_in_acres || 0;
          var projectAreaInKanal=vm.project_area_in_kanal|| 0 ;
          var projectAreaInMarla=vm.project_area_in_marla|| 0;
          vm.projectsitedetail.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);

      }
      vm.changeinKanal=function(){
           var projectAreaInAcres=vm.project_area_in_acres || 0;
           var projectAreaInKanal=vm.project_area_in_kanal|| 0 ;
           var projectAreaInMarla=vm.project_area_in_marla|| 0;
           vm.projectsitedetail.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);      }

      vm.changeInMarla=function(){
          var projectAreaInAcres=vm.project_area_in_acres || 0;
          var projectAreaInKanal=vm.project_area_in_kanal|| 0 ;
          var projectAreaInMarla=vm.project_area_in_marla|| 0;
          vm.projectsitedetail.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);
}
      vm.changeInCrore=function(){
      var projectCostInCrore=vm.project_cost_in_crore || '00';
      var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
       var projectCostInThousands=vm.project_cost_in_thousands||'00';
       if( vm.project_cost_in_lacs<10){

      projectCostInLacs='0'+vm.project_cost_in_lacs;

       }
       if( vm.project_cost_in_thousands<10){

      projectCostInThousands='0'+vm.project_cost_in_thousands;

       }
return project_finance_investment.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
}

       vm.changeInLacs=function(){
      var projectCostInCrore=vm.project_cost_in_crore || '00';
      var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
      var projectCostInThousands=vm.project_cost_in_thousands||'00';
      if( vm.project_cost_in_lacs<10){
      projectCostInLacs='0'+vm.project_cost_in_lacs;
       }
       if( vm.project_cost_in_thousands<10){

      projectCostInThousands='0'+vm.project_cost_in_thousands;

       }
    return project_finance_investment.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
     }


       vm.changeInThousands=function(){
       var projectCostInCrore=vm.project_cost_in_crore || '00';
       var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
       var projectCostInThousands=vm.project_cost_in_thousands||'00';

       if( vm.project_cost_in_lacs<10){

      projectCostInLacs='0'+vm.project_cost_in_lacs;

       }
       if( vm.project_cost_in_thousands<10){

      projectCostInThousands='0'+vm.project_cost_in_thousands;

       }
    return project_finance_investment.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
       }
        vm.CompleteProjectDetail={};
        vm.uploadFiles=uploadFiles;
        vm.completeprojectphasedata=[];
        vm.addProject_phaseData=addProject_phaseData;
        vm.cAFAttachment=cAFAttachment;
        vm.cAFAttachmentSign="";
        vm.cAFAttachmentPhoto="";
        vm.saveCompleteProjectDetail=saveCompleteProjectDetail;
        vm.projectlog=projectLog;
        $scope.file = {};
        var cafflag=0;

        function addProject_phaseData(){
          vm.project_phase.projectid="";
          vm.completeprojectphasedata.push(vm.project_phase);
          vm.project_phase={};
        }
//        vm.term_declaration_accept.acceptance.value=false;
         // delete the selected rows from table
        vm.removeRow = function(phase){
            var index = -1;
            var comArr =eval(vm.completeprojectphasedata);

            for( var i = 0; i < comArr.length; i++ ) {
                if( comArr[i].phase=== phase) {
                    index = i;
                    break;
                }
            }
           vm.completeprojectphasedata.splice( index, 1 );
          };

       //Start raw material
        vm.projectrawmaterialdata=[];
        vm.addProject_rawmaterialData=addProject_rawmaterialData;
              function addProject_rawmaterialData(){
                  if(angular.isDefined(vm.project_rawmaterial.selectedUnit))
                  {
                      vm.project_rawmaterial.units=vm.project_rawmaterial.selectedUnit.unittypes;
                  }
                  else
                  {
                      vm.project_rawmaterial.units="";
                  }

                 vm.projectrawmaterialdata.push(vm.project_rawmaterial);
                               //reinstantiate your $scope.formVariable so that your form is empty
                 vm.project_rawmaterial={};
               }

             vm.removeRawRow = function(rawmaterial){
                 var index = -1;
                 var comArr =eval(vm.projectrawmaterialdata);

                 for( var i = 0; i < comArr.length; i++ ) {
                     if( comArr[i].rawmaterial=== rawmaterial) {
                         index = i;
                         break;
                     }
                 }
                vm.projectrawmaterialdata.splice( index, 1 );
              };

            // Start main product
       vm.projectmainproductdata=[];
       vm.addProject_mainproductData=addProject_mainproductData;

            function addProject_mainproductData(){
                if(angular.isDefined(vm.product.selectedUnit))
                {
                     vm.product.units=vm.product.selectedUnit.unittypes;
                }
                else
                {
                   vm.product.units="";
                }
                vm.projectmainproductdata.push(vm.product);
                //reinstantiate your $scope.formVariable so that your form is empty
                vm.product={};
            }
       vm.removeMainRow = function(mainproduct){
                var index = -1;
                var comArr =eval(vm.projectmainproductdata);

                for( var i = 0; i < comArr.length; i++ ) {
                    if(comArr[i].mainproduct=== mainproduct) {
                        index = i;
                        break;
                    }
                }
                vm.projectmainproductdata.splice( index, 1 );
       };

                  //End main product

       vm.projectprocessflowstepdata=[];
       vm.addProject_processflowstepData=addProject_processflowstepData;
       function addProject_processflowstepData(){
           vm.projectprocessflowstepdata.push(vm.projectprocessflowstep);
           //reinstantiate your $scope.formVariable so that your form is empty
          vm.projectprocessflowstep={};
       }
       vm.removeStepRow = function(steps){
            var index = -1;
            var comArr =eval(vm.projectprocessflowstepdata);
              for( var i = 0; i < comArr.length; i++ ) {
                if( comArr[i].steps=== steps) {
                    index = i;
                    break;
                }
              }
          vm.projectprocessflowstepdata.splice( index, 1 );
       };

                        // Start emission detail
       vm.emissiondetaildata=[];
       vm.addProject_emissiondetailData=addProject_emissiondetailData;
       function addProject_emissiondetailData() {
              if(angular.isDefined(vm.emissiondetail.selectedParticular))
               {
               vm.emissiondetail.particulars=vm.emissiondetail.selectedParticular.particulars;
               }
              else
               {
              vm.emissiondetail.particulars="";
               }

               if(angular.isDefined(vm.emissiondetail.selectedTypeoffuel))
                {
                   vm.emissiondetail.type_of_fuel=vm.emissiondetail.selectedTypeoffuel.typeoffuel;
                }
               else
                {
                  vm.emissiondetail.type_of_fuel="";
                }

               if(angular.isDefined(vm.emissiondetail.selectedAirpollutioncontroldevice))
                {
                 vm.emissiondetail.air_pollution_control_device=vm.emissiondetail.selectedAirpollutioncontroldevice.airpollutioncontroldevice;
                 }
               else
                {
               vm.emissiondetail.air_pollution_control_device="";
                }

             vm.emissiondetaildata.push(vm.emissiondetail);
            //reinstantiate your $scope.formVariable so that your form is empty
            vm.emissiondetail={};
       }

       vm.removeEmissionRow = function(selectedParticular){
                       var index = -1;
                       var comArr =eval(vm.emissiondetaildata);

                       for( var i = 0; i < comArr.length; i++ ) {
                           if( comArr[i].selectedParticular=== selectedParticular) {
                               index = i;
                               break;
                           }
                       }
                 vm.emissiondetaildata.splice( index, 1 )
       };

           // End emission detail

          // Start waste water detail
       vm.wastewaterdetaildata=[];
       vm.addProject_wastewaterdetailData=addProject_wastewaterdetailData;
       function addProject_wastewaterdetailData(){
              if(angular.isDefined(vm.wastewaterdetail.selectedNaturetype))
              {
               vm.wastewaterdetail.naturetype=vm.wastewaterdetail.selectedNaturetype.naturetype;

                   }
               else
                 {
                vm.wastewaterdetail.naturetype="";
                  }

               if(angular.isDefined(vm.wastewaterdetail.selectedModeofdisposal))
               {
                 vm.wastewaterdetail.mode_of_disposal=vm.wastewaterdetail.selectedModeofdisposal.disposal_for_discharge
                  }
               else
                 {
               vm.wastewaterdetail.mode_of_disposal="";
                  }
         vm.wastewaterdetaildata.push(vm.wastewaterdetail);
         vm.wastewaterdetail={};
       }
       vm.removeSourceRow = function(source_of_generation){
          var index = -1;
          var comArr =eval(vm.wastewaterdetaildata);

          for( var i = 0; i < comArr.length; i++ ) {
              if( comArr[i].source_of_generation=== source_of_generation) {
                  index = i;
                  break;
              }
          }
          vm.wastewaterdetaildata.splice( index, 1 );
         };
//End waste water

        vm.investor=investor;
        vm.landrequirementcaf=landrequirementcaf;
        vm.companydetail=companydetail;
        vm.projectdetail=projectdetail;
        vm.projectsitedetail=projectsitedetail;
        vm.electricrequirement=electricrequirement;
        vm.manufacturingdetail=manufacturingdetail;
        vm.project_finance_investment=project_finance_investment;
        vm.projectcombinecodes=projectcombinecodes;
        vm.environmentimpactdetail=environmentimpactdetail;
        vm.term_declaration_accept=term_declaration_accept;
        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;

        function checkDropDowns()
        {
            if (angular.isDefined(vm.investor.selectedCountry))
                vm.investor.countryname=vm.investor.selectedCountry.countryname;
            if (angular.isDefined(vm.investor.selectedState))
                vm.investor.statename=vm.investor.selectedState.statename;
            if (angular.isDefined(vm.investor.selectedCity))
                vm.investor.cityname=vm.investor.selectedCity.districtname;
            if (angular.isDefined(vm.companydetail.selectedBusiness))
                vm.companydetail.businessentitytype=vm.companydetail.selectedBusiness.businessentitytype;
            if (angular.isDefined(vm.projectdetail.selectedSector))
                vm.projectdetail.sectorname=vm.projectdetail.selectedSector.sectortype;
            if (angular.isDefined(vm.projectdetail.selectedSizeOfIndustry))
                vm.projectdetail.size_of_industry=vm.projectdetail.selectedSizeOfIndustry.sizeofindustry;
            if (angular.isDefined(vm.projectdetail.selectedProjectType))
                vm.projectdetail.projectype=vm.projectdetail.selectedProjectType.projectypes;
            if (angular.isDefined(vm.projectdetail.selectedProjectCategory))
                vm.projectdetail.category_of_project=vm.projectdetail.selectedProjectCategory.categorytype;
            if (angular.isDefined(vm.projectdetail.selectedCountry))
                vm.projectdetail.collaboration_with_foreign_country=vm.projectdetail.selectedCountry.countryname;
            if (angular.isDefined(vm.projectdetail.selectedApprovalForm))
                vm.projectdetail.approval_application_form=vm.projectdetail.selectedApprovalForm.existingapprovalforms;

            if (angular.isDefined(vm.projectsitedetail.selectedDistrict))
                vm.projectsitedetail.district=vm.projectsitedetail.selectedDistrict.districtname;
            if (angular.isDefined(vm.projectsitedetail.selectedBlock))
                vm.projectsitedetail.block=vm.projectsitedetail.selectedBlock.blockname;
            if (angular.isDefined(vm.projectsitedetail.selectedCityTownVillage))
                vm.projectsitedetail.city_town_village=vm.projectsitedetail.selectedCityTownVillage.city_town_village_name;
            if (angular.isDefined(vm.projectsitedetail.selectedConnectingRoad))
                vm.projectsitedetail.connectingroad=vm.projectsitedetail.selectedConnectingRoad.connectingraodtype;
            if (angular.isDefined(vm.projectsitedetail.selectedLandZoneUseType))
                vm.projectsitedetail.landzoneuse_type=vm.projectsitedetail.selectedLandZoneUseType.landzoneclassificationtype;

            if (angular.isDefined(vm.project_finance_investment.selectedcountryid))
                vm.project_finance_investment.fdi_country=vm.project_finance_investment.selectedcountryid.countryname;
            if (angular.isDefined(vm.foreignfundingresources.selectedforeignfundingresourceid))
                vm.project_finance_investment.foreign_funding_source= vm.foreignfundingresources.selectedforeignfundingresourceid.foreignfundingtypes;

            if (angular.isDefined(vm.environmentimpactdetail.selectedWatersource))
                vm.environmentimpactdetail.source_of_water_supply=vm.environmentimpactdetail.selectedWatersource.watersupplysourcetype;
            if (angular.isDefined(vm.environmentimpactdetail.selectedTreatmentone))
                vm.environmentimpactdetail.recycling_process= vm.environmentimpactdetail.selectedTreatmentone.treatment1;
            if (angular.isDefined(vm.environmentimpactdetail.selectedTreatmenttwo))
                vm.environmentimpactdetail.recycling_cooling=vm.environmentimpactdetail.selectedTreatmenttwo.treatment2;
            if (angular.isDefined(vm.environmentimpactdetail.selectedTreatmentthree))
                vm.environmentimpactdetail.recycling_domestic= vm.environmentimpactdetail.selectedTreatmentthree.treatment3;
            if (angular.isDefined(vm.environmentimpactdetail.selectedDischarge))
                vm.environmentimpactdetail.mode_of_disposal_for_discharge= vm.environmentimpactdetail.selectedDischarge.disposal_for_discharge;

            if (angular.isDefined(vm.electricrequirement.selectedCustomerType))
                vm.electricrequirement.customertype= vm.electricrequirement.selectedCustomerType.customertype;
        }

        function saveCompleteProjectDetail(flag)
        {

            vm.isSaving = true;
            checkDropDowns();
            if(flag=='Final')
            {
                vm.investor.cafpin=1;
                cafflag=1;
            }
            vm.CompleteProjectDetail.investorDTO=vm.investor;
            if (vm.landrequired){
                vm.CompleteProjectDetail.landrequirementcafDTO=vm.landrequirementcaf;
            }
            vm.CompleteProjectDetail.companydetailDTO=vm.companydetail;
            vm.CompleteProjectDetail.projectdetailDTO=vm.projectdetail;
            vm.CompleteProjectDetail.projectsitedetailDTO=vm.projectsitedetail;
            vm.CompleteProjectDetail.project_finance_investmentDTO=vm.project_finance_investment;
            vm.CompleteProjectDetail.manufacturingdetailDTO=vm.manufacturingdetail;
            vm.CompleteProjectDetail.environment_impactdetailDTO=vm.environmentimpactdetail;
            vm.CompleteProjectDetail.electricrequirementDTO=vm.electricrequirement;
            vm.CompleteProjectDetail.projectdetailcombinecodesDTO =vm.projectcombinecodes;
            vm.CompleteProjectDetail.project_phaseDTOList=vm.completeprojectphasedata;
            vm.CompleteProjectDetail.projectrawmaterialDTOList=vm.projectrawmaterialdata;
            vm.CompleteProjectDetail.term_declaration_acceptDTO=vm.term_declaration_accept;

            vm.CompleteProjectDetail.projectproductDTOList=vm.projectmainproductdata;
            vm.CompleteProjectDetail.projectprocessflowstepsDTOList=vm.projectprocessflowstepdata;
            vm.CompleteProjectDetail.emissiondetailDTOList=vm.emissiondetaildata;
            vm.CompleteProjectDetail.wastewaterdetailDTOList= vm.wastewaterdetaildata;
            console.log(vm.projectsitedetail.totalproposedprojectarea);
            console.log(vm.project_finance_investment.total_project_cost);
            Projectcompletedetail.save(vm.CompleteProjectDetail,onSaveCompleteProjectSuccess,onSaveCompleteProjectError);
        }
        function onSaveCompleteProjectSuccess (resultCompleteProject) {
            $scope.$emit('investhryApp:projectdetailUpdate', resultCompleteProject);
            vm.resultCompleteProject=resultCompleteProject;
            vm.isSaving = false;
            vm.uploadFiles(vm.resultCompleteProject.projectdetailcombinecodesDTO.id);
            if(resultCompleteProject.investorDTO.cafpin.length == 10)
            {
                if(cafflag == 1)
                {
                    vm.projectlog.actiontype = "CAF Added";
                }
                else
                {
                    vm.projectlog.actiontype = "CAF Edited";
                }
                vm.projectlog.projectid = vm.resultCompleteProject.projectdetailcombinecodesDTO.id;
                vm.projectlog.actiontaken = "Added CAF.";
                Projectlog.save(vm.projectlog, onProjectLogSaveSuccess, onProjectLogSaveError);
            }
            alert('saved');
            $state.go('listproject');
        }
        function onSaveCompleteProjectError () {
            vm.isSaving = false;
            alert('not saved');
        }

        function onProjectLogSaveSuccess(result)
        {

        }
        function onProjectLogSaveError()
        {

        }

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });


        $scope.loadStates = function (obj) {
        vm.statebycountry=StateCountry.query({countryID : obj.id});
        }

        $scope.loadDistrict = function(obj)
        {
        vm.districtbystate=DistrictState.query({stateID : obj.id});
       // vm.city_town_villages = vm.districtbystate;
        }

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }
        vm.IsVisible = false;
        vm.ShowPassport = function (value) {
            //If DIV is visible it will be hidden and vice versa.
            vm.IsVisible = value == "Y";
        }

       fillFormDataFromEntities();
       function fillFormDataFromEntities()
       {
       Country.query(function(result) {
           vm.countries = result;
           vm.searchQuery = null;
       });
       State.query(function(result) {
           vm.states = result;
           vm.searchQuery = null;
       });
       District.query(function(result) {
           vm.districts=result
           vm.searchQuery = null;
       });
       City_town_village.query(function(result) {
           vm.city_town_villages = result;
           vm.searchQuery = null;
       });

       Businessentitys.query(function(result) {
           vm.businessentities = result;
           vm.searchQuery = null;
       });
       Sector.query(function(result) {
           vm.sectors = result;
           vm.searchQuery = null;
       });
       Industrysize.query(function(result) {
           vm.industrysizes = result;
           vm.searchQuery = null;
       });
       Projectype.query(function(result) {
           vm.projectypes = result;
           vm.searchQuery = null;
       });
       Projectcategory.query(function(result) {
           vm.projectcategories = result;
           vm.searchQuery = null;
       });
       Foreignfundingresource.query(function(result) {
           vm.foreignfundingresources = result;
           vm.searchQuery = null;
       });
       Approvalforms.query(function(result) {
           vm.approvalforms = result;
           vm.searchQuery = null;
       });
       Block.query(function(result) {
           vm.blocks = result;
           vm.searchQuery = null;
       });
       Connectingroad.query(function(result) {
           vm.connectingroads = result;
           vm.searchQuery = null;
       });
       Landusezoneclassification.query(function(result) {
           vm.landusezoneclassifications = result;
           vm.searchQuery = null;
       });
       Watersupplysource.query(function(result) {
           vm.watersupplysources = result;
           vm.searchQuery = null;
       });
       Waste_water_disposal_mode.query(function(result) {
           vm.waste_water_disposal_modes = result;
               vm.searchQuery = null;
           });
       Emmision_pollution_controll.query(function(result) {
           vm.emmision_pollution_controlls = result;
           vm.searchQuery = null;
       });
       Emmision_fuel_type.query(function(result) {
           vm.emmision_fuel_types = result;
           vm.searchQuery = null;
       });

       Wwtreatmentone.query(function(result) {
              vm.treatment1 = result;
              vm.searchQuery = null;
          });
       Wwtreatmenttwo.query(function(result) {
             vm.treatment2 = result;
             vm.searchQuery = null;
         });
       Wwtreatmentthree.query(function(result) {
            vm.treatment3 = result;
            vm.searchQuery = null;
        });

        Manufacturingunits.query(function(result) {
            vm.manufacturingunits = result;
            vm.searchQuery = null;
          });

        Modeofdisposalfor_discharge.query(function(result) {
             vm.modeofdisposalfor_discharge = result;
             vm.searchQuery = null;
         });
        Particular.query(function(result) {
            vm.particulars = result;
            vm.searchQuery = null;
        });
        Waste_water_naturetype.query(function(result) {
            vm.waste_water_naturetype = result;
            vm.searchQuery = null;
        });
        Customertype.query(function(result) {
            vm.customerType = result;
            vm.searchQuery = null;
        });
       }
       function uploadFiles(projectid)
       {
            if(angular.isDefined(vm.cAFAttachmentPhoto.investorphoto)){
                var file=vm.cAFAttachmentPhoto.investorphoto;
                vm.cAFAttachmentPhoto.docName="Applicant Photo";
                vm.cAFAttachmentPhoto.projectid=projectid;
                CAFAttachment.save(vm.cAFAttachmentPhoto,onSaveCAFAttachmentPhotoSuccess,onSaveCAFAttachmentPhotoError);
            }
            if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
                var file=vm.cAFAttachmentSign.investorsign;
                vm.cAFAttachmentSign.docName="Signature";
                vm.cAFAttachmentSign.projectid=projectid;
                CAFAttachment.save(vm.cAFAttachmentSign,onSaveCAFAttachmentSignSuccess,onSaveCAFAttachmentSignError);
            }

            function onSaveCAFAttachmentPhotoSuccess (result) {
                $scope.$emit('investhryApp:cAFAttachmentUpdate', result);

                var filename = result.id;
                var file=vm.cAFAttachmentPhoto.investorphoto;
                FileManagement.saveFile(file,filename);
                var CAFAttachmentResultObject=result;

                var fileNameArray = file.name.split(".");
                var fileextension="";
                if((fileNameArray.length>1))
                {
                    fileextension=fileNameArray[(fileNameArray.length-1)];
                }

                var inputFileName=result.id;
                if(fileextension!=="")
                {
                    inputFileName=inputFileName+"."+fileextension;
                }
                CAFAttachmentResultObject.fileName=inputFileName;
                CAFAttachment.update(CAFAttachmentResultObject,onUpdateCAFAttachmentPhotoSuccess,onUpdateCAFAttachmentPhotoError);
                vm.isSaving = false;
            }
            function onSaveCAFAttachmentSignSuccess (result) {
                $scope.$emit('investhryApp:cAFAttachmentUpdate', result);

                var filename = result.id;
                var file=vm.cAFAttachmentSign.investorsign;
                FileManagement.saveFile(file,filename);
                var CAFAttachmentResultObject=result;

                var fileNameArray = file.name.split(".");
                var fileextension="";
                if((fileNameArray.length>1))
                {
                    fileextension=fileNameArray[(fileNameArray.length-1)];
                }

                var inputFileName=result.id;
                if(fileextension!=="")
                {
                    inputFileName=inputFileName+"."+fileextension;
                }
                CAFAttachmentResultObject.fileName=inputFileName;
                CAFAttachment.update(CAFAttachmentResultObject,onUpdateCAFAttachmentPhotoSuccess,onUpdateCAFAttachmentPhotoError);
                vm.isSaving = false;
            }

            function onSaveCAFAttachmentPhotoError()
            {
                vm.isSaving = false;
            }

            function onUpdateCAFAttachmentPhotoSuccess(result)
            {
                $scope.$emit('investhryApp:cAFAttachmentUpdate', result);
                vm.isSaving = false;
            }

            function onUpdateCAFAttachmentPhotoError()
            {
                vm.isSaving = false;
            }

            function onSaveCAFAttachmentSignError()
            {
                vm.isSaving = false;
            }

            function onSaveCAFAttachmentError () {
                vm.isSaving = false;
            }

       }
       checkRenewedProject();
    }
})();

//
// (function () {
//     'use strict';
//
//     angular
//         .module('investhryApp')
//         .factory('EditCafForUserService', EditCafForUserService);
//
//     EditCafForUserService.$inject = ['$resource'];
//
//     function EditCafForUserService($resource) {
//
//         var resourceUrl = '/api/project-edit';
//
//         return $resource(resourceUrl, {}, {
//
//             'save': {
//                 method: 'POST'
//             }
//
//         });
//     }
// })();




(function () {
    'use strict';

    angular
        .module('investhryApp')
        .factory('EditCafForUserService', EditCafForUserService);

    EditCafForUserService.$inject = ['$resource'];

    function EditCafForUserService($resource) {

        var resourceUrl = '/api/project-edit';

        return $resource(resourceUrl, {}, {

            save: {
                method: 'POST',
                transformRequest: angular.identity,   // 🔥 IMPORTANT
                headers: { 'Content-Type': undefined } // 🔥 VERY IMPORTANT
            }

        });
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('EditCafForUser', EditCafForUser);

    EditCafForUser.$inject = [
        '$state',
        'project',
        'EditCafForUserService',
        'District',
        'Businessentitys',
        'DistrictVillageBlockMapping'
    ];

    function EditCafForUser(
        $state,
        project,
        EditCafForUserService,
        District,
        Businessentitys,
        DistrictVillageBlockMapping
    ) {

        var vm = this;

        vm.proj = angular.copy(project);
        vm.originalProj = angular.copy(project);

        vm.isSaving = false;
        vm.cafType = vm.proj.caftype;

        vm.districts = [];
        vm.businessentities = [];
        vm.villages = [];

        // $scope.file = {};
        vm.form = {};  // IMPORTANT


        vm.updateSelectedFields = updateSelectedFields;
        vm.cancel = cancel;
        vm.getVillages = getVillages;
        vm.setBlockCategory = setBlockCategory;

        loadDropdowns();

        // ----------------------------------------

        function loadDropdowns() {

            District.query(function (result) {
                vm.districts = result;
            });

            Businessentitys.query(function (result) {
                vm.businessentities = result;
            });

            if (vm.proj.district) {
                getVillages(vm.proj.district);
            }
        }

        // ----------------------------------------

        function getVillages(districtName) {

            // vm.proj.village = null;
            // vm.proj.blockCategory = null;

            // alert("district came"+districtName)

            DistrictVillageBlockMapping.query(
                { id: '1', districtName: districtName },
                function (result) {
                    vm.villages = result;
                }
            );
        }

        // ----------------------------------------

        function setBlockCategory(villageName, villageList) {
            // alert("request came for block")

            angular.forEach(villageList, function (value) {
                if (value.village === villageName) {
                    vm.proj.blockCategory = value.category;

                    // alert("block is"+ vm.proj.blockCategory);
                }
            });
        }



        vm.getVillages = function (districtName) {
            DistrictVillageBlockMapping.query({id: '1',districtName: districtName},function(result) {
                vm.villages = result;
                vm.searchQuery = null;
                vm.proj.village = null;
                vm.proj.blockCategory = null;
            });
        };

        vm.setBlockCategory = function (villageName, villageList) {
            vm.villageNames =[];
            angular.forEach(villageList, function(value, key){
                vm.villageNames.push(value.village);
            });
            if(vm.villageNames.indexOf(villageName) !== -1){
                vm.invalidVillage = false;
                vm.proj.blockCategory = villageList[vm.villageNames.indexOf(villageName)].category;
            }
            else {
                vm.invalidVillage = true;
            }
        };



        function updateSelectedFields() {


            if (vm.maxSizeError2mbtest || vm.fileTypeErrortest) {
                return; // stop backend call
            }

            vm.isSaving = true;

            var formData = new FormData();



            // Only send selected fields
            var updatePayload = {
                newbusinessentity: vm.proj.businessentity,
                oldbusinessentity: vm.originalProj.businessentity,
                newBusinessEntityType: vm.proj.businessentitytype,
                oldBusinessEntityType: vm.originalProj.businessentitytype,
                newDistrict: vm.proj.district,
                oldDistrict: vm.originalProj.district,
                newVillage: vm.proj.village,
                oldVillage: vm.originalProj.village,
                newBlockCategory: vm.proj.blockCategory,
                oldBlockCategory: vm.originalProj.blockCategory,
                newSiteAddress: vm.proj.siteaddress,
                oldSiteAddress: vm.originalProj.siteaddress,
                cafpin: vm.originalProj.cafpin,
                caftype: vm.originalProj.caftype
            };

            formData.append('data', new Blob([angular.toJson(updatePayload)], { type: "application/json" }));


            // Append file if present
            if (vm.form.file) {
                formData.append('file', vm.form.file);
            }

            // alert("Sending payload: " + JSON.stringify(updatePayload));

            EditCafForUserService.save(formData,
                function success(response) {
                    alert("Your CAF Change Request has been submitted successfully");
                    vm.isSaving = false;

                    $state.go('edit-caf-requests');


                },
                function error(response) {
                    vm.isSaving = false;

                    // Check if backend sent a message
                    if (response.data && response.data.message) {
                        alert("Error: " + response.data.message);
                    } else {
                        alert("CAF Update Failed");
                    }
                }
            );
        }


        // ----------------------------------------

        function cancel() {
            $state.go('listproject');
        }


        // vm.validateFile = function () {
        //
        //     vm.fileSizeError = false;
        //     vm.fileTypeError = false;
        //
        //     var file = vm.form.file;
        //
        //     if (!file) return;
        //
        //     var maxSize = 2 * 1024 * 1024; // 2MB
        //
        //     if (file.type !== "application/pdf") {
        //         vm.fileTypeError = true;
        //         vm.form.file = null;
        //         return;
        //     }
        //
        //     if (file.size > maxSize) {
        //         vm.fileSizeError = true;
        //         vm.form.file = null;
        //         return;
        //     }
        // };






        vm.maxSizeError2mbtest = false;
        vm.fileTypeErrortest = false;

        vm.checkFileValidation = function () {

            alert("testinggggggg");

            vm.maxSizeError2mbtest = false;
            vm.fileTypeErrortest = false;

            if (vm.form.file) {

                var fileSize = vm.form.file.size;
                var maxSize = 2 * 1024 * 1024;
                var allowedType = "application/pdf";

                if (fileSize > maxSize) {
                    vm.maxSizeError2mbtest = true;
                    vm.form.file = null;
                    return;
                }

                if (vm.form.file.type !== allowedType) {
                    vm.fileTypeErrortest = true;
                    vm.form.file = null;
                    return;
                }
            }
        };












    //
    //     vm.applyTowerRemoval = function () {
    //
    //         // Create FormData object
    //         var formData = new FormData();
    //
    //         // Append JSON data as a Blob
    //         var dto = {
    //             district: vm.selectedDistrict.districtname,
    //             businessEntity: vm.form.selectedEntity.id,
    //             serviceName:vm.form.service,
    //             remark: vm.form.remark,
    //             status: "Pending"
    //         };
    //
    //
    //         formData.append('data', new Blob([angular.toJson(dto)], { type: "application/json" }));
    //
    //         // Append file if present
    //         if (vm.form.file) {
    //             formData.append('file', vm.form.file);
    //         }
    //
    //         console.log("formdataaa" + formData);
    //
    //         // Send the request
    //         TowerRemovalApplyService.save(formData,
    //             function success() {
    //                 alert(" Request Submitted successfully!");
    //                 loadApplicationAppliedBy();
    //
    //                 // 🔥 RESET ALL MODELS
    //                 vm.form = {};
    //                 vm.selectedDistrict = null;
    //                 vm.businessEntities = [];
    //                 vm.services = [];
    //
    //                 // 🔥 RESET FILE INPUT MANUALLY
    //                 document.querySelector('input[type="file"]').value = null;
    //
    //                 // 🔥 RESET ANGULAR FORM STATE
    //                 if ($scope.inspectionForm) {
    //                     $scope.inspectionForm.$setPristine();
    //                     $scope.inspectionForm.$setUntouched();
    //                 }
    //             },
    //             function error(err) {
    //                 console.log("Error in submitting:", err);
    //             });
    //
    //     };
    }




})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('CAFTypeController', CAFTypeController);

    CAFTypeController.$inject = ['$scope','$state','$uibModalInstance','Projectlist','$filter'];

    function CAFTypeController($scope,$state,$uibModalInstance, Projectlist, $filter) {

        var vm = this;
        vm.clear = clear;

        function clear () {
           $uibModalInstance.dismiss('cancel');
        }

        vm.onprojectTypeSelected=function(){
            if(vm.projectType=='LANDREQUIREMENT'){
            $uibModalInstance.close();
            $state.go('addCAFlandreq',{},{reload:true});
            }
            if(vm.projectType=='SHOP'){
            $uibModalInstance.close();
            $state.go('addCAFshop',{},{reload:true});
            }
            if(vm.projectType=='RENEWABLE'){
            $uibModalInstance.close();
            $state.go('addCAFrenewable',{},{reload:true});
            }
            if(vm.projectType=='NEW'){
                Projectlist.projectList.query({id: "1", status: "All"}, function (result) {
                    vm.newCAFsList = $filter('filter')(result.content,{ caftype : 'New' }, true);
                    if (vm.newCAFsList.length > 0){
                        Swal.fire({
                            title: 'Attention!',
                            type: 'info',
                            html:
                                "You've already applied for a 'New' type of CAF from this account. " +
                                "If you continue then you'll be redirected to expand/diversify existing New CAF",
                            showCloseButton: true,
                            showCancelButton: true,
                            focusConfirm: false,
                            confirmButtonText:
                                'Expand/Diversify',
                            cancelButtonText:
                                'View CAFs',
                        }).then(function (result) {
                            if (result.value) {
                                $uibModalInstance.close();
                                $state.go('addCAFnewRestricted',{
                                    "id": vm.newCAFsList[0].projectid
                                },{reload:true});
                            }else {
                                $uibModalInstance.close();
                                $state.go('listproject',{},{reload:true});
                            }
                        });
                    }else {
                        $uibModalInstance.close();
                        $state.go('addCAFnew',{},{reload:true});
                    }
                });

            }
            if(vm.projectType=='TOWERCAF'){
            $uibModalInstance.close();
            $state.go('addCAFtower',{},{reload:true});
            }
            if(vm.projectType=='LANDEXCHANGE'){
                $uibModalInstance.close();
                $state.go('addCAFlandExchange',{},{reload:true});
            }
            if(vm.projectType=='FILMCAF'){
                $uibModalInstance.close();
                $state.go('addCAFfilm',{},{reload:true});
            }
            if(vm.projectType==='EXCISE'){
                $uibModalInstance.close();
                $state.go('addCAFexcise',{},{reload:true});
            }
            // if(vm.projectType==='ROW'){
            //     $uibModalInstance.close();
            //     $state.go('addCAFrow',{},{reload:true});
            // }
        }

    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('CAFOtp', CAFOtp);

    CAFOtp.$inject = ['$resource', 'DateUtils'];

    function CAFOtp ($resource, DateUtils) {
        var resourceUrl =  'api/cafOTP/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AddCAFtowerController', AddCAFtowerController);

    AddCAFtowerController.$inject = ['$scope', '$sessionStorage','$http', 'Principal', 'LoginService', '$state', 'AddCAF', 'project','District', 'cAFAttachment', 'FileManagement', 'CAFAttachment', 'cafAttachments','CheckContent'];

    function AddCAFtowerController ($scope, $sessionStorage, $http, Principal, LoginService, $state, AddCAF, project, District, cAFAttachment, FileManagement, CAFAttachment, cafAttachments,CheckContent) {
        var vm = this;

        vm.landreq = project;
        vm.cAFAttachment=cAFAttachment;
        vm.cAFAttachmentSign="";
        $scope.file = {};
        vm.cafAttachments = cafAttachments;
        vm.investorsign=null;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.businessEntities = [];
        vm.selectedBusinessEntity = null;
        vm.isBusinessEntityAutoSelected = false;
        vm.isDistrictAutoSelected = false;
        vm.isMobileAutoFilled = false;
        vm.onBusinessEntityChange = onBusinessEntityChange;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();
        loadBusinessEntities();

        var businessEntity = $sessionStorage.businessEntity;

        var district = $sessionStorage.districtCode;
       var sessionMobile=  $sessionStorage.mobile;
       var beCode=  $sessionStorage.beCode;




        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                if(vm.landreq.id==null){
                vm.landreq.firstname = account.firstName;
                vm.landreq.lastname = account.lastName;
                vm.landreq.emailprimary = account.email;
                vm.landreq.mobilenumber = account.phone;
                }
                vm.isAuthenticated = Principal.isAuthenticated;
                if (sessionMobile) {

                    vm.landreq.mobilenumber = sessionMobile;

                    vm.isMobileAutoFilled = true;

                    console.log("Mobile auto filled:", vm.landreq.mobilenumber);
                }

            });
        }
        function register () {
            $state.go('register');
        }






        // function loadBusinessEntities() {
        //
        //     CAFAttachment.getBusinessEntities().$promise
        //         .then(function(response) {
        //
        //             console.log(response);
        //
        //             if (response.status === "true") {
        //                 vm.businessEntities = response.data;
        //             }
        //
        //         })
        //         .catch(function(error) {
        //             console.error(error);
        //         });
        // }

        function loadBusinessEntities() {

            CAFAttachment.getBusinessEntities().$promise
                .then(function(response) {

                    console.log("Business Entity API Response:", response);

                    if (response.status === "true") {

                        vm.businessEntities = response.data;

                        // Business Entity received from CenterRedirectUrlController
                        var businessEntityFromSession =
                            $sessionStorage.businessEntity;

                        console.log(
                            "Business Entity received:",
                            businessEntityFromSession
                        );

                        if (businessEntityFromSession && vm.businessEntities.length > 0) {

                            var matchedEntity = vm.businessEntities.find(function(entity) {
                                vm.isBusinessEntityAutoSelected = true;

                                return entity.name &&
                                    entity.name.trim().toLowerCase() ===
                                    businessEntityFromSession.trim().toLowerCase();

                            });

                            if (matchedEntity) {

                                vm.landreq.businessentity = businessEntityFromSession;

                                // Save Business Entity Code
                                vm.landreq.businessentitycode = "BE"+beCode;

                                console.log(
                                    "Matched Business Entity:",
                                    matchedEntity
                                );

                                // Set the value according to your dropdown ng-model

                                vm.selectedBusinessEntity = matchedEntity;

                            } else {

                                console.log(
                                    "Business Entity not found:",
                                    businessEntityFromSession
                                );
                            }
                        }
                    }

                })
                .catch(function(error) {
                    console.error(error);
                });
        }

        function onBusinessEntityChange() {

            if (vm.selectedBusinessEntity) {

                // Save Business Entity Name
                vm.landreq.businessentity = vm.selectedBusinessEntity.name;

                // Save Business Entity Code
                vm.landreq.businessentitycode = vm.selectedBusinessEntity.be_code;


                console.log("Name : " + vm.landreq.businessentity);
                console.log("Code : " + vm.landreq.businessentitycode);
            }
        }


        vm.districts = [];

        loadAllDistrict();

        function loadAllDistrict() {

            District.query(function(result) {

                vm.districtstemp = result;

                angular.forEach(vm.districtstemp, function(value, key) {

                    if (value.districtname !== 'Narnaul' &&
                        value.districtname !== 'Chandigarh HQ') {

                        vm.districts.push(value);
                    }
                });

                // -----------------------------------------
                // Auto-select district from session
                // -----------------------------------------

                var sessionDistrictCode = $sessionStorage.districtCode;

                console.log("Session District Code:", sessionDistrictCode);

                if (sessionDistrictCode) {

                    var matchedDistrict = vm.districts.find(function(district) {

                        return String(district.districtCode) ===
                            String(sessionDistrictCode);

                    });

                    if (matchedDistrict) {
                        vm.isDistrictAutoSelected = true;

                        console.log("Matched District:", matchedDistrict);

                        // Your ng-model stores districtname
                        vm.landreq.district = matchedDistrict.districtname;

                        console.log(
                            "Auto selected District:",
                            vm.landreq.district
                        );

                    } else {

                        console.log(
                            "District not found for code:",
                            sessionDistrictCode
                        );
                    }
                }

                vm.searchQuery = null;
            });
        }


//    vm.changeInCost=function(){
//          var projectCostInCrore=vm.project_cost_in_crore || '00';
//          var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
//          var projectCostInThousands=vm.project_cost_in_thousands||'00';
//          if(vm.project_cost_in_lacs<10){
//             projectCostInLacs='0'+vm.project_cost_in_lacs;
//          }
//          if(vm.project_cost_in_thousands<10){
//             projectCostInThousands='0'+vm.project_cost_in_thousands;
//          }
//return vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
//          }


//    var calculateCostInCrore=function(){
//       return parseInt(vm.landreq.total_project_cost.toString().split('.')[0]);
//    }

//    var calculateCostInLacs=function(){
//       if(vm.landreq.total_project_cost.toString().indexOf('.')!=-1){
//       return parseInt(vm.landreq.total_project_cost.toString().split('.')[1].substring(0,2));
//       }
//       return 0;
//    }

//    var calculateCostInThousands=function(){
//       if(vm.landreq.total_project_cost.toString().indexOf('.')!=-1){
//        return parseInt(vm.landreq.total_project_cost.toString().split('.')[1].substring(2,4));
//       }
//       return 0;
//    }

//     vm.project_cost_in_crore = calculateCostInCrore();
//     vm.project_cost_in_lacs = calculateCostInLacs();
//     vm.project_cost_in_thousands = calculateCostInThousands();

//       var projectCostInCrore=vm.project_cost_in_crore || '00';
//       var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
//       var projectCostInThousands=vm.project_cost_in_thousands||'00';
//       if(vm.project_cost_in_lacs<10){
//          projectCostInLacs='0'+vm.project_cost_in_lacs;
//       }
//       if(vm.project_cost_in_thousands<10){
//          projectCostInThousands='0'+vm.project_cost_in_thousands;
//       }
//       vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;


     vm.onsaveProject = onsaveProject;

     function onsaveProject(flag){
       vm.isSaving = true;
//       vm.landreq.total_project_cost = vm.total_project_cost;
       if(flag=='Draft'){
          vm.landreq.isdraft=true;
       }
       else if(flag=='Final'){
          vm.landreq.isdraft=false;
       }
         if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
             var sign =vm.cAFAttachmentSign.investorsign;
             var fileNameArray = sign.name.split(".");

             if(fileNameArray.length<3) {
                 if (fileNameArray[0] != "") {
                     var idxDot = sign.name.lastIndexOf(".") + 1;
                     var extFile = sign.name.substr(idxDot, sign.length).toLowerCase();

                     if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
                         saveCAF();
                     }
                     else {
                         alert("Only jpg/jpeg and png files are allowed!");
                     }
                 }
                 else {
                     alert("Invalid File Name");
                 }
             }
             else{
                 alert('Signature File should be in appropriate format')
             }
         }
         else {
             saveCAF();
         }


     }


     function onSaveProjectSuccess(result){
        uploadFile(result.id);
        vm.isSaving = false;
     }

     function onSaveProjectError(){
        alert('CAF Not Saved');
        vm.isSaving = false;
     }

        vm.verifyPan = function() {

            // ng-disabled="shopform.$invalid || file.maxSizeError"

            var inputData = {
                pan: vm.landreq.pan_number,
                name: vm.landreq.businessentity,
                fathername: '',
                dob:'01/01/2015'
            };

            AddCAF.verifyPan(inputData, function(response) {
                console.log('Raw API Response:', response);
                // Extract only the numbered properties from the response manually
                var message = '';
                for (var key in response) {
                    if (response.hasOwnProperty(key) && !isNaN(key)) {
                        message += response[key]; // Append only numeric keys
                    }
                }
                console.log('Extracted Message:', message);
                if (message.indexOf('verified') !== -1) {
                    vm.panSuccessMessage = message; // Display success response
                    vm.panErrorMessage = ''; // Clear error message
                } else {
                    vm.panErrorMessage = message; // Display error response
                    vm.panSuccessMessage = ''; // Clear success message
                }
            }, function(error) {
                vm.panErrorMessage = 'An error occurred while verifying PAN. Please try again.';
                console.error('Error from verifyPan API:', error);
            });

        };

     function uploadFile(projectid)
     {
         if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
             vm.cAFAttachment.docName="Signature";
             vm.cAFAttachment.projectid=projectid;
             CAFAttachment.save(vm.cAFAttachment,onSaveCAFAttachmentSignSuccess,onSaveCAFAttachmentSignError);
         }
         function onSaveCAFAttachmentSignSuccess (result) {
             $scope.$emit('investhryApp:cAFAttachmentUpdate', result);
             vm.cafattachresult = result;
             var cafattachmentid = result.id;

             var filename = result.id;
             var file = vm.cAFAttachmentSign.investorsign;
             FileManagement.saveFile(file,filename,onFileSaveSuccess,onFileSaveError(cafattachmentid));
             vm.isSaving = false;
         }

         function onFileSaveSuccess(result){
         $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachresult);
             var CAFAttachmentResultObject=vm.cafattachresult;
             var filename = CAFAttachmentResultObject.id;
             var file = vm.cAFAttachmentSign.investorsign;
             var fileNameArray = file.name.split(".");
             var fileextension="";
             if((fileNameArray.length>1))
             {
                 fileextension=fileNameArray[(fileNameArray.length-1)];
             }

             var inputFileName = CAFAttachmentResultObject.id;
             if(fileextension!=="")
             {
                 inputFileName=inputFileName+"."+fileextension;
             }
             CAFAttachmentResultObject.fileName=inputFileName;
             CAFAttachment.update(CAFAttachmentResultObject);
         }
         function onFileSaveError(cafattachmentid)
         {
             CAFAttachment.delete({id:cafattachmentid});

         }
         function onSaveCAFAttachmentSignError()
         {
             vm.isSaving = false;
         }
     }


     for(var attachmentcounter=0;attachmentcounter<vm.cafAttachments.length;attachmentcounter++)
      {
        if(vm.cafAttachments[0].docName=="Signature")
        {
            vm.investorsign=vm.cafAttachments[0];
        }
      }

     function onUpdateProjectSuccess(result)
     {
         replaceUploadedSign(result);
         vm.isSaving = false;
     }
     function onUpdateProjectError(result){
         alert('CAF Not Edited');
         vm.isSaving = false;
     }

     function replaceUploadedSign(result)
     {
         if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
            if(vm.investorsign!==null){
              var file = vm.cAFAttachmentSign.investorsign;
              var filename = vm.investorsign.id;
              FileManagement.saveFile(file,filename,onreplaceUploadedSignSuccess,onreplaceUploadedSignError);
            }
            else
            {
              uploadFile(result.id);
            }
         }
         function onreplaceUploadedSignSuccess(){
               var file = vm.cAFAttachmentSign.investorsign;
               var filename = vm.investorsign.id;
               var fileNameArray = file.name.split(".");
               var fileextension="";
               if((fileNameArray.length>1))
               {
                   fileextension=fileNameArray[(fileNameArray.length-1)];
               }

               var inputFileName=vm.investorsign.id;
               if(fileextension!=="")
               {
                   inputFileName=inputFileName+"."+fileextension;
               }
               vm.investorsign.fileName=inputFileName;
               CAFAttachment.update(vm.investorsign,onUpdateCAFAttachmentSignSuccess,onUpdateCAFAttachmentSignError);
               vm.isSaving = false;
         }
         function onreplaceUploadedSignError(){
               vm.isSaving=false;
         }
         function onUpdateCAFAttachmentSignSuccess(){
               vm.isSaving=false;
         }
         function onUpdateCAFAttachmentSignError(){
               vm.isSaving=false;
         }
     }

     function saveCAF() {
         if (vm.landreq.id !== null) {
             AddCAF.update(vm.landreq,onUpdateProjectSuccess,onUpdateProjectError);
             alert('CAF Edited');
             // CAF saved successfully

             delete $sessionStorage.isFromCentralPortal;
             delete $sessionStorage.businessEntity;
             delete $sessionStorage.beCode;
             delete $sessionStorage.districtCode;
             delete $sessionStorage.mobile;

             console.log("Central Portal session values cleared");

         }
         else{
             AddCAF.save(vm.landreq,onSaveProjectSuccess,onSaveProjectError);
             if(vm.landreq.isdraft === true){
                 alert('Please note that any draft CAF saved in the system for more than 10 days shall be automatically deleted. Hence, you are requested to submit the CAF along with the required information within the prescribed time limit.\n' +
                     'Kindly contact our helpdesk at 1800-180-2132 in case you need any assistance in filling out the CAF Form.');
             }
             else {
                 alert('CAF Saved');
             }

             delete $sessionStorage.isFromCentralPortal;
             delete $sessionStorage.businessEntity;
             delete $sessionStorage.beCode;
             delete $sessionStorage.districtCode;
             delete $sessionStorage.mobile;


         }
         $state.go('listproject');
     }
        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AddCAFshopController', AddCAFshopController);

    AddCAFshopController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'AddCAF', 'project','District', 'cAFAttachment', 'FileManagement', 'CAFAttachment', 'cafAttachments', 'DistrictVillageBlockMapping','CheckContent'];

    function AddCAFshopController ($scope, Principal, LoginService, $state, AddCAF, project, District, cAFAttachment, FileManagement, CAFAttachment, cafAttachments, DistrictVillageBlockMapping,CheckContent) {
        var vm = this;

        vm.landreq = project;
        vm.cAFAttachment=cAFAttachment;
        vm.cAFAttachmentSign="";
        $scope.file = {};
        vm.cafAttachments = cafAttachments;
        vm.investorsign=null;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                if(vm.landreq.id==null){
                vm.landreq.firstname = account.firstName;
                vm.landreq.lastname = account.lastName;
                vm.landreq.emailprimary = account.email;
                vm.landreq.mobilenumber = account.phone;
                }
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }


        vm.districts = [];
        loadAllDistrict();
        function loadAllDistrict(){
            District.query(function(result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

        vm.getVillages = function (districtName) {
            DistrictVillageBlockMapping.query({id: '1',districtName: districtName},function(result) {
                vm.villages = result;
                vm.searchQuery = null;
                vm.landreq.village = null;
                vm.landreq.blockCategory = null;
            });
        };

        vm.verifyPan = function() {

            var inputData = {
                pan: vm.landreq.pan_number,
                name: vm.landreq.businessentity,
                fathername: '',
                dob:'01/01/2015'
            };

            AddCAF.verifyPan(inputData, function(response) {
                console.log('Raw API Response:', response);
                // Extract only the numbered properties from the response manually
                var message = '';
                for (var key in response) {
                    if (response.hasOwnProperty(key) && !isNaN(key)) {
                        message += response[key]; // Append only numeric keys
                    }
                }
                console.log('Extracted Message:', message);
                if (message.indexOf('verified') !== -1) {
                    vm.panSuccessMessage = message; // Display success response
                    vm.panErrorMessage = ''; // Clear error message
                } else {
                    vm.panErrorMessage = message; // Display error response
                    vm.panSuccessMessage = ''; // Clear success message
                }
            }, function(error) {
                vm.panErrorMessage = 'An error occurred while verifying PAN. Please try again.';
                console.error('Error from verifyPan API:', error);
            });

        };

        vm.setBlockCategory = function (villageName, villageList) {
            vm.villageNames =[];
            angular.forEach(villageList, function(value, key){
                vm.villageNames.push(value.village);
            });
            if(vm.villageNames.indexOf(villageName) !== -1){
                vm.invalidVillage = false;
                vm.landreq.blockCategory = villageList[vm.villageNames.indexOf(villageName)].category;
            }
            else {
                vm.invalidVillage = true;
            }
        };

        vm.blockopen = function(){
            $('#blockCategoryHint').modal('show');
        };


    vm.changeInCost=function(){
          var projectCostInCrore=vm.project_cost_in_crore || '00';
          var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
          var projectCostInThousands=vm.project_cost_in_thousands||'00';
          if(vm.project_cost_in_lacs<10){
             projectCostInLacs='0'+vm.project_cost_in_lacs;
          }
          if(vm.project_cost_in_thousands<10){
             projectCostInThousands='0'+vm.project_cost_in_thousands;
          }
return vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
          }

    var calculateCostInCrore=function(){
       return parseInt(vm.landreq.total_project_cost.toString().split('.')[0]);
    }

    var calculateCostInLacs=function(){
       if(vm.landreq.total_project_cost.toString().indexOf('.')!=-1){
           var num = parseInt(vm.landreq.total_project_cost*(10000000));
           var lac = parseInt((num/100000)%100);
         return lac;
       }
       return 0;
    }

    var calculateCostInThousands=function(){
       if(vm.landreq.total_project_cost.toString().indexOf('.')!=-1){
            var num = parseInt(vm.landreq.total_project_cost*(10000000));
            var th = parseInt((num/1000)%100);
         return th;
       }
       return 0;
    }

     vm.project_cost_in_crore = calculateCostInCrore();
     vm.project_cost_in_lacs = calculateCostInLacs();
     vm.project_cost_in_thousands = calculateCostInThousands();

       var projectCostInCrore=vm.project_cost_in_crore || '00';
       var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
       var projectCostInThousands=vm.project_cost_in_thousands||'00';
       if(vm.project_cost_in_lacs<10){
          projectCostInLacs='0'+vm.project_cost_in_lacs;
       }
       if(vm.project_cost_in_thousands<10){
          projectCostInThousands='0'+vm.project_cost_in_thousands;
       }
       vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;


     vm.onsaveProject = onsaveProject;

     function onsaveProject(flag){
       vm.isSaving = true;
       vm.landreq.total_project_cost = vm.total_project_cost;
       if(flag=='Draft'){
          vm.landreq.isdraft=true;
       }
       else if(flag=='Final'){
          vm.landreq.isdraft=false;
       }
       if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
           var sign =vm.cAFAttachmentSign.investorsign;
           var fileNameArray = sign.name.split(".");

           if(fileNameArray.length<3) {
               if (fileNameArray[0] != "") {
                   var idxDot = sign.name.lastIndexOf(".") + 1;
                   var extFile = sign.name.substr(idxDot, sign.length).toLowerCase();

                   if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
                       saveCAF();
                   }
                   else {
                       alert("Only jpg/jpeg and png files are allowed!");
                   }
               }
               else {
                   alert("Invalid File Name");
               }
           }
           else{
               alert('Signature File should be in appropriate format')
           }
       }
       else {
           saveCAF();
       }

    }


     function onSaveProjectSuccess(result){
        uploadFile(result.id);
        vm.isSaving = false;
     }

     function onSaveProjectError(){
        alert('CAF Not Saved');
        vm.isSaving = false;
     }

     function uploadFile(projectid)
     {
         if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
             vm.cAFAttachment.docName="Signature";
             vm.cAFAttachment.projectid=projectid;
             CAFAttachment.save(vm.cAFAttachment,onSaveCAFAttachmentSignSuccess,onSaveCAFAttachmentSignError);
         }
         function onSaveCAFAttachmentSignSuccess (result) {
             $scope.$emit('investhryApp:cAFAttachmentUpdate', result);
             vm.cafattachresult = result;
             var cafattachmentid = result.id;

             var filename = result.id;
             var file = vm.cAFAttachmentSign.investorsign;
             FileManagement.saveFile(file,filename,onFileSaveSuccess,onFileSaveError(cafattachmentid));
             vm.isSaving = false;
         }

         function onFileSaveSuccess(result){
         $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachresult);
             var CAFAttachmentResultObject=vm.cafattachresult;
             var filename = CAFAttachmentResultObject.id;
             var file = vm.cAFAttachmentSign.investorsign;
             var fileNameArray = file.name.split(".");
             var fileextension="";
             if((fileNameArray.length>1))
             {
                 fileextension=fileNameArray[(fileNameArray.length-1)];
             }

             var inputFileName = CAFAttachmentResultObject.id;
             if(fileextension!=="")
             {
                 inputFileName=inputFileName+"."+fileextension;
             }
             CAFAttachmentResultObject.fileName=inputFileName;
             CAFAttachment.update(CAFAttachmentResultObject);
         }
         function onFileSaveError(cafattachmentid)
         {
             CAFAttachment.delete({id:cafattachmentid});

         }
         function onSaveCAFAttachmentSignError()
         {
             vm.isSaving = false;
         }
     }


     for(var attachmentcounter=0;attachmentcounter<vm.cafAttachments.length;attachmentcounter++)
     {
       if(vm.cafAttachments[0].docName=="Signature")
       {
           vm.investorsign=vm.cafAttachments[0];
       }
     }

     function onUpdateProjectSuccess(result)
     {
         replaceUploadedSign(result);
         vm.isSaving = false;
     }
     function onUpdateProjectError(result){
         alert('CAF Not Edited');
         vm.isSaving = false;
     }

     function replaceUploadedSign(result)
     {
         if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
            if(vm.investorsign!==null){
              var file = vm.cAFAttachmentSign.investorsign;
              var filename = vm.investorsign.id;
              FileManagement.saveFile(file,filename,onreplaceUploadedSignSuccess,onreplaceUploadedSignError);
            }
            else
            {
              uploadFile(result.id);
            }
         }
         function onreplaceUploadedSignSuccess(){
               var file = vm.cAFAttachmentSign.investorsign;
               var filename = vm.investorsign.id;
               var fileNameArray = file.name.split(".");
               var fileextension="";
               if((fileNameArray.length>1))
               {
                   fileextension=fileNameArray[(fileNameArray.length-1)];
               }

               var inputFileName=vm.investorsign.id;
               if(fileextension!=="")
               {
                   inputFileName=inputFileName+"."+fileextension;
               }
               vm.investorsign.fileName=inputFileName;
               CAFAttachment.update(vm.investorsign,onUpdateCAFAttachmentSignSuccess,onUpdateCAFAttachmentSignError);
               vm.isSaving = false;
         }
         function onreplaceUploadedSignError(){
               vm.isSaving=false;
         }
         function onUpdateCAFAttachmentSignSuccess(){
               vm.isSaving=false;
         }
         function onUpdateCAFAttachmentSignError(){
               vm.isSaving=false;
         }
     }
     function saveCAF() {
         if (vm.landreq.id !== null) {
             AddCAF.update(vm.landreq,onUpdateProjectSuccess,onUpdateProjectError);
             alert('CAF Edited');
         }
         else{
             AddCAF.save(vm.landreq,onSaveProjectSuccess,onSaveProjectError);
             if(vm.landreq.isdraft === true){
                 alert('Please note that any draft CAF saved in the system for more than 10 days shall be automatically deleted. Hence, you are requested to submit the CAF along with the required information within the prescribed time limit.\n' +
                     'Kindly contact our helpdesk at 1800-180-2132 in case you need any assistance in filling out the CAF Form.');
             }
             else {
                 alert('CAF Saved');
             }
         }
         $state.go('listproject');
     }

        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AddCAFrowController', AddCAFrowController);

    AddCAFrowController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'AddCAF', 'project','District', 'cAFAttachment', 'FileManagement', 'CAFAttachment', 'cafAttachments','CheckContent'];

    function AddCAFrowController ($scope, Principal, LoginService, $state, AddCAF, project, District, cAFAttachment, FileManagement, CAFAttachment, cafAttachments,CheckContent) {
        var vm = this;

        vm.CAFrow = project;
        vm.cAFAttachment=cAFAttachment;
        vm.cAFAttachmentSign="";
        $scope.file = {};
        vm.cafAttachments = cafAttachments;
        vm.investorsign=null;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                if(vm.CAFrow.id==null){
                vm.CAFrow.firstname = account.firstName;
                vm.CAFrow.lastname = account.lastName;
                vm.CAFrow.emailprimary = account.email;
                vm.CAFrow.mobilenumber = account.phone;
                }
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        vm.districts = [];
        loadAllDistrict();
        function loadAllDistrict(){
            District.query(function(result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

        vm.onsaveProject = onsaveProject;

         function onsaveProject(flag){
           vm.isSaving = true;
           if(flag=='Draft'){
              vm.CAFrow.isdraft=true;
           }
           else if(flag=='Final'){
              vm.CAFrow.isdraft=false;
           }
           if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
               var sign =vm.cAFAttachmentSign.investorsign;
               var fileNameArray = sign.name.split(".");

               if(fileNameArray.length<3) {
                   if (fileNameArray[0] != "") {
                       var idxDot = sign.name.lastIndexOf(".") + 1;
                       var extFile = sign.name.substr(idxDot, sign.length).toLowerCase();

                       if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
                           saveCAF();
                       }
                       else {
                           alert("Only jpg/jpeg and png files are allowed!");
                       }
                   }
                   else {
                       alert("Invalid File Name");
                   }
               }
               else {
                   alert('Signature File should be in appropriate format')
               }

           }
           else{
               saveCAF();
           }

          }


         function onSaveProjectSuccess(result){
            uploadFile(result.id);
            vm.isSaving = false;
         }

         function onSaveProjectError(){
            alert('CAF Not Saved');
            vm.isSaving = false;
         }

         function uploadFile(projectid)
         {
             if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
                 vm.cAFAttachment.docName="Signature";
                 vm.cAFAttachment.projectid=projectid;
                 CAFAttachment.save(vm.cAFAttachment,onSaveCAFAttachmentSignSuccess,onSaveCAFAttachmentSignError);
             }
             function onSaveCAFAttachmentSignSuccess (result) {
                 $scope.$emit('investhryApp:cAFAttachmentUpdate', result);
                 vm.cafattachresult = result;
                 var cafattachmentid = result.id;

                 var filename = result.id;
                 var file = vm.cAFAttachmentSign.investorsign;
                 FileManagement.saveFile(file,filename,onFileSaveSuccess,onFileSaveError(cafattachmentid));
                 vm.isSaving = false;
             }

             function onFileSaveSuccess(result){
             $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachresult);
                 var CAFAttachmentResultObject=vm.cafattachresult;
                 var filename = CAFAttachmentResultObject.id;
                 var file = vm.cAFAttachmentSign.investorsign;
                 var fileNameArray = file.name.split(".");
                 var fileextension="";
                 if((fileNameArray.length>1))
                 {
                     fileextension=fileNameArray[(fileNameArray.length-1)];
                 }

                 var inputFileName = CAFAttachmentResultObject.id;
                 if(fileextension!=="")
                 {
                     inputFileName=inputFileName+"."+fileextension;
                 }
                 CAFAttachmentResultObject.fileName=inputFileName;
                 CAFAttachment.update(CAFAttachmentResultObject);
             }
             function onFileSaveError(cafattachmentid)
             {
                 CAFAttachment.delete({id:cafattachmentid});

             }
             function onSaveCAFAttachmentSignError()
             {
                 vm.isSaving = false;
             }
         }


         for(var attachmentcounter=0;attachmentcounter<vm.cafAttachments.length;attachmentcounter++)
          {
            if(vm.cafAttachments[0].docName=="Signature")
            {
                vm.investorsign=vm.cafAttachments[0];
            }
          }

         function onUpdateProjectSuccess(result)
         {
             replaceUploadedSign(result);
             vm.isSaving = false;
         }
         function onUpdateProjectError(result){
             alert('CAF Not Edited');
             vm.isSaving = false;
         }

         function replaceUploadedSign(result)
         {
             if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
                if(vm.investorsign!==null){
                  var file = vm.cAFAttachmentSign.investorsign;
                  var filename = vm.investorsign.id;
                  FileManagement.saveFile(file,filename,onreplaceUploadedSignSuccess,onreplaceUploadedSignError);
                }
                else
                {
                  uploadFile(result.id);
                }
             }
             function onreplaceUploadedSignSuccess(){
                   var file = vm.cAFAttachmentSign.investorsign;
                   var filename = vm.investorsign.id;
                   var fileNameArray = file.name.split(".");
                   var fileextension="";
                   if((fileNameArray.length>1))
                   {
                       fileextension=fileNameArray[(fileNameArray.length-1)];
                   }

                   var inputFileName=vm.investorsign.id;
                   if(fileextension!=="")
                   {
                       inputFileName=inputFileName+"."+fileextension;
                   }
                   vm.investorsign.fileName=inputFileName;
                   CAFAttachment.update(vm.investorsign,onUpdateCAFAttachmentSignSuccess,onUpdateCAFAttachmentSignError);
                   vm.isSaving = false;
             }
             function onreplaceUploadedSignError(){
                   vm.isSaving=false;
             }
             function onUpdateCAFAttachmentSignSuccess(){
                   vm.isSaving=false;
             }
             function onUpdateCAFAttachmentSignError(){
                   vm.isSaving=false;
             }
         }

         function  saveCAF() {
             if (vm.CAFrow.id !== null) {
                 AddCAF.update(vm.CAFrow,onUpdateProjectSuccess,onUpdateProjectError);
                 alert('CAF Edited');
             }
             else{
                 AddCAF.save(vm.CAFrow,onSaveProjectSuccess,onSaveProjectError);
                 if(vm.CAFrow.isdraft === true){
                     alert('Please note that any draft CAF saved in the system for more than 10 days shall be automatically deleted. Hence, you are requested to submit the CAF along with the required information within the prescribed time limit.\n' +
                         'Kindly contact our helpdesk at 1800-180-2132 in case you need any assistance in filling out the CAF Form.');
                 }
                 else {
                     alert('CAF Saved');
                 }
             }
             $state.go('listproject');
         }

        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AddCAFrenewableController', AddCAFrenewableController);

    AddCAFrenewableController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'AddCAF', 'project','District', 'cAFAttachment', 'FileManagement', 'CAFAttachment', 'cafAttachments','CheckContent'];

    function AddCAFrenewableController ($scope, Principal, LoginService, $state, AddCAF, project, District, cAFAttachment, FileManagement, CAFAttachment, cafAttachments,CheckContent) {
        var vm = this;

        vm.landreq = project;
        vm.cAFAttachment=cAFAttachment;
        vm.cAFAttachmentSign="";
        $scope.file = {};
        vm.cafAttachments = cafAttachments;
        vm.investorsign=null;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                if(vm.landreq.id==null){
                vm.landreq.firstname = account.firstName;
                vm.landreq.lastname = account.lastName;
                vm.landreq.emailprimary = account.email;
                vm.landreq.mobilenumber = account.phone;
                }
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        vm.districts = [];
        loadAllDistrict();
        function loadAllDistrict(){
            District.query(function(result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

        vm.onsaveProject = onsaveProject;

        function onsaveProject(flag){
           vm.isSaving = true;
           if(flag=='Draft'){
             vm.landreq.isdraft=true;
           }
           else if(flag=='Final'){
             vm.landreq.isdraft=false;
           }
            if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
                var sign =vm.cAFAttachmentSign.investorsign;
                var fileNameArray = sign.name.split(".");

                if(fileNameArray.length<3) {
                    if (fileNameArray[0] != "") {
                        var idxDot = sign.name.lastIndexOf(".") + 1;
                        var extFile = sign.name.substr(idxDot, sign.length).toLowerCase();

                        if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
                            saveCAF();
                        }
                        else {
                            alert("Only jpg/jpeg and png files are allowed!");
                        }
                    }
                    else {
                        alert("Invalid File Name");
                    }
                }
                else{
                    alert('Signature File should be in appropriate format')
                }
            }
            else {
                saveCAF();
            }

        }



        function onSaveProjectSuccess(result){
           uploadFile(result.id);
           vm.isSaving = false;
        }
        function onSaveProjectError(){
            alert('CAF Not Saved');
            vm.isSaving = false;
        }


        function uploadFile(projectid)
        {
            if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
                vm.cAFAttachment.docName="Signature";
                vm.cAFAttachment.projectid=projectid;
                CAFAttachment.save(vm.cAFAttachment,onSaveCAFAttachmentSignSuccess,onSaveCAFAttachmentSignError);
            }
            function onSaveCAFAttachmentSignSuccess (result) {
                $scope.$emit('investhryApp:cAFAttachmentUpdate', result);
                vm.cafattachresult = result;
                var cafattachmentid = result.id;

                var filename = result.id;
                var file = vm.cAFAttachmentSign.investorsign;
                FileManagement.saveFile(file,filename,onFileSaveSuccess,onFileSaveError(cafattachmentid));
                vm.isSaving = false;
            }

            function onFileSaveSuccess(result){
            $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachresult);
                var CAFAttachmentResultObject=vm.cafattachresult;
                var filename = CAFAttachmentResultObject.id;
                var file = vm.cAFAttachmentSign.investorsign;
                var fileNameArray = file.name.split(".");
                var fileextension="";
                if((fileNameArray.length>1))
                {
                    fileextension=fileNameArray[(fileNameArray.length-1)];
                }

                var inputFileName = CAFAttachmentResultObject.id;
                if(fileextension!=="")
                {
                    inputFileName=inputFileName+"."+fileextension;
                }
                CAFAttachmentResultObject.fileName=inputFileName;
                CAFAttachment.update(CAFAttachmentResultObject);
            }
            function onFileSaveError(cafattachmentid)
            {
                CAFAttachment.delete({id:cafattachmentid});

            }
            function onSaveCAFAttachmentSignError()
            {
                vm.isSaving = false;
            }
        }

        for(var attachmentcounter=0;attachmentcounter<vm.cafAttachments.length;attachmentcounter++)
        {
          if(vm.cafAttachments[0].docName=="Signature")
          {
              vm.investorsign=vm.cafAttachments[0];
          }
        }

         function onUpdateProjectSuccess(result)
         {
             replaceUploadedSign(result);
             vm.isSaving = false;
         }
         function onUpdateProjectError(result){
             alert('CAF Not Edited');
             vm.isSaving = false;
         }

         function replaceUploadedSign(result)
         {
             if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
                if(vm.investorsign!==null){
                  var file = vm.cAFAttachmentSign.investorsign;
                  var filename = vm.investorsign.id;
                  FileManagement.saveFile(file,filename,onreplaceUploadedSignSuccess,onreplaceUploadedSignError);
                }
                else
                {
                  uploadFile(result.id);
                }
             }
             function onreplaceUploadedSignSuccess(){
                   var file = vm.cAFAttachmentSign.investorsign;
                   var filename = vm.investorsign.id;
                   var fileNameArray = file.name.split(".");
                   var fileextension="";
                   if((fileNameArray.length>1))
                   {
                       fileextension=fileNameArray[(fileNameArray.length-1)];
                   }

                   var inputFileName=vm.investorsign.id;
                   if(fileextension!=="")
                   {
                       inputFileName=inputFileName+"."+fileextension;
                   }
                   vm.investorsign.fileName=inputFileName;
                   CAFAttachment.update(vm.investorsign,onUpdateCAFAttachmentSignSuccess,onUpdateCAFAttachmentSignError);
                   vm.isSaving = false;
             }
             function onreplaceUploadedSignError(){
                   vm.isSaving=false;
             }
             function onUpdateCAFAttachmentSignSuccess(){
                   vm.isSaving=false;
             }
             function onUpdateCAFAttachmentSignError(){
                   vm.isSaving=false;
             }
         }
         function saveCAF() {
             if (vm.landreq.id !== null)
             {
                 AddCAF.update(vm.landreq,onUpdateProjectSuccess,onUpdateProjectError);
                 alert('CAF Edited.');
             }
             else
             {
                 AddCAF.save(vm.landreq,onSaveProjectSuccess,onSaveProjectError);
                 if(vm.landreq.isdraft === true){
                     alert('Please note that any draft CAF saved in the system for more than 10 days shall be automatically deleted. Hence, you are requested to submit the CAF along with the required information within the prescribed time limit.\n' +
                         'Kindly contact our helpdesk at 1800-180-2132 in case you need any assistance in filling out the CAF Form.');
                 }
                 else {
                     alert('CAF Added');
                 }             }
             $state.go('listproject');
         }

         $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AddCAFnewRestrictedController', AddCAFnewRestrictedController);

    AddCAFnewRestrictedController.$inject = ['$stateParams', '$timeout', '$scope', 'Principal', 'LoginService', '$state', 'AddCAF', 'project','District', 'Landusezoneclassification', 'Businessentitys', 'Sector', 'Industrysize', 'Projectype', 'Country', 'Connectingroad', 'Block', 'City_town_village', 'Approvalforms', 'FileManagement', 'CAFAttachment', 'cafAttachments','ExtendedUserInformation','CountryService','$filter', 'DistrictVillageBlockMapping','CheckContent','AlertService', 'Project', 'State', 'Estate', 'GetImageForApplicant' ,'CAFOtp'];

    function AddCAFnewRestrictedController ($stateParams, $timeout, $scope, Principal, LoginService, $state, AddCAF, project, District, Landusezoneclassification, Businessentitys, Sector, Industrysize, Projectype, Country, Connectingroad, Block, City_town_village, Approvalforms, FileManagement, CAFAttachment, cafAttachments,ExtendedUserInformation,CountryService,$filter, DistrictVillageBlockMapping,CheckContent,AlertService, Project,State,Estate, GetImageForApplicant, CAFOtp) {
        var vm = this;

        vm.proj = {
            id: null,
            mouapplicable: false,
            mousignyear: null,
            mouidnumber: null,
            firstname: null,
            middlename: null,
            lastname: null,
            address1: null,
            address2: null,
            address3: null,
            emailprimary: null,
            emailsecondary: null,
            userlogin: null,
            cityname: null,
            countryname: null,
            statename: null,
            createdate: null,
            updatedate: null,
            cafpin: null,
            pincode: null,
            phonenumber: null,
            mobilenumber: null,
            promoter_md_director: null,
            designation: null,
            businessentity: null,
            director_promoter_md_ceo_number: null,
            pan_number: null,
            aadhar_number: null,
            nri: null,
            tin_vat_number: null,
            cst_number: null,
            businessentitytype: null,
            gstnumber: null,
            siteaddress: null,
            multyvillageinvolved: false,
            villageinvolved: null,
            falls_in_aravalli: false,
            islandprocured: false,
            allotedbyhsiidc: false,
            estate: null,
            cluster: null,
            phase: null,
            sector: null,
            plotno: null,
            hadbastno: null,
            liesunder_mc: false,
            distance_from_mc: null,
            islocated_in_urban: false,
            totalproposedprojectarea: "0",
            proposedbuilt_up_area: null,
            certifiedownership: false,
            leaseapplicable: false,
            landagreementapplicable: false,
            intersectiondistance: false,
            railwaydistance: false,
            confirmitylanduse: false,
            existing_building_applicable: false,
            site_situated_in_controlled_area: false,
            buildingexisted: null,
            district: null,
            block: null,
            city_town_village: null,
            connectingroad: null,
            landzoneuse_type: "",
            tehsil_subtehsil: null,
            clurequired: false,
            land_cost: null,
            building_cost: null,
            total_project_cost: "0",
            totalpurposedemployment: 0,
            acceptance: false,
            applicationdate: null,
            place: null,
            projectpurpose: null,
            niccode: null,
            existing_regulatory_approval: false,
            edc_sif_clu_fee_paid_applicable: false,
            approval_application_form: null,
            category_of_project: null,
            collaboration_with_foreign_country: null,
            projectype: null,
            sectorname: null,
            size_of_industry: null,
            sectorother: null,
            isdeactivated: false,
            deactivatedby: null,
            deactivateddate: null,
            projectlevel: "d",
            isdraft: false,
            caftype: "New",
            landrequired: null,
            plotsize: null,
            landusetype: null,
            product: null,
            uamnumber: null,
            isfdi: false,
            foreign_investment: 0,
            nri_investment: "0",
            investmentType: null,
            otherInvestmetType: null,
            prodctionStartDate: null,
            otherFDI: null,
            haryanadomicile: 0,
            nonharyanadomicile: 0
        };
        vm.cAFAttachmentSignobject = {
            projectid: null,
            docName: null,
            fileName: null,
            id: null
        };
        vm.cAFAttachmentPhotoobject = {
            projectid: null,
            docName: null,
            fileName: null,
            id: null
        };
        vm.cAFAttachmentSign = "";
        vm.cAFAttachmentPhoto = "";
        $scope.file = {};
        vm.cafAttachments = cafAttachments;
        vm.investorphoto = null;
        vm.investorsign = null;
        vm.showEstateConfirmation = false;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.errorMessage=errorMessage;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.sectorValueChange = sectorValueChange;
        vm.showIndustrialEstates = false;
        vm.estates = [];

        vm.OTP = false;
        vm.OTPstatus = false;
        vm.cafOTP= null;

        Project.get({ id: $stateParams.id }, function (project) {
            vm.proj.firstname = project.firstname;
            vm.proj.middlename = project.middlename;
            vm.proj.lastname = project.lastname;
            vm.proj.mobilenumber = project.mobilenumber;
            vm.proj.businessentity = project.businessentity
        });
        vm.datePickerOpenStatus.prodctionStartDate = false;

        function openCalendar (date) {
            vm.datePickerOpenStatus[date] = true;
        }

        loadAll();
        for(var cafAttachmentscounter=0;cafAttachmentscounter<vm.cafAttachments.length;cafAttachmentscounter++)
        {
            if(vm.cafAttachments[cafAttachmentscounter].docName=="Applicant Photo")
            {
                var filename=vm.cafAttachments[cafAttachmentscounter].fileName;
                vm.investorphoto1=GetImageForApplicant.getImageApplicant(filename);
                vm.cafAttachementInvestorPhoto=vm.cafAttachments[cafAttachmentscounter];

            }
            if(vm.cafAttachments[cafAttachmentscounter].docName=="Signature")
            {
                var filename=vm.cafAttachments[cafAttachmentscounter].fileName;
                vm.investorsign1=GetImageForApplicant.getImageApplicant(filename);
            }
        }


        function loadAll() {
            vm.sectorValueChange (project.sectorname);

            if(vm.isIndustrialEstate!="" && vm.proj.district!=null){
                vm.showEstateConfirmation = true;
                vm.showIndustrialEstates =true;
                if(vm.proj.industrialEstate!= null){
                    vm.isIndustrialEstate ="yes";
                    Estate.query(function (estates) {
                        vm.estates = $filter('filter')(estates, {district: vm.proj.district});
                    });
                }
            }

            if(project.prodctionStartDate !== null){
                vm.proj.prodctionStartDate = new Date(project.prodctionStartDate);
            }
            if(project.investmentType === 'Other'){
                vm.showOtherInvestmentType = true;
            }
            else if(project.investmentType === null){
                project.otherInvestmetType = ' ';
            }

            if(project.foreign_investment !== null && project.foreign_investment !== 0){
                vm.radioToggle = 'Yes';
                vm.showFDI = true;
            }
            else if(project.foreign_investment === null || project.foreign_investment === 0){
                vm.radioToggle = 'No';
                vm.showFDI = false;
            }
        }

        vm.getIndustrialEstates = function(){
            if (vm.isIndustrialEstate === 'yes'){
                vm.showIndustrialEstates = true;
                Estate.query(function (estates) {
                    vm.estates = $filter('filter')(estates, {district: vm.proj.district});
                });
            }else {
                vm.showIndustrialEstates = false;
                return;
            }
        };

        vm.getVillages = function (districtName) {
            vm.showEstateConfirmation =true;
            vm.isIndustrialEstate = "no";
            vm.showIndustrialEstates = false;
            DistrictVillageBlockMapping.query({id: '1',districtName: districtName},function(result) {
                vm.villages = result;
                vm.searchQuery = null;
                vm.proj.village = null;
                vm.proj.blockCategory = null;
            });
        };

        vm.setBlockCategory = function (villageName, villageList) {
            vm.showEstateConfirmation = true;
            vm.villageNames =[];
            angular.forEach(villageList, function(value, key){
                vm.villageNames.push(value.village);
            });
            if(vm.villageNames.indexOf(villageName) !== -1){
                vm.invalidVillage = false;
                vm.proj.blockCategory = villageList[vm.villageNames.indexOf(villageName)].category;
            }
            else {
                vm.invalidVillage = true;
            }
        };

        vm.verifyPan = function() {
            var inputData = {
                pan: vm.proj.pan_number,
                name: vm.proj.businessentity,
                fathername: '',
                dob:'01/01/2015'
            };

            AddCAF.verifyPan(inputData, function(response) {
                console.log('Raw API Response:', response);
                // Extract only the numbered properties from the response manually
                var message = '';
                for (var key in response) {
                    if (response.hasOwnProperty(key) && !isNaN(key)) {
                        message += response[key]; // Append only numeric keys
                    }
                }
                console.log('Extracted Message:', message);
                if (message.indexOf('verified') !== -1) {
                    vm.panSuccessMessage = message; // Display success response
                    vm.panErrorMessage = ''; // Clear error message
                } else {
                    vm.panErrorMessage = message; // Display error response
                    vm.panSuccessMessage = ''; // Clear success message
                }
            }, function(error) {
                vm.panErrorMessage = 'An error occurred while verifying PAN. Please try again.';
                console.error('Error from verifyPan API:', error);
            });
        };

        function sectorValueChange (sectorName) {
            if(sectorName === 'Other Industries'){
                if(project.otherFDI === null || vm.proj.otherFDI === 'NA' ){
                    vm.proj.otherFDI = '';
                }
                vm.showOtherSector = true;
            }
            else {
                vm.showOtherSector = false;
                vm.proj.otherFDI = 'NA'
            }
        };

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        $scope.enterEvent= function (event) {
            event.preventDefault();
            vm.ShowError=true;
        };

        function errorMessage() {
            vm.ShowError=false;
        }

        vm.showOtherInvestment = function (currentValue) {
            vm.total_project_cost=0;
            vm.proj.total_project_cost = 0;
            vm.proj.totalproposedprojectarea = 0;
            vm.proj.haryanadomicile = 0;
            vm.proj.totalpurposedemployment = 0;
            vm.proj.nonharyanadomicile = 0;
            vm.project_cost_in_crore = 0;
            vm.project_cost_in_lacs = 0;
            vm.project_cost_in_thousands = 0;
            vm.project_area_in_acres = 0;
            vm.project_area_in_kanal = 0;
            vm.project_area_in_marla = 0;
            vm.proj.powerRequirement = null;
            vm.showOtherInvestmentType = currentValue === 'Other';

        };

        vm.proposedEmployment = function(domicile){
            if(domicile === 'haryana'){
                vm.proj.nonharyanadomicile = vm.proj.totalpurposedemployment - vm.proj.haryanadomicile;
                if(vm.proj.nonharyanadomicile < 0){
                    vm.proj.haryanadomicile = 0;
                    vm.proj.nonharyanadomicile = 0;
                    alert("Your Value Is Not Valid");
                }
            }else{
                vm.proj.haryanadomicile = vm.proj.totalpurposedemployment - vm.proj.nonharyanadomicile;
                if(vm.proj.haryanadomicile < 0){
                    vm.proj.nonharyanadomicile = 0;
                    vm.proj.haryanadomicile = 0;
                    alert("Your Value Is Not Valid");
                }
            }
        };

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                if(vm.proj.id==null){
                    vm.proj.firstname = account.firstName;
                    vm.proj.lastname = account.lastName;
                    vm.proj.emailprimary = account.email;
                    ExtendedUserInformation.get({id:account.id},function (result) {
                        vm.proj.address1=result.userAddress;
                        vm.proj.address2='';
                        vm.proj.address3='';
                        vm.proj.mobilenumber = result.userMobile;

                    });
                }
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        vm.districts = [];
        loadAllDistrict();
        function loadAllDistrict(){
            District.query(function(result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }
        Landusezoneclassification.query(function(result) {
            vm.landusezoneclassifications = result;
            vm.searchQuery = null;
        });
        Businessentitys.query(function(result) {
            vm.businessentities = result;
            vm.searchQuery = null;
        });
        Sector.query(function(result) {
            vm.sectors = result;
            vm.searchQuery = null;
        });
        Industrysize.query(function(result) {
            vm.industrysizes = result;
            vm.searchQuery = null;
        });
        Projectype.query(function(result) {
            vm.projectypes = result;
            vm.searchQuery = null;
        });
        Country.query(function(result) {
            vm.countries = result;
            vm.searchQuery = null;
        });
        State.query(function(result) {
            vm.states = result;
            vm.searchQuery = null;
        });
        Block.query(function(result) {
            vm.blocks = result;
            vm.searchQuery = null;
        });
        Connectingroad.query(function(result) {
            vm.connectingroads = result;
            vm.searchQuery = null;
        });
        City_town_village.query(function(result) {
            vm.city_town_villages = result;
            vm.searchQuery = null;
        });
        Approvalforms.query(function(result) {
            vm.approvalforms = result;
            vm.searchQuery = null;
        });

        vm.project_area_in_acres=Math.floor(calculateAreaInAcre());
        vm.project_area_in_kanal= Math.floor(calculateAreaInKanal());
        vm.project_area_in_marla=Math.floor(calculateAreaInMarla());

        var projectAreaInAcres=vm.project_area_in_acres || 0;
        var projectAreaInKanal=vm.project_area_in_kanal || 0 ;
        var projectAreaInMarla=vm.project_area_in_marla || 0;
        vm.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);

        vm.changeInArea=function(){
            var projectAreaInAcres=vm.project_area_in_acres || 0;
            var projectAreaInKanal=vm.project_area_in_kanal || 0 ;
            var projectAreaInMarla=vm.project_area_in_marla || 0;
            vm.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);
        }

        vm.changeInCost=function(){
            var projectCostInCrore=vm.project_cost_in_crore || '00';
            var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
            var projectCostInThousands=vm.project_cost_in_thousands||'00';
            if(vm.project_cost_in_lacs<10){
                projectCostInLacs='0'+vm.project_cost_in_lacs;
            }
            if(vm.project_cost_in_thousands<10){
                projectCostInThousands='0'+vm.project_cost_in_thousands;
            }
            return vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
        };

        // // Inside your AngularJS controller
        // vm.verifyPan = function() {
        //     // Define the regex pattern for PAN format
        //     var panPattern = /^[A-Z]{5}[0-9]{4}[A-Z]$/;
        //
        //     // Check if the input matches the pattern
        //     if (vm.proj.pan_number && panPattern.test(vm.proj.pan_number)) {
        //         // Display success message
        //         vm.panSuccessMessage = "PAN Number is in the correct format.";
        //         vm.panErrorMessage = ""; // Clear error message
        //     } else {
        //         // Display error message
        //         vm.panErrorMessage = "PAN Number must be in uppercase and follow the correct format (e.g., ABCDE1234F).";
        //         vm.panSuccessMessage = ""; // Clear success message
        //     }
        // };


        vm.changeInForeignInvestment=function(){
            var projectCostInCrore=vm.foreigninvestment_in_crores || '00';
            var projectCostInLacs=vm.foreigninvestment_in_lacs|| '00' ;
            var projectCostInThousands=vm.foreigninvestment_in_thousands||'00';
            if(vm.foreigninvestment_in_lacs<10){
                projectCostInLacs='0'+vm.foreigninvestment_in_lacs;
            }
            if(vm.foreigninvestment_in_thousands<10){
                projectCostInThousands='0'+vm.foreigninvestment_in_thousands;
            }
            return vm.total_foreign_investment = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
        };


        vm.changeInNri_investment=function(){
            var projectCostInCrore=vm.nri_investment_in_crore || '00';
            var projectCostInLacs=vm.nri_investment_in_lacs|| '00' ;
            var projectCostInThousands=vm.nri_investment_in_thousands||'00';
            if(vm.nri_investment_in_lacs<10){
                projectCostInLacs='0'+vm.nri_investment_in_lacs;
            }
            if(vm.nri_investment_in_thousands<10){
                projectCostInThousands='0'+vm.nri_investment_in_thousands;
            }
            return vm.total_nri_investment = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
        };

        var calculateCostInCrore=function(){
            return parseInt(vm.proj.total_project_cost.toString().split('.')[0]);
        };

        var calculateCostInLacs=function(){
            if(vm.proj.total_project_cost.toString().indexOf('.')!=-1){
                var org = vm.proj.total_project_cost*10000000;
                var lac = (org/100000)%100;
                return parseInt(lac);
            }
            return 0;
        };

        var calculateCostInThousands=function(){
            if(vm.proj.total_project_cost.toString().indexOf('.')!=-1){
                var org = vm.proj.total_project_cost*10000000;
                var th = (org/1000)%100;
                return parseInt(th);
            }
            return 0;
        };

        var calculateforeignInvestmentInCrore = function () {
            if((vm.proj.foreign_investment!=0) && (vm.proj.foreign_investment!=null)){
                return parseInt(vm.proj.foreign_investment.toString().split('.')[0]);
            }
        };

        var calculateforeignInvestmentInlacs = function () {
            if((vm.proj.foreign_investment!=0) && (vm.proj.foreign_investment!=null)){
                if (vm.proj.foreign_investment.toString().indexOf('.') != -1) {
                    return parseInt(vm.proj.foreign_investment.toString().split('.')[1].substring(0, 2));
                }
                return 0;
            }
        };

        var calculateforeignInvestmentInThousands = function () {
            if((vm.proj.foreign_investment!=0) && (vm.proj.foreign_investment!=null)){
                if (vm.proj.foreign_investment.toString().indexOf('.') != -1) {
                    return parseInt(vm.proj.foreign_investment.toString().split('.')[1].substring(2, 4));
                }
                return 0;
            }
        };


        var calculatenri_investmentInCrore = function () {
            if((vm.proj.nri_investment!=0) && (vm.proj.nri_investment!=null)){
                return parseInt(vm.proj.nri_investment.toString().split('.')[0]);
            }
        };


        var calculatenri_investmentInlacs = function () {
            if((vm.proj.nri_investment!=0) && (vm.proj.nri_investment!=null)){
                if (vm.proj.nri_investment.toString().indexOf('.') != -1) {
                    return parseInt(vm.proj.nri_investment.toString().split('.')[1].substring(0, 2));
                }
                return 0;
            }
        };

        var calculatenri_investmentInThousands = function () {
            if((vm.proj.nri_investment!=0) && (vm.proj.nri_investment!=null)){
                if (vm.proj.nri_investment.toString().indexOf('.') != -1) {
                    return parseInt(vm.proj.nri_investment.toString().split('.')[1].substring(2, 4));
                }
                return 0;
            }
        };

        function calculateAreaInAcre(){
            return vm.proj.totalproposedprojectarea;
        }

        function calculateAreaInKanal(){
            var areainkanal=vm.proj.totalproposedprojectarea-Math.floor(vm.proj.totalproposedprojectarea);
            var areaInKanal=areainkanal*8;
            return areaInKanal;
        }

        function calculateAreaInMarla(){
            var areainmarla=Math.floor(calculateAreaInKanal());
            var areaInMarla=(calculateAreaInKanal()-areainmarla)*20;
            return Math.round(areaInMarla);
        }


        vm.project_cost_in_crore=calculateCostInCrore();
        vm.project_cost_in_lacs= calculateCostInLacs();
        vm.project_cost_in_thousands=calculateCostInThousands();

        vm.foreigninvestment_in_crores=calculateforeignInvestmentInCrore();
        vm.foreigninvestment_in_lacs=calculateforeignInvestmentInlacs();
        vm.foreigninvestment_in_thousands=calculateforeignInvestmentInThousands();


        vm.nri_investment_in_crore=calculatenri_investmentInCrore();
        vm.nri_investment_in_lacs=calculatenri_investmentInlacs();
        vm.nri_investment_in_thousands=calculatenri_investmentInThousands();


        var projectCostInCrore=vm.project_cost_in_crore || '00';
        var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
        var projectCostInThousands=vm.project_cost_in_thousands||'00';
        if(vm.project_cost_in_lacs<10){
            projectCostInLacs='0'+vm.project_cost_in_lacs;
        }
        if(vm.project_cost_in_thousands<10){
            projectCostInThousands='0'+vm.project_cost_in_thousands;
        }


        vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;


        var foreignInvestmentInCrore=vm.foreigninvestment_in_crores || '00';
        var foreignInvestmentLacs=vm.foreigninvestment_in_lacs|| '00' ;
        var foreignInvestmentThousands=vm.foreigninvestment_in_thousands||'00';
        if(vm.foreigninvestment_in_lacs<10){
            foreignInvestmentLacs='0'+vm.foreigninvestment_in_lacs;
        }
        if(vm.foreigninvestment_in_thousands<10){
            foreignInvestmentThousands='0'+vm.foreigninvestment_in_thousands;
        }
        vm.total_foreign_investment = foreignInvestmentInCrore+"."+foreignInvestmentLacs+""+foreignInvestmentThousands ;

        var nriInCrore=vm.nri_investment_in_crore || '00';
        var nriInLacs=vm.nri_investment_in_lacs|| '00' ;
        var nriInThousands=vm.nri_investment_in_thousands||'00';
        if(vm.nri_investment_in_lacs<10){
            nriInLacs='0'+vm.nri_investment_in_lacs;
        }
        if(vm.nri_investment_in_thousands<10){
            nriInThousands='0'+vm.nri_investment_in_thousands;
        }
        vm.total_nri_investment = nriInCrore+"."+nriInLacs+""+nriInThousands;


        vm.saveProject = saveProject;

        vm.blockopen = function(){
            $('#blockCategoryHint').modal('show');
        };


        function saveProject(flag){
            vm.isSaving = true;
            if(vm.proj.totalpurposedemployment > 0 && (vm.proj.haryanadomicile + vm.proj.nonharyanadomicile != vm.proj.totalpurposedemployment)){
                alert("Total of employment with Haryana Domicile and Non-Haryana Domicile must be equal to Total Proposed Employment!!");
                vm.proj.haryanadomicile = 0;
                vm.proj.nonharyanadomicile = 0;
                return;
            }
            if(vm.proj.totalpurposedemployment === 0){
                vm.proj.haryanadomicile = 0;
                vm.proj.nonharyanadomicile = 0;
            }
            vm.proj.totalproposedprojectarea = vm.totalproposedprojectarea;
            vm.proj.total_project_cost = vm.total_project_cost;
            vm.proj.foreign_investment=vm.total_foreign_investment;
            vm.proj.nri_investment=vm.total_nri_investment;

            if(vm.proj.investmentType ==="Existing Project (not a new investment in state)"){
                vm.proj.powerRequirement = null;
            }


            if(flag=='Draft'){
                vm.proj.isdraft=true;
            }
            else if(flag=='Final'){
                vm.proj.isdraft=false;
            }
            if((angular.isDefined(vm.cAFAttachmentSign.investorsign)) || (angular.isDefined(vm.cAFAttachmentPhoto.investorphoto))) {
                var extFile = "jpg";
                var extPic = "jpg";
                var sign = true;
                var photo = true;
                if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
                    var sign = vm.cAFAttachmentSign.investorsign;
                    var fileNameArray = sign.name.split(".");
                    if (fileNameArray.length < 3) {
                        if (fileNameArray[0] != "") {
                            var signDot = sign.name.lastIndexOf(".") + 1;
                            extFile = sign.name.substr(signDot, sign.length).toLowerCase();
                        }
                        else {
                            alert("Invalid File Name");
                            var sign = false;
                        }
                    }
                    else {
                        alert('Signature File should be in appropriate format')
                        var sign = false;

                    }
                }
                if (angular.isDefined(vm.cAFAttachmentPhoto.investorphoto)) {
                    var investorPhoto = vm.cAFAttachmentPhoto.investorphoto;
                    var filePhotoArray = investorPhoto.name.split(".");

                    if (filePhotoArray.length < 3) {
                        if (filePhotoArray[0] != "") {
                            var picDot = investorPhoto.name.lastIndexOf(".") + 1;
                            extPic = investorPhoto.name.substr(picDot, investorPhoto.length).toLowerCase();
                        } else {
                            alert("Invalid File Name");
                            var photo = false;
                        }
                    }
                    else {
                        alert('Applicant Photo File should be in appropriate format');
                        var photo = false;
                    }
                }
                if(photo && sign) {
                    if ((extFile == "jpg" || extFile == "jpeg" || extFile == "png") && (extPic == "jpg" || extPic == "jpeg" || extPic == "png")) {
                        saveCAF();
                    }
                    else {
                        alert("Only jpg/jpeg and png files are allowed!");
                    }
                }
            }
            else {
                saveCAF();
            }
        }


        function onSaveProjectSuccess(result)
        {
            uploadphoto(result.id);
            uploadsign(result.id);
            vm.isSaving = false;

            if(vm.proj.isdraft === true){
                alert('Please note that any draft CAF saved in the system for more than 10 days shall be automatically deleted. Hence, you are requested to submit the CAF along with the required information within the prescribed time limit.\n' +
                    'Kindly contact our helpdesk at 1800-180-2132 in case you need any assistance in filling out the CAF Form.');
            }
            else{
                alert('CAF Saved');
            }
            $state.go('listproject');
        }
        function onSaveProjectError(result){
            if(result.status === 409){
                vm.existingCAFPin = result.data.cafpin;
                vm.existingCAFLogin = result.data.userlogin;
                alert(' It has been observed that the details entered by you are already present in our system with the following details: CAF Number: ' + vm.existingCAFPin + '  Login ID: ' + vm.existingCAFLogin + '  Please login using the above mentioned login ID to proceed further. In case the CAF number & login ID do not belong to you, kindly contact our helpdesk at 1800-180-2132 to proceed further with the registration process.');
                return;
            }
            alert('CAF Not Saved');
//        AlertService.error("Details Mached With Existing Caf.");
            vm.isSaving = false;
        }

        function uploadsign(projectid)
        {
            if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
                vm.cAFAttachmentSignobject.docName = "Signature";
                vm.cAFAttachmentSignobject.projectid = projectid;
                CAFAttachment.save(vm.cAFAttachmentSignobject,onSaveCAFAttachmentSignSuccess,onSaveCAFAttachmentSignError);
            }
            function onSaveCAFAttachmentSignSuccess (result) {
                vm.cafattachsignresult = result;
                var cafattachmentid = result.id;

                var filename = result.id;
                var file = vm.cAFAttachmentSign.investorsign;
                FileManagement.saveFile(file,filename,onSignFileSaveSuccess,onSignFileSaveError(cafattachmentid));
                vm.isSaving = false;
            }

            function onSignFileSaveSuccess(result){
                $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachsignresult);
                var CAFAttachmentResultObject = vm.cafattachsignresult;
                var filename = CAFAttachmentResultObject.id;
                var file = vm.cAFAttachmentSign.investorsign;
                var fileNameArray = file.name.split(".");
                var fileextension="";
                if((fileNameArray.length>1))
                {
                    fileextension=fileNameArray[(fileNameArray.length-1)];
                }
                var inputFileName = CAFAttachmentResultObject.id;
                if(fileextension!=="")
                {
                    inputFileName=inputFileName+"."+fileextension;
                }
                CAFAttachmentResultObject.fileName=inputFileName;
                CAFAttachment.update(CAFAttachmentResultObject, onUpdateCAFAttachmentSignSuccess, onUpdateCAFAttachmentSignError);
            }
            function onSignFileSaveError(cafattachmentid)
            {
                CAFAttachment.delete({id:cafattachmentid});
            }
            function onSaveCAFAttachmentSignError()
            {
                vm.isSaving = false;
            }

            function onUpdateCAFAttachmentSignSuccess(result)
            {
                vm.isSaving = false;
            }
            function onUpdateCAFAttachmentSignError()
            {
                vm.isSaving = false;
            }
        }



        function uploadphoto(projectid)
        {
            if(angular.isDefined(vm.cAFAttachmentPhoto.investorphoto)){
                vm.cAFAttachmentPhotoobject.docName = "Applicant Photo";
                vm.cAFAttachmentPhotoobject.projectid = projectid;
                CAFAttachment.save(vm.cAFAttachmentPhotoobject,onSaveCAFAttachmentPhotoSuccess,onSaveCAFAttachmentPhotoError);
            }
            function onSaveCAFAttachmentPhotoSuccess (result) {
                vm.cafattachphotoresult = result;
                var cafattachmentid = result.id;

                var filename = result.id;
                var file = vm.cAFAttachmentPhoto.investorphoto;
                FileManagement.saveFile(file,filename,onPhotoFileSaveSuccess,onPhotoFileSaveError(cafattachmentid));
                vm.isSaving = false;
            }

            function onPhotoFileSaveSuccess(result){
                $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachphotoresult);
                var CAFAttachmentResultObject=vm.cafattachphotoresult;
                var filename = CAFAttachmentResultObject.id;
                var file = vm.cAFAttachmentPhoto.investorphoto;
                var fileNameArray = file.name.split(".");
                var fileextension = "";
                if((fileNameArray.length>1))
                {
                    fileextension=fileNameArray[(fileNameArray.length-1)];
                }
                var inputFileName = CAFAttachmentResultObject.id;
                if(fileextension!=="")
                {
                    inputFileName=inputFileName+"."+fileextension;
                }
                CAFAttachmentResultObject.fileName=inputFileName;
                CAFAttachment.update(CAFAttachmentResultObject);
            }

            function onPhotoFileSaveError(cafattachmentid)
            {
                CAFAttachment.delete({id:cafattachmentid});
            }

            function onSaveCAFAttachmentPhotoError()
            {
                vm.isSaving = false;
            }

        }

        for(var attachmentcounter=0;attachmentcounter<vm.cafAttachments.length;attachmentcounter++)
        {
            if(vm.cafAttachments[attachmentcounter].docName=="Applicant Photo")
            {
                vm.investorphoto=vm.cafAttachments[attachmentcounter];
            }
            if(vm.cafAttachments[attachmentcounter].docName=="Signature")
            {
                vm.investorsign=vm.cafAttachments[attachmentcounter];
            }
        }

        function onUpdateProjectSuccess(result)
        {
            replaceUploadedPhoto(result);
            replaceUploadedSign(result);
            alert('CAF Edited');
            $state.go('listproject');
            vm.isSaving = false;
        }
        function onUpdateProjectError(result){
            alert('CAF Not Edited');
            vm.isSaving = false;
        }

        function replaceUploadedPhoto(result)
        {
            if(angular.isDefined(vm.cAFAttachmentPhoto.investorphoto)){
                if(vm.investorphoto!==null){
                    var file=vm.cAFAttachmentPhoto.investorphoto;
                    var filename=vm.investorphoto.id;
                    FileManagement.saveFile(file,filename,onreplaceUploadedPhotoSuccess,onreplaceUploadedPhotoError);
                }
                else
                {
                    uploadphoto(result.id);
                }
            }
            function onreplaceUploadedPhotoSuccess(){
                var file=vm.cAFAttachmentPhoto.investorphoto;
                var filename=vm.investorphoto.id;
                var fileNameArray = file.name.split(".");
                var fileextension="";
                if((fileNameArray.length>1))
                {
                    fileextension=fileNameArray[(fileNameArray.length-1)];
                }

                var inputFileName=vm.investorphoto.id;
                if(fileextension!=="")
                {
                    inputFileName=inputFileName+"."+fileextension;
                }
                vm.investorphoto.fileName=inputFileName;
                CAFAttachment.update(vm.investorphoto,onUpdateCAFAttachmentPhotoSuccess,onUpdateCAFAttachmentPhotoError);
                vm.isSaving = false;
            }
            function onreplaceUploadedPhotoError(){
                vm.isSaving=false;
            }
            function onUpdateCAFAttachmentPhotoSuccess(){
                vm.isSaving=false;
            }
            function onUpdateCAFAttachmentPhotoError(){
                vm.isSaving=false;
            }
        }

        function replaceUploadedSign(result)
        {
            if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
                if(vm.investorsign!==null){
                    var file = vm.cAFAttachmentSign.investorsign;
                    var filename = vm.investorsign.id;
                    FileManagement.saveFile(file,filename,onreplaceUploadedSignSuccess,onreplaceUploadedSignError);
                }
                else
                {
                    uploadsign(result.id);
                }
            }
            function onreplaceUploadedSignSuccess(){
                var file = vm.cAFAttachmentSign.investorsign;
                var filename = vm.investorsign.id;
                var fileNameArray = file.name.split(".");
                var fileextension="";
                if((fileNameArray.length>1))
                {
                    fileextension=fileNameArray[(fileNameArray.length-1)];
                }

                var inputFileName=vm.investorsign.id;
                if(fileextension!=="")
                {
                    inputFileName=inputFileName+"."+fileextension;
                }
                vm.investorsign.fileName=inputFileName;
                CAFAttachment.update(vm.investorsign,onUpdateCAFAttachmentSignSuccess,onUpdateCAFAttachmentSignError);
                vm.isSaving = false;
            }
            function onreplaceUploadedSignError(){
                vm.isSaving=false;
            }
            function onUpdateCAFAttachmentSignSuccess(){
                vm.isSaving=false;
            }
            function onUpdateCAFAttachmentSignError(){
                vm.isSaving=false;
            }
        }
        loadAllCountries();
        function loadAllCountries() {
            vm.allcountries=CountryService.getAllCountries();
        }

        vm.confirmProject = function () {
            if(vm.account.authorities.includes('ROLE_USER')){
                vm.sendOTP(vm.proj.mobilenumber);
            }
            $('#confirmCaf').modal('show');
        };
        vm.editForm = function() {
            $('#confirmCaf').modal('hide');
            vm.OTP = false;
            vm.cafOTP = null;
        };
        vm.saveAndClose = function () {
            $('#confirmCaf').modal('hide');
            vm.OTP = false;
            vm.cafOTP = null;
            $timeout(function() {
                saveProject('Final')
            }, 1000);
        };
        function saveCAF() {

            if(vm.isIndustrialEstate==="no" || vm.isIndustrialEstate===""){
                vm.proj.industrialEstate=null;
            }

            if (vm.proj.id !== null)
            {
                AddCAF.update(vm.proj,onUpdateProjectSuccess,onUpdateProjectError);
            }
            else
            {
                AddCAF.save(vm.proj,onSaveProjectSuccess,onSaveProjectError);
            }
        }

        vm.sendOTP = function (mobilenumber) {
            CAFOtp.get({mobileNumber:mobilenumber},function (result) {
                if(result.sending ===true) {
                    vm.OTPstatus = true;
                    vm.cafOTP= null;
                }
                else {
                    vm.OTPstatus = false;
                }
            })

        };
        vm.verifyOTP = function(mobileNumber,OTP){
            CAFOtp.get({mobileNumber:mobileNumber,OTP:OTP},function (result) {
                if(result.verified ===true) {
                    vm.OTP = true;
                    vm.cafOTP = null;
                    CAFOtp.get({mobileNumber: mobileNumber, status: true, user: '1'}, function (result) {

                    })
                }
                else {
                    alert("WRONG OTP")
                }

            })
        };


        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AddCAFnewController', AddCAFnewController);

    AddCAFnewController.$inject = ['$timeout', '$scope', 'Principal', 'LoginService', '$state', 'AddCAF', 'project','District', 'Landusezoneclassification', 'Businessentitys', 'Sector', 'Industrysize', 'Projectype', 'Country', 'Connectingroad', 'Block', 'City_town_village', 'Approvalforms', 'cAFAttachmentPhotoobject', 'cAFAttachmentSignobject', 'FileManagement', 'CAFAttachment', 'cafAttachments','ExtendedUserInformation','CountryService','$filter', 'DistrictVillageBlockMapping','CheckContent','AlertService','Estate', 'State','GetImageForApplicant','CAFOtp','DateUtils'];

    function AddCAFnewController ($timeout, $scope, Principal, LoginService, $state, AddCAF, project, District, Landusezoneclassification, Businessentitys, Sector, Industrysize, Projectype, Country, Connectingroad, Block, City_town_village, Approvalforms, cAFAttachmentPhotoobject, cAFAttachmentSignobject, FileManagement, CAFAttachment, cafAttachments,ExtendedUserInformation,CountryService,$filter, DistrictVillageBlockMapping,CheckContent,AlertService, Estate, State ,GetImageForApplicant,CAFOtp,DateUtils) {
        var vm = this;

        vm.proj = project;
        vm.cAFAttachmentSignobject = cAFAttachmentSignobject;
        vm.cAFAttachmentPhotoobject = cAFAttachmentPhotoobject;
        vm.cAFAttachmentSign = "";
        vm.cAFAttachmentPhoto = "";
        $scope.file = {};
        vm.cafAttachments = cafAttachments;
        vm.investorphoto = null;
        vm.investorsign = null;
        vm.showEstateConfirmation = false;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.errorMessage=errorMessage;
        vm.datePickerOpenStatus = {};
       // vm.openCalendar = openCalendar;
        vm.sectorValueChange = sectorValueChange;
        vm.showIndustrialEstates = false;
        vm.estates = [];

        vm.OTP = false;
        vm.OTPstatus = false;
        vm.cafOTP= null;
        //
        // vm.datePickerOpenStatus.prodctionStartDate = false;
        vm.dateformat = DateUtils.dateformat();
        vm.todayDate = DateUtils.convertLocalDateToServer(new Date());

        // function openCalendar (date) {
        //     vm.datePickerOpenStatus[date] = true;
        // }

        loadAll();
        for(var cafAttachmentscounter=0;cafAttachmentscounter<vm.cafAttachments.length;cafAttachmentscounter++)
        {
            if(vm.cafAttachments[cafAttachmentscounter].docName=="Applicant Photo")
            {
                var filename=vm.cafAttachments[cafAttachmentscounter].fileName;
                vm.investorphoto1=GetImageForApplicant.getImageApplicant(filename);
                vm.cafAttachementInvestorPhoto=vm.cafAttachments[cafAttachmentscounter];

            }
            if(vm.cafAttachments[cafAttachmentscounter].docName=="Signature")
            {
                var filename=vm.cafAttachments[cafAttachmentscounter].fileName;
                vm.investorsign1=GetImageForApplicant.getImageApplicant(filename);
            }
        }


        function loadAll() {
            vm.sectorValueChange (project.sectorname);

            if(vm.isIndustrialEstate!="" && vm.proj.district!=null){
                vm.showEstateConfirmation = true;
                vm.showIndustrialEstates =true;
                if(vm.proj.industrialEstate!= null){
                    vm.isIndustrialEstate ="yes";
                    Estate.query(function (estates) {
                       vm.estates = $filter('filter')(estates, {district: vm.proj.district});
                    });
                }
            }

            if(project.prodctionStartDate !== null){
                vm.proj.prodctionStartDate = new Date(project.prodctionStartDate);
            }
            if(project.investmentType === 'Other'){
                vm.showOtherInvestmentType = true;
            }
            else if(project.investmentType === null){
                project.otherInvestmetType = ' ';
            }

            if(project.foreign_investment !== null && project.foreign_investment !== 0){
                vm.radioToggle = 'Yes';
                vm.showFDI = true;
            }
            else if(project.foreign_investment === null || project.foreign_investment === 0){
                vm.radioToggle = 'No';
                vm.showFDI = false;
            }
        }

        vm.getIndustrialEstates = function(){
                   if (vm.isIndustrialEstate === 'yes'){
                       vm.showIndustrialEstates = true;
                       Estate.query(function (estates) {
                           vm.estates = $filter('filter')(estates, {district: vm.proj.district});
                       });
                   }else {
                       vm.showIndustrialEstates = false;
                       return;
                   }
         };

        vm.getVillages = function (districtName) {
            vm.showEstateConfirmation =true;
            vm.isIndustrialEstate = "no";
            vm.showIndustrialEstates = false;
            DistrictVillageBlockMapping.query({id: '1',districtName: districtName},function(result) {
                vm.villages = result;
                vm.searchQuery = null;
                vm.proj.village = null;
                vm.proj.blockCategory = null;
            });
        };

        vm.setBlockCategory = function (villageName, villageList) {
            vm.showEstateConfirmation = true;
            vm.villageNames =[];
            angular.forEach(villageList, function(value, key){
                vm.villageNames.push(value.village);
            });
            if(vm.villageNames.indexOf(villageName) !== -1){
                vm.invalidVillage = false;
                vm.proj.blockCategory = villageList[vm.villageNames.indexOf(villageName)].category;
            }
            else {
                vm.invalidVillage = true;
            }
        };

        function sectorValueChange (sectorName) {
            if(sectorName === 'Other Industries'){
                if(project.otherFDI === null || vm.proj.otherFDI === 'NA' ){
                    vm.proj.otherFDI = '';
                }
                vm.showOtherSector = true;
            }
            else {
                vm.showOtherSector = false;
                vm.proj.otherFDI = 'NA'
            }
        };

        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        $scope.enterEvent= function (event) {
            event.preventDefault();
            vm.ShowError=true;
        };

        function errorMessage() {
            vm.ShowError=false;
        }
        vm.blockopen = function(){
            $('#blockCategoryHint').modal('show');
        };

        vm.showOtherInvestment = function (currentValue) {
            vm.total_project_cost=0;
            vm.proj.total_project_cost = 0;
            vm.proj.totalproposedprojectarea = 0;
            vm.proj.haryanadomicile = 0;
            vm.proj.totalpurposedemployment = 0;
            vm.proj.nonharyanadomicile = 0;
            vm.project_cost_in_crore = 0;
            vm.project_cost_in_lacs = 0;
            vm.project_cost_in_thousands = 0;
            vm.project_area_in_acres = 0;
            vm.project_area_in_kanal = 0;
            vm.project_area_in_marla = 0;
            vm.proj.powerRequirement = null;
            vm.showOtherInvestmentType = currentValue === 'Other';

        };

        vm.proposedEmployment = function(domicile){
            if(domicile === 'haryana'){
                vm.proj.nonharyanadomicile = vm.proj.totalpurposedemployment - vm.proj.haryanadomicile;
                if(vm.proj.nonharyanadomicile < 0){
                    vm.proj.haryanadomicile = 0;
                    vm.proj.nonharyanadomicile = 0;
                    alert("Your Value Is Not Valid");
                }
            }else{
                vm.proj.haryanadomicile = vm.proj.totalpurposedemployment - vm.proj.nonharyanadomicile;
                if(vm.proj.haryanadomicile < 0){
                    vm.proj.nonharyanadomicile = 0;
                    vm.proj.haryanadomicile = 0;
                    alert("Your Value Is Not Valid");
                }
            }
        };

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                if(vm.proj.id==null){
                vm.proj.firstname = account.firstName;
                vm.proj.lastname = account.lastName;
                vm.proj.emailprimary = account.email;
                    ExtendedUserInformation.get({id:account.id},function (result) {
                        vm.proj.address1=result.userAddress;
                        vm.proj.address2='';
                        vm.proj.address3='';
                        vm.proj.mobilenumber = result.userMobile;

                    });
                }
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        vm.districts = [];
        loadAllDistrict();
        function loadAllDistrict(){
            District.query(function(result) {
               vm.districtstemp = result;
               angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
               });
               vm.searchQuery = null;
           });
        }
        Landusezoneclassification.query(function(result) {
           vm.landusezoneclassifications = result;
           vm.searchQuery = null;
        });
        Businessentitys.query(function(result) {
           vm.businessentities = result;
           vm.searchQuery = null;
        });
        Sector.query(function(result) {
           vm.sectors = result;
           vm.searchQuery = null;
        });
        Industrysize.query(function(result) {
           vm.industrysizes = result;
           vm.searchQuery = null;
        });
        Projectype.query(function(result) {
           vm.projectypes = result;
           vm.searchQuery = null;
        });
        Country.query(function(result) {
           vm.countries = result;
           vm.searchQuery = null;
        });
        State.query(function(result) {
           vm.states = result;
           vm.searchQuery = null;
        });
        Block.query(function(result) {
           vm.blocks = result;
           vm.searchQuery = null;
        });
        Connectingroad.query(function(result) {
           vm.connectingroads = result;
           vm.searchQuery = null;
        });
        City_town_village.query(function(result) {
           vm.city_town_villages = result;
           vm.searchQuery = null;
        });
        Approvalforms.query(function(result) {
           vm.approvalforms = result;
           vm.searchQuery = null;
        });

    vm.project_area_in_acres=Math.floor(calculateAreaInAcre());
    vm.project_area_in_kanal= Math.floor(calculateAreaInKanal());
    vm.project_area_in_marla=Math.floor(calculateAreaInMarla());

    var projectAreaInAcres=vm.project_area_in_acres || 0;
    var projectAreaInKanal=vm.project_area_in_kanal || 0 ;
    var projectAreaInMarla=vm.project_area_in_marla || 0;
    vm.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);

    vm.changeInArea=function(){
        var projectAreaInAcres=vm.project_area_in_acres || 0;
        var projectAreaInKanal=vm.project_area_in_kanal || 0 ;
        var projectAreaInMarla=vm.project_area_in_marla || 0;
        vm.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);
    }

    vm.changeInCost=function(){
          var projectCostInCrore=vm.project_cost_in_crore || '00';
          var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
          var projectCostInThousands=vm.project_cost_in_thousands||'00';
          if(vm.project_cost_in_lacs<10){
             projectCostInLacs='0'+vm.project_cost_in_lacs;
          }
          if(vm.project_cost_in_thousands<10){
             projectCostInThousands='0'+vm.project_cost_in_thousands;
          }
          return vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
    };


    vm.changeInForeignInvestment=function(){
        var projectCostInCrore=vm.foreigninvestment_in_crores || '00';
        var projectCostInLacs=vm.foreigninvestment_in_lacs|| '00' ;
        var projectCostInThousands=vm.foreigninvestment_in_thousands||'00';
        if(vm.foreigninvestment_in_lacs<10){
            projectCostInLacs='0'+vm.foreigninvestment_in_lacs;
        }
        if(vm.foreigninvestment_in_thousands<10){
            projectCostInThousands='0'+vm.foreigninvestment_in_thousands;
        }
        return vm.total_foreign_investment = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
    };


    vm.changeInNri_investment=function(){
        var projectCostInCrore=vm.nri_investment_in_crore || '00';
        var projectCostInLacs=vm.nri_investment_in_lacs|| '00' ;
        var projectCostInThousands=vm.nri_investment_in_thousands||'00';
        if(vm.nri_investment_in_lacs<10){
            projectCostInLacs='0'+vm.nri_investment_in_lacs;
        }
        if(vm.nri_investment_in_thousands<10){
            projectCostInThousands='0'+vm.nri_investment_in_thousands;
        }
        return vm.total_nri_investment = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
    };

    var calculateCostInCrore=function(){
       return parseInt(vm.proj.total_project_cost.toString().split('.')[0]);
    };

    var calculateCostInLacs=function(){
       if(vm.proj.total_project_cost.toString().indexOf('.')!=-1){
        var org = vm.proj.total_project_cost*10000000;
        var lac = (org/100000)%100;
        return parseInt(lac);
       }
       return 0;
    };

    var calculateCostInThousands=function(){
       if(vm.proj.total_project_cost.toString().indexOf('.')!=-1){
       var org = vm.proj.total_project_cost*10000000;
       var th = (org/1000)%100;
        return parseInt(th);
       }
       return 0;
    };

        var calculateforeignInvestmentInCrore = function () {
         if((vm.proj.foreign_investment!=0) && (vm.proj.foreign_investment!=null)){
            return parseInt(vm.proj.foreign_investment.toString().split('.')[0]);
            }
       };

        var calculateforeignInvestmentInlacs = function () {
         if((vm.proj.foreign_investment!=0) && (vm.proj.foreign_investment!=null)){
            if (vm.proj.foreign_investment.toString().indexOf('.') != -1) {
              return parseInt(vm.proj.foreign_investment.toString().split('.')[1].substring(0, 2));
                }
         return 0;
         }
        };

        var calculateforeignInvestmentInThousands = function () {
         if((vm.proj.foreign_investment!=0) && (vm.proj.foreign_investment!=null)){
            if (vm.proj.foreign_investment.toString().indexOf('.') != -1) {
                  return parseInt(vm.proj.foreign_investment.toString().split('.')[1].substring(2, 4));
            }
            return 0;
            }
        };


        var calculatenri_investmentInCrore = function () {
        if((vm.proj.nri_investment!=0) && (vm.proj.nri_investment!=null)){
            return parseInt(vm.proj.nri_investment.toString().split('.')[0]);
            }
        };


        var calculatenri_investmentInlacs = function () {
        if((vm.proj.nri_investment!=0) && (vm.proj.nri_investment!=null)){
            if (vm.proj.nri_investment.toString().indexOf('.') != -1) {
                return parseInt(vm.proj.nri_investment.toString().split('.')[1].substring(0, 2));
            }
            return 0;
            }
        };

        var calculatenri_investmentInThousands = function () {
        if((vm.proj.nri_investment!=0) && (vm.proj.nri_investment!=null)){
            if (vm.proj.nri_investment.toString().indexOf('.') != -1) {
                return parseInt(vm.proj.nri_investment.toString().split('.')[1].substring(2, 4));
            }
            return 0;
          }
        };

    function calculateAreaInAcre(){
       return vm.proj.totalproposedprojectarea;
    }

    function calculateAreaInKanal(){
       var areainkanal=vm.proj.totalproposedprojectarea-Math.floor(vm.proj.totalproposedprojectarea);
       var areaInKanal=areainkanal*8;
       return areaInKanal;
    }

    function calculateAreaInMarla(){
       var areainmarla=Math.floor(calculateAreaInKanal());
       var areaInMarla=(calculateAreaInKanal()-areainmarla)*20;
       return Math.round(areaInMarla);
    }


    vm.project_cost_in_crore=calculateCostInCrore();
    vm.project_cost_in_lacs= calculateCostInLacs();
    vm.project_cost_in_thousands=calculateCostInThousands();

        vm.foreigninvestment_in_crores=calculateforeignInvestmentInCrore();
        vm.foreigninvestment_in_lacs=calculateforeignInvestmentInlacs();
        vm.foreigninvestment_in_thousands=calculateforeignInvestmentInThousands();


        vm.nri_investment_in_crore=calculatenri_investmentInCrore();
        vm.nri_investment_in_lacs=calculatenri_investmentInlacs();
        vm.nri_investment_in_thousands=calculatenri_investmentInThousands();


      var projectCostInCrore=vm.project_cost_in_crore || '00';
      var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
      var projectCostInThousands=vm.project_cost_in_thousands||'00';
      if(vm.project_cost_in_lacs<10){
         projectCostInLacs='0'+vm.project_cost_in_lacs;
      }
      if(vm.project_cost_in_thousands<10){
         projectCostInThousands='0'+vm.project_cost_in_thousands;
      }


    vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;


        var foreignInvestmentInCrore=vm.foreigninvestment_in_crores || '00';
        var foreignInvestmentLacs=vm.foreigninvestment_in_lacs|| '00' ;
        var foreignInvestmentThousands=vm.foreigninvestment_in_thousands||'00';
        if(vm.foreigninvestment_in_lacs<10){
            foreignInvestmentLacs='0'+vm.foreigninvestment_in_lacs;
        }
        if(vm.foreigninvestment_in_thousands<10){
            foreignInvestmentThousands='0'+vm.foreigninvestment_in_thousands;
        }
        vm.total_foreign_investment = foreignInvestmentInCrore+"."+foreignInvestmentLacs+""+foreignInvestmentThousands ;

        var nriInCrore=vm.nri_investment_in_crore || '00';
        var nriInLacs=vm.nri_investment_in_lacs|| '00' ;
        var nriInThousands=vm.nri_investment_in_thousands||'00';
        if(vm.nri_investment_in_lacs<10){
            nriInLacs='0'+vm.nri_investment_in_lacs;
        }
        if(vm.nri_investment_in_thousands<10){
            nriInThousands='0'+vm.nri_investment_in_thousands;
        }
        vm.total_nri_investment = nriInCrore+"."+nriInLacs+""+nriInThousands;


    vm.saveProject = saveProject;

    function saveProject(flag){
        vm.isSaving = true;
       if(vm.proj.totalpurposedemployment > 0 && (vm.proj.haryanadomicile + vm.proj.nonharyanadomicile != vm.proj.totalpurposedemployment)){
            alert("Total of employment with Haryana Domicile and Non-Haryana Domicile must be equal to Total Proposed Employment!!");
            vm.proj.haryanadomicile = 0;
            vm.proj.nonharyanadomicile = 0;
            return;
       }
       if(vm.proj.totalpurposedemployment === 0){
            vm.proj.haryanadomicile = 0;
            vm.proj.nonharyanadomicile = 0;
       }
       vm.proj.totalproposedprojectarea = vm.totalproposedprojectarea;
       vm.proj.total_project_cost = vm.total_project_cost;
       vm.proj.foreign_investment=vm.total_foreign_investment;
       vm.proj.nri_investment=vm.total_nri_investment;

        if(vm.proj.investmentType ==="Existing Project (not a new investment in state)"){
            vm.proj.powerRequirement = null;
        }


       if(flag=='Draft'){
         vm.proj.isdraft=true;
       }
       else if(flag=='Final'){
         vm.proj.isdraft=false;
       }
        if((angular.isDefined(vm.cAFAttachmentSign.investorsign)) || (angular.isDefined(vm.cAFAttachmentPhoto.investorphoto))) {
            var extFile = "jpg";
            var extPic = "jpg";
            var sign = true;
            var photo = true;
            if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
                var sign = vm.cAFAttachmentSign.investorsign;
                var fileNameArray = sign.name.split(".");
                if (fileNameArray.length < 3) {
                    if (fileNameArray[0] != "") {
                        var signDot = sign.name.lastIndexOf(".") + 1;
                        extFile = sign.name.substr(signDot, sign.length).toLowerCase();
                    }
                    else {
                        alert("Invalid File Name");
                        var sign = false;
                    }
                }
                else {
                    alert('Signature File should be in appropriate format')
                    var sign = false;

                }
            }
            if (angular.isDefined(vm.cAFAttachmentPhoto.investorphoto)) {
                var investorPhoto = vm.cAFAttachmentPhoto.investorphoto;
                var filePhotoArray = investorPhoto.name.split(".");

                if (filePhotoArray.length < 3) {
                    if (filePhotoArray[0] != "") {
                        var picDot = investorPhoto.name.lastIndexOf(".") + 1;
                        extPic = investorPhoto.name.substr(picDot, investorPhoto.length).toLowerCase();
                    } else {
                        alert("Invalid File Name");
                        var photo = false;
                    }
                }
                else {
                    alert('Applicant Photo File should be in appropriate format');
                    var photo = false;
                }
            }
            if(photo && sign) {
                if ((extFile == "jpg" || extFile == "jpeg" || extFile == "png") && (extPic == "jpg" || extPic == "jpeg" || extPic == "png")) {
                    saveCAF();
                }
                else {
                    alert("Only jpg/jpeg and png files are allowed!");
                }
            }
        }
        else {
            saveCAF();
        }
    }


    function onSaveProjectSuccess(result)
    {
       uploadphoto(result.id);
       uploadsign(result.id);
       vm.isSaving = false;

       if(vm.proj.isdraft === true){
            alert('Please note that any draft CAF saved in the system for more than 10 days shall be automatically deleted. Hence, you are requested to submit the CAF along with the required information within the prescribed time limit.\n' +
                'Kindly contact our helpdesk at 1800-180-2132 in case you need any assistance in filling out the CAF Form.');
        }
        else{
            alert('CAF Saved');
        }
        $state.go('listproject');
    }
    function onSaveProjectError(result){
        if(result.status === 409){
            vm.existingCAFPin = result.data.cafpin;
            vm.existingCAFLogin = result.data.userlogin;
            alert(' It has been observed that the details entered by you are already present in our system with the following details: CAF Number: ' + vm.existingCAFPin + '  Login ID: ' + vm.existingCAFLogin + '  Please login using the above mentioned login ID to proceed further. In case the CAF number & login ID do not belong to you, kindly contact our helpdesk at 1800-180-2132 to proceed further with the registration process.');
            return;
        }
        alert('CAF Not Saved');
//        AlertService.error("Details Mached With Existing Caf.");
        vm.isSaving = false;
    }

    function uploadsign(projectid)
    {
       if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
           vm.cAFAttachmentSignobject.docName = "Signature";
           vm.cAFAttachmentSignobject.projectid = projectid;
           CAFAttachment.save(vm.cAFAttachmentSignobject,onSaveCAFAttachmentSignSuccess,onSaveCAFAttachmentSignError);
       }
       function onSaveCAFAttachmentSignSuccess (result) {
           vm.cafattachsignresult = result;
           var cafattachmentid = result.id;

           var filename = result.id;
           var file = vm.cAFAttachmentSign.investorsign;
           FileManagement.saveFile(file,filename,onSignFileSaveSuccess,onSignFileSaveError(cafattachmentid));
           vm.isSaving = false;
       }

       function onSignFileSaveSuccess(result){
           $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachsignresult);
           var CAFAttachmentResultObject = vm.cafattachsignresult;
           var filename = CAFAttachmentResultObject.id;
           var file = vm.cAFAttachmentSign.investorsign;
           var fileNameArray = file.name.split(".");
           var fileextension="";
           if((fileNameArray.length>1))
           {
               fileextension=fileNameArray[(fileNameArray.length-1)];
           }
           var inputFileName = CAFAttachmentResultObject.id;
           if(fileextension!=="")
           {
               inputFileName=inputFileName+"."+fileextension;
           }
           CAFAttachmentResultObject.fileName=inputFileName;
           CAFAttachment.update(CAFAttachmentResultObject, onUpdateCAFAttachmentSignSuccess, onUpdateCAFAttachmentSignError);
       }
       function onSignFileSaveError(cafattachmentid)
       {
           CAFAttachment.delete({id:cafattachmentid});
       }
       function onSaveCAFAttachmentSignError()
       {
           vm.isSaving = false;
       }

       function onUpdateCAFAttachmentSignSuccess(result)
       {
           vm.isSaving = false;
       }
       function onUpdateCAFAttachmentSignError()
       {
           vm.isSaving = false;
       }
    }



    function uploadphoto(projectid)
    {
       if(angular.isDefined(vm.cAFAttachmentPhoto.investorphoto)){
           vm.cAFAttachmentPhotoobject.docName = "Applicant Photo";
           vm.cAFAttachmentPhotoobject.projectid = projectid;
           CAFAttachment.save(vm.cAFAttachmentPhotoobject,onSaveCAFAttachmentPhotoSuccess,onSaveCAFAttachmentPhotoError);
       }
       function onSaveCAFAttachmentPhotoSuccess (result) {
           vm.cafattachphotoresult = result;
           var cafattachmentid = result.id;

           var filename = result.id;
           var file = vm.cAFAttachmentPhoto.investorphoto;
           FileManagement.saveFile(file,filename,onPhotoFileSaveSuccess,onPhotoFileSaveError(cafattachmentid));
           vm.isSaving = false;
       }

       function onPhotoFileSaveSuccess(result){
           $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachphotoresult);
           var CAFAttachmentResultObject=vm.cafattachphotoresult;
           var filename = CAFAttachmentResultObject.id;
           var file = vm.cAFAttachmentPhoto.investorphoto;
           var fileNameArray = file.name.split(".");
           var fileextension = "";
           if((fileNameArray.length>1))
           {
               fileextension=fileNameArray[(fileNameArray.length-1)];
           }
           var inputFileName = CAFAttachmentResultObject.id;
           if(fileextension!=="")
           {
               inputFileName=inputFileName+"."+fileextension;
           }
           CAFAttachmentResultObject.fileName=inputFileName;
           CAFAttachment.update(CAFAttachmentResultObject);
       }

       function onPhotoFileSaveError(cafattachmentid)
       {
           CAFAttachment.delete({id:cafattachmentid});
       }

       function onSaveCAFAttachmentPhotoError()
       {
           vm.isSaving = false;
       }

    }

    for(var attachmentcounter=0;attachmentcounter<vm.cafAttachments.length;attachmentcounter++)
    {
        if(vm.cafAttachments[attachmentcounter].docName=="Applicant Photo")
        {
            vm.investorphoto=vm.cafAttachments[attachmentcounter];
        }
        if(vm.cafAttachments[attachmentcounter].docName=="Signature")
        {
            vm.investorsign=vm.cafAttachments[attachmentcounter];
        }
    }

     function onUpdateProjectSuccess(result)
     {
        replaceUploadedPhoto(result);
        replaceUploadedSign(result);
        alert('CAF Edited');
         $state.go('listproject');
         vm.isSaving = false;
     }
     function onUpdateProjectError(result){
         alert('CAF Not Edited');
         vm.isSaving = false;
     }

     function replaceUploadedPhoto(result)
     {
         if(angular.isDefined(vm.cAFAttachmentPhoto.investorphoto)){
            if(vm.investorphoto!==null){
              var file=vm.cAFAttachmentPhoto.investorphoto;
              var filename=vm.investorphoto.id;
              FileManagement.saveFile(file,filename,onreplaceUploadedPhotoSuccess,onreplaceUploadedPhotoError);
            }
            else
            {
              uploadphoto(result.id);
            }
         }
         function onreplaceUploadedPhotoSuccess(){
               var file=vm.cAFAttachmentPhoto.investorphoto;
               var filename=vm.investorphoto.id;
               var fileNameArray = file.name.split(".");
               var fileextension="";
               if((fileNameArray.length>1))
               {
                   fileextension=fileNameArray[(fileNameArray.length-1)];
               }

               var inputFileName=vm.investorphoto.id;
               if(fileextension!=="")
               {
                 inputFileName=inputFileName+"."+fileextension;
               }
               vm.investorphoto.fileName=inputFileName;
               CAFAttachment.update(vm.investorphoto,onUpdateCAFAttachmentPhotoSuccess,onUpdateCAFAttachmentPhotoError);
               vm.isSaving = false;
         }
         function onreplaceUploadedPhotoError(){
               vm.isSaving=false;
         }
         function onUpdateCAFAttachmentPhotoSuccess(){
               vm.isSaving=false;
         }
         function onUpdateCAFAttachmentPhotoError(){
               vm.isSaving=false;
         }
     }

     function replaceUploadedSign(result)
     {
          if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
             if(vm.investorsign!==null){
               var file = vm.cAFAttachmentSign.investorsign;
               var filename = vm.investorsign.id;
               FileManagement.saveFile(file,filename,onreplaceUploadedSignSuccess,onreplaceUploadedSignError);
             }
             else
             {
               uploadsign(result.id);
             }
          }
          function onreplaceUploadedSignSuccess(){
                var file = vm.cAFAttachmentSign.investorsign;
                var filename = vm.investorsign.id;
                var fileNameArray = file.name.split(".");
                var fileextension="";
                if((fileNameArray.length>1))
                {
                    fileextension=fileNameArray[(fileNameArray.length-1)];
                }

                var inputFileName=vm.investorsign.id;
                if(fileextension!=="")
                {
                    inputFileName=inputFileName+"."+fileextension;
                }
                vm.investorsign.fileName=inputFileName;
                CAFAttachment.update(vm.investorsign,onUpdateCAFAttachmentSignSuccess,onUpdateCAFAttachmentSignError);
                vm.isSaving = false;
          }
          function onreplaceUploadedSignError(){
                vm.isSaving=false;
          }
          function onUpdateCAFAttachmentSignSuccess(){
                vm.isSaving=false;
          }
          function onUpdateCAFAttachmentSignError(){
                vm.isSaving=false;
          }
     }
loadAllCountries();
 function loadAllCountries() {
     vm.allcountries=CountryService.getAllCountries();
 }

        vm.confirmProject = function () {
             if(vm.account.authorities.includes('ROLE_USER')){
                 vm.sendOTP(vm.proj.mobilenumber);
             }
            $('#confirmCaf').modal('show');
        };
        vm.editForm = function() {
            $('#confirmCaf').modal('hide');
            vm.OTP = false;
            vm.cafOTP = null;
        };
        vm.saveAndClose = function () {
            $('#confirmCaf').modal('hide');
            vm.OTP = false;
            vm.cafOTP = null;
            $timeout(function() {
                saveProject('Final')
            }, 1000);
        };
        function saveCAF() {

            if(vm.isIndustrialEstate==="no" || vm.isIndustrialEstate===""){
                vm.proj.industrialEstate=null;
            }

            if (vm.proj.id !== null)
            {
                AddCAF.update(vm.proj,onUpdateProjectSuccess,onUpdateProjectError);
            }
            else
            {
                AddCAF.save(vm.proj,onSaveProjectSuccess,onSaveProjectError);
            }
        }

        vm.sendOTP = function (mobilenumber) {
            CAFOtp.get({mobileNumber:mobilenumber},function (result) {
                if(result.sending ===true) {
                    vm.OTPstatus = true;
                    vm.cafOTP= null;
                }
                else {
                    vm.OTPstatus = false;
                }
            })

        };

        //Inside your AngularJS controller
        vm.verifyPan = function() {
            var inputData = {
                pan: vm.proj.pan_number,
                name: vm.proj.businessentity,
                fathername: '',
                dob:'01/01/2015'
            };

            AddCAF.verifyPan(inputData, function(response) {
                console.log('Raw API Response:', response);
                // Extract only the numbered properties from the response manually
                var message = '';
                for (var key in response) {
                    if (response.hasOwnProperty(key) && !isNaN(key)) {
                        message += response[key]; // Append only numeric keys
                    }
                }
                console.log('Extracted Message:', message);
                if (message.indexOf('verified') !== -1) {
                    vm.panSuccessMessage = message; // Display success response
                    vm.panErrorMessage = ''; // Clear error message
                } else {
                    vm.panErrorMessage = message; // Display error response
                    vm.panSuccessMessage = ''; // Clear success message
                }
            }, function(error) {
                vm.panErrorMessage = 'An error occurred while verifying PAN. Please try again.';
                console.error('Error from verifyPan API:', error);
            });
        };


        vm.verifyOTP = function(mobileNumber,OTP){
                CAFOtp.get({mobileNumber:mobileNumber,OTP:OTP},function (result) {
                    if(result.verified ===true) {
                        vm.OTP = true;
                        vm.cafOTP = null;
                        CAFOtp.get({mobileNumber: mobileNumber, status: true, user: '1'}, function (result) {

                        })
                    }
                else {
                    alert("WRONG OTP")
                }

            })
            };

        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});
    }

})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AddCAFlandreqController', AddCAFlandreqController);

    AddCAFlandreqController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'AddCAF', 'project','District', 'CAFAttachment', 'cAFAttachment', 'FileManagement', 'cafAttachments', 'DistrictVillageBlockMapping','CheckContent'];

    function AddCAFlandreqController ($scope, Principal, LoginService, $state, AddCAF, project, District, CAFAttachment, cAFAttachment, FileManagement, cafAttachments, DistrictVillageBlockMapping,CheckContent) {
        var vm = this;

        vm.landreq = project;
        vm.cAFAttachment = cAFAttachment;
        vm.cAFAttachmentSign = "";
        $scope.file = {};
        vm.cafAttachments = cafAttachments;
        vm.investorsign=null;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                if(vm.landreq.id==null){
                vm.landreq.firstname = account.firstName;
                vm.landreq.lastname = account.lastName;
                vm.landreq.emailprimary = account.email;
                vm.landreq.mobilenumber = account.phone;
                }
                vm.landrequiredoptions = ['In Industrial Estate/Area','Outside Developed Industrial Estate/Area'];
                vm.agencies = ['HSIIDC','HUDA','Other developer'];
                vm.landusetypes = ['In Controlled Area','Outside Controlled Area'];
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }
        function register () {
            $state.go('register');
        }

        vm.districts = [];
        loadAllDistrict();
        function loadAllDistrict(){
            District.query(function(result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

        vm.verifyPan = function() {

            var inputData = {
                pan: vm.landreq.pan_number,
                name: vm.landreq.businessentity,
                fathername: '',
                dob:'01/01/2015'
            };

            AddCAF.verifyPan(inputData, function(response) {
                console.log('Raw API Response:', response);
                // Extract only the numbered properties from the response manually
                var message = '';
                for (var key in response) {
                    if (response.hasOwnProperty(key) && !isNaN(key)) {
                        message += response[key]; // Append only numeric keys
                    }
                }
                console.log('Extracted Message:', message);
                if (message.indexOf('verified') !== -1) {
                    vm.panSuccessMessage = message; // Display success response
                    vm.panErrorMessage = ''; // Clear error message
                } else {
                    vm.panErrorMessage = message; // Display error response
                    vm.panSuccessMessage = ''; // Clear success message
                }
            }, function(error) {
                vm.panErrorMessage = 'An error occurred while verifying PAN. Please try again.';
                console.error('Error from verifyPan API:', error);
            });

        };
        vm.getVillages = function (districtName) {
            DistrictVillageBlockMapping.query({id: '1',districtName: districtName},function(result) {
                vm.villages = result;
                vm.searchQuery = null;
                vm.landreq.village = null;
                vm.landreq.blockCategory = null;
            });
        };

        vm.blockopen = function(){
            $('#blockCategoryHint').modal('show');
        };

        vm.setBlockCategory = function (villageName, villageList) {
            vm.villageNames =[];
            angular.forEach(villageList, function(value, key){
                vm.villageNames.push(value.village);
            });
            if(vm.villageNames.indexOf(villageName) !== -1){
                vm.invalidVillage = false;
                vm.landreq.blockCategory = villageList[vm.villageNames.indexOf(villageName)].category;
            }
            else {
                vm.invalidVillage = true;
            }
        };


     vm.project_area_in_acres=Math.floor(calculateAreaInAcre());
     vm.project_area_in_kanal= Math.floor(calculateAreaInKanal());
     vm.project_area_in_marla=Math.floor(calculateAreaInMarla());

      var projectAreaInAcres=vm.project_area_in_acres || 0;
      var projectAreaInKanal=vm.project_area_in_kanal|| 0 ;
      var projectAreaInMarla=vm.project_area_in_marla|| 0;
      vm.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);

    vm.changeInArea=function(){
        var projectAreaInAcres=vm.project_area_in_acres || 0;
        var projectAreaInKanal=vm.project_area_in_kanal|| 0 ;
        var projectAreaInMarla=vm.project_area_in_marla|| 0;
        vm.totalproposedprojectarea=projectAreaInAcres+(projectAreaInKanal/8)+(projectAreaInMarla/160);
    }

    vm.changeInCost=function(){
          var projectCostInCrore=vm.project_cost_in_crore || '00';
          var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
          var projectCostInThousands=vm.project_cost_in_thousands||'00';
          if(vm.project_cost_in_lacs<10){
             projectCostInLacs='0'+vm.project_cost_in_lacs;
          }
          if(vm.project_cost_in_thousands<10){
             projectCostInThousands='0'+vm.project_cost_in_thousands;
          }
return vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;
          }


     var calculateCostInCrore=function(){
       return parseInt(vm.landreq.total_project_cost.toString().split('.')[0]);
     }

     var calculateCostInLacs=function(){
       if(vm.landreq.total_project_cost.toString().indexOf('.')!=-1){
       return parseInt(vm.landreq.total_project_cost.toString().split('.')[1].substring(0,2));
       }
       return 0;
     }

     var calculateCostInThousands=function(){
       if(vm.landreq.total_project_cost.toString().indexOf('.')!=-1){
        return parseInt(vm.landreq.total_project_cost.toString().split('.')[1].substring(2,4));
       }
       return 0;
     }

     function calculateAreaInAcre(){
       return vm.landreq.totalproposedprojectarea;
     }

     function calculateAreaInKanal(){
       var areainkanal=vm.landreq.totalproposedprojectarea-Math.floor(vm.landreq.totalproposedprojectarea);
       var areaInKanal=areainkanal*8;
       return areaInKanal;
     }

     function calculateAreaInMarla(){
       var areainmarla=Math.floor(calculateAreaInKanal());
       var areaInMarla=(calculateAreaInKanal()-areainmarla)*20;
       return Math.round(areaInMarla);
     }


     vm.project_cost_in_crore=calculateCostInCrore();
     vm.project_cost_in_lacs= calculateCostInLacs();
     vm.project_cost_in_thousands=calculateCostInThousands();

       var projectCostInCrore=vm.project_cost_in_crore || '00';
       var projectCostInLacs=vm.project_cost_in_lacs|| '00' ;
       var projectCostInThousands=vm.project_cost_in_thousands||'00';
       if(vm.project_cost_in_lacs<10){
          projectCostInLacs='0'+vm.project_cost_in_lacs;
       }
       if(vm.project_cost_in_thousands<10){
          projectCostInThousands='0'+vm.project_cost_in_thousands;
       }
      vm.total_project_cost = projectCostInCrore+"."+projectCostInLacs+""+projectCostInThousands ;


     vm.onsaveProject = onsaveProject;

     function onsaveProject(flag) {
         vm.isSaving = true;
         vm.landreq.totalproposedprojectarea = vm.totalproposedprojectarea;
         vm.landreq.total_project_cost = vm.total_project_cost;
         if (flag == 'Draft') {
             vm.landreq.isdraft = true;
         }
         else if (flag == 'Final') {
             vm.landreq.isdraft = false;
         }
         if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
             var sign = vm.cAFAttachmentSign.investorsign;
             var fileNameArray = sign.name.split(".");

             if (fileNameArray.length < 3) {
                 if (fileNameArray[0] != "") {
                     var idxDot = sign.name.lastIndexOf(".") + 1;
                     var extFile = sign.name.substr(idxDot, sign.length).toLowerCase();
                     if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
                         saveCAF();
                     }
                     else {
                         alert("Only jpg/jpeg and png files are allowed!");
                     }
                 }
                 else {
                     alert("Invalid File Name");
                 }
             }
             else {
                 alert('Signature File should be in appropriate format')
             }
         }
         else {
             saveCAF();
         }
     }


        function onSaveProjectSuccess(result){
       uploadFile(result.id);
       vm.isSaving = false;
     }

     function onSaveProjectError(){
       alert('CAF Not Saved');
       vm.isSaving = false;
     }

     function uploadFile(projectid)
     {
        if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
            vm.cAFAttachment.docName="Signature";
            vm.cAFAttachment.projectid=projectid;
            CAFAttachment.save(vm.cAFAttachment,onSaveCAFAttachmentSignSuccess,onSaveCAFAttachmentSignError);
        }
        function onSaveCAFAttachmentSignSuccess (result) {
            $scope.$emit('investhryApp:cAFAttachmentUpdate', result);
            vm.cafattachresult = result;
            var cafattachmentid = result.id;

            var filename = result.id;
            var file = vm.cAFAttachmentSign.investorsign;
            FileManagement.saveFile(file,filename,onFileSaveSuccess,onFileSaveError(cafattachmentid));
            vm.isSaving = false;
        }

        function onFileSaveSuccess(result){
        $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachresult);
            var CAFAttachmentResultObject=vm.cafattachresult;
            var filename = CAFAttachmentResultObject.id;
            var file = vm.cAFAttachmentSign.investorsign;
            var fileNameArray = file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }

            var inputFileName = CAFAttachmentResultObject.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            CAFAttachmentResultObject.fileName=inputFileName;
            CAFAttachment.update(CAFAttachmentResultObject);
        }
        function onFileSaveError(cafattachmentid)
        {
            CAFAttachment.delete({id:cafattachmentid});

        }
        function onSaveCAFAttachmentSignError()
        {
            vm.isSaving = false;
        }

     }

     for(var attachmentcounter=0;attachmentcounter<vm.cafAttachments.length;attachmentcounter++)
     {
       if(vm.cafAttachments[0].docName=="Signature")
       {
           vm.investorsign=vm.cafAttachments[0];
       }
     }

      function onUpdateProjectSuccess(result)
      {
        replaceUploadedSign(result);
        vm.isSaving = false;
      }
      function onUpdateProjectError(result){
        alert('CAF Not Edited');
        vm.isSaving = false;
      }

      function replaceUploadedSign(result)
      {
        if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
           if(vm.investorsign!==null){
             var file = vm.cAFAttachmentSign.investorsign;
             var filename = vm.investorsign.id;
             FileManagement.saveFile(file,filename,onreplaceUploadedSignSuccess,onreplaceUploadedSignError);
           }
           else
           {
             uploadFile(result.id);
           }
        }
        function onreplaceUploadedSignSuccess(){
              var file = vm.cAFAttachmentSign.investorsign;
              var filename = vm.investorsign.id;
              var fileNameArray = file.name.split(".");
              var fileextension="";
              if((fileNameArray.length>1))
              {
                  fileextension=fileNameArray[(fileNameArray.length-1)];
              }

              var inputFileName=vm.investorsign.id;
              if(fileextension!=="")
              {
                  inputFileName=inputFileName+"."+fileextension;
              }
              vm.investorsign.fileName=inputFileName;
              CAFAttachment.update(vm.investorsign,onUpdateCAFAttachmentSignSuccess,onUpdateCAFAttachmentSignError);
              vm.isSaving = false;
        }
        function onreplaceUploadedSignError(){
              vm.isSaving=false;
        }
        function onUpdateCAFAttachmentSignSuccess(){
              vm.isSaving=false;
        }
        function onUpdateCAFAttachmentSignError(){
              vm.isSaving=false;
        }
      }

      function saveCAF() {
              if (vm.landreq.id !== null) {
                  AddCAF.update(vm.landreq, onUpdateProjectSuccess, onUpdateProjectError);
                  alert('CAF Edited');
              }
              else {
                  AddCAF.save(vm.landreq, onSaveProjectSuccess, onSaveProjectError);
                  if(vm.landreq.isdraft === true){
                      alert('Please note that any draft CAF saved in the system for more than 10 days shall be automatically deleted. Hence, you are requested to submit the CAF along with the required information within the prescribed time limit.\n' +
                          'Kindly contact our helpdesk at 1800-180-2132 in case you need any assistance in filling out the CAF Form.');
                  }
                  else {
                      alert('CAF Saved');
                  }
              }
              $state.go('listproject');
        }

        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AddCAFlandExchangeController', AddCAFlandExchangeController);

    AddCAFlandExchangeController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'AddCAF', 'project','District', 'cAFAttachment', 'FileManagement', 'CAFAttachment', 'cafAttachments', 'Block', 'Municipality'];

    function AddCAFlandExchangeController ($scope, Principal, LoginService, $state, AddCAF, project, District, cAFAttachment, FileManagement, CAFAttachment, cafAttachments, Block, Municipality) {
        var vm = this;

        vm.landreq = project;
        vm.cAFAttachment=cAFAttachment;
        vm.cAFAttachmentSign="";
        $scope.file = {};
        vm.cafAttachments = cafAttachments;
        vm.investorsign=null;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.landreq.isulb=false;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function() {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function(account) {
                vm.account = account;
                if(vm.landreq.id==null){
                vm.landreq.firstname = account.firstName;
                vm.landreq.lastname = account.lastName;
                vm.landreq.emailprimary = account.email;
                vm.landreq.mobilenumber = account.phone;
                }
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register () {
            $state.go('register');
        }

        vm.districts = [];
        loadAllDistrict();
        function loadAllDistrict(){
            District.query(function(result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function(value, key){
                    if((value.districtname!=='Narnaul' && value.districtname!== 'Chandigarh HQ')){
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

     vm.onsaveProject = onsaveProject;

     function onsaveProject(flag){
       vm.isSaving = true;
//       vm.landreq.total_project_cost = vm.total_project_cost;
       if(flag=='Draft'){
          vm.landreq.isdraft=true;
       }
       else if(flag=='Final'){
          vm.landreq.isdraft=false;
       }
         if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
             var sign =vm.cAFAttachmentSign.investorsign;
             var fileNameArray = sign.name.split(".");

             if(fileNameArray.length<3) {
                 if (fileNameArray[0] != "") {
                     var idxDot = sign.name.lastIndexOf(".") + 1;
                     var extFile = sign.name.substr(idxDot, sign.length).toLowerCase();

                     if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
                         saveCAF();
                     }
                     else {
                         alert("Only jpg/jpeg and png files are allowed!");
                     }
                 }
                 else {
                     alert("Invalid File Name");
                 }
             }
             else{
                 alert('Signature File should be in appropriate format')
             }
         }
         else {
             saveCAF();
         }
     }


     function onSaveProjectSuccess(result){
        uploadFile(result.id);
        vm.isSaving = false;
     }

     function onSaveProjectError(){
        alert('CAF Not Saved');
        vm.isSaving = false;
     }

     function uploadFile(projectid)
     {
         if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
             vm.cAFAttachment.docName="Signature";
             vm.cAFAttachment.projectid=projectid;
             CAFAttachment.save(vm.cAFAttachment,onSaveCAFAttachmentSignSuccess,onSaveCAFAttachmentSignError);
         }
         function onSaveCAFAttachmentSignSuccess (result) {
             $scope.$emit('investhryApp:cAFAttachmentUpdate', result);
             vm.cafattachresult = result;
             var cafattachmentid = result.id;

             var filename = result.id;
             var file = vm.cAFAttachmentSign.investorsign;
             FileManagement.saveFile(file,filename,onFileSaveSuccess,onFileSaveError(cafattachmentid));
             vm.isSaving = false;
         }

         function onFileSaveSuccess(result){
         $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachresult);
             var CAFAttachmentResultObject=vm.cafattachresult;
             var filename = CAFAttachmentResultObject.id;
             var file = vm.cAFAttachmentSign.investorsign;
             var fileNameArray = file.name.split(".");
             var fileextension="";
             if((fileNameArray.length>1))
             {
                 fileextension=fileNameArray[(fileNameArray.length-1)];
             }

             var inputFileName = CAFAttachmentResultObject.id;
             if(fileextension!=="")
             {
                 inputFileName=inputFileName+"."+fileextension;
             }
             CAFAttachmentResultObject.fileName=inputFileName;
             CAFAttachment.update(CAFAttachmentResultObject);
         }
         function onFileSaveError(cafattachmentid)
         {
             CAFAttachment.delete({id:cafattachmentid});

         }
         function onSaveCAFAttachmentSignError()
         {
             vm.isSaving = false;
         }
     }


     for(var attachmentcounter=0;attachmentcounter<vm.cafAttachments.length;attachmentcounter++)
      {
        if(vm.cafAttachments[0].docName=="Signature")
        {
            vm.investorsign=vm.cafAttachments[0];
        }
      }

     function onUpdateProjectSuccess(result)
     {
         replaceUploadedSign(result);
         vm.isSaving = false;
     }
     function onUpdateProjectError(result){
         alert('CAF Not Edited');
         vm.isSaving = false;
     }

     function replaceUploadedSign(result)
     {
         if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
            if(vm.investorsign!==null){
              var file = vm.cAFAttachmentSign.investorsign;
              var filename = vm.investorsign.id;
              FileManagement.saveFile(file,filename,onreplaceUploadedSignSuccess,onreplaceUploadedSignError);
            }
            else
            {
              uploadFile(result.id);
            }
         }
         function onreplaceUploadedSignSuccess(){
               var file = vm.cAFAttachmentSign.investorsign;
               var filename = vm.investorsign.id;
               var fileNameArray = file.name.split(".");
               var fileextension="";
               if((fileNameArray.length>1))
               {
                   fileextension=fileNameArray[(fileNameArray.length-1)];
               }

               var inputFileName=vm.investorsign.id;
               if(fileextension!=="")
               {
                   inputFileName=inputFileName+"."+fileextension;
               }
               vm.investorsign.fileName=inputFileName;
               CAFAttachment.update(vm.investorsign,onUpdateCAFAttachmentSignSuccess,onUpdateCAFAttachmentSignError);
               vm.isSaving = false;
         }
         function onreplaceUploadedSignError(){
               vm.isSaving=false;
         }
         function onUpdateCAFAttachmentSignSuccess(){
               vm.isSaving=false;
         }
         function onUpdateCAFAttachmentSignError(){
               vm.isSaving=false;
         }
     }

     vm.optiontriggerd= function (value) {
         if(value){
           vm.show =true;
           vm.landreq.isulb=true;
         }
         else {
             vm.show =false;
             vm.landreq.isulb=false;
         }
     };

     vm.getBydistrict =function (district) {
         Block.query({id: 1,districtname: district},function(result) {
             vm.blocks = result;
             vm.searchQuery = null;
         });
         Municipality.query({id: 1,districtname: district},function(result) {
             console.log(result);
             vm.municipalities = result;
             vm.searchQuery = null;
         });
     }

     function saveCAF() {
         if (vm.landreq.id !== null) {
             AddCAF.update(vm.landreq,onUpdateProjectSuccess,onUpdateProjectError);
             alert('CAF Edited');
         }
         else{
             AddCAF.save(vm.landreq,onSaveProjectSuccess,onSaveProjectError);
             if(vm.landreq.isdraft === true){
                 alert('Please note that any draft CAF saved in the system for more than 10 days shall be automatically deleted. Hence, you are requested to submit the CAF along with the required information within the prescribed time limit.\n' +
                     'Kindly contact our helpdesk at 1800-180-2132 in case you need any assistance in filling out the CAF Form.');
             }
             else {
                 alert('CAF Saved');
             }
         }
         $state.go('listproject');
     }

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AddCAFfilmController', AddCAFfilmController);

    AddCAFfilmController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'AddCAF', 'project','District', 'cAFAttachment', 'FileManagement', 'CAFAttachment', 'cafAttachments','CheckContent'];

    function AddCAFfilmController ($scope, Principal, LoginService, $state, AddCAF, project, District, cAFAttachment, FileManagement, CAFAttachment, cafAttachments,CheckContent) {
        var vm = this;

        vm.landreq = project;
        vm.cAFAttachment = cAFAttachment;
        vm.cAFAttachmentSign = "";
        $scope.file = {};
        vm.cafAttachments = cafAttachments;
        vm.investorsign = null;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                if (vm.landreq.id == null) {
                    vm.landreq.firstname = account.firstName;
                    vm.landreq.lastname = account.lastName;
                    vm.landreq.emailprimary = account.email;
                    vm.landreq.mobilenumber = account.phone;
                }
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register() {
            $state.go('register');
        }

        vm.districts = [];
        loadAllDistrict();

        function loadAllDistrict() {
            District.query(function (result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function (value, key) {
                    if ((value.districtname !== 'Narnaul' && value.districtname !== 'Chandigarh HQ')) {
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

        vm.onsaveProject = onsaveProject;

        function onsaveProject(flag) {
            vm.isSaving = true;
//       vm.landreq.total_project_cost = vm.total_project_cost;
            if (flag == 'Draft') {
                vm.landreq.isdraft = true;
            }
            else if (flag == 'Final') {
                vm.landreq.isdraft = false;
            }
            if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
                var sign = vm.cAFAttachmentSign.investorsign;
                var fileNameArray = sign.name.split(".");

                if (fileNameArray.length < 3) {
                    if (fileNameArray[0] != "") {
                        var idxDot = sign.name.lastIndexOf(".") + 1;
                        var extFile = sign.name.substr(idxDot, sign.length).toLowerCase();

                        if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
                            saveCAF();
                        }
                        else {
                            alert("Only jpg/jpeg and png files are allowed!");
                        }
                    }
                    else
                        {
                            alert("Invalid File Name");
                        }
                }
                else {
                    alert('Signature File should be in appropriate format')
                }
            }
            else {
                saveCAF();
            }
        }

     function onSaveProjectSuccess(result){
        uploadFile(result.id);
        vm.isSaving = false;
     }

     function onSaveProjectError(){
        alert('CAF Not Saved');
        vm.isSaving = false;
     }

        vm.verifyPan = function() {

            var inputData = {
                pan: vm.landreq.pan_number,
                name: vm.landreq.businessentity,
                fathername: '',
                dob:'01/01/2015'
            };

            AddCAF.verifyPan(inputData, function(response) {
                console.log('Raw API Response:', response);
                // Extract only the numbered properties from the response manually
                var message = '';
                for (var key in response) {
                    if (response.hasOwnProperty(key) && !isNaN(key)) {
                        message += response[key]; // Append only numeric keys
                    }
                }

                console.log('Extracted Message:', message);
                if (message.indexOf('verified') !== -1) {
                    vm.panSuccessMessage = message; // Display success response
                    vm.panErrorMessage = ''; // Clear error message
                } else {
                    vm.panErrorMessage = message; // Display error response
                    vm.panSuccessMessage = ''; // Clear success message
                }
            }, function(error) {
                vm.panErrorMessage = 'An error occurred while verifying PAN. Please try again.';
                console.error('Error from verifyPan API:', error);
            });


        };

     function uploadFile(projectid)
     {
         if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
             vm.cAFAttachment.docName="Signature";
             vm.cAFAttachment.projectid=projectid;
             CAFAttachment.save(vm.cAFAttachment,onSaveCAFAttachmentSignSuccess,onSaveCAFAttachmentSignError);
         }
         function onSaveCAFAttachmentSignSuccess (result) {
             $scope.$emit('investhryApp:cAFAttachmentUpdate', result);
             vm.cafattachresult = result;
             var cafattachmentid = result.id;

             var filename = result.id;
             var file = vm.cAFAttachmentSign.investorsign;
             FileManagement.saveFile(file,filename,onFileSaveSuccess,onFileSaveError(cafattachmentid));
             vm.isSaving = false;
         }

         function onFileSaveSuccess(result){
         $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachresult);
             var CAFAttachmentResultObject=vm.cafattachresult;
             var filename = CAFAttachmentResultObject.id;
             var file = vm.cAFAttachmentSign.investorsign;
             var fileNameArray = file.name.split(".");
             var fileextension="";
             if((fileNameArray.length>1))
             {
                 fileextension=fileNameArray[(fileNameArray.length-1)];
             }

             var inputFileName = CAFAttachmentResultObject.id;
             if(fileextension!=="")
             {
                 inputFileName=inputFileName+"."+fileextension;
             }
             CAFAttachmentResultObject.fileName=inputFileName;
             CAFAttachment.update(CAFAttachmentResultObject);
         }
         function onFileSaveError(cafattachmentid)
         {
             CAFAttachment.delete({id:cafattachmentid});

         }
         function onSaveCAFAttachmentSignError()
         {
             vm.isSaving = false;
         }
     }


     for(var attachmentcounter=0;attachmentcounter<vm.cafAttachments.length;attachmentcounter++)
      {
        if(vm.cafAttachments[0].docName=="Signature")
        {
            vm.investorsign=vm.cafAttachments[0];
        }
      }

     function onUpdateProjectSuccess(result)
     {
         replaceUploadedSign(result);
         vm.isSaving = false;
     }
     function onUpdateProjectError(result){
         alert('CAF Not Edited');
         vm.isSaving = false;
     }

     function replaceUploadedSign(result)
     {
         if(angular.isDefined(vm.cAFAttachmentSign.investorsign)){
            if(vm.investorsign!==null){
              var file = vm.cAFAttachmentSign.investorsign;
              var filename = vm.investorsign.id;
              FileManagement.saveFile(file,filename,onreplaceUploadedSignSuccess,onreplaceUploadedSignError);
            }
            else
            {
              uploadFile(result.id);
            }
         }
         function onreplaceUploadedSignSuccess(){
               var file = vm.cAFAttachmentSign.investorsign;
               var filename = vm.investorsign.id;
               var fileNameArray = file.name.split(".");
               var fileextension="";
               if((fileNameArray.length>1))
               {
                   fileextension=fileNameArray[(fileNameArray.length-1)];
               }

               var inputFileName=vm.investorsign.id;
               if(fileextension!=="")
               {
                   inputFileName=inputFileName+"."+fileextension;
               }
               vm.investorsign.fileName=inputFileName;
               CAFAttachment.update(vm.investorsign,onUpdateCAFAttachmentSignSuccess,onUpdateCAFAttachmentSignError);
               vm.isSaving = false;
         }
         function onreplaceUploadedSignError(){
               vm.isSaving=false;
         }
         function onUpdateCAFAttachmentSignSuccess(){
               vm.isSaving=false;
         }
         function onUpdateCAFAttachmentSignError(){
               vm.isSaving=false;
         }
     }
     function saveCAF() {
         if(vm.landreq.id !== null) {
             AddCAF.update(vm.landreq, onUpdateProjectSuccess, onUpdateProjectError);
             alert('CAF Edited');
         }
         else {
             AddCAF.save(vm.landreq, onSaveProjectSuccess, onSaveProjectError);
             if(vm.landreq.isdraft === true){
                 alert('Please note that any draft CAF saved in the system for more than 10 days shall be automatically deleted. Hence, you are requested to submit the CAF along with the required information within the prescribed time limit.\n' +
                     'Kindly contact our helpdesk at 1800-180-2132 in case you need any assistance in filling out the CAF Form.');
             }
             else{
                 alert('CAF Saved');
             }
         }
         $state.go('listproject');
     }

        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});
    }
})();

(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AddCAFexciseController', AddCAFexciseController);

    AddCAFexciseController.$inject = ['$scope', 'Principal', 'LoginService', '$state', 'AddCAF', 'project', 'District', 'cAFAttachment', 'FileManagement', 'CAFAttachment', 'cafAttachments', 'DistrictVillageBlockMapping', 'CheckContent', 'ExtendedUserInformation'];

    function AddCAFexciseController($scope, Principal, LoginService, $state, AddCAF, project, District, cAFAttachment, FileManagement, CAFAttachment, cafAttachments, DistrictVillageBlockMapping, CheckContent, ExtendedUserInformation) {
        var vm = this;

        vm.excisereq = project;
        vm.cAFAttachment = cAFAttachment;
        vm.cAFAttachmentSign = "";
        $scope.file = {};
        vm.cafAttachments = cafAttachments;
        vm.investorsign = null;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = LoginService.open;
        vm.register = register;
        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        getAccount();

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                if (vm.excisereq.id == null) {
                    vm.excisereq.firstname = account.firstName;
                    vm.excisereq.lastname = account.lastName;
                    vm.excisereq.emailprimary = account.email;
                    ExtendedUserInformation.get({id: account.id}, function (result) {
                        vm.excisereq.mobilenumber = result.userMobile;
                    });
                }
                vm.isAuthenticated = Principal.isAuthenticated;
            });
        }

        function register() {
            $state.go('register');
        }


        vm.districts = [];
        loadAllDistrict();

        function loadAllDistrict() {
            District.query(function (result) {
                vm.districtstemp = result;
                angular.forEach(vm.districtstemp, function (value, key) {
                    if ((value.districtname !== 'Narnaul' && value.districtname !== 'Chandigarh HQ')) {
                        vm.districts.push(value);
                    }
                });
                vm.searchQuery = null;
            });
        }

        vm.getVillages = function (districtName) {
            DistrictVillageBlockMapping.query({id: '1', districtName: districtName}, function (result) {
                vm.villages = result;
                vm.searchQuery = null;
                vm.excisereq.village = null;
                vm.excisereq.blockCategory = null;
            });
        };

        vm.setBlockCategory = function (villageName, villageList) {
            vm.villageNames = [];
            angular.forEach(villageList, function (value, key) {
                vm.villageNames.push(value.village);
            });
            if (vm.villageNames.indexOf(villageName) !== -1) {
                vm.invalidVillage = false;
                vm.excisereq.blockCategory = villageList[vm.villageNames.indexOf(villageName)].category;
            } else {
                vm.invalidVillage = true;
            }
        };

        vm.verifyPan = function() {

            var inputData = {
                pan: vm.excisereq.pan_number,
                name: vm.excisereq.businessentity,
                fathername: '',
                dob:'01/01/2015'
            };

            AddCAF.verifyPan(inputData, function(response) {
                console.log('Raw API Response:', response);
                // Extract only the numbered properties from the response manually
                var message = '';
                for (var key in response) {
                    if (response.hasOwnProperty(key) && !isNaN(key)) {
                        message += response[key]; // Append only numeric keys
                    }
                }

                console.log('Extracted Message:', message);
                if (message.indexOf('verified') !== -1) {
                    vm.panSuccessMessage = message; // Display success response
                    vm.panErrorMessage = ''; // Clear error message
                } else {
                    vm.panErrorMessage = message; // Display error response
                    vm.panSuccessMessage = ''; // Clear success message
                }
            }, function(error) {
                vm.panErrorMessage = 'An error occurred while verifying PAN. Please try again.';
                console.error('Error from verifyPan API:', error);
            });

        };
        vm.changeInCost = function () {
            var projectCostInCrore = vm.project_cost_in_crore || '00';
            var projectCostInLacs = vm.project_cost_in_lacs || '00';
            var projectCostInThousands = vm.project_cost_in_thousands || '00';
            if (vm.project_cost_in_lacs < 10) {
                projectCostInLacs = '0' + vm.project_cost_in_lacs;
            }
            if (vm.project_cost_in_thousands < 10) {
                projectCostInThousands = '0' + vm.project_cost_in_thousands;
            }
            return vm.total_project_cost = projectCostInCrore + "." + projectCostInLacs + "" + projectCostInThousands;
        }

        var calculateCostInCrore = function () {
            return parseInt(vm.excisereq.total_project_cost.toString().split('.')[0]);
        }

        var calculateCostInLacs = function () {
            if (vm.excisereq.total_project_cost.toString().indexOf('.') != -1) {
                var num = parseInt(vm.excisereq.total_project_cost * (10000000));
                var lac = parseInt((num / 100000) % 100);
                return lac;
            }
            return 0;
        }

        var calculateCostInThousands = function () {
            if (vm.excisereq.total_project_cost.toString().indexOf('.') != -1) {
                var num = parseInt(vm.excisereq.total_project_cost * (10000000));
                var th = parseInt((num / 1000) % 100);
                return th;
            }
            return 0;
        }

        vm.project_cost_in_crore = calculateCostInCrore();
        vm.project_cost_in_lacs = calculateCostInLacs();
        vm.project_cost_in_thousands = calculateCostInThousands();

        var projectCostInCrore = vm.project_cost_in_crore || '00';
        var projectCostInLacs = vm.project_cost_in_lacs || '00';
        var projectCostInThousands = vm.project_cost_in_thousands || '00';
        if (vm.project_cost_in_lacs < 10) {
            projectCostInLacs = '0' + vm.project_cost_in_lacs;
        }
        if (vm.project_cost_in_thousands < 10) {
            projectCostInThousands = '0' + vm.project_cost_in_thousands;
        }
        vm.total_project_cost = projectCostInCrore + "." + projectCostInLacs + "" + projectCostInThousands;


        vm.onsaveProject = onsaveProject;

        function onsaveProject(flag) {
            vm.isSaving = true;
            vm.excisereq.total_project_cost = vm.total_project_cost;
            if (flag == 'Draft') {
                vm.excisereq.isdraft = true;
            } else if (flag == 'Final') {
                vm.excisereq.isdraft = false;
            }
            if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
                var sign = vm.cAFAttachmentSign.investorsign;
                var fileNameArray = sign.name.split(".");

                if (fileNameArray.length < 3) {
                    if (fileNameArray[0] != "") {
                        var idxDot = sign.name.lastIndexOf(".") + 1;
                        var extFile = sign.name.substr(idxDot, sign.length).toLowerCase();

                        if (extFile == "jpg" || extFile == "jpeg" || extFile == "png") {
                            saveCAF();
                        } else {
                            alert("Only jpg/jpeg and png files are allowed!");
                        }
                    } else {
                        alert("Invalid File Name");
                    }
                } else {
                    alert('Signature File should be in appropriate format')
                }
            } else {
                saveCAF();
            }

        }


        function onSaveProjectSuccess(result) {
            uploadFile(result.id);
            alert('CAF Saved');
            vm.isSaving = false;
        }

        function onSaveProjectError() {
            alert('You can apply only once for excise caf');
            vm.isSaving = false;
        }

        function uploadFile(projectid) {
            if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
                vm.cAFAttachment.docName = "Signature";
                vm.cAFAttachment.projectid = projectid;
                CAFAttachment.save(vm.cAFAttachment, onSaveCAFAttachmentSignSuccess, onSaveCAFAttachmentSignError);
            }

            function onSaveCAFAttachmentSignSuccess(result) {
                $scope.$emit('investhryApp:cAFAttachmentUpdate', result);
                vm.cafattachresult = result;
                var cafattachmentid = result.id;

                var filename = result.id;
                var file = vm.cAFAttachmentSign.investorsign;
                FileManagement.saveFile(file, filename, onFileSaveSuccess, onFileSaveError(cafattachmentid));
                vm.isSaving = false;
            }

            function onFileSaveSuccess(result) {
                $scope.$emit('investhryApp:cAFAttachmentUpdate', vm.cafattachresult);
                var CAFAttachmentResultObject = vm.cafattachresult;
                var filename = CAFAttachmentResultObject.id;
                var file = vm.cAFAttachmentSign.investorsign;
                var fileNameArray = file.name.split(".");
                var fileextension = "";
                if ((fileNameArray.length > 1)) {
                    fileextension = fileNameArray[(fileNameArray.length - 1)];
                }

                var inputFileName = CAFAttachmentResultObject.id;
                if (fileextension !== "") {
                    inputFileName = inputFileName + "." + fileextension;
                }
                CAFAttachmentResultObject.fileName = inputFileName;
                CAFAttachment.update(CAFAttachmentResultObject);
            }

            function onFileSaveError(cafattachmentid) {
                CAFAttachment.delete({id: cafattachmentid});

            }

            function onSaveCAFAttachmentSignError() {
                vm.isSaving = false;
            }
        }


        for (var attachmentcounter = 0; attachmentcounter < vm.cafAttachments.length; attachmentcounter++) {
            if (vm.cafAttachments[0].docName == "Signature") {
                vm.investorsign = vm.cafAttachments[0];
            }
        }

        function onUpdateProjectSuccess(result) {
            replaceUploadedSign(result);
            alert('CAF Edited');

            vm.isSaving = false;
        }

        function onUpdateProjectError(result) {
            alert('CAF Not Edited');
            vm.isSaving = false;
        }

        function replaceUploadedSign(result) {
            if (angular.isDefined(vm.cAFAttachmentSign.investorsign)) {
                if (vm.investorsign !== null) {
                    var file = vm.cAFAttachmentSign.investorsign;
                    var filename = vm.investorsign.id;
                    FileManagement.saveFile(file, filename, onreplaceUploadedSignSuccess, onreplaceUploadedSignError);
                } else {
                    uploadFile(result.id);
                }
            }

            function onreplaceUploadedSignSuccess() {
                var file = vm.cAFAttachmentSign.investorsign;
                var filename = vm.investorsign.id;
                var fileNameArray = file.name.split(".");
                var fileextension = "";
                if ((fileNameArray.length > 1)) {
                    fileextension = fileNameArray[(fileNameArray.length - 1)];
                }

                var inputFileName = vm.investorsign.id;
                if (fileextension !== "") {
                    inputFileName = inputFileName + "." + fileextension;
                }
                vm.investorsign.fileName = inputFileName;
                CAFAttachment.update(vm.investorsign, onUpdateCAFAttachmentSignSuccess, onUpdateCAFAttachmentSignError);
                vm.isSaving = false;
            }

            function onreplaceUploadedSignError() {
                vm.isSaving = false;
            }

            function onUpdateCAFAttachmentSignSuccess() {
                vm.isSaving = false;
            }

            function onUpdateCAFAttachmentSignError() {
                vm.isSaving = false;
            }
        }

        function saveCAF() {
            if (vm.excisereq.id !== null) {
                AddCAF.update(vm.excisereq, onUpdateProjectSuccess, onUpdateProjectError);
            } else {
                AddCAF.save(vm.excisereq, onSaveProjectSuccess, onSaveProjectError);
            }
            $state.go('listproject');
        }

        $('input').each(function () {
            CheckContent.check($(this))
        });
        $('textarea').each(function () {
            CheckContent.check($(this))
        });

    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('addCAFlandreq', {
            parent: 'app',
            url: '/addCAFlandreq',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFlandreq.html',
                    controller: 'AddCAFlandreqController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: function () {
                     return {
                         id: null,
                         firstname: null,
                         middlename: null,
                         lastname: null,
                         emailprimary: null,
                         emailsecondary: null,
                         phonenumber: null,
                         mobilenumber: null,
                         businessentity: null,
                         district: null,
                         totalproposedprojectarea: "0",
                         total_project_cost: "0",
                         totalpurposedemployment: 0,

                         cafpin: null,
                         isdeactivated: false,

                         landrequired: null,
                         plotsize: null,
                         agencyname: null,
                         estatename: null,
                         purchaserate: null,
                         village: null,
                         tehsil: null,
                         landrequirementindistrict: null,
                         landusetype: null,

                         landzoneuse_type: "Commercial",
                         clurequired: false,

                         acceptance: null,
                         place: null,
                         isdraft: false,
                         caftype: "LandRequirement",

                         mouapplicable: false,
                         multyvillageinvolved: false,
                         falls_in_aravalli: false,
                         islandprocured: false,
                         allotedbyhsiidc: false,
                         liesunder_mc: false,
                         islocated_in_urban: false,
                         certifiedownership: false,
                         leaseapplicable: false,
                         landagreementapplicable: false,
                         intersectiondistance: false,
                         railwaydistance: false,
                         confirmitylanduse: false,
                         existing_building_applicable: false,
                         site_situated_in_controlled_area: false,
                         isfdi: false,
                         existing_regulatory_approval: false,
                         edc_sif_clu_fee_paid_applicable: false,
                         foreign_investment: "0",
                         nri_investment: "0",
                         projectlevel: "d",
                         powerRequirement: null
                     };
                },
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                }
        }
        })

        .state('editlandreqCAF', {
            parent: 'app',
            url: '/addCAFlandreq/edit/{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFlandreq.html',
                    controller: 'AddCAFlandreqController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: ['$stateParams', 'Project', function($stateParams,Project) {
                        return Project.get({id : $stateParams.id}).$promise;
                }],
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                    return CAFAttachment.query({id : "1",projectid : $stateParams.id}).$promise;
                }]
            }
        })

        .state('caftype', {
            parent: 'app',
            url: '/caftype',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/addCAF/caftype.html',
                    controller: 'CAFTypeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg'
                });
            }],
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })

        .state('addCAFshop', {
            parent: 'app',
            url: '/addCAFshop',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFshop.html',
                    controller: 'AddCAFshopController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: function () {
                     return {
                         id: null,
                         firstname: null,
                         middlename: null,
                         lastname: null,
                         emailprimary: null,
                         emailsecondary: null,
                         phonenumber: null,
                         mobilenumber: null,
                         businessentity: null,
                         district: null,
                         total_project_cost: "0",
                         totalpurposedemployment: 0,
                         cafpin: null,
                         isdeactivated: false,
                         landzoneuse_type: "Commercial",
                         clurequired: false,
                         acceptance: null,
                         place: null,
                         isdraft: false,
                         caftype: "Shop",

                         totalproposedprojectarea: "0",
                         mouapplicable: false,
                         multyvillageinvolved: false,
                         falls_in_aravalli: false,
                         islandprocured: false,
                         allotedbyhsiidc: false,
                         liesunder_mc: false,
                         islocated_in_urban: false,
                         certifiedownership: false,
                         leaseapplicable: false,
                         landagreementapplicable: false,
                         intersectiondistance: false,
                         railwaydistance: false,
                         confirmitylanduse: false,
                         existing_building_applicable: false,
                         site_situated_in_controlled_area: false,
                         isfdi: false,
                         existing_regulatory_approval: false,
                         edc_sif_clu_fee_paid_applicable: false,
                         foreign_investment: "0",
                         nri_investment: "0",
                         projectlevel: "d"
                     };
                },
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                }
            }
        })
            .state('addCAFexcise', {
                parent: 'app',
                url: '/addCAFexcise',
                data: {
                    authorities: ['ROLE_USER','ROLE_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/addCAF/addCAFexcise.html',
                        controller: 'AddCAFexciseController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('addproject');
                        return $translate.refresh();
                    }],
                    project: function () {
                        return {
                            id: null,
                            firstname: null,
                            middlename: null,
                            lastname: null,
                            emailprimary: null,
                            emailsecondary: null,
                            phonenumber: null,
                            mobilenumber: null,
                            businessentity: null,
                            district: null,
                            total_project_cost: "0",
                            totalpurposedemployment: 0,
                            cafpin: null,
                            isdeactivated: false,
                            landzoneuse_type: "Commercial",
                            clurequired: false,
                            acceptance: null,
                            place: null,
                            isdraft: false,
                            caftype: "Excise",

                            totalproposedprojectarea: "0",
                            mouapplicable: false,
                            multyvillageinvolved: false,
                            falls_in_aravalli: false,
                            islandprocured: false,
                            allotedbyhsiidc: false,
                            liesunder_mc: false,
                            islocated_in_urban: false,
                            certifiedownership: false,
                            leaseapplicable: false,
                            landagreementapplicable: false,
                            intersectiondistance: false,
                            railwaydistance: false,
                            confirmitylanduse: false,
                            existing_building_applicable: false,
                            site_situated_in_controlled_area: false,
                            isfdi: false,
                            existing_regulatory_approval: false,
                            edc_sif_clu_fee_paid_applicable: false,
                            foreign_investment: "0",
                            nri_investment: "0",
                            projectlevel: "d"
                        };
                    },
                    cAFAttachment: function () {
                        return {
                            projectid: null,
                            docName: null,
                            fileName: null,
                            id: null
                        };
                    },
                    cafAttachments: function () {
                        return {
                            projectid: null,
                            docName: null,
                            fileName: null,
                            id: null
                        };
                    }
                }
            })

        .state('editshopCAF', {
            parent: 'app',
            url: '/addCAFshop/edit/{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFshop.html',
                    controller: 'AddCAFshopController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: ['$stateParams', 'Project', function($stateParams,Project) {
                        return Project.get({id : $stateParams.id}).$promise;
                }],
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                    return CAFAttachment.query({id : "1",projectid : $stateParams.id}).$promise;
                }]
            }
        })

        .state('addCAFrenewable', {
            parent: 'app',
            url: '/addCAFrenewable',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFrenewable.html',
                    controller: 'AddCAFrenewableController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: function () {
                     return {
                         id: null,
                         firstname: null,
                         middlename: null,
                         lastname: null,
                         emailprimary: null,
                         emailsecondary: null,
                         phonenumber: null,
                         mobilenumber: null,
                         district: null,
                         cafpin: null,
                         isdeactivated: false,
                         landzoneuse_type: "Industrial",
                         clurequired: false,
                         acceptance: null,
                         place: null,
                         isdraft: false,
                         caftype: "Renewable",
                         businessentity: null,

                         totalpurposedemployment: 0,
                         totalproposedprojectarea: "0",
                         total_project_cost: "0",
                         mouapplicable: false,
                         multyvillageinvolved: false,
                         falls_in_aravalli: false,
                         islandprocured: false,
                         allotedbyhsiidc: false,
                         liesunder_mc: false,
                         islocated_in_urban: false,
                         certifiedownership: false,
                         leaseapplicable: false,
                         landagreementapplicable: false,
                         intersectiondistance: false,
                         railwaydistance: false,
                         confirmitylanduse: false,
                         existing_building_applicable: false,
                         site_situated_in_controlled_area: false,
                         isfdi: false,
                         existing_regulatory_approval: false,
                         edc_sif_clu_fee_paid_applicable: false,
                         foreign_investment: "0",
                         nri_investment: "0",
                         projectlevel: "d"
                     };
                },
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                }
            }
        })

        .state('editrenewableCAF', {
            parent: 'app',
            url: '/addCAFrenewable/edit/{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFrenewable.html',
                    controller: 'AddCAFrenewableController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: ['$stateParams', 'Project', function($stateParams,Project) {
                        return Project.get({id : $stateParams.id}).$promise;
                }],
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                    return CAFAttachment.query({id : "1",projectid : $stateParams.id}).$promise;
                }]
            }
        })

        .state('addCAFnew', {
            parent: 'app',
            url: '/addCAFnew',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFnew.html',
                    controller: 'AddCAFnewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: function () {
                     return {
                         id: null,
                         mouapplicable: false,
                         mousignyear: null,
                         mouidnumber: null,
                         firstname: null,
                         middlename: null,
                         lastname: null,
                         address1: null,
                         address2: null,
                         address3: null,
                         emailprimary: null,
                         emailsecondary: null,
                         userlogin: null,
                         cityname: null,
                         countryname: null,
                         statename: null,
                         createdate: null,
                         updatedate: null,
                         cafpin: null,
                         pincode: null,
                         phonenumber: null,
                         mobilenumber: null,
                         promoter_md_director: null,
                         designation: null,
                         businessentity: null,
                         director_promoter_md_ceo_number: null,
                         pan_number: null,
                         aadhar_number: null,
                         nri: null,
                         tin_vat_number: null,
                         cst_number: null,
                         businessentitytype: null,
                         gstnumber: null,
                         siteaddress: null,
                         multyvillageinvolved: false,
                         villageinvolved: null,
                         falls_in_aravalli: false,
                         islandprocured: false,
                         allotedbyhsiidc: false,
                         estate: null,
                         cluster: null,
                         phase: null,
                         sector: null,
                         plotno: null,
                         hadbastno: null,
                         liesunder_mc: false,
                         distance_from_mc: null,
                         islocated_in_urban: false,
                         totalproposedprojectarea: "0",
                         proposedbuilt_up_area: null,
                         certifiedownership: false,
                         leaseapplicable: false,
                         landagreementapplicable: false,
                         intersectiondistance: false,
                         railwaydistance: false,
                         confirmitylanduse: false,
                         existing_building_applicable: false,
                         site_situated_in_controlled_area: false,
                         buildingexisted: null,
                         district: null,
                         block: null,
                         city_town_village: null,
                         connectingroad: null,
                         landzoneuse_type: "",
                         tehsil_subtehsil: null,
                         clurequired: false,
                         land_cost: null,
                         building_cost: null,
                         total_project_cost: "0",
                         totalpurposedemployment: 0,
                         acceptance: false,
                         applicationdate: null,
                         place: null,
                         projectpurpose: null,
                         niccode: null,
                         existing_regulatory_approval: false,
                         edc_sif_clu_fee_paid_applicable: false,
                         approval_application_form: null,
                         category_of_project: null,
                         collaboration_with_foreign_country: null,
                         projectype: null,
                         sectorname: null,
                         size_of_industry: null,
                         sectorother: null,
                         isdeactivated: false,
                         deactivatedby: null,
                         deactivateddate: null,
                         projectlevel: "d",
                         isdraft: false,
                         caftype: "New",
                         landrequired: null,
                         plotsize: null,
                         landusetype: null,
                         product: null,
                         uamnumber: null,
                         isfdi: false,
                         foreign_investment: 0,
                         nri_investment: "0",
                         investmentType: null,
                         otherInvestmetType: null,
                         prodctionStartDate: null,
                         otherFDI: null,
                         haryanadomicile: 0,
                         nonharyanadomicile: 0
                     };
                },
                cAFAttachmentPhotoobject: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cAFAttachmentSignobject: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                }
            }
        })

        .state('editnewCAF', {
            parent: 'app',
            url: '/addCAFnew/edit/{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFnew.html',
                    controller: 'AddCAFnewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: ['$stateParams', 'Project', function($stateParams,Project) {
                    return Project.get({id : $stateParams.id}).$promise;
                }],
                cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                        return CAFAttachment.query({id : "1",projectid : $stateParams.id}).$promise;
                }],
                cAFAttachmentPhotoobject: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cAFAttachmentSignobject: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                }
            }
        })
            //
            // .state('editCafForUser', {
            //     parent: 'app',
            //     url: '/editCafForUser/{id}',
            //     data: {
            //         authorities: []   // add role if needed later
            //     },
            //     views: {
            //         'content@': {
            //             templateUrl: 'app/addCAF/editCafForUser.html',
            //             controller: 'EditCafForUser',
            //             controllerAs: 'vm'
            //         }
            //     },
            //     resolve: {
            //
            //         translatePartialLoader: [
            //             '$translate',
            //             '$translatePartialLoader',
            //             function ($translate, $translatePartialLoader) {
            //                 $translatePartialLoader.addPart('addproject');
            //                 return $translate.refresh();
            //             }
            //         ],
            //
            //         project: [
            //             '$stateParams',
            //             'Project',
            //             function ($stateParams, Project) {
            //                 return Project.get({ id: $stateParams.id }).$promise;
            //             }
            //         ]
            //     }
            // })


            .state('editCafForUser', {
                parent: 'app',
                url: '/editCafForUser/{id}',
                data: {
                    authorities: []  // add role later if needed
                },
                views: {
                    'content@': {
                        templateUrl: 'app/addCAF/editCafForUser.html',
                        controller: 'EditCafForUser',
                        controllerAs: 'vm'
                    }
                },
                resolve: {

                    translatePartialLoader: [
                        '$translate',
                        '$translatePartialLoader',
                        function ($translate, $translatePartialLoader) {
                            $translatePartialLoader.addPart('addproject');
                            return $translate.refresh();
                        }
                    ],

                    project: [
                        '$stateParams',
                        'Project',
                        function ($stateParams, Project) {
                            return Project.get({ id: $stateParams.id }).$promise;
                        }
                    ]
                }
            })


            .state('addCAFnewRestricted', {
                parent: 'app',
                url: '/addCAFnew/restricted/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/addCAF/addCAFnewRestricted.html',
                        controller: 'AddCAFnewRestrictedController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('addproject');
                        return $translate.refresh();
                    }],
                    project: ['$stateParams', 'Project', function($stateParams,Project) {
                        var project = Project.get({id : $stateParams.id}).$promise;
                        return {
                            id: null,
                            mouapplicable: false,
                            mousignyear: null,
                            mouidnumber: null,
                            firstname: null,
                            middlename: null,
                            lastname: null,
                            address1: null,
                            address2: null,
                            address3: null,
                            emailprimary: null,
                            emailsecondary: null,
                            userlogin: null,
                            cityname: null,
                            countryname: null,
                            statename: null,
                            createdate: null,
                            updatedate: null,
                            cafpin: null,
                            pincode: null,
                            phonenumber: null,
                            mobilenumber: null,
                            promoter_md_director: null,
                            designation: null,
                            businessentity: null,
                            director_promoter_md_ceo_number: null,
                            pan_number: null,
                            aadhar_number: null,
                            nri: null,
                            tin_vat_number: null,
                            cst_number: null,
                            businessentitytype: null,
                            gstnumber: null,
                            siteaddress: null,
                            multyvillageinvolved: false,
                            villageinvolved: null,
                            falls_in_aravalli: false,
                            islandprocured: false,
                            allotedbyhsiidc: false,
                            estate: null,
                            cluster: null,
                            phase: null,
                            sector: null,
                            plotno: null,
                            hadbastno: null,
                            liesunder_mc: false,
                            distance_from_mc: null,
                            islocated_in_urban: false,
                            totalproposedprojectarea: "0",
                            proposedbuilt_up_area: null,
                            certifiedownership: false,
                            leaseapplicable: false,
                            landagreementapplicable: false,
                            intersectiondistance: false,
                            railwaydistance: false,
                            confirmitylanduse: false,
                            existing_building_applicable: false,
                            site_situated_in_controlled_area: false,
                            buildingexisted: null,
                            district: null,
                            block: null,
                            city_town_village: null,
                            connectingroad: null,
                            landzoneuse_type: "",
                            tehsil_subtehsil: null,
                            clurequired: false,
                            land_cost: null,
                            building_cost: null,
                            total_project_cost: "0",
                            totalpurposedemployment: 0,
                            acceptance: false,
                            applicationdate: null,
                            place: null,
                            projectpurpose: null,
                            niccode: null,
                            existing_regulatory_approval: false,
                            edc_sif_clu_fee_paid_applicable: false,
                            approval_application_form: null,
                            category_of_project: null,
                            collaboration_with_foreign_country: null,
                            projectype: null,
                            sectorname: null,
                            size_of_industry: null,
                            sectorother: null,
                            isdeactivated: false,
                            deactivatedby: null,
                            deactivateddate: null,
                            projectlevel: "d",
                            isdraft: false,
                            caftype: "New",
                            landrequired: null,
                            plotsize: null,
                            landusetype: null,
                            product: null,
                            uamnumber: null,
                            isfdi: false,
                            foreign_investment: 0,
                            nri_investment: "0",
                            investmentType: null,
                            otherInvestmetType: null,
                            prodctionStartDate: null,
                            otherFDI: null,
                            haryanadomicile: 0,
                            nonharyanadomicile: 0
                        };
                    }],
                    cAFAttachmentPhotoobject: function () {
                        return {
                            projectid: null,
                            docName: null,
                            fileName: null,
                            id: null
                        };
                    },
                    cAFAttachmentSignobject: function () {
                        return {
                            projectid: null,
                            docName: null,
                            fileName: null,
                            id: null
                        };
                    },
                    cAFAttachment: function () {
                        return {
                            projectid: null,
                            docName: null,
                            fileName: null,
                            id: null
                        };
                    },
                    cafAttachments: function () {
                        return {
                            projectid: null,
                            docName: null,
                            fileName: null,
                            id: null
                        };
                    }
                }
        })

        .state('caftypeNewEnterprise', {
            parent: 'caftype',
            url: '/NewEnterpriseservies',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/addCAF/newcafservices.html',
                    controller: 'CAFTypeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('caftype', {}, { reload: false });
                }, function() {
                    $state.go('caftype');
                });
            }]
        })

        .state('caftypeShopEnterprise', {
            parent: 'caftype',
            url: '/ShopEnterpriseservies',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/addCAF/shopcafservices.html',
                    controller: 'CAFTypeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('caftype', {}, { reload: false });
                }, function() {
                    $state.go('caftype');
                });
            }]
        })
            .state('caftypeExciseEnterprise', {
                parent: 'caftype',
                url: '/ExciseEnterpriseservies',
                data: {
                    authorities: ['ROLE_USER','ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/addCAF/excisecafservices.html',
                        controller: 'CAFTypeController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                        }
                    }).result.then(function() {
                        $state.go('caftype', {}, { reload: false });
                    }, function() {
                        $state.go('caftype');
                    });
                }]
            })

         .state('caftypeLandExchange', {
            parent: 'caftype',
            url: '/landExchangecafservices',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/addCAF/landExchangecafservices.html',
                    controller: 'CAFTypeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('caftype', {}, { reload: false });
                }, function() {
                    $state.go('caftype');
                });
            }]
        })

        .state('caftypeRenewEnterprise', {
            parent: 'caftype',
            url: '/RenewEnterpriseservies',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/addCAF/renewcafservices.html',
                    controller: 'CAFTypeController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                    }
                }).result.then(function() {
                    $state.go('caftype', {}, { reload: false });
                }, function() {
                    $state.go('caftype');
                });
            }]
        })

        .state('commAndConnServices', {
                    parent: 'caftype',
                    url: '/commAndConnServices',
                    data: {
                        authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
                    },
                    onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/addCAF/CommAndConnPermissions.html',
                            controller: 'CAFTypeController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                            }
                        }).result.then(function() {
                            $state.go('caftype', {}, { reload: false });
                        }, function() {
                            $state.go('caftype');
                        });
                    }]
                })
            // .state('rowServices', {
            //     parent: 'caftype',
            //     url: '/rowServices',
            //     data: {
            //         authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            //     },
            //     onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
            //         $uibModal.open({
            //             templateUrl: 'app/addCAF/rowServices.html',
            //             controller: 'CAFTypeController',
            //             controllerAs: 'vm',
            //             backdrop: 'static',
            //             size: 'lg',
            //             resolve: {
            //             }
            //         }).result.then(function() {
            //             $state.go('caftype', {}, { reload: false });
            //         }, function() {
            //             $state.go('caftype');
            //         });
            //     }]
            // })
            .state('filmServices', {
                parent: 'caftype',
                url: '/filmServices',
                data: {
                    authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/addCAF/filmServices.html',
                        controller: 'CAFTypeController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                        }
                    }).result.then(function() {
                        $state.go('caftype', {}, { reload: false });
                    }, function() {
                        $state.go('caftype');
                    });
                }]
            })
            .state('landServices', {
                parent: 'caftype',
                url: '/landServices',
                data: {
                    authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/addCAF/landServices.html',
                        controller: 'CAFTypeController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                        }
                    }).result.then(function() {
                        $state.go('caftype', {}, { reload: false });
                    }, function() {
                        $state.go('caftype');
                    });
                }]
            })

        .state('addCAFtower', {
                    parent: 'app',
                    url: '/addCAFtower',
                    data: {
                        authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/addCAF/addCAFtower.html',
                            controller: 'AddCAFtowerController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('addproject');
                            return $translate.refresh();
                        }],
                        project: function () {
                             return {
                                 id: null,
                                 firstname: null,
                                 middlename: null,
                                 lastname: null,
                                 emailprimary: null,
                                 emailsecondary: null,
                                 phonenumber: null,
                                 mobilenumber: null,
                                 businessentity: null,
                                 district: null,
                                 total_project_cost: "0",
                                 totalpurposedemployment: 0,
                                 cafpin: null,
                                 isdeactivated: false,
                                 landzoneuse_type: "Commercial",
                                 clurequired: false,
                                 acceptance: null,
                                 place: null,
                                 isdraft: false,
                                 caftype: "Tower",

                                 totalproposedprojectarea: "0",
                                 mouapplicable: false,
                                 multyvillageinvolved: false,
                                 falls_in_aravalli: false,
                                 islandprocured: false,
                                 allotedbyhsiidc: false,
                                 liesunder_mc: false,
                                 islocated_in_urban: false,
                                 certifiedownership: false,
                                 leaseapplicable: false,
                                 landagreementapplicable: false,
                                 intersectiondistance: false,
                                 railwaydistance: false,
                                 confirmitylanduse: false,
                                 existing_building_applicable: false,
                                 site_situated_in_controlled_area: false,
                                 isfdi: false,
                                 existing_regulatory_approval: false,
                                 edc_sif_clu_fee_paid_applicable: false,
                                 foreign_investment: "0",
                                 nri_investment: "0",
                                 projectlevel: "d"
                             };
                        },
                        cAFAttachment: function () {
                            return {
                                projectid: null,
                                docName: null,
                                fileName: null,
                                id: null
                            };
                        },
                        cafAttachments: function () {
                            return {
                                projectid: null,
                                docName: null,
                                fileName: null,
                                id: null
                            };
                        }
                    }
                })

        .state('editTowerCAF', {
            parent: 'app',
            url: '/addCAFtower/edit/{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFtower.html',
                    controller: 'AddCAFtowerController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: ['$stateParams', 'Project', function($stateParams,Project) {
                        return Project.get({id : $stateParams.id}).$promise;
                }],
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                    return CAFAttachment.query({id : "1",projectid : $stateParams.id}).$promise;
                }]
            }
        })

        .state('addCAFrow', {
            parent: 'app',
            url: '/addCAFrow',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFrow.html',
                    controller: 'AddCAFrowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: function () {
                    return {
                        id: null,
                        firstname: null,
                        middlename: null,
                        lastname: null,
                        emailprimary: null,
                        emailsecondary: null,
                        phonenumber: null,
                        mobilenumber: null,
                        businessentity: null,
                        district: null,
                        total_project_cost: "0",
                        totalpurposedemployment: 0,
                        cafpin: null,
                        isdeactivated: false,
                        landzoneuse_type: "NA",
                        clurequired: false,
                        acceptance: null,
                        place: null,
                        isdraft: false,
                        caftype: "ROW",

                        totalproposedprojectarea: "0",
                        mouapplicable: false,
                        multyvillageinvolved: false,
                        falls_in_aravalli: false,
                        islandprocured: false,
                        allotedbyhsiidc: false,
                        liesunder_mc: false,
                        islocated_in_urban: false,
                        certifiedownership: false,
                        leaseapplicable: false,
                        landagreementapplicable: false,
                        intersectiondistance: false,
                        railwaydistance: false,
                        confirmitylanduse: false,
                        existing_building_applicable: false,
                        site_situated_in_controlled_area: false,
                        isfdi: false,
                        existing_regulatory_approval: false,
                        edc_sif_clu_fee_paid_applicable: false,
                        foreign_investment: "0",
                        nri_investment: "0",
                        projectlevel: "d"
                    };
                },
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                }
            }
        })

        .state('editRowCAF', {
            parent: 'app',
            url: '/addCAFrow/edit/{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFrow.html',
                    controller: 'AddCAFrowController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: ['$stateParams', 'Project', function($stateParams,Project) {
                    return Project.get({id : $stateParams.id}).$promise;
                }],
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                    return CAFAttachment.query({id : "1",projectid : $stateParams.id}).$promise;
                }]
            }
        })

        .state('editFilmCAF', {
            parent: 'app',
            url: '/editFilmCAF/edit/{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFfilm.html',
                    controller: 'AddCAFfilmController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: ['$stateParams', 'Project', function($stateParams,Project) {
                        return Project.get({id : $stateParams.id}).$promise;
                }],
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                    return CAFAttachment.query({id : "1",projectid : $stateParams.id}).$promise;
                }]
            }
        })

            .state('editExciseCAF', {
                parent: 'app',
                url: '/editExciseCAF/edit/{id}',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/addCAF/addCAFexcise.html',
                        controller: 'AddCAFexciseController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('addproject');
                        return $translate.refresh();
                    }],
                    project: ['$stateParams', 'Project', function($stateParams,Project) {
                        return Project.get({id : $stateParams.id}).$promise;
                    }],
                    cAFAttachment: function () {
                        return {
                            projectid: null,
                            docName: null,
                            fileName: null,
                            id: null
                        };
                    },
                    cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                        return CAFAttachment.query({id : "1",projectid : $stateParams.id}).$promise;
                    }]
                }
            })

        .state('addCAFlandExchange', {
                parent: 'app',
                url: '/addCAFlandExchange',
                data: {
                    authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/addCAF/addCAFlandExchange.html',
                        controller: 'AddCAFlandExchangeController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('addproject');
                        return $translate.refresh();
                    }],
                    project: function () {
                        return {
                            id: null,
                            firstname: null,
                            middlename: null,
                            lastname: null,
                            emailprimary: null,
                            emailsecondary: null,
                            phonenumber: null,
                            mobilenumber: null,
                            businessentity: null,
                            district: null,
                            total_project_cost: "0",
                            totalpurposedemployment: 0,
                            cafpin: null,
                            isdeactivated: false,
                            landzoneuse_type: "Commercial",
                            clurequired: false,
                            acceptance: null,
                            place: null,
                            isdraft: false,
                            caftype: "LandExchange",
                            block: "NA",

                            totalproposedprojectarea: "0",
                            mouapplicable: false,
                            multyvillageinvolved: false,
                            falls_in_aravalli: false,
                            islandprocured: false,
                            allotedbyhsiidc: false,
                            liesunder_mc: false,
                            islocated_in_urban: false,
                            certifiedownership: false,
                            leaseapplicable: false,
                            landagreementapplicable: false,
                            intersectiondistance: false,
                            railwaydistance: false,
                            confirmitylanduse: false,
                            existing_building_applicable: false,
                            site_situated_in_controlled_area: false,
                            isfdi: false,
                            existing_regulatory_approval: false,
                            edc_sif_clu_fee_paid_applicable: false,
                            foreign_investment: "0",
                            nri_investment: "0",
                            projectlevel: "d",
                            isulb: false,
                            mc: "NA"
                        };
                    },
                    cAFAttachment: function () {
                        return {
                            projectid: null,
                            docName: null,
                            fileName: null,
                            id: null
                        };
                    },
                    cafAttachments: function () {
                        return {
                            projectid: null,
                            docName: null,
                            fileName: null,
                            id: null
                        };
                    }
                }
            })

        .state('editLandExchangeCAF', {
            parent: 'app',
            url: '/addCAFlandExchange/edit/{id}',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFlandExchange.html',
                    controller: 'AddCAFlandExchangeController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: ['$stateParams', 'Project', function($stateParams,Project) {
                    return Project.get({id : $stateParams.id}).$promise;
                }],
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: ['$stateParams', 'CAFAttachment', function($stateParams,CAFAttachment) {
                    return CAFAttachment.query({id : "1",projectid : $stateParams.id}).$promise;
                }]
            }
        })
        .state('addCAFfilm', {
            parent: 'app',
            url: '/addCAFfilm',
            data: {
                authorities: ['ROLE_USER','ROLE_ADMIN','ROLE_SUB_ADMIN']
            },
            views: {
                'content@': {
                    templateUrl: 'app/addCAF/addCAFfilm.html',
                    controller: 'AddCAFfilmController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('addproject');
                    return $translate.refresh();
                }],
                project: function () {
                     return {
                         id: null,
                         firstname: null,
                         middlename: null,
                         lastname: null,
                         emailprimary: null,
                         emailsecondary: null,
                         phonenumber: null,
                         mobilenumber: null,
                         businessentity: null,
                         district: null,
                         total_project_cost: "0",
                         totalpurposedemployment: 0,
                         cafpin: null,
                         isdeactivated: false,
                         landzoneuse_type: "Commercial",
                         clurequired: false,
                         acceptance: null,
                         place: null,
                         isdraft: false,
                         caftype: "FILMCAF",

                         totalproposedprojectarea: "0",
                         mouapplicable: false,
                         multyvillageinvolved: false,
                         falls_in_aravalli: false,
                         islandprocured: false,
                         allotedbyhsiidc: false,
                         liesunder_mc: false,
                         islocated_in_urban: false,
                         certifiedownership: false,
                         leaseapplicable: false,
                         landagreementapplicable: false,
                         intersectiondistance: false,
                         railwaydistance: false,
                         confirmitylanduse: false,
                         existing_building_applicable: false,
                         site_situated_in_controlled_area: false,
                         isfdi: false,
                         existing_regulatory_approval: false,
                         edc_sif_clu_fee_paid_applicable: false,
                         foreign_investment: "0",
                         nri_investment: "0",
                         projectlevel: "d"
                     };
                },
                cAFAttachment: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                },
                cafAttachments: function () {
                    return {
                        projectid: null,
                        docName: null,
                        fileName: null,
                        id: null
                    };
                }
            }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('AddCAF', AddCAF);

    AddCAF.$inject = ['$resource'];

    function AddCAF ($resource) {
        var resourceUrl =  '/api/addcaf';


        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'verifyPan': {
                method: 'POST',
                url: '/api/verifyPan',
                transformResponse: function (data) {
                    return data; // Return the raw response (string)
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activateuser', {
                    parent: 'app',
                    url: '/activateuser',
                    data: {
                        authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN']
                    },
                    views: {
                        'content@': {
                            templateUrl: 'app/activateuser/activateuser.html',
                            controller: 'ActivateUserController',
                            controllerAs: 'vm'
                        }
                    },
                    resolve: {
                        translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                            $translatePartialLoader.addPart('home');
                            return $translate.refresh();
                 }]
             }
        });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('ActivateUser', ActivateUser);

    ActivateUser.$inject = ['$resource'];

    function ActivateUser ($resource) {
        var resourceUrl =  '/api/activateuser';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ActivateUserController', ActivateUserController);

    ActivateUserController.$inject = ['User','UserById','ActivateUser'];

    function ActivateUserController(User,UserById,ActivateUser) {

        var vm = this;
        vm.getUser = getUser;
        function getUser(id){
            UserById.get({id:id},function(user){
                vm.user = user;
            });
        }

        vm.activate = activate;
        function activate(user){
            vm.user.activated = true;
            ActivateUser.update(vm.user,onSuccess,onError);
        }
        function onSuccess(result){
            alert("User Successfully Activated with login: " + result.login);
        }
        function onError(){
            alert("User Not Activated.");
        }
    }
 })();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'account',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER','ROLE_RM','ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_DESK_OFFICER','ROLE_NODAL_OFFICER','ROLE_FIELD_OFFICER', 'ROLE_ACCOUNT_OFFICER', 'ROLE_TOWER_OFFICER','ROLE_FILM_OFFICER','ROLE_FEEDBACK_OFFICER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal','$state','Auth', 'JhiLanguageService', '$translate', 'ExtendedUserInformation','CheckContent'];

    function SettingsController (Principal,$state, Auth, JhiLanguageService, $translate, ExtendedUserInformation,CheckContent) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.extendedUserInformation={};

        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});

        /**
         * Store the "settings account" in a separate variable, and not in the shared "account" variable.
         */
        var copyAccount = function (account) {
           // console.log(account);
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login
            };
        };

        Principal.identity().then(function(account) {
            ExtendedUserInformation.get({id:account.id},function(result) {
                vm.extendedUserInformation = result;
            });
            vm.settingsAccount = copyAccount(account);
        });

        function save () {
            Auth.updateAccount(vm.settingsAccount).then(function() {
                ExtendedUserInformation.update(vm.extendedUserInformation);
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function(account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function(current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
                $state.go('home',{},{reload:true});
            }).catch(function() {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$stateParams', '$timeout', 'Auth', 'LoginService'];

    function ResetFinishController ($stateParams, $timeout, Auth, LoginService) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = LoginService.open;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                var encrytedResetPassword = encryptPassword(vm.resetAccount.password);
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: encrytedResetPassword}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function encryptPassword(plainString)
        {
            var iv = "a407e444cd6179be5ced97caf0ff11cb";
            var salt = "a826254e90f626b011eb21aca9a79b65";
            var keySize = 128;
            var iterationCount = 10000;
            var passPhrase = "NAimIodPNkqOyHQXmEpoFA==Sdty=jHY";
            var aesUtil = new AesUtil(keySize, iterationCount);
            var encryptedString = aesUtil.encrypt(salt, iv, passPhrase, plainString);
            return encryptedString;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService','CheckContent'];

    function RegisterController ($translate, $timeout, Auth, LoginService,CheckContent) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        vm.isSaving = false;

        $('input').each(function(){ CheckContent.check($(this))});
        $('textarea').each(function() { CheckContent.check($(this))});

        $timeout(function () {
            angular.element('#login').focus();
        });

        function register() {
        vm.isSaving = true;
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
                vm.isSaving = false;
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;
                vm.errorLoginNotAcceptable = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    vm.isSaving = false;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'Login Not Acceptable with this Extension.Choose Another') {
                        vm.errorLoginNotAcceptable = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('investhryApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'account',
            url: '/password',
            data: {
                authorities: ['ROLE_USER', 'ROLE_ADMIN','ROLE_SUB_ADMIN', 'ROLE_RM', 'ROLE_DESK_OFFICER', 'ROLE_NODAL_OFFICER', 'ROLE_ACCOUNT_OFFICER', 'ROLE_FIELD_OFFICER','ROLE_ASSIGNRM_OFFICER','ROLE_MONITORING_OFFICER', 'ROLE_HEPC_MONITORING_OFFICER','ROLE_API_VIEWER','ROLE_GRIEVANCE_OFFICER','ROLE_GRIEVANCE_ADMIN', 'ROLE_TOWER_DC', 'ROLE_TOWER_USER', 'ROLE_TOWER_NODAL_OFFICER', 'ROLE_TOWER_DEPARTMENT', 'ROLE_CPUSER', 'ROLE_TOWER_DIO','ROLE_TOWER_OFFICER','ROLE_DEPT_CHANGE','ROLE_USER_EXT','ROLE_FILM_OFFICER','ROLE_FILM_SUBOFFICER', 'ROLE_L1_SUPPORT', 'ROLE_L2_IT_MANAGER', 'ROLE_L2_INCENTIVES', 'ROLE_L2_DEPARTMENT','ROLE_L2_DEPARTMENT_HEAD','ROLE_TICKET_OPERATION_MANAGER', 'ROLE_TICKET_NODAL_OFFICER', 'ROLE_FEEDBACK_OFFICER', 'ROLE_TICKET_ADMIN' ,'ROLE_SKILLS_REQUIREMENT_OFFICER','ROLE_CAF_STATUS_OFFICER','ROLE_INCENTIVE_DISBURSEMENT_HEAD'],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal', '$state'];

    function PasswordController (Auth, Principal, $state) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;
        vm.passwordResult = false;
        vm.showError = false;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword (currentPassword) {
            var encPassword = encryptPassword(currentPassword);
            Auth.checkPassword({
                username: vm.account.login,
                password: encPassword
            },function(result) {
                vm.passwordResult = result;
                if(vm.passwordResult) {
                    if (vm.password !== vm.confirmPassword) {
                        vm.error = null;
                        vm.success = null;
                        vm.doNotMatch = 'ERROR';
                    } else {
                        vm.doNotMatch = null;
                        var newPassword = encryptPassword(vm.password);
                        Auth.changePassword(newPassword).then(function () {
                            vm.error = null;
                            vm.success = 'OK';
                        }).catch(function () {
                            vm.success = null;
                            vm.error = 'ERROR';
                        });
                    }
                } else {
                    vm.showError = true;
                }
            });
        }

        function encryptPassword(plainString)
        {
            var iv = "a407e444cd6179be5ced97caf0ff11cb";
            var salt = "a826254e90f626b011eb21aca9a79b65";
            var keySize = 128;
            var iterationCount = 10000;
            var passPhrase = "NAimIodPNkqOyHQXmEpoFA==Sdty=jHY";
            var aesUtil = new AesUtil(keySize, iterationCount);
            var encryptedString = aesUtil.encrypt(salt, iv, passPhrase, plainString);
            return encryptedString;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$stateParams', 'Auth', 'LoginService'];

    function ActivationController ($stateParams, Auth, LoginService) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = LoginService.open;
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('acceptance', {
            parent: 'app',
            url: '/acceptance',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/acceptance/acceptance.html',
                    controller: 'acceptanceController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('home');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('acceptanceController', acceptanceController);

    acceptanceController.$inject = ['$state'];

    function acceptanceController($state) {
        var vm = this;
       };
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AboveGroundDialogController', AboveGroundDialogController);

    AboveGroundDialogController.$inject = ['$timeout', '$scope', '$state', '$stateParams', 'entity', 'Above_ground', 'FileManagement', 'District', 'Zone'];

    function AboveGroundDialogController ($timeout, $scope, $state, $stateParams, entity, Above_ground, FileManagement, District, Zone) {
        var vm = this;

        vm.above_ground = entity;
        vm.save = save;
        vm.extent= extent;
        vm.upload= upload;
        vm.onsubmit = onsubmit;
        $scope.file = {};
        var savefilename=null;

        loadAll();
        UIkit.modal("#modal-above2").show();

        function loadAll() {
            District.query(function(result) {
                vm.districts = result;
                vm.searchQuery = null;
            });
            Zone.query(function(result) {
                vm.zones = result;
                vm.searchQuery = null;
            });
        }

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function extent() {
         vm.show= !vm.show;
        }

        function save () {
            vm.isSaving = true;
            vm.show1= true;
            if (vm.above_ground.id !== null) {
                Above_ground.update(vm.above_ground, onSaveSuccess, onSaveError);
            } else {
                if($stateParams=='new'){
                  vm.above_ground.isexisting = false;
                }
                vm.above_ground.isfullyfilled = false;
                vm.above_ground.status = 'Pending';
                Above_ground.save(vm.above_ground, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            vm.result=result;
            $scope.$emit('investhryApp:above_groundUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function  upload(i,object) {
            var fileNameArray = object.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var filename = vm.result.id+'_'+ i;
            savefilename=filename+ "." + fileextension;
            var file =object;
            FileManagement.saveFile(file,filename,onFileUploadedSuccess,onFileUploadedError);
            vm.vari=i;
        }

        function onsubmit() {
            $state.go("aboveGround");
        }


        function onFileUploadedSuccess() {
            UIkit.notification("File Uploaded Successfully . . .",{timeout: 2000});
            if (vm.vari==1){
                vm.show_upload1=true;
                vm.result.document1= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==2){
                vm.show_upload2=true;
                vm.result.document2= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==3){
                vm.show_upload3=true;
                vm.result.document3= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==4){
                vm.show_upload4=true;
                vm.result.document4= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==5){
                vm.show_upload5=true;
                vm.result.document5= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==6){
                vm.show_upload6=true;
                vm.result.document6= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==7){
                vm.show_upload7=true;
                vm.result.document7= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==8){
                vm.show_upload8=true;
                vm.result.document8= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==9){
                vm.show_upload9=true;
                vm.result.document9= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==10){
                vm.show_upload10=true;
                vm.result.document10= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==11){
                vm.show_upload11=true;
                vm.result.document11= savefilename;
                vm.result.isfullyfilled = true;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==12){
                vm.show_upload12=true;
                vm.result.other_document1= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==13){
                vm.show_upload13=true;
                vm.result.other_document2= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==14){
                vm.show_upload14=true;
                vm.result.other_document3= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==15){
                vm.show_upload15=true;
                vm.result.other_document4= savefilename;
                Above_ground.update(vm.result);
            }
            else if(vm.vari==16) {
                vm.show_upload16=true;
                vm.result.other_document5= savefilename;
                Above_ground.update(vm.result);
            }
        }

        function onFileUploadedError() {
            UIkit.notification("Unexpected Error Occurred! Try Again . .",{timeout: 2000,status: 'danger'});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AboveGroundDetailController', AboveGroundDetailController);

    AboveGroundDetailController.$inject = ['$scope', '$state', '$stateParams', 'entity', 'Above_ground', 'District', 'Zone','FileManagement'];

    function AboveGroundDetailController($scope, $state, $stateParams, entity, Above_ground, District, Zone,FileManagement) {
        var vm = this;
        vm.save= save;

        vm.above_ground = entity;
        console.log(entity);
        vm.edit_form= edit_form;
        vm.download=download;
        vm.upload=upload;
        var savefilename=null;

        $scope.file={};
        $scope.isDisabled =true;

        loadAll();

        function loadAll() {
            District.query(function(result) {
                vm.districts = result;
                vm.searchQuery = null;
            });
            Zone.query(function(result) {
                vm.zones = result;
                vm.searchQuery = null;
            });
        }

        function save () {
            vm.isSaving = true;
            vm.show1= true;
            if (vm.above_ground.id !== null) {
                vm.above_ground.status = 'Pending';
                Above_ground.update(vm.above_ground, onSaveSuccess, onSaveError);
            } else {
                vm.above_ground.isfullyfilled = false;
                Above_ground.save(vm.above_ground, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $state.go("aboveGround");
            //$scope.$emit('investhryApp:above_groundUpdate', result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }

        function edit_form() {
            vm.show= true;
            $scope.isDisabled =false;
        }

        function download(serverfilename,clientfilename) {
            downloadserviceformattachment.download(serverfilename,clientfilename);
        }

        function  upload(i,object) {
            var fileNameArray = object.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var filename = vm.above_ground.id+'_'+ i;
            savefilename=filename+ "." + fileextension;
            var file = object;
            FileManagement.saveFile(file,filename,onFileUploadedSuccess,onFileUploadedError);
            vm.tempvar=i;
        }


        function onFileUploadedSuccess() {
            UIkit.notification("File Uploaded Successfully . . .",{timeout: 2000});
         if(vm.tempvar==1){
                vm.show_upload1=true;
                vm.above_ground.document1= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==2){
                vm.show_upload2=true;
                vm.above_ground.document2= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==3){
                vm.show_upload3=true;
                vm.above_ground.document3= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==4){
                vm.show_upload4=true;
                vm.above_ground.document4= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==5){
                vm.show_upload5=true;
                vm.above_ground.document5= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==6){
                vm.show_upload6=true;
                vm.above_ground.document6= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==7){
                vm.show_upload7=true;
                vm.above_ground.document7= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==8){
                vm.show_upload8=true;
                vm.above_ground.document8= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==9){
                vm.show_upload9=true;
                vm.above_ground.document9= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==10){
                vm.show_upload10=true;
                vm.above_ground.document10= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==11){
                vm.show_upload11=true;
                vm.above_ground.document11= savefilename;
                vm.above_ground.isfullyfilled = true;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==12){
                vm.show_upload12=true;
                vm.above_ground.other_document1= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==13){
                vm.show_upload13=true;
                vm.above_ground.other_document2= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==14){
                vm.show_upload14=true;
                vm.above_ground.other_document3= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==15){
                vm.show_upload15=true;
                vm.above_ground.other_document4= savefilename;
                Above_ground.update(vm.above_ground);
            }
            else if(vm.tempvar==16) {
                vm.show_upload16=true;
                vm.above_ground.other_document5= savefilename;
                Above_ground.update(vm.above_ground);
            }

        }

        function onFileUploadedError() {
            UIkit.notification("Unexpected Error Occurred! Try Again . .",{timeout: 2000,status: 'danger'});
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
         .state('aboveGround', {
            parent: 'app',
                url: '/towerInstallation/aboveGround',
            data: {
                authorities: ['ROLE_TOWER_USER'],
                pageTitle: 'global.menu.aboveGround'
            },
            views: {
                'content@': {
                    templateUrl: 'app/aboveGround/aboveGround.html',
                    controller: 'AboveGroundController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aboveGround');
                    return $translate.refresh();
                }]
            }
        })
         .state('aboveGround-dialog', {
                parent: 'aboveGround',
                url: '/{isNew}',
                data: {
                    authorities: ['ROLE_TOWER_USER']
                },
                views: {
                 'content@': {
                     templateUrl: 'app/aboveGround/aboveGround-dialog.html',
                     controller: 'AboveGroundDialogController',
                     controllerAs: 'vm'
                 }
                },
                resolve: {
                    entity: function () {
                        return {
                            name_applicant: null,
                            registered_address: null,
                            har_office_address: null,
                            designation_auth_person: null,
                            phone_auth_person: null,
                            email_auth_person: null,
                            extent: null,
                            address_line_1: null,
                            address_line_2: null,
                            address_line_3: null,
                            address_line_4: null,
                            tehsil: null,
                            district: null,
                            latitude_longitude: null,
                            name_auth_person: null,
                            zone_area: null,
                            owner_name: null,
                            owner_address: null,
                            tower_height: null,
                            tower_weight: null,
                            tower_type1: null,
                            tower_type2: null,
                            tower_type3: null,
                            tower_antena_no: null,
                            tower_lat_long: null,
                            other_info1: null,
                            other_info2: null,
                            other_info3: null,
                            other_info4: null,
                            other_info5: null,
                            other_info6: null,
                            fee_details: null,
                            document1: null,
                            document2: null,
                            document3: null,
                            document4: null,
                            document5: null,
                            document6: null,
                            document7: null,
                            document8: null,
                            document9: null,
                            document10: null,
                            document11: null,
                            other_document1: null,
                            other_document2: null,
                            other_document3: null,
                            other_document4: null,
                            other_document5: null,
                            isfullyfilled: false,
                            status: null,
                            isforwardedtodio: false,
                            isforwardedtodept: false,
                            isforwardedtodc: false,

                            clearancefile1: null,
                            clearancefile2: null,
                            clearancefile3: null,

                            created_by: null,
                            created_on: null,
                            isforwarded: null,
                            isexisting: false,

                            id: null
                        };
                    }
             }
            })
         .state('aboveGround-detail', {
                parent: 'aboveGround',
                url: '/{id}',
                data: {
                    authorities: ['ROLE_TOWER_USER']
                    //pageTitle: 'investhryApp.aboveGround.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/aboveGround/aboveGround-detail.html',
                        controller: 'AboveGroundDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('above_ground');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Above_ground', function($stateParams, Above_ground) {
                        return Above_ground.get({id : $stateParams.id}).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'above-ground',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            });
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('AboveGroundService', AboveGroundService);

    AboveGroundService.$inject = ['$resource', 'DateUtils'];

    function AboveGroundService ($resource, DateUtils) {
        var resourceUrl =  'api/above-grounds-by-user';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created_on = DateUtils.convertLocalDateFromServer(data.created_on);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.created_on = DateUtils.convertLocalDateToServer(copy.created_on);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.created_on = DateUtils.convertLocalDateToServer(copy.created_on);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();


(function () {
    'use strict';

    angular
        .module('investhryApp')
        .controller('AboveGroundController', AboveGroundController);

    AboveGroundController.$inject = ['$scope', 'Principal', 'AboveGroundService', 'Above_ground','Tower_log', 'downloadserviceformattachment'];

    function AboveGroundController($scope, Principal , AboveGroundService, Above_ground,Tower_log,downloadserviceformattachment) {
        var vm = this;
        vm.view_log=view_log;
        vm.comment= comment;
        vm.save= save;
        vm.download=download;
        vm.dowload_dialog=dowload_dialog;

        loadAll();
        // Principal.identity().then(function(account){
        //     vm.username=account.login;
        //
        // });

        function loadAll() {
            AboveGroundService.query(function(result) {
                vm.above_grounds = result;
                vm.searchQuery = null;
            });

        }
        function view_log(id) {
            Tower_log.query({towerId: id},function (result){
                vm.towerLog=result;
            });
        }
        function comment(result) {
          vm.applicant_id= result.id;
          vm.name_applicant= result.name_applicant;
        }
        function save() {
            vm.tower_log.tower_id= vm.applicant_id;
            vm.tower_log.action= "comment";
            Tower_log.save(vm.tower_log, onSaveSuccess);
        }
        function onSaveSuccess() {
            UIkit.modal('#modal_above3').hide();
            vm.tower_log.comment =null;
        }

        function dowload_dialog(file1,file2,file3) {
            vm.clearancefile1=file1;
            vm.clearancefile2=file2;
            vm.clearancefile3=file3;
        }

        function download(file_id,clientfilename) {
            if(file_id===1){
                downloadserviceformattachment.download(vm.clearancefile1,clientfilename);
            }
            else if(file_id===2){
                downloadserviceformattachment.download(vm.clearancefile2,clientfilename);
            }
            else if(file_id===3){
                downloadserviceformattachment.download(vm.clearancefile3,clientfilename);
            }

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('investhryApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.
        state('aai-fillform', {
                              parent: 'serviceclearanceaction',
                              url: '/aai-fillform/{projectserviceid}',
                              data: {
                                  authorities: ['ROLE_ADMIN','ROLE_SUB_ADMIN','ROLE_USER','ROLE_RM']
                              },
                              onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                                  $uibModal.open({
                                      templateUrl: 'app/aai/aai-fillform.html',
                                      controller: 'AAIFillFormController',
                                      controllerAs: 'vm',
                                      backdrop: 'static',
                                      size: 'lg',
                                      resolve: {
                                          projectServiceFormFieldData: function () {
                                              return {
                                                  serviceid: null,
                                                  formfieldvalue: null,
                                                  projectid: null,
                                                  formfieldName: null,
                                                  id: null
                                              };
                                          },
                                          projectAttachemnt: function () {
                                                return {
                                                    fileName: null,
                                                    description: null,
                                                    fileExtension: null,
                                                    serverFileName: null,
                                                    id: null
                                                };
                                            },
                                            projectServiceLog: function () {
                                                return {
                                                    projectid: null,
                                                    serviceid: null,
                                                    comments: null,
                                                    commentDate: null,
                                                    commentByUserLogin: null,
                                                    actionTaken: null,
                                                    id: null
                                                };
                                            },
                                            projectService: ['Projectservicedetail', function(Projectservicedetail) {
                                              return Projectservicedetail.get({id : $stateParams.projectserviceid}).$promise;
                                            }],
                                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                                              $translatePartialLoader.addPart('home');
                                              return $translate.refresh();
                                            }]
                                      }
                                  }).result.then(function() {
                                      $state.go('serviceclearanceaction', null, { reload: 'serviceclearanceaction' });
                                  }, function() {
                                      $state.go('serviceclearanceaction');
                                  });
                              }]
                          })
    }
})();

(function() {
    'use strict';
    angular
        .module('investhryApp')
        .factory('Aai', Aai);

    Aai.$inject = ['$http'];

    function Aai ($http) {
        var AAIObject={};
        return {
            createAAIObject:function (formfielddata,uniqueId) {
                AAIObject.uniqueId = uniqueId;
                for (var i = 0; i < formfielddata.length; i++){
                    switch (formfielddata[i].formfieldName){
                        case'Height Clearance For':
                            AAIObject.heightClearanceFor=formfielddata[i].formfieldvalue;
                            break;
                        case'Name of Applicant*':
                            AAIObject.nameOfApplicant=formfielddata[i].formfieldvalue;
                            break;
                        case'Address of Applicant*':
                            AAIObject.addressOfApplicant=formfielddata[i].formfieldvalue;
                            break;
                        case'Mobile No*':
                            AAIObject.mobileNumber=formfielddata[i].formfieldvalue;
                            break;
                        case'Email Id*':
                            AAIObject.emailId=formfielddata[i].formfieldvalue;
                            break;
                        case'Name of Owner/Owners*':
                            AAIObject.nameOfOwner=formfielddata[i].formfieldvalue;
                            break;
                        case'Address of Communication*':
                            AAIObject.addressOfCommunication=formfielddata[i].formfieldvalue;
                            break;
                        case'Type of Structure *':
                            AAIObject.typeOfStructure=formfielddata[i].formfieldvalue;
                            break;
                        case'Uses/Purpose of Structure*':
                            AAIObject.useOfStructure=formfielddata[i].formfieldvalue;
                            break;
                        case'Site Description–Site Name & No, Plot No. (Max 500 Characters)*':
                            AAIObject.siteDescription=formfielddata[i].formfieldvalue;
                            break;
                        case'Size Of Plot(sq.mtrs)*':
                            AAIObject.sizeOfPlot=formfielddata[i].formfieldvalue;
                            break;
                        case'State*':
                            AAIObject.state=formfielddata[i].formfieldvalue;
                            break;
                        case'City*':
                            AAIObject.city=formfielddata[i].formfieldvalue;
                            break;
                        case'Area name – Taluk / Village / Town Name *':
                            AAIObject.areaName=formfielddata[i].formfieldvalue;
                            break;
                        case'Latitude 1*':
                            AAIObject.latitude1 = formfielddata[i].formfieldvalue;
                            break;
                        case'Latitude 2':
                            AAIObject.latitude2 = formfielddata[i].formfieldvalue;
                            break;
                        case'Latitude 3':
                            AAIObject.latitude3 = formfielddata[i].formfieldvalue;
                            break;
                        case'Latitude 4':
                            AAIObject.latitude4 = formfielddata[i].formfieldvalue;
                            break;
                        case'Longitude 1*':
                            AAIObject.longitude1 = formfielddata[i].formfieldvalue;
                            break;
                        case'Longitude 2':
                            AAIObject.longitude2 = formfielddata[i].formfieldvalue;
                            break;
                        case'Longitude 3':
                            AAIObject.longitude3 = formfielddata[i].formfieldvalue;
                            break;
                        case'Longitude 4':
                            AAIObject.longitude4 = formfielddata[i].formfieldvalue;
                            break;
                        case'SiteElevation (AMSL)(mtr)':
                            AAIObject.siteElevation=formfielddata[i].formfieldvalue;
                            break;
                        case'Building Height (AGL)(mtr)':
                            AAIObject.buildingHeight=formfielddata[i].formfieldvalue;
                            break;
                        case'Max Site Elevation (AMSL)(mtr)':
                            AAIObject.maxSiteElevation=formfielddata[i].formfieldvalue;
                            break;
                        case'Do the above Coordinates plotted on the map correlate to your site/plot ?':
                            AAIObject.isCorrelated = formfielddata[i].formfieldvalue;
                            break;
                        case'Does the site lies within the airport premises/Within the land belonging to Airport Operator':
                            AAIObject.isWithinPremesis=formfielddata[i].formfieldvalue;
                            break;
                        case'Have you obtained permission from Airport Authority':
                            AAIObject.hasPermission=formfielddata[i].formfieldvalue;
                            break;
                        }
                    };
                console.log(AAIObject);
                $http.post('/api/aai',AAIObject).then(function () {
                    console.log('success');
                    return AAIObject;
                });
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('investhryApp')
        .controller('AAIFillFormController', AAIFillFormController);

   AAIFillFormController.$inject = ['$http', '$timeout','$scope','$stateParams','$uibModalInstance','projectService','projectServiceFormFieldData','projectAttachemnt','projectServiceLog','ProjectAttachemnt','ProjectServiceLogUpdated','FileManagement','Projectservicedetail','Projectserviceformfielddata','serviceFormFieldDataCollection','ServiceFormAttachments','DepartmentService','Serviceformdocs','downloadserviceformattachment'];
   function AAIFillFormController ($http, $timeout, $scope, $stateParams, $uibModalInstance,projectService,projectServiceFormFieldData, projectAttachemnt, projectServiceLog, ProjectAttachemnt, ProjectServiceLogUpdated, FileManagement, Projectservicedetail, Projectserviceformfielddata,serviceFormFieldDataCollection,ServiceFormAttachments,DepartmentService,Serviceformdocs,downloadserviceformattachment) {
        var vm = this;
        var AAIObject = {};
        vm.projectServiceLog = projectServiceLog;
        vm.projectAttachemnt = projectAttachemnt;
        vm.projectServiceFormFieldData=projectServiceFormFieldData;
        vm.projectService = projectService;
        vm.uploadAAIFiles = uploadAAIFiles;
        var eventname;
        var projectAttachmentResultObject=null;
        var projectServiceLogid=null;
        var formfielddataObjectArrayLength = 0;
        var formfieldCount = 0;
        var saveLogFlag = false;
        vm.clear = clear;
        vm.serviceformattachment = {};
        vm.saveFormFieldData = saveFormFieldData;
        vm.downloadFile=downloadFile;

        vm.aaiObject = {};

        $scope.file = {};
        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });
        function clear()
        {
             $uibModalInstance.dismiss('cancel');
        }

        vm.departmentservice= DepartmentService.get({id:vm.projectService.serviceid});
        Serviceformdocs.query({id:"1",serviceid:vm.projectService.serviceid},function(result) {
            vm.serviceformdocs = result;
            vm.searchQuery = null;
        });
        loadServiceFormFields();
        function loadServiceFormFields() {
            vm.serviceFormFieldData = serviceFormFieldDataCollection.query({serviceid:vm.projectService.serviceid, projectid:vm.projectService.projectid});
        }
        var combineFilledForm="";
        function saveFormFieldData()
        {
            var vmlength = vm.serviceFormFieldData.length;
            for(var i= 0; i<vmlength;i++) {
                var order = vm.serviceFormFieldData[i].formfieldOrder;
                if ( order == '20' || order == '21' || order == '22' || order == '23' || order == '24' || order == '25' || order == '26' || order == '27'){
                    $scope.strArray = vm.serviceFormFieldData[i].formfieldvalue.split(" ");
                    console.log($scope.strArray);
                    $scope.strArray = $scope.strArray.filter(function(e) {
                        return String(e).trim();
                    });
                    if($scope.strArray.length === 3){
                        for(var j = 0; j < $scope.strArray.length; j++){
                            if (!$scope.strArray[j].trim().match(/^[.0-9]+$/)){
                                alert("wrong coordinates format");
                                vm.isSaving = false;
                                return;
                            }
                        }
                    }else {
                        alert("fill coordinates correctly!!");
                        vm.isSaving = false;
                        return;
                    }
                }else if( order == '15' && !vm.serviceFormFieldData[i].formfieldvalue.match(/^[.0-9]+$/) ){
                    alert("Size of plot must be a number.");
                    vm.isSaving = false;
                    return;
                }else if( order == '28' && !vm.serviceFormFieldData[i].formfieldvalue.match(/^[.0-9]+$/) ){
                    alert("Site elevation must be a number.");
                    vm.isSaving = false;
                    return;
                }else if( order == '29' && !vm.serviceFormFieldData[i].formfieldvalue.match(/^[.0-9]+$/) ){
                    alert("Building height must be a number.");
                    vm.isSaving = false;
                    return;
                }
            }
            if( vm.undertaking1aUploaded != null && vm.elevationUploaded != null && vm.coordinatesUploaded != null && vm.authorizationUploaded != null && vm.permissionUploaded != null ){
                var isConfirmed = confirm("Alert!!! This is final submission. You can not edit the details further.");
                if (isConfirmed){
                    vm.isSaving = true;
                    // var vmlength = vm.serviceFormFieldData.length;
                    formfielddataObjectArrayLength = vmlength;
                    for(var i= 0; i<vmlength;i++)
                    {
                        var data = vm.serviceFormFieldData[i];
                        combineFilledForm=combineFilledForm + vm.serviceFormFieldData[i].formfieldvalue+" | ";
                        data.projectid = vm.projectService.projectid;
                        if (data.id !== null)
                        {
                            Projectserviceformfielddata.update(data, onSaveServiceFormFieldDataSuccess, onSaveServiceFormFieldDataError);
                        } else
                        {
                            Projectserviceformfielddata.save(data, onSaveServiceFormFieldDataSuccess, onSaveServiceFormFieldDataError);
                        }
                        formfieldCount = i;
                    }
                    for( var j = 0; j < vm.fileattach.length; j++ ) {
                        if(vm.fileattach[j].isSaved===false)
                        {
                            vm.fileattach[j].isSaved=true;
                        }
                        ServiceFormAttachments.update(vm.fileattach[j],onUpdatefieldServiceFormAttachmentsSuccess);
                    }
                    if((vm.projectService.serviceid == '16b4d378-5723-4adc-85e9-de55da296008') || ( vm.projectService.serviceid == '48726760-540c-4890-b649-e89dc5ff314e' )){
                        vm.createAAIObject(vm.serviceFormFieldData,vm.projectService.id);
                    }
                }else {
                    vm.isSaving = false;
                    return;
                }
            }else{
                alert("Please upload all files!!");
                vm.isSaving = false;
                return;
            }
        }

        function onUpdatefieldServiceFormAttachmentsSuccess()
        {}
        vm.fileattach = ServiceFormAttachments.query({id:"1", projectid:vm.projectService.projectid, serviceid:vm.projectService.serviceid});
        vm.addfileattachment=addfileattachment;

        function addfileattachment(documenttype)
        {
            eventname = documenttype;
            var fileNameArray = vm.serviceformfile.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=vm.serviceformattachment.description;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            vm.serviceformattachment.isSaved=false;
            vm.serviceformattachment.downloadfilename=inputFileName;
            vm.serviceformattachment.clientfilename=vm.serviceformfile.name;
            vm.serviceformattachment.projectID=vm.projectService.projectid;
            vm.serviceformattachment.serviceID=vm.projectService.serviceid;
            ServiceFormAttachments.save(vm.serviceformattachment,onSaveServiceFormAttachmentsSuccess);

        }



        function onSaveServiceFormAttachmentsSuccess (result)
        {

            var filename = result.id;
            var file =vm.serviceformfile;
            FileManagement.saveFile(file,filename);
            var fileNameArray = vm.serviceformfile.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            result.serverfilename=inputFileName;
            eventname(result);
            ServiceFormAttachments.update(result,onUpdateServiceFormAttachmentsSuccess);
        }
        function onUpdateServiceFormAttachmentsSuccess(result)
        {

            vm.fileattach.push(result);
            vm.fileattachment={};
            vm.serviceformattachment.description="";
            $('#browsefile').val('');

        }

        vm.removeRow = function(id,documenttype){
            vm.removeRawRow(id,function(){
                switch(documenttype){
                    case 'undertaking1auploaded':
                        vm.undertaking1aUploaded = null;
                        break;
                    case 'elevationuploaded':
                        vm.elevationUploaded = null;
                        break;
                    case 'coordinatesuploaded':
                        vm.coordinatesUploaded = null;
                        break;
                    case 'authorizationuploaded':
                        vm.authorizationUploaded = null;
                        break;
                    case 'permissionuploaded':
                        vm.permissionUploaded = null;
                        break;
                }
            });
        }

        vm.removeRawRow = function(id,callBack)
        {
             ServiceFormAttachments.delete({id: id});
             var index = -1;
             var comArray =eval(vm.fileattach);
             for( var i = 0; i < comArray.length; i++ )
             {
                 if( comArray[i].id=== id)
                 {
                     index = i;
                     break;
                 }
             }
             vm.fileattach.splice( index, 1 );
             callBack();
        }
        function onSaveServiceFormFieldDataSuccess(result)
        {
            if(!saveLogFlag)
            {
                if(formfieldCount === (formfielddataObjectArrayLength-1))
                {
                    saveProjectServiceLog();
                    saveLogFlag = true;
                }
            }
        }
        function onSaveServiceFormFieldDataError()
        {}
        function saveProjectServiceLog(result){
            $scope.$emit('investhryApp:projectserviceformfielddataUpdate', result);
            vm.projectServiceLog.projectid=vm.projectService.projectid;
            vm.projectServiceLog.serviceid=vm.projectService.serviceid;
            vm.projectServiceLog.comments=vm.projectServiceLog.comments + " | " +combineFilledForm;
            vm.projectServiceLog.actionTaken="ServiceFormEdited";
            ProjectServiceLogUpdated.save(vm.projectServiceLog,onServiceLogSaveSuccess,onServiceLogSaveError);
        }
        function onServiceLogSaveSuccess(result)
        {
            $scope.$emit('investhryApp:projectServiceLogUpdate', result);
            projectServiceLogid=result.id;
            vm.projectService.latestComments="Service form edited";
            vm.projectService.formFilledStatus=true;
            Projectservicedetail.update(vm.projectService,onUpdateProjectServiceSuccess,onUpdateProjectServiceError);
        }
        function onUpdateProjectServiceSuccess(result)
        {
            $scope.$emit('investhryApp:projectservicedetailUpdate', result);
            if(angular.isDefined(vm.projectAttachemnt.file)){
                saveProjectAttachment();
            }
            else
            {
                $uibModalInstance.close(result);
                vm.isSaving = false;
            }
        }
        function onUpdateProjectServiceError()
        {
            vm.isSaving = false;
        }
        function onServiceLogSaveError()
        {
            vm.isSaving = false;
        }
        function saveProjectAttachment()
        {
            var file=vm.projectAttachemnt.file;
            vm.projectAttachemnt.id=projectServiceLogid;
            vm.projectAttachemnt.fileName=file.name;
            vm.projectAttachemnt.description="Service Form Field Data Attachment";
            vm.projectAttachemnt.fileExtension =file.type;
            ProjectAttachemnt.update(vm.projectAttachemnt,onSaveProjectAttachmentSuccess,onSaveProjectAttachmentError);
        }
        function onSaveProjectAttachmentSuccess(result)
        {
            $scope.$emit('investhryApp:projectAttachemntUpdate', result);
            var filename = result.id;
            var file =vm.projectAttachemnt.file;
            FileManagement.saveFile(file,filename);
            projectAttachmentResultObject=result;

            var fileNameArray = vm.projectAttachemnt.file.name.split(".");
            var fileextension="";
            if((fileNameArray.length>1))
            {
                fileextension=fileNameArray[(fileNameArray.length-1)];
            }
            var inputFileName=result.id;
            if(fileextension!=="")
            {
                inputFileName=inputFileName+"."+fileextension;
            }
            projectAttachmentResultObject.serverFileName=inputFileName;

            ProjectAttachemnt.update(projectAttachmentResultObject,onUpdateProjectAttachmentSuccess,onUpdateProjectAttachmentError);
        }
        function onSaveProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function onUpdateProjectAttachmentSuccess(result)
        {

            $uibModalInstance.close(result);
        }

        function onUpdateProjectAttachmentError()
        {
            vm.isSaving = false;
        }

        function downloadFile(serverfilename,downloadfilename)
        {
            downloadserviceformattachment.download(serverfilename,downloadfilename)
            .then(function(success) {
                console.log('success : ' + success);
            }, function(error) {
                console.log('error : ' + error);
            });
        }

        function uploadAAIFiles(documenttype){
            switch (documenttype) {

                            case 'undertaking1a':
                                vm.serviceformfile = vm.undertaking1a;
                                vm.serviceformattachment.description = documenttype;
                                addfileattachment(function (result) {
                                    vm.undertaking1aUploaded = result;
                                });
                                vm.undertaking1a = null;
                                $('#undertaking1a').val('');
                                break;

                            case 'elevation':
                                vm.serviceformfile = vm.elevation;
                                vm.serviceformattachment.description = documenttype;
                                addfileattachment(function (result) {
                                    vm.elevationUploaded = result;
                                });
                                vm.elevation = null;
                                $('#elevation').val('');
                                break;

                            case 'coordinates':
                                vm.serviceformattachment.description = documenttype;
                                vm.serviceformfile = vm.coordinates;
                                addfileattachment(function (result) {
                                        vm.coordinatesUploaded = result;
                                    });
                                vm.coordinates = null;
                                $('#coordinates').val('');
                                break;


                            case 'authorization':
                                vm.serviceformfile = vm.authorization;
                                vm.serviceformattachment.description = documenttype;
                                addfileattachment(function (result) {
                                        vm.authorizationUploaded = result
                                    });
                                vm.authorization = null;
                                $('#authorization').val('');
                                break;

                            case 'permission':
                                vm.serviceformfile = vm.permission;
                                vm.serviceformattachment.description = documenttype;
                                addfileattachment(function (result) {
                                        vm.permissionUploaded = result
                                    });
                                vm.permission = null;
                                $('#permission').val('');
                                break;
                        }
        }

        vm.createAAIObject = function (formfielddata,uniqueId) {
            AAIObject.uniqueId = uniqueId;
            for (var i = 0; i < formfielddata.length; i++){
                switch (formfielddata[i].formfieldName){
                    case'Height Clearance For':
                        AAIObject.heightClearanceFor=formfielddata[i].formfieldvalue;
                        break;
                    case'Name of Applicant*':
                        AAIObject.nameOfApplicant=formfielddata[i].formfieldvalue;
                        break;
                    case'Address of Applicant*':
                        AAIObject.addressOfApplicant=formfielddata[i].formfieldvalue;
                        break;
                    case'Mobile No*':
                        AAIObject.mobileNumber=formfielddata[i].formfieldvalue;
                        break;
                    case'Email Id*':
                        AAIObject.emailId=formfielddata[i].formfieldvalue;
                        break;
                    case'Name of Owner/Owners*':
                        AAIObject.nameOfOwner=formfielddata[i].formfieldvalue;
                        break;
                    case'Address of Communication*':
                        AAIObject.addressOfCommunication=formfielddata[i].formfieldvalue;
                        break;
                    case'Type of Structure*':
                        AAIObject.typeOfStructure=formfielddata[i].formfieldvalue;
                        break;
                    case'Uses/Purpose of Structure*':
                        AAIObject.useOfStructure=formfielddata[i].formfieldvalue;
                        break;
                    case'Site Address–Site Name & No, Plot No. (Max 500 Characters)*':
                        AAIObject.siteDescription=formfielddata[i].formfieldvalue;
                        break;
                    case'Size Of Plot(sq.mtrs)*':
                        AAIObject.sizeOfPlot=formfielddata[i].formfieldvalue;
                        break;
                    case'State*':
                        AAIObject.state=formfielddata[i].formfieldvalue;
                        break;
                    case'City*':
                        AAIObject.city=formfielddata[i].formfieldvalue;
                        break;
                    case'Area name – Taluk / Village / Town Name*':
                        AAIObject.areaName=formfielddata[i].formfieldvalue;
                        break;
                    case'Latitude 1*':
                        AAIObject.latitude1 = formfielddata[i].formfieldvalue;
                        break;
                    case'Latitude 2*':
                        AAIObject.latitude2 = formfielddata[i].formfieldvalue;
                        break;
                    case'Latitude 3*':
                        AAIObject.latitude3 = formfielddata[i].formfieldvalue;
                        break;
                    case'Latitude 4*':
                        AAIObject.latitude4 = formfielddata[i].formfieldvalue;
                        break;
                    case'Longitude 1*':
                        AAIObject.longitude1 = formfielddata[i].formfieldvalue;
                        break;
                    case'Longitude 2*':
                        AAIObject.longitude2 = formfielddata[i].formfieldvalue;
                        break;
                    case'Longitude 3*':
                        AAIObject.longitude3 = formfielddata[i].formfieldvalue;
                        break;
                    case'Longitude 4*':
                        AAIObject.longitude4 = formfielddata[i].formfieldvalue;
                        break;
                    case'SiteElevation (AMSL)(mtr)*':
                        AAIObject.siteElevation=formfielddata[i].formfieldvalue;
                        break;
                    case'Building Height (AGL)(mtr)*':
                        AAIObject.buildingHeight=formfielddata[i].formfieldvalue;
                        break;
                    case'Max Site Elevation (AMSL)(mtr)*':
                        AAIObject.maxSiteElevation=formfielddata[i].formfieldvalue;
                        break;
                    case'Do the above Coordinates plotted on the map correlate to your site/plot ?*':
                        AAIObject.isCorrelated = formfielddata[i].formfieldvalue;
                        break;
                    case'Does the site lies within the airport premises/Within the land belonging to Airport Operator*':
                        AAIObject.isWithinPremesis=formfielddata[i].formfieldvalue;
                        break;
                    case'Have you obtained permission from Airport Authority*':
                        AAIObject.hasPermission=formfielddata[i].formfieldvalue;
                        break;
                    }
                };
                if(vm.undertaking1aUploaded != undefined){
                    AAIObject.undertaking1aUrl = vm.undertaking1aUploaded.serverfilename;
                }
                if(vm.elevationUploaded != undefined){
                    AAIObject.elevationUrl = vm.elevationUploaded.serverfilename;
                }
                if(vm.coordinatesUploaded != undefined){
                    AAIObject.coordinatesUrl = vm.coordinatesUploaded.serverfilename;
                }
                if(vm.authorizationUploaded != undefined){
                    AAIObject.authorizationUrl = vm.authorizationUploaded.serverfilename;
                }
                if(vm.permissionUploaded != undefined){
                    AAIObject.permissionUrl = vm.permissionUploaded.serverfilename;
                }

                console.log(AAIObject);
                $http.post('/api/aai',AAIObject).then(function () {
                    console.log('success');
                    return AAIObject;
                });
            }
    }
})();
(function(){angular.module('investhryApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/dirPagination.tpl.html','<ul class="pagination" ng-if="1 < pages.length || !autoHide"><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(1)">&laquo;</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == 1 }"><a href="" ng-click="setCurrent(pagination.current - 1)">&lsaquo;</a></li><li ng-repeat="pageNumber in pages track by tracker(pageNumber, $index)" ng-class="{ active : pagination.current == pageNumber, disabled : pageNumber == \'...\' }"><a href="" ng-click="setCurrent(pageNumber)">{{ pageNumber }}</a></li><li ng-if="directionLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.current + 1)">&rsaquo;</a></li><li ng-if="boundaryLinks" ng-class="{ disabled : pagination.current == pagination.last }"><a href="" ng-click="setCurrent(pagination.last)">&raquo;</a></li></ul>');
$templateCache.put('app/CafwithNoService/CAFwithNoService.html','<div ng-cloak><div class="container"><div class="row"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>No</th><th>CAF Pin (Composite Application Form)</th><th>Investor Name</th><th>Business Entity</th><th>E-mail</th><th>Project Level</th><th>Caf Type</th><th>Created Date</th><th></th></tr></thead><tbody><tr ng-repeat="project in vm.cafWithNoServices | orderBy: \'-createddate\'"><td>{{$index+1}}</td><td>{{project.cafpin}}</td><td>{{project.investorName}}</td><td>{{project.businessentity}}</td><td>{{project.emailprimary}}</td><td>{{project.projectlevel==\'e\' ? "EEC" : "DLCC"}}</td><td>{{project.caftype}}</td><td>{{project.createddate | date:\'yyyy-MM-dd\'}}</td><td class="action verticalalign"><button type="button" class="btn btn-primary" ui-sref="projectdetailjist({projectid:project.id})">Details</button></td></tr></tbody></table></div><div ng-if="!vm.showtable">No Projects Right Now.</div></div></div><br><br>');
$templateCache.put('app/ConstructionPermit/aai-detailPage.html','<div class="col-md-8 col-md-offset-2"><h2><span></span>Airport Authority of India</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.aai.height_clearance">Height Clearance</span></dt><dd><span>{{vm.aai.height_clearance}}</span></dd><dt><span data-translate="investhryApp.aai.nameOfAplicant">Name Of Aplicant</span></dt><dd><span>{{vm.aai.nameOfAplicant}}</span></dd><dt><span data-translate="investhryApp.aai.addressOfApplicant">Address Of Applicant</span></dt><dd><span>{{vm.aai.addressOfApplicant}}</span></dd><dt><span data-translate="investhryApp.aai.mobile_no">Mobile No</span></dt><dd><span>{{vm.aai.mobile_no}}</span></dd><dt><span data-translate="investhryApp.aai.email_id">Email Id</span></dt><dd><span>{{vm.aai.email_id}}</span></dd><dt><span data-translate="investhryApp.aai.nameOfOwner">Name Of Owner</span></dt><dd><span>{{vm.aai.nameOfOwner}}</span></dd><dt><span data-translate="investhryApp.aai.addressOfCommunication">Address Of Communication</span></dt><dd><span>{{vm.aai.addressOfCommunication}}</span></dd><dt><span data-translate="investhryApp.aai.typeOfStructure">Type Of Structure</span></dt><dd><span>{{vm.aai.typeOfStructure}}</span></dd><dt><span data-translate="investhryApp.aai.usesOfStructure">Uses Of Structure</span></dt><dd><span>{{vm.aai.usesOfStructure}}</span></dd><dt><span data-translate="investhryApp.aai.siteDescription">Site Description</span></dt><dd><span>{{vm.aai.siteDescription}}</span></dd><dt><span data-translate="investhryApp.aai.sizeOfPlot">Size Of Plot</span></dt><dd><span>{{vm.aai.sizeOfPlot}}</span></dd><dt><span data-translate="investhryApp.aai.state">State</span></dt><dd><span>{{vm.aai.state}}</span></dd><dt><span data-translate="investhryApp.aai.areaName">Area Name</span></dt><dd><span>{{vm.aai.areaName}}</span></dd><dt><span data-translate="investhryApp.aai.latitude1">Latitude 1</span></dt><dd><span>{{vm.aai.latitude1}}</span></dd><dt><span data-translate="investhryApp.aai.latitude2">Latitude 2</span></dt><dd><span>{{vm.aai.latitude2}}</span></dd><dt><span data-translate="investhryApp.aai.latitude3">Latitude 3</span></dt><dd><span>{{vm.aai.latitude3}}</span></dd><dt><span data-translate="investhryApp.aai.longitude1">Longitude 1</span></dt><dd><span>{{vm.aai.longitude1}}</span></dd><dt><span data-translate="investhryApp.aai.longitude2">Longitude 2</span></dt><dd><span>{{vm.aai.longitude2}}</span></dd><dt><span data-translate="investhryApp.aai.longitude3">Longitude 3</span></dt><dd><span>{{vm.aai.longitude3}}</span></dd><dt><span data-translate="investhryApp.aai.siteElevation">Site Elevation</span></dt><dd><span>{{vm.aai.siteElevation}}</span></dd><dt><span data-translate="investhryApp.aai.buildingHeight">Building Height</span></dt><dd><span>{{vm.aai.buildingHeight}}</span></dd><dt><span data-translate="investhryApp.aai.maxSiteElevation">Max Site Elevation</span></dt><dd><span>{{vm.aai.maxSiteElevation}}</span></dd><dt><span data-translate="investhryApp.aai.question1">Question 1</span></dt><dd><span>{{vm.aai.question1}}</span></dd><dt><span data-translate="investhryApp.aai.question2">Question 2</span></dt><dd><span>{{vm.aai.question2}}</span></dd><dt><span data-translate="investhryApp.aai.question3">Question 3</span></dt><dd><span>{{vm.aai.question3}}</span></dd><dt><span data-translate="investhryApp.aai.file1">File 1</span></dt><dd><span>{{vm.aai.file1}}</span></dd><dt><span data-translate="investhryApp.aai.city">City</span></dt><dd><span>{{vm.aai.city}}</span></dd></dl></div>');
$templateCache.put('app/ConstructionPermit/ffs.html','<form target="my_iframe" action="{{vm.resourceurl_ffs}}" method="POST"><!--<input type="hidden" name="email" value="\'2c520622-d89a-42a1-ae85-efa54ee3630f\'">--><!--<input type="hidden" name="address" value="{{vm.projectid}}">--><!--<input type="hidden" name="url"--><!--value="http://staging.ulbharyana.gov.in/eforms/HepcLinkPage.aspx">--> <input id="ffsbutton" type="submit" class="btn btn-link" value=" "></form><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" ng-click="vm.saveffs()" data-target="#waterConnectionModal" data-toggle="modal">Save & Continue</button><script>jQuery(function(){\n        jQuery(\'#ffsbutton\').click();\n    });</script>');
$templateCache.put('app/ConstructionPermit/fireNOC.html','<!--<form target="my_iframe"--><!--action="http://hudaoabp.gov.in/BPAMSClient/Proposal/appform.aspx"--><!--method="POST">--><!--<input type="hidden" name="email" value="\'43575ec0-7dd3-40bd-b3c4-47638d17bf3c\'">--><!--<input type="hidden" name="address" value="{{vm.projectid}}">--><!--<input type="hidden" name="url"--><!--value="http://hudaoabp.gov.in/BPAMSClient/Proposal/appform.aspx">--><!--<input id="hudabutton" type="submit" class="btn btn-link"--><!--value=" ">--><!--</form>--><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" ng-click="vm.fireNOC()" ui-sref="constructionpermit({id: vm.projectid})">Save</button><!--<script>--><!--jQuery(function(){--><!--jQuery(\'#hudabutton\').click();--><!--});--><!--</script>-->');
$templateCache.put('app/ConstructionPermit/hsidc.html','<form target="my_iframe" action="https://122.160.61.180:8446/HSIIDCBackup/linkHEPC" method="POST"><input type="hidden" name="email" value="\'a69786f5-c674-4de9-8807-8689c7ef86b5\'"> <input type="hidden" name="address" value="{{vm.projectid}}"> <input type="hidden" name="url" value="https://122.160.61.180:8446/HSIIDCBackup/linkHEPC"> <input id="hsidcbutton" type="submit" class="btn btn-link" value=" "></form><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" data-toggle="modal" data-target="#hudamodal" ng-click="vm.saveDepartment(\'hsidc\')">Save & Continue</button><div id="hudamodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Is the plot within the vicinity of Aerodrome i.e Approval from Airport Authority of India is required?</h4></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="aai-state({CPid: vm.constructorPermit.id})">Yes</button> <button type="button" class="btn btn-success" data-dismiss="modal" data-toggle="modal" data-target="#nmamodal">No</button></div></div></div></div><div id="nmamodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Is the proposed construction site falls in limit of any centrally protected monument?</h4></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="nma-state({CPid: vm.constructorPermit.id})">Yes</button> <button type="button" class="btn btn-success" data-dismiss="modal" ui-sref="ffs">No</button></div></div></div></div><script>jQuery(function(){\n        jQuery(\'#hsidcbutton\').click();\n    });</script>');
$templateCache.put('app/ConstructionPermit/hsiidc-oc.html','<form target="my_iframe" action="https://122.160.61.180:8446/HSIIDCBackup/linkHEPC" method="POST"><input type="hidden" name="email" value="\'159a0331-87c3-407d-9c6c-559455d4b6ab\'"> <input type="hidden" name="address" value="{{vm.projectid}}"> <input type="hidden" name="url" value="https://122.160.61.180:8446/HSIIDCBackup/linkHEPC"> <input id="tcpbutton" type="submit" class="btn btn-link" value=" "></form><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" ng-click="vm.saveOC(\'077f3112-69e6-41ea-a2e5-75b4925d6900\')" ui-sref="constructionpermit({id: vm.projectid})">Save</button><!--<button id="abc" type="button" class="btn btn-primary" ng-click="vm.click()">Yes</button>--><script>jQuery(function(){\n        jQuery(\'#tcpbutton\').click();\n    });</script>');
$templateCache.put('app/ConstructionPermit/huda-oc.html','<form name="editForm" role="form" class="col-md-8 col-md-offset-2" ng-submit="vm.save()"><div class="modal-header"><!--<button type="button" class="close" data-dismiss="modal" aria-hidden="true"--><!--ng-click="vm.clear()">&times;</button>--><h4 class="modal-title" id="myHudaformOcLabel">New HUDA Occupation Certificate</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.hudaformOc.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.hudaformOc.id" hidden></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.certificateFrom" for="field_certificateFrom">Certificate From</label><input type="text" class="form-control" name="certificateFrom" id="field_certificateFrom" ng-model="vm.hudaformOc.certificateFrom"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.orderNo" for="field_orderNo">Order No</label><input type="text" class="form-control" name="orderNo" id="field_orderNo" ng-model="vm.hudaformOc.orderNo"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.dated" for="field_dated">Dated</label><input type="text" class="form-control" name="dated" id="field_dated" ng-model="vm.hudaformOc.dated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.completedOn" for="field_completedOn">Completed On</label><input type="text" class="form-control" name="completedOn" id="field_completedOn" ng-model="vm.hudaformOc.completedOn"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.anyModifications" for="field_anyModifications">Any Modifications</label><input type="text" class="form-control" name="anyModifications" id="field_anyModifications" ng-model="vm.hudaformOc.anyModifications"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.plotNo" for="field_plotNo">Plot No</label><input type="text" class="form-control" name="plotNo" id="field_plotNo" ng-model="vm.hudaformOc.plotNo"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.phase" for="field_phase">Phase</label><input type="text" class="form-control" name="phase" id="field_phase" ng-model="vm.hudaformOc.phase"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.estate" for="field_estate">Estate</label><input type="text" class="form-control" name="estate" id="field_estate" ng-model="vm.hudaformOc.estate"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.sector" for="field_sector">Sector</label><input type="text" class="form-control" name="sector" id="field_sector" ng-model="vm.hudaformOc.sector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.colony" for="field_colony">Colony</label><input type="text" class="form-control" name="colony" id="field_colony" ng-model="vm.hudaformOc.colony"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.hudaformOc.city"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.khasra" for="field_khasra">Khasra</label><input type="text" class="form-control" name="khasra" id="field_khasra" ng-model="vm.hudaformOc.khasra"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.village" for="field_village">Village</label><input type="text" class="form-control" name="village" id="field_village" ng-model="vm.hudaformOc.village"></div></div><div class="modal-footer"><button class="btn btn-primary pull-right" type="submit" ng-click="vm.saveOC(\'9b8f4307-4f88-4821-aec7-2dd2668041ab\')" ui-sref="constructionpermit({id: vm.projectid})">Save</button><!--<button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">--><!--<span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>--><!--</button>--><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>--><!--</button>--></div></form><!--<button id="abc" type="button" class="btn btn-primary" ng-click="vm.click()">Yes</button>--><!--<script>--><!--jQuery(function(){--><!--jQuery(\'#tcpbutton\').click();--><!--});--><!--</script>-->');
$templateCache.put('app/ConstructionPermit/huda.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="col-md-8 col-md-offset-2"><div class="modal-header"><!--<button type="button" class="close" data-dismiss="modal" aria-hidden="true"--><!--ng-click="vm.clear()">&times;</button>--><h4 class="modal-title" id="myHudaFormLabel">New Huda Building Approval Form</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.hudaForm.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.hudaForm.id" hidden></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.caseType" for="field_caseType">Case Type</label><input type="text" class="form-control" name="caseType" id="field_caseType" ng-model="vm.hudaForm.caseType" placeholder="Fresh Building Plan" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.estateOffice" for="field_estateOffice">Estate Office</label><input type="text" class="form-control" name="estateOffice" id="field_estateOffice" ng-model="vm.hudaForm.estateOffice"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.projectType" for="field_projectType">Project Type</label><input type="text" class="form-control" name="projectType" id="field_projectType" ng-model="vm.hudaForm.projectType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.sector" for="field_sector">Sector</label><input type="text" class="form-control" name="sector" id="field_sector" ng-model="vm.hudaForm.sector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.existingFAR" for="field_existingFAR">Existing FAR</label><input type="text" class="form-control" name="existingFAR" id="field_existingFAR" ng-model="vm.hudaForm.existingFAR"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.basementArea" for="field_basementArea">Basement Area</label><input type="text" class="form-control" name="basementArea" id="field_basementArea" ng-model="vm.hudaForm.basementArea"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.zoningLayout" for="field_zoningLayout">Zoning Layout</label><input type="text" class="form-control" name="zoningLayout" id="field_zoningLayout" ng-model="vm.hudaForm.zoningLayout"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.plotNumber" for="field_plotNumber">Plot Number</label><input type="text" class="form-control" name="plotNumber" id="field_plotNumber" ng-model="vm.hudaForm.plotNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.applicationType" for="field_applicationType">Application Type</label><input type="text" class="form-control" name="applicationType" id="field_applicationType" ng-model="vm.hudaForm.applicationType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.applicantName" for="field_applicantName">Applicant Name</label><input type="text" class="form-control" name="applicantName" id="field_applicantName" ng-model="vm.hudaForm.applicantName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.applicantEmail" for="field_applicantEmail">Applicant Email</label><input type="text" class="form-control" name="applicantEmail" id="field_applicantEmail" ng-model="vm.hudaForm.applicantEmail"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.applicantMobile" for="field_applicantMobile">Applicant Mobile</label><input type="text" class="form-control" name="applicantMobile" id="field_applicantMobile" ng-model="vm.hudaForm.applicantMobile"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.ownerName" for="field_ownerName">Owner Name</label><input type="text" class="form-control" name="ownerName" id="field_ownerName" ng-model="vm.hudaForm.ownerName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.ownerAddress" for="field_ownerAddress">Owner Address</label><input type="text" class="form-control" name="ownerAddress" id="field_ownerAddress" ng-model="vm.hudaForm.ownerAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.aadhaarCardNumber" for="field_aadhaarCardNumber">Aadhaar Card Number</label><input type="text" class="form-control" name="aadhaarCardNumber" id="field_aadhaarCardNumber" ng-model="vm.hudaForm.aadhaarCardNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.fatherName" for="field_fatherName">Father Name</label><input type="text" class="form-control" name="fatherName" id="field_fatherName" ng-model="vm.hudaForm.fatherName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.pinCode" for="field_pinCode">Pin Code</label><input type="text" class="form-control" name="pinCode" id="field_pinCode" ng-model="vm.hudaForm.pinCode"></div></div><div class="modal-footer"><span ng-show="vm.isFileUpload" style="color: green">File Uploaded Successfully</span> <button type="button" class="btn btn-danger" data-toggle="modal" data-target="#drwaingModal">Upload Drwaings</button> <button class="btn btn-primary pull-right" type="submit" data-toggle="modal" data-target="#hudamodal" ng-click="vm.saveDepartmenthuda()">Save & Continue</button></div></form><div id="hudamodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Is the plot within the vicinity of Aerodrome i.e Approval from Airport Authority of India is required?</h4></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="aai-state({CPid: vm.constructorPermit.id})" ng-click="vm.saveAai()">Yes</button> <button type="button" class="btn btn-success" data-dismiss="modal" data-toggle="modal" data-target="#nmamodal">No</button></div></div></div></div><div id="nmamodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Is the proposed construction site falls in limit of any centrally protected monument?</h4></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="nma-state({CPid: vm.constructorPermit.id})">Yes</button> <button type="button" class="btn btn-success" data-dismiss="modal" ui-sref="ffs">No</button></div></div></div></div><div id="drwaingModal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Upload Drawing (In <b>*.dwg</b> format)</h4></div><div class="modal-body"><input type="file" ng-model="vm.fileDrawing" class="form-control"></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.isFileUpload = true">Upload</button> <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button></div></div></div></div><!--<button id="abc" type="button" class="btn btn-primary" ng-click="vm.click()">Yes</button>--><!--<script>--><!--jQuery(function(){--><!--jQuery(\'#hudabutton\').click();--><!--});--><!--</script>-->');
$templateCache.put('app/ConstructionPermit/inspectionOfficer.html','<div class="col-md-offset-2 col-md-8"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>CAF pin (Composite Application Form)</span></th><th><span>Service Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="pendingConstructionPermit in vm.pendingConstructionPermits"><td>{{pendingConstructionPermit.cafPin}}</td><td>{{pendingConstructionPermit.serviceName}}</td><!--<td>{{pendingConstructionPermit.projectId}}</td>--><!--<td>{{pendingConstructionPermit.serviceId}}</td>--><td><button class="btn btn-success" type="button" data-toggle="modal" data-target="#uploadIR" ng-click="vm.uploadInspectionReport(pendingConstructionPermit)">Upload Inspection Report</button></td></tr></tbody></table></div></div><div id="uploadIR" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Upload Inspection Report</h4></div><div class="modal-body"><div class="row" style="margin: 10px"><h4>File 1</h4><div class="col-md-10"><input type="file" class="form-control" file-model="vm.file1" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.uploadfile(vm.file1,1)">Upload</button></div></div><div class="row" style="margin: 10px"><h4>File 2</h4><div class="col-md-10"><input type="file" class="form-control" file-model="vm.file2" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.uploadfile(vm.file2,2)">Upload</button></div></div><div class="row" style="margin: 10px"><h4>File 3</h4><div class="col-md-10"><input type="file" class="form-control" file-model="vm.file3" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.uploadfile(vm.file3,3)">Upload</button></div></div><div class="row" style="margin: 10px"><h4>File 4</h4><div class="col-md-10"><input type="file" class="form-control" file-model="vm.file4" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.uploadfile(vm.file4,4)">Upload</button></div></div><div class="row" style="margin: 10px"><h4>File 5</h4><div class="col-md-10"><input type="file" class="form-control" file-model="vm.file5" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.uploadfile(vm.file5,5)">Upload</button></div></div><div class="row" style="margin: 10px"><h4>File 6</h4><div class="col-md-10"><input type="file" class="form-control" file-model="vm.file6" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.uploadfile(vm.file6,6)">Upload</button></div></div><div class="row" style="margin: 10px"><h4>File 7</h4><div class="col-md-10"><input type="file" class="form-control" file-model="vm.file7" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.uploadfile(vm.file7,7)">Upload</button></div></div><div class="row" style="margin: 10px"><h4>File 8</h4><div class="col-md-10"><input type="file" class="form-control" file-model="vm.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.uploadfile(vm.file8,8)">Upload</button></div></div><div class="row" style="margin: 10px"><h4>File 9</h4><div class="col-md-10"><input type="file" class="form-control" file-model="vm.file9" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.uploadfile(vm.file9,9)">Upload</button></div></div><div class="row" style="margin: 10px"><h4>Inspection Cerificate</h4><div class="col-md-10"><input type="file" class="form-control" file-model="vm.file10" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.uploadfile(vm.file10,10)">Upload</button></div></div></div><div class="modal-footer"><button type="button" class="btn btn-success" data-dismiss="modal" ng-click="vm.onDoneSaveSuccess()">Done</button></div></div></div></div>');
$templateCache.put('app/ConstructionPermit/labour-oc.html','<!--<form target="my_iframe"--><!--action="https://tcpharyana.gov.in/OnlineDiary/TcpOnlineDiary/OnlineDiaryFromSSO/CheckUserAuthenticationCode?ListType=HPEC&ApplicationDocID=85&ApplicationType=NOC&sid=849999"--><!--method="POST">--><!--<input type="hidden" name="email" value="\'159a0331-87c3-407d-9c6c-559455d4b6ab\'">--><!--<input type="hidden" name="address" value="{{vm.projectid}}">--><!--<input type="hidden" name="url"--><!--value="https://tcpharyana.gov.in/OnlineDiary/TcpOnlineDiary/OnlineDiaryFromSSO/CheckUserAuthenticationCode?ListType=HPEC&ApplicationDocID=85&ApplicationType=NOC&sid=849999">--><!--<input id="tcpbutton" type="submit" class="btn btn-link"--><!--value=" ">--><!--</form>--><!--<section height="inherit">--><!--<iframe name="my_iframe" style="--><!--width: 100%; height: 1000px" frameborder="0" scrolling="yes"--><!--marginheight="0" marginwidth="0">--><!--</iframe>--><!--</section>--><!--<button class="btn btn-primary pull-right" type="button" style="margin: 20px;" ng-click="vm.saveOC(\'c8981bea-c376-4e65-9d43-9650989a7bb7\')">Save</button>--><!--&lt;!&ndash;<button id="abc" type="button" class="btn btn-primary" ng-click="vm.click()">Yes</button>&ndash;&gt;--><!--<script>--><!--jQuery(function(){--><!--jQuery(\'#tcpbutton\').click();--><!--});--><!--</script>-->');
$templateCache.put('app/ConstructionPermit/labour.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" class="col-md-8 col-md-offset-2"><div class="modal-header"><!--<button type="button" class="close" data-dismiss="modal" aria-hidden="true"--><!--ng-click="vm.clear()">&times;</button>--><h4 class="modal-title" id="myFactotyPlanLabel">New Factoty Plan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--<div class="form-group" ng-show="vm.factotyPlan.id">--><!--<label for="id" data-translate="global.field.id">ID</label>--><!--<input type="text" class="form-control" id="id" name="id"--><!--ng-model="vm.factotyPlan.id" readonly />--><!--</div>--><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.nameApplicant" for="field_nameApplicant">Name Applicant</label><input type="text" class="form-control" name="nameApplicant" id="field_nameApplicant" ng-model="vm.factotyPlan.nameApplicant"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.applicantAddress" for="field_applicantAddress">Applicant Address</label><input type="text" class="form-control" name="applicantAddress" id="field_applicantAddress" ng-model="vm.factotyPlan.applicantAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.factoryName" for="field_factoryName">Factory Name</label><input type="text" class="form-control" name="factoryName" id="field_factoryName" ng-model="vm.factotyPlan.factoryName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.factoryAddress" for="field_factoryAddress">Factory Address</label><input type="text" class="form-control" name="factoryAddress" id="field_factoryAddress" ng-model="vm.factotyPlan.factoryAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.factorySituation" for="field_factorySituation">Factory Situation</label><input type="text" class="form-control" name="factorySituation" id="field_factorySituation" ng-model="vm.factotyPlan.factorySituation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.state" for="field_state">State</label><input type="text" class="form-control" name="state" id="field_state" ng-model="vm.factotyPlan.state"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.factotyPlan.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.town" for="field_town">Town</label><input type="text" class="form-control" name="town" id="field_town" ng-model="vm.factotyPlan.town"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.nearestRailwayStation" for="field_nearestRailwayStation">Nearest Railway Station</label><input type="text" class="form-control" name="nearestRailwayStation" id="field_nearestRailwayStation" ng-model="vm.factotyPlan.nearestRailwayStation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.perticularPlant" for="field_perticularPlant">Perticular Plant</label><input type="text" class="form-control" name="perticularPlant" id="field_perticularPlant" ng-model="vm.factotyPlan.perticularPlant"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.datePlant" for="field_datePlant">Date Plant</label><div class="input-group"><input id="field_datePlant" type="text" class="form-control" name="datePlant" uib-datepicker-popup="{{dateformat}}" ng-model="vm.factotyPlan.datePlant" is-open="vm.datePickerOpenStatus.datePlant"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datePlant\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button class="btn btn-primary pull-right" type="submit" style="margin: 20px" ng-click="vm.saveLabour()" ui-sref="constructionpermit({id: vm.projectid})">Save</button><!--<button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">--><!--<span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>--><!--</button>--><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span>--><!--</button>--></div></form><!--<button class="btn btn-primary pull-right" type="button" style="margin: 20px;" data-toggle="modal" data-target="#labourmodal" ng-click="vm.saveLabour()">Save & Continue</button>--><!--<div id="labourmodal" class="modal fade" role="dialog">--><!--<div class="modal-dialog">--><!--&lt;!&ndash; Modal content&ndash;&gt;--><!--<div class="modal-content">--><!--<div class="modal-header">--><!--<button type="button" class="close" data-dismiss="modal">&times;</button>--><!--<h4 class="modal-title">Is the plot within the vicinity of Aerodrome i.e Approval from Airport Authority of India is required?</h4>--><!--</div>--><!--<div class="modal-footer">--><!--<button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="aai-state({CPid: vm.constructorPermit.id})">Yes</button>--><!--<button type="button" class="btn btn-success" data-dismiss="modal" data-toggle="modal" data-target="#nmamodal" >No</button>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div id="nmamodal" class="modal fade" role="dialog">--><!--<div class="modal-dialog">--><!--&lt;!&ndash; Modal content&ndash;&gt;--><!--<div class="modal-content">--><!--<div class="modal-header">--><!--<button type="button" class="close" data-dismiss="modal">&times;</button>--><!--<h4 class="modal-title">Is the proposed construction site falls in limit of any centrally protected monument?</h4>--><!--</div>--><!--<div class="modal-footer">--><!--<button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="nma-state({CPid: vm.constructorPermit.id})">Yes</button>--><!--<button type="button" class="btn btn-success" data-dismiss="modal" ui-sref="ffs">No</button>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<button id="abc" type="button" class="btn btn-primary" ng-click="vm.click()">Yes</button>--><!--<script>--><!--jQuery(function(){--><!--jQuery(\'#labourbutton\').click();--><!--});--><!--</script>-->');
$templateCache.put('app/ConstructionPermit/nma-detailPage.html','<div class="col-md-8 col-md-offset-2"><!--<h2><span data-translate="investhryApp.nma.detail.title">Nma</span> {{vm.nma.id}}</h2>--><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.nma.department">Department</span></dt><dd><span>{{vm.nma.department}}</span></dd><dt><span data-translate="investhryApp.nma.architectName">Architect Name</span></dt><dd><span>{{vm.nma.architectName}}</span></dd><dt><span data-translate="investhryApp.nma.architectEmail">Architect Email</span></dt><dd><span>{{vm.nma.architectEmail}}</span></dd><dt><span data-translate="investhryApp.nma.architectMobile">Architect Mobile</span></dt><dd><span>{{vm.nma.architectMobile}}</span></dd><dt><span data-translate="investhryApp.nma.nocRequestScreen">Noc Request Screen</span></dt><dd><span>{{vm.nma.nocRequestScreen}}</span></dd><dt><span data-translate="investhryApp.nma.nameOfApplicant">Name Of Applicant</span></dt><dd><span>{{vm.nma.nameOfApplicant}}</span></dd><dt><span data-translate="investhryApp.nma.presentAddress">Present Address</span></dt><dd><span>{{vm.nma.presentAddress}}</span></dd><dt><span data-translate="investhryApp.nma.permanentAddress">Permanent Address</span></dt><dd><span>{{vm.nma.permanentAddress}}</span></dd><dt><span data-translate="investhryApp.nma.isOwner">Is Owner</span></dt><dd><span>{{vm.nma.isOwner}}</span></dd><dt><span data-translate="investhryApp.nma.nameOfOwner">Name Of Owner</span></dt><dd><span>{{vm.nma.nameOfOwner}}</span></dd><dt><span data-translate="investhryApp.nma.presentAddressOwner">Present Address Owner</span></dt><dd><span>{{vm.nma.presentAddressOwner}}</span></dd><dt><span data-translate="investhryApp.nma.permanentAddressOwner">Permanent Address Owner</span></dt><dd><span>{{vm.nma.permanentAddressOwner}}</span></dd><dt><span data-translate="investhryApp.nma.typeOwner1">Type Owner 1</span></dt><dd><span>{{vm.nma.typeOwner1}}</span></dd><dt><span data-translate="investhryApp.nma.typeOwner2">Type Owner 2</span></dt><dd><span>{{vm.nma.typeOwner2}}</span></dd><dt><span data-translate="investhryApp.nma.typeOwner3">Type Owner 3</span></dt><dd><span>{{vm.nma.typeOwner3}}</span></dd><dt><span data-translate="investhryApp.nma.plotNo">Plot No</span></dt><dd><span>{{vm.nma.plotNo}}</span></dd><dt><span data-translate="investhryApp.nma.state">State</span></dt><dd><span>{{vm.nma.state}}</span></dd><dt><span data-translate="investhryApp.nma.district">District</span></dt><dd><span>{{vm.nma.district}}</span></dd><dt><span data-translate="investhryApp.nma.taulk">Taulk</span></dt><dd><span>{{vm.nma.taulk}}</span></dd><dt><span data-translate="investhryApp.nma.locality">Locality</span></dt><dd><span>{{vm.nma.locality}}</span></dd><dt><span data-translate="investhryApp.nma.monumentName">Monument Name</span></dt><dd><span>{{vm.nma.monumentName}}</span></dd><dt><span data-translate="investhryApp.nma.stateMonument">State Monument</span></dt><dd><span>{{vm.nma.stateMonument}}</span></dd><dt><span data-translate="investhryApp.nma.districtMonument">District Monument</span></dt><dd><span>{{vm.nma.districtMonument}}</span></dd><dt><span data-translate="investhryApp.nma.taulkMonument">Taulk Monument</span></dt><dd><span>{{vm.nma.taulkMonument}}</span></dd><dt><span data-translate="investhryApp.nma.localityMonument">Locality Monument</span></dt><dd><span>{{vm.nma.localityMonument}}</span></dd><dt><span data-translate="investhryApp.nma.distance1">Distance 1</span></dt><dd><span>{{vm.nma.distance1}}</span></dd><dt><span data-translate="investhryApp.nma.distance2">Distance 2</span></dt><dd><span>{{vm.nma.distance2}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails1">Work Details 1</span></dt><dd><span>{{vm.nma.workDetails1}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails2">Work Details 2</span></dt><dd><span>{{vm.nma.workDetails2}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails3">Work Details 3</span></dt><dd><span>{{vm.nma.workDetails3}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails4">Work Details 4</span></dt><dd><span>{{vm.nma.workDetails4}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails5">Work Details 5</span></dt><dd><span>{{vm.nma.workDetails5}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails6">Work Details 6</span></dt><dd><span>{{vm.nma.workDetails6}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails7">Work Details 7</span></dt><dd><span>{{vm.nma.workDetails7}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails8">Work Details 8</span></dt><dd><span>{{vm.nma.workDetails8}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails9">Work Details 9</span></dt><dd><span>{{vm.nma.workDetails9}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails10">Work Details 10</span></dt><dd><span>{{vm.nma.workDetails10}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails11">Work Details 11</span></dt><dd><span>{{vm.nma.workDetails11}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails12">Work Details 12</span></dt><dd><span>{{vm.nma.workDetails12}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails1">Other Work Details 1</span></dt><dd><span>{{vm.nma.otherWorkDetails1}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails2">Other Work Details 2</span></dt><dd><span>{{vm.nma.otherWorkDetails2}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails3">Other Work Details 3</span></dt><dd><span>{{vm.nma.otherWorkDetails3}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails4">Other Work Details 4</span></dt><dd><span>{{vm.nma.otherWorkDetails4}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails5">Other Work Details 5</span></dt><dd><span>{{vm.nma.otherWorkDetails5}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails6">Other Work Details 6</span></dt><dd><span>{{vm.nma.otherWorkDetails6}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails7">Other Work Details 7</span></dt><dd><span>{{vm.nma.otherWorkDetails7}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails8">Other Work Details 8</span></dt><dd><span>{{vm.nma.otherWorkDetails8}}</span></dd></dl></div>');
$templateCache.put('app/ConstructionPermit/tcp-oc.html','<form target="my_iframe" action="https://tcpharyana.gov.in/OnlineDiary/TcpOnlineDiary/OnlineDiaryFromSSO/CheckUserAuthenticationCode?ListType=HPEC&ApplicationDocID=85&ApplicationType=NOC&sid=849999" method="POST"><input type="hidden" name="email" value="\'159a0331-87c3-407d-9c6c-559455d4b6ab\'"> <input type="hidden" name="address" value="{{vm.projectid}}"> <input type="hidden" name="url" value="https://tcpharyana.gov.in/OnlineDiary/TcpOnlineDiary/OnlineDiaryFromSSO/CheckUserAuthenticationCode?ListType=HPEC&ApplicationDocID=85&ApplicationType=NOC&sid=849999"> <input id="tcpbutton" type="submit" class="btn btn-link" value=" "></form><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" ng-click="vm.saveOC(\'c8981bea-c376-4e65-9d43-9650989a7bb7\')" ui-sref="constructionpermit({id: vm.projectid})">Save</button><!--<button id="abc" type="button" class="btn btn-primary" ng-click="vm.click()">Yes</button>--><script>jQuery(function(){\n        jQuery(\'#tcpbutton\').click();\n    });</script>');
$templateCache.put('app/ConstructionPermit/tcp.html','<form target="my_iframe" action="https://tcpharyana.gov.in/BuildingPlan/Application_Details/HEPCBuildingPlanForm" method="POST"><input type="hidden" name="serviceid" value="\'159a0331-87c3-407d-9c6c-559455d4b6ab\'"> <input type="hidden" name="projectid" value="{{vm.projectid}}"> <input type="hidden" name="url" value="https://tcpharyana.gov.in/BuildingPlan/Application_Details/HEPCBuildingPlanForm"> <input id="tcpbutton" type="submit" class="btn btn-link" value=" "></form><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" data-toggle="modal" data-target="#hudamodal" ng-click="vm.saveDepartment(\'tcp\')">Save & Continue</button><div id="hudamodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Is the plot within the vicinity of Aerodrome i.e Approval from Airport Authority of India is required?</h4></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="aai-state({CPid: vm.constructorPermit.id})" ng-click="vm.saveAai()">Yes</button> <button type="button" class="btn btn-success" data-dismiss="modal" data-toggle="modal" data-target="#nmamodal">No</button></div></div></div></div><div id="nmamodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Is the proposed construction site falls in limit of any centrally protected monument?</h4></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="nma-state({CPid: vm.constructorPermit.id})">Yes</button> <button type="button" class="btn btn-success" data-dismiss="modal" ui-sref="ffs">No</button></div></div></div></div><!--<button id="abc" type="button" class="btn btn-primary" ng-click="vm.click()">Yes</button>--><script>jQuery(function(){\n        jQuery(\'#tcpbutton\').click();\n    });</script>');
$templateCache.put('app/ConstructionPermit/tec.html','<form target="my_iframe" action="https://newconn.uhbvn.org.in/hepc.aspx" method="POST"><input type="hidden" name="email" value="\'0577cfbb-77e3-4022-8b13-ec100e7094e0\'"> <input type="hidden" name="address" value="{{vm.projectid}}"> <input type="hidden" name="url" value="https://newconn.uhbvn.org.in/hepc.aspx"> <input id="tecbutton" type="submit" class="btn btn-link" value=" "></form><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" ui-sref="constructionpermit({id: vm.projectid})" ng-click="vm.saveTEC()">Save</button><script>jQuery(function(){\n        jQuery(\'#tecbutton\').click();\n    });</script>');
$templateCache.put('app/ConstructionPermit/twc.html','<form target="my_iframe" action="https://122.160.61.180:8446/HSIIDCBackup/linkHEPC" method="POST"><input type="hidden" name="email" value="\'c5baea92-079d-44d3-9980-8b7d7d568f98\'"> <input type="hidden" name="address" value="{{vm.projectid}}"> <input type="hidden" name="url" value="https://122.160.61.180:8446/HSIIDCBackup/linkHEPC"> <input id="twcbutton" type="submit" class="btn btn-link" value=" "></form><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" ng-click="vm.saveTWC()" data-toggle="modal" data-target="#TECmodal">Save & Continue</button><script>jQuery(function(){\n        jQuery(\'#twcbutton\').click();\n    });</script>');
$templateCache.put('app/ConstructionPermit/twc_huda.html','<form target="my_iframe" action="https://www.waterbilling.huda.org.in/Modules/HepcWaterConnection.aspx" method="POST"><input type="hidden" name="email" value="\'c5baea92-079d-44d3-9980-8b7d7d568f98\'"> <input type="hidden" name="address" value="{{vm.projectid}}"> <input type="hidden" name="url" value="https://www.waterbilling.huda.org.in/Modules/HepcWaterConnection.aspx"> <input id="twcbutton" type="submit" class="btn btn-link" value=" "></form><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" ng-click="vm.saveTWC()" data-toggle="modal" data-target="#TECmodal">Save & Continue</button><script>jQuery(function(){\n        jQuery(\'#twcbutton\').click();\n    });</script>');
$templateCache.put('app/ConstructionPermit/twc_ulb.html','<form target="my_iframe" action="{{vm.resourceurl_twc}}" method="POST"><!--<input type="hidden" name="email" value="\'c5baea92-079d-44d3-9980-8b7d7d568f98\'">--><!--<input type="hidden" name="address" value="{{vm.projectid}}">--><!--<input type="hidden" name="url"--><!--value="https://122.160.61.180:8446/HSIIDCBackup/linkHEPC">--> <input id="twcbutton" type="submit" class="btn btn-link" value=" "></form><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" ng-click="vm.saveTWC()" data-toggle="modal" data-target="#TECmodal">Save & Continue</button><script>jQuery(function(){\n        jQuery(\'#twcbutton\').click();\n    });</script>');
$templateCache.put('app/ConstructionPermit/ulb-oc.html','<form target="my_iframe" action="{{vm.resourceurl_ulbOC}}" method="POST"><!--<input type="hidden" name="email" value="\'1c90c949-f2d1-4997-84b0-e6b2d40fe5e6\'">--><!--<input type="hidden" name="address" value="{{vm.projectid}}">--><!--<input type="hidden" name="url"--><!--value="http://staging.ulbharyana.gov.in/eforms/HepcLinkPage.aspx">--> <input id="ulbbutton" type="submit" class="btn btn-link" value=" "></form><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" ng-click="vm.saveOC(\'9d063f53-5e50-4b05-b543-bfa0fcb6da58\')">Save</button><!--<button id="abc" type="button" class="btn btn-primary" ng-click="vm.click()">Yes</button>--><script>jQuery(function(){\n        jQuery(\'#ulbbutton\').click();\n    });</script>');
$templateCache.put('app/ConstructionPermit/ulb.html','<form target="my_iframe" action="{{vm.resourceurl}}" method="POST"><!--<input type="hidden" name="serviceid" value="\'1c90c949-f2d1-4997-84b0-e6b2d40fe5e6\'">--><!--<input type="hidden" name="projectid" value="{{vm.projectid}}">--><!--<input type="hidden" name="url"--><!--value="http://staging.ulbharyana.gov.in/eforms/HepcLinkPage.aspx?projectid=&serviceid=">--> <input id="ulbbutton" type="submit" class="btn btn-link" value=" "></form><section height="inherit"><iframe name="my_iframe" style="width: 100%; height: 1000px" frameborder="0" scrolling="yes" marginheight="0" marginwidth="0"></iframe></section><button class="btn btn-primary pull-right" type="button" style="margin: 20px" data-toggle="modal" data-target="#hudamodal" ng-click="vm.saveDepartment(\'ulb\')">Save & Continue</button><div id="hudamodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Is the plot within the vicinity of Aerodrome i.e Approval from Airport Authority of India is required?</h4></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="aai-state({CPid: vm.constructorPermit.id})" ng-click="vm.saveAai()">Yes</button> <button type="button" class="btn btn-success" data-dismiss="modal" data-toggle="modal" data-target="#nmamodal">No</button></div></div></div></div><div id="nmamodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Is the proposed construction site falls in limit of any centrally protected monument?</h4></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="nma-state({CPid: vm.constructorPermit.id})">Yes</button> <button type="button" class="btn btn-success" data-dismiss="modal" ui-sref="ffs">No</button></div></div></div></div><!--<button id="abc" type="button" class="btn btn-primary" ng-click="vm.click()">Yes</button>--><script>jQuery(function(){\n        jQuery(\'#ulbbutton\').click();\n    });</script>');
$templateCache.put('app/ProjectCompleteDetail/ProjectCompleteDetailExcise.html','<div class="row"><jhi-alert-error></jhi-alert-error><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b>Mandatory Fields</b></p></div><div class="panel-body"><div class="row"><div class="col-md-4"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Applicant Name :</b></dt><dd>{{vm.project.firstname}} {{vm.project.middlename}} {{vm.project.lastname}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Email :</b></dt><dd>{{vm.project.emailprimary}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.emailsecondary}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Contact Number :</b></dt><dd>{{vm.project.mobilenumber}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.phonenumber}}</dd></dl></div><div class="col-md-4 panel-border"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Business Entity (M/s) :</b></dt><dd>{{vm.project.businessentity}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>District :</b></dt><dd>{{vm.project.district}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Block Category :</b></dt><dd>{{vm.project.blockCategory}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Total Proposed Project Area :</b></dt><dd>{{vm.project.totalproposedprojectarea}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Land Zone Use Type :</b></dt><dd>{{vm.project.landzoneuse_type}}</dd></dl></div><div class="col-md-4 panel-border"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Total Project Cost (in Crore) :</b></dt><dd>{{vm.project.total_project_cost}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Total Project Employment :</b></dt><dd>{{vm.project.totalpurposedemployment}}</dd></dl></div></div><div class="row panel-body col-md-offset-1"><div class="col-md-10"><div class="col-md-9"><label class="col-md-4">Applicant Signature:</label><div class="thumbnail col-md-7"><img src="{{vm.investorsign}}" style="width:30%;height:10%"></div></div><div class="col-md-3"><label class="col-md-6">Place:</label><p class="col-md-6">{{vm.project.place}}</p></div></div></div></div></div></div>');
$templateCache.put('app/ProjectCompleteDetail/ProjectCompleteDetailFilm.html','<div class="row"><jhi-alert-error></jhi-alert-error><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b>Mandatory Fields</b></p></div><div class="panel-body"><div class="row"><div class="col-md-4"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Applicant Name :</b></dt><dd>{{vm.project.firstname}} {{vm.project.middlename}} {{vm.project.lastname}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Email :</b></dt><dd>{{vm.project.emailprimary}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.emailsecondary}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>District :</b></dt><dd>{{vm.project.district}}</dd></dl><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Block Category :</b></dt>--><!--<dd>{{vm.project.blockCategory}}</dd>--><!--</dl>--></div><div class="col-md-4 panel-border"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Contact Number :</b></dt><dd>{{vm.project.mobilenumber}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.phonenumber}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Business Entity (M/s) :</b></dt><dd>{{vm.project.businessentity}}</dd></dl></div><div class="col-md-4 panel-border"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>place :</b></dt><dd>{{vm.project.place}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Applicant Signature :</b></dt><dd class="thumbnail"><img ng-src="{{vm.investorsign}}" style="width:30%;height:10%"></dd></dl></div></div></div></div></div>');
$templateCache.put('app/ProjectCompleteDetail/ProjectCompleteDetailLandRequirement.html','<div class="row"><jhi-alert-error></jhi-alert-error><div class="col-md-6"><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b>Mandatory Fields</b></p></div><div class="panel-body"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Applicant Name :</b></dt><dd>{{vm.project.firstname}} {{vm.project.middlename}} {{vm.project.lastname}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Email :</b></dt><dd>{{vm.project.emailprimary}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.emailsecondary}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Contact Number :</b></dt><dd>{{vm.project.mobilenumber}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.phonenumber}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Business Entity (M/s) :</b></dt><dd>{{vm.project.businessentity}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>District :</b></dt><dd>{{vm.project.district}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Block Category :</b></dt><dd>{{vm.project.blockCategory}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Total Proposed Project Area :</b></dt><dd>{{vm.project.totalproposedprojectarea}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Total Project Cost (in Crore) :</b></dt><dd>{{vm.project.total_project_cost}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Total Project Employment :</b></dt><dd>{{vm.project.totalpurposedemployment}}</dd></dl></div></div></div><div class="col-md-6"><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b>Land Requirement Details</b></p></div><div class="panel-body"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Land Required :</b></dt><dd>{{vm.project.landrequired}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Plot Size :</b></dt><dd>{{vm.project.plotsize}}</dd></dl><div ng-hide="vm.project.landrequired!=\'In Industrial Estate/Area\'"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Agency Name :</b></dt><dd>{{vm.project.agencyname}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Name of Industrial Estate/Location :</b></dt><dd>{{vm.project.estatename}}</dd></dl></div><div ng-hide="vm.project.landrequired!=\'Outside Developed Industrial Estate/Area\'"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Expected Purchase Rate/ SQ. Mtr :</b></dt><dd>{{vm.project.purchaserate}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Village :</b></dt><dd>{{vm.project.village}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Tehsil :</b></dt><dd>{{vm.project.tehsil}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>District :</b></dt><dd>{{vm.project.landrequirementindistrict}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Land Use Type :</b></dt><dd>{{vm.project.landusetype }}</dd></dl></div></div></div><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b>Applicant Signature</b></p></div><div class="panel-body"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>place :</b></dt><dd>{{vm.project.place}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Applicant Signature :</b></dt><dd class="thumbnail"><img ng-src="{{vm.investorsign}}" style="width:30%;height:10%"></dd></dl></div></div></div></div>');
$templateCache.put('app/ProjectCompleteDetail/ProjectCompleteDetailNew.html','<!--<div class="row">--><!--<jhi-alert-error></jhi-alert-error>--><!--<div class="col-md-4 ">--><!--<div class="panel panel-primary">--><!--<div class="panel-heading">--><!--<p class="panel-title text-center " style="font-size: 18px;"><b>Mandatory Fields</b></p>--><!--</div>--><!--<div class="panel-body" >--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Applicant Name :</b></dt>--><!--<dd>{{vm.project.firstname}} {{vm.project.middlename}} {{vm.project.lastname}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Email :</b></dt>--><!--<dd>{{vm.project.emailprimary}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.emailsecondary}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Contact Number :</b></dt>--><!--<dd>{{vm.project.mobilenumber}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.phonenumber}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Business Entity (M/s) :</b></dt>--><!--<dd>{{vm.project.businessentity}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>District :</b></dt>--><!--<dd>{{vm.project.district}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Block Category :</b></dt>--><!--<dd>{{vm.project.blockCategory}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Total Proposed Project Area :</b></dt>--><!--<dd>{{vm.project.totalproposedprojectarea}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Land Zone Use Type :</b></dt>--><!--<dd>{{vm.project.landzoneuse_type}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Total Project Cost (in Crore) :</b></dt>--><!--<dd>{{vm.project.total_project_cost}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Total Project Employment :</b></dt>--><!--<dd>{{vm.project.totalpurposedemployment}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Haryana Domicile  :</b></dt>--><!--<dd>{{vm.project.haryanadomicile}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Non Haryana Domicile  :</b></dt>--><!--<dd>{{vm.project.nonharyanadomicile}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Investment Type :</b></dt>--><!--<dd>{{vm.project.investmentType == \'Other\'?  vm.project.otherInvestmetType : vm.project.investmentType}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Production Start date :</b></dt>--><!--<dd>{{vm.project.prodctionStartDate | date:\'dd.MM.y\'}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Foreign Direct Investment :</b></dt>--><!--<dd>{{vm.project.foreign_investment !== null ? vm.project.foreign_investment : \'No\'}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Industrial Estate :</b></dt>--><!--<dd>{{vm.project.industrialEstate !== null ? vm.project.industrialEstate : \'NA\'}}</dd>--><!--</dl>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-md-4">--><!--<div class="panel panel-primary" >--><!--<div class="panel-heading">--><!--<p class="panel-title text-center" style="font-size: 18px;"><b>Company Detail</b></p>--><!--</div>--><!--<div class="panel-body">--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Business Entity Type :</b></dt>--><!--<dd>{{vm.project.businessentitytype}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Promoter / MD / Director :</b></dt>--><!--<dd>{{vm.project.promoter_md_director}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>No. of Directors/ Promoters /MDs /CEO :</b></dt>--><!--<dd>{{vm.project.director_promoter_md_ceo_number}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>PAN Number :</b></dt>--><!--<dd>{{vm.project.pan_number}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Aadhar Number :</b></dt>--><!--<dd>{{vm.project.aadhar_number}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Applicant is NRI? :</b></dt>--><!--<dd>{{vm.project.nri == true ? "Yes" : "No"}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>GST Number :</b></dt>--><!--<dd>{{vm.project.gstnumber}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>UAM Number :</b></dt>--><!--<dd>{{vm.project.uamnumber}}</dd>--><!--</dl>--><!--</div>--><!--</div>--><!--<div class="panel panel-primary">--><!--<div class="panel-heading">--><!--<p class="panel-title text-center" style="font-size: 18px;"><b>CAF Documents</b></p>--><!--</div>--><!--<div class="panel-body" ng-repeat="cafattachment in vm.cafAttachments">--><!--<a href="" ng-click="vm.downloadFile(cafattachment.fileName)">{{cafattachment.docName}}</a>--><!--</div>--><!--</div>--><!--<div class="panel panel-primary">--><!--<div class="panel-heading">--><!--<p class="uk-card-title text-center" style="font-size: 18px;"><b>Project Site Detail</b></p>--><!--</div>--><!--<div class="panel-body">--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>CLU Required :</b></dt>--><!--<dd>{{vm.project.clurequired== true ? "Yes" : "No"}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Site Address :</b></dt>--><!--<dd>{{vm.project.siteaddress}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Block :</b></dt>--><!--<dd>{{vm.project.block}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>place :</b></dt>--><!--<dd>{{vm.project.place}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Applicant Signature :</b></dt>--><!--<dd class="thumbnail"><img src="{{vm.investorsign}}" style="width:30%;height:10%;"></dd>--><!--</dl>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-md-4">--><!--<div class="panel panel-primary">--><!--<div class="panel-heading">--><!--<p class="panel-title text-center" style="font-size: 18px;"><b>Investor</b></p>--><!--</div>--><!--<div class="thumbnail pull-right panel-body">--><!--<img src="{{vm.investorphoto}}" alt="Image Not Found" style="height:150px; width: 150px;">--><!--</div>--><!--<div class="panel-body">--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>mouapplicable :</b></dt>--><!--<dd>{{vm.project.mouapplicable == true ? "Yes" : "No"}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Country :</b></dt>--><!--<dd>{{vm.project.countryname}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>State :</b></dt>--><!--<dd>{{vm.project.statename}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>City :</b></dt>--><!--<dd>{{vm.project.cityname}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Address :</b></dt>--><!--<dd>{{vm.project.address1}}</dd>--><!--<dd>{{vm.project.address2}}</dd>--><!--<dd>{{vm.project.address3}}</dd>--><!--</dl>--><!--</div>--><!--</div>--><!--<div class="panel panel-primary" >--><!--<div class="panel-heading">--><!--<p class="panel-title text-center" style="font-size: 18px;"><b>Project Detail</b></p>--><!--</div>--><!--<div class="panel-body" >--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Sector :</b></dt>--><!--<dd >{{vm.project.sectorname}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Collaboration with Foreign Investor :</b></dt>--><!--<dd>{{vm.project.collaboration_with_foreign_country}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Size of Industry :</b></dt>--><!--<dd>{{vm.project.size_of_industry}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Project Sector :</b></dt>--><!--<dd>{{vm.project.sector}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Existing Regulatory Approval :</b></dt>--><!--<dd>{{vm.project.existing_regulatory_approval == true ? "Yes" : "No"}}</dd>--><!--</dl>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class="row" xmlns="http://www.w3.org/1999/html"><jhi-alert-error></jhi-alert-error><div class="col-md-4"><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b data-translate="global.addcafnew.INDUSTRY DETAILS">INDUSTRY DETAILS</b></p></div><div class="panel-body"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Proposed Industry Name">Proposed Industry Name</span>:</b></dt><dd>{{vm.project.businessentity}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Sector">Sector</span> :</b></dt><dd>{{vm.project.sectorname}}</dd></dl><dl ng-if="vm.project.sectorname ===\'Other Industries\'" class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b data-translate="global.addcafnew.Other Sector :">Other Sector :</b></dt><dd>{{vm.project.otherFDI}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Product of Manufacture / Service Provided">Product of Manufacture /Service Provided</span>:</b></dt><dd>{{vm.project.product}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Expected Start Date of Commercial Production / Operations">Expected Start Date of Commercial Production/Operations</span> :</b></dt><dd>{{vm.project.prodctionStartDate | date:\'dd.MM.y\'}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.District">District</span> :</b></dt><dd>{{vm.project.district}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Size of Industry">Size of Industry</span> :</b></dt><dd>{{vm.project.size_of_industry}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Village">Village</span> :</b></dt><dd>{{vm.project.village}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Business Entity Type">Business Entity Type</span> :</b></dt><dd>{{vm.project.businessentitytype}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Block">Block</span> :</b></dt><dd>{{vm.project.blockCategory}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Investment Type">Investment Type</span> :</b></dt><dd>{{vm.project.investmentType == \'Other\'? vm.project.otherInvestmetType : vm.project.investmentType}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Total Proposed Project Area">Total Proposed Project Area</span> :</b></dt><dd>{{vm.project.totalproposedprojectarea}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Total Proposed Project Cost (in Crore)">Total Project Cost (in Crore)</span> :</b></dt><dd>{{vm.project.total_project_cost}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Total Project Employment">Total Project Employment</span> :</b></dt><dd>{{vm.project.totalpurposedemployment}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Haryana Domicile">Haryana Domicile</span> :</b></dt><dd>{{vm.project.haryanadomicile}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Non Haryana Domicile">Non Haryana Domicile</span> :</b></dt><dd>{{vm.project.nonharyanadomicile}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Site Address">Site Address</span> :</b></dt><dd>{{vm.project.siteaddress}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Foreign Direct Investment">Foreign Direct Investment</span> :</b></dt><dd>{{vm.project.foreign_investment !== null ? vm.project.foreign_investment : \'No\'}}</dd></dl><dl ng-show="vm.project.foreign_investment !== null" class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Country of Origin">Country of Origin</span>:</b></dt><dd>{{vm.project.countryname}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Power Load Requirement">Power Load Reuirement</span> :</b></dt><dd>{{vm.project.powerRequirement}}</dd></dl></div></div></div><div class="col-md-4"><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b data-translate="global.addcafnew.Personal Details">Personal Details</b></p></div><div class="panel-body"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Designation in the Firm">Designation in the Firm</span> :</b></dt><dd>{{vm.project.designation}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Applicant Name">Applicant Name</span> :</b></dt><dd>{{vm.project.firstname}} {{vm.project.middlename}} {{vm.project.lastname}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Contact Number">Contact Number</span> :</b></dt><dd>{{vm.project.mobilenumber}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Email">Email</span><dd>{{vm.project.emailprimary}}</dd></b></dt></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.PAN Number">PAN Number</span> :</b></dt><dd>{{vm.project.pan_number}}</dd></dl></div></div><div class="panel panel-primary"><div class="panel-heading"><p class="uk-card-title text-center" style="font-size: 18px"><b data-translate="global.addcafnew.Applicant Photo and Sign">Applicant Photo and Sign.</b></p></div><div class="panel-body"><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>CLU Required :</b></dt>--><!--<dd>{{vm.project.clurequired== true ? "Yes" : "No"}}</dd>--><!--</dl>--><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Block :</b></dt>--><!--<dd>{{vm.project.block}}</dd>--><!--</dl>--><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Applicant Photo">Applicant Photo</span> :</b></dt><dd class="thumbnail"><img ng-src="{{vm.investorphoto}}" style="height:150px; width: 150px"></dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Applicant Signature">Applicant Signature</span> :</b></dt><dd class="thumbnail"><img ng-src="{{vm.investorsign}}" style="width:30%;height:10%"></dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Place">place</span> :</b></dt><dd>{{vm.project.place}}</dd></dl></div></div></div><div class="col-md-4"><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b data-translate="global.addcafnew.LAND USE DETAILS">Land Use Details</b></p></div><div class="panel-body"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Industrial Estate">Industrial Estate</span> :</b></dt><dd>{{vm.project.industrialEstate !== null ? vm.project.industrialEstate : \'NA\'}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.Land Zone Use Type">Land Zone Use Type</span> :</b></dt><dd>{{vm.project.landzoneuse_type}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b><span data-translate="global.addcafnew.CLU Required">CLU Required</span> :</b></dt><dd>{{vm.project.clurequired== true ? "Yes" : "No"}}</dd></dl></div></div><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b data-translate="global.addcafnew.CAF Documents">CAF Documents</b></p></div><div class="panel-body" ng-repeat="cafattachment in vm.cafAttachments"><a href="" ng-click="vm.downloadFile(cafattachment.fileName)">{{cafattachment.docName}}</a></div></div></div></div>');
$templateCache.put('app/ProjectCompleteDetail/ProjectCompleteDetailRenewable.html','<div class="row"><jhi-alert-error></jhi-alert-error><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b>Mandatory Fields</b></p></div><div class="panel-body"><div class="row"><div class="col-md-4"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Applicant Name :</b></dt><dd>{{vm.project.firstname}} {{vm.project.middlename}} {{vm.project.lastname}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Email :</b></dt><dd>{{vm.project.emailprimary}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.emailsecondary}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>District :</b></dt><dd>{{vm.project.district}}</dd></dl><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Block Category :</b></dt>--><!--<dd>{{vm.project.blockCategory}}</dd>--><!--</dl>--></div><div class="col-md-4 panel-border"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Contact Number :</b></dt><dd>{{vm.project.mobilenumber}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.phonenumber}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Business Entity (M/s) :</b></dt><dd>{{vm.project.businessentity}}</dd></dl></div><div class="col-md-4 panel-border"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>place :</b></dt><dd>{{vm.project.place}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Applicant Signature :</b></dt><dd class="thumbnail"><img ng-src="{{vm.investorsign}}" style="width:30%;height:10%"></dd></dl></div></div></div></div></div>');
$templateCache.put('app/ProjectCompleteDetail/ProjectCompleteDetailShop.html','<div class="row"><jhi-alert-error></jhi-alert-error><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b>Mandatory Fields</b></p></div><div class="panel-body"><div class="row"><div class="col-md-4"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Applicant Name :</b></dt><dd>{{vm.project.firstname}} {{vm.project.middlename}} {{vm.project.lastname}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Email :</b></dt><dd>{{vm.project.emailprimary}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.emailsecondary}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Contact Number :</b></dt><dd>{{vm.project.mobilenumber}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.phonenumber}}</dd></dl></div><div class="col-md-4 panel-border"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Business Entity (M/s) :</b></dt><dd>{{vm.project.businessentity}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>District :</b></dt><dd>{{vm.project.district}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Block Category :</b></dt><dd>{{vm.project.blockCategory}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Total Proposed Project Area :</b></dt><dd>{{vm.project.totalproposedprojectarea}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Land Zone Use Type :</b></dt><dd>{{vm.project.landzoneuse_type}}</dd></dl></div><div class="col-md-4 panel-border"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Total Project Cost (in Crore) :</b></dt><dd>{{vm.project.total_project_cost}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Total Project Employment :</b></dt><dd>{{vm.project.totalpurposedemployment}}</dd></dl></div></div><div class="row panel-body col-md-offset-1"><div class="col-md-10"><div class="col-md-9"><label class="col-md-4">Applicant Signature:</label><div class="thumbnail col-md-7"><img ng-src="{{vm.investorsign}}" style="width:30%;height:10%"></div></div><div class="col-md-3"><label class="col-md-6">Place:</label><p class="col-md-6">{{vm.project.place}}</p></div></div></div></div></div></div>');
$templateCache.put('app/ProjectCompleteDetail/ProjectCompleteDetailTower.html','<div class="row"><jhi-alert-error></jhi-alert-error><div class="panel panel-primary"><div class="panel-heading"><p class="panel-title text-center" style="font-size: 18px"><b>Mandatory Fields</b></p></div><div class="panel-body"><div class="row"><div class="col-md-4"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Applicant Name :</b></dt><dd>{{vm.project.firstname}} {{vm.project.middlename}} {{vm.project.lastname}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Email :</b></dt><dd>{{vm.project.emailprimary}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.emailsecondary}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>District :</b></dt><dd>{{vm.project.district}}</dd></dl><!--<dl class="uk-description-list uk-description-list-divider">--><!--<dt style="font-size: 14px;"><b>Block Category :</b></dt>--><!--<dd>{{vm.project.blockCategory}}</dd>--><!--</dl>--></div><div class="col-md-4 panel-border"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Contact Number :</b></dt><dd>{{vm.project.mobilenumber}} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; {{vm.project.phonenumber}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Business Entity (M/s) :</b></dt><dd>{{vm.project.businessentity}}</dd></dl></div><div class="col-md-4 panel-border"><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>place :</b></dt><dd>{{vm.project.place}}</dd></dl><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 14px"><b>Applicant Signature :</b></dt><dd class="thumbnail"><img ng-src="{{vm.investorsign}}" style="width:30%;height:10%"></dd></dl></div></div></div></div></div>');
$templateCache.put('app/Gallery/gallery.html','<div class="container"><h2 class="text-center">Image Gallery</h2><div class="row"><div class="col-md-12 col-sm-12 col-xs-12"><div class="col-md-6"><img src="../../content/gallery/1000125180.jpg" alt="Loading...." class="img-responsive" ng-click="" style="cursor: pointer"></div><div class="col-md-6"><img src="../../content/gallery/1000125189.jpg" alt="Loading...." class="img-responsive" ng-click="" style="cursor: pointer"></div><div class="col-md-6"><img src="../../content/gallery/1000125186.jpg" alt="Loading...." class="img-responsive" ng-click="" style="cursor: pointer; height: 300px"></div><div class="col-md-6"><img src="../../content/gallery/1000125183.jpg" alt="Loading...." class="img-responsive" ng-click="" style="cursor: pointer; height: 300px"></div><!--            <div class="thumbnail">--><!--                <img src="../../content/gallery/1000125180.jpg" alt="{{img.title}}" class="img-responsive"--><!--                     ng-click="" style="cursor: pointer;">--><!--                <div class="caption text-center">--><!--                    <p></p>--><!--                </div>--><!--            </div>--></div></div></div>');
$templateCache.put('app/aai/aai-fillform.html','<form name="myForm" role="form" ng-submit="vm.saveFormFieldData()" method="POST"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">{{vm.departmentservice.departmentname}} : {{vm.departmentservice.serviceName}}</h4></div><div class="modal-body jumbotron"><div><p class="text-danger">* All fields are mandatory.</p></div><div ng-repeat="field in vm.serviceFormFieldData | orderBy : \'formfieldOrder\'" class="form-horizontal"><ng-form name="form"><!-- TEXT FIELDS --><div ng-if="field.formfieldtype==\'text\' && field.formfieldOrder != \'30\'" class="form-group"><label class="col-sm-4 control-label">{{field.formfieldName}}</label><div class="col-sm-6"><input type="{{ field.fieldType }}" id="{{field.id}}" ng-model="field.formfieldvalue" class="form-control" ng-change="vm.changeField(field)" required></div></div><!-- SELECT FIELDS --><div ng-if="field.formfieldtype==\'select\'" class="form-group"><label class="col-sm-4 control-label">{{field.formfieldName}}</label><div class="col-sm-6"><select ng-model="field.formfieldvalue" dynamic-name="field.id" ng-options="x for x in field.formtypeOption.split(\',\') " class="form-control" required><option value="">-- Select --</option></select></div></div><!-- LAVEL FIELDS --><div ng-if="field.formfieldtype==\'label\'" class="form-group alert alert-dismissible alert-danger"><div class="col-sm-11">{{field.formfieldName}}</div><div class="col-sm-1"><label class="col-sm-12 control-label" ng-model="field.formfieldvalue"></label></div><div class="col-sm-11" ng-if="field.formfieldOrder == \'19\'"><p>(e.g. 10 21 31.1)</p></div></div></ng-form></div></div><div class="panel panel-primary" ng-show="(vm.serviceformdocs.length>0)"><div class="panel-body"><div class="col-md-2" ng-repeat="serviceformdoc in vm.serviceformdocs"><a href="" ng-click="vm.downloadFile(serviceformdoc.downloadfilename,serviceformdoc.docname)">{{serviceformdoc.docname}}</a></div></div></div><div class="modal-body jumbotron"><div><p class="text-danger">* All files must be in pdf format.</p><p class="text-danger">* File size must not exceed more than 1mb.</p></div><jhi-alert-error></jhi-alert-error><div class="form-group"><div class="col-lg-12"><label class="control-label">Undertaking 1A</label></div><div class="col-lg-7"><input type="file" id="undertaking1a" class="form-control" file-model="vm.undertaking1a" accept="application/pdf"><p ng-show="vm.undertaking1a.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" class="btn btn-success" ng-disabled=" vm.undertaking1a==undefined || vm.undertaking1a==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadAAIFiles(\'undertaking1a\')"><span class="glyphicon glyphicon-open"></span> &nbsp Upload</button> <span ng-show="(vm.undertaking1aUploaded != undefined && vm.undertaking1aUploaded.length!=0)" class="glyphicon glyphicon-ok" aria-hidden="true">uploaded</span> <button ng-show="(vm.undertaking1aUploaded != undefined && vm.undertaking1aUploaded.length!=0)" type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(vm.undertaking1aUploaded.id,\'undertaking1auploaded\')"><span class="glyphicon glyphicon-remove-sign"></span></button></div><div class="form-group"><div class="col-lg-12"><label class="control-label">Site Elevation Certificate</label></div><div class="col-lg-7"><input type="file" id="elevation" class="form-control" file-model="vm.elevation" accept="application/pdf"><p ng-show="vm.elevation.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" id="elevationupload" class="btn btn-success" ng-disabled=" vm.elevation==undefined || vm.elevation==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadAAIFiles(\'elevation\')"><span class="glyphicon glyphicon-open"></span> &nbsp Upload</button> <span ng-show="(vm.elevationUploaded != undefined && vm.elevationUploaded.length!=0)" class="glyphicon glyphicon-ok" aria-hidden="true">uploaded</span> <button ng-show="(vm.elevationUploaded != undefined && vm.elevationUploaded.length!=0)" type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(vm.elevationUploaded.id,\'elevationuploaded\')"><span class="glyphicon glyphicon-remove-sign"></span></button></div><div class="form-group"><div class="col-lg-12"><label class="control-label">Site Coordinates Certificate (WGS84 datum)</label></div><div class="col-lg-7"><input type="file" id="coordinates" class="form-control" file-model="vm.coordinates" accept="application/pdf"><p ng-show="vm.coordinates.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" id="coordinateupload" class="btn btn-success" ng-disabled=" vm.coordinates==undefined || vm.coordinates==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadAAIFiles(\'coordinates\')"><span class="glyphicon glyphicon-open"></span> &nbsp Upload</button> <span ng-show="(vm.coordinatesUploaded != undefined && vm.coordinatesUploaded.length!=0)" class="glyphicon glyphicon-ok" aria-hidden="true">uploaded</span> <button ng-show="(vm.coordinatesUploaded != undefined && vm.coordinatesUploaded.length!=0)" type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(vm.coordinatesUploaded.id,\'coordinatesuploaded\')"><span class="glyphicon glyphicon-remove-sign"></span></button></div><div class="form-group"><div class="col-lg-12"><label class="control-label">Authorization Letter (In case application is not file by Owner/Lessee)</label></div><div class="col-lg-7"><input type="file" id="authorization" class="form-control" file-model="vm.authorization" accept="application/pdf"><p ng-show="vm.authorization.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" id="authorizationupload" class="btn btn-success" ng-disabled="vm.authorization==undefined || vm.authorization==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadAAIFiles(\'authorization\')"><span class="glyphicon glyphicon-open"></span> &nbsp Upload</button> <span ng-show="(vm.authorizationUploaded != undefined && vm.authorizationUploaded.length!=0)" class="glyphicon glyphicon-ok" aria-hidden="true">uploaded</span> <button ng-show="(vm.authorizationUploaded != undefined && vm.authorizationUploaded.length!=0)" type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(vm.authorizationUploaded.id,\'authorizationuploaded\')"><span class="glyphicon glyphicon-remove-sign"></span></button></div><div class="form-group"><div class="col-lg-12"><label class="control-label">Permission from Airport Operator (only if sites within Airport premises)</label></div><div class="col-lg-7"><input type="file" id="permission" class="form-control" file-model="vm.permission" accept="application/pdf"><p ng-show="vm.permission.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" id="permissionupload" class="btn btn-success" ng-disabled=" vm.permission==undefined || vm.permission==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadAAIFiles(\'permission\')"><span class="glyphicon glyphicon-open"></span> &nbsp Upload</button> <span ng-show="(vm.permissionUploaded != undefined && vm.permissionUploaded.length!=0)" class="glyphicon glyphicon-ok" aria-hidden="true">uploaded</span> <button ng-show="(vm.permissionUploaded != undefined && vm.permissionUploaded.length!=0)" type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(vm.permissionUploaded.id,\'permissionuploaded\')"><span class="glyphicon glyphicon-remove-sign"></span></button></div></div><div class="modal-footer"><button type="button" class="btn btn-default col-lg-offset-10" data-dismiss="modal" ng-click="vm.clear()">Clear</button> <button type="submit" class="btn btn-primary" ng-disabled="vm.isSaving"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/aboveGround/aboveGround-detail.html','<div class="container panel-body"><div class="row"><div class="col-md-12"><div id="outerdiv"><form name="editForm" role="form" ng-submit="vm.save()" show-validation><div class="row"><h4 class="col-md-4 control-label"><b>A. Details of the applicant licensee</b></h4><button ng-hide="vm.above_ground.isforwardedtodc" ng-click="vm.edit_form()" type="button" class="col-md-1 pull-right uk-button uk-button-danger" style="font-size: 12px"><span class="glyphicon glyphicon-pencil">&nbsp;</span>Edit</button> <button ui-sref="aboveGround" type="button" class="col-md-1 pull-right uk-button uk-button-primary" style="font-size: 12px"><span class="glyphicon glyphicon-arrow-left">&nbsp;</span>Back</button></div><div class="col-md-offset-1 row"><div class="form-group" ng-show="vm.above_ground.id" hidden><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.above_ground.id" readonly="readonly"></div><div class="col-md-5 form-group"><label class="control-label" for="field_name_applicant">Name of Applicant *</label><input ng-disabled="isDisabled" placeholder="Enter Your Name Here" type="text" class="form-control" name="name_applicant" id="field_name_applicant" ng-model="vm.above_ground.name_applicant" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_registered_address">Registered Address *</label><textarea ng-disabled="isDisabled" type="text" class="form-control" name="registered_address" id="field_registered_address" ng-model="vm.above_ground.registered_address" rows="3" required></textarea></div><div class="col-md-5 form-group"><label class="control-label" for="field_har_office_address">Haryana Circle office Address *</label><textarea ng-disabled="isDisabled" type="text" class="form-control" name="har_office_address" id="field_har_office_address" ng-model="vm.above_ground.har_office_address" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_name_auth_person">Name of the Authorized Person *</label><input ng-disabled="isDisabled" placeholder="Enter Name Here" type="text" class="form-control" name="name_auth_person" id="field_name_auth_person" ng-model="vm.above_ground.name_auth_person" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_designation_auth_person">Designation of the Authorized Person *</label><input ng-disabled="isDisabled" placeholder="Enter Designation here" type="text" class="form-control" name="designation_auth_person" id="field_designation_auth_person" ng-model="vm.above_ground.designation_auth_person" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_phone_auth_person">Phone/Mobile no. of the Authorized Person *</label><input ng-disabled="isDisabled" placeholder="Enter Phone/Mobile no. Here" type="text" ng-pattern="/^[0-9]*$/" class="form-control" name="phone_auth_person" id="field_phone_auth_person" minlength="10" maxlength="10" ng-model="vm.above_ground.phone_auth_person" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_email_auth_person">Email of the Authorized Person *</label><input ng-disabled="isDisabled" placeholder="example@domain.com" type="email" class="form-control" name="email_auth_person" id="field_email_auth_person" ng-model="vm.above_ground.email_auth_person" required></div></div><div class="row"><div class="col-md-6"><h4 class="control-label"><b>B.</b><div class="uk-margin-left" uk-form-custom="target: > * > span:last-child"><select ng-click="vm.extent()" class="form-control" name="extent" id="field_extent" ng-model="vm.above_ground.extent"><option value="Installation on land">Installation on land</option><option value="Installation on Building (Private/Government)">Installation on Building (Private/Government)</option></select><span class="uk-link"><span class="glyphicon glyphicon-pencil"></span> <span></span></span></div></h4></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label ng-show="vm.above_ground.extent ==\'Installation on land\'" class="control-label" for="field_address_line_1">Plot No./Khasara No. *</label><label ng-show="vm.above_ground.extent ==\'Installation on Building (Private/Government)\'" class="control-label" for="field_address_line_1">Name of building/structure *</label><input ng-disabled="isDisabled" placeholder="" type="text" class="form-control" name="address_line_1" id="field_address_line_1" ng-model="vm.above_ground.address_line_1" required></div><div class="col-md-5 form-group"><label ng-show="vm.above_ground.extent ==\'Installation on land\'" for="field_address_line_2">Road/Street *</label><label ng-show="vm.above_ground.extent ==\'Installation on Building (Private/Government)\'" class="control-label" for="field_address_line_2">Height and stories of building *</label><input ng-disabled="isDisabled" type="text" class="form-control" name="address_line_2" id="field_address_line_2" ng-model="vm.above_ground.address_line_2" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label ng-show="vm.above_ground.extent ==\'Installation on land\'" class="control-label" for="field_address_line_3">Ward no. & name of colony *</label><label ng-show="vm.above_ground.extent ==\'Installation on Building (Private/Government)\'" class="control-label" for="field_address_line_3">Area of the building/structure *</label><input ng-disabled="isDisabled" type="text" class="form-control" name="address_line_3" id="field_address_line_3" ng-model="vm.above_ground.address_line_3" required></div><div class="col-md-5 form-group"><label ng-show="vm.above_ground.extent ==\'Installation on land\'" class="control-label" for="field_address_line_4">City/Town or name of revenue village *</label><label ng-show="vm.above_ground.extent ==\'Installation on Building (Private/Government)\'" class="control-label" for="field_address_line_4">Complete address of the building/structure *</label><input ng-disabled="isDisabled" type="text" class="form-control" name="address_line_4" id="field_address_line_4" ng-model="vm.above_ground.address_line_4" required></div></div><div class="col-md-offset-1 row"><div ng-show="vm.above_ground.extent ==\'Installation on land\'" class="col-md-5 form-group"><label class="control-label" for="field_tehsil">Tehsil *</label><input ng-disabled="isDisabled" placeholder="Enter Tehsil Here" type="text" class="form-control" name="tehsil" id="field_tehsil" ng-model="vm.above_ground.tehsil"></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_district">District *</label><select ng-disabled="isDisabled" placeholder="Enter District Here" type="text" class="form-control" name="district" id="field_district" ng-model="vm.above_ground.district" required><option value="" disabled="disabled">--- Select District ---</option><option ng-repeat="option in vm.districts">{{option.districtname}}</option></select></div><div class="col-md-5 form-group"><label class="control-label" for="field_latitude_longitude">Exact Latitude and Longitude of the Proposed Site *</label><input ng-disabled="isDisabled" type="text" class="form-control" name="latitude_longitude" id="field_latitude_longitude" ng-model="vm.above_ground.latitude_longitude" required></div></div><h4 class="control-label"><b>C. Name and address of the owner of the land or building</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_owner_name">Name of Owner *</label><input ng-disabled="isDisabled" placeholder="Enter Name Here" type="text" class="form-control" name="owner_name" id="field_owner_name" ng-model="vm.above_ground.owner_name" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_owner_address">Address of Owner *</label><textarea ng-disabled="isDisabled" placeholder="Enter Address Here" type="text" class="form-control" name="owner_address" id="field_owner_address" ng-model="vm.above_ground.owner_address" rows="3" required></textarea></div></div><h4 class="control-label"><b>D. Name of the Zone under which this area is falling *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><select ng-disabled="isDisabled" placeholder="Enter Zone Name Here" type="text" class="form-control" name="zone_area" id="field_zone_area" ng-model="vm.above_ground.zone_area" required><option value="" disabled="disabled">--- Select Zone ---</option><option ng-repeat="zone in vm.zones">{{zone.zone_name}}</option></select></div></div><h4 class="control-label"><b>E. Details of the proposed Tower/Post</b></h4><div class="col-md-offset-1 row"><div class="col-md-4 form-group"><label class="control-label" for="field_tower_height">Height(In meters) *</label><input ng-disabled="isDisabled" placeholder="Enter Tower Height" type="text" ng-pattern="/^[0-9]*$/" class="form-control" name="tower_height" id="field_tower_height" ng-model="vm.above_ground.tower_height" required></div><div class="col-md-offset-1 col-md-4 form-group"><label class="control-label" for="field_tower_weight">Weight(In kg) *</label><input ng-disabled="isDisabled" placeholder="Enter Tower Weight" type="text" ng-pattern="/^[0-9]*$/" class="form-control" name="tower_weight" id="field_tower_weight" ng-model="vm.above_ground.tower_weight" required></div></div><div class="col-md-offset-1 row"><div class="col-md-4 form-group"><label class="control-label" for="field_tower_type1">Ground/Roof Top Tower *</label><select ng-disabled="isDisabled" class="form-control" name="tower_type1" id="field_tower_type1" ng-model="vm.above_ground.tower_type1" required><option value="" disabled="disabled">--- Select Type ---</option><option value="Ground">Ground Tower</option><option value="Roof Top">Roof Top Tower</option></select></div><div class="col-md-offset-1 col-md-4 form-group"><label class="control-label" for="field_tower_type2">Pole/wall mounted *</label><select ng-disabled="isDisabled" class="form-control" name="tower_type1" id="field_tower_type2" ng-model="vm.above_ground.tower_type2 " required><option value="" disabled="disabled">--- Select Type ---</option><option value="Pole">Pole mounted</option><option value="wall">Wall mounted</option></select></div></div><div class="col-md-offset-1 row"><div class="col-md-4 form-group"><label class="control-label" for="field_tower_type3">Whether proposed on an open plot/building *</label><select ng-disabled="isDisabled" class="form-control" name="tower_type2" id="field_tower_type3" ng-model="vm.above_ground.tower_type3" required><option value="" disabled="disabled">--- Select Type ---</option><option value="Open Plot">Open Plot</option><option value="Building">Building</option></select></div><div class="col-md-offset-1 col-md-4 form-group"><label class="control-label" for="field_tower_antena_no">Number of Antenna *</label><input ng-disabled="isDisabled" placeholder="Enter no. of Antenna\'s" type="text" ng-pattern="/^[0-9]*$/" class="form-control" name="tower_antena_no" id="field_tower_antena_no" ng-model="vm.above_ground.tower_antena_no" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_tower_lat_long">Exact Latitude & Longitude of the Tower/Post *</label><input ng-disabled="isDisabled" type="text" class="form-control" name="tower_lat_long" id="field_tower_lat_long" ng-model="vm.above_ground.tower_lat_long" required></div></div><h4 class="control-label"><b>F. Other related information *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><!--<label class="control-label"  for="field_other_info1"></label>--><textarea ng-disabled="isDisabled" placeholder="The mode of and the time duration for execution of the work" type="text" class="form-control" name="other_info1" id="field_other_info1" ng-model="vm.above_ground.other_info1" rows="3" required></textarea></div><div class="col-md-5 form-group"><!--<label class="control-label" for="field_other_info2">The inconvenience that is likely to be caused to the public and the specific measure to be taken to mitigate such--><!--inconvenience</label>--><textarea ng-disabled="isDisabled" placeholder="The inconvenience that is likely to be caused to the public and the specific measure to be taken to mitigate such\n                    inconvenience" type="text" class="form-control" name="other_info2" id="field_other_info2" ng-model="vm.above_ground.other_info2" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><!--<label class="control-label" for="field_other_info3">The measures proposed to be taken to ensure public safety during the execution of the work</label>--><textarea ng-disabled="isDisabled" placeholder="The measures proposed to be taken to ensure public safety during the execution of the work" type="text" class="form-control" name="other_info3" id="field_other_info3" ng-model="vm.above_ground.other_info3" rows="3" required></textarea></div><div class="col-md-5 form-group"><!--<label class="control-label" for="field_other_info4">Other Info 4</label>--><textarea ng-disabled="isDisabled" placeholder="The names and contact details of the employees of the licensee for the purpose of communication in regard to the\n                   application made" type="text" class="form-control" name="other_info4" id="field_other_info4" ng-model="vm.above_ground.other_info4" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><!--<label class="control-label" for="field_other_info5">Other Info 5</label>--><textarea ng-disabled="isDisabled" placeholder="Any other matter relevant, in the opinion of the licensee, connected with or relative to the work proposed to be\n                       undertaken" type="text" class="form-control" name="other_info5" id="field_other_info5" ng-model="vm.above_ground.other_info5" rows="3" required></textarea></div><div class="col-md-5 form-group"><!--<label class="control-label" for="field_other_info6">Other Info 6</label>--><textarea ng-disabled="isDisabled" placeholder="Any other matter specified by the DoT or State Govt. or the local body" type="text" class="form-control" name="other_info6" id="field_other_info6" ng-model="vm.above_ground.other_info6" rows="3" required></textarea></div></div><h4 class="control-label"><b>G. Details of fee and charges deposited *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><!--<label class="control-label" data-translate="investhryApp.above_ground.fee_details" for="field_fee_details">Fee Details</label>--><textarea ng-disabled="isDisabled" placeholder="Enter Fee Details Here" type="text" class="form-control" name="fee_details" id="field_fee_details" ng-model="vm.above_ground.fee_details" rows="3" required> </textarea></div></div><div id="documentdiv"><h4 class="control-label"><b>H. Documents (Mandatory)</b></h4><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" ng-show="vm.show" ng-show="vm.show" class="col-md-3"><input type="file" ng-show="vm.show" class="form-conocument1" id="field_document1" file-model="vm.document1" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_document1">A copy of the license/registration certificate granted by the Department of Telecommunication (DoT) Ministry of communication Government of India.</label></div><div class="col-md-2"><button ng-disabled="vm.document1==null" type="button" ng-show="vm.show" ng-click="vm.upload(1,vm.document1)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-click="vm.download(vm.above_ground.document1,\'document1\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload1" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" ng-show="vm.show" ng-show="vm.show" class="col-md-3"><input type="file" ng-show="vm.show" class="form-conocument2" id="field_document2" file-model="vm.document2" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_document2">Location Plan (Scale 1:1000) showing the site with reference to the surrounding existing developments</label></div><div class="col-md-2"><button ng-disabled="vm.document2==null" type="button" ng-show="vm.show" ng-click="vm.upload(2,vm.document2)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-click="vm.download(vm.above_ground.document2,\'document2\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload2" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" ng-show="vm.show" ng-show="vm.show" class="col-md-3"><input type="file" ng-show="vm.show" class="form-conocument3" id="field_document3" file-model="vm.document3" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_document3">The detailed technical design and drawings of the tower/post or other aboveground infrastructure including the specification of foundation. In case the tower /post etc. is in the vicinity or adjoining to high or low tension line, then its distance from the same shall be clearly indicated in the drawings</label></div><div class="col-md-2"><button ng-disabled="vm.document3==null" type="button" ng-show="vm.show" ng-click="vm.upload(3,vm.document3)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-click="vm.download(vm.above_ground.document3,\'document3\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload3" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" ng-show="vm.show" ng-show="vm.show" class="col-md-3"><input type="file" ng-show="vm.show" class="form-conocument4" id="field_document4" file-model="vm.document4" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_document4">Copy of certification of the technical design and Structural Stability/safety certificate for the building and tower/post as per sub para 10.3 of para 10 of the policy (Prescribed Format)</label></div><div class="col-md-2"><button ng-disabled="vm.document4==null" type="button" ng-show="vm.show" ng-click="vm.upload(4,vm.document4)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-click="vm.download(vm.above_ground.document4,\'document4\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload4" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" ng-show="vm.show" ng-show="vm.show" class="col-md-3"><input type="file" ng-show="vm.show" class="form-conocument5" id="field_document5" file-model="vm.document5" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_document5">Time schedule (Stretch-wise) for completion of the work.</label></div><div class="col-md-2"><button ng-disabled="vm.document5==null" type="button" ng-show="vm.show" ng-click="vm.upload(5,vm.document5)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-click="vm.download(vm.above_ground.document5,\'document5\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload5" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" ng-show="vm.show" ng-show="vm.show" class="col-md-3"><input type="file" ng-show="vm.show" class="form-concument6" id="field_document6" file-model="vm.document6" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_document6">Copy of the type test certificate issued by Automotive Research Association of India (ARAI) to the manufactures of the DG sets, in case DG is to be installed</label></div><div class="col-md-2"><button ng-disabled="vm.document6==null" type="button" ng-show="vm.show" ng-click="vm.upload(6,vm.document6)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-click="vm.download(vm.above_ground.document6,\'document6\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload6" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" ng-show="vm.show" ng-show="vm.show" class="col-md-3"><input type="file" ng-show="vm.show" class="form-conocument7" id="field_document7" file-model="vm.document7" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_document7">Attested copy of lease Agreement Deed/Consent Agreement Deed, signed by the applicant and the owner of the site/building</label></div><div class="col-md-2"><button ng-disabled="vm.document7==null" type="button" ng-show="vm.show" ng-click="vm.upload(7,vm.document7)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-click="vm.download(vm.above_ground.document7,\'document7\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload7" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" ng-show="vm.show" ng-show="vm.show" class="col-md-3"><input type="file" ng-show="vm.show" class="form-conocument8" id="field_document8" file-model="vm.document8" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_document8">Copy of SACFA clearance/copy of SACFA application for the said location submitted to Wireless Planning & Coordination (WPC) wing of DoT with registration number as WPC acknowledgement along with undertaking that in case of any objection/rejection, licensee will take corrective actions/remove the tower.</label></div><div class="col-md-2"><button ng-disabled="vm.document8==null" type="button" ng-show="vm.show" ng-click="vm.upload(8,vm.document8)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-click="vm.download(vm.above_ground.document8,\'document8\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload8" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="document9" id="field_document9" file-model="vm.document9" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_document9">Acknowledgement receipt issued by TERM Cell of the self-certificate submitted by Applicant in respect of mobile tower/Base Transceiver Station (BTS) establishing/ certifying that all general public areas around the tower will be within safe Electro Magnetic Radiation (EMR) exposure limit as per peak traffic measurement after the antennas starts radiating. *{Note: - It can be submitted within 30 days after radiating the tower}.</label></div><div class="col-md-2"><button ng-disabled="vm.document9==null" type="button" ng-show="vm.show" ng-click="vm.upload(9,vm.document9)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-click="vm.download(vm.above_ground.document9,\'document9\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload9" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="document10" id="field_document10" file-model="vm.document10" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_document10">Indemnity bond to indemnify the Government/ Local Body/ Authority in the prescribed format against (i) any liability for the damage caused to the infrastructure laid by the applicant for any reasons, and (ii) claims against any accidents on account of the infrastructure laid/ facilities installed or against any claims thereafter during the period of Operation & Maintenance of such infrastructure at all times</label></div><div class="col-md-2"><button ng-disabled="vm.document10==null" type="button" ng-show="vm.show" ng-click="vm.upload(10,vm.document10)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-click="vm.download(vm.above_ground.document10,\'document10\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload10" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="document11" id="field_document11" file-model="vm.document11" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_document11">Undertaking as per Appendix-7 (prescribed format)</label></div><div class="col-md-2"><button ng-disabled="vm.document11==null" type="button" ng-show="vm.show" ng-click="vm.upload(11,vm.document11)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-click="vm.download(vm.above_ground.document11,\'document11\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload11" class="uk-label">Uploaded</span></div></div></div><h4 class="control-label"><b>H. Documents (Optional)</b></h4><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="other_document1" id="field_other_document1" file-model="vm.document12" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_other_document1">For Forest/Protected Areas, the copy of clearance from State Environment & Forest Department, if applicable.</label></div><div class="col-md-2"><button ng-disabled="vm.document12==null" type="button" ng-show="vm.show" ng-click="vm.upload(12,vm.document12)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-hide="vm.above_ground.other_document1===null" ng-click="vm.download(vm.above_ground.other_document1,\'otherdocument1\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload12" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="other_document2" id="field_other_document2" file-model="vm.document13" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_other_document2">Fire NOC</label></div><div class="col-md-2"><button ng-disabled="vm.document13==null" type="button" ng-show="vm.show" ng-click="vm.upload(13,vm.document13)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-hide="vm.above_ground.other_document2===null" ng-click="vm.download(vm.above_ground.other_document2,\'other_document2\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload13" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="other_document3" id="field_other_document3" file-model="vm.document14" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_other_document3">Ownership document of the building/site. (Attested copy)</label></div><div class="col-md-2"><button ng-disabled="vm.document14==null" type="button" ng-show="vm.show" ng-click="vm.upload(14,vm.document14)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-hide="vm.above_ground.other_document3===null" ng-click="vm.download(vm.above_ground.other_document3,\'other_document4\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload14" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="other_document4" id="field_other_document4" file-model="vm.document15" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_other_document4">Copy of no objection certificate issued by the Fire Safety Department in case of high rise buildings where fire clearance is mandatory</label></div><div class="col-md-2"><button ng-disabled="vm.document15==null" type="button" ng-show="vm.show" ng-click="vm.upload(15,vm.document15)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-hide="vm.above_ground.other_document4===null" ng-click="vm.download(vm.above_ground.other_document4,\'other_document4\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload15" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="other_document5" id="field_other_document5" file-model="vm.document16" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_other_document5">In case the permission is sought in the land/premises of any office of Central Government or a PSU of Central Government, the prior written consent copy of agreement from the authority having legitimate right over the land/premises shall be attached with the application.</label></div><div class="col-md-2"><button ng-disabled="vm.document16==null" type="button" ng-show="vm.show" ng-click="vm.upload(16,vm.document16)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-show="!vm.show" ng-hide="vm.above_ground.other_document5===null" ng-click="vm.download(vm.above_ground.other_document5,\'other_document5\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload16" class="uk-label">Uploaded</span></div></div></div><div ng-show="vm.show" class="modal-footer"><button type="submit" ng-disabled="vm.isSaving" class="uk-button uk-button-primary uk-button-large" style="font-size: 14px"><span class="glyphicon glyphicon-save"></span>&nbsp;Save</button></div></div></form></div></div></div></div>');
$templateCache.put('app/aboveGround/aboveGround-dialog.html','<!--<jhi-alert-error></jhi-alert-error novalidate>--><div class="container panel-body"><div class="row"><div class="col-md-12"><div ng-show="!vm.show1"><form name="editForm" role="form" ng-submit="vm.save()" show-validation><h4 class="control-label"><b>A. Details of the applicant licenseessss</b></h4><div class="col-md-offset-1 row"><div class="form-group" ng-show="vm.above_ground.id" hidden><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.above_ground.id" readonly="readonly"></div><div class="col-md-5 form-group"><label class="control-label" for="field_name_applicant">Name of Applicanttt *</label><input placeholder="Enter Your Name Here" type="text" class="form-control" name="name_applicant" id="field_name_applicant" ng-model="vm.above_ground.name_applicant" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_registered_address">Registered Address *</label><textarea type="text" class="form-control" name="registered_address" id="field_registered_address" ng-model="vm.above_ground.registered_address" rows="3" required></textarea></div><div class="col-md-5 form-group"><label class="control-label" for="field_har_office_address">Haryana Circle office Address *</label><textarea type="text" class="form-control" name="har_office_address" id="field_har_office_address" ng-model="vm.above_ground.har_office_address" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_name_auth_person">Name of the Authorized Person *</label><input placeholder="Enter Name Here" type="text" class="form-control" name="name_auth_person" id="field_name_auth_person" ng-model="vm.above_ground.name_auth_person" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_designation_auth_person">Designation of the Authorized Person *</label><input placeholder="Enter Designation here" type="text" class="form-control" name="designation_auth_person" id="field_designation_auth_person" ng-model="vm.above_ground.designation_auth_person" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_phone_auth_person">Phone/Mobile no. of the Authorized Person *</label><input placeholder="Enter Phone/Mobile no. Here" type="number" class="form-control" name="phone_auth_person" id="field_phone_auth_person" ng-model="vm.above_ground.phone_auth_person" minlength="10" maxlength="10" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_email_auth_person">Email of the Authorized Person *</label><input placeholder="example@domain.com" type="email" class="form-control" name="email_auth_person" id="field_email_auth_person" ng-model="vm.above_ground.email_auth_person" required></div></div><div class="row"><div class="col-md-6"><h4 class="control-label"><b>B.</b><div class="uk-margin-left" uk-form-custom="target: > * > span:last-child"><select ng-click="vm.extent()" class="form-control" name="extent" id="field_extent" ng-model="vm.above_ground.extent"><option value="Installation on land">Installation on land</option><option value="Installation on Building (Private/Government)">Installation on Building (Private/Government)</option></select><span class="uk-link"><span class="glyphicon glyphicon-pencil"></span> <span></span></span></div></h4></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label ng-show="!vm.show" class="control-label" for="field_address_line_1">Plot No./Khasara No. *</label><label ng-show="vm.show" class="control-label" for="field_address_line_1">Name of building/structure *</label><input placeholder="" type="text" class="form-control" name="address_line_1" id="field_address_line_1" ng-model="vm.above_ground.address_line_1" required></div><div class="col-md-5 form-group"><label ng-show="!vm.show" class="control-label" for="field_address_line_2">Road/Street *</label><label ng-show="vm.show" class="control-label" for="field_address_line_2">Height and stories of building *</label><input type="text" class="form-control" name="address_line_2" id="field_address_line_2" ng-model="vm.above_ground.address_line_2" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label ng-show="!vm.show" class="control-label" for="field_address_line_3">Ward no. & name of colony *</label><label ng-show="vm.show" class="control-label" for="field_address_line_3">Area of the building/structure *</label><input type="text" class="form-control" name="address_line_3" id="field_address_line_3" ng-model="vm.above_ground.address_line_3" required></div><div class="col-md-5 form-group"><label ng-show="!vm.show" class="control-label" for="field_address_line_4">City/Town or name of revenue village *</label><label ng-show="vm.show" class="control-label" for="field_address_line_4">Complete address of the building/structure *</label><input type="text" class="form-control" name="address_line_4" id="field_address_line_4" ng-model="vm.above_ground.address_line_4" required></div></div><div class="col-md-offset-1 row"><div ng-show="!vm.show" class="col-md-5 form-group"><label class="control-label" for="field_tehsil">Tehsil *</label><input placeholder="Enter Tehsil Here" type="text" class="form-control" name="tehsil" id="field_tehsil" ng-model="vm.above_ground.tehsil"></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_district">District *</label><select placeholder="Enter District Here" type="text" class="form-control" name="district" id="field_district" ng-model="vm.above_ground.district" required><option value="" disabled="disabled">--- Select District ---</option><option ng-repeat="option in vm.districts">{{option.districtname}}</option></select></div><div class="col-md-5 form-group"><label class="control-label" for="field_latitude_longitude">Exact Latitude and Longitude of the Proposed Site *</label><input type="text" class="form-control" name="latitude_longitude" id="field_latitude_longitude" ng-model="vm.above_ground.latitude_longitude" required></div></div><h4 class="control-label"><b>C. Name and address of the owner of the land or building</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_owner_name">Name of Owner *</label><input placeholder="Enter Name Here" type="text" class="form-control" name="owner_name" id="field_owner_name" ng-model="vm.above_ground.owner_name" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_owner_address">Address of Owner *</label><textarea placeholder="Enter Address Here" type="text" class="form-control" name="owner_address" id="field_owner_address" ng-model="vm.above_ground.owner_address" rows="3" required></textarea></div></div><h4 class="control-label"><b>D. Name of the Zone under which this area is falling *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><select placeholder="Enter Zone Name Here" type="text" class="form-control" name="zone_area" id="field_zone_area" ng-model="vm.above_ground.zone_area" required><option value="" disabled="disabled">--- Select Zone ---</option><option ng-repeat="zone in vm.zones">{{zone.zone_name}}</option></select></div></div><h4 class="control-label"><b>E. Details of the proposed Tower/Post</b></h4><div class="col-md-offset-1 row"><div class="col-md-4 form-group"><label class="control-label" for="field_tower_height">Height (In <b>meters</b>) *</label><input placeholder="Enter Tower Height" type="number" class="form-control" name="tower_height" id="field_tower_height" ng-model="vm.above_ground.tower_height" required></div><div class="col-md-offset-1 col-md-4 form-group"><label class="control-label" for="field_tower_weight">Weight (In <b>kg</b>) *</label><input placeholder="Enter Tower Weight" type="number" class="form-control" name="tower_weight" id="field_tower_weight" ng-model="vm.above_ground.tower_weight" required></div></div><div class="col-md-offset-1 row"><div class="col-md-4 form-group"><label class="control-label" for="field_tower_type1">Ground/Roof Top Tower *</label><select class="form-control" name="tower_type1" id="field_tower_type1" ng-model="vm.above_ground.tower_type1" required><option value="" disabled="disabled">--- Select Type ---</option><option value="Ground">Ground Tower</option><option value="Roof Top">Roof Top Tower</option></select></div><div class="col-md-offset-1 col-md-4 form-group"><label class="control-label" for="field_tower_type2">Pole/wall mounted *</label><select class="form-control" name="tower_type1" id="field_tower_type2" ng-model="vm.above_ground.tower_type2 " required><option value="" disabled="disabled">--- Select Type ---</option><option value="Pole">Pole mounted</option><option value="wall">Wall mounted</option></select></div></div><div class="col-md-offset-1 row"><div class="col-md-4 form-group"><label class="control-label" for="field_tower_type3">Whether proposed on an open plot/building *</label><select class="form-control" name="tower_type2" id="field_tower_type3" ng-model="vm.above_ground.tower_type3" required><option value="" disabled="disabled">--- Select Type ---</option><option value="Open Plot">Open Plot</option><option value="Building">Building</option></select></div><div class="col-md-offset-1 col-md-4 form-group"><label class="control-label" for="field_tower_antena_no">Number of Antenna *</label><input placeholder="Enter no. of Antenna\'s" type="number" class="form-control" name="tower_antena_no" id="field_tower_antena_no" ng-model="vm.above_ground.tower_antena_no" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_tower_lat_long">Exact Latitude & Longitude of the Tower/Post *</label><input type="text" class="form-control" name="tower_lat_long" id="field_tower_lat_long" ng-model="vm.above_ground.tower_lat_long" required></div></div><h4 class="control-label"><b>F. Other related information *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><!--<label class="control-label"  for="field_other_info1"></label>--><textarea placeholder="The mode of and the time duration for execution of the work" type="text" class="form-control" name="other_info1" id="field_other_info1" ng-model="vm.above_ground.other_info1" rows="3" required></textarea></div><div class="col-md-5 form-group"><!--<label class="control-label" for="field_other_info2">The inconvenience that is likely to be caused to the public and the specific measure to be taken to mitigate such--><!--inconvenience</label>--><textarea placeholder="The inconvenience that is likely to be caused to the public and the specific measure to be taken to mitigate such\n                    inconvenience" type="text" class="form-control" name="other_info2" id="field_other_info2" ng-model="vm.above_ground.other_info2" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><!--<label class="control-label" for="field_other_info3">The measures proposed to be taken to ensure public safety during the execution of the work</label>--><textarea placeholder="The measures proposed to be taken to ensure public safety during the execution of the work" type="text" class="form-control" name="other_info3" id="field_other_info3" ng-model="vm.above_ground.other_info3" rows="3" required></textarea></div><div class="col-md-5 form-group"><!--<label class="control-label" for="field_other_info4">Other Info 4</label>--><textarea placeholder="The names and contact details of the employees of the licensee for the purpose of communication in regard to the\n                   application made" type="text" class="form-control" name="other_info4" id="field_other_info4" ng-model="vm.above_ground.other_info4" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><!--<label class="control-label" for="field_other_info5">Other Info 5</label>--><textarea placeholder="Any other matter relevant, in the opinion of the licensee, connected with or relative to the work proposed to be\n                       undertaken" type="text" class="form-control" name="other_info5" id="field_other_info5" ng-model="vm.above_ground.other_info5" rows="3" required></textarea></div><div class="col-md-5 form-group"><!--<label class="control-label" for="field_other_info6">Other Info 6</label>--><textarea placeholder="Any other matter specified by the DoT or State Govt. or the local body" type="text" class="form-control" name="other_info6" id="field_other_info6" ng-model="vm.above_ground.other_info6" rows="3" required></textarea></div></div><h4 class="control-label"><b>G. Details of fee and charges deposited *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><!--<label class="control-label" data-translate="investhryApp.above_ground.fee_details" for="field_fee_details">Fee Details</label>--><textarea placeholder="Enter Fee Details Here" type="text" class="form-control" name="fee_details" id="field_fee_details" ng-model="vm.above_ground.fee_details" rows="3" required> </textarea></div></div><div class="modal-footer"><button type="submit" ng-disabled="vm.isSaving" class="uk-button uk-button-primary uk-button-large" style="font-size: 14px">Next&nbsp;&nbsp;<span class="glyphicon glyphicon-forward"></span></button></div></form></div><div ng-show="vm.show1"><form name="editForm" role="form" ng-submit="vm.onsubmit()" show-validation><h4 class="control-label"><b>H. Documents (Mandatory)</b></h4><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="document1" id="field_document1" file-model="vm.document1" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div><div class="col-md-7"><label class="control-label" for="field_document1">A copy of the license/registration certificate granted by the Department of Telecommunication (DoT) Ministry of communication Government of India.</label></div><div class="col-md-2"><button ng-disabled="vm.document1==null" type="button" ng-click="vm.upload(1,vm.document1)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload1" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="document2" id="field_document2" file-model="vm.document2" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div><div class="col-md-7"><label class="control-label" for="field_document2">Location Plan (Scale 1:1000) showing the site with reference to the surrounding existing developments</label></div><div class="col-md-2"><button ng-disabled="vm.document2==null" type="button" ng-click="vm.upload(2,vm.document2)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload2" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="document3" id="field_document3" file-model="vm.document3" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div><div class="col-md-7"><label class="control-label" for="field_document3">The detailed technical design and drawings of the tower/post or other aboveground infrastructure including the specification of foundation. In case the tower /post etc. is in the vicinity or adjoining to high or low tension line, then its distance from the same shall be clearly indicated in the drawings</label></div><div class="col-md-2"><button ng-disabled="vm.document3==null" type="button" ng-click="vm.upload(3,vm.document3)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload3" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="document4" id="field_document4" file-model="vm.document4" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div><div class="col-md-7"><label class="control-label" for="field_document4">Copy of certification of the technical design and Structural Stability/safety certificate for the building and tower/post as per sub para 10.3 of para 10 of the policy (Prescribed Format)</label></div><div class="col-md-2"><button ng-disabled="vm.document4==null" type="button" ng-click="vm.upload(4,vm.document4)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload4" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="document5" id="field_document5" file-model="vm.document5" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div><div class="col-md-7"><label class="control-label" for="field_document5">Time schedule (Stretch-wise) for completion of the work.</label></div><div class="col-md-2"><button ng-disabled="vm.document5==null" type="button" ng-click="vm.upload(5,vm.document5)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload5" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-contro-file" name="document6" id="field_document6" file-model="vm.document6" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div><div class="col-md-7"><label class="control-label" for="field_document6">Copy of the type test certificate issued by Automotive Research Association of India (ARAI) to the manufactures of the DG sets, in case DG is to be installed</label></div><div class="col-md-2"><button ng-disabled="vm.document6==null" type="button" ng-click="vm.upload(6,vm.document6)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload6" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="document7" id="field_document7" file-model="vm.document7" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div><div class="col-md-7"><label class="control-label" for="field_document7">Attested copy of lease Agreement Deed/Consent Agreement Deed, signed by the applicant and the owner of the site/building</label></div><div class="col-md-2"><button ng-disabled="vm.document7==null" type="button" ng-click="vm.upload(7,vm.document7)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload7" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="document8" id="field_document8" file-model="vm.document8" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div><div class="col-md-7"><label class="control-label" for="field_document8">Copy of SACFA clearance/copy of SACFA application for the said location submitted to Wireless Planning & Coordination (WPC) wing of DoT with registration number as WPC acknowledgement along with undertaking that in case of any objection/rejection, licensee will take corrective actions/remove the tower.</label></div><div class="col-md-2"><button ng-disabled="vm.document8==null" type="button" ng-click="vm.upload(8,vm.document8)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload8" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="document9" id="field_document9" file-model="vm.document9" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div><div class="col-md-7"><label class="control-label" for="field_document9">Acknowledgement receipt issued by TERM Cell of the self-certificate submitted by Applicant in respect of mobile tower/Base Transceiver Station (BTS) establishing/ certifying that all general public areas around the tower will be within safe Electro Magnetic Radiation (EMR) exposure limit as per peak traffic measurement after the antennas starts radiating. *{Note: - It can be submitted within 30 days after radiating the tower}.</label></div><div class="col-md-2"><button ng-disabled="vm.document9==null" type="button" ng-click="vm.upload(9,vm.document9)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload9" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="document10" id="field_document10" file-model="vm.document10" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div><div class="col-md-7"><label class="control-label" for="field_document10">Indemnity bond to indemnify the Government/ Local Body/ Authority in the prescribed format against (i) any liability for the damage caused to the infrastructure laid by the applicant for any reasons, and (ii) claims against any accidents on account of the infrastructure laid/ facilities installed or against any claims thereafter during the period of Operation & Maintenance of such infrastructure at all times</label></div><div class="col-md-2"><button ng-disabled="vm.document10==null " type="button" ng-click="vm.upload(10,vm.document10)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload10" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="document11" id="field_document11" file-model="vm.document11" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div><div class="col-md-7"><label class="control-label" for="field_document11">Undertaking as per Appendix-7 (prescribed format)</label></div><div class="col-md-2"><button ng-disabled="vm.document11==null " type="button" ng-click="vm.upload(11,vm.document11)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload11" class="uk-label">Uploaded</span></div></div></div><h4 class="control-label"><b>H. Documents (Optional)</b></h4><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="other_document1" id="field_other_document1" file-model="vm.document12" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_other_document1">Forest Permission</label></div><div class="col-md-2"><button ng-disabled="vm.document12==null " type="button" ng-click="vm.upload(12,vm.document12)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload12" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="other_document2" id="field_other_document2" file-model="vm.document13" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_other_document2">For Forest/Protected Areas, the copy of clearance from State Environment & Forest Department, if applicable.</label></div><div class="col-md-2"><button ng-disabled="vm.document13==null " type="button" ng-click="vm.upload(13,vm.document13)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload13" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="other_document3" id="field_other_document3" file-model="vm.document14" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_other_document3">Ownership document of the building/site. (Attested copy)</label></div><div class="col-md-2"><button ng-disabled="vm.document14==null " type="button" ng-click="vm.upload(14,vm.document14)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload14" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="other_document4" id="field_other_document4" file-model="vm.document15" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_other_document4">Copy of no objection certificate issued by the Fire Safety Department in case of high rise buildings where fire clearance is mandatory</label></div><div class="col-md-2"><button ng-disabled="vm.document15==null " type="button" ng-click="vm.upload(15,vm.document15)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload15" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="other_document5" id="field_other_document5" file-model="vm.document16" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div><div class="col-md-7"><label class="control-label" for="field_other_document5">In case the permission is sought in the land/premises of any office of Central Government or a PSU of Central Government, the prior written consent copy of agreement from the authority having legitimate right over the land/premises shall be attached with the application.</label></div><div class="col-md-2"><button ng-disabled="vm.document16==null " type="button" ng-click="vm.upload(16,vm.document16)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload16" class="uk-label">Uploaded</span></div></div></div><div class="modal-footer"><button type="submit" ng-disabled="vm.isSaving" class="uk-button uk-button-primary uk-button-large" style="font-size: 14px"><span class="glyphicon glyphicon-save"></span>&nbsp;Save</button></div></form></div></div></div></div><div id="modal-above2" class="uk-modal-container" uk-modal><div class="uk-modal-dialog uk-modal-body" uk-overflow-auto><button class="uk-modal-close-default" type="button" uk-close></button><div><h3>Document (Mandatory)</h3><p>1. A copy of the license/registration certificate granted by the Department of Telecommunication (DoT) Ministry of communication Government of India.</p><p>2. Location Plan (Scale 1:1000) showing the site with reference to the surrounding existing developments</p><p>3. The detailed technical design and drawings of the tower/post or other aboveground infrastructure including the specification of foundation. In case the tower /post etc. is in the vicinity or adjoining to high or low tension line, then its distance from the same shall be clearly indicated in the drawings</p><p>4. Copy of certification of the technical design and Structural Stability/safety certificate for the building and tower/post as per sub para 10.3 of para 10 of the policy (Prescribed Format)</p><p>5. Time schedule (Stretch-wise) for completion of the work.</p><p>6. Copy of the type test certificate issued by Automotive Research Association of India (ARAI) to the manufactures of the DG sets, in case DG is to be installed</p><p>7. Attested copy of lease Agreement Deed/Consent Agreement Deed, signed by the applicant and the owner of the site/building.</p><p>8. Copy of SACFA clearance/copy of SACFA application for the said location submitted to Wireless Planning & Coordination (WPC) wing of DoT with registration number as WPC acknowledgement along with undertaking that in case of any objection/rejection, licensee will take corrective actions/remove the tower.</p><p>9. Acknowledgement receipt issued by TERM Cell of the self-certificate submitted by Applicant in respect of mobile tower/Base Transceiver Station (BTS) establishing/ certifying that all general public areas around the tower will be within safe Electro Magnetic Radiation (EMR) exposure limit as per peak traffic measurement after the antennas starts radiating. *{Note: - It can be submitted within 30 days after radiating the tower}.</p><p>10. Indemnity bond to indemnify the Government/ Local Body/ Authority in the prescribed format against (i) any liability for the damage caused to the infrastructure laid by the applicant for any reasons, and (ii) claims against any accidents on account of the infrastructure laid/ facilities installed or against any claims thereafter during the period of Operation & Maintenance of such infrastructure at all times.</p><p>11. Undertaking as per Appendix-7 (prescribed format)</p><h3>Document (Optional)</h3><p>1. For Forest/Protected Areas, the copy of clearance from State Environment & Forest Department, if applicable.</p><p>2. Fire NOC</p><p>3. Ownership document of the building/site. (Attested copy)</p><p>4. Copy of no objection certificate issued by the Fire Safety Department in case of high rise buildings where fire clearance is mandatory</p><p>5. In case the permission is sought in the land/premises of any office of Central Government or a PSU of Central Government, the prior written consent copy of agreement from the authority having legitimate right over the land/premises shall be attached with the applicatio</p></div><div class="uk-text-right"><button class="uk-button uk-button-primary uk-modal-close" type="button" style="font-size: 12px">Proceed</button></div></div></div>');
$templateCache.put('app/aboveGround/aboveGround.html','<!--<jhi-alert></jhi-alert>--><div class="container-fluid panel-body"><div class="row"><div class="col-md-12"><div class="col-md-5 col-md-offset-1"><button class="uk-button uk-margin-left uk-button-primary uk-button-large" style="font-size: 14px" ui-sref="aboveGround-dialog({isNew: \'new\'})">Request a New Above Ground Tower Installtion</button></div><div class="col-md-5"><button class="uk-button uk-button-primary uk-button-large" style="font-size: 14px" ui-sref="aboveGround-dialog({isNew: \'existing\'})">Request for permission of already installed tower</button></div></div></div><br><div class="row"><div class="col-md-12"><table class="jh-table table table-striped"><thead><tr><th><span>Name of Applicant</span></th><th><span>Name of Authorized Person</span></th><th><span>Designation of Authorized Person</span></th><th><span>Phone of Authorized Person</span></th><th><span>Email of Authorized Person</span></th><th><span>Extent</span></th><th>Form Filled Complete/Partial</th><th><span>Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="above_ground in vm.above_grounds track by above_ground.id"><td>{{above_ground.name_applicant}}</td><td>{{above_ground.name_auth_person}}</td><td>{{above_ground.designation_auth_person}}</td><td>{{above_ground.phone_auth_person}}</td><td>{{above_ground.email_auth_person}}</td><td>{{above_ground.extent}}</td><td><span ng-show="above_ground.isfullyfilled == true" class="uk-label uk-label-default" style="font-size: 12px">Complete</span> <span ng-show="above_ground.isfullyfilled == false" class="uk-label uk-label-danger" style="font-size: 12px">Partial</span></td><td><span ng-show="above_ground.status == \'Pending\'" class="uk-label uk-label-warning" style="font-size: 12px">Pending</span> <span ng-show="above_ground.status == \'Rejected\'" class="uk-label uk-label-danger" style="font-size: 12px">Rejected</span> <span ng-show="above_ground.status == \'Cleared\'" class="uk-label uk-label-default" style="font-size: 12px">Cleared</span></td><td><div class="uk-inline"><button class="uk-button uk-button-primary" type="button" style="font-size: 12px">Action</button><div uk-dropdown="mode: click"><ul class="uk-nav uk-dropdown-nav" style="font-size: 14px"><li><a ui-sref="aboveGround-detail({id:above_ground.id})">View Form</a></li><li><a ng-click="vm.comment(above_ground)" uk-toggle="target: #modal_above3">Comment</a></li><li><a ng-click="vm.view_log(above_ground.id)" uk-toggle="target: #modal_above1">View Log</a></li><li><a ng-show="above_ground.clearancefile3" ng-click="vm.dowload_dialog(above_ground.clearancefile1,above_ground.clearancefile2,above_ground.clearancefile3)" uk-toggle="target: #modal_above4">Clearance Files</a></li></ul></div></div></td></tr></tbody></table></div></div></div><div id="modal_above1" uk-modal><div class="uk-modal-dialog"><button class="uk-modal-close-default" type="button" uk-close></button><div class="uk-modal-header"><h2 class="uk-modal-title">Log</h2></div><div class="uk-modal-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Action</span></th><th><span>Action By</span></th><th><span>Comment</span></th><!--<th><span>Tower Id</span></th>--><th><span>Action Date</span></th></tr></thead><tbody><tr ng-repeat="tower_log in vm.towerLog track by tower_log.id"><td>{{tower_log.action}}</td><td>{{tower_log.action_by}}</td><td>{{tower_log.comment}}</td><!--<td>{{tower_log.tower_id}}</td>--><td>{{tower_log.action_date | date:\'medium\'}}</td></tr></tbody></table></div></div><div class="uk-modal-footer uk-text-right"><button class="uk-button uk-button-danger uk-modal-close" type="button" style="font-size: 12px">Close</button></div></div></div><div id="modal_above3" uk-modal bg-close="false"><div class="uk-modal-dialog"><form name="editForm" role="form" ng-submit="vm.save()" show-validation><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h2 class="uk-modal-title">Comment on {{vm.name_applicant}} \'s Form . . .</h2></div><div class="uk-modal-body"><textarea ng-model="vm.tower_log.comment" class="uk-textarea" rows="5" name="comment" id="comment" required></textarea></div><div class="uk-text-right uk-modal-footer"><!--<button type="button" class="uk-button uk-button-danger uk-modal-close" style="font-size: 12px">Close</button>--> <button type="submit" class="uk-button uk-button-primary" style="font-size: 12px">Comment</button></div></form></div></div><div id="modal_above4" uk-modal><div class="uk-modal-dialog uk-margin-auto-vertical uk-modal-body"><div><button class="uk-modal-close-outside" type="button" uk-close></button><h2 class="uk-modal-title text-center"><b>Choose File to Downlad</b></h2></div><div><div class="row"><div class="col-md-4 text-center"><label for="download1">Clearance File 1:</label><button id="download1" type="button" ng-click="vm.download(1,\'clearancefile1\')" class="uk-button uk-button-primary" style="font-size: 14px">Download</button></div><div class="col-md-4 text-center"><label for="download2">Clearance File 2:</label><button id="download2" type="button" ng-click="vm.download(2,\'clearancefile2\')" class="uk-button uk-button-primary" style="font-size: 14px">Download</button></div><div class="col-md-4 text-center"><label for="download3">Clearance File 3:</label><button id="download3" type="button" ng-click="vm.download(3,\'clearancefile3\')" class="uk-button uk-button-primary" style="font-size: 14px">Download</button></div></div></div><!--<div class="uk-text-right uk-modal-footer">--><!--<button type="button" class="uk-button uk-button-danger uk-modal-close" style="font-size: 12px">Close</button>--><!--</div>--></div></div>');
$templateCache.put('app/acceptance/acceptance.html','<div ng-cloak><div class="panel panel-warning"><div class="panel-heading"><h3 class="panel-title">NOTE: Kindly make sure that all the attachments are clear and readable before uploading.</h3></div><div class="panel-body"><div class="col-md-12 row"><div class="col-md-1"><p>I.</p></div><div class="col-md-11">Please scan following Attachment as PDF file. The size of each file must be less than 4 MB. You can use software like Free PDF Compressor for compression of pdf file.</div></div><div class="col-md-12"><table class="table table-striped table-hover"><thead><tr><th>SNo</th><th>CAF Documents</th></tr></thead><tbody><tr><td>1.</td><td>Memorandum of Undertaking (1.2)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Signed with State Government</label></td></tr><tr><td>2.</td><td>Directors/Partners/MDs/CEO List Attachment (4.4.2)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Enclosed list of directors with DIN numbers</label></td></tr><tr><td>3.</td><td>PAN Card Attachment (4.5.2a)</td></tr><tr><td>4.</td><td>AADHAR Card Attachment (4.5.2b)</td></tr><tr><td>5.</td><td>Tin / Vat Number Certificate (4.6.2)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* in case of Expansion</label></td></tr><tr><td>6.</td><td>CST Number Attachment (4.7.2)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* in case of Expansion</label></td></tr><tr><td>7.</td><td>MoA/Partnership Deed Attachment (4.8)</td></tr><tr><td>8.</td><td>Certificate of Incorporation/Partnership firm Registration Certificate (4.9)</td></tr><tr><td>9.</td><td>Khasra Number Attachment (5.8)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Enclosed list of table of masteel, khasra numbers &amp; respective area in K-M for which CLU is required</label><br><a target="_blank" href="/Content/documents/SampleForms/Sample_Khasranumbers_details_Required.pdf">Khasra Number Specimen</a></td></tr><tr><td>10.</td><td>Revenue/Shajra Plan Attachment (5.10)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Revenue plan Superimposed by the area in possession for which CLU is required</label></td></tr><tr><td>11.</td><td>Jamabandi Attachment (5.11)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Should not be older than 15 days from Date of Application</label></td></tr><tr><td>12.</td><td>Non Encumbrance Certificate Attachment (5.12)</td></tr><tr><td>13.</td><td>Certified Copy of Ownership Attachment (5.15.2)</td></tr><tr><td>14.</td><td>Certified Copy of Lease Document Attachment (5.16.2)<br></td></tr><tr><td>15.</td><td>Certified Copy of Land Agreement Attachment (5.17.2)</td></tr><tr><td>16.</td><td>Site/Layout Plan Attachment (5.18)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Map showing dimensions &amp; directions of project site with entry/exit</label></td></tr><tr><td>17.</td><td>Location Plan Attachment (5.19)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Map showing all major natural features &amp; establishments in surroundings of 500mtr of site &amp; connecting road</label></td></tr><tr><td>18.</td><td>Linear Strip Plan Attachment (5.20)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Map showing the width of entry / exit gate and its distance from the connecting NH/SH/SR/Other road</label><br><a target="_blank" href="/Content/documents/SampleForms/Specimen_of_linear_strip_plan.pdf">Linear strip Specimen</a></td></tr><tr><td>19.</td><td>If Site situated on National Highway/Scheduled Road, attach permission from competent authority (5.19.3)</td></tr><tr><td>20.</td><td>Detailed Project Report (6.6)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Should also contain applicable manufacturing/service process flow chart list of machineries; list of products/services; list of raw materials</label></td></tr><tr><td>21.</td><td>If Obtained Regulatory Approval Granted Attachment (6.7.2)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Such as CLU, CTE, CTO, Building Plan etc</label></td></tr><tr><td>22.</td><td>Details of EDC / SIF / CLU / Fee Paid Attachment (6.9.2)</td></tr><tr><td>23.</td><td>Manufacturing Process Flow Attachment (11.2)</td></tr><tr><td>24.</td><td>Waste Water Treatment Attachment (12.2)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Enclosed annexure for details</label></td></tr><tr><td>25.</td><td>Existing Electricity Bill (13.2)<br><label style="font-size:11px;font-style:italic;font-weight:normal">* Enclose electricity bill copy in case of existing connection (only in case of expansion)</label></td></tr></tbody></table></div><div class="col-md-12 row"><div class="col-md-1"><p>II.</p></div><div class="col-md-11"><p style="font-weight:bold">Please scan following photos as .JPG file. The size of each file must be less than 4 MB</p><ol style="line-height:25px"><li>Applicant Photo</li><li>Applicant Signature</li></ol></div></div><div class="col-md-12 row"><div class="col-md-1"><p>III.</p></div><div class="col-md-11"><p style="font-weight:bold">FCI (sum of Land Cost, Building Cost, Plant &amp; Machinery Cost and Miscellaneous Fixed Assets Cost) must be<br></p><ol><li>Greater than Rs. 10 Cr. for Empowerment Committee</li><li>Less than Rs. 10 Cr. for District</li></ol><p></p></div></div><div class="col-md-12 row"><div class="col-md-1"><p>IV.</p></div><div class="col-md-11"><p style="font-weight:bold">An application by a Partnership firm, Company or a Trust/Society shall be accompanied by following documents:</p><ol style="line-height: 25px;text-align:justify"><li>An attested copy of the partnership deed signed by all the partners or by a partner authorized to sign by other partners through a Special Power of Attorney duly notarized.</li><li>A private or a public limited company, shall while submitting an application furnish certified copies (by the Chartered Accountant of the Company) of its Memorandum of Association / Articles of Association, incorporation certificate and the resolution of the Board of Directors in favour of the person authorized to sign the A&amp;A form for UHBVN/DHBVN and other documents. The signatures of the authorized signatory shall also bear the common seal of the company. The names of members of the Board of Directors and their residential addresses shall also be furnished. The consumer shall intimate every change in the Board of Directors within one month.</li><li>An application by a Trust or a Society shall be accompanied by a certified copy of its constitution, its bye laws along with resolution in favour of the authorized signatory for signing the A&amp;A form for UHBVN/DHBVN and other documents. The names of the managing body of the Trust or Society and their residential addresses shall also be furnished. The consumer shall intimate every change in the managing body of the Trust or Society within one month.</li></ol></div></div><div class="col-md-12"><button type="submit" ui-sref="addproject" class="btn btn-info">Start Filling Comprehensive Application Format</button></div></div></div></div>');
$templateCache.put('app/activateuser/activateuser.html','<div class="container"><form name="userForm"><div class="row form-group"><div class="col-sm-4 col-sm-offset-2"><input type="text" name="userinfo" class="form-control" ng-model="vm.id" placeholder="Enter user\'s ID" required></div><div class="btn-group col-sm-4"><button type="submit" class="btn btn-info" ng-disabled="userForm.userinfo.$invalid" ng-click="vm.getUser(vm.id)">Search</button></div></div><br></form><br><jhi-alert-error></jhi-alert-error><div class="table-responsive" ng-hide="vm.user==undefined"><table class="table table-striped"><thead><tr><th><span>ID</span></th><th><span>Login</span></th><th><span>Email</span></th><th></th><th><span>Lang Key</span></th><th><span>Profiles</span></th><th><span>Create Date</span></th><th><span>Update Date</span></th><th></th></tr></thead><tbody><tr><td><a ui-sref="user-management-detail({login:user.login})">{{vm.user.id}}</a></td><td>{{vm.user.login}}</td><td>{{vm.user.email}}</td><td><span class="label label-danger hand" ng-show="!vm.user.activated">Deactivated</span> <span class="label label-success hand" ng-show="vm.user.activated">Activated</span></td><td>{{vm.user.langKey}}</td><td><div ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{vm.user.createDate | date:\'medium\'}}</td><td>{{vm.user.updateDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" class="btn btn-info btn-sm" ng-show="!vm.user.activated" ng-click="vm.activate()">Activate</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/addproject/ProjectTypeRenew.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Servies</h4></div><div class="modal-body"><pre>\n      <b>DEPARTMENT OF INDUSTRIES & COMMERCE</b>\n         Renewal Under Boiler Act\n\n      <b>HARYANA STATE POLLUTION CONTROL BOARD</b>\n         Renewal of Consent to Operate - Air-Water\n         Renewal of CTE\n\n      <b>LABOUR DEPARTMENT - FACTORY WING</b>\n         Renewal Factory registration or license\n\n      <b>LABOUR DEPARTMENT - LABOUR WING</b>\n         Registration certificate of Establishment Inter State Migrant Worker men\n         Registration of Principal Employers\n\n</pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/addproject/ProjectypeNewEnterprise.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Servies</h4></div><div class="modal-body"><pre>\n      <b>LABOUR DEPARTMENT - FACTORY WING</b>\n         Approval of factory plan\n         Factory registration or license\n         Registration under The Building and Other Construction Workers Act\n         Renewal Factory registration or license\n\n      <b>LABOUR DEPARTMENT - LABOUR WING</b>\n         License for contractor under provision of Contract Labour\n         Registration certificate of Establishment Inter State Migrant Worker men\n         Registration of Principal Employers\n\n      <b>HARYANA STATE POLLUTION CONTROL BOARD</b>\n         Authorization under Bio Medical Waste\n         Authorization under e-Waste\n         Authorization Under Hazardous Waste Rules\n         Consent to Operate - Air-Water\n         CTE\n         CTE-Renewal\n         Registration under plastic manufacture, sale and usage\n         Renewal of Consent to Operate - Air-Water\n\n      <b>DAKSHIN HARYANA BIJLI VITRAN NIGAM</b>\n         Approval For Regular Electricity Connection (DHBVN)\n         Approval For Temporary Electricity Connection (DHBVN)\n\n      <b>UTTAR HARYANA BIJLI VITRAN NIGAM</b>\n         Approval For Regular Electricity Connection (UHBVN)\n         Approval For Temporary Electricity Connection (UHBVN)\n\n      <b>TOWN & COUNTRY PLANNING</b>\n         Application for Licence to Establish Kiln\n         Approval of Building plan\n         Change of Land Use under Controlled Area\n         Licence for Industrial Plotted Colony\n         NOC for establishment of unit under Urban Area Act\n         NOC for unit falling outside controlled or urban area\n         Occupation or Completion Certificate (Form BR-IVB)\n\n      <b>URBAN LOCAL BODIES</b>\n         Application for New Fire Fighting Scheme\n         Approval of Building plan\n         Change of Land Use under MC Limit\n         Issuance of sewerage connection\n         Issuance of Trade License under section 330\n         Issuance of Water connection\n         NOC for Fire Service\n         Occupation or Completion Certificate (Form BR-IVB)\n         Water and Sewer\n\n      <b>HARYANA URBAN DEVELOPMENT AUTHORITY</b>\n         Approval of Building plan\n         Occupation or Completion Certificate (Form BR-IVB)\n         Sewarage Connection\n         Water Connection-Permanent\n         Water Connection-Temporary\n\n      <b>HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD</b>\n         Approval of Building plan\n         Issuance of sewerage connection\n         Occupation or Completion Certificate (Form BR-IVA) - Institutional and Commercial\n         Occupation or Completion Certificate (Form BR-IVB) - Industrial\n         Release of permanent water connection\n\n      <b>DEPARTMENT OF INDUSTRIES & COMMERCE</b>\n         Lubricating License for Manufacturing\n         Registration under Boiler Act\n         Lubricating License for Trading\n         Renewal Under Boiler Act\n\n      <b>CHIEF ELECTRICAL INSPECTOR</b>\n         NOC Application for Height Clearance\n         Certificate of Transmission Lines Upto 33KV (Form - B2)\n         Certification of Electrical Installation above 33kv (Form-A1)\n         Certification of Transmission-lines above 33kv (Fom - B1 )\n\n      <b>DEPARTMENT OF FORESTS & WILDLIFE</b>\n         Application for Tree Felling\n         Forest NOC/Clarification/Forest Clearance\n\n      <b>DEPARTMENT OF RENEWABLE ENERGY</b>\n         Registration and Approval for Setting of Biomass Based Power Project\n\n      <b>ENVIRONMENT</b>\n         Environment Clearance under Aravali Notification dated 07.05.1992\n\n      <b>FOOD & SUPPLIES DEPARTMENT</b>\n         Issuance of New Licence Dealer\n         Issuance of New Licence Manufacturer\n         Issuance of New Licence Repairer\n         Licence for brick kiln\n\n      <b>Food and Drug Administration</b>\n         Drug License for Allopathic Medicine\n         Drug manufacturing license for biological & non biological drugs\n\n      <b>MINES & GEOLOGY DEPARTMENT</b>\n         Licence for stone crashers\n         Permit for manufacturing of bricks\n\n      <b>National Monument Authority</b>\n         NMA Clearance\n\n      <b>PUBLIC HEALTH ENGINEERING DEPARTMENT</b>\n         Issuance of permanent water connection\n         Issuance of sewerage connection\n\n      <b>PWD (B & R) DEPARTMENT</b>\n         Clearance for entry or exit from State Highway or Scheduled road under MORT&H guidelines\n\n      <b>Airport Authority of India</b>\n         Certificate of Electrical Installation upto 33KV (Form -A2)\n\n      <b>DEPARTMENT OF AGRICULTURE</b>\n         Application form for fertilizer manufacture certificate\n         Licence to Manufacture Insecticides\n\n      <b>DEPARTMENT OF AYUSH</b>\n         Drug License for Ayurvedic Medicine\n\n</pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/addproject/addproject.html','<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.3/jquery.min.js"></script><script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/js/bootstrap.min.js"></script><div class="container"><!--<jhi-alert></jhi-alert>--><form ng-submit="vm.saveCompleteProjectDetail(\'Final\')" name="myform" novalidate><div class="panel-group" id="accordion"><div class="panel panel-default"><!--<div class="alert alert-dismissible alert-danger">--><!--<strong>Note:- Only {{vm.numberoffields}} fields are compulsary(Marked with * ).</strong>--><!--</div>--><div class="panel-heading"><h4 class="panel-title"><button type="button" class="btn btn-primary" data-dpmaxz-eid="12" ng-click="vm.saveCompleteProjectDetail(\'Draft\')" ng-disabled="myform.$invalid || file.maxSizeError">Save Draft</button></h4></div><div id="mandatory"><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Mandatory Fields</legend><div class="form-group"><label class="col-lg-2 control-label">Applicant Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-pattern="/^[a-zA-Z]*$/" ng-model="vm.investor.firstname" name="firstname" placeholder="First Name" data-dpmaxz-eid="20" required><div ng-show="myform.firstname.$invalid && myform.firstname.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="middlename" ng-model="vm.investor.middlename" placeholder="Middle Name" data-dpmaxz-eid="20"></div><div class="col-lg-3"><input type="text" class="form-control" id="lastname" placeholder="Last Name" data-dpmaxz-eid="20" ng-model="vm.investor.lastname"></div></div><div class="form-group"><label for="email1" class="col-lg-2 control-label">Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email1" placeholder="Primary Email" ng-model="vm.investor.emailprimary" required><div ng-show="myform.input.$invalid && myform.input.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="email2" placeholder="Secondary Email" ng-model="vm.investor.emailsecondary"></div></div><div class="form-group"><label class="col-lg-2 control-label">Contact Number<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.investor.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" required><div ng-show="myform.mobileno.$invalid && myform.mobileno.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="phonenumber" placeholder="Phone Number" ng-model="vm.investor.phonenumber"></div></div><div class="form-group"><label for="businessentity" class="col-lg-2 control-label" ng-hide="vm.renewproject">Business Entity (M/s)<span style="color:red">*</span></label><div class="col-lg-3" ng-hide="vm.renewproject"><input type="text" class="form-control" id="businessentity" ng-disabled="vm.renewproject" placeholder="Enter Business Entity" ng-model="vm.companydetail.businessentity" required></div><label for="district" class="col-lg-2 control-label">District<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="district" ng-model="vm.projectsitedetail.selectedDistrict" ng-options="district.districtname for district in vm.districts | orderBy:\'districtname\'" ng-change="vm.changePowerCompany()" required><option value="">Select District</option></select></div></div><div class="form-group" ng-hide="vm.renewproject"><label class="col-lg-2 control-label">Total Proposed Project Area<span style="color:red">*</span></label><div class="col-lg-8"><div class="col-lg-2"><input type="number" class="form-control" name="acres" placeholder="Acres" ng-disabled="vm.renewproject" ng-model="vm.project_area_in_acres" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeinAcres()" min="0" required><div ng-show="myform.acres.$invalid && myform.acres.$touched || myform.acres.$error.min"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">acres</small><div class="col-lg-2"><input type="number" class="form-control" name="kanal" placeholder="Kanals" ng-model="vm.project_area_in_kanal" ng-disabled="vm.renewproject" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeinKanal()" min="0" max="7" required><div ng-show="myform.kanal.$invalid && myform.kanal.$touched || myform.kanal.$error.min && !myform.kanal.$error.max"><small style="color:red; display:block;text-align:left">Invalid Input</small></div><div ng-show="myform.kanal.$error.max"><small style="color:red; display:block;text-align:left">value cannot be more than 7</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">kanal</small><div class="col-lg-3"><input type="number" class="form-control" name="marla" placeholder="Marlas" ng-model="vm.project_area_in_marla" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-disabled="vm.renewproject" ng-change="vm.changeInMarla()" min="0" max="19" required><div ng-show="myform.marla.$invalid && myform.marla.$touched || myform.marla.$error.min && !myform.marla.$error.max"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div><div ng-show="myform.marla.$error.max"><small style="color:red; display:block;text-align:left">value cannot be more than 19</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">marla</small></div></div><div class="form-group" ng-hide="vm.renewproject || vm.landrequired"><label class="col-lg-2 control-label">Land Zone Use Type<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" name="landzonetype" ng-model="vm.projectsitedetail.selectedLandZoneUseType" ng-options="landzoneclassificationtype.landzoneclassificationtype for landzoneclassificationtype in vm.landusezoneclassifications" required><option value="">Select Land Zone</option></select></div></div><div class="form-group" ng-hide="vm.renewproject && !vm.shopcaf"><label class="col-lg-2 control-label">Total Project Cost (in Crore) <span style="color:red">*</span></label><div class="col-lg-8"><div class="col-lg-2"><input type="number" class="form-control" name="croresCost" placeholder="Crores" ng-model="vm.project_cost_in_crore" ng-pattern="/^[0-9]*$/" ng-change="vm.changeInCrore()" min="0" required><div ng-show="myform.croresCost.$invalid && myform.croresCost.$touched || myform.croresCost.$error.min"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-2"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.project_cost_in_lacs" ng-pattern="/^[0-9]*$/" ng-change="vm.changeInLacs()" min="0" max="99" required><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-3"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.project_cost_in_thousands" ng-pattern="/^[0-9]*$/" ng-change="vm.changeInThousands()" min="0" max="99" required><div ng-show="myform.thousandsCost.$invalid && myform.thousandsCost.$touched || myform.thousandsCost.$error.min"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div></div><label class="col-lg-2 control-label" ng-hide="vm.renewproject && !vm.shopcaf">Total Project Employement <span style="color:red">*</span></label><div class="col-lg-3" ng-hide="vm.renewproject && !vm.shopcaf"><input type="number" class="form-control" id="totalemplotment" placeholder="0" ng-model="vm.project_finance_investment.totalpurposedemployment" min="0" required></div><div class="form-group" ng-hide="vm.renewproject || vm.landrequired"><div><label class="col-lg-2 control-label">CLU Required</label><div class="col-lg-2"><input type="checkbox" name="checkConfirmityoflanduse" ng-model="vm.projectsitedetail.clurequired"></div></div><div><h6><i>*Check if CLU is required.</i></h6></div></div></fieldset></div></div></div></div><div class="panel panel-default" ng-show="vm.landrequired"><div class="panel-heading"><h4 class="panel-title">Land Requirement Details</h4></div><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Land Requirement Details</legend><div class="form-group"><label class="col-md-2 control-label">Land Required<span style="color: red">*</span></label><div class="col-md-3"><select class="form-control" ng-model="vm.landrequirementcaf.landrequired" ng-options="x for x in vm.landrequiredoptions" ng-required="vm.landrequired"><option value="">Select</option></select></div></div><div class="form-group"><label class="col-md-2 control-label">Plot Size<span style="color: red">*</span></label><div class="col-md-3"><input type="number" class="form-control" placeholder="Plot Size" ng-model="vm.landrequirementcaf.plotsize" ng-required="vm.landrequired"></div><p class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">sq. yards</p></div><div ng-show="vm.landrequirementcaf.landrequired==\'In Industrial Estate/Area\'"><div class="form-group"><label class="col-md-2 control-label">Agency Name<span style="color: red">*</span></label><div class="col-md-3"><select class="form-control" ng-model="vm.landrequirementcaf.agencyname" ng-options="x  for x in vm.agencies" ng-required="vm.landrequirementcaf.landrequired==\'In Industrial Estate/Area\'"><option value="">Select</option></select></div></div><div class="form-group"><label class="col-md-2 control-label">Name of Industrial Estate/Location<span style="color: red">*</span></label><div class="col-md-3"><input type="text" class="form-control" placeholder="Name of Industrial Estate/Location" ng-model="vm.landrequirementcaf.estatename" ng-required="vm.landrequirementcaf.landrequired==\'In Industrial Estate/Area\'"></div></div></div><div ng-show="vm.landrequirementcaf.landrequired==\'Outside Developed Industrial Estate/Area\'"><div class="form-group"><label class="col-md-2 control-label">Expected Purchase Rate/ SQ. Mtr<span style="color: red">*</span></label><div class="col-md-3"><input type="number" class="form-control" placeholder="Expected Purchase Rate" ng-model="vm.landrequirementcaf.purchaserate" ng-required="vm.landrequirementcaf.landrequired==\'Outside Developed Industrial Estate/Area\'"></div></div><legend>Location</legend><div class="form-group"><label class="col-md-2 control-label">Village<span style="color: red">*</span></label><div class="col-md-3"><input type="text" class="form-control" placeholder="Village" ng-model="vm.landrequirementcaf.village" ng-required="vm.landrequirementcaf.landrequired==\'Outside Developed Industrial Estate/Area\'"></div></div><div class="form-group"><label class="col-md-2 control-label">Tehsil<span style="color: red">*</span></label><div class="col-md-3"><input type="text" class="form-control" placeholder="Tehsil" ng-model="vm.landrequirementcaf.tehsil" ng-required="vm.landrequirementcaf.landrequired==\'Outside Developed Industrial Estate/Area\'"></div></div><div class="form-group"><label class="col-md-2 control-label">District<span style="color: red">*</span></label><div class="col-md-3"><input type="text" class="form-control" placeholder="District" ng-model="vm.landrequirementcaf.district" ng-required="vm.landrequirementcaf.landrequired==\'Outside Developed Industrial Estate/Area\'"></div></div><div class="form-group"><label class="col-md-2 control-label">Land Use Type<span style="color: red">*</span></label><div class="col-md-3"><select class="form-control" ng-model="vm.landrequirementcaf.landusetype" ng-options="x for x in vm.landusetypes" ng-required="vm.landrequirementcaf.landrequired==\'Outside Developed Industrial Estate/Area\'"><option value="">Select</option></select></div></div></div><div class="col-md-offset-2"><a target="_blank" href="http://hsiidc.org.in/sites/default/files/E%20Documents/Estate%20Availability.pdf">HSIIDC Plots Availability</a></div></fieldset></div></div></div><div class="panel panel-default" ng-hide="vm.renewproject || vm.landrequired"><div class="panel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-parent="#accordion" href=".invt">Investor</a></h4></div><div id="invt"><div class="panel-body"><div class="form-horizontal"><fieldset><div class="form-group"><label class="col-lg-2 control-label">Mou Applicable</label><div class="col-lg-10"><label><input type="checkbox" name="ismouapplicable" ng-model="vm.investor.mouapplicable"> Applicable</label></div></div><div class="form-group"><label class="col-lg-2 control-label">Country</label><div class="col-lg-3"><select class="form-control" ng-model="vm.investor.selectedCountry" ng-options="country.countryname for country in vm.countries track by country.id" id="country.id" value="country.countryname" ng-change="loadStates(vm.investor.selectedCountry)"></select></div></div><div class="form-group"><label class="col-lg-2 control-label">State</label><div class="col-lg-3"><select class="form-control" ng-model="vm.investor.selectedState" ng-options="state.statename for state in vm.statebycountry track by state.id" id="state.id" value="state.statename" ng-change="loadDistrict(vm.investor.selectedState)"></select></div></div><div class="form-group"><label class="col-lg-2 control-label">City</label><div class="col-lg-3"><select class="form-control" ng-model="vm.investor.selectedCity" ng-options="district.districtname for district in vm.districtbystate"></select></div></div><div class="form-group"><label for="address1" class="col-lg-2 control-label">Address</label><div class="col-lg-3"><textarea class="form-control" rows="3" id="address1" placeholder="Address 1" ng-model="vm.investor.address1"></textarea></div><div class="col-lg-3"><textarea class="form-control" rows="3" id="address2" placeholder="Address 2" ng-model="vm.investor.address2"></textarea></div><div class="col-lg-3"><textarea class="form-control" rows="3" id="address3" placeholder="Address 3" ng-model="vm.investor.address3"></textarea></div></div><div class="form-group"><label class="col-lg-2 control-label">Applicant Photo</label><div class="col-lg-3"><input type="file" class="form-control" file-model="vm.cAFAttachmentPhoto.investorphoto" accept="image/*"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div></div><div class="panel panel-default" ng-hide="vm.renewproject || vm.landrequired"><div class="panel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-parent="#accordion" href=".collapseTwo">Company Detail</a></h4></div><div id="collapseTwo"><div class="panel-body"><div class="form-horizontal"><fieldset><!--<legend>Company Detail</legend>--><div class="form-group"><label class="col-lg-3 control-label">Business Entity Type</label><div class="col-lg-3"><select class="form-control" ng-model="vm.companydetail.selectedBusiness" ng-options="business.businessentitytype for business in vm.businessentities"></select></div></div><div class="form-group"><label for="mddirector" class="col-lg-3 control-label">Promoter / MD / Director</label><div class="col-lg-3"><input type="text" class="form-control" id="mddirector" placeholder="Enter Name" ng-model="vm.companydetail.promoter_md_director"></div><div class="col-lg-3"><input type="text" class="form-control" id="designation" placeholder="Enter Designation" ng-model="vm.companydetail.designation"></div></div><div class="form-group"><label for="promotor" class="col-lg-3 control-label">No. of Directors/ Promoters /MDs /CEO</label><div class="col-lg-3"><input type="number" class="form-control" id="promotor" ng-model="vm.companydetail.director_promoter_md_ceo_number" min="0"></div></div><div class="form-group"><label for="PanNumber" class="col-lg-3 control-label">PAN Number</label><div class="col-lg-3"><input type="text" class="form-control" id="PanNumber" placeholder="Enter PAN Number" ng-model="vm.companydetail.pan_number" maxlength="10"></div></div><div class="form-group"><label for="aadharnumber" class="col-lg-3 control-label">Aadhar Number</label><div class="col-lg-3"><input type="text" class="form-control" id="aadharnumber" placeholder="Enter Aadhar Number" ng-model="vm.companydetail.aadhar_number" maxlength="12"></div></div><div class="form-group"><label class="col-lg-3 control-label">Applicant is NRI?</label><div class="col-lg-3"><input type="checkbox" name="radioISNRI" checked="false" ng-model="vm.companydetail.nri"></div></div><div class="form-group"><!--<label for="tinvatnumber" class="col-lg-3 control-label">VAT Number</label>--><!--<div class="col-lg-3"><input type="text" class="form-control" id="tinvatnumber"--><!--placeholder="Enter VAT Number"--><!--ng-model="vm.companydetail.tin_vat_number"></div>--></div><div class="form-group"><!--<label for="cstnumber" class="col-lg-3 control-label">CST Number</label>--><!--<div class="col-lg-3"><input type="text" class="form-control" id="cstnumber"--><!--placeholder="Enter CST Number"--><!--ng-model="vm.companydetail.cst_number"></div>--></div><div class="form-group"><label for="gstnumber" class="col-lg-3 control-label">GST Number</label><div class="col-lg-3"><input type="text" class="form-control" id="gstnumber" placeholder="Enter GST Number" ng-model="vm.companydetail.gstnumber"></div></div><div class="form-group"><div class="col-lg-6 col-lg-offset-2"></div></div></fieldset></div></div></div></div><div class="panel panel-default" ng-hide="vm.renewproject || vm.landrequired"><div class="panel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-parent="#accordion" href=".collapseThree">Project Detail</a></h4></div><div id="collapseThree"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><!--<legend>Project Detail</legend>--><div class="form-group"><label for="Sector" class="col-lg-2 control-label">Sector</label><div class="col-lg-3"><select class="form-control" ng-model="vm.projectdetail.selectedSector" ng-options="sector.sectortype for sector in vm.sectors"></select></div><label for="purpose" class="col-lg-2 control-label">Project Purpose</label><div class="col-lg-3"><input type="text" class="form-control" id="purpose" placeholder="Enter Project Purpose" ng-model="vm.projectdetail.projectpurpose"></div></div><div class="form-group"><label class="col-lg-2 control-label">Size of Industry</label><div class="col-lg-3"><select class="form-control" ng-model="vm.projectdetail.selectedSizeOfIndustry" ng-options="si.sizeofindustry for si in vm.industrysizes"></select></div><label class="col-lg-2 control-label">Project Type</label><div class="col-lg-3"><select class="form-control" ng-model="vm.projectdetail.selectedProjectType" ng-options="projecttype.projectypes for projecttype in vm.projectypes"></select></div></div><div class="form-group"><label for="NICCode" class="col-lg-2 control-label">NIC Code</label><div class="col-lg-3"><input type="number" class="form-control" id="NICCode" placeholder="Enter NIC Code" data-dpmaxz-eid="20" ng-model="vm.projectdetail.niccode" min="0"></div><label class="col-lg-2 control-label" style="visibility:hidden">Category Of Project</label><div class="col-lg-3"><select style="visibility:hidden" class="form-control" ng-model="vm.projectdetail.selectedProjectCategory" ng-options="projectcategory.categorytype for projectcategory in vm.projectcategories"></select></div></div><div class="form-group"><label class="col-lg-2 control-label">Collaboration with Foreign Investor</label><div class="col-lg-3"><select class="form-control" ng-model="vm.projectdetail.selectedCountry" ng-options="country.countryname for country in vm.countries"></select></div><label class="col-lg-2 control-label">Existing Regulatory Approval</label><div class="col-lg-3"><input type="checkbox" name="checkExistingRegulatoryApproval" ng-model="vm.projectdetail.existing_regulatory_approval"></div></div><div class="form-group" ng-show="vm.projectdetail.existing_regulatory_approval"><label class="col-lg-2 control-label">Approved Form</label><div class="col-lg-3"><select class="form-control" ng-model="vm.projectdetail.selectedApprovalForm" ng-options="approvalform.existingapprovalforms for approvalform in vm.approvalforms"></select></div><label class="col-lg-2 control-label">EDC/SIF/CLU/Other Fee</label><div class="col-lg-3"><input type="checkbox" name="checkEDCSIFCLUOtherFee" ng-model="vm.projectdetail.edc_sif_clu_fee_paid_applicable"></div></div><div class="form-group"><div class="col-lg-6 col-lg-offset-2"></div></div></fieldset></div></div></div></div><!--<div class="panel panel-default" ng-hide="vm.renewproject || vm.landrequired">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">--><!--<a data-toggle="collapse" data-parent="#accordion" href=".projectsitedetail2">4. Project Site--><!--Detail </a>--><!--</h4>--><!--</div>--><!--<div id="projectsitedetail2">--><!--<div class="panel-body">--><!--<div class="form-horizontal">--><!--<fieldset>--><!--<legend>Project Site Detail</legend>--><!--<div class="form-group">--><!--<div>--><!--<label class="col-lg-2 control-label">CLU Required</label>--><!--<div class="col-lg-2">--><!--<input type="checkbox" name="checkConfirmityoflanduse"--><!--ng-model="vm.projectsitedetail.clurequired">--><!--</div>--><!--</div>--><!--<div>--><!--<h6><i>*Check if CLU is required.</i></h6>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="siteaddress" class="col-lg-2 control-label">Site Address</label>--><!--<div class="col-lg-3"><textarea class="form-control" rows="3" id="siteaddress"--><!--placeholder="Enter Site Address"--><!--ng-model="vm.projectsitedetail.siteaddress"></textarea>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="block" class="col-lg-2 control-label">Block</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" id="block"--><!--ng-model="vm.projectsitedetail.selectedBlock"--><!--ng-options="block.blockname for block in vm.blocks">--><!--</select>--><!--</div>--><!--<label class="col-lg-2 control-label">City/Town/Village</label>--><!--<div class="col-lg-3">--><!--<select class="form-control"--><!--ng-model="vm.projectsitedetail.selectedCityTownVillage"--><!--ng-options="city.city_town_village_name for city in vm.city_town_villages | orderBy:\'city_town_village_name\'">--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Multi-Village Involved</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkMultyVillageInvolved"--><!--ng-model="vm.projectsitedetail.multyvillageinvolved">--><!--</div>--><!--<div class="form-group" ng-show="vm.projectsitedetail.multyvillageinvolved">--><!--<label for="Villageinvolved" class="col-lg-2 control-label">Village--><!--Involved</label>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="Villageinvolved"--><!--placeholder="Enter Village Involve" data-dpmaxz-eid="20"--><!--ng-model="vm.projectsitedetail.villageinvolved">--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<div class="col-lg-12">--><!--<label class="col-lg-2 control-label">If site falls in Gurgaon or Mewat--><!--district,--><!--whether--><!--land falls under Aravalli Notification Act </label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" ng-model="vm.projectsitedetail.falls_in_aravalli"--><!--name="checkIfinGurgaonorMewat">--><!--</div>--><!--<label class="col-lg-2 control-label">Is Land Procured</label>--><!--<div class="col-lg-3    ">--><!--<input type="checkbox" name="checkIsLandProcured"--><!--ng-model="vm.projectsitedetail.islandprocured">--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Is Land alloted By HSIIDC/HUDA/Private--><!--Developer</label>--><!--<div class="col-lg-3">--><!--<label><input type="checkbox" name="checkIsLandAllocatedByHSIID"--><!--ng-model="vm.projectsitedetail.allotedbyhsiidc">--><!--</label>--><!--</div>--><!--<label for="Estate" class="col-lg-2 control-label">Estate/Location</label>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="Estate" placeholder="Enter Estate"--><!--ng-model="vm.projectsitedetail.estate">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="Cluster" class="col-lg-2 control-label">Cluster</label>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="Cluster" placeholder="Enter Cluster"--><!--ng-model="vm.projectsitedetail.cluster">--><!--</div>--><!--<label for="Phase" class="col-lg-2 control-label">Phase</label>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="phase" placeholder="Enter Phase"--><!--ng-model="vm.projectsitedetail.phase">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="Sector" class="col-lg-2 control-label">Sector</label>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="Sector" placeholder="Enter Sector"--><!--ng-model="vm.projectsitedetail.sector">--><!--</div>--><!--<label for="Plotno" class="col-lg-2 control-label">Plot Number</label>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="Plotno"--><!--placeholder="Enter Plot Number"--><!--ng-model="vm.projectsitedetail.plotno">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="Hadbastno" class="col-lg-2 control-label">Hadbast Number</label>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="Hadbastno"--><!--placeholder="Enter Hadbast Number"--><!--ng-model="vm.projectsitedetail.hadbastno">--><!--</div>--><!--<label class="col-lg-2 control-label">Lies Under MC</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkLiesUnderMC"--><!--ng-model="vm.projectsitedetail.liesunder_mc">--><!--</div>--><!--</div>--><!--<div>--><!--<label for="mcdistance" class="col-lg-2 control-label">Distance From MC</label>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" id="mcdistance"--><!--ng-model="vm.projectsitedetail.distance_from_mc">--><!--</div>--><!--<label class="col-lg-2 control-label">Site is located in Urban Area</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkisSiteAllocatedinUrbanArea"--><!--ng-model="vm.projectsitedetail.islocated_in_urban">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Proposed Built Up--><!--Area (In Sq. Mtr.)</label>--><!--<div class="col-lg-3">--><!--<input class="form-control" name="proposebuilduparea"--><!--placeholder="Proposed Build Up Area"--><!--ng-model="vm.projectsitedetail.proposedbuilt_up_area"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/">--><!--<div--><!--ng-show="myform.proposebuilduparea.$invalid && myform.proposebuilduparea.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Certified Ownership</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkCerfiedOwnership"--><!--ng-model="vm.projectsitedetail.certifiedownership">--><!--</div>--><!--<label class="col-lg-2 control-label">Lease Applicable</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkLeaseApplicable"--><!--ng-model="vm.projectsitedetail.leaseapplicable">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Land Agreement Applicable</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkLandAgreementApplicable"--><!--ng-model="vm.projectsitedetail.landagreementapplicable">--><!--</div>--><!--<label class="col-lg-2 control-label">Connecting Road</label>--><!--<div class="col-lg-3">--><!--<select class="form-control"--><!--ng-model="vm.projectsitedetail.selectedConnectingRoad"--><!--ng-options="connectingraodtype.connectingraodtype for connectingraodtype in vm.connectingroads">--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Intersection Distance</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkIntersectionDistance"--><!--ng-model="vm.projectsitedetail.intersectiondistance">--><!--</div>--><!--<label class="col-lg-2 control-label">Railway Distance</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkRailwayDistance"--><!--ng-model="vm.projectsitedetail.railwaydistance">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Confirmity of land use</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkConfirmityoflanduse"--><!--ng-model="vm.projectsitedetail.confirmitylanduse">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="buildingexisting" class="col-lg-2 control-label">Building--><!--existed</label>--><!--<div class="col-lg-3">--><!--<select type="text" class="form-control" id="buildingexisting"--><!--ng-model="vm.projectsitedetail.buildingexisted" data-dpmaxz-eid="20">--><!--<option>Before</option>--><!--<option>After</option>--><!--</select>--><!--</div>--><!--<label class="col-lg-2 control-label">Existing Building Applicable</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="radio"--><!--ng-model="vm.projectsitedetail.existing_building_applicable">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Site Situated In Controlled Area</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkSiteSituatedInControlledArea"--><!--ng-model="vm.projectsitedetail.site_situated_in_controlled_area">--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!-- <div class="panel panel-default" ng-show="!vm.renewproject">\n                 <div class="panel-heading">\n                     <h4 class="panel-title">\n                         <a data-toggle="collapse" data-parent="#accordion" href=".financestrength">5. Proposed Fixed\n                             Capital\n                             Investment</a>\n                     </h4>\n                 </div>\n            --><!-- <div id="financestrength">\n                <div class="panel-body">\n                    <div class="form-horizontal" data-dpmaxz-eid="7">\n                        <fieldset>\n                            <legend>Proposed Fixed Capital Investment</legend>\n                            <div class="form-group">\n                                <label class="col-lg-2 control-label">Land Cost (in Crore)</label>\n                                <div class="col-lg-3">\n                                    <input class="form-control" name="landcost" placeholder="0.00"\n                                           ng-model="vm.project_finance_investment.land_cost"\n                                           ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/">\n\n                                    <div ng-show="myform.landcost.$invalid && myform.landcost.$touched ">\n                                        <small style="color:red; display:block;text-align:ceter">Invalid Input\n                                        </small>\n                                    </div>\n\n                                </div>\n                                <label class="col-lg-3 control-label">Building Cost (in Crore)</label>\n                                <div class="col-lg-3">\n                                    <input class="form-control" name="buildingcost" placeholder="0.00"\n                                           ng-model="vm.project_finance_investment.building_cost"\n                                           ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/">\n\n                                    <div ng-show="myform.buildingcost.$invalid && myform.buildingcost.$touched ">\n                                        <small style="color:red; display:block;text-align:ceter">Invalid Input\n                                        </small>\n                                    </div>\n\n                                </div>\n                            </div>\n                            <div class="form-group">\n                                <label class="col-lg-2 control-label">Plant & Machinery\n                                    Cost (in Crore)</label>\n                                <div class="col-lg-3">\n                                    <input class="form-control" name="machinerycost" placeholder="0.00"\n                                           ng-model="vm.project_finance_investment.machinery_cost"\n                                           ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/">\n\n                                    <div ng-show="myform.machinerycost.$invalid && myform.machinerycost.$touched ">\n                                        <small style="color:red; display:block;text-align:ceter">Invalid Input\n                                        </small>\n                                    </div>\n\n\n                                </div>\n                                <label class="col-lg-3 control-label">Cost of Miscellaneous\n                                    Assets (in Crore)</label>\n                                <div class="col-lg-3">\n                                    <input class="form-control" name="misccost" placeholder="0.00"\n                                           ng-model="vm.project_finance_investment.misc_assests"\n                                           ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/">\n\n                                    <div ng-show="myform.misccost.$invalid && myform.misccost.$touched">\n                                        <small style="color:red; display:block;text-align:ceter">Invalid Input\n                                        </small>\n                                    </div>\n                                </div>\n                            </div>\n\n                            <hr/>\n\n                            <div class="form-group">\n                                <div class="col-lg-2">\n                                    <label><input type="checkbox" id="fdi" data-dpmaxz-eid="10"\n                                                  ng-model="vm.project_finance_investment.isfdi">FDI, If\n                                        applicable (in INR)</label>\n                                </div>\n                                <div class="col-lg-3">\n                                    <input type="number" class="form-control" id="fdivalue" placeholder="0.00"\n                                           ng-model="vm.project_finance_investment.fdivalue">\n                                </div>\n                                <label class="col-lg-3 control-label">If FDI, name of the country</label>\n                                <div class="col-lg-3">\n                                    &lt;!&ndash;  <select class="form-control" ng-model="vm.country.selectedCountry" ng-options="country.countryname for country in vm.countries">\n                                   </select>&ndash;&gt;\n                                    <select class="form-control"\n                                            ng-model="vm.project_finance_investment.selectedcountryid"\n                                            ng-options="country.countryname for country in vm.countries">\n                                    </select>\n                                </div>\n                            </div>\n\n                            <div class="form-group">\n                                <label class="col-lg-2 control-label">Foreign Funding Resources</label>\n                                <div class="col-lg-3">\n                                    <select class="form-control"\n                                            ng-model="vm.foreignfundingresources.selectedforeignfundingresourceid"\n                                            ng-options="foreignfundingresource.foreignfundingtypes for foreignfundingresource in vm.foreignfundingresources">\n                                    </select>\n                                </div>\n                            </div>\n                            <hr>\n                            <br/>\n                            <div class="form-group">\n                                <label for="constructionstartdate" class="col-lg-2 control-label">Start of Project\n                                    Construction</label>\n                                <div class="col-lg-3">\n                                    <input type="date" class="form-control" id="constructionstartdate"\n                                           placeholder="0.00"\n                                           ng-model="vm.project_finance_investment.project_construction_start_date">\n                                </div>\n                                <label for="commercialactivitystartdate" class="col-lg-3 control-label">Proposed\n                                    Date of\n                                    Commercial Activity</label>\n                                <div class="col-lg-3">\n                                    <input type="date" class="form-control" id="commercialactivitystartdate"\n                                           placeholder="0.00"\n                                           ng-model="vm.project_finance_investment.commercial_activity_start_date">\n                                </div>\n                            </div>\n                            <hr/>\n                            <p class="alert alert-success"\n                               style="font-size:14px; font-weight:bold; width:100%;">\n                                Phase-wise Implementation / FCI Details</p>\n\n                            <hr/>\n                            <div class="form-group text-center col-lg-12">\n                                <div class="form-group">\n                                    <label for="Phase" class="col-lg-1 control-label">Phase</label>\n                                    <div class="col-lg-1"><input type="text" class="form-control"\n                                                                 placeholder="Phase"\n                                                                 ng-model="vm.project_phase.phase">\n                                    </div>\n                                    <label for="Productcategory" class="col-lg-2 control-label">Product\n                                        category</label>\n                                    <div class="col-lg-2"><input type="text" class="form-control"\n                                                                 id="Productcategory"\n                                                                 placeholder="Productcategory"\n                                                                 ng-model="vm.project_phase.productcategory"></div>\n                                    <label for="Fci" class="col-lg-1 control-label">FCI</label>\n                                    <div class="col-lg-1"><input type="text" class="form-control" id="Fci"\n                                                                 placeholder="0" ng-model="vm.project_phase.fci">\n                                    </div>\n                                    <label for="Implementationdate" class="col-lg-2 control-label">Implementation\n                                        Date</label>\n                                    <div class="col-lg-2"><input type="date" class="form-control"\n                                                                 id="Implementationdate"\n                                                                 ng-model="vm.project_phase.implementationdate">\n                                    </div>\n                                </div>\n                                <div class="col-lg-12 col-lg-offset-5">\n                                    <button type="button" class="btn btn-primary"\n                                            ng-click="vm.addProject_phaseData()">ADD\n                                    </button>\n                                </div>\n                            </div>\n                            <div class="col-lg-12">\n                                <table class="table table-striped table-hover"\n                                       ng-show="(vm.completeprojectphasedata.length!=0)">\n                                    <thead>\n                                    <tr>\n                                        <th>Phase</th>\n                                        <th>Product Category</th>\n                                        <th>FCI</th>\n                                        <th>Implementation Date</th>\n                                        <th>Action</th>\n                                    </tr>\n                                    </thead>\n                                    <tbody>\n                                    <tr ng-repeat="projectphase in vm.completeprojectphasedata">\n                                        <td>{{projectphase.phase}}</td>\n                                        <td>{{projectphase.productcategory}}</td>\n                                        <td>{{projectphase.fci}}</td>\n                                        <td>{{projectphase.implementationdate}}</td>\n                                        <td>\n                                            <button type="button" class="btn btn-primary pull-center"\n                                                    value="Deletephase"\n                                                    data-dpmaxz-eid="41"\n                                                    ng-Click="vm.removeRow(projectphase.phase)">Delete\n                                            </button>\n                                        </td>\n                                    </tr>\n                                    </tbody>\n                                </table>\n\n                            </div>\n                        </fieldset>\n                    </div>\n\n                </div>\n            </div>\n        </div>\n--><!--<div class="panel panel-default">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">--><!--<a data-toggle="collapse" data-parent="#accordion" href=".financestrength">5. Proposed Fixed--><!--Capital--><!--Investment</a>--><!--</h4>--><!--</div>--><!--<div id="financestrength">--><!--<div class="panel-body">--><!--<div class="form-horizontal" data-dpmaxz-eid="7">--><!--<fieldset>--><!--<legend>Proposed Fixed Capital Investment</legend>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Land Cost (in Crore)</label>--><!--<div class="col-lg-3">--><!--<input class="form-control" name="landcost" placeholder="0.00"--><!--ng-model="vm.project_finance_investment.land_cost"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/">--><!--<div ng-show="myform.landcost.$invalid && myform.landcost.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<label class="col-lg-3 control-label">Building Cost (in Crore)</label>--><!--<div class="col-lg-3">--><!--<input class="form-control" name="buildingcost" placeholder="0.00"--><!--ng-model="vm.project_finance_investment.building_cost"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/">--><!--<div ng-show="myform.buildingcost.$invalid && myform.buildingcost.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Plant & Machinery--><!--Cost (in Crore)</label>--><!--<div class="col-lg-3">--><!--<input class="form-control" name="machinerycost" placeholder="0.00"--><!--ng-model="vm.project_finance_investment.machinery_cost"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/">--><!--<div ng-show="myform.machinerycost.$invalid && myform.machinerycost.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<label class="col-lg-3 control-label">Cost of Miscellaneous--><!--Assets (in Crore)</label>--><!--<div class="col-lg-3">--><!--<input class="form-control" name="misccost" placeholder="0.00"--><!--ng-model="vm.project_finance_investment.misc_assests"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/">--><!--<div ng-show="myform.misccost.$invalid && myform.misccost.$touched">--><!--<small style="color:red; display:block;text-align:ceter">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--<hr/>--><!--<div class="form-group">--><!--<div class="col-lg-2">--><!--<label><input type="checkbox" id="fdi" data-dpmaxz-eid="10"--><!--ng-model="vm.project_finance_investment.isfdi">FDI, If--><!--applicable (in INR)</label>--><!--</div>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" id="fdivalue" placeholder="0.00"--><!--ng-model="vm.project_finance_investment.fdivalue">--><!--</div>--><!--<label class="col-lg-3 control-label">If FDI, name of the country</label>--><!--<div class="col-lg-3">--><!--&lt;!&ndash;  <select class="form-control" ng-model="vm.country.selectedCountry" ng-options="country.countryname for country in vm.countries">--><!--</select>&ndash;&gt;--><!--<select class="form-control"--><!--ng-model="vm.project_finance_investment.selectedcountryid"--><!--ng-options="country.countryname for country in vm.countries">--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Foreign Funding Resources</label>--><!--<div class="col-lg-3">--><!--<select class="form-control"--><!--ng-model="vm.foreignfundingresources.selectedforeignfundingresourceid"--><!--ng-options="foreignfundingresource.foreignfundingtypes for foreignfundingresource in vm.foreignfundingresources">--><!--</select>--><!--</div>--><!--</div>--><!--<hr>--><!--<br/>--><!--<div class="form-group">--><!--<label for="constructionstartdate" class="col-lg-2 control-label">Start of Project--><!--Construction</label>--><!--<div class="col-lg-3">--><!--<input type="date" class="form-control" id="constructionstartdate"--><!--placeholder="0.00"--><!--ng-model="vm.project_finance_investment.project_construction_start_date">--><!--</div>--><!--<label for="commercialactivitystartdate" class="col-lg-3 control-label">Proposed--><!--Date of--><!--Commercial Activity</label>--><!--<div class="col-lg-3">--><!--<input type="date" class="form-control" id="commercialactivitystartdate"--><!--placeholder="0.00"--><!--ng-model="vm.project_finance_investment.commercial_activity_start_date">--><!--</div>--><!--</div>--><!--<hr/>--><!--<p class="alert alert-success"--><!--style="font-size:14px; font-weight:bold; width:100%;">--><!--Phase-wise Implementation / FCI Details</p>--><!--<hr/>--><!--<div class="form-group text-center col-lg-12">--><!--<div class="form-group">--><!--<label for="Phase" class="col-lg-1 control-label">Phase</label>--><!--<div class="col-lg-1"><input type="text" class="form-control"--><!--placeholder="Phase"--><!--ng-model="vm.project_phase.phase">--><!--</div>--><!--<label for="Productcategory" class="col-lg-2 control-label">Product--><!--category</label>--><!--<div class="col-lg-2"><input type="text" class="form-control"--><!--id="Productcategory"--><!--placeholder="Productcategory"--><!--ng-model="vm.project_phase.productcategory"></div>--><!--<label for="Fci" class="col-lg-1 control-label">FCI</label>--><!--<div class="col-lg-1"><input type="text" class="form-control" id="Fci"--><!--placeholder="0" ng-model="vm.project_phase.fci">--><!--</div>--><!--<label for="Implementationdate" class="col-lg-2 control-label">Implementation--><!--Date</label>--><!--<div class="col-lg-2"><input type="date" class="form-control"--><!--id="Implementationdate"--><!--ng-model="vm.project_phase.implementationdate">--><!--</div>--><!--</div>--><!--<div class="col-lg-12 col-lg-offset-5">--><!--<button type="button" class="btn btn-primary"--><!--ng-click="vm.addProject_phaseData()">ADD--><!--</button>--><!--</div>--><!--</div>--><!--<div class="col-lg-12">--><!--<table class="table table-striped table-hover"--><!--ng-show="(vm.completeprojectphasedata.length!=0)">--><!--<thead>--><!--<tr>--><!--<th>Phase</th>--><!--<th>Product Category</th>--><!--<th>FCI</th>--><!--<th>Implementation Date</th>--><!--<th>Action</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat="projectphase in vm.completeprojectphasedata">--><!--<td>{{projectphase.phase}}</td>--><!--<td>{{projectphase.productcategory}}</td>--><!--<td>{{projectphase.fci}}</td>--><!--<td>{{projectphase.implementationdate}}</td>--><!--<td>--><!--<button type="button" class="btn btn-primary pull-center"--><!--value="Deletephase"--><!--data-dpmaxz-eid="41"--><!--ng-Click="vm.removeRow(projectphase.phase)">Delete--><!--</button>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--- End Proposed Payment Data --><!--- Manufacturing Data --><!-- <div class="panel panel-default" ng-show="!vm.renewproject">\n                 <div class="panel-heading">\n                     <h4 class="panel-title">\n                         <a data-toggle="collapse" data-parent="#accordion" href=".manufacturing">6. Manufacturing\n                             Data</a>\n                     </h4>\n                 </div>\n                 <div id="manufacturing">\n                     <div class="panel-body">\n                         <div class="form-horizontal" data-dpmaxz-eid="7">\n                             <fieldset>\n                                 <legend>Manufacturing Details</legend>\n                                 <div class="col-lg-12">\n                                     <div class="form-group" class="col-lg-12 pagination-centered">\n                                         <div class="col-lg-3">\n                                             <div class="form-group">\n                                                 <label for="rawmaterial" class="col-lg-8 control-label">Raw\n                                                     Material</label>\n                                                 <div class="col-lg-12">\n                                                     <input type="text" class="form-control"\n                                                            ng-model="vm.project_rawmaterial.rawmaterial"\n                                                            id="rawmaterial"\n                                                            placeholder="Enter Raw Material">\n                                                 </div>\n                                             </div>\n                                         </div>\n                                         <div class="col-lg-3">\n                                             <div class="form-group">\n                                                 <label for="Quantity" class="col-lg-8 control-label">Quantity</label>\n                                                 <div class="col-lg-12">\n                                                     <input type="number" class="form-control"\n                                                            ng-model="vm.project_rawmaterial.quantity" id="Quantity"\n                                                            placeholder="Enter Quantity" min="0">\n                                                 </div>\n                                             </div>\n                                         </div>\n                                         <div class="col-lg-3">\n                                             <div class="form-group">\n                                                 <label for="Units" class="col-lg-8 control-label">Units</label>\n                                                 <div class="col-lg-12">\n                                                     <select class="form-control"\n                                                             ng-model="vm.project_rawmaterial.selectedUnit"\n                                                             ng-options="unit.unittypes for unit in vm.manufacturingunits"\n                                                     >\n                                                     </select>\n                                                 </div>\n                                             </div>\n                                         </div>\n                                         <div class="col-lg-1">\n                                             <div class="form-group">\n                                                 <label for="Units" class="col-lg-8 control-label">&nbsp;</label>\n                                                 <div class="col-lg-12">\n                                                     <button type="button" class="btn btn-primary"\n                                                             ng-click="vm.addProject_rawmaterialData()">ADD\n                                                     </button>\n                                                 </div>\n                                             </div>\n                                         </div>\n                                     </div>\n                                     <div class="col-lg-12" ng-show="(vm.projectrawmaterialdata.length!=0)">\n                                         <table class="table table-striped table-hover ">\n                                             <thead>\n                                             <tr>\n                                                 <th>Raw Material</th>\n                                                 <th>Quantity</th>\n                                                 <th>Units</th>\n                                                 <th>Action</th>\n                                             </tr>\n                                             </thead>\n                                             <tbody>\n                                             <tr ng-repeat="projectrawmaterial in vm.projectrawmaterialdata">\n                                                 <td>{{projectrawmaterial.rawmaterial}}</td>\n                                                 <td>{{projectrawmaterial.quantity}}</td>\n                                                 <td>{{projectrawmaterial.units}}</td>\n                                                 <td>\n                                                     <button type="button" class="btn btn-primary pull-center"\n                                                             value="Deletephase"\n                                                             data-dpmaxz-eid="41"\n                                                             ng-Click="vm.removeRawRow(projectrawmaterial.rawmaterial)">\n                                                         Delete\n                                                     </button>\n                                                 </td>\n                                             </tr>\n                                             </tbody>\n                                         </table>\n\n                                     </div>\n                                 </div>\n                                 &lt;!&ndash; product &ndash;&gt;\n                                 <hr/>\n                                 <div class="col-lg-12">\n                                     <div class="form-group">\n                                         <div class="col-lg-3">\n                                             <div class="form-group">\n                                                 <label for="mainproduct" class="col-lg-6 control-label">Main\n                                                     Product</label>\n                                                 <div class="col-lg-12">\n                                                     <input type="text" class="form-control"\n                                                            ng-model="vm.product.mainproduct" id="mainproduct"\n                                                            placeholder="Enter Main Product" data-dpmaxz-eid="20">\n                                                 </div>\n                                             </div>\n                                         </div>\n                                         <div class="col-lg-3">\n                                             <div class="form-group">\n                                                 <label for="Quantity" class="col-lg-6 control-label">Quantity</label>\n                                                 <div class="col-lg-12">\n                                                     <input type="number" class="form-control"\n                                                            ng-model="vm.product.quantity" id="Productqty"\n                                                            placeholder="Enter Quantity" data-dpmaxz-eid="20" min="0">\n                                                 </div>\n                                             </div>\n                                         </div>\n                                         <div class="col-lg-3">\n                                             <div class="form-group">\n                                                 <label for="Units" class="col-lg-6 control-label">Units</label>\n                                                 <div class="col-lg-12">\n                                                     <select class="form-control"\n                                                             ng-model="vm.product.selectedUnit"\n                                                             ng-options="unit.unittypes for unit in vm.manufacturingunits"\n                                                             id="Units"\n                                                             data-dpmaxz-eid="20">\n                                                     </select>\n                                                 </div>\n                                             </div>\n                                         </div>\n                                         <div class="col-lg-3">\n                                             <div class="form-group">\n                                                 <label for="Units" class="col-lg-6 control-label">&nbsp;</label>\n                                                 <div class="col-lg-12">\n                                                     <button type="button" class="btn btn-primary" data-dpmaxz-eid="12"\n                                                             ng-click="vm.addProject_mainproductData()">ADD\n                                                     </button>\n\n                                                 </div>\n                                             </div>\n                                         </div>\n                                     </div>\n                                     <div class="col-lg-12" ng-show="(vm.projectmainproductdata.length!=0)">\n                                         <table class="table table-striped table-hover">\n                                             <thead>\n                                             <tr>\n                                                 <th>Main Product</th>\n                                                 <th>Quantity</th>\n                                                 <th>Units</th>\n                                                 <th>Action</th>\n                                             </tr>\n                                             </thead>\n                                             <tbody>\n                                             <tr ng-repeat="projectmainproduct in vm.projectmainproductdata">\n                                                 <td>{{projectmainproduct.mainproduct}}</td>\n                                                 <td>{{projectmainproduct.quantity}}</td>\n                                                 <td>{{projectmainproduct.units}}</td>\n                                                 <td>\n                                                     <button type="button" class="btn btn-primary pull-center"\n                                                             value="Deletephase"\n                                                             data-dpmaxz-eid="41"\n                                                             ng-Click="vm.removeMainRow(projectmainproduct.mainproduct)">\n                                                         Delete\n                                                     </button>\n                                                 </td>\n                                             </tr>\n                                             </tbody>\n                                         </table>\n\n                                     </div>\n                                 </div>\n\n                                 <hr/>\n\n                                 <div class="form-group">\n                                     <label for="addprocess" class="col-lg-2 control-label">Add Process</label>\n                                     <div class="col-lg-7">\n                                             <textarea rows="3" ng-model="vm.projectprocessflowstep.steps"\n                                                       class="form-control"\n                                                       id="addprocess">\n                                             </textarea>\n                                     </div>\n                                     <div class="col-lg-3">\n                                         <button type="button" class="btn btn-primary" data-dpmaxz-eid="12"\n                                                 ng-click="vm.addProject_processflowstepData()">ADD\n                                         </button>\n                                     </div>\n\n                                     <div class="col-lg-12" ng-show="(vm.projectprocessflowstepdata.length!=0)">\n                                         <table class="table table-striped table-hover ">\n                                             <thead>\n                                             <tr>\n                                                 <th class="col-lg-8">Added Process</th>\n                                                 <th class="pull-right">Action</th>\n                                             </tr>\n                                             </thead>\n                                             <tbody>\n                                             <tr ng-repeat="projectprocessflowstep in vm.projectprocessflowstepdata">\n                                                 <td class="col-lg-8">{{projectprocessflowstep.steps}}</td>\n                                                 <td>\n                                                     <button type="button" class="btn btn-primary pull-right"\n                                                             value="Deletephase"\n                                                             ng-Click="vm.removeStepRow(projectprocessflowstep.steps)">\n                                                         Delete\n                                                     </button>\n                                                 </td>\n                                             </tr>\n                                             </tbody>\n                                         </table>\n                                     </div>\n                                 </div>\n                             </fieldset>\n                         </div>\n                     </div>\n                 </div>\n             </div>--><!-- end of Manufacturing Data --><!-- Starting Environment Impact --><!--<div class="panel panel-default" ng-show="!vm.renewproject">\n                <div class="panel-heading">\n                    <h4 class="panel-title">\n                        <a data-toggle="collapse" data-parent="#accordion" href=".environment">7. Environment Impact\n                            Detail</a>\n                    </h4>\n                </div>\n                <div id="environment impact">\n                    <div class="panel-body">\n                        <div class="form-horizontal" data-dpmaxz-eid="7">\n                            <fieldset>\n                                <legend>Environment Impact Detail</legend>\n                                <div>\n                                    <div class="row">\n                                        <div class="col-md-12">\n                                            <label class="control-label col-md-3">Source of Water Supply</label>\n                                            <div class="col-lg-3">\n                                                <select class="form-control"\n                                                        ng-model="vm.environmentimpactdetail.selectedWatersource"\n                                                        ng-options="watersupplysource.watersupplysourcetype for watersupplysource in vm.watersupplysources"\n                                                        placeholder="Select Source of Water Supply">\n                                                </select>\n\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <hr/>\n                                    <div class="table table-bordered table-striped" style="min-height:40px;">\n                                        <table class="table">\n                                            <tbody>\n                                            <tr>\n                                                <th>Particulars</th>\n                                                <th>Process</th>\n                                                <th>Cooling</th>\n                                                <th>Domestic</th>\n                                                <th>Other</th>\n                                            </tr>\n                                            <tr>\n                                                <td>Water Usage (in KL per day)\n                                                </td>\n                                                <td>\n\n                                                    <input class="form-control" name="water_proc"\n                                                           ng-model="vm.environmentimpactdetail.water_process" min="0"\n                                                           ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                    <div\n                                                        ng-show="myform.water_proc.$invalid && myform.water_proc.$touched ">\n                                                        <small style="color:red; display:block;text-align:ceter">Invalid\n                                                            Input\n                                                        </small>\n                                                    </div>\n\n\n                                                </td>\n                                                <td>\n                                                    <input class="form-control" name="water_col"\n                                                           ng-model="vm.environmentimpactdetail.water_cooling" min="0"\n                                                           ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                    <div\n                                                        ng-show="myform.water_col.$invalid && myform.water_col.$touched ">\n                                                        <small style="color:red; display:block;text-align:ceter">Invalid\n                                                            Input\n                                                        </small>\n                                                    </div>\n\n                                                </td>\n                                                <td>\n                                                    <input class="form-control" name="water_dom"\n                                                           ng-model="vm.environmentimpactdetail.water_domestic" min="0"\n                                                           ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n                                                    <div\n                                                        ng-show="myform.water_dom.$invalid && myform.water_dom.$touched ">\n                                                        <small style="color:red; display:block;text-align:ceter">Invalid\n                                                            Input\n                                                        </small>\n                                                    </div>\n\n                                                </td>\n                                                <td>\n\n                                                    <input class="form-control"\n                                                           ng-model="vm.environmentimpactdetail.water_other"/>\n                                                </td>\n                                            </tr>\n\n                                            <tr>\n                                                <td>Waste Water Generation (in KL per day)\n                                                <td>\n                                                    <input class="form-control" name="waste_proc"\n                                                           ng-model="vm.environmentimpactdetail.waste_water_process"\n                                                           min="0" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                    <div\n                                                        ng-show="myform.waste_proc.$invalid && myform.waste_proc.$touched ">\n                                                        <small style="color:red; display:block;text-align:ceter">Invalid\n                                                            Input\n                                                        </small>\n                                                    </div>\n\n                                                </td>\n                                                <td>\n                                                    <input class="form-control" name="waste_col"\n                                                           ng-model="vm.environmentimpactdetail.waste_water_cooling"\n                                                           min="0" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n                                                    <div\n                                                        ng-show="myform.waste_col.$invalid && myform.waste_col.$touched ">\n                                                        <small style="color:red; display:block;text-align:ceter">Invalid\n                                                            Input\n                                                        </small>\n                                                    </div>\n\n                                                </td>\n                                                <td>\n                                                    <input class="form-control" name="waste_dom"\n                                                           ng-model="vm.environmentimpactdetail.waste_water_domesting"\n                                                           min="0" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                    <div\n                                                        ng-show="myform.waste_dom.$invalid && myform.waste_dom.$touched ">\n                                                        <small style="color:red; display:block;text-align:ceter">Invalid\n                                                            Input\n                                                        </small>\n                                                    </div>\n\n                                                </td>\n                                                <td>\n                                                    <input class="form-control"\n                                                           ng-model="vm.environmentimpactdetail.waste_water_other"/>\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td>Waste Water Treatment<br></td>\n                                                <td>\n                                                    <select class="form-control"\n                                                            ng-model="vm.environmentimpactdetail.selectedTreatmentone"\n                                                            ng-options="treatmentone.treatment1 for treatmentone in vm.treatment1"\n                                                            placeholder="Select Waste water treatment One">\n                                                    </select>\n                                                </td>\n                                                <td>\n                                                    <select class="form-control"\n                                                            ng-model="vm.environmentimpactdetail.selectedTreatmenttwo"\n                                                            ng-options="treatmenttwo.treatment2 for treatmenttwo in vm.treatment2"\n                                                            placeholder="Select Waste water treatment Two">\n                                                    </select>\n                                                </td>\n                                                <td>\n                                                    <select class="form-control"\n                                                            ng-model="vm.environmentimpactdetail.selectedTreatmentthree"\n                                                            ng-options="treatmentthree.treatment3 for treatmentthree in vm.treatment3"\n                                                            data-dpmaxz-eid="20"\n                                                            placeholder="Select Waste water treatment Three">\n                                                    </select>\n                                                    <span class="field-validation-valid errorMsg"\n                                                          data-valmsg-for="WasteWaterTreatmentDomestic"\n                                                          data-valmsg-replace="true"></span>\n                                                    <span class="field-validation-valid errorMsg"\n                                                          data-valmsg-for="RequiredWasteWaterTreatmentDomestic"\n                                                          data-valmsg-replace="true"></span>\n\n                                                    <br>\n                                                </td>\n                                                <td>\n                                                    <input class="form-control" data-val="true"\n                                                           data-val-length="Other waste water treatment must be 1-100 characters long !"\n                                                           data-val-length-max="100" data-val-length-min="1"\n                                                           data-val-regex="Other waste water treatment can only have alphanumerics, space and special characters (, - / ()) !"\n                                                           data-val-regex-pattern="^([0-9a-zA-Z,-/()]+)$"\n                                                           name="WasteWaterTreatmentOther" type="text"\n                                                           ng-model="vm.environmentimpactdetail.recycling_other"\n                                                           value="RECIRCULATION"\n                                                           autocomplete="off"\n                                                           autocompletetype="Disable"><br>\n                                                    <span class="field-validation-valid errorMsg"\n                                                          data-valmsg-for="WasteWaterTreatmentOther"\n                                                          data-valmsg-replace="true"></span>\n                                                    <span class="field-validation-valid errorMsg"\n                                                          data-valmsg-for="RequiredWasteWaterTreatmentOther"\n                                                          data-valmsg-replace="true"></span>\n                                                </td>\n                                            </tr>\n                                            </tbody>\n                                        </table>\n                                    </div>\n\n                                    <div class="row">\n                                        <div class="col-md-12">\n                                            <label class="control-label col-md-3">Mode of disposal for Discharge</label>\n                                            <div class="col-lg-3">\n                                                <select class="form-control"\n                                                        ng-model="vm.environmentimpactdetail.selectedDischarge"\n                                                        ng-options="discharge.disposal_for_discharge for discharge in vm.modeofdisposalfor_discharge"\n                                                        data-dpmaxz-eid="20" placeholder="Select Waste water treatment">\n                                                </select>\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <hr/>\n                                    <div>\n                                        <p class="alert alert-success"\n                                           style="font-size:14px; font-weight:bold; width:100%;">\n                                            Emission Data</p>\n                                    </div>\n\n                                    <div class="table-bordered table-striped table-responsive" style="min-height:40px;">\n                                        <table class="table">\n                                            <tbody>\n                                            <tr>\n                                                <th>\n                                                    Emission Type\n                                                </th>\n                                                <th>\n                                                    Capacity\n                                                    <span style="font-size:small">\n                                                            (Ton Per Hour / KVA or Mega Watt)\n                                                        </span>\n                                                </th>\n                                                <th>\n                                                    Type of Fuel\n                                                </th>\n\n                                                <th>\n                                                    Air Pollution Control Device\n                                                </th>\n                                            </tr>\n                                            <tr>\n                                                <td>\n                                                    <select class="form-control"\n                                                            ng-model="vm.emissiondetail.selectedParticular"\n                                                            ng-options="particular.particulars for particular in vm.particulars"\n                                                            placeholder="Select Emmision Pollution Controls">\n                                                    </select>\n                                                </td>\n                                                <td>\n                                                    <input class="form-control" data-val="true"\n                                                           data-val-number="The field Capacity must be a number."\n                                                           data-val-regex="Please enter only numbers or decimal"\n                                                           data-val-regex-pattern="^[0-9]{1,9}(\\.[0-9]{0,2})?$"\n                                                           id="Capacity" name="Capacity"\n                                                           placeholder="Click here to enter text" type="text"\n                                                           ng-model="vm.emissiondetail.capacity" value=""\n                                                           autocomplete="off" autocompletetype="Disable"\n                                                           data-dpmaxz-eid="36">\n                                                    <span class="field-validation-valid" data-valmsg-for="Capacity"\n                                                          data-valmsg-replace="true"></span>\n                                                </td>\n                                                <td>\n                                                    <select class="form-control"\n                                                            ng-model="vm.emissiondetail.selectedTypeoffuel"\n                                                            ng-options="typeoffuelname.typeoffuel for typeoffuelname in vm.emmision_fuel_types"\n                                                            data-dpmaxz-eid="20"\n                                                            placeholder="Select Emmision Fuel Type">\n                                                    </select>\n                                                </td>\n                                                <td>\n                                                    <select class="form-control"\n                                                            ng-model="vm.emissiondetail.selectedAirpollutioncontroldevice"\n                                                            ng-options="airpollutioncontroldevicename.airpollutioncontroldevice for airpollutioncontroldevicename in vm.emmision_pollution_controlls"\n                                                            data-dpmaxz-eid="20"\n                                                            placeholder="Select Emmision Fuel Type">\n                                                    </select>\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td align="right" colspan="12">\n                                                    <button type="button" class="btn btn-primary" data-dpmaxz-eid="12"\n                                                            ng-click="vm.addProject_emissiondetailData()">ADD\n                                                    </button>\n\n                                                </td>\n                                            </tr>\n                                            </tbody>\n                                        </table>\n                                        <div ng-show="(vm.emissiondetaildata.length!=0)">\n                                            <table class="table table-curved">\n                                                <thead>\n                                                <tr>\n                                                    <th scope="col">\n                                                        Emission Type\n                                                    </th>\n                                                    <th scope="col">\n                                                        Capacity\n                                                    </th>\n                                                    <th scope="col">\n                                                        Type Of Fuel\n                                                    </th>\n                                                    <th scope="col">\n                                                        Pollution Control Device\n                                                    </th>\n                                                    <th>Action</th>\n\n                                                </tr>\n                                                </thead>\n                                                <tbody>\n                                                <tr ng-repeat="emissiondetail in vm.emissiondetaildata">\n                                                    <td>{{emissiondetail.particulars}}</td>\n                                                    <td>{{emissiondetail.capacity}}</td>\n                                                    <td>{{emissiondetail.type_of_fuel}}</td>\n                                                    <td>{{emissiondetail.air_pollution_control_device}}</td>\n                                                    <td>\n                                                        <button type="button" class="btn btn-primary pull-center"\n                                                                value="Deletephase"\n                                                                data-dpmaxz-eid="41"\n                                                                ng-Click="vm.removeEmissionRow(emissiondetail.selectedParticular)">\n                                                            Delete\n                                                        </button>\n                                                    </td>\n\n                                                </tr>\n                                                </tbody>\n                                            </table>\n                                        </div>\n                                        <div>\n                                        </div>\n                                    </div>\n\n                                    <hr/>\n\n                                    <div class="row">\n                                        <div class="col-md-12">\n                                            <p class="alert alert-success"\n                                               style="font-size:14px; font-weight:bold; width:100%;">\n                                                Solid Waste Generation Details</p>\n                                        </div>\n                                    </div>\n                                    <div class="table-bordered table-striped table-responsive" style="min-height:40px;">\n                                        <table class="table">\n                                            <tbody>\n                                            <tr>\n                                                <th>\n                                                    Source of Generation\n                                                </th>\n                                                <th>\n                                                    Nature/Type\n                                                </th>\n                                                <th>\n                                                    Quantity (Tons per Day)\n                                                </th>\n                                                <th>\n                                                    Mode of Disposal\n                                                </th>\n                                            </tr>\n                                            <tr>\n                                                <td>\n                                                    <input class="form-control"\n                                                           ng-model="vm.wastewaterdetail.source_of_generation"\n                                                           data-val="true"/>\n\n                                                </td>\n                                                <td>\n                                                    <select class="form-control"\n                                                            ng-model="vm.wastewaterdetail.selectedNaturetype"\n                                                            ng-options="naturetypename.naturetype for naturetypename in vm.waste_water_naturetype"\n                                                            data-dpmaxz-eid="20" placeholder="Select Nature of Type">\n                                                    </select>\n\n                                                    <span class="field-validation-valid" data-valmsg-for="NatureOrType"\n                                                          data-valmsg-replace="true"></span>\n                                                </td>\n                                                <td>\n                                                    <input type="number" class="form-control" data-val="true"\n                                                           ng-model="vm.wastewaterdetail.quantity" min="0"/>\n\n                                                </td>\n                                                <td>\n                                                    <select class="form-control"\n                                                            ng-model="vm.wastewaterdetail.selectedModeofdisposal"\n                                                            ng-options="mode_of_disposalname.disposal_for_discharge for mode_of_disposalname in vm.modeofdisposalfor_discharge"\n                                                            data-dpmaxz-eid="20" placeholder="Select Mode of Dipsosal">\n                                                    </select>\n                                                    <span class="field-validation-valid"\n                                                          data-valmsg-for="ModeOfDisposal"\n                                                          data-valmsg-replace="true"></span>\n                                                </td>\n                                            </tr>\n                                            <tr>\n                                                <td align="right" colspan="6">\n                                                    <button type="button" class="btn btn-primary" data-dpmaxz-eid="12"\n                                                            ng-click="vm.addProject_wastewaterdetailData()">ADD\n                                                    </button>\n\n                                                </td>\n                                            </tr>\n                                            </tbody>\n                                        </table>\n                                        <div class="col-lg-12" ng-show="(vm.wastewaterdetaildata.length!=0)">\n                                            <table class="table table-striped table-hover ">\n                                                <thead>\n                                                <tr>\n                                                    <th>Source of Generation</th>\n                                                    <th>Nature/Type</th>\n                                                    <th>Quantity (Tons per Day)</th>\n                                                    <th>Mode of Disposal</th>\n                                                    <th>Action</th>\n                                                </tr>\n                                                </thead>\n                                                <tbody>\n                                                <tr ng-repeat="wastewaterdetail in vm.wastewaterdetaildata">\n                                                    <td>{{wastewaterdetail.source_of_generation}}</td>\n                                                    <td>{{wastewaterdetail.naturetype}}</td>\n                                                    <td>{{wastewaterdetail.quantity}}</td>\n                                                    <td>{{wastewaterdetail.mode_of_disposal}}</td>\n                                                    <td>\n                                                        <button type="button" class="btn btn-primary pull-center"\n                                                                value="Deletephase"\n                                                                data-dpmaxz-eid="41"\n                                                                ng-Click="vm.removeSourceRow(wastewaterdetail.source_of_generation)">\n                                                            Delete\n                                                        </button>\n                                                    </td>\n                                                </tr>\n                                                </tbody>\n                                            </table>\n\n                                        </div>\n                                        <div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </fieldset>\n                        </div>\n\n                    </div>\n                </div>\n            </div>\n\n            &lt;!&ndash; Electrict Requirement &ndash;&gt;\n\n            <div class="panel panel-default" ng-show="!vm.renewproject">\n                <div class="panel-heading">\n                    <h4 class="panel-title">\n                        <a data-toggle="collapse" data-parent="#accordion" href=".electric">8. Electric Requirement</a>\n                    </h4>\n                </div>\n                <div id="electric">\n                    <div class="panel-body">\n                        <div class="form-horizontal" data-dpmaxz-eid="7">\n                            <fieldset>\n                                <legend>Electric Requirement Data</legend>\n                                <div id="divElectric">\n                                    <div style="background-color:aliceblue;" class="pull-right">\n                                        <span class="field-validation-valid errorMsg" data-valmsg-for="SelectEletricPower"\n                                              data-valmsg-replace="true" id="SelectEletricPower"></span>\n                                    </div>\n\n                                    <div id="temporary" class="row table col-md-12">\n                                        <div class="col-md-5">\n                                            <label class="control-label col-md-8">\n                                                TEMPORARY CONNECTION\n                                                <label class="cafSubHeadings" style="margin-left:-15px;">* During\n                                                    Construction</label><label class="cafSubHeadings"\n                                                                               style="margin-left:-15px;">\n                                            </label><br> <br> <br>\n                                                * Enclose bill\n                                                copy in\n                                                case of existing connection\n                                            </label>\n                                            <div class="row col-md-8">\n                                                <table>\n                                                    <tbody>\n                                                    <tr>\n                                                        <td style="border-top:none;">\n                                                        </td>\n                                                    </tr>\n\n                                                    </tbody>\n                                                </table>\n                                            </div>\n\n\n                                        </div>\n                                        <div class="col-md-7">\n\n                                        </div>\n\n                                        <div class="col-md-7" style="min-height:30px;">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Power Company</label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <label class="control-label">{{vm.projectsitedetail.selectedDistrict.powercompany}}</label>\n                                            </div>\n                                        </div>\n\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7" style="min-height:30px;">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Existing Connection</label>\n                                            </div>\n                                            <div class="col-md-3" id="divTempRunning">\n                                                <input type="checkbox"\n                                                       ng-model="vm.electricrequirement.tem_load_existing">\n                                            </div>\n                                        </div>\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Account Number</label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input class="form-control" id="TempAccountNo" name="TempAccountNo"\n                                                       placeholder="Click here" type="text" value="" autocomplete="off"\n                                                       autocompletetype="Disable" data-dpmaxz-eid="4"\n                                                       ng-model="vm.electricrequirement.tem_account_number">\n                                            </div>\n                                        </div>\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Existing Load Demand (KW) </label>\n\n\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input class="form-control" data-val="true"\n                                                       name="TempExistingLoadKW"\n                                                       placeholder="0.00"\n                                                       ng-model="vm.electricrequirement.temp_existing_load_demand_kw"\n                                                       ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                <div\n                                                    ng-show="myform.TempExistingLoadKW.$invalid && myform.TempExistingLoadKW.$touched ">\n                                                    <small style="color:red; display:block;text-align:ceter">Invalid\n                                                        Input\n                                                    </small>\n                                                </div>\n\n                                            </div>\n                                        </div>\n\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Existing Load Demand (KVA) </label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input class="form-control" data-val="true"\n                                                       name="TempExistingLoadKVA"\n                                                       placeholder="0.00"\n                                                       ng-model="vm.electricrequirement.temp_existing_load_demand_kva"\n                                                       ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                <div\n                                                    ng-show="myform.TempExistingLoadKVA.$invalid && myform.TempExistingLoadKVA.$touched ">\n                                                    <small style="color:red; display:block;text-align:ceter">Invalid\n                                                        Input\n                                                    </small>\n                                                </div>\n\n                                            </div>\n                                        </div>\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">New Load Demand (KW) </label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input class="form-control" name="LoadDemandKW" placeholder="0.00"\n                                                       ng-model="vm.electricrequirement.temp_new_load_demand_kw"\n                                                       ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                <div\n                                                    ng-show="myform.LoadDemandKW.$invalid && myform.LoadDemandKW.$touched ">\n                                                    <small style="color:red; display:block;text-align:ceter">Invalid\n                                                        Input\n                                                    </small>\n                                                </div>\n\n                                            </div>\n                                        </div>\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">New Load Demand (KVA) </label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input class="form-control" data-val="true"\n                                                       name="LoadDemandKVA" placeholder="0.00"\n                                                       ng-model="vm.electricrequirement.temp_new_load_demand_kva"\n                                                       ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                <div\n                                                    ng-show="myform.LoadDemandKVA.$invalid && myform.LoadDemandKVA.$touched ">\n                                                    <small style="color:red; display:block;text-align:ceter">Invalid\n                                                        Input\n                                                    </small>\n                                                </div>\n\n                                            </div>\n                                        </div>\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div id="tDemandDate" class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Demand Date</label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input type="date" class="form-control" placeholder="Demand Date"\n                                                       data-dpmaxz-eid="20"\n                                                       ng-model="vm.electricrequirement.temp_load_demand_date">\n                                            </div>\n                                        </div>\n                                    </div>\n                                    <div id="regular" class="table row col-md-12">\n                                        <div class="col-md-5">\n                                            <label class="control-label col-md-6">REGULAR CONNECTION<label\n                                                style="margin-left:-15px;">* During Commercial Activity</label>\n                                                <label class="cafSubHeadings" style="margin-left:-15px;">* Enclose bill\n                                                    copy\n                                                    in case of existing connection</label></label><br>\n                                            <br><br>\n\n                                            <div class="row col-md-8">\n                                                <table>\n                                                    <tbody>\n                                                    <tr>\n                                                        <td style="border-top:none;">\n                                                        </td>\n                                                        <td style="border-top:none;">\n                                                            <span id="rReqBill"\n                                                                  style="color:red; display:none; width:10px;">*</span>\n                                                        </td>\n                                                    </tr>\n                                                    <tr>\n                                                        <td style="border-top:none;">\n                                                            <div class="bill_name" style="display:none;"></div>\n                                                            <div id="divEBill"></div>\n                                                            <span class="field-validation-valid errorMsg"\n                                                                  data-valmsg-for="ErrorExistingBill"\n                                                                  data-valmsg-replace="true"\n                                                                  id="ErrorExistingBill"></span>\n                                                        </td>\n                                                    </tr>\n                                                    </tbody>\n                                                </table>\n                                            </div>\n                                        </div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Load Required</label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input type="checkbox"\n                                                       ng-model="vm.electricrequirement.regular_load_required">\n                                            </div>\n                                        </div>\n                                        <div class="col-md-7" style="min-height:30px;">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Power Company</span></label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <label class="control-label">{{vm.projectsitedetail.selectedDistrict.powercompany}}</label>\n                                            </div>\n                                        </div>\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7" style="min-height:30px;">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Existing Connection</label>\n                                            </div>\n                                            <div class="col-md-3" id="divRegRunning">\n                                                <input type="checkbox"\n                                                       ng-model="vm.electricrequirement.regular_existing_connection">\n                                            </div>\n\n                                        </div>\n                                        <div class="col-md-5"></div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Customer Type</span></label>\n                                            </div>\n                                            <div class="col-lg-5">\n                                                <select class="form-control"\n                                                        ng-model="vm.electricrequirement.selectedCustomerType"\n                                                        ng-options="customer.customertype for customer in vm.customerType">\n                                                </select>\n                                            </div>\n                                        </div>\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Account Number</label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input class="form-control" id="RegAccountNo" name="RegAccountNo"\n                                                       placeholder="Click here" type="text" value="" autocomplete="off"\n                                                       autocompletetype="Disable" data-dpmaxz-eid="12"\n                                                       ng-model="vm.electricrequirement.regular_account_number">\n                                            </div>\n                                        </div>\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Existing Load If Any (In KW)</label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input class="form-control" data-val="true"\n                                                       name="ExistingLoadKW"\n                                                       placeholder="0.00"\n                                                       ng-model="vm.electricrequirement.regular_existing_load_ifany_kw"\n                                                       ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                <div\n                                                    ng-show="myform.ExistingLoadKW.$invalid && myform.ExistingLoadKW.$touched ">\n                                                    <small style="color:red; display:block;text-align:ceter">Invalid\n                                                        Input\n                                                    </small>\n                                                </div>\n\n                                            </div>\n                                        </div>\n\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Existing Load If Any(In KVA)</label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input class="form-control" data-val="true"\n                                                       name="ExistingLoadKVA"\n                                                       placeholder="0.00"\n                                                       ng-model="vm.electricrequirement.regular_existing_load_ifany_kva"\n                                                       ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                <div\n                                                    ng-show="myform.ExistingLoadKVA.$invalid && myform.ExistingLoadKVA.$touched ">\n                                                    <small style="color:red; display:block;text-align:ceter">Invalid\n                                                        Input\n                                                    </small>\n                                                </div>\n\n                                            </div>\n                                        </div>\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">New Load Demand (In KW)</label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input class="form-control" data-val="true"\n                                                       name="NewLoadKW" placeholder="0.00"\n                                                       ng-model="vm.electricrequirement.regular_new_load_demand_kw"\n                                                       ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                <div ng-show="myform.NewLoadKW.$invalid && myform.NewLoadKW.$touched ">\n                                                    <small style="color:red; display:block;text-align:ceter">Invalid\n                                                        Input\n                                                    </small>\n                                                </div>\n\n                                            </div>\n                                        </div>\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">New Load Demand (In KVA)</label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input class="form-control" data-val="true"\n                                                       name="NewLoadKVA" placeholder="0.00"\n                                                       ng-model="vm.electricrequirement.regular_new_load_demand_kva"\n                                                       ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>\n\n                                                <div\n                                                    ng-show="myform.NewLoadKVA.$invalid && myform.NewLoadKVA.$touched ">\n                                                    <small style="color:red; display:block;text-align:ceter">Invalid\n                                                        Input\n                                                    </small>\n                                                </div>\n\n                                            </div>\n                                        </div>\n                                        <div class="col-md-5">\n                                        </div>\n                                        <div id="rDemandDate" class="col-md-7">\n                                            <div class="col-md-5" style="text-align:right;">\n                                                <label class="control-label">Demand Date</label>\n                                            </div>\n                                            <div class="col-md-3">\n                                                <input type="date" class="form-control" id="regulardemanddate"\n                                                       placeholder="Demand Date" data-dpmaxz-eid="20"\n                                                       ng-model="vm.electricrequirement.regular_load_demand_date">\n                                            </div>\n                                        </div>\n                                    </div>\n                                </div>\n                            </fieldset>\n                        </div>\n\n                    </div>\n                </div>\n            </div>\n    --><!--<div class="panel panel-default">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">--><!--<a data-toggle="collapse" data-parent="#accordion" href=".manufacturing">6. Manufacturing--><!--Data</a>--><!--</h4>--><!--</div>--><!--<div id="manufacturing">--><!--<div class="panel-body">--><!--<div class="form-horizontal" data-dpmaxz-eid="7">--><!--<fieldset>--><!--<legend>Manufacturing Details</legend>--><!--<div class="col-lg-12">--><!--<div class="form-group" class="col-lg-12 pagination-centered">--><!--<div class="col-lg-3">--><!--<div class="form-group">--><!--<label for="rawmaterial" class="col-lg-8 control-label">Raw--><!--Material</label>--><!--<div class="col-lg-12">--><!--<input type="text" class="form-control"--><!--ng-model="vm.project_rawmaterial.rawmaterial"--><!--id="rawmaterial"--><!--placeholder="Enter Raw Material">--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-lg-3">--><!--<div class="form-group">--><!--<label for="Quantity" class="col-lg-8 control-label">Quantity</label>--><!--<div class="col-lg-12">--><!--<input type="number" class="form-control"--><!--ng-model="vm.project_rawmaterial.quantity" id="Quantity"--><!--placeholder="Enter Quantity" min="0">--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-lg-3">--><!--<div class="form-group">--><!--<label for="Units" class="col-lg-8 control-label">Units</label>--><!--<div class="col-lg-12">--><!--<select class="form-control"--><!--ng-model="vm.project_rawmaterial.selectedUnit"--><!--ng-options="unit.unittypes for unit in vm.manufacturingunits"--><!--&gt;--><!--</select>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-lg-1">--><!--<div class="form-group">--><!--<label for="Units" class="col-lg-8 control-label">&nbsp;</label>--><!--<div class="col-lg-12">--><!--<button type="button" class="btn btn-primary"--><!--ng-click="vm.addProject_rawmaterialData()">ADD--><!--</button>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-lg-12" ng-show="(vm.projectrawmaterialdata.length!=0)">--><!--<table class="table table-striped table-hover ">--><!--<thead>--><!--<tr>--><!--<th>Raw Material</th>--><!--<th>Quantity</th>--><!--<th>Units</th>--><!--<th>Action</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat="projectrawmaterial in vm.projectrawmaterialdata">--><!--<td>{{projectrawmaterial.rawmaterial}}</td>--><!--<td>{{projectrawmaterial.quantity}}</td>--><!--<td>{{projectrawmaterial.units}}</td>--><!--<td>--><!--<button type="button" class="btn btn-primary pull-center"--><!--value="Deletephase"--><!--data-dpmaxz-eid="41"--><!--ng-Click="vm.removeRawRow(projectrawmaterial.rawmaterial)">--><!--Delete--><!--</button>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><!--&lt;!&ndash; product &ndash;&gt;--><!--<hr/>--><!--<div class="col-lg-12">--><!--<div class="form-group">--><!--<div class="col-lg-3">--><!--<div class="form-group">--><!--<label for="mainproduct" class="col-lg-6 control-label">Main--><!--Product</label>--><!--<div class="col-lg-12">--><!--<input type="text" class="form-control"--><!--ng-model="vm.product.mainproduct" id="mainproduct"--><!--placeholder="Enter Main Product" data-dpmaxz-eid="20">--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-lg-3">--><!--<div class="form-group">--><!--<label for="Quantity" class="col-lg-6 control-label">Quantity</label>--><!--<div class="col-lg-12">--><!--<input type="number" class="form-control"--><!--ng-model="vm.product.quantity" id="Productqty"--><!--placeholder="Enter Quantity" data-dpmaxz-eid="20" min="0">--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-lg-3">--><!--<div class="form-group">--><!--<label for="Units" class="col-lg-6 control-label">Units</label>--><!--<div class="col-lg-12">--><!--<select class="form-control"--><!--ng-model="vm.product.selectedUnit"--><!--ng-options="unit.unittypes for unit in vm.manufacturingunits"--><!--id="Units"--><!--data-dpmaxz-eid="20">--><!--</select>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-lg-3">--><!--<div class="form-group">--><!--<label for="Units" class="col-lg-6 control-label">&nbsp;</label>--><!--<div class="col-lg-12">--><!--<button type="button" class="btn btn-primary" data-dpmaxz-eid="12"--><!--ng-click="vm.addProject_mainproductData()">ADD--><!--</button>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-lg-12" ng-show="(vm.projectmainproductdata.length!=0)">--><!--<table class="table table-striped table-hover">--><!--<thead>--><!--<tr>--><!--<th>Main Product</th>--><!--<th>Quantity</th>--><!--<th>Units</th>--><!--<th>Action</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat="projectmainproduct in vm.projectmainproductdata">--><!--<td>{{projectmainproduct.mainproduct}}</td>--><!--<td>{{projectmainproduct.quantity}}</td>--><!--<td>{{projectmainproduct.units}}</td>--><!--<td>--><!--<button type="button" class="btn btn-primary pull-center"--><!--value="Deletephase"--><!--data-dpmaxz-eid="41"--><!--ng-Click="vm.removeMainRow(projectmainproduct.mainproduct)">--><!--Delete--><!--</button>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><!--<hr/>--><!--<div class="form-group">--><!--<label for="addprocess" class="col-lg-2 control-label">Add Process</label>--><!--<div class="col-lg-7">--><!--<textarea rows="3" ng-model="vm.projectprocessflowstep.steps"--><!--class="form-control"--><!--id="addprocess">--><!--</textarea>--><!--</div>--><!--<div class="col-lg-3">--><!--<button type="button" class="btn btn-primary" data-dpmaxz-eid="12"--><!--ng-click="vm.addProject_processflowstepData()">ADD--><!--</button>--><!--</div>--><!--<div class="col-lg-12" ng-show="(vm.projectprocessflowstepdata.length!=0)">--><!--<table class="table table-striped table-hover ">--><!--<thead>--><!--<tr>--><!--<th class="col-lg-8">Added Process</th>--><!--<th class="pull-right">Action</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat="projectprocessflowstep in vm.projectprocessflowstepdata">--><!--<td class="col-lg-8">{{projectprocessflowstep.steps}}</td>--><!--<td>--><!--<button type="button" class="btn btn-primary pull-right"--><!--value="Deletephase"--><!--ng-Click="vm.removeStepRow(projectprocessflowstep.steps)">--><!--Delete--><!--</button>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!-- end of Manufacturing Data --><!-- Starting Environment Impact --><!--<div class="panel panel-default">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">--><!--<a data-toggle="collapse" data-parent="#accordion" href=".environment">7. Environment Impact--><!--Detail</a>--><!--</h4>--><!--</div>--><!--<div id="environment impact">--><!--<div class="panel-body">--><!--<div class="form-horizontal" data-dpmaxz-eid="7">--><!--<fieldset>--><!--<legend>Environment Impact Detail</legend>--><!--<div>--><!--<div class="row">--><!--<div class="col-md-12">--><!--<label class="control-label col-md-3">Source of Water Supply</label>--><!--<div class="col-lg-3">--><!--<select class="form-control"--><!--ng-model="vm.environmentimpactdetail.selectedWatersource"--><!--ng-options="watersupplysource.watersupplysourcetype for watersupplysource in vm.watersupplysources"--><!--placeholder="Select Source of Water Supply">--><!--</select>--><!--</div>--><!--</div>--><!--</div>--><!--<hr/>--><!--<div class="table table-bordered table-striped" style="min-height:40px;">--><!--<table class="table">--><!--<tbody>--><!--<tr>--><!--<th>Particulars</th>--><!--<th>Process</th>--><!--<th>Cooling</th>--><!--<th>Domestic</th>--><!--<th>Other</th>--><!--</tr>--><!--<tr>--><!--<td>Water Usage (in KL per day)--><!--</td>--><!--<td>--><!--<input class="form-control" name="water_proc"--><!--ng-model="vm.environmentimpactdetail.water_process" min="0"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.water_proc.$invalid && myform.water_proc.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</td>--><!--<td>--><!--<input class="form-control" name="water_col"--><!--ng-model="vm.environmentimpactdetail.water_cooling" min="0"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.water_col.$invalid && myform.water_col.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</td>--><!--<td>--><!--<input class="form-control" name="water_dom"--><!--ng-model="vm.environmentimpactdetail.water_domestic" min="0"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.water_dom.$invalid && myform.water_dom.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</td>--><!--<td>--><!--<input class="form-control"--><!--ng-model="vm.environmentimpactdetail.water_other"/>--><!--</td>--><!--</tr>--><!--<tr>--><!--<td>Waste Water Generation (in KL per day)--><!--<td>--><!--<input class="form-control" name="waste_proc"--><!--ng-model="vm.environmentimpactdetail.waste_water_process"--><!--min="0" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.waste_proc.$invalid && myform.waste_proc.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</td>--><!--<td>--><!--<input class="form-control" name="waste_col"--><!--ng-model="vm.environmentimpactdetail.waste_water_cooling"--><!--min="0" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.waste_col.$invalid && myform.waste_col.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</td>--><!--<td>--><!--<input class="form-control" name="waste_dom"--><!--ng-model="vm.environmentimpactdetail.waste_water_domesting"--><!--min="0" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.waste_dom.$invalid && myform.waste_dom.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</td>--><!--<td>--><!--<input class="form-control"--><!--ng-model="vm.environmentimpactdetail.waste_water_other"/>--><!--</td>--><!--</tr>--><!--<tr>--><!--<td>Waste Water Treatment<br></td>--><!--<td>--><!--<select class="form-control"--><!--ng-model="vm.environmentimpactdetail.selectedTreatmentone"--><!--ng-options="treatmentone.treatment1 for treatmentone in vm.treatment1"--><!--placeholder="Select Waste water treatment One">--><!--</select>--><!--</td>--><!--<td>--><!--<select class="form-control"--><!--ng-model="vm.environmentimpactdetail.selectedTreatmenttwo"--><!--ng-options="treatmenttwo.treatment2 for treatmenttwo in vm.treatment2"--><!--placeholder="Select Waste water treatment Two">--><!--</select>--><!--</td>--><!--<td>--><!--<select class="form-control"--><!--ng-model="vm.environmentimpactdetail.selectedTreatmentthree"--><!--ng-options="treatmentthree.treatment3 for treatmentthree in vm.treatment3"--><!--data-dpmaxz-eid="20"--><!--placeholder="Select Waste water treatment Three">--><!--</select>--><!--<span class="field-validation-valid errorMsg"--><!--data-valmsg-for="WasteWaterTreatmentDomestic"--><!--data-valmsg-replace="true"></span>--><!--<span class="field-validation-valid errorMsg"--><!--data-valmsg-for="RequiredWasteWaterTreatmentDomestic"--><!--data-valmsg-replace="true"></span>--><!--<br>--><!--</td>--><!--<td>--><!--<input class="form-control" data-val="true"--><!--data-val-length="Other waste water treatment must be 1-100 characters long !"--><!--data-val-length-max="100" data-val-length-min="1"--><!--data-val-regex="Other waste water treatment can only have alphanumerics, space and special characters (, - / ()) !"--><!--data-val-regex-pattern="^([0-9a-zA-Z,-/()]+)$"--><!--name="WasteWaterTreatmentOther" type="text"--><!--ng-model="vm.environmentimpactdetail.recycling_other"--><!--value="RECIRCULATION"--><!--autocomplete="off"--><!--autocompletetype="Disable"><br>--><!--<span class="field-validation-valid errorMsg"--><!--data-valmsg-for="WasteWaterTreatmentOther"--><!--data-valmsg-replace="true"></span>--><!--<span class="field-validation-valid errorMsg"--><!--data-valmsg-for="RequiredWasteWaterTreatmentOther"--><!--data-valmsg-replace="true"></span>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--<div class="row">--><!--<div class="col-md-12">--><!--<label class="control-label col-md-3">Mode of disposal for Discharge</label>--><!--<div class="col-lg-3">--><!--<select class="form-control"--><!--ng-model="vm.environmentimpactdetail.selectedDischarge"--><!--ng-options="discharge.disposal_for_discharge for discharge in vm.modeofdisposalfor_discharge"--><!--data-dpmaxz-eid="20" placeholder="Select Waste water treatment">--><!--</select>--><!--</div>--><!--</div>--><!--</div>--><!--<hr/>--><!--<div>--><!--<p class="alert alert-success"--><!--style="font-size:14px; font-weight:bold; width:100%;">--><!--Emission Data</p>--><!--</div>--><!--<div class="table-bordered table-striped table-responsive" style="min-height:40px;">--><!--<table class="table">--><!--<tbody>--><!--<tr>--><!--<th>--><!--Emission Type--><!--</th>--><!--<th>--><!--Capacity--><!--<span style="font-size:small">--><!--(Ton Per Hour / KVA or Mega Watt)--><!--</span>--><!--</th>--><!--<th>--><!--Type of Fuel--><!--</th>--><!--<th>--><!--Air Pollution Control Device--><!--</th>--><!--</tr>--><!--<tr>--><!--<td>--><!--<select class="form-control"--><!--ng-model="vm.emissiondetail.selectedParticular"--><!--ng-options="particular.particulars for particular in vm.particulars"--><!--placeholder="Select Emmision Pollution Controls">--><!--</select>--><!--</td>--><!--<td>--><!--<input class="form-control" data-val="true"--><!--data-val-number="The field Capacity must be a number."--><!--data-val-regex="Please enter only numbers or decimal"--><!--data-val-regex-pattern="^[0-9]{1,9}(\\.[0-9]{0,2})?$"--><!--id="Capacity" name="Capacity"--><!--placeholder="Click here to enter text" type="text"--><!--ng-model="vm.emissiondetail.capacity" value=""--><!--autocomplete="off" autocompletetype="Disable"--><!--data-dpmaxz-eid="36">--><!--<span class="field-validation-valid" data-valmsg-for="Capacity"--><!--data-valmsg-replace="true"></span>--><!--</td>--><!--<td>--><!--<select class="form-control"--><!--ng-model="vm.emissiondetail.selectedTypeoffuel"--><!--ng-options="typeoffuelname.typeoffuel for typeoffuelname in vm.emmision_fuel_types"--><!--data-dpmaxz-eid="20"--><!--placeholder="Select Emmision Fuel Type">--><!--</select>--><!--</td>--><!--<td>--><!--<select class="form-control"--><!--ng-model="vm.emissiondetail.selectedAirpollutioncontroldevice"--><!--ng-options="airpollutioncontroldevicename.airpollutioncontroldevice for airpollutioncontroldevicename in vm.emmision_pollution_controlls"--><!--data-dpmaxz-eid="20"--><!--placeholder="Select Emmision Fuel Type">--><!--</select>--><!--</td>--><!--</tr>--><!--<tr>--><!--<td align="right" colspan="12">--><!--<button type="button" class="btn btn-primary" data-dpmaxz-eid="12"--><!--ng-click="vm.addProject_emissiondetailData()">ADD--><!--</button>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--<div ng-show="(vm.emissiondetaildata.length!=0)">--><!--<table class="table table-curved">--><!--<thead>--><!--<tr>--><!--<th scope="col">--><!--Emission Type--><!--</th>--><!--<th scope="col">--><!--Capacity--><!--</th>--><!--<th scope="col">--><!--Type Of Fuel--><!--</th>--><!--<th scope="col">--><!--Pollution Control Device--><!--</th>--><!--<th>Action</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat="emissiondetail in vm.emissiondetaildata">--><!--<td>{{emissiondetail.particulars}}</td>--><!--<td>{{emissiondetail.capacity}}</td>--><!--<td>{{emissiondetail.type_of_fuel}}</td>--><!--<td>{{emissiondetail.air_pollution_control_device}}</td>--><!--<td>--><!--<button type="button" class="btn btn-primary pull-center"--><!--value="Deletephase"--><!--data-dpmaxz-eid="41"--><!--ng-Click="vm.removeEmissionRow(emissiondetail.selectedParticular)">--><!--Delete--><!--</button>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--<div>--><!--</div>--><!--</div>--><!--<hr/>--><!--<div class="row">--><!--<div class="col-md-12">--><!--<p class="alert alert-success"--><!--style="font-size:14px; font-weight:bold; width:100%;">--><!--Solid Waste Generation Details</p>--><!--</div>--><!--</div>--><!--<div class="table-bordered table-striped table-responsive" style="min-height:40px;">--><!--<table class="table">--><!--<tbody>--><!--<tr>--><!--<th>--><!--Source of Generation--><!--</th>--><!--<th>--><!--Nature/Type--><!--</th>--><!--<th>--><!--Quantity (Tons per Day)--><!--</th>--><!--<th>--><!--Mode of Disposal--><!--</th>--><!--</tr>--><!--<tr>--><!--<td>--><!--<input class="form-control"--><!--ng-model="vm.wastewaterdetail.source_of_generation"--><!--data-val="true"/>--><!--</td>--><!--<td>--><!--<select class="form-control"--><!--ng-model="vm.wastewaterdetail.selectedNaturetype"--><!--ng-options="naturetypename.naturetype for naturetypename in vm.waste_water_naturetype"--><!--data-dpmaxz-eid="20" placeholder="Select Nature of Type">--><!--</select>--><!--<span class="field-validation-valid" data-valmsg-for="NatureOrType"--><!--data-valmsg-replace="true"></span>--><!--</td>--><!--<td>--><!--<input type="number" class="form-control" data-val="true"--><!--ng-model="vm.wastewaterdetail.quantity" min="0"/>--><!--</td>--><!--<td>--><!--<select class="form-control"--><!--ng-model="vm.wastewaterdetail.selectedModeofdisposal"--><!--ng-options="mode_of_disposalname.disposal_for_discharge for mode_of_disposalname in vm.modeofdisposalfor_discharge"--><!--data-dpmaxz-eid="20" placeholder="Select Mode of Dipsosal">--><!--</select>--><!--<span class="field-validation-valid"--><!--data-valmsg-for="ModeOfDisposal"--><!--data-valmsg-replace="true"></span>--><!--</td>--><!--</tr>--><!--<tr>--><!--<td align="right" colspan="6">--><!--<button type="button" class="btn btn-primary" data-dpmaxz-eid="12"--><!--ng-click="vm.addProject_wastewaterdetailData()">ADD--><!--</button>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--<div class="col-lg-12" ng-show="(vm.wastewaterdetaildata.length!=0)">--><!--<table class="table table-striped table-hover ">--><!--<thead>--><!--<tr>--><!--<th>Source of Generation</th>--><!--<th>Nature/Type</th>--><!--<th>Quantity (Tons per Day)</th>--><!--<th>Mode of Disposal</th>--><!--<th>Action</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat="wastewaterdetail in vm.wastewaterdetaildata">--><!--<td>{{wastewaterdetail.source_of_generation}}</td>--><!--<td>{{wastewaterdetail.naturetype}}</td>--><!--<td>{{wastewaterdetail.quantity}}</td>--><!--<td>{{wastewaterdetail.mode_of_disposal}}</td>--><!--<td>--><!--<button type="button" class="btn btn-primary pull-center"--><!--value="Deletephase"--><!--data-dpmaxz-eid="41"--><!--ng-Click="vm.removeSourceRow(wastewaterdetail.source_of_generation)">--><!--Delete--><!--</button>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--<div>--><!--</div>--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!-- Electrict Requirement --><!--<div class="panel panel-default">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">--><!--<a data-toggle="collapse" data-parent="#accordion" href=".electric">8. Electric Requirement</a>--><!--</h4>--><!--</div>--><!--<div id="electric">--><!--<div class="panel-body">--><!--<div class="form-horizontal" data-dpmaxz-eid="7">--><!--<fieldset>--><!--<legend>Electric Requirement Data</legend>--><!--<div id="divElectric">--><!--<div style="background-color:aliceblue;" class="pull-right">--><!--<span class="field-validation-valid errorMsg" data-valmsg-for="SelectEletricPower"--><!--data-valmsg-replace="true" id="SelectEletricPower"></span>--><!--</div>--><!--<div id="temporary" class="row table col-md-12">--><!--<div class="col-md-5">--><!--<label class="control-label col-md-8">--><!--TEMPORARY CONNECTION--><!--<label class="cafSubHeadings" style="margin-left:-15px;">* During--><!--Construction</label><label class="cafSubHeadings"--><!--style="margin-left:-15px;">--><!--</label><br> <br> <br>--><!--* Enclose bill--><!--copy in--><!--case of existing connection--><!--</label>--><!--<div class="row col-md-8">--><!--<table>--><!--<tbody>--><!--<tr>--><!--<td style="border-top:none;">--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><!--<div class="col-md-7">--><!--</div>--><!--<div class="col-md-7" style="min-height:30px;">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Power Company</label>--><!--</div>--><!--<div class="col-md-3">--><!--<label class="control-label">{{vm.projectsitedetail.selectedDistrict.powercompany}}</label>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7" style="min-height:30px;">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Existing Connection</label>--><!--</div>--><!--<div class="col-md-3" id="divTempRunning">--><!--<input type="checkbox"--><!--ng-model="vm.electricrequirement.tem_load_existing">--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Account Number</label>--><!--</div>--><!--<div class="col-md-3">--><!--<input class="form-control" id="TempAccountNo" name="TempAccountNo"--><!--placeholder="Click here" type="text" value="" autocomplete="off"--><!--autocompletetype="Disable" data-dpmaxz-eid="4"--><!--ng-model="vm.electricrequirement.tem_account_number">--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Existing Load Demand (KW) </label>--><!--</div>--><!--<div class="col-md-3">--><!--<input class="form-control" data-val="true"--><!--name="TempExistingLoadKW"--><!--placeholder="0.00"--><!--ng-model="vm.electricrequirement.temp_existing_load_demand_kw"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.TempExistingLoadKW.$invalid && myform.TempExistingLoadKW.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Existing Load Demand (KVA) </label>--><!--</div>--><!--<div class="col-md-3">--><!--<input class="form-control" data-val="true"--><!--name="TempExistingLoadKVA"--><!--placeholder="0.00"--><!--ng-model="vm.electricrequirement.temp_existing_load_demand_kva"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.TempExistingLoadKVA.$invalid && myform.TempExistingLoadKVA.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">New Load Demand (KW) </label>--><!--</div>--><!--<div class="col-md-3">--><!--<input class="form-control" name="LoadDemandKW" placeholder="0.00"--><!--ng-model="vm.electricrequirement.temp_new_load_demand_kw"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.LoadDemandKW.$invalid && myform.LoadDemandKW.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">New Load Demand (KVA) </label>--><!--</div>--><!--<div class="col-md-3">--><!--<input class="form-control" data-val="true"--><!--name="LoadDemandKVA" placeholder="0.00"--><!--ng-model="vm.electricrequirement.temp_new_load_demand_kva"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.LoadDemandKVA.$invalid && myform.LoadDemandKVA.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div id="tDemandDate" class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Demand Date</label>--><!--</div>--><!--<div class="col-md-3">--><!--<input type="date" class="form-control" placeholder="Demand Date"--><!--data-dpmaxz-eid="20"--><!--ng-model="vm.electricrequirement.temp_load_demand_date">--><!--</div>--><!--</div>--><!--</div>--><!--<div id="regular" class="table row col-md-12">--><!--<div class="col-md-5">--><!--<label class="control-label col-md-6">REGULAR CONNECTION<label--><!--style="margin-left:-15px;">* During Commercial Activity</label>--><!--<label class="cafSubHeadings" style="margin-left:-15px;">* Enclose bill--><!--copy--><!--in case of existing connection</label></label><br>--><!--<br><br>--><!--<div class="row col-md-8">--><!--<table>--><!--<tbody>--><!--<tr>--><!--<td style="border-top:none;">--><!--</td>--><!--<td style="border-top:none;">--><!--<span id="rReqBill"--><!--style="color:red; display:none; width:10px;">*</span>--><!--</td>--><!--</tr>--><!--<tr>--><!--<td style="border-top:none;">--><!--<div class="bill_name" style="display:none;"></div>--><!--<div id="divEBill"></div>--><!--<span class="field-validation-valid errorMsg"--><!--data-valmsg-for="ErrorExistingBill"--><!--data-valmsg-replace="true"--><!--id="ErrorExistingBill"></span>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Load Required</label>--><!--</div>--><!--<div class="col-md-3">--><!--<input type="checkbox"--><!--ng-model="vm.electricrequirement.regular_load_required">--><!--</div>--><!--</div>--><!--<div class="col-md-7" style="min-height:30px;">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Power Company</span></label>--><!--</div>--><!--<div class="col-md-3">--><!--<label class="control-label">{{vm.projectsitedetail.selectedDistrict.powercompany}}</label>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7" style="min-height:30px;">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Existing Connection</label>--><!--</div>--><!--<div class="col-md-3" id="divRegRunning">--><!--<input type="checkbox"--><!--ng-model="vm.electricrequirement.regular_existing_connection">--><!--</div>--><!--</div>--><!--<div class="col-md-5"></div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Customer Type</span></label>--><!--</div>--><!--<div class="col-lg-5">--><!--<select class="form-control"--><!--ng-model="vm.electricrequirement.selectedCustomerType"--><!--ng-options="customer.customertype for customer in vm.customerType">--><!--</select>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Account Number</label>--><!--</div>--><!--<div class="col-md-3">--><!--<input class="form-control" id="RegAccountNo" name="RegAccountNo"--><!--placeholder="Click here" type="text" value="" autocomplete="off"--><!--autocompletetype="Disable" data-dpmaxz-eid="12"--><!--ng-model="vm.electricrequirement.regular_account_number">--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Existing Load If Any (In KW)</label>--><!--</div>--><!--<div class="col-md-3">--><!--<input class="form-control" data-val="true"--><!--name="ExistingLoadKW"--><!--placeholder="0.00"--><!--ng-model="vm.electricrequirement.regular_existing_load_ifany_kw"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.ExistingLoadKW.$invalid && myform.ExistingLoadKW.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Existing Load If Any(In KVA)</label>--><!--</div>--><!--<div class="col-md-3">--><!--<input class="form-control" data-val="true"--><!--name="ExistingLoadKVA"--><!--placeholder="0.00"--><!--ng-model="vm.electricrequirement.regular_existing_load_ifany_kva"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.ExistingLoadKVA.$invalid && myform.ExistingLoadKVA.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">New Load Demand (In KW)</label>--><!--</div>--><!--<div class="col-md-3">--><!--<input class="form-control" data-val="true"--><!--name="NewLoadKW" placeholder="0.00"--><!--ng-model="vm.electricrequirement.regular_new_load_demand_kw"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div ng-show="myform.NewLoadKW.$invalid && myform.NewLoadKW.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">New Load Demand (In KVA)</label>--><!--</div>--><!--<div class="col-md-3">--><!--<input class="form-control" data-val="true"--><!--name="NewLoadKVA" placeholder="0.00"--><!--ng-model="vm.electricrequirement.regular_new_load_demand_kva"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"/>--><!--<div--><!--ng-show="myform.NewLoadKVA.$invalid && myform.NewLoadKVA.$touched ">--><!--<small style="color:red; display:block;text-align:ceter">Invalid--><!--Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--</div>--><!--<div id="rDemandDate" class="col-md-7">--><!--<div class="col-md-5" style="text-align:right;">--><!--<label class="control-label">Demand Date</label>--><!--</div>--><!--<div class="col-md-3">--><!--<input type="date" class="form-control" id="regulardemanddate"--><!--placeholder="Demand Date" data-dpmaxz-eid="20"--><!--ng-model="vm.electricrequirement.regular_load_demand_date">--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class="panel panel-default"><div class="panel-heading" ng-hide="vm.renewproject || vm.landrequired"><h4 class="panel-title"><a data-toggle="collapse" data-parent="#accordion" href=".termsandconditions">Terms & Conditions</a></h4></div><div id="termsandconditions"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><!--<p class="alert alert-success"--><!--style="font-size:14px; font-weight:bold; width:100%;">--><!--TERMS AND CONDITIONS</p>--><div class="col-md-1"></div><div class="col-md-12"><ol><li style="padding:10px">I/We <b>{{vm.investor.firstname}}</b>, hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</li><li style="padding:10px">All the required attachments have been completely and legibly attached to this form.</li></ol></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><input type="checkbox" id="chkAccept" style="outline: 2px solid; margin-left:23px" autocomplete="off" ng-model="vm.term_declaration_accept.acceptance" autocompletetype="Disable" data-dpmaxz-eid="18"> I Accept Terms and Conditions</div></div><br><div class="table table-striped" style="min-height:40px"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><div id="PreviousFile"></div><div class="file_name" style="display:none"></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Applicant Signature</label></div><div class="col-md-8" style="margin-top:7px"><input type="file" class="form-control" file-model="vm.cAFAttachmentSign.investorsign" accept="image/*"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Place</label></div><div class="col-md-8" style="margin-top:7px"><input class="form-control capitalize" id="Place" name="Place" placeholder="Click here to enter text" type="text" value="" autocomplete="off" ng-model="vm.term_declaration_accept.place" autocompletetype="Disable" data-dpmaxz-eid="19"> <span class="field-validation-valid" data-valmsg-for="Place" data-valmsg-replace="true"></span></div></div></div></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div><div class="panel-heading"><button type="submit" class="btn btn-primary" data-dpmaxz-eid="12" ng-show="vm.term_declaration_accept.acceptance" ng-disabled="myform.$invalid || file.maxSizeError">Submit Complete Form</button></div></div></div></form></div>');
$templateCache.put('app/addproject/projectTypeShopReg.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Servies</h4></div><div class="modal-body"><pre>\n      <b>LABOUR DEPARTMENT - LABOUR WING</b>\n         License for contractor under provision of Contract Labour\n         Registration certificate of Establishment Inter State Migrant Worker men\n         Registration of Principal Employers\n         Renewal under shops and establishment act\n         Shop Registration under shops and establishment act\n\n        </pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/addproject/projecttype.html','<div class="modal-body"><label class="control-label">Select Project Type</label><div class="row"><div class="col-md-5"><div class="radio"><label><input type="radio" value="NEW" ng-model="vm.projectType" ng-click="vm.onprojectTypeSelected()"> New Enterprise/Expansion/Diversification</label></div></div><div class="col-md-offset-4 col-md-3"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="projecttypeNewEnterprise"><span></span>&nbsp;<span>Services</span></button></div></div><div class="row"><div class="col-md-5"><div class="radio"><label><input type="radio" value="EXIST" ng-model="vm.projectType" ng-click="vm.onprojectTypeSelected()"> Renew of Factory Registration / CTO / CTE / Boiler</label></div></div><div class="col-md-offset-4 col-md-3"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="projecttypeRenewEnterprise"><span></span>&nbsp;<span>Services</span></button></div></div><div class="row"><div class="col-md-5"><div class="radio"><label><input type="radio" value="SHOP" ng-model="vm.projectType" ng-click="vm.onprojectTypeSelected()"> Shop Registration/Renew</label></div></div><div class="col-md-offset-4 col-md-3"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="projecttypeShopEnterprise"><span></span>&nbsp;<span>Services</span></button></div></div><div class="row"><div class="col-md-5"><div class="radio"><label><input type="radio" value="LAND_REQUIREMENT" ng-model="vm.projectType" ng-click="vm.onprojectTypeSelected()"> Land Requirement CAF</label></div></div></div></div>');
$templateCache.put('app/addCAF/CommAndConnPermissions.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Services</h4></div><div class="modal-body"><pre>\n      <b>Communication and Connectivity Permissions</b>\n         Communication and Connectivity Permissions/Renewal(Below Ground)\n         Regularization of existing Tower/Renewal (Above ground)\n         Communication and Connectivity Permissions/Renewal(Above Ground)\n         Renewal/Extension of Communication and Connectivity Permission\n         Right of Way / Right of Use to CABLE TV Operators\n\n      <b>DAKSHIN HARYANA BIJLI VITRAN NIGAM</b>\n         Approval For Regular Electricity Connection (DHBVN)\n         Approval For Temporary Electricity Connection (DHBVN)\n\n      <b>UTTAR HARYANA BIJLI VITRAN NIGAM</b>\n         Approval For Regular Electricity Connection (UHBVN)\n         Approval For Temporary Electricity Connection (UHBVN)\n        </pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/addCAF/addCAFexcise.html','<!--<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.3/jquery.min.js"></script>--><script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/js/bootstrap.min.js"></script><div class="container"><form ng-submit="vm.onsaveProject(\'Final\')" name="exciseform" novalidate><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><button type="button" class="btn btn-primary" data-dpmaxz-eid="12" ng-click="vm.onsaveProject(\'Draft\')" ng-show="vm.excisereq.cafpin==null || vm.excisereq.cafpin==\'NA\'" ng-disabled="exciseform.$invalid || file.maxSizeError">Save Draft</button></h4></div><div id="mandatory"><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Mandatory Fields</legend><div class="form-group"><label class="col-lg-2 control-label">Applicant Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-pattern="/^[a-zA-Z]*$/" ng-model="vm.excisereq.firstname" name="firstname" placeholder="First Name" data-dpmaxz-eid="20" required><div ng-show="exciseform.firstname.$invalid && exciseform.firstname.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="middlename" ng-model="vm.excisereq.middlename" placeholder="Middle Name" data-dpmaxz-eid="20"></div><div class="col-lg-3"><input type="text" class="form-control" id="lastname" placeholder="Last Name" data-dpmaxz-eid="20" ng-model="vm.excisereq.lastname"></div></div><div class="form-group"><label for="email1" class="col-lg-2 control-label">Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email1" placeholder="Primary Email" ng-model="vm.excisereq.emailprimary" required readonly="readonly"><div ng-show="exciseform.input.$invalid && exciseform.input.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="email3" placeholder="Secondary Email" ng-model="vm.excisereq.emailsecondary"></div></div><!--                                <div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">--><!--                                    <label for="email1" class="col-lg-2 control-label">Update Email <span--><!--                                        style="color:red">*</span></label>--><!--                                    <div class="col-lg-3">--><!--                                        <input type="email" name="email" class="form-control" id="email4"--><!--                                               placeholder="Primary Email"--><!--                                               ng-model="vm.excisereq.emailprimary" required>--><!--                                        <div ng-show="exciseform.email.$invalid && exciseform.email.$touched ">--><!--                                            <small style="color:red; display:block;text-align:center">Invalid Input--><!--                                            </small>--><!--                                        </div>--><!--                                    </div>--><!--                                </div>--><div class="form-group"><label class="col-lg-2 control-label">Contact Number<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.excisereq.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" readonly="readonly" required><div ng-show="exciseform.mobileno.$invalid && exciseform.mobileno.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="phonenumber" placeholder="Phone Number" ng-model="vm.excisereq.phonenumber"></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><label class="col-lg-2 control-label">Update Contact Number<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.excisereq.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" required><div ng-show="exciseform.mobileno.$invalid && exciseform.mobileno.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div></div><div class="form-group"><label for="businessentity" class="col-lg-2 control-label" ng-hide="vm.renewproject">Business Entity (M/s)<span style="color:red">*</span></label><div class="col-lg-3" ng-hide="vm.renewproject"><input type="text" class="form-control" id="businessentity" ng-disabled="vm.renewproject" placeholder="Enter Business Entity" ng-model="vm.excisereq.businessentity" required><!--                                        <p><font color="red">*The Proposed Industry/Business Entity  Name should match the name mentioned in the PAN</font></p>--></div></div><div class="form-group"><div class="col-md-12"><p class="text-danger col-md-offset-6">*To know your block enter your village name or visit this <a target="_blank" ng-click="" data-toggle="modal" data-target="#blockCategoryHint">link</a></p></div><label for="district" class="col-lg-2 control-label">District<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="district" ng-model="vm.excisereq.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" required ng-change="vm.getVillages(vm.excisereq.district)"><option value="" disabled="disabled">Select District</option></select></div><label for="district" class="col-lg-2 control-label">Village</label><div class="col-lg-3"><input type="text" class="form-control" id="village" placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.excisereq.district === null" ng-model="vm.excisereq.village" ng-change="vm.setBlockCategory(vm.excisereq.village,vm.villages)"><datalist id="villages"><option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option></datalist></div><div class="col-lg-2"><small ng-show="vm.invalidVillage" class="text-danger">invalid village name</small></div></div><div class="form-group"><label class="col-lg-2 control-label">Category of Block<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="blockCategory" ng-model="vm.excisereq.blockCategory" required><option value="">Select Block</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option></select></div></div><div class="form-group"><label class="col-lg-2 control-label">Total Proposed Project Cost (in Crore) <span style="color:red">*</span></label><div class="col-lg-8"><div class="col-lg-2"><input type="number" class="form-control" name="croresCost" placeholder="Crores" ng-model="vm.project_cost_in_crore" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" required><div ng-show="exciseform.croresCost.$invalid && exciseform.croresCost.$touched || exciseform.croresCost.$error.min"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-2"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.project_cost_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="exciseform.lacsCost.$invalid && exciseform.lacsCost.$touched || exciseform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-3"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.project_cost_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="exciseform.thousandsCost.$invalid && exciseform.thousandsCost.$touched || exciseform.thousandsCost.$error.min"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div></div><div class="form-group"><label class="col-lg-2 control-label">Total Proposed Project Employment <span style="color:red">*</span></label><div class="col-lg-3"><input type="number" class="form-control" id="totalemplotment" placeholder="0" ng-model="vm.landreq.totalpurposedemployment" min="0" required></div></div><div class="form-group"><label for="PanNumber" class="col-lg-2 control-label">PAN Number<span style="color:red">*</span></label><div class="col-lg-2"><input type="text" ng-pattern="/^([A-Z]){5}([0-9]){4}([A-Z]){1}/" class="form-control" id="PanNumber" placeholder="Enter PAN Number" name="PanNumber" ng-model="vm.excisereq.pan_number" maxlength="10" style="text-transform: uppercase" required></div><!-- Verify Button --><div class="col-lg-2"><button type="button" class="btn btn-primary" ng-click="vm.verifyPan()">Verify</button></div><!-- Error Messages, aligned on a new line --><div style="margin-top: 15px" class="col-lg-6" style="margin-top: 5px"><span ng-show="vm.panErrorMessage" class="text-danger">{{ vm.panErrorMessage }}</span> <span ng-show="vm.panSuccessMessage" class="text-success">{{ vm.panSuccessMessage }}</span></div><div ng-show="myform.PanNumber.$invalid"></div></div></fieldset></div></div></div><div id="termsandconditions"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">TERMS AND CONDITIONS</p><div class="col-md-1"></div><div class="col-md-12"><ol><li style="padding:10px">I/We <b>{{vm.excisereq.firstname}}</b>, hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</li><li style="padding:10px">All the required attachments have been completely and legibly attached to this form.</li></ol></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><input type="checkbox" id="chkAccept" style="outline: 2px solid; margin-left:23px" autocomplete="off" ng-model="vm.excisereq.acceptance" autocompletetype="Disable" data-dpmaxz-eid="18"> I Accept Terms and Conditions</div></div><br><div class="table table-striped" style="min-height:40px"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><div id="PreviousFile"></div><div class="file_name" style="display:none"></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Applicant Signature</label></div><div class="col-md-8" style="margin-top:7px"><input type="file" class="form-control" file-model="vm.cAFAttachmentSign.investorsign" accept="image/*"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Place</label></div><div class="col-md-8" style="margin-top:7px"><input class="form-control capitalize" id="Place" name="Place" placeholder="Click here to enter text" type="text" value="" autocomplete="off" ng-model="vm.excisereq.place" autocompletetype="Disable" data-dpmaxz-eid="19"> <span class="field-validation-valid" data-valmsg-for="Place" data-valmsg-replace="true"></span></div></div></div></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div><div class="panel-heading"><button type="submit" class="btn btn-primary" data-dpmaxz-eid="12" ng-show="vm.excisereq.acceptance" ng-disabled="exciseform.$invalid || file.maxSizeError">Submit Complete Form</button></div></div></div></form></div><div id="blockCategoryHint" class="modal fade" role="dialog"><div class="modal-dialog"><embed src="../../content/pdfs/blockCategories.pdf" width="750px" height="1000px"></div></div>');
$templateCache.put('app/addCAF/addCAFfilm.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><!--<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.3/jquery.min.js"></script>--><script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/js/bootstrap.min.js"></script><div class="container"><form ng-submit="vm.onsaveProject(\'Final\')" name="shopform" novalidate><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><button type="button" class="btn btn-primary" data-dpmaxz-eid="12" ng-click="vm.onsaveProject(\'Draft\')" ng-show="vm.landreq.cafpin==null || vm.landreq.cafpin==\'NA\'" ng-disabled="shopform.$invalid || file.maxSizeError">Save Draft</button></h4></div><div id="mandatory"><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Mandatory Fields</legend><div class="form-group"><label class="col-lg-2 control-label">Applicant Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-pattern="/^[a-zA-Z]*$/" ng-model="vm.landreq.firstname" name="firstname" placeholder="First Name" data-dpmaxz-eid="20" required><div ng-show="shopform.firstname.$invalid && shopform.firstname.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="middlename" ng-model="vm.landreq.middlename" placeholder="Middle Name" data-dpmaxz-eid="20"></div><div class="col-lg-3"><input type="text" class="form-control" id="lastname" placeholder="Last Name" data-dpmaxz-eid="20" ng-model="vm.landreq.lastname"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Name of the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="email1" class="col-lg-2 control-label">Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email1" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required readonly="readonly"><div ng-show="shopform.input.$invalid && shopform.input.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="email2" placeholder="Secondary Email" ng-model="vm.landreq.emailsecondary"></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><label for="email1" class="col-lg-2 control-label">Update Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email3" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required><div ng-show="shopform.input.$invalid && shopform.input.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div></div><div class="form-group"><label class="col-lg-2 control-label">Contact Number<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.landreq.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" required><div ng-show="shopform.mobileno.$invalid && shopform.mobileno.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="phonenumber" placeholder="Phone Number" ng-model="vm.landreq.phonenumber"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Contact number the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="businessentity" class="col-lg-2 control-label" ng-hide="vm.renewproject">Business Entity (M/s)<span style="color:red">*</span></label><div class="col-lg-3" ng-hide="vm.renewproject"><input type="text" class="form-control" id="businessentity" ng-disabled="vm.renewproject" placeholder="Enter Business Entity" ng-model="vm.landreq.businessentity" required><!--                                        <p><font color="red">*The Proposed Industry/Business Entity  Name should match the name mentioned in the PAN</font></p>--></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Full name of the Enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="district" class="col-lg-2 control-label">District<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="district" ng-model="vm.landreq.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" required><option value="">Select District</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="District where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="PanNumber" class="col-lg-2 control-label">PAN Number<span style="color:red">*</span></label><div class="col-lg-2"><input type="text" ng-pattern="/^([A-Z]){5}([0-9]){4}([A-Z]){1}/" class="form-control" id="PanNumber" placeholder="Enter PAN Number" name="PanNumber" ng-model="vm.landreq.pan_number" maxlength="10" style="text-transform: uppercase" required></div><!-- Verify Button --><div class="col-lg-2"><button type="button" class="btn btn-primary" ng-click="vm.verifyPan()">Verify</button></div><!-- Error Messages, aligned on a new line --><div style="margin-top: 15px" class="col-lg-6" style="margin-top: 5px"><span ng-show="vm.panErrorMessage" class="text-danger">{{ vm.panErrorMessage }}</span> <span ng-show="vm.panSuccessMessage" class="text-success">{{ vm.panSuccessMessage }}</span></div><div ng-show="myform.PanNumber.$invalid"></div></div></fieldset></div></div></div><div id="termsandconditions"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">TERMS AND CONDITIONS</p><div class="col-md-1"></div><div class="col-md-12"><ol><li style="padding:10px">I/We <b>{{vm.landreq.firstname}}</b>, hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</li><li style="padding:10px">All the required attachments have been completely and legibly attached to this form.</li></ol><div style="padding:10px"><b>Disclaimer</b> : Please ensure that the email and phone no. provided in this form pertain to concerned person who may be contacted regarding the CAF filled through this login. Incorrect/Invalid information provided in this field may lead to de-activation of CAF created through this login.</div></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><input type="checkbox" id="chkAccept" style="outline: 2px solid; margin-left:23px" autocomplete="off" ng-model="vm.landreq.acceptance" autocompletetype="Disable" data-dpmaxz-eid="18"> I Accept Terms and Conditions</div></div><br><div class="table table-striped" style="min-height:40px"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><div id="PreviousFile"></div><div class="file_name" style="display:none"></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Applicant Signature</label></div><div class="col-md-8" style="margin-top:7px"><input type="file" class="form-control" file-model="vm.cAFAttachmentSign.investorsign" accept="image/*"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Place</label></div><div class="col-md-8" style="margin-top:7px"><input class="form-control capitalize" id="Place" name="Place" placeholder="Click here to enter text" type="text" value="" autocomplete="off" ng-model="vm.landreq.place" autocompletetype="Disable" data-dpmaxz-eid="19"> <span class="field-validation-valid" data-valmsg-for="Place" data-valmsg-replace="true"></span></div></div></div></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div><div class="panel-heading"><button type="submit" class="btn btn-primary" data-dpmaxz-eid="12" ng-show="vm.landreq.acceptance" ng-disabled="shopform.$invalid || file.maxSizeError">Submit Complete Form</button></div></div></div></form></div><div id="blockCategoryHint" class="modal fade" role="dialog"><div class="modal-dialog"><embed src="../../content/pdfs/blockCategories.pdf" width="750px" height="1000px"></div></div>');
$templateCache.put('app/addCAF/addCAFlandExchange.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><div class="container"><form ng-submit="vm.onsaveProject(\'Final\')" name="shopform" novalidate><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><button type="button" class="btn btn-primary" data-dpmaxz-eid="12" ng-click="vm.onsaveProject(\'Draft\')" ng-show="vm.landreq.cafpin==null || vm.landreq.cafpin==\'NA\'" ng-disabled="shopform.$invalid || file.maxSizeError">Save Draft</button></h4></div><div id="mandatory"><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Mandatory Fields</legend><div class="form-group"><label class="col-lg-2 control-label">Applicant Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-pattern="/^[a-zA-Z]*$/" ng-model="vm.landreq.firstname" name="firstname" placeholder="First Name" data-dpmaxz-eid="20" required><div ng-show="shopform.firstname.$invalid && shopform.firstname.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="middlename" ng-model="vm.landreq.middlename" placeholder="Middle Name" data-dpmaxz-eid="20"></div><div class="col-lg-3"><input type="text" class="form-control" id="lastname" placeholder="Last Name" data-dpmaxz-eid="20" ng-model="vm.landreq.lastname"></div></div><div class="form-group"><label for="email1" class="col-lg-2 control-label">Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email1" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required readonly="readonly"><div ng-show="shopform.input.$invalid && shopform.input.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="email2" placeholder="Secondary Email" ng-model="vm.landreq.emailsecondary"></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><label for="email1" class="col-lg-2 control-label">Update Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email3" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required><div ng-show="shopform.input.$invalid && shopform.input.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div></div><div class="form-group"><label class="col-lg-2 control-label">Contact Number<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.landreq.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" required><div ng-show="shopform.mobileno.$invalid && shopform.mobileno.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="phonenumber" placeholder="Phone Number" ng-model="vm.landreq.phonenumber"></div></div><div class="form-group"><label for="businessentity" class="col-lg-2 control-label" ng-hide="vm.renewproject">Business Entity (M/s)<span style="color:red">*</span></label><div class="col-lg-3" ng-hide="vm.renewproject"><input type="text" class="form-control" id="businessentity" ng-disabled="vm.renewproject" placeholder="Enter Business Entity" ng-model="vm.landreq.businessentity" required></div><label for="district" class="col-lg-2 control-label">District<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="district" ng-model="vm.landreq.district" ng-change="vm.getBydistrict(vm.landreq.district)" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" required><option value="">Select District</option></select></div></div><div class="form-group"><label for="district" class="col-lg-2 control-label">Select type<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" ng-change="vm.optiontriggerd(vm.value)" ng-model="vm.value"><option value="">Development and Panchayats</option><option value="ulb">URBAN LOCAL BODIES</option></select></div><label ng-show="!vm.show" for="district" class="col-lg-2 control-label">Block<span style="color:red">*</span></label><div ng-show="!vm.show" class="col-lg-3"><select class="form-control" id="block" placeholder="Enter Block Name" ng-model="vm.landreq.block" ng-options="block.blockname as block.blockname for block in vm.blocks" required><option value="">-- Select --</option></select></div><label ng-show="vm.show" for="district" class="col-lg-2 control-label">Municipality<span style="color:red">*</span></label><div ng-show="vm.show" class="col-lg-3"><select class="form-control" id="municipality" placeholder="Enter Municipality Name" ng-model="vm.landreq.mc" ng-options="municipality.municipality_name as municipality.municipality_name for municipality in vm.municipalities" required><option value="">-- Select --</option></select></div></div><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Total Project Cost (in Crore) <span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-8">--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="croresCost"--><!--placeholder="Crores"--><!--ng-model="vm.project_cost_in_crore"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()"--><!--min="0" required/>--><!--<div--><!--ng-show="shopform.croresCost.$invalid && shopform.croresCost.$touched || shopform.croresCost.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">crores--><!--</small>--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="lacsCost" placeholder="lacs"--><!--ng-model="vm.project_cost_in_lacs"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()"--><!--min="0" max="99" required/>--><!--<div--><!--ng-show="shopform.lacsCost.$invalid && shopform.lacsCost.$touched || shopform.lacsCost.$error.min">--><!--<small style="color:red; display:block;text-align:left">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs--><!--</small>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" name="thousandsCost"--><!--placeholder="thousands"--><!--ng-model="vm.project_cost_in_thousands"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"--><!--ng-change="vm.changeInCost()" min="0" max="99" required/>--><!--<div--><!--ng-show="shopform.thousandsCost.$invalid && shopform.thousandsCost.$touched || shopform.thousandsCost.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands--><!--</small>--><!--</div>--><!--</div>--><!--<label class="col-lg-2 control-label">Total Project Employment--><!--<span style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" id="totalemplotment" placeholder="0"--><!--ng-model="vm.landreq.totalpurposedemployment" min="0"--><!--required/>--><!--</div>--></fieldset></div></div></div><div id="termsandconditions"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">TERMS AND CONDITIONS</p><div class="col-md-1"></div><div class="col-md-12"><ol><li style="padding:10px">I/We <b>{{vm.landreq.firstname}}</b>, hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</li><li style="padding:10px">All the required attachments have been completely and legibly attached to this form.</li></ol></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><input type="checkbox" id="chkAccept" style="outline: 2px solid; margin-left:23px" autocomplete="off" ng-model="vm.landreq.acceptance" autocompletetype="Disable" data-dpmaxz-eid="18"> I Accept Terms and Conditions</div></div><br><div class="table table-striped" style="min-height:40px"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><div id="PreviousFile"></div><div class="file_name" style="display:none"></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Applicant Signature</label></div><div class="col-md-8" style="margin-top:7px"><input type="file" class="form-control" file-model="vm.cAFAttachmentSign.investorsign"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Place</label></div><div class="col-md-8" style="margin-top:7px"><input class="form-control capitalize" id="Place" name="Place" placeholder="Click here to enter text" type="text" value="" autocomplete="off" ng-model="vm.landreq.place" autocompletetype="Disable" data-dpmaxz-eid="19"> <span class="field-validation-valid" data-valmsg-for="Place" data-valmsg-replace="true"></span></div></div></div></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div><div class="panel-heading"><button type="submit" class="btn btn-primary" data-dpmaxz-eid="12" ng-show="vm.landreq.acceptance" ng-disabled="shopform.$invalid || file.maxSizeError || (vm.landreq.block ===\'NA\' && vm.landreq.mc ===\'NA\')">Submit Complete Form</button></div></div></div></form></div>');
$templateCache.put('app/addCAF/addCAFlandreq.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><!--<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.3/jquery.min.js"></script>--><script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/js/bootstrap.min.js"></script><div class="container"><form ng-submit="vm.onsaveProject(\'Final\')" name="myform" novalidate><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><button type="button" class="btn btn-primary" data-dpmaxz-eid="12" ng-click="vm.onsaveProject(\'Draft\')" ng-show="vm.landreq.cafpin==null || vm.landreq.cafpin==\'NA\'" ng-disabled="myform.$invalid || file.maxSizeError">Save Draft</button></h4></div><div id="mandatory"><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Mandatory Fields</legend><div class="form-group"><label class="col-lg-2 control-label">Applicant Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-pattern="/^[a-zA-Z]*$/" ng-model="vm.landreq.firstname" name="firstname" placeholder="First Name" data-dpmaxz-eid="20" required><div ng-show="myform.firstname.$invalid && myform.firstname.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="middlename" ng-model="vm.landreq.middlename" placeholder="Middle Name" data-dpmaxz-eid="20"></div><div class="col-lg-3"><input type="text" class="form-control" id="lastname" placeholder="Last Name" data-dpmaxz-eid="20" ng-model="vm.landreq.lastname"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Name of the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="email1" class="col-lg-2 control-label">Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email1" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required readonly="readonly"><div ng-show="myform.input.$invalid && myform.input.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="email2" placeholder="Secondary Email" ng-model="vm.landreq.emailsecondary"></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><label for="email1" class="col-lg-2 control-label">Update Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email3" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required><div ng-show="myform.input.$invalid && myform.input.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div></div><div class="form-group"><label class="col-lg-2 control-label">Contact Number<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.landreq.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" required><div ng-show="myform.mobileno.$invalid && myform.mobileno.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="phonenumber" placeholder="Phone Number" ng-model="vm.landreq.phonenumber"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Contact number the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="businessentity" class="col-lg-2 control-label" ng-hide="vm.renewproject">Business Entity (M/s)<span style="color:red">*</span></label><div class="col-lg-3" ng-hide="vm.renewproject"><input type="text" class="form-control" id="businessentity" ng-disabled="vm.renewproject" placeholder="Enter Business Entity" ng-model="vm.landreq.businessentity" required><!--                                        <p><font color="red">*The Proposed Industry/Business Entity  Name should match the name mentioned in the PAN</font></p>--></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Full name of the Enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><div class="col-md-12"><p class="text-danger col-md-offset-6">*To know your block enter your village name or visit this <a target="_blank" ng-click="vm.blockopen()" data-toggle="modal">link</a></p></div><label for="district" class="col-lg-2 control-label">District<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="district" ng-model="vm.landreq.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" required ng-change="vm.getVillages(vm.landreq.district)"><option value="" disabled="disabled">Select District</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="District where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label for="district" class="col-lg-2 control-label">Village</label><div class="col-lg-3"><input type="text" class="form-control" id="village" placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.landreq.district === null" ng-model="vm.landreq.village" ng-change="vm.setBlockCategory(vm.landreq.village,vm.villages)"><datalist id="villages"><option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option></datalist></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Village where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><div class="col-lg-2"><small ng-show="vm.invalidVillage" class="text-danger">invalid village name</small></div></div><div class="form-group"><label class="col-lg-2 control-label">Category of Block<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="blockCategory" ng-model="vm.landreq.blockCategory" required><option value="">Select Block</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option></select></div></div><div class="form-group"><label class="col-lg-2 control-label">Total Proposed Project Area<span style="color:red">*</span></label><div class="col-lg-8"><div class="col-lg-2"><input type="number" class="form-control" name="acres" placeholder="Acres" ng-model="vm.project_area_in_acres" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()" min="0" required><div ng-show="myform.acres.$invalid && myform.acres.$touched || myform.acres.$error.min"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">acres</small><div class="col-lg-2"><input type="number" class="form-control" name="kanal" placeholder="Kanals" ng-model="vm.project_area_in_kanal" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()" min="0" max="7" required><div ng-show="myform.kanal.$invalid && myform.kanal.$touched || myform.kanal.$error.min && !myform.kanal.$error.max"><small style="color:red; display:block;text-align:left">Invalid Input</small></div><div ng-show="myform.kanal.$error.max"><small style="color:red; display:block;text-align:left">value cannot be more than 7</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">kanal</small><div class="col-lg-3"><input type="number" class="form-control" name="marla" placeholder="Marlas" ng-model="vm.project_area_in_marla" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()" min="0" max="19" required><div ng-show="myform.marla.$invalid && myform.marla.$touched || myform.marla.$error.min && !myform.marla.$error.max"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div><div ng-show="myform.marla.$error.max"><small style="color:red; display:block;text-align:left">value cannot be more than 19</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">marla</small></div></div><div class="form-group"><label class="col-lg-2 control-label">Total Proposed Project Cost (in Crore) <span style="color:red">*</span></label><div class="col-lg-8"><div class="col-lg-2"><input type="number" class="form-control" name="croresCost" placeholder="Crores" ng-model="vm.project_cost_in_crore" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" required><div ng-show="myform.croresCost.$invalid && myform.croresCost.$touched || myform.croresCost.$error.min"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-2"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.project_cost_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-3"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.project_cost_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="myform.thousandsCost.$invalid && myform.thousandsCost.$touched || myform.thousandsCost.$error.min"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div></div><div class="form-group"><label class="col-lg-2 control-label">Total Proposed Project Employment <span style="color:red">*</span></label><div class="col-lg-3"><input type="number" class="form-control" id="totalemplotment" placeholder="0" ng-model="vm.landreq.totalpurposedemployment" min="0" required></div></div><div class="form-group"><label for="PanNumber" class="col-lg-2 control-label">PAN Number<span style="color:red">*</span></label><div class="col-lg-2"><input type="text" ng-pattern="/^([A-Z]){5}([0-9]){4}([A-Z]){1}/" class="form-control" id="PanNumber" placeholder="Enter PAN Number" name="PanNumber" ng-model="vm.landreq.pan_number" maxlength="10" style="text-transform: uppercase" required></div><!-- Verify Button --><div class="col-lg-2"><button type="button" class="btn btn-primary" ng-click="vm.verifyPan()">Verify</button></div><!-- Error Messages, aligned on a new line --><div style="margin-top: 15px" class="col-lg-6" style="margin-top: 5px"><span ng-show="vm.panErrorMessage" class="text-danger">{{ vm.panErrorMessage }}</span> <span ng-show="vm.panSuccessMessage" class="text-success">{{ vm.panSuccessMessage }}</span></div><div ng-show="myform.PanNumber.$invalid"></div></div></fieldset></div></div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title">Land Requirement Details</h4></div><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Land Requirement Details</legend><div class="form-group"><label class="col-md-2 control-label">Land Required<span style="color: red">*</span></label><div class="col-md-3"><select class="form-control" ng-model="vm.landreq.landrequired" ng-options="x for x in vm.landrequiredoptions" ng-required="vm.landrequired"><option value="">Select</option></select></div></div><div class="form-group"><label class="col-md-2 control-label">Plot Size<span style="color: red">*</span></label><div class="col-md-3"><input type="text" class="form-control" placeholder="Plot Size" name="plotsize" ng-model="vm.landreq.plotsize" ng-required="vm.landrequired" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"></div><p class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">sq. yards</p><div ng-show="myform.plotsize.$invalid"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div ng-show="vm.landreq.landrequired==\'In Industrial Estate/Area\'"><div class="form-group"><label class="col-md-2 control-label">Agency Name<span style="color: red">*</span></label><div class="col-md-3"><select class="form-control" ng-model="vm.landreq.agencyname" ng-options="x for x in vm.agencies" ng-required="vm.landreq.landrequired==\'In Industrial Estate/Area\'"><option value="">Select</option></select></div></div><div class="form-group"><label class="col-md-2 control-label">Name of Industrial Estate/Location<span style="color: red">*</span></label><div class="col-md-3"><input type="text" class="form-control" placeholder="Name of Industrial Estate/Location" ng-model="vm.landreq.estatename" ng-required="vm.landreq.landrequired==\'In Industrial Estate/Area\'"></div></div></div><div ng-show="vm.landreq.landrequired==\'Outside Developed Industrial Estate/Area\'"><div class="form-group"><label class="col-md-2 control-label">Expected Purchase Rate/ SQ. Mtr<span style="color: red">*</span></label><div class="col-md-3"><input type="number" class="form-control" placeholder="Expected Purchase Rate" ng-model="vm.landreq.purchaserate" ng-required="vm.landreq.landrequired==\'Outside Developed Industrial Estate/Area\'"></div></div><legend>Location</legend><div class="form-group"><label class="col-md-2 control-label">Village<span style="color: red">*</span></label><div class="col-md-3"><input type="text" class="form-control" placeholder="Village" ng-model="vm.landreq.village" ng-required="vm.landreq.landrequired==\'Outside Developed Industrial Estate/Area\'"></div></div><div class="form-group"><label class="col-md-2 control-label">Tehsil<span style="color: red">*</span></label><div class="col-md-3"><input type="text" class="form-control" placeholder="Tehsil" ng-model="vm.landreq.tehsil" ng-required="vm.landreq.landrequired==\'Outside Developed Industrial Estate/Area\'"></div></div><div class="form-group"><label class="col-md-2 control-label">District<span style="color: red">*</span></label><div class="col-md-3"><input type="text" class="form-control" placeholder="District" ng-model="vm.landreq.landrequirementindistrict" ng-required="vm.landreq.landrequired==\'Outside Developed Industrial Estate/Area\'"></div></div><div class="form-group"><label class="col-md-2 control-label">Land Use Type<span style="color: red">*</span></label><div class="col-md-3"><select class="form-control" ng-model="vm.landreq.landusetype" ng-options="x for x in vm.landusetypes" ng-required="vm.landreq.landrequired==\'Outside Developed Industrial Estate/Area\'"><option value="">Select</option></select></div></div></div><div class="col-md-offset-2"><a target="_blank" href="http://hsiidc.org.in/sites/default/files/E%20Documents/Estate%20Availability.pdf">HSIIDC Plots Availability</a></div></fieldset></div></div></div><div id="termsandconditions"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">TERMS AND CONDITIONS</p><div class="col-md-1"></div><div class="col-md-12"><ol><li style="padding:10px">I/We <b>{{vm.landreq.firstname}}</b>, hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</li><li style="padding:10px">All the required attachments have been completely and legibly attached to this form.</li></ol><div style="padding:10px"><b>Disclaimer</b> : Please ensure that the email and phone no. provided in this form pertain to concerned person who may be contacted regarding the CAF filled through this login. Incorrect/Invalid information provided in this field may lead to de-activation of CAF created through this login.</div></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><input type="checkbox" id="chkAccept" style="outline: 2px solid; margin-left:23px" autocomplete="off" ng-model="vm.landreq.acceptance" autocompletetype="Disable" data-dpmaxz-eid="18"> I Accept Terms and Conditions</div></div><br><div class="table table-striped" style="min-height:40px"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><div id="PreviousFile"></div><div class="file_name" style="display:none"></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Applicant Signature</label></div><div class="col-md-8" style="margin-top:7px"><input type="file" class="form-control" file-model="vm.cAFAttachmentSign.investorsign" accept="image/*"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Place</label></div><div class="col-md-8" style="margin-top:7px"><input class="form-control capitalize" id="Place" name="Place" placeholder="Click here to enter text" type="text" value="" autocomplete="off" ng-model="vm.landreq.place" autocompletetype="Disable" data-dpmaxz-eid="19"> <span class="field-validation-valid" data-valmsg-for="Place" data-valmsg-replace="true"></span></div></div></div></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div><div class="panel-heading"><button type="submit" class="btn btn-primary" data-dpmaxz-eid="12" ng-show="vm.landreq.acceptance" ng-disabled="myform.$invalid || file.maxSizeError">Submit Complete Form</button></div></div></form></div><div class="modal rmPaddingModal" data-backdrop="static" data-keyboard="false" id="blockCategoryHint" tabindex="-1" role="dialog" aria-labelledby="YourModalId1"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal()"><span aria-hidden="true">&times;</span></button><h2 class="text-center">Block Data</h2></div><div class="modal-body"><div class="modal-body"><embed src="../../content/pdfs/blockCategories.pdf" width="560px" height="700px"></div></div></div></div></div>');
$templateCache.put('app/addCAF/addCAFnew.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><div class="container"><form ng-submit="vm.saveProject(\'Final\')" name="myform"><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><button type="button" class="btn btn-primary" data-dpmaxz-eid="12" ng-click="vm.saveProject(\'Draft\')" ng-show="vm.proj.cafpin==null || vm.proj.cafpin==\'NA\'" ng-disabled="myform.$invalid || file.maxSizeError ||vm.total_foreign_investment.includes(\'null\')||vm.total_nri_investment.includes(\'null\')">Save Draft</button> <a data-toggle="collapse" data-parent="#accordion"><center><span data-translate="global.addcafnew.INDUSTRY DETAILS">INDUSTRY DETAILS</span></center></a></h4></div><div><div class="panel-body"><div class="form-horizontal"><fieldset><legend><span data-translate="global.addcafnew.INDUSTRY DETAILS">Industry Detailsz</span></legend><div class="form-group"><label for="businessentity" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Proposed Industry Name">Proposed Industry Name</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" id="businessentity" placeholder="Enter Business Entity" ng-model="vm.proj.businessentity" required><!--                                        <p><font color="red">*The Proposed Industry/Business Entity  Name should match the name mentioned in the PAN</font></p>--></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Full name of the Enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Sector">Sector</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" ng-model="vm.proj.sectorname" ng-change="vm.sectorValueChange(vm.proj.sectorname)" ng-options="sector.sectortype as sector.sectortype for sector in vm.sectors" required><option value="" data-translate="global.addcafnew.select">Select</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="The sector which your Enterprise falls under. Incase, the relevant sector is not present in the list, please select the option Other Industries and input the sector in the textbox provided. " data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><div ng-show="vm.showOtherSector"><label class="col-lg-offset-4 col-lg-2 control-label" data-translate="">Other Sector<span style="color:red">*</span></label></div><div class="col-lg-3" ng-show="vm.showOtherSector"><input type="text" class="form-control" placeholder="Please specify" ng-model="vm.proj.otherFDI"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Product of Manufacture / Service Provided">Product of Manufacture /Service Provided</span> <span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" id="product" placeholder="Enter Product" ng-model="vm.proj.product" required></div><div class="col-md-1"><div><a data-balloon-length="xlarge" data-balloon="Product being manufactured or the Service being provided by your Enterprise" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Expected Start Date of Commercial Production / Operations">Expected Start Date of Commercial Production / Operations</span><span style="color:red">*</span></label><div class="col-lg-3"><div class="input-group"><input type="date" class="form-control" name="prodctionStartDate" placeholder="Select Date" ng-model="vm.proj.prodctionStartDate" datetime-picker="{{dateformat}}" max="2999-01-01" required><!--                                            <span class="input-group-btn">--><!--                                                <button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'prodctionStartDate\')"><i class="glyphicon glyphicon-calendar"></i></button>--><!--                                             </span>--></div></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Proposed date of commencement of operations for your Enterprise" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">State<span--><!--style="color:red">*</span></label></label>--><!--<div class="col-lg-3">--><!--&lt;!&ndash;<select class="form-control" ng-change="vm.loadAllCities()" ng-options="state.state as state.state for state in vm.states" ng-model="vm.proj.statename" id="state">&ndash;&gt;--><!--<select class="form-control" ng-options="state.statename as state.statename for state in vm.states" ng-model="vm.proj.statename" required>--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--<div class="col-lg-1"></div>--><!--</div>--><div class="form-group"><label for="district" class="col-lg-2 control-label"><span data-translate="global.addcafnew.District">District</span> <span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="district" ng-model="vm.proj.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" required ng-change="vm.getVillages(vm.proj.district)"><option value="" disabled="disabled" data-translate="global.addcafnew.Select District">Select District</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="District where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Size of Industry">Size of Industry</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" ng-model="vm.proj.size_of_industry" ng-options="si.sizeofindustry as si.sizeofindustry for si in vm.industrysizes" required><option value="" data-translate="global.addcafnew.select">Select</option></select></div></div><div class="form-group"><div class="col-md-12"><p class="text-danger" data-translate="global.addcafnew.To know your block enter your village name or visit this">*To know your block enter your village name or visit this <a target="_blank" ng-click="vm.blockopen()" data-toggle="modal">link</a></p></div><label for="village" class="col-lg-2 control-label" data-translate="global.addcafnew.Village">Village</label><div class="col-lg-3"><input type="text" class="form-control" id="village" placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.proj.district === null" ng-model="vm.proj.village" ng-change="vm.setBlockCategory(vm.proj.village,vm.villages)"><datalist id="villages"><option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option></datalist></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Village where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Business Entity Type">Business Entity Type</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" ng-model="vm.proj.businessentitytype" ng-options="business.businessentitytype as business.businessentitytype for business in vm.businessentities" required><option value="" data-translate="global.addcafnew.select">Select</option></select></div><div class="col-lg-offset-2 col-lg-2"><small ng-show="vm.invalidVillage"><font color="red">Invalid Village Name</font></small></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Block">Block</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="blockCategory" ng-model="vm.proj.blockCategory" required><option value="" data-translate="global.addcafnew.Select Block">Select Block</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option></select></div><div class="col-lg-1"></div><label class="col-lg-2 control-label" data-translate="global.addcafnew.Investment Type">Investment Type<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" name="investmenttype" ng-change="vm.showOtherInvestment(vm.proj.investmentType)" ng-model="vm.proj.investmentType" required><option value="" disabled="disabled" data-translate="global.addcafnew.Select Investment Type">Select Investment Type</option><option value="New Project">New Project</option><option value="Expansion Project">Expansion/Diversification Project</option><option value="Existing Project (not a new investment in state)">Existing Project (not a new investment in state)</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="1. New Project: Select this option in case your Enterprise is currently planned/proposed to be setup in Haryana\n                                                2. Expansion/Diversification Project: Select this option in case your Enterprise has already been setup in Haryana & an expansion or diversification is planned in the same\n                                                3. Existing Project : Select this option in case your Enterprise has already been setup in Haryana and no new investment is planned currently" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group"><div class="container"><p class="text-warning" data-translate="global.addcafnew.*In case your Total Proposed Investment is greater than INR 10,000 Crores or Total Proposed Project Employment is greater than 10,000, kindly contact our helpdesk at 1800-180-2132 for further assistance.">*In case your Total Proposed Investment is greater than INR 10,000 Crores or Total Proposed Project Employment is greater than 10,000, kindly contact our helpdesk at 1800-180-2132 for further assistance.</p></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Total Proposed Project Area">Total Proposed Project Area</span><span style="color:red">*</span></label><div class="col-lg-8"><div class="col-lg-2"><input type="number" class="form-control" name="acres" placeholder="Acres" ng-model="vm.project_area_in_acres" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()" min="0" required><div ng-show="myform.acres.$invalid && myform.acres.$touched || myform.acres.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.acres">acres</small><div class="col-lg-2"><input type="number" class="form-control" name="kanal" placeholder="Kanals" ng-model="vm.project_area_in_kanal" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()" min="0" max="7" required><div ng-show="myform.kanal.$invalid && myform.kanal.$touched || myform.kanal.$error.min && !myform.kanal.$error.max"><small style="color:red; display:block;text-align:left">Invalid Input</small></div><div ng-show="myform.kanal.$error.max"><small style="color:red; display:block;text-align:left">value cannot be more than 7</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.kanal">kanal</small><div class="col-lg-3"><input type="number" class="form-control" name="marla" placeholder="Marlas" ng-model="vm.project_area_in_marla" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()" min="0" max="19" required><div ng-show="myform.marla.$invalid && myform.marla.$touched || myform.marla.$error.min && !myform.marla.$error.max"><small style="color:red; display:block;text-align:center">Invalid Input</small></div><div ng-show="myform.marla.$error.max"><small style="color:red; display:block;text-align:left">value cannot be more than 19</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.marla">marla</small></div></div><div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Total Proposed Project Cost (in Crore)">Total Proposed Project Cost (in Crore) </span><span style="color:red">*</span></label><div class="col-lg-8"><div class="col-lg-2"><input type="number" class="form-control" name="croresCost" placeholder="Crores" ng-model="vm.project_cost_in_crore" maxlength="5" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" required><div ng-show="myform.croresCost.$invalid && myform.croresCost.$touched || myform.croresCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.crores">crores</small><div class="col-lg-2"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.project_cost_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.lacs">lacs</small><div class="col-lg-3"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.project_cost_in_thousands" ng-model="vm.project_cost_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="myform.thousandsCost.$invalid && myform.thousandsCost.$touched || myform.thousandsCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.thousands">thousands</small></div></div><div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group"><div class="col-md-6"><label class="col-lg-4 control-label"><span data-translate="global.addcafnew.Total Proposed Project Employment">Total Proposed Project Employment</span> <span style="color:red">*</span></label><div class="col-lg-3"><input type="number" class="form-control" id="totalemployment" placeholder="Proposed Employment" name="totalEmployment" ng-model="vm.proj.totalpurposedemployment" min="0" maxlength="5" required><div ng-show="myform.totalEmployment.$invalid && myform.totalEmployment.$touched || myform.totalEmployment.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div></div></div><div class="form-group" ng-if="(vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\') && vm.proj.totalpurposedemployment != 0"><label ng-show="vm.proj.totalpurposedemployment" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Haryana Domicile">Haryana Domicile</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="number" class="form-control" id="Haryana_Domicile" placeholder="0" ng-model="vm.proj.haryanadomicile" id="haryanaDomicile" ng-change="vm.proposedEmployment(\'haryana\')" min="0" ng-show="vm.proj.totalpurposedemployment" required></div><label ng-show="vm.proj.totalpurposedemployment" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Non Haryana Domicile">Non Haryana Domicile</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="number" class="form-control" id="Non_Haryana_Domicile" placeholder="0" ng-model="vm.proj.nonharyanadomicile" ng-change="vm.proposedEmployment(\'nonHaryana\')" min="0" ng-show="vm.proj.totalpurposedemployment" required></div></div><div class="form-group"><label for="siteaddress" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Site Address">Site Address</span> <span style="color:red">*</span></label><div class="col-lg-3"><textarea class="form-control" rows="3" id="siteaddress" name="siteaddress" placeholder="Enter Site Address" ng-model="vm.proj.siteaddress" required></textarea><div ng-show="myform.siteaddress.$invalid && myform.siteaddress.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="The complete address of the enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Foreign Direct Investment">Foreign Direct Investment</span><span style="color:red">*</span></label>{{foreign_investment}}<div class="col-md-2"><div class="radio text-center"><label class="col-md-6"><input ng-model="vm.radioToggle" value="Yes" type="radio" name="optradio" ng-click="vm.showFDI = true" data-translate="global.addcafnew.yes">Yes</label><label class="col-md-6"><input ng-model="vm.radioToggle" value="No" type="radio" name="optradio" checked="checked" ng-click="vm.showFDI = false" data-translate="global.addcafnew.no">No</label></div></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Information on investment/ownership in the Enterprise by an entity or individual located outside India" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div ng-show="vm.showFDI" class="form-group"><div class="col-lg-2 control-label"><label class="control-label"><span data-translate="global.addcafnew.Specify, FDI">Specify, FDI</span><span style="color:red">*</span></label></div><div class="col-lg-1"><input type="number" class="form-control" name="foreigncostcrores" placeholder="0" ng-model="vm.foreigninvestment_in_crores" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0"><div ng-show="myform.foreigncostcrores.$invalid || myform.foreigncostcrores.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.crores">crores</small><div class="col-lg-1"><input type="number" class="form-control" name="foreigncostlacs" placeholder="0" ng-model="vm.foreigninvestment_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0" max="99"><div ng-show="myform.foreigncostlacs.$invalid || myform.foreigncostlacs.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.lacs">lacs</small><div class="col-lg-1"><input type="number" class="form-control" name="foreigncostthousand" placeholder="0" ng-model="vm.foreigninvestment_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0" max="99"><div ng-show="myform.foreigncostthousand.$invalid || myform.foreigncostthousand.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.thousands">thousands</small><label class="col-lg-2 control-label" data-translate="global.addcafnew.Country of Origin">Country of Origin</label><div class="col-lg-3"><select class="form-control" ng-options="country.name as country.name for country in vm.allcountries" ng-model="vm.proj.countryname"><option value="" data-translate="global.addcafnew.select">Select</option></select></div><div class="col-lg-1"></div></div><div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group"><label for="powerrequirement" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Power Load Requirement">Power Load Requirement</span> <span style="color:red">*</span></label><div class="col-lg-3"><input type="number" class="form-control" id="powerrequirement" name="powerrequirement" placeholder="Enter Power Load Requirement" ng-model="vm.proj.powerRequirement" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" min="0" max="99999" required><div ng-show="myform.powerrequirement.$invalid && myform.powerrequirement.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.KW">KW</small><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="The estimated power load requirement for the Enterprise" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div></fieldset></div></div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-parent="#accordion" href=".invt"><center><span data-translate="global.addcafnew.Personal Details">PERSONAL DETAILS</span></center></a></h4></div><div id="invt"><div class="panel-body"><div class="form-horizontal"><fieldset><legend><span data-translate="global.addcafnew.Personal Details">Personal Details</span></legend><div class="form-group"><label for="designation" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Designation in the Firm">Designation in the Firm</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="designation" ng-model="vm.proj.designation" required><option value="" data-translate="global.addcafnew.Select Designation">Select Designation</option><option value="Director">Director</option><option value="Entrepreneur">Entrepreneur</option><option value="Partner">Partner</option><option value="Professional">Professional</option><option value="Authorized Representative">Authorized Representative</option></select></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Applicant Name">Applicant Name</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-pattern="/^[a-zA-Z]*$/" ng-model="vm.proj.firstname" name="firstname" placeholder="First Name" data-dpmaxz-eid="20" required><div ng-show="myform.firstname.$invalid && myform.firstname.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="middlename" ng-model="vm.proj.middlename" placeholder="Middle Name" data-dpmaxz-eid="20"></div><div class="col-lg-3"><input type="text" class="form-control" id="lastname" placeholder="Last Name" data-dpmaxz-eid="20" ng-model="vm.proj.lastname" required></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Name of the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Mobile Number">Mobile Number</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.proj.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" required readonly="readonly"><div ng-show="myform.mobileno.$invalid && myform.mobileno.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="phonenumber"--><!--placeholder="Phone Number"--><!--ng-model="vm.proj.phonenumber">--><!--</div>--><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Contact number the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Update Mobile Number">Update Mobile Number</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.proj.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" required><div ng-show="myform.mobileno.$invalid && myform.mobileno.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div></div><div class="form-group"><label for="email1" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Email">Email</span> <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="email" class="form-control" id="email1" placeholder="Primary Email" ng-model="vm.proj.emailprimary" required readonly="readonly"><div ng-show="myform.email.$invalid && myform.email.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="email2" placeholder="Secondary Email" ng-model="vm.proj.emailsecondary"></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><label for="email1" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Update Email">Update Email</span> <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="email" class="form-control" id="email3" placeholder="Primary Email" ng-model="vm.proj.emailprimary" required><div ng-show="myform.email.$invalid && myform.email.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div></div><div class="form-group"><label for="PanNumber" class="col-lg-2 control-label"><span data-translate="global.addcafnew.PAN Number">PAN Number</span><span style="color:red">*</span></label><div class="col-lg-2"><input type="text" ng-pattern="/^([A-Z]){5}([0-9]){4}([A-Z]){1}/" class="form-control" id="PanNumber" placeholder="Enter PAN Number" name="PanNumber" ng-model="vm.proj.pan_number" maxlength="10" style="text-transform: uppercase" required></div><!-- Verify Button --><div class="col-lg-2"><button type="button" class="btn btn-primary" ng-click="vm.verifyPan()"><span data-translate="global.addcafnew.Verify">Verify</span></button></div><!-- Error Messages --><div style="margin-top: 15px" ng-show="vm.panErrorMessage" class="text-danger">{{ vm.panErrorMessage }}</div><div style="margin-top: 15px" ng-show="vm.panSuccessMessage" class="text-success">{{ vm.panSuccessMessage }}</div><div ng-show="myform.PanNumber.$invalid"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Applicant Photo">Applicant Photo</span><span style="color:red">*</span></label><div class="col-lg-3 text-danger"><input type="file" class="form-control input" file-model="vm.cAFAttachmentPhoto.investorphoto" accept=".jpeg,.jpg,.png" required><p><span data-translate="global.addcafnew.Max file size (1 MB) and image files accepted with extension .jpg, .png, .jpeg">Max file size (1 MB) and image files accepted with extension .jpg, .png, .jpeg</span></p><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-lg-3" ng-if="vm.cafAttachementInvestorPhoto.fileName"><div class="thumbnail pull-right panel-body"><img src="{{vm.investorphoto1}}" style="height:150px; width: 150px"></div></div></div><!--<div class="form-group">--><!--<label for="siteaddress" class="col-lg-2 control-label">Site Address--><!--<span style="color:red">*</span></label>--><!--<div class="col-lg-3"><textarea class="form-control" rows="3" id="siteaddress"--><!--name="siteaddress"    placeholder="Enter Site Address"--><!--ng-model="vm.proj.siteaddress" required></textarea>--><!--<div ng-show="myform.siteaddress.$invalid && myform.siteaddress.$touched ">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="The complete address of the enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<div class="col-md-12">--><!--<p class="text-danger col-md-offset-6">*To know your block enter your village name or visit this--><!--<a target="_blank" ng-click="" data-toggle="modal" data-target="#blockCategoryHint">link</a>--><!--</p>--><!--</div>--><!--<label for="district" class="col-lg-2 control-label">District<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<select class="form-control" id="district"--><!--ng-model="vm.proj.district"--><!--ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'"--><!--required ng-change="vm.getVillages(vm.proj.district)">--><!--<option value="" disabled>Select District</option>--><!--</select>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="District where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--<label for="district" class="col-lg-2 control-label">Village</label>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="village"--><!--placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.proj.district === null"--><!--ng-model="vm.proj.village" ng-change="vm.setBlockCategory(vm.proj.village,vm.villages)"/>--><!--<datalist id="villages">--><!--<option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option>--><!--</datalist>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Village where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--<div class="col-lg-2">--><!--<small ng-show="vm.invalidVillage" class="text-danger">invalid village name</small>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Category of Block<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<select class="form-control" id="blockCategory"--><!--ng-model="vm.proj.blockCategory"--><!--required>--><!--<option value="">Select Block</option>--><!--<option value="A">A</option>--><!--<option value="B">B</option>--><!--<option value="C">C</option>--><!--<option value="D">D</option>--><!--</select>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--</div>--><!--</div>--><!--<label class="col-lg-2 control-label">Land Zone Use Type<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<select class="form-control" name="landzonetype"--><!--ng-model="vm.proj.landzoneuse_type"--><!--ng-options="landzoneclassificationtype.landzoneclassificationtype as landzoneclassificationtype.landzoneclassificationtype for landzoneclassificationtype in vm.landusezoneclassifications"--><!--required>--><!--<option value="">Select Land Zone</option>--><!--</select>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Type of land on which the Enterprise is setup or proposed to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Investment Type<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<select class="form-control" name="investmenttype" ng-change="vm.showOtherInvestment(vm.proj.investmentType)"--><!--ng-model="vm.proj.investmentType" required>--><!--<option value="" disabled>Select Investment Type</option>--><!--<option value="New Project">New Project</option>--><!--<option value="Expansion Project">Expansion/Diversification Project</option>--><!--<option value="Existing Project (not a new investment in state)">Existing Project (not a new investment in state)</option>--><!--</select>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="1. New Project: Select this option in case your Enterprise is currently planned/proposed to be setup in Haryana--><!--2. Expansion/Diversification Project: Select this option in case your Enterprise has already been setup in Haryana & an expansion or diversification is planned in the same--><!--3. Existing Project : Select this option in case your Enterprise has already been setup in Haryana and no new investment is planned currently" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--</div>--><!--<div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group">--><!--<div class="container"><p class="text-warning">*In case your Total Proposed Investment is greater than INR 10,000 Crores or Total Proposed Project Employment is greater than 10,000, kindly contact our helpdesk at 1800-180-2132 for further assistance.</p></div>--><!--<label class="col-lg-2 control-label">Total Proposed Project Area<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-8">--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="acres"--><!--placeholder="Acres"--><!--ng-model="vm.project_area_in_acres"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()"--><!--min="0" required/>--><!--<div--><!--ng-show="myform.acres.$invalid && myform.acres.$touched || myform.acres.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">acres--><!--</small>--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="kanal" placeholder="Kanals"--><!--ng-model="vm.project_area_in_kanal"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()"--><!--min="0" max="7" required/>--><!--<div--><!--ng-show="myform.kanal.$invalid && myform.kanal.$touched || myform.kanal.$error.min && !myform.kanal.$error.max">--><!--<small style="color:red; display:block;text-align:left">Invalid Input--><!--</small>--><!--</div>--><!--<div--><!--ng-show="myform.kanal.$error.max">--><!--<small style="color:red; display:block;text-align:left">value cannot be--><!--more than 7--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">kanal--><!--</small>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" name="marla"--><!--placeholder="Marlas"--><!--ng-model="vm.project_area_in_marla"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"--><!--ng-change="vm.changeInArea()" min="0" max="19" required/>--><!--<div--><!--ng-show="myform.marla.$invalid && myform.marla.$touched || myform.marla.$error.min && !myform.marla.$error.max">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--<div--><!--ng-show="myform.marla.$error.max">--><!--<small style="color:red; display:block;text-align:left">value cannot be--><!--more than 19--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left" style="margin-top:10px;margin-left:-10px">marla</small>--><!--</div>--><!--</div>--><!--<div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group">--><!--<label class="col-lg-2 control-label">Total Proposed Project Cost (in Crore) <span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-8">--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="croresCost"--><!--placeholder="Crores"--><!--ng-model="vm.project_cost_in_crore"--><!--maxlength="4"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()"--><!--min="0" required/>--><!--<div--><!--ng-show="myform.croresCost.$invalid && myform.croresCost.$touched || myform.croresCost.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">crores--><!--</small>--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="lacsCost" placeholder="lacs"--><!--ng-model="vm.project_cost_in_lacs"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()"--><!--min="0" max="99" required/>--><!--<div--><!--ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min">--><!--<small style="color:red; display:block;text-align:left">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs--><!--</small>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" name="thousandsCost"--><!--placeholder="thousands"--><!--ng-model="vm.project_cost_in_thousands"--><!--ng-model="vm.project_cost_in_thousands"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"--><!--ng-change="vm.changeInCost()" min="0" max="99" required/>--><!--<div--><!--ng-show="myform.thousandsCost.$invalid && myform.thousandsCost.$touched || myform.thousandsCost.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands--><!--</small>--><!--</div>--><!--</div>--><!--<div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group">--><!--<div class="col-md-6">--><!--<label class=" col-lg-4 control-label">Total Proposed Project Employment--><!--<span style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" id="totalemployment" placeholder="Proposed Employment" name="totalEmployment"--><!--ng-model="vm.proj.totalpurposedemployment" min="0" maxlength="4"--><!--required/>--><!--<div--><!--ng-show="myform.totalEmployment.$invalid && myform.totalEmployment.$touched || myform.totalEmployment.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group" ng-if="(vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\') && vm.proj.totalpurposedemployment != 0">--><!--<label ng-show="vm.proj.totalpurposedemployment" class="col-lg-2 control-label" >Haryana Domicile--><!--<span style="color:red">*</span></label>--><!--<div class="col-lg-3" >--><!--<input type="number" class="form-control" id="Haryana_Domicile" placeholder="0"--><!--ng-model="vm.proj.haryanadomicile" id="haryanaDomicile" ng-change="vm.proposedEmployment(\'haryana\')" min="0" ng-show="vm.proj.totalpurposedemployment"--><!--required/>--><!--</div>--><!--<label ng-show="vm.proj.totalpurposedemployment" class="col-lg-2 control-label">Non Haryana Domicile--><!--<span style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<input type="number"  class="form-control" id="Non_Haryana_Domicile" placeholder="0"--><!--ng-model="vm.proj.nonharyanadomicile" ng-change="vm.proposedEmployment(\'nonHaryana\')" min="0" ng-show="vm.proj.totalpurposedemployment"--><!--required/>--><!--</div>--><!--</div>--><!--<div class="col-md-12">--><!--<div class="col-md-5">--><!--<label class="col-lg-4 control-label">Product of Manufacture /Service Provided--><!--<span style="color:red">*</span></label>--><!--<div class="col-lg-7">--><!--<input type="text" class="form-control" id="product" placeholder="Enter Product"--><!--ng-model="vm.proj.product"--><!--required/>--><!--</div>--><!--</div>--><!--<div class="col-md-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Product being manufactured or the Service being provided by your Enterprise" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--<label class="col-lg-2 control-label">CLU Required</label>--><!--<div class="col-lg-2">--><!--<label><input type="checkbox" name="checkConfirmityoflanduse"--><!--ng-model="vm.proj.clurequired"> Required </label>--><!--</div>--><!--<div class="col-lg-4">--><!--<h5><i><span--><!--style="color:red">*</span>Check if CLU is required.</i></h5>--><!--</div>--><!--</div>--><!--<div class="col-md-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Please check this box if you wish to apply for Change of Land Use" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--</div>--><!--<div class="form-group">--><!--<div class="col-md-2" ng-show="vm.showOtherInvestmentType">--><!--<label class="control-label">Other Investment Type<span--><!--style="color:red">*</span></label>--><!--</div>--><!--<div class="col-md-3" ng-show="vm.showOtherInvestmentType">--><!--<input type="text" class="form-control"--><!--placeholder="Please specify" ng-model="vm.proj.otherInvestmetType"/>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Expected Start Date of Commercial Production / Operations<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<div class="input-group">--><!--<input type="date" class="form-control" placeholder="Select Date" name="prodctionStartDate"--><!--ng-model="vm.proj.prodctionStartDate" datetime-picker="{{dateformat}}"--><!--is-open="vm.datePickerOpenStatus.prodctionStartDate" required/>--><!--<span class="input-group-btn">--><!--<button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'prodctionStartDate\')"><i class="glyphicon glyphicon-calendar"></i></button>--><!--</span>--><!--</div>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Proposed date of commencement of operations for your Enterprise" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Foreign Direct Investment<span--><!--style="color:red">*</span></label>{{foreign_investment}}--><!--<div class="col-md-2">--><!--<div class="radio text-center">--><!--<label class="col-md-6"><input ng-model="vm.radioToggle" value="Yes" type="radio" name="optradio" ng-click="vm.showFDI = true">Yes</label>--><!--<label class="col-md-6"><input ng-model="vm.radioToggle" value="No" type="radio" name="optradio" checked ng-click="vm.showFDI = false">No</label>--><!--</div>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Information on investment/ownership in the Enterprise by an entity or individual located outside India" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--<div ng-show="vm.showFDI" class="col-lg-7">--><!--<div class="col-md-2">--><!--<label class="control-label">Specify, FDI<span--><!--style="color:red">*</span></label>--><!--</div>--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="foreigncostcrores"--><!--placeholder="Crores" ng-model="vm.foreigninvestment_in_crores"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0"/>--><!--<div--><!--ng-show="myform.foreigncostcrores.$invalid || myform.foreigncostcrores.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">crores--><!--</small>--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="foreigncostlacs" placeholder="lacs"--><!--ng-model="vm.foreigninvestment_in_lacs"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()"--><!--min="0" max="99"/>--><!--<div--><!--ng-show="myform.foreigncostlacs.$invalid || myform.foreigncostlacs.$error.min">--><!--<small style="color:red; display:block;text-align:left">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs--><!--</small>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" name="foreigncostthousand"--><!--placeholder="thousands"--><!--ng-model="vm.foreigninvestment_in_thousands"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"--><!--ng-change="vm.changeInForeignInvestment()" min="0" max="99"/>--><!--<div--><!--ng-show="myform.foreigncostthousand.$invalid || myform.foreigncostthousand.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands--><!--</small>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="PanNumber" class="col-lg-2 control-label">PAN Number<span style="color:red">*</span></label></label>--><!--<div class="col-lg-2"><input type="text" ng-pattern="/^([A-Z]){5}([0-9]){4}([A-Z]){1}/"  class="form-control" id="PanNumber"--><!--placeholder="Enter PAN Number" name="PanNumber"--><!--ng-model="vm.proj.pan_number" maxlength="10" required>--><!--</div>--><!--<div class="text-danger"><b>*</b>Enter PAN in Uppercase--><!--</div>--><!--</div>--><!--<div ng-show="myform.PanNumber.$invalid">--><!--<div class="text-danger"><b>*</b>PAN Number must be in Correct Format--><!--</div>--><!--</div>--></fieldset></div></div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-parent="#accordion"><center><span data-translate="global.addcafnew.LAND USE DETAILS">LAND USE DETAILS</span></center></a></h4></div><div><div class="panel-body"><div class="form-horizontal"><fieldset><legend><span data-translate="global.addcafnew.LAND USE DETAILS">Land Use Details</span></legend><div class="form-group" ng-show="vm.showEstateConfirmation"><label for="isIndustrialEstate" class="col-lg-2 control-label">Whether your business entity falls under HSIIDC Industrial Estate (Yes/No)<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="isIndustrialEstate" ng-model="vm.isIndustrialEstate" required ng-change="vm.getIndustrialEstates(vm.isIndustrialEstate)"><option value="" disabled="disabled">Select an option</option><option value="yes">Yes</option><option value="no">No</option></select></div><label ng-if="vm.showIndustrialEstates" for="industrialEstates" class="col-lg-2 control-label">Choose HSIIDC Industrial Estate<span style="color:red">*</span></label><div class="col-lg-3" ng-if="vm.showIndustrialEstates"><select class="form-control" id="industrialEstates" ng-model="vm.proj.industrialEstate" ng-options="estate.estate as estate.estate for estate in vm.estates | orderBy: \'estate\'" required><option value="" disabled="disabled">Select HSIIDC Estate</option></select></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Land Zone Use Type">Land Zone Use Type</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" name="landzonetype" ng-model="vm.proj.landzoneuse_type" ng-options="landzoneclassificationtype.landzoneclassificationtype as landzoneclassificationtype.landzoneclassificationtype for landzoneclassificationtype in vm.landusezoneclassifications" required><option value="" data-translate="global.addcafnew.Select Land Zone">Select Land Zone</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Type of land on which the Enterprise is setup or proposed to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label class="col-lg-2 control-label" data-translate="global.addcafnew.CLU Required">CLU Required</label><div class="col-lg-2"><label><input type="checkbox" name="checkConfirmityoflanduse" ng-model="vm.proj.clurequired" data-translate="global.addcafnew.Required"> Required &nbsp&nbsp <a data-balloon-length="xlarge" data-balloon="Please check this box if you wish to apply for Change of Land Use" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></label></div><div class="col-lg-4"><div class="text-danger"><b>*</b><span data-translate="global.addcafnew.Check if CLU is required.">Check if CLU is required.</span></div></div><!--<div class="col-md-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Please check this box if you wish to apply for Change of Land Use" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--></div><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">State</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-change="vm.loadAllCities()" ng-options="state.state as state.state for state in vm.states" ng-model="vm.proj.statename" id="state">--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">City</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.cityname" placeholder="Select City"--><!--ng-options="city for city in vm.cities">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">NRI Investment, If any</label>--><!--<div class="col-lg-8">--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="nricostcrores"--><!--placeholder="Crores"--><!--ng-model="vm.nri_investment_in_crore"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInNri_investment()"--><!--min="0"/>--><!--<div--><!--ng-show="myform.nricostcrores.$invalid || myform.nricostcrores.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">crores--><!--</small>--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="nricostlacs" placeholder="lacs"--><!--ng-model="vm.nri_investment_in_lacs"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInNri_investment()"--><!--min="0" max="99"/>--><!--<div--><!--ng-show="myform.nricostlacs.$invalid || myform.nricostlacs.$error.min">--><!--<small style="color:red; display:block;text-align:left">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs--><!--</small>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" name="nricostthousand"--><!--placeholder="thousands"--><!--ng-model="vm.nri_investment_in_thousands"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"--><!--ng-change="vm.changeInNri_investment()" min="0" max="99"/>--><!--<div--><!--ng-show="myform.nricostthousand.$invalid || myform.nricostthousand.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands--><!--</small>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="address1" class="col-lg-2 control-label">Address</label>--><!--<div class="col-lg-3">--><!--<textarea class="form-control" rows="3" id="address1" Placeholder="Address 1"--><!--ng-model="vm.proj.address1" ng-keydown="$event.keyCode === 13 && enterEvent($event)" ng-change="vm.errorMessage()"></textarea>--><!--</div>--><!--<p ng-show="vm.ShowError"><font color="red">Enter Not Allowed In Address Field</font></p>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Applicant Photo<span style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<input type="file" class="form-control input" file-Model="vm.cAFAttachmentPhoto.investorphoto" accept=".jpeg,.jpg,.png" required/>--><!--<p><font color="red">Max file size (1 MB) and image files accepted with extension .jpg, .png, .jpeg</font></p>--><!--<p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1--><!--MB)</font></p>--><!--</div>--><!--</div>--></fieldset></div></div></div></div><!--<div class="panel panel-default">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">--><!--<a data-toggle="collapse" data-parent="#accordion" href=".collapseTwo">2. Company Detail</a>--><!--</h4>--><!--</div>--><!--<div id="collapseTwo">--><!--<div class="panel-body">--><!--<div class="form-horizontal">--><!--<fieldset>--><!--<legend>Company Detail</legend>--><!--<div class="form-group">--><!--<label class="col-lg-3 control-label">Business Entity Type</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.businessentitytype"--><!--ng-options="business.businessentitytype as business.businessentitytype for business in vm.businessentities">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="mddirector" class="col-lg-3 control-label">Promoter / MD /--><!--Director</label>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="mddirector" placeholder="Enter Name"--><!--ng-model="vm.proj.promoter_md_director">--><!--</div>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="designation"--><!--placeholder="Enter Designation"--><!--ng-model="vm.proj.designation">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="promotor" class="col-lg-3 control-label">No. of Directors/ Promoters--><!--/MDs--><!--/CEO</label>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" id="promotor"--><!--ng-model="vm.proj.director_promoter_md_ceo_number" min="0">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="aadharnumber" class="col-lg-3 control-label">Aadhar Number</label>--><!--<div class="col-lg-3"><input type="text" class="form-control" id="aadharnumber"--><!--placeholder="Enter Aadhar Number"--><!--ng-model="vm.proj.aadhar_number"--><!--maxlength="12"></div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-3 control-label">Applicant is NRI?</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="radioISNRI" checked="false"--><!--ng-model="vm.proj.nri">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="gstnumber" class="col-lg-3 control-label">GST Number</label>--><!--<div class="col-lg-3"><input type="text" class="form-control" id="gstnumber"--><!--placeholder="Enter GST Number"--><!--ng-model="vm.proj.gstnumber"></div>--><!--</div>--><!--<div class="form-group">--><!--<label for="uamnumber" class="col-lg-3 control-label">UAM Number</label>--><!--<div class="col-lg-3"><input type="text" class="form-control" id="uamnumber"--><!--placeholder="Enter UAM Number"--><!--ng-model="vm.proj.uamnumber">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-3 control-label">Size of Industry</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.size_of_industry"--><!--ng-options="si.sizeofindustry as si.sizeofindustry for si in vm.industrysizes">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="panel panel-default">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">--><!--<a data-toggle="collapse" data-parent="#accordion" href=".collapseThree">3. Project Detail</a>--><!--</h4>--><!--</div>--><!--<div id="collapseThree">--><!--<div class="panel-body">--><!--<div class="form-horizontal" data-dpmaxz-eid="7">--><!--<fieldset>--><!--<legend>Project Detail</legend>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Sector</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.sectorname"--><!--ng-options="sector.sectortype as sector.sectortype for sector in vm.sectors">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--<label class="col-lg-2 control-label">Collaboration with Foreign Investor</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.collaboration_with_foreign_country"--><!--ng-options="country.countryname as country.countryname for country in vm.countries">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Size of Industry</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.size_of_industry"--><!--ng-options="si.sizeofindustry as si.sizeofindustry for si in vm.industrysizes">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--<label class="col-lg-2 control-label">Project Sector</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.projectype"--><!--ng-options="projecttype.projectypes as projecttype.projectypes for projecttype in vm.projectypes">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Existing Regulatory Approval</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkExistingRegulatoryApproval"--><!--ng-model="vm.proj.existing_regulatory_approval">--><!--</div>--><!--</div>--><!--<div class="form-group" ng-show="vm.proj.existing_regulatory_approval">--><!--<label class="col-lg-2 control-label">Approved Form</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.approval_application_form"--><!--ng-options="approvalform.existingapprovalforms as approvalform.existingapprovalforms for approvalform in vm.approvalforms">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--<label class="col-lg-2 control-label">EDC/SIF/CLU/Other Fee</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkEDCSIFCLUOtherFee"--><!--ng-model="vm.proj.edc_sif_clu_fee_paid_applicable"/>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<div class="col-lg-6 col-lg-offset-2">--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="panel panel-default">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">--><!--<a data-toggle="collapse" data-parent="#accordion" href=".projectsitedetail2">4. Project Site--><!--Detail </a>--><!--</h4>--><!--</div>--><!--<div id="projectsitedetail2">--><!--<div class="panel-body">--><!--<div class="form-horizontal">--><!--<fieldset>--><!--<legend>Project Site Detail</legend>--><!--<div class="form-group">--><!--<label for="siteaddress" class="col-lg-2 control-label">Site Address</label>--><!--<div class="col-lg-3"><textarea class="form-control" rows="3" id="siteaddress"--><!--placeholder="Enter Site Address"--><!--ng-model="vm.proj.siteaddress"></textarea>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="block" class="col-lg-2 control-label">Block</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" id="block"--><!--ng-model="vm.proj.block"--><!--ng-options="block.blockname as block.blockname for block in vm.blocks">--><!--<option value="">Select Block</option>--><!--</select>--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-parent="#accordion" href=".termsandconditions"><center><span data-translate="global.addcafnew.TERMS AND CONDITIONS">Terms & Conditions</span></center></a></h4></div><div id="termsandconditions"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><!--<div class="col-md-12">--><legend><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%" data-translate="global.addcafnew.TERMS AND CONDITIONS">TERMS AND CONDITIONS</p></legend><div class="col-md-12"><br><br><ol><li style="padding:10px"><span data-translate="global.addcafnew.I/We,">I/We </span><b>{{vm.proj.firstname}}</b>, <span data-translate="global.addcafnew.hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.">hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</span></li><li style="padding:10px" data-translate="global.addcafnew.All the required attachments have been completely and legibly attached to this form.">All the required attachments have been completely and legibly attached to this form.</li></ol><div style="padding:10px"><b data-translate="global.addcafnew.Disclaimer">Disclaimer </b>: <span data-translate="global.addcafnew.Please ensure that the email and phone no. provided in this form pertain to concerned person who may be contacted regarding the CAF filled through this login. Incorrect/Invalid information provided in this field may lead to de-activation of CAF created through this login.">Please ensure that the email and phone no. provided in this form pertain to concerned person who may be contacted regarding the CAF filled through this login. Incorrect/Invalid information provided in this field may lead to de-activation of CAF created through this login.</span></div></div><!--</div>--><div class="row"><div class="col-md-12"><div class="col-md-6"><input type="checkbox" id="chkAccept" style="outline: 2px solid; margin-left:23px" autocomplete="off" ng-model="vm.proj.acceptance" autocompletetype="Disable" data-dpmaxz-eid="18"><span data-translate="global.addcafnew.I Accept Terms and Conditions">I Accept Terms and Conditions</span></div></div><br><div class="table table-striped" style="min-height:40px"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><div id="PreviousFile"></div><div class="file_name" style="display:none"></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label data-translate="global.addcafnew.Applicant Signature">Applicant Signature</label></div><div class="col-md-8" style="margin-top:7px"><input type="file" class="form-control" file-model="vm.cAFAttachmentSign.investorsign" accept="image/*"><p class="text-danger" data-translate="global.addcafnew.Max file size (1 MB) and image files accepted with extension .jpg, .png, .jpeg">Max file size (1 MB) and image files accepted with extension .jpg, .png, .jpeg</p><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label data-translate="global.addcafnew.Place">Place</label></div><div class="col-md-8" style="margin-top:7px"><input class="form-control capitalize" id="Place" name="Place" placeholder="Click here to enter text" type="text" value="" autocomplete="off" ng-model="vm.proj.place" autocompletetype="Disable" data-dpmaxz-eid="19"> <span class="field-validation-valid" data-valmsg-for="Place" data-valmsg-replace="true"></span></div></div></div></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div><div class="panel-heading"><button type="button" ng-click="vm.confirmProject()" data-dpmaxz-eid="12" class="btn btn-primary" ng-show="vm.proj.acceptance" ng-disabled="myform.$invalid || file.maxSizeError|| vm.cAFAttachmentPhoto.investorphoto== null && !vm.cafAttachementInvestorPhoto.fileName || vm.total_foreign_investment.includes(\'null\') || vm.total_nri_investment.includes(\'null\')\n                                || (vm.proj.investmentType === \'Other\' && (vm.proj.otherInvestmetType === null || vm.proj.otherInvestmetType === \'\'))\n                                || (vm.proj.sectorname === \'Other Industries\' && (vm.proj.otherFDI === null || vm.proj.otherFDI === \'\'))"><span data-translate="global.addcafnew.Submit Complete Form">Submit Complete Form</span></button></div></div></div></form></div><div class="modal rmPaddingModal" data-backdrop="static" data-keyboard="false" id="blockCategoryHint" tabindex="-1" role="dialog" aria-labelledby="YourModalId1"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal()"><span aria-hidden="true">&times;</span></button><h2 class="text-center">Block Data</h2></div><div class="modal-body"><div class="modal-body"><embed src="../../content/pdfs/blockCategories.pdf" width="560px" height="700px"></div></div></div></div></div><div id="confirmCaf" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><h4 class="modal-title"><b>Kindly review the below CAF fields. Once submited, you will no longer be able to change.</b></h4></div><div class="modal-body"><div class="row"><div class="col-md-6"><p><b>Business Entity (M/s) :- </b>{{vm.proj.businessentity}}</p></div><div class="col-md-6"><p><b>Site Address :- </b>{{vm.proj.siteaddress}}</p></div><div class="col-md-6"><p><b>District :- </b>{{vm.proj.district}}</p></div><div class="col-md-6"><p><b>Block Category :- </b>{{vm.proj.blockCategory}}</p></div><div class="col-md-6"><p><b>Investment Type :- </b>{{vm.proj.investmentType}}</p></div><div class="col-md-6"><p><b>Proposed Employment :- </b><code style="font-size:18px">{{vm.proj.totalpurposedemployment}}</code></p></div><div class="col-md-12"><p><b>Proposed Investment (Cr):- </b><code style="font-size:18px">{{vm.total_project_cost}}</code></p></div><!--                    <div ng-if="vm.OTPstatus && !vm.OTP" class="form-group col-md-12">--><!--                        <label  class="col-md-2 control-label">OTP</label>--><!--                        <div class="col-md-4">--><!--                            <input  type="text" class="form-control" ng-model="vm.cafOTP">--><!--                        </div>--><!--                        <button type="button" class="btn btn-default" ng-click="vm.verifyOTP(vm.proj.mobilenumber,vm.cafOTP)">Verify OTP</button>--><!--                        <button type="button" class="btn btn-default" ng-click="vm.sendOTP(vm.proj.mobilenumber)">Resend OTP</button>--><!--                    </div>--><!--                    <div ng-if="!vm.OTPstatus" class="form-group col-md-12">--><!--                        <h4>OTP Sending Failed.Please click on Resend OTP button.</h4>--><!--                        <button ng-if="!vm.OTPstatus" type="button" class="btn btn-default" ng-click="vm.sendOTP(vm.proj.mobilenumber)">Resend OTP</button>--><!--                    </div>--><!--                    <div  class="form-group col-md-12">--><!--                        <span class="text-success" ng-if="vm.OTPstatus && !vm.OTP"><b>OTP Sent.</b></span>--><!--                    </div>--><!--                    <div  class="form-group col-md-12">--><!--                        <span class="text-success" ng-if="vm.OTP"><b>OTP Verified.</b></span>--><!--                    </div>--></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.editForm()">Edit</button> <button type="button" ng-click="vm.saveAndClose()" data-dpmaxz-eid="12" class="btn btn-primary" ng-show="vm.proj.acceptance && vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')" ng-disabled="myform.$invalid || file.maxSizeError|| vm.total_foreign_investment.includes(\'null\') || vm.total_nri_investment.includes(\'null\')\n                                || (vm.proj.investmentType === \'Other\' && (vm.proj.otherInvestmetType === null || vm.proj.otherInvestmetType === \'\'))\n                                || (vm.proj.sectorname === \'Other Industries\' && (vm.proj.otherFDI === null || vm.proj.otherFDI === \'\'))">Submit Complete Form</button><!--                <button ng-if="vm.OTP" type="button" ng-click="vm.saveAndClose()" data-dpmaxz-eid="12" class="btn btn-primary"--><!--                        ng-show="vm.proj.acceptance && vm.account.authorities.includes(\'ROLE_USER\')"--><!--                        ng-disabled="myform.$invalid || file.maxSizeError|| vm.total_foreign_investment.includes(\'null\') || vm.total_nri_investment.includes(\'null\')--><!--                                || (vm.proj.investmentType === \'Other\' && (vm.proj.otherInvestmetType === null || vm.proj.otherInvestmetType === \'\'))--><!--                                || (vm.proj.sectorname === \'Other Industries\' && (vm.proj.otherFDI === null || vm.proj.otherFDI === \'\'))">--><!--                    Submit Complete Form--><!--                </button>--> <button ng-click="vm.saveAndClose()" data-dpmaxz-eid="12" class="btn btn-primary" ng-show="vm.proj.acceptance && vm.account.authorities.includes(\'ROLE_USER\')" ng-disabled="myform.$invalid || file.maxSizeError|| vm.total_foreign_investment.includes(\'null\') || vm.total_nri_investment.includes(\'null\')\n                                || (vm.proj.investmentType === \'Other\' && (vm.proj.otherInvestmetType === null || vm.proj.otherInvestmetType === \'\'))\n                                || (vm.proj.sectorname === \'Other Industries\' && (vm.proj.otherFDI === null || vm.proj.otherFDI === \'\'))">Submit Complete Form</button></div></div></div></div>');
$templateCache.put('app/addCAF/addCAFnewRestricted.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><div class="container"><form ng-submit="vm.saveProject(\'Final\')" name="myform"><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><button type="button" class="btn btn-primary" data-dpmaxz-eid="12" ng-click="vm.saveProject(\'Draft\')" ng-show="vm.proj.cafpin==null || vm.proj.cafpin==\'NA\'" ng-disabled="myform.$invalid || file.maxSizeError ||vm.total_foreign_investment.includes(\'null\')||vm.total_nri_investment.includes(\'null\')">Save Draft</button> <a data-toggle="collapse" data-parent="#accordion"><center><span data-translate="global.addcafnew.INDUSTRY DETAILS">INDUSTRY DETAILS</span></center></a></h4></div><div><div class="panel-body"><div class="form-horizontal"><fieldset><legend><span data-translate="global.addcafnew.INDUSTRY DETAILS">INDUSTRY DETAILS</span></legend><div class="form-group"><label for="businessentity" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Proposed Industry Name">Proposed Industry Name</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" id="businessentity" placeholder="Enter Business Entity" ng-model="vm.proj.businessentity" required readonly="readonly"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Full name of the Enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Sector">Sector</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" ng-model="vm.proj.sectorname" ng-change="vm.sectorValueChange(vm.proj.sectorname)" ng-options="sector.sectortype as sector.sectortype for sector in vm.sectors" required><option value="" data-translate="global.addcafnew.select">Select</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="The sector which your Enterprise falls under. Incase, the relevant sector is not present in the list, please select the option Other Industries and input the sector in the textbox provided. " data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><div ng-show="vm.showOtherSector"><label class="col-lg-offset-4 col-lg-2 control-label">Other Sector<span style="color:red">*</span></label></div><div class="col-lg-3" ng-show="vm.showOtherSector"><input type="text" class="form-control" placeholder="Please specify" ng-model="vm.proj.otherFDI"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Product of Manufacture / Service Provided">Product of Manufacture /Service Provided</span> <span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" id="product" placeholder="Enter Product" ng-model="vm.proj.product" required></div><div class="col-md-1"><div><a data-balloon-length="xlarge" data-balloon="Product being manufactured or the Service being provided by your Enterprise" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Expected Start Date of Commercial Production / Operations">Expected Start Date of Commercial Production / Operations</span><span style="color:red">*</span></label><div class="col-lg-3"><div class="input-group"><input type="date" class="form-control" placeholder="Select Date" name="prodctionStartDate" ng-model="vm.proj.prodctionStartDate" datetime-picker="{{dateformat}}" is-open="vm.datePickerOpenStatus.prodctionStartDate" max="2999-12-31" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'prodctionStartDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Proposed date of commencement of operations for your Enterprise" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">State<span--><!--style="color:red">*</span></label></label>--><!--<div class="col-lg-3">--><!--&lt;!&ndash;<select class="form-control" ng-change="vm.loadAllCities()" ng-options="state.state as state.state for state in vm.states" ng-model="vm.proj.statename" id="state">&ndash;&gt;--><!--<select class="form-control" ng-options="state.statename as state.statename for state in vm.states" ng-model="vm.proj.statename" required>--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--<div class="col-lg-1"></div>--><!--</div>--><div class="form-group"><label for="district" class="col-lg-2 control-label"><span data-translate="global.addcafnew.District">District</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="district" ng-model="vm.proj.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" required ng-change="vm.getVillages(vm.proj.district)"><option value="" disabled="disabled" data-translate="global.addcafnew.Select District">Select District</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="District where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Size of Industry">Size of Industry</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" ng-model="vm.proj.size_of_industry" ng-options="si.sizeofindustry as si.sizeofindustry for si in vm.industrysizes" required><option value="" data-translate="global.addcafnew.select">Select</option></select></div></div><div class="form-group"><div class="col-md-12"><p class="text-danger" data-translate="global.addcafnew.To know your block enter your village name or visit this">*To know your block enter your village name or visit this <a target="_blank" ng-click="vm.blockopen()" data-toggle="modal">link</a></p></div><label for="village" class="col-lg-2 control-label" data-translate="global.addcafnew.Village">Village</label><div class="col-lg-3"><input type="text" class="form-control" id="village" placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.proj.district === null" ng-model="vm.proj.village" ng-change="vm.setBlockCategory(vm.proj.village,vm.villages)"><datalist id="villages"><option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option></datalist></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Village where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Business Entity Type">Business Entity Type</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" ng-model="vm.proj.businessentitytype" ng-options="business.businessentitytype as business.businessentitytype for business in vm.businessentities" required><option value="" data-translate="global.addcafnew.select">Select</option></select></div><div class="col-lg-offset-2 col-lg-2"><small ng-show="vm.invalidVillage"><font color="red">Invalid Village Name</font></small></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Block">Block</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="blockCategory" ng-model="vm.proj.blockCategory" required><option value="" data-translate="global.addcafnew.Select Block">Select Block</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option></select></div><div class="col-lg-1"></div><label class="col-lg-2 control-label" data-translate="global.addcafnew.Investment Type">Investment Type<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" name="investmenttype" ng-change="vm.showOtherInvestment(vm.proj.investmentType)" ng-model="vm.proj.investmentType" required><option value="" disabled="disabled" data-translate="global.addcafnew.Select Investment Type">Select Investment Type</option><!--                                            <option value="New Project">New Project</option>--><option value="Expansion Project">Expansion/Diversification Project</option><!--                                            <option value="Existing Project (not a new investment in state)">Existing Project (not a new investment in state)</option>--></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="1. New Project: Select this option in case your Enterprise is currently planned/proposed to be setup in Haryana\n                                                2. Expansion/Diversification Project: Select this option in case your Enterprise has already been setup in Haryana & an expansion or diversification is planned in the same\n                                                3. Existing Project : Select this option in case your Enterprise has already been setup in Haryana and no new investment is planned currently" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group"><div class="container"><p class="text-warning" data-translate="global.addcafnew.*In case your Total Proposed Investment is greater than INR 10,000 Crores or Total Proposed Project Employment is greater than 10,000, kindly contact our helpdesk at 1800-180-2132 for further assistance.">*In case your Total Proposed Investment is greater than INR 10,000 Crores or Total Proposed Project Employment is greater than 10,000, kindly contact our helpdesk at 1800-180-2132 for further assistance.</p></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Total Proposed Project Area">Total Proposed Project Area</span><span style="color:red">*</span></label><div class="col-lg-8"><div class="col-lg-2"><input type="number" class="form-control" name="acres" placeholder="Acres" ng-model="vm.project_area_in_acres" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()" min="0" required><div ng-show="myform.acres.$invalid && myform.acres.$touched || myform.acres.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.acres">acres</small><div class="col-lg-2"><input type="number" class="form-control" name="kanal" placeholder="Kanals" ng-model="vm.project_area_in_kanal" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()" min="0" max="7" required><div ng-show="myform.kanal.$invalid && myform.kanal.$touched || myform.kanal.$error.min && !myform.kanal.$error.max"><small style="color:red; display:block;text-align:left">Invalid Input</small></div><div ng-show="myform.kanal.$error.max"><small style="color:red; display:block;text-align:left">value cannot be more than 7</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.kanal">kanal</small><div class="col-lg-3"><input type="number" class="form-control" name="marla" placeholder="Marlas" ng-model="vm.project_area_in_marla" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()" min="0" max="19" required><div ng-show="myform.marla.$invalid && myform.marla.$touched || myform.marla.$error.min && !myform.marla.$error.max"><small style="color:red; display:block;text-align:center">Invalid Input</small></div><div ng-show="myform.marla.$error.max"><small style="color:red; display:block;text-align:left">value cannot be more than 19</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.marla">marla</small></div></div><div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Total Proposed Project Cost (in Crore)">Total Proposed Project Cost (in Crore) </span><span style="color:red">*</span></label><div class="col-lg-8"><div class="col-lg-2"><input type="number" class="form-control" name="croresCost" placeholder="Crores" ng-model="vm.project_cost_in_crore" maxlength="5" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" required><div ng-show="myform.croresCost.$invalid && myform.croresCost.$touched || myform.croresCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.crores">crores</small><div class="col-lg-2"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.project_cost_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.lacs">lacs</small><div class="col-lg-3"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.project_cost_in_thousands" ng-model="vm.project_cost_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="myform.thousandsCost.$invalid && myform.thousandsCost.$touched || myform.thousandsCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.thousands">thousands</small></div></div><div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group"><div class="col-md-6"><label class="col-lg-4 control-label"><span data-translate="global.addcafnew.Total Proposed Project Employment">Total Proposed Project Employment</span> <span style="color:red">*</span></label><div class="col-lg-3"><input type="number" class="form-control" id="totalemployment" placeholder="Proposed Employment" name="totalEmployment" ng-model="vm.proj.totalpurposedemployment" min="0" maxlength="5" required><div ng-show="myform.totalEmployment.$invalid && myform.totalEmployment.$touched || myform.totalEmployment.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div></div></div><div class="form-group" ng-if="(vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\') && vm.proj.totalpurposedemployment != 0"><label ng-show="vm.proj.totalpurposedemployment" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Haryana Domicile">Haryana Domicile</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="number" class="form-control" id="Haryana_Domicile" placeholder="0" ng-model="vm.proj.haryanadomicile" id="haryanaDomicile" ng-change="vm.proposedEmployment(\'haryana\')" min="0" ng-show="vm.proj.totalpurposedemployment" required></div><label ng-show="vm.proj.totalpurposedemployment" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Non Haryana Domicile">Non Haryana Domicile</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="number" class="form-control" id="Non_Haryana_Domicile" placeholder="0" ng-model="vm.proj.nonharyanadomicile" ng-change="vm.proposedEmployment(\'nonHaryana\')" min="0" ng-show="vm.proj.totalpurposedemployment" required></div></div><div class="form-group"><label for="siteaddress" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Site Address">Site Address</span> <span style="color:red">*</span></label><div class="col-lg-3"><textarea class="form-control" rows="3" id="siteaddress" name="siteaddress" placeholder="Enter Site Address" ng-model="vm.proj.siteaddress" required></textarea><div ng-show="myform.siteaddress.$invalid && myform.siteaddress.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="The complete address of the enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Foreign Direct Investment">Foreign Direct Investment</span><span style="color:red">*</span></label>{{foreign_investment}}<div class="col-md-2"><div class="radio text-center"><label class="col-md-6"><input ng-model="vm.radioToggle" value="Yes" type="radio" name="optradio" ng-click="vm.showFDI = true" data-translate="global.addcafnew.yes">Yes</label><label class="col-md-6"><input ng-model="vm.radioToggle" value="No" type="radio" name="optradio" checked="checked" ng-click="vm.showFDI = false" data-translate="global.addcafnew.no">No</label></div></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Information on investment/ownership in the Enterprise by an entity or individual located outside India" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div ng-show="vm.showFDI" class="form-group"><div class="col-lg-2 control-label"><label class="control-label"><span data-translate="global.addcafnew.Specify, FDI">Specify, FDI</span><span style="color:red">*</span></label></div><div class="col-lg-1"><input type="number" class="form-control" name="foreigncostcrores" placeholder="0" ng-model="vm.foreigninvestment_in_crores" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0"><div ng-show="myform.foreigncostcrores.$invalid || myform.foreigncostcrores.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.crores">crores</small><div class="col-lg-1"><input type="number" class="form-control" name="foreigncostlacs" placeholder="0" ng-model="vm.foreigninvestment_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0" max="99"><div ng-show="myform.foreigncostlacs.$invalid || myform.foreigncostlacs.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.lacs">lacs</small><div class="col-lg-1"><input type="number" class="form-control" name="foreigncostthousand" placeholder="0" ng-model="vm.foreigninvestment_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0" max="99"><div ng-show="myform.foreigncostthousand.$invalid || myform.foreigncostthousand.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.thousands">thousands</small><label class="col-lg-2 control-label" data-translate="global.addcafnew.Country of Origin">Country of Origin</label><div class="col-lg-3"><select class="form-control" ng-options="country.name as country.name for country in vm.allcountries" ng-model="vm.proj.countryname"><option value="" data-translate="global.addcafnew.select">Select</option></select></div><div class="col-lg-1"></div></div><div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group"><label for="powerrequirement" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Power Load Requirement">Power Load Requirement</span> <span style="color:red">*</span></label><div class="col-lg-3"><input type="number" class="form-control" id="powerrequirement" name="powerrequirement" placeholder="Enter Power Load Requirement" ng-model="vm.proj.powerRequirement" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" min="0" max="99999" required><div ng-show="myform.powerrequirement.$invalid && myform.powerrequirement.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px" data-translate="global.addcafnew.KW">KW</small><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="The estimated power load requirement for the Enterprise" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div></fieldset></div></div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-parent="#accordion" href=".invt"><center><span data-translate="global.addcafnew.Personal Details">PERSONAL DETAILS</span></center></a></h4></div><div id="invt"><div class="panel-body"><div class="form-horizontal"><fieldset><legend><span data-translate="global.addcafnew.Personal Details">Personal Details</span></legend><div class="form-group"><label for="designation" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Designation in the Firm">Designation in the Firm</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="designation" ng-model="vm.proj.designation" required><option value="" data-translate="global.addcafnew.Select Designation">Select Designation</option><option value="Director">Director</option><option value="Entrepreneur">Entrepreneur</option><option value="Partner">Partner</option><option value="Professional">Professional</option><option value="Authorized Representative">Authorized Representative</option></select></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Applicant Name">Applicant Name</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-pattern="/^[a-zA-Z]*$/" ng-model="vm.proj.firstname" name="firstname" placeholder="First Name" data-dpmaxz-eid="20" required readonly="readonly"><div ng-show="myform.firstname.$invalid && myform.firstname.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="middlename" ng-model="vm.proj.middlename" placeholder="Middle Name" data-dpmaxz-eid="20" readonly="readonly"></div><div class="col-lg-3"><input type="text" class="form-control" id="lastname" placeholder="Last Name" data-dpmaxz-eid="20" ng-model="vm.proj.lastname" required readonly="readonly"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Name of the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Mobile Number">Mobile Number</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.proj.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" required readonly="readonly"><div ng-show="myform.mobileno.$invalid && myform.mobileno.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="phonenumber"--><!--placeholder="Phone Number"--><!--ng-model="vm.proj.phonenumber">--><!--</div>--><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Contact number the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="email1" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Email">Email</span> <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="email" class="form-control" id="email1" placeholder="Primary Email" ng-model="vm.proj.emailprimary" required readonly="readonly"><div ng-show="myform.email.$invalid && myform.email.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="email2" placeholder="Secondary Email" ng-model="vm.proj.emailsecondary"></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><label for="email1" class="col-lg-2 control-label"><span data-translate="global.addcafnew.Update Email">Update Email</span> <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="email" class="form-control" id="email3" placeholder="Primary Email" ng-model="vm.proj.emailprimary" required><div ng-show="myform.email.$invalid && myform.email.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div></div><div class="form-group"><label for="PanNumber" class="col-lg-2 control-label"><span data-translate="global.addcafnew.PAN Number">PAN Number</span><span style="color:red">*</span></label><div class="col-lg-2"><input type="text" ng-pattern="/^([A-Z]){5}([0-9]){4}([A-Z]){1}/" class="form-control" id="PanNumber" placeholder="Enter PAN Number" name="PanNumber" ng-model="vm.proj.pan_number" maxlength="10" style="text-transform: uppercase" required></div><!-- Verify Button --><div class="col-lg-2"><button type="button" class="btn btn-primary" ng-click="vm.verifyPan()"><span data-translate="global.addcafnew.Verify">Verify</span></button></div><!-- Error Messages --><div style="margin-top: 15px" ng-show="vm.panErrorMessage" class="text-danger">{{ vm.panErrorMessage }}</div><div style="margin-top: 15px" ng-show="vm.panSuccessMessage" class="text-success">{{ vm.panSuccessMessage }}</div><div ng-show="myform.PanNumber.$invalid"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Applicant Photo">Applicant Photo</span><span style="color:red">*</span></label><div class="col-lg-3 text-danger"><input type="file" class="form-control input" file-model="vm.cAFAttachmentPhoto.investorphoto" accept=".jpeg,.jpg,.png" required><p data-translate="global.addcafnew.Max file size (1 MB) and image files accepted with extension .jpg, .png, .jpeg">Max file size (1 MB) and image files accepted with extension .jpg, .png, .jpeg</p><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-lg-3" ng-if="vm.cafAttachementInvestorPhoto.fileName"><div class="thumbnail pull-right panel-body"><img src="{{vm.investorphoto1}}" style="height:150px; width: 150px"></div></div></div><!--<div class="form-group">--><!--<label for="siteaddress" class="col-lg-2 control-label">Site Address--><!--<span style="color:red">*</span></label>--><!--<div class="col-lg-3"><textarea class="form-control" rows="3" id="siteaddress"--><!--name="siteaddress"    placeholder="Enter Site Address"--><!--ng-model="vm.proj.siteaddress" required></textarea>--><!--<div ng-show="myform.siteaddress.$invalid && myform.siteaddress.$touched ">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="The complete address of the enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<div class="col-md-12">--><!--<p class="text-danger col-md-offset-6">*To know your block enter your village name or visit this--><!--<a target="_blank" ng-click="" data-toggle="modal" data-target="#blockCategoryHint">link</a>--><!--</p>--><!--</div>--><!--<label for="district" class="col-lg-2 control-label">District<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<select class="form-control" id="district"--><!--ng-model="vm.proj.district"--><!--ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'"--><!--required ng-change="vm.getVillages(vm.proj.district)">--><!--<option value="" disabled>Select District</option>--><!--</select>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="District where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--<label for="district" class="col-lg-2 control-label">Village</label>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="village"--><!--placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.proj.district === null"--><!--ng-model="vm.proj.village" ng-change="vm.setBlockCategory(vm.proj.village,vm.villages)"/>--><!--<datalist id="villages">--><!--<option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option>--><!--</datalist>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Village where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--<div class="col-lg-2">--><!--<small ng-show="vm.invalidVillage" class="text-danger">invalid village name</small>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Category of Block<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<select class="form-control" id="blockCategory"--><!--ng-model="vm.proj.blockCategory"--><!--required>--><!--<option value="">Select Block</option>--><!--<option value="A">A</option>--><!--<option value="B">B</option>--><!--<option value="C">C</option>--><!--<option value="D">D</option>--><!--</select>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--</div>--><!--</div>--><!--<label class="col-lg-2 control-label">Land Zone Use Type<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<select class="form-control" name="landzonetype"--><!--ng-model="vm.proj.landzoneuse_type"--><!--ng-options="landzoneclassificationtype.landzoneclassificationtype as landzoneclassificationtype.landzoneclassificationtype for landzoneclassificationtype in vm.landusezoneclassifications"--><!--required>--><!--<option value="">Select Land Zone</option>--><!--</select>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Type of land on which the Enterprise is setup or proposed to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Investment Type<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<select class="form-control" name="investmenttype" ng-change="vm.showOtherInvestment(vm.proj.investmentType)"--><!--ng-model="vm.proj.investmentType" required>--><!--<option value="" disabled>Select Investment Type</option>--><!--<option value="New Project">New Project</option>--><!--<option value="Expansion Project">Expansion/Diversification Project</option>--><!--<option value="Existing Project (not a new investment in state)">Existing Project (not a new investment in state)</option>--><!--</select>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="1. New Project: Select this option in case your Enterprise is currently planned/proposed to be setup in Haryana--><!--2. Expansion/Diversification Project: Select this option in case your Enterprise has already been setup in Haryana & an expansion or diversification is planned in the same--><!--3. Existing Project : Select this option in case your Enterprise has already been setup in Haryana and no new investment is planned currently" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--</div>--><!--<div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group">--><!--<div class="container"><p class="text-warning">*In case your Total Proposed Investment is greater than INR 10,000 Crores or Total Proposed Project Employment is greater than 10,000, kindly contact our helpdesk at 1800-180-2132 for further assistance.</p></div>--><!--<label class="col-lg-2 control-label">Total Proposed Project Area<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-8">--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="acres"--><!--placeholder="Acres"--><!--ng-model="vm.project_area_in_acres"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()"--><!--min="0" required/>--><!--<div--><!--ng-show="myform.acres.$invalid && myform.acres.$touched || myform.acres.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">acres--><!--</small>--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="kanal" placeholder="Kanals"--><!--ng-model="vm.project_area_in_kanal"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInArea()"--><!--min="0" max="7" required/>--><!--<div--><!--ng-show="myform.kanal.$invalid && myform.kanal.$touched || myform.kanal.$error.min && !myform.kanal.$error.max">--><!--<small style="color:red; display:block;text-align:left">Invalid Input--><!--</small>--><!--</div>--><!--<div--><!--ng-show="myform.kanal.$error.max">--><!--<small style="color:red; display:block;text-align:left">value cannot be--><!--more than 7--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">kanal--><!--</small>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" name="marla"--><!--placeholder="Marlas"--><!--ng-model="vm.project_area_in_marla"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"--><!--ng-change="vm.changeInArea()" min="0" max="19" required/>--><!--<div--><!--ng-show="myform.marla.$invalid && myform.marla.$touched || myform.marla.$error.min && !myform.marla.$error.max">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--<div--><!--ng-show="myform.marla.$error.max">--><!--<small style="color:red; display:block;text-align:left">value cannot be--><!--more than 19--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left" style="margin-top:10px;margin-left:-10px">marla</small>--><!--</div>--><!--</div>--><!--<div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group">--><!--<label class="col-lg-2 control-label">Total Proposed Project Cost (in Crore) <span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-8">--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="croresCost"--><!--placeholder="Crores"--><!--ng-model="vm.project_cost_in_crore"--><!--maxlength="4"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()"--><!--min="0" required/>--><!--<div--><!--ng-show="myform.croresCost.$invalid && myform.croresCost.$touched || myform.croresCost.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">crores--><!--</small>--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="lacsCost" placeholder="lacs"--><!--ng-model="vm.project_cost_in_lacs"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()"--><!--min="0" max="99" required/>--><!--<div--><!--ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min">--><!--<small style="color:red; display:block;text-align:left">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs--><!--</small>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" name="thousandsCost"--><!--placeholder="thousands"--><!--ng-model="vm.project_cost_in_thousands"--><!--ng-model="vm.project_cost_in_thousands"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"--><!--ng-change="vm.changeInCost()" min="0" max="99" required/>--><!--<div--><!--ng-show="myform.thousandsCost.$invalid && myform.thousandsCost.$touched || myform.thousandsCost.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands--><!--</small>--><!--</div>--><!--</div>--><!--<div ng-if="vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\'" class="form-group">--><!--<div class="col-md-6">--><!--<label class=" col-lg-4 control-label">Total Proposed Project Employment--><!--<span style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" id="totalemployment" placeholder="Proposed Employment" name="totalEmployment"--><!--ng-model="vm.proj.totalpurposedemployment" min="0" maxlength="4"--><!--required/>--><!--<div--><!--ng-show="myform.totalEmployment.$invalid && myform.totalEmployment.$touched || myform.totalEmployment.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group" ng-if="(vm.proj.investmentType === \'New Project\' || vm.proj.investmentType === \'Expansion Project\') && vm.proj.totalpurposedemployment != 0">--><!--<label ng-show="vm.proj.totalpurposedemployment" class="col-lg-2 control-label" >Haryana Domicile--><!--<span style="color:red">*</span></label>--><!--<div class="col-lg-3" >--><!--<input type="number" class="form-control" id="Haryana_Domicile" placeholder="0"--><!--ng-model="vm.proj.haryanadomicile" id="haryanaDomicile" ng-change="vm.proposedEmployment(\'haryana\')" min="0" ng-show="vm.proj.totalpurposedemployment"--><!--required/>--><!--</div>--><!--<label ng-show="vm.proj.totalpurposedemployment" class="col-lg-2 control-label">Non Haryana Domicile--><!--<span style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<input type="number"  class="form-control" id="Non_Haryana_Domicile" placeholder="0"--><!--ng-model="vm.proj.nonharyanadomicile" ng-change="vm.proposedEmployment(\'nonHaryana\')" min="0" ng-show="vm.proj.totalpurposedemployment"--><!--required/>--><!--</div>--><!--</div>--><!--<div class="col-md-12">--><!--<div class="col-md-5">--><!--<label class="col-lg-4 control-label">Product of Manufacture /Service Provided--><!--<span style="color:red">*</span></label>--><!--<div class="col-lg-7">--><!--<input type="text" class="form-control" id="product" placeholder="Enter Product"--><!--ng-model="vm.proj.product"--><!--required/>--><!--</div>--><!--</div>--><!--<div class="col-md-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Product being manufactured or the Service being provided by your Enterprise" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--<div class="col-md-5">--><!--<label class="col-lg-2 control-label">CLU Required</label>--><!--<div class="col-lg-2">--><!--<label><input type="checkbox" name="checkConfirmityoflanduse"--><!--ng-model="vm.proj.clurequired"> Required </label>--><!--</div>--><!--<div class="col-lg-4">--><!--<h5><i><span--><!--style="color:red">*</span>Check if CLU is required.</i></h5>--><!--</div>--><!--</div>--><!--<div class="col-md-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Please check this box if you wish to apply for Change of Land Use" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--</div>--><!--<div class="form-group">--><!--<div class="col-md-2" ng-show="vm.showOtherInvestmentType">--><!--<label class="control-label">Other Investment Type<span--><!--style="color:red">*</span></label>--><!--</div>--><!--<div class="col-md-3" ng-show="vm.showOtherInvestmentType">--><!--<input type="text" class="form-control"--><!--placeholder="Please specify" ng-model="vm.proj.otherInvestmetType"/>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Expected Start Date of Commercial Production / Operations<span--><!--style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<div class="input-group">--><!--<input type="date" class="form-control" placeholder="Select Date" name="prodctionStartDate"--><!--ng-model="vm.proj.prodctionStartDate" datetime-picker="{{dateformat}}"--><!--is-open="vm.datePickerOpenStatus.prodctionStartDate" required/>--><!--<span class="input-group-btn">--><!--<button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'prodctionStartDate\')"><i class="glyphicon glyphicon-calendar"></i></button>--><!--</span>--><!--</div>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Proposed date of commencement of operations for your Enterprise" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Foreign Direct Investment<span--><!--style="color:red">*</span></label>{{foreign_investment}}--><!--<div class="col-md-2">--><!--<div class="radio text-center">--><!--<label class="col-md-6"><input ng-model="vm.radioToggle" value="Yes" type="radio" name="optradio" ng-click="vm.showFDI = true">Yes</label>--><!--<label class="col-md-6"><input ng-model="vm.radioToggle" value="No" type="radio" name="optradio" checked ng-click="vm.showFDI = false">No</label>--><!--</div>--><!--</div>--><!--<div class="col-lg-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Information on investment/ownership in the Enterprise by an entity or individual located outside India" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--><!--<div ng-show="vm.showFDI" class="col-lg-7">--><!--<div class="col-md-2">--><!--<label class="control-label">Specify, FDI<span--><!--style="color:red">*</span></label>--><!--</div>--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="foreigncostcrores"--><!--placeholder="Crores" ng-model="vm.foreigninvestment_in_crores"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0"/>--><!--<div--><!--ng-show="myform.foreigncostcrores.$invalid || myform.foreigncostcrores.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">crores--><!--</small>--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="foreigncostlacs" placeholder="lacs"--><!--ng-model="vm.foreigninvestment_in_lacs"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()"--><!--min="0" max="99"/>--><!--<div--><!--ng-show="myform.foreigncostlacs.$invalid || myform.foreigncostlacs.$error.min">--><!--<small style="color:red; display:block;text-align:left">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs--><!--</small>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" name="foreigncostthousand"--><!--placeholder="thousands"--><!--ng-model="vm.foreigninvestment_in_thousands"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"--><!--ng-change="vm.changeInForeignInvestment()" min="0" max="99"/>--><!--<div--><!--ng-show="myform.foreigncostthousand.$invalid || myform.foreigncostthousand.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands--><!--</small>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="PanNumber" class="col-lg-2 control-label">PAN Number<span style="color:red">*</span></label></label>--><!--<div class="col-lg-2"><input type="text" ng-pattern="/^([A-Z]){5}([0-9]){4}([A-Z]){1}/"  class="form-control" id="PanNumber"--><!--placeholder="Enter PAN Number" name="PanNumber"--><!--ng-model="vm.proj.pan_number" maxlength="10" required>--><!--</div>--><!--<div class="text-danger"><b>*</b>Enter PAN in Uppercase--><!--</div>--><!--</div>--><!--<div ng-show="myform.PanNumber.$invalid">--><!--<div class="text-danger"><b>*</b>PAN Number must be in Correct Format--><!--</div>--><!--</div>--></fieldset></div></div></div></div><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-parent="#accordion"><center><span data-translate="global.addcafnew.LAND USE DETAILS">LAND USE DETAILS</span></center></a></h4></div><div><div class="panel-body"><div class="form-horizontal"><fieldset><legend><span data-translate="global.addcafnew.LAND USE DETAILS">Land Use Details</span></legend><div class="form-group" ng-show="vm.showEstateConfirmation"><label for="isIndustrialEstate" class="col-lg-2 control-label">Whether your business entity falls under HSIIDC Industrial Estate (Yes/No)<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="isIndustrialEstate" ng-model="vm.isIndustrialEstate" required ng-change="vm.getIndustrialEstates(vm.isIndustrialEstate)"><option value="" disabled="disabled">Select an option</option><option value="yes">Yes</option><option value="no">No</option></select></div><label ng-if="vm.showIndustrialEstates" for="industrialEstates" class="col-lg-2 control-label">Choose HSIIDC Industrial Estate<span style="color:red">*</span></label><div class="col-lg-3" ng-if="vm.showIndustrialEstates"><select class="form-control" id="industrialEstates" ng-model="vm.proj.industrialEstate" ng-options="estate.estate as estate.estate for estate in vm.estates | orderBy: \'estate\'" required><option value="" disabled="disabled">Select HSIIDC Estate</option></select></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Land Zone Use Type">Land Zone Use Type</span><select class="form-control" name="landzonetype" ng-model="vm.proj.landzoneuse_type" ng-options="landzoneclassificationtype.landzoneclassificationtype as landzoneclassificationtype.landzoneclassificationtype for landzoneclassificationtype in vm.landusezoneclassifications" required><option value="" data-translate="global.addcafnew.Select Land Zone">Select Land Zone</option></select></label></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Type of land on which the Enterprise is setup or proposed to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></fieldset></div><div class="form-group"><label class="col-lg-2 control-label" data-translate="global.addcafnew.CLU Required">CLU Required</label><div class="col-lg-2"><label><input type="checkbox" name="checkConfirmityoflanduse" ng-model="vm.proj.clurequired" data-translate="global.addcafnew.Required"> Required &nbsp&nbsp <a data-balloon-length="xlarge" data-balloon="Please check this box if you wish to apply for Change of Land Use" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></label></div><div class="col-lg-4"><div class="text-danger"><b>*</b><span data-translate="global.addcafnew.Check if CLU is required.">Check if CLU is required.</span></div></div><!--<div class="col-md-1">--><!--<div>--><!--<a data-balloon-length="xlarge" data-balloon="Please check this box if you wish to apply for Change of Land Use" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a>--><!--</div>--><!--</div>--></div><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">State</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-change="vm.loadAllCities()" ng-options="state.state as state.state for state in vm.states" ng-model="vm.proj.statename" id="state">--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">City</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.cityname" placeholder="Select City"--><!--ng-options="city for city in vm.cities">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">NRI Investment, If any</label>--><!--<div class="col-lg-8">--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="nricostcrores"--><!--placeholder="Crores"--><!--ng-model="vm.nri_investment_in_crore"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInNri_investment()"--><!--min="0"/>--><!--<div--><!--ng-show="myform.nricostcrores.$invalid || myform.nricostcrores.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">crores--><!--</small>--><!--<div class="col-lg-2">--><!--<input type="number" class="form-control" name="nricostlacs" placeholder="lacs"--><!--ng-model="vm.nri_investment_in_lacs"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInNri_investment()"--><!--min="0" max="99"/>--><!--<div--><!--ng-show="myform.nricostlacs.$invalid || myform.nricostlacs.$error.min">--><!--<small style="color:red; display:block;text-align:left">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left"--><!--style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs--><!--</small>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" name="nricostthousand"--><!--placeholder="thousands"--><!--ng-model="vm.nri_investment_in_thousands"--><!--ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/"--><!--ng-change="vm.changeInNri_investment()" min="0" max="99"/>--><!--<div--><!--ng-show="myform.nricostthousand.$invalid || myform.nricostthousand.$error.min">--><!--<small style="color:red; display:block;text-align:center">Invalid Input--><!--</small>--><!--</div>--><!--</div>--><!--<small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands--><!--</small>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="address1" class="col-lg-2 control-label">Address</label>--><!--<div class="col-lg-3">--><!--<textarea class="form-control" rows="3" id="address1" Placeholder="Address 1"--><!--ng-model="vm.proj.address1" ng-keydown="$event.keyCode === 13 && enterEvent($event)" ng-change="vm.errorMessage()"></textarea>--><!--</div>--><!--<p ng-show="vm.ShowError"><font color="red">Enter Not Allowed In Address Field</font></p>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Applicant Photo<span style="color:red">*</span></label>--><!--<div class="col-lg-3">--><!--<input type="file" class="form-control input" file-Model="vm.cAFAttachmentPhoto.investorphoto" accept=".jpeg,.jpg,.png" required/>--><!--<p><font color="red">Max file size (1 MB) and image files accepted with extension .jpg, .png, .jpeg</font></p>--><!--<p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1--><!--MB)</font></p>--><!--</div>--><!--</div>--></div></div></div></div><!--<div class="panel panel-default">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">--><!--<a data-toggle="collapse" data-parent="#accordion" href=".collapseTwo">2. Company Detail</a>--><!--</h4>--><!--</div>--><!--<div id="collapseTwo">--><!--<div class="panel-body">--><!--<div class="form-horizontal">--><!--<fieldset>--><!--<legend>Company Detail</legend>--><!--<div class="form-group">--><!--<label class="col-lg-3 control-label">Business Entity Type</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.businessentitytype"--><!--ng-options="business.businessentitytype as business.businessentitytype for business in vm.businessentities">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="mddirector" class="col-lg-3 control-label">Promoter / MD /--><!--Director</label>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="mddirector" placeholder="Enter Name"--><!--ng-model="vm.proj.promoter_md_director">--><!--</div>--><!--<div class="col-lg-3">--><!--<input type="text" class="form-control" id="designation"--><!--placeholder="Enter Designation"--><!--ng-model="vm.proj.designation">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="promotor" class="col-lg-3 control-label">No. of Directors/ Promoters--><!--/MDs--><!--/CEO</label>--><!--<div class="col-lg-3">--><!--<input type="number" class="form-control" id="promotor"--><!--ng-model="vm.proj.director_promoter_md_ceo_number" min="0">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="aadharnumber" class="col-lg-3 control-label">Aadhar Number</label>--><!--<div class="col-lg-3"><input type="text" class="form-control" id="aadharnumber"--><!--placeholder="Enter Aadhar Number"--><!--ng-model="vm.proj.aadhar_number"--><!--maxlength="12"></div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-3 control-label">Applicant is NRI?</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="radioISNRI" checked="false"--><!--ng-model="vm.proj.nri">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="gstnumber" class="col-lg-3 control-label">GST Number</label>--><!--<div class="col-lg-3"><input type="text" class="form-control" id="gstnumber"--><!--placeholder="Enter GST Number"--><!--ng-model="vm.proj.gstnumber"></div>--><!--</div>--><!--<div class="form-group">--><!--<label for="uamnumber" class="col-lg-3 control-label">UAM Number</label>--><!--<div class="col-lg-3"><input type="text" class="form-control" id="uamnumber"--><!--placeholder="Enter UAM Number"--><!--ng-model="vm.proj.uamnumber">--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-3 control-label">Size of Industry</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.size_of_industry"--><!--ng-options="si.sizeofindustry as si.sizeofindustry for si in vm.industrysizes">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="panel panel-default">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">--><!--<a data-toggle="collapse" data-parent="#accordion" href=".collapseThree">3. Project Detail</a>--><!--</h4>--><!--</div>--><!--<div id="collapseThree">--><!--<div class="panel-body">--><!--<div class="form-horizontal" data-dpmaxz-eid="7">--><!--<fieldset>--><!--<legend>Project Detail</legend>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Sector</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.sectorname"--><!--ng-options="sector.sectortype as sector.sectortype for sector in vm.sectors">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--<label class="col-lg-2 control-label">Collaboration with Foreign Investor</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.collaboration_with_foreign_country"--><!--ng-options="country.countryname as country.countryname for country in vm.countries">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Size of Industry</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.size_of_industry"--><!--ng-options="si.sizeofindustry as si.sizeofindustry for si in vm.industrysizes">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--<label class="col-lg-2 control-label">Project Sector</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.projectype"--><!--ng-options="projecttype.projectypes as projecttype.projectypes for projecttype in vm.projectypes">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label class="col-lg-2 control-label">Existing Regulatory Approval</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkExistingRegulatoryApproval"--><!--ng-model="vm.proj.existing_regulatory_approval">--><!--</div>--><!--</div>--><!--<div class="form-group" ng-show="vm.proj.existing_regulatory_approval">--><!--<label class="col-lg-2 control-label">Approved Form</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" ng-model="vm.proj.approval_application_form"--><!--ng-options="approvalform.existingapprovalforms as approvalform.existingapprovalforms for approvalform in vm.approvalforms">--><!--<option value="">Select</option>--><!--</select>--><!--</div>--><!--<label class="col-lg-2 control-label">EDC/SIF/CLU/Other Fee</label>--><!--<div class="col-lg-3">--><!--<input type="checkbox" name="checkEDCSIFCLUOtherFee"--><!--ng-model="vm.proj.edc_sif_clu_fee_paid_applicable"/>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<div class="col-lg-6 col-lg-offset-2">--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="panel panel-default">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">--><!--<a data-toggle="collapse" data-parent="#accordion" href=".projectsitedetail2">4. Project Site--><!--Detail </a>--><!--</h4>--><!--</div>--><!--<div id="projectsitedetail2">--><!--<div class="panel-body">--><!--<div class="form-horizontal">--><!--<fieldset>--><!--<legend>Project Site Detail</legend>--><!--<div class="form-group">--><!--<label for="siteaddress" class="col-lg-2 control-label">Site Address</label>--><!--<div class="col-lg-3"><textarea class="form-control" rows="3" id="siteaddress"--><!--placeholder="Enter Site Address"--><!--ng-model="vm.proj.siteaddress"></textarea>--><!--</div>--><!--</div>--><!--<div class="form-group">--><!--<label for="block" class="col-lg-2 control-label">Block</label>--><!--<div class="col-lg-3">--><!--<select class="form-control" id="block"--><!--ng-model="vm.proj.block"--><!--ng-options="block.blockname as block.blockname for block in vm.blocks">--><!--<option value="">Select Block</option>--><!--</select>--><!--</div>--><!--</div>--><!--</fieldset>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><a data-toggle="collapse" data-parent="#accordion" href=".termsandconditions"><center><span data-translate="global.addcafnew.TERMS AND CONDITIONS">Terms & Conditions</span></center></a></h4></div><div id="termsandconditions"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><!--<div class="col-md-12">--><legend><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%" data-translate="global.addcafnew.TERMS AND CONDITIONS">TERMS AND CONDITIONS</p></legend><div class="col-md-12"><br><br><ol><li style="padding:10px"><span data-translate="global.addcafnew.I/We,">I/We </span><b>{{vm.proj.firstname}}</b>, <span data-translate="global.addcafnew.hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.">hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</span></li><li style="padding:10px" data-translate="global.addcafnew.All the required attachments have been completely and legibly attached to this form.">All the required attachments have been completely and legibly attached to this form.</li></ol><div style="padding:10px"><b data-translate="global.addcafnew.Disclaimer">Disclaimer </b>: <span data-translate="global.addcafnew.Please ensure that the email and phone no. provided in this form pertain to concerned person who may be contacted regarding the CAF filled through this login. Incorrect/Invalid information provided in this field may lead to de-activation of CAF created through this login.">Please ensure that the email and phone no. provided in this form pertain to concerned person who may be contacted regarding the CAF filled through this login. Incorrect/Invalid information provided in this field may lead to de-activation of CAF created through this login.</span></div></div><!--</div>--><div class="row"><div class="col-md-12"><div class="col-md-6"><input type="checkbox" id="chkAccept" style="outline: 2px solid; margin-left:23px" autocomplete="off" ng-model="vm.proj.acceptance" autocompletetype="Disable" data-dpmaxz-eid="18"> <span data-translate="global.addcafnew.I Accept Terms and Conditions">I Accept Terms and Conditions</span></div></div><br><div class="table table-striped" style="min-height:40px"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><div id="PreviousFile"></div><div class="file_name" style="display:none"></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label data-translate="global.addcafnew.Applicant Signature">Applicant Signature</label></div><div class="col-md-8" style="margin-top:7px"><input type="file" class="form-control" file-model="vm.cAFAttachmentSign.investorsign" accept="image/*"><p class="text-danger" data-translate="global.addcafnew.Max file size (1 MB) and image files accepted with extension .jpg, .png, .jpeg">Max file size (1 MB) and image files accepted with extension .jpg, .png, .jpeg</p><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label data-translate="global.addcafnew.Place">Place</label></div><div class="col-md-8" style="margin-top:7px"><input class="form-control capitalize" id="Place" name="Place" placeholder="Click here to enter text" type="text" value="" autocomplete="off" ng-model="vm.proj.place" autocompletetype="Disable" data-dpmaxz-eid="19"> <span class="field-validation-valid" data-valmsg-for="Place" data-valmsg-replace="true"></span></div></div></div></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div><div class="panel-heading"><button type="button" ng-click="vm.confirmProject()" data-dpmaxz-eid="12" class="btn btn-primary" ng-show="vm.proj.acceptance" ng-disabled="myform.$invalid || file.maxSizeError|| vm.cAFAttachmentPhoto.investorphoto== null && !vm.cafAttachementInvestorPhoto.fileName || vm.total_foreign_investment.includes(\'null\') || vm.total_nri_investment.includes(\'null\')\n                                || (vm.proj.investmentType === \'Other\' && (vm.proj.otherInvestmetType === null || vm.proj.otherInvestmetType === \'\'))\n                                || (vm.proj.sectorname === \'Other Industries\' && (vm.proj.otherFDI === null || vm.proj.otherFDI === \'\'))"><span data-translate="global.addcafnew.Submit Complete Form">Submit Complete Form</span></button></div></div></form></div><div class="modal rmPaddingModal" data-backdrop="static" data-keyboard="false" id="blockCategoryHint" tabindex="-1" role="dialog" aria-labelledby="YourModalId1"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal()"><span aria-hidden="true">&times;</span></button><h2 class="text-center">Block Data</h2></div><div class="modal-body"><div class="modal-body"><embed src="../../content/pdfs/blockCategories.pdf" width="560px" height="700px"></div></div></div></div></div><div id="confirmCaf" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><h4 class="modal-title"><b>Kindly review the below CAF fields. Once submited, you will no longer be able to change.</b></h4></div><div class="modal-body"><div class="row"><div class="col-md-6"><p><b>Business Entity (M/s) :- </b>{{vm.proj.businessentity}}</p></div><div class="col-md-6"><p><b>Site Address :- </b>{{vm.proj.siteaddress}}</p></div><div class="col-md-6"><p><b>District :- </b>{{vm.proj.district}}</p></div><div class="col-md-6"><p><b>Block Category :- </b>{{vm.proj.blockCategory}}</p></div><div class="col-md-6"><p><b>Investment Type :- </b>{{vm.proj.investmentType}}</p></div><div class="col-md-6"><p><b>Proposed Employment :- </b><code style="font-size:18px">{{vm.proj.totalpurposedemployment}}</code></p></div><div class="col-md-12"><p><b>Proposed Investment (Cr):- </b><code style="font-size:18px">{{vm.total_project_cost}}</code></p></div><!--                    <div ng-if="vm.OTPstatus && !vm.OTP" class="form-group col-md-12">--><!--                        <label  class="col-md-2 control-label">OTP</label>--><!--                        <div class="col-md-4">--><!--                            <input  type="text" class="form-control" ng-model="vm.cafOTP">--><!--                        </div>--><!--                        <button type="submit" class="btn btn-default" ng-disabled="vm.cafOTP===null" ng-click="vm.verifyOTP(vm.proj.mobilenumber,vm.cafOTP)">Verify OTP</button>--><!--                        <button type="button" class="btn btn-default" ng-click="vm.sendOTP(vm.proj.mobilenumber)">Resend OTP</button>--><!--                    </div>--><!--                    <div ng-if="!vm.OTPstatus" class="form-group col-md-12">--><!--                        <h4>OTP Sending Failed.Please click on Resend OTP button.</h4>--><!--                        <button ng-if="!vm.OTPstatus" type="button" class="btn btn-default" ng-click="vm.sendOTP(vm.proj.mobilenumber)">Resend OTP</button>--><!--                    </div>--><!--                    <div  class="form-group col-md-12">--><!--                        <span class="text-success" ng-if="vm.OTPstatus && !vm.OTP"><b>OTP Sent.</b></span>--><!--                    </div>--><!--                    <div  class="form-group col-md-12">--><!--                        <span class="text-success" ng-if="vm.OTP"><b>OTP Verified.</b></span>--><!--                    </div>--></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.editForm()">Edit</button> <button type="button" ng-click="vm.saveAndClose()" data-dpmaxz-eid="12" class="btn btn-primary" ng-show="vm.proj.acceptance && vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')" ng-disabled="myform.$invalid || file.maxSizeError|| vm.total_foreign_investment.includes(\'null\') || vm.total_nri_investment.includes(\'null\')\n                                || (vm.proj.investmentType === \'Other\' && (vm.proj.otherInvestmetType === null || vm.proj.otherInvestmetType === \'\'))\n                                || (vm.proj.sectorname === \'Other Industries\' && (vm.proj.otherFDI === null || vm.proj.otherFDI === \'\'))">Submit Complete Form</button><!--                <button ng-if="vm.OTP" type="button" ng-click="vm.saveAndClose()" data-dpmaxz-eid="12" class="btn btn-primary"--><!--                        ng-show="vm.proj.acceptance && vm.account.authorities.includes(\'ROLE_USER\')"--><!--                        ng-disabled="myform.$invalid || file.maxSizeError|| vm.total_foreign_investment.includes(\'null\') || vm.total_nri_investment.includes(\'null\')--><!--                                || (vm.proj.investmentType === \'Other\' && (vm.proj.otherInvestmetType === null || vm.proj.otherInvestmetType === \'\'))--><!--                                || (vm.proj.sectorname === \'Other Industries\' && (vm.proj.otherFDI === null || vm.proj.otherFDI === \'\'))">--><!--                    Submit Complete Form--><!--                </button>--> <button type="button" ng-click="vm.saveAndClose()" data-dpmaxz-eid="12" class="btn btn-primary" ng-show="vm.proj.acceptance && vm.account.authorities.includes(\'ROLE_USER\')" ng-disabled="myform.$invalid || file.maxSizeError|| vm.total_foreign_investment.includes(\'null\') || vm.total_nri_investment.includes(\'null\')\n                                || (vm.proj.investmentType === \'Other\' && (vm.proj.otherInvestmetType === null || vm.proj.otherInvestmetType === \'\'))\n                                || (vm.proj.sectorname === \'Other Industries\' && (vm.proj.otherFDI === null || vm.proj.otherFDI === \'\'))">Submit Complete Form</button></div></div></div></div>');
$templateCache.put('app/addCAF/addCAFrenewable.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><!--<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.3/jquery.min.js"></script>--><script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/js/bootstrap.min.js"></script><div class="container"><form ng-submit="vm.onsaveProject(\'Final\')" name="myform" novalidate><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><button type="button" class="btn btn-primary" data-dpmaxz-eid="12" ng-click="vm.onsaveProject(\'Draft\')" ng-show="vm.landreq.cafpin==null || vm.landreq.cafpin==\'NA\'" ng-disabled="myform.$invalid || file.maxSizeError">Save Draft</button></h4></div><div id="mandatory"><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Mandatory Fields</legend><div class="form-group"><label class="col-lg-2 control-label">Applicant Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-pattern="/^[a-zA-Z]*$/" ng-model="vm.landreq.firstname" name="firstname" placeholder="First Name" data-dpmaxz-eid="20" required><div ng-show="myform.firstname.$invalid && myform.firstname.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="middlename" ng-model="vm.landreq.middlename" placeholder="Middle Name" data-dpmaxz-eid="20"></div><div class="col-lg-3"><input type="text" class="form-control" id="lastname" placeholder="Last Name" data-dpmaxz-eid="20" ng-model="vm.landreq.lastname"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Name of the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="email1" class="col-lg-2 control-label">Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email1" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required readonly="readonly"><div ng-show="myform.input.$invalid && myform.input.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="email2" placeholder="Secondary Email" ng-model="vm.landreq.emailsecondary"></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><label for="email1" class="col-lg-2 control-label">Update Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email3" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required><div ng-show="myform.input.$invalid && myform.input.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div></div><div class="form-group"><label class="col-lg-2 control-label">Contact Number<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.landreq.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" required><div ng-show="myform.mobileno.$invalid && myform.mobileno.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="phonenumber" placeholder="Phone Number" ng-model="vm.landreq.phonenumber"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Contact number the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="district" class="col-lg-2 control-label">District<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="district" ng-model="vm.landreq.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" required><option value="">Select District</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="District where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="businessentity" class="col-lg-2 control-label">Business Entity (M/s)<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" id="businessentity" placeholder="Enter Business Entity" ng-model="vm.landreq.businessentity" required></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Full name of the Enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div id="termsandconditions"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">TERMS AND CONDITIONS</p><div class="col-md-1"></div><div class="col-md-12"><ol><li style="padding:10px">I/We <b>{{vm.landreq.firstname}}</b>, hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</li><li style="padding:10px">All the required attachments have been completely and legibly attached to this form.</li></ol><div style="padding:10px"><b>Disclaimer</b> : Please ensure that the email and phone no. provided in this form pertain to concerned person who may be contacted regarding the CAF filled through this login. Incorrect/Invalid information provided in this field may lead to de-activation of CAF created through this login.</div></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><input type="checkbox" id="chkAccept" style="outline: 2px solid; margin-left:23px" autocomplete="off" ng-model="vm.landreq.acceptance" autocompletetype="Disable" data-dpmaxz-eid="18"> I Accept Terms and Conditions</div></div><br><div class="table table-striped" style="min-height:40px"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><div id="PreviousFile"></div><div class="file_name" style="display:none"></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Applicant Signature</label></div><div class="col-md-8" style="margin-top:7px"><input type="file" class="form-control" file-model="vm.cAFAttachmentSign.investorsign" accept="image/*"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Place</label></div><div class="col-md-8" style="margin-top:7px"><input class="form-control capitalize" id="Place" name="Place" placeholder="Click here to enter text" type="text" value="" autocomplete="off" ng-model="vm.landreq.place" autocompletetype="Disable" data-dpmaxz-eid="19"> <span class="field-validation-valid" data-valmsg-for="Place" data-valmsg-replace="true"></span></div></div></div></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div><div class="panel-heading"><button type="submit" class="btn btn-primary" data-dpmaxz-eid="12" ng-show="vm.landreq.acceptance" ng-disabled="myform.$invalid || file.maxSizeError">Submit Complete Form</button></div></fieldset></div></div></div></div></div></form></div><div id="blockCategoryHint" class="modal fade" role="dialog"><div class="modal-dialog"><embed src="../../content/pdfs/blockCategories.pdf" width="750px" height="1000px"></div></div>');
$templateCache.put('app/addCAF/addCAFrow.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><div class="container"><form ng-submit="vm.onsaveProject(\'Final\')" name="shopform" novalidate><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><button type="button" class="btn btn-primary" data-dpmaxz-eid="12" ng-click="vm.onsaveProject(\'Draft\')" ng-show="vm.CAFrow.cafpin==null || vm.CAFrow.cafpin==\'NA\'" ng-disabled="shopform.$invalid || file.maxSizeError">Save Draft</button></h4></div><div id="mandatory"><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Mandatory Fields</legend><div class="form-group"><label class="col-lg-2 control-label">Applicant Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-pattern="/^[a-zA-Z]*$/" ng-model="vm.CAFrow.firstname" name="firstname" placeholder="First Name" data-dpmaxz-eid="20" required><div ng-show="shopform.firstname.$invalid && shopform.firstname.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="middlename" ng-model="vm.CAFrow.middlename" placeholder="Middle Name" data-dpmaxz-eid="20"></div><div class="col-lg-3"><input type="text" class="form-control" id="lastname" placeholder="Last Name" data-dpmaxz-eid="20" ng-model="vm.CAFrow.lastname"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Name of the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="email1" class="col-lg-2 control-label">Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email1" placeholder="Primary Email" ng-model="vm.CAFrow.emailprimary" required readonly="readonly"><div ng-show="shopform.input.$invalid && shopform.input.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="email2" placeholder="Secondary Email" ng-model="vm.CAFrow.emailsecondary"></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><label for="email1" class="col-lg-2 control-label">Update Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email3" placeholder="Primary Email" ng-model="vm.CAFrow.emailprimary" required><div ng-show="shopform.input.$invalid && shopform.input.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div></div><div class="form-group"><label class="col-lg-2 control-label">Contact Number<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.CAFrow.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" required><div ng-show="shopform.mobileno.$invalid && shopform.mobileno.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="phonenumber" placeholder="Phone Number" ng-model="vm.CAFrow.phonenumber"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Contact number the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="businessentity" class="col-lg-2 control-label" ng-hide="vm.renewproject">Business Entity (M/s)<span style="color:red">*</span></label><div class="col-lg-3" ng-hide="vm.renewproject"><input type="text" class="form-control" id="businessentity" ng-disabled="vm.renewproject" placeholder="Enter Business Entity" ng-model="vm.CAFrow.businessentity" required></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Full name of the Enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="district" class="col-lg-2 control-label">District<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="district" ng-model="vm.CAFrow.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" required><option value="">Select District</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="District where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div></fieldset></div></div></div><div id="termsandconditions"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">TERMS AND CONDITIONS</p><div class="col-md-1"></div><div class="col-md-12"><ol><li style="padding:10px">I/We <b>{{vm.CAFrow.firstname}}</b>, hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</li><li style="padding:10px">All the required attachments have been completely and legibly attached to this form.</li></ol><div style="padding:10px"><b>Disclaimer</b> : Please ensure that the email and phone no. provided in this form pertain to concerned person who may be contacted regarding the CAF filled through this login. Incorrect/Invalid information provided in this field may lead to de-activation of CAF created through this login.</div></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><input type="checkbox" id="chkAccept" style="outline: 2px solid; margin-left:23px" autocomplete="off" ng-model="vm.CAFrow.acceptance" autocompletetype="Disable" data-dpmaxz-eid="18"> I Accept Terms and Conditions</div></div><br><div class="table table-striped" style="min-height:40px"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><div id="PreviousFile"></div><div class="file_name" style="display:none"></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Applicant Signature</label></div><div class="col-md-8" style="margin-top:7px"><input type="file" class="form-control" file-model="vm.cAFAttachmentSign.investorsign" accept="image/*"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Place</label></div><div class="col-md-8" style="margin-top:7px"><input class="form-control capitalize" id="Place" name="Place" placeholder="Click here to enter text" type="text" value="" autocomplete="off" ng-model="vm.CAFrow.place" autocompletetype="Disable" data-dpmaxz-eid="19"> <span class="field-validation-valid" data-valmsg-for="Place" data-valmsg-replace="true"></span></div></div></div></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div><div class="panel-heading"><button type="submit" class="btn btn-primary" data-dpmaxz-eid="12" ng-show="vm.CAFrow.acceptance" ng-disabled="shopform.$invalid || file.maxSizeError">Submit Complete Form</button></div></div></div></form></div><div id="blockCategoryHint" class="modal fade" role="dialog"><div class="modal-dialog"><embed src="../../content/pdfs/blockCategories.pdf" width="750px" height="1000px"></div></div>');
$templateCache.put('app/addCAF/addCAFshop.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><!--<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.3/jquery.min.js"></script>--><script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/js/bootstrap.min.js"></script><div class="container"><form ng-submit="vm.onsaveProject(\'Final\')" name="shopform" novalidate><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><button type="button" class="btn btn-primary" data-dpmaxz-eid="12" ng-click="vm.onsaveProject(\'Draft\')" ng-show="vm.landreq.cafpin==null || vm.landreq.cafpin==\'NA\'" ng-disabled="shopform.$invalid || file.maxSizeError">Save Draft</button></h4></div><div id="mandatory"><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Mandatory Fields</legend><div class="form-group"><label class="col-lg-2 control-label">Applicant Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-pattern="/^[a-zA-Z]*$/" ng-model="vm.landreq.firstname" name="firstname" placeholder="First Name" data-dpmaxz-eid="20" required><div ng-show="shopform.firstname.$invalid && shopform.firstname.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="middlename" ng-model="vm.landreq.middlename" placeholder="Middle Name" data-dpmaxz-eid="20"></div><div class="col-lg-3"><input type="text" class="form-control" id="lastname" placeholder="Last Name" data-dpmaxz-eid="20" ng-model="vm.landreq.lastname"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Name of the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="email1" class="col-lg-2 control-label">Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email1" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required readonly="readonly"><div ng-show="shopform.input.$invalid && shopform.input.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="email2" placeholder="Secondary Email" ng-model="vm.landreq.emailsecondary"></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><label for="email1" class="col-lg-2 control-label">Update Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email3" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required><div ng-show="shopform.input.$invalid && shopform.input.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div></div><div class="form-group"><label class="col-lg-2 control-label">Contact Number<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.landreq.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" required><div ng-show="shopform.mobileno.$invalid && shopform.mobileno.$touched "><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="phonenumber" placeholder="Phone Number" ng-model="vm.landreq.phonenumber"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Contact number the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="businessentity" class="col-lg-2 control-label" ng-hide="vm.renewproject">Business Entity (M/s)<span style="color:red">*</span></label><div class="col-lg-3" ng-hide="vm.renewproject"><input type="text" class="form-control" id="businessentity" ng-disabled="vm.renewproject" placeholder="Enter Business Entity" ng-model="vm.landreq.businessentity" required><!--                                        <p><font color="red">*The Proposed Industry/Business Entity  Name should match the name mentioned in the PAN</font></p>--></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Full name of the Enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><div class="col-md-12"><p class="text-danger col-md-offset-6">*To know your block enter your village name or visit this <a target="_blank" ng-click="vm.blockopen()" data-toggle="modal">link</a></p></div><label for="district" class="col-lg-2 control-label">District<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="district" ng-model="vm.landreq.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" required ng-change="vm.getVillages(vm.landreq.district)"><option value="" disabled="disabled">Select District</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="District where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><label for="district" class="col-lg-2 control-label">Village</label><div class="col-lg-3"><input type="text" class="form-control" id="village" placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.landreq.district === null" ng-model="vm.landreq.village" ng-change="vm.setBlockCategory(vm.landreq.village,vm.villages)"><datalist id="villages"><option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option></datalist></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Village where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><div class="col-lg-2"><small ng-show="vm.invalidVillage" class="text-danger">invalid village name</small></div></div><div class="form-group"><label class="col-lg-2 control-label">Category of Block<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="blockCategory" ng-model="vm.landreq.blockCategory" required><option value="">Select Block</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option></select></div></div><div class="form-group"><label class="col-lg-2 control-label">Total Proposed Project Cost (in Crore) <span style="color:red">*</span></label><div class="col-lg-8"><div class="col-lg-2"><input type="number" class="form-control" name="croresCost" placeholder="Crores" ng-model="vm.project_cost_in_crore" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" required><div ng-show="shopform.croresCost.$invalid && shopform.croresCost.$touched || shopform.croresCost.$error.min"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-2"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.project_cost_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="shopform.lacsCost.$invalid && shopform.lacsCost.$touched || shopform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-3"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.project_cost_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="shopform.thousandsCost.$invalid && shopform.thousandsCost.$touched || shopform.thousandsCost.$error.min"><small style="color:red; display:block;text-align:ceter">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div></div><div class="form-group"><label class="col-lg-2 control-label">Total Proposed Project Employment <span style="color:red">*</span></label><div class="col-lg-3"><input type="number" class="form-control" id="totalemplotment" placeholder="0" ng-model="vm.landreq.totalpurposedemployment" min="0" required></div></div><div class="form-group"><label for="PanNumber" class="col-lg-2 control-label">PAN Number<span style="color:red">*</span></label><div class="col-lg-2"><input type="text" ng-pattern="/^([A-Z]){5}([0-9]){4}([A-Z]){1}/" class="form-control" id="PanNumber" placeholder="Enter PAN Number" name="PanNumber" ng-model="vm.landreq.pan_number" maxlength="10" style="text-transform: uppercase" required></div><!-- Verify Button --><div class="col-lg-2"><button type="button" class="btn btn-primary" ng-click="vm.verifyPan()">Verify</button></div><!-- Error Messages, aligned on a new line --><div style="margin-top: 15px" class="col-lg-6" style="margin-top: 5px"><span ng-show="vm.panErrorMessage" class="text-danger">{{ vm.panErrorMessage }}</span> <span ng-show="vm.panSuccessMessage" class="text-success">{{ vm.panSuccessMessage }}</span></div><div ng-show="myform.PanNumber.$invalid"></div></div></fieldset></div></div></div><div id="termsandconditions"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">TERMS AND CONDITIONS</p><div class="col-md-1"></div><div class="col-md-12"><ol><li style="padding:10px">I/We <b>{{vm.landreq.firstname}}</b>, hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</li><li style="padding:10px">All the required attachments have been completely and legibly attached to this form.</li></ol><div style="padding:10px"><b>Disclaimer</b> : Please ensure that the email and phone no. provided in this form pertain to concerned person who may be contacted regarding the CAF filled through this login. Incorrect/Invalid information provided in this field may lead to de-activation of CAF created through this login.</div></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><input type="checkbox" id="chkAccept" style="outline: 2px solid; margin-left:23px" autocomplete="off" ng-model="vm.landreq.acceptance" autocompletetype="Disable" data-dpmaxz-eid="18"> I Accept Terms and Conditions</div></div><br><div class="table table-striped" style="min-height:40px"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><div id="PreviousFile"></div><div class="file_name" style="display:none"></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Applicant Signature</label></div><div class="col-md-8" style="margin-top:7px"><input type="file" class="form-control" file-model="vm.cAFAttachmentSign.investorsign" accept="image/*"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Place</label></div><div class="col-md-8" style="margin-top:7px"><input class="form-control capitalize" id="Place" name="Place" placeholder="Click here to enter text" type="text" value="" autocomplete="off" ng-model="vm.landreq.place" autocompletetype="Disable" data-dpmaxz-eid="19"> <span class="field-validation-valid" data-valmsg-for="Place" data-valmsg-replace="true"></span></div></div></div></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div><div class="panel-heading"><button type="submit" class="btn btn-primary" data-dpmaxz-eid="12" ng-show="vm.landreq.acceptance" ng-disabled="shopform.$invalid || file.maxSizeError">Submit Complete Form</button></div></div></div></form></div><div class="modal rmPaddingModal" data-backdrop="static" data-keyboard="false" id="blockCategoryHint" tabindex="-1" role="dialog" aria-labelledby="YourModalId1"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal()"><span aria-hidden="true">&times;</span></button><h2 class="text-center">Block Data</h2></div><div class="modal-body"><div class="modal-body"><embed src="../../content/pdfs/blockCategories.pdf" width="560px" height="700px"></div></div></div></div></div>');
$templateCache.put('app/addCAF/addCAFtower.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><!--<script src="https://ajax.googleapis.com/ajax/libs/jquery/1.11.3/jquery.min.js"></script>--><script src="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.5/js/bootstrap.min.js"></script><div class="container"><form ng-submit="vm.onsaveProject(\'Final\')" name="shopform" novalidate><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-heading"><h4 class="panel-title"><button type="button" class="btn btn-primary" data-dpmaxz-eid="12" ng-click="vm.onsaveProject(\'Draft\')" ng-show="vm.landreq.cafpin==null || vm.landreq.cafpin==\'NA\'" ng-disabled="shopform.$invalid || file.maxSizeError">Save Draft</button></h4></div><div id="mandatory"><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Mandatory Fields</legend><div class="form-group"><label class="col-lg-2 control-label">Applicant Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-pattern="/^[a-zA-Z]*$/" ng-model="vm.landreq.firstname" name="firstname" placeholder="First Name" data-dpmaxz-eid="20" required><div ng-show="shopform.firstname.$invalid && shopform.firstname.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="middlename" ng-model="vm.landreq.middlename" placeholder="Middle Name" data-dpmaxz-eid="20"></div><div class="col-lg-3"><input type="text" class="form-control" id="lastname" placeholder="Last Name" data-dpmaxz-eid="20" ng-model="vm.landreq.lastname"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Name of the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="email1" class="col-lg-2 control-label">Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email1" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required readonly="readonly"><div ng-show="shopform.input.$invalid && shopform.input.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="email2" placeholder="Secondary Email" ng-model="vm.landreq.emailsecondary"></div></div><div class="form-group" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><label for="email1" class="col-lg-2 control-label">Update Email <span style="color:red">*</span></label><div class="col-lg-3"><input type="email" name="input" class="form-control" id="email3" placeholder="Primary Email" ng-model="vm.landreq.emailprimary" required><div ng-show="shopform.input.$invalid && shopform.input.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div></div><div class="form-group"><label class="col-lg-2 control-label">Contact Number<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" name="mobileno" placeholder="Mobile Number" ng-model="vm.landreq.mobilenumber" ng-pattern="/^[0-9]*$/" maxlength="10" ng-disabled="vm.isMobileAutoFilled" required><div ng-show="shopform.mobileno.$invalid && shopform.mobileno.$touched "><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><div class="col-lg-3"><input type="text" class="form-control" id="phonenumber" placeholder="Phone Number" ng-model="vm.landreq.phonenumber"></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Contact number the representative of the enterprise who can be contacted regarding this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="businessentity" class="col-lg-2 control-label" ng-hide="vm.renewproject">Business Entity (M/s) <span style="color:red">*</span></label><div class="col-lg-3" ng-hide="vm.renewproject"><select class="form-control" id="businessentity" ng-model="vm.selectedBusinessEntity" ng-options="entity as entity.name for entity in vm.businessEntities" ng-change="vm.onBusinessEntityChange()" ng-disabled="vm.isBusinessEntityAutoSelected" required><option value="">-- Select Business Entity --</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="Full name of the Enterprise for which clearances/approvals shall be applied through this CAF" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="district" class="col-lg-2 control-label">District<span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" id="district" ng-model="vm.landreq.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" ng-disabled="vm.isDistrictAutoSelected" required><option value="">Select District</option></select></div><div class="col-lg-1"><div><a data-balloon-length="xlarge" data-balloon="District where the Enterprise is setup or planned to be setup" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div></div><div class="form-group"><label for="PanNumber" class="col-lg-2 control-label">PAN Number<span style="color:red">*</span></label><div class="col-lg-2"><input type="text" ng-pattern="/^([A-Z]){5}([0-9]){4}([A-Z]){1}/" class="form-control" id="PanNumber" placeholder="Enter PAN Number" name="PanNumber" ng-model="vm.landreq.pan_number" maxlength="10" style="text-transform: uppercase" required></div><!-- Verify Button --><div class="col-lg-2"><button type="button" class="btn btn-primary" ng-click="vm.verifyPan()">Verify</button></div><!-- Error Messages, aligned on a new line --><div style="margin-top: 15px" class="col-lg-6" style="margin-top: 5px"><span ng-show="vm.panErrorMessage" class="text-danger">{{ vm.panErrorMessage }}</span> <span ng-show="vm.panSuccessMessage" class="text-success">{{ vm.panSuccessMessage }}</span></div><div ng-show="myform.PanNumber.$invalid"></div></div></fieldset></div></div></div><div id="termsandconditions"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">TERMS AND CONDITIONS</p><div class="col-md-1"></div><div class="col-md-12"><ol><li style="padding:10px">I/We <b>{{vm.landreq.firstname}}</b>, hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</li><li style="padding:10px">All the required attachments have been completely and legibly attached to this form.</li></ol><div style="padding:10px"><b>Disclaimer</b> : Please ensure that the email and phone no. provided in this form pertain to concerned person who may be contacted regarding the CAF filled through this login. Incorrect/Invalid information provided in this field may lead to de-activation of CAF created through this login.</div></div></div><div class="row"><div class="col-md-12"><div class="col-md-6"><input type="checkbox" id="chkAccept" style="outline: 2px solid; margin-left:23px" autocomplete="off" ng-model="vm.landreq.acceptance" autocompletetype="Disable" data-dpmaxz-eid="18"> I Accept Terms and Conditions</div></div><br><div class="table table-striped" style="min-height:40px"><div class="row"><div class="col-md-8"></div><div class="col-md-4"><div id="PreviousFile"></div><div class="file_name" style="display:none"></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Applicant Signature</label></div><div class="col-md-8" style="margin-top:7px"><input type="file" class="form-control" file-model="vm.cAFAttachmentSign.investorsign" accept="image/*"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div><div class="row"><div class="col-md-6"></div><div class="col-md-6"><div class="col-md-4 control-label"><label>Place</label></div><div class="col-md-8" style="margin-top:7px"><input class="form-control capitalize" id="Place" name="Place" placeholder="Click here to enter text" type="text" value="" autocomplete="off" ng-model="vm.landreq.place" autocompletetype="Disable" data-dpmaxz-eid="19"> <span class="field-validation-valid" data-valmsg-for="Place" data-valmsg-replace="true"></span></div></div></div></div></div><div class="form-group"><div class="col-lg-10 col-lg-offset-2"></div></div></fieldset></div></div></div><div class="panel-heading"><button type="submit" class="btn btn-primary" data-dpmaxz-eid="12" ng-show="vm.landreq.acceptance">Submit Complete Form</button></div></div></div></form></div><div id="blockCategoryHint" class="modal fade" role="dialog"><div class="modal-dialog"><embed src="../../content/pdfs/blockCategories.pdf" width="750px" height="1000px"></div></div>');
$templateCache.put('app/addCAF/caftype.html','<div class="modal-body"><label class="control-label" data-translate="global.menu.Select Project Type">Select Project Type</label><div class="row"><div class="col-md-5"><div class="radio"><label><input type="radio" value="NEW" ng-model="vm.projectType" ng-click="vm.onprojectTypeSelected()"> <span data-translate="global.menu.New Enterprise/Expansion/Diversification">New Enterprise/Expansion/Diversification</span></label></div></div><div class="col-md-offset-4 col-md-3"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="caftypeNewEnterprise"><span></span>&nbsp;<span data-translate="global.menu.Services">Services</span></button></div></div><!--<div class="row">--><!--<div class="col-md-5">--><!--<div class="radio">--><!--<label>--><!--<input type="radio" value=\'RENEWABLE\' ng-model="vm.projectType"--><!--ng-click="vm.onprojectTypeSelected()">--><!--Renew of Factory Registration / CTO / Boiler /BMW /HWM--><!--</label>--><!--</div>--><!--</div>--><!--<div class="col-md-offset-4 col-md-3">--><!--<button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="caftypeRenewEnterprise">--><!--<span></span>&nbsp;<span>Services</span>--><!--</button>--><!--</div>--><!--</div>--><div class="row"><div class="col-md-5"><div class="radio"><label><input type="radio" value="SHOP" ng-model="vm.projectType" ng-click="vm.onprojectTypeSelected()"> <span data-translate="global.menu.Shop Registration">Shop Registration</span></label></div></div><div class="col-md-offset-4 col-md-3"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="caftypeShopEnterprise"><span></span>&nbsp;<span data-translate="global.menu.Services">Services</span></button></div></div><div class="row"><div class="col-md-5"><div class="radio"><label><input type="radio" value="LANDREQUIREMENT" ng-model="vm.projectType" ng-click="vm.onprojectTypeSelected()"> <span data-translate="global.menu.Land Requirement CAF">Land Requirement CAF</span></label></div></div><div class="col-md-offset-4 col-md-3"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="landServices"><span></span>&nbsp;<span data-translate="global.menu.Services">Services</span></button></div></div><div class="row"><div class="col-md-5"><div class="radio"><label><input type="radio" value="TOWERCAF" ng-model="vm.projectType" ng-click="vm.onprojectTypeSelected()"> <span data-translate="global.menu.Communication and Connectivity Permissions">Communication and Connectivity Permissions</span></label></div></div><div class="col-md-offset-4 col-md-3"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="commAndConnServices"><span></span>&nbsp;<span data-translate="global.menu.Services">Services</span></button></div></div><div class="row"><div class="col-md-5"><div class="radio"><label><input type="radio" value="FILMCAF" ng-model="vm.projectType" ng-click="vm.onprojectTypeSelected()"> <span data-translate="global.menu.Film Shooting permission/Cinema License/Tourism Event">Film Shooting permission/Cinema License/TourismEvent</span></label></div></div><div class="col-md-offset-4 col-md-3"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="filmServices"><span></span>&nbsp;<span data-translate="global.menu.Services">Services</span></button></div></div><div class="row"><div class="col-md-5"><div class="radio"><label><input type="radio" value="EXCISE" ng-model="vm.projectType" ng-click="vm.onprojectTypeSelected()"> <span data-translate="global.menu.Excise and Taxation">Excise and Taxation</span></label></div></div><div class="col-md-offset-4 col-md-3"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="caftypeExciseEnterprise"><span></span>&nbsp;<span data-translate="global.menu.Services">Services</span></button></div></div><!--    <div class="row">--><!--        <div class="col-md-5">--><!--            <div class="radio">--><!--                <label>--><!--                    <input type="radio" value=\'ROW\' ng-model="vm.projectType"--><!--                           ng-click="vm.onprojectTypeSelected()">--><!--                    Row - Gas Pipeline--><!--                </label>--><!--            </div>--><!--        </div>--><!--        <div class="col-md-offset-4 col-md-3">--><!--            <button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="rowServices">--><!--                <span></span>&nbsp;<span>Services</span>--><!--            </button>--><!--        </div>--><!--    </div>--><!--<div class="row">--><!--<div class="col-md-5">--><!--<div class="radio">--><!--<label>--><!--<input type="radio" value=\'LANDEXCHANGE\' ng-model="vm.projectType"--><!--ng-click="vm.onprojectTypeSelected()">--><!--Exchange of Revenue Raasta--><!--</label>--><!--</div>--><!--</div>--><!--<div class="col-md-offset-4 col-md-3">--><!--<button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="caftypeLandExchange">--><!--<span></span>&nbsp;<span>Services</span>--><!--</button>--><!--</div>--><!--</div>--></div>');
$templateCache.put('app/addCAF/editCafForUser.html','<div class="container" ng-if="vm.proj"><h3 class="page-header">CAF Change Request for {{vm.originalProj.cafpin}}</h3><form name="editCafForm" novalidate><!-- ===================== SECTION 1 ===================== --><div class="panel panel-default"><div class="panel-heading"><h4>Business Entity Details</h4></div><div class="panel-body"><div class="form-group"><label>Proposed Industry Name</label><input type="text" class="form-control" ng-model="vm.proj.businessentity" required></div></div></div><!-- ===================== SECTION 2 ===================== --><div class="panel panel-default" ng-if="vm.cafType == \'New\'"><div class="panel-heading"><h4>Business Entity Type</h4></div><div class="panel-body"><div class="form-group"><label>Business Entity Type</label><select class="form-control" ng-model="vm.proj.businessentitytype" ng-options="entity.businessentitytype as entity.businessentitytype for entity in vm.businessentities" required><option value="">-- Select Entity Type --</option></select></div></div></div><!-- ===================== SECTION 3 ===================== --><div class="panel panel-default"><div class="panel-heading"><h4>Address Details</h4></div><div class="panel-body"><div class="form-group"><label>District</label><select class="form-control" ng-model="vm.proj.district" ng-options="district.districtname as district.districtname for district in vm.districts" ng-change="vm.getVillages(vm.proj.district)" required><option value="">-- Select District --</option></select></div><div ng-if="vm.cafType == \'New\' || vm.cafType == \'Shop\' || vm.cafType==\'LandRequirement\'"><p class="text-danger" data-translate="global.addcafnew.To know your block enter your village name or visit this">*To know your block enter your village name or visit this <a target="_blank" ng-click="vm.blockopen()" data-toggle="modal">link</a></p></div><label for="village" class="col-lg-2 control-label" data-translate="global.addcafnew.Village">Village</label><div class="col-lg-3"><input type="text" class="form-control" id="village" placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.proj.district === null" ng-model="vm.proj.village" ng-change="vm.setBlockCategory(vm.proj.village,vm.villages)"><datalist id="villages"><option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option></datalist></div><!-- Block Category --><div ng-if="vm.cafType == \'New\' || vm.cafType == \'Shop\' || vm.cafType==\'LandRequirement\' || vm.cafType==\'Excise\'"><div class="form-group row"><label class="col-lg-2 col-form-label">Block Category</label><div class="col-lg-3"><input type="text" readonly="readonly" class="form-control" ng-model="vm.proj.blockCategory" required></div></div></div><!-- Site Address --><div ng-if="vm.cafType == \'New\'"><div class="form-group"><label>Site Address</label><textarea class="form-control" ng-model="vm.proj.siteaddress" rows="3" required>\n                        </textarea></div></div></div></div><div class="panel panel-default"><div class="panel-heading"><h4>Upload Supporting Documents</h4></div><div class="panel-body"><div class="form-group"><label>Attachment (* Only PDF files up to 2 MB are allowed.)</label><!--                    <input type="file"--><!--                           name="attachment"--><!--                           class="form-control"--><!--                           file-model="vm.form.file"--><!--                           ng-change="vm.checkFileValidation()"--><!--                           required>--> <input type="file" name="attachment" class="form-control" file-model-two-mb="vm.form.file" accept="application/pdf" required><!-- Required validation --><p ng-show="editCafForm.attachment.$touched && editCafForm.attachment.$error.required" style="color:red">Document is required.</p><!-- File size error --><p ng-show="vm.maxSizeError2mbtest" style="color:red">Max file size exceeded (2 MB)</p><!-- File type error --><p ng-show="vm.fileTypeErrortest" style="color:red">Only PDF files are allowed.</p></div></div></div><br><button type="button" class="btn btn-primary" ng-click="vm.updateSelectedFields()" ng-disabled="editCafForm.$invalid || !vm.form.file || vm.isSaving">Submit</button> <button type="button" class="btn btn-default" ng-click="vm.cancel()">Cancel</button><!--        <br>--><!--        <br>--></form></div>');
$templateCache.put('app/addCAF/excisecafservices.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Servies</h4></div><div class="modal-body"><pre>\n        <b>EXCISE & TAXATION - EXCISE</b>\n         Application for Permit (Import Permit/Within State Permit/Export)\n         Application for License of Local sale (Retail)\n         Application for Label/Brand Registration\n\n        </pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/addCAF/filmServices.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Services</h4></div><div class="modal-body"><pre>\n      <b>Information, Public Relations and Language\t</b>\n         Permission (Registration & renewal) for Movie shooting in Haryana (including at State Protected monuments)\n      <b>HOME DEPARTMENT</b>\n         Issuance & Renewal of Cinema License\n         NoC for Tourism Events/ Exhibition\n\n        </pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/addCAF/landExchangecafservices.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Services</h4></div><div class="modal-body"><pre>\n            <b>Development and Panchayats</b>\n                Exchange of land for industrial and residential colonies\n\n            <b>Urban Local Bodies</b>\n                Exchange of land for industrial and residential colonies\n        </pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/addCAF/landServices.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Servies</h4></div><div class="modal-body"><pre>\n      <b>HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD\t</b>\n            Land Allotment\n        </pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/addCAF/newcafservices.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Services</h4></div><div class="modal-body"><pre>\n      <b>LABOUR DEPARTMENT - FACTORY WING</b>\n         Approval of factory plan\n         Factory registration or license\n         Registration under The Building and Other Construction Workers Act\n         Renewal Factory registration or license\n\n      <b>LABOUR DEPARTMENT - LABOUR WING</b>\n         License for contractor under provision of Contract Labour\n         Registration certificate of Establishment Inter State Migrant Worker men\n         Registration of Principal Employers\n\n      <b>HARYANA STATE POLLUTION CONTROL BOARD</b>\n         Authorization under e-Waste\n         Authorization under Bio Medical Waste\n         Authorization Under Hazardous Waste Rules\n         Consent to Operate - Air/Water\n         CTE\n         CTE-Renewal\n         Registration under Plastic Manufacture, Sale and Usage\n         Renewal of Authorization under e-Waste\n         Renewal of Consent to Operate - Air/Water\n         Renewal of Registration under Plastic Manufacture, Sale and Usage\n         Auto-Renewal of Consent to Operate Air/Water Self certification\n         Registration under Battery-Waste (Management) Rules, 2022\n         Authorization under C & D Waste Management Rules 2016\n         Authorization under Solid Waste Management Rules 2016\n\n      <b>DAKSHIN HARYANA BIJLI VITRAN NIGAM</b>\n         Regular Electricity Connection- Release of Connection (DHBVN)\n         Regular Electricity Connection-Demand Notice Issue (DHBVN)\n         Temporary Electricity Connection (DHBVN)\n         Extension/Reduction of Load-Demand Notice Issue (DHBVN)\n         Extension/Reduction of Load-Release of Connection (DHBVN)\n\n      <b>UTTAR HARYANA BIJLI VITRAN NIGAM</b>\n         Regular Electricity Connection- Release of Connection (UHBVN)\n         Regular Electricity Connection-Demand Notice Issue (UHBVN)\n         Temporary Electricity Connection (UHBVN)\n         Extension/Reduction of Load-Demand Notice Issue(UHBVN)\n         Extension/Reduction of Load-Release of Connection(UHBVN)\n         Change of Name - Electricity Connection\n         Reconnection - Electricity Connection\n         Reduction of Load-Electricity Connection\n         Shifting of HT/LT lines - Demand Notice\n         Shifting of HT/LT lines - Execution of work completion\n\n      <b>TOWN & COUNTRY PLANNING</b>\n         Application for Licence to Establish Kiln\n         Approval of Building plan\n         Licence for Industrial Plotted Colony\n         NOC for unit falling outside controlled or urban area\n         Occupation or Completion Certificate (Form BR-IVB)\n         Conversion of LOI into CLU permission\n\t     Letter of Intent (LOI) for CLU\n\t     Completion Certificate in Licence Colony\n\n      <b>URBAN LOCAL BODIES</b>\n         Application for New Fire Fighting Scheme\n         Approval of Building plan\n         Change of Land Use under MC Limit\n         Issuance of sewerage connection\n         Issuance of Trade License under section 330\n         Issuance of Water connection\n         NOC for Fire Service\n         Occupation or Completion Certificate (Form BR-IVB)\n\n      <b>HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD</b>\n         Approval of Building plan\n         Sewerage Connection\n         Occupation or Completion Certificate (Form BR-IVA) - Institutional and Commercial\n         Occupation Certificate (Form BR-IVB) - Industrial HOBPAS\n         Release of permanent water connection\n\n      <b>DEPARTMENT OF INDUSTRIES & COMMERCE</b>\n         Lubricating License for Manufacturing\n         Registration under Boiler Act\n         Lubricating License for Trading\n         Renewal Under Boiler Act\n         Boiler Manufacturing\n\n      <b>CHIEF ELECTRICAL INSPECTOR</b>\n         Certification of Electrical Installation upto 33KV (Form -A2)(Sub-Station/Transformer, Generating Set & Solar Power Plant)(Form-A2)\n         Certificate of Transmission Lines Upto 33KV (Form - B2)\n         Certification of Electrical Installation above 33KV (Sub-Station/Transformer, Generating Set & Solar Power Plant) (Form-A1)\n         Certification of Transmission-lines above 33kv (Fom - B1 )\n         Periodical Inspection of the Electrical installation (HTI/MPI, Sub-Station/Transformer,Generating Set & Solar Power Plant\n         Approval of Single line Diagram\n\n      <b>DEPARTMENT OF FORESTS & WILDLIFE</b>\n         Application for Tree Felling\n         Forest NOC/Clarification/Forest Clearance\n\n      <b>ENVIRONMENT</b>\n         Environment Clearance under Aravali Notification dated 07.05.1992\n\n      <b>FOOD & SUPPLIES DEPARTMENT</b>\n         Issuance of New Licence Dealer\n         Issuance of New Licence Manufacturer\n         Issuance of New Licence Repairer\n         Licence for brick kiln\n         Certificate of Verification of weights and measures\n\n      <b>Food and Drug Administration</b>\n         Application for Biological Drugs in own premises (Form 27)\n         Application for Biological Drugs in loan premises (Form 27A)\n         Application for Non-Biological Drugs in own premises (Form 24)\n         Application for Non-Biological Drugs in loan premises (Form 24A)\n\n      <b>MINES & GEOLOGY DEPARTMENT</b>\n         License for Stone Crushers/Grinding Unit\n         Permit for manufacturing of bricks\n         Grant of Mineral Dealer\'s License\n         Permit for Excavation of ordinary clay or earth\n         Permit for the Grant of Permission for Disposal of Mineral\n         Renewal of Excavation of Brick Earth by the Brick\n         Renewal of Mineral Dealer\'s License\n         Renewal of Stone Crusher/Grinding Unit\n\n      <b>National Monument Authority</b>\n         NMA Clearance\n\n      <b>PUBLIC HEALTH ENGINEERING DEPARTMENT</b>\n         Issuance of permanent water connection\n         Issuance of sewerage connection\n\n      <b>PWD (B & R) DEPARTMENT</b>\n         Clearance for entry or exit from State Highway or Scheduled road under MORT&H guidelines\n         Road Cutting Permission\n\n      <b>Airport Authority of India</b>\n         NOC Application for Height Clearance\n\n      <b>DEPARTMENT OF AGRICULTURE</b>\n         Application form for fertilizer manufacture certificate\n         Licence to Manufacture Insecticides\n\n      <b>DEPARTMENT OF AYUSH</b>\n         New ASU Drug Manufacturing license\n         New ASU Drug Manufacturing loan license\n         Renewal of ASU Drug Manufacturing license\n         Renewal of ASU Drug Manufacturing loan license\n         Single Medicine Approval\n\n      <b>GMDA</b>\n         CLU\n      <b>Haryana Shehri Vikas Pradhikaran</b>\n         Approval of Building plan\n         Occupation or Completion Certificate (Form BR-IVB)\n         Sewerage Connection\n         Water Connection-Permanent\n         Water Connection-Temporary\n\n\n            <!--<b>DEPARTMENT OF RENEWABLE ENERGY</b>-->\n    <!--Registration and Approval for Setting of Biomass Based Power Project-->\n\n\n</pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/addCAF/renewcafservices.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Services</h4></div><div class="modal-body"><pre>\n      <b>DEPARTMENT OF INDUSTRIES & COMMERCE</b>\n         Renewal Under Boiler Act\n\n      <b>HARYANA STATE POLLUTION CONTROL BOARD</b>\n         CTE\n         Renewal of CTE\n         Authorization Under Hazardous Waste Rules\n         Authorization under Bio Medical Waste\n         Renewal of Registration under Plastic Manufacture, Sale and Usage\n         Renewal of Authorization under e-Waste\n         Auto-Renewal of Consent to Operate Air/Water Self certification\n         Renewal of Consent to Operate - Air-Water\n         Consent to Operate - Air/Water\n\n      <b>LABOUR DEPARTMENT - FACTORY WING</b>\n         Renewal Factory registration or license\n\n      <b>LABOUR DEPARTMENT - LABOUR WING</b>\n         Registration certificate of Establishment Inter State Migrant Worker men\n         Registration of Principal Employers\n\n</pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/addCAF/rowServices.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Services</h4></div><div class="modal-body"><pre>\n      <b>ROW</b>\n            ROW- Gas Pipeline (HARYANA SHEHRI VIKAS PRADHIKARAN)\n            ROW- Gas Pipeline (PWD(B&R))\n            ROW- Gas Pipeline(Irrigation Department)\n            ROW- Gas Pipeline (HSIIDC)\n            ROW- Gas Pipeline (Development and Panchayats)\n        </pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Close</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/addCAF/shopcafservices.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Services</h4></div><div class="modal-body"><pre>\n      <b>LABOUR DEPARTMENT - LABOUR WING</b>\n         License for contractor under provision of Contract Labour\n         Registration certificate of Establishment Inter State Migrant Worker men\n         Registration of Principal Employers\n         Shop Registration under shops and establishment act\n\n      <b>Food and Drug Administration</b>\n         Application for Retail/Wholesale Drug License\n\n\n<!--      <b>EXCISE & TAXATION - EXCISE</b>-->\n<!--         Application for Permit (Import Permit/Within State Permit/Export)-->\n<!--         Application for License of Local sale (Retail)-->\n<!--         Application for Label/Brand Registration-->\n\n\n        </pre></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button><!--<button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary">--><!--<span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span>--><!--</button>--></div></form>');
$templateCache.put('app/applicationLogs/applicationLogs.html','');
$templateCache.put('app/assignFieldOfficerToDepartment/assignFieldOfficerToDepartment.html','<div ng-cloak><div class="container"><div class="row"><div class="navbar-form navbar-left" role="search"><div class="form-group"><label>Select Department :</label><select id="department" name="department" class="form-control" ng-model="vm.department.val" required><option value="">Select Department</option><option ng-repeat="department in vm.departments track by department.id" ng-model="vm.department.selected" value="{{department.id}}">{{department.departmentname}}</option></select><label id="departmentname" name="departmentname" class="form-control ng-hide" ng-model="vm.department.val">{{vm.department.val}}</label></div>{{vm.fieldOfficer.val}}</div></div><div class="row"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><!--<th>Project Identification No.(PIN)</th>--><th>User Name</th><th>User Login</th><th>User Email</th></tr></thead><tbody><tr ng-repeat="fieldOfficer in vm.fieldofficerList track by fieldOfficer.id"><!--<td >{{vm.projectcompletedetail.investorDTO.firstname}}</td>--><!--{{prdtl.projectdetailDTO.id}}--><td>{{fieldOfficer.firstName}} {{fieldOfficer.lastName}}</td><td>{{fieldOfficer.login}}</td><td>{{fieldOfficer.email}}</td><td class="action verticalalign"><button type="submit" ng-click="vm.save(vm.department.val, fieldOfficer)" class="btn btn-info">Assign</button></td></tr></tbody></table></div><div class="row"></div><!--<div class = "row">--><!--<div class="navbar-form navbar-left" role="search">--><!--<div class="form-group" >--><!--<label>Assign To : </label>--><!--<select id="FO" name="FO" class="form-control" ng-model ="vm.fieldOfficer.val" required>--><!--<option value="">Select Field Officer</option>--><!--<option ng-repeat="fieldOfficer in vm.fieldofficerList track by fieldOfficer.id" value="{{fieldOfficer.login}}">--><!--{{fieldOfficer.firstName}} {{fieldOfficer.lastName}} ({{fieldOfficer.login}})--><!--</option>--><!--</select>--><!--<label id="departmentnasme" name="deparstmentname"  class="form-control" ng-model ="fieldOfficer.id">{{fieldOfficer.id}}</label>--><!--</div>--><!--<button type="submit" class="btn btn-danger" ng-click="vm.save(vm.department.val, vm.fieldOfficer.val)">Assign</button>--><!--</div>--><!--</div>--></div></div>');
$templateCache.put('app/assignProjectToRM/assignProjectToRM.html','<div class="container-fluid"><div class="row"><div class="col-lg-6 list-group"><a ng-click="vm.getUnassignedProject()" class="list-group-item active">Unassigned<span class="badge">{{vm.totalUnassignedProject}}</span></a></div><div class="col-lg-6 list-group"><a ng-click="vm.getAssignedProject()" class="list-group-item active">Assigned<span class="badge">{{vm.totalAssignedProject}}</span></a></div></div><div class="row"><div class="col-md-12"><div class="container-fluid"><div class="row"><div class="navbar-header col-md-4"><a class="navbar-brand">{{vm.title}}</a></div><div class="col-md-8" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><div class="row" ng-show="vm.assigned"><div class="col-md-3"><label>Select RM from List</label></div><div class="col-md-4"><select class="form-control" ng-model="vm.selectedRm" ng-change="vm.getAssignedProjectByRm(vm.selectedRm)" ng-options="rmlist.rmlogin as rmlist.rmlogin for rmlist in vm.rmlists"><option value=" " selected="selected">---Select RM--</option></select></div></div></div></div><button id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm pull-right btn-marginTop" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div><div class="row"><div class="table-responsive"><table id="result_table" class="table table-striped table-hover"><thead><tr class="headerGrid"><!--<th>Project Identification No.(PIN)</th>--><th>#</th><th>CAF Pin (Composite Application Form)</th><th>RM Info (Relationship Manager)</th><th>Investor Name</th><th>Project Purpose</th><th>Business Entity</th><th>Project Type</th><th>Total Project Cost</th><th>Proposed Employment</th><th>Project Level</th><th>District</th><th></th></tr></thead><tbody ng-if="vm.pagination"><tr ng-repeat="prdtl in vm.projectlist.slice(((currentPage-1)*itemsPerPage), ((currentPage)*itemsPerPage)) "><td>{{($index + 1 + currentPage*itemsPerPage) - itemsPerPage}}</td><td>{{prdtl.cafPin}}</td><td>{{prdtl.assignedToRM === \'Not Assigned\' ? prdtl.assignedToRM : prdtl.rmInfo}}</td><td>{{prdtl.investorName}}</td><td>{{prdtl.sectorName}}</td><td>{{prdtl.businessEntity}}</td><td>{{prdtl.projectType}}</td><td>{{prdtl.projectTotalCost}}</td><td>{{prdtl.totalEmployement}}</td><td>{{prdtl.projectLevel === \'d\' ? \'DLCC\' :\'EEC\'}}</td><td>{{prdtl.district}}</td><td class="action verticalalign"><button type="submit" ui-sref="assignRM({projectid:prdtl.id})" class="btn btn-info">Details</button></td></tr></tbody><tbody ng-if="!vm.pagination"><tr ng-repeat="prdtl in vm.projectlistByRM"><td>{{($index + 1 )}}</td><td>{{prdtl.cafPin}}</td><td>{{prdtl.assignedToRM === \'Not Assigned\' ? prdtl.assignedToRM : prdtl.rmInfo}}</td><td>{{prdtl.investorName}}</td><td>{{prdtl.sectorName}}</td><td>{{prdtl.businessEntity}}</td><td>{{prdtl.projectType}}</td><td>{{prdtl.projectTotalCost}}</td><td>{{prdtl.totalEmployement}}</td><td>{{prdtl.projectLevel === \'d\' ? \'DLCC\' :\'EEC\'}}</td><td>{{prdtl.district}}</td><td class="action verticalalign"><button type="submit" ui-sref="assignRM({projectid:prdtl.id})" class="btn btn-info">Details</button></td></tr></tbody></table></div></div><div class="row" ng-if="vm.pagination"><div class="col-md-12 text-center"><ul class="pagination pagination-md"><li><a href="" aria-label="Previous"><span aria-hidden="true">\xAB</span></a></li><li ng-repeat="num in maxSizeArray() track by $index" ng-class="{active : currentPage === $index+1}"><a ng-click="vm.changePage($index)">{{$index+1}}</a></li><li><a href="" aria-label="Next"><span aria-hidden="true">\xBB</span></a></li></ul></div></div></div>');
$templateCache.put('app/assignProjectToRM/assignRM.html','<div ng-cloak><div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Details</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><th class="col-md-3">Application For</th><td class="col-md-3">Regulatory Approvals & Services</td><th class="col-md-3">Sector</th><td class="col-md-3">{{vm.investorsummarydetails.sectorName}}</td></tr><tr><th class="col-md-3">CAF PIN (Composite Application Form)</th><td class="col-md-3">{{vm.investorsummarydetails.cafpin}}</td><th class="col-md-3">ApplicationDate</th><td class="col-md-3">{{vm.investorsummarydetails.applicationDate | date:\'dd-MM-yyyy\'}}</td></tr><tr><th class="col-md-3">Business Entity</th><td class="col-md-3">{{vm.investorsummarydetails.buisnessEntity}}</td><th class="col-md-3">Site Detail</th><td class="col-md-3">{{vm.investorsummarydetails.siteaddress}},{{vm.investorsummarydetails.district}},{{vm.investorsummarydetails.block}}</td></tr><tr><th class="col-md-2">Project Cost</th><td class="col-md-2">{{vm.investorsummarydetails.projectTotalCost}}</td><th class="col-md-2">Total Proposed Area</th><td class="col-md-2">{{vm.investorsummarydetails.totalProposedLandArea}}</td></tr><tr><th class="col-md-2">Land Zone</th><td class="col-md-2">{{vm.investorsummarydetails.landZoneType}}</td><th class="col-md-2"></th><td class="col-md-2"></td></tr><tr><th class="col-md-2">Relationship Manager</th><td class="col-md-2">{{vm.investorsummarydetails.rmInfo}}</td><th class="col-md-2">Contact Person</th><td class="col-md-2">{{vm.investorsummarydetails.investorName}}</td></tr></tbody></table></div></div><div><form class="navbar-form navbar-left" role="search"><div class="form-group"><label>Assign To :</label><select id="RM" name="RM" class="form-control" ng-model="vm.RMDetail.login" required><option value="">Select Relationship Manager</option><option ng-repeat="rm in vm.RMDetails track by rm.login" value="{{rm.login}}">{{rm.firstName}} {{rm.lastName}} ({{rm.login}})</option></select></div><button type="submit" class="btn btn-danger" ng-click="vm.save(vm.investorsummarydetails.projectid, vm.RMDetail.login)">Assign</button> <button type="submit" class="btn btn-primary" ui-sref="assignProjectToRM">Back</button></form></div></div></div>');
$templateCache.put('app/belowGround/belowGround-detail.html','<div class="container panel-body"><div class="row"><div class="col-md-12"><form name="editForm" role="form" ng-submit="vm.save()"><div id="outerdiv"><div class="row"><h4 class="col-md-4 control-label"><b>A. Details of the applicant licensee</b></h4><button ng-hide="vm.below_ground.isforwardedtodc" ng-click="vm.edit_form()" type="button" class="col-md-1 pull-right uk-button uk-button-danger" style="font-size: 12px"><span class="glyphicon glyphicon-pencil">&nbsp;</span>Edit</button> <button ui-sref="belowGround" type="button" class="col-md-1 pull-right uk-button uk-button-primary" style="font-size: 12px"><span class="glyphicon glyphicon-arrow-left">&nbsp;</span>Back</button></div><div class="col-md-offset-1 row"><div class="form-group" ng-show="vm.below_ground.id" hidden><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.below_ground.id" readonly="readonly"></div><div class="col-md-5 form-group"><label class="control-label" for="field_name">Name of Applicant *</label><input ng-disabled="isDisabled" placeholder="Enter Your Name Here" type="text" class="form-control" name="name" id="field_name" ng-model="vm.below_ground.name" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_reg_add">Registered Address *</label><textarea ng-disabled="isDisabled" type="text" class="form-control" name="reg_add" id="field_reg_add" ng-model="vm.below_ground.reg_add" rows="3" required></textarea></div><div class="col-md-5 form-group"><label class="control-label" for="field_har_office_add">Haryana Circle office Address *</label><textarea ng-disabled="isDisabled" type="text" class="form-control" name="har_office_add" id="field_har_office_add" ng-model="vm.below_ground.har_office_add" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_name_auth">Name of the Authorized Person *</label><input ng-disabled="isDisabled" placeholder="Enter Name Here" type="text" class="form-control" name="name_auth" id="field_name_auth" ng-model="vm.below_ground.name_auth" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_designation_auth">Designation of the Authorized Person *</label><input ng-disabled="isDisabled" placeholder="Enter Designation here" type="text" class="form-control" name="designation_auth" id="field_designation_auth" ng-model="vm.below_ground.designation_auth" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_phone_auth">Phone/Mobile no. of the Authorized Person *</label><input ng-disabled="isDisabled" placeholder="Enter Phone/Mobile no. Here" type="text" class="form-control" name="phone_auth" id="field_phone_auth" ng-pattern="/^[0-9]*$/" ng-model="vm.below_ground.phone_auth" minlength="10" maxlength="10" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_email">Email of the Authorized Person *</label><input ng-disabled="isDisabled" placeholder="example@domain.com" type="email" class="form-control" name="email" id="field_email" ng-model="vm.below_ground.email" required></div></div><h4 class="control-label"><b>B. Details of the proposed work to be laid</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_lenth">Length etc. of the proposed work *</label><textarea ng-disabled="isDisabled" placeholder="Enter Details Here" type="text" class="form-control" name="lenth" id="field_lenth" ng-model="vm.below_ground.lenth" rows="3" required></textarea></div><div class="col-md-5 form-group"><label class="control-label" for="field_route">Route planned for the proposed work *</label><textarea ng-disabled="isDisabled" placeholder="Enter Details Here" type="text" class="form-control" name="route" id="field_route" ng-model="vm.below_ground.route" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_nature">Nature of the proposed work *</label><textarea ng-disabled="isDisabled" placeholder="Enter Details Here" type="text" class="form-control" name="nature" id="field_nature" ng-model="vm.below_ground.nature" rows="3" required></textarea></div><div class="col-md-5 form-group"><label class="control-label" for="field_methodology">Methodology for execution of the proposed work *</label><textarea ng-disabled="isDisabled" placeholder="Enter Details Here" type="text" class="form-control" name="methodology" id="field_methodology" ng-model="vm.below_ground.methodology" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_address1">Location details including ward no. colony etc. *</label><input ng-disabled="isDisabled" placeholder="Enter Address Details Here" type="text" class="form-control" name="address1" id="field_address1" ng-model="vm.below_ground.address1" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_address2">City/Town/Village & Tehsil *</label><input ng-disabled="isDisabled" placeholder="Enter Address Details Here" type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.below_ground.address2" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_district">District *</label><select ng-disabled="isDisabled" placeholder="Enter District Name Here" type="text" class="form-control" name="district" id="field_district" ng-model="vm.below_ground.district" required><option value="" disabled="disabled">--- Select District ---</option><option ng-repeat="option in vm.districts">{{option.districtname}}</option></select></div><div class="col-md-5 form-group"><label class="control-label" for="field_zone">Zone under which this area is falling *</label><select ng-disabled="isDisabled" placeholder="Enter Zone Name Here" type="text" class="form-control" name="zone" id="field_zone" ng-model="vm.below_ground.zone" required><option value="" disabled="disabled">--- Select Zone ---</option><option ng-repeat="zone in vm.zones">{{zone.zone_name}}</option></select></div></div><h4 class="control-label"><b>C. Details of fee and charges deposited *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><textarea ng-disabled="isDisabled" placeholder="Enter Fee Details Here" type="text" class="form-control" name="details1" id="field_details1" ng-model="vm.below_ground.details1" rows="3" required> </textarea></div></div><h4 class="control-label"><b>D. Details of Performance Bank Guarantee to be given as per para 2.3 of Appendix 2 *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><textarea ng-disabled="isDisabled" placeholder="Enter Details Here" type="text" class="form-control" name="details2" id="field_details2" ng-model="vm.below_ground.details2" rows="3" required> </textarea></div></div><h4 class="control-label"><b>E. Other information for proposed work *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><textarea ng-disabled="isDisabled" placeholder="The details of land or building or structures where\n                           the laying of OFC/telegraph infrastructure is proposed" type="text" class="form-control" name="other_info1" id="field_other_info1" ng-model="vm.below_ground.other_info1" rows="3" required></textarea></div><div class="col-md-5 form-group"><textarea ng-disabled="isDisabled" placeholder="The mode of and the time duration for execution of the work " type="text" class="form-control" name="other_info2" id="field_other_info2" ng-model="vm.below_ground.other_info2" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><textarea ng-disabled="isDisabled" placeholder="The time of the day when the work is expected to be done in case the applicant expects the work to be done during specific time of the day" type="text" class="form-control" name="other_info3" id="field_other_info3" ng-model="vm.below_ground.other_info3" rows="3" required></textarea></div><div class="col-md-5 form-group"><textarea ng-disabled="isDisabled" placeholder="The inconvenience that is likely to be caused to the public and the specific measures proposed to be taken to mitigate such inconvenience" type="text" class="form-control" name="other_info4" id="field_other_info4" ng-model="vm.below_ground.other_info4" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><textarea ng-disabled="isDisabled" placeholder="The specific measures proposed to be taken to ensure public safety during the execution of the work" type="text" class="form-control" name="other_info5" id="field_other_info5" ng-model="vm.below_ground.other_info5" rows="3" required></textarea></div><div class="col-md-5 form-group"><textarea ng-disabled="isDisabled" placeholder="Any other matter relevant, in the opinion of the licensee, connected with or relative to the work proposed to be undertaken" type="text" class="form-control" name="other_info6" id="field_other_info6" ng-model="vm.below_ground.other_info6" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><textarea ng-disabled="isDisabled" placeholder="Any other information required under any order of DoT, State Govt. or local body" type="text" class="form-control" name="other_info7" id="field_other_info7" ng-model="vm.below_ground.other_info7" rows="3" required></textarea></div></div></div><div id="documentdiv"><h4 class="control-label"><b>F. Documents (Mandatory)</b></h4><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="mdocument1" id="field_mdocument1" file-model="vm.document1" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument1">A copy of relevant license/infrastructure provider registration certificate granted by the DoT</label></div><div class="col-md-2"><button ng-disabled="vm.document1==null" type="button" ng-show="vm.show" ng-click="vm.upload(1,vm.document1)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload1" class="uk-label">Uploaded </span><button type="button" ng-show="!vm.show" ng-click="vm.download(vm.below_ground.document1,\'registration-certificate\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="mdocument2" id="field_mdocument2" file-model="vm.document2" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument2">Detail of the location of map showing the proposed underground or over ground OFC/telegraph infrastructure including route planned, exact latitude and longitude, nature of land</label></div><div class="col-md-2"><button ng-disabled="vm.document2==null" type="button" ng-show="vm.show" ng-click="vm.upload(2,vm.document2)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload2" class="uk-label">Uploaded </span><button type="button" ng-show="!vm.show" ng-click="vm.download(vm.below_ground.document2,\'tower-location\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="mdocument3" id="field_mdocument3" file-model="vm.document3" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument3">The copy of consent of the owner of land/building where the OFC/telegraph infrastructure proposed to be laid</label></div><div class="col-md-2"><button ng-disabled="vm.document3==null" type="button" ng-show="vm.show" ng-click="vm.upload(3,vm.document3)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload3" class="uk-label">Uploaded </span><button type="button" ng-show="!vm.show" ng-click="vm.download(vm.below_ground.document3,\'consent-of-building-owner\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="mdocument4" id="field_mdocument4" file-model="vm.document4" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument4">Time schedule (Stretch-wise) for completion of the work</label></div><div class="col-md-2"><button ng-disabled="vm.document4==null" type="button" ng-show="vm.show" ng-click="vm.upload(4,vm.document4)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload4" class="uk-label">Uploaded </span><button type="button" ng-show="!vm.show" ng-click="vm.download(vm.below_ground.document4,\'work-timeschedule\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="mdocument5" id="field_mdocument5" file-model="vm.document5" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument5">Indemnity bond to indemnify the Government/ Local Body/ Authority in the /prescribed format against (i) any liability for the damage caused to the infrastructure laid by the applicant for any reasons, and (ii) claims against any accidents on account of the infrastructure laid/ facilities installed or against any claims thereafter during the period of Operation & Maintenance of such infrastructure at all times</label></div><div class="col-md-2"><button ng-disabled="vm.document5==null" type="button" ng-show="vm.show" ng-click="vm.upload(5,vm.document5)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload5" class="uk-label">Uploaded </span><button type="button" ng-show="!vm.show" ng-click="vm.download(vm.below_ground.document5,\'indemnity-bond\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="mdocument6" id="field_mdocument6" file-model="vm.document6" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument6">Undertaking as per Appendix-7 (Prescribed Format)</label></div><div class="col-md-2"><button ng-disabled="vm.document6==null" type="button" ng-show="vm.show" ng-click="vm.upload(6,vm.document6)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload6" class="uk-label">Uploaded </span><button type="button" ng-show="!vm.show" ng-click="vm.download(vm.below_ground.document6,\'undertaking\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button></div></div></div><br><h4 class="control-label"><b>H. Documents (Optional)</b></h4><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" class="form-control-file" name="odocument1" id="field_odocument1" file-model="vm.document7" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_odocument1">For forest/protected areas, the copy of clearance from State Environment & Forest Department</label></div><div class="col-md-2"><button ng-disabled="vm.document7==null" type="button" ng-show="vm.show" ng-click="vm.upload(7,vm.document7)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-hide="vm.below_ground.document7===null" ng-show="!vm.show" ng-click="vm.download(vm.below_ground.document7,\'forest-clearance-doc\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload7" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div ng-show="vm.show" class="col-md-3"><input type="file" id="browsefile" class="form-control-file" file-model="vm.document8" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError" for="browsefile"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="browsefile">The detailed technical design and drawings of the post or other above ground contrivances (in case of over ground cabling)</label></div><div class="col-md-2"><button ng-disabled="vm.document8==null" type="button" ng-show="vm.show" ng-click="vm.upload(8,vm.document8)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <button type="button" ng-hide="vm.below_ground.document8===null" ng-show="!vm.show" ng-click="vm.download(vm.below_ground.document8,\'detailed-design-doc\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class=""></span>&nbsp;Download</button> <span ng-show="vm.show_upload8" class="uk-label">Uploaded</span></div></div></div><div ng-show="vm.show" class="modal-footer"><button type="submit" ng-disabled="vm.isSaving" class="uk-button uk-button-primary uk-button-large" style="font-size: 14px"><span class="glyphicon glyphicon-save"></span>&nbsp;Save</button></div></div></form></div></div></div>');
$templateCache.put('app/belowGround/belowGround-dialog.html','<div class="container panel-body"><div class="row"><div class="col-md-12"><form name="editForm" role="form" ng-submit="vm.save()"><div ng-show="!vm.show"><h4 class="control-label"><b>A. Details of the applicant licensee</b></h4><div class="col-md-offset-1 row"><div class="form-group" ng-show="vm.below_ground.id" hidden><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.below_ground.id" readonly="readonly"></div><div class="col-md-5 form-group"><label class="control-label" for="field_name">Name of Applicant *</label><input placeholder="Enter Your Name Here" type="text" class="form-control" name="name" id="field_name" ng-model="vm.below_ground.name" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_reg_add">Registered Address *</label><textarea type="text" class="form-control" name="reg_add" id="field_reg_add" ng-model="vm.below_ground.reg_add" rows="3" required></textarea></div><div class="col-md-5 form-group"><label class="control-label" for="field_har_office_add">Haryana Circle office Address *</label><textarea type="text" class="form-control" name="har_office_add" id="field_har_office_add" ng-model="vm.below_ground.har_office_add" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_name_auth">Name of the Authorized Person *</label><input placeholder="Enter Name Here" type="text" class="form-control" name="name_auth" id="field_name_auth" ng-model="vm.below_ground.name_auth" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_designation_auth">Designation of the Authorized Person *</label><input placeholder="Enter Designation here" type="text" class="form-control" name="designation_auth" id="field_designation_auth" ng-model="vm.below_ground.designation_auth" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_phone_auth">Phone/Mobile no. of the Authorized Person *</label><input placeholder="Enter Phone/Mobile no. Here" type="number" class="form-control" name="phone_auth" id="field_phone_auth" ng-model="vm.below_ground.phone_auth" minlength="10" maxlength="10" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_email">Email of the Authorized Person *</label><input placeholder="example@domain.com" type="email" class="form-control" name="email" id="field_email" ng-model="vm.below_ground.email" required></div></div><h4 class="control-label"><b>B. Details of the proposed work to be laid</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_lenth">Length etc. of the proposed work *</label><textarea placeholder="Enter Details Here" type="text" class="form-control" name="lenth" id="field_lenth" ng-model="vm.below_ground.lenth" rows="3" required></textarea></div><div class="col-md-5 form-group"><label class="control-label" for="field_route">Route planned for the proposed work *</label><textarea placeholder="Enter Details Here" type="text" class="form-control" name="route" id="field_route" ng-model="vm.below_ground.route" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_nature">Nature of the proposed work *</label><textarea placeholder="Enter Details Here" type="text" class="form-control" name="nature" id="field_nature" ng-model="vm.below_ground.nature" rows="3" required></textarea></div><div class="col-md-5 form-group"><label class="control-label" for="field_methodology">Methodology for execution of the proposed work *</label><textarea placeholder="Enter Details Here" type="text" class="form-control" name="methodology" id="field_methodology" ng-model="vm.below_ground.methodology" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_address1">Location details including ward no. colony etc. *</label><input placeholder="Enter Address Details Here" type="text" class="form-control" name="address1" id="field_address1" ng-model="vm.below_ground.address1" required></div><div class="col-md-5 form-group"><label class="control-label" for="field_address2">City/Town/Village & Tehsil *</label><input placeholder="Enter Address Details Here" type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.below_ground.address2" required></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><label class="control-label" for="field_district">District *</label><select placeholder="Enter District Name Here" type="text" class="form-control" name="district" id="field_district" ng-model="vm.below_ground.district" required><option ng-repeat="option in vm.districts">{{option.districtname}}</option></select></div><div class="col-md-5 form-group"><label class="control-label" for="field_zone">Zone under which this area is falling *</label><select placeholder="Enter Zone Name Here" type="text" class="form-control" name="zone" id="field_zone" ng-model="vm.below_ground.zone" required><option ng-repeat="zone in vm.zones">{{zone.zone_name}}</option></select></div></div><h4 class="control-label"><b>C. Details of fee and charges deposited *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><!--<label class="control-label" data-translate="investhryApp.above_ground.fee_details" for="field_fee_details">Fee Details</label>--><textarea placeholder="Enter Fee Details Here" type="text" class="form-control" name="details1" id="field_details1" ng-model="vm.below_ground.details1" rows="3" required> </textarea></div></div><h4 class="control-label"><b>D. Details of Performance Bank Guarantee to be given as per para 2.3 of Appendix 2 *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><!--<label class="control-label" data-translate="investhryApp.above_ground.fee_details" for="field_fee_details">Fee Details</label>--><textarea placeholder="Enter Details Here" type="text" class="form-control" name="details2" id="field_details2" ng-model="vm.below_ground.details2" rows="3" required> </textarea></div></div><h4 class="control-label"><b>E. Other information for proposed work *</b></h4><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><textarea placeholder="The details of land or building or structures where\nthe laying of OFC/telegraph infrastructure is proposed" type="text" class="form-control" name="other_info1" id="field_other_info1" ng-model="vm.below_ground.other_info1" rows="3" required></textarea></div><div class="col-md-5 form-group"><textarea placeholder="The mode of and the time duration for execution of the work " type="text" class="form-control" name="other_info2" id="field_other_info2" ng-model="vm.below_ground.other_info2" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><textarea placeholder="The time of the day when the work is expected to be done in case the applicant expects the work to be done during specific time of the day" type="text" class="form-control" name="other_info3" id="field_other_info3" ng-model="vm.below_ground.other_info3" rows="3" required></textarea></div><div class="col-md-5 form-group"><textarea placeholder="The inconvenience that is likely to be caused to the public and the specific measures proposed to be taken to mitigate such inconvenience" type="text" class="form-control" name="other_info4" id="field_other_info4" ng-model="vm.below_ground.other_info4" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><textarea placeholder="The specific measures proposed to be taken to ensure public safety during the execution of the work" type="text" class="form-control" name="other_info5" id="field_other_info5" ng-model="vm.below_ground.other_info5" rows="3" required></textarea></div><div class="col-md-5 form-group"><textarea placeholder="Any other matter relevant, in the opinion of the licensee, connected with or relative to the work proposed to be undertaken" type="text" class="form-control" name="other_info6" id="field_other_info6" ng-model="vm.below_ground.other_info6" rows="3" required></textarea></div></div><div class="col-md-offset-1 row"><div class="col-md-5 form-group"><textarea placeholder="Any other information required under any order of DoT, State Govt. or local body" type="text" class="form-control" name="other_info7" id="field_other_info7" ng-model="vm.below_ground.other_info7" rows="3" required></textarea></div></div><div class="modal-footer"><button ng-show="!vm.show" type="submit" ng-disabled="vm.isSaving" class="uk-button uk-button-primary uk-button-large" style="font-size: 14px">Next&nbsp;&nbsp;<span class="glyphicon glyphicon-forward"></span></button></div></div></form><div ng-show="vm.show"><form name="editForm" role="form" ng-submit="vm.onsubmit()"><h4 class="control-label"><b>F. Documents (Mandatory)</b></h4><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="mdocument1" id="field_mdocument1" file-model="vm.document1" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument1">A copy of relevant license/infrastructure provider registration certificate granted by the DoT</label></div><div class="col-md-2"><button ng-disabled="vm.document1==null" type="button" ng-click="vm.upload(1,vm.document1)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload1" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="mdocument2" id="field_mdocument2" file-model="vm.document2" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument2">Detail of the location of map showing the proposed underground or over ground OFC/telegraph infrastructure including route planned, exact latitude and longitude, nature of land</label></div><div class="col-md-2"><button ng-disabled="vm.document2==null" type="button" ng-click="vm.upload(2,vm.document2)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload2" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="mdocument3" id="field_mdocument3" file-model="vm.document3" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument3">The copy of consent of the owner of land/building where the OFC/telegraph infrastructure proposed to be laid</label></div><div class="col-md-2"><button ng-disabled="vm.document3==null" type="button" ng-click="vm.upload(3,vm.document3)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload3" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="mdocument4" id="field_mdocument4" file-model="vm.document4" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument4">Time schedule (Stretch-wise) for completion of the work</label></div><div class="col-md-2"><button ng-disabled="vm.document4==null" type="button" ng-click="vm.upload(4,vm.document4)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload4" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="mdocument5" id="field_mdocument5" file-model="vm.document5" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument5">Indemnity bond to indemnify the Government/ Local Body/ Authority in the /prescribed format against (i) any liability for the damage caused to the infrastructure laid by the applicant for any reasons, and (ii) claims against any accidents on account of the infrastructure laid/ facilities installed or against any claims thereafter during the period of Operation & Maintenance of such infrastructure at all times</label></div><div class="col-md-2"><button ng-disabled="vm.document5==null" type="button" ng-click="vm.upload(5,vm.document5)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload5" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="mdocument6" id="field_mdocument6" file-model="vm.document6" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_mdocument6">Undertaking as per Appendix-7 (Prescribed Format)</label></div><div class="col-md-2"><button ng-disabled="vm.document6==null" type="button" ng-click="vm.upload(6,vm.document6)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload6" class="uk-label">Uploaded</span></div></div></div><br><h4 class="control-label"><b>H. Documents (Optional)</b></h4><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" class="form-control-file" name="odocument1" id="field_odocument1" file-model="vm.document7" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="field_odocument1">For forest/protected areas, the copy of clearance from State Environment & Forest Department</label></div><div class="col-md-2"><button ng-disabled="vm.document7==null" type="button" ng-click="vm.upload(7,vm.document7)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload7" class="uk-label">Uploaded</span></div></div></div><div class="panel-body bordered-row row"><div class="form-group"><div class="col-md-3"><input type="file" id="browsefile" class="form-control-file" file-model="vm.document8" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError" for="browsefile"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="col-md-7"><label class="control-label" for="browsefile">The detailed technical design and drawings of the post or other above ground contrivances (in case of over ground cabling)</label></div><div class="col-md-2"><button ng-disabled="vm.document8==null" type="button" ng-click="vm.upload(8,vm.document8)" class="uk-button uk-button-danger" style="font-size: 14px"><span class="glyphicon glyphicon-upload"></span>&nbsp;Upload</button> <span ng-show="vm.show_upload8" class="uk-label">Uploaded</span></div></div></div><div class="modal-footer"><button ng-show="vm.show" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="uk-button uk-button-primary uk-button-large" style="font-size: 14px"><span class="glyphicon glyphicon-save"></span>&nbsp;Save</button></div></form></div></div></div></div><div id="modal-below2" class="uk-modal-container" uk-modal><div class="uk-modal-dialog uk-modal-body" uk-overflow-auto><button class="uk-modal-close-default" type="button" uk-close></button><div><h3>Document (Mandatory)</h3><p>1. A copy of relevant license/infrastructure provider registration certificate granted by the DoT</p><p>2. Detail of the location of map showing the proposed underground or over ground OFC/telegraph infrastructure including route planned, exact latitude and longitude, nature of land</p><p>3. The copy of consent of the owner of land/building where the OFC/telegraph infrastructure proposed to be laid</p><p>4. Time schedule (Stretch-wise) for completion of the work</p><p>5. Indemnity bond to indemnify the Government/ Local Body/ Authority in the /prescribed format against (i) any liability for the damage caused to the infrastructure laid by the applicant for any reasons, and (ii) claims against any accidents on account of the infrastructure laid/ facilities installed or against any claims thereafter during the period of Operation & Maintenance of such infrastructure at all times</p><p>6. Undertaking as per Appendix-7 (Prescribed Format)</p><h3>Document (Optional)</h3><p>1. For forest/protected areas, the copy of clearance from State Environment & Forest Department</p><p>2. The detailed technical design and drawings of the post or other above ground contrivances (in case of over ground cabling)</p></div><div class="uk-text-right"><button class="uk-button uk-button-primary uk-modal-close" type="button" style="font-size: 12px">Proceed</button></div></div></div>');
$templateCache.put('app/belowGround/belowGround.html','<div class="container-fluid panel-body"><div class="row"><div class="col-md-12"><center><button class="uk-button uk-button-primary uk-button-large" style="font-size: 14px" ui-sref="belowGround-dialog"><span>Permission for laying/establishment of underground Telegraph Infrastructure</span></button></center></div></div><br><div class="row"><div class="col-md-12"><table class="jh-table table table-striped"><thead><tr><th><span>Name of Applicant</span></th><th><span>Name of Authorized Person</span></th><th><span>Designation of Authorized Person</span></th><th><span>Phone of Authorized Person</span></th><th><span>Email of Authorized Person</span></th><th>Form Filled Complete/Partial</th><th><span>Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="below_ground in vm.below_grounds track by below_ground.id"><td>{{below_ground.name}}</td><td>{{below_ground.name_auth}}</td><td>{{below_ground.designation_auth}}</td><td>{{below_ground.phone_auth}}</td><td>{{below_ground.email}}</td><td><span ng-show="below_ground.isfullyfilled == true" class="uk-label uk-label-default" style="font-size: 12px">Complete</span> <span ng-show="below_ground.isfullyfilled == false" class="uk-label uk-label-danger" style="font-size: 12px">Partial</span></td><td><span ng-show="below_ground.status == \'Pending\'" class="uk-label uk-label-warning" style="font-size: 12px">Pending</span> <span ng-show="below_ground.status == \'Rejected\'" class="uk-label uk-label-danger" style="font-size: 12px">Rejected</span> <span ng-show="below_ground.status == \'Cleared\'" class="uk-label uk-label-default" style="font-size: 12px">Cleared</span></td><td><div class="uk-inline"><button class="uk-button uk-button-primary" type="button" style="font-size: 12px">Action</button><div uk-dropdown="pos: bottom-justify" mode="click"><ul class="uk-nav uk-dropdown-nav" style="font-size: 14px"><li><a ui-sref="belowGround-detail({id:below_ground.id})">View Form</a></li><li><a ng-click="vm.comment(below_ground)" uk-toggle="target: #modal_below3">Comment</a></li><li><a ng-click="vm.view_log(below_ground.id)" uk-toggle="target: #modal_below1">View Log</a></li><li><a ng-show="below_ground.clearancefile3" ng-show="below_ground.clearancefile3" ng-click="vm.dowload_dialog(below_ground.clearancefile1,below_ground.clearancefile2,below_ground.clearancefile3)" uk-toggle="target: #modal_below4">Clearance Files</a></li></ul></div></div></td></tr></tbody></table></div></div></div><div id="modal_below1" uk-modal><div class="uk-modal-dialog"><button class="uk-modal-close-default" type="button" uk-close></button><div class="uk-modal-header"><h2 class="uk-modal-title">Log</h2></div><div class="uk-modal-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Action</span></th><th><span>Action By</span></th><th><span>Comment</span></th><!--<th><span>Tower Id</span></th>--><th><span>Action Date</span></th></tr></thead><tbody><tr ng-repeat="tower_log in vm.towerLog track by tower_log.id"><td>{{tower_log.action}}</td><td>{{tower_log.action_by}}</td><td>{{tower_log.comment}}</td><!--<td>{{tower_log.tower_id}}</td>--><td>{{tower_log.action_date | date:\'medium\'}}</td></tr></tbody></table></div></div><div class="uk-modal-footer uk-text-right"><button class="uk-button uk-button-danger uk-modal-close" type="button" style="font-size: 12px">Close</button></div></div></div><div id="modal_below3" uk-modal><div class="uk-modal-dialog"><form role="form" ng-submit="vm.save()" show-validation><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h2 class="uk-modal-title">Comment on {{vm.name_applicant}} \'s Form . . .</h2></div><div class="uk-modal-body"><textarea ng-model="vm.tower_log.comment" class="uk-textarea" rows="5" name="comment" id="comment" required></textarea></div><div class="uk-text-right uk-modal-footer"><!--<button type="button" class="uk-button uk-button-danger uk-modal-close" style="font-size: 12px">Close</button>--> <button type="submit" class="uk-button uk-button-primary" style="font-size: 12px">Comment</button></div></form></div></div><div id="modal_below4" uk-modal><div class="uk-modal-dialog uk-margin-auto-vertical uk-modal-body"><div><button class="uk-modal-close-outside" type="button" uk-close></button><h2 class="uk-modal-title text-center"><b>Choose File to Downlad</b></h2></div><div><div class="row"><div class="col-md-4 text-center"><label for="download1">Clearance File 1:</label><button id="download1" type="button" ng-click="vm.download(1,\'clearancefile1\')" class="uk-button uk-button-primary" style="font-size: 14px">Download</button></div><div class="col-md-4 text-center"><label for="download2">Clearance File 2:</label><button id="download2" type="button" ng-click="vm.download(2,\'clearancefile2\')" class="uk-button uk-button-primary" style="font-size: 14px">Download</button></div><div class="col-md-4 text-center"><label for="download3">Clearance File 3:</label><button id="download3" type="button" ng-click="vm.download(3,\'clearancefile3\')" class="uk-button uk-button-primary" style="font-size: 14px">Download</button></div></div></div><!--<div class="uk-text-right uk-modal-footer">--><!--<button type="button" class="uk-button uk-button-danger uk-modal-close" style="font-size: 12px">Close</button>--><!--</div>--></div></div>');
$templateCache.put('app/cafservicestatus/cafservicestatus.html','<div class="container"><div class="row"><div class="col-md-9"><ul class="nav nav-pills"><li class="active"><a>Total CAFs&nbsp;<span class="badge">{{vm.cafservicestatus.length}}</span></a></li><li class="active"><a>Total Completed CAFs&nbsp;<span class="badge">{{vm.totalcompleted}}</span></a></li><li class="text-danger"><b>*</b> <small>Total CAFs : Active CAFs with atleast one service pending/cleared</small></li></ul></div><div class="form-group"><span class="filter-margin uk-label uk-label-danger col-md-1" style="font-size: 12px">FILTER BY:</span><div class="col-md-2"><select class="form-control" ng-options="x.value as x.name for x in vm.percentages" ng-model="vm.percentfilter" ng-change="vm.filterResult(vm.percentfilter)"><option value="" disabled="disabled">-- Select --</option></select></div></div></div><div class="row"><div class="pull-left" style="color: red"><b>*</b> Enter a period of 6 months</div></div><div class="row"><div class="col-md-1"><strong class="pull-right" style="padding-right:10px"><i>From</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_fromdate" type="text" class="form-control" name="fromdate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-change="vm.selectedDate(vm.fromdate)" ng-model="vm.fromdate" is-open="vm.datePickerOpenStatus.fromdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><strong class="pull-right" style="padding-right:10px"><i>To</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_todate" type="text" class="form-control" name="todate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions1" ng-model="vm.todate" is-open="vm.datePickerOpenStatus.todate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><button class="btn btn-primary col-md-2" ng-disabled="vm.todate==null" style="margin-right: 5px" ng-click="vm.getCafBetweenDates()">Get Record</button> <button class="btn btn-primary col-md-2" ng-if="vm.clearFilterButton" style="margin-right: 5px" ng-click="vm.clearFilter()">Clear Filter</button></div><button ng-show="vm.show" style="margin-bottom: 12px" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm pull-right btn-marginTop">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button><br><table id="result_table" class="table table-striped table-bordered table-sm" cellspacing="0" width="100%"><thead><tr><th>#</th><th>CAF Pin (Composite Application Form)</th><th>Total Applied</th><th>Applied Services</th><th>Total Cleared</th><th>Cleared Services</th><th>Total Pending</th><th>Pending Services</th><th>Percentage Completed</th></tr></thead><tbody><tr ng-repeat="caf in vm.filteredResult.slice(((currentPage-1)*itemsPerPage), ((currentPage)*itemsPerPage))  | orderBy:\'-totalapplied\'"><td>{{($index + 1 + currentPage*itemsPerPage) - itemsPerPage}}</td><td><a target="_blank" ui-sref="projectdetailjist({projectid:caf.projectid})">{{caf.cafpin}}</a></td><td>{{caf.totalapplied}}</td><td>{{caf.appliedservicename}}</td><td>{{caf.totalcleared}}</td><td>{{caf.clearedservicename}}</td><td>{{caf.totalpending}}</td><td>{{caf.pendingservicename}}</td><td><div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" role="progressbar" aria-valuenow="{{caf.percentagecompleted}}" aria-valuemin="0" aria-valuemax="100" style="width:{{caf.percentagecompleted}}%">{{caf.percentagecompleted}}%</div></div></td></tr></tbody></table><div class="row"><div class="col-md-12 text-center"><ul class="pagination pagination-md"><li><a href="" aria-label="Previous"><span aria-hidden="true">\xAB</span></a></li><li ng-repeat="num in maxSizeArray() track by $index" ng-class="{active : currentPage === $index+1}"><a ng-click="vm.changePage($index)">{{$index+1}}</a></li><li><a href="" aria-label="Next"><span aria-hidden="true">\xBB</span></a></li></ul></div></div></div>');
$templateCache.put('app/centerRedirectPage/centralForm.html','<div class="hidden"><!--    <form action="https://row.sugamsanchar.gov.in/Portal/Applicant/ReturnURL" id="myform" method="POST">--><form action="https://row.gatishaktisanchar.gov.in/Portal/Applicant/ReturnURL" id="myform" method="POST"><input type="hidden" name="stateCode" id="stateCode" value="{{vm.project.stateCode}}"> <input type="hidden" name="userId" id="userId" value="{{vm.project.userId}}"> <input type="hidden" name="requestId" id="requestId" value="{{vm.project.requestId}}"> <input type="hidden" name="applicationType" id="applicationType" value="{{vm.project.applicationType}}"> <input type="hidden" name="applicationName" id="applicationName" value="{{vm.project.applicationName}}"> <input type="hidden" name="email" id="email" value="{{vm.project.email}}"> <input type="hidden" name="username" id="username" value="{{vm.project.username}}"> <input type="hidden" name="mobileNumber" id="mobileNumber" value="{{vm.project.mobileNumber}}"> <input type="hidden" name="districtCOde" id="districtCOde" value="{{vm.project.districtCOde}}"> <input type="hidden" name="applicantAddress" id="applicantAddress" value="{{vm.project.applicantAddress}}"> <input type="hidden" name="organisationType" id="organisationType" value="{{vm.project.organisationType}}"> <input type="hidden" name="licenseNumber" id="licenseNumber" value="{{vm.project.licenseNumber}}"> <input type="hidden" name="licenseExpiryDate" id="licenseExpiryDate" value="{{vm.project.licenseExpiryDate}}"> <input type="hidden" name="licenseCertificationPath" id="licenseCertificationPath" value="{{vm.project.licenseCertificationPath}}"> <input type="hidden" name="authorizationLetterPath" id="authorizationLetterPath" value="{{vm.project.authorizationLetterPath}}"> <input type="hidden" name="isView" id="isView" value="{{vm.project.isView}}"> <input type="hidden" name="applicationNumber" id="applicationNumber" value="{{vm.project.applicationNumber}}"> <input type="hidden" name="zipCode" id="zipCode" value="{{vm.project.zipCode}}"> <input type="submit" id="fillform" value="Fill Service Form"></form></div>');
$templateCache.put('app/centerRedirectPage/searchCAF.html','<!--<div ng-cloak>--><!--    <div class="container">--><!--        <div class="row">--><!--            <div class="col-sm-4">--><!--                <input type="text"  ng-model="vm.CAFPIN" class="form-control" ng-model="searchText" id="searchQuery"--><!--                       placeholder="Enter CAF PIN or Project ID" >--><!--            </div>--><!--            <div class="btn-group col-sm-4">--><!--                <button type="submit" ng-click="vm.getProject()" class="btn btn-info " has-any-authority="ROLE_USER, ROLE_ADMIN, ROLE_MONITORING_OFFICER,ROLE_DESK_OFFICER,ROLE_DEPT_CHANGE,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD, ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_NODAL_OFFICER,ROLE_TICKET_ADMIN">Search</button>--><!--            </div>--><!--        </div>--><!--        <div class="row" ng-show="vm.showtable">--><!--            <table class="table table-striped table-hover ">--><!--                <thead>--><!--                <tr class="headerGrid">--><!--                    <th>CAF Pin</th>--><!--                    &lt;!&ndash;<th>Investor Name</th>&ndash;&gt;--><!--                    <th>RM Info</th>--><!--                    <th>Total Project Cost</th>--><!--                    <th>Proposed Employment</th>--><!--                    <th>Business Entity</th>--><!--                    <th>District</th>--><!--                    <th>Project Level</th>--><!--                    <th>Project ID</th>--><!--                    <th>Caf Type</th>--><!--                    <th></th>--><!--                </tr>--><!--                </thead>--><!--                <tbody>--><!--                <tr>--><!--                    <td >{{vm.project.cafpin}}</td>--><!--                    &lt;!&ndash;<td >{{prdtl.investorName}}</td>&ndash;&gt;--><!--                    <td >{{vm.project.rm==\'\' ? "Not Assigned" : vm.project.rm}}</td>--><!--                    <td >{{vm.project.projectTotalCost}}</td>--><!--                    <td >{{vm.project.totalEmployement}}</td>--><!--                    <td >{{vm.project.buisnessEntity}}</td>--><!--                    <td >{{vm.project.district}}</td>--><!--                    <td >{{vm.project.projectlevel==\'e\' ? "EEC" : "DLCC"}}</td>--><!--                    <td>{{vm.project.projectid}}</td>--><!--                    <td>{{vm.project.caftype}}</td>--><!--                    <td class="action verticalalign">--><!--                        <a ui-sref="projectdetailjist({projectid:vm.project.projectid})" class="btn btn-primary">Details</a>--><!--                        &lt;!&ndash;<button type="submit" ui-sref="projectdetailjist({projectid:vm.project.projectid})"&ndash;&gt;--><!--                                &lt;!&ndash;class="btn btn-info ">Details</button>&ndash;&gt;--><!--                    </td>--><!--                </tr>--><!--                </tbody>--><!--            </table>--><!--        </div>--><!--        &lt;!&ndash;<div ng-show="!vm.showtable">&ndash;&gt;--><!--            &lt;!&ndash;No Projects Right Now.&ndash;&gt;--><!--        &lt;!&ndash;</div>&ndash;&gt;--><!--    </div>--><!--</div>--><!--<br/>--><!--<br/>--><!--<br/>-->');
$templateCache.put('app/checklistAvailability/checklistAvailability.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Know Your Checklist Availability</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Know Your Checklist Availability</span></li></ol></div></section><br><div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Know Your Checklist Availability</h3></div><div class="panel-body"><form name="checklistForm" class="form-horizontal" ng-submit="vm.submitForm()" novalidate><div class="form-group" ng-class="{\'has-error\': checklistForm.department.$invalid && checklistForm.department.$touched}"><label class="col-sm-1 control-label pull-left">1.</label><label class="col-lg-3 control-label pull-left">Department Name <span class="text-danger">*</span></label><div class="col-lg-6"><select class="form-control" ng-change="vm.getServices(vm.checklistAvailability.departmentId)" ng-model="vm.checklistAvailability.departmentId"><option value="">Select Department</option><option value="a65ccd5c-cb40-4d2c-8400-923f52377284">LABOUR DEPARTMENT - LABOUR WING</option><option value="c4c7a500-03d8-454a-b27d-1be87f6349aa">MUNICIPAL CORPORATION</option><option value="27e5ed82-8f29-466f-98fd-68efe6823a50">PWD (B & R) DEPARTMENT</option><option value="829faa03-1039-437e-adac-185e5b47ee6f">DAKSHIN HARYANA BIJLI VITRAN NIGAM</option><option value="2c360927-0c00-4f34-9310-3e69535f999a">HARYANA URBAN DEVELOPMENT AUTHORITY</option><option value="006ea6d0-98f2-4dfe-bdc9-dc7bdfad9df9">TOWN & COUNTRY PLANNING</option><option value="6f061dbe-22c4-4952-91a9-df7b091b9113">ZILA PARISHAD</option><option value="98d01743-a1c6-4fc8-a094-b243efa2f10d">FOOD & SUPPLIES DEPARTMENT</option><option value="4ca05fe6-206a-483d-8bec-4c2d80b0f510">MUNICIPAL COMMITTEE</option><option value="4ba94361-021a-4a62-84ab-2da2492bf932">MUNICIPAL COUNCIL</option><option value="bb845590-d47a-407a-992c-f7065e69e592">HARYANA STATE POLLUTION CONTROL BOARD</option><option value="3b156a83-e39a-4c2c-8a5f-6820258ab9a2">UTTAR HARYANA BIJLI VITRAN NIGAM</option><option value="4a6b3155-80e1-41b0-93df-cddd090b07a7">Electronics and Information Technology</option><option value="96f63c52-f719-4d90-9a4f-3000da5ae0b9">Airport Authority of India</option><option value="fef4feb0-44da-4209-8e33-b32cc9a40850">URBAN LOCAL BODIES</option><option value="a8d5154a-e19b-4bd5-aa38-06986fb045de">HARYANA STATE MARKETING BOARD</option><option value="05013274-891d-4955-bfca-0159e7da53fc">DEPARTMENT OF AYUSH</option><option value="e88df516-4e1d-432a-ab9d-a091b67e1648">National Monument Authority</option><option value="cc705753-bed5-40d7-90a9-857bb0ecca6d">HOME DEPARTMENT</option><option value="5cb21fc4-e3d6-43d7-b69b-e494673bdcfb">ENVIRONMENT</option><option value="638eeaa4-b069-4417-a198-ad5373cc4d18">CHIEF ELECTRICAL INSPECTOR</option><option value="2936b5f9-2e85-449d-9c0f-f1fc4b1212f6">DEPARTMENT OF INDUSTRIES & COMMERCE</option><option value="ee66184a-a1dc-4c92-92d7-7fb53d052292">PUBLIC HEALTH ENGINEERING DEPARTMENT</option><option value="73628252-5b0d-4236-b943-98885fce7bc3">EXCISE & TAXATION - EXCISE</option><option value="b55a377b-33bc-42c8-8361-021438cd4d1e">MINES & GEOLOGY DEPARTMENT</option><option value="3bb27193-61c4-4433-b2a6-d5b4ab1e3b2c">DEPARTMENT OF FORESTS & WILDLIFE</option><option value="e832a828-192e-4029-bce4-8cfe9fb2da58">Development and Panchayats</option><option value="ce8611d6-8e84-416c-b9ba-7818463005ff">Food and Drug Administration</option><option value="550e2870-9403-4050-bf5c-0c790c41ed19">HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD</option><option value="c262bb82-b002-42c1-b791-023f91c7e17a">DEPARTMENT OF RENEWABLE ENERGY</option><option value="24cf7139-3a30-4862-842d-b9b33f2cfb6c">PANCHAYAT</option><option value="97909540-e982-46fd-88ee-64ed89dc74d4">LABOUR DEPARTMENT - FACTORY WING</option><option value="aad03c60-ac6c-4266-8b35-42a5abaeaae5">IRRIGATION</option><option value="0364ac85-c3ed-4b49-ab6d-a0526b7cd20b">REVENUE</option><option value="29ed0e3a-4d4c-4a0a-a3fb-09ccef8b9368">DEPARTMENT OF AGRICULTURE</option></select><span class="help-block" ng-show="checklistForm.department.$invalid && checklistForm.department.$touched">Department Name is required.</span></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">2.</label><label class="col-lg-3 control-label pull-left">Service Name<span class="text-danger">*</span></label><div class="col-lg-6"><select class="form-control" id="service" ng-model="vm.checklistAvailability.service" ng-options="service.serviceName as service.serviceName for service in vm.services | filter:{active:true} | orderBy: \'serviceName\'" required><option value="" disabled="disabled">Select Service</option></select><span class="help-block" ng-show="checklistForm.service.$invalid && checklistForm.service.$touched">Service is required.</span></div></div><div class="form-group" ng-class="{\'has-error\': checklistForm.riskCategory.$invalid && checklistForm.riskCategory.$touched}"><label class="col-sm-1 control-label pull-left">3.</label><label class="col-lg-3 control-label pull-left">Risk category <span class="text-danger">*</span></label><div class="col-lg-6"><select name="riskCategory" class="form-control" ng-model="vm.checklistAvailability.riskCategory" required><option value="" disabled="disabled" selected="selected">Select Risk category</option><option value="Low">Low</option><option value="Medium">Medium</option><option value="High">High</option><option value="NA">NA</option></select><span class="help-block" ng-show="checklistForm.riskCategory.$invalid && checklistForm.riskCategory.$touched">Risk category is required.</span></div></div><div class="form-group" ng-class="{\'has-error\': checklistForm.sizeOfFirm.$invalid && checklistForm.sizeOfFirm.$touched}"><label class="col-sm-1 control-label pull-left">4.</label><label class="col-lg-3 control-label pull-left">Size of firm <span class="text-danger">*</span></label><div class="col-lg-6"><select name="sizeOfFirm" class="form-control" ng-model="vm.checklistAvailability.sizeOfFirm" required><option value="" disabled="disabled" selected="selected">Select Size Of Firm</option><option value="Small - more than 25 lakhs and less than or upto 5 crores">Small - more than 25 lakhs and less than or upto 5 crores</option><option value="Micro - upto 25 lakhs">Micro - upto 25 lakhs</option><option value="Medium - more than 5 crores and less than or upto 10 crores">Medium - more than 5 crores and less than or upto 10 crores</option><option value="Large - more than 10 crores and less than or upto 100 crores">Large - more than 10 crores and less than or upto 100 crores</option><option value="Mega - more than 100 crores">Mega - more than 100 crores</option></select><span class="help-block" ng-show="checklistForm.sizeOfFirm.$invalid && checklistForm.sizeOfFirm.$touched">Size of firm is required.</span></div></div><!-- District --><div class="form-group"><label class="col-sm-1 control-label pull-left">5.</label><label class="col-lg-3 control-label pull-left">District <span class="text-danger">*</span></label><div class="col-lg-6"><select class="form-control" id="district" ng-model="vm.checklistAvailability.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" required ng-change="vm.getVillages(vm.checklistAvailability.district)"><option value="" disabled="disabled">Select District</option></select><span class="help-block" ng-show="checklistForm.distrcit.$invalid && checklistForm.distrcit.$touched">District is required.</span></div></div><!-- Village --><div class="form-group"><label class="col-sm-1 control-label pull-left">6.</label><label class="col-lg-3 control-label pull-left">Village <span class="text-danger">*</span></label><div class="col-lg-6"><input type="text" class="form-control" id="village" placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.proj.district === null" ng-model="vm.checklistAvailability.village" ng-change="vm.setBlockCategory(vm.checklistAvailability.village,vm.villages)"><datalist id="villages"><option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option></datalist></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">7.</label><label class="col-lg-3 control-label pull-left">Business location/Block Code<span class="text-danger">*</span></label><div class="col-lg-6"><select class="form-control" id="blockCategory" ng-model="vm.checklistAvailability.blockCategory" required><option value="">Select Block</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option></select></div></div><div class="form-group" ng-class="{\'has-error\': checklistForm.investorType.$invalid && checklistForm.investorType.$touched}"><label class="col-sm-1 control-label pull-left">8.</label><label class="col-lg-3 control-label pull-left">Investor Type <span class="text-danger">*</span></label><div class="col-lg-6"><select name="investorType" class="form-control" ng-model="vm.checklistAvailability.investorType" required><option value="" disabled="disabled" selected="selected">Select Investor Type</option><option value="Foreign">Foreign</option><option value="Domestic">Domestic</option></select><span class="help-block" ng-show="checklistForm.investorType.$invalid && checklistForm.investorType.$touched">Investor Type is required.</span></div></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><button type="submit" class="btn btn-warning pull-right" ng-disabled="checklistForm.$invalid">Search</button></div></div></form></div></div></div>');
$templateCache.put('app/checklistAvailability/searchResults.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">View Checklist</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Search Results</span></li></ol></div></section><br><div class="container"><div class="panel panel-success"><div class="panel-body"><p ng-if="vm.fileUrl">Click to see checklist availability: <a ng-href="api/files/{{ vm.fileUrl }}.pdf" target="_blank">Download/View Document</a></p><p ng-if="!vm.fileUrl">No document found.</p></div><a ui-sref="home" class="btn btn-primary">Go to Home</a></div></div>');
$templateCache.put('app/checklistAvailabilityNew/checklistAvailabilityNew.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Know Your Checklist Availability</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Know Your Checklist Availability</span></li></ol></div></section><br><div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Know Your Checklist Availability</h3></div><div class="panel-body"><form name="checklistForm" class="form-horizontal" ng-submit="vm.submitForm()" novalidate><div class="form-group" ng-class="{\'has-error\': checklistForm.department.$invalid && checklistForm.department.$touched}"><label class="col-sm-1 control-label pull-left">1.</label><label class="col-lg-3 control-label pull-left">Department Name</label><div class="col-lg-6"><select class="form-control" ng-change="vm.applyFilters()" ng-model="vm.checklistAvailability.departmentId"><option value="">All</option><option value="a65ccd5c-cb40-4d2c-8400-923f52377284">LABOUR DEPARTMENT - LABOUR WING</option><option value="c4c7a500-03d8-454a-b27d-1be87f6349aa">MUNICIPAL CORPORATION</option><option value="27e5ed82-8f29-466f-98fd-68efe6823a50">PWD (B & R) DEPARTMENT</option><option value="829faa03-1039-437e-adac-185e5b47ee6f">DAKSHIN HARYANA BIJLI VITRAN NIGAM</option><option value="2c360927-0c00-4f34-9310-3e69535f999a">HARYANA URBAN DEVELOPMENT AUTHORITY</option><option value="006ea6d0-98f2-4dfe-bdc9-dc7bdfad9df9">TOWN & COUNTRY PLANNING</option><option value="6f061dbe-22c4-4952-91a9-df7b091b9113">ZILA PARISHAD</option><option value="98d01743-a1c6-4fc8-a094-b243efa2f10d">FOOD & SUPPLIES DEPARTMENT</option><option value="4ca05fe6-206a-483d-8bec-4c2d80b0f510">MUNICIPAL COMMITTEE</option><option value="4ba94361-021a-4a62-84ab-2da2492bf932">MUNICIPAL COUNCIL</option><option value="bb845590-d47a-407a-992c-f7065e69e592">HARYANA STATE POLLUTION CONTROL BOARD</option><option value="3b156a83-e39a-4c2c-8a5f-6820258ab9a2">UTTAR HARYANA BIJLI VITRAN NIGAM</option><option value="4a6b3155-80e1-41b0-93df-cddd090b07a7">Electronics and Information Technology</option><option value="96f63c52-f719-4d90-9a4f-3000da5ae0b9">Airport Authority of India</option><option value="fef4feb0-44da-4209-8e33-b32cc9a40850">URBAN LOCAL BODIES</option><option value="a8d5154a-e19b-4bd5-aa38-06986fb045de">HARYANA STATE MARKETING BOARD</option><option value="05013274-891d-4955-bfca-0159e7da53fc">DEPARTMENT OF AYUSH</option><option value="e88df516-4e1d-432a-ab9d-a091b67e1648">National Monument Authority</option><option value="cc705753-bed5-40d7-90a9-857bb0ecca6d">HOME DEPARTMENT</option><option value="5cb21fc4-e3d6-43d7-b69b-e494673bdcfb">ENVIRONMENT</option><option value="638eeaa4-b069-4417-a198-ad5373cc4d18">CHIEF ELECTRICAL INSPECTOR</option><option value="2936b5f9-2e85-449d-9c0f-f1fc4b1212f6">DEPARTMENT OF INDUSTRIES & COMMERCE</option><option value="ee66184a-a1dc-4c92-92d7-7fb53d052292">PUBLIC HEALTH ENGINEERING DEPARTMENT</option><option value="73628252-5b0d-4236-b943-98885fce7bc3">EXCISE & TAXATION - EXCISE</option><option value="b55a377b-33bc-42c8-8361-021438cd4d1e">MINES & GEOLOGY DEPARTMENT</option><option value="3bb27193-61c4-4433-b2a6-d5b4ab1e3b2c">DEPARTMENT OF FORESTS & WILDLIFE</option><option value="e832a828-192e-4029-bce4-8cfe9fb2da58">Development and Panchayats</option><option value="ce8611d6-8e84-416c-b9ba-7818463005ff">Food and Drug Administration</option><option value="550e2870-9403-4050-bf5c-0c790c41ed19">HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD</option><option value="c262bb82-b002-42c1-b791-023f91c7e17a">DEPARTMENT OF RENEWABLE ENERGY</option><option value="24cf7139-3a30-4862-842d-b9b33f2cfb6c">PANCHAYAT</option><option value="97909540-e982-46fd-88ee-64ed89dc74d4">LABOUR DEPARTMENT - FACTORY WING</option><option value="aad03c60-ac6c-4266-8b35-42a5abaeaae5">IRRIGATION</option><option value="0364ac85-c3ed-4b49-ab6d-a0526b7cd20b">REVENUE</option><option value="29ed0e3a-4d4c-4a0a-a3fb-09ccef8b9368">DEPARTMENT OF AGRICULTURE</option></select><!--                        <span class="help-block" ng-show="checklistForm.department.$invalid && checklistForm.department.$touched">Department Name is required.</span>--></div></div><!--                <div class="form-group">--><!--                    <label class="col-sm-1 control-label pull-left">2.</label>--><!--                    <label class="col-lg-3 control-label pull-left">Service Name<span class="text-danger">*</span></label>--><!--                    <div class="col-lg-6">--><!--                        <select class="form-control" id="service"--><!--                                ng-model="vm.checklistAvailability.service"--><!--                                ng-options="service.serviceName as service.serviceName for service in vm.services | filter:{active:true} | orderBy: \'serviceName\'"--><!--                                required >--><!--                            <option value="" disabled>Select Service</option>--><!--                        </select>--><!--                        <span class="help-block" ng-show="checklistForm.service.$invalid && checklistForm.service.$touched">Service is required.</span>--><!--                    </div>--><!--                </div>--><div class="form-group" ng-class="{\'has-error\': checklistForm.riskCategory.$invalid && checklistForm.riskCategory.$touched}"><label class="col-sm-1 control-label pull-left">2.</label><label class="col-lg-3 control-label pull-left">Risk category</label><div class="col-lg-6"><select ng-disabled="vm.checklistAvailability.departmentId !== \'bb845590-d47a-407a-992c-f7065e69e592\' && vm.checklistAvailability.departmentId !== \'a65ccd5c-cb40-4d2c-8400-923f52377284\'" name="riskCategory" ng-change="vm.applyFilters()" class="form-control" ng-model="vm.checklistAvailability.riskCategory" required><option value="" selected="selected">All</option><!--                            <option value="All">All</option>--><option ng-if="vm.checklistAvailability.departmentId === \'a65ccd5c-cb40-4d2c-8400-923f52377284\'" value="High">High</option><option ng-if="vm.checklistAvailability.departmentId === \'a65ccd5c-cb40-4d2c-8400-923f52377284\'" value="Medium">Medium</option><option ng-if="vm.checklistAvailability.departmentId === \'a65ccd5c-cb40-4d2c-8400-923f52377284\'" value="Low">Low</option><option ng-if="vm.checklistAvailability.departmentId === \'bb845590-d47a-407a-992c-f7065e69e592\'" value="Red">Red</option><option ng-if="vm.checklistAvailability.departmentId === \'bb845590-d47a-407a-992c-f7065e69e592\'" value="Orange">Orange</option><option ng-if="vm.checklistAvailability.departmentId === \'bb845590-d47a-407a-992c-f7065e69e592\'" value="Green">Green</option><option ng-if="vm.checklistAvailability.departmentId === \'bb845590-d47a-407a-992c-f7065e69e592\'" value="White">White</option></select><!--                        <span class="help-block" ng-show="checklistForm.riskCategory.$invalid && checklistForm.riskCategory.$touched">Risk category is required.</span>--></div></div><div class="form-group" ng-class="{\'has-error\': checklistForm.sizeOfFirm.$invalid && checklistForm.sizeOfFirm.$touched}"><label class="col-sm-1 control-label pull-left">3.</label><label class="col-lg-3 control-label pull-left">Size of firm</label><div class="col-lg-6"><select name="sizeOfFirm" ng-change="vm.applyFilters()" class="form-control" ng-model="vm.checklistAvailability.sizeOfFirm" required><option value="" selected="selected">All</option><option value="Small">Small - more than 25 lakhs and less than or upto 5 crores</option><option value="Micro">Micro - upto 25 lakhs</option><option value="Medium">Medium - more than 5 crores and less than or upto 10 crores</option><option value="Large">Large - more than 10 crores and less than or upto 100 crores</option><option value="Mega">Mega - more than 100 crores</option></select><!--                            <span class="help-block" ng-show="checklistForm.sizeOfFirm.$invalid && checklistForm.sizeOfFirm.$touched">Size of firm is required.</span>--></div></div><!-- District --><!--                <div class="form-group">--><!--                    <label class="col-sm-1 control-label pull-left">5.</label>--><!--                    <label class="col-lg-3 control-label pull-left">District <span class="text-danger">*</span></label>--><!--                    <div class="col-lg-6">--><!--                        <select class="form-control" id="district"--><!--                                ng-model="vm.checklistAvailability.district"--><!--                                ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'"--><!--                                required ng-change="vm.getVillages(vm.checklistAvailability.district)">--><!--                            <option value="" disabled>Select District</option>--><!--                        </select>--><!--                        <span class="help-block" ng-show="checklistForm.distrcit.$invalid && checklistForm.distrcit.$touched">District is required.</span>--><!--                    </div>--><!--                </div>--><!-- Village --><!--                <div class="form-group">--><!--                    <label class="col-sm-1 control-label pull-left">6.</label>--><!--                    <label class="col-lg-3 control-label pull-left">Village <span class="text-danger">*</span></label>--><!--                    <div class="col-lg-6">--><!--                        <input type="text" class="form-control" id="village"--><!--                               placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.proj.district === null"--><!--                               ng-model="vm.checklistAvailability.village" ng-change="vm.setBlockCategory(vm.checklistAvailability.village,vm.villages)"/>--><!--                        <datalist id="villages">--><!--                            <option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option>--><!--                        </datalist>--><!--                    </div>--><!--                </div>--><div class="form-group"><label class="col-sm-1 control-label pull-left">4.</label><label class="col-lg-3 control-label pull-left">Business location/Block Code</label><div class="col-lg-6"><select ng-change="vm.applyFilters()" class="form-control" id="blockCategory" ng-model="vm.checklistAvailability.blockCategory" required><option value="">All</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option></select></div></div><div class="form-group" ng-class="{\'has-error\': checklistForm.investorType.$invalid && checklistForm.investorType.$touched}"><label class="col-sm-1 control-label pull-left">5.</label><label class="col-lg-3 control-label pull-left">Investor Type</label><div class="col-lg-6"><select name="investorType" ng-change="vm.applyFilters()" class="form-control" ng-model="vm.checklistAvailability.investorType" required><option value="" disabled="disabled" selected="selected">All</option><option value="Foreign">Foreign</option><option value="Domestic">Domestic</option></select><!--                        <span class="help-block" ng-show="checklistForm.investorType.$invalid && checklistForm.investorType.$touched">Investor Type is required.</span>--></div></div><!--                <div class="row footer">--><!--                    <div class="col-lg-12">--><!--                        <hr class="footer-line">--><!--&lt;!&ndash;                        <button type="submit" class="btn btn-warning pull-right" ng-disabled="checklistForm.$invalid">Search</button>&ndash;&gt;--><!--                    </div>--><!--                </div>--></form></div></div><table class="table table-bordered"><thead><tr><!--            <th>Department Name</th>--><th>Service Details (Name of Service)</th><th>Fee Structure</th><th>Document Checklist</th><th>Standard Operating Procedure</th><th>Stage wise Timeline</th><!--            <th>Inspection Checklist</th>--><th>Risk Category</th><th>Size of Firm(Unit Category)</th><th>Business Location</th><th>Investor Type</th></tr></thead><tbody><tr ng-if="vm.groupedChecklists.length > 0 " ng-repeat="item in vm.groupedChecklists"><!--            <td>{{ vm.departmentNames[item.departmentId] || \'N.A\' }}</td>--><td>{{ vm.serviceNames[item.serviceId] || \'N.A\' }}</td><td><span ng-if="!item.feeStructureDoc">N.A</span> <a ng-if="item.feeStructureDoc" href="/api/files/{{item.feeStructureDoc + \'.pdf\'}}" target="_blank">Yes</a></td><td><span ng-if="!item.documentUrl">N.A</span> <a ng-if="item.documentUrl" href="/api/files/{{item.documentUrl + \'.pdf\'}}" target="_blank">Download</a></td><td><div ng-repeat="(risk, url) in item.riskDocs track by risk"><!--                    <span>{{risk}}:</span>--> <a ng-if="url" href="/api/files/{{url + \'.pdf\'}}" target="_blank">{{risk}}</a> <span ng-if="!url">N.A</span></div></td><!--            <td>--><!--                <span ng-if="!item.sopDoc">N.A</span>--><!--                <a ng-if="item.sopDoc" href="/api/files/{{item.sopDoc + \'.pdf\'}}" target="_blank">Yes</a>--><!--            </td>--><td><span ng-if="!item.timelineDoc">N.A</span> <a ng-if="item.timelineDoc" href="/api/files/{{item.timelineDoc + \'.pdf\'}}" target="_blank">Yes</a></td><!--            <td>--><!--                <span ng-if="!item.inspectionDoc">N.A</span>--><!--                <a ng-if="item.inspectionDoc" href="/api/files/{{item.inspectionDoc + \'.pdf\'}}" target="_blank">Yes</a>--><!--            </td>--><!--            <td>--><!--                <span ng-if="!item.riskCategoryDoc">N.A</span>--><!--                <a ng-if="item.riskCategoryDoc" href="/api/files/{{item.riskCategoryDoc + \'.pdf\'}}" target="_blank">Yes</a>--><!--            </td>--><td><span ng-if="!vm.checklistAvailability.riskCategory">All</span> <span ng-if="vm.checklistAvailability.riskCategory">{{item.riskCategory}}</span></td><td><span ng-if="!vm.checklistAvailability.sizeOfFirm">All</span> <span ng-if="vm.checklistAvailability.sizeOfFirm">{{item.sizeOfFirm}}</span></td><td><span ng-if="!vm.checklistAvailability.blockCategory">All</span> <span ng-if="vm.checklistAvailability.blockCategory">{{item.businessLocation}}</span></td><td><span ng-if="!vm.checklistAvailability.investerType">All</span> <span ng-if="vm.checklistAvailability.investerType">{{item.investorType}}</span></td><!--                            <td><a ng-href="{{item.documentUrl}}" target="_blank">View Document</a></td>--></tr><tr ng-if="vm.groupedChecklists.length <= 0 " ng-repeat="itemNew in vm.services"><!--            <td>{{ itemNew.departmentname }}</td>--><td>{{ itemNew.serviceName }}</td><td><span ng-if="!item.documentUrl">N.A</span> <a ng-if="item.documentUrl" href="/api/files/{{item.documentUrl + \'.pdf\'}}" target="_blank">Download</a></td><td><span ng-if="!item.feeStructureDoc">N.A</span> <a ng-if="item.feeStructureDoc" href="/api/files/{{item.feeStructureDoc + \'.pdf\'}}" target="_blank">Yes</a></td><td><div ng-repeat="(risk, url) in item.riskDocs track by risk"><!--                    <span>{{risk}}:</span>--> <a ng-if="url" href="/api/files/{{url + \'.pdf\'}}" target="_blank">{{risk}}</a> <span ng-if="!url">N.A</span></div></td><!--            <td>--><!--                <span ng-if="!item.sopDoc">N.A</span>--><!--                <a ng-if="item.sopDoc" href="/api/files/{{item.sopDoc + \'.pdf\'}}" target="_blank">Yes</a>--><!--            </td>--><td><span ng-if="!item.timelineDoc">N.A</span> <a ng-if="item.timelineDoc" href="/api/files/{{item.timelineDoc + \'.pdf\'}}" target="_blank">Yes</a></td><!--            <td>--><!--                <span ng-if="!item.inspectionDoc">N.A</span>--><!--                <a ng-if="item.inspectionDoc" href="/api/files/{{item.inspectionDoc + \'.pdf\'}}" target="_blank">Yes</a>--><!--            </td>--><!--            <td>--><!--                <span ng-if="!item.riskCategoryDoc">N.A</span>--><!--                <a ng-if="item.riskCategoryDoc" href="/api/files/{{item.riskCategoryDoc + \'.pdf\'}}" target="_blank">Yes</a>--><!--            </td>--><td><span ng-if="!vm.checklistAvailability.riskCategory">All</span> <span ng-if="vm.checklistAvailability.riskCategory">{{item.riskCategory}}</span></td><td><span ng-if="!vm.checklistAvailability.sizeOfFirm">All</span> <span ng-if="vm.checklistAvailability.sizeOfFirm">{{item.sizeOfFirm}}</span></td><td><span ng-if="!vm.checklistAvailability.blockCategory">All</span> <span ng-if="vm.checklistAvailability.blockCategory">{{item.businessLocation}}</span></td><td><span ng-if="!vm.checklistAvailability.investerType">All</span> <span ng-if="vm.checklistAvailability.investerType">{{item.investorType}}</span></td><!--                            <td><a ng-href="{{item.documentUrl}}" target="_blank">View Document</a></td>--></tr></tbody></table></div>');
$templateCache.put('app/checklistAvailabilityNew/searchResults.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">View Checklist</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Search Results</span></li></ol></div></section><br><div class="container"><div class="panel panel-success"><div class="panel-body"><p ng-if="vm.fileUrl">Click to see checklist availability: <a ng-href="{{ vm.fileUrl }}" target="_blank">Download/View Document</a></p><p ng-if="!vm.fileUrl">No document found.</p></div><a ui-sref="home" class="btn btn-primary">Go to Home</a></div></div>');
$templateCache.put('app/completeprojectdetail/completeprojectdetail.html','<div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">1. Application</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-1">1.1</td><td class="col-md-4 bold">Application For</td><td class="col-md-5">Regulatory Approvals &amp; Services</td><td rowspan="3"><img style="float:right" src="./DetailCAF1 - Single Roof Clearance Systems, HEPB_files/e8cf30a8-337c-470a-a15e-92ee15c3ae1d.png" width="100px;"></td></tr><tr><td class="col-md-1">1.2</td><td class="col-md-4 bold">Have you signed MoU with the Haryana Government? If Yes, specify year</td><td class="col-md-3"><span>No</span></td></tr><tr><td class="col-md-1">2</td><td class="col-md-4 bold">Applicant Name</td><td class="col-md-3">Satish Kumar Sharma</td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">3. Correspondance Address</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-1">3.1</td><td class="col-md-4 bold">Country</td><td class="col-md-3">India</td><td></td></tr><tr><td class="col-md-1">3.2</td><td class="col-md-4 bold">State</td><td class="col-md-3"><span>NA</span></td><td></td></tr><tr><td class="col-md-1">3.3</td><td class="col-md-4 bold">City</td><td class="col-md-3">Kolkata</td><td></td></tr><tr><td class="col-md-1">3.4</td><td class="col-md-4 bold">Pin Code / Zip Code</td><td class="col-md-3">700012</td><td></td></tr><tr><td class="col-md-1">3.5</td><td class="col-md-4 bold">Address Line 1</td><td class="col-md-3">P4 Black Burn Lane</td><td></td></tr><tr><td class="col-md-1">3.6</td><td class="col-md-4 bold">Address Line 2</td><td class="col-md-3">3rd Floor</td><td></td></tr><tr><td class="col-md-1">3.7</td><td class="col-md-4 bold">Address Line 3</td><td class="col-md-3"><span>NA</span></td><td></td></tr><tr><td class="col-md-1">3.8</td><td class="col-md-4 bold">Phone Number</td><td class="col-md-3"><span>NA</span></td><td></td></tr><tr><td class="col-md-1">3.9</td><td class="col-md-4 bold">Mobile Number</td><td class="col-md-3">9820126050</td><td></td></tr><tr><td class="col-md-1">3.10</td><td class="col-md-4 bold">Fax Number</td><td class="col-md-3"><span>NA</span></td><td></td></tr><tr><td class="col-md-1">3.11.1</td><td class="col-md-4 bold">Email Address</td><td class="col-md-3"><a href="mailto:naresh@cci-logistics.com">naresh@cci-logistics.com</a></td><td></td></tr><tr><td class="col-md-1">3.11.2</td><td class="col-md-4 bold">Alternate Email Address</td><td class="col-md-3"><a href="mailto:satish@cci-logistics.com">satish@cci-logistics.com</a></td><td></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">4. Firm Details</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-1">4.1.1</td><td class="col-md-4 bold">Name of Promoter / MD</td><td class="col-md-3">Satish Kumar Sharma</td><td></td></tr><tr><td class="col-md-1">4.1.2</td><td class="col-md-4 bold">Designation</td><td class="col-md-3">Director</td><td></td></tr><tr><td class="col-md-1">4.2</td><td class="col-md-4 bold">Name of Business Entity</td><td class="col-md-3">JKS INFRASTRUCTURE PVT LTD</td><td></td></tr><tr><td class="col-md-1">4.3</td><td class="col-md-4 bold">Type of Business Entity</td><td class="col-md-3">Private Limited</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">4.4</td><td class="col-md-4 bold">Number of Directors</td><td class="col-md-3">2</td><td class="col-md-4"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/e5c490ae-8f3a-4d2e-b91a-8564da375bd3.pdf">View Directory List Attachment</a></td></tr><tr><td class="col-md-1">4.5.1</td><td class="col-md-4 bold">PAN Number</td><td class="col-md-3">AABCG3408M</td><td class="col-md-4"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/eabc07e7-95be-49b2-8ebc-ee377e3d7a8a.pdf">View PAN Number Attachment</a></td></tr><tr><td class="col-md-1">4.5.2</td><td class="col-md-4 bold">AADHAR Number</td><td class="col-md-3"><span>NA</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">4.5.3</td><td class="col-md-4 bold">Is NRI</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">4.6</td><td class="col-md-4 bold">TIN / VAT Number</td><td class="col-md-3"><span>NA</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">4.7</td><td class="col-md-4 bold">CST Number</td><td class="col-md-3"><span>NA</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">4.8</td><td class="col-md-4 bold">MoA / Partnership Deed</td><td class="col-md-3"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/4887b556-5f04-4346-8b3a-42705610606f.pdf">View MoA Partnership Deed Attachment</a></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">4.9</td><td class="col-md-4 bold">Certificate of Incorporation / Registration</td><td class="col-md-3"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/50f31468-9a43-4dfa-838b-418f117c434a.pdf">View Certificate of Incorporation / Registration Attachment</a></td><td class="col-md-4"></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">5. Proposed Site Detail</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-1">5.1</td><td class="col-md-4 bold">Site Address</td><td class="col-md-3">Village Pathreri, Patuadi-Bilaspur Tauru Road</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.2a</td><td class="col-md-4 bold">District</td><td class="col-md-3">Gurgaon</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.2b</td><td class="col-md-4 bold">Block</td><td class="col-md-3">GURGAON</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.2c</td><td class="col-md-4 bold">Village / Town / City</td><td class="col-md-3">Gurgaon</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.2d</td><td class="col-md-4 bold">Tehsil</td><td class="col-md-3">Manesar</td><td class="col-md-4"></td></tr><tr><td class="col-md-1"></td><td class="col-md-4 bold">Multiple Villages Involved?</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.2e</td><td class="col-md-4 bold">If site falls in Gurgaon or Mewat district, whether land falls under Aravalli Notification Act</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.3</td><td class="col-md-4 bold">Site has been alloted by HSIIDC</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1"></td><td class="col-md-4 bold">If YES, please indicate the following</td><td class="col-md-3"></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">(i)</td><td class="col-md-4 bold">Estate</td><td class="col-md-3">NA</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">(ii)</td><td class="col-md-4 bold">Cluster</td><td class="col-md-3">NA</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">(iii)</td><td class="col-md-4 bold">Phase</td><td class="col-md-3">NA</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">(iv)</td><td class="col-md-4 bold">Sector</td><td class="col-md-3">NA</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">(v)</td><td class="col-md-4 bold">Plot Number</td><td class="col-md-3">NA</td><td class="col-md-4"></td></tr><tr><td class="col-md-1"></td><td class="col-md-4 bold">If NO, please indicate the following</td><td class="col-md-3"></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.4</td><td class="col-md-4 bold">Hadbast Number</td><td class="col-md-3">143</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.5</td><td class="col-md-4 bold">Khasra Number</td><td class="col-md-3"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/b307cd3d-bc17-49c7-983c-62f23b0b37b6.PDF">View Khasra Attachment</a></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.5a</td><td class="col-md-4 bold">SiteInMCLimit</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"><div>15 Km</div></td></tr><tr><td class="col-md-1">5.5b</td><td class="col-md-4 bold">Site is located in Urban Area</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.6</td><td class="col-md-4 bold">Revenue/Shajra Plan</td><td class="col-md-3"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/e9e80528-9f91-4189-8f15-18b020b1df1e.pdf">View Revenue/Shajra Plan Attachment</a></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.7</td><td class="col-md-4 bold">Jamabandi of the site area</td><td class="col-md-3"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/e2e250d6-f2bb-43ab-a8e2-da90daa6cf06.pdf">View Jamabandi Attachment</a></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.8</td><td class="col-md-4 bold">Non Encumbrance Certificate of the site</td><td class="col-md-3"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/a5ad4c03-441c-441c-bcbc-97bb31e50674.pdf">View Non Encumbrance Attachment</a></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.9</td><td class="col-md-4 bold">Total Proposed Project Area</td><td class="col-md-3">114547.70 Acre</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.10</td><td class="col-md-4 bold">Total Built-up Area</td><td class="col-md-3">70635.00 m<sup>2</sup></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.11</td><td class="col-md-4 bold">Certified Copy of Ownership</td><td class="col-md-3"><span>Yes</span></td><td class="col-md-4"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/e71e79ba-3321-4286-999d-7857ab8ae6ca.PDF">View Ownership Attachment</a></td></tr><tr><td class="col-md-1">5.12</td><td class="col-md-4 bold">Certified Copy of Lease Document</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.13</td><td class="col-md-4 bold">Certified Copy of Land under Agreement</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.14</td><td class="col-md-4 bold">Site / Layout Plan<br><span style="font-size:12px; font-style:italic; font-weight:normal">*Map showing dimensions &amp; directions of project site with entry/exit</span></td><td class="col-md-3"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/b689a2ab-d0c2-4305-8f49-f41228df748a.pdf">View Site / Layout Plan</a></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.15</td><td class="col-md-4 bold">Location Plan<br><span style="font-size:12px; font-style:italic;font-weight:normal">*Map showing all major natural features &amp; establishment in surrounding of 500 mtr of site &amp; connecting road</span></td><td class="col-md-3"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/f2ac9201-92dc-43bb-a255-1ced85a6f43f.pdf">View Location plan</a></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.16</td><td class="col-md-4 bold">Linear Strip Plan<br><span style="font-size:12px; font-style:italic; font-weight:normal">*Map showing the width of entry/exit gate and its distance from the connecting NH/SH/SR/Other road</span></td><td class="col-md-3"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/0516e54c-6526-4db9-8aaf-28a7edfab540.pdf">View Linear Strip Plan</a></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.17</td><td class="col-md-4 bold">Connecting Road</td><td class="col-md-3">State Highway</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">(i)</td><td class="col-md-4 bold">Is Minimum distance from Intersection/Median opening and take off point of an access<br><span style="font-size:12px; font-style:italic; font-weight:normal">(a) For Urban: more than 100m</span><br><span style="font-size:12px; font-style:italic; font-weight:normal">(b) For Rural: more than 300m</span></td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">(ii)</td><td class="col-md-4 bold">Is Minimum distance from railway crossing is more than 300m (for urban and rural)</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.18.1</td><td class="col-md-4 bold">Conformity of Land Use</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.18.2</td><td class="col-md-4 bold">Land Use Zone Classification</td><td class="col-md-3"><span>NA</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.19.1</td><td class="col-md-4 bold">Site situated on National Highway/ Scheduled Road<br><span style="font-size:12px; font-style:italic; font-weight:normal">*Attach permission from Competent Authority</span></td><td class="col-md-3"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/">View Site situated on National Highway/ Scheduled Road</a></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.19.2</td><td class="col-md-4 bold">Building exists BEFORE/AFTER declaration of controlled area</td><td class="col-md-3"></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.19.3</td><td class="col-md-4 bold">Is there any building structure exists</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">5.19.4</td><td class="col-md-4 bold">Site situated in controlled area<br><span style="font-size:12px; font-style:italic; font-weight:normal">*Details of controlled area at website of Town and Country Planning Department (http://tcpharyana.gov.in/)</span></td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">6. Project Details</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-1">6.1</td><td class="col-md-4 bold">Sector</td><td class="col-md-3">Other Industries</td><td class="col-md-4">Warehouse</td></tr><tr><td class="col-md-1">6.2</td><td class="col-md-4 bold">Project Purpose</td><td class="col-md-3">Logistic Park</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">6.3</td><td class="col-md-4 bold">Size of Industry</td><td class="col-md-3">Large - more than 10 crores</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">6.4</td><td class="col-md-4 bold">Project Type</td><td class="col-md-3">New Project (New Site)</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">6.5a</td><td class="col-md-4 bold">NIC Code</td><td class="col-md-3"><span>NA</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">6.5b</td><td class="col-md-4 bold">Category of Project</td><td class="col-md-3">None of these</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">6.5c</td><td class="col-md-4 bold">Foreign Country</td><td class="col-md-3"><span>NA</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">6.6</td><td class="col-md-4 bold">Detailed Project Report (DPR)</td><td class="col-md-3"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/1e32bf42-68cf-4e57-a984-0078c6d2b112.pdf">View Detailed Project Report</a></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">6.7</td><td class="col-md-4 bold">Any Existing Regulatory Approval Granted</td><td class="col-md-3"><span>No</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">6.8</td><td class="col-md-4 bold">Detail of EDC / SIF / CLU / License-Fee Paid</td><td class="col-md-3"><span>Yes</span></td><td class="col-md-4"><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/630f05e0-cdce-45ff-a0ca-d1c2e8bb7c27.PDF">View Details of EDC/SIF/CLU/License-Fee Paid</a></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">7. Proposed Fixed Capital Investment</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-1">7.1</td><td class="col-md-4 bold">Land Cost</td><td class="col-md-3"><span>Rs. 63.20 crore</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">7.2</td><td class="col-md-4 bold">Building Cost</td><td class="col-md-3"><span>Rs. 82.50 crore</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">7.3a</td><td class="col-md-4 bold">Plant &amp; Machinery Cost</td><td class="col-md-3"><span>Rs. 15.00 crore</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">7.3b</td><td class="col-md-4 bold">Cost of Miscellaneous Assets</td><td class="col-md-3"><span>Rs. 15.00 crore</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">7.4</td><td class="col-md-4 bold">Total Project Cost<br><span style="font-size:12px; font-style:italic;font-weight:normal">*Sum of 7.1,7.2,7.3a and 7.3b</span></td><td class="col-md-3"><span>Rs. 160.70 crore</span></td><td class="col-md-4"></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">8. Means of Finance</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-1">8.1a</td><td class="col-md-4 bold">FDI</td><td class="col-md-3"><span>Rs. 0.00</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">8.1b</td><td class="col-md-4 bold">If FDI, Name of Country</td><td class="col-md-3"><span>NA</span></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">8.2</td><td class="col-md-4 bold">Foreign Funding Resources</td><td class="col-md-3"><span>Not Applicable</span></td><td class="col-md-4"></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">9. Proposed Employment</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-1">9.1</td><td class="col-md-4 bold">Total Proposed Employment</td><td class="col-md-3"><span>197</span></td><td class="col-md-4"></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">10. Proposed Project Schedule</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-1">10.1</td><td class="col-md-4 bold">Start of Project Construction</td><td class="col-md-3">15/09/2016 00:00:00</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">10.2</td><td class="col-md-4 bold">Start of Commercial Activity</td><td class="col-md-3">01/04/2018 00:00:00</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">10.3</td><td class="col-md-4 bold">Phase-wise Implementation / FCI Details</td><td class="col-md-3"></td><td class="col-md-4"></td></tr><tr><td colspan="4"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th scope="col">Phase</th><th scope="col">Product Category</th><th scope="col">FCI</th><th scope="col">Implementation Date</th></tr></thead><tbody></tbody></table></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">11. Manufacturing Data</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-11 bold" colspan="4">11.1 Manufacturing Details</td></tr><tr><td colspan="1"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th scope="col">Raw Material</th><th scope="col">Quantity</th><th scope="col">Units</th></tr></thead><tbody></tbody></table></td><td colspan="3"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th scope="col">Main Product</th><th scope="col">Quantity</th><th scope="col">Units</th></tr></thead><tbody></tbody></table></td></tr><tr><td class="bold col-md-2" colspan="3">11.2 Manufacturing Process Flow</td></tr><tr><td class="col-md-2"></td><td class="col-md-2">Step 1</td><td class="col-md-3">Level the ground</td></tr><tr><td class="col-md-2"></td><td class="col-md-2">Step 2</td><td class="col-md-3">Raise the Docks</td></tr><tr><td class="col-md-2"></td><td class="col-md-2">Step 3</td><td class="col-md-3">Make foundations</td></tr><tr><td class="col-md-2"></td><td class="col-md-2">Step 4</td><td class="col-md-3">Erect Building</td></tr><tr><td class="col-md-2"></td><td class="col-md-2">Step 5</td><td class="col-md-3"></td></tr><tr><td class="col-md-2"></td><td class="col-md-2">Step 6</td><td class="col-md-3"></td></tr><tr><td class="col-md-2"></td><td class="col-md-2">Step 7</td><td class="col-md-3"></td></tr><tr><td class="col-md-2"></td><td class="col-md-2">Step 7</td><td class="col-md-3"></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">12. Environment Impact Data</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-1">12.1</td><td class="col-md-4 bold">Raw Water &amp; Effluent Details</td><td class="col-md-3"></td><td class="col-md-4"></td></tr><tr><td class="col-md-1">12.2</td><td class="col-md-4 bold">Source of Water Supply</td><td class="col-md-3">Tubewell</td><td class="col-md-4"></td></tr><tr><td colspan="4"><table class="table table-striped table-hover"><thead><tr><th class="col-md-2 bold">Particulars</th><th class="col-md-2 bold">Process</th><th class="col-md-2 bold">Cooling</th><th class="col-md-2 bold">Domestic &nbsp;&nbsp;Other</th></tr></thead><tbody><tr><td class="col-md-3">a. Water Usage (In m<sup>3</sup> per day)</td><td class="col-md-3">1</td><td class="col-md-3">0</td><td class="col-md-3"><table class="table table-striped table-hover"><tbody><tr><td>1</td><td>0</td></tr></tbody></table></td></tr><tr><td class="col-md-3">b. Waste Water Generation (In m<sup>3</sup> per day)</td><td class="col-md-3">0.25</td><td class="col-md-3">0</td><td class="col-md-3"><table class="table table-striped table-hover"><tbody><tr><td>0.25</td><td>0</td></tr></tbody></table></td></tr><tr><td class="col-md-3">c. Waste Water Treatment<br></td><td class="col-md-3">Effluent Treatment Plant</td><td class="col-md-3">Others <span>-0</span></td><td class="col-md-3"><table class="table table-striped table-hover"><tbody><tr><td>Septic Tank</td><td>0</td></tr></tbody></table></td></tr></tbody></table></td></tr><tr><td class="col-md-1">12.3</td><td class="col-md-4">Mode of Disposal For Discharge</td><td class="col-md-3">Sewer</td><td class="col-md-4"></td></tr><tr><td class="col-md-1">12.4</td><td class="col-md-4">Land Details In Case Disposal On To Land</td><td class="col-md-3"><table class="table table-striped table-hover"><tbody><tr><td>Area</td><td><span>NA</span></td></tr><tr><td>Status Of Land</td><td><span>NA</span></td></tr></tbody></table></td><td class="col-md-4"></td></tr><tr><td colspan="4">12.5 Emission Data</td></tr><tr><td colspan="4"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th scope="col">Emission Type</th><th scope="col">Capacity</th><th scope="col">Type Of Fuel</th><th scope="col">Pollution Control Device</th></tr></thead><tbody><tr class="rowGrid"><td>DG Set</td><td>250.00</td><td>HSD</td><td>Adequate Stack Height Only</td></tr></tbody></table></td></tr><tr><td colspan="4">12.6 Solid Waste Generation Details</td></tr><tr><td colspan="4"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th scope="col">Source Of Generation</th><th scope="col">Nature / Type</th><th scope="col">Quantity</th><th scope="col">Mode Of Disposal</th></tr></thead><tbody><tr class="rowGrid"><td>Pallets</td><td>Non-Hazardous</td><td>0.25</td><td>Sold to Registered Recycler</td></tr></tbody></table></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">13. Electric Power Requirement</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td class="col-md-2 bold">13.1 Temporary Connection<br><span style="font-size:12px; font-style:italic;font-weight:normal">* During Construction</span> <span style="font-size:12px; font-style:italic;font-weight:normal">*Enclose bill copy in case of existing connection</span><br><br><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/">View Existing Bill</a></td><td class="col-md-5"><div class="col-md-12"><div class="col-md-6">Load Required</div><div class="col-md-6">No</div></div><div class="col-md-12"><div class="col-md-6">Power Company</div><div class="col-md-6"><span>NA</span></div></div><div class="col-md-12"><div class="col-md-6">Account Number</div><div class="col-md-6"><span>NA</span></div></div><div class="col-md-12"><div class="col-md-6">Existing Load(in KW)</div><div class="col-md-6">0.00</div></div><div class="col-md-12"><div class="col-md-6">Existing Load (in KVA)</div><div class="col-md-6">0.00</div></div><div class="col-md-12"><div class="col-md-6">New Load Demand (in KW)</div><div class="col-md-6">0.00</div></div><div class="col-md-12"><div class="col-md-6">New Load Demand (in KVA)</div><div class="col-md-6">0.00</div></div><div class="col-md-12"><div class="col-md-6">Demand Date</div><div class="col-md-6"><span>NA</span></div></div></td></tr><tr><td class="col-md-2 bold">13.2 Regular Connection<br><span style="font-size:12px; font-style:italic;font-weight:normal">* During Commercial Activity</span><br><span style="font-size:12px; font-style:italic;font-weight:normal">*Enclose bill copy in case of existing connection</span><br><br><a class="dlnk" target="_blank" href="http://investharyana.nic.in/writereaddata/upload/b17a777f-37db-4864-8e6d-43a3f14ebe58.pdf">View Existing Bill</a></td><td class="col-md-5"><div class="col-md-12"><div class="col-md-6">Load Required</div><div class="col-md-6">Yes</div></div><div class="col-md-12"><div class="col-md-6">Power Company</div><div class="col-md-6">DHBVN</div></div><div class="col-md-12"><div class="col-md-6">Customer Type</div><div class="col-md-6">Non-Domestic</div></div><div class="col-md-12"><div class="col-md-6">Account Number</div><div class="col-md-6">OG33-TC11-1304</div><div class="col-md-12"><div class="col-md-6" style="padding-left:0px">Existing Load (in KW)</div><div class="col-md-6">6.00</div></div><div class="col-md-12"><div class="col-md-6" style="padding-left:0px">Existing Load (in KVA)</div><div class="col-md-6">7.00</div></div><div class="col-md-12"><div class="col-md-6" style="padding-left:0px">New Load (in KW)</div><div class="col-md-6">10.00</div></div><div class="col-md-12"><div class="col-md-6" style="padding-left:0px">New Load (in KVA)</div><div class="col-md-6">11.00</div></div><div class="col-md-12"><div class="col-md-6" style="padding-left:0px">Demand Date</div><div class="col-md-6">01-Aug-2017</div></div></div></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Terms and Conditions</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><td style="width:10px">&nbsp;</td><td><ol><li style="padding:10px">I/We <b>Satish Sharma</b>, Proprietor/Partner/Director of M/s.<b>JKS INFRASTRUCTURE PVT LTD</b>, hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</li><li style="padding:10px">All the required attachments have been completely and legibly attached to this form.</li></ol></td></tr><tr><td style="width:10px">&nbsp;</td><td><input checked="checked" id="chkAccept" disabled="disabled" style="outline: 2px solid" autocomplete="off" autocompletetype="Disable" type="checkbox"> I Accept Terms and Conditions</td></tr></tbody></table><table class="table table-striped table-hover"><tbody><tr><td class="col-md-3 bold" style="border-top-left-radius:8px">Application Date: 10-Aug-2016</td><td class="col-md-3" style="text-align:center;border-top-right-radius:8px"><img src="./DetailCAF4 - Single Roof Clearance Systems, HEPB_files/b5a0266d-cdad-440d-9be0-dc12c89c5910.png" width="160px" height="70px"></td></tr><tr><td class="col-md-3 bold">Place: New Delhi</td><td class="col-md-3 bold"><div class="col-md-4"></div><div class="pull-left col-md-8">Applicant Name: Satish Kumar Sharma</div></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/complianceprojectdetaillist/complianceprojectdetaillist.html','<div class="row"><div class="panel panel-primary"><!--        <div class="panel-heading">--><!--            <h3 class="panel-title">Compliance List</h3>--><!--        </div>--><div class="panel-body"><h3>Compliance List</h3><!--            <div class="col-md-2 text-center">--><!--                <select class="form-control custom-form-control" ng-change="vm.statusChange(vm.statusOnPage)" ng-model="vm.statusOnPage">--><!--                    <option value="All">All</option>--><!--                    <option value="Pending">Pending</option>--><!--                    <option value="Required">Required</option>--><!--                    <option value="Cleared">Cleared</option>--><!--                    <option value="Declined">Rejected</option>--><!--                    <option value="Rejected">Deactivated</option>--><!--                </select>--><!--            </div>--><table class="jh-table table table-striped mt-60" style="overflow: auto"><thead><tr><th><span>Department</span></th><th><span>Compliance (Service Name)</span></th><th><span>Compliance Document</span></th><th><span>Act Applicable</span></th><th><span>Rules Applicable</span></th><th><span>Penal provision in cas of non-compliance</span></th><th><span>Periodicity of Compliance</span></th><th><span>Compliance Start Date</span></th><th><span>Compliance End Date</span></th><th><span>SMS/Email/Both trigger date</span></th><th><span>Approval</span></th><th><span>Current Compliance status</span></th><th></th></tr></thead><tbody><tr ng-if="vm.projectid==\'6791a861-0913-41c1-953b-708c76897cdd\'"><td>Food & Supplies Department</td><td>Certificate of Verification of weights and measures</td><td class="action verticalalign"><!--                        <button type="button" class="btn btn-info"--><!--&lt;!&ndash;                                ng-if="projectservice.status == \'Cleared\' || projectservice.status == \'Declined\'"&ndash;&gt;--><!--                                ng-click="vm.goToServiceDetail(projectservice.projectid, projectservice.serviceid, projectservice.status, projectservice.reApplyCounter)">--><!--                            Download--><!--                        </button>--> <button type="button" class="btn btn-info" ng-click="vm.handleButtonClick(projectservice)">Download</button></td><!--                    <td><button ng-show="(servicelog.fileName) ||--><!--                     ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))"--><!--                                id="myBtn" type="button" class="btn btn-primary" ng-click="vm.downFile(servicelog)">Download</button></td>--><!--                    <td><button  ng-show="(servicelog.fileName) ||--><!--                    ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') ||--><!--                    (servicelog.actionTaken==\'Declined\')))" id="myBtn1" type="button" class="btn btn-primary"--><!--                                ng-click="vm.userFile(servicelog)">Download</button></td>--><td>Legal Metrology Act 2009</td><td>24 (1) 33</td><td>in case of non compliance a maximum fine upto 10000 Rs under Penal Section 33</td><td>3 Yr</td><td>25-Oct-2019</td><td>24-Oct-2024</td><td>-----------</td><td>-----------</td><td>Yes</td></tr><tr ng-if="vm.projectid==\'6791a861-0913-41c1-953b-708c76897cdd\'"><td>Haryana Pollution Control Board</td><td>CTE</td><td class="action verticalalign"><!--                        <button type="button" class="btn btn-info"--><!--&lt;!&ndash;                                ng-if="projectservice.status == \'Cleared\' || projectservice.status == \'Declined\'"&ndash;&gt;--><!--                                ng-click="vm.goToServiceDetail(projectservice.projectid, projectservice.serviceid, projectservice.status, projectservice.reApplyCounter)">--><!--                            Download--><!--                        </button>--> <button type="button" class="btn btn-info" ng-click="vm.handleButtonClick(projectservice)">Download</button></td><!--                    <td><button ng-show="(servicelog.fileName) ||--><!--                     ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))"--><!--                                id="myBtn" type="button" class="btn btn-primary" ng-click="vm.downFile(servicelog)">Download</button></td>--><!--                    <td><button  ng-show="(servicelog.fileName) ||--><!--                    ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') ||--><!--                    (servicelog.actionTaken==\'Declined\')))" id="myBtn1" type="button" class="btn btn-primary"--><!--                                ng-click="vm.userFile(servicelog)">Download</button></td>--><td>THE WATER (PREVENTION AND CONTROL OF POLLUTION) ACT, 1974 ACT NO. 6 OF 1974 (as amended to date) & THE AIR (PREVENTION AND CONTROL OF POLLUTION) ACT, 1981 (ACT NO. 14 OF 1981) (as amended to date)</td><td>Haryana Water (Prevention and Control of Pollution) Rules, 1978 and Haryana Air (Prevention and Control of Pollution) Rules, 1983.</td><td>Air Act penal Provision Ministry of Law and Justice (Legislative Department), Government of India vide notification dated 11.08.2023 has amended the provisions of the Air (Prevention & Control of Pollution) Act, 1981 through the Jan Vishwas (Amendment of Provisions) Act, 2023 (No. 18 of 2023). Criminal action under sections 37, 38, 38A and section 39 of the Air Act, 1981 has now been replaced with penalty and prosecution provisions remains only u/s 39D of Air Act for failure to comply with provisions of section 21 of the Air Act, 1981 and for failure to pay penalty imposed under Air Act, 1981 by adjudticating authority. Water Act penal Provision Ministry of Law and Justice (Legislative Department), Government of India vide notification dated 15.02.2024 has amended the provisions Water Act, 1974 through the Water (Prevention & Control of Pollution) Amendment Act 2024 (No. 5 OF 2024). Criminal action under sections 41, 41A, 42, 43, 44, 45A and 48 of the Water Act, 1974 has now been replaced with penalty. The amended provisions of the Water Act, 2024 is under process at the level of Government for adoption by virtue article 252 of Constitution of India as the water is a State subject and the amended provisions become applicable in the state of Haryana as and when adopted. At present, prosecution provisions u/s of section 41 to 48 of the Water Act, 1974 are applicable in the State of Haryana.</td><td>5 years and/or synchronised with the validity of EC</td><td>28-Nov-2019</td><td>27-Nov-2024</td><td>26-Oct-2024</td><td>-----------</td><td>Yes</td></tr><tr ng-if="vm.projectid==\'6791a861-0913-41c1-953b-708c76897cdd\'"><td>Haryana Pollution Control Board</td><td>Consent to Operate - Air/Water</td><td class="action verticalalign"><!--                        <button type="button" class="btn btn-info"--><!--&lt;!&ndash;                                ng-if="projectservice.status == \'Cleared\' || projectservice.status == \'Declined\'"&ndash;&gt;--><!--                                ng-click="vm.goToServiceDetail(projectservice.projectid, projectservice.serviceid, projectservice.status, projectservice.reApplyCounter)">--><!--                            Download--><!--                        </button>--> <button type="button" class="btn btn-info" ng-click="vm.handleButtonClick(projectservice)">Download</button></td><!--                    <td><button ng-show="(servicelog.fileName) ||--><!--                     ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))"--><!--                                id="myBtn" type="button" class="btn btn-primary" ng-click="vm.downFile(servicelog)">Download</button></td>--><!--                    <td><button  ng-show="(servicelog.fileName) ||--><!--                    ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') ||--><!--                    (servicelog.actionTaken==\'Declined\')))" id="myBtn1" type="button" class="btn btn-primary"--><!--                                ng-click="vm.userFile(servicelog)">Download</button></td>--><td>THE WATER (PREVENTION AND CONTROL OF POLLUTION) ACT, 1974 ACT NO. 6 OF 1974 (as amended to date) & THE AIR (PREVENTION AND CONTROL OF POLLUTION) ACT, 1981 (ACT NO. 14 OF 1981) (as amended to date)</td><td>Haryana Water (Prevention and Control of Pollution) Rules, 1978 and Haryana Air (Prevention and Control of Pollution) Rules, 1983.</td><td>Air Act penal Provision Ministry of Law and Justice (Legislative Department), Government of India vide notification dated 11.08.2023 has amended the provisions of the Air (Prevention & Control of Pollution) Act, 1981 through the Jan Vishwas (Amendment of Provisions) Act, 2023 (No. 18 of 2023). Criminal action under sections 37, 38, 38A and section 39 of the Air Act, 1981 has now been replaced with penalty and prosecution provisions remains only u/s 39D of Air Act for failure to comply with provisions of section 21 of the Air Act, 1981 and for failure to pay penalty imposed under Air Act, 1981 by adjudticating authority. Water Act penal Provision Ministry of Law and Justice (Legislative Department), Government of India vide notification dated 15.02.2024 has amended the provisions Water Act, 1974 through the Water (Prevention & Control of Pollution) Amendment Act 2024 (No. 5 OF 2024). Criminal action under sections 41, 41A, 42, 43, 44, 45A and 48 of the Water Act, 1974 has now been replaced with penalty. The amended provisions of the Water Act, 2024 is under process at the level of Government for adoption by virtue article 252 of Constitution of India as the water is a State subject and the amended provisions become applicable in the state of Haryana as and when adopted. At present, prosecution provisions u/s of section 41 to 48 of the Water Act, 1974 are applicable in the State of Haryana.</td><td>Orange -10</td><td>29-Nov-2019</td><td>30-Nov-2029</td><td>-----------</td><td>-----------</td><td>Yes</td></tr><tr ng-if="vm.projectid==\'6791a861-0913-41c1-953b-708c76897cdd\'"><td>Uttar Haryana Bijli Vitran Nigam</td><td>Temporary Electricity Connection (UHBVN)</td><td class="action verticalalign"><!--                        <button type="button" class="btn btn-info"--><!--&lt;!&ndash;                                ng-if="projectservice.status == \'Cleared\' || projectservice.status == \'Declined\'"&ndash;&gt;--><!--                                ng-click="vm.goToServiceDetail(projectservice.projectid, projectservice.serviceid, projectservice.status, projectservice.reApplyCounter)">--><!--                            Download--><!--                        </button>--> <button type="button" class="btn btn-info" ng-click="vm.handleButtonClick(projectservice)">Download</button></td><!--                    <td><button ng-show="(servicelog.fileName) ||--><!--                     ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))"--><!--                                id="myBtn" type="button" class="btn btn-primary" ng-click="vm.downFile(servicelog)">Download</button></td>--><!--                    <td><button  ng-show="(servicelog.fileName) ||--><!--                    ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') ||--><!--                    (servicelog.actionTaken==\'Declined\')))" id="myBtn1" type="button" class="btn btn-primary"--><!--                                ng-click="vm.userFile(servicelog)">Download</button></td>--><td>Electricity Act, 2003</td><td>HERC regulations on standard of performance notified under electricity act 2005</td><td>No</td><td>No</td><td>30-Oct-2019</td><td>One Time Issue</td><td>-----------</td><td>-----------</td><td>Yes</td></tr><tr ng-if="vm.projectid==\'6791a861-0913-41c1-953b-708c76897cdd\'"><td>Uttar Haryana Bijli Vitran Nigam</td><td>Temporary Electricity Connection (UHBVN)</td><td class="action verticalalign"><!--                        <button type="button" class="btn btn-info"--><!--&lt;!&ndash;                                ng-if="projectservice.status == \'Cleared\' || projectservice.status == \'Declined\'"&ndash;&gt;--><!--                                ng-click="vm.goToServiceDetail(projectservice.projectid, projectservice.serviceid, projectservice.status, projectservice.reApplyCounter)">--><!--                            Download--><!--                        </button>--> <button type="button" class="btn btn-info" ng-click="vm.handleButtonClick(projectservice)">Download</button></td><!--                    <td><button ng-show="(servicelog.fileName) ||--><!--                     ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))"--><!--                                id="myBtn" type="button" class="btn btn-primary" ng-click="vm.downFile(servicelog)">Download</button></td>--><!--                    <td><button  ng-show="(servicelog.fileName) ||--><!--                    ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') ||--><!--                    (servicelog.actionTaken==\'Declined\')))" id="myBtn1" type="button" class="btn btn-primary"--><!--                                ng-click="vm.userFile(servicelog)">Download</button></td>--><td>Electricity Act, 2003</td><td>HERC regulations on standard of performance notified under electricity act 2005</td><td>No</td><td>No</td><td>22-Oct-2019</td><td>One Time Issue</td><td>-----------</td><td>-----------</td><td>Yes</td></tr><tr ng-if="vm.projectid==\'6791a861-0913-41c1-953b-708c76897cdd\'"><td>Haryana State Industrial & Infrastructure Development Corporation Ltd</td><td>Land Allotment</td><td class="action verticalalign"><!--                        <button type="button" class="btn btn-info"--><!--&lt;!&ndash;                                ng-if="projectservice.status == \'Cleared\' || projectservice.status == \'Declined\'"&ndash;&gt;--><!--                                ng-click="vm.goToServiceDetail(projectservice.projectid, projectservice.serviceid, projectservice.status, projectservice.reApplyCounter)">--><!--                            Download--><!--                        </button>--> <button type="button" class="btn btn-info" ng-click="vm.handleButtonClick(projectservice)">Download</button></td><!--                    <td><button ng-show="(servicelog.fileName) ||--><!--                     ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))"--><!--                                id="myBtn" type="button" class="btn btn-primary" ng-click="vm.downFile(servicelog)">Download</button></td>--><!--                    <td><button  ng-show="(servicelog.fileName) ||--><!--                    ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') ||--><!--                    (servicelog.actionTaken==\'Declined\')))" id="myBtn1" type="button" class="btn btn-primary"--><!--                                ng-click="vm.userFile(servicelog)">Download</button></td>--><td>Estate Management Procedure-2015 (amended from time to time)</td><td>Estate Management Procedure-2015 (amended from time to time)</td><td>Not Applicable</td><td>Not Applicable</td><td>18-Oct-2019</td><td>One Time Issue</td><td>-----------</td><td>-----------</td><td>Yes</td></tr><tr ng-if="vm.projectid==\'6791a861-0913-41c1-953b-708c76897cdd\'"><td>Haryana State Industrial & Infrastructure Development Corporation Ltd</td><td>Release of Permanent Water Connection</td><td class="action verticalalign"><!--                        <button type="button" class="btn btn-info"--><!--&lt;!&ndash;                                ng-if="projectservice.status == \'Cleared\' || projectservice.status == \'Declined\'"&ndash;&gt;--><!--                                ng-click="vm.goToServiceDetail(projectservice.projectid, projectservice.serviceid, projectservice.status, projectservice.reApplyCounter)">--><!--                            Download--><!--                        </button>--> <button type="button" class="btn btn-info" ng-click="vm.handleButtonClick(projectservice)">Download</button></td><!--                    <td><button ng-show="(servicelog.fileName) ||--><!--                     ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))"--><!--                                id="myBtn" type="button" class="btn btn-primary" ng-click="vm.downFile(servicelog)">Download</button></td>--><!--                    <td><button  ng-show="(servicelog.fileName) ||--><!--                    ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') ||--><!--                    (servicelog.actionTaken==\'Declined\')))" id="myBtn1" type="button" class="btn btn-primary"--><!--                                ng-click="vm.userFile(servicelog)">Download</button></td>--><td>Water tariff Policy 2011</td><td>B(1)</td><td>Nil</td><td>Not Applicable</td><td>15-Oct-2019</td><td>One Time Issue</td><td>-----------</td><td>-----------</td><td>Yes</td></tr><tr ng-if="vm.projectid==\'6791a861-0913-41c1-953b-708c76897cdd\'"><td>Haryana State Industrial & Infrastructure Development Corporation Ltd</td><td>Obtaining Water Connection</td><td class="action verticalalign"><!--                        <button type="button" class="btn btn-info"--><!--&lt;!&ndash;                                ng-if="projectservice.status == \'Cleared\' || projectservice.status == \'Declined\'"&ndash;&gt;--><!--                                ng-click="vm.goToServiceDetail(projectservice.projectid, projectservice.serviceid, projectservice.status, projectservice.reApplyCounter)">--><!--                            Download--><!--                        </button>--> <button type="button" class="btn btn-info" ng-click="vm.handleButtonClick(projectservice)">Download</button></td><!--                    <td><button ng-show="(servicelog.fileName) ||--><!--                     ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))"--><!--                                id="myBtn" type="button" class="btn btn-primary" ng-click="vm.downFile(servicelog)">Download</button></td>--><!--                    <td><button  ng-show="(servicelog.fileName) ||--><!--                    ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') ||--><!--                    (servicelog.actionTaken==\'Declined\')))" id="myBtn1" type="button" class="btn btn-primary"--><!--                                ng-click="vm.userFile(servicelog)">Download</button></td>--><td>Water tariff Policy 2011</td><td>B(3)</td><td>Unauthorized sewerage connection detected, if any penalty of Rs.10,000/- each time</td><td>Not Applicable</td><td>27-Oct-2019</td><td>One Time Issue</td><td>-----------</td><td>-----------</td><td>Yes</td></tr><tr ng-if="vm.projectid==\'6791a861-0913-41c1-953b-708c76897cdd\'"><td>Department of Industries & Commerce</td><td>Registration under Boiler Act</td><td class="action verticalalign"><!--                        <button type="button" class="btn btn-info"--><!--&lt;!&ndash;                                ng-if="projectservice.status == \'Cleared\' || projectservice.status == \'Declined\'"&ndash;&gt;--><!--                                ng-click="vm.goToServiceDetail(projectservice.projectid, projectservice.serviceid, projectservice.status, projectservice.reApplyCounter)">--><!--                            Download--><!--                        </button>--> <button type="button" class="btn btn-info" ng-click="vm.handleButtonClick(projectservice)">Download</button></td><!--                    <td><button ng-show="(servicelog.fileName) ||--><!--                     ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))"--><!--                                id="myBtn" type="button" class="btn btn-primary" ng-click="vm.downFile(servicelog)">Download</button></td>--><!--                    <td><button  ng-show="(servicelog.fileName) ||--><!--                    ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') ||--><!--                    (servicelog.actionTaken==\'Declined\')))" id="myBtn1" type="button" class="btn btn-primary"--><!--                                ng-click="vm.userFile(servicelog)">Download</button></td>--><td>Indian Boiler Act -1923</td><td>The Boiler Operation Engineers Rules, 2011</td><td>Not Applicable</td><td>1 yr</td><td>20-Oct-2019</td><td>19-Oct-2020</td><td>-----------</td><td>-----------</td><td>Yes</td></tr><tr ng-if="vm.projectid!=\'6791a861-0913-41c1-953b-708c76897cdd\'" ng-repeat="projectservice in vm.projectservicelist"><td>{{projectservice.departmentName}}</td><td>{{projectservice.serviceName}}</td><td class="action verticalalign"><!--                        <button type="button" class="btn btn-info"--><!--&lt;!&ndash;                                ng-if="projectservice.status == \'Cleared\' || projectservice.status == \'Declined\'"&ndash;&gt;--><!--                                ng-click="vm.goToServiceDetail(projectservice.projectid, projectservice.serviceid, projectservice.status, projectservice.reApplyCounter)">--><!--                            Download--><!--                        </button>--> <button type="button" class="btn btn-info" ng-click="vm.handleButtonClick(projectservice)">Download</button></td><!--                    <td><button ng-show="(servicelog.fileName) ||--><!--                     ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))"--><!--                                id="myBtn" type="button" class="btn btn-primary" ng-click="vm.downFile(servicelog)">Download</button></td>--><!--                    <td><button  ng-show="(servicelog.fileName) ||--><!--                    ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') ||--><!--                    (servicelog.actionTaken==\'Declined\')))" id="myBtn1" type="button" class="btn btn-primary"--><!--                                ng-click="vm.userFile(servicelog)">Download</button></td>--><td>{{projectservice.actName}}</td><td>{{projectservice.ruleApplicable}}</td><td>{{projectservice.penalProvision}}</td><td>{{projectservice.periodicity}}</td><td>{{projectservice.certificateIssueDate}}</td><td>{{projectservice.certificateExpireDate}}</td><td>-----------</td><td>-----------</td><td>{{projectservice.status}}</td></tr></tbody></table></div></div></div><!-- Modal -->');
$templateCache.put('app/complianceprojectdetaillist/serviceclearanceactions.html','<div class="row"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">{{vm.title}}</h3></div><div class="panel-body"><div class="col-md-3 filter-margin text-right"><label for="filterDept" class="uk-label uk-label-danger" style="font-size: 12px">Filter :</label></div><div class="col-md-5 text-center"><select id="filterDept" class="form-control custom-form-control" ng-model="vm.departmentFilter"><option value="">All Department\'s</option><option value="{{departmentName}}" ng-repeat="(departmentName, service_list) in vm.projectservicelist.projectservicedetailDTOS | orderBy: \'departmentName\' | groupBy: \'departmentName\' ">{{departmentName}}</option></select></div><div class="col-md-2 text-center"><select class="form-control custom-form-control" ng-change="vm.statusChange(vm.statusOnPage)" ng-model="vm.statusOnPage"><option value="All">All</option><option value="Pending">Pending</option><option value="Required">Required</option><option value="Cleared">Cleared</option><option value="Declined">Rejected</option><option value="Rejected">Deactivated</option></select></div><table class="jh-table table table-striped mt-60"><thead><tr><th><span>Department</span></th><th><span>Service Name</span></th><th><span>Stage</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectservice in vm.projectservicelist.projectservicedetailDTOS | filter: {departmentName: vm.departmentFilter, status: vm.statusFilter} | filter: {formFilledStatus: vm.formStatus} | orderBy:[\'departmentName\',\'serviceName\']"><td ng-if="projectservice.departmentName!==\'Communication and Connectivity Permissions\'">{{projectservice.departmentName}}</td><td ng-if="projectservice.departmentName===\'Communication and Connectivity Permissions\'">NA</td><td>{{projectservice.serviceName}}</td><td>{{projectservice.serviceStage}}</td><td class="text-left"><a has-any-authority="ROLE_USER" target="_blank" type="button" class="btn btn-info btn-sm" ng-show="projectservice.isRequired && projectservice.serviceName !== \'Certificate of Verification of weights and measures\'" ui-sref="view-checklist({serviceid:projectservice.serviceid})">Check List</a> <a has-any-authority="ROLE_USER" target="_blank" type="button" class="btn btn-info btn-sm" ng-show="projectservice.serviceName === \'Certificate of Verification of weights and measures\'" href="../../content/pdfs/Check list for Reverification RVWM PDF.pdf">Check List</a> <button has-any-authority="ROLE_USER" ng-disabled="vm.isSaving" type="submit" ng-show="projectservice.isRequired && projectservice.serviceName===\'Regularization of existing Tower/Renewal (Above ground)\' && projectservice.isShowchoosedept && projectservice.status==\'Pending\'" data-toggle="modal" data-target="#tower_department1" ng-click="vm.tower_departments(projectservice,\'tower\')" class="btn btn-info btn-sm">Choose Department</button> <button has-any-authority="ROLE_USER" ng-disabled="vm.isSaving" type="submit" ng-show="projectservice.isRequired && projectservice.serviceName===\'Communication and Connectivity Permissions/Renewal(Below Ground)\' && projectservice.isShowchoosedept && projectservice.status==\'Pending\'" data-toggle="modal" data-target="#tower_department1" ng-click="vm.tower_departments(projectservice,\'tower\')" class="btn btn-info btn-sm">Choose Department</button> <button has-any-authority="ROLE_USER" ng-disabled="vm.isSaving" type="submit" ng-show="projectservice.isRequired && projectservice.serviceName===\'Communication and Connectivity Permissions/Renewal(Above Ground)\' && projectservice.isShowchoosedept && projectservice.status==\'Pending\'" data-toggle="modal" data-target="#tower_department1" ng-click="vm.tower_departments(projectservice,\'tower\')" class="btn btn-info btn-sm">Choose Department</button> <button has-any-authority="ROLE_DEPT_CHANGE" ng-disabled="vm.isSaving" type="submit" ng-show="projectservice.isRequired && (projectservice.serviceName === \'Communication and Connectivity Permissions/Renewal(Above Ground)\' || projectservice.serviceName===\'Regularization of existing Tower/Renewal (Above ground)\' || projectservice.serviceName===\'Right of Way / Right of Use to CABLE TV Operators\' || projectservice.serviceName===\'Renewal/Extension of Communication and Connectivity Permissions\') && projectservice.status==\'Pending\'" data-toggle="modal" data-target="#tower_department2" ng-click="vm.tower_departments(projectservice,\'tower\')" class="btn btn-info btn-sm">Update Department</button> <button has-any-authority="ROLE_DEPT_CHANGE" ng-disabled="vm.isSaving" type="submit" ng-show="projectservice.isRequired && (projectservice.serviceName===\'Communication and Connectivity Permissions/Renewal(Below Ground)\') && projectservice.status==\'Pending\'" data-toggle="modal" data-target="#tower_department2" ng-click="vm.tower_departments(projectservice,\'tower\')" class="btn btn-info btn-sm">Update Department</button> <button ng-disabled="vm.isSaving" type="submit" class="btn btn-info btn-sm" ng-click="vm.fillform(projectservice,\'reApply\')" ng-show="vm.showReApply(projectservice)">Re-Apply</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_ACCOUNT_OFFICER,ROLE_FIELD_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER,ROLE_DEPT_CHANGE,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD,ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_TICKET_ADMIN" type="submit" ui-sref="serviceLog({projectserviceid:projectservice.id,projectid:projectservice.projectid,serviceid:projectservice.serviceid})" ng-disabled="vm.isSaving" ng-show="(projectservice.isRequired==true)" class="btn btn-info btn-sm">View Service Log</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="reject-dialog({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.status==\'Pending\') && (projectservice.isRequired==true) && vm.isDeskof" class="btn btn-info btn-sm">Deactivate</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="decline-dialog({projectserviceid:projectservice.id})" ng-show="!vm.isTowerService(projectservice) && (projectservice.status==\'Pending\') && (projectservice.isRequired==true) && (!projectservice.isIntegrated)" class="btn btn-info btn-sm">Reject</button> <button has-any-authority="ROLE_USER" type="submit" ng-show="vm.isTowerServiceForWithdraw(projectservice) && (projectservice.status==\'Pending\')" ui-sref="withdraw-dialog({projectserviceid:projectservice.id})" class="btn btn-info btn-sm">Withdraw</button> <button has-any-authority="ROLE_USER" type="submit" ng-show="vm.isTowerServiceForWithdraw(projectservice) && (projectservice.clarificationByDc)" ui-sref="clarification-dialog({role:\'DC\',projectserviceid:projectservice.id})" class="btn btn-info btn-sm">Clarification DC</button> <button has-any-authority="ROLE_USER" type="submit" ng-show="vm.isTowerServiceForWithdraw(projectservice) && (projectservice.clarificationByTo)" ui-sref="clarification-dialog({role:\'TO\',projectserviceid:projectservice.id})" class="btn btn-info btn-sm">Clarification Tower Officer</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="reactivate({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.status==\'Rejected\') && (!projectservice.isIntegrated) && vm.isDeskof" class="btn btn-info btn-sm">Re-Activate</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="reactivate({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.status==\'Rejected\') && (projectservice.isIntegrated) && vm.isDeskof" class="btn btn-info btn-sm">Re-Activate</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_ACCOUNT_OFFICER,ROLE_FIELD_OFFICER,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER" type="submit" ui-sref="comment-dialog({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.isRequired==true)" class="btn btn-info btn-sm">Comment</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_NODAL_OFFICER,ROLE_DESK_OFFICER,ROLE_FIELD_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="assignservice({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.isAssigned==false) && (projectservice.isRequired==true) && (projectservice.status==\'Pending\') && (!projectservice.isIntegrated)" class="btn btn-info btn-sm">Assign Service Fee</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_NODAL_OFFICER,ROLE_DESK_OFFICER,ROLE_FIELD_OFFICER" type="submit" ui-sref="assignotherservice({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.isRequired==true) && (projectservice.isAssigned==true) && (projectservice.status==\'Pending\') && (!projectservice.isIntegrated)" class="btn btn-info btn-sm">Assign Other Fee</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_FILM_OFFICER" ng-click="vm.fillform(projectservice,\'new\')" ng-disabled="vm.isSaving" ng-show="projectservice.status != \'DeemedCleared\' && vm.showFillServiceForm(projectservice) && (!((projectservice.serviceid===\'16b4d378-5723-4adc-85e9-de55da296008\') && projectservice.formFilledStatus===true) && projectservice.serviceActive===true)" class="btn btn-info btn-sm">Fill Service Form</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICER" ng-click="vm.fillform(projectservice,\'track\')" ng-show="vm.showTrackServiceForm(projectservice)" ng-disabled="vm.isSaving" class="btn btn-info btn-sm">Track Service Form</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_RM,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICER,ROLE_USER,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER" type="submit" ui-sref="viewFormFilled({projectserviceid:projectservice.id})" ng-show="(projectservice.formFilledStatus==true) && (!projectservice.isIntegrated)" class="btn btn-info btn-sm">View Service Form</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER" type="submit" ui-sref="otherServicePayment({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="projectservice.status != \'DeemedCleared\' && (projectservice.isRequired==true) && (projectservice.isAssigned==true) && (projectservice.status==\'Pending\') && (!projectservice.isIntegrated)" class="btn btn-info btn-sm">Pay Fees</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_ACCOUNT_OFFICER,ROLE_NODAL_OFFICER,ROLE_USER,ROLE_FIELD_OFFICER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="verifyOtherPayment({projectserviceid:projectservice.id})" ng-show="(projectservice.isRequired==true) && (projectservice.isAssigned==true) && (!projectservice.isIntegrated)" class="btn btn-info btn-sm">View Payments</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_NODAL_OFFICER,ROLE_TOWER_DC,ROLE_FILM_OFFICER" type="submit" ui-sref="serviceClearance-action({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="!vm.isTowerService(projectservice) && (projectservice.isRequired==true) && (projectservice.status==\'Pending\') && (!projectservice.isIntegrated)" class="btn btn-info btn-sm">Clearance</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER" type="submit" ui-sref="deemedClearance({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.isDimmed) && (projectservice.status==\'Pending\')" class="btn btn-info btn-sm">Deemed Clearance</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="undoreject({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.status==\'Declined\') && (!projectservice.isIntegrated)" class="btn btn-info btn-sm">Undo-Reject</button><label ng-show="(projectservice.status==\'Declined\')">Service Rejected</label><label ng-show="(projectservice.status==\'Rejected\')">Service Deactivated</label><label ng-show="(projectservice.status==\'Cleared\')">Service Cleared</label><label ng-show="(projectservice.status==\'DeemedCleared\')">Service Deemed Cleared</label><label ng-show="(projectservice.status==\'Withdraw\')">Service Withdraw</label></td></tr></tbody></table></div></div></div><!-- Modal --><div class="modal" id="tower_department2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="clear()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Select New Department</h4></div><div class="modal-body"><div class="row panel-body"><div class="table-responsive" style="display:block;overflow:auto;height:400px;width:100%"><table class="jh-table table table-striped"><thead><tr><th><span>Department Name</span></th><th><span>Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.tower_departmentlist" ng-show="department.istower"><td>{{department.departmentname}}</td><td><input type="checkbox" class="form-control" ng-click="vm.updateCheck(department.departmentname)" checklist-model="required.department" checklist-value="department.departmentname"></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()">Close</button> <button type="button" ng-disabled="required.department.length==0" ng-show="vm.tower_service.id!=null" class="btn btn-primary" ng-click="vm.updateTowerServiceNO(vm.tower_service.id)" data-dismiss="modal">Done</button></div></div></div></div><div class="modal" id="tower_department3" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="clear()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Select New Department/Department\'s</h4></div><div class="modal-body"><div class="row panel-body"><div class="table-responsive" style="display:block;overflow:auto;height:400px;width:100%"><table class="jh-table table table-striped"><thead><tr><th><span>Department Name</span></th><th><span>Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.tower_departmentlist" ng-show="department.istower"><td>{{department.departmentname}}</td><td><input type="checkbox" class="form-control" ng-click="vm.BelowGround(department.departmentname)" checklist-model="required.department" checklist-value="department.departmentname"></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()">Close</button> <button type="button" ng-disabled="required.department.length==0" ng-show="vm.tower_service.id!=null" class="btn btn-primary" ng-click="vm.updateTowerServiceNO(vm.tower_service.id)" data-dismiss="modal">Done</button></div></div></div></div><div class="modal rmPaddingModal" id="YourModalId" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="YourModalId1">Select Required Department/Department\'s</h4></div><div class="modal-body" ng-show="vm.municipals.length!=0"><div class="row panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Department Name</span></th><th><span>Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.municipals"><td>{{department.name}}</td><td><input class="form-control" type="radio" name="myType" ng-model="vm.aboveMunicipal" value="{{department.name}}"><!--<input type="checkbox" class="form-control" ng-click="vm.updateMunicipal(department.name)" checklist-model="required.municipal" checklist-value="department.name"/>--></td></tr></tbody></table></div></div></div><div class="modal-footer" ng-show="vm.municipals.length!=0"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal()">Close</button> <button type="button" class="btn btn-primary" ng-disabled="vm.aboveMunicipal==null" ng-click="vm.markRequiredForMunicipal(vm.tower_service.id,required.department,vm.aboveMunicipal)" data-dismiss="modal">Done</button></div><div class="alert alert-warning" ng-hide="vm.municipals.length>0"><b>No</b> Department!</div></div></div></div><div class="modal rmPaddingModal" id="belowGround" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeBelow()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="belowGroundService">Select Required Department/Department\'s</h4></div><div class="modal-body" ng-show="vm.municipals.length!=0"><div class="row panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Department Name</span></th><th><span>Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.municipals"><td>{{department.name}}</td><td><input type="checkbox" class="form-control" checklist-model="required.belowMunicipal" checklist-value="department.name"></td></tr></tbody></table></div></div></div><div class="modal-footer" ng-show="vm.municipals.length!=0"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeBelow()">Close</button> <button type="button" class="btn btn-primary" ng-disabled="required.belowMunicipal==null" data-dismiss="modal" ng-click="vm.markRequiredForBelow(vm.tower_service.id,required.department,required.belowMunicipal)">Done</button></div><div class="alert alert-warning" ng-hide="vm.municipals.length>0"><b>No</b> Department!</div></div></div></div>');
$templateCache.put('app/conversionOfBoiler/conversionOfBoiler.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_10 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">CAQM</h1></div></div></div></section><br><div ng-cloak><div class="container"><div class="row"><!--            <div class="col-md-3" ng-if="vm.isAuthenticated()">--><!--                <form target="my_iframe"--><!--                      action="https://haryanaindustries.gov.in/msme/evincentivescheme/viewappstatus/policy2022"--><!--                      method="POST">--><!--                    <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                    <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--                    <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                    <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--                    <input type="hidden" name="url"--><!--                           value="https://haryanaindustries.gov.in/msme/evincentivescheme/viewappstatus/policy2022">--><!--                    <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="View Application Status">--><!--                </form>--><!--&lt;!&ndash;                <button class="btn btn-success" type="submit" href="#modal-full" uk-toggle>View Application Status</button>&ndash;&gt;--><!--            </div>--><!--            <div class="col-md-3" ng-if="vm.isAuthenticated()">--><!--                <form target="my_iframe"--><!--                      action="https://haryanaindustries.gov.in/msme/evincentivescheme/onholdapplications/policy2022"--><!--                      method="POST">--><!--                    <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                    <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--                    <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                    <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--                    <input type="hidden" name="url"--><!--                           value="https://haryanaindustries.gov.in/msme/evincentivescheme/onholdapplications/policy2022">--><!--                    <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Reply to onhold application">--><!--                </form>--><!--&lt;!&ndash;                <button class="btn btn-success" type="submit" href="#modal-full" uk-toggle>Reply to onhold application</button>&ndash;&gt;--><!--            </div>--><div class="col-md-3 pull-right" ng-if="vm.isAuthenticated()"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/onholdapplications/caqm" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/onholdapplications/caqm"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Reply to onhold application"></form></div><div class="col-md-3 pull-right" ng-if="vm.isAuthenticated()"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/viewappstatus/caqm" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/viewappstatus/caqm"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="My Incentive Status"></form></div><br><table class="table table-striped table-hover" ng-switch="vm.isAuthenticated()"><thead><tr class="headerGrid"><th>S.No</th><th>Scheme Name</th><th>Scheme Document (PDF)</th><th>Apply For Scheme</th></tr></thead><tbody><tr><td>1</td><td>Assistance in Conversion of Boiler to run on cleaner fuels</td><td><a target="_blank" href="../../content/pdfs/notification.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" type="submit" href="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner" uk-toggle>Apply Now</button>--></td></tr><tr><td>2</td><td>VAT Assistance in operating Industries on cleaner fuels</td><td><a target="_blank" href="../../content/pdfs/VAT Assistance in operating Industries on cleaner fuels.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/vat_assistance" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/vat_assistance"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" type="submit" href="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner" uk-toggle>Apply Now</button>--></td></tr></tbody></table></div></div></div><div id="modal-full" class="uk-modal-full" uk-modal esc-close="false" bg-close="false"><div class="uk-modal-dialog"><button class="uk-modal-close-full uk-close-large" type="button" uk-close></button><div class="uk-grid-collapse uk-flex-middle" uk-grid><section><iframe name="my_iframe" style="width: 500vw; height: 100vh" frameborder="0" marginheight="0" marginwidth="0"></iframe></section></div></div></div><br><br>');
$templateCache.put('app/dashboard/dashboard.html','<div class="container-fluid"><div class="row"><div class="col-md-12"><ul class="nav nav-pills flex-container"><li class="active"><a ui-sref="totaldeptdashboarddetail({status:\'AllEEC\'})">EEC&nbsp;<span class="badge">{{vm.totalstatcollection.allTotalEEC}}</span></a></li><li class="active"><a ui-sref="totaldeptdashboarddetail({status:\'AllDLCC\'})">DLCC&nbsp;<span class="badge">{{vm.totalstatcollection.allTotalDLCC}}</span></a></li><li class="active"><a ui-sref="totaldeptdashboarddetail({status:\'All\'})">Total CAF&nbsp;<span class="badge">{{vm.totalstatcollection.allTotalCaf}}</span></a></li><li class="active"><a ui-sref="totaldeptdashboarddetail({status:\'AllDeactivated\'})">Deactivated CAF&nbsp;<span class="badge">{{vm.totalstatcollection.allTotalDeactivatedCaf}}</span></a></li><li class="active"><a ui-sref="totaldeptdashboarddetail({status:\'AllNew\'})">New CAF&nbsp;<span class="badge">{{vm.totalstatcollection.allTotalNewCaf}}</span></a></li><li class="active"><a ui-sref="totaldeptdashboarddetail({status:\'AllRenewable\'})">Renew CAF&nbsp;<span class="badge">{{vm.totalstatcollection.allTotalRenewableCaf}}</span></a></li><li class="active"><a ui-sref="totaldeptdashboarddetail({status:\'AllShop\'})">Shop CAF&nbsp;<span class="badge">{{vm.totalstatcollection.allTotalShopCaf}}</span></a></li><li class="active"><a ui-sref="totaldeptdashboarddetail({status:\'AllLandRequirement\'})">Land Requirement CAF&nbsp;<span class="badge">{{vm.totalstatcollection.allTotalLandRequirementCaf}}</span></a></li></ul></div></div><br><div class="container"><div class="row"><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">TOWN & COUNTRY PLANNING</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'TOWN & COUNTRY PLANNING\',status:\'EEC\'})"><span class="badge">{{vm.tcpstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'TOWN & COUNTRY PLANNING\',status:\'DLCC\'})"><span class="badge">{{vm.tcpstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'TOWN & COUNTRY PLANNING\',status:\'All\'})"><span class="badge">{{vm.tcpstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'TOWN & COUNTRY PLANNING\',status:\'Pending\'})"><span class="badge">{{vm.tcpstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'TOWN & COUNTRY PLANNING\',status:\'Pending30\'})"><span class="badge">{{vm.tcpstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'TOWN & COUNTRY PLANNING\',status:\'Pending45\'})"><span class="badge">{{vm.tcpstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD\',status:\'EEC\'})"><span class="badge">{{vm.hsiidcstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD\',status:\'DLCC\'})"><span class="badge">{{vm.hsiidcstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD\',status:\'All\'})"><span class="badge">{{vm.hsiidcstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD\',status:\'Pending\'})"><span class="badge">{{vm.hsiidcstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD\',status:\'Pending30\'})"><span class="badge">{{vm.hsiidcstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD\',status:\'Pending45\'})"><span class="badge">{{vm.hsiidcstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">PWD (B & R) DEPARTMENT</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PWD (B & R) DEPARTMENT\',status:\'EEC\'})"><span class="badge">{{vm.pwdstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PWD (B & R) DEPARTMENT\',status:\'DLCC\'})"><span class="badge">{{vm.pwdstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PWD (B & R) DEPARTMENT\',status:\'All\'})"><span class="badge">{{vm.pwdstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PWD (B & R) DEPARTMENT\',status:\'Pending\'})"><span class="badge">{{vm.pwdstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PWD (B & R) DEPARTMENT\',status:\'Pending30\'})"><span class="badge">{{vm.pwdstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PWD (B & R) DEPARTMENT\',status:\'Pending45\'})"><span class="badge">{{vm.pwdstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div></div></div><div class="container"><div class="row"><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">LABOUR DEPARTMENT - LABOUR WING</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - LABOUR WING\',status:\'EEC\'})"><span class="badge">{{vm.labourstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - LABOUR WING\',status:\'DLCC\'})"><span class="badge">{{vm.labourstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - LABOUR WING\',status:\'All\'})"><span class="badge">{{vm.labourstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - LABOUR WING\',status:\'Pending\'})"><span class="badge">{{vm.labourstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - LABOUR WING\',status:\'Pending30\'})"><span class="badge">{{vm.labourstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - LABOUR WING\',status:\'Pending45\'})"><span class="badge">{{vm.labourstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">DAKSHIN HARYANA BIJLI VITRAN NIGAM</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DAKSHIN HARYANA BIJLI VITRAN NIGAM\',status:\'EEC\'})"><span class="badge">{{vm.dhbvnstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DAKSHIN HARYANA BIJLI VITRAN NIGAM\',status:\'DLCC\'})"><span class="badge">{{vm.dhbvnstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DAKSHIN HARYANA BIJLI VITRAN NIGAM\',status:\'All\'})"><span class="badge">{{vm.dhbvnstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DAKSHIN HARYANA BIJLI VITRAN NIGAM\',status:\'Pending\'})"><span class="badge">{{vm.dhbvnstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DAKSHIN HARYANA BIJLI VITRAN NIGAM\',status:\'Pending30\'})"><span class="badge">{{vm.dhbvnstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DAKSHIN HARYANA BIJLI VITRAN NIGAM\',status:\'Pending45\'})"><span class="badge">{{vm.dhbvnstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">HARYANA URBAN DEVELOPMENT AUTHORITY</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA URBAN DEVELOPMENT AUTHORITY\',status:\'EEC\'})"><span class="badge">{{vm.hudastatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA URBAN DEVELOPMENT AUTHORITY\',status:\'DLCC\'})"><span class="badge">{{vm.hudastatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA URBAN DEVELOPMENT AUTHORITY\',status:\'All\'})"><span class="badge">{{vm.hudastatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA URBAN DEVELOPMENT AUTHORITY\',status:\'Pending\'})"><span class="badge">{{vm.hudastatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA URBAN DEVELOPMENT AUTHORITY\',status:\'Pending30\'})"><span class="badge">{{vm.hudastatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA URBAN DEVELOPMENT AUTHORITY\',status:\'Pending45\'})"><span class="badge">{{vm.hudastatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div></div></div><div class="container"><div class="row"><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">URBAN LOCAL BODIES</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'URBAN LOCAL BODIES\',status:\'EEC\'})"><span class="badge">{{vm.ulbstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'URBAN LOCAL BODIES\',status:\'DLCC\'})"><span class="badge">{{vm.ulbstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'URBAN LOCAL BODIES\',status:\'All\'})"><span class="badge">{{vm.ulbstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'URBAN LOCAL BODIES\',status:\'Pending\'})"><span class="badge">{{vm.ulbstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'URBAN LOCAL BODIES\',status:\'Pending30\'})"><span class="badge">{{vm.ulbstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'URBAN LOCAL BODIES\',status:\'Pending45\'})"><span class="badge">{{vm.ulbstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">DEPARTMENT OF AYUSH</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AYUSH\',status:\'EEC\'})"><span class="badge">{{vm.ayushstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AYUSH\',status:\'DLCC\'})"><span class="badge">{{vm.ayushstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AYUSH\',status:\'All\'})"><span class="badge">{{vm.ayushstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AYUSH\',status:\'Pending\'})"><span class="badge">{{vm.ayushstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AYUSH\',status:\'Pending30\'})"><span class="badge">{{vm.ayushstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AYUSH\',status:\'Pending45\'})"><span class="badge">{{vm.ayushstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">ENVIRONMENT</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'ENVIRONMENT\',status:\'EEC\'})"><span class="badge">{{vm.environmentstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'ENVIRONMENT\',status:\'DLCC\'})"><span class="badge">{{vm.environmentstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'ENVIRONMENT\',status:\'All\'})"><span class="badge">{{vm.environmentstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'ENVIRONMENT\',status:\'Pending\'})"><span class="badge">{{vm.environmentstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'ENVIRONMENT\',status:\'Pending30\'})"><span class="badge">{{vm.environmentstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'ENVIRONMENT\',status:\'Pending45\'})"><span class="badge">{{vm.environmentstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div></div></div><div class="container"><div class="row"><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">FOOD & SUPPLIES DEPARTMENT</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'FOOD & SUPPLIES DEPARTMENT\',status:\'EEC\'})"><span class="badge">{{vm.foodnsupplystatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'FOOD & SUPPLIES DEPARTMENT\',status:\'DLCC\'})"><span class="badge">{{vm.foodnsupplystatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'FOOD & SUPPLIES DEPARTMENT\',status:\'All\'})"><span class="badge">{{vm.foodnsupplystatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'FOOD & SUPPLIES DEPARTMENT\',status:\'Pending\'})"><span class="badge">{{vm.foodnsupplystatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'FOOD & SUPPLIES DEPARTMENT\',status:\'Pending30\'})"><span class="badge">{{vm.foodnsupplystatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'FOOD & SUPPLIES DEPARTMENT\',status:\'Pending45\'})"><span class="badge">{{vm.foodnsupplystatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">HARYANA STATE POLLUTION CONTROL BOARD</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE POLLUTION CONTROL BOARD\',status:\'EEC\'})"><span class="badge">{{vm.hspcbstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE POLLUTION CONTROL BOARD\',status:\'DLCC\'})"><span class="badge">{{vm.hspcbstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE POLLUTION CONTROL BOARD\',status:\'All\'})"><span class="badge">{{vm.hspcbstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE POLLUTION CONTROL BOARD\',status:\'Pending\'})"><span class="badge">{{vm.hspcbstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE POLLUTION CONTROL BOARD\',status:\'Pending30\'})"><span class="badge">{{vm.hspcbstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'HARYANA STATE POLLUTION CONTROL BOARD\',status:\'Pending45\'})"><span class="badge">{{vm.hspcbstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">UTTAR HARYANA BIJLI VITRAN NIGAM</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'UTTAR HARYANA BIJLI VITRAN NIGAM\',status:\'EEC\'})"><span class="badge">{{vm.uhbvnstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'UTTAR HARYANA BIJLI VITRAN NIGAM\',status:\'DLCC\'})"><span class="badge">{{vm.uhbvnstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'UTTAR HARYANA BIJLI VITRAN NIGAM\',status:\'All\'})"><span class="badge">{{vm.uhbvnstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'UTTAR HARYANA BIJLI VITRAN NIGAM\',status:\'Pending\'})"><span class="badge">{{vm.uhbvnstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'UTTAR HARYANA BIJLI VITRAN NIGAM\',status:\'Pending30\'})"><span class="badge">{{vm.uhbvnstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'UTTAR HARYANA BIJLI VITRAN NIGAM\',status:\'Pending45\'})"><span class="badge">{{vm.uhbvnstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div></div></div><div class="container"><div class="row"><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">CHIEF ELECTRICAL INSPECTOR</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'CHIEF ELECTRICAL INSPECTOR\',status:\'EEC\'})"><span class="badge">{{vm.ceistatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'CHIEF ELECTRICAL INSPECTOR\',status:\'DLCC\'})"><span class="badge">{{vm.ceistatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'CHIEF ELECTRICAL INSPECTOR\',status:\'All\'})"><span class="badge">{{vm.ceistatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'CHIEF ELECTRICAL INSPECTOR\',status:\'Pending\'})"><span class="badge">{{vm.ceistatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'CHIEF ELECTRICAL INSPECTOR\',status:\'Pending30\'})"><span class="badge">{{vm.ceistatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'CHIEF ELECTRICAL INSPECTOR\',status:\'Pending45\'})"><span class="badge">{{vm.ceistatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">DEPARTMENT OF INDUSTRIES & COMMERCE</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF INDUSTRIES & COMMERCE\',status:\'EEC\'})"><span class="badge">{{vm.dicstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF INDUSTRIES & COMMERCE\',status:\'DLCC\'})"><span class="badge">{{vm.dicstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF INDUSTRIES & COMMERCE\',status:\'All\'})"><span class="badge">{{vm.dicstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF INDUSTRIES & COMMERCE\',status:\'Pending\'})"><span class="badge">{{vm.dicstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF INDUSTRIES & COMMERCE\',status:\'Pending30\'})"><span class="badge">{{vm.dicstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF INDUSTRIES & COMMERCE\',status:\'Pending45\'})"><span class="badge">{{vm.dicstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">PUBLIC HEALTH ENGINEERING DEPARTMENT</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PUBLIC HEALTH ENGINEERING DEPARTMENT\',status:\'EEC\'})"><span class="badge">{{vm.phedstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PUBLIC HEALTH ENGINEERING DEPARTMENT\',status:\'DLCC\'})"><span class="badge">{{vm.phedstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PUBLIC HEALTH ENGINEERING DEPARTMENT\',status:\'All\'})"><span class="badge">{{vm.phedstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PUBLIC HEALTH ENGINEERING DEPARTMENT\',status:\'Pending\'})"><span class="badge">{{vm.phedstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PUBLIC HEALTH ENGINEERING DEPARTMENT\',status:\'Pending30\'})"><span class="badge">{{vm.phedstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'PUBLIC HEALTH ENGINEERING DEPARTMENT\',status:\'Pending45\'})"><span class="badge">{{vm.phedstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div></div></div><div class="container"><div class="row"><!--<div class="col-lg-4 col-sm-5">--><!--<div class="panel panel-primary">--><!--<div class="panel-heading">--><!--<h4 class="panel-title">EXCISE & TAXATION - EXCISE</h4>--><!--</div>--><!--<div class="panel-body">--><!--<div class="list-group">--><!--<div class="list-group-item">--><!--EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'EXCISE & TAXATION - EXCISE\',status:\'EEC\'})"><span class="badge">{{vm.excisestatcollection.totaleec}}</span></a></div>--><!--</div>--><!--<div class="list-group-item">--><!--DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'EXCISE & TAXATION - EXCISE\',status:\'DLCC\'})"><span class="badge">{{vm.excisestatcollection.totaldlcc}}</span></a></div>--><!--</div>--><!--<div class="list-group-item">--><!--Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'EXCISE & TAXATION - EXCISE\',status:\'All\'})"><span class="badge">{{vm.excisestatcollection.totalCaf}}</span></a></div>--><!--</div>--><!--<div class="list-group-item">--><!--Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'EXCISE & TAXATION - EXCISE\',status:\'Pending\'})"><span class="badge">{{vm.excisestatcollection.totalPendingCaf}}</span></a></div>--><!--</div>--><!--<div class="list-group-item">--><!--Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'EXCISE & TAXATION - EXCISE\',status:\'Pending30\'})"><span class="badge">{{vm.excisestatcollection.totalPendingCaf30Days}}</span></a></div>--><!--</div>--><!--<div class="list-group-item">--><!--Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'EXCISE & TAXATION - EXCISE\',status:\'Pending45\'})"><span class="badge">{{vm.excisestatcollection.totalPendingCaf45Days}}</span></a></div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">Airport Authority of India</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Airport Authority of India\',status:\'EEC\'})"><span class="badge">{{vm.loadairportauthoritycollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Airport Authority of India\',status:\'DLCC\'})"><span class="badge">{{vm.loadairportauthoritycollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Airport Authority of India\',status:\'All\'})"><span class="badge">{{vm.loadairportauthoritycollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Airport Authority of India\',status:\'Pending\'})"><span class="badge">{{vm.loadairportauthoritycollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Airport Authority of India\',status:\'Pending30\'})"><span class="badge">{{vm.loadairportauthoritycollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Airport Authority of India\',status:\'Pending45\'})"><span class="badge">{{vm.loadairportauthoritycollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">MINES & GEOLOGY DEPARTMENT</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'MINES & GEOLOGY DEPARTMENT\',status:\'EEC\'})"><span class="badge">{{vm.minesstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'MINES & GEOLOGY DEPARTMENT\',status:\'DLCC\'})"><span class="badge">{{vm.minesstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'MINES & GEOLOGY DEPARTMENT\',status:\'All\'})"><span class="badge">{{vm.minesstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'MINES & GEOLOGY DEPARTMENT\',status:\'Pending\'})"><span class="badge">{{vm.minesstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'MINES & GEOLOGY DEPARTMENT\',status:\'Pending30\'})"><span class="badge">{{vm.minesstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'MINES & GEOLOGY DEPARTMENT\',status:\'Pending45\'})"><span class="badge">{{vm.minesstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">DEPARTMENT OF FORESTS & WILDLIFE</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF FORESTS & WILDLIFE\',status:\'EEC\'})"><span class="badge">{{vm.fnwstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF FORESTS & WILDLIFE\',status:\'DLCC\'})"><span class="badge">{{vm.fnwstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF FORESTS & WILDLIFE\',status:\'All\'})"><span class="badge">{{vm.fnwstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF FORESTS & WILDLIFE\',status:\'Pending\'})"><span class="badge">{{vm.fnwstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF FORESTS & WILDLIFE\',status:\'Pending30\'})"><span class="badge">{{vm.fnwstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF FORESTS & WILDLIFE\',status:\'Pending45\'})"><span class="badge">{{vm.fnwstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div></div></div><div class="container"><div class="row"><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">Food and Drug Administration</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Food and Drug Administration\',status:\'EEC\'})"><span class="badge">{{vm.foodndrugstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Food and Drug Administration\',status:\'DLCC\'})"><span class="badge">{{vm.foodndrugstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Food and Drug Administration\',status:\'All\'})"><span class="badge">{{vm.foodndrugstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Food and Drug Administration\',status:\'Pending\'})"><span class="badge">{{vm.foodndrugstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Food and Drug Administration\',status:\'Pending30\'})"><span class="badge">{{vm.foodndrugstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'Food and Drug Administration\',status:\'Pending45\'})"><span class="badge">{{vm.foodndrugstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">DEPARTMENT OF RENEWABLE ENERGY</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF RENEWABLE ENERGY\',status:\'EEC\'})"><span class="badge">{{vm.renewablestatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF RENEWABLE ENERGY\',status:\'DLCC\'})"><span class="badge">{{vm.renewablestatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF RENEWABLE ENERGY\',status:\'All\'})"><span class="badge">{{vm.renewablestatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF RENEWABLE ENERGY\',status:\'Pending\'})"><span class="badge">{{vm.renewablestatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF RENEWABLE ENERGY\',status:\'Pending30\'})"><span class="badge">{{vm.renewablestatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF RENEWABLE ENERGY\',status:\'Pending45\'})"><span class="badge">{{vm.renewablestatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">DEPARTMENT OF AGRICULTURE</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AGRICULTURE\',status:\'EEC\'})"><span class="badge">{{vm.agriculturestatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AGRICULTURE\',status:\'DLCC\'})"><span class="badge">{{vm.agriculturestatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AGRICULTURE\',status:\'All\'})"><span class="badge">{{vm.agriculturestatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AGRICULTURE\',status:\'Pending\'})"><span class="badge">{{vm.agriculturestatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AGRICULTURE\',status:\'Pending30\'})"><span class="badge">{{vm.agriculturestatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'DEPARTMENT OF AGRICULTURE\',status:\'Pending45\'})"><span class="badge">{{vm.agriculturestatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div></div></div><div class="container"><div class="row"><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">LABOUR DEPARTMENT - FACTORY WING</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - FACTORY WING\',status:\'EEC\'})"><span class="badge">{{vm.labourfactorywingstatcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - FACTORY WING\',status:\'DLCC\'})"><span class="badge">{{vm.labourfactorywingstatcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - FACTORY WING\',status:\'All\'})"><span class="badge">{{vm.labourfactorywingstatcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - FACTORY WING\',status:\'Pending\'})"><span class="badge">{{vm.labourfactorywingstatcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - FACTORY WING\',status:\'Pending30\'})"><span class="badge">{{vm.labourfactorywingstatcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'LABOUR DEPARTMENT - FACTORY WING\',status:\'Pending45\'})"><span class="badge">{{vm.labourfactorywingstatcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div><div class="col-lg-4 col-sm-5"><div class="panel panel-primary"><div class="panel-heading"><h4 class="panel-title">National Monument Authority</h4></div><div class="panel-body"><div class="list-group"><div class="list-group-item">EEC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'National Monument Authority\',status:\'EEC\'})"><span class="badge">{{vm.loadnationalmonumentcollection.totaleec}}</span></a></div></div><div class="list-group-item">DLCC<div class="pull-right"><a ui-sref="dashboardcafs({department:\'National Monument Authority\',status:\'DLCC\'})"><span class="badge">{{vm.loadnationalmonumentcollection.totaldlcc}}</span></a></div></div><div class="list-group-item">Total CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'National Monument Authority\',status:\'All\'})"><span class="badge">{{vm.loadnationalmonumentcollection.totalCaf}}</span></a></div></div><div class="list-group-item">Pending CAF<div class="pull-right"><a ui-sref="dashboardcafs({department:\'National Monument Authority\',status:\'Pending\'})"><span class="badge">{{vm.loadnationalmonumentcollection.totalPendingCaf}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 30 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'National Monument Authority\',status:\'Pending30\'})"><span class="badge">{{vm.loadnationalmonumentcollection.totalPendingCaf30Days}}</span></a></div></div><div class="list-group-item">Total Pending CAF > 45 Days<div class="pull-right"><a ui-sref="dashboardcafs({department:\'National Monument Authority\',status:\'Pending45\'})"><span class="badge">{{vm.loadnationalmonumentcollection.totalPendingCaf45Days}}</span></a></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/dashboard/viewcafs.html','<form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-10"><h4 class="modal-title" id="myBlockLabel">Department : {{vm.department}}</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="col-md-1 pull-right"><button ng-show="vm.show" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div><div class="row"><div class="text-center"><h5 class="modal-title" ng-show="vm.status==\'All\'"><b>All CAFs(Composite Application Form)</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending\'"><b>All Pending CAFs (Composite Application Form)</b></h5><h5 class="modal-title" ng-show="vm.status==\'DLCC\'"><b>All DLCC CAFs (Composite Application Form)</b></h5><h5 class="modal-title" ng-show="vm.status==\'EEC\'"><b>All EEC CAFs (Composite Application Form)</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending30\'"><b>All CAFs Pending for more than 30 days</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending45\'"><b>All CAFs Pending for more than 45 days</b></h5><!--<h5 class="modal-title pull-right" ng-show="vm.status==\'Pending60\'">All CAFs Pending for more than 60 days</h5>--></div></div></div><div class="panel-body"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><th><span>Business Entity</span></th><th><span>District</span></th><th><span>Project Level</span></th><th><span>Proposed Employment</span></th><th><span>Proposed Investment(in crore)</span></th></tr></thead><tbody><tr ng-repeat="caf in vm.dashboardcafs | orderBy: \'-projectlevel\'"><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><td>{{caf.businessentity}}</td><td>{{caf.district}}</td><td>{{caf.projectlevel=="d" ? "DLCC" : "EEC"}}</td><td>{{caf.projectemployment}}</td><td>{{caf.projectinvestment}}</td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/datewiseDeptDashboard/datewiseDeptDashboard.html','<form name="myForm" ng-submit="vm.getDatewiseDeptStat()" class="form-horizontal" role="form"><div class="container"><div class="col-md-2"><button class="btn btn-danger" ng-click="vm.getDeactivatedCAFs()"><span ng-show="vm.deactivatedCAFsAvailable"><i class="glyphicon glyphicon-refresh spinning"></i></span>{{ vm.deactivatedCAFsAvailable ? " Please Wait..." : "Get All Deactivated CAFs" }}</button></div><div class="row flex-container"><div class="col-md-2 col-md-offset-2"><div class="form-group"><div class="input-group"><label>CAF Application Date :</label></div></div></div><div class="col-md-2"><div class="input-group"><input id="field_fromdate" type="text" class="form-control" name="fromdate" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.cafdetail.startdate" ng-change="vm.selectedDate(vm.cafdetail.startdate)" is-open="vm.datePickerOpenStatus.fromdate" datepicker-options="optionsForDatePicker" placeholder="From"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-2"><div class="input-group"><input id="field_todate" type="text" class="form-control" name="todate" uib-datepicker-popup="dd-MM-yyyy" ng-model="vm.cafdetail.enddate" ng-change="vm.selectedDate(vm.cafdetail.enddate)" is-open="vm.datePickerOpenStatus.todate" datepicker-options="vm.dateOptions1" placeholder="To"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="row"><div class="pull-left" style="color: red;margin-left: 100px"><b>*</b> Enter a period of 1 months</div></div></div><div class="row flex-container" ng-show="vm.cafdetail.startdate != null && vm.cafdetail.enddate != null && !vm.isDeactivatedRequested"><div class="col-md-12"><div class="col-md-2"><div class="input-group"><label>Project Investment :</label><select class="form-control" ng-model="vm.amount"><option value="all">All</option><option value="a">less than 1 crore</option><option value="b">1 crore to 10 crore</option><option value="c">10 crore to 50 crore</option><option value="d">50 crore to 100 crore</option><option value="e">more than 100 crore</option></select></div></div><div class="col-md-2"><div class="input-group"><label>Proposed Area:</label><select class="form-control" ng-model="vm.area"><option value="all">All</option><option value="a">less than 1 acre</option><option value="b">1 acre to 5 acre</option><option value="c">5 acre to 10 acre</option><option value="d">more than 10 acre</option></select></div></div><div class="col-md-2"><div class="input-group"><label>CAF Type:</label><select class="form-control" ng-model="vm.caftype"><!--<option value="all">All</option>--><option value="new">New</option><option value="shop">Shop</option><option value="excise">Excise</option><option value="renewable">Renew</option><option value="landrequirement">LandCAF</option><option value="tower">TowerCAF</option><option value="FILMCAF">Film</option><option value="ROW">Row</option></select></div></div><div class="col-md-2"><div class="input-group"><label>Sector:</label><select class="form-control" ng-model="vm.sectorObj" ng-options="sector.sectortype for sector in vm.sectors"></select></div></div><div class="col-md-2"><div class="input-group"><label>Proposed Employment:</label><select class="form-control" ng-model="vm.employees"><option value="all">All</option><option value="a">less than 10</option><option value="b">10 to 50</option><option value="c">50 to 100</option><option value="d">more than 100</option></select></div></div><div class="col-md-2"><div class="input-group pull-bottom"><input type="submit" class="btn btn-primary" value="Submit"><br><br></div></div></div></div></div><div class="container-fluid border-top"><h3 ng-show="vm.isDeactivatedRequested">Currently showing all deactivated CAFs</h3><div class="row"><div class="col-md-12"><button ng-show="vm.show" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm pull-right btn-marginTop">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button><table id="result_table" class="jh-table table table-striped table-condensed"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><th><span>Investor Name</span></th><th><span>Email</span></th><th><span>Contact</span></th><th><span>Business Entity</span></th><th><span>Site Address</span></th><th ng-hide="vm.isDeactivatedRequested"><span>RM Info (Relationship Manager)</span></th><th><span>District</span></th><th><span>Project Level</span></th><th><span>Proposed Employment</span></th><th><span>Haryana Domicile</span></th><th><span>Non Haryana Domicile</span></th><th><span>Proposed Investment(in crore)</span></th><th><span>Proposed Area (in acres)</span></th><th><span>Sector</span></th><th><span>Project Purpose</span></th><th><span>Project ID</span></th><th><span>Application Date</span></th><th ng-if="vm.showDeactivationDate"><span>Deactivation Date</span></th><th><span>Category Of Block</span></th><th><span>Investment Type</span></th><th><span>Product</span></th><th><span>Industrial Estate</span></th><th><span>Start Date of Production</span></th><th><span>Foreign Direct Investment</span></th></tr></thead><tbody><tr ng-hide="vm.isDeactivatedRequested" ng-repeat="caf in vm.datewisestatcollection | orderBy: \'-_source.applicationdate\'"><!--                        <td>{{$index +1}}</td>--><!--                        <td>{{caf._source.cafpin}}</td>--><!--                        <td>{{caf._source.firstname}} {{caf._source.middlename}} {{caf._source.lastname}}</td>--><!--                        <td>{{caf._source.emailprimary}}</td>--><!--                        <td>{{caf._source.mobilenumber}}</td>--><!--                        <td>{{caf._source.businessentity== "Renewable" ? "Renew" : caf._source.businessentity}}</td>--><!--                        <td>{{caf._source.siteaddress}}</td>--><!--                        <td ng-hide="vm.isDeactivatedRequested">{{caf._source.assignedRM==\'\' ? "Not Assigned" : caf._source.assignedRM}}</td>--><!--                        <td>{{caf._source.district}}</td>--><!--                        <td>{{caf._source.projectlevel=="d" ? "DLCC" : "EEC"}}</td>--><!--                        <td>{{caf._source.totalpurposedemployment}}</td>--><!--                        <td>{{caf._source.haryanadomicile}}</td>--><!--                        <td>{{caf._source.nonharyanadomicile}}</td>--><!--                        <td>{{caf._source.total_project_cost | decimalFormat}}</td>--><!--                        <td>{{caf._source.totalproposedprojectarea}}</td>--><!--                        <td>{{caf._source.sectorname === \'Other Industries\' ? caf._source.otherSector + " - "+ caf._source.sectorname : caf._source.sectorname}}</td>--><!--                        <td>{{caf._source.projectpurpose}}</td>--><!--                        <td>{{caf._source.id}}</td>--><!--                        <td>{{caf._source.applicationdate | date:\'dd-MM-yyyy\'}}</td>--><!--                        <td ng-if="vm.showDeactivationDate">{{caf._source.deactivateddate | date:\'dd-MM-yyyy\'}}</td>--><!--                        <td>{{caf._source.blockCategory}}</td>--><!--                        <td>{{caf._source.investmentType}}</td>--><!--                        <td>{{caf._source.product}}</td>--><!--                        <td>{{caf._source.prodctionStartDate | date:\'dd-MM-yyyy\'}}</td>--><!--                        <td>{{caf._source.foreign_investment !== null ? caf._source.foreign_investment : \'NA\'}}</td>--><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><td>{{caf.investorName}}</td><td>{{caf.investorEmail}}</td><td>{{caf.investorContact}}</td><td>{{caf.businessentity== "Renewable" ? "Renew" : caf.businessentity}}</td><td>{{caf.siteAddress}}</td><td ng-hide="vm.isDeactivatedRequested">{{caf.rmInfo==\'\' ? "Not Assigned" : caf.rmInfo}}</td><td>{{caf.district}}</td><td>{{caf.projectlevel=="d" ? "DLCC" : "EEC"}}</td><td>{{caf.projectemployment}}</td><td>{{caf.haryanadomicile}}</td><td>{{caf.nonharyanadomicile}}</td><td>{{caf.projectinvestment | decimalFormat}}</td><td>{{caf.proposedprojectarea}}</td><td>{{caf.sector === \'Other Industries\' ? caf.otherSector + " - "+ caf.sector : caf.sector}}</td><td>{{caf.projectPurpose}}</td><td>{{caf.projectId}}</td><td>{{caf.applicationdate | date:\'dd-MM-yyyy\'}}</td><td>{{caf.blockCategory}}</td><td>{{caf.investmentType}}</td><td>{{caf.product}}</td><td>{{caf.industrialEstate!=null ? "Yes" : "No"}}</td><td>{{caf.prodctionStartDate | date:\'dd-MM-yyyy\'}}</td><td>{{caf.foreignInvestment !== null ? caf.foreignInvestment : \'NA\'}}</td></tr><tr ng-if="vm.showDeactivationDate" ng-repeat="caf in vm.datewisestatcollection | orderBy: \'-_source.deactivateddate\'"><!--                        <td>{{$index +1}}</td>--><!--                        <td>{{caf._source.cafpin}}</td>--><!--                        <td>{{caf._source.firstname}} {{caf._source.middlename}} {{caf._source.lastname}}</td>--><!--                        <td>{{caf._source.emailprimary}}</td>--><!--                        <td>{{caf._source.mobilenumber}}</td>--><!--                        <td>{{caf._source.businessentity== "Renewable" ? "Renew" : caf._source.businessentity}}</td>--><!--                        <td>{{caf._source.siteaddress}}</td>--><!--                        <td ng-hide="vm.isDeactivatedRequested">{{caf._source.assignedRM==\'\' ? "Not Assigned" : caf._source.assignedRM}}</td>--><!--                        <td>{{caf._source.district}}</td>--><!--                        <td>{{caf._source.projectlevel=="d" ? "DLCC" : "EEC"}}</td>--><!--                        <td>{{caf._source.totalpurposedemployment}}</td>--><!--                        <td>{{caf._source.haryanadomicile}}</td>--><!--                        <td>{{caf._source.nonharyanadomicile}}</td>--><!--                        <td>{{caf._source.total_project_cost | decimalFormat}}</td>--><!--                        <td>{{caf._source.totalproposedprojectarea}}</td>--><!--                        <td>{{caf._source.sectorname === \'Other Industries\' ? caf._source.otherSector + " - "+ caf._source.sectorname : caf._source.sectorname}}</td>--><!--                        <td>{{caf._source.projectpurpose}}</td>--><!--                        <td>{{caf._source.id}}</td>--><!--                        <td>{{caf._source.applicationdate | date:\'dd-MM-yyyy\'}}</td>--><!--                        <td ng-if="vm.showDeactivationDate">{{caf._source.deactivateddate | date:\'dd-MM-yyyy\'}}</td>--><!--                        <td>{{caf._source.blockCategory}}</td>--><!--                        <td>{{caf._source.investmentType}}</td>--><!--                        <td>{{caf._source.product}}</td>--><!--                        <td>{{caf._source.prodctionStartDate | date:\'dd-MM-yyyy\'}}</td>--><!--                        <td>{{caf._source.foreign_investment !== null ? caf._source.foreign_investment : \'NA\'}}</td>--><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><td>{{caf.investorName}}</td><td>{{caf.investorEmail}}</td><td>{{caf.investorContact}}</td><td>{{caf.businessentity== "Renewable" ? "Renew" : caf.businessentity}}</td><td>{{caf.siteAddress}}</td><td ng-hide="vm.isDeactivatedRequested">{{caf.rmInfo==\'\' ? "Not Assigned" : caf.rmInfo}}</td><td>{{caf.district}}</td><td>{{caf.projectlevel=="d" ? "DLCC" : "EEC"}}</td><td>{{caf.projectemployment}}</td><td>{{caf.haryanadomicile}}</td><td>{{caf.nonharyanadomicile}}</td><td>{{caf.projectinvestment | decimalFormat}}</td><td>{{caf.proposedprojectarea}}</td><td>{{caf.sector === \'Other Industries\' ? caf.otherSector + " - "+ caf.sector : caf.sector}}</td><td>{{caf.projectPurpose}}</td><td>{{caf.projectId}}</td><td>{{caf.applicationdate | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.showDeactivationDate">{{caf.deactivateddate | date:\'dd-MM-yyyy\'}}</td><td>{{caf.blockCategory}}</td><td>{{caf.investmentType}}</td><td>{{caf.product}}</td><td>{{caf.industrialEstate!=null ? "Yes" : "No"}}</td>{{caf.industrialEstate}}<td>{{caf.prodctionStartDate | date:\'dd-MM-yyyy\'}}</td><td>{{caf.foreignInvestment !== null ? caf.foreignInvestment : \'NA\'}}</td></tr></tbody></table></div></div></div></form><style>.glyphicon.spinning {\n        -webkit-animation: spin2 1s infinite linear;\n    }\n    @keyframes spin {\n        from {\n            transform: scale(1) rotate(0deg);\n        }\n        to {\n            transform: scale(1) rotate(360deg);\n        }\n    }\n    @-webkit-keyframes spin2 {\n        from {\n            -webkit-transform: rotate(0deg);\n        }\n        to {\n            -webkit-transform: rotate(360deg);\n        }\n    }</style>');
$templateCache.put('app/dashboardbetweendates/dashboardbetweendates.html','<style>.app-modal-window .modal-dialog {\nwidth: 90%;\n}\n/* Fix input-group button height alignment (Bootstrap 3 + Material Design) */\n.input-group .input-group-btn .btn {\n    height: 34px; /* match default input height */\n    padding-top: 6px;\n    padding-bottom: 6px;\n    line-height: 1.42857143;\n    border-radius: 0 4px 4px 0; /* smooth right corner */\n}\n\n.input-group .form-control {\n    height: 34px;\n    line-height: 1.42857143;\n}</style><div class="container"><jhi-alert></jhi-alert><!--    <div class="row">--><!--&lt;!&ndash;        <button class="btn btn-primary pull-right" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN" ng-disabled="vm.selectedStatus==null || vm.fromdate==null || vm.todate==null" ui-sref="dashboardCAFAllServices({from:vm.fromdate,to:vm.todate,status:vm.selectedStatus})">Download</button>&ndash;&gt;--><!--        <div class="pull-right" style="color: red"><b>*</b> Enter a period of 31 days</div>--><!--    </div>--><br><div class="container mt-3"><!-- ================= Monthwise Filter ================= --><div class="card shadow-sm p-3 mb-4"><div class="card-header bg-primary text-white"><h5 class="mb-0">Month-wise Filter</h5></div><div class="card-body"><div class="row align-items-center"><div class="col-md-2"><label class="form-label fw-bold"><i>Select Month</i></label></div><div class="col-md-4"><div class="input-group"><input id="field_fromMonth" type="text" class="form-control" name="fromMonth" uib-datepicker-popup="MM-yyyy" datepicker-options="vm.dateOptionsOnlyMonth" ng-change="vm.selectedDate(vm.fromMonth)" ng-model="vm.fromMonth" is-open="vm.datePickerOpenStatus.fromMonth"> <span class="input-group-btn"><button type="button" class="btn btn-outline-secondary" ng-click="vm.openCalendar(\'fromMonth\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-2"><select class="form-control" ng-disabled="vm.isloading" ng-change="vm.statusChanged()" ng-model="vm.selectedStatusMonth" ng-options="x for x in vm.status"><option value="">Select</option></select></div><div class="col-md-3"><button class="btn btn-success" ng-disabled="vm.fromMonth==null || vm.selectedStatusMonth==null " ng-click="vm.getServicesBetweenDatesMonthWise()">Get Services</button></div></div></div></div><!-- ================= Datewise Filter ================= --><div class="card shadow-sm p-3"><div class="pull-right" style="color: white"><b>*</b> Enter a period of 31 days</div><div class="card-header bg-primary text-white"><h5 class="mb-0">Date-wise Filter</h5></div><div class="card-body"><div class="row mb-3 align-items-center"><div class="col-md-1"><label class="form-label fw-bold"><i>From</i></label></div><div class="col-md-3"><div class="input-group"><input id="field_fromdate" type="text" class="form-control" name="fromdate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-change="vm.selectedDate(vm.fromdate)" ng-model="vm.fromdate" is-open="vm.datePickerOpenStatus.fromdate"> <span class="input-group-btn"><button style="height: 33px" type="button" class="btn btn-outline-secondary" ng-click="vm.openCalendar(\'fromdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><label class="form-label fw-bold"><i>To</i></label></div><div class="col-md-3"><div class="input-group"><input id="field_todate" type="text" class="form-control" name="todate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions1" ng-model="vm.todate" is-open="vm.datePickerOpenStatus.todate"> <span class="input-group-btn"><button type="button" class="btn btn-outline-secondary" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-2"><select class="form-control" ng-disabled="vm.isloading" ng-change="vm.statusChanged()" ng-model="vm.selectedStatus" ng-options="x for x in vm.status"><option value="">Select</option></select></div><div class="col-md-2"><button class="btn btn-success w-100" ng-disabled="vm.selectedStatus==null || vm.fromdate==null || vm.todate==null" ng-click="vm.getServicesBetweenDates()">Get Services</button></div></div></div></div></div><div class="container" ng-hide="vm.dashboardsbydate==null"><div ng-repeat="dashboard in vm.dashboardsbydate | orderBy:\'deptorder\'" ng-hide="dashboard.departmentName==null"><div class="row"><div class="col-md-11"><h4 class="pull-left">{{dashboard.departmentName}}</h4></div></div><table id="result_table" class="table table-striped table-hover table-responsive"><thead><th class="headerGrid row col-md-2 bg-primary text-center">Service Name</th><th class="headerGrid row col-md-1 bg-primary text-center">{{vm.header}}</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Pending\'">Pending>30</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Pending\'">Pending>45</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Pending\'">Pending>60</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Pending\'">Pending>75</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Pending\'">Pending>90</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Cleared\'">ClearedUnder 30</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Cleared\'">Cleared(30-45)</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Cleared\'">Cleared(45-60)</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Cleared\'">Cleared(60-75)</th><th class="headerGrid row col-md-1 bg-primary text-center" style="color: #0A0A0A" ng-show="vm.header==\'Cleared\'">Cleared(75-90)</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Cleared\'">Cleared>90</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Rejected\'">Rejected>30</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Rejected\'">Rejected>45</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Rejected\'">Rejected>60</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Rejected\'">Rejected>75</th><th class="headerGrid row col-md-1 bg-primary text-center" ng-show="vm.header==\'Rejected\'">Rejected>90</th></thead><tbody><tr ng-repeat="service in dashboard.serviceStats"><td class="col-md-2 bg-success">{{service.servicename}}</td><td class="col-md-1 bg-success text-center"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:vm.selectedStatus,from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.totalcleared}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Pending\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'pendingafter30\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.pendingafter30}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Pending\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'pendingafter45\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.pendingafter45}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Pending\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'pendingafter60\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.pendingafter60}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Pending\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'pendingafter75\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.pendingafter75}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Pending\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'pendingafter90\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.pendingafter90}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Cleared\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'clearedUnder30\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.clearedUnder30}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Cleared\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'cleared30_45\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.cleared30_45}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Cleared\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'cleared45_60\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.cleared45_60}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Cleared\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'cleared60_75\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.cleared60_75}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Cleared\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'cleared75_90\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.cleared75_90}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Cleared\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'clearedAfter90\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.clearedAfter90}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Rejected\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'rejectedafter30\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.rejectedAfter30}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Rejected\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'rejectedafter45\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.rejectedAfter45}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Rejected\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'rejectedafter60\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.rejectedAfter60}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Rejected\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'rejectedafter75\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.rejectedAfter75}}</span></a></td><td class="col-md-1 bg-success text-center" ng-show="vm.header==\'Rejected\'"><a ui-sref="dashboardCAFs({serviceid:service.serviceid,status:\'rejectedafter90\',from:vm.fromDate,to:vm.toDate})"><span class="badge">{{service.rejectedAfter90}}</span></a></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/dashboardbetweendates/dashboardbetweendatesAllServices.html','<div class="modal-header"><div class="row"><div class="col-md-10"><h4>All {{vm.status}} Services From {{vm.fromdate | date:\'dd-MM-yyyy\'}} To {{vm.todate | date:\'dd-MM-yyyy\'}}</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="col-md-1 pull-right"><button ng-show="vm.show" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div><div class="modal-body table-responsive"><table id="result_table" class="table table-striped table-hover"><thead><tr class="headerGrid row"><th>#</th><th>Dept name</th><th>Service Name</th><th>Project Id</th><th>CAF Pin (Composite Application Form)</th><!--                <th>Business Entity</th>--><th>District</th><th>Project Level</th><th>Proposed Employment</th><th>Proposed Investment (in crore)</th><th>SLA</th><th ng-show="vm.status==\'Pending\'"><span>Ageing</span></th><th ng-show="vm.status==\'Applied\'">Applied Date</th><th ng-show="vm.status==\'Cleared\'">Cleared Date</th></tr></thead><tbody><tr class="row" ng-repeat="caf in vm.servicecafs"><td>{{$index+1}}</td><td>{{caf.deptName}}</td><td>{{caf.servicename}}</td><td>{{caf.projectid}}</td><td>{{caf.cafpin}}</td><!--                <td>{{caf.businessentity}}</td>--><td>{{caf.district}}</td><td>{{caf.projectlevel==\'e\'?\'EEC\':\'DLCC\'}}</td><td>{{caf.projectemployment}}</td><td>{{caf.projectinvestment}}</td><td>{{caf.sladays}}</td><td ng-show="vm.status==\'Pending\'">{{(vm.status != \'Pending\' || caf.ageing > 200) ? "NA" : caf.ageing}}</td><td ng-show="vm.status==\'Applied\'">{{(caf.appliedDate==null ? "NA" : caf.appliedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\'">{{(caf.clearedDate==null ? "NA" :caf.clearedDate) | date:\'dd-MM-yyyy\'}}</td></tr></tbody></table></div><div class="modal-footer"><button class="btn btn-danger" ng-click="vm.clear()">Close</button></div></div>');
$templateCache.put('app/dashboardbetweendates/dashboardbetweendatesCAFs.html','<div class="modal-header"><div class="row"><div class="col-md-10"><h4>{{vm.servicecafs[0].servicename}}</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="col-md-1 pull-right"><button ng-show="vm.show" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div><div class="modal-body"><table id="result_table" class="table table-hover table-responsive table-striped"><thead><tr class="headerGrid row"><th>#</th><th>Project Id</th><th>CAF Pin (Composite Application Form)</th><!--                <th>Business Entity</th>--><th>District</th><th>Project Level</th><th>Proposed Employment</th><th>Proposed Investment (in crore)</th><th>SLA</th><th ng-show="vm.status==\'Pending\' || vm.status==\'pendingafter30\' || vm.status==\'pendingafter45\' || vm.status==\'pendingafter60\' || vm.status==\'pendingafter75\' || vm.status==\'pendingafter90\'"><span>Ageing</span></th><th ng-show="vm.status==\'Applied\'">Applied Date</th><th ng-show="vm.status==\'Cleared\' || vm.status==\'clearedUnder30\' || vm.status==\'cleared30_45\' || vm.status==\'cleared45_60\' || vm.status==\'cleared60_75\' || vm.status==\'cleared75_90\' || vm.status==\'clearedAfter90\'">Cleared Date</th></tr></thead><tbody><tr class="row" ng-repeat="caf in vm.servicecafs"><td>{{$index+1}}</td><td>{{caf.projectid}}</td><td>{{caf.cafpin}}</td><!--                <td>{{caf.businessentity}}</td>--><td>{{caf.district}}</td><td>{{caf.projectlevel==\'e\'?\'ELCC\':\'DLCC\'}}</td><td>{{caf.projectemployment}}</td><td>{{caf.projectinvestment}}</td><td>{{caf.sladays}}</td><td ng-show="vm.status==\'Pending\' || vm.status==\'pendingafter30\' || vm.status==\'pendingafter45\' || vm.status==\'pendingafter60\' || vm.status==\'pendingafter75\' || vm.status==\'pendingafter90\'">{{(vm.status != \'Pending\' || caf.ageing > 200) ? "NA" : caf.ageing}}</td><td ng-show="vm.status==\'Applied\'">{{(caf.appliedDate==null ? "NA" : caf.appliedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'clearedUnder30\' || vm.status==\'cleared30_45\' || vm.status==\'cleared45_60\' || vm.status==\'cleared60_75\' || vm.status==\'cleared75_90\' || vm.status==\'clearedAfter90\'">{{(caf.clearedDate==null ? "NA" :caf.clearedDate) | date:\'dd-MM-yyyy\'}}</td></tr></tbody></table></div><div class="modal-footer"><button class="btn btn-danger" ng-click="vm.clear()">Close</button></div></div>');
$templateCache.put('app/deactivateduplicateusers/deactivateuser.html','<div class="container"><form name="userForm"><div class="row form-group"><div class="col-sm-4 col-sm-offset-2"><input type="text" name="userinfo" class="form-control" ng-model="vm.id" placeholder="Enter user\'s ID" required></div><div class="btn-group col-sm-4"><button type="submit" class="btn btn-info" ng-disabled="userForm.userinfo.$invalid" ng-click="vm.getUser(vm.id)">Search</button></div></div><br></form><br><jhi-alert-error></jhi-alert-error><div class="table-responsive" ng-hide="vm.user==undefined"><table class="table table-striped"><thead><tr><th><span>ID</span></th><th><span>Login</span></th><th><span>Email</span></th><th></th><th><span>Lang Key</span></th><th><span>Profiles</span></th><th><span>Create Date</span></th><th><span>Update Date</span></th><th></th></tr></thead><tbody><tr><td><a ui-sref="user-management-detail({login:user.login})">{{vm.user.id}}</a></td><td>{{vm.user.login}}</td><td>{{vm.user.email}}</td><td><span class="label label-danger hand" ng-show="!vm.user.activated">Deactivated</span> <span class="label label-success hand" ng-show="vm.user.activated">Activated</span></td><td>{{vm.user.langKey}}</td><td><div ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td>{{vm.user.createDate | date:\'medium\'}}</td><td>{{vm.user.updateDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" class="btn btn-info btn-sm" ng-show="vm.user.activated" ng-click="vm.deactivate()">Deactivate</button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/decriminalization/decriminalization-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.decriminalization.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.decriminalization.delete.question" translate-values="{id: \'{{vm.decriminalization.id}}\'}">Are you sure you want to delete this Decriminalization?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/decriminalization/decriminalization-detail.html','<div><h2><span data-translate="investhryApp.decriminalization.detail.title">Decriminalization</span> {{vm.decriminalization.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.decriminalization.complianceRequest">Compliance Request</span></dt><dd><span>{{vm.decriminalization.complianceRequest}}</span></dd><dt><span data-translate="investhryApp.decriminalization.departmentName">Department Name</span></dt><dd><span>{{vm.decriminalization.departmentName}}</span></dd><dt><span data-translate="investhryApp.decriminalization.departmentId">Department Id</span></dt><dd><span>{{vm.decriminalization.departmentId}}</span></dd><dt><span data-translate="investhryApp.decriminalization.serviceType">Service Type</span></dt><dd><span>{{vm.decriminalization.serviceType}}</span></dd><dt><span data-translate="investhryApp.decriminalization.otherServiceType">Other Service Type</span></dt><dd><span>{{vm.decriminalization.otherServiceType}}</span></dd><dt><span data-translate="investhryApp.decriminalization.serviceSchemeName">Service Scheme Name</span></dt><dd><span>{{vm.decriminalization.serviceSchemeName}}</span></dd><dt><span data-translate="investhryApp.decriminalization.actName">Act Name</span></dt><dd><span>{{vm.decriminalization.actName}}</span></dd><dt><span data-translate="investhryApp.decriminalization.ruleRegulation">Rule Regulation</span></dt><dd><span>{{vm.decriminalization.ruleRegulation}}</span></dd><dt><span data-translate="investhryApp.decriminalization.ruleRegulationName">Rule Regulation Name</span></dt><dd><span>{{vm.decriminalization.ruleRegulationName}}</span></dd><dt><span data-translate="investhryApp.decriminalization.sectionRuleNumber">Section Rule Number</span></dt><dd><span>{{vm.decriminalization.sectionRuleNumber}}</span></dd><dt><span data-translate="investhryApp.decriminalization.sectionRuleNumberCriminalProvision">Section Rule Number Criminal Provision</span></dt><dd><span>{{vm.decriminalization.sectionRuleNumberCriminalProvision}}</span></dd><dt><span data-translate="investhryApp.decriminalization.criminalPunishmentDescription">Criminal Punishment Description</span></dt><dd><span>{{vm.decriminalization.criminalPunishmentDescription}}</span></dd><dt><span data-translate="investhryApp.decriminalization.sector">Sector</span></dt><dd><span>{{vm.decriminalization.sector}}</span></dd><dt><span data-translate="investhryApp.decriminalization.otherSector">Other Sector</span></dt><dd><span>{{vm.decriminalization.otherSector}}</span></dd><dt><span data-translate="investhryApp.decriminalization.offence">Offence</span></dt><dd><span>{{vm.decriminalization.offence}}</span></dd><dt><span data-translate="investhryApp.decriminalization.criminalPunishmentTenureInMonths">Criminal Punishment Tenure In Months</span></dt><dd><span>{{vm.decriminalization.criminalPunishmentTenureInMonths}}</span></dd><dt><span data-translate="investhryApp.decriminalization.minimumTenure">Minimum Tenure</span></dt><dd><span>{{vm.decriminalization.minimumTenure}}</span></dd><dt><span data-translate="investhryApp.decriminalization.maximumTenure">Maximum Tenure</span></dt><dd><span>{{vm.decriminalization.maximumTenure}}</span></dd><dt><span data-translate="investhryApp.decriminalization.criminalPunishmentAmountInInr">Criminal Punishment Amount In Inr</span></dt><dd><span>{{vm.decriminalization.criminalPunishmentAmountInInr}}</span></dd><dt><span data-translate="investhryApp.decriminalization.minimumAmount">Minimum Amount</span></dt><dd><span>{{vm.decriminalization.minimumAmount}}</span></dd><dt><span data-translate="investhryApp.decriminalization.maximumAmount">Maximum Amount</span></dt><dd><span>{{vm.decriminalization.maximumAmount}}</span></dd><dt><span data-translate="investhryApp.decriminalization.createDate">Create Date</span></dt><dd><span>{{vm.decriminalization.createDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.decriminalization.updateDate">Update Date</span></dt><dd><span>{{vm.decriminalization.updateDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.decriminalization.sectorId">Sector Id</span></dt><dd><span>{{vm.decriminalization.sectorId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="decriminalization-detail.edit({id:vm.decriminalization.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/decriminalization/decriminalization-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDecriminalizationLabel" data-translate="investhryApp.decriminalization.home.createOrEditLabel">Create or edit a Decriminalization</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.decriminalization.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.decriminalization.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.complianceRequest" for="field_complianceRequest">Compliance Request</label><input type="text" class="form-control" name="complianceRequest" id="field_complianceRequest" ng-model="vm.decriminalization.complianceRequest"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.decriminalization.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.departmentId" for="field_departmentId">Department Id</label><input type="text" class="form-control" name="departmentId" id="field_departmentId" ng-model="vm.decriminalization.departmentId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.serviceType" for="field_serviceType">Service Type</label><input type="text" class="form-control" name="serviceType" id="field_serviceType" ng-model="vm.decriminalization.serviceType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.otherServiceType" for="field_otherServiceType">Other Service Type</label><input type="text" class="form-control" name="otherServiceType" id="field_otherServiceType" ng-model="vm.decriminalization.otherServiceType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.serviceSchemeName" for="field_serviceSchemeName">Service Scheme Name</label><input type="text" class="form-control" name="serviceSchemeName" id="field_serviceSchemeName" ng-model="vm.decriminalization.serviceSchemeName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.actName" for="field_actName">Act Name</label><input type="text" class="form-control" name="actName" id="field_actName" ng-model="vm.decriminalization.actName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.ruleRegulation" for="field_ruleRegulation">Rule Regulation</label><input type="text" class="form-control" name="ruleRegulation" id="field_ruleRegulation" ng-model="vm.decriminalization.ruleRegulation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.ruleRegulationName" for="field_ruleRegulationName">Rule Regulation Name</label><input type="text" class="form-control" name="ruleRegulationName" id="field_ruleRegulationName" ng-model="vm.decriminalization.ruleRegulationName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.sectionRuleNumber" for="field_sectionRuleNumber">Section Rule Number</label><input type="text" class="form-control" name="sectionRuleNumber" id="field_sectionRuleNumber" ng-model="vm.decriminalization.sectionRuleNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.sectionRuleNumberCriminalProvision" for="field_sectionRuleNumberCriminalProvision">Section Rule Number Criminal Provision</label><input type="text" class="form-control" name="sectionRuleNumberCriminalProvision" id="field_sectionRuleNumberCriminalProvision" ng-model="vm.decriminalization.sectionRuleNumberCriminalProvision"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.criminalPunishmentDescription" for="field_criminalPunishmentDescription">Criminal Punishment Description</label><input type="text" class="form-control" name="criminalPunishmentDescription" id="field_criminalPunishmentDescription" ng-model="vm.decriminalization.criminalPunishmentDescription"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.sector" for="field_sector">Sector</label><input type="text" class="form-control" name="sector" id="field_sector" ng-model="vm.decriminalization.sector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.otherSector" for="field_otherSector">Other Sector</label><input type="text" class="form-control" name="otherSector" id="field_otherSector" ng-model="vm.decriminalization.otherSector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.offence" for="field_offence">Offence</label><input type="text" class="form-control" name="offence" id="field_offence" ng-model="vm.decriminalization.offence"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.criminalPunishmentTenureInMonths" for="field_criminalPunishmentTenureInMonths">Criminal Punishment Tenure In Months</label><input type="text" class="form-control" name="criminalPunishmentTenureInMonths" id="field_criminalPunishmentTenureInMonths" ng-model="vm.decriminalization.criminalPunishmentTenureInMonths"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.minimumTenure" for="field_minimumTenure">Minimum Tenure</label><input type="text" class="form-control" name="minimumTenure" id="field_minimumTenure" ng-model="vm.decriminalization.minimumTenure"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.maximumTenure" for="field_maximumTenure">Maximum Tenure</label><input type="text" class="form-control" name="maximumTenure" id="field_maximumTenure" ng-model="vm.decriminalization.maximumTenure"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.criminalPunishmentAmountInInr" for="field_criminalPunishmentAmountInInr">Criminal Punishment Amount In Inr</label><input type="text" class="form-control" name="criminalPunishmentAmountInInr" id="field_criminalPunishmentAmountInInr" ng-model="vm.decriminalization.criminalPunishmentAmountInInr"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.minimumAmount" for="field_minimumAmount">Minimum Amount</label><input type="text" class="form-control" name="minimumAmount" id="field_minimumAmount" ng-model="vm.decriminalization.minimumAmount"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.maximumAmount" for="field_maximumAmount">Maximum Amount</label><input type="text" class="form-control" name="maximumAmount" id="field_maximumAmount" ng-model="vm.decriminalization.maximumAmount"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.createDate" for="field_createDate">Create Date</label><div class="input-group"><input id="field_createDate" type="text" class="form-control" name="createDate" datetime-picker="{{dateformat}}" ng-model="vm.decriminalization.createDate" is-open="vm.datePickerOpenStatus.createDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.updateDate" for="field_updateDate">Update Date</label><div class="input-group"><input id="field_updateDate" type="text" class="form-control" name="updateDate" datetime-picker="{{dateformat}}" ng-model="vm.decriminalization.updateDate" is-open="vm.datePickerOpenStatus.updateDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updateDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.sectorId" for="field_sectorId">Sector Id</label><input type="text" class="form-control" name="sectorId" id="field_sectorId" ng-model="vm.decriminalization.sectorId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/decriminalization/decriminalizations.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Decriminalization Form</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Decriminalization Form</span></li></ol></div></section><br><div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Decriminalization Form</h3></div><div class="panel-body"><!--            <h6 class="text-danger">* The list of approvals is comprehensive and as per the details provided by the user.</h6>--><!--            <h5 >Please fill the detail to know the list of clearance you require for setting up--><!--                an industry in haryana.<button type="submit" class="btn btn-warning pull-right" ui-sref="allclearances">View All Clearances</button></h5>--><form class="form-horizontal" name="editForm" role="form" ng-submit="vm.save()"><div class="col-md-12"></div><!--                <div class="form-group">--><!--&lt;!&ndash;                    <label class="col-sm-1 control-label pull-left">1.</label>&ndash;&gt;--><!--                    <label class="col-lg-3 control-label pull-left">Compliance Request Interface <span--><!--                        style="color:red">*</span></label>--><!--                    <div class="col-lg-6">--><!--                        <input type="radio" ng-click="requestInterface(\'Business\')"  ng-model="vm.decriminalization.complianceRequest"  name="complianceRequest" value="Business"/>Business--><!--                        <input type="radio" ng-click="requestInterface(\'Citizen\')"  ng-model="vm.decriminalization.complianceRequest" name="complianceRequest" value="Citizen"/>Citizen--><!--                    </div>--><!--                </div>--><div class="form-group"><!--                    <label class="col-sm-1 control-label pull-left">2.</label>--><label class="col-lg-3 control-label pull-">Select Department <span style="color:red">*</span></label><div class="col-lg-6"><select class="form-control" ng-model="vm.decriminalization.departmentId"><option value="" disabled="disabled" selected="selected">Select Department</option><option ng-repeat="department in vm.departments" value="{{department.id}}">{{department.departmentname}}</option></select></div></div><!--                <div class="form-group" ng-if="vm.showServiceType">--><!--&lt;!&ndash;                    <label class="col-sm-1 control-label pull-left">3.</label>&ndash;&gt;--><!--                    <label class="col-lg-3 control-label pull-left">Service Type <span--><!--                        style="color:red">*</span></label>--><!--                    <div class="col-lg-6">--><!--                        <select class="form-control" ng-change="serviceTypeCheck()"  ng-model="vm.decriminalization.serviceType">--><!--                            <option value="" disabled selected>Select Service</option>--><!--                            <option  value="Certificate/ NoC/ Licences">Certificate/ NoC/ Licences</option>--><!--                            <option  value="Information Services">Information Services</option>--><!--                            <option  value="Payments/ Receipts">Payments/ Receipts</option>--><!--                            <option  value="Schemes/ Subsidies/ Benefits/ Grants">Schemes/ Subsidies/ Benefits/ Grants</option>--><!--                            <option  value="Partnership">Feedback/ Consultation</option>--><!--                            <option  value="Other">Other</option>--><!--                        </select>--><!--                    </div>--><!--                    <button class="btn btn-default btn-circle" uk-toggle="target: #serviceTypeTooltip" title="More info...">--><!--                        <span uk-toggle="target: #serviceTypeTooltip" class="glyphicon glyphicon-question-sign"></span>--><!--                    </button>--><!--                </div>--><!--                <div class="form-group" ng-if="vm.showOtherServiceType" >--><!--&lt;!&ndash;                    <label class="col-sm-1 control-label pull-left">4.</label>&ndash;&gt;--><!--                    <label class="col-lg-3 control-label pull-left">Other Service Type <span--><!--                        style="color:red">*</span></label>--><!--                    <div class="col-lg-6">--><!--                        <textarea class="form-control" maxlength="500" placeholder="Enter Other Service Type. Max-length: 500" ng-model="vm.decriminalization.otherServiceType" ></textarea>--><!--                    </div>--><!--                </div>--><!--                <div class="form-group" ng-if="vm.showServiceName">--><!--&lt;!&ndash;                    <label class="col-sm-1 control-label pull-left">5.</label>&ndash;&gt;--><!--                    <label class="col-lg-3 control-label pull-left">Name of Service/Scheme <span--><!--                        style="color:red">*</span></label>--><!--                    <div class="col-lg-6">--><!--                        <textarea class="form-control" maxlength="500" placeholder="Enter Service/Scheme Name. Max-length: 500" ng-model="vm.decriminalization.serviceSchemeName"></textarea>--><!--                    </div>--><!--                </div>--><div class="form-group"><!--                    <label class="col-sm-1 control-label pull-left">6.</label>--><label class="col-lg-3 control-label pull-left">Act Name <span style="color:red" ng-if="vm.showSector">*</span></label><div class="col-lg-6"><textarea class="form-control" maxlength="1000" placeholder="Type an Act/Policy. Max-length: 1000" ng-model="vm.decriminalization.actName"></textarea></div><button class="btn btn-default btn-circle" uk-toggle="target: #actNameTooltip" title="More info..."><span uk-toggle="target: #actNameTooltip" class="glyphicon glyphicon-question-sign"></span></button></div><!--                <div class="form-group">--><!--&lt;!&ndash;                    <label class="col-sm-1 control-label pull-left">7.</label>&ndash;&gt;--><!--                    <label class="col-lg-3 control-label pull-left">Rule Regulation <span--><!--                        style="color:red">*</span></label>--><!--                    <div class="col-lg-6">--><!--                        <select class="form-control" ng-model="vm.decriminalization.ruleRegulation">--><!--                            <option value="" disabled selected>Select Rule Regulation</option>--><!--                            <option value="Proprietary">Rules</option>--><!--                            <option value="Public">Notifications</option>--><!--                            <option value="Private Ltd">Schedule</option>--><!--                            <option value="Partnership">Guidelines</option>--><!--                            <option value="Partnership">Order</option>--><!--                            <option value="Partnership">Other</option>--><!--                        </select>--><!--                    </div>--><!--                </div>--><!--                <div class="form-group">--><!--&lt;!&ndash;                    <label class="col-sm-1 control-label pull-left">8.</label>&ndash;&gt;--><!--                    <label class="col-lg-3 control-label pull-left">Rule/Regulation Name <span--><!--                        style="color:red">*</span></label>--><!--                    <div class="col-lg-6">--><!--                        <textarea class="form-control" maxlength="1000" placeholder="Max-length: 1000" ng-model="vm.decriminalization.ruleRegulationName"></textarea>--><!--                    </div>--><!--                </div>--><!--                <div class="form-group">--><!--&lt;!&ndash;                    <label class="col-sm-1 control-label pull-left">9.</label>&ndash;&gt;--><!--                    <label class="col-lg-3 control-label pull-left">Section/Rule number  <span--><!--                        style="color:red">*</span></label>--><!--                    <div class="col-lg-6">--><!--                        <select class="form-control" ng-model="vm.decriminalization.sectionRuleNumber">--><!--                            <option value="" disabled selected>Select Rule number</option>--><!--                            <option value="Sections">Sections</option>--><!--                            <option value="Rules">Rules</option>--><!--                            <option value="Regulations">Regulations</option>--><!--                            <option value="Notifications">Notifications</option>--><!--                            <option value="Schedule">Schedule</option>--><!--                            <option value="Guidelines">Guidelines</option>--><!--                            <option value="Order">Order</option>--><!--                            <option value="Other">Other</option>--><!--                        </select>--><!--                    </div>--><!--                </div>--><!--                <div class="form-group">--><!--&lt;!&ndash;                    <label class="col-sm-1 control-label pull-left">10.</label>&ndash;&gt;--><!--                    <label class="col-lg-3 control-label pull-left">Section/Rule number of Criminal Provision  <span--><!--                        style="color:red">*</span></label>--><!--                    <div class="col-lg-6">--><!--                        <textarea class="form-control" ng-model="vm.decriminalization.sectionRuleNumberCriminalProvision" maxlength="500" placeholder="Section/Rule number that prescribe Criminal Punishment. Max-lengh: 500" ></textarea>--><!--                    </div>--><!--                    <button class="btn btn-default btn-circle" uk-toggle="target: #sectionRuleTooltip" title="More info...">--><!--                        <span uk-toggle="target: #sectionRuleTooltip" class="glyphicon glyphicon-question-sign"></span>--><!--                    </button>--><!--                </div>--><div class="form-group"><!--                    <label class="col-sm-1 control-label pull-left">11.</label>--><label class="col-lg-3 control-label pull-left">Criminal Punishment Description <span style="color:red">*</span></label><div class="col-lg-6"><textarea class="form-control" maxlength="3000" placeholder="Enter Criminal Punishment Description. Max-length: 3000 " ng-model="vm.decriminalization.criminalPunishmentDescription" rows="5"></textarea></div><button class="btn btn-default btn-circle" uk-toggle="target: #criminalPunishmentTooltip" title="More info..."><span uk-toggle="target: #criminalPunishmentTooltip" class="glyphicon glyphicon-question-sign"></span></button></div><div class="form-group" ng-if="vm.showSector"><!--                    <label class="col-sm-1 control-label pull-left">12.</label>--><label class="col-lg-3 control-label pull-left">Sector <span style="color:red">*</span></label><div class="col-lg-6"><select class="form-control" ng-click="otherSectorCheck()" ng-model="vm.decriminalization.sector"><option value="" disabled="disabled" selected="selected">Select Sector</option><option value="steel">Steel</option><option value="aluminium">Aluminium</option><option value="agro-clusters">Agro-Clusters</option><option value="ready-to-eat">Ready to Eat</option><option value="electronics-components">Electronics Components</option><option value="agro-chemicals">Agro-Chemicals</option><option value="textiles">Textiles</option><option value="air-conditioners">Air Conditioners</option><option value="leather">Leather</option><option value="auto-components">Auto Components</option><option value="fisheries">Fisheries</option><option value="furniture">Furniture</option><option value="ev-components-integrated-circuits">EV Components & Integrated Circuits</option><option value="ethanol">Ethanol</option><option value="ceramics">Ceramics</option><option value="set-top-boxes">Set top Boxes</option><option value="robotics">Robotics</option><option value="televisions">Televisions</option><option value="cctvs">CCTVs</option><option value="toys">Toys</option><option value="drones-drone-components">Drones and drone components</option><option value="medical-devices">Medical devices</option><option value="sporting-goods">Sporting Goods</option><option value="gym-equipment">Gym Equipment</option><option value="across-all-sectors">Across all Sectors</option><option value="mobile-manufacturing">Mobile Manufacturing and Specified Electronic Components (Large Scale Electronics Manufacturing)</option><option value="manufacturing-medical-devices">Manufacturing of Medical Devices</option><option value="advanced-chemistry-cell-battery">Advanced Chemistry Cell (ACC) Battery</option><option value="electronic-technology-products">Electronic/Technology Products (IT Hardware)</option><option value="automobiles-auto-components">Automobiles and Auto Components</option><option value="pharmaceuticals-drugs">Pharmaceuticals Drugs</option><option value="telecom-networking-products">Telecom & Networking Products</option><option value="textile-products-mmf-technical">Textile Products: MMF segment and technical textiles</option><option value="food-products">Food Products</option><option value="high-efficiency-solar-pv-modules">High efficiency solar PV modules</option><option value="white-goods-ac-leds">White Goods (ACs and LEDs)</option><option value="specialty-steel">Specialty Steel</option><option value="Other">Other</option></select></div></div><div class="form-group" ng-if="vm.showOtherSector"><!--                    <label class="col-sm-1 control-label pull-left">13.</label>--><label class="col-lg-3 control-label pull-left">Other sector <span style="color:red">*</span></label><div class="col-lg-6"><textarea class="form-control" maxlength="500" placeholder="Enter Other Sector Name. Max-length: 500" ng-model="vm.decriminalization.otherSector"></textarea></div></div><div class="form-group"><!--                    <label class="col-sm-1 control-label pull-left">14.</label>--><label class="col-lg-3 control-label pull-left">Frequency of Offense <span style="color:red">*</span></label><div class="col-lg-6"><select class="form-control" ng-model="vm.decriminalization.offence"><option value="" disabled="disabled" selected="selected">Select Offence</option><option value="First Offence">First Offence</option><option value="Second Offence / Subsequent Offence">Second Offence / Subsequent Offence</option><option value="Not Applicable">Not Applicable</option></select></div></div><div class="form-group"><!--                    <label class="col-sm-1 control-label pull-left">15.</label>--><label class="col-lg-3 control-label pull-left">Criminal Punishment Tenure in months <span style="color:red">*</span></label><div class="col-lg-6"><select class="form-control" ng-change="crimePunMonths()" ng-model="vm.decriminalization.criminalPunishmentTenureInMonths"><option value="" disabled="disabled" selected="selected">Select Criminal Punishment Tenure in months</option><option value="Enter months">Enter months</option><!--                            <option  value="Death Penalty">Death Penalty</option>--><option value="Life Imprisonment">Life Imprisonment</option><!--                            <option  value="Rigorous imprisonment for life">Rigorous imprisonment for life</option>--><!--                            <option  value="Not Defined">Not Defined</option>--></select></div><button class="btn btn-default btn-circle" uk-toggle="target: #tenureTooltip" title="More info..."><span uk-toggle="target: #tenureTooltip" class="glyphicon glyphicon-question-sign"></span></button></div><div class="form-group"><!--                    <label class="col-sm-1 control-label pull-left">16.</label>--><label class="col-lg-3 control-label pull-left">Minimum Tenure <span style="color:red">*</span></label><div class="col-lg-6"><input type="number" min="0" class="form-control" ng-model="vm.decriminalization.minimumTenure" ng-disabled="vm.disableMinTenure" placeholder="Enter Minimum Tenure"></div></div><div class="form-group"><!--                    <label class="col-sm-1 control-label pull-left">17.</label>--><label class="col-lg-3 control-label pull-left">Maximum Tenure <span style="color:red">*</span></label><div class="col-lg-6"><input type="number" min="0" class="form-control" ng-model="vm.decriminalization.maximumTenure" ng-disabled="vm.disableMaxTenure" placeholder="Enter Maximum Tenure"></div></div><div class="form-group"><!--                    <label class="col-sm-1 control-label pull-left">18.</label>--><label class="col-lg-3 control-label pull-left">Criminal Punishment Amount in INR <span style="color:red">*</span></label><div class="col-lg-6"><select class="form-control" ng-change="crimePunAmount()" ng-model="vm.decriminalization.criminalPunishmentAmountInInr"><option value="" disabled="disabled" selected="selected">Select Criminal Punishment Amount in INR</option><option value="Enter Amount">Enter Amount</option><option value="Not Defined">Not Defined</option></select></div><button class="btn btn-default btn-circle" uk-toggle="target: #amountTooltip" title="More info..."><span uk-toggle="target: #amountTooltip" class="glyphicon glyphicon-question-sign"></span></button></div><div class="form-group"><!--                    <label class="col-sm-1 control-label pull-left">19.</label>--><label class="col-lg-3 control-label pull-left">Minimum Amount <span style="color:red">*</span></label><div class="col-lg-6"><input type="number" class="form-control" ng-model="vm.decriminalization.minimumAmount" ng-disabled="vm.disableMinAmount" placeholder="Enter Minimum Amount"></div></div><div class="form-group"><!--                    <label class="col-sm-1 control-label pull-left">20.</label>--><label class="col-lg-3 control-label pull-left">Maximum Amount <span style="color:red">*</span></label><div class="col-lg-6"><input type="number" class="form-control" ng-model="vm.decriminalization.maximumAmount" ng-disabled="vm.disableMaxAmount" placeholder="Enter Maximum Amount"></div></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></div></form></div></div></div><div id="serviceTypeTooltip" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1"><tbody><tr><td><b>1. CERTIFICATES/NOC/LICENSES/REGISTRATIONS/ATTESTATION:</b> Statutory certificates and documents issued by the Government e.g. Birth Certificate, Income Certificate, Driving licence, Passport, Aadhar etc.</td></tr><tr><td><b>2. FEEDBACK/CONSULTATIONS:</b> Feedback or grievances logged by the citizens in relation to any particular service or scheme</td></tr><tr><td><b>3. INFORMATIONAL SERVICES:</b> Knowledge/information on various Govt. programs or schemes, application status tracking, warnings and guidelines issued by the Government</td></tr><tr><td><b>4. RECEIPTS/PAYMENTS:</b> Transactions which include payment from citizens to government like payment of taxes, utility bills etc.</td></tr><tr><td><b>5. SUBSIDIES/SCHEMES/BENEFITS/GRANTS:</b> Recurring government disbursements to citizens like social pensions, MNREGA payment, DBT, scholarships etc.</td></tr></tbody></table></div></div></div><div id="actNameTooltip" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1"><tbody><tr><td>Mention the full Name of the Act/Policy as notified.</td></tr><tr><td>Example - \u201CThe Kerla Ground Water (Control & Regulation), Act, 2022\u201D Please do not write it in short form or in any other format such as \u201CABC & S ACT 1988\u201D</td></tr></tbody></table></div></div></div><div id="sectionRuleTooltip" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1"><tbody><tr><td>Please mention section number only as stated in the example and do not write any other text in in the box such as \u201CABC & S ACT 1988-Section 43A\u201D</td></tr></tbody></table></div></div></div><div id="criminalPunishmentTooltip" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1"><tbody><tr><td>\u2022 Describe the details of the provision which contains the Criminal punishment prescribed in Section/Rule of the Act. Example - Unauthorized digging or construction or use of wells, with imprisonment upto six months or a fine which may extend to ten thousand rupee for the second or subsequent offences</td></tr></tbody></table></div></div></div><div id="tenureTooltip" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1"><tbody><tr><td>Please enter numbers only. If there is no punishment in months, then mention \u20180\u2019 numeric value in the box</td></tr></tbody></table></div></div></div><div id="amountTooltip" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1"><tbody><tr><td>Please enter numbers only. If there is no punishment amount in INR then mention \u20180\u2019 numeric value in the box.</td></tr><tr><td>Not Applicable: Fine is there but it is at the discretion of the competent authority.</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/decriminalization/view-decriminalizations.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">View Decriminalization Form</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>View Decriminalization Form</span></li></ol></div></section><br><div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">View Decriminalization Form</h3></div><div class="panel-body"><!--            <h6 class="text-danger">* The list of approvals is comprehensive and as per the details provided by the user.</h6>--><!--            <h5 >Please fill the detail to know the list of clearance you require for setting up--><!--                an industry in haryana.<button type="submit" class="btn btn-warning pull-right" ui-sref="allclearances">View All Clearances</button></h5>--><form class="form-horizontal" name="editForm" role="form"><div class="col-md-12"><div class="form-group"><label class="col-sm-1 control-label pull-left">1.</label><label class="col-lg-3 control-label pull-left">Department Name <span class="text-danger">*</span></label><div class="col-md-6"><select class="form-control" ng-model="vm.decriminalization.departmentId" required><option value="">Select Department</option><option value="">All Department</option><option value="a65ccd5c-cb40-4d2c-8400-923f52377284">LABOUR DEPARTMENT - LABOUR WING</option><option value="c4c7a500-03d8-454a-b27d-1be87f6349aa">MUNICIPAL CORPORATION</option><option value="27e5ed82-8f29-466f-98fd-68efe6823a50">PWD (B & R) DEPARTMENT</option><option value="829faa03-1039-437e-adac-185e5b47ee6f">DAKSHIN HARYANA BIJLI VITRAN NIGAM</option><option value="2c360927-0c00-4f34-9310-3e69535f999a">HARYANA URBAN DEVELOPMENT AUTHORITY</option><option value="006ea6d0-98f2-4dfe-bdc9-dc7bdfad9df9">TOWN & COUNTRY PLANNING</option><option value="6f061dbe-22c4-4952-91a9-df7b091b9113">ZILA PARISHAD</option><option value="98d01743-a1c6-4fc8-a094-b243efa2f10d">FOOD & SUPPLIES DEPARTMENT</option><option value="4ca05fe6-206a-483d-8bec-4c2d80b0f510">MUNICIPAL COMMITTEE</option><option value="4ba94361-021a-4a62-84ab-2da2492bf932">MUNICIPAL COUNCIL</option><option value="bb845590-d47a-407a-992c-f7065e69e592">HARYANA STATE POLLUTION CONTROL BOARD</option><option value="3b156a83-e39a-4c2c-8a5f-6820258ab9a2">UTTAR HARYANA BIJLI VITRAN NIGAM</option><option value="4a6b3155-80e1-41b0-93df-cddd090b07a7">Electronics and Information Technology</option><option value="96f63c52-f719-4d90-9a4f-3000da5ae0b9">Airport Authority of India</option><option value="fef4feb0-44da-4209-8e33-b32cc9a40850">URBAN LOCAL BODIES</option><option value="a8d5154a-e19b-4bd5-aa38-06986fb045de">HARYANA STATE MARKETING BOARD</option><option value="05013274-891d-4955-bfca-0159e7da53fc">DEPARTMENT OF AYUSH</option><option value="e88df516-4e1d-432a-ab9d-a091b67e1648">National Monument Authority</option><option value="cc705753-bed5-40d7-90a9-857bb0ecca6d">HOME DEPARTMENT</option><option value="5cb21fc4-e3d6-43d7-b69b-e494673bdcfb">ENVIRONMENT</option><option value="638eeaa4-b069-4417-a198-ad5373cc4d18">CHIEF ELECTRICAL INSPECTOR</option><option value="2936b5f9-2e85-449d-9c0f-f1fc4b1212f6">DEPARTMENT OF INDUSTRIES & COMMERCE</option><option value="ee66184a-a1dc-4c92-92d7-7fb53d052292">PUBLIC HEALTH ENGINEERING DEPARTMENT</option><option value="73628252-5b0d-4236-b943-98885fce7bc3">EXCISE & TAXATION - EXCISE</option><option value="b55a377b-33bc-42c8-8361-021438cd4d1e">MINES & GEOLOGY DEPARTMENT</option><option value="3bb27193-61c4-4433-b2a6-d5b4ab1e3b2c">DEPARTMENT OF FORESTS & WILDLIFE</option><option value="e832a828-192e-4029-bce4-8cfe9fb2da58">Development and Panchayats</option><option value="ce8611d6-8e84-416c-b9ba-7818463005ff">Food and Drug Administration</option><option value="550e2870-9403-4050-bf5c-0c790c41ed19">HARYANA STATE INDUSTRIAL & INFRASTRUCTURE DEVELOPMENT CORPORATION LTD</option><option value="c262bb82-b002-42c1-b791-023f91c7e17a">DEPARTMENT OF RENEWABLE ENERGY</option><option value="24cf7139-3a30-4862-842d-b9b33f2cfb6c">PANCHAYAT</option><option value="97909540-e982-46fd-88ee-64ed89dc74d4">LABOUR DEPARTMENT - FACTORY WING</option><option value="aad03c60-ac6c-4266-8b35-42a5abaeaae5">IRRIGATION</option><option value="0364ac85-c3ed-4b49-ab6d-a0526b7cd20b">REVENUE</option><option value="29ed0e3a-4d4c-4a0a-a3fb-09ccef8b9368">DEPARTMENT OF AGRICULTURE</option></select></div></div><!--                    //<label class="col-sm-1 control-label pull-left">1.</label>--><!--                    <div class="col-md-6">--><!--                        <select class="form-control" ng-model="vm.decriminalization.actName">--><!--                            <option value="">Select Act</option>--><!--                            <option ng-repeat="decriminalization in vm.decriminalization"  >{{decriminalization.actName}}</option>--><!--                            &lt;!&ndash;                            <option ng-repeat="department in vm.departments" value="{{department.id}}">&ndash;&gt;--><!--                            &lt;!&ndash;                                {{department.departmentname}}&ndash;&gt;--><!--                            &lt;!&ndash;                            </option>&ndash;&gt;--><!--                        </select>--><!--                    </div>--><div class="form-group"><label class="col-sm-1 control-label pull-left">2.</label><label class="col-lg-3 control-label pull-left">Select Act<span class="text-danger">*</span></label><div class="col-lg-6"><select class="form-control" ng-model="vm.decriminalization.actName" required><option value="" disabled="disabled">Select Act</option><option ng-repeat="decriminalization in vm.decriminalization | unique: \'actName\'" value="{{decriminalization.actName}}">{{decriminalization.actName}}</option></select></div></div><!--                    <div class="form-group">--><!--                        <label class="col-sm-1 control-label pull-left">3.</label>--><!--                        <label class="col-lg-3 control-label pull-left">Risk category </label>--><!--                        <div class="col-lg-6">--><!--                            <select name="riskCategory" class="form-control" ng-model="vm.checklistAvailability.riskCategory">--><!--                                <option value="" disabled selected>Select Risk category</option>--><!--                                <option value="Low">Low</option>--><!--                                <option value="Medium">Medium</option>--><!--                                <option value="High">High</option>--><!--                                <option value="NA">NA</option>--><!--                            </select>--><!--                        </div>--><!--                    </div>--><div class="form-group"><label class="col-sm-1 control-label pull-left">3.</label><label class="col-lg-3 control-label pull-left">Size of firm</label><div class="col-lg-6"><select name="sizeOfFirm" class="form-control" ng-model="vm.checklistAvailability.sizeOfFirm"><option value="" disabled="disabled" selected="selected">Select Size Of Firm</option><option value="Small - more than 25 lakhs and less than or upto 5 crores">Small - more than 25 lakhs and less than or upto 5 crores</option><option value="Micro - upto 25 lakhs">Micro - upto 25 lakhs</option><option value="Medium - more than 5 crores and less than or upto 10 crores">Medium - more than 5 crores and less than or upto 10 crores</option><option value="Large - more than 10 crores and less than or upto 100 crores">Large - more than 10 crores and less than or upto 100 crores</option><option value="Mega - more than 100 crores">Mega - more than 100 crores</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">4.</label><label class="col-lg-3 control-label pull-left">District</label><div class="col-lg-6"><select class="form-control" id="district" ng-model="vm.decriminalizations.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy: \'districtname\'" required ng-change="vm.getVillages(vm.decriminalizations.district)"><option value="" disabled="disabled">Select District</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">5.</label><label class="col-lg-3 control-label pull-left">Village</label><div class="col-lg-6"><input type="text" class="form-control" id="village" placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.proj.district === null" ng-model="vm.decriminalization.village" ng-change="vm.setBlockCategory(vm.decriminalization.village,vm.villages)"><datalist id="villages"><option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option></datalist></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">6.</label><label class="col-lg-3 control-label pull-left">Business location/Block Code</label><div class="col-lg-6"><select class="form-control" id="blockCategory" ng-model="vm.decriminalization.blockCategory"><option value="">Select Block</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option></select></div></div><!--                    <div class="form-group">--><!--                        <label class="col-sm-1 control-label pull-left">8.</label>--><!--                        <label class="col-lg-3 control-label pull-left">Investor Type </label>--><!--                        <div class="col-lg-6">--><!--                            <select name="investorType" class="form-control" ng-model="vm.checklistAvailability.investorType" >--><!--                                <option value="" disabled selected>Select Investor Type</option>--><!--                                <option value="Foreign">Foreign</option>--><!--                                <option value="Domestic">Domestic</option>--><!--                            </select>--><!--                        </div>--><!--                    </div>--><div class="col-md-2"><button ng-click="searchForm()" type="button" class="btn btn-primary btn-sm" ng-disabled="!vm.decriminalization.departmentId || !vm.decriminalization.actName">Search&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-6 col-md-offset-4 text-right"><button ng-click="vm.download()" type="button" class="btn btn-primary btn-sm" ng-disabled="!vm.decriminalization.departmentId || !vm.decriminalization.actName">Excel&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button> <button ng-click="vm.downloadPDF()" type="button" class="btn btn-primary btn-sm" style="margin-left: 10px" ng-disabled="!vm.decriminalization.departmentId || !vm.decriminalization.actName">Pdf&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></form><div ng-if="vm.searchPerformed && vm.decriminalizationResult.length > 0"><div class="panel-body table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><!--<th>#</th>--><th>Sr. No.</th><!--                    <th>Compliance Request No.</th>--><th>Department</th><th>Act/Rule</th><th>Description</th><th>Frequency of Offense</th><th colspan="2">Criminal Punishment Tenure</th><th colspan="2">Fine/ Penalty Amount</th></tr><tr><th></th><!-- Empty cell for alignment --><th></th><!-- Empty cell for alignment --><th></th><!-- Empty cell for alignment --><th></th><!-- Empty cell for alignment --><th></th><!-- Empty cell for alignment --><th>Min Tenure</th><th>Max Tenure</th><th>Min Amount</th><th>Max Amount</th></tr></thead><tbody><tr ng-repeat="dec in vm.decriminalizationResult"><td>{{$index +1}}</td><!--                        <td>{{dec.id}}</td>--><!--                    <td>{{dec.id}}</td>--><td>{{dec.departmentName}}</td><td>{{dec.actName}}</td><td>{{dec.criminalPunishmentDescription}}</td><td>{{dec.offence}}</td><td ng-if="dec.criminalPunishmentTenureInMonths === \'Enter months\'">{{dec.minimumTenure}}</td><td ng-if="dec.criminalPunishmentTenureInMonths === \'Enter months\'">{{dec.maximumTenure}}</td><td ng-if="dec.criminalPunishmentTenureInMonths !== \'Enter months\'">--</td><td ng-if="dec.criminalPunishmentTenureInMonths !== \'Enter months\'">--</td><td ng-if="dec.criminalPunishmentAmountInInr === \'Enter Amount\'">{{dec.minimumAmount}}</td><td ng-if="dec.criminalPunishmentAmountInInr === \'Enter Amount\'">{{dec.maximumAmount}}</td><td ng-if="dec.criminalPunishmentAmountInInr !== \'Enter Amount\'">--</td><td ng-if="dec.criminalPunishmentAmountInInr !== \'Enter Amount\'">--</td></tr></tbody></table></div></div><div ng-if="vm.searchPerformed && vm.decriminalizationResult.length === 0"><div class="text-danger"><strong>No Data Found</strong> - No results found for your search criteria.</div></div></div></div></div>');
$templateCache.put('app/deleteuser/deleteuser.html','<div class="container"><form name="userForm"><div class="row form-group"><div class="col-sm-4 col-sm-offset-2"><input type="text" name="userinfo" class="form-control" ng-model="vm.id" placeholder="Enter user\'s ID" required></div><div class="btn-group col-sm-4"><button type="submit" class="btn btn-info" ng-disabled="userForm.userinfo.$invalid" ng-click="vm.getUser(vm.id)">Search</button></div></div><br></form><br><jhi-alert-error></jhi-alert-error><div class="table-responsive" ng-hide="vm.user==undefined"><table class="table table-striped"><thead><tr><th><span>ID</span></th><th><span>Login</span></th><th><span>Email</span></th><th></th><th><span>Lang Key</span></th><th><span>Profiles</span></th><th></th></tr></thead><tbody><tr><td><a ui-sref="user-management-detail({login:user.login})">{{vm.user.id}}</a></td><td>{{vm.user.login}}</td><td>{{vm.user.email}}</td><td><span class="label label-danger hand" ng-show="!vm.user.activated">Deactivated</span> <span class="label label-success hand" ng-show="vm.user.activated">Activated</span></td><td>{{vm.user.langKey}}</td><td><div ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" class="btn btn-info btn-sm" ng-show="vm.showButton" data-toggle="modal" data-target="#myModal">Delete</button></div></td></tr></tbody></table></div></div><!-- Modal --><div id="myModal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><p>Are you sure you want to delete User {{vm.user.login}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal"><span class="glyphicon glyphicon-ban-circle"></span> &nbsp; Close</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.deleteuser(vm.user.id)"><span class="glyphicon glyphicon-remove-circle"></span> &nbsp; DELETE</button></div></div></div></div>');
$templateCache.put('app/department-best-practices/department-best-practices.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Department Best Practices</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li class="active"><span>Department Best Practices</span></li></ol></div></section><br><div class="container"><div class="row"><div class="col-md-12"><table class="table table-striped table-hover" ng-switch="vm.isAuthenticated()"><thead><tr class="headerGrid"><th>S.No</th><th>Department Name</th><th>View/Download</th></tr></thead><tbody><tr><td>1</td><td>Haryana State Pollution Control Board</td><td><a target="_blank" href="../../content/pdfs/HSPCB_Best_Practices.pdf">View</a></td></tr><tr><td>2</td><td>Haryana Enterprise Promotion Center (HEPC)</td><td><a target="_blank" href="../../content/pdfs/HEPC_Best_Practices.pdf">View</a></td></tr><tr><td>3</td><td>Labour Department Haryana</td><td><a target="_blank" href="../../content/pdfs/Labour_Best_Practices.pdf">View</a></td></tr><tr><td>4</td><td>Public health Engineering Department, Haryana</td><td><a target="_blank" href="../../content/pdfs/PHED_Best_Practices.pdf">View</a></td></tr><tr><td>5</td><td>Town and Country Department. Haryana</td><td><a target="_blank" href="../../content/pdfs/TCP_ULB_HSIIDC_Best_Practices.pdf">View</a></td></tr><tr><td>6</td><td>Haryana, General Administration Department</td><td><a target="_blank" href="../../content/pdfs/General_Administration_AAS_Portal_Best_Practices.pdf">View</a></td></tr><tr><td>7</td><td>Uttar Haryana Bijli Vitran Nigam Limited (UHBVN)</td><td><a target="_blank" href="../../content/pdfs/Best Practices Energy Deptt..pdf">View</a></td></tr><br></tbody></table></div></div></div>');
$templateCache.put('app/deptHodServiceDashboard/deptHodServiceDashboard.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Service Status</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Service Status</span></li></ol></div></section><br><section class="ls section_padding_top_25 section_padding_bottom_75 columns_padding_10" id="user_section"><div class="container"><div class="col-md-12"><div ng-repeat="(departmentname, servicedashboard_data) in vm.deptservicedashboard | orderBy: \'departmentorder\' | groupBy: \'department_name\' "><div class="row"><h3>{{departmentname}} <a ui-sref="towerservicedashboard" class="pull-right" ng-show="departmentname===\'Communication and Connectivity Permissions\'" style="font-size: 18px; color: red">View Department wise Tower Service Dashboard</a></h3><table class="table table_template table-striped"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-6">Service Name</th><!--                    <th class="col-md-1 text-center">Required</th>--><!--                    <th class="col-md-1 text-center">Applied</th>--><th class="col-md-6 text-center">Applications pending for > 45 days</th><!--                    <th class="col-md-4 text-center">Completed</th>--></tr></thead><tbody><!--<tr class="headerGrid row gradient_bg_color2">--><!--<td class="col-md-6 text-center"></td>--><!--&lt;!&ndash;                    <td class="col-md-1 text-center"></td>&ndash;&gt;--><!--&lt;!&ndash;                    <td class="col-md-1 text-center"></td>&ndash;&gt;--><!--<td class="col-md-6 text-center " style="padding:0;margin:0;">--><!--&lt;!&ndash;                        <div class="col-md-2">Total</div>&ndash;&gt;--><!--&lt;!&ndash;                        <div class="col-md-2">> 30 days</div>&ndash;&gt;--><!--<div class="col-md-12">> 45 days</div>--><!--&lt;!&ndash;                        <div class="col-md-2">> 60 days</div>&ndash;&gt;--><!--&lt;!&ndash;                        <div class="col-md-2">> 75 days</div>&ndash;&gt;--><!--&lt;!&ndash;                        <div class="col-md-2">> 90 days</div>&ndash;&gt;--><!--</td>--><!--&lt;!&ndash;                    <td class="col-md-4 "  style="padding:0;margin:0;">&ndash;&gt;--><!--&lt;!&ndash;                        <span class="col-md-3">Cleared</span>&ndash;&gt;--><!--&lt;!&ndash;                        <span class="col-md-3">De-activated</span>&ndash;&gt;--><!--&lt;!&ndash;                        <span class="col-md-3">Deemed Cleared</span>&ndash;&gt;--><!--&lt;!&ndash;                        <span class="col-md-3">Rejected</span>&ndash;&gt;--><!--&lt;!&ndash;                    </td>&ndash;&gt;--><!--</tr>--><tr class="row" ng-repeat="servicedashboard in servicedashboard_data"><td class="col-md-6">{{servicedashboard.service_name}}</td><!--                    <td class="col-md-1 text-center">--><!--                        <div class="col-md-12">--><!--                            <a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Required\'})"><span class="badge">{{servicedashboard.required}}</span></a>--><!--                        </div>--><!--                    </td>--><!--                    <td class="col-md-1 text-center">--><!--                        <div class="col-md-12">--><!--                            <a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Applied\'})"><span class="badge">{{servicedashboard.applied}}</span></a>--><!--                        </div>--><!--                    </td>--><td class="col-md-6 text-center"><!--                        <div class="col-md-2"><a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending\'})"><span class="badge">{{servicedashboard.pending_total}}</span></a></div>--><!--                        <div class="col-md-2"><a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending30\'})"><span class="badge">{{servicedashboard.pending_30days}}</span></a></div>--><div class="col-md-12"><a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending45\'})"><span class="badge">{{servicedashboard.pending_45days}}</span></a></div><!--                        <div class="col-md-2"><a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending60\'})"><span class="badge">{{servicedashboard.pending_60days}}</span></a></div>--><!--                        <div class="col-md-2"><a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending75\'})"><span class="badge">{{servicedashboard.pending_75days}}</span></a></div>--><!--                        <div class="col-md-2"><a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending90\'})"><span class="badge">{{servicedashboard.pending_90days}}</span></a></div>--></td><!--                    <td class="col-md-4 text-center">--><!--                        <div class="col-md-3"><a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Cleared\'})"><span class="badge">{{servicedashboard.cleared}}</span></a></div>--><!--                        <div class="col-md-3"><a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Rejected\'})"><span class="badge">{{servicedashboard.deactivated}}</span></a></div>--><!--                        <div class="col-md-3"><a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'DeemedCleared\'})"><span class="badge">{{servicedashboard.deemed_cleared}}</span></a></div>--><!--                        <div class="col-md-3"><a ui-sref="servicedashboardcafsHod({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Declined\'})"><span class="badge">{{servicedashboard.rejected}}</span></a></div>--><!--                    </td>--></tr></tbody></table></div></div></div></div></section>');
$templateCache.put('app/deptHodServiceDashboard/hodDashboard.html','<div class="content-wrapper"><div class="container"><div class="row"><!-- Icon Cards--><div ui-sref="closedticketview" style="cursor: pointer" class="col-lg-6 col-md-6 col-sm-6 col-12 mb-2 mt-4"><div class="inforide"><div class="row"><div class="col-lg-9 col-md-8 col-sm-8 col-8 fontsty"><h4>Pending Tickets</h4><h2>{{vm.openTickets}}</h2></div><div class="col-lg-3 col-md-4 col-sm-4 col-4 rideone"><i class="fa fa-ticket fa-5x"></i></div></div></div></div><div ui-sref="ticketview" style="cursor: pointer" class="col-lg-6 col-md-6 col-sm-6 col-12 mb-2 mt-4"><div class="inforide"><div class="row"><div class="col-lg-9 col-md-8 col-sm-8 col-8 fontsty"><h4>Overdue Tickets</h4><h2>{{vm.openTickets}}</h2></div><div class="col-lg-3 col-md-4 col-sm-4 col-4 ridetwo"><i class="fa fa-ticket fa-5x"></i></div></div></div></div><div ui-sref="feedbacksbyofficer" style="cursor: pointer" class="col-lg-6 col-md-6 col-sm-6 col-12 mb-2 mt-4"><div class="inforide"><div class="row"><div class="col-lg-9 col-md-8 col-sm-8 col-8 fontsty"><h4>Feedbacks</h4><h2>{{vm.feedbacks}}</h2></div><div class="col-lg-3 col-md-4 col-sm-4 col-4 ridethree"><i class="fa fa-eye fa-5x"></i></div></div></div></div><div ui-sref="servicedashboardhod" style="cursor: pointer" class="col-lg-6 col-md-6 col-sm-6 col-12 mb-2 mt-4"><div class="inforide"><div class="row"><div class="col-lg-9 col-md-8 col-sm-8 col-8 fontsty"><h4>Services Pending for > 45 days</h4><h2>{{vm.totalPending45}}</h2></div><div class="col-lg-3 col-md-4 col-sm-4 col-4 rideFour"><i class="fa fa-stack-exchange fa-5x"></i></div></div></div></div></div></div></div><style>.inforide {\n  box-shadow: 1px 2px 8px 0px #a3f1ee;\n  background-color: white;\n  border-radius: 8px;\n  height: 125px;\n}\n\n.rideone {\n  background-color: #6CC785;\n  padding-top: 25px;\n  border-radius: 8px 0px 0px 8px;\n  text-align: center;\n  height: 113px;\n  margin-left: 15px;\n}\n\n.ridetwo {\n  background-color: #9A75FE;\n  padding-top: 25px;\n  border-radius: 8px 0px 0px 8px;\n  text-align: center;\n  height: 113px;\n  margin-left: 15px;\n}\n\n.ridethree {\n  background-color: #4EBCE5;\n  padding-top: 25px;\n  border-radius: 8px 0px 0px 8px;\n  text-align: center;\n  height: 113px;\n  margin-left: 15px;\n}\n.rideFour {\n  background-color: #e50d00;\n  padding-top: 25px;\n  border-radius: 8px 0px 0px 8px;\n  text-align: center;\n  height: 113px;\n  margin-left: 15px;\n}\n\n.fontsty {\n  margin-right: -15px;\n}\n\n.fontsty h2{\n  color: #6E6E6E;\n  font-size: 35px;\n  margin-top: 15px;\n    margin-left: 30px;\n}\n\n.fontsty h4{\n  color: #6E6E6E;\n  font-size: 25px;\n  margin-top: 20px;\n  margin-left: 30px;\n}\n\n.content-wrapper {\n  min-height: calc(100vh - 56px);\n  padding-top: 4rem;\n  overflow-x: hidden;\n  background: transparent;\n}</style>');
$templateCache.put('app/deptservicedashboard/deptservicedashboard.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Service Dashboard</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Service Dashboard</span></li></ol></div></section><br><div ng-hide="(vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')) && vm.auth !==\'Cumulative\'" class="container-fluid"><div class="row"><div class="col-md-12"><ul class="nav nav-pills"><li ng-hide="vm.auth ===\'Cumulative\'" class="active"><a ui-sref="totaldeptservicesdetail({status:\'Required\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Required Services<span class="badge">{{vm.totalrequiredservices}}</span></a></li><li class="active"><a ui-sref="totaldeptservicesdetail({status:\'Applied\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Applied Services<span class="badge">{{vm.totalappliedservices}}</span></a></li><li class="active"><a ui-sref="totaldeptservicesdetail({status:\'Pending\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Pending Services<span class="badge">{{vm.totalpendingservices}}</span></a></li><li class="active"><a ui-sref="totaldeptservicesdetail({status:\'Cleared\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Cleared Services<span class="badge">{{vm.totalcompletedservices}}</span></a></li><li class="active"><a ui-sref="totaldeptservicesdetail({status:\'DeemedCleared\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Deemed Cleared Services<span class="badge">{{vm.totaldeemedclearedservices}}</span></a></li><li class="active"><a ui-sref="totaldeptservicesdetail({status:\'Declined\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Rejected Services<span class="badge">{{vm.totalrejectedservices}}</span></a></li><li class="active"><a ui-sref="totaldeptservicesdetail({status:\'Rejected\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Deactivated Services<span class="badge">{{vm.totaldeactivatedservices}}</span></a></li><li class="active"><a ui-sref="dashboardbetweendates" has-any-authority="ROLE_ADMIN">Datewise Stats</a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\')">Total Required Services<span class="badge">{{vm.totalrequiredservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Applied Services<span class="badge">{{vm.totalappliedservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Pending Services<span class="badge">{{vm.totalpendingservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Cleared Services<span class="badge">{{vm.totalcompletedservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Rejected Services<span class="badge">{{vm.totalrejectedservices}}</span></a></li></ul></div></div></div><div ng-hide="vm.auth ==\'Cumulative\'"><div ng-hide="(vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')) && vm.auth !=\'Cumulative\'"><div class="row" style="padding: 12px" ng-if="vm.deptservicedashboard"><div class="col-md-1 filter-margin"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div><div class="col-md-3"><select class="custom-select form-control" ng-model="vm.filter.departmentName"><option value="" disabled="disabled">All Department</option><option value="{{department}}" ng-repeat="department in vm.departments">{{department}}</option></select></div><div class="col-md-2"><select class="custom-select form-control" ng-model="vm.filter.district" ng-options="district.districtname as district.districtname for district in vm.districts"><option value="" disabled="disabled">All Districts</option><option value="district.districtname">{{district.districtname}}</option></select></div><div class="col-md-2"><select class="custom-select form-control" ng-model="vm.filter.projectLevel"><option value="" disabled="disabled">All</option><option value="e">EEC</option><option value="d">DLCC</option></select></div><button class="btn btn-primary" ng-click="vm.FilterWiseDat()">Filter</button> <button ng-if="!vm.hideClear" class="btn btn-primary" ng-click="vm.clearFilter()">Clear</button></div></div></div><section ng-hide="vm.auth ==\'Cumulative\'" class="ls section_padding_top_25 section_padding_bottom_75 columns_padding_10" id="user_section"><div ng-hide="(vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')) && vm.auth !==\'Cumulative\'" class="container"><div ng-repeat="(departmentname, servicedashboard_data) in vm.deptservicedashboard | orderBy: \'departmentorder\' | groupBy: \'department_name\' "><div class="row"><h3>{{departmentname}} <a ui-sref="towerservicedashboard" class="pull-right" ng-show="departmentname===\'Communication and Connectivity Permissions\'" style="font-size: 18px; color: red">View Department wise Tower Service Dashboard</a></h3><table class="table table_template table-striped"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-2">Service</th><th class="col-md-1 text-center">Required</th><th class="col-md-1 text-center">Applied</th><th class="col-md-4 text-center">Pending</th><th class="col-md-4 text-center">Completed</th></tr></thead><tbody><tr class="headerGrid row gradient_bg_color2"><td class="col-md-2 text-center"></td><td class="col-md-1 text-center"></td><td class="col-md-1 text-center"></td><td class="col-md-4 text-center" style="padding:0;margin:0"><div class="col-md-2">Total</div><div class="col-md-2">> 30 days</div><div class="col-md-2">> 45 days</div><div class="col-md-2">> 60 days</div><div class="col-md-2">> RTS Days</div></td><td class="col-md-4" style="padding:0;margin:0"><span class="col-md-3">Cleared</span> <span class="col-md-3">De-activated</span> <span class="col-md-3">Deemed Cleared</span> <span class="col-md-3">Rejected</span></td></tr><tr class="row" ng-repeat="servicedashboard in servicedashboard_data"><td class="col-md-2">{{servicedashboard.service_name}}</td><td class="col-md-1 text-center"><div class="col-md-12"><a ui-sref="servicedashboardcafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Required\'})"><span class="badge">{{servicedashboard.required}}</span></a></div></td><td class="col-md-1 text-center"><div class="col-md-12"><a ui-sref="servicedashboardcafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Applied\'})"><span class="badge">{{servicedashboard.applied}}</span></a></div></td><td class="col-md-4 text-center"><div class="col-md-2"><a ui-sref="servicedashboardcafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending\'})"><span class="badge">{{servicedashboard.pending_total}}</span></a></div><div class="col-md-2"><a ui-sref="servicedashboardcafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending30\'})"><span class="badge">{{servicedashboard.pending_30days}}</span></a></div><div class="col-md-2"><a ui-sref="servicedashboardcafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending45\'})"><span class="badge">{{servicedashboard.pending_45days}}</span></a></div><div class="col-md-2"><a ui-sref="servicedashboardcafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending60\'})"><span class="badge">{{servicedashboard.pending_60days}}</span></a></div><div class="col-md-2" ng-if="servicedashboard.rtsDays==\'NA\'"><a><span class="badge">{{servicedashboard.rtsDays}}</span></a></div><div class="col-md-2" ng-if="servicedashboard.rtsDays!=\'NA\'"><a ui-sref="servicedashboardcafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'RTSdays\'})"><span class="badge">{{servicedashboard.rtsDays}}</span></a></div></td><td class="col-md-4 text-center"><div class="col-md-3"><a ui-sref="servicedashboardcafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Cleared\'})"><span class="badge">{{servicedashboard.cleared}}</span></a></div><div class="col-md-3"><a ui-sref="servicedashboardcafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Rejected\'})"><span class="badge">{{servicedashboard.deactivated}}</span></a></div><div class="col-md-3"><a ui-sref="servicedashboardcafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'DeemedCleared\'})"><span class="badge">{{servicedashboard.deemed_cleared}}</span></a></div><div class="col-md-3"><a ui-sref="servicedashboardcafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Declined\'})"><span class="badge">{{servicedashboard.rejected}}</span></a></div></td></tr></tbody></table></div></div></div></section>');
$templateCache.put('app/deptservicedashboard/powerDashboard.html','<form name="myForm" class="form-horizontal" role="form"><div><div><div class="modal-header"><div class="row"><div class="col-sm-12 text-center text-md-left"><h3><b>Power Requirement</b></h3></div><div><button ng-show="vm.show" class="btn btn-sm pull-right" style="margin-right: 10px" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div><div class="panel-body"><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><th><span>District</span></th><th><span>Village</span></th><th><span>Block</span></th><th><span>Power Load Requirement</span></th><th><span>Expected Start Date of Commencement of Production/ Operation</span></th></tr></thead><tbody><tr ng-repeat="caf in vm.requiredcaf |  orderBy: \'-clearedDate\'"><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><td>{{caf.district}}</td><td>{{caf.village}}</td><td>{{caf.blockCategory}}</td><td>{{caf.powerRequirement}}</td><td>{{caf.prodctionStartDate | date:\'dd-MM-yyyy\'}}</td></tr></tbody></table></div></div></div></div></form>');
$templateCache.put('app/deptservicedashboard/serviceviewcafs.html','<form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-9"><h4 class="modal-title text-warning bold" id="myBlockLabel">{{vm.servicename}}</h4></div><div class="col-md-2"><button ng-show="vm.show" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div><div class="row"><div class="text-center"><h5 class="modal-title" ng-show="vm.status==\'All\'"><b>All CAFs with this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending\'"><b>All Pending CAFs against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending30\'"><b>CAFs pending for more than 30 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending45\'"><b>CAFs pending for more than 45 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending60\'"><b>CAFs pending for more than 60 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending75\'"><b>CAFs pending for more than 75 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending90\'"><b>CAFs pending for more than 90 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Cleared\'"><b>CAFs Cleared against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Rejected\'"><b>Service Deactivated for the following CAFs</b></h5><h5 class="modal-title" ng-show="vm.status==\'DeemedCleared\'"><b>Service Deemed Cleared for the following CAFs</b></h5><!--<h5 class="modal-title pull-right" ng-show="vm.status==\'Pending60\'">All CAFs Pending for more than 60 days</h5>--></div></div></div><div class="panel-body"><!--<h5 class="pull-left" ng-show="vm.status==\'Cleared\'">Average Clearance Time :<strong >{{" "}}{{vm.averageTime.toString()==\'NaN\'?"NA": vm.averageTime + \' days\'}}</strong> </h5>--><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><th><span>Business Entity</span></th><th><span>District</span></th><th><span>Project Level</span></th><th><span ng-show="vm.servicename == \'Regularization of existing Tower/Renewal (Above ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Above Ground)\'">Department</span></th><th><span>Proposed Employment</span></th><th><span>Proposed Investment(in crore)</span></th><th><span>SLA</span></th><th ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'Pending90\'"><span>Ageing</span></th><th ng-show="vm.status==\'Cleared\'">Applied Date</th><th ng-show="vm.status==\'Cleared\'">Cleared Date</th></tr></thead><tbody><tr dir-paginate="caf in vm.dashboardcafs.content | orderBy: \'-projectlevel\' | orderBy: \'-clearedDate\' | itemsPerPage: pageSize" total-items="vm.dashboardcafs.totalElements" current-page="currentPage"><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><td>{{caf.businessEntity}}</td><td>{{caf.district}}</td><td>{{caf.projectLevel=="d" ? "DLCC" : "EEC"}}</td><td><span ng-show="vm.servicename == \'Regularization of existing Tower/Renewal (Above ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\'\n                                        || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Above Ground)\'">{{caf.deptName === \'Communication and Connectivity Permissions\' ? "NA" : caf.deptName}}</span></td><!--<td>--><!--<div class="dropdown">--><!--<button ng-show="vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\'" class="btn btn-sm btn-info dropdown-toggle" ng-click="vm.showDepartments(caf)"--><!--data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">View--><!--<span class="caret"></span></button>--><!--<ul class="dropdown-menu dropdown-menu-left" aria-labelledby="dLabel">--><!--<li ng-repeat="dept in vm.departmentName"><a>{{dept}}</a></li>--><!--</ul>--><!--</div>--><!--</td>--><td>{{caf.proposedEmployment}}</td><td>{{caf.proposedInvestment}}</td><td>{{caf.sladays}}</td><td ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'Pending90\'">{{caf.ageing}}</td><td ng-show="vm.status==\'Cleared\'">{{(caf.appliedDate==null ? "NA" : caf.appliedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\'">{{(caf.clearedDate==null ? "NA" :caf.clearedDate) | date:\'dd-MM-yyyy\'}}</td></tr></tbody></table><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/deptservicedashboard/serviceviewcafsTower.html','<form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-10"><h4 ng-if="vm.departmentname!=\'Communication and Connectivity Permissions\'" class="modal-title text-warning bold" id="myBlockLabel">{{vm.departmentname}}</h4><h4 ng-if="vm.departmentname===\'Communication and Connectivity Permissions\'" class="modal-title text-warning bold" id="myBlockLabel1">Communication & Connectivity Permissions</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="col-md-1 pull-right"><button ng-show="vm.show" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div><div class="row"><div class="text-center"><h5 class="modal-title" ng-show="vm.status==\'All\'"><b>All CAFs with this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending\'"><b>All Pending CAFs against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending30\'"><b>CAFs pending for more than 30 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending45\'"><b>CAFs pending for more than 45 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Cleared\'"><b>CAFs Cleared against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Rejected\'"><b>Service Deactivated for the following CAFs</b></h5><h5 class="modal-title" ng-show="vm.status==\'DeemedCleared\'"><b>Service Deemed Cleared for the following CAFs</b></h5><!--<h5 class="modal-title pull-right" ng-show="vm.status==\'Pending60\'">All CAFs Pending for more than 60 days</h5>--></div></div></div><div class="panel-body"><!--<h5 class="pull-left" ng-show="vm.status==\'Cleared\'">Average Clearance Time :<strong >{{" "}}{{vm.averageTime.toString()==\'NaN\'?"NA": vm.averageTime + \' days\'}}</strong> </h5>--><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><th><span>Business Entity</span></th><th><span ng-show="vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\'">Department\'s</span></th><th><span>District</span></th><th><span>SLA</span></th><th ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\'"><span>Ageing</span></th><th ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">Applied Date</th><th ng-show="vm.status==\'Cleared\'">Cleared Date</th><th ng-show="vm.status==\'Declined\'">Rejection Date</th></tr></thead><tbody><tr ng-repeat="caf in vm.dashboardcafs | orderBy: \'-clearedDate\'"><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><td>{{caf.businessentity}}</td><td>{{caf.deptName === \'Communication and Connectivity Permissions\' ? "NA" : caf.deptName}}</td><td>{{caf.district}}</td><td>{{caf.sladays}}</td><td ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\'">{{caf.ageing}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">{{(caf.appliedDate==null ? "NA" : caf.appliedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\'">{{(caf.clearedDate==null ? "NA" :caf.clearedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Declined\'">{{(caf.clearedDate==null ? "NA" :caf.clearedDate) | date:\'dd-MM-yyyy\'}}</td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/deptservicedashboard/towerservicedashboard.html','<div class="container"><div class="pull-right" style="color: red"><b>* NA -</b> cases in which department is not selected</div><div ng-repeat="(servicename, servicedashboard_data) in vm.tower_service_dashboards | groupBy: \'service_name\' "><div class="row"><h3>{{servicename}}</h3><table class="table table-striped table-hover table-responsive"><thead><tr class="headerGrid row"><th class="col-md-5">Department Name</th><!--<th class="col-md-1 text-center bg-primary">Required</th>--><th class="col-md-1 text-center bg-primary">Applied</th><th class="col-md-2 text-center bg-info">Pending</th><th class="col-md-4 text-center bg-danger">Completed</th></tr><tr class="headerGrid row"><th class="col-md-5 text-center"></th><!--<th class="col-md-1 text-center"></th>--><th class="col-md-1 text-center"></th><th class="col-md-2 text-center"><div class="col-md-4">Total</div><div class="col-md-4">> 30 days</div><div class="col-md-4">> 45 days</div></th><th class="col-md-4 text-center"><div class="col-md-3">Cleared</div><div class="col-md-3">De-activated</div><div class="col-md-3">Deemed Cleared</div><div class="col-md-3">Rejected</div></th></tr></thead><tbody><tr class="success row" ng-repeat="servicedashboard in servicedashboard_data | orderBy: \'departmentOrder\' | unique:\'department_name\'"><td ng-if="servicedashboard.department_name!==\'Communication and Connectivity Permissions\'" class="col-md-5"><div class="col-md-12">{{servicedashboard.department_name}}</div></td><td ng-if="servicedashboard.department_name===\'Communication and Connectivity Permissions\'" class="col-md-5"><div class="col-md-12">Communication & Connectivity Permissions</div></td><!--<td class="col-md-1 text-center"><a ui-sref="tower-servicedashboardcafs({departmentname:servicedashboard.department_name,servicename:servicedashboard.service_name,status:\'Required\'})"><span class="badge">{{servicedashboard.required}}</span></a></td>--><td class="col-md-1 text-center"><div class="col-md-12"><a ui-sref="tower-servicedashboardcafs({departmentname:servicedashboard.department_name,servicename:servicedashboard.service_name,status:\'Applied\'})"><span style="padding-top: 20%">{{servicedashboard.applied}}</span></a></div></td><td class="col-md-2 text-center"><div class="col-md-4"><a ui-sref="tower-servicedashboardcafs({departmentname:servicedashboard.department_name,servicename:servicedashboard.service_name,status:\'Pending\'})"><span>{{servicedashboard.pending_total}}</span></a></div><div class="col-md-4"><a ui-sref="tower-servicedashboardcafs({departmentname:servicedashboard.department_name,servicename:servicedashboard.service_name,status:\'Pending30\'})"><span>{{servicedashboard.pending_30}}</span></a></div><div class="col-md-4"><a ui-sref="tower-servicedashboardcafs({departmentname:servicedashboard.department_name,servicename:servicedashboard.service_name,status:\'Pending45\'})"><span>{{servicedashboard.pending_45}}</span></a></div></td><td class="col-md-4 text-center"><div class="col-md-3"><a ui-sref="tower-servicedashboardcafs({departmentname:servicedashboard.department_name,servicename:servicedashboard.service_name,status:\'Cleared\'})"><span>{{servicedashboard.cleared}}</span></a></div><div class="col-md-3"><a ui-sref="tower-servicedashboardcafs({departmentname:servicedashboard.department_name,servicename:servicedashboard.service_name,status:\'Rejected\'})"><span>{{servicedashboard.deactivated}}</span></a></div><div class="col-md-3"><a ui-sref="tower-servicedashboardcafs({departmentname:servicedashboard.department_name,servicename:servicedashboard.service_name,status:\'DeemedCleared\'})"><span>{{servicedashboard.deemed}}</span></a></div><div class="col-md-3"><a ui-sref="tower-servicedashboardcafs({departmentname:servicedashboard.department_name,servicename:servicedashboard.service_name,status:\'Declined\'})"><span>{{servicedashboard.rejected}}</span></a></div></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/disputeDashboard/disputeDashboard.html','<div class="container"><div><div class="form-group"><label class="col-md-6 control-label text-right">Select Dipsutes by Department / District<span style="color:red">*</span></label><div class="col-md-4"><select class="form-control" ng-model="vm.disputeType" ng-change="vm.resultDistrictWise(vm.disputeType)" required><option value="" disabled="disabled">Select Type</option><option value="District" selected="selected">District</option><option value="Department">Department</option></select></div><div class="pull-right"><button ng-if="vm.disputeType" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><br><div class="row" ng-if="vm.disputeType ==\'Department\'"><table id="result_table" class="table table-striped table-hover table-responsive" ng-if="vm.disputeType != null"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-4">Department Name</th><th class="col-md-3 text-center">Total</th><th class="col-md-3 text-center">Resolved</th><th class="col-md-2 text-center">Pending</th></tr></thead><tbody><tr class="row" ng-repeat="final in vm.finalObject" ng-if="final.total !=0"><td class="col-md-4 text-center"><a ng-click="vm.deatils(final.records)"><span class="badge">{{final.departmentname}}</span></a></td><td class="col-md-3 text-center"><a ng-click="vm.deatils(final.records)"><span class="badge">{{final.total}}</span></a></td><td class="col-md-3 text-center"><a ng-click="vm.deatils(final.records,\'resolved\')"><span class="badge">{{final.resolved}}</span></a></td><td class="col-md-2 text-center"><a ng-click="vm.deatils(final.records,\'pending\')"><span class="badge">{{final.pending}}</span></a></td></tr></tbody></table></div><div class="row" ng-if="vm.disputeType ==\'District\'"><table id="result_table" class="table table-striped table-hover table-responsive" ng-if="vm.disputeType != null"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-4">District</th><th class="col-md-3 text-center">Total</th><th class="col-md-3 text-center">Resolved</th><th class="col-md-2 text-center">Pending</th></tr></thead><tbody><tr class="row" ng-repeat="final in vm.finalObject" ng-if="final.total !=0"><td class="col-md-4 text-center"><a ng-click="vm.deatils(final.records)"><span class="badge">{{final.districtName}}</span></a></td><td class="col-md-3 text-center"><a ng-click="vm.deatils(final.records)"><span class="badge">{{final.total}}</span></a></td><td class="col-md-3 text-center"><a ng-click="vm.deatils(final.records,\'resolved\')"><span class="badge">{{final.resolved}}</span></a></td><td class="col-md-2 text-center"><a ng-click="vm.deatils(final.records,\'pending\')"><span class="badge">{{final.pending}}</span></a></td></tr></tbody></table></div></div></div><div class="modal" id="dispute"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><div class="row"><div class="col-md-10"><h4 class="modal-title text-warning bold" ng-show="vm.disputeType ==\'District\'">Disputes Details : {{vm.recordList[0].distrcit}}</h4><h4 class="modal-title text-warning bold" ng-show="vm.disputeType ==\'Department\'">Disputes Details : {{vm.recordList[0].departmentName}}</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="col-md-1 pull-right"><button id="download-btn1" onclick="download_table_data1()" type="button" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></div></div></div><div class="modal-body"><table id="result_table1" class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>Dispute ID</span></th><th ng-if="vm.disputeType ==\'Department\'"><span>District</span></th><th ng-if="vm.disputeType ==\'District\'"><span>Department Name</span></th><th><span>Dispute Date</span></th></tr></thead><tbody><tr ng-repeat="dispute in vm.recordList | orderBy: \'-creationDate\'"><td>{{$index +1}}</td><td>{{dispute.disputeID}}</td><td ng-if="vm.disputeType ==\'Department\'">{{dispute.distrcit}}</td><td ng-if="vm.disputeType ==\'District\'">{{dispute.departmentName}}</td><td>{{dispute.creationDate | date:\'dd-MM-yy\'}}</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></div></div></div>');
$templateCache.put('app/document-center/document-center.html','<!--<div ng-if="vm.loading" class="page-loader">--><!--    <i class="fa fa-spinner fa-spin"></i> Loading...--><!--</div>--><!--<div ng-if="!vm.loading">--><!-- your existing document-center UI --><div class="container-fluid"><!-- Upper Tab --><ul class="nav nav-tabs"><li class="active"><a href="" ng-if="!vm.showEntityLocker">Document Center</a></li><!--        <li class="active">--><!--            <a href="" ng-if="!vm.showEntityLocker">You are logged in .Fetch Documents.</a>--><!--        </li>--><!--        <li ng-if="vm.showEntityLocker">--><!--            <a href="" ng-click="vm.openEntityLocker()">--><!--                <i class="glyphicon glyphicon-list"></i>--><!--                <span>Login To Entity Locker</span>--><!--            </a>--><!--        </li>--><li ng-if="vm.showEntityLocker"><a href="" ng-click="vm.openEntityLocker()" class="entity-locker-link"><img src="/logo/EntityLocker.jpeg" alt="Entity Locker" style="height:40px;width:auto;margin-right:6px"> <span>Login To EntityLocker</span></a></li><li ng-if="vm.showDigiLocker"><a href="" ng-click="vm.openDigiLocker()" class="entity-locker-link"><img src="/logo/digishort.jpeg" style="height:60px;width:auto;margin-right:6px"> <span>Login To DigiLocker</span></a></li></ul><br><div class="row" style="margin-bottom: 15px"><div class="col-md-8"><div style="display: flex; gap: 10px; flex-wrap: wrap"><!--                <button class="btn btn-primary"--><!--                        ng-click="vm.fetchIssuedDocuments()"--><!--                        ng-disabled="vm.loading">--><!--                    <i class="fa fa-database"></i> Fetchh Issued Documents--><!--                </button>--> <button ng-if="!vm.showEntityLocker" class="btn btn-primary" ng-click="vm.fetchIssuedDocuments()" ng-disabled="vm.loading" style="display:flex; align-items:center; gap:6px"><img src="/logo/EntityLocker.jpeg" alt="Entity Locker" style="height:20px; width:auto"> <span>Fetch Issued Documents (EntityLocker)</span></button><!--                <button ng-if="!vm.showEntityLocker" class="btn btn-default"--><!--                        ng-click="vm.fetchSelfUploaded()"--><!--                        ng-disabled="vm.loading">--><!--                    <i class="fa fa-upload"></i> Fetch Enterprise Vault Documents--><!--                </button>--> <button ng-if="!vm.showEntityLocker" class="btn btn-primary" ng-click="vm.fetchSelfUploaded()" ng-disabled="vm.loading" style="display:flex; align-items:center; gap:6px"><img src="/logo/EntityLocker.jpeg" alt="Entity Locker" style="height:20px; width:auto"> <span>Fetch Enterprise Vault Documents(EntityLocker)</span></button> <button ng-if="!vm.showDigiLocker" class="btn btn-primary" ng-click="vm.fetchIssuedDocumentsFromDigilcoker()" ng-disabled="vm.loading" style="display:flex; align-items:center; gap:6px"><img src="/logo/digishort.jpeg" alt="Entity Locker" style="height:20px; width:auto"> <span>Fetch Issued Documents (DigiLocker)</span></button><!--                <button ng-if="!vm.showEntityLocker" class="btn btn-default"--><!--                        ng-click="vm.fetchSelfUploaded()"--><!--                        ng-disabled="vm.loading">--><!--                    <i class="fa fa-upload"></i> Fetch Enterprise Vault Documents--><!--                </button>--> <button ng-if="!vm.showDigiLocker" class="btn btn-primary" ng-click="vm.fetchSelfUploadedFromDigiLocker()" ng-disabled="vm.loading" style="display:flex; align-items:center; gap:6px"><img src="/logo/digishort.jpeg" alt="Entity Locker" style="height:20px; width:auto"> <span>Fetch Drive Documents(DigiLocker)</span></button></div></div></div><h4 ng-if="vm.documents.length > 0" style="margin-top: 20px">{{ vm.documentType }}</h4><!-- Documents Table --><table class="table table-bordered table-striped" ng-if="vm.documents.length > 0"><thead><tr><th>Document Name</th><!--            <th>URI</th>--><th>Document Fetch Date</th><!--            <th>Issuer</th>--><th ng-if="vm.documentType === \'Issued Documents\'">Issued By</th><th>Action</th></tr></thead><tbody><tr ng-repeat="doc in vm.documents"><td>{{doc.name}}</td><!--            <td>{{doc.uri}}</td>--><!--            <td>{{doc.date}}</td>--><td>{{ doc.date | date:\'dd-MM-yyyy\':\'UTC\' }}</td><!--            <td>{{ doc.date | date:\'dd-MM-yyyy\' }}</td>--><!--            <td>{{doc.issuer}}</td>--><td ng-if="vm.documentType === \'Issued Documents\'">{{doc.issuer}}</td><td><!--                <a--><!--                   ng-href="/api/entity-locker/getdoc/{{doc.uri}}"--><!--                   target="_blank"--><!--                   class="btn btn-primary" >--><!--                    <i class="fa fa-eye"></i>--><!--                    Download                 </a>--><!--                <button ng-if="!vm.showEntityLocker"--><!--                    class="btn btn-primary"--><!--                    ng-click="vm.downloadFileFromEntitylocker(doc.uri)">--><!--                    <i class="fa fa-eye"></i> Download--><!--                </button>--><!--                <button ng-if="!vm.showDigiLocker"--><!--                        class="btn btn-primary"--><!--                        ng-click="vm.downloadFileFromDigilocker(doc.uri)">--><!--                    <i class="fa fa-eye"></i> Download--><!--                </button>--> <button ng-if="vm.lastFetchSource === \'ENTITY\' && !vm.showEntityLocker" class="btn btn-primary" ng-click="vm.downloadFileFromEntitylocker(doc.uri)"><i class="fa fa-eye"></i> Download</button> <button ng-if="vm.lastFetchSource === \'DIGI\' && !vm.showDigiLocker" class="btn btn-primary" ng-click="vm.downloadFileFromDigilocker(doc.uri)"><i class="fa fa-eye"></i> Download</button></td></tr></tbody></table><!--    <div ng-if="vm.documents.length === 0 && !vm.loading"  >--><!--        Currently No documents found.Fetch documents.--><!--    </div>--></div><!--</div>-->');
$templateCache.put('app/disputeForm/ViewDisputeFormFilled.html','<div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><br><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success pull-right"><span class="glyphicon glyphicon-download-alt"></span></button></div><div id="pdf_data"><h2><span>&nbsp;Dispute ID:</span> {{vm.dispute.disputeID}}</h2><hr><h3><span>&nbsp;&nbsp;Personal Details</span></h3><dl class="dl-horizontal jh-entity-details col-md-offset-3"><dt><span>Name Of Enterprise</span></dt><dd><span>{{vm.dispute.nameOfEnterprise}}</span></dd><dt><span>Name Of Partner</span></dt><dd><span>{{vm.dispute.nameOfPartner}}</span></dd><dt><span>Mobile Number</span></dt><dd><span>{{vm.dispute.mobileNumber}}</span></dd><dt><span>Email Address</span></dt><dd><span>{{vm.dispute.emailAddress}}</span></dd><dt><span>Address</span></dt><dd><span>{{vm.dispute.address}}</span></dd><dt><span>Office Address</span></dt><dd><span>{{vm.dispute.officeAddress}}</span></dd><dt><span>Distrcit</span></dt><dd><span>{{vm.dispute.distrcit}}</span></dd></dl><h3><span>&nbsp;&nbsp;Dispute Details</span></h3><hr><dl class="dl-horizontal jh-entity-details col-md-offset-3"><dt><span>Fixed Investement</span></dt><dd><span>{{vm.dispute.fixedInvestement}}</span></dd><dt><span>Category Of Dispute</span></dt><dd><span>{{vm.dispute.categoryOfDispute}}</span></dd><dt><span>Detail Of Dispute</span></dt><dd><span>{{vm.dispute.detailOfDispute}}</span></dd><dt><span>Status Pending Level</span></dt><dd><span>{{vm.dispute.statusPendingLevel}}</span></dd><dt><span>Activity</span></dt><dd><span>{{vm.dispute.activity}}</span></dd><dt><span>Is Resolved</span></dt><dd ng-if="vm.dispute.isResolved"><span>Yes</span></dd><dd ng-if="!vm.dispute.isResolved"><span>NO</span></dd><dt><span>Resolve Comment</span></dt><dd><span>{{vm.dispute.resolveComment}}</span></dd><dt><span>Dispute ID</span></dt><dd><span>{{vm.dispute.disputeID}}</span></dd><dt><span>Got Relief Level</span></dt><dd ng-if="!vm.dispute.gotReliefLevel"><span>NO</span></dd><dd ng-if="vm.dispute.gotReliefLevel"><span>YES</span></dd><dt><span>Level Of Relief</span></dt><dd><span>{{vm.dispute.levelOfRelief}}</span></dd><dt><span>Department Name</span></dt><dd><span>{{vm.dispute.departmentName}}</span></dd><dt><span>Department Appeals</span></dt><dd ng-if="vm.dispute.departmentAppeals"><span>Yes</span></dd><dd ng-if="!vm.dispute.departmentAppeals"><span>NO</span></dd><dt><span>Resolve Comment</span></dt><dd><span>{{vm.dispute.resolveComment}}</span></dd><dt><span>Assigned Nodal Officer</span></dt><dd><span>{{vm.dispute.concernedNo}}</span></dd><dt><span>Date Of Filing</span></dt><dd><span>{{vm.dispute.dateOfFiling | date:\'mediumDate\'}}</span></dd><dt><span>Duration Of Pendency</span></dt><dd><span>{{vm.dispute.durationOfPendency}}</span></dd><dt><span>Other Category Dispute</span></dt><dd><span>{{vm.dispute.otherCategoryDispute}}</span></dd></dl><hr><h3><span>&nbsp;&nbsp;Dispute Attachments</span></h3><hr><dl class="dl-horizontal jh-entity-details col-md-offset-3"><dt><span>Reply Of Department</span></dt><dd ng-if="vm.dispute.replyOfDepartment !=null"><span><button class="btn btn-info" ng-click="vm.downloadFile(vm.dispute.replyOfDepartment)">Download</button></span></dd><br><dt><span>Details Of Decision</span></dt><dd ng-if="vm.dispute.detailsOfDecision !=null"><span><button class="btn btn-info" ng-click="vm.downloadFile(vm.dispute.detailsOfDecision)">Download</button></span></dd><br><dt ng-if="vm.dispute.orderOfReliefAttachemnt"><span>Order Of Relief</span></dt><dd ng-show="vm.dispute.orderOfReliefAttachemnt !=null"><span><button class="btn btn-info" ng-click="vm.downloadFile(vm.dispute.orderOfReliefAttachemnt)">Download</button></span></dd><br><dt><span>Appeals Document</span></dt><dd ng-if="vm.dispute.appealsDocument !=null"><span><button class="btn btn-info" ng-click="vm.downloadFile(vm.dispute.appealsDocument)">Download</button></span></dd><br><dt><span>Date Of Filing Petition</span></dt><dd><span><button class="btn btn-info" ng-click="vm.downloadFile(vm.dispute.dateOfFilingPetition)">Download</button></span></dd><br><br></dl><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></div></div>');
$templateCache.put('app/disputeForm/assignDispute.html','<form name="resolveDispute"><div class="modal-header"><button type="button" class="close" data-dismiss="" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel">Assign Dispute</h4></div><div class="modal-body"><div class="form-group"><dl class="dl-horizontal"><dt><span class="pull-left">Dispute ID:</span></dt><dd><span><b>{{vm.dispute.disputeID}}</b></span></dd></dl></div><div class="form-group"><label for="select" class="control-label">Assign to:</label><div class=""><select class="form-control" id="select" ng-model="vm.dispute.concernedNo" ng-options="department.nodalOfficerLogin as department.departmentname+\'&nbsp;&nbsp;(&nbsp;\'+ department.nodalOfficerLogin+\'&nbsp;)&nbsp;\' for department in vm.departments" required><option value="" disabled="disabled">Select Department</option><option class="form-control" value="department.nodalOfficerLogin">{{department}}</option></select></div></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="">Resolve Comment</label>--><!--<textarea class="form-control" rows="3" id="textArea" name="comment" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.dispute.resolveComment" required></textarea>--><!--<div ng-show="grievanceform.comment.$error.pattern">--><!--<div style="color: red"><b>*</b>Only these Characters are allowed--><!--_\'.@A-Za-z0-9-,=();" :  /- --><!--</div>--><!--</div>--><!--</div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.saveResolveData()"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Submit</span></button></div></form>');
$templateCache.put('app/disputeForm/disputeComment.html','<form name="editForm" role="form" ng-submit="vm.saveComments()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Comments</label><textarea class="form-control" rows="3" id="textArea" name="comment" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.disputelog.actionComment" required></textarea><div ng-show="editForm.comment.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/disputeForm/disputeForm.html','<form name="editForm" role="form" show-validation ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDisputeLabel">Dispute Form</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" for="field_nameOfEnterprise">Name Of Enterprise</label><input type="text" class="form-control" name="nameOfEnterprise" id="field_nameOfEnterprise" ng-model="vm.dispute.nameOfEnterprise" required></div><div class="form-group"><label class="control-label" for="field_address">Address of the Enterprise</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.dispute.address" required></div><div class="form-group"><label class="control-label" for="field_officeAddress">Registered office Address of the Enterprise</label><input type="text" class="form-control" name="officeAddress" id="field_officeAddress" ng-model="vm.dispute.officeAddress" required></div><div class="form-group"><label class="control-label" for="field_distrcit">Distrcit</label><select class="form-control" name="distrcit" id="field_distrcit" ng-model="vm.dispute.distrcit" ng-options="district.districtname as district.districtname for district in vm.districts" required><option value="" disabled="disabled">Select District</option></select></div><div class="form-group"><label class="control-label" for="field_activity">Activity of Enterprise</label><input type="text" class="form-control" name="activity" id="field_activity" ng-model="vm.dispute.activity" required></div><div class="form-group"><label class="control-label" for="field_nameOfPartner">Name of Proprietor/Partner/Director</label><input type="text" class="form-control" name="nameOfPartner" id="field_nameOfPartner" ng-model="vm.dispute.nameOfPartner" required></div><div class="form-group"><label class="control-label" for="field_mobileNumber">Contact Number</label><input type="number" class="form-control" name="mobileNumber" id="field_mobileNumber" ng-model="vm.dispute.mobileNumber" minlength="10" maxlength="10" required><div ng-show="editForm.mobileNumber.$invalid && editForm.mobileNumber.$touched "><small style="color:red; display:block">Invalid Input</small></div></div><div class="form-group"><label class="control-label" for="field_emailAddress">Email Address</label><input type="email" class="form-control" name="emailAddress" id="field_emailAddress" ng-model="vm.dispute.emailAddress" required><div ng-show="editForm.emailAddress.$invalid && editForm.emailAddress.$touched "><small style="color:red; display:block">Invalid Input</small></div></div><div class="form-group"><label class="control-label" for="field_fixedInvestement">Fixed Capital Investment (in Rs.)</label><input type="number" class="form-control" name="fixedInvestement" id="field_fixedInvestement" ng-model="vm.dispute.fixedInvestement" required></div><div class="form-group"><label class="control-label" for="field_categoryOfDispute">Category Of Dispute</label><select class="form-control" name="categoryOfDispute" id="field_categoryOfDispute" ng-model="vm.dispute.categoryOfDispute" required><option value="" disabled="disabled">Select Block</option><option value="Service related">Service related</option><option value="Infrastructure related">Infrastructure related</option><option value="Policy related">Policy related</option><option value="Land/Plot related">Land/Plot related</option><option value="Subsidy related">Subsidy related</option><option value="Any other (please specify)">Any other (please specify)</option></select></div><div class="form-group" ng-if="vm.dispute.categoryOfDispute==\'Any other (please specify)\'"><label class="control-label" for="field_otherCategoryDispute">Other Category Dispute</label><input type="text" class="form-control" name="otherCategoryDispute" id="field_otherCategoryDispute" ng-model="vm.dispute.otherCategoryDispute"></div><div class="form-group"><label class="control-label" for="field_detailOfDispute">Brief details of the dispute</label><input type="text" class="form-control" name="detailOfDispute" id="field_detailOfDispute" ng-model="vm.dispute.detailOfDispute" required></div><div class="form-group"><label class="control-label" for="field_departmentName">Name of the department to which dispute is related</label><select class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.dispute.departmentName" ng-options="department.departmentname as department.departmentname for department in vm.departments"><option value="" disabled="disabled">Select Department</option><option class="form-control" value="department.departmentname">{{department.departmentname}}</option></select></div><div class="row"><div class="form-group"><label class="col-md-4 control-label">Whether all departmental channels of appeal have been exhausted ?<span style="color:red">*</span></label><div class="col-md-4"><label for="Yes8">Yes</label><input id="Yes8" type="radio" ng-model="vm.dispute.departmentAppeals" name="departmentAppeals" value="True" required><label for="No8">No</label><input id="No8" type="radio" ng-model="vm.dispute.departmentAppeals" ng-click="vm.checkPoint(vm.dispute.departmentAppeals)" name="departmentAppeals" value="False"></div></div></div><br><div class="form-group" ng-if="vm.dispute.departmentAppeals ==\'True\'"><div><label class="control-label">Appeals and decision therein</label><input type="file" id="permission" class="form-control" file-model="vm.appealsDocument" accept="application/pdf" required><p ng-show="vm.appealsDocument.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.appealsDocument.maxSizeError}}</div></div><br><div class="form-group"><label class="control-label" for="field_statusPendingLevel">Status Pending Level</label><select class="form-control" name="statusPendingLevel" id="field_statusPendingLevel" ng-model="vm.dispute.statusPendingLevel" required><option value="" disabled="disabled">Select Level</option><option value="Arbitrator">Arbitrator</option><option value="Sales Tax tribunal">Sales Tax Tribunal</option><option value="Lower court">Lower court</option><option value="District court">District court</option><option value="High court">High court</option><option value="Supreme court">Supreme court</option></select></div><div class="row"><div class="form-group"><!--<input type="checkbox" name="gotReliefLevel" id="field_gotReliefLevel"--><!--ng-model="vm.dispute.gotReliefLevel"/>--><div><label class="col-md-4 control-label">Whether the applicant has got relief in the dispute at any stage/level?</label></div><div class="col-md-4"><label for="Yes8">Yes</label><input id="Yes" type="radio" ng-model="vm.dispute.gotReliefLevel" name="gotReliefLevel" value="True" required><label for="No8">No</label><input id="No" type="radio" ng-model="vm.dispute.gotReliefLevel" name="gotReliefLevel" value="False"></div></div></div><br><div class="form-group" ng-if="vm.dispute.gotReliefLevel ==\'True\'"><label class="control-label" for="field_levelOfRelief">Level Of Relief</label><select class="form-control" name="levelOfRelief" id="field_levelOfRelief" ng-model="vm.dispute.levelOfRelief" required><option value="" disabled="disabled">Select Level</option><option value="Arbitrator">Arbitrator</option><option value="Sales Tax tribunal">Sales Tax Tribunal</option><option value="Lower court">Lower court</option><option value="District court">District court</option><option value="High court">High court</option><option value="Supreme court">Supreme court</option></select></div><div class="form-group" ng-if="vm.dispute.gotReliefLevel ==\'True\'"><div><label class="control-label">Order Of Relief</label><input type="file" id="permission1" class="form-control" file-model="vm.orderOfReliefAttachemnt" accept="application/pdf" required><p ng-show="vm.orderOfReliefAttachemnt.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.orderOfReliefAttachemnt.maxSizeError}}</div></div><br><div class="form-group"><label class="control-label" for="field_durationOfPendency">Duration Of Pendency</label><input type="text" class="form-control" name="durationOfPendency" id="field_durationOfPendency" ng-model="vm.dispute.durationOfPendency" required></div><div class="form-group"><label class="control-label" for="field_dateOfFiling">Date Of Filing</label><div class="input-group"><input id="field_dateOfFiling" type="date" class="form-control" name="dateOfFiling" max="2999-01-01" uib-datepicker-popup="{{dateformat}}" ng-model="vm.dispute.dateOfFiling" is-open="vm.datePickerOpenStatus.dateOfFiling" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfFiling\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><div><label class="control-label">Date of filing of petition</label><input type="file" id="dateOfFilingOfPetition" class="form-control" file-model="vm.dateOfFilingPetition" accept="application/pdf" required><p ng-show="vm.dateOfFilingPetition.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.dateOfFilingPetition.maxSizeError}}</div></div><br><div class="form-group"><div><label class="control-label">Reply of the department</label><input type="file" id="elevation" class="form-control" file-model="vm.replyOfDepartment" accept="application/pdf" required><p ng-show="vm.replyOfDepartment.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.replyOfDepartment.maxSizeError}}</div></div><br><div class="form-group"><div><label class="control-label">Details of decision</label><input type="file" id="authorization" class="form-control" file-model="vm.detailsOfDecision" accept="application/pdf" required><p ng-show="vm.detailsOfDecision.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.detailsOfDecision.maxSizeError}}</div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || file.maxSizeError" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span>Save</span></button></div></form>');
$templateCache.put('app/disputeForm/disputeResolve.html','<form name="resolveDispute" show-validation ng-submit="vm.saveResolveData()"><div class="modal-header"><button type="button" class="close" data-dismiss="" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Resolve Dispute</h4></div><div class="modal-body"><div class="form-group"><dl class="dl-horizontal"><dt><span class="pull-left">Dispute:</span></dt><dd><span>{{vm.dispute.disputeID}}</span></dd></dl></div><div class="form-group"><label class="control-label" data-translate="">Resolve Comment</label><textarea class="form-control" rows="3" id="textArea" name="comment" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.dispute.resolveComment" required></textarea><div ng-show="resolveDispute.comment.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><div><input type="file" id="elevation" class="form-control" file-model="vm.projectAttachemnt.file" accept="application/pdf" required><p ng-show="vm.projectAttachemnt.file.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.projectAttachemnt.file.maxSizeError}}</div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="resolveDispute.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Submit</span></button></div></form>');
$templateCache.put('app/disputeForm/disputes.html','<div><h2>Disputes</h2><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Name Of Enterprise</span></th><th><span>Dispute ID</span></th><th><span>Activity</span></th><th><span>Name Of Partner</span></th><th><span>Mobile Number</span></th><th><span>Email Address</span></th><th><span>Fixed Investement</span></th><th><span>Category Of Dispute</span></th><th><span>Detail Of Dispute</span></th><th><span>Duration Of Pendency</span></th><th><span>Other Category Dispute</span></th><th><span>Status Pending Level</span></th><th><span>Is Resolved</span></th><th><span>Got Relief Level</span></th><th><span>Level Of Relief</span></th><th><span>Department Name</span></th><th><span>Department Appeals</span></th><th><span>Address</span></th><th><span>Office Address</span></th><th><span>Date Of Filing</span></th><th><span>Date Of Filing Petition Document</span></th><th><span>Reply Of Department</span></th><th><span>Details Of Decision</span></th><th><span>Order Of Relief Attachemnt</span></th><th><span>Appeals Document</span></th><th></th></tr></thead><tbody><tr ng-repeat="dispute in vm.disputes track by dispute.id"><td>{{dispute.nameOfEnterprise}}</td><td><a ng-click="vm.showPersonalDetail(dispute.id)">{{dispute.disputeID}}</a></td><td>{{dispute.activity}}</td><td>{{dispute.nameOfPartner}}</td><td>{{dispute.mobileNumber}}</td><td>{{dispute.emailAddress}}</td><td>{{dispute.fixedInvestement}}</td><td>{{dispute.categoryOfDispute}}</td><td>{{dispute.detailOfDispute}}</td><td>{{dispute.durationOfPendency}}</td><td>{{dispute.otherCategoryDispute}}</td><td>{{dispute.statusPendingLevel}}</td><td><span ng-show="dispute.isResolved">YES</span> <span ng-show="!dispute.isResolved">NO</span></td><td><span ng-show="dispute.gotReliefLevel">YES</span> <span ng-show="!dispute.gotReliefLevel">NO</span></td><td>{{dispute.levelOfRelief}}</td><td>{{dispute.departmentName}}</td><td><span ng-show="dispute.departmentAppeals">YES</span> <span ng-show="!dispute.departmentAppeals">NO</span></td><td>{{dispute.address}}</td><td>{{dispute.officeAddress}}</td><td>{{dispute.dateOfFiling | date:\'dd-MM-yyyy\'}}</td><td><button type="button" class="btn btn-sm btn-success" ng-if="dispute.dateOfFilingPetition!=null" ng-click="vm.DownloadFile(dispute.dateOfFilingPetition)">Download</button></td><td><button type="button" class="btn btn-sm btn-success" ng-if="dispute.replyOfDepartment!=null" ng-click="vm.DownloadFile(dispute.replyOfDepartment)">Download</button></td><td><button type="button" class="btn btn-sm btn-success" ng-if="dispute.detailsOfDecision!=null" ng-click="vm.DownloadFile(dispute.detailsOfDecision)">Download</button></td><td><button type="button" class="btn btn-sm btn-success" ng-if="dispute.orderOfReliefAttachemnt!=null" ng-click="vm.DownloadFile(dispute.orderOfReliefAttachemnt)">Download</button></td><td><button type="button" class="btn btn-sm btn-success" ng-if="dispute.appealsDocument!=null" ng-click="vm.DownloadFile(dispute.appealsDocument)">Download</button></td><td class="action verticalalign"><button type="button" class="btn btn-info" ui-sref="viewDisputeFilledForm({id:dispute.id})">View Form</button> <button type="button" class="btn btn-sm btn-success" ng-if="!dispute.isResolved" ui-sref="resolveDisputes({id:dispute.id})">Resolve</button><label ng-if="dispute.isResolved">Resolved</label><button type="button" class="btn btn-info" ui-sref="assignDispute({id:dispute.id})">Assign</button> <button type="button" class="btn btn-info" ui-sref="viewDisputeLog-NO({id:dispute.id})">View Log</button> <button type="button" class="btn btn-info" ui-sref="commentDispute-DeskOfficer({id:dispute.id})">Comment</button></td><!--<button type="submit"--><!--ui-sref="dispute.edit({id:dispute.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="dispute.delete({id:dispute.id})"--><!--class="btn btn-danger btn-sm">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--><!--</button>--><!--</div>--></tr></tbody></table></div></div>');
$templateCache.put('app/disputeForm/userdisputes.html','<div><h2>Disputes</h2><div class="container-fluid"><div class="row col-md-12"><button type="submit" ng-show="vm.account.authorities ==\'ROLE_USER\'" ui-sref="disputeForm" class="btn btn-info">Add Dispute</button></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Name Of Enterprise</span></th><th><span>Dispute ID</span></th><th><span>Activity</span></th><th><span>Name Of Partner</span></th><th><span>Mobile Number</span></th><th><span>Email Address</span></th><th><span>Fixed Investement</span></th><th><span>Category Of Dispute</span></th><th><span>Detail Of Dispute</span></th><th><span>Duration Of Pendency</span></th><th><span>Other Category Dispute</span></th><th><span>Status Pending Level</span></th><th><span>Is Resolved</span></th><th><span>Got Relief Level</span></th><th><span>Level Of Relief</span></th><th><span>Department Name</span></th><th><span>Department Appeals</span></th><th><span>Address</span></th><th><span>Office Address</span></th><th><span>Date Of Filing</span></th><th><span>Date Of Filing Petition Document</span></th><th><span>Reply Of Department</span></th><th><span>Details Of Decision</span></th><th><span>Order Of Relief Attachemnt</span></th><th><span>Appeals Document</span></th><th></th></tr></thead><tbody><tr ng-repeat="dispute in vm.disputes track by dispute.id"><td>{{dispute.nameOfEnterprise}}</td><td><a ng-click="vm.showPersonalDetail(dispute.id)">{{dispute.disputeID}}</a></td><td>{{dispute.activity}}</td><td>{{dispute.nameOfPartner}}</td><td>{{dispute.mobileNumber}}</td><td>{{dispute.emailAddress}}</td><td>{{dispute.fixedInvestement}}</td><td>{{dispute.categoryOfDispute}}</td><td>{{dispute.detailOfDispute}}</td><td>{{dispute.durationOfPendency}}</td><td>{{dispute.otherCategoryDispute}}</td><td>{{dispute.statusPendingLevel}}</td><td><span ng-show="dispute.isResolved">YES</span> <span ng-show="!dispute.isResolved">NO</span></td><td><span ng-show="dispute.gotReliefLevel">YES</span> <span ng-show="!dispute.gotReliefLevel">NO</span></td><td>{{dispute.levelOfRelief}}</td><td>{{dispute.departmentName}}</td><td><span ng-show="dispute.departmentAppeals">YES</span> <span ng-show="!dispute.departmentAppeals">NO</span></td><td>{{dispute.address}}</td><td>{{dispute.officeAddress}}</td><td>{{dispute.dateOfFiling | date:\'dd-MM-yyyy\'}}</td><td><button type="button" class="btn btn-sm btn-success" ng-if="dispute.dateOfFilingPetition!=null" ng-click="vm.DownloadFile(dispute.dateOfFilingPetition)">Download</button></td><td><button type="button" class="btn btn-sm btn-success" ng-if="dispute.replyOfDepartment!=null" ng-click="vm.DownloadFile(dispute.replyOfDepartment)">Download</button></td><td><button type="button" class="btn btn-sm btn-success" ng-if="dispute.detailsOfDecision!=null" ng-click="vm.DownloadFile(dispute.detailsOfDecision)">Download</button></td><td><button type="button" class="btn btn-sm btn-success" ng-if="dispute.orderOfReliefAttachemnt!=null" ng-click="vm.DownloadFile(dispute.orderOfReliefAttachemnt)">Download</button></td><td><button type="button" class="btn btn-sm btn-success" ng-if="dispute.appealsDocument!=null" ng-click="vm.DownloadFile(dispute.appealsDocument)">Download</button></td><td class="action verticalalign"><button type="button" class="btn btn-info" ui-sref="viewUserFilledForm({id:dispute.id})">View Form</button><!--<button  type="button" class="btn btn-sm btn-success"  ng-if="!dispute.isResolved" ui-sref="resolveDisputes({id:dispute.id})">--><!--<span class="glyphicon glyphicon-ok"></span> &nbsp; Resolve--><!--</button>--> <button type="button" class="btn btn-info" ui-sref="myDisputeLog({id:dispute.id})">View Log</button> <button type="button" class="btn btn-info" ui-sref="commentDispute({id:dispute.id})">Comment</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/disputeForm/viewLog.html','<div class="container-fluid"><div class="row"><div class="col-md-12"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><div id="pdf_data"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel" data-translate="">Dispute Log : {{vm.dispute.disputeID}}</h4></div><div class="modal-body"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>Action</th><th>Action Date</th><th>Action By</th><th>Action Comment</th><th></th></tr></thead><tbody><tr ng-repeat="dispute in vm.disputeLog | orderBy : \'-actionDate\'"><td>{{dispute.action}}</td><td>{{dispute.actionDate | date:\'dd-MM-yyyy\'}}</td><td>{{dispute.actionBy}}</td><td>{{dispute.actionComment}}</td><td><button ng-show="(dispute.fileName)" type="button" class="btn btn-primary" ng-click="vm.downloadFile(dispute.fileName)">Download</button></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="" ng-click="vm.clear()"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span data-translate="">Close</span></button></div></div></div></div>');
$templateCache.put('app/draftCAF/draftCAF.html','<div ng-cloak><div class="container"><div class="row"><button type="button" class="btn btn-primary pull-right" ng-click="vm.DeleteCaf()">Delete All</button><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>No</th><th>CAF Pin (Composite Application Form)</th><!--<th>Investor Name</th>--><th>Business Entity</th><th>Project Level</th><th>Project ID</th><th>Caf Type</th><th>Created Date</th><th></th></tr></thead><tbody><tr ng-repeat="project in vm.project | orderBy: \'-createdate\'"><td>{{$index+1}}</td><td>{{project.cafpin}}</td><!--<td >{{prdtl.investorName}}</td>--><td>{{project.businessentity}}</td><td>{{project.projectlevel==\'e\' ? "EEC" : "DLCC"}}</td><td>{{project.id}}</td><td>{{project.caftype}}</td><td>{{project.createdate | date:\'yyyy-MM-dd\'}}</td><td class="action verticalalign"><button type="button" class="btn btn-primary" ng-click="vm.modalCaf(project.id)">Delete</button></td></tr></tbody></table></div><div ng-if="!vm.showtable">No Projects Right Now.</div></div></div><br><br><br><div class="modal" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm delete operation</h4></div><div class="modal-body"><p>Are you sure you want to delete this Caf?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="button" ng-disabled="deleteForm.$invalid" class="btn btn-danger" ng-click="vm.deleteCaf(vm.deleteId)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Delete</span></button></div></div></div></div>');
$templateCache.put('app/edit-caf-details/edit-caf-details.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>CAF Change Requests</span></li></ol></div></section><br><div class="container" style="width:98%; max-width:98%"><div class="text-right" style="margin-bottom: 10px"><button class="btn btn-primary" ng-if="vm.applications.length > 0" ng-click="vm.downloadCSV()"><i class="fa fa-download"></i> Download CSV</button></div><table class="table table-bordered table-striped" ng-if="vm.applications.length > 0"><thead><tr><th>CAF PIN</th><th>CAF Type</th><th>Business Entity</th><th>Business Type</th><th>District</th><th>Village</th><th>Block Category</th><th>Site Address</th><th>Status</th><th>Document</th><th>Applied On</th><th>Action</th></tr></thead><tbody><tr ng-repeat="app in vm.applications"><!-- CAF Details --><td>{{app.cafpin || \'NA\'}}</td><td>{{app.caftype || \'NA\'}}</td><!-- Business Entity --><td><div><strong>Old:</strong> {{app.oldbusinessentity || \'NA\'}}</div><div><strong>New:</strong> {{app.newbusinessentity || \'NA\'}}</div></td><!-- Business Type --><td><div><strong>Old:</strong> {{app.oldBusinessEntityType || \'NA\'}}</div><div><strong>New:</strong> {{app.newBusinessEntityType || \'NA\'}}</div></td><!-- District --><td><div><strong>Old:</strong> {{app.oldDistrict || \'NA\'}}</div><div><strong>New:</strong> {{app.newDistrict || \'NA\'}}</div></td><!-- Village --><td><div><strong>Old:</strong> {{app.oldVillage || \'NA\'}}</div><div><strong>New:</strong> {{app.newVillage || \'NA\'}}</div></td><!-- Block Category --><td><div><strong>Old:</strong> {{app.oldBlockCategory || \'NA\'}}</div><div><strong>New:</strong> {{app.newBlockCategory || \'NA\'}}</div></td><!-- Site Address --><td><div><strong>Old:</strong> {{app.oldSiteAddress || \'NA\'}}</div><div><strong>New:</strong> {{app.newSiteAddress || \'NA\'}}</div></td><!-- Status --><td><span class="label" ng-class="{\n                        \'label-warning\': app.status === \'PENDING\',\n                        \'label-success\': app.status === \'APPROVED\',\n                        \'label-danger\': app.status === \'REJECTED\'\n                      }">{{app.status || \'NOT AVAILABLE\'}}</span></td><td><a ng-if="app.filePath" ng-href="/api/files/{{app.filePath}}" class="btn btn-primary"><i class="fa fa-eye"></i> Download</a></td><!-- Created Date --><td>{{app.createdat ? (app.createdat | date:\'dd-MM-yyyy HH:mm\') : \'NA\'}}</td><!-- Action Buttons --><td><div has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN"><button ng-if="app.status === \'PENDING\'" class="btn btn-success btn-sm" ng-click="vm.updateStatus(app, \'APPROVED\')">Approve</button> <button ng-if="app.status === \'PENDING\'" class="btn btn-danger btn-sm" ng-click="vm.updateStatus(app, \'REJECTED\')">Reject</button></div><span ng-if="app.status !== \'PENDING\'">- </span><button class="btn btn-info btn-sm" ng-click="vm.viewLogs(app.cafpin)">View Logs</button></td></tr></tbody></table><!-- If No Data --><div ng-if="vm.applications.length === 0" class="alert alert-info text-center">No edit requests found.</div></div><!-- Logs Modal --><div class="modal fade" id="logsModal" tabindex="-1" role="dialog"><div class="modal-dialog" style="width:98%; max-width:98%"><div class="modal-content"><div class="modal-header"><h4 class="modal-title">CAF Change Request logs for {{vm.selectedCafpin}}</h4><button type="button" class="close" data-dismiss="modal">&times;</button></div><div class="modal-body"><div class="text-right" style="margin-bottom: 10px"><button class="btn btn-primary" ng-if="vm.logs.length > 0" ng-click="vm.downloadLogsCSV()"><i class="fa fa-download"></i> Download Logs CSV</button></div><table class="table table-bordered table-striped" ng-if="vm.logs.length > 0"><thead><tr><th>Business Entity</th><th>Business Type</th><th>District</th><th>Village</th><th>Block Category</th><th>Site Address</th><th>Action Taken</th><th>Action Taken By</th><th>Created On</th><th>Comments</th><th>Document</th></tr></thead><tbody><tr ng-repeat="log in vm.logs"><td><div><strong>Old:</strong> {{log.oldbusinessentity || \'NA\'}}</div><div><strong>New:</strong> {{log.newbusinessentity || \'NA\'}}</div></td><!-- Business Type --><td><div><strong>Old:</strong> {{log.oldBusinessEntityType || \'NA\'}}</div><div><strong>New:</strong> {{log.newBusinessEntityType || \'NA\'}}</div></td><!-- District --><td><div><strong>Old:</strong> {{log.oldDistrict || \'NA\'}}</div><div><strong>New:</strong> {{log.newDistrict || \'NA\'}}</div></td><!-- Village --><td><div><strong>Old:</strong> {{log.oldVillage || \'NA\'}}</div><div><strong>New:</strong> {{log.newVillage || \'NA\'}}</div></td><!-- Block Category --><td><div><strong>Old:</strong> {{log.oldBlockCategory || \'NA\'}}</div><div><strong>New:</strong> {{log.newBlockCategory || \'NA\'}}</div></td><!-- Site Address --><td><div><strong>Old:</strong> {{log.oldSiteAddress || \'NA\'}}</div><div><strong>New:</strong> {{log.newSiteAddress || \'NA\'}}</div></td><td>{{log.actiontaken || \'NA\'}}</td><td>{{log.actiontakenby || \'NA\'}}</td><td>{{log.createdat ? (log.createdat | date:\'dd-MM-yyyy HH:mm\') : \'NA\'}}</td><td>{{log.comments || \'NA\'}}</td><td><a ng-if="log.filePath" ng-href="/api/files/{{log.filePath}}" class="btn btn-primary"><i class="fa fa-eye"></i> Download</a></td></tr></tbody></table><div ng-if="vm.logs.length === 0" class="alert alert-info text-center">No logs found.</div></div></div></div></div><!-- Approve / Reject Modal --><div class="modal fade" id="statusModal" tabindex="-1" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><h4 class="modal-title">{{vm.selectedStatus}} Application</h4><button type="button" class="close" data-dismiss="modal">&times;</button></div><div class="modal-body"><div class="form-group"><label><strong>Comments</strong></label><textarea class="form-control" rows="4" ng-model="vm.statusComments" placeholder="Enter your comments here..." required>\n                    </textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button> <button type="button" class="btn btn-primary" ng-click="vm.confirmStatusUpdate()" ng-disabled="!vm.statusComments">Submit</button></div></div></div></div>');
$templateCache.put('app/eodb/eodb.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">EODB</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li class="active"><span>EODB</span></li></ol></div></section><br><div class="container"><div class="row"><div class="col-md-12"><h3 class="heading-style">ABOUT</h3><p class="content-style">\u201CEase of Doing Business \u2013 EoDB\u201D is one of the important initiatives run by the Department of Industrial Policy and Promotion, GoI. In EoDB framework, the emphasis has been on simplification and rationalization of the existing rules and introduction of information technology to make governance more efficient and effective. According to the ease of doing business rankings released by the DIPP in 2016, Haryana was featured among the top 5 states on the index with an implementation score of 96.95 percent. Haryana has locked this success by understanding and implementing some key reform areas which include implementation of a Single Window Clearance system, relaxation in Labour laws, faster environmental clearance etc. These reforms have helped Haryana improve its ranking from 14th to 6th among Indian states on (EoDB) business index.</p><h3 class="heading-style">DEPARTMENT\'S</h3><div class="row"><div class="col-md-6"><p data-toggle="modal" data-target="#dept1" class="logo-style">Haryana Forest Department</p></div><div class="col-md-6"><p data-toggle="modal" data-target="#dept2" class="logo-style">Haryana Enterprises Promotion Centre - HEPC</p></div></div><div class="row"><div class="col-md-6"><p data-toggle="modal" data-target="#dept3" class="logo-style">Haryana Shehri Vikas Pradhikaran \u2013 HSVP</p></div><div class="col-md-6"><p data-toggle="modal" data-target="#dept4" class="logo-style">Department of Labour</p></div></div><div class="row"><div class="col-md-6"><p data-toggle="modal" data-target="#dept5" data-toggle="modal" data-target="#dept5" class="logo-style">Department of Land Records</p></div><div class="col-md-6"><p data-toggle="modal" data-target="#dept6" class="logo-style">Department of Industries & Commerce Haryana \u2013 I&C</p></div></div><div class="row"><div class="col-md-6"><p data-toggle="modal" data-target="#dept7" class="logo-style">Town & Country Planning Department, Haryana \u2013 TCP</p></div><div class="col-md-6"><p data-toggle="modal" data-target="#dept8" class="logo-style">Urban Local Bodies, Haryana \u2013 ULB</p></div></div><div class="row"><div class="col-md-6"><p data-toggle="modal" data-target="#dept9" class="logo-style">Haryana State Industrial and Infrastructural Development Corp. \u2013 HSIIDC</p></div><div class="col-md-6"><p data-toggle="modal" data-target="#dept10" class="logo-style">Haryana State Pollution Control Board \u2013 HSPCB</p></div></div><div class="row"><div class="col-md-12"><p data-toggle="modal" data-target="#dept11" class="logo-style">Department of Power \u2013 Uttar Haryana Bijli Vitran Nigam/ Dakshin Haryana Bijli Vitran Nigam</p></div></div></div></div></div><div class="modal fade" id="dept1" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="heading-style">Haryana Forest Department</h4><h4 class="heading1-style">Introduction</h4><p class="content-style"><b>Vision -</b> To make the state ecologically stable and to conserve the biodiversity of forest and wildlife.</p><p class="content-style"><b>Mission</b> - To adopt diversification of species for conservation of biodiversity, to adopt measures for soil and water conservation and try to achieve the target of 20% Forest and Tree Cover in a phased manner by 2020 as envisaged in the State Forest Policy.</p><p class="content-style"><b>Objectives -</b></p><ul class="list-style"><li>Afforestation on Govt. Forest Lands.</li><li>Afforestation on institutional lands, panchayat lands, community lands and private farm lands.</li><li>Protection of Forests.</li><li>Raising of saplings for distribution/sale.</li><li>Strengthening, expansion and improvement of National Parks and Sanctuaries for Wildlife protection.</li><li>To strengthen Community Participation through Joint Forest Management.</li><li>Soil and Water Conservation on watershed basis including Cho-Training.</li><li>Development of infrastructure for the department including Management Information System.</li><li>Establishment and maintenance of Herbal Parks.</li><li>Carrying out Research Activities including preparation of Working Plans, Publicity, Training and Extension.</li></ul><p class="content-style"><b>Functions -</b></p><ul class="list-style"><li>Management and protection of forests as per Indian Forest Act, 1927, Forest Conservation Act, 1980, Punjab Land Preservation Act, 1900 and other related acts, rules and regulations.</li><li>Afforestation on Govt. forest lands and other wastelands.</li><li>Development of Herbal parks.</li><li>Soil & Water Conservation including construction of Water Harvesting Structures.</li></ul><button type="button" class="pull-right btn btn-danger" data-dismiss="modal">Close</button><br><br></div></div></div></div><div class="modal fade" id="dept2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="heading-style">Haryana Enterprise Promotion Centre \u2013 HEPC</h4><h4 class="heading1-style">Introduction</h4><p class="content-style"><b>Haryana Enterprises Promotion Centre (HEPC)</b> a unique Single Roof Clearance System for the benefit of the new units or units under expansion. The single-roof facility is a part of Haryana\'s ongoing efforts to adopt a revolutionary mechanism to help simplify procedures and facilitate ease in doing business with the State supported by state-of-the-art Technology platform. Under this initiative more than 70 clearances of 14 different departments are granted under one roof in a time bound manner i.e. 30 + 15 days. Further \u201CDeemed Clearance\u201D is provided after the completion of 45 days from the date of online application on Invest Haryana portal if the service is not granted within 45 days. Haryana Enterprise Promotion Centre (HEPC), was set up with a statuary backing. HEPC facilitate investors in obtaining all sorts of clearances for the Enterprise via portal - <a href="https://investharyana.in/#/">https://investharyana.in/#/ </a>under one roof. HEPC is fully committed to provide clearances in time bound manner.</p><p class="content-style"><b>Composite Application Form \u2013 CAF</b> HEPC provides all industrial related clearances to new or existing enterprises through a common form. CAF follows the principle of \u201CInformation and Document once submitted by the entrepreneur during any point of his investment cycle should not be asked again by any other agency for approval in the State\u201D. The state of Haryana has mandated under the Haryana Enterprise Promotion Act, 2016 that all new/ existing industrial related approvals shall be provided through Online Composite Application Form Only.</p><p class="content-style"><b>Key Features of Composite Application Form are \u2013</b></p><ul class="list-style"><li>Online Application Submission.</li><li>Online Payment without any physical touch point.</li><li>Tracking of Status.</li><li>Auto Fetching of common information in Service Forms.</li><li>Issuance of Certificates from the online portal.</li><li>Email and SMS alerts to the user whenever any action is taken on the CAF</li></ul><h4 class="heading1-style">Ease of Doing Business Initiatives</h4><ul class="list-style"><li>Till 2015, the process of obtaining all industrial related clearness was very cumbersome and time taking as it involved multiple investor touch points. Investor has to coordinate with every department for seeking clearances for setting up a new industry.</li><li>Understanding the criticality of attracting new investments in the state, Govt of Haryana took a path breaking initiative by setting up Haryana Enterprise Promotion Centre in 2016.</li></ul><center><img src="/content/used-images-new/eodb_hepc.png"></center><br><button type="button" class="pull-right btn btn-danger" data-dismiss="modal">Close</button><br><br></div></div></div></div><div class="modal fade" id="dept3" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="heading-style">Haryana Urban Development Authority \u2013 HUDA</h4><h4 class="heading1-style">Introduction</h4><p class="content-style">The Haryana Urban Development Authority (HUDA) is a statutory body under Haryana Urban Development Authority Act, 1977.</p><p class="content-style"><b>The functions of Haryana Urban Development Authority are:-</b></p><ul class="list-style"><li>To promote and secure development of urban areas in a systematic and planned way with the power to acquire sell and dispose off property, both movable and immovable.</li><li>Use this so acquired land for residential, industrial, recreational and commercial purpose.</li><li>To make available developed land to Haryana Housing Board and other bodies for providing houses to economically weaker sections of the society.</li><li>To undertake building works.</li></ul><h4 class="heading1-style">Ease of Doing Business Initiatives</h4><ul class="list-style"><li>The department has implemented web-enabled services that allow online application, payment, tracking and monitoring without the need for a physical touch point for document submission and verification through its Online Services portal.</li><li>The approvals will be delivered under the various laws in a time bound manner, as notified under the Haryana Right to Service Act, 2014.</li><li>The investor is facilitated with online availability on comprehensive information, procedure and checklist for the requisite approvals.</li><li>Online availability of Land Bank data on the department\u2019s web portal without any requirement of login. The user can view the all the industrial plots from the web portal without any requirement of login.</li><li>Developed GIS system providing details about available infrastructure such as road, water, electrical substation and poles etc. The GIS system provides information and details on road infrastructure, water pipelines, sewerage systems, electricity connections and gas pipelines that are available or accessible to each plot of land.</li><li>Haryana has recently released the amended Uniform Building Code 2017.In order to fast track building plan approvals, Uniform Building code has provisioned the approval of building plans considering the risk based classification of buildings depending upon height. Under this provision around 70% (Low risk and Medium Risk) of the establishments have been given the provision for self-certification.</li><li>Computerized system for identifying building/area that needs to be inspected based on risk assessment.</li><li>The buildings are categorized in three risk categories<ul class="list-style"><li><b>Low Risk:</b> Low Risk category includes plotted residential and commercial sites having maximum permissible height up to 15 meters and area up to 1000 square meters; plots (all sizes) of industrial plotted colonies.</li><li><b>Moderate Risk:</b> Moderate Risk category includes commercial sites having maximum permissible height up to 15 meters and area from 1001 square meters to 2000 square meters.</li><li><b>High Risk:</b> High Risk category consists of buildings other than building stated above at (i) and (ii).Under the code</li></ul></li><li>Under Uniform Building Code, Single Joint Inspection has been provisioned with various internal and external agencies for granting construction permits in the state.</li><li>Mandatory qualifications defined for Architects & Structural engineers.</li><li>Auto Scrutiny of Building Plans through Auto DCR software. The software automatically scan building plans and monitor compliance with the building by-laws and building codes in force. Key Features of Auto- DCR \u2013<ul class="list-style"><li>Automated systems has the provision that allows computer verification.</li><li>Simultaneously reduce the risk of human error in the review of the plans.</li><li>Building Plans automatically reviewed for compliance against the building code.</li><li>Once submitted, the plans are scrutinized online without any manual interference.</li></ul></li><li>Online process for allotment of land and defined land allotment criteria on the department\u2019s web portal.</li><li>Online Water Connection Applications with No Inspection of Water Meter thus removing the physical touch point. The applicant has to upload the plumber report mandatorily while for online water connection.</li><li>Dedicated conflict resolution mechanism for any sort of issues.</li><li>For easing the Inspection reforms, following initiatives have been taken-<ul class="list-style"><li>A well-defined inspection procedure and checklist published department\u2019s web site.</li><li>Computerized risk assessment for identifying establishments that need to be inspected.</li><li>Online submission of inspection report within 48 hours to the Department.</li><li>For enabling Inspection transparency, the department has designed computerized allocation of inspectors.</li><li>Inspection reports for last 2 years can be viewed and downloaded by the users.</li></ul></li></ul><button type="button" class="pull-right btn btn-danger" data-dismiss="modal">Close</button><br><br></div></div></div></div><div class="modal fade" id="dept4" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="heading-style">Department of Labour</h4><h4 class="heading1-style">Introduction</h4><p class="content-style">The Labour Department is responsible for the enforcement of various labour laws in which the appropriate government is the state government. These laws provide for basic working conditions, statutory terms of employment including welfare and also for maintenance of industrial relations. This involves other stakeholders\u2019 i.e. the employers and the employees. It is incumbent upon the labour department to not only ensure the implementation of labour laws in letter and spirit but also to maintain a balance in the industrial relation so as to ensure productivity and economic growth.</p><p class="content-style"><b>Key objectives of the department are \u2013</b></p><ul class="list-style"><li>To implement labour laws for ensuring basic statutory working conditions and labour standards.</li><li>To maintain and foster industrial peace and harmony.</li><li>To ensure and promote industrial safety and health.</li><li>To eliminate employment of all forms of child labour.</li><li>To ensure social justice with productivity and growth of industry.</li><li>To provide and promote labour welfare measures for enhancing the quality of life of the work force.</li><li>To create ever-improving conditions for women workers by following policies, which take into account their special needs at the workplace.</li><li>To continuously strengthen and facilitate the functioning of the Labour Courts for adjudication of industrial disputes and claims.</li></ul><h4 class="heading-style">Ease of Doing Business Initiatives</h4><p><b>1. Reform Type \u2013 Payment of Single Integrated Return under all Labour Laws</b></p><ul><li>Need for Reform - Earlier the firms had to file multiple returns, thus increasing the cost of business transaction.</li><li>Impact of Reform - Understanding the challenge faced by firms in filling multiple returns, Haryana has mandated the online filing of single integrated return and applicable payments under all Labour Laws. This reform has brought ease in the existing system as now the investor only has to fill one return online without any physical touch point.</li></ul><p><b>2. Reform Type - Registration under the Shops and Establishment Act is granted within one day</b></p><ul class="list-style"><li>Need for Reform - Inspections were conducted before granting registration. The inspector had to visit the premise to check the authenticity of premise before granting approval thus increasing time and hassle for the entrepreneurs. <b>The total time taken for granting registration was 15 days</b></li><li>Impact of Reform - Eliminated the requirement of inspection prior to registration under the Shops and Establishment Act and <b>registration is granted within one day from the date of application</b></li></ul><p><b>3. Reform Type - Self-Certification Scheme</b></p><ul class="list-style"><li>Need for Reform - Earlier the Government officials had to mandatorily inspect all units,i.e. even those units which are not compromising on the safety, health, social security and welfare of the workers as provided under the various labour enactments.</li><li>Impact of Reform - To liberalize the enforcement of labour laws, Haryana has formulated \u201CSelf-Certification Scheme\u201D for the factories, shops and commercial establishments in the State.</li></ul><p><b>4. Reform Type - Synchronized Joint Inspections</b></p><ul class="list-style"><li>Need for Reform \u2013 From many years there had been arbitrariness and adhocism in the actions of inspecting authorities. There had been a strong need to curb the malpractices and harassment of the industrial and other Establishments with a view to improve the ease of doing business.</li><li>Impact of Reform - The state has launched the Synchronized Joint Inspection wherein the inspection shall be conducted jointly in synchronized manner by the team of maximum three inspecting officers of the labour department. Under Inspection reforms, the department have following key initiatives \u2013<ul class="list-style"><li>The <b>inspecting officers are allocated randomly</b> by the computerized system.</li><li>The <b>inspection report</b> shall be prepared and uploaded within 24 working hours from the date of completion of inspection</li><li><b>Same inspector will not inspect the same establishment twice</b> consecutively.</li><li><b>Low risk industries exempted from labour compliance inspections</b> under all Labour laws.</li></ul></li></ul><p><b>5. Reform Type \u2013 Increasing the validity of registration/contract licenses</b></p><ul class="list-style"><li>Impact of Reform - Labour Department has increased the validity of the licenses and relaxed the norms for limits for obtaining contract license as under -<ul class="list-style"><li><b>Validity of Factory License</b> and all subsequent renewals <b>increased to 10 years.</b></li><li>The limits for <b>obtaining contract license and registration of employer</b> has been <b>raised from 20 to 50 workers</b> under Contract Labour ( R & A) Act, 1970.</li></ul></li></ul><button type="button" class="pull-right btn btn-danger" data-dismiss="modal">Close</button><br><br></div></div></div></div><div class="modal fade" id="dept5" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="heading-style">Department of Land Records</h4><h4 class="heading1-style">Introduction</h4><p class="content-style">Department of land records is responsible for maintaining the state level land record database for the state of Haryana. The whole State is divided into 6 Divisions, 22 Districts, 71 Sub Divisions, 93 Tehsils & 49 Sub-Tehsils, 256 Kanungo circles and 2691 Patwari Circles. Department of Land Records, Haryana uses a specialized tool named \u201CHARIS\u201D- Haryana Registration Information System for deed registration and mutation of land. While registration, a deed is entered in the HARIS system and after regularizing, the deed is registered on the same day of appointment.</p><p class="content-style">The department has also issued a mandate for \u201Ce-Registration\u201D and \u201Ce- stamping\u201D to ensure that the user is facilitated by online application, online document verification and making secured e-payments.</p><p class="content-style">Haryana uses \u201Ce-Registration\u201D- Appointment Management System (AMS). The user will follow the following process for appointment and online payment processes:</p><ul class="list-style"><li>Auto Calculation of Stamp Duty Amount on web portal.</li><li>Checking the appointment slot availability online.</li><li>Paying for Stamp and Registration Fee online at E- GRAS portal.</li><li>Auto- Appointment generation at respective SRO office.</li><li>Online payment by using E- Stamp.</li></ul><h4 class="heading-style">Ease of Doing Business Initiatives</h4><ul class="list-style"><li><b>Registration of transaction deed in a single day:</b>Registration of the transaction deed is provided to related parties on the same day of appointment. The Department of land records has made the provision of online registration of land deeds in all State Registrar offices - SROs of the state. The verification of land details is done via specialized HARIS (Haryana Registration Information System) and HALRIS (Haryana Land Record Information System) software, where the real time transaction of deed is captured thus allowing the parties to register the deed on the same day of appointment.</li><li>Online <b>Auto Calculator</b> for Stamp Duty Calculation on <a href="http://jamabandi.nic.in">http://jamabandi.nic.in </a>. By entering the Transaction value of the property, the calculator will auto calculate the property Stamp Duty and Reg. Fee to be paid.</li><li><b>Online Appointment Management system</b> for registration of deeds at every Sub Registrar office. The online appointment system has the facility of auto generation of appointment (date and time) on making the required payment online at respective SRO offices</li><li>The <b>online system</b> developed by the department allows user to download the Registry certificate from the department\u2019s web portal i.e.<a href="http://jamabandi.nic.in"> http://jamabandi.nic.in </a>.</li><li>The department has <b>integrated the mutation process with the registration process and allowing intimation of mutation as soon as the deed is registered.</b> This integration includes not only the data-sharing, but also focuses on process integration. This allows the newly registered deeds for property sales to automatically initiate the mutation process. The process also reduces the number of interfaces between the user and the state government and thus promotes greater transparency.</li><li>Digitization of cadastral maps for all the rural area on the department\u2019s web portal i.e. <a href="http://jamabandi.nic.in">http://jamabandi.nic.in </a>.The cadastral map is a map defining land ownership and shows all registered geospatial data relating to registered plots. The cadastral map designed by the department consists of cadastral units, each of which represents a single registered plot of land.</li><li>Integration of land record databases with Judicial database (Revenue) to provide complete picture of current land disputes on the department\u2019s web portal. An individual can check the status of Revenue cases on the property from the integrated database without any requirement of login.</li><li>Mandating online fee submission while registering of property through E- Stamping only</li></ul><button type="button" class="pull-right btn btn-danger" data-dismiss="modal">Close</button><br><br></div></div></div></div><div class="modal fade" id="dept6" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="heading-style">Department of Industries & Commerce Haryana \u2013 I&C</h4><h4 class="heading1-style">Introduction</h4><p class="content-style">The Industries & Commerce Department, Haryana, is responsible for the development of industrial sector in the State. It functions as the nodal department to promote industries and to facilitate the entrepreneurs in setting up of Industries in the State. The role of the department is promotional and that of a motivator. Potential entrepreneurs are advised regarding availability of land, procedure for allotment of land, conversion of land use, incentives and concessions available to the industry, pollution control and other clearances required and facilities available from other Government departments / agencies.</p><p class="content-style">It is also the nodal department of the State for implementation of Central Government policies relating to the manufacturing and commerce. To that end, it is responsible for provision of a policy framework, facilitation and advisory services for ease of starting businesses, drive the industrial infrastructure development for provision of developed land for the industrial ventures and coordinates with various related government departments (i.e. Commercial Taxes, Labour, Town & Country Planning, Pollution Control Board etc.) for various clearances and enforcement of the regulatory requirements.</p><h4 class="heading1-style">Reforms</h4><ul class="list-style"><li>The Department of Industries & Commerce has notified the Enterprise Promotion Policy 2015 through 1/16/2012-1FD-III dated 10th August, 2015 following a detailed consultative process with all the stakeholders with a vision of generating investments of more than Rs.1 lakh crore and providing employment to in excess of 4 lakh.</li><li>The state launched the Single Window Service through the Invest Haryana Portal (investharyana.nic.in) with the vision of online approvals, deemed clearances and time bound delivery of services mandated by legislation with minimum human interface.</li><li>The Haryana Enterprise Promotion Board under the Haryana Enterprise Promotion Act 2016 was constituted to ensure ease of doing business for the promotion of industrial development and facilitation of new investments. Under the supervision and guidance of HEPB, a two tier system consisting of an Empowered Executive Committee (EEC) and District Level Clearance Committee (DLCC) in each district shall function for grant of project clearances.</li><li>To enable the investors and providing transparency by setting up the 3-tier grievance redressal system consisting of:</li><ul class="list-style"><li>Apex Level Grievance Committee under the Chairmanship of the Chief Minister, Haryana.</li><li>State Level Grievance Committee headed by Administrative Secretary of Industries & Commerce Department.</li><li>District Level Grievance Committee headed by the Deputy Commissioner.</li></ul><li>With the aim to promote the investment environment and facilitate queries regarding the application and approval process the State has operationalized two central helpline numbers, one dedicated to Japanese Investors.</li></ul><h4 class="heading-style">Ease of Doing Business Initiatives</h4><ul class="list-style"><li>The department has provisioned for promoting regulatory certainty for business by allowing stakeholders the opportunity to review and provide feedback on draft regulations before they are enacted. Since the regulations that are compiled with stakeholder input tend to feature higher compliance and impose a lower burden in terms of enforcement as well as compliance.</li><li>The State has enacted legislation to mandate time bound delivery of services to business/investors by enforcement of Haryana Right to Service Act, 2014. The act also defines punitive provisions that deter officials from not complying with the defined timelines for services being provided to Industries/ Businesses along with clear procedures for applicants to submit grievances relating to non-compliance with the defined timelines.</li><li>The incentives under Industrial Policy are provided as a service through the online single window system- HEPC in a manner that allows online application, payments, tracking of status and approvals.</li><li>The department has implemented web-enabled services that allow online application, payment, tracking and monitoring without the need for a physical touch point for document submission and verification for issuance and renewal of boiler license.</li><li>The department has provisioned third party certification for boilers during use u/s 34(3) of the Boilers Act, 1923, by persons having requisite qualification and experience.</li><li>Provisioning of third party certifications by empaneled Boiler Operations Engineer \u2013 BOE.</li><li>The investor is facilitated with online availability on comprehensive information, procedure and checklist for the requisite approvals.</li><li>For making the online system transparent, tracking process have been enabled in the system to track the status of the application at any point of the application approval cycle.</li></ul><button type="button" class="pull-right btn btn-danger" data-dismiss="modal">Close</button><br><br></div></div></div></div><div class="modal fade" id="dept7" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="heading-style">Town & Country Planning Department, Haryana \u2013 TCP</h4><h4 class="heading1-style">Introduction</h4><p class="content-style">The Department of Town & Country Planning, Haryana is the nodal department to enable regulated urban development in the State of Haryana. The policies of the department aim at encouraging a healthy competition amongst various private developers and public sector entities for integrated planned urban development. The department also renders advisory services to various Departments / Corporations / Boards such as HSVP, Housing Board, HSIIDC, and Marketing Board. To name a few major functions of the department are given as under:-</p><ul class="list-style"><li>Prevention of unauthorized and haphazard construction and regulation of planned urban development under the provision of Punjab Scheduled Roads and Controlled Areas Restriction of Unregulated Development Act, 1963 by declaring controlled areas around towns and public institutions, preparation of their development plans and sectorial plans for planned urban development.</li><li>To regulate the development of colonies in order to prevent ill-planned and haphazard urbanization in or around the towns under the provision of the Haryana Development and Regulation of Urban Areas Act, 1975.</li><li>Prevention of unauthorized constructions and regulation of planned urban development under the provision of the Punjab New Capital Periphery (Control) (Haryana Amendment) Act, 1971 applicable around Chandigarh in Panchkula District.</li></ul><p class="content-style">To cater to needs of society, Haryana Urban Development Authority; a statutory body is executing the urban development projects in various towns. However in order to meet the requirement of different uses, the department is also granting licenses to the private colonizers to develop residential and commercial colonies in urban areas under the provisions of the Haryana Development and Regulation of Urban Areas Act, 1975.</p><h4 class="heading-style">Ease of Doing Business Initiatives</h4><ul class="list-style"><li>The approvals will be delivered under the various laws in a time bound manner, as notified under the Haryana Right to Service Act, 2014.</li><li>The investor is facilitated with online availability of comprehensive information, procedures and a checklist containing the requisite approvals.</li><li>Haryana has recently released the amended Uniform Building Code 2017.In order to fast track building plan approvals, Uniform Building code has provisioned the approval of building plans considering the risk based classification of buildings depending upon height. Under this provision around 70% (Low risk and Medium Risk) of the establishments have been given the provision for self-certification.</li><li>Computerized system for identifying building/area that needs to be inspected based on risk assessment.</li><li>The buildings are categorized in three risk categories<ul class="list-style"><li><b>Low Risk:</b>Low Risk category includes plotted residential and commercial sites having maximum permissible height up to 15 meters and area up to 1000 square meters; plots (all sizes) of industrial plotted colonies.</li><li><b>Moderate Risk:</b> Moderate Risk category includes commercial sites having maximum permissible height up to 15 meters and area from 1001 square meters to 2000 square meters.</li><li><b>High Risk:</b> High Risk category consists of buildings other than the buildings stated above in (i) and (ii).</li></ul></li><li>Under Uniform Building Code, Single Joint Inspection has been provisioned with various internal and external agencies for granting construction permits in the state.</li><li>Availability of Master plans online for information to stakeholders.</li><li>Clear timelines defined for Change of land Use, building plan approvals .</li><li>Clear process definition for approvals & inspections.</li><li>Mandatory qualifications defined for Architects & Structural engineers.</li><li>Dedicated conflict resolution mechanism for any sort of issues.</li><li>For easing the Inspection reforms, following initiatives have been taken-<ul class="list-style"><li>A well-defined inspection procedure and checklist has been published on the departmental website</li><li>Computerized risk assessment for identifying establishments that need to be inspected</li><li>Online submission of inspection report within 48 hours by the Department</li><li>For enabling Inspection transparency, the department has designed computerized allocation of inspectors</li><li>Inspection reports for last 2 years can be viewed and downloaded by the users</li></ul></li></ul><button type="button" class="pull-right btn btn-danger" data-dismiss="modal">Close</button><br><br></div></div></div></div><div class="modal fade" id="dept8" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="heading-style">Urban Local Bodies, Haryana \u2013 ULB</h4><h4 class="heading1-style">Introduction</h4><p class="content-style">The 74th Constitutional Amendment Act of India lays the foundation for a sustainable Urban Governance System in the Country. While the national governments pursue the goals of economic development, it is generally left for the local governments to manage the rapidly growing urban areas, and to provide the basic services to the residents. To have better co-ordination and control on the working of municipalities in the State, the Directorate of Urban Local Bodies Department, Haryana was established on 1st April, 1982. The Department was established to give impetus to the 74th Amendment of the Constitution and to lay a solid foundation for the Urban Development in the State of Haryana.</p><p class="content-style">The broad functions of the Directorate of Urban Local Bodies Department, Haryana are as given under:</p><ul class="list-style"><li>To provide the policy framework for the Urban Development in the State of Haryana.</li><li>To facilitate the working of the Urban Local Bodies in the State.</li><li>To maintain the civic amenities in the State.</li></ul><h4 class="heading-style">Ease of Doing Business Initiatives</h4><ul class="list-style"><li>The department has implemented web-enabled services that allow online application, payment, tracking and monitoring without the need for a physical touch point for document submission and verification through its Online Services portal.</li><li>The approvals will be delivered under the various laws in a time bound manner, as notified under the Haryana Right to Service Act, 2014</li><li>The investor is facilitated with online availability on comprehensive information, procedure and checklist for the requisite approvals</li><li>Haryana has recently released the amended Uniform Building Code 2017.In order to fast track building plan approvals, Uniform Building code has provisioned the approval of building plans considering the risk based classification of buildings depending upon height. Under this provision around 70% (Low risk and Medium Risk) of the establishments have been given the provision for self-certification.</li><li>Computerized system for identifying building/area that needs to be inspected based on risk assessment</li><li>The buildings are categorized in three risk categories<ul class="list-style"><li><b>Low Risk:</b> Low Risk category includes plotted residential and commercial sites having maximum permissible height up to 15 meters and area up to 1000 square meters; plots (all sizes) of industrial plotted colonies.</li><li><b>Moderate Risk:</b> Moderate Risk category includes commercial sites having maximum permissible height up to 15 meters and area from 1001 square meters to 2000 square meters.</li><li><b>High Risk:</b> High Risk category consists of buildings other than building stated above at (i) and (ii).Under the code</li></ul></li><li>Under Uniform Building Code, Single Joint Inspection has been provisioned with various internal and external agencies for granting construction permits in the state.</li><li>Clear timelines defined for Change of land Use, building plan approvals & Fire NOC</li><li>Availability of Master plans online for information to stakeholders</li><li>Facility to download & verify final approval certificate from website</li><li>Clear process definition for approvals & inspections</li><li>Mandatory qualifications defined for Architects & Structural engineers</li><li>Dedicated conflict resolution mechanism for any sort of issues</li><li>Online Water Connection Applications with No Inspection of Water Meter thus removing the physical touch point. The applicant has to upload the plumber report mandatorily while for online water connection</li><li>For easing the Inspection reforms, following initiatives have been taken-<ul class="list-style"><li>A well-defined inspection procedure and checklist published department\u2019s web site</li><li>Computerized risk assessment for identifying establishments that need to be inspected</li><li>Online submission of inspection report within 48 hours to the Department</li><li>For enabling Inspection transparency, the department has designed computerized allocation of inspectors</li><li>Inspection reports for last 2 years can be viewed and downloaded by the users</li></ul></li></ul><button type="button" class="pull-right btn btn-danger" data-dismiss="modal">Close</button><br><br></div></div></div></div><div class="modal fade" id="dept9" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="heading-style">Haryana State Industrial and Infrastructural Development Corp. \u2013 HSIIDC</h4><h4 class="heading1-style">Introduction</h4><p class="content-style">HSIIDC is a company incorporated on 08.03.1967, under the provisions of the Companies Act, 1956 with the objectives to develop industrial infrastructure in the State of Haryana under the aegis of Department of Industries and Commerce, Haryana. 100% equity of the Corporation is held by the State Government and as such the Corporation is a Government Company under section 617 of the Companies Act.</p><p class="content-style">Today, 50 years after its inception and transforming the State, it is a premier institution in infrastructure development for industrial promotion and investment facilitation. It has played a key role in the well-being and progress of Haryana and has been instrumental in the evolution of Haryana from a primarily agrarian State to one of the highly industrialized States in the country. HSIIDC has clearly set a new order in motion in the State, resounding with greater progress and prosperity.</p><h4 class="heading-style">Ease of Doing Business Initiatives</h4><ul class="list-style"><li>The department has implemented web-enabled services that allow online application, payment, tracking and monitoring without the need for a physical touch point for document submission and verification through its Online Services portal.</li><li>The approvals will be delivered under the various laws in a time bound manner, as notified under the Haryana Right to Service Act, 2014</li><li>The investor is facilitated with online availability on comprehensive information, procedure and checklist for the requisite approvals</li><li>Online availability of Land Bank data on the department\u2019s web portal without any requirement of login. The user can view the all the industrial plots from the web portal without any requirement of login</li><li>Developed GIS system providing details about available infrastructure such as road, water, electrical substation and poles etc. The GIS system provides information and details on road infrastructure, water pipelines, sewerage systems, electricity connections and gas pipelines that are available or accessible to each plot of land.</li><li>Haryana has recently released the amended Uniform Building Code 2017.In order to fast track building plan approvals, Uniform Building code has provisioned the approval of building plans considering the risk based classification of buildings depending upon height. Under this provision around 70% (Low risk and Medium Risk) of the establishments have been given the provision for self-certification.</li><li>The buildings are categorized in three risk categories<ul class="list-style"><li><b>Low Risk:</b> Low Risk category includes plotted residential and commercial sites having maximum permissible height up to 15 meters and area up to 1000 square meters; plots (all sizes) of industrial plotted colonies.</li><li><b>Moderate Risk:</b> Moderate Risk category includes commercial sites having maximum permissible height up to 15 meters and area from 1001 square meters to 2000 square meters.</li><li><b>High Risk:</b> High Risk category consists of buildings other than building stated above at (i) and (ii).Under the code</li></ul></li><li>Under Uniform Building Code, Single Joint Inspection has been provisioned with various internal and external agencies for granting construction permits in the state.</li><li>Mandatory qualifications defined for Architects & Structural engineers</li><li>Auto Scrutiny of Building Plans through Auto DCR software.</li><li>Online process for allotment of land and defined land allotment criteria on the department\u2019s web portal</li><li>Online Water Connection Applications with No Inspection of Water Meter thus removing the physical touch point. The applicant has to upload the plumber report mandatorily while for online water connection</li><li>Dedicated conflict resolution mechanism for any sort of issues</li><li>For easing the Inspection reforms, following initiatives have been taken-<ul class="list-style"><li>A well-defined inspection procedure and checklist published department\u2019s web site</li><li>Computerized risk assessment for identifying establishments that need to be inspected</li><li>Online submission of inspection report within 48 hours to the Department</li><li>For enabling Inspection transparency, the department has designed computerized allocation of inspectors</li><li>Inspection reports for last 2 years can be viewed and downloaded by the users</li></ul></li></ul><button type="button" class="pull-right btn btn-danger" data-dismiss="modal">Close</button><br><br></div></div></div></div><div class="modal fade" id="dept10" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="heading-style">Haryana State Pollution Control Board \u2013 HSPCB</h4><h4 class="heading1-style">Introduction</h4><p class="content-style">The functions and responsibilities of the Board are as under:-</p><ul class="list-style"><li>To plan a comprehensive program for the prevention, control or abatement of pollution of streams and wells as well as of air in the State and to secure the execution thereof</li><li>To advise the State Government on any matter concerning the prevention, control or abatement of Pollution.</li><li>To collect and disseminate information relating to pollution and the prevention, control or abatement thereof</li><li>To encourage, conduct and participate in investigations and research relating to problems of pollution and prevention, control or abatement of pollution.</li><li>To collaborate with the Central Board in organizing the training of persons engaged or to be engaged in programs relating to prevention, control or abatement of pollution and to organize mass education programs relating thereto :</li><li>To inspect sewage or trade effluents, works and plants for the treatment of sewage and trade effluents and to review plans, specifications or other data relating to treatment plants and the system for the disposal of sewage or in connection with the grant of any consent as required by this act</li><li>To lay down, modify or annul effluent standards for the sewage and trade effluents and for the quality of receiving waters (not being water in an interstate stream) resulting from the discharge of effluents and to classify waters of the State</li><li>To evolve economical and reliable methods of treatment of sewage and trade effluents, having regard to the peculiar conditions of soils, climate and water resources of different regions and more especially the prevailing flow characteristics of water in streams and wells which render it impossible to attain even the minimum degree of dilution</li><li>To evolve methods of utilization of sewage and suitable trade effluents in agriculture</li><li>To evolve efficient methods of disposal of sewage and trade effluents on land, as are necessary on account of the predominant conditions of scant stream flows that do not provide for major part of the year the minimum degree of dilution</li><li>To lay down standards of treatment of sewage and trade effluents to be discharged into any particular stream taking into account the minimum fair weather dilution available in that stream and the tolerance limits of pollution permissible in the water of the stream, after the discharge of such effluents</li><li>To make, vary or revoke any order<ul class="list-style"><li>For the prevention, control or abatement or discharges of waste into streams or wells;</li><li>Requiring any person concerned to construct new systems for the disposal of sewage and trade effluents or to modify, alter or extend any such existing system or to adopt such remedial measures as are necessary to prevent, control or abate water pollution</li><li>To lay down effluent standards to be complied with by persons while causing discharge of sewage or sludge or both and to lay down, modify or annul effluent standards for the sewage and trade effluents</li><li>To Grant authorization under Hazardous Waste (Management & Handling) Rules, 1989.</li><li>To Grant authorization under Bio-Medical Waste (Management & Handling) Rules, 1998.</li><li>To implement the provisions of Noise pollution (Regulations & Rules)</li><li>To implement the provisions of the Manufacture, Use, Import, Export and Storage of Hazardous Micro-Organism Genetically Engineered Organism or Cells Rules, 1989.</li><li>To implement the provisions of the Manufacture, Storage and Import of Hazardous Chemicals Rules, 1989, as amended to date.</li><li>To implement the provisions of the Chemical Accidents (Emergency Planning, Preparedness and Response) Rules, 1996.</li><li>To implement the provisions of the Recycled Plastics Manufacture and Usage Rules</li><li>To implement the provisions of the Ozone Depleting Substances (Regulation) Rules, 2000.</li><li>To implement the provisions of the Batteries (Management and Handling) Rules, 2001.</li><li>To implement the provisions of Control of Solid Waste Management under Notification of Solid Waste Management issued by the Ministry of Environment, Govt. of India vide No. SO 908 (E) dated 25.9.2000.</li><li>To advise the State Government with respect to the location of any industry the carrying on of which is likely to pollute a stream or well or suitability of any premises or location for carrying on any industry which is likely to cause air pollution.</li></ul></li></ul><h4 class="heading-style">Ease of Doing Business Initiatives</h4><ul class="list-style"><li><b>Key Reform area \u2013 Exemption of Green industries from compliance inspection</b><ul class="list-style"><li>Need for Reform- The objective of the reform is to promote a differentiated and streamlined inspection environment for businesses on the basis of their Environmental risk.</li><li>Impact of the Reform \u2013 HSPCB has exempted the Green Industries with satisfactory history from compliance inspections and have also provisioned for self-certification</li></ul></li><li><b>Key Reform area \u2013 Auto-renewal of Consent to Establish and Consent to Operate</b><ul class="list-style"><li>Need for Reform- As observed, separate processes to renew Consents to Establish and Operate annually impose costs upon both the state government as well on enterprises. For state governments, annual renewals imply repeated paperwork, inspection and costs associated with recruiting and maintaining sufficient manpower to carry out the annual checks and reregistration. However, in many cases, there are no changes in pollution levels or activities \u2013 therefore, the exercise is only repeated annually, thereby imposing repeated costs on the department and the entrepreneur. Therefore the board considered the reform for enabling auto- renewal of CTE/CTO to reduce multiple touch points for an investor.</li><li>Impact of the Reform \u2013 Haryana has the facility of granting auto- renewal of consent to establish and consent to operate based on self-certification/third party certification. Majority of establishments have already availed this provision till date</li></ul></li><li><b>Key Reform area \u2013 Categorization of industry into White, Green, Orange and Red based on their pollution and discharge potential</b><ul class="list-style"><li>Need for Reform- The categorization of industry will help differentiate inspection regime defining a clear notification that outlines the process for each type of industry, and also mandates the frequency of inspections for Amber and Red<industries class=""></industries></li><li>Impact of the Reform \u2013 Haryana has categorized industries into White, Green, Orange and Red categories for consent management.For white industries, the state has done away with pollution control board clearances / mandatory inspections and replaced them with need-based inspections which are only invoked in case there are specific complaints. Green Industries are exempted from the compliance Inspections and are provisioned with self-certification. The inspection regime for amber and red industries is differentiated, with less frequent inspections for Amber and more frequent inspections for Red industries and firms.</li></ul></li><li><b>Key Reform area \u2013 Inspection Related Reforms</b><ul class="list-style"><li>Need for Reform \u2013 To increase the transparency and accountability, HSPCB has taken following reforms to ease the Inspection processes \u2013<ul class="list-style"><li><b>Allowing third party certifications</b> under all the environment/pollution laws for medium risk industries</li><li><b>Computerized risk assessment</b> for identifying establishments that need to be inspected</li><li>Online submission of <b>inspection report within 48 hours</b> to the Department</li><li>For enabling Inspection transparency, the department has designed <b>computerized allocation of inspectors</b></li><li><b>Well defined inspection policy</b> of the Board implemented & published on the Board\u2019s website</li><li><b>White category has been exempted from clearances</b> and inspection governed by self-regulatory regime</li><li>The department has mandated that no inspector will visit the same establishment twice for inspection</li></ul></li></ul></li></ul><button type="button" class="pull-right btn btn-danger" data-dismiss="modal">Close</button><br><br></div></div></div></div><div class="modal fade" id="dept11" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-body"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="heading-style">Department of Power \u2013 Uttar Haryana Bijli Vitran Nigam/ Dakshin Haryana Bijli Vitran Nigam</h4><h4 class="heading1-style">Introduction</h4><p class="content-style">Haryana Power sector comprises four wholly State-owned Corporations viz HPGCL, HVPNL, UHBVNL and DHBVNL which after unbundling of the HSEB in 1998 are responsible for power generation, transmission, distribution and trading in the State. These utilities and the HERC work under the administrative control of the Deptt. Of Power which is headed by Principal Secretary, Power.</p><p class="content-style">The State power sector was restructured on August 14, 1998. The Haryana State Electricity Board (HSEB) was reorganized initially into two State-owned Corporations namely Haryana Vidyut Prasaran Nigam Ltd. (HVPN) and responsible for operation and maintenance of State\'s own power generating stations. HVPNL was entrusted the power transmission and distribution functions. Simultaneously, an independent regulatory body i.e. Haryana Electricity Regulatory Commission (HERC), was constituted to aid and advise the State Govt. on the development of the power sector, to regulate the power utilities and take appropriate measure to balance the interest of various stake-holders in the power sector, namely electricity consumers, power entities and generation companies etc.</p><p class="content-style">HVPNL was further reorganized on July 1, 1999 by carving out two more Corporations, namely Uttar Haryana Bijli Vitran Nigam Ltd. (UHBVNL) and Dakshin Haryana Bijli Vitran Nigam Ltd. (DHBVNL) with the responsibility of distribution and retail supply of power within their jurisdiction. While UHBVNL is responsible for Panchkula, Ambala, Yamunanagar, Kurukshetra, Kaithal, Karnal, Panipat, Sonepat, Rohtak, Jhajjar and Jind districts, DHBVN caters to Hisar, Fatehabad, Bhiwani, Sirsa, Faridabad, Gurgaon, Mewat, Rewari and Narnaul districts. The distribution companies are at the moment serving about 41 lac consumers of different categories. The Haryana Power Utilities (HPUs) are making a befitting contribution to the overall development of the State. The grain yield has greatly enhanced and the overall production has gone up.</p><h4 class="heading-style">Ease of Doing Business Initiatives</h4><ul class="list-style"><li><b>Key Reform area \u2013 Easing regulatory Reforms for obtaining Electricity Connection</b><ul class="list-style"><li>Need for Reform - Earlier proofs required for obtaining electricity connection: Proof of Ownership/Occupancy, Identity Proof, Test Report and Architect\u2019s Certificates, Address Proof</li><li>Impact of the Reform - Understanding the complexity of obtaining electricity connection, the department realized the importance of easing the regulatory reforms. The major regulatory reforms taken are as under<ul class="list-style"><li><b>Self-certification</b> for applying for load under 11KW</li><li><b>Reduced the number of documents</b> required for obtaining the electricity connection to only two i.e. proof of ownership/occupancy and authorization document (in case of firm/company)</li><li>Facilitating users to apply for the electricity connection online with the provision of online application, payment of fee, uploading documents online and downloading the final load release document online through the department\u2019s web portal</li><li>Fixed cost estimation based on the load (KVA/KW) required for obtaining electricity connection through the online portal in all industrial areas of States</li><li>Provisioned third party inspection of internal installations</li><li>Third parties can also easily verify the authenticity of the certificates on the public domain without any requirement of login</li></ul></li></ul></li><li><b>The department has also taken following key reforms to make the system more transparent and efficient</b><ul class="list-style"><li>Publishing monthly or quarterly data regarding total duration and frequency of outages online in public domain</li><li>Total outage cap is fixed by the department for a quarter/year and compensations for outages are given to customers over the fixed cap</li><li>Charged electrical connections (up to 150 KVA) is provided within Seven days (where no \u2018Right of Way\u2019 (RoW) is required) and in Fifteen days where RoW is required from concerned agencies</li></ul></li></ul><button type="button" class="pull-right btn btn-danger" data-dismiss="modal">Close</button><br><br></div></div></div></div>');
$templateCache.put('app/eodb-notifications/eodb-notifications.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">EODB Notifications</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li class="active"><span>EODB Notifications</span></li></ol></div></section><br><div class="container"><div class="row"><div class="col-md-12"><table class="table table-striped table-hover" ng-switch="vm.isAuthenticated()"><thead><tr class="headerGrid"><th>S.No</th><th>Title</th><th>Documents</th></tr></thead><tbody><tr><td>1</td><td>Notification of Haryana Govt. Gazette dated 07.11.2024 regarding composition of District Coordination Committee (DCC) for PM Gati Shakti NMP</td><td><a target="_blank" href="../../content/pdfs/DCC_PM Gati Shakti.pdf">Download</a></td></tr><tr><td>2</td><td>Notification of service under Haryana Right to Service Act, 2014 - Haryana Enterprises Promotion Centre (Industries & Commerce)</td><td><a target="_blank" href="../../content/pdfs/RTS_Notification_HEPC.pdf">Download</a></td></tr><tr><td>3</td><td>ULB_ THE HARYANA MUNICIPAL (AMENDMENT) ACT, 2022, Dated 22.08.2022</td><td><a target="blank" href="../../content/pdfs/ULB_ THE HARYANA MUNICIPAL (AMENDMENT) ACT, 2022, Dated 22.08.2022_3.pdf">Download</a></td></tr><tr><td>4</td><td>ULB_THE HARYANA MUNICIPAL CORPORATION (AMENDMENT) ACT, 2022, dated 22.08.2022</td><td><a target="blank" href="../../content/pdfs/ULB_THE HARYANA MUNICIPAL CORPORATION (AMENDMENT) ACT, 2022, dated 22.08.2022_4.pdf">Download</a></td></tr><tr><td>5</td><td>ULB_Mandate Order for Sustainable Water Use practices Rainwater Harvesting</td><td><a target="blank" href="../../content/pdfs/ULB_Mandate Order for Sustainable Water Use practices Rain Water Harvesting_5.pdf">Download</a></td></tr><tr><td>6</td><td>ULB_Order for Trade Licence in Municipalities</td><td><a target="blank" href="../../content/pdfs/ULB_Order for Trade Licence in Municipalities_6.pdf">Download</a></td></tr><tr><td>7</td><td>ULB_Order for Trade Licence in Municipal Corporations</td><td><a target="blank" href="../../content/pdfs/ULB_Order for Trade Licence in Municipal Corporations_7.pdf">Download</a></td></tr><tr><td>8</td><td>Fire_Mandate Order_Fire License_NoC</td><td><a target="blank" href="../../content/pdfs/Fire_Mandate Order_Fire License_NoC_8.pdf">Download</a></td></tr><tr><td>9</td><td>HSIIDC_ Mandate Order_Land Allotment & Water Connection</td><td><a target="blank" href="../../content/pdfs/HSIIDC_ Mandate Order_Land Allotment & Water Connection_9.pdf">Download</a></td></tr><tr><td>10</td><td>PHED_Mandate Orders _BRAP 2024</td><td><a target="blank" href="../../content/pdfs/PHED_Mandate Orders _BRAP 2024_10.pdf">Download</a></td></tr><tr><td>11</td><td>HSPCB_Mandate Order_Online Dashboard_CTO</td><td><a target="blank" href="../../content/pdfs/HSPCB_Mandate Order_Online Dashboard_CTO_11.pdf">Download</a></td></tr><tr><td>12</td><td>HSPCB_Mandate Order_Online Dashboard_Under Nine Acts or Rules</td><td><a target="blank" href="../../content/pdfs/HSPCB_Mandate Order_Online Dashboard_Under Nine Acts or Rules_12.pdf">Download</a></td></tr><tr><td>13</td><td>Dashboard Mandate Order of the Department of Forest, Haryana</td><td><a target="blank" href="../../content/pdfs/Dashboard_Mandate_Forest_Deptt_23_12_2024_13.pdf">Download</a></td></tr><tr><td>14</td><td>Office Order for the Service "Tree Transit Permission" - Department of Forest, Haryana</td><td><a target="blank" href="../../content/pdfs/Office_Order_Forest-Tree_Tranist_letter_MIS_18_23_12_2024_14-2.pdf">Download</a></td></tr><tr><td>15</td><td>Dashboard Mandate Order of the Department Excise & Taxation, Haryana</td><td><a target="blank" href="../../content/pdfs/Notiifcation_Excise&Taxation_15-1.pdf">Download</a></td></tr><tr><td>16</td><td>Dashboard Mandate Order of the Department Industries & Commerce, Haryana</td><td><a target="blank" href="../../content/pdfs/Notification_Industries_16.pdf">Download</a></td></tr><tr><td>17</td><td>Dashboard Mandate Order for Boiler Services (Department Industries & Commerce), Haryana</td><td><a target="blank" href="../../content/pdfs/Notification_Boiler_Services_17.pdf">Download</a></td></tr><tr><td>18</td><td>Dashboard Mandate Order for Grievance Redressal System, Haryana</td><td><a target="blank" href="../../content/pdfs/Notification_Grievance_office_order_18.pdf">Download</a></td></tr><tr><td>19</td><td>Check List and Procedure document for department of Forest, Haryana</td><td><a target="blank" href="../../content/pdfs/Checklist_procedure_Forest_BRAP_2024.pdf">Download</a></td></tr><tr><td>20</td><td>Check List and Procedure document for department of Industries & Commerce (Firm & Society)</td><td><a target="blank" href="../../content/pdfs/Checklist and Procedure for Firm and Societies.pdf">Download</a></td></tr><tr><td>21</td><td>Dashboard Mandate Order for department of Industries & Commerce (Firm & Society)</td><td><a target="blank" href="../../content/pdfs/Mandate Order Dashboard Firms & Society (1).pdf">Download</a></td></tr><tr><td>22</td><td>Office Order for Forest based Enterprises, Haryana State Rural Livelihoods Mission (HSRLM), under the Rural Development Department, Government of Haryana</td><td><a target="blank" href="../../content/pdfs/HSRLM Response.pdf">Download</a></td></tr><tr><td>23</td><td>HSIIDC-Mandate Order for Sewerage Connection</td><td><a target="blank" href="../../content/pdfs/HSIIDC_Mandate Order_Sewerage Connection_ BRAP 328 HSIIDC.pdf">Download</a></td></tr><tr><td>24</td><td>Mandate Order for Department of Land Records</td><td><a target="blank" href="../../content/pdfs/mandate_Departmet_of_Land_record.pdf">Download</a></td></tr><tr><td>25</td><td>Office order for Excise Verification Certificate, Department of Excise & Taxation, Haryana</td><td><a target="blank" href="../../content/pdfs/Office order-EXciseVerificationCertificate.pdf">Download</a></td></tr><tr><td>26</td><td>Mandate Order for the Right to Service Act, 2014, regarding the Connection and Connectivity Infrastructure Policy, Haryana (DITECH)</td><td><a target="blank" href="../../content/pdfs/Notification_RTS_CCIP.pdf">Download</a></td></tr><tr><td>27</td><td>Mandate Order for the Right to Service Act, 2014, regarding Film Shooting Permission under the Department of Information, Public Relations, and Languages, Haryana</td><td><a target="blank" href="../../content/pdfs/Notification_RTS_Movie Shooting.pdf">Download</a></td></tr><tr><td>28</td><td>Mandate Order for the Right to Service Act, 2014, regarding Cinema Hall Permissions under the Department of Home, Haryana</td><td><a target="blank" href="../../content/pdfs/Notification_Cinema Hall.pdf">Download</a></td></tr><tr><td>29</td><td>Mandate order for inclusion of any new services in the online wizard/system (NSWS) within 30 days after it is introduced on State-Single Window System</td><td><a target="blank" href="../../content/pdfs/1_BRAP_Notification_NSWS_30_days.pdf">Download</a></td></tr><tr><td>30</td><td>Mandate Order for capturing PAN details for each profile or business approval-related transaction</td><td><a target="blank" href="../../content/pdfs/6_BRAP_Notification_NSWS_PAN.pdf">Download</a></td></tr><tr><td>31</td><td>Mandate Order for the Haryana Single Window System, which has developed the dashboards as per the prescribed format</td><td><a target="blank" href="../../content/pdfs/7_BRAP_Notification_NSWS_Dashboard.pdf">Download</a></td></tr><tr><td>32</td><td>Mandate order for Startup Dashboard</td><td><a target="blank" href="../../content/pdfs/mandate_dashboard_Startup.pdf">Download</a></td></tr><tr><td>33</td><td>Mandate order to review District Export Action Plans on fortnightly basis</td><td><a target="blank" href="../../content/pdfs/33. Periodic review of DEAPs.pdf">Download</a></td></tr><tr><td>34</td><td>Establishment of an ODOP Facilitation Centre</td><td><a target="blank" href="../../content/pdfs/34. ODOP cell.pdf">Download</a></td></tr><tr><td>35</td><td>Mandate order to conduct at least four District Export Promotion Committee meetings annually</td><td><a target="blank" href="../../content/pdfs/35. Four DEPC Meetings letter.pdf">Download</a></td></tr><br></tbody></table></div></div></div>');
$templateCache.put('app/eodbdashboardyearly/eodbdashboardyearly.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">EODB Dashboard</h1><p><span class="text-danger">*</span> Data of services applied after 01-January-2022</p></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Service Dashboard</span></li></ol></div></section><style>/* The summary table carries 11 columns, so the theme\'s default 20px/30px cell\n       padding has to be tightened for them to fit on one line. Scoped to this table. */\n    .table_template.eodb-summary-table td,\n    .table_template.eodb-summary-table th {\n        padding: 8px 5px;\n        font-size: 12px;\n        vertical-align: middle;\n        word-break: break-word;\n    }</style><br><div class="container-fluid"><div class="row"><!--        <h5 class="pull-right text-danger" style="padding-right:2px;">*Dashboard is getting updated on real time basis</h5>--><h5 class="pull-right text-danger" style="padding-right:5px">*Dashboard updated on {{ CurrentDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</h5><div class="col-md-12"><ul class="nav nav-pills"><!--                <h5 class="pull-right text-danger" style="padding-right:2px;">*Dashboard is getting updated on real time basis</h5>--><!--<li class="active"><a ui-sref="totaldeptservicesdetailyearly({status:\'Required\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Required Services<span class="badge">{{vm.totalrequiredservices}}</span></a></li>--><li class="active"><a ui-sref="eodbtotaldeptservicesdetailyearly({status:\'Applied\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Applied Services<span class="badge">{{vm.totalappliedservices}}</span></a></li><li class="active"><a ui-sref="eodbtotaldeptservicesdetailyearly({status:\'Pending\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Pending Services<span class="badge">{{vm.totalpendingservices}}</span></a></li><li class="active"><a ui-sref="eodbtotaldeptservicesdetailyearly({status:\'Cleared\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Cleared Services<span class="badge">{{vm.totalcompletedservices}}</span></a></li><li class="active"><a ui-sref="eodbtotaldeptservicesdetailyearly({status:\'Declined\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Rejected Services<span class="badge">{{vm.totalrejectedservices}}</span></a></li><!--                <li class="active"><a ui-sref="dashboardbetweendates" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_MONITORING_OFFICER" style="margin-left: 24px">Datewise Stats</a></li>--><!--                <li class="active"><a ui-sref="servicedashboard({auth:\'Cumulative\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || (vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') && vm.account.login==\'deskof\')" style="margin-left: 24px">Cumulative Count</a></li>--><!--<li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Required Services<span class="badge">{{vm.totalrequiredservices}}</span></a></li>--><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Applied Services<span class="badge">{{vm.totalappliedservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Pending Services<span class="badge">{{vm.totalpendingservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Cleared Services<span class="badge">{{vm.totalcompletedservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Rejected Services<span class="badge">{{vm.totalrejectedservices}}</span></a></li><!--                <li class="active"><a ui-sref="servicedashboard({auth:\'Cumulative\'})" has-any-authority="ROLE_NODAL_OFFICER" style="margin-left: 24px">Cumulative Count</a></li>--></ul></div></div></div><div ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_FIELD_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')"><div class="row" style="padding: 12px" ng-if="vm.deptservicedashboard"><div class="col-md-1 filter-margin"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div><div class="col-md-3" ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')"><select class="custom-select form-control" ng-model="vm.filter.departmentName"><option value="" disabled="disabled">All Department</option><option value="{{department}}" ng-repeat="department in vm.departments">{{department}}</option></select></div><div class="col-md-2" ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_FIELD_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')"><select class="custom-select form-control" ng-model="vm.filter.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy:\'districtname\'"><option value="" disabled="disabled">All Districts</option><option value="district.districtname">{{district.districtname}}</option></select></div><div class="col-md-2" ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')"><select class="custom-select form-control" ng-model="vm.filter.projectLevel"><option value="" disabled="disabled">All Level</option><option value="e">EEC</option><option value="d">DLCC</option></select></div><button class="btn btn-primary" ng-click="vm.FilterWiseDat()">Filter</button> <button ng-if="vm.hideClear" class="btn btn-primary" ng-click="vm.clearFilter()">Clear</button></div></div><!--<p ng-if="vm.deptservicedashboard" class="pull-right text-danger" style="padding-right:2px;">*Mean & Median are calculated on cleared services after 01-April-2020</p>--><section class="ls section_padding_top_25 section_padding_bottom_75 columns_padding_10" id="user_section"><div class="container"><div ng-repeat="(departmentname, servicedashboard_data) in vm.deptservicedashboard | orderBy: \'departmentorder\' | groupBy: \'department_name\' "><div class="row"><h3>{{departmentname}} <a ui-sref="pstowerdashboard" class="pull-right" ng-if="(vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')) &&(departmentname===\'Communication and Connectivity Permissions\')" style="font-size: 18px; color: red">View Department wise Tower Service Dashboard</a></h3><table class="table table_template table-striped eodb-summary-table"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-2">Service</th><th class="col-md-1 text-center">Department</th><th class="col-md-1 text-center">District</th><th class="col-md-1 text-center">Time Period</th><th class="col-md-1 text-center">Applications Received</th><th class="col-md-1 text-center">Applications Approved</th><th class="col-md-1 text-center">Applications Rejected</th><th class="col-md-1 text-center">SLA Met (%)</th><th class="col-md-1 text-center">Average Time (Days)</th><th class="col-md-1 text-center">Fees Collected (INR)</th><th class="col-md-1 text-center">Feedback Score (1&ndash;5)</th></tr></thead><tbody><tr class="row" ng-repeat="servicedashboard in servicedashboard_data | orderBy: \'service_name\'"><td class="col-md-2">{{servicedashboard.service_name}}</td><td class="col-md-1 text-center">{{departmentname}}</td><td class="col-md-1 text-center">{{vm.filter.district || \'All Districts\'}}</td><td class="col-md-1 text-center">{{vm.timePeriod}}</td><td class="col-md-1 text-center"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Applied\'})"><span>{{servicedashboard.applied}}</span></a></td><td class="col-md-1 text-center"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Cleared\'})"><span>{{servicedashboard.cleared}}</span></a></td><td class="col-md-1 text-center"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Declined\'})"><span>{{servicedashboard.rejected}}</span></a></td><td class="col-md-1 text-center"><span style="color: blue">{{servicedashboard.slaMet}}</span></td><td class="col-md-1 text-center"><span>{{servicedashboard.avgTime}}</span></td><td class="col-md-1 text-center"><span>{{servicedashboard.feesCollected}}</span></td><td class="col-md-1 text-center"><span>{{servicedashboard.feedbackScore}}</span></td></tr></tbody></table><!-- ============================================================================\n                 LEGACY TABLE - kept for reference, never rendered (ng-if="false").\n                 Superseded by the summary table above. Everything it used to show that is\n                 no longer required is inside it: the whole PENDING block (Total, > 30 days,\n                 > 45 days, > 60 days, RTS days) plus De-activated, Deemed Cleared,\n                 Avg.(Mean)/Median and MinTime / MaxTime.\n                 ============================================================================ --><table class="table table_template table-striped" ng-if="false"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-2">Service</th><!-- <th class="col-md-1 text-center">Required</th> --><th class="col-md-1 text-center">Applied</th><th class="col-md-5 text-center">Pending</th><th class="col-md-4 text-center">Completed</th></tr></thead><tbody><tr class="headerGrid row gradient_bg_color2"><td class="col-md-2 text-center"></td><!-- <td class="col-md-1 text-center"></td> --><td class="col-md-1 text-center"></td><td class="col-md-4 text-center" style="padding:0;margin:0"><div class="col-md-2">Total</div><div class="col-md-2">> 30 days</div><div class="col-md-2">> 45 days</div><div class="col-md-2">> 60 days</div><div class="col-md-2">RTS days</div></td><td class="col-md-5 text-center" style="padding:0;margin:0"><span class="col-md-2">Cleared</span> <span class="col-md-2">De-activated</span> <span class="col-md-2">Deemed Cleared</span> <span class="col-md-2">Rejected</span> <span class="col-md-2">Avg.(Mean)/Median (in days)</span> <span class="col-md-2">MinTime / MaxTime</span> <span class="col-md-2">SLA Met (%)</span> <span class="col-md-2">Average Time (Days)</span> <span class="col-md-2">Fees Collected (INR)</span> <span class="col-md-2">Feedback Score (1&ndash;5)</span></td></tr><tr class="row" ng-repeat="servicedashboard in servicedashboard_data | orderBy: \'service_name\'"><td class="col-md-2">{{servicedashboard.service_name}}</td><!-- <td class="col-md-1 text-center">\n                        <div class="col-md-12">\n                            <a ui-sref="servicedashboardyearlycafs({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Required\'})"><span class="badge">{{servicedashboard.required}}</span></a>\n                        </div>\n                    </td> --><td class="col-md-1 text-center"><div class="col-md-12"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Applied\'})"><span>{{servicedashboard.applied}}</span></a></div></td><td class="col-md-4 text-center"><div class="col-md-2"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending\'})"><span ng-if="servicedashboard.pending_total < 0">{{ -servicedashboard.pending_total }}</span> <span ng-if="servicedashboard.pending_total >= 0">{{ servicedashboard.pending_total }}</span></a></div><div class="col-md-2"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending30\'})"><span ng-if="servicedashboard.pending_30days < 0">{{ -servicedashboard.pending_30days }}</span> <span ng-if="servicedashboard.pending_30days >= 0">{{ servicedashboard.pending_30days }}</span></a></div><div class="col-md-2"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending45\'})"><span ng-if="servicedashboard.pending_45days < 0">{{ -servicedashboard.pending_45days }}</span> <span ng-if="servicedashboard.pending_45days >= 0">{{ servicedashboard.pending_45days }}</span></a></div><div class="col-md-2"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending60\'})"><span ng-if="servicedashboard.pending_60days < 0">{{ -servicedashboard.pending_60days }}</span> <span ng-if="servicedashboard.pending_60days >= 0">{{ servicedashboard.pending_60days }}</span></a></div><div class="col-md-2"><a><span>{{servicedashboard.rtsDays}}</span></a></div><!--                        <div class="col-md-2" ng-if="servicedashboard.rtsDays!=\'NA\'"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'RTSdays\'})"><span >{{servicedashboard.rtsDays}}</span></a></div>--></td><td class="col-md-5 text-center"><div class="col-md-2"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Cleared\'})"><span>{{servicedashboard.cleared}}</span></a></div><div class="col-md-2"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Rejected\'})"><span>{{servicedashboard.deactivated}}</span></a></div><div class="col-md-2"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'DeemedCleared\'})"><span>{{servicedashboard.deemed_cleared}}</span></a></div><div class="col-md-2"><a ui-sref="eodbdashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Declined\'})"><span>{{servicedashboard.rejected}}</span></a></div><div class="col-md-2"><a><span><span ng-if="servicedashboard.pending_75days < 0">{{ -servicedashboard.pending_75days }}</span> <span ng-if="servicedashboard.pending_75days >= 0">{{ servicedashboard.pending_75days }}</span> / <span ng-if="servicedashboard.pending_90days < 0">{{ -servicedashboard.pending_90days }}</span> <span ng-if="servicedashboard.pending_90days >= 0">{{ servicedashboard.pending_90days }}</span></span></a></div><div class="col-md-2"><a><span>{{servicedashboard.minTime}}/{{servicedashboard.maxTime}}</span></a></div><div class="col-md-2"><a><span style="color: blue">{{servicedashboard.slaMet}}</span></a></div><div class="col-md-2"><a><span>{{servicedashboard.avgTime}}</span></a></div><div class="col-md-2"><a><span>{{servicedashboard.feesCollected}}</span></a></div><div class="col-md-2"><a><span>{{servicedashboard.feedbackScore}}</span></a></div></td></tr></tbody></table></div></div></div></section><!--<div class="text-center" style="margin-bottom: 10%;margin-top: 10%">--><!--    <div>--><!--        <p style="font-size: large"><b>Sorry for the inconvenience but we&rsquo;re performing some maintenance at this page.</b></p>--><!--    </div>--><!--</div>-->');
$templateCache.put('app/eodbdashboardyearly/eodbviewcafsyearly.html','<style>.loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        animation: spin 2s linear infinite;\n    }\n\n    @keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n    }</style><form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-9"><h4 class="modal-title text-warning bold" id="myBlockLabel">{{vm.servicename}}</h4></div><!--                    <div class="col-md-2">--><!--                        <button ng-show="vm.show" id="download-btn" ng-click="vm.downloadAllData()" type="button" class="btn btn-primary btn-sm" >Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button>--><!--                    </div>--><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div><div ng-if="vm.spiner" class="loader"></div><div class="row"><div class="text-center"><h5 class="modal-title" ng-show="vm.status==\'All\'"><b>All CAFs with this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending\'"><b>All Pending CAFs against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending30\'"><b>CAFs pending for more than 30 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending45\'"><b>CAFs pending for more than 45 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending60\'"><b>CAFs pending for more than 60 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending75\'"><b>CAFs pending for more than 75 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'RTSdays\'"><b>CAFs pending for more than RTS days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Cleared\'"><b>CAFs Cleared against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Rejected\'"><b>Service Deactivated for the following CAFs</b></h5><h5 class="modal-title" ng-show="vm.status==\'DeemedCleared\'"><b>Service Deemed Cleared for the following CAFs</b></h5></div></div></div><div class="panel-body"><!--<h5 class="pull-left" ng-show="vm.status==\'Cleared\'">Average Clearance Time :<strong >{{" "}}{{vm.averageTime.toString()==\'NaN\'?"NA": vm.averageTime + \' days\'}}</strong> </h5>--><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><!--                            <th><span>Business Entity</span></th>--><th><span>District</span></th><th><span>Project Level</span></th><th><span ng-show="vm.servicename == \'Regularization of existing Tower/Renewal (Above ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Above Ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\' || vm.servicename == \'Registration under Shops & Establishment AND/OR Trade License\' || vm.servicename == \'Renewal/Extension of Communication and Connectivity Permissions\'">Department</span></th><th><span>Proposed Employment</span></th><th><span>Proposed Investment(in crore)</span></th><th><span>SLA</span></th><th ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'RTSdays\'"><span>Ageing</span></th><th ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">Applied Date</th><th ng-show="vm.status==\'Cleared\'">Cleared Date</th><th ng-show="vm.status==\'Declined\'">Rejected Date</th><th ng-if="vm.status==\'DeemedCleared\'">Deemed Cleared Date</th><th ng-if="vm.status==\'Rejected\'">De-Activated Date</th></tr></thead><tbody><tr dir-paginate="caf in vm.dashboardcafs.content | orderBy:\'-ageing\' | orderBy: \'-clearedDate\' | itemsPerPage: pageSize" total-items="vm.dashboardcafs.totalElements" current-page="currentPage"><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><!--                            <td>{{caf.businessEntity}}</td>--><td>{{caf.district}}</td><td>{{caf.projectLevel=="d" ? "DLCC" : "EEC"}}</td><td><span ng-show="vm.servicename == \'Regularization of existing Tower/Renewal (Above ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Above Ground)\'\n                                        || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\' || vm.servicename == \'Registration under Shops & Establishment AND/OR Trade License\' || vm.servicename == \'Renewal/Extension of Communication and Connectivity Permissions\'">{{caf.departmentName === \'Communication and Connectivity Permissions\' ? "NA" : caf.departmentName}}</span></td><!--<td>--><!--<div class="dropdown">--><!--<button ng-show="vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\'" class="btn btn-sm btn-info dropdown-toggle" ng-click="vm.showDepartments(caf)"--><!--data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">View--><!--<span class="caret"></span></button>--><!--<ul class="dropdown-menu dropdown-menu-left" aria-labelledby="dLabel">--><!--<li ng-repeat="dept in vm.departmentName"><a>{{dept}}</a></li>--><!--</ul>--><!--</div>--><!--</td>--><td>{{caf.proposedEmployment}}</td><td>{{caf.proposedInvestment}}</td><td>{{caf.sladays}}</td><td ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'RTSdays\'">{{caf.ageing}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">{{(caf.appliedDate==null ? "NA" : caf.appliedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\'">{{(caf.clearedDate==null ? "NA" :caf.clearedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Declined\'">{{(caf.rejectionDate==null ? "NA" :caf.rejectionDate) | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.status==\'DeemedCleared\'">{{(caf.statusDate==null ? "NA" :caf.statusDate) | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.status==\'Rejected\'">{{(caf.statusDate==null ? "NA" :caf.statusDate) | date:\'dd-MM-yyyy\'}}</td></tr></tbody></table><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/eodbpublicdashboard/eodbpublicdashboard.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">EODB PUBLIC DASHBOARD</h1><p><span class="text-danger">*</span> Data of services applied after 01-April-2018</p></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>EODB Public Dashboard</span></li></ol></div></section><style>/* The summary table carries 11 columns, so the theme\'s default 20px/30px cell\n       padding has to be tightened for them to fit on one line. Scoped to this table. */\n    .table_template.eodb-public-summary-table td,\n    .table_template.eodb-public-summary-table th {\n        padding: 8px 5px;\n        font-size: 12px;\n        vertical-align: middle;\n        word-break: break-word;\n    }\n\n    /* SLA Status indicators: green >= 90%, yellow 75-89%, red < 75%.\n       Rendered as a filled pill so the band is readable without relying on colour alone -\n       the percentage itself stays visible inside it. */\n    .sla-pill {\n        display: inline-block;\n        min-width: 46px;\n        padding: 3px 8px;\n        border-radius: 10px;\n        font-weight: 700;\n        font-size: 12px;\n        line-height: 1.4;\n    }\n    .sla-green  { background: #d4edda; color: #155724; border: 1px solid #b6ddc0; }\n    .sla-yellow { background: #fff3cd; color: #856404; border: 1px solid #f0dda0; }\n    .sla-red    { background: #f8d7da; color: #721c24; border: 1px solid #eeb8be; }\n    .sla-na     { background: #ececec; color: #777;    border: 1px solid #ddd; font-weight: 400; }</style><br><div class="container-fluid"><div class="row"><h5 class="pull-right text-danger" style="padding-right:5px">*Dashboard updated on {{ CurrentDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</h5><div class="col-md-12"><ul class="nav nav-pills"><li class="active"><a>Total Applied Services<span class="badge">{{vm.totalappliedservices}}</span></a></li><li class="active"><a>Total Pending Services<span class="badge">{{vm.totalpendingservices}}</span></a></li><li class="active"><a>Total Cleared Services<span class="badge">{{vm.totalcompletedservices}}</span></a></li><li class="active"><a>Total Rejected Services<span class="badge">{{vm.totalrejectedservices}}</span></a></li></ul></div></div></div><!-- Filters applied in the browser on the rows already loaded - no round trip, they take effect\n     the moment they are changed. --><div class="row" style="padding: 12px 12px 0 12px" ng-if="vm.deptservicedashboard"><div class="col-md-1 filter-margin"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div><!-- i. Department --><div class="col-md-2"><select class="custom-select form-control" ng-model="vm.clientFilter.departmentName" ng-change="vm.onDepartmentChange()" ng-disabled="vm.loading"><option value="">All Department</option><option value="{{department}}" ng-repeat="department in vm.departments">{{department}}</option></select></div><!-- ii. Service --><div class="col-md-3"><select class="custom-select form-control" ng-model="vm.clientFilter.serviceName" ng-change="vm.applyClientFilters()" ng-disabled="vm.loading"><option value="">All Services</option><option value="{{service}}" ng-repeat="service in vm.services">{{service}}</option></select></div><!-- iv. SLA Status --><div class="col-md-2"><select class="custom-select form-control" ng-model="vm.clientFilter.slaStatus" ng-change="vm.applyClientFilters()" ng-disabled="vm.loading"><option value="">All SLA Status</option><option value="Met">SLA Met</option><option value="Unmet">SLA Unmet</option></select></div><!-- v. Application Status --><div class="col-md-2"><select class="custom-select form-control" ng-model="vm.clientFilter.applicationStatus" ng-change="vm.applyClientFilters()" ng-disabled="vm.loading"><option value="">All Application Status</option><option value="Received">Received</option><option value="Approved">Approved</option><option value="Rejected">Rejected</option></select></div><div class="col-md-2"><span ng-if="!vm.loading" style="font-size: 12px; color: #666; line-height: 34px">Showing {{vm.visibleDashboard.length}} of {{vm.deptservicedashboard.length}} services </span><span ng-if="vm.loading" style="font-size: 12px; color: #b62d65; line-height: 34px">Loading&hellip;</span></div><div class="col-md-12" style="padding-top: 6px"><span style="font-size: 11px; color: #777">SLA STATUS:</span> <span class="sla-pill sla-green">&ge; 90%</span> <span class="sla-pill sla-yellow">75&ndash;89%</span> <span class="sla-pill sla-red">&lt; 75%</span> <span class="sla-pill sla-na">NA</span> <span style="font-size: 11px; color: #999; margin-left: 6px">NA means no SLA could be measured (no RTS days configured, or no cleared application with both dates).</span></div></div><!-- iii. District. A row is one service totalled over every district and carries no district of\n     its own, so this cannot be done in the browser - the server recomputes the counts for the\n     district picked here. Level rides along on the same call. --><div class="row" style="padding: 8px 12px 12px 12px" ng-if="vm.deptservicedashboard"><div class="col-md-offset-1 col-md-11"><select class="custom-select form-control" style="width:auto; display:inline-block; margin-right:8px" ng-model="vm.filter.district" ng-disabled="vm.loading" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy:\'districtname\'"><option value="">All Districts</option></select><select class="custom-select form-control" style="width:auto; display:inline-block; margin-right:8px" ng-model="vm.filter.projectLevel" ng-disabled="vm.loading"><option value="">All Level</option><option value="e">EEC</option><option value="d">DLCC</option></select><button class="btn btn-primary" ng-click="vm.FilterWiseDat()" ng-disabled="vm.loading"><span ng-if="!vm.loading">Apply District / Level</span> <span ng-if="vm.loading">Loading&hellip;</span></button> <button ng-if="vm.hideClear || vm.hasAnyFilter()" class="btn btn-primary" ng-click="vm.clearFilter()" ng-disabled="vm.loading">Clear</button> <span style="margin-left: 12px; font-size: 11px; color: #999">District and Level re-query the server because the counts are recalculated for that district. </span><span class="pull-right"><!-- Exports carry the filtered rows exactly as shown on screen. --> <button class="btn btn-success" ng-click="vm.exportExcel()" ng-disabled="!vm.canExport()" title="Download the rows currently shown as an Excel workbook (.xlsx)"><span class="glyphicon glyphicon-download-alt"></span> Export Excel</button> <button class="btn btn-danger" ng-click="vm.exportPdf()" ng-disabled="!vm.canExport()" title="Download the rows currently shown as a PDF"><span class="glyphicon glyphicon-download-alt"></span> Export PDF</button></span></div></div><section class="ls section_padding_top_25 section_padding_bottom_75 columns_padding_10" id="user_section"><div class="container"><div ng-if="vm.visibleDashboard.length === 0" class="text-center" style="padding: 40px 0; color:#777"><p style="font-size: large"><b>No service matches the selected filters.</b></p></div><div ng-repeat="(departmentname, servicedashboard_data) in vm.visibleDashboard | orderBy: \'departmentorder\' | groupBy: \'department_name\' "><div class="row"><h3>{{departmentname}}</h3><table class="table table_template table-striped eodb-public-summary-table"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-2">Service</th><th class="col-md-1 text-center">Department</th><th class="col-md-1 text-center">District</th><th class="col-md-1 text-center">Time Period</th><th class="col-md-1 text-center">Applications Received</th><th class="col-md-1 text-center">Applications Approved</th><th class="col-md-1 text-center">Applications Rejected</th><th class="col-md-1 text-center">SLA Met (%)</th><th class="col-md-1 text-center">Average Time (Days)</th><th class="col-md-1 text-center">Fees Collected (INR)</th><th class="col-md-1 text-center">Feedback Score (1&ndash;5)</th></tr></thead><tbody><tr class="row" ng-repeat="servicedashboard in servicedashboard_data | orderBy: \'service_name\'"><td class="col-md-2">{{servicedashboard.service_name}}</td><td class="col-md-1 text-center">{{departmentname}}</td><td class="col-md-1 text-center">{{vm.appliedDistrict || \'All Districts\'}}</td><td class="col-md-1 text-center">{{vm.timePeriod}}</td><td class="col-md-1 text-center"><span>{{servicedashboard.applied}}</span></td><td class="col-md-1 text-center"><span>{{servicedashboard.cleared}}</span></td><td class="col-md-1 text-center"><span>{{servicedashboard.rejected}}</span></td><td class="col-md-1 text-center"><span class="sla-pill" ng-class="vm.slaIndicatorClass(servicedashboard)">{{servicedashboard.slaMet}}</span></td><td class="col-md-1 text-center"><span>{{servicedashboard.avgTime}}</span></td><td class="col-md-1 text-center"><span>{{servicedashboard.feesCollected}}</span></td><td class="col-md-1 text-center"><span>{{servicedashboard.feedbackScore}}</span></td></tr></tbody></table></div></div></div></section>');
$templateCache.put('app/eodbtotaldeptservicesdetailyearly/eodbtotaldeptservicesdetailyearly.html','<style>.app-modal-window .modal-dialog {\n        width: 90%;\n    }\n\n    .loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 40px !important;\n        height: 40px;\n        animation: spin 2s linear infinite;\n    }\n\n    @keyframes spin {\n        0% {\n            transform: rotate(0deg);\n        }\n        100% {\n            transform: rotate(360deg);\n        }\n    }</style><form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-10"><h4 class="modal-title" ng-show="vm.status==\'Required\'">ALL CAFs WITH REQUIRED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Pending\'">ALL CAFs WITH PENDING SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Cleared\'">ALL CAFs WITH CLEARED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Applied\'">ALL CAFs WITH APPLIED SERVICES</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div><!--                <div class="row" align="center">--><!--                    <div class="col-md-2">--><!--                        <strong class="pull-right" style="padding-right:10px"><i>From</i></strong>--><!--                    </div>--><!--                    <div class="col-md-2">--><!--                        <div class="input-group">--><!--                            <input id="field_fromdate" type="text" class="form-control" name="fromdate"--><!--                                   uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions"--><!--                                   ng-change="vm.selectedDate(vm.fromdate)" ng-model="vm.fromdate"--><!--                                   is-open="vm.datePickerOpenStatus.fromdate" readonly--><!--                            />--><!--                            <span class="input-group-btn">--><!--                                  <button type="button" class="btn btn-default"--><!--                                          ng-click="vm.openCalendar(\'fromdate\')"><i--><!--                                      class="glyphicon glyphicon-calendar"></i></button>--><!--                              </span>--><!--                        </div>--><!--                    </div>--><!--                    <div class="col-md-1">--><!--                        <strong class="pull-right" style="padding-right:10px"><i>To</i></strong>--><!--                    </div>--><!--                    <div class="col-md-2">--><!--                        <div class="input-group">--><!--                            <input id="field_todate" type="text" class="form-control" name="todate"--><!--                                   uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions1"--><!--                                   ng-model="vm.todate"--><!--                                   is-open="vm.datePickerOpenStatus.todate" readonly/>--><!--                            <span class="input-group-btn">--><!--                                  <button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button>--><!--                           </span>--><!--                        </div>--><!--                    </div>--><!--                    <div class="col-md-1">--><!--                        <button ng-show="vm.show" id="download-btn" ng-disabled="vm.fromdate==null || vm.todate==null"--><!--                                ng-click="vm.download(vm.status)" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span--><!--                            class="glyphicon glyphicon-download-alt"></span></button>--><!--                    </div>--><!--                    <div class="col-md-2">--><!--                        <div style="color: red"><b>*</b> Enter a max. period of 1 year</div>--><!--                    </div>--><!--                    <br/>--><!--                </div>--></div><div ng-if="vm.spiner" class="loader"></div><div class="panel-body table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><!--<th>#</th>--><th>CAF Pin (Composite Application Form)</th><th>Service Name</th><!--                        <th>Business Entity</th>--><th>District</th><th>Department</th><th>Investor Name</th><th>Investor Contact</th><th>Investor Email</th><th>Project Level</th><th>Proposed Employment</th><th>Proposed Investment(in crore)</th><th ng-show="vm.status==\'Pending\'">Land Zone Use Type</th><th ng-show="vm.status==\'Pending\'">Ageing</th><th>Applied Date</th><th ng-show="vm.status==\'Cleared\'  || vm.status==\'Rejected\'">Completion Date</th><th>Address</th></tr></thead><tbody><tr dir-paginate="caf in vm.totaldeptservicesdetail.content | orderBy: \'-projectlevel\' | orderBy: \'-clearedDate\'| itemsPerPage: pageSize" total-items="vm.totaldeptservicesdetail.totalElements" current-page="currentPage"><!--<td>{{$index +1}}</td>--><td>{{caf.cafpin}}</td><td>{{caf.serviceName}}</td><!--                        <td>{{caf.businessEntity}}</td>--><td>{{caf.district}}</td><td>{{caf.departmentName}}</td><td>{{caf.investorName}}</td><td>{{caf.investorMobilenumber}}</td><td>{{caf.investorEmail}}</td><td>{{caf.projectLevel=="d" ? "DLCC" : "EEC"}}</td><td>{{caf.proposedEmployment}}</td><td>{{caf.proposedInvestment}}</td><td ng-show="vm.status==\'Pending\'">{{caf.landZoneUseType}}</td><td ng-show="vm.status==\'Pending\'">{{caf.ageing>200 ? "NA" : caf.ageing}}</td><td>{{caf.formFilledOn==null ? "NA" : caf.formFilledOn | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'Rejected\'">{{caf.clearedDate==null ? "NA" : caf.clearedDate | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'TotalCleared\'">{{caf.clearedDate | date:\'dd-MM-yyyy\'}}</td><td>{{caf.investorAddress}}</td></tr></tbody></table><!-- Pager --><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><!--                    <dir-pagination-controls on-page-change="pageChanged(newPageNumber)"></dir-pagination-controls>--><dir-pagination-controls boundary-links="true" on-page-change="pageChanged(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/evPolicies/evPolicies.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_10 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Haryana Electric Vehicle Policy 2022</h1></div></div></div></section><br><div ng-cloak><div class="container"><div class="row"><div class="col-md-3" ng-if="vm.isAuthenticated()"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/evincentivescheme/viewappstatus/policy2022" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/evincentivescheme/viewappstatus/policy2022"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="View Application Status"></form><!--                <button class="btn btn-success" type="submit" href="#modal-full" uk-toggle>View Application Status</button>--></div><div class="col-md-3" ng-if="vm.isAuthenticated()"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/evincentivescheme/onholdapplications/policy2022" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/evincentivescheme/onholdapplications/policy2022"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Reply to onhold application"></form><!--                <button class="btn btn-success" type="submit" href="#modal-full" uk-toggle>Reply to onhold application</button>--></div><div class="col-md-3" ng-if="vm.isAuthenticated()"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/dashboard/default/allschemes"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Reply to onhold for new portal applications\n"></form><!--                <button class="btn btn-success" type="submit" href="#modal-full" uk-toggle>Reply to onhold application</button>--></div><br><table class="table table-striped table-hover" ng-switch="vm.isAuthenticated()"><thead><tr class="headerGrid"><th>S.No</th><th>Scheme Name</th><th>EV Policy Document (PDF)</th><th>Apply For Scheme</th></tr></thead><tbody><tr><td>1</td><td>Capital subsidy of Fixed Capital Investment (FCI)</td><td><a target="_blank" href="../../content/used-images-new/Capital Subsidy Scheme V42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/evincentivescheme/capital-subsidy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" type="submit" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr><tr><td>2</td><td>Seed and Conversion Fund</td><td><a target="_blank" href="../../content/used-images-new/Seed and Conversion Fund_v42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/evincentivescheme/seed_conversion"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button type="submit" class="btn btn-success" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr><tr><td>3</td><td>Net SGST reimbursement</td><td><a target="_blank" href="../../content/used-images-new/Net SGST Reimbursement Scheme for EV_V42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/evincentivescheme/sgst_reimbursement"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr><tr><td>4</td><td>Reimbursement in Stamp Duty</td><td><a target="_blank" href="../../content/used-images-new/Reimbursement of Stamp Duty v42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/evincentivescheme/stamp_duty"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr><tr><td>5</td><td>Power subsidy incentive- Electricity Duty</td><td><a target="_blank" href="../../content/used-images-new/Power Incentives (Electricity Duty Exemption) v42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/evincentivescheme/electricity-duty"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr><tr><td>6</td><td>Water Treatment Plant Incentives</td><td><a target="_blank" href="../../content/used-images-new/Water Treatment  v42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/evincentivescheme/water_treatment"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr><tr><td>7</td><td>Patent Fee Reimbursement Scheme</td><td><a target="_blank" href="../../content/used-images-new/Patent Fee Reimbursement Scheme_v42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/evincentivescheme/patent_fee"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr><tr><td>8</td><td>Employment Generation Subsidy</td><td><a target="_blank" href="../../content/used-images-new/Employment Generation Subsidy Scheme_V42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/evincentivescheme/emp_gen/"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr><tr><td>9</td><td>Incentives for Buyers \u2013 Purchase Incentive</td><td><a target="_blank" href="../../content/used-images-new/Purchase Incentive_V42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="_blank" action="https://egrashry.nic.in/WebPages/SubsidyOnEVehicle.aspx" method="GET"><!--                                <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                                <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--                                <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                                <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--                                <input type="hidden" name="url"--><!--                                       value="https://egrashry.nic.in/WebPages/SubsidyOnEVehicle.aspx">--> <input type="submit" class="btn btn-link" value=" Apply Now"></form></div></td></tr><tr><td>10</td><td>Incentive for privately owned public charging station / privately owned Battery Swapping Station</td><td><a target="_blank" href="../../content/used-images-new/Charging and Swapping Station Schemes_V42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/evincentivescheme/charging_swapping_stations/"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr><tr><td>11</td><td>Human Capacity building - of Center of Excellences</td><td><a target="_blank" href="../../content/used-images-new/Scheme for CoE v42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/evincentivescheme/claiming_ceo"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr><tr><td>12</td><td>Research & Development Incentive</td><td><a target="_blank" href="../../content/used-images-new/R&D Incentives_v42.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/evincentivescheme/r_and_d"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr></tbody><!--                <tbody>--><!--                <tr>--><!--                    <td>1</td>--><!--                    <td >Capital subsidy of Fixed Capital Investment (FCI)</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/Capital Subsidy Scheme.pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/evincentivescheme/capital_subsidy\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>2</td>--><!--                    <td >Seed and Conversion Fund</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/Seed and Conversion Fund.pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/evincentivescheme/seed_conversion\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>3</td>--><!--                    <td >Net SGST reimbursement</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/Net SGST Reimbursement Scheme for EV.pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/evincentivescheme/sgst_reimbursement\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>4</td>--><!--                    <td >Reimbursement in Stamp Duty</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/Reimbursement of Stamp Duty.pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/evincentivescheme/stamp_duty\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>5</td>--><!--                    <td >Power subsidy incentive- Electricity Duty</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/Power Incentives (Electricity Duty Exemption).pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/evincentivescheme/electricity_duty\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>6</td>--><!--                    <td >Water Treatment Plant Incentives</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/Water Treatment.pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/evincentivescheme/water_treatment\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>7</td>--><!--                    <td >Patent Fee</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/Patent Fee Reimbursement Scheme.pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/evincentivescheme/patent_fee\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>8</td>--><!--                    <td >Employment Generation Subsidy</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/Employment Generation Subsidy Scheme.pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/evincentivescheme/emp_gen\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>9</td>--><!--                    <td >Incentives for Buyers \u2013 Purchase Incentive</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/Purchase Incentive.pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://egrashry.nic.in/WebPages/SubsidyOnEVehicle.aspx\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>10</td>--><!--                    <td >Incentive for privately owned public charging station / privately owned Battery Swapping Station</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/Charging and Swapping Station Schemes.pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/evincentivescheme/charging_swapping_stations\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>11</td>--><!--                    <td >Human Capacity building - of Center of Excellences</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/Scheme for Center of Excellence.pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/evincentivescheme/claiming_ceo\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>12</td>--><!--                    <td >Research & Development Incentive</td>--><!--                    <td ><a target="_blank" href="../../content/used-images-new/R&D Incentives.pdf">View PDF</a></td>--><!--                    <td>--><!--                        <button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/evincentivescheme/r_and_d\',\'_blank\')">Apply Now</button>--><!--                    </td>--><!--                </tr>--><!--                </tbody>--></table></div></div></div><div id="modal-full" class="uk-modal-full" uk-modal esc-close="false" bg-close="false"><div class="uk-modal-dialog"><button class="uk-modal-close-full uk-close-large" type="button" uk-close></button><div class="uk-grid-collapse uk-flex-middle" uk-grid><section><iframe name="my_iframe" style="width: 500vw; height: 100vh" frameborder="0" marginheight="0" marginwidth="0"></iframe></section></div></div></div>');
$templateCache.put('app/exciseMoveCaf/ShopMoveToExcise.html','<div class="container-fluid"><div class="panel-body"><!--<h5 class="pull-left" ng-show="vm.status==\'Cleared\'">Average Clearance Time :<strong >{{" "}}{{vm.averageTime.toString()==\'NaN\'?"NA": vm.averageTime + \' days\'}}</strong> </h5>--><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><th><span>Business Entity</span></th><th><span>District</span></th><th><span>Project Level</span></th><th><span>Department</span></th><th><span>ServiceName</span></th><th></th></tr></thead><tbody><tr ng-repeat="caf in vm.projects | orderBy: \'-formFilledOn\'"><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><td>{{caf.businessEntity}}</td><td>{{caf.district}}</td><td>{{caf.projectLevel=="d" ? "DLCC" : "EEC"}}</td><td>{{caf.departmentName}}</td><td>{{caf.serviceName}}</td><!--<td>--><!--<div class="dropdown">--><!--<button ng-show="vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\'" class="btn btn-sm btn-info dropdown-toggle" ng-click="vm.showDepartments(caf)"--><!--data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">View--><!--<span class="caret"></span></button>--><!--<ul class="dropdown-menu dropdown-menu-left" aria-labelledby="dLabel">--><!--<li ng-repeat="dept in vm.departmentName"><a>{{dept}}</a></li>--><!--</ul>--><!--</div>--><!--</td>--><td class="action verticalalign"><a ui-sref="projectdetailjist({projectid:caf.projectId})" class="btn btn-primary">Details</a> <button type="button" class="btn btn-primary" ng-click="vm.modalCaf(caf.projectId)">Move To Excise</button><!--                        <button type="button" class="btn btn-primary"  ng-click="vm.moveData(caf.projectId)">Move To Excise</button>--></td></tr></tbody></table></div></div></div><div class="modal" id="deleteModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm Move Caf operation</h4></div><div class="modal-body"><p>Are you sure you want to Move this Caf {{vm.deleteId}}?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="button" ng-disabled="deleteForm.$invalid" class="btn btn-danger" ng-click="vm.deleteCaf(vm.deleteId)"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Move</span></button></div></div></div></div>');
$templateCache.put('app/export/export.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Export</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li class="active"><span>Export</span></li></ol></div></section><br><div class="container"><div class="row"><div class="col-md-12"><table class="table table-striped table-hover" ng-switch="vm.isAuthenticated()"><thead><tr class="headerGrid"><th>S.No</th><th>Title</th><th>View/Download</th></tr></thead><tbody><tr><td>1</td><td>Link to access the export data of Haryana</td><td><a target="_blank" href="https://ftddp.dgciskol.gov.in/dgcis/">View</a></td></tr><tr><td>2</td><td>Link to access district-wise export data of Haryana</td><td><a target="_blank" href="https://ftddp.dgciskol.gov.in/dgcis/">View</a></td></tr><tr><td>3</td><td>Link to access District Export Action Plans (DEAPs) of 22 districts</td><td><a ui-sref="exportdistrict">Download DEAPs</a></td></tr><br></tbody></table></div></div></div>');
$templateCache.put('app/export/exportdistrict.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">District Export</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li class="active"><span>District Export</span></li></ol></div></section><br><div class="container"><div class="row"><h5 class="pull-right text-danger" style="padding-right:2px"><b>*Dashboard updated on {{ CurrentDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</b></h5><div class="col-md-12"><table class="table table-striped table-hover" ng-switch="vm.isAuthenticated()"><thead><tr class="headerGrid"><th>S.No</th><th>District Name</th><th>District Export Action Plan</th><th>Comment/Feedback</th><th>No. of Feedback Received</th><th>Last Updated on</th></tr></thead><tbody><tr><td>1</td><td>Ambala</td><td><a target="_blank" href="../../content/pdfs/Ambala.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>3 Feedback Received</td><td>22.01.2025</td></tr><tr><td>2</td><td>Bhiwani</td><td><a target="_blank" href="../../content/pdfs/Bhiwani.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>2 Feedback Received</td><td>22.01.2025</td></tr><tr><td>3</td><td>Charkhi Dadri</td><td><a target="_blank" href="../../content/pdfs/Charkhi Dadri.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>4 Feedback Received</td><td>22.01.2025</td></tr><tr><td>4</td><td>Faridabad</td><td><a target="_blank" href="../../content/pdfs/Faridabad.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>6 Feedback Received</td><td>22.01.2025</td></tr><tr><td>5</td><td>Fatehabad</td><td><a target="_blank" href="../../content/pdfs/Fatehabad.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>1 Feedback Received</td><td>22.01.2025</td></tr><tr><td>6</td><td>Gurugram</td><td><a target="_blank" href="../../content/pdfs/Gurugram.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>0 Feedback Received</td><td>22.01.2025</td></tr><tr><td>7</td><td>Hisar</td><td><a target="_blank" href="../../content/pdfs/Hisar.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>0 Feedback Received</td><td>22.01.2025</td></tr><tr><td>8</td><td>Jhajjar</td><td><a target="_blank" href="../../content/pdfs/Jhajjar.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>0 Feedback Received</td><td>22.01.2025</td></tr><tr><td>9</td><td>Jind</td><td><a target="_blank" href="../../content/pdfs/Jind.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>0 Feedback Received</td><td>22.01.2025</td></tr><tr><td>10</td><td>Kaithal</td><td><a target="_blank" href="../../content/pdfs/Kaithal.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>0 Feedback Received</td><td>22.01.2025</td></tr><tr><td>11</td><td>Karnal</td><td><a target="_blank" href="../../content/pdfs/Karnal.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>0 Feedback Received</td><td>22.01.2025</td></tr><tr><td>12</td><td>Kurukshetra</td><td><a target="_blank" href="../../content/pdfs/Kurukshetra.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>0 Feedback Received</td><td>22.01.2025</td></tr><tr><td>13</td><td>Mahendergarh</td><td><a target="_blank" href="../../content/pdfs/Mahendergarh.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>0 Feedback Received</td><td>22.01.2025</td></tr><tr><td>14</td><td>Nuh</td><td><a target="_blank" href="../../content/pdfs/Nuh.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>2 Feedback Received</td><td>22.01.2025</td></tr><tr><td>15</td><td>Palwal</td><td><a target="_blank" href="../../content/pdfs/Palwal.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>3 Feedback Received</td><td>22.01.2025</td></tr><tr><td>16</td><td>Panchkula</td><td><a target="_blank" href="../../content/pdfs/Panchkula.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>1 Feedback Received</td><td>22.01.2025</td></tr><tr><td>17</td><td>Panipat</td><td><a target="_blank" href="../../content/pdfs/Panipat.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>4 Feedback Received</td><td>22.01.2025</td></tr><tr><td>18</td><td>Rewari</td><td><a target="_blank" href="../../content/pdfs/Rewari.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>7 Feedback Received</td><td>22.01.2025</td></tr><tr><td>19</td><td>Rohtak</td><td><a target="_blank" href="../../content/pdfs/Rohtak.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>10 Feedback Received</td><td>22.01.2025</td></tr><tr><td>20</td><td>Sirsa</td><td><a target="_blank" href="../../content/pdfs/Sirsa.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>3 Feedback Received</td><td>22.01.2025</td></tr><tr><td>21</td><td>Sonipat</td><td><a target="_blank" href="../../content/pdfs/Sonipat.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>0 Feedback Received</td><td>22.01.2025</td></tr><tr><td>22</td><td>Yamunanagar</td><td><a target="_blank" href="../../content/pdfs/Yamumnagar.pdf">Click to download DEAP</a></td><td><button class="btn btn-primary btn-sm" ng-click="openForm()">Give Feedback</button></td><td>0 Feedback Received</td><td>22.01.2025</td></tr><br></tbody></table></div><!-- Modal --><div class="modal fade" id="feedbackModal" tabindex="-1" role="dialog"><div class="modal-dialog" role="document"><div class="modal-content"><form><div class="modal-header"><h4 class="modal-title">Feedback Form</h4><button type="button" class="close" data-dismiss="modal">&times;</button></div><div class="modal-body"><div class="form-group"><label>Name</label><input type="text" ng-model="feedback.name" class="form-control" required></div><div class="form-group"><label>Email</label><input type="email" ng-model="feedback.email" class="form-control" required></div><div class="form-group"><label>Mobile</label><input type="text" ng-model="feedback.mobile" class="form-control" required></div><div class="form-group"><label>Comment</label><textarea ng-model="feedback.comment" class="form-control" required></textarea></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-click="vm.submitFeedback()">Submit Feedback</button> <button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></form></div></div></div></div></div>');
$templateCache.put('app/feedbackratingdashboard/allratingsummary.html','<div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-10"><h4 class="modal-title text-warning bold" id="myBlockLabel">{{ vm.status + " Ratings"}}</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="col-md-1 pull-right"><button ng-show="vm.feedbacks.length > 0" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div><div class="panel-body"><div class="table-responsive"><table id="result_table" class="jh-table table table-responsive table-condensed table-striped col-md-12" ng-show="vm.feedbacks.length > 0"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><th><span>Name</span></th><th><span>Business Entity</span></th><th><span>Email</span></th><th><span>Contact No.</span></th><th><span>District</span></th><th><span>Project Level</span></th><th><span>Department Name</span></th><th><span>Service Name</span></th><th><span>Applied Date</span></th><th><span>Cleared Date</span></th><th><span>Rating</span></th><th><span>Comments</span></th><th><span>Feedback Date</span></th><!--<th ng-show="vm.status === \'Resolved\'"><span>Resolved</span></th>--><th ng-if="vm.status === \'Resolved\'"><span>Action Taken</span></th><th ng-if="vm.status === \'Resolved\'"><span>Action Date</span></th></tr></thead><tbody><tr ng-repeat="rating in vm.feedbacks track by rating.id"><td>{{$index +1}}</td><td>{{rating.cafPin}}</td><td>{{rating.name}}</td><td>{{rating.businessEntity}}</td><td>{{rating.investorEmail}}</td><td>{{rating.investorContact}}</td><td>{{rating.district}}</td><td>{{rating.projectLevel == \'e\' ? \'EEC\' : \'DLCC\'}}</td><td>{{rating.departmentName}}</td><td>{{rating.serviceName}}</td><td>{{rating.appliedDate | date:\'dd-MMM-yy\'}}</td><td>{{rating.clearedDate | date:\'dd-MMM-yy\'}}</td><td>{{rating.rating}}</td><td>{{rating.comment}}</td><td>{{rating.lastUpadte | date:\'dd-MMM-yy\'}}</td><!--<td ng-show="vm.status === \'Resolved\'">{{(rating.isResolved == \'\' || rating.isResolved == false) ? \'No\' : \'Yes\'}}</td>--><td ng-show="vm.status === \'Resolved\'">{{rating.actionTaken}}</td><td ng-show="vm.status === \'Resolved\'">{{rating.actionTakenDate | date:\'dd-MMM-yy\'}}</td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div><style>.app-modal-window .modal-dialog {\n      width: 1000px;\n    }</style>');
$templateCache.put('app/feedbackratingdashboard/feedbacks.html','<div class="col-md-12"><div class="row"><div class="col-md-3"><button class="btn btn-success" ui-sref="allratingsummary({status:\'Resolved\'})">Resolved<span class="badge">{{vm.resolvedPoorCounter + vm.resolvedAverageCounter}}</span></button> <button class="btn btn-warning" ui-sref="allratingsummary({status:\'Unresolved\'})">Unresolved<span class="badge">{{vm.unresolvedPoorCounter + vm.unresolvedAverageCounter}}</span></button></div><div class="col-md-9"><ul class="nav nav-pills"><li class="active"><a style="cursor: default">Total Ratings<span class="badge">{{vm.allRatingStats.excellentCounter + vm.allRatingStats.veryGoodCounter + vm.allRatingStats.goodCounter + vm.allRatingStats.averageCounter + vm.allRatingStats.poorCounter}}</span></a></li><li class="active"><a style="cursor: default">Excellent<span class="badge">{{vm.allRatingStats.excellentCounter}}</span></a></li><li class="active"><a style="cursor: default">Very Good<span class="badge">{{vm.allRatingStats.veryGoodCounter}}</span></a></li><li class="active"><a style="cursor: default">Good<span class="badge">{{vm.allRatingStats.goodCounter}}</span></a></li><li class="active"><a style="cursor: default">Average<span class="badge">{{vm.allRatingStats.averageCounter}}</span></a></li><li class="active"><a style="cursor: default">Poor<span class="badge">{{vm.allRatingStats.poorCounter}}</span></a></li></ul></div></div></div><div class="well"><div class="row"><div class="col-md-2" style=""><h2 class="text-danger"><b>User Ratings <span><button ng-show="vm.feedbackratings.length > 0" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></span></b></h2></div><div class="col-md-4" style="padding-top: 22px; text-align: center"><span class="uk-label uk-label-danger" style="font-size: 15px">FILTER BY:</span> <span><div class="btn-group"><select class="form-control" ng-model="vm.filter" ng-change="vm.selectFilter(vm.filter)"><option value="" disabled="disabled">-- Filter Type--</option><option value="district">District</option><option value="department">Department</option></select><!--<button type="button" class="btn btn-primary" autofocus="autofocus" ng-click="vm.selectFilter(\'department\')">Department</button>--><!--&lt;!&ndash;<button type="button" class="btn btn-primary" autofocus="autofocus" ng-click="vm.selectFilter(\'service\')">Service</button>&ndash;&gt;--><!--<button type="button" class="btn btn-primary" ng-click="vm.selectFilter(\'district\')">District</button>--></div></span></div><div class="col-md-2" style="padding-top: 22px" ng-show="vm.selectedFilter === \'department\'"><select class="form-control" ng-model="vm.selectedDepartmentId" ng-change="vm.departmentSelected(vm.selectedDepartmentId)"><!--ng-repeat="departmentname as departmentname for departmentname in vm.departments | orderBy: \'departmentName\'"--><option value="" disabled="disabled">Select Department</option><option value="{{departmentname}}" ng-repeat="departmentname in vm.departments | orderBy:\'departmentname\'">{{departmentname}}</option></select></div><!--<div class="col-md-4" style="padding-top: 22px; " ng-show="vm.selectedFilter === \'department\'" >--><!--<select class="form-control" ng-model="vm.selectedDepartmentId" ng-change="vm.departmentSelected(vm.selectedDepartmentId)">--><!--<option value="" disabled selected>&#45;&#45;Select Department&#45;&#45;</option>--><!--<option value="{{ departmentname.departmentname }}" ng-repeat="departmentname in vm.departments | orderBy : \'departmentname\'">{{ departmentname.departmentname}}</option>--><!--</select>--><!--</div>--><div class="col-md-4" style="padding-top: 22px" ng-show="vm.selectedFilter === \'department\'"><select class="form-control" ng-model="vm.selectedServiceId" ng-change="vm.serviceSelected(vm.selectedServiceId)"><option value="" disabled="disabled">--Select Service--</option><option value="{{ departmentservice}}" ng-repeat="departmentservice in vm.departmentservices | orderBy : \'departmentservice\'">{{ departmentservice}}</option></select></div><div class="col-md-4" style="padding-top: 22px" ng-show="vm.selectedFilter === \'district\'"><select class="form-control" ng-model="vm.selectedDistrict" ng-change="vm.districtSelected(vm.selectedDistrict)"><option value="" disabled="disabled" selected="selected">--Select District--</option><option value="{{ district.districtname }}" ng-repeat="district in vm.districts | orderBy : \'districtname\'">{{ district.districtname }}</option></select></div></div><hr style="border-width: thick"><div class="table-responsive"><table id="result_table" class="jh-table table table-striped" ng-show="vm.feedbackratings.length > 0"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><th><span>Name</span></th><th><span>Business Entity</span></th><th><span>Email</span></th><th><span>Contact No.</span></th><th><span>District</span></th><th><span>Project Level</span></th><th><span>Department Name</span></th><th><span>Service Name</span></th><th><span>Applied Date</span></th><th><span>Cleared Date</span></th><th><span>Rating</span></th><th><span>Comments</span></th><th><span>Feedback Date</span></th></tr></thead><tbody><tr ng-repeat="rating in vm.feedbackratings | orderBy : \'-lastUpadte\'"><td>{{$index +1}}</td><td>{{rating.cafPin}}</td><td>{{rating.name}}</td><td>{{rating.businessEntity}}</td><td>{{rating.investorEmail}}</td><td>{{rating.investorContact}}</td><td>{{rating.district}}</td><td>{{rating.projectLevel == \'e\' ? \'EEC\' : \'DLCC\'}}</td><td>{{rating.departmentName}}</td><td>{{rating.serviceName}}</td><td>{{rating.appliedDate | date:\'dd-MMM-yy\'}}</td><td>{{rating.clearedDate | date:\'dd-MMM-yy\'}}</td><td>{{rating.rating}}</td><td>{{rating.comment}}</td><td>{{rating.lastUpadte | date:\'dd-MMM-yy\'}}</td></tr></tbody></table><div class="alert alert-warning" ng-hide="vm.feedbackratings.length > 0 "><b>No</b> ratings received for this {{ vm.selectedFilter }}!</div></div></div>');
$templateCache.put('app/feedbacksbyofficer/actiontaken.html','<form name="editForm" role="form" ng-submit="vm.saveActionTaken()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Action Taken</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Action Taken</label><textarea class="form-control" rows="3" id="textArea" ng-model="vm.actionTaken" required></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/feedbacksbyofficer/feedbacksbyofficer.html','<div class="well"><h2 class="text-danger"><b>User Ratings</b></h2><a class="pull-right" ng-click="vm.getPoorAverage()" ng-hide="vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\')">Click here to notify action taken on Average and Poor Feedback</a><hr style="border-width: thick"><div class="row"><div class="col-md-10"><li ng-repeat="departmentName in vm.departmentNames" style="list-style-type:none"><code style="font-size:18px">{{ departmentName }}</code></li></div><div class="col-md-2"><button class="btn btn-md btn-success" ng-if="vm.filter" ng-click="vm.back()">Back</button> <button ng-show="vm.feedbacks.length > 0" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><hr style="border-width: thick"><div class="row"><div class="col-md-7"><!--<div class="btn-group" data-toggle="buttons">--><!--<label class="btn btn-warning active">--><!--<input type="radio" ng-model="vm.getWorkListType" id="option1" ng-change="vm.getWorkList(vm.getWorkListType)"> Un-resolved--><!--</label>--><!--<label class="btn btn-success">--><!--<input type="radio" ng-model="vm.getWorkListType" id="option2" ng-change="vm.getWorkList(vm.getWorkListType)"> Resolved--><!--</label>--><!--</div>--> <button class="btn btn-md btn-warning" ng-hide="vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\')" ng-click="vm.getPoorAverage()">Un-resolved</button> <button class="btn btn-md btn-success" ng-hide="vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\')" ng-click="vm.getWorkList(\'resolved\')">Resolved</button></div><div class="form-group col-md-5" ng-if="!vm.filter" ng-show="vm.account.authorities.includes(\'ROLE_FEEDBACK_OFFICER\')"><label class="control-label col-md-3">Rating Type</label><div class="col-md-9"><select class="form-control" ng-model="vm.ratingType" ng-change="vm.getRatingsByRating(vm.ratingType)"><option value="All">All</option><option value="Excellent">Excellent</option><option value="Very Good">Very Good</option><option value="Good">Good</option><option value="Average">Average</option><option value="Poor">Poor</option></select></div></div><div class="form-group col-md-5" ng-show="vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') && !vm.account.authorities.includes(\'ROLE_FEEDBACK_OFFICER\')"><label class="control-label col-md-3">Rating Type</label><div class="col-md-9"><select class="form-control" ng-model="vm.ratingType" ng-change="vm.getRatingsByRating(vm.ratingType)"><!--<option value=" " disabled>&#45;&#45;Select Rating Type</option>--><option value="Average" ng-selected="true">Average</option><option value="Poor">Poor</option></select></div></div></div><hr style="border-width: thick"><div class="table-responsive"><table id="result_table" class="jh-table table table-responsive table-condensed table-striped col-md-12" ng-show="(vm.feedbacks.length > 0 && !vm.resolve) || (vm.ResolveFeedback.length > 0 && vm.resolve)"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><th><span>Name</span></th><th><span>Business Entity</span></th><th><span>Email</span></th><th><span>Contact No.</span></th><th><span>District</span></th><th><span>Project Level</span></th><th><span>Department Name</span></th><th><span>Service Name</span></th><th><span>Applied Date</span></th><th><span>Cleared Date</span></th><th><span>Rating</span></th><th><span>Comments</span></th><th><span>Feedback Date</span></th><th ng-hide="vm.getWorkType === \'pending\'"><span>Resolved</span></th><th ng-hide="vm.getWorkType === \'pending\'"><span>Action Taken</span></th><th ng-hide="vm.getWorkType === \'pending\'"><span>Action Date</span></th></tr></thead><tbody><tr ng-if="!vm.resolve" ng-repeat="rating in vm.feedbacks"><td>{{$index +1}}</td><td>{{rating.cafPin}}</td><td>{{rating.name}}</td><td>{{rating.businessEntity}}</td><td>{{rating.investorEmail}}</td><td>{{rating.investorContact}}</td><td>{{rating.district}}</td><td>{{rating.projectLevel == \'e\' ? \'EEC\' : \'DLCC\'}}</td><td>{{rating.departmentName}}</td><td>{{rating.serviceName}}</td><td>{{rating.appliedDate | date:\'dd-MMM-yy\'}}</td><td>{{rating.clearedDate | date:\'dd-MMM-yy\'}}</td><td>{{rating.rating}}</td><td>{{rating.comment}}</td><td>{{rating.lastUpadte | date:\'dd-MMM-yy\'}}</td><td ng-show="rating.isResolved === true">{{(rating.isResolved == \'\' || rating.isResolved == false) ? \'No\' : \'Yes\'}}</td><td ng-show="rating.isResolved === true">{{rating.actionTaken}}</td><td ng-show="rating.isResolved === true">{{rating.actionTakenDate | date:\'dd-MMM-yy\'}}</td><td ng-show="(rating.rating === \'Poor\' || rating.rating === \'Average\') && (rating.isResolved != true)"><button class="btn btn-md btn-warning" has-authority="ROLE_FEEDBACK_OFFICER" ui-sref="resolveRating({ratingId: rating.id})">Resolve</button></td></tr><tr ng-if="vm.resolve" ng-repeat="rating in vm.ResolveFeedback | filter: averageOrPoor"><td>{{$index +1}}</td><td>{{rating.cafPin}}</td><td>{{rating.name}}</td><td>{{rating.businessEntity}}</td><td>{{rating.investorEmail}}</td><td>{{rating.investorContact}}</td><td>{{rating.district}}</td><td>{{rating.projectLevel == \'e\' ? \'EEC\' : \'DLCC\'}}</td><td>{{rating.departmentName}}</td><td>{{rating.serviceName}}</td><td>{{rating.appliedDate | date:\'dd-MMM-yy\'}}</td><td>{{rating.clearedDate | date:\'dd-MMM-yy\'}}</td><td>{{rating.rating}}</td><td>{{rating.comment}}</td><td>{{rating.lastUpadte | date:\'dd-MMM-yy\'}}</td><td ng-show="rating.isResolved === true">{{(rating.isResolved == \'\' || rating.isResolved == false) ? \'No\' : \'Yes\'}}</td><td ng-show="rating.isResolved === true">{{rating.actionTaken}}</td><td ng-show="rating.isResolved === true">{{rating.actionTakenDate | date:\'dd-MMM-yy\'}}</td><td ng-show="(rating.rating === \'Poor\' || rating.rating === \'Average\') && (rating.isResolved != true)"><button class="btn btn-md btn-warning" has-authority="ROLE_FEEDBACK_OFFICER" ui-sref="resolveRating({ratingId: rating.id})">Resolve</button></td></tr></tbody></table><div class="alert alert-warning" ng-hide="(vm.feedbacks.length > 0 && !vm.resolve) || (vm.ResolveFeedback.length > 0 && vm.resolve)"><b>No</b> ratings received!</div></div></div>');
$templateCache.put('app/force-majeure/force-majeure.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Force Majeure \u2013 Application Form</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Force Majeure</span></li><!--            <li class="active"><span>Third Party Inspection</span></li>--></ol></div></section><br><div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Force Majeure</h3></div><div class="panel-body"><form name="inspectionForm" class="form-horizontal" ng-submit="vm.applyTemporaryTower()" novalidate><!-- District --><div class="form-group"><label class="col-lg-3 control-label pull-left">District <span class="text-danger">*</span></label><div class="col-lg-6"><select class="form-control" ng-model="vm.selectedDistrict" ng-options="d as d.districtname for d in vm.districts" required><option value="">Select District</option></select></div></div><!-- Start Date --><div class="form-group"><label class="col-lg-3 control-label pull-left">Start Date <span class="text-danger">*</span></label><div class="col-lg-6"><input type="date" class="form-control" min="{{ vm.minDate | date:\'yyyy-MM-dd\' }}" ng-model="vm.form.startDate" required></div></div><!-- End Date --><div class="form-group"><label class="col-lg-3 control-label pull-left">End Date <span class="text-danger">*</span></label><div class="col-lg-6"><input type="date" class="form-control" min="{{ vm.minDate | date:\'yyyy-MM-dd\' }}" ng-model="vm.form.endDate" required></div></div><!-- Remark --><div class="form-group"><label class="col-lg-3 control-label pull-left">Remark</label><div class="col-lg-6"><textarea class="form-control" rows="3" ng-model="vm.form.remark"></textarea></div></div><div class="form-group"><label class="col-lg-3 control-label pull-left" data-translate="">Attachment</label><div class="col-lg-6"><input type="file" class="form-control" file-model="vm.form.file"></div><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div><!-- Submit --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><button type="submit" class="btn btn-warning pull-right" ng-disabled="inspectionForm.$invalid">Submit</button></div></div></form></div></div><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title">Your Submitted Force Majeure Applications</h3></div><div class="panel-body"><table class="table table-bordered table-striped" ng-if="vm.applications.length > 0"><thead><tr><th>District</th><th>Start Date</th><th>End Date</th><th>Status</th><th>Applied Date</th><th>View Document</th><th>Action</th></tr></thead><tbody><tr ng-repeat="app in vm.applications"><td>{{app.district}}</td><td>{{app.startDate | date:\'dd-MM-yyyy\'}}</td><td>{{app.endDate | date:\'dd-MM-yyyy\'}}</td><td>{{app.status}}</td><td>{{app.appliedDate | date:\'dd-MM-yyyy\'}}</td><td><a ng-if="app.filePath" ng-href="/api/files{{app.filePath}}" target="_blank" class="btn btn-primary">View Document</a></td><td><button ng-if="app.status==\'ServiceStopped\'" class="btn btn-primary btn-sm" ng-click="vm.openEditModal(app)">Resume</button></td></tr></tbody></table><div ng-if="vm.applications.length === 0"><p>No applications found.</p></div></div></div></div><div id="editTowerModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog modal-md" role="document"><div class="modal-content"><div class="modal-header"><h4 class="modal-title">Confirmation</h4><button type="button" class="close" data-dismiss="modal">&times;</button></div><div class="modal-body"><p>Are you sure you want to resume service?</p></div><div class="modal-footer"><button class="btn btn-success" ng-click="vm.Resume()">Yes</button> <button class="btn btn-default" data-dismiss="modal">No</button></div></div></div></div>');
$templateCache.put('app/grievancedashboard/grievancedashboard.html','<div class="container"><ul class="nav nav-pills flex-container"><li class="active"><a>Total Unassigned Grievances <span class="badge">{{vm.totalunassignedgrievances}}</span></a></li><li class="active"><a>Total Assigned Grievances <span class="badge">{{vm.totalassignedgrievances}}</span></a></li><li class="active"><a>Total Pending Grievances <span class="badge">{{vm.totalpendinggrievances}}</span></a></li><li class="active"><a>Total Resolved Grievances <span class="badge">{{vm.totalresolvedgrievances}}</span></a></li></ul><br><button type="button" class="btn btn-primary pull-right" ui-sref="searchGrievance" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><span class="glyphicon glyphicon-search"></span>&nbsp;&nbsp;Search By GrievanceID</button><div ng-repeat="(departmentname, grievancedashboard_districtdata) in vm.grievancedashboard | groupBy: \'deptname\' "><div class="row"><h3>{{departmentname}}</h3><table class="table table-striped table-hover table-responsive"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-3">District</th><th class="col-md-1 text-center">Total</th><th class="col-md-2 text-center">Unassigned</th><th class="col-md-2 text-center">Assigned</th><th class="col-md-2 text-center">Pending</th><th class="col-md-2 text-center">Resolved</th></tr></thead><tbody><tr class="row" ng-repeat="grievancestats in grievancedashboard_districtdata"><td class="col-md-3">{{grievancestats.districtname}}</td><td class="col-md-1 text-center"><a ui-sref="grievanceviewstatsdetail({departmentId:grievancestats.deptid,district:grievancestats.districtname,districtId:grievancestats.districtid,status:\'Total\'})"><span class="badge">{{grievancestats.total}}</span></a></td><td class="col-md-2 text-center"><a ui-sref="grievanceviewstatsdetail({departmentId:grievancestats.deptid,district:grievancestats.districtname,districtId:grievancestats.districtid,status:\'Unassigned\'})"><span class="badge">{{grievancestats.unassigned}}</span></a></td><td class="col-md-2 text-center"><a ui-sref="grievanceviewstatsdetail({departmentId:grievancestats.deptid,district:grievancestats.districtname,districtId:grievancestats.districtid,status:\'Assigned\'})"><span class="badge">{{grievancestats.assigned}}</span></a></td><td class="col-md-2 text-center"><a ui-sref="grievanceviewstatsdetail({departmentId:grievancestats.deptid,district:grievancestats.districtname,districtId:grievancestats.districtid,status:\'Pending\'})"><span class="badge">{{grievancestats.pending}}</span></a></td><td class="col-md-2 text-center"><a ui-sref="grievanceviewstatsdetail({departmentId:grievancestats.deptid,district:grievancestats.districtname,districtId:grievancestats.districtid,status:\'Resolved\'})"><span class="badge">{{grievancestats.resolved}}</span></a></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/grievancedashboard/grievanceviewstatsdetail.html','<form name="grievanceform"><div class="modal-header"><div class="row"><div class="col-md-10"><h4 class="modal-title text-warning bold" ng-show="vm.status==\'Total\'">Total Grievances : {{vm.district}}</h4><h4 class="modal-title text-warning bold" ng-show="vm.status==\'Pending\'">Pending Grievances : {{vm.district}}</h4><h4 class="modal-title text-warning bold" ng-show="vm.status==\'Resolved\'">Resolved Grievances : {{vm.district}}</h4><h4 class="modal-title text-warning bold" ng-show="vm.status==\'Unassigned\'">Unassigned Grievances : {{vm.district}}</h4><h4 class="modal-title text-warning bold" ng-show="vm.status==\'Assigned\'">Assigned Grievances : {{vm.district}}</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="col-md-1 pull-right"><button ng-show="vm.show" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div><div class="modal-body"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>Grievance ID</span></th><th><span>Grievance</span></th><th><span>Grievance By</span></th><th><span>Grievance Date</span></th><!--<th ng-show="vm.assignstatus==true || vm.status==\'Pending\' || vm.status==\'Resolved\'"><span>Assign To</span></th>--><!--<th ng-show="vm.assignstatus==true || vm.status==\'Pending\' || vm.status==\'Resolved\'"><span>Assign By</span></th>--><!--<th ng-show="vm.assignstatus==true || vm.status==\'Pending\' || vm.status==\'Resolved\'"><span>Assign Date</span></th>--><!--<th ng-show="vm.status==\'Resolved\'"><span>Resolved By</span></th>--><!--<th ng-show="vm.status==\'Resolved\'"><span>Resolved Date</span></th>--></tr></thead><tbody><tr ng-repeat="grievances in vm.grievancestats | orderBy: \'-grievanceDate\'"><td>{{$index +1}}</td><td>{{grievances.grievanceId}}</td><td>{{grievances.grievance}}</td><td>{{grievances.grievanceBy}}</td><td>{{grievances.grievanceDate | date:\'medium\'}}</td><!--<td ng-show="vm.assignstatus==true || vm.status==\'Pending\' || vm.status==\'Resolved\'">{{grievances.assignTo}}</td>--><!--<td ng-show="vm.assignstatus==true || vm.status==\'Pending\' || vm.status==\'Resolved\'">{{grievances.assignBy}}</td>--><!--<td ng-show="vm.assignstatus==true || vm.status==\'Pending\' || vm.status==\'Resolved\'">{{grievances.assignDate}}</td>--><!--<td ng-show="vm.status==\'Resolved\'">{{grievances.resolveBy}}</td>--><!--<td ng-show="vm.status==\'Resolved\'">{{grievances.resolveDate}}</td>--></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/grievancedashboard/searchgrievance.html','<div class="container"><div class="row" style="margin-top: 10px"><div class="col-sm-4"><input type="text" ng-model="vm.grievanceID" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Enter Grievance ID"></div><div class="btn-group col-sm-4"><button type="button" ng-click="vm.getGrievance()" class="btn btn-info" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">Search</button></div></div><div class="row" ng-show="vm.showtable"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>Sr No.</th><th>Grievance ID</th><th>Grievance</th><th ng-show="vm.status === \'assigned\'">Assigned To</th><th>Date</th><th>District</th><th>Department</th><th ng-show="vm.status=== \'all\'">Assign Status</th><th ng-show="vm.status=== \'all\'">Status</th></tr></thead><tbody><tr><td>{{$index+1}}</td><td><a ng-click="vm.showPersonalDetail(vm.grievance .id)">{{vm.grievance .grievanceId}}</a></td><td>{{vm.grievance .grievance}}</td><td ng-show="vm.status === \'assigned\'">{{vm.grievance .assignTo}}</td><td>{{vm.grievance .grievanceDate | date:\'medium\'}}</td><td>{{vm.grievance .district}}</td><td>{{vm.grievance .department}}</td><th ng-show="vm.status=== \'all\'">{{vm.grievance .assignStatus}}</th><td ng-show="vm.status=== \'all\'">{{vm.grievance .status}}</td><td><button ng-show="vm.status===\'unassigned\'" type="button" class="btn btn-sm btn-success" ui-sref="grievanceassign({id:grievance.id})"><span class="glyphicon glyphicon-user"></span> &nbsp Assign</button> <button type="button" class="btn btn-sm btn-warning" ui-sref="viewlog({grievanceId:vm.grievance.grievanceId})"><span class="glyphicon glyphicon-th-list"></span> &nbsp View Log</button> <button type="button" class="btn btn-sm btn-danger" data-toggle="modal" data-target="#myModal" ng-click="vm.commentContent(vm.grievance)"><span class="glyphicon glyphicon-comment"></span> &nbsp; Comment</button></td></tr></tbody></table></div></div></div><!-- Modal --><div id="myModal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Comment</h4></div><div class="modal-body"><div class="form-group"><textarea class="form-control" rows="4" id="textArea" ng-model="vm.commentValue" required></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal"><span class="glyphicon glyphicon-remove-circle"></span> &nbsp; Close</button> <button type="button" class="btn btn-primary" data-dismiss="modal" ng-disabled="vm.commentValue ==null" ng-click="vm.comment()"><span class="glyphicon glyphicon-comment"></span> &nbsp; Comment</button></div></div></div></div>');
$templateCache.put('app/grievancedetail/ViewGrievanceFormFilled.html','<div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><br><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success pull-right"><span class="glyphicon glyphicon-download-alt"></span></button></div><div id="pdf_data"><h2><span>&nbsp;Grievance ID:</span> {{vm.grievancedata.grievanceId}}</h2><hr><h3><span>&nbsp;&nbsp;Personal Details</span></h3><dl class="dl-horizontal jh-entity-details col-md-offset-3"><dt><span>Name Of Enterprise</span></dt><dd><span>{{vm.grievancedata.nameOfEnterprise}}</span></dd><dt><span>Name Of Partner</span></dt><dd><span>{{vm.grievancedata.nameOfPartner}}</span></dd><dt><span>Mobile Number</span></dt><dd><span>{{vm.grievancedata.contactNumber}}</span></dd><dt><span>Email Address</span></dt><dd><span>{{vm.grievancedata.emailAddress}}</span></dd><dt><span>Correspondence Address</span></dt><dd><span>{{vm.grievancedata.correspondenceAddress}}</span></dd><dt><span>Factory Address</span></dt><dd><span>{{vm.grievancedata.factoryAddress}}</span></dd><dt><span>District</span></dt><dd><span>{{vm.grievancedata.district}}</span></dd></dl><h3><span>&nbsp;&nbsp;Grievance Details</span></h3><hr><dl class="dl-horizontal jh-entity-details col-md-offset-3"><dt><span>Department Name</span></dt><dd><span>{{vm.grievancedata.department}}</span></dd><dt><span>Category Of Grievance</span></dt><dd><span>{{vm.grievancedata.categoryOfGrievance}}</span></dd><dt><span>Detail Of Grievance</span></dt><dd><span>{{vm.grievancedata.grievance}}</span></dd><dt><span>Activity</span></dt><dd><span>{{vm.grievancedata.activityOfEnterprise}}</span></dd><dt><span>Is Resolved</span></dt><dd ng-if="vm.grievance.isResolved"><span>Yes</span></dd><dd ng-if="!vm.grievancedata.isResolved"><span>NO</span></dd><dt><span>Grievance Reffered</span></dt><dd ng-if="!vm.grievancedata.grievanceRefferedToDept"><span>NO</span></dd><dd ng-if="vm.grievance.gotReliefLevel"><span>YES</span></dd><dt><span>Resolve Comment</span></dt><dd><span>{{vm.grievancedata.resolveComment}}</span></dd><dt><span>Department Name</span></dt><dd><span>{{vm.grievance.departmentName}}</span></dd><dt><span>Department Appeals</span></dt><dd ng-if="vm.grievance.departmentAppeals"><span>Yes</span></dd><dd ng-if="!vm.grievance.departmentAppeals"><span>NO</span></dd><dt><span>Resolve Comment</span></dt><dd><span>{{vm.grievance.resolveComment}}</span></dd><dt><span>Userlogin</span></dt><dd><span>{{vm.grievance.userlogin}}</span></dd><dt><span>Date Of Communication</span></dt><dd><span>{{vm.grievancedata.dateOfCommunication | date:\'mediumDate\'}}</span></dd><dt><span>Other Category</span></dt><dd><span>{{vm.grievancedata.otherCategory}}</span></dd></dl><hr><h3 ng-if="vm.grievancedata.attachment1 !=null && vm.grievancedata.attachment2 !=null"><span>&nbsp;&nbsp;Grievance Attachments</span></h3><dl class="dl-horizontal jh-entity-details col-md-offset-3"><dt ng-if="vm.grievancedata.attachment1 !=null"><span>Attachemnt 1</span></dt><dd ng-if="vm.grievancedata.attachment1 !=null"><span><button class="btn btn-info" ng-click="vm.downloadFile(vm.grievancedata.attachment1)">Download</button></span></dd><br><dt ng-if="vm.grievancedata.attachment2 !=null"><span>Attachemnt 2</span></dt><dd ng-if="vm.grievancedata.attachment2 !=null"><span><button class="btn btn-info" ng-click="vm.downloadFile(vm.grievancedata.attachment2)">Download</button></span></dd><br></dl><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></div></div>');
$templateCache.put('app/grievancedetail/grievanceassign.html','<form name="grievanceform"><div class="modal-header"><button type="button" class="close" data-dismiss="" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Assign Grievance</h4></div><div class="modal-body"><dl class="dl-horizontal"><dt><span class="pull-left">Grievance:</span></dt><dd><span>{{vm.grievance.grievance}}</span></dd></dl><div class="form-group"><label for="select" class="control-label">Assign to:</label><div class=""><select class="form-control" id="select" ng-model="vm.grievance.selectedassignTo" ng-options="user.firstName for user in vm.users"><option value="">--Select Grievance Officer--</option></select></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.updateAssignGrievance()" ng-disabled="vm.grievance.selectedassignTo==null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Submit</span></button></div></form>');
$templateCache.put('app/grievancedetail/grievancedetail.html','<form name="grievanceForm" role="form" data-backdrop="static" data-keyboard="false" novalidate ng-submit="vm.addfileattachment()"><div class="modal-header"><button type="button" class="close" data-dismiss="" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Grievance</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" for="field_nameOfEnterprise">Name of the Enterprise/Industries Association</label><input type="text" class="form-control" name="nameOfEnterprise" id="field_nameOfEnterprise" ng-model="vm.grievancedata.nameOfEnterprise" required></div><div class="form-group"><label class="control-label" for="field_officeAddress">Complete Factory/Association Address</label><input type="text" class="form-control" name="officeAddress" id="field_officeAddress" ng-model="vm.grievancedata.factoryAddress" required></div><div class="form-group"><label class="control-label" for="field_address">Correspondence Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.grievancedata.correspondenceAddress" required></div><div class="form-group"><label for="district" class="control-label">District<span style="color:red">&nbsp *</span></label><select class="form-control" id="district" ng-model="vm.grievancedata.selecteddistrict" ng-options="district.districtname for district in vm.districts" required><option value="">--Select District--</option></select></div><div class="form-group"><label class="control-label" for="field_activity">Activity of Enterprise</label><input type="text" class="form-control" name="activity" id="field_activity" ng-model="vm.grievancedata.activityOfEnterprise" required></div><div class="form-group"><label class="control-label" for="field_adhaarNumber">Adhaar/ UAM/ IEM Number of Enterprises</label><input type="text" class="form-control" name="adhaarNumber" id="field_adhaarNumber" ng-model="vm.grievancedata.adhaarNumber" required></div><div class="form-group"><label class="control-label" for="field_nameOfPartner">Name of Proprietor/Partner/Director</label><input type="text" class="form-control" name="nameOfPartner" id="field_nameOfPartner" ng-model="vm.grievancedata.nameOfPartner" required></div><div class="form-group"><label class="control-label" for="field_officeBearerIndustriesAssociation">Name of the Office bearer of Industries Association</label><input type="text" class="form-control" name="officeBearerIndustriesAssociation" id="field_officeBearerIndustriesAssociation" ng-model="vm.grievancedata.officeBearerIndustriesAssociation" required></div><div class="form-group"><label class="control-label" for="field_mobileNumber">Contact Number</label><input type="number" class="form-control" name="mobileNumber" id="field_mobileNumber" ng-model="vm.grievancedata.contactNumber" minlength="10" maxlength="10" required><div ng-show="grievanceForm.mobileNumber.$invalid && editForm.mobileNumber.$touched "><small style="color:red; display:block">Invalid Input</small></div></div><div class="form-group"><label class="control-label" for="field_emailAddress">Email Address</label><input type="email" class="form-control" name="emailAddress" id="field_emailAddress" ng-model="vm.grievancedata.emailAddress" required><div ng-show="grievanceForm.emailAddress.$invalid && editForm.emailAddress.$touched "><small style="color:red; display:block">Invalid Input</small></div></div><div class="form-group"><label class="control-label" for="field_categoryOfGrievance">Category Of Grievance</label><select class="form-control" name="categoryOfGrievance" id="field_categoryOfGrievance" ng-model="vm.grievancedata.categoryOfGrievance" required><option value="" disabled="disabled">Select Block</option><option value="Service related">Service related</option><option value="Infrastructure related">Infrastructure related</option><option value="Policy related">Policy related</option><option value="Land/Plot related">Land/Plot related</option><option value="Subsidy related">Subsidy related</option><option value="Any other (please specify)">Any other (please specify)</option></select></div><div class="form-group" ng-if="vm.grievancedata.categoryOfGrievance==\'Any other (please specify)\'"><label class="control-label" for="field_otherCategory">Other Category Grievance</label><input type="text" class="form-control" name="otherCategory" id="field_otherCategory" ng-model="vm.grievancedata.otherCategory"></div><div class="form-group"><label class="control-label">Brief details of the grievance<span style="color:red">&nbsp *</span></label><textarea class="form-control" rows="3" id="textArea" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.grievancedata.grievance" required></textarea><div ng-show="grievanceForm.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label for="department" class="control-label">Department<span style="color:red">&nbsp *</span></label><select class="form-control" id="department" ng-model="vm.grievancedata.selecteddepartment" ng-options="department.departmentname for department in vm.departments" required><option value="">--Select Department--</option></select></div><div class="row"><div class="form-group"><!--<input type="checkbox" name="gotReliefLevel" id="field_gotReliefLevel"--><!--ng-model="vm.dispute.gotReliefLevel"/>--><div><label class="col-md-4 control-label">Has the grievance ever been referred to the concerned department?</label></div><div class="col-md-4"><label for="Yes">Yes</label><input id="Yes" type="radio" ng-model="vm.grievancedata.grievanceRefferedToDept" name="grievanceRefferedToDept" value="True" required><label for="No">No</label><input id="No" type="radio" ng-model="vm.grievancedata.grievanceRefferedToDept" name="grievanceRefferedToDept" value="False"></div></div></div><br><div class="form-group" ng-if="vm.grievancedata.grievanceRefferedToDept ==\'True\'"><label class="control-label" for="field_dateOfCommunication">Date Of Communication</label><div class="input-group"><input id="field_dateOfCommunication" type="date" class="form-control" max="2999-01-01" name="dateOfCommunication" uib-datepicker-popup="{{dateformat}}" ng-model="vm.grievancedata.dateOfCommunication" is-open="vm.datePickerOpenStatus.dateOfFiling" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfFiling\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><br><div class="form-group"><div><label class="control-label">Attachment 1</label><input type="file" id="attachment1" class="form-control" file-model="vm.attachment1" accept="application/pdf"><p ng-show="vm.attachment1.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.attachment1.maxSizeError}}</div></div><br><div class="form-group"><div><label class="control-label">Attachment 2</label><input type="file" id="attachment2" class="form-control" file-model="vm.attachment2" accept="application/pdf"><p ng-show="vm.attachment2.size > 1048576"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.attachment2.maxSizeError}}</div></div><br></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="grievanceForm.$invalid || grievanceForm.maxSizeError || vm.grievancedata.grievance==null || vm.grievancedata.selecteddistrict==null || vm.grievancedata.selecteddepartment==null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Submit</span></button></div></form>');
$templateCache.put('app/grievancedetail/grievancelist.html','<div ng-cloak><div class="container"><div class="row col-md-12"><button type="submit" ui-sref="grievancedetail" class="btn btn-info col-md-2">Add Grievance</button></div><div class="row" ng-show="(vm.grievances.length!=0)"><table class="table table-striped table-hover"><thead><tr><th>Grievance ID</th><th>Grievance</th><th>District</th><th>Department</th><th>Date</th><th>Status</th><th>Resolve comment</th></tr></thead><tbody><tr ng-repeat="grievance in vm.grievances | orderBy : \'-grievanceDate\'"><td>{{grievance.grievanceId}}</td><td>{{grievance.grievance}}</td><td>{{grievance.district}}</td><td>{{grievance.department}}</td><td>{{grievance.grievanceDate | date:\'medium\'}}</td><td>{{grievance.status}}</td><td>{{grievance.resolveComment === null ? \'NA\' : grievance.resolveComment}}</td><td><button type="button" class="btn btn-sm btn-info" ui-sref="viewMyFilledForm({id:grievance.id})"><span class="glyphicon glyphicon-user"></span> &nbsp; View Form</button> <button type="button" class="btn btn-sm btn-warning" ui-sref="viewlog-userlist({grievanceId:grievance.grievanceId})"><span class="glyphicon glyphicon-th-list"></span> &nbsp; View Log</button> <button type="button" class="btn btn-sm btn-danger" data-toggle="modal" data-target="#myModal" ng-click="vm.commentContent(grievance)"><span class="glyphicon glyphicon-comment"></span> &nbsp; Comment</button></td></tr></tbody></table></div></div></div><!-- Modal --><div id="myModal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Comment</h4></div><div class="modal-body"><div class="form-group"><textarea class="form-control" rows="4" id="textArea" ng-model="vm.commentValue" required></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal"><span class="glyphicon glyphicon-remove-circle"></span> &nbsp; Close</button> <button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.comment()"><span class="glyphicon glyphicon-comment"></span> &nbsp; Comment</button></div></div></div></div>');
$templateCache.put('app/grievancedetail/grievancelistadmin.html','<div ng-cloak><div class="container-fluid"><div class="row"><div class="col-md-9"><h4 ng-show="vm.status=== \'all\'"><b>All Grievances</b></h4><h4 ng-show="vm.status=== \'unassigned\'"><b>Unassigned Grievances</b></h4><h4 ng-show="vm.status=== \'assigned\'"><b>Assigned Grievances</b></h4></div><div class="col-md-2 pull-right"><select style="border: none; box-shadow: none" class="form-control" ng-model="vm.status" ng-change="vm.statusSelected()"><option value="unassigned">Unassigned Grievances</option><option value="assigned">Assigned Grievances</option><option value="all">All Grievances</option></select></div><div class="col-md-1 filter-margin pull-right"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div></div></div><div class="container"><div class="row" ng-show="(vm.grievance.length!=0)"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>Sr No.</th><th>Grievance ID</th><th>Grievance</th><th ng-show="vm.status === \'assigned\'">Assigned To</th><th>Date</th><th>District</th><th>Department</th><th ng-show="vm.status=== \'all\'">Assign Status</th><th ng-show="vm.status=== \'all\'">Status</th></tr></thead><tbody><tr ng-repeat="grievance in vm.grievance | orderBy : \'-grievanceDate\'"><td>{{$index+1}}</td><td><a ng-click="vm.showPersonalDetail(grievance.id)">{{grievance.grievanceId}}</a></td><td>{{grievance.grievance}}</td><td ng-show="vm.status === \'assigned\'">{{grievance.assignTo}}</td><td>{{grievance.grievanceDate | date:\'medium\'}}</td><td>{{grievance.district}}</td><td>{{grievance.department}}</td><th ng-show="vm.status=== \'all\'">{{grievance.assignStatus}}</th><td ng-show="vm.status=== \'all\'">{{grievance.status}}</td><td><button type="button" class="btn btn-sm btn-info" ui-sref="viewFilledForm-admin({id:grievance.id})"><span class="glyphicon glyphicon-user"></span> &nbsp; View Form</button> <button ng-show="vm.status===\'unassigned\'" type="button" class="btn btn-sm btn-success" ui-sref="grievanceassign({id:grievance.id})"><span class="glyphicon glyphicon-user"></span> &nbsp Assign</button> <button type="button" class="btn btn-sm btn-warning" ui-sref="viewlog-adminlist({grievanceId:grievance.grievanceId})"><span class="glyphicon glyphicon-th-list"></span> &nbsp View Log</button> <button type="button" class="btn btn-sm btn-danger" data-toggle="modal" data-target="#myModal" ng-click="vm.commentContent(grievance)"><span class="glyphicon glyphicon-comment"></span> &nbsp; Comment</button></td></tr></tbody></table></div></div></div></div><!-- Modal --><div id="myModal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Comment</h4></div><div class="modal-body"><div class="form-group"><textarea class="form-control" rows="4" id="textArea" ng-model="vm.commentValue" required></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal"><span class="glyphicon glyphicon-remove-circle"></span> &nbsp; Close</button> <button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.comment()"><span class="glyphicon glyphicon-comment"></span> &nbsp; Comment</button></div></div></div></div>');
$templateCache.put('app/grievancedetail/grievancelistofficer.html','<div ng-cloak><!--<button type="submit" ui-sref="officerlistpending({status:\'Pending\'})" class="btn btn-info col-md-2">Pending Grievances</button>--><div class="container-fluid"><div class="row"><div class="col-md-9"><h4 ng-show="vm.status=== \'all\'"><b>All Grievances</b></h4><h4 ng-show="vm.status=== \'pending\'"><b>Pending Grievances</b></h4><h4 ng-show="vm.status=== \'resolved\'"><b>Resolved Grievances</b></h4><h4 ng-show="vm.status=== \'myassigned\'"><b>Re-Assigned By Me</b></h4></div><div class="col-md-2 pull-right"><select style="border: none; box-shadow: none" class="form-control" ng-model="vm.status" ng-change="vm.statusSelected()"><option value="pending">Pending Grievances</option><option value="resolved">Resolved Grievances</option><option value="all">All Grievances</option><option value="myassigned">Re-Assigned By Me</option></select></div><div class="col-md-1 filter-margin pull-right"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div></div></div><div class="container"><div class="row" ng-show="(vm.grievance.length!=0)"><div class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>Sr No.</th><th>Grievance ID</th><th>Grievance</th><th ng-show="vm.status === \'resolved\'">Assigned To</th><th>Date</th><th>District</th><th>Department</th><th ng-show="vm.status=== \'all\'">Assign Status</th><th ng-show="vm.status=== \'all\'">Status</th></tr></thead><tbody><tr ng-repeat="grievance in vm.grievance | orderBy : \'-grievanceDate\'"><td>{{$index+1}}</td><td><a ng-click="vm.showPersonalDetail(grievance.id)">{{grievance.grievanceId}}</a></td><td>{{grievance.grievance}}</td><td ng-show="vm.status === \'resolved\'">{{grievance.assignTo}}</td><td>{{grievance.grievanceDate | date:\'medium\'}}</td><td>{{grievance.district}}</td><td>{{grievance.department}}</td><th ng-show="vm.status=== \'all\'">{{grievance.assignStatus}}</th><td ng-show="vm.status=== \'all\'">{{grievance.status}}</td><td><div><button type="button" class="btn btn-sm btn-info" ui-sref="viewFilledForm-Officer({id:grievance.id})"><span class="glyphicon glyphicon-user"></span> &nbsp; View Form</button> <button ng-show="vm.status===\'pending\'" type="button" class="btn btn-sm btn-info" ui-sref="grievanceassignofficer({id:grievance.id})"><span class="glyphicon glyphicon-user"></span> &nbsp; Re-Assign</button> <button ng-show="vm.status===\'pending\'" type="button" class="btn btn-sm btn-success" ui-sref="resolvebox({id:grievance.id})"><span class="glyphicon glyphicon-ok"></span> &nbsp; Resolve</button> <button type="button" class="btn btn-sm btn-warning" ui-sref="viewlog-officer({grievanceId:grievance.grievanceId})"><span class="glyphicon glyphicon-th-list"></span> &nbsp; View Log</button> <button type="button" class="btn btn-sm btn-danger" data-toggle="modal" data-target="#myModal" ng-click="vm.commentContent(grievance)"><span class="glyphicon glyphicon-comment"></span> &nbsp; Comment</button></div></td></tr></tbody></table></div></div></div></div><!-- Modal --><div id="myModal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Comment</h4></div><div class="modal-body"><div class="form-group"><textarea class="form-control" rows="4" id="textArea" ng-model="vm.commentValue" required></textarea></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal"><span class="glyphicon glyphicon-remove-circle"></span> &nbsp; Close</button> <button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.comment()"><span class="glyphicon glyphicon-comment"></span> &nbsp; Comment</button></div></div></div></div>');
$templateCache.put('app/grievancedetail/resolvebox.html','<form name="grievanceform"><div class="modal-header"><button type="button" class="close" data-dismiss="" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Resolve Grievance</h4></div><div class="modal-body"><div class="form-group"><dl class="dl-horizontal"><dt><span class="pull-left">Grievance:</span></dt><dd><span>{{vm.grievance.grievance}}</span></dd></dl></div><div class="form-group"><label class="control-label" data-translate="">Resolve Comment</label><textarea class="form-control" rows="3" id="textArea" name="comment" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.grievance.resolveComment" required></textarea><div ng-show="grievanceform.comment.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-click="vm.saveResolveData()" ng-disabled="vm.grievance.resolveComment==null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Submit</span></button></div></form>');
$templateCache.put('app/grievancedetail/viewlog.html','<div class="container-fluid"><div class="row"><div class="col-md-12"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><div id="pdf_data"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel" data-translate="">Grievance Log : {{vm.grievanceId}}</h4></div><div class="modal-body"><div ng-show="(vm.grievancelog.length!=0)" class="table-responsive"><table class="table table-striped table-hover"><thead><tr><th>Action</th><th>Action Date</th><th>Action By</th><th>Action Comment</th><th></th></tr></thead><tbody><tr ng-repeat="grievance in vm.grievancelog | orderBy : \'-actionDate\'"><td>{{grievance.action}}</td><td>{{grievance.actionDate | date:\'dd-MM-yyyy\'}}</td><td>{{grievance.actionBy}}</td><td>{{grievance.actionComment}}</td><td><button ng-show="(grievance.attachment)" type="button" class="btn btn-primary" ng-click="vm.downloadFile(grievance.attachment)">Download</button></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="" ng-click="vm.clear()"><span class="glyphicon glyphicon-remove"></span>&nbsp;<span data-translate="">Close</span></button></div></div></div></div>');
$templateCache.put('app/hepc-startupharyana/hepc-startupharyana.html','<!--<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css">--><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_10 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Haryana State Startup Policy 2022</h1></div></div></div></section><br><div ng-cloak><div class="container"><div class="row"><div class="col-md-3" ng-if="vm.isAuthenticated()"><button class="btn btn-success" type="submit"><a href="https://startupharyana.gov.in/invest-haryana/my-schemes?email={{vm.userdetails.useremail}}&name={{vm.userdetails.username}}" target="_blank" style="color: white">My Incentive Status</a></button></div><div class="col-md-3" ng-if="vm.isAuthenticated()"><button class="btn btn-success" type="submit"><a href="https://startupharyana.gov.in/invest-haryana/objected-schemes?email={{vm.userdetails.useremail}}&name={{vm.userdetails.username}}" target="_blank" style="color: white">Reply to onhold applications</a></button></div><br><table class="table table-striped table-hover" ng-switch="vm.isAuthenticated()"><thead><tr class="headerGrid"><th>S.No</th><th>Scheme Name</th><!--                    <th>EV Policy Document (PDF)</th>--><th>Apply For Scheme</th></tr></thead><tbody><!--                <tr>--><!--                    <td>1</td>--><!--                    <td >REIMBURSEMENT FOR CLOUD STORAGE SCHEME</td>--><!--                    <td>--><!--                        <div class="col-md-6">--><!--                            <form target="my_iframe"--><!--                                  action="https://startupharyana.gov.in/invest-haryana/apply-scheme/cloud-storage-reimbursement"--><!--                                  method="GET">--><!--                                <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                                <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                                <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true">--><!--                            </form>--><!--                            <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()">--><!--                        </div>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>2</td>--><!--                    <td >NET SGST REIMBURSEMENT SCHEME</td>--><!--                    <td>--><!--                        <div class="col-md-6">--><!--                            <form target="my_iframe"--><!--                                  action="https://startupharyana.gov.in/invest-haryana/apply-scheme/sgst-reimbursement"--><!--                                  method="GET">--><!--                                <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                                <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                                <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()">--><!--                            </form>--><!--                        </div>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>3</td>--><!--                    <td >PATENT COST REIMBURSEMENT SCHEME</td>--><!--                    <td>--><!--                        <div class="col-md-6">--><!--                            <form target="my_iframe"--><!--                                  action="https://startupharyana.gov.in/invest-haryana/apply-scheme/patent-cost"--><!--                                  method="GET">--><!--                                <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                                <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                                <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()">--><!--                            </form>--><!--                        </div>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>4</td>--><!--                    <td >LEASE RENTAL SUBSIDY SCHEME</td>--><!--                    <td>--><!--                        <div class="col-md-6">--><!--                            <form target="my_iframe"--><!--                                  action="https://startupharyana.gov.in/invest-haryana/apply-scheme/reimbursement-lease-rental"--><!--                                  method="GET">--><!--                                <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                                <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                                <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()">--><!--                            </form>--><!--                        </div>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>5</td>--><!--                    <td >ASSISTANCE IN ACCELERATION PROGRAMS SCHEME \u2013 IN-PRINCIPAL APPROVAL</td>--><!--                    <td>--><!--                        <div class="col-md-6">--><!--                            <form target="my_iframe"--><!--                                  action="https://startupharyana.gov.in/invest-haryana/apply-scheme/acceleration-program"--><!--                                  method="GET">--><!--                                <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                                <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                                <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()">--><!--                            </form>--><!--                        </div>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>6</td>--><!--                    <td >ASSISTANCE IN ACCELERATION PROGRAMS SCHEME \u2013 CLAIMING ASSISTANCE</td>--><!--                    <td>--><!--                        <div class="col-md-6">--><!--                            <form target="my_iframe"--><!--                                  action="https://startupharyana.gov.in/invest-haryana/apply-scheme/acceleration-program-incentive"--><!--                                  method="GET">--><!--                                <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                                <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                                <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()">--><!--                            </form>--><!--                        </div>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>7</td>--><!--                    <td >SEED FUND FOR STARTUPS - 1ST TRANCHE</td>--><!--                    <td>--><!--                        <div class="col-md-6">--><!--                            <form target="my_iframe"--><!--                                  action="https://startupharyana.gov.in/invest-haryana/apply-scheme/seed-fund-startup"--><!--                                  method="GET">--><!--                                <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                                <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                                <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()">--><!--                            </form>--><!--                        </div>--><!--                    </td>--><!--                </tr>--><!--                <tr>--><!--                    <td>8</td>--><!--                    <td >SEED FUND FOR STARTUPS \u2013 2ND TRANCHE</td>--><!--                    <td>--><!--                        <div class="col-md-6">--><!--                            <form target="my_iframe"--><!--                                  action="https://startupharyana.gov.in/invest-haryana/apply-scheme"--><!--                                  method="GET">--><!--                                <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                                <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                                <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()">--><!--                            </form>--><!--                        </div>--><!--                    </td>--><!--                </tr>--><tr><td>1</td><td>{{vm.schemeName}}</td><td><div class="col-md-6"><form target="my_iframe" id="myForm" action="https://startupharyana.gov.in/invest-haryana/sso-login" method="GET"><!--                                <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                                <input type="hidden" name="name" value="{{vm.userdetails.username}}">--> <input style="display: none" type="submit" href="#modal-full" uk-toggle value=""></form><span class="btn btn-primary" ng-click="vm.reload()">Apply Now</span></div><!--                        <button class="btn btn-success" href="#modal-full" uk-toggle>Apply Now</button>--></td></tr></tbody></table></div></div></div><div id="modal-full" class="uk-modal-full" uk-modal esc-close="false" bg-close="false"><div class="uk-modal-dialog"><button class="uk-modal-close-full uk-close-large" type="button" uk-close></button><div class="uk-grid-collapse uk-flex-middle" uk-grid><section><iframe name="my_iframe" id="my_iframe" style="width: 500vw; height: 100vh" frameborder="0" marginheight="0" marginwidth="0"></iframe></section></div></div></div>');
$templateCache.put('app/hepcTickets/hepcTickets.html','<style type="text/css">@media screen and (min-width: 810px) {\n        .affix-top {\n            position: relative;\n        }\n\n        .affix {\n            position: fixed;\n            top: 10px;\n        }\n    }</style><script>$(document).ready(function(){\n        $(".myAffix").affix({\n            offset: {\n                top: 315,\n                bottom: function() {\n                    return (this.bottom = $(\'.footer\').outerHeight(true))\n                }\n            }\n        });\n    });</script><div class="container-fluid" style="background-color: #e6e6e6"><div class="row" ng-if="vm.authenticated"><div class="col-md-2"><div ui-view="tktSidebar"></div></div><div class="col-md-10"><div class="tkt-height" ui-view="content_section"></div></div></div><div class="row" ng-if="!vm.authenticated"><div class="col-md-12"><div class="tkt-height" ui-view="content_section"></div></div></div></div>');
$templateCache.put('app/home/Enabling_infrastructure.html','<!DOCTYPE html><html><!--<head>--><!--<title> Demo for all bootstrap </title>--><!--<link rel="stylesheet" type="text/css" href="css/bootstrap.min.css">--><!--<link rel="stylesheet" type="text/css" href="css/font-awesome.css">--><!--<link rel="stylesheet" type="text/css" href="css/style.css">--><!--</head>--><body><!--<div class="header-1">--><!--<div class="container-fluid bgc-r">--><!--<div class="row">--><!--<div class="col-md-3 col-xs-12">--><!--<p class="font14">Toll  Free  Helpline <br>--><!--1800-180-2132</p>--><!--</div>--><!--<div class="col-md-6"></div>--><!--<div class="col-md-3"></div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="header-2">--><!--<div class="container-fluid">--><!--<div class="second-box">--><!--<div class="row">--><!--<div class="col-md-3">--><!--<div class="logo-site">--><!--<img src="img/logo.PNG" alt="logo-hepc" title="logo" class="img-responsive center-block">--><!--</div>--><!--</div>--><!--<div class="col-md-6">--><!--<div class="text-main text-center">--><!--<p class="font15">Department of Industries<br> Haryana Enterprise Promotion Center</p>--><!--</div>--><!--</div>--><!--<div class="col-md-1"></div>--><!--<div class="col-md-2">--><!--<div class="second-logo">--><!--<img src="img/logo-gov.PNG" class="img-responsive center-block" alt="logo-gov" title="logogov">--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="navbar-box">--><!--<div class="container-fluid">--><!--<div class="row">--><!--<header id="header">--><!--<nav class="navbar">--><!--<div class="container-fluid bgc-r">--><!--<div class="navbar-header">--><!--<button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">--><!--<span class="icon-bar"></span>--><!--<span class="icon-bar"></span>--><!--<span class="icon-bar"></span>--><!--</button>--><!--</div>--><!--<div class="collapse navbar-collapse" id="myNavbar">--><!--<ul class="nav navbar-nav">--><!--<li><a class="active" href="#"> About Us</a></li>--><!--<li><a href="#"> Haryana</a></li>--><!--<li><a href="#">Investor Service</a></li>--><!--<li><a href="#">Information</a></li>--><!--<li><a href="#">News &amp; Gallery</a></li>--><!--<li><a href="#">Login</a></li>--><!--<li style="border-right: 1px solid transparent;"><a href="#">Contact</a></li>--><!--</ul>--><!--</div>--><!--</div>--><!--</nav>--><!--</header>--><!--</div>--><!--</div>--><!--</div>--><br><div class="new-section"><div class="container-fluid"><div class="row"><div class="col-md-3"><strong><span style="color:#990000; font-size: 20px">Haryana</span></strong><br><div class="row"><div class="col-md-2" style="padding-right: 0px"><img src="../../content/used-images-new/Capture2.jpg" alt="" title="" class="img-responsive"></div><div class="col-md-10" style="margin-left:-19px"><br><a ui-sref="haryana"><p class="font19">Fact File</p></a><br><a ui-sref="states"><p class="font19">States</p></a><br><a ui-sref="Enabling_infrastructure"><p class="font19">Enabling Infrastructure</p></a><br><a ui-sref="urban_infrastructure"><p class="font19">Urban Infrastructure</p></a><br><a ui-sref="industrial_powerhouse"><p class="font19">Industrial Powerhouse</p></a><br></div></div></div><div class="col-md-8" style="padding-right: 0px"><img src="../../content/used-images-new/enabling_infrastructure.jpg" alt="" title="" class="img-responsive"></div><!--<div class="col-md-9" style="font-size:22px;">--><!--<div class="col-sm-6" style="background-color: #c6007c; color:#fff; padding: 30px;">--><!--<div class="col-sm-4">--><!--<i class="fa fa-plane fa-5x" style="font-size: 7em;"></i>--><!--<p class="text-center"style="margin: 0px 0px 0px -30px; font-size: 19px;"><strong>AIR <br>CONNECTIVITY</strong></p>--><!--</div>--><!--&lt;!&ndash;<div class="col-sm-8" style="font-size: 19px; padding: 10px;">&ndash;&gt;--><!--&lt;!&ndash;<ul>&ndash;&gt;--><!--&lt;!&ndash;<li style="padding: 3px;">2 International Airport</li>&ndash;&gt;--><!--&lt;!&ndash;<li style="padding: 3px;">5 Civil Airports</li>&ndash;&gt;--><!--&lt;!&ndash;<li style="padding: 3px;">20 minutes from IGI Airport </li>&ndash;&gt;--><!--&lt;!&ndash;<li style="padding: 3px;">2200 acres MRO Hub tosetupin Hisar</li>&ndash;&gt;--><!--&lt;!&ndash;</ul>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--<div class="col-sm-6" style="background-color: #473599;padding: 30px;">--><!--<div class="col-sm-4">--><!--<i class="fa fa-plane fa-5x" style="font-size: 7em;"></i>--><!--<p class="text-center"style="margin: 0px 0px 0px -30px; font-size: 19px;"><strong>AIR <br>CONNECTIVITY</strong></p>--><!--</div>--><!--<div class="col-sm-8" style="font-size: 19px; padding: 10px;">--><!--<ul>--><!--<li style="padding: 3px;">2 International Airport</li>--><!--<li style="padding: 3px;">5 Civil Airports</li>--><!--<li style="padding: 3px;">20 minutes from IGI Airport </li>--><!--<li style="padding: 3px;">2200 acres MRO Hub tosetupin Hisar</li>--><!--</ul>--><!--</div>--><!--</div>--><!--</div>--></div></div></div><br><br><br><br><!--<div class="container bgc-g">--><!--<div class="footer">--><!--<div class="row">--><!--<div class="col-md-4">--><!--<p>Disclamer</p>--><!--<p>Privacy Policy</p>--><!--<p>Hyperlinking Policy</p>--><!--<p>Copyright Statement</p>--><!--<p>Terms of Use</p>--><!--<p>Sitemap</p>--><!--</div>--><!--<div class="col-md-4">--><!--<p>Citizen Corner</p>--><!--<p>Feedback</p>--><!--<p>Content Review Policy</p>--><!--<p>Content Approval</p>--><!--<p>Content archival</p>--><!--<p>FAQ\'s</p>--><!--</div>--><!--<div class="col-md-4">--><!--<img src="img/logo_1.png" alt="" title="" class="img-responsive"><br>--><!--<p><strong>Visiter Count:</strong> 00-005-27-7</p>--><!--<p><strong>Last Update on: </strong> 6 July 2017</p>--><!--<p><strong>Site Best View In:</strong> Google Chrome, IE, Firefox </p>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<br>--><!--<div class="header-1">--><!--<div class="container-fluid bgc-r">--><!--<p>&nbsp;</p><p>&nbsp;</p>--><!--</div>--><!--</div>--><!--<script type="text/javascript" src="js/jquery.js"></script>--><!--<script type="text/javascript" src="js/bootstrap.min.js"></script>--><!--<script type="text/javascript" src="js/script.js"></script>--></body></html>');
$templateCache.put('app/home/Mission.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Mission & Vision</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>About Us</span></li><li class="active"><span>Mission & Vision</span></li></ol></div></section><div class="with_background gradient_bg_color1 col-md-12"><div class="col-md-2"></div><div class="col-md-10"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li><a ui-sref="aboutHEPC">About HEPC</a></li><li><a ui-sref="org_structure">Organization Structure</a></li><!--<li> <a ui-sref="CM_Message">CM Message</a> </li>--><li class="active"><a ui-sref="mission">Mission & Vision</a></li></ul></nav></div></div><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container"><p style="font-size:16px">To position Haryana as a pre-eminent investment destination and facilitate balanced regional and sustainable development supported by a dynamic governance system, wide scale adoption of innovation & technology has taken place alongwith skill development in order to nurture entrepreneurship and generate employment opportunities in the state.</p><ul style="font-size:16px"><li>Position Haryana as a "Preferred Destination" in Ease of Doing business and Cost of Doing Business</li><li>Facilitate State GDP growth rate in excess of 8%</li><li>Generate more than 0.4 million jobs</li><!--                        <li>Attract investments over INR 1 lakh crore </li>--><li>Increase contribution of secondary sector in the State GDP from 27% to 32% in tandem with the Government of India\'s National Manufacturing Policy and "Make in India" initiative</li><li>Promote balanced regional development through geographical dispersal of Industry</li><li>Increase the competitiveness of MSMEs through cluster development, adoption of "Zero Defect Zero Effect" manufacturing practices</li></ul></div></div></div></div></section>');
$templateCache.put('app/home/about.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">About HEPC</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>About Us</span></li><li class="active"><span>About HEPC</span></li></ol></div></section><div class="with_background gradient_bg_color1 col-md-12"><div class="col-md-2"></div><div class="col-md-10"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li class="active"><a ui-sref="aboutHEPC">About HEPC</a></li><li><a ui-sref="org_structure">Organization Structure</a></li><!--<li> <a ui-sref="CM_Message">CM Message</a> </li>--><li><a ui-sref="mission">Mission & Vision</a></li></ul></nav></div></div><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container"><div class="row"><div class="col-sm-12"><p>We at HEPC are inspired by a goal to make Haryana the most investor friendly destination in India. With rapidly growing investment opportunities and technological advancements, the Government of Haryana conceptualized the idea of implementing an online platform i.e. a Single Roof Clearance System which ensures a time bound, hassle free and transparent system of clearances to give our investors a one stop solution for any service to enhance the ease of doing business in the State.</p><p>Inaugurated by the Hon\u2019ble Chief Minister of Haryana, Shri Manohar Lal in February 2017, HEPC are committed to providing approvals, clearances & NOCs of all industrial services within 30 days along with facilities to track the stage of the application and support on understanding incentives and policies pertaining to the investors\u2019 nature of business.</p><p>The whole process of getting clearances is online on the Invest Haryana portal which is the official portal for all services related to HEPC. It facilitates investors in applying and tracking services of different departments under one roof and also provides knowledge about the incentives and policies related to their projects and sectors.</p><p>As on date, more than 100+ Industrial clearances related to 20+ departments are being offered through HEPC. Assisting with this are more than 20 nodal officers from all departments. In addition to that, there are a group of relationship managers to help the investors out in case of any queries.</p><p>We welcome you to the state of Haryana. Please feel free to reach out to us in case of any queries.</p><p><img src="../../content/used-images-new/abouthepc.jpg" usemap="#Map"><map name="Map"><area shape="rect" coords="546,66,676,127" href="http://www.investharyana.in"></map></p></div></div></div></div></div></div></section>');
$templateCache.put('app/home/advertisment.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">HSIIDC Advertisement</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li></ol></div></section><div><div class="carousel-inner" role="listbox"><div class="item active bgImgCenter"><div class="col-md-12 panel-body"><div class="row"><div class="col-md-12 col-sm-12 col-xs-12"><div id="myCarousel" class="carousel slide" data-ride="carousel"><!-- Indicators --><ol class="carousel-indicators"><li data-target="#myCarousel" data-slide-to="0" class="active"></li><li data-target="#myCarousel" data-slide-to="1"></li><li data-target="#myCarousel" data-slide-to="2"></li><li data-target="#myCarousel" data-slide-to="3"></li><li data-target="#myCarousel" data-slide-to="4"></li><li data-target="#myCarousel" data-slide-to="5"></li><li data-target="#myCarousel" data-slide-to="6"></li><li data-target="#myCarousel" data-slide-to="7"></li><li data-target="#myCarousel" data-slide-to="8"></li><li data-target="#myCarousel" data-slide-to="9"></li><li data-target="#myCarousel" data-slide-to="10"></li><li data-target="#myCarousel" data-slide-to="11"></li><li data-target="#myCarousel" data-slide-to="12"></li><li data-target="#myCarousel" data-slide-to="13"></li><li data-target="#myCarousel" data-slide-to="14"></li><li data-target="#myCarousel" data-slide-to="15"></li><li data-target="#myCarousel" data-slide-to="16"></li><li data-target="#myCarousel" data-slide-to="17"></li><li data-target="#myCarousel" data-slide-to="18"></li><li data-target="#myCarousel" data-slide-to="19"></li><li data-target="#myCarousel" data-slide-to="20"></li><li data-target="#myCarousel" data-slide-to="21"></li><li data-target="#myCarousel" data-slide-to="22"></li><li data-target="#myCarousel" data-slide-to="23"></li><li data-target="#myCarousel" data-slide-to="24"></li><li data-target="#myCarousel" data-slide-to="25"></li><li data-target="#myCarousel" data-slide-to="26"></li><li data-target="#myCarousel" data-slide-to="27"></li><li data-target="#myCarousel" data-slide-to="28"></li></ol><!-- Wrapper for slides --><div class="carousel-inner"><div class="item active"><h5><center><b>Group Housing</b></center></h5><br><img src="content/used-images-new/Group Housing 25.7.24.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>Allotment of Flats(As is where is basis) in Express Greens M1 (HARERA Regn. No.83 of 2022 and Project ID. RERA-GRG 1122 - 2022), Manesar & Express Greens M1A (HARERA Regn. No.84 of 2022 and Project ID. RERA-GRG 1125 - 2022), Manesar Distt. Gurugram</b></center></h5><br><img src="content/used-images-new/Allotment Ready to Move Flats Through E-Auction in Express Greens Sector-M1 & M1A Manesar Distt Gurugram_page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>Commercial Booth, SCO, Shop, Booth Commercial Plots</b></center></h5><br><img src="content/used-images-new/Commercial Booth, SCO, Shop, Booth Commercial Plots 25.7.24.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>Industrial Estat IE Kundli</b></center></h5><br><img src="content/used-images-new/Industrial Estat IE Kundli 25.7.24.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>e-Auction of Industrial Estate IMT Sohna EMC</b></center></h5><br><img src="content/used-images-new/e-Auction of Industrial Estat IMT Sohna EMC 24.7.2024 .jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>e-auction of various sites in its industrial estates</b></center></h5><br><img src="content/used-images-new/e-auction of Commercial Sites 23.2.24.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>e Auction of Industrial Plots in IMT Bawla</b></center></h5><br><img src="content/used-images-new/e-auction of Industrial Plots in IMT BAWAL 22.2.2024.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>Industrial Plots Barwala.</b></center></h5><br><img src="content/used-images-new/Industrial Plots Barwala 29.1.24.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC announces e-Auction of Industrial Plots in Industrial Estate at IE Faridabad</b></center></h5><br><img src="content/used-images-new/e-Auction of IE Faridabad 02.1.24.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>Group Housing Sites at Manesar 912 acre</b></center></h5><br><img src="content/used-images-new/Ad- 3797 - Group Housing Sites at Manesar 912 acre_page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC announces e-Auction of Indutrial Plots in Indutrial Estate at IMT Manesar, Manesar, IE Rai, and IE Kundli</b></center></h5><br><img src="content/used-images-new/IMT Manesar, Transport Hub-IMT Manesar, IE Rai,.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC announces e-Auction of Indutrial Plots in Indutrial Estate at Pace City Gurugram</b></center></h5><br><img src="content/used-images-new/Pace City Gurugram Industrial Plots.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>e-Auction of Industrial Plots at MFP IMT Rohtak and MFP IE Barhi</b></center></h5><br><img src="content/used-images-new/HSIIDC e-Auction of Industrial Plots advt 12x17 English.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>e-Auction of Industrial Plots at IE Barhi</b></center></h5><br><img src="content/used-images-new/HSIIDC E -Auction Barhi advt 12x14 English.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>e-auction of Commercial plots,Hotel,Tower in its various Estates</b></center></h5><br><img src="content/used-images-new/Ad- 3741-e-auction of Commercial plots,Hotel,Tower in its various Estates_page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>e-Acution IE Bahadurgarh</b></center></h5><br><img src="content/used-images-new/Ad-3734-e-Acution IE Bahadurgarh_page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>Land Pooling advertisement IMT Kharkhoda, IMT Sohna, IMT, IMT Bawal</b></center></h5><br><img src="content/used-images-new/Ad-3732-Land Pooling Kharkhoda, IMT Sohna, and IMT Bawal_page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC announces e-Auction of Industrial Plots at IMT Rohtak</b></center></h5><br><img src="content/used-images-new/Ad-3717-e-Auction of Industrial Plots at IMT Rohtak (1)_page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC announces e-Auction of Industrial Plots at IMT Sohna</b></center></h5><br><img src="content/used-images-new/Ad-3718-e-Auction of Industrial Plots at IMT Sohna (2)_page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC announces e-auction of commercial sites</b></center></h5><br><img src="content/used-images-new/HSIIDC_Commercial_Site_ad-02_11_2023_page_0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC announces e-Auction of Industrial Plots at IMT Bawal</b></center></h5><br><img src="content/used-images-new/Ad-3705-HSIIDC announces e-Auction of Industrial Plots at IMT Bawal _page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>Group Housing and Residential Sites at Panipat,Bawal,Faridabad,Kharkhauda,Sohna,Rohtak,Saha</b></center></h5><br><img src="content/used-images-new/Ad-3703-Group Housing and Residential Sites at Panipat,Bawal,Faridabad,Kharkhauda,Sohna,Rohtak,Saha_page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC announces e-Auction of Industrial Plots at IE Panchkula Phase-I and Phase II</b></center></h5><br><img src="content/used-images-new/Ad- 3704-HSIIDC announces e-Auction of Industrial Plots at IE Panchkula Phase-I and Phase II_page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>Commercial Complex at Panipat</b></center></h5><br><img src="content/used-images-new/Ad-3698-Commercial Complex at Panipat_page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>e-Auction For Mix-use Land Parcels In Global City, Gurugram.</b></center></h5><br><img src="content/used-images-new/Ad 3667-e-Auction Size 33x25cm_page-gurugram.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>Announces e-Auction of Industrial Plots at IE Karnal</b></center></h5><br><img src="content/used-images-new/Ad-3674-e-Acution IE Karnal_page-0001.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC Global City e-Auction</b></center></h5><br><img src="content/used-images-new/Ad-3661-e-Auction.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC Announces e-Auction of Industrial Plots Barwala</b></center></h5><br><img src="content/used-images-new/Ad- 3627-Industrial Plots Barwala.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC Announces e-Auction of Industrial Plots in IE Dharuhera</b></center></h5><br><img src="content/used-images-new/Ad-3650-e-Auction of Industrial Plots in IE Dharuhera 12.9.jpg" class="img-responsive" style="width:50%;height:50%"></div><div class="item"><h5><center><b>HSIIDC Announces e-Auction of Commercial & Residential Plots IE Karnal</b></center></h5><br><img src="content/used-images-new/Ad 3652-Commercial & Residential  Plots IE Karnal Sector 37.jpg" class="img-responsive" style="width:50%;height:50%"></div><!--                                 Left and right controls --></div><a class="left carousel-control" href="#myCarousel" data-slide="prev"><span class="glyphicon glyphicon-chevron-left"></span> <span class="sr-only">Previous</span> </a><a class="right carousel-control" href="#myCarousel" data-slide="next"><span class="glyphicon glyphicon-chevron-right"></span> <span class="sr-only">Next</span></a></div></div></div></div></div></div></div>');
$templateCache.put('app/home/agriculture.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Agro & Food Processing</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Focus Sectors</span></li><li class="active"><span>Agro & Food Processing</span></li></ol></div></section><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><section class="ls"><div class="row"><div class="col-md-12"><h3 class="text-center gradient_bg_color3" style="padding: 10px;font-size: 20px">Key Sector Highlights</h3><div class="row"><div class="col-md-8"><ul><li>Though Haryana is one of the smallest States in India with 4.4 million hectares of land, forming 1.34 percent of the total geographical area of the country , agriculture sector contributes about 15% share to the State GDP</li><li>Haryana is the 2nd largest contributor of food grains to India\u2019s central pool</li><li>The per capita milk availability in Haryana is the second highest in the country</li><li>The state accounts for more than 60 per cent of the export of Basmati rice in the country</li><li>More than 3000 operative food processing units are present in Haryana.</li><li>Haryana is the pioneer in adopting Sprinkler Irrigation Technology in the country.</li></ul></div><div class="col-md-4"><img src="../../content/used-images-new/agro2.png" style="width: 100%"></div></div></div><div class="col-md-12"><h3 class="text-center gradient_bg_color3" style="padding: 10px;font-size: 20px">Key Initiatives</h3><ul><li>54 Mandis of state covered under E-National Agriculture Market (E-NAM) initiative.</li><li>A dedicated Haryana Agri-Business and Food-Processing Policy 2018 has been formulated.</li><li>All Food Parks equipped with World class facilities like Silos & Testing Lab facility, Cold Stores, Deep Freezer, Steam Boiler, Primary Processing Centers, Warehouses for Raw Material & Multi-Purpose Cold Storage facilities.</li></ul></div><div class="col-md-12"><h3 class="text-center gradient_bg_color3" style="padding: 10px;font-size: 20px">Key Sector Incentives</h3><table class="table table_template table-striped"><thead><tr><th class="text-center">Incentive</th><th class="text-center">Details</th></tr></thead><tbody><tr><td>Employment Generation Subsidy</td><td>50% of the total cost of the training of manpower on obtaining industry recognized skill certifications from recognized institutions</td></tr><tr><td>VAT/SGST Subsidy</td><td>75% of net SGST paid for first 7 years, 35% of net SGST paid for next 3 years in \u2018C\u2019 & \u2018D\u2019 Category blocks</td></tr><tr><td>Interest Subsidy</td><td>6% on term loan for 5 years</td></tr><tr><td>Stamp Duty Refund</td><td>100% refund of stamp duty within 5 years of filing of IEM in \u2018C\u2019 & \u2018D\u2019 category blocks</td></tr><tr><td>EDC Charges</td><td>50% exemption of External Development Charges</td></tr><tr><td>Electricity Duty Exemption</td><td>100% Exemption from payment of Electricity duty for 10 years</td></tr><tr><td>Power Tariff Subsidy (Only for Micro & Small)</td><td>Rs. 2 per unit for 3 years in \u2018C\u2019 & \u2018D\u2019 category blocks</td></tr><tr><td>Power Tariff Subsidy (Only for Medium & Large Enterprise)</td><td>Exemption from open excess charges of 93 paisa per unit</td></tr></tbody></table></div><div class="col-md-12"><h3 class="text-center gradient_bg_color3" style="padding: 10px;font-size: 20px">Investment Opportunities</h3><ul><li>Haryana State Industrial and Infrastructure Development Corporation Limited (HSIIDC) has developed Food Parks at Rai in District Sonepat and at Saha in District Ambala</li><li>A Mega Food Park Project is also being developed at Industrial Estate Barhi in District Sonipat</li><li>A Mega Food Park is proposed at IMT Rohtak</li></ul></div></div></section></div></section>');
$templateCache.put('app/home/booming_economy.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Booming Economy</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Why Haryana</span></li><li class="active"><span>Booming Economy</span></li></ol></div></section><div class="with_background gradient_bg_color1 col-md-12"><div class="col-md-12 text-center"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li><a ui-sref="conducive_ecosystem">Conducive Ecosystem</a></li><li class="active"><a ui-sref="booming_economy">Booming Economy</a></li><li><a ui-sref="industrial_powerhouse">Industrial Powerhouse</a></li><li><a ui-sref="supportive_government">Supportive Government</a></li><li><a ui-sref="qualityOfLife">Quality Of Life</a></li></ul></nav></div></div><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container"><div class="row"><div class="col-sm-12">Haryana is a thriving economy with the per capita growth being higher than that of the average Indian. It also boasts of a consistently high GDP growth rate which happens to be more than the national average GDP growth.</div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;margin-top: 10px;font-size: 20px">Haryana\u2019s robust economy \u2013 A pillar of strength for India</h5></div><div class="col-md-7"><img src="../../content/used-images-new/hepcBooming1.png"><p style="font-size: small" class="text-center">Source: Department of Economic & Statistical Analysis, Haryana</p></div><div class="col-md-5" style="margin-top: 10%">As per the report published by the Department of Economic and Statistical Analysis of Haryana, the state has had a consistently high GSDP.</div></div></div></div><div class="row padding_20"><div class="col-md-6"><img src="../../content/used-images-new/boomingGraph1.png" style="width: 30vw; min-height: 300px"><p class="text-center">Haryana per capita income is 1.87 times higher than that of India</p></div><div class="col-md-6"><img src="../../content/used-images-new/boomingGraph2.png" style="width: 30vw; min-height: 300px"><p class="text-center">Though Haryana is geographically a small State, the contribution of the State to the National Gross Domestic Product at current prices has been estimated as 3.8% as per Quick Estimates of 2018-19.</p></div><!--                <div class="col-md-4">--><!--                    <img src="../../content/used-images-new/graph3.png" style="width: 30vw; min-height: 300px;"/>--><!--                    <p class="text-center">--><!--                        3.5% contribution to the GDP of India with just 1.3% of the total area of the country--><!--                </div>--></div><div class="row"><div class="col-md-12"><div class="col-md-4"><h6 class="text-center gradient_bg_color1" style="padding: 10px;font-size: 20px">Monthly per capita consumption expenditure</h6><ul><li>Urban Haryana ranked no. 1 among all major Indian states in terms of consumer expenditure .</li><li>Rural Haryana, ranked at No. 3</li></ul></div><div class="col-md-4"><h6 class="text-center gradient_bg_color3 text-white" style="padding: 10px;font-size: 20px">Vehicle registrations</h6><ul><li>Number of vehicle registrations increased by 47.4% between 2011 and 2015</li></ul></div><div class="col-md-4"><h6 class="text-center gradient_bg_color1" style="padding: 10px;font-size: 20px">Young Population</h6><ul><li>Haryana has 63.6% of its population in working age group of 15-59 years</li></ul></div></div><div class="col-md-12"><div class="col-md-4"><h6 class="text-center gradient_bg_color3 text-white" style="padding: 10px;font-size: 20px">Urbanization</h6><ul><li>Haryana\u2019s urbanization percentage is 34.78%, higher that the national average of 31.15%</li></ul></div><div class="col-md-4"><h6 class="text-center gradient_bg_color1 text-white" style="padding: 10px;font-size: 20px">Skilled manpower</h6><ul><li>More than 80,000 people in Haryana have been imparted skill training</li></ul></div><div class="col-md-4"><h6 class="text-center gradient_bg_color3 text-white" style="padding: 10px;font-size: 20px">Footfall in malls</h6><ul><li>Ambience Mall in Gurgaon registers a footfall of approximately 1.7 million people every month</li></ul></div></div></div></div></div></section>');
$templateCache.put('app/home/caffillingguide.html','<!DOCTYPE html><html><body><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">CAF filling guide</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>CAF filling guide</span></li></ol></div></section><br><div class="new-section"><div class="container-fluid text-center"><div class="with_background gradient_bg_color1 col-md-12"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li><a ui-sref="investorfacilitationcell"><p class="font19">Investor facilitation cell</p></a></li><li class="active"><a ui-sref="caffillingguide"><p class="font19">CAF filling guide</p></a></li><li><a ui-sref="serviceapplicationguide"><p class="font19">Application Approval Process</p></a></li></ul></nav></div><div class="row"><div class="col-md-10 col-md-offset-1" style="padding-right: 0px"><img src="../../content/used-images-new/ProcedureI.jpg" alt="" title="" class="img-responsive"></div></div></div></div><br><br><br><br></body></html>');
$templateCache.put('app/home/cmMessage.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">CM Message</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>About Us</span></li><li class="active"><span>CM Message</span></li></ol></div></section><div class="with_background gradient_bg_color1 col-md-12"><div class="col-md-2"></div><div class="col-md-10"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li><a ui-sref="aboutHEPC">About HEPC</a></li><li><a ui-sref="org_structure">Organization Structure</a></li><li class="active"><a ui-sref="CM_Message">CM Message</a></li><li><a ui-sref="mission">Mission & Vision</a></li></ul></nav></div></div><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container"><div class="col-md-3"><!--<img src="../../content/used-images-new/cm-hepc.jpg" alt="" style="margin-left:auto; margin-right:auto; display:block"><br>--></div><div class="col-md-9"><p style="font-size:16px">Haryana is a leading state in the country on both the industrial and agricultural front. It possesses a locational advantage of being the focal point of the entire northern region of the country and thus, plays a significant role in the socio-economic growth of the entire belt.</p><p style="font-size:16px">I am hopeful that a whole generation of PRANETAs would come up through our scheme for Professional and New Entrepreneurs Task Assistance and lead to the long overdue VISTAAR of enterprises across the sacred land of Gita. Come, invest in Haryana. We aim to kick start Haryana\'s economy by achieving 8% GDP growth, generate more than 4 lakhs jobs and attract investments of one lakh crore.</p><p style="font-size:16px">The state has invested in the development of world class infrastructure facilities such as special economic zones (SEZs), Kundli-Manesar-Palwal (KMP) global corridor and Delhi- Mumbai Industrial Corridor (DMIC). In addition, the state will play a crucial role in the development of the proposed Amritsar-Kolkata Industrial Corridor as well.</p><p style="font-size:16px">The Happening Haryana Global Investor Summit 2016 is an initiative towards our resolve.</p><p style="font-size:16px">I, welcome you to the historical land of Haryana.</p><br><p style="font-size:20px"><strong>Shri Manohar Lal</strong></p><p style="font-size:20px"><strong>Chief Minister, Haryana</strong></p></div></div></div></div></div></section>');
$templateCache.put('app/home/conducive_ecosystem.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Conducive Ecosystem</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Why Haryana</span></li><li class="active"><span>Conducive Ecosystem</span></li></ol></div></section><div class="with_background gradient_bg_color1 col-md-12"><div class="col-md-12 text-center"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li class="active"><a ui-sref="conducive_ecosystem">Conducive Ecosystem</a></li><li><a ui-sref="booming_economy">Booming Economy</a></li><li><a ui-sref="industrial_powerhouse">Industrial Powerhouse</a></li><li><a ui-sref="supportive_government">Supportive Government</a></li><li><a ui-sref="qualityOfLife">Quality Of Life</a></li></ul></nav></div></div><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container"><div class="row"><div class="col-sm-12">Haryana provides a conducive environment for businesses to grow and prosper. World class infrastructural facilities like land, roads, internet and power are available for an investor. Haryana also has a large number of technical and non-technical educational institutions to help meet the requirement of manpower for industries.</div></div><div class="row"><div class="col-md-6"><h6 class="text-center gradient_bg_color1" style="padding: 10px;font-size: 20px">Healthcare</h6><ul><li>124 Community Health Centers, 500 Primary Health Centers, 2630 Sub-Centers</li><li>Under \u2018Mukhya Mantri Muft Ilaj Yojana\u2019 seven types of medical services are being provided for free in Haryana</li></ul></div><div class="col-md-6"><h6 class="text-center gradient_bg_color3 text-white" style="padding: 10px;font-size: 20px">Well connected road network</h6><ul><li>One of India\u2019s biggest state road transport undertakings with the fleet of nearly 4215 buses</li><li>26131 km of total road network with a road density of 52.1 sq. km. per 100 sq. km.</li><li>2482 km of 21 NHs passing through Haryana</li><li>Among the states having almost 100% connectivity to rural areas with metalled roads</li></ul></div><div class="col-md-6"><h6 class="text-center gradient_bg_color1" style="padding: 10px;font-size: 20px">Train And Metro</h6><ul><li>1710 km long railway network</li><li>Metro connectiivity in Faridabad and Gurgaon</li><li>Rail density of 33 km per 1000 sq.km., ranked 5th best in the country</li><li>MRTS Gurgaon-Manesar-Bawal under construction</li></ul></div><div class="col-md-6"><h6 class="text-center gradient_bg_color3 text-white" style="padding: 10px;font-size: 20px">Telecom and Broadband Connectivity</h6><ul><li>25.71 million wireless subscribers</li><li>92.18% teledensity, 10th highest in the country</li><li>Faridabad, Sonepat & Rewari connected via Broadband</li><li>BharatNet Scheme & CCIP Policy to provide a major push to telecom and communication infrastructure in the state</li></ul></div></div><div class="row"><div class="col-md-6"><h6 class="text-center gradient_bg_color1" style="padding: 10px;font-size: 20px">Education</h6><ul><li>39 Universities and 1156 Colleges/Institutes (2015-16)</li><li>Home to premier education institutes: IIM, IIIT, NIT, NID, NIFT, NIFTEM, Central University etc.</li><li>IIT Extension and Rajiv Gandhi Education city in pipeline</li><li>School available within distance of 1.03 kms of each village</li></ul></div><div class="col-md-6"><h6 class="text-center gradient_bg_color3 text-white" style="padding: 10px;font-size: 20px">Power Surplus</h6><ul><li>11,242 MW of installed power capacity</li><li>Thermal, gas and hydra power plants in Yamunanagar, Hisar, Panipat, Jhajjar and Faridabad</li><li>\u201CMhara Gaon Jagmag Gaon\u201D scheme launched with a view to provide 24x7 supply of power across rural domestic consumers</li><li>100% electrification since 1970</li></ul></div><div class="col-md-6"><h6 class="text-center gradient_bg_color1" style="padding: 10px;font-size: 20px">Location Advantage</h6><ul><li>Approximately 2/3 of Haryana lies in NCR region</li><li>20 minutes from IGI Airport</li><li>Surrounded by UP, Punjab, Rajasthan and New Delhi, enhancing trade and business opportunities</li><li>Access to more than 11% of India\'s population</li></ul></div><div class="col-md-6"><h6 class="text-center gradient_bg_color3 text-white" style="padding: 10px;font-size: 20px">Land Provisions</h6><ul><li>Land banks made available for investment by HSIIDC</li><li>Industrial plots made available for investment</li><li>License to develop industrial colonies</li><li>Provision of Auto CLU/ No CLU</li></ul></div></div></div></div></div></div></section>');
$templateCache.put('app/home/contact.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Contact Us</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li class="active"><span>Contact Us</span></li></ol></div></section><section class="ls columns_padding_30 section_padding_top_75 section_padding_bottom_75"><div class="container"><div class="row"><div class="col-md-4 to_animate" data-animation="scaleAppear"><ul class="list1 no-bullets no-top-border no-bottom-border"><li><div class="media"><div class="media-body"><h6 class="media-heading grey">Address:</h6>Haryana Enterprises Promotion Centre<br>Bay No. 63-66, Level-II, Sector 2, Panchkula 134112</div></div></li><li><div class="media"><div class="media-body greylinks"><h6 class="media-heading grey">Email:</h6><a href="mailto:hepc.helpdesk@gmail.com">hepc[dot]helpdesk[at]gmail[dot]com</a></div></div></li><li><div class="media"><div class="media-body"><h6 class="media-heading grey">Contact Us:</h6>+91-172-2521800</div><div class="media-body"><h6 class="media-heading grey">Toll Free:</h6>1800-180-2132</div></div></li><li><div class="media"><div class="media-body"><h6 class="media-heading grey">Timings:</h6>Mon - Fri: 09:00 AM - 05:00 PM<br>Sat & Sun: Closed</div></div></li></ul></div><div class="col-md-8 to_animate" data-animation="scaleAppear"><section class="ls page_map"><iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2425.9356932195246!2d76.85985090920396!3d30.69615152631101!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390f936fdb7492f7%3A0xe97a6cad893e1a89!2sHaryana+Enterprises+Promotion+Centre!5e0!3m2!1sen!2sin!4v1542310595296" width="100%" height="450" frameborder="0" style="border:0" allowfullscreen></iframe></section></div></div></div></section>');
$templateCache.put('app/home/defence.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Defence & Aerospace</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Focus Sectors</span></li><li class="active"><span>Defence & Aerospace</span></li></ol></div></section><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container-fluid"><div class="row"><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Highlights</h5></div><div class="col-md-12"><ul><li>5 civil airstrips present in the state at Hisar, Bhiwani,Karnal,Narnaul &Pinjore</li><li>2 defence aerodromes located at Sirsa and Ambala</li><li>3 aviation centres of Haryana Institute of Civil Aviation located at Hisar, Karnal and Pinjore</li><li>A functional international airport at Chandigarh along with close proximity of the state to India\'s largest international airport at Delhi</li><li>Existing production for Defense equipments at Bharat Electronics Limited, Panchkula and production & supply of ammunition boxes to the Armed Forces from Yamunanagar</li></ul></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Incentives</h5><table class="table table_template table-striped"><thead><tr><th class="text-center">INCENTIVE</th><th class="text-center">DETAILS</th></tr></thead><tbody><tr><td class="text-center">Land fees and taxes</td><td><ul><li>Upto 100% refund of stamp duty</li></ul></td></tr><tr><td class="text-center">Power charges</td><td><ul><li>Upto Power Subsidy @ INR 2 per unit</li><li>Upto 100% exemption of electricity duty</li></ul></td></tr><tr><td class="text-center">Employment generation incentive</td><td><ul><li>Upto INR 36000/- per annum per employment generation</li></ul></td></tr><tr><td class="text-center">Other incentives</td><td><ul><li>Upto 75% VAT Subsidy</li><li>Upto 6% Interest Subsidy</li><li>Maximum 50% exemption of EDC Charges</li><li>The maximum incentive specified for any sector and any category of industry will be applicable for the defense production in \u2018B\u2019,\u2019C\u2019 & \u2018D\u2019 category blocks (EPP Policy)</li></ul></td></tr></tbody></table></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Investment Opportunities</h5><ul><li>The existing airstrip at Hisar is proposed to be developed as an Aviation hub including setting up of a MRO, FBO and Aerospace & Defense manufacturing facility.</li><li>MRO Sector \u2013 About 600 aircrafts in the country are expected to be more than 5 years in service by 2020.Hence,MRO sector presents a huge demand and ample opportunity for investment</li><li>FBO Sector \u2013 Apart from Delhi & Mumbai, no other airport in India has any FBO. Therefore, presence of FBOs can significantly reduce cost of aircraft handling at airports other than the base airport of the service provider.<br>Haryana, being in close proximity to 2 international airports, provides ample scope in this sector</li><li>Aerospace & Defense Manufacturing \u2013 India has limited capacity to manufacture light/mid-size jets therefore presenting an opportunity to aircraft manufacturers</li><li>Cargo Warehousing \u2013 Delhi alone handles 27% of the international air cargo traffic. With the upcoming International cargo airport planned at Bawal, district Rewari, there will be a need of cargo warehouse within North India</li></ul></div></div></div></div></div></div></section>');
$templateCache.put('app/home/electronicsAndInfo.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Electronics & IT/ITES</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Focus Sectors</span></li><li class="active"><span>Electronics & IT/ITES</span></li></ol></div></section><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container-fluid"><div class="row"><div class="col-md-12"><img src="../../content/used-images-new/electronics.jpg" style="width: 100%; height: 300px"></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Highlights</h5></div><div class="col-md-12"><ul><li>One of the leading states in internet usage with more than 5% of households having computers with internet facility</li><li>IT-BPM industry contributes 9.4% to state\u2019s GDP and 54% to state\u2019s exports</li><li>Home to 4 Software Technology Parks, over 450 companies, direct employment of 2.5-3 lakh people, indirect employment of 8-9 lakh people</li><li>Existence of large scale IT companies like Microsoft, Accenture, Google, IBM, TCS etc.</li></ul></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Initiatives</h5></div><div class="col-md-12"><ul><li>Communication and Connectivity Infrastructure Policy 2013 launched to augment telecom and connectivity infrastructure in the State</li><li>Establishment of Gurgaon as BPM capital of the world, with Gurgaon alone contributing to 5% of total worldwide BPM workforce</li><li>Training in IT for Government employees is a focus area with the IT Department training about 1000 employees every year</li></ul></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Incentives</h5><table class="table table_template table-striped"><thead><tr><th class="text-center">INCENTIVE</th><th class="text-center">DETAILS</th></tr></thead><tbody><tr><td class="text-center">Stamp duty</td><td><ul><li>IT Industry shall be eligible for 100% reimbursement of stamp duty paid on sale / lease deeds paid on the first transaction for setting up units in notified IT Parks, IT cities, Technology Parks / STPIs or any land earmarked by the State Government for IT industry</li></ul></td></tr><tr><td class="text-center">Power charges</td><td><ul><li>100% exemption for a period of 7 years from commercial operations</li><li>IT/ ITeS industry shall be eligible for getting power @ INR 5.49 per unit* provided the investor signs Memorandum of Understanding - MoU with Government of Haryana for investments in the State *Subsidy is restricted up to a certain level of consumption of per industrial unit which shall be decided separately with approval of Hon\u2019ble Chief Minister, Haryana.</li></ul></td></tr><tr><td class="text-center">Property Tax at industrial rates</td><td><ul><li>Property Tax on IT / ITeS units shall be at par with the industrial rates and further definition of IT / ITeS industry as specified in chapter 1 of this policy shall be applicable for identification of IT / ITeS industry</li></ul></td></tr><tr><td class="text-center">SGST Reimbursement</td><td><ul><li>100% reimbursement (net tax) for a period of 10 years subject to maximum of 100% of Fixed Capital Investment \u2013 FCI for units setting up in \u2018C\u2019 & \u2018D\u2019 Blocks</li></ul></td></tr><tr><td class="text-center">Mega Projects</td><td><ul><li>Mega projects shall be eligible for Special package of incentives over and above of the standard package for IT industry shall be considered by the empowered committee on case to case basis</li></ul></td></tr><tr><td class="text-center">Ultra Mega Projects</td><td><ul><li>Ultra-Mega Projects shall be offered special package of incentives by Haryana Enterprise Promotion Board including such as mixed land use,allotment of land at a price to be decided by the Government etc.</li></ul></td></tr></tbody></table></div></div></div></div></div></div></section>');
$templateCache.put('app/home/eodb.html','<div class="bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"><div class="well" style="width:500px, height:500 px"><a href="http://events.eletsonline.com/edb/haryana/" target="_blank"><img src="../../content/used-images-new/EODBBANNER.jpg" class="img-responsive" alt="EODB Banner"></a><br><br></div></div>');
$templateCache.put('app/home/focusarea.html','<br><div class="container"><div class="col-md-12"><strong><span style="color:#990000">Focus Area</span></strong><br><br><br><div class="col-md-2"><a href="../../content/pdfs/SectorProfileRenewableEnergy.pdf" target="_blank"><img src="../../content/used-images-new/01.jpg" title="" class="img-responsive"></a></div><div class="col-md-2"><a href="../../content/pdfs/SectorProfileAerospaceandDefence.pdf" target="_blank"><img src="../../content/used-images-new/02.jpg" title="" class="img-responsive"></a></div><div class="col-md-2"><a href="../../content/pdfs/SectorProfileITESDM.pdf" target="_blank"><img src="../../content/used-images-new/03.jpg" title="" class="img-responsive"></a></div><div class="col-md-2"><a href="../../content/pdfs/SectorProfileManufacturingCompetitiveness.pdf" target="_blank"><img src="../../content/used-images-new/04.jpg" title="" class="img-responsive"></a></div><div class="col-md-2"><a href="../../content/pdfs/SectorProfilePharmaceuticalsAndChemicals.pdf" target="_blank"><img src="../../content/used-images-new/05.jpg" title="" class="img-responsive"></a></div><div class="col-md-2"><a href="../../content/pdfs/SectorProfileFootwear.pdf" target="_blank"><img src="../../content/used-images-new/06.jpg" title="" class="img-responsive"></a></div><div class="col-md-2"><a href="../../content/pdfs/SectorProfileTextile.pdf" target="_blank"><img src="../../content/used-images-new/07.jpg" title="" class="img-responsive"></a></div><!--<a href="../../content/images/SectorProfileAerospaceandDefence.pdf" target="_blank">-&ndash;&gt;  Sector Profile -Aerospace and Defence </a> <br/><br/>--><!--<a href="../../content/images/SectorProfileFoodProcessing.pdf" target="_blank">-&ndash;&gt;  Sector Profile -Food Processing </a> <br/><br/>--><!--<a href="../../content/images/SectorProfileFootwear.pdf" target="_blank">-&ndash;&gt;  Sector Profile - Footwear </a> <br/><br/>--><!--<a href="../../content/images/SectorProfileITESDM.pdf" target="_blank">-&ndash;&gt;  Sector Profile- IT ESDM </a> <br/><br/>--><!--<a href="../../content/images/SectorProfileManufacturingCompetitiveness.pdf" target="_blank">-&ndash;&gt;  Sector Profile - Manufacturing Competitiveness </a> <br/><br/>--><!--<a href="../../content/images/SectorProfilePharmaceuticalsAndChemicals.pdf" target="_blank"> -&ndash;&gt;  Sector Profile - Pharmaceuticals and Chemicals </a> <br/><br/>--><!--<a href="../../content/images/SectorProfileRenewableEnergy.pdf" target="_blank"> -&ndash;&gt;  Sector Profile  - Renewable Energy </a> <br/><br/>--><!--<a href="../../content/images/SectorProfileTextile.pdf" target="_blank"> -&ndash;&gt;  Sector Profile - Textile </a> <br/><br/>--><!--<a href="../../content/images/SubCommitteeBrochureAgriBusiness.pdf" target="_blank"> -&ndash;&gt;  Sub-Committee Brochure Agriculture Business </a> <br/><br/>--><!--<a href="../../content/images/SubCommitteeBrochureEmergingPPModels.pdf" target="_blank"> -&ndash;&gt;  Sub-Committee Brochure Emerging PPP Models </a> <br/><br/>--><!--<a href="../../content/images/SubCommitteeBrochure ITITeSESDM.pdf" target="_blank"> -&ndash;&gt;  Sub Committee Brochure - IT ITeS ESDM </a> <br/><br/>--></div></div>');
$templateCache.put('app/home/footwearAndAccessory.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Footwear & Accessories</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Focus Sectors</span></li><li class="active"><span>Footwear & Accessories</span></li></ol></div></section><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container-fluid"><div class="row"><div class="col-sm-12"><img src="../../content/used-images-new/footwear.jpg" style="width: 100%; height: 300px"></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Highlights</h5></div><div class="col-md-12"><ul><li>Growth potential for this sector expected to be 20% CAGR for the next 35 years</li><li>Major brands like Liberty, Action, Relaxo, Lancer, Lakhani, Today, Columbus and Welcome present in the state</li><li>Karnal, Bahadurgarh, Faridabad and Gurgaon identified as major centres of footwear production, leather garments, shoe parts and accessories</li></ul></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Initiatives</h5></div><div class="col-md-12"><ul><li>Developed 555.34 acre land in Sector 16-17,Bahadurgarh to establish Industrial Estate and Footwear Park</li><li>499 units already in production with proposed investment to the extent of around USD 215.1 million ( USD 21.51 Crores) and proposed employment of around 28,280 persons</li><li>About 177 acre land acquired in Sector 4-B, Bahadurgarh for extension of Industrial Estate with required facilities</li><li>Establishment of Industrial estates and footwear park at Bahadurgarh offering state of the art facility with roads, sewerage, street light, electrification and water distribution system</li><li>In view of the demand for trained manpower, Footwear Design and Development Institute (FDDI) has been setup at IMT Rohtak. This institute will cater to the needs of providing skilled manpower for footwear design as per the Industry requirements</li><li>Major clusters at Karnal, Faridabad, Bahadurgarh, Gurgaon, Manesar, Sonepat, Kundli and Ambala involved in the process of end-to-end product manufacturing.</li></ul></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Incentives</h5><table class="table table_template table-striped"><thead><tr><th class="text-center">INCENTIVES</th><th class="text-center">DETAILS</th></tr></thead><tbody><tr><td class="text-center">Investment Subsidy on VAT</td><td><ul><li>75% of VAT/SGST net paid for first 7 years, 35% for next three years in \u2018C\u2019 & \u2018D\u2019 category blocks and 50% for first 5 years, 25% for next 3 years in \u2018B\u2019 category blocks from the date of commencement of commercial production or provided atleast 50% additional investment in plant and machinery for expansion/diversification with cap of 100% of fixed capital investment</li></ul></td></tr><tr><td class="text-center">Employment Generation Subsidy</td><td><ul><li>On-time support of Rs.10,000/- for capacity building of persons belonging to Haryana (skilled-semi-skilled) engaged in footwear rural functional clusters in \u2018B\u2019, \u2018C\u2019 and \u2018D\u2019 category blocks</li></ul></td></tr><tr><td class="text-center">Interest Subsidy</td><td><ul><li>@6% for Micro, Small and Medium Enterprises or maximum upto Rs.10.00 lakh per year for 5 years in \u2018B\u2019, \u2018C\u2019, & \u2018D\u2019 category blocks limited to amount of net VAT/SGST paid during the relevant year</li></ul></td></tr><tr><td class="text-center">Power charges</td><td><ul><li>Adoption of ITI by private sector with complete autonomy in technical and commercial matters with a guarantee of 70% employment</li></ul></td></tr><tr><td class="text-center">Power tariff incentive</td><td><ul><li>MSME in \u2018C\u2019 and \u2018D\u2019 Category block units engaged in manufacturing of footwear and footwear components shall be provided a concession @Rs.2/- per unit in electricity tariff</li><li>100% exemption for 10 years only for new enterprise in \u2018C\u2019 & \u2018D\u2019 category blocks</li></ul></td></tr><tr><td class="text-center">Reduced VAT</td><td><ul><li>5% VAT in place of existing 12.5% on the footwear above Rs.500/-</li></ul></td></tr><tr><td class="text-center">Special incentives</td><td><ul><li>Special incentives like interest subsidy @ 6% , investment subsidy on VAT @ 50%-75% for 8-10 years, refund of 80%-100% stamp duty and 50% exemption from EDC etc. for some categories</li></ul></td></tr></tbody></table></div></div></div></div></div></div></section>');
$templateCache.put('app/home/gurugram.html','<script>ga(\'set\', \'page\', \'/gurugram\');ga(\'send\',\'pageview\');</script><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Global City at Gurugram</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investment Opportunities</span></li><li class="active"><span>Global City at Gurugram</span></li></ol></div></section><div class="container-fluid"><section class="ls"><div class="container"><div class="row"><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key projects for development by potential Master Planners/Developers</h5><div class="col-md-6"><div class="text-center" style="margin-top: 50px"><img src="../../content/used-images-new/globalcityggn.jpg"></div></div><div class="col-md-6"><h5 class="gradient_bg_color1 text-center" style="color: white; padding: 10px;font-size: 20px">Salient features</h5><ul><li>Located in Delhi NCR as part of the Manesar Urban Development Complex</li><li><b>1000 acres of land in the Haryana sub region of Delhi-Mumbai Industrial Corridor</b></li><li><b>Approx. 30 km from the Indira Gandhi International airport (New Delhi)</b></li><li><b>Close proximity to the Delhi-Jaipur rail line, NH-8 and KMP Peripheral road</b></li><li>Allowable Built Up Area of 12.17 million Sq mt</li><li><b>High Density with Mixed Land use \u2013 More than 5 Lakh people turning up at peak, 785 person / acre</b></li><li>Dominant manufacturing, and service hub of Gurgaon in close proximity</li></ul><h5 class="gradient_bg_color1 text-center" style="color: white; padding: 10px;font-size: 20px">Global City at Gurugram</h5><ul><li><b>Investment Potential \u2013 US $ 15 billion</b><br>( Rs. 1,00,000 crore)</li><li><b>Implementation mode</b> -SPV by the name of DMIC Haryana Global City Project has been incorporated which is a Joint venture of HSIIDC and DMICDC</li></ul></div></div></div></div></section></div>');
$templateCache.put('app/home/haryana.html','<!DOCTYPE html><html><!--<head>--><!--<title> Demo for all bootstrap </title>--><!--<link rel="stylesheet" type="text/css" href="css/bootstrap.min.css">--><!--<link rel="stylesheet" type="text/css" href="css/font-awesome.css">--><!--<link rel="stylesheet" type="text/css" href="css/style.css">--><!--</head>--><body><!--<div class="header-1">--><!--<div class="container-fluid bgc-r">--><!--<div class="row">--><!--<div class="col-md-3 col-xs-12">--><!--<p class="font14">Toll  Free  Helpline <br>--><!--1800-180-2132</p>--><!--</div>--><!--<div class="col-md-6"></div>--><!--<div class="col-md-3"></div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="header-2">--><!--<div class="container-fluid">--><!--<div class="second-box">--><!--<div class="row">--><!--<div class="col-md-3">--><!--<div class="logo-site">--><!--<img src="img/logo.PNG" alt="logo-hepc" title="logo" class="img-responsive center-block">--><!--</div>--><!--</div>--><!--<div class="col-md-6">--><!--<div class="text-main text-center">--><!--<p class="font15">Department of Industries<br> Haryana Enterprise Promotion Center</p>--><!--</div>--><!--</div>--><!--<div class="col-md-1"></div>--><!--<div class="col-md-2">--><!--<div class="second-logo">--><!--<img src="img/logo-gov.PNG" class="img-responsive center-block" alt="logo-gov" title="logogov">--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="navbar-box">--><!--<div class="container-fluid">--><!--<div class="row">--><!--<header id="header">--><!--<nav class="navbar">--><!--<div class="container-fluid bgc-r">--><!--<div class="navbar-header">--><!--<button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">--><!--<span class="icon-bar"></span>--><!--<span class="icon-bar"></span>--><!--<span class="icon-bar"></span>--><!--</button>--><!--</div>--><!--<div class="collapse navbar-collapse" id="myNavbar">--><!--<ul class="nav navbar-nav">--><!--<li><a class="active" href="#"> About Us</a></li>--><!--<li><a href="#"> Haryana</a></li>--><!--<li><a href="#">Investor Service</a></li>--><!--<li><a href="#">Information</a></li>--><!--<li><a href="#">News &amp; Gallery</a></li>--><!--<li><a href="#">Login</a></li>--><!--<li style="border-right: 1px solid transparent;"><a href="#">Contact</a></li>--><!--</ul>--><!--</div>--><!--</div>--><!--</nav>--><!--</header>--><!--</div>--><!--</div>--><!--</div>--><br><div class="new-section"><div class="container-fluid"><div class="row"><div class="col-md-3"><strong><span style="color:#990000; font-size: 20px">Haryana</span></strong><br><div class="row"><div class="col-md-2" style="padding-right: 0px"><img src="../../content/used-images-new/Capture2.jpg" alt="" title="" class="img-responsive"></div><div class="col-md-10" style="margin-left:-19px"><br><a ui-sref="haryana"><p class="font19">Fact File</p></a><br><a ui-sref="states"><p class="font19">States</p></a><br><a ui-sref="Enabling_infrastructure"><p class="font19">Enabling Infrastructure</p></a><br><a ui-sref="urban_infrastructure"><p class="font19">Urban Infrastructure</p></a><br><a ui-sref="industrial_powerhouse"><p class="font19">Industrial Powerhouse</p></a><br></div></div></div><div class="col-md-9"><div class="col-sm-6"><img src="../../content/used-images-new/hry.jpg" class="img-responsive" alt=""><br></div><div class="col-sm-6"><h2 style="color: #a0233d;border-bottom: 2px solid black;padding: 5px">Haryana - Land of Opportunity</h2><ul style="font-size: 16px"><li><b>Haryana is surrounded by Uttar Pradesh in the east, Punjab in the west, Himachal Pradesh in the north & Rajasthan in the south. The state surrounds the national capital city, New Delhi, from 3 sides.</b></li><br><li><b>The most commonly spoken languages are Hindi & Punjabi. English is the medium of education in most schools.</b></li><br><li><b>Gurgaon, Faridabad, Karnal, Ambala, Panipat & Kurukshetra are some of the key districts of the state.</b></li><br><li><b>The state has 3 major seasons, viz., summer (April-June), monsoon (July-September) and winter (October-March).</b></li><br></ul><br><br><br></div></div><div class="col-md-9 col-md-offset-3"><p style="font-size: 24px; color: #a0233d"><b>22 Districts | 74 Sub-Districts | 154 Towns | 6841 Villages | 127 CD Blocks</b></p><h1>Conducive Ecosystem</h1><div class="col-sm-4"><h2 style="background-color: #a0233d; text-align: center; padding: 10px; color: white; font-size: 24px">Land Availability</h2><div style="background-color: #d0d2d4; width: 100%; margin-top: -10px; height: 350px;"><ul style="font-size: 16px"><li>12,000 acres of new land made available by HSIIDC</li><br><li>3000 no\' of Industrial plots</li><br><li>Panchayat land for industrial use is under consideration</li><br><li>Industrial license to developers</li><br><li>Provision of Auto CLU/ No CLU</li><br></ul></div></div><div class="col-sm-4"><h2 style="background-color: #a0233d; text-align: center; padding: 10px; color: white; font-size: 24px">Power Surplus</h2><div style="background-color: #d0d2d4; width: 100%; margin-top: -10px; height: 350px"><ul style="font-size: 16px"><li>Considerably reduced power tariff for new investments (to be announced very soon)</li><br><li>100% electrification since 1970</li><br><li>11,102MW of installed power capacity</li><br><li>\u0178100% Rural electrification</li><br></ul></div></div><div class="col-sm-4"><h2 style="background-color: #a0233d; text-align: center; padding: 10px; color: white; font-size: 24px">Strong Dynamic Market</h2><div style="background-color: #d0d2d4; width: 100%; margin-top: -10px; height: 350px"><ul style="font-size: 16px"><li>13 districts of the state are a part of National Capital Region (NCR) which is one of the largest production, consumption and trade zones in India</li><br><li>Access to more than 11% of India\'s population,</li><br><li>Two Industrial corridors (DMIC & AKIC) passing through Haryana</li><br><li>21 National Highways passing through Haryana</li><br></ul></div></div></div></div></div></div><br><br><br><br><!--<div class="container bgc-g">--><!--<div class="footer">--><!--<div class="row">--><!--<div class="col-md-4">--><!--<p>Disclamer</p>--><!--<p>Privacy Policy</p>--><!--<p>Hyperlinking Policy</p>--><!--<p>Copyright Statement</p>--><!--<p>Terms of Use</p>--><!--<p>Sitemap</p>--><!--</div>--><!--<div class="col-md-4">--><!--<p>Citizen Corner</p>--><!--<p>Feedback</p>--><!--<p>Content Review Policy</p>--><!--<p>Content Approval</p>--><!--<p>Content archival</p>--><!--<p>FAQ\'s</p>--><!--</div>--><!--<div class="col-md-4">--><!--<img src="img/logo_1.png" alt="" title="" class="img-responsive"><br>--><!--<p><strong>Visiter Count:</strong> 00-005-27-7</p>--><!--<p><strong>Last Update on: </strong> 6 July 2017</p>--><!--<p><strong>Site Best View In:</strong> Google Chrome, IE, Firefox </p>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<br>--><!--<div class="header-1">--><!--<div class="container-fluid bgc-r">--><!--<p>&nbsp;</p><p>&nbsp;</p>--><!--</div>--><!--</div>--><!--<script type="text/javascript" src="js/jquery.js"></script>--><!--<script type="text/javascript" src="js/bootstrap.min.js"></script>--><!--<script type="text/javascript" src="js/script.js"></script>--></body></html>');
$templateCache.put('app/home/home.html','<style>.card {\n        border: none;\n        border-radius: 15px;\n        box-shadow: 0 4px 10px rgba(0,0,0,0.1);\n        transition: all 0.3s ease-in-out;\n        background-color: #fff;\n    }\n\n    .card:hover {\n        transform: translateY(-5px);\n        box-shadow: 0 8px 16px rgba(0,0,0,0.2);\n    }\n\n    .card-img-top {\n        width: 120px;\n        height: 120px;\n        object-fit: cover;\n        border: 3px solid #007bff;\n        margin: 0 auto;\n    }\n\n    .card-body {\n        padding: 15px 10px;\n    }\n\n    .card-title {\n        font-weight: 600;\n        color: #333;\n    }\n\n    .card-text {\n        font-size: 14px;\n        color: #666;\n    }\n\n    .chatbot-btn {\n        position: fixed;\n        bottom: 25px;\n        right: 25px;\n        background: #007bff;\n        color: white;\n        padding: 15px 18px;\n        border-radius: 50%;\n        cursor: pointer;\n        box-shadow: 0 4px 8px rgba(0,0,0,0.2);\n        font-size: 22px;\n        z-index: 9999;\n    }\n    .chatbot-btn:hover {\n        background: #0056b3;\n    }\n\n    .chatbot-box {\n        position: fixed;\n        bottom: 90px;\n        right: 25px;\n        width: 340px;\n        background: #fff;\n        border-radius: 10px;\n        box-shadow: 0 6px 20px rgba(0,0,0,0.25);\n        z-index: 9999;\n        overflow: hidden;\n        max-height: 480px;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .chatbot-header {\n        padding: 10px 15px;\n    }\n\n    .chatbot-body {\n        overflow-y: auto;\n        max-height: 400px;\n    }\n\n    .list-group-item:hover {\n        background: #ff99cc !important;\n    }</style><div id="myCarousel" class="container-fluid darkblue_gradient carousel slide" data-ride="carousel"><div class="col-md-12"><marquee direction="left" scrollamount="6" id="whatshappening" onmouseover="this.stop();" onmouseout="this.start();"><b style="color: yellow; font-size: medium;padding: 100px">New \u2013 The Invest Haryana / Single Window System Portal has been upgraded with respect to Right of Way (RoW) / Right of Use applications within the State and has been made live w.e.f. 24th December, 2025. All concerned are requested to process RoW applications through the said portal strictly as per the provisions of the Government Order dated 08.04.2025 and the Telecommunications (Right of Way) Rules, 2024. </b><b style="color: yellow; font-size: medium;padding: 100px">*New* - The implementation of Deemed Approval w.r.t Right of Way/Right of Use applications within the State shall be made live from 1st December, 2023 onwards. All concerned, are requested to clear the pendency accordingly. </b><!--            <b style="color: yellow; font-size: medium;padding: 100px;">--><!--                *NEW - Registration of CABLE TV Operators and Grant of Permissions for Right of Way / Right of Use for laying the Cable TV infrastructure under Communication & Connectivity now available on Portal.--><!--            </b>--> <b style="color: yellow; font-size: medium;padding: 100px">Haryana CSR Advisory Board link is available under \u201CInvestor Services\u201D tab. </b><b style="color: yellow; font-size: medium;padding: 100px">As per the notification no. 11/23/2018-4Lab all commercial establishments are now exempted from renewal of registration under the Shops & Establishment Act. For more details, please visit Notifications -> Notices link on the investharyana web portal.</b></marquee><marquee direction="left" scrollamount="6" id="newpolicies" onmouseover="this.stop();" onmouseout="this.start();"><a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/Make in Haryana Industrial Policy 2025 - 15.09.2025.pdf" target="_blank"><b>*Draft MAKE IN HARYANA INDUSTRIAL POLICY 2025</b></a> <b style="color: yellow; font-size: medium;padding: 10px">(Send your suggestions <a href="/#/public-feedback">\u201CClick Here\u201D</a> on Draft Regulation, if any. You can also send it on the email ids: eobdhry@gmail.com and ipcharyana@yahoo.com.) </b><a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/Press Note.pdf" target="_blank"><b>*Important Notice: Regarding Purchase Incentive Schemes Under the Haryana EV Policy 2022</b></a> <a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/E-Waste Policy 27.06.pdf" target="_blank"><b>*Draft Haryana Electronics Waste Recycling Policy, 2024.</b></a> <a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/AVGCXR Policy 27.06.pdf" target="_blank"><b>*Draft Haryana AVGC-XR Policy, 2024.</b></a> <a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/IT-ITeS Policy 27.06.pdf" target="_blank"><b>*Draft Haryana IT & ITeS Policy, 2024.</b></a> <a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/Electronic Toys Policy 14.3.pdf" target="_blank"><b>*Draft Haryana Electronic Toys Manufacturing Policy, 2024.</b></a> <a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/ESDM Policy 14.3.pdf" target="_blank"><b>*Draft Haryana Electronic System Design & Manufacturing (ESDM) Policy, 2024.</b></a> <a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/Medical Devices Policy 16.2 (1).pdf" target="_blank"><b>*Draft Haryana Medical Devices Manufacturing Policy, 2024</b></a> <b style="color: yellow; font-size: medium;padding: 100px">(Send your suggestions on above policies if any, email id: emdsection2023@gmail.com & industries.commerce.haryana@gmail.com) </b><a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/Revised Communication Connectivity Infrastructure Policy 2023.pdf" target="_blank"><b>*New - Communication & Connectivity Infrastructure Policy - 2023.</b></a> <a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/EV Policy 2022.pdf" target="_blank"><b>*EV policy 2022</b></a> <a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/Instructions for buyers EV Policy 22-1.pdf" target="_blank"><b>*Instructions for EV Buyers</b></a> <a style="color: yellow; font-size: medium;padding: 100px"><b>*NEW - Renewal/Extension Permissions for Mobile Tower Communication and Connectivity now available on Portal</b></a> <a style="color: yellow; font-size: medium;padding: 100px" href="../../content/pdfs/2020_HEEP.pdf" target="_blank"><b>*HARYANA ENTERPRISES AND EMPLOYMENT POLICY, 2020*</b></a></marquee></div><div class="carousel-inner" role="listbox"><div class="item active bgImgCenter" style="height: 280px"><div class="col-md-8 panel-body"><div class="row"><h1 class="slider-text"><span data-translate="global.menu.Single">Single</span> <span class="thin"><span data-translate="global.menu.Roof Clearances">Roof Clearances</span></span><br><span class="thin" data-translate="global.menu.System">System</span></h1><p style="color: white !important" data-translate="global.menu.Facilitates prospective investors to obtain regulatory clearances online through Haryana Enterprise Promotion Board under Empowered Executive Committee.">Facilitates prospective investors to obtain regulatory clearances online through Haryana Enterprise Promotion Board under Empowered Executive Committee.</p></div></div></div></div></div><div class="container mt-4"><div class="row text-center"><!-- Person 1 --><div class="col-md-3 col-sm-6 mb-4"><div class="card hover-shadow" style="padding-top: 20px"><img src="../../content/used-images-new/haryana_cm_logo_12X15.jpg" class="card-img-top rounded-circle mt-3" alt="Chief Minister"><div class="card-body"><h5 class="card-title mb-1">Sh. Nayab Singh Saini</h5><p class="card-text text-muted">Hon\'ble Chief Minister, Haryana</p></div><br></div></div><!-- Person 2 --><div class="col-md-3 col-sm-6 mb-4"><div class="card hover-shadow" style="padding-top: 20px"><!--                <img src="../../content/used-images-new/Rao-narbir.png" class="card-img-top rounded-circle mt-3" alt="Deputy Chief Minister">--> <img src="https://training.investharyana.in/content/used-images-new/Rao-narbir.png" class="card-img-top rounded-circle mt-3" alt="Ministry of Industries and Commerce"><div class="card-body"><h5 class="card-title mb-1">Sh. Rao Narbir Singh</h5><p class="card-text text-muted">Hon\'ble Industries Minister, Haryana</p></div><br></div></div><!-- Person 3 --><div class="col-md-3 col-sm-6 mb-4"><div class="card hover-shadow" style="padding-top: 20px"><img src="../../content/used-images-new/Amitkumar.jpg" class="card-img-top rounded-circle mt-3" alt="Officer"><div class="card-body"><h5 class="card-title mb-1">Dr. Amit K. Agrawal, IAS.</h5><p class="card-text text-muted">Commissioner & Secretary, Industries & Commerce</p></div></div></div><!-- Person 4 --><div class="col-md-3 col-sm-6 mb-4"><div class="card hover-shadow" style="padding-top: 20px"><img src="../../content/used-images-new/yash_garg.jpg" class="card-img-top rounded-circle mt-3" alt="Officer"><div class="card-body"><h5 class="card-title mb-1">Dr. Yash Garg, IAS</h5><p class="card-text text-muted">Director General, Industries & Commerce & MSME</p></div></div></div></div></div><section id="counters" class="ls section_padding_top_50 section_padding_bottom_50 columns_margin_bottom_40"><div class="container"><div class="row"><div class="col-xxs-12 col-xs-6 col-md-3"><div class="teaser text-center"><img src="../../content/used-images-new/icons/counter-1.png" alt=""><h3 class="counter" data-from="0" data-to="{{vm.homePageCountOutputs.totalCafs}}" data-speed="156">{{vm.homePageCountOutputs.totalCafs}}</h3><p><span data-translate="global.menu.No. of New CAFs">No. of New CAFs</span><br><span data-translate="global.menu.Registered">Registered</span></p></div></div><div class="col-xxs-12 col-xs-6 col-md-3"><div class="teaser text-center"><img src="../../content/used-images-new/icons/counter-2.png" alt=""><h3 class="counter" data-from="0" data-to="{{vm.homePageCountOutputs.totalServicesApplied}}" data-speed="2100">{{vm.homePageCountOutputs.totalServicesApplied}}</h3><p><span data-translate="global.menu.No. of Services">No. of Services</span><br><span data-translate="global.menu.Applied">Applied</span></p></div></div><div class="col-xxs-12 col-xs-6 col-md-3"><div class="teaser text-center"><img src="../../content/used-images-new/icons/counter-3.png" alt=""><h3 class="counter-wrap"><span class="counter" data-from="0" data-to="{{vm.homePageCountOutputs.totalServicesGranted}}" data-speed="2100"></span><span class="counter-add">{{vm.homePageCountOutputs.totalServicesGranted}}</span></h3><p><span data-translate="global.menu.No. of Services">No. of Services</span><br><span data-translate="global.menu.Granted">Granted</span></p></div></div><div class="col-xxs-12 col-xs-6 col-md-3"><div class="teaser text-center"><img src="../../content/used-images-new/icons/counter-4.png" alt=""><h3 class="counter" data-from="0" data-to="{{vm.homePageCountOutputs.totalCompletedCafs}}" data-speed="2100">{{vm.homePageCountOutputs.totalCompletedCafs}}</h3><p><span data-translate="global.menu.No. of CAFs">No. of Completed</span><br><span data-translate="global.menu.Completed">CAFs</span></p></div></div></div></div></section><section id="features2" class="cs fluid_padding_0 columns_padding_0 columns_margin_0"><div class="container-fluid"><div class="row flex-wrap v-content-equalize v-center-content"><div class="col-xs-12 col-sm-12 col-md-2 text-center text-md-left" style="flex-direction: row; margin-left: 40px"><div class="with_padding big-padding gradient_bg_color3"><div class="media inline-block xs-block-media"><div class="media-left media-middle"><img src="../../content/used-images-new/icons/pay.png" alt=""></div><div class="media-body media-middle"><a href="http://hsiidcgis.org.in/hsiidcgis/" class="text_button"><span data-translate="global.menu.Land">Land</span><!--                                <i class="fa fa-arrow-right leftpadding_5"></i>--><br><span data-translate="global.menu.Availability">Availability</span></a></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-2 text-center text-md-left" style="flex-direction: row; margin-left: 40px"><div class="with_padding big-padding gradient_bg_color3"><div class="media inline-block xs-block-media"><div class="media-left media-middle"><img src="../../content/used-images-new/icons/pay.png" alt=""></div><div class="media-body media-middle"><a href="https://hsiidc.bidx.in" class="text_button" target="_blank"><span data-translate="global.menu.HSIIDC">HSIIDC </span><!--                                <i class="fa fa-arrow-right leftpadding_5"></i>--><br><span data-translate="global.menu.e-Auction">e-Auction</span></a></div></div></div></div><div class="col-xs-12 col-sm-6 col-md-2 text-center text-sm-left" style="flex-direction: row; margin-left: 30px"><div class="with_padding big-padding gradient_bg_color1"><div class="media inline-block xs-block-media"><div class="media-left media-middle"><img src="../../content/used-images-new/icons/appointment.png" alt=""></div><div class="media-body media-middle"><a ui-sref="policyFeedbackDashboard" class="text_button"><span data-translate="global.menu.Policy">Policy</span><!--                                <i class="fa fa-arrow-right leftpadding_5"></i>--><br><span data-translate="global.menu.Feedback">Feedback</span></a></div></div></div></div><div class="col-xs-12 col-sm-6 col-md-2 text-center text-sm-left" style="flex-direction: row; margin-left: 28px"><div class="with_padding big-padding gradient_bg_color2"><div class="media inline-block xs-block-media"><div class="media-left media-middle"><img src="../../content/used-images-new/icons/evaluation.png" alt=""></div><div class="media-body media-middle"><a ui-sref="incentivedashboard" class="text_button"><span data-translate="global.menu.Incentive">Incentive</span><!--                                <i class="fa fa-arrow-right leftpadding_5"></i>--><br><span data-translate="global.menu.dashboard">Dashboard</span></a></div></div></div></div><div class="col-xs-12 col-sm-12 col-md-2 text-center text-md-left" style="flex-direction: row; margin-left: 30px"><div class="with_padding big-padding gradient_bg_color3"><div><div class="media inline-block xs-block-media"><div class="media-left media-middle"><img src="../../content/used-images-new/icons/pay.png" alt=""></div><div class="media-body media-middle"><a ui-sref="servicedashboardyearly" class="text_button"><span data-translate="global.menu.Service">Service</span><!--                                    <i class="fa fa-arrow-right leftpadding_5"></i>--><br><span data-translate="global.menu.dashboard">Dashboard</span></a></div></div></div></div></div></div></div></section><section class="ls section_padding_top_50 section_padding_bottom_50"><div class="container-fluid"><div class="row"><div class="col-sm-6 dotted-right-border"><h3 class="text-center gradient_bg_color1 with_padding" data-translate="global.menu.FOCUS SECTORS">FOCUS SECTORS</h3><div class="isotope-item col-xs-12 col-md-4 col-lg-3 text-center"><article class="teaser"><a ng-click="vm.commingSoonPages()"><img src="../../content/used-images-new/focus-sectors/auto.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ng-click="vm.commingSoonPages()" data-translate="global.menu.Auto & Auto Components">Auto & Auto Components</a></h4></article></div><div class="isotope-item col-xs-12 col-md-4 col-lg-3 text-center"><article class="teaser"><a ui-sref="agriculture" ui-sref-opts="{reload: true, notify: true}"><img src="../../content/used-images-new/focus-sectors/agro.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="agriculture" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.Agro & Food Processing">Agro & Food Processing</a></h4></article></div><div class="isotope-item col-xs-12 col-md-4 col-md-3 text-center"><article class="teaser"><a ui-sref="textile" ui-sref-opts="{reload: true, notify: true}"><img src="../../content/used-images-new/focus-sectors/textiles.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="textile" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.Textiles & Apparels">Textiles & Apparels</a></h4></article></div><div class="isotope-item col-xs-12 col-md-4 col-md-3 text-center"><article class="teaser"><a ui-sref="footwearAndAccessory" ui-sref-opts="{reload: true, notify: true}"><img src="../../content/used-images-new/focus-sectors/footwear.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="footwearAndAccessory" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.Footwear & Accessories">Footwear & Accessories<br><br></a></h4></article></div><div class="isotope-item col-xs-12 col-md-4 col-md-3 text-center"><article class="teaser"><a ui-sref="electronicsAndInfo" ui-sref-opts="{reload: true, notify: true}"><img src="../../content/used-images-new/focus-sectors/electronics.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="electronicsAndInfo" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.Electronics & IT/ITES">Electronics & IT/ITES</a></h4></article></div><div class="isotope-item col-xs-12 col-md-4 col-md-3 text-center"><article class="teaser"><a ui-sref="defence" ui-sref-opts="{reload: true, notify: true}"><img src="../../content/used-images-new/focus-sectors/aerospace.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="defence" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.Defence & Aerospace">Defence & Aerospace</a></h4></article></div><div class="isotope-item col-xs-12 col-md-4 col-md-3 text-center"><article class="teaser"><a ui-sref="renewable" ui-sref-opts="{reload: true, notify: true}"><img src="../../content/used-images-new/focus-sectors/solar.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="renewable" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.Renewable Energy & Solar Parks">Renewable Energy & Solar Parks</a></h4></article></div><div class="isotope-item col-xs-12 col-md-4 col-md-3 text-center"><article class="teaser"><a ui-sref="pharmaceuticalAndChemical" ui-sref-opts="{reload: true, notify: true}"><img src="../../content/used-images-new/focus-sectors/pharma.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="pharmaceuticalAndChemical" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.Pharmaceutical & Chemical">Pharmaceutical & Chemical</a></h4></article></div><div class="clearfix"></div></div><div class="col-sm-6"><h3 class="text-center gradient_bg_color3 with_padding text-white" data-translate="global.menu.INVESTMENT OPPORTUNITIES">INVESTMENT OPPORTUNITIES</h3><div class="isotope-item col-xs-12 col-md-6 col-md-4 text-center"><article class="teaser"><a ui-sref="kmpGlobalCorridor" ui-sref-opts="{reload: true, notify: true}"><img src="../../content/used-images-new/service-icons/strategy.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="kmpGlobalCorridor" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.KMP Global Corridor">KMP Global Corridor</a></h4></article></div><div class="isotope-item col-xs-12 col-md-6 col-md-4 text-center"><article class="teaser"><a ui-sref="gurugram" ui-sref-opts="{reload: true, notify: true}"><img src="../../content/used-images-new/service-icons/business.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="gurugram" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.Global City at Gurugram">Global City at Gurugram</a></h4></article></div><div class="isotope-item col-xs-12 col-md-6 col-md-4 text-center"><article class="teaser"><a ui-sref="iMultiModalLogisticsHub" ui-sref-opts="{reload: true, notify: true}"><img src="../../content/used-images-new/service-icons/marketing.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="iMultiModalLogisticsHub" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.Integrated Multi Modal Logistics Hub">Integrated Multi Modal Logistics Hub</a></h4></article></div><div class="isotope-item col-xs-12 col-md-6 col-md-4 text-center"><article class="teaser"><a ng-click="vm.commingSoonPages()"><img src="../../content/used-images-new/service-icons/optimize.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ng-click="vm.commingSoonPages()" data-translate="global.menu.MRTS between Gurugram Manesar Bawal">MRTS between Gurugram Manesar Bawal</a></h4></article></div><div class="isotope-item col-xs-12 col-md-6 col-md-4 text-center"><article class="teaser"><a ng-click="vm.commingSoonPages()"><img src="../../content/used-images-new/service-icons/studies.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="industrialModalTownship" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.Industrial Model Townships">Industrial Model Townships</a></h4></article></div><div class="isotope-item col-xs-12 col-md-6 col-md-4 text-center"><article class="teaser"><a ui-sref="integratedAviationHub" ui-sref-opts="{reload: true, notify: true}"><img src="../../content/used-images-new/service-icons/research.png" alt=""></a><div class="toppadding_5"></div><h4 class="entry-title small"><a ui-sref="integratedAviationHub" ui-sref-opts="{reload: true, notify: true}" data-translate="global.menu.Integrated Aviation Hub">Integrated Aviation Hub</a></h4></article></div></div></div></div></section><div class="container-fluid panel-body"><!-- Indicators --><div id="myCarousel2" class="carousel slide" data-ride="carousel"><!-- Wrapper for slides --><div class="text-center"><h2 class="section_header" data-translate="global.menu.What Clients Say">What Clients Say</h2><hr class="divider_60_2"></div><div class="carousel-inner" style="min-height: 320px" role="listbox"><div class="item active"><blockquote><p class="text-center" data-translate="global.menu.It is really heartening to see the focus of state government on ease of doing business through the single window concept. We really appreciate and thank the government for this initiative.">"It is really heartening to see the focus of state government on ease of doing business through the single window concept. We really appreciate and thank the government for this initiative."</p><div style="margin-top: 20px" class="text-center"><footer class="media inline-block"><div class="media-left media-middle"><img src="../../content/used-images-new/faces/03.jpg" alt=""></div><div class="media-body media-middle"><cite><span data-translate="global.menu.Krish Iyer">Krish Iyer</span> <span class="highlight" data-translate="global.menu.President & CEO, Walmart India">President & CEO, Walmart India</span></cite></div></footer></div></blockquote></div><div class="item"><blockquote><p class="text-center" data-translate="global.menu.We have searched every location in India like Chennai, Bangalore etc. to do local manufacturing. However, we decided to invest in Haryana and during investing period HSIIDC people were really friendly with us, so it was really helpful for us.">"We have searched every location in India like Chennai, Bangalore etc. to do local manufacturing. However, we decided to invest in Haryana and during investing period HSIIDC people were really friendly with us, so it was really helpful for us."</p><div style="margin-top: 20px" class="text-center"><footer class="media inline-block"><div class="media-left media-middle"><img src="../../content/used-images-new/faces/02.jpg" alt=""></div><div class="media-body media-middle"><cite><span data-translate="global.menu.Takahashi San">Takahashi San</span> <span class="highlight" data-translate="global.menu.Head Asia Region, Fujikura Kasei Coatings">Head Asia Region, Fujikura Kasei Coatings</span></cite></div></footer></div></blockquote></div><div class="item"><blockquote><p class="text-center" data-translate="global.menu.We are fully satisfied with HEPC team that assisted in getting various services approved through investharyana. Occupation certificate and building plan approval are some of the important certificates that we have got cleared through invest Haryana. This is definitely a proud beginning of a new era.">"We are fully satisfied with HEPC team that assisted in getting various services approved through investharyana. Occupation certificate and building plan approval are some of the important certificates that we have got cleared through invest Haryana. This is definitely a proud beginning of a new era."</p><div style="margin-top: 20px" class="text-center"><footer class="media inline-block"><div class="media-left media-middle"><img src="../../content/used-images-new/faces/01.jpg" alt=""></div><div class="media-body media-middle"><cite><span data-translate="global.menu.Varinder Pal Singh Kandhari">Varinder Pal Singh Kandhari</span> <span class="highlight" data-translate="global.menu.Chairman, Enrich Agro Food Products">Chairman, Enrich Agro Food Products</span></cite></div></footer></div></blockquote></div></div><ol class="carousel-indicators"><li data-target="#myCarousel2" data-slide-to="0" class="active"></li><li data-target="#myCarousel2" data-slide-to="1"></li><li data-target="#myCarousel2" data-slide-to="2"></li></ol></div></div><div id="advModal" role="dialog" ng-show="vm.isModalVisible"><div class="modal-dialog modal-lg"><!-- Modal content --><div class="modal-content border-0 shadow-lg rounded-3" style="overflow: hidden"><!-- Header --><div class="modal-header bg-primary text-white"><h5 style="color: white" class="fw-bold text-light">Investor Facilitation & MIS Dashboards <span class="pull-right"><b>* Press ESC to continue</b></span>&nbsp; &nbsp;</h5><!--                <small class="me-3 text-light pull-lg-right"><b>* Press ESC to continue</b>&nbsp; &nbsp;   <button type="button" class="btn btn-light pull-lg-right" ng-click="vm.clear()">X</button></small>--><!--                <div class="ms-auto d-flex align-items-center">--><!--                    <small class="me-3 text-light"><b>* Press ESC to continue</b></small>--><!--                    <button type="button" class="btn btn-sm btn-light" ng-click="vm.clear()">X</button>--><!--                </div>--></div><!-- Body --><div class="modal-body bg-light"><div class="row g-4 text-center"><!-- Module 3: Policy Dashboard --><div class="col-md-6 col-lg-3"><div class="card border-0 shadow-sm h-100 hover-shadow"><div class="card-body"><div class="mb-3 text-info"><i class="glyphicon glyphicon-stats" style="font-size: 36px"></i></div><h6 class="fw-bold mb-2">Policy Dashboard</h6><p class="text-muted small">View state policies, incentives, and active schemes for investors.</p><a href="#/policy-dashboard" ng-click="vm.clear()" class="btn btn-info btn-sm mt-2">Open Module</a></div></div></div><!-- Module 2: Intent To Invest --><div class="col-md-6 col-lg-3"><div class="card border-0 shadow-sm h-100 hover-shadow"><div class="card-body"><div class="mb-3 text-success"><i class="glyphicon glyphicon-briefcase" style="font-size: 36px"></i></div><h6 class="fw-bold mb-2">Intent To Invest</h6><p class="text-muted small">Submit and track investment intentions and project details.</p><a href="#/intent-to-invest" ng-click="vm.clear()" class="btn btn-success btn-sm mt-2">Open Module</a></div></div></div><!-- Module 4: Central Inspection System --><div class="col-md-6 col-lg-3"><div class="card border-0 shadow-sm h-100 hover-shadow"><div class="card-body"><div class="mb-3 text-warning"><i class="glyphicon glyphicon-search" style="font-size: 36px"></i></div><h6 class="fw-bold mb-2">Inspection Dashboard</h6><p class="text-muted small">Manage and monitor inspections across multiple departments.</p><a href="https://cisharyana.in/" target="_blank" ng-click="vm.clear()" class="btn btn-warning btn-sm mt-2">Open Module</a></div></div></div><!-- Module 1: Month-wise Filter --><div class="col-md-6 col-lg-3"><div class="card border-0 shadow-sm h-100 hover-shadow"><div class="card-body"><div class="mb-3 text-primary"><i class="glyphicon glyphicon-calendar" style="font-size: 36px"></i></div><h6 class="fw-bold mb-2">MIS:Month-wise Filter</h6><p class="text-muted small">Filter and analyze service data month by month.</p><br><a href="#/dashboardbetweendates" ng-click="vm.clear()" class="btn btn-primary btn-sm mt-2">Open Module</a></div></div></div></div></div><!-- Footer --><div class="modal-footer bg-light"><button type="button" class="btn btn-secondary btn-sm" ng-click="vm.clear()">Close</button></div></div></div></div><!-- Chatbot Floating Button --><div class="chatbot-btn" ng-click="vm.toggleChat()"><i class="glyphicon glyphicon-comment"></i></div><!-- Chatbot Window --><div class="chatbot-box" ng-show="vm.chatVisible"><div class="chatbot-header bg-primary text-white d-flex justify-content-between align-items-center"><h5 class="mb-0">Ask to HEPC Support Team</h5><button type="button" class="btn btn-light btn-sm pull-right" ng-click="vm.toggleChat()">X</button></div><div class="chatbot-body p-3"><!-- Step 1: Select Topic --><div ng-if="!vm.selectedTopic"><br><p class="fw-bold text-secondary mb-2"><b>Please select a topic:</b></p><div class="list-group"><button class="list-group-item list-group-item-action" ng-repeat="topic in vm.topics" ng-click="vm.selectTopic(topic)">{{topic.name}}</button></div></div><!-- Step 2: Show Questions --><div ng-if="vm.selectedTopic && !vm.selectedQuestion"><p class="fw-bold text-secondary mb-2">Topic: <span class="text-primary">{{vm.selectedTopic.name}}</span></p><div class="list-group"><button class="list-group-item list-group-item-action" ng-repeat="question in vm.selectedTopic.questions" ng-click="vm.selectQuestion(question)">{{question.q}}</button></div><button class="btn btn-primary mt-3" ng-click="vm.backToTopics()">\u2190 Back to topics</button></div><!-- Step 3: Show Answer --><div ng-if="vm.selectedQuestion"><p class="fw-bold text-secondary">You asked:</p><div class="alert alert-info">{{vm.selectedQuestion.q}}</div><p class="fw-bold text-secondary">Chatbot says:</p><div class="alert alert-success">{{vm.selectedQuestion.a}}</div><button class="btn btn-primary" ng-click="vm.backToQuestions()">\u2190 Back to questions</button></div></div></div><style>.badge-warning { background-color: red!important }\n    .blink_me {\n        animation: blinker 2s linear infinite;\n    }\n\n    @keyframes blinker {\n        50% {\n            opacity: 0;\n        }\n    }</style>');
$templateCache.put('app/home/iMultiModalLogisticsHub.html','<script>ga(\'set\', \'page\', "/iMultiModalLogisticsHub");ga(\'send\',\'pageview\');</script><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Integrated Multi Modal Logistics Hub</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investment Opportunities</span></li><li class="active"><span>Integrated Multi Modal Logistics Hub</span></li></ol></div></section><div class="container-fluid"><section class="ls"><div class="container"><div class="row"><div class="col-md-12"><div class="col-md-6"><h5 class="gradient_bg_color1 text-center" style="color: white; padding: 10px;font-size: 20px">Salient features</h5><ul style="margin-top: 50px"><li>To be developed as the <b>largest logistics hub in North India</b> over <b>1200 acres at Nangal Chaudhary</b>, Narnaul</li><li><b>Envisaged Investment of about INR</b> 5000 crore</li><li><b>260 crore fund has been approved by Union Cabinet </b>and it will soon be released to the SPV</li><li>Has the potential to <b>significantly reduce the goods movement time</b></li><li>To be implemented as a 50:50 joint venture between HSIIDC and DMICDC/DMIC Trust \u2013 DMIC Haryana Multi Modal Logistic Hub Project Limited</li><li>Site abutting the Delhi Mumbai Dedicated Freight Corridor passing through Haryana</li></ul></div><div class="col-md-6"><img src="../../content/used-images-newintegratedMultiModalLogistics.png"></div></div></div></div></section></div>');
$templateCache.put('app/home/industrialModalTownship.html','<script>ga(\'create\',\'UA-138860801-1\',\'auto\');ga(\'set\', \'page\',\'/industrialModalTownship\');ga(\'send\',\'pageview\');</script><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Industrial Model Township</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investment Opportunities</span></li><li class="active"><span>Industrial Model Township</span></li></ol></div></section><div class="container-fluid"><section class="ls"><div class="container"><div class="row"><div class="col-md-12"><div class="col-md-6"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Industrial Model Township (IMT), Sohna, Haryana</h5><p>HSIIDC, a state government undertaking, has decided to venture into a Joint Development of an Integrated Industrial Model Township at Sohna under the Public Private Partnership (PPP) Model</p><p>HSIIDC is exploring the possibility of partnering with the world\u2019s best in the field for development of state-of-the-art industrial infrastructure through International Competitive Bidding (ICB).</p><div class="col-md-6"><h5 class="text-center gradient_bg_color1" style="color: white; padding: 10px;font-size: 20px">Location</h5><ul><li>Mewat region</li><li><b>Located on the junction of Gurgaon - Alwar road & Kundli-Manesar-Palwal Expressway</b></li></ul></div><div class="col-md-6"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">AREA</h5><ul><li>Total land: <b>1406 acres</b></li></ul><li>Project land (1,292 Acres)</li><li>100 m Green Belt (79 Acre)</li><li>50 m Orbital rail (34 Acres)</li></div></div><div class="col-md-6 text-center"><img src="../../content/used-images-new/industrialModelTownship.png"></div></div><div class="col-md-12"><h5 class="text-center gradient_bg_color1" style="color: white; padding: 10px;font-size: 20px">Footwear Park Industrial Model Township (IMT), KHARKHODA</h5></div></div></div></section></div>');
$templateCache.put('app/home/industrial_powerhouse.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Industrial Powerhouse</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Why Haryana</span></li><li class="active"><span>Industrial Powerhouse</span></li></ol></div></section><div class="with_background gradient_bg_color1 col-md-12"><div class="col-md-12 text-center"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li><a ui-sref="conducive_ecosystem">Conducive Ecosystem</a></li><li><a ui-sref="booming_economy">Booming Economy</a></li><li class="active"><a ui-sref="industrial_powerhouse">Industrial Powerhouse</a></li><li><a ui-sref="supportive_government">Supportive Government</a></li><li><a ui-sref="qualityOfLife">Quality Of Life</a></li></ul></nav></div></div><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container"><div class="row"><div class="col-sm-12"><p>Haryana is one of the most prominent states in terms of industrial production, specially passenger cars, two- wheelers, mobile cranes and tractors. Haryana is also the second-largest contributor of food grains to India\u2019s central pool and accounts for more than 60 per cent of the export of Basmati rice in the country,is the third- largest exporter of software and is one of the preferred destinations for IT/ITeS facilities. The state has invested in the development of world class infrastructure facilities such as special economic zones (SEZs), Kundli-Manesar-Palwal (KMP) global corridor and Delhi- Mumbai Industrial Corridor (DMIC). Haryana enjoys a locational advantage, with nearly one-third of the state\u2019s area under the National Capital Region (NCR), a prominent trade and consumption center.</p><div class="col-md-6 col-md-offset-6"><img src="../../content/used-images-new/hepc_industrial1.png"></div><ul class="col-md-6"><li>Industrial Model Townships: IMT Rohtak, IMT Faridabad, IMT Kharkhoda, IMT Mewat , IMT Bawal , IMT Manesar</li><li>Industrial Corridors : 60% of the state is flanked by: Delhi Mumbai Industrial Corridor (DMIC) on the northern side and Amritsar Kolkata Industrial Corridor (AKIC) on the southern side.</li><li>Kundli-Manesar-Palwal (KMP) Expressway will provide an opportunity for huge investments.</li></ul><div class="col-md-6"><img src="../../content/used-images-new/haryana_new.png" style="width: 100%" alt="Haryana Map"></div><table class="table table_template table-striped"><thead><tr><th class="text-center">Segment</th><th class="text-center">Details</th></tr></thead><tbody><tr><td class="text-center">Agriculture</td><td>Haryana is the second largest contributor of food grains to India\u2019s central pool</td></tr><tr><td class="text-center">BPO</td><td>Highest concentration of BPO workforce in the world in Gurgaon \u2013 5% of the world</td></tr><tr><td class="text-center">Automobile</td><td>Contributes to Two-thirds of passenger cars, 50% of tractors and 60% of motorcycles manufactured in the country. Home to Maruti Udyog Ltd, India\u2019s largest passenger car manufacturer & Hero MotoCorp Ltd, the world\'s largest manufacturer of 2-wheelers</td></tr><tr><td class="text-center">Export</td><td>Contributes to 60% of Basmati Rice exports from the country</td></tr><tr><td class="text-center">IT/ITeS</td><td>Haryana is the third-largest exporter of software and one of the preferred destinations for IT/ITeS facilities</td></tr><tr><td class="text-center">Manufacturing</td><td>Contributes to 50% of the refrigerators manufactured in the country</td></tr><tr><td class="text-center">Textile</td><td>Abundant availability of raw materials gives Haryana a competitive advantage in the textile sector<br>Readymade garments worth around US$ 1.3 billion exported from Haryana annually, providing employment to around one million workers.</td></tr><tr><td class="text-center">Real Estate</td><td>Gurugram accounts for more than 70% of the new commercial space coming up in the NCR and is registering the fastest growth in the real estate sector in India.</td></tr></tbody></table></div></div></div></div></div></div></section>');
$templateCache.put('app/home/information.html','<br><div class="new-section"><div class="container-fluid"><div class="row"><div class="col-md-3"><strong><span style="color:#990000; font-size: 20px">Information</span></strong><br><div class="row"><div class="col-md-2" style="padding-right: 0px"><img src="../../content/used-images-new/Capture2.jpg" alt="" title="" class="img-responsive"></div><div class="col-md-10" style="margin-left:-19px"><br><a href=""><p class="font19">Acts/Policies</p></a><a href=""><p class="font19">Land Bank</p></a><a href=""><p class="font19">Forms/Fees</p></a><a href=""><p class="font19">Comprehensive List of Approvals</p></a><a href=""><p class="font19">Focus Area</p></a><a href=""><p class="font19">FAQs</p></a></div></div></div><div class="col-md-8"><div class="well"><a href="../../content/pdfs/AllServicesBoilers.pdf" target="_blank">Boiler</a></div></div></div></div></div><br><br><br><br>');
$templateCache.put('app/home/integratedAviationHub.html','<script>ga(\'set\', \'page\',\'/integratedAviationHub\');ga(\'send\',\'pageview\');</script><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Integrated Aviation Hub</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investment Opportunities</span></li><li class="active"><span>Integrated Aviation Hub</span></li></ol></div></section><div class="container-fluid"><section class="ls"><div class="container"><div class="row"><div class="col-md-12"><div class="col-md-8"><h5 class="gradient_bg_color1 text-center" style="color: white; padding: 10px;font-size: 20px">Salient features</h5><ul style="margin-top: 50px"><li>Aviation Hub is being developed over 4200 acres of land</li><li>Six Lane Controlled access Highway from Delhi to Hisar</li><li>Rapid Rail Connectivity is under construction (to be extended up to Airport)</li><li>MoU signed with Spice Jet</li><li>Great opportunities for logistics sector</li></ul><img src="../../content/used-images-new/integratedAviationHub3.png" width="700"></div><div class="col-md-4"><img src="" height="853"> <img src="../../content/used-images-new/integratedAviationHub2.jpg" height="853"></div></div></div></div></section></div>');
$templateCache.put('app/home/investor_services.html','<div class="new-section"><br><div class="container-fluid"><div class="row"><div class="col-md-3"><strong><span style="color:#990000; font-size: 20px">Haryana</span></strong><br><div class="row"><div class="col-md-2" style="padding-right: 0px"><img src="../../content/used-images-new/Capture1.jpg" alt="" title="" class="img-responsive"></div><div class="col-md-10" style="margin-left:-19px"><br><a ng-click="vm.login()"><p class="font19">Investor Login/Registration</p></a><br><a target="_blank" href=""><p class="font19">How to Apply</p></a><br><a ui-sref="Questionnaire"><p class="font19">Know Your Approvals</p></a><br><a href="industrial.php"><p class="font19">Application Procedure</p></a><br><a ui-sref="servicedashboard"><p class="font19">Service Dashboard</p></a><br><a href="https://haryanaindustries.gov.in/msme/site/login" target="_blank"><p class="font19">Incentives</p></a><br></div></div></div><div class="col-md-8"><h3 style="color: #a0233d">Detailed Procedure from Application Submission till Application Approval</h3><br><img src="../../content/used-images-new/investor-services.jpg" alt="" class="img-responsive"></div></div></div></div><br><br><br><br>');
$templateCache.put('app/home/investorfacilitationcell.html','<!DOCTYPE html><html><body><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Investor facilitation cell</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Investor facilitation cell</span></li></ol></div></section><br><div class="new-section"><div class="container-fluid text-center"><strong><span style="color:#990000">How to Apply-Application Procedure</span></strong><br><div class="with_background gradient_bg_color1 col-md-12"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li class="active"><a ui-sref="investorfacilitationcell"><p class="font19">Investor facilitation cell</p></a></li><li><a ui-sref="caffillingguide"><p class="font19">CAF filling guide</p></a></li><li><a ui-sref="serviceapplicationguide"><p class="font19">Application Approval Process</p></a></li></ul></nav></div><div class="row"><div class="col-md-12" style="padding-right: 0px"><img src="../../content/used-images-new/IFC.jpg" alt="" title="" class="img-responsive"></div></div></div></div><br><br><br><br></body></html>');
$templateCache.put('app/home/kmpGlobalCorridor.html','<script>ga(\'set\', \'page\', \'/kmpGlobalCorridor\');ga(\'send\',\'pageview\');</script><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">KMP Global Corridor</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investment Opportunities</span></li><li class="active"><span>KMP Global Corridor</span></li></ol></div></section><div class="container-fluid"><section class="ls"><div class="container"><div class="row"><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">KMP Global Corridor</h5><div class="col-md-6"><h5 class="gradient_bg_color1 text-center" style="color: white; padding: 10px;font-size: 20px">Salient features</h5><ul style="margin-top: 50px; margin-bottom: 95px"><li><b>Kundli-Manesar-Palwal expressway is 135.65 km</b> expressway to decongest traffic entering Delhi</li><br><li>A Global Economic Corridor to be developed <b>within 1 KM area on either side of the expressway</b></li><br><li>KMP Global Economic Corridor planned along its alignment with <b>investment potential of close to US$ 10 Bn</b></li><br><li><b>Fully operational expressway;</b> Recently launched by Hon\u2019ble Prime Minister on 19th Nov, 2018</li></ul></div><div class="col-md-6 text-center"><img src="../../content/used-images-new/kmp1.png" width="400" height="400"></div></div></div></div></section><section class="ls"><div class="container"><div class="row"><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Panchgram City development across KMP Global Corridor</h5><div class="col-md-6"><h5 class="gradient_bg_color1 text-center" style="color: white; padding: 10px;font-size: 20px">Salient features</h5><ul style="margin-top: 90px; margin-bottom: 95px"><li>Government of Haryana to <b>develop five new cities in an area of 2.5 lac hectares</b> as part of <b>\u2018Panchgram\u2019 vision</b></li><li>Each city to accommodate on an average <b>~15-18 lac people</b></li><li><b>Core group constituted</b> to develop these five new cities around Kundli- Manesar- Palwal corridor</li><li><b>Panchgram authority vested with required powers</b> so as to expedite and fast track the project completion</li><li>Boundaries of the new cities to be towards Delhi and UP borders</li><li>Planning of the <b>\u2018Panchgram\u2019</b> based on the <b>trends of rapid urbanization</b></li></ul></div><div class="col-md-6 text-center"><img src="../../content/used-images-new/kmp7.png"></div></div></div></div></section><section class="ls"><div class="row"><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Development Options along KMP</h5><div class="container"><div class="row"><div class="col-md-12"><div class="col-md-4"><h6 class="text-center gradient_bg_color1" style="padding: 10px;font-size: 20px">Metro Corridor Along KMP</h6><img src="../../content/used-images-new/kmpdevelopment1.png" style="height: 289px; min-width: 362px"></div><div class="col-md-4"><h6 class="text-center gradient_bg_color3 text-white" style="padding: 10px;font-size: 20px">Metro Rail Cluster</h6><img src="../../content/used-images-new/kmpdevelopment2.png" style="height: 289px; min-width: 362px"></div><div class="col-md-4"><h6 class="text-center gradient_bg_color1" style="padding: 10px;font-size: 20px">Auto Cluster</h6><img src="../../content/used-images-new/kmpdevelopment3.png" style="height: 289px; min-width: 362px"></div></div><div class="col-md-12"><div class="col-md-4"><h6 class="text-center gradient_bg_color3 text-white" style="padding: 10px;font-size: 20px">FTWZ cum Warehousing Cluster</h6><img src="../../content/used-images-new/kmpdevelopment4.png" style="height: 289px; min-width: 362px"></div><div class="col-md-4"><h6 class="text-center gradient_bg_color1 text-white" style="padding: 10px;font-size: 20px">Agri\u2013Business Cluster</h6><img src="../../content/used-images-new/kmpdevelopment5.png" style="height: 289px; min-width: 362px"></div><div class="col-md-4"><h6 class="text-center gradient_bg_color3 text-white" style="padding: 10px;font-size: 20px">Techno \u2013 City</h6><img src="../../content/used-images-new/kmpdevelopment6.png" style="height: 289px; min-width: 362px"></div></div></div></div></div></div></section><section><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key hubs for development by potential Master Planners/Developers across the KMP</h5><table class="table table_template table-striped"><thead><tr><th class="text-center">#</th><th class="text-center">Development Hub / Clusters</th><th class="text-center">Area (acre)</th><th class="text-center">Location</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">Education Hub (A)</td><td class="text-center">2,005</td><td class="text-center">Kundli</td></tr><tr><td class="text-center">2</td><td class="text-center">Cyber Hub (A)</td><td class="text-center">526</td><td class="text-center">Kundli</td></tr><tr><td class="text-center">3</td><td class="text-center">Sports Hub (A)</td><td class="text-center">610</td><td class="text-center">Kundli</td></tr><tr><td class="text-center">4</td><td class="text-center">Agri Business Cluster (A)</td><td class="text-center">600</td><td class="text-center">Kundli</td></tr><tr><td class="text-center">5</td><td class="text-center">Bio Science Hub (A)</td><td class="text-center">2,642</td><td class="text-center">Sampla</td></tr><tr><td class="text-center">6</td><td class="text-center">Medical Hub (B)</td><td class="text-center">926</td><td class="text-center">Sampla</td></tr><tr><td class="text-center">7</td><td class="text-center">Metro Rail Cluster (B)</td><td class="text-center">600</td><td class="text-center">Sampla</td></tr><tr><td class="text-center">8</td><td class="text-center">Auto Cluster (C)</td><td class="text-center">1,100</td><td class="text-center">Badli</td></tr><tr><td class="text-center">9</td><td class="text-center">Retail Merchandizer Hub (D)</td><td class="text-center">543</td><td class="text-center">Manesar</td></tr><tr><td class="text-center">10</td><td class="text-center">Sports Hub (D)</td><td class="text-center">711</td><td class="text-center">Manesar</td></tr><tr><td class="text-center">11</td><td class="text-center">Entertainment Hub (D)</td><td class="text-center">345</td><td class="text-center">Manesar</td></tr><tr><td class="text-center">12</td><td class="text-center">World Trade Hub (D)</td><td class="text-center">691</td><td class="text-center">Manesar</td></tr><tr><td class="text-center">13</td><td class="text-center">FTWZ cum Warehousing Hub(D)</td><td class="text-center">1,000</td><td class="text-center">Manesar</td></tr><tr><td class="text-center">14</td><td class="text-center">Techno City (E)</td><td class="text-center">2,000</td><td class="text-center">Manesar</td></tr><tr><td class="text-center">15</td><td class="text-center">Dry Port City (G)</td><td class="text-center">2,507</td><td class="text-center">Prithla</td></tr><tr><td class="text-center">16</td><td class="text-center">Leisure City (F)</td><td class="text-center">691</td><td class="text-center">Sohna</td></tr><tr><td class="text-center">17</td><td class="text-center">Leisure City (F)</td><td class="text-center">1,852</td><td class="text-center">Sohna</td></tr></tbody></table></div></section></div>');
$templateCache.put('app/home/landCAFpromotion.html','<div class="bs-example-modal-lg" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"><div class="panel panel-info"><div class="panel-heading" style="font-size: 20px"><b>Land Allotment Services</b></div><div class="panel-body"><div class="alert alert-info" style="font-size: 20px">In order to take Industrial Land Allotment Services, Please fill a Land Requirement CAF.</div></div></div></div>');
$templateCache.put('app/home/meetOurExperts.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Meet Our Experts</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Meet Our Experts</span></li></ol></div></section><br><div class="container"><table class="table table_template table-striped"><thead><tr><th class="text-center">Sr.No.</th><th class="text-center">Name</th><th class="text-center">Assigned Sector/ Area</th><th class="text-center">Email Address</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">Sh. Sunil Kumar</td><td class="text-center">Agro/ Food Processing & Allied Industries</td><td class="text-center">hepcnodalofficerfw@gmail.com</td></tr><tr><td class="text-center">2</td><td class="text-center">Ms. Priyam Bhardwaj</td><td class="text-center">Footwear & Accessories</td><td class="text-center">atp.hqps.tcp@gmail.com</td></tr><tr><td class="text-center">3</td><td class="text-center">Sh. Nipun Gupta</td><td class="text-center">Auto, Auto Components & Light Engineering</td><td class="text-center">hspcbho@gmail.com</td></tr><tr><td class="text-center">4</td><td class="text-center">Sh. Mahavir Singh</td><td class="text-center">Defense and Aerospace Manufacturing</td><td class="text-center">mahas61@rediffmail.com</td></tr><tr><td class="text-center">5</td><td class="text-center">Ms. Mamta Joshi</td><td class="text-center">Textile, Apparel, Knitting, Embroidery</td><td class="text-center">joshi.mamta47@yahoo.com</td></tr><tr><td class="text-center">6</td><td class="text-center">Sh. Anupam Katiyar</td><td class="text-center">Renewable Energy/ Solar Parks</td><td class="text-center">nohepcuhdh@gmail.com</td></tr><tr><td class="text-center">7</td><td class="text-center">Sh. Rajesh Khyalia</td><td class="text-center">Pharmaceuticals</td><td class="text-center">khyaliarajesh44@gmail.com</td></tr><tr><td class="text-center">8</td><td class="text-center">Sh. Vikram Singla</td><td class="text-center">Publicity, Markrting & Branding</td><td class="text-center"></td></tr><tr><td class="text-center">9</td><td class="text-center">Sh. Dharmendar Singh</td><td class="text-center">Incharge, Social Media & responding to Grievances on social media</td><td class="text-center">c3dharmender@gmail.com</td></tr></tbody></table><table class="table table_template mt-5 table-striped"><thead><tr><th class="text-center">Sr.No.</th><th class="text-center">Name</th><th class="text-center">Cell</th><th class="text-center">Email Address</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">Ms. Priyanka Vashisht</td><td class="text-center">Facilitation & Monitoring Cell, Aftercare and Grievance Handling</td><td class="text-center">priyankav.hepc@gmail.com</td></tr><tr><td class="text-center">2</td><td class="text-center">Mr. Gaurav Kapoor</td><td class="text-center">Investment Promotion, Targeting and Branding, Research and Misc. issues</td><td class="text-center">gauravk.hepc@gmail.com</td></tr><tr><td class="text-center">3</td><td class="text-center">Ms. Surbhi Sharma</td><td class="text-center">Mega Projects, Policy Matters, Social Media, Helpdesk</td><td class="text-center">surbhi.hepc@gmail.com</td></tr></tbody></table></div>');
$templateCache.put('app/home/news_gallery.html','<div class="container-fluid" ng-repeat="imageFile in vm.imageFiles track by $index"><br><img ng-src="api/getimage?name={{ imageFile.description }}" width="900px" height="500px"><br><br></div>');
$templateCache.put('app/home/org_structure.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Organization Structure</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>About Us</span></li><li class="active"><span>Organization Structure</span></li></ol></div></section><div class="with_background gradient_bg_color1 col-md-12"><div class="col-md-2"></div><div class="col-md-10"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li><a ui-sref="aboutHEPC">About HEPC</a></li><li class="active"><a ui-sref="org_structure">Organization Structure</a></li><!--<li> <a ui-sref="CM_Message">CM Message</a> </li>--><li><a ui-sref="mission">Mission & Vision</a></li></ul></nav></div></div><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container text-center"><h5 class="gradient_bg_color3" style="color: white; padding:10px; margin-top: 20px">Organisation Structure</h5><br><img src="../../content/used-images-new/orgStrctNew.png"></div><!--                <div class="container text-center">--><!--                    <h5 class="gradient_bg_color3" style="color: white; padding:10px; margin-top: 20px">Organisation structure \u2013 HEPC</h5>--><!--                    <img src="../../content/used-images-new/OrgStrct2.png">--><!--                </div>--><!--                <div class="container text-center">--><!--                    <h5 class="gradient_bg_color3" style="color: white; padding:10px; margin-top: 20px">Organisation Structure- BIPP</h5>--><!--                    <img src="../../content/used-images-new/OrgStrct3.png">--><!--                </div>--></div></div></div></section>');
$templateCache.put('app/home/participating_department.html','<!DOCTYPE html><html><!--<head>--><!--<title> Demo for all bootstrap </title>--><!--<link rel="stylesheet" type="text/css" href="css/bootstrap.min.css">--><!--<link rel="stylesheet" type="text/css" href="css/font-awesome.css">--><!--<link rel="stylesheet" type="text/css" href="css/style.css">--><!--</head>--><body><!--<div class="header-1">--><!--<div class="container-fluid bgc-r">--><!--<div class="row">--><!--<div class="col-md-3 col-xs-12">--><!--<p class="font14">Toll  Free  Helpline <br>--><!--1800-180-2132</p>--><!--</div>--><!--<div class="col-md-6"></div>--><!--<div class="col-md-3"></div>--><!--</div>--><!--</div>   --><!--</div>--><!--<div class="header-2">--><!--<div class="container-fluid">--><!--<div class="second-box">--><!--<div class="row">--><!--<div class="col-md-3">--><!--<div class="logo-site">--><!--<img src="img/logo.PNG" alt="logo-hepc" title="logo" class="img-responsive center-block">--><!--</div>--><!--</div>--><!--<div class="col-md-6">--><!--<div class="text-main text-center">--><!--<p class="font15">Department of Industries<br> Haryana Enterprise Promotion Center</p>--><!----><!--</div>--><!--</div>--><!--<div class="col-md-1"></div>--><!--<div class="col-md-2">--><!--<div class="second-logo">--><!--<img src="img/logo-gov.PNG" class="img-responsive center-block" alt="logo-gov" title="logogov">--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>  --><!--<div class="navbar-box">--><!--<div class="container-fluid">--><!--<div class="row">--><!--<header id="header">--><!--<nav class="navbar">--><!--<div class="container-fluid bgc-r">--><!--<div class="navbar-header">--><!--<button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">--><!--<span class="icon-bar"></span>--><!--<span class="icon-bar"></span>--><!--<span class="icon-bar"></span>--><!--</button>--><!--</div>--><!--<div class="collapse navbar-collapse" id="myNavbar">--><!--<ul class="nav navbar-nav">--><!--<li><a class="active" href="#"> About Us</a></li>--><!--<li><a href="#"> Haryana</a></li>--><!--<li><a href="#">Investor Service</a></li>--><!--<li><a href="#">Information</a></li>--><!--<li><a href="#">News &amp; Gallery</a></li>--><!--<li><a href="#">Login</a></li>--><!--<li style="border-right: 1px solid transparent;"><a href="#">Contact</a></li>--><!----><!--</ul>--><!--</div>--><!--</div>--><!--</nav>--><!--</header>--><!--</div>--><!--</div>--><!--</div>--><br><div class="new-section"><div class="container-fluid"><div class="row"><div class="col-md-3"><strong><span style="color:#990000; font-size: 20px">About Us</span></strong><br><div class="row"><div class="col-md-2" style="padding-right: 0px"><img src="../../content/used-images-new/Capture.jpg" alt="" title="" class="img-responsive"></div><div class="col-md-10" style="margin-left:-19px"><br><a ui-sref="about"><p class="font19">About HEPC</p></a><br><!--<a ui-sref="CM_Message"><p class="font19">CM Messages</p></a>--><br><a ui-sref="mission"><p class="font19">Mission & Vision</p></a><br><a ui-sref="participating_department"><p class="font19">Participating Department</p></a></div></div></div><div class="col-md-9"><img src="../../content/used-images-new/participatingdepartment.jpg" alt="" style="margin-left:auto; margin-right:auto; display:block"><br><p style="font-size:16px">63 services from 12 Departments are provided online through HEPC Portal - www.investharyana.in. Nodal officers from 12 departments are deployed here in HEPC. Haryana is first state to have all the departments sitting under oneroof to facilitate Investors who fill application for state industrial clearances.</p><br><p style="font-size:16px"><strong>Following are the participating departments:</strong></p><br><ul style="font-size:16px"><li>Uttar/Dakshin Haryana Bijli Vitran Nigam</li><li>Town and Country Planning</li><li>Environment Department/Haryana State Pollution Control Board</li><li>Labour Department/Chief inspector of Factories</li><li>Industries and Commerce Department</li><li>Directorate of Health Services</li><li>Excise and Taxation</li><li>Haryana State Industrial Development Corporation Ltd</li><li>Haryana Urban Local Bodies Department</li><li>Revenue Department</li><li>Non-Conventional Energy/Renewal Energy Department</li><li>Food and Supply Department</li></ul></div></div></div></div><br><br><br><br><!--<div class="container bgc-g">--><!--<div class="footer">--><!--<div class="row">--><!--<div class="col-md-4">--><!--<p>Disclamer</p>--><!--<p>Privacy Policy</p>--><!--<p>Hyperlinking Policy</p>--><!--<p>Copyright Statement</p>--><!--<p>Terms of Use</p>--><!--<p>Sitemap</p>--><!--</div>--><!--<div class="col-md-4">--><!--<p>Citizen Corner</p>--><!--<p>Feedback</p>--><!--<p>Content Review Policy</p>--><!--<p>Content Approval</p>--><!--<p>Content archival</p>--><!--<p>FAQ\'s</p>--><!--</div>--><!--<div class="col-md-4">--><!--<img src="img/logo_1.png" alt="" title="" class="img-responsive"><br>--><!--<p><strong>Visiter Count:</strong> 00-005-27-7</p>--><!--<p><strong>Last Update on: </strong> 6 July 2017</p>--><!--<p><strong>Site Best View In:</strong> Google Chrome, IE, Firefox </p>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<br>--><!--<div class="header-1">--><!--<div class="container-fluid bgc-r">--><!--<p>&nbsp;</p><p>&nbsp;</p>--><!--</div>--><!--</div>--><!--<script type="text/javascript" src="js/jquery.js"></script>--><!--<script type="text/javascript" src="js/bootstrap.min.js"></script>--><!--<script type="text/javascript" src="js/script.js"></script>--></body></html>');
$templateCache.put('app/home/pharmaceuticalAndChemical.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Pharmaceutical & Chemical</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Focus Sectors</span></li><li class="active"><span>Pharmaceutical & Chemical</span></li></ol></div></section><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container-fluid"><div class="row"><div class="col-sm-12"><img src="../../content/used-images-new/pharmaceutical.jpg" style="width: 100%; height: 300px"></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Highlights</h5></div><div class="col-md-12"><ul><li>Government of Haryana identifies Pharmaceutical sector as one of the focus sectors</li><li>Leading exporters in the country are present in the state with a total worth of State exports valued at INR 69,485 crores (3 year average-2014-2017)</li><li>Haryana enjoys locational advantage, characterized by its geographical confluence with economic corridors (DMIC, AKIC, and Eastern peripheral corridor), Special Economic Zones, investment regions and big ticket infrastructure projects.</li></ul></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Initiatives</h5></div><div class="col-md-12"><ul><li>100% of the cost of external and internal infrastructure development to be borne by the State Government subject to a ceiling of Rs 50 Cr., to develop a Pharma Park in Karnal</li><li>The Government to provide additional manpower and facilities in terms of State Drug Testing Laboratories.</li><li>The Government will continuously upgrade the State Drug Testing Laboratories, which will be equipped with state-of the-art modern testing equipment and infrastructure.</li><li>The Government of Haryana intends to provide support to the Common Cluster Laboratory established at Karnal which is equipped with modern testing equipment and facilities. This will reduce the cost of testing borne by the units in the Pharma Park and help in assuring the quality of drugs.</li><li>The Government of Haryana will facilitate collaborations and matchmaking between research organizations, pharma industry players and educational institutes.</li></ul></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Incentives</h5><table class="table table_template table-striped"><thead><tr><th class="text-center">INCENTIVES</th><th class="text-center">DETAILS</th></tr></thead><tbody><tr><td class="text-center">Capital Subsidy</td><td><ul><li>Reimbursement of 25% of cost of plant and machinery subject to a maximum of INR 5 Cr</li></ul></td></tr><tr><td class="text-center">Interest Subsidy</td><td><ul><li>To the extent of 5% per annum for 5 years in the form of reimbursement of interest paid on term loan, subject to annual ceiling of INR 50 lakhs per annum per unit</li></ul></td></tr><tr><td class="text-center">Patent cost</td><td><ul><li>Reimbursement of 60% of actual expenses (including filing fees, consultancy fees, search fees and maintenance fees) subject to a maximum of INR 40 lakhs for domestic and international patent registration</li></ul></td></tr></tbody></table></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Investment Opportunities</h5><ul><li>The state intends to establish a Pharma Park at Karnal which is a centrally located district with excellent road (situated on NH-1)/rail (Delhi Ambala broad gage line, where Delhi and Ambala are both junctions) and air connectivity.</li><li>The State government will provide common facilities such as Common Cluster Lab and Common Effluent Treatment Plant for this Park (in the formulations manufacturing zone) with guidelines and designs provided by the Haryana State Pollution Control Board.</li><li>New units setting up in the Pharma Park in Karnal will be eligible for a special package of incentives, in addition to benefits as per Haryana Enterprises Promotion Policy 2015</li></ul></div></div></div></div></div></div></section>');
$templateCache.put('app/home/qualityOfLife.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Quality Of Life</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Why Haryana</span></li><li class="active"><span>Quality Of Life</span></li></ol></div></section><div class="with_background gradient_bg_color1 col-md-12"><div class="col-md-12 text-center"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li><a ui-sref="conducive_ecosystem">Conducive Ecosystem</a></li><li><a ui-sref="booming_economy">Booming Economy</a></li><li><a ui-sref="industrial_powerhouse">Industrial Powerhouse</a></li><li><a ui-sref="supportive_government">Supportive Government</a></li><li class="active"><a ui-sref="qualityOfLife">Quality Of Life</a></li></ul></nav></div></div><div class="container-fluid"><section class="ls"><div class="container"><div class="row"><div class="col-md-6"><button class="btn btn-success pull-right" ng-click="vm.city = \'gurugram\'">Gurugram</button></div><div class="col-md-6"><button class="btn btn-success pull-left" ng-click="vm.city = \'faridabad\'">Faridabad</button></div></div><div class="row" ng-if="vm.city === \'gurugram\'"><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">ABOUT GURUGRAM</h5><div class="col-md-12"><p>District Gurugram is located 30 km south of New Delhi, about 10 Kilometers from Dwarka sub-city and 268 Km south of Chandigarh, the State Capital. The District is one of Delhi\'s\u2019 major satellite cities and is a part of the National Capital Region. It is within commuting distance of Delhi via an expressway and Delhi Metro. Gurugram is the second largest city in Haryana and is also the industrial and financial centre of Haryana. It has the 3rd highest per capita income in India after Chandigarh and Mumbai. It is also the only Indian city to have successfully distributed electricity connections to all its households. Haryana is the IT hub & center of various BPO companies.</p><p>Gurugram District has witnessed a phenomenal growth in all spheres of development, particularly in industry and urbanization. Today, it has become a hub for multinational companies, industry giants, call centres, software companies, shopping malls and skyscrapers. Gurugram is strategically located with its boundaries touching Rajasthan, Uttar Pradesh and Delhi. Its excellent connectivity with other states via Delhi- Jaipur-Ahmedabad broad gauge rail link and NH 8 brings thousands of people to Gurugram for the purpose of work, travel and entertainment. Infact with the collaboration of Suzuki Motors of Japan and Maruti Udyog Limited in early eighties, a new area of rapid industrialization of Gurugram started as a result of which the district came on the world map.</p><p>The Gurugram - Manesar - Bawal belt has emerged as the auto hub of the country, thereby offering ample opportunities to the entrepreneurs. There are many prominent and prestigious units involved in the manufacturing of telecommunication equipments, electrical goods, sports goods, rubber products readymade garments and in software development.</p><p>With its rapid development, Gurugram has emerged as an important District in Haryana and has done the State proud with its achievements. It boasts of the best educational institutions, healthcare facilities and recreational avenues, some of which have been mentioned consequently.</p></div></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">District at a glance</h5><div class="col-md-12 text-center"><div class="col-md-4"><img src="../../content/used-images-new/qualityOfLife1.png"></div><div class="col-md-8"><img src="../../content/used-images-new/qualityOfLife2.png" height="400" width="400"></div></div></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Schools</h5><h6>Gurgaon provides best education facilities to its citizens. It has more than 70 schools , both public and private, offering quality education some of which are as follows:</h6><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color1" style="color: white; padding: 10px;font-size: 20px">Public schools</h5><table class="table table_template table-striped"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">Goverment Primary School, Ghudana, Gurugram</td><td class="text-center">Ghudana, Gurugram</td></tr><tr><td class="text-center">2</td><td class="text-center">Goverment Primary School, Goriyawas, Gurugram</td><td class="text-center">Goriyawas, Gurugram</td></tr><tr><td class="text-center">3</td><td class="text-center">Government Girl Primary School, Khandewla, Gurugram</td><td class="text-center">Khandewla, Gurugram</td></tr><tr><td class="text-center">4</td><td class="text-center">Government Girls Middle School, Birhera, Gurugram</td><td class="text-center">Birhera, Gurugram</td></tr><tr><td class="text-center">5</td><td class="text-center">Government Girls Middle School, Pathreri, Gurugram</td><td class="text-center">Pathreri, Gurugram</td></tr><tr><td class="text-center">6</td><td class="text-center">Government High School, Hazipur, Gurugram</td><td class="text-center">Hazipur, Gurugram</td></tr><tr><td class="text-center">7</td><td class="text-center">Government High School, Ullawas, Gurugram</td><td class="text-center">Ullawas, Gurugram</td></tr><tr><td class="text-center">8</td><td class="text-center">Government Middle School, Darapur, Gurugram</td><td class="text-center">Darapur, Gurugram</td></tr><tr><td class="text-center">9</td><td class="text-center">Government Middle School, Akhlimpur, Gurugram</td><td class="text-center">Akhlimpur, Gurugram</td></tr><tr><td class="text-center">10</td><td class="text-center">Government Middle School, Mubarikpur, Gurugram</td><td class="text-center">Mubarikpur, Gurugram</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color1" style="color: white; padding: 10px;font-size: 20px">International Schools</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name of the School</th><th class="text-center">Address</th><th class="text-center">Phone No</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center"><a target="_blank" href="https://www.gemsindiaschools.com/gurgaon-schools/sector-51-gurgaon/">Little GEMS International</a></td><td class="text-center">Plot No. 9, Next to Artemis Hospital, Mayfield Garden, Sector 51, Gurugram, Haryana 122001</td><td class="text-center">092055 65878</td></tr><tr><td class="text-center">2</td><td class="text-center"><a target="_blank" href="http://www.lis.ac.in/">Lancers International School</a></td><td class="text-center">DLF Phase 5, Sector 53, Gurugram, Haryana 122001</td><td class="text-center">0124 417 1900</td></tr><tr><td class="text-center">3</td><td class="text-center"><a target="_blank" href="https://www.scottishigh.com/">Scottish High International School</a></td><td class="text-center">Near Hongkong Market, Block G, Sushant Lok 2, Sector 57, Gurugram, Haryana 122011</td><td class="text-center">0124 411 2782</td></tr><tr><td class="text-center">4</td><td class="text-center"><a target="_blank" href="http://amity.edu/ais/gurgaon46/">Amity International School</a></td><td class="text-center">Power Grid Complex, Sector 43, Gurugram, Haryana 122022</td><td class="text-center">0124 238 5112</td></tr><tr><td class="text-center">5</td><td class="text-center"><a target="_blank" href="https://www.gemsindiaschools.com/gurgaon-schools/palam-vihar/">GEMS International School</a></td><td class="text-center">C2 Block, Sector 3, Palam Vihar, Gurugram, Haryana 122017</td><td class="text-center">095139 00154</td></tr><tr><td class="text-center">6</td><td class="text-center"><a target="_blank" href="http://www.shalomhills.com/">Shalom Hills International School</a></td><td class="text-center">Sushant Lok Rd, Block C, Sector 52A, Gurugram, Haryana 122002</td><td class="text-center">0124 404 6471</td></tr><tr><td class="text-center">7</td><td class="text-center"><a target="_blank" href="http://www.dpsiedge.edu.in/">DPS International</a></td><td class="text-center">HS-01, Golf Course Ext Rd, Block W, South City II, Sector 50, Gurugram, Haryana 122001</td><td class="text-center">0124 710 0080</td></tr><tr><td class="text-center">8</td><td class="text-center"><a target="_blank" href="http://euroschoolsec10ggn.com/">Euro International School</a></td><td class="text-center">Krishna Nagar, Sector 10, Gurugram, Haryana 122001</td><td class="text-center">098731 14317</td></tr><tr><td class="text-center">9</td><td class="text-center"><a target="_blank" href="http://www.excelsioreducation.org/">Excelsior American School</a></td><td class="text-center">Behind Dell building, Golf Course Road, Phase 1, Sector 43, Gurugram, Haryana 122001</td><td class="text-center">093110 91645</td></tr><tr><td class="text-center">10</td><td class="text-center"><a target="_blank" href="http://ked.edu.in/international/">Kunskapsskolan International School</a></td><td class="text-center">Adjacent to A Gul Farm Complex Gul Farm Sector, Sector 70, Gurugram, Haryana 122004</td><td class="text-center">070273 73737</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Hospitals</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center"><a target="_blank" href="https://www.artemishospitals.com/">Artemis Hospital Gurgaon</a></td><td class="text-center">Sector 51, Gurugram, Haryana 122001</td><td class="text-center">0124 451 1111</td></tr><tr><td class="text-center">2</td><td class="text-center"><a target="_blank" href="http://haryanahealth.nic.in/">Government Hospital</a></td><td class="text-center">Basai Rd, Vikas Nagar, Sector 10, Gurugram, Haryana 122001</td><td class="text-center"></td></tr><tr><td class="text-center">3</td><td class="text-center">Government Hospital</td><td class="text-center">Gurgaon Village, Sector 6, Gurugram Rural, Haryana 122006</td><td class="text-center"></td></tr><tr><td class="text-center">4</td><td class="text-center">Government Hospital, Wazirabad</td><td class="text-center">Wazirabad, Sector 52, Gurugram, Haryana 122022</td><td class="text-center"></td></tr><tr><td class="text-center">5</td><td class="text-center"><a target="_blank" href="http://haryanahealth.nic.in/">Civil Hospital</a></td><td class="text-center">Jharsa Road, Near, Bus Stand Rd, Gurugram, Haryana 122001</td><td class="text-center">0124 233 0102</td></tr><tr><td class="text-center">6</td><td class="text-center">City Hospital</td><td class="text-center">Shiv Mandir,, Mata Rd, West Rajiv Nagar, Sector 12, Gurugram, Haryana 122001</td><td class="text-center"></td></tr><tr><td class="text-center">7</td><td class="text-center"><a target="_blank" href="https://www.maxhealthcare.in/hospital-network/max-hospital-gurgaon">Max Healthcare Hospital</a></td><td class="text-center">B Block, Sushant Lok 1, Near Huda City Centre, Gurugram, Haryana 122001</td><td class="text-center">0124 662 3000</td></tr><tr><td class="text-center">8</td><td class="text-center"><a target="_blank" href="https://www.medanta.org/">Medanta -The Medicity</a></td><td class="text-center">CH Baktawar Singh Road, Sector 38, Gurugram, Haryana 122001</td><td class="text-center">0124 414 1414</td></tr><tr><td class="text-center">9</td><td class="text-center"><a target="_blank" href="https://www.cloudninecare.com/">Cloudnine Hospital</a></td><td class="text-center">Plot No. A-2 MSJ House Beside SS Plaza, Vikas Marg, Mayfield Garden, Sector 47, Gurugram, Haryana 122003</td><td class="text-center">1860 108 9999</td></tr><tr><td class="text-center">10</td><td class="text-center"><a target="_blank" href="https://www.mayomhospital.com/">Mayom Hospital</a></td><td class="text-center">D - Block, Block G, South City I, Sector 41, Gurugram, Haryana 122001</td><td class="text-center">0124 411 1880</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Sports Clubs</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center"><a target="_blank" href="http://www.ryderssports.com/">Ryder\'s Sports Academy</a></td><td class="text-center">DLF Phase 5, Sector 53, Gurugram, Haryana 122003</td><td class="text-center">087440 06913</td></tr><tr><td class="text-center">2</td><td class="text-center"><a target="_blank" href="http://thepolarstarsportsclub.blogspot.com/">The Polar Star Sports Club Cricket Ground</a></td><td class="text-center">To Sohna Rd, Sector 73, Gurugram, Haryana 122004</td><td class="text-center">087504 94545</td></tr><tr><td class="text-center">3</td><td class="text-center"><a href="http://jnssports.in/">J.N.S Sports Academy</a></td><td class="text-center">V.P.O Samaspur, Sector 51, Gurugram, Haryana 122003</td><td class="text-center">099995 06262</td></tr><tr><td class="text-center">4</td><td class="text-center"><a href="http://fastfootballclub.com/">Fast Football Club 2</a></td><td class="text-center">Block Fast football club opposite, SHUSHANT LOK,2 EXT., Golf Course Ext Rd, Block F, Sushant Lok 2, Sector 57, Gurugram, Haryana 122011</td><td class="text-center">099118 73728</td></tr><tr><td class="text-center">5</td><td class="text-center"><a target="_blank" href="http://www.flowsportslife.com/">Flow Sports Life</a></td><td class="text-center">Vipul World - A Block, FLOW Next to F Sec 48, Vipul Greens Internal Rd, Vipul World, Sector 48, Gurugram, Haryana 122001</td><td class="text-center">099580 53174</td></tr><tr><td class="text-center">6</td><td class="text-center"><a href="https://www.pingpongacademy.in/">Ping Pong Academy</a></td><td class="text-center">Part-Gurgaon BS-1049, Sector 15 Part 2, Gurugram, Haryana 122001</td><td class="text-center">098702 84694</td></tr><tr><td class="text-center">7</td><td class="text-center"><a target="_blank" href="https://www.getfitso.com/running-group">Fitso Flash - Tau Devi Lal Park</a></td><td class="text-center">Sector 52A, Gurugram, Haryana 122022</td><td class="text-center">098689 36854</td></tr><tr><td class="text-center">8</td><td class="text-center"><a target="_blank" href="http://avidarcheryclub.com/">Avid Archery Club</a></td><td class="text-center">1571, Carterpuri Rd, Palam Farms, Gurugram, Haryana 110061</td><td class="text-center">099990 42628</td></tr><tr><td class="text-center">9</td><td class="text-center"><a target="_blank" href="https://kick-football-club.business.site/">KICK FOOTBALL CLUB</a></td><td class="text-center">122017, Pocket I, Gurugram, Haryana</td><td class="text-center">098117 12671</td></tr><tr><td class="text-center">10</td><td class="text-center">Jahid Kabaddi Club</td><td class="text-center">Shop No. 6, Opp. HUDA Office, Delhi Rd, Rajiv Nagar, Sector 13, Gurugram, Haryana 122001</td><td class="text-center"></td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Amusement Parks</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center"><a target="_blank" href="http://www.aapnoghar.in/">AapnoGhar</a></td><td class="text-center">Sector 77, Gurugram, Haryana 122004</td><td class="text-center">076667 79997</td></tr><tr><td class="text-center">2</td><td class="text-center"><a target="_blank" href="http://www.appughar.com/">Appu Ghar</a></td><td class="text-center">Appu Ghar Marg, Behind Huda City Metro Station, Sector 29, Gurugram, Haryana 122009</td><td class="text-center">0124 458 1000</td></tr><tr><td class="text-center">3</td><td class="text-center">Oyster\'s Water Park</td><td class="text-center">Leisure Valley Rd, Sector 29, Gurugram, Haryana 122022</td><td class="text-center">0124 458 1000</td></tr><tr><td class="text-center">4</td><td class="text-center"><a href="http://skyjumpertp.com/">SkyJumper Trampoline Park Gurgaon</a></td><td class="text-center">ILD Trade center, Sohna Road, Sector-47, Gurugram, Haryana 122018</td><td class="text-center">088822 88001</td></tr><tr><td class="text-center">5</td><td class="text-center"><a target="_blank" href="https://www.funnfood.com/">Fun N Food Village</a></td><td class="text-center">Old Delhi Gurgaon Rd, Kapashera, New Delhi, Delhi 110097</td><td class="text-center">099900 06518</td></tr><tr><td class="text-center">6</td><td class="text-center"><a href="http://www.wetnwildresorts.com/">Wet n Wild</a></td><td class="text-center">45-Milestone, National Highway 8, Naurangpur Rd, Sector 78, Gurugram, Haryana 122001</td><td class="text-center">0124 481 2100</td></tr><tr><td class="text-center">7</td><td class="text-center"><a target="_blank" href="https://www.thehiddenhour.com/">The Hidden Hour Gurugram - Escape Rooms</a></td><td class="text-center">2nd Floor, Shop No. 50, MGF Metropolis Mall, Mehrauli-Gurgaon Rd, Sector 28, Gurugram, Haryana 122002</td><td class="text-center">083770 94958</td></tr><tr><td class="text-center">8</td><td class="text-center">OBSTACLE PARK</td><td class="text-center">Behind celebration mall Subash chowk, Sohna Rd, Gurugram, Haryana 122002</td><td class="text-center">098990 77066</td></tr><tr><td class="text-center">9</td><td class="text-center"><a target="_blank" href="https://www.thehiddenhour.com/">JoyRides Amusement Park</a></td><td class="text-center">Kingdom of Dreams, Near IFFCO Metro Station, Sector 29, Gurugram, Haryana 122001</td><td class="text-center">081785 58438</td></tr><tr><td class="text-center">10</td><td class="text-center"><a href="http://www.kingdomofdreams.in/">Kingdom of Dreams</a></td><td class="text-center">Auditorium Complex Near IFFCO Metro Station, Sector 29, Gurugram, Haryana 122001</td><td class="text-center">0124 452 8000</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Cinemas</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center"><a target="_blank" href="https://www.inoxmovies.com/">INOX Gurgaon Dreamz</a></td><td class="text-center">3rd Floor Gurgaon Dreamz Mall Old Railway Road, New Railway Road, 7 Circle, Sector 4, Gurugram, Haryana 122001</td><td class="text-center">080802 11111</td></tr><tr><td class="text-center">2</td><td class="text-center"><a target="_blank" href="https://www.pvrcinemas.com/">PVR</a></td><td class="text-center">MGF Metropolitan Mall, DLF City Phase II, MG Rd, Heritage City, Sector 25, Gurugram, Haryana 122002</td><td class="text-center">0124 470 8100</td></tr><tr><td class="text-center">3</td><td class="text-center"><a href="https://www.pvrcinemas.com/">PVR Star Mall Gurgaon</a></td><td class="text-center">Boys PG Behind DLF Star Mall, 2nd, NH8, Opposite MileStone 32, Block A, Sector 30, Gurugram, Haryana 122002</td><td class="text-center">0124 470 8100</td></tr><tr><td class="text-center">4</td><td class="text-center"><a href="https://www.pvrcinemas.com/">PVR Cinemas</a></td><td class="text-center">Ambience Mall, 3rd NH 8, Ambience Island, DLF Phase 3, Sector 24, Gurugram, Haryana 122002</td><td class="text-center">0124 466 5543</td></tr><tr><td class="text-center">5</td><td class="text-center"><a target="_blank" href="https://www.pvrcinemas.com/">PVR Sahara</a></td><td class="text-center">Sahara Mall, Mehrauli-Gurgaon Rd, A Block, DLF Phase 1, Sector 28, Gurugram, Haryana 122002</td><td class="text-center">0124 470 8100</td></tr><tr><td class="text-center">6</td><td class="text-center"><a href="http://srscinemas.net/">SRS Cinemas</a></td><td class="text-center">Omaxe Gurgaon Mall, 2nd Omaxe Mall, Sohna Rd, Sector 49, Gurugram, Haryana 122004</td><td class="text-center">01234 567 890</td></tr><tr><td class="text-center">7</td><td class="text-center"><a target="_blank" href="https://www.pvrcinemas.com/">PVR City Centre</a></td><td class="text-center">City Centre Mall, 3rd Floor DLF City Centre Mall, Mehrauli-Gurgaon Rd, Opp Beverley Park, DLF Phase 2, Gurugram, Haryana 122002</td><td class="text-center">0124 470 8100</td></tr><tr><td class="text-center">8</td><td class="text-center"><a href="https://www.carnivalcinemas.com/">Grand Cinemas Raheja Mall</a></td><td class="text-center">Raheja Mall, 4th Floor, Sohna Rd, Gurugram, Haryana 122018</td><td class="text-center">082910 80052</td></tr><tr><td class="text-center">9</td><td class="text-center">SRS Cinemas</td><td class="text-center">Celebration Mall, Sohna Rd, Central Park II, Sector 48, Gurugram, Haryana 122101</td><td class="text-center">0124 646 4349</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Hotels</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center"><a target="_blank" href="https://www.parkinn.com/hotel-gurgaonin?s_cid=os.apac-IN-prk-INDGUPD-gmb">Park Inn, Gurgaon</a></td><td class="text-center">Plot No 282-283 Near More Chowk Sector 15, Civil Lines, Gurugram, Haryana 122001</td><td class="text-center">0124 479 5555</td></tr><tr><td class="text-center">2</td><td class="text-center"><a target="_blank" href="https://www.crossroadshotels.com/">Hotel Crossroads, Gurgaon</a></td><td class="text-center">Behind ITI College, Sector 15 Part 2, Gurugram, Haryana 122001</td><td class="text-center">0124 499 0000</td></tr><tr><td class="text-center">3</td><td class="text-center"><a href="https://www.radisson.com/gurgaon-hotel-hr-122016/indrguv">Radisson Gurugram Udyog Vihar</a></td><td class="text-center">NH 8 Adjacent to Plot No 406, Phase III, Udyog Vihar, Gurugram, Haryana 122016</td><td class="text-center">0124 494 2555</td></tr><tr><td class="text-center">4</td><td class="text-center"><a href="http://www.clarksinn.in/">Clarks Inn Gurgaon</a></td><td class="text-center">Plot No. 45, Old Judicial Complex, 46, Civil Line Rd, Sector 15, Gurugram, Haryana 122001</td><td class="text-center">0124 493 0000</td></tr><tr><td class="text-center">5</td><td class="text-center"><a target="_blank" href="https://www.wyndhamhotels.com/ramada/gurgaon-india/ramada-gurgaon-central/overview?CID=LC:RA::GGL:RIO:National:36587">Ramada Gurgaon Central</a></td><td class="text-center">2, Sector 44, Gurugram, Haryana 122003</td><td class="text-center">0124 488 6400</td></tr><tr><td class="text-center">6</td><td class="text-center"><a href="http://www.habitarehotels.com/">The Habitare Hotel</a></td><td class="text-center">21, 1, Mehrauli-Gurgaon Rd, Near kalyani Hospital, Anamika Enclave, Sector 14, Gurugram, Haryana 122001</td><td class="text-center">0124 491 5300</td></tr><tr><td class="text-center">7</td><td class="text-center"><a target="_blank" href="https://www.leisureinnwestgurgaon.in/?utm_source=google&utm_medium=organic&utm_campaign=local-listing">Leisure Inn West Gurgaon</a></td><td class="text-center">17/6, Old Delhi Gurgaon Rd, Anamika Enclave, Sector 14, Gurugram, Haryana 122001</td><td class="text-center">0124 493 1100</td></tr><tr><td class="text-center">8</td><td class="text-center"><a href="https://hiltongardeninn3.hilton.com/en/hotels/india/hilton-garden-inn-gurgaon-baani-square-DELGUGI/index.html?WT.mc_id=zELWAKN0APAC1GI2DMH3LocalSearch4DGGenericx6DELGUGI">Hilton Garden Inn Gurgaon Baani Square</a></td><td class="text-center">Baani Square, Pocket C, Mayfield Garden, Sector 50, Gurugram, Haryana 122002</td><td class="text-center">0124 442 0000</td></tr><tr><td class="text-center">9</td><td class="text-center"><a href="http://www.anyahotels.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb">Anya Gurgaon</a></td><td class="text-center">42, Golf Course Road, DLF Phase 5, Sector 43, Gurugram, Haryana 122002</td><td class="text-center">085277 01115</td></tr><tr><td class="text-center">10</td><td class="text-center"><a href="http://gazeboinnandsuites.com/yoona/index.php">Gazebo Inn & Suites</a></td><td class="text-center">GH-7 Opposite Medanta Hospital, Sector 39, Gurugram, Haryana 122001</td><td class="text-center">095992 40192</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Shopping Malls</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center"><a target="_blank" href="http://www.ambiencemalls.com/">Ambience Mall, Gurgaon</a></td><td class="text-center">NH 8, Ambience Island, Gurugram, Haryana 122002</td><td class="text-center">0124 473 7101</td></tr><tr><td class="text-center">2</td><td class="text-center"><a target="_blank" href="https://www.omaxe.com/projects/gurgaon/commercial/omaxe-gurgaon-mall">OMAXE GURGAON MALL</a></td><td class="text-center">Sohna - Gurgaon Rd, Block S, Uppal Southend, Sector 49, Gurugram, Haryana 122018</td><td class="text-center">1800 102 0064</td></tr><tr><td class="text-center">3</td><td class="text-center"><a href="http://mgf.co/business-areas/mgf-mall-management/mgf-mega-city-gurgaon/">MGF Megacity Mall</a></td><td class="text-center">Metro Station, Mehrauli-Gurgaon Rd, Near, Sikanderpur, DLF Phase 1, Sector 28, Gurugram, Haryana 122002</td><td class="text-center">0124 438 1985</td></tr><tr><td class="text-center">4</td><td class="text-center"><a href="https://www.omaxe.com/projects/gurgaon/commercial/omaxe-celebrations-mall-gurgaon">Omaxe Celebration Mall</a></td><td class="text-center">SHOP NO. 19 B Sohna Road Sector 48, Subhash Chowk, Gurugram, Haryana 122001</td><td class="text-center">1800 102 0064</td></tr><tr><td class="text-center">5</td><td class="text-center">Sahara Mall</td><td class="text-center">Mehrauli-Gurgaon Rd, Saraswati Vihar, DLF Phase 1, Sector 28, Gurugram, Haryana 122002</td><td class="text-center">0124 404 8592</td></tr><tr><td class="text-center">6</td><td class="text-center"><a href="http://jmdgroup.in/">JMD Regent Plaza Mall</a></td><td class="text-center">Mehrauli-Gurgaon Road Near Guru Dronacharya Metro Station, Sector 26, Gurugram, Haryana 122002</td><td class="text-center">0124 428 9224</td></tr><tr><td class="text-center">7</td><td class="text-center"><a target="_blank" href="https://centralandme.com/">Gurgaon Central Mall</a></td><td class="text-center">Metro Station, Mehroli Gurgaon Service Road, Near, M.G.Road, Gurugram, Haryana 122001</td><td class="text-center">0124 285 9000</td></tr><tr><td class="text-center">8</td><td class="text-center">Scottish Mall</td><td class="text-center">Sohna Road, Tatvam Villas, Dhani, Sector 49, Gurugram, Haryana 122001</td><td class="text-center">078368 43650</td></tr><tr><td class="text-center">9</td><td class="text-center"><a href="http://www.raheja.com/raheja-rmall.asp">Raheja Mall</a></td><td class="text-center">Near, Sohna Rd, D1 Block, Malibu Town, Sector 47, Gurugram, Haryana 122018</td><td class="text-center">011 4061 1111</td></tr><tr><td class="text-center">10</td><td class="text-center"><a href="https://shop.co.in/3297-Jewelry.html">Plaza Mall</a></td><td class="text-center">Mehrauli-Gurgaon Rd, Near MG Metro Station, Indian Airlines Pilots Society, Sushant Lok Phase I, Sector 28, Gurugram, Haryana 122002</td><td class="text-center">0124 401 0001</td></tr></tbody></table></div></div><!--Faridabad start --></div><div class="row" ng-if="vm.city === \'faridabad\'"><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">ABOUT FARIDABAD</h5><div class="col-md-12"><p>Faridabad District has been awarded Faridabad City by this name, which was established in AD 1707 by Sheikh Farid, the treasurer of Jahangir with the objective of protecting the highway passing through the city. The site selected for Faridabad township covers the area of 18.1 square kilometers on the western side of Delhi-Mathura National Highway. It has a geographical area of 742.90 square kilometers. Faridabad District and Division is located on South-Eastern part of the State. Its proximity to places like Gurgaon and New Delhi make it a favourable investment destination.</p></div></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">District at Glance</h5><div class="col-md-12 text-center"><div class="col-md-4"><img src="../../content/used-images-new/fridabad1.png"></div><div class="col-md-8"><img src="../../content/used-images-new/fridabad2.png"></div></div></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Schools</h5><h5 class="text-center gradient_bg_color1" style="color: white; padding: 10px;font-size: 20px">Public Schools</h5><table class="table table_template table-striped"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">Govt.Girls Sr. Sec. School</td><td class="text-center">Old Faridabad Cowki, Anaj Mandi, New Baselwa Colony, Sector 18, Old Faridabad, Faridabad, Haryana 121002</td></tr><tr><td class="text-center">2</td><td class="text-center">Govt. Middle School</td><td class="text-center">Sector 31, Faridabad, Haryana 121003</td></tr><tr><td class="text-center">3</td><td class="text-center">Government Primary School</td><td class="text-center">Sector 28, Faridabad, Haryana 121002</td></tr><tr><td class="text-center">4</td><td class="text-center">Government Senior Secondary School</td><td class="text-center">1164, Sector 7, Sector 7e, Block E, Sector 7, Faridabad, Haryana 121006</td></tr><tr><td class="text-center">5</td><td class="text-center">Government Primary School</td><td class="text-center">Baselwa Colony, Faridabad, Haryana 121002</td></tr><tr><td class="text-center">6</td><td class="text-center">Government Boys High School</td><td class="text-center">14A/14B, KL Mehta Rd, Block F, New Industrial Twp 2, New Industrial Town, Faridabad, Haryana 121001</td></tr><tr><td class="text-center">7</td><td class="text-center">Government Boys Senior Secondary School</td><td class="text-center">Main Market, Anaj Mandi, Near Police Station, Pandit Krishnan Dutt Marg, Sector 18, Faridabad, Haryana 121002</td></tr><tr><td class="text-center">8</td><td class="text-center">Government Senior Secondary School</td><td class="text-center">Saran, Saran Village, Faridabad, Haryana 121005</td></tr><tr><td class="text-center">9</td><td class="text-center">Govt Girls Senior Secondary School</td><td class="text-center">Tgn, N I T, Narela Rajeev Nagar, Aravalli Golf Course, New Industrial Town, Faridabad, Haryana 121001</td></tr><tr><td class="text-center">10</td><td class="text-center">Government Girls Senior Secondary School</td><td class="text-center">Sector 8 NIT 104, Faridabad, Haryana 121006</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color1" style="color: white; padding: 10px;font-size: 20px">International Schools</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No.</th><th class="text-center">Website</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">SRS International School</td><td class="text-center">SRS Chowk, Sector 88, Near SRS Residency, Faridabad, Haryana 121002</td><td class="text-center">0129 407 2888</td><td class="text-center">http://www.srsintlschool.com/</td></tr><tr><td class="text-center">2</td><td class="text-center">Grand Columbus International School</td><td class="text-center">Behind Metro Hospital, Nirman Kunj, ADB PWD Colony, Sector 16A, Faridabad, Haryana 121002</td><td class="text-center">099999 54705</td><td class="text-center">https://www.grandcolumbus.com/</td></tr><tr><td class="text-center">3</td><td class="text-center">Aravali International School</td><td class="text-center">Badkal Surajkund Road, Sector- 43, Faridabad, Haryana 121003</td><td class="text-center">0129 298 8146</td><td class="text-center">http://aravali.edu.in/sector43</td></tr><tr><td class="text-center">4</td><td class="text-center">Manav Rachna International School</td><td class="text-center">Eros Garden, Charmwood Village, Delhi - Surajkund Road,, Faridabad, Haryana 121008</td><td class="text-center">0129 426 9999</td><td class="text-center">https://mris.edu.in/faridabad-sector-14/</td></tr><tr><td class="text-center">5</td><td class="text-center">Ryan International School</td><td class="text-center">Opp. Community Centre, Sector 21 \u2013 B, Faridabad, Haryana 121001</td><td class="text-center">0129 298 0050</td><td class="text-center">https://www.ryaninternational.org/</td></tr><tr><td class="text-center">6</td><td class="text-center">Rawal International School</td><td class="text-center">Nangla, Sohna Road, Sarurpur Industrial Area, Faridabad, Haryana 121004</td><td class="text-center">098991 51886</td><td class="text-center">https://www.rawalinternationalschool.com/</td></tr><tr><td class="text-center">7</td><td class="text-center">Surajkund International School</td><td class="text-center">Chetram Colony, Block GC, Dayal Bagh Colony, Faridabad, Haryana 121009</td><td class="text-center">0129 409 2600</td><td class="text-center">http://www.surajkundinternational.in/director1.php</td></tr><tr><td class="text-center">8</td><td class="text-center">VIdyasagar International School , SECTOR-2, Faridabad</td><td class="text-center">Near Housing Board, Bhatia Colony, Ram Prasad Colony, Sector 2, Faridabad, Haryana 121004</td><td class="text-center">0129 230 4007</td><td class="text-center">http://www.visfaridabad.com/</td></tr><tr><td class="text-center">9</td><td class="text-center">Dynasty International School</td><td class="text-center">Sector 28, Faridabad, Haryana 121008</td><td class="text-center">0129 404 3701</td><td class="text-center">https://dynastyinternationalschool.in/</td></tr><tr><td class="text-center">10</td><td class="text-center">Northland International School</td><td class="text-center">33, Indraprastha Colony, Sector 30, Faridabad, Haryana 121003</td><td class="text-center">098107 72609</td><td class="text-center">http://www.northlandinternationalschool.in/</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Hospitals</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No.</th><th class="text-center">Website</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">District Civil Hospital</td><td class="text-center">Opp Dussehra Ground, New Industrial Town, Faridabad, Haryana 121001</td><td class="text-center">0129 241 6169</td><td class="text-center">https://faridabad.nic.in/public-utility/civil-hospital/</td></tr><tr><td class="text-center">2</td><td class="text-center">Government Hospital</td><td class="text-center">827, Gali Number 14, Ward No.4, New Baselwa Colony, Sector 18, Old Faridabad, Faridabad, Haryana 121002</td><td></td><td></td></tr><tr><td class="text-center">3</td><td class="text-center">Government Hospital (CRHSP Aiims)</td><td class="text-center">National Highway, 2, Mathura Rd, Ballabhgarh, Faridabad, Haryana 121004</td><td></td><td></td></tr><tr><td class="text-center">4</td><td class="text-center">R.C.H. Government Hospital</td><td class="text-center">Near Aggarwal Public School, Sector 3, Faridabad, Haryana 121001</td><td class="text-center">094678 81875</td><td class="text-center"></td></tr><tr><td class="text-center">5</td><td class="text-center">ESI Hospital</td><td class="text-center">Faridabad Road, Sector 8, Faridabad, Haryana 121006</td><td class="text-center">0129 230 3155</td><td class="text-center">https://www.esic.nic.in/Haryana-hospital.php</td></tr><tr><td class="text-center">6</td><td class="text-center">Fortis Escorts</td><td class="text-center">Neelam Bata Rd, Opp. Neelam Cinema, AC Nagar, New Industrial Town, Faridabad, Haryana 121001</td><td class="text-center">0129 246 6000</td><td class="text-center">https://www.fortishealthcare.com/india/fortis-escorts-hospital-in-faridabad</td></tr><tr><td class="text-center">7</td><td class="text-center">Sarvodaya Hospital</td><td class="text-center">YMCA Road, Sector-8, Near ESI Hospital, Block A, Faridabad, Haryana 121006</td><td class="text-center">0129 418 4444</td><td class="text-center">https://www.sarvodayahospital.com/</td></tr><tr><td class="text-center">8</td><td class="text-center">Asian Institute of Medical Sciences</td><td class="text-center">Badkal Flyover, Road, Sector 21A, Faridabad, Haryana 121001</td><td class="text-center">0129 425 3000</td><td class="text-center">https://www.aimsindia.com/</td></tr><tr><td class="text-center">9</td><td class="text-center">Metro Heart Institute with Multispeciality</td><td class="text-center">Nirman Kunj, ADB PWD Colony, Sector 16A, Faridabad, Haryana 121002</td><td class="text-center">0129 427 7777</td><td class="text-center">https://www.metrohospitalfaridabad.com/</td></tr><tr><td class="text-center">10</td><td class="text-center">Goyal Hospital - Multispeciality Hospital</td><td class="text-center">Nursing home site number 2,opposite hanuman temple, sector-8, Faridabad, Haryana 121106</td><td class="text-center">0129 224 2383</td><td class="text-center">https://goyalhospitalfaridabad.com/</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Sports Clubs</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No.</th><th class="text-center">Website</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">Gymkhana Club-II</td><td class="text-center">Suraj Kund Badkhal Rd, Sector 21C, Near Ankhir Chowk Maharaja Agrasen Society, Faridabad, Haryana 121001</td><td class="text-center">0129 243 7022</td><td class="text-center">http://www.faridabadgymkhana1.in/</td></tr><tr><td class="text-center">2</td><td class="text-center">Spartans Club Gym</td><td class="text-center">SCF 15, Huda Market Sector 14, Faridabad, Haryana 121007</td><td class="text-center">084474 74785</td><td class="text-center">http://spartansclub.co.in/</td></tr><tr><td class="text-center">3</td><td class="text-center">Faridabad District Badminton Association</td><td class="text-center">(Manav Rachna International School), Sector - 14, Faridabad, Haryana</td><td class="text-center">093128 36764</td><td class="text-center">http://fdba.in/</td></tr><tr><td class="text-center">4</td><td class="text-center">Aravali Golf Club</td><td class="text-center">New Industrial Township( N I T), Near Nahar Singh Stadium Golf Club, Faridabad, Haryana 121001</td><td class="text-center">0129 241 4810</td><td class="text-center">http://haryanatourism.gov.in/</td></tr><tr><td class="text-center">5</td><td class="text-center">Dronacharya Boxing Club Faridabad</td><td class="text-center">Delhi Publc School, Sector 11D, Faridabad, Haryana 121006</td><td class="text-center">099999 21269</td><td class="text-center">http://dronacharyaboxingclub.com/</td></tr><tr><td class="text-center">6</td><td class="text-center">Manav Rachna Sports Academy</td><td class="text-center">Manav Rachna International School Gate No-3, Sector 14, Faridabad, Haryana 121007</td><td class="text-center">0129 419 7272</td><td class="text-center">http://www.mrsa.co.in/</td></tr><tr><td class="text-center">7</td><td class="text-center">Deva Swimming Institute</td><td class="text-center">Hotel Rajhans,Soorajkund, Faridabad, Faridabad, Haryana 121009</td><td class="text-center">080598 69586</td><td class="text-center">http://www.devaswimminginstitute.com/</td></tr><tr><td class="text-center">8</td><td class="text-center">Grabin Sports Pvt Ltd</td><td class="text-center">16/6, Ojha Niwas, Rajiv Chowk, Mathura Rd, Faridabad, Haryana 121002</td><td class="text-center">098712 70565</td><td class="text-center">https://grabinsports.com/</td></tr><tr><td class="text-center">9</td><td class="text-center">Rajiv Godara Boxer</td><td class="text-center">H.NO 85 Sec 11d, faridabad, Faridabad, Haryana 121006</td><td class="text-center">099999 21269</td><td class="text-center">http://dronacharyaboxingclub.com/</td></tr><tr><td class="text-center">10</td><td class="text-center">Azad Football Club</td><td class="text-center">121001, Block 7, New Industrial Twp 4, New Industrial Town, Faridabad, Haryana 121001</td><td class="text-center">097185 26160</td><td class="text-center"></td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Amusement Parks</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No.</th><th class="text-center">Website</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">Family Kingdom Faridabad</td><td class="text-center">Seekri, Delhi Mathura Road, Faridabad, Haryana 121004</td><td class="text-center">093110 05747</td><td class="text-center">http://www.familykingdom.co.in/</td></tr><tr><td class="text-center">2</td><td class="text-center">FFUNMAX</td><td class="text-center">42 Milestone, Main Mathura Road, Behind Royal Villa Banquet Hall, Village Sikri, Faridabad, Haryana 121004</td><td class="text-center">088825 59988</td><td class="text-center">http://ffunmax.com/</td></tr><tr><td class="text-center">3</td><td class="text-center">Ambedkar Park</td><td class="text-center">Lakewood city, Surajkund, Faridabad, Haryana 121009</td><td class="text-center"></td><td class="text-center"></td></tr><tr><td class="text-center">4</td><td class="text-center">Worlds of Wonder</td><td class="text-center">The Great India Place Mall, Sector-38 A, Entry from Gate No. 11 Adjacent, Noida, Uttar Pradesh 201301</td><td class="text-center">1800 103 1415</td><td class="text-center">https://www.worldsofwonder.in/</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Cinemas</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No.</th><th class="text-center">Website</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">INOX</td><td class="text-center">3rd Floor Crown Interiorz Mall, Mathura Rd, Subash Nagar, Sector 35, Faridabad, Haryana 121003</td><td class="text-center">080802 11111</td><td class="text-center">https://www.inoxmovies.com/</td></tr><tr><td class="text-center">2</td><td class="text-center">SRS Cinemas</td><td class="text-center">City Centre, SRS Multiplex mall, 2nd, Sector 12, Faridabad, Haryana 121007</td><td class="text-center">0129 428 2999</td><td class="text-center">http://www.srscinemas.net/contact.php</td></tr><tr><td class="text-center">3</td><td class="text-center">SRS Cinemas</td><td class="text-center">3rd Floor Pristine Mall, Sector 31, Faridabad, Haryana 121003</td><td class="text-center">081303 07258</td><td class="text-center">http://www.srscinemas.net/</td></tr><tr><td class="text-center">4</td><td class="text-center">PVR Cinemas</td><td class="text-center">Crown Plaza, 1st Floor, A, Mathura Rd, Azad Colony, Sector 15, Faridabad, Haryana 121001</td><td class="text-center">088009 00009</td><td class="text-center">https://www.pvrcinemas.com/</td></tr><tr><td class="text-center">5</td><td class="text-center">INOX EF3 Cinema</td><td class="text-center">EROS EF3 Mall 3rd Floor, Sector 20 A, Faridabad, Haryana 121001</td><td class="text-center">072900 16917</td><td class="text-center">https://www.inoxmovies.com/</td></tr><tr><td class="text-center">6</td><td class="text-center">MSX Silver City Cinemas</td><td class="text-center">Parsvnath City Mall, 1st Floor, Sector 12, National Highway 2, Mathura Road, Near Bata Metro Station, Faridabad, Haryana 121003</td><td class="text-center">0129 413 6666</td><td class="text-center">http://www.msxsilvercitycinemas.com/contact.htm</td></tr><tr><td class="text-center">7</td><td class="text-center">SRS Cinemas</td><td class="text-center">Om Shubham Tower, 4th Floor Nit, Neelam Bata Rd, Faridabad, Haryana 121001</td><td></td><td class="text-center">http://www.srscinemas.net/</td></tr><tr><td class="text-center">8</td><td class="text-center">Red Rocks Cinema</td><td class="text-center">SLF Mall, 33, Sector 30, Indraprastha Colony, Sector 32, Faridabad, Haryana 121001</td><td class="text-center">0129 414 7074</td><td class="text-center">http://redrockscinemas.com/about-us/</td></tr><tr><td class="text-center">9</td><td class="text-center">Mastiii 7D Theater</td><td class="text-center">1st Floor, Crown Interiorz, NH- 2,, Sector 35, DLF Industrial Area Faridabad, Haryana, Delhi, Haryana 121003</td><td class="text-center">0129 431 0400</td><td class="text-center">http://modernmasti.com/site/</td></tr><tr><td class="text-center">10</td><td class="text-center">Neelam Cinema</td><td class="text-center">B-387B, Neelam Flyover, Nehru Ground, New Industrial Twp 1, New Industrial Town, Faridabad, Haryana 121001</td><td class="text-center">0129 241 5398</td><td class="text-center">https://www.bollywoodmdb.com/theater/neelam-cinema-bata-road-faridabad-1406</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Hotels</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No.</th><th class="text-center">Website</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">Goldfinch Hotel Faridabad</td><td class="text-center">Goldfinch Hotel, Sector 39, Surajkund, Faridabad, Surajkund, Faridabad, Haryana, 121010</td><td class="text-center">0129 424 9999</td><td class="text-center">https://www.goldfinchhotels.com/Delhi/about_gf_delhi.php</td></tr><tr><td class="text-center">2</td><td class="text-center">Radisson Blu Hotel Faridabad</td><td class="text-center">Sector - 20B, Mathura Road, Faridabad, Haryana 121001</td><td class="text-center">0129 266 6000</td><td class="text-center">https://www.radissonblu.com/en/hotel-faridabad</td></tr><tr><td class="text-center">3</td><td class="text-center">Vivanta Surajkund</td><td class="text-center">Shooting Range Rd, Block C, Surajkund, Faridabad, Haryana 121009</td><td class="text-center">0129 419 0000</td><td class="text-center">https://www.tajhotels.com/en-in/vivanta/surajkund-ncr/?utm_source=Google&utm_campaign=Surajkund-Ncr&utm_medium=Local</td></tr><tr><td class="text-center">4</td><td class="text-center">Park Plaza Faridabad</td><td class="text-center">Plot #1, Sector 21C, Faridabad, Haryana 121002</td><td class="text-center">0129 424 1111</td><td class="text-center">https://www.sarovarhotels.com/park-plaza-faridabad/?utm_source=GMBlisting&utm_medium=organic</td></tr><tr><td class="text-center">5</td><td class="text-center">Vibe By The LaLiT Traveller</td><td class="text-center">12/7 Mathura Road Just after Toll Plaza Faridabad, Delhi NCR, Haryana 121003</td><td class="text-center">0129 429 0000</td><td class="text-center">https://vibehotels.in/</td></tr><tr><td class="text-center">6</td><td class="text-center">Mahalakshmi Palace Hotel</td><td class="text-center">No.68, Neelam Bata Rd, Near Fortis Hospital, AC Nagar, New Industrial Town, Faridabad, Haryana 121001</td><td class="text-center">0129 400 8882</td><td class="text-center">https://mphotel.in/</td></tr><tr><td class="text-center">7</td><td class="text-center">Ginger Hotel</td><td class="text-center">Fun City Mall, Arjonda Chowk, Main Mathura Road, Faridabad, Haryana 121001</td><td class="text-center">0129 666 3333</td><td class="text-center">https://www.gingerhotels.com/ginger-faridabad</td></tr><tr><td class="text-center">8</td><td class="text-center">Golden Galaxy Hotels & Resorts</td><td class="text-center">6 Kms from Ballabgarh, Delhi Mathura Road, Faridabad, Haryana 121004</td><td class="text-center">095993 85803</td><td class="text-center">http://www.goldengalaxy.in/</td></tr><tr><td class="text-center">9</td><td class="text-center">The Atrium</td><td class="text-center">Shooting Range Rd, Block C, Surajkund, Faridabad, Haryana 121009</td><td class="text-center">084481 92825</td><td class="text-center">https://www.atrium-hotels.com/</td></tr><tr><td class="text-center">10</td><td class="text-center">Hotel Delite Grand</td><td class="text-center">A-5/B, Neelam Bata Road, Shaheed Bhagat Singh Marg, New Industrial Township, Faridabad, Haryana 121001</td><td class="text-center">0129 435 5555</td><td class="text-center">http://www.delitehotels.com/</td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Shopping Malls</h5><table class="table table_template table-striped"><col width="50"><col width="100"><col width="200"><col width="100"><col width="100"><thead><tr><th class="text-center">Sr. No.</th><th class="text-center">Name</th><th class="text-center">Address</th><th class="text-center">Phone No.</th><th class="text-center">Website</th></tr></thead><tbody><tr><td class="text-center">1</td><td class="text-center">Parsvnath City Mall</td><td class="text-center">NH2, Sector 12, Faridabad, Haryana 121007</td><td></td><td class="text-center">http://www.parsvnath.com/</td></tr><tr><td class="text-center">2</td><td class="text-center">SRS Shopping Mall</td><td class="text-center">Ground Floor, Town Park Road, Sector 12, Sector 12, Faridabad, Haryana 121007</td><td class="text-center">0129 428 2801</td><td class="text-center">http://www.srsparivar.com/</td></tr><tr><td class="text-center">3</td><td class="text-center">Mall Manhattan</td><td class="text-center">Plot No 11, Sector 20 A, Mathura Road, Faridabad, Haryana 121001</td><td class="text-center">011 3096 9305</td><td class="text-center">http://www.parsvnath.com/city/retail/retail-faridabad/</td></tr><tr><td class="text-center">4</td><td class="text-center">SRS - Eldeco Mall</td><td class="text-center">18/6, Sector 12, Faridabad, Haryana 121007</td><td class="text-center">0129 406 6204</td><td class="text-center">http://www.eldecogroup.com/</td></tr><tr><td class="text-center">5</td><td class="text-center">Eros EF3 Mall</td><td class="text-center">Plot N0.12, Sector 20A, Mathura Road, Faridabad, Haryana 121101</td><td class="text-center">098733 38916</td><td class="text-center">http://www.eros-group.com/eros-ef3-mall.asp</td></tr><tr><td class="text-center">6</td><td class="text-center">Ozone Centre Mall</td><td class="text-center">Sector 12, Faridabad, Haryana 121007</td><td class="text-center">097119 50689</td><td class="text-center">http://www.shivsai.com/</td></tr><tr><td class="text-center">7</td><td class="text-center">Crown Interiorz Mall</td><td class="text-center">47, Mathura Rd, Ashoka Enclave 3, Ashoka Enclave Part 3, Subash Nagar, Sector 35, Faridabad, Haryana 121003</td><td class="text-center"></td><td class="text-center"></td></tr><tr><td class="text-center">8</td><td class="text-center">City Centre Shopping Mall</td><td class="text-center">HUDA Staff Colony, Sector 16, Faridabad, Haryana 121002</td><td class="text-center"></td><td class="text-center"></td></tr><tr><td class="text-center">9</td><td class="text-center">Crown Plaza</td><td class="text-center">27/5, Mathura Rd, Azad Colony, Sector 15A, Faridabad, Haryana 121007</td><td class="text-center">0129 411 7536</td><td></td></tr><tr><td class="text-center">10</td><td class="text-center">Reliance Mart Mall</td><td class="text-center">Mathura Rd, Opp 37 Cut, Sector 27D, Faridabad, Haryana 121003</td><td class="text-center">0129 416 1119</td><td class="text-center"></td></tr></tbody></table></div></div></div></section></div>');
$templateCache.put('app/home/renewable.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Renewable Energy & Solar Parks</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Focus Sectors</span></li><li class="active"><span>Renewable Energy & Solar Parks</span></li></ol></div></section><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container-fluid"><div class="row"><div class="col-sm-12"><img src="../../content/used-images-new/defence1.jpg" style="width: 100%; height: 300px"></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Highlights</h5></div><div class="col-md-12"><ul><li>100% rural electrification completed</li><li>Current energy sources: Thermal (81%), Hydro (17%), Renewable Energy Sources (2%), Nuclear (1%)</li><li>Renewable energy projects with a total capacity of 251.89 MW already commissioned and 239.5 MW projects under execution</li><li>Emphasis on increasing Solar and Biomass energy sources</li><li>Being an agriculture intensive state, significant amount of biomass is generated</li></ul></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Incentives</h5><table class="table table_template table-striped"><thead><tr><th class="text-center">INCENTIVE</th><th class="text-center">DETAILS</th></tr></thead><tbody><tr><td>Land fees and taxes</td><td><ul><li>100% exemption from payment of fee and stamp duty charges for registration of rent/lease deed for the land required for the projects</li><li>Exemption from change of land use approval, external development charges, scrutiny fee and infrastructure development charges</li><li>Panchayat land on nominal lease</li></ul></td></tr><tr><td>Power charges</td><td><ul><li>Exemption from electricity duty, electricity taxes & cess, wheeling charges, transmission and distribution losses, cross subsidy charges, surcharges and reactive power charges</li><li>State utilities to bear the cost of EHV/HV transmission line up to a distance of 10 km</li></ul></td></tr><tr><td>Solar rooftop projects</td><td><ul><li>No permission required from the building plan sanctioning authority for setting up of rooftop solar power plants</li></ul></td></tr><tr><td>Other Solar incentives</td><td><ul><li>Horticulture/Floriculture activities allowed along with solar generation</li><li>Exemption of clearance from Haryana Pollution Control Board and Forest Department</li><li>All new projects of MW scale generating solar energy will be treated as \u201CIndustry\u201D enabling them to enjoy the incentives available to industrial units under the industrial policy</li><li>20% reservations for small power projects of 1MW to 2 MW</li><li>Power from solar pumps allowed for sale to the state power utilities</li></ul></td></tr><tr><td>Price Preference</td><td><ul><li>Price preference will be given to IPPs who set up the Solar Power Plants in the State</li></ul></td></tr><tr><td>Banking</td><td><ul><li>UHBVN/DHBVN/HVPNL shall permit banking of solar power generated by eligible producer</li></ul></td></tr></tbody></table></div><div class="col-md-12 text-center"><h5 class="gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Policy Targets</h5><div class="col-md-10 col-md-offset-1"><div class="col-md-4" style="background-color: #494F6B; color: #FFFFFF; margin: 10px">Installed Solar power capacity of 3200 MW by 2021-22</div><div class="col-md-3" style="background-color: #494F6B; color: #FFFFFF; margin: 10px">Small/Mini hydel capacity of 100 MW by 2020</div><div class="col-md-3" style="background-color: #494F6B; color: #FFFFFF; margin: 10px">Waste to energy capacity of 50 MW by 2020</div></div></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Investment Opportunities</h5><ul><li>Development of first solar park in Haryana (300 acres earmarked by HSIIDC and HPGCL)</li><li>Commercial solar power generation projects in Bhiwani, Hisar, Jhajjar, Karnal and Mahendergarh areas</li><li>Co-creation of Solar Centres of Excellence along with a pool of technical professionals</li><li>Setting up of MW scale solar power projects in consultation with the irrigation department, Haryana government</li><li>Development of biomass and cogeneration- bagasse power projects within identified areas of the state with strategic assistance from government of Haryana</li><li>Development of small and medium hydro power projects</li><li>Establishment of wind farms and wind power generation projects</li><li>Identification of waste, other than biomass and establishment of facilities for commercial energy production from the same</li></ul></div></div></div></div></div></div></section>');
$templateCache.put('app/home/serviceapplicationguide.html','<!DOCTYPE html><html><body><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Application Approval Process</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Application Approval Process</span></li></ol></div></section><br><div class="new-section"><div class="container-fluid text-center"><div class="with_background gradient_bg_color1 col-md-12"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li><a ui-sref="investorfacilitationcell"><p class="font19">Investor facilitation cell</p></a></li><li><a ui-sref="caffillingguide"><p class="font19">CAF filling guide</p></a></li><li class="active"><a ui-sref="serviceapplicationguide"><p class="font19">Application Approval Process</p></a></li></ul></nav></div><div class="row"><div class="col-md-10 col-md-offset-1" style="padding-right: 0px"><img src="../../content/used-images-new/serviceapplicationguide.jpg" alt="" title="" class="img-responsive"></div></div></div></div><br><br><br><br></body></html>');
$templateCache.put('app/home/states.html','<br><div class="new-section"><div class="container-fluid"><div class="row"><div class="col-md-3"><strong><span style="color:#990000; font-size: 20px">Haryana</span></strong><br><div class="row"><div class="col-md-2" style="padding-right: 0px"><img src="../../content/used-images-new/Capture2.jpg" alt="" title="" class="img-responsive"></div><div class="col-md-10" style="margin-left:-19px"><br><a ui-sref="haryana"><p class="font19">Fact File</p></a><br><a ui-sref="states"><p class="font19">Haryana States</p></a><br><a ui-sref="Enabling_infrastructure"><p class="font19">Enabling Infrastructure</p></a><br><a ui-sref="urban_infrastructure"><p class="font19">Urban Infrastructure</p></a><br><a ui-sref="industrial_powerhouse"><p class="font19">Industrial Powerhouse</p></a><br></div></div></div><br><div class="col-md-8"><div class="well"><a href="../../content/pdfs/HaryanaStateProfile.pdf" target="_blank">---> Haryana State Profile</a><br><br><a href="../../content/pdfs/HappeningHaryanCityProfile.pdf" target="_blank">---> Happening Haryana City Profile</a><br><br><!--<a href="content/images/HappeningHaryanaPartnerCountriesProfile.pdf" target="_blank">-&ndash;&gt;  Happening Haryana Partner Countries Profile</a> <br/><br/>--><!--<a href="content/images/SectorProfileAerospaceandDefence.pdf" target="_blank">-&ndash;&gt;  Sector Profile -Aerospace and Defence </a> <br/><br/>--><!--<a href="content/images/SectorProfileFoodProcessing.pdf" target="_blank">-&ndash;&gt;  Sector Profile -Food Processing </a> <br/><br/>--><!--<a href="content/images/SectorProfileFootwear.pdf" target="_blank">-&ndash;&gt;  Sector Profile - Footwear </a> <br/><br/>--><!--<a href="content/images/SectorProfileITESDM.pdf" target="_blank">-&ndash;&gt;  Sector Profile- IT ESDM </a> <br/><br/>--><!--<a href="content/images/SectorProfileManufacturingCompetitiveness.pdf" target="_blank">-&ndash;&gt;  Sector Profile - Manufacturing Competitiveness </a> <br/><br/>--><!--<a href="content/images/SectorProfilePharmaceuticalsAndChemicals.pdf" target="_blank"> -&ndash;&gt;  Sector Profile - Pharmaceuticals and Chemicals </a> <br/><br/>--><!--<a href="content/images/SectorProfileRenewableEnergy.pdf" target="_blank"> -&ndash;&gt;  Sector Profile  - Renewable Energy </a> <br/><br/>--><!--<a href="content/images/SectorProfileTextile.pdf" target="_blank"> -&ndash;&gt;  Sector Profile - Textile </a> <br/><br/>--><!--<a href="content/images/SubCommitteeBrochureAgriBusiness.pdf" target="_blank"> -&ndash;&gt;  Sub-Committee Brochure Agriculture Business </a> <br/><br/>--><!--<a href="content/images/SubCommitteeBrochureEmergingPPModels.pdf" target="_blank"> -&ndash;&gt;  Sub-Committee Brochure Emerging PPP Models </a> <br/><br/>--><!--<a href="content/images/SubCommitteeBrochure ITITeSESDM.pdf" target="_blank"> -&ndash;&gt;  Sub Committee Brochure - IT ITeS ESDM </a> <br/><br/>--></div></div></div></div></div>');
$templateCache.put('app/home/supportive_government.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Supportive Government</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Why Haryana</span></li><li class="active"><span>Supportive Government</span></li></ol></div></section><div class="with_background gradient_bg_color1 col-md-12"><div class="col-md-12 text-center"><nav class="mainmenu_wrapper"><ul class="mainmenu nav sf-menu"><li><a ui-sref="conducive_ecosystem">Conducive Ecosystem</a></li><li><a ui-sref="booming_economy">Booming Economy</a></li><li><a ui-sref="industrial_powerhouse">Industrial Powerhouse</a></li><li class="active"><a ui-sref="supportive_government">Supportive Government</a></li><li><a ui-sref="qualityOfLife">Quality Of Life</a></li></ul></nav></div></div><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container-fluid"><div class="row"><div class="col-xs-12"><div class="container"><div class="row"><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding:10px;margin-top: 10px;font-size: 20px">Haryana : Location advantage coupled with world class infrastructural facilities</h5></div><div class="col-md-1"></div><div class="col-md-6"><h6 class="text-center gradient_bg_color1" style="padding: 10px;font-size: 20px">Lies at the Heart of the country</h6><ul><li style="font-size: small"><p>Approximately 2/3rd of Haryana lies in NCR region- 13 districts of the state are part of National Capital Region (NCR)- one of largest consumption & trade zone of India.</p></li></ul><h6 class="text-center gradient_bg_color3 text-white" style="padding:10px;font-size: 20px">Proximity to High Consumer base- National Capital Region</h6><ul><li style="font-size: small"><p>Highest penetration of modern retail in India at 26%</p></li><li style="font-size: small"><p>Modern retail size is USD 5.3 bn (USD 530 Crores) with market rate of growth 58%</p></li></ul><h6 class="text-center gradient_bg_color1" style="padding: 10px;font-size: 20px">Industrial corridors \u2013 beltway to spur economic activity</h6><ul><li style="font-size: small"><p>Delhi \u2013 Mumbai Industrial Corridor (DMIC)</p></li><li style="font-size: small"><p>Amritsar Kolkata Industrial Corridor (AKIC)</p></li><li style="font-size: small"><p>Kundli - Manesar - Palwal Expressway (KMP)</p></li></ul><h6 class="text-center gradient_bg_color3 text-white" style="padding: 10px;font-size: 20px">GST Regime: An impetus to Haryana\u2019s Economy</h6><ul><li style="font-size: small"><p>Strategic factors such as <b>proximity to market and manufacturing zones</b> making Haryana an obvious choice to setup Logistics hubs and Warehouses.</p></li></ul></div><div class="col-md-1"></div><div class="col-md-4"><img src="../../content/used-images-new/hepc_indiamap.png"></div></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Empowering Mega Investors</h5><img class="col-md-8 col-md-offset-2" src="../../content/used-images-new/hepc_supportive4.png"></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Attractive policies \u2013 Lucrative incentives reducing the cost of doing business</h5><img class="col-md-8 col-md-offset-2" src="../../content/used-images-new/hepc_supportive5.png"></div></div></div></div></div></section>');
$templateCache.put('app/home/textile.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Textiles & Apparels</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Focus Sectors</span></li><li class="active"><span>Textiles & Apparels</span></li></ol></div></section><section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10" id="about"><div class="container"><div class="row"><div class="col-xs-12"><div class="container-fluid"><div class="row"><div class="col-sm-12"><img src="../../content/used-images-new/textile1.jpg" style="width: 100%; height: 300px"></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Highlights</h5></div><div class="col-md-12"><ul><li>Haryana is the 4th largest producer of cotton in the country</li><li>Readymade garments worth approx. USD1.3 billion (USD 130 Crores) exported from Haryana annually</li><li>Around 1 million workers employed in the textile sector</li><li>Panipat is known as the \u2018city of weavers\u2019 for its eminence in handloom products</li><li>More than 150 ginning units established in the western region of Haryana</li><li>Cluster based development approach to promote industries</li></ul></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Key Sector Incentives</h5><table class="table table_template table-striped"><thead><tr><th class="text-center">INCENTIVE</th><th class="text-center">DETAILS</th></tr></thead><tbody><tr><td>Investment subsidy on VAT</td><td><ul><li>75% of VAT/SGST net paid for first 7 years, 35% for next three years in \u2018C\u2019 & \u2018D\u2019 category blocks and 50% for first 5 years, 25% for next 3 years in \u2018B\u2019 category blocks from the date of commencement of commercial production with cap of 100% of fixed capital investment</li></ul></td></tr><tr><td>Employment Generation Subsidy</td><td><ul><li>One-time support of Rs.10,000/- for capacity building of persons belonging to Haryana engaged in apparel rural functional clusters</li><li>Employment generation subsidy of Rs.36000/- per annum for SC/Women and Rs.30000/- per annum for General category for 5 years for capacity building of persons of Haryana</li></ul></td></tr><tr><td>Interest Subsidy</td><td><ul><li>@6% or maximum upto Rs.10 lakh per year for Micro, Small & Medium Enterprises on term loan for new/expansion/diversification</li></ul></td></tr><tr><td>Stamp duty</td><td><ul><li>100% refund on stamp duty on purchase/leasing of land for establishment of enterprise including Industrial Estates developed by HSIIDC/private developer</li></ul></td></tr><tr><td>EDC Charges</td><td><ul><li>50% exemption of external development charges in certain category blocks</li></ul></td></tr><tr><td>Mandi Fees Exemption</td><td><ul><li>100% exemption in case of ginning enterprises in certain category blocks</li></ul></td></tr><tr><td>Electricity Duty Exemption</td><td><ul><li>100% exemption for 10 years only for new enterprises in certain category blocks from date of release of electricity connection</li></ul></td></tr><tr><td>VAT Exemption on cotton yarn</td><td><ul><li>100% VAT Exemption of VAT @ 5.25% of cotton yard manufactured in the State</li></ul></td></tr><tr><td>Transfer Property Tax</td><td><ul><li>Exemption from transfer property tax in case of Dyes & Chemicals purchased from outside the state being used in process house</li></ul></td></tr></tbody></table></div><div class="col-md-12"><h5 class="text-center gradient_bg_color3" style="color: white; padding: 10px;font-size: 20px">Investment Opportunities</h5><ul><li>Entire value chain of synthetics and value added and specialty fabrics: Opportunities across value chain of synthetics like dyeing of yarns and fabrics etc.</li><li>Spinning Units: Opportunities for converting fibre to yarn, yarn to fabrics and fabrics to finish products</li><li>Fabric processing setups for all kind of natural and synthetic textiles: Integrated Textile Park at Panipat spread over an area of 30 acres provides ample opportunities for investors</li><li>Technical textiles: Manufacturing textile materials and products used for their technical performance and functional properties</li><li>Garment & Retail: Setting up of apparel & readymade garment units in the proximity of existing readymade garment & apparel parks at the SEZs in Gurgaon & Barhi</li></ul></div></div></div></div></div></div></section>');
$templateCache.put('app/home/urban_infrastructure.html','<!DOCTYPE html><html><!--<head>--><!--<title> Demo for all bootstrap </title>--><!--<link rel="stylesheet" type="text/css" href="css/bootstrap.min.css">--><!--<link rel="stylesheet" type="text/css" href="css/font-awesome.css">--><!--<link rel="stylesheet" type="text/css" href="css/style.css">--><!--</head>--><body><!--<div class="header-1">--><!--<div class="container-fluid bgc-r">--><!--<div class="row">--><!--<div class="col-md-3 col-xs-12">--><!--<p class="font14">Toll  Free  Helpline <br>--><!--1800-180-2132</p>--><!--</div>--><!--<div class="col-md-6"></div>--><!--<div class="col-md-3"></div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="header-2">--><!--<div class="container-fluid">--><!--<div class="second-box">--><!--<div class="row">--><!--<div class="col-md-3">--><!--<div class="logo-site">--><!--<img src="img/logo.PNG" alt="logo-hepc" title="logo" class="img-responsive center-block">--><!--</div>--><!--</div>--><!--<div class="col-md-6">--><!--<div class="text-main text-center">--><!--<p class="font15">Department of Industries<br> Haryana Enterprise Promotion Center</p>--><!--</div>--><!--</div>--><!--<div class="col-md-1"></div>--><!--<div class="col-md-2">--><!--<div class="second-logo">--><!--<img src="img/logo-gov.PNG" class="img-responsive center-block" alt="logo-gov" title="logogov">--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<div class="navbar-box">--><!--<div class="container-fluid">--><!--<div class="row">--><!--<header id="header">--><!--<nav class="navbar">--><!--<div class="container-fluid bgc-r">--><!--<div class="navbar-header">--><!--<button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">--><!--<span class="icon-bar"></span>--><!--<span class="icon-bar"></span>--><!--<span class="icon-bar"></span>--><!--</button>--><!--</div>--><!--<div class="collapse navbar-collapse" id="myNavbar">--><!--<ul class="nav navbar-nav">--><!--<li><a class="active" href="#"> About Us</a></li>--><!--<li><a href="#"> Haryana</a></li>--><!--<li><a href="#">Investor Service</a></li>--><!--<li><a href="#">Information</a></li>--><!--<li><a href="#">News &amp; Gallery</a></li>--><!--<li><a href="#">Login</a></li>--><!--<li style="border-right: 1px solid transparent;"><a href="#">Contact</a></li>--><!--</ul>--><!--</div>--><!--</div>--><!--</nav>--><!--</header>--><!--</div>--><!--</div>--><!--</div>--><br><div class="new-section"><div class="container-fluid"><div class="row"><div class="col-md-3"><strong><span style="color:#990000; font-size: 20px">Haryana</span></strong><br><div class="row"><div class="col-md-2" style="padding-right: 0px"><img src="../../content/used-images-new/Capture2.jpg" alt="" title="" class="img-responsive"></div><div class="col-md-10" style="margin-left:-19px"><br><a ui-sref="haryana"><p class="font19">Fact File</p></a><br><a ui-sref="states"><p class="font19">States</p></a><br><a ui-sref="Enabling_infrastructure"><p class="font19">Enabling Infrastructure</p></a><br><a ui-sref="urban_infrastructure"><p class="font19">Urban Infrastructure</p></a><br><a ui-sref="industrial_powerhouse"><p class="font19">Industrial Powerhouse</p></a><br></div></div></div><div class="col-md-9" style="font-size:16px"><ul><li>Ministry of Urban Development has so far released US$11.16 million to Haryana under Swachh Bharat Mission (Urban).The state government has provided an impetus & would continue to the financial status of urban local bodies & provide adequate funds for improving civic amenities in urban areas. There are 77 urban local bodies in the state, consisting of 9 municipal corporations, 19 municipal councils & 50 municipal committees</li><br><li>Realty firm, Signature Global, signed an agreement with the Government of Haryana in January 2017, for investing US$76.92 million to develop 2 housing projects in Gurgaon.</li><br><li>As of April, 2017, Swachh Bharat Mission (Urban) has been implemented in all 80 statutory towns & cities in Haryana. Around 24,986 individual household toilets out of the targeted 1,06,373 have been built, and around 1,679 public toilets have been constructed out of the target of 10,394.</li><br><li>In Haryana, 10 towns - Panipat, Sirsa, Mandi Dabwali, Thanesar, Pehowa, Ladwa, Shahbad, Kalanwali, Ellenabad & Rania - have been declared & certified as Open Defecation Free.</li><br><li>The state\'s 20 cities & towns are included in the AMRUT Mission. A total investment of US$ 378.4 million has been approved under this mission for providing water taps to all urban households in mission cities as 1 st priority, besides improving sewerage & drainage networks, non-motorised urban transport & providing open spaces. Total central assistance of US$ 113.64 million has been approved for Haryana under Atal Mission.</li><br><li>Panipat, Sonipat, Ambala, Ambala Sadar, Bahadurgarh, Hissar, Karnal, Rohtak, Bhiwani, Jagadhari, Palwal, Sirsa, Faridabad, Jind, Panchkukla, Thanesar, Gurgaon, Kaithal, Rewari & Yamuna Nagar are the AMRUT cities of Haryana</li><br><li>Investment worth US$ 386.73 million has been approved under the Smart City Plan of Faridabad. Karnal and Faridabad have been included in Smart City Mission.</li><br><li>Under Pradhan Mantri Awas Yojana (Urban) - Housing for All, US$ 50.28 million has been approved by the Ministry of Housing & Urban Poverty Alleviation for the construction of 4,299 houses. Central assistance of US$ 33.32 million has been approved for the</li><br><li>construction of this project, out of which US$ 17.7 million has been released to the state. Completion of construction of 958 houses for urban poor has also been announced.</li><br><li>In June 2017, the state ministry proposed to develop "Science city" by the National Council of Science Museums (NCSM) under Ministry of Culture. The total cost of the project will be worth US$ 28.41 million.</li><br><br></ul></div></div></div></div><br><br><br><br><!--<div class="container bgc-g">--><!--<div class="footer">--><!--<div class="row">--><!--<div class="col-md-4">--><!--<p>Disclamer</p>--><!--<p>Privacy Policy</p>--><!--<p>Hyperlinking Policy</p>--><!--<p>Copyright Statement</p>--><!--<p>Terms of Use</p>--><!--<p>Sitemap</p>--><!--</div>--><!--<div class="col-md-4">--><!--<p>Citizen Corner</p>--><!--<p>Feedback</p>--><!--<p>Content Review Policy</p>--><!--<p>Content Approval</p>--><!--<p>Content archival</p>--><!--<p>FAQ\'s</p>--><!--</div>--><!--<div class="col-md-4">--><!--<img src="img/logo_1.png" alt="" title="" class="img-responsive"><br>--><!--<p><strong>Visiter Count:</strong> 00-005-27-7</p>--><!--<p><strong>Last Update on: </strong> 6 July 2017</p>--><!--<p><strong>Site Best View In:</strong> Google Chrome, IE, Firefox </p>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--<br>--><!--<div class="header-1">--><!--<div class="container-fluid bgc-r">--><!--<p>&nbsp;</p><p>&nbsp;</p>--><!--</div>--><!--</div>--><!--<script type="text/javascript" src="js/jquery.js"></script>--><!--<script type="text/javascript" src="js/bootstrap.min.js"></script>--><!--<script type="text/javascript" src="js/script.js"></script>--></body></html>');
$templateCache.put('app/homeClearedServiceDocument/searchClearedHome.html','<div ng-cloak><div class="container"><div class="panel-heading"><h2 style="text-align: center;color: #0000cc">Third Party Verification</h2></div><div class="row"><div class="col-sm-4"><select class="form-control" name="serviceName"><option selected="selected">Name of Service/Department</option><option>Registration and Renewal of Boiler</option><option>Registration of Partnership firm</option><option>Registration of Societies</option><option>Cinema Registration</option><option>Tourism Events</option><option>Mobile Tower Approval</option></select></div><div class="col-sm-4"><input type="text" ng-model="vm.CAFPIN" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Enter CAF PIN (Composite Application Form)"></div><div class="btn-group col-sm-4"><button type="submit" ng-click="vm.getProject()" class="btn btn-info">Search</button></div></div><!--        <div class="row">--><!--            <h2 style="color: #0000cc">Third Party clarification links for Department</h2>--><!--        </div>--><div class="row"><div class="col-sm-4"><label>Departments wise Third Party Links</label></div></div><div class="row"><div class="col-sm-4" class="select_location"><div><a target="_blank" href="https://egovservices.in/#/clearanceReport">Chief Electrical Inspector</a></div><div><a target="_blank" href="https://hrylabour.gov.in/">Labour Department</a></div><div><a target="_blank" href="https://hrocmms.nic.in/OCMMS/allReports/consentThirdPartyVerification">Industries & Commerce</a></div><div><a target="_blank" href="https://hrocmms.nic.in/OCMMS/allReports/consentThirdPartyVerification">Haryana State Pollution Control Board</a></div><div><a target="_blank" href="https://online.ulbharyana.gov.in/Default_VerifyCertificate.aspx">Urban Local Bodies</a></div><div><a target="_blank" href="https://fdaharyana.gov.in/FDA-TrackLicenseApp">Health & Family Welfare</a></div><div><a target="_blank" href="https://hsiidcesewa.org.in/hsiidcprod/welcomeLink">HSIIDC</a></div><div><a target="_blank" href="https://lm.haryanafood.gov.in/lm/Search.aspx">FCS</a></div><div><a target="_blank" href="https://haryanatax.gov.in/HEXWAR/searchLicensesDetails.html">Excise & Taxation</a></div><div><a target="_blank" href="https://minesgeologyharyana.in/MinesAndGeology/thirdPartyAuth">Mines & Geology</a></div><div><a target="_blank" href="http://filmcell.prharyana.gov.in/eservices/search.aspx">DIPR</a></div><div><a target="_blank" href="https://fdaharyana.gov.in/FDA-TrackLicenseApp">Food and Drug Administration</a></div></div></div><div class="row" ng-show="vm.showtable"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><!--<th>Investor Name</th>--><th>Service Name</th><th>Status</th><th>Clearance Document</th></tr></thead><tbody><tr ng-repeat="project in vm.project | unique:\'comments\'"><td>{{project.comments}}</td><td>{{project.actionTaken}}</td><td><button class="btn btn-primary" id="myBtn" ng-click="vm.downFile(project)" ng-show="(project.fileName)" type="button">Download</button></td></tr></tbody></table></div><div ng-if="vm.noProject">No Projects Right Now.</div></div></div><br><br><br>');
$templateCache.put('app/incentive-wizard/incentivewizard.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Know Your Incentives</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Know Your Incentives</span></li></ol></div></section><br><div class="container"><h6 style="text-align:right" class="text-danger"><b>*Current View is Under Beta Testing</b></h6><h6 style="text-align:right" class="text-danger"><b>*For enquiries & feedback : hepc.helpdesk@gmail.com</b></h6><form name="incentivesForm" novalidate show-validation><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-body"><div class="form-horizontal"><fieldset><div class="form-group"><div class="col-sm-11 alert alert-dismissible alert-info"><strong>Project Details</strong></div><div class="col-sm-1"><label class="col-sm-12 control-label" ng-model="field.formfieldvalue"></label></div></div><div class="form-group"><label for="projectdistrict" class="control-label col-lg-3">District <span style="color: red">*</span></label><div class="col-md-3"><select name="projectdistrict" id="projectdistrict" title="Please select the district in which your enterprise/project is setup or planned to be setup" ng-change="vm.loadBlocksByDistrict()" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy:\'districtname\'" class="form-control" ng-model="vm.incentives.projectdistrict" required><option value="">Select</option></select></div></div><div ng-hide="vm.incentives.projectdistrict===undefined ||vm.incentives.projectdistrict===\'\'" class="form-group"><label for="projectblock" class="control-label col-lg-3">Block <span style="color: red">*</span></label><div class="col-md-3"><select name="projectblock" id="projectblock" class="form-control" title="Please select the block in which your enterprise/project is setup or planned to be setup" ng-options="block.blockName as block.blockName for block in vm.blocks | orderBy:\'blockName\'" ng-model="vm.incentives.projectblock" ng-change="vm.loadBlockType()" required><option value="">Select</option></select></div></div><div class="form-group" ng-show="vm.block != \'undefined\' && vm.block.blocktype != \'undefined\'"><label for="blocktype" class="control-label col-lg-3">Block Type<span style="color: red">*</span></label><div class="col-md-3"><input id="blocktype" name="blocktype" class="form-control" type="text" ng-model="vm.block.blockType" title="Select the District and Block above to automatically populate this field" required readonly="readonly"></div></div><div class="form-group"><label class="col-lg-3 control-label">Fixed Capital Investment (crores) <span style="color:red">*</span></label><div class=""><div class="col-lg-1"><input type="number" class="form-control" name="croresCost" placeholder="Crores" ng-model="vm.project_cost_in_crore" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0"><div ng-show="myform.croresCost.$invalid && myform.croresCost.$touched || myform.croresCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-1"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.project_cost_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99"><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-1"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.project_cost_in_thousands" ng-model="vm.project_cost_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99"><div ng-show="myform.thousandsCost.$invalid && myform.thousandsCost.$touched || myform.thousandsCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div><div class="" ng-show="vm.projecttype===\'manufacturing\' && !vm.projecttype===\'services\'"><div class="col-lg-1"><input type="number" class="form-control" name="croresCost" placeholder="Crores" ng-model="vm.project_cost_in_crore" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0"><div ng-show="myform.croresCost.$invalid && myform.croresCost.$touched || myform.croresCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-1"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.project_cost_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99"><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-1"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.project_cost_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99"><div ng-show="myform.thousandsCost.$invalid && myform.thousandsCost.$touched || myform.thousandsCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div></div><div class="form-group" ng-if="vm.showTurnOverInput"><label class="col-lg-3 control-label">Turn Over (crores) <span style="color:red">*</span></label><div class=""><div class="col-lg-1"><input type="number" class="form-control" name="croresTurnover" placeholder="Crores" ng-model="vm.project_turnover_in_crore" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInTurnover()" min="0"><div ng-show="myform.croresTurnover.$invalid && myform.croresTurnover.$touched || myform.croresTurnover.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-1"><input type="number" class="form-control" name="lacsTurnover" placeholder="lacs" ng-model="vm.project_turnover_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInTurnover()" min="0" max="99"><div ng-show="myform.lacsTurnover.$invalid && myform.lacsTurnover.$touched || myform.lacsTurnover.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-1"><input type="number" class="form-control" name="thousandsTurnover" placeholder="thousands" ng-model="vm.project_turnover_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInTurnover()" min="0" max="99"><div ng-show="myform.thousandsTurnover.$invalid && myform.thousandsTurnover.$touched || myform.thousandsTurnover.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div></div><div class="form-group"><label for="projecttype" class="control-label col-lg-3">Project Type<span style="color: red">*</span></label><div class="col-md-3"><input id="projecttype" name="projecttype" class="form-control" type="text" ng-model="vm.incentives.projectSize" title="Select the District and Block above to automatically populate this field" required readonly="readonly"></div></div><div class="form-group"><label for="projectcategory" class="control-label col-lg-3">Project Category<span style="color: red">*</span></label><div class="col-md-3"><select id="projectcategory" name="projectcategory" ng-change="vm.loadProjectType(vm.projecttype)" title="Please select the category of your enterprise/project based on the following: " class="form-control" ng-model="vm.projecttype" required><option value="services" title="Enterprises engaged in the manufacture or production of goods pertaining to any industry">Services</option><option value="manufacturing" title="Enterprises engaged in providing or rendering of services">Manufacturing</option></select></div><button class="btn btn-default btn-circle" uk-toggle="target: #modal4" title="More info..."><span uk-toggle="target: #modal4" class="glyphicon glyphicon-question-sign"></span></button></div><div class="form-group"><label for="conformsToRestrictiveList" class="control-label col-lg-3">Does your business fall under the Restrictive List?<span style="color: red">*</span></label><div class="col-md-3"><select id="conformsToRestrictiveList" name="conformsToRestrictiveList" class="form-control" ng-model="vm.incentives.conformsToRestrictiveList" required><option value="Y" title="Yes">Yes</option><option value="N" title="No">No</option></select></div></div><div class="form-group" ng-if="vm.projecttype === \'services\'"><label for="subSector" class="control-label col-lg-3">Service Sub Sector<span style="color: red">*</span></label><div class="col-md-3"><select id="subSector" name="subSector" class="form-control" ng-model="vm.incentives.subSector" required><option value="IT & ITeS" title="IT & ITeS">IT & ITeS</option><option value="Logistics" title="Logistics">Logistics</option><option value="Research & Development (R&D)" title="Research & Development (R&D)">Research & Development (R&D)</option><option value="Healthcare" title="Healthcare">Healthcare</option><option value="Education" title="Yes">Education</option><option value="Tourism" title="Tourism">Tourism</option><option value="None of the Above" title="None of the Above">None of the Above</option></select></div></div><div class="form-group" ng-if="vm.projecttype === \'manufacturing\' && vm.incentives.conformsToRestrictiveList ===\'N\'"><label for="thrustSector" class="control-label col-lg-3">Thurst Sector<span style="color: red">*</span></label><div class="col-md-3"><select id="thrustSector" name="thrustSector" class="form-control" ng-model="vm.incentives.thrustSector" required><option value="Agro-based, Food Processing & Allied Industry">Agro-based, Food Processing & Allied Industry</option><option value="Textile and Apparel">Textile and Apparel</option><option value="Auto, Auto Components & Light Engineering">Auto, Auto Components & Light Engineering</option><option value="Electronics System Design & Manufacturing (ESDM)">Electronics System Design & Manufacturing (ESDM)</option><option value="Defence and Aerospace Manufacturing">Defence and Aerospace Manufacturing</option><option value="Pharmaceutical & Medical Devices">Pharmaceutical & Medical Devices</option><option value="Chemical and Petrochemicals">Chemical and Petrochemicals</option><option value="Large Scale Energy and Data Storage">Large Scale Energy and Data Storage</option><option value="None of the Above">None of the Above</option></select></div></div><div class="form-group" ng-if="vm.projecttype === \'manufacturing\' && vm.showStartup"><label for="startupCompany" class="control-label col-lg-3">Start Up?<span style="color: red">*</span></label><div class="col-md-3"><select id="startupCompany" name="startupCompany" class="form-control" ng-model="vm.incentives.startupCompany" required><option value="Y" title="Yes">Yes</option><option value="N" title="No">No</option></select></div></div><div class="form-group" ng-if="(vm.projecttype === \'manufacturing\' && vm.incentives.conformsToRestrictiveList ===\'N\') && (vm.projectSize === \'Micro\' || vm.projectSize === \'Small\' || vm.projectSize === \'Medium\')"><label for="sectorEnterPrise" class="control-label col-lg-3">Essential Sector Enterprise?<span style="color: red">*</span></label><div class="col-md-3"><select id="sectorEnterPrise" name="sectorEnterPrise" class="form-control" ng-model="vm.incentives.sectorEnterPrise" required><option value="Y" title="Yes">Yes</option><option value="N" title="No">No</option></select></div></div><div class="form-group" ng-if="vm.projecttype === \'manufacturing\' && vm.incentives.conformsToRestrictiveList ===\'N\'"><label for="importSubstitutionEnterprise" class="control-label col-lg-3">Import Substituion Enterprise?<span style="color: red">*</span></label><div class="col-md-3"><select id="importSubstitutionEnterprise" name="importSubstitutionEnterprise" class="form-control" ng-model="vm.incentives.importSubstitutionEnterprise" required><option value="Y" title="Yes">Yes</option><option value="N" title="No">No</option></select></div></div><div class="form-group" ng-if="(vm.projecttype === \'manufacturing\' && vm.incentives.conformsToRestrictiveList ===\'N\') && (vm.projectSize === \'Micro\' || vm.projectSize === \'Small\')"><label for="exportOriented" class="control-label col-lg-3">Export Oriented<span style="color: red">*</span></label><div class="col-md-3"><select id="exportOriented" name="exportOriented" class="form-control" ng-model="vm.incentives.exportOriented" required><option value="Y" title="Yes">Yes</option><option value="N" title="No">No</option></select></div></div><div class="form-group" ng-if="vm.projecttype === \'manufacturing\' && vm.incentives.conformsToRestrictiveList ===\'N\'"><label for="outsideMunicipalLimits" class="control-label col-lg-3">Outside Municipal Limits?<span style="color: red">*</span></label><div class="col-md-3"><select id="outsideMunicipalLimits" name="outsideMunicipalLimits" class="form-control" ng-model="vm.incentives.outsideMunicipalLimits" required><option value="Y" title="Yes">Yes</option><option value="N" title="No">No</option></select></div></div><div class="form-group" ng-if="vm.projecttype === \'services\'"><label for="infrastructureRelated" class="control-label col-lg-3">Infrastructure Related?<span style="color: red">*</span></label><div class="col-md-3"><select id="infrastructureRelated" name="infrastructureRelated" class="form-control" ng-model="vm.incentives.infrastructureRelated" required><option value="Y" title="Yes">Yes</option><option value="N" title="No">No</option></select></div></div><div class="form-group" ng-if="vm.projecttype === \'manufacturing\' && vm.incentives.conformsToRestrictiveList ===\'N\'"><label for="renewable" class="control-label col-lg-3">Renewable?<span style="color: red">*</span></label><div class="col-md-3"><select id="renewable" name="renewable" class="form-control" ng-model="vm.incentives.renewable" required><option value="Y" title="Yes">Yes</option><option value="N" title="No">No</option></select></div></div><div class="form-group"><!--                                <div class="col-sm-11 alert alert-dismissible alert-info"><strong>Project Sector Details</strong></div>--><div class="col-sm-1"><label class="col-sm-12 control-label" ng-model="field.formfieldvalue"></label></div></div></fieldset></div></div><div class="panel-heading"><button ng-disabled="incentivesForm.$invalid" type="button" data-toggle="modal" data-target="#incentivesModal" class="btn btn-primary" data-dpmaxz-eid="12">View Incentives</button></div></div></div></form></div><div class="modal fade" id="incentivesModal" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog" ng-show="!vm.isConfirmed || !vm.showIncentives"><!-- Modal content--><form name="form" role="form" novalidate show-validation><div class="modal-content"><div class="modal-header"><h4 class="modal-title"><b>Kindly verify the information regarding your enterprise/project:</b></h4></div><div class="modal-body col-md-12"><div class="table table-responsive"><table><tbody><tr><td>Total applicable investment:</td><td>INR <code style="font-size:18px">{{ vm.total_project_cost }}</code> Crores</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.getConfirmation()">Confirm</button> <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button></div></div></form></div><div class="modal-dialog modal-lg" role="document" ng-show="vm.isConfirmed && vm.showIncentives"><div class="modal-content"><div class="modal-header"><h5 class="uk-modal-title" id="exampleModalLongTitle">{{vm.incentives.businessentity}}</h5></div><div class="modal-body"><div class="row"><div class="col-md-2"><span class="uk-label" style="font-size: 12px">Project Size:</span></div><div class="col-md-2"><span>{{vm.incentives.projectSize}}</span></div><div class="col-md-2"><span class="uk-label uk-label-danger" style="font-size: 12px">Project District:</span></div><div class="col-md-1"><span>{{vm.incentives.projectdistrict}}</span></div></div><br><div class="row"><div class="col-md-2"><span class="uk-label uk-label-success" style="font-size: 12px">Project Block:</span></div><div class="col-md-2"><span>{{vm.incentives.projectblock}}</span></div><div class="col-md-2"><span class="uk-label uk-label-warning" style="font-size: 12px">Block Type:</span></div><div class="col-md-1"><span>{{vm.block.blockType}}</span></div></div><br><!--                <input class="form-control" id="myInput" type="text" placeholder="Search Keywords...">--><br><h4 class="text-center" ng-show="vm.notIncentivesFound">No Incentives Available for your Block</h4><h4 class="text-center" ng-show="vm.isLoadingIncentives">Loading Incentives for your Block</h4><table class="table table-striped table-hover table-bordered" ng-hide="vm.incentivesData && vm.incentivesData.length === 0"><thead><tr class="row"><th class="text-center bg-primary col-md-12" style="font-size: 18px">Incentives (Click to expand)</th></tr></thead><tbody id="myTable1"><tr ng-repeat="incentive in vm.incentivesData track by $index" class="row"><td class="bg-info col-md-6"><div class=""><a style="font-size: 18px" ui-sref="newincentiveswizard" data-toggle="collapse" href="#{{\'acc\'+($index+1)}}" role="button" aria-expanded="false" aria-controls="collapseExample">{{incentive.referenceNumber}}. &nbsp;<b>{{incentive.incentiveCategory}}:</b></a><div class="collapse" id="{{\'acc\'+($index+1)}}"><div class="col-md-11"><p class="text-success" style="font-size: 16px"><span style="font-size:18px"><b>\u1D25</b></span>{{incentive.rawNote}}</p></div><div class="col-md-1" style="border-left: 1px solid; margin-top: 10px; margin-bottom: 10px; padding-top: 20px; padding-bottom: 20px"><div><a data-balloon-length="xlarge" data-balloon="{{ incentive.rawNote }}" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><!--<p class="text-warning" style="font-size: 12px" ng-show="incentive.remarks !== null">* {{ incentive.remarks }}</p>--></div></div></td></tr></tbody></table><br><br><!--Incentives with sector type--><table class="table table-striped table-hover table-bordered" ng-hide="vm.result.incentives.length===0 || vm.isEPPOnly"><thead><tr class="row"><th class="text-center bg-primary col-md-12" style="font-size: 20px">Incentives (Click to expand)</th></tr></thead><tbody id="myTable2"><tr ng-repeat="incentive in vm.eppWithSector.incentives track by $index" class="row"><td class="bg-info col-md-6"><div class=""><a style="font-size: 18px" ui-sref="incentiveswizard" data-toggle="collapse" href="#{{\'accc\'+($index+1)}}" role="button" aria-expanded="false" aria-controls="collapseExample"><b>{{incentive.name}}:</b></a><div class="collapse" id="{{\'accc\'+($index+1)}}"><div ng-show="incentive.value1 !== null || incentive.value2 !== null" style="text-align: justify"><p class="text-success" style="font-size: 16px"><b><u>As per HARYANA ENTERPRISES & EMPLOYMENT POLICY (HEEP)-2020</u></b></p><div class="col-md-11"><div ng-hide="incentive.constraints1 == null"><p class="text-success" style="font-size: 16px"><span style="font-size:18px"><b>\u1D25</b></span>{{" " + incentive.constraints1}}</p></div><div ng-hide="incentive.constraints2 == null"><p class="text-success" style="font-size: 16px">AND<br><span style="font-size:18px"><b>\u1D25</b></span>{{" " + incentive.constraints2}}</p></div></div><div ng-hide="incentive.remarks1 == null" class="col-md-1" style="border-left: 1px solid; margin-top: 10px; margin-bottom: 10px; padding-top: 20px; padding-bottom: 20px"><div><a data-balloon-length="xlarge" data-balloon="{{ incentive.remarks1 }}" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a><!--<p class="text-warning" style="font-size: 12px">*{{ incentive.remarks1 }}</p>--></div></div><br><div class="col-md-11"><div ng-hide="incentive.constraints3 == null"><p class="text-success" style="font-size: 16px"><span class="text-warning"><b>OR</b></span><br><span style="font-size:18px"><b>\u1D25</b></span>{{" " + incentive.constraints3}}</p></div><div ng-hide="incentive.constraints4 == null"><p class="text-success" style="font-size: 16px">AND<br><span style="font-size:18px"><b>\u1D25</b></span>{{" " + incentive.constraints4}}</p></div></div><div ng-hide="incentive.remarks2 == null" class="col-md-1" style="border-left: 1px solid; margin-top: 10px; margin-bottom: 10px; padding-top: 20px; padding-bottom: 20px"><div><a data-balloon-length="xlarge" data-balloon="{{ incentive.remarks2 }}" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span>`</a><!--<p class="text-warning" style="font-size: 12px">*{{ incentive.remarks2 }}</p>--></div></div></div></div></div></td></tr></tbody></table></div><div class="modal-footer"><button class="btn btn-default pull-right" ng-click="vm.dismiss()">Close</button></div></div></div></div><div id="modal2" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1"><tbody><tr><td><strong>Project Type</strong></td><td><strong>Definition</strong></td></tr><tr><td>Ultra Mega Project</td><td>Projects in manufacturing enterprises, Tourism, wholesale markets and Logistics etc. with investments minimum of US$ 1 billion (Rs. 6000 crore) on land area of minimum 500 acres</td></tr><tr><td>Mega Project</td><td>Fixed capital investment of &gt; 100 Crores<br>OR<br>direct employment of &gt; 200 persons in block D<br>OR<br>direct employment of &gt; 500 persons in block B &amp; C</td></tr><tr><td>Large Project</td><td>Investment in plant and machinery is &gt; 10 Crores and &lt;= 100 Crores</td></tr><tr><td>Medium Enterprise</td><td>Investment in plant and machinery &gt; 5 Crores &amp; &lt;= 10 crore</td></tr><tr><td>Small Enterprise</td><td>Investment in plant and machinery &gt; 25 Lakhs &amp; &lt;= 5 crore</td></tr><tr><td>Micro Enterprise</td><td>Investment in plant and machinery &lt;=25 Lakhs</td></tr></tbody></table></div></div></div><div id="modal3" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1"><tbody><tr><td><strong>Project Type</strong></td><td><strong>Definition</strong></td></tr><tr><td>Ultra Mega Project</td><td>Projects in manufacturing enterprises, Tourism, wholesale markets and Logistics etc. with investments minimum of US$ 1 billion (Rs. 6000 crore) on land area of minimum 500 acres</td></tr><tr><td>Mega Project</td><td>Fixed capital investment of &gt; 100 Crores<br>OR<br>direct employment of &gt; 200 persons in block D<br>OR<br>direct employment of &gt; 500 persons in block B &amp; C</td></tr><tr><td>Large Service Enterprise</td><td>Investment in building &amp; equipment &gt; 5 Crores</td></tr><tr><td>Medium Service Enterprise</td><td>Investment in equipment &gt; 2 Crores &amp; &lt; 5 Crores</td></tr><tr><td>Small Service Enterprise</td><td>Investment in equipment &gt; 10 Lakhs &amp; &lt; 2 Crores</td></tr><tr><td>Micro Service Enterprise</td><td>Investment in equipment &lt; 10 Lakhs</td></tr></tbody></table></div></div></div><div id="modal4" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1">Please select the category of your enterprise/project based on the following:<tbody><tr><td><b>Manufacturing Enterprises</b></td><td>Enterprises engaged in the manufacture or production of goods pertaining to any industry</td></tr><tr><td><b>Services Enterprises</b></td><td>Enterprises engaged in providing or rendering of services</td></tr></tbody></table></div></div></div><div id="modal5" uk-modal><div class="uk-modal-dialog container">Please select the district in which your enterprise/project is setup or planned to be setup</div></div><div id="modal6" uk-modal><div class="uk-modal-dialog container">Please select the block in which your enterprise/project is setup or planned to be setup</div></div><div id="modal7" uk-modal><div class="uk-modal-dialog container">Please select the block type (as specified in the Haryana Enterprise Promotion Policy 2015) in which your enterprise/project is setup or planned to be setup</div></div><div id="modal8" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1">Please select the industry sector which your enterprise/project falls under<tbody><tr><td>Auto, Auto Components and Light Engineering</td></tr><tr><td>Agro based, Food Processing & Allied Industry</td></tr><tr><td>Textiles/Apparel/Technical textiles</td></tr><tr><td>Footwear & Accessories</td></tr><tr><td>Electronics</td></tr><tr><td>IT/ITeS</td></tr><tr><td>Defence & Aerospace Manufacturing</td></tr><tr><td>Renewable Energy & Solar Parks</td></tr><tr><td>Pharmaceutical & Chemical Industry</td></tr><tr><td>Other</td></tr></tbody></table></div></div></div><script>$(document).ready(function(){\n        $("#myInput").on("keyup", function() {\n            var value = $(this).val().toLowerCase();\n            $("#myTable1 tr").filter(function() {\n                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)\n            });\n            $("#myTable2 tr").filter(function() {\n                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)\n            });\n        });\n    });</script><style>.tip {\n        border-bottom: 1px dotted [template("base font color")];\n        position: relative;\n        cursor: help;\n        text-decoration: none;\n        color: inherit;\n    }\n    .tip span {\n        display: none;\n        z-index: 100;\n        position: absolute;\n        padding: .6em;\n        padding-left: 1em;\n        top: 1.5em;\n        left: 2.4em;\n        width: 10em;\n        background-color: [template("page background color")];\n        border: 1px solid [template("base font color")];\n        border-radius: 0.5em;\n    }\n    .tip:hover span {\n        display: inline-block;\n    }\n    .sg-question-set,\n    .sg-type-radio ul.sg-list-vertical li,\n    .sg-type-checkbox ul.sg-list-vertical li,\n    .sg-question-options,\n    .sg-type-radio-likert .sg-question-options,\n    .sg-type-table .sg-question-options,\n    .sg-instructions\n    {\n        overflow: visible;\n    }</style><!--<div id="confirmation1" class="modal fade" role="dialog">--><!--<div class="modal-dialog">--><!--&lt;!&ndash; Modal content&ndash;&gt;--><!--<form name="form" role="form" novalidate ng-submit="vm.calculateIncentives()" show-validation>--><!--<div class="modal-content">--><!--<div class="modal-header">--><!--<h4 class="modal-title" id="Rate"><b>Please confirm your inputs:</b></h4>--><!--</div>--><!--<div class="modal-body col-md-12">--><!--asdfghjkl--><!--</div>--><!--<div class="modal-footer">--><!--<button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.calculateIncentives()">Confirm</button>--><!--<button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>--><!--</div>--><!--</div>--><!--</form>--><!--</div>--><!--</div>--><script type="text/javascript">$(document).ready(function(){\n        $(".tooltipex").tooltip({\n\n        });\n    });</script><style>.glass{\n        /* background styles */\n        position: relative;\n        display: inline-block;\n        background-color: green; /*for compatibility with older browsers*/\n        background-image: linear-gradient(green,lightgreen);\n\n        /* text styles */\n        text-decoration: none;\n        color: #fff;\n        font-family: sans-serif;\n        font-weight: 100;\n\n        border-radius: 3px;\n        box-shadow: 0px 1px 4px -2px #333;\n        text-shadow: 0px -1px #333;\n    }\n    .glass:after{\n        content: \'\';\n        position: absolute;\n        top: 2px;\n        left: 2px;\n        width: calc(100% - 4px);\n        height: 50%;\n        background: linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.2));\n    }\n\n    .glass:hover{\n        background: linear-gradient(#073,#0fa);\n    }</style>');
$templateCache.put('app/incentive-wizard/oldincentivewizard.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Know Your Incentives</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Know Your Incentives</span></li></ol></div></section><br><div class="container"><h6 style="text-align:right" class="text-danger"><b>*Current View is Under Beta Testing</b></h6><h6 style="text-align:right" class="text-danger"><b>*For enquiries & feedback : hepc.helpdesk@gmail.com</b></h6><form name="incentivesForm" novalidate show-validation><div class="panel-group" id="accordion"><div class="panel panel-default"><div class="panel-body"><div class="form-horizontal"><fieldset><div class="form-group"><div class="col-sm-11 alert alert-dismissible alert-info"><strong>Project Details</strong></div><div class="col-sm-1"><label class="col-sm-12 control-label" ng-model="field.formfieldvalue"></label></div></div><div class="form-group"><label for="projectcategory" class="control-label col-lg-3">Project Category<span style="color: red">*</span></label><div class="col-md-3"><select id="projectcategory" name="projectcategory" ng-change="vm.loadProjectType(vm.projecttype)" title="Please select the category of your enterprise/project based on the following: " class="form-control" ng-model="vm.projecttype" required><option value="services" title="Enterprises engaged in the manufacture or production of goods pertaining to any industry">Services</option><option value="manufacturing" title="Enterprises engaged in providing or rendering of services">Manufacturing</option></select></div><button class="btn btn-default btn-circle" uk-toggle="target: #modal4" title="More info..."><span uk-toggle="target: #modal4" class="glyphicon glyphicon-question-sign"></span></button></div><div class="form-group"><label for="projectdistrict" class="control-label col-lg-3">District <span style="color: red">*</span></label><div class="col-md-3"><select name="projectdistrict" id="projectdistrict" title="Please select the district in which your enterprise/project is setup or planned to be setup" ng-change="vm.loadBlocksByDistrict()" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy:\'districtname\'" class="form-control" ng-model="vm.incentives.projectdistrict" required><option value="">Select</option></select></div></div><div ng-hide="vm.incentives.projectdistrict===undefined ||vm.incentives.projectdistrict===\'\'" class="form-group"><label for="projectblock" class="control-label col-lg-3">Block <span style="color: red">*</span></label><div class="col-md-3"><select name="projectblock" id="projectblock" class="form-control" title="Please select the block in which your enterprise/project is setup or planned to be setup" ng-options="block.blockname as block.blockname for block in vm.blocks | orderBy:\'blockname\'" ng-model="vm.incentives.projectblock" ng-change="vm.loadBlockType()" required><option value="">Select</option></select></div></div><div class="form-group" ng-show="vm.block != \'undefined\' && vm.block.blocktype != \'undefined\'"><label for="blocktype" class="control-label col-lg-3">Block Type<span style="color: red">*</span></label><div class="col-md-3"><input id="blocktype" name="blocktype" class="form-control" type="text" ng-model="vm.block.blocktype" title="Select the District and Block above to automatically populate this field" required readonly="readonly"></div></div><div class="form-group"><label for="employment" class="control-label col-lg-3">Estimated Total Employment<span style="color: red">*</span></label><div class="col-md-3"><input id="employment" name="employment" class="form-control" type="number" ng-model="vm.employment" title="Please enter the total number of persons proposed to be employed in the enterprise/project" min="0" required></div></div><div class="form-group"><label for="employmentHaryana" class="control-label col-lg-3">Estimated employment from Haryana State<span style="color: red">*</span></label><div class="col-md-3"><input id="employmentHaryana" name="employmentHaryana" class="form-control" type="number" min="0" ng-model="vm.employmentHaryana" title="Please enter the number of persons belonging to Haryana proposed to be employed in the enterprise/project" required></div></div><div class="form-group"><label for="landArea" class="control-label col-lg-3">Land Area (in Acres) of the proposed unit<span style="color: red">*</span></label><div class="col-md-3"><input id="landArea" name="landArea" class="form-control" type="number" ng-model="vm.landArea" min="0" title="Land Area" required></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">acres</small></div><div class="form-group"><label ng-show="vm.projecttype===\'services\'" class="col-lg-3 control-label">Investment in equipment(in Crore) <span style="color:red">*</span></label><label ng-show="vm.projecttype===\'manufacturing\'" class="col-lg-3 control-label">Investment in plant and machinery(in Crore) <span style="color:red">*</span></label><div class="" vm.show="vm.projecttype===\'services\' && !vm.projecttype===\'manufacturing\'"><div class="col-lg-1"><input type="number" class="form-control" name="croresCost" placeholder="Crores" ng-model="vm.project_cost_in_crore" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" required><div ng-show="myform.croresCost.$invalid && myform.croresCost.$touched || myform.croresCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-1"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.project_cost_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-1"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.project_cost_in_thousands" ng-model="vm.project_cost_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="myform.thousandsCost.$invalid && myform.thousandsCost.$touched || myform.thousandsCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div><div class="" ng-show="vm.projecttype===\'manufacturing\' && !vm.projecttype===\'services\'"><div class="col-lg-1"><input type="number" class="form-control" name="croresCost" placeholder="Crores" ng-model="vm.project_cost_in_crore" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" required><div ng-show="myform.croresCost.$invalid && myform.croresCost.$touched || myform.croresCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-1"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.project_cost_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-1"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.project_cost_in_thousands" ng-model="vm.project_cost_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" required><div ng-show="myform.thousandsCost.$invalid && myform.thousandsCost.$touched || myform.thousandsCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div></div><div class="form-group"><label for="projecttype" class="control-label col-lg-3">Project Type<span style="color: red">*</span></label><div class="col-md-3"><input id="projecttype" name="projecttype" class="form-control" type="text" ng-model="vm.calculatedProjectType" title="Select the District and Block above to automatically populate this field" required readonly="readonly"></div></div><div class="form-group"><div class="col-sm-11 alert alert-dismissible alert-info"><strong>Project Sector Details</strong></div><div class="col-sm-1"><label class="col-sm-12 control-label" ng-model="field.formfieldvalue"></label></div></div><div class="form-group"><label for="projectsector" class="control-label col-lg-3">Sector</label><div class="col-md-3"><select id="projectsector" name="projectsector" class="form-control" ng-model="vm.incentives.projectsector" ng-change="vm.getSelectedSector(vm.incentives.projectsector)" title="Please select the industry sector which your enterprise/project falls under" required><option value="All">Select Sector</option><option value="Auto, Auto Components and Light Engineering">Auto, Auto Components and Light Engineering</option><option value="Agro">Agro based, Food Processing & Allied Industry</option><option value="Textiles">Textiles/Apparel/Technical textiles</option><option value="Footwear">Footwear & Accessories</option><option value="Electronics">Electronics</option><option value="IT/ITeS">IT/ITeS</option><option value="Defence & Aerospace Manufacturing">Defence & Aerospace Manufacturing</option><option value="Renewable Energy & Solar Parks">Renewable Energy & Solar Parks</option><option value="Pharmaceutical & Chemical Industry">Pharmaceutical & Chemical Industry</option><option value="Other">Other</option></select></div><button class="btn btn-default btn-circle" uk-toggle="target: #modal8" title="More info..."><span class="glyphicon glyphicon-question-sign"></span></button></div></fieldset></div></div><div class="panel-heading"><button ng-disabled="vm.incentives.projectdistrict == undefined || vm.block == undefined || vm.block.blocktype == undefined || vm.employment == undefined || vm.employmentHaryana == undefined || vm.landArea == undefined || vm.total_project_cost == undefined" type="button" data-toggle="modal" data-target="#incentivesModal" class="btn btn-primary" data-dpmaxz-eid="12">View Incentives</button></div></div></div></form></div><div class="modal fade" id="incentivesModal" tabindex="-1" role="dialog" aria-hidden="true"><div class="modal-dialog" ng-show="!vm.isConfirmed || !vm.showIncentives"><!-- Modal content--><form name="form" role="form" novalidate show-validation><div class="modal-content"><div class="modal-header"><h4 class="modal-title"><b>Kindly verify the information regarding your enterprise/project:</b></h4></div><div class="modal-body col-md-12"><div class="table table-responsive"><table><tbody><tr><td>Total applicable investment:</td><td>INR <code style="font-size:18px">{{ vm.total_project_cost }}</code> Crores</td></tr><tr><td>Estimated Total Employment:</td><td><code style="font-size:18px">{{ vm.employment }}</code> Persons</td></tr><tr><td>Estimated Employment from Haryana:</td><td><code style="font-size:18px">{{ vm.employmentHaryana }}</code> Persons</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.getConfirmation()">Confirm</button> <button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button></div></div></form></div><div class="modal-dialog modal-lg" role="document" ng-show="vm.isConfirmed && vm.showIncentives"><div class="modal-content"><div class="modal-header"><h5 class="uk-modal-title" id="exampleModalLongTitle">{{vm.incentives.businessentity}}</h5></div><div class="modal-body"><div class="row"><div class="col-md-2"><span class="uk-label" style="font-size: 12px">Project SIze:</span></div><div class="col-md-2"><span>{{vm.result.projectsize}}</span></div><div class="col-md-2"><span class="uk-label uk-label-danger" style="font-size: 12px">Project District:</span></div><div class="col-md-1"><span>{{vm.incentives.projectdistrict}}</span></div></div><br><div class="row"><div class="col-md-2"><span class="uk-label uk-label-success" style="font-size: 12px">Project Block:</span></div><div class="col-md-2"><span>{{vm.incentives.projectblock}}</span></div><div class="col-md-2"><span class="uk-label uk-label-warning" style="font-size: 12px">Block Type:</span></div><div class="col-md-1"><span>{{vm.block.blocktype}}</span></div></div><br><input class="form-control" id="myInput" type="text" placeholder="Search Keywords..."><br><h4 class="text-center" ng-show="vm.result.incentives.length===0">No Incentives Available for your Block</h4><table class="table table-striped table-hover table-bordered" ng-hide="vm.result.incentives.length===0 || !vm.isEPPOnly"><thead><tr class="row"><th class="text-center bg-primary col-md-12" style="font-size: 18px">Incentives (Click to expand)</th></tr></thead><tbody id="myTable1"><tr ng-repeat="incentive in vm.result.incentives track by $index" class="row"><td class="bg-info col-md-6"><div class=""><a style="font-size: 18px" ui-sref="incentiveswizard" data-toggle="collapse" href="#{{\'acc\'+($index+1)}}" role="button" aria-expanded="false" aria-controls="collapseExample"><b>{{incentive.name}}:</b></a><div class="collapse" id="{{\'acc\'+($index+1)}}"><p class="text-success" style="font-size: 16px"><b><u>As per ENTERPRISES PROMOTION POLICY-2015</u></b></p><div class="col-md-11"><p class="text-success" style="font-size: 16px" ng-show="incentive.constraints1 !== null"><span style="font-size:18px"><b>\u1D25</b></span>{{" " + incentive.constraints1}}</p><p class="text-success" style="font-size: 16px" ng-show="incentive.constraints2 !== null">AND<br><span style="font-size:18px"><b>\u1D25</b></span>{{" " + incentive.constraints2}}</p></div><div ng-hide="incentive.remarks == null" class="col-md-1" style="border-left: 1px solid; margin-top: 10px; margin-bottom: 10px; padding-top: 20px; padding-bottom: 20px"><div><a data-balloon-length="xlarge" data-balloon="{{ incentive.remarks }}" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a></div></div><!--<p class="text-warning" style="font-size: 12px" ng-show="incentive.remarks !== null">* {{ incentive.remarks }}</p>--></div></div></td></tr></tbody></table><br><br><!--Incentives with sector type--><table class="table table-striped table-hover table-bordered" ng-hide="vm.result.incentives.length===0 || vm.isEPPOnly"><thead><tr class="row"><th class="text-center bg-primary col-md-12" style="font-size: 20px">Incentives (Click to expand)</th></tr></thead><tbody id="myTable2"><tr ng-repeat="incentive in vm.eppWithSector.incentives track by $index" class="row"><td class="bg-info col-md-6"><div class=""><a style="font-size: 18px" ui-sref="incentiveswizard" data-toggle="collapse" href="#{{\'accc\'+($index+1)}}" role="button" aria-expanded="false" aria-controls="collapseExample"><b>{{incentive.name}}:</b></a><div class="collapse" id="{{\'accc\'+($index+1)}}"><div ng-show="incentive.value1 !== null || incentive.value2 !== null" style="text-align: justify"><p class="text-success" style="font-size: 16px"><b><u>As per ENTERPRISES PROMOTION POLICY-2015</u></b></p><div class="col-md-11"><div ng-hide="incentive.constraints1 == null"><p class="text-success" style="font-size: 16px"><span style="font-size:18px"><b>\u1D25</b></span>{{" " + incentive.constraints1}}</p></div><div ng-hide="incentive.constraints2 == null"><p class="text-success" style="font-size: 16px">AND<br><span style="font-size:18px"><b>\u1D25</b></span>{{" " + incentive.constraints2}}</p></div></div><div ng-hide="incentive.remarks1 == null" class="col-md-1" style="border-left: 1px solid; margin-top: 10px; margin-bottom: 10px; padding-top: 20px; padding-bottom: 20px"><div><a data-balloon-length="xlarge" data-balloon="{{ incentive.remarks1 }}" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span></a><!--<p class="text-warning" style="font-size: 12px">*{{ incentive.remarks1 }}</p>--></div></div><br><div class="col-md-11"><div ng-hide="incentive.constraints3 == null"><p class="text-success" style="font-size: 16px"><span class="text-warning"><b>OR</b></span><br><span style="font-size:18px"><b>\u1D25</b></span>{{" " + incentive.constraints3}}</p></div><div ng-hide="incentive.constraints4 == null"><p class="text-success" style="font-size: 16px">AND<br><span style="font-size:18px"><b>\u1D25</b></span>{{" " + incentive.constraints4}}</p></div></div><div ng-hide="incentive.remarks2 == null" class="col-md-1" style="border-left: 1px solid; margin-top: 10px; margin-bottom: 10px; padding-top: 20px; padding-bottom: 20px"><div><a data-balloon-length="xlarge" data-balloon="{{ incentive.remarks2 }}" data-balloon-pos="up"><span class="glyphicon glyphicon-question-sign"></span>`</a><!--<p class="text-warning" style="font-size: 12px">*{{ incentive.remarks2 }}</p>--></div></div></div></div></div></td></tr></tbody></table></div><div class="modal-footer"><button class="btn btn-default pull-right" ng-click="vm.dismiss()">Close</button></div></div></div></div><div id="modal2" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1"><tbody><tr><td><strong>Project Type</strong></td><td><strong>Definition</strong></td></tr><tr><td>Ultra Mega Project</td><td>Projects in manufacturing enterprises, Tourism, wholesale markets and Logistics etc. with investments minimum of US$ 1 billion (Rs. 6000 crore) on land area of minimum 500 acres</td></tr><tr><td>Mega Project</td><td>Fixed capital investment of &gt; 100 Crores<br>OR<br>direct employment of &gt; 200 persons in block D<br>OR<br>direct employment of &gt; 500 persons in block B &amp; C</td></tr><tr><td>Large Project</td><td>Investment in plant and machinery is &gt; 10 Crores and &lt;= 100 Crores</td></tr><tr><td>Medium Enterprise</td><td>Investment in plant and machinery &gt; 5 Crores &amp; &lt;= 10 crore</td></tr><tr><td>Small Enterprise</td><td>Investment in plant and machinery &gt; 25 Lakhs &amp; &lt;= 5 crore</td></tr><tr><td>Micro Enterprise</td><td>Investment in plant and machinery &lt;=25 Lakhs</td></tr></tbody></table></div></div></div><div id="modal3" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1"><tbody><tr><td><strong>Project Type</strong></td><td><strong>Definition</strong></td></tr><tr><td>Ultra Mega Project</td><td>Projects in manufacturing enterprises, Tourism, wholesale markets and Logistics etc. with investments minimum of US$ 1 billion (Rs. 6000 crore) on land area of minimum 500 acres</td></tr><tr><td>Mega Project</td><td>Fixed capital investment of &gt; 100 Crores<br>OR<br>direct employment of &gt; 200 persons in block D<br>OR<br>direct employment of &gt; 500 persons in block B &amp; C</td></tr><tr><td>Large Service Enterprise</td><td>Investment in building &amp; equipment &gt; 5 Crores</td></tr><tr><td>Medium Service Enterprise</td><td>Investment in equipment &gt; 2 Crores &amp; &lt; 5 Crores</td></tr><tr><td>Small Service Enterprise</td><td>Investment in equipment &gt; 10 Lakhs &amp; &lt; 2 Crores</td></tr><tr><td>Micro Service Enterprise</td><td>Investment in equipment &lt; 10 Lakhs</td></tr></tbody></table></div></div></div><div id="modal4" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1">Please select the category of your enterprise/project based on the following:<tbody><tr><td><b>Manufacturing Enterprises</b></td><td>Enterprises engaged in the manufacture or production of goods pertaining to any industry</td></tr><tr><td><b>Services Enterprises</b></td><td>Enterprises engaged in providing or rendering of services</td></tr></tbody></table></div></div></div><div id="modal5" uk-modal><div class="uk-modal-dialog container">Please select the district in which your enterprise/project is setup or planned to be setup</div></div><div id="modal6" uk-modal><div class="uk-modal-dialog container">Please select the block in which your enterprise/project is setup or planned to be setup</div></div><div id="modal7" uk-modal><div class="uk-modal-dialog container">Please select the block type (as specified in the Haryana Enterprise Promotion Policy 2015) in which your enterprise/project is setup or planned to be setup</div></div><div id="modal8" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-body table-responsive"><table class="jh-table table table-striped" border="1">Please select the industry sector which your enterprise/project falls under<tbody><tr><td>Auto, Auto Components and Light Engineering</td></tr><tr><td>Agro based, Food Processing & Allied Industry</td></tr><tr><td>Textiles/Apparel/Technical textiles</td></tr><tr><td>Footwear & Accessories</td></tr><tr><td>Electronics</td></tr><tr><td>IT/ITeS</td></tr><tr><td>Defence & Aerospace Manufacturing</td></tr><tr><td>Renewable Energy & Solar Parks</td></tr><tr><td>Pharmaceutical & Chemical Industry</td></tr><tr><td>Other</td></tr></tbody></table></div></div></div><script>$(document).ready(function(){\n        $("#myInput").on("keyup", function() {\n            var value = $(this).val().toLowerCase();\n            $("#myTable1 tr").filter(function() {\n                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)\n            });\n            $("#myTable2 tr").filter(function() {\n                $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1)\n            });\n        });\n    });</script><style>.tip {\n        border-bottom: 1px dotted [template("base font color")];\n        position: relative;\n        cursor: help;\n        text-decoration: none;\n        color: inherit;\n    }\n    .tip span {\n        display: none;\n        z-index: 100;\n        position: absolute;\n        padding: .6em;\n        padding-left: 1em;\n        top: 1.5em;\n        left: 2.4em;\n        width: 10em;\n        background-color: [template("page background color")];\n        border: 1px solid [template("base font color")];\n        border-radius: 0.5em;\n    }\n    .tip:hover span {\n        display: inline-block;\n    }\n    .sg-question-set,\n    .sg-type-radio ul.sg-list-vertical li,\n    .sg-type-checkbox ul.sg-list-vertical li,\n    .sg-question-options,\n    .sg-type-radio-likert .sg-question-options,\n    .sg-type-table .sg-question-options,\n    .sg-instructions\n    {\n        overflow: visible;\n    }</style><!--<div id="confirmation1" class="modal fade" role="dialog">--><!--<div class="modal-dialog">--><!--&lt;!&ndash; Modal content&ndash;&gt;--><!--<form name="form" role="form" novalidate ng-submit="vm.calculateIncentives()" show-validation>--><!--<div class="modal-content">--><!--<div class="modal-header">--><!--<h4 class="modal-title" id="Rate"><b>Please confirm your inputs:</b></h4>--><!--</div>--><!--<div class="modal-body col-md-12">--><!--asdfghjkl--><!--</div>--><!--<div class="modal-footer">--><!--<button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.calculateIncentives()">Confirm</button>--><!--<button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button>--><!--</div>--><!--</div>--><!--</form>--><!--</div>--><!--</div>--><script type="text/javascript">$(document).ready(function(){\n        $(".tooltipex").tooltip({\n\n        });\n    });</script><style>.glass{\n        /* background styles */\n        position: relative;\n        display: inline-block;\n        background-color: green; /*for compatibility with older browsers*/\n        background-image: linear-gradient(green,lightgreen);\n\n        /* text styles */\n        text-decoration: none;\n        color: #fff;\n        font-family: sans-serif;\n        font-weight: 100;\n\n        border-radius: 3px;\n        box-shadow: 0px 1px 4px -2px #333;\n        text-shadow: 0px -1px #333;\n    }\n    .glass:after{\n        content: \'\';\n        position: absolute;\n        top: 2px;\n        left: 2px;\n        width: calc(100% - 4px);\n        height: 50%;\n        background: linear-gradient(rgba(255,255,255,0.8), rgba(255,255,255,0.2));\n    }\n\n    .glass:hover{\n        background: linear-gradient(#073,#0fa);\n    }</style>');
$templateCache.put('app/incentiveforms/incentivedashboard.html','<div><div class="row"><section height="inherit"><iframe style="width: 100%; height: 2000px" frameborder="0" scrolling="no" marginheight="0" marginwidth="0" src="https://haryanaindustries.gov.in/msme/dashboardhepc"></iframe></section></div></div>');
$templateCache.put('app/incentiveforms/incentiveform.html','<div class="container"><div class="row"><br><a target="_blank" href="../../content/pdfs/message.pdf" style="color:#000099;font-size: 15px"><b>As per order of W/ACS (I&C) from 01.12.2022 onwards, all appeals under various incentive schemes shall be received through online mode (Web-Portal) only.</b></a><br><br><div class="col-xs-2 col-sm-2 col-md-2"><strong><span style="color:#990000">Apply For</span></strong></div><div class="col-xs-4 col-sm-4 col-md-4"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/revival_interest" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/revival_interest"> <input class="badge-warning blink_me" type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="Haryana MSME Revival Interest Benefit Scheme"><!--                <input type="submit" class="btn btn-primary" ui-sref="incentiveformsmega"--><!--                       value="Incentives for Mega Projects">--><!--<a href="#modal-full" uk-toggle>My Incentive Status</a>--></form></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/viewallapplications/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/viewallapplications/index"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="My Incentive Status"><!--                <input type="submit" class="btn btn-primary" ui-sref="incentiveformsmega"--><!--                       value="Incentives for Mega Projects">--><!--<a href="#modal-full" uk-toggle>My Incentive Status</a>--></form></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/onholdapplications/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/onholdapplications/index"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="Reply to onhold application"></form></div></div><div class="row"><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/reimbursementofexpenses/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/reimbursementofexpenses/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Re-Imbursement of Expenses Incurred for E-commerce Linkages"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/aidforprimaryprocessingcentres/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/aidforprimaryprocessingcentres/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Primary processing centre scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/interestsubsidyontermloan/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/interestsubsidyontermloan/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Claiming Interest subsidy on bank loan"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/assistancetechnologyaquisition/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/assistancetechnologyaquisition/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Assistance Technology Aquisition"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/stampdutyscheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/stampdutyscheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Stamp Duty Refund Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/qualitycertificationassistancescheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/qualitycertificationassistancescheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Quality Certification Assistance Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/waterauditscheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/waterauditscheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Water Audit Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/creditlinkedinterestsubsidyscheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/creditlinkedinterestsubsidyscheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Credit Linked Interest Subsidy"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/clinicdesignscheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/clinicdesignscheme/index\n"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Design Clinic Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/assistanceforenvironmentcompliance/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/assistanceforenvironmentcompliance/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Assistance for Environment Compliance"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/energyauditscheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/energyauditscheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Energy Audit Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/creditratingscheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/creditratingscheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Credit Rating Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/claiminginvestmentsubsidy/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/claiminginvestmentsubsidy/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Claiming Investment Subsidy on VAT/SGST"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/freightassistancescheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/freightassistancescheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Freight Assistance Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/testingequipmentassistancescheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/testingequipmentassistancescheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Testing Equipment Assistance Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/marketdevelopmentassistancescheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/marketdevelopmentassistancescheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Marketing Development Assistance scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/marketingassistanceartisans/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/marketingassistanceartisans/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Market Development Assistance for Artisans"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/electricitydutyscheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/electricitydutyscheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Electricity Duty/ Open Excess Charges Exemption"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/interestsubsidyartisans/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/interestsubsidyartisans/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Interest Subsidy Artisans Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/availingemploymentgenerationsubsidy/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/availingemploymentgenerationsubsidy/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Availing Employment Generation Subsidy"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/financialassistanceonpatentregistration/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/financialassistanceonpatentregistration/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Financial Assistance on Patent Registration"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/safetyauditscheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/safetyauditscheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Safety Audit Scheme"></form></div><!--<div class="col-md-6">--><!--<form target="my_iframe"--><!--action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/powertariffsubsidy"--><!--method="POST">--><!--<input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--<input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--<input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--<input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--<input type="hidden" name="url"--><!--value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/powertariffsubsidy">--><!--<input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Power Tariff Subsidy">--><!--</form>--><!--</div>--></div></div><div id="modal-full" class="uk-modal-full" uk-modal esc-close="false" bg-close="false"><div class="uk-modal-dialog"><button class="uk-modal-close-full uk-close-large" type="button" uk-close></button><div class="uk-grid-collapse uk-flex-middle" uk-grid><section><iframe name="my_iframe" style="width: 400vw; height: 200vh" frameborder="0" marginheight="0" marginwidth="0"></iframe></section></div></div></div><!--<form target="my_iframe"--><!--action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/marketingassistanceartisans/index"--><!--method="POST">--><!--<input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--<input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--<input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--<input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--<input type="hidden" name="url"--><!--value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/marketingassistanceartisans/index">--><!--<input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Marketing Assistance for Artisans">--><!--</form>--><!--<form target="my_iframe"--><!--action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/exportawardscheme/index"--><!--method="POST">--><!--<input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--<input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--<input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--<input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--<input type="hidden" name="url"--><!--value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/exportawardscheme/index">--><!--<input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Export Award Scheme">--><!--</form>--><!--<form target="my_iframe"--><!--action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/stateaward/index"--><!--method="POST">--><!--<input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--<input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--<input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--<input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--<input type="hidden" name="url"--><!--value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/stateaward/index">--><!--<input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" State Award Scheme">--><!--</form>--><!--<form target="my_iframe"--><!--action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/handicraftawardscheme/index"--><!--method="POST">--><!--<input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--<input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--<input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--<input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--<input type="hidden" name="url"--><!--value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/handicraftawardscheme/index">--><!--<input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Handicraft award Scheme">--><!--</form>--><style>.badge-warning { background-color: red!important;\n        display: inline-block;\n        min-width: 10px;\n        padding: 3px 7px;\n        font-size: 14px;\n        font-weight: bold;\n        line-height: 1;\n        color: #fff;\n        text-align: center;\n        white-space: nowrap;\n        vertical-align: middle;\n        background-color: #777;\n        border-radius: 10px;\n    }\n    .blink_me {\n        animation: blinker 2s linear infinite !important;\n        color:white\n    }\n\n    @keyframes blinker {\n        30% { opacity: 0; color: red; }\n        60% { opacity: 0; color: yellow; }\n    }</style>');
$templateCache.put('app/incentiveforms/incentiveformNewScheme.html','<div class="container"><br><a target="_blank" href="../../content/pdfs/message.pdf" style="color:#000099;font-size: 15px"><b>As per order of W/ACS (I&C) from 01.12.2022 onwards, all appeals under various incentive schemes shall be received through online mode (Web-Portal) only.</b></a><br><br><a target="_blank" href="../../content/pdfs/msg.pdf" style="color:#000099;font-size: 15px"><b>Office Order regarding delay in submission of incentive applications due to non functionality of the Web-Portal.</b></a><br><br><div class="row" ng-if="vm.param===\'warehousing\'"><div class="col-xs-6 col-sm-6 col-md-6"><strong><span style="color:#990000">Apply For</span></strong></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/viewappstatus/logistics" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/viewappstatus/logistics"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="My Incentive Status"><!--                <input type="submit" class="btn btn-primary" ui-sref="incentiveformsmega"--><!--                       value="Incentives for Mega Projects">--><!--<a href="#modal-full" uk-toggle>My Incentive Status</a>--></form></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/onholdapplications/logistics" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/onholdapplications/logistics"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="Reply to onhold application"></form></div><div class="col-md-6"><form target="my_iframe" class="pull-right" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/dashboard/default/allschemes"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="Reply to onhold for new portal applications"></form></div></div><div class="row" ng-if="vm.param===\'warehousing\'"><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/newincentivescheme/capitalsubsidy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Capital Subsidy incentive"></form></div><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/newincentivescheme/edc"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Reimbursement of External Development Charges (EDC)"></form></div><div class="col-md-6"><form target="my_iframe" action="ttps://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/newincentivescheme/commercial_license"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Commercial License Fee reimbursement"></form></div><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/newincentivescheme/capacity_building"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Capacity Building incentives"></form></div><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/newincentivescheme/stamp-duty-refund/"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="STAMP DUTY REFUND"></form><!--<button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/newincentivescheme/stamp_duty\',\'_blank\')"><b>STAMP DUTY REFUND</b></button>--></div><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="hhttps://dic.haryanaindustries.gov.in/newincentivescheme/interestsubsidy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="INTEREST SUBSIDY"></form><!--<button class="btn btn-success" onclick=" window.open(\'https://haryanaindustries.gov.in/msme/newincentivescheme/interestsubsidy\',\'_blank\')"><b>INTEREST SUBSIDY</b></button>--></div><div class="col-md-6"><button class="btn btn-success" onclick="window.open(\'https://dic.haryanaindustries.gov.in/newincentivescheme/electricity_duty_exemption\',\'_blank\')"><b>ELECTRICITY DUTY EXEMPTION</b></button></div></div><div class="row" ng-if="vm.param===\'agriculture\'"><div class="col-xs-6 col-sm-6 col-md-6"><strong><span style="color:#990000">Apply For</span></strong></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/viewappstatus/foodprocessing" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/viewappstatus/foodprocessing"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="My Incentive Status"><!--                <input type="submit" class="btn btn-primary" ui-sref="incentiveformsmega"--><!--                       value="Incentives for Mega Projects">--><!--<a href="#modal-full" uk-toggle>My Incentive Status</a>--></form></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/onholdapplications/foodprocessing" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/onholdapplications/foodprocessing"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="Reply to onhold application"></form></div></div><div class="row" ng-if="vm.param===\'agriculture\'"><div class="col-md-5"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/linkages" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/linkages"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Haryana Backward and Forward Linkage scheme"></form></div><div class="col-md-7"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/agro_food" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/agro_food"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Creation Expansion Diversification of Individual Agro and Food Processing Units"></form></div><div class="col-md-5"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/mini_food_park" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/mini_food_park"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Integrated Mini food park scheme"></form></div><div class="col-md-7"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/cold_chain" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/cold_chain"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Cold Chain Scheme"></form></div></div><div class="row" ng-if="vm.param===\'policy2019\'"><div class="col-xs-6 col-sm-6 col-md-6"><strong><span style="color:#990000">Apply For</span></strong></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/newincentivescheme/viewappstatus/policy2019" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/viewappstatus/policy2019"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="My Incentive Status"><!--                <input type="submit" class="btn btn-primary" ui-sref="incentiveformsmega"--><!--                       value="Incentives for Mega Projects">--><!--<a href="#modal-full" uk-toggle>My Incentive Status</a>--></form></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/newincentivescheme/onholdapplications/policy2019" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/onholdapplications/policy2019"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="Reply to onhold application"></form></div></div><div class="row" ng-if="vm.param===\'policy2019\'"><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/skill_development" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/skill_development"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Skill Development Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/electricity_duty" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/electricity_duty"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Electricity Duty Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/stamp_duty_refund" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/stamp_duty_refund"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Stamp Duty Refund Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/claiming_permotion" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/claiming_permotion"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Claiming Promotion of ICT"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/exchange_equity" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/exchange_equity"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="SME Exchange Equity scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/renewable_energy" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/renewable_energy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="State Renewal Energy scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/mini_revamped" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/mini_revamped"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="State Mini Revamped Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/mini_lean_mfg" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/mini_lean_mfg"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="State Mini Lean Manufacturing Competitiveness Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/cluster_plug_play" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/cluster_plug_play"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Cluster Plug & Play Scheme"></form></div></div><div class="row" ng-if="vm.param===\'policy2020\'"><div class="col-xs-6 col-sm-6 col-md-6"><strong><span style="color:#990000">Apply For</span></strong></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/newincentivescheme/viewappstatus/policy2020" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/viewappstatus/policy2020"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="My Incentive Status"><!--                <input type="submit" class="btn btn-primary" ui-sref="incentiveformsmega"--><!--                       value="Incentives for Mega Projects">--><!--<a href="#modal-full" uk-toggle>My Incentive Status</a>--></form></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/heepincentivescheme/renewable-energy"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="Renewable Energy Projects Scheme"><!--                <input type="submit" class="btn btn-primary" ui-sref="incentiveformsmega"--><!--                       value="Incentives for Mega Projects">--><!--<a href="#modal-full" uk-toggle>My Incentive Status</a>--></form></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/newincentivescheme/onholdapplications/policy2020" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/onholdapplications/policy2020"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="Reply to onhold application"></form></div><div class="col-xs-3 col-sm-3 col-md-3" style="margin-left: 141px"><form target="my_iframe" class="pull-right" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/dashboard/default/allschemes"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="Reply to onhold for new portal applications"></form></div></div><div class="row" ng-if="vm.param===\'policy2020\'"><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/state_startup" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/state_startup"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Scheme for Assistance for Startups in the State"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/waste_management" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/waste_management"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Assistance for Waste Management"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/export_credit_guarantee" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/export_credit_guarantee"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Assistance under Export Credit guarantee Corporation Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/free_credit_guarantee" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/free_credit_guarantee"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Collateral Free Credit Guarantee Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/academia_research" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/academia_research"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Collaborative Industry-Academia Research Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/edc_exemption" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/edc_exemption"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" The Grant of External Development Charges Exemption for new Industrial Enterprises"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/set_subsidy" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/set_subsidy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Generator Set Subsidy Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/hguvy" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/hguvy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Haryana Gramin Udyogik Vikas Yojna"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/lean_mfg" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/lean_mfg"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Scheme of State Award for Lean Manufacturing Technique"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/ind_infra_dev" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/ind_infra_dev"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Infrastructure_Industrial_Development_Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/rnd_center" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/rnd_center"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Research and Development Center Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/heepincentivescheme/state_mini_cluster/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Mini_Cluster_Development_Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/sme_exchange" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/sme_exchange"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  SME Exchange Equity scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/pro_innovation" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/pro_innovation"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Scheme of State Award for Product Process Innovation"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/quality_product" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/quality_product"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Scheme of State Award for Quality Products"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/oefforts_service" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/oefforts_service"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  State Awards for outstanding entrepreneur in Service"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/testingequipmentassistancescheme" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/testingequipmentassistancescheme"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Testing Equipment Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/incentiveschemehepc/stampdutyscheme"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Stamp duty scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/incentiveschemehepc/marketdevelopmentassistancescheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Market Development Assistance"></form></div><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/incentiveschemehepc/electricitydutyscheme"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Electricity Duty Exemption"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/qualitycertificationassistancescheme" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/qualitycertificationassistancescheme"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Quality Certification scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/assistanceforenvironmentcompliance" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/assistanceforenvironmentcompliance"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Environment compliance scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/assistancetechnologyaquisition" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/assistancetechnologyaquisition"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Technology Acquisition scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/financialassistanceonpatentregistration" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/financialassistanceonpatentregistration"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Patent Registration Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/energyauditscheme" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/energyauditscheme"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Energy conservation scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/incentiveschemehepc/freightassistancescheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Freight Assistance Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/creditratingscheme" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/creditratingscheme"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Credit Rating Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/waterauditscheme" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/waterauditscheme"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Water Conservation Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/safetyauditscheme" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/safetyauditscheme"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Safety Compliance Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/incentiveschemehepc/availingemploymentgenerationsubsidy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Employment Generation subsidy"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/interestsubsidyontermloan" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/interestsubsidyontermloan"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Interest subsidy on term loan"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/creditlinkedinterestsubsidyscheme" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/creditlinkedinterestsubsidyscheme"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  State Credit Linked Interest Subsidy for Technology upgradation"></form></div><div class="col-md-6"><form target="my_iframe" action="https://dic.haryanaindustries.gov.in/formhepc/promptscreensubmitcommon" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://dic.haryanaindustries.gov.in/incentiveschemehepc/claiminginvestmentsubsidy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Investment Subsidy on SGST"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/heepincentivescheme/oefforts_mfg" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/heepincentivescheme/oefforts_mfg"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="  Scheme of State Award for outstanding entrepreneur in Manufacturing"></form></div></div></div><div id="modal-full" class="uk-modal-full" uk-modal esc-close="false" bg-close="false"><div class="uk-modal-dialog"><button class="uk-modal-close-full uk-close-large" type="button" uk-close></button><div class="uk-grid-collapse uk-flex-middle" uk-grid><section><iframe name="my_iframe" style="width: 500vw; height: 100vh" frameborder="0" marginheight="0" marginwidth="0"></iframe></section></div></div></div><!--<form target="my_iframe"--><!--action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/marketingassistanceartisans/index"--><!--method="POST">--><!--<input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--<input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--<input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--<input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--<input type="hidden" name="url"--><!--value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/marketingassistanceartisans/index">--><!--<input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Marketing Assistance for Artisans">--><!--</form>--><!--<form target="my_iframe"--><!--action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/exportawardscheme/index"--><!--method="POST">--><!--<input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--<input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--<input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--<input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--<input type="hidden" name="url"--><!--value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/exportawardscheme/index">--><!--<input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Export Award Scheme">--><!--</form>--><!--<form target="my_iframe"--><!--action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/stateaward/index"--><!--method="POST">--><!--<input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--<input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--<input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--<input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--<input type="hidden" name="url"--><!--value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/stateaward/index">--><!--<input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" State Award Scheme">--><!--</form>--><!--<form target="my_iframe"--><!--action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/handicraftawardscheme/index"--><!--method="POST">--><!--<input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--<input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--<input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--<input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--<input type="hidden" name="url"--><!--value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/handicraftawardscheme/index">--><!--<input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Handicraft award Scheme">--><!--</form>-->');
$templateCache.put('app/incentiveforms/incentiveformsmega.html','<div class="container"><div class="row"><div class="col-xs-3 col-sm-3 col-md-3"><strong><span style="color:#990000">Apply For</span></strong></div><div class="col-xs-6 col-sm-6 col-md-6"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/viewallapplications/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/viewallapplications/index"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="My Incentive Status"><!--                <input type="submit" class="btn btn-primary" ui-sref="incentiveforms"--><!--                       value="Back">--><!--<a href="#modal-full" uk-toggle>My Incentive Status</a>--></form></div><div class="col-xs-3 col-sm-3 col-md-3"><form target="my_iframe" class="pull-right" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/onholdapplications/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/onholdapplications/index"> <input type="submit" class="btn btn-primary" href="#modal-full" uk-toggle value="Reply to onhold application"></form></div></div><div class="row"><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/stampdutyscheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/stampdutyscheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Stamp Duty Refund Scheme"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/claiminginvestmentsubsidy/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/claiminginvestmentsubsidy/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Claiming Investment Subsidy on VAT/SGST"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/electricitydutyscheme/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/electricitydutyscheme/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Electricity Duty/ Open Excess Charges Exemption"></form></div><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/incentiveschemehepc/availingemploymentgenerationsubsidy/index" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/incentiveschemehepc/availingemploymentgenerationsubsidy/index"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value=" Availing Employment Generation Subsidy"></form></div></div></div><div id="modal-full" class="uk-modal-full" uk-modal esc-close="false" bg-close="false"><div class="uk-modal-dialog"><button class="uk-modal-close-full uk-close-large" type="button" uk-close></button><div class="uk-grid-collapse uk-child-width-1-2@s uk-flex-middle" uk-grid><section><iframe name="my_iframe" style="width: 100vw; height: 100vh" frameborder="0" marginheight="0" marginwidth="0"></iframe></section></div></div></div>');
$templateCache.put('app/intentToInvest/IntentToInvest.html','<style>.card-header {\n        border-radius: 10px 10px 0 0;\n    }\n\n    .card {\n        border-radius: 10px;\n        /*box-shadow: 0 4px 10px rgba(0,0,0,0.1);*/\n        margin-bottom: 20px;\n    }\n\n    .card-body {\n        /*border-radius: 10px;*/\n        box-shadow: none;\n        /*margin-bottom: 20px;*/\n    }\n\n    label {\n        font-weight: 500;\n    }\n\n    .text-danger {\n        font-size: 16px;\n    }</style><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Intent To Invest</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Intent To Invest</span></li></ol></div></section><br><div class="container mt-4" ng-app="investApp" ng-controller="IntentToInvestController as vm"><form name="vm.investorProjectForm" novalidate ng-submit="vm.submitForm()"><!-- ====================== Investor Details ====================== --><div class="card mb-4"><div class="card-header bg-primary text-white"><h4 class="mb-0">Investor Details</h4></div><div class="card-body"><div class="row"><!-- Full Name --><div class="col-md-6 form-group"><label>Full Name <span class="text-danger">*</span></label><input type="text" name="fullName" class="form-control" ng-model="vm.form.fullName" ng-pattern="/^[A-Za-z\\s]{3,}$/" ng-minlength="3" required><div class="text-danger mt-1" ng-show="vm.investorProjectForm.fullName.$touched && vm.investorProjectForm.fullName.$invalid"><small ng-show="vm.investorProjectForm.fullName.$error.required">Full name is required.</small> <small ng-show="vm.investorProjectForm.fullName.$error.pattern">Only alphabets allowed (min 3 chars).</small></div></div><!-- Business Entity --><div class="col-md-6 form-group"><label>Business Entity Name <span class="text-danger">*</span></label><input type="text" name="businessEntity" class="form-control" ng-model="vm.form.businessEntity" ng-pattern="/^[A-Za-z0-9\\s]{3,}$/" required><div class="text-danger mt-1" ng-show="vm.investorProjectForm.businessEntity.$touched && vm.investorProjectForm.businessEntity.$invalid"><small ng-show="vm.investorProjectForm.businessEntity.$error.required">Business entity name is required.</small> <small ng-show="vm.investorProjectForm.businessEntity.$error.pattern">Only letters & numbers (min 3 chars).</small></div></div><!-- Phone Number --><div class="col-md-6 form-group"><label>Phone Number</label><input type="text" name="phoneNumber" class="form-control" ng-model="vm.form.phoneNumber" ng-pattern="/^[0-9]{6,15}$/"><div class="text-danger mt-1" ng-show="vm.investorProjectForm.phoneNumber.$touched && vm.investorProjectForm.phoneNumber.$invalid"><small ng-show="vm.investorProjectForm.phoneNumber.$error.pattern">Enter 6\u201315 digits only.</small></div></div><!-- Mobile Number --><div class="col-md-6 form-group"><label>Mobile Number <span class="text-danger">*</span></label><input type="text" name="mobileNumber" class="form-control" ng-model="vm.form.mobileNumber" ng-pattern="/^[0-9]{10}$/" required><div class="text-danger mt-1" ng-show="vm.investorProjectForm.mobileNumber.$touched && vm.investorProjectForm.mobileNumber.$invalid"><small ng-show="vm.investorProjectForm.mobileNumber.$error.required">Mobile number is required.</small> <small ng-show="vm.investorProjectForm.mobileNumber.$error.pattern">Enter a valid 10-digit mobile number.</small></div></div><!-- Email --><div class="col-md-6 form-group"><label>Email <span class="text-danger">*</span></label><input type="email" name="email" class="form-control" ng-model="vm.form.email" required><div class="text-danger mt-1" ng-show="vm.investorProjectForm.email.$touched && vm.investorProjectForm.email.$invalid"><small ng-show="vm.investorProjectForm.email.$error.required">Email is required.</small> <small ng-show="vm.investorProjectForm.email.$error.email">Enter a valid email address.</small></div></div><!-- Country --><div class="col-md-6 form-group"><label>Country <span class="text-danger">*</span></label><select class="form-control" name="country" ng-options="country.name as country.name for country in vm.allcountries" ng-model="vm.form.country" required><option value="">Select</option></select><div class="text-danger mt-1" ng-show="vm.investorProjectForm.country.$touched && vm.investorProjectForm.country.$invalid"><small>Country selection is required.</small></div></div><!-- Sector --><div class="col-md-6 form-group"><label>Sector <span class="text-danger">*</span></label><select class="form-control" name="sector" ng-model="vm.form.sector" ng-options="sector.sectortype as sector.sectortype for sector in vm.sectors" required><option value="">Select</option></select><div class="text-danger mt-1" ng-show="vm.investorProjectForm.sector.$touched && vm.investorProjectForm.sector.$invalid"><small>Sector selection is required.</small></div></div></div></div><div class="card-header bg-primary text-white"><h4 class="mb-0">Project Details</h4></div><div class="card-body"><div class="row"><!-- 1. Project Name --><div class="col-md-6 form-group"><label>Name of the Project <span class="text-danger">*</span></label><input type="text" name="projectName" class="form-control" ng-model="vm.form.projectName" ng-pattern="/^[A-Za-z0-9\\s]{3,}$/" ng-minlength="3" required><div class="text-danger mt-1" ng-show="vm.investorProjectForm.projectName.$touched && vm.investorProjectForm.projectName.$invalid"><small ng-show="vm.investorProjectForm.projectName.$error.required">Project name is required.</small> <small ng-show="vm.investorProjectForm.projectName.$error.pattern">Only letters and numbers, min 3 characters.</small></div></div><!-- 2. Approx Land Required --><div class="col-md-6 form-group"><label>Approx. Land Required (In Acres) <span class="text-danger">*</span></label><input type="number" name="landRequired" class="form-control" ng-model="vm.form.landRequired" min="0.1" step="0.01" required><div class="text-danger mt-1" ng-show="vm.investorProjectForm.landRequired.$touched && vm.investorProjectForm.landRequired.$invalid"><small ng-show="vm.investorProjectForm.landRequired.$error.required">Land required is mandatory.</small> <small ng-show="vm.investorProjectForm.landRequired.$error.min">Value must be positive.</small></div></div><!-- 3. Approx Investment --><div class="col-md-6 form-group"><label>Approx. Investment (In Crores) <span class="text-danger">*</span></label><div class="border rounded p-3 bg-light"><!-- Land --><div class="form-group mb-2"><label class="small fw-bold">Land <span class="text-danger">*</span></label><input type="number" name="landInvestment" class="form-control" ng-model="vm.form.landInvestment" ng-change="vm.calculateTotalInvestment()" min="0" step="0.01" required><div class="text-danger mt-1" ng-show="vm.investorProjectForm.landInvestment.$touched && vm.investorProjectForm.landInvestment.$invalid"><small>Enter positive number only.</small></div></div><!-- Building --><div class="form-group mb-2"><label class="small fw-bold">Building <span class="text-danger">*</span></label><input type="number" name="buildingInvestment" class="form-control" ng-model="vm.form.buildingInvestment" ng-change="vm.calculateTotalInvestment()" min="0" step="0.01" required><div class="text-danger mt-1" ng-show="vm.investorProjectForm.buildingInvestment.$touched && vm.investorProjectForm.buildingInvestment.$invalid"><small>Enter positive number only.</small></div></div><!-- Plant & Machinery --><div class="form-group mb-2"><label class="small fw-bold">Plant & Machinery <span class="text-danger">*</span></label><input type="number" name="plantMachineryInvestment" class="form-control" ng-model="vm.form.plantMachineryInvestment" ng-change="vm.calculateTotalInvestment()" min="0" step="0.01" required><div class="text-danger mt-1" ng-show="vm.investorProjectForm.plantMachineryInvestment.$touched && vm.investorProjectForm.plantMachineryInvestment.$invalid"><small>Enter positive number only.</small></div></div><!-- Total --><div class="form-group mb-0"><label class="small fw-bold text-primary">Total Investment</label><input type="number" name="totalInvestment" class="form-control bg-light" ng-model="vm.form.totalInvestment" readonly="readonly"></div></div></div><!-- 4. Direct Employment --><div class="col-md-6 form-group"><label>Approx. Direct Employment <span class="text-danger">*</span></label><input type="number" name="employment" class="form-control" ng-model="vm.form.employment" min="1" step="1" required><div class="text-danger mt-1" ng-show="vm.investorProjectForm.employment.$touched && vm.investorProjectForm.employment.$invalid"><small ng-show="vm.investorProjectForm.employment.$error.required">Employment is required.</small> <small ng-show="vm.investorProjectForm.employment.$error.min">Must be a positive integer.</small></div></div><!-- 5. Product / Activity --><div class="col-md-6 form-group"><label>Product / Activity <span class="text-danger">*</span></label><input type="text" name="productActivity" class="form-control" ng-model="vm.form.productActivity" ng-pattern="/^[A-Za-z0-9\\s]{3,}$/" ng-minlength="3" required><div class="text-danger mt-1" ng-show="vm.investorProjectForm.productActivity.$touched && vm.investorProjectForm.productActivity.$invalid"><small ng-show="vm.investorProjectForm.productActivity.$error.required">This field is required.</small> <small ng-show="vm.investorProjectForm.productActivity.$error.pattern">Only alphanumeric, min 3 characters.</small></div></div><!-- 6. Information Source --><div class="col-md-6 form-group"><label>Information Source Name <span class="text-danger">*</span></label><select class="form-control" name="infoSource" ng-model="vm.form.infoSource" required><option value="">Select Information Source</option><option value="Road show">Road show</option><option value="Conference">Conference</option><option value="Exhibition">Exhibition</option><option value="From Web">From Web</option><option value="Other">Other</option></select><div class="text-danger mt-1" ng-show="vm.investorProjectForm.infoSource.$touched && vm.investorProjectForm.infoSource.$invalid"><small>Information source selection is required.</small></div></div><!-- 7. Description --><div class="col-md-12 form-group"><label>Description <span class="text-danger">*</span></label><textarea class="form-control" name="description" rows="3" ng-model="vm.form.description" ng-minlength="1" ng-maxlength="200" placeholder="Maximum 200 characters limit" required></textarea><div class="text-danger mt-1" ng-show="vm.investorProjectForm.description.$touched && vm.investorProjectForm.description.$invalid"><small ng-show="vm.investorProjectForm.description.$error.required">Description is required.</small> <small ng-show="vm.investorProjectForm.description.$error.minlength">Maximum 200 characters required.</small></div></div></div><!-- ====================== Submit Button ====================== --><!-- ====================== Submit & Reset Buttons ====================== --><div class="row mb-5"><div class="col-md-12 text-right"><button type="submit" class="btn btn-primary btn-lg" ng-disabled="vm.investorProjectForm.$invalid" style="margin-left: 10px">Submit</button> <button type="reset" class="btn btn-default btn-lg" ng-click="vm.resetForm()">Reset</button></div></div></div></div></form></div>');
$templateCache.put('app/intentToInvest/intentToInvestDetail.html','<style>.card-header {\n        border-radius: 10px 10px 0 0;\n    }\n    .card {\n        border-radius: 10px;\n        margin-bottom: 20px;\n    }\n    .label-title {\n        font-weight: 600;\n    }\n    .value-text {I\n        font-size: 16px;\n        color: #333;\n        word-break: break-word;\n    }\n\n    .card-body {\n        box-shadow: none;\n    }</style><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Intent To Invest - Submitted Details</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>View Submission</span></li></ol></div></section><br><div class="container mt-4" ng-app="investApp" ng-controller="IntentToInvestDetailController as vm"><div class="card mb-4"><!-- Investor Details Section --><div class="card-header bg-primary text-white"><h4 class="mb-0">Investor Details</h4></div><div class="card-body"><div class="row"><div class="col-md-6 mb-3"><span class="label-title">Full Name:</span><p class="value-text">{{vm.data.fullName}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Business Entity Name:</span><p class="value-text">{{vm.data.businessEntity}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Phone Number:</span><p class="value-text">{{vm.data.phoneNumber}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Mobile Number:</span><p class="value-text">{{vm.data.mobileNumber}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Email:</span><p class="value-text">{{vm.data.email}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Country:</span><p class="value-text">{{vm.data.country}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Sector:</span><p class="value-text">{{vm.data.sector}}</p></div></div></div><!-- Project Details Section --><div class="card-header bg-primary text-white"><h4 class="mb-0">Project Details</h4></div><div class="card-body"><div class="row"><div class="col-md-6 mb-3"><span class="label-title">Project Name:</span><p class="value-text">{{vm.data.projectName}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Land Required (In Acres):</span><p class="value-text">{{vm.data.landRequired}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Land Investment (Cr):</span><p class="value-text">{{vm.data.investmentLand}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Building Investment (Cr):</span><p class="value-text">{{vm.data.investmentBuilding}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Plant & Machinery Investment (Cr):</span><p class="value-text">{{vm.data.investmentPlantMachinery}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Total Investment (Cr):</span><p class="value-text"><strong>{{vm.data.totalInvestment}}</strong></p></div><div class="col-md-6 mb-3"><span class="label-title">Approx. Employment:</span><p class="value-text">{{vm.data.approximateDirectEmployment}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Product / Activity:</span><p class="value-text">{{vm.data.productActivity}}</p></div><div class="col-md-6 mb-3"><span class="label-title">Information Source:</span><p class="value-text">{{vm.data.infoSource}}</p></div><div class="col-md-12 mb-3"><span class="label-title">Description:</span><p class="value-text">{{vm.data.description}}</p></div></div><!-- Back to Dashboard Button --><div class="row mb-5"><div class="col-md-12 text-right"><button class="btn btn-primary btn-lg" ui-sref="intent-to-invest-dashboard">Back to Dashboard</button></div></div></div></div></div>');
$templateCache.put('app/intentToInvest/viewIntentToInvest.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Intent To Invest Dashboard</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Intent To Invest Dashboard</span></li></ol></div></section><br><div class="container"><!--    <h4 class="mb-3 text-center">List of Intent to Invest</h4>--><div class="table-responsive"><table class="table table-bordered table-striped table-hover"><thead class="thead-dark"><tr><th>#</th><th>Investor Name</th><th>Business Entity Name</th><!--            <th>Land Investment</th>--><!--            <th>Building Investment</th>--><!--            <th>Plant & Machinery</th>--><!--            <th>Total Investment</th>--><!--            <th>Land Required</th>--><!--            <th>Phone</th>--><th>Mobile</th><th>Email</th><th>Country</th><th>Sector</th><th>Proposed Investment</th><th>Assigned Officer</th><th></th><!--            <th>Project Name</th>--><!--            <th>Employment</th>--><!--            <th>Product / Activity</th>--><!--            <th>Info Source</th>--><!--            <th>Description</th>--></tr></thead><tbody><tr ng-repeat="invest in vm.allIntentToInvest track by invest.id"><td>{{$index + 1}}</td><td>{{invest.fullName}}</td><td>{{invest.businessEntity}}</td><!--            <td>{{invest.investmentLand | number:2}}</td>--><!--            <td>{{invest.investmentBuilding | number:2}}</td>--><!--            <td>{{invest.investmentPlantMachinery | number:2}}</td>--><!--            <td>{{invest.totalInvestment | number:2}}</td>--><!--            <td>{{invest.landRequired | number:2}}</td>--><!--            <td>{{invest.phoneNumber}}</td>--><td>{{invest.mobileNumber}}</td><td>{{invest.email}}</td><td>{{invest.country}}</td><td>{{invest.sector}}</td><td>{{invest.totalInvestment}}</td><td>Not Assigned</td><td><button class="btn-primary small" ui-sref="intent-to-invest-detail({id:invest.id})">Detail</button></td><!--            <td>{{invest.projectName}}</td>--><!--            <td>{{invest.approximateDirectEmployment}}</td>--><!--            <td>{{invest.productActivity}}</td>--><!--            <td>{{invest.infoSource}}</td>--><!--            <td>{{invest.description}}</td>--></tr></tbody></table><div ng-if="!vm.allIntentToInvest.length" class="text-center text-muted">No records found.</div></div></div>');
$templateCache.put('app/leviesimposed/leviesimposed.html','<div class="container-fluid"><div class="row"><ul class="list-group"><li class="list-group-item"><a uk-toggle="target: #modal1">Receipts under State Motor Vehicles Taxation Act- Department of Transport</a></li><li class="list-group-item"><a uk-toggle="target: #modal2">Stamp and Registration Fees- Department of Revenue</a></li><li class="list-group-item"><a uk-toggle="target: #modal3">Professional Tax- Department of Excise and Taxation</a></li><li class="list-group-item"><a uk-toggle="target: #modal4">State Excise Duty- Department of Excise and Taxation</a></li><li class="list-group-item"><a uk-toggle="target: #modal5">Taxes and duties on Electricity- Department of Power i.e. UHBVN/DHBVN</a></li></ul></div></div><div id="modal1" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h5 class="uk-modal-title text-center">Receipts under State Motor Vehicles Taxation Act- Department of Transport</h5></div><ul class="list-group"><li class="list-group-item"><a target="_blank" href="https://haryanatransport.gov.in/srservices/vahan/gui/jsp/taxesandfees.jsp">list of taxes and Fees pertaining to Department of Transport</a></li><li class="list-group-item"><a target="_blank" href="https://haryanatransport.gov.in/srservices/vahan/gui/jsp/registration.jsp">detailed checklist and procedure (Department of Transport)</a></li></ul></div></div><div id="modal2" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h5 class="uk-modal-title text-center">Stamp and Registration Fees- Department of Revenue</h5></div><ul class="list-group"><li class="list-group-item"><a target="_blank" href="http://jamabandi.nic.in/Docs/SDRates.pdf">Link for Rates of Stamp Duty Calculation</a></li><li class="list-group-item"><a target="_blank" href="http://jamabandi.nic.in/Docs/Registration%20Fee.pdf">Link for Rates for Registration Fee Calculation</a></li><li class="list-group-item"><a target="_blank" href="http://jamabandi.nic.in/StampDuty.aspx">Link for auto calculation of Stamp Duty fee Department\u2019s Web portal</a></li><li class="list-group-item"><a target="_blank" href="http://jamabandi.nic.in/HARIS/DeedChecklist.aspx">Link for Checklist required for Deed Registration</a></li><li class="list-group-item"><a target="_blank" href="http://jamabandi.nic.in/DeedTemplatesNew/How%20to%20use%20Deed%20Templates.pdf">Link for Procedure for Deed Registration</a></li></ul></div></div><div id="modal3" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h5 class="uk-modal-title text-center">Professional Tax- Department of Excise and Taxation</h5></div><p class="lead">Professional Tax is not applicable on the state</p><p class="lead"><a target="_blank" href="../../content/pdfs/Prof_Tax_EoDBpdf.pdf">Professional Tax Information</a></p></div><div id="modal4" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h5 class="uk-modal-title text-center">State Excise Duty- Department of Excise and Taxation</h5></div><p class="lead">Refer Point no 8 and sub points of 8.1 of Policy document 17-18 for all Levies detail</p><p class="lead"><a href="../../content/pdfs/Excise_policy.pdf" target="_blank">Excise Policy</a></p><h4><b>Procedure and Checklist:</b></h4><p class="lead">Procedure and checklist for e-Tendering for Allotment of Zones of Country Liquor and IMFL Vends</p><p class="lead">For <a target="_blank" href="https://haryanatax.gov.in/HEXWAR/faq/User%20Manual%20for%20Sign%20up.pdf">checklist </a>(Please refer page number 15 of below document)</p><p class="lead">For <a target="_blank" href="../../content/pdfs/Excise_ProcedureforeTendring.pdf">procedure </a>refer to the below document</p></div></div><div id="modal5" uk-modal><div class="uk-modal-dialog container"><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h5 class="uk-modal-title">Taxes and duties on Electricity- Department of Power i.e. UHBVN/DHBVN</h5></div><ul class="list-group"><li class="list-group-item"><a target="_blank" href="http://uhbvn.org.in/staticContent/documents/circular/SC2000/SC_U_12_2000.pdf">Electricity Duty Rates</a></li><li class="list-group-item"><a target="_blank" href="http://uhbvn.org.in/staticContent/documents/circular/SC2000/SC_U_26_2000.pdf">Levy of tax on consumers of Electricity within the municipality</a></li><li class="list-group-item"><a target="_blank" href="http://112.196.3.244/applicationform/Documentsrequired.pdf">Checklist for applying Electricity Connection</a></li><li class="list-group-item"><a target="_blank" href="https://investharyana.in/#/questionnaire/allclearances/page14">Procedure for applying for Electricity connection</a></li></ul></div></div></div>');
$templateCache.put('app/licensetrack/licensetrack.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Track License</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Track License</span></li></ol></div></section><br><div class="container"><strong><span style="color:#990000">Track your License</span></strong><br><div><div class="col-md-12" style="margin-left:-19px; margin-top:20px"><table class="table table_template table-striped"><thead><tr><th>Department</th><th>Service</th></tr></thead><tbody><tr><td>Department of Town and Country Planning (TCP)</td><td><ul><li><a href="https://tcpharyana.gov.in/clu.htm" target="_blank">Change of land use</a></li><li><a href="https://tcpharyana.gov.in/WebAdmin/Display/ViewFormCLU" target="_blank">Building plan</a></li></ul></td></tr><tr><td>HSIIDC</td><td><ul><li><a href="https://www.hsiidcesewa.org.in/hsiidcprod/EMP/loadPostAllotmentPublic" target="_blank">Building plan</a></li><li><a href="https://www.hsiidcesewa.org.in/hsiidcprod/EMP/loadPostAllotmentPublic" target="_blank">Occupation Certificate</a></li></ul></td></tr><tr><td>Directorate of Urban Local Bodies (ULB)</td><td><ul><li><a href="https://online.ulbharyana.gov.in/eforms/status.aspx" target="_blank">Building plan</a></li><li><a href="https://online.ulbharyana.gov.in/eforms/status.aspx" target="_blank">Fire NOC</a></li><li><a href="https://online.ulbharyana.gov.in/eforms/status.aspx" target="_blank">Occupation Certificate</a></li><li><a href="https://online.ulbharyana.gov.in/eforms/status.aspx" target="_blank">Firefighting scheme</a></li></ul></td></tr><tr><td>UHBVN & DHBVN</td><td><ul><li><a href="http://112.196.3.244/applicationform/login.aspx?t=uh" target="_blank">Temporary Electricity Connection</a></li><li><a href="http://112.196.3.244/applicationform/login.aspx?t=uh" target="_blank">Permanent electricity connection</a></li></ul></td></tr><tr><td>G2C Services</td><td><ul><li><a href="https://egovservices.in/#/detail-of-approval" target="_blank">Certification of Electrical Installation</a></li></ul></td></tr><tr><td>Haryana State Pollution Control Board (HSPCB)</td><td><ul><li><a href="https://hrocmms.nic.in/OCMMS/allReports/consentThirdPartyVerification" target="_blank">Consent to Establish (CTE)</a></li><li><a href="https://hrocmms.nic.in/OCMMS/allReports/consentThirdPartyVerification" target="_blank">Consent to Operate (CTO)</a></li></ul></td></tr><tr><td>Labour Department Haryana</td><td><ul><li><a href="https://hrylabour.gov.in/excel_upload/offline_verification" target="_blank">Factory Building Plan</a></li><li><a href="https://hrylabour.gov.in/excel_upload/offline_verification" target="_blank">Factory License</a></li></ul></td></tr><tr><td>Department of Industries and Commerce</td><td><ul><li><a href="https://haryanaindustries.gov.in/msme/verificationlinkforerector" target="_blank">Erection of Boiler</a></li><li><a href="https://haryanaindustries.gov.in/msme/verificationlinkforerector" target="_blank">Registration of Boiler</a></li></ul></td></tr><tr><td>Haryana Shehri Vikas Pradhikaran</td><td><ul><li><a href="http://hudaoabp.gov.in/BPAMSClient/CitizenSearch/CitSrh.aspx?sName=HUDA&edFlag=1&iVal=1" target="_blank">Building Plan</a></li><li><a href="https://www.waterbilling.huda.org.in/modules/ConsumerOnlinePayment.aspx" target="_blank">Permanent water connection</a></li></ul></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/licensetrack/procedures.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Procedures and Checklists</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Procedures and Checklists</span></li></ol></div></section><br><div class="container"><strong><span style="color:#990000">Procedures and Checklists</span></strong><br><div><div class="col-md-12" style="margin-left:-19px; margin-top:20px"><table class="table table_template table-striped"><thead><tr><th>Department</th><th>Service</th></tr></thead><tbody><tr><td>Information, Public Relations and Language</td><td><ul><li><a href="../../../content/pdfs/PermissionforMovieShooting.pdf" target="_blank">Permission (Registration & renewal) for Movie shooting in Haryana (including at State Protected monuments)</a></li></ul></td></tr><tr><td>Home Department</td><td><ul><li><a href="../../../content/pdfs/ProcedureForApplyingForCinemaLicense.pdf" target="_blank">Procedure for Applying for Cinema License</a></li><li><a href="../../../content/pdfs/Procedure and Checklist _ Tourism Event License.pdf" target="_blank">Tourism Event License</a></li></ul></td></tr><tr><td>Communication and Connectivity Permissions</td><td><ul><li><a href="../../../content/pdfs/MobiletowerpermissonProcedure.pdf" target="_blank">Mobile Tower Permission - Procedure</a></li><li><a href="../../../content/pdfs/ChecklistandFees_ MobileTowerPermissions.pdf" target="_blank">Mobile Tower Permission - Checklist and Fee details</a></li></ul></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/listcompliances/listcompliances.html','<div ng-cloak><div class="container"><div class="row"><div class="col-sm-8 input-group"><input type="text" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Search.."> <span class="input-group-addon"><i class="fa fa-search"></i></span></div></div><div class="row"><!--            <h3 style="color: #A0233D"><b>Your Drafts (Submission required)</b></h3>--><table class="table table-striped table-hover"><thead><!--                <tr class="headerGrid">--><!--                    <th>#</th>--><!--                    <th>CAF Pin</th>--><!--                    &lt;!&ndash;<th>Investor Name</th>&ndash;&gt;--><!--                    <th>Name of Organization</th>--><!--                    <th>Industry Scale</th>--><!--                    <th>Type Of Business</th>--><!--                    <th>Compliance Dashboard for the Period</th>--><!--                    <th>Industry Classification</th>--><!--                    <th>Risk Category</th>--><!--                    <th>Organization Compliance Rating</th>--><!--                    <th></th>--><!--                </tr>--><!--                </thead>--><!--                <tbody>--><!--                <tr ng-repeat = "prdtl in vm.projectlistNA | filter:searchText | orderBy: \'-applicationDate\'">--><!--                    <td >{{$index+1}}</td>--><!--                    <td >{{prdtl.cafpin}}</td>--><!--                    &lt;!&ndash;<td >{{prdtl.investorName}}</td>&ndash;&gt;--><!--                    <td >{{prdtl.buisnessEntity}}</td>--><!--                    <td >{{prdtl.size_of_industry}}</td>--><!--                    <td >{{prdtl.product}}</td>--><!--                    <td >2024-2025</td>--><!--                    <td >&#45;&#45;&#45;&#45;&#45;&#45;</td>--><!--                    <td >&#45;&#45;&#45;&#45;&#45;&#45;</td>--><!--                    <td >&#45;&#45;&#45;&#45;&#45;&#45;</td>--><!--                    <td class="action verticalalign">--><!--                        <button type="button" class="btn btn-info" ng-click="vm.surveyFormOptions(prdtl)">Details</button>--><!--                    </td>--><!--                </tr>--><tr><h3 style="color: #A0233D"><b>Compliance Dashboard</b></h3></tr></thead><thead><tr class="headerGrid"><th>#</th><th>CAF Pin</th><!--<th>Investor Name</th>--><th>Name of Organization</th><th>Industry Scale</th><th>Type Of Business</th><th>Compliance Dashboard for the Period</th><th>Industry Classification</th><th>Risk Category</th><th>Organization Compliance Rating</th><th></th></tr></thead><tbody><tr ng-if="vm.account.email==\'testtesttest@gmail.com\'"><td>1</td><td>3306143695</td><!--<td >{{prdtl.investorName}}</td>--><td>Danish Lab</td><td>Medium - more than 5 crores and less than or upto 10 crores</td><td>Manufacturing</td><td>2024-2025</td><td>State</td><td>Orange</td><td>AAA</td><td class="action verticalalign"><button type="button" class="btn btn-info" ng-click="vm.goToProjectDetail(\'6791a861-0913-41c1-953b-708c76897cdd\')">Details</button></td></tr><tr dir-paginate="prdtl in vm.projectlistFinal | filter:searchText | orderBy:\'-applicationDate\' | itemsPerPage: pageSize" total-items="vm.totalElements" current-page="currentPage"><td>{{$index+1}}</td><td>{{prdtl.cafpin}}</td><!--<td >{{prdtl.investorName}}</td>--><td>{{prdtl.buisnessEntity}}</td><td>{{prdtl.sizeOfIndustry}}</td><td>{{prdtl.product}}</td><td>{{vm.getYearRange(prdtl.applicationDate)}}</td><td>------</td><td>------</td><td>------</td><td class="action verticalalign"><button type="button" class="btn btn-info" ng-click="vm.goToProjectDetail(prdtl.projectid)">Details</button></td></tr></tbody></table><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option><option value="1000">1000</option><option value="5000">5000</option><option value="10000">10000</option></select></div></div><div class="text-center"><!--                    <dir-pagination-controls on-page-change="pageChanged(newPageNumber)"></dir-pagination-controls>--><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div><div id="details-modal" class="uk-modal-container" uk-modal><div class="uk-modal-dialog"><button class="uk-modal-close-outside" type="button" uk-close></button><div class="uk-modal-header"><h2 class="uk-modal-title">Survey Form</h2></div><div class="uk-modal-body"><form name="myform" ng-submit="vm.saveSurvey()"><div class="row text-center"><div class="col-md-4"><p><strong>cafpin: </strong>{{vm.project.cafpin}}</p></div><div class="col-md-4"><p><strong>Business Entity: </strong>{{vm.project.businessentity}}</p></div><div class="col-md-4"><p><strong>District: </strong>{{vm.project.district}}</p></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Sectors<span style="color:red">*</span></label><div class="col-md-4"><select class="form-control" id="sectors" ng-model="vm.project.sectorname" ng-options="sector.sectortype as sector.sectortype for sector in vm.sectors" required><option value="" disabled="disabled">-- Select Sector --</option></select></div><div class="col-md-1" ng-show="vm.project.sectorname === \'Other Industries\'"><label class="control-label help-block">Specify<span style="color:red">*</span></label></div><div class="col-md-3" ng-show="vm.project.sectorname === \'Other Industries\'"><input type="text" class="form-control" placeholder="Please specify" ng-model="vm.project.otherFDI"></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Product of Manufacture /Service Provided<span style="color:red">*</span></label><div class="col-md-4"><input type="text" class="form-control" name="product" placeholder="Product Manufactured" ng-model="vm.project.product" required></div></div></div><br><div class="row"><div class="form-group"><div class="col-md-12 text-center"><p class="text-danger">*To know your block enter your village name or visit this <a target="_blank" href="../../content/pdfs/Categorization_of_Blocks.pdf">link</a></p></div><label for="village" class="col-md-4 control-label text-right">Village</label><div class="col-md-4"><input type="text" class="form-control" id="village" placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.proj.district === null" ng-model="vm.proj.village" ng-change="vm.setBlockCategory(vm.proj.village,vm.villages)"><datalist id="villages"><option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option></datalist></div><div class="col-md-4"><p class="help-block"><small ng-show="vm.invalidVillage" class="text-danger">invalid village name</small></p></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Category of Block<span style="color:red">*</span></label><div class="col-md-4"><select class="form-control" id="block" ng-model="vm.project.blockCategory" required><option value="" disabled="disabled">Select Block</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option></select></div><div class="col-md-2"><p class="help-block"><a class="text-danger" target="_blank" href="../../content/pdfs/140Blocks_GPs6205.pdf" data-toggle="modal" style="padding-top: 10px">* List of Blocks</a></p></div></div></div><br><div class="row"><div class="form-group text-right"><label class="col-md-4 control-label">Site Address:<span style="color:red">*</span></label><div class="col-lg-4"><textarea type="text" class="form-control" name="site" ng-model="vm.project.siteaddress" row="3" required></textarea></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Investment Type<span style="color:red">*</span></label><div class="col-md-4"><select class="form-control" ng-model="vm.project.investmentType" required><option value="" disabled="disabled">Select Type</option><option value="New Project">New Project</option><option value="Expansion Project">Expansion Project</option><option value="Existing Project (not a new investment in state)">Existing Project (not a new investment in state)</option><option value="Other">Other</option></select></div><div class="col-md-1" ng-show="vm.project.investmentType === \'Other\'"><label class="control-label help-block">Specify<span style="color:red">*</span></label></div><div class="col-md-3" ng-show="vm.project.investmentType === \'Other\'"><input type="text" class="form-control" placeholder="Please specify" ng-model="vm.project.otherInvestmetType"></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Expected Start Date of Commercial Production / Operations:<span style="color:red">*</span></label><div class="col-md-4"><div class="input-group"><input type="date" class="form-control" placeholder="Select Date" name="prodctionStartDate" ng-model="vm.project.prodctionStartDate" datetime-picker="{{dateformat}}" is-open="vm.datePickerOpenStatus.prodctionStartDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'prodctionStartDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Does your Investment include Foreign Direct Investment(FDI) component?<span style="color:red">*</span></label><div class="col-lg-2"><div class="radio text-center"><label class="col-md-6"><input ng-model="vm.radioToggle" value="Yes" type="radio" name="optradio" ng-click="vm.showFDI = true">Yes</label><label class="col-md-6"><input ng-model="vm.radioToggle" value="No" type="radio" name="optradio" checked="checked" ng-click="vm.showFDI = false">No</label></div></div></div></div><br><div class="row" ng-show="vm.showFDI"><div class="form-group"><label class="col-md-4 control-label text-right">Specify, FDI<span style="color:red">*</span></label><div class="col-md-8"><div class="col-lg-2"><input type="number" class="form-control" name="foreigncostcrores" placeholder="Crores" ng-model="vm.foreigninvestment_in_crores" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0"><div ng-show="myform.foreigncostcrores.$invalid || myform.foreigncostcrores.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-2"><input type="number" class="form-control" name="foreigncostlacs" placeholder="lacs" ng-model="vm.foreigninvestment_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0" max="99"><div ng-show="myform.foreigncostlacs.$invalid || myform.foreigncostlacs.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-3"><input type="number" class="form-control" name="foreigncostthousand" placeholder="thousands" ng-model="vm.foreigninvestment_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0" max="99"><div ng-show="myform.foreigncostthousand.$invalid || myform.foreigncostthousand.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div></div></div><br><div class="uk-modal-footer uk-text-right"><button type="button" ng-click="vm.hideApp()" ui-sref="projectdetailjist({projectid:vm.project.id})" class="uk-button uk-button-secondary" style="font-size: 14px">Skip</button> <button type="submit" ng-click="vm.save()" ng-disabled="myform.$invalid || vm.isSaving || (vm.project.investmentType === \'Other\' && (vm.project.otherInvestmetType === null || vm.project.otherInvestmetType === \'\'))\n                                               || (vm.project.sectorname === \'Other Industries\' && (vm.project.otherFDI === null || vm.project.otherFDI === \'\'))" class="uk-button uk-button-primary" style="font-size: 14px">Next <span class="glyphicon glyphicon-chevron-right"></span></button></div></form></div></div></div><!-- Modal --><div id="Next-modal" class="uk-modal-container" uk-modal><div class="uk-modal-dialog"><!-- Modal content--><div class="modal-content"><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h4 class="uk-modal-title">Survey Form</h4></div><div class="uk-modal-body"><form name="myform2" ng-submit="vm.saveSurvey()"><div class="row text-center"><div class="col-md-4"><p><strong>cafpin: </strong>{{vm.project.cafpin}}</p></div><div class="col-md-4"><p><strong>Business Entity: </strong>{{vm.project.businessentity}}</p></div><div class="col-md-4"><p><strong>District: </strong>{{vm.project.district}}</p></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Investment Initiation Date (Month & Year):<span style="color:red">*</span></label><div class="col-md-4"><div class="col-md-12 input-group"><input id="field_investmentDate" type="date" class="form-control" name="investmentDate" datetime-picker="{{dateformat}}" ng-model="vm.survey.investmentDate" is-open="vm.datePickerOpenStatus.investmentDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'investmentDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Grounded Investment (in Crores INR):<span style="color:red">*</span></label><div class="col-md-8 no-padding"><div class="col-md-3"><input type="number" class="form-control" name="croresCost" ng-change="vm.changeInGroundInvestment()" placeholder="Crores" ng-model="vm.ground_investment_in_crore" min="0"></div><small class="pull-left" style="margin-right:10px;margin-top:10px">crores</small><div class="col-md-3"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.ground_investment_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInGroundInvestment()" min="0" max="99"><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px">lacs</small><div class="col-md-3"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.ground_investment_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInGroundInvestment()" min="0" max="99"><div ng-show="myform2.thousandsCost.$invalid && myform2.thousandsCost.$touched || myform2.thousandsCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px">thousands</small></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Grounded Employmment<span style="color:red">*</span></label><div class="col-md-4"><input type="number" class="form-control" id="totalemplotment" placeholder="0" ng-model="vm.survey.groundedEmployement" min="0" required></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Out of persons employed above, are50% people employed with Haryana Domicile?<span style="color:red">*</span></label><div class="col-md-4"><label for="Yes8">Yes</label><input id="Yes8" type="radio" value="true" name="Choice8" ng-model="vm.survey.isEmployed"><label for="No8">No</label><input id="No8" type="radio" value="false" name="Choice8" ng-model="vm.survey.isEmployed"></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Are you aware of Employment Subsidy Scheme?:<span style="color:red">*</span></label><div class="col-md-2"><label for="Yes9">Yes</label><input id="Yes9" type="radio" value="true" name="Choice9" ng-click="vm.promotionYes=true" ng-model="vm.survey.isSubsidy"><label for="No9">No</label><input id="No9" type="radio" value="false" name="Choice9" ng-click="vm.promotionYes=false" ng-model="vm.survey.isSubsidy" checked="checked"></div><div ng-show="vm.promotionYes === true"><label class="col-md-4 control-label text-right">If Yes, have you applied for Employment Subsidy Scheme?<span style="color:red">*</span></label><div class="col-md-2"><label for="Yes10">Yes</label><input id="Yes10" type="radio" value="true" name="Choice10" ng-model="vm.survey.isAppliedSubsidy"><label for="No10">No</label><input id="No10" type="radio" value="false" name="Choice10" ng-model="vm.survey.isAppliedSubsidy"></div></div><div ng-show="vm.promotionYes === false"><label class="col-md-4 control-label text-right">If No, whether Enterprise Promotion Policy\u20132015 was brought to your notice?<span style="color:red">*</span></label><div class="col-md-2"><label for="Yes11">Yes</label><input id="Yes11" type="radio" value="true" name="Choice11" ng-model="vm.survey.isKnowledgePolicy"><label for="No11">No</label><input id="No11" type="radio" value="false" name="Choice11" ng-model="vm.survey.isKnowledgePolicy"></div></div></div></div><div class="uk-modal-footer uk-text-right"><button type="button" ng-click="vm.hideApp()" ui-sref="projectdetailjist({projectid:vm.project.id})" class="uk-button uk-button-secondary" style="font-size: 14px">Skip</button> <button type="submit" ng-disabled="myform2.$invalid || vm.onSuccess || vm.total_ground_investment === null || vm.survey.isSubsidy === undefined ||\n                                            vm.survey.isEmployed === undefined || (vm.survey.isAppliedSubsidy === undefined && vm.survey.isKnowledgePolicy === undefined)" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-save"></span>&nbsp;Submit</button></div></form></div></div><div id="blockCategoryHint" class="modal fade" role="dialog"><div class="modal-dialog"><embed src="../../content/pdfs/Categorization_of_Blocks.pdf" width="750px" height="1000px"></div></div><div id="blockCategoryHint1" class="modal fade" role="dialog"><div class="modal-dialog"><embed src="../../content/pdfs/140Blocks_GPs6205.pdf" width="750px" height="1000px"></div></div></div></div>');
$templateCache.put('app/listcompliances/listproject.html','<div ng-cloak><div class="container"><div class="row"><div class="col-sm-8 input-group"><input type="text" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Search.."> <span class="input-group-addon"><i class="fa fa-search"></i></span></div></div><div class="row"><h3 style="color: #A0233D"><b>Your Drafts (Submission required)</b></h3><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>CAF Pin</th><!--<th>Investor Name</th>--><th>RM Info (Relationship Manager)</th><th>Total Project Cost</th><th>Proposed Employment</th><th>Business Entity</th><th>CAF Type</th><th>District</th><th></th></tr></thead><tbody><tr ng-repeat="prdtl in vm.projectlistNA | filter:searchText | orderBy: \'-applicationDate\'"><td>{{$index+1}}</td><td>{{prdtl.cafpin}}</td><!--<td >{{prdtl.investorName}}</td>--><td>{{prdtl.rm==\'\' ? "Not Assigned" : prdtl.rm}}</td><td>{{prdtl.projectTotalCost}}</td><td>{{prdtl.totalEmployement}}</td><td>{{prdtl.buisnessEntity}}</td><td>{{prdtl.caftype}}</td><td>{{prdtl.district}}</td><td class="action verticalalign"><button type="button" class="btn btn-info" ng-click="vm.surveyFormOptions(prdtl)">Details</button></td></tr><tr><td colspan="3"><h3 style="color: #A0233D"><b>Your CAFs</b></h3></td></tr></tbody><thead><tr class="headerGrid"><th>#</th><th>CAF Pin</th><!--<th>Investor Name</th>--><th>RM Info (Relationship Manager)</th><th>Total Project Cost</th><th>Proposed Employment</th><th>Business Entity</th><th>CAF Type</th><th>District</th><th></th></tr></thead><tbody><tr ng-repeat="prdtl in vm.projectlistFinal | filter:searchText | orderBy: \'-applicationDate\'"><td>{{$index+1}}</td><td>{{prdtl.cafpin}}</td><!--<td >{{prdtl.investorName}}</td>--><td>{{prdtl.rm==\'\' ? "Not Assigned" : prdtl.rm}}</td><td>{{prdtl.projectTotalCost}}</td><td>{{prdtl.totalEmployement}}</td><td>{{prdtl.buisnessEntity}}</td><td>{{prdtl.caftype}}</td><td>{{prdtl.district}}</td><td class="action verticalalign"><button type="button" class="btn btn-info" ng-click="vm.surveyFormOptions(prdtl)">Details</button></td></tr></tbody></table></div></div></div><div id="details-modal" class="uk-modal-container" uk-modal><div class="uk-modal-dialog"><button class="uk-modal-close-outside" type="button" uk-close></button><div class="uk-modal-header"><h2 class="uk-modal-title">Survey Form</h2></div><div class="uk-modal-body"><form name="myform" ng-submit="vm.saveSurvey()"><div class="row text-center"><div class="col-md-4"><p><strong>cafpin: </strong>{{vm.project.cafpin}}</p></div><div class="col-md-4"><p><strong>Business Entity: </strong>{{vm.project.businessentity}}</p></div><div class="col-md-4"><p><strong>District: </strong>{{vm.project.district}}</p></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Sectors<span style="color:red">*</span></label><div class="col-md-4"><select class="form-control" id="sectors" ng-model="vm.project.sectorname" ng-options="sector.sectortype as sector.sectortype for sector in vm.sectors" required><option value="" disabled="disabled">-- Select Sector --</option></select></div><div class="col-md-1" ng-show="vm.project.sectorname === \'Other Industries\'"><label class="control-label help-block">Specify<span style="color:red">*</span></label></div><div class="col-md-3" ng-show="vm.project.sectorname === \'Other Industries\'"><input type="text" class="form-control" placeholder="Please specify" ng-model="vm.project.otherFDI"></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Product of Manufacture /Service Provided<span style="color:red">*</span></label><div class="col-md-4"><input type="text" class="form-control" name="product" placeholder="Product Manufactured" ng-model="vm.project.product" required></div></div></div><br><div class="row"><div class="form-group"><div class="col-md-12 text-center"><p class="text-danger">*To know your block enter your village name or visit this <a target="_blank" href="../../content/pdfs/Categorization_of_Blocks.pdf">link</a></p></div><label for="village" class="col-md-4 control-label text-right">Village</label><div class="col-md-4"><input type="text" class="form-control" id="village" placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.proj.district === null" ng-model="vm.proj.village" ng-change="vm.setBlockCategory(vm.proj.village,vm.villages)"><datalist id="villages"><option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option></datalist></div><div class="col-md-4"><p class="help-block"><small ng-show="vm.invalidVillage" class="text-danger">invalid village name</small></p></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Category of Block<span style="color:red">*</span></label><div class="col-md-4"><select class="form-control" id="block" ng-model="vm.project.blockCategory" required><option value="" disabled="disabled">Select Block</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option></select></div><div class="col-md-2"><p class="help-block"><a class="text-danger" target="_blank" href="../../content/pdfs/140Blocks_GPs6205.pdf" data-toggle="modal" style="padding-top: 10px">* List of Blocks</a></p></div></div></div><br><div class="row"><div class="form-group text-right"><label class="col-md-4 control-label">Site Address:<span style="color:red">*</span></label><div class="col-lg-4"><textarea type="text" class="form-control" name="site" ng-model="vm.project.siteaddress" row="3" required></textarea></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Investment Type<span style="color:red">*</span></label><div class="col-md-4"><select class="form-control" ng-model="vm.project.investmentType" required><option value="" disabled="disabled">Select Type</option><option value="New Project">New Project</option><option value="Expansion Project">Expansion Project</option><option value="Existing Project (not a new investment in state)">Existing Project (not a new investment in state)</option><option value="Other">Other</option></select></div><div class="col-md-1" ng-show="vm.project.investmentType === \'Other\'"><label class="control-label help-block">Specify<span style="color:red">*</span></label></div><div class="col-md-3" ng-show="vm.project.investmentType === \'Other\'"><input type="text" class="form-control" placeholder="Please specify" ng-model="vm.project.otherInvestmetType"></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Expected Start Date of Commercial Production / Operations:<span style="color:red">*</span></label><div class="col-md-4"><div class="input-group"><input type="date" class="form-control" placeholder="Select Date" name="prodctionStartDate" ng-model="vm.project.prodctionStartDate" datetime-picker="{{dateformat}}" is-open="vm.datePickerOpenStatus.prodctionStartDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'prodctionStartDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Does your Investment include Foreign Direct Investment(FDI) component?<span style="color:red">*</span></label><div class="col-lg-2"><div class="radio text-center"><label class="col-md-6"><input ng-model="vm.radioToggle" value="Yes" type="radio" name="optradio" ng-click="vm.showFDI = true">Yes</label><label class="col-md-6"><input ng-model="vm.radioToggle" value="No" type="radio" name="optradio" checked="checked" ng-click="vm.showFDI = false">No</label></div></div></div></div><br><div class="row" ng-show="vm.showFDI"><div class="form-group"><label class="col-md-4 control-label text-right">Specify, FDI<span style="color:red">*</span></label><div class="col-md-8"><div class="col-lg-2"><input type="number" class="form-control" name="foreigncostcrores" placeholder="Crores" ng-model="vm.foreigninvestment_in_crores" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0"><div ng-show="myform.foreigncostcrores.$invalid || myform.foreigncostcrores.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-2"><input type="number" class="form-control" name="foreigncostlacs" placeholder="lacs" ng-model="vm.foreigninvestment_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0" max="99"><div ng-show="myform.foreigncostlacs.$invalid || myform.foreigncostlacs.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-3"><input type="number" class="form-control" name="foreigncostthousand" placeholder="thousands" ng-model="vm.foreigninvestment_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0" max="99"><div ng-show="myform.foreigncostthousand.$invalid || myform.foreigncostthousand.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div></div></div><br><div class="uk-modal-footer uk-text-right"><button type="button" ng-click="vm.hideApp()" ui-sref="projectdetailjist({projectid:vm.project.id})" class="uk-button uk-button-secondary" style="font-size: 14px">Skip</button> <button type="submit" ng-click="vm.save()" ng-disabled="myform.$invalid || vm.isSaving || (vm.project.investmentType === \'Other\' && (vm.project.otherInvestmetType === null || vm.project.otherInvestmetType === \'\'))\n                                               || (vm.project.sectorname === \'Other Industries\' && (vm.project.otherFDI === null || vm.project.otherFDI === \'\'))" class="uk-button uk-button-primary" style="font-size: 14px">Next <span class="glyphicon glyphicon-chevron-right"></span></button></div></form></div></div></div><!-- Modal --><div id="Next-modal" class="uk-modal-container" uk-modal><div class="uk-modal-dialog"><!-- Modal content--><div class="modal-content"><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h4 class="uk-modal-title">Survey Form</h4></div><div class="uk-modal-body"><form name="myform2" ng-submit="vm.saveSurvey()"><div class="row text-center"><div class="col-md-4"><p><strong>cafpin: </strong>{{vm.project.cafpin}}</p></div><div class="col-md-4"><p><strong>Business Entity: </strong>{{vm.project.businessentity}}</p></div><div class="col-md-4"><p><strong>District: </strong>{{vm.project.district}}</p></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Investment Initiation Date (Month & Year):<span style="color:red">*</span></label><div class="col-md-4"><div class="col-md-12 input-group"><input id="field_investmentDate" type="date" class="form-control" name="investmentDate" datetime-picker="{{dateformat}}" ng-model="vm.survey.investmentDate" is-open="vm.datePickerOpenStatus.investmentDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'investmentDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Grounded Investment (in Crores INR):<span style="color:red">*</span></label><div class="col-md-8 no-padding"><div class="col-md-3"><input type="number" class="form-control" name="croresCost" ng-change="vm.changeInGroundInvestment()" placeholder="Crores" ng-model="vm.ground_investment_in_crore" min="0"></div><small class="pull-left" style="margin-right:10px;margin-top:10px">crores</small><div class="col-md-3"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.ground_investment_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInGroundInvestment()" min="0" max="99"><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px">lacs</small><div class="col-md-3"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.ground_investment_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInGroundInvestment()" min="0" max="99"><div ng-show="myform2.thousandsCost.$invalid && myform2.thousandsCost.$touched || myform2.thousandsCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px">thousands</small></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Grounded Employmment<span style="color:red">*</span></label><div class="col-md-4"><input type="number" class="form-control" id="totalemplotment" placeholder="0" ng-model="vm.survey.groundedEmployement" min="0" required></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Out of persons employed above, are50% people employed with Haryana Domicile?<span style="color:red">*</span></label><div class="col-md-4"><label for="Yes8">Yes</label><input id="Yes8" type="radio" value="true" name="Choice8" ng-model="vm.survey.isEmployed"><label for="No8">No</label><input id="No8" type="radio" value="false" name="Choice8" ng-model="vm.survey.isEmployed"></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Are you aware of Employment Subsidy Scheme?:<span style="color:red">*</span></label><div class="col-md-2"><label for="Yes9">Yes</label><input id="Yes9" type="radio" value="true" name="Choice9" ng-click="vm.promotionYes=true" ng-model="vm.survey.isSubsidy"><label for="No9">No</label><input id="No9" type="radio" value="false" name="Choice9" ng-click="vm.promotionYes=false" ng-model="vm.survey.isSubsidy" checked="checked"></div><div ng-show="vm.promotionYes === true"><label class="col-md-4 control-label text-right">If Yes, have you applied for Employment Subsidy Scheme?<span style="color:red">*</span></label><div class="col-md-2"><label for="Yes10">Yes</label><input id="Yes10" type="radio" value="true" name="Choice10" ng-model="vm.survey.isAppliedSubsidy"><label for="No10">No</label><input id="No10" type="radio" value="false" name="Choice10" ng-model="vm.survey.isAppliedSubsidy"></div></div><div ng-show="vm.promotionYes === false"><label class="col-md-4 control-label text-right">If No, whether Enterprise Promotion Policy\u20132015 was brought to your notice?<span style="color:red">*</span></label><div class="col-md-2"><label for="Yes11">Yes</label><input id="Yes11" type="radio" value="true" name="Choice11" ng-model="vm.survey.isKnowledgePolicy"><label for="No11">No</label><input id="No11" type="radio" value="false" name="Choice11" ng-model="vm.survey.isKnowledgePolicy"></div></div></div></div><div class="uk-modal-footer uk-text-right"><button type="button" ng-click="vm.hideApp()" ui-sref="projectdetailjist({projectid:vm.project.id})" class="uk-button uk-button-secondary" style="font-size: 14px">Skip</button> <button type="submit" ng-disabled="myform2.$invalid || vm.onSuccess || vm.total_ground_investment === null || vm.survey.isSubsidy === undefined ||\n                                            vm.survey.isEmployed === undefined || (vm.survey.isAppliedSubsidy === undefined && vm.survey.isKnowledgePolicy === undefined)" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-save"></span>&nbsp;Submit</button></div></form></div></div><div id="blockCategoryHint" class="modal fade" role="dialog"><div class="modal-dialog"><embed src="../../content/pdfs/Categorization_of_Blocks.pdf" width="750px" height="1000px"></div></div><div id="blockCategoryHint1" class="modal fade" role="dialog"><div class="modal-dialog"><embed src="../../content/pdfs/140Blocks_GPs6205.pdf" width="750px" height="1000px"></div></div></div></div>');
$templateCache.put('app/listproject/listproject.html','<div ng-cloak><div class="container"><div class="row"><div class="col-sm-8 input-group"><input type="text" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Search.."> <span class="input-group-addon"><i class="fa fa-search"></i></span></div></div><div class="row"><h3 style="color: #A0233D"><b data-translate="global.viewcaf.Your Drafts">Your Drafts (Submission required)</b></h3><table class="jh-table table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th data-translate="global.viewcaf.CAF Pin">CAF Pin</th><!--<th>Investor Name</th>--><th data-translate="global.viewcaf.RM Info">RM Info</th><th data-translate="global.viewcaf.Total Project Cost">Total Project Cost</th><th data-translate="global.viewcaf.Proposed Employment">Proposed Employment</th><th data-translate="global.viewcaf.Business Entity">Business Entity</th><th data-translate="global.viewcaf.CAF Type">CAF Type</th><th data-translate="global.viewcaf.District">District</th><th></th></tr></thead><tbody><tr dir-paginate="prdtl in vm.projectlistNA | filter:searchText | orderBy:\'-applicationDate\' | itemsPerPage: pageSize" total-items="vm.totalElements" current-page="currentPage"><td>{{$index + 1}}</td><td>{{prdtl.cafpin}}</td><!--<td>{{prdtl.investorName}}</td>--><td>{{prdtl.rm === \'\' ? "Not Assigned" : prdtl.rm}}</td><td>{{prdtl.projectTotalCost}}</td><td>{{prdtl.totalEmployement}}</td><td>{{prdtl.buisnessEntity}}</td><td>{{prdtl.caftype}}</td><td>{{prdtl.district}}</td><td class="action verticalalign"><button type="button" class="btn btn-info" ng-click="vm.surveyFormOptions(prdtl)" data-translate="global.viewcaf.Detail">Details</button></td></tr><tr><td colspan="3"><h3 style="color: #A0233D"><b data-translate="global.viewcaf.Your CAFs">Your CAFs</b></h3></td></tr></tbody><thead><tr class="headerGrid"><th>#</th><th data-translate="global.viewcaf.CAF Pin">CAF Pin</th><!--<th>Investor Name</th>--><th data-translate="global.viewcaf.RM Info">RM Info</th><th data-translate="global.viewcaf.Total Project Cost">Total Project Cost</th><th data-translate="global.viewcaf.Proposed Employment">Proposed Employment</th><th data-translate="global.viewcaf.Business Entity">Business Entity</th><th data-translate="global.viewcaf.CAF Type">CAF Type</th><th data-translate="global.viewcaf.District">District</th><th></th></tr></thead><tbody><tr dir-paginate="prdtl in vm.projectlistFinal | filter:searchText | orderBy:\'-applicationDate\' | itemsPerPage: pageSize" total-items="vm.totalElements" current-page="currentPage"><td>{{$index + 1}}</td><td>{{prdtl.cafpin}}</td><!--<td>{{prdtl.investorName}}</td>--><td>{{prdtl.rm === \'\' ? "Not Assigned" : prdtl.rm}}</td><td>{{prdtl.projectTotalCost}}</td><td>{{prdtl.totalEmployement}}</td><td>{{prdtl.buisnessEntity}}</td><td>{{prdtl.caftype}}</td><td>{{prdtl.district}}</td><td class="action verticalalign"><button type="button" class="btn btn-info" ng-click="vm.surveyFormOptions(prdtl)" data-translate="global.viewcaf.Detail">Details</button></td></tr><!--                <tr ng-repeat="prdtl in vm.projectlistFinal | filter:searchText | orderBy: \'-applicationDate\'">--><!--                    <td >{{$index+1}}</td>--><!--                    <td >{{prdtl.cafpin}}</td>--><!--                    &lt;!&ndash;<td >{{prdtl.investorName}}</td>&ndash;&gt;--><!--                    <td >{{prdtl.rm==\'\' ? "Not Assigned" : prdtl.rm}}</td>--><!--                    <td >{{prdtl.projectTotalCost}}</td>--><!--                    <td >{{prdtl.totalEmployement}}</td>--><!--                    <td >{{prdtl.buisnessEntity}}</td>--><!--                    <td >{{prdtl.caftype}}</td>--><!--                    <td >{{prdtl.district}}</td>--><!--                    <td class="action verticalalign">--><!--                        <button type="button" class="btn btn-info" ng-click="vm.surveyFormOptions(prdtl)" data-translate="global.viewcaf.Detail">Details</button>--><!--                    </td>--><!--                </tr>--></tbody></table><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option><option value="1000">1000</option><option value="5000">5000</option><option value="10000">10000</option></select></div></div><div class="text-center"><!--                    <dir-pagination-controls on-page-change="pageChanged(newPageNumber)"></dir-pagination-controls>--><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div><div id="details-modal" class="uk-modal-container" uk-modal><div class="uk-modal-dialog"><button class="uk-modal-close-outside" type="button" uk-close></button><div class="uk-modal-header"><h2 class="uk-modal-title">Survey Form</h2></div><div class="uk-modal-body"><form name="myform" ng-submit="vm.saveSurvey()"><div class="row text-center"><div class="col-md-4"><p><strong>cafpin: </strong>{{vm.project.cafpin}}</p></div><div class="col-md-4"><p><strong>Business Entity: </strong>{{vm.project.businessentity}}</p></div><div class="col-md-4"><p><strong>District: </strong>{{vm.project.district}}</p></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Sectors<span style="color:red">*</span></label><div class="col-md-4"><select class="form-control" id="sectors" ng-model="vm.project.sectorname" ng-options="sector.sectortype as sector.sectortype for sector in vm.sectors" required><option value="" disabled="disabled">-- Select Sector --</option></select></div><div class="col-md-1" ng-show="vm.project.sectorname === \'Other Industries\'"><label class="control-label help-block">Specify<span style="color:red">*</span></label></div><div class="col-md-3" ng-show="vm.project.sectorname === \'Other Industries\'"><input type="text" class="form-control" placeholder="Please specify" ng-model="vm.project.otherFDI"></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Product of Manufacture /Service Provided<span style="color:red">*</span></label><div class="col-md-4"><input type="text" class="form-control" name="product" placeholder="Product Manufactured" ng-model="vm.project.product" required></div></div></div><br><div class="row"><div class="form-group"><div class="col-md-12 text-center"><p class="text-danger">*To know your block enter your village name or visit this <a target="_blank" href="../../content/pdfs/Categorization_of_Blocks.pdf">link</a></p></div><label for="village" class="col-md-4 control-label text-right">Village</label><div class="col-md-4"><input type="text" class="form-control" id="village" placeholder="Enter Vilage Name" list="villages" ng-disabled="vm.proj.district === null" ng-model="vm.proj.village" ng-change="vm.setBlockCategory(vm.proj.village,vm.villages)"><datalist id="villages"><option value="{{village.village}}" ng-repeat="village in vm.villages">{{village.village}}</option></datalist></div><div class="col-md-4"><p class="help-block"><small ng-show="vm.invalidVillage" class="text-danger">invalid village name</small></p></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Category of Block<span style="color:red">*</span></label><div class="col-md-4"><select class="form-control" id="block" ng-model="vm.project.blockCategory" required><option value="" disabled="disabled">Select Block</option><option value="A">A</option><option value="B">B</option><option value="C">C</option><option value="D">D</option></select></div><div class="col-md-2"><p class="help-block"><a class="text-danger" target="_blank" href="../../content/pdfs/140Blocks_GPs6205.pdf" data-toggle="modal" style="padding-top: 10px">* List of Blocks</a></p></div></div></div><br><div class="row"><div class="form-group text-right"><label class="col-md-4 control-label">Site Address:<span style="color:red">*</span></label><div class="col-lg-4"><textarea type="text" class="form-control" name="site" ng-model="vm.project.siteaddress" row="3" required></textarea></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Investment Type<span style="color:red">*</span></label><div class="col-md-4"><select class="form-control" ng-model="vm.project.investmentType" required><option value="" disabled="disabled">Select Type</option><option value="New Project">New Project</option><option value="Expansion Project">Expansion Project</option><option value="Existing Project (not a new investment in state)">Existing Project (not a new investment in state)</option><option value="Other">Other</option></select></div><div class="col-md-1" ng-show="vm.project.investmentType === \'Other\'"><label class="control-label help-block">Specify<span style="color:red">*</span></label></div><div class="col-md-3" ng-show="vm.project.investmentType === \'Other\'"><input type="text" class="form-control" placeholder="Please specify" ng-model="vm.project.otherInvestmetType"></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Expected Start Date of Commercial Production / Operations:<span style="color:red">*</span></label><div class="col-md-4"><div class="input-group"><input type="date" class="form-control" placeholder="Select Date" name="prodctionStartDate" ng-model="vm.project.prodctionStartDate" datetime-picker="{{dateformat}}" is-open="vm.datePickerOpenStatus.prodctionStartDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'prodctionStartDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Does your Investment include Foreign Direct Investment(FDI) component?<span style="color:red">*</span></label><div class="col-lg-2"><div class="radio text-center"><label class="col-md-6"><input ng-model="vm.radioToggle" value="Yes" type="radio" name="optradio" ng-click="vm.showFDI = true">Yes</label><label class="col-md-6"><input ng-model="vm.radioToggle" value="No" type="radio" name="optradio" checked="checked" ng-click="vm.showFDI = false">No</label></div></div></div></div><br><div class="row" ng-show="vm.showFDI"><div class="form-group"><label class="col-md-4 control-label text-right">Specify, FDI<span style="color:red">*</span></label><div class="col-md-8"><div class="col-lg-2"><input type="number" class="form-control" name="foreigncostcrores" placeholder="Crores" ng-model="vm.foreigninvestment_in_crores" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0"><div ng-show="myform.foreigncostcrores.$invalid || myform.foreigncostcrores.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-lg-2"><input type="number" class="form-control" name="foreigncostlacs" placeholder="lacs" ng-model="vm.foreigninvestment_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0" max="99"><div ng-show="myform.foreigncostlacs.$invalid || myform.foreigncostlacs.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-lg-3"><input type="number" class="form-control" name="foreigncostthousand" placeholder="thousands" ng-model="vm.foreigninvestment_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInForeignInvestment()" min="0" max="99"><div ng-show="myform.foreigncostthousand.$invalid || myform.foreigncostthousand.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div></div></div><br><div class="uk-modal-footer uk-text-right"><button type="button" ng-click="vm.hideApp()" ui-sref="projectdetailjist({projectid:vm.project.id})" class="uk-button uk-button-secondary" style="font-size: 14px">Skip</button> <button type="submit" ng-click="vm.save()" ng-disabled="myform.$invalid || vm.isSaving || (vm.project.investmentType === \'Other\' && (vm.project.otherInvestmetType === null || vm.project.otherInvestmetType === \'\'))\n                                               || (vm.project.sectorname === \'Other Industries\' && (vm.project.otherFDI === null || vm.project.otherFDI === \'\'))" class="uk-button uk-button-primary" style="font-size: 14px">Next <span class="glyphicon glyphicon-chevron-right"></span></button></div></form></div></div></div><!-- Modal --><div id="Next-modal" class="uk-modal-container" uk-modal><div class="uk-modal-dialog"><!-- Modal content--><div class="modal-content"><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h4 class="uk-modal-title">Survey Form</h4></div><div class="uk-modal-body"><form name="myform2" ng-submit="vm.saveSurvey()"><div class="row text-center"><div class="col-md-4"><p><strong>cafpin: </strong>{{vm.project.cafpin}}</p></div><div class="col-md-4"><p><strong>Business Entity: </strong>{{vm.project.businessentity}}</p></div><div class="col-md-4"><p><strong>District: </strong>{{vm.project.district}}</p></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Investment Initiation Date (Month & Year):<span style="color:red">*</span></label><div class="col-md-4"><div class="col-md-12 input-group"><input id="field_investmentDate" type="date" class="form-control" name="investmentDate" datetime-picker="{{dateformat}}" ng-model="vm.survey.investmentDate" is-open="vm.datePickerOpenStatus.investmentDate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'investmentDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Grounded Investment (in Crores INR):<span style="color:red">*</span></label><div class="col-md-8 no-padding"><div class="col-md-3"><input type="number" class="form-control" name="croresCost" ng-change="vm.changeInGroundInvestment()" placeholder="Crores" ng-model="vm.ground_investment_in_crore" min="0"></div><small class="pull-left" style="margin-right:10px;margin-top:10px">crores</small><div class="col-md-3"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.ground_investment_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInGroundInvestment()" min="0" max="99"><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px">lacs</small><div class="col-md-3"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.ground_investment_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInGroundInvestment()" min="0" max="99"><div ng-show="myform2.thousandsCost.$invalid && myform2.thousandsCost.$touched || myform2.thousandsCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px">thousands</small></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Grounded Employmment<span style="color:red">*</span></label><div class="col-md-4"><input type="number" class="form-control" id="totalemplotment" placeholder="0" ng-model="vm.survey.groundedEmployement" min="0" required></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Out of persons employed above, are50% people employed with Haryana Domicile?<span style="color:red">*</span></label><div class="col-md-4"><label for="Yes8">Yes</label><input id="Yes8" type="radio" value="true" name="Choice8" ng-model="vm.survey.isEmployed"><label for="No8">No</label><input id="No8" type="radio" value="false" name="Choice8" ng-model="vm.survey.isEmployed"></div></div></div><br><div class="row"><div class="form-group"><label class="col-md-4 control-label text-right">Are you aware of Employment Subsidy Scheme?:<span style="color:red">*</span></label><div class="col-md-2"><label for="Yes9">Yes</label><input id="Yes9" type="radio" value="true" name="Choice9" ng-click="vm.promotionYes=true" ng-model="vm.survey.isSubsidy"><label for="No9">No</label><input id="No9" type="radio" value="false" name="Choice9" ng-click="vm.promotionYes=false" ng-model="vm.survey.isSubsidy" checked="checked"></div><div ng-show="vm.promotionYes === true"><label class="col-md-4 control-label text-right">If Yes, have you applied for Employment Subsidy Scheme?<span style="color:red">*</span></label><div class="col-md-2"><label for="Yes10">Yes</label><input id="Yes10" type="radio" value="true" name="Choice10" ng-model="vm.survey.isAppliedSubsidy"><label for="No10">No</label><input id="No10" type="radio" value="false" name="Choice10" ng-model="vm.survey.isAppliedSubsidy"></div></div><div ng-show="vm.promotionYes === false"><label class="col-md-4 control-label text-right">If No, whether Enterprise Promotion Policy\u20132015 was brought to your notice?<span style="color:red">*</span></label><div class="col-md-2"><label for="Yes11">Yes</label><input id="Yes11" type="radio" value="true" name="Choice11" ng-model="vm.survey.isKnowledgePolicy"><label for="No11">No</label><input id="No11" type="radio" value="false" name="Choice11" ng-model="vm.survey.isKnowledgePolicy"></div></div></div></div><div class="uk-modal-footer uk-text-right"><button type="button" ng-click="vm.hideApp()" ui-sref="projectdetailjist({projectid:vm.project.id})" class="uk-button uk-button-secondary" style="font-size: 14px">Skip</button> <button type="submit" ng-disabled="myform2.$invalid || vm.onSuccess || vm.total_ground_investment === null || vm.survey.isSubsidy === undefined ||\n                                            vm.survey.isEmployed === undefined || (vm.survey.isAppliedSubsidy === undefined && vm.survey.isKnowledgePolicy === undefined)" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-save"></span>&nbsp;Submit</button></div></form></div></div><div id="blockCategoryHint" class="modal fade" role="dialog"><div class="modal-dialog"><embed src="../../content/pdfs/Categorization_of_Blocks.pdf" width="750px" height="1000px"></div></div><div id="blockCategoryHint1" class="modal fade" role="dialog"><div class="modal-dialog"><embed src="../../content/pdfs/140Blocks_GPs6205.pdf" width="750px" height="1000px"></div></div></div></div>');
$templateCache.put('app/migratedata/indexMigrateData.html','<div class="container"><div class="row"><div class="col-sm-3"><button type="submit" ng-click="vm.migrate_project_service_log()" class="btn btn-info" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">Migrate Project Service Log Data</button></div><div class="col-sm-3"><button type="submit" ng-click="vm.migrate_total_service_dashboard_detail()" class="btn btn-info" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">Migrate Total Service Dashboard Detail Data</button></div><div class="col-sm-3"><button type="submit" ng-click="vm.migrate_project_service_detail()" class="btn btn-info" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">Migrate Project Service Detail Data</button></div><div class="col-sm-3"><button type="submit" ng-click="vm.migrate_grievance()" class="btn btn-info" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">Migrate Grievance Data</button></div><div class="col-sm-3"><button type="submit" ng-click="vm.migrate_grievance_log()" class="btn btn-info" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">Migrate Grievance Log Data</button></div><div class="col-sm-3"><button type="submit" ng-click="vm.migrate_grievance_dashboard_output()" class="btn btn-info" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">Migrate Grievance Dashboard Output Data</button></div><div class="col-sm-3"><button type="submit" ng-click="vm.migrate_project_assigned_data()" class="btn btn-info" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">Migrate Assigned Project Data</button></div></div></div>');
$templateCache.put('app/migratedata/migratedata.html','<div class="container"><!--<div class=" col-sm-2">--><!--<button type="submit" ng-click="vm.migratedata()" class="btn btn-info " has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate Data</button>--><!--</div>--><div class="row col-sm-12"><div class="col-sm-3"><button type="submit" ng-click="vm.migrate_project_elastic_data()" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate Project data to Elastic</button></div><div class="col-sm-5"><button type="submit" ng-click="vm.migrate_projectservicedetail_elastic_data()" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate Project Service Detail data to Elastic</button></div><div class="col-sm-3"><button type="submit" ng-click="vm.migrate_min_max_to_Elastic()" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate Min/Max to Department Service</button></div></div><div class="row col-sm-12"><div class="col-sm-2"><button type="submit" ng-click="vm.migrateApplicationDate()" class="btn btn-info" has-any-authority="ROLE_ADMIN">Migrate Application Date</button></div></div><br><div class="row"><div class="col-sm-3"><button type="submit" ng-click="vm.migrate_service_dashboard_data()" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate Service Dashboard Data</button></div><div class="col-sm-4"><button type="submit" ng-click="vm.migrate_tower_service_dashboard_data1()" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate Tower Service Dashboard Data</button></div><div class="col-sm-3"><button type="submit" ng-click="vm.migrateGrievanceDashboardData()" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate Grievance Dashboard Data</button></div></div><br><div class="row"><div class="col-sm-4"><button type="submit" ng-click="vm.migratedashboardbetweendatescafsdata()" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate Dashboard Between Dates CAFs Data</button></div><div class="col-sm-4"><button type="submit" ng-click="vm.migratedashboardbetweendatesdata()" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate Dashboard Between Dates Stats Data</button></div><div class="col-sm-3"><button type="submit" ng-click="vm.migrate_nodalofficer_dashboard_data()" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate Nodal Officer Dashboard Data</button></div><!--<div class=" col-sm-4">--><!--<button type="submit" ng-click="vm.setisrequiredtotrue()" class="btn btn-info " has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Set IsRequired To True of two Entities</button>--><!--</div>--></div><br><div class="row"><div class="col-sm-3"><button type="submit" ng-click="vm.migrateTotalDashboardData()" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate Total Dashboard Data</button></div><!--<div class=" col-sm-3">--><!--<button type="submit" ng-click="vm.setAttachmentNull()" class="btn btn-info " has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Setting attachments to null for grievance.</button>--><!--</div>--><div class="col-sm-4"><button type="submit" ng-click="vm.migrate_tower_service_dashboard_data2()" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Set Department in ProjectServiceDetail</button></div><div class="col-sm-3"><button type="submit" class="btn btn-info" has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN" data-toggle="modal" data-target="#myModal">Set Department by choice</button></div></div><br><div class="row"><!--<div class=" col-sm-2">--><!--<button type="submit" ng-click="vm.shareAllDataToMou()" class="btn btn-info " has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Sharing all cafs to mou</button>--><!--</div>--><!--<div class=" col-sm-2">--><!--<button type="submit" ng-click="vm.showDuplicate()" class="btn btn-info " has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN" >Remove Null IsDeactivated</button>--><!--</div>--><!--<div class=" col-sm-2">--><!--<button type="submit" class="btn btn-info " has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN" data-toggle="modal" data-target="#reAssignModal">Re-Assign Grievance</button>--><!--</div>--><!--<div class=" col-sm-2">--><!--<button type="submit" ng-click="vm.setReapplyCounter()" class="btn btn-info " has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Set ReApply Counter to 1</button>--><!--</div>--><!--<div class=" col-sm-2">--><!--<button type="submit" ng-click="vm.migrateGrievancewithAssignBy()" class="btn btn-info " has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN" data-toggle="modal" data-target="#myModal2">Get Assign By</button>--><!--</div>--></div><br><div class="row"><div class="col-sm-3"><button type="submit" ng-click="vm.migrateNewDashboardStats()" class="btn btn-info">Migrating New Dashboard Stats</button></div><div class="col-sm-3"><button type="submit" ng-click="vm.migrateCafServiceStatus()" class="btn btn-info">Migrating Caf Service Status</button></div><div class="col-sm-3 col-md-offset-1 form-group"><button type="submit" ng-click="vm.setStatusDates()" class="btn btn-info">Migrate Department Name From Cafs Nodal officer(Tower)</button></div><!--<div class=" col-sm-3">--><!--<button type="submit" ng-click="vm.migratePreviousServiceStats()" class="btn btn-info ">Migrate Previous Service Stats1</button>--><!--</div>--><!--<div class=" col-sm-3">--><!--<button type="submit" ng-click="vm.migrateServiceStatusData()" class="btn btn-info ">Migrate Service Status Data1</button>--><!--</div>--><!--<div class=" col-sm-2">--><!--<button class="btn btn-warning" type="submit" ng-click="vm.testFireBulkEmails()">Test fire bulk email.</button>--><!--</div>--><!--<div class=" col-sm-2">--><!--<button class="btn btn-danger" type="submit" ng-click="vm.fireBulkEmails()">Fire.</button>--><!--</div>--></div><div class="row"><div class="col-sm-3"><button type="submit" ng-click="vm.migrateRatingsData()" class="btn btn-info">Migrate Ratings Data</button></div><!--<div class=" col-sm-3">--><!--<button type="submit" ng-click="vm.migrate_reapply_dashboard_data()" class="btn btn-info " has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN">Migrate ReApplyDashboard Data</button>--><!--</div>--><div class="col-sm-4"><button type="submit" ng-click="vm.migrateRatings()" class="btn btn-info">Ratings to RatingsByDepartmentId</button></div><div class="col-sm-3 form-group"><button type="submit" ng-click="vm.migrateHomePageCounts()" class="btn btn-info">Migrate Home Page Counts</button></div></div><br><div class="row"><div class="col-sm-3"><button type="submit" ng-click="vm.migrateProjectByEmail()" class="btn btn-info">Migrate Mean & Median</button></div><div class="col-sm-4"><button type="submit" ng-click="vm.saveMultipleUsersWithSingleMail()" class="btn btn-info">Save Active Multiple User With Single Mail</button></div><div class="col-sm-3"><button type="submit" ng-click="vm.saveMultipleUserWithSingleMailWithoutCaf()" class="btn btn-info">Save Users Without Caf</button></div><div class="col-sm-2"><button type="submit" ng-click="vm.saveMultipleUserWithSingleMailWithCaf()" class="btn btn-info">Save Users With Caf</button></div><div class="col-sm-2"><button type="submit" ng-click="vm.saveRejectionReason()" class="btn btn-info">Save Rejection Reason</button></div></div><br><div class="row"><div class="col-sm-3 form-group"><button type="button" ng-click="vm.migrateHepcTicketlogsData(\'feedbackByTicketNumber\')" class="btn btn-info">Migrate Ticket Feedback Data</button></div><div class="col-sm-3 form-group"><button type="button" ng-click="vm.migrateHepcTicketlogsData(\'SendMailToClosedTicket\')" class="btn btn-warning">Send Mail To Closed Ticket</button></div><div class="col-sm-3 form-group"><button type="submit" ng-click="vm.migrateExistingCafsToZero()" class="btn btn-info">Migrate Existing Cafs To Zero</button></div><!--<div class=" col-sm-3 form-group">--><!--<button type="submit" ng-click="vm.migrateNewCafLogs()" class="btn btn-info ">Migrate \'New\' CAF Logs</button>--><!--</div>--><!--<div class=" col-sm-3 form-group">--><!--<button type="submit" ng-click="vm.migrateDistrictNodalOfficer()" class="btn btn-info ">Migrate District Nodal Officer</button>--><!--</div>--><div class="col-sm-3 form-group"><button type="submit" ng-click="vm.migrateDatesToServiceDetailfromLog()" class="btn btn-info">Migrate Dates from ServiceLog To ServiceDetail</button></div></div><div class="col-md-12"><!--<div class=" col-sm-3 form-group">--><!--<button type="submit" ng-click="vm.projectToExistingCafSearch()" class="btn btn-info ">project ==> existing_caf_search</button>--><!--</div>--><div class="col-sm-3 form-group"><button type="submit" ng-click="vm.migrateServicelogToReappliedservices()" class="btn btn-info">Migrate Servicelog to Reappliedservices</button></div><div class="col-sm-3 form-group"><button type="submit" ng-click="vm.migrateServicelogToReappliedservices()" class="btn btn-info">Migrate cafsForNodalofficer from cassandra to elastic</button></div><div class="col-sm-3 col-md-offset-1 form-group"><button type="submit" ng-click="vm.removeServiceFromDashboardFlag()" class="btn btn-info">Remove Service From Dashboard Flag</button></div></div><div class="row"><div class="col-md-3 form-group"><button type="submit" ng-click="vm.migrate_service_dashboard_april_2018()" class="btn btn-info">Migrate service dashboard 2018</button></div><div class="col-md-3 form-group"><button type="submit" ng-click="vm.migrateProjectServiceDetailToIndex()" class="btn btn-info">Migrate Projectservicedetail index</button></div><div class="col-sm-3 form-group"><button type="submit" ng-click="vm.migrateServicelogToReappliedservices()" class="btn btn-info">Migrate Servicelog to Reappliedservices</button></div></div><div class="row"><div class="col-sm-4 form-group"><button type="submit" ng-click="vm.removeServiceFromDashboardFlag()" class="btn btn-info">Remove Service From Dashboard Flag</button></div><div class="col-sm-5 form-group"><button type="submit" ng-click="vm.setTowerDatesToNull()" class="btn btn-info">Set Tower services cleared rejection dates to null</button></div><div class="col-sm-3 form-group"><button type="submit" ng-click="vm.calculateDraftsHavingServices()" class="btn btn-info">Calculate Draft CAFs having Services</button></div></div><div class="row"><div class="col-sm-3"><button type="submit" ng-click="vm.migrateAssignedRM()" class="btn btn-info">Delete Duplicate Assigned RM</button></div><div class="col-sm-2"><button type="submit" ng-click="vm.deleteMultipleRecordsWithSameProjectid()" class="btn btn-info">Delete RM Multiple Records with Same ProjectId</button></div></div><div class="row"><div class="col-md-3"><button type="submit" ng-click="vm.openTicketSchedular()" class="btn btn-info">Ticket Opening Scheduler</button></div><div class="col-md-3"><button type="submit" ng-click="vm.closeTicketSchedular()" class="btn btn-info">Ticket Closing Scheduler</button></div></div><div class="row"><div class="col-md-3"><button type="submit" ng-click="vm.ccipdata()" class="btn btn-info">DashboardBetweenDates To elastic Scheduler</button></div></div><div class="row"><div class="col-md-3"><button type="submit" ng-click="vm.projectServiceCcipdata()" class="btn btn-info">ProjectServiceDetail To Elastic</button></div></div></div><!--<div>--><!--<div class=" col-sm-3 form-group">--><!--<button type="submit" ng-click="vm.projectToExistingCafSearch()" class="btn btn-info ">project ==> existing_caf_search</button>--><!--</div>--><!--</div>--><br><!-- Modal --><div id="myModal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Please choose</h4></div><div class="modal-body"><select class="form-control" ng-model="vm.data.service_name"><option value="" disabled="disabled">-- Select Service Name--</option><option value="Regularization of existing Tower/Renewal (Above ground)">Regularization of existing Tower/Renewal (Above ground)</option><option value="Communication and Connectivity Permissions/Renewal(Above Ground)">Communication and Connectivity Permissions/Renewal(Above Ground)</option></select><br><select class="form-control" ng-model="vm.data.department_name"><option value="" disabled="disabled">-- Select Department--</option><option ng-repeat="department in vm.departments">{{department.departmentname}}</option></select><br><select class="form-control" ng-model="vm.data.district"><option value="" disabled="disabled">-- Select District--</option><option ng-repeat="district in vm.districts">{{district.districtname}}</option></select><br><select class="form-control" ng-model="vm.data.login"><option value="" disabled="disabled">-- Select Login--</option><option ng-repeat="towerofficer in vm.towerofficerlists">{{towerofficer.towerofficerLogin}}</option></select></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.setDepartmentByChoice()">Done</button></div></div></div></div><!-- Modal 2--><div id="myModal2" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Project ID\'s of Duplicate Data</h4></div><div class="modal-body text-center"><p ng-repeat="duplicateid in vm.duplicateIds">{{duplicateid.grievanceId}},{{duplicateid.grievanceBy}}</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal">Close</button></div></div></div></div><div id="reAssignModal" class="modal fade" role="dialog"><div class="modal-dialog modal-md"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4>Re-Assign Modal</h4></div><div class="modal-body"><label for="assignBy">Assign by:</label><input type="text" class="form-control" id="assignBy" ng-model="vm.assignBy"><br><label for="grievanceid">Grievance id:</label><input type="text" class="form-control" id="grievanceid" ng-model="vm.grievanceid"><br><label for="assignto">Assign to:</label><input type="text" class="form-control" id="assignto" ng-model="vm.assignto"><br><label for="assigndate">Assign date:</label><input type="text" class="form-control" id="assigndate" ng-model="vm.assigndate"></div><div class="modal-footer"><button type="button" class="btn btn-primary" ng-click="vm.reAssignGrievance()">Re-Assign</button></div></div></div><div class="row"><div class="col-sm-2"><button type="submit" ng-click="vm.migrateNewDashboardStats()" class="btn btn-info">Migrate NewDashboardStats</button></div><!--<div class=" col-sm-2">--><!--<button type="submit" ng-click="vm.migrateIntegrationData()" class="btn btn-info ">Migrate Integration Data</button>--><!--</div>--></div></div>');
$templateCache.put('app/migratedata/uhbvnAutoRequired.html','<div class="container"><div class="row"><div class="col-md-10"><div class="row"><div class="col-md-6"><label>Enter Project Id</label></div><div class="col-md-6"><input type="text" ng-model="vm.projectId" class="form-control" id="projectId" placeholder="Code Depoyement removing loop"></div></div><div class="row"><div class="col-md-6"><label>Enter Service Id</label></div><div class="col-md-6"><input type="text" ng-model="vm.serviceId" class="form-control" id="serviceId" placeholder="Enter Service ID"></div></div><br><!--            <div>--><!--                <button type="submit" ng-disabled="\'vm.projectId ==null\' && vm.serviceId == null" ng-click="vm.migrateDataUHBVN(vm.projectId,vm.serviceId)" class="btn btn-info pull-right"--><!--                        has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">Migrate Project Service Detail Data</button>--><!--            </div>--></div></div></div>');
$templateCache.put('app/moveCafLogin/moveCafLogin.html','<div class="container-fluid"><div class="row"><div class="col-md-2"><div id="nav-side-menu" class="myAffix affix-top" data-spy="affix" style="position: -webkit-sticky;position: sticky;top: 0"><div class="brand">Multiple CAFs/Grievance</div><hr><i class="fa fa-bars fa-2x toggle-btn" data-toggle="collapse" data-target="#menu-content"></i><div class="menu-list"><ul id="menu-content" class="menu-content collapse out"><li class="uk-hidden-touch" ng-class="{ active : vm.tabSelected === \'caf\' }" ui-sref="moveCaf({type: \'caf\'})"><a ng-click="vm.collapseNavbar()"><span>Move Caf</span></a></li><li class="uk-hidden-touch" ng-class="{ active : vm.tabSelected === \'grievance\' }" ui-sref="moveCaf({type: \'grievance\'})"><a ng-click="vm.collapseNavbar()"><span>Move Grievance</span></a></li></ul></div></div></div><div class="col-md-10" ng-if="vm.tabSelected === \'caf\'"><div class="col-md-6" ng-if="!vm.showCafpinBlock"><div class="form-group"><label for="user">Find User</label><input type="text" class="form-control" ng-model="vm.userLogin"></div></div><div class="col-md-6" ng-if="!vm.showCafpinBlock"><div class="form-group"><button type="button" class="btn btn-success" style="margin-top: 20px" ng-click="vm.findUser(vm.userLogin)">Find</button></div></div><div class="col-md-6 col-md-offset-2 text-center" ng-if="vm.user.login"><div class="card"><div class="card-body padding_10"><h4>{{vm.user.firstName}} {{vm.user.lastName}}</h4><h4>{{vm.user.email}}</h4><button type="button" ng-if="!vm.showCafpinBlock" class="btn btn-success" ng-click="vm.confirm()">Confirm</button></div></div></div><div class="col-md-6" ng-if="vm.showCafpinBlock"><div class="form-group"><label for="user">Enter Caf Pin (Composite Application Form)</label><input type="text" class="form-control" ng-model="vm.cafPin"></div></div><div class="col-md-6" ng-if="vm.showCafpinBlock"><div class="form-group"><button type="button" class="btn btn-success" style="margin-top: 20px" ng-click="vm.confirmProject()">Move Caf</button></div></div></div><div class="col-md-10" ng-if="vm.tabSelected === \'grievance\'"><div class="col-md-6" ng-if="!vm.showGrievanceBlock"><div class="form-group"><label for="user">Find User</label><input type="text" class="form-control" ng-model="vm.userLogin"></div></div><div class="col-md-6" ng-if="!vm.showGrievanceBlock"><div class="form-group"><button type="button" class="btn btn-success" style="margin-top: 20px" ng-click="vm.findUser(vm.userLogin)">Find</button></div></div><div class="col-md-6 col-md-offset-2 text-center" ng-if="vm.user.login"><div class="card"><div class="card-body padding_10"><h4>{{vm.user.firstName}} {{vm.user.lastName}}</h4><h4>{{vm.user.email}}</h4><button type="button" ng-if="!vm.showGrievanceBlock" class="btn btn-success" ng-click="vm.grievanceConfirm()">Confirm</button></div></div></div><div class="col-md-6" ng-if="vm.showGrievanceBlock"><div class="form-group"><label for="user">Enter Grievance Id</label><input type="text" class="form-control" ng-model="vm.grievanceID"></div></div><div class="col-md-6" ng-if="vm.showGrievanceBlock"><div class="form-group"><button type="button" class="btn btn-success" style="margin-top: 20px" ng-click="vm.confirmGrievance()">Move Grievance</button></div></div></div></div></div><div id="confirmCaf" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><h4 class="modal-title"><b>Kindly review the below details.</b></h4></div><div class="modal-body"><div class="row"><div class="col-md-6"><h4 class="text-center"><b>Old</b></h4><br><h4 class="text-center">{{vm.cafresult.userLogin}}</h4></div><div class="col-md-6"><h4 class="text-center"><b>New</b></h4><br><h4 class="text-center">{{vm.user.login}}</h4></div><div class="col-md-12"><button type="button" ng-click="vm.moveCaf(vm.cafPin)" data-dpmaxz-eid="12" class="btn btn-primary pull-right">Move Caf</button> <button type="button" class="btn btn-default pull-right" data-dismiss="modal">Edit</button></div></div></div></div></div></div><div id="confirmgrievance" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><h4 class="modal-title"><b>Kindly review the below details.</b></h4></div><div class="modal-body"><div class="row"><div class="col-md-6"><h4 class="text-center"><b>Old</b></h4><br><h4 class="text-center">{{vm.grievance.grievanceBy}}</h4></div><div class="col-md-6"><h4 class="text-center"><b>New</b></h4><br><h4 class="text-center">{{vm.user.login}}</h4></div><div class="col-md-12"><button type="button" ng-click="vm.moveGrievance(vm.grievanceID)" data-dpmaxz-eid="12" class="btn btn-primary pull-right">Move Grievance</button> <button type="button" class="btn btn-default pull-right" data-dismiss="modal">Edit</button></div></div></div></div></div></div>');
$templateCache.put('app/msmePolicies/msmePolicies.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_10 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">MSME Policies</h1></div></div></div></section><br><div ng-cloak><div class="container"><div class="row"><!--            <div class="col-md-3" ng-if="vm.isAuthenticated()">--><!--                <form target="my_iframe"--><!--                      action="https://haryanaindustries.gov.in/msme/evincentivescheme/viewappstatus/policy2022"--><!--                      method="POST">--><!--                    <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                    <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--                    <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                    <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--                    <input type="hidden" name="url"--><!--                           value="https://haryanaindustries.gov.in/msme/evincentivescheme/viewappstatus/policy2022">--><!--                    <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="View Application Status">--><!--                </form>--><!--&lt;!&ndash;                <button class="btn btn-success" type="submit" href="#modal-full" uk-toggle>View Application Status</button>&ndash;&gt;--><!--            </div>--><!--            <div class="col-md-3" ng-if="vm.isAuthenticated()">--><!--                <form target="my_iframe"--><!--                      action="https://haryanaindustries.gov.in/msme/evincentivescheme/onholdapplications/policy2022"--><!--                      method="POST">--><!--                    <input type="hidden" name="email" value="{{vm.userdetails.useremail}}">--><!--                    <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}">--><!--                    <input type="hidden" name="name" value="{{vm.userdetails.username}}">--><!--                    <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}">--><!--                    <input type="hidden" name="url"--><!--                           value="https://haryanaindustries.gov.in/msme/evincentivescheme/onholdapplications/policy2022">--><!--                    <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Reply to onhold application">--><!--                </form>--><!--&lt;!&ndash;                <button class="btn btn-success" type="submit" href="#modal-full" uk-toggle>Reply to onhold application</button>&ndash;&gt;--><!--            </div>--><div class="col-md-3 pull-right" ng-if="vm.isAuthenticated()"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/onholdapplications/atamnirbhar" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/onholdapplications/atamnirbhar"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Reply to onhold application"></form></div><div class="col-md-3 pull-right" ng-if="vm.isAuthenticated()"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/newincentivescheme/viewappstatus/atamnirbhar" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/newincentivescheme/viewappstatus/atamnirbhar"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="My Incentive Status"></form></div><br><table class="table table-striped table-hover" ng-switch="vm.isAuthenticated()"><thead><tr class="headerGrid"><th>S.No</th><th>Scheme Name</th><th>Scheme Document (PDF)</th><th>Apply For Scheme</th></tr></thead><tbody><tr><td>1</td><td>Capital Investment Subsidy for Textile Units</td><td><a target="_blank" href="../../content/pdfs/Capital Investment Subsidy for Textile Units.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/textile_schemes/capital_investment_subsidy" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/textile_schemes/capital_investment_subsidy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" type="submit" href="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner" uk-toggle>Apply Now</button>--><!--                        <div class="col-md-6">--><!--                            <form--><!--                                  action="https://haryanaindustries.gov.in/msme/textile_schemes/capital_investment_subsidy">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now">--><!--                            </form>--><!--                        </div>--></td></tr><tr><td>2</td><td>Interest Subsidy Scheme</td><td><a target="_blank" href="../../content/pdfs/Interest Subsidy Scheme.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/textile_schemes/interest_subsidy" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/textile_schemes/interest_subsidy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" type="submit" href="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner" uk-toggle>Apply Now</button>--><!--                        <div class="col-md-6">--><!--                            <form target="_blank"--><!--                                  action="https://haryanaindustries.gov.in/msme/textile_schemes/interest_subsidy">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now">--><!--                            </form>--><!--                        </div>--></td></tr><tr><td>3</td><td>Investment Subsidy in Lieu of Net SGST</td><td><a target="_blank" href="../../content/pdfs/Investment Subsidy in Lieu of Net SGST.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/textile_schemes/investment_subsidy" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/textile_schemes/investment_subsidy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" type="submit" href="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner" uk-toggle>Apply Now</button>--><!--                        <div class="col-md-6">--><!--                            <form target="_blank"--><!--                                  action="https://haryanaindustries.gov.in/msme/textile_schemes/investment_subsidy">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now">--><!--                            </form>--><!--                        </div>--></td></tr><tr><td>4</td><td>Support for Obtaining Fire Insurance Policy</td><td><a target="_blank" href="../../content/pdfs/Support for Obtaining Fire Insurance Policy.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/textile_schemes/fire_inc_policy" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/textile_schemes/fire_inc_policy"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" type="submit" href="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner" uk-toggle>Apply Now</button>--><!--                        <div class="col-md-6">--><!--                            <form target="_blank"--><!--                                  action="https://haryanaindustries.gov.in/msme/textile_schemes/fire_inc_policy">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now">--><!--                            </form>--><!--                        </div>--></td></tr><tr><td>5</td><td>Promoting Green & Sustainable Production Scheme</td><td><a target="_blank" href="../../content/pdfs/Promoting Green & Sustainable Production Scheme.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/textile_schemes/green_sustainable_prod" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/textile_schemes/green_sustainable_prod"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" type="submit" href="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner" uk-toggle>Apply Now</button>--><!--                        <div class="col-md-6">--><!--                            <form target="_blank"--><!--                                  action="https://haryanaindustries.gov.in/msme/textile_schemes/green_sustainable_prod">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now">--><!--                            </form>--><!--                        </div>--></td></tr><tr><td>6</td><td>Textile Park Scheme</td><td><a target="_blank" href="../../content/pdfs/Textile Park Scheme.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/textile_schemes/park_scheme" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/textile_schemes/park_scheme"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" type="submit" href="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner" uk-toggle>Apply Now</button>--><!--                        <div class="col-md-6">--><!--                            <form target="_blank"--><!--                                  action="https://haryanaindustries.gov.in/msme/textile_schemes/park_scheme">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now">--><!--                            </form>--><!--                        </div>--></td></tr><tr><td>7</td><td>Textile Cluster Development Scheme</td><td><a target="_blank" href="../../content/pdfs/Textile Cluster Development Scheme.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/textile_schemes/cluster_development" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/textile_schemes/cluster_development"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" type="submit" href="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner" uk-toggle>Apply Now</button>--><!--                        <div class="col-md-6">--><!--                            <form target="_blank"--><!--                                  action="https://haryanaindustries.gov.in/msme/textile_schemes/cluster_development">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now">--><!--                            </form>--><!--                        </div>--></td></tr><tr><td>8</td><td>Skill Training Scheme</td><td><a target="_blank" href="../../content/pdfs/Skill Training Scheme.pdf">View PDF</a></td><td><div class="col-md-6"><form target="my_iframe" action="https://haryanaindustries.gov.in/msme/textile_schemes/skill_training" method="POST"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="address" value="{{vm.userdetails.useraddress}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="hidden" name="mobile" value="{{vm.userdetails.usermobile}}"> <input type="hidden" name="url" value="https://haryanaindustries.gov.in/msme/textile_schemes/skill_training"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now" ng-switch-when="true"> <input type="submit" class="btn btn-link" value="Apply Now" ng-switch-when="false" ng-click="vm.login()"></form></div><!--                        <button class="btn btn-success" type="submit" href="https://haryanaindustries.gov.in/msme/textile_schemes/fuel_cleaner" uk-toggle>Apply Now</button>--><!--                        <div class="col-md-6">--><!--                            <form target="_blank"--><!--                                  action="https://haryanaindustries.gov.in/msme/textile_schemes/skill_training">--><!--                                <input type="submit" class="btn btn-link" value="Apply Now">--><!--                            </form>--><!--                        </div>--></td></tr></tbody></table></div></div></div><div id="modal-full" class="uk-modal-full" uk-modal esc-close="false" bg-close="false"><div class="uk-modal-dialog"><button class="uk-modal-close-full uk-close-large" type="button" uk-close></button><div class="uk-grid-collapse uk-flex-middle" uk-grid><section><iframe name="my_iframe" style="width: 500vw; height: 100vh" frameborder="0" marginheight="0" marginwidth="0"></iframe></section></div></div></div><br><br>');
$templateCache.put('app/newDashboard/mainView.html','<div class="container"><h4 class="text-danger">* All stats last updated on yesterday.</h4><h3><u>All CAFs</u></h3><br><table class="table-new"><thead class="thead-dark"><tr><th scope="col">CAF Type</th><th scope="col">Project Level</th><th scope="col">Total Count</th><th scope="col">Total Employment</th><th scope="col">Total Investment (in Cr)</th></tr></thead><tbody><tr ng-repeat="t in vm.newDashboardStats | orderBy : [\'projectType\',\'-projectLevel\']"><td><b>{{ t.projectType}}</b></td><td>{{ t.projectLevel == \'e\' ? \'EEC\' : \'DLCC\'}}</td><td>{{ t.total }}</td><td>{{ t.totalEmployment == 0 ? \'NA\' : (t.totalEmployment | number: 0) }}</td><td>{{ t.totalInvestment == 0 ? \'NA\' : (t.totalInvestment | number: 2) }}</td></tr></tbody></table><br><!--<h3><u>Completely resolved CAFs</u></h3>--><!--<h5 class="text-danger"> * CAFs having no services pending are considered as completely resolved.</h5>--><!--<br>--><!--<table class="table-new">--><!--<thead class="thead-dark">--><!--<tr>--><!--<th scope="col">CAF Type</th>--><!--<th scope="col">Project Level</th>--><!--<th scope="col">Total Count</th>--><!--<th scope="col">Total Employment</th>--><!--<th scope="col">Total Investment (in Cr)</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat="t in vm.newDashboardAllCompleteStats | orderBy : \'caftype\'">--><!--<td><b>{{ t.caftype}}</b></td>--><!--<td>{{ t.projectLevel == \'e\' ? \'EEC\' : \'DLCC\'}}</td>--><!--<td>{{ t.total }}</td>--><!--<td>{{ t.totalEmployment == 0 ? \'NA\' : (t.totalEmployment | number: 0) }}</td>--><!--<td>{{ t.totalInvestment == 0 ? \'NA\' : (t.totalInvestment | number: 2) }}</td>--><!--</tr>--><!--</tbody>--><!--</table>--></div><style>@charset "UTF-8";\n@import url(https://fonts.googleapis.com/css?family=Open+Sans:300,400,700);\n\n.blue { color: #f80a0a; }\n.yellow { color: #a00; }\n\n th{\n\t  font-weight: bold;\n\t  font-size: 1em;\n  text-align: left;\n  color: #a00;\n  background-color:#a00;\n}\n\n.table-new td {\n\t  font-weight: normal;\n\t  font-size: 1em;\n  -webkit-box-shadow: 0 2px 2px -2px #0E1119;\n\t   -moz-box-shadow: 0 2px 2px -2px #0E1119;\n\t        box-shadow: 0 2px 2px -2px #0E1119;\n}\n\n.table-new {\n\t  text-align: left;\n\t  overflow: hidden;\n\t  width: 80%;\n\t  margin: 0 auto;\n  display: table;\n  padding: 0 0 8em 0;\n}\n\n.table-new td, .table-new th {\n\t  padding-bottom: 2%;\n\t  padding-top: 2%;\n  padding-left:2%;\n}\n\n/* Background-color of the odd rows */\n.table-new tr:nth-child(odd) {\n\t  background-color: rgb(215, 217, 219);\n}\n\n/* Background-color of the even rows */\n.table-new tr:nth-child(even) {\n\t  background-color: rgb(215, 217, 219);\n}\n\n.table-new th {\n\t  background-color: rgb(215, 217, 219);\n}\n\n.table-new td:first-child { color: rgb(14, 8, 9); }\n\n.table-new tr:hover {\n   background-color: rgb(194, 198, 207);\n-webkit-box-shadow: 0 6px 6px -6px #0E1119;\n\t   -moz-box-shadow: 0 6px 6px -6px #0E1119;\n\t        box-shadow: 0 6px 6px -6px #0E1119;\n}\n\n.table-new td:hover {\n  background-color: #FFF842;\n  color: #403E10;\n  font-weight: bold;\n\n  box-shadow: #7F7C21 -1px 1px, #7F7C21 -2px 2px, #7F7C21 -3px 3px, #7F7C21 -4px 4px, #7F7C21 -5px 5px, #7F7C21 -6px 6px;\n  transform: translate3d(6px, -6px, 0);\n\n  transition-delay: 0s;\n\t  transition-duration: 0.4s;\n\t  transition-property: all;\n  transition-timing-function: line;\n}\n\n@media (max-width: 800px) {\n.table-new td:nth-child(4),\n.table-new th:nth-child(4) { display: none; }\n}</style>');
$templateCache.put('app/newdeptservicedashboard/newdeptservicedashboard.html','<div class="container"><div class="row"><div class="col-md-2"><ul class="nav nav-pills nav-stacked"><li ng-click="vm.loadAll(\'HSPCB\')"><a href="">HSPCB</a></li><li ng-click="vm.loadAll(\'LABOUR\')"><a href="">Labour Department</a></li><li ng-click="vm.loadAll(\'REVENUE\')"><a href="">Revenue Department</a></li><li ng-click="vm.loadAll(\'ULB\')"><a href="">Urban Local Bodies</a></li><li ng-click="vm.loadAll(\'UHBVN\')"><a href="">UHBVN</a></li><li ng-click="vm.loadAll(\'DHBVN\')"><a href="">DHBVN</a></li><li ng-click="vm.loadAll(\'HUDA\')"><a href="">HUDA</a></li><li ng-click="vm.loadAll(\'Food&Supplies\')"><a href="">Food & Supplies</a></li></ul></div><div class="col-md-10"><h3>{{vm.Department}}</h3><table class="table table-hover table-responsive"><thead><tr class="headerGrid row"><th class="col-md-2"><ul class="nav nav-tabs nav-stacked text-center"><li><a href="" style="color: #fff;background-color: #006fb5">Service Name</a></li></ul></th><th class="col-md-1"><ul class="nav nav-tabs nav-stacked text-center"><li><a href="" style="color: #fff;background-color: #006fb5">Recieved</a></li></ul></th><th class="col-md-3"><ul class="nav nav-tabs nav-stacked text-center"><li><a href="" style="color: #fff;background-color: #006fb5">Approved</a></li></ul></th><th class="col-md-4"><ul class="nav nav-tabs nav-stacked text-center"><li><a href="" style="color: #fff;background-color: #006fb5">Pending</a></li></ul></th></tr></thead><tbody><tr class="row" ng-repeat="field in vm.newdeptservicedashboard"><td class="col-md-4"><ul class="pager"><li><a href="" style="color: #fff;background-color: #1A5276">{{field.servicename}}</a></li></ul></td><td class="col-md-1"><ul class="pager"><li><a href="" style="color: #fff;background-color: #00bcd4">{{field.total_recieved}}</a></li></ul></td><td class="col-md-3 text-center"><ul class="pager"><div class="col-md-4"><li><a href="" style="color: #fff;background-color: #00bcd4">{{field.total_approved}}</a></li></div><div class="col-md-4"><li><a href="" style="color: #fff; background-color:#27ae60">{{field.approved_within_time}}</a></li></div><div class="col-md-4"><li><a href="" style="color: #fff; background-color: #b34d4b">{{field.approved_beyond_time}}</a></li></div></ul></td><td class="col-md-3 text-center"><ul class="pager"><div class="col-md-3"><li><a href="" style="color: #fff;background-color: #00bcd4">{{field.total_pending}}</a></li></div><div class="col-md-3"><li><a href="" style="color: #fff; background-color:#27ae60">{{field.pending_within_time}}</a></li></div><div class="col-md-3"><li><a href="" style="color: #fff; background-color: #e67e22">{{field.pending_with_applicant}}</a></li></div><div class="col-md-3"><li><a href="" style="color: #fff; background-color: #b34d4b">{{field.pending_beyond_time}}</a></li></div></ul></td></tr></tbody></table></div></div></div><div class="col-md-12"><div class="col-md-3"></div><ul class="nav nav-pills"><li><a href="" style="color: #fff;background-color: #00bcd4">Total</a></li><li><a href="" style="color: #fff; background-color:#27ae60">Within Time</a></li><li><a href="" style="color: #fff; background-color:#e67e22">Pending With Applicant</a></li><li><a href="" style="color: #fff; background-color:#b34d4b">Beyond Time</a></li></ul></div>');
$templateCache.put('app/newservicedashboard/clearancecharts.html','<div class="modal-header" ng-show="vm.isService"><h4 class="modal-title">{{vm.departmentname}}</h4></div><div class="modal-header" ng-show="vm.isTotal"><h4 class="modal-title">Average Service Clearance</h4></div><div class="modal-body"><canvas id="pie" class="chart chart-doughnut" chart-data="vm.averageTime" chart-labels="vm.services" chart-options="vm.options"></canvas></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div>');
$templateCache.put('app/newservicedashboard/newservicedashboard.html','<div class="container"><div class="row"><div class="pull-right" style="color: red"><b>*</b> Enter a period of 31 days</div></div><br><div class="row"><div class="col-md-1"><strong class="pull-right" style="padding-right:10px"><i>From</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_fromdate" type="text" class="form-control" name="fromdate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-change="vm.selectedDate(vm.fromdate)" ng-model="vm.fromdate" is-open="vm.datePickerOpenStatus.fromdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><strong class="pull-right" style="padding-right:10px"><i>To</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_todate" type="text" class="form-control" name="todate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions1" ng-model="vm.todate" is-open="vm.datePickerOpenStatus.todate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><button class="btn btn-primary col-md-2" ng-disabled="vm.fromdate==null || vm.todate==null" style="margin-right: 5px" ng-click="vm.getServicesBetweenDates()">Get Services</button> <button class="btn btn-danger col-md-3" ng-disabled="vm.fromdate==null || vm.todate==null|| vm.newdashboards===undefined" ng-click="vm.getAverageClearance(vm.newdashboards,\'TOTAL\')" ui-sref="clearancecharts({departmentid:\'1\'})">View Average Clearance</button></div></div><div class="container"><div ng-repeat="dashboard in vm.newdashboards | orderBy:\'deptorder\'" ng-hide="dashboard.deptname == null || dashboard.deptname == \'\'"><div class="row"><div class="col-md-11"><h4 class="pull-left">{{dashboard.deptname}}</h4></div><div class="col-md-1"><button class="btn btn-primary" ng-click="vm.viewcharts(dashboard.deptname,dashboard.newServiceStats,\'SERVICE\')" ui-sref="clearancecharts({departmentid:dashboard.deptid})">View Chart</button></div></div><table class="table table-striped table-hover table-responsive"><thead class="gradient_bg_color2"><th class="headerGrid row col-md-2 text-center">Service Name</th><th class="headerGrid row col-md-2 text-center">Total Cleared</th><th class="headerGrid row col-md-2 text-center">Average Clearance Time(in days)</th><th class="headerGrid row col-md-2 text-center">Average Clearance Percentage(%)</th></thead><tbody><tr ng-repeat="service in dashboard.newServiceStats"><td class="col-md-2 bg-success">{{service.servicename}}</td><td class="col-md-2 bg-success text-center">{{(service.totalCleared==0?\'NA\':service.totalCleared)}}</td><td class="col-md-2 bg-success text-center">{{service.averageClearanceTime}}</td><td class="col-md-2 bg-success text-center">{{service.averageClearancePercentage}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/nmaserviceform/nmaserviceform.html','<form name="myForm" role="form" ng-submit="vm.saveFormFieldData()"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">{{vm.departmentservice.departmentname}} : {{vm.departmentservice.serviceName}}</h4></div><div class="modal-body"><div ng-repeat="field in vm.serviceFormFieldData | orderBy : \'formfieldOrder\'" class="form-horizontal"><ng-form name="form"><!-- TEXT FIELDS --><div ng-if="field.formfieldtype==\'text\'" class="form-group"><label class="col-sm-4 control-label">{{field.formfieldName}}<span style="color: red">*</span></label><div class="col-sm-6"><input type="{{ field.fieldType }}" id="{{field.id}}" ng-model="field.formfieldvalue" class="form-control" required></div></div><!-- SELECT FIELDS --><div ng-if="field.formfieldtype==\'select\'" class="form-group"><label class="col-sm-4 control-label">{{field.formfieldName}}<span ng-show="field.formfieldName===\'Department\' " style="color: red">*</span></label><div class="col-sm-6"><select ng-model="field.formfieldvalue" ng-required="field.formfieldName===\'Department\'" dynamic-name="field.id" ng-options="x for x in field.formtypeOption.split(\',\')" class="form-control" required><option value="">-- Select --</option></select></div></div><!-- LAVEL FIELDS --><div ng-if="field.formfieldtype==\'label\'" class="form-group alert alert-dismissible alert-danger"><div class="col-sm-11">{{field.formfieldName}}</div><div class="col-sm-1"><label class="col-sm-12 control-label" ng-model="field.formfieldvalue"></label></div></div><div ng-if="field.formfieldtype==\'file\'" class="form-group alert alert-dismissible alert-danger"><div class="col-sm-11">{{field.formfieldName}}</div><div class="col-sm-1"><label class="col-sm-12 control-label" ng-model="field.formfieldvalue"></label></div></div></ng-form></div></div><div class="panel panel-primary" ng-show="(vm.serviceformdocs.length>0)"><div class="panel-body"><div class="col-md-2" ng-repeat="serviceformdoc in vm.serviceformdocs"><a ng-click="vm.downloadFile(serviceformdoc.downloadfilename,serviceformdoc.docname)">{{serviceformdoc.docname}}</a></div></div></div><!--Static Portion For NMA--><div class="modal-body"><div class="col-md-12"><label class="control-label">Property Document (1)</label></div><div class="col-md-7"><input type="file" id="propertydocs" class="form-control" file-model="vm.propertydocument"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.propertydocument.maxSizeError}}</div><button type="button" class="btn btn-success" ng-disabled="vm.propertydocument==undefined || vm.propertydocument==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadNMAFiles(\'Property\')"><span class="glyphicon glyphicon-open"></span> &nbsp; Upload</button><div class="col-lg-12" ng-show="(vm.propertyDocument.length>0)"><table class="table table-striped table-hover"><thead><tr><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.propertyDocument"><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(propertyDocument,vm.propertyDocument,fileattach.id,$index)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp; Delete</button></td></tr></tbody></table></div></div><div class="modal-body"><div class="col-md-12"><label class="control-label">Elevation Document (4)</label></div><div class="row"><div class="col-md-7"><input type="file" id="elevationdocs" class="form-control" file-model="vm.elevationdocument"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.elevationdocument.maxSizeError}}</div><button type="button" class="btn btn-success" ng-disabled="vm.elevationdocument==undefined || vm.elevationdocument==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadNMAFiles(\'Elevation\')"><span class="glyphicon glyphicon-open"></span> &nbsp; Upload</button></div><div class="col-lg-12" ng-show="(vm.elevationDocuments.length>0)"><table class="table table-striped table-hover"><thead><tr><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.elevationDocuments"><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(elevationDocuments,vm.elevationDocuments,fileattach.id,$index)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp; Delete</button></td></tr></tbody></table></div></div><div class="modal-body"><div class="col-md-12"><label class="control-label">Section Document (2)</label></div><div class="col-md-7"><input type="file" id="sectiondocs" class="form-control" file-model="vm.sectiondocument"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.sectiondocument.maxSizeError}}</div><button type="button" class="btn btn-success" ng-disabled="vm.sectiondocument==undefined || vm.sectiondocument==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadNMAFiles(\'Section\')"><span class="glyphicon glyphicon-open"></span> &nbsp; Upload</button><div class="col-lg-12" ng-show="(vm.sectionDocuments.length>0)"><table class="table table-striped table-hover"><thead><tr><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.sectionDocuments"><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(sectionDocuments,vm.sectionDocuments,fileattach.id,$index)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp; Delete</button></td></tr></tbody></table></div></div><div class="modal-body"><div class="col-md-12"><label class="control-label">Typical Floor Plan (7)</label></div><div class="col-md-7"><input type="file" id="floorplan" class="form-control" file-model="vm.typicalfloorplan"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" class="btn btn-success" ng-disabled="vm.typicalfloorplan==undefined || vm.typicalfloorplan==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadNMAFiles(\'FloorPlan\')"><span class="glyphicon glyphicon-open"></span> &nbsp; Upload</button><div class="col-lg-12" ng-show="(vm.typicalfloorplans.length>0)"><table class="table table-striped table-hover"><thead><tr><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.typicalfloorplans"><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(typicalfloorplans,vm.typicalfloorplans,fileattach.id,$index)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp; Delete</button></td></tr></tbody></table></div></div><div class="modal-body"><div class="col-md-12"><label class="control-label">Repairs Or Renovation Report From Duly Authorised Or Licenced Architect (1)</label></div><div class="col-md-7"><input type="file" id="repairdocs" class="form-control" file-model="vm.repairsdocument"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max<button type="button" ng-click="vm.createNMAObject()" class="btn btn-primary" ng-disabled="vm.isSaving"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Create</span></button> file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" class="btn btn-success" ng-disabled="vm.repairsdocument==undefined || vm.repairsdocument==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadNMAFiles(\'Repairs\')"><span class="glyphicon glyphicon-open"></span> &nbsp; Upload</button><div class="col-lg-12" ng-show="(vm.repairsDocuments.length>0)"><table class="table table-striped table-hover"><thead><tr><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.repairsDocuments"><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(repairDocuments,vm.repairDocuments,fileattach.id,$index)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp; Delete</button></td></tr></tbody></table></div></div><div class="modal-body"><div class="col-md-12"><label class="control-label">Signature (1)</label></div><div class="col-md-7"><input type="file" id="signature" class="form-control" file-model="vm.signature"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" class="btn btn-success" ng-disabled="vm.signature==undefined || vm.signature==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadNMAFiles(\'Signature\')"><span class="glyphicon glyphicon-open"></span> &nbsp; Upload</button><div class="col-lg-12" ng-show="(vm.sign.length>0)"><table class="table table-striped table-hover"><thead><tr><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.sign"><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(signature,vm.sign,fileattach.id,$index)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp; Delete</button></td></tr></tbody></table></div></div><div class="modal-body"><div class="col-md-12"><label class="control-label">Other Documents</label></div><div class="col-md-7"><input type="file" id="others" class="form-control" file-model="vm.otherdocument"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" class="btn btn-success" ng-disabled="vm.otherdocument==undefined || vm.otherdocument==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadNMAFiles(\'Other\')"><span class="glyphicon glyphicon-open"></span> &nbsp; Upload</button><div class="col-lg-12" ng-show="(vm.otherDocuments.length>0)"><table class="table table-striped table-hover"><thead><tr><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.otherDocuments"><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(otherDocuments,vm.otherDocuments,fileattach.id,$index)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp; Delete</button></td></tr></tbody></table></div></div><div class="modal-body"><div class="col-md-12"><label class="control-label">Firm Files</label></div><div class="col-md-7"><input type="file" id="firmfiles" class="form-control" file-model="vm.firmfile"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" class="btn btn-success" ng-disabled="vm.firmfile==undefined || vm.firmfile==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadNMAFiles(\'Firm\')"><span class="glyphicon glyphicon-open"></span> &nbsp; Upload</button><div class="col-lg-12" ng-show="(vm.firmFiles.length>0)"><table class="table table-striped table-hover"><thead><tr><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.firmFiles"><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(firmFiles,vm.firmFiles,fileattach.id,$index)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp; Delete</button></td></tr></tbody></table></div></div><div class="modal-body"><div class="col-md-12"><label class="control-label">Modern Constructions Image</label></div><div class="col-md-7"><input type="file" id="constructiondocs" class="form-control" file-model="vm.constructionimg"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" class="btn btn-success" ng-disabled="vm.constructionimg==undefined || vm.constructionimg==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadNMAFiles(\'ModernConstructionsImage\')"><span class="glyphicon glyphicon-open"></span> &nbsp; Upload</button><div class="col-lg-12" ng-show="(vm.modernconstructionImage.length>0)"><table class="table table-striped table-hover"><thead><tr><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.modernconstructionImage"><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(modernconstructionImage,vm.modernconstructionImage,fileattach.id,$index)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp; Delete</button></td></tr></tbody></table></div></div><div class="modal-body"><div class="col-md-12"><label class="control-label">Google Earth Image</label></div><div class="col-md-7"><input type="file" id="earthimage" class="form-control" file-model="vm.googlearth"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" class="btn btn-success" ng-disabled="vm.googlearth==undefined || vm.googlearth==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadNMAFiles(\'GoogleEarthImage\')"><span class="glyphicon glyphicon-open"></span> &nbsp; Upload</button><div class="col-lg-12" ng-show="(vm.googleEarthImage.length>0)"><table class="table table-striped table-hover"><thead><tr><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.googleEarthImage"><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(googleEarthImage,f,vm.googleEarthImage,fileattach.id,$index)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp; Delete</button></td></tr></tbody></table></div></div><div class="modal-body"><div class="col-md-12"><label class="control-label">Ownership Documents</label></div><div class="col-md-7"><input type="file" class="form-control" file-model="vm.ownership"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" id="ownership" class="btn btn-success" ng-disabled="vm.ownership==undefined || vm.ownership==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.uploadNMAFiles(\'Ownership\')"><span class="glyphicon glyphicon-open"></span> &nbsp; Upload</button><div class="col-lg-12" ng-show="(vm.ownershipdocuments.length>0)"><table class="table table-striped table-hover"><thead><tr><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.ownershipdocuments"><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRow(ownershipdocuments,vm.ownershipdocuments,fileattach.id,$index)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp; Delete</button></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Clear</button> <button type="submit" ng-disabled="myForm.$invalid || vm.propertyDocument.length<1 || vm.elevationDocuments.length<4 || vm.sectionDocuments.length<2 || vm.repairsDocuments.length<1 ||vm.typicalfloorplans.length<7 || vm.sign.length<1 || vm.repairsDocuments.length<1 || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button> <button type="button" ng-click="vm.finalsubmitted()" ng-disabled="myForm.$invalid || vm.propertyDocument.length<1 || vm.elevationDocuments.length<4 || vm.sectionDocuments.length<2 || vm.repairsDocuments.length<1 ||vm.typicalfloorplans.length<7 || vm.sign.length<1 || vm.repairsDocuments.length<1 || vm.isSaving" ng-show="vm.isDraftSaved" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Final Submit</span></button></div></form>');
$templateCache.put('app/nswsRedirectPage/searchCAF.html','<!--<div ng-cloak>--><!--    <div class="container">--><!--        <div class="row">--><!--            <div class="col-sm-4">--><!--                <input type="text"  ng-model="vm.CAFPIN" class="form-control" ng-model="searchText" id="searchQuery"--><!--                       placeholder="Enter CAF PIN or Project ID" >--><!--            </div>--><!--            <div class="btn-group col-sm-4">--><!--                <button type="submit" ng-click="vm.getProject()" class="btn btn-info " has-any-authority="ROLE_USER, ROLE_ADMIN, ROLE_MONITORING_OFFICER,ROLE_DESK_OFFICER,ROLE_DEPT_CHANGE,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD, ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_NODAL_OFFICER,ROLE_TICKET_ADMIN">Search</button>--><!--            </div>--><!--        </div>--><!--        <div class="row" ng-show="vm.showtable">--><!--            <table class="table table-striped table-hover ">--><!--                <thead>--><!--                <tr class="headerGrid">--><!--                    <th>CAF Pin</th>--><!--                    &lt;!&ndash;<th>Investor Name</th>&ndash;&gt;--><!--                    <th>RM Info</th>--><!--                    <th>Total Project Cost</th>--><!--                    <th>Proposed Employment</th>--><!--                    <th>Business Entity</th>--><!--                    <th>District</th>--><!--                    <th>Project Level</th>--><!--                    <th>Project ID</th>--><!--                    <th>Caf Type</th>--><!--                    <th></th>--><!--                </tr>--><!--                </thead>--><!--                <tbody>--><!--                <tr>--><!--                    <td >{{vm.project.cafpin}}</td>--><!--                    &lt;!&ndash;<td >{{prdtl.investorName}}</td>&ndash;&gt;--><!--                    <td >{{vm.project.rm==\'\' ? "Not Assigned" : vm.project.rm}}</td>--><!--                    <td >{{vm.project.projectTotalCost}}</td>--><!--                    <td >{{vm.project.totalEmployement}}</td>--><!--                    <td >{{vm.project.buisnessEntity}}</td>--><!--                    <td >{{vm.project.district}}</td>--><!--                    <td >{{vm.project.projectlevel==\'e\' ? "EEC" : "DLCC"}}</td>--><!--                    <td>{{vm.project.projectid}}</td>--><!--                    <td>{{vm.project.caftype}}</td>--><!--                    <td class="action verticalalign">--><!--                        <a ui-sref="projectdetailjist({projectid:vm.project.projectid})" class="btn btn-primary">Details</a>--><!--                        &lt;!&ndash;<button type="submit" ui-sref="projectdetailjist({projectid:vm.project.projectid})"&ndash;&gt;--><!--                                &lt;!&ndash;class="btn btn-info ">Details</button>&ndash;&gt;--><!--                    </td>--><!--                </tr>--><!--                </tbody>--><!--            </table>--><!--        </div>--><!--        &lt;!&ndash;<div ng-show="!vm.showtable">&ndash;&gt;--><!--            &lt;!&ndash;No Projects Right Now.&ndash;&gt;--><!--        &lt;!&ndash;</div>&ndash;&gt;--><!--    </div>--><!--</div>--><!--<br/>--><!--<br/>--><!--<br/>-->');
$templateCache.put('app/payments/disbursePayment.html','<form name="deleteForm" ng-submit="vm.disbursePayment(vm.block.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirm Disbursement</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Are you sure you want to Disburse this Payment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span>Disburse</span></button></div></form>');
$templateCache.put('app/payments/viewpayments.html','<div ng-cloak><div class="container"><div class="row"><div class="col-lg-5"><button type="submit" ui-sref="viewpayments({disbursed:false})" class="btn btn-info">View Pending Payments</button> <button type="submit" ui-sref="viewpayments({disbursed:true})" class="btn btn-primary">View Disbursed Payments</button></div><div class="col-lg-5 input-group"><input type="text" class="form-control" ng-model="vm.transId" id="searchQuery" placeholder="Search by transaction id or cafpin"> <span class="input-group-addon" ng-click="vm.getPaymentByTransactionId(vm.viewstatus,vm.transId)"><i class="fa fa-search"></i></span></div></div><div class="row"><div class="col-md-1"><strong class="pull-right" style="padding-right:10px"><i>From</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_fromdate" type="text" class="form-control" name="fromdate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-model="vm.fromdate" is-open="vm.datePickerOpenStatus.fromdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><strong class="pull-right" style="padding-right:10px"><i>To</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_todate" type="text" class="form-control" name="todate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions1" ng-model="vm.todate" is-open="vm.datePickerOpenStatus.todate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><button class="btn btn-primary col-md-2" ng-disabled="vm.todate==null" style="margin-right: 5px" ng-click="vm.getPaymentBetweenDates(vm.viewstatus)">Get Record</button> <button class="btn btn-primary col-md-2" ng-if="vm.clearFilterButton" style="margin-right: 5px" ng-click="vm.clearFilter()">Clear Filter</button></div><div class="row"><div class="col-lg-7 input-group"><h4 ng-show="vm.viewstatus==\'Pending\'">Pending Payments</h4><h4 ng-show="vm.viewstatus==\'Disbursed\'">Disbursed Payments</h4></div><button ng-if="vm.projectservicepayments.length > 0" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button><table id="result_table" class="table table-striped table-hover"><thead><tr class="headerGrid"><th>S.No.</th><th>CAF Pin (Composite Application Form)</th><th>Investor Name</th><th>Business Entity</th><th>Department</th><th>District</th><th>More Info</th><th>Service</th><th>Transaction Id</th><th>Fee Description</th><th>Amount</th><th>Date of Transaction</th><th></th></tr></thead><tbody><tr ng-repeat="payment in vm.projectservicepayments | filter:searchText | orderBy:\'-paymentdate\'"><td>{{$index+1}}</td><td>{{payment.cafpin}}</td><td>{{payment.investorname}}</td><td>{{payment.businessentity}}</td><td>{{payment.departmentname}}</td><td>{{payment.district}}</td><td>{{payment.subDepartment}}</td><td>{{payment.servicename}}</td><td>{{payment.transactionid}}</td><td>{{payment.feedescription==null?"Service Fee":payment.feedescription}}</td><td>{{payment.amount}}</td><td>{{payment.paymentdate | date:\'dd-MM-yyyy\'}}</td><td class="action verticalalign" has-any-authority="ROLE_ACCOUNT_OFFICER,ROLE_ADMIN,ROLE_SUB_ADMIN"><button type="submit" ui-sref="disbursePayment({id:payment.id})" class="btn btn-info" ng-show="payment.paymentdisbursed==false">Disrburse Payment</button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/policyDashboard/policydashboard.html','<style>body {\n            background-color: #f8f9fa;\n        }\n        .table thead {\n            background-color: #0d6efd;\n            color: white;\n        }\n        .table td, .table th {\n            vertical-align: top;\n        }\n        .page-title {\n            color: #0d6efd;\n            margin-top: 30px;\n            font-weight: 600;\n            text-align: center;\n        }\n        .note {\n            font-style: italic;\n            color: #6c757d;\n        }</style><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Policy Dashboard</h1><!--                    <p><span class="text-danger">*</span> Data of services applied after 01-April-2018</p>--></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Dashboards</span></li><li class="active"><span>Policy Dashboard</span></li></ol></div></section><br><div class="container mt-5 mb-5"><div class="card shadow-sm"><div class="card-body"><div class="table-responsive"><table class="table table-bordered align-middle"><thead class="text-center"><tr><th>S. No</th><th>Policy Name</th><th>Description</th><th>List of Schemes/Incentives</th><th>Policy Expiry Date</th><th>Download (PDF)</th></tr></thead><tbody><tr><td>1</td><td><strong>Haryana Enterprise & Employment Policy 2020</strong></td><td>The vision of the policy is to establish Haryana as a competitive and favoured investment destination, achieve regional development, export diversification and augment livelihood opportunities for its people through resilient economic development. The policy objective is to attract investments of INR 1 lakh crore and generate 5 lakh jobs in the State.</td><td><ol class="mb-0"><li>Investment Subsidy in lieu of Net SGST</li><li>Employment Generation Subsidy</li><li>Electricity Duty Exemption</li><li>Stamp Duty Refund</li><li>External Development Charges Exemption</li></ol><p class="note mt-2">Note: The incentives mentioned above are for Ultra Mega Projects, Mega Projects, and Large Enterprises; the quantum of incentives differs for each. Higher quantum of incentives is provisioned for identified Thrust Sectors of the State.</p></td><td class="text-center">31.12.2025</td><td class="text-center"><a href="../../content/pdfs/HEEP policy with corrigendum.pdf" target="_blank" class="btn btn-sm btn-primary">Download</a></td></tr><tr><td>2</td><td><strong>Haryana Logistics Warehousing & Retail Policy 2019</strong></td><td>This policy targets to transform Haryana into a global Logistics, Warehousing and Retail hub, which is well equipped with state-of-the-art Logistics & Warehousing infrastructure, a conducive regulatory environment and a mechanism for maximizing returns for retailers and providing best buying experience to the end consumer.</td><td><ol class="mb-0"><li>Capital Subsidy*</li><li>Interest Subsidy*</li><li>Stamp Duty</li><li>Electricity Duty</li><li>External Development Charges (EDC)</li><li>EDC and Commercial License fee (for Warehousing cum Retail category)</li><li>Capacity Building Incentives</li></ol><p class="note mt-2">*Applicable for warehouses, Logistics Parks, and Integrated/Multi-Modal Logistics Parks.<br>*(Applicable for units setting up in C & D category blocks)</p></td><td class="text-center">Valid till new Haryana Logistics, Warehousing & Retail Policy is notified</td><td class="text-center"><a href="../../content/pdfs/Logistic Policy 2019 new.pdf" target="_blank" class="btn btn-sm btn-primary">Download</a></td></tr><tr><td>3</td><td><strong>Haryana Electric Vehicle Policy 2022</strong></td><td>This policy places a special emphasis on the creation of end-to-end ecosystem for E-Mobility in the state and envisages harnessing Haryana\u2019s inherent strength in automotive manufacturing sector for supporting Electric Vehicle manufacturing and adoption within the state.</td><td><ol class="mb-0"><li>Capital subsidy of Fixed Capital Investment (FCI)</li><li>Seed and Conversion Fund</li><li>Net SGST reimbursement</li><li>Reimbursement in Stamp Duty</li><li>Power subsidy and incentives</li><li>Water treatment plant incentives</li><li>Patent Fee</li><li>Employment Generation Subsidy</li><li>Incentives for Buyers</li><li>Incentives for Privately owned Public Charging/ Battery Swapping Stations</li><li>Human Capacity Building</li><li>Research and Development</li><li>Purchase Incentives for Buyers</li><li>Tax Exemptions on Electric Vehicles</li></ol></td><td class="text-center">09.07.2027</td><td class="text-center"><a href="../../content/pdfs/The Haryana Electric Vehicle Policy 2022 new.pdf" target="_blank" class="btn btn-sm btn-primary">Download</a></td></tr><tr><td>4</td><td><strong>Haryana Registered Vehicle Scrappage and Recycling Facility Incentive Policy 2024</strong></td><td>To create a conducive ecosystem for growth of scrapping and recycling in Haryana in addition to the obvious benefits of reduction in pollution, fuel import bill, raw materials availability, recycle or re-use parts and impetus of replacement demand.</td><td><ol class="mb-0"><li>Policy notified on 24.10.2024</li><li>Proposal being sent to Planning Department based on their comments for consideration of SFC-B</li></ol></td><td class="text-center">5 years from 24.10.2024 or until discontinued by the Government</td><td class="text-center"><a href="../../content/pdfs/Vehicle Scrappage Policy Haryana_Transport Dept._Gazette_214-2022_Ext_15160 new.pdf" target="_blank" class="btn btn-sm btn-primary">Download</a></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/policyFeedbackDashboard/feedbacks.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Policy Feedback</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Policy Feedback</span></li></ol></div></section><br><div class="container"><div class="row"><div class="col-md-2 pull-left"><p class="btn btn-md btn-primary" uk-toggle="target: #draft_policy" type="button"><span><i class="glyphicon glyphicon-pencil"></i></span>&nbsp;&nbsp;Add your feedback</p></div><div class="col-md-2 pull-right"><select style="border: none; box-shadow: none" class="form-control" ng-model="vm.policyFilter" ng-change="vm.statusSelected(vm.statusFilter,vm.policyFilter)"><option value="All">All</option><option value="{{policy.name}}" ng-repeat="policy in vm.policyDetails">{{policy.name}}</option><option value="Draft HEEP 2020">Draft HEEP 2020</option></select></div><div class="col-md-2 pull-right"><select style="border: none; box-shadow: none" class="form-control" ng-model="vm.statusFilter" ng-change="vm.statusSelected(vm.statusFilter,vm.policyFilter)"><option value="All">All</option><option value="Pending">Pending</option><option value="Reviewed">Reviewed</option></select></div><div class="col-md-1 filter-margin pull-right"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div></div><div><h2 class="text-danger"><b>Feedbacks received:</b></h2><h3 class="text-danger thread-title">Status: <b>{{ vm.statusFilter }} </b>&nbsp &nbsp &nbsp &nbsp Policy(s): <b>{{ vm.policyFilter }}</b> <b><a class="pull-right" ng-show="vm.policyFilter === \'Draft HEEP 2020\'" target="_blank" href="../../content/pdfs/2020_HEEP.pdf">View PDF</a></b></h3><hr style="border-width: thick"></div><div ng-if="vm.policyFilter !== \'Draft HEEP 2020\'" class="msg-wrap" ng-repeat="draftPolicy in vm.draftPolicies | orderBy : \'-remarkDate\'"><div class="msg odd" ng-show="($index % 2) != 0"><div class="col-md-3 author"><b><h5 class="media-heading">{{draftPolicy.name}}</h5></b></div><div class="col-md-9"><div class="col-md-9">{{draftPolicy.remarks}}</div><div class="col-md-9" ng-show="draftPolicy.remarks_admin"><b>Reply: </b>{{draftPolicy.remarks_admin}}</div></div><div class="clearfix"></div></div><div class="msg even" ng-show="($index % 2) == 0"><div class="col-md-3 author"><b><h5 class="media-heading">{{draftPolicy.name}}</h5></b></div><div class="col-md-9"><div class="col-md-9">{{draftPolicy.remarks}}</div><div class="col-md-9" ng-show="draftPolicy.remarks_admin"><b>Reply: </b>{{draftPolicy.remarks_admin}}</div></div><div class="clearfix"></div></div></div></div><div ng-if="vm.statusFilter !== \'Draft HEEP 2020\'" id="draft_policy" class="uk-flex-top" uk-modal><div class="uk-modal-dialog"><div class="uk-modal-header"><b><h3 class="text-primary">Feedback on Draft Policy</h3></b></div><div class="uk-modal-body" ng-show="vm.policyDetails.length > 0"><h5 class="text-primary">Kindly provide your valuable comments on the draft policies published below. Your comments will be considered by the GoH while drafting the final policies.</h5><button class="uk-modal-close-outside" type="button" uk-close></button><ul class="nav nav-pills" role="tablist"><li ng-repeat="policy in vm.policyDetails"><a role="tab" data-toggle="tab" ng-click="setTempItem(policy)">{{policy.name}}</a></li></ul><div id="{{policyName}}" class="tab-content" ng-show="vm.showPolicyForm"><div class="tab-pane active" role="tabpanel"><br><form ng-show="policyName != null" class="uk-grid-small" uk-grid ng-submit="vm.save()"><span hidden>{{vm.draftPolicy.policy = policyName}}</span><div class="col-md-12 uk-first-column"><input class="uk-input" type="email" ng-model="vm.draftPolicy.email" placeholder="E-Mail" required></div><div class="col-md-6 uk-grid-margin"><input class="uk-input" type="text" ng-model="vm.draftPolicy.name" placeholder="Name" required></div><div class="col-md-6 uk-grid-margin"><input name="mobile" id="mobile" class="uk-input" type="number" ng-model="vm.draftPolicy.phone" placeholder="Phone no." ng-maxlength="10" ng-minlength="10" required></div><div class="col-md-12 uk-grid-margin"><textarea class="uk-textarea" rows="4" ng-model="vm.draftPolicy.remarks" placeholder="Remarks" required></textarea></div><div class="col-md-12 uk-grid-margin"><button type="button" class="uk-button uk-button-danger" style="font-size: 14px" ng-click="vm.downloadAdvertisement(serverFileName,\'PolicyDetails\')"><i class="fa fa-download">&nbsp;&nbsp;</i>View Policy</button> <button type="submit" class="uk-button uk-button-primary pull-right" style="font-size: 14px"><i class="fa fa-save">&nbsp;&nbsp;</i>Submit</button></div></form></div></div></div><div class="uk-modal-body" ng-hide="vm.policyDetails.length > 0"><button class="uk-modal-close-outside" type="button" uk-close></button><h4>No policy right now to comment upon.</h4></div></div></div>');
$templateCache.put('app/processapplication/paymentservice.html','<form name="editForm" role="form"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">Payment Amount</h4></div><div class="modal-body"><div class="form-group"><label class="control-label">Payment amount</label><input type="text" class="form-control" placeholder="Enter Payment amount" required></div><div class="form-group"><label class="control-label">Remarks</label><textarea class="form-control" placeholder="Enter Remarks" required>\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Clear</button>\n        <button type="submit" class="btn btn-default">Save</button></div></form>');
$templateCache.put('app/processapplication/processapplication.html','<div ng-cloak><div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Application Process Section</h3></div><div class="panel-body"><table class="table table-striped table-hover"><tbody><tr><th>Application For</th><td></td><th>Sector</th><td></td></tr><tr><th>PIN</th><td></td><th>ApplicationDate</th><td></td></tr><tr><th>Business Entity</th><td></td><th>Site Detail</th><td></td></tr><tr><th>Project Cost</th><td></td><th>MOU (Year)</th><td></td></tr><tr><th>Relationship Manager</th><td></td><th>Contact Info</th><td></td></tr></tbody></table></div></div><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Take Action</h3></div><div class="panel-body"><div class="row"><div class="form-group"><div class="col-lg-12">&nbsp;</div><div class="col-lg-12">&nbsp;</div></div><div class="form-group forward"><div class="col-lg-12"><table class="table table-striped table-hover"><thead><tr><th scope="col"><input type="checkbox"></th><th scope="col">Department</th><th scope="col">Service</th><th scope="col">Action</th></tr></thead><tbody><tr><td><input type="checkbox"></td><td>HARTRON</td><td>DEVELOPMENT</td><td><button type="submit" ui-sref="processapplication.payment" class="btn btn-info">Assign</button></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/projectBankGuarantee/assignfeeforbankgurantee.html','<form name="editForm" role="form" ng-submit="vm.assignService()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCountryLabel" data-translate="">Bank Gurantee Service Fee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Fee Amount</label><input type="number" class="form-control" ng-model="vm.projectservicedetail.serviceFee" required></div><div class="form-group"><label class="control-label" data-translate="">Comment</label><textarea class="form-control" rows="3" id="textArea" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editForm.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/projectBankGuarantee/projectBankGuarantee.html','<div class="container" ng-controller="ProjectBankGuaranteeController as vm"><form name="pbgForm" novalidate ng-submit="vm.save()"><div class="panel-group"><div class="panel panel-default"><div class="panel-heading"><h4><strong>Project Bank Guarantee Form</strong></h4></div><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Bank Guarantee Details</legend><div class="form-group"><label class="col-lg-2 control-label">PBG Number <span style="color:red">*</span></label><div class="col-lg-4"><input type="text" class="form-control" ng-model="vm.pbgForm.pbgNumber" placeholder="Enter PBG Number" required></div><label class="col-lg-2 control-label">Bank Name <span style="color:red">*</span></label><div class="col-lg-4"><input type="text" class="form-control" ng-model="vm.pbgForm.bankName" placeholder="Enter Bank Name" required></div></div><div class="form-group"><label class="col-lg-2 control-label">Expiry Date <span style="color:red">*</span></label><div class="col-lg-4"><input type="date" class="form-control" ng-model="vm.pbgForm.expiryDate" required></div><label class="col-lg-2 control-label">Upload Document</label><div class="col-lg-4"><input type="file" class="form-control input" file-model="vm.pbgForm.uploadDocument" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div><!--                                    <label class="col-lg-2 control-label" data-translate="" >Upload Document</label>--><!--                                <div class="col-lg-4">--><!--                                    <input type="file" class="form-control input"  file-Model="vm.pbgForm.uploadDocument" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf">--><!--                                    <p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p>--><!--                                </div>--><!--                                <label class="col-lg-2 control-label">Upload Document</label>--><!--                                <div class="col-lg-4">--><!--                                    <input type="file" class="form-control" ng-model="vm.pbgForm.uploadDocument" placeholder="e.g. document.pdf" />--><!--                                </div>--></div></fieldset></div></div></div></div><div class="form-group"><div class="col-lg-offset-2 col-lg-10"><button type="submit" class="btn btn-success">Submit</button></div></div></form></div>');
$templateCache.put('app/projectBankGuarantee/projectBankGuranteeEdit.html','<div class="container" ng-controller="ProjectBankGuaranteeEditController as vm"><form name="pbgForm" novalidate ng-submit="vm.updateProjectBankGuarantee()"><div class="panel-group"><div class="panel panel-default"><div class="panel-heading"><h4><strong>Project Bank Guarantee Form</strong></h4></div><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Bank Guarantee Details</legend><div class="form-group"><label class="col-lg-2 control-label">PBG Number <span style="color:red">*</span></label><div class="col-lg-4"><input type="text" class="form-control" ng-model="vm.projectGuaranteeData.pbgNumber" placeholder="Enter PBG Number" required></div><label class="col-lg-2 control-label">Bank Name <span style="color:red">*</span></label><div class="col-lg-4"><input type="text" class="form-control" ng-model="vm.projectGuaranteeData.bankName" placeholder="Enter Bank Name" required></div></div><div class="form-group"><label class="col-lg-2 control-label">Expiry Date <span style="color:red">*</span></label><div class="col-lg-4"><input type="{{vm.expiryDateInputType}}" class="form-control" ng-model="vm.projectGuaranteeData.expiryDate" required ng-focus="vm.expiryDateInputType = \'date\'" ng-blur="vm.expiryDateInputType = \'text\'"></div><label class="col-lg-2 control-label">Upload Document</label><div class="col-lg-4"><input type="text" class="form-control" ng-model="vm.projectGuaranteeData.uploadDocument" placeholder="e.g. document.pdf"></div></div><!-- You can also show Project Service ID if needed --><!--\n                            <div class="form-group">\n                                <label class="col-lg-2 control-label">Project Service ID</label>\n                                <div class="col-lg-4">\n                                    <input type="text" class="form-control"\n                                        ng-model="vm.projectGuaranteeData.projectServiceId"\n                                        readonly />\n                                </div>\n                            </div>\n                            --></fieldset></div></div></div></div><div class="form-group"><div class="col-lg-offset-2 col-lg-10"><button type="submit" class="btn btn-success">Update</button> <button type="button" class="btn btn-default" ng-click="vm.close()">Close</button></div></div></form></div>');
$templateCache.put('app/projectBankGuarantee/projectBankGuranteeView.html','<div class="container" ng-controller="ProjectBankGuaranteeViewController as vm"><form name="pbgForm" novalidate ng-submit="vm.save()"><div class="panel-group"><div class="panel panel-default"><div class="panel-heading"><h4><strong>Project Bank Guarantee Form</strong></h4></div><div class="panel-body"><div class="form-horizontal"><fieldset><legend>Bank Guarantee Details</legend><div class="form-group"><label class="col-lg-2 control-label">PBG Number <span style="color:red">*</span></label><div class="col-lg-4"><input type="text" class="form-control" ng-model="vm.projectGuaranteeData.pbgNumber" placeholder="Enter PBG Number" readonly="readonly"></div><label class="col-lg-2 control-label">Bank Name <span style="color:red">*</span></label><div class="col-lg-4"><input type="text" class="form-control" ng-model="vm.projectGuaranteeData.bankName" placeholder="Enter Bank Name" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label">Expiry Date <span style="color:red">*</span></label><div class="col-lg-4"><input type="text" class="form-control" ng-model="vm.projectGuaranteeData.expiryDate" readonly="readonly"></div><label class="col-lg-2 control-label">Upload Document</label><div class="col-lg-4"><input type="text" class="form-control" ng-model="vm.projectGuaranteeData.uploadDocument" placeholder="e.g. document.pdf" readonly="readonly"></div></div><div class="form-group" ng-repeat="servicelog in vm.ServiceLog | orderBy:\'-commentDate\'"><div class="col-lg-4"><div ng-show="servicelog.fileName && servicelog.actionTaken == \'Bank Gurantee Logs\'"><!-- Title and Button Inline --><p><strong>Download Document:</strong> <button id="myBtn" type="button" class="btn btn-primary btn-sm" style="margin-left: 10px" ng-click="vm.downFile(servicelog)">Download</button></p></div></div></div><!-- You can also show Project Service ID if needed --><!--\n                            <div class="form-group">\n                                <label class="col-lg-2 control-label">Project Service ID</label>\n                                <div class="col-lg-4">\n                                    <input type="text" class="form-control"\n                                        ng-model="vm.projectGuaranteeData.projectServiceId"\n                                        readonly />\n                                </div>\n                            </div>\n                            --></fieldset></div></div></div></div><div class="form-group"><div class="col-lg-offset-2 col-lg-10"><button type="button" class="btn btn-default" ng-click="vm.close()">Close</button></div></div></form></div>');
$templateCache.put('app/projectdetailjist/NoInfo.html','<div class="row"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title" data-translate="global.viewcaf.Nodal Officer Contact Information">Nodal Officer Contact Information</h3></div><div class="panel-body"><div class="col-md-3 filter-margin text-right"><label for="filterDept" class="uk-label uk-label-danger" style="font-size: 12px"><span data-translate="global.viewcaf.Filter">Filter</span> :</label></div><div class="col-md-5 text-center"><select id="filterDept" class="form-control custom-form-control" ng-options="department.deptName as department.deptName for department in vm.NOInfo | unique:\'deptName\' | orderBy:\'deptName\'" ng-change="vm.findNO(vm.departmentFilter)" ng-model="vm.departmentFilter"><option value="" disabled="" data-translate="global.viewcaf.SELECT DEPARTMENT">Select Department</option><option value="{{deptName}}">{{deptName}}</option></select></div><table class="jh-table table table-striped mt-60"><thead><tr><th><span data-translate="global.viewcaf.Nodal Officer Name">Nodal Officer Name</span></th><th><span data-translate="global.viewcaf.Phone Number">Phone Number</span></th><th><span data-translate="global.viewcaf.LandLine Number">LandLine Number</span></th></tr></thead><tbody><tr ng-repeat="Noinfo in vm.NOContact "><td>{{Noinfo.name}}</td><td>{{Noinfo.phoneNumber}}</td><td ng-if="Noinfo.landlineNumber">{{Noinfo.landlineNumber}}</td><td ng-if="!Noinfo.landlineNumber">-</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/projectdetailjist/cafSummary.html','<div class="container-fluid" ng-cloak><div class="row"><div class="col-md-12"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title"><span data-translate="global.viewcaf.CAF Summary">CAF Summary</span> <span class="pull-right">{{vm.investorsummarydetails.caftype}}</span></h3></div><div class="panel-body"><div ng-show="vm.investorsummarydetails.isdeactivated == true" class="alert alert-dismissible alert-danger"><strong>This CAF has been Deactivated</strong></div><jhi-alert-error></jhi-alert-error><jhi-alert></jhi-alert><h4></h4><table class="table table-striped table-hover"><tbody><tr><th class="col-md-3" data-translate="global.viewcaf.Application For">Application For</th><td class="col-md-3">Regulatory Approvals & Services</td><th class="col-md-3" data-translate="global.viewcaf.Sector">Sector</th><td class="col-md-3">{{vm.investorsummarydetails.sectorName}}</td></tr><tr><th class="col-md-3" data-translate="global.viewcaf.CAF Pin">CAF PIN</th><td class="col-md-3">{{vm.investorsummarydetails.cafpin}}</td><th class="col-md-3" data-translate="global.viewcaf.Application Date">Application Date</th><td class="col-md-3">{{vm.investorsummarydetails.applicationDate | date:\'dd-MM-yyyy\'}}</td></tr><tr><th class="col-md-3" data-translate="global.viewcaf.Business Entity">Business Entity</th><td class="col-md-3">{{vm.investorsummarydetails.buisnessEntity}}</td><th class="col-md-3" data-translate="global.viewcaf.Site Detail">Site Detail</th><td class="col-md-3">{{vm.investorsummarydetails.siteaddress}},{{vm.investorsummarydetails.district}},{{vm.investorsummarydetails.block}}</td></tr><tr><th class="col-md-3" data-translate="global.viewcaf.Project Cost">Project Cost</th><td class="col-md-3">{{vm.investorsummarydetails.projectTotalCost}} <span data-translate="global.addcafnew.crores">Crores</span></td><th class="col-md-3" data-translate="global.viewcaf.MOU (Year)">MOU (Year)</th><td class="col-md-3">{{vm.investorsummarydetails.mouYear}}</td></tr><tr><th class="col-md-3" data-translate="global.viewcaf.Relationship Manager">Relationship Manager</th><td class="col-md-3">{{vm.investorsummarydetails.rm==\'\' ? "Not Assigned" : vm.investorsummarydetails.rm}}</td><th class="col-md-3" data-translate="global.viewcaf.Helpdesk Number">Helpdesk Number</th><td class="col-md-3">1800-180-2132</td></tr><tr><th class="col-md-3" data-translate="global.viewcaf.Investor Info">Investor Info</th><td class="col-md-3">{{vm.investorsummarydetails.investorInfo}}</td><th class="col-md-3" data-translate="global.viewcaf.CAF Active">CAF Active</th><td class="col-md-3">{{(vm.investorsummarydetails.isdeactivated == false || vm.investorsummarydetails.isdeactivated == null) ? "Yes" : "No"}}{{}}</td></tr><tr><th ng-show="vm.REDetails!=null && vm.REDetails.length!=0" class="col-md-3">RE Details</th><td ng-show="vm.REDetails!=null && vm.REDetails.length!=0" class="col-md-3"><span>{{vm.REDetails[0].REName}}</span><br><span>{{vm.REDetails[0].REphoneNumber}}</span><br><span>{{vm.REDetails[0].EmailId}}</span></td></tr><tr><th class="col-md-3"><button type="submit" class="btn btn-danger btn-sm" ng-show="((vm.investorsummarydetails.isdeactivated==false) || (vm.investorsummarydetails.isdeactivated==null)) && (vm.investorsummarydetails.cafpin!=\'NA\') && (vm.account.login === \'deskof\' || vm.account.login === \'admin\')" ng-click="vm.deactivateCAF()">Deactive CAF</button> <button type="submit" ng-show="(vm.investorsummarydetails.isdeactivated==true) && (vm.account.login === \'deskof\' || vm.account.login === \'admin\')" ng-click="vm.activateCAF()" class="btn btn-info btn-sm">Activate CAF</button></th><td class="col-md-3"></td><th class="col-md-3"></th><td class="col-md-3"><button type="submit" ng-click="vm.edit_form()" ng-show="(vm.investorsummarydetails.cafpin==\'NA\' || vm.investorsummarydetails.cafpin==null) && (vm.investorsummarydetails.isdeactivated==false || vm.investorsummarydetails.isdeactivated==null)" class="btn btn-info btn-sm">Edit Form</button> <button has-any-authority="ROLE_ADMIN ,ROLE_SUB_ADMIN" type="submit" data-toggle="modal" data-target="#editCAFmodal" class="btn btn-info btn-sm" ng-click="vm.editInvestment()" ng-if="vm.investorsummarydetails.caftype == \'New\' && !vm.investorsummarydetails.isdeactivated">Edit Cost</button> <button type="submit" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_FILM_OFFICER" ng-click="vm.edit_form()" ng-show="(vm.investorsummarydetails.cafpin!=\'NA\' || vm.investorsummarydetails.cafpin!=null) && (vm.investorsummarydetails.isdeactivated==false || vm.investorsummarydetails.isdeactivated==null)" class="btn btn-info btn-sm">Edit Form</button> <button type="submit" has-any-authority="ROLE_USER,ROLE_ADMIN" ng-click="vm.edit_formForUser()" ng-show="(vm.investorsummarydetails.cafpin!=\'NA\' || vm.investorsummarydetails.cafpin!=null) && (vm.investorsummarydetails.isdeactivated==false || vm.investorsummarydetails.isdeactivated==null)" class="btn btn-info btn-sm">Submit \u2014 CAF Change Request</button></td></tr></tbody></table></div></div><div ui-view="viewformUi"></div></div></div></div><div id="editCAFmodal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Change Project Detail\'s</h4></div><div class="modal-body"><div class="row" ng-if="vm.existingproject"><label class="col-md-10 control-label" style="color:red">This is an Existing Project. Proposed Project Cost and Employment will remain 0.</label></div><div class="row"><div class="form-group"><label class="col-md-4 control-label">Total Proposed Project Cost (in Crore) <span style="color:red">*</span></label><div class="col-md-8"><div class="col-md-3"><input type="number" class="form-control" name="croresCost" placeholder="Crores" ng-model="vm.project_cost_in_crore" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" ng-readonly="vm.existingproject" required><div ng-show="myform.croresCost.$invalid && myform.croresCost.$touched || myform.croresCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">crores</small><div class="col-md-3"><input type="number" class="form-control" name="lacsCost" placeholder="lacs" ng-model="vm.project_cost_in_lacs" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" ng-readonly="vm.existingproject" required><div ng-show="myform.lacsCost.$invalid && myform.lacsCost.$touched || myform.lacsCost.$error.min"><small style="color:red; display:block;text-align:left">Invalid Input</small></div></div><small class="pull-left" style="margin-right:10px;margin-top:10px;margin-left:-10px">lacs</small><div class="col-md-3"><input type="number" class="form-control" name="thousandsCost" placeholder="thousands" ng-model="vm.project_cost_in_thousands" ng-model="vm.project_cost_in_thousands" ng-pattern="/^[0-9]+(\\.[0-9]{1,2})?$/" ng-change="vm.changeInCost()" min="0" max="99" ng-readonly="vm.existingproject" required><div ng-show="myform.thousandsCost.$invalid && myform.thousandsCost.$touched || myform.thousandsCost.$error.min"><small style="color:red; display:block;text-align:center">Invalid Input</small></div></div><small class="pull-left" style="margin-top:10px;margin-left:-10px">thousands</small></div></div></div><br><div class="row"><div class="form-group"><label class="col-lg-4 control-label">Total Proposed Project Employment <span style="color:red">*</span></label><div class="col-lg-4"><input type="number" class="form-control" id="totalemployment" placeholder="Proposed Employment" ng-model="vm.project.totalpurposedemployment" min="0" ng-readonly="vm.existingproject" required></div></div></div><br><div class="row"><div class="form-group"><label class="col-lg-4 control-label" ng-if="vm.project.totalpurposedemployment != 0">Haryana Domicile <span style="color:red">*</span></label><div class="col-lg-2"><input type="number" class="form-control" id="Haryana_Domicile" placeholder="0" ng-model="vm.project.haryanadomicile" id="haryanaDomicile" ng-change="vm.proposedEmployment(\'haryana\')" min="0" ng-show="vm.project.totalpurposedemployment" ng-readonly="vm.existingproject" required></div><label class="col-lg-4 control-label" ng-if="vm.project.totalpurposedemployment != 0">Non Haryana Domicile <span style="color:red">*</span></label><div class="col-lg-2"><input type="number" class="form-control" id="Non_Haryana_Domicile" placeholder="0" ng-model="vm.project.nonharyanadomicile" ng-change="vm.proposedEmployment(\'nonHaryana\')" min="0" ng-show="vm.project.totalpurposedemployment" ng-readonly="vm.existingproject" required></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button> <button type="button" class="btn btn-primary" ng-click="vm.changeInvestment(vm.project)">Save</button></div></div></div></div><!--<div class="panel panel-primary">--><!--<div class="panel-heading">--><!--<h3 class="panel-title">Project Acceptance</h3>--><!--&lt;!&ndash;<span ng-show="vm.investorsummarydetails.caftype==\'New\'" has-any-authority="ROLE_MONITORING_OFFICER,ROLE_USER" class="panel-title pull-right" style="margin-top: -20px;font-size: 15px" ng-click="vm.createConstructionPermit()">Common Construction Permit Approval Form</span>&ndash;&gt;--><!--</div>--><!--<div class="panel-body">--><!--<table class="table table-striped table-hover ">--><!--<thead>--><!--<tr>--><!--<th>Clearance</th>--><!--<th>Status</th>--><!--<th>Action</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr>--><!--<td>CAF</td>--><!--<td>Project Submitted</td>--><!--<td>--><!--<button type="submit" ng-show="(vm.investorsummarydetails.cafpin!=\'NA\' && vm.investorsummarydetails.cafpin!=null) && (vm.investorsummarydetails.isdeactivated==false || vm.investorsummarydetails.isdeactivated==null)"--><!--ui-sref="serviceclearanceaction({id:vm.investorsummarydetails.projectid})"--><!--class="btn btn-danger btn-sm">Service Clearance--><!--</button>--><!--&lt;!&ndash;<button has-authority="ROLE_MONITORING_OFFICER" type="submit"&ndash;&gt;--><!--&lt;!&ndash;class="btn btn-success btn-sm" >Common Construction Permit Approval Form&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--&lt;!&ndash;<button has-authority="ROLE_MONITORING_OFFICER" type="submit"&ndash;&gt;--><!--&lt;!&ndash;class="btn btn-primary btn-sm" ui-sref="inspectionOfficer">Pending Inspections&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>-->');
$templateCache.put('app/projectdetailjist/projectdetailjist.html','<div class="container-fluid" ng-cloak><div class="sticky-hepc col-md-2 sidebar"><div class="sidebar-header"><div class="header-cafPin"><span data-translate="global.viewcaf.CAF Pin">CAF Pin</span>: {{vm.project.cafpin}}</div><div class="header-caftype"><span data-translate="global.viewcaf.CAF Type">Caf Type</span>: {{vm.project.caftype}}</div></div><div class="siderbar-menu"><ul class="nav"><li ng-class="{active: currentstate == \'projectdetailjist\'}" ui-sref="projectdetailjist({projectid: projectId})" ui-sref-opts="{reload: true}"><a href=""><i class="glyphicon glyphicon-home"></i> <span data-translate="global.viewcaf.CAF Summary">CAF Summary</span></a></li><li ng-class="{active: currentstate == \'ProjectCompleteDetailNew\' || currentstate == \'ProjectCompleteDetailShop\' || currentstate == \'ProjectCompleteDetailRenewable\'\n                                || currentstate == \'ProjectCompleteDetailLandRequirement\' || currentstate == \'ProjectCompleteDetailTower\' || currentstate == \'ProjectCompleteDetailFilm\'}"><a href="" ng-click="vm.view_form()"><i class="glyphicon glyphicon-eye-open"></i> <span data-translate="global.viewcaf.View Form">View Form</span></a></li><li ng-class="{active: currentstate == \'serviceclearanceaction.required\'}" ng-hide="vm.project.isdeactivated || vm.project.isdraft || vm.project.cafpin === \'NA\'" ui-sref="serviceclearanceaction.required({district: vm.project.district})" ui-sref-opts="{reload: true}" has-any-authority="ROLE_USER,ROLE_ADMIN,ROLE_STATE_NODAL_OFFICER"><a href=""><i class="glyphicon glyphicon-ok"></i> <span data-translate="global.viewcaf.Service Required">Service Required</span></a></li><li ng-class="{active: currentstate == \'serviceclearanceaction\'}" ng-hide="vm.project.isdeactivated || vm.project.isdraft || vm.project.cafpin === \'NA\'" ui-sref="serviceclearanceaction({district: vm.project.district})" ui-sref-opts="{reload: true}"><a href=""><i class="glyphicon glyphicon glyphicon-stats"></i> <span data-translate="global.viewcaf.Service In Progress">Service In Progress</span></a></li><li ng-class="{active: currentstate == \'noInfo\'}" ng-hide="vm.project.isdeactivated || vm.project.isdraft || vm.project.cafpin === \'NA\'" ui-sref="noInfo({district: vm.project.district})" ui-sref-opts="{reload: true}"><a href=""><i class="glyphicon glyphicon-earphone"></i> <span data-translate="global.viewcaf.Nodal Officer">Nodal Officer</span></a></li><li ng-class="{active: currentstate == \'viewServiceLog\'}"><a href="" ui-sref="viewServiceLog({cafType: vm.project.caftype})" ui-sref-opts="{reload: true}"><i class="glyphicon glyphicon-list"></i> <span data-translate="global.viewcaf.Project Log">Project Log</span></a></li><li ng-class="{active: currentstate == \'viewServiceLog\'}"><a href="" ng-click="vm.openEntityLocker()"><i class="glyphicon glyphicon-list"></i> <span>Entity Locker</span></a></li></ul><br><button class="bttn success" ng-if="vm.project.caftype == \'New\' && vm.project.cafpin != \'NA\' && !vm.project.isdraft && vm.project.isskillsFilled==null  && !vm.project.isdeactivated\n                    || vm.project.caftype == \'New\' &&  !vm.project.isdeactivated && vm.project.cafpin != \'NA\' && !vm.project.isdraft  && !vm.project.isskillsFilled" ui-sref="skills({id: vm.project.id})"><i class="glyphicon glyphicon-wrench"></i> <span data-translate="global.menu.Skills Required">Skills Required</span></button></div></div><div class="col-md-10"><div class="main-content"><div ui-view="sideView"></div></div></div></div><style>.bttn {\n        border: 2px solid black;\n        background-color: white;\n        color: black;\n        padding: 6px 12px;\n        font-size: 12px;\n        cursor: pointer;\n    }/* Green */\n    .success {\n        border-color: #4CAF50;\n        color: green;\n    }\n\n    .success:hover {\n        background-color: #4CAF50;\n        color: white;\n    }</style>');
$templateCache.put('app/projectdetailjist/serviceLog.html','<div class="container-fluid" ng-cloak><div class="row"><div class="col-md-12"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title" data-translate="global.viewcaf.Project Log">Project Log</h3></div><div class="panel-body"><table class="jh-table table table-striped" ng-if="vm.projectlogs"><thead><tr><th><span data-translate="global.viewcaf.Action Taken">Action Taken</span></th><th><span data-translate="global.viewcaf.Action By">Action By</span></th><th><span data-translate="global.viewcaf.Action Date">Action Date</span></th><th><span data-translate="global.viewcaf.Description">Description</span></th></tr></thead><tbody><tr ng-repeat="projectlog in vm.projectlogs | orderBy : \'-actiontakendate\'"><td>{{projectlog.actiontype}}</td><td>{{projectlog.actiontakenby}}</td><td>{{projectlog.actiontakendate | date:\'dd-MM-yyyy\'}}</td><td>{{projectlog.actiontaken}}</td></tr></tbody></table><table class="jh-table table table-striped" ng-if="vm.projectlogsnewcaf"><thead><tr><th><span data-translate="global.viewcaf.Action">Action</span></th><th><span data-translate="global.viewcaf.Action By">Action By</span></th><th><span data-translate="global.viewcaf.Action Date">Action Date</span></th><th><span data-translate="global.viewcaf.Fields Updated">Fields Updated</span></th><th><span data-translate="global.viewcaf.Old Value">Old Value</span></th><th><span data-translate="global.viewcaf.New Value">New Value</span></th></tr></thead><tbody><tr ng-repeat="projectLogNewCaf in vm.projectlogsnewcaf | orderBy : \'-actionTakenDate\'"><td>{{projectLogNewCaf.actionType}}</td><td>{{projectLogNewCaf.actionTakenBy}}</td><!--<td>{{projectLogNewCaf.actionTakenDate | date:\'medium\'}}</td>--><td>{{projectLogNewCaf.actionTakenDate | date:\'dd-MM-yyyy\'}}</td><td>{{projectLogNewCaf.fieldUpdated}}</td><td>{{projectLogNewCaf.oldValue}}</td><td>{{projectLogNewCaf.newValue}}</td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/projectdetailjist/skillsRequired.html','<form name="skillsForm" novalidate ng-submit="vm.saveSkillsRequried(field.formfieldvalue)"><div class="container-fluid" ng-cloak><div class="row"><div class="col-md-12"><div class="panel"><button type="button" class="btn btn-default pull-right" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><div class="panel-heading"><h3 class="text-danger">Skills Required</h3></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="col-md-offset-1 control-label">Sectors<span style="color:red">*</span></label></div><div class="col-md-6"><select class="form-control" id="sectors" ng-model="vm.sectorname" ng-change="vm.sectorResult(vm.sectorname)" ng-options="skillsData.sector as skillsData.sector for skillsData in vm.skillsData | unique:\'sector\'" required><option value="" disabled="disabled">-- Select Sector --</option></select></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="col-md-offset-1 control-label">Job Role</label></div><div class="col-md-6"><multiselect placeholder="Select Job Roles" ng-model="vm.mySectorData" options="vm.requiredPerson" show-search="true" id-prop="jobRole" display-prop="jobRole" required>{{vm.mySectorData}}</div></div></div><br><div ng-repeat="field in vm.mySectorData"><!-- TEXT FIELDS --><div class="form-group"><div class="row"><div class="col-md-5"><label class="col-md-offset-1 control-label">{{field.jobRole}}<span style="color:red">*</span></label></div><div class="col-md-6"><input class="form-control" type="number" id="{{field.id}}" min="1" oninput="validity.valid||(value=\'\');" ng-model="field.requiredLabour" class="form-control" required></div></div></div></div><span class="text-justify text-left"><b>In case any information is required for engaging skilled manpower in your enterprise, Please contact :</b></span><br><div class="text-right"><span><b>Dr. Sanjay Bhardwaj</b></span><br><span class="text-success">sanjay.hvsu@gmail.com/+91-9871922449,</span><br><span>Deputy Director, Shri Vishwakarma Skill University, Haryana</span></div><br><br><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">&nbsp;<span>Cancel</span></button> <button type="submit" ng-disabled="skillsForm.$invalid || vm.sectorname==null || vm.mySectorData.size==0" class="btn btn-primary">&nbsp;<span>Submit</span></button><br></div></div></div></div></div></form>');
$templateCache.put('app/projectdetailjist/totalskills.html','<div><h2>Project Skills</h2><button style="margin-bottom: 12px;margin-left: 1100px" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button><br><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>Caf Pin (Composite Application Form)</span></th><th><span>District</span></th><th><span>Sector</span></th><th><span>Job Role</span></th><th><span>Required Labour</span></th><th><span>Business Entity Name</span></th><th><span>Site Address</span></th><th><span>Contact Number</span></th><th><span>Email Id</span></th><th><span>Project Investment Cost</span></th><th><span>Project Employment</span></th><th><span>Haryana Domicile</span></th><th><span>Non haryana domicile</span></th><th><span>Creation Date</span></th></tr></thead><tbody><tr ng-repeat="projectSkills in vm.projectSkills | orderBy:\'-cafpin\'"><td>{{projectSkills.cafpin}}</td><td>{{projectSkills.district}}</td><td>{{projectSkills.sector}}</td><td>{{projectSkills.jobRole}}</td><td>{{projectSkills.requiredLabour}}</td><td>{{projectSkills.businessentity}}</td><td>{{projectSkills.siteaddress}}</td><td>{{projectSkills.mobilenumber}}</td><td>{{projectSkills.emailprimary}}</td><td>{{projectSkills.total_project_cost}}</td><td>{{projectSkills.totalpurposedemployment}}</td><td>{{projectSkills.haryanadomicile}}</td><td>{{projectSkills.nonharyanadomicile}}</td><td>{{projectSkills.creationDate | date:\'dd-MM-yyyy\'}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/psTowerDashboard/psTowerDashboardView.html','<style>.app-modal-window .modal-dialog {\n        width: 90%;\n    }\n\n    .loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 40px !important;\n        height: 40px;\n        animation: spin 2s linear infinite;\n    }\n\n    @keyframes spin {\n        0% {\n            transform: rotate(0deg);\n        }\n        100% {\n            transform: rotate(360deg);\n        }\n    }</style><form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-10"><h4 class="modal-title" ng-show="vm.status==\'Declined\'">ALL CAFs WITH REJECTED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Pending\'">ALL CAFs WITH PENDING SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Cleared\'">ALL CAFs WITH CLEARED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Applied\'">ALL CAFs WITH APPLIED SERVICES</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div><div class="row" align="center" has-any-authority="ROLE_ADMIN, ROLE_NODAL_OFFICER, ROLE_TOWER_DC, ROLE_TOWER_MONITORING_OFFICER, ROLE_RM, ROLE_SUB_ADMIN, ROLE_DESK_OFFICER, ROLE_ACCOUNT_OFFICER, ROLE_FIELD_OFFICER, ROLE_ASSIGNRM_OFFICER, ROLE_MONITORING_OFFICER, ROLE_HEPC_MONITORING_OFFICER, ROLE_GRIEVANCE_OFFICER, ROLE_GRIEVANCE_ADMIN, ROLE_TOWER_DIO, ROLE_TOWER_OFFICER,\n                    ROLE_DEPT_CHANGE, ROLE_L1_SUPPORT, ROLE_TICKET_NODAL_OFFICER, ROLE_L2_DEPARTMENT_HEAD, ROLE_TICKET_OPERATION_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_INCENTIVES, ROLE_TICKET_ADMIN, ROLE_TICKET_HOBPAS, ROLE_DISPUTE_OFFICER, ROLE_HOME_DC, ROLE_HOME_SUPERINTENDENT, ROLE_HOME_CTM, ROLE_INCENTIVE_DISBURSEMENT_HEAD, ROLE_STATE_NODAL_OFFICER"><div class="col-md-2"><strong class="pull-right" style="padding-right:10px"><i>From</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_fromdate" type="text" class="form-control" name="fromdate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-model="vm.fromdate" is-open="vm.datePickerOpenStatus.fromdate" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><strong class="pull-right" style="padding-right:10px"><i>To</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_todate" type="text" class="form-control" name="todate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-model="vm.todate" is-open="vm.datePickerOpenStatus.todate" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-2"><button ng-show="vm.show" id="download-btn" ng-disabled="vm.fromdate==null || vm.todate==null" ng-click="vm.download(vm.status)" type="button" class="btn btn-primary btn-sm">Download Excel&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-2"><button ng-show="vm.show" id="download-btn-csv" ng-disabled="vm.fromdate==null || vm.todate==null" ng-click="vm.downloadPdf(vm.status)" type="button" class="btn btn-primary btn-sm">Download PDF&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><br></div><!--                <div class="col-md-1 pull-right" style="margin-right: 7%;">--><!--                    <button ng-show="vm.show" id="download-btn" ng-click="vm.download(vm.status)" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button>--><!--                </div>--><!--&lt;!&ndash;                --></div><div ng-if="vm.spiner" class="loader"></div><div class="panel-body table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><!--<th>#</th>--><th>CAF Pin (Composite Application Form)</th><th>Service Name</th><!--                        <th>Business Entity</th>--><th>District</th><th>Department</th><th>Investor Name</th><th ng-show="vm.isAuthenticated()">Investor Contact</th><th ng-show="vm.isAuthenticated()">Investor Email</th><th>Project Level</th><th>Proposed Employment</th><th>Proposed Investment(in crore)</th><th>Pending At</th><th ng-show="vm.status==\'Pending\'">Land Zone Use Type</th><th ng-show="vm.status==\'Pending\'">Ageing</th><th>Applied Date</th><th ng-show="vm.status==\'Cleared\'  || vm.status==\'Rejected\'">Completion Date</th><th>Address</th><th ng-show="vm.status==\'DeemedCleared\'">Deemed Cleared Date</th></tr></thead><tbody><tr dir-paginate="caf in vm.psTowerDashboard.content | orderBy: \'-projectlevel\' | orderBy: \'-clearedDate\'| itemsPerPage: pageSize" total-items="vm.psTowerDashboard.totalElements" current-page="currentPage"><!--<td>{{$index +1}}</td>--><td>{{caf.cafpin}}</td><td>{{caf.serviceName}}</td><!--                        <td>{{caf.businessEntity}}</td>--><td>{{caf.district}}</td><td>{{caf.departmentName}}</td><td>{{caf.investorName}}</td><td ng-show="vm.isAuthenticated()">{{caf.investorMobilenumber}}</td><td ng-show="vm.isAuthenticated()">{{caf.investorEmail}}</td><td>{{caf.projectLevel=="d" ? "DLCC" : "EEC"}}</td><td>{{caf.proposedEmployment}}</td><td>{{caf.proposedInvestment}}</td><td>{{caf.pendingAt}}</td><td ng-show="vm.status==\'Pending\'">{{caf.landZoneUseType}}</td><td ng-show="vm.status==\'Pending\'">{{caf.ageing>200 ? "NA" : caf.ageing}}</td><td>{{caf.formFilledOn==null ? "NA" : caf.formFilledOn | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'Rejected\'">{{caf.clearedDate==null ? "NA" : caf.clearedDate | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'TotalCleared\'">{{caf.clearedDate | date:\'dd-MM-yyyy\'}}</td><td>{{caf.investorAddress}}</td><td ng-show="vm.status==\'DeemedCleared\'">{{caf.deemedClearedDate}}</td></tr></tbody></table><!-- Pager --><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><!--                    <dir-pagination-controls on-page-change="pageChanged(newPageNumber)"></dir-pagination-controls>--><dir-pagination-controls boundary-links="true" on-page-change="pageChanged(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/psTowerDashboard/pstowerdashboard.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">CCIP Dashboard</h1><p><span class="text-danger">*</span> Data of services applied after 01-April-2018</p></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>CCIP Dashboard</span></li></ol></div></section><br><div class="container-fluid"><div class="row"><h5 class="pull-right text-danger" style="padding-right:2px">*Dashboard is getting updated on real time basis</h5><div class="col-md-12"><ul class="nav nav-pills"><li class="active"><a ui-sref="psTowerDashboard({status:\'Applied\'})">Total Applied Services<span class="badge">{{vm.totalappliedservices}}</span></a></li><li class="active"><a ui-sref="psTowerDashboard({status:\'Pending\'})">Total Pending Services<span class="badge">{{vm.totalpendingservices}}</span></a></li><li class="active"><a ui-sref="psTowerDashboard({status:\'Cleared\'})">Total Cleared Services<span class="badge">{{vm.totalcompletedservices}}</span></a></li><li class="active"><a ui-sref="psTowerDashboard({status:\'Declined\'})">Total Rejected Services<span class="badge">{{vm.totalrejectedservices}}</span></a></li><li class="active"><a ui-sref="psTowerDashboard({status:\'DeemedCleared\'})">Total Deemed Services<span class="badge">{{vm.totaldeemedclearedservices}}</span></a></li><li has-any-authority="ROLE_ACS" class="active"><a ui-sref="psTowerDashboard({status:\'Withdraw\'})">Total Withdraw Services<span class="badge">{{vm.totalWithdrawServices}}</span></a></li><!--                <li class="active"><a ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Applied Services<span class="badge">{{vm.totalappliedservices}}</span></a></li>--><!--                <li class="active"><a ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Pending Services<span class="badge">{{vm.totalpendingservices}}</span></a></li>--><!--                <li class="active"><a ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Cleared Services<span class="badge">{{vm.totalcompletedservices}}</span></a></li>--><!--                <li class="active"><a ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Rejected Services<span class="badge">{{vm.totalrejectedservices}}</span></a></li>--></ul></div></div></div><div><div class="row" style="padding: 12px" ng-if="vm.deptservicedashboard"><div class="col-md-1 filter-margin"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div><div class="col-md-3"><select class="custom-select form-control" ng-model="vm.filter.departmentName"><option value="" disabled="disabled">All Department</option><option value="{{department.departmentname}}" ng-repeat="department in vm.departments">{{department.departmentname}}</option></select></div><div class="col-md-2"><select class="custom-select form-control" ng-model="vm.filter.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy:\'districtname\'"><option value="" disabled="disabled">All Districts</option><option value="district.districtname">{{district.districtname}}</option></select></div><button class="btn btn-primary" ng-click="vm.FilterWiseDat()">Filter</button> <button ng-if="vm.hideClear" class="btn btn-primary" ng-click="vm.clearFilter()">Clear</button></div></div><!--<p ng-if="vm.deptservicedashboard" class="pull-right text-danger" style="padding-right:2px;">*Mean & Median are calculated on cleared services after 01-April-2020</p>--><section class="ls section_padding_top_25 section_padding_bottom_75 columns_padding_10" id="user_section"><div class="container"><div ng-repeat="(servicename, servicedashboard_data) in vm.deptservicedashboard | groupBy: \'service_name\'  "><div class="row"><h3>{{servicename}}</h3><table class="table table_template table-striped"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-2">Department Name</th><!-- <th class="col-md-1 text-center">Required</th> --><th class="col-md-1 text-center">Applied</th><th class="col-md-5 text-center">Pending</th><th class="col-md-4 text-center">Completed</th></tr></thead><tbody><tr class="headerGrid row gradient_bg_color2"><td class="col-md-2 text-center"></td><!-- <td class="col-md-1 text-center"></td> --><td class="col-md-1 text-center"></td><td class="col-md-4 text-center" style="padding:0;margin:0"><div class="col-md-2">Total</div><div class="col-md-2">> 30 days</div><div class="col-md-2">> 45 days</div><div class="col-md-2">> 60 days</div></td><td class="col-md-5 text-center" style="padding:0;margin:0"><span class="col-md-2">Cleared</span> <span class="col-md-2">De-activated</span> <span class="col-md-2">Deemed Cleared</span> <span class="col-md-2">Rejected</span></td></tr><tr class="row" ng-repeat="servicedashboard in servicedashboard_data | orderBy: \'departmentorder\'"><td class="col-md-2">{{servicedashboard.department_name}}</td><!-- <td class="col-md-1 text-center">\n                        <div class="col-md-12">\n                            <a ui-sref="servicedashboardyearlycafs({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Required\'})"><span class="badge">{{servicedashboard.required}}</span></a>\n                        </div>\n                    </td> --><td class="col-md-1 text-center"><div class="col-md-12"><a ui-sref="pstowerdashboardcafs({departmentName:servicedashboard.department_name,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Applied\'})"><span>{{servicedashboard.applied}}</span></a></div></td><td class="col-md-4 text-center"><div class="col-md-2"><a ui-sref="pstowerdashboardcafs({departmentName:servicedashboard.department_name,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending\'})"><span ng-if="servicedashboard.pending_total < 0">{{ -servicedashboard.pending_total }}</span> <span ng-if="servicedashboard.pending_total >= 0">{{ servicedashboard.pending_total }}</span></a></div><div class="col-md-2"><a ui-sref="pstowerdashboardcafs({departmentName:servicedashboard.department_name,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending30\'})"><span ng-if="servicedashboard.pending_30days < 0">{{ -servicedashboard.pending_30days }}</span> <span ng-if="servicedashboard.pending_30days >= 0">{{ servicedashboard.pending_30days }}</span></a></div><div class="col-md-2"><a ui-sref="pstowerdashboardcafs({departmentName:servicedashboard.department_name,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending45\'})"><span ng-if="servicedashboard.pending_45days < 0">{{ -servicedashboard.pending_45days }}</span> <span ng-if="servicedashboard.pending_45days >= 0">{{ servicedashboard.pending_45days }}</span></a></div><div class="col-md-2"><a ui-sref="pstowerdashboardcafs({departmentName:servicedashboard.department_name,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending60\'})"><span ng-if="servicedashboard.pending_60days < 0">{{ -servicedashboard.pending_60days }}</span> <span ng-if="servicedashboard.pending_60days >= 0">{{ servicedashboard.pending_60days }}</span></a></div></td><td class="col-md-5 text-center"><div class="col-md-2"><a ui-sref="pstowerdashboardcafs({departmentName:servicedashboard.department_name,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Cleared\'})"><span>{{servicedashboard.cleared}}</span></a></div><div class="col-md-2"><a ui-sref="pstowerdashboardcafs({departmentName:servicedashboard.department_name,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Rejected\'})"><span>{{servicedashboard.deactivated}}</span></a></div><div class="col-md-2"><a ui-sref="pstowerdashboardcafs({departmentName:servicedashboard.department_name,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'DeemedCleared\'})"><span>{{servicedashboard.deemed_cleared}}</span></a></div><div class="col-md-2"><a ui-sref="pstowerdashboardcafs({departmentName:servicedashboard.department_name,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Declined\'})"><span>{{servicedashboard.rejected}}</span></a></div></td></tr></tbody></table></div></div></div></section><!--<div class="text-center" style="margin-bottom: 10%;margin-top: 10%">--><!--    <div>--><!--        <p style="font-size: large"><b>Sorry for the inconvenience but we&rsquo;re performing some maintenance at this page.</b></p>--><!--    </div>--><!--</div>-->');
$templateCache.put('app/psTowerDashboard/pstowerserviceview.html','<style>.loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        animation: spin 2s linear infinite;\n    }\n\n    @keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n    }</style><form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-9"><h4 class="modal-title text-warning bold" id="myBlockLabel">{{vm.servicename}}</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div><div class="row col-md-12"><div class="col-md-3"><strong class=""><i>From Date</i></strong><div class="input-group"><input id="field_fromdate" type="text" class="form-control" name="fromdate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-change="vm.selectedDate(vm.fromdate)" ng-model="vm.fromdate" is-open="vm.datePickerOpenStatus.fromdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-3"><strong class=""><i>To Date</i></strong><div class="input-group"><input id="field_todate" type="text" class="form-control" name="todate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-model="vm.todate" is-open="vm.datePickerOpenStatus.todate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-2"><br><button class="btn btn-primary btn-sm" ng-click="vm.loadAllCafsByDate()">Filter</button></div><div class="col-md-2"><br><button ng-if="vm.hideClear" class="btn btn-primary btn-sm" ng-click="vm.clearFilter()">Clear</button></div><div has-any-authority="ROLE_ADMIN, ROLE_NODAL_OFFICER, ROLE_TOWER_DC, ROLE_TOWER_MONITORING_OFFICER, ROLE_RM, ROLE_SUB_ADMIN, ROLE_DESK_OFFICER, ROLE_ACCOUNT_OFFICER, ROLE_FIELD_OFFICER, ROLE_ASSIGNRM_OFFICER, ROLE_MONITORING_OFFICER, ROLE_HEPC_MONITORING_OFFICER, ROLE_GRIEVANCE_OFFICER, ROLE_GRIEVANCE_ADMIN, ROLE_TOWER_DIO,\n                                ROLE_DEPT_CHANGE, ROLE_L1_SUPPORT, ROLE_TICKET_NODAL_OFFICER, ROLE_L2_DEPARTMENT_HEAD, ROLE_TICKET_OPERATION_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_INCENTIVES, ROLE_TICKET_ADMIN, ROLE_TICKET_HOBPAS, ROLE_DISPUTE_OFFICER, ROLE_HOME_DC, ROLE_HOME_SUPERINTENDENT, ROLE_HOME_CTM, ROLE_INCENTIVE_DISBURSEMENT_HEAD, ROLE_STATE_NODAL_OFFICER"><button ng-show="vm.show" class="btn btn-sm pull-right" style="margin-right: 10px" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download &nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><!--                            <div class="col-md-2">--><!--                                <button ng-show="vm.show" id="download-btn" ng-click="vm.downloadAllData()" type="button" class="btn btn-primary btn-sm" >Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button>--><!--                            </div>--></div></div><!--                <div>--><!--                </div>--><!--                    <div class="col-md-2">--><!--                        <button ng-show="vm.show" id="download-btn" ng-click="vm.downloadAllData()" type="button" class="btn btn-primary btn-sm" >Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button>--><!--                    </div>--><!--                    <div class="col-md-1 pull-right">--><!--                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button>--><!--                    </div>--></div><div ng-if="vm.spiner" class="loader"></div><div class="row"><div class="text-center"><h5 class="modal-title" ng-show="vm.status==\'All\'"><b>All CAFs with this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending\'"><b>All Pending CAFs against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending30\'"><b>CAFs pending for more than 30 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending45\'"><b>CAFs pending for more than 45 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending60\'"><b>CAFs pending for more than 60 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending75\'"><b>CAFs pending for more than 75 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'RTSdays\'"><b>CAFs pending for more than RTS days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Cleared\'"><b>CAFs Cleared against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Rejected\'"><b>Service Deactivated for the following CAFs</b></h5><h5 class="modal-title" ng-show="vm.status==\'DeemedCleared\'"><b>Service Deemed Cleared for the following CAFs</b></h5></div></div></div><div class="panel-body"><!--<h5 class="pull-left" ng-show="vm.status==\'Cleared\'">Average Clearance Time :<strong >{{" "}}{{vm.averageTime.toString()==\'NaN\'?"NA": vm.averageTime + \' days\'}}</strong> </h5>--><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>Id</span></th><th><span>CAF Pin (Composite Application Form)</span></th><!--                            <th><span>Business Entity</span></th>--><th><span>District</span></th><th><span>Project Level</span></th><th><span>Proposed Employment</span></th><th><span>Proposed Investment(in crore)</span></th><th><span>SLA</span></th><th ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'RTSdays\'"><span>Pending At</span></th><th ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">Applied Date</th><th ng-show="vm.status==\'Cleared\'">Cleared Date</th><th ng-show="vm.status==\'Declined\'">Rejected Date</th><th ng-if="vm.status==\'DeemedCleared\'">Deemed Cleared Date</th><th ng-if="vm.status==\'Rejected\'">De-Activated Date</th></tr></thead><tbody><tr dir-paginate="caf in vm.dashboardcafs.content | orderBy:\'-ageing\' | orderBy: \'-clearedDate\' | itemsPerPage: pageSize" total-items="vm.dashboardcafs.totalElements" current-page="currentPage"><td>{{$index +1}}</td><td>{{caf.id}}</td><td>{{caf.cafpin}}</td><!--                            <td>{{caf.businessEntity}}</td>--><td>{{caf.district}}</td><td>{{caf.projectLevel=="d" ? "DLCC" : "EEC"}}</td><!--<td>--><!--<div class="dropdown">--><!--<button ng-show="vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\'" class="btn btn-sm btn-info dropdown-toggle" ng-click="vm.showDepartments(caf)"--><!--data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">View--><!--<span class="caret"></span></button>--><!--<ul class="dropdown-menu dropdown-menu-left" aria-labelledby="dLabel">--><!--<li ng-repeat="dept in vm.departmentName"><a>{{dept}}</a></li>--><!--</ul>--><!--</div>--><!--</td>--><td>{{caf.proposedEmployment}}</td><td>{{caf.proposedInvestment}}</td><td>{{caf.sladays}}</td><td ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'RTSdays\'">{{caf.pendingAt}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">{{(caf.appliedDate==null ? "NA" : caf.appliedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\'">{{(caf.clearedDate==null ? "NA" :caf.clearedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Declined\'">{{(caf.rejectionDate==null ? "NA" :caf.rejectionDate) | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.status==\'DeemedCleared\'">{{(caf.statusDate==null ? "NA" :caf.statusDate) | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.status==\'Rejected\'">{{(caf.statusDate==null ? "NA" :caf.statusDate) | date:\'dd-MM-yyyy\'}}</td></tr></tbody></table><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/publicFeedback/publicFeedback.html','<style>body {\n            background-color: #f8f9fa;\n        }\n        .table thead {\n            background-color: #0d6efd;\n            color: white;\n        }\n        .table td, .table th {\n            vertical-align: top;\n        }\n        .page-title {\n            color: #0d6efd;\n            margin-top: 30px;\n            font-weight: 600;\n            text-align: center;\n        }\n        .note {\n            font-style: italic;\n            color: #6c757d;\n        }</style><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Public Feedback \u2013 Draft Regulations</h1><!--                    <p><span class="text-danger">*</span> Data of services applied after 01-April-2018</p>--></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li class="active"><span>Public Feedback \u2013 Draft Regulations</span></li></ol></div></section><br><div class="container mt-5 mb-5"><div class="card shadow-sm"><div class="card-body"><div class="table-responsive"><table class="table table-bordered align-middle"><thead class="text-center"><tr><th>S. No</th><th>Policy Name</th><th>Download Document (PDF)</th><th>Comment/Feedback</th><th>Total no of feedbacks</th></tr></thead><tbody><tr ng-repeat="policy in vm.policyList"><td>{{$index + 1}}</td><td><strong>{{policy.policyName}}</strong></td><td><a ng-href="{{policy.pdfUrl}}" target="_blank" class="btn btn-sm btn-primary">Download</a></td><td class="text-center"><button class="btn btn-sm btn-primary" ng-click="vm.openFeedbackModal(policy.policyName)">Submit Feedback</button></td><td><a ng-click="vm.viewAllFeedback(policy.policyName)"><span class="badge badge-info ml-6" style="font-size: 16px; padding: 6px 10px">{{vm.feedbackCounts[policy.policyName] || 0}} Feedbacks</span></a></td></tr></tbody></table></div></div></div></div><!-- Feedback Modal --><div class="modal" id="feedbackModal"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><h5 class="modal-title" id="myBlockLabel">Submit Feedback for {{vm.selectedPolicy}}</h5><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><form name="feedbackForm"><div class="form-group"><label for="feedbackText">Your Comment/Feedback</label><textarea id="feedbackText" class="form-control" maxlength="200" rows="4" ng-model="vm.feedback.comment" placeholder="Enter your feedback..."></textarea></div></form></div><div class="modal-footer"><button type="button" class="btn btn-secondary" data-dismiss="modal">Cancel</button> <button type="button" class="btn btn-primary" ng-click="vm.submitFeedback()">Submit</button></div></div></div></div><div class="modal fade" id="feedbackViewModal" tabindex="-1" role="dialog" aria-labelledby="feedbackModalLabel" aria-hidden="true"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header"><h5 class="modal-title" id="feedbackModalLabel">Feedback for <strong>{{vm.selectedPolicy}}</strong></h5><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><!-- Dynamic Feedback Comments Table --><div ng-if="vm.policyFeedbacks.length > 0"><table class="table table-bordered table-striped"><thead><tr><th style="width: 60px">#</th><th>Comment / Feedback</th></tr></thead><tbody><tr ng-repeat="feedback in vm.policyFeedbacks track by $index"><td>{{$index + 1}}</td><td>{{feedback.comment}}</td></tr></tbody></table></div><!-- No Feedback Found Message --><div ng-if="!vm.policyFeedbacks || vm.policyFeedbacks.length === 0" class="text-center text-muted">No feedback yet for this policy.</div></div><div class="modal-footer"><button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/questionnaire/allclearances.html','<div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">All Approvals</h3></div><div class="panel-body"><table class="table table-striped table-hover"><thead>Pre-Establishment</thead><tbody><tr><th>#</th><th>Department</th><!--<th>Stage</th>--><th>Service</th></tr><tr class="info" ng-repeat="n in vm.answerspreestablish"><td></td><td>{{n.department}}</td><!--<td>{{n.stage}}</td>--><td><a ui-sref="{{n.url}}">{{n.clearance}}</a></td></tr></tbody></table><table class="table table-striped table-hover"><thead>Pre-Operational</thead><tbody><tr><th>#</th><th>Department</th><!--<th>Stage</th>--><th>Service</th></tr><tr class="info" ng-repeat="n in vm.answerspreoperational"><td></td><td>{{n.department}}</td><!--<td>{{n.stage}}</td>--><td><a ui-sref="{{n.url}}">{{n.clearance}}</a></td></tr></tbody></table><table class="table table-striped table-hover"><thead>Post-Establishment</thead><tbody><tr><th>#</th><th>Department</th><!--<th>Stage</th>--><th>Service</th></tr><tr class="info" ng-repeat="n in vm.answerspostestablish"><td></td><td>{{n.department}}</td><!--<td>{{n.stage}}</td>--><td><a ui-sref="{{n.url}}">{{n.clearance}}</a></td></tr></tbody></table></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><button type="submit" class="btn btn-primary pull-right" ui-sref="Questionnaire">Back</button><!--<button type="submit" class="btn btn-warning pull-right" ng-click="owner()" ui-sref="clearances({questionnaire:vm.questionnaire})">Show My Clearances >></button>--></div></div></div></div>');
$templateCache.put('app/questionnaire/clearances.html','<div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Approval List</h3></div><div class="panel-body"><table class="table table-striped table-hover"><thead><tr><th>#</th><th>Department</th><!--<th>Stage</th>--><th>Service</th></tr></thead><tbody><tr class="info" ng-repeat="n in vm.answers"><td></td><td>{{n.department}}</td><!--<td>{{n.stage}}</td>--><td><a ui-sref="{{n.url}}">{{n.clearance}}</a></td></tr><!--<tr class="info">--><!--<td></td>--><!--<td>Fire Department</td>--><!--<td><a ui-sref="table33">NOC for fire service</a></td>--><!--</tr>--><!--<tr class="info">--><!--<td></td>--><!--<td>Forest Department</td>--><!--<td><a ui-sref="page26">Forest clearance for approach public entry/exit and diversion of forest land-under Forest Conservation Act,1980</a></td>--><!--</tr>--><!--<tr class="info">--><!--<td></td>--><!--<td>Labour department</td>--><!--<td><a ui-sref="table45">Approval of factory plan under the Factories Act, 1948</a></td>--><!--</tr>--><!--<tr class="info">--><!--<td></td>--><!--<td>Labour department</td>--><!--<td><a ui-sref="factlicense">Factory registration/ license under Factories Act, 1948-Safety Wing</a></td>--><!--</tr>--><!--<tr class="info">--><!--<td></td>--><!--<td>Excie & taxatation</td>--><!--<td><a ui-sref="page25">GST/CST/VAT registration</a> </td>--><!--</tr>--></tbody></table></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><button type="submit" class="btn btn-primary pull-right" ui-sref="Questionnaire">Back</button><!--<button type="submit" class="btn btn-warning pull-right" ng-click="owner()" ui-sref="clearances({questionnaire:vm.questionnaire})">Show My Clearances >></button>--></div></div></div></div>');
$templateCache.put('app/questionnaire/questionnaire.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Know Your Approval</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Know Your Approval</span></li></ol></div></section><br><div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Know Your Approval</h3></div><div class="panel-body"><h6 class="text-danger">* The list of approvals is comprehensive and as per the details provided by the user.</h6><h5>Please fill the detail to know the list of approval you require for setting up an industry in haryana.<button type="submit" class="btn btn-warning pull-right" ui-sref="allclearances">View All Approvals</button></h5><form class="form-horizontal"><div class="col-md-12"><p class="gradient_bg_color1 heading_padding_10" style="font-weight:bold; width:100%">A. Enterprises</p></div><div class="form-group"><label class="col-sm-1 control-label pull-left">1.</label><label class="col-lg-3 control-label pull-left">Please select the stage of your proposed business activities</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.typeofestablishment"><option value="Pre-Establishment">Pre-Establishment</option><option value="Post-Establishment">Post-Establishment</option><option value="Pre-Operational">Pre-Operational</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">2.</label><label class="col-lg-3 control-label pull-">Type of Industry</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.typeofoperation"><option value="Manufacturing">Manufacturing</option><option value="Service Business">Service Business</option><option value="Trade Business">Trade Business</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">3.</label><label class="col-lg-3 control-label pull-left">Investment(in Crores)</label><div class="col-lg-6"><input type="text" class="form-control" placeholder="0.00" ng-model="vm.questionnaire.investment"></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">4.</label><label class="col-lg-3 control-label pull-left">Size of Firm</label><div class="col-lg-6"><select name="sizeOfFirm" class="form-control" ng-model="vm.questionnaire.sizeOfFirm" required><option value="" disabled="disabled" selected="selected">Select Size Of Firm</option><option value="Small - more than 25 lakhs and less than or upto 5 crores">Small - more than 25 lakhs and less than or upto 5 crores</option><option value="Micro - upto 25 lakhs">Micro - upto 25 lakhs</option><option value="Medium - more than 5 crores and less than or upto 10 crores">Medium - more than 5 crores and less than or upto 10 crores</option><option value="Large - more than 10 crores and less than or upto 100 crores">Large - more than 10 crores and less than or upto 100 crores</option><option value="Mega - more than 100 crores">Mega - more than 100 crores</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">5.</label><label class="col-lg-3 control-label pull-left">Business Location</label><div class="col-lg-6"><select class="form-control" ng-options="district.districtname as district.districtname for district in vm.districts" ng-model="vm.questionnaire.district"><option value="">Select</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">6.</label><label class="col-lg-3 control-label pull-left">Type of Ownership</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.typeofownership"><option value="Proprietary">Proprietary</option><option value="Public">Public</option><option value="Private Ltd">Private Ltd</option><option value="Partnership">Partnership</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">7.</label><label class="col-lg-3 control-label pull-left">Investor Type</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.investorType"><option selected="selected" value="Domestic">Domestic</option><option value="Foreign">Foreign</option></select></div></div><div class="col-md-12"><p class="gradient_bg_color1 heading_padding_10" style="font-weight:bold; width:100%">B. Sector</p></div><div class="form-group"><label class="col-sm-1 control-label pull-left">8.</label><label class="col-lg-3 control-label pull-left">Sector</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.sector"><option>Auto or Auto component or Light Engineering</option><option>Agro based,Food processing,Allied industry</option><option>Textile or Apparel or kinitting or Embroidry or Technical textile</option><option>Footwear & accessories</option><option>Electronics or IT or ITES</option><option>Defence & Aerospace manufacturing</option><option>Renewable Energy & Solar Park</option><option>Pharmaceutical Industry</option><option>Chemical Industry</option><option>Others</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">9.</label><label class="col-lg-3 control-label pull-left">Product/Activity</label><div class="col-lg-6"><input type="text" class="form-control" id="inputEmail" placeholder="Product/Activity" ng-model="vm.questionnaire.product"></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">10.</label><label class="col-lg-3 control-label pull-left">Risk Category</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.category"><option>Red</option><option>Orange</option><option>Green</option><option>White</option></select></div><div class="col-lg-2"><a target="_blank" href="http://hspcb.gov.in/14.7.16.pdf"><span class="label label-info">View Notification</span></a></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">11.</label><label class="col-lg-3 control-label pull-left">ODOP Product</label><div class="col-lg-2">Yes <input type="radio" ng-model="vm.questionnaire.odop" name="odop" value="Yes" class="form-check-input form-check-sm"> No <input type="radio" ng-model="vm.questionnaire.odop" name="odop" value="No" class="form-check-input form-check-sm"></div></div><div class="col-md-12"><p class="gradient_bg_color1 heading_padding_10" style="font-weight:bold; width:100%">C. Land</p></div><div class="form-group"><label class="col-sm-1 control-label pull-left">12.</label><label class="col-lg-3 control-label pull-left">Nature/Type of land</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.natureofland"><option>Industrial</option><option>Within Controlled Area & Urban Area</option><option>With in MC Limit</option><option>Under Controlled area & within extended Mc limit</option><option>Under Controlled area & outside extended Mc limit</option><option>Outside MC limit & beyond controlled area</option><option>Outside controlled area & urban area</option><option>Forest land</option></select></div></div><div class="col-md-12"><p class="gradient_bg_color1 heading_padding_10" style="font-weight:bold; width:100%">D. Utilities</p></div><div class="form-group"><label class="col-sm-1 control-label pull-left">13.</label><label class="col-lg-3 control-label">Source of Water</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.sourceofwater"><option>Ground Water</option><option>Municiple Corporation</option><option>River & Public Tank</option><option>Urban water supply</option><option>HSIIDC</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">14.</label><label class="col-lg-3 control-label">Electricity Connection For Establishment</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.electrictype"><option>Temporary Connection</option><option>Permanent Connection</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">15.</label><label class="col-lg-3 control-label pull-left">Load Required(in KVA)</label><div class="col-lg-6"><input type="text" class="form-control" placeholder="0.00" ng-model="vm.questionnaire.loadrequired"></div></div><div class="col-md-12"><p class="gradient_bg_color1 heading_padding_10" style="font-weight:bold; width:100%">E. Employment</p></div><div class="form-group"><label class="col-sm-1 control-label pull-left">16.</label><label class="col-lg-3 control-label pull-left">Total number of employees</label><div class="col-lg-6"><input type="number" class="form-control" placeholder="0" ng-model="vm.questionnaire.totalworker"></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">17.</label><label class="col-lg-3 control-label pull-left">Will Inter State migrant worker(s) be employed</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.migrantworker"><option>Yes</option><option>No</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">18.</label><label class="col-lg-3 control-label pull-left">Will the worker(s) be employed through contractor</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.contractworker"><option>Yes</option><option>No</option></select></div></div><div class="col-md-12"><p class="gradient_bg_color1 heading_padding_10" style="font-weight:bold; width:100%">F. Other Services</p></div><div class="form-group"><label class="col-sm-1 control-label pull-left">19.</label><label class="col-lg-3 control-label pull-left">Waste handling type</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.hazardouswaste"><option>hazardous waste</option><option>bio-medical waste</option><option>E-waste</option><option>municipal solid waste</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">20.</label><label class="col-lg-3 control-label pull-left">Medicine manufacturing category</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.involveallopathic"><option>Allopathic medicine</option><option>Ayurvedic medicine</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">21.</label><label class="col-lg-3 control-label pull-left">Manufacturing of pesticide/fertilizer</label><div class="col-lg-6"><select class="form-control" ng-model="vm.questionnaire.involvepesticides"><option>Pesticide or Insecticide</option><option>Fertilizer</option></select></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">22.</label><label class="col-lg-8 control-label">Do you require to purchase land in HSIIDC Industrial Estate?</label><div class="checkbox col-lg-2"><label><input type="checkbox" ng-model="vm.questionnaire.purchaseland"> Yes</label></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">23.</label><label class="col-lg-8 control-label">Will you be operating boiler(s)?</label><div class="checkbox col-lg-2"><label><input type="checkbox" ng-model="vm.questionnaire.operatingboilers"> Yes</label></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">24.</label><label class="col-lg-8 control-label">Do you need license for Motor Transport Workers Act, 1961?</label><div class="checkbox col-lg-2"><label><input type="checkbox" ng-model="vm.questionnaire.motortransport"> Yes</label></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">25.</label><label class="col-lg-8 control-label">Do you need Lubricating License</label><div class="checkbox col-lg-2"><label><input type="checkbox" ng-model="vm.questionnaire.lubricatinglicense"> Yes</label></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">26.</label><label class="col-lg-8 control-label">Whether any Shop/ Commercial Activity will be carried out in the manufacturing premises?</label><div class="checkbox col-lg-2"><label><input type="checkbox" ng-model="vm.questionnaire.commercial"> Yes</label></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">27.</label><label class="col-lg-8 control-label">will any building or construction activities be carried under the provisions of the BOCW Act?</label><div class="checkbox col-lg-2"><label><input type="checkbox" ng-model="vm.questionnaire.underbocwact"> Yes</label></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">28.</label><label class="col-lg-8 control-label">Does your Project require excavation of Brick Earth/Stone crushing</label><div class="checkbox col-lg-2"><label><input type="checkbox" ng-model="vm.questionnaire.requireexcavation"> Yes</label></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">29.</label><label class="col-lg-8 control-label">Does your project involve in generating Non-Conventional Energy/ Renewal Energy?</label><div class="checkbox col-lg-2"><label><input type="checkbox" ng-model="vm.questionnaire.involveenergy"> Yes</label></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">30.</label><label class="col-lg-8 control-label">Does land fall under Aravali notified area under Notification 1992 & 1996?</label><div class="checkbox col-lg-2"><label><input type="checkbox" ng-model="vm.questionnaire.underaravali"> Yes</label></div></div><div class="form-group"><label class="col-sm-1 control-label pull-left">31.</label><label class="col-lg-8 control-label pull-left">Is the Proposed industry/process covered under the list of industries under EIA Notification 2006?</label><div class="checkbox col-lg-2 pull-left"><label><input type="checkbox" ng-model="vm.questionnaire.undereia"> Yes</label><a target="_blank" href="http://environmentclearance.nic.in/writereaddata/EIA_notifications/2006_09_14_EIA.pdf"><span class="label label-info">View Notification</span></a></div><div></div></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><button type="submit" class="btn btn-warning pull-right" ui-sref="clearances({questionnaire:vm.questionnaire})">Show My Approvals</button></div></div></form></div></div></div>');
$templateCache.put('app/rating-summary/rating-summary.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Rating Summary</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li class="active"><span>Rating Summary</span></li></ol></div></section><br><div class="container"><div class="row"><div class="col-md-12"><table class="table table-striped table-hover" ng-switch="vm.isAuthenticated()"><thead><tr class="headerGrid"><th>S.No</th><th>Service Name</th><th>Department Name</th><th>No. of feedback providers</th><th>Rating (1-5)</th></tr></thead><tbody><tr ng-repeat="rating in vm.feedbackratings | orderBy : \'-lastUpadte\'"><td>{{$index +1}}</td><td>{{rating.serviceName}}</td><td>{{rating.departmentName}}</td><td><a ui-sref="rating-view({serviceid:rating.serviceId,departmentid:rating.departmentName})">{{rating.totalUserRating}}</a></td><td>{{rating.overallRating}}</td></tr><br></tbody></table></div></div></div>');
$templateCache.put('app/rating-summary/rating-view.html','<style>.loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        animation: spin 2s linear infinite;\n    }\n\n    @keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n    }</style><form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-9"><h4 class="modal-title text-warning bold" id="myBlockLabel">{{vm.servicename}}</h4></div><div class="col-md-2" has-any-authority="ROLE_ADMIN, ROLE_NODAL_OFFICER, ROLE_TOWER_DC, ROLE_TOWER_MONITORING_OFFICER, ROLE_RM, ROLE_SUB_ADMIN, ROLE_DESK_OFFICER, ROLE_ACCOUNT_OFFICER, ROLE_FIELD_OFFICER, ROLE_ASSIGNRM_OFFICER, ROLE_MONITORING_OFFICER, ROLE_HEPC_MONITORING_OFFICER, ROLE_GRIEVANCE_OFFICER, ROLE_GRIEVANCE_ADMIN, ROLE_TOWER_DIO,\n                        ROLE_DEPT_CHANGE, ROLE_L1_SUPPORT, ROLE_TICKET_NODAL_OFFICER, ROLE_L2_DEPARTMENT_HEAD, ROLE_TICKET_OPERATION_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_INCENTIVES, ROLE_TICKET_ADMIN, ROLE_TICKET_HOBPAS, ROLE_DISPUTE_OFFICER, ROLE_HOME_DC, ROLE_HOME_SUPERINTENDENT, ROLE_HOME_CTM, ROLE_INCENTIVE_DISBURSEMENT_HEAD, ROLE_STATE_NODAL_OFFICER"><button ng-show="vm.show" id="download-btn" ng-click="vm.downloadAllData()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div><div ng-if="vm.spiner" class="loader"></div><div class="row"><div class="text-center"><h5 class="modal-title" ng-show="vm.status==\'All\'"><b>All CAFs with this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending\'"><b>All Pending CAFs against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending30\'"><b>CAFs pending for more than 30 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending45\'"><b>CAFs pending for more than 45 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending60\'"><b>CAFs pending for more than 60 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending75\'"><b>CAFs pending for more than 75 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'RTSdays\'"><b>CAFs pending for more than RTS days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Cleared\'"><b>CAFs Cleared against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Rejected\'"><b>Service Deactivated for the following CAFs</b></h5><h5 class="modal-title" ng-show="vm.status==\'DeemedCleared\'"><b>Service Deemed Cleared for the following CAFs</b></h5></div></div></div><div class="panel-body"><div class="table-responsive"><span><b>Service Name</b> : {{vm.ratingSummaries[0].serviceName}}</span><br><span><b>Department Name</b> : {{vm.ratingSummaries[0].departmentName}}</span><table class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF PIN</span></th><th><span>Investor Rating</span></th><th><span>Comment/Remarks</span></th></tr></thead><tbody><tr ng-repeat="rating in vm.ratingSummaries"><td>{{$index + 1}}</td><td>{{rating.cafPin}}</td><!-- \u2B50 Visual rating display --><td><!-- Stars --> <span ng-repeat="n in [].constructor(\n                        rating.rating === \'Excellent\' ? 5 :\n                        rating.rating === \'Good\' ? 4 :\n                        rating.rating === \'Average\' ? 3 :\n                        rating.rating === \'Poor\' ? 2 :\n                        rating.rating === \'Very Poor\' ? 1 : 0\n                    ) track by $index"><i class="fa fa-star text-warning"></i> </span><!-- Colored badge for clarity --> <span class="badge" ng-class="{\n                            \'bg-success\': rating.rating===\'Excellent\',\n                            \'bg-primary\': rating.rating===\'Good\',\n                            \'bg-warning text-dark\': rating.rating===\'Average\',\n                            \'bg-orange text-dark\': rating.rating===\'Poor\',\n                            \'bg-danger\': rating.rating===\'Very Poor\'\n                          }">{{rating.rating}}</span></td><td>{{rating.comment}}</td></tr></tbody></table><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/reApplyDashboard/reApplyDashboard-view.html','<form name="myForm" class="form-horizontal" role="form"><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-10"><h4 class="modal-title text-warning bold" id="myBlockLabel">{{vm.serviceName}}</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div></div></div><div class="panel-body"><!--<h5 class="pull-left" ng-show="vm.status==\'Cleared\'">Average Clearance Time :<strong >{{" "}}{{vm.averageTime.toString()==\'NaN\'?"NA": vm.averageTime + \' days\'}}</strong> </h5>--><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><th><span>Business Entity</span></th><th><span>District</span></th><th><span>Project Level</span></th><th><span ng-show="vm.servicename == \'Regularization of existing Tower/Renewal (Above ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Above Ground)\'">Department</span></th><th><span ng-show="vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\'">Department\'s</span></th><th><span>Reapply Counts</span></th></tr></thead><tbody><tr ng-repeat="caf in vm.dashboardcafs | orderBy: \'-projectlevel\' | orderBy: \'-clearedDate\'"><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><td>{{caf.businessentity}}</td><td>{{caf.district}}</td><td>{{caf.projectlevel=="d" ? "DLCC" : "EEC"}}</td><td><span ng-show="vm.servicename == \'Regularization of existing Tower/Renewal (Above ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Above Ground)\'">{{caf.deptName}}</span></td><td><div class="dropdown"><button ng-show="vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\'" class="btn btn-sm btn-info dropdown-toggle" ng-click="vm.showDepartments(caf)" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">View <span class="caret"></span></button><ul class="dropdown-menu dropdown-menu-left" aria-labelledby="dLabel"><li ng-repeat="dept in vm.departmentName"><a>{{dept}}</a></li></ul></div></td><td>{{caf.mousignyear}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/reApplyDashboard/reApplyDashboard.html','<div class="container"><div ng-repeat="(departmentName, reapplydashboard_data) in vm.reApplyDashboardData | groupBy: \'departmentName\' "><div class="row"><h3>{{departmentName}} <a ui-sref="towerservicedashboard" class="pull-right" ng-show="departmentname===\'Communication and Connectivity Permissions\'" style="font-size: 18px; color: red">View Department wise Tower Service Dashboard</a></h3><table class="table table-striped table-hover table-responsive"><thead><tr class="headerGrid row"><th class="col-md-6">Service</th><th class="col-md-6 text-center bg-primary">Reapplied</th></tr></thead><tbody><tr class="success row" ng-repeat="reapplydashboard in reapplydashboard_data"><td class="col-md-9">{{reapplydashboard.serviceName}}</td><td class="col-md-3"><a ui-sref="reApplyDashboard-view({serviceid: reapplydashboard.serviceId, servicename: reapplydashboard.serviceName})">{{reapplydashboard.serviceCounter}}</a></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/rejectionReason/rejectionReasonPage.html','<div ng-cloak><div class="container"><button id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm pull-right btn-marginTop" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button><br><br><div class="row"><table id="result_table" class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>CAF Pin (Composite Application Form)</th><th>Business Entity</th><th>Department Name</th><th>Service Name</th><th>Rejection Date</th><th>Rejection Reason</th><th>Remarks</th></tr></thead><tbody><tr ng-repeat="prdtl in vm.projectlist"><td>{{$index+1}}</td><td>{{prdtl.cafPin}}</td><td>{{prdtl.businessEntity}}</td><td>{{prdtl.departmentName}}</td><td>{{prdtl.serviceName}}</td><td>{{prdtl.rejectionDate | date:\'dd-MM-yyyy\'}}</td><td>{{prdtl.rejectionReason}}</td><td>{{prdtl.comment}}</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/scheduledService/projectDetail-dialog.html','<!--modal for logs--><div class="container-fluid" ng-show="vm.status===\'service-logs\'"><div class="row"><div class="col-md-12"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><form name="logs" class="form-horizontal" role="form"><div class="row modal-header"><h4 class="modal-title">Service Log</h4><h4 class="text-center"><b>{{vm.service.serviceName}}</b></h4></div><div class="row"><div class="col-md-12"><table class="jh-table table table-striped table-responsive"><thead><tr><th><span>Action Taken</span></th><th><span>Date</span></th><th><span>Action By</span></th><th><span>Comments</span></th><th><span>Attachment</span></th></tr></thead><tbody><tr ng-repeat="servicelog in vm.ServiceLog | orderBy:\'-commentDate\'"><td>{{(servicelog.actionTaken == \'Rejected\' ? "Deactivated": (servicelog.actionTaken == \'Declined\' ? "Rejected" : (servicelog.actionTaken == \'MarkedRequired\' ? "Required" : (servicelog.actionTaken == \'ServiceFormEdited\' ? "Service Form Filled" : (servicelog.actionTaken == \'OpenComment\' ? "Comment" :servicelog.actionTaken)))))}}</td><td>{{servicelog.commentDate | date:\'dd-MM-yyyy\'}}</td><td>{{servicelog.commentByUserLogin}}</td><td class="break-line">{{(servicelog.comments == \'MarkedRequired\' ? (servicelog.comments= \'The Investor has indicated his desire for this service\') : servicelog.comments)}}</td><td><button ng-show="(servicelog.fileName) || ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))" type="button" class="btn btn-primary" ng-click="vm.downloadFile(servicelog.fileName,servicelog.actionTaken)">Download</button></td></tr></tbody></table></div></div></form><div class="row modal-footer"><button type="button" class="btn btn-default" ng-click="vm.clear()">Close</button></div></div></div></div><!--modal for viewform--><form name="viewForm" class="form-horizontal" role="form" ng-show="vm.status===\'view-form\'"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success pull-right"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><div id="pdf_data" class="panel"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">{{vm.project.departmentName}} : {{vm.project.serviceName}}</h4></div><div class="panel-body"><div ng-repeat="field in vm.serviceFormFieldData | orderBy : \'formfieldOrder\'" class="form-horizontal"><div class="row"><div class="col-sm-6"><label class="control-label pull-right">{{field.formfieldName}}</label></div><div class="col-sm-6"><p class="control-label pull-left">{{field.formfieldvalue}}</p></div></div></div><br><!--documents--><div class="col-lg-offset-2 col-lg-8"><center><table class="table table-striped table-responsive table-hover"><thead><tr><th class="col-lg-6">File Description</th><th class="col-lg-2">Action</th></tr></thead><tbody><tr ng-repeat="serviceformattachment in vm.serviceformattachments"><td>{{serviceformattachment.description}}</td><td><button type="button" class="btn btn-success pull-center btn-sm" ng-click="vm.downloadFile(serviceformattachment.serverfilename,serviceformattachment.downloadfilename)"><span class="glyphicon glyphicon-download-alt"></span></button></td></tr></tbody></table></center></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/scheduledService/scheduledList.html','<div ng-cloak><div class="container"><div class="row"><div class="pull-right"><div class="form-group"><div class="row"><div class="col-md-5 filter-margin"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div><div class="col-md-7"><select style="border: none; box-shadow: none" class="form-control" ng-model="vm.statusFilter" ng-change="vm.statusSelected(vm.statusFilter)"><option value="Pending" selected="selected">Pending</option><option value="Scheduled">Scheduled</option></select></div></div></div><!--<button type="button" class="btn btn-info btn-sm active" ng-click="vm.pending()">Pending</button>--><!--<button type="button" class="btn btn-info btn-sm" ng-click="vm.scheduled()">Scheduled</button>--></div>&nbsp;&nbsp;&nbsp;&nbsp;<!--<div class="col-sm-4 input-group pull-right">--><!--<input type="text" class="form-control" ng-model="searchText" id="searchQuery"--><!--placeholder="Search..">--><!--<span class="input-group-addon"><i class="fa fa-search"></i></span>--><!--</div>&nbsp;&nbsp;&nbsp;&nbsp;--></div><div class="col-md-12" ng-repeat="(cafpin, serviceList) in vm.scheduledList | groupBy: \'cafPin\' "><h3>CAF Pin (Composite Application Form): {{cafpin}}</h3><div><span class="input-group-btn"><button type="button" ng-show="vm.value" class="btn btn-info btn-sm" data-toggle="modal" data-target="#datetimepicker1" data-dismiss="modal" ng-click="vm.repeatValue(serviceList)">Scheduled</button></span></div><div class="row"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>Service Name</th><!--<th>Investor Name</th>--><!--<th>RM Info</th>--><!--<th>Total Project Cost</th>--><th>Department Name</th><th>Business Entity</th><th>District</th><th ng-show="!vm.value">Scheduled Date</th><th ng-show="!vm.value">Inspector Officer</th><th></th></tr></thead><tbody><tr ng-repeat="prdtl in serviceList  | filter:searchText | orderBy: \'-applicationDate\'"><td>{{$index+1}}</td><td>{{prdtl.serviceName}}</td><!--<td >{{prdtl.investorName}}</td>--><!--<td >{{prdtl.rm==\'\' ? "Not Assigned" : prdtl.rm}}</td>--><!--<td >{{prdtl.serviceName}}</td>--><td>{{prdtl.departmentName}}</td><td>{{prdtl.businessEntity}}</td><td>{{prdtl.district}}</td><td ng-show="!vm.value">{{prdtl.scheduledDate}}</td><td ng-show="!vm.value">{{prdtl.serviceName == \'NOC for Fire Service\' ? prdtl.assignedToOfficer : prdtl.assignedOfficerMail}}</td><td class="action verticalalign"><button type="button" class="btn btn-info btn-sm" ui-sref="service-action({action:\'service-logs\',projectserviceid:prdtl.id})">View Service Log</button> <button type="button" class="btn btn-info btn-sm" ui-sref="service-action({action:\'view-form\',projectserviceid:prdtl.id})">View Service Form</button></td></tr></tbody></table></div></div></div></div><div class="alert alert-warning jumbotron text-center" ng-hide="vm.scheduledList.length > 0"><b>No Service Found</b></div><div id="datetimepicker1" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content"><div class="modal-header"><h3>Scheduled Inspection</h3></div><form role="form" name="prdtl" ng-submit="vm.save()" novalidate><div class="modal-body hackyhack"><div class="col-md-12 form-group"><label>Select Scheduled Date</label><div class="row"><div class="col-md-8"><input id="field_scheduledDate" type="text" class="form-control" name="scheduledDate" uib-datepicker-popup="{{dateformat}}" datepicker-options="options" ng-model="vm.prdtl.scheduledDate" is-open="vm.datePickerOpenStatus.scheduledDate" required></div><div class="col-md-2"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'scheduledDate\')"><i class="glyphicon glyphicon-calendar"></i></button></div></div></div><div class="col-md-6 form-group"><label>Select Fire NOC</label><select ng-model="vm.prdtl.fireOfficer" class="form-control" required><option value="" disabled="disabled">--Select Fire Officer</option><option value="Ramdutt Bhardwaj">Ramdutt Bhardwaj</option></select></div><div class="col-md-6 form-group"><label>Select OC officer</label><select ng-model="vm.prdtl.ocOfficer" class="form-control" required><option value="" disabled="disabled">Select</option><option value="Robin">Robin</option><!--<option value="Veenu">Veenu</option>--></select></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="prdtl.$invalid">Save</button> <button class="btn" data-dismiss="modal">Close</button></div></form></div></div></div><style>.hackyhack {\n        position: relative;\n    }\n    .hackyhack .dropdown-menu {\n        left: 26% !important;\n    }</style>');
$templateCache.put('app/searchCAF/searchBusinessEntity.html','<div ng-cloak><div class="container"><!-- First Row: Business Entity Name + Search Button --><div class="row"><div class="col-sm-6"><label>Business Entity Name</label><div class="form-inline"><input type="text" ng-model="vm.businessEntityName" class="form-control" id="searchQuery" placeholder="Enter Business Entity Name"> <button type="submit" ng-click="vm.getByBusinessEntityName()" class="btn btn-info" has-any-authority="ROLE_ADMIN,ROLE_STATE_NODAL_OFFICER" style="margin-left: 10px">Search</button></div></div></div><br><!-- Second Row: Financial Year and Size of Industry --><div class="row"><div class="col-sm-4"><label>Financial Year</label><select ng-model="vm.financialYear" class="form-control" id="financialYear"><option value="">Choose financial year</option><option value="2018-2019">2018-2019</option><option value="2019-2020">2019-2020</option><option value="2020-2021">2020-2021</option><option value="2021-2022">2021-2022</option><option value="2022-2023">2022-2023</option><option value="2023-2024">2023-2024</option><option value="2024-2025">2024-2025</option></select></div><div class="col-sm-4"><label>Size of Industry</label><select class="form-control" ng-model="vm.size_of_industry" ng-options="si.sizeofindustry as si.sizeofindustry for si in vm.industrysizes" required><option value="" data-translate="global.addcafnew.select">Select</option></select></div><div class="col-sm-4"><label>&nbsp;</label><br><button type="submit" ng-click="vm.searchByFinancialYearOrIndustry()" class="btn btn-info" has-any-authority="ROLE_ADMIN,ROLE_STATE_NODAL_OFFICER">Search</button></div></div><!--        <div class="row" ng-show="vm.showtable">--><!--            <table class="table table-striped table-hover">--><!--                <thead>--><!--                <tr class="headerGrid">--><!--                    <th>Sr. No.</th>--><!--                    <th>Name of the Project</th>--><!--                    <th>Date of Approval of HEPB</th>--><!--                    <th>Approved under Policy</th>--><!--                    <th>District</th>--><!--                    <th>Block</th>--><!--                    <th>Proposed Investment (INR Cr)</th>--><!--                    <th>Proposed Employment</th>--><!--                    <th>Grounded Investment (Cr.)</th>--><!--                    <th>Grounded Employment (Total)</th>--><!--                    <th>Grounded Employment (Haryana Employees)</th>--><!--                    <th>Commercial Production</th>--><!--                    <th></th>--><!--                </tr>--><!--                </thead>--><!--                <tbody>--><!--                <tr>--><!--                    <td>1</td>--><!--                    <td>{{vm.project.businessentity || \'N/A\'}}</td>--><!--                    <td>{{vm.project.applicationdate ? (vm.project.applicationdate | date:\'dd-MM-yyyy\') : \'N/A\'}}</td>--><!--                    <td>{{vm.project.approvedPolicy || \'N/A\'}}</td>--><!--                    <td>{{vm.project.district || \'N/A\'}}</td>--><!--                    <td>{{vm.project.block || \'N/A\'}}</td>--><!--                    <td>{{vm.project.total_project_cost || \'N/A\'}}</td>--><!--                    <td>{{vm.project.totalpurposedemployment || \'N/A\'}}</td>--><!--                    <td>{{vm.project.groundedInvestment || \'N/A\'}}</td>--><!--                    <td>{{vm.project.groundedEmploymentTotal || \'N/A\'}}</td>--><!--                    <td>{{vm.project.groundedEmploymentHaryana || \'N/A\'}}</td>--><!--                    <td>{{vm.project.commercialProduction != null ? (vm.project.commercialProduction ? \'Yes\' : \'No\') : \'N/A\'}}</td>--><!--                    <td class="action verticalalign">--><!--                        <a ng-show="!vm.account.authorities.includes(\'ROLE_DEPT_CHANGE\')"--><!--                           ui-sref="projectdetailjist({projectid:vm.project.id})"--><!--                           class="btn btn-primary">Details</a>--><!--                        <a ng-if="vm.project.caftype === \'Tower\'"--><!--                           ui-sref="projectdetailjist({projectid:vm.project.id})"--><!--                           class="btn btn-primary">Details</a>--><!--                    </td>--><!--                </tr>--><!--                </tbody>--><!--            </table>--><!--        </div>--></div></div>');
$templateCache.put('app/searchCAF/searchCAF.html','<div ng-cloak><div class="container"><div class="row"><div class="col-sm-4"><input type="text" ng-model="vm.CAFPIN" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Enter CAF PIN (Composite Application Form) or Project ID"><br><span style="color: red">Note: Please add 0 as a prefix to make CAF (Composite Application Form) 10 digit</span></div><div class="btn-group col-sm-4"><button type="submit" ng-click="vm.getProject()" class="btn btn-info" has-any-authority="ROLE_USER, ROLE_ADMIN, ROLE_SUB_ADMIN, ROLE_MONITORING_OFFICER, ROLE_HEPC_MONITORING_OFFICER, ROLE_DESK_OFFICER,ROLE_DEPT_CHANGE,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD, ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_NODAL_OFFICER,ROLE_TICKET_ADMIN">Search</button></div></div><div class="row" ng-show="vm.showtable"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>CAF Pin (Composite Application Form)</th><!--<th>Investor Name</th>--><th>RM Info (Relationship Manager)</th><th>Total Project Cost</th><th>Proposed Employment</th><th>Business Entity</th><th>District</th><th>Project Level</th><th>Project ID</th><th>Caf Type</th><th></th></tr></thead><tbody><tr><td>{{vm.project.cafpin}}</td><!--<td >{{prdtl.investorName}}</td>--><td>{{vm.project.rm==\'\' ? "Not Assigned" : vm.project.rm}}</td><td>{{vm.project.projectTotalCost}}</td><td>{{vm.project.totalEmployement}}</td><td>{{vm.project.buisnessEntity}}</td><td>{{vm.project.district}}</td><td>{{vm.project.projectlevel==\'e\' ? "EEC" : "DLCC"}}</td><td>{{vm.project.projectid}}</td><td>{{vm.project.caftype}}</td><td class="action verticalalign"><a ng-show="!vm.account.authorities.includes(\'ROLE_DEPT_CHANGE\')" ui-sref="projectdetailjist({projectid:vm.project.projectid})" class="btn btn-primary">Details</a> <a ng-show="vm.account.authorities.includes(\'ROLE_DEPT_CHANGE\')" ng-if="vm.project.caftype === \'Tower\'" ui-sref="projectdetailjist({projectid:vm.project.projectid})" class="btn btn-primary">Details</a></td></tr></tbody></table></div><!--<div ng-show="!vm.showtable">--><!--No Projects Right Now.--><!--</div>--></div></div><br><br><br>');
$templateCache.put('app/serviceclearanceactions/ULBlandexchange-detail.html','<div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success pull-right"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><form id="myForm" name="myForm" class="form-horizontal" role="form"><div id="pdf_data" class="panel"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">Exchange of land for industrial and residential colonies</h4></div><div class="panel-body"><div class="col-md-12"><dl class="row jh-entity-details"><div class="col-md-6"><h4 class="text-center bg-danger">Applicant details</h4><dt><span data-translate="investhryApp.landexchange.investor_name">Investor Name</span></dt><dd><span>{{vm.landexchange.investor_name}}</span></dd><dt><span data-translate="investhryApp.landexchange.address">Address</span></dt><dd><span>{{vm.landexchange.address}}</span></dd><dt><span data-translate="investhryApp.landexchange.contact">Contact</span></dt><dd><span>{{vm.landexchange.contact}}</span></dd><dt><span data-translate="investhryApp.landexchange.email">Email</span></dt><dd><span>{{vm.landexchange.email}}</span></dd><h4 class="text-center bg-danger">Reason</h4><dt><span data-translate="investhryApp.landexchange.reason">Reason</span></dt><dd><span>{{vm.landexchange.reason}}</span></dd><h4 class="text-center bg-danger">Documents Uploaded</h4><table class="table table-striped table-responsive table-hover"><thead><tr><th class="col-lg-6">File Description</th><th class="col-lg-2">Action</th></tr></thead><tbody><tr ng-repeat="serviceformattachment in vm.serviceformattachments"><td>{{serviceformattachment.description}}</td><td><button type="button" class="btn btn-success pull-center btn-sm" ng-click="vm.downloadFile(serviceformattachment.serverfilename,serviceformattachment.downloadfilename)"><span class="glyphicon glyphicon-download-alt"></span></button></td></tr></tbody></table></div><div class="col-md-6"><h4 class="text-center bg-danger">Details of land required</h4><dt><span>Municipality</span></dt><dd><span>{{vm.landexchange.name_of_gramPanchayat}}</span></dd><dt><span data-translate="investhryApp.landexchange.district">District</span></dt><dd><span>{{vm.landexchange.district}}</span></dd><dt><span data-translate="investhryApp.landexchange.village">Village</span></dt><dd><span>{{vm.landexchange.village}}</span></dd><dt><span data-translate="investhryApp.landexchange.khasra">Khasra</span></dt><dd><span>{{vm.landexchange.khasra}}</span></dd><dt><span data-translate="investhryApp.landexchange.area_of_land">Area Of Land</span></dt><dd><span>{{vm.landexchange.area_of_land}}</span></dd><dt><span data-translate="investhryApp.landexchange.market_value">Market Value</span></dt><dd><span>{{vm.landexchange.market_value}}</span></dd><h4 class="text-center bg-danger">Details of land offered</h4><dt><span data-translate="investhryApp.landexchange.owner_name_offered">Owner Name Offered</span></dt><dd><span>{{vm.landexchange.owner_name_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.district_offered">District Offered</span></dt><dd><span>{{vm.landexchange.district_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.village_offered">Village Offered</span></dt><dd><span>{{vm.landexchange.village_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.khasra_offered">Khasra Offered</span></dt><dd><span>{{vm.landexchange.khasra_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.area_of_land_offered">Area Of Land Offered</span></dt><dd><span>{{vm.landexchange.area_of_land_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.market_value_offered">Market Value Offered</span></dt><dd><span>{{vm.landexchange.market_value_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.dimension_of_site">Dimension Of Site</span></dt><dd><span>{{vm.landexchange.dimension_of_site}}</span></dd><dt><span data-translate="investhryApp.landexchange.location_of_site">Location Of Site</span></dt><dd><span>{{vm.landexchange.location_of_site}}</span></dd></div><!--<dt><span data-translate="investhryApp.landexchange.type_of_land">Type Of Land</span></dt>--><!--<dd>--><!--<span>{{vm.landexchange.type_of_land}}</span>--><!--</dd>--><!----><!--<dt><span data-translate="investhryApp.landexchange.type_of_land_offered">Type Of Land Offered</span></dt>--><!--<dd>--><!--<span>{{vm.landexchange.type_of_land_offered}}</span>--><!--</dd>--></dl></div></div></div></form>');
$templateCache.put('app/serviceclearanceactions/ULBlandexchange-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLandexchangeLabel">URBAN LOCAL BODIES: Service Form</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><h4 class="text-center bg-danger">Applicant Details</h4><div class="form-group" ng-show="vm.landexchange.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.landexchange.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.investor_name" for="field_investor_name">Investor Name</label><input type="text" class="form-control" name="investor_name" id="field_investor_name" ng-model="vm.landexchange.investor_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.address" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.landexchange.address"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.contact" for="field_contact">Contact</label><input type="text" class="form-control" name="contact" id="field_contact" ng-model="vm.landexchange.contact"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.landexchange.email"></div><h4 class="text-center bg-danger">Reason for availing services</h4><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.reason" for="field_reason">Reason</label><input type="text" class="form-control" name="reason" id="field_reason" ng-model="vm.landexchange.reason"></div><h4 class="text-center bg-danger">Details of land required</h4><div class="form-group"><label class="control-label" for="field_name_of_gramPanchayat">Municipality</label><input type="text" class="form-control" name="name_of_gramPanchayat" id="field_name_of_gramPanchayat" ng-model="vm.landexchange.name_of_gramPanchayat"></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.landexchange.gramPanchayat_code" for="field_gramPanchayat_code">Gram Panchayat Code</label>--><!--<input type="text" class="form-control" name="gramPanchayat_code" id="field_gramPanchayat_code"--><!--ng-model="vm.landexchange.gramPanchayat_code"--><!--/>--><!--</div>--><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.district" for="field_district">District</label><select class="form-control" name="district" id="field_district" ng-model="vm.landexchange.district" ng-options="district.districtname as district.districtname for district in vm.districts"></select></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.landexchange.owner_name" for="field_owner_name">Owner Name</label>--><!--<input type="text" class="form-control" name="owner_name" id="field_owner_name"--><!--ng-model="vm.landexchange.owner_name"--><!--/>--><!--</div>--><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.village" for="field_village">Village</label><input type="text" class="form-control" name="village" id="field_village" ng-model="vm.landexchange.village"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.khasra" for="field_khasra">Khasra</label><input type="text" class="form-control" name="khasra" id="field_khasra" ng-model="vm.landexchange.khasra"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.type_of_land" for="field_type_of_land">Type Of Land</label><input type="text" class="form-control" name="type_of_land" id="field_type_of_land" ng-model="vm.landexchange.type_of_land"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.area_of_land" for="field_area_of_land">Area Of Land</label><input type="text" class="form-control" name="area_of_land" id="field_area_of_land" ng-model="vm.landexchange.area_of_land"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.market_value" for="field_market_value">Market Value</label><input type="text" class="form-control" name="market_value" id="field_market_value" ng-model="vm.landexchange.market_value"></div><h4 class="text-center bg-danger">Details of land offered</h4><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.owner_name_offered" for="field_owner_name_offered">Owner Name Offered</label><input type="text" class="form-control" name="owner_name_offered" id="field_owner_name_offered" ng-model="vm.landexchange.owner_name_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.district_offered" for="field_district_offered">District Offered</label><select class="form-control" name="district" id="field_district_offered" ng-model="vm.landexchange.district_offered" ng-options="district.districtname as district.districtname for district in vm.districts"></select></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.village_offered" for="field_village_offered">Village Offered</label><input type="text" class="form-control" name="village_offered" id="field_village_offered" ng-model="vm.landexchange.village_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.khasra_offered" for="field_khasra_offered">Khasra Offered</label><input type="text" class="form-control" name="khasra_offered" id="field_khasra_offered" ng-model="vm.landexchange.khasra_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.type_of_land_offered" for="field_type_of_land_offered">Type Of Land Offered</label><input type="text" class="form-control" name="type_of_land_offered" id="field_type_of_land_offered" ng-model="vm.landexchange.type_of_land_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.area_of_land_offered" for="field_area_of_land_offered">Area Of Land Offered</label><input type="text" class="form-control" name="area_of_land_offered" id="field_area_of_land_offered" ng-model="vm.landexchange.area_of_land_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.market_value_offered" for="field_market_value_offered">Market Value Offered</label><input type="text" class="form-control" name="market_value_offered" id="field_market_value_offered" ng-model="vm.landexchange.market_value_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.dimension_of_site" for="field_dimension_of_site">Dimension Of Site</label><input type="text" class="form-control" name="dimension_of_site" id="field_dimension_of_site" ng-model="vm.landexchange.dimension_of_site"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.location_of_site" for="field_location_of_site">Location Of Site</label><input type="text" class="form-control" name="location_of_site" id="field_location_of_site" ng-model="vm.landexchange.location_of_site"></div><h4 class="text-center bg-danger">Upload Documents</h4><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Latest Jamabandi and Latest Khasra Girdawri of both the lands to be exchanged</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file1"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file1)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Copy of mutation, if any</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file2"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file2)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Revenue Map showing both the proposed lands, applicant\'s project land and other shamlat / panchayat\'s land in different colours</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file3"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file3)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Ownership proof of applicant\'s project land</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file4"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file4)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Ownership proof of land offerd and Khasra Girdawari</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file7"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file7)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Supporting Affidavit stating therein the details of land and the reasons for availing service</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file5"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file5)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Resolution of Community,Co-operation,Counsil with \xBE majority in support of application</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file6"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file6)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Collector rate of the land which to be transfer to Municipality</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file8"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file8)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Collector rate of the land of the Municipality to be given in liew of exchnage.</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file9"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file9)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Exchange proposal showing the detail of proposed excahnge on drawing.</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file10"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file10)">Upload</button></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/acknowledgement.html','<div class="container-fluid"><div class="row"><div class="col-md-12"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><div id="pdf_data" style="width: 100%; word-wrap: break-word"><div class="modal-header"><h2 class="text-center text-primary"><b>Dear User, this is for your acknowledgment</b></h2><h5 class="text-center text-primary"><b>Application Details</b></h5></div><div class="modal-body"><div ng-show="vm.projectService.serviceid===\'bdb451cb-f12b-4352-8360-e6e3a715386f\' && vm.tokenFound"><div class="pull-left"><strong>Unique Id:</strong><span>{{\' \'+vm.nmatoken.cafpin}}</span><br></div><div class="pull-right"><strong>Token:</strong><span>{{\' \'+vm.nmatoken.nmatoken}}</span></div></div><br><table class="jh-table table table-striped table-responsive"><thead></thead><tbody><tr><th class="w-50">Reference No/ Application No</th><td>{{ vm.projectService.id }}</td></tr><tr><th>Department Name</th><td>{{vm.projectService.departmentName}}</td></tr><tr><th>Applied Date</th><td>{{ vm.projectService.formFilledOnDate | date:\'dd-MM-yyyy\' }}</td></tr><tr><th>CAF PIN</th><td>{{ vm.cafpin }}</td></tr><tr><th>Service Name</th><td>{{ vm.projectService.serviceName }}</td></tr><tr><th>Email</th><td>{{ vm.account.email }}</td></tr><tr><th>Phone Number</th><td>{{vm.account.phone}}</td></tr><tr><th>Address</th><td>{{ vm.account.address }}</td></tr><tr><th>RTS Due Date</th><td>{{ vm.rtsDueDate | date:\'dd-MM-yyyy\' }}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></div></div></div><div id="ratings" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><form name="form" role="form" novalidate ng-submit="vm.saveRating()" show-validation><div class="modal-content"><div class="row"><div class="modal-header"><div class="col-md-12"><h4 class="modal-title" id="Rate"><b>Rate Us</b></h4><span>Thank you for using the Invest Haryana portal! We value your feedback. Please rate your experience with <b>{{vm.service.serviceName}}</b> and share any comments to help us improve.</span></div><div class="col-md-2"><p><a class="fa fa-facebook-square" style="font-size:24px;text-decoration: none !important" target="_blank" href="https://www.facebook.com/investharyana/"></a> <a class="fa fa-twitter-square" style="font-size:24px;color: #1da1f2;text-decoration: none !important" target="_blank" href="https://twitter.com/investharyana/"></a> <a class="fa fa-linkedin-square" style="font-size:24px;color:#0077B5;text-decoration: none !important" target="_blank" href="https://www.linkedin.com/company/investharyana/"></a></p></div></div></div><div class="modal-body col-md-12"><div class="form-group"><div class="row col-md-12" style="margin-left: 7px"><span>Were you required to manually submit the application fee? <input type="radio" id="isFeeManuallySubmityes" ng-value="true" ng-model="vm.rating.isFeeManuallySubmit" name="isFeeManuallySubmit" value="yes"><label for="isFeeManuallySubmityes">Yes</label><input type="radio" id="isFeeManuallySubmitno" ng-value="false" ng-model="vm.rating.isFeeManuallySubmit" name="isFeeManuallySubmit" value="no"><label for="isFeeManuallySubmitno">No</label></span><br><span>Were you required to submit physical copy of the document at any stage of the application process? <input type="radio" id="isDocPhysicallySubmityes" ng-value="true" ng-model="vm.rating.isDocPhysicallySubmit" name="isDocPhysicallySubmit" value="yes"><label for="isDocPhysicallySubmityes">Yes</label><input type="radio" id="isDocPhysicallySubmitno" ng-value="false" ng-model="vm.rating.isDocPhysicallySubmit" name="isDocPhysicallySubmit" value="no"><label for="isDocPhysicallySubmitno">No</label></span><br><span>Were you able to get the final approval with a defined timeline? <input type="radio" id="isApprovalOnTimeyes" ng-value="true" ng-model="vm.rating.isApprovalOnTime" name="isApprovalOnTime" value="yes"><label for="isApprovalOnTimeyes">Yes</label><input type="radio" id="isApprovalOnTimeno" ng-value="false" ng-model="vm.rating.isApprovalOnTime" name="isApprovalOnTime" value="no"><label for="isApprovalOnTimeno">No</label></span><br><span>Could you able to download the final certificate/NOC from the portal? <input type="radio" id="isCertificateDownloadyes" ng-value="true" ng-model="vm.rating.isCertificateDownload" name="isCertificateDownload" value="yes"><label for="isCertificateDownloadyes">Yes</label><input type="radio" id="isCertificateDownloadno" ng-value="true" ng-model="vm.rating.isCertificateDownload" name="isCertificateDownload" value="no"><label for="isCertificateDownloadno">No</label></span><br><span>Did you physically visit the department to either submit the application or during the process of application? <input type="radio" id="isPhysicallyVisitYes" ng-value="true" ng-model="vm.rating.isPhysicallyVisit" name="isPhysicallyVisit" value="yes"><label for="isPhysicallyVisitYes">Yes</label><input type="radio" id="isPhysicallyVisitNo" ng-value="false" ng-model="vm.rating.isPhysicallyVisit" name="isPhysicallyVisit" value="no"><label for="isPhysicallyVisitNo">No</label></span><br><br></div></div><div class="form-group"><div class="radio-group rating"><span style="margin-left: 20px"><b>Rate</b></span>&nbsp;&nbsp;&nbsp;&nbsp; <input type="radio" id="star5" name="rating" ng-model="vm.rating.rating" value="Excellent"><label for="star5" title="Excellent">5 stars</label><input type="radio" id="star4" name="rating" ng-model="vm.rating.rating" value="Very Good"><label for="star4" title="Very Good">4 stars</label><input type="radio" id="star3" name="rating" ng-model="vm.rating.rating" value="Good"><label for="star3" title="Good">3 stars</label><input type="radio" id="star2" name="rating" ng-model="vm.rating.rating" value="Average"><label for="star2" title="Average">2 stars</label><input type="radio" id="star1" name="rating" ng-model="vm.rating.rating" value="Poor" required><label for="star1" title="Poor">1 stars</label></div></div><br><div class="row col-md-12"><label class="col-md-2" style="padding-bottom: 10px">Remarks &nbsp;&nbsp;&nbsp;</label><textarea rows="4" cols="200" class="col-md-8" type="text" name="comment" ng-model="vm.rating.comment" ng-required="vm.rating.rating ==\'Poor\' || vm.rating.rating ==\'Average\' || vm.rating.rating ==\'Good\'"></textarea></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-disabled="form.$invalid">Submit</button> <button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></form></div></div>');
$templateCache.put('app/serviceclearanceactions/assignOtherServiceDialog.html','<form name="editForm" id="resetForm" role="form"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCountryLabel" data-translate="">Other Service Fee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Fee Amount</label><input type="number" class="form-control" ng-model="vm.assignServiceFee.feeamount" required></div><div class="form-group"><label class="control-label" data-translate="">Fee Description</label><textarea class="form-control" rows="3" id="textArea" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.assignServiceFee.feedescription" required></textarea><div ng-show="editForm.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><button type="button" class="btn btn-primary" ng-disabled="editForm.$invalid" ng-click="vm.addOtherService()"><span class="glyphicon glyphicon-plus"></span>&nbsp;<span data-translate="">Add</span></button></div></div><div class="form-group"><div class="col-lg-12" ng-show="(vm.addfeeDetail.length!=0)"><table class="table table-striped table-hover table-bordered"><thead><tr class="info"><th><span>Amount</span></th><th><span>Description</span></th><th><span>Action</span></th></tr></thead><tbody></tbody><tr ng-repeat="addfeeDetail in vm.addfeeDetail"><td>{{addfeeDetail.feeamount}}</td><td>{{addfeeDetail.feedescription}}</td><td ng-show="(addfeeDetail.isPaymentMade==false)"><button type="button" class="btn btn-danger btn-sm" ng-click="vm.deleteRow(addfeeDetail.id)"><b>Delete</b></button></td><td ng-show="(addfeeDetail.isPaymentMade==true)"><button type="button" disabled="disabled" class="btn btn-success btn-sm"><b>&nbsp;Paid&nbsp;</b></button></td></tr></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="button" class="btn btn-primary" ng-click="vm.assignOtherService()" ng-disabled="vm.actionflag==false"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/assignServiceDialog.html','<form name="editForm" role="form" ng-submit="vm.assignService()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCountryLabel" data-translate="">Service Fee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Fee Amount</label><input type="number" class="form-control" ng-model="vm.projectservicedetail.serviceFee" required></div><div class="form-group"><label class="control-label" data-translate="">Comment</label><textarea class="form-control" rows="3" id="textArea" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editForm.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/checklist.html','<link rel="stylesheet" href="https://d1azc1qln24ryf.cloudfront.net/114779/Socicon/style-cf.css?9ukd8d"><script src="https://cdnjs.cloudflare.com/ajax/libs/uikit/3.0.0-beta.35/js/uikit.min.js"></script><!--<div id="dislayCheckList" class="uk-modal-full" uk-modal bg-close="false" style="overflow:hidden"  >--><!--    <div class="uk-modal-dialog">--><!--        <div class="uk-grid-collapse uk-child-width-1-2@s uk-flex-middle" uk-grid>--><!--            <div class="">--><!--                <div class="fullscreenDiv" style="text-align: center;">--><!--                    <object data="data:application/pdf;base64,{{urlpdf}}" class="mastercontainer" type="application/pdf"></object>--><!--                </div>--><!--            </div>--><!--        </div>--><!--    </div>--><!--</div>--><div id="dislayCheckList" role="dialog" class="modal" style="overflow:hidden"><div class=""><div class="fullscreenDiv" style="text-align: center"><object data="data:application/pdf;base64,{{urlpdf}}" class="mastercontainer" type="application/pdf"></object></div></div></div>');
$templateCache.put('app/serviceclearanceactions/clarificationDialog.html','<form name="editForm" role="form" ng-submit="vm.clarify(vm.role)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Comment</label><textarea class="form-control" rows="3" id="textArea" name="comment" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editForm.comment.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/commentDialog.html','<form name="editForm" role="form" ng-submit="vm.saveComments()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Comments</label><textarea class="form-control" rows="3" id="textArea" name="comment" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editForm.comment.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/constructionpermit.html','<div class="flex-container"><button style="margin: 10px" ng-show="!vm.show" type="button" class="btn btn-primary" ng-click="vm.toggleShow()">Show Approval Steps & Phases</button> <button style="margin: 10px" ng-show="vm.show" type="button" class="btn btn-primary" ng-click="vm.toggleShow()">Hide Approval Steps & Phases</button> <button style="margin: 10px" ng-show="vm.constructionPermit.bPflag==true" type="button" class="btn btn-success" ng-click="vm.showLog()" data-toggle="modal" data-target="#logmodal">View Status</button> <button style="margin: 10px" ng-show="vm.constructionPermit.pIflag==true" type="button" class="btn btn-warning" ng-click="vm.showInspectionReport()" data-toggle="modal" data-target="#downloadModal">Download Certificate</button><!--<button style="margin: 10px;" class="btn btn-success" type="button" data-toggle="modal" data-target="#uploadIR">--><!--Upload Inspection Report--><!--</button>--></div><div ng-show="vm.show" style="margin-left: 10px;margin-bottom: 10px"><label style="margin-right: 5px; font-size: 16px"><span class="label label-default">Approval (Phase - 1)</span></label><button class="btn-right"><d>Building Plans</d></button> <button class="btn-right"><d>Airport Authority of India</d></button> <button class="btn-right"><d>National Monument Auth</d></button> <button class="btn-right"><d>Fire Fighting Scheme</d></button> <button class="btn-right"><d>Water Connection</d></button> <button class="btn-right"><d>Electricity Connection</d></button></div><div ng-show="vm.show" style="margin-left: 10px;margin-bottom: 10px"><label style="margin-right: 5px; font-size: 16px"><span class="label label-default">Approval (Phase - 2)</span></label><button class="btn-right"><d>Plinth Inspection</d></button> <button class="btn-right"><d>View Inspection Report</d></button> <button class="btn-right"><d>Fire NOC</d></button> <button class="btn-right"><d>Factory Building Plan</d></button> <button class="btn-right"><d>Occupation Certificate</d></button></div><div style="margin-left: 10px;margin-bottom: 10px"><label style="margin-right: 5px;font-size: 16px"><span class="label label-primary">Phase - 1</span></label><button class="btn-left" data-toggle="modal" data-target="#BPmodal"><a>Approval Building Plan</a></button> <button ng-show="vm.constructionPermit.bPflag==true && vm.constructionPermit.aAIid==null" class="btn-left"><a ui-sref="aai-state">Airport Authority of India</a></button> <button ng-show="vm.constructionPermit.bPflag==true && vm.constructionPermit.aAIid!=null" class="btn-left" ng-click="vm.viewAAI(vm.constructionPermit.aAIid)"><a ui-sref="aai-detailPage({aaiId: vm.constructionPermit.aAIid})">Airport Authority of India</a></button> <button ng-show="vm.constructionPermit.aAIflag==true && vm.constructionPermit.nMAid==null" class="btn-left"><a ui-sref="nma-state">National Monument Auth</a></button> <button ng-show="vm.constructionPermit.aAIflag==true && vm.constructionPermit.nMAid!=null" class="btn-left" ng-click="vm.viewNMA(vm.constructionPermit.nMAid)"><a ui-sref="nma-detailPage({nmaId: vm.constructionPermit.nMAid})">National Monument Auth</a></button> <button ng-show="vm.constructionPermit.nMAflag==true" class="btn-left"><a ui-sref="ffs">Fire Fighting Scheme</a></button> <button ng-show="vm.constructionPermit.fFSflag==true" class="btn-left" data-toggle="modal" data-target="#waterConnectionModal"><a>Water Connection</a></button> <button ng-show="vm.constructionPermit.tWCflag==true" class="btn-left" data-toggle="modal" data-target="#TECmodal"><a>Electricity Connection</a></button></div><div style="margin-left: 10px"><label ng-show="vm.constructionPermit.tECflag==true" style="margin-right: 5px;font-size: 16px"><span class="label label-primary">Phase - 2</span></label><button ng-show="vm.constructionPermit.tECflag==true" class="btn-left" data-toggle="modal" data-target="#pimodal"><a>Plinth Inspection</a></button> <button ng-show="vm.constructionPermit.pIflag==true" class="btn-left" ng-click="vm.downloadReportInspection(vm.constructionPermit.id)"><a>View Inspection Report</a></button> <button ng-show="vm.constructionPermit.fireNOCflag==true" class="btn-left" data-toggle="modal" data-target="#NOCmodal"><a>Fire NOC</a></button> <button ng-show="vm.constructionPermit.oCflag==true" class="btn-left"><a ui-sref="labour">Factory Building Plan</a></button> <button ng-show="vm.constructionPermit.oCflag==true" class="btn-left" ng-click="vm.OccupationCertificate()"><a>Occupation Certificate</a></button></div><div class="col-md-8 col-md-offset-2" ng-show="vm.constructionPermit.pIflag==true"><table class="jh-table table table-striped"><thead><tr><th><span>Type of Inspection (single joint inspection)</span></th><th><span>Status</span></th><th><span>Inspector Name</span></th><th><span>Date</span></th></tr></thead><tbody><tr><td>Approval of Building Plan / Fire Fighing Scheme / Factory Plan Approval<br><span style="font-size: 12px">*Department schedules inspection on every Tuesday(working day).</span></td><td ng-show="vm.constructionPermit.fireNOCflag!=true">Scheduled</td><td ng-show="vm.constructionPermit.fireNOCflag==true">Completed</td><td>Sanjay Singh</td><td></td></tr></tbody></table></div><div id="BPmodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Select your Department</h4></div><div class="modal-body"><button ng-show="vm.constructionPermit.serviceId==\'159a0331-87c3-407d-9c6c-559455d4b6ab\' || vm.constructionPermit.serviceId == null" type="button" class="btn btn-success" data-dismiss="modal" ui-sref="tcp">Town & Country Planing</button> <button ng-show="vm.constructionPermit.serviceId==\'43575ec0-7dd3-40bd-b3c4-47638d17bf3c\' || vm.constructionPermit.serviceId == null" type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="huda">HUDA</button> <button ng-show="vm.constructionPermit.serviceId==\'a69786f5-c674-4de9-8807-8689c7ef86b5\' || vm.constructionPermit.serviceId == null" type="button" class="btn btn-danger" data-dismiss="modal" ui-sref="hsidc">HSIIDC</button> <button ng-show="vm.constructionPermit.serviceId==\'1c90c949-f2d1-4997-84b0-e6b2d40fe5e6\' || vm.constructionPermit.serviceId == null" type="button" class="btn btn-warning" data-dismiss="modal" ui-sref="ulb">ULB</button></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button></div></div></div></div><div id="pimodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Is Plinth Level Construction Completed?</h4></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal">No</button> <button type="button" class="btn btn-success" data-dismiss="modal" data-toggle="modal" data-target="#ocmodal">Yes</button></div></div></div></div><div id="ocmodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Remarks</h4></div><div class="modal-body"><textarea class="form-control" rows="3" id="address1" placeholder="Enter Remarks Here" ng-model="vm.constructionPermitLog.clearanceURL"></textarea></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button> <button type="button" class="btn btn-primary" data-dismiss="modal" ng-click="vm.savePlinth()">Done</button></div></div></div></div><div id="logmodal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Construction Permit Log</h4></div><div class="modal-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>CAF pin (Composite Application Form)</span></th><th><span>Service Name</span></th><th><span>Actiondate</span></th><th><span>Action</span></th><th><span>Clearance Remarks</span></th></tr></thead><tbody><tr ng-repeat="constructionPermitLog in vm.constructionPermitLogs track by constructionPermitLog.id"><td>{{constructionPermitLog.cafPin}}</td><td>{{constructionPermitLog.serviceName}}</td><td>{{constructionPermitLog.actiondate | date:\'mediumDate\'}}</td><td>{{constructionPermitLog.action}}</td><td>{{constructionPermitLog.clearanceURL}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button></div></div></div></div><div id="IRmodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Inspection Report</h4></div><div class="modal-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Projectid</span></th><th><span>Serviceid</span></th><th><span>Report Description</span></th><th><span>Report URL</span></th><th></th></tr></thead><tbody><tr ng-repeat="inspectionReport in vm.inspectionReports track by inspectionReport.id"><td>{{inspectionReport.projectid}}</td><td>{{inspectionReport.serviceid}}</td><td>{{inspectionReport.reportDescription}}</td><td>{{inspectionReport.reportURL}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Cancel</button></div></div></div></div><div id="TECmodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Select your Department</h4></div><div class="modal-body"><button type="button" ng-show="vm.constructionPermit.tECid==\'57fa837c-0897-4c7a-8225-74323823c890\' || vm.constructionPermit.tECid == null" class="btn btn-success" data-dismiss="modal" ui-sref="tec({deptID:\'57fa837c-0897-4c7a-8225-74323823c890\'})">DHBVN</button> <button type="button" ng-show="vm.constructionPermit.tECid==\'0577cfbb-77e3-4022-8b13-ec100e7094e0\' || vm.constructionPermit.tECid == null" class="btn btn-primary" data-dismiss="modal" ui-sref="tec({deptID:\'0577cfbb-77e3-4022-8b13-ec100e7094e0\'})">UHBVN</button></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button></div></div></div></div><div ui-view="nestedForm"></div><div id="waterConnectionModal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Select your Department</h4></div><div class="modal-body"><button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="twc">HSIIDC</button> <button type="button" class="btn btn-success" data-dismiss="modal" ui-sref="twc_huda">HUDA</button> <button type="button" class="btn btn-warning" data-dismiss="modal" ui-sref="twc_ulb">ULB</button></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Cancel</button></div></div></div></div><div id="NOCmodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Is the proposed requires Fire NOC?</h4></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="fireNOC">Yes</button> <button type="button" class="btn btn-success" data-dismiss="modal" ng-click="vm.fireNOC()">No</button></div></div></div></div><div id="downloadModal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Files to Download</h4></div><div class="modal-body col-md-offset-1"><div class="row" ng-show="vm.filesdata[0].file1!==null"><div class="col-md-7"><h4>Approval of Building Plan</h4></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.downloadReport(vm.filesdata[0].file1)">Download</button></div></div><div class="row" ng-show="vm.filesdata[0].file2!==null"><div class="col-md-7"><h4>Fire Fighting Scheme</h4></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.downloadReport(vm.filesdata[0].file2)">Download</button></div></div><div class="row" ng-show="vm.filesdata[0].file3!==null"><div class="col-md-7"><h4>Water Connection</h4></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.downloadReport(vm.filesdata[0].file3)">Download</button></div></div><div class="row" ng-show="vm.filesdata[0].file4!==null"><div class="col-md-7"><h4>Electricity Connection</h4></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.downloadReport(vm.filesdata[0].file4)">Download</button></div></div><div class="row" ng-show="vm.filesdata[0].file5!==null"><div class="col-md-7"><h4>Approval of Factory Building Plan</h4></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.downloadReport(vm.filesdata[0].file5)">Download</button></div></div><div class="row" ng-show="vm.filesdata[0].file6!==null"><div class="col-md-7"><h4>Fire NOC</h4></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.downloadReport(vm.filesdata[0].file6)">Download</button></div></div><div class="row" ng-show="vm.filesdata[0].file7!==null"><div class="col-md-7"><h4>Occupation Certificate</h4></div><div class="col-md-2"><button type="button" class="btn btn-primary" ng-click="vm.downloadReport(vm.filesdata[0].file7)">Download</button></div></div><!--<div class="row" ng-show="vm.filesdata[0].file8!==null">--><!--<div class="col-md-2">--><!--<h4>File 8</h4>--><!--</div>--><!--<div class="col-md-2">--><!--<button type="button" class="btn btn-primary" ng-click="vm.downloadReport(vm.filesdata[0].file8)">Download</button>--><!--</div>--><!--</div>--><!--<div class="row" ng-show="vm.filesdata[0].file9!==null">--><!--<div class="col-md-2">--><!--<h4>File 9</h4>--><!--</div>--><!--<div class="col-md-2">--><!--<button type="button" class="btn btn-primary" ng-click="vm.downloadReport(vm.filesdata[0].file9)">Download</button>--><!--</div>--><!--</div>--><!--<div class="row" ng-show="vm.filesdata[0].file10!==null">--><!--<div class="col-md-2">--><!--<h4>File 10</h4>--><!--</div>--><!--<div class="col-md-2">--><!--<button type="button" class="btn btn-primary" ng-click="vm.downloadReport(vm.filesdata[0].file10)">Download</button>--><!--</div>--><!--</div>--></div><div class="modal-footer"><button type="button" class="btn btn-success" data-dismiss="modal">Done</button></div></div></div></div>');
$templateCache.put('app/serviceclearanceactions/declineDialog.html','<form name="editForm" role="form" ng-submit="vm.declineService()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Reject</h4><!--<h5 style="color:red;">Warning: Once rejected, the service cannot be enabled again. </h5>--></div><div class="modal-body"><div class="form-group" ng-if="(!((vm.projectService.serviceid === \'741f0f60-cf69-4659-8b19-19d96ffe0103\') || (vm.projectService.serviceid === \'58d75fd4-f360-4931-a484-ff9be0adc12c\') || (vm.projectService.serviceid === \'6f81801c-59c6-4773-9f37-a5d81172a1bf\') || (vm.projectService.serviceid === \'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\') || (vm.projectService.serviceid === \'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\')))"><label class="control-label" data-translate="">Rejection Reason</label><br><select class="form-control" ng-model="vm.projectServiceLog.rejectionReason" required><option value="" disabled="disabled" selected="selected">Select Reason</option><option value="Incomplete/Wrongly filled form">a :- Incomplete/Wrongly filled form</option><option value="Non-Payment/Part-Payment of fees">b :- Non-Payment/Part-Payment of fees</option><option value="Service Not Required">c :- Service Not Required</option><option value="Duplicate Application">d :- Duplicate Application</option><option value="Ineligible Application">e :- Ineligible Application</option><option value="Withdrawal by Investor">f :- Withdrawal by Investor</option><option value="Non-Compliance of statutory requirements">g :- Non-Compliance of statutory requirements</option><option value="Any other">h :- Any other</option></select></div><div class="form-group" ng-if="vm.projectService.serviceid === \'741f0f60-cf69-4659-8b19-19d96ffe0103\' || vm.projectService.serviceid === \'58d75fd4-f360-4931-a484-ff9be0adc12c\' || vm.projectService.serviceid === \'6f81801c-59c6-4773-9f37-a5d81172a1bf\' || vm.projectService.serviceid === \'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\' || vm.projectService.serviceid === \'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\'"><label class="control-label">Select Category</label><select class="form-control" ng-model="vm.selectedCategory" ng-change="vm.getRejectionReason(vm.selectedCategory)" ng-options="reasonCategory as reasonCategory.category for reasonCategory in vm.reasonCategories" required><option value="">-- Select --</option></select></div><div class="form-group" ng-if="vm.projectService.serviceid === \'741f0f60-cf69-4659-8b19-19d96ffe0103\' || vm.projectService.serviceid === \'58d75fd4-f360-4931-a484-ff9be0adc12c\' || vm.projectService.serviceid === \'6f81801c-59c6-4773-9f37-a5d81172a1bf\' || vm.projectService.serviceid === \'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\' || vm.projectService.serviceid === \'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\'"><label class="control-label">Select Reason</label><select class="form-control" ng-model="vm.selectedReason" ng-change="vm.getReasons()" multiple="multiple" ng-options="rejectionReason as rejectionReason.reason for rejectionReason in vm.rejectionReasons" required><option value="">-- Select --</option></select></div><div class="form-group"><label class="control-label" data-translate="">Comments</label><textarea class="form-control" rows="3" id="textArea" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editForm.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/deemedClearance.html','<form name="editForm" role="form" ng-submit="vm.deemedClearService()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Deemed Clearance</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Comment</label><textarea class="form-control" rows="3" id="textArea" name="text" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editForm.comment.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/i-serviceform.html','<div class="hidden"><form action="{{vm.actionURL}}" id="myform" method="{{vm.methodType}}"><input type="hidden" name="uname" id="uname" value="{{vm.uname}}"> <input type="hidden" name="investorname" id="investorname" value="{{vm.investorname}}"> <input type="hidden" name="address" id="address" value="{{vm.address}}"> <input type="hidden" name="useremail" id="useremail" value="{{vm.useremail}}"> <input type="hidden" name="country" id="country" value="{{vm.country}}"> <input type="hidden" name="state" id="state" value="{{vm.state}}"> <input type="hidden" name="city" id="city" value="{{vm.city}}"> <input type="hidden" name="niccode" id="niccode" value="{{vm.niccode}}"> <input type="hidden" name="pannumber" id="pannumber" value="{{vm.pannumber}}"> <input type="hidden" name="gstnumber" id="gstnumber" value="{{vm.gstnumber}}"> <input type="hidden" name="aadhar_number" id="aadhar_number" value="{{vm.aadhar_number}}"> <input type="hidden" name="proposedbuilt_up_area" id="proposedbuilt_up_area" value="{{vm.proposedbuilt_up_area}}"> <input type="hidden" name="mobile" id="mobile" value="{{vm.mobile}}"> <input type="hidden" name="totalproposedprojectarea" id="totalproposedprojectarea" value="{{vm.totalproposedprojectarea}}"> <input type="hidden" name="totalpurposedemployment" id="totalpurposedemployment" value="{{vm.totalpurposedemployment}}"> <input type="hidden" name="total_project_cost" id="total_project_cost" value="{{vm.total_project_cost}}"> <input type="hidden" name="project_site_district" id="project_site_district" value="{{vm.district}}"> <input type="hidden" name="landzoneuse_type" id="landzoneuse_type" value="{{vm.landzoneuse_type}}"> <input type="hidden" name="businessentity" id="businessentity" value="{{vm.businessentity}}"> <input type="hidden" name="projecttype" id="projecttype" value="{{vm.projecttype}}"> <input type="hidden" name="projectid" id="projectid" value="{{vm.projectid}}"> <input type="hidden" name="serviceid" id="serviceid" value="{{vm.serviceid}}"> <input type="hidden" name="projectserviceid" id="projectserviceid" value="{{vm.projectserviceid}}"> <input type="hidden" name="cafpin" id="cafpin" value="{{vm.cafpin}}"> <input type="hidden" name="projectlevel" id="projectlevel" value="{{vm.projectlevel}}"> <input type="hidden" name="requestType" id="requestType" value="{{vm.requestType}}"> <input type="hidden" name="cafType" id="cafType" value="{{vm.cafType}}"> <input type="submit" id="fillform" value="Fill Service Form"></form></div>');
$templateCache.put('app/serviceclearanceactions/landexchange-detail.html','<div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success pull-right"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><form id="myForm" name="myForm" class="form-horizontal" role="form"><div id="pdf_data" class="panel"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">Exchange of land for industrial and residential colonies</h4></div><div class="panel-body"><div class="col-md-12"><dl class="row jh-entity-details"><div class="col-md-6"><h4 class="text-center bg-danger">Applicant details</h4><dt><span data-translate="investhryApp.landexchange.investor_name">Investor Name</span></dt><dd><span>{{vm.landexchange.investor_name}}</span></dd><dt><span data-translate="investhryApp.landexchange.address">Address</span></dt><dd><span>{{vm.landexchange.address}}</span></dd><dt><span data-translate="investhryApp.landexchange.contact">Contact</span></dt><dd><span>{{vm.landexchange.contact}}</span></dd><dt><span data-translate="investhryApp.landexchange.email">Email</span></dt><dd><span>{{vm.landexchange.email}}</span></dd><h4 class="text-center bg-danger">Reason</h4><dt><span data-translate="investhryApp.landexchange.reason">Reason</span></dt><dd><span>{{vm.landexchange.reason}}</span></dd><h4 class="text-center bg-danger">Documents Uploaded</h4><table class="table table-striped table-responsive table-hover"><thead><tr><th class="col-lg-6">File Description</th><th class="col-lg-2">Action</th></tr></thead><tbody><tr ng-repeat="serviceformattachment in vm.serviceformattachments"><td>{{serviceformattachment.description}}</td><td><button type="button" class="btn btn-success pull-center btn-sm" ng-click="vm.downloadFile(serviceformattachment.serverfilename,serviceformattachment.downloadfilename)"><span class="glyphicon glyphicon-download-alt"></span></button></td></tr></tbody></table></div><div class="col-md-6"><h4 class="text-center bg-danger">Details of land required</h4><dt><span data-translate="investhryApp.landexchange.name_of_gramPanchayat">Name Of Gram Panchayat</span></dt><dd><span>{{vm.landexchange.name_of_gramPanchayat}}</span></dd><dt><span data-translate="investhryApp.landexchange.district">District</span></dt><dd><span>{{vm.landexchange.district}}</span></dd><dt><span data-translate="investhryApp.landexchange.tehsil">Tehsil</span></dt><dd><span>{{vm.landexchange.tehsil}}</span></dd><dt><span data-translate="investhryApp.landexchange.block">Block</span></dt><dd><span>{{vm.landexchange.block}}</span></dd><dt><span data-translate="investhryApp.landexchange.village">Village</span></dt><dd><span>{{vm.landexchange.village}}</span></dd><dt><span data-translate="investhryApp.landexchange.khasra">Khasra</span></dt><dd><span>{{vm.landexchange.khasra}}</span></dd><dt><span data-translate="investhryApp.landexchange.area_of_land">Area Of Land</span></dt><dd><span>{{vm.landexchange.area_of_land}}</span></dd><dt><span data-translate="investhryApp.landexchange.market_value">Market Value</span></dt><dd><span>{{vm.landexchange.market_value}}</span></dd><h4 class="text-center bg-danger">Details of land offered</h4><dt><span data-translate="investhryApp.landexchange.owner_name_offered">Owner Name Offered</span></dt><dd><span>{{vm.landexchange.owner_name_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.district_offered">District Offered</span></dt><dd><span>{{vm.landexchange.district_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.tehsil_offered">Tehsil Offered</span></dt><dd><span>{{vm.landexchange.tehsil_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.block_offered">Block Offered</span></dt><dd><span>{{vm.landexchange.block_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.village_offered">Village Offered</span></dt><dd><span>{{vm.landexchange.village_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.khasra_offered">Khasra Offered</span></dt><dd><span>{{vm.landexchange.khasra_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.area_of_land_offered">Area Of Land Offered</span></dt><dd><span>{{vm.landexchange.area_of_land_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.market_value_offered">Market Value Offered</span></dt><dd><span>{{vm.landexchange.market_value_offered}}</span></dd></div><!--<dt><span data-translate="investhryApp.landexchange.type_of_land">Type Of Land</span></dt>--><!--<dd>--><!--<span>{{vm.landexchange.type_of_land}}</span>--><!--</dd>--><!----><!--<dt><span data-translate="investhryApp.landexchange.type_of_land_offered">Type Of Land Offered</span></dt>--><!--<dd>--><!--<span>{{vm.landexchange.type_of_land_offered}}</span>--><!--</dd>--></dl></div></div></div></form>');
$templateCache.put('app/serviceclearanceactions/landexchange-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLandexchangeLabel">Development and Panchayats: Service Form</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><h4 class="text-center bg-danger">Applicant Details</h4><div class="form-group" ng-show="vm.landexchange.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.landexchange.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.investor_name" for="field_investor_name">Investor Name</label><input type="text" class="form-control" name="investor_name" id="field_investor_name" ng-model="vm.landexchange.investor_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.address" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.landexchange.address"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.contact" for="field_contact">Contact</label><input type="text" class="form-control" name="contact" id="field_contact" ng-model="vm.landexchange.contact"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.landexchange.email"></div><h4 class="text-center bg-danger">Reason for availing services</h4><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.reason" for="field_reason">Reason</label><input type="text" class="form-control" name="reason" id="field_reason" ng-model="vm.landexchange.reason"></div><h4 class="text-center bg-danger">Details of land required</h4><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.name_of_gramPanchayat" for="field_name_of_gramPanchayat">Name Of Gram Panchayat</label><input type="text" class="form-control" name="name_of_gramPanchayat" id="field_name_of_gramPanchayat" ng-model="vm.landexchange.name_of_gramPanchayat"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.district" for="field_district">District</label><select class="form-control" name="district" id="field_district" ng-model="vm.landexchange.district" ng-options="district.districtname as district.districtname for district in vm.districts"></select></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.landexchange.owner_name" for="field_owner_name">Owner Name</label>--><!--<input type="text" class="form-control" name="owner_name" id="field_owner_name"--><!--ng-model="vm.landexchange.owner_name"--><!--/>--><!--</div>--><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.tehsil" for="field_tehsil">Tehsil</label><select class="form-control" name="tehsil" id="field_tehsil" ng-model="vm.landexchange.tehsil" ng-options="tehsil.tehsil_subtehsilname as tehsil.tehsil_subtehsilname for tehsil in vm.tehsil_subtehsils"></select></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.block" for="field_block">Block</label><select class="form-control" name="block" id="field_block" ng-model="vm.landexchange.block" ng-options="block.blockname as block.blockname for block in vm.blocks"></select></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.village" for="field_village">Village</label><input type="text" class="form-control" name="village" id="field_village" ng-model="vm.landexchange.village"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.khasra" for="field_khasra">Khasra</label><input type="text" class="form-control" name="khasra" id="field_khasra" ng-model="vm.landexchange.khasra"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.type_of_land" for="field_type_of_land">Type Of Land</label><input type="text" class="form-control" name="type_of_land" id="field_type_of_land" ng-model="vm.landexchange.type_of_land"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.area_of_land" for="field_area_of_land">Area Of Land</label><input type="text" class="form-control" name="area_of_land" id="field_area_of_land" ng-model="vm.landexchange.area_of_land"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.market_value" for="field_market_value">Market Value</label><input type="text" class="form-control" name="market_value" id="field_market_value" ng-model="vm.landexchange.market_value"></div><h4 class="text-center bg-danger">Details of land offered</h4><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.owner_name_offered" for="field_owner_name_offered">Owner Name Offered</label><input type="text" class="form-control" name="owner_name_offered" id="field_owner_name_offered" ng-model="vm.landexchange.owner_name_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.district_offered" for="field_district_offered">District Offered</label><select class="form-control" name="district" id="field_district_offered" ng-model="vm.landexchange.district_offered" ng-options="district.districtname as district.districtname for district in vm.districts"></select></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.tehsil_offered" for="field_tehsil_offered">Tehsil Offered</label><select class="form-control" name="tehsil" id="field_tehsil_offered" ng-model="vm.landexchange.tehsil_offered" ng-options="tehsil.tehsil_subtehsilname as tehsil.tehsil_subtehsilname for tehsil in vm.tehsil_subtehsils"></select></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.block_offered" for="field_block_offered">Block Offered</label><select class="form-control" name="block" id="field_block_offered" ng-model="vm.landexchange.block_offered" ng-options="block.blockname as block.blockname for block in vm.blocks"></select></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.village_offered" for="field_village_offered">Village Offered</label><input type="text" class="form-control" name="village_offered" id="field_village_offered" ng-model="vm.landexchange.village_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.khasra_offered" for="field_khasra_offered">Khasra Offered</label><input type="text" class="form-control" name="khasra_offered" id="field_khasra_offered" ng-model="vm.landexchange.khasra_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.type_of_land_offered" for="field_type_of_land_offered">Type Of Land Offered</label><input type="text" class="form-control" name="type_of_land_offered" id="field_type_of_land_offered" ng-model="vm.landexchange.type_of_land_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.area_of_land_offered" for="field_area_of_land_offered">Area Of Land Offered</label><input type="text" class="form-control" name="area_of_land_offered" id="field_area_of_land_offered" ng-model="vm.landexchange.area_of_land_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.market_value_offered" for="field_market_value_offered">Market Value Offered</label><input type="text" class="form-control" name="market_value_offered" id="field_market_value_offered" ng-model="vm.landexchange.market_value_offered"></div><h4 class="text-center bg-danger">Upload Documents</h4><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Latest Jamabandi and Latest Khasra Girdawri of both the lands to be exchanged</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file1"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file1)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Copy of mutation, if any</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file2"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file2)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Revenue Map showing both the proposed lands, applicant\'s project land and other shamlat / panchayat\'s land in different colours</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file3"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file3)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Ownership proof of applicant\'s project land</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file4"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file4)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Supporting Affidavit stating therein the details of land and the reasons for availing service</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file5"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file5)">Upload</button></div></div></div><div class="form-group"><div class="row"><div class="col-md-5"><label class="control-label" for="field_market_value_offered">Resolution of Gram Panchayat with \xBE majority in support of application</label></div><div class="col-md-5"><input type="file" class="form-control" name="file" file-model="vm.file6"></div><div class="col-md-2"><button type="button" class="btn btn-success" ng-click="vm.upload(vm.file6)">Upload</button></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/otherServicePayment.html','<form name="editForm" role="form" method="post" action="{{actionURL}}"><!--<form name="editForm" role="form" method="post" action="https://test.payu.in/_payment">--><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">View Payments</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><span ng-show="((vm.servicePaymentList.length==0) && (vm.projectServicePayment.paymentMade==0))"><h5>No Payments to be Made.</h5></span><span ng-show="((vm.servicePaymentList.length!=0) || (vm.projectServicePayment.paymentMade!=0))"><h4><b>Select amount to pay for this service:</b></h4></span><div class="form-group"><div class="col-lg-12"><table class="table table-striped table-hover table-bordered" ng-show="((vm.servicePaymentList.feeamount!=0) || (vm.projectServicePayment.paymentMade!=0))"><thead><center><tr class="success"><th><span>Amount</span></th><th><span>Description</span></th><th><span>Action</span></th></tr></center></thead><tbody><center><tr ng-repeat="servicePaymentList in vm.servicePaymentList" ng-show="(vm.servicePaymentList.feeamount!=0)"><td>Rs.&nbsp;{{servicePaymentList.feeamount}}</td><td>{{servicePaymentList.feedescription}}</td><td ng-show="(servicePaymentList.isPaymentMade==false)"><input type="radio" name="payment" ng-click="vm.individualPay(servicePaymentList.id,servicePaymentList.feeamount)">&nbsp;Pay</td><td ng-show="(servicePaymentList.isPaymentMade==true)"><label>Paid</label></td></tr><tr ng-show="(vm.projectServicePayment.paymentMade!=0)"><td>Rs.&nbsp;{{vm.projectServicePayment.paymentMade}}</td><td>Service Fee</td><td ng-show="(vm.projectServicePayment.isPaymentMade==false)"><input type="radio" name="payment" ng-click="vm.individualPay(vm.projectService.id,vm.projectServicePayment.paymentMade)">&nbsp;Pay</td><td ng-show="(vm.projectServicePayment.isPaymentMade==true)"><label>Paid</label></td></tr></center></tbody></table></div></div></div><div class="modal-footer"><input type="hidden" name="firstname" value="{{vm.paymentparameters.firstname}}"> <input type="hidden" name="surl" value="{{vm.paymentparameters.surl}}"> <input type="hidden" name="phone" value="{{vm.paymentparameters.phone}}"> <input type="hidden" name="key" value="{{vm.paymentparameters.key}}"> <input type="hidden" name="hash" value="{{vm.paymentparameters.hash}}"> <input type="hidden" name="furl" value="{{vm.paymentparameters.furl}}"> <input type="hidden" name="txnid" value="{{vm.paymentparameters.txnid}}"> <input type="hidden" name="productinfo" value="{{vm.paymentparameters.productinfo}}"> <input type="hidden" name="amount" value="{{vm.paymentparameters.amount}}"> <input type="hidden" name="email" value="{{vm.paymentparameters.email}}"> <input type="hidden" name="udf1" value="{{vm.paymentparameters.udf1}}"> <input type="hidden" name="udf2" value="{{vm.paymentparameters.udf2}}"> <input type="hidden" name="udf3" value="{{vm.paymentparameters.udf3}}"> <input type="hidden" name="udf4" value="{{vm.paymentparameters.udf4}}"> <input type="hidden" name="udf5" value="{{vm.paymentparameters.udf5}}"> <button type="submit" id="payubutton1" ng-show="vm.enableButton1!=0" class="btn btn-info btn-sm">Proceed To Pay</button> <input type="hidden" name="returnUrl" value="{{vm.paymentparameters.surl}}"> <input type="hidden" id="phoneNumber" name="phoneNumber" value="{{vm.paymentparameters.phone}}"> <input type="hidden" id="secSignature" name="secSignature" value="{{vm.paymentparameters.securitySignature}}"> <input type="hidden" id="notifyUrl" name="notifyUrl" value="{{furl}}"> <input type="hidden" id="merchantTxnId" name="merchantTxnId" value="{{vm.paymentparameters.txnid}}"> <input type="hidden" id="orderAmount" name="orderAmount" value="{{vm.paymentparameters.amount}}"> <input type="hidden" id="currency" name="currency" value="INR"> <input type="hidden" id="email" name="email" value="{{vm.paymentparameters.email}}"> <input type="hidden" name="customParams[0].name" value="projectid"> <input type="hidden" name="customParams[0].value" value="{{vm.paymentparameters.udf1}}"> <input type="hidden" name="customParams[1].name" value="serviceid"> <input type="hidden" name="customParams[1].value" value="{{vm.paymentparameters.udf2}}"> <input type="hidden" name="customParams[2].name" value="currentuserlogin"> <input type="hidden" name="customParams[2].value" value="{{vm.paymentparameters.udf3}}"> <input type="hidden" name="customParams[3].name" value="idmain"> <input type="hidden" name="customParams[3].value" value="{{vm.paymentparameters.udf4}}"> <button type="submit" id="payubutton2" ng-show="vm.enableButton2!=0" class="btn btn-info btn-sm">Proceed to Pay</button></div></form>');
$templateCache.put('app/serviceclearanceactions/paymentResponse.html','<div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Payment Response</h3></div><div class="panel-body"><table class="table table-striped"><tbody><tr><th class="col-lg-3">Transaction Id :</th><td class="col-md-3 pull-left">{{vm.response.transactionid}}</td></tr><tr><th class="col-lg-3">Amount :</th><td class="col-md-3 pull-left">{{vm.response.amount}}</td></tr><tr><th class="col-lg-3">Status :</th><td class="col-md-3 pull-left">{{vm.response.status}}</td></tr></tbody></table><button ui-sref="serviceclearanceaction({id:vm.response.projectid})" class="btn btn-success glyphicon glyphicon-arrow-left">Back</button></div></div></div>');
$templateCache.put('app/serviceclearanceactions/reactivateDialog.html','<form name="editForm" role="form" ng-submit="vm.reactivateService()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Re-Activate</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Comments</label><textarea class="form-control" rows="3" id="textArea" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editForm.comment.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/rejectDialog.html','<form name="editForm" role="form" ng-submit="vm.rejectService()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Deactivate</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Comments</label><textarea class="form-control" rows="3" id="textArea" ng-model="vm.projectServiceLog.comments" required></textarea></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/requiredList.html','<div class="row" ng-cloak><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title" data-translate="global.viewcaf.Service Required">Service Required</h3></div><div class="panel-body"><div class="col-md-12"><div class="col-md-4 filter-margin text-right"><label for="filterDept" class="uk-label uk-label-danger" style="font-size: 12px" data-translate="global.viewcaf.SELECT DEPARTMENT">SELECT DEPARTMENT</label></div><div class="col-md-5 text-center"><select id="filterDept" class="form-control custom-form-control" ng-model="vm.departmentFilter"><option value="" data-translate="global.addcafnew.select">-- select --</option><option value="{{departmentName}}" ng-repeat="(departmentName, service_list) in vm.projectservicelist.projectservicedetailDTOS | orderBy: \'departmentName\' | groupBy: \'departmentName\' ">{{departmentName}}</option></select></div><table class="jh-table table table-striped mt-60" ng-if="vm.departmentFilter"><thead><tr><th><span data-translate="global.viewcaf.Department">Department</span></th><th><span data-translate="global.viewcaf.Service Name">Service Name</span></th><th><span data-translate="global.viewcaf.Stage">Stage</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectservice in vm.projectservicelist.projectservicedetailDTOS | filter: vm.departmentFilter"><td>{{projectservice.departmentName}}</td><td>{{projectservice.serviceName}}</td><td>{{projectservice.serviceStage}}</td><td class="text-left"><button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICE" ng-disabled="vm.isSaving" type="button" ng-show="!projectservice.isRequired && projectservice.departmentName == \'GMDA\'" data-toggle="modal" data-target="#GMDA1" data-backdrop="static" data-keyboard="false" class="btn btn-info btn-sm" ng-click="vm.saveServiceObject = projectservice" data-translate="global.viewcaf.Require">Require</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICE,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER" ng-disabled="vm.isSaving" type="submit" ng-show="!projectservice.isRequired && projectservice.departmentName!==\'Communication and Connectivity Permissions\' && projectservice.departmentName!==\'GMDA\'  && projectservice.departmentName!==\'Centre Scheme\'" ng-click="vm.markRequired(projectservice)" class="btn btn-info btn-sm" data-translate="global.viewcaf.Require">Require</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICE" ng-disabled="vm.isSaving" type="submit" ng-show="!projectservice.isRequired && projectservice.serviceName===\'Regularization of existing Tower/Renewal (Above ground)\'" data-toggle="modal" data-target="#tower_department1" data-backdrop="static" data-keyboard="false" ng-click="vm.tower_departments(projectservice, \'tower\')" class="btn btn-info btn-sm" data-translate="global.viewcaf.Require">Require</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICE" type="submit" ng-show="!projectservice.isRequired && projectservice.serviceName===\'Communication and Connectivity Permissions/Renewal(Below Ground)\'" data-toggle="modal" data-target="#tower_department1" data-backdrop="static" data-keyboard="false" ng-click="vm.tower_departments(projectservice, \'tower\',\'below\')" class="btn btn-info btn-sm" data-translate="global.viewcaf.Require">Require</button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICE" ng-disabled="vm.isSaving" type="submit" ng-show="!projectservice.isRequired && projectservice.serviceName===\'Communication and Connectivity Permissions/Renewal(Above Ground)\'" data-toggle="modal" data-target="#tower_department1" data-backdrop="static" data-keyboard="false" ng-click="vm.tower_departments(projectservice, \'tower\')" class="btn btn-info btn-sm" data-translate="global.viewcaf.Require">Require</button> <button has-any-authority="ROLE_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICE" ng-disabled="vm.isSaving" type="submit" ng-show="!projectservice.isRequired && projectservice.serviceName===\'Right of Way / Right of Use to CABLE TV Operators\'" data-toggle="modal" data-target="#tower_department1" data-backdrop="static" data-keyboard="false" ng-click="vm.tower_departments(projectservice, \'tower\')" class="btn btn-info btn-sm" data-translate="global.viewcaf.Require">Require</button> <button has-any-authority="ROLE_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICE" ng-disabled="vm.isSaving" type="submit" ng-show="!projectservice.isRequired && projectservice.serviceName===\'Renewal/Extension of Communication and Connectivity Permissions\'" data-toggle="modal" data-target="#tower_department1" data-backdrop="static" data-keyboard="false" ng-click="vm.tower_departments(projectservice, \'tower\')" class="btn btn-info btn-sm" data-translate="global.viewcaf.Require">Require</button> <button has-any-authority="ROLE_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICE" ng-disabled="vm.isSaving" type="submit" ng-show="!projectservice.isRequired && projectservice.serviceName===\'Bharat Net (OFC)\'" data-toggle="modal" data-target="#tower_department1" data-backdrop="static" data-keyboard="false" ng-click="vm.tower_departments(projectservice, \'tower\')" class="btn btn-info btn-sm" data-translate="global.viewcaf.Require">Require</button> <button has-any-authority="ROLE_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICE" ng-disabled="vm.isSaving" type="submit" ng-show="!projectservice.isRequired && projectservice.serviceName===\'5G Application Form\'" data-toggle="modal" data-target="#tower_department1" data-backdrop="static" data-keyboard="false" ng-click="vm.tower_departments(projectservice, \'tower\')" class="btn btn-info btn-sm">Require 1</button></td></tr></tbody></table></div></div></div></div><!-- Modal --><!--<div class="modal" id="tower_department" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="myModalLabel" >--><!--    <div class="modal-dialog" role="document" >--><!--        <div class="modal-content">--><!--            <div class="modal-header">--><!--                <button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="clear()"><span aria-hidden="true">&times;</span></button>--><!--                <h4 class="modal-title" id="myModalLabel">Select Required Department/Department\'s</h4>--><!--            </div>--><!--            <div class="modal-body">--><!--                <div class="row panel-body">--><!--                    <div class="table-responsive" style="display:block;overflow:auto;height:400px;width:100%;">--><!--                        <table class="jh-table table table-striped">--><!--                            <thead>--><!--                            <tr>--><!--                                <th><span >Department Name</span></th>--><!--                                <th><span >Required</span></th>--><!--                            </tr>--><!--                            </thead>--><!--                            <tbody>--><!--                            <tr ng-repeat="department in vm.tower_departmentlist" ng-show="department.istower">--><!--                                <td>{{department.departmentname}}</td>--><!--                                <td>--><!--                                    <input type="checkbox" class="form-control" ng-click="vm.BelowGround(department.departmentname)" checklist-model="required.department"  checklist-value="department.departmentname"/>--><!--                                </td>--><!--                            </tr>--><!--                            </tbody>--><!--                        </table>--><!--                    </div>--><!--                </div>--><!--            </div>--><!--            <div class="modal-footer">--><!--                <button type="button" class="btn btn-default" ng-click="clear()" data-dismiss="modal">Close</button>--><!--                <button type="button" class="btn btn-primary" ng-disabled="required.department.length==0" ng-click="vm.markRequired(vm.tower_service,required.department)" data-dismiss="modal">Done</button>--><!--            </div>--><!--        </div>--><!--    </div>--><!--</div>--><div class="modal" id="tower_department1" tabindex="-1" data-backdrop="static" data-keyboard="false" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="clear()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Select Required Department/Department\'s 3</h4></div><div class="modal-body"><div class="row panel-body"><div class="table-responsive" style="display:block;overflow:auto;height:400px;width:100%"><table class="jh-table table table-striped"><thead><tr><th><span>Department Name</span></th><th><span>Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.tower_departmentlist" ng-show="department.istower"><td>{{department.departmentname}}</td><td><input type="checkbox" class="form-control" ng-click="vm.updateCheck(department.departmentname)" checklist-model="required.department" checklist-value="department.departmentname"></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="clear()" data-dismiss="modal">Close</button> <button type="button" class="btn btn-primary" ng-disabled="required.department.length==0" ng-click="vm.markRequired(vm.tower_service, required.department)" data-dismiss="modal">Done</button></div></div></div></div><div class="modal rmPaddingModal" data-backdrop="static" data-keyboard="false" id="YourModalId" tabindex="-1" role="dialog" aria-labelledby="YourModalId1"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="YourModalId1">Select Required Department/Department\'s 1</h4></div><div class="modal-body" ng-show="vm.municipals.length!=0"><div class="row panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Department Name</span></th><th><span>Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.municipals"><td>{{department.name}}</td><td><input class="form-control" type="radio" name="myType" ng-model="vm.aboveMunicipal" value="{{department.name}}"><!--<input type="checkbox" class="form-control" ng-click="vm.updateMunicipal(department.name)" checklist-model="required.municipal" checklist-value="department.name"/>--></td></tr></tbody></table></div></div></div><div class="modal-footer" ng-show="vm.municipals.length!=0"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal()">Close</button> <button type="button" class="btn btn-primary" ng-disabled="vm.aboveMunicipal==null" ng-click="vm.markRequiredForMunicipal(vm.tower_service,required.department,vm.aboveMunicipal)" data-dismiss="modal">Done</button></div><div class="alert alert-warning" ng-hide="vm.municipals.length>0"><b>No</b> Department!</div></div></div></div><div class="modal rmPaddingModal" data-backdrop="static" data-keyboard="false" id="belowGround" tabindex="-1" role="dialog" aria-labelledby="belowGroundService"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeBelow()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="belowGroundService">Select Required Department/Department\'s 2</h4></div><div class="modal-body" ng-show="vm.municipals.length!=0"><div class="row panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Department Name</span></th><th><span>Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.municipals"><td>{{department.name}}</td><td><input type="checkbox" class="form-control" checklist-model="required.belowMunicipal" checklist-value="department.name"></td></tr></tbody></table></div></div></div><div class="modal-footer" ng-show="vm.municipals.length!=0"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeBelow()">Close</button> <button type="button" class="btn btn-primary" data-dismiss="modal" ng-disabled="required.belowMunicipal==null" ng-click="vm.markRequiredForBelow(vm.tower_service,required.department,required.belowMunicipal)">Done</button></div><div class="alert alert-warning" ng-hide="vm.municipals.length>0"><b>No</b> Department!</div></div></div></div><div class="modal fade" id="GMDA1" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title"><p class="text-danger">* Proceed if your village exist in the list</p></h4></div><div class="modal-body"><div class="table-responsive"><table class="text-center" cellspacing="1" border="5"><tr><td>Tehsil</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td></tr><tr><td style="min-width:50px">Gurugram</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">Manesar</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">Sohna</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">Farukhnagar</td><td style="min-width:50px"></td></tr><tr><td style="min-width:50px">Sno</td><td style="min-width:50px">Village Name</td><td style="min-width:50px"></td><td style="min-width:50px">Sno</td><td style="min-width:50px">Village Name</td><td style="min-width:50px"></td><td style="min-width:50px">Sno</td><td style="min-width:50px">Village Name</td><td style="min-width:50px"></td><td style="min-width:50px">Sno</td><td style="min-width:50px">Village Name</td></tr><tr><td style="min-width:50px">1</td><td style="min-width:50px">Bajhgera</td><td style="min-width:50px"></td><td style="min-width:50px">1</td><td style="min-width:50px">Badha</td><td style="min-width:50px"></td><td style="min-width:50px">1</td><td style="min-width:50px">Bhondsi</td><td style="min-width:50px"></td><td style="min-width:50px">1</td><td style="min-width:50px">Sultanpur</td></tr><tr><td style="min-width:50px">2</td><td style="min-width:50px">Babupur</td><td style="min-width:50px"></td><td style="min-width:50px">2</td><td style="min-width:50px">Sikanderpur Badha</td><td style="min-width:50px"></td><td style="min-width:50px">2</td><td style="min-width:50px">Kadarpur</td><td style="min-width:50px"></td><td style="min-width:50px">2</td><td style="min-width:50px">Kaliawas</td></tr><tr><td style="min-width:50px">3</td><td style="min-width:50px">Dharampur</td><td style="min-width:50px"></td><td style="min-width:50px">3</td><td style="min-width:50px">Lakhnola</td><td style="min-width:50px"></td><td style="min-width:50px">3</td><td style="min-width:50px">Behrampur</td><td style="min-width:50px"></td><td style="min-width:50px">3</td><td style="min-width:50px">Sadpur Mohammadpur</td></tr><tr><td style="min-width:50px">4</td><td style="min-width:50px">Mohammadheri</td><td style="min-width:50px"></td><td style="min-width:50px">4</td><td style="min-width:50px">Nawada Fatehpur</td><td style="min-width:50px"></td><td style="min-width:50px">4</td><td style="min-width:50px">Ulahwas</td><td style="min-width:50px"></td><td style="min-width:50px">4</td><td style="min-width:50px">Khantawas</td></tr><tr><td style="min-width:50px">5</td><td style="min-width:50px">Daultabad</td><td style="min-width:50px"></td><td style="min-width:50px">5</td><td style="min-width:50px">Naharpur Kasan</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">5</td><td style="min-width:50px">Dhanawas</td></tr><tr><td style="min-width:50px">6</td><td style="min-width:50px">Kherki Majra</td><td style="min-width:50px"></td><td style="min-width:50px">6</td><td style="min-width:50px">Khoh</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">6</td><td style="min-width:50px">Babra Bakipur</td></tr><tr><td style="min-width:50px">7</td><td style="min-width:50px">Dhankot</td><td style="min-width:50px"></td><td style="min-width:50px">7</td><td style="min-width:50px">Kasan</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">7</td><td style="min-width:50px">Khawaspur</td></tr><tr><td style="min-width:50px">8</td><td style="min-width:50px">Gopalpur</td><td style="min-width:50px"></td><td style="min-width:50px">8</td><td style="min-width:50px">Fazalwas</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">8</td><td style="min-width:50px">Jhund Sarai Abad</td></tr><tr><td style="min-width:50px">9</td><td style="min-width:50px">Budhera</td><td style="min-width:50px"></td><td style="min-width:50px">9</td><td style="min-width:50px">Kukdola</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">9</td><td style="min-width:50px">Jhund Sarai Viran</td></tr><tr><td style="min-width:50px">10</td><td style="min-width:50px">Chandu</td><td style="min-width:50px"></td><td style="min-width:50px">10</td><td style="min-width:50px">Sehrawan</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">10</td><td style="min-width:50px">Baslambi</td></tr><tr><td style="min-width:50px">11</td><td style="min-width:50px">Sadhrana</td><td style="min-width:50px"></td><td style="min-width:50px">11</td><td style="min-width:50px">Gwaliar</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">11</td><td style="min-width:50px">Kharkhari</td></tr><tr><td style="min-width:50px">12</td><td style="min-width:50px">Garhi Harsaru</td><td style="min-width:50px"></td><td style="min-width:50px">12</td><td style="min-width:50px">Nainwal</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">12</td><td style="min-width:50px">Mokalwas</td></tr><tr><td style="min-width:50px">13</td><td style="min-width:50px">Hamirpur</td><td style="min-width:50px"></td><td style="min-width:50px">13</td><td style="min-width:50px">Manesar</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">13</td><td style="min-width:50px">Fakharpur</td></tr><tr><td style="min-width:50px">14</td><td style="min-width:50px">Wazirpur</td><td style="min-width:50px"></td><td style="min-width:50px">14</td><td style="min-width:50px">Baskusla</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">14</td><td style="min-width:50px">Sanpka</td></tr><tr><td style="min-width:50px">15</td><td style="min-width:50px">Dhorka</td><td style="min-width:50px"></td><td style="min-width:50px">15</td><td style="min-width:50px">Naurangpur</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">15</td><td style="min-width:50px">Jamalpur</td></tr><tr><td style="min-width:50px">16</td><td style="min-width:50px">Meoka</td><td style="min-width:50px"></td><td style="min-width:50px">16</td><td style="min-width:50px">Shikohpur (Dhani Rampur)</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">16</td><td style="min-width:50px">Tatarpur</td></tr><tr><td style="min-width:50px">17</td><td style="min-width:50px">Hayatpur</td><td style="min-width:50px"></td><td style="min-width:50px">17</td><td style="min-width:50px">Hassanpur</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">17</td><td style="min-width:50px">Jatola</td></tr><tr><td style="min-width:50px">18</td><td style="min-width:50px">Kankrola</td><td style="min-width:50px"></td><td style="min-width:50px">18</td><td style="min-width:50px">Binola</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">18</td><td style="min-width:50px">Judola</td></tr><tr><td style="min-width:50px">19</td><td style="min-width:50px">Dhana</td><td style="min-width:50px"></td><td style="min-width:50px">19</td><td style="min-width:50px">Bilaspur</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">19</td><td style="min-width:50px">Tajnagar</td></tr><tr><td style="min-width:50px">20</td><td style="min-width:50px">Bhangrola</td><td style="min-width:50px"></td><td style="min-width:50px">20</td><td style="min-width:50px">Pathrari</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">20</td><td style="min-width:50px">Fazilpur Badli</td></tr><tr><td style="min-width:50px">21</td><td style="min-width:50px">Basharia</td><td style="min-width:50px"></td><td style="min-width:50px">21</td><td style="min-width:50px">Chandla Dungarwas</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">21</td><td style="min-width:50px">Mubarikpur</td></tr><tr><td style="min-width:50px">22</td><td style="min-width:50px">Palra</td><td style="min-width:50px"></td><td style="min-width:50px">22</td><td style="min-width:50px">Langra</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">22</td><td style="min-width:50px">Patli Hajipur</td></tr><tr><td style="min-width:50px">23</td><td style="min-width:50px">Dhumaspur</td><td style="min-width:50px"></td><td style="min-width:50px">23</td><td style="min-width:50px">Udepuri</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">23</td><td style="min-width:50px">Iqbalpur</td></tr><tr><td style="min-width:50px">24</td><td style="min-width:50px">Medawas</td><td style="min-width:50px"></td><td style="min-width:50px">24</td><td style="min-width:50px">Baghanki</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">24</td><td style="min-width:50px">Jhanjrola</td></tr><tr><td style="min-width:50px">25</td><td style="min-width:50px">Kadarpur</td><td style="min-width:50px"></td><td style="min-width:50px">25</td><td style="min-width:50px">Kherki</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px">25</td><td style="min-width:50px">Sarbasirpur</td></tr><tr><td style="min-width:50px">26</td><td style="min-width:50px">Nangli Umarpur</td><td style="min-width:50px"></td><td style="min-width:50px">26</td><td style="min-width:50px">Bar Gujjar</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td></tr><tr><td style="min-width:50px">27</td><td style="min-width:50px">Tikli</td><td style="min-width:50px"></td><td style="min-width:50px">27</td><td style="min-width:50px">Sakatpur</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td></tr><tr><td style="min-width:50px">28</td><td style="min-width:50px">Aklimpur</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td></tr><tr><td style="min-width:50px">29</td><td style="min-width:50px">Gairatpur Bas</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td></tr><tr><td style="min-width:50px">30</td><td style="min-width:50px">Mankrola</td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td><td style="min-width:50px"></td></tr></table></div></div><div class="modal-footer"><p class="text-danger pull-left">* Proceed if your village exist in the list</p><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()">Close</button> <button type="button" class="btn btn-info" ng-click="vm.markRequired(vm.saveServiceObject)" data-dismiss="modal">Required</button></div></div></div></div>');
$templateCache.put('app/serviceclearanceactions/serviceForm.html','<form name="myForm" role="form" ng-submit="vm.saveFormFieldData()" method="POST"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">{{(vm.departmentservice.departmentname == \'Directorate of Information, Public Relation and Language\' || vm.departmentservice.departmentname == \'Information, Public Relations and Language\')? \'Directorate of Information, Public Relations and Language\' : vm.departmentservice.departmentname}} : {{vm.departmentservice.serviceName}}</h4></div><div class="modal-body"><div><p class="text-danger">* abc All fields are mandatory.</p></div><div ng-repeat="field in vm.serviceFormFieldData | orderBy : \'formfieldOrder\'" class="form-horizontal"><ng-form name="form"><!-- TEXT FIELDS --><div ng-if="field.formfieldtype==\'text\'" class="form-group"><label class="col-sm-4 control-label">{{field.formfieldName}}<span ng-show="field.isRequired==true" style="color:red">*</span></label><div class="col-sm-6"><input type="{{ field.fieldType }}" id="{{field.id}}" ng-model="field.formfieldvalue" class="form-control" ng-required="field.formfieldName!==\'Fee details\'"></div></div><!-- SELECT FIELDS --><div ng-if="field.formfieldtype==\'select\'" class="form-group"><label class="col-sm-4 control-label">{{field.formfieldName}}<span ng-show="field.isRequired==true" style="color:red">*</span></label><!-- If the dropdown has only one option, auto-select it (unless a value is already saved) --><div class="col-sm-6" ng-init="field.formtypeOption.split(\',\').length === 1 && !field.formfieldvalue && (field.formfieldvalue = field.formtypeOption.split(\',\')[0])"><select ng-model="field.formfieldvalue" dynamic-name="field.id" ng-options="x for x in field.formtypeOption.split(\',\') " class="form-control" ng-required="true" ng-disabled="field.formtypeOption.split(\',\').length === 1"><option value="">-- Select --</option></select><!--\n                        <label class="control-label" style="margin-top:5px;color:#337ab7;" ng-show="field.formfieldName==\'Property\' && field.formfieldvalue">\n                            Selected: {{ field.formfieldvalue }}\n                        </label>\n                        Service id shown only for Regularization of existing Tower/Renewal (Above ground) + Other Than Public Property.\n                        <label class="control-label" style="margin-top:5px;color:#337ab7;display:block;"\n                               ng-show="field.formfieldName==\'Property\'\n                                        && vm.projectService.serviceid == \'58d75fd4-f360-4931-a484-ff9be0adc12c\'\n                                        && (((field.formfieldvalue || \'\') | lowercase).trim() == \'other than public property\')">\n                            Selected id: {{ vm.projectService.serviceid }}\n                        </label>\n                        --></div></div><!-- LAVEL FIELDS --><div ng-if="field.formfieldtype==\'label\'" class="form-group alert alert-dismissible alert-danger"><div class="col-sm-11">{{field.formfieldName}}</div><div class="col-sm-1"><label class="col-sm-12 control-label" ng-model="field.formfieldvalue"></label></div></div><!-- TEXTAREA FIELDS --><div ng-if="field.formfieldtype==\'textarea\'" class="form-group"><label class="col-sm-4 control-label">{{field.formfieldName}}<span ng-show="field.isRequired==true" style="color:red">*</span></label><div class="col-sm-6"><textarea ng-model="field.formfieldvalue" id="textarea" class="form-control" rows="3" ng-required="field.formfieldName!==\'Fee details\'"></textarea></div></div><!-- TEXTAREA FIELDS --><div ng-if="field.formfieldtype==\'date\'" class="form-group"><label class="col-sm-4 control-label">{{field.formfieldName}}<span ng-show="field.isRequired==true" style="color:red">*</span></label><div class="col-sm-6"><input ng-model="field.formfieldvalue" id="date" class="form-control" rows="3" type="date"></div></div></ng-form></div><div id="termsandconditions" ng-show="vm.projectService.serviceid==\'0fb4fb41-8651-4d11-b9f3-e3d4ed1a8ab0\'"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">TERMS AND CONDITIONS</p><div class="col-md-1"></div><ul><!--<li>Application can be submitted only through email:  haryanafilmcell@gmail.com undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.</li>--><!--<li>Submit a duly signed hard copy of application in the office of HFC, 8th Floor, Media Centre, Haryana Civil Secretariat, Chandigarh- 160001.</li>--><li>The decision of the High Power Committee will be the final decision of the HFC. No further Correspondence with respect to the decision of the HFC will be entertained.</li><li>Full and complete information in regard to the particulars required as mentioned in the project.</li><li>Details of other projects that you are currently working on and their status.</li><li>Submission of CA certified financial status of producer/financer is mandatory for proposal approval.</li></ul><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">The following Enclosures need to be submitted along with the Project Overview Form:</p><div class="col-md-1"></div><ol><li>Please submit this application form and all documents.</li><li>PDF copies of Script (English or Hindi and One (1) copy of the script in the original language in which the film is to be produced).</li><li>PDF copies of Synopsis and Treatment in English or Hindi and One (1) copy of the same in the original language in which the film is to be produced.</li><li>One (1) PDF copy of the Directors profile and the Producer\u2019s profile along with mentions of web links, if any.</li><li>Financial capability of the Producer/s with supporting documents.</li><li>Previous Film Experience of the Director must be showcased through a Show reel in MPEG format.</li><li>All the columns should be filled, if not filled give the reason.</li><li>The total budget cost should be certified by a Charted Accountant.</li><li>Income Tax return certified of the producer/firm/institutions/public/partners of previous three years should be attached with the application.</li><li>A non-refundable draft amounting to Rs. 10,000/-(ten thousand only) for Producers submitting film proposals in Haryanvi film category & Rs. 50,000/- (fifty thousand only) for film makers submitting proposals in non-haryanvi category and Rs.1,00,000/-(one lakh only) for film makers applying for the international and mega project category in favor of \u2018Haryana Film Cell\u2019 payable at Chandigarh, will have to be submitted as processing fee.</li><li>Clear details about the objectives, message, social relevance and the culture & tourism etc. of Haryana should be mentioned in the plot of the script.</li><li>Please provide the bank details of the Producer / Director / Firm.</li></ol><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">Undertaking:</p><div class="col-md-1"></div><ul><li style="padding:0px">I/We <b>{{vm.project.firstname}}</b>, Messrs <b>{{vm.project.businessentity}}</b> Producer/Director of the film hereby declare oath that all the facts and details mentioned in the application are true to my knowledge. If any facts or details is found incorrect, than the HFC will be free to recover all the amount sanctioned as subsidy with interest from me and also initiate legal proceeding as per the rules against me.</li><li>I also declare that this film will be shot in Haryana according to the Haryana Film Policy 2018. It will not be a dubbed or copied film.</li><li>I declare on oath that the Haryana Film Cell will examine the subsidy payable on my film and decide regarding granting/non-granting of subsidy after checking the rules, directives and objectives as mentioned in the Film Policy. I will have no objection on the decision taken by HFC and the decision taken by the Corporation will be final and acceptable to me. I will not raise any dispute in this regard on any forum.</li></ul></div></fieldset></div></div></div><div id="termsandconditions1" ng-show="vm.projectService.serviceid==\'c3d87ea6-7459-4ec1-a7f1-49a1ae33374e\'"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">Note :</p><div class="col-md-1"></div><ul><li>Spreadsheet format for submitting details of ROW required can be downloaded from the link \u201CDownload\u201D above. The applicant shall provide complete details of ROW in the spreadsheet. In case of incomplete information, the application may be rejected.</li><li>dwg file should contains GPR survey also.</li><li>Applicants are requested to upload the GPR survey date in the attached format only (refer to: gpr_date_Format.pdf) for acceptance by HSVP.</li></ul><div class="col-md-1"></div><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">Undertaking:</p><div class="col-md-1"></div><ul><li>I hereby affirm and declare that the information given and the uploaded documents is true and correct to the best of my knowledge and belief and nothing material has been concealed therein.</li><li>I am well aware that concealment of facts and giving false information is punishable offence and in case I am guilty of giving false information or concealment of fact herein, I will be liable to be punished with imprisonment and / or fine as per the relevant provisions of law.</li><li>I also undertake that the benefits availed by me by furnishing such false information or concealment of the facts shall be liable to be summarily withdrawn.</li><li>I commit that I shall share a build diagram in interoperability format, once the work is completed else the Bank Guarantee shall be forfeited and submitting the application for RoW is my consent for the same. Also, I shall upload weekly progress of the work on e-samiksh in.shp file format which will contain latitude & longitude details.</li><li>I/We <b>{{vm.project.firstname}}</b>, Messrs <b>{{vm.project.businessentity}}</b> have read and understood the terms and conditions mentioned above. After having accepting these terms and conditions, I/we am/are submitting the application.</li></ul></div></fieldset></div></div></div><div id="termsandconditions2" ng-show="vm.projectService.serviceid==\'f2cc0d64-ffc2-4189-a805-8237f7dd9693\'"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">Terms & Conditions</p><div class="col-md-1"></div><ul><li>1. I/We <b>{{vm.project.firstname}}</b> hereby undertake that all the information furnished above is true and correct to the best of my/our knowledge and belief. No part of the information is false and nothing has been concealed therein.All the required attachments have been completely and legibly attached to this form.</li><li>2. I/We <b>{{vm.project.firstname}}</b> have carefully read and understood the policy/guidelines for grant of permission of Right of Way to Gas Companies for laying of Gas Pipelines in the State of Haryana circulated by Director of Industries & Commerce, Haryana, Chandigarh vide memo no DIH/C/CNG/PNG/353-A dated 04.01.2018 and HSIIDC letter no 873-885 dated 17.06.2010.</li><li>2.1 I/We <b>{{vm.project.firstname}} </b>hereby acknowledge the poliey/guidelines referred to above" and undertake to comply with these policy/guidelines.</li><li>3. I/We <b>{{vm.project.firstname}}</b> have also carefully read and understood the Haryana PWD Code para 27.4 (Management of Roads) and hereby undertake to comply with the provisions of PWD Code para 27.4 as well.</li></ul><div class="col-md-1"></div></div></fieldset></div></div></div><div id="termsandconditionsforPanchayat" ng-show="vm.projectService.serviceid==\'c8035e09-f983-44fd-9291-35083c0f62db\'"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">Terms & Conditions</p><ul><li>I have read the provisions under rule 12 A of The Haryana Panchayati Raj. Rules 1995 and shall abide by the terms and conditions mentioned therein and also abide by the terms and conditions to be imposed by the Gram Panchayat or the State Govt.</li><li>All the required attachments have been completely and legibly attached to this form.</li></ul><div class="col-md-1"></div></div></fieldset></div></div></div><div id="termsandconditionsforHome" ng-if="vm.projectService.serviceid==\'be783ce2-7027-44be-9408-7ff1d78db057\' || vm.projectService.serviceid==\'765a17ce-712a-4413-abba-cbe293a72610\'"><div class="panel-body"><div class="form-horizontal" data-dpmaxz-eid="7"><fieldset><div class="col-md-12"><p class="alert alert-success" style="font-size:14px; font-weight:bold; width:100%">Declaration</p><ul><li>I hereby declare that the details furnished above are true and correct to the best of my knowledge and belief and I undertake to inform you of any changes therein,immediately. In case any of the above information is found to be false or untrue or misleading or misrepresenting, I am aware that I may be held liable for it.</li></ul><div class="col-md-1"></div></div></fieldset></div></div></div><div class="form-group form-group alert alert-dismissible alert-danger" ng-show="vm.projectService.serviceid==\'0fb4fb41-8651-4d11-b9f3-e3d4ed1a8ab0\'"><label class="control-label">Please fill and upload the annexure together with all required documents:</label><a style="margin-left: 20px" class="btn btn-sm btn-info" href="../../content/pdfs/ApplicationFormForFilmSubsidy.docx">Download Annexure<span class="glyphicon glyphicon-download-alt"></span></a></div></div><div class="panel panel-primary" ng-show="(vm.serviceformdocs.length>0)"><div class="panel-body"><div class="col-md-2" ng-repeat="serviceformdoc in vm.serviceformdocs"><a href="" ng-click="vm.downloadFile(serviceformdoc.downloadfilename,serviceformdoc.docname)">{{serviceformdoc.docname}}</a></div></div></div><!-- Documents to upload: shown only for Public Property + Ground tower.\n         Condition is computed inline from vm.serviceFormFieldData (template-only, no controller JS needed). --><div class="panel panel-primary" ng-if="(((vm.serviceFormFieldData | filter:{formfieldName:\'Property\'}:true)[0].formfieldvalue || \'\') | lowercase).trim() == \'public property\'\n              && (((vm.serviceFormFieldData | filter:{formfieldName:\'Ground/Roof Top Tower\'}:true)[0].formfieldvalue || \'\') | lowercase).trim() == \'ground\'"><div class="panel-heading">Documents to upload</div><div class="panel-body"><table class="table table-striped table-bordered"><thead><tr><th style="width:50%">ROW Rules 2024</th><th style="width:50%">List of Documents</th></tr></thead><tbody><tr><td>A copy of the authorisation under the Telecommunications Act, 2023 (44 of 2023), or license granted under the Indian Telegraph Act, 1885 (13 of 1885)</td><td>A copy of the license/ registration/ Exemption certificate granted by the Department of Telecommunication Govt of India</td></tr><tr><td>Details of the nature of land and location</td><td>Details of the ownership and use of land and location map</td></tr><tr><td>Details of technical design and drawings of the post</td><td>Technical Drawing for Tower and Foundations or other above-ground contrivances OR other specific details</td></tr><tr><td>Copy of the approval issued by the Central Government (part of SACFA clearances)</td><td>Copy of SACFA Clearance</td></tr><tr><td>Details of specific measures proposed to be taken to ensure public safety during the execution of the work</td><td>Undertaking to take care of loss or injury to accident caused during Execution.</td></tr><tr><td>Undertaking related to any damage to the property, including restoration of the property to its state, facility provider shall pay compensation for such damage as may be mutually agreed.</td><td>Undertaking for the damage to the property caused to the infrastructure claims</td></tr><tr><td>Details of the extent of land / floor space required</td><td>1- Layout Plan / Site Plan<br>2- Photograph of land</td></tr><tr><td>Details of the mode of and the estimated time duration for execution of the work, contact details</td><td>Fill in the online form</td></tr><tr><td>Details of the need of facility provider for access to the telecommunication network sought to be established</td><td>Technical Note/ Justification of the necessity of the proposed infrastructure</td></tr><tr><td>Where applicable, copy of the certification by a structural engineer authorised by a public entity, attesting to the structural safety of the Tower</td><td>1- Structural stability certificate for Building from State Government authorized Structural Engineer.<br>2- Soil Bearing Test Report Foundation design certificate from Authorised Structural Engineer.</td></tr></tbody></table></div></div><!-- Documents to upload: shown only for Other Than Public Property + Ground tower. --><div class="panel panel-primary" ng-if="(((vm.serviceFormFieldData | filter:{formfieldName:\'Property\'}:true)[0].formfieldvalue || \'\') | lowercase).trim() == \'other than public property\'\n              && (((vm.serviceFormFieldData | filter:{formfieldName:\'Ground/Roof Top Tower\'}:true)[0].formfieldvalue || \'\') | lowercase).trim() == \'ground\'"><div class="panel-heading">Documents to upload</div><div class="panel-body"><table class="table table-striped table-bordered"><thead><tr><th style="width:50%">ROW Rules 2024</th><th style="width:50%">List of Documents</th></tr></thead><tbody><tr><td>Share the consent letter and registered agreement copy with the person who has ownership, control, or management such property</td><td>lease agreement deed, NOC/ Consent Letter by Land owner</td></tr><tr><td>details of the inconvenience that is likely to be caused to the public and the specific measures proposed to be taken to mitigate such inconvenience</td><td>Undertaking for Public Inconvenience and Mitigation Measures</td></tr><tr><td>Details of technical design and drawings of the post or other above-ground contrivances</td><td>Technical Drawing for Tower and Foundations</td></tr><tr><td>Where applicable, copy of the certification by a structural engineer authorised by a public entity, attesting to the structural safety of the Tower</td><td>Structural Stability Certificate for Tower including Foundation</td></tr><tr><td>Any document found incorrect, false or misleading a) will be treated as violation of relevant license or authorization b) appropriate action shall be taken as per applicable law by State / UT C) PE concerned may take action according to law and financial loss will be borne by Facility Provider</td><td>Undertaking by Applicant</td></tr></tbody></table></div></div><!-- Documents to upload: shown only for Public Property + Roof Top tower. --><div class="panel panel-primary" ng-if="(((vm.serviceFormFieldData | filter:{formfieldName:\'Property\'}:true)[0].formfieldvalue || \'\') | lowercase).trim() == \'public property\'\n              && (((vm.serviceFormFieldData | filter:{formfieldName:\'Ground/Roof Top Tower\'}:true)[0].formfieldvalue || \'\') | lowercase).trim() == \'roof top\'"><div class="panel-heading">Documents to upload</div><div class="panel-body"><table class="table table-striped table-bordered"><thead><tr><th style="width:50%">ROW Rules 2024</th><th style="width:50%">List of Documents</th></tr></thead><tbody><tr><td>Details of the location</td><td>1- Location Plan showing the site with reference to the surrounding existing developments duly signed by Applicant.</td></tr><tr><td>Covered in layout / Site plan</td><td>Layout Plan / Site Plan<br>Photograph of Building</td></tr><tr><td>details of the inconvenience that is likely to be caused to the public and the specific measures proposed to be taken to mitigate such inconvenience</td><td>Undertaking for Public Inconvenience and Mitigation Measures</td></tr><tr><td>A copy of the authorisation under the Telecommunications Act, 2023 (44 of 2023), or license granted under the Indian Telegraph Act, 1885 (13 of 1885)</td><td>A copy of the license/ registration/ Exemption certificate granted by the Department of Telecommunication Govt of India</td></tr><tr><td>Details of the location</td><td>1- Location Plan showing the site with reference to the surrounding existing developments duly signed by Applicant</td></tr><tr><td>Copy of the approval issued by the Central Government (part of SACFA clearances)</td><td>Copy of SACFA Clearance</td></tr><tr><td>Where applicable, a copy of the certification of the technical design by a structural engineer authorised by a public entity attesting to the structural safety of the Tower and Building Structure</td><td>1- Structural stability certificate of Building from State Government authorized Structural Engineer.</td></tr><tr><td>Details of the need of facility provider for access to the telecommunication network sought to be established</td><td>Technical Note/ Justification of the necessity of the proposed infrastructure</td></tr><tr><td>Details of the building or structure where the establishment of the mobile tower or pole is proposed</td><td>Update online in the Form</td></tr></tbody></table></div></div><!-- Documents to upload: shown only for Other Than Public Property + Roof Top tower. --><div class="panel panel-primary" ng-if="(((vm.serviceFormFieldData | filter:{formfieldName:\'Property\'}:true)[0].formfieldvalue || \'\') | lowercase).trim() == \'other than public property\'\n              && (((vm.serviceFormFieldData | filter:{formfieldName:\'Ground/Roof Top Tower\'}:true)[0].formfieldvalue || \'\') | lowercase).trim() == \'roof top\'"><div class="panel-heading">Documents to upload</div><div class="panel-body"><table class="table table-striped table-bordered"><thead><tr><th style="width:50%">ROW Rules 2024</th><th style="width:50%">List of Documents</th></tr></thead><tbody><tr><td>Share the consent letter and registered agreement copy with the person who has ownership, control, or management such property</td><td>lease agreement deed, NOC/ Consent Letter by Land owner</td></tr><tr><td>details of the inconvenience that is likely to be caused to the public and the specific measures proposed to be taken to mitigate such inconvenience</td><td>Undertaking for Public Inconvenience and Mitigation Measures</td></tr><tr><td>Details of technical design and drawings of the post or other above-ground contrivances</td><td>Technical Drawing for Tower and Foundations</td></tr><tr><td>Where applicable, copy of the certification by a structural engineer authorised by a public entity, attesting to the structural safety of the Tower</td><td>Structural Stability Certificate for Tower and Building including Foundation</td></tr><tr><td>Any document found incorrect, false or misleading a) will be treated as violation of relevant license or authorization b) appropriate action shall be taken as per applicable law by State / UT C) PE concerned may take action according to law and financial loss will be borne by Facility Provider</td><td>Undertaking by Applicant</td></tr></tbody></table></div></div><!-- Documents to upload: shown only for Category = RoW Fiber + Public Property. --><div class="panel panel-primary" ng-if="(((vm.serviceFormFieldData | filter:{formfieldName:\'Category\'}:true)[0].formfieldvalue || \'\') | lowercase).trim() == \'row fiber\'\n              && (((vm.serviceFormFieldData | filter:{formfieldName:\'Property\'}:true)[0].formfieldvalue || \'\') | lowercase).trim() == \'public property\'"><div class="panel-heading">Documents to upload</div><div class="panel-body"><table class="table table-striped table-bordered"><thead><tr><th style="width:50%">ROW Rules 2024</th><th style="width:50%">List of Documents</th></tr></thead><tbody><tr><td>A copy of the authorisation under the Telecommunications Act, 2023 (44 of 2023), or license granted under the Indian Telegraph Act, 1885 (13 of 1885)</td><td>A copy of the license/ registration/ Exemption certificate granted by the Department of Telecommunication Govt of India</td></tr><tr><td>Details of the proposed underground / overground telecom network.</td><td>1- Route plan on Index map and possible interference with other public infrastructure.<br>2- Single Line Diagram</td></tr><tr><td>Details of specific measures proposed to be taken to ensure public safety during the execution of the work</td><td>Undertaking to take care of loss or injury to accident caused during Execution.</td></tr><tr><td>Details of technical design and drawings of the post or other above-ground contrivances</td><td>Route plan on Index map and possible interference with other public infrastructure</td></tr><tr><td>Details of the mode of and the estimated time duration for execution of the work, contact details, estimated expense</td><td>Fill in the online form</td></tr><tr><td>A copy of as-built drawings of such telecommunication network if the right of way pertains to existing network</td><td>A copy of as-built drawings of existing network OR other specific details</td></tr><tr><td>Details of the intended work timing (if specific daytime execution is proposed).</td><td>Details of specific time at which Applicant wants to work, duly signed by User Agency</td></tr><tr><td>Details of access to the telecommunication network sought to be established requirements for operations and maintenance.</td><td>Technical Note/ Justification of the necessity of the proposed infrastructure</td></tr><tr><td>details of the inconvenience that is likely to be caused to the public and the specific measures proposed to be taken to mitigate such inconvenience</td><td>Undertaking for Public Inconvenience and Mitigation Measures</td></tr></tbody></table></div></div><div class="modal-body jumbotron"><jhi-alert-error></jhi-alert-error><div class="form-group"><div class="col-lg-12 panel-body"><div class="col-md-8"><div class="col-md-4"><label class="control-label">File Description:</label></div><div class="col-md-4"><label class="control-label" style="margin-left: 18px">Upload Documents</label></div></div><div class="col-md-2"><button ng-show="vm.show" ng-click="vm.download_appendix()" type="button" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-download-alt"></span> &nbsp Appendix 7</button></div><div class="col-md-2"><button ng-show="vm.projectService.serviceid===\'58d75fd4-f360-4931-a484-ff9be0adc12c\'" ng-click="vm.clear()" uk-toggle="target: #modal-above" type="button" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-eye-open"></span> &nbsp Prerequisites</button> <button ng-show="vm.projectService.serviceid===\'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\'" ng-click="vm.clear()" uk-toggle="target: #modal-below" type="button" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-eye-open"></span> &nbsp Prerequisites</button> <button ng-show="vm.projectService.serviceid===\'741f0f60-cf69-4659-8b19-19d96ffe0103\'" ng-click="vm.clear()" uk-toggle="target: #modal-above" type="button" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-eye-open"></span> &nbsp Prerequisites</button></div></div><div class="col-lg-3"><input type="text" class="form-control" ng-model="vm.serviceformattachment.description" name="description" ng-maxlength="50"><p ng-show="myForm.description.$error.maxlength"><font size="2px" color="red">Max letters exceeded (50)</font></p></div><div class="col-lg-7"><input type="file" id="browsefile" class="form-control" file-model="vm.serviceformfile" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div><button type="button" id="fileupload" class="btn btn-success" ng-disabled="vm.serviceformattachment.description==undefined || vm.serviceformattachment.description==\'\' || vm.serviceformfile==undefined || vm.serviceformfile==\'\' || file.maxSizeError" data-dismiss="modal" ng-click="vm.addfileattachment()"><span class="glyphicon glyphicon-open"></span> &nbsp Upload</button><div class="col-lg-12" ng-show="(vm.fileattach.length!=0)"><table class="table table-striped table-hover"><thead><tr><th>Description</th><th>File Name</th><th>Action</th></tr></thead><tbody><tr ng-repeat="fileattach in vm.fileattach"><td>{{fileattach.description}}</td><td>{{fileattach.clientfilename}}</td><td><button type="button" class="btn btn-danger pull-center btn-sm" value="Deletephase" data-dpmaxz-eid="41" ng-click="vm.removeRawRow(fileattach.id)"><span class="glyphicon glyphicon-remove-sign"></span>&nbsp Delete</button></td></tr></tbody></table></div></div></div><div class="form-group alert alert-dismissible alert-danger" ng-show="vm.projectService.serviceName==\'5G Application Form\'"><label class="control-label" style="display: inline">The list of locations in Excel format is mandatory for upload. Kindly download the 5G Application Form Excel template and upload it in the specified format:</label><a style="margin-left: 10px; display: inline-block" class="btn btn-sm btn-info" href="../../content/pdfs/5G_Sample_Form.xlsx">Format <span class="glyphicon glyphicon-download-alt"></span></a></div><div class="form-group form-group alert alert-dismissible alert-danger" ng-show="vm.projectService.serviceName==\'5G Application Form\'"><label class="control-label">Note: Users can upload multiple documents. Please utilize the file upload feature to submit both the \'Downloaded Excel/CSV Format\' and the \'Structural Safety Certificate\' individually.</label></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Clear</button> <button type="button" ng-click="vm.saveAsDraft()" class="btn btn-primary btn-sm" ng-disabled="(vm.isSaving)"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save As Draft</span></button> <button type="submit" class="btn btn-primary" ng-disabled="(vm.isSaving) || (myForm.$invalid)"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Submit</span></button></div></form><div id="modal-above" class="uk-modal-container" uk-modal><div class="uk-modal-dialog uk-modal-body" uk-overflow-auto><button class="uk-modal-close-default" type="button" uk-close></button><div><h3>Document (Mandatory)</h3><p>1. A copy of the license/registration certificate granted by the Department of Telecommunication (DoT) Ministry of communication Government of India.</p><p>2. Location Plan (Scale 1:1000) showing the site with reference to the surrounding existing developments</p><p>3. The detailed technical design and drawings of the tower/post or other aboveground infrastructure including the specification of foundation. In case the tower /post etc. is in the vicinity or adjoining to high or low tension line, then its distance from the same shall be clearly indicated in the drawings</p><p>4. Copy of certification of the technical design and Structural Stability/safety certificate for the building and tower/post as per sub para 10.3 of para 10 of the policy (Prescribed Format)</p><p>5. Time schedule (Stretch-wise) for completion of the work.</p><p>6. Copy of the type test certificate issued by Automotive Research Association of India (ARAI) to the manufactures of the DG sets, in case DG is to be installed</p><p>7. Attested copy of lease Agreement Deed/Consent Agreement Deed, signed by the applicant and the owner of the site/building.</p><p>8. Copy of SACFA clearance/copy of SACFA application for the said location submitted to Wireless Planning & Coordination (WPC) wing of DoT with registration number as WPC acknowledgement along with undertaking that in case of any objection/rejection, licensee will take corrective actions/remove the tower.</p><p>9. Acknowledgement receipt issued by TERM Cell of the self-certificate submitted by Applicant in respect of mobile tower/Base Transceiver Station (BTS) establishing/ certifying that all general public areas around the tower will be within safe Electro Magnetic Radiation (EMR) exposure limit as per peak traffic measurement after the antennas starts radiating. *{Note: - It can be submitted within 30 days after radiating the tower}.</p><p>10. Indemnity bond to indemnify the Government/ Local Body/ Authority in the prescribed format against (i) any liability for the damage caused to the infrastructure laid by the applicant for any reasons, and (ii) claims against any accidents on account of the infrastructure laid/ facilities installed or against any claims thereafter during the period of Operation & Maintenance of such infrastructure at all times.</p><p>11. Undertaking as per Appendix-7 (prescribed format)<!--&nbsp;<button ng-click="vm.clear()" class="uk-button uk-button-primary uk-button-small" type="button" style="font-size: 10px">Downloadddddd</button>--></p><h3>Document (Optional)</h3><p>1. For Forest/Protected Areas, the copy of clearance from State Environment & Forest Department, if applicable.</p><p>2. Fire NOC</p><p>3. Ownership document of the building/site. (Attested copy)</p><p>4. Copy of no objection certificate issued by the Fire Safety Department in case of high rise buildings where fire clearance is mandatory</p><p>5. In case the permission is sought in the land/premises of any office of Central Government or a PSU of Central Government, the prior written consent copy of agreement from the authority having legitimate right over the land/premises shall be attached with the applicatio</p></div><div class="uk-text-right"><button class="uk-button uk-button-primary uk-modal-close" type="button" style="font-size: 12px">Proceed</button></div></div></div><div id="modal-below" class="uk-modal-container" uk-modal><div class="uk-modal-dialog uk-modal-body" uk-overflow-auto><button class="uk-modal-close-default" type="button" uk-close></button><div><h3>Document (Mandatory)</h3><p>1. A copy of relevant license/infrastructure provider registration certificate granted by the DoT</p><p>2. Detail of the location of map showing the proposed underground or over ground OFC/telegraph infrastructure including route planned, exact latitude and longitude, nature of land</p><p>3. The copy of consent of the owner of land/building where the OFC/telegraph infrastructure proposed to be laid</p><p>4. Time schedule (Stretch-wise) for completion of the work</p><p>5. Indemnity bond to indemnify the Government/ Local Body/ Authority in the /prescribed format against (i) any liability for the damage caused to the infrastructure laid by the applicant for any reasons, and (ii) claims against any accidents on account of the infrastructure laid/ facilities installed or against any claims thereafter during the period of Operation & Maintenance of such infrastructure at all times</p><p>6. Undertaking as per Appendix-7 (Prescribed Format)<!--&nbsp;<button ng-click="vm.download_appendix()" class="uk-button uk-button-primary uk-button-small" type="button" style="font-size: 10px">Download</button>--></p><h3>Document (Optional)</h3><p>1. For forest/protected areas, the copy of clearance from State Environment & Forest Department</p><p>2. The detailed technical design and drawings of the post or other above ground contrivances (in case of over ground cabling)</p></div><div class="uk-text-right"><button class="uk-button uk-button-primary uk-modal-close" type="button" style="font-size: 12px">Proceed</button></div></div></div>');
$templateCache.put('app/serviceclearanceactions/serviceFormFilled.html','<div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success pull-right"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><form id="myForm" name="myForm" class="form-horizontal" role="form"><div id="pdf_data" class="panel"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">{{vm.departmentservice.departmentname}} : {{vm.departmentservice.serviceName}}</h4><h5 class="pull-left">CafPin : {{vm.project.cafpin}}</h5><h5 class="pull-right">Application Date : {{vm.projectService.formFilledOnDate | date:\'mediumDate\'}}</h5></div><div class="panel-body"><div ng-repeat="field in vm.serviceFormFieldData | orderBy : \'formfieldOrder\'" class="form-horizontal"><div class="row"><div class="col-sm-6"><label class="control-label pull-right">{{field.formfieldName}}</label></div><div class="col-sm-6"><label class="control-label">{{field.formfieldvalue}}</label></div></div></div><br><div class="col-lg-offset-2 col-lg-8"><center><table class="table table-striped table-responsive table-hover"><thead><tr><th class="col-lg-6">File Description</th><th class="col-lg-2">Action</th></tr></thead><tbody><tr ng-repeat="serviceformattachment in vm.serviceformattachments"><td>{{serviceformattachment.description}}</td><td><button type="button" class="btn btn-success pull-center btn-sm" ng-click="vm.downloadFile(serviceformattachment.serverfilename,serviceformattachment.downloadfilename)"><span class="glyphicon glyphicon-download-alt"></span></button></td></tr></tbody></table></center></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/serviceclearanceactions/serviceLog.html','<div class="container-fluid"><div class="row"><div class="col-md-12"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><div id="pdf_data"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">Service Log</h4><h4 class="text-center"><b>{{vm.service.serviceName}}</b></h4></div><div class="modal-body"><div ng-show="vm.projectService.serviceid===\'bdb451cb-f12b-4352-8360-e6e3a715386f\' && vm.tokenFound"><div class="pull-left"><strong>Unique Id:</strong><span>{{\' \'+vm.nmatoken.cafpin}}</span><br></div><div class="pull-right"><strong>Token:</strong><span>{{\' \'+vm.nmatoken.nmatoken}}</span></div></div><br><table class="jh-table table table-striped table-responsive"><thead><tr><th><span>Action Taken</span></th><th><span>Date</span></th><th><span>Action By</span></th><th><span>Comments</span></th><th><span>Rejection Reason</span></th><th><span>Reason Category</span></th><th><span>Attachment</span></th></tr></thead><tbody><tr ng-repeat="servicelog in vm.ServiceLog | orderBy:\'-commentDate\'"><td>{{vm.actionLabel(servicelog)}}</td><td>{{servicelog.commentDate | date:\'dd-MM-yyyy\'}}</td><td>{{servicelog.commentByUserLogin}}</td><td class="break-line">{{vm.commentText(servicelog)}}</td><td>{{servicelog.rejectionReason}}</td><td class="break-line">{{servicelog.reasonCategory}}</td><td><button ng-if="vm.account.authorities.indexOf(\'ROLE_USER\')==-1" ng-show="(servicelog.fileName) || ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))" id="myBtn" type="button" class="btn btn-primary" ng-click="vm.downFile(servicelog)">Download</button></td><td><button ng-if="vm.account.authorities.indexOf(\'ROLE_USER\')>-1" ng-show="(servicelog.fileName) || ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))" id="myBtn1" type="button" class="btn btn-primary" ng-click="vm.userFile(servicelog)">Download</button></td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></div></div></div><div id="ratings" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><form name="form" role="form" novalidate ng-submit="vm.saveRating()" show-validation><div class="modal-content"><div class="row"><div class="modal-header"><div class="col-md-12"><h4 class="modal-title" id="Rate"><b>Rate Us</b></h4><span>Thank you for using the Invest Haryana portal! We value your feedback. Please rate your experience with <b>{{vm.service.serviceName}}</b> and share any comments to help us improve.</span></div><div class="col-md-2"><p><a class="fa fa-facebook-square" style="font-size:24px;text-decoration: none !important" target="_blank" href="https://www.facebook.com/investharyana/"></a> <a class="fa fa-twitter-square" style="font-size:24px;color: #1da1f2;text-decoration: none !important" target="_blank" href="https://twitter.com/investharyana/"></a> <a class="fa fa-linkedin-square" style="font-size:24px;color:#0077B5;text-decoration: none !important" target="_blank" href="https://www.linkedin.com/company/investharyana/"></a></p></div></div></div><div class="modal-body col-md-12"><div class="form-group"><div class="row col-md-12" style="margin-left: 7px"><span>Were you required to manually submit the application fee? <input type="radio" id="isFeeManuallySubmityes" ng-value="true" ng-model="vm.rating.isFeeManuallySubmit" name="isFeeManuallySubmit" value="yes"><label for="isFeeManuallySubmityes">Yes</label><input type="radio" id="isFeeManuallySubmitno" ng-value="false" ng-model="vm.rating.isFeeManuallySubmit" name="isFeeManuallySubmit" value="no"><label for="isFeeManuallySubmitno">No</label></span><br><span>Were you required to submit physical copy of the document at any stage of the application process? <input type="radio" id="isDocPhysicallySubmityes" ng-value="true" ng-model="vm.rating.isDocPhysicallySubmit" name="isDocPhysicallySubmit" value="yes"><label for="isDocPhysicallySubmityes">Yes</label><input type="radio" id="isDocPhysicallySubmitno" ng-value="false" ng-model="vm.rating.isDocPhysicallySubmit" name="isDocPhysicallySubmit" value="no"><label for="isDocPhysicallySubmitno">No</label></span><br><span>Were you able to get the final approval with a defined timeline? <input type="radio" id="isApprovalOnTimeyes" ng-value="true" ng-model="vm.rating.isApprovalOnTime" name="isApprovalOnTime" value="yes"><label for="isApprovalOnTimeyes">Yes</label><input type="radio" id="isApprovalOnTimeno" ng-value="false" ng-model="vm.rating.isApprovalOnTime" name="isApprovalOnTime" value="no"><label for="isApprovalOnTimeno">No</label></span><br><span>Could you able to download the final certificate/NOC from the portal? <input type="radio" id="isCertificateDownloadyes" ng-value="true" ng-model="vm.rating.isCertificateDownload" name="isCertificateDownload" value="yes"><label for="isCertificateDownloadyes">Yes</label><input type="radio" id="isCertificateDownloadno" ng-value="true" ng-model="vm.rating.isCertificateDownload" name="isCertificateDownload" value="no"><label for="isCertificateDownloadno">No</label></span><br><span>Did you physically visit the department to either submit the application or during the process of application? <input type="radio" id="isPhysicallyVisitYes" ng-value="true" ng-model="vm.rating.isPhysicallyVisit" name="isPhysicallyVisit" value="yes"><label for="isPhysicallyVisitYes">Yes</label><input type="radio" id="isPhysicallyVisitNo" ng-value="false" ng-model="vm.rating.isPhysicallyVisit" name="isPhysicallyVisit" value="no"><label for="isPhysicallyVisitNo">No</label></span><br><br></div></div><div class="form-group"><div class="radio-group rating"><span style="margin-left: 20px"><b>Rate</b></span>&nbsp;&nbsp;&nbsp;&nbsp; <input type="radio" id="star5" name="rating" ng-model="vm.rating.rating" value="Excellent"><label for="star5" title="Excellent">5 stars</label><input type="radio" id="star4" name="rating" ng-model="vm.rating.rating" value="Very Good"><label for="star4" title="Very Good">4 stars</label><input type="radio" id="star3" name="rating" ng-model="vm.rating.rating" value="Good"><label for="star3" title="Good">3 stars</label><input type="radio" id="star2" name="rating" ng-model="vm.rating.rating" value="Average"><label for="star2" title="Average">2 stars</label><input type="radio" id="star1" name="rating" ng-model="vm.rating.rating" value="Poor" required><label for="star1" title="Poor">1 stars</label></div></div><br><div class="row col-md-12"><label class="col-md-2" style="padding-bottom: 10px">Remarks &nbsp;&nbsp;&nbsp;</label><textarea rows="4" cols="200" class="col-md-8" type="text" name="comment" ng-model="vm.rating.comment" ng-required="vm.rating.rating ==\'Poor\' || vm.rating.rating ==\'Average\' || vm.rating.rating ==\'Good\'"></textarea></div></div><div class="modal-footer"><button type="submit" class="btn btn-primary" ng-disabled="form.$invalid">Submit</button> <button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></form></div></div>');
$templateCache.put('app/serviceclearanceactions/servicePayment.html','<!--<form name="editForm" role="form" method="post" action="https://secure.payu.in/_payment">--><form name="editForm" role="form" method="post" action="https://test.payu.in/_payment"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Payment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Amount : Rs. {{vm.projectServicePayment.paymentMade}}</label></div></div><div class="modal-footer"><input type="hidden" name="firstname" value="{{vm.paymentparameters.firstname}}"> <input type="hidden" name="surl" value="{{vm.paymentparameters.surl}}"> <input type="hidden" name="phone" value="{{vm.paymentparameters.phone}}"> <input type="hidden" name="key" value="{{vm.paymentparameters.key}}"> <input type="hidden" name="hash" value="{{vm.paymentparameters.hash}}"> <input type="hidden" name="furl" value="{{vm.paymentparameters.furl}}"> <input type="hidden" name="txnid" value="{{vm.paymentparameters.txnid}}"> <input type="hidden" name="productinfo" value="{{vm.paymentparameters.productinfo}}"> <input type="hidden" name="amount" value="{{vm.paymentparameters.amount}}"> <input type="hidden" name="email" value="{{vm.paymentparameters.email}}"> <input type="hidden" name="udf1" value="{{vm.paymentparameters.udf1}}"> <input type="hidden" name="udf2" value="{{vm.paymentparameters.udf2}}"> <input type="hidden" name="udf3" value="{{vm.paymentparameters.udf3}}"> <button type="submit" id="payubutton1" class="btn btn-info btn-sm">Proceed to Pay</button></div></form>');
$templateCache.put('app/serviceclearanceactions/serviceclearance.html','<form name="editForm" role="form" ng-submit="vm.clearService()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Service Clearance</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" id="textArea" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editForm.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/serviceclearanceactions.html','<div class="row"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">{{vm.title}}</h3></div><div class="panel-body"><div class="col-md-3 filter-margin text-right"><label for="filterDept" class="uk-label uk-label-danger" style="font-size: 12px"><span data-translate="global.viewcaf.Filter">Filter</span> :</label></div><div class="col-md-5 text-center"><select id="filterDept" class="form-control custom-form-control" ng-model="vm.departmentFilter"><option value="" data-translate="global.viewcaf.All Department\'s">All Department\'s</option><option value="{{departmentName}}" ng-repeat="(departmentName, service_list) in vm.projectservicelist.projectservicedetailDTOS | orderBy: \'departmentName\' | groupBy: \'departmentName\' ">{{departmentName}}</option></select></div><div class="col-md-2 text-center"><select class="form-control custom-form-control" ng-change="vm.statusChange(vm.statusOnPage)" ng-model="vm.statusOnPage"><option value="All" data-translate="global.viewcaf.All">All</option><option value="Pending">Pending</option><option value="Required">Required</option><option value="Cleared">Cleared</option><!-- Where an Above Ground intimation ends up once it is decided. --><option value="Intimation Valid">Intimation Valid</option><option value="Intimation Invalid">Intimation Invalid</option><option value="Declined">Rejected</option><option value="Rejected">Deactivated</option></select></div><table class="jh-table table table-striped mt-60"><thead><tr><th><span data-translate="global.viewcaf.Department">Department</span></th><th><span data-translate="global.viewcaf.Service Name">Service Name</span></th><th><span data-translate="global.viewcaf.Stage">Stage</span></th><!-- With a status picked in the filter every row carries it, so the tag is only worth a column under All. --><th ng-if="vm.statusOnPage==\'All\'"><span data-translate="global.viewcaf.Status">Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectservice in vm.projectservicelist.projectservicedetailDTOS | filter: {departmentName: vm.departmentFilter, status: vm.statusFilter} | filter: {formFilledStatus: vm.formStatus} | orderBy:[\'departmentName\',\'serviceName\']"><td ng-if="projectservice.departmentName!==\'Communication and Connectivity Permissions\'">{{projectservice.departmentName}}</td><td ng-if="projectservice.departmentName===\'Communication and Connectivity Permissions\'">NA</td><td>{{projectservice.serviceName}}</td><td>{{projectservice.serviceStage}}</td><td ng-if="vm.statusOnPage==\'All\'"><span class="uk-label {{vm.statusTagClass(projectservice.status)}}">{{vm.statusName(projectservice.status)}}</span></td><td class="text-left"><a has-any-authority="ROLE_USER" target="_blank" type="button" class="btn btn-info btn-sm" ng-show="projectservice.isRequired && projectservice.serviceName !== \'Certificate of Verification of weights and measures\'" ui-sref="view-checklist({serviceid:projectservice.serviceid})"><span data-translate="global.viewcaf.Check List">Check List</span></a> <a has-any-authority="ROLE_USER" target="_blank" type="button" class="btn btn-info btn-sm" ng-show="projectservice.serviceName === \'Certificate of Verification of weights and measures\'" href="../../content/pdfs/Check list for Reverification RVWM PDF.pdf"><span data-translate="global.viewcaf.Check List">Check List</span></a> <button has-any-authority="ROLE_USER" ng-disabled="vm.isSaving" type="submit" ng-show="projectservice.isRequired && projectservice.serviceName===\'Regularization of existing Tower/Renewal (Above ground)\' && projectservice.isShowchoosedept && projectservice.status==\'Pending\'" data-toggle="modal" data-target="#tower_department1" ng-click="vm.tower_departments(projectservice,\'tower\')" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Choose Department">Choose Department</span></button> <button has-any-authority="ROLE_USER" ng-disabled="vm.isSaving" type="submit" ng-show="projectservice.isRequired && projectservice.serviceName===\'Communication and Connectivity Permissions/Renewal(Below Ground)\' && projectservice.isShowchoosedept && projectservice.status==\'Pending\'" data-toggle="modal" data-target="#tower_department1" ng-click="vm.tower_departments(projectservice,\'tower\')" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Choose Department">Choose Department</span></button> <button has-any-authority="ROLE_USER" ng-disabled="vm.isSaving" type="submit" ng-show="projectservice.isRequired && projectservice.serviceName===\'Communication and Connectivity Permissions/Renewal(Above Ground)\' && projectservice.isShowchoosedept && projectservice.status==\'Pending\'" data-toggle="modal" data-target="#tower_department1" ng-click="vm.tower_departments(projectservice,\'tower\')" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Choose Department">Choose Department</span></button> <button has-any-authority="ROLE_DEPT_CHANGE" ng-disabled="vm.isSaving" type="submit" ng-show="projectservice.isRequired && (projectservice.serviceName === \'Communication and Connectivity Permissions/Renewal(Above Ground)\' || projectservice.serviceName===\'Regularization of existing Tower/Renewal (Above ground)\' || projectservice.serviceName===\'Right of Way / Right of Use to CABLE TV Operators\' || projectservice.serviceName===\'Renewal/Extension of Communication and Connectivity Permissions\') && projectservice.status==\'Pending\'" data-toggle="modal" data-target="#tower_department2" ng-click="vm.tower_departments(projectservice,\'tower\')" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Update Department">Update Department</span></button> <button has-any-authority="ROLE_DEPT_CHANGE" ng-disabled="vm.isSaving" type="submit" ng-show="projectservice.isRequired && (projectservice.serviceName===\'Communication and Connectivity Permissions/Renewal(Below Ground)\') && projectservice.status==\'Pending\'" data-toggle="modal" data-target="#tower_department2" ng-click="vm.tower_departments(projectservice,\'tower\')" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Update Department">Update Department</span></button> <button ng-disabled="vm.isSaving" type="submit" class="btn btn-info btn-sm" ng-click="vm.fillform(projectservice,\'reApply\')" ng-show="vm.showReApply(projectservice)"><span data-translate="global.viewcaf.Re-Apply">Re-Apply</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_ACCOUNT_OFFICER,ROLE_FIELD_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER,ROLE_DEPT_CHANGE,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD,ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_TICKET_ADMIN" type="submit" ui-sref="serviceLog({projectserviceid:projectservice.id,projectid:projectservice.projectid,serviceid:projectservice.serviceid})" ng-disabled="vm.isSaving" ng-show="(projectservice.isRequired==true)" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.View Service Log">View Service Log</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_ACCOUNT_OFFICER,ROLE_FIELD_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER,ROLE_DEPT_CHANGE,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD,ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_TICKET_ADMIN" type="submit" ui-sref="serviceclearanceactionforsurvey({projectserviceid:projectservice.id})" ui-sref-opts="{reload: true}" ng-disabled="vm.isSaving" ng-show="projectservice.isRequired === true && projectservice.surveyFormFilled === false && ([\'741f0f60-cf69-4659-8b19-19d96ffe0103\',\'58d75fd4-f360-4931-a484-ff9be0adc12c\',\'6f81801c-59c6-4773-9f37-a5d81172a1bf\',\'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\',\'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\'].includes(projectservice.serviceid))" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Fill Survey Form">Fill Survey Form</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_ACCOUNT_OFFICER,ROLE_FIELD_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER,ROLE_DEPT_CHANGE,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD,ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_TICKET_ADMIN" type="submit" ui-sref="serviceclearanceactionforbankgurantee({projectserviceid:projectservice.id,district:vm.district,\n                                projectid:projectservice.projectid,serviceid:projectservice.serviceid})" ui-sref-opts="{reload: true}" ng-disabled="vm.isSaving" ng-show="projectservice.isRequired === true && ([\'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\'].includes(projectservice.serviceid)) && projectservice.bankguranteeassigned===true && projectservice.bankGuranteeFilled === false" class="btn btn-info btn-sm"><span>Fill Bank Gurantee</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_ACCOUNT_OFFICER,ROLE_FIELD_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER,ROLE_DEPT_CHANGE,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD,ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_TICKET_ADMIN" type="submit" ui-sref="serviceclearanceactionforbankguranteeusingprojectserviceid({projectserviceid:projectservice.id,district:vm.district,\n                                projectid:projectservice.projectid,serviceid:projectservice.serviceid})" ui-sref-opts="{reload: true}" ng-disabled="vm.isSaving" ng-show="projectservice.isRequired === true\n             && projectservice.bankGuranteeFilled === true && projectservice.bankguranteeassigned===true\n             && ([\'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\'].includes(projectservice.serviceid))" class="btn btn-info btn-sm"><span>View Bank Gurantee</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_ACCOUNT_OFFICER,ROLE_FIELD_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER,ROLE_DEPT_CHANGE,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD,ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_TICKET_ADMIN" type="submit" ui-sref="serviceclearanceactionforbankguranteeusingprojectserviceidforedit({projectserviceid:projectservice.id,district:vm.district})" ui-sref-opts="{reload: true}" ng-disabled="vm.isSaving" ng-show="projectservice.isRequired === true\n             && projectservice.bankGuranteeFilled === true\n             && ([\'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\'].includes(projectservice.serviceid))" class="btn btn-info btn-sm"><span>Edit Bank Gurantee</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_ACCOUNT_OFFICER,ROLE_FIELD_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER,ROLE_DEPT_CHANGE,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD,ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_TICKET_ADMIN" type="submit" ui-sref="serviceclearanceactionforsurveyformview({projectserviceid:projectservice.id})" ui-sref-opts="{reload: true}" ng-disabled="vm.isSaving" ng-show="projectservice.isRequired === true && projectservice.surveyFormFilled === true" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.View Survey Form">View Survey Form</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_USER" type="submit" ui-sref="acknowledgement({projectserviceid:projectservice.id,projectid:projectservice.projectid,serviceid:projectservice.serviceid, cafpin:vm.cafpinNew})" ng-disabled="vm.isSaving" ng-show="(projectservice.formFilledStatus==true) && (projectservice.serviceid ==\'0f37cdd6-9816-4df2-89bf-40da4bd44a1c\' || projectservice.serviceid ==\'60ea068a-2228-41b7-9a85-bea22bd09931\' || projectservice.serviceid ==\'759fed25-8e75-4fba-8e6f-c06f770731aa\' || projectservice.serviceid ==\'b02da13b-01d6-4c95-93b0-3e377455e430\') && (projectservice.status==\'Pending\')" class="btn btn-info btn-sm"><span>View Acknowledgment</span></button><!-- Approval for establishment of Telegraph Infrastructure, issued when the\n                                 service form of a tower on a property other than public property was filled.\n                                 Only Communication and Connectivity Permissions/Renewal(Above Ground) carries one. --> <a has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICER,ROLE_TOWER_OFFICER,ROLE_TOWER_DC,ROLE_TOWER_DIO" ng-if="projectservice.acknowledgementFile && projectservice.serviceid==\'58d75fd4-f360-4931-a484-ff9be0adc12c\'" ng-href="/api/downloadserviceformattachment?serverfilename={{projectservice.acknowledgementFile}}&downloadfilename={{projectservice.acknowledgementFile}}" target="_blank" class="btn btn-info btn-sm"><span>Download Acknowledgement</span> </a><a has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICER,ROLE_TOWER_OFFICER,ROLE_TOWER_DC,ROLE_TOWER_DIO" ng-if="projectservice.serviceid==\'240d2c66-b6cc-4a0c-b5f0-3f6717177810\'" ng-href="/api/downloadserviceformattachment?serverfilename={{projectservice.acknowledgementFile}}&downloadfilename={{projectservice.acknowledgementFile}}" target="_blank" class="btn btn-info btn-sm"><span>Download Acknowledgement</span> </a><!-- The nodal officer\'s clarification on an Above Ground intimation of a\n                                 tower on a property other than public property - asked once, and only\n                                 within 15 days of the day the service form was filled. --> <button has-any-authority="ROLE_NODAL_OFFICER" type="submit" ng-disabled="vm.isSaving" ng-show="vm.canClarifyIntimation(projectservice)" ui-sref="nodalofficer-intimation-action({action:\'Revert\',projectserviceid:projectservice.id})" class="btn btn-info btn-sm"><span>Clarify</span></button><!-- ..and the officer\'s word on it once acknowledged - Approve stands it as\n                                 valid, Reject takes it away. Both write a service log. --> <button has-any-authority="ROLE_NODAL_OFFICER" type="submit" ng-disabled="vm.isSaving" ng-show="vm.canDecideIntimation(projectservice)" ui-sref="nodalofficer-intimation-action({action:\'Approve\',projectserviceid:projectservice.id})" class="btn btn-success btn-sm"><span>Approve</span></button> <button has-any-authority="ROLE_NODAL_OFFICER" type="submit" ng-disabled="vm.isSaving" ng-show="vm.canDecideIntimation(projectservice)" ui-sref="nodalofficer-intimation-action({action:\'Reject\',projectserviceid:projectservice.id})" class="btn btn-danger btn-sm"><span>Reject</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="reject-dialog({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.status==\'Pending\') && (projectservice.isRequired==true) && vm.isDeskof" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Deactivate">Deactivate</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="decline-dialog({projectserviceid:projectservice.id})" ng-show="!vm.isTowerService(projectservice) && (projectservice.status==\'Pending\') && (projectservice.isRequired==true) && (!projectservice.isIntegrated)" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Reject">Reject</span></button> <button has-any-authority="ROLE_USER" type="submit" ng-show="vm.isTowerServiceForWithdraw(projectservice) && (projectservice.status==\'Pending\') && !vm.isForceMajeure" ui-sref="withdraw-dialog({projectserviceid:projectservice.id})" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Withdraw">Withdraw</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="reactivate({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.status==\'Rejected\') && (!projectservice.isIntegrated) && vm.isDeskof" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Re-Activate">Re-Activate</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="reactivate({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.status==\'Rejected\') && (projectservice.isIntegrated) && vm.isDeskof" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Re-Activate">Re-Activate</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_RM,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_ACCOUNT_OFFICER,ROLE_FIELD_OFFICER,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER" type="submit" ui-sref="comment-dialog({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="projectservice.isRequired==true && !vm.isForceMajeure" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Comment">Comment</span></button> <button has-any-authority="ROLE_USER" type="submit" ui-sref="comment-dialog({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="projectservice.isRequired==true && projectservice.clarificationByDc!=true &&  projectservice.clarificationByTo!=true && !vm.isForceMajeure" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Comment">Comment</span></button> <button has-any-authority="ROLE_USER" type="submit" ui-sref="clarification-dialog({role:\'DC\',projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="projectservice.isRequired==true && (projectservice.clarificationByDc==true ||  projectservice.clarificationByTo==true) && !vm.isForceMajeure" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Comment">Comment</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_NODAL_OFFICER,ROLE_DESK_OFFICER,ROLE_FIELD_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="assignservice({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.isAssigned==false) && (projectservice.isRequired==true) && (projectservice.status==\'Pending\') && (!projectservice.isIntegrated)" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Assign Service Fee">Assign Service Fee</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_NODAL_OFFICER,ROLE_DESK_OFFICER,ROLE_FIELD_OFFICER" type="submit" ui-sref="assignotherservice({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.isRequired==true) && (projectservice.isAssigned==true) && (projectservice.status==\'Pending\') && (!projectservice.isIntegrated)" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Assign Other Fee">Assign Other Fee</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_FILM_OFFICER" ng-click="vm.fillform(projectservice,\'new\')" ng-disabled="vm.isSaving" ng-show="projectservice.status != \'DeemedCleared\' && vm.showFillServiceForm(projectservice) && (!((projectservice.serviceid===\'16b4d378-5723-4adc-85e9-de55da296008\') && projectservice.formFilledStatus===true) && projectservice.serviceActive===true && !vm.isForceMajeure)" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Fill Service Form">Fill Service Form</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER,ROLE_RM,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICER" ng-click="vm.fillform(projectservice,\'track\')" ng-show="vm.showTrackServiceForm(projectservice)" ng-disabled="vm.isSaving" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Track Service Form">Track Service Form</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_RM,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICER,ROLE_USER,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER" type="submit" ui-sref="viewFormFilled({projectserviceid:projectservice.id})" ng-show="(projectservice.formFilledStatus==true) && (!projectservice.isIntegrated)" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.View Service Form">View Service Form</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_USER" type="submit" ui-sref="otherServicePayment({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="projectservice.status != \'DeemedCleared\' && (projectservice.isRequired==true) && (projectservice.isAssigned==true) && (projectservice.status==\'Pending\') && (!projectservice.isIntegrated)" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Pay Fees">Pay Fees</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_ACCOUNT_OFFICER,ROLE_NODAL_OFFICER,ROLE_USER,ROLE_FIELD_OFFICER,ROLE_RM,ROLE_DESK_OFFICER,ROLE_FILM_OFFICER" type="submit" ui-sref="verifyOtherPayment({projectserviceid:projectservice.id})" ng-show="(projectservice.isRequired==true) && (projectservice.isAssigned==true) && (!projectservice.isIntegrated)" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.View Payment">View Payment</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_NODAL_OFFICER,ROLE_TOWER_DC,ROLE_FILM_OFFICER" type="submit" ui-sref="serviceClearance-action({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="!vm.isTowerService(projectservice) && (projectservice.isRequired==true) && (projectservice.status==\'Pending\') && (!projectservice.isIntegrated)" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Clearance">Clearance</span></button> <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER" type="submit" ui-sref="deemedClearance({projectserviceid:projectservice.id})" ng-disabled="vm.isSaving" ng-show="(projectservice.isDimmed) && (projectservice.status==\'Pending\')" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Deemed Clearance">Deemed Clearance</span></button><!--                            <button has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FILM_OFFICER" type="submit"--><!--                                    ui-sref="undoreject({projectserviceid:projectservice.id})"--><!--                                    ng-disabled="vm.isSaving"--><!--                                    ng-show="(projectservice.status==\'Declined\') && (!projectservice.isIntegrated)"--><!--                                    class="btn btn-info btn-sm"><span data-translate="global.viewcaf.Undo-Reject">Undo-Reject</span>--><!--                            </button>--><!-- Where an Above Ground intimation ends up, whether the officer decided it\n                                 or the scheduler did. --><label ng-show="(projectservice.status==\'Intimation Valid\')">Intimation Valid</label><label ng-show="(projectservice.status==\'Intimation Invalid\')">Intimation Invalid</label><label ng-show="(projectservice.status==\'Declined\')"><span data-translate="global.viewcaf.Service Rejected">Service Rejected</span></label><label ng-show="(projectservice.status==\'Rejected\')"><span data-translate="global.viewcaf.Service Deactivated">Service Deactivated</span></label><label ng-show="(projectservice.status==\'Cleared\')"><span data-translate="global.viewcaf.Service Cleared">Service Cleared</span></label><label ng-show="(projectservice.status==\'DeemedCleared\')"><span data-translate="global.viewcaf.Service Deemed Cleared">Service Deemed Cleared</span></label><label ng-show="(projectservice.status==\'Withdraw\')"><span data-translate="global.viewcaf.Service Withdraw">Service Withdraw</span></label></td></tr></tbody></table></div></div></div><!-- Modal --><div class="modal" id="tower_department2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="clear()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title"><span data-translate="global.viewcaf.Select New Department">Select New Department</span></h4></div><div class="modal-body"><div class="row panel-body"><div class="table-responsive" style="display:block;overflow:auto;height:400px;width:100%"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.viewcaf.Department Name">Department Name</span></th><th><span data-translate="global.addcafnew.Required">Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.tower_departmentlist" ng-show="department.istower"><td>{{department.departmentname}}</td><td><input type="checkbox" class="form-control" ng-click="vm.updateCheck(department.departmentname)" checklist-model="required.department" checklist-value="department.departmentname"></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()">Close</button> <button type="button" ng-disabled="required.department.length==0" ng-show="vm.tower_service.id!=null" class="btn btn-primary" ng-click="vm.updateTowerServiceNO(vm.tower_service.id)" data-dismiss="modal">Done</button></div></div></div></div><div class="modal" id="tower_department3" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="clear()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title"><span data-translate="global.viewcaf.Select New Department/Department\'s">Select New Department/Department\'s</span></h4></div><div class="modal-body"><div class="row panel-body"><div class="table-responsive" style="display:block;overflow:auto;height:400px;width:100%"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.viewcaf.Department Name">Department Name</span></th><th><span data-translate="global.addcafnew.Required">Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.tower_departmentlist" ng-show="department.istower"><td>{{department.departmentname}}</td><td><input type="checkbox" class="form-control" ng-click="vm.BelowGround(department.departmentname)" checklist-model="required.department" checklist-value="department.departmentname"></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()" data-translate="global.viewcaf.Close">Close</button> <button type="button" ng-disabled="required.department.length==0" ng-show="vm.tower_service.id!=null" class="btn btn-primary" ng-click="vm.updateTowerServiceNO(vm.tower_service.id)" data-dismiss="modal" data-translate="global.viewcaf.Done">Done</button></div></div></div></div><div class="modal rmPaddingModal" id="YourModalId" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="YourModalId1"><span data-translate="global.viewcaf.Select Required Department/Department\'s">Select Required Department/Department\'s</span></h4></div><div class="modal-body" ng-show="vm.municipals.length!=0"><div class="row panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.viewcaf.Department Name">Department Name</span></th><th><span data-translate="global.addcafnew.Required">Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.municipals"><td>{{department.name}}</td><td><input class="form-control" type="radio" name="myType" ng-model="vm.aboveMunicipal" value="{{department.name}}"><!--<input type="checkbox" class="form-control" ng-click="vm.updateMunicipal(department.name)" checklist-model="required.municipal" checklist-value="department.name"/>--></td></tr></tbody></table></div></div></div><div class="modal-footer" ng-show="vm.municipals.length!=0"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal()" data-translate="global.viewcaf.Close">Close</button> <button type="button" class="btn btn-primary" ng-disabled="vm.aboveMunicipal==null" ng-click="vm.markRequiredForMunicipal(vm.tower_service.id,required.department,vm.aboveMunicipal)" data-dismiss="modal" data-translate="global.viewcaf.Done">Done</button></div><div class="alert alert-warning" ng-hide="vm.municipals.length>0"><b>No</b> Department!</div></div></div></div><div class="modal rmPaddingModal" id="belowGround" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeBelow()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="belowGroundService"><span data-translate="global.viewcaf.Select Required Department/Department\'s">Select Required Department/Department\'s</span></h4></div><div class="modal-body" ng-show="vm.municipals.length!=0"><div class="row panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.viewcaf.Department Name">Department Name</span></th><th><span data-translate="global.addcafnew.Required">Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.municipals"><td>{{department.name}}</td><td><input type="checkbox" class="form-control" checklist-model="required.belowMunicipal" checklist-value="department.name"></td></tr></tbody></table></div></div></div><div class="modal-footer" ng-show="vm.municipals.length!=0"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeBelow()" data-translate="global.viewcaf.Close">Close</button> <button type="button" class="btn btn-primary" ng-disabled="required.belowMunicipal==null" data-dismiss="modal" ng-click="vm.markRequiredForBelow(vm.tower_service.id,required.department,required.belowMunicipal)" data-translate="global.viewcaf.Done">Done</button></div><div class="alert alert-warning" ng-hide="vm.municipals.length>0"><b><span data-translate="global.viewcaf.no">No</span></b> <span data-translate="global.viewcaf.Department">Department</span>!</div></div></div></div>');
$templateCache.put('app/serviceclearanceactions/undoRejectDialog.html','<form name="editForm" role="form" ng-submit="vm.undoRejectService()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Undo-Reject</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Comments</label><textarea class="form-control" rows="3" id="textArea" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editForm.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/serviceclearanceactions/verifyOtherPayment.html','<form name="myForm" class="form-horizontal" role="form"><form><div class="panel panel-primary"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel">Payment Stack</h4></div><div class="panel-body"><h5 ng-show="(vm.assignFeeDetail==0)">No Payments Made.</h5><table class="jh-table table table-striped table-bordered" ng-show="(vm.assignFeeDetail!=0)"><thead><tr><th><span>Amount</span></th><th><span>Description</span></th><th><span>Payment Made By</span></th><th><span>Payment Date</span></th><th><span>Transaction ID</span></th><th><span>Payment Status</span></th></tr></thead><tbody><!-- <tr ng-repeat="allPaymentsDetail in vm.allPaymentsDetail | orderBy : \'-paymentDate\'" ng-show="(allPaymentsDetail.paymentMade!=0)">\n                        <td>Rs.&nbsp;{{allPaymentsDetail.paymentMade}}</td>\n                        <td>{{allPaymentsDetail.paymentMadeBy}}</td>\n                        <td>{{allPaymentsDetail.paymentDate | date : \'medium\'}}</td>\n                        <td>{{allPaymentsDetail.transactionId}}</td>\n                        <td>{{allPaymentsDetail.paymentStatus}}</td>\n                    </tr>--><tr ng-repeat="assignFeeDetail in vm.assignFeeDetail | orderBy : \'-paymentDate\'" ng-show="(assignFeeDetail.paymentMade!=0) && (assignFeeDetail.length!=0) "><td>Rs.&nbsp;{{assignFeeDetail.paymentMade}}</td><td>{{assignFeeDetail.feeDescription}}</td><td>{{assignFeeDetail.paymentMadeBy}}</td><td>{{assignFeeDetail.paymentDate | date : \'medium\'}}</td><td>{{assignFeeDetail.transactionId}}</td><td>{{assignFeeDetail.paymentStatus}}</td></tr></tbody></table></div></div></form><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button><!--<button type="submit" class="btn btn-primary" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_ACCOUNT_OFFICER"\n                ng-show="(vm.projectService.isPaymentVerified==false)"\n                ng-click="vm.verifyPayment()">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Payment Disbursed</span>\n        </button>--></div></form>');
$templateCache.put('app/serviceclearanceactions/verifyPayment.html','<form name="myForm" class="form-horizontal" role="form"><form><div class="panel panel-primary"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">Payment Stack</h4></div><div class="modal-header"><h5 ng-show="(vm.projectService.isPaymentVerified==true)" class="modal-title">Payment has been disbursed</h5><h5 ng-show="(vm.projectService.isPaymentVerified==false)" class="modal-title">Payment not disbursed</h5></div><div class="panel-body"><table class="jh-table table table-striped"><thead><tr><th><span>Amount</span></th><th><span>Payment Made By</span></th><th><span>Payment Date</span></th><th><span>Transactionid</span></th><th><span>Payment Status</span></th></tr></thead><tbody><tr ng-repeat="projectServicePaymentDetail in vm.projectServicePaymentDetails | orderBy : \'-paymentDate\'" ng-show="(projectServicePaymentDetail.paymentStatus != \'Pending\') && (projectServicePaymentDetail.paymentStatus != \'pending\')"><td>{{projectServicePaymentDetail.paymentMade}}</td><td>{{projectServicePaymentDetail.paymentMadeBy}}</td><td>{{projectServicePaymentDetail.paymentDate | date : \'medium\'}}</td><td>{{projectServicePaymentDetail.transactionId}}</td><td>{{projectServicePaymentDetail.paymentStatus}}</td></tr></tbody></table></div></div></form><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button><!--<button type="submit" class="btn btn-primary" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_ACCOUNT_OFFICER"\n                ng-show="(vm.projectService.isPaymentVerified==false)"\n                ng-click="vm.verifyPayment()">\n            <span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Payment Disbursed</span>\n        </button>--></div></form>');
$templateCache.put('app/serviceclearanceactions/withdrawDialog.html','<form name="editForm" role="form" ng-submit="vm.confirmWithdraw()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="">Withdraw</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Comments</label><textarea class="form-control" rows="3" id="textArea" name="comment" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editForm.comment.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/servicedashboardyearly/averagefeeyearly.html','<style>.loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        animation: spin 2s linear infinite;\n    }\n\n    @keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n    }\n    .modal-content {\n        width: 922px;\n    }</style><form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary" style="width: 920px"><div class="modal-header"><div class="row"><div class="col-md-9"><h4 class="modal-title text-warning bold" id="myBlockLabel">{{vm.servicename}}</h4></div><div class="col-md-2" has-any-authority="ROLE_ADMIN, ROLE_NODAL_OFFICER, ROLE_TOWER_DC, ROLE_TOWER_MONITORING_OFFICER, ROLE_RM, ROLE_SUB_ADMIN, ROLE_DESK_OFFICER, ROLE_ACCOUNT_OFFICER, ROLE_FIELD_OFFICER, ROLE_ASSIGNRM_OFFICER, ROLE_MONITORING_OFFICER, ROLE_HEPC_MONITORING_OFFICER, ROLE_GRIEVANCE_OFFICER, ROLE_GRIEVANCE_ADMIN, ROLE_TOWER_DIO,\n                        ROLE_DEPT_CHANGE, ROLE_L1_SUPPORT, ROLE_TICKET_NODAL_OFFICER, ROLE_L2_DEPARTMENT_HEAD, ROLE_TICKET_OPERATION_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_INCENTIVES, ROLE_TICKET_ADMIN, ROLE_TICKET_HOBPAS, ROLE_DISPUTE_OFFICER, ROLE_HOME_DC, ROLE_HOME_SUPERINTENDENT, ROLE_HOME_CTM, ROLE_INCENTIVE_DISBURSEMENT_HEAD, ROLE_STATE_NODAL_OFFICER"><button ng-show="vm.show" id="download-btn" ng-click="vm.downloadAllData()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div><div ng-if="vm.spiner" class="loader"></div><div class="row"><div class="text-center"><h5 class="modal-title" ng-show="vm.status==\'All\'"><b>All CAFs with this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending\'"><b>All Pending CAFs against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending30\'"><b>CAFs pending for more than 30 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending45\'"><b>CAFs pending for more than 45 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending60\'"><b>CAFs pending for more than 60 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending75\'"><b>CAFs pending for more than 75 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'RTSdays\'"><b>CAFs pending for more than RTS days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Cleared\'"><b>CAFs Cleared against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Rejected\'"><b>Service Deactivated for the following CAFs</b></h5><h5 class="modal-title" ng-show="vm.status==\'DeemedCleared\'"><b>Service Deemed Cleared for the following CAFs</b></h5></div></div></div><div class="panel-body" style="width: 920px"><!--<h5 class="pull-left" ng-show="vm.status==\'Cleared\'">Average Clearance Time :<strong >{{" "}}{{vm.averageTime.toString()==\'NaN\'?"NA": vm.averageTime + \' days\'}}</strong> </h5>--><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF Pin</span></th><th><span>District</span></th><th><span>Project Level</span></th><th><span>Proposed Employment</span></th><th><span>Proposed Investment(in crore)</span></th><th><span>SLA</span></th><th ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'RTSdays\'"><span>Ageing</span></th><th ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">Applied Date</th><th ng-show="vm.status==\'Cleared\'">Cleared Date</th><th ng-show="vm.status==\'Declined\'">Rejected Date</th><th ng-if="vm.status==\'DeemedCleared\'">Deemed Cleared Date</th><th ng-if="vm.status==\'Rejected\'">De-Activated Date</th><th><span>Fee Details</span></th><th><span>Total Fee</span></th></tr></thead><td><tr dir-paginate="caf in vm.dashboardcafs.content | orderBy:\'-ageing\' | orderBy: \'-clearedDate\' | itemsPerPage: pageSize" total-items="vm.dashboardcafs.totalElements" current-page="currentPage"><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><td>{{caf.district}}</td><td>{{caf.projectLevel=="d" ? "DLCC" : "EEC"}}</td><!--<td>--><!--<div class="dropdown">--><!--<button ng-show="vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\'" class="btn btn-sm btn-info dropdown-toggle" ng-click="vm.showDepartments(caf)"--><!--data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">View--><!--<span class="caret"></span></button>--><!--<ul class="dropdown-menu dropdown-menu-left" aria-labelledby="dLabel">--><!--<li ng-repeat="dept in vm.departmentName"><a>{{dept}}</a></li>--><!--</ul>--><!--</div>--><!--</td>--><td>{{caf.proposedEmployment}}</td><td>{{caf.proposedInvestment}}</td><td>{{caf.sladays}}</td><td ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'RTSdays\'">{{caf.ageing}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">{{(caf.appliedDate==null ? "NA" : caf.appliedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\'">{{(caf.clearedDate==null ? "NA" :caf.clearedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Declined\'">{{(caf.rejectionDate==null ? "NA" :caf.rejectionDate) | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.status==\'DeemedCleared\'">{{(caf.statusDate==null ? "NA" :caf.statusDate) | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.status==\'Rejected\'">{{(caf.statusDate==null ? "NA" :caf.statusDate) | date:\'dd-MM-yyyy\'}}</td><td><span ng-if="caf.averageFeeApiList && caf.averageFeeApiList.length"><span ng-repeat="feeApi in caf.averageFeeApiList">{{feeApi.phasename}} : {{feeApi.phasefee}} <span ng-if="!$last">,</span> </span></span><span ng-if="!caf.averageFeeApiList || !caf.averageFeeApiList.length">--</span></td><td>{{ vm.getTotalPhaseFee(caf.averageFeeApiList) || \'--\' }}</td></tr></td></table><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></div></form>');
$templateCache.put('app/servicedashboardyearly/newservicedashboardyearly.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Service Dashboard</h1><p><span class="text-danger">*</span> Data of services applied after 01-April-2018</p></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Service Dashboard</span></li></ol></div></section><br><div class="container-fluid"><div class="row"><!--        <h5 class="pull-right text-danger" style="padding-right:2px;">*Dashboard is getting updated on real time basis</h5>--><h5 class="pull-right text-danger" style="padding-right:5px">*Dashboard updated on {{ CurrentDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</h5><div class="col-md-12"><ul class="nav nav-pills"><!--                <h5 class="pull-right text-danger" style="padding-right:2px;">*Dashboard is getting updated on real time basis</h5>--><!--<li class="active"><a ui-sref="totaldeptservicesdetailyearly({status:\'Required\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Required Services<span class="badge">{{vm.totalrequiredservices}}</span></a></li>--><li class="active"><a ui-sref="totaldeptservicesdetailyearly({status:\'Applied\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Applied Services<span class="badge">{{vm.totalappliedservices}}</span></a></li><li class="active"><a ui-sref="newtotaldeptservicesdetailyearly({status:\'Pending\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Pending Services<span class="badge">{{vm.totalpendingservices}}</span></a></li><li class="active"><a ui-sref="totaldeptservicesdetailyearly({status:\'Cleared\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Cleared Services<span class="badge">{{vm.totalcompletedservices}}</span></a></li><li class="active"><a ui-sref="totaldeptservicesdetailyearly({status:\'Declined\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Rejected Services<span class="badge">{{vm.totalrejectedservices}}</span></a></li><li class="active"><a ui-sref="dashboardbetweendates" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_MONITORING_OFFICER" style="margin-left: 24px">Datewise Stats</a></li><li class="active"><a ui-sref="servicedashboard({auth:\'Cumulative\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || (vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') && vm.account.login==\'deskof\')" style="margin-left: 24px">Cumulative Count</a></li><!--<li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Required Services<span class="badge">{{vm.totalrequiredservices}}</span></a></li>--><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Applied Services<span class="badge">{{vm.totalappliedservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Pending Services<span class="badge">{{vm.totalpendingservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Cleared Services<span class="badge">{{vm.totalcompletedservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Rejected Services<span class="badge">{{vm.totalrejectedservices}}</span></a></li><li class="active"><a ui-sref="servicedashboard({auth:\'Cumulative\'})" has-any-authority="ROLE_NODAL_OFFICER" style="margin-left: 24px">Cumulative Count</a></li></ul></div></div></div><div ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_FIELD_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')"><div class="row" style="padding: 12px" ng-if="vm.deptservicedashboard"><div class="col-md-1 filter-margin"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div><div class="col-md-3" ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')"><select class="custom-select form-control" ng-model="vm.filter.departmentName"><option value="" disabled="disabled">All Department</option><option value="{{department}}" ng-repeat="department in vm.departments">{{department}}</option></select></div><div class="col-md-2" ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_FIELD_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')"><select class="custom-select form-control" ng-model="vm.filter.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy:\'districtname\'"><option value="" disabled="disabled">All Districts</option><option value="district.districtname">{{district.districtname}}</option></select></div><div class="col-md-2" ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')"><select class="custom-select form-control" ng-model="vm.filter.projectLevel"><option value="" disabled="disabled">All Level</option><option value="e">EEC</option><option value="d">DLCC</option></select></div><button class="btn btn-primary" ng-click="vm.FilterWiseDat()">Filter</button> <button ng-if="vm.hideClear" class="btn btn-primary" ng-click="vm.clearFilter()">Clear</button></div></div><p ng-if="vm.deptservicedashboard" class="pull-right text-danger" style="padding-right:2px">*Mean & Median are calculated on cleared services after 01-April-2020</p><section class="ls section_padding_top_25 section_padding_bottom_75 columns_padding_10" id="user_section"><div class="container"><div ng-repeat="(departmentname, servicedashboard_data) in vm.deptservicedashboard | orderBy: \'departmentorder\' | groupBy: \'department_name\' "><div class="row"><h3>{{departmentname}} <a ui-sref="pstowerdashboard" class="pull-right" ng-if="(vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')) &&(departmentname===\'Communication and Connectivity Permissions\')" style="font-size: 18px; color: red">View Department wise Tower Service Dashboard</a></h3><table class="table table_template table-striped"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-2">Service</th><!-- <th class="col-md-1 text-center">Required</th> --><th class="col-md-1 text-center">Applied</th><th class="col-md-1 text-center">Pending</th><th class="col-md-8 text-center">Completed</th></tr></thead><tbody><tr class="headerGrid row gradient_bg_color2"><td class="col-md-2 text-center"></td><!-- <td class="col-md-1 text-center"></td> --><td class="col-md-1 text-center"></td><td class="col-md-3 text-center" style="padding:0;margin:0"><div class="col-md-2">Total</div><div class="col-md-2">> 30 days</div><div class="col-md-2">> 45 days</div><div class="col-md-2">> 60 days</div><div class="col-md-2">RTS days</div></td><td class="col-md-6 text-center" style="padding:0;margin:0"><span class="col-md-2">Cleared</span> <span class="col-md-1">De-activated</span> <span class="col-md-1">Deemed Cleared</span> <span class="col-md-2">Rejected</span> <span class="col-md-2">Avg.(Mean)/Median (in days)</span> <span class="col-md-2">MinTime / MaxTime</span> <span class="col-md-2">Average Fee</span></td></tr><tr class="row" ng-repeat="servicedashboard in servicedashboard_data | orderBy: \'service_name\'"><td class="col-md-2">{{servicedashboard.service_name}}</td><!-- <td class="col-md-1 text-center">\n                        <div class="col-md-12">\n                            <a ui-sref="servicedashboardyearlycafs({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Required\'})"><span class="badge">{{servicedashboard.required}}</span></a>\n                        </div>\n                    </td> --><td class="col-md-1 text-center"><div class="col-md-12"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Applied\'})"><span>{{servicedashboard.applied}}</span></a></div></td><td class="col-md-4 text-center"><div class="col-md-2"><a ui-sref="newservicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending\'})"><span ng-if="servicedashboard.pending_total < 0">{{ -servicedashboard.pending_total }}</span> <span ng-if="servicedashboard.pending_total >= 0">{{ servicedashboard.pending_total }}</span></a></div><div class="col-md-2"><a ui-sref="newservicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending30\'})"><span ng-if="servicedashboard.pending_30days < 0">{{ -servicedashboard.pending_30days }}</span> <span ng-if="servicedashboard.pending_30days >= 0">{{ servicedashboard.pending_30days }}</span></a></div><div class="col-md-2"><a ui-sref="newservicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending45\'})"><span ng-if="servicedashboard.pending_45days < 0">{{ -servicedashboard.pending_45days }}</span> <span ng-if="servicedashboard.pending_45days >= 0">{{ servicedashboard.pending_45days }}</span></a></div><div class="col-md-2"><a ui-sref="newservicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending60\'})"><span ng-if="servicedashboard.pending_60days < 0">{{ -servicedashboard.pending_60days }}</span> <span ng-if="servicedashboard.pending_60days >= 0">{{ servicedashboard.pending_60days }}</span></a></div><div class="col-md-2"><a><span>{{servicedashboard.rtsDays}}</span></a></div><!--                        <div class="col-md-2" ng-if="servicedashboard.rtsDays!=\'NA\'"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'RTSdays\'})"><span >{{servicedashboard.rtsDays}}</span></a></div>--></td><td class="col-md-5 text-center"><div class="col-md-2"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Cleared\'})"><span>{{servicedashboard.cleared}}</span></a></div><div class="col-md-1"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Rejected\'})"><span>{{servicedashboard.deactivated}}</span></a></div><div class="col-md-1"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'DeemedCleared\'})"><span>{{servicedashboard.deemed_cleared}}</span></a></div><div class="col-md-2"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Declined\'})"><span>{{servicedashboard.rejected}}</span></a></div><div class="col-md-2"><a><span>{{servicedashboard.pending_75days}} / {{servicedashboard.pending_90days}}</span></a></div><div class="col-md-2"><a><span>{{servicedashboard.minTime}}/{{servicedashboard.maxTime}}</span></a></div><div class="col-md-2"><!-- Show clickable link if averageFee is present --> <a ui-sref="averagefee({departmentName: vm.filter.departmentName, district: vm.filter.district, projectLevel: vm.filter.projectLevel, servicename: servicedashboard.service_name, serviceid: servicedashboard.service_id, status: \'Cleared\'})" ng-if="servicedashboard.averageFee"><span>{{ servicedashboard.averageFee }}</span> </a><!-- Show non-clickable text if averageFee is not present --> <span ng-if="!servicedashboard.averageFee">--</span></div></td></tr></tbody></table></div></div></div></section><!--<div class="text-center" style="margin-bottom: 10%;margin-top: 10%">--><!--    <div>--><!--        <p style="font-size: large"><b>Sorry for the inconvenience but we&rsquo;re performing some maintenance at this page.</b></p>--><!--    </div>--><!--</div>-->');
$templateCache.put('app/servicedashboardyearly/newserviceviewcafsyearly.html','<style>.loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        animation: spin 2s linear infinite;\n    }\n\n    @keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n    }</style><form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-9"><h4 class="modal-title text-warning bold" id="myBlockLabel">{{vm.servicename}}</h4></div><div class="col-md-2" has-any-authority="ROLE_ADMIN, ROLE_NODAL_OFFICER, ROLE_TOWER_DC, ROLE_TOWER_MONITORING_OFFICER, ROLE_RM, ROLE_SUB_ADMIN, ROLE_DESK_OFFICER, ROLE_ACCOUNT_OFFICER, ROLE_FIELD_OFFICER, ROLE_ASSIGNRM_OFFICER, ROLE_MONITORING_OFFICER, ROLE_HEPC_MONITORING_OFFICER, ROLE_GRIEVANCE_OFFICER, ROLE_GRIEVANCE_ADMIN, ROLE_TOWER_DIO,\n                        ROLE_DEPT_CHANGE, ROLE_L1_SUPPORT, ROLE_TICKET_NODAL_OFFICER, ROLE_L2_DEPARTMENT_HEAD, ROLE_TICKET_OPERATION_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_INCENTIVES, ROLE_TICKET_ADMIN, ROLE_TICKET_HOBPAS, ROLE_DISPUTE_OFFICER, ROLE_HOME_DC, ROLE_HOME_SUPERINTENDENT, ROLE_HOME_CTM, ROLE_INCENTIVE_DISBURSEMENT_HEAD, ROLE_STATE_NODAL_OFFICER"><button ng-show="vm.show" id="download-btn" ng-click="vm.downloadAllData()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div><div ng-if="vm.spiner" class="loader"></div><div class="row"><div class="text-center"><h5 class="modal-title" ng-show="vm.status==\'All\'"><b>All CAFs with this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending\'"><b>All Pending CAFs against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending30\'"><b>CAFs pending for more than 30 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending45\'"><b>CAFs pending for more than 45 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending60\'"><b>CAFs pending for more than 60 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending75\'"><b>CAFs pending for more than 75 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'RTSdays\'"><b>CAFs pending for more than RTS days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Cleared\'"><b>CAFs Cleared against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Rejected\'"><b>Service Deactivated for the following CAFs</b></h5><h5 class="modal-title" ng-show="vm.status==\'DeemedCleared\'"><b>Service Deemed Cleared for the following CAFs</b></h5></div></div></div><div class="panel-body"><!--<h5 class="pull-left" ng-show="vm.status==\'Cleared\'">Average Clearance Time :<strong >{{" "}}{{vm.averageTime.toString()==\'NaN\'?"NA": vm.averageTime + \' days\'}}</strong> </h5>--><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><!--                            <th><span>Business Entity</span></th>--><th><span>District</span></th><th><span>Project Level</span></th><th><span ng-show="vm.servicename == \'Regularization of existing Tower/Renewal (Above ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Above Ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\' || vm.servicename == \'Registration under Shops & Establishment AND/OR Trade License\' || vm.servicename == \'Renewal/Extension of Communication and Connectivity Permissions\'">Department</span></th><th><span>Proposed Employment</span></th><th><span>Proposed Investment(in crore)</span></th><th><span>SLA</span></th><th ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'RTSdays\'"><span>Ageing</span></th><th ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">Applied Date</th><th ng-show="vm.status==\'Cleared\'">Cleared Date</th><th ng-show="vm.status==\'Declined\'">Rejected Date</th><th ng-if="vm.status==\'DeemedCleared\'">Deemed Cleared Date</th><th ng-if="vm.status==\'Rejected\'">De-Activated Date</th></tr></thead><tbody><tr dir-paginate="caf in vm.dashboardcafs.content | orderBy:\'-ageing\' | orderBy: \'-clearedDate\' | itemsPerPage: pageSize" total-items="vm.dashboardcafs.totalElements" current-page="currentPage"><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><!--                            <td>{{caf.businessEntity}}</td>--><td>{{caf.district}}</td><td>{{caf.projectLevel=="d" ? "DLCC" : "EEC"}}</td><td><span ng-show="vm.servicename == \'Regularization of existing Tower/Renewal (Above ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Above Ground)\'\n                                        || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\' || vm.servicename == \'Registration under Shops & Establishment AND/OR Trade License\' || vm.servicename == \'Renewal/Extension of Communication and Connectivity Permissions\'">{{caf.departmentName === \'Communication and Connectivity Permissions\' ? "NA" : caf.departmentName}}</span></td><!--<td>--><!--<div class="dropdown">--><!--<button ng-show="vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\'" class="btn btn-sm btn-info dropdown-toggle" ng-click="vm.showDepartments(caf)"--><!--data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">View--><!--<span class="caret"></span></button>--><!--<ul class="dropdown-menu dropdown-menu-left" aria-labelledby="dLabel">--><!--<li ng-repeat="dept in vm.departmentName"><a>{{dept}}</a></li>--><!--</ul>--><!--</div>--><!--</td>--><td>{{caf.proposedEmployment}}</td><td>{{caf.proposedInvestment}}</td><td>{{caf.sladays}}</td><td ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'RTSdays\'">{{caf.countTotalDays}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">{{(caf.appliedDate==null ? "NA" : caf.appliedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\'">{{(caf.clearedDate==null ? "NA" :caf.clearedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Declined\'">{{(caf.rejectionDate==null ? "NA" :caf.rejectionDate) | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.status==\'DeemedCleared\'">{{(caf.statusDate==null ? "NA" :caf.statusDate) | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.status==\'Rejected\'">{{(caf.statusDate==null ? "NA" :caf.statusDate) | date:\'dd-MM-yyyy\'}}</td></tr></tbody></table><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/servicedashboardyearly/servicedashboardyearly.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Service Dashboard</h1><p><span class="text-danger">*</span> Data of services applied after 01-April-2018</p></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Service Dashboard</span></li></ol></div></section><br><div class="container-fluid"><div class="row"><!--        <h5 class="pull-right text-danger" style="padding-right:2px;">*Dashboard is getting updated on real time basis</h5>--><h5 class="pull-right text-danger" style="padding-right:5px">*Dashboard updated on {{ CurrentDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</h5><div class="col-md-12"><ul class="nav nav-pills"><!--                <h5 class="pull-right text-danger" style="padding-right:2px;">*Dashboard is getting updated on real time basis</h5>--><!--<li class="active"><a ui-sref="totaldeptservicesdetailyearly({status:\'Required\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Required Services<span class="badge">{{vm.totalrequiredservices}}</span></a></li>--><li class="active"><a ui-sref="totaldeptservicesdetailyearly({status:\'Applied\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Applied Services<span class="badge">{{vm.totalappliedservices}}</span></a></li><li class="active"><a ui-sref="totaldeptservicesdetailyearly({status:\'Pending\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Pending Services<span class="badge">{{vm.totalpendingservices}}</span></a></li><li class="active"><a ui-sref="totaldeptservicesdetailyearly({status:\'Cleared\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Cleared Services<span class="badge">{{vm.totalcompletedservices}}</span></a></li><li class="active"><a ui-sref="totaldeptservicesdetailyearly({status:\'Declined\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')|| vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Rejected Services<span class="badge">{{vm.totalrejectedservices}}</span></a></li><li class="active"><a ui-sref="servicedashboard({auth:\'Cumulative\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || (vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') && vm.account.login==\'deskof\')" style="margin-left: 24px">Cumulative Count</a></li><!--<li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Required Services<span class="badge">{{vm.totalrequiredservices}}</span></a></li>--><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Applied Services<span class="badge">{{vm.totalappliedservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Pending Services<span class="badge">{{vm.totalpendingservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Cleared Services<span class="badge">{{vm.totalcompletedservices}}</span></a></li><li class="active"><a ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Rejected Services<span class="badge">{{vm.totalrejectedservices}}</span></a></li><li class="active"><a ui-sref="servicedashboard({auth:\'Cumulative\'})" has-any-authority="ROLE_NODAL_OFFICER" style="margin-left: 24px">Cumulative Count</a></li><li class="active"><a ui-sref="dashboardbetweendates">Datewise Stats</a></li><li class="active"><a ui-sref="dashboardbetweendates">Monthwise Stats</a></li></ul></div></div></div><div ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_FIELD_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')"><div class="row" style="padding: 12px" ng-if="vm.deptservicedashboard"><div class="col-md-1 filter-margin"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div><div class="col-md-3" ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')"><select class="custom-select form-control" ng-model="vm.filter.departmentName"><option value="" disabled="disabled">All Department</option><option value="{{department}}" ng-repeat="department in vm.departments">{{department}}</option></select></div><div class="col-md-2" ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_FIELD_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')"><select class="custom-select form-control" ng-model="vm.filter.district" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy:\'districtname\'"><option value="" disabled="disabled">All Districts</option><option value="district.districtname">{{district.districtname}}</option></select></div><div class="col-md-2" ng-if="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')"><select class="custom-select form-control" ng-model="vm.filter.projectLevel"><option value="" disabled="disabled">All Level</option><option value="e">EEC</option><option value="d">DLCC</option></select></div><button class="btn btn-primary" ng-click="vm.FilterWiseDat()">Filter</button> <button ng-if="vm.hideClear" class="btn btn-primary" ng-click="vm.clearFilter()">Clear</button></div></div><p ng-if="vm.deptservicedashboard" class="pull-right text-danger" style="padding-right:2px">*Mean & Median are calculated on cleared services after 01-April-2020</p><section class="ls section_padding_top_25 section_padding_bottom_75 columns_padding_10" id="user_section"><div class="container"><div ng-repeat="(departmentname, servicedashboard_data) in vm.deptservicedashboard | orderBy: \'departmentorder\' | groupBy: \'department_name\' "><div class="row"><h3>{{departmentname}} <a ui-sref="pstowerdashboard" class="pull-right" ng-if="(vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_NODAL_OFFICER\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\')) &&(departmentname===\'Communication and Connectivity Permissions\')" style="font-size: 18px; color: red">View Department wise Tower Service Dashboard</a></h3><table class="table table_template table-striped"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-2">Service</th><!-- <th class="col-md-1 text-center">Required</th> --><th class="col-md-1 text-center">Applied</th><th class="col-md-1 text-center">Pending</th><th class="col-md-8 text-center">Completed</th></tr></thead><tbody><tr class="headerGrid row gradient_bg_color2"><td class="col-md-2 text-center"></td><!-- <td class="col-md-1 text-center"></td> --><td class="col-md-1 text-center"></td><td class="col-md-3 text-center" style="padding:0;margin:0"><div class="col-md-2">Total</div><div class="col-md-2">> 30 days</div><div class="col-md-2">> 45 days</div><div class="col-md-2">> 60 days</div><div class="col-md-2">RTS days</div></td><td class="col-md-6 text-center" style="padding:0;margin:0"><span class="col-md-2">Cleared</span> <span class="col-md-1">De-activated</span> <span class="col-md-1">Deemed Cleared</span> <span class="col-md-2">Rejected</span> <span class="col-md-2">Avg.(Mean)/Median (in days)</span> <span class="col-md-2">MinTime / MaxTime</span> <span class="col-md-2">Average Fee</span></td></tr><tr class="row" ng-repeat="servicedashboard in servicedashboard_data | orderBy: \'service_name\'"><td class="col-md-2">{{servicedashboard.service_name}}</td><!-- <td class="col-md-1 text-center">\n                        <div class="col-md-12">\n                            <a ui-sref="servicedashboardyearlycafs({servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Required\'})"><span class="badge">{{servicedashboard.required}}</span></a>\n                        </div>\n                    </td> --><td class="col-md-1 text-center"><div class="col-md-12"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Applied\'})"><span>{{servicedashboard.applied}}</span></a></div></td><td class="col-md-4 text-center"><div class="col-md-2"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending\'})"><span ng-if="servicedashboard.pending_total < 0">{{ -servicedashboard.pending_total }}</span> <span ng-if="servicedashboard.pending_total >= 0">{{ servicedashboard.pending_total }}</span></a></div><div class="col-md-2"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending30\'})"><span ng-if="servicedashboard.pending_30days < 0">{{ -servicedashboard.pending_30days }}</span> <span ng-if="servicedashboard.pending_30days >= 0">{{ servicedashboard.pending_30days }}</span></a></div><div class="col-md-2"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending45\'})"><span ng-if="servicedashboard.pending_45days < 0">{{ -servicedashboard.pending_45days }}</span> <span ng-if="servicedashboard.pending_45days >= 0">{{ servicedashboard.pending_45days }}</span></a></div><div class="col-md-2"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Pending60\'})"><span ng-if="servicedashboard.pending_60days < 0">{{ -servicedashboard.pending_60days }}</span> <span ng-if="servicedashboard.pending_60days >= 0">{{ servicedashboard.pending_60days }}</span></a></div><div class="col-md-2"><a><span>{{servicedashboard.rtsDays}}</span></a></div><!--                        <div class="col-md-2" ng-if="servicedashboard.rtsDays!=\'NA\'"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'RTSdays\'})"><span >{{servicedashboard.rtsDays}}</span></a></div>--></td><td class="col-md-5 text-center"><div class="col-md-2"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Cleared\'})"><span>{{servicedashboard.cleared}}</span></a></div><div class="col-md-1"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Rejected\'})"><span>{{servicedashboard.deactivated}}</span></a></div><div class="col-md-1"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'DeemedCleared\'})"><span>{{servicedashboard.deemed_cleared}}</span></a></div><div class="col-md-2"><a ui-sref="servicedashboardyearlycafs({departmentName:vm.filter.departmentName,district:vm.filter.district,projectLevel:vm.filter.projectLevel,servicename:servicedashboard.service_name,serviceid:servicedashboard.service_id,status:\'Declined\'})"><span>{{servicedashboard.rejected}}</span></a></div><div class="col-md-2"><a><span>{{servicedashboard.pending_75days}} / {{servicedashboard.pending_90days}}</span></a></div><div class="col-md-2"><a><span>{{servicedashboard.minTime}}/{{servicedashboard.maxTime}}</span></a></div><div class="col-md-2"><!-- Show clickable link if averageFee is present --> <a ui-sref="averagefee({departmentName: vm.filter.departmentName, district: vm.filter.district, projectLevel: vm.filter.projectLevel, servicename: servicedashboard.service_name, serviceid: servicedashboard.service_id, status: \'Cleared\'})" ng-if="servicedashboard.averageFee"><span>{{ servicedashboard.averageFee }}</span> </a><!-- Show non-clickable text if averageFee is not present --> <span ng-if="!servicedashboard.averageFee">--</span></div></td></tr></tbody></table></div></div></div></section><!--<div class="text-center" style="margin-bottom: 10%;margin-top: 10%">--><!--    <div>--><!--        <p style="font-size: large"><b>Sorry for the inconvenience but we&rsquo;re performing some maintenance at this page.</b></p>--><!--    </div>--><!--</div>-->');
$templateCache.put('app/servicedashboardyearly/serviceviewcafsyearly.html','<style>.loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        animation: spin 2s linear infinite;\n    }\n\n    @keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n    }</style><form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-9"><h4 class="modal-title text-warning bold" id="myBlockLabel">{{vm.servicename}}</h4></div><div class="col-md-2" has-any-authority="ROLE_ADMIN, ROLE_NODAL_OFFICER, ROLE_TOWER_DC, ROLE_TOWER_MONITORING_OFFICER, ROLE_RM, ROLE_SUB_ADMIN, ROLE_DESK_OFFICER, ROLE_ACCOUNT_OFFICER, ROLE_FIELD_OFFICER, ROLE_ASSIGNRM_OFFICER, ROLE_MONITORING_OFFICER, ROLE_HEPC_MONITORING_OFFICER, ROLE_GRIEVANCE_OFFICER, ROLE_GRIEVANCE_ADMIN, ROLE_TOWER_DIO,\n                        ROLE_DEPT_CHANGE, ROLE_L1_SUPPORT, ROLE_TICKET_NODAL_OFFICER, ROLE_L2_DEPARTMENT_HEAD, ROLE_TICKET_OPERATION_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_INCENTIVES, ROLE_TICKET_ADMIN, ROLE_TICKET_HOBPAS, ROLE_DISPUTE_OFFICER, ROLE_HOME_DC, ROLE_HOME_SUPERINTENDENT, ROLE_HOME_CTM, ROLE_INCENTIVE_DISBURSEMENT_HEAD, ROLE_STATE_NODAL_OFFICER"><button ng-show="vm.show" id="download-btn" ng-click="vm.downloadAllData()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div><div ng-if="vm.spiner" class="loader"></div><div class="row"><div class="text-center"><h5 class="modal-title" ng-show="vm.status==\'All\'"><b>All CAFs with this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending\'"><b>All Pending CAFs against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending30\'"><b>CAFs pending for more than 30 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending45\'"><b>CAFs pending for more than 45 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending60\'"><b>CAFs pending for more than 60 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending75\'"><b>CAFs pending for more than 75 days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'RTSdays\'"><b>CAFs pending for more than RTS days for this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Cleared\'"><b>CAFs Cleared against this service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Rejected\'"><b>Service Deactivated for the following CAFs</b></h5><h5 class="modal-title" ng-show="vm.status==\'DeemedCleared\'"><b>Service Deemed Cleared for the following CAFs</b></h5></div></div></div><div class="panel-body"><!--<h5 class="pull-left" ng-show="vm.status==\'Cleared\'">Average Clearance Time :<strong >{{" "}}{{vm.averageTime.toString()==\'NaN\'?"NA": vm.averageTime + \' days\'}}</strong> </h5>--><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><!--                            <th><span>Business Entity</span></th>--><th><span>District</span></th><th><span>Project Level</span></th><th><span ng-show="vm.servicename == \'Regularization of existing Tower/Renewal (Above ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Above Ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\' || vm.servicename == \'Registration under Shops & Establishment AND/OR Trade License\' || vm.servicename == \'Renewal/Extension of Communication and Connectivity Permissions\'">Department</span></th><th><span>Proposed Employment</span></th><th><span>Proposed Investment(in crore)</span></th><th><span>SLA</span></th><th ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'RTSdays\'"><span>Ageing</span></th><th ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">Applied Date</th><th ng-show="vm.status==\'Cleared\'">Cleared Date</th><th ng-show="vm.status==\'Declined\'">Rejected Date</th><th ng-if="vm.status==\'DeemedCleared\'">Deemed Cleared Date</th><th ng-if="vm.status==\'Rejected\'">De-Activated Date</th></tr></thead><tbody><tr dir-paginate="caf in vm.dashboardcafs.content | orderBy:\'-ageing\' | orderBy: \'-clearedDate\' | itemsPerPage: pageSize" total-items="vm.dashboardcafs.totalElements" current-page="currentPage"><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><!--                            <td>{{caf.businessEntity}}</td>--><td>{{caf.district}}</td><td>{{caf.projectLevel=="d" ? "DLCC" : "EEC"}}</td><td><span ng-show="vm.servicename == \'Regularization of existing Tower/Renewal (Above ground)\' || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Above Ground)\'\n                                        || vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\' || vm.servicename == \'Registration under Shops & Establishment AND/OR Trade License\' || vm.servicename == \'Renewal/Extension of Communication and Connectivity Permissions\'">{{caf.departmentName === \'Communication and Connectivity Permissions\' ? "NA" : caf.departmentName}}</span></td><!--<td>--><!--<div class="dropdown">--><!--<button ng-show="vm.servicename == \'Communication and Connectivity Permissions/Renewal(Below Ground)\'" class="btn btn-sm btn-info dropdown-toggle" ng-click="vm.showDepartments(caf)"--><!--data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">View--><!--<span class="caret"></span></button>--><!--<ul class="dropdown-menu dropdown-menu-left" aria-labelledby="dLabel">--><!--<li ng-repeat="dept in vm.departmentName"><a>{{dept}}</a></li>--><!--</ul>--><!--</div>--><!--</td>--><td>{{caf.proposedEmployment}}</td><td>{{caf.proposedInvestment}}</td><td>{{caf.sladays}}</td><td ng-show="vm.status==\'Pending\' || vm.status==\'Pending30\' || vm.status==\'Pending45\' || vm.status==\'Pending60\' || vm.status==\'Pending75\' || vm.status==\'RTSdays\'">{{caf.ageing}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'Declined\'">{{(caf.appliedDate==null ? "NA" : caf.appliedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\'">{{(caf.clearedDate==null ? "NA" :caf.clearedDate) | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Declined\'">{{(caf.rejectionDate==null ? "NA" :caf.rejectionDate) | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.status==\'DeemedCleared\'">{{(caf.statusDate==null ? "NA" :caf.statusDate) | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.status==\'Rejected\'">{{(caf.statusDate==null ? "NA" :caf.statusDate) | date:\'dd-MM-yyyy\'}}</td></tr></tbody></table><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/showcafs-stateNodalOfficer/projects-dialog.html','<!--modal for logs--><div class="container-fluid" ng-show="vm.status===\'service-logs\'"><div class="row"><div class="col-md-12"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><form name="myForm" class="form-horizontal" role="form"><div class="row modal-header"><h4 class="modal-title">Service Log</h4><h4 class="text-center"><b>{{vm.service.serviceName}}</b></h4></div><div class="row"><div class="col-md-12"><table class="jh-table table table-striped table-responsive"><thead><tr><th><span>Action Taken</span></th><th><span>Date</span></th><th><span>Action By</span></th><th><span>Comments</span></th><th><span>Reason Category</span></th><th><span>Rejection Reason</span></th><th><span>Attachment</span></th></tr></thead><tbody><tr ng-repeat="servicelog in vm.ServiceLog | orderBy:\'-commentDate\'"><td>{{(servicelog.actionTaken == \'Rejected\' ? "Deactivated": (servicelog.actionTaken == \'Declined\' ? "Rejected" : (servicelog.actionTaken == \'MarkedRequired\' ? "Required" : (servicelog.actionTaken == \'ServiceFormEdited\' ? "Service Form Filled" : (servicelog.actionTaken == \'OpenComment\' ? "Comment" :servicelog.actionTaken)))))}}</td><td>{{servicelog.commentDate | date:\'dd-MM-yyyy\'}}</td><td>{{servicelog.commentByUserLogin}}</td><td class="break-line">{{(servicelog.comments == \'MarkedRequired\' ? (servicelog.comments= \'The Investor has indicated his desire for this service\') : servicelog.comments)}}</td><td>{{servicelog.reasonCategory}}</td><td>{{servicelog.rejectionReason}}</td><td><button ng-show="(servicelog.fileName) || ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))" type="button" class="btn btn-primary" ng-click="vm.downloadFile(servicelog.fileName,servicelog.actionTaken)">Download</button></td></tr></tbody></table></div></div></form><div class="row modal-footer"><button type="button" class="btn btn-default" ng-click="vm.clear()">Close</button></div></div></div></div><!--modal for viewform--><form id="myForm" name="myForm" class="form-horizontal" role="form" ng-show="vm.status===\'view-form\'"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success pull-right"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><div id="pdf_data" class="panel"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">{{vm.project.departmentName}} : {{vm.project.serviceName}}</h4></div><div class="panel-body"><div ng-repeat="field in vm.serviceFormFieldData | orderBy : \'formfieldOrder\'" class="form-horizontal"><div class="row"><div class="col-sm-6"><label class="control-label pull-right">{{field.formfieldName}}</label></div><div class="col-sm-6"><p class="control-label pull-left">{{field.formfieldvalue}}</p></div></div></div><br><div class="col-lg-offset-2 col-lg-8"><center><table class="table table-striped table-responsive table-hover"><thead><tr><th class="col-lg-6">File Description</th><th class="col-lg-2">Action</th></tr></thead><tbody><tr ng-repeat="serviceformattachment in vm.serviceformattachments"><td>{{serviceformattachment.description}}</td><td><button type="button" class="btn btn-success pull-center btn-sm" ng-click="vm.downloadFile(serviceformattachment.serverfilename,serviceformattachment.downloadfilename)"><span class="glyphicon glyphicon-download-alt"></span></button></td></tr></tbody></table></center></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form><!--modal for clearance--><form name="editFormClear" role="form" ng-submit="vm.clearService()" ng-show="vm.status===\'clearance\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Service Clearance</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" id="textArea" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormClear.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormClear.$invalid || file.maxSizeError || vm.projectAttachemnt.file == null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for rejection--><form name="editFormReject" role="form" ng-submit="vm.rejectService()" ng-show="vm.status===\'reject\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Reject Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.projectService.serviceid === \'741f0f60-cf69-4659-8b19-19d96ffe0103\' || vm.projectService.serviceid === \'58d75fd4-f360-4931-a484-ff9be0adc12c\' || vm.projectService.serviceid === \'6f81801c-59c6-4773-9f37-a5d81172a1bf\' || vm.projectService.serviceid === \'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\' || vm.projectService.serviceid === \'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\'"><label class="control-label">Select Category</label><select class="form-control" ng-model="vm.selectedCategory" ng-change="vm.getRejectionReason(vm.selectedCategory)" ng-options="reasonCategory as reasonCategory.category for reasonCategory in vm.reasonCategories" required><option value="">-- Select --</option></select></div><div class="form-group" ng-if="vm.projectService.serviceid === \'741f0f60-cf69-4659-8b19-19d96ffe0103\' || vm.projectService.serviceid === \'58d75fd4-f360-4931-a484-ff9be0adc12c\' || vm.projectService.serviceid === \'6f81801c-59c6-4773-9f37-a5d81172a1bf\' || vm.projectService.serviceid === \'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\' || vm.projectService.serviceid === \'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\'"><label class="control-label">Select Reason</label><select class="form-control" ng-model="vm.selectedReason" ng-change="vm.getReasons()" multiple="multiple" ng-options="rejectionReason as rejectionReason.reason for rejectionReason in vm.rejectionReasons" required><option value="">-- Select --</option></select></div><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormReject.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormReject.$invalid || file.maxSizeError || vm.projectAttachemnt.file == null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for deactivation--><form name="editFormDeactivate" role="form" ng-submit="vm.deactivateService()" ng-show="vm.status===\'deactivate\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Deactivate Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormReject.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormDeactivate.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for comment--><form name="editFormComment" role="form" ng-submit="vm.addComment()" ng-show="vm.status===\'comment\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormComment.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormComment.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for clarification--><form name="comment" role="form" ng-submit="vm.addClarification(\'DC\')" ng-show="vm.status===\'clarification\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><br><div class="form-group"><label class="control-label">Choose Comment Type <i style="color: red; font-size: 25px">*</i></label><br><input type="radio" name="commentType" ng-model="vm.commentsType" value="Comment" ng-click="vm.chooseCommentType(\'Comment\')"><label class="control-label">General Comment</label><br><label>(This option facilitates general communication between the department officers (intra departmental communication). Importantly, using this provision will not impact the department\u2019s timeline)</label><br><input type="radio" name="commentType" ng-model="vm.commentsType" value="Clarification" ng-click="vm.chooseCommentType(\'Clarification\')"><label class="control-label">Send Back To User for Clarification</label><br><label>(This option is specifically for raising clarifications with the applicant regarding missing documents or information. When this provision is utilized, the department\u2019s timeline will pause until a response is received from the applicant)</label><br><label class="control-label">Choose Comment Type <i style="color: red; font-size: 25px">*</i></label><br><input type="radio" name="commentType" ng-model="vm.commentsType" value="Comment" ng-click="vm.chooseCommentType(\'Comment\')" required><label class="control-label">General Comment</label><br><label>(This option facilitates general communication between the department officers (intra departmental communication). Importantly, using this provision will not impact the department\u2019s timeline)</label><br><input type="radio" name="commentType" ng-model="vm.commentsType" value="Clarification" ng-click="vm.chooseCommentType(\'Clarification\')" required><label class="control-label">Send Back To User for Clarification</label><br><label>(This option is specifically for raising clarifications with the applicant regarding missing documents or information. When this provision is utilized, the department\u2019s timeline will pause until a response is received from the applicant)</label><br><!-- Show only when Clarification is selected --><div class="form-group" ng-if="vm.commentsType === \'Clarification\' && (\n              vm.projectService.serviceid === \'741f0f60-cf69-4659-8b19-19d96ffe0103\' ||\n              vm.projectService.serviceid === \'58d75fd4-f360-4931-a484-ff9be0adc12c\' ||\n              vm.projectService.serviceid === \'6f81801c-59c6-4773-9f37-a5d81172a1bf\' ||\n              vm.projectService.serviceid === \'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\' ||\n              vm.projectService.serviceid === \'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\'\n           )"><label class="control-label">Select Category <i style="color: red">*</i></label><select class="form-control" ng-model="vm.selectedCategory" ng-change="vm.getRejectionReason(vm.selectedCategory)" ng-options="reasonCategory as reasonCategory.category for reasonCategory in vm.reasonCategories" ng-required="vm.commentsType === \'Clarification\'"><option value="">-- Select --</option></select></div><div class="form-group" ng-if="vm.commentsType === \'Clarification\' && (\n              vm.projectService.serviceid === \'741f0f60-cf69-4659-8b19-19d96ffe0103\' ||\n              vm.projectService.serviceid === \'58d75fd4-f360-4931-a484-ff9be0adc12c\' ||\n              vm.projectService.serviceid === \'6f81801c-59c6-4773-9f37-a5d81172a1bf\' ||\n              vm.projectService.serviceid === \'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\' ||\n              vm.projectService.serviceid === \'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\'\n           )"><label class="control-label">Select Reason <i style="color: red">*</i></label><select class="form-control" ng-model="vm.selectedReason" ng-change="vm.getReasons()" multiple="multiple" ng-options="rejectionReason as rejectionReason.reason for rejectionReason in vm.rejectionReasons" ng-required="vm.commentsType === \'Clarification\'"><option value="">-- Select --</option></select></div><label class="control-label">Description</label><textarea class="form-control" id="description" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="comment.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="comment.description.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for undo reject--><form name="editFormUndoReject" role="form" ng-submit="vm.undoreject()" ng-show="vm.status===\'undo-reject\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Undo Reject Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormUndoReject.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormUndoReject.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for re activate--><form name="editFormActivate" role="form" ng-submit="vm.reactivate()" ng-show="vm.status===\'re-activate\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Reactivate Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormActivate.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormActivate.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for deemed Clear--><form name="editFormDeemed" role="form" ng-submit="vm.deemedClearService()" ng-show="vm.status===\'deemedClear\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Deemed Clearancee</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" data-translate="">Comment</label><textarea class="form-control" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editFormDeemed.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormDeemed.$invalid || file.maxSizeError || vm.projectAttachemnt.file == null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><form name="myForm" class="form-horizontal" role="form" ng-show="vm.status===\'verifyOtherPayment\'"><form><div class="panel panel-primary"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel">Payment Stack</h4></div><div class="panel-body"><h5 ng-show="(vm.assignFeeDetail==0)">No Payments Made.</h5><table class="jh-table table table-striped table-bordered" ng-show="(vm.assignFeeDetail!=0)"><thead><tr><th><span>Amount</span></th><th><span>Description</span></th><th><span>Payment Made By</span></th><th><span>Payment Date</span></th><th><span>Transaction ID</span></th><th><span>Payment Status</span></th></tr></thead><tbody><!-- <tr ng-repeat="allPaymentsDetail in vm.allPaymentsDetail | orderBy : \'-paymentDate\'" ng-show="(allPaymentsDetail.paymentMade!=0)">\n                         <td>Rs.&nbsp;{{allPaymentsDetail.paymentMade}}</td>\n                         <td>{{allPaymentsDetail.paymentMadeBy}}</td>\n                         <td>{{allPaymentsDetail.paymentDate | date : \'medium\'}}</td>\n                         <td>{{allPaymentsDetail.transactionId}}</td>\n                         <td>{{allPaymentsDetail.paymentStatus}}</td>\n                     </tr>--><tr ng-repeat="assignFeeDetail in vm.assignFeeDetail | orderBy : \'-paymentDate\'" ng-show="(assignFeeDetail.paymentMade!=0) && (assignFeeDetail.length!=0) "><td>Rs.&nbsp;{{assignFeeDetail.paymentMade}}</td><td>{{assignFeeDetail.feeDescription}}</td><td>{{assignFeeDetail.paymentMadeBy}}</td><td>{{assignFeeDetail.paymentDate | date : \'medium\'}}</td><td>{{assignFeeDetail.transactionId}}</td><td>{{assignFeeDetail.paymentStatus}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form></form>');
$templateCache.put('app/showcafs-stateNodalOfficer/showcafs-state-nodal-officer.html','<div class="container-fluid"><div class="row mt-30"><div class="col-md-12"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>CAF Pin</th><th>Action</th></tr></thead><tbody><!--                    <tr ng-if="projects.length > 0" ng-repeat="project in projects = ( vm.projects | orderBy:\'-lastactiondate\' | filter: {departmentname: vm.currentDepartment})">--><tr ng-repeat="project in vm.projects"><td>{{$index+1}}</td><td>{{project.cafpin}}</td><td><!--                            <button--><!--                                type="button"--><!--                                class="btn btn-info btn-sm" ng-click="vm.rejectCaf(project.id)" >Reject--><!--                            </button>--></td></tr><!--                    <tr ng-if="projects.length == 0" class="text-center">--><!--                        <td colspan="10">--><!--                            <h1 class="pt-60">No records found</h1>--><!--                        </td>--><!--                    </tr>--></tbody></table><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div><!-- Modal --><div class="modal" id="tower_department2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="clear()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Select New Department</h4></div><div class="modal-body"><div class="row panel-body"><div class="table-responsive" style="display:block;overflow:auto;height:400px;width:100%"><table class="jh-table table table-striped"><thead><tr><th><span>Department Name</span></th><th><span>Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.tower_departmentlist" ng-show="department.istower"><td>{{department.departmentname}}</td><td><input type="checkbox" class="form-control" ng-click="vm.updateCheck(department.departmentname)" checklist-model="required.department" checklist-value="department.departmentname"></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()">Close</button> <button type="button" ng-disabled="required.department.length==0" ng-show="vm.tower_service.projectserviceid!=null" class="btn btn-primary" ng-click="vm.updateTowerServiceNO(vm.tower_service.projectserviceid)" data-dismiss="modal">Done</button></div></div></div></div><div class="modal rmPaddingModal" id="YourModalId" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="YourModalId1">Select Required Department/Department\'s</h4></div><div class="modal-body" ng-show="vm.municipals.length!=0"><div class="row panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Department Name</span></th><th><span>Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.municipals"><td>{{department.name}}</td><td><input class="form-control" type="radio" name="myType" ng-model="vm.aboveMunicipal" value="{{department.name}}"><!--<input type="checkbox" class="form-control" ng-click="vm.updateMunicipal(department.name)" checklist-model="required.municipal" checklist-value="department.name"/>--></td></tr></tbody></table></div></div></div><div class="modal-footer" ng-show="vm.municipals.length!=0"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal()">Close</button> <button type="button" class="btn btn-primary" ng-disabled="vm.aboveMunicipal==null" ng-click="vm.markRequiredForMunicipal(vm.tower_service.projectserviceid,required.department,vm.aboveMunicipal)" data-dismiss="modal">Done</button></div><div class="alert alert-warning" ng-hide="vm.municipals.length>0"><b>No</b> Department!</div></div></div></div>');
$templateCache.put('app/showprojects-home/projects-dialog_home.html','<!--modal for logs--><div class="container-fluid" ng-show="vm.status===\'service-logs\'"><div class="row"><div class="col-md-12"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><form name="myForm" class="form-horizontal" role="form"><div class="row modal-header"><h4 class="modal-title">Service Log</h4><h4 class="text-center"><b>{{vm.service.serviceName}}</b></h4></div><div class="row"><div class="col-md-12"><table class="jh-table table table-striped table-responsive"><thead><tr><th><span>Action Taken</span></th><th><span>Date</span></th><th><span>Action By</span></th><th><span>Comments</span></th><th><span>Attachment</span></th></tr></thead><tbody><tr ng-repeat="servicelog in vm.ServiceLog | orderBy:\'-commentDate\'"><td>{{(servicelog.actionTaken == \'Rejected\' ? "Deactivated": (servicelog.actionTaken == \'Declined\' ? "Rejected" : (servicelog.actionTaken == \'MarkedRequired\' ? "Required" : (servicelog.actionTaken == \'ServiceFormEdited\' ? "Service Form Filled" : (servicelog.actionTaken == \'OpenComment\' ? "Comment" :servicelog.actionTaken)))))}}</td><td>{{servicelog.commentDate | date:\'dd-MM-yyyy\'}}</td><td>{{servicelog.commentByUserLogin}}</td><td class="break-line">{{(servicelog.comments == \'MarkedRequired\' ? (servicelog.comments= \'The Investor has indicated his desire for this service\') : servicelog.comments)}}</td><td><button ng-show="(servicelog.fileName) || ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))" type="button" class="btn btn-primary" ng-click="vm.downloadFile(servicelog.fileName,servicelog.actionTaken)">Download</button></td></tr></tbody></table></div></div></form><div class="row modal-footer"><button type="button" class="btn btn-default" ng-click="vm.clear()">Close</button></div></div></div></div><!--modal for viewform--><form id="myForm" name="myForm" class="form-horizontal" role="form" ng-show="vm.status===\'view-form\'"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success pull-right"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><div id="pdf_data" class="panel"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">{{vm.project.departmentName}} : {{vm.project.serviceName}}</h4></div><div class="panel-body"><div ng-repeat="field in vm.serviceFormFieldData | orderBy : \'formfieldOrder\'" class="form-horizontal"><div class="row"><div class="col-sm-6"><label class="control-label pull-right">{{field.formfieldName}}</label></div><div class="col-sm-6"><p class="control-label pull-left">{{field.formfieldvalue}}</p></div></div></div><br><div class="col-lg-offset-2 col-lg-8"><center><table class="table table-striped table-responsive table-hover"><thead><tr><th class="col-lg-6">File Description</th><th class="col-lg-2">Action</th></tr></thead><tbody><tr ng-repeat="serviceformattachment in vm.serviceformattachments"><td>{{serviceformattachment.description}}</td><td><button type="button" class="btn btn-success pull-center btn-sm" ng-click="vm.downloadFile(serviceformattachment.serverfilename,serviceformattachment.downloadfilename)"><span class="glyphicon glyphicon-download-alt"></span></button></td></tr></tbody></table></center></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form><!--modal for clearance--><form name="editFormClear" role="form" ng-submit="vm.clearService()" ng-show="vm.status===\'clearance\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Service Clearance</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" id="textArea" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormClear.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormClear.$invalid || file.maxSizeError || vm.projectAttachemnt.file == null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for rejection--><form name="editFormReject" role="form" ng-submit="vm.rejectService()" ng-show="vm.status===\'reject\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Reject Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormReject.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormReject.$invalid || file.maxSizeError || vm.projectAttachemnt.file == null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for deactivation--><form name="editFormDeactivate" role="form" ng-submit="vm.deactivateService()" ng-show="vm.status===\'deactivate\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Deactivate Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormReject.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormDeactivate.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for comment--><form name="editFormComment" role="form" ng-submit="vm.addComment()" ng-show="vm.status===\'comment\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormComment.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormComment.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for undo reject--><form name="editFormUndoReject" role="form" ng-submit="vm.undoreject()" ng-show="vm.status===\'undo-reject\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Undo Reject Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormUndoReject.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormUndoReject.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for re activate--><form name="editFormActivate" role="form" ng-submit="vm.reactivate()" ng-show="vm.status===\'re-activate\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Reactivate Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormActivate.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormActivate.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for deemed Clear--><form name="editFormDeemed" role="form" ng-submit="vm.deemedClearService()" ng-show="vm.status===\'deemedClear\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Deemed Clearance</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" data-translate="">Comment</label><textarea class="form-control" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editFormDeemed.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormDeemed.$invalid || file.maxSizeError || vm.projectAttachemnt.file == null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/showprojects-home/projects_home.html','<div class="container-fluid"><div class="row"><div class="col-md-2 pull-right"><select class="custom-select form-control" ng-model="vm.status" ng-change="vm.statusSelected()"><option value="Pending">Pending</option><option value="Reverted" has-any-authority="ROLE_HOME_CTM, ROLE_HOME_SUPERINTENDENT">Reverted</option><option value="Approved" has-any-authority="ROLE_HOME_ASSISTANT">Approved</option></select></div><div class="col-md-1 filter-margin pull-right"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div></div><div class="row mt-30"><div class="col-md-12"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>Service Name</th><th>CAF Pin (Composite Application Form)</th><th>Business Entity</th><th>District</th><th>Department Name</th><th>Ageing</th><th>Latest Comments</th><th>Last Action Date</th><th></th></tr></thead><tbody><tr ng-if="projects.length > 0" ng-repeat="project in projects = ( vm.projects | orderBy:\'-lastActionDate\' | filter: {departmentName: vm.currentDepartment}) "><td>{{$index+1}}</td><td>{{project.serviceName}}</td><td>{{project.cafPin}}</td><td>{{project.businessEntity}}</td><td>{{project.district}}</td><td>{{project.departmentName}}</td><td>{{project.ageing}}</td><td>{{project.lastComments}}</td><td>{{project.lastActionDate | date:\'dd-MM-yyyy\'}}</td><td><button type="button" has-any-authority="ROLE_HOME_CTM" ng-if="project.status==\'Pending\'" class="btn btn-info btn-sm" ng-click="vm.mark(project, \'Marked to Superintendent\', $index)">Mark to Superintendent</button> <button type="button" has-any-authority="ROLE_HOME_SUPERINTENDENT" ng-if="project.status==\'Marked to Superintendent\'" class="btn btn-info btn-sm" ng-click="vm.mark(project, \'Marked to Assistant\', $index)">Mark to Assistant</button> <button type="button" has-any-authority="ROLE_HOME_ASSISTANT" ng-if="project.status==\'Marked to Assistant\'" class="btn btn-info btn-sm" ng-click="vm.mark(project, \'Reverted to Superintendent\', $index)">Revert to Superintendent</button> <button type="button" has-any-authority="ROLE_HOME_SUPERINTENDENT" ng-if="project.status==\'Reverted to Superintendent\'" class="btn btn-info btn-sm" ng-click="vm.mark(project, \'Reverted to CTM\', $index)">Revert to CTM</button> <button type="button" has-any-authority="ROLE_HOME_CTM" ng-if="project.status==\'Reverted to CTM\'" class="btn btn-info btn-sm" ng-click="vm.mark(project, \'Mark to DC\', $index)">Mark to DC</button> <button type="button" has-any-authority="ROLE_HOME_DC" ng-if="project.status==\'Mark to DC\'" class="btn btn-info btn-sm" ng-click="vm.mark(project, \'Approved\', $index)">Approve</button> <button type="button" has-any-authority="ROLE_HOME_DC" ng-if="project.status==\'Mark to DC\'" class="btn btn-info btn-sm" ng-click="vm.mark(project, \'Rejected\', $index)">Reject</button> <button type="button" has-any-authority="ROLE_HOME_ASSISTANT" class="btn btn-info btn-sm" ng-show="project.status===\'Approved\'" ui-sref="action-home({action:\'clearance\',projectserviceid:project.id})">Clearance</button> <button type="button" class="btn btn-info btn-sm" ui-sref="action-home({action:\'service-logs\',projectserviceid:project.id})">View Service Log</button> <button type="button" class="btn btn-info btn-sm" ui-sref="action-home({action:\'comment\',projectserviceid:project.id})">Comment</button><!--                        <button--><!--                            type="button" has-any-authority="ROLE_HOME_ASSISTANT"--><!--                            class="btn btn-info btn-sm"  ng-show="project.status===\'Approved\'" ui-sref="action-home({action:\'reject\',projectserviceid:project.id})">Reject--><!--                        </button>--> <button type="button" class="btn btn-info btn-sm" ui-sref="action-home({action:\'view-form\',projectserviceid:project.id})">View Service Form</button></td></tr><tr ng-if="projects.length == 0" class="text-center"><td colspan="10"><h1 class="pt-60">No records found</h1></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/showprojects-towerdc/projects-dialog.html','<!--modal for logs--><div class="container-fluid" ng-show="vm.status===\'service-logs\'"><div class="row"><div class="col-md-12"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><form name="myForm" class="form-horizontal" role="form"><div class="row modal-header"><h4 class="modal-title">Service Log</h4><h4 class="text-center"><b>{{vm.service.serviceName}}</b></h4></div><div class="row"><div class="col-md-12"><table class="jh-table table table-striped table-responsive"><thead><tr><th><span>Action Taken</span></th><th><span>Date</span></th><th><span>Action By</span></th><th><span>Comments</span></th><th><span>Reason Category</span></th><th><span>Rejection Reason</span></th><th><span>Attachment</span></th></tr></thead><tbody><tr ng-repeat="servicelog in vm.ServiceLog | orderBy:\'-commentDate\'"><td>{{(servicelog.actionTaken == \'Rejected\' ? "Deactivated": (servicelog.actionTaken == \'Declined\' ? "Rejected" : (servicelog.actionTaken == \'MarkedRequired\' ? "Required" : (servicelog.actionTaken == \'ServiceFormEdited\' ? "Service Form Filled" : (servicelog.actionTaken == \'OpenComment\' ? "Comment" :servicelog.actionTaken)))))}}</td><td>{{servicelog.commentDate | date:\'dd-MM-yyyy\'}}</td><td>{{servicelog.commentByUserLogin}}</td><td class="break-line">{{(servicelog.comments == \'MarkedRequired\' ? (servicelog.comments= \'The Investor has indicated his desire for this service\') : servicelog.comments)}}</td><td>{{servicelog.reasonCategory}}</td><td>{{servicelog.rejectionReason}}</td><td><button ng-show="(servicelog.fileName) || ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))" type="button" class="btn btn-primary" ng-click="vm.downloadFile(servicelog.fileName,servicelog.fileName)">Download</button></td></tr></tbody></table></div></div></form><div class="row modal-footer"><button type="button" class="btn btn-default" ng-click="vm.clear()">Close</button></div></div></div></div><!--modal for viewform--><form id="myForm" name="myForm" class="form-horizontal" role="form" ng-show="vm.status===\'view-form\'"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success pull-right"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><div id="pdf_data" class="panel"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">{{vm.project.departmentName}} : {{vm.project.serviceName}}</h4></div><div class="panel-body"><div ng-repeat="field in vm.serviceFormFieldData | orderBy : \'formfieldOrder\'" class="form-horizontal"><div class="row"><div class="col-sm-6"><label class="control-label pull-right">{{field.formfieldName}}</label></div><div class="col-sm-6"><p class="control-label pull-left">{{field.formfieldvalue}}</p></div></div></div><br><div class="col-lg-offset-2 col-lg-8"><center><table class="table table-striped table-responsive table-hover"><thead><tr><th class="col-lg-6">File Description</th><th class="col-lg-2">Action</th></tr></thead><tbody><tr ng-repeat="serviceformattachment in vm.serviceformattachments"><td>{{serviceformattachment.description}}</td><td><button type="button" class="btn btn-success pull-center btn-sm" ng-click="vm.downloadFile(serviceformattachment.serverfilename,serviceformattachment.downloadfilename)"><span class="glyphicon glyphicon-download-alt"></span></button></td></tr></tbody></table></center></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form><!--modal for clearance--><form name="editFormClear" role="form" ng-submit="vm.clearService()" ng-show="vm.status===\'clearance\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Service Clearance</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" id="textArea" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormClear.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormClear.$invalid || file.maxSizeError || vm.projectAttachemnt.file == null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for rejection--><form name="editFormReject" role="form" ng-submit="vm.rejectService()" ng-show="vm.status===\'reject\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Reject Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-if="vm.projectService.serviceid === \'741f0f60-cf69-4659-8b19-19d96ffe0103\' || vm.projectService.serviceid === \'58d75fd4-f360-4931-a484-ff9be0adc12c\' || vm.projectService.serviceid === \'6f81801c-59c6-4773-9f37-a5d81172a1bf\' || vm.projectService.serviceid === \'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\' || vm.projectService.serviceid === \'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\'"><label class="control-label">Select Category</label><select class="form-control" ng-model="vm.selectedCategory" ng-change="vm.getRejectionReason(vm.selectedCategory)" ng-options="reasonCategory as reasonCategory.category for reasonCategory in vm.reasonCategories" required><option value="">-- Select --</option></select></div><div class="form-group" ng-if="vm.projectService.serviceid === \'741f0f60-cf69-4659-8b19-19d96ffe0103\' || vm.projectService.serviceid === \'58d75fd4-f360-4931-a484-ff9be0adc12c\' || vm.projectService.serviceid === \'6f81801c-59c6-4773-9f37-a5d81172a1bf\' || vm.projectService.serviceid === \'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\' || vm.projectService.serviceid === \'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\'"><label class="control-label">Select Reason</label><select class="form-control" ng-model="vm.selectedReason" ng-change="vm.getReasons()" multiple="multiple" ng-options="rejectionReason as rejectionReason.reason for rejectionReason in vm.rejectionReasons" required><option value="">-- Select --</option></select></div><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormReject.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormReject.$invalid || file.maxSizeError || vm.projectAttachemnt.file == null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for deactivation--><form name="editFormDeactivate" role="form" ng-submit="vm.deactivateService()" ng-show="vm.status===\'deactivate\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Deactivate Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormReject.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormDeactivate.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for comment--><form name="editFormComment" role="form" ng-submit="vm.addComment()" ng-show="vm.status===\'comment\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormComment.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormComment.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for clarification--><form name="comment" role="form" ng-submit="vm.addClarification(\'DC\')" ng-show="vm.status===\'clarification\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><br><div class="form-group"><label class="control-label">Choose Comment Type <i style="color: red; font-size: 25px">*</i></label><br><input type="radio" name="commentType" ng-model="vm.commentsType" value="Comment" ng-click="vm.chooseCommentType(\'Comment\')" required><label class="control-label">General Comment</label><br><label>(This option facilitates general communication between the department officers (intra departmental communication). Importantly, using this provision will not impact the department\u2019s timeline)</label><br><input type="radio" name="commentType" ng-model="vm.commentsType" value="Clarification" ng-click="vm.chooseCommentType(\'Clarification\')" required><label class="control-label">Send Back To User for Clarification</label><br><label>(This option is specifically for raising clarifications with the applicant regarding missing documents or information. When this provision is utilized, the department\u2019s timeline will pause until a response is received from the applicant)</label><br><!-- Show only when Clarification is selected --><div class="form-group" ng-if="vm.commentsType === \'Clarification\' && (\n              vm.projectService.serviceid === \'741f0f60-cf69-4659-8b19-19d96ffe0103\' ||\n              vm.projectService.serviceid === \'58d75fd4-f360-4931-a484-ff9be0adc12c\' ||\n              vm.projectService.serviceid === \'6f81801c-59c6-4773-9f37-a5d81172a1bf\' ||\n              vm.projectService.serviceid === \'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\' ||\n              vm.projectService.serviceid === \'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\'\n           )"><label class="control-label">Select Category <i style="color: red">*</i></label><select class="form-control" ng-model="vm.selectedCategory" ng-change="vm.getRejectionReason(vm.selectedCategory)" ng-options="reasonCategory as reasonCategory.category for reasonCategory in vm.reasonCategories" ng-required="vm.commentsType === \'Clarification\'"><option value="">-- Select --</option></select></div><div class="form-group" ng-if="vm.commentsType === \'Clarification\' && (\n              vm.projectService.serviceid === \'741f0f60-cf69-4659-8b19-19d96ffe0103\' ||\n              vm.projectService.serviceid === \'58d75fd4-f360-4931-a484-ff9be0adc12c\' ||\n              vm.projectService.serviceid === \'6f81801c-59c6-4773-9f37-a5d81172a1bf\' ||\n              vm.projectService.serviceid === \'5f8e0757-e88b-4ef1-bb15-00a9e984b9b1\' ||\n              vm.projectService.serviceid === \'fc1b1635-d3dc-4d30-a5fd-5abf6381594d\'\n           )"><label class="control-label">Select Reason <i style="color: red">*</i></label><select class="form-control" ng-model="vm.selectedReason" ng-change="vm.getReasons()" multiple="multiple" ng-options="rejectionReason as rejectionReason.reason for rejectionReason in vm.rejectionReasons" ng-required="vm.commentsType === \'Clarification\'"><option value="">-- Select --</option></select></div><label class="control-label">Description</label><textarea class="form-control" id="description" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="comment.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="comment.$invalid || comment.description.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for undo reject--><form name="editFormUndoReject" role="form" ng-submit="vm.undoreject()" ng-show="vm.status===\'undo-reject\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Undo Reject Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormUndoReject.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormUndoReject.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for re activate--><form name="editFormActivate" role="form" ng-submit="vm.reactivate()" ng-show="vm.status===\'re-activate\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Reactivate Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormActivate.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormActivate.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for deemed Clear--><form name="editFormDeemed" role="form" ng-submit="vm.deemedClearService()" ng-show="vm.status===\'deemedClear\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Deemed Clearancee</h4></div><div class="modal-body"><div class="form-group"><label class="control-label" data-translate="">Comment</label><textarea class="form-control" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.projectServiceLog.comments" required></textarea><div ng-show="editFormDeemed.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormDeemed.$invalid || file.maxSizeError || vm.projectAttachemnt.file == null"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><form name="myForm" class="form-horizontal" role="form" ng-show="vm.status===\'verifyOtherPayment\'"><div class="panel panel-primary"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel">Payment Stack</h4></div><div class="panel-body"><h5 ng-show="(vm.assignFeeDetail==0)">No Payments Made.</h5><table class="jh-table table table-striped table-bordered" ng-show="(vm.assignFeeDetail!=0)"><thead><tr><th><span>Amount</span></th><th><span>Description</span></th><th><span>Payment Made By</span></th><th><span>Payment Date</span></th><th><span>Transaction ID</span></th><th><span>Payment Status</span></th></tr></thead><tbody><!-- <tr ng-repeat="allPaymentsDetail in vm.allPaymentsDetail | orderBy : \'-paymentDate\'" ng-show="(allPaymentsDetail.paymentMade!=0)">\n                         <td>Rs.&nbsp;{{allPaymentsDetail.paymentMade}}</td>\n                         <td>{{allPaymentsDetail.paymentMadeBy}}</td>\n                         <td>{{allPaymentsDetail.paymentDate | date : \'medium\'}}</td>\n                         <td>{{allPaymentsDetail.transactionId}}</td>\n                         <td>{{allPaymentsDetail.paymentStatus}}</td>\n                     </tr>--><tr ng-repeat="assignFeeDetail in vm.assignFeeDetail | orderBy : \'-paymentDate\'" ng-show="(assignFeeDetail.paymentMade!=0) && (assignFeeDetail.length!=0) "><td>Rs.&nbsp;{{assignFeeDetail.paymentMade}}</td><td>{{assignFeeDetail.feeDescription}}</td><td>{{assignFeeDetail.paymentMadeBy}}</td><td>{{assignFeeDetail.paymentDate | date : \'medium\'}}</td><td>{{assignFeeDetail.transactionId}}</td><td>{{assignFeeDetail.paymentStatus}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form><!-- modal for revert --><form name="editFormRevert" role="form" ng-submit="vm.addRevert()" ng-show="vm.status === \'Revert\'" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Revert</h4></div><div class="modal-body"><div class="form-group"><label>Description</label><textarea class="form-control" name="description" rows="3" ng-model="vm.projectServiceLog.comments" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22\\x27\\s\\x0D:\\/-]*$/" required>\n            </textarea><div ng-show="editFormRevert.description.$error.pattern" style="color:red">Only allowed characters: _\'.@A-Za-z0-9-,=();:/-</div></div><div class="form-group"><label>Attachment</label><input type="file" class="form-control" file-model="vm.projectAttachemnt.file"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Cancel</button> <button type="submit" class="btn btn-primary" ng-disabled="editFormRevert.$invalid">Save</button></div></form><!-- modal for Reject Intimation --><form name="editFormRejectIntimated" role="form" ng-submit="vm.rejectIntimation()" ng-show="vm.status === \'RejectIntimated\'" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Reject Intimation</h4></div><div class="modal-body"><div class="form-group"><label>Description</label><textarea class="form-control" name="description" rows="3" ng-model="vm.projectServiceLog.comments" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22\\x27\\s\\x0D:\\/-]*$/" required>\n            </textarea><div ng-show="editFormRejectIntimated.description.$error.pattern" style="color:red">Only allowed characters: _\'.@A-Za-z0-9-,=();:/-</div></div><div class="form-group"><label>Attachment</label><input type="file" class="form-control" file-model="vm.projectAttachemnt.file"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Cancel</button> <button type="submit" class="btn btn-primary" ng-disabled="editFormRejectIntimated.$invalid">Save</button></div></form>');
$templateCache.put('app/showprojects-towerdc/projects.html','<div class="container-fluid"><div class="row"><div class="col-md-3 pull-right"><select class="custom-select form-control" ng-model="vm.currentDepartment" , ng-change="vm.statusSelected()"><option value="All">All Departments</option><option value="{{department.departmentname}}" ng-repeat="department in vm.departments">{{department.departmentname}}</option></select></div><div class="col-md-2 pull-right"><select class="custom-select form-control" ng-model="vm.status" ng-change="vm.statusSelected()"><option value="Pending">Pending</option><option value="Reverted">Reverted</option><option value="RejectIntimated">Reject Intimated</option><option value="Cleared">Cleared</option><option value="DeemedCleared">Deemed Cleared</option><option value="Declined">Rejected</option></select></div><div class="col-md-1 filter-margin pull-right"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div></div><div class="row mt-30"><div class="col-md-12"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>Service Name</th><th>CAF Pin (Composite Application Form)</th><th>Business Entity</th><th>District</th><th>Department Name</th><th>More Info</th><th>Ageing</th><th>Latest Comments</th><th>Last Action Date</th><th></th></tr></thead><tbody><!--                    <tr ng-if="projects.length > 0" ng-repeat="project in projects = ( vm.projects | orderBy:\'-lastactiondate\' | filter: {departmentname: vm.currentDepartment})">--><tr dir-paginate="project in vm.projects.content | orderBy:\'-lastactiondate\' | itemsPerPage: pageSize" total-items="vm.projects.totalElements" current-page="currentPage"><td>{{$index+1}}</td><td>{{project.servicename}}</td><td>{{project.cafpin}}</td><td>{{project.businessentity}}</td><td>{{project.district}}</td><td>{{project.servicename===\'Communication and Connectivity Permissions/Renewal(Below Ground)\' ? project.noDept : project.departmentname}}</td><td>{{project.subDepartmentName}}</td><td>{{project.age}}</td><td>{{project.latestComments}}</td><td>{{project.lastactiondate | date:\'dd-MM-yyyy\'}}</td><td><button type="button" class="btn btn-info btn-sm" ui-sref="action({action:\'service-logs\',projectserviceid:project.projectserviceid})">View Service Log</button> <button type="button" class="btn btn-info btn-sm" ui-sref="action({action:\'view-form\',projectserviceid:project.projectserviceid})" ng-show="project.formfilledstatus">View Service Form</button> <button type="button" ui-sref="action({action:\'verifyOtherPayment\',projectserviceid:project.projectserviceid})" class="btn btn-info btn-sm" ng-show="project.serviceid!=\'240d2c66-b6cc-4a0c-b5f0-3f6717177810\'">View Payments</button> <button type="button" class="btn btn-info btn-sm" ng-show="(project.status===\'Pending\') && (!vm.isForceMajeure) && (!project.reverted || !project.rejectIntimated) && (project.age <= 30) " ui-sref="action({action:\'Revert\',projectserviceid:project.projectserviceid})">Revert</button> <button type="button" class="btn btn-info btn-sm" ng-show="(project.status===\'Pending\' || project.status===\'Reverted\') && (!vm.isForceMajeure) && (!project.rejectIntimated)" ui-sref="action({action:\'RejectIntimated\',projectserviceid:project.projectserviceid})">Reject Intimation</button> <button type="button" class="btn btn-info btn-sm" ng-show="(project.status===\'Pending\' || project.status===\'Reverted\' || project.status===\'RejectIntimated\') && (!vm.isForceMajeure) && (project.rejectIntimated || project.age >= 45)" ui-sref="action({action:\'reject\',projectserviceid:project.projectserviceid})">Reject</button> <button type="button" class="btn btn-info btn-sm" ui-sref="action({action:\'comment\',projectserviceid:project.projectserviceid})">Comment</button> <button type="button" ng-disabled="vm.isSaving" ng-show="(project.deemedclearancerequired) &&(project.status==\'Pending\') && !vm.isForceMajeure" ui-sref="action({action:\'deemedClear\',projectserviceid:project.projectserviceid})" class="btn btn-info btn-sm">Deemed Clearance</button> <button has-any-authority="ROLE_TOWER_DC" ng-disabled="vm.isSaving" type="submit" ng-show="(project.servicename === \'Communication and Connectivity Permissions/Renewal(Above Ground)\' || project.servicename===\'Regularization of existing Tower/Renewal (Above ground)\' || project.servicename===\'Right of Way / Right of Use to CABLE TV Operators\' || project.servicename===\'Renewal/Extension of Communication and Connectivity Permissions\') && project.status==\'Pending\' && !vm.isForceMajeure" data-toggle="modal" data-target="#tower_department2" ng-click="vm.tower_departments(project,\'tower\')" class="btn btn-info btn-sm">Update Department</button><!--                            <button  type="submit"--><!--                                      ui-sref="action({action:\'clarification\',projectserviceid:project.projectserviceid})"--><!--                                     class="btn btn-info btn-sm">Comment--><!--                            </button>--> <button has-any-authority="ROLE_TOWER_DC" ng-disabled="vm.isSaving" type="submit" ng-show="(project.servicename===\'Communication and Connectivity Permissions/Renewal(Below Ground)\') && project.status==\'Pending\' && !vm.isForceMajeure" data-toggle="modal" data-target="#tower_department2" ng-click="vm.tower_departments(project,\'tower\')" class="btn btn-info btn-sm">Update Department</button> <button type="button" class="btn btn-info btn-sm" ng-show="project.status===\'Pending\' && !vm.isForceMajeure" ui-sref="action({action:\'clearance\',projectserviceid:project.projectserviceid})">Clearance</button><!--<button--><!--type="button"--><!--class="btn btn-info btn-sm" ng-show="project.status===\'Rejected\'" ui-sref="action({action:\'re-activate\',projectserviceid:project.projectserviceid})">Reactivate--><!--</button>--><!--                            <button--><!--                                type="button"--><!--                                class="btn btn-info btn-sm" ng-show="project.status===\'Declined\' && !vm.isForceMajeure" ui-sref="action({action:\'undo-reject\',projectserviceid:project.projectserviceid})">Undo Reject--><!--                            </button>--><label ng-show="(project.status==\'Declined\')">Service Rejected</label><label ng-show="(project.status==\'Rejected\')">Service Deactivated</label><label ng-show="(project.status==\'Cleared\')">Service Cleared</label><label ng-show="(project.status==\'DeemedCleared\')">Service Deemed Cleared</label><label ng-show="(project.status==\'Withdraw\')">Service Withdraw</label></td></tr><!--                    <tr ng-if="projects.length == 0" class="text-center">--><!--                        <td colspan="10">--><!--                            <h1 class="pt-60">No records found</h1>--><!--                        </td>--><!--                    </tr>--></tbody></table><div class="row text-center"><div class="col-lg-3 col-lg-offset-4"><label class="control-label col-lg-8" style="margin-top: 4px">View number of records per page</label><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div><!-- Modal --><div class="modal" id="tower_department2" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="clear()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title">Select New Department</h4></div><div class="modal-body"><div class="row panel-body"><div class="table-responsive" style="display:block;overflow:auto;height:400px;width:100%"><table class="jh-table table table-striped"><thead><tr><th><span>Department Name</span></th><th><span>Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.tower_departmentlist" ng-show="department.istower"><td>{{department.departmentname}}</td><td><input type="checkbox" class="form-control" ng-click="vm.updateCheck(department.departmentname)" checklist-model="required.department" checklist-value="department.departmentname"></td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="clear()">Close</button> <button type="button" ng-disabled="required.department.length==0" ng-show="vm.tower_service.projectserviceid!=null" class="btn btn-primary" ng-click="vm.updateTowerServiceNO(vm.tower_service.projectserviceid)" data-dismiss="modal">Done</button></div></div></div></div><div class="modal rmPaddingModal" id="YourModalId" data-backdrop="static" data-keyboard="false" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close" ng-click="vm.closeModal()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="YourModalId1">Select Required Department/Department\'s</h4></div><div class="modal-body" ng-show="vm.municipals.length!=0"><div class="row panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Department Name</span></th><th><span>Required</span></th></tr></thead><tbody><tr ng-repeat="department in vm.municipals"><td>{{department.name}}</td><td><input class="form-control" type="radio" name="myType" ng-model="vm.aboveMunicipal" value="{{department.name}}"><!--<input type="checkbox" class="form-control" ng-click="vm.updateMunicipal(department.name)" checklist-model="required.municipal" checklist-value="department.name"/>--></td></tr></tbody></table></div></div></div><div class="modal-footer" ng-show="vm.municipals.length!=0"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.closeModal()">Close</button> <button type="button" class="btn btn-primary" ng-disabled="vm.aboveMunicipal==null" ng-click="vm.markRequiredForMunicipal(vm.tower_service.projectserviceid,required.department,vm.aboveMunicipal)" data-dismiss="modal">Done</button></div><div class="alert alert-warning" ng-hide="vm.municipals.length>0"><b>No</b> Department!</div></div></div></div>');
$templateCache.put('app/showprojects-towerdio/projects-dialog_towerdio.html','<!--modal for logs--><div class="container-fluid" ng-show="vm.status===\'service-logs\'"><div class="row"><div class="col-md-12"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><form name="myForm" class="form-horizontal" role="form"><div class="row modal-header"><h4 class="modal-title">Service Log</h4><h4 class="text-center"><b>{{vm.service.serviceName}}</b></h4></div><div class="row"><div class="col-md-12"><table class="jh-table table table-striped table-responsive"><thead><tr><th><span>Action Taken</span></th><th><span>Date</span></th><th><span>Action By</span></th><th><span>Comments</span></th><th><span>Attachment</span></th></tr></thead><tbody><tr ng-repeat="servicelog in vm.ServiceLog | orderBy:\'-commentDate\'"><td>{{(servicelog.actionTaken == \'Rejected\' ? "Deactivated": (servicelog.actionTaken == \'Declined\' ? "Rejected" : (servicelog.actionTaken == \'MarkedRequired\' ? "Required" : (servicelog.actionTaken == \'ServiceFormEdited\' ? "Service Form Filled" : (servicelog.actionTaken == \'OpenComment\' ? "Comment" :servicelog.actionTaken)))))}}</td><td>{{servicelog.commentDate | date:\'dd-MM-yyyy\'}}</td><td>{{servicelog.commentByUserLogin}}</td><td class="break-line">{{(servicelog.comments == \'MarkedRequired\' ? (servicelog.comments= \'The Investor has indicated his desire for this service\') : servicelog.comments)}}</td><td><button ng-show="(servicelog.fileName) || ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))" type="button" class="btn btn-primary" ng-click="vm.downloadFile(servicelog.fileName,servicelog.actionTaken)">Download</button></td></tr></tbody></table></div></div></form><div class="row modal-footer"><button type="button" class="btn btn-default" ng-click="vm.clear()">Close</button></div></div></div></div><!--modal for viewform--><form id="myForm" name="myForm" class="form-horizontal" role="form" ng-show="vm.status===\'view-form\'"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success pull-right"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><div id="pdf_data" class="panel"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">{{vm.project.departmentName}} : {{vm.project.serviceName}}</h4></div><div class="panel-body"><div ng-repeat="field in vm.serviceFormFieldData | orderBy : \'formfieldOrder\'" class="form-horizontal"><div class="row"><div class="col-sm-6"><label class="control-label pull-right">{{field.formfieldName}}</label></div><div class="col-sm-6"><p class="control-label pull-left">{{field.formfieldvalue}}</p></div></div></div><br><div class="col-lg-offset-2 col-lg-8"><center><table class="table table-striped table-responsive table-hover"><thead><tr><th class="col-lg-6">File Description</th><th class="col-lg-2">Action</th></tr></thead><tbody><tr ng-repeat="serviceformattachment in vm.serviceformattachments"><td>{{serviceformattachment.description}}</td><td><button type="button" class="btn btn-success pull-center btn-sm" ng-click="vm.downloadFile(serviceformattachment.serverfilename,serviceformattachment.downloadfilename)"><span class="glyphicon glyphicon-download-alt"></span></button></td></tr></tbody></table></center></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form><!--modal for clearance--><form name="clearanceForm" role="form" ng-submit="vm.clearService()" ng-show="vm.status===\'clearance\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Service Clearance</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" id="textArea" name="textArea" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="clearanceForm.textArea.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="clearanceForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for rejection--><form name="rejectForm" role="form" ng-submit="vm.rejectService()" ng-show="vm.status===\'reject\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Reject Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="rejectForm.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="rejectForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for deactivation--><form name="deactivateForm" role="form" ng-submit="vm.deactivateService()" ng-show="vm.status===\'deactivate\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Deactivate Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="deactivateForm.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="deactivateForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for comment--><form name="comment" role="form" ng-submit="vm.addComment()" ng-show="vm.status===\'comment\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea id="description" class="form-control" name="description" rows="3" ng-model="vm.comments" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" required></textarea><div ng-show="comment.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="comment.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for undo reject--><form name="undo-rejectForm" role="form" ng-submit="vm.undoreject()" ng-show="vm.status===\'undo-reject\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Undo Reject Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="undo-rejectForm.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="undo-rejectForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for re activate--><form name="editForm" role="form" ng-submit="vm.reactivate()" ng-show="vm.status===\'re-activate\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Reactivate Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editForm.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form>');
$templateCache.put('app/showprojects-towerdio/projects_towerdio.html','<div class="container-fluid"><div class="row"><div class="col-md-3 pull-right"><select class="custom-select form-control" ng-model="vm.currentDepartment" ng-change="vm.statusSelected()"><option value="All">All Departments</option><option value="{{department.departmentname}}" ng-repeat="department in vm.departments">{{department.departmentname}}</option></select></div><div class="col-md-2 pull-right"><select style="border: none; box-shadow: none" class="form-control" ng-model="vm.status" ng-change="vm.statusSelected()"><option value="Pending">Pending</option><option value="Cleared">Cleared</option><option value="DeemedCleared">Deemed Cleared</option><option value="Declined">Rejected</option></select></div><div class="col-md-1 filter-margin pull-right"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div></div><div class="row mt-30"><div class="col-md-12"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>Service Name</th><th>CAF Pin (Composite Application Form)</th><th>Business Entity</th><th>District</th><th>Department Name</th><th>More Info</th><th>Ageing</th><th>Latest Comments</th><th>Last Action Date</th><th></th></tr></thead><tbody><!--                    <tr ng-if="projects.length > 0" ng-repeat="project in projects = ( vm.projects | orderBy:\'-lastactiondate\' | filter: {departmentname: vm.currentDepartment}) ">--><tr dir-paginate="project in vm.projects.content | orderBy:\'-lastactiondate\' | itemsPerPage: pageSize" total-items="vm.projects.totalElements" current-page="currentPage"><td>{{$index+1}}</td><td>{{project.servicename}}</td><td>{{project.cafpin}}</td><td>{{project.businessentity}}</td><td>{{project.district}}</td><td ng-show="project.servicename===\'Communication and Connectivity Permissions/Renewal(Below Ground)\'">{{project.noDept}}</td><td ng-hide="project.servicename===\'Communication and Connectivity Permissions/Renewal(Below Ground)\'">{{project.departmentname}}</td><td>{{project.subDepartmentName}}</td><td>{{project.age}}</td><td>{{project.latestComments}}</td><td>{{project.lastactiondate | date:\'dd-MM-yyyy\'}}</td><td><button type="button" class="btn btn-info btn-sm" ui-sref="action-towerdio({action:\'service-logs\',projectserviceid:project.projectserviceid})">View Service Log</button> <button type="button" class="btn btn-info btn-sm" ui-sref="action-towerdio({action:\'view-form\',projectserviceid:project.projectserviceid})" ng-show="project.formfilledstatus">View Service Form</button> <button type="button" class="btn btn-info btn-sm" ui-sref="action-towerdio({action:\'comment\',projectserviceid:project.projectserviceid})">Comment</button><!--<button--><!--type="button"--><!--class="btn btn-info btn-sm"  ng-show="project.status===\'Pending\'" ui-sref="action-towerdio({action:\'reject\',projectserviceid:project.projectserviceid})">Reject--><!--</button>--><!--<button--><!--type="button"--><!--class="btn btn-info btn-sm" ng-show="project.status===\'Pending\'" ui-sref="action({action:\'deactivate\',projectserviceid:project.projectserviceid})">Deactivate--><!--</button>--><!--<button--><!--type="button"--><!--class="btn btn-info btn-sm" ng-show="project.status===\'Pending\'" ui-sref="action-towerdio({action:\'clearance\',projectserviceid:project.projectserviceid})">Clearance--><!--</button>--><!--<button--><!--type="button"--><!--class="btn btn-info btn-sm" ng-show="project.status===\'Rejected\'" ui-sref="action({action:\'re-activate\',projectserviceid:project.projectserviceid})">Reactivate--><!--</button>--><!--<button--><!--type="button"--><!--class="btn btn-info btn-sm" ng-show="project.status===\'Declined\'" ui-sref="action-towerdio({action:\'undo-reject\',projectserviceid:project.projectserviceid})">Undo Reject--><!--</button>--><label ng-show="(project.status==\'Declined\')">Service Rejected</label><label ng-show="(project.status==\'Rejected\')">Service Deactivated</label><label ng-show="(project.status==\'Cleared\')">Service Cleared</label><label ng-show="(project.status==\'DeemedCleared\')">Service Deemed Cleared</label><label ng-show="(project.status==\'Withdraw\')">Service Withdraw</label></td></tr><tr ng-if="projects.length == 0" class="text-center"><td colspan="10"><h1 class="pt-60">No records found</h1></td></tr></tbody></table><div class="row text-center"><div class="col-lg-3 col-lg-offset-4"><label class="control-label col-lg-8" style="margin-top: 4px">View number of records per page</label><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div>');
$templateCache.put('app/showprojects-towerofficer/projects-dialog.html','<!--modal for logs--><div id="pdf_logs" class="container-fluid" ng-show="vm.status===\'service-logs\'"><div class="row"><div class="col-md-12"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><form name="logs" class="form-horizontal" role="form"><div class="row modal-header"><h4 class="modal-title">Service Log</h4><h4 class="text-center"><b>{{vm.service.serviceName}}</b></h4></div><div class="row"><div class="col-md-12"><table class="jh-table table table-striped table-responsive"><thead><tr><th><span>Action Taken</span></th><th><span>Date</span></th><th><span>Action By</span></th><th><span>Comments</span></th><th><span>Attachment</span></th></tr></thead><tbody><tr ng-repeat="servicelog in vm.ServiceLog | orderBy:\'-commentDate\'"><td>{{(servicelog.actionTaken == \'Rejected\' ? "Deactivated": (servicelog.actionTaken == \'Declined\' ? "Rejected" : (servicelog.actionTaken == \'MarkedRequired\' ? "Required" : (servicelog.actionTaken == \'ServiceFormEdited\' ? "Service Form Filled" : (servicelog.actionTaken == \'OpenComment\' ? "Comment" :servicelog.actionTaken)))))}}</td><td>{{servicelog.commentDate | date:\'dd-MM-yyyy\'}}</td><td>{{servicelog.commentByUserLogin}}</td><td class="break-line">{{(servicelog.comments == \'MarkedRequired\' ? (servicelog.comments= \'The Investor has indicated his desire for this service\') : servicelog.comments)}}</td><td><button ng-show="(servicelog.fileName) || ((isServiceInList(servicelog.serviceid)) && ((servicelog.actionTaken==\'Cleared\') || (servicelog.actionTaken==\'Declined\')))" type="button" class="btn btn-primary" ng-click="vm.downloadFile(servicelog.fileName,servicelog.fileName)">Download</button></td></tr></tbody></table></div></div></form><div class="row modal-footer"><button type="button" class="btn btn-default" ng-click="vm.clear()">Close</button></div></div></div></div><!--modal for viewform--><form name="viewForm" class="form-horizontal" role="form" ng-show="vm.status===\'view-form\'"><div class="btn-margin"><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="pull-right"><button title="dowload as pdf" ng-click="vm.pdfconverter()" type="button" class="btn btn-success pull-right"><span class="glyphicon glyphicon-download-alt"></span></button></div></div><div id="pdf_data" class="panel"><div class="modal-header"><h4 class="modal-title" id="myBlockLabel">{{vm.project.departmentName}} : {{vm.project.serviceName}}</h4></div><div class="panel-body"><div ng-repeat="field in vm.serviceFormFieldData | orderBy : \'formfieldOrder\'" class="form-horizontal"><div class="row"><div class="col-sm-6"><label class="control-label pull-right">{{field.formfieldName}}</label></div><div class="col-sm-6"><p class="control-label pull-left">{{field.formfieldvalue}}</p></div></div></div><br><!--documents--><div class="col-lg-offset-2 col-lg-8"><center><table class="table table-striped table-responsive table-hover"><thead><tr><th class="col-lg-6">File Description</th><th class="col-lg-2">Action</th></tr></thead><tbody><tr ng-repeat="serviceformattachment in vm.serviceformattachments"><td>{{serviceformattachment.description}}</td><td><button type="button" class="btn btn-success pull-center btn-sm" ng-click="vm.downloadFile(serviceformattachment.serverfilename,serviceformattachment.downloadfilename)"><span class="glyphicon glyphicon-download-alt"></span></button></td></tr></tbody></table></center></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form><!--modal for comment--><form name="comment" role="form" ng-submit="vm.addComment()" ng-show="vm.status===\'comment\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label">Description</label><textarea class="form-control" id="description" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="comment.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="comment.description.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><form name="comment" role="form" ng-submit="vm.addClarification(\'TO\')" ng-show="vm.status===\'clarification\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Comment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><br><div class="form-group"><label class="control-label">Choose Comment Type <i style="color: red; font-size: 25px">*</i></label><br><input type="radio" name="commentType" ng-model="vm.commentsType" value="Comment" ng-click="vm.chooseCommentType(\'Comment\')" required><label class="control-label">General Comment</label><br><label>(This option facilitates general communication between the department officers (intra departmental communication). Importantly, using this provision will not impact the department\u2019s timeline)</label><br><input type="radio" name="commentType" ng-model="vm.commentsType" value="Clarification" ng-click="vm.chooseCommentType(\'Clarification\')" required><label class="control-label">Send Back To User for Clarification</label><br><label>(This option is specifically for raising clarifications with the applicant regarding missing documents or information. When this provision is utilized, the department\u2019s timeline will pause until a response is received from the applicant)</label><br><!-- Show only when Clarification is selected --><div class="form-group" ng-if="vm.commentsType === \'Clarification\'"><label class="control-label">Select Category <i style="color: red">*</i></label><select class="form-control" ng-model="vm.selectedCategory" ng-change="vm.getRejectionReason(vm.selectedCategory)" ng-options="reasonCategory as reasonCategory.category for reasonCategory in vm.reasonCategories" ng-required="vm.commentsType === \'Clarification\'"><option value="">-- Select --</option></select></div><div class="form-group" ng-if="vm.commentsType === \'Clarification\'"><label class="control-label">Select Reason <i style="color: red">*</i></label><select class="form-control" ng-model="vm.selectedReason" ng-change="vm.getReasons()" multiple="multiple" ng-options="rejectionReason as rejectionReason.reason for rejectionReason in vm.rejectionReasons" ng-required="vm.commentsType === \'Clarification\'"><option value="">-- Select --</option></select></div><label class="control-label">Description</label><textarea class="form-control" id="description" name="description" rows="3" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="comment.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="comment.$invalid || comment.description.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for Assign Service Fee--><form name="assignFee" role="form" ng-submit="vm.assignServiceFee()" ng-show="vm.status===\'assign-serviceFee\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCountryLabel" data-translate="">Service Fee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Fee Amount</label><input type="number" class="form-control" ng-model="vm.serviceFee" required></div><div class="form-group"><label class="control-label" data-translate="">Comment</label><textarea class="form-control" rows="3" id="textArea" name="comment" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="assignFee.comment.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><div class="form-group"><label class="control-label" data-translate="">Attachment</label><input type="file" class="form-control input" file-model="vm.projectAttachemnt.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="assignFee.$invalid || file.maxSizeError"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!-- modal for the officer\'s word on an acknowledged intimation - Approve stands it as\n     valid, Reject takes it away. Both are answered on this one form. --><form name="intimationDecisionForm" role="form" ng-submit="vm.addIntimationDecision()" ng-show="vm.status === \'Approve\' || vm.status === \'Reject\'" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.clear()">&times;</button><h4 class="modal-title">{{vm.status === \'Approve\' ? \'Approve Intimation\' : \'Reject Intimation\'}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><label>{{vm.status === \'Approve\' ? \'The intimation will be marked Intimation Valid.\' : \'The intimation will be marked Intimation Invalid.\'}}</label><div class="form-group"><label>Description</label><textarea class="form-control" name="description" rows="3" ng-model="vm.projectServiceLog.comments" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22\\x27\\s\\x0D:\\/-]*$/" required>\n            </textarea><div ng-show="intimationDecisionForm.description.$error.pattern" style="color:red">Only allowed characters: _\'.@A-Za-z0-9-,=();:/-</div></div><div class="form-group"><label>Attachment</label><input type="file" class="form-control" file-model="vm.projectAttachemnt.file"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Cancel</button> <button type="submit" class="btn btn-primary" ng-disabled="intimationDecisionForm.$invalid">Save</button></div></form><!-- modal for revert --><form name="editFormRevert" role="form" ng-submit="vm.addRevert()" ng-show="vm.status === \'Revert\'" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Revert</h4></div><div class="modal-body"><div class="form-group"><label>Description</label><textarea class="form-control" name="description" rows="3" ng-model="vm.projectServiceLog.comments" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22\\x27\\s\\x0D:\\/-]*$/" required>\n            </textarea><div ng-show="editFormRevert.description.$error.pattern" style="color:red">Only allowed characters: _\'.@A-Za-z0-9-,=();:/-</div></div><div class="form-group"><label>Attachment</label><input type="file" class="form-control" file-model="vm.projectAttachemnt.file"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Cancel</button> <button type="submit" class="btn btn-primary" ng-disabled="editFormRevert.$invalid">Save</button></div></form>');
$templateCache.put('app/showprojects-towerofficer/showprojectsTowerofficer.html','<div class="container-fluid"><div class="row"><div class="col-md-2 pull-right"><select style="border: none; box-shadow: none" class="form-control" ng-model="vm.status" ng-change="vm.statusSelected()"><option value="Pending">Pending</option><option value="Acknowledged">Acknowledged</option><option value="Reverted">Reverted</option><!-- Where an Above Ground intimation the officer decided ends up.. --><option value="Intimation Valid">Intimation Valid</option><option value="Intimation Invalid">Intimation Invalid</option><!-- ..and where one the portal decided on a closed window ends up. --><option value="Deemed Valid">Deemed Valid</option><option value="Deemed Invalid">Deemed Invalid</option><option value="RejectIntimated">Reject Intimated</option><option value="Cleared">Cleared</option><option value="DeemedCleared">Deemed Cleared</option><option value="Declined">Rejected</option></select></div><div class="col-md-1 filter-margin pull-right"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div></div><div class="row"><div class="col-md-12"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>Service Name</th><th>CAF Pin (Composite Application Form)</th><th>Business Entity</th><th>District</th><th>Department Name</th><th>More Info</th><th>Ageing</th><th>Latest Comments</th><th>Last Action Date</th><th ng-if="vm.showFormFilledOnDate">Form Filled On Date</th><th></th></tr></thead><tbody><tr ng-repeat="project in vm.projects | orderBy:\'-lastactiondate\'"><td>{{$index+1}}</td><td>{{project.servicename}}</td><td>{{project.cafpin}}</td><td>{{project.businessentity}}</td><td>{{project.district}}</td><td ng-show="project.servicename===\'Communication and Connectivity Permissions/Renewal(Below Ground)\'">{{project.noDept}}</td><td ng-hide="project.servicename===\'Communication and Connectivity Permissions/Renewal(Below Ground)\'">{{project.departmentname}}</td><td>{{project.subDepartmentName}}</td><td>{{project.age}}</td><td>{{project.latestComments}}</td><td>{{project.lastactiondate | date:\'dd-MM-yyyy\'}}</td><td ng-if="vm.showFormFilledOnDate">{{project.formFilledOnDate ? (project.formFilledOnDate | date:\'dd-MM-yyyy\') : \'NA\'}}</td><td><button type="button" class="btn btn-info btn-sm" ui-sref="towerofficer-action({action:\'service-logs\',projectserviceid:project.projectserviceid})">View Service Log</button> <button type="button" class="btn btn-info btn-sm" ui-sref="towerofficer-action({action:\'view-form\',projectserviceid:project.projectserviceid})" ng-show="project.formfilledstatus">View Service Form</button><!--                        <button--><!--                            type="button"--><!--                            class="btn btn-info btn-sm"  ui-sref="towerofficer-action({action:\'comment\',projectserviceid:project.projectserviceid})">Comment--><!--                        </button>--> <button type="button" class="btn btn-info btn-sm" ui-sref="towerofficer-action({action:\'assign-serviceFee\',projectserviceid:project.projectserviceid})" ng-show="(project.assigned==false) && (project.status==\'Pending\') && (project.departmentLevel) && (!project.isForceMajeure) && (project.serviceid!=\'240d2c66-b6cc-4a0c-b5f0-3f6717177810\')">Assign Service Fee</button><!--                        <button  type="submit"--><!--                                 ng-show="vm.isTowerServiceForClarification(project.serviceId) && !project.isForceMajeure"   ui-sref="towerofficer-action({action:\'clarification\',projectserviceid:project.projectserviceid})"--><!--                                 class="btn btn-info btn-sm">Comment--><!--                        </button> --><!--                        --> <button type="submit" ng-show="vm.isTowerServiceForClarification(project.serviceId) && !project.isForceMajeure" ui-sref="towerofficer-action({action:\'comment\',projectserviceid:project.projectserviceid})" class="btn btn-info btn-sm">Comment</button> <button type="button" class="btn btn-info btn-sm" ng-show="(project.status===\'Pending\') && (!vm.isForceMajeure) && (!project.reverted || !project.rejectIntimated) && (project.age <= 30) && (project.serviceid !=\'240d2c66-b6cc-4a0c-b5f0-3f6717177810\')" ui-sref="towerofficer-action({action:\'Revert\',projectserviceid:project.projectserviceid})">Revert</button> <button type="button" ui-sref="towerofficer-action-verifyOtherPayment({projectserviceid:project.projectserviceid})" class="btn btn-info btn-sm" ng-show="project.required && project.assigned && (projectservice.serviceid!=\'240d2c66-b6cc-4a0c-b5f0-3f6717177810\')">View Payments</button> <button type="submit" ui-sref="assignserviceforbankgurantee({projectserviceid:project.projectserviceid})" ng-disabled="vm.isSaving" ng-show="(project.servicename===\'Communication and Connectivity Permissions/Renewal(Below Ground)\') && (project.assigned) && (project.required) && (project.paymentMade) && (project.status==\'Pending\') && (project.restorationByUser==\'Restoration By User\') && (!project.bankguranteeassigned)" class="btn btn-info btn-sm"><span data-translate="">Assign Bank Gurantee</span></button><!-- Approval for establishment of Telegraph Infrastructure, issued when the\n                             service form of a tower on a property other than public property was filled.\n                             Only Communication and Connectivity Permissions/Renewal(Above Ground) carries one. --> <a ng-if="project.acknowledgementFile && project.serviceid==\'58d75fd4-f360-4931-a484-ff9be0adc12c\'" ng-href="/api/downloadserviceformattachment?serverfilename={{project.acknowledgementFile}}&downloadfilename={{project.acknowledgementFile}}" target="_blank" class="btn btn-info btn-sm"><span>Download Acknowledgement</span> </a><!-- Same revert dialog as the Pending one, open for 15 days from the day\n                             the service form was filled - that day counted in. --> <button type="button" class="btn btn-info btn-sm" ng-show="project.canClarify" ui-sref="towerofficer-action({action:\'Revert\',projectserviceid:project.projectserviceid})">Clarify</button><!-- The officer\'s word on an acknowledged intimation - Approve stands it\n                             as valid, Reject takes it away. Both write a service log. --> <button type="button" class="btn btn-success btn-sm" ng-show="project.canDecideIntimation" ui-sref="towerofficer-action({action:\'Approve\',projectserviceid:project.projectserviceid})">Approve</button> <button type="button" class="btn btn-danger btn-sm" ng-show="project.canDecideIntimation" ui-sref="towerofficer-action({action:\'Reject\',projectserviceid:project.projectserviceid})">Reject</button><label ng-show="(project.status==\'Acknowledged\')">Service Acknowledged</label><label ng-show="(project.status==\'Intimation Valid\')">Intimation Valid</label><label ng-show="(project.status==\'Intimation Invalid\')">Intimation Invalid</label><label ng-show="(project.status==\'Deemed Valid\')">Deemed Valid</label><label ng-show="(project.status==\'Deemed Invalid\')">Deemed Invalid</label><label ng-show="(project.status==\'Declined\')">Service Rejected</label><label ng-show="(project.status==\'Rejected\')">Service Deactivated</label><label ng-show="(project.status==\'Cleared\')">Service Cleared</label><label ng-show="(project.status==\'DeemedCleared\')">Service Deemed Cleared</label><label ng-show="(project.status==\'Withdraw\')">Service Withdraw</label></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/startup-support/startup-support.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Startup Support</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li class="active"><span>Startup Support</span></li></ol></div></section><br><div class="container"><div class="row"><div class="col-md-12"><table class="table table-striped table-hover" ng-switch="vm.isAuthenticated()"><thead><tr class="headerGrid"><th>S.No</th><th>Department Name</th><th>View/Download</th></tr></thead><tbody><tr><td>1</td><td>Government Supported Incubators</td><td><a target="_blank" href="https://www.startupharyana.gov.in/front/government_supported_incubators">View</a></td></tr><tr><td>2</td><td>Incubation Support</td><td><a target="_blank" href="https://live.hartron.org.in/10519">View</a></td></tr><tr><td>3</td><td>Mentorship</td><td><a target="_blank" href="https://haryana.coe-iot.com/">View</a></td></tr><br></tbody></table></div></div></div>');
$templateCache.put('app/startupPolicies/startupPolicies-login.html','<!--<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css">--><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_10 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Haryana State Startup Policy 20222</h1></div></div></div></section><br><div ng-cloak><div class="container"><div class="row"><div class="col-md-3" ng-if="vm.isAuthenticated()"><button class="btn btn-success" type="submit"><a href="https://startupharyana.gov.in/invest-haryana/my-schemes?email={{vm.userdetails.useremail}}&name={{vm.userdetails.username}}" target="_blank" style="color: white">My Incentive Status</a></button></div><div class="col-md-3" ng-if="vm.isAuthenticated()"><button class="btn btn-success" type="submit"><a href="https://startupharyana.gov.in/invest-haryana/objected-schemes?email={{vm.userdetails.useremail}}&name={{vm.userdetails.username}}" target="_blank" style="color: white">Reply to onhold applications</a></button></div><br><table class="table table-striped table-hover"><thead><tr><th colspan="3" style="text-align:center; background-color:#A0233D; font-size:16px">Startup Schemes</th></tr><tr class="headerGrid"><th>S.No</th><th>Scheme Name</th><!--                    <th>EV Policy Document (PDF)</th>--><th>Apply For Scheme</th></tr></thead><tbody><tr><td>1</td><td>REIMBURSEMENT FOR CLOUD STORAGE SCHEME</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>2</td><td>NET SGST REIMBURSEMENT SCHEME</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>3</td><td>PATENT COST REIMBURSEMENT SCHEME</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>4</td><td>LEASE RENTAL SUBSIDY SCHEME</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>5</td><td>ASSISTANCE IN ACCELERATION PROGRAMS SCHEME \u2013 IN-PRINCIPAL APPROVAL</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>6</td><td>ASSISTANCE IN ACCELERATION PROGRAMS SCHEME \u2013 CLAIMING ASSISTANCE</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>7</td><td>SEED FUND FOR STARTUPS - 1ST TRANCHE</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>8</td><td>SEED FUND FOR STARTUPS \u2013 2ND TRANCHE</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>9</td><td>SEED FUND FOR STARTUPS \u2013 3RD TRANCHE</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr></tbody></table></div><div class="row"><table class="table table-striped table-hover"><thead><th colspan="3" style="text-align:center; background-color:#A0233D; font-size:16px">Incubator Schemes</th><tr class="headerGrid"><th>S.No</th><th>Scheme Name</th><!--                    <th>EV Policy Document (PDF)</th>--><th>Apply For Scheme</th></tr></thead><tbody><tr><td>1</td><td>REIMBURSEMENT ON RENTAL CHARGE SCHEME</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>2</td><td>ELECTRICITY DUTY REIMBURSEMENT SCHEME</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>3</td><td>STAMP DUTY & REGISTRATION REIMBURSEMENT SCHEME</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>4</td><td>MENTORING ASSISTANCE SCHEME (IN-PRINCIPLE APPROVAL)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>5</td><td>MENTORING ASSISTANCE SCHEME (POST COMPLETION OF MENTORING PROGRAM)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>6</td><td>ASSISTANCE FOR FAIR/EXHIBITION (IN-PRINCIPLE APPROVAL)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>7</td><td>ASSISTANCE FOR FAIR/EXHIBITION (POST COMPLETION)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>8</td><td>STARTUP COMPETITION ASSISTANCE SCHEME (IN-PRINCIPLE APPROVAL)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>9</td><td>STARTUP COMPETITION ASSISTANCE SCHEME (POST COMPLETION)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>10</td><td>CAPITAL SUBSIDY SCHEME</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>11</td><td>CAPITAL SUBSIDY SCHEME (TRANCHE 1)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>12</td><td>CAPITAL SUBSIDY SCHEME (TRANCHE 2)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>13</td><td>CAPITAL SUBSIDY SCHEME (TRANCHE 3)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>14</td><td>Mobile Application Development Centre Scheme (in-principle Approval)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>15</td><td>Mobile Application Development Centre Scheme (Tranche 1)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>16</td><td>Mobile Application Development Centre Scheme (Tranche 2)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>17</td><td>Mobile Application Development Centre Scheme (Tranche 3)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>18</td><td>Mobile Application Development Centre Scheme (Application for availing the Yearly Support)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>19</td><td>Assistance for New Startup Warehouse/ Innovation Campus Scheme (in- principle Approval)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>20</td><td>Assistance for New Startup Warehouse/ Innovation Campus Scheme (Tranche 1)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>21</td><td>Assistance for New Startup Warehouse/ Innovation Campus Scheme (Tranche 2)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>22</td><td>Assistance for New Startup Warehouse/ Innovation Campus Scheme (Tranche 3)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>23</td><td>Assistance for New Startup Warehouse/ Innovation Campus Scheme (Application for availing the Recurring Expense)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>24</td><td>Assistance for establishing New or Upgrading Incubation Centres in Government Universities & Institutions Scheme (in-principle Approval)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>25</td><td>Assistance for establishing New or Upgrading Incubation Centres in Government Universities & Institutions Scheme (Tranche 1)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>26</td><td>Assistance for establishing New or Upgrading Incubation Centres in Government Universities & Institutions Scheme (Tranche 2)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>27</td><td>Assistance for establishing New or Upgrading Incubation Centres in Government Universities & Institutions Scheme (Tranche 3)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr><tr><td>28</td><td>Assistance for establishing New or Upgrading Incubation Centres in Government Universities & Institutions Scheme (Application for availing the Recurring Expense)</td><td><div class="col-md-6"><form><input type="submit" class="btn btn-link" value="Apply Now" ng-click="vm.login()"></form></div></td></tr></tbody></table></div></div></div><!--<div id="modal-full" class="uk-modal-full" uk-modal esc-close="false" bg-close="false">--><!--    <div class="uk-modal-dialog">--><!--        <button class="uk-modal-close-full uk-close-large" type="button" uk-close></button>--><!--        <div class="uk-grid-collapse uk-flex-middle" uk-grid>--><!--            <section>--><!--                <iframe name="my_iframe" id="my_iframe"  style="width: 500vw; height: 100vh" frameborder="0"--><!--                        marginheight="0" marginwidth="0">--><!--                </iframe>--><!--            </section>--><!--        </div>--><!--    </div>--><!--</div>-->');
$templateCache.put('app/startupPolicies/startupPolicies.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_10 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Haryana State Startup Policy 2022</h1></div></div></div></section><br><div ng-cloak><div class="container"><div class="row"><div class="col-md-3" ng-if="vm.isAuthenticated()"><button class="btn btn-success" type="submit"><a href="https://stagingstartupharyana.trigma.in/invest-haryana/my-schemes?email={{vm.userdetails.useremail}}&name={{vm.userdetails.username}}" target="_blank" style="color: white">My Incentive Status</a></button></div><div class="col-md-3" ng-if="vm.isAuthenticated()"><button class="btn btn-success" type="submit"><a href="https://stagingstartupharyana.trigma.in/invest-haryana/objected-schemes?email={{vm.userdetails.useremail}}&name={{vm.userdetails.username}}" target="_blank" style="color: white">Reply to onhold applications</a></button></div><br><table class="table table-striped table-hover"><thead><th colspan="3" style="text-align:center; background-color:#A0233D; font-size:16px">Startup Schemes</th><tr class="headerGrid"><th>S.No</th><th>Scheme Name</th><!--                    <th>EV Policy Document (PDF)</th>--><th>Apply For Scheme</th></tr></thead><tbody><tr><td>1</td><td>REIMBURSEMENT FOR CLOUD STORAGE SCHEME</td><td><div class="col-md-6"><form target="my_iframe" action="https://startupharyana.gov.in/invest-haryana/apply-scheme/cloud-storage-reimbursement" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>2</td><td>NET SGST REIMBURSEMENT SCHEME</td><td><div class="col-md-6"><form target="my_iframe" action="https://startupharyana.gov.in/invest-haryana/apply-scheme/sgst-reimbursement" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>3</td><td>PATENT COST REIMBURSEMENT SCHEME</td><td><div class="col-md-6"><form target="my_iframe" action="https://startupharyana.gov.in/invest-haryana/apply-scheme/patent-cost" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>4</td><td>LEASE RENTAL SUBSIDY SCHEME</td><td><div class="col-md-6"><form target="my_iframe" action="https://startupharyana.gov.in/invest-haryana/apply-scheme/reimbursement-lease-rental" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>5</td><td>ASSISTANCE IN ACCELERATION PROGRAMS SCHEME \u2013 IN-PRINCIPAL APPROVAL</td><td><div class="col-md-6"><form target="my_iframe" action="https://startupharyana.gov.in/invest-haryana/apply-scheme/acceleration-program" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>6</td><td>ASSISTANCE IN ACCELERATION PROGRAMS SCHEME \u2013 CLAIMING ASSISTANCE</td><td><div class="col-md-6"><form target="my_iframe" action="https://startupharyana.gov.in/invest-haryana/apply-scheme/acceleration-program-incentive" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>7</td><td>SEED FUND FOR STARTUPS - 1ST TRANCHE</td><td><div class="col-md-6"><form target="my_iframe" action="https://startupharyana.gov.in/invest-haryana/apply-scheme/seed-fund-startup" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>8</td><td>SEED FUND FOR STARTUPS \u2013 2ND TRANCHE</td><td><div class="col-md-6"><form target="my_iframe" action="https://startupharyana.gov.in/invest-haryana/apply-scheme/seed-fund-startup-tranche2" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>9</td><td>SEED FUND FOR STARTUPS \u2013 3RD TRANCHE</td><td><div class="col-md-6"><form target="my_iframe" id="myForm" action="https://startupharyana.gov.in/invest-haryana/apply-scheme/seed-fund-startup-tranche3" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr></tbody></table></div><div class="row"><table class="table table-striped table-hover"><thead><th colspan="3" style="text-align:center; background-color:#A0233D; font-size:16px">Incubator Schemes</th><tr class="headerGrid"><th>S.No</th><th>Scheme Name</th><!--                    <th>EV Policy Document (PDF)</th>--><th>Apply For Scheme</th></tr></thead><tbody><tr><td>1</td><td>REIMBURSEMENT ON RENTAL CHARGE SCHEME</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/rental_charge" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>2</td><td>ELECTRICITY DUTY REIMBURSEMENT SCHEME</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/electricity_duty_reimbursement" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>3</td><td>STAMP DUTY & REGISTRATION REIMBURSEMENT SCHEME</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/stamp_duty_reimbursement" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>4</td><td>MENTORING ASSISTANCE SCHEME (IN-PRINCIPLE APPROVAL)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/monitoring_programs" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>5</td><td>MENTORING ASSISTANCE SCHEME (POST COMPLETION OF MENTORING PROGRAM)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/mentoring_program_incentive" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>6</td><td>ASSISTANCE FOR FAIR/EXHIBITION (IN-PRINCIPLE APPROVAL)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/fair_exhibition" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>7</td><td>ASSISTANCE FOR FAIR/EXHIBITION (POST COMPLETION)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/fair_exhibition_incentive" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>8</td><td>STARTUP COMPETITION ASSISTANCE SCHEME (IN-PRINCIPLE APPROVAL)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/startup_competition_assistance" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>9</td><td>STARTUP COMPETITION ASSISTANCE SCHEME (POST COMPLETION)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/startup_competition_incentive" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>10</td><td>CAPITAL SUBSIDY SCHEME</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/capital_subsidy" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>11</td><td>CAPITAL SUBSIDY SCHEME (TRANCHE 1)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/capital_subsidy_tranche1" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>12</td><td>CAPITAL SUBSIDY SCHEME (TRANCHE 2)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/capital_subsidy_tranche2" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>13</td><td>CAPITAL SUBSIDY SCHEME (TRANCHE 3)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/capital_subsidy_tranche3" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>14</td><td>Mobile Application Development Centre Scheme (in-principle Approval)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/mobile_development_centre" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>15</td><td>Mobile Application Development Centre Scheme (Tranche 1)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/mobile_development_centre_tranche1" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>16</td><td>Mobile Application Development Centre Scheme (Tranche 2)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/mobile_development_centre_tranche2" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>17</td><td>Mobile Application Development Centre Scheme (Tranche 3)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/mobile_development_centre_tranche3" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>18</td><td>Mobile Application Development Centre Scheme (Application for availing the Yearly Support)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/mobile_development_centre_recurring" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>19</td><td>Assistance for New Startup Warehouse/ Innovation Campus Scheme (in- principle Approval)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/startup_warehouse_innovation" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>20</td><td>Assistance for New Startup Warehouse/ Innovation Campus Scheme (Tranche 1)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/startup_warehouse_innovation_tranche1" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>21</td><td>Assistance for New Startup Warehouse/ Innovation Campus Scheme (Tranche 2)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/startup_warehouse_innovation_tranche2" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>22</td><td>Assistance for New Startup Warehouse/ Innovation Campus Scheme (Tranche 3)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/startup_warehouse_innovation_tranche3" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>23</td><td>Assistance for New Startup Warehouse/ Innovation Campus Scheme (Application for availing the Recurring Expense)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/startup_warehouse_innovation_recurring" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>24</td><td>Assistance for establishing New or Upgrading Incubation Centres in Government Universities & Institutions Scheme (in-principle Approval)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/incubation_govt_institute" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>25</td><td>Assistance for establishing New or Upgrading Incubation Centres in Government Universities & Institutions Scheme (Tranche 1)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/incubation_govt_institute_tranche1" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>26</td><td>Assistance for establishing New or Upgrading Incubation Centres in Government Universities & Institutions Scheme (Tranche 2)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-\nscheme/incubation_govt_institute_tranche2" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>27</td><td>Assistance for establishing New or Upgrading Incubation Centres in Government Universities & Institutions Scheme (Tranche 3)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/incubation_govt_institute_tranche3" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr><tr><td>28</td><td>Assistance for establishing New or Upgrading Incubation Centres in Government Universities & Institutions Scheme (Application for availing the Recurring Expense)</td><td><div class="col-md-6"><form target="my_iframe" action="https://stagingstartupharyana.trigma.in/invest-haryana/apply-scheme/incubation_govt_institute_recurring" method="GET"><input type="hidden" name="email" value="{{vm.userdetails.useremail}}"> <input type="hidden" name="name" value="{{vm.userdetails.username}}"> <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Apply Now"></form></div></td></tr></tbody></table></div></div></div><div id="modal-full" class="uk-modal-full" uk-modal esc-close="false" bg-close="false"><div class="uk-modal-dialog"><button class="uk-modal-close-full uk-close-large" type="button" uk-close></button><div class="uk-grid-collapse uk-flex-middle" uk-grid><section><iframe name="my_iframe" id="my_iframe" style="width: 500vw; height: 100vh" frameborder="0" marginheight="0" marginwidth="0"></iframe></section></div></div></div>');
$templateCache.put('app/supplyDisposal/supplyDisposal.html','<div ng-cloak><!--    <div class="container-fluid">--><!--        <div class="row">--><!--            <div class="col-md-12">--><!--                <ul class="nav nav-pills">--><!--                    &lt;!&ndash;<li class="active"><a ui-sref="totaldeptservicesdetailyearly({status:\'Required\'})" ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_DESK_OFFICER\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')">Total Required Services<span class="badge">{{vm.totalrequiredservices}}</span></a></li>&ndash;&gt;--><!--                    <li class="active"><a>Total Applied Services<span class="badge">{{vm.supplyAndDisposals.length}}</span></a></li>--><!--                    <li class="active"><a>Total Cleared Services<span class="badge">{{2}}</span></a></li>--><!--                    <li class="active"><a>Total Rejected Services<span class="badge">{{2}}</span></a></li>--><!--                </ul>--><!--            </div>--><!--        </div>--><!--    </div>--><!--    <div class="container">--><!--        <div class="row">--><!--            <table class="table table-striped table-hover ">--><!--                <thead>--><!--                <tr class="headerGrid">--><!--                    <th>Application Number</th>--><!--                    &lt;!&ndash;<th>Investor Name</th>&ndash;&gt;--><!--                    <th>Name</th>--><!--                    <th>Applied Date</th>--><!--                    <th>Rejected Date</th>--><!--                    <th>Cleared Date</th>--><!--                    <th>Last Action</th>--><!--                    <th>Last Action By</th>--><!--                    <th>Applied By</th>--><!--                    <th>Status</th>--><!--                    <th></th>--><!--                </tr>--><!--                </thead>--><!--                <tbody>--><!--                <tr ng-repeat="supplyAndDisposal in vm.supplyAndDisposals">--><!--                    <td >{{supplyAndDisposal.applicationNumber}}</td>--><!--                    &lt;!&ndash;<td >{{prdtl.investorName}}</td>&ndash;&gt;--><!--                    <td >{{supplyAndDisposal.name}}</td>--><!--                    <td >{{supplyAndDisposal.appliedDate | date:\'medium\'}}</td>--><!--                    <td >{{supplyAndDisposal.rejectedDate | date:\'medium\'}}</td>--><!--                    <td >{{supplyAndDisposal.clearedDate | date:\'medium\'}}</td>--><!--                    <td>{{supplyAndDisposal.lastAction}}</td>--><!--                    <td>{{supplyAndDisposal.lastActionBy}}</td>--><!--                    <td>{{supplyAndDisposal.appliedBy}}</td>--><!--                    <td>{{supplyAndDisposal.status}}</td>--><!--                    <td></td>--><!--&lt;!&ndash;                    <td class="action verticalalign">&ndash;&gt;--><!--&lt;!&ndash;                        <a ng-show="!vm.account.authorities.includes(\'ROLE_DEPT_CHANGE\')" ui-sref="projectdetailjist({projectid:vm.project.projectid})" class="btn btn-primary">Details</a>&ndash;&gt;--><!--&lt;!&ndash;                        <a ng-show="vm.account.authorities.includes(\'ROLE_DEPT_CHANGE\')" ng-if="vm.project.caftype === \'Tower\'" ui-sref="projectdetailjist({projectid:vm.project.projectid})" class="btn btn-primary">Details</a>&ndash;&gt;--><!--&lt;!&ndash;                    </td>&ndash;&gt;--><!--                </tr>--><!--                </tbody>--><!--            </table>--><!--        </div>--><!--        &lt;!&ndash;<div ng-show="!vm.showtable">&ndash;&gt;--><!--            &lt;!&ndash;No Projects Right Now.&ndash;&gt;--><!--        &lt;!&ndash;</div>&ndash;&gt;--><!--    </div>--></div><section class="ls section_padding_top_25 section_padding_bottom_75 columns_padding_10" id="user_section"><div class="container"><div><div class="row"><table class="table table_template table-striped"><thead><tr class="headerGrid row gradient_bg_color2"><th class="col-md-2">Service Name</th><th class="col-md-2 text-center">Applied</th><!--                        <th class="col-md-2 text-center">Pending</th>--><th class="col-md-2 text-center">Rejected</th><th class="col-md-2 text-center">Cleared</th><th class="col-md-4 text-center">Mean / Median (in days)</th></tr></thead><tbody><tr class="row"><td class="col-md-2">Supply And Disposal</td><td class="col-md-1 text-center"><div class="col-md-12"><span>{{vm.supplyAndDisposals.applied}}</span><!--                                <a ui-sref="supplyAndDisposaldashboard({status:\'Applied\'})"><span>{{vm.supplyAndDisposals.applied}}</span></a>--></div></td><td class="col-md-1 text-center"><div class="col-md-12"><span>{{vm.supplyAndDisposals.rejected}}</span><!--                                <a ui-sref="supplyAndDisposaldashboard({status:\'Rejected\'})"><span>{{vm.supplyAndDisposals.rejected}}</span></a>--></div></td><td class="col-md-1 text-center"><div class="col-md-12"><span>{{vm.supplyAndDisposals.cleared}}</span><!--                                <a ui-sref="supplyAndDisposaldashboard({status:\'Cleared\'})"><span>{{vm.supplyAndDisposals.cleared}}</span></a>--></div></td><td class="col-md-1 text-center"><div class="col-md-12"><span>{{vm.supplyAndDisposals.pending_45days}}/{{vm.supplyAndDisposals.pending_30days}}</span><!--<a ui-sref="supplyAndDisposaldashboard({status:\'Cleared\'})"><span>{{vm.supplyAndDisposals.cleared}}</span></a>--></div></td></tr></tbody></table></div></div></div></section><br><br><br>');
$templateCache.put('app/supplyDisposal/supplyDisposalView.html','<form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><!--                    <div class="col-md-9">--><!--                        <h4 class="modal-title text-warning bold" id="myBlockLabel">{{vm.servicename}}</h4>--><!--                    </div>--><!--                    <div class="col-md-2">--><!--                        <button ng-show="vm.show" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm" >Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button>--><!--                    </div>--><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div><div ng-if="vm.spiner" class="loader"></div><div class="row"><div class="text-center"><h5 class="modal-title" ng-show="vm.status==\'Applied\'"><b>All Services</b></h5><h5 class="modal-title" ng-show="vm.status==\'Pending\'"><b>All Pending service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Cleared\'"><b>All Cleared service</b></h5><h5 class="modal-title" ng-show="vm.status==\'Rejected\'"><b>All Rejected Service</b></h5></div></div></div><div class="panel-body"><!--<h5 class="pull-left" ng-show="vm.status==\'Cleared\'">Average Clearance Time :<strong >{{" "}}{{vm.averageTime.toString()==\'NaN\'?"NA": vm.averageTime + \' days\'}}</strong> </h5>--><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>Application Number</span></th><th><span>Service Name</span></th><th><span>Applied Date</span></th><th><span>Rejected Date</span></th><th><span>Cleared Date</span></th><th><span>Applied By</span></th><th><span>Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="supplyAndDisposal in vm.dashboardcafs"><td>{{$index+1}}</td><td>{{supplyAndDisposal.applicationNumber}}</td><!--<td >{{prdtl.investorName}}</td>--><td>{{supplyAndDisposal.name}}</td><td>{{supplyAndDisposal.appliedDate | date:\'medium\'}}</td><td>{{supplyAndDisposal.rejectedDate | date:\'medium\'}}</td><td>{{supplyAndDisposal.clearedDate | date:\'medium\'}}</td><td>{{supplyAndDisposal.appliedBy}}</td><td>{{supplyAndDisposal.status}}</td><td></td></tr></tbody></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form><style>.loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 40px;\n        height: 40px;\n        animation: spin 2s linear infinite;\n    }\n\n    @keyframes spin {\n        0% { transform: rotate(0deg); }\n        100% { transform: rotate(360deg); }\n    }</style>');
$templateCache.put('app/surveyForm/SurveyFormForTowerOfficer.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><div class="container"><form ng-submit="vm.saveProject(\'Final\')" name="myform"><div class="panel-group" id="accordion"><div class="panel panel-default"><div><div class="panel-body"><div class="form-horizontal"><fieldset><legend><span data-translate="global.viewcaf.Survey Form">Survey Form</span></legend><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.District">District</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="district" ng-model="vm.projectServiceDetail.districtName" readonly="readonly"></div><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.Land Type">Land Type</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-model="vm.projectServiceDetail.landType" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label" data-translate="global.viewcaf.Area Type">Area Type<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-model="vm.projectServiceDetail.areaType" readonly="readonly"></div><label class="col-lg-2 control-label" data-translate="global.viewcaf.Department Name">Department Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Department Name" ng-model="vm.projectServiceDetail.departmentName" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Applicant Name">Applicant Name</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-value="vm.projectServiceDetail.applicantName" readonly="readonly"></div><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.Business Entity">Business Entity</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Business Entity" ng-value="vm.projectServiceDetail.businessEntity" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Mobile Number">Mobile Number</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-value="vm.projectServiceDetail.mobileNumber" readonly="readonly"></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Email">Email</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-value="vm.projectServiceDetail.email" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Applicant Address">Applicant Address</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-value="vm.projectServiceDetail.address" readonly="readonly"></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Pin Code">Pin Code</span><span style="color:red">*</span></label><div class="col-lg-3"><!-- Pin Code input (add ng-model) --> <input type="text" class="form-control" ng-model="vm.projectServiceDetail.pincode" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span>Latitude</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Enter Latitude" ng-value="vm.projectServiceDetail.latitude" readonly="readonly"></div><label class="col-lg-2 control-label"><span>Longitude</span><span style="color:red">*</span></label><div class="col-lg-3"><!-- Pin Code input (add ng-model) --> <input type="text" class="form-control" placeholder="Enter Longitude" ng-value="vm.projectServiceDetail.longitude" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.Service Name">Service Name</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-value="vm.projectServiceDetail.serviceName" readonly="readonly"></div></div><!-- Continue from the last form-group --><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.ActionType">Action Type</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" ng-model="vm.projectServiceDetail.actionType" required><option value="" disabled="disabled" selected="selected">Select Action</option><option value="Cleared">Cleared</option><option value="Rejected">Rejected</option></select></div><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.Comment">Comment</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Enter comment" ng-model="vm.projectServiceDetail.comment" required></div></div><!-- Submit Button --><div class="form-group"><div class="col-lg-12 text-center"><button type="submit" class="btn btn-success" ng-disabled="myform.$invalid || vm.isSaving"><span data-translate="global.save">Submit</span></button></div></div></fieldset></div></div></div></div></div></form></div>');
$templateCache.put('app/surveyForm/commentForSurvey.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><!-- Container for the modal content --><div class="container"><form name="editFormClear" role="form" ng-submit="vm.clearService()" ng-show="vm.status===\'clearance\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Service Clearance</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" id="textArea" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormClear.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormClear.$invalid"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form><!--modal for rejection--><form name="editFormReject" role="form" ng-submit="vm.rejectService()" ng-show="vm.status===\'reject\'"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="">Reject Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="">Description</label><textarea class="form-control" rows="3" name="description" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" ng-model="vm.comments" required></textarea><div ng-show="editFormReject.description.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="">Cancel</span></button> <button type="submit" class="btn btn-primary" ng-disabled="editFormReject.$invalid"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="">Save</span></button></div></form></div>');
$templateCache.put('app/surveyForm/surveyForm.html','<div ng-controller="SurveyFormController as vm"><form name="vm.myForm" ng-submit="vm.submitForm()"><label>ID:</label><input type="text" ng-model="vm.formData.id" placeholder="UUID"><br><label>User Login:</label><input type="text" ng-model="vm.formData.userLogin"><br><label>Form Fill Date:</label><input type="datetime-local" ng-model="vm.formData.formFillDate"><br><label>Status:</label><input type="text" ng-model="vm.formData.status"><br><label>Approve:</label><input type="checkbox" ng-model="vm.formData.approve"><br><label>Approved By:</label><input type="text" ng-model="vm.formData.approvedBy"><br><label>Remark:</label><textarea ng-model="vm.formData.remark"></textarea><br><label>Approval Type:</label><input type="text" ng-model="vm.formData.approvalType"><br><label>Approval Date:</label><input type="datetime-local" ng-model="vm.formData.approvalDate"><br><label>Project Service Detail ID:</label><input type="text" ng-model="vm.formData.projectServiceDetailId"><br><label>Rejected:</label><input type="checkbox" ng-model="vm.formData.rejected"><br><label>Rejection Date:</label><input type="datetime-local" ng-model="vm.formData.rejectionDate"><br><label>Project ID:</label><input type="text" ng-model="vm.formData.projectId"><br><label>Service ID:</label><input type="text" ng-model="vm.formData.serviceId"><br><button type="submit">Submit</button><div ng-if="vm.success" style="color: green">Form submitted successfully!</div></form></div>');
$templateCache.put('app/surveyForm/surveyFormDashboard.html','<form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div ng-if="vm.spiner" class="loader"></div><div class="panel-body table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th>#</th><th>Service Name</th><th>Business Entity</th><th>District</th><th>Department</th><th>Investor Name</th><th>Investor Contact</th><th>Investor Email</th><th>Latitude</th><th>Longitude</th><th>Actions</th><!-- New column --></tr></thead><tbody><tr ng-repeat="caf in vm.surveyFormsList"><td>{{$index + 1}}</td><td>{{caf.serviceName}}</td><td>{{caf.businessEntity}}</td><td>{{caf.districtName}}</td><td>{{caf.departmentName}}</td><td>{{caf.applicantName}}</td><td>{{caf.mobileNumber}}</td><td>{{caf.email}}</td><td>{{caf.latitude}}</td><td>{{caf.longitude}}</td><td><!--                            <button type="button" class="btn btn-info btn-sm" ng-click="vm.viewSurveyForm(caf.id)">View Survey Form</button>--> <button type="submit" ui-sref="showsurveyform({projectserviceid:caf.id})" ui-sref-opts="{reload: true}" ng-disabled="vm.isSaving" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.View Survey Form">View Survey Form</span></button><!--                            <button type="button" class="btn btn-success btn-sm" ui-sref="showcomment({projectserviceid:caf.id})">Approve Survey Form</button>--> <button type="button" class="btn btn-info btn-sm" ng-show="caf.status===\'Pending\'" ui-sref="actionForSurvey({action:\'clearance\',projectserviceid:caf.id})">Clearance</button> <button type="button" class="btn btn-info btn-sm" ng-show="caf.status===\'Pending\'" ui-sref="actionForSurvey({action:\'reject\',projectserviceid:caf.id})">Reject</button><p ng-show="caf.status === \'Cleared\' || caf.status === \'Rejected\'"><strong>Survey Form {{ caf.status }}</strong></p></td></tr></tbody></table></div></div></div></form>');
$templateCache.put('app/surveyForm/surveyFormFilledView.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><div class="container" ng-if="vm.showSurveyForm"><button type="button" class="btn btn-danger pull-right" ng-click="vm.closeForm()">Close</button><form ng-submit="vm.saveProject(\'Final\')" name="myform"><div class="panel-group" id="accordion"><div class="panel panel-default"><div><div class="panel-body"><div class="form-horizontal"><fieldset><legend><span data-translate="global.viewcaf.Survey Form">Survey Form</span></legend><div class="form-group"><label class="col-lg-3 control-label">Survey Number : {{vm.projectServiceDetail.surveyNumber}}</label><label class="col-lg-5 control-label">Survey Date : {{vm.projectServiceDetail.formFillDate | date:\'dd-MM-yyyy\' }}</label></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.District">District</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="district" ng-model="vm.projectServiceDetail.districtName" readonly="readonly"></div><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.Land Type">Land Type</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-model="vm.projectServiceDetail.landType" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label" data-translate="global.viewcaf.Area Type">Area Type<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-model="vm.projectServiceDetail.areaType" readonly="readonly"></div><label class="col-lg-2 control-label" data-translate="global.viewcaf.Department Name">Department Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Department Name" ng-model="vm.projectServiceDetail.departmentName" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Applicant Name">Applicant Name</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-value="vm.projectServiceDetail.applicantName" readonly="readonly"></div><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.Business Entity">Business Entity</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Business Entity" ng-value="vm.projectServiceDetail.businessEntity" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Mobile Number">Mobile Number</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-value="vm.projectServiceDetail.mobileNumber" readonly="readonly"></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Email">Email</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-value="vm.projectServiceDetail.email" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Applicant Address">Applicant Address</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-value="vm.projectServiceDetail.address" readonly="readonly"></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Pin Code">Pin Code</span><span style="color:red">*</span></label><div class="col-lg-3"><!-- Pin Code input (add ng-model) --> <input type="text" class="form-control" ng-model="vm.projectServiceDetail.pincode" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span>Latitude</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Enter Latitude" ng-value="vm.projectServiceDetail.latitude" readonly="readonly"></div><label class="col-lg-2 control-label"><span>Longitude</span><span style="color:red">*</span></label><div class="col-lg-3"><!-- Pin Code input (add ng-model) --> <input type="text" class="form-control" placeholder="Enter Longitude" ng-value="vm.projectServiceDetail.longitude" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.Service Name">Service Name</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" ng-value="vm.projectServiceDetail.serviceName" readonly="readonly"></div></div></fieldset></div></div></div></div></div></form></div>');
$templateCache.put('app/surveyForm/surveyFormForDc.html','<form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div ng-if="vm.spiner" class="loader"></div><div class="panel-body table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th>#</th><th>Service Name</th><th>Business Entity</th><th>District</th><th>Department</th><th>Investor Name</th><th>Investor Contact</th><th>Investor Email</th><th>Latitude</th><th>Longitude</th><th>Actions</th><!-- New column --></tr></thead><tbody><tr ng-repeat="caf in vm.surveyFormsList"><!-- \u2728 Updated line --><td>{{$index + 1}}</td><td>{{caf.serviceName}}</td><td>{{caf.businessEntity}}</td><td>{{caf.districtName}}</td><td>{{caf.departmentName}}</td><td>{{caf.applicantName}}</td><td>{{caf.mobileNumber}}</td><td>{{caf.email}}</td><td>{{caf.latitude}}</td><td>{{caf.longitude}}</td><td><button type="submit" ui-sref="showsurveyform({projectserviceid:caf.id})" ui-sref-opts="{reload: true}" ng-disabled="vm.isSaving" class="btn btn-info btn-sm"><span data-translate="global.viewcaf.View Survey Form">View Survey Form</span></button> <button type="button" class="btn btn-info btn-sm" ng-show="caf.status===\'Pending\'" ui-sref="actionForSurvey({action:\'clearance\',projectserviceid:caf.id})">Clearance</button> <button type="button" class="btn btn-info btn-sm" ng-show="caf.status===\'Pending\'" ui-sref="actionForSurvey({action:\'reject\',projectserviceid:caf.id})">Reject</button><p ng-show="caf.status === \'Cleared\' || caf.status === \'Rejected\'"><strong>Survey Form {{ caf.status }}</strong></p></td></tr></tbody></table></div></div></div></form>');
$templateCache.put('app/surveyForm/surveyFormView.html','<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/balloon-css/0.5.0/balloon.min.css"><div class="container"><form ng-submit="vm.saveProject(\'Final\')" name="myform"><div class="panel-group" id="accordion"><div class="panel panel-default"><div><div class="panel-body"><div class="form-horizontal"><fieldset><legend><span data-translate="global.viewcaf.Survey Form">Survey Form</span></legend><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.District">District</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="district" ng-model="vm.projectDetails.district" readonly="readonly"></div><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.Land Type">Land Type</span><span style="color:red">*</span></label><div class="col-lg-3"><select class="form-control" ng-model="vm.projectDetails.landusetype" ng-disabled="vm.projectDetails.landusetype"><option value="" disabled="disabled" selected="selected">Choose land type</option><option value="Government">Government</option></select></div></div><div class="form-group"><label class="col-lg-2 control-label" data-translate="global.viewcaf.Area Type">Area Type<span style="color:red">*</span></label><div class="col-lg-3"><!-- Area Type dropdown (add ng-model) --><select class="form-control" ng-model="vm.formData.areaType"><option value="" disabled="disabled" selected="selected">Choose Area Type</option><option value="Urban">Urban</option><option value="Rural">Rural</option></select></div><label class="col-lg-2 control-label" data-translate="global.viewcaf.Department Name">Department Name<span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Department Name" ng-model="vm.projectServiceDetail.departmentName" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Applicant Name">Applicant Name</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Applicant Name" ng-value="vm.projectDetails.firstname + \' \' + (vm.projectDetails.middlename || \'\') + \' \' + (vm.projectDetails.lastname || \'\')" readonly="readonly"></div><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.Business Entity">Business Entity</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Business Entity" ng-value="vm.projectDetails.businessentity" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Mobile Number">Mobile Number</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Mobile Number" ng-value="vm.projectDetails.mobilenumber" readonly="readonly"></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Email">Email</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Email" ng-value="vm.projectDetails.emailprimary" readonly="readonly"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Applicant Address">Applicant Address</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Applicant Address" ng-model="vm.formData.address"></div><label class="col-lg-2 control-label"><span data-translate="global.addcafnew.Pin Code">Pin Code</span><span style="color:red">*</span></label><div class="col-lg-3"><!-- Pin Code input (add ng-model) --> <input type="text" class="form-control" placeholder="Pin Code" ng-model="vm.formData.pincode"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span>Latitude</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Enter Latitude" ng-model="vm.formData.latitude"></div><label class="col-lg-2 control-label"><span>Longitude</span><span style="color:red">*</span></label><div class="col-lg-3"><!-- Pin Code input (add ng-model) --> <input type="text" class="form-control" placeholder="Enter Longitude" ng-model="vm.formData.longitude"></div></div><div class="form-group"><label class="col-lg-2 control-label"><span data-translate="global.viewcaf.Service Name">Service Name</span><span style="color:red">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Service Name" ng-value="vm.projectServiceDetail.serviceName" readonly="readonly"></div></div></fieldset></div></div></div></div></div><div class="form-group"><div class="col-lg-offset-2 col-lg-10"><button type="button" class="btn btn-success" ng-click="vm.submitForm()">Submit</button></div></div></form></div>');
$templateCache.put('app/tat/tat-dashboard.html','<!-- tat-dashboard.html --><div class="container"><h2>TAT Dashboard</h2><!-- \uD83D\uDD39 Filters --><div class="row"><div class="col-md-3"><label>From Date</label><input type="date" ng-model="vm.fromDate" class="form-control"></div><div class="col-md-3"><label>To Date</label><input type="date" ng-model="vm.toDate" class="form-control"></div><div class="col-md-3" style="margin-top: 25px"><button class="btn btn-primary" ng-click="vm.loadData()">Load Data</button></div><div class="col-md-3" style="margin-top: 25px"><button class="btn btn-primary" has-any-authority="ROLE_ADMIN" ng-click="vm.loadDataOptimised()">Load Data Optimised</button></div></div><br><!-- \uD83D\uDD39 Table --><table class="table table-bordered table-striped"><thead><tr><th>Sr. No</th><th>CAF PIN</th><th>Status</th><th>Pre Construction (Days)</th><th>Post Construction (Days)</th><th>Caf Creation Date</th><th>First Service Aplied on</th><th>No. of Queries</th></tr></thead><tbody><tr ng-repeat="item in vm.tatList"><!--            <td>{{item.cafpin}}</td>--><td>{{$index + 1}}</td><td><a href="" ng-click="vm.loadServiceDetails(item)">{{item.cafpin}}</a></td><td><span ng-class="{\n                        \'label label-success\': item.currentStatus === \'Close\',\n                        \'label label-danger\': item.currentStatus === \'Open\',\n                    }">{{item.currentStatus}}</span></td><!--            <td>{{item.preConstructionDays}}</td>--><td><a href="" ng-if="item.preConstructionDays > 0" ng-click="vm.loadPreServices(item)">{{item.preConstructionDays}}</a></td><!--            <td>{{item.postConstructionDays}}</td>--><td><a href="" ng-if="item.postConstructionDays > 0" ng-click="vm.loadPostServices(item)">{{item.postConstructionDays}}</a></td><td>{{item.cafCreationDate | date:\'dd-MM-yyyy\'}}</td><td>{{item.firstServiceAppliedOn | date:\'dd-MM-yyyy\'}}</td><!----><td ng-mouseenter="vm.loadQueries(item)" ng-mouseleave="vm.hideQueries(item)"><!-- \uD83D\uDD39 Default View --> <span ng-if="!item.showQueries"><span ng-if="!item.queriesLoaded"><span class="label label-default">Load</span> </span><span ng-if="item.queriesLoaded">{{item.queryCount}} </span></span><!-- \uD83D\uDD39 Hover View --><div ng-if="item.showQueries"><span ng-if="item.loading">Loading...</span> <span ng-if="!item.loading" class="label label-info">Queries: {{item.queryCount}}</span></div></td></tr></tbody></table></div><!-- \uD83D\uDD25 PRE SERVICES MODAL --><div id="preServiceModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Pre Establishment Services (CAF: {{vm.selectedCafpin}})</h4></div><div class="modal-body"><table class="table table-bordered"><thead><tr><th>Sr. No</th><th>Service Name</th><th>Department name</th><th>Time Taken(In days)</th><th>Status</th></tr></thead><tbody><tr ng-repeat="s in vm.preServiceList"><td>{{$index + 1}}</td><td>{{s.serviceName}}</td><td>{{s.departmentName}}</td><td>{{s.days}}</td><td>{{s.status}}</td></tr><tr ng-if="vm.preServiceList.length == 0"><td colspan="2" class="text-center">No Data Found</td></tr></tbody></table></div></div></div></div><!-- \uD83D\uDD25 Post SERVICES MODAL --><div id="postServiceModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Post Establishment Services (CAF: {{vm.selectedCafpin}})</h4></div><div class="modal-body"><table class="table table-bordered"><thead><tr><th>Sr. No</th><th>Service Name</th><th>Department name</th><th>Time Taken(In days)</th><th>Status</th></tr></thead><tbody><tr ng-repeat="s in vm.postServiceList"><td>{{$index + 1}}</td><td>{{s.serviceName}}</td><td>{{s.departmentName}}</td><td>{{s.days}}</td><td>{{s.status}}</td></tr><tr ng-if="vm.postServiceList.length == 0"><td colspan="2" class="text-center">No Data Found</td></tr></tbody></table></div></div></div></div><!-- \uD83D\uDD25 SERVICE DETAILS MODAL --><div class="modal fade" id="serviceDetailsModal" tabindex="-1"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4>Service Details (CAF: {{vm.selectedCafpin}})</h4></div><div class="modal-body"><table class="table table-bordered"><thead><tr><th>Sr. No</th><th>Service Name</th><th>Approval Stage</th><th>Department</th><th>Days</th><th>Status</th><th>Queries</th></tr></thead><tbody><tr ng-repeat="s in vm.serviceDetailsList"><td>{{$index + 1}}</td><td>{{s.serviceName}}</td><td>{{s.level}}</td><td>{{s.departmentName}}</td><td>{{s.days}}</td><td>{{s.status}}</td><!--                        <td>{{s.queryCount}}</td>--><td><a href="" ng-if="s.queryCount > 0" ng-click="vm.loadQueryDetails(s)">{{s.queryCount}}</a></td></tr></tbody></table><div ng-if="vm.loadingDetails">Loading...</div></div></div></div></div><!-- \uD83D\uDD25 QUERY DETAILS MODAL --><div class="modal fade" id="queryDetailsModal" tabindex="-1"><div class="modal-dialog modal-lg"><div class="modal-content"><!-- HEADER --><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4>Queries (CAF: {{vm.selectedCafpin}})</h4><h5>Service Name: {{vm.selectedServiceName}} |</h5><div class="row text-center" style="margin-top:10px"><div class="col-md-6"><span class="label label-success" style="font-size:14px; padding:8px 15px">Query Raised By Applicant: {{vm.applicantCount}}</span></div><div class="col-md-6"><span class="label label-danger" style="font-size:14px; padding:8px 15px">Query Raised By Department: {{vm.departmentCount}}</span></div></div></div><!-- BODY --><div class="modal-body"><div ng-if="vm.loadingQueries"><h4>Loading...</h4></div><table class="table table-bordered" ng-if="!vm.loadingQueries"><thead><tr><th>Sr. No</th><th>Query Submitted On</th><th>Action By</th><th>Comments</th></tr></thead><tbody><tr ng-repeat="q in vm.queryList | orderBy:\'-submittedOn\'"><td>{{$index + 1}}</td><td>{{q.submittedOn | date:\'dd-MM-yyyy HH:mm\'}}</td><td>{{q.actionBy}}</td><td style="white-space: pre-wrap">{{q.comments}}</td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/temp-tower-by-user/temp-tower-by-user.html','<div class="container-fluid"><h3>Temp Tower By User</h3><!-- only an investor (ROLE_USER) fills the application --><form name="tempTowerForm" role="form" novalidate ng-submit="vm.save()" has-any-authority="ROLE_USER"><!-- ================= Geographical Level ================= --><div class="panel panel-primary"><div class="panel-heading">Geographical Level</div><div class="panel-body"><div class="row"><!-- District list from /api/districts --><div class="col-md-6 form-group"><label class="control-label">Select District</label><select class="form-control" name="district" ng-model="vm.form.district" ng-change="vm.onDistrictChange()" ng-options="district.districtname as district.districtname for district in vm.districts | orderBy:\'districtname\'"><option value="">-- Select --</option></select></div><!-- Department list from /api/departments --><div class="col-md-6 form-group"><label class="control-label">Select Department</label><select class="form-control" name="department" ng-model="vm.form.department" ng-change="vm.onDepartmentChange()" ng-options="dept.departmentname as dept.departmentname for dept in vm.departments | orderBy:\'departmentname\'"><option value="">-- Select --</option></select></div></div><!-- Municipality list from /api/municipals, only for municipal departments --><div class="row" ng-if="vm.isMunicipalDepartment"><div class="col-md-6 form-group"><label class="control-label">Municipality</label><select class="form-control" name="municipality" ng-model="vm.form.municipality" ng-options="municipal.name as municipal.name for municipal in vm.municipals | orderBy:\'name\'"><option value="">-- Select --</option></select><p ng-show="vm.municipals.length === 0" class="text-danger" style="margin-top:5px">No municipality found for the selected district.</p></div></div></div></div><!-- ================= User Data ================= --><div class="panel panel-primary"><div class="panel-heading">User Data</div><div class="panel-body"><div class="row"><!-- Business Entity: the logged in user\'s CAFs of the selected district --><div class="col-md-6 form-group"><label class="control-label">Business Entity Name</label><select class="form-control" name="businessEntity" ng-model="vm.selectedBusinessEntity" ng-change="vm.onBusinessEntityChange()" ng-disabled="!vm.form.district" ng-options="project.businessentity for project in vm.businessEntities | orderBy:\'businessentity\'"><option value="">-- Select --</option></select><p ng-show="!vm.form.district" class="help-block" style="margin-top:5px">Please select the District first.</p><p ng-show="vm.form.district && vm.businessEntities.length === 0" class="text-danger" style="margin-top:5px">No business entity found for the selected district.</p></div><!-- Auto-populated from the selected business entity --><div class="col-md-6 form-group"><label class="control-label">Business Entity Type</label><input type="text" class="form-control" name="businessEntityType" ng-model="vm.form.businessEntityType" readonly="readonly"></div></div><div class="row"><div class="col-md-6 form-group"><label class="control-label">Pan No</label><input type="text" class="form-control" name="panNo" ng-model="vm.form.panNo" readonly="readonly"></div><div class="col-md-6 form-group"><label class="control-label">Email</label><input type="text" class="form-control" name="email" ng-model="vm.form.email" readonly="readonly"></div></div><div class="row"><div class="col-md-6 form-group"><label class="control-label">Name</label><input type="text" class="form-control" name="name" ng-model="vm.form.name"></div><div class="col-md-6 form-group"><label class="control-label">License Number</label><input type="text" class="form-control" name="licenseNumber" ng-model="vm.form.licenseNumber"></div></div><div class="row"><div class="col-md-6 form-group"><label class="control-label">License Registration Date</label><div class="input-group"><input type="text" class="form-control" name="licenseRegistrationDate" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.form.licenseRegistrationDate" is-open="vm.datePickerOpenStatus.licenseRegistrationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'licenseRegistrationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-6 form-group"><label class="control-label">License Expiry Date</label><div class="input-group"><input type="text" class="form-control" name="licenseExpiryDate" uib-datepicker-popup="{{vm.dateformat}}" ng-model="vm.form.licenseExpiryDate" is-open="vm.datePickerOpenStatus.licenseExpiryDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'licenseExpiryDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div></div><!-- ================= App Info Data ================= --><div class="panel panel-primary"><div class="panel-heading">App Info Data</div><div class="panel-body"><div class="row"><div class="col-md-6 form-group"><label class="control-label">Remarks</label><input type="text" class="form-control" name="remarks" ng-model="vm.form.remarks"></div><div class="col-md-6 form-group"><label class="control-label">Form Type</label><input type="text" class="form-control" name="formType" ng-model="vm.form.formType"></div></div><div class="row"><div class="col-md-6 form-group"><label class="control-label">Latitude</label><input type="text" class="form-control" name="latitude" ng-model="vm.form.latitude"></div><div class="col-md-6 form-group"><label class="control-label">Longitude</label><input type="text" class="form-control" name="longitude" ng-model="vm.form.longitude"></div></div></div></div><!-- ================= Workflow ================= --><div class="form-group"><button type="submit" class="btn btn-primary" ng-disabled="vm.isSaving"><span class="glyphicon glyphicon-save"></span>&nbsp;Save</button> <button type="button" class="btn btn-default" ng-click="vm.clear()"><span class="glyphicon glyphicon-remove"></span>&nbsp;Clear</button></div></form><!-- ================= Saved records ================= --><div class="panel panel-primary" ng-show="vm.records.length > 0"><div class="panel-heading">Applications</div><div class="panel-body" style="overflow-x: auto"><table class="table table-striped table-hover"><thead><tr><th>District</th><th>Department</th><th>Municipality</th><th>Business Entity</th><th>Business Entity Type</th><th>Pan No</th><th>Email</th><th>Name</th><th>License Number</th><th>License Registration Date</th><th>License Expiry Date</th><th>Remarks</th><th>Form Type</th><th>Latitude</th><th>Longitude</th><th></th></tr></thead><tbody><tr ng-repeat="record in vm.records"><td>{{record.district}}</td><td>{{record.department}}</td><td>{{record.municipality}}</td><td>{{record.businessEntity}}</td><td>{{record.businessEntityType}}</td><td>{{record.panNo}}</td><td>{{record.email}}</td><td>{{record.name}}</td><td>{{record.licenseNumber}}</td><td>{{record.licenseRegistrationDate | date:\'dd-MM-yyyy\'}}</td><td>{{record.licenseExpiryDate | date:\'dd-MM-yyyy\'}}</td><td>{{record.remarks}}</td><td>{{record.formType}}</td><td>{{record.latitude}}</td><td>{{record.longitude}}</td><td><button type="button" class="btn btn-info btn-sm" ng-click="vm.edit(record)"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" class="btn btn-danger btn-sm" ng-click="vm.remove(record)"><span class="glyphicon glyphicon-remove-sign"></span></button><!-- acknowledgement generated when the application was saved --> <a ng-if="record.filePath" ng-href="/api/downloadserviceformattachment?serverfilename={{record.filePath}}&downloadfilename={{record.filePath}}" target="_blank" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-download-alt"></span>&nbsp;Download</a></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/temporary-tower-apply/temporary-tower-apply.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Temporary Tower \u2013 Application Form</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Temporary Tower</span></li><!--            <li class="active"><span>Third Party Inspection</span></li>--></ol></div></section><br><div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Temporary Tower Application Form</h3></div><div class="panel-body"><form name="inspectionForm" class="form-horizontal" ng-submit="vm.applyTemporaryTower()" novalidate><!-- District --><div class="form-group"><label class="col-lg-3 control-label pull-left">District <span class="text-danger">*</span></label><div class="col-lg-6"><select class="form-control" ng-model="vm.selectedDistrict" ng-change="vm.loadBusinessEntities()" ng-options="d as d.districtname for d in vm.districts"><option value="">Select District</option></select></div></div><!-- Business Entity (after district) --><div class="form-group" ng-show="vm.selectedDistrict"><label class="col-lg-3 control-label pull-left">Business Entity <span class="text-danger">*</span></label><div class="col-lg-6"><select class="form-control" ng-model="vm.form.businessEntity" required><option value="">Select Entity</option><option ng-repeat="b in vm.businessEntities" value="{{b.id}}">{{b.businessentity}}</option></select></div></div><!-- Start Date --><div class="form-group"><label class="col-lg-3 control-label pull-left">Start Date <span class="text-danger">*</span></label><div class="col-lg-6"><input type="date" class="form-control" ng-model="vm.form.startDate" required></div></div><!-- End Date --><div class="form-group"><label class="col-lg-3 control-label pull-left">End Date <span class="text-danger">*</span></label><div class="col-lg-6"><input type="date" class="form-control" ng-model="vm.form.endDate" required></div></div><!-- Latitude & Longitude --><div class="form-group"><label class="col-lg-3 control-label pull-left">Location (Latitude & Longitude)<span class="text-danger">*</span></label><div class="col-lg-3"><input type="text" class="form-control" placeholder="Latitude" ng-model="vm.form.latitude" required></div><div class="col-lg-3"><input type="text" class="form-control" placeholder="Longitude" ng-model="vm.form.longitude" required></div><!--                    <div class="col-lg-6 col-lg-offset-3" style="margin-top:10px;">--><!--                        <button type="button" class="btn btn-info btn-sm" ng-click="vm.openMap()">Select From Map</button>--><!--                    </div>--></div><!-- Remark --><div class="form-group"><label class="col-lg-3 control-label pull-left">Remark</label><div class="col-lg-6"><textarea class="form-control" rows="3" ng-model="vm.form.remark"></textarea></div></div><!-- Submit --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><button type="submit" class="btn btn-warning pull-right" ng-disabled="inspectionForm.$invalid">Submit</button></div></div></form></div></div><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title">Your Submitted Temporary Tower Applications</h3></div><div class="panel-body"><table class="table table-bordered table-striped" ng-if="vm.applications.length > 0"><thead><tr><th>Temporary Tower ID</th><th>District</th><th>Business Entity</th><th>Latitude</th><th>Longitude</th><th>Start Date</th><th>End Date</th><th>Status</th><th>Applied Date</th><th>Action</th></tr></thead><tbody><tr ng-repeat="app in vm.applications"><td>{{app.temporaryTowerNumber}}</td><td>{{app.district}}</td><td>{{app.businessEntity}}</td><td>{{app.latitude}}</td><td>{{app.longitude}}</td><td>{{app.startDate | date:\'dd-MM-yyyy\'}}</td><td>{{app.endDate | date:\'dd-MM-yyyy\'}}</td><td>{{app.status}}</td><td>{{app.applieddate | date:\'dd-MM-yyyy\'}}</td><td><button ng-if="app.status==\'Pending\'" class="btn btn-primary btn-sm" ng-click="vm.openEditModal(app)">Modify Location</button></td></tr></tbody></table><div ng-if="vm.applications.length === 0"><p>No applications found.</p></div></div></div></div><div id="editTowerModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog modal-md" role="document"><div class="modal-content"><div class="modal-header"><h4 class="modal-title">Edit Temporary Tower Location</h4><button type="button" class="close" data-dismiss="modal">&times;</button></div><div class="modal-body"><form name="editForm" novalidate><!-- District --><div class="form-group"><label>District <span class="text-danger">*</span></label><select class="form-control" ng-model="vm.editData.district" ng-options="d.districtname as d.districtname for d in vm.districts" required disabled="disabled"><option value="">Select District</option></select></div><!-- Latitude --><div class="form-group"><label>Latitude</label><input type="text" class="form-control" ng-model="vm.editData.latitude" placeholder="Latitude" required></div><!-- Longitude --><div class="form-group"><label>Longitude</label><input type="text" class="form-control" ng-model="vm.editData.longitude" placeholder="Longitude" required></div></form></div><div class="modal-footer"><button class="btn btn-success" ng-click="vm.updateLocation()" ng-disabled="editForm.$invalid">Update</button> <button class="btn btn-default" data-dismiss="modal">Cancel</button></div></div></div></div>');
$templateCache.put('app/temporary-tower-apply/temporary-tower-view.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Temporary Tower Applications</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Temporary Tower</span></li><!--            <li class="active"><span>Third Party Inspection</span></li>--></ol></div></section><br><div class="container"><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title">Temporary Tower Applications</h3></div><div class="panel-body"><table class="table table-bordered table-striped" ng-if="vm.applications.length > 0"><thead><tr><th>Temporary Tower ID</th><th>District</th><th>Business Entity</th><th>Latitude</th><th>Longitude</th><th>Start Date</th><th>End Date</th><th>Status</th><th>Applied Date</th><th>Action</th></tr></thead><tbody><tr ng-repeat="app in vm.applications"><td>{{app.temporaryTowerNumber}}</td><td>{{app.district}}</td><td>{{app.businessEntity}}</td><td>{{app.latitude}}</td><td>{{app.longitude}}</td><td>{{app.startDate | date:\'dd-MM-yyyy\'}}</td><td>{{app.endDate | date:\'dd-MM-yyyy\'}}</td><td>{{app.status}}</td><td>{{app.applieddate | date:\'dd-MM-yyyy\'}}</td><td><button ng-if="app.status === \'Pending\' && vm.isDateInRange(app.startDate, app.endDate)" class="btn btn-primary btn-sm" ng-click="vm.openEditModal(app)">Confirm</button></td></tr></tbody></table><div ng-if="vm.applications.length === 0"><p>No applications found.</p></div></div></div></div><div id="editTowerModal" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog modal-md" role="document"><div class="modal-content"><div class="modal-header"><h4 class="modal-title">Confirmation</h4><button type="button" class="close" data-dismiss="modal">&times;</button></div><div class="modal-body"><p>Are you sure you want to approve this Temporary Tower?</p></div><div class="modal-footer"><button class="btn btn-success" ng-click="vm.ApproveTower()">Yes</button> <button class="btn btn-default" data-dismiss="modal">No</button></div></div></div></div>');
$templateCache.put('app/third-party-inspection/third-party-inspection.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Third Party Inspection</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li class="active"><span>Third Party Inspection</span></li></ol></div></section><br><div class="container"><div class="row"><div class="col-md-12"><table class="table table-striped table-hover" ng-switch="vm.isAuthenticated()"><thead><tr class="headerGrid"><th>S.No</th><th>Department Name</th><th>View/Download</th></tr></thead><tbody><tr><td>1</td><td>Public Health and Engineering, Haryana</td><td><a target="_blank" href="https://services.phedharyana.gov.in/frmplumberlist">View</a></td></tr><tr><td>2</td><td>Town Country & Planning, haryana</td><td><a target="_blank" href="https://tcpharyana.gov.in/WebAdmin/Tpr/TprDetails">View</a></td></tr><tr><td>3</td><td>Urban Local Bodies</td><td><a target="blank" href="https://tcpharyana.gov.in/WebAdmin/Tpr/TprDetails">View</a></td></tr><tr><td>4</td><td>Haryana State Industrial & Infrastructure Development Corporation Ltd,</td><td><a target="blank" href="https://tcpharyana.gov.in/WebAdmin/Tpr/TprDetails">View</a></td></tr><tr><td>5</td><td>Directorate of Boiler</td><td><a target="blank" href="https://haryanaindustries.gov.in/themes/backend/uploads/Uploads/List%20of%20Authorized%20Third%20Party%20Inspection%20Agencies.pdf">View</a></td></tr><tr><td>6</td><td>Labour Department</td><td><a target="blank" href="../../content/pdfs/1731917322.pdf">Download</a></td></tr><tr><td>7</td><td>Power Department</td><td><a target="blank" href="../../content/pdfs/Third Paty Power.pdf">Download</a></td></tr><br></tbody></table></div></div></div>');
$templateCache.put('app/totaldeptdashboarddetail/totaldeptdashboarddetail.html','<form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-4"><h4 class="modal-title" ng-show="vm.status==\'All\'">All CAFs</h4><h4 class="modal-title" ng-show="vm.status==\'AllEEC\'">All EEC CAFs</h4><h4 class="modal-title" ng-show="vm.status==\'AllDLCC\'">All DLCC CAFs</h4><h4 class="modal-title" ng-show="vm.status==\'AllDeactivated\'">All New CAFs</h4><h4 class="modal-title" ng-show="vm.status==\'AllNew\'">All New CAFs</h4><h4 class="modal-title" ng-show="vm.status==\'AllRenewable\'">All Renew CAFs</h4><h4 class="modal-title" ng-show="vm.status==\'AllShop\'">All Shop CAFs</h4><h4 class="modal-title" ng-show="vm.status==\'AllLandRequirement\'">All Land Requirement CAFs</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="col-md-1 pull-right"><button ng-show="vm.show" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div><div class="panel-body"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>CAF Pin (Composite Application Form)</span></th><th ng-hide="vm.status==\'AllDeactivated\' || vm.status==\'AllLandRequirement\' "><span>Department</span></th><th><span>Business Entity</span></th><th><span>District</span></th><th ng-show="vm.status==\'All\'"><span>Project Level</span></th><th><span>Proposed Employment</span></th><th><span>Proposed Investment(in crore)</span></th></tr></thead><tbody><tr ng-repeat="caf in vm.totaldeptdashboarddetail | orderBy: \'-projectlevel\'"><td>{{$index +1}}</td><td>{{caf.cafpin}}</td><td ng-hide="vm.status==\'AllDeactivated\' || vm.status==\'AllLandRequirement\'">{{caf.department}}</td><td>{{caf.businessentity}}</td><td>{{caf.district}}</td><td ng-show="vm.status==\'All\'">{{caf.projectlevel=="d" ? "DLCC" : "EEC"}}</td><td>{{caf.projectemployment}}</td><td>{{caf.projectinvestment}}</td></tr></tbody></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form><script></script>');
$templateCache.put('app/totaldeptservicesdetail/totaldeptservicesdetail.html','<style>.app-modal-window .modal-dialog {\nwidth: 90%;\n}</style><form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-10"><h4 class="modal-title" ng-show="vm.status==\'Required\'">ALL CAFs WITH REQUIRED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Pending\'">ALL CAFs WITH PENDING SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Cleared\'">ALL CAFs WITH CLEARED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Applied\'">ALL CAFs WITH APPLIED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'DeemedCleared\'">ALL CAFs WITH DEEMED CLEARED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Deactivated\'">ALL CAFs WITH DEACTIVATED SERVICES</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="col-md-1 pull-right" has-any-authority="ROLE_ADMIN, ROLE_NODAL_OFFICER, ROLE_TOWER_DC, ROLE_TOWER_MONITORING_OFFICER, ROLE_RM, ROLE_SUB_ADMIN, ROLE_DESK_OFFICER, ROLE_ACCOUNT_OFFICER, ROLE_FIELD_OFFICER, ROLE_ASSIGNRM_OFFICER, ROLE_MONITORING_OFFICER, ROLE_HEPC_MONITORING_OFFICER, ROLE_GRIEVANCE_OFFICER, ROLE_GRIEVANCE_ADMIN, ROLE_TOWER_DIO,\n                        ROLE_DEPT_CHANGE, ROLE_L1_SUPPORT, ROLE_TICKET_NODAL_OFFICER, ROLE_L2_DEPARTMENT_HEAD, ROLE_TICKET_OPERATION_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_INCENTIVES, ROLE_TICKET_ADMIN, ROLE_TICKET_HOBPAS, ROLE_DISPUTE_OFFICER, ROLE_HOME_DC, ROLE_HOME_SUPERINTENDENT, ROLE_HOME_CTM, ROLE_INCENTIVE_DISBURSEMENT_HEAD, ROLE_STATE_NODAL_OFFICER"><button ng-show="vm.show" id="download-btn" ng-click="vm.download(vm.totaldeptservicesdetail,vm.status)" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div><div class="panel-body table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><!--                        <th>#</th>--><th>CAF Pin (Composite Application Form)</th><th>Service Name</th><th>Business Entity</th><th>District</th><th>Department</th><th>Investor Name</th><th>Investor Contact</th><th>Investor Email</th><th>Project Level</th><th>Proposed Employment</th><th>Proposed Investment(in crore)</th><th ng-show="vm.status==\'Pending\'">Land Zone Use Type</th><th ng-show="vm.status==\'Pending\'">Ageing</th><th>Applied Date</th><th ng-show="vm.status==\'DeemedCleared\'">Date Of Deemed Clearance</th><th ng-show="vm.status==\'Cleared\'  || vm.status==\'Rejected\'">Completion Date</th><th>Address</th></tr></thead><tbody><tr dir-paginate="caf in vm.totaldeptservicesdetail | orderBy: \'-serviceClearedDate\'| itemsPerPage: pageSize" current-page="currentPage"><!--                        <td>{{$index +1}}</td>--><td>{{caf.cafpin}}</td><td>{{caf.servicename}}</td><td>{{caf.businessentity}}</td><td>{{caf.district}}</td><td>{{caf.departmentname}}</td><td>{{caf.investorName}}</td><td>{{caf.investorContact}}</td><td>{{caf.investorEmail}}</td><td>{{caf.projectlevel=="d" ? "DLCC" : "EEC"}}</td><td>{{caf.proposedemployement}}</td><td>{{caf.projectinvestment}}</td><td ng-show="vm.status==\'Pending\'">{{caf.landZoneUseType}}</td><td ng-show="vm.status==\'Pending\'">{{caf.aging>200 ? "NA" : caf.aging}}</td><td>{{caf.formfilleddate==null ? "NA" : caf.formfilleddate | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'DeemedCleared\'">{{caf.serviceClearedDate==null ? "NA" : caf.serviceClearedDate | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'Rejected\'">{{caf.serviceClearedDate==null ? "NA" : caf.serviceClearedDate | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'TotalCleared\'">{{caf.clearedDate | date:\'dd-MM-yyyy\'}}</td><td>{{caf.address}}</td></tr></tbody></table><!-- Pager --><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select class="form-control" ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><!--<option value="10" >10</option>--><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangeHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/tower-removal/tower-removal-apply.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Tower Removal \u2013 Application Form</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Tower Removal</span></li><!--            <li class="active"><span>Third Party Inspection</span></li>--></ol></div></section><br><div class="container"><div class="panel panel-primary"><div class="panel-heading"><h3 class="panel-title">Tower Removal Application Form</h3></div><div class="panel-body"><form name="inspectionForm" class="form-horizontal" ng-submit="vm.applyTowerRemoval()" novalidate><!-- District --><div class="form-group"><label class="col-lg-3 control-label pull-left">District <span class="text-danger">*</span></label><div class="col-lg-6"><!--                        <select class="form-control"--><!--                                ng-model="vm.selectedDistrict"--><!--                                ng-change="vm.loadBusinessEntities()"--><!--                                ng-options="d as d.districtname for d in vm.districts">--><!--                            <option value="">Select District</option>--><!--                        </select>--><select class="form-control" ng-model="vm.selectedDistrict" ng-change="vm.loadBusinessEntities()" ng-options="d as d.districtname for d in (vm.districts | orderBy:\'districtname\')"><option value="">Select District</option></select></div></div><!-- Business Entity (after district) --><div class="form-group" ng-show="vm.selectedDistrict"><label class="col-lg-3 control-label pull-left">Business Entity <span class="text-danger">*</span></label><div class="col-lg-6"><select class="form-control" ng-model="vm.form.selectedEntity" ng-change="vm.loadServices()" ng-options="b as (b.businessentity + \' (CAF: \' + b.cafpin + \')\')\n                    for b in (vm.businessEntities | orderBy:[\'businessentity\', \'-cafpin\'])" required><option value="">Select Entity</option></select></div></div><div class="form-group" ng-show="vm.services"><label class="col-lg-3 control-label pull-left">Approved Tower <span class="text-danger">*</span></label><div class="col-lg-6"><select class="form-control" ng-model="vm.form.service" required><option value="">Select Service</option><option ng-repeat="s in vm.services" ng-value="s.serviceName">{{s.serviceName}}</option></select></div></div><!-- Remark --><div class="form-group"><label class="col-lg-3 control-label pull-left">Remark</label><div class="col-lg-6"><textarea class="form-control" rows="3" ng-model="vm.form.remark"></textarea></div></div><div class="form-group"><label class="col-lg-3 control-label pull-left" data-translate="">Attachment</label><div class="col-lg-6"><input type="file" class="form-control" file-model="vm.form.file"></div><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div><!-- Submit --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><button type="submit" class="btn btn-warning pull-right" ng-disabled="inspectionForm.$invalid">Submit</button></div></div></form></div></div><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title">Your Submitted Tower Removal Applications</h3></div><div class="panel-body"><table class="table table-bordered table-striped" ng-if="vm.applications.length > 0"><thead><tr><th>District</th><th>Business Entity</th><th>Service</th><th>Status</th><th>Applied Date</th><th>Remarks</th><th>Action</th></tr></thead><tbody><tr ng-repeat="app in vm.applications"><td>{{app.district}}</td><td>{{app.businessEntity}}</td><td>{{app.serviceName}}</td><td>{{app.status}}</td><td>{{app.applieddate | date:\'dd-MM-yyyy\'}}</td><td>{{app.remark}}</td><td><!--                        <button ng-if="app.status==\'Pending\'" class="btn btn-primary btn-sm"--><!--                                ng-click="vm.openEditModal(app)">--><!--                            Edit--><!--                        </button>--> <a ng-if="app.filePath" ng-href="/api/file/{{app.filePath}}" target="_blank" class="btn btn-primary"><i class="fa fa-eye"></i> View Removal Application </a><a ng-if="app.removalPlanFilePath" ng-href="/api/file/{{app.filePath}}" target="_blank" class="btn btn-primary"><i class="fa fa-eye"></i> View Removal Plan </a><a ng-if="app.removalConfirmationFilePath" ng-href="/api/file/{{app.filePath}}" target="_blank" class="btn btn-primary"><i class="fa fa-eye"></i> View Removal Confirmation</a></td></tr></tbody></table><div ng-if="vm.applications.length === 0"><p>No applications found.</p></div></div></div></div><!--<div id="editTowerModal" class="modal fade" tabindex="-1" role="dialog">--><!--    <div class="modal-dialog modal-md" role="document">--><!--        <div class="modal-content">--><!--            <div class="modal-header">--><!--                <h4 class="modal-title">Edit Tower Removal Location</h4>--><!--                <button type="button" class="close" data-dismiss="modal">&times;</button>--><!--            </div>--><!--            <div class="modal-body">--><!--                <form name="editForm" novalidate>--><!--                    &lt;!&ndash; District &ndash;&gt;--><!--                    <div class="form-group">--><!--                        <label>District <span class="text-danger">*</span></label>--><!--                        <select class="form-control"--><!--                                ng-model="vm.editData.district"--><!--                                ng-options="d.districtname as d.districtname for d in vm.districts"--><!--                                required disabled>--><!--                            <option value="">Select District</option>--><!--                        </select>--><!--                    </div>--><!--                    &lt;!&ndash; Latitude &ndash;&gt;--><!--                    <div class="form-group">--><!--                        <label>Latitude</label>--><!--                        <input type="text"--><!--                               class="form-control"--><!--                               ng-model="vm.editData.latitude"--><!--                               placeholder="Latitude"--><!--                               required>--><!--                    </div>--><!--                    &lt;!&ndash; Longitude &ndash;&gt;--><!--                    <div class="form-group">--><!--                        <label>Longitude</label>--><!--                        <input type="text"--><!--                               class="form-control"--><!--                               ng-model="vm.editData.longitude"--><!--                               placeholder="Longitude"--><!--                               required>--><!--                    </div>--><!--                </form>--><!--            </div>--><!--            <div class="modal-footer">--><!--                <button class="btn btn-success"--><!--                        ng-click="vm.updateLocation()"--><!--                        ng-disabled="editForm.$invalid">--><!--                    Update--><!--                </button>--><!--                <button class="btn btn-default" data-dismiss="modal">--><!--                    Cancel--><!--                </button>--><!--            </div>--><!--        </div>--><!--    </div>--><!--</div>-->');
$templateCache.put('app/tower-removal/tower-removal-view.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Tower Removal Applications</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Tower Removal</span></li><!--            <li class="active"><span>Third Party Inspection</span></li>--></ol></div></section><br><div class="container"><div class="panel panel-info"><div class="panel-heading"><h3 class="panel-title">Tower Removal Applications</h3></div><div class="panel-body"><table class="table table-bordered table-striped" ng-if="vm.applications.length > 0"><thead><tr><th>District</th><th>Business Entity</th><th>Service</th><th>Status</th><th>Applied Date</th><th>Remarks</th><th>Action</th></tr></thead><tbody><tr ng-repeat="app in vm.applications"><td>{{app.district}}</td><td>{{app.businessEntity}}</td><td>{{app.serviceName}}</td><td>{{app.status}}</td><td>{{app.applieddate | date:\'dd-MM-yyyy\'}}</td><td>{{app.remark}}</td><td><a ng-if="app.filePath" ng-href="/api/file/{{app.filePath}}" target="_blank" class="btn btn-primary"><i class="fa fa-eye"></i> View Removal Application </a><a ng-if="app.removalPlanFilePath" ng-href="/api/file/{{app.filePath}}" target="_blank" class="btn btn-primary"><i class="fa fa-eye"></i> View Removal Plan </a><a ng-if="app.removalConfirmationFilePath" ng-href="/api/file/{{app.filePath}}" target="_blank" class="btn btn-primary"><i class="fa fa-eye"></i> View Removal Confirmation </a><button ng-if="app.status === vm.Status.PENDING" class="btn btn-primary btn-sm" ng-click="vm.openEditModal(app)"><i class="fa fa-upload"></i> Upload Removal Plan</button> <button ng-if="app.status === vm.Status.REMOVAL_PLAN_SUBMITTED" class="btn btn-primary btn-sm" ng-click="vm.openModalForConfirmationPlan(app)"><i class="fa fa-upload"></i> Upload Confiramtion Plan</button></td></tr></tbody></table><div ng-if="vm.applications.length === 0"><p>No applications found.</p></div></div></div></div><div id="submitPlan" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog modal-md" role="document"><div class="modal-content"><div class="modal-header"><h3 class="modal-title">Submit tower removal plan!</h3><button type="button" class="close" data-dismiss="modal">&times;</button></div><div class="modal-body"><!-- File Upload --><div class="form-group row"><label class="col-lg-4 control-label">Attachment</label><div class="col-lg-8"><input type="file" required class="form-control" file-model="vm.form.file"><p ng-show="file.maxSizeError" class="text-danger">Max file size exceeded (1 MB)</p></div></div><!-- Remark --><div class="form-group row"><label class="col-lg-4 control-label">Remark</label><div class="col-lg-8"><textarea class="form-control" rows="3" ng-model="vm.form.removalPlanRemark"></textarea></div></div></div><div class="modal-footer"><button class="btn btn-success" ng-click="vm.submitPlan()" ng-disabled="!vm.form.file">Submit</button> <button class="btn btn-default" data-dismiss="modal">Cancel</button></div></div></div></div><div id="submitConfirmationPlan" class="modal fade" tabindex="-1" role="dialog"><div class="modal-dialog modal-md" role="document"><div class="modal-content"><div class="modal-header"><h3 class="modal-title">Submit tower removal confirmation plan!</h3><button type="button" class="close" data-dismiss="modal">&times;</button></div><div class="modal-body"><!-- File Upload --><div class="form-group row"><label class="col-lg-4 control-label">Attachment</label><div class="col-lg-8"><input type="file" required class="form-control" file-model="vm.form.file"><p ng-show="file.maxSizeError" class="text-danger">Max file size exceeded (1 MB)</p></div></div><!-- Remark --><div class="form-group row"><label class="col-lg-4 control-label">Remark</label><div class="col-lg-8"><textarea class="form-control" rows="3" ng-model="vm.form.removalPlanRemark"></textarea></div></div></div><div class="modal-footer"><button class="btn btn-success" ng-click="vm.submitConfimationPlan()" ng-disabled="!vm.form.file">Submit</button> <button class="btn btn-default" data-dismiss="modal">Cancel</button></div></div></div></div>');
$templateCache.put('app/totaldeptservicesdetailyearly/newtotaldeptservicesdetailyearly.html','<style>.app-modal-window .modal-dialog {\n        width: 90%;\n    }\n\n    .loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 40px !important;\n        height: 40px;\n        animation: spin 2s linear infinite;\n    }\n\n    @keyframes spin {\n        0% {\n            transform: rotate(0deg);\n        }\n        100% {\n            transform: rotate(360deg);\n        }\n    }</style><form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-10"><h4 class="modal-title" ng-show="vm.status==\'Required\'">ALL CAFs WITH REQUIRED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Pending\'">ALL CAFs WITH PENDING SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Cleared\'">ALL CAFs WITH CLEARED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Applied\'">ALL CAFs WITH APPLIED SERVICES</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div><div class="row" align="center" has-any-authority="ROLE_ADMIN, ROLE_NODAL_OFFICER, ROLE_TOWER_DC, ROLE_TOWER_MONITORING_OFFICER, ROLE_RM, ROLE_SUB_ADMIN, ROLE_DESK_OFFICER, ROLE_ACCOUNT_OFFICER, ROLE_FIELD_OFFICER, ROLE_ASSIGNRM_OFFICER, ROLE_MONITORING_OFFICER, ROLE_HEPC_MONITORING_OFFICER, ROLE_GRIEVANCE_OFFICER, ROLE_GRIEVANCE_ADMIN, ROLE_TOWER_DIO,\n                        ROLE_DEPT_CHANGE, ROLE_L1_SUPPORT, ROLE_TICKET_NODAL_OFFICER, ROLE_L2_DEPARTMENT_HEAD, ROLE_TICKET_OPERATION_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_INCENTIVES, ROLE_TICKET_ADMIN, ROLE_TICKET_HOBPAS, ROLE_DISPUTE_OFFICER, ROLE_HOME_DC, ROLE_HOME_SUPERINTENDENT, ROLE_HOME_CTM, ROLE_INCENTIVE_DISBURSEMENT_HEAD, ROLE_STATE_NODAL_OFFICER"><div class="col-md-2"><strong class="pull-right" style="padding-right:10px"><i>From</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_fromdate" type="text" class="form-control" name="fromdate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-change="vm.selectedDate(vm.fromdate)" ng-model="vm.fromdate" is-open="vm.datePickerOpenStatus.fromdate" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><strong class="pull-right" style="padding-right:10px"><i>To</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_todate" type="text" class="form-control" name="todate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions1" ng-model="vm.todate" is-open="vm.datePickerOpenStatus.todate" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><button ng-show="vm.show" id="download-btn" ng-disabled="vm.fromdate==null || vm.todate==null" ng-click="vm.download(vm.status)" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-2"><div style="color: red"><b>*</b> Enter a max. period of 1 year</div></div><br></div><div class="row" align="center" has-any-authority="ROLE_ADMIN, ROLE_L2_IT_MANAGER"><div class="col-md-2"><input type="text" placeholder="Enter DepartmentName" ng-model="vm.departmentName"></div><div class="col-md-2"><strong class="pull-right" style="padding-right:10px"><i>From</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_fromdate-report" type="text" class="form-control" name="fromdate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-change="vm.selectedDate(vm.fromdate)" ng-model="vm.fromdate" is-open="vm.datePickerOpenStatus.fromdate" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><strong class="pull-right" style="padding-right:10px"><i>To</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_todate-report" type="text" class="form-control" name="todate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions1" ng-model="vm.todate" is-open="vm.datePickerOpenStatus.todate" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><button ng-show="vm.show" id="download-btn-report" ng-disabled="vm.fromdate==null || vm.todate==null" ng-click="vm.downloadReport(vm.status)" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-2"><div style="color: red"><b>*</b> Enter a max. period of 1 year</div></div><br></div></div><div ng-if="vm.spiner" class="loader"></div><div class="panel-body table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><!--<th>#</th>--><th>CAF Pin (Composite Application Form)</th><th>Service Name</th><!--                        <th>Business Entity</th>--><th>District</th><th>Department</th><th>Investor Name</th><th>Investor Contact</th><th>Investor Email</th><th>Project Level</th><th>Proposed Employment</th><th>Proposed Investment(in crore)</th><th ng-show="vm.status==\'Pending\'">Land Zone Use Type</th><th ng-show="vm.status==\'Pending\'">Ageing</th><th>Applied Date</th><th ng-show="vm.status==\'Cleared\'  || vm.status==\'Rejected\'">Completion Date</th><th>Address</th></tr></thead><tbody><tr dir-paginate="caf in vm.totaldeptservicesdetail.content | orderBy: \'-projectlevel\' | orderBy: \'-clearedDate\'| itemsPerPage: pageSize" total-items="vm.totaldeptservicesdetail.totalElements" current-page="currentPage"><!--<td>{{$index +1}}</td>--><td>{{caf.cafpin}}</td><td>{{caf.serviceName}}</td><!--                        <td>{{caf.businessEntity}}</td>--><td>{{caf.district}}</td><td>{{caf.departmentName}}</td><td>{{caf.investorName}}</td><td>{{caf.investorMobilenumber}}</td><td>{{caf.investorEmail}}</td><td>{{caf.projectLevel=="d" ? "DLCC" : "EEC"}}</td><td>{{caf.proposedEmployment}}</td><td>{{caf.proposedInvestment}}</td><td ng-show="vm.status==\'Pending\'">{{caf.landZoneUseType}}</td><td ng-show="vm.status==\'Pending\'">{{caf.ageing>200 ? "NA" : caf.ageing}}</td><td>{{caf.formFilledOn==null ? "NA" : caf.formFilledOn | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'Rejected\'">{{caf.clearedDate==null ? "NA" : caf.clearedDate | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'TotalCleared\'">{{caf.clearedDate | date:\'dd-MM-yyyy\'}}</td><td>{{caf.investorAddress}}</td></tr></tbody></table><!-- Pager --><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><!--                    <dir-pagination-controls on-page-change="pageChanged(newPageNumber)"></dir-pagination-controls>--><dir-pagination-controls boundary-links="true" on-page-change="pageChanged(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/totaldeptservicesdetailyearly/totaldeptservicesdetailyearly.html','<style>.app-modal-window .modal-dialog {\n        width: 90%;\n    }\n\n    .loader {\n        border: 16px solid #f3f3f3; /* Light grey */\n        border-top: 16px solid #3498db; /* Blue */\n        border-radius: 50%;\n        width: 40px !important;\n        height: 40px;\n        animation: spin 2s linear infinite;\n    }\n\n    @keyframes spin {\n        0% {\n            transform: rotate(0deg);\n        }\n        100% {\n            transform: rotate(360deg);\n        }\n    }</style><form name="myForm" class="form-horizontal" role="form"><div><div class="panel panel-primary"><div class="modal-header"><div class="row"><div class="col-md-10"><h4 class="modal-title" ng-show="vm.status==\'Required\'">ALL CAFs WITH REQUIRED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Pending\'">ALL CAFs WITH PENDING SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Cleared\'">ALL CAFs WITH CLEARED SERVICES</h4><h4 class="modal-title" ng-show="vm.status==\'Applied\'">ALL CAFs WITH APPLIED SERVICES</h4></div><div class="col-md-1 pull-right"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div></div><div class="row" align="center" has-any-authority="ROLE_ADMIN, ROLE_NODAL_OFFICER, ROLE_TOWER_DC, ROLE_TOWER_MONITORING_OFFICER, ROLE_RM, ROLE_SUB_ADMIN, ROLE_DESK_OFFICER, ROLE_ACCOUNT_OFFICER, ROLE_FIELD_OFFICER, ROLE_ASSIGNRM_OFFICER, ROLE_MONITORING_OFFICER, ROLE_HEPC_MONITORING_OFFICER, ROLE_GRIEVANCE_OFFICER, ROLE_GRIEVANCE_ADMIN, ROLE_TOWER_DIO,\n                        ROLE_DEPT_CHANGE, ROLE_L1_SUPPORT, ROLE_TICKET_NODAL_OFFICER, ROLE_L2_DEPARTMENT_HEAD, ROLE_TICKET_OPERATION_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_INCENTIVES, ROLE_TICKET_ADMIN, ROLE_TICKET_HOBPAS, ROLE_DISPUTE_OFFICER, ROLE_HOME_DC, ROLE_HOME_SUPERINTENDENT, ROLE_HOME_CTM, ROLE_INCENTIVE_DISBURSEMENT_HEAD, ROLE_STATE_NODAL_OFFICER"><div class="col-md-2"><strong class="pull-right" style="padding-right:10px"><i>From</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_fromdate" type="text" class="form-control" name="fromdate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-change="vm.selectedDate(vm.fromdate)" ng-model="vm.fromdate" is-open="vm.datePickerOpenStatus.fromdate" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><strong class="pull-right" style="padding-right:10px"><i>To</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_todate" type="text" class="form-control" name="todate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions1" ng-model="vm.todate" is-open="vm.datePickerOpenStatus.todate" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><button ng-show="vm.show" id="download-btn" ng-disabled="vm.fromdate==null || vm.todate==null" ng-click="vm.download(vm.status)" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-2"><div style="color: red"><b>*</b> Enter a max. period of 1 year</div></div><br></div><div class="row" align="center" has-any-authority="ROLE_ADMIN, ROLE_L2_IT_MANAGER"><div class="col-md-2"><input type="text" placeholder="Enter DepartmentName" ng-model="vm.departmentName"></div><div class="col-md-2"><strong class="pull-right" style="padding-right:10px"><i>From</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_fromdate-report" type="text" class="form-control" name="fromdate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions" ng-change="vm.selectedDate(vm.fromdate)" ng-model="vm.fromdate" is-open="vm.datePickerOpenStatus.fromdate" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fromdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><strong class="pull-right" style="padding-right:10px"><i>To</i></strong></div><div class="col-md-2"><div class="input-group"><input id="field_todate-report" type="text" class="form-control" name="todate" uib-datepicker-popup="dd-MM-yyyy" datepicker-options="vm.dateOptions1" ng-model="vm.todate" is-open="vm.datePickerOpenStatus.todate" readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'todate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-1"><button ng-show="vm.show" id="download-btn-report" ng-disabled="vm.fromdate==null || vm.todate==null" ng-click="vm.downloadReport(vm.status)" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-2"><div style="color: red"><b>*</b> Enter a max. period of 1 year</div></div><br></div></div><div ng-if="vm.spiner" class="loader"></div><div class="panel-body table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><!--<th>#</th>--><th>CAF Pin (Composite Application Form)</th><th>Service Name</th><!--                        <th>Business Entity</th>--><th>District</th><th>Department</th><th>Investor Name</th><th>Investor Contact</th><th>Investor Email</th><th>Project Level</th><th>Proposed Employment</th><th>Proposed Investment(in crore)</th><th ng-show="vm.status==\'Pending\'">Land Zone Use Type</th><th ng-show="vm.status==\'Pending\'">Ageing</th><th>Applied Date</th><th ng-show="vm.status==\'Cleared\'  || vm.status==\'Rejected\'">Completion Date</th><th>Address</th></tr></thead><tbody><tr dir-paginate="caf in vm.totaldeptservicesdetail.content | orderBy: \'-projectlevel\' | orderBy: \'-clearedDate\'| itemsPerPage: pageSize" total-items="vm.totaldeptservicesdetail.totalElements" current-page="currentPage"><!--<td>{{$index +1}}</td>--><td>{{caf.cafpin}}</td><td>{{caf.serviceName}}</td><!--                        <td>{{caf.businessEntity}}</td>--><td>{{caf.district}}</td><td>{{caf.departmentName}}</td><td>{{caf.investorName}}</td><td>{{caf.investorMobilenumber}}</td><td>{{caf.investorEmail}}</td><td>{{caf.projectLevel=="d" ? "DLCC" : "EEC"}}</td><td>{{caf.proposedEmployment}}</td><td>{{caf.proposedInvestment}}</td><td ng-show="vm.status==\'Pending\'">{{caf.landZoneUseType}}</td><td ng-show="vm.status==\'Pending\'">{{caf.ageing>200 ? "NA" : caf.ageing}}</td><td>{{caf.formFilledOn==null ? "NA" : caf.formFilledOn | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'Cleared\' || vm.status==\'Rejected\'">{{caf.clearedDate==null ? "NA" : caf.clearedDate | date:\'dd-MM-yyyy\'}}</td><td ng-show="vm.status==\'TotalCleared\'">{{caf.clearedDate | date:\'dd-MM-yyyy\'}}</td><td>{{caf.investorAddress}}</td></tr></tbody></table><!-- Pager --><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><!--                    <dir-pagination-controls on-page-change="pageChanged(newPageNumber)"></dir-pagination-controls>--><dir-pagination-controls boundary-links="true" on-page-change="pageChanged(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">Close</button></div></form>');
$templateCache.put('app/towerCafServices/towerCafsServices.html','<div class="container-fluid"><!--    <br/>--><!--    <h2 style="text-align: center">Tower Pending Cases</h2>--><!--    <button style="margin-bottom: 12px;margin-left: 1100px" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary" >Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button><br/>--> <button style="margin-bottom: 12px;margin-left: 1100px" id="download-btn" ng-click="vm.downloadAllData()" type="button" class="btn btn-primary">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button><br><div class="row"><div class="col-md-4 pull-left input-group" style="margin-left: 20px"><input type="text" class="form-control" ng-model="vm.cafPin" id="searchQuery" placeholder="Search CAF"> <span class="input-group-addon" ng-click="vm.getTowerCafs(vm.cafPin)">search</span></div><div class="col-md-2 pull-left"><select class="custom-select form-control" ng-model="vm.status" ng-change="vm.statusSelected()"><option value="Pending">Pending</option><option value="Rejected">Rejected</option></select></div><!--       <div class="col-md-2 pull-right">--><!--           <button style="margin-bottom: 12px;margin-left: 1100px" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary" >Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button><br/>--><!--       </div>--></div><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>Caf Pin (Composite Application Form)</span></th><th><span>District</span></th><th><span>Service Name</span></th><th><span>Status</span></th><th ng-if="vm.status == \'Rejected\'"><span>Rejected Reason</span></th><th><span>Business Entity Name</span></th><th><span>Department</span></th><th></th></tr></thead><tbody><tr dir-paginate="towercaf in vm.towerData.content |orderBy:\'-cafpin\' | itemsPerPage: pageSize" total-items="vm.towerData.totalElements" current-page="currentPage"><td>{{towercaf.cafpin}}</td><td>{{towercaf.district}}</td><td>{{towercaf.serviceName}}</td><td>{{towercaf.status == "Declined" ? "Rejected": towercaf.status}}</td><td ng-if="vm.status == \'Rejected\'">{{towercaf.rejectionReason}}</td><td>{{towercaf.businessEntity}}</td><td>{{towercaf.departmentName}}</td><td><button type="submit" ui-sref="serviceLogTower({projectserviceid:towercaf.id,projectid:towercaf.projectId,serviceid:towercaf.serviceId})" class="btn btn-info btn-sm">View Service Log</button></td></tr></tbody></table><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><!--                    <dir-pagination-controls on-page-change="pageChanged(newPageNumber)"></dir-pagination-controls>--><dir-pagination-controls boundary-links="true" on-page-change="pageChanged(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div>');
$templateCache.put('app/towerClearedServiceDocument/searchClearedTowerCAF.html','<div ng-cloak><div class="container"><div class="panel-heading"><h2 style="text-align: center;color: #0000cc">Tower Services Clearance Status By CAF PIN (Composite Application Form)</h2></div><div class="row"><div class="col-sm-4"><input type="text" ng-model="vm.CAFPIN" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Enter CAF PIN (Composite Application Form)"></div><div class="btn-group col-sm-4"><button type="submit" ng-click="vm.getProject()" class="btn btn-info">Search</button></div></div><div class="row" ng-show="vm.showtable"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><!--<th>Investor Name</th>--><th>Service Name</th><th>Status</th><th>Clearance Document</th></tr></thead><tbody><tr ng-repeat="project in vm.project | unique:\'comments\'"><td>{{project.comments}}</td><td>{{project.actionTaken}}</td><td><button class="btn btn-primary" id="myBtn" ng-click="vm.downFile(project)" ng-show="(project.fileName)" type="button">Download</button></td></tr></tbody></table></div><div ng-if="vm.noProject">No Projects Right Now.</div></div></div><br><br><br>');
$templateCache.put('app/towerInstallation/towerInstallation.html','<div class="container-fluid"><div class="row flex-container"><div class="col-md-1 filter-margin"><span class="uk-label" style="font-size: 12px">FILTER BY:</span></div><div class="col-md-2"><select class="form-control" ng-change="vm.show_type(vm.towertype)" ng-model="vm.towertype"><option value="Above">Above Ground</option><option value="Below">Below Ground</option></select></div><div class="col-md-2"><select class="form-control" ng-change="vm.show_status(vm.status)" ng-model="vm.status"><option value="N">New</option><option value="F">Forwarded</option><option has-authority="ROLE_TOWER_DC" value="FDC">Approved by Dept.</option><option value="C">Cleared</option></select></div><div class="col-md-2"><select class="form-control" ng-change="vm.show_request(vm.requesttype)" ng-model="vm.requesttype"><option value="false">New Request\'s</option><option value="true">Existing Request\'s</option></select></div></div><hr class="style1"><div ng-show="!vm.show1" class="row"><div class="col-md-12"><table class="jh-table table table-striped"><thead><tr><th><span>Name of Applicant</span></th><th><span>Name of Authorized Person</span></th><th><span>Designation of Authorized Person</span></th><th><span>Phone of Authorized Person</span></th><th><span>Email of Authorized Person</span></th><th><span>Extent</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="above_ground in vm.above_grounds"><td>{{above_ground.name_applicant}}</td><td>{{above_ground.name_auth_person}}</td><td>{{above_ground.designation_auth_person}}</td><td>{{above_ground.phone_auth_person}}</td><td>{{above_ground.email_auth_person}}</td><td>{{above_ground.extent}}</td><td><span ng-show="above_ground.status == \'Pending\'" class="uk-label uk-label-warning" style="font-size: 12px">Pending</span> <span ng-show="above_ground.status == \'Rejected\'" class="uk-label uk-label-danger" style="font-size: 12px">Rejected</span> <span ng-show="above_ground.status == \'Cleared\'" class="uk-label uk-label-default" style="font-size: 12px">Cleared</span></td><td><div class="uk-inline"><button class="uk-button uk-button-primary" type="button" style="font-size: 12px">Action</button><div uk-dropdown="pos: bottom-justify" mode="click"><ul class="uk-nav uk-dropdown-nav" style="font-size: 14px"><li><a has-authority="ROLE_TOWER_DC" ng-show="above_ground.status == \'Pending\'" ng-click="vm.action(1,above_ground,\'Above\')" uk-toggle="target: #modal5">Clear</a></li><li><a ng-click="vm.action(2,above_ground,\'Above\')" uk-toggle="target: #modal1">Comment</a></li><li><a has-authority="ROLE_TOWER_DC" ng-show="above_ground.status == \'Pending\'" ng-click="vm.action(3,above_ground,\'Above\')" uk-toggle="target: #modal1">Reject</a></li><li><a ng-click="vm.detail(1,above_ground.id)" uk-toggle="target: #modal2">View Form</a></li><li><a ng-click="vm.view_log(above_ground.id)" uk-toggle="target: #modal4">View Log</a></li><li><a ng-show="above_ground.isforwardedtodio==false" has-authority="ROLE_TOWER_DC" ng-click="vm.forward(above_ground,\'Above\',\'DC\')" uk-toggle="target: #modal6">Forward ( TO DIO )</a></li><li><a ng-show="above_ground.isforwardedtodept==false" has-authority="ROLE_TOWER_NODAL_OFFICER" ng-click="vm.forward(above_ground,\'Above\',\'DIO\')" uk-toggle="target: #modal6">Forward ( TO DEPT )</a></li><li><a ng-show="above_ground.isforwardedtodc==false" has-authority="ROLE_TOWER_DEPARTMENT" ng-click="vm.forward(above_ground,\'Above\', \'DEPT\')" uk-toggle="target: #modal6">Forward ( TO DC )</a></li></ul></div></div></td></tr></tbody></table></div></div><div ng-show="vm.show2" class="row"><div class="col-md-12"><table class="jh-table table table-striped"><thead><tr><th><span>Name of Applicant</span></th><th><span>Name of Authorized Person</span></th><th><span>Designation of Authorized Person</span></th><th><span>Phone of Authorized Person</span></th><th><span>Email of Authorized Person</span></th><th></th><th></th></tr></thead><tbody><tr ng-repeat="below_ground in vm.below_grounds" ng-hide=""><td>{{below_ground.name}}</td><td>{{below_ground.name_auth}}</td><td>{{below_ground.designation_auth}}</td><td>{{below_ground.phone_auth}}</td><td>{{below_ground.email}}</td><td><span ng-show="below_ground.status == \'Pending\'" class="uk-label uk-label-warning" style="font-size: 12px">Pending</span> <span ng-show="below_ground.status == \'Rejected\'" class="uk-label uk-label-danger" style="font-size: 12px">Rejected</span> <span ng-show="below_ground.status == \'Cleared\'" class="uk-label uk-label-default" style="font-size: 12px">Cleared</span></td><td><div class="uk-inline"><button class="uk-button uk-button-primary" type="button" style="font-size: 12px">Action</button><div uk-dropdown="pos: bottom-justify" mode="click"><ul class="uk-nav uk-dropdown-nav" style="font-size: 14px"><li><a has-authority="ROLE_TOWER_DC" ng-show="below_ground.status == \'Pending\'" ng-click="vm.action(1,below_ground,\'Below\')" uk-toggle="target: #modal5">Clear</a></li><li><a ng-click="vm.action(2,below_ground,\'Below\')" uk-toggle="target: #modal1">Comment</a></li><li><a has-authority="ROLE_TOWER_DC" ng-show="below_ground.status == \'Pending\'" ng-click="vm.action(3,below_ground,\'Below\')" uk-toggle="target: #modal1">Reject</a></li><li><a ng-click="vm.detail(2,below_ground.id)" uk-toggle="target: #modal3">View Form</a></li><li><a ng-click="vm.view_log(below_ground.id)" uk-toggle="target: #modal4">View Log</a></li><li><a ng-show="below_ground.isforwardedtodio==false" has-authority="ROLE_TOWER_DC" ng-click="vm.forward(below_ground,\'Below\',\'DC\')" uk-toggle="target: #modal6">Forward ( TO DIO )</a></li><li><a ng-show="below_ground.isforwardedtodept==false" has-authority="ROLE_TOWER_NODAL_OFFICER" ng-click="vm.forward(below_ground,\'Below\',\'DIO\')" uk-toggle="target: #modal6">Forward ( TO DEPT )</a></li><li><a ng-show="below_ground.isforwardedtodc==false" has-authority="ROLE_TOWER_DEPARTMENT" ng-click="vm.forward(below_ground,\'Below\', \'DEPT\')" uk-toggle="target: #modal6">Forward ( TO DC )</a></li></ul></div></div></td></tr></tbody></table></div></div></div><div id="modal1" uk-modal><div class="uk-modal-dialog" bg-close="false"><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><!--<h2 ng-show="(vm.comment_title== \'clear\')" class="uk-modal-title">Service Clearance . . .</h2>--><h2 ng-show="(vm.comment_title== \'comment\')" class="uk-modal-title">Comment on {{vm.name_applicant}} \'s Form . . .</h2><h2 ng-show="(vm.comment_title== \'reject\')" class="uk-modal-title">Rejecting Service . . .</h2></div><div class="uk-modal-body"><textarea ng-model="vm.tower_log.comment" class="uk-textarea" rows="5" name="comment" id="comment"></textarea></div><div class="uk-text-right uk-modal-footer"><!--<button type="button" class="uk-button uk-button-danger uk-modal-close" style="font-size: 12px">Close</button>--> <button ng-show="(vm.comment_title== \'comment\')" ng-click="vm.save(vm.applicant_id)" type="button" ng-disabled="!vm.tower_log.comment" class="uk-button uk-button-primary uk-modal-close" style="font-size: 12px">Comment</button> <button ng-show="(vm.comment_title== \'reject\')" ng-click="vm.save(vm.applicant_id)" type="button" ng-disabled="!vm.tower_log.comment" class="uk-button uk-button-primary uk-modal-close" style="font-size: 12px">Reject</button></div></div></div><div id="modal2" class="uk-modal-full" bg-close="false" uk-modal><div class="panel-body uk-modal-dialog"><button class="uk-modal-close-full uk-close-large" type="button" uk-close></button><div class="container-fluid panel-body"><div class="row"><div class="col-md-12"><div class="uk-child-width-1-3 uk-grid-match" uk-grid><div class="uk-card uk-card-hover uk-card-body"><h4><b>A. Details of the applicant licensee</b></h4><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 12px"><b>Name of Applicant</b></dt><dd><span>{{vm.above_ground.name_applicant}}</span></dd><dt style="font-size: 12px"><b>Registered Address</b></dt><dd><span>{{vm.above_ground.registered_address}}</span></dd><dt style="font-size: 12px"><b>Haryana Circle office Address</b></dt><dd><span>{{vm.above_ground.har_office_address}}</span></dd><dt style="font-size: 12px"><b>Name of the Authorized Person</b></dt><dd><span>{{vm.above_ground.name_auth_person}}</span></dd><dt style="font-size: 12px"><b>Designation of the Authorized Person</b></dt><dd><span>{{vm.above_ground.designation_auth_person}}</span></dd><dt style="font-size: 12px"><b>Phone no. of the Authorized Person</b></dt><dd><span>{{vm.above_ground.phone_auth_person}}</span></dd><dt style="font-size: 12px"><b>Email of the Authorized Person</b></dt><dd><span>{{vm.above_ground.email_auth_person}}</span></dd></dl></div><div class="uk-card uk-card-default uk-card-hover uk-card-body"><h4 class=""><b>B. The extent of land required: {{vm.above_ground.extent}}</b></h4><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 12px" ng-show="vm.above_ground.extent ==\'Installation on land\'"><b>Plot No./Khasara No.</b></dt><dt style="font-size: 12px" ng-show="vm.above_ground.extent ==\'Installation on Building (Private/Government)\'"><b>Name of building/structure</b></dt><dd><span>{{vm.above_ground.address_line_1}}</span></dd><dt style="font-size: 12px" ng-show="vm.above_ground.extent ==\'Installation on land\'"><b>Road/Street</b></dt><dt style="font-size: 12px" ng-show="vm.above_ground.extent ==\'Installation on Building (Private/Government)\'"><b>Height and stories of building</b></dt><dd><span>{{vm.above_ground.address_line_2}}</span></dd><dt style="font-size: 12px" ng-show="vm.above_ground.extent ==\'Installation on land\'"><b>Ward no. & name of colony</b></dt><dt style="font-size: 12px" ng-show="vm.above_ground.extent ==\'Installation on Building (Private/Government)\'"><b>Area of the building/structure</b></dt><dd><span>{{vm.above_ground.address_line_3}}</span></dd><dt style="font-size: 12px" ng-show="vm.above_ground.extent ==\'Installation on land\'"><b>City/Town or name of revenue village</b></dt><dt style="font-size: 12px" ng-show="vm.above_ground.extent ==\'Installation on Building (Private/Government)\'"><b>Complete address of the building/structure</b></dt><dd><span>{{vm.above_ground.address_line_4}}</span></dd><dt style="font-size: 12px"><b>Tehsil</b></dt><dd><span>{{vm.above_ground.tehsil}}</span></dd><dt style="font-size: 12px"><b>District</b></dt><dd><span>{{vm.above_ground.district}}</span></dd><dt style="font-size: 12px"><b>Exact Latitude & Longitude of Proposed Site</b></dt><dd><span>{{vm.above_ground.latitude_longitude}}</span></dd></dl></div><div class="uk-card uk-card-default uk-card-hover uk-card-body"><h4 class=""><b>C. Details of the proposed Tower</b></h4><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 12px"><b>Tower Height</b></dt><dd><span>{{vm.above_ground.tower_height}}</span></dd><dt style="font-size: 12px"><b>Tower Weight</b></dt><dd><span>{{vm.above_ground.tower_weight}}</span></dd><dt style="font-size: 12px"><b>Ground/Roof Top Tower</b></dt><dd><span>{{vm.above_ground.tower_type1}}</span></dd><dt style="font-size: 12px"><b>Pole/wall mounted</b></dt><dd><span>{{vm.above_ground.tower_type2}}</span></dd><dt style="font-size: 12px"><b>Whether proposed on an open plot/building</b></dt><dd><span>{{vm.above_ground.tower_type3}}</span></dd><dt style="font-size: 12px"><b>Number of Antenna</b></dt><dd><span>{{vm.above_ground.tower_antena_no}}</span></dd><dt style="font-size: 12px"><b>Exact Latitude & Longitude of the Tower</b></dt><dd><span>{{vm.above_ground.tower_lat_long}}</span></dd></dl></div><div class="uk-card uk-card-default uk-card-hover uk-card-body"><h4 class=""><b>D. Detail\'s of owner of land/building & Zone</b></h4><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 12px"><b>Name of Owner</b></dt><dd><span>{{vm.above_ground.owner_name}}</span></dd><dt style="font-size: 12px"><b>Address of Owner</b></dt><dd><span>{{vm.above_ground.owner_address}}</span></dd><dt style="font-size: 12px"><b>Name of the Zone under which this area is falling</b></dt><dd><span>{{vm.above_ground.zone_area}}</span></dd><dt style="font-size: 12px"><b>Details of fee and charges deposited</b></dt><dd><span>{{vm.above_ground.fee_details}}</span></dd></dl></div><div class="uk-card uk-card-default uk-card-hover uk-card-body"><h4 class=""><b>E. Other related information</b></h4><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 12px"><b>The mode of work and the time duration for execution of the work</b></dt><dd><span>{{vm.above_ground.other_info1}}</span></dd><dt style="font-size: 12px"><b>The inconvenience that is likely to be caused to the public and the specific measure to be taken to mitigate such inconvenience</b></dt><dd><span>{{vm.above_ground.other_info2}}</span></dd><dt style="font-size: 12px"><b>The measures proposed to be taken to ensure public safety during the execution of the work</b></dt><dd><span>{{vm.above_ground.other_info3}}</span></dd></dl></div><div class="uk-card uk-card-default uk-card-hover uk-card-body"><h4 class=""><b>F. Other related information</b></h4><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 12px"><b>The names and contact details of the employees of the licensee for the purpose of communication in regard to the application made</b></dt><dd><span>{{vm.above_ground.other_info4}}</span></dd><dt style="font-size: 12px"><b>Any other matter relevant, in the opinion of the licensee, connected with or relative to the work proposed to be undertaken</b></dt><dd><span>{{vm.above_ground.other_info5}}</span></dd><dt style="font-size: 12px"><b>Any other matter specified by the DoT or State Govt. or the local body</b></dt><dd><span>{{vm.above_ground.other_info6}}</span></dd></dl></div></div><div class="uk-child-width-1-1 uk-grid-match" uk-grid><h4 class="control-label"><b>G. Documents (Mandatory)</b></h4><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">A copy of the license/registration certificate granted by the Department of Telecommunication (DoT) Ministry of communication Government of India.</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.document1,\'document_1\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Location Plan (Scale 1:1000) showing the site with reference to the surrounding existing developments</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.document2,\'document_2\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">The detailed technical design and drawings of the tower/post or other aboveground infrastructure including the specification of foundation. In case the tower /post etc. is in the vicinity or adjoining to high or low tension line, then its distance from the same shall be clearly indicated in the drawings</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.document3,\'document_3\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Copy of certification of the technical design and Structural Stability/safety certificate for the building and tower/post as per sub para 10.3 of para 10 of the policy (Prescribed Format)</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.document4,\'document_4\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Time schedule (Stretch-wise) for completion of the work.</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.document5,\'document_5\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Copy of the type test certificate issued by Automotive Research Association of India (ARAI) to the manufactures of the DG sets, in case DG is to be installed</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.document6,\'document_6\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Attested copy of lease Agreement Deed/Consent Agreement Deed, signed by the applicant and the owner of the site/building</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.document7,\'document_7\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Copy of SACFA clearance/copy of SACFA application for the said location submitted to Wireless Planning & Coordination (WPC) wing of DoT with registration number as WPC acknowledgement along with undertaking that in case of any objection/rejection, licensee will take corrective actions/remove the tower.</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.document8,\'document_8\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Acknowledgement receipt issued by TERM Cell of the self-certificate submitted by Applicant in respect of mobile tower/Base Transceiver Station (BTS) establishing/ certifying that all general public areas around the tower will be within safe Electro Magnetic Radiation (EMR) exposure limit as per peak traffic measurement after the antennas starts radiating. *{Note: - It can be submitted within 30 days after radiating the tower}.</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.document9,\'document_9\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Indemnity bond to indemnify the Government/ Local Body/ Authority in the prescribed format against (i) any liability for the damage caused to the infrastructure laid by the applicant for any reasons, and (ii) claims against any accidents on account of the infrastructure laid/ facilities installed or against any claims thereafter during the period of Operation & Maintenance of such infrastructure at all times</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.document10,\'document_10\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Undertaking as per Appendix-7 (prescribed format)</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.document11,\'document_11\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><h4 class="control-label"><b>H. Documents (Optional)</b></h4><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Forest Permission</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.other_document1,\'document_12\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Fire NOC</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.other_document2,\'document_13\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Ownership document of the building/site. (Attested copy)</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.other_document3,\'document_14\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Seek the copy of No Objection Certificate (NOC) from building owners/entities having roof top rights in case of roof based tower or from land owner in case of ground based tower</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.other_document4,\'document_15\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">In case the permission is sought in the land/premises of any office of Central Government or a PSU of Central Government, the prior written consent copy of agreement from the authority having legitimate right over the land/premises shall be attached with the application.</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.above_ground.other_document5,\'document_16\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div></div></div></div></div><button type="button" class="pull-right uk-button uk-button-danger uk-modal-close" style="font-size: 12px">Close</button></div></div><div id="modal3" class="uk-modal-full" bg-close="false" uk-modal><div class="panel-body uk-modal-dialog"><button class="uk-modal-close-full uk-close-large" type="button" uk-close></button><div class="container-fluid panel-body"><div class="row"><div class="col-md-12"><div class="uk-child-width-1-3 uk-grid-match" uk-grid><div class="uk-card uk-card-hover uk-card-body"><h4><b>A. Details of the applicant licensee</b></h4><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 12px"><b>Name of Applicant</b></dt><dd><span>{{vm.below_ground.name}}</span></dd><dt style="font-size: 12px"><b>Registered Address</b></dt><dd><span>{{vm.below_ground.reg_add}}</span></dd><dt style="font-size: 12px"><b>Haryana Circle office Address</b></dt><dd><span>{{vm.below_ground.har_office_add}}</span></dd><dt style="font-size: 12px"><b>Name of the Authorized Person</b></dt><dd><span>{{vm.below_ground.name_auth}}</span></dd><dt style="font-size: 12px"><b>Designation of the Authorized Person</b></dt><dd><span>{{vm.below_ground.designation_auth}}</span></dd><dt style="font-size: 12px"><b>Phone no. of the Authorized Person</b></dt><dd><span>{{vm.below_ground.phone_auth}}</span></dd><dt style="font-size: 12px"><b>Email of the Authorized Person</b></dt><dd><span>{{vm.below_ground.email}}</span></dd></dl></div><div class="uk-card uk-card-default uk-card-hover uk-card-body"><h4><b>B. Details of the proposed work to be laid</b></h4><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 12px"><b>Length etc. of the proposed work</b></dt><dd><span>{{vm.below_ground.lenth}}</span></dd><dt style="font-size: 12px"><b>Route planned for the proposed work</b></dt><dd><span>{{vm.below_ground.route}}</span></dd><dt style="font-size: 12px"><b>Nature of the proposed work</b></dt><dd><span>{{vm.below_ground.nature}}</span></dd><dt style="font-size: 12px"><b>Methodology for execution of the proposed work</b></dt><dd><span>{{vm.below_ground.methodology}}</span></dd><dt style="font-size: 12px"><b>Location details including ward no. colony etc.</b></dt><dd><span>{{vm.below_ground.address1}}</span></dd><dt style="font-size: 12px"><b>City/Town/Village & Tehsil</b></dt><dd><span>{{vm.below_ground.address2}}</span></dd><dt style="font-size: 12px"><b>District</b></dt><dd><span>{{vm.below_ground.district}}</span></dd><dt style="font-size: 12px"><b>Zone under which this area is falling</b></dt><dd><span>{{vm.below_ground.zone}}</span></dd></dl></div><div class="uk-card uk-card-default uk-card-hover uk-card-body"><h4 class=""><b>C. Other information for proposed work</b></h4><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 12px"><b data-translate="global.menu.info1">Other Info 1</b></dt><dd><span>{{vm.below_ground.other_info1}}</span></dd><dt style="font-size: 12px"><b data-translate="global.menu.info2">Other Info 2</b></dt><dd><span>{{vm.below_ground.other_info2}}</span></dd><dt style="font-size: 12px"><b data-translate="global.menu.info3">Other Info 3</b></dt><dd><span>{{vm.below_ground.other_info3}}</span></dd><dt style="font-size: 12px"><b data-translate="global.menu.info4">Other Info 4</b></dt><dd><span>{{vm.below_ground.other_info4}}</span></dd><dt style="font-size: 12px"><b data-translate="global.menu.info5">Other Info 1</b></dt><dd><span>{{vm.below_ground.other_info5}}</span></dd></dl></div><div class="uk-card uk-card-default uk-card-hover uk-card-body"><h4 class=""><b>D. Other information for proposed work</b></h4><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 12px"><b data-translate="global.menu.info6">Other Info 2</b></dt><dd><span>{{vm.below_ground.other_info6}}</span></dd><dt style="font-size: 12px"><b data-translate="global.menu.info7">Other Info 3</b></dt><dd><span>{{vm.below_ground.other_info7}}</span></dd></dl></div><div class="uk-card uk-card-default uk-card-hover uk-card-body"><h4 class=""><b>E. Other information</b></h4><dl class="uk-description-list uk-description-list-divider"><dt style="font-size: 12px"><b>Details of fee and charges deposited</b></dt><dd><span>{{vm.below_ground.details1}}</span></dd><dt style="font-size: 12px"><b>Details of Performance Bank</b></dt><dd><span>{{vm.below_ground.details2}}</span></dd></dl></div></div><div class="uk-child-width-1-1 uk-grid-match" uk-grid><h4 class="control-label"><b>F. Documents (Mandatory)</b></h4><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">A copy of relevant license/infrastructure provider registration certificate granted by the DoT</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.below_ground.document1,\'document_1\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Detail of the location of map showing the proposed underground or over ground OFC/telegraph infrastructure including route planned, exact latitude and longitude, nature of land</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.below_ground.document2,\'document_2\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">The copy of consent of the owner of land/building where the OFC/telegraph infrastructure proposed to be laid</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.below_ground.document3,\'document_3\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Time schedule (Stretch-wise) for completion of the work</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.below_ground.document4,\'document_4\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Indemnity bond to indemnify the Government/ Local Body/ Authority in the /prescribed format against (i) any liability for the damage caused to the infrastructure laid by the applicant for any reasons, and (ii) claims against any accidents on account of the infrastructure laid/ facilities installed or against any claims thereafter during the period of Operation & Maintenance of such infrastructure at all times</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.below_ground.document5,\'document_5\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">Undertaking as per Appendix-7 (Prescribed Format)</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.below_ground.document6,\'document_6\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><br><h4 class="control-label"><b>H. Documents (Optional)</b></h4><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">For forest/protected areas, the copy of clearance from State Environment & Forest Department</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.below_ground.document7,\'document_7\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div><div class="col-md-offset-1 panel-body bordered-row row"><div class="form-group"><div class="col-md-8"><label class="control-label">The detailed technical design and drawings of the post or other above ground contrivances (in case of over ground cabling)</label></div><div class="col-md-2"><button type="button" ng-click="vm.download(vm.below_ground.document8,\'document_8\')" class="uk-button uk-button-primary" style="font-size: 14px"><span class="glyphicon glyphicon-download"></span>&nbsp;Download</button></div></div></div></div></div></div></div><button type="button" class="pull-right uk-button uk-button-danger uk-modal-close" style="font-size: 12px">Close</button></div></div><div id="modal4" uk-modal><div class="uk-modal-dialog"><button class="uk-modal-close-default" type="button" uk-close></button><div class="uk-modal-header"><h2 class="uk-modal-title">Log</h2></div><div class="uk-modal-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Action</span></th><th><span>Action By</span></th><th><span>Comment</span></th><!--<th><span>Tower Id</span></th>--><th><span>Action Date</span></th></tr></thead><tbody><tr ng-repeat="tower_log in vm.towerLog track by tower_log.id"><td>{{tower_log.action}}</td><td>{{tower_log.action_by}}</td><td>{{tower_log.comment}}</td><!--<td>{{tower_log.tower_id}}</td>--><td>{{tower_log.action_date | date:\'dd-MM-yyyy\'}}</td></tr></tbody></table></div></div><div class="uk-modal-footer uk-text-right"><button class="uk-button uk-button-danger uk-modal-close" type="button" style="font-size: 12px">Close</button></div></div></div><div id="modal5" uk-modal><div class="uk-modal-dialog"><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h2 ng-show="(vm.comment_title== \'clear\')" class="uk-modal-title">Service Clearance . . .</h2></div><div class="uk-modal-body"><textarea ng-model="vm.tower_log.comment" class="uk-textarea" rows="5" name="comment" id="clear"></textarea><br><br><div id="filediv" ng-show="(vm.comment_title== \'clear\')"><div class="row"><label class="control-label col-md-2">Clearance File 1</label><div class="col-md-5"><input type="file" class="form-control-file" name="document1" id="field_document1" file-model="vm.clearancefile1" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div></div><br><div class="row"><label class="control-label col-md-2">Clearance File 2</label><div class="col-md-5"><input type="file" class="form-control-file" name="document1" id="field_document2" file-model="vm.clearancefile2" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div></div><br><div class="row"><label class="control-label col-md-2">Clearance File 3</label><div class="col-md-5"><input type="file" class="form-control-file" name="document1" id="field_document3" file-model="vm.clearancefile3" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf" required></div></div></div></div><div class="uk-text-right uk-modal-footer"><!--<button type="button" class="uk-button uk-button-danger uk-modal-close" style="font-size: 12px">Close</button>--> <button ng-disabled="vm.disableSave() || !vm.tower_log.comment" ng-click="vm.save(vm.applicant_id)" type="button" class="uk-button uk-button-primary uk-modal-close" style="font-size: 12px">Clear</button></div></div></div><div id="modal6" uk-modal><div class="uk-modal-dialog" bg-close="false"><div class="uk-modal-header"><button class="uk-modal-close-outside" type="button" uk-close></button><h2 class="uk-modal-title">{{vm.comment_title}}</h2></div><div class="uk-modal-body"><textarea ng-model="vm.tower_log.comment" class="uk-textarea" rows="5" name="comment"></textarea></div><div class="uk-text-right uk-modal-footer"><button type="button" ng-click="vm.save(vm.applicant_id)" ng-disabled="!vm.tower_log.comment" class="uk-button uk-button-primary uk-modal-close" style="font-size: 12px">Forward</button></div></div></div>');
$templateCache.put('app/viewProjectAdmin/viewProjectAdmin.html','<div ng-cloak><div class="container"><div class="row"><div class="caf-style col-sm-8"><div class="col-sm-3"><h4>CAF type :</h4></div><div class="caf-select col-sm-5"><select ng-model="vm.type" class="form-control" ng-change="vm.viewcafs(\'All\')" ng-disabled="vm.isloadingrequest"><option value="new">New</option><option value="Renewable">Renew</option><option value="ShopCaf">Shop</option><option value="LandRequirementCaf">Land Requirement</option></select></div></div></div><br><div class="row"><div class="btn-group col-sm-5"><a type="submit" ui-sref="viewProjectAdmin" class="btn btn-info" ng-click="vm.viewcafs(\'All\')" ng-disabled="vm.isloadingrequest">All Project</a> <a type="submit" ui-sref="viewProjectAdmin" ng-click="vm.viewcafs(\'Pending\')" class="btn btn-primary" ng-disabled="vm.isloadingrequest">Pending</a> <a type="submit" ng-click="vm.viewcafs(\'Completed\')" ui-sref="viewProjectAdmin" class="btn btn-danger" ng-disabled="vm.isloadingrequest">Completed</a> <a type="submit" has-any-authority="ROLE_DESK_OFFICER,ROLE_ADMIN,ROLE_SUB_ADMIN" ng-click="vm.viewcafs(\'DeemedClear\')" ui-sref="viewProjectAdmin" class="btn btn-warning" ng-disabled="vm.isloadingrequest">Deemed Clearance</a></div><div class="col-sm-7 input-group"><input type="text" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Search.."> <span class="input-group-addon"><i class="fa fa-search"></i></span></div></div><br><br>{{message}}<!--<div ng-show="vm.viewcafs()">{{message}}</div>--><div class="row"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>CAF Pin (Composite Application Form)</th><!--<th>Investor Name</th>--><th>RM Info (Relationship Manager)</th><th>Total Project Cost</th><th>Proposed Employment</th><th>Business Entity</th><th>District</th><th>Level</th><th>Application Date</th><!--<th has-any-authority="ROLE_NODAL_OFFICER">Last Action Date</th>--><!--<th has-any-authority="ROLE_NODAL_OFFICER">Last Action By</th>--><th></th></tr></thead><tbody><tr ng-repeat="prdtl in vm.projectlist | filter:searchText | orderBy: \'-applicationDate\'"><td>{{$index+1}}</td><td>{{prdtl.cafpin}}</td><!--<td >{{prdtl.investorName}}</td>--><td>{{prdtl.rm==\'\' ? "Not Assigned" : prdtl.rm}}</td><td>{{prdtl.projectTotalCost}} Crores</td><td>{{prdtl.totalEmployement}}</td><td>{{prdtl.buisnessEntity}}</td><td>{{prdtl.district}}</td><td>{{prdtl.projectlevel == \'e\' ? "EEC" : "DLCC"}}</td><td>{{prdtl.applicationDate | date:\'dd-MM-yyyy\'}}</td><!--<td has-any-authority="ROLE_NODAL_OFFICER">{{prdtl.lastactiondate | date:\'dd-MM-yyyy\'}}</td>--><!--<td has-any-authority="ROLE_NODAL_OFFICER">{{prdtl.lastactionby}}</td>--><td class="action verticalalign"><a type="submit" ui-sref="projectdetailjist({projectid:prdtl.projectid})" class="btn btn-info">Details</a></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/viewServiceStatus/viewServiceStatus.html','<br><div ng-cloak><div class="container"><div class="row" ng-show="!vm.service"><div class="col-sm-4"><input type="text" ng-model="vm.cafPin" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Enter CAF PIN (Composite Application Form)"></div><div class="btn-group"><button type="submit" ng-click="vm.getProject()" class="btn btn-info">Search</button></div><div class="btn-group"><button type="submit" ng-click="vm.deptservice()" class="btn btn-info">Search By Service Name</button></div><div class="btn-group pull-right"><button ui-sref="feedback-ratings" class="btn btn-danger">Feedback Dashboard</button></div><div class="row" ng-show="vm.showtable"><div class="row"><div class="col-md-12" ng-repeat="(cafpin, servicedetails) in vm.serviceStatus | groupBy: \'cafPin\' "><h3>CAF Pin (Composite Application Form): {{cafpin}}</h3><div class="table-responsive"><table class="table table-striped table-hover text-center"><thead><tr class="row"><th class="col-md-5" style="font-size: 16px">Service Name</th><th class="col-md-5 bg-primary">Percentage Progress</th><th class="col-md-2"></th></tr></thead><tbody ng-repeat="services in servicedetails"><tr class="success row"><td class="col-md-5"><div class="padding-style">{{services.serviceName}}</div></td><td class="col-md-5"><div class="padding-style"><div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" aria-valuenow="{{services.percentageCompleted}}" aria-valuemin="0" aria-valuemax="100" ng-style="width={width:\'{{services.percentageCompleted}}%\'}">{{services.percentageCompleted}}%</div></div></div></td><td class="col-md-2"><div class="padding-style"><button class="btn btn-warning btn-sm" ng-show="!isShowing($index)" ng-click="vm.more($index, services.serviceId)"><span class="glyphicon glyphicon-chevron-down"></span>&nbsp;More</button> <button class="btn btn-warning btn-sm" ng-show="isShowing($index)" ng-click="vm.more(-1)"><span class="glyphicon glyphicon-chevron-up"></span>&nbsp;Less</button></div></td></tr><tr class="row" style="font-weight: bold" ng-show="isShowing($index)"><td style="text-align: left"><u style="color: red">Required steps:</u><ul class="list-group" ng-repeat="step in vm.serviceLevelsSelected track by $index"><li class="list-group-item-light" ng-if="step != \'\' && step != null && step != \'Rejected\'"><i class="glyphicon glyphicon-hand-right"></i>{{ " " + step }}</li></ul></td><td colspan="3" class="bs-wizard clearfix"><br><ul class="progress-indicator"><li ng-hide="services.level1==null" ng-class="{completed : services.percentageCompleted >= 10}"><span class="bubble"></span><i ng-show="services.level1 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level1}}<br><span style="color:#586069 !important">{{services.level1Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level2==null" ng-class="{completed : services.percentageCompleted >= 20}"><span class="bubble"></span><i ng-show="services.level2 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level2}}<br><span style="color:#586069 !important">{{services.level2Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level3==null" ng-class="{completed : services.percentageCompleted >= 30}"><span class="bubble"></span><i ng-show="services.level3 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level3}}<br><span style="color:#586069 !important">{{services.level3Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level4==null" ng-class="{completed : services.percentageCompleted >= 40}"><span class="bubble"></span><i ng-show="services.level4 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level4}}<br><span style="color:#586069 !important">{{services.level4Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level5==null" ng-class="{completed : services.percentageCompleted >= 50}"><span class="bubble"></span><i ng-show="services.level5 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level5}}<br><span style="color:#586069 !important">{{services.level5Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level6==null" ng-class="{completed : services.percentageCompleted >= 60}"><span class="bubble"></span><i ng-show="services.level6 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level6}}<br><span style="color:#586069 !important">{{services.level6Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level7==null" ng-class="{completed : services.percentageCompleted >= 70}"><span class="bubble"></span><i ng-show="services.level7 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level7}}<br><span style="color:#586069 !important">{{services.level7Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level8==null" ng-class="{completed : services.percentageCompleted >= 80}"><span class="bubble"></span><i ng-show="services.level8 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level8}}<br><span style="color:#586069 !important">{{services.level8Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level9==null" ng-class="{completed : services.percentageCompleted >= 90}"><span class="bubble"></span><i ng-show="services.level9 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level9}}<br><span style="color:#586069 !important">{{services.level9Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level10==null" ng-class="{completed : services.percentageCompleted >= 100}"><span class="bubble"></span><i ng-show="services.level10 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level10}}<br><span style="color:#586069 !important">{{services.level10Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level0==null" ng-class="{completed : services.percentageCompleted >= 100}"><span class="bubble"></span><i ng-show="services.level0 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level0}}<br><span style="color:#586069 !important">{{services.level0Date | date:\'mediumDate\'}}</span></li></ul><br></td></tr></tbody></table></div></div></div></div></div><div class="row" ng-show="vm.service"><div class="col-sm-3"><select class="dropdown-caret form-control" ng-model="vm.deptName" ng-change="vm.findservice()"><option disabled="disabled" value="">--Select Department--</option><option ng-repeat="departments in vm.departments | orderBy: \'departmentname\' " value="{{departments.id}}">{{departments.departmentname}}</option></select></div><div class="col-sm-3"><select class="dropdown-caret form-control" ng-model="vm.serviceId"><option disabled="disabled" value="">--Select Service Name--</option><option ng-repeat="services in vm.departmentservices" value="{{services.id}}">{{services.serviceName}}</option></select></div><div class="btn-group col-sm-3"><button type="submit" ng-click="vm.projectbyservice()" class="btn btn-info" ng-disabled="vm.deptName == null || vm.serviceId == null">Search</button></div><div class="btn-group col-sm-3"><button type="submit" ng-click="vm.projectbycafPin()" class="btn btn-info">Search By CafPin</button></div><div class="col-md-12"><div class="row"><div class="col-md-12" ng-repeat="(serviceName, servicedetails) in vm.serviceStatusByService | groupBy: \'serviceName\' "><h3>Service Name: {{serviceName}}</h3><div class="table-responsive"><table class="table table-striped table-hover text-center"><thead><tr class="row"><th class="col-md-5" style="font-size: 16px">CAF Pin (Composite Application Form)</th><th class="col-md-5 bg-primary">Percentage Progress</th><th class="col-md-2"></th></tr></thead><tbody ng-repeat="services in servicedetails"><tr class="success row"><td class="col-md-5"><div class="padding-style">CAF Pin (Composite Application Form) : {{services.cafPin}}</div></td><td class="col-md-5"><div class="padding-style"><div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" aria-valuenow="{{services.percentageCompleted}}" aria-valuemin="0" aria-valuemax="100" ng-style="width={width:\'{{services.percentageCompleted}}%\'}">{{services.percentageCompleted}}%</div></div></div></td><td class="col-md-2"><div class="padding-style"><button class="btn btn-warning btn-sm" ng-show="!isShowing($index)" ng-click="vm.more($index, services.serviceId)"><span class="glyphicon glyphicon-chevron-down"></span>&nbsp;More</button> <button class="btn btn-warning btn-sm" ng-show="isShowing($index)" ng-click="vm.more(-1)"><span class="glyphicon glyphicon-chevron-up"></span>&nbsp;Less</button></div></td></tr><tr class="row" style="font-weight: bold" ng-show="isShowing($index)"><td style="text-align: left"><u style="color: red">Required steps:</u><ul class="list-group" ng-repeat="step in vm.serviceLevelsSelected track by $index"><li class="list-group-item-light" ng-if="step != \'\' && step != null && step != \'Rejected\'"><i class="glyphicon glyphicon-hand-right"></i>{{ " " + step }}</li></ul></td><td colspan="3" class="bs-wizard clearfix"><br><ul class="progress-indicator"><li ng-hide="services.level1==null" ng-class="{completed : services.percentageCompleted >= 10}"><span class="bubble"></span><i ng-show="services.level1 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level1}}<br><span style="color:#586069 !important">{{services.level1Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level2==null" ng-class="{completed : services.percentageCompleted >= 20}"><span class="bubble"></span><i ng-show="services.level2 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level2}}<br><span style="color:#586069 !important">{{services.level2Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level3==null" ng-class="{completed : services.percentageCompleted >= 30}"><span class="bubble"></span><i ng-show="services.level3 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level3}}<br><span style="color:#586069 !important">{{services.level3Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level4==null" ng-class="{completed : services.percentageCompleted >= 40}"><span class="bubble"></span><i ng-show="services.level4 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level4}}<br><span style="color:#586069 !important">{{services.level4Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level5==null" ng-class="{completed : services.percentageCompleted >= 50}"><span class="bubble"></span><i ng-show="services.level5 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level5}}<br><span style="color:#586069 !important">{{services.level5Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level6==null" ng-class="{completed : services.percentageCompleted >= 60}"><span class="bubble"></span><i ng-show="services.level6 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level6}}<br><span style="color:#586069 !important">{{services.level6Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level7==null" ng-class="{completed : services.percentageCompleted >= 70}"><span class="bubble"></span><i ng-show="services.level7 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level7}}<br><span style="color:#586069 !important">{{services.level7Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level8==null" ng-class="{completed : services.percentageCompleted >= 80}"><span class="bubble"></span><i ng-show="services.level8 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level8}}<br><span style="color:#586069 !important">{{services.level8Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level9==null" ng-class="{completed : services.percentageCompleted >= 90}"><span class="bubble"></span><i ng-show="services.level9 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level9}}<br><span style="color:#586069 !important">{{services.level9Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level10==null" ng-class="{completed : services.percentageCompleted >= 100}"><span class="bubble"></span><i ng-show="services.level10 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level10}}<br><span style="color:#586069 !important">{{services.level10Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level0==null" ng-class="{completed : services.percentageCompleted >= 100}"><span class="bubble"></span><i ng-show="services.level0 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level0}}<br><span style="color:#586069 !important">{{services.level0Date | date:\'mediumDate\'}}</span></li></ul><br></td></tr></tbody></table></div></div></div></div></div></div></div>');
$templateCache.put('app/viewServiceStatus/viewUsersServiceStatus.html','<br><div ng-cloak><div class="container"><div class="row"><div class="col-sm-4 input-group pull-right"><input type="text" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Search By CAF Pin (Composite Application Form)"> <span class="input-group-addon"><i class="fa fa-search"></i></span></div></div><div class="row"><div class="row"><div class="col-md-12" ng-repeat="(cafpin, servicedetails) in vm.serviceStatuses | filter:searchText | groupBy: \'cafPin\' " ng-show="cafpin !== \'undefined\'"><h3>CAF Pin (Composite Application Form): {{cafpin}}</h3><div class="table-responsive"><table class="table table-striped table-hover text-center"><thead><tr class="row"><th class="col-md-5" style="font-size: 16px">Service Name</th><th class="col-md-5 bg-primary">Percentage Progress</th><th class="col-md-2"></th></tr></thead><tbody ng-repeat="services in servicedetails"><tr class="success row"><td class="col-md-5"><div class="padding-style">{{services.serviceName}}</div></td><td class="col-md-5"><div class="padding-style"><div class="progress"><div class="progress-bar progress-bar-success progress-bar-striped" aria-valuenow="{{services.percentageCompleted}}" aria-valuemin="0" aria-valuemax="100" ng-style="width={width:\'{{services.percentageCompleted}}%\'}">{{services.percentageCompleted}}%</div></div></div></td><td class="col-md-2"><div class="padding-style"><button class="btn btn-warning btn-sm" ng-show="!isShowing($index+services.cafPin)" ng-click="vm.more($index+services.cafPin, services.serviceId)"><span class="glyphicon glyphicon-chevron-down"></span>&nbsp;More</button> <button class="btn btn-warning btn-sm" ng-show="isShowing($index+services.cafPin)" ng-click="vm.more(-1)"><span class="glyphicon glyphicon-chevron-up"></span>&nbsp;Less</button></div></td></tr><tr class="row" style="font-weight: bold" ng-show="isShowing($index+services.cafPin)"><td style="text-align: left"><u style="color: red">Required steps:</u><ul class="list-group" ng-repeat="step in vm.serviceLevelsSelected track by $index"><li class="list-group-item-light" ng-if="step != \'\' && step != null && step != \'Rejected\'"><i class="glyphicon glyphicon-hand-right"></i>{{ " " + step }}</li></ul></td><td colspan="3" class="bs-wizard clearfix"><br><ul class="progress-indicator"><li ng-hide="services.level1==null" ng-class="{completed : services.percentageCompleted >= 10}"><span class="bubble"></span><i ng-show="services.level1 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level1}}<br><span style="color:#586069 !important">{{services.level1Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level2==null" ng-class="{completed : services.percentageCompleted >= 20}"><span class="bubble"></span><i ng-show="services.level2 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level2}}<br><span style="color:#586069 !important">{{services.level2Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level3==null" ng-class="{completed : services.percentageCompleted >= 30}"><span class="bubble"></span><i ng-show="services.level3 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level3}}<br><span style="color:#586069 !important">{{services.level3Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level4==null" ng-class="{completed : services.percentageCompleted >= 40}"><span class="bubble"></span><i ng-show="services.level4 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level4}}<br><span style="color:#586069 !important">{{services.level4Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level5==null" ng-class="{completed : services.percentageCompleted >= 50}"><span class="bubble"></span><i ng-show="services.level5 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level5}}<br><span style="color:#586069 !important">{{services.level5Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level6==null" ng-class="{completed : services.percentageCompleted >= 60}"><span class="bubble"></span><i ng-show="services.level6 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level6}}<br><span style="color:#586069 !important">{{services.level6Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level7==null" ng-class="{completed : services.percentageCompleted >= 70}"><span class="bubble"></span><i ng-show="services.level7 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level7}}<br><span style="color:#586069 !important">{{services.level7Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level8==null" ng-class="{completed : services.percentageCompleted >= 80}"><span class="bubble"></span><i ng-show="services.level8 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level8}}<br><span style="color:#586069 !important">{{services.level8Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level9==null" ng-class="{completed : services.percentageCompleted >= 90}"><span class="bubble"></span><i ng-show="services.level9 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level9}}<br><span style="color:#586069 !important">{{services.level9Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level10==null" ng-class="{completed : services.percentageCompleted >= 100}"><span class="bubble"></span><i ng-show="services.level10 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level10}}<br><span style="color:#586069 !important">{{services.level10Date | date:\'mediumDate\'}}</span></li><li ng-hide="services.level0==null" ng-class="{completed : services.percentageCompleted >= 100}"><span class="bubble"></span><i ng-show="services.level0 !== null" class="fa fa-check-circle"></i>&nbsp;&nbsp;{{services.level0}}<br><span style="color:#586069 !important">{{services.level0Date | date:\'mediumDate\'}}</span></li></ul><br></td></tr></tbody></table></div></div></div></div></div></div>');
$templateCache.put('app/viewprojectdetail/nodalofficerviewprojectdetail.html','<div ng-cloak><div class="container-fluid"><div class="row" style="padding: 12px"><div class="col-md-1 filter-margin"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div><div class="col-md-3"><select class="custom-select form-control" ng-model="vm.serviceFilter"><option value="">All Services</option><option value="{{service}}" ng-repeat="service in vm.servicesList">{{service}}</option></select></div><div class="col-md-1"><select class="custom-select form-control" ng-model="vm.districtSelected"><option value="">All Districts</option><option value="{{district}}" ng-repeat="district in vm.districtsList">{{district}}</option></select></div><div class="col-md-1"><select class="custom-select form-control" ng-model="vm.status" ui-sref="nodalofficerviewprojectdetail({status: vm.status})"><option value="All">All Projects</option><option value="Pending">Pending</option><!-- Every state an intimation of a Communication and Connectivity\n                         Permissions tower passes through - acknowledged when it is issued,\n                         valid or invalid once the authority says so, deemed either way when\n                         the portal says so on a window closing. --><option value="Acknowledged">CCIP Acknowledged</option><option value="Intimation Valid">CCIP Valid Intimation</option><option value="Intimation Invalid">CCIP Invalid Intimation</option><option value="Deemed Valid">CCIP Deemed Valid</option><option value="Deemed Invalid">CCIP Deemed Invalid</option><option value="Required">Required</option><option value="Completed">Completed</option></select></div><div class="row"><div class="col-sm-2"><input type="text" ng-model="vm.cafpin" class="form-control" id="searchQuery" placeholder="Enter CAF PIN (Composite Application Form)"></div><div class="btn-group col-sm-4"><button type="submit" ng-click="vm.getDataByCafpin()" class="btn btn-info" has-any-authority="ROLE_USER, ROLE_ADMIN, ROLE_SUB_ADMIN, ROLE_MONITORING_OFFICER, ROLE_HEPC_MONITORING_OFFICER, ROLE_DESK_OFFICER,ROLE_DEPT_CHANGE,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD, ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_NODAL_OFFICER,ROLE_TICKET_ADMIN">Search</button></div></div><!--            <div class="col-md-4 input-group">--><!--                <input type="text" class="form-control" ng-model="searchText" id="searchQuery"--><!--                       placeholder="Search..">--><!--                <span class="input-group-addon"><i class="fa fa-search"></i></span>--><!--            </div>--> <button ng-if="vm.projectlist !=null" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm pull-right btn-marginTop">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><div class="row"><div class="col-md-2 pull-right" ng-show="vm.showButton"><button type="submit" ui-sref="showDLCC" class="btn btn-success">Show DLCC</button></div></div><div class="row"><div class="col-md-12"><div id="result_table" class="table-responsive"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>Service Name</th><th>CAF Pin (Composite Application Form)</th><!--<th>Investor Name</th>--><th>RM Info (Relationship Manager)</th><th>Total Project Cost</th><th>Proposed Employment</th><th>Business Entity</th><th>District</th><th>Site Address</th><th>Level</th><th>Application Date</th><th>Last Action Date</th><th>Last Action Comment</th><th></th></tr></thead><tbody><tr dir-paginate="prdtl in vm.projectlist.content\n                        | filter:searchText | filter: {district: vm.districtSelected} | filter: {serviceName: vm.serviceFilter}\n                        | orderBy: \'-lastActionDate\' | itemsPerPage: pageSize" total-items="vm.projectlist.totalElements" current-page="currentPage"><td>{{$index+1}}</td><td>{{prdtl.serviceName}}</td><td>{{prdtl.cafpin}}</td><!--<td>{{prdtl.investorName}}</td>--><td>{{prdtl.rm==\'\' ? "Not Assigned" : prdtl.rmInfo}}</td><td>{{prdtl.totalProjectCost}} Crores</td><td>{{prdtl.proposedEmployment}}</td><td>{{prdtl.businessEntity}}</td><td>{{prdtl.district}}</td><td>{{prdtl.siteAddress==\'\'?\'NA\':prdtl.siteAddress}}</td><td>{{prdtl.projectLevel == \'e\' ? "EEC" : "DLCC"}}</td><td>{{prdtl.applicationDate | date:\'dd-MM-yyyy\'}}</td><td>{{prdtl.lastActionDate | date:\'dd-MM-yyyy\'}}</td><td>{{prdtl.lastActionComment}}</td><td class="action verticalalign"><a type="submit" ui-sref="projectdetailjist({projectid:prdtl.projectId})" class="btn btn-info">Details</a></td></tr></tbody></table><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div></div></div>');
$templateCache.put('app/viewprojectdetail/showDLCC.html','<div ng-cloak><div class="container"><div class="row"><div class="btn-group col-md-1"><button type="submit" glyphicon glyphicon-arrow-left ui-sref="nodalofficerviewprojectdetail({status:\'All\'})" class="btn btn-success"><span class="glyphicon glyphicon-arrow-left"></span> Back</button></div><div class="col-md-1 filter-margin"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div><div class="col-md-2"><select class="custom-select form-control" ng-model="vm.status" ng-change="vm.loadAll()"><option value="All">All Projects</option><option value="Pending">Pending</option><option value="Required">Required</option><option value="Cleared">Cleared</option><option value="DeemedCleared">Deemed Cleared</option><option value="Declined">Declined</option><option value="Rejected">Rejected</option></select></div><div class="col-md-3"><select class="custom-select form-control" ng-model="vm.serviceFilter"><option value="">All Services</option><option value="{{service}}" ng-repeat="service in vm.servicesList">{{service}}</option></select></div><div class="col-md-2"><select class="custom-select form-control" ng-model="vm.districtSelected"><option value="">All Districts</option><option value="{{district}}" ng-repeat="district in vm.districtsList">{{district}}</option></select></div><div class="col-md-3 input-group"><input type="text" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Search.."> <span class="input-group-addon"><i class="fa fa-search"></i></span></div></div><div class="row"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>Service Name</th><th>CAF Pin (Composite Application Form)</th><!--<th>Investor Name</th>--><th>RM Info (Relationship Manager)</th><th>Total Project Cost</th><th>Proposed Employement</th><th>Business Entity</th><th>District</th><th>Level</th><th>Application Date</th><th>Last Action Date</th><th>Last Action Comment</th><th></th></tr></thead><tbody><tr dir-paginate="prdtl in vm.projectlistDLCC.content | filter:searchText\n                 | filter: {district: vm.districtSelected} | filter: {serviceName: vm.serviceFilter}\n                 | orderBy: \'-lastactiondate\' | itemsPerPage: pageSize" total-items="vm.projectlistDLCC.totalElements" current-page="currentPage"><td>{{$index+1}}</td><td>{{prdtl.serviceName}}</td><td>{{prdtl.cafpin}}</td><!--<td>{{prdtl.investorName}}</td>--><td>{{prdtl.rmInfo==\'\' ? "Not Assigned" : prdtl.rmInfo}}</td><td>{{prdtl.totalProjectCost}} Crores</td><td>{{prdtl.proposedEmployment}}</td><td>{{prdtl.businessEntity}}</td><td>{{prdtl.district}}</td><td>{{prdtl.projectLevel == \'e\' ? "EEC" : "DLCC"}}</td><td>{{prdtl.applicationDate | date:\'dd-MM-yyyy\'}}</td><td>{{prdtl.lastActionDate | date:\'dd-MM-yyyy\'}}</td><td>{{prdtl.lastActionComment}}</td><td class="action verticalalign"><button type="submit" ui-sref="projectdetailjist({projectid:prdtl.projectId})" class="btn btn-info">Details</button></td></tr></tbody></table><div class="row"><label class="control-label col-md-offset-3 col-lg-3">View number of records per page</label><div class="col-lg-1"><select ng-model="vm.selectedValue" id="vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required><option value="10">10</option><option value="25">25</option><option value="50">50</option><option value="100">100</option></select></div></div><div class="text-center"><dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls></div></div></div></div>');
$templateCache.put('app/viewprojectdetail/viewprojectdetail.html','<div ng-cloak><div class="container"><div class="row"><div class="btn-group col-sm-5"><!--<button type="submit"--><!--ui-sref="viewprojectdetail({status:\'All\'})"--><!--class="btn btn-info ">All Project</button>--><!--<button type="submit"--><!--ui-sref="viewprojectdetail({status:\'Pending\'})"--><!--class="btn btn-primary">Pending</button>--><!--<button type="submit"--><!--ui-sref="viewprojectdetail({status:\'Completed\'})"--><!--class="btn btn-danger">Completed</button>--><!--<button type="submit" has-any-authority="ROLE_DESK_OFFICER,ROLE_ADMIN,ROLE_SUB_ADMIN"--><!--ui-sref="viewprojectdetail({status:\'DeemedClear\'})"--><!--class="btn btn-warning">Deemed Clearance</button>--><ul class="nav nav-pills flex-container"><li class="active"><a ui-sref="viewprojectdetail({status:\'All\'})">All Project</a></li><li class="active"><a ui-sref="viewprojectdetail({status:\'Pending\'})">Pending</a></li><li class="active"><a ui-sref="viewprojectdetail({status:\'Completed\'})">Completed</a></li><li class="active" has-any-authority="ROLE_DESK_OFFICER,ROLE_ADMIN,ROLE_SUB_ADMIN"><a ui-sref="viewprojectdetail({status:\'DeemedClear\'})">Deemed Clearance</a></li></ul></div><div class="col-sm-4"><input type="text" class="form-control" ng-model="searchText" id="searchQuery" placeholder="Search.."></div><div class="col-sm-1"><button type="submit" ng-click="vm.findByCafpin(searchText)" class="btn btn-info" has-any-authority="ROLE_USER, ROLE_ADMIN, ROLE_SUB_ADMIN, ROLE_DESK_OFFICER,ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_NODAL_OFFICER,ROLE_TICKET_ADMIN">Search</button></div></div><div class="card-content" ng-show="vm.projectlist.content.length == 0"><br><h3 class="jumbotron text-center">Please try next</h3></div><div class="row"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>#</th><th>CAF Pin (Composite Application Form)</th><!--<th>Investor Name</th>--><th>RM Info (Relationship Manager)</th><th>Total Project Cost</th><th>Proposed Employment</th><th>Business Entity</th><th>District</th><th>Level</th><th>Application Date</th><!--<th has-any-authority="ROLE_NODAL_OFFICER">Last Action Date</th>--><!--<th has-any-authority="ROLE_NODAL_OFFICER">Last Action By</th>--><th></th></tr></thead><tbody><tr ng-repeat="prdtl in vm.allprojectlist | orderBy: \'-applicationDate\'"><td>{{$index+1}}</td><td>{{prdtl.cafpin}}</td><!--<td >{{prdtl.investorName}}</td>--><td>{{prdtl.rm==\'\' ? "Not Assigned" : prdtl.rm}}</td><td>{{prdtl.projectTotalCost}} Crores</td><td>{{prdtl.totalEmployement}}</td><td>{{prdtl.buisnessEntity}}</td><td>{{prdtl.district}}</td><td>{{prdtl.projectlevel == \'e\' ? "EEC" : "DLCC"}}</td><td>{{prdtl.applicationDate | date:\'dd-MM-yyyy\'}}</td><!--<td has-any-authority="ROLE_NODAL_OFFICER">{{prdtl.lastactiondate | date:\'dd-MM-yyyy\'}}</td>--><!--<td has-any-authority="ROLE_NODAL_OFFICER">{{prdtl.lastactionby}}</td>--><td class="action verticalalign"><button type="submit" ui-sref="projectdetailjist({projectid:prdtl.projectid})" class="btn btn-info">Details</button></td></tr></tbody></table><button class="btn btn-blue" ng-click="vm.loadAll(vm.page - 1)">Previous</button> <button class="btn btn-blue" ng-disabled="vm.projectlist.number==0" ng-click="vm.loadAll(vm.page + 1)">Next</button><br><br><!--        <div class="row">--><!--            <label class=" control-label col-md-offset-3 col-lg-3">View number of records per page</label>--><!--            <div class="col-lg-1">--><!--                <select ng-model="vm.selectedValue" id = "vm.selectedValue" ng-change="setPageSize(vm.selectedValue)" required>--><!--                    <option value="10" >10</option>--><!--                    <option value="25" >25</option>--><!--                    <option value="50" >50</option>--><!--                    <option value="100" >100</option>--><!--                </select>--><!--            </div>--><!--        </div>--><!--        <div class="text-center">--><!--            <dir-pagination-controls boundary-links="true" on-page-change="pageChangedHandler(newPageNumber)" template-url="app/dirPagination.tpl.html"></dir-pagination-controls>--><!--        </div>--></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/settings/settings.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>] .</h2><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100" disabled="disabled"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group" has-authority="ROLE_USER"><label class="control-label" for="mobile">Mobile</label><input type="text" class="form-control" id="mobile1" name="mobile" ng-model="vm.extendedUserInformation.userMobile" ng-minlength="10" ng-maxlength="10/"><div ng-show="form.mobile.$dirty && form.mobile.$invalid"><p class="help-block" ng-show="form.mobile.$error.mobile">Your Mobile is invalid.</p><p class="help-block" ng-show="form.mobile.$error.minlength">Your Mobile is required to be at least 10 characters.</p><p class="help-block" ng-show="form.mobile.$error.maxlength">Your Mobile is required to be at max 10 characters.</p></div></div><div class="form-group" has-any-authority="ROLE_RM,ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_FIELD_OFFICER,ROLE_ACCOUNT_OFFICER,ROLE_TOWER_OFFICER,ROLE_FILM_OFFICER"><label class="control-label" for="mobile">Mobile</label><input type="text" class="form-control" id="mobile" name="mobile" ng-model="vm.extendedUserInformation.userMobile" ng-minlength="10" ng-maxlength="10"><div ng-show="form.mobile.$dirty && form.mobile.$invalid"><p class="help-block" ng-show="form.mobile.$error.mobile">Your Mobile is invalid.</p><p class="help-block" ng-show="form.mobile.$error.minlength">Your Mobile is required to be at least 10 characters.</p><p class="help-block" ng-show="form.mobile.$error.maxlength">Your Mobile is required to be at max 10 characters.</p></div></div><div class="form-group"><label class="control-label" for="address">Address</label><input type="text" class="form-control" id="address" name="address" ng-model="vm.extendedUserInformation.userAddress" ng-maxlength="500"><div ng-show="form.address.$dirty && form.address.$invalid"><p class="help-block" ng-show="form.address.$error.address">Your Address is invalid.</p><p class="help-block" ng-show="form.address.$error.maxlength">Your Address is required to be at max 500 characters.</p></div></div><!--<div class="form-group">--><!--<label for="langKey" data-translate="settings.form.language">Language</label>--><!--<select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select>--><!--</div>--> <button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 translate-values="{username: \'{{vm.account.login}}\'}">Change Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" ng-hide="vm.success" novalidate ng-submit="vm.changePassword(vm.currentpassword)" show-validation><div class="form-group"><label class="control-label">Current password</label><input type="password" class="form-control" id="currentPasswordInput" name="currentpassword" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');" placeholder="Enter your current password" ng-model="vm.currentpassword" ng-minlength="6" ng-maxlength="50" required><div ng-show="!vm.passwordResult && vm.showError"><p class="help-block"><span class="text-danger">Your current password is wrong</span></p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');" placeholder="Enter your new password" ng-model="vm.password" ng-minlength="6" ng-maxlength="50" ng-pattern="/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,50}$/" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 6 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p><p class="help-block">Your password must contain atleast one uppercase letter(A-Z), one lowercase letter(a-z), one digit(0-9) and one special character.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPasswordInput" name="confirmPassword" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');" placeholder="Enter your password" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" ng-pattern="/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,50}$/" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 6 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p><p class="help-block">Your password must contain atleast one uppercase letter(A-Z), one lowercase letter(a-z), one digit(0-9) and one special character.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div><div class="col-md-12 blink_me"><b style="color: red; font-size: small;padding: 100px">To access and apply for schemes under the Haryana State Startup Policy 2022, please sign up using the same email address registered on the Startup Haryana portal.</b></div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="register.title">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorLoginNotAcceptable"><strong>Login Not Acceptable with this Extension!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div></div><div class="col-md-8 col-md-offset-2"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="firstname">First Name</label><input type="text" class="form-control" id="firstname" name="firstname" placeholder="Your First Name" ng-model="vm.registerAccount.firstName" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z]*$/" required><div ng-show="form.login.$dirty && form.firstname.$invalid"><p class="help-block" ng-show="form.firstname.$error.required">Your First Name is required.</p><p class="help-block" ng-show="form.firstname.$error.minlength">Your First Name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstname.$error.maxlength">Your First Name cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.firstname.$error.pattern">Your First Name can only contain letters.</p></div></div><div class="form-group"><label class="control-label" for="lastname">Last Name</label><input type="text" class="form-control" id="lastname" name="lastname" placeholder="Your Last Name" ng-model="vm.registerAccount.lastName" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z]*$/" required><div ng-show="form.login.$dirty && form.lastname.$invalid"><p class="help-block" ng-show="form.lastname.$error.required">Your Last Name is required.</p><p class="help-block" ng-show="form.lastname.$error.minlength">Your Last Name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastname.$error.maxlength">Your Last Name cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.lastname.$error.pattern">Your Last Name can only contain letters.</p></div></div><div class="form-group"><label class="control-label" for="login" data-translate="global.form.username">Username</label><input type="text" class="form-control" id="login" name="login" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control password" id="password" name="password" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.registerAccount.password" ng-minlength="6" ng-maxlength="50" ng-pattern="/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,50}$/" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 6 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p><p class="help-block">Your password must contain atleast one uppercase letter(A-Z), one lowercase letter(a-z), one digit(0-9) and one special character.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control password" id="confirmPassword" name="confirmPassword" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="6" ng-maxlength="50" ng-pattern="/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,50}$/" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 6 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p><p class="help-block">Your password must contain atleast one uppercase letter(A-Z), one lowercase letter(a-z), one digit(0-9) and one special character.</p></div></div><div class="form-group"><label class="control-label" data-translate="">Mobile</label><input type="text" class="form-control" name="mobile" id="mobile" ng-model="vm.registerAccount.phone" ng-maxlength="10" ng-minlength="10" placeholder="Mobile Number" ng-pattern="/^[0-9]*$/" required><div ng-show="form.mobile.$dirty && form.mobile.$invalid"><p class="help-block" ng-show="form.mobile.$error.required">Your Mobile Number is required.</p><p class="help-block" ng-show="form.mobile.$error.maxlength">Your Mobile cannot be longer than 10 characters.</p><p class="help-block" ng-show="form.mobile.$error.minlength">Your Mobile cannot be less than 10 characters.</p><p class="help-block" ng-show="form.mobile.$error.pattern">Your Mobile can only contain numbers.</p></div></div><div class="form-group"><label class="control-label" data-translate="">Address</label><input type="text" class="form-control" name="address" ng-model="vm.registerAccount.userAddress" ng-maxlength="150" ng-pattern="/^[_\'.@A-Za-z0-9-,=();\\x22 \\x27 \\s\\ \\xOD :  \\/-]*$/" placeholder="Address"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.address.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 150 characters.</p></div><div ng-show="form.address.$error.pattern"><div style="color: red"><b>*</b>Only these Characters are allowed _\'.@A-Za-z0-9-,=();" : /-</div></div></div><button type="submit" ng-disabled="form.$invalid || vm.isSaving" class="btn btn-primary" data-translate="register.form.button">Register</button></form><!--<div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>--><!--If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br/>- Administrator (login="admin" and password="admin") <br/>- User (login="user" and password="user").--><!--</div>--></div></div></div><style>.badge-warning { background-color: red!important }\n    .blink_me {\n        animation: blinker 2s linear infinite;\n    }\n\n    @keyframes blinker {\n        50% {\n            opacity: 0;\n        }\n    }</style>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/user-management/newduplicateuser.html','<div class="table-responsive" ng-hide="vm.user===undefined"><table class="table table-striped"><thead><tr><td>S. No.</td><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="userManagement.login">Login</span></th><th><span data-translate="userManagement.email">Email</span></th><th></th><th><span data-translate="userManagement.langKey">Lang Key</span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th><span>Create Date</span></th><th><span>Update Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.user"><td>{{$index+1}}</td><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger hand" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success hand" ng-show="user.activated" data-translate="userManagement.activated">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{authority}}</span></div></td><td>{{user.createDate | date:\'medium\'}}</td><td>{{user.updateDate | date:\'medium\'}}</td></tr></tbody></table></div>');
$templateCache.put('app/admin/user-management/user-list.html','<div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="newduplicates"><span class="glyphicon glyphicon-danger"></span> <span>New Duplicate Entries</span></button></div></div><div class="table-responsive" ng-hide="vm.user===undefined"><table class="table table-striped"><thead><tr><td>S. No.</td><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="userManagement.login">Login</span></th><th><span data-translate="userManagement.email">Email</span></th><th></th><th><span data-translate="userManagement.langKey">Lang Key</span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th><span>Create Date</span></th><th><span>Update Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.user"><td>{{$index+1}}</td><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger hand" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success hand" ng-show="user.activated" data-translate="userManagement.activated">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{authority}}</span></div></td><td>{{user.createDate | date:\'medium\'}}</td><td>{{user.updateDate | date:\'medium\'}}</td></tr></tbody></table></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<section class="ls section_padding_top_75 section_padding_bottom_75 columns_padding_10 row" id="about"><div class="col-md-11 col-md-offset-1"><h2><span data-translate="userManagement.detail.title">User</span> [<b>{{vm.user.login}}</b>]</h2><dl class="jh-entity-details"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span> <span class="label label-danger" ng-show="!vm.user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success" ng-show="vm.user.activated" data-translate="userManagement.activated">Activated</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="">Mobile</span></dt><dd>{{vm.user.phone}}</dd><dt><span data-translate="">Address</span></dt><dd>{{vm.user.userAddress}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.updateDate | date:\'dd/MM/yy HH:mm\'}}</dd><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span class="label label-info">{{authority}}</span></li></ul></dd></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div></section>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserLabel" data-translate="userManagement.home.createOrEditLabel">Create or edit a User</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group"><label class="control-label" data-translate="">Mobile</label><input type="text" class="form-control" name="mobile" ng-model="vm.extendedUserInformation.userMobile" ng-maxlength="10"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.mobile.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="">Address</label><input type="text" class="form-control" name="address" ng-model="vm.extendedUserInformation.userAddress" ng-maxlength="150"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.address.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 150 characters.</p></div></div><div class="form-group"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><!--<div class="form-group">--><!--<label data-translate="userManagement.langKey">Lang Key</label>--><!--<select class="form-control" name="langKey" ng-model="vm.user.langKey"--><!--ng-options="language as language for language in vm.languages track by language">--><!--</select>--><!--</div>--><div class="form-group"><label data-translate="userManagement.profiles">Profiles</label><select class="form-control" multiple="multiple" name="authority" ng-model="vm.user.authorities" ng-options="authority for authority in vm.authorities"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="container"><h2 data-translate="userManagement.home.title">Users</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-4"><button class="btn btn-primary" ui-sref="user-management.new"><span class="glyphicon glyphicon-flash"></span> <span data-translate="userManagement.home.createLabel">Create a new User</span></button></div></div></div><br><div class="container"><form ng-submit="vm.getUser()" name="userForm"><div class="row form-group"><div class="col-sm-4 col-sm-offset-2"><input type="text" name="userinfo" class="form-control" ng-model="vm.userinfo" id="searchQuery" placeholder="Enter user\'s login or email" required></div><div class="btn-group col-sm-4"><button type="submit" class="btn btn-info" ng-disabled="userForm.userinfo.$invalid">Search</button></div></div><br></form><br><jhi-alert-error></jhi-alert-error><div class="table-responsive" ng-hide="vm.users===undefined"><table class="table table-striped"><thead><tr><td>S. No.</td><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="userManagement.login">Login</span></th><th><span data-translate="userManagement.email">Email</span></th><th></th><th><span data-translate="userManagement.langKey">Lang Key</span></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th><span>Create Date</span></th><th><span>Update Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users"><td>{{$index+1}}</td><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger hand" ng-show="!user.activated" data-translate="userManagement.deactivated">Deactivated</span> <span class="label label-success hand" ng-show="user.activated" data-translate="userManagement.activated">Activated</span></td><td>{{user.langKey}}</td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{authority}}</span></div></td><td>{{user.createDate | date:\'medium\'}}</td><td>{{user.updateDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login, id:user.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-xs hidden-sm" data-translate="entity.action.edit"></span></button><!--<button type="submit"--><!--ui-sref="user-management.delete({login:user.login})"--><!--class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-xs hidden-sm" data-translate="entity.action.delete"></span>--><!--</button>--></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/components/login/login.html','<div class="modal-body login-bg"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><div class="row"><div class="col-md-12 text-center"><h1>Login to Your Account</h1></div><div class="col-md-8 col-md-offset-1"><div class="alert alert-danger" ng-show="vm.authenticationError" data-translate="login.messages.error.authentication"><strong>Failed to sign in!</strong> Please check your credentials and try again.</div></div><div class="col-md-8 col-md-offset-1"><form class="form-horizontal" role="form" autocomplete="off"><fieldset><div class="form-group"><label class="col-md-4 control-label" for="username" data-translate="global.form.username">Email</label><div class="col-md-8"><input type="text" class="form-control" id="username" placeholder="{{\'global.form.username.placeholder\' | translate}}" ng-model="vm.username"></div></div><div class="form-group"><label class="col-md-4 control-label" data-translate="login.form.password">Password</label><div class="col-md-8"><input type="password" class="form-control" id="confirmPassword" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');" placeholder="{{\'login.form.password.placeholder\' | translate}}" ng-model="vm.password"></div></div><div class="form-group"><label class="col-md-4 control-label">Enter CAPTCHA</label><div class="col-md-8"><!-- CAPTCHA image (canvas) --><canvas id="captchaCanvas" class="captcha-canvas" width="180" height="50" style="border:1px solid #000; background-color:#000"></canvas><!-- Input field with refresh button --><div class="input-group" style="margin-top: 10px"><input type="text" class="form-control captcha-input" id="captchaInput" placeholder="Enter CAPTCHA" ng-model="vm.captchaInput"><div class="input-group-btn"><button type="button" class="btn btn-refresh-captcha" ng-click="vm.refreshCaptcha()" style="color: white; height: 100%; padding: 7px 16px"><span class="glyphicon glyphicon-refresh"></span><!-- Refresh icon --></button></div></div><!-- Error message for incorrect CAPTCHA --><p ng-show="vm.captchaError" class="text-danger">CAPTCHA is incorrect. Please try again.</p></div></div><div class="login-help col-md-9 col-md-offset-3 text-center"><a href="" ng-click="vm.register()">New Investor Registration</a> - <a href="" ng-click="vm.requestResetPassword()">Forgot Password</a></div><div class="form-group"><div class="text-center"><label class="control-label" for="rememberMe"><input type="checkbox" id="rememberMe" ng-model="vm.rememberMe" checked="checked"> <span data-translate="login.form.rememberme">Remember me</span></label><button type="button" class="btn btn-primary pull-right" ng-click="vm.login($event)" ng-disabled="!vm.username || !vm.password" data-translate="login.form.button">Sign in</button></div></div></fieldset></form><!--            <form target="my_iframe"--><!--                  action="https://startupharyana.gov.in/invest-haryana/apply-schemes"--><!--                  method="GET" ng-submit="vm.handleApplyNow($event)">--><!--                <input type="submit" class="btn btn-link" href="#modal-full" uk-toggle value="Login with Startup Haryana" >--><!--            </form>--><!--            <br>--><!--            <div class="row" style="display: flex; align-items: center; gap: 15px;">--><!--                <a href="https://entity.digilocker.gov.in/" class="entity-locker-link">--><!--                    <img src="/logo/entitylogo.jpeg"--><!--                         style="height:40px;width:auto;">--><!--                </a>--><!--                <a href="https://www.digilocker.gov.in/" class="entity-locker-link">--><!--                    <img src="/logo/digilocker.jpeg"--><!--                         style="height:40px;width:auto;">--><!--                </a>--><!--            </div>--><div style="display:flex; align-items:center; gap:20px"><!-- Button wrapper (fixed height) --><div style="display:flex; align-items:center"><form target="my_iframe" action="https://startupharyana.gov.in/invest-haryana/apply-schemes" method="GET" ng-submit="vm.handleApplyNow($event)" style="margin:0"><input type="submit" href="#modal-full" uk-toggle class="uk-button uk-button-link" value="Login with Startup Haryana" style="/*background:none;*/\n                     /*border:none;*/\n                     /*color:#1e87f0;*/\n                     cursor:pointer;\n                     font-size:14px;\n                     padding:0 6px;\n                     line-height:normal"></form></div><!-- Entity Locker Logo (isolated size) --><div style="display:flex; align-items:center; gap:20px"><a href="https://entity.digilocker.gov.in/"><img src="/logo/entitylogo.jpeg" style="width:100px; height:auto; max-width:none"> </a><a href="https://www.digilocker.gov.in/"><img src="/logo/digilocker.jpeg" style="width:100px; height:auto; max-width:none"></a></div></div></div></div></div><div id="modal-full" class="uk-modal-full" uk-modal esc-close="false" bg-close="false"><div class="uk-modal-dialog"><button class="uk-modal-close-full uk-close-large" type="button" uk-close ng-click="vm.close()"></button><div class="uk-grid-collapse uk-flex-middle" uk-grid><section><iframe name="my_iframe" style="width: 500vw; height: 100vh" frameborder="0" marginheight="0" marginwidth="0"></iframe></section></div></div></div>');
$templateCache.put('app/entities/aai/aai-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.aai.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.aai.delete.question" translate-values="{id: \'{{vm.aai.id}}\'}">Are you sure you want to delete this Aai?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/aai/aai-detail.html','<div><h2><span data-translate="investhryApp.aai.detail.title">Aai</span> {{vm.aai.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.aai.height_clearance">Height Clearance</span></dt><dd><span>{{vm.aai.height_clearance}}</span></dd><dt><span data-translate="investhryApp.aai.nameOfAplicant">Name Of Aplicant</span></dt><dd><span>{{vm.aai.nameOfAplicant}}</span></dd><dt><span data-translate="investhryApp.aai.addressOfApplicant">Address Of Applicant</span></dt><dd><span>{{vm.aai.addressOfApplicant}}</span></dd><dt><span data-translate="investhryApp.aai.mobile_no">Mobile No</span></dt><dd><span>{{vm.aai.mobile_no}}</span></dd><dt><span data-translate="investhryApp.aai.email_id">Email Id</span></dt><dd><span>{{vm.aai.email_id}}</span></dd><dt><span data-translate="investhryApp.aai.nameOfOwner">Name Of Owner</span></dt><dd><span>{{vm.aai.nameOfOwner}}</span></dd><dt><span data-translate="investhryApp.aai.addressOfCommunication">Address Of Communication</span></dt><dd><span>{{vm.aai.addressOfCommunication}}</span></dd><dt><span data-translate="investhryApp.aai.typeOfStructure">Type Of Structure</span></dt><dd><span>{{vm.aai.typeOfStructure}}</span></dd><dt><span data-translate="investhryApp.aai.usesOfStructure">Uses Of Structure</span></dt><dd><span>{{vm.aai.usesOfStructure}}</span></dd><dt><span data-translate="investhryApp.aai.siteDescription">Site Description</span></dt><dd><span>{{vm.aai.siteDescription}}</span></dd><dt><span data-translate="investhryApp.aai.sizeOfPlot">Size Of Plot</span></dt><dd><span>{{vm.aai.sizeOfPlot}}</span></dd><dt><span data-translate="investhryApp.aai.state">State</span></dt><dd><span>{{vm.aai.state}}</span></dd><dt><span data-translate="investhryApp.aai.areaName">Area Name</span></dt><dd><span>{{vm.aai.areaName}}</span></dd><dt><span data-translate="investhryApp.aai.latitude1">Latitude 1</span></dt><dd><span>{{vm.aai.latitude1}}</span></dd><dt><span data-translate="investhryApp.aai.latitude2">Latitude 2</span></dt><dd><span>{{vm.aai.latitude2}}</span></dd><dt><span data-translate="investhryApp.aai.latitude3">Latitude 3</span></dt><dd><span>{{vm.aai.latitude3}}</span></dd><dt><span data-translate="investhryApp.aai.longitude1">Longitude 1</span></dt><dd><span>{{vm.aai.longitude1}}</span></dd><dt><span data-translate="investhryApp.aai.longitude2">Longitude 2</span></dt><dd><span>{{vm.aai.longitude2}}</span></dd><dt><span data-translate="investhryApp.aai.longitude3">Longitude 3</span></dt><dd><span>{{vm.aai.longitude3}}</span></dd><dt><span data-translate="investhryApp.aai.siteElevation">Site Elevation</span></dt><dd><span>{{vm.aai.siteElevation}}</span></dd><dt><span data-translate="investhryApp.aai.buildingHeight">Building Height</span></dt><dd><span>{{vm.aai.buildingHeight}}</span></dd><dt><span data-translate="investhryApp.aai.maxSiteElevation">Max Site Elevation</span></dt><dd><span>{{vm.aai.maxSiteElevation}}</span></dd><dt><span data-translate="investhryApp.aai.question1">Question 1</span></dt><dd><span>{{vm.aai.question1}}</span></dd><dt><span data-translate="investhryApp.aai.question2">Question 2</span></dt><dd><span>{{vm.aai.question2}}</span></dd><dt><span data-translate="investhryApp.aai.question3">Question 3</span></dt><dd><span>{{vm.aai.question3}}</span></dd><dt><span data-translate="investhryApp.aai.file1">File 1</span></dt><dd><span>{{vm.aai.file1}}</span></dd><dt><span data-translate="investhryApp.aai.city">City</span></dt><dd><span>{{vm.aai.city}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="aai-detail.edit({id:vm.aai.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/aai/aai-dialog.html','<div class="col-md-8 col-md-offset-2"><form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><!--<button type="button" class="close" data-dismiss="modal" aria-hidden="true"--><!--ng-click="vm.clear()">&times;</button>--><h4 class="modal-title" id="myAaiLabel">New Airport Authority of India Integration</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.aai.id" hidden><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.aai.id" hidden></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.height_clearance" for="field_height_clearance">Height Clearance</label><input type="text" class="form-control" name="height_clearance" id="field_height_clearance" ng-model="vm.aai.height_clearance"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.nameOfAplicant" for="field_nameOfAplicant">Name Of Aplicant</label><input type="text" class="form-control" name="nameOfAplicant" id="field_nameOfAplicant" ng-model="vm.aai.nameOfAplicant"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.addressOfApplicant" for="field_addressOfApplicant">Address Of Applicant</label><input type="text" class="form-control" name="addressOfApplicant" id="field_addressOfApplicant" ng-model="vm.aai.addressOfApplicant"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.mobile_no" for="field_mobile_no">Mobile No</label><input type="text" class="form-control" name="mobile_no" id="field_mobile_no" ng-model="vm.aai.mobile_no"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.email_id" for="field_email_id">Email Id</label><input type="text" class="form-control" name="email_id" id="field_email_id" ng-model="vm.aai.email_id"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.nameOfOwner" for="field_nameOfOwner">Name Of Owner</label><input type="text" class="form-control" name="nameOfOwner" id="field_nameOfOwner" ng-model="vm.aai.nameOfOwner"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.addressOfCommunication" for="field_addressOfCommunication">Address Of Communication</label><input type="text" class="form-control" name="addressOfCommunication" id="field_addressOfCommunication" ng-model="vm.aai.addressOfCommunication"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.typeOfStructure" for="field_typeOfStructure">Type Of Structure</label><input type="text" class="form-control" name="typeOfStructure" id="field_typeOfStructure" ng-model="vm.aai.typeOfStructure"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.usesOfStructure" for="field_usesOfStructure">Uses Of Structure</label><input type="text" class="form-control" name="usesOfStructure" id="field_usesOfStructure" ng-model="vm.aai.usesOfStructure"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.siteDescription" for="field_siteDescription">Site Description</label><input type="text" class="form-control" name="siteDescription" id="field_siteDescription" ng-model="vm.aai.siteDescription"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.sizeOfPlot" for="field_sizeOfPlot">Size Of Plot</label><input type="text" class="form-control" name="sizeOfPlot" id="field_sizeOfPlot" ng-model="vm.aai.sizeOfPlot"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.state" for="field_state">State</label><input type="text" class="form-control" name="state" id="field_state" ng-model="vm.aai.state"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.aai.city"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.areaName" for="field_areaName">Area Name</label><input type="text" class="form-control" name="areaName" id="field_areaName" ng-model="vm.aai.areaName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.latitude1" for="field_latitude1">Latitude 1</label><input type="text" class="form-control" name="latitude1" id="field_latitude1" ng-model="vm.aai.latitude1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.latitude2" for="field_latitude2">Latitude 2</label><input type="text" class="form-control" name="latitude2" id="field_latitude2" ng-model="vm.aai.latitude2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.latitude3" for="field_latitude3">Latitude 3</label><input type="text" class="form-control" name="latitude3" id="field_latitude3" ng-model="vm.aai.latitude3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.longitude1" for="field_longitude1">Longitude 1</label><input type="text" class="form-control" name="longitude1" id="field_longitude1" ng-model="vm.aai.longitude1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.longitude2" for="field_longitude2">Longitude 2</label><input type="text" class="form-control" name="longitude2" id="field_longitude2" ng-model="vm.aai.longitude2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.longitude3" for="field_longitude3">Longitude 3</label><input type="text" class="form-control" name="longitude3" id="field_longitude3" ng-model="vm.aai.longitude3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.siteElevation" for="field_siteElevation">Site Elevation</label><input type="text" class="form-control" name="siteElevation" id="field_siteElevation" ng-model="vm.aai.siteElevation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.buildingHeight" for="field_buildingHeight">Building Height</label><input type="text" class="form-control" name="buildingHeight" id="field_buildingHeight" ng-model="vm.aai.buildingHeight"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.maxSiteElevation" for="field_maxSiteElevation">Max Site Elevation</label><input type="text" class="form-control" name="maxSiteElevation" id="field_maxSiteElevation" ng-model="vm.aai.maxSiteElevation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.question1" for="field_question1">Question 1</label><input type="text" class="form-control" name="question1" id="field_question1" ng-model="vm.aai.question1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.question2" for="field_question2">Question 2</label><input type="text" class="form-control" name="question2" id="field_question2" ng-model="vm.aai.question2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.aai.question3" for="field_question3">Question 3</label><input type="text" class="form-control" name="question3" id="field_question3" ng-model="vm.aai.question3"></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.aai.file1" for="field_file1">File 1</label>--><!--<input type="text" class="form-control" name="file1" id="field_file1"--><!--ng-model="vm.aai.file1"--><!--/>--><!--</div>--></div><div class="modal-footer"><!--<button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">--><!--<span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span>--><!--</button>--> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary" data-toggle="modal" data-target="#aaimodal">Save & Continue</button></div></form><div id="aaimodal" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Is the proposed construction site falls in limit of any centrally protected monument?</h4></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal" ui-sref="nma-state({CPid: vm.id})">Yes</button> <button type="button" class="btn btn-success" data-dismiss="modal" ui-sref="ffs">No</button></div></div></div></div></div>');
$templateCache.put('app/entities/aai/aais.html','<div><h2 data-translate="investhryApp.aai.home.title">Aais</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="aai.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.aai.home.createLabel">Create new Aai</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.aai.height_clearance">Height Clearance</span></th><th><span data-translate="investhryApp.aai.nameOfAplicant">Name Of Aplicant</span></th><th><span data-translate="investhryApp.aai.addressOfApplicant">Address Of Applicant</span></th><th><span data-translate="investhryApp.aai.mobile_no">Mobile No</span></th><th><span data-translate="investhryApp.aai.email_id">Email Id</span></th><th><span data-translate="investhryApp.aai.nameOfOwner">Name Of Owner</span></th><th><span data-translate="investhryApp.aai.addressOfCommunication">Address Of Communication</span></th><th><span data-translate="investhryApp.aai.typeOfStructure">Type Of Structure</span></th><th><span data-translate="investhryApp.aai.usesOfStructure">Uses Of Structure</span></th><th><span data-translate="investhryApp.aai.siteDescription">Site Description</span></th><th><span data-translate="investhryApp.aai.sizeOfPlot">Size Of Plot</span></th><th><span data-translate="investhryApp.aai.state">State</span></th><th><span data-translate="investhryApp.aai.areaName">Area Name</span></th><th><span data-translate="investhryApp.aai.latitude1">Latitude 1</span></th><th><span data-translate="investhryApp.aai.latitude2">Latitude 2</span></th><th><span data-translate="investhryApp.aai.latitude3">Latitude 3</span></th><th><span data-translate="investhryApp.aai.longitude1">Longitude 1</span></th><th><span data-translate="investhryApp.aai.longitude2">Longitude 2</span></th><th><span data-translate="investhryApp.aai.longitude3">Longitude 3</span></th><th><span data-translate="investhryApp.aai.siteElevation">Site Elevation</span></th><th><span data-translate="investhryApp.aai.buildingHeight">Building Height</span></th><th><span data-translate="investhryApp.aai.maxSiteElevation">Max Site Elevation</span></th><th><span data-translate="investhryApp.aai.question1">Question 1</span></th><th><span data-translate="investhryApp.aai.question2">Question 2</span></th><th><span data-translate="investhryApp.aai.question3">Question 3</span></th><th><span data-translate="investhryApp.aai.file1">File 1</span></th><th><span data-translate="investhryApp.aai.city">City</span></th><th></th></tr></thead><tbody><tr ng-repeat="aai in vm.aais track by aai.id"><td><a ui-sref="aai-detail({id:aai.id})">{{aai.id}}</a></td><td>{{aai.height_clearance}}</td><td>{{aai.nameOfAplicant}}</td><td>{{aai.addressOfApplicant}}</td><td>{{aai.mobile_no}}</td><td>{{aai.email_id}}</td><td>{{aai.nameOfOwner}}</td><td>{{aai.addressOfCommunication}}</td><td>{{aai.typeOfStructure}}</td><td>{{aai.usesOfStructure}}</td><td>{{aai.siteDescription}}</td><td>{{aai.sizeOfPlot}}</td><td>{{aai.state}}</td><td>{{aai.areaName}}</td><td>{{aai.latitude1}}</td><td>{{aai.latitude2}}</td><td>{{aai.latitude3}}</td><td>{{aai.longitude1}}</td><td>{{aai.longitude2}}</td><td>{{aai.longitude3}}</td><td>{{aai.siteElevation}}</td><td>{{aai.buildingHeight}}</td><td>{{aai.maxSiteElevation}}</td><td>{{aai.question1}}</td><td>{{aai.question2}}</td><td>{{aai.question3}}</td><td>{{aai.file1}}</td><td>{{aai.city}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="aai-detail({id:aai.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="aai.edit({id:aai.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="aai.delete({id:aai.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/above-ground/above-ground-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.above_ground.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.above_ground.delete.question" translate-values="{id: \'{{vm.above_ground.id}}\'}">Are you sure you want to delete this Above Ground?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/above-ground/above-ground-detail.html','<div><h2><span data-translate="investhryApp.above_ground.detail.title">Above Ground</span> {{vm.above_ground.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.above_ground.name_applicant">Name Applicant</span></dt><dd><span>{{vm.above_ground.name_applicant}}</span></dd><dt><span data-translate="investhryApp.above_ground.registered_address">Registered Address</span></dt><dd><span>{{vm.above_ground.registered_address}}</span></dd><dt><span data-translate="investhryApp.above_ground.har_office_address">Har Office Address</span></dt><dd><span>{{vm.above_ground.har_office_address}}</span></dd><dt><span data-translate="investhryApp.above_ground.designation_auth_person">Designation Auth Person</span></dt><dd><span>{{vm.above_ground.designation_auth_person}}</span></dd><dt><span data-translate="investhryApp.above_ground.phone_auth_person">Phone Auth Person</span></dt><dd><span>{{vm.above_ground.phone_auth_person}}</span></dd><dt><span data-translate="investhryApp.above_ground.email_auth_person">Email Auth Person</span></dt><dd><span>{{vm.above_ground.email_auth_person}}</span></dd><dt><span data-translate="investhryApp.above_ground.extent">Extent</span></dt><dd><span>{{vm.above_ground.extent}}</span></dd><dt><span data-translate="investhryApp.above_ground.address_line_1">Address Line 1</span></dt><dd><span>{{vm.above_ground.address_line_1}}</span></dd><dt><span data-translate="investhryApp.above_ground.address_line_2">Address Line 2</span></dt><dd><span>{{vm.above_ground.address_line_2}}</span></dd><dt><span data-translate="investhryApp.above_ground.address_line_3">Address Line 3</span></dt><dd><span>{{vm.above_ground.address_line_3}}</span></dd><dt><span data-translate="investhryApp.above_ground.address_line_4">Address Line 4</span></dt><dd><span>{{vm.above_ground.address_line_4}}</span></dd><dt><span data-translate="investhryApp.above_ground.tehsil">Tehsil</span></dt><dd><span>{{vm.above_ground.tehsil}}</span></dd><dt><span data-translate="investhryApp.above_ground.district">District</span></dt><dd><span>{{vm.above_ground.district}}</span></dd><dt><span data-translate="investhryApp.above_ground.latitude_longitude">Latitude Longitude</span></dt><dd><span>{{vm.above_ground.latitude_longitude}}</span></dd><dt><span data-translate="investhryApp.above_ground.name_auth_person">Name Auth Person</span></dt><dd><span>{{vm.above_ground.name_auth_person}}</span></dd><dt><span data-translate="investhryApp.above_ground.zone_area">Zone Area</span></dt><dd><span>{{vm.above_ground.zone_area}}</span></dd><dt><span data-translate="investhryApp.above_ground.owner_name">Owner Name</span></dt><dd><span>{{vm.above_ground.owner_name}}</span></dd><dt><span data-translate="investhryApp.above_ground.owner_address">Owner Address</span></dt><dd><span>{{vm.above_ground.owner_address}}</span></dd><dt><span data-translate="investhryApp.above_ground.tower_height">Tower Height</span></dt><dd><span>{{vm.above_ground.tower_height}}</span></dd><dt><span data-translate="investhryApp.above_ground.tower_weight">Tower Weight</span></dt><dd><span>{{vm.above_ground.tower_weight}}</span></dd><dt><span data-translate="investhryApp.above_ground.tower_type1">Tower Type 1</span></dt><dd><span>{{vm.above_ground.tower_type1}}</span></dd><dt><span data-translate="investhryApp.above_ground.tower_type2">Tower Type 2</span></dt><dd><span>{{vm.above_ground.tower_type2}}</span></dd><dt><span data-translate="investhryApp.above_ground.tower_type3">Tower Type 3</span></dt><dd><span>{{vm.above_ground.tower_type3}}</span></dd><dt><span data-translate="investhryApp.above_ground.tower_antena_no">Tower Antena No</span></dt><dd><span>{{vm.above_ground.tower_antena_no}}</span></dd><dt><span data-translate="investhryApp.above_ground.tower_lat_long">Tower Lat Long</span></dt><dd><span>{{vm.above_ground.tower_lat_long}}</span></dd><dt><span data-translate="investhryApp.above_ground.other_info1">Other Info 1</span></dt><dd><span>{{vm.above_ground.other_info1}}</span></dd><dt><span data-translate="investhryApp.above_ground.other_info2">Other Info 2</span></dt><dd><span>{{vm.above_ground.other_info2}}</span></dd><dt><span data-translate="investhryApp.above_ground.other_info3">Other Info 3</span></dt><dd><span>{{vm.above_ground.other_info3}}</span></dd><dt><span data-translate="investhryApp.above_ground.other_info4">Other Info 4</span></dt><dd><span>{{vm.above_ground.other_info4}}</span></dd><dt><span data-translate="investhryApp.above_ground.other_info5">Other Info 5</span></dt><dd><span>{{vm.above_ground.other_info5}}</span></dd><dt><span data-translate="investhryApp.above_ground.other_info6">Other Info 6</span></dt><dd><span>{{vm.above_ground.other_info6}}</span></dd><dt><span data-translate="investhryApp.above_ground.fee_details">Fee Details</span></dt><dd><span>{{vm.above_ground.fee_details}}</span></dd><dt><span data-translate="investhryApp.above_ground.document1">Document 1</span></dt><dd><span>{{vm.above_ground.document1}}</span></dd><dt><span data-translate="investhryApp.above_ground.document2">Document 2</span></dt><dd><span>{{vm.above_ground.document2}}</span></dd><dt><span data-translate="investhryApp.above_ground.document3">Document 3</span></dt><dd><span>{{vm.above_ground.document3}}</span></dd><dt><span data-translate="investhryApp.above_ground.document4">Document 4</span></dt><dd><span>{{vm.above_ground.document4}}</span></dd><dt><span data-translate="investhryApp.above_ground.document5">Document 5</span></dt><dd><span>{{vm.above_ground.document5}}</span></dd><dt><span data-translate="investhryApp.above_ground.document6">Document 6</span></dt><dd><span>{{vm.above_ground.document6}}</span></dd><dt><span data-translate="investhryApp.above_ground.document7">Document 7</span></dt><dd><span>{{vm.above_ground.document7}}</span></dd><dt><span data-translate="investhryApp.above_ground.document8">Document 8</span></dt><dd><span>{{vm.above_ground.document8}}</span></dd><dt><span data-translate="investhryApp.above_ground.document9">Document 9</span></dt><dd><span>{{vm.above_ground.document9}}</span></dd><dt><span data-translate="investhryApp.above_ground.document10">Document 10</span></dt><dd><span>{{vm.above_ground.document10}}</span></dd><dt><span data-translate="investhryApp.above_ground.document11">Document 11</span></dt><dd><span>{{vm.above_ground.document11}}</span></dd><dt><span data-translate="investhryApp.above_ground.other_document1">Other Document 1</span></dt><dd><span>{{vm.above_ground.other_document1}}</span></dd><dt><span data-translate="investhryApp.above_ground.other_document2">Other Document 2</span></dt><dd><span>{{vm.above_ground.other_document2}}</span></dd><dt><span data-translate="investhryApp.above_ground.other_document3">Other Document 3</span></dt><dd><span>{{vm.above_ground.other_document3}}</span></dd><dt><span data-translate="investhryApp.above_ground.other_document4">Other Document 4</span></dt><dd><span>{{vm.above_ground.other_document4}}</span></dd><dt><span data-translate="investhryApp.above_ground.other_document5">Other Document 5</span></dt><dd><span>{{vm.above_ground.other_document5}}</span></dd><dt><span data-translate="investhryApp.above_ground.isfullyfilled">Isfullyfilled</span></dt><dd><span>{{vm.above_ground.isfullyfilled}}</span></dd><dt><span data-translate="investhryApp.above_ground.status">Status</span></dt><dd><span>{{vm.above_ground.status}}</span></dd><dt><span data-translate="investhryApp.above_ground.isforwardedtodio">Isforwardedtodio</span></dt><dd><span>{{vm.above_ground.isforwardedtodio}}</span></dd><dt><span data-translate="investhryApp.above_ground.isforwardedtodept">Isforwardedtodept</span></dt><dd><span>{{vm.above_ground.isforwardedtodept}}</span></dd><dt><span data-translate="investhryApp.above_ground.isforwardedtodc">Isforwardedtodc</span></dt><dd><span>{{vm.above_ground.isforwardedtodc}}</span></dd><dt><span data-translate="investhryApp.above_ground.clearancefile1">Clearancefile 1</span></dt><dd><span>{{vm.above_ground.clearancefile1}}</span></dd><dt><span data-translate="investhryApp.above_ground.clearancefile2">Clearancefile 2</span></dt><dd><span>{{vm.above_ground.clearancefile2}}</span></dd><dt><span data-translate="investhryApp.above_ground.clearancefile3">Clearancefile 3</span></dt><dd><span>{{vm.above_ground.clearancefile3}}</span></dd><dt><span data-translate="investhryApp.above_ground.created_by">Created By</span></dt><dd><span>{{vm.above_ground.created_by}}</span></dd><dt><span data-translate="investhryApp.above_ground.created_on">Created On</span></dt><dd><span>{{vm.above_ground.created_on | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.above_ground.isexisting">Isexisting</span></dt><dd><span>{{vm.above_ground.isexisting}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="above-ground-detail.edit({id:vm.above_ground.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/above-ground/above-ground-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAbove_groundLabel" data-translate="investhryApp.above_ground.home.createOrEditLabel">Create or edit a Above Ground</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.above_ground.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.above_ground.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.name_applicant" for="field_name_applicant">Name Applicant</label><input type="text" class="form-control" name="name_applicant" id="field_name_applicant" ng-model="vm.above_ground.name_applicant" required><div ng-show="editForm.name_applicant.$invalid"><p class="help-block" ng-show="editForm.name_applicant.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.registered_address" for="field_registered_address">Registered Address</label><input type="text" class="form-control" name="registered_address" id="field_registered_address" ng-model="vm.above_ground.registered_address"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.har_office_address" for="field_har_office_address">Har Office Address</label><input type="text" class="form-control" name="har_office_address" id="field_har_office_address" ng-model="vm.above_ground.har_office_address"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.designation_auth_person" for="field_designation_auth_person">Designation Auth Person</label><input type="text" class="form-control" name="designation_auth_person" id="field_designation_auth_person" ng-model="vm.above_ground.designation_auth_person"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.phone_auth_person" for="field_phone_auth_person">Phone Auth Person</label><input type="text" class="form-control" name="phone_auth_person" id="field_phone_auth_person" ng-model="vm.above_ground.phone_auth_person"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.email_auth_person" for="field_email_auth_person">Email Auth Person</label><input type="text" class="form-control" name="email_auth_person" id="field_email_auth_person" ng-model="vm.above_ground.email_auth_person"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.extent" for="field_extent">Extent</label><input type="text" class="form-control" name="extent" id="field_extent" ng-model="vm.above_ground.extent"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.address_line_1" for="field_address_line_1">Address Line 1</label><input type="text" class="form-control" name="address_line_1" id="field_address_line_1" ng-model="vm.above_ground.address_line_1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.address_line_2" for="field_address_line_2">Address Line 2</label><input type="text" class="form-control" name="address_line_2" id="field_address_line_2" ng-model="vm.above_ground.address_line_2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.address_line_3" for="field_address_line_3">Address Line 3</label><input type="text" class="form-control" name="address_line_3" id="field_address_line_3" ng-model="vm.above_ground.address_line_3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.address_line_4" for="field_address_line_4">Address Line 4</label><input type="text" class="form-control" name="address_line_4" id="field_address_line_4" ng-model="vm.above_ground.address_line_4"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.tehsil" for="field_tehsil">Tehsil</label><input type="text" class="form-control" name="tehsil" id="field_tehsil" ng-model="vm.above_ground.tehsil"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.above_ground.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.latitude_longitude" for="field_latitude_longitude">Latitude Longitude</label><input type="text" class="form-control" name="latitude_longitude" id="field_latitude_longitude" ng-model="vm.above_ground.latitude_longitude"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.name_auth_person" for="field_name_auth_person">Name Auth Person</label><input type="text" class="form-control" name="name_auth_person" id="field_name_auth_person" ng-model="vm.above_ground.name_auth_person"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.zone_area" for="field_zone_area">Zone Area</label><input type="text" class="form-control" name="zone_area" id="field_zone_area" ng-model="vm.above_ground.zone_area"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.owner_name" for="field_owner_name">Owner Name</label><input type="text" class="form-control" name="owner_name" id="field_owner_name" ng-model="vm.above_ground.owner_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.owner_address" for="field_owner_address">Owner Address</label><input type="text" class="form-control" name="owner_address" id="field_owner_address" ng-model="vm.above_ground.owner_address"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.tower_height" for="field_tower_height">Tower Height</label><input type="text" class="form-control" name="tower_height" id="field_tower_height" ng-model="vm.above_ground.tower_height"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.tower_weight" for="field_tower_weight">Tower Weight</label><input type="text" class="form-control" name="tower_weight" id="field_tower_weight" ng-model="vm.above_ground.tower_weight"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.tower_type1" for="field_tower_type1">Tower Type 1</label><input type="text" class="form-control" name="tower_type1" id="field_tower_type1" ng-model="vm.above_ground.tower_type1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.tower_type2" for="field_tower_type2">Tower Type 2</label><input type="text" class="form-control" name="tower_type2" id="field_tower_type2" ng-model="vm.above_ground.tower_type2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.tower_type3" for="field_tower_type3">Tower Type 3</label><input type="text" class="form-control" name="tower_type3" id="field_tower_type3" ng-model="vm.above_ground.tower_type3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.tower_antena_no" for="field_tower_antena_no">Tower Antena No</label><input type="text" class="form-control" name="tower_antena_no" id="field_tower_antena_no" ng-model="vm.above_ground.tower_antena_no"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.tower_lat_long" for="field_tower_lat_long">Tower Lat Long</label><input type="text" class="form-control" name="tower_lat_long" id="field_tower_lat_long" ng-model="vm.above_ground.tower_lat_long"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.other_info1" for="field_other_info1">Other Info 1</label><input type="text" class="form-control" name="other_info1" id="field_other_info1" ng-model="vm.above_ground.other_info1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.other_info2" for="field_other_info2">Other Info 2</label><input type="text" class="form-control" name="other_info2" id="field_other_info2" ng-model="vm.above_ground.other_info2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.other_info3" for="field_other_info3">Other Info 3</label><input type="text" class="form-control" name="other_info3" id="field_other_info3" ng-model="vm.above_ground.other_info3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.other_info4" for="field_other_info4">Other Info 4</label><input type="text" class="form-control" name="other_info4" id="field_other_info4" ng-model="vm.above_ground.other_info4"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.other_info5" for="field_other_info5">Other Info 5</label><input type="text" class="form-control" name="other_info5" id="field_other_info5" ng-model="vm.above_ground.other_info5"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.other_info6" for="field_other_info6">Other Info 6</label><input type="text" class="form-control" name="other_info6" id="field_other_info6" ng-model="vm.above_ground.other_info6"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.fee_details" for="field_fee_details">Fee Details</label><input type="text" class="form-control" name="fee_details" id="field_fee_details" ng-model="vm.above_ground.fee_details"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.document1" for="field_document1">Document 1</label><input type="text" class="form-control" name="document1" id="field_document1" ng-model="vm.above_ground.document1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.document2" for="field_document2">Document 2</label><input type="text" class="form-control" name="document2" id="field_document2" ng-model="vm.above_ground.document2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.document3" for="field_document3">Document 3</label><input type="text" class="form-control" name="document3" id="field_document3" ng-model="vm.above_ground.document3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.document4" for="field_document4">Document 4</label><input type="text" class="form-control" name="document4" id="field_document4" ng-model="vm.above_ground.document4"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.document5" for="field_document5">Document 5</label><input type="text" class="form-control" name="document5" id="field_document5" ng-model="vm.above_ground.document5"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.document6" for="field_document6">Document 6</label><input type="text" class="form-control" name="document6" id="field_document6" ng-model="vm.above_ground.document6"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.document7" for="field_document7">Document 7</label><input type="text" class="form-control" name="document7" id="field_document7" ng-model="vm.above_ground.document7"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.document8" for="field_document8">Document 8</label><input type="text" class="form-control" name="document8" id="field_document8" ng-model="vm.above_ground.document8"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.document9" for="field_document9">Document 9</label><input type="text" class="form-control" name="document9" id="field_document9" ng-model="vm.above_ground.document9"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.document10" for="field_document10">Document 10</label><input type="text" class="form-control" name="document10" id="field_document10" ng-model="vm.above_ground.document10"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.document11" for="field_document11">Document 11</label><input type="text" class="form-control" name="document11" id="field_document11" ng-model="vm.above_ground.document11"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.other_document1" for="field_other_document1">Other Document 1</label><input type="text" class="form-control" name="other_document1" id="field_other_document1" ng-model="vm.above_ground.other_document1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.other_document2" for="field_other_document2">Other Document 2</label><input type="text" class="form-control" name="other_document2" id="field_other_document2" ng-model="vm.above_ground.other_document2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.other_document3" for="field_other_document3">Other Document 3</label><input type="text" class="form-control" name="other_document3" id="field_other_document3" ng-model="vm.above_ground.other_document3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.other_document4" for="field_other_document4">Other Document 4</label><input type="text" class="form-control" name="other_document4" id="field_other_document4" ng-model="vm.above_ground.other_document4"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.other_document5" for="field_other_document5">Other Document 5</label><input type="text" class="form-control" name="other_document5" id="field_other_document5" ng-model="vm.above_ground.other_document5"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.isfullyfilled" for="field_isfullyfilled">Isfullyfilled</label><input type="checkbox" class="form-control" name="isfullyfilled" id="field_isfullyfilled" ng-model="vm.above_ground.isfullyfilled"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.above_ground.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.isforwardedtodio" for="field_isforwardedtodio">Isforwardedtodio</label><input type="checkbox" class="form-control" name="isforwardedtodio" id="field_isforwardedtodio" ng-model="vm.above_ground.isforwardedtodio"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.isforwardedtodept" for="field_isforwardedtodept">Isforwardedtodept</label><input type="checkbox" class="form-control" name="isforwardedtodept" id="field_isforwardedtodept" ng-model="vm.above_ground.isforwardedtodept"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.isforwardedtodc" for="field_isforwardedtodc">Isforwardedtodc</label><input type="checkbox" class="form-control" name="isforwardedtodc" id="field_isforwardedtodc" ng-model="vm.above_ground.isforwardedtodc"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.clearancefile1" for="field_clearancefile1">Clearancefile 1</label><input type="text" class="form-control" name="clearancefile1" id="field_clearancefile1" ng-model="vm.above_ground.clearancefile1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.clearancefile2" for="field_clearancefile2">Clearancefile 2</label><input type="text" class="form-control" name="clearancefile2" id="field_clearancefile2" ng-model="vm.above_ground.clearancefile2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.clearancefile3" for="field_clearancefile3">Clearancefile 3</label><input type="text" class="form-control" name="clearancefile3" id="field_clearancefile3" ng-model="vm.above_ground.clearancefile3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.created_by" for="field_created_by">Created By</label><input type="text" class="form-control" name="created_by" id="field_created_by" ng-model="vm.above_ground.created_by"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.created_on" for="field_created_on">Created On</label><div class="input-group"><input id="field_created_on" type="text" class="form-control" name="created_on" uib-datepicker-popup="{{dateformat}}" ng-model="vm.above_ground.created_on" is-open="vm.datePickerOpenStatus.created_on"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'created_on\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.above_ground.isexisting" for="field_isexisting">Isexisting</label><input type="checkbox" class="form-control" name="isexisting" id="field_isexisting" ng-model="vm.above_ground.isexisting"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/above-ground/above-grounds.html','<div><h2 data-translate="investhryApp.above_ground.home.title">Above Grounds</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="above-ground.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.above_ground.home.createLabel">Create new Above Ground</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.above_ground.name_applicant">Name Applicant</span></th><th><span data-translate="investhryApp.above_ground.registered_address">Registered Address</span></th><th><span data-translate="investhryApp.above_ground.har_office_address">Har Office Address</span></th><th><span data-translate="investhryApp.above_ground.designation_auth_person">Designation Auth Person</span></th><th><span data-translate="investhryApp.above_ground.phone_auth_person">Phone Auth Person</span></th><th><span data-translate="investhryApp.above_ground.email_auth_person">Email Auth Person</span></th><th><span data-translate="investhryApp.above_ground.extent">Extent</span></th><th><span data-translate="investhryApp.above_ground.address_line_1">Address Line 1</span></th><th><span data-translate="investhryApp.above_ground.address_line_2">Address Line 2</span></th><th><span data-translate="investhryApp.above_ground.address_line_3">Address Line 3</span></th><th><span data-translate="investhryApp.above_ground.address_line_4">Address Line 4</span></th><th><span data-translate="investhryApp.above_ground.tehsil">Tehsil</span></th><th><span data-translate="investhryApp.above_ground.district">District</span></th><th><span data-translate="investhryApp.above_ground.latitude_longitude">Latitude Longitude</span></th><th><span data-translate="investhryApp.above_ground.name_auth_person">Name Auth Person</span></th><th><span data-translate="investhryApp.above_ground.zone_area">Zone Area</span></th><th><span data-translate="investhryApp.above_ground.owner_name">Owner Name</span></th><th><span data-translate="investhryApp.above_ground.owner_address">Owner Address</span></th><th><span data-translate="investhryApp.above_ground.tower_height">Tower Height</span></th><th><span data-translate="investhryApp.above_ground.tower_weight">Tower Weight</span></th><th><span data-translate="investhryApp.above_ground.tower_type1">Tower Type 1</span></th><th><span data-translate="investhryApp.above_ground.tower_type2">Tower Type 2</span></th><th><span data-translate="investhryApp.above_ground.tower_type3">Tower Type 3</span></th><th><span data-translate="investhryApp.above_ground.tower_antena_no">Tower Antena No</span></th><th><span data-translate="investhryApp.above_ground.tower_lat_long">Tower Lat Long</span></th><th><span data-translate="investhryApp.above_ground.other_info1">Other Info 1</span></th><th><span data-translate="investhryApp.above_ground.other_info2">Other Info 2</span></th><th><span data-translate="investhryApp.above_ground.other_info3">Other Info 3</span></th><th><span data-translate="investhryApp.above_ground.other_info4">Other Info 4</span></th><th><span data-translate="investhryApp.above_ground.other_info5">Other Info 5</span></th><th><span data-translate="investhryApp.above_ground.other_info6">Other Info 6</span></th><th><span data-translate="investhryApp.above_ground.fee_details">Fee Details</span></th><th><span data-translate="investhryApp.above_ground.document1">Document 1</span></th><th><span data-translate="investhryApp.above_ground.document2">Document 2</span></th><th><span data-translate="investhryApp.above_ground.document3">Document 3</span></th><th><span data-translate="investhryApp.above_ground.document4">Document 4</span></th><th><span data-translate="investhryApp.above_ground.document5">Document 5</span></th><th><span data-translate="investhryApp.above_ground.document6">Document 6</span></th><th><span data-translate="investhryApp.above_ground.document7">Document 7</span></th><th><span data-translate="investhryApp.above_ground.document8">Document 8</span></th><th><span data-translate="investhryApp.above_ground.document9">Document 9</span></th><th><span data-translate="investhryApp.above_ground.document10">Document 10</span></th><th><span data-translate="investhryApp.above_ground.document11">Document 11</span></th><th><span data-translate="investhryApp.above_ground.other_document1">Other Document 1</span></th><th><span data-translate="investhryApp.above_ground.other_document2">Other Document 2</span></th><th><span data-translate="investhryApp.above_ground.other_document3">Other Document 3</span></th><th><span data-translate="investhryApp.above_ground.other_document4">Other Document 4</span></th><th><span data-translate="investhryApp.above_ground.other_document5">Other Document 5</span></th><th><span data-translate="investhryApp.above_ground.isfullyfilled">Isfullyfilled</span></th><th><span data-translate="investhryApp.above_ground.status">Status</span></th><th><span data-translate="investhryApp.above_ground.isforwardedtodio">Isforwardedtodio</span></th><th><span data-translate="investhryApp.above_ground.isforwardedtodept">Isforwardedtodept</span></th><th><span data-translate="investhryApp.above_ground.isforwardedtodc">Isforwardedtodc</span></th><th><span data-translate="investhryApp.above_ground.clearancefile1">Clearancefile 1</span></th><th><span data-translate="investhryApp.above_ground.clearancefile2">Clearancefile 2</span></th><th><span data-translate="investhryApp.above_ground.clearancefile3">Clearancefile 3</span></th><th><span data-translate="investhryApp.above_ground.created_by">Created By</span></th><th><span data-translate="investhryApp.above_ground.created_on">Created On</span></th><th><span data-translate="investhryApp.above_ground.isexisting">Isexisting</span></th><th></th></tr></thead><tbody><tr ng-repeat="above_ground in vm.above_grounds track by above_ground.id"><td><a ui-sref="above-ground-detail({id:above_ground.id})">{{above_ground.id}}</a></td><td>{{above_ground.name_applicant}}</td><td>{{above_ground.registered_address}}</td><td>{{above_ground.har_office_address}}</td><td>{{above_ground.designation_auth_person}}</td><td>{{above_ground.phone_auth_person}}</td><td>{{above_ground.email_auth_person}}</td><td>{{above_ground.extent}}</td><td>{{above_ground.address_line_1}}</td><td>{{above_ground.address_line_2}}</td><td>{{above_ground.address_line_3}}</td><td>{{above_ground.address_line_4}}</td><td>{{above_ground.tehsil}}</td><td>{{above_ground.district}}</td><td>{{above_ground.latitude_longitude}}</td><td>{{above_ground.name_auth_person}}</td><td>{{above_ground.zone_area}}</td><td>{{above_ground.owner_name}}</td><td>{{above_ground.owner_address}}</td><td>{{above_ground.tower_height}}</td><td>{{above_ground.tower_weight}}</td><td>{{above_ground.tower_type1}}</td><td>{{above_ground.tower_type2}}</td><td>{{above_ground.tower_type3}}</td><td>{{above_ground.tower_antena_no}}</td><td>{{above_ground.tower_lat_long}}</td><td>{{above_ground.other_info1}}</td><td>{{above_ground.other_info2}}</td><td>{{above_ground.other_info3}}</td><td>{{above_ground.other_info4}}</td><td>{{above_ground.other_info5}}</td><td>{{above_ground.other_info6}}</td><td>{{above_ground.fee_details}}</td><td>{{above_ground.document1}}</td><td>{{above_ground.document2}}</td><td>{{above_ground.document3}}</td><td>{{above_ground.document4}}</td><td>{{above_ground.document5}}</td><td>{{above_ground.document6}}</td><td>{{above_ground.document7}}</td><td>{{above_ground.document8}}</td><td>{{above_ground.document9}}</td><td>{{above_ground.document10}}</td><td>{{above_ground.document11}}</td><td>{{above_ground.other_document1}}</td><td>{{above_ground.other_document2}}</td><td>{{above_ground.other_document3}}</td><td>{{above_ground.other_document4}}</td><td>{{above_ground.other_document5}}</td><td>{{above_ground.isfullyfilled}}</td><td>{{above_ground.status}}</td><td>{{above_ground.isforwardedtodio}}</td><td>{{above_ground.isforwardedtodept}}</td><td>{{above_ground.isforwardedtodc}}</td><td>{{above_ground.clearancefile1}}</td><td>{{above_ground.clearancefile2}}</td><td>{{above_ground.clearancefile3}}</td><td>{{above_ground.created_by}}</td><td>{{above_ground.created_on | date:\'mediumDate\'}}</td><td>{{above_ground.isexisting}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="above-ground-detail({id:above_ground.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="above-ground.edit({id:above_ground.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="above-ground.delete({id:above_ground.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/acknowledgements/acknowledgements-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.acknowledgements.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.acknowledgements.delete.question" translate-values="{id: \'{{vm.acknowledgements.id}}\'}">Are you sure you want to delete this Acknowledgements?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/acknowledgements/acknowledgements-detail.html','<div><h2><span data-translate="investhryApp.acknowledgements.detail.title">Acknowledgements</span> {{vm.acknowledgements.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.acknowledgements.source">Source</span></dt><dd><span>{{vm.acknowledgements.source}}</span></dd><dt><span data-translate="investhryApp.acknowledgements.content">Content</span></dt><dd><span>{{vm.acknowledgements.content}}</span></dd><dt><span data-translate="investhryApp.acknowledgements.lastactiontime">Lastactiontime</span></dt><dd><span>{{vm.acknowledgements.lastactiontime | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.acknowledgements.error">Error</span></dt><dd><span>{{vm.acknowledgements.error}}</span></dd><dt><span data-translate="investhryApp.acknowledgements.isSent">Is Sent</span></dt><dd><span>{{vm.acknowledgements.isSent}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="acknowledgements-detail.edit({id:vm.acknowledgements.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/acknowledgements/acknowledgements-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAcknowledgementsLabel" data-translate="investhryApp.acknowledgements.home.createOrEditLabel">Create or edit a Acknowledgements</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.acknowledgements.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.acknowledgements.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.acknowledgements.source" for="field_source">Source</label><input type="text" class="form-control" name="source" id="field_source" ng-model="vm.acknowledgements.source"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.acknowledgements.content" for="field_content">Content</label><input type="text" class="form-control" name="content" id="field_content" ng-model="vm.acknowledgements.content"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.acknowledgements.lastactiontime" for="field_lastactiontime">Lastactiontime</label><div class="input-group"><input id="field_lastactiontime" type="text" class="form-control" name="lastactiontime" datetime-picker="{{dateformat}}" ng-model="vm.acknowledgements.lastactiontime" is-open="vm.datePickerOpenStatus.lastactiontime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastactiontime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.acknowledgements.error" for="field_error">Error</label><input type="text" class="form-control" name="error" id="field_error" ng-model="vm.acknowledgements.error"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.acknowledgements.isSent" for="field_isSent">Is Sent</label><input type="checkbox" class="form-control" name="isSent" id="field_isSent" ng-model="vm.acknowledgements.isSent"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/acknowledgements/acknowledgements.html','<div><h2 data-translate="investhryApp.acknowledgements.home.title">Acknowledgements</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="acknowledgements.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.acknowledgements.home.createLabel">Create new Acknowledgements</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.acknowledgements.source">Source</span></th><th><span data-translate="investhryApp.acknowledgements.content">Content</span></th><th><span data-translate="investhryApp.acknowledgements.lastactiontime">Lastactiontime</span></th><th><span data-translate="investhryApp.acknowledgements.error">Error</span></th><th><span data-translate="investhryApp.acknowledgements.isSent">Is Sent</span></th><th></th></tr></thead><tbody><tr ng-repeat="acknowledgements in vm.acknowledgements | orderBy: \'-lastactiontime\' | limitTo:vm.limit"><td><a ui-sref="acknowledgements-detail({id:acknowledgements.id})">{{acknowledgements.id}}</a></td><td>{{acknowledgements.source}}</td><td>{{acknowledgements.content}}</td><td>{{acknowledgements.lastactiontime | date:\'medium\'}}</td><td>{{acknowledgements.error}}</td><td>{{acknowledgements.isSent}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="acknowledgements-detail({id:acknowledgements.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="acknowledgements.edit({id:acknowledgements.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="acknowledgements.delete({id:acknowledgements.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="row"><div class="col-md-offset-2 col-md-1"><button class="btn btn-primary" ng-click="vm.incrementSize()" ng-disabled="vm.limit===vm.acknowledgements.length || vm.acknowledgements.length===0">More</button></div><div class="col-md-1"><button class="btn btn-primary" ng-click="vm.decrementSize()" ng-disabled="vm.limit===1000 || vm.acknowledgements.length===0">Less</button></div></div></div>');
$templateCache.put('app/entities/application-logs/application-logs-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.applicationLogs.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.applicationLogs.delete.question" translate-values="{id: \'{{vm.applicationLogs.id}}\'}">Are you sure you want to delete this Application Logs?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/application-logs/application-logs-detail.html','<div><h2><span data-translate="investhryApp.applicationLogs.detail.title">Application Logs</span> {{vm.applicationLogs.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.applicationLogs.user_role">User Role</span></dt><dd><span>{{vm.applicationLogs.user_role}}</span></dd><dt><span data-translate="investhryApp.applicationLogs.user_details">User Details</span></dt><dd><span>{{vm.applicationLogs.user_details}}</span></dd><dt><span data-translate="investhryApp.applicationLogs.path">Path</span></dt><dd><span>{{vm.applicationLogs.path}}</span></dd><dt><span data-translate="investhryApp.applicationLogs.requestBody">Request Body</span></dt><dd><span>{{vm.applicationLogs.requestBody}}</span></dd><dt><span data-translate="investhryApp.applicationLogs.responseBody">Response Body</span></dt><dd><span>{{vm.applicationLogs.responseBody}}</span></dd><dt><span data-translate="investhryApp.applicationLogs.status">Status</span></dt><dd><span>{{vm.applicationLogs.status}}</span></dd><dt><span data-translate="investhryApp.applicationLogs.params">Params</span></dt><dd><span>{{vm.applicationLogs.params}}</span></dd><dt><span data-translate="investhryApp.applicationLogs.header">Header</span></dt><dd><span>{{vm.applicationLogs.header}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="application-logs-detail.edit({id:vm.applicationLogs.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/application-logs/application-logs-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myApplicationLogsLabel" data-translate="investhryApp.applicationLogs.home.createOrEditLabel">Create or edit a Application Logs</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.applicationLogs.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.applicationLogs.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationLogs.user_role" for="field_user_role">User Role</label><input type="text" class="form-control" name="user_role" id="field_user_role" ng-model="vm.applicationLogs.user_role"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationLogs.user_details" for="field_user_details">User Details</label><input type="text" class="form-control" name="user_details" id="field_user_details" ng-model="vm.applicationLogs.user_details"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationLogs.path" for="field_path">Path</label><input type="text" class="form-control" name="path" id="field_path" ng-model="vm.applicationLogs.path"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationLogs.requestBody" for="field_requestBody">Request Body</label><input type="text" class="form-control" name="requestBody" id="field_requestBody" ng-model="vm.applicationLogs.requestBody"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationLogs.responseBody" for="field_responseBody">Response Body</label><input type="text" class="form-control" name="responseBody" id="field_responseBody" ng-model="vm.applicationLogs.responseBody"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationLogs.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.applicationLogs.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationLogs.params" for="field_params">Params</label><input type="text" class="form-control" name="params" id="field_params" ng-model="vm.applicationLogs.params"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationLogs.header" for="field_header">Header</label><input type="text" class="form-control" name="header" id="field_header" ng-model="vm.applicationLogs.header"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/application-logs/application-logs.html','<div><h2 data-translate="investhryApp.applicationLogs.home.title">Application Logs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="application-logs.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.applicationLogs.home.createLabel">Create new Application Logs</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.applicationLogs.user_role">User Role</span></th><th><span data-translate="investhryApp.applicationLogs.user_details">User Details</span></th><th><span data-translate="investhryApp.applicationLogs.path">Path</span></th><th><span data-translate="investhryApp.applicationLogs.requestBody">Request Body</span></th><th><span data-translate="investhryApp.applicationLogs.responseBody">Response Body</span></th><th><span data-translate="investhryApp.applicationLogs.status">Status</span></th><th><span data-translate="investhryApp.applicationLogs.params">Params</span></th><th><span data-translate="investhryApp.applicationLogs.header">Header</span></th><th><span>Method</span></th><th><span>Action Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="applicationLogs in vm.applicationLogs track by applicationLogs.id"><td><a ui-sref="application-logs-detail({id:applicationLogs.id})">{{applicationLogs.id}}</a></td><td>{{applicationLogs.user_role}}</td><td>{{applicationLogs.user_details}}</td><td>{{applicationLogs.path}}</td><td>{{applicationLogs.requestBody}}</td><td>{{applicationLogs.responseBody}}</td><td>{{applicationLogs.status}}</td><td>{{applicationLogs.params}}</td><td>{{applicationLogs.header}}</td><td>{{applicationLogs.method}}</td><td>{{applicationLogs.actionDate}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="application-logs-detail({id:applicationLogs.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="application-logs.edit({id:applicationLogs.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="application-logs.delete({id:applicationLogs.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/applicationstatus/applicationstatus-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.applicationstatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.applicationstatus.delete.question" translate-values="{id: \'{{vm.applicationstatus.id}}\'}">Are you sure you want to delete this Applicationstatus?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/applicationstatus/applicationstatus-detail.html','<div><h2><span data-translate="investhryApp.applicationstatus.detail.title">Applicationstatus</span> {{vm.applicationstatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.applicationstatus.department">Department</span></dt><dd><span>{{vm.applicationstatus.department}}</span></dd><dt><span data-translate="investhryApp.applicationstatus.applicationUniqueNumebr">Application Unique Numebr</span></dt><dd><span>{{vm.applicationstatus.applicationUniqueNumebr}}</span></dd><dt><span data-translate="investhryApp.applicationstatus.proximityStatus">Proximity Status</span></dt><dd><span>{{vm.applicationstatus.proximityStatus}}</span></dd><dt><span data-translate="investhryApp.applicationstatus.status">Status</span></dt><dd><span>{{vm.applicationstatus.status}}</span></dd><dt><span data-translate="investhryApp.applicationstatus.responseTime">Response Time</span></dt><dd><span>{{vm.applicationstatus.responseTime}}</span></dd><dt><span data-translate="investhryApp.applicationstatus.remarks">Remarks</span></dt><dd><span>{{vm.applicationstatus.remarks}}</span></dd><dt><span data-translate="investhryApp.applicationstatus.nocFileUrl">Noc File Url</span></dt><dd><span>{{vm.applicationstatus.nocFileUrl}}</span></dd><dt><span data-translate="investhryApp.applicationstatus.nocNumber">Noc Number</span></dt><dd><span>{{vm.applicationstatus.nocNumber}}</span></dd><dt><span data-translate="investhryApp.applicationstatus.fileName">File Name</span></dt><dd><span>{{vm.applicationstatus.fileName}}</span></dd><dt><span data-translate="investhryApp.applicationstatus.uniqueId">Unique Id</span></dt><dd><span>{{vm.applicationstatus.uniqueId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="applicationstatus-detail.edit({id:vm.applicationstatus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/applicationstatus/applicationstatus-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myApplicationstatusLabel" data-translate="investhryApp.applicationstatus.home.createOrEditLabel">Create or edit a Applicationstatus</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.applicationstatus.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.applicationstatus.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationstatus.department" for="field_department">Department</label><input type="text" class="form-control" name="department" id="field_department" ng-model="vm.applicationstatus.department"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationstatus.applicationUniqueNumebr" for="field_applicationUniqueNumebr">Application Unique Numebr</label><input type="text" class="form-control" name="applicationUniqueNumebr" id="field_applicationUniqueNumebr" ng-model="vm.applicationstatus.applicationUniqueNumebr"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationstatus.proximityStatus" for="field_proximityStatus">Proximity Status</label><input type="text" class="form-control" name="proximityStatus" id="field_proximityStatus" ng-model="vm.applicationstatus.proximityStatus"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationstatus.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.applicationstatus.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationstatus.responseTime" for="field_responseTime">Response Time</label><input type="text" class="form-control" name="responseTime" id="field_responseTime" ng-model="vm.applicationstatus.responseTime"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationstatus.remarks" for="field_remarks">Remarks</label><input type="text" class="form-control" name="remarks" id="field_remarks" ng-model="vm.applicationstatus.remarks"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationstatus.nocFileUrl" for="field_nocFileUrl">Noc File Url</label><input type="text" class="form-control" name="nocFileUrl" id="field_nocFileUrl" ng-model="vm.applicationstatus.nocFileUrl"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationstatus.nocNumber" for="field_nocNumber">Noc Number</label><input type="text" class="form-control" name="nocNumber" id="field_nocNumber" ng-model="vm.applicationstatus.nocNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationstatus.fileName" for="field_fileName">File Name</label><input type="text" class="form-control" name="fileName" id="field_fileName" ng-model="vm.applicationstatus.fileName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.applicationstatus.uniqueId" for="field_uniqueId">Unique Id</label><input type="text" class="form-control" name="uniqueId" id="field_uniqueId" ng-model="vm.applicationstatus.uniqueId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/applicationstatus/applicationstatuses.html','<div><h2 data-translate="investhryApp.applicationstatus.home.title">Applicationstatuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="applicationstatus.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.applicationstatus.home.createLabel">Create new Applicationstatus</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.applicationstatus.department">Department</span></th><th><span data-translate="investhryApp.applicationstatus.applicationUniqueNumebr">Application Unique Numebr</span></th><th><span data-translate="investhryApp.applicationstatus.proximityStatus">Proximity Status</span></th><th><span data-translate="investhryApp.applicationstatus.status">Status</span></th><th><span data-translate="investhryApp.applicationstatus.responseTime">Response Time</span></th><th><span data-translate="investhryApp.applicationstatus.remarks">Remarks</span></th><th><span data-translate="investhryApp.applicationstatus.nocFileUrl">Noc File Url</span></th><th><span data-translate="investhryApp.applicationstatus.nocNumber">Noc Number</span></th><th><span data-translate="investhryApp.applicationstatus.fileName">File Name</span></th><th><span data-translate="investhryApp.applicationstatus.uniqueId">Unique Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="applicationstatus in vm.applicationstatuses track by applicationstatus.id"><td><a ui-sref="applicationstatus-detail({id:applicationstatus.id})">{{applicationstatus.id}}</a></td><td>{{applicationstatus.department}}</td><td>{{applicationstatus.applicationUniqueNumebr}}</td><td>{{applicationstatus.proximityStatus}}</td><td>{{applicationstatus.status}}</td><td>{{applicationstatus.responseTime}}</td><td>{{applicationstatus.remarks}}</td><td>{{applicationstatus.nocFileUrl}}</td><td>{{applicationstatus.nocNumber}}</td><td>{{applicationstatus.fileName}}</td><td>{{applicationstatus.uniqueId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="applicationstatus-detail({id:applicationstatus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="applicationstatus.edit({id:applicationstatus.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="applicationstatus.delete({id:applicationstatus.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/applied-services/applied-services-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.appliedServices.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.appliedServices.delete.question" translate-values="{id: \'{{vm.appliedServices.id}}\'}">Are you sure you want to delete this Applied Services?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/applied-services/applied-services-detail.html','<div><h2><span data-translate="investhryApp.appliedServices.detail.title">Applied Services</span> {{vm.appliedServices.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.appliedServices.appliedDate">Applied Date</span></dt><dd><span>{{vm.appliedServices.appliedDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.appliedServices.serviceId">Service Id</span></dt><dd><span>{{vm.appliedServices.serviceId}}</span></dd><dt><span data-translate="investhryApp.appliedServices.ageing">Ageing</span></dt><dd><span>{{vm.appliedServices.ageing}}</span></dd><dt><span data-translate="investhryApp.appliedServices.status">Status</span></dt><dd><span>{{vm.appliedServices.status}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="applied-services-detail.edit({id:vm.appliedServices.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/applied-services/applied-services-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAppliedServicesLabel" data-translate="investhryApp.appliedServices.home.createOrEditLabel">Create or edit a Applied Services</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.appliedServices.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.appliedServices.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.appliedServices.appliedDate" for="field_appliedDate">Applied Date</label><div class="input-group"><input id="field_appliedDate" type="text" class="form-control" name="appliedDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.appliedServices.appliedDate" is-open="vm.datePickerOpenStatus.appliedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'appliedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.appliedServices.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.appliedServices.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.appliedServices.ageing" for="field_ageing">Ageing</label><input type="text" class="form-control" name="ageing" id="field_ageing" ng-model="vm.appliedServices.ageing"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.appliedServices.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.appliedServices.status"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/applied-services/applied-services.html','<div><h2 data-translate="investhryApp.appliedServices.home.title">Applied Services</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="applied-services.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.appliedServices.home.createLabel">Create new Applied Services</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.appliedServices.appliedDate">Applied Date</span></th><th><span data-translate="investhryApp.appliedServices.serviceId">Service Id</span></th><th><span data-translate="investhryApp.appliedServices.ageing">Ageing</span></th><th><span data-translate="investhryApp.appliedServices.status">Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="appliedServices in vm.appliedServices track by appliedServices.id"><td><a ui-sref="applied-services-detail({id:appliedServices.id})">{{appliedServices.id}}</a></td><td>{{appliedServices.appliedDate | date:\'mediumDate\'}}</td><td>{{appliedServices.serviceId}}</td><td>{{appliedServices.ageing}}</td><td>{{appliedServices.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="applied-services-detail({id:appliedServices.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="applied-services.edit({id:appliedServices.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="applied-services.delete({id:appliedServices.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/assign-field-officer-to-department/assign-field-officer-to-department-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.assignFieldOfficerToDepartment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.assignFieldOfficerToDepartment.delete.question" translate-values="{id: \'{{vm.assignFieldOfficerToDepartment.id}}\'}">Are you sure you want to delete this Assign Field Officer To Department?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/assign-field-officer-to-department/assign-field-officer-to-department-detail.html','<div><h2><span data-translate="investhryApp.assignFieldOfficerToDepartment.detail.title">Assign Field Officer To Department</span> {{vm.assignFieldOfficerToDepartment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.assignFieldOfficerToDepartment.departmentid">Departmentid</span></dt><dd><span>{{vm.assignFieldOfficerToDepartment.departmentid}}</span></dd><dt><span data-translate="investhryApp.assignFieldOfficerToDepartment.departmentname">Departmentname</span></dt><dd><span>{{vm.assignFieldOfficerToDepartment.departmentname}}</span></dd><dt><span data-translate="investhryApp.assignFieldOfficerToDepartment.fieldOfficerid">Field Officerid</span></dt><dd><span>{{vm.assignFieldOfficerToDepartment.fieldOfficerid}}</span></dd><dt><span data-translate="investhryApp.assignFieldOfficerToDepartment.fieldofficerlogin">Fieldofficerlogin</span></dt><dd><span>{{vm.assignFieldOfficerToDepartment.fieldofficerlogin}}</span></dd><dt><span data-translate="investhryApp.assignFieldOfficerToDepartment.fieldofficerdesignation">Fieldofficerdesignation</span></dt><dd><span>{{vm.assignFieldOfficerToDepartment.fieldofficerdesignation}}</span></dd><dt><span data-translate="investhryApp.assignFieldOfficerToDepartment.fieldofficeraddress">Fieldofficeraddress</span></dt><dd><span>{{vm.assignFieldOfficerToDepartment.fieldofficeraddress}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="assign-field-officer-to-department-detail.edit({id:vm.assignFieldOfficerToDepartment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/assign-field-officer-to-department/assign-field-officer-to-department-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAssignFieldOfficerToDepartmentLabel" data-translate="investhryApp.assignFieldOfficerToDepartment.home.createOrEditLabel">Create or edit a Assign Field Officer To Department</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.assignFieldOfficerToDepartment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.assignFieldOfficerToDepartment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignFieldOfficerToDepartment.departmentid" for="field_departmentid">Departmentid</label><input type="text" class="form-control" name="departmentid" id="field_departmentid" ng-model="vm.assignFieldOfficerToDepartment.departmentid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignFieldOfficerToDepartment.departmentname" for="field_departmentname">Departmentname</label><input type="text" class="form-control" name="departmentname" id="field_departmentname" ng-model="vm.assignFieldOfficerToDepartment.departmentname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignFieldOfficerToDepartment.fieldOfficerid" for="field_fieldOfficerid">Field Officerid</label><input type="text" class="form-control" name="fieldOfficerid" id="field_fieldOfficerid" ng-model="vm.assignFieldOfficerToDepartment.fieldOfficerid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignFieldOfficerToDepartment.fieldofficerlogin" for="field_fieldofficerlogin">Fieldofficerlogin</label><input type="text" class="form-control" name="fieldofficerlogin" id="field_fieldofficerlogin" ng-model="vm.assignFieldOfficerToDepartment.fieldofficerlogin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignFieldOfficerToDepartment.fieldofficerdesignation" for="field_fieldofficerdesignation">Fieldofficerdesignation</label><input type="text" class="form-control" name="fieldofficerdesignation" id="field_fieldofficerdesignation" ng-model="vm.assignFieldOfficerToDepartment.fieldofficerdesignation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignFieldOfficerToDepartment.fieldofficeraddress" for="field_fieldofficeraddress">Fieldofficeraddress</label><input type="text" class="form-control" name="fieldofficeraddress" id="field_fieldofficeraddress" ng-model="vm.assignFieldOfficerToDepartment.fieldofficeraddress"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/assign-field-officer-to-department/assign-field-officer-to-departments.html','<div><h2 data-translate="investhryApp.assignFieldOfficerToDepartment.home.title">Assign Field Officer To Departments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="assign-field-officer-to-department.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.assignFieldOfficerToDepartment.home.createLabel">Create new Assign Field Officer To Department</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.assignFieldOfficerToDepartment.departmentid">Departmentid</span></th><th><span data-translate="investhryApp.assignFieldOfficerToDepartment.departmentname">Departmentname</span></th><th><span data-translate="investhryApp.assignFieldOfficerToDepartment.fieldOfficerid">Field Officerid</span></th><th><span data-translate="investhryApp.assignFieldOfficerToDepartment.fieldofficerlogin">Fieldofficerlogin</span></th><th><span data-translate="investhryApp.assignFieldOfficerToDepartment.fieldofficerdesignation">Fieldofficerdesignation</span></th><th><span data-translate="investhryApp.assignFieldOfficerToDepartment.fieldofficeraddress">Fieldofficeraddress</span></th><th></th></tr></thead><tbody><tr ng-repeat="assignFieldOfficerToDepartment in vm.assignFieldOfficerToDepartments track by assignFieldOfficerToDepartment.id"><td><a ui-sref="assign-field-officer-to-department-detail({id:assignFieldOfficerToDepartment.id})">{{assignFieldOfficerToDepartment.id}}</a></td><td>{{assignFieldOfficerToDepartment.departmentid}}</td><td>{{assignFieldOfficerToDepartment.departmentname}}</td><td>{{assignFieldOfficerToDepartment.fieldOfficerid}}</td><td>{{assignFieldOfficerToDepartment.fieldofficerlogin}}</td><td>{{assignFieldOfficerToDepartment.fieldofficerdesignation}}</td><td>{{assignFieldOfficerToDepartment.fieldofficeraddress}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="assign-field-officer-to-department-detail({id:assignFieldOfficerToDepartment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="assign-field-officer-to-department.edit({id:assignFieldOfficerToDepartment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="assign-field-officer-to-department.delete({id:assignFieldOfficerToDepartment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/approvalforms/approvalforms-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.approvalforms.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.approvalforms.delete.question" translate-values="{id: \'{{vm.approvalforms.id}}\'}">Are you sure you want to delete this Approvalforms?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/approvalforms/approvalforms-detail.html','<div class="container"><h2><span data-translate="investhryApp.approvalforms.detail.title">Approvalforms</span> {{vm.approvalforms.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.approvalforms.existingapprovalforms">Existingapprovalforms</span></dt><dd><span>{{vm.approvalforms.existingapprovalforms}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="approvalforms-detail.edit({id:vm.approvalforms.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/approvalforms/approvalforms-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myApprovalformsLabel" data-translate="investhryApp.approvalforms.home.createOrEditLabel">Create or edit a Approvalforms</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.approvalforms.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.approvalforms.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.approvalforms.existingapprovalforms" for="field_existingapprovalforms">Existingapprovalforms</label><input type="text" class="form-control" name="existingapprovalforms" id="field_existingapprovalforms" ng-model="vm.approvalforms.existingapprovalforms" required><div ng-show="editForm.existingapprovalforms.$invalid"><p class="help-block" ng-show="editForm.existingapprovalforms.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/approvalforms/approvalforms.html','<div class="container"><h2 data-translate="investhryApp.approvalforms.home.title">Approvalforms</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="approvalforms.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.approvalforms.home.createLabel">Create new Approvalforms</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.approvalforms.existingapprovalforms">Existingapprovalforms</span></th><th></th></tr></thead><tbody><tr ng-repeat="approvalforms in vm.approvalforms track by approvalforms.id"><td><a ui-sref="approvalforms-detail({id:approvalforms.id})">{{approvalforms.id}}</a></td><td>{{approvalforms.existingapprovalforms}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="approvalforms-detail({id:approvalforms.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="approvalforms.edit({id:approvalforms.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="approvalforms.delete({id:approvalforms.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/assign-project-to-rm/assign-project-to-rm-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.assignProjectToRM.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.assignProjectToRM.delete.question" translate-values="{id: \'{{vm.assignProjectToRM.id}}\'}">Are you sure you want to delete this Assign Project To RM?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/assign-project-to-rm/assign-project-to-rm-detail.html','<div><h2><span data-translate="investhryApp.assignProjectToRM.detail.title">Assign Project To RM</span> {{vm.assignProjectToRM.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.assignProjectToRM.assignBy">Assign By</span></dt><dd><span>{{vm.assignProjectToRM.assignBy}}</span></dd><dt><span data-translate="investhryApp.assignProjectToRM.assignDate">Assign Date</span></dt><dd><span>{{vm.assignProjectToRM.assignDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.assignProjectToRM.projectid">Projectid</span></dt><dd><span>{{vm.assignProjectToRM.projectid}}</span></dd><dt><span data-translate="investhryApp.assignProjectToRM.assignedToRM">Assigned To RM</span></dt><dd><span>{{vm.assignProjectToRM.assignedToRM}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="assign-project-to-rm-detail.edit({id:vm.assignProjectToRM.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/assign-project-to-rm/assign-project-to-rm-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAssignProjectToRMLabel" data-translate="investhryApp.assignProjectToRM.home.createOrEditLabel">Create or edit a Assign Project To RM</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.assignProjectToRM.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.assignProjectToRM.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignProjectToRM.assignBy" for="field_assignBy">Assign By</label><input type="text" class="form-control" name="assignBy" id="field_assignBy" ng-model="vm.assignProjectToRM.assignBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignProjectToRM.assignDate" for="field_assignDate">Assign Date</label><div class="input-group"><input id="field_assignDate" type="text" class="form-control" name="assignDate" datetime-picker="{{dateformat}}" ng-model="vm.assignProjectToRM.assignDate" is-open="vm.datePickerOpenStatus.assignDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'assignDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignProjectToRM.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.assignProjectToRM.projectid" required><div ng-show="editForm.projectid.$invalid"><p class="help-block" ng-show="editForm.projectid.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignProjectToRM.assignedToRM" for="field_assignedToRM">Assigned To RM</label><input type="text" class="form-control" name="assignedToRM" id="field_assignedToRM" ng-model="vm.assignProjectToRM.assignedToRM" required><div ng-show="editForm.assignedToRM.$invalid"><p class="help-block" ng-show="editForm.assignedToRM.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/assign-project-to-rm/assign-project-to-rms.html','<div><h2 data-translate="investhryApp.assignProjectToRM.home.title">Assign Project To RMS</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="assign-project-to-rm.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.assignProjectToRM.home.createLabel">Create new Assign Project To RM</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.assignProjectToRM.assignBy">Assign By</span></th><th><span data-translate="investhryApp.assignProjectToRM.assignDate">Assign Date</span></th><th><span data-translate="investhryApp.assignProjectToRM.projectid">Projectid</span></th><th><span data-translate="investhryApp.assignProjectToRM.assignedToRM">Assigned To RM</span></th><th></th></tr></thead><tbody><tr ng-repeat="assignProjectToRM in vm.assignProjectToRMS track by assignProjectToRM.id"><td><a ui-sref="assign-project-to-rm-detail({id:assignProjectToRM.id})">{{assignProjectToRM.id}}</a></td><td>{{assignProjectToRM.assignBy}}</td><td>{{assignProjectToRM.assignDate | date:\'medium\'}}</td><td>{{assignProjectToRM.projectid}}</td><td>{{assignProjectToRM.assignedToRM}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="assign-project-to-rm-detail({id:assignProjectToRM.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="assign-project-to-rm.edit({id:assignProjectToRM.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="assign-project-to-rm.delete({id:assignProjectToRM.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/assign-service-fee/assign-service-fee-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.assignServiceFee.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.assignServiceFee.delete.question" translate-values="{id: \'{{vm.assignServiceFee.id}}\'}">Are you sure you want to delete this Assign Service Fee?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/assign-service-fee/assign-service-fee-detail.html','<div><h2><span data-translate="investhryApp.assignServiceFee.detail.title">Assign Service Fee</span> {{vm.assignServiceFee.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.assignServiceFee.feedescription">Feedescription</span></dt><dd><span>{{vm.assignServiceFee.feedescription}}</span></dd><dt><span data-translate="investhryApp.assignServiceFee.feeamount">Feeamount</span></dt><dd><span>{{vm.assignServiceFee.feeamount}}</span></dd><dt><span data-translate="investhryApp.assignServiceFee.projectid">Projectid</span></dt><dd><span>{{vm.assignServiceFee.projectid}}</span></dd><dt><span data-translate="investhryApp.assignServiceFee.serviceid">Serviceid</span></dt><dd><span>{{vm.assignServiceFee.serviceid}}</span></dd><dt><span data-translate="investhryApp.assignServiceFee.isSaved">Is Saved</span></dt><dd><span>{{vm.assignServiceFee.isSaved}}</span></dd><dt><span data-translate="investhryApp.assignServiceFee.isPaymentMade">Is Payment Made</span></dt><dd><span>{{vm.assignServiceFee.isPaymentMade}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="assign-service-fee-detail.edit({id:vm.assignServiceFee.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/assign-service-fee/assign-service-fee-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myAssignServiceFeeLabel" data-translate="investhryApp.assignServiceFee.home.createOrEditLabel">Create or edit a Assign Service Fee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.assignServiceFee.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.assignServiceFee.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignServiceFee.feedescription" for="field_feedescription">Feedescription</label><input type="text" class="form-control" name="feedescription" id="field_feedescription" ng-model="vm.assignServiceFee.feedescription"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignServiceFee.feeamount" for="field_feeamount">Feeamount</label><input type="text" class="form-control" name="feeamount" id="field_feeamount" ng-model="vm.assignServiceFee.feeamount"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignServiceFee.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.assignServiceFee.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignServiceFee.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.assignServiceFee.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignServiceFee.isSaved" for="field_isSaved">Is Saved</label><input type="checkbox" name="isSaved" id="field_isSaved" ng-model="vm.assignServiceFee.isSaved"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.assignServiceFee.isPaymentMade" for="field_isPaymentMade">Is Payment Made</label><input type="checkbox" name="isPaymentMade" id="field_isPaymentMade" ng-model="vm.assignServiceFee.isPaymentMade"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/assign-service-fee/assign-service-fees.html','<div><h2 data-translate="investhryApp.assignServiceFee.home.title">Assign Service Fees</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="assign-service-fee.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.assignServiceFee.home.createLabel">Create new Assign Service Fee</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.assignServiceFee.feedescription">Feedescription</span></th><th><span data-translate="investhryApp.assignServiceFee.feeamount">Feeamount</span></th><th><span data-translate="investhryApp.assignServiceFee.projectid">Projectid</span></th><th><span data-translate="investhryApp.assignServiceFee.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.assignServiceFee.isSaved">Is Saved</span></th><th><span data-translate="investhryApp.assignServiceFee.isPaymentMade">Is Payment Made</span></th><th></th></tr></thead><tbody><tr ng-repeat="assignServiceFee in vm.assignServiceFees track by assignServiceFee.id"><td><a ui-sref="assign-service-fee-detail({id:assignServiceFee.id})">{{assignServiceFee.id}}</a></td><td>{{assignServiceFee.feedescription}}</td><td>{{assignServiceFee.feeamount}}</td><td>{{assignServiceFee.projectid}}</td><td>{{assignServiceFee.serviceid}}</td><td>{{assignServiceFee.isSaved}}</td><td>{{assignServiceFee.isPaymentMade}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="assign-service-fee-detail({id:assignServiceFee.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="assign-service-fee.edit({id:assignServiceFee.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="assign-service-fee.delete({id:assignServiceFee.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/backup-project-service-log/backup-project-service-log-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.backupProjectServiceLog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.backupProjectServiceLog.delete.question" translate-values="{id: \'{{vm.backupProjectServiceLog.id}}\'}">Are you sure you want to delete this Backup Project Service Log?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/backup-project-service-log/backup-project-service-log-detail.html','<div><h2><span data-translate="investhryApp.backupProjectServiceLog.detail.title">Backup Project Service Log</span> {{vm.backupProjectServiceLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.backupProjectServiceLog.projectid">Projectid</span></dt><dd><span>{{vm.backupProjectServiceLog.projectid}}</span></dd><dt><span data-translate="investhryApp.backupProjectServiceLog.serviceid">Serviceid</span></dt><dd><span>{{vm.backupProjectServiceLog.serviceid}}</span></dd><dt><span data-translate="investhryApp.backupProjectServiceLog.comments">Comments</span></dt><dd><span>{{vm.backupProjectServiceLog.comments}}</span></dd><dt><span data-translate="investhryApp.backupProjectServiceLog.commentDate">Comment Date</span></dt><dd><span>{{vm.backupProjectServiceLog.commentDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.backupProjectServiceLog.commentByUserLogin">Comment By User Login</span></dt><dd><span>{{vm.backupProjectServiceLog.commentByUserLogin}}</span></dd><dt><span data-translate="investhryApp.backupProjectServiceLog.actionTaken">Action Taken</span></dt><dd><span>{{vm.backupProjectServiceLog.actionTaken}}</span></dd><dt><span data-translate="investhryApp.backupProjectServiceLog.reApplyCounter">Re Apply Counter</span></dt><dd><span>{{vm.backupProjectServiceLog.reApplyCounter}}</span></dd><dt><span data-translate="investhryApp.backupProjectServiceLog.rejectionReason">Rejection Reason</span></dt><dd><span>{{vm.backupProjectServiceLog.rejectionReason}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="backup-project-service-log-detail.edit({id:vm.backupProjectServiceLog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/backup-project-service-log/backup-project-service-log-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBackupProjectServiceLogLabel" data-translate="investhryApp.backupProjectServiceLog.home.createOrEditLabel">Create or edit a Backup Project Service Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.backupProjectServiceLog.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.backupProjectServiceLog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.backupProjectServiceLog.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.backupProjectServiceLog.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.backupProjectServiceLog.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.backupProjectServiceLog.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.backupProjectServiceLog.comments" for="field_comments">Comments</label><input type="text" class="form-control" name="comments" id="field_comments" ng-model="vm.backupProjectServiceLog.comments"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.backupProjectServiceLog.commentDate" for="field_commentDate">Comment Date</label><div class="input-group"><input id="field_commentDate" type="text" class="form-control" name="commentDate" datetime-picker="{{dateformat}}" ng-model="vm.backupProjectServiceLog.commentDate" is-open="vm.datePickerOpenStatus.commentDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'commentDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.backupProjectServiceLog.commentByUserLogin" for="field_commentByUserLogin">Comment By User Login</label><input type="text" class="form-control" name="commentByUserLogin" id="field_commentByUserLogin" ng-model="vm.backupProjectServiceLog.commentByUserLogin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.backupProjectServiceLog.actionTaken" for="field_actionTaken">Action Taken</label><input type="text" class="form-control" name="actionTaken" id="field_actionTaken" ng-model="vm.backupProjectServiceLog.actionTaken"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.backupProjectServiceLog.reApplyCounter" for="field_reApplyCounter">Re Apply Counter</label><input type="number" class="form-control" name="reApplyCounter" id="field_reApplyCounter" ng-model="vm.backupProjectServiceLog.reApplyCounter"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.backupProjectServiceLog.rejectionReason" for="field_rejectionReason">Rejection Reason</label><input type="text" class="form-control" name="rejectionReason" id="field_rejectionReason" ng-model="vm.backupProjectServiceLog.rejectionReason"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/backup-project-service-log/backup-project-service-logs.html','<div><h2 data-translate="investhryApp.backupProjectServiceLog.home.title">Backup Project Service Logs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="backup-project-service-log.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.backupProjectServiceLog.home.createLabel">Create new Backup Project Service Log</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.backupProjectServiceLog.projectid">Projectid</span></th><th><span data-translate="investhryApp.backupProjectServiceLog.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.backupProjectServiceLog.comments">Comments</span></th><th><span data-translate="investhryApp.backupProjectServiceLog.commentDate">Comment Date</span></th><th><span data-translate="investhryApp.backupProjectServiceLog.commentByUserLogin">Comment By User Login</span></th><th><span data-translate="investhryApp.backupProjectServiceLog.actionTaken">Action Taken</span></th><th><span data-translate="investhryApp.backupProjectServiceLog.reApplyCounter">Re Apply Counter</span></th><th><span data-translate="investhryApp.backupProjectServiceLog.rejectionReason">Rejection Reason</span></th><th></th></tr></thead><tbody><tr ng-repeat="backupProjectServiceLog in vm.backupProjectServiceLogs track by backupProjectServiceLog.id"><td><a ui-sref="backup-project-service-log-detail({id:backupProjectServiceLog.id})">{{backupProjectServiceLog.id}}</a></td><td>{{backupProjectServiceLog.projectid}}</td><td>{{backupProjectServiceLog.serviceid}}</td><td>{{backupProjectServiceLog.comments}}</td><td>{{backupProjectServiceLog.commentDate | date:\'medium\'}}</td><td>{{backupProjectServiceLog.commentByUserLogin}}</td><td>{{backupProjectServiceLog.actionTaken}}</td><td>{{backupProjectServiceLog.reApplyCounter}}</td><td>{{backupProjectServiceLog.rejectionReason}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="backup-project-service-log-detail({id:backupProjectServiceLog.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="backup-project-service-log.edit({id:backupProjectServiceLog.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="backup-project-service-log.delete({id:backupProjectServiceLog.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/below-ground/below-ground-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.below_ground.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.below_ground.delete.question" translate-values="{id: \'{{vm.below_ground.id}}\'}">Are you sure you want to delete this Below Ground?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/below-ground/below-ground-detail.html','<div><h2><span data-translate="investhryApp.below_ground.detail.title">Below Ground</span> {{vm.below_ground.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.below_ground.name">Name</span></dt><dd><span>{{vm.below_ground.name}}</span></dd><dt><span data-translate="investhryApp.below_ground.reg_add">Reg Add</span></dt><dd><span>{{vm.below_ground.reg_add}}</span></dd><dt><span data-translate="investhryApp.below_ground.har_office_add">Har Office Add</span></dt><dd><span>{{vm.below_ground.har_office_add}}</span></dd><dt><span data-translate="investhryApp.below_ground.name_auth">Name Auth</span></dt><dd><span>{{vm.below_ground.name_auth}}</span></dd><dt><span data-translate="investhryApp.below_ground.designation_auth">Designation Auth</span></dt><dd><span>{{vm.below_ground.designation_auth}}</span></dd><dt><span data-translate="investhryApp.below_ground.phone_auth">Phone Auth</span></dt><dd><span>{{vm.below_ground.phone_auth}}</span></dd><dt><span data-translate="investhryApp.below_ground.email">Email</span></dt><dd><span>{{vm.below_ground.email}}</span></dd><dt><span data-translate="investhryApp.below_ground.lenth">Lenth</span></dt><dd><span>{{vm.below_ground.lenth}}</span></dd><dt><span data-translate="investhryApp.below_ground.route">Route</span></dt><dd><span>{{vm.below_ground.route}}</span></dd><dt><span data-translate="investhryApp.below_ground.nature">Nature</span></dt><dd><span>{{vm.below_ground.nature}}</span></dd><dt><span data-translate="investhryApp.below_ground.methodology">Methodology</span></dt><dd><span>{{vm.below_ground.methodology}}</span></dd><dt><span data-translate="investhryApp.below_ground.address1">Address 1</span></dt><dd><span>{{vm.below_ground.address1}}</span></dd><dt><span data-translate="investhryApp.below_ground.district">District</span></dt><dd><span>{{vm.below_ground.district}}</span></dd><dt><span data-translate="investhryApp.below_ground.zone">Zone</span></dt><dd><span>{{vm.below_ground.zone}}</span></dd><dt><span data-translate="investhryApp.below_ground.details1">Details 1</span></dt><dd><span>{{vm.below_ground.details1}}</span></dd><dt><span data-translate="investhryApp.below_ground.details2">Details 2</span></dt><dd><span>{{vm.below_ground.details2}}</span></dd><dt><span data-translate="investhryApp.below_ground.other_info1">Other Info 1</span></dt><dd><span>{{vm.below_ground.other_info1}}</span></dd><dt><span data-translate="investhryApp.below_ground.other_info2">Other Info 2</span></dt><dd><span>{{vm.below_ground.other_info2}}</span></dd><dt><span data-translate="investhryApp.below_ground.other_info3">Other Info 3</span></dt><dd><span>{{vm.below_ground.other_info3}}</span></dd><dt><span data-translate="investhryApp.below_ground.other_info4">Other Info 4</span></dt><dd><span>{{vm.below_ground.other_info4}}</span></dd><dt><span data-translate="investhryApp.below_ground.other_info5">Other Info 5</span></dt><dd><span>{{vm.below_ground.other_info5}}</span></dd><dt><span data-translate="investhryApp.below_ground.other_info6">Other Info 6</span></dt><dd><span>{{vm.below_ground.other_info6}}</span></dd><dt><span data-translate="investhryApp.below_ground.other_info7">Other Info 7</span></dt><dd><span>{{vm.below_ground.other_info7}}</span></dd><dt><span data-translate="investhryApp.below_ground.address2">Address 2</span></dt><dd><span>{{vm.below_ground.address2}}</span></dd><dt><span data-translate="investhryApp.below_ground.document1">Document 1</span></dt><dd><span>{{vm.below_ground.document1}}</span></dd><dt><span data-translate="investhryApp.below_ground.document2">Document 2</span></dt><dd><span>{{vm.below_ground.document2}}</span></dd><dt><span data-translate="investhryApp.below_ground.document3">Document 3</span></dt><dd><span>{{vm.below_ground.document3}}</span></dd><dt><span data-translate="investhryApp.below_ground.document4">Document 4</span></dt><dd><span>{{vm.below_ground.document4}}</span></dd><dt><span data-translate="investhryApp.below_ground.document5">Document 5</span></dt><dd><span>{{vm.below_ground.document5}}</span></dd><dt><span data-translate="investhryApp.below_ground.document6">Document 6</span></dt><dd><span>{{vm.below_ground.document6}}</span></dd><dt><span data-translate="investhryApp.below_ground.document7">Document 7</span></dt><dd><span>{{vm.below_ground.document7}}</span></dd><dt><span data-translate="investhryApp.below_ground.document8">Document 8</span></dt><dd><span>{{vm.below_ground.document8}}</span></dd><dt><span data-translate="investhryApp.below_ground.isfullyfilled">Isfullyfilled</span></dt><dd><span>{{vm.below_ground.isfullyfilled}}</span></dd><dt><span data-translate="investhryApp.below_ground.status">Status</span></dt><dd><span>{{vm.below_ground.status}}</span></dd><dt><span data-translate="investhryApp.below_ground.isforwardedtodio">Isforwardedtodio</span></dt><dd><span>{{vm.below_ground.isforwardedtodio}}</span></dd><dt><span data-translate="investhryApp.below_ground.isforwardedtodept">Isforwardedtodept</span></dt><dd><span>{{vm.below_ground.isforwardedtodept}}</span></dd><dt><span data-translate="investhryApp.below_ground.isforwardedtodc">Isforwardedtodc</span></dt><dd><span>{{vm.below_ground.isforwardedtodc}}</span></dd><dt><span data-translate="investhryApp.below_ground.clearancefile1">Clearancefile 1</span></dt><dd><span>{{vm.below_ground.clearancefile1}}</span></dd><dt><span data-translate="investhryApp.below_ground.clearancefile2">Clearancefile 2</span></dt><dd><span>{{vm.below_ground.clearancefile2}}</span></dd><dt><span data-translate="investhryApp.below_ground.clearancefile3">Clearancefile 3</span></dt><dd><span>{{vm.below_ground.clearancefile3}}</span></dd><dt><span data-translate="investhryApp.below_ground.created_by">Created By</span></dt><dd><span>{{vm.below_ground.created_by}}</span></dd><dt><span data-translate="investhryApp.below_ground.created_on">Created On</span></dt><dd><span>{{vm.below_ground.created_on | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.below_ground.isforwarded">Isforwarded</span></dt><dd><span>{{vm.below_ground.isforwarded}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="below-ground-detail.edit({id:vm.below_ground.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/below-ground/below-ground-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBelow_groundLabel" data-translate="investhryApp.below_ground.home.createOrEditLabel">Create or edit a Below Ground</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.below_ground.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.below_ground.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.below_ground.name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.reg_add" for="field_reg_add">Reg Add</label><input type="text" class="form-control" name="reg_add" id="field_reg_add" ng-model="vm.below_ground.reg_add"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.har_office_add" for="field_har_office_add">Har Office Add</label><input type="text" class="form-control" name="har_office_add" id="field_har_office_add" ng-model="vm.below_ground.har_office_add"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.name_auth" for="field_name_auth">Name Auth</label><input type="text" class="form-control" name="name_auth" id="field_name_auth" ng-model="vm.below_ground.name_auth"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.designation_auth" for="field_designation_auth">Designation Auth</label><input type="text" class="form-control" name="designation_auth" id="field_designation_auth" ng-model="vm.below_ground.designation_auth"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.phone_auth" for="field_phone_auth">Phone Auth</label><input type="text" class="form-control" name="phone_auth" id="field_phone_auth" ng-model="vm.below_ground.phone_auth"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.below_ground.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.lenth" for="field_lenth">Lenth</label><input type="text" class="form-control" name="lenth" id="field_lenth" ng-model="vm.below_ground.lenth"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.route" for="field_route">Route</label><input type="text" class="form-control" name="route" id="field_route" ng-model="vm.below_ground.route"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.nature" for="field_nature">Nature</label><input type="text" class="form-control" name="nature" id="field_nature" ng-model="vm.below_ground.nature"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.methodology" for="field_methodology">Methodology</label><input type="text" class="form-control" name="methodology" id="field_methodology" ng-model="vm.below_ground.methodology"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.address1" for="field_address1">Address 1</label><input type="text" class="form-control" name="address1" id="field_address1" ng-model="vm.below_ground.address1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.below_ground.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.zone" for="field_zone">Zone</label><input type="text" class="form-control" name="zone" id="field_zone" ng-model="vm.below_ground.zone"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.details1" for="field_details1">Details 1</label><input type="text" class="form-control" name="details1" id="field_details1" ng-model="vm.below_ground.details1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.details2" for="field_details2">Details 2</label><input type="text" class="form-control" name="details2" id="field_details2" ng-model="vm.below_ground.details2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.other_info1" for="field_other_info1">Other Info 1</label><input type="text" class="form-control" name="other_info1" id="field_other_info1" ng-model="vm.below_ground.other_info1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.other_info2" for="field_other_info2">Other Info 2</label><input type="text" class="form-control" name="other_info2" id="field_other_info2" ng-model="vm.below_ground.other_info2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.other_info3" for="field_other_info3">Other Info 3</label><input type="text" class="form-control" name="other_info3" id="field_other_info3" ng-model="vm.below_ground.other_info3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.other_info4" for="field_other_info4">Other Info 4</label><input type="text" class="form-control" name="other_info4" id="field_other_info4" ng-model="vm.below_ground.other_info4"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.other_info5" for="field_other_info5">Other Info 5</label><input type="text" class="form-control" name="other_info5" id="field_other_info5" ng-model="vm.below_ground.other_info5"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.other_info6" for="field_other_info6">Other Info 6</label><input type="text" class="form-control" name="other_info6" id="field_other_info6" ng-model="vm.below_ground.other_info6"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.other_info7" for="field_other_info7">Other Info 7</label><input type="text" class="form-control" name="other_info7" id="field_other_info7" ng-model="vm.below_ground.other_info7"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.address2" for="field_address2">Address 2</label><input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.below_ground.address2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.document1" for="field_document1">Document 1</label><input type="text" class="form-control" name="document1" id="field_document1" ng-model="vm.below_ground.document1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.document2" for="field_document2">Document 2</label><input type="text" class="form-control" name="document2" id="field_document2" ng-model="vm.below_ground.document2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.document3" for="field_document3">Document 3</label><input type="text" class="form-control" name="document3" id="field_document3" ng-model="vm.below_ground.document3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.document4" for="field_document4">Document 4</label><input type="text" class="form-control" name="document4" id="field_document4" ng-model="vm.below_ground.document4"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.document5" for="field_document5">Document 5</label><input type="text" class="form-control" name="document5" id="field_document5" ng-model="vm.below_ground.document5"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.document6" for="field_document6">Document 6</label><input type="text" class="form-control" name="document6" id="field_document6" ng-model="vm.below_ground.document6"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.document7" for="field_document7">Document 7</label><input type="text" class="form-control" name="document7" id="field_document7" ng-model="vm.below_ground.document7"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.document8" for="field_document8">Document 8</label><input type="text" class="form-control" name="document8" id="field_document8" ng-model="vm.below_ground.document8"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.isfullyfilled" for="field_isfullyfilled">Isfullyfilled</label><input type="checkbox" class="form-control" name="isfullyfilled" id="field_isfullyfilled" ng-model="vm.below_ground.isfullyfilled"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.below_ground.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.isforwardedtodio" for="field_isforwardedtodio">Isforwardedtodio</label><input type="checkbox" class="form-control" name="isforwardedtodio" id="field_isforwardedtodio" ng-model="vm.below_ground.isforwardedtodio"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.isforwardedtodept" for="field_isforwardedtodept">Isforwardedtodept</label><input type="checkbox" class="form-control" name="isforwardedtodept" id="field_isforwardedtodept" ng-model="vm.below_ground.isforwardedtodept"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.isforwardedtodc" for="field_isforwardedtodc">Isforwardedtodc</label><input type="checkbox" class="form-control" name="isforwardedtodc" id="field_isforwardedtodc" ng-model="vm.below_ground.isforwardedtodc"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.clearancefile1" for="field_clearancefile1">Clearancefile 1</label><input type="text" class="form-control" name="clearancefile1" id="field_clearancefile1" ng-model="vm.below_ground.clearancefile1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.clearancefile2" for="field_clearancefile2">Clearancefile 2</label><input type="text" class="form-control" name="clearancefile2" id="field_clearancefile2" ng-model="vm.below_ground.clearancefile2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.clearancefile3" for="field_clearancefile3">Clearancefile 3</label><input type="text" class="form-control" name="clearancefile3" id="field_clearancefile3" ng-model="vm.below_ground.clearancefile3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.created_by" for="field_created_by">Created By</label><input type="text" class="form-control" name="created_by" id="field_created_by" ng-model="vm.below_ground.created_by"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.created_on" for="field_created_on">Created On</label><div class="input-group"><input id="field_created_on" type="text" class="form-control" name="created_on" uib-datepicker-popup="{{dateformat}}" ng-model="vm.below_ground.created_on" is-open="vm.datePickerOpenStatus.created_on"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'created_on\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.below_ground.isforwarded" for="field_isforwarded">Isforwarded</label><input type="text" class="form-control" name="isforwarded" id="field_isforwarded" ng-model="vm.below_ground.isforwarded"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/below-ground/below-grounds.html','<div><h2 data-translate="investhryApp.below_ground.home.title">Below Grounds</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="below-ground.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.below_ground.home.createLabel">Create new Below Ground</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.below_ground.name">Name</span></th><th><span data-translate="investhryApp.below_ground.reg_add">Reg Add</span></th><th><span data-translate="investhryApp.below_ground.har_office_add">Har Office Add</span></th><th><span data-translate="investhryApp.below_ground.name_auth">Name Auth</span></th><th><span data-translate="investhryApp.below_ground.designation_auth">Designation Auth</span></th><th><span data-translate="investhryApp.below_ground.phone_auth">Phone Auth</span></th><th><span data-translate="investhryApp.below_ground.email">Email</span></th><th><span data-translate="investhryApp.below_ground.lenth">Lenth</span></th><th><span data-translate="investhryApp.below_ground.route">Route</span></th><th><span data-translate="investhryApp.below_ground.nature">Nature</span></th><th><span data-translate="investhryApp.below_ground.methodology">Methodology</span></th><th><span data-translate="investhryApp.below_ground.address1">Address 1</span></th><th><span data-translate="investhryApp.below_ground.district">District</span></th><th><span data-translate="investhryApp.below_ground.zone">Zone</span></th><th><span data-translate="investhryApp.below_ground.details1">Details 1</span></th><th><span data-translate="investhryApp.below_ground.details2">Details 2</span></th><th><span data-translate="investhryApp.below_ground.other_info1">Other Info 1</span></th><th><span data-translate="investhryApp.below_ground.other_info2">Other Info 2</span></th><th><span data-translate="investhryApp.below_ground.other_info3">Other Info 3</span></th><th><span data-translate="investhryApp.below_ground.other_info4">Other Info 4</span></th><th><span data-translate="investhryApp.below_ground.other_info5">Other Info 5</span></th><th><span data-translate="investhryApp.below_ground.other_info6">Other Info 6</span></th><th><span data-translate="investhryApp.below_ground.other_info7">Other Info 7</span></th><th><span data-translate="investhryApp.below_ground.address2">Address 2</span></th><th><span data-translate="investhryApp.below_ground.document1">Document 1</span></th><th><span data-translate="investhryApp.below_ground.document2">Document 2</span></th><th><span data-translate="investhryApp.below_ground.document3">Document 3</span></th><th><span data-translate="investhryApp.below_ground.document4">Document 4</span></th><th><span data-translate="investhryApp.below_ground.document5">Document 5</span></th><th><span data-translate="investhryApp.below_ground.document6">Document 6</span></th><th><span data-translate="investhryApp.below_ground.document7">Document 7</span></th><th><span data-translate="investhryApp.below_ground.document8">Document 8</span></th><th><span data-translate="investhryApp.below_ground.isfullyfilled">Isfullyfilled</span></th><th><span data-translate="investhryApp.below_ground.status">Status</span></th><th><span data-translate="investhryApp.below_ground.isforwardedtodio">Isforwardedtodio</span></th><th><span data-translate="investhryApp.below_ground.isforwardedtodept">Isforwardedtodept</span></th><th><span data-translate="investhryApp.below_ground.isforwardedtodc">Isforwardedtodc</span></th><th><span data-translate="investhryApp.below_ground.clearancefile1">Clearancefile 1</span></th><th><span data-translate="investhryApp.below_ground.clearancefile2">Clearancefile 2</span></th><th><span data-translate="investhryApp.below_ground.clearancefile3">Clearancefile 3</span></th><th><span data-translate="investhryApp.below_ground.created_by">Created By</span></th><th><span data-translate="investhryApp.below_ground.created_on">Created On</span></th><th><span data-translate="investhryApp.below_ground.isforwarded">Isforwarded</span></th><th></th></tr></thead><tbody><tr ng-repeat="below_ground in vm.below_grounds track by below_ground.id"><td><a ui-sref="below-ground-detail({id:below_ground.id})">{{below_ground.id}}</a></td><td>{{below_ground.name}}</td><td>{{below_ground.reg_add}}</td><td>{{below_ground.har_office_add}}</td><td>{{below_ground.name_auth}}</td><td>{{below_ground.designation_auth}}</td><td>{{below_ground.phone_auth}}</td><td>{{below_ground.email}}</td><td>{{below_ground.lenth}}</td><td>{{below_ground.route}}</td><td>{{below_ground.nature}}</td><td>{{below_ground.methodology}}</td><td>{{below_ground.address1}}</td><td>{{below_ground.district}}</td><td>{{below_ground.zone}}</td><td>{{below_ground.details1}}</td><td>{{below_ground.details2}}</td><td>{{below_ground.other_info1}}</td><td>{{below_ground.other_info2}}</td><td>{{below_ground.other_info3}}</td><td>{{below_ground.other_info4}}</td><td>{{below_ground.other_info5}}</td><td>{{below_ground.other_info6}}</td><td>{{below_ground.other_info7}}</td><td>{{below_ground.address2}}</td><td>{{below_ground.document1}}</td><td>{{below_ground.document2}}</td><td>{{below_ground.document3}}</td><td>{{below_ground.document4}}</td><td>{{below_ground.document5}}</td><td>{{below_ground.document6}}</td><td>{{below_ground.document7}}</td><td>{{below_ground.document8}}</td><td>{{below_ground.isfullyfilled}}</td><td>{{below_ground.status}}</td><td>{{below_ground.isforwardedtodio}}</td><td>{{below_ground.isforwardedtodept}}</td><td>{{below_ground.isforwardedtodc}}</td><td>{{below_ground.clearancefile1}}</td><td>{{below_ground.clearancefile2}}</td><td>{{below_ground.clearancefile3}}</td><td>{{below_ground.created_by}}</td><td>{{below_ground.created_on | date:\'mediumDate\'}}</td><td>{{below_ground.isforwarded}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="below-ground-detail({id:below_ground.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="below-ground.edit({id:below_ground.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="below-ground.delete({id:below_ground.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/block/block-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.block.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.block.delete.question" translate-values="{id: \'{{vm.block.id}}\'}">Are you sure you want to delete this Block?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/block/block-detail.html','<div><h2><span data-translate="investhryApp.block.detail.title">Block</span> {{vm.block.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.block.blockname">Blockname</span></dt><dd><span>{{vm.block.blockname}}</span></dd><dt><span data-translate="investhryApp.block.districtname">Districtname</span></dt><dd><span>{{vm.block.districtname}}</span></dd><dt><span data-translate="investhryApp.block.blocktype">Blocktype</span></dt><dd><span>{{vm.block.blocktype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="block-detail.edit({id:vm.block.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/block/block-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBlockLabel" data-translate="investhryApp.block.home.createOrEditLabel">Create or edit a Block</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.block.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.block.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.block.blockname" for="field_blockname">Blockname</label><input type="text" class="form-control" name="blockname" id="field_blockname" ng-model="vm.block.blockname" required><div ng-show="editForm.blockname.$invalid"><p class="help-block" ng-show="editForm.blockname.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.block.districtname" for="field_districtname">Districtname</label><input type="text" class="form-control" name="districtname" id="field_districtname" ng-model="vm.block.districtname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.block.blocktype" for="field_blocktype">Blocktype</label><input type="text" class="form-control" name="blocktype" id="field_blocktype" ng-model="vm.block.blocktype"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/block/blocks.html','<div><h2 data-translate="investhryApp.block.home.title">Blocks</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="block.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.block.home.createLabel">Create new Block</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.block.blockname">Blockname</span></th><th><span data-translate="investhryApp.block.districtname">Districtname</span></th><th><span data-translate="investhryApp.block.blocktype">Blocktype</span></th><th></th></tr></thead><tbody><tr ng-repeat="block in vm.blocks track by block.id"><td><a ui-sref="block-detail({id:block.id})">{{block.id}}</a></td><td>{{block.blockname}}</td><td>{{block.districtname}}</td><td>{{block.blocktype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="block-detail({id:block.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="block.edit({id:block.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="block.delete({id:block.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/brap-checklist/brap-checklist-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.brapChecklist.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.brapChecklist.delete.question" translate-values="{id: \'{{vm.brapChecklist.id}}\'}">Are you sure you want to delete this Brap Checklist?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/brap-checklist/brap-checklist-detail.html','<div><h2><span data-translate="investhryApp.brapChecklist.detail.title">Brap Checklist</span> {{vm.brapChecklist.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.brapChecklist.departmentId">Department Id</span></dt><dd><span>{{vm.brapChecklist.departmentId}}</span></dd><dt><span data-translate="investhryApp.brapChecklist.riskCategory">Risk Category</span></dt><dd><span>{{vm.brapChecklist.riskCategory}}</span></dd><dt><span data-translate="investhryApp.brapChecklist.sizeOfFirm">Size Of Firm</span></dt><dd><span>{{vm.brapChecklist.sizeOfFirm}}</span></dd><dt><span data-translate="investhryApp.brapChecklist.businessLocation">Business Location</span></dt><dd><span>{{vm.brapChecklist.businessLocation}}</span></dd><dt><span data-translate="investhryApp.brapChecklist.investerType">Invester Type</span></dt><dd><span>{{vm.brapChecklist.investerType}}</span></dd><dt><span data-translate="investhryApp.brapChecklist.createdAt">Created At</span></dt><dd><span>{{vm.brapChecklist.createdAt | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.brapChecklist.updatedAt">Updated At</span></dt><dd><span>{{vm.brapChecklist.updatedAt | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.brapChecklist.documentUrl">Document Url</span></dt><dd><span>{{vm.brapChecklist.documentUrl}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="brap-checklist-detail.edit({id:vm.brapChecklist.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/brap-checklist/brap-checklist-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.submitForm()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBrapChecklistLabel" data-translate="investhryApp.brapChecklist.home.createOrEditLabel">Create or edit a Brap Checklist</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.brapChecklist.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.brapChecklist.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.brapChecklist.departmentId" for="field_departmentId">Department Id</label><input type="text" class="form-control" name="departmentId" id="field_departmentId" ng-model="vm.brapChecklist.departmentId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.brapChecklist.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.brapChecklist.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.brapChecklist.riskCategory" for="field_riskCategory">Risk Category</label><input type="text" class="form-control" name="riskCategory" id="field_riskCategory" ng-model="vm.brapChecklist.riskCategory"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.brapChecklist.sizeOfFirm" for="field_sizeOfFirm">Size Of Firm</label><input type="text" class="form-control" name="sizeOfFirm" id="field_sizeOfFirm" ng-model="vm.brapChecklist.sizeOfFirm"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.brapChecklist.businessLocation" for="field_businessLocation">Business Location</label><input type="text" class="form-control" name="businessLocation" id="field_businessLocation" ng-model="vm.brapChecklist.businessLocation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.brapChecklist.investerType" for="field_investerType">Invester Type</label><input type="text" class="form-control" name="investerType" id="field_investerType" ng-model="vm.brapChecklist.investerType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.brapChecklist.createdAt" for="field_createdAt">Created At</label><div class="input-group"><input id="field_createdAt" type="text" class="form-control" name="createdAt" datetime-picker="{{dateformat}}" ng-model="vm.brapChecklist.createdAt" is-open="vm.datePickerOpenStatus.createdAt"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdAt\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.brapChecklist.updatedAt" for="field_updatedAt">Updated At</label><div class="input-group"><input id="field_updatedAt" type="text" class="form-control" name="updatedAt" datetime-picker="{{dateformat}}" ng-model="vm.brapChecklist.updatedAt" is-open="vm.datePickerOpenStatus.updatedAt"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedAt\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" for="field_document">Upload Document</label><input type="file" class="form-control" name="document" id="field_document"></div><div class="form-group"><label class="control-label" for="field_feeStructureDoc">Fee Structure Document</label><input type="file" class="form-control" name="feeStructureDoc" id="field_feeStructureDoc"></div><div class="form-group"><label class="control-label" for="field_sopDoc">SOP Document</label><input type="file" class="form-control" name="sopDoc" id="field_sopDoc"></div><div class="form-group"><label class="control-label" for="field_timelineDoc">Statutory Timeline Document</label><input type="file" class="form-control" name="timelineDoc" id="field_timelineDoc"></div><div class="form-group"><label class="control-label" for="field_inspectionDoc">Inspection Checklist Document</label><input type="file" class="form-control" name="inspectionDoc" id="field_inspectionDoc"></div><div class="form-group"><label class="control-label" for="field_riskCategoryDoc">Risk category Document</label><input type="file" class="form-control" name="riskCategoryDoc" id="field_riskCategoryDoc"></div><!--        <div class="form-group">--><!--            <label class="col-lg-2 control-label">Upload Photo<span style="color:red">*</span></label>--><!--            <div class="col-lg-3 text-danger">--><!--                <input type="file" class="form-control input" file-Model="vm.cAFAttachmentPhoto.investorphoto" accept=".jpeg,.jpg,.png" required/>--><!--                <p>Max file size (1 MB) and image files accepted with extension .jpg, .png, .jpeg</p>--><!--                <p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1--><!--                    MB)</font></p>--><!--            </div>--><!--            <div class="col-lg-3" ng-if="vm.cafAttachementInvestorPhoto.fileName">--><!--                <div class="thumbnail pull-right panel-body">--><!--                    <img src="{{vm.investorphoto1}}"  style="height:150px; width: 150px;">--><!--                </div>--><!--            </div>--><!--        </div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/brap-checklist/brap-checklists.html','<div><h2 data-translate="investhryApp.brapChecklist.home.title">Brap Checklists</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="brap-checklist.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.brapChecklist.home.createLabel">Create new Brap Checklist</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.brapChecklist.departmentId">Department Id</span></th><th><span data-translate="investhryApp.brapChecklist.riskCategory">Risk Category</span></th><th><span data-translate="investhryApp.brapChecklist.sizeOfFirm">Size Of Firm</span></th><th><span data-translate="investhryApp.brapChecklist.businessLocation">Business Location</span></th><th><span data-translate="investhryApp.brapChecklist.investerType">Invester Type</span></th><th><span data-translate="investhryApp.brapChecklist.createdAt">Created At</span></th><th><span data-translate="investhryApp.brapChecklist.updatedAt">Updated At</span></th><th><span data-translate="investhryApp.brapChecklist.documentUrl">Document Url</span></th><th></th></tr></thead><tbody><tr ng-repeat="brapChecklist in vm.brapChecklists track by brapChecklist.id"><td><a ui-sref="brap-checklist-detail({id:brapChecklist.id})">{{brapChecklist.id}}</a></td><td>{{brapChecklist.departmentId}}</td><td>{{brapChecklist.riskCategory}}</td><td>{{brapChecklist.sizeOfFirm}}</td><td>{{brapChecklist.businessLocation}}</td><td>{{brapChecklist.investerType}}</td><td>{{brapChecklist.createdAt | date:\'medium\'}}</td><td>{{brapChecklist.updatedAt | date:\'medium\'}}</td><td>{{brapChecklist.documentUrl}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="brap-checklist-detail({id:brapChecklist.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="brap-checklist.edit({id:brapChecklist.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="brap-checklist.delete({id:brapChecklist.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/businessentity/businessentities.html','<div class="container"><h2 data-translate="investhryApp.businessentity.home.title">Businessentities</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="businessentity.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.businessentity.home.createLabel">Create new Businessentity</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.businessentity.businessentitytype">Businessentitytype</span></th><th></th></tr></thead><tbody><tr ng-repeat="businessentity in vm.businessentities track by businessentity.id"><td><a ui-sref="businessentity-detail({id:businessentity.id})">{{businessentity.id}}</a></td><td>{{businessentity.businessentitytype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="businessentity-detail({id:businessentity.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="businessentity.edit({id:businessentity.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="businessentity.delete({id:businessentity.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/businessentity/businessentity-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.businessentity.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.businessentity.delete.question" translate-values="{id: \'{{vm.businessentity.id}}\'}">Are you sure you want to delete this Businessentity?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/businessentity/businessentity-detail.html','<div class="container"><h2><span data-translate="investhryApp.businessentity.detail.title">Businessentity</span> {{vm.businessentity.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.businessentity.businessentitytype">Businessentitytype</span></dt><dd><span>{{vm.businessentity.businessentitytype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="businessentity-detail.edit({id:vm.businessentity.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/businessentity/businessentity-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBusinessentityLabel" data-translate="investhryApp.businessentity.home.createOrEditLabel">Create or edit a Businessentity</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.businessentity.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.businessentity.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.businessentity.businessentitytype" for="field_businessentitytype">Businessentitytype</label><input type="text" class="form-control" name="businessentitytype" id="field_businessentitytype" ng-model="vm.businessentity.businessentitytype"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/businessentitys/businessentitys-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.businessentitys.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.businessentitys.delete.question" translate-values="{id: \'{{vm.businessentitys.id}}\'}">Are you sure you want to delete this Businessentitys?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/businessentitys/businessentitys-detail.html','<div class="container"><h2><span data-translate="investhryApp.businessentitys.detail.title">Businessentitys</span> {{vm.businessentitys.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.businessentitys.businessentitytype">Businessentitytype</span></dt><dd><span>{{vm.businessentitys.businessentitytype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="businessentitys-detail.edit({id:vm.businessentitys.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/businessentitys/businessentitys-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myBusinessentitysLabel" data-translate="investhryApp.businessentitys.home.createOrEditLabel">Create or edit a Businessentitys</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.businessentitys.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.businessentitys.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.businessentitys.businessentitytype" for="field_businessentitytype">Businessentitytype</label><input type="text" class="form-control" name="businessentitytype" id="field_businessentitytype" ng-model="vm.businessentitys.businessentitytype"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/businessentitys/businessentitys.html','<div class="container"><h2 data-translate="investhryApp.businessentitys.home.title">Businessentitys</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="businessentitys.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.businessentitys.home.createLabel">Create new Businessentitys</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.businessentitys.businessentitytype">Businessentitytype</span></th><th></th></tr></thead><tbody><tr ng-repeat="businessentitys in vm.businessentitys track by businessentitys.id"><td><a ui-sref="businessentitys-detail({id:businessentitys.id})">{{businessentitys.id}}</a></td><td>{{businessentitys.businessentitytype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="businessentitys-detail({id:businessentitys.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="businessentitys.edit({id:businessentitys.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="businessentitys.delete({id:businessentitys.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/c-af-attachment/c-af-attachments.html','<div><h2 data-translate="investhryApp.cAFAttachment.home.title">CAF Attachments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="caf-attachment.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.cAFAttachment.home.createLabel">Create new CAF Attachment</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.cAFAttachment.projectid">Projectid</span></th><th><span data-translate="investhryApp.cAFAttachment.docName">Doc Name</span></th><th><span data-translate="investhryApp.cAFAttachment.fileName">File Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="cAFAttachment in vm.cAFAttachments track by cAFAttachment.id"><td><a ui-sref="caf-attachment-detail({id:cAFAttachment.id})">{{cAFAttachment.id}}</a></td><td>{{cAFAttachment.projectid}}</td><td>{{cAFAttachment.docName}}</td><td>{{cAFAttachment.fileName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="caf-attachment-detail({id:cAFAttachment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="caf-attachment.edit({id:cAFAttachment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="caf-attachment.delete({id:cAFAttachment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/c-af-attachment/caf-attachment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cAFAttachment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.cAFAttachment.delete.question" translate-values="{id: \'{{vm.cAFAttachment.id}}\'}">Are you sure you want to delete this CAF Attachment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/c-af-attachment/caf-attachment-detail.html','<div><h2><span data-translate="investhryApp.cAFAttachment.detail.title">CAF Attachment</span> {{vm.cAFAttachment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.cAFAttachment.projectid">Projectid</span></dt><dd><span>{{vm.cAFAttachment.projectid}}</span></dd><dt><span data-translate="investhryApp.cAFAttachment.docName">Doc Name</span></dt><dd><span>{{vm.cAFAttachment.docName}}</span></dd><dt><span data-translate="investhryApp.cAFAttachment.fileName">File Name</span></dt><dd><span>{{vm.cAFAttachment.fileName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="caf-attachment-detail.edit({id:vm.cAFAttachment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/c-af-attachment/caf-attachment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCAFAttachmentLabel" data-translate="investhryApp.cAFAttachment.home.createOrEditLabel">Create or edit a CAF Attachment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cAFAttachment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cAFAttachment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cAFAttachment.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.cAFAttachment.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cAFAttachment.docName" for="field_docName">Doc Name</label><input type="text" class="form-control" name="docName" id="field_docName" ng-model="vm.cAFAttachment.docName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cAFAttachment.fileName" for="field_fileName">File Name</label><input type="text" class="form-control" name="fileName" id="field_fileName" ng-model="vm.cAFAttachment.fileName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/caf-otp/caf-otp-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cafOtp.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.cafOtp.delete.question" translate-values="{id: \'{{vm.cafOtp.id}}\'}">Are you sure you want to delete this Caf Otp?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/caf-otp/caf-otp-detail.html','<div><h2><span data-translate="investhryApp.cafOtp.detail.title">Caf Otp</span> {{vm.cafOtp.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.cafOtp.cafMobileNo">Caf Mobile No</span></dt><dd><span>{{vm.cafOtp.cafMobileNo}}</span></dd><dt><span data-translate="investhryApp.cafOtp.otp">Otp</span></dt><dd><span>{{vm.cafOtp.otp}}</span></dd><dt><span data-translate="investhryApp.cafOtp.userLogin">User Login</span></dt><dd><span>{{vm.cafOtp.userLogin}}</span></dd><dt><span data-translate="investhryApp.cafOtp.requestTimeOut">Request Time Out</span></dt><dd><span>{{vm.cafOtp.requestTimeOut | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="caf-otp-detail.edit({id:vm.cafOtp.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/caf-otp/caf-otp-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCafOtpLabel" data-translate="investhryApp.cafOtp.home.createOrEditLabel">Create or edit a Caf Otp</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cafOtp.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cafOtp.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafOtp.cafMobileNo" for="field_cafMobileNo">Caf Mobile No</label><input type="text" class="form-control" name="cafMobileNo" id="field_cafMobileNo" ng-model="vm.cafOtp.cafMobileNo"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafOtp.otp" for="field_otp">Otp</label><input type="text" class="form-control" name="otp" id="field_otp" ng-model="vm.cafOtp.otp"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafOtp.userLogin" for="field_userLogin">User Login</label><input type="text" class="form-control" name="userLogin" id="field_userLogin" ng-model="vm.cafOtp.userLogin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafOtp.requestTimeOut" for="field_requestTimeOut">Request Time Out</label><div class="input-group"><input id="field_requestTimeOut" type="text" class="form-control" name="requestTimeOut" datetime-picker="{{dateformat}}" ng-model="vm.cafOtp.requestTimeOut" is-open="vm.datePickerOpenStatus.requestTimeOut"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'requestTimeOut\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/caf-otp/caf-otps.html','<div><h2 data-translate="investhryApp.cafOtp.home.title">Caf Otps</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="caf-otp.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.cafOtp.home.createLabel">Create new Caf Otp</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.cafOtp.cafMobileNo">Caf Mobile No</span></th><th><span data-translate="investhryApp.cafOtp.otp">Otp</span></th><th><span data-translate="investhryApp.cafOtp.userLogin">User Login</span></th><th><span data-translate="investhryApp.cafOtp.requestTimeOut">Request Time Out</span></th><th></th></tr></thead><tbody><tr ng-repeat="cafOtp in vm.cafOtps track by cafOtp.id"><td><a ui-sref="caf-otp-detail({id:cafOtp.id})">{{cafOtp.id}}</a></td><td>{{cafOtp.cafMobileNo}}</td><td>{{cafOtp.otp}}</td><td>{{cafOtp.userLogin}}</td><td>{{cafOtp.requestTimeOut | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="caf-otp-detail({id:cafOtp.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="caf-otp.edit({id:cafOtp.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="caf-otp.delete({id:cafOtp.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/caf-with-no-service/caf-with-no-service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cafWithNoService.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.cafWithNoService.delete.question" translate-values="{id: \'{{vm.cafWithNoService.id}}\'}">Are you sure you want to delete this Caf With No Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/caf-with-no-service/caf-with-no-service-detail.html','<div><h2><span data-translate="investhryApp.cafWithNoService.detail.title">Caf With No Service</span> {{vm.cafWithNoService.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.cafWithNoService.address">Address</span></dt><dd><span>{{vm.cafWithNoService.address}}</span></dd><dt><span data-translate="investhryApp.cafWithNoService.applicationdate">Applicationdate</span></dt><dd><span>{{vm.cafWithNoService.applicationdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.cafWithNoService.businessentity">Businessentity</span></dt><dd><span>{{vm.cafWithNoService.businessentity}}</span></dd><dt><span data-translate="investhryApp.cafWithNoService.cafpin">Cafpin</span></dt><dd><span>{{vm.cafWithNoService.cafpin}}</span></dd><dt><span data-translate="investhryApp.cafWithNoService.caftype">Caftype</span></dt><dd><span>{{vm.cafWithNoService.caftype}}</span></dd><dt><span data-translate="investhryApp.cafWithNoService.emailprimary">Emailprimary</span></dt><dd><span>{{vm.cafWithNoService.emailprimary}}</span></dd><dt><span data-translate="investhryApp.cafWithNoService.investorName">Investor Name</span></dt><dd><span>{{vm.cafWithNoService.investorName}}</span></dd><dt><span data-translate="investhryApp.cafWithNoService.projectlevel">Projectlevel</span></dt><dd><span>{{vm.cafWithNoService.projectlevel}}</span></dd><dt><span data-translate="investhryApp.cafWithNoService.district">District</span></dt><dd><span>{{vm.cafWithNoService.district}}</span></dd><dt><span data-translate="investhryApp.cafWithNoService.createddate">Createddate</span></dt><dd><span>{{vm.cafWithNoService.createddate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="caf-with-no-service-detail.edit({id:vm.cafWithNoService.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/caf-with-no-service/caf-with-no-service-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCafWithNoServiceLabel" data-translate="investhryApp.cafWithNoService.home.createOrEditLabel">Create or edit a Caf With No Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cafWithNoService.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cafWithNoService.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafWithNoService.address" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.cafWithNoService.address"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafWithNoService.applicationdate" for="field_applicationdate">Applicationdate</label><div class="input-group"><input id="field_applicationdate" type="text" class="form-control" name="applicationdate" datetime-picker="{{dateformat}}" ng-model="vm.cafWithNoService.applicationdate" is-open="vm.datePickerOpenStatus.applicationdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'applicationdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafWithNoService.businessentity" for="field_businessentity">Businessentity</label><input type="text" class="form-control" name="businessentity" id="field_businessentity" ng-model="vm.cafWithNoService.businessentity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafWithNoService.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.cafWithNoService.cafpin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafWithNoService.caftype" for="field_caftype">Caftype</label><input type="text" class="form-control" name="caftype" id="field_caftype" ng-model="vm.cafWithNoService.caftype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafWithNoService.emailprimary" for="field_emailprimary">Emailprimary</label><input type="text" class="form-control" name="emailprimary" id="field_emailprimary" ng-model="vm.cafWithNoService.emailprimary"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafWithNoService.investorName" for="field_investorName">Investor Name</label><input type="text" class="form-control" name="investorName" id="field_investorName" ng-model="vm.cafWithNoService.investorName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafWithNoService.projectlevel" for="field_projectlevel">Projectlevel</label><input type="text" class="form-control" name="projectlevel" id="field_projectlevel" ng-model="vm.cafWithNoService.projectlevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafWithNoService.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.cafWithNoService.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafWithNoService.createddate" for="field_createddate">Createddate</label><div class="input-group"><input id="field_createddate" type="text" class="form-control" name="createddate" datetime-picker="{{dateformat}}" ng-model="vm.cafWithNoService.createddate" is-open="vm.datePickerOpenStatus.createddate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createddate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/caf-with-no-service/caf-with-no-services.html','<div><h2 data-translate="investhryApp.cafWithNoService.home.title">Caf With No Services</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="caf-with-no-service.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.cafWithNoService.home.createLabel">Create new Caf With No Service</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.cafWithNoService.address">Address</span></th><th><span data-translate="investhryApp.cafWithNoService.applicationdate">Applicationdate</span></th><th><span data-translate="investhryApp.cafWithNoService.businessentity">Businessentity</span></th><th><span data-translate="investhryApp.cafWithNoService.cafpin">Cafpin</span></th><th><span data-translate="investhryApp.cafWithNoService.caftype">Caftype</span></th><th><span data-translate="investhryApp.cafWithNoService.emailprimary">Emailprimary</span></th><th><span data-translate="investhryApp.cafWithNoService.investorName">Investor Name</span></th><th><span data-translate="investhryApp.cafWithNoService.projectlevel">Projectlevel</span></th><th><span data-translate="investhryApp.cafWithNoService.district">District</span></th><th><span data-translate="investhryApp.cafWithNoService.createddate">Createddate</span></th><th></th></tr></thead><tbody><tr ng-repeat="cafWithNoService in vm.cafWithNoServices track by cafWithNoService.id"><td><a ui-sref="caf-with-no-service-detail({id:cafWithNoService.id})">{{cafWithNoService.id}}</a></td><td>{{cafWithNoService.address}}</td><td>{{cafWithNoService.applicationdate | date:\'medium\'}}</td><td>{{cafWithNoService.businessentity}}</td><td>{{cafWithNoService.cafpin}}</td><td>{{cafWithNoService.caftype}}</td><td>{{cafWithNoService.emailprimary}}</td><td>{{cafWithNoService.investorName}}</td><td>{{cafWithNoService.projectlevel}}</td><td>{{cafWithNoService.district}}</td><td>{{cafWithNoService.createddate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="caf-with-no-service-detail({id:cafWithNoService.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="caf-with-no-service.edit({id:cafWithNoService.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="caf-with-no-service.delete({id:cafWithNoService.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/cafsfornodalofficer/cafsfornodalofficer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cafsfornodalofficer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.cafsfornodalofficer.delete.question" translate-values="{id: \'{{vm.cafsfornodalofficer.id}}\'}">Are you sure you want to delete this Cafsfornodalofficer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/cafsfornodalofficer/cafsfornodalofficer-detail.html','<div><h2><span data-translate="investhryApp.cafsfornodalofficer.detail.title">Cafsfornodalofficer</span> {{vm.cafsfornodalofficer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.cafsfornodalofficer.serviceName">Service Name</span></dt><dd><span>{{vm.cafsfornodalofficer.serviceName}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.cafpin">Cafpin</span></dt><dd><span>{{vm.cafsfornodalofficer.cafpin}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.rmInfo">Rm Info</span></dt><dd><span>{{vm.cafsfornodalofficer.rmInfo}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.totalProjectCost">Total Project Cost</span></dt><dd><span>{{vm.cafsfornodalofficer.totalProjectCost}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.proposedEmployment">Proposed Employment</span></dt><dd><span>{{vm.cafsfornodalofficer.proposedEmployment}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.district">District</span></dt><dd><span>{{vm.cafsfornodalofficer.district}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.projectLevel">Project Level</span></dt><dd><span>{{vm.cafsfornodalofficer.projectLevel}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.applicationDate">Application Date</span></dt><dd><span>{{vm.cafsfornodalofficer.applicationDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.lastActionDate">Last Action Date</span></dt><dd><span>{{vm.cafsfornodalofficer.lastActionDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.lastActionComment">Last Action Comment</span></dt><dd><span>{{vm.cafsfornodalofficer.lastActionComment}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.departmentName">Department Name</span></dt><dd><span>{{vm.cafsfornodalofficer.departmentName}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.status">Status</span></dt><dd><span>{{vm.cafsfornodalofficer.status}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.businessEntity">Business Entity</span></dt><dd><span>{{vm.cafsfornodalofficer.businessEntity}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.projectId">Project Id</span></dt><dd><span>{{vm.cafsfornodalofficer.projectId}}</span></dd><dt><span data-translate="investhryApp.cafsfornodalofficer.formfillstatus">Formfillstatus</span></dt><dd><span>{{vm.cafsfornodalofficer.formfillstatus}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="cafsfornodalofficer-detail.edit({id:vm.cafsfornodalofficer.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/cafsfornodalofficer/cafsfornodalofficer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCafsfornodalofficerLabel" data-translate="investhryApp.cafsfornodalofficer.home.createOrEditLabel">Create or edit a Cafsfornodalofficer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cafsfornodalofficer.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cafsfornodalofficer.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.cafsfornodalofficer.serviceName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.cafsfornodalofficer.cafpin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.rmInfo" for="field_rmInfo">Rm Info</label><input type="text" class="form-control" name="rmInfo" id="field_rmInfo" ng-model="vm.cafsfornodalofficer.rmInfo"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.totalProjectCost" for="field_totalProjectCost">Total Project Cost</label><input type="text" class="form-control" name="totalProjectCost" id="field_totalProjectCost" ng-model="vm.cafsfornodalofficer.totalProjectCost"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.proposedEmployment" for="field_proposedEmployment">Proposed Employment</label><input type="text" class="form-control" name="proposedEmployment" id="field_proposedEmployment" ng-model="vm.cafsfornodalofficer.proposedEmployment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.cafsfornodalofficer.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.projectLevel" for="field_projectLevel">Project Level</label><input type="text" class="form-control" name="projectLevel" id="field_projectLevel" ng-model="vm.cafsfornodalofficer.projectLevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.applicationDate" for="field_applicationDate">Application Date</label><div class="input-group"><input id="field_applicationDate" type="text" class="form-control" name="applicationDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.cafsfornodalofficer.applicationDate" is-open="vm.datePickerOpenStatus.applicationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'applicationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.lastActionDate" for="field_lastActionDate">Last Action Date</label><div class="input-group"><input id="field_lastActionDate" type="text" class="form-control" name="lastActionDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.cafsfornodalofficer.lastActionDate" is-open="vm.datePickerOpenStatus.lastActionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastActionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.lastActionComment" for="field_lastActionComment">Last Action Comment</label><input type="text" class="form-control" name="lastActionComment" id="field_lastActionComment" ng-model="vm.cafsfornodalofficer.lastActionComment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.cafsfornodalofficer.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.cafsfornodalofficer.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.businessEntity" for="field_businessEntity">Business Entity</label><input type="text" class="form-control" name="businessEntity" id="field_businessEntity" ng-model="vm.cafsfornodalofficer.businessEntity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.cafsfornodalofficer.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsfornodalofficer.formfillstatus" for="field_formfillstatus">Formfillstatus</label><input type="checkbox" name="formfillstatus" id="field_formfillstatus" ng-model="vm.cafsfornodalofficer.formfillstatus"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cafsfornodalofficer/cafsfornodalofficers.html','<div><h2 data-translate="investhryApp.cafsfornodalofficer.home.title">Cafsfornodalofficers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="cafsfornodalofficer.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.cafsfornodalofficer.home.createLabel">Create new Cafsfornodalofficer</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.serviceName">Service Name</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.cafpin">Cafpin</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.rmInfo">Rm Info</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.totalProjectCost">Total Project Cost</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.proposedEmployment">Proposed Employment</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.district">District</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.projectLevel">Project Level</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.applicationDate">Application Date</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.lastActionDate">Last Action Date</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.lastActionComment">Last Action Comment</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.departmentName">Department Name</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.status">Status</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.businessEntity">Business Entity</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.projectId">Project Id</span></th><th><span data-translate="investhryApp.cafsfornodalofficer.formfillstatus">Formfillstatus</span></th><th></th></tr></thead><tbody><tr ng-repeat="cafsfornodalofficer in vm.cafsfornodalofficers track by cafsfornodalofficer.id"><td><a ui-sref="cafsfornodalofficer-detail({id:cafsfornodalofficer.id})">{{cafsfornodalofficer.id}}</a></td><td>{{cafsfornodalofficer.serviceName}}</td><td>{{cafsfornodalofficer.cafpin}}</td><td>{{cafsfornodalofficer.rmInfo}}</td><td>{{cafsfornodalofficer.totalProjectCost}}</td><td>{{cafsfornodalofficer.proposedEmployment}}</td><td>{{cafsfornodalofficer.district}}</td><td>{{cafsfornodalofficer.projectLevel}}</td><td>{{cafsfornodalofficer.applicationDate | date:\'mediumDate\'}}</td><td>{{cafsfornodalofficer.lastActionDate | date:\'mediumDate\'}}</td><td>{{cafsfornodalofficer.lastActionComment}}</td><td>{{cafsfornodalofficer.departmentName}}</td><td>{{cafsfornodalofficer.status}}</td><td>{{cafsfornodalofficer.businessEntity}}</td><td>{{cafsfornodalofficer.projectId}}</td><td>{{cafsfornodalofficer.formfillstatus}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cafsfornodalofficer-detail({id:cafsfornodalofficer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="cafsfornodalofficer.edit({id:cafsfornodalofficer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="cafsfornodalofficer.delete({id:cafsfornodalofficer.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/cafsscheduledfordeactivation/cafsscheduledfordeactivation-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.cafsscheduledfordeactivation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.cafsscheduledfordeactivation.delete.question" translate-values="{id: \'{{vm.cafsscheduledfordeactivation.id}}\'}">Are you sure you want to delete this Cafsscheduledfordeactivation?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/cafsscheduledfordeactivation/cafsscheduledfordeactivation-detail.html','<div><h2><span data-translate="investhryApp.cafsscheduledfordeactivation.detail.title">Cafsscheduledfordeactivation</span> {{vm.cafsscheduledfordeactivation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.cafsscheduledfordeactivation.scheduledDeactivationDate">Scheduled Deactivation Date</span></dt><dd><span>{{vm.cafsscheduledfordeactivation.scheduledDeactivationDate | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="cafsscheduledfordeactivation-detail.edit({id:vm.cafsscheduledfordeactivation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/cafsscheduledfordeactivation/cafsscheduledfordeactivation-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCafsscheduledfordeactivationLabel" data-translate="investhryApp.cafsscheduledfordeactivation.home.createOrEditLabel">Create or edit a Cafsscheduledfordeactivation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cafsscheduledfordeactivation.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cafsscheduledfordeactivation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.cafsscheduledfordeactivation.scheduledDeactivationDate" for="field_scheduledDeactivationDate">Scheduled Deactivation Date</label><div class="input-group"><input id="field_scheduledDeactivationDate" type="text" class="form-control" name="scheduledDeactivationDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.cafsscheduledfordeactivation.scheduledDeactivationDate" is-open="vm.datePickerOpenStatus.scheduledDeactivationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'scheduledDeactivationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cafsscheduledfordeactivation/cafsscheduledfordeactivations.html','<div><h2 data-translate="investhryApp.cafsscheduledfordeactivation.home.title">Cafsscheduledfordeactivations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="cafsscheduledfordeactivation.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.cafsscheduledfordeactivation.home.createLabel">Create new Cafsscheduledfordeactivation</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.cafsscheduledfordeactivation.scheduledDeactivationDate">Scheduled Deactivation Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="cafsscheduledfordeactivation in vm.cafsscheduledfordeactivations track by cafsscheduledfordeactivation.id"><td><a ui-sref="cafsscheduledfordeactivation-detail({id:cafsscheduledfordeactivation.id})">{{cafsscheduledfordeactivation.id}}</a></td><td>{{cafsscheduledfordeactivation.scheduledDeactivationDate | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cafsscheduledfordeactivation-detail({id:cafsscheduledfordeactivation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="cafsscheduledfordeactivation.edit({id:cafsscheduledfordeactivation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="cafsscheduledfordeactivation.delete({id:cafsscheduledfordeactivation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/center-tower-user-data/center-tower-user-data-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.centerTowerUserData.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.centerTowerUserData.delete.question" translate-values="{id: \'{{vm.centerTowerUserData.id}}\'}">Are you sure you want to delete this Center Tower User Data?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/center-tower-user-data/center-tower-user-data-detail.html','<div><h2><span data-translate="investhryApp.centerTowerUserData.detail.title">Center Tower User Data</span> {{vm.centerTowerUserData.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.centerTowerUserData.stateCode">State Code</span></dt><dd><span>{{vm.centerTowerUserData.stateCode}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.userId">User Id</span></dt><dd><span>{{vm.centerTowerUserData.userId}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.requestId">Request Id</span></dt><dd><span>{{vm.centerTowerUserData.requestId}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.applicationType">Application Type</span></dt><dd><span>{{vm.centerTowerUserData.applicationType}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.applicationName">Application Name</span></dt><dd><span>{{vm.centerTowerUserData.applicationName}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.email">Email</span></dt><dd><span>{{vm.centerTowerUserData.email}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.mobileNumber">Mobile Number</span></dt><dd><span>{{vm.centerTowerUserData.mobileNumber}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.username">Username</span></dt><dd><span>{{vm.centerTowerUserData.username}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.districtCode">District Code</span></dt><dd><span>{{vm.centerTowerUserData.districtCode}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.applicantAddress">Applicant Address</span></dt><dd><span>{{vm.centerTowerUserData.applicantAddress}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.organisationType">Organisation Type</span></dt><dd><span>{{vm.centerTowerUserData.organisationType}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.organisationName">Organisation Name</span></dt><dd><span>{{vm.centerTowerUserData.organisationName}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.licenseNumber">License Number</span></dt><dd><span>{{vm.centerTowerUserData.licenseNumber}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.licenseExpiryDate">License Expiry Date</span></dt><dd><span>{{vm.centerTowerUserData.licenseExpiryDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.licenseCertificationPath">License Certification Path</span></dt><dd><span>{{vm.centerTowerUserData.licenseCertificationPath}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.authorizationLetterPath">Authorization Letter Path</span></dt><dd><span>{{vm.centerTowerUserData.authorizationLetterPath}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.isView">Is View</span></dt><dd><span>{{vm.centerTowerUserData.isView}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.applicationNumber">Application Number</span></dt><dd><span>{{vm.centerTowerUserData.applicationNumber}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.zipCode">Zip Code</span></dt><dd><span>{{vm.centerTowerUserData.zipCode}}</span></dd><dt><span data-translate="investhryApp.centerTowerUserData.createdDate">Created Date</span></dt><dd><span>{{vm.centerTowerUserData.createdDate | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="center-tower-user-data-detail.edit({id:vm.centerTowerUserData.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/center-tower-user-data/center-tower-user-data-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCenterTowerUserDataLabel" data-translate="investhryApp.centerTowerUserData.home.createOrEditLabel">Create or edit a Center Tower User Data</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.centerTowerUserData.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.centerTowerUserData.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.stateCode" for="field_stateCode">State Code</label><input type="number" class="form-control" name="stateCode" id="field_stateCode" ng-model="vm.centerTowerUserData.stateCode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.userId" for="field_userId">User Id</label><input type="text" class="form-control" name="userId" id="field_userId" ng-model="vm.centerTowerUserData.userId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.requestId" for="field_requestId">Request Id</label><input type="text" class="form-control" name="requestId" id="field_requestId" ng-model="vm.centerTowerUserData.requestId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.applicationType" for="field_applicationType">Application Type</label><input type="number" class="form-control" name="applicationType" id="field_applicationType" ng-model="vm.centerTowerUserData.applicationType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.applicationName" for="field_applicationName">Application Name</label><input type="text" class="form-control" name="applicationName" id="field_applicationName" ng-model="vm.centerTowerUserData.applicationName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.centerTowerUserData.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.mobileNumber" for="field_mobileNumber">Mobile Number</label><input type="text" class="form-control" name="mobileNumber" id="field_mobileNumber" ng-model="vm.centerTowerUserData.mobileNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.username" for="field_username">Username</label><input type="text" class="form-control" name="username" id="field_username" ng-model="vm.centerTowerUserData.username"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.districtCode" for="field_districtCode">District Code</label><input type="number" class="form-control" name="districtCode" id="field_districtCode" ng-model="vm.centerTowerUserData.districtCode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.applicantAddress" for="field_applicantAddress">Applicant Address</label><input type="text" class="form-control" name="applicantAddress" id="field_applicantAddress" ng-model="vm.centerTowerUserData.applicantAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.organisationType" for="field_organisationType">Organisation Type</label><input type="text" class="form-control" name="organisationType" id="field_organisationType" ng-model="vm.centerTowerUserData.organisationType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.organisationName" for="field_organisationName">Organisation Name</label><input type="text" class="form-control" name="organisationName" id="field_organisationName" ng-model="vm.centerTowerUserData.organisationName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.licenseNumber" for="field_licenseNumber">License Number</label><input type="text" class="form-control" name="licenseNumber" id="field_licenseNumber" ng-model="vm.centerTowerUserData.licenseNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.licenseExpiryDate" for="field_licenseExpiryDate">License Expiry Date</label><div class="input-group"><input id="field_licenseExpiryDate" type="text" class="form-control" name="licenseExpiryDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.centerTowerUserData.licenseExpiryDate" is-open="vm.datePickerOpenStatus.licenseExpiryDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'licenseExpiryDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.licenseCertificationPath" for="field_licenseCertificationPath">License Certification Path</label><input type="text" class="form-control" name="licenseCertificationPath" id="field_licenseCertificationPath" ng-model="vm.centerTowerUserData.licenseCertificationPath"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.authorizationLetterPath" for="field_authorizationLetterPath">Authorization Letter Path</label><input type="text" class="form-control" name="authorizationLetterPath" id="field_authorizationLetterPath" ng-model="vm.centerTowerUserData.authorizationLetterPath"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.isView" for="field_isView">Is View</label><input type="number" class="form-control" name="isView" id="field_isView" ng-model="vm.centerTowerUserData.isView"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.applicationNumber" for="field_applicationNumber">Application Number</label><input type="text" class="form-control" name="applicationNumber" id="field_applicationNumber" ng-model="vm.centerTowerUserData.applicationNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.zipCode" for="field_zipCode">Zip Code</label><input type="text" class="form-control" name="zipCode" id="field_zipCode" ng-model="vm.centerTowerUserData.zipCode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.centerTowerUserData.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.centerTowerUserData.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/center-tower-user-data/center-tower-user-data.html','<div><h2 data-translate="investhryApp.centerTowerUserData.home.title">Center Tower User Data</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="center-tower-user-data.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.centerTowerUserData.home.createLabel">Create new Center Tower User Data</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.centerTowerUserData.stateCode">State Code</span></th><th><span data-translate="investhryApp.centerTowerUserData.userId">User Id</span></th><th><span data-translate="investhryApp.centerTowerUserData.requestId">Request Id</span></th><th><span data-translate="investhryApp.centerTowerUserData.applicationType">Application Type</span></th><th><span data-translate="investhryApp.centerTowerUserData.applicationName">Application Name</span></th><th><span data-translate="investhryApp.centerTowerUserData.email">Email</span></th><th><span data-translate="investhryApp.centerTowerUserData.mobileNumber">Mobile Number</span></th><th><span data-translate="investhryApp.centerTowerUserData.username">Username</span></th><th><span data-translate="investhryApp.centerTowerUserData.districtCode">District Code</span></th><th><span data-translate="investhryApp.centerTowerUserData.applicantAddress">Applicant Address</span></th><th><span data-translate="investhryApp.centerTowerUserData.organisationType">Organisation Type</span></th><th><span data-translate="investhryApp.centerTowerUserData.organisationName">Organisation Name</span></th><th><span data-translate="investhryApp.centerTowerUserData.licenseNumber">License Number</span></th><th><span data-translate="investhryApp.centerTowerUserData.licenseExpiryDate">License Expiry Date</span></th><th><span data-translate="investhryApp.centerTowerUserData.licenseCertificationPath">License Certification Path</span></th><th><span data-translate="investhryApp.centerTowerUserData.authorizationLetterPath">Authorization Letter Path</span></th><th><span data-translate="investhryApp.centerTowerUserData.isView">Is View</span></th><th><span data-translate="investhryApp.centerTowerUserData.applicationNumber">Application Number</span></th><th><span data-translate="investhryApp.centerTowerUserData.zipCode">Zip Code</span></th><th><span data-translate="investhryApp.centerTowerUserData.createdDate">Created Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="centerTowerUserData in vm.centerTowerUserData track by centerTowerUserData.id"><td><a ui-sref="center-tower-user-data-detail({id:centerTowerUserData.id})">{{centerTowerUserData.id}}</a></td><td>{{centerTowerUserData.stateCode}}</td><td>{{centerTowerUserData.userId}}</td><td>{{centerTowerUserData.requestId}}</td><td>{{centerTowerUserData.applicationType}}</td><td>{{centerTowerUserData.applicationName}}</td><td>{{centerTowerUserData.email}}</td><td>{{centerTowerUserData.mobileNumber}}</td><td>{{centerTowerUserData.username}}</td><td>{{centerTowerUserData.districtCode}}</td><td>{{centerTowerUserData.applicantAddress}}</td><td>{{centerTowerUserData.organisationType}}</td><td>{{centerTowerUserData.organisationName}}</td><td>{{centerTowerUserData.licenseNumber}}</td><td>{{centerTowerUserData.licenseExpiryDate | date:\'mediumDate\'}}</td><td>{{centerTowerUserData.licenseCertificationPath}}</td><td>{{centerTowerUserData.authorizationLetterPath}}</td><td>{{centerTowerUserData.isView}}</td><td>{{centerTowerUserData.applicationNumber}}</td><td>{{centerTowerUserData.zipCode}}</td><td>{{centerTowerUserData.createdDate | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="center-tower-user-data-detail({id:centerTowerUserData.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="center-tower-user-data.edit({id:centerTowerUserData.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="center-tower-user-data.delete({id:centerTowerUserData.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/checklist/checklist-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.checklist.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.checklist.delete.question" translate-values="{id: \'{{vm.checklist.id}}\'}">Are you sure you want to delete this Checklist?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/checklist/checklist-detail.html','<div><h2><span data-translate="investhryApp.checklist.detail.title">Checklist</span> {{vm.checklist.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.checklist.serverFileName">Server File Name</span></dt><dd><span>{{vm.checklist.serverFileName}}</span></dd><dt><span data-translate="investhryApp.checklist.clientFileName">Client File Name</span></dt><dd><span>{{vm.checklist.clientFileName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="checklist-detail.edit({id:vm.checklist.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/checklist/checklist-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.UploadAttachment()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myChecklistLabel" data-translate="investhryApp.checklist.home.createOrEditLabel">Create or edit a Checklist</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label for="department">Department Name</label><select type="text" class="form-control" id="department" name="department" ng-model="vm.departmentId" ng-change="serviceByDepartment()" required><option value="" disabled="disabled">-- Select --</option><option value="{{department.id}}" ng-repeat="department in vm.departments">{{department.departmentname}}</option></select></div><div class="form-group"><label for="id">Service Name</label><select type="text" class="form-control" id="id" name="id" ng-model="vm.checklist.id" required><option value="" disabled="disabled">-- Select --</option><option value="{{departmentService.id}}" ng-repeat="departmentService in vm.departmentServices">{{departmentService.serviceName}}</option></select></div><div class="form-group"><label class="control-label" for="field_serverFileName">Check List (in ".pdf" format)</label><input type="file" class="form-control" name="serverFileName" id="field_serverFileName" file-model="vm.serviceAttachemnt" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.checklist.clientFileName" for="field_clientFileName">Client File Name</label>--><!--<input type="text" class="form-control" name="clientFileName" id="field_clientFileName"--><!--ng-model="vm.checklist.clientFileName"--><!--/>--><!--</div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/checklist/checklists.html','<div><h2 data-translate="investhryApp.checklist.home.title">Checklists</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="checklist.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.checklist.home.createLabel">Create new Checklist</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.checklist.serverFileName">Server File Name</span></th><th><span data-translate="investhryApp.checklist.clientFileName">Client File Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="checklist in vm.checklists track by checklist.id"><td><a ui-sref="checklist-detail({id:checklist.id})">{{checklist.id}}</a></td><td>{{checklist.serverFileName}}</td><td>{{checklist.clientFileName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="checklist-detail({id:checklist.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="checklist.edit({id:checklist.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="checklist.delete({id:checklist.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/city-town-village/city-town-village-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.city_town_village.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.city_town_village.delete.question" translate-values="{id: \'{{vm.city_town_village.id}}\'}">Are you sure you want to delete this City Town Village?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/city-town-village/city-town-village-detail.html','<div class="container"><h2><span data-translate="investhryApp.city_town_village.detail.title">City Town Village</span> {{vm.city_town_village.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.city_town_village.city_town_village_name">City Town Village Name</span></dt><dd><span>{{vm.city_town_village.city_town_village_name}}</span></dd><dt><span data-translate="investhryApp.city_town_village.blockname">Blockname</span></dt><dd><span>{{vm.city_town_village.blockname}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="city-town-village-detail.edit({id:vm.city_town_village.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/city-town-village/city-town-village-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCity_town_villageLabel" data-translate="investhryApp.city_town_village.home.createOrEditLabel">Create or edit a City Town Village</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.city_town_village.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.city_town_village.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.city_town_village.city_town_village_name" for="field_city_town_village_name">City Town Village Name</label><input type="text" class="form-control" name="city_town_village_name" id="field_city_town_village_name" ng-model="vm.city_town_village.city_town_village_name" required><div ng-show="editForm.city_town_village_name.$invalid"><p class="help-block" ng-show="editForm.city_town_village_name.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.city_town_village.blockname" for="field_blockname">Blockname</label><input type="text" class="form-control" name="blockname" id="field_blockname" ng-model="vm.city_town_village.blockname"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/city-town-village/city-town-villages.html','<div class="container"><h2 data-translate="investhryApp.city_town_village.home.title">City Town Villages</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="city-town-village.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.city_town_village.home.createLabel">Create new City Town Village</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.city_town_village.city_town_village_name">City Town Village Name</span></th><th><span data-translate="investhryApp.city_town_village.blockname">Blockname</span></th><th></th></tr></thead><tbody><tr ng-repeat="city_town_village in vm.city_town_villages track by city_town_village.id"><td><a ui-sref="city-town-village-detail({id:city_town_village.id})">{{city_town_village.id}}</a></td><td>{{city_town_village.city_town_village_name}}</td><td>{{city_town_village.blockname}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="city-town-village-detail({id:city_town_village.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="city-town-village.edit({id:city_town_village.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="city-town-village.delete({id:city_town_village.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/cleared-services/cleared-services-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.clearedServices.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.clearedServices.delete.question" translate-values="{id: \'{{vm.clearedServices.id}}\'}">Are you sure you want to delete this Cleared Services?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/cleared-services/cleared-services-detail.html','<div><h2><span data-translate="investhryApp.clearedServices.detail.title">Cleared Services</span> {{vm.clearedServices.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.clearedServices.clearedDate">Cleared Date</span></dt><dd><span>{{vm.clearedServices.clearedDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.clearedServices.serviceId">Service Id</span></dt><dd><span>{{vm.clearedServices.serviceId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="cleared-services-detail.edit({id:vm.clearedServices.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/cleared-services/cleared-services-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myClearedServicesLabel" data-translate="investhryApp.clearedServices.home.createOrEditLabel">Create or edit a Cleared Services</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.clearedServices.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.clearedServices.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.clearedServices.clearedDate" for="field_clearedDate">Cleared Date</label><div class="input-group"><input id="field_clearedDate" type="text" class="form-control" name="clearedDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.clearedServices.clearedDate" is-open="vm.datePickerOpenStatus.clearedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'clearedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.clearedServices.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.clearedServices.serviceId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cleared-services/cleared-services.html','<div><h2 data-translate="investhryApp.clearedServices.home.title">Cleared Services</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="cleared-services.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.clearedServices.home.createLabel">Create new Cleared Services</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.clearedServices.clearedDate">Cleared Date</span></th><th><span data-translate="investhryApp.clearedServices.serviceId">Service Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="clearedServices in vm.clearedServices track by clearedServices.id"><td><a ui-sref="cleared-services-detail({id:clearedServices.id})">{{clearedServices.id}}</a></td><td>{{clearedServices.clearedDate | date:\'mediumDate\'}}</td><td>{{clearedServices.serviceId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cleared-services-detail({id:clearedServices.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="cleared-services.edit({id:clearedServices.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="cleared-services.delete({id:clearedServices.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/companydetail/companydetail-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.companydetail.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.companydetail.delete.question" translate-values="{id: \'{{vm.companydetail.id}}\'}">Are you sure you want to delete this Companydetail?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/companydetail/companydetail-detail.html','<div><h2><span data-translate="investhryApp.companydetail.detail.title">Companydetail</span> {{vm.companydetail.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.companydetail.promoter_md_director">Promoter Md Director</span></dt><dd><span>{{vm.companydetail.promoter_md_director}}</span></dd><dt><span data-translate="investhryApp.companydetail.designation">Designation</span></dt><dd><span>{{vm.companydetail.designation}}</span></dd><dt><span data-translate="investhryApp.companydetail.businessentity">Businessentity</span></dt><dd><span>{{vm.companydetail.businessentity}}</span></dd><dt><span data-translate="investhryApp.companydetail.director_promoter_md_ceo_number">Director Promoter Md Ceo Number</span></dt><dd><span>{{vm.companydetail.director_promoter_md_ceo_number}}</span></dd><dt><span data-translate="investhryApp.companydetail.pan_number">Pan Number</span></dt><dd><span>{{vm.companydetail.pan_number}}</span></dd><dt><span data-translate="investhryApp.companydetail.aadhar_number">Aadhar Number</span></dt><dd><span>{{vm.companydetail.aadhar_number}}</span></dd><dt><span data-translate="investhryApp.companydetail.nri">Nri</span></dt><dd><span>{{vm.companydetail.nri}}</span></dd><dt><span data-translate="investhryApp.companydetail.tin_vat_number">Tin Vat Number</span></dt><dd><span>{{vm.companydetail.tin_vat_number}}</span></dd><dt><span data-translate="investhryApp.companydetail.cst_number">Cst Number</span></dt><dd><span>{{vm.companydetail.cst_number}}</span></dd><dt><span data-translate="investhryApp.companydetail.businessentitytype">Businessentitytype</span></dt><dd><span>{{vm.companydetail.businessentitytype}}</span></dd><dt><span data-translate="investhryApp.companydetail.createdate">Createdate</span></dt><dd><span>{{vm.companydetail.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.companydetail.updatedate">Updatedate</span></dt><dd><span>{{vm.companydetail.updatedate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.companydetail.gstnumber">Gstnumber</span></dt><dd><span>{{vm.companydetail.gstnumber}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="companydetail-detail.edit({id:vm.companydetail.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/companydetail/companydetail-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCompanydetailLabel" data-translate="investhryApp.companydetail.home.createOrEditLabel">Create or edit a Companydetail</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.companydetail.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.companydetail.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.promoter_md_director" for="field_promoter_md_director">Promoter Md Director</label><input type="text" class="form-control" name="promoter_md_director" id="field_promoter_md_director" ng-model="vm.companydetail.promoter_md_director"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.designation" for="field_designation">Designation</label><input type="text" class="form-control" name="designation" id="field_designation" ng-model="vm.companydetail.designation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.businessentity" for="field_businessentity">Businessentity</label><input type="text" class="form-control" name="businessentity" id="field_businessentity" ng-model="vm.companydetail.businessentity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.director_promoter_md_ceo_number" for="field_director_promoter_md_ceo_number">Director Promoter Md Ceo Number</label><input type="number" class="form-control" name="director_promoter_md_ceo_number" id="field_director_promoter_md_ceo_number" ng-model="vm.companydetail.director_promoter_md_ceo_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.pan_number" for="field_pan_number">Pan Number</label><input type="text" class="form-control" name="pan_number" id="field_pan_number" ng-model="vm.companydetail.pan_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.aadhar_number" for="field_aadhar_number">Aadhar Number</label><input type="text" class="form-control" name="aadhar_number" id="field_aadhar_number" ng-model="vm.companydetail.aadhar_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.nri" for="field_nri">Nri</label><input type="checkbox" class="form-control" name="nri" id="field_nri" ng-model="vm.companydetail.nri"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.tin_vat_number" for="field_tin_vat_number">Tin Vat Number</label><input type="text" class="form-control" name="tin_vat_number" id="field_tin_vat_number" ng-model="vm.companydetail.tin_vat_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.cst_number" for="field_cst_number">Cst Number</label><input type="text" class="form-control" name="cst_number" id="field_cst_number" ng-model="vm.companydetail.cst_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.businessentitytype" for="field_businessentitytype">Businessentitytype</label><input type="text" class="form-control" name="businessentitytype" id="field_businessentitytype" ng-model="vm.companydetail.businessentitytype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.companydetail.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.companydetail.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.companydetail.gstnumber" for="field_gstnumber">Gstnumber</label><input type="text" class="form-control" name="gstnumber" id="field_gstnumber" ng-model="vm.companydetail.gstnumber"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/companydetail/companydetails.html','<div><h2 data-translate="investhryApp.companydetail.home.title">Companydetails</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="companydetail.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.companydetail.home.createLabel">Create new Companydetail</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.companydetail.promoter_md_director">Promoter Md Director</span></th><th><span data-translate="investhryApp.companydetail.designation">Designation</span></th><th><span data-translate="investhryApp.companydetail.businessentity">Businessentity</span></th><th><span data-translate="investhryApp.companydetail.director_promoter_md_ceo_number">Director Promoter Md Ceo Number</span></th><th><span data-translate="investhryApp.companydetail.pan_number">Pan Number</span></th><th><span data-translate="investhryApp.companydetail.aadhar_number">Aadhar Number</span></th><th><span data-translate="investhryApp.companydetail.nri">Nri</span></th><th><span data-translate="investhryApp.companydetail.tin_vat_number">Tin Vat Number</span></th><th><span data-translate="investhryApp.companydetail.cst_number">Cst Number</span></th><th><span data-translate="investhryApp.companydetail.businessentitytype">Businessentitytype</span></th><th><span data-translate="investhryApp.companydetail.createdate">Createdate</span></th><th><span data-translate="investhryApp.companydetail.updatedate">Updatedate</span></th><th><span data-translate="investhryApp.companydetail.gstnumber">Gstnumber</span></th><th></th></tr></thead><tbody><tr ng-repeat="companydetail in vm.companydetails track by companydetail.id"><td><a ui-sref="companydetail-detail({id:companydetail.id})">{{companydetail.id}}</a></td><td>{{companydetail.promoter_md_director}}</td><td>{{companydetail.designation}}</td><td>{{companydetail.businessentity}}</td><td>{{companydetail.director_promoter_md_ceo_number}}</td><td>{{companydetail.pan_number}}</td><td>{{companydetail.aadhar_number}}</td><td>{{companydetail.nri}}</td><td>{{companydetail.tin_vat_number}}</td><td>{{companydetail.cst_number}}</td><td>{{companydetail.businessentitytype}}</td><td>{{companydetail.createdate | date:\'medium\'}}</td><td>{{companydetail.updatedate | date:\'medium\'}}</td><td>{{companydetail.gstnumber}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="companydetail-detail({id:companydetail.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="companydetail.edit({id:companydetail.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="companydetail.delete({id:companydetail.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/connectingroad/connectingroad-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.connectingroad.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.connectingroad.delete.question" translate-values="{id: \'{{vm.connectingroad.id}}\'}">Are you sure you want to delete this Connectingroad?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/connectingroad/connectingroad-detail.html','<div class="container"><h2><span data-translate="investhryApp.connectingroad.detail.title">Connectingroad</span> {{vm.connectingroad.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.connectingroad.connectingraodtype">Connectingraodtype</span></dt><dd><span>{{vm.connectingroad.connectingraodtype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="connectingroad-detail.edit({id:vm.connectingroad.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/connectingroad/connectingroad-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConnectingroadLabel" data-translate="investhryApp.connectingroad.home.createOrEditLabel">Create or edit a Connectingroad</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.connectingroad.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.connectingroad.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.connectingroad.connectingraodtype" for="field_connectingraodtype">Connectingraodtype</label><input type="text" class="form-control" name="connectingraodtype" id="field_connectingraodtype" ng-model="vm.connectingroad.connectingraodtype" required><div ng-show="editForm.connectingraodtype.$invalid"><p class="help-block" ng-show="editForm.connectingraodtype.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/connectingroad/connectingroads.html','<div class="container"><h2 data-translate="investhryApp.connectingroad.home.title">Connectingroads</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="connectingroad.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.connectingroad.home.createLabel">Create new Connectingroad</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.connectingroad.connectingraodtype">Connectingraodtype</span></th><th></th></tr></thead><tbody><tr ng-repeat="connectingroad in vm.connectingroads track by connectingroad.id"><td><a ui-sref="connectingroad-detail({id:connectingroad.id})">{{connectingroad.id}}</a></td><td>{{connectingroad.connectingraodtype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="connectingroad-detail({id:connectingroad.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="connectingroad.edit({id:connectingroad.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="connectingroad.delete({id:connectingroad.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/construction-permit-log/construction-permit-log-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.constructionPermitLog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.constructionPermitLog.delete.question" translate-values="{id: \'{{vm.constructionPermitLog.id}}\'}">Are you sure you want to delete this Construction Permit Log?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/construction-permit-log/construction-permit-log-detail.html','<div><h2><span data-translate="investhryApp.constructionPermitLog.detail.title">Construction Permit Log</span> {{vm.constructionPermitLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.constructionPermitLog.projectid">Projectid</span></dt><dd><span>{{vm.constructionPermitLog.projectid}}</span></dd><dt><span data-translate="investhryApp.constructionPermitLog.serviceid">Serviceid</span></dt><dd><span>{{vm.constructionPermitLog.serviceid}}</span></dd><dt><span data-translate="investhryApp.constructionPermitLog.actiondate">Actiondate</span></dt><dd><span>{{vm.constructionPermitLog.actiondate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.constructionPermitLog.action">Action</span></dt><dd><span>{{vm.constructionPermitLog.action}}</span></dd><dt><span data-translate="investhryApp.constructionPermitLog.clearanceURL">Clearance URL</span></dt><dd><span>{{vm.constructionPermitLog.clearanceURL}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="construction-permit-log-detail.edit({id:vm.constructionPermitLog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/construction-permit-log/construction-permit-log-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConstructionPermitLogLabel" data-translate="investhryApp.constructionPermitLog.home.createOrEditLabel">Create or edit a Construction Permit Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.constructionPermitLog.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.constructionPermitLog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitLog.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.constructionPermitLog.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitLog.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.constructionPermitLog.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitLog.actiondate" for="field_actiondate">Actiondate</label><div class="input-group"><input id="field_actiondate" type="text" class="form-control" name="actiondate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.constructionPermitLog.actiondate" is-open="vm.datePickerOpenStatus.actiondate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'actiondate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitLog.action" for="field_action">Action</label><input type="text" class="form-control" name="action" id="field_action" ng-model="vm.constructionPermitLog.action"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitLog.clearanceURL" for="field_clearanceURL">Clearance URL</label><input type="text" class="form-control" name="clearanceURL" id="field_clearanceURL" ng-model="vm.constructionPermitLog.clearanceURL"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/construction-permit-log/construction-permit-logs.html','<div><h2 data-translate="investhryApp.constructionPermitLog.home.title">Construction Permit Logs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="construction-permit-log.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.constructionPermitLog.home.createLabel">Create new Construction Permit Log</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.constructionPermitLog.projectid">Projectid</span></th><th><span data-translate="investhryApp.constructionPermitLog.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.constructionPermitLog.actiondate">Actiondate</span></th><th><span data-translate="investhryApp.constructionPermitLog.action">Action</span></th><th><span data-translate="investhryApp.constructionPermitLog.clearanceURL">Clearance URL</span></th><th></th></tr></thead><tbody><tr ng-repeat="constructionPermitLog in vm.constructionPermitLogs track by constructionPermitLog.id"><td><a ui-sref="construction-permit-log-detail({id:constructionPermitLog.id})">{{constructionPermitLog.id}}</a></td><td>{{constructionPermitLog.projectid}}</td><td>{{constructionPermitLog.serviceid}}</td><td>{{constructionPermitLog.actiondate | date:\'mediumDate\'}}</td><td>{{constructionPermitLog.action}}</td><td>{{constructionPermitLog.clearanceURL}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="construction-permit-log-detail({id:constructionPermitLog.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="construction-permit-log.edit({id:constructionPermitLog.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="construction-permit-log.delete({id:constructionPermitLog.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/construction-permit-approval-steps/construction-permit-approval-steps-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.constructionPermitApprovalSteps.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.constructionPermitApprovalSteps.delete.question" translate-values="{id: \'{{vm.constructionPermitApprovalSteps.id}}\'}">Are you sure you want to delete this Construction Permit Approval Steps?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/construction-permit-approval-steps/construction-permit-approval-steps-detail.html','<div><h2><span data-translate="investhryApp.constructionPermitApprovalSteps.detail.title">Construction Permit Approval Steps</span> {{vm.constructionPermitApprovalSteps.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.bPflag">B Pflag</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.bPflag}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.aAIflag">A A Iflag</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.aAIflag}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.nMAflag">N M Aflag</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.nMAflag}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.fFSflag">F F Sflag</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.fFSflag}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.tWCflag">T W Cflag</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.tWCflag}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.tECflag">T E Cflag</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.tECflag}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.projectId">Project Id</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.projectId}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.serviceId">Service Id</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.serviceId}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.serviceIdEC">Service Id EC</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.serviceIdEC}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.pIflag">P Iflag</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.pIflag}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.oCflag">O Cflag</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.oCflag}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.isFileUploaded">Is File Uploaded</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.isFileUploaded}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.aAIid">A A Iid</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.aAIid}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.nMAid">N M Aid</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.nMAid}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.tECid">T E Cid</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.tECid}}</span></dd><dt><span data-translate="investhryApp.constructionPermitApprovalSteps.fireNOCflag">Fire NO Cflag</span></dt><dd><span>{{vm.constructionPermitApprovalSteps.fireNOCflag}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="construction-permit-approval-steps-detail.edit({id:vm.constructionPermitApprovalSteps.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/construction-permit-approval-steps/construction-permit-approval-steps-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myConstructionPermitApprovalStepsLabel" data-translate="investhryApp.constructionPermitApprovalSteps.home.createOrEditLabel">Create or edit a Construction Permit Approval Steps</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.constructionPermitApprovalSteps.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.constructionPermitApprovalSteps.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.bPflag" for="field_bPflag">B Pflag</label><input type="checkbox" class="form-control" name="bPflag" id="field_bPflag" ng-model="vm.constructionPermitApprovalSteps.bPflag"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.aAIflag" for="field_aAIflag">A A Iflag</label><input type="checkbox" class="form-control" name="aAIflag" id="field_aAIflag" ng-model="vm.constructionPermitApprovalSteps.aAIflag"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.nMAflag" for="field_nMAflag">N M Aflag</label><input type="checkbox" class="form-control" name="nMAflag" id="field_nMAflag" ng-model="vm.constructionPermitApprovalSteps.nMAflag"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.fFSflag" for="field_fFSflag">F F Sflag</label><input type="checkbox" class="form-control" name="fFSflag" id="field_fFSflag" ng-model="vm.constructionPermitApprovalSteps.fFSflag"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.tWCflag" for="field_tWCflag">T W Cflag</label><input type="checkbox" class="form-control" name="tWCflag" id="field_tWCflag" ng-model="vm.constructionPermitApprovalSteps.tWCflag"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.tECflag" for="field_tECflag">T E Cflag</label><input type="checkbox" class="form-control" name="tECflag" id="field_tECflag" ng-model="vm.constructionPermitApprovalSteps.tECflag"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.constructionPermitApprovalSteps.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.constructionPermitApprovalSteps.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.serviceIdEC" for="field_serviceIdEC">Service Id EC</label><input type="text" class="form-control" name="serviceIdEC" id="field_serviceIdEC" ng-model="vm.constructionPermitApprovalSteps.serviceIdEC"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.pIflag" for="field_pIflag">P Iflag</label><input type="checkbox" class="form-control" name="pIflag" id="field_pIflag" ng-model="vm.constructionPermitApprovalSteps.pIflag"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.oCflag" for="field_oCflag">O Cflag</label><input type="checkbox" class="form-control" name="oCflag" id="field_oCflag" ng-model="vm.constructionPermitApprovalSteps.oCflag"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.isFileUploaded" for="field_isFileUploaded">Is File Uploaded</label><input type="checkbox" class="form-control" name="isFileUploaded" id="field_isFileUploaded" ng-model="vm.constructionPermitApprovalSteps.isFileUploaded"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.aAIid" for="field_aAIid">A A Iid</label><input type="text" class="form-control" name="aAIid" id="field_aAIid" ng-model="vm.constructionPermitApprovalSteps.aAIid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.nMAid" for="field_nMAid">N M Aid</label><input type="text" class="form-control" name="nMAid" id="field_nMAid" ng-model="vm.constructionPermitApprovalSteps.nMAid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.tECid" for="field_tECid">T E Cid</label><input type="text" class="form-control" name="tECid" id="field_tECid" ng-model="vm.constructionPermitApprovalSteps.tECid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.constructionPermitApprovalSteps.fireNOCflag" for="field_fireNOCflag">Fire NO Cflag</label><input type="checkbox" class="form-control" name="fireNOCflag" id="field_fireNOCflag" ng-model="vm.constructionPermitApprovalSteps.fireNOCflag"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/construction-permit-approval-steps/construction-permit-approval-steps.html','<div><h2 data-translate="investhryApp.constructionPermitApprovalSteps.home.title">Construction Permit Approval Steps</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="construction-permit-approval-steps.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.constructionPermitApprovalSteps.home.createLabel">Create new Construction Permit Approval Steps</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.bPflag">B Pflag</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.aAIflag">A A Iflag</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.nMAflag">N M Aflag</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.fFSflag">F F Sflag</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.tWCflag">T W Cflag</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.tECflag">T E Cflag</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.projectId">Project Id</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.serviceId">Service Id</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.serviceIdEC">Service Id EC</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.pIflag">P Iflag</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.oCflag">O Cflag</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.isFileUploaded">Is File Uploaded</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.aAIid">A A Iid</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.nMAid">N M Aid</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.tECid">T E Cid</span></th><th><span data-translate="investhryApp.constructionPermitApprovalSteps.fireNOCflag">Fire NO Cflag</span></th><th></th></tr></thead><tbody><tr ng-repeat="constructionPermitApprovalSteps in vm.constructionPermitApprovalSteps track by constructionPermitApprovalSteps.id"><td><a ui-sref="construction-permit-approval-steps-detail({id:constructionPermitApprovalSteps.id})">{{constructionPermitApprovalSteps.id}}</a></td><td>{{constructionPermitApprovalSteps.bPflag}}</td><td>{{constructionPermitApprovalSteps.aAIflag}}</td><td>{{constructionPermitApprovalSteps.nMAflag}}</td><td>{{constructionPermitApprovalSteps.fFSflag}}</td><td>{{constructionPermitApprovalSteps.tWCflag}}</td><td>{{constructionPermitApprovalSteps.tECflag}}</td><td>{{constructionPermitApprovalSteps.projectId}}</td><td>{{constructionPermitApprovalSteps.serviceId}}</td><td>{{constructionPermitApprovalSteps.serviceIdEC}}</td><td>{{constructionPermitApprovalSteps.pIflag}}</td><td>{{constructionPermitApprovalSteps.oCflag}}</td><td>{{constructionPermitApprovalSteps.isFileUploaded}}</td><td>{{constructionPermitApprovalSteps.aAIid}}</td><td>{{constructionPermitApprovalSteps.nMAid}}</td><td>{{constructionPermitApprovalSteps.tECid}}</td><td>{{constructionPermitApprovalSteps.fireNOCflag}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="construction-permit-approval-steps-detail({id:constructionPermitApprovalSteps.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="construction-permit-approval-steps.edit({id:constructionPermitApprovalSteps.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="construction-permit-approval-steps.delete({id:constructionPermitApprovalSteps.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/customertype/customertype-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.customertype.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.customertype.delete.question" translate-values="{id: \'{{vm.customertype.id}}\'}">Are you sure you want to delete this Customertype?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/customertype/customertype-detail.html','<div><h2><span data-translate="investhryApp.customertype.detail.title">Customertype</span> {{vm.customertype.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.customertype.customertype">Customertype</span></dt><dd><span>{{vm.customertype.customertype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="customertype-detail.edit({id:vm.customertype.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/customertype/customertype-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCustomertypeLabel" data-translate="investhryApp.customertype.home.createOrEditLabel">Create or edit a Customertype</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.customertype.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.customertype.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.customertype.customertype" for="field_customertype">Customertype</label><input type="text" class="form-control" name="customertype" id="field_customertype" ng-model="vm.customertype.customertype" required><div ng-show="editForm.customertype.$invalid"><p class="help-block" ng-show="editForm.customertype.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/customertype/customertypes.html','<div><h2 data-translate="investhryApp.customertype.home.title">Customertypes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="customertype.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.customertype.home.createLabel">Create new Customertype</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.customertype.customertype">Customertype</span></th><th></th></tr></thead><tbody><tr ng-repeat="customertype in vm.customertypes track by customertype.id"><td><a ui-sref="customertype-detail({id:customertype.id})">{{customertype.id}}</a></td><td>{{customertype.customertype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="customertype-detail({id:customertype.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="customertype.edit({id:customertype.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="customertype.delete({id:customertype.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/country/countries.html','<div class="container"><h2 data-translate="investhryApp.country.home.title">Countries</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="country.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.country.home.createLabel">Create new Country</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.country.countryname">Countryname</span></th><th></th></tr></thead><tbody><tr ng-repeat="country in vm.countries track by country.id"><td><a ui-sref="country-detail({id:country.id})">{{country.id}}</a></td><td>{{country.countryname}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="country-detail({id:country.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="country.edit({id:country.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="country.delete({id:country.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/country/country-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.country.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.country.delete.question" translate-values="{id: \'{{vm.country.id}}\'}">Are you sure you want to delete this Country?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/country/country-detail.html','<div><h2><span data-translate="investhryApp.country.detail.title">Country</span> {{vm.country.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.country.countryname">Countryname</span></dt><dd><span>{{vm.country.countryname}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="country-detail.edit({id:vm.country.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/country/country-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myCountryLabel" data-translate="investhryApp.country.home.createOrEditLabel">Create or edit a Country</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.country.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.country.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.country.countryname" for="field_countryname">Countryname</label><input type="text" class="form-control" name="countryname" id="field_countryname" ng-model="vm.country.countryname" required><div ng-show="editForm.countryname.$invalid"><p class="help-block" ng-show="editForm.countryname.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dashboardbetweendatescaf/dashboardbetweendatescaf-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dashboardbetweendatescaf.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.dashboardbetweendatescaf.delete.question" translate-values="{id: \'{{vm.dashboardbetweendatescaf.id}}\'}">Are you sure you want to delete this Dashboardbetweendatescaf?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dashboardbetweendatescaf/dashboardbetweendatescaf-detail.html','<div><h2><span data-translate="investhryApp.dashboardbetweendatescaf.detail.title">Dashboardbetweendatescaf</span> {{vm.dashboardbetweendatescaf.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.dashboardbetweendatescaf.serviceId">Service Id</span></dt><dd><span>{{vm.dashboardbetweendatescaf.serviceId}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.statusDate">Status Date</span></dt><dd><span>{{vm.dashboardbetweendatescaf.statusDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.status">Status</span></dt><dd><span>{{vm.dashboardbetweendatescaf.status}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.projectId">Project Id</span></dt><dd><span>{{vm.dashboardbetweendatescaf.projectId}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.cafpin">Cafpin</span></dt><dd><span>{{vm.dashboardbetweendatescaf.cafpin}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.businessEntity">Business Entity</span></dt><dd><span>{{vm.dashboardbetweendatescaf.businessEntity}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.district">District</span></dt><dd><span>{{vm.dashboardbetweendatescaf.district}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.projectLevel">Project Level</span></dt><dd><span>{{vm.dashboardbetweendatescaf.projectLevel}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.proposedEmployment">Proposed Employment</span></dt><dd><span>{{vm.dashboardbetweendatescaf.proposedEmployment}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.proposedInvestment">Proposed Investment</span></dt><dd><span>{{vm.dashboardbetweendatescaf.proposedInvestment}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.duration">Duration</span></dt><dd><span>{{vm.dashboardbetweendatescaf.duration}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.ageing">Ageing</span></dt><dd><span>{{vm.dashboardbetweendatescaf.ageing}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.formFilledOn">Form Filled On</span></dt><dd><span>{{vm.dashboardbetweendatescaf.formFilledOn | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.appliedDate">Applied Date</span></dt><dd><span>{{vm.dashboardbetweendatescaf.appliedDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.clearedDate">Cleared Date</span></dt><dd><span>{{vm.dashboardbetweendatescaf.clearedDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.serviceName">Service Name</span></dt><dd><span>{{vm.dashboardbetweendatescaf.serviceName}}</span></dd><dt><span data-translate="investhryApp.dashboardbetweendatescaf.rejectionDate">Rejection Date</span></dt><dd><span>{{vm.dashboardbetweendatescaf.rejectionDate | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dashboardbetweendatescaf-detail.edit({id:vm.dashboardbetweendatescaf.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dashboardbetweendatescaf/dashboardbetweendatescaf-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDashboardbetweendatescafLabel" data-translate="investhryApp.dashboardbetweendatescaf.home.createOrEditLabel">Create or edit a Dashboardbetweendatescaf</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.dashboardbetweendatescaf.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dashboardbetweendatescaf.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.dashboardbetweendatescaf.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.statusDate" for="field_statusDate">Status Date</label><div class="input-group"><input id="field_statusDate" type="text" class="form-control" name="statusDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.dashboardbetweendatescaf.statusDate" is-open="vm.datePickerOpenStatus.statusDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'statusDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.dashboardbetweendatescaf.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.dashboardbetweendatescaf.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.dashboardbetweendatescaf.cafpin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.businessEntity" for="field_businessEntity">Business Entity</label><input type="text" class="form-control" name="businessEntity" id="field_businessEntity" ng-model="vm.dashboardbetweendatescaf.businessEntity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.dashboardbetweendatescaf.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.projectLevel" for="field_projectLevel">Project Level</label><input type="text" class="form-control" name="projectLevel" id="field_projectLevel" ng-model="vm.dashboardbetweendatescaf.projectLevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.proposedEmployment" for="field_proposedEmployment">Proposed Employment</label><input type="text" class="form-control" name="proposedEmployment" id="field_proposedEmployment" ng-model="vm.dashboardbetweendatescaf.proposedEmployment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.proposedInvestment" for="field_proposedInvestment">Proposed Investment</label><input type="text" class="form-control" name="proposedInvestment" id="field_proposedInvestment" ng-model="vm.dashboardbetweendatescaf.proposedInvestment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.duration" for="field_duration">Duration</label><input type="text" class="form-control" name="duration" id="field_duration" ng-model="vm.dashboardbetweendatescaf.duration"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.ageing" for="field_ageing">Ageing</label><input type="text" class="form-control" name="ageing" id="field_ageing" ng-model="vm.dashboardbetweendatescaf.ageing"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.formFilledOn" for="field_formFilledOn">Form Filled On</label><div class="input-group"><input id="field_formFilledOn" type="text" class="form-control" name="formFilledOn" uib-datepicker-popup="{{dateformat}}" ng-model="vm.dashboardbetweendatescaf.formFilledOn" is-open="vm.datePickerOpenStatus.formFilledOn"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'formFilledOn\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.appliedDate" for="field_appliedDate">Applied Date</label><div class="input-group"><input id="field_appliedDate" type="text" class="form-control" name="appliedDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.dashboardbetweendatescaf.appliedDate" is-open="vm.datePickerOpenStatus.appliedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'appliedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.clearedDate" for="field_clearedDate">Cleared Date</label><div class="input-group"><input id="field_clearedDate" type="text" class="form-control" name="clearedDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.dashboardbetweendatescaf.clearedDate" is-open="vm.datePickerOpenStatus.clearedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'clearedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.dashboardbetweendatescaf.serviceName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dashboardbetweendatescaf.rejectionDate" for="field_rejectionDate">Rejection Date</label><div class="input-group"><input id="field_rejectionDate" type="text" class="form-control" name="rejectionDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.dashboardbetweendatescaf.rejectionDate" is-open="vm.datePickerOpenStatus.rejectionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'rejectionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dashboardbetweendatescaf/dashboardbetweendatescafs.html','<div><h2 data-translate="investhryApp.dashboardbetweendatescaf.home.title">Dashboardbetweendatescafs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dashboardbetweendatescaf.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.dashboardbetweendatescaf.home.createLabel">Create new Dashboardbetweendatescaf</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.serviceId">Service Id</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.statusDate">Status Date</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.status">Status</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.projectId">Project Id</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.cafpin">Cafpin</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.businessEntity">Business Entity</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.district">District</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.projectLevel">Project Level</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.proposedEmployment">Proposed Employment</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.proposedInvestment">Proposed Investment</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.duration">Duration</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.ageing">Ageing</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.formFilledOn">Form Filled On</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.appliedDate">Applied Date</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.clearedDate">Cleared Date</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.serviceName">Service Name</span></th><th><span data-translate="investhryApp.dashboardbetweendatescaf.rejectionDate">Rejection Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="dashboardbetweendatescaf in vm.dashboardbetweendatescafs track by dashboardbetweendatescaf.id"><td><a ui-sref="dashboardbetweendatescaf-detail({id:dashboardbetweendatescaf.id})">{{dashboardbetweendatescaf.id}}</a></td><td>{{dashboardbetweendatescaf.serviceId}}</td><td>{{dashboardbetweendatescaf.statusDate | date:\'mediumDate\'}}</td><td>{{dashboardbetweendatescaf.status}}</td><td>{{dashboardbetweendatescaf.projectId}}</td><td>{{dashboardbetweendatescaf.cafpin}}</td><td>{{dashboardbetweendatescaf.businessEntity}}</td><td>{{dashboardbetweendatescaf.district}}</td><td>{{dashboardbetweendatescaf.projectLevel}}</td><td>{{dashboardbetweendatescaf.proposedEmployment}}</td><td>{{dashboardbetweendatescaf.proposedInvestment}}</td><td>{{dashboardbetweendatescaf.duration}}</td><td>{{dashboardbetweendatescaf.ageing}}</td><td>{{dashboardbetweendatescaf.formFilledOn | date:\'mediumDate\'}}</td><td>{{dashboardbetweendatescaf.appliedDate | date:\'mediumDate\'}}</td><td>{{dashboardbetweendatescaf.clearedDate | date:\'mediumDate\'}}</td><td>{{dashboardbetweendatescaf.serviceName}}</td><td>{{dashboardbetweendatescaf.rejectionDate | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dashboardbetweendatescaf-detail({id:dashboardbetweendatescaf.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="dashboardbetweendatescaf.edit({id:dashboardbetweendatescaf.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dashboardbetweendatescaf.delete({id:dashboardbetweendatescaf.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/decriminalization/decriminalization-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.decriminalization.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.decriminalization.delete.question" translate-values="{id: \'{{vm.decriminalization.id}}\'}">Are you sure you want to delete this Decriminalization?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/decriminalization/decriminalization-detail.html','<div><h2><span data-translate="investhryApp.decriminalization.detail.title">Decriminalization</span> {{vm.decriminalization.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.decriminalization.complianceRequest">Compliance Request</span></dt><dd><span>{{vm.decriminalization.complianceRequest}}</span></dd><dt><span data-translate="investhryApp.decriminalization.departmentName">Department Name</span></dt><dd><span>{{vm.decriminalization.departmentName}}</span></dd><dt><span data-translate="investhryApp.decriminalization.departmentId">Department Id</span></dt><dd><span>{{vm.decriminalization.departmentId}}</span></dd><dt><span data-translate="investhryApp.decriminalization.serviceType">Service Type</span></dt><dd><span>{{vm.decriminalization.serviceType}}</span></dd><dt><span data-translate="investhryApp.decriminalization.otherServiceType">Other Service Type</span></dt><dd><span>{{vm.decriminalization.otherServiceType}}</span></dd><dt><span data-translate="investhryApp.decriminalization.serviceSchemeName">Service Scheme Name</span></dt><dd><span>{{vm.decriminalization.serviceSchemeName}}</span></dd><dt><span data-translate="investhryApp.decriminalization.actName">Act Name</span></dt><dd><span>{{vm.decriminalization.actName}}</span></dd><dt><span data-translate="investhryApp.decriminalization.ruleRegulation">Rule Regulation</span></dt><dd><span>{{vm.decriminalization.ruleRegulation}}</span></dd><dt><span data-translate="investhryApp.decriminalization.ruleRegulationName">Rule Regulation Name</span></dt><dd><span>{{vm.decriminalization.ruleRegulationName}}</span></dd><dt><span data-translate="investhryApp.decriminalization.sectionRuleNumber">Section Rule Number</span></dt><dd><span>{{vm.decriminalization.sectionRuleNumber}}</span></dd><dt><span data-translate="investhryApp.decriminalization.sectionRuleNumberCriminalProvision">Section Rule Number Criminal Provision</span></dt><dd><span>{{vm.decriminalization.sectionRuleNumberCriminalProvision}}</span></dd><dt><span data-translate="investhryApp.decriminalization.criminalPunishmentDescription">Criminal Punishment Description</span></dt><dd><span>{{vm.decriminalization.criminalPunishmentDescription}}</span></dd><dt><span data-translate="investhryApp.decriminalization.sector">Sector</span></dt><dd><span>{{vm.decriminalization.sector}}</span></dd><dt><span data-translate="investhryApp.decriminalization.otherSector">Other Sector</span></dt><dd><span>{{vm.decriminalization.otherSector}}</span></dd><dt><span data-translate="investhryApp.decriminalization.offence">Offence</span></dt><dd><span>{{vm.decriminalization.offence}}</span></dd><dt><span data-translate="investhryApp.decriminalization.criminalPunishmentTenureInMonths">Criminal Punishment Tenure In Months</span></dt><dd><span>{{vm.decriminalization.criminalPunishmentTenureInMonths}}</span></dd><dt><span data-translate="investhryApp.decriminalization.minimumTenure">Minimum Tenure</span></dt><dd><span>{{vm.decriminalization.minimumTenure}}</span></dd><dt><span data-translate="investhryApp.decriminalization.maximumTenure">Maximum Tenure</span></dt><dd><span>{{vm.decriminalization.maximumTenure}}</span></dd><dt><span data-translate="investhryApp.decriminalization.criminalPunishmentAmountInInr">Criminal Punishment Amount In Inr</span></dt><dd><span>{{vm.decriminalization.criminalPunishmentAmountInInr}}</span></dd><dt><span data-translate="investhryApp.decriminalization.minimumAmount">Minimum Amount</span></dt><dd><span>{{vm.decriminalization.minimumAmount}}</span></dd><dt><span data-translate="investhryApp.decriminalization.maximumAmount">Maximum Amount</span></dt><dd><span>{{vm.decriminalization.maximumAmount}}</span></dd><dt><span data-translate="investhryApp.decriminalization.createDate">Create Date</span></dt><dd><span>{{vm.decriminalization.createDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.decriminalization.updateDate">Update Date</span></dt><dd><span>{{vm.decriminalization.updateDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.decriminalization.sectorId">Sector Id</span></dt><dd><span>{{vm.decriminalization.sectorId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="decriminalization-detail.edit({id:vm.decriminalization.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/decriminalization/decriminalization-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDecriminalizationLabel" data-translate="investhryApp.decriminalization.home.createOrEditLabel">Create or edit a Decriminalization</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.decriminalization.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.decriminalization.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.complianceRequest" for="field_complianceRequest">Compliance Request</label><input type="text" class="form-control" name="complianceRequest" id="field_complianceRequest" ng-model="vm.decriminalization.complianceRequest"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.decriminalization.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.departmentId" for="field_departmentId">Department Id</label><input type="text" class="form-control" name="departmentId" id="field_departmentId" ng-model="vm.decriminalization.departmentId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.serviceType" for="field_serviceType">Service Type</label><input type="text" class="form-control" name="serviceType" id="field_serviceType" ng-model="vm.decriminalization.serviceType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.otherServiceType" for="field_otherServiceType">Other Service Type</label><input type="text" class="form-control" name="otherServiceType" id="field_otherServiceType" ng-model="vm.decriminalization.otherServiceType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.serviceSchemeName" for="field_serviceSchemeName">Service Scheme Name</label><input type="text" class="form-control" name="serviceSchemeName" id="field_serviceSchemeName" ng-model="vm.decriminalization.serviceSchemeName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.actName" for="field_actName">Act Name</label><input type="text" class="form-control" name="actName" id="field_actName" ng-model="vm.decriminalization.actName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.ruleRegulation" for="field_ruleRegulation">Rule Regulation</label><input type="text" class="form-control" name="ruleRegulation" id="field_ruleRegulation" ng-model="vm.decriminalization.ruleRegulation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.ruleRegulationName" for="field_ruleRegulationName">Rule Regulation Name</label><input type="text" class="form-control" name="ruleRegulationName" id="field_ruleRegulationName" ng-model="vm.decriminalization.ruleRegulationName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.sectionRuleNumber" for="field_sectionRuleNumber">Section Rule Number</label><input type="text" class="form-control" name="sectionRuleNumber" id="field_sectionRuleNumber" ng-model="vm.decriminalization.sectionRuleNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.sectionRuleNumberCriminalProvision" for="field_sectionRuleNumberCriminalProvision">Section Rule Number Criminal Provision</label><input type="text" class="form-control" name="sectionRuleNumberCriminalProvision" id="field_sectionRuleNumberCriminalProvision" ng-model="vm.decriminalization.sectionRuleNumberCriminalProvision"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.criminalPunishmentDescription" for="field_criminalPunishmentDescription">Criminal Punishment Description</label><input type="text" class="form-control" name="criminalPunishmentDescription" id="field_criminalPunishmentDescription" ng-model="vm.decriminalization.criminalPunishmentDescription"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.sector" for="field_sector">Sector</label><input type="text" class="form-control" name="sector" id="field_sector" ng-model="vm.decriminalization.sector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.otherSector" for="field_otherSector">Other Sector</label><input type="text" class="form-control" name="otherSector" id="field_otherSector" ng-model="vm.decriminalization.otherSector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.offence" for="field_offence">Offence</label><input type="text" class="form-control" name="offence" id="field_offence" ng-model="vm.decriminalization.offence"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.criminalPunishmentTenureInMonths" for="field_criminalPunishmentTenureInMonths">Criminal Punishment Tenure In Months</label><input type="text" class="form-control" name="criminalPunishmentTenureInMonths" id="field_criminalPunishmentTenureInMonths" ng-model="vm.decriminalization.criminalPunishmentTenureInMonths"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.minimumTenure" for="field_minimumTenure">Minimum Tenure</label><input type="text" class="form-control" name="minimumTenure" id="field_minimumTenure" ng-model="vm.decriminalization.minimumTenure"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.maximumTenure" for="field_maximumTenure">Maximum Tenure</label><input type="text" class="form-control" name="maximumTenure" id="field_maximumTenure" ng-model="vm.decriminalization.maximumTenure"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.criminalPunishmentAmountInInr" for="field_criminalPunishmentAmountInInr">Criminal Punishment Amount In Inr</label><input type="text" class="form-control" name="criminalPunishmentAmountInInr" id="field_criminalPunishmentAmountInInr" ng-model="vm.decriminalization.criminalPunishmentAmountInInr"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.minimumAmount" for="field_minimumAmount">Minimum Amount</label><input type="text" class="form-control" name="minimumAmount" id="field_minimumAmount" ng-model="vm.decriminalization.minimumAmount"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.maximumAmount" for="field_maximumAmount">Maximum Amount</label><input type="text" class="form-control" name="maximumAmount" id="field_maximumAmount" ng-model="vm.decriminalization.maximumAmount"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.createDate" for="field_createDate">Create Date</label><div class="input-group"><input id="field_createDate" type="text" class="form-control" name="createDate" datetime-picker="{{dateformat}}" ng-model="vm.decriminalization.createDate" is-open="vm.datePickerOpenStatus.createDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.updateDate" for="field_updateDate">Update Date</label><div class="input-group"><input id="field_updateDate" type="text" class="form-control" name="updateDate" datetime-picker="{{dateformat}}" ng-model="vm.decriminalization.updateDate" is-open="vm.datePickerOpenStatus.updateDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updateDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.decriminalization.sectorId" for="field_sectorId">Sector Id</label><input type="text" class="form-control" name="sectorId" id="field_sectorId" ng-model="vm.decriminalization.sectorId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/decriminalization/decriminalizations.html','<div><h2 data-translate="investhryApp.decriminalization.home.title">Decriminalizations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="decriminalization.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.decriminalization.home.createLabel">Create new Decriminalization</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.decriminalization.complianceRequest">Compliance Request</span></th><th><span data-translate="investhryApp.decriminalization.departmentName">Department Name</span></th><th><span data-translate="investhryApp.decriminalization.departmentId">Department Id</span></th><th><span data-translate="investhryApp.decriminalization.serviceType">Service Type</span></th><th><span data-translate="investhryApp.decriminalization.otherServiceType">Other Service Type</span></th><th><span data-translate="investhryApp.decriminalization.serviceSchemeName">Service Scheme Name</span></th><th><span data-translate="investhryApp.decriminalization.actName">Act Name</span></th><th><span data-translate="investhryApp.decriminalization.ruleRegulation">Rule Regulation</span></th><th><span data-translate="investhryApp.decriminalization.ruleRegulationName">Rule Regulation Name</span></th><th><span data-translate="investhryApp.decriminalization.sectionRuleNumber">Section Rule Number</span></th><th><span data-translate="investhryApp.decriminalization.sectionRuleNumberCriminalProvision">Section Rule Number Criminal Provision</span></th><th><span data-translate="investhryApp.decriminalization.criminalPunishmentDescription">Criminal Punishment Description</span></th><th><span data-translate="investhryApp.decriminalization.sector">Sector</span></th><th><span data-translate="investhryApp.decriminalization.otherSector">Other Sector</span></th><th><span data-translate="investhryApp.decriminalization.offence">Offence</span></th><th><span data-translate="investhryApp.decriminalization.criminalPunishmentTenureInMonths">Criminal Punishment Tenure In Months</span></th><th><span data-translate="investhryApp.decriminalization.minimumTenure">Minimum Tenure</span></th><th><span data-translate="investhryApp.decriminalization.maximumTenure">Maximum Tenure</span></th><th><span data-translate="investhryApp.decriminalization.criminalPunishmentAmountInInr">Criminal Punishment Amount In Inr</span></th><th><span data-translate="investhryApp.decriminalization.minimumAmount">Minimum Amount</span></th><th><span data-translate="investhryApp.decriminalization.maximumAmount">Maximum Amount</span></th><th><span data-translate="investhryApp.decriminalization.createDate">Create Date</span></th><th><span data-translate="investhryApp.decriminalization.updateDate">Update Date</span></th><th><span data-translate="investhryApp.decriminalization.sectorId">Sector Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="decriminalization in vm.decriminalizations track by decriminalization.id"><td><a ui-sref="decriminalization-detail({id:decriminalization.id})">{{decriminalization.id}}</a></td><td>{{decriminalization.complianceRequest}}</td><td>{{decriminalization.departmentName}}</td><td>{{decriminalization.departmentId}}</td><td>{{decriminalization.serviceType}}</td><td>{{decriminalization.otherServiceType}}</td><td>{{decriminalization.serviceSchemeName}}</td><td>{{decriminalization.actName}}</td><td>{{decriminalization.ruleRegulation}}</td><td>{{decriminalization.ruleRegulationName}}</td><td>{{decriminalization.sectionRuleNumber}}</td><td>{{decriminalization.sectionRuleNumberCriminalProvision}}</td><td>{{decriminalization.criminalPunishmentDescription}}</td><td>{{decriminalization.sector}}</td><td>{{decriminalization.otherSector}}</td><td>{{decriminalization.offence}}</td><td>{{decriminalization.criminalPunishmentTenureInMonths}}</td><td>{{decriminalization.minimumTenure}}</td><td>{{decriminalization.maximumTenure}}</td><td>{{decriminalization.criminalPunishmentAmountInInr}}</td><td>{{decriminalization.minimumAmount}}</td><td>{{decriminalization.maximumAmount}}</td><td>{{decriminalization.createDate | date:\'medium\'}}</td><td>{{decriminalization.updateDate | date:\'medium\'}}</td><td>{{decriminalization.sectorId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="decriminalization-detail({id:decriminalization.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="decriminalization.edit({id:decriminalization.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="decriminalization.delete({id:decriminalization.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/deemed-clearance-approval/deemed-clearance-approval-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.deemedClearanceApproval.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.deemedClearanceApproval.delete.question" translate-values="{id: \'{{vm.deemedClearanceApproval.id}}\'}">Are you sure you want to delete this Deemed Clearance Approval?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/deemed-clearance-approval/deemed-clearance-approval-detail.html','<div><h2><span data-translate="investhryApp.deemedClearanceApproval.detail.title">Deemed Clearance Approval</span> {{vm.deemedClearanceApproval.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.deemedClearanceApproval.projectid">Projectid</span></dt><dd><span>{{vm.deemedClearanceApproval.projectid}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.serviceid">Serviceid</span></dt><dd><span>{{vm.deemedClearanceApproval.serviceid}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.cafpin">Cafpin</span></dt><dd><span>{{vm.deemedClearanceApproval.cafpin}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.serviceName">Service Name</span></dt><dd><span>{{vm.deemedClearanceApproval.serviceName}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.departmentName">Department Name</span></dt><dd><span>{{vm.deemedClearanceApproval.departmentName}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.forwardedToDO">Forwarded To DO</span></dt><dd><span>{{vm.deemedClearanceApproval.forwardedToDO}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.fowardedtoADI">Fowardedto ADI</span></dt><dd><span>{{vm.deemedClearanceApproval.fowardedtoADI}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.forwardedtoDI">Forwardedto DI</span></dt><dd><span>{{vm.deemedClearanceApproval.forwardedtoDI}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.forwardedtoCEO">Forwardedto CEO</span></dt><dd><span>{{vm.deemedClearanceApproval.forwardedtoCEO}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.approved">Approved</span></dt><dd><span>{{vm.deemedClearanceApproval.approved}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.discarded">Discarded</span></dt><dd><span>{{vm.deemedClearanceApproval.discarded}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.discardedby">Discardedby</span></dt><dd><span>{{vm.deemedClearanceApproval.discardedby}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.discardcomment">Discardcomment</span></dt><dd><span>{{vm.deemedClearanceApproval.discardcomment}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.status">Status</span></dt><dd><span>{{vm.deemedClearanceApproval.status}}</span></dd><dt><span data-translate="investhryApp.deemedClearanceApproval.projectlevel">Projectlevel</span></dt><dd><span>{{vm.deemedClearanceApproval.projectlevel}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="deemed-clearance-approval-detail.edit({id:vm.deemedClearanceApproval.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/deemed-clearance-approval/deemed-clearance-approval-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDeemedClearanceApprovalLabel" data-translate="investhryApp.deemedClearanceApproval.home.createOrEditLabel">Create or edit a Deemed Clearance Approval</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.deemedClearanceApproval.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.deemedClearanceApproval.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.deemedClearanceApproval.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.deemedClearanceApproval.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.deemedClearanceApproval.cafpin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.deemedClearanceApproval.serviceName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.deemedClearanceApproval.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.forwardedToDO" for="field_forwardedToDO">Forwarded To DO</label><input type="checkbox" class="form-control" name="forwardedToDO" id="field_forwardedToDO" ng-model="vm.deemedClearanceApproval.forwardedToDO"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.fowardedtoADI" for="field_fowardedtoADI">Fowardedto ADI</label><input type="checkbox" class="form-control" name="fowardedtoADI" id="field_fowardedtoADI" ng-model="vm.deemedClearanceApproval.fowardedtoADI"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.forwardedtoDI" for="field_forwardedtoDI">Forwardedto DI</label><input type="checkbox" class="form-control" name="forwardedtoDI" id="field_forwardedtoDI" ng-model="vm.deemedClearanceApproval.forwardedtoDI"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.forwardedtoCEO" for="field_forwardedtoCEO">Forwardedto CEO</label><input type="checkbox" class="form-control" name="forwardedtoCEO" id="field_forwardedtoCEO" ng-model="vm.deemedClearanceApproval.forwardedtoCEO"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.approved" for="field_approved">Approved</label><input type="checkbox" class="form-control" name="approved" id="field_approved" ng-model="vm.deemedClearanceApproval.approved"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.discarded" for="field_discarded">Discarded</label><input type="checkbox" class="form-control" name="discarded" id="field_discarded" ng-model="vm.deemedClearanceApproval.discarded"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.discardedby" for="field_discardedby">Discardedby</label><input type="text" class="form-control" name="discardedby" id="field_discardedby" ng-model="vm.deemedClearanceApproval.discardedby"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.discardcomment" for="field_discardcomment">Discardcomment</label><input type="text" class="form-control" name="discardcomment" id="field_discardcomment" ng-model="vm.deemedClearanceApproval.discardcomment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.deemedClearanceApproval.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.deemedClearanceApproval.projectlevel" for="field_projectlevel">Projectlevel</label><input type="text" class="form-control" name="projectlevel" id="field_projectlevel" ng-model="vm.deemedClearanceApproval.projectlevel"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/deemed-clearance-approval/deemed-clearance-approvals.html','<div><h2 data-translate="investhryApp.deemedClearanceApproval.home.title">Deemed Clearance Approvals</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="deemed-clearance-approval.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.deemedClearanceApproval.home.createLabel">Create new Deemed Clearance Approval</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.projectid">Projectid</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.cafpin">Cafpin</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.serviceName">Service Name</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.departmentName">Department Name</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.forwardedToDO">Forwarded To DO</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.fowardedtoADI">Fowardedto ADI</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.forwardedtoDI">Forwardedto DI</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.forwardedtoCEO">Forwardedto CEO</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.approved">Approved</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.discarded">Discarded</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.discardedby">Discardedby</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.discardcomment">Discardcomment</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.status">Status</span></th><th><span data-translate="investhryApp.deemedClearanceApproval.projectlevel">Projectlevel</span></th><th></th></tr></thead><tbody><tr ng-repeat="deemedClearanceApproval in vm.deemedClearanceApprovals track by deemedClearanceApproval.id"><td><a ui-sref="deemed-clearance-approval-detail({id:deemedClearanceApproval.id})">{{deemedClearanceApproval.id}}</a></td><td>{{deemedClearanceApproval.projectid}}</td><td>{{deemedClearanceApproval.serviceid}}</td><td>{{deemedClearanceApproval.cafpin}}</td><td>{{deemedClearanceApproval.serviceName}}</td><td>{{deemedClearanceApproval.departmentName}}</td><td>{{deemedClearanceApproval.forwardedToDO}}</td><td>{{deemedClearanceApproval.fowardedtoADI}}</td><td>{{deemedClearanceApproval.forwardedtoDI}}</td><td>{{deemedClearanceApproval.forwardedtoCEO}}</td><td>{{deemedClearanceApproval.approved}}</td><td>{{deemedClearanceApproval.discarded}}</td><td>{{deemedClearanceApproval.discardedby}}</td><td>{{deemedClearanceApproval.discardcomment}}</td><td>{{deemedClearanceApproval.status}}</td><td>{{deemedClearanceApproval.projectlevel}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="deemed-clearance-approval-detail({id:deemedClearanceApproval.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="deemed-clearance-approval.edit({id:deemedClearanceApproval.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="deemed-clearance-approval.delete({id:deemedClearanceApproval.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/department/department-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.department.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.department.delete.question" translate-values="{id: \'{{vm.department.id}}\'}">Are you sure you want to delete this Department?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/department/department-detail.html','<div><h2><span data-translate="investhryApp.department.detail.title">Department</span> {{vm.department.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.department.departmentname">Departmentname</span></dt><dd><span>{{vm.department.departmentname}}</span></dd><dt><span data-translate="investhryApp.department.description">Description</span></dt><dd><span>{{vm.department.description}}</span></dd><dt><span data-translate="investhryApp.department.hod">Hod</span></dt><dd><span>{{vm.department.hod}}</span></dd><dt><span data-translate="investhryApp.department.email">Email</span></dt><dd><span>{{vm.department.email}}</span></dd><dt><span data-translate="investhryApp.department.hodmobile">Hodmobile</span></dt><dd><span>{{vm.department.hodmobile}}</span></dd><dt><span data-translate="investhryApp.department.nodalofficer">Nodalofficer</span></dt><dd><span>{{vm.department.nodalofficer}}</span></dd><dt><span data-translate="investhryApp.department.departmentorder">Departmentorder</span></dt><dd><span>{{vm.department.departmentorder}}</span></dd><dt><span data-translate="investhryApp.department.istower">Istower</span></dt><dd><span>{{vm.department.istower}}</span></dd><dt><span data-translate="investhryApp.department.isrow">Isrow</span></dt><dd><span>{{vm.department.isrow}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="department-detail.edit({id:vm.department.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/department/department-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDepartmentLabel" data-translate="investhryApp.department.home.createOrEditLabel">Create or edit a Department</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.department.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.department.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.department.departmentname" for="field_departmentname">Departmentname</label><input type="text" class="form-control" name="departmentname" id="field_departmentname" ng-model="vm.department.departmentname" required><div ng-show="editForm.departmentname.$invalid"><p class="help-block" ng-show="editForm.departmentname.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.department.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.department.description" required><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.department.hod" for="field_hod">Hod</label><input type="text" class="form-control" name="hod" id="field_hod" ng-model="vm.department.hod"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.department.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.department.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.department.hodmobile" for="field_hodmobile">Hodmobile</label><input type="text" class="form-control" name="hodmobile" id="field_hodmobile" ng-model="vm.department.hodmobile"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.department.nodalofficer" for="field_nodalofficer">Nodalofficer</label><input type="text" class="form-control" name="nodalofficer" id="field_nodalofficer" ng-model="vm.department.nodalofficer"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.department.departmentorder" for="field_departmentorder">Departmentorder</label><input type="number" class="form-control" name="departmentorder" id="field_departmentorder" ng-model="vm.department.departmentorder"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.department.istower" for="field_istower">Istower</label><input type="checkbox" name="istower" id="field_istower" ng-model="vm.department.istower"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.department.isrow" for="field_isrow">Isrow</label><input type="checkbox" name="isrow" id="field_isrow" ng-model="vm.department.isrow"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/department/departments.html','<div><h2 data-translate="investhryApp.department.home.title">Departments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="department.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.department.home.createLabel">Create new Department</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.department.departmentname">Departmentname</span></th><th><span data-translate="investhryApp.department.description">Description</span></th><th><span data-translate="investhryApp.department.hod">Hod</span></th><th><span data-translate="investhryApp.department.email">Email</span></th><th><span data-translate="investhryApp.department.hodmobile">Hodmobile</span></th><th><span data-translate="investhryApp.department.nodalofficer">Nodalofficer</span></th><th><span data-translate="investhryApp.department.departmentorder">Departmentorder</span></th><th><span data-translate="investhryApp.department.istower">Istower</span></th><th><span data-translate="investhryApp.department.isrow">Isrow</span></th><th></th></tr></thead><tbody><tr ng-repeat="department in vm.departments track by department.id"><td><a ui-sref="department-detail({id:department.id})">{{department.id}}</a></td><td>{{department.departmentname}}</td><td>{{department.description}}</td><td>{{department.hod}}</td><td>{{department.email}}</td><td>{{department.hodmobile}}</td><td>{{department.nodalofficer}}</td><td>{{department.departmentorder}}</td><td>{{department.istower}}</td><td>{{department.isrow}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="department-detail({id:department.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="department.edit({id:department.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="department.delete({id:department.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/department-hod/department-hod-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.departmentHod.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.departmentHod.delete.question" translate-values="{id: \'{{vm.departmentHod.id}}\'}">Are you sure you want to delete this Department Hod?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/department-hod/department-hod-detail.html','<div><h2><span data-translate="investhryApp.departmentHod.detail.title">Department Hod</span> {{vm.departmentHod.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.departmentHod.departmentId">Department Id</span></dt><dd><span>{{vm.departmentHod.departmentId}}</span></dd><dt><span data-translate="investhryApp.departmentHod.departmentName">Department Name</span></dt><dd><span>{{vm.departmentHod.departmentName}}</span></dd><dt><span data-translate="investhryApp.departmentHod.login">Login</span></dt><dd><span>{{vm.departmentHod.login}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="department-hod-detail.edit({id:vm.departmentHod.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/department-hod/department-hod-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDepartmentHodLabel" data-translate="investhryApp.departmentHod.home.createOrEditLabel">Create or edit a Department Hod</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.departmentHod.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.departmentHod.id" readonly="readonly"></div><div class="form-group"><label class="control-label" for="field_departmentName">Department Name</label><select class="form-control" ng-model="vm.selectedDepartment" ng-options="department.departmentname for department in vm.departments" name="departmentName" id="field_departmentName" ng-change="vm.onDepartmentChange(vm.selectedDepartment)" required><option value="" disabled="disabled">Select Department</option></select><div ng-show="editForm.departmentName.$invalid"><p class="help-block" ng-show="editForm.departmentName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentHod.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.departmentHod.login"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/department-hod/department-hods.html','<div><h2 data-translate="investhryApp.departmentHod.home.title">Department Hods</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="department-hod.new"><span>Create Department Hod</span></button></div></div></div><br><div class="container"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.departmentHod.departmentId">Department Id</span></th><th><span data-translate="investhryApp.departmentHod.departmentName">Department Name</span></th><th><span data-translate="investhryApp.departmentHod.login">Login</span></th><th></th></tr></thead><tbody><tr ng-repeat="departmentHod in vm.departmentHods track by departmentHod.id"><td><a ui-sref="department-hod-detail({id:departmentHod.id})">{{departmentHod.id}}</a></td><td>{{departmentHod.departmentId}}</td><td>{{departmentHod.departmentName}}</td><td>{{departmentHod.login}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="department-hod-detail({id:departmentHod.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="department-hod.edit({id:departmentHod.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="department-hod.delete({id:departmentHod.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/department-service/department-service-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.departmentService.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.departmentService.delete.question" translate-values="{id: \'{{vm.departmentService.id}}\'}">Are you sure you want to delete this Department Service?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/department-service/department-service-detail.html','<div><h2><span data-translate="investhryApp.departmentService.detail.title">Department Service</span> {{vm.departmentService.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.departmentService.serviceName">Service Name</span></dt><dd><span>{{vm.departmentService.serviceName}}</span></dd><dt><span data-translate="investhryApp.departmentService.serviceDescription">Service Description</span></dt><dd><span>{{vm.departmentService.serviceDescription}}</span></dd><dt><span data-translate="investhryApp.departmentService.duration">Duration</span></dt><dd><span>{{vm.departmentService.duration}}</span></dd><dt><span data-translate="investhryApp.departmentService.stage">Stage</span></dt><dd><span>{{vm.departmentService.stage}}</span></dd><dt><span>RTS Days</span></dt><dd><span>{{vm.departmentService.rtsDays}}</span></dd><dt><span data-translate="investhryApp.departmentService.departmentname">Departmentname</span></dt><dd><span>{{vm.departmentService.departmentname}}</span></dd><dt><span data-translate="investhryApp.departmentService.departmentid">Departmentid</span></dt><dd><span>{{vm.departmentService.departmentid}}</span></dd><dt><span data-translate="investhryApp.departmentService.isRenewable">Is Renewable</span></dt><dd><span>{{vm.departmentService.isRenewable}}</span></dd><dt><span data-translate="investhryApp.departmentService.isShop">Is Shop</span></dt><dd><span>{{vm.departmentService.isShop}}</span></dd><dt><span data-translate="investhryApp.departmentService.constructionpermit">Constructionpermit</span></dt><dd><span>{{vm.departmentService.constructionpermit}}</span></dd><dt><span data-translate="investhryApp.departmentService.active">Active</span></dt><dd><span>{{vm.departmentService.active}}</span></dd><dt><span data-translate="investhryApp.departmentService.istowerservice">Istowerservice</span></dt><dd><span>{{vm.departmentService.istowerservice}}</span></dd><dt><span data-translate="investhryApp.departmentService.integrationDate">Integration Date</span></dt><dd><span>{{vm.departmentService.integrationDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.departmentService.url">Url</span></dt><dd><span>{{vm.departmentService.url}}</span></dd><dt><span data-translate="investhryApp.departmentService.isIntegrated">Is Integrated</span></dt><dd><span>{{vm.departmentService.isIntegrated}}</span></dd><dt><span data-translate="investhryApp.departmentService.islandexchange">Islandexchange</span></dt><dd><span>{{vm.departmentService.islandexchange}}</span></dd><dt><span data-translate="investhryApp.departmentService.isRowService">Is Row Service</span></dt><dd><span>{{vm.departmentService.isRowService}}</span></dd><dt><span data-translate="investhryApp.departmentService.isNewService">Is New Service</span></dt><dd><span>{{vm.departmentService.isNewService}}</span></dd><dt><span>Is Excise Service</span></dt><dd><span>{{vm.departmentService.isExciseService}}</span></dd><dt><span data-translate="investhryApp.departmentService.isLandRequirement">Is Land Requirement</span></dt><dd><span>{{vm.departmentService.isLandRequirement}}</span></dd><dt><span data-translate="investhryApp.departmentService.downloadUrl">Download Url</span></dt><dd><span>{{vm.departmentService.downloadUrl}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="department-service-detail.edit({id:vm.departmentService.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/department-service/department-service-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDepartmentServiceLabel" data-translate="investhryApp.departmentService.home.createOrEditLabel">Create or edit a Department Service</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.departmentService.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.departmentService.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.departmentService.serviceName" required><div ng-show="editForm.serviceName.$invalid"><p class="help-block" ng-show="editForm.serviceName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_approvalId">Approval Id</label><input type="text" class="form-control" name="approvalId" id="field_approvalId" ng-model="vm.departmentService.approvalId"><!--            <div ng-show="editForm.serviceName.$invalid">--><!--                <p class="help-block"--><!--                   ng-show="editForm.serviceName.$error.required" data-translate="entity.validation.required">--><!--                    This field is required.--><!--                </p>--><!--            </div>--></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.serviceDescription" for="field_serviceDescription">Service Description</label><input type="text" class="form-control" name="serviceDescription" id="field_serviceDescription" ng-model="vm.departmentService.serviceDescription" required><div ng-show="editForm.serviceDescription.$invalid"><p class="help-block" ng-show="editForm.serviceDescription.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.duration" for="field_duration">Duration</label><input type="number" class="form-control" name="duration" id="field_duration" ng-model="vm.departmentService.duration"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.stage" for="field_stage">Stage</label><input type="text" class="form-control" name="stage" id="field_stage" ng-model="vm.departmentService.stage"></div><div class="form-group"><label class="control-label" for="rst_days">RTS Days</label><input type="number" class="form-control" name="stage" id="rst_days" ng-model="vm.departmentService.rtsDays"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.departmentname" for="field_departmentname">Departmentname</label><input type="text" class="form-control" name="departmentname" id="field_departmentname" ng-model="vm.departmentService.departmentname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.departmentid" for="field_departmentid">Departmentid</label><input type="text" class="form-control" name="departmentid" id="field_departmentid" ng-model="vm.departmentService.departmentid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.constructionpermit" for="field_constructionpermit">Constructionpermit</label><input type="text" class="form-control" name="constructionpermit" id="field_constructionpermit" ng-model="vm.departmentService.constructionpermit"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.isIntegrated" for="field_isIntegrated">Is Integrated</label><input type="checkbox" name="isIntegrated" id="field_isIntegrated" ng-model="vm.departmentService.isIntegrated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.integrationDate" for="field_integrationDate">Integration Date</label><div class="input-group"><input id="field_integrationDate" type="text" class="form-control" name="integrationDate" datetime-picker="{{dateformat}}" ng-model="vm.departmentService.integrationDate" is-open="vm.datePickerOpenStatus.integrationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'integrationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.url" for="field_url">Url</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.departmentService.url"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.downloadUrl" for="downloadUrl">Download Url</label><input type="text" class="form-control" name="downloadUrl" id="downloadUrl" ng-model="vm.departmentService.downloadUrl"></div><div class="form-group"><label class="control-label" for="actName">Act Name</label><input type="text" class="form-control" name="actName" id="actName" ng-model="vm.departmentService.actName"></div><div class="form-group"><label class="control-label" for="ruleApplicable">Rule Applicable</label><input type="text" class="form-control" name="ruleApplicable" id="ruleApplicable" ng-model="vm.departmentService.ruleApplicable"></div><div class="form-group"><label class="control-label" for="periodicity">Periodicity</label><input type="text" class="form-control" name="periodicity" id="periodicity" ng-model="vm.departmentService.periodicity"></div><div class="form-group"><label class="control-label" for="downloadUrl">Penal Provision</label><input type="text" class="form-control" name="penalProvision" id="penalProvision" ng-model="vm.departmentService.penalProvision"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.active" for="field_active">Active</label><input type="checkbox" name="active" id="field_active" ng-model="vm.departmentService.active"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.isRemoveFromDashboards" for="field_active">isRemoveFromDashboards</label><input type="checkbox" name="isRemoveFromDashboards" id="field_isRemoveFromDashboards" ng-model="vm.departmentService.isRemoveFromDashboards"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.istowerservice" for="field_istowerservice">Istowerservice</label><input type="checkbox" name="istowerservice" id="field_istowerservice" ng-model="vm.departmentService.istowerservice"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.isRenewable" for="field_isRenewable">Is Renewable</label><input type="checkbox" name="isRenewable" id="field_isRenewable" ng-model="vm.departmentService.isRenewable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.isShop" for="field_isShop">Is Shop</label><input type="checkbox" name="isShop" id="field_isShop" ng-model="vm.departmentService.isShop"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.islandexchange" for="field_islandexchange">Islandexchange</label><input type="checkbox" name="islandexchange" id="field_islandexchange" ng-model="vm.departmentService.islandexchange"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.isRowService" for="field_isRowService">Is Row Service</label><input type="checkbox" name="isRowService" id="field_isRowService" ng-model="vm.departmentService.isRowService"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.isNewService" for="field_isNewService">Is New Service</label><input type="checkbox" name="isNewService" id="field_isNewService" ng-model="vm.departmentService.isNewService"></div><div class="form-group"><label class="control-label" for="field_isExciseService">Is Excise Service</label><input type="checkbox" name="isExciseService" id="field_isExciseService" ng-model="vm.departmentService.isExciseService"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentService.isLandRequirement" for="field_isLandRequirement">Is Land Requirement</label><input type="checkbox" name="isLandRequirement" id="field_isLandRequirement" ng-model="vm.departmentService.isLandRequirement"></div><div class="form-group"><label class="control-label" for="field_isFilm">Is Film</label><input type="checkbox" name="isFilm" id="field_isFilm" ng-model="vm.departmentService.isFilm"></div><div class="form-group"><label class="control-label" for="field_showThirdPartyServiceDashboard">Show Third Party Service Dashboard</label><input type="checkbox" name="showThirdPartyServiceDashboard" id="field_showThirdPartyServiceDashboard" ng-model="vm.departmentService.showThirdPartyServiceDashboard"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/department-service/department-services.html','<div><h2 data-translate="investhryApp.departmentService.home.title">Department Services</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="department-service.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.departmentService.home.createLabel">Create new Department Service</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.departmentService.serviceName">Service Name</span></th><th><span data-translate="investhryApp.departmentService.serviceDescription">Service Description</span></th><th><span data-translate="investhryApp.departmentService.duration">Duration</span></th><th><span data-translate="investhryApp.departmentService.stage">Stage</span></th><th><span>RTS Days</span></th><th><span>Mean Time</span></th><th><span>Median</span></th><th><span>Approval Id</span></th><th><span data-translate="investhryApp.departmentService.departmentname">Departmentname</span></th><th><span data-translate="investhryApp.departmentService.departmentid">Departmentid</span></th><th><span>Act Name</span></th><th><span>Rule Applicable</span></th><th><span>Periodicity</span></th><th><span>Penal Provision</span></th><th><span data-translate="investhryApp.departmentService.isRenewable">Is Renewable</span></th><th><span data-translate="investhryApp.departmentService.isShop">Is Shop</span></th><th><span data-translate="investhryApp.departmentService.constructionpermit">Constructionpermit</span></th><th><span data-translate="investhryApp.departmentService.active">Active</span></th><th><span>/isFilm</span></th><th><span data-translate="investhryApp.departmentService.isRemoveFromDashboards">RemoveFromDashboards</span></th><th><span data-translate="investhryApp.departmentService.istowerservice">Istowerservice</span></th><th><span data-translate="investhryApp.departmentService.integrationDate">Integration Date</span></th><th><span data-translate="investhryApp.departmentService.url">Url</span></th><th><span data-translate="investhryApp.departmentService.isIntegrated">Is Integrated</span></th><th><span data-translate="investhryApp.departmentService.islandexchange">Islandexchange</span></th><th><span data-translate="investhryApp.departmentService.isRowService">Is Row Service</span></th><th><span data-translate="investhryApp.departmentService.isNewService">Is New Service</span></th><th><span>Is Excise Service</span></th><th><span data-translate="investhryApp.departmentService.isLandRequirement">Is Land Requirement</span></th><th><span data-translate="investhryApp.departmentService.downloadUrl">Download Url</span></th><th></th></tr></thead><tbody><tr ng-repeat="departmentService in vm.departmentServices track by departmentService.id"><td>{{$index+1}}</td><td><a ui-sref="department-service-detail({id:departmentService.id})">{{departmentService.id}}</a></td><td>{{departmentService.serviceName}}</td><td>{{departmentService.serviceDescription}}</td><td>{{departmentService.duration}}</td><td>{{departmentService.stage}}</td><td>{{departmentService.rtsDays}}</td><td>{{departmentService.meanTime}}</td><td>{{departmentService.median}}</td><td>{{departmentService.approvalId}}</td><td>{{departmentService.departmentname}}</td><td>{{departmentService.departmentid}}</td><td>{{departmentService.actName}}</td><td>{{departmentService.ruleApplicable}}</td><td>{{departmentService.periodicity}}</td><td>{{departmentService.penalProvision}}</td><td>{{departmentService.isRenewable}}</td><td>{{departmentService.isShop}}</td><td>{{departmentService.constructionpermit}}</td><td>{{departmentService.active}}</td><td>{{departmentService.isFilm}}</td><td>{{departmentService.isRemoveFromDashboards}}</td><td>{{departmentService.istowerservice}}</td><td>{{departmentService.integrationDate | date:\'medium\'}}</td><td>{{departmentService.url}}</td><td>{{departmentService.isIntegrated}}</td><td>{{departmentService.islandexchange}}</td><td>{{departmentService.isRowService}}</td><td>{{departmentService.isNewService}}</td><td>{{departmentService.isExciseService}}</td><td>{{departmentService.isLandRequirement}}</td><td>{{departmentService.downloadUrl}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="department-service-detail({id:departmentService.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="department-service.edit({id:departmentService.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="department-service.delete({id:departmentService.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/departmentservice/departmentservice-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.departmentservice.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.departmentservice.delete.question" translate-values="{id: \'{{vm.departmentservice.id}}\'}">Are you sure you want to delete this Departmentservice?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/departmentservice/departmentservice-detail.html','<div class="container"><h2><span data-translate="investhryApp.departmentservice.detail.title">Departmentservice</span> {{vm.departmentservice.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.departmentservice.duration">Duration</span></dt><dd><span>{{vm.departmentservice.duration}}</span></dd><dt><span data-translate="investhryApp.departmentservice.stage">Stage</span></dt><dd><span>{{vm.departmentservice.stage}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="departmentservice-detail.edit({id:vm.departmentservice.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/departmentservice/departmentservice-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDepartmentserviceLabel" data-translate="investhryApp.departmentservice.home.createOrEditLabel">Create or edit a Departmentservice</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.departmentservice.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.departmentservice.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentservice.duration" for="field_duration">Duration</label><input type="text" class="form-control" name="duration" id="field_duration" ng-model="vm.departmentservice.duration"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.departmentservice.stage" for="field_stage">Stage</label><input type="text" class="form-control" name="stage" id="field_stage" ng-model="vm.departmentservice.stage"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/departmentservice/departmentservices.html','<div class="container"><h2 data-translate="investhryApp.departmentservice.home.title">Departmentservices</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="departmentservice.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.departmentservice.home.createLabel">Create new Departmentservice</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.departmentservice.duration">Duration</span></th><th><span data-translate="investhryApp.departmentservice.stage">Stage</span></th><th></th></tr></thead><tbody><tr ng-repeat="departmentservice in vm.departmentservices track by departmentservice.id"><td><a ui-sref="departmentservice-detail({id:departmentservice.id})">{{departmentservice.id}}</a></td><td>{{departmentservice.duration}}</td><td>{{departmentservice.stage}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="departmentservice-detail({id:departmentservice.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="departmentservice.edit({id:departmentservice.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="departmentservice.delete({id:departmentservice.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/dispute/dispute-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.dispute.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.dispute.delete.question" translate-values="{id: \'{{vm.dispute.id}}\'}">Are you sure you want to delete this Dispute?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dispute/dispute-detail.html','<div><h2><span data-translate="investhryApp.dispute.detail.title">Dispute</span> {{vm.dispute.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.dispute.nameOfEnterprise">Name Of Enterprise</span></dt><dd><span>{{vm.dispute.nameOfEnterprise}}</span></dd><dt><span data-translate="investhryApp.dispute.activity">Activity</span></dt><dd><span>{{vm.dispute.activity}}</span></dd><dt><span data-translate="investhryApp.dispute.nameOfPartner">Name Of Partner</span></dt><dd><span>{{vm.dispute.nameOfPartner}}</span></dd><dt><span data-translate="investhryApp.dispute.mobileNumber">Mobile Number</span></dt><dd><span>{{vm.dispute.mobileNumber}}</span></dd><dt><span data-translate="investhryApp.dispute.emailAddress">Email Address</span></dt><dd><span>{{vm.dispute.emailAddress}}</span></dd><dt><span data-translate="investhryApp.dispute.fixedInvestement">Fixed Investement</span></dt><dd><span>{{vm.dispute.fixedInvestement}}</span></dd><dt><span data-translate="investhryApp.dispute.categoryOfDispute">Category Of Dispute</span></dt><dd><span>{{vm.dispute.categoryOfDispute}}</span></dd><dt><span data-translate="investhryApp.dispute.detailOfDispute">Detail Of Dispute</span></dt><dd><span>{{vm.dispute.detailOfDispute}}</span></dd><dt><span data-translate="investhryApp.dispute.statusPendingLevel">Status Pending Level</span></dt><dd><span>{{vm.dispute.statusPendingLevel}}</span></dd><dt><span data-translate="investhryApp.dispute.isResolved">Is Resolved</span></dt><dd><span>{{vm.dispute.isResolved}}</span></dd><dt><span data-translate="investhryApp.dispute.disputeID">Dispute ID</span></dt><dd><span>{{vm.dispute.disputeID}}</span></dd><dt><span data-translate="investhryApp.dispute.gotReliefLevel">Got Relief Level</span></dt><dd><span>{{vm.dispute.gotReliefLevel}}</span></dd><dt><span data-translate="investhryApp.dispute.levelOfRelief">Level Of Relief</span></dt><dd><span>{{vm.dispute.levelOfRelief}}</span></dd><dt><span data-translate="investhryApp.dispute.departmentName">Department Name</span></dt><dd><span>{{vm.dispute.departmentName}}</span></dd><dt><span data-translate="investhryApp.dispute.departmentAppeals">Department Appeals</span></dt><dd><span>{{vm.dispute.departmentAppeals}}</span></dd><dt><span data-translate="investhryApp.dispute.address">Address</span></dt><dd><span>{{vm.dispute.address}}</span></dd><dt><span data-translate="investhryApp.dispute.officeAddress">Office Address</span></dt><dd><span>{{vm.dispute.officeAddress}}</span></dd><dt><span data-translate="investhryApp.dispute.resolveComment">Resolve Comment</span></dt><dd><span>{{vm.dispute.resolveComment}}</span></dd><dt><span data-translate="investhryApp.dispute.userlogin">Userlogin</span></dt><dd><span>{{vm.dispute.userlogin}}</span></dd><dt><span data-translate="investhryApp.dispute.dateOfFilingPetition">Date Of Filing Petition</span></dt><dd><span>{{vm.dispute.dateOfFilingPetition}}</span></dd><dt><span data-translate="investhryApp.dispute.replyOfDepartment">Reply Of Department</span></dt><dd><span>{{vm.dispute.replyOfDepartment}}</span></dd><dt><span data-translate="investhryApp.dispute.detailsOfDecision">Details Of Decision</span></dt><dd><span>{{vm.dispute.detailsOfDecision}}</span></dd><dt><span data-translate="investhryApp.dispute.orderOfReliefAttachemnt">Order Of Relief Attachemnt</span></dt><dd><span>{{vm.dispute.orderOfReliefAttachemnt}}</span></dd><dt><span data-translate="investhryApp.dispute.appealsDocument">Appeals Document</span></dt><dd><span>{{vm.dispute.appealsDocument}}</span></dd><dt><span data-translate="investhryApp.dispute.distrcit">Distrcit</span></dt><dd><span>{{vm.dispute.distrcit}}</span></dd><dt><span data-translate="investhryApp.dispute.dateOfFiling">Date Of Filing</span></dt><dd><span>{{vm.dispute.dateOfFiling | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.dispute.durationOfPendency">Duration Of Pendency</span></dt><dd><span>{{vm.dispute.durationOfPendency}}</span></dd><dt><span data-translate="investhryApp.dispute.otherCategoryDispute">Other Category Dispute</span></dt><dd><span>{{vm.dispute.otherCategoryDispute}}</span></dd><dt><span data-translate="investhryApp.dispute.creationDate">Creation Date</span></dt><dd><span>{{vm.dispute.creationDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.dispute.lastActionDate">Last Action Date</span></dt><dd><span>{{vm.dispute.lastActionDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dispute-detail.edit({id:vm.dispute.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dispute/dispute-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDisputeLabel" data-translate="investhryApp.dispute.home.createOrEditLabel">Create or edit a Dispute</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.dispute.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.dispute.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.nameOfEnterprise" for="field_nameOfEnterprise">Name Of Enterprise</label><input type="text" class="form-control" name="nameOfEnterprise" id="field_nameOfEnterprise" ng-model="vm.dispute.nameOfEnterprise"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.activity" for="field_activity">Activity</label><input type="text" class="form-control" name="activity" id="field_activity" ng-model="vm.dispute.activity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.nameOfPartner" for="field_nameOfPartner">Name Of Partner</label><input type="text" class="form-control" name="nameOfPartner" id="field_nameOfPartner" ng-model="vm.dispute.nameOfPartner"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.mobileNumber" for="field_mobileNumber">Mobile Number</label><input type="text" class="form-control" name="mobileNumber" id="field_mobileNumber" ng-model="vm.dispute.mobileNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.emailAddress" for="field_emailAddress">Email Address</label><input type="text" class="form-control" name="emailAddress" id="field_emailAddress" ng-model="vm.dispute.emailAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.fixedInvestement" for="field_fixedInvestement">Fixed Investement</label><input type="text" class="form-control" name="fixedInvestement" id="field_fixedInvestement" ng-model="vm.dispute.fixedInvestement"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.categoryOfDispute" for="field_categoryOfDispute">Category Of Dispute</label><input type="text" class="form-control" name="categoryOfDispute" id="field_categoryOfDispute" ng-model="vm.dispute.categoryOfDispute"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.detailOfDispute" for="field_detailOfDispute">Detail Of Dispute</label><input type="text" class="form-control" name="detailOfDispute" id="field_detailOfDispute" ng-model="vm.dispute.detailOfDispute"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.statusPendingLevel" for="field_statusPendingLevel">Status Pending Level</label><input type="text" class="form-control" name="statusPendingLevel" id="field_statusPendingLevel" ng-model="vm.dispute.statusPendingLevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.isResolved" for="field_isResolved">Is Resolved</label><input type="checkbox" name="isResolved" id="field_isResolved" ng-model="vm.dispute.isResolved"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.disputeID" for="field_disputeID">Dispute ID</label><input type="text" class="form-control" name="disputeID" id="field_disputeID" ng-model="vm.dispute.disputeID"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.gotReliefLevel" for="field_gotReliefLevel">Got Relief Level</label><input type="checkbox" name="gotReliefLevel" id="field_gotReliefLevel" ng-model="vm.dispute.gotReliefLevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.levelOfRelief" for="field_levelOfRelief">Level Of Relief</label><input type="text" class="form-control" name="levelOfRelief" id="field_levelOfRelief" ng-model="vm.dispute.levelOfRelief"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.dispute.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.departmentAppeals" for="field_departmentAppeals">Department Appeals</label><input type="checkbox" name="departmentAppeals" id="field_departmentAppeals" ng-model="vm.dispute.departmentAppeals"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.address" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.dispute.address"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.officeAddress" for="field_officeAddress">Office Address</label><input type="text" class="form-control" name="officeAddress" id="field_officeAddress" ng-model="vm.dispute.officeAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.resolveComment" for="field_resolveComment">Resolve Comment</label><input type="text" class="form-control" name="resolveComment" id="field_resolveComment" ng-model="vm.dispute.resolveComment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.userlogin" for="field_userlogin">Userlogin</label><input type="text" class="form-control" name="userlogin" id="field_userlogin" ng-model="vm.dispute.userlogin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.dateOfFilingPetition" for="field_dateOfFilingPetition">Date Of Filing Petition</label><input type="text" class="form-control" name="dateOfFilingPetition" id="field_dateOfFilingPetition" ng-model="vm.dispute.dateOfFilingPetition"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.replyOfDepartment" for="field_replyOfDepartment">Reply Of Department</label><input type="text" class="form-control" name="replyOfDepartment" id="field_replyOfDepartment" ng-model="vm.dispute.replyOfDepartment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.detailsOfDecision" for="field_detailsOfDecision">Details Of Decision</label><input type="text" class="form-control" name="detailsOfDecision" id="field_detailsOfDecision" ng-model="vm.dispute.detailsOfDecision"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.orderOfReliefAttachemnt" for="field_orderOfReliefAttachemnt">Order Of Relief Attachemnt</label><input type="text" class="form-control" name="orderOfReliefAttachemnt" id="field_orderOfReliefAttachemnt" ng-model="vm.dispute.orderOfReliefAttachemnt"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.appealsDocument" for="field_appealsDocument">Appeals Document</label><input type="text" class="form-control" name="appealsDocument" id="field_appealsDocument" ng-model="vm.dispute.appealsDocument"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.distrcit" for="field_distrcit">Distrcit</label><input type="text" class="form-control" name="distrcit" id="field_distrcit" ng-model="vm.dispute.distrcit"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.dateOfFiling" for="field_dateOfFiling">Date Of Filing</label><div class="input-group"><input id="field_dateOfFiling" type="text" class="form-control" name="dateOfFiling" uib-datepicker-popup="{{dateformat}}" ng-model="vm.dispute.dateOfFiling" is-open="vm.datePickerOpenStatus.dateOfFiling"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dateOfFiling\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.durationOfPendency" for="field_durationOfPendency">Duration Of Pendency</label><input type="text" class="form-control" name="durationOfPendency" id="field_durationOfPendency" ng-model="vm.dispute.durationOfPendency"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.otherCategoryDispute" for="field_otherCategoryDispute">Other Category Dispute</label><input type="text" class="form-control" name="otherCategoryDispute" id="field_otherCategoryDispute" ng-model="vm.dispute.otherCategoryDispute"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.creationDate" for="field_creationDate">Creation Date</label><div class="input-group"><input id="field_creationDate" type="text" class="form-control" name="creationDate" datetime-picker="{{dateformat}}" ng-model="vm.dispute.creationDate" is-open="vm.datePickerOpenStatus.creationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.dispute.lastActionDate" for="field_lastActionDate">Last Action Date</label><div class="input-group"><input id="field_lastActionDate" type="text" class="form-control" name="lastActionDate" datetime-picker="{{dateformat}}" ng-model="vm.dispute.lastActionDate" is-open="vm.datePickerOpenStatus.lastActionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastActionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dispute/disputes.html','<div><h2 data-translate="investhryApp.dispute.home.title">Disputes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dispute.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.dispute.home.createLabel">Create new Dispute</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.dispute.nameOfEnterprise">Name Of Enterprise</span></th><th><span data-translate="investhryApp.dispute.activity">Activity</span></th><th><span data-translate="investhryApp.dispute.nameOfPartner">Name Of Partner</span></th><th><span data-translate="investhryApp.dispute.mobileNumber">Mobile Number</span></th><th><span data-translate="investhryApp.dispute.emailAddress">Email Address</span></th><th><span data-translate="investhryApp.dispute.fixedInvestement">Fixed Investement</span></th><th><span data-translate="investhryApp.dispute.categoryOfDispute">Category Of Dispute</span></th><th><span data-translate="investhryApp.dispute.detailOfDispute">Detail Of Dispute</span></th><th><span data-translate="investhryApp.dispute.statusPendingLevel">Status Pending Level</span></th><th><span data-translate="investhryApp.dispute.isResolved">Is Resolved</span></th><th><span data-translate="investhryApp.dispute.disputeID">Dispute ID</span></th><th><span data-translate="investhryApp.dispute.gotReliefLevel">Got Relief Level</span></th><th><span data-translate="investhryApp.dispute.levelOfRelief">Level Of Relief</span></th><th><span data-translate="investhryApp.dispute.departmentName">Department Name</span></th><th><span data-translate="investhryApp.dispute.departmentAppeals">Department Appeals</span></th><th><span data-translate="investhryApp.dispute.address">Address</span></th><th><span data-translate="investhryApp.dispute.officeAddress">Office Address</span></th><th><span data-translate="investhryApp.dispute.resolveComment">Resolve Comment</span></th><th><span data-translate="investhryApp.dispute.userlogin">Userlogin</span></th><th><span data-translate="investhryApp.dispute.dateOfFilingPetition">Date Of Filing Petition</span></th><th><span data-translate="investhryApp.dispute.replyOfDepartment">Reply Of Department</span></th><th><span data-translate="investhryApp.dispute.detailsOfDecision">Details Of Decision</span></th><th><span data-translate="investhryApp.dispute.orderOfReliefAttachemnt">Order Of Relief Attachemnt</span></th><th><span data-translate="investhryApp.dispute.appealsDocument">Appeals Document</span></th><th><span data-translate="investhryApp.dispute.distrcit">Distrcit</span></th><th><span data-translate="investhryApp.dispute.dateOfFiling">Date Of Filing</span></th><th><span data-translate="investhryApp.dispute.durationOfPendency">Duration Of Pendency</span></th><th><span data-translate="investhryApp.dispute.otherCategoryDispute">Other Category Dispute</span></th><th><span data-translate="investhryApp.dispute.creationDate">Creation Date</span></th><th><span data-translate="investhryApp.dispute.lastActionDate">Last Action Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="dispute in vm.disputes track by dispute.id"><td><a ui-sref="dispute-detail({id:dispute.id})">{{dispute.id}}</a></td><td>{{dispute.nameOfEnterprise}}</td><td>{{dispute.activity}}</td><td>{{dispute.nameOfPartner}}</td><td>{{dispute.mobileNumber}}</td><td>{{dispute.emailAddress}}</td><td>{{dispute.fixedInvestement}}</td><td>{{dispute.categoryOfDispute}}</td><td>{{dispute.detailOfDispute}}</td><td>{{dispute.statusPendingLevel}}</td><td>{{dispute.isResolved}}</td><td>{{dispute.disputeID}}</td><td>{{dispute.gotReliefLevel}}</td><td>{{dispute.levelOfRelief}}</td><td>{{dispute.departmentName}}</td><td>{{dispute.departmentAppeals}}</td><td>{{dispute.address}}</td><td>{{dispute.officeAddress}}</td><td>{{dispute.resolveComment}}</td><td>{{dispute.userlogin}}</td><td>{{dispute.dateOfFilingPetition}}</td><td>{{dispute.replyOfDepartment}}</td><td>{{dispute.detailsOfDecision}}</td><td>{{dispute.orderOfReliefAttachemnt}}</td><td>{{dispute.appealsDocument}}</td><td>{{dispute.distrcit}}</td><td>{{dispute.dateOfFiling | date:\'mediumDate\'}}</td><td>{{dispute.durationOfPendency}}</td><td>{{dispute.otherCategoryDispute}}</td><td>{{dispute.creationDate | date:\'medium\'}}</td><td>{{dispute.lastActionDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dispute-detail({id:dispute.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="dispute.edit({id:dispute.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dispute.delete({id:dispute.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/dispute-attachment/dispute-attachment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.disputeAttachment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.disputeAttachment.delete.question" translate-values="{id: \'{{vm.disputeAttachment.id}}\'}">Are you sure you want to delete this Dispute Attachment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/dispute-attachment/dispute-attachment-detail.html','<div><h2><span data-translate="investhryApp.disputeAttachment.detail.title">Dispute Attachment</span> {{vm.disputeAttachment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.disputeAttachment.fileName">File Name</span></dt><dd><span>{{vm.disputeAttachment.fileName}}</span></dd><dt><span data-translate="investhryApp.disputeAttachment.disputeId">Dispute Id</span></dt><dd><span>{{vm.disputeAttachment.disputeId}}</span></dd><dt><span data-translate="investhryApp.disputeAttachment.disputeMainId">Dispute Main Id</span></dt><dd><span>{{vm.disputeAttachment.disputeMainId}}</span></dd><dt><span data-translate="investhryApp.disputeAttachment.description">Description</span></dt><dd><span>{{vm.disputeAttachment.description}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="dispute-attachment-detail.edit({id:vm.disputeAttachment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/dispute-attachment/dispute-attachment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDisputeAttachmentLabel" data-translate="investhryApp.disputeAttachment.home.createOrEditLabel">Create or edit a Dispute Attachment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.disputeAttachment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.disputeAttachment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.disputeAttachment.fileName" for="field_fileName">File Name</label><input type="text" class="form-control" name="fileName" id="field_fileName" ng-model="vm.disputeAttachment.fileName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.disputeAttachment.disputeId" for="field_disputeId">Dispute Id</label><input type="text" class="form-control" name="disputeId" id="field_disputeId" ng-model="vm.disputeAttachment.disputeId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.disputeAttachment.disputeMainId" for="field_disputeMainId">Dispute Main Id</label><input type="text" class="form-control" name="disputeMainId" id="field_disputeMainId" ng-model="vm.disputeAttachment.disputeMainId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.disputeAttachment.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.disputeAttachment.description"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/dispute-attachment/dispute-attachments.html','<div><h2 data-translate="investhryApp.disputeAttachment.home.title">Dispute Attachments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="dispute-attachment.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.disputeAttachment.home.createLabel">Create new Dispute Attachment</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.disputeAttachment.fileName">File Name</span></th><th><span data-translate="investhryApp.disputeAttachment.disputeId">Dispute Id</span></th><th><span data-translate="investhryApp.disputeAttachment.disputeMainId">Dispute Main Id</span></th><th><span data-translate="investhryApp.disputeAttachment.description">Description</span></th><th></th></tr></thead><tbody><tr ng-repeat="disputeAttachment in vm.disputeAttachments track by disputeAttachment.id"><td><a ui-sref="dispute-attachment-detail({id:disputeAttachment.id})">{{disputeAttachment.id}}</a></td><td>{{disputeAttachment.fileName}}</td><td>{{disputeAttachment.disputeId}}</td><td>{{disputeAttachment.disputeMainId}}</td><td>{{disputeAttachment.description}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="dispute-attachment-detail({id:disputeAttachment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="dispute-attachment.edit({id:disputeAttachment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="dispute-attachment.delete({id:disputeAttachment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/disputelog/disputelog-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.disputelog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.disputelog.delete.question" translate-values="{id: \'{{vm.disputelog.id}}\'}">Are you sure you want to delete this Disputelog?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/disputelog/disputelog-detail.html','<div><h2><span data-translate="investhryApp.disputelog.detail.title">Disputelog</span> {{vm.disputelog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.disputelog.action">Action</span></dt><dd><span>{{vm.disputelog.action}}</span></dd><dt><span data-translate="investhryApp.disputelog.actionBy">Action By</span></dt><dd><span>{{vm.disputelog.actionBy}}</span></dd><dt><span data-translate="investhryApp.disputelog.actionComment">Action Comment</span></dt><dd><span>{{vm.disputelog.actionComment}}</span></dd><dt><span data-translate="investhryApp.disputelog.actionDate">Action Date</span></dt><dd><span>{{vm.disputelog.actionDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.disputelog.disputeID">Dispute ID</span></dt><dd><span>{{vm.disputelog.disputeID}}</span></dd><dt><span data-translate="investhryApp.disputelog.disputeMainId">Dispute Main Id</span></dt><dd><span>{{vm.disputelog.disputeMainId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="disputelog-detail.edit({id:vm.disputelog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/disputelog/disputelog-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDisputelogLabel" data-translate="investhryApp.disputelog.home.createOrEditLabel">Create or edit a Disputelog</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.disputelog.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.disputelog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.disputelog.action" for="field_action">Action</label><input type="text" class="form-control" name="action" id="field_action" ng-model="vm.disputelog.action"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.disputelog.actionBy" for="field_actionBy">Action By</label><input type="text" class="form-control" name="actionBy" id="field_actionBy" ng-model="vm.disputelog.actionBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.disputelog.actionComment" for="field_actionComment">Action Comment</label><input type="text" class="form-control" name="actionComment" id="field_actionComment" ng-model="vm.disputelog.actionComment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.disputelog.actionDate" for="field_actionDate">Action Date</label><div class="input-group"><input id="field_actionDate" type="text" class="form-control" name="actionDate" datetime-picker="{{dateformat}}" ng-model="vm.disputelog.actionDate" is-open="vm.datePickerOpenStatus.actionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'actionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.disputelog.disputeID" for="field_disputeID">Dispute ID</label><input type="text" class="form-control" name="disputeID" id="field_disputeID" ng-model="vm.disputelog.disputeID"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.disputelog.disputeMainId" for="field_disputeMainId">Dispute Main Id</label><input type="text" class="form-control" name="disputeMainId" id="field_disputeMainId" ng-model="vm.disputelog.disputeMainId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/disputelog/disputelogs.html','<div><h2 data-translate="investhryApp.disputelog.home.title">Disputelogs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="disputelog.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.disputelog.home.createLabel">Create new Disputelog</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.disputelog.action">Action</span></th><th><span data-translate="investhryApp.disputelog.actionBy">Action By</span></th><th><span data-translate="investhryApp.disputelog.actionComment">Action Comment</span></th><th><span data-translate="investhryApp.disputelog.actionDate">Action Date</span></th><th><span data-translate="investhryApp.disputelog.disputeID">Dispute ID</span></th><th><span data-translate="investhryApp.disputelog.disputeMainId">Dispute Main Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="disputelog in vm.disputelogs track by disputelog.id"><td><a ui-sref="disputelog-detail({id:disputelog.id})">{{disputelog.id}}</a></td><td>{{disputelog.action}}</td><td>{{disputelog.actionBy}}</td><td>{{disputelog.actionComment}}</td><td>{{disputelog.actionDate | date:\'medium\'}}</td><td>{{disputelog.disputeID}}</td><td>{{disputelog.disputeMainId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="disputelog-detail({id:disputelog.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="disputelog.edit({id:disputelog.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="disputelog.delete({id:disputelog.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/district/district-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.district.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.district.delete.question" translate-values="{id: \'{{vm.district.id}}\'}">Are you sure you want to delete this District?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/district/district-detail.html','<div><h2><span data-translate="investhryApp.district.detail.title">District</span> {{vm.district.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.district.districtname">Districtname</span></dt><dd><span>{{vm.district.districtname}}</span></dd><dt><span>District Code</span></dt><dd><span>{{vm.district.districtCode}}</span></dd><dt><span>Saral District Code</span></dt><dd><span>{{vm.district.saralDistrictCode}}</span></dd><dt><span data-translate="investhryApp.district.statename">Statename</span></dt><dd><span>{{vm.district.statename}}</span></dd><dt><span data-translate="investhryApp.district.powercompany">Powercompany</span></dt><dd><span>{{vm.district.powercompany}}</span></dd><dt><span data-translate="investhryApp.district.stateID">State ID</span></dt><dd><span>{{vm.district.stateID}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="district-detail.edit({id:vm.district.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/district/district-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDistrictLabel" data-translate="investhryApp.district.home.createOrEditLabel">Create or edit a District</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.district.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.district.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.district.districtname" for="field_districtname">Districtname</label><input type="text" class="form-control" name="districtname" id="field_districtname" ng-model="vm.district.districtname"></div><div class="form-group"><label class="control-label" for="field_districtCode">District Code</label><input type="text" class="form-control" name="districtCode" id="field_districtCode" ng-model="vm.district.districtCode"></div><div class="form-group"><label class="control-label" for="field_saralDistrictCode">Saral District Code</label><input type="text" class="form-control" name="saralDistrictCode" id="field_saralDistrictCode" ng-model="vm.district.saralDistrictCode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.district.statename" for="field_statename">Statename</label><select class="form-control" name="statename" id="field_statename" ng-options="state.statename for state in vm.states track by state.id" ng-model="selected"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.district.powercompany" for="field_powercompany">Powercompany</label><input type="text" class="form-control" name="powercompany" id="field_powercompany" ng-model="vm.district.powercompany"></div><div class="form-group hidden"><label class="control-label" data-translate="investhryApp.district.stateID" for="field_stateID">State ID</label><input type="text" class="form-control" name="stateID" id="field_stateID" ng-model="vm.district.stateID"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/district/districts.html','<div><h2 data-translate="investhryApp.district.home.title">Districts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="district.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.district.home.createLabel">Create new District</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.district.districtname">Districtname</span></th><th><span>District Code</span></th><th><span>Saral District Code</span></th><th><span data-translate="investhryApp.district.statename">Statename</span></th><th><span data-translate="investhryApp.district.powercompany">Powercompany</span></th><th><span data-translate="investhryApp.district.stateID">State ID</span></th><th></th></tr></thead><tbody><tr ng-repeat="district in vm.districts track by district.id"><td><a ui-sref="district-detail({id:district.id})">{{district.id}}</a></td><td>{{district.districtname}}</td><td>{{district.districtCode}}</td><td>{{district.saralDistrictCode}}</td><td>{{district.statename}}</td><td>{{district.powercompany}}</td><td>{{district.stateID}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="district-detail({id:district.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="district.edit({id:district.id, stateID:district.stateID})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="district.delete({id:district.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/district-desk-officer/district-desk-officer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.districtDeskOfficer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.districtDeskOfficer.delete.question" translate-values="{id: \'{{vm.districtDeskOfficer.id}}\'}">Are you sure you want to delete this District Desk Officer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/district-desk-officer/district-desk-officer-detail.html','<div><h2><span data-translate="investhryApp.districtDeskOfficer.detail.title">District Desk Officer</span> {{vm.districtDeskOfficer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.districtDeskOfficer.deskOfficerLogin">Desk Officer Login</span></dt><dd><span>{{vm.districtDeskOfficer.deskOfficerLogin}}</span></dd><dt><span data-translate="investhryApp.districtDeskOfficer.districtid">Districtid</span></dt><dd><span>{{vm.districtDeskOfficer.districtid}}</span></dd><dt><span data-translate="investhryApp.districtDeskOfficer.districtName">District Name</span></dt><dd><span>{{vm.districtDeskOfficer.districtName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="district-desk-officer-detail.edit({id:vm.districtDeskOfficer.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/district-desk-officer/district-desk-officer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDistrictDeskOfficerLabel" data-translate="investhryApp.districtDeskOfficer.home.createOrEditLabel">Create or edit a District Desk Officer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.districtDeskOfficer.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.districtDeskOfficer.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.districtDeskOfficer.deskOfficerLogin" for="field_deskOfficerLogin">Desk Officer Login</label><input type="text" class="form-control" name="deskOfficerLogin" id="field_deskOfficerLogin" ng-model="vm.districtDeskOfficer.deskOfficerLogin"></div><!--        <div class="form-group">--><!--            <label class="control-label" data-translate="investhryApp.districtDeskOfficer.districtid" for="field_districtid">Districtid</label>--><!--            <input type="text" class="form-control" name="districtid" id="field_districtid"--><!--                    ng-model="vm.districtDeskOfficer.districtid"--><!--                    />--><!--        </div>--><div class="form-group"><label class="control-label" for="field_districtName">District Name</label><select type="text" class="form-control" name="districtName" id="field_districtName" ng-model="vm.districtDeskOfficer.districtName" ng-options="x.districtname as x.districtname for x in vm.districts" required><option value="">Select</option></select><div ng-show="editForm.district.$invalid"><p class="help-block" ng-show="editForm.district.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/district-desk-officer/district-desk-officers.html','<div><h2 data-translate="investhryApp.districtDeskOfficer.home.title">District Desk Officers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="district-desk-officer.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.districtDeskOfficer.home.createLabel">Create new District Desk Officer</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.districtDeskOfficer.deskOfficerLogin">Desk Officer Login</span></th><th><span data-translate="investhryApp.districtDeskOfficer.districtid">Districtid</span></th><th><span data-translate="investhryApp.districtDeskOfficer.districtName">District Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="districtDeskOfficer in vm.districtDeskOfficers track by districtDeskOfficer.id"><td><a ui-sref="district-desk-officer-detail({id:districtDeskOfficer.id})">{{districtDeskOfficer.id}}</a></td><td>{{districtDeskOfficer.deskOfficerLogin}}</td><td>{{districtDeskOfficer.districtid}}</td><td>{{districtDeskOfficer.districtName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="district-desk-officer-detail({id:districtDeskOfficer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="district-desk-officer.edit({id:districtDeskOfficer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="district-desk-officer.delete({id:districtDeskOfficer.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/district-field-officer/district-field-officer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.districtFieldOfficer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.districtFieldOfficer.delete.question" translate-values="{id: \'{{vm.districtFieldOfficer.id}}\'}">Are you sure you want to delete this District Field Officer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/district-field-officer/district-field-officer-detail.html','<div><h2><span data-translate="investhryApp.districtFieldOfficer.detail.title">District Field Officer</span> {{vm.districtFieldOfficer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.districtFieldOfficer.districtid">Districtid</span></dt><dd><span>{{vm.districtFieldOfficer.districtid}}</span></dd><dt><span data-translate="investhryApp.districtFieldOfficer.districtName">District Name</span></dt><dd><span>{{vm.districtFieldOfficer.districtName}}</span></dd><dt><span data-translate="investhryApp.districtFieldOfficer.departmentid">Departmentid</span></dt><dd><span>{{vm.districtFieldOfficer.departmentid}}</span></dd><dt><span data-translate="investhryApp.districtFieldOfficer.departmentName">Department Name</span></dt><dd><span>{{vm.districtFieldOfficer.departmentName}}</span></dd><dt><span data-translate="investhryApp.districtFieldOfficer.designation">Designation</span></dt><dd><span>{{vm.districtFieldOfficer.designation}}</span></dd><dt><span data-translate="investhryApp.districtFieldOfficer.fieldofficerlogin">Fieldofficerlogin</span></dt><dd><span>{{vm.districtFieldOfficer.fieldofficerlogin}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="district-field-officer-detail.edit({id:vm.districtFieldOfficer.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/district-field-officer/district-field-officer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDistrictFieldOfficerLabel" data-translate="investhryApp.districtFieldOfficer.home.createOrEditLabel">Create or edit a District Field Officer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.districtFieldOfficer.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.districtFieldOfficer.id" readonly="readonly"></div><div class="form-group"><label class="control-label">District</label><select class="form-control" ng-model="vm.districtFieldOfficer.selecteddistrict" ng-options="district.districtname for district in vm.districts" required><option value="">Select District</option></select></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.districtFieldOfficer.districtid" for="field_districtid">Districtid</label>--><!--<input type="text" class="form-control" name="districtid" id="field_districtid"--><!--ng-model="vm.districtFieldOfficer.districtid"--><!--/>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.districtFieldOfficer.districtName" for="field_districtName">District Name</label>--><!--<input type="text" class="form-control" name="districtName" id="field_districtName"--><!--ng-model="vm.districtFieldOfficer.districtName"--><!--/>--><!--</div>--><div class="form-group"><label class="control-label">Department</label><select class="form-control" ng-model="vm.districtFieldOfficer.selecteddepartment" ng-options="department.departmentname for department in vm.departments" required><option value="">Select Department</option></select></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.districtFieldOfficer.departmentid" for="field_departmentid">Departmentid</label>--><!--<input type="text" class="form-control" name="departmentid" id="field_departmentid"--><!--ng-model="vm.districtFieldOfficer.departmentid"--><!--/>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.districtFieldOfficer.departmentName" for="field_departmentName">Department Name</label>--><!--<input type="text" class="form-control" name="departmentName" id="field_departmentName"--><!--ng-model="vm.districtFieldOfficer.departmentName"--><!--/>--><!--</div>--><div class="form-group"><label class="control-label" data-translate="investhryApp.districtFieldOfficer.designation" for="field_designation">Designation</label><input type="text" class="form-control" name="designation" id="field_designation" ng-model="vm.districtFieldOfficer.designation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.districtFieldOfficer.fieldofficerlogin" for="field_fieldofficerlogin">Fieldofficerlogin</label><input type="text" class="form-control" name="fieldofficerlogin" id="field_fieldofficerlogin" ng-model="vm.districtFieldOfficer.fieldofficerlogin" required></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/district-field-officer/district-field-officers.html','<div><h2 data-translate="investhryApp.districtFieldOfficer.home.title">District Field Officers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="district-field-officer.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.districtFieldOfficer.home.createLabel">Create new District Field Officer</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.districtFieldOfficer.districtid">Districtid</span></th><th><span data-translate="investhryApp.districtFieldOfficer.districtName">District Name</span></th><th><span data-translate="investhryApp.districtFieldOfficer.departmentid">Departmentid</span></th><th><span data-translate="investhryApp.districtFieldOfficer.departmentName">Department Name</span></th><th><span data-translate="investhryApp.districtFieldOfficer.designation">Designation</span></th><th><span data-translate="investhryApp.districtFieldOfficer.fieldofficerlogin">Fieldofficerlogin</span></th><th></th></tr></thead><tbody><tr ng-repeat="districtFieldOfficer in vm.districtFieldOfficers track by districtFieldOfficer.id"><td><a ui-sref="district-field-officer-detail({id:districtFieldOfficer.id})">{{districtFieldOfficer.id}}</a></td><td>{{districtFieldOfficer.districtid}}</td><td>{{districtFieldOfficer.districtName}}</td><td>{{districtFieldOfficer.departmentid}}</td><td>{{districtFieldOfficer.departmentName}}</td><td>{{districtFieldOfficer.designation}}</td><td>{{districtFieldOfficer.fieldofficerlogin}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="district-field-officer-detail({id:districtFieldOfficer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="district-field-officer.edit({id:districtFieldOfficer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="district-field-officer.delete({id:districtFieldOfficer.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/district-nodal-officer/district-nodal-officer-delete-dialog.html','s<form name="deleteForm" ng-submit="vm.confirmDelete(vm.districtNodalOfficer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.districtNodalOfficer.delete.question" translate-values="{id: \'{{vm.districtNodalOfficer.id}}\'}">Are you sure you want to delete this District Nodal Officer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/district-nodal-officer/district-nodal-officer-detail.html','<div><h2><span data-translate="investhryApp.districtNodalOfficer.detail.title">District Nodal Officer</span> {{vm.districtNodalOfficer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.districtNodalOfficer.nodalOfficerLogin">Nodal Officer Login</span></dt><dd><span>{{vm.districtNodalOfficer.nodalOfficerLogin}}</span></dd><dt><span data-translate="investhryApp.districtNodalOfficer.districtName">District Name</span></dt><dd><span>{{vm.districtNodalOfficer.districtName}}</span></dd><dt><span data-translate="investhryApp.districtNodalOfficer.departmentid">Departmentid</span></dt><dd><span>{{vm.districtNodalOfficer.departmentid}}</span></dd><dt><span data-translate="investhryApp.districtNodalOfficer.districtid">Districtid</span></dt><dd><span>{{vm.districtNodalOfficer.districtid}}</span></dd><dt><span data-translate="investhryApp.districtNodalOfficer.departmentname">Departmentname</span></dt><dd><span>{{vm.districtNodalOfficer.departmentname}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="district-nodal-officer-detail.edit({id:vm.districtNodalOfficer.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/district-nodal-officer/district-nodal-officer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDistrictNodalOfficerLabel" data-translate="investhryApp.districtNodalOfficer.home.createOrEditLabel">Create or edit a District Nodal Officer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.districtNodalOfficer.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.districtNodalOfficer.id" readonly="readonly"></div><div class="form-group"><label class="control-label">District</label><select class="form-control" ng-model="vm.districtNodalOfficer.districtid" ng-options="district.id as district.districtname for district in vm.districts"><option value="">Select District</option></select></div><div class="form-group"><label class="control-label">Department</label><select class="form-control" ng-model="vm.districtNodalOfficer.departmentid" ng-options="department.id as department.departmentname for department in vm.departments" required><option value="" disabled="disabled">Select Department</option><!--<option ng-repeat="department in vm.departments" ng-hide="department.departmentname===\'Development and Panchayats\'">{{department.departmentname}}</option>--></select></div><div class="form-group"><label class="control-label" data-translate="investhryApp.districtNodalOfficer.nodalOfficerLogin" for="field_nodalOfficerLogin">Nodal Officer Login</label><input type="text" class="form-control" name="nodalOfficerLogin" id="field_nodalOfficerLogin" ng-model="vm.districtNodalOfficer.nodalOfficerLogin" required><div ng-show="editForm.nodalOfficerLogin.$invalid"><p class="help-block" ng-show="editForm.nodalOfficerLogin.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.districtNodalOfficer.districtName" for="field_districtName">District Name</label>--><!--<input type="text" class="form-control" name="districtName" id="field_districtName"--><!--ng-model="vm.districtNodalOfficer.districtName"--><!--/>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.districtNodalOfficer.departmentid" for="field_departmentid">Departmentid</label>--><!--<input type="text" class="form-control" name="departmentid" id="field_departmentid"--><!--ng-model="vm.districtNodalOfficer.departmentid"--><!--/>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.districtNodalOfficer.districtid" for="field_districtid">Districtid</label>--><!--<input type="text" class="form-control" name="districtid" id="field_districtid"--><!--ng-model="vm.districtNodalOfficer.districtid"--><!--/>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.districtNodalOfficer.departmentname" for="field_departmentname">Departmentname</label>--><!--<input type="text" class="form-control" name="departmentname" id="field_departmentname"--><!--ng-model="vm.districtNodalOfficer.departmentname"--><!--/>--><!--</div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/district-nodal-officer/district-nodal-officers.html','<div><h2 data-translate="investhryApp.districtNodalOfficer.home.title">District Nodal Officers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="district-nodal-officer.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.districtNodalOfficer.home.createLabel">Create new District Nodal Officer</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.districtNodalOfficer.nodalOfficerLogin">Nodal Officer Login</span></th><th><span data-translate="investhryApp.districtNodalOfficer.districtName">District Name</span></th><th><span data-translate="investhryApp.districtNodalOfficer.departmentid">Departmentid</span></th><th><span data-translate="investhryApp.districtNodalOfficer.districtid">Districtid</span></th><th><span data-translate="investhryApp.districtNodalOfficer.departmentname">Departmentname</span></th><th></th></tr></thead><tbody><tr ng-repeat="districtNodalOfficer in vm.districtNodalOfficers track by districtNodalOfficer.id"><td><a ui-sref="district-nodal-officer-detail({id:districtNodalOfficer.id})">{{districtNodalOfficer.id}}</a></td><td>{{districtNodalOfficer.nodalOfficerLogin}}</td><td>{{districtNodalOfficer.districtName}}</td><td>{{districtNodalOfficer.departmentid}}</td><td>{{districtNodalOfficer.districtid}}</td><td>{{districtNodalOfficer.departmentname}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="district-nodal-officer-detail({id:districtNodalOfficer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="district-nodal-officer.edit({id:districtNodalOfficer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="district-nodal-officer.delete({id:districtNodalOfficer.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/district-village-block-mapping/district-village-block-mapping-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.districtVillageBlockMapping.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.districtVillageBlockMapping.delete.question" translate-values="{id: \'{{vm.districtVillageBlockMapping.id}}\'}">Are you sure you want to delete this District Village Block Mapping?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/district-village-block-mapping/district-village-block-mapping-detail.html','<div><h2><span data-translate="investhryApp.districtVillageBlockMapping.detail.title">District Village Block Mapping</span> {{vm.districtVillageBlockMapping.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.districtVillageBlockMapping.districtName">District Name</span></dt><dd><span>{{vm.districtVillageBlockMapping.districtName}}</span></dd><dt><span data-translate="investhryApp.districtVillageBlockMapping.category">Category</span></dt><dd><span>{{vm.districtVillageBlockMapping.category}}</span></dd><dt><span data-translate="investhryApp.districtVillageBlockMapping.village">Village</span></dt><dd><span>{{vm.districtVillageBlockMapping.village}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="district-village-block-mapping-detail.edit({id:vm.districtVillageBlockMapping.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/district-village-block-mapping/district-village-block-mapping-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDistrictVillageBlockMappingLabel" data-translate="investhryApp.districtVillageBlockMapping.home.createOrEditLabel">Create or edit a District Village Block Mapping</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.districtVillageBlockMapping.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.districtVillageBlockMapping.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.districtVillageBlockMapping.districtName" for="field_districtName">District Name</label><input type="text" class="form-control" name="districtName" id="field_districtName" ng-model="vm.districtVillageBlockMapping.districtName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.districtVillageBlockMapping.category" for="field_category">Category</label><input type="text" class="form-control" name="category" id="field_category" ng-model="vm.districtVillageBlockMapping.category"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.districtVillageBlockMapping.village" for="field_village">Village</label><input type="text" class="form-control" name="village" id="field_village" ng-model="vm.districtVillageBlockMapping.village"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/district-village-block-mapping/district-village-block-mappings.html','<div><h2 data-translate="investhryApp.districtVillageBlockMapping.home.title">District Village Block Mappings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="district-village-block-mapping.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.districtVillageBlockMapping.home.createLabel">Create new District Village Block Mapping</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.districtVillageBlockMapping.districtName">District Name</span></th><th><span data-translate="investhryApp.districtVillageBlockMapping.category">Category</span></th><th><span data-translate="investhryApp.districtVillageBlockMapping.village">Village</span></th><th></th></tr></thead><tbody><tr ng-repeat="districtVillageBlockMapping in vm.districtVillageBlockMappings track by districtVillageBlockMapping.id"><td><a ui-sref="district-village-block-mapping-detail({id:districtVillageBlockMapping.id})">{{districtVillageBlockMapping.id}}</a></td><td>{{districtVillageBlockMapping.districtName}}</td><td>{{districtVillageBlockMapping.category}}</td><td>{{districtVillageBlockMapping.village}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="district-village-block-mapping-detail({id:districtVillageBlockMapping.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="district-village-block-mapping.edit({id:districtVillageBlockMapping.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="district-village-block-mapping.delete({id:districtVillageBlockMapping.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/draft-policy/draft-policies.html','<div class="container"><div class="row"><div class="col-md-2 pull-right"><select style="border: none; box-shadow: none" class="form-control" ng-model="vm.policyFilter" ng-change="vm.statusSelected(vm.statusFilter,vm.policyFilter)"><option value="" disabled="disabled">-- Select Policy --</option><option value="all">All</option><option value="{{policy.name}}" ng-repeat="policy in vm.policyDetails">{{policy.name}}</option></select></div><div class="col-md-2 pull-right"><select style="border: none; box-shadow: none" class="form-control" ng-model="vm.statusFilter" ng-change="vm.statusSelected(vm.statusFilter,vm.policyFilter)"><option value="Pending">Pending</option><option value="Reviewed">Reviewed</option></select></div><div class="col-md-1 filter-margin pull-right"><span class="uk-label uk-label-danger" style="font-size: 12px">FILTER BY:</span></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th>#</th><th><span data-translate="investhryApp.draftPolicy.policy">Policy</span></th><th><span data-translate="investhryApp.draftPolicy.name">Name</span></th><th><span data-translate="investhryApp.draftPolicy.email">Email</span></th><th><span data-translate="investhryApp.draftPolicy.phone">Phone</span></th><th><span data-translate="investhryApp.draftPolicy.remarks">Remarks</span></th><th ng-show="vm.statusFilter == \'Reviewed\'"><span>Remarks By Admin</span></th><!--<th><span data-translate="investhryApp.draftPolicy.isReplied">Is Replied</span></th>--><th></th></tr></thead><tbody><tr ng-repeat="draftPolicy in vm.draftPolicies track by draftPolicy.id"><td>{{$index+1}}</td><td>{{draftPolicy.policy}}</td><td>{{draftPolicy.name}}</td><td>{{draftPolicy.email}}</td><td>{{draftPolicy.phone}}</td><td>{{draftPolicy.remarks}}</td><td ng-show="vm.statusFilter == \'Reviewed\'">{{draftPolicy.remarks_admin}}</td><!--<td>{{draftPolicy.isReplied}}</td>--><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ng-show="vm.statusFilter == \'Pending\'" uk-toggle="target: #remarkAdmin" type="button" class="btn btn-primary btn-sm" ng-click="vm.tempData = draftPolicy"><span class="glyphicon glyphicon-pencil">&nbsp;</span> <span class="hidden-sm-down">Add Remark</span></button></div></td></tr></tbody></table></div></div><div id="remarkAdmin" class="uk-flex-top" uk-modal><div class="uk-modal-dialog uk-modal-body"><button class="uk-modal-close-default" type="button" uk-close></button><h2 class="uk-modal-title">Add Remark</h2><textarea class="uk-textarea" rows="5" ng-model="vm.tempData.remarks_admin" placeholder="Remarks" required></textarea><p class="uk-text-right"><br><button type="button" class="uk-button uk-button-primary pull-right" style="font-size: 14px" ng-click="vm.save(vm.tempData)"><i class="fa fa-save">&nbsp;&nbsp;</i>Submit</button></p></div></div>');
$templateCache.put('app/entities/draft-policy/draft-policy-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.draftPolicy.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.draftPolicy.delete.question" translate-values="{id: \'{{vm.draftPolicy.id}}\'}">Are you sure you want to delete this Draft Policy?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/draft-policy/draft-policy-detail.html','<div><h2><span data-translate="investhryApp.draftPolicy.detail.title">Draft Policy</span> {{vm.draftPolicy.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.draftPolicy.policy">Policy</span></dt><dd><span>{{vm.draftPolicy.policy}}</span></dd><dt><span data-translate="investhryApp.draftPolicy.name">Name</span></dt><dd><span>{{vm.draftPolicy.name}}</span></dd><dt><span data-translate="investhryApp.draftPolicy.email">Email</span></dt><dd><span>{{vm.draftPolicy.email}}</span></dd><dt><span data-translate="investhryApp.draftPolicy.phone">Phone</span></dt><dd><span>{{vm.draftPolicy.phone}}</span></dd><dt><span data-translate="investhryApp.draftPolicy.remarks">Remarks</span></dt><dd><span>{{vm.draftPolicy.remarks}}</span></dd><dt><span data-translate="investhryApp.draftPolicy.remarks_admin">Remarks Admin</span></dt><dd><span>{{vm.draftPolicy.remarks_admin}}</span></dd><dt><span data-translate="investhryApp.draftPolicy.isReplied">Is Replied</span></dt><dd><span>{{vm.draftPolicy.isReplied}}</span></dd><dt><span data-translate="investhryApp.draftPolicy.remarkDate">Remark Date</span></dt><dd><span>{{vm.draftPolicy.remarkDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="draft-policy-detail.edit({id:vm.draftPolicy.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/draft-policy/draft-policy-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myDraftPolicyLabel" data-translate="investhryApp.draftPolicy.home.createOrEditLabel">Create or edit a Draft Policy</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.draftPolicy.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.draftPolicy.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.draftPolicy.policy" for="field_policy">Policy</label><input type="text" class="form-control" name="policy" id="field_policy" ng-model="vm.draftPolicy.policy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.draftPolicy.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.draftPolicy.name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.draftPolicy.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.draftPolicy.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.draftPolicy.phone" for="field_phone">Phone</label><input type="text" class="form-control" name="phone" id="field_phone" ng-model="vm.draftPolicy.phone"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.draftPolicy.remarks" for="field_remarks">Remarks</label><input type="text" class="form-control" name="remarks" id="field_remarks" ng-model="vm.draftPolicy.remarks"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.draftPolicy.remarks_admin" for="field_remarks_admin">Remarks Admin</label><input type="text" class="form-control" name="remarks_admin" id="field_remarks_admin" ng-model="vm.draftPolicy.remarks_admin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.draftPolicy.isReplied" for="field_isReplied">Is Replied</label><input type="checkbox" name="isReplied" id="field_isReplied" ng-model="vm.draftPolicy.isReplied"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.draftPolicy.remarkDate" for="field_remarkDate">Remark Date</label><div class="input-group"><input id="field_remarkDate" type="text" class="form-control" name="remarkDate" datetime-picker="{{dateformat}}" ng-model="vm.draftPolicy.remarkDate" is-open="vm.datePickerOpenStatus.remarkDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'remarkDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/electricrequirement/electricrequirement-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.electricrequirement.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.electricrequirement.delete.question" translate-values="{id: \'{{vm.electricrequirement.id}}\'}">Are you sure you want to delete this Electricrequirement?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/electricrequirement/electricrequirement-detail.html','<div><h2><span data-translate="investhryApp.electricrequirement.detail.title">Electricrequirement</span> {{vm.electricrequirement.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.electricrequirement.temporaryrequired">Temporaryrequired</span></dt><dd><span>{{vm.electricrequirement.temporaryrequired}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.tem_load_existing">Tem Load Existing</span></dt><dd><span>{{vm.electricrequirement.tem_load_existing}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.tem_account_number">Tem Account Number</span></dt><dd><span>{{vm.electricrequirement.tem_account_number}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.temp_existing_load_demand_kw">Temp Existing Load Demand Kw</span></dt><dd><span>{{vm.electricrequirement.temp_existing_load_demand_kw}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.temp_existing_load_demand_kva">Temp Existing Load Demand Kva</span></dt><dd><span>{{vm.electricrequirement.temp_existing_load_demand_kva}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.temp_new_load_demand_kw">Temp New Load Demand Kw</span></dt><dd><span>{{vm.electricrequirement.temp_new_load_demand_kw}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.temp_new_load_demand_kva">Temp New Load Demand Kva</span></dt><dd><span>{{vm.electricrequirement.temp_new_load_demand_kva}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.temp_load_demand_date">Temp Load Demand Date</span></dt><dd><span>{{vm.electricrequirement.temp_load_demand_date | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.regular_load_required">Regular Load Required</span></dt><dd><span>{{vm.electricrequirement.regular_load_required}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.regular_existing_connection">Regular Existing Connection</span></dt><dd><span>{{vm.electricrequirement.regular_existing_connection}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.regular_account_number">Regular Account Number</span></dt><dd><span>{{vm.electricrequirement.regular_account_number}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.regular_existing_load_ifany_kw">Regular Existing Load Ifany Kw</span></dt><dd><span>{{vm.electricrequirement.regular_existing_load_ifany_kw}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.regular_existing_load_ifany_kva">Regular Existing Load Ifany Kva</span></dt><dd><span>{{vm.electricrequirement.regular_existing_load_ifany_kva}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.regular_new_load_demand_kw">Regular New Load Demand Kw</span></dt><dd><span>{{vm.electricrequirement.regular_new_load_demand_kw}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.regular_new_load_demand_kva">Regular New Load Demand Kva</span></dt><dd><span>{{vm.electricrequirement.regular_new_load_demand_kva}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.regular_load_demand_date">Regular Load Demand Date</span></dt><dd><span>{{vm.electricrequirement.regular_load_demand_date | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.customertype">Customertype</span></dt><dd><span>{{vm.electricrequirement.customertype}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.createdate">Createdate</span></dt><dd><span>{{vm.electricrequirement.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.electricrequirement.updatedate">Updatedate</span></dt><dd><span>{{vm.electricrequirement.updatedate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="electricrequirement-detail.edit({id:vm.electricrequirement.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/electricrequirement/electricrequirement-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myElectricrequirementLabel" data-translate="investhryApp.electricrequirement.home.createOrEditLabel">Create or edit a Electricrequirement</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.electricrequirement.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.electricrequirement.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.temporaryrequired" for="field_temporaryrequired">Temporaryrequired</label><input type="checkbox" class="form-control" name="temporaryrequired" id="field_temporaryrequired" ng-model="vm.electricrequirement.temporaryrequired"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.tem_load_existing" for="field_tem_load_existing">Tem Load Existing</label><input type="checkbox" class="form-control" name="tem_load_existing" id="field_tem_load_existing" ng-model="vm.electricrequirement.tem_load_existing"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.tem_account_number" for="field_tem_account_number">Tem Account Number</label><input type="text" class="form-control" name="tem_account_number" id="field_tem_account_number" ng-model="vm.electricrequirement.tem_account_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.temp_existing_load_demand_kw" for="field_temp_existing_load_demand_kw">Temp Existing Load Demand Kw</label><input type="number" class="form-control" name="temp_existing_load_demand_kw" id="field_temp_existing_load_demand_kw" ng-model="vm.electricrequirement.temp_existing_load_demand_kw"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.temp_existing_load_demand_kva" for="field_temp_existing_load_demand_kva">Temp Existing Load Demand Kva</label><input type="number" class="form-control" name="temp_existing_load_demand_kva" id="field_temp_existing_load_demand_kva" ng-model="vm.electricrequirement.temp_existing_load_demand_kva"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.temp_new_load_demand_kw" for="field_temp_new_load_demand_kw">Temp New Load Demand Kw</label><input type="number" class="form-control" name="temp_new_load_demand_kw" id="field_temp_new_load_demand_kw" ng-model="vm.electricrequirement.temp_new_load_demand_kw"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.temp_new_load_demand_kva" for="field_temp_new_load_demand_kva">Temp New Load Demand Kva</label><input type="number" class="form-control" name="temp_new_load_demand_kva" id="field_temp_new_load_demand_kva" ng-model="vm.electricrequirement.temp_new_load_demand_kva"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.temp_load_demand_date" for="field_temp_load_demand_date">Temp Load Demand Date</label><div class="input-group"><input id="field_temp_load_demand_date" type="text" class="form-control" name="temp_load_demand_date" datetime-picker="{{dateformat}}" ng-model="vm.electricrequirement.temp_load_demand_date" is-open="vm.datePickerOpenStatus.temp_load_demand_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'temp_load_demand_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.regular_load_required" for="field_regular_load_required">Regular Load Required</label><input type="checkbox" class="form-control" name="regular_load_required" id="field_regular_load_required" ng-model="vm.electricrequirement.regular_load_required"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.regular_existing_connection" for="field_regular_existing_connection">Regular Existing Connection</label><input type="checkbox" class="form-control" name="regular_existing_connection" id="field_regular_existing_connection" ng-model="vm.electricrequirement.regular_existing_connection"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.regular_account_number" for="field_regular_account_number">Regular Account Number</label><input type="text" class="form-control" name="regular_account_number" id="field_regular_account_number" ng-model="vm.electricrequirement.regular_account_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.regular_existing_load_ifany_kw" for="field_regular_existing_load_ifany_kw">Regular Existing Load Ifany Kw</label><input type="number" class="form-control" name="regular_existing_load_ifany_kw" id="field_regular_existing_load_ifany_kw" ng-model="vm.electricrequirement.regular_existing_load_ifany_kw"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.regular_existing_load_ifany_kva" for="field_regular_existing_load_ifany_kva">Regular Existing Load Ifany Kva</label><input type="number" class="form-control" name="regular_existing_load_ifany_kva" id="field_regular_existing_load_ifany_kva" ng-model="vm.electricrequirement.regular_existing_load_ifany_kva"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.regular_new_load_demand_kw" for="field_regular_new_load_demand_kw">Regular New Load Demand Kw</label><input type="number" class="form-control" name="regular_new_load_demand_kw" id="field_regular_new_load_demand_kw" ng-model="vm.electricrequirement.regular_new_load_demand_kw"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.regular_new_load_demand_kva" for="field_regular_new_load_demand_kva">Regular New Load Demand Kva</label><input type="number" class="form-control" name="regular_new_load_demand_kva" id="field_regular_new_load_demand_kva" ng-model="vm.electricrequirement.regular_new_load_demand_kva"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.regular_load_demand_date" for="field_regular_load_demand_date">Regular Load Demand Date</label><div class="input-group"><input id="field_regular_load_demand_date" type="text" class="form-control" name="regular_load_demand_date" datetime-picker="{{dateformat}}" ng-model="vm.electricrequirement.regular_load_demand_date" is-open="vm.datePickerOpenStatus.regular_load_demand_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'regular_load_demand_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.customertype" for="field_customertype">Customertype</label><input type="text" class="form-control" name="customertype" id="field_customertype" ng-model="vm.electricrequirement.customertype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.electricrequirement.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.electricrequirement.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.electricrequirement.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/electricrequirement/electricrequirements.html','<div><h2 data-translate="investhryApp.electricrequirement.home.title">Electricrequirements</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="electricrequirement.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.electricrequirement.home.createLabel">Create new Electricrequirement</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.electricrequirement.temporaryrequired">Temporaryrequired</span></th><th><span data-translate="investhryApp.electricrequirement.tem_load_existing">Tem Load Existing</span></th><th><span data-translate="investhryApp.electricrequirement.tem_account_number">Tem Account Number</span></th><th><span data-translate="investhryApp.electricrequirement.temp_existing_load_demand_kw">Temp Existing Load Demand Kw</span></th><th><span data-translate="investhryApp.electricrequirement.temp_existing_load_demand_kva">Temp Existing Load Demand Kva</span></th><th><span data-translate="investhryApp.electricrequirement.temp_new_load_demand_kw">Temp New Load Demand Kw</span></th><th><span data-translate="investhryApp.electricrequirement.temp_new_load_demand_kva">Temp New Load Demand Kva</span></th><th><span data-translate="investhryApp.electricrequirement.temp_load_demand_date">Temp Load Demand Date</span></th><th><span data-translate="investhryApp.electricrequirement.regular_load_required">Regular Load Required</span></th><th><span data-translate="investhryApp.electricrequirement.regular_existing_connection">Regular Existing Connection</span></th><th><span data-translate="investhryApp.electricrequirement.regular_account_number">Regular Account Number</span></th><th><span data-translate="investhryApp.electricrequirement.regular_existing_load_ifany_kw">Regular Existing Load Ifany Kw</span></th><th><span data-translate="investhryApp.electricrequirement.regular_existing_load_ifany_kva">Regular Existing Load Ifany Kva</span></th><th><span data-translate="investhryApp.electricrequirement.regular_new_load_demand_kw">Regular New Load Demand Kw</span></th><th><span data-translate="investhryApp.electricrequirement.regular_new_load_demand_kva">Regular New Load Demand Kva</span></th><th><span data-translate="investhryApp.electricrequirement.regular_load_demand_date">Regular Load Demand Date</span></th><th><span data-translate="investhryApp.electricrequirement.customertype">Customertype</span></th><th><span data-translate="investhryApp.electricrequirement.createdate">Createdate</span></th><th><span data-translate="investhryApp.electricrequirement.updatedate">Updatedate</span></th><th></th></tr></thead><tbody><tr ng-repeat="electricrequirement in vm.electricrequirements track by electricrequirement.id"><td><a ui-sref="electricrequirement-detail({id:electricrequirement.id})">{{electricrequirement.id}}</a></td><td>{{electricrequirement.temporaryrequired}}</td><td>{{electricrequirement.tem_load_existing}}</td><td>{{electricrequirement.tem_account_number}}</td><td>{{electricrequirement.temp_existing_load_demand_kw}}</td><td>{{electricrequirement.temp_existing_load_demand_kva}}</td><td>{{electricrequirement.temp_new_load_demand_kw}}</td><td>{{electricrequirement.temp_new_load_demand_kva}}</td><td>{{electricrequirement.temp_load_demand_date | date:\'medium\'}}</td><td>{{electricrequirement.regular_load_required}}</td><td>{{electricrequirement.regular_existing_connection}}</td><td>{{electricrequirement.regular_account_number}}</td><td>{{electricrequirement.regular_existing_load_ifany_kw}}</td><td>{{electricrequirement.regular_existing_load_ifany_kva}}</td><td>{{electricrequirement.regular_new_load_demand_kw}}</td><td>{{electricrequirement.regular_new_load_demand_kva}}</td><td>{{electricrequirement.regular_load_demand_date | date:\'medium\'}}</td><td>{{electricrequirement.customertype}}</td><td>{{electricrequirement.createdate | date:\'medium\'}}</td><td>{{electricrequirement.updatedate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="electricrequirement-detail({id:electricrequirement.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="electricrequirement.edit({id:electricrequirement.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="electricrequirement.delete({id:electricrequirement.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/emissiondetail/emissiondetail-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.emissiondetail.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.emissiondetail.delete.question" translate-values="{id: \'{{vm.emissiondetail.id}}\'}">Are you sure you want to delete this Emissiondetail?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/emissiondetail/emissiondetail-detail.html','<div><h2><span data-translate="investhryApp.emissiondetail.detail.title">Emissiondetail</span> {{vm.emissiondetail.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.emissiondetail.capacity">Capacity</span></dt><dd><span>{{vm.emissiondetail.capacity}}</span></dd><dt><span data-translate="investhryApp.emissiondetail.particulars">Particulars</span></dt><dd><span>{{vm.emissiondetail.particulars}}</span></dd><dt><span data-translate="investhryApp.emissiondetail.type_of_fuel">Type Of Fuel</span></dt><dd><span>{{vm.emissiondetail.type_of_fuel}}</span></dd><dt><span data-translate="investhryApp.emissiondetail.air_pollution_control_device">Air Pollution Control Device</span></dt><dd><span>{{vm.emissiondetail.air_pollution_control_device}}</span></dd><dt><span data-translate="investhryApp.emissiondetail.createdate">Createdate</span></dt><dd><span>{{vm.emissiondetail.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.emissiondetail.updatedate">Updatedate</span></dt><dd><span>{{vm.emissiondetail.updatedate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.emissiondetail.projectid">Projectid</span></dt><dd><span>{{vm.emissiondetail.projectid}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="emissiondetail-detail.edit({id:vm.emissiondetail.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/emissiondetail/emissiondetail-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEmissiondetailLabel" data-translate="investhryApp.emissiondetail.home.createOrEditLabel">Create or edit a Emissiondetail</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.emissiondetail.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.emissiondetail.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.emissiondetail.capacity" for="field_capacity">Capacity</label><input type="text" class="form-control" name="capacity" id="field_capacity" ng-model="vm.emissiondetail.capacity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.emissiondetail.particulars" for="field_particulars">Particulars</label><input type="text" class="form-control" name="particulars" id="field_particulars" ng-model="vm.emissiondetail.particulars"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.emissiondetail.type_of_fuel" for="field_type_of_fuel">Type Of Fuel</label><input type="text" class="form-control" name="type_of_fuel" id="field_type_of_fuel" ng-model="vm.emissiondetail.type_of_fuel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.emissiondetail.air_pollution_control_device" for="field_air_pollution_control_device">Air Pollution Control Device</label><input type="text" class="form-control" name="air_pollution_control_device" id="field_air_pollution_control_device" ng-model="vm.emissiondetail.air_pollution_control_device"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.emissiondetail.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.emissiondetail.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.emissiondetail.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.emissiondetail.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.emissiondetail.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.emissiondetail.projectid"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/emissiondetail/emissiondetails.html','<div><h2 data-translate="investhryApp.emissiondetail.home.title">Emissiondetails</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="emissiondetail.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.emissiondetail.home.createLabel">Create new Emissiondetail</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.emissiondetail.capacity">Capacity</span></th><th><span data-translate="investhryApp.emissiondetail.particulars">Particulars</span></th><th><span data-translate="investhryApp.emissiondetail.type_of_fuel">Type Of Fuel</span></th><th><span data-translate="investhryApp.emissiondetail.air_pollution_control_device">Air Pollution Control Device</span></th><th><span data-translate="investhryApp.emissiondetail.createdate">Createdate</span></th><th><span data-translate="investhryApp.emissiondetail.updatedate">Updatedate</span></th><th><span data-translate="investhryApp.emissiondetail.projectid">Projectid</span></th><th></th></tr></thead><tbody><tr ng-repeat="emissiondetail in vm.emissiondetails track by emissiondetail.id"><td><a ui-sref="emissiondetail-detail({id:emissiondetail.id})">{{emissiondetail.id}}</a></td><td>{{emissiondetail.capacity}}</td><td>{{emissiondetail.particulars}}</td><td>{{emissiondetail.type_of_fuel}}</td><td>{{emissiondetail.air_pollution_control_device}}</td><td>{{emissiondetail.createdate | date:\'medium\'}}</td><td>{{emissiondetail.updatedate | date:\'medium\'}}</td><td>{{emissiondetail.projectid}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="emissiondetail-detail({id:emissiondetail.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="emissiondetail.edit({id:emissiondetail.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="emissiondetail.delete({id:emissiondetail.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/emmision-fuel-type/emmision-fuel-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.emmision_fuel_type.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.emmision_fuel_type.delete.question" translate-values="{id: \'{{vm.emmision_fuel_type.id}}\'}">Are you sure you want to delete this Emmision Fuel Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/emmision-fuel-type/emmision-fuel-type-detail.html','<div class="container"><h2><span data-translate="investhryApp.emmision_fuel_type.detail.title">Emmision Fuel Type</span> {{vm.emmision_fuel_type.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.emmision_fuel_type.typeoffuel">Typeoffuel</span></dt><dd><span>{{vm.emmision_fuel_type.typeoffuel}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="emmision-fuel-type-detail.edit({id:vm.emmision_fuel_type.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/emmision-fuel-type/emmision-fuel-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEmmision_fuel_typeLabel" data-translate="investhryApp.emmision_fuel_type.home.createOrEditLabel">Create or edit a Emmision Fuel Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.emmision_fuel_type.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.emmision_fuel_type.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.emmision_fuel_type.typeoffuel" for="field_typeoffuel">Typeoffuel</label><input type="text" class="form-control" name="typeoffuel" id="field_typeoffuel" ng-model="vm.emmision_fuel_type.typeoffuel" required><div ng-show="editForm.typeoffuel.$invalid"><p class="help-block" ng-show="editForm.typeoffuel.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/emmision-fuel-type/emmision-fuel-types.html','<div class="container"><h2 data-translate="investhryApp.emmision_fuel_type.home.title">Emmision Fuel Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="emmision-fuel-type.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.emmision_fuel_type.home.createLabel">Create new Emmision Fuel Type</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.emmision_fuel_type.typeoffuel">Typeoffuel</span></th><th></th></tr></thead><tbody><tr ng-repeat="emmision_fuel_type in vm.emmision_fuel_types track by emmision_fuel_type.id"><td><a ui-sref="emmision-fuel-type-detail({id:emmision_fuel_type.id})">{{emmision_fuel_type.id}}</a></td><td>{{emmision_fuel_type.typeoffuel}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="emmision-fuel-type-detail({id:emmision_fuel_type.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="emmision-fuel-type.edit({id:emmision_fuel_type.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="emmision-fuel-type.delete({id:emmision_fuel_type.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/emmision-pollution-controll/emmision-pollution-controll-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.emmision_pollution_controll.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.emmision_pollution_controll.delete.question" translate-values="{id: \'{{vm.emmision_pollution_controll.id}}\'}">Are you sure you want to delete this Emmision Pollution Controll?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/emmision-pollution-controll/emmision-pollution-controll-detail.html','<div class="container"><h2><span data-translate="investhryApp.emmision_pollution_controll.detail.title">Emmision Pollution Controll</span> {{vm.emmision_pollution_controll.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.emmision_pollution_controll.airpollutioncontroldevice">Airpollutioncontroldevice</span></dt><dd><span>{{vm.emmision_pollution_controll.airpollutioncontroldevice}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="emmision-pollution-controll-detail.edit({id:vm.emmision_pollution_controll.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/emmision-pollution-controll/emmision-pollution-controll-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEmmision_pollution_controllLabel" data-translate="investhryApp.emmision_pollution_controll.home.createOrEditLabel">Create or edit a Emmision Pollution Controll</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.emmision_pollution_controll.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.emmision_pollution_controll.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.emmision_pollution_controll.airpollutioncontroldevice" for="field_airpollutioncontroldevice">Airpollutioncontroldevice</label><input type="text" class="form-control" name="airpollutioncontroldevice" id="field_airpollutioncontroldevice" ng-model="vm.emmision_pollution_controll.airpollutioncontroldevice" required><div ng-show="editForm.airpollutioncontroldevice.$invalid"><p class="help-block" ng-show="editForm.airpollutioncontroldevice.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/emmision-pollution-controll/emmision-pollution-controlls.html','<div class="container"><h2 data-translate="investhryApp.emmision_pollution_controll.home.title">Emmision Pollution Controlls</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="emmision-pollution-controll.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.emmision_pollution_controll.home.createLabel">Create new Emmision Pollution Controll</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.emmision_pollution_controll.airpollutioncontroldevice">Airpollutioncontroldevice</span></th><th></th></tr></thead><tbody><tr ng-repeat="emmision_pollution_controll in vm.emmision_pollution_controlls track by emmision_pollution_controll.id"><td><a ui-sref="emmision-pollution-controll-detail({id:emmision_pollution_controll.id})">{{emmision_pollution_controll.id}}</a></td><td>{{emmision_pollution_controll.airpollutioncontroldevice}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="emmision-pollution-controll-detail({id:emmision_pollution_controll.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="emmision-pollution-controll.edit({id:emmision_pollution_controll.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="emmision-pollution-controll.delete({id:emmision_pollution_controll.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/environment-impactdetail/environment-impactdetail-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.environment_impactdetail.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.environment_impactdetail.delete.question" translate-values="{id: \'{{vm.environment_impactdetail.id}}\'}">Are you sure you want to delete this Environment Impactdetail?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/environment-impactdetail/environment-impactdetail-detail.html','<div><h2><span data-translate="investhryApp.environment_impactdetail.detail.title">Environment Impactdetail</span> {{vm.environment_impactdetail.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.environment_impactdetail.source_of_water_supply">Source Of Water Supply</span></dt><dd><span>{{vm.environment_impactdetail.source_of_water_supply}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.mode_of_disposal_for_discharge">Mode Of Disposal For Discharge</span></dt><dd><span>{{vm.environment_impactdetail.mode_of_disposal_for_discharge}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.recycling_process">Recycling Process</span></dt><dd><span>{{vm.environment_impactdetail.recycling_process}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.recycling_cooling">Recycling Cooling</span></dt><dd><span>{{vm.environment_impactdetail.recycling_cooling}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.recycling_domestic">Recycling Domestic</span></dt><dd><span>{{vm.environment_impactdetail.recycling_domestic}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.recycling_other">Recycling Other</span></dt><dd><span>{{vm.environment_impactdetail.recycling_other}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.createdate">Createdate</span></dt><dd><span>{{vm.environment_impactdetail.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.updatedate">Updatedate</span></dt><dd><span>{{vm.environment_impactdetail.updatedate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.sourcewatersupplyother">Sourcewatersupplyother</span></dt><dd><span>{{vm.environment_impactdetail.sourcewatersupplyother}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.modedisposalother">Modedisposalother</span></dt><dd><span>{{vm.environment_impactdetail.modedisposalother}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.water_process">Water Process</span></dt><dd><span>{{vm.environment_impactdetail.water_process}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.water_cooling">Water Cooling</span></dt><dd><span>{{vm.environment_impactdetail.water_cooling}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.water_domestic">Water Domestic</span></dt><dd><span>{{vm.environment_impactdetail.water_domestic}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.water_other">Water Other</span></dt><dd><span>{{vm.environment_impactdetail.water_other}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.waste_water_process">Waste Water Process</span></dt><dd><span>{{vm.environment_impactdetail.waste_water_process}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.waste_water_cooling">Waste Water Cooling</span></dt><dd><span>{{vm.environment_impactdetail.waste_water_cooling}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.waste_water_domesting">Waste Water Domesting</span></dt><dd><span>{{vm.environment_impactdetail.waste_water_domesting}}</span></dd><dt><span data-translate="investhryApp.environment_impactdetail.waste_water_other">Waste Water Other</span></dt><dd><span>{{vm.environment_impactdetail.waste_water_other}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="environment-impactdetail-detail.edit({id:vm.environment_impactdetail.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/environment-impactdetail/environment-impactdetail-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEnvironment_impactdetailLabel" data-translate="investhryApp.environment_impactdetail.home.createOrEditLabel">Create or edit a Environment Impactdetail</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.environment_impactdetail.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.environment_impactdetail.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.source_of_water_supply" for="field_source_of_water_supply">Source Of Water Supply</label><input type="text" class="form-control" name="source_of_water_supply" id="field_source_of_water_supply" ng-model="vm.environment_impactdetail.source_of_water_supply"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.mode_of_disposal_for_discharge" for="field_mode_of_disposal_for_discharge">Mode Of Disposal For Discharge</label><input type="text" class="form-control" name="mode_of_disposal_for_discharge" id="field_mode_of_disposal_for_discharge" ng-model="vm.environment_impactdetail.mode_of_disposal_for_discharge"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.recycling_process" for="field_recycling_process">Recycling Process</label><input type="text" class="form-control" name="recycling_process" id="field_recycling_process" ng-model="vm.environment_impactdetail.recycling_process"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.recycling_cooling" for="field_recycling_cooling">Recycling Cooling</label><input type="text" class="form-control" name="recycling_cooling" id="field_recycling_cooling" ng-model="vm.environment_impactdetail.recycling_cooling"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.recycling_domestic" for="field_recycling_domestic">Recycling Domestic</label><input type="text" class="form-control" name="recycling_domestic" id="field_recycling_domestic" ng-model="vm.environment_impactdetail.recycling_domestic"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.recycling_other" for="field_recycling_other">Recycling Other</label><input type="text" class="form-control" name="recycling_other" id="field_recycling_other" ng-model="vm.environment_impactdetail.recycling_other"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.environment_impactdetail.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.environment_impactdetail.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.sourcewatersupplyother" for="field_sourcewatersupplyother">Sourcewatersupplyother</label><input type="text" class="form-control" name="sourcewatersupplyother" id="field_sourcewatersupplyother" ng-model="vm.environment_impactdetail.sourcewatersupplyother"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.modedisposalother" for="field_modedisposalother">Modedisposalother</label><input type="text" class="form-control" name="modedisposalother" id="field_modedisposalother" ng-model="vm.environment_impactdetail.modedisposalother"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.water_process" for="field_water_process">Water Process</label><input type="number" class="form-control" name="water_process" id="field_water_process" ng-model="vm.environment_impactdetail.water_process"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.water_cooling" for="field_water_cooling">Water Cooling</label><input type="number" class="form-control" name="water_cooling" id="field_water_cooling" ng-model="vm.environment_impactdetail.water_cooling"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.water_domestic" for="field_water_domestic">Water Domestic</label><input type="number" class="form-control" name="water_domestic" id="field_water_domestic" ng-model="vm.environment_impactdetail.water_domestic"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.water_other" for="field_water_other">Water Other</label><input type="text" class="form-control" name="water_other" id="field_water_other" ng-model="vm.environment_impactdetail.water_other"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.waste_water_process" for="field_waste_water_process">Waste Water Process</label><input type="number" class="form-control" name="waste_water_process" id="field_waste_water_process" ng-model="vm.environment_impactdetail.waste_water_process"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.waste_water_cooling" for="field_waste_water_cooling">Waste Water Cooling</label><input type="number" class="form-control" name="waste_water_cooling" id="field_waste_water_cooling" ng-model="vm.environment_impactdetail.waste_water_cooling"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.waste_water_domesting" for="field_waste_water_domesting">Waste Water Domesting</label><input type="number" class="form-control" name="waste_water_domesting" id="field_waste_water_domesting" ng-model="vm.environment_impactdetail.waste_water_domesting"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.environment_impactdetail.waste_water_other" for="field_waste_water_other">Waste Water Other</label><input type="text" class="form-control" name="waste_water_other" id="field_waste_water_other" ng-model="vm.environment_impactdetail.waste_water_other"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/environment-impactdetail/environment-impactdetails.html','<div><h2 data-translate="investhryApp.environment_impactdetail.home.title">Environment Impactdetails</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="environment-impactdetail.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.environment_impactdetail.home.createLabel">Create new Environment Impactdetail</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.environment_impactdetail.source_of_water_supply">Source Of Water Supply</span></th><th><span data-translate="investhryApp.environment_impactdetail.mode_of_disposal_for_discharge">Mode Of Disposal For Discharge</span></th><th><span data-translate="investhryApp.environment_impactdetail.recycling_process">Recycling Process</span></th><th><span data-translate="investhryApp.environment_impactdetail.recycling_cooling">Recycling Cooling</span></th><th><span data-translate="investhryApp.environment_impactdetail.recycling_domestic">Recycling Domestic</span></th><th><span data-translate="investhryApp.environment_impactdetail.recycling_other">Recycling Other</span></th><th><span data-translate="investhryApp.environment_impactdetail.createdate">Createdate</span></th><th><span data-translate="investhryApp.environment_impactdetail.updatedate">Updatedate</span></th><th><span data-translate="investhryApp.environment_impactdetail.sourcewatersupplyother">Sourcewatersupplyother</span></th><th><span data-translate="investhryApp.environment_impactdetail.modedisposalother">Modedisposalother</span></th><th><span data-translate="investhryApp.environment_impactdetail.water_process">Water Process</span></th><th><span data-translate="investhryApp.environment_impactdetail.water_cooling">Water Cooling</span></th><th><span data-translate="investhryApp.environment_impactdetail.water_domestic">Water Domestic</span></th><th><span data-translate="investhryApp.environment_impactdetail.water_other">Water Other</span></th><th><span data-translate="investhryApp.environment_impactdetail.waste_water_process">Waste Water Process</span></th><th><span data-translate="investhryApp.environment_impactdetail.waste_water_cooling">Waste Water Cooling</span></th><th><span data-translate="investhryApp.environment_impactdetail.waste_water_domesting">Waste Water Domesting</span></th><th><span data-translate="investhryApp.environment_impactdetail.waste_water_other">Waste Water Other</span></th><th></th></tr></thead><tbody><tr ng-repeat="environment_impactdetail in vm.environment_impactdetails track by environment_impactdetail.id"><td><a ui-sref="environment-impactdetail-detail({id:environment_impactdetail.id})">{{environment_impactdetail.id}}</a></td><td>{{environment_impactdetail.source_of_water_supply}}</td><td>{{environment_impactdetail.mode_of_disposal_for_discharge}}</td><td>{{environment_impactdetail.recycling_process}}</td><td>{{environment_impactdetail.recycling_cooling}}</td><td>{{environment_impactdetail.recycling_domestic}}</td><td>{{environment_impactdetail.recycling_other}}</td><td>{{environment_impactdetail.createdate | date:\'medium\'}}</td><td>{{environment_impactdetail.updatedate | date:\'medium\'}}</td><td>{{environment_impactdetail.sourcewatersupplyother}}</td><td>{{environment_impactdetail.modedisposalother}}</td><td>{{environment_impactdetail.water_process}}</td><td>{{environment_impactdetail.water_cooling}}</td><td>{{environment_impactdetail.water_domestic}}</td><td>{{environment_impactdetail.water_other}}</td><td>{{environment_impactdetail.waste_water_process}}</td><td>{{environment_impactdetail.waste_water_cooling}}</td><td>{{environment_impactdetail.waste_water_domesting}}</td><td>{{environment_impactdetail.waste_water_other}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="environment-impactdetail-detail({id:environment_impactdetail.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="environment-impactdetail.edit({id:environment_impactdetail.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="environment-impactdetail.delete({id:environment_impactdetail.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/estate/estate-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.estate.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.estate.delete.question" translate-values="{id: \'{{vm.estate.id}}\'}">Are you sure you want to delete this Estate?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/estate/estate-detail.html','<div><h2><span data-translate="investhryApp.estate.detail.title">Estate</span> {{vm.estate.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.estate.estate">Estate</span></dt><dd><span>{{vm.estate.estate}}</span></dd><dt><span data-translate="investhryApp.estate.district">District</span></dt><dd><span>{{vm.estate.district}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="estate-detail.edit({id:vm.estate.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/estate/estate-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEstateLabel" data-translate="investhryApp.estate.home.createOrEditLabel">Create or edit a Estate</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.estate.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.estate.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.estate.estate" for="field_estate">Estate</label><input type="text" class="form-control" name="estate" id="field_estate" ng-model="vm.estate.estate" required><div ng-show="editForm.estate.$invalid"><p class="help-block" ng-show="editForm.estate.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_district">District</label><select type="text" class="form-control" name="district" id="field_district" ng-model="vm.estate.district" ng-options="x.districtname as x.districtname for x in vm.districts" required><option value="">Select</option></select><div ng-show="editForm.district.$invalid"><p class="help-block" ng-show="editForm.district.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/estate/estates.html','<div><h2 data-translate="investhryApp.estate.home.title">Estates</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="estate.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.estate.home.createLabel">Create new Estate</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.estate.estate">Estate</span></th><th><span data-translate="investhryApp.estate.district">District</span></th><th></th></tr></thead><tbody><tr ng-repeat="estate in vm.estates track by estate.id"><td><a ui-sref="estate-detail({id:estate.id})">{{estate.id}}</a></td><td>{{estate.estate}}</td><td>{{estate.district}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="estate-detail({id:estate.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="estate.edit({id:estate.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="estate.delete({id:estate.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/estate-manager/estate-manager-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.estateManager.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.estateManager.delete.question" translate-values="{id: \'{{vm.estateManager.id}}\'}">Are you sure you want to delete this Estate Manager?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/estate-manager/estate-manager-detail.html','<div><h2><span data-translate="investhryApp.estateManager.detail.title">Estate Manager</span> {{vm.estateManager.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.estateManager.login">Login</span></dt><dd><span>{{vm.estateManager.login}}</span></dd><dt><span data-translate="investhryApp.estateManager.estate">Estate</span></dt><dd><span>{{vm.estateManager.estate}}</span></dd><dt><span data-translate="investhryApp.estateManager.district">District</span></dt><dd><span>{{vm.estateManager.district}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="estate-manager-detail.edit({id:vm.estateManager.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/estate-manager/estate-manager-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEstateManagerLabel" data-translate="investhryApp.estateManager.home.createOrEditLabel">Create or edit a Estate Manager</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.estateManager.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.estateManager.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.estateManager.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.estateManager.login" required><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_district">District</label><select type="text" class="form-control" name="district" id="field_district" ng-model="vm.estateManager.district" ng-options="x.districtname as x.districtname for x in vm.districts" ng-change="vm.loadEstates()" required><option value="">Select</option></select><div ng-show="editForm.district.$invalid"><p class="help-block" ng-show="editForm.district.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" for="field_estate">Estate</label><select type="text" class="form-control" name="district" id="field_estate" ng-model="vm.estateManager.estate" ng-options="x.estate as x.estate for x in vm.estates" required><option value="">Select</option></select><div ng-show="editForm.district.$invalid"><p class="help-block" ng-show="editForm.district.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/estate-manager/estate-managers.html','<div><h2 data-translate="investhryApp.estateManager.home.title">Estate Managers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="estate-manager.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.estateManager.home.createLabel">Create new Estate Manager</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.estateManager.login">Login</span></th><th><span data-translate="investhryApp.estateManager.estate">Estate</span></th><th><span data-translate="investhryApp.estateManager.district">District</span></th><th></th></tr></thead><tbody><tr ng-repeat="estateManager in vm.estateManagers track by estateManager.id"><td><a ui-sref="estate-manager-detail({id:estateManager.id})">{{estateManager.id}}</a></td><td>{{estateManager.login}}</td><td>{{estateManager.estate}}</td><td>{{estateManager.district}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="estate-manager-detail({id:estateManager.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="estate-manager.edit({id:estateManager.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" has-authority="ROLE_ADMIN" ui-sref="estate-manager.delete({id:estateManager.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/excise-service-form-filled/excise-service-form-filled-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.exciseServiceFormFilled.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.exciseServiceFormFilled.delete.question" translate-values="{id: \'{{vm.exciseServiceFormFilled.id}}\'}">Are you sure you want to delete this Excise Service Form Filled?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/excise-service-form-filled/excise-service-form-filled-detail.html','<div><h2><span data-translate="investhryApp.exciseServiceFormFilled.detail.title">Excise Service Form Filled</span> {{vm.exciseServiceFormFilled.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.exciseServiceFormFilled.projectId">Project Id</span></dt><dd><span>{{vm.exciseServiceFormFilled.projectId}}</span></dd><dt><span data-translate="investhryApp.exciseServiceFormFilled.serviceId">Service Id</span></dt><dd><span>{{vm.exciseServiceFormFilled.serviceId}}</span></dd><dt><span data-translate="investhryApp.exciseServiceFormFilled.status">Status</span></dt><dd><span>{{vm.exciseServiceFormFilled.status}}</span></dd><dt><span data-translate="investhryApp.exciseServiceFormFilled.lastActionDate">Last Action Date</span></dt><dd><span>{{vm.exciseServiceFormFilled.lastActionDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.exciseServiceFormFilled.formFilledDate">Form Filled Date</span></dt><dd><span>{{vm.exciseServiceFormFilled.formFilledDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="excise-service-form-filled-detail.edit({id:vm.exciseServiceFormFilled.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/excise-service-form-filled/excise-service-form-filled-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myExciseServiceFormFilledLabel" data-translate="investhryApp.exciseServiceFormFilled.home.createOrEditLabel">Create or edit a Excise Service Form Filled</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.exciseServiceFormFilled.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.exciseServiceFormFilled.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.exciseServiceFormFilled.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.exciseServiceFormFilled.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.exciseServiceFormFilled.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.exciseServiceFormFilled.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.exciseServiceFormFilled.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.exciseServiceFormFilled.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.exciseServiceFormFilled.lastActionDate" for="field_lastActionDate">Last Action Date</label><div class="input-group"><input id="field_lastActionDate" type="text" class="form-control" name="lastActionDate" datetime-picker="{{dateformat}}" ng-model="vm.exciseServiceFormFilled.lastActionDate" is-open="vm.datePickerOpenStatus.lastActionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastActionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.exciseServiceFormFilled.formFilledDate" for="field_formFilledDate">Form Filled Date</label><div class="input-group"><input id="field_formFilledDate" type="text" class="form-control" name="formFilledDate" datetime-picker="{{dateformat}}" ng-model="vm.exciseServiceFormFilled.formFilledDate" is-open="vm.datePickerOpenStatus.formFilledDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'formFilledDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/excise-service-form-filled/excise-service-form-filleds.html','<div><h2 data-translate="investhryApp.exciseServiceFormFilled.home.title">Excise Service Form Filleds</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="excise-service-form-filled.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.exciseServiceFormFilled.home.createLabel">Create new Excise Service Form Filled</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.exciseServiceFormFilled.projectId">Project Id</span></th><th><span data-translate="investhryApp.exciseServiceFormFilled.serviceId">Service Id</span></th><th><span data-translate="investhryApp.exciseServiceFormFilled.status">Status</span></th><th><span data-translate="investhryApp.exciseServiceFormFilled.lastActionDate">Last Action Date</span></th><th><span data-translate="investhryApp.exciseServiceFormFilled.formFilledDate">Form Filled Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="exciseServiceFormFilled in vm.exciseServiceFormFilleds track by exciseServiceFormFilled.id"><td><a ui-sref="excise-service-form-filled-detail({id:exciseServiceFormFilled.id})">{{exciseServiceFormFilled.id}}</a></td><td>{{exciseServiceFormFilled.projectId}}</td><td>{{exciseServiceFormFilled.serviceId}}</td><td>{{exciseServiceFormFilled.status}}</td><td>{{exciseServiceFormFilled.lastActionDate | date:\'medium\'}}</td><td>{{exciseServiceFormFilled.formFilledDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="excise-service-form-filled-detail({id:exciseServiceFormFilled.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="excise-service-form-filled.edit({id:exciseServiceFormFilled.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="excise-service-form-filled.delete({id:exciseServiceFormFilled.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/extended-user-information/extended-user-information-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.extendedUserInformation.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.extendedUserInformation.delete.question" translate-values="{id: \'{{vm.extendedUserInformation.id}}\'}">Are you sure you want to delete this Extended User Information?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/extended-user-information/extended-user-information-detail.html','<div><h2><span data-translate="investhryApp.extendedUserInformation.detail.title">Extended User Information</span> {{vm.extendedUserInformation.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.extendedUserInformation.userAddress">User Address</span></dt><dd><span>{{vm.extendedUserInformation.userAddress}}</span></dd><dt><span data-translate="investhryApp.extendedUserInformation.userMobile">User Mobile</span></dt><dd><span>{{vm.extendedUserInformation.userMobile}}</span></dd><dt><span data-translate="investhryApp.extendedUserInformation.userid">Userid</span></dt><dd><span>{{vm.extendedUserInformation.userid}}</span></dd><dt><span data-translate="investhryApp.extendedUserInformation.userlogin">Userlogin</span></dt><dd><span>{{vm.extendedUserInformation.userlogin}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="extended-user-information-detail.edit({id:vm.extendedUserInformation.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/extended-user-information/extended-user-information-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myExtendedUserInformationLabel" data-translate="investhryApp.extendedUserInformation.home.createOrEditLabel">Create or edit a Extended User Information</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.extendedUserInformation.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.extendedUserInformation.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.extendedUserInformation.userAddress" for="field_userAddress">User Address</label><input type="text" class="form-control" name="userAddress" id="field_userAddress" ng-model="vm.extendedUserInformation.userAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.extendedUserInformation.userMobile" for="field_userMobile">User Mobile</label><input type="text" class="form-control" name="userMobile" id="field_userMobile" ng-model="vm.extendedUserInformation.userMobile"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.extendedUserInformation.userid" for="field_userid">Userid</label><input type="text" class="form-control" name="userid" id="field_userid" ng-model="vm.extendedUserInformation.userid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.extendedUserInformation.userlogin" for="field_userlogin">Userlogin</label><input type="text" class="form-control" name="userlogin" id="field_userlogin" ng-model="vm.extendedUserInformation.userlogin"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/extended-user-information/extended-user-informations.html','<div><h2 data-translate="investhryApp.extendedUserInformation.home.title">Extended User Informations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="extended-user-information.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.extendedUserInformation.home.createLabel">Create new Extended User Information</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.extendedUserInformation.userAddress">User Address</span></th><th><span data-translate="investhryApp.extendedUserInformation.userMobile">User Mobile</span></th><th><span data-translate="investhryApp.extendedUserInformation.userid">Userid</span></th><th><span data-translate="investhryApp.extendedUserInformation.userlogin">Userlogin</span></th><th></th></tr></thead><tbody><tr ng-repeat="extendedUserInformation in vm.extendedUserInformations track by extendedUserInformation.id"><td><a ui-sref="extended-user-information-detail({id:extendedUserInformation.id})">{{extendedUserInformation.id}}</a></td><td>{{extendedUserInformation.userAddress}}</td><td>{{extendedUserInformation.userMobile}}</td><td>{{extendedUserInformation.userid}}</td><td>{{extendedUserInformation.userlogin}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="extended-user-information-detail({id:extendedUserInformation.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="extended-user-information.edit({id:extendedUserInformation.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="extended-user-information.delete({id:extendedUserInformation.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/factoty-plan/factoty-plan-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.factotyPlan.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.factotyPlan.delete.question" translate-values="{id: \'{{vm.factotyPlan.id}}\'}">Are you sure you want to delete this Factoty Plan?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/factoty-plan/factoty-plan-detail.html','<div><h2><span data-translate="investhryApp.factotyPlan.detail.title">Factoty Plan</span> {{vm.factotyPlan.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.factotyPlan.nameApplicant">Name Applicant</span></dt><dd><span>{{vm.factotyPlan.nameApplicant}}</span></dd><dt><span data-translate="investhryApp.factotyPlan.applicantAddress">Applicant Address</span></dt><dd><span>{{vm.factotyPlan.applicantAddress}}</span></dd><dt><span data-translate="investhryApp.factotyPlan.factoryAddress">Factory Address</span></dt><dd><span>{{vm.factotyPlan.factoryAddress}}</span></dd><dt><span data-translate="investhryApp.factotyPlan.factorySituation">Factory Situation</span></dt><dd><span>{{vm.factotyPlan.factorySituation}}</span></dd><dt><span data-translate="investhryApp.factotyPlan.state">State</span></dt><dd><span>{{vm.factotyPlan.state}}</span></dd><dt><span data-translate="investhryApp.factotyPlan.district">District</span></dt><dd><span>{{vm.factotyPlan.district}}</span></dd><dt><span data-translate="investhryApp.factotyPlan.town">Town</span></dt><dd><span>{{vm.factotyPlan.town}}</span></dd><dt><span data-translate="investhryApp.factotyPlan.nearestRailwayStation">Nearest Railway Station</span></dt><dd><span>{{vm.factotyPlan.nearestRailwayStation}}</span></dd><dt><span data-translate="investhryApp.factotyPlan.perticularPlant">Perticular Plant</span></dt><dd><span>{{vm.factotyPlan.perticularPlant}}</span></dd><dt><span data-translate="investhryApp.factotyPlan.datePlant">Date Plant</span></dt><dd><span>{{vm.factotyPlan.datePlant | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.factotyPlan.factoryName">Factory Name</span></dt><dd><span>{{vm.factotyPlan.factoryName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="factoty-plan-detail.edit({id:vm.factotyPlan.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/factoty-plan/factoty-plan-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFactotyPlanLabel" data-translate="investhryApp.factotyPlan.home.createOrEditLabel">Create or edit a Factoty Plan</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.factotyPlan.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.factotyPlan.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.nameApplicant" for="field_nameApplicant">Name Applicant</label><input type="text" class="form-control" name="nameApplicant" id="field_nameApplicant" ng-model="vm.factotyPlan.nameApplicant"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.applicantAddress" for="field_applicantAddress">Applicant Address</label><input type="text" class="form-control" name="applicantAddress" id="field_applicantAddress" ng-model="vm.factotyPlan.applicantAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.factoryAddress" for="field_factoryAddress">Factory Address</label><input type="text" class="form-control" name="factoryAddress" id="field_factoryAddress" ng-model="vm.factotyPlan.factoryAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.factorySituation" for="field_factorySituation">Factory Situation</label><input type="text" class="form-control" name="factorySituation" id="field_factorySituation" ng-model="vm.factotyPlan.factorySituation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.state" for="field_state">State</label><input type="text" class="form-control" name="state" id="field_state" ng-model="vm.factotyPlan.state"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.factotyPlan.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.town" for="field_town">Town</label><input type="text" class="form-control" name="town" id="field_town" ng-model="vm.factotyPlan.town"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.nearestRailwayStation" for="field_nearestRailwayStation">Nearest Railway Station</label><input type="text" class="form-control" name="nearestRailwayStation" id="field_nearestRailwayStation" ng-model="vm.factotyPlan.nearestRailwayStation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.perticularPlant" for="field_perticularPlant">Perticular Plant</label><input type="text" class="form-control" name="perticularPlant" id="field_perticularPlant" ng-model="vm.factotyPlan.perticularPlant"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.datePlant" for="field_datePlant">Date Plant</label><div class="input-group"><input id="field_datePlant" type="text" class="form-control" name="datePlant" uib-datepicker-popup="{{dateformat}}" ng-model="vm.factotyPlan.datePlant" is-open="vm.datePickerOpenStatus.datePlant"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'datePlant\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.factotyPlan.factoryName" for="field_factoryName">Factory Name</label><input type="text" class="form-control" name="factoryName" id="field_factoryName" ng-model="vm.factotyPlan.factoryName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/factoty-plan/factoty-plans.html','<div><h2 data-translate="investhryApp.factotyPlan.home.title">Factoty Plans</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="factoty-plan.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.factotyPlan.home.createLabel">Create new Factoty Plan</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.factotyPlan.nameApplicant">Name Applicant</span></th><th><span data-translate="investhryApp.factotyPlan.applicantAddress">Applicant Address</span></th><th><span data-translate="investhryApp.factotyPlan.factoryAddress">Factory Address</span></th><th><span data-translate="investhryApp.factotyPlan.factorySituation">Factory Situation</span></th><th><span data-translate="investhryApp.factotyPlan.state">State</span></th><th><span data-translate="investhryApp.factotyPlan.district">District</span></th><th><span data-translate="investhryApp.factotyPlan.town">Town</span></th><th><span data-translate="investhryApp.factotyPlan.nearestRailwayStation">Nearest Railway Station</span></th><th><span data-translate="investhryApp.factotyPlan.perticularPlant">Perticular Plant</span></th><th><span data-translate="investhryApp.factotyPlan.datePlant">Date Plant</span></th><th><span data-translate="investhryApp.factotyPlan.factoryName">Factory Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="factotyPlan in vm.factotyPlans track by factotyPlan.id"><td><a ui-sref="factoty-plan-detail({id:factotyPlan.id})">{{factotyPlan.id}}</a></td><td>{{factotyPlan.nameApplicant}}</td><td>{{factotyPlan.applicantAddress}}</td><td>{{factotyPlan.factoryAddress}}</td><td>{{factotyPlan.factorySituation}}</td><td>{{factotyPlan.state}}</td><td>{{factotyPlan.district}}</td><td>{{factotyPlan.town}}</td><td>{{factotyPlan.nearestRailwayStation}}</td><td>{{factotyPlan.perticularPlant}}</td><td>{{factotyPlan.datePlant | date:\'mediumDate\'}}</td><td>{{factotyPlan.factoryName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="factoty-plan-detail({id:factotyPlan.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="factoty-plan.edit({id:factotyPlan.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="factoty-plan.delete({id:factotyPlan.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/feedback-officer/feedback-officer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.feedbackOfficer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.feedbackOfficer.delete.question" translate-values="{id: \'{{vm.feedbackOfficer.id}}\'}">Are you sure you want to delete this Feedback Officer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/feedback-officer/feedback-officer-detail.html','<div><h2><span data-translate="investhryApp.feedbackOfficer.detail.title">Feedback Officer</span> {{vm.feedbackOfficer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.feedbackOfficer.login">Login</span></dt><dd><span>{{vm.feedbackOfficer.login}}</span></dd><dt><span data-translate="investhryApp.feedbackOfficer.departmentName">Department Name</span></dt><dd><span>{{vm.feedbackOfficer.departmentName}}</span></dd><dt><span data-translate="investhryApp.feedbackOfficer.departmentId">Department Id</span></dt><dd><span>{{vm.feedbackOfficer.departmentId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="feedback-officer-detail.edit({id:vm.feedbackOfficer.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/feedback-officer/feedback-officer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFeedbackOfficerLabel" data-translate="investhryApp.feedbackOfficer.home.createOrEditLabel">Create or edit a Feedback Officer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.feedbackOfficer.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.feedbackOfficer.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.feedbackOfficer.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.feedbackOfficer.login" required><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.feedbackOfficer.departmentName" for="field_departmentName">Department Name</label><select class="form-control" ng-model="vm.feedbackOfficer.departmentName" ng-options="department.departmentname for department in vm.departments" name="departmentName" id="field_departmentName" ng-change="vm.onDepartmentChange(vm.feedbackOfficer.departmentName)" required><option value="" disabled="disabled">Select Department</option></select><div ng-show="editForm.departmentName.$invalid"><p class="help-block" ng-show="editForm.departmentName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/feedback-officer/feedback-officers.html','<div><h2 data-translate="investhryApp.feedbackOfficer.home.title">Feedback Officers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="feedback-officer.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.feedbackOfficer.home.createLabel">Create new Feedback Officer</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.feedbackOfficer.login">Login</span></th><th><span data-translate="investhryApp.feedbackOfficer.departmentName">Department Name</span></th><th><span data-translate="investhryApp.feedbackOfficer.departmentId">Department Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="feedbackOfficer in vm.feedbackOfficers track by feedbackOfficer.id"><td><a ui-sref="feedback-officer-detail({id:feedbackOfficer.id})">{{feedbackOfficer.id}}</a></td><td>{{feedbackOfficer.login}}</td><td>{{feedbackOfficer.departmentName}}</td><td>{{feedbackOfficer.departmentId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="feedback-officer-detail({id:feedbackOfficer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="feedback-officer.edit({id:feedbackOfficer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="feedback-officer.delete({id:feedbackOfficer.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/filetesting/filetesting-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.filetesting.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.filetesting.delete.question" translate-values="{id: \'{{vm.filetesting.id}}\'}">Are you sure you want to delete this Filetesting?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/filetesting/filetesting-detail.html','<div><h2><span data-translate="investhryApp.filetesting.detail.title">Filetesting</span> {{vm.filetesting.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.filetesting.filename">Filename</span></dt><dd><span>{{vm.filetesting.filename}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="filetesting-detail.edit({id:vm.filetesting.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/filetesting/filetesting-dialog.html','<form name="editForm" role="form" enctype="multipart/form-data" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFiletestingLabel" data-translate="investhryApp.filetesting.home.createOrEditLabel">Create or edit a Filetesting</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.filetesting.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.filetesting.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.filetesting.filename" for="field_filename">Filename</label><input type="text" class="form-control" name="filename" id="field_filename" ng-model="vm.filetesting.filename"></div><div class="form-group"><label class="control-label" for="field_file">Filename</label><input type="file" class="form-control" name="file" id="field_file" file-model="vm.filetesting.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/filetesting/filetestings.html','<div><h2 data-translate="investhryApp.filetesting.home.title">Filetestings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="filetesting.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.filetesting.home.createLabel">Create new Filetesting</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.filetesting.filename">Filename</span></th><th></th></tr></thead><tbody><tr ng-repeat="filetesting in vm.filetestings track by filetesting.id"><td><a ui-sref="filetesting-detail({id:filetesting.id})">{{filetesting.id}}</a></td><td>{{filetesting.filename}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="filetesting-detail({id:filetesting.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="filetesting.edit({id:filetesting.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="filetesting.delete({id:filetesting.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/foreignfundingresource/foreignfundingresource-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.foreignfundingresource.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.foreignfundingresource.delete.question" translate-values="{id: \'{{vm.foreignfundingresource.id}}\'}">Are you sure you want to delete this Foreignfundingresource?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/foreignfundingresource/foreignfundingresource-detail.html','<div class="container"><h2><span data-translate="investhryApp.foreignfundingresource.detail.title">Foreignfundingresource</span> {{vm.foreignfundingresource.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.foreignfundingresource.foreignfundingtypes">Foreignfundingtypes</span></dt><dd><span>{{vm.foreignfundingresource.foreignfundingtypes}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="foreignfundingresource-detail.edit({id:vm.foreignfundingresource.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/foreignfundingresource/foreignfundingresource-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myForeignfundingresourceLabel" data-translate="investhryApp.foreignfundingresource.home.createOrEditLabel">Create or edit a Foreignfundingresource</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.foreignfundingresource.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.foreignfundingresource.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.foreignfundingresource.foreignfundingtypes" for="field_foreignfundingtypes">Foreignfundingtypes</label><input type="text" class="form-control" name="foreignfundingtypes" id="field_foreignfundingtypes" ng-model="vm.foreignfundingresource.foreignfundingtypes" required><div ng-show="editForm.foreignfundingtypes.$invalid"><p class="help-block" ng-show="editForm.foreignfundingtypes.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/foreignfundingresource/foreignfundingresources.html','<div class="container"><h2 data-translate="investhryApp.foreignfundingresource.home.title">Foreignfundingresources</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="foreignfundingresource.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.foreignfundingresource.home.createLabel">Create new Foreignfundingresource</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.foreignfundingresource.foreignfundingtypes">Foreignfundingtypes</span></th><th></th></tr></thead><tbody><tr ng-repeat="foreignfundingresource in vm.foreignfundingresources track by foreignfundingresource.id"><td><a ui-sref="foreignfundingresource-detail({id:foreignfundingresource.id})">{{foreignfundingresource.id}}</a></td><td>{{foreignfundingresource.foreignfundingtypes}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="foreignfundingresource-detail({id:foreignfundingresource.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="foreignfundingresource.edit({id:foreignfundingresource.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="foreignfundingresource.delete({id:foreignfundingresource.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/grievance/grievance-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.grievance.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.grievance.delete.question" translate-values="{id: \'{{vm.grievance.id}}\'}">Are you sure you want to delete this Grievance?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/grievance/grievance-detail.html','<div><h2><span data-translate="investhryApp.grievance.detail.title">Grievance</span> {{vm.grievance.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.grievance.grievanceId">Grievance Id</span></dt><dd><span>{{vm.grievance.grievanceId}}</span></dd><dt><span data-translate="investhryApp.grievance.grievanceDate">Grievance Date</span></dt><dd><span>{{vm.grievance.grievanceDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.grievance.grievanceBy">Grievance By</span></dt><dd><span>{{vm.grievance.grievanceBy}}</span></dd><dt><span data-translate="investhryApp.grievance.grievance">Grievance</span></dt><dd><span>{{vm.grievance.grievance}}</span></dd><dt><span data-translate="investhryApp.grievance.status">Status</span></dt><dd><span>{{vm.grievance.status}}</span></dd><dt><span data-translate="investhryApp.grievance.resolveComment">Resolve Comment</span></dt><dd><span>{{vm.grievance.resolveComment}}</span></dd><dt><span data-translate="investhryApp.grievance.resolveDate">Resolve Date</span></dt><dd><span>{{vm.grievance.resolveDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.grievance.resolveBy">Resolve By</span></dt><dd><span>{{vm.grievance.resolveBy}}</span></dd><dt><span data-translate="investhryApp.grievance.assignTo">Assign To</span></dt><dd><span>{{vm.grievance.assignTo}}</span></dd><dt><span data-translate="investhryApp.grievance.assignDate">Assign Date</span></dt><dd><span>{{vm.grievance.assignDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.grievance.assignBy">Assign By</span></dt><dd><span>{{vm.grievance.assignBy}}</span></dd><dt><span data-translate="investhryApp.grievance.assignStatus">Assign Status</span></dt><dd><span>{{vm.grievance.assignStatus}}</span></dd><dt><span data-translate="investhryApp.grievance.district">District</span></dt><dd><span>{{vm.grievance.district}}</span></dd><dt><span data-translate="investhryApp.grievance.department">Department</span></dt><dd><span>{{vm.grievance.department}}</span></dd><dt><span data-translate="investhryApp.grievance.districtId">District Id</span></dt><dd><span>{{vm.grievance.districtId}}</span></dd><dt><span data-translate="investhryApp.grievance.departmentId">Department Id</span></dt><dd><span>{{vm.grievance.departmentId}}</span></dd><dt><span data-translate="investhryApp.grievance.isResolved">Is Resolved</span></dt><dd><span>{{vm.grievance.isResolved}}</span></dd><dt><span data-translate="investhryApp.grievance.isUserAttachmentPresent">Is User Attachment Present</span></dt><dd><span>{{vm.grievance.isUserAttachmentPresent}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="grievance-detail.edit({id:vm.grievance.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/grievance/grievance-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGrievanceLabel" data-translate="investhryApp.grievance.home.createOrEditLabel">Create or edit a Grievance</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.grievance.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.grievance.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.grievanceId" for="field_grievanceId">Grievance Id</label><input type="text" class="form-control" name="grievanceId" id="field_grievanceId" ng-model="vm.grievance.grievanceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.grievanceDate" for="field_grievanceDate">Grievance Date</label><div class="input-group"><input id="field_grievanceDate" type="text" class="form-control" name="grievanceDate" datetime-picker="{{dateformat}}" ng-model="vm.grievance.grievanceDate" is-open="vm.datePickerOpenStatus.grievanceDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'grievanceDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.grievanceBy" for="field_grievanceBy">Grievance By</label><input type="text" class="form-control" name="grievanceBy" id="field_grievanceBy" ng-model="vm.grievance.grievanceBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.grievance" for="field_grievance">Grievance</label><input type="text" class="form-control" name="grievance" id="field_grievance" ng-model="vm.grievance.grievance"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.grievance.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.resolveComment" for="field_resolveComment">Resolve Comment</label><input type="text" class="form-control" name="resolveComment" id="field_resolveComment" ng-model="vm.grievance.resolveComment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.resolveDate" for="field_resolveDate">Resolve Date</label><div class="input-group"><input id="field_resolveDate" type="text" class="form-control" name="resolveDate" datetime-picker="{{dateformat}}" ng-model="vm.grievance.resolveDate" is-open="vm.datePickerOpenStatus.resolveDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'resolveDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.resolveBy" for="field_resolveBy">Resolve By</label><input type="text" class="form-control" name="resolveBy" id="field_resolveBy" ng-model="vm.grievance.resolveBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.assignTo" for="field_assignTo">Assign To</label><input type="text" class="form-control" name="assignTo" id="field_assignTo" ng-model="vm.grievance.assignTo"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.assignDate" for="field_assignDate">Assign Date</label><div class="input-group"><input id="field_assignDate" type="text" class="form-control" name="assignDate" datetime-picker="{{dateformat}}" ng-model="vm.grievance.assignDate" is-open="vm.datePickerOpenStatus.assignDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'assignDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.assignBy" for="field_assignBy">Assign By</label><input type="text" class="form-control" name="assignBy" id="field_assignBy" ng-model="vm.grievance.assignBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.assignStatus" for="field_assignStatus">Assign Status</label><input type="checkbox" name="assignStatus" id="field_assignStatus" ng-model="vm.grievance.assignStatus"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.grievance.district" required><div ng-show="editForm.district.$invalid"><p class="help-block" ng-show="editForm.district.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.department" for="field_department">Department</label><input type="text" class="form-control" name="department" id="field_department" ng-model="vm.grievance.department" required><div ng-show="editForm.department.$invalid"><p class="help-block" ng-show="editForm.department.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.districtId" for="field_districtId">District Id</label><input type="text" class="form-control" name="districtId" id="field_districtId" ng-model="vm.grievance.districtId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.departmentId" for="field_departmentId">Department Id</label><input type="text" class="form-control" name="departmentId" id="field_departmentId" ng-model="vm.grievance.departmentId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.isResolved" for="field_isResolved">Is Resolved</label><input type="checkbox" name="isResolved" id="field_isResolved" ng-model="vm.grievance.isResolved"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievance.isUserAttachmentPresent" for="field_isUserAttachmentPresent">Is User Attachment Present</label><input type="checkbox" name="isUserAttachmentPresent" id="field_isUserAttachmentPresent" ng-model="vm.grievance.isUserAttachmentPresent"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/grievance/grievances.html','<div><h2 data-translate="investhryApp.grievance.home.title">Grievances</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="grievance.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.grievance.home.createLabel">Create new Grievance</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Index</span></th><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.grievance.grievanceId">Grievance Id</span></th><th><span data-translate="investhryApp.grievance.grievanceDate">Grievance Date</span></th><th><span data-translate="investhryApp.grievance.grievanceBy">Grievance By</span></th><th><span data-translate="investhryApp.grievance.grievance">Grievance</span></th><th><span data-translate="investhryApp.grievance.status">Status</span></th><th><span data-translate="investhryApp.grievance.resolveComment">Resolve Comment</span></th><th><span data-translate="investhryApp.grievance.resolveDate">Resolve Date</span></th><th><span data-translate="investhryApp.grievance.resolveBy">Resolve By</span></th><th><span data-translate="investhryApp.grievance.assignTo">Assign To</span></th><th><span data-translate="investhryApp.grievance.assignDate">Assign Date</span></th><th><span data-translate="investhryApp.grievance.assignBy">Assign By</span></th><th><span data-translate="investhryApp.grievance.assignStatus">Assign Status</span></th><th><span data-translate="investhryApp.grievance.district">District</span></th><th><span data-translate="investhryApp.grievance.department">Department</span></th><th><span data-translate="investhryApp.grievance.districtId">District Id</span></th><th><span data-translate="investhryApp.grievance.departmentId">Department Id</span></th><th><span data-translate="investhryApp.grievance.isResolved">Is Resolved</span></th><th><span data-translate="investhryApp.grievance.isUserAttachmentPresent">Is User Attachment Present</span></th><th></th></tr></thead><tbody><tr ng-repeat="grievance in vm.grievances track by grievance.id"><td>{{$index}}</td><td><a ui-sref="grievance-detail({id:grievance.id})">{{grievance.id}}</a></td><td>{{grievance.grievanceId}}</td><td>{{grievance.grievanceDate | date:\'medium\'}}</td><td>{{grievance.grievanceBy}}</td><td>{{grievance.grievance}}</td><td>{{grievance.status}}</td><td>{{grievance.resolveComment}}</td><td>{{grievance.resolveDate | date:\'medium\'}}</td><td>{{grievance.resolveBy}}</td><td>{{grievance.assignTo}}</td><td>{{grievance.assignDate | date:\'medium\'}}</td><td>{{grievance.assignBy}}</td><td>{{grievance.assignStatus}}</td><td>{{grievance.district}}</td><td>{{grievance.department}}</td><td>{{grievance.districtId}}</td><td>{{grievance.departmentId}}</td><td>{{grievance.isResolved}}</td><td>{{grievance.isUserAttachmentPresent}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="grievance-detail({id:grievance.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="grievance.edit({id:grievance.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="grievance.delete({id:grievance.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/grievance-assign/grievance-assign-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.grievanceAssign.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.grievanceAssign.delete.question" translate-values="{id: \'{{vm.grievanceAssign.id}}\'}">Are you sure you want to delete this Grievance Assign?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/grievance-assign/grievance-assign-detail.html','<div><h2><span data-translate="investhryApp.grievanceAssign.detail.title">Grievance Assign</span> {{vm.grievanceAssign.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.grievanceAssign.grievanceId">Grievance Id</span></dt><dd><span>{{vm.grievanceAssign.grievanceId}}</span></dd><dt><span data-translate="investhryApp.grievanceAssign.assignBy">Assign By</span></dt><dd><span>{{vm.grievanceAssign.assignBy}}</span></dd><dt><span data-translate="investhryApp.grievanceAssign.assignDate">Assign Date</span></dt><dd><span>{{vm.grievanceAssign.assignDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.grievanceAssign.assignTo">Assign To</span></dt><dd><span>{{vm.grievanceAssign.assignTo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="grievance-assign-detail.edit({id:vm.grievanceAssign.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/grievance-assign/grievance-assign-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGrievanceAssignLabel" data-translate="investhryApp.grievanceAssign.home.createOrEditLabel">Create or edit a Grievance Assign</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.grievanceAssign.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.grievanceAssign.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceAssign.grievanceId" for="field_grievanceId">Grievance Id</label><input type="text" class="form-control" name="grievanceId" id="field_grievanceId" ng-model="vm.grievanceAssign.grievanceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceAssign.assignBy" for="field_assignBy">Assign By</label><input type="text" class="form-control" name="assignBy" id="field_assignBy" ng-model="vm.grievanceAssign.assignBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceAssign.assignDate" for="field_assignDate">Assign Date</label><div class="input-group"><input id="field_assignDate" type="text" class="form-control" name="assignDate" datetime-picker="{{dateformat}}" ng-model="vm.grievanceAssign.assignDate" is-open="vm.datePickerOpenStatus.assignDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'assignDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceAssign.assignTo" for="field_assignTo">Assign To</label><input type="text" class="form-control" name="assignTo" id="field_assignTo" ng-model="vm.grievanceAssign.assignTo"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/grievance-assign/grievance-assigns.html','<div><h2 data-translate="investhryApp.grievanceAssign.home.title">Grievance Assigns</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="grievance-assign.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.grievanceAssign.home.createLabel">Create new Grievance Assign</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.grievanceAssign.grievanceId">Grievance Id</span></th><th><span data-translate="investhryApp.grievanceAssign.assignBy">Assign By</span></th><th><span data-translate="investhryApp.grievanceAssign.assignDate">Assign Date</span></th><th><span data-translate="investhryApp.grievanceAssign.assignTo">Assign To</span></th><th></th></tr></thead><tbody><tr ng-repeat="grievanceAssign in vm.grievanceAssigns track by grievanceAssign.id"><td><a ui-sref="grievance-assign-detail({id:grievanceAssign.id})">{{grievanceAssign.id}}</a></td><td>{{grievanceAssign.grievanceId}}</td><td>{{grievanceAssign.assignBy}}</td><td>{{grievanceAssign.assignDate | date:\'medium\'}}</td><td>{{grievanceAssign.assignTo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="grievance-assign-detail({id:grievanceAssign.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="grievance-assign.edit({id:grievanceAssign.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="grievance-assign.delete({id:grievanceAssign.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/grievance-dashboard-output/grievance-dashboard-output-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.grievanceDashboardOutput.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.grievanceDashboardOutput.delete.question" translate-values="{id: \'{{vm.grievanceDashboardOutput.id}}\'}">Are you sure you want to delete this Grievance Dashboard Output?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/grievance-dashboard-output/grievance-dashboard-output-detail.html','<div><h2><span data-translate="investhryApp.grievanceDashboardOutput.detail.title">Grievance Dashboard Output</span> {{vm.grievanceDashboardOutput.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.grievanceDashboardOutput.deptname">Deptname</span></dt><dd><span>{{vm.grievanceDashboardOutput.deptname}}</span></dd><dt><span data-translate="investhryApp.grievanceDashboardOutput.districtname">Districtname</span></dt><dd><span>{{vm.grievanceDashboardOutput.districtname}}</span></dd><dt><span data-translate="investhryApp.grievanceDashboardOutput.total">Total</span></dt><dd><span>{{vm.grievanceDashboardOutput.total}}</span></dd><dt><span data-translate="investhryApp.grievanceDashboardOutput.unassigned">Unassigned</span></dt><dd><span>{{vm.grievanceDashboardOutput.unassigned}}</span></dd><dt><span data-translate="investhryApp.grievanceDashboardOutput.assigned">Assigned</span></dt><dd><span>{{vm.grievanceDashboardOutput.assigned}}</span></dd><dt><span data-translate="investhryApp.grievanceDashboardOutput.pending">Pending</span></dt><dd><span>{{vm.grievanceDashboardOutput.pending}}</span></dd><dt><span data-translate="investhryApp.grievanceDashboardOutput.resolved">Resolved</span></dt><dd><span>{{vm.grievanceDashboardOutput.resolved}}</span></dd><dt><span data-translate="investhryApp.grievanceDashboardOutput.deptid">Deptid</span></dt><dd><span>{{vm.grievanceDashboardOutput.deptid}}</span></dd><dt><span data-translate="investhryApp.grievanceDashboardOutput.districtid">Districtid</span></dt><dd><span>{{vm.grievanceDashboardOutput.districtid}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="grievance-dashboard-output-detail.edit({id:vm.grievanceDashboardOutput.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/grievance-dashboard-output/grievance-dashboard-output-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGrievanceDashboardOutputLabel" data-translate="investhryApp.grievanceDashboardOutput.home.createOrEditLabel">Create or edit a Grievance Dashboard Output</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.grievanceDashboardOutput.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.grievanceDashboardOutput.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceDashboardOutput.deptname" for="field_deptname">Deptname</label><input type="text" class="form-control" name="deptname" id="field_deptname" ng-model="vm.grievanceDashboardOutput.deptname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceDashboardOutput.districtname" for="field_districtname">Districtname</label><input type="text" class="form-control" name="districtname" id="field_districtname" ng-model="vm.grievanceDashboardOutput.districtname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceDashboardOutput.total" for="field_total">Total</label><input type="text" class="form-control" name="total" id="field_total" ng-model="vm.grievanceDashboardOutput.total"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceDashboardOutput.unassigned" for="field_unassigned">Unassigned</label><input type="text" class="form-control" name="unassigned" id="field_unassigned" ng-model="vm.grievanceDashboardOutput.unassigned"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceDashboardOutput.assigned" for="field_assigned">Assigned</label><input type="text" class="form-control" name="assigned" id="field_assigned" ng-model="vm.grievanceDashboardOutput.assigned"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceDashboardOutput.pending" for="field_pending">Pending</label><input type="text" class="form-control" name="pending" id="field_pending" ng-model="vm.grievanceDashboardOutput.pending"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceDashboardOutput.resolved" for="field_resolved">Resolved</label><input type="text" class="form-control" name="resolved" id="field_resolved" ng-model="vm.grievanceDashboardOutput.resolved"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceDashboardOutput.deptid" for="field_deptid">Deptid</label><input type="text" class="form-control" name="deptid" id="field_deptid" ng-model="vm.grievanceDashboardOutput.deptid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceDashboardOutput.districtid" for="field_districtid">Districtid</label><input type="text" class="form-control" name="districtid" id="field_districtid" ng-model="vm.grievanceDashboardOutput.districtid"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/grievance-dashboard-output/grievance-dashboard-outputs.html','<div><h2 data-translate="investhryApp.grievanceDashboardOutput.home.title">Grievance Dashboard Outputs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="grievance-dashboard-output.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.grievanceDashboardOutput.home.createLabel">Create new Grievance Dashboard Output</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.grievanceDashboardOutput.deptname">Deptname</span></th><th><span data-translate="investhryApp.grievanceDashboardOutput.districtname">Districtname</span></th><th><span data-translate="investhryApp.grievanceDashboardOutput.total">Total</span></th><th><span data-translate="investhryApp.grievanceDashboardOutput.unassigned">Unassigned</span></th><th><span data-translate="investhryApp.grievanceDashboardOutput.assigned">Assigned</span></th><th><span data-translate="investhryApp.grievanceDashboardOutput.pending">Pending</span></th><th><span data-translate="investhryApp.grievanceDashboardOutput.resolved">Resolved</span></th><th><span data-translate="investhryApp.grievanceDashboardOutput.deptid">Deptid</span></th><th><span data-translate="investhryApp.grievanceDashboardOutput.districtid">Districtid</span></th><th></th></tr></thead><tbody><tr ng-repeat="grievanceDashboardOutput in vm.grievanceDashboardOutputs track by grievanceDashboardOutput.id"><td><a ui-sref="grievance-dashboard-output-detail({id:grievanceDashboardOutput.id})">{{grievanceDashboardOutput.id}}</a></td><td>{{grievanceDashboardOutput.deptname}}</td><td>{{grievanceDashboardOutput.districtname}}</td><td>{{grievanceDashboardOutput.total}}</td><td>{{grievanceDashboardOutput.unassigned}}</td><td>{{grievanceDashboardOutput.assigned}}</td><td>{{grievanceDashboardOutput.pending}}</td><td>{{grievanceDashboardOutput.resolved}}</td><td>{{grievanceDashboardOutput.deptid}}</td><td>{{grievanceDashboardOutput.districtid}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="grievance-dashboard-output-detail({id:grievanceDashboardOutput.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="grievance-dashboard-output.edit({id:grievanceDashboardOutput.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="grievance-dashboard-output.delete({id:grievanceDashboardOutput.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/grievance-log/grievance-log-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.grievanceLog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.grievanceLog.delete.question" translate-values="{id: \'{{vm.grievanceLog.id}}\'}">Are you sure you want to delete this Grievance Log?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/grievance-log/grievance-log-detail.html','<div><h2><span data-translate="investhryApp.grievanceLog.detail.title">Grievance Log</span> {{vm.grievanceLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.grievanceLog.grievanceId">Grievance Id</span></dt><dd><span>{{vm.grievanceLog.grievanceId}}</span></dd><dt><span data-translate="investhryApp.grievanceLog.action">Action</span></dt><dd><span>{{vm.grievanceLog.action}}</span></dd><dt><span data-translate="investhryApp.grievanceLog.actionDate">Action Date</span></dt><dd><span>{{vm.grievanceLog.actionDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.grievanceLog.actionComment">Action Comment</span></dt><dd><span>{{vm.grievanceLog.actionComment}}</span></dd><dt><span data-translate="investhryApp.grievanceLog.actionBy">Action By</span></dt><dd><span>{{vm.grievanceLog.actionBy}}</span></dd><dt><span data-translate="investhryApp.grievanceLog.attachment">Attachment</span></dt><dd><span>{{vm.grievanceLog.attachment}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="grievance-log-detail.edit({id:vm.grievanceLog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/grievance-log/grievance-log-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myGrievanceLogLabel" data-translate="investhryApp.grievanceLog.home.createOrEditLabel">Create or edit a Grievance Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.grievanceLog.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.grievanceLog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceLog.grievanceId" for="field_grievanceId">Grievance Id</label><input type="text" class="form-control" name="grievanceId" id="field_grievanceId" ng-model="vm.grievanceLog.grievanceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceLog.action" for="field_action">Action</label><input type="text" class="form-control" name="action" id="field_action" ng-model="vm.grievanceLog.action"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceLog.actionDate" for="field_actionDate">Action Date</label><div class="input-group"><input id="field_actionDate" type="text" class="form-control" name="actionDate" datetime-picker="{{dateformat}}" ng-model="vm.grievanceLog.actionDate" is-open="vm.datePickerOpenStatus.actionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'actionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceLog.actionComment" for="field_actionComment">Action Comment</label><input type="text" class="form-control" name="actionComment" id="field_actionComment" ng-model="vm.grievanceLog.actionComment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceLog.actionBy" for="field_actionBy">Action By</label><input type="text" class="form-control" name="actionBy" id="field_actionBy" ng-model="vm.grievanceLog.actionBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.grievanceLog.attachment" for="field_attachment">Attachment</label><input type="text" class="form-control" name="attachment" id="field_attachment" ng-model="vm.grievanceLog.attachment"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/grievance-log/grievance-logs.html','<div><h2 data-translate="investhryApp.grievanceLog.home.title">Grievance Logs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="grievance-log.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.grievanceLog.home.createLabel">Create new Grievance Log</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.grievanceLog.grievanceId">Grievance Id</span></th><th><span data-translate="investhryApp.grievanceLog.action">Action</span></th><th><span data-translate="investhryApp.grievanceLog.actionDate">Action Date</span></th><th><span data-translate="investhryApp.grievanceLog.actionComment">Action Comment</span></th><th><span data-translate="investhryApp.grievanceLog.actionBy">Action By</span></th><th><span data-translate="investhryApp.grievanceLog.attachment">Attachment</span></th><th></th></tr></thead><tbody><tr ng-repeat="grievanceLog in vm.grievanceLogs track by grievanceLog.id"><td><a ui-sref="grievance-log-detail({id:grievanceLog.id})">{{grievanceLog.id}}</a></td><td>{{grievanceLog.grievanceId}}</td><td>{{grievanceLog.action}}</td><td>{{grievanceLog.actionDate | date:\'medium\'}}</td><td>{{grievanceLog.actionComment}}</td><td>{{grievanceLog.actionBy}}</td><td>{{grievanceLog.attachment}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="grievance-log-detail({id:grievanceLog.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="grievance-log.edit({id:grievanceLog.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="grievance-log.delete({id:grievanceLog.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/hepc-recruitment/hepc-recruitment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.hepcRecruitment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.hepcRecruitment.delete.question" translate-values="{id: \'{{vm.hepcRecruitment.id}}\'}">Are you sure you want to delete this Hepc Recruitment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/hepc-recruitment/hepc-recruitment-detail.html','<div class="container"><h2><span>Hepc Recruitment</span></h2><hr><jhi-alert-error></jhi-alert-error><div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.applicationId">Application Id:-</span></label><span>{{vm.hepcRecruitment.applicationId}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.jobProfile">Job Profile:-</span></label><span>{{vm.hepcRecruitment.jobProfile}}</span></div><div class="col-md-6"><label><span>Name:-</span></label><span>{{vm.hepcRecruitment.name}}</span></div><div class="col-md-6"><label><span>Father/Husband Name:-</span></label><span>{{vm.hepcRecruitment.fatherHusbandName}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.gender">Gender:-</span></label><span>{{vm.hepcRecruitment.gender}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.aadharNumber">Aadhar Number:-</span></label><span>{{vm.hepcRecruitment.aadharNumber}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.correspondenceAddress">Correspondence Address:-</span></label><span>{{vm.hepcRecruitment.correspondenceAddress}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.correspondenceDistrict">Correspondence District:-</span></label><span>{{vm.hepcRecruitment.correspondenceDistrict}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.correspondenceState">Correspondence State:-</span></label><span>{{vm.hepcRecruitment.correspondenceState}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.permanentAddress">Permanent Address:-</span></label><span>{{vm.hepcRecruitment.permanentAddress}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.permanentDistrict">Permanent District:-</span></label><span>{{vm.hepcRecruitment.permanentDistrict}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.permanentState">Permanent State:-</span></label><span>{{vm.hepcRecruitment.permanentState}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.contactNumber">Contact Number:-</span></label><span>{{vm.hepcRecruitment.contactNumber}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.alternateContactNumber">Alternate Number:-</span></label><span>{{vm.hepcRecruitment.alternateContactNumber}}</span></div><div class="col-md-6"><label><span data-translate="investhryApp.hepcRecruitment.email">Email:-</span></label><span>{{vm.hepcRecruitment.email}}</span></div><div class="col-md-6" ng-if="vm.hepcRecruitment.jobProfile === \'Relationship Executive\'"><label><span data-translate="investhryApp.hepcRecruitment.preferredLocation">Preferred Location:-</span></label><span>{{vm.hepcRecruitment.preferredLocation}},{{vm.hepcRecruitment.preferredLocationSecond}},{{vm.hepcRecruitment.preferredLocationThree}}</span></div><a target="_blank" class="btn btn-primary" ng-click="vm.viewDocument(\'photo\')">View Photograph</a> <a target="_blank" class="btn btn-primary" ng-click="vm.viewDocument(\'sign\')">View Signature</a> <a ng-if="vm.hepcRecruitment.resume" target="_blank" class="btn btn-primary" ng-click="vm.viewDocument(\'resume\')">View Resume</a></div><table class="jh-table table table-striped"><thead><tr><th>Class/Degree</th><th>Stream</th><th>Session</th><th>Passing Year</th><th>School/University</th><th>Specialization</th><th>Marks</th><th>%</th><th>*Regular/Correspondance</th><th>Division</th><th></th></tr></thead><tbody><tr ng-repeat="data in vm.hepcRecruitmentQualifications"><td>{{data.degree}}</td><td>{{data.stream}}</td><td>{{data.session}}</td><td>{{data.passingYear | date:\'mediumDate\'}}</td><td>{{data.schoolUniversity}}</td><td>{{data.specialization}}</td><td>{{data.marksObtained}}</td><td>{{data.marksPercentage}}</td><td>{{data.regularCorrespondance}}</td><td>{{data.division}}</td><td ng-if="data.documentName !== null"><a target="_blank" class="btn btn-primary" ng-click="vm.viewDocument(data.documentName)">View Document</a></td><td ng-if="data.documentName === null">No Document Uploaded</td></tr></tbody></table><table class="jh-table table table-striped"><thead><tr><th>Name of Organization</th><th>Designation</th><th>Start Date (e.g. 01-Jan-18)</th><th>End Date (e.g. 01-Jan-18)</th><th>Total Experience (in months)</th><th>Field of Work</th><th>Upload Document</th><th></th></tr></thead><tbody><tr class="item-row" ng-repeat="data in vm.hepcRecruitmentExperiences track by $index"><td>{{data.organization}}</td><td>{{data.designation}}</td><td>{{data.startDate}}</td><td>{{data.endDate}}</td><td>{{data.totalExperience}}</td><td>{{data.workField}}</td><td ng-if="data.documentName !== null"><a target="_blank" class="btn btn-primary" ng-click="vm.viewDocument(data.documentName)">View Document</a></td><td ng-if="data.documentName === null">No Document Uploaded</td></tr></tbody></table><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div>');
$templateCache.put('app/entities/hepc-recruitment/hepc-recruitment-dialog.html','<style type="text/css">table{\n        overflow-y: scroll;\n        height:100%;\n        display:block;\n    }</style><form name="editForm" role="form" ng-submit="vm.save()" show-validation><div class="modal-body"><jhi-alert-error></jhi-alert-error><p class="text-center">Haryana Enterprises Promotion Center<br>Department of Industries & Commerce, Haryana<br>Bsys No. 63-66, Sector 2, Panchkula</p><pre class="text-center" ng-if="vm.hepcRecruitment.jobProfile">Job application for the post of {{vm.hepcRecruitment.jobProfile}}</pre><div class="form-group col-md-12"><label class="control-label" for="field_name">Upload Photograph</label><input type="file" file-model="vm.photograph" accept="image/*" required><p ng-show="vm.photograph.size > vm.maxFileSize"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><div class="form-group col-md-6"><label class="control-label" for="field_jobProfile">Position applying for</label><select id="field_jobProfile" ng-model="vm.hepcRecruitment.jobProfile" class="form-control" required><option selected="selected" disabled="disabled">Select Job Profile</option><option value="Investor Facilitation Officer">Investor Facilitation Officer</option><option value="Manager (Admin)">Manager (Admin)</option><option value="Manager (Account &amp; Finance)">Manager (Account &amp; Finance)</option><option value="Relationship Executive">Relationship Executive</option></select></div><div class="form-group col-md-6"><label class="control-label" data-translate="investhryApp.hepcRecruitment.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.hepcRecruitment.name" required></div><div class="form-group col-md-6"><label class="control-label" for="field_fatherHusbandName">Father/Husband Name</label><input type="text" class="form-control" name="fatherHusbandName" id="field_fatherHusbandName" ng-model="vm.hepcRecruitment.fatherHusbandName" required></div><div class="form-group col-md-6"><label class="control-label" data-translate="investhryApp.hepcRecruitment.gender" for="field_gender">Gender</label><select class="form-control" id="field_gender" name="gender" ng-model="vm.hepcRecruitment.gender" required><option value="Male">Male</option><option value="Female">Female</option></select></div><div class="form-group col-md-6"><label class="control-label" for="field_dateOfBirth">Date Of Birth</label><div class="input-group"><input id="field_dateOfBirth" required type="date" class="form-control" name="dateOfBirth" datepicker-options="vm.options" uib-datepicker-popup="{{dateformat}}" ng-model="vm.hepcRecruitment.dob" is-open="vm.datePickerOpenStatus.dob"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'dob\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group col-md-6"><label class="control-label" data-translate="investhryApp.hepcRecruitment.aadharNumber" for="field_aadharNumber">Aadhar Number</label><input type="text" pattern="\\d*" maxlength="12" minlength="12" class="form-control" name="aadharNumber" required id="field_aadharNumber" ng-model="vm.hepcRecruitment.aadharNumber"></div><div class="col-md-6"><div class="form-group col-md-12"><label class="control-label" data-translate="investhryApp.hepcRecruitment.correspondenceAddress" for="field_correspondenceAddress">Correspondence Address</label><textarea required type="text" class="form-control" name="correspondenceAddress" id="field_correspondenceAddress" ng-model="vm.hepcRecruitment.correspondenceAddress"></textarea></div><div class="form-group col-md-6"><label class="control-label" data-translate="investhryApp.hepcRecruitment.correspondenceState" for="field_correspondenceState">Correspondence State</label><select required class="form-control" name="correspondenceState" id="field_correspondenceState" ng-model="vm.hepcRecruitment.correspondenceState" ng-options="state.statename as state.statename for state in vm.states"></select></div><div class="form-group col-md-6"><label class="control-label" data-translate="investhryApp.hepcRecruitment.correspondenceDistrict" for="field_correspondenceDistrict">Correspondence District</label><input required type="text" class="form-control" name="correspondenceDistrict" id="field_correspondenceDistrict" ng-model="vm.hepcRecruitment.correspondenceDistrict"></div></div><div class="col-md-6"><div class="form-group col-md-12"><label class="control-label" data-translate="investhryApp.hepcRecruitment.permanentAddress" for="field_permanentAddress">Permanent Address</label><textarea required type="text" class="form-control" name="permanentAddress" id="field_permanentAddress" ng-model="vm.hepcRecruitment.permanentAddress"></textarea></div><div class="form-group col-md-6"><label class="control-label" data-translate="investhryApp.hepcRecruitment.permanentState" for="field_permanentState">Permanent State</label><select required class="form-control" name="permanentState" id="field_permanentState" ng-model="vm.hepcRecruitment.permanentState" ng-options="state.statename as state.statename for state in vm.states"></select></div><div class="form-group col-md-6"><label class="control-label" data-translate="investhryApp.hepcRecruitment.permanentDistrict" for="field_permanentDistrict">Permanent District</label><input type="text" class="form-control" name="permanentDistrict" id="field_permanentDistrict" ng-model="vm.hepcRecruitment.permanentDistrict"></div></div><div class="form-group col-md-6"><label class="control-label" data-translate="investhryApp.hepcRecruitment.contactNumber" for="field_contactNumber">Contact Number</label><input type="text" pattern="\\d*" required class="form-control" maxlength="10" minlength="10" name="contactNumber" id="field_contactNumber" ng-model="vm.hepcRecruitment.contactNumber"></div><div class="form-group col-md-6"><label class="control-label" data-translate="investhryApp.hepcRecruitment.alternateContactNumber" for="field_alternateContactNumber">Alternate Contact Number</label><input placeholder="Mobile/Landline" pattern="\\d*" type="text" maxlength="12" class="form-control" name="alternateContactNumber" id="field_alternateContactNumber" ng-model="vm.hepcRecruitment.alternateContactNumber"></div><div class="form-group col-md-4"><label class="control-label" data-translate="investhryApp.hepcRecruitment.email" for="field_email">Email</label><input type="email" class="form-control" name="email" id="field_email" ng-model="vm.hepcRecruitment.email" required></div><div class="form-group col-md-8" ng-if="vm.hepcRecruitment.jobProfile === \'Relationship Executive\'"><div class="col-md-4"><label class="control-label" for="field_preferredLocation">First Preferred Location</label><select ng-required="vm.hepcRecruitment.jobProfile === \'Relationship Executive\'" class="form-control" name="preferredLocation" id="field_preferredLocation" ng-model="vm.hepcRecruitment.preferredLocation"><option value="" selected="selected">--Select Location--</option><option ng-repeat="location in vm.districts | orderBy" value="{{location}}" ng-show="vm.hepcRecruitment.preferredLocationSecond !== location && vm.hepcRecruitment.preferredLocationThree !== location ">{{location}}</option></select></div><div class="col-md-4"><label class="control-label" for="field_preferredLocationSecond">Second Preferred Location</label><select class="form-control" name="preferredLocationSecond" id="field_preferredLocationSecond" ng-model="vm.hepcRecruitment.preferredLocationSecond"><option value="" selected="selected">--Select Location--</option><option ng-repeat="location in vm.districts | orderBy" value="{{location}}" ng-show="vm.hepcRecruitment.preferredLocation !== location && vm.hepcRecruitment.preferredLocationThree !== location ">{{location}}</option></select></div><div class="col-md-4"><label class="control-label" for="field_preferredLocationThree">Third Preferred Location</label><select class="form-control" name="preferredLocationThree" id="field_preferredLocationThree" ng-model="vm.hepcRecruitment.preferredLocationThree"><option value="" selected="selected">--Select Location--</option><option ng-repeat="location in vm.districts | orderBy" value="{{location}}" ng-show="vm.hepcRecruitment.preferredLocation !== location && vm.hepcRecruitment.preferredLocationSecond !== location ">{{location}}</option></select></div></div><div class="col-md-12"><h5>Educational Qualifications:</h5><p>(Mention all educational qualifications starting from class 10 th onwards)</p><p>*Applications will be accepted only for candidates who have done regular qualification</p><table style="width: 100vw" class="jh-table table table-striped"><thead><tr><th>Class / Degree</th><th>Stream</th><th>Session(e.g. 2014 - 2016)</th><th>Passing Year(e.g 12 - 2014)</th><th>School / University</th><th>Specialization</th><th>Marks obtained / Total Marks</th><th>% Marks</th><th>*Regular/Correspondance</th><th>Division</th><th>Upload document</th><th>Document uploaded</th></tr></thead><tbody><tr><td>10th <span style="color: red" ng-show="vm.qualifications.tenth">*</span></td><td><input type="text" name="tenth-stream" ng-model="vm.qualifications.tenth.stream" onkeypress="return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))" ng-required="vm.qualifications.tenth"></td><td><input type="text" name="tenth-session" ng-model="vm.qualifications.tenth.session" ng-required="vm.qualifications.tenth"></td><td><div class="form-group"><div class="input-group"><input id="field_tenthPassingYear" ng-change="getDate(vm.qualifications.tenth.passingYear, \'twelveth\', 2)" ng-required="vm.qualifications.tenth" type="text" name="tenthPassingYear" datepicker-options="vm.options" uib-datepicker-popup="{{\'MMMM-yyyy\'}}" ng-model="vm.qualifications.tenth.passingYear" is-open="vm.datePickerOpenStatus.tengthPassingYear"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'tengthPassingYear\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></td><td><input type="text" name="tenth-schoolUniversity" ng-model="vm.qualifications.tenth.schoolUniversity" ng-required="vm.qualifications.tenth"></td><td><input type="text" name="tenth-specialization" ng-model="vm.qualifications.tenth.specialization" ng-required="vm.qualifications.tenth"></td><td><input type="text" name="tenth-marksObtained" ng-model="vm.qualifications.tenth.marksObtained" ng-required="vm.qualifications.tenth"></td><td><input type="text" name="tenth-marksPercentage" ng-model="vm.qualifications.tenth.marksPercentage" ng-required="vm.qualifications.tenth"></td><td><select name="tenth-regularCorrespondance" ng-model="vm.qualifications.tenth.regularCorrespondance" ng-required="vm.qualifications.tenth"><option value="regular" selected="selected">Regular</option><option value="correspondance">Correspondance</option></select></td><td><select name="tenth-division" type="text" ng-model="vm.qualifications.tenth.division" ng-required="vm.qualifications.tenth"><option value="first">First</option><option value="second">Second</option><option value="third">Third</option></select></td><td><input name="tenth-document" type="file" file-model="vm.qualifications.tenth.document" ng-required="vm.qualifications.tenth.documentType === \'Yes\'" ng-disabled="vm.qualifications.tenth.documentType !== \'Yes\'" accept=".xlsx,.xls,.doc,.docx,.pdf"><p ng-show="vm.qualifications.tenth.document.size > vm.maxFileSize"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></td><td><select name="tenth-documentType" ng-model="vm.qualifications.tenth.documentType" ng-required="vm.qualifications.tenth"><option value="Yes">Yes</option><option value="No">No</option></select></td></tr><tr><td>10+2 <span style="color: red" ng-show="vm.qualifications.twelveth">*</span></td><td><input name="twelveth-stream" type="text" ng-model="vm.qualifications.twelveth.stream" onkeypress="return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))" ng-required="vm.qualifications.twelveth"></td><td><input name="twelveth-session" type="text" ng-model="vm.qualifications.twelveth.session" ng-required="vm.qualifications.twelveth"></td><td><div class="form-group"><div class="input-group"><input id="field_twelvethPassingYear" ng-change="getDate(vm.qualifications.twelveth.passingYear, \'graduation\', 2)" datepicker-options="vm.degreeDateOptions.twelveth" ng-required="vm.qualifications.twelveth" type="text" name="twelvethPassingYear" datepicker-options="vm.options" uib-datepicker-popup="{{\'MMMM-yyyy\'}}" ng-model="vm.qualifications.twelveth.passingYear" is-open="vm.datePickerOpenStatus.twelvethPassingYear"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'twelvethPassingYear\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></td><td><input name="twelveth-schoolUniversity" type="text" ng-model="vm.qualifications.twelveth.schoolUniversity" ng-required="vm.qualifications.twelveth"></td><td><input name="twelveth-specialization" type="text" ng-model="vm.qualifications.twelveth.specialization" ng-required="vm.qualifications.twelveth"></td><td><input name="twelveth-marksObtained" type="text" ng-model="vm.qualifications.twelveth.marksObtained" ng-required="vm.qualifications.twelveth"></td><td><input name="twelveth-marksPercentage" type="text" ng-model="vm.qualifications.twelveth.marksPercentage" ng-required="vm.qualifications.twelveth"></td><td><select name="twelveth-regularCorrespondance" ng-model="vm.qualifications.twelveth.regularCorrespondance" ng-required="vm.qualifications.twelveth"><option value="regular" selected="selected">Regular</option><option value="correspondance">Correspondance</option></select></td><td><select name="twelveth-division" type="text" ng-model="vm.qualifications.twelveth.division" ng-required="vm.qualifications.twelveth"><option value="first">First</option><option value="second">Second</option><option value="third">Third</option></select></td><td><input name="twelveth-document" type="file" file-model="vm.qualifications.twelveth.document" ng-required="vm.qualifications.twelveth.documentType === \'Yes\'" ng-disabled="vm.qualifications.twelveth.documentType !== \'Yes\'" accept=".xlsx,.xls,.doc,.docx,.pdf"><p ng-show="vm.qualifications.twelveth.document.size > vm.maxFileSize"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></td><td><select name="twelveth-documentType" ng-model="vm.qualifications.twelveth.documentType" ng-required="vm.qualifications.twelveth"><option value="Yes">Yes</option><option value="No">No</option></select></td></tr><tr><td>Graduation <span style="color: red" ng-show="vm.qualifications.graduation">*</span></td><td><input name="graduation-stream" type="text" ng-model="vm.qualifications.graduation.stream" onkeypress="return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))" ng-required="vm.qualifications.graduation"></td><td><input name="graduation-session" type="text" ng-model="vm.qualifications.graduation.session"></td><td><div class="form-group"><div class="input-group"><input id="field_graduationPassingYear" ng-change="getDate(vm.qualifications.graduation.passingYear, \'pg\', 2)" datepicker-options="vm.degreeDateOptions.graduation" ng-required="vm.qualifications.graduation" type="text" name="graduationPassingYear" datepicker-options="vm.options" uib-datepicker-popup="{{\'MMMM-yyyy\'}}" ng-model="vm.qualifications.graduation.passingYear" is-open="vm.datePickerOpenStatus.graduationPassingYear"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'graduationPassingYear\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></td><td><input name="graduation-schoolUniversity" type="text" ng-model="vm.qualifications.graduation.schoolUniversity" ng-required="vm.qualifications.graduation"></td><td><input name="graduation-specialization" type="text" ng-model="vm.qualifications.graduation.specialization" ng-required="vm.qualifications.graduation"></td><td><input name="graduation-marksObtained" type="text" ng-model="vm.qualifications.graduation.marksObtained" ng-required="vm.qualifications.graduation"></td><td><input name="graduation-marksPercentage" type="text" ng-model="vm.qualifications.graduation.marksPercentage" ng-required="vm.qualifications.graduation"></td><td><select name="graduation-regularCorrespondance" ng-model="vm.qualifications.graduation.regularCorrespondance" ng-required="vm.qualifications.graduation"><option value="regular" selected="selected">Regular</option><option value="correspondance">Correspondance</option></select></td><td><select name="graduation-division" type="text" ng-model="vm.qualifications.graduation.division" ng-required="vm.qualifications.graduation"><option value="first">First</option><option value="second">Second</option><option value="third">Third</option></select></td><td><input name="graduation-document" type="file" file-model="vm.qualifications.graduation.document" ng-required="vm.qualifications.graduation.documentType === \'Yes\'" ng-disabled="vm.qualifications.graduation.documentType !== \'Yes\'" accept=".xlsx,.xls,.doc,.docx,.pdf"><p ng-show="vm.qualifications.graduation.document.size > vm.maxFileSize"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></td><td><select name="graduation-documentType" ng-model="vm.qualifications.graduation.documentType" ng-required="vm.qualifications.graduation"><option value="Yes">Yes</option><option value="No">No</option></select></td></tr><tr><td>Post Graduation <span style="color: red" ng-show="vm.qualifications.pg">*</span></td><td><input name="pg-stream" type="text" ng-model="vm.qualifications.pg.stream" onkeypress="return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))" ng-required="vm.qualifications.pg"></td><td><input name="pg-session" type="text" ng-model="vm.qualifications.pg.session" ng-required="vm.qualifications.pg"></td><td><div class="form-group"><div class="input-group"><input id="field_pgPassingYear" ng-change="getDate(vm.qualifications.pg.passingYear, \'others\', 2)" datepicker-options="vm.degreeDateOptions.pg" ng-required="vm.qualifications.pg" type="text" name="pgPassingYear" datepicker-options="vm.options" uib-datepicker-popup="{{\'MMMM-yyyy\'}}" ng-model="vm.qualifications.pg.passingYear" is-open="vm.datePickerOpenStatus.pgPassingYear"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'pgPassingYear\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></td><td><input name="pg-schoolUniversity" type="text" ng-model="vm.qualifications.pg.schoolUniversity" ng-required="vm.qualifications.pg"></td><td><input name="pg-specialization" type="text" ng-model="vm.qualifications.pg.specialization" ng-required="vm.qualifications.pg"></td><td><input name="pg-marksObtained" type="text" ng-model="vm.qualifications.pg.marksObtained" ng-required="vm.qualifications.pg"></td><td><input name="pg-marksPercentage" type="text" ng-model="vm.qualifications.pg.marksPercentage" ng-required="vm.qualifications.pg"></td><td><select name="pg-regularCorrespondance" ng-model="vm.qualifications.pg.regularCorrespondance" ng-required="vm.qualifications.pg"><option value="regular" selected="selected">Regular</option><option value="correspondance">Correspondance</option></select></td><td><select name="pg-division" type="text" ng-model="vm.qualifications.pg.division" ng-required="vm.qualifications.pg"><option value="first">First</option><option value="second">Second</option><option value="third">Third</option></select></td><td><input name="pg-document" type="file" file-model="vm.qualifications.pg.document" ng-required="vm.qualifications.pg.documentType === \'Yes\'" ng-disabled="vm.qualifications.pg.documentType !== \'Yes\'" accept=".xlsx,.xls,.doc,.docx,.pdf"><p ng-show="vm.qualifications.pg.document.size > vm.maxFileSize"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></td><td><select name="pg-documentType" ng-model="vm.qualifications.pg.documentType" ng-required="vm.qualifications.pg"><option value="Yes">Yes</option><option value="No">No</option></select></td></tr><tr><td>Other, if any <span style="color: red" ng-show="vm.qualifications.other">*</span></td><td><input name="other-stream" type="text" ng-model="vm.qualifications.other.stream" onkeypress="return ((event.charCode >= 65 && event.charCode <= 90) || (event.charCode >= 97 && event.charCode <= 122) || (event.charCode == 32))" ng-required="vm.qualifications.other"></td><td><input name="other-session" type="text" ng-model="vm.qualifications.other.session" ng-required="vm.qualifications.other"></td><td><div class="form-group"><div class="input-group"><input id="field_otherPassingYear" datepicker-options="vm.degreeDateOptions.others" ng-required="vm.qualifications.other" type="text" name="otherPassingYear" datepicker-options="vm.options" uib-datepicker-popup="{{\'MMMM-yyyy\'}}" ng-model="vm.qualifications.other.passingYear" is-open="vm.datePickerOpenStatus.otherPassingYear"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'otherPassingYear\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></td><td><input name="other-schoolUniversity" type="text" ng-model="vm.qualifications.other.schoolUniversity" ng-required="vm.qualifications.other"></td><td><input name="other-specialization" type="text" ng-model="vm.qualifications.other.specialization" ng-required="vm.qualifications.other"></td><td><input name="other-marksObtained" type="text" ng-model="vm.qualifications.other.marksObtained" ng-required="vm.qualifications.other"></td><td><input name="other-marksPercentage" type="text" ng-model="vm.qualifications.other.marksPercentage" ng-required="vm.qualifications.other"></td><td><select name="other-regularCorrespondance" ng-model="vm.qualifications.other.regularCorrespondance" ng-required="vm.qualifications.other"><option value="regular" selected="selected">Regular</option><option value="correspondance">Correspondance</option></select></td><td><select name="other-division" type="text" ng-model="vm.qualifications.other.division" ng-required="vm.qualifications.other"><option value="first">First</option><option value="second">Second</option><option value="third">Third</option></select></td><td><input name="other-document" type="file" file-model="vm.qualifications.other.document" ng-required="vm.qualifications.other.documentType === \'Yes\'" ng-disabled="vm.qualifications.other.documentType !== \'Yes\'" accept=".xlsx,.xls,.doc,.docx,.pdf"><p ng-show="vm.qualifications.other.document.size > vm.maxFileSize"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></td><td><select name="other-documentType" ng-model="vm.qualifications.other.documentType" ng-required="vm.qualifications.other"><option value="Yes">Yes</option><option value="No">No</option></select></td></tr></tbody></table></div><div class="col-md-12"><h5>Work Experience:</h5><p>(Please mention only post qualification, full time work experience)</p><button type="button" style="font-size:18px" id="addrow" ng-click="addmore()" title="Add More Row"><i class="fa fa-plus"></i> Add</button><table style="width: 100vw" class="jh-table table table-striped"><thead><tr><th>Sr. No.</th><th>Name of Organization</th><th>Designation</th><th>Start Date (e.g. 01-Jan-18)</th><th>End Date (e.g. 01-Jan-18)</th><th>Total Experience (in months)</th><th>Field of Work</th><th>Upload Document</th><th>Document uploaded</th></tr></thead><tbody><tr class="item-row" ng-repeat="data in more track by $index"><td><a ng-click="remove_more($index)" class="delete pull-right"><span class="fa fa-remove icons-black"></span></a>{{$index + 1}} <span style="color: red">*</span></td><td><input name="organization" type="text" ng-model="data.organization" required></td><td><input name="designation" type="text" ng-model="data.designation" required></td><td><input name="startDate" type="date" max="{{vm.options.maxDate | date:\'yyyy-MM-dd\'}}" ng-model="data.startDate" required></td><td><input name="endDate" type="date" max="{{vm.options.maxDate | date:\'yyyy-MM-dd\'}}" ng-model="data.endDate"></td><td><select name="totalExperience" ng-model="data.totalExperience" required><option ng-repeat="n in [] | range: 200">{{$index + 1}}</option></select></td><td><input name="workField" type="text" ng-model="data.workField" required></td><td><input name="document" type="file" ng-disabled="data.documentType !== \'Yes\'" file-model="data.document" ng-required="data.documentType === \'Yes\'" ng-init="data.documentType = \'Yes\'" accept=".xlsx,.xls,.doc,.docx,.pdf"><p ng-show="data.document.size > vm.maxFileSize"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></td><td><select name="documentType" ng-model="data.documentType" required><option value="Yes">Yes</option><option value="No">No</option></select></td></tr></tbody></table></div><div class="col-md-6 col-md-offset-2"><div class="col-md-6"><h5>Please upload your resume</h5></div><div class="col-md-6"><input type="file" file-model="vm.resume" accept=".doc,.docx,.pdf"><p ng-show="vm.resume.size > vm.maxFileSize"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p></div><!--<input type="file" file-model="resume" ng-file-select="imageToBase($files)" ng-model="resume">--></div><div class="col-md-10 col-md-offset-2" style="margin-top: 20px"><h3>Declarations</h3><div class="col-md-12"><input type="checkbox" value="check" ng-model="vm.tc1">I declare that the particulars furnished by me in the above form are correct and true to the best of my knowledge and belief and no part of it is false.</div><div class="col-md-12"><input type="checkbox" value="check" ng-model="vm.tc2">I undertake that I fulfill the eligibility criteria, as prescribed in the qualification given on Haryana Enterprises Promotion Centre website.</div><div class="col-md-12"><input type="checkbox" value="check" ng-model="vm.tc3">I understand that I shall be disqualified/ terminated, if any information/ documents/certificates etc. submitted by me, are found to be false/fraudulent.</div></div><div class="col-md-3 col-md-offset-9" style="margin-top: 20px"><input type="file" file-model="vm.signature" accept="image/*" required><p ng-show="vm.signature.size > vm.maxFileSize"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p><label>Signature of the candidate</label><br><label ng-if="vm.hepcRecruitment.name">Name:- {{vm.hepcRecruitment.name}}</label><br><label for="signatureDate">Date</label><input type="date" class="form-control" id="signatureDate" ng-model="vm.hepcRecruitment.signatureDate" required><label for="signaturePlace">Place</label><input type="text" class="form-control" id="signaturePlace" ng-model="vm.hepcRecruitment.signaturePlace" required></div></div><div class="footer pull-right"><button ng-disabled="editForm.$invalid || vm.isSaving || !vm.tc1 || !vm.tc2 || !vm.tc3 || file.maxSizeError" type="submit" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/hepc-recruitment/hepc-recruitments.html','<div><h2 data-translate="investhryApp.hepcRecruitment.home.title">Hepc Recruitments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="hepc-recruitment.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.hepcRecruitment.home.createLabel">Create new Hepc Recruitment</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="investhryApp.hepcRecruitment.name">Name</span></th><th><span data-translate="investhryApp.hepcRecruitment.applicationId">Application Id</span></th><th><span data-translate="investhryApp.hepcRecruitment.jobProfile">Job Profile</span></th><th><span data-translate="investhryApp.hepcRecruitment.totalExperience">Total Experience</span></th><th></th></tr></thead><tbody><tr ng-repeat="hepcRecruitment in vm.hepcRecruitments track by hepcRecruitment.id"><td>{{hepcRecruitment.name}}</td><td>{{hepcRecruitment.applicationId}}</td><td>{{hepcRecruitment.jobProfile}}</td><td>{{hepcRecruitment.totalExperience}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="hepc-recruitment-detail({id:hepcRecruitment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/hepc-recruitment-experience/hepc-recruitment-experience-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.hepcRecruitmentExperience.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.hepcRecruitmentExperience.delete.question" translate-values="{id: \'{{vm.hepcRecruitmentExperience.id}}\'}">Are you sure you want to delete this Hepc Recruitment Experience?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/hepc-recruitment-experience/hepc-recruitment-experience-detail.html','<div><h2><span data-translate="investhryApp.hepcRecruitmentExperience.detail.title">Hepc Recruitment Experience</span> {{vm.hepcRecruitmentExperience.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.hepcRecruitmentExperience.organization">Organization</span></dt><dd><span>{{vm.hepcRecruitmentExperience.organization}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentExperience.designation">Designation</span></dt><dd><span>{{vm.hepcRecruitmentExperience.designation}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentExperience.startDate">Start Date</span></dt><dd><span>{{vm.hepcRecruitmentExperience.startDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentExperience.endDate">End Date</span></dt><dd><span>{{vm.hepcRecruitmentExperience.endDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentExperience.totalExperience">Total Experience</span></dt><dd><span>{{vm.hepcRecruitmentExperience.totalExperience}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentExperience.workField">Work Field</span></dt><dd><span>{{vm.hepcRecruitmentExperience.workField}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentExperience.documentName">Document Name</span></dt><dd><span>{{vm.hepcRecruitmentExperience.documentName}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentExperience.documentType">Document Type</span></dt><dd><span>{{vm.hepcRecruitmentExperience.documentType}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentExperience.refId">Ref Id</span></dt><dd><span>{{vm.hepcRecruitmentExperience.refId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="hepc-recruitment-experience-detail.edit({id:vm.hepcRecruitmentExperience.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/hepc-recruitment-experience/hepc-recruitment-experience-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHepcRecruitmentExperienceLabel" data-translate="investhryApp.hepcRecruitmentExperience.home.createOrEditLabel">Create or edit a Hepc Recruitment Experience</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.hepcRecruitmentExperience.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.hepcRecruitmentExperience.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentExperience.organization" for="field_organization">Organization</label><input type="text" class="form-control" name="organization" id="field_organization" ng-model="vm.hepcRecruitmentExperience.organization"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentExperience.designation" for="field_designation">Designation</label><input type="text" class="form-control" name="designation" id="field_designation" ng-model="vm.hepcRecruitmentExperience.designation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentExperience.startDate" for="field_startDate">Start Date</label><div class="input-group"><input id="field_startDate" type="text" class="form-control" name="startDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.hepcRecruitmentExperience.startDate" is-open="vm.datePickerOpenStatus.startDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'startDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentExperience.endDate" for="field_endDate">End Date</label><div class="input-group"><input id="field_endDate" type="text" class="form-control" name="endDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.hepcRecruitmentExperience.endDate" is-open="vm.datePickerOpenStatus.endDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'endDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentExperience.totalExperience" for="field_totalExperience">Total Experience</label><input type="text" class="form-control" name="totalExperience" id="field_totalExperience" ng-model="vm.hepcRecruitmentExperience.totalExperience"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentExperience.workField" for="field_workField">Work Field</label><input type="text" class="form-control" name="workField" id="field_workField" ng-model="vm.hepcRecruitmentExperience.workField"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentExperience.documentName" for="field_documentName">Document Name</label><input type="text" class="form-control" name="documentName" id="field_documentName" ng-model="vm.hepcRecruitmentExperience.documentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentExperience.documentType" for="field_documentType">Document Type</label><input type="text" class="form-control" name="documentType" id="field_documentType" ng-model="vm.hepcRecruitmentExperience.documentType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentExperience.refId" for="field_refId">Ref Id</label><input type="text" class="form-control" name="refId" id="field_refId" ng-model="vm.hepcRecruitmentExperience.refId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/hepc-recruitment-experience/hepc-recruitment-experiences.html','<div><h2 data-translate="investhryApp.hepcRecruitmentExperience.home.title">Hepc Recruitment Experiences</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="hepc-recruitment-experience.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.hepcRecruitmentExperience.home.createLabel">Create new Hepc Recruitment Experience</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.hepcRecruitmentExperience.organization">Organization</span></th><th><span data-translate="investhryApp.hepcRecruitmentExperience.designation">Designation</span></th><th><span data-translate="investhryApp.hepcRecruitmentExperience.startDate">Start Date</span></th><th><span data-translate="investhryApp.hepcRecruitmentExperience.endDate">End Date</span></th><th><span data-translate="investhryApp.hepcRecruitmentExperience.totalExperience">Total Experience</span></th><th><span data-translate="investhryApp.hepcRecruitmentExperience.workField">Work Field</span></th><th><span data-translate="investhryApp.hepcRecruitmentExperience.documentName">Document Name</span></th><th><span data-translate="investhryApp.hepcRecruitmentExperience.documentType">Document Type</span></th><th><span data-translate="investhryApp.hepcRecruitmentExperience.refId">Ref Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="hepcRecruitmentExperience in vm.hepcRecruitmentExperiences track by hepcRecruitmentExperience.id"><td><a ui-sref="hepc-recruitment-experience-detail({id:hepcRecruitmentExperience.id})">{{hepcRecruitmentExperience.id}}</a></td><td>{{hepcRecruitmentExperience.organization}}</td><td>{{hepcRecruitmentExperience.designation}}</td><td>{{hepcRecruitmentExperience.startDate | date:\'mediumDate\'}}</td><td>{{hepcRecruitmentExperience.endDate | date:\'mediumDate\'}}</td><td>{{hepcRecruitmentExperience.totalExperience}}</td><td>{{hepcRecruitmentExperience.workField}}</td><td>{{hepcRecruitmentExperience.documentName}}</td><td>{{hepcRecruitmentExperience.documentType}}</td><td>{{hepcRecruitmentExperience.refId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="hepc-recruitment-experience-detail({id:hepcRecruitmentExperience.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="hepc-recruitment-experience.edit({id:hepcRecruitmentExperience.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="hepc-recruitment-experience.delete({id:hepcRecruitmentExperience.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/hepc-recruitment-qualifications/hepc-recruitment-qualifications-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.hepcRecruitmentQualifications.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.hepcRecruitmentQualifications.delete.question" translate-values="{id: \'{{vm.hepcRecruitmentQualifications.id}}\'}">Are you sure you want to delete this Hepc Recruitment Qualifications?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/hepc-recruitment-qualifications/hepc-recruitment-qualifications-detail.html','<div><h2><span data-translate="investhryApp.hepcRecruitmentQualifications.detail.title">Hepc Recruitment Qualifications</span> {{vm.hepcRecruitmentQualifications.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.degree">Degree</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.degree}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.stream">Stream</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.stream}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.session">Session</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.session}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.passingYear">Passing Year</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.passingYear}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.schoolUniversity">School University</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.schoolUniversity}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.specialization">Specialization</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.specialization}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.marksObtained">Marks Obtained</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.marksObtained}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.marksPercentage">Marks Percentage</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.marksPercentage}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.regularCorrespondance">Regular Correspondance</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.regularCorrespondance}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.division">Division</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.division}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.documentName">Document Name</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.documentName}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.documentType">Document Type</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.documentType}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.refId">Ref Id</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.refId}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.applicationId">Application Id</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.applicationId}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.preferredLocation">Preferred Location</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.preferredLocation}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.totalExperience">Total Experience</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.totalExperience}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.jobProfile">Job Profile</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.jobProfile}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.name">Name</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.name}}</span></dd><dt><span data-translate="investhryApp.hepcRecruitmentQualifications.sortIndex">Sort Index</span></dt><dd><span>{{vm.hepcRecruitmentQualifications.sortIndex}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="hepc-recruitment-qualifications-detail.edit({id:vm.hepcRecruitmentQualifications.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/hepc-recruitment-qualifications/hepc-recruitment-qualifications-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHepcRecruitmentQualificationsLabel" data-translate="investhryApp.hepcRecruitmentQualifications.home.createOrEditLabel">Create or edit a Hepc Recruitment Qualifications</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.hepcRecruitmentQualifications.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.hepcRecruitmentQualifications.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.degree" for="field_degree">Degree</label><input type="text" class="form-control" name="degree" id="field_degree" ng-model="vm.hepcRecruitmentQualifications.degree"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.stream" for="field_stream">Stream</label><input type="text" class="form-control" name="stream" id="field_stream" ng-model="vm.hepcRecruitmentQualifications.stream"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.session" for="field_session">Session</label><input type="text" class="form-control" name="session" id="field_session" ng-model="vm.hepcRecruitmentQualifications.session"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.passingYear" for="field_passingYear">Passing Year</label><input type="text" class="form-control" name="passingYear" id="field_passingYear" ng-model="vm.hepcRecruitmentQualifications.passingYear"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.schoolUniversity" for="field_schoolUniversity">School University</label><input type="text" class="form-control" name="schoolUniversity" id="field_schoolUniversity" ng-model="vm.hepcRecruitmentQualifications.schoolUniversity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.specialization" for="field_specialization">Specialization</label><input type="text" class="form-control" name="specialization" id="field_specialization" ng-model="vm.hepcRecruitmentQualifications.specialization"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.marksObtained" for="field_marksObtained">Marks Obtained</label><input type="text" class="form-control" name="marksObtained" id="field_marksObtained" ng-model="vm.hepcRecruitmentQualifications.marksObtained"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.marksPercentage" for="field_marksPercentage">Marks Percentage</label><input type="text" class="form-control" name="marksPercentage" id="field_marksPercentage" ng-model="vm.hepcRecruitmentQualifications.marksPercentage"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.regularCorrespondance" for="field_regularCorrespondance">Regular Correspondance</label><input type="text" class="form-control" name="regularCorrespondance" id="field_regularCorrespondance" ng-model="vm.hepcRecruitmentQualifications.regularCorrespondance"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.division" for="field_division">Division</label><input type="text" class="form-control" name="division" id="field_division" ng-model="vm.hepcRecruitmentQualifications.division"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.documentName" for="field_documentName">Document Name</label><input type="text" class="form-control" name="documentName" id="field_documentName" ng-model="vm.hepcRecruitmentQualifications.documentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.documentType" for="field_documentType">Document Type</label><input type="text" class="form-control" name="documentType" id="field_documentType" ng-model="vm.hepcRecruitmentQualifications.documentType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.refId" for="field_refId">Ref Id</label><input type="text" class="form-control" name="refId" id="field_refId" ng-model="vm.hepcRecruitmentQualifications.refId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.applicationId" for="field_applicationId">Application Id</label><input type="text" class="form-control" name="applicationId" id="field_applicationId" ng-model="vm.hepcRecruitmentQualifications.applicationId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.preferredLocation" for="field_preferredLocation">Preferred Location</label><input type="text" class="form-control" name="preferredLocation" id="field_preferredLocation" ng-model="vm.hepcRecruitmentQualifications.preferredLocation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.totalExperience" for="field_totalExperience">Total Experience</label><input type="number" class="form-control" name="totalExperience" id="field_totalExperience" ng-model="vm.hepcRecruitmentQualifications.totalExperience"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.jobProfile" for="field_jobProfile">Job Profile</label><input type="text" class="form-control" name="jobProfile" id="field_jobProfile" ng-model="vm.hepcRecruitmentQualifications.jobProfile"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.hepcRecruitmentQualifications.name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcRecruitmentQualifications.sortIndex" for="field_sortIndex">Sort Index</label><input type="number" class="form-control" name="sortIndex" id="field_sortIndex" ng-model="vm.hepcRecruitmentQualifications.sortIndex"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/hepc-recruitment-qualifications/hepc-recruitment-qualifications.html','<div><h2 data-translate="investhryApp.hepcRecruitmentQualifications.home.title">Hepc Recruitment Qualifications</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="hepc-recruitment-qualifications.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.hepcRecruitmentQualifications.home.createLabel">Create new Hepc Recruitment Qualifications</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.degree">Degree</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.stream">Stream</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.session">Session</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.passingYear">Passing Year</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.schoolUniversity">School University</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.specialization">Specialization</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.marksObtained">Marks Obtained</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.marksPercentage">Marks Percentage</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.regularCorrespondance">Regular Correspondance</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.division">Division</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.documentName">Document Name</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.documentType">Document Type</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.refId">Ref Id</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.applicationId">Application Id</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.preferredLocation">Preferred Location</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.totalExperience">Total Experience</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.jobProfile">Job Profile</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.name">Name</span></th><th><span data-translate="investhryApp.hepcRecruitmentQualifications.sortIndex">Sort Index</span></th><th></th></tr></thead><tbody><tr ng-repeat="hepcRecruitmentQualifications in vm.hepcRecruitmentQualifications track by hepcRecruitmentQualifications.id"><td><a ui-sref="hepc-recruitment-qualifications-detail({id:hepcRecruitmentQualifications.id})">{{hepcRecruitmentQualifications.id}}</a></td><td>{{hepcRecruitmentQualifications.degree}}</td><td>{{hepcRecruitmentQualifications.stream}}</td><td>{{hepcRecruitmentQualifications.session}}</td><td>{{hepcRecruitmentQualifications.passingYear}}</td><td>{{hepcRecruitmentQualifications.schoolUniversity}}</td><td>{{hepcRecruitmentQualifications.specialization}}</td><td>{{hepcRecruitmentQualifications.marksObtained}}</td><td>{{hepcRecruitmentQualifications.marksPercentage}}</td><td>{{hepcRecruitmentQualifications.regularCorrespondance}}</td><td>{{hepcRecruitmentQualifications.division}}</td><td>{{hepcRecruitmentQualifications.documentName}}</td><td>{{hepcRecruitmentQualifications.documentType}}</td><td>{{hepcRecruitmentQualifications.refId}}</td><td>{{hepcRecruitmentQualifications.applicationId}}</td><td>{{hepcRecruitmentQualifications.preferredLocation}}</td><td>{{hepcRecruitmentQualifications.totalExperience}}</td><td>{{hepcRecruitmentQualifications.jobProfile}}</td><td>{{hepcRecruitmentQualifications.name}}</td><td>{{hepcRecruitmentQualifications.sortIndex}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="hepc-recruitment-qualifications-detail({id:hepcRecruitmentQualifications.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="hepc-recruitment-qualifications.edit({id:hepcRecruitmentQualifications.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="hepc-recruitment-qualifications.delete({id:hepcRecruitmentQualifications.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/hepc-ticket-task/hepc-ticket-task-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.hepcTicketTask.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.hepcTicketTask.delete.question" translate-values="{id: \'{{vm.hepcTicketTask.id}}\'}">Are you sure you want to delete this Hepc Ticket Task?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/hepc-ticket-task/hepc-ticket-task-detail.html','<div><h2><span data-translate="investhryApp.hepcTicketTask.detail.title">Hepc Ticket Task</span> {{vm.hepcTicketTask.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.hepcTicketTask.openingTime">Opening Time</span></dt><dd><span>{{vm.hepcTicketTask.openingTime | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.hepcTicketTask.closingTime">Closing Time</span></dt><dd><span>{{vm.hepcTicketTask.closingTime | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.hepcTicketTask.isWorkingDay">Is Working Day</span></dt><dd><span>{{vm.hepcTicketTask.isWorkingDay}}</span></dd><dt><span data-translate="investhryApp.hepcTicketTask.isWorkingHours">Is Working Hours</span></dt><dd><span>{{vm.hepcTicketTask.isWorkingHours}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="hepc-ticket-task-detail.edit({id:vm.hepcTicketTask.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/hepc-ticket-task/hepc-ticket-task-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHepcTicketTaskLabel" data-translate="investhryApp.hepcTicketTask.home.createOrEditLabel">Create or edit a Hepc Ticket Task</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.hepcTicketTask.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.hepcTicketTask.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcTicketTask.openingTime" for="field_openingTime">Opening Time</label><div class="input-group"><input id="field_openingTime" type="text" class="form-control" name="openingTime" datetime-picker="{{dateformat}}" ng-model="vm.hepcTicketTask.openingTime" is-open="vm.datePickerOpenStatus.openingTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'openingTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcTicketTask.closingTime" for="field_closingTime">Closing Time</label><div class="input-group"><input id="field_closingTime" type="text" class="form-control" name="closingTime" datetime-picker="{{dateformat}}" ng-model="vm.hepcTicketTask.closingTime" is-open="vm.datePickerOpenStatus.closingTime"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'closingTime\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcTicketTask.isWorkingDay" for="field_isWorkingDay">Is Working Day</label><input type="checkbox" name="isWorkingDay" id="field_isWorkingDay" ng-model="vm.hepcTicketTask.isWorkingDay"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hepcTicketTask.isWorkingHours" for="field_isWorkingHours">Is Working Hours</label><input type="checkbox" name="isWorkingHours" id="field_isWorkingHours" ng-model="vm.hepcTicketTask.isWorkingHours"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/hepc-ticket-task/hepc-ticket-tasks.html','<div><h2 data-translate="investhryApp.hepcTicketTask.home.title">Hepc Ticket Tasks</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="hepc-ticket-task.new" ng-hide="vm.hepcTicketTasks.length==1"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.hepcTicketTask.home.createLabel">Create new Hepc Ticket Task</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.hepcTicketTask.openingTime">Opening Time</span></th><th><span data-translate="investhryApp.hepcTicketTask.closingTime">Closing Time</span></th><th><span data-translate="investhryApp.hepcTicketTask.isWorkingDay">Is Working Day</span></th><th><span data-translate="investhryApp.hepcTicketTask.isWorkingHours">Is Working Hours</span></th><th></th></tr></thead><tbody><tr ng-repeat="hepcTicketTask in vm.hepcTicketTasks track by hepcTicketTask.id"><td><a ui-sref="hepc-ticket-task-detail({id:hepcTicketTask.id})">{{hepcTicketTask.id}}</a></td><td>{{hepcTicketTask.openingTime | date:\'medium\'}}</td><td>{{hepcTicketTask.closingTime | date:\'medium\'}}</td><td>{{hepcTicketTask.isWorkingDay}}</td><td>{{hepcTicketTask.isWorkingHours}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="hepc-ticket-task-detail({id:hepcTicketTask.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="hepc-ticket-task.edit({id:hepcTicketTask.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="hepc-ticket-task.delete({id:hepcTicketTask.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/home-page-count-output/home-page-count-output-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.homePageCountOutput.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.homePageCountOutput.delete.question" translate-values="{id: \'{{vm.homePageCountOutput.id}}\'}">Are you sure you want to delete this Home Page Count Output?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/home-page-count-output/home-page-count-output-detail.html','<div><h2><span data-translate="investhryApp.homePageCountOutput.detail.title">Home Page Count Output</span> {{vm.homePageCountOutput.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.homePageCountOutput.totalCafs">Total Cafs</span></dt><dd><span>{{vm.homePageCountOutput.totalCafs}}</span></dd><dt><span data-translate="investhryApp.homePageCountOutput.totalServicesApplied">Total Services Applied</span></dt><dd><span>{{vm.homePageCountOutput.totalServicesApplied}}</span></dd><dt><span data-translate="investhryApp.homePageCountOutput.totalServicesGranted">Total Services Granted</span></dt><dd><span>{{vm.homePageCountOutput.totalServicesGranted}}</span></dd><dt><span data-translate="investhryApp.homePageCountOutput.totalCompletedCafs">Total Completed Cafs</span></dt><dd><span>{{vm.homePageCountOutput.totalCompletedCafs}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="home-page-count-output-detail.edit({id:vm.homePageCountOutput.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/home-page-count-output/home-page-count-output-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHomePageCountOutputLabel" data-translate="investhryApp.homePageCountOutput.home.createOrEditLabel">Create or edit a Home Page Count Output</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.homePageCountOutput.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.homePageCountOutput.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homePageCountOutput.totalCafs" for="field_totalCafs">Total Cafs</label><input type="number" class="form-control" name="totalCafs" id="field_totalCafs" ng-model="vm.homePageCountOutput.totalCafs"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homePageCountOutput.totalServicesApplied" for="field_totalServicesApplied">Total Services Applied</label><input type="number" class="form-control" name="totalServicesApplied" id="field_totalServicesApplied" ng-model="vm.homePageCountOutput.totalServicesApplied"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homePageCountOutput.totalServicesGranted" for="field_totalServicesGranted">Total Services Granted</label><input type="number" class="form-control" name="totalServicesGranted" id="field_totalServicesGranted" ng-model="vm.homePageCountOutput.totalServicesGranted"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homePageCountOutput.totalCompletedCafs" for="field_totalCompletedCafs">Total Completed Cafs</label><input type="number" class="form-control" name="totalCompletedCafs" id="field_totalCompletedCafs" ng-model="vm.homePageCountOutput.totalCompletedCafs"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/home-page-count-output/home-page-count-outputs.html','<div><h2 data-translate="investhryApp.homePageCountOutput.home.title">Home Page Count Outputs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="home-page-count-output.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.homePageCountOutput.home.createLabel">Create new Home Page Count Output</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.homePageCountOutput.totalCafs">Total Cafs</span></th><th><span data-translate="investhryApp.homePageCountOutput.totalServicesApplied">Total Services Applied</span></th><th><span data-translate="investhryApp.homePageCountOutput.totalServicesGranted">Total Services Granted</span></th><th><span data-translate="investhryApp.homePageCountOutput.totalCompletedCafs">Total Completed Cafs</span></th><th></th></tr></thead><tbody><tr ng-repeat="homePageCountOutput in vm.homePageCountOutputs track by homePageCountOutput.id"><td><a ui-sref="home-page-count-output-detail({id:homePageCountOutput.id})">{{homePageCountOutput.id}}</a></td><td>{{homePageCountOutput.totalCafs}}</td><td>{{homePageCountOutput.totalServicesApplied}}</td><td>{{homePageCountOutput.totalServicesGranted}}</td><td>{{homePageCountOutput.totalCompletedCafs}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="home-page-count-output-detail({id:homePageCountOutput.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="home-page-count-output.edit({id:homePageCountOutput.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="home-page-count-output.delete({id:homePageCountOutput.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/home-project-service-details/home-project-service-details-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.homeProjectServiceDetails.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.homeProjectServiceDetails.delete.question" translate-values="{id: \'{{vm.homeProjectServiceDetails.id}}\'}">Are you sure you want to delete this Home Project Service Details?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/home-project-service-details/home-project-service-details-detail.html','<div><h2><span data-translate="investhryApp.homeProjectServiceDetails.detail.title">Home Project Service Details</span> {{vm.homeProjectServiceDetails.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.homeProjectServiceDetails.projectId">Project Id</span></dt><dd><span>{{vm.homeProjectServiceDetails.projectId}}</span></dd><dt><span data-translate="investhryApp.homeProjectServiceDetails.serviceId">Service Id</span></dt><dd><span>{{vm.homeProjectServiceDetails.serviceId}}</span></dd><dt><span data-translate="investhryApp.homeProjectServiceDetails.cafPin">Caf Pin</span></dt><dd><span>{{vm.homeProjectServiceDetails.cafPin}}</span></dd><dt><span data-translate="investhryApp.homeProjectServiceDetails.district">District</span></dt><dd><span>{{vm.homeProjectServiceDetails.district}}</span></dd><dt><span data-translate="investhryApp.homeProjectServiceDetails.status">Status</span></dt><dd><span>{{vm.homeProjectServiceDetails.status}}</span></dd><dt><span data-translate="investhryApp.homeProjectServiceDetails.serviceName">Service Name</span></dt><dd><span>{{vm.homeProjectServiceDetails.serviceName}}</span></dd><dt><span data-translate="investhryApp.homeProjectServiceDetails.businessEntity">Business Entity</span></dt><dd><span>{{vm.homeProjectServiceDetails.businessEntity}}</span></dd><dt><span data-translate="investhryApp.homeProjectServiceDetails.departmentName">Department Name</span></dt><dd><span>{{vm.homeProjectServiceDetails.departmentName}}</span></dd><dt><span data-translate="investhryApp.homeProjectServiceDetails.ageing">Ageing</span></dt><dd><span>{{vm.homeProjectServiceDetails.ageing}}</span></dd><dt><span data-translate="investhryApp.homeProjectServiceDetails.lastComments">Last Comments</span></dt><dd><span>{{vm.homeProjectServiceDetails.lastComments}}</span></dd><dt><span data-translate="investhryApp.homeProjectServiceDetails.lastActionDate">Last Action Date</span></dt><dd><span>{{vm.homeProjectServiceDetails.lastActionDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="home-project-service-details-detail.edit({id:vm.homeProjectServiceDetails.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/home-project-service-details/home-project-service-details-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHomeProjectServiceDetailsLabel" data-translate="investhryApp.homeProjectServiceDetails.home.createOrEditLabel">Create or edit a Home Project Service Details</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.homeProjectServiceDetails.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.homeProjectServiceDetails.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homeProjectServiceDetails.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.homeProjectServiceDetails.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homeProjectServiceDetails.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.homeProjectServiceDetails.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homeProjectServiceDetails.cafPin" for="field_cafPin">Caf Pin</label><input type="text" class="form-control" name="cafPin" id="field_cafPin" ng-model="vm.homeProjectServiceDetails.cafPin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homeProjectServiceDetails.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.homeProjectServiceDetails.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homeProjectServiceDetails.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.homeProjectServiceDetails.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homeProjectServiceDetails.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.homeProjectServiceDetails.serviceName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homeProjectServiceDetails.businessEntity" for="field_businessEntity">Business Entity</label><input type="text" class="form-control" name="businessEntity" id="field_businessEntity" ng-model="vm.homeProjectServiceDetails.businessEntity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homeProjectServiceDetails.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.homeProjectServiceDetails.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homeProjectServiceDetails.ageing" for="field_ageing">Ageing</label><input type="text" class="form-control" name="ageing" id="field_ageing" ng-model="vm.homeProjectServiceDetails.ageing"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homeProjectServiceDetails.lastComments" for="field_lastComments">Last Comments</label><input type="text" class="form-control" name="lastComments" id="field_lastComments" ng-model="vm.homeProjectServiceDetails.lastComments"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.homeProjectServiceDetails.lastActionDate" for="field_lastActionDate">Last Action Date</label><div class="input-group"><input id="field_lastActionDate" type="text" class="form-control" name="lastActionDate" datetime-picker="{{dateformat}}" ng-model="vm.homeProjectServiceDetails.lastActionDate" is-open="vm.datePickerOpenStatus.lastActionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastActionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/home-project-service-details/home-project-service-details.html','<div><h2 data-translate="investhryApp.homeProjectServiceDetails.home.title">Home Project Service Details</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="home-project-service-details.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.homeProjectServiceDetails.home.createLabel">Create new Home Project Service Details</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.homeProjectServiceDetails.projectId">Project Id</span></th><th><span data-translate="investhryApp.homeProjectServiceDetails.serviceId">Service Id</span></th><th><span data-translate="investhryApp.homeProjectServiceDetails.cafPin">Caf Pin</span></th><th><span data-translate="investhryApp.homeProjectServiceDetails.district">District</span></th><th><span data-translate="investhryApp.homeProjectServiceDetails.status">Status</span></th><th><span data-translate="investhryApp.homeProjectServiceDetails.serviceName">Service Name</span></th><th><span data-translate="investhryApp.homeProjectServiceDetails.businessEntity">Business Entity</span></th><th><span data-translate="investhryApp.homeProjectServiceDetails.departmentName">Department Name</span></th><th><span data-translate="investhryApp.homeProjectServiceDetails.ageing">Ageing</span></th><th><span data-translate="investhryApp.homeProjectServiceDetails.lastComments">Last Comments</span></th><th><span data-translate="investhryApp.homeProjectServiceDetails.lastActionDate">Last Action Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="homeProjectServiceDetails in vm.homeProjectServiceDetails track by homeProjectServiceDetails.id"><td><a ui-sref="home-project-service-details-detail({id:homeProjectServiceDetails.id})">{{homeProjectServiceDetails.id}}</a></td><td>{{homeProjectServiceDetails.projectId}}</td><td>{{homeProjectServiceDetails.serviceId}}</td><td>{{homeProjectServiceDetails.cafPin}}</td><td>{{homeProjectServiceDetails.district}}</td><td>{{homeProjectServiceDetails.status}}</td><td>{{homeProjectServiceDetails.serviceName}}</td><td>{{homeProjectServiceDetails.businessEntity}}</td><td>{{homeProjectServiceDetails.departmentName}}</td><td>{{homeProjectServiceDetails.ageing}}</td><td>{{homeProjectServiceDetails.lastComments}}</td><td>{{homeProjectServiceDetails.lastActionDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="home-project-service-details-detail({id:homeProjectServiceDetails.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="home-project-service-details.edit({id:homeProjectServiceDetails.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="home-project-service-details.delete({id:homeProjectServiceDetails.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/huda-form/huda-form-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.hudaForm.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.hudaForm.delete.question" translate-values="{id: \'{{vm.hudaForm.id}}\'}">Are you sure you want to delete this Huda Form?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/huda-form/huda-form-detail.html','<div><h2><span data-translate="investhryApp.hudaForm.detail.title">Huda Form</span> {{vm.hudaForm.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.hudaForm.caseType">Case Type</span></dt><dd><span>{{vm.hudaForm.caseType}}</span></dd><dt><span data-translate="investhryApp.hudaForm.estateOffice">Estate Office</span></dt><dd><span>{{vm.hudaForm.estateOffice}}</span></dd><dt><span data-translate="investhryApp.hudaForm.projectType">Project Type</span></dt><dd><span>{{vm.hudaForm.projectType}}</span></dd><dt><span data-translate="investhryApp.hudaForm.sector">Sector</span></dt><dd><span>{{vm.hudaForm.sector}}</span></dd><dt><span data-translate="investhryApp.hudaForm.existingFAR">Existing FAR</span></dt><dd><span>{{vm.hudaForm.existingFAR}}</span></dd><dt><span data-translate="investhryApp.hudaForm.basementArea">Basement Area</span></dt><dd><span>{{vm.hudaForm.basementArea}}</span></dd><dt><span data-translate="investhryApp.hudaForm.zoningLayout">Zoning Layout</span></dt><dd><span>{{vm.hudaForm.zoningLayout}}</span></dd><dt><span data-translate="investhryApp.hudaForm.plotNumber">Plot Number</span></dt><dd><span>{{vm.hudaForm.plotNumber}}</span></dd><dt><span data-translate="investhryApp.hudaForm.applicationType">Application Type</span></dt><dd><span>{{vm.hudaForm.applicationType}}</span></dd><dt><span data-translate="investhryApp.hudaForm.applicantEmail">Applicant Email</span></dt><dd><span>{{vm.hudaForm.applicantEmail}}</span></dd><dt><span data-translate="investhryApp.hudaForm.applicantMobile">Applicant Mobile</span></dt><dd><span>{{vm.hudaForm.applicantMobile}}</span></dd><dt><span data-translate="investhryApp.hudaForm.ownerName">Owner Name</span></dt><dd><span>{{vm.hudaForm.ownerName}}</span></dd><dt><span data-translate="investhryApp.hudaForm.ownerAddress">Owner Address</span></dt><dd><span>{{vm.hudaForm.ownerAddress}}</span></dd><dt><span data-translate="investhryApp.hudaForm.aadhaarCardNumber">Aadhaar Card Number</span></dt><dd><span>{{vm.hudaForm.aadhaarCardNumber}}</span></dd><dt><span data-translate="investhryApp.hudaForm.fatherName">Father Name</span></dt><dd><span>{{vm.hudaForm.fatherName}}</span></dd><dt><span data-translate="investhryApp.hudaForm.pinCode">Pin Code</span></dt><dd><span>{{vm.hudaForm.pinCode}}</span></dd><dt><span data-translate="investhryApp.hudaForm.applicantName">Applicant Name</span></dt><dd><span>{{vm.hudaForm.applicantName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="huda-form-detail.edit({id:vm.hudaForm.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/huda-form/huda-form-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHudaFormLabel" data-translate="investhryApp.hudaForm.home.createOrEditLabel">Create or edit a Huda Form</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.hudaForm.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.hudaForm.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.caseType" for="field_caseType">Case Type</label><input type="text" class="form-control" name="caseType" id="field_caseType" ng-model="vm.hudaForm.caseType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.estateOffice" for="field_estateOffice">Estate Office</label><input type="text" class="form-control" name="estateOffice" id="field_estateOffice" ng-model="vm.hudaForm.estateOffice"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.projectType" for="field_projectType">Project Type</label><input type="text" class="form-control" name="projectType" id="field_projectType" ng-model="vm.hudaForm.projectType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.sector" for="field_sector">Sector</label><input type="text" class="form-control" name="sector" id="field_sector" ng-model="vm.hudaForm.sector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.existingFAR" for="field_existingFAR">Existing FAR</label><input type="text" class="form-control" name="existingFAR" id="field_existingFAR" ng-model="vm.hudaForm.existingFAR"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.basementArea" for="field_basementArea">Basement Area</label><input type="text" class="form-control" name="basementArea" id="field_basementArea" ng-model="vm.hudaForm.basementArea"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.zoningLayout" for="field_zoningLayout">Zoning Layout</label><input type="text" class="form-control" name="zoningLayout" id="field_zoningLayout" ng-model="vm.hudaForm.zoningLayout"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.plotNumber" for="field_plotNumber">Plot Number</label><input type="text" class="form-control" name="plotNumber" id="field_plotNumber" ng-model="vm.hudaForm.plotNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.applicationType" for="field_applicationType">Application Type</label><input type="text" class="form-control" name="applicationType" id="field_applicationType" ng-model="vm.hudaForm.applicationType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.applicantEmail" for="field_applicantEmail">Applicant Email</label><input type="text" class="form-control" name="applicantEmail" id="field_applicantEmail" ng-model="vm.hudaForm.applicantEmail"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.applicantMobile" for="field_applicantMobile">Applicant Mobile</label><input type="text" class="form-control" name="applicantMobile" id="field_applicantMobile" ng-model="vm.hudaForm.applicantMobile"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.ownerName" for="field_ownerName">Owner Name</label><input type="text" class="form-control" name="ownerName" id="field_ownerName" ng-model="vm.hudaForm.ownerName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.ownerAddress" for="field_ownerAddress">Owner Address</label><input type="text" class="form-control" name="ownerAddress" id="field_ownerAddress" ng-model="vm.hudaForm.ownerAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.aadhaarCardNumber" for="field_aadhaarCardNumber">Aadhaar Card Number</label><input type="text" class="form-control" name="aadhaarCardNumber" id="field_aadhaarCardNumber" ng-model="vm.hudaForm.aadhaarCardNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.fatherName" for="field_fatherName">Father Name</label><input type="text" class="form-control" name="fatherName" id="field_fatherName" ng-model="vm.hudaForm.fatherName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.pinCode" for="field_pinCode">Pin Code</label><input type="text" class="form-control" name="pinCode" id="field_pinCode" ng-model="vm.hudaForm.pinCode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaForm.applicantName" for="field_applicantName">Applicant Name</label><input type="text" class="form-control" name="applicantName" id="field_applicantName" ng-model="vm.hudaForm.applicantName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/huda-form/huda-forms.html','<div><h2 data-translate="investhryApp.hudaForm.home.title">Huda Forms</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="huda-form.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.hudaForm.home.createLabel">Create new Huda Form</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.hudaForm.caseType">Case Type</span></th><th><span data-translate="investhryApp.hudaForm.estateOffice">Estate Office</span></th><th><span data-translate="investhryApp.hudaForm.projectType">Project Type</span></th><th><span data-translate="investhryApp.hudaForm.sector">Sector</span></th><th><span data-translate="investhryApp.hudaForm.existingFAR">Existing FAR</span></th><th><span data-translate="investhryApp.hudaForm.basementArea">Basement Area</span></th><th><span data-translate="investhryApp.hudaForm.zoningLayout">Zoning Layout</span></th><th><span data-translate="investhryApp.hudaForm.plotNumber">Plot Number</span></th><th><span data-translate="investhryApp.hudaForm.applicationType">Application Type</span></th><th><span data-translate="investhryApp.hudaForm.applicantEmail">Applicant Email</span></th><th><span data-translate="investhryApp.hudaForm.applicantMobile">Applicant Mobile</span></th><th><span data-translate="investhryApp.hudaForm.ownerName">Owner Name</span></th><th><span data-translate="investhryApp.hudaForm.ownerAddress">Owner Address</span></th><th><span data-translate="investhryApp.hudaForm.aadhaarCardNumber">Aadhaar Card Number</span></th><th><span data-translate="investhryApp.hudaForm.fatherName">Father Name</span></th><th><span data-translate="investhryApp.hudaForm.pinCode">Pin Code</span></th><th><span data-translate="investhryApp.hudaForm.applicantName">Applicant Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="hudaForm in vm.hudaForms track by hudaForm.id"><td><a ui-sref="huda-form-detail({id:hudaForm.id})">{{hudaForm.id}}</a></td><td>{{hudaForm.caseType}}</td><td>{{hudaForm.estateOffice}}</td><td>{{hudaForm.projectType}}</td><td>{{hudaForm.sector}}</td><td>{{hudaForm.existingFAR}}</td><td>{{hudaForm.basementArea}}</td><td>{{hudaForm.zoningLayout}}</td><td>{{hudaForm.plotNumber}}</td><td>{{hudaForm.applicationType}}</td><td>{{hudaForm.applicantEmail}}</td><td>{{hudaForm.applicantMobile}}</td><td>{{hudaForm.ownerName}}</td><td>{{hudaForm.ownerAddress}}</td><td>{{hudaForm.aadhaarCardNumber}}</td><td>{{hudaForm.fatherName}}</td><td>{{hudaForm.pinCode}}</td><td>{{hudaForm.applicantName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="huda-form-detail({id:hudaForm.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="huda-form.edit({id:hudaForm.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="huda-form.delete({id:hudaForm.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/hudaform-oc/hudaform-oc-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.hudaformOc.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.hudaformOc.delete.question" translate-values="{id: \'{{vm.hudaformOc.id}}\'}">Are you sure you want to delete this Hudaform Oc?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/hudaform-oc/hudaform-oc-detail.html','<div><h2><span data-translate="investhryApp.hudaformOc.detail.title">Hudaform Oc</span> {{vm.hudaformOc.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.hudaformOc.certificateFrom">Certificate From</span></dt><dd><span>{{vm.hudaformOc.certificateFrom}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.orderNo">Order No</span></dt><dd><span>{{vm.hudaformOc.orderNo}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.dated">Dated</span></dt><dd><span>{{vm.hudaformOc.dated}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.completedOn">Completed On</span></dt><dd><span>{{vm.hudaformOc.completedOn}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.anyModifications">Any Modifications</span></dt><dd><span>{{vm.hudaformOc.anyModifications}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.plotNo">Plot No</span></dt><dd><span>{{vm.hudaformOc.plotNo}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.phase">Phase</span></dt><dd><span>{{vm.hudaformOc.phase}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.estate">Estate</span></dt><dd><span>{{vm.hudaformOc.estate}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.sector">Sector</span></dt><dd><span>{{vm.hudaformOc.sector}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.colony">Colony</span></dt><dd><span>{{vm.hudaformOc.colony}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.city">City</span></dt><dd><span>{{vm.hudaformOc.city}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.khasra">Khasra</span></dt><dd><span>{{vm.hudaformOc.khasra}}</span></dd><dt><span data-translate="investhryApp.hudaformOc.village">Village</span></dt><dd><span>{{vm.hudaformOc.village}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="hudaform-oc-detail.edit({id:vm.hudaformOc.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/hudaform-oc/hudaform-oc-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myHudaformOcLabel" data-translate="investhryApp.hudaformOc.home.createOrEditLabel">Create or edit a Hudaform Oc</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.hudaformOc.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.hudaformOc.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.certificateFrom" for="field_certificateFrom">Certificate From</label><input type="text" class="form-control" name="certificateFrom" id="field_certificateFrom" ng-model="vm.hudaformOc.certificateFrom"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.orderNo" for="field_orderNo">Order No</label><input type="text" class="form-control" name="orderNo" id="field_orderNo" ng-model="vm.hudaformOc.orderNo"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.dated" for="field_dated">Dated</label><input type="text" class="form-control" name="dated" id="field_dated" ng-model="vm.hudaformOc.dated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.completedOn" for="field_completedOn">Completed On</label><input type="text" class="form-control" name="completedOn" id="field_completedOn" ng-model="vm.hudaformOc.completedOn"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.anyModifications" for="field_anyModifications">Any Modifications</label><input type="text" class="form-control" name="anyModifications" id="field_anyModifications" ng-model="vm.hudaformOc.anyModifications"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.plotNo" for="field_plotNo">Plot No</label><input type="text" class="form-control" name="plotNo" id="field_plotNo" ng-model="vm.hudaformOc.plotNo"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.phase" for="field_phase">Phase</label><input type="text" class="form-control" name="phase" id="field_phase" ng-model="vm.hudaformOc.phase"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.estate" for="field_estate">Estate</label><input type="text" class="form-control" name="estate" id="field_estate" ng-model="vm.hudaformOc.estate"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.sector" for="field_sector">Sector</label><input type="text" class="form-control" name="sector" id="field_sector" ng-model="vm.hudaformOc.sector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.colony" for="field_colony">Colony</label><input type="text" class="form-control" name="colony" id="field_colony" ng-model="vm.hudaformOc.colony"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.city" for="field_city">City</label><input type="text" class="form-control" name="city" id="field_city" ng-model="vm.hudaformOc.city"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.khasra" for="field_khasra">Khasra</label><input type="text" class="form-control" name="khasra" id="field_khasra" ng-model="vm.hudaformOc.khasra"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.hudaformOc.village" for="field_village">Village</label><input type="text" class="form-control" name="village" id="field_village" ng-model="vm.hudaformOc.village"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/hudaform-oc/hudaform-ocs.html','<div><h2 data-translate="investhryApp.hudaformOc.home.title">Hudaform Ocs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="hudaform-oc.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.hudaformOc.home.createLabel">Create new Hudaform Oc</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.hudaformOc.certificateFrom">Certificate From</span></th><th><span data-translate="investhryApp.hudaformOc.orderNo">Order No</span></th><th><span data-translate="investhryApp.hudaformOc.dated">Dated</span></th><th><span data-translate="investhryApp.hudaformOc.completedOn">Completed On</span></th><th><span data-translate="investhryApp.hudaformOc.anyModifications">Any Modifications</span></th><th><span data-translate="investhryApp.hudaformOc.plotNo">Plot No</span></th><th><span data-translate="investhryApp.hudaformOc.phase">Phase</span></th><th><span data-translate="investhryApp.hudaformOc.estate">Estate</span></th><th><span data-translate="investhryApp.hudaformOc.sector">Sector</span></th><th><span data-translate="investhryApp.hudaformOc.colony">Colony</span></th><th><span data-translate="investhryApp.hudaformOc.city">City</span></th><th><span data-translate="investhryApp.hudaformOc.khasra">Khasra</span></th><th><span data-translate="investhryApp.hudaformOc.village">Village</span></th><th></th></tr></thead><tbody><tr ng-repeat="hudaformOc in vm.hudaformOcs track by hudaformOc.id"><td><a ui-sref="hudaform-oc-detail({id:hudaformOc.id})">{{hudaformOc.id}}</a></td><td>{{hudaformOc.certificateFrom}}</td><td>{{hudaformOc.orderNo}}</td><td>{{hudaformOc.dated}}</td><td>{{hudaformOc.completedOn}}</td><td>{{hudaformOc.anyModifications}}</td><td>{{hudaformOc.plotNo}}</td><td>{{hudaformOc.phase}}</td><td>{{hudaformOc.estate}}</td><td>{{hudaformOc.sector}}</td><td>{{hudaformOc.colony}}</td><td>{{hudaformOc.city}}</td><td>{{hudaformOc.khasra}}</td><td>{{hudaformOc.village}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="hudaform-oc-detail({id:hudaformOc.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="hudaform-oc.edit({id:hudaformOc.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="hudaform-oc.delete({id:hudaformOc.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/incentive-block-mapping/incentive-block-mapping-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.incentiveBlockMapping.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.incentiveBlockMapping.delete.question" translate-values="{id: \'{{vm.incentiveBlockMapping.id}}\'}">Are you sure you want to delete this Incentive Block Mapping?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/incentive-block-mapping/incentive-block-mapping-detail.html','<div><h2><span data-translate="investhryApp.incentiveBlockMapping.detail.title">Incentive Block Mapping</span> {{vm.incentiveBlockMapping.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.incentiveBlockMapping.districtName">District Name</span></dt><dd><span>{{vm.incentiveBlockMapping.districtName}}</span></dd><dt><span data-translate="investhryApp.incentiveBlockMapping.blockName">Block Name</span></dt><dd><span>{{vm.incentiveBlockMapping.blockName}}</span></dd><dt><span data-translate="investhryApp.incentiveBlockMapping.blockType">Block Type</span></dt><dd><span>{{vm.incentiveBlockMapping.blockType}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="incentive-block-mapping-detail.edit({id:vm.incentiveBlockMapping.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/incentive-block-mapping/incentive-block-mapping-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myIncentiveBlockMappingLabel" data-translate="investhryApp.incentiveBlockMapping.home.createOrEditLabel">Create or edit a Incentive Block Mapping</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.incentiveBlockMapping.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.incentiveBlockMapping.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveBlockMapping.districtName" for="field_districtName">District Name</label><input type="text" class="form-control" name="districtName" id="field_districtName" ng-model="vm.incentiveBlockMapping.districtName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveBlockMapping.blockName" for="field_blockName">Block Name</label><input type="text" class="form-control" name="blockName" id="field_blockName" ng-model="vm.incentiveBlockMapping.blockName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveBlockMapping.blockType" for="field_blockType">Block Type</label><input type="text" class="form-control" name="blockType" id="field_blockType" ng-model="vm.incentiveBlockMapping.blockType"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/incentive-block-mapping/incentive-block-mappings.html','<div><h2 data-translate="investhryApp.incentiveBlockMapping.home.title">Incentive Block Mappings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="incentive-block-mapping.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.incentiveBlockMapping.home.createLabel">Create new Incentive Block Mapping</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.incentiveBlockMapping.districtName">District Name</span></th><th><span data-translate="investhryApp.incentiveBlockMapping.blockName">Block Name</span></th><th><span data-translate="investhryApp.incentiveBlockMapping.blockType">Block Type</span></th><th></th></tr></thead><tbody><tr ng-repeat="incentiveBlockMapping in vm.incentiveBlockMappings track by incentiveBlockMapping.id"><td><a ui-sref="incentive-block-mapping-detail({id:incentiveBlockMapping.id})">{{incentiveBlockMapping.id}}</a></td><td>{{incentiveBlockMapping.districtName}}</td><td>{{incentiveBlockMapping.blockName}}</td><td>{{incentiveBlockMapping.blockType}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="incentive-block-mapping-detail({id:incentiveBlockMapping.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="incentive-block-mapping.edit({id:incentiveBlockMapping.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="incentive-block-mapping.delete({id:incentiveBlockMapping.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/incentive-wizard-rule/incentive-wizard-rule-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.incentiveWizardRule.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.incentiveWizardRule.delete.question" translate-values="{id: \'{{vm.incentiveWizardRule.id}}\'}">Are you sure you want to delete this Incentive Wizard Rule?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/incentive-wizard-rule/incentive-wizard-rule-detail.html','<div><h2><span data-translate="investhryApp.incentiveWizardRule.detail.title">Incentive Wizard Rule</span> {{vm.incentiveWizardRule.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.incentiveWizardRule.businessType">Business Type</span></dt><dd><span>{{vm.incentiveWizardRule.businessType}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.conformsToRestrictiveList">Conforms To Restrictive List</span></dt><dd><span>{{vm.incentiveWizardRule.conformsToRestrictiveList}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.thrustSector">Thrust Sector</span></dt><dd><span>{{vm.incentiveWizardRule.thrustSector}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.startupCompany">Startup Company</span></dt><dd><span>{{vm.incentiveWizardRule.startupCompany}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.sectorEnterPrise">Sector Enter Prise</span></dt><dd><span>{{vm.incentiveWizardRule.sectorEnterPrise}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.importSubstitutionEnterprise">Import Substitution Enterprise</span></dt><dd><span>{{vm.incentiveWizardRule.importSubstitutionEnterprise}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.exportOriented">Export Oriented</span></dt><dd><span>{{vm.incentiveWizardRule.exportOriented}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.outsideMunicipalLimits">Outside Municipal Limits</span></dt><dd><span>{{vm.incentiveWizardRule.outsideMunicipalLimits}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.infrastructureRelated">Infrastructure Related</span></dt><dd><span>{{vm.incentiveWizardRule.infrastructureRelated}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.renewable">Renewable</span></dt><dd><span>{{vm.incentiveWizardRule.renewable}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.projectType">Project Type</span></dt><dd><span>{{vm.incentiveWizardRule.projectType}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.subSector">Sub Sector</span></dt><dd><span>{{vm.incentiveWizardRule.subSector}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.blockType">Block Type</span></dt><dd><span>{{vm.incentiveWizardRule.blockType}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.referenceNumber">Reference Number</span></dt><dd><span>{{vm.incentiveWizardRule.referenceNumber}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.incentiveCategory">Incentive Category</span></dt><dd><span>{{vm.incentiveWizardRule.incentiveCategory}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.rawNote">Raw Note</span></dt><dd><span>{{vm.incentiveWizardRule.rawNote}}</span></dd><dt><span data-translate="investhryApp.incentiveWizardRule.displayPriority">Display Priority</span></dt><dd><span>{{vm.incentiveWizardRule.displayPriority}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="incentive-wizard-rule-detail.edit({id:vm.incentiveWizardRule.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/incentive-wizard-rule/incentive-wizard-rule-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myIncentiveWizardRuleLabel" data-translate="investhryApp.incentiveWizardRule.home.createOrEditLabel">Create or edit a Incentive Wizard Rule</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.incentiveWizardRule.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.incentiveWizardRule.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.businessType" for="field_businessType">Business Type</label><input type="text" class="form-control" name="businessType" id="field_businessType" ng-model="vm.incentiveWizardRule.businessType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.conformsToRestrictiveList" for="field_conformsToRestrictiveList">Conforms To Restrictive List</label><input type="text" class="form-control" name="conformsToRestrictiveList" id="field_conformsToRestrictiveList" ng-model="vm.incentiveWizardRule.conformsToRestrictiveList"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.thrustSector" for="field_thrustSector">Thrust Sector</label><input type="text" class="form-control" name="thrustSector" id="field_thrustSector" ng-model="vm.incentiveWizardRule.thrustSector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.startupCompany" for="field_startupCompany">Startup Company</label><input type="text" class="form-control" name="startupCompany" id="field_startupCompany" ng-model="vm.incentiveWizardRule.startupCompany"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.sectorEnterPrise" for="field_sectorEnterPrise">Sector Enter Prise</label><input type="text" class="form-control" name="sectorEnterPrise" id="field_sectorEnterPrise" ng-model="vm.incentiveWizardRule.sectorEnterPrise"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.importSubstitutionEnterprise" for="field_importSubstitutionEnterprise">Import Substitution Enterprise</label><input type="text" class="form-control" name="importSubstitutionEnterprise" id="field_importSubstitutionEnterprise" ng-model="vm.incentiveWizardRule.importSubstitutionEnterprise"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.exportOriented" for="field_exportOriented">Export Oriented</label><input type="text" class="form-control" name="exportOriented" id="field_exportOriented" ng-model="vm.incentiveWizardRule.exportOriented"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.outsideMunicipalLimits" for="field_outsideMunicipalLimits">Outside Municipal Limits</label><input type="text" class="form-control" name="outsideMunicipalLimits" id="field_outsideMunicipalLimits" ng-model="vm.incentiveWizardRule.outsideMunicipalLimits"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.infrastructureRelated" for="field_infrastructureRelated">Infrastructure Related</label><input type="text" class="form-control" name="infrastructureRelated" id="field_infrastructureRelated" ng-model="vm.incentiveWizardRule.infrastructureRelated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.renewable" for="field_renewable">Renewable</label><input type="text" class="form-control" name="renewable" id="field_renewable" ng-model="vm.incentiveWizardRule.renewable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.projectType" for="field_projectType">Project Type</label><input type="text" class="form-control" name="projectType" id="field_projectType" ng-model="vm.incentiveWizardRule.projectType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.subSector" for="field_subSector">Sub Sector</label><input type="text" class="form-control" name="subSector" id="field_subSector" ng-model="vm.incentiveWizardRule.subSector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.blockType" for="field_blockType">Block Type</label><input type="text" class="form-control" name="blockType" id="field_blockType" ng-model="vm.incentiveWizardRule.blockType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.referenceNumber" for="field_referenceNumber">Reference Number</label><input type="text" class="form-control" name="referenceNumber" id="field_referenceNumber" ng-model="vm.incentiveWizardRule.referenceNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.incentiveCategory" for="field_incentiveCategory">Incentive Category</label><input type="text" class="form-control" name="incentiveCategory" id="field_incentiveCategory" ng-model="vm.incentiveWizardRule.incentiveCategory"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.rawNote" for="field_rawNote">Raw Note</label><input type="text" class="form-control" name="rawNote" id="field_rawNote" ng-model="vm.incentiveWizardRule.rawNote"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.incentiveWizardRule.displayPriority" for="field_displayPriority">Display Priority</label><input type="number" class="form-control" name="displayPriority" id="field_displayPriority" ng-model="vm.incentiveWizardRule.displayPriority"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/incentive-wizard-rule/incentive-wizard-rules.html','<div><h2 data-translate="investhryApp.incentiveWizardRule.home.title">Incentive Wizard Rules</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="incentive-wizard-rule.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.incentiveWizardRule.home.createLabel">Create new Incentive Wizard Rule</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.incentiveWizardRule.businessType">Business Type</span></th><th><span data-translate="investhryApp.incentiveWizardRule.conformsToRestrictiveList">Conforms To Restrictive List</span></th><th><span data-translate="investhryApp.incentiveWizardRule.thrustSector">Thrust Sector</span></th><th><span data-translate="investhryApp.incentiveWizardRule.startupCompany">Startup Company</span></th><th><span data-translate="investhryApp.incentiveWizardRule.sectorEnterPrise">Sector Enter Prise</span></th><th><span data-translate="investhryApp.incentiveWizardRule.importSubstitutionEnterprise">Import Substitution Enterprise</span></th><th><span data-translate="investhryApp.incentiveWizardRule.exportOriented">Export Oriented</span></th><th><span data-translate="investhryApp.incentiveWizardRule.outsideMunicipalLimits">Outside Municipal Limits</span></th><th><span data-translate="investhryApp.incentiveWizardRule.infrastructureRelated">Infrastructure Related</span></th><th><span data-translate="investhryApp.incentiveWizardRule.renewable">Renewable</span></th><th><span data-translate="investhryApp.incentiveWizardRule.projectType">Project Type</span></th><th><span data-translate="investhryApp.incentiveWizardRule.subSector">Sub Sector</span></th><th><span data-translate="investhryApp.incentiveWizardRule.blockType">Block Type</span></th><th><span data-translate="investhryApp.incentiveWizardRule.referenceNumber">Reference Number</span></th><th><span data-translate="investhryApp.incentiveWizardRule.incentiveCategory">Incentive Category</span></th><th><span data-translate="investhryApp.incentiveWizardRule.rawNote">Raw Note</span></th><th><span data-translate="investhryApp.incentiveWizardRule.displayPriority">Display Priority</span></th><th></th></tr></thead><tbody><tr ng-repeat="incentiveWizardRule in vm.incentiveWizardRules track by incentiveWizardRule.id"><td><a ui-sref="incentive-wizard-rule-detail({id:incentiveWizardRule.id})">{{incentiveWizardRule.id}}</a></td><td>{{incentiveWizardRule.businessType}}</td><td>{{incentiveWizardRule.conformsToRestrictiveList}}</td><td>{{incentiveWizardRule.thrustSector}}</td><td>{{incentiveWizardRule.startupCompany}}</td><td>{{incentiveWizardRule.sectorEnterPrise}}</td><td>{{incentiveWizardRule.importSubstitutionEnterprise}}</td><td>{{incentiveWizardRule.exportOriented}}</td><td>{{incentiveWizardRule.outsideMunicipalLimits}}</td><td>{{incentiveWizardRule.infrastructureRelated}}</td><td>{{incentiveWizardRule.renewable}}</td><td>{{incentiveWizardRule.projectType}}</td><td>{{incentiveWizardRule.subSector}}</td><td>{{incentiveWizardRule.blockType}}</td><td>{{incentiveWizardRule.referenceNumber}}</td><td>{{incentiveWizardRule.incentiveCategory}}</td><td>{{incentiveWizardRule.rawNote}}</td><td>{{incentiveWizardRule.displayPriority}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="incentive-wizard-rule-detail({id:incentiveWizardRule.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="incentive-wizard-rule.edit({id:incentiveWizardRule.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="incentive-wizard-rule.delete({id:incentiveWizardRule.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/industrysize/industrysize-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.industrysize.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.industrysize.delete.question" translate-values="{id: \'{{vm.industrysize.id}}\'}">Are you sure you want to delete this Industrysize?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/industrysize/industrysize-detail.html','<div class="container"><h2><span data-translate="investhryApp.industrysize.detail.title">Industrysize</span> {{vm.industrysize.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.industrysize.sizeofindustry">Sizeofindustry</span></dt><dd><span>{{vm.industrysize.sizeofindustry}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="industrysize-detail.edit({id:vm.industrysize.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/industrysize/industrysize-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myIndustrysizeLabel" data-translate="investhryApp.industrysize.home.createOrEditLabel">Create or edit a Industrysize</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.industrysize.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.industrysize.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.industrysize.sizeofindustry" for="field_sizeofindustry">Sizeofindustry</label><input type="text" class="form-control" name="sizeofindustry" id="field_sizeofindustry" ng-model="vm.industrysize.sizeofindustry" required><div ng-show="editForm.sizeofindustry.$invalid"><p class="help-block" ng-show="editForm.sizeofindustry.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/industrysize/industrysizes.html','<div class="container"><h2 data-translate="investhryApp.industrysize.home.title">Industrysizes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="industrysize.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.industrysize.home.createLabel">Create new Industrysize</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.industrysize.sizeofindustry">Sizeofindustry</span></th><th></th></tr></thead><tbody><tr ng-repeat="industrysize in vm.industrysizes track by industrysize.id"><td><a ui-sref="industrysize-detail({id:industrysize.id})">{{industrysize.id}}</a></td><td>{{industrysize.sizeofindustry}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="industrysize-detail({id:industrysize.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="industrysize.edit({id:industrysize.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="industrysize.delete({id:industrysize.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/inspection-report/inspection-report-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.inspectionReport.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.inspectionReport.delete.question" translate-values="{id: \'{{vm.inspectionReport.id}}\'}">Are you sure you want to delete this Inspection Report?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/inspection-report/inspection-report-detail.html','<div><h2><span data-translate="investhryApp.inspectionReport.detail.title">Inspection Report</span> {{vm.inspectionReport.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.inspectionReport.projectid">Projectid</span></dt><dd><span>{{vm.inspectionReport.projectid}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.serviceid">Serviceid</span></dt><dd><span>{{vm.inspectionReport.serviceid}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.reportDescription">Report Description</span></dt><dd><span>{{vm.inspectionReport.reportDescription}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.file1">File 1</span></dt><dd><span>{{vm.inspectionReport.file1}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.file2">File 2</span></dt><dd><span>{{vm.inspectionReport.file2}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.file3">File 3</span></dt><dd><span>{{vm.inspectionReport.file3}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.file4">File 4</span></dt><dd><span>{{vm.inspectionReport.file4}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.file5">File 5</span></dt><dd><span>{{vm.inspectionReport.file5}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.file6">File 6</span></dt><dd><span>{{vm.inspectionReport.file6}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.file7">File 7</span></dt><dd><span>{{vm.inspectionReport.file7}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.file8">File 8</span></dt><dd><span>{{vm.inspectionReport.file8}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.file9">File 9</span></dt><dd><span>{{vm.inspectionReport.file9}}</span></dd><dt><span data-translate="investhryApp.inspectionReport.file10">File 10</span></dt><dd><span>{{vm.inspectionReport.file10}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="inspection-report-detail.edit({id:vm.inspectionReport.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/inspection-report/inspection-report-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInspectionReportLabel" data-translate="investhryApp.inspectionReport.home.createOrEditLabel">Create or edit a Inspection Report</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.inspectionReport.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.inspectionReport.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.inspectionReport.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.inspectionReport.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.reportDescription" for="field_reportDescription">Report Description</label><input type="text" class="form-control" name="reportDescription" id="field_reportDescription" ng-model="vm.inspectionReport.reportDescription"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.file1" for="field_file1">File 1</label><input type="text" class="form-control" name="file1" id="field_file1" ng-model="vm.inspectionReport.file1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.file2" for="field_file2">File 2</label><input type="text" class="form-control" name="file2" id="field_file2" ng-model="vm.inspectionReport.file2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.file3" for="field_file3">File 3</label><input type="text" class="form-control" name="file3" id="field_file3" ng-model="vm.inspectionReport.file3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.file4" for="field_file4">File 4</label><input type="text" class="form-control" name="file4" id="field_file4" ng-model="vm.inspectionReport.file4"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.file5" for="field_file5">File 5</label><input type="text" class="form-control" name="file5" id="field_file5" ng-model="vm.inspectionReport.file5"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.file6" for="field_file6">File 6</label><input type="text" class="form-control" name="file6" id="field_file6" ng-model="vm.inspectionReport.file6"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.file7" for="field_file7">File 7</label><input type="text" class="form-control" name="file7" id="field_file7" ng-model="vm.inspectionReport.file7"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.file8" for="field_file8">File 8</label><input type="text" class="form-control" name="file8" id="field_file8" ng-model="vm.inspectionReport.file8"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.file9" for="field_file9">File 9</label><input type="text" class="form-control" name="file9" id="field_file9" ng-model="vm.inspectionReport.file9"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectionReport.file10" for="field_file10">File 10</label><input type="text" class="form-control" name="file10" id="field_file10" ng-model="vm.inspectionReport.file10"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/inspection-report/inspection-reports.html','<div><h2 data-translate="investhryApp.inspectionReport.home.title">Inspection Reports</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="inspection-report.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.inspectionReport.home.createLabel">Create new Inspection Report</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.inspectionReport.projectid">Projectid</span></th><th><span data-translate="investhryApp.inspectionReport.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.inspectionReport.reportDescription">Report Description</span></th><th><span data-translate="investhryApp.inspectionReport.file1">File 1</span></th><th><span data-translate="investhryApp.inspectionReport.file2">File 2</span></th><th><span data-translate="investhryApp.inspectionReport.file3">File 3</span></th><th><span data-translate="investhryApp.inspectionReport.file4">File 4</span></th><th><span data-translate="investhryApp.inspectionReport.file5">File 5</span></th><th><span data-translate="investhryApp.inspectionReport.file6">File 6</span></th><th><span data-translate="investhryApp.inspectionReport.file7">File 7</span></th><th><span data-translate="investhryApp.inspectionReport.file8">File 8</span></th><th><span data-translate="investhryApp.inspectionReport.file9">File 9</span></th><th><span data-translate="investhryApp.inspectionReport.file10">File 10</span></th><th></th></tr></thead><tbody><tr ng-repeat="inspectionReport in vm.inspectionReports track by inspectionReport.id"><td><a ui-sref="inspection-report-detail({id:inspectionReport.id})">{{inspectionReport.id}}</a></td><td>{{inspectionReport.projectid}}</td><td>{{inspectionReport.serviceid}}</td><td>{{inspectionReport.reportDescription}}</td><td>{{inspectionReport.file1}}</td><td>{{inspectionReport.file2}}</td><td>{{inspectionReport.file3}}</td><td>{{inspectionReport.file4}}</td><td>{{inspectionReport.file5}}</td><td>{{inspectionReport.file6}}</td><td>{{inspectionReport.file7}}</td><td>{{inspectionReport.file8}}</td><td>{{inspectionReport.file9}}</td><td>{{inspectionReport.file10}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="inspection-report-detail({id:inspectionReport.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="inspection-report.edit({id:inspectionReport.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="inspection-report.delete({id:inspectionReport.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/inspector-details/inspector-details-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.inspectorDetails.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.inspectorDetails.delete.question" translate-values="{id: \'{{vm.inspectorDetails.id}}\'}">Are you sure you want to delete this Inspector Details?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/inspector-details/inspector-details-detail.html','<div><h2><span data-translate="investhryApp.inspectorDetails.detail.title">Inspector Details</span> {{vm.inspectorDetails.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.inspectorDetails.inspectorId">Inspector Id</span></dt><dd><span>{{vm.inspectorDetails.inspectorId}}</span></dd><dt><span data-translate="investhryApp.inspectorDetails.inspectorName">Inspector Name</span></dt><dd><span>{{vm.inspectorDetails.inspectorName}}</span></dd><dt><span data-translate="investhryApp.inspectorDetails.estateName">Estate Name</span></dt><dd><span>{{vm.inspectorDetails.estateName}}</span></dd><dt><span data-translate="investhryApp.inspectorDetails.districtName">District Name</span></dt><dd><span>{{vm.inspectorDetails.districtName}}</span></dd><dt><span data-translate="investhryApp.inspectorDetails.contactNo">Contact No</span></dt><dd><span>{{vm.inspectorDetails.contactNo}}</span></dd><dt><span data-translate="investhryApp.inspectorDetails.inspectorEmail">Inspector Email</span></dt><dd><span>{{vm.inspectorDetails.inspectorEmail}}</span></dd><dt><span data-translate="investhryApp.inspectorDetails.departmentName">Department Name</span></dt><dd><span>{{vm.inspectorDetails.departmentName}}</span></dd><dt><span data-translate="investhryApp.inspectorDetails.inspectorService">Inspector Service</span></dt><dd><span>{{vm.inspectorDetails.inspectorService}}</span></dd><dt><span data-translate="investhryApp.inspectorDetails.serviceId">Service Id</span></dt><dd><span>{{vm.inspectorDetails.serviceId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="inspector-details-detail.edit({id:vm.inspectorDetails.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/inspector-details/inspector-details-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInspectorDetailsLabel" data-translate="investhryApp.inspectorDetails.home.createOrEditLabel">Create or edit a Inspector Details</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.inspectorDetails.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.inspectorDetails.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectorDetails.inspectorId" for="field_inspectorId">Inspector Id</label><input type="text" class="form-control" name="inspectorId" id="field_inspectorId" ng-model="vm.inspectorDetails.inspectorId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectorDetails.inspectorName" for="field_inspectorName">Inspector Name</label><input type="text" class="form-control" name="inspectorName" id="field_inspectorName" ng-model="vm.inspectorDetails.inspectorName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectorDetails.estateName" for="field_estateName">Estate Name</label><input type="text" class="form-control" name="estateName" id="field_estateName" ng-model="vm.inspectorDetails.estateName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectorDetails.districtName" for="field_districtName">District Name</label><input type="text" class="form-control" name="districtName" id="field_districtName" ng-model="vm.inspectorDetails.districtName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectorDetails.contactNo" for="field_contactNo">Contact No</label><input type="text" class="form-control" name="contactNo" id="field_contactNo" ng-model="vm.inspectorDetails.contactNo"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectorDetails.inspectorEmail" for="field_inspectorEmail">Inspector Email</label><input type="text" class="form-control" name="inspectorEmail" id="field_inspectorEmail" ng-model="vm.inspectorDetails.inspectorEmail"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectorDetails.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.inspectorDetails.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectorDetails.inspectorService" for="field_inspectorService">Inspector Service</label><input type="text" class="form-control" name="inspectorService" id="field_inspectorService" ng-model="vm.inspectorDetails.inspectorService"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.inspectorDetails.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.inspectorDetails.serviceId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/inspector-details/inspector-details.html','<div><h2 data-translate="investhryApp.inspectorDetails.home.title">Inspector Details</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="inspector-details.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.inspectorDetails.home.createLabel">Create new Inspector Details</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.inspectorDetails.inspectorId">Inspector Id</span></th><th><span data-translate="investhryApp.inspectorDetails.inspectorName">Inspector Name</span></th><th><span data-translate="investhryApp.inspectorDetails.estateName">Estate Name</span></th><th><span data-translate="investhryApp.inspectorDetails.districtName">District Name</span></th><th><span data-translate="investhryApp.inspectorDetails.contactNo">Contact No</span></th><th><span data-translate="investhryApp.inspectorDetails.inspectorEmail">Inspector Email</span></th><th><span data-translate="investhryApp.inspectorDetails.departmentName">Department Name</span></th><th><span data-translate="investhryApp.inspectorDetails.inspectorService">Inspector Service</span></th><th><span data-translate="investhryApp.inspectorDetails.serviceId">Service Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="inspectorDetails in vm.inspectorDetails track by inspectorDetails.id"><td><a ui-sref="inspector-details-detail({id:inspectorDetails.id})">{{inspectorDetails.id}}</a></td><td>{{inspectorDetails.inspectorId}}</td><td>{{inspectorDetails.inspectorName}}</td><td>{{inspectorDetails.estateName}}</td><td>{{inspectorDetails.districtName}}</td><td>{{inspectorDetails.contactNo}}</td><td>{{inspectorDetails.inspectorEmail}}</td><td>{{inspectorDetails.departmentName}}</td><td>{{inspectorDetails.inspectorService}}</td><td>{{inspectorDetails.serviceId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="inspector-details-detail({id:inspectorDetails.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="inspector-details.edit({id:inspectorDetails.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="inspector-details.delete({id:inspectorDetails.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/investor/investor-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.investor.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.investor.delete.question" translate-values="{id: \'{{vm.investor.id}}\'}">Are you sure you want to delete this Investor?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/investor/investor-detail.html','<div><h2><span data-translate="investhryApp.investor.detail.title">Investor</span> {{vm.investor.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.investor.mouapplicable">Mouapplicable</span></dt><dd><span>{{vm.investor.mouapplicable}}</span></dd><dt><span data-translate="investhryApp.investor.mousignyear">Mousignyear</span></dt><dd><span>{{vm.investor.mousignyear}}</span></dd><dt><span data-translate="investhryApp.investor.mouidnumber">Mouidnumber</span></dt><dd><span>{{vm.investor.mouidnumber}}</span></dd><dt><span data-translate="investhryApp.investor.firstname">Firstname</span></dt><dd><span>{{vm.investor.firstname}}</span></dd><dt><span data-translate="investhryApp.investor.middlename">Middlename</span></dt><dd><span>{{vm.investor.middlename}}</span></dd><dt><span data-translate="investhryApp.investor.lastname">Lastname</span></dt><dd><span>{{vm.investor.lastname}}</span></dd><dt><span data-translate="investhryApp.investor.address1">Address 1</span></dt><dd><span>{{vm.investor.address1}}</span></dd><dt><span data-translate="investhryApp.investor.address2">Address 2</span></dt><dd><span>{{vm.investor.address2}}</span></dd><dt><span data-translate="investhryApp.investor.address3">Address 3</span></dt><dd><span>{{vm.investor.address3}}</span></dd><dt><span data-translate="investhryApp.investor.emailprimary">Emailprimary</span></dt><dd><span>{{vm.investor.emailprimary}}</span></dd><dt><span data-translate="investhryApp.investor.emailsecondary">Emailsecondary</span></dt><dd><span>{{vm.investor.emailsecondary}}</span></dd><dt><span data-translate="investhryApp.investor.userlogin">Userlogin</span></dt><dd><span>{{vm.investor.userlogin}}</span></dd><dt><span data-translate="investhryApp.investor.cityname">Cityname</span></dt><dd><span>{{vm.investor.cityname}}</span></dd><dt><span data-translate="investhryApp.investor.countryname">Countryname</span></dt><dd><span>{{vm.investor.countryname}}</span></dd><dt><span data-translate="investhryApp.investor.statename">Statename</span></dt><dd><span>{{vm.investor.statename}}</span></dd><dt><span data-translate="investhryApp.investor.createdate">Createdate</span></dt><dd><span>{{vm.investor.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.investor.updatedate">Updatedate</span></dt><dd><span>{{vm.investor.updatedate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.investor.cafpin">Cafpin</span></dt><dd><span>{{vm.investor.cafpin}}</span></dd><dt><span data-translate="investhryApp.investor.pincode">Pincode</span></dt><dd><span>{{vm.investor.pincode}}</span></dd><dt><span data-translate="investhryApp.investor.phonenumber">Phonenumber</span></dt><dd><span>{{vm.investor.phonenumber}}</span></dd><dt><span data-translate="investhryApp.investor.mobilenumber">Mobilenumber</span></dt><dd><span>{{vm.investor.mobilenumber}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="investor-detail.edit({id:vm.investor.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/investor/investor-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myInvestorLabel" data-translate="investhryApp.investor.home.createOrEditLabel">Create or edit a Investor</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.investor.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.investor.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.mouapplicable" for="field_mouapplicable">Mouapplicable</label><input type="checkbox" class="form-control" name="mouapplicable" id="field_mouapplicable" ng-model="vm.investor.mouapplicable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.mousignyear" for="field_mousignyear">Mousignyear</label><input type="number" class="form-control" name="mousignyear" id="field_mousignyear" ng-model="vm.investor.mousignyear"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.mouidnumber" for="field_mouidnumber">Mouidnumber</label><input type="text" class="form-control" name="mouidnumber" id="field_mouidnumber" ng-model="vm.investor.mouidnumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.firstname" for="field_firstname">Firstname</label><input type="text" class="form-control" name="firstname" id="field_firstname" ng-model="vm.investor.firstname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.middlename" for="field_middlename">Middlename</label><input type="text" class="form-control" name="middlename" id="field_middlename" ng-model="vm.investor.middlename"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.lastname" for="field_lastname">Lastname</label><input type="text" class="form-control" name="lastname" id="field_lastname" ng-model="vm.investor.lastname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.address1" for="field_address1">Address 1</label><input type="text" class="form-control" name="address1" id="field_address1" ng-model="vm.investor.address1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.address2" for="field_address2">Address 2</label><input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.investor.address2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.address3" for="field_address3">Address 3</label><input type="text" class="form-control" name="address3" id="field_address3" ng-model="vm.investor.address3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.emailprimary" for="field_emailprimary">Emailprimary</label><input type="text" class="form-control" name="emailprimary" id="field_emailprimary" ng-model="vm.investor.emailprimary"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.emailsecondary" for="field_emailsecondary">Emailsecondary</label><input type="text" class="form-control" name="emailsecondary" id="field_emailsecondary" ng-model="vm.investor.emailsecondary"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.userlogin" for="field_userlogin">Userlogin</label><input type="text" class="form-control" name="userlogin" id="field_userlogin" ng-model="vm.investor.userlogin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.cityname" for="field_cityname">Cityname</label><input type="text" class="form-control" name="cityname" id="field_cityname" ng-model="vm.investor.cityname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.countryname" for="field_countryname">Countryname</label><input type="text" class="form-control" name="countryname" id="field_countryname" ng-model="vm.investor.countryname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.statename" for="field_statename">Statename</label><input type="text" class="form-control" name="statename" id="field_statename" ng-model="vm.investor.statename"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.investor.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.investor.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.investor.cafpin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.pincode" for="field_pincode">Pincode</label><input type="text" class="form-control" name="pincode" id="field_pincode" ng-model="vm.investor.pincode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.phonenumber" for="field_phonenumber">Phonenumber</label><input type="text" class="form-control" name="phonenumber" id="field_phonenumber" ng-model="vm.investor.phonenumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.investor.mobilenumber" for="field_mobilenumber">Mobilenumber</label><input type="text" class="form-control" name="mobilenumber" id="field_mobilenumber" ng-model="vm.investor.mobilenumber"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/investor/investors.html','<div><h2 data-translate="investhryApp.investor.home.title">Investors</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="investor.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.investor.home.createLabel">Create new Investor</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.investor.mouapplicable">Mouapplicable</span></th><th><span data-translate="investhryApp.investor.mousignyear">Mousignyear</span></th><th><span data-translate="investhryApp.investor.mouidnumber">Mouidnumber</span></th><th><span data-translate="investhryApp.investor.firstname">Firstname</span></th><th><span data-translate="investhryApp.investor.middlename">Middlename</span></th><th><span data-translate="investhryApp.investor.lastname">Lastname</span></th><th><span data-translate="investhryApp.investor.address1">Address 1</span></th><th><span data-translate="investhryApp.investor.address2">Address 2</span></th><th><span data-translate="investhryApp.investor.address3">Address 3</span></th><th><span data-translate="investhryApp.investor.emailprimary">Emailprimary</span></th><th><span data-translate="investhryApp.investor.emailsecondary">Emailsecondary</span></th><th><span data-translate="investhryApp.investor.userlogin">Userlogin</span></th><th><span data-translate="investhryApp.investor.cityname">Cityname</span></th><th><span data-translate="investhryApp.investor.countryname">Countryname</span></th><th><span data-translate="investhryApp.investor.statename">Statename</span></th><th><span data-translate="investhryApp.investor.createdate">Createdate</span></th><th><span data-translate="investhryApp.investor.updatedate">Updatedate</span></th><th><span data-translate="investhryApp.investor.cafpin">Cafpin</span></th><th><span data-translate="investhryApp.investor.pincode">Pincode</span></th><th><span data-translate="investhryApp.investor.phonenumber">Phonenumber</span></th><th><span data-translate="investhryApp.investor.mobilenumber">Mobilenumber</span></th><th></th></tr></thead><tbody><tr ng-repeat="investor in vm.investors track by investor.id"><td><a ui-sref="investor-detail({id:investor.id})">{{investor.id}}</a></td><td>{{investor.mouapplicable}}</td><td>{{investor.mousignyear}}</td><td>{{investor.mouidnumber}}</td><td>{{investor.firstname}}</td><td>{{investor.middlename}}</td><td>{{investor.lastname}}</td><td>{{investor.address1}}</td><td>{{investor.address2}}</td><td>{{investor.address3}}</td><td>{{investor.emailprimary}}</td><td>{{investor.emailsecondary}}</td><td>{{investor.userlogin}}</td><td>{{investor.cityname}}</td><td>{{investor.countryname}}</td><td>{{investor.statename}}</td><td>{{investor.createdate | date:\'medium\'}}</td><td>{{investor.updatedate | date:\'medium\'}}</td><td>{{investor.cafpin}}</td><td>{{investor.pincode}}</td><td>{{investor.phonenumber}}</td><td>{{investor.mobilenumber}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="investor-detail({id:investor.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="investor.edit({id:investor.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="investor.delete({id:investor.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/landexchange/landexchange-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.landexchange.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.landexchange.delete.question" translate-values="{id: \'{{vm.landexchange.id}}\'}">Are you sure you want to delete this Landexchange?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/landexchange/landexchange-detail.html','<div><h2><span data-translate="investhryApp.landexchange.detail.title">Landexchange</span> {{vm.landexchange.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.landexchange.investor_name">Investor Name</span></dt><dd><span>{{vm.landexchange.investor_name}}</span></dd><dt><span data-translate="investhryApp.landexchange.address">Address</span></dt><dd><span>{{vm.landexchange.address}}</span></dd><dt><span data-translate="investhryApp.landexchange.contact">Contact</span></dt><dd><span>{{vm.landexchange.contact}}</span></dd><dt><span data-translate="investhryApp.landexchange.reason">Reason</span></dt><dd><span>{{vm.landexchange.reason}}</span></dd><dt><span data-translate="investhryApp.landexchange.owner_name">Owner Name</span></dt><dd><span>{{vm.landexchange.owner_name}}</span></dd><dt><span data-translate="investhryApp.landexchange.tehsil">Tehsil</span></dt><dd><span>{{vm.landexchange.tehsil}}</span></dd><dt><span data-translate="investhryApp.landexchange.block">Block</span></dt><dd><span>{{vm.landexchange.block}}</span></dd><dt><span data-translate="investhryApp.landexchange.village">Village</span></dt><dd><span>{{vm.landexchange.village}}</span></dd><dt><span data-translate="investhryApp.landexchange.khasra">Khasra</span></dt><dd><span>{{vm.landexchange.khasra}}</span></dd><dt><span data-translate="investhryApp.landexchange.area_of_land">Area Of Land</span></dt><dd><span>{{vm.landexchange.area_of_land}}</span></dd><dt><span data-translate="investhryApp.landexchange.market_value">Market Value</span></dt><dd><span>{{vm.landexchange.market_value}}</span></dd><dt><span data-translate="investhryApp.landexchange.owner_name_offered">Owner Name Offered</span></dt><dd><span>{{vm.landexchange.owner_name_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.tehsil_offered">Tehsil Offered</span></dt><dd><span>{{vm.landexchange.tehsil_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.block_offered">Block Offered</span></dt><dd><span>{{vm.landexchange.block_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.village_offered">Village Offered</span></dt><dd><span>{{vm.landexchange.village_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.khasra_offered">Khasra Offered</span></dt><dd><span>{{vm.landexchange.khasra_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.area_of_land_offered">Area Of Land Offered</span></dt><dd><span>{{vm.landexchange.area_of_land_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.market_value_offered">Market Value Offered</span></dt><dd><span>{{vm.landexchange.market_value_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.email">Email</span></dt><dd><span>{{vm.landexchange.email}}</span></dd><dt><span data-translate="investhryApp.landexchange.name_of_gramPanchayat">Name Of Gram Panchayat</span></dt><dd><span>{{vm.landexchange.name_of_gramPanchayat}}</span></dd><dt><span data-translate="investhryApp.landexchange.district">District</span></dt><dd><span>{{vm.landexchange.district}}</span></dd><dt><span data-translate="investhryApp.landexchange.type_of_land">Type Of Land</span></dt><dd><span>{{vm.landexchange.type_of_land}}</span></dd><dt><span data-translate="investhryApp.landexchange.district_offered">District Offered</span></dt><dd><span>{{vm.landexchange.district_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.type_of_land_offered">Type Of Land Offered</span></dt><dd><span>{{vm.landexchange.type_of_land_offered}}</span></dd><dt><span data-translate="investhryApp.landexchange.dimension_of_site">Dimension Of Site</span></dt><dd><span>{{vm.landexchange.dimension_of_site}}</span></dd><dt><span data-translate="investhryApp.landexchange.location_of_site">Location Of Site</span></dt><dd><span>{{vm.landexchange.location_of_site}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="landexchange-detail.edit({id:vm.landexchange.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/landexchange/landexchange-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLandexchangeLabel" data-translate="investhryApp.landexchange.home.createOrEditLabel">Create or edit a Landexchange</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.landexchange.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.landexchange.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.investor_name" for="field_investor_name">Investor Name</label><input type="text" class="form-control" name="investor_name" id="field_investor_name" ng-model="vm.landexchange.investor_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.address" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.landexchange.address"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.contact" for="field_contact">Contact</label><input type="text" class="form-control" name="contact" id="field_contact" ng-model="vm.landexchange.contact"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.reason" for="field_reason">Reason</label><input type="text" class="form-control" name="reason" id="field_reason" ng-model="vm.landexchange.reason"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.owner_name" for="field_owner_name">Owner Name</label><input type="text" class="form-control" name="owner_name" id="field_owner_name" ng-model="vm.landexchange.owner_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.tehsil" for="field_tehsil">Tehsil</label><input type="text" class="form-control" name="tehsil" id="field_tehsil" ng-model="vm.landexchange.tehsil"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.block" for="field_block">Block</label><input type="text" class="form-control" name="block" id="field_block" ng-model="vm.landexchange.block"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.village" for="field_village">Village</label><input type="text" class="form-control" name="village" id="field_village" ng-model="vm.landexchange.village"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.khasra" for="field_khasra">Khasra</label><input type="text" class="form-control" name="khasra" id="field_khasra" ng-model="vm.landexchange.khasra"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.area_of_land" for="field_area_of_land">Area Of Land</label><input type="text" class="form-control" name="area_of_land" id="field_area_of_land" ng-model="vm.landexchange.area_of_land"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.market_value" for="field_market_value">Market Value</label><input type="text" class="form-control" name="market_value" id="field_market_value" ng-model="vm.landexchange.market_value"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.owner_name_offered" for="field_owner_name_offered">Owner Name Offered</label><input type="text" class="form-control" name="owner_name_offered" id="field_owner_name_offered" ng-model="vm.landexchange.owner_name_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.tehsil_offered" for="field_tehsil_offered">Tehsil Offered</label><input type="text" class="form-control" name="tehsil_offered" id="field_tehsil_offered" ng-model="vm.landexchange.tehsil_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.block_offered" for="field_block_offered">Block Offered</label><input type="text" class="form-control" name="block_offered" id="field_block_offered" ng-model="vm.landexchange.block_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.village_offered" for="field_village_offered">Village Offered</label><input type="text" class="form-control" name="village_offered" id="field_village_offered" ng-model="vm.landexchange.village_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.khasra_offered" for="field_khasra_offered">Khasra Offered</label><input type="text" class="form-control" name="khasra_offered" id="field_khasra_offered" ng-model="vm.landexchange.khasra_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.area_of_land_offered" for="field_area_of_land_offered">Area Of Land Offered</label><input type="text" class="form-control" name="area_of_land_offered" id="field_area_of_land_offered" ng-model="vm.landexchange.area_of_land_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.market_value_offered" for="field_market_value_offered">Market Value Offered</label><input type="text" class="form-control" name="market_value_offered" id="field_market_value_offered" ng-model="vm.landexchange.market_value_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.landexchange.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.name_of_gramPanchayat" for="field_name_of_gramPanchayat">Name Of Gram Panchayat</label><input type="text" class="form-control" name="name_of_gramPanchayat" id="field_name_of_gramPanchayat" ng-model="vm.landexchange.name_of_gramPanchayat"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.landexchange.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.type_of_land" for="field_type_of_land">Type Of Land</label><input type="text" class="form-control" name="type_of_land" id="field_type_of_land" ng-model="vm.landexchange.type_of_land"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.district_offered" for="field_district_offered">District Offered</label><input type="text" class="form-control" name="district_offered" id="field_district_offered" ng-model="vm.landexchange.district_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.type_of_land_offered" for="field_type_of_land_offered">Type Of Land Offered</label><input type="text" class="form-control" name="type_of_land_offered" id="field_type_of_land_offered" ng-model="vm.landexchange.type_of_land_offered"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.dimension_of_site" for="field_dimension_of_site">Dimension Of Site</label><input type="text" class="form-control" name="dimension_of_site" id="field_dimension_of_site" ng-model="vm.landexchange.dimension_of_site"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landexchange.location_of_site" for="field_location_of_site">Location Of Site</label><input type="text" class="form-control" name="location_of_site" id="field_location_of_site" ng-model="vm.landexchange.location_of_site"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/landexchange/landexchanges.html','<div><h2 data-translate="investhryApp.landexchange.home.title">Landexchanges</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="landexchange.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.landexchange.home.createLabel">Create new Landexchange</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.landexchange.investor_name">Investor Name</span></th><th><span data-translate="investhryApp.landexchange.address">Address</span></th><th><span data-translate="investhryApp.landexchange.contact">Contact</span></th><th><span data-translate="investhryApp.landexchange.reason">Reason</span></th><th><span data-translate="investhryApp.landexchange.owner_name">Owner Name</span></th><th><span data-translate="investhryApp.landexchange.tehsil">Tehsil</span></th><th><span data-translate="investhryApp.landexchange.block">Block</span></th><th><span data-translate="investhryApp.landexchange.village">Village</span></th><th><span data-translate="investhryApp.landexchange.khasra">Khasra</span></th><th><span data-translate="investhryApp.landexchange.area_of_land">Area Of Land</span></th><th><span data-translate="investhryApp.landexchange.market_value">Market Value</span></th><th><span data-translate="investhryApp.landexchange.owner_name_offered">Owner Name Offered</span></th><th><span data-translate="investhryApp.landexchange.tehsil_offered">Tehsil Offered</span></th><th><span data-translate="investhryApp.landexchange.block_offered">Block Offered</span></th><th><span data-translate="investhryApp.landexchange.village_offered">Village Offered</span></th><th><span data-translate="investhryApp.landexchange.khasra_offered">Khasra Offered</span></th><th><span data-translate="investhryApp.landexchange.area_of_land_offered">Area Of Land Offered</span></th><th><span data-translate="investhryApp.landexchange.market_value_offered">Market Value Offered</span></th><th><span data-translate="investhryApp.landexchange.email">Email</span></th><th><span data-translate="investhryApp.landexchange.name_of_gramPanchayat">Name Of Gram Panchayat</span></th><th><span data-translate="investhryApp.landexchange.district">District</span></th><th><span data-translate="investhryApp.landexchange.type_of_land">Type Of Land</span></th><th><span data-translate="investhryApp.landexchange.district_offered">District Offered</span></th><th><span data-translate="investhryApp.landexchange.type_of_land_offered">Type Of Land Offered</span></th><th><span data-translate="investhryApp.landexchange.dimension_of_site">Dimension Of Site</span></th><th><span data-translate="investhryApp.landexchange.location_of_site">Location Of Site</span></th><th></th></tr></thead><tbody><tr ng-repeat="landexchange in vm.landexchanges track by landexchange.id"><td><a ui-sref="landexchange-detail({id:landexchange.id})">{{landexchange.id}}</a></td><td>{{landexchange.investor_name}}</td><td>{{landexchange.address}}</td><td>{{landexchange.contact}}</td><td>{{landexchange.reason}}</td><td>{{landexchange.owner_name}}</td><td>{{landexchange.tehsil}}</td><td>{{landexchange.block}}</td><td>{{landexchange.village}}</td><td>{{landexchange.khasra}}</td><td>{{landexchange.area_of_land}}</td><td>{{landexchange.market_value}}</td><td>{{landexchange.owner_name_offered}}</td><td>{{landexchange.tehsil_offered}}</td><td>{{landexchange.block_offered}}</td><td>{{landexchange.village_offered}}</td><td>{{landexchange.khasra_offered}}</td><td>{{landexchange.area_of_land_offered}}</td><td>{{landexchange.market_value_offered}}</td><td>{{landexchange.email}}</td><td>{{landexchange.name_of_gramPanchayat}}</td><td>{{landexchange.district}}</td><td>{{landexchange.type_of_land}}</td><td>{{landexchange.district_offered}}</td><td>{{landexchange.type_of_land_offered}}</td><td>{{landexchange.dimension_of_site}}</td><td>{{landexchange.location_of_site}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="landexchange-detail({id:landexchange.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="landexchange.edit({id:landexchange.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="landexchange.delete({id:landexchange.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/landrequirementcaf/landrequirementcaf-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.landrequirementcaf.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.landrequirementcaf.delete.question" translate-values="{id: \'{{vm.landrequirementcaf.id}}\'}">Are you sure you want to delete this Landrequirementcaf?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/landrequirementcaf/landrequirementcaf-detail.html','<div><h2><span data-translate="investhryApp.landrequirementcaf.detail.title">Landrequirementcaf</span> {{vm.landrequirementcaf.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.landrequirementcaf.landrequired">Landrequired</span></dt><dd><span>{{vm.landrequirementcaf.landrequired}}</span></dd><dt><span data-translate="investhryApp.landrequirementcaf.plotsize">Plotsize</span></dt><dd><span>{{vm.landrequirementcaf.plotsize}}</span></dd><dt><span data-translate="investhryApp.landrequirementcaf.estatename">Estatename</span></dt><dd><span>{{vm.landrequirementcaf.estatename}}</span></dd><dt><span data-translate="investhryApp.landrequirementcaf.purchaserate">Purchaserate</span></dt><dd><span>{{vm.landrequirementcaf.purchaserate}}</span></dd><dt><span data-translate="investhryApp.landrequirementcaf.estatelocation">Estatelocation</span></dt><dd><span>{{vm.landrequirementcaf.estatelocation}}</span></dd><dt><span data-translate="investhryApp.landrequirementcaf.agencyname">Agencyname</span></dt><dd><span>{{vm.landrequirementcaf.agencyname}}</span></dd><dt><span data-translate="investhryApp.landrequirementcaf.village">Village</span></dt><dd><span>{{vm.landrequirementcaf.village}}</span></dd><dt><span data-translate="investhryApp.landrequirementcaf.tehsil">Tehsil</span></dt><dd><span>{{vm.landrequirementcaf.tehsil}}</span></dd><dt><span data-translate="investhryApp.landrequirementcaf.district">District</span></dt><dd><span>{{vm.landrequirementcaf.district}}</span></dd><dt><span data-translate="investhryApp.landrequirementcaf.landusetype">Landusetype</span></dt><dd><span>{{vm.landrequirementcaf.landusetype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="landrequirementcaf-detail.edit({id:vm.landrequirementcaf.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/landrequirementcaf/landrequirementcaf-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLandrequirementcafLabel" data-translate="investhryApp.landrequirementcaf.home.createOrEditLabel">Create or edit a Landrequirementcaf</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.landrequirementcaf.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.landrequirementcaf.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landrequirementcaf.landrequired" for="field_landrequired">Landrequired</label><input type="text" class="form-control" name="landrequired" id="field_landrequired" ng-model="vm.landrequirementcaf.landrequired"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landrequirementcaf.plotsize" for="field_plotsize">Plotsize</label><input type="text" class="form-control" name="plotsize" id="field_plotsize" ng-model="vm.landrequirementcaf.plotsize"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landrequirementcaf.estatename" for="field_estatename">Estatename</label><input type="text" class="form-control" name="estatename" id="field_estatename" ng-model="vm.landrequirementcaf.estatename"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landrequirementcaf.purchaserate" for="field_purchaserate">Purchaserate</label><input type="text" class="form-control" name="purchaserate" id="field_purchaserate" ng-model="vm.landrequirementcaf.purchaserate"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landrequirementcaf.estatelocation" for="field_estatelocation">Estatelocation</label><input type="text" class="form-control" name="estatelocation" id="field_estatelocation" ng-model="vm.landrequirementcaf.estatelocation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landrequirementcaf.agencyname" for="field_agencyname">Agencyname</label><input type="text" class="form-control" name="agencyname" id="field_agencyname" ng-model="vm.landrequirementcaf.agencyname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landrequirementcaf.village" for="field_village">Village</label><input type="text" class="form-control" name="village" id="field_village" ng-model="vm.landrequirementcaf.village"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landrequirementcaf.tehsil" for="field_tehsil">Tehsil</label><input type="text" class="form-control" name="tehsil" id="field_tehsil" ng-model="vm.landrequirementcaf.tehsil"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landrequirementcaf.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.landrequirementcaf.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landrequirementcaf.landusetype" for="field_landusetype">Landusetype</label><input type="text" class="form-control" name="landusetype" id="field_landusetype" ng-model="vm.landrequirementcaf.landusetype"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/landrequirementcaf/landrequirementcafs.html','<div><h2 data-translate="investhryApp.landrequirementcaf.home.title">Landrequirementcafs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="landrequirementcaf.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.landrequirementcaf.home.createLabel">Create new Landrequirementcaf</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.landrequirementcaf.landrequired">Landrequired</span></th><th><span data-translate="investhryApp.landrequirementcaf.plotsize">Plotsize</span></th><th><span data-translate="investhryApp.landrequirementcaf.estatename">Estatename</span></th><th><span data-translate="investhryApp.landrequirementcaf.purchaserate">Purchaserate</span></th><th><span data-translate="investhryApp.landrequirementcaf.estatelocation">Estatelocation</span></th><th><span data-translate="investhryApp.landrequirementcaf.agencyname">Agencyname</span></th><th><span data-translate="investhryApp.landrequirementcaf.village">Village</span></th><th><span data-translate="investhryApp.landrequirementcaf.tehsil">Tehsil</span></th><th><span data-translate="investhryApp.landrequirementcaf.district">District</span></th><th><span data-translate="investhryApp.landrequirementcaf.landusetype">Landusetype</span></th><th></th></tr></thead><tbody><tr ng-repeat="landrequirementcaf in vm.landrequirementcafs track by landrequirementcaf.id"><td><a ui-sref="landrequirementcaf-detail({id:landrequirementcaf.id})">{{landrequirementcaf.id}}</a></td><td>{{landrequirementcaf.landrequired}}</td><td>{{landrequirementcaf.plotsize}}</td><td>{{landrequirementcaf.estatename}}</td><td>{{landrequirementcaf.purchaserate}}</td><td>{{landrequirementcaf.estatelocation}}</td><td>{{landrequirementcaf.agencyname}}</td><td>{{landrequirementcaf.village}}</td><td>{{landrequirementcaf.tehsil}}</td><td>{{landrequirementcaf.district}}</td><td>{{landrequirementcaf.landusetype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="landrequirementcaf-detail({id:landrequirementcaf.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="landrequirementcaf.edit({id:landrequirementcaf.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="landrequirementcaf.delete({id:landrequirementcaf.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/landusezoneclassification/landusezoneclassification-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.landusezoneclassification.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.landusezoneclassification.delete.question" translate-values="{id: \'{{vm.landusezoneclassification.id}}\'}">Are you sure you want to delete this Landusezoneclassification?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/landusezoneclassification/landusezoneclassification-detail.html','<div class="container"><h2><span data-translate="investhryApp.landusezoneclassification.detail.title">Landusezoneclassification</span> {{vm.landusezoneclassification.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.landusezoneclassification.landzoneclassificationtype">Landzoneclassificationtype</span></dt><dd><span>{{vm.landusezoneclassification.landzoneclassificationtype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="landusezoneclassification-detail.edit({id:vm.landusezoneclassification.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/landusezoneclassification/landusezoneclassification-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myLandusezoneclassificationLabel" data-translate="investhryApp.landusezoneclassification.home.createOrEditLabel">Create or edit a Landusezoneclassification</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.landusezoneclassification.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.landusezoneclassification.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.landusezoneclassification.landzoneclassificationtype" for="field_landzoneclassificationtype">Landzoneclassificationtype</label><input type="text" class="form-control" name="landzoneclassificationtype" id="field_landzoneclassificationtype" ng-model="vm.landusezoneclassification.landzoneclassificationtype" required><div ng-show="editForm.landzoneclassificationtype.$invalid"><p class="help-block" ng-show="editForm.landzoneclassificationtype.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/landusezoneclassification/landusezoneclassifications.html','<div class="container"><h2 data-translate="investhryApp.landusezoneclassification.home.title">Landusezoneclassifications</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="landusezoneclassification.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.landusezoneclassification.home.createLabel">Create new Landusezoneclassification</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.landusezoneclassification.landzoneclassificationtype">Landzoneclassificationtype</span></th><th></th></tr></thead><tbody><tr ng-repeat="landusezoneclassification in vm.landusezoneclassifications track by landusezoneclassification.id"><td><a ui-sref="landusezoneclassification-detail({id:landusezoneclassification.id})">{{landusezoneclassification.id}}</a></td><td>{{landusezoneclassification.landzoneclassificationtype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="landusezoneclassification-detail({id:landusezoneclassification.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="landusezoneclassification.edit({id:landusezoneclassification.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="landusezoneclassification.delete({id:landusezoneclassification.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/manufacturingdetail/manufacturingdetail-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.manufacturingdetail.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.manufacturingdetail.delete.question" translate-values="{id: \'{{vm.manufacturingdetail.id}}\'}">Are you sure you want to delete this Manufacturingdetail?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/manufacturingdetail/manufacturingdetail-detail.html','<div class="container"><h2><span data-translate="investhryApp.manufacturingdetail.detail.title">Manufacturingdetail</span> {{vm.manufacturingdetail.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.manufacturingdetail.projectid">Projectid</span></dt><dd><span>{{vm.manufacturingdetail.projectid}}</span></dd><dt><span data-translate="investhryApp.manufacturingdetail.projectrawmaterialid">Projectrawmaterialid</span></dt><dd><span>{{vm.manufacturingdetail.projectrawmaterialid}}</span></dd><dt><span data-translate="investhryApp.manufacturingdetail.productid">Productid</span></dt><dd><span>{{vm.manufacturingdetail.productid}}</span></dd><dt><span data-translate="investhryApp.manufacturingdetail.processid">Processid</span></dt><dd><span>{{vm.manufacturingdetail.processid}}</span></dd><dt><span data-translate="investhryApp.manufacturingdetail.manufacturing_flow_document">Manufacturing Flow Document</span></dt><dd><span>{{vm.manufacturingdetail.manufacturing_flow_document}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="manufacturingdetail-detail.edit({id:vm.manufacturingdetail.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/manufacturingdetail/manufacturingdetail-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myManufacturingdetailLabel" data-translate="investhryApp.manufacturingdetail.home.createOrEditLabel">Create or edit a Manufacturingdetail</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.manufacturingdetail.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.manufacturingdetail.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.manufacturingdetail.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.manufacturingdetail.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.manufacturingdetail.projectrawmaterialid" for="field_projectrawmaterialid">Projectrawmaterialid</label><input type="text" class="form-control" name="projectrawmaterialid" id="field_projectrawmaterialid" ng-model="vm.manufacturingdetail.projectrawmaterialid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.manufacturingdetail.productid" for="field_productid">Productid</label><input type="text" class="form-control" name="productid" id="field_productid" ng-model="vm.manufacturingdetail.productid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.manufacturingdetail.processid" for="field_processid">Processid</label><input type="text" class="form-control" name="processid" id="field_processid" ng-model="vm.manufacturingdetail.processid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.manufacturingdetail.manufacturing_flow_document" for="field_manufacturing_flow_document">Manufacturing Flow Document</label><input type="text" class="form-control" name="manufacturing_flow_document" id="field_manufacturing_flow_document" ng-model="vm.manufacturingdetail.manufacturing_flow_document"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/manufacturingdetail/manufacturingdetails.html','<div class="container"><h2 data-translate="investhryApp.manufacturingdetail.home.title">Manufacturingdetails</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="manufacturingdetail.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.manufacturingdetail.home.createLabel">Create new Manufacturingdetail</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.manufacturingdetail.projectid">Projectid</span></th><th><span data-translate="investhryApp.manufacturingdetail.projectrawmaterialid">Projectrawmaterialid</span></th><th><span data-translate="investhryApp.manufacturingdetail.productid">Productid</span></th><th><span data-translate="investhryApp.manufacturingdetail.processid">Processid</span></th><th><span data-translate="investhryApp.manufacturingdetail.manufacturing_flow_document">Manufacturing Flow Document</span></th><th></th></tr></thead><tbody><tr ng-repeat="manufacturingdetail in vm.manufacturingdetails track by manufacturingdetail.id"><td><a ui-sref="manufacturingdetail-detail({id:manufacturingdetail.id})">{{manufacturingdetail.id}}</a></td><td>{{manufacturingdetail.projectid}}</td><td>{{manufacturingdetail.projectrawmaterialid}}</td><td>{{manufacturingdetail.productid}}</td><td>{{manufacturingdetail.processid}}</td><td>{{manufacturingdetail.manufacturing_flow_document}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="manufacturingdetail-detail({id:manufacturingdetail.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="manufacturingdetail.edit({id:manufacturingdetail.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="manufacturingdetail.delete({id:manufacturingdetail.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/manufacturingunits/manufacturingunits-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.manufacturingunits.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.manufacturingunits.delete.question" translate-values="{id: \'{{vm.manufacturingunits.id}}\'}">Are you sure you want to delete this Manufacturingunits?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/manufacturingunits/manufacturingunits-detail.html','<div class="container"><h2><span data-translate="investhryApp.manufacturingunits.detail.title">Manufacturingunits</span> {{vm.manufacturingunits.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.manufacturingunits.unittypes">Unittypes</span></dt><dd><span>{{vm.manufacturingunits.unittypes}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="manufacturingunits-detail.edit({id:vm.manufacturingunits.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/manufacturingunits/manufacturingunits-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myManufacturingunitsLabel" data-translate="investhryApp.manufacturingunits.home.createOrEditLabel">Create or edit a Manufacturingunits</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.manufacturingunits.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.manufacturingunits.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.manufacturingunits.unittypes" for="field_unittypes">Unittypes</label><input type="text" class="form-control" name="unittypes" id="field_unittypes" ng-model="vm.manufacturingunits.unittypes" required><div ng-show="editForm.unittypes.$invalid"><p class="help-block" ng-show="editForm.unittypes.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/manufacturingunits/manufacturingunits.html','<div class="container"><h2 data-translate="investhryApp.manufacturingunits.home.title">Manufacturingunits</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="manufacturingunits.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.manufacturingunits.home.createLabel">Create new Manufacturingunits</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.manufacturingunits.unittypes">Unittypes</span></th><th></th></tr></thead><tbody><tr ng-repeat="manufacturingunits in vm.manufacturingunits track by manufacturingunits.id"><td><a ui-sref="manufacturingunits-detail({id:manufacturingunits.id})">{{manufacturingunits.id}}</a></td><td>{{manufacturingunits.unittypes}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="manufacturingunits-detail({id:manufacturingunits.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="manufacturingunits.edit({id:manufacturingunits.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="manufacturingunits.delete({id:manufacturingunits.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/meeting-attendance/meeting-attendance-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.meeting_attendance.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.meeting_attendance.delete.question" translate-values="{id: \'{{vm.meeting_attendance.id}}\'}">Are you sure you want to delete this Meeting Attendance?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/meeting-attendance/meeting-attendance-detail.html','<div><h2><span data-translate="investhryApp.meeting_attendance.detail.title">Meeting Attendance</span> {{vm.meeting_attendance.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.meeting_attendance.attendee_id">Attendee Id</span></dt><dd><span>{{vm.meeting_attendance.attendee_id}}</span></dd><dt><span data-translate="investhryApp.meeting_attendance.meeting_date">Meeting Date</span></dt><dd><span>{{vm.meeting_attendance.meeting_date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.meeting_attendance.ispresent">Ispresent</span></dt><dd><span>{{vm.meeting_attendance.ispresent}}</span></dd><dt><span data-translate="investhryApp.meeting_attendance.isinvited">Isinvited</span></dt><dd><span>{{vm.meeting_attendance.isinvited}}</span></dd><dt><span data-translate="investhryApp.meeting_attendance.attendee_name">Attendee Name</span></dt><dd><span>{{vm.meeting_attendance.attendee_name}}</span></dd><dt><span data-translate="investhryApp.meeting_attendance.department">Department</span></dt><dd><span>{{vm.meeting_attendance.department}}</span></dd><dt><span data-translate="investhryApp.meeting_attendance.email_id">Email Id</span></dt><dd><span>{{vm.meeting_attendance.email_id}}</span></dd><dt><span data-translate="investhryApp.meeting_attendance.mobile_no">Mobile No</span></dt><dd><span>{{vm.meeting_attendance.mobile_no}}</span></dd><dt><span data-translate="investhryApp.meeting_attendance.team">Team</span></dt><dd><span>{{vm.meeting_attendance.team}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="meeting-attendance-detail.edit({id:vm.meeting_attendance.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/meeting-attendance/meeting-attendance-dialog.html','<form name="editForm" role="form" ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMeeting_attendanceLabel" data-translate="investhryApp.meeting_attendance.home.createOrEditLabel">Create or edit a Meeting Attendance</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--<div class="form-group" ng-show="vm.meeting_attendance.id">--><!--<label for="id" data-translate="global.field.id">ID</label>--><!--<input type="text" class="form-control" id="id" name="id"--><!--ng-model="vm.meeting_attendance.id" readonly />--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.meeting_attendance.attendee_id" for="field_attendee_id">Attendee Id</label>--><!--<input type="text" class="form-control" name="attendee_id" id="field_attendee_id"--><!--ng-model="vm.meeting_attendance.attendee_id"--><!--/>--><!--</div>--><div class="row"><div class="col-md-12"><div class="form-group"><div class="col-md-2 col-md-offset-2"><label class="control-label" data-translate="investhryApp.meeting_attendance.meeting_date" for="field_meeting_date">Meeting Date</label></div><div class="col-md-4 input-group"><input id="field_meeting_date" type="text" class="form-control" name="meeting_date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.meeting_attendance.meeting_date" is-open="vm.datePickerOpenStatus.meeting_date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'meeting_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><!--<div class="col-md-2 pull-right">--><!--<label class="control-label" for="select_all" style="margin-right: 15px;">All Present</label>--><!--<input type="checkbox" id="select_all" ng-click="toggleAll()" ng-model="isAllSelected" />--><!--</div>--></div></div></div><div class="row panel-body"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span>Attendee Name</span></th><th><span>Department</span></th><th><span>Mobile-No.</span></th><th><span>Email-Id</span></th><th><span>Team</span></th><!--<th><span >Is Invited</span></th>--><th><span>Is Present</span></th><th><span>On Leave</span></th><th><span>On Tour</span></th></tr></thead><tbody><tr ng-repeat="meeting_attendee in vm.meeting_attendees"><td>{{meeting_attendee.attendee_name}}</td><td>{{meeting_attendee.department}}</td><td>{{meeting_attendee.mobile_no}}</td><td>{{meeting_attendee.email_id}}</td><td>{{meeting_attendee.team}}</td><!--<td>--><!--<input type="checkbox" class="form-control" ng-checked="selction_invited.indexOf(meeting_attendee.id)"--><!--ng-click="toggleSelection_invited(meeting_attendee.id)"/>--><!--</td>--><td class="text-center"><input name="radio[{{$index}}]" type="checkbox" class="xyz form-group" ng-model="meeting_attendee.ispresent" ng-change="optionToggled(\'present\',$index)"></td><td class="text-center"><input name="radio[{{$index}}]" type="checkbox" class="xyz form-group" ng-model="meeting_attendee.onleave" ng-change="optionToggled(\'leave\',$index)"></td><td class="text-center"><input name="radio[{{$index}}]" type="checkbox" class="xyz form-group" ng-model="meeting_attendee.ontour" ng-change="optionToggled(\'tour\',$index)"></td></tr></tbody></table></div></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.meeting_attendance.ispresent" for="field_ispresent">Ispresent</label>--><!--<input type="checkbox" class="form-control" name="ispresent" id="field_ispresent"--><!--ng-model="vm.meeting_attendance.ispresent"--><!--/>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.meeting_attendance.isinvited" for="field_isinvited">Isinvited</label>--><!--<input type="checkbox" class="form-control" name="isinvited" id="field_isinvited"--><!--ng-model="vm.meeting_attendance.isinvited"--><!--/>--><!--</div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form><script>jQuery(function(){\n        jQuery(\'.xyz\').click(function(){\n            var group = "input:checkbox[name=\'"+$(this).prop("name")+"\']";\n            $(group).prop("checked",false);\n            $(this).prop("checked",true);\n        });\n    });</script>');
$templateCache.put('app/entities/meeting-attendance/meeting-attendances.html','<!--<div>--><!--<jhi-alert></jhi-alert>--><!--<div class="container">--><!--<div class="row">--><!--<div class="col-md-4 col-md-offset-2">--><!--<button class="uk-button uk-button-primary uk-button-large" style="font-size: 14px" ui-sref="meeting-attendance.new" >--><!--<span>--><!--Add a new meeting--><!--</span>--><!--</button>--><!--</div>--><!--</div>--><!--<div class="row">--><!--<br/>--><!--<div class="table-responsive">--><!--<table class="jh-table table table-striped">--><!--<thead>--><!--<tr>--><!--<th><span data-translate="global.field.id">ID</span></th>--><!--<th><span data-translate="investhryApp.meeting_attendance.attendee_id">Attendee Id</span></th>--><!--<th><span data-translate="investhryApp.meeting_attendance.meeting_date">Meeting Date</span></th>--><!--<th><span data-translate="investhryApp.meeting_attendance.ispresent">Ispresent</span></th>--><!--<th><span data-translate="investhryApp.meeting_attendance.isinvited">Isinvited</span></th>--><!--<th></th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat="meeting_attendance in vm.meeting_attendances track by meeting_attendance.id">--><!--<td><a ui-sref="meeting-attendance-detail({id:meeting_attendance.id})">{{meeting_attendance.id}}</a></td>--><!--<td>{{meeting_attendance.attendee_id}}</td>--><!--<td>{{meeting_attendance.meeting_date | date:\'mediumDate\'}}</td>--><!--<td>{{meeting_attendance.ispresent}}</td>--><!--<td>{{meeting_attendance.isinvited}}</td>--><!--<td class="text-right">--><!--<div class="btn-group flex-btn-group-container">--><!--<button type="submit"--><!--ui-sref="meeting-attendance-detail({id:meeting_attendance.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="meeting-attendance.edit({id:meeting_attendance.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="meeting-attendance.delete({id:meeting_attendance.id})"--><!--class="btn btn-danger btn-sm">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--><!--</button>--><!--</div>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><div class="container"><div class="row"><div class="col-md-12"><div class="col-md-8 card-body col-md-offset-2"><div class="row"><br><div has-authority="ROLE_DESK_OFFICER" class="text-center"><button class="uk-button uk-button-primary uk-button-large" style="font-size: 14px" ui-sref="meeting-attendance.new"><span>Add a New Meeting\'s Attendance</span></button></div><div class="modal-header"><h4 class="modal-title">Previous Meeting Attendances</h4></div><br></div><div class="row"><div class="col-md-8 col-md-offset-2"><div class="input-group"><span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'meeting_date\')"><i class="glyphicon glyphicon-calendar"></i></button> </span><input placeholder="Please Select Date of Meeting" id="field_meeting_date" type="text" class="form-control" name="meeting_date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.AttendanceDate" is-open="vm.datePickerOpenStatus.meeting_date"> <span class="input-group-btn"><button data-toggle="modal" data-target="#show_AttendanceByDate" type="button" class="btn btn-primary" ng-click="vm.AttendanceByDate()" ng-disabled="vm.AttendanceDate === \'empty\'">Show Attendance</button></span></div></div></div><br></div></div></div></div><div class="modal fade" id="show_AttendanceByDate" tabindex="-1" role="dialog" aria-labelledby="myModalLabel"><div class="modal-dialog modal-lg" role="document"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="myModalLabel">Attendance\'s of {{vm.AttendanceDate | date:\'mediumDate\'}}</h4></div><div class="modal-body"><div class=""><div class="col-md-2 pull-right"><select style="border: none; box-shadow: none" class="form-control" ng-change="toggle_attendance_function(toggle_attendance)" ng-model="toggle_attendance"><option value="present">Present</option><option value="absent">Absent</option><option value="leave">On Leave</option><option value="tour">On Tour</option></select></div><div class="col-md-2 filter-margin pull-right"><span class="uk-label" style="font-size: 12px">FILTER BY:</span></div><!--<ul class="nav nav-pills">--><!--<li class="active" data-toggle="pill" ng-click="toggle_attendance_function(\'present\')"><a>Present</a></li>--><!--<li data-toggle="pill" ng-click="toggle_attendance_function(\'absent\')"><a>Absent</a></li>--><!--</ul>--></div><table ng-show="toggle_attendance==\'present\'" class="jh-table table table-striped"><thead><tr><th><span>Attendee Name</span></th><th><span>Department</span></th><th><span>Mobile No</span></th><th><span>Email Id</span></th><th><span>Team</span></th></tr></thead><tbody><tr ng-repeat="meeting_attendee in vm.meeting_attendees" ng-show="meeting_attendee.ispresent"><td>{{meeting_attendee.attendee_name}}</td><td>{{meeting_attendee.department}}</td><td>{{meeting_attendee.mobile_no}}</td><td>{{meeting_attendee.email_id}}</td><td>{{meeting_attendee.team}}</td></tr></tbody></table><table ng-show="toggle_attendance==\'absent\'" class="jh-table table table-striped"><thead><tr><th><span>Attendee Name</span></th><th><span>Department</span></th><th><span>Mobile No</span></th><th><span>Email Id</span></th><th><span>Team</span></th></tr></thead><tbody><!--isinvited working as isabsent--><tr ng-repeat="meeting_attendee in vm.meeting_attendees" ng-show="meeting_attendee.isinvited"><td>{{meeting_attendee.attendee_name}}</td><td>{{meeting_attendee.department}}</td><td>{{meeting_attendee.mobile_no}}</td><td>{{meeting_attendee.email_id}}</td><td>{{meeting_attendee.team}}</td></tr></tbody></table><table ng-show="toggle_attendance==\'leave\'" class="jh-table table table-striped"><thead><tr><th><span>Attendee Name</span></th><th><span>Department</span></th><th><span>Mobile No</span></th><th><span>Email Id</span></th><th><span>Team</span></th></tr></thead><tbody><tr ng-repeat="meeting_attendee in vm.meeting_attendees" ng-show="meeting_attendee.onleave"><td>{{meeting_attendee.attendee_name}}</td><td>{{meeting_attendee.department}}</td><td>{{meeting_attendee.mobile_no}}</td><td>{{meeting_attendee.email_id}}</td><td>{{meeting_attendee.team}}</td></tr></tbody></table><table ng-show="toggle_attendance==\'tour\'" class="jh-table table table-striped"><thead><tr><th><span>Attendee Name</span></th><th><span>Department</span></th><th><span>Mobile No</span></th><th><span>Email Id</span></th><th><span>Team</span></th></tr></thead><tbody><tr ng-repeat="meeting_attendee in vm.meeting_attendees" ng-show="meeting_attendee.ontour"><td>{{meeting_attendee.attendee_name}}</td><td>{{meeting_attendee.department}}</td><td>{{meeting_attendee.mobile_no}}</td><td>{{meeting_attendee.email_id}}</td><td>{{meeting_attendee.team}}</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/entities/meeting-attendee/meeting-attendee-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.meeting_attendee.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.meeting_attendee.delete.question" translate-values="{id: \'{{vm.meeting_attendee.id}}\'}">Are you sure you want to delete this Meeting Attendee?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/meeting-attendee/meeting-attendee-detail.html','<div><h2><span data-translate="investhryApp.meeting_attendee.detail.title">Meeting Attendee</span> {{vm.meeting_attendee.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.meeting_attendee.attendee_name">Attendee Name</span></dt><dd><span>{{vm.meeting_attendee.attendee_name}}</span></dd><dt><span data-translate="investhryApp.meeting_attendee.department">Department</span></dt><dd><span>{{vm.meeting_attendee.department}}</span></dd><dt><span data-translate="investhryApp.meeting_attendee.mobile_no">Mobile No</span></dt><dd><span>{{vm.meeting_attendee.mobile_no}}</span></dd><dt><span data-translate="investhryApp.meeting_attendee.email_id">Email Id</span></dt><dd><span>{{vm.meeting_attendee.email_id}}</span></dd><dt><span data-translate="investhryApp.meeting_attendee.team">Team</span></dt><dd><span>{{vm.meeting_attendee.team}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="meeting-attendee-detail.edit({id:vm.meeting_attendee.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/meeting-attendee/meeting-attendee-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMeeting_attendeeLabel" data-translate="investhryApp.meeting_attendee.home.createOrEditLabel">Create or edit a Meeting Attendee</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.meeting_attendee.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.meeting_attendee.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.meeting_attendee.attendee_name" for="field_attendee_name">Attendee Name</label><input type="text" class="form-control" name="attendee_name" id="field_attendee_name" ng-model="vm.meeting_attendee.attendee_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.meeting_attendee.department" for="field_department">Department</label><input type="text" class="form-control" name="department" id="field_department" ng-model="vm.meeting_attendee.department"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.meeting_attendee.mobile_no" for="field_mobile_no">Mobile No</label><input type="text" class="form-control" name="mobile_no" id="field_mobile_no" ng-model="vm.meeting_attendee.mobile_no"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.meeting_attendee.email_id" for="field_email_id">Email Id</label><input type="text" class="form-control" name="email_id" id="field_email_id" ng-model="vm.meeting_attendee.email_id"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.meeting_attendee.team" for="field_team">Team</label><input type="text" class="form-control" name="team" id="field_team" ng-model="vm.meeting_attendee.team"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/meeting-attendee/meeting-attendees.html','<div><h2 data-translate="investhryApp.meeting_attendee.home.title">Meeting Attendees</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="meeting-attendee.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.meeting_attendee.home.createLabel">Create new Meeting Attendee</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.meeting_attendee.attendee_name">Attendee Name</span></th><th><span data-translate="investhryApp.meeting_attendee.department">Department</span></th><th><span data-translate="investhryApp.meeting_attendee.mobile_no">Mobile No</span></th><th><span data-translate="investhryApp.meeting_attendee.email_id">Email Id</span></th><th><span data-translate="investhryApp.meeting_attendee.team">Team</span></th><th></th></tr></thead><tbody><tr ng-repeat="meeting_attendee in vm.meeting_attendees track by meeting_attendee.id"><td><a ui-sref="meeting-attendee-detail({id:meeting_attendee.id})">{{meeting_attendee.id}}</a></td><td>{{meeting_attendee.attendee_name}}</td><td>{{meeting_attendee.department}}</td><td>{{meeting_attendee.mobile_no}}</td><td>{{meeting_attendee.email_id}}</td><td>{{meeting_attendee.team}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="meeting-attendee-detail({id:meeting_attendee.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="meeting-attendee.edit({id:meeting_attendee.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="meeting-attendee.delete({id:meeting_attendee.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/minutesofmeeting/minutesofmeeting-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.minutesofmeeting.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.minutesofmeeting.delete.question" translate-values="{id: \'{{vm.minutesofmeeting.id}}\'}">Are you sure you want to delete this Minutesofmeeting?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/minutesofmeeting/minutesofmeeting-detail.html','<div><h2><span data-translate="investhryApp.minutesofmeeting.detail.title">Minutesofmeeting</span> {{vm.minutesofmeeting.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.minutesofmeeting.momdescription">Momdescription</span></dt><dd><span>{{vm.minutesofmeeting.momdescription}}</span></dd><dt><span data-translate="investhryApp.minutesofmeeting.downloadfilename">Downloadfilename</span></dt><dd><span>{{vm.minutesofmeeting.downloadfilename}}</span></dd><dt><span data-translate="investhryApp.minutesofmeeting.serverfilename">Serverfilename</span></dt><dd><span>{{vm.minutesofmeeting.serverfilename}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="minutesofmeeting-detail.edit({id:vm.minutesofmeeting.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/minutesofmeeting/minutesofmeeting-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMinutesofmeetingLabel" data-translate="investhryApp.minutesofmeeting.home.createOrEditLabel">Create or edit a Minutesofmeeting</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.minutesofmeeting.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.minutesofmeeting.id" readonly="readonly"></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" data-translate="investhryApp.minutesofmeeting.momdescription" for="field_momdescription">Momdescription</label><input type="text" class="form-control" name="momdescription" id="field_momdescription" ng-model="vm.minutesofmeeting.momdescription" required ng-minlength="1" ng-maxlength="20"><div ng-show="editForm.momdescription.$invalid"><p class="help-block" ng-show="editForm.momdescription.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.momdescription.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.momdescription.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" data-translate="investhryApp.minutesofmeeting.meeting_type" for="meeting_type">Meeting Type</label><select class="form-control" name="meeting_type" id="meeting_type" ng-model="vm.minutesofmeeting.meeting_type" required><option value="" disabled="disabled">-- Select --</option><option value="HEPB">HEPB</option><option value="EEC">EEC</option></select></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="meeting_date">Meeting Date</label><div class="input-group"><input placeholder="Please Select Date of Meeting" id="meeting_date" type="text" class="form-control" name="meeting_date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.minutesofmeeting.date" is-open="vm.datePickerOpenStatus.meeting_date" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'meeting_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label">Select File *</label><input type="file" class="form-control" file-model="vm.mintuesofmeeting.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || vm.mintuesofmeeting.file==undefined || file.maxSizeError" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/minutesofmeeting/minutesofmeeting-edit.html','<form name="editForm" role="form" novalidate ng-submit="vm.update()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMinutesofmeetingLabel" data-translate="investhryApp.minutesofmeeting.home.createOrEditLabel">Create or edit a Minutesofmeeting</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><!--<div class="form-group" ng-show="vm.minutesofmeeting.id">--><!--<label for="id" data-translate="global.field.id">ID</label>--><!--<input type="text" class="form-control" id="id" name="id"--><!--ng-model="vm.minutesofmeeting.id" readonly />--><!--</div>--><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" data-translate="investhryApp.minutesofmeeting.momdescription" for="field_momdescription">Momdescription</label><input type="text" class="form-control" name="momdescription" id="field_momdescription" ng-model="vm.minutesofmeeting.momdescription" required ng-minlength="1" ng-maxlength="20"><div ng-show="editForm.momdescription.$invalid"><p class="help-block" ng-show="editForm.momdescription.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.momdescription.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="1">This field is required to be at least 1 characters.</p><p class="help-block" ng-show="editForm.momdescription.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="20">This field cannot be longer than 20 characters.</p></div></div></div></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" data-translate="investhryApp.minutesofmeeting.meeting_type" for="meeting_type">Meeting Type</label><select class="form-control" name="meeting_type" id="meeting_type" ng-model="vm.minutesofmeeting.meeting_type" required><option value="" disabled="disabled">-- Select --</option><option value="HEPB">HEPB</option><option value="EEC">EEC</option></select></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="meeting_date">Meeting Date</label><div class="input-group"><input placeholder="Please Select Date of Meeting" id="meeting_date" type="text" class="form-control" name="meeting_date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.minutesofmeeting.date" is-open="vm.datePickerOpenStatus.meeting_date" required readonly="readonly"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'meeting_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div></div><!--<div class="row">--><!--<div class="col-md-12">--><!--<div class="form-group">--><!--<label class="control-label">Select File *</label>--><!--<input type="file" class="form-control" file-Model="vm.mintuesofmeeting.file">--><!--<p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p>--><!--</div>--><!--</div>--><!--</div>--></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/minutesofmeeting/minutesofmeetings.html','<div class="container"><h2 data-translate="investhryApp.minutesofmeeting.home.title">Minutesofmeetings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="minutesofmeeting.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.minutesofmeeting.home.createLabel">Create new Minutesofmeeting</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><!--<th><span data-translate="global.field.id">ID</span></th>--><th><span data-translate="investhryApp.minutesofmeeting.momdescription">Momdescription</span></th><!--<th><span data-translate="investhryApp.minutesofmeeting.downloadfilename">Downloadfilename</span></th>--><th></th></tr></thead><tbody><tr ng-repeat="minutesofmeeting in vm.minutesofmeetings track by minutesofmeeting.id"><!--<td><a ui-sref="minutesofmeeting-detail({id:minutesofmeeting.id})">{{minutesofmeeting.id}}</a></td>--><td>{{minutesofmeeting.momdescription}}</td><!--<td>{{minutesofmeeting.downloadfilename}}</td>--><td class="text-right"><div class="btn-group flex-btn-group-container"><!--<button type="submit"--><!--ui-sref="minutesofmeeting-detail({id:minutesofmeeting.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--> <button type="submit" ui-sref="minutesofmeeting.edit({id:minutesofmeeting.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="minutesofmeeting.delete({id:minutesofmeeting.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/modeofdisposalfor-discharge/modeofdisposalfor-discharge-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.modeofdisposalfor_discharge.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.modeofdisposalfor_discharge.delete.question" translate-values="{id: \'{{vm.modeofdisposalfor_discharge.id}}\'}">Are you sure you want to delete this Modeofdisposalfor Discharge?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/modeofdisposalfor-discharge/modeofdisposalfor-discharge-detail.html','<div class="container"><h2><span data-translate="investhryApp.modeofdisposalfor_discharge.detail.title">Modeofdisposalfor Discharge</span> {{vm.modeofdisposalfor_discharge.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.modeofdisposalfor_discharge.disposal_for_discharge">Disposal For Discharge</span></dt><dd><span>{{vm.modeofdisposalfor_discharge.disposal_for_discharge}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="modeofdisposalfor-discharge-detail.edit({id:vm.modeofdisposalfor_discharge.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/modeofdisposalfor-discharge/modeofdisposalfor-discharge-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myModeofdisposalfor_dischargeLabel" data-translate="investhryApp.modeofdisposalfor_discharge.home.createOrEditLabel">Create or edit a Modeofdisposalfor Discharge</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.modeofdisposalfor_discharge.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.modeofdisposalfor_discharge.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.modeofdisposalfor_discharge.disposal_for_discharge" for="field_disposal_for_discharge">Disposal For Discharge</label><input type="text" class="form-control" name="disposal_for_discharge" id="field_disposal_for_discharge" ng-model="vm.modeofdisposalfor_discharge.disposal_for_discharge" required><div ng-show="editForm.disposal_for_discharge.$invalid"><p class="help-block" ng-show="editForm.disposal_for_discharge.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/modeofdisposalfor-discharge/modeofdisposalfor-discharges.html','<div class="container"><h2 data-translate="investhryApp.modeofdisposalfor_discharge.home.title">Modeofdisposalfor Discharges</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="modeofdisposalfor-discharge.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.modeofdisposalfor_discharge.home.createLabel">Create new Modeofdisposalfor Discharge</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.modeofdisposalfor_discharge.disposal_for_discharge">Disposal For Discharge</span></th><th></th></tr></thead><tbody><tr ng-repeat="modeofdisposalfor_discharge in vm.modeofdisposalfor_discharges track by modeofdisposalfor_discharge.id"><td><a ui-sref="modeofdisposalfor-discharge-detail({id:modeofdisposalfor_discharge.id})">{{modeofdisposalfor_discharge.id}}</a></td><td>{{modeofdisposalfor_discharge.disposal_for_discharge}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="modeofdisposalfor-discharge-detail({id:modeofdisposalfor_discharge.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="modeofdisposalfor-discharge.edit({id:modeofdisposalfor_discharge.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="modeofdisposalfor-discharge.delete({id:modeofdisposalfor_discharge.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/multiple-user-with-caf/multiple-user-with-caf-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.multipleUserWithCaf.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.multipleUserWithCaf.delete.question" translate-values="{id: \'{{vm.multipleUserWithCaf.id}}\'}">Are you sure you want to delete this Multiple User With Caf?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/multiple-user-with-caf/multiple-user-with-caf-detail.html','<div><h2><span data-translate="investhryApp.multipleUserWithCaf.detail.title">Multiple User With Caf</span> {{vm.multipleUserWithCaf.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.multipleUserWithCaf.userId">User Id</span></dt><dd><span>{{vm.multipleUserWithCaf.userId}}</span></dd><dt><span data-translate="investhryApp.multipleUserWithCaf.login">Login</span></dt><dd><span>{{vm.multipleUserWithCaf.login}}</span></dd><dt><span data-translate="investhryApp.multipleUserWithCaf.email">Email</span></dt><dd><span>{{vm.multipleUserWithCaf.email}}</span></dd><dt><span data-translate="investhryApp.multipleUserWithCaf.cafpin">Cafpin</span></dt><dd><span>{{vm.multipleUserWithCaf.cafpin}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="multiple-user-with-caf-detail.edit({id:vm.multipleUserWithCaf.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/multiple-user-with-caf/multiple-user-with-caf-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMultipleUserWithCafLabel" data-translate="investhryApp.multipleUserWithCaf.home.createOrEditLabel">Create or edit a Multiple User With Caf</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.multipleUserWithCaf.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.multipleUserWithCaf.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleUserWithCaf.userId" for="field_userId">User Id</label><input type="text" class="form-control" name="userId" id="field_userId" ng-model="vm.multipleUserWithCaf.userId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleUserWithCaf.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.multipleUserWithCaf.login"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleUserWithCaf.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.multipleUserWithCaf.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleUserWithCaf.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.multipleUserWithCaf.cafpin"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/multiple-user-with-caf/multiple-user-with-cafs.html','<div><h2 data-translate="investhryApp.multipleUserWithCaf.home.title">Multiple User With Cafs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--<button class="btn btn-primary" ui-sref="multiple-user-with-caf.new" >--><!--<span class="glyphicon glyphicon-plus"></span>--><!--<span  data-translate="investhryApp.multipleUserWithCaf.home.createLabel">--><!--Create new Multiple User With Caf--><!--</span>--><!--</button>--><div class="col-md-1 pull-right"><button id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div></div><br><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span>S.No.</span></th><th><span data-translate="investhryApp.multipleUserWithCaf.userId">User Id</span></th><th><span data-translate="investhryApp.multipleUserWithCaf.login">Login</span></th><th><span data-translate="investhryApp.multipleUserWithCaf.email">Email</span></th><th><span data-translate="investhryApp.multipleUserWithCaf.cafpin">Cafpin</span></th><th></th></tr></thead><tbody><tr ng-repeat="multipleUserWithCaf in vm.multipleUserWithCafs | orderBy:\'email\'"><td><a ui-sref="multiple-user-with-caf-detail({id:multipleUserWithCaf.id})">{{multipleUserWithCaf.id}}</a></td><td>{{$index+1}}</td><td>{{multipleUserWithCaf.userId}}</td><td>{{multipleUserWithCaf.login}}</td><td>{{multipleUserWithCaf.email}}</td><td>{{multipleUserWithCaf.cafpin}}</td><!--<td class="text-right">--><!--<div class="btn-group flex-btn-group-container">--><!--<button type="submit"--><!--ui-sref="multiple-user-with-caf-detail({id:multipleUserWithCaf.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="multiple-user-with-caf.edit({id:multipleUserWithCaf.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="multiple-user-with-caf.delete({id:multipleUserWithCaf.id})"--><!--class="btn btn-danger btn-sm">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--><!--</button>--><!--</div>--><!--</td>--></tr></tbody></table></div></div>');
$templateCache.put('app/entities/multiple-user-without-caf/multiple-user-without-caf-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.multipleUserWithoutCaf.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.multipleUserWithoutCaf.delete.question" translate-values="{id: \'{{vm.multipleUserWithoutCaf.id}}\'}">Are you sure you want to delete this Multiple User Without Caf?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/multiple-user-without-caf/multiple-user-without-caf-detail.html','<div><h2><span data-translate="investhryApp.multipleUserWithoutCaf.detail.title">Multiple User Without Caf</span> {{vm.multipleUserWithoutCaf.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.multipleUserWithoutCaf.userId">User Id</span></dt><dd><span>{{vm.multipleUserWithoutCaf.userId}}</span></dd><dt><span data-translate="investhryApp.multipleUserWithoutCaf.login">Login</span></dt><dd><span>{{vm.multipleUserWithoutCaf.login}}</span></dd><dt><span data-translate="investhryApp.multipleUserWithoutCaf.email">Email</span></dt><dd><span>{{vm.multipleUserWithoutCaf.email}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="multiple-user-without-caf-detail.edit({id:vm.multipleUserWithoutCaf.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/multiple-user-without-caf/multiple-user-without-caf-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMultipleUserWithoutCafLabel" data-translate="investhryApp.multipleUserWithoutCaf.home.createOrEditLabel">Create or edit a Multiple User Without Caf</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.multipleUserWithoutCaf.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.multipleUserWithoutCaf.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleUserWithoutCaf.userId" for="field_userId">User Id</label><input type="text" class="form-control" name="userId" id="field_userId" ng-model="vm.multipleUserWithoutCaf.userId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleUserWithoutCaf.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.multipleUserWithoutCaf.login"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleUserWithoutCaf.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.multipleUserWithoutCaf.email"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/multiple-user-without-caf/multiple-user-without-cafs.html','<div><h2 data-translate="investhryApp.multipleUserWithoutCaf.home.title">Multiple User Without Cafs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--<button class="btn btn-primary" ui-sref="multiple-user-without-caf.new" >--><!--<span class="glyphicon glyphicon-plus"></span>--><!--<span  data-translate="investhryApp.multipleUserWithoutCaf.home.createLabel">--><!--Create new Multiple User Without Caf--><!--</span>--><!--</button>--><div class="col-md-1 pull-right"><button id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div></div><br><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span>S.No.</span></th><th><span data-translate="investhryApp.multipleUserWithoutCaf.userId">User Id</span></th><th><span data-translate="investhryApp.multipleUserWithoutCaf.login">Login</span></th><th><span data-translate="investhryApp.multipleUserWithoutCaf.email">Email</span></th><th></th></tr></thead><tbody><tr ng-repeat="multipleUserWithoutCaf in vm.multipleUserWithoutCafs | orderBy:\'email\'"><td><a ui-sref="multiple-user-without-caf-detail({id:multipleUserWithoutCaf.id})">{{multipleUserWithoutCaf.id}}</a></td><td>{{$index+1}}</td><td>{{multipleUserWithoutCaf.userId}}</td><td>{{multipleUserWithoutCaf.login}}</td><td>{{multipleUserWithoutCaf.email}}</td><!--<td class="text-right">--><!--<div class="btn-group flex-btn-group-container">--><!--<button type="submit"--><!--ui-sref="multiple-user-without-caf-detail({id:multipleUserWithoutCaf.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="multiple-user-without-caf.edit({id:multipleUserWithoutCaf.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="multiple-user-without-caf.delete({id:multipleUserWithoutCaf.id})"--><!--class="btn btn-danger btn-sm">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--><!--</button>--><!--</div>--><!--</td>--></tr></tbody></table></div></div>');
$templateCache.put('app/entities/multipleactiveaccountwithcaf/multipleactiveaccountwithcaf-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.multipleactiveaccountwithcaf.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.multipleactiveaccountwithcaf.delete.question" translate-values="{id: \'{{vm.multipleactiveaccountwithcaf.id}}\'}">Are you sure you want to delete this Multipleactiveaccountwithcaf?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/multipleactiveaccountwithcaf/multipleactiveaccountwithcaf-detail.html','<div><h2><span data-translate="investhryApp.multipleactiveaccountwithcaf.detail.title">Multipleactiveaccountwithcaf</span> {{vm.multipleactiveaccountwithcaf.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.multipleactiveaccountwithcaf.email">Email</span></dt><dd><span>{{vm.multipleactiveaccountwithcaf.email}}</span></dd><dt><span data-translate="investhryApp.multipleactiveaccountwithcaf.login">Login</span></dt><dd><span>{{vm.multipleactiveaccountwithcaf.login}}</span></dd><dt><span data-translate="investhryApp.multipleactiveaccountwithcaf.userId">User Id</span></dt><dd><span>{{vm.multipleactiveaccountwithcaf.userId}}</span></dd><dt><span data-translate="investhryApp.multipleactiveaccountwithcaf.cafpin">Cafpin</span></dt><dd><span>{{vm.multipleactiveaccountwithcaf.cafpin}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="multipleactiveaccountwithcaf-detail.edit({id:vm.multipleactiveaccountwithcaf.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/multipleactiveaccountwithcaf/multipleactiveaccountwithcaf-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMultipleactiveaccountwithcafLabel" data-translate="investhryApp.multipleactiveaccountwithcaf.home.createOrEditLabel">Create or edit a Multipleactiveaccountwithcaf</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.multipleactiveaccountwithcaf.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.multipleactiveaccountwithcaf.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleactiveaccountwithcaf.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.multipleactiveaccountwithcaf.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleactiveaccountwithcaf.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.multipleactiveaccountwithcaf.login"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleactiveaccountwithcaf.userId" for="field_userId">User Id</label><input type="text" class="form-control" name="userId" id="field_userId" ng-model="vm.multipleactiveaccountwithcaf.userId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleactiveaccountwithcaf.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.multipleactiveaccountwithcaf.cafpin"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/multipleactiveaccountwithcaf/multipleactiveaccountwithcafs.html','<div><h2 data-translate="investhryApp.multipleactiveaccountwithcaf.home.title">Multipleactiveaccountwithcafs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--<button class="btn btn-primary" ui-sref="multipleactiveaccountwithcaf.new" >--><!--<span class="glyphicon glyphicon-plus"></span>--><!--<span  data-translate="investhryApp.multipleactiveaccountwithcaf.home.createLabel">--><!--Create new Multipleactiveaccountwithcaf--><!--</span>--><!--</button>--><div class="col-md-1 pull-right"><button id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div></div><br><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span>S. No.</span></th><th><span data-translate="investhryApp.multipleactiveaccountwithcaf.userId">User Id</span></th><th><span data-translate="investhryApp.multipleactiveaccountwithcaf.login">Login</span></th><th><span data-translate="investhryApp.multipleactiveaccountwithcaf.email">Email</span></th><th><span data-translate="investhryApp.multipleactiveaccountwithcaf.cafpin">Cafpin</span></th><th></th></tr></thead><tbody><tr ng-repeat="multipleactiveaccountwithcaf in vm.multipleactiveaccountwithcafs | orderBy:\'email\'"><td><a ui-sref="multipleactiveaccountwithcaf-detail({id:multipleactiveaccountwithcaf.id})">{{multipleactiveaccountwithcaf.id}}</a></td><td>{{$index+1}}</td><td>{{multipleactiveaccountwithcaf.userId}}</td><td>{{multipleactiveaccountwithcaf.login}}</td><td>{{multipleactiveaccountwithcaf.email}}</td><td>{{multipleactiveaccountwithcaf.cafpin}}</td><!--<td class="text-right">--><!--<div class="btn-group flex-btn-group-container">--><!--<button type="submit"--><!--ui-sref="multipleactiveaccountwithcaf-detail({id:multipleactiveaccountwithcaf.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="multipleactiveaccountwithcaf.edit({id:multipleactiveaccountwithcaf.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="multipleactiveaccountwithcaf.delete({id:multipleactiveaccountwithcaf.id})"--><!--class="btn btn-danger btn-sm">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--><!--</button>--><!--</div>--><!--</td>--></tr></tbody></table></div></div>');
$templateCache.put('app/entities/multipleactiveaccountwithoutcaf/multipleactiveaccountwithoutcaf-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.multipleactiveaccountwithoutcaf.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.multipleactiveaccountwithoutcaf.delete.question" translate-values="{id: \'{{vm.multipleactiveaccountwithoutcaf.id}}\'}">Are you sure you want to delete this Multipleactiveaccountwithoutcaf?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/multipleactiveaccountwithoutcaf/multipleactiveaccountwithoutcaf-detail.html','<div><h2><span data-translate="investhryApp.multipleactiveaccountwithoutcaf.detail.title">Multipleactiveaccountwithoutcaf</span> {{vm.multipleactiveaccountwithoutcaf.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.multipleactiveaccountwithoutcaf.email">Email</span></dt><dd><span>{{vm.multipleactiveaccountwithoutcaf.email}}</span></dd><dt><span data-translate="investhryApp.multipleactiveaccountwithoutcaf.userId">User Id</span></dt><dd><span>{{vm.multipleactiveaccountwithoutcaf.userId}}</span></dd><dt><span data-translate="investhryApp.multipleactiveaccountwithoutcaf.login">Login</span></dt><dd><span>{{vm.multipleactiveaccountwithoutcaf.login}}</span></dd><dt><span data-translate="investhryApp.multipleactiveaccountwithoutcaf.sNo">S No</span></dt><dd><span>{{vm.multipleactiveaccountwithoutcaf.sNo}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="multipleactiveaccountwithoutcaf-detail.edit({id:vm.multipleactiveaccountwithoutcaf.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/multipleactiveaccountwithoutcaf/multipleactiveaccountwithoutcaf-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMultipleactiveaccountwithoutcafLabel" data-translate="investhryApp.multipleactiveaccountwithoutcaf.home.createOrEditLabel">Create or edit a Multipleactiveaccountwithoutcaf</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.multipleactiveaccountwithoutcaf.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.multipleactiveaccountwithoutcaf.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleactiveaccountwithoutcaf.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.multipleactiveaccountwithoutcaf.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleactiveaccountwithoutcaf.userId" for="field_userId">User Id</label><input type="text" class="form-control" name="userId" id="field_userId" ng-model="vm.multipleactiveaccountwithoutcaf.userId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleactiveaccountwithoutcaf.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.multipleactiveaccountwithoutcaf.login"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleactiveaccountwithoutcaf.sNo" for="field_sNo">S No</label><input type="number" class="form-control" name="sNo" id="field_sNo" ng-model="vm.multipleactiveaccountwithoutcaf.sNo"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/multipleactiveaccountwithoutcaf/multipleactiveaccountwithoutcafs.html','<div><h2 data-translate="investhryApp.multipleactiveaccountwithoutcaf.home.title">Multipleactiveaccountwithoutcafs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--<button class="btn btn-primary" ui-sref="multipleactiveaccountwithoutcaf.new" >--><!--<span class="glyphicon glyphicon-plus"></span>--><!--<span  data-translate="investhryApp.multipleactiveaccountwithoutcaf.home.createLabel">--><!--Create new Multipleactiveaccountwithoutcaf--><!--</span>--><!--</button>--> <button ng-click="vm.deactivateAll()" type="button" class="btn btn-danger btn-sm">Deactivate All<span class="glyphicon glyphicon-remove-circle"></span></button><div class="col-md-1 pull-right"><button id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div></div><br><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.multipleactiveaccountwithoutcaf.sNo">S No</span></th><th><span data-translate="investhryApp.multipleactiveaccountwithoutcaf.email">Email</span></th><th><span data-translate="investhryApp.multipleactiveaccountwithoutcaf.userId">User Id</span></th><th><span data-translate="investhryApp.multipleactiveaccountwithoutcaf.login">Login</span></th><th></th></tr></thead><tbody><tr ng-repeat="multipleactiveaccountwithoutcaf in vm.multipleactiveaccountwithoutcafs | orderBy:\'email\'"><td><a ui-sref="multipleactiveaccountwithoutcaf-detail({id:multipleactiveaccountwithoutcaf.id})">{{multipleactiveaccountwithoutcaf.id}}</a></td><td>{{$index+1}}</td><td>{{multipleactiveaccountwithoutcaf.email}}</td><td>{{multipleactiveaccountwithoutcaf.userId}}</td><td>{{multipleactiveaccountwithoutcaf.login}}</td><!--<td class="text-right">--><!--<div class="btn-group flex-btn-group-container">--><!--<button type="submit"--><!--ui-sref="multipleactiveaccountwithoutcaf-detail({id:multipleactiveaccountwithoutcaf.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="multipleactiveaccountwithoutcaf.edit({id:multipleactiveaccountwithoutcaf.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="multipleactiveaccountwithoutcaf.delete({id:multipleactiveaccountwithoutcaf.id})"--><!--class="btn btn-danger btn-sm">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--><!--</button>--><!--</div>--><!--</td>--></tr></tbody></table></div></div>');
$templateCache.put('app/entities/multipleuser/multipleuser-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.multipleuser.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.multipleuser.delete.question" translate-values="{id: \'{{vm.multipleuser.id}}\'}">Are you sure you want to delete this Multipleuser?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/multipleuser/multipleuser-detail.html','<div><h2><span data-translate="investhryApp.multipleuser.detail.title">Multipleuser</span> {{vm.multipleuser.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.multipleuser.userId">User Id</span></dt><dd><span>{{vm.multipleuser.userId}}</span></dd><dt><span data-translate="investhryApp.multipleuser.login">Login</span></dt><dd><span>{{vm.multipleuser.login}}</span></dd><dt><span data-translate="investhryApp.multipleuser.email">Email</span></dt><dd><span>{{vm.multipleuser.email}}</span></dd><dt><span data-translate="investhryApp.multipleuser.count">Count</span></dt><dd><span>{{vm.multipleuser.count}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="multipleuser-detail.edit({id:vm.multipleuser.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/multipleuser/multipleuser-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMultipleuserLabel" data-translate="investhryApp.multipleuser.home.createOrEditLabel">Create or edit a Multipleuser</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.multipleuser.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.multipleuser.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleuser.userId" for="field_userId">User Id</label><input type="text" class="form-control" name="userId" id="field_userId" ng-model="vm.multipleuser.userId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleuser.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.multipleuser.login"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleuser.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.multipleuser.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.multipleuser.count" for="field_count">Count</label><input type="number" class="form-control" name="count" id="field_count" ng-model="vm.multipleuser.count"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/multipleuser/multipleusers.html','<div><h2 data-translate="investhryApp.multipleuser.home.title">Multipleusers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><!--<button class="btn btn-primary" ui-sref="multipleuser.new" >--><!--<span class="glyphicon glyphicon-plus"></span>--><!--<span  data-translate="investhryApp.multipleuser.home.createLabel">--><!--Create new Multipleuser--><!--</span>--><!--</button>--><div class="col-md-1 pull-right"><button id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div></div><br><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span>S.No.</span></th><th><span data-translate="investhryApp.multipleuser.userId">User Id</span></th><th><span data-translate="investhryApp.multipleuser.login">Login</span></th><th><span data-translate="investhryApp.multipleuser.email">Email</span></th><th><span data-translate="investhryApp.multipleuser.count">Count</span></th><th></th></tr></thead><tbody><tr ng-repeat="multipleuser in vm.multipleusers | orderBy:\'email\'"><td><a ui-sref="multipleuser-detail({id:multipleuser.id})">{{multipleuser.id}}</a></td><td>{{$index+1}}</td><td>{{multipleuser.userId}}</td><td>{{multipleuser.login}}</td><td>{{multipleuser.email}}</td><td>{{multipleuser.count}}</td><!--<td class="text-right">--><!--<div class="btn-group flex-btn-group-container">--><!--<button type="submit"--><!--ui-sref="multipleuser-detail({id:multipleuser.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="multipleuser.edit({id:multipleuser.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="multipleuser.delete({id:multipleuser.id})"--><!--class="btn btn-danger btn-sm">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--><!--</button>--><!--</div>--><!--</td>--></tr></tbody></table></div></div>');
$templateCache.put('app/entities/municipal-payment-params/municipal-payment-params-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.municipalPaymentParams.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.municipalPaymentParams.delete.question" translate-values="{id: \'{{vm.municipalPaymentParams.id}}\'}">Are you sure you want to delete this Municipal Payment Params?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/municipal-payment-params/municipal-payment-params-detail.html','<div><h2><span data-translate="investhryApp.municipalPaymentParams.detail.title">Municipal Payment Params</span> {{vm.municipalPaymentParams.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.municipalPaymentParams.salt">Salt</span></dt><dd><span>{{vm.municipalPaymentParams.salt}}</span></dd><dt><span data-translate="investhryApp.municipalPaymentParams.key">Key</span></dt><dd><span>{{vm.municipalPaymentParams.key}}</span></dd><dt><span data-translate="investhryApp.municipalPaymentParams.subDepartmentName">Sub Department Name</span></dt><dd><span>{{vm.municipalPaymentParams.subDepartmentName}}</span></dd><dt><span data-translate="investhryApp.municipalPaymentParams.url">Url</span></dt><dd><span>{{vm.municipalPaymentParams.url}}</span></dd><dt><span data-translate="investhryApp.municipalPaymentParams.district">District</span></dt><dd><span>{{vm.municipalPaymentParams.district}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="municipal-payment-params-detail.edit({id:vm.municipalPaymentParams.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/municipal-payment-params/municipal-payment-params-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMunicipalPaymentParamsLabel" data-translate="investhryApp.municipalPaymentParams.home.createOrEditLabel">Create or edit a Municipal Payment Params</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.municipalPaymentParams.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.municipalPaymentParams.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipalPaymentParams.salt" for="field_salt">Salt</label><input type="text" class="form-control" name="salt" id="field_salt" ng-model="vm.municipalPaymentParams.salt"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipalPaymentParams.key" for="field_key">Key</label><input type="text" class="form-control" name="key" id="field_key" ng-model="vm.municipalPaymentParams.key"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipalPaymentParams.subDepartmentName" for="field_subDepartmentName">Sub Department Name</label><input type="text" class="form-control" name="subDepartmentName" id="field_subDepartmentName" ng-model="vm.municipalPaymentParams.subDepartmentName"><!--            <select class="form-control" name="subDepartmentName" id="field_subDepartmentName"--><!--                    ng-model="vm.municipalPaymentParams.subDepartmentName" ng-options="department.departmentname as department.departmentname for department in vm.departments">--><!--                <option value="" disabled>Select Department</option>--><!--                <option class="form-control" value="department.departmentname">{{department.departmentname}}</option>--><!--            </select>--></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipalPaymentParams.url" for="field_url">Url</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.municipalPaymentParams.url"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipalPaymentParams.district" for="field_district">District</label><select class="form-control" name="district" id="field_district" ng-model="vm.municipalPaymentParams.district" ng-options="district.districtname as district.districtname for district in vm.districts"><option value="" disabled="disabled">Select District</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/municipal-payment-params/municipal-payment-params.html','<div><h2 data-translate="investhryApp.municipalPaymentParams.home.title">Municipal Payment Params</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="municipal-payment-params.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.municipalPaymentParams.home.createLabel">Create new Municipal Payment Params</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.municipalPaymentParams.salt">Salt</span></th><th><span data-translate="investhryApp.municipalPaymentParams.key">Key</span></th><th><span data-translate="investhryApp.municipalPaymentParams.subDepartmentName">Sub Department Name</span></th><th><span data-translate="investhryApp.municipalPaymentParams.url">Url</span></th><th><span data-translate="investhryApp.municipalPaymentParams.district">District</span></th><th></th></tr></thead><tbody><tr ng-repeat="municipalPaymentParams in vm.municipalPaymentParams track by municipalPaymentParams.id"><td><a ui-sref="municipal-payment-params-detail({id:municipalPaymentParams.id})">{{municipalPaymentParams.id}}</a></td><td>{{municipalPaymentParams.salt}}</td><td>{{municipalPaymentParams.key}}</td><td>{{municipalPaymentParams.subDepartmentName}}</td><td>{{municipalPaymentParams.url}}</td><td>{{municipalPaymentParams.district}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="municipal-payment-params-detail({id:municipalPaymentParams.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="municipal-payment-params.edit({id:municipalPaymentParams.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="municipal-payment-params.delete({id:municipalPaymentParams.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/municipality/municipalities.html','<div><h2 data-translate="investhryApp.municipality.home.title">Municipalities</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="municipality.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.municipality.home.createLabel">Create new Municipality</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.municipality.district">District</span></th><th><span data-translate="investhryApp.municipality.municipality_name">Municipality Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="municipality in vm.municipalities track by municipality.id"><td><a ui-sref="municipality-detail({id:municipality.id})">{{municipality.id}}</a></td><td>{{municipality.district}}</td><td>{{municipality.municipality_name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="municipality-detail({id:municipality.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="municipality.edit({id:municipality.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="municipality.delete({id:municipality.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/municipality/municipality-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.municipality.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.municipality.delete.question" translate-values="{id: \'{{vm.municipality.id}}\'}">Are you sure you want to delete this Municipality?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/municipality/municipality-detail.html','<div><h2><span data-translate="investhryApp.municipality.detail.title">Municipality</span> {{vm.municipality.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.municipality.district">District</span></dt><dd><span>{{vm.municipality.district}}</span></dd><dt><span data-translate="investhryApp.municipality.municipality_name">Municipality Name</span></dt><dd><span>{{vm.municipality.municipality_name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="municipality-detail.edit({id:vm.municipality.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/municipality/municipality-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMunicipalityLabel" data-translate="investhryApp.municipality.home.createOrEditLabel">Create or edit a Municipality</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.municipality.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.municipality.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipality.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.municipality.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipality.municipality_name" for="field_municipality_name">Municipality Name</label><input type="text" class="form-control" name="municipality_name" id="field_municipality_name" ng-model="vm.municipality.municipality_name"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/municipals/municipals-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.municipals.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.municipals.delete.question" translate-values="{id: \'{{vm.municipals.id}}\'}">Are you sure you want to delete this Municipals?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/municipals/municipals-detail.html','<div><h2><span data-translate="investhryApp.municipals.detail.title">Municipals</span> {{vm.municipals.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.municipals.district">District</span></dt><dd><span>{{vm.municipals.district}}</span></dd><dt><span data-translate="investhryApp.municipals.name">Name</span></dt><dd><span>{{vm.municipals.name}}</span></dd><dt><span data-translate="investhryApp.municipals.departmentName">Department Name</span></dt><dd><span>{{vm.municipals.departmentName}}</span></dd><dt><span>Location Code</span></dt><dd><span>{{vm.municipals.locationCode}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="municipals-detail.edit({id:vm.municipals.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/municipals/municipals-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myMunicipalsLabel" data-translate="investhryApp.municipals.home.createOrEditLabel">Create or edit a Municipals</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.municipals.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.municipals.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipals.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.municipals.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipals.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.municipals.name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipals.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.municipals.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipals.locationCode" for="field_locationCode">Location Code</label><input type="text" class="form-control" name="locationCode" id="field_locationCode" ng-model="vm.municipals.locationCode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipals.lgdCode" for="field_lgdCode">LGDCode</label><input type="text" class="form-control" name="lgdCode" id="field_lgdCode" ng-model="vm.municipals.lgdCode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.municipals.locationName" for="field_lgdCode">Location Name</label><input type="text" class="form-control" name="locationName" id="field_locationName" ng-model="vm.municipals.locationName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/municipals/municipals.html','<div><h2 data-translate="investhryApp.municipals.home.title">Municipals</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="municipals.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.municipals.home.createLabel">Create new Municipals</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.municipals.district">District</span></th><th><span data-translate="investhryApp.municipals.name">Name</span></th><th><span data-translate="investhryApp.municipals.departmentName">Department Name</span></th><th><span>Location Code</span></th><th><span>LGD Code</span></th><th><span>Location Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="municipals in vm.municipals track by municipals.id"><td><a ui-sref="municipals-detail({id:municipals.id})">{{municipals.id}}</a></td><td>{{municipals.district}}</td><td>{{municipals.name}}</td><td>{{municipals.departmentName}}</td><td>{{municipals.locationCode}}</td><td>{{municipals.lgdCode}}</td><td>{{municipals.locationName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="municipals-detail({id:municipals.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="municipals.edit({id:municipals.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="municipals.delete({id:municipals.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/new-dasboard-all-completed-stats/new-dasboard-all-completed-stats-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.newDasboardAllCompletedStats.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.newDasboardAllCompletedStats.delete.question" translate-values="{id: \'{{vm.newDasboardAllCompletedStats.id}}\'}">Are you sure you want to delete this New Dasboard All Completed Stats?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/new-dasboard-all-completed-stats/new-dasboard-all-completed-stats-detail.html','<div><h2><span data-translate="investhryApp.newDasboardAllCompletedStats.detail.title">New Dasboard All Completed Stats</span> {{vm.newDasboardAllCompletedStats.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.newDasboardAllCompletedStats.caftype">Caftype</span></dt><dd><span>{{vm.newDasboardAllCompletedStats.caftype}}</span></dd><dt><span data-translate="investhryApp.newDasboardAllCompletedStats.projectLevel">Project Level</span></dt><dd><span>{{vm.newDasboardAllCompletedStats.projectLevel}}</span></dd><dt><span data-translate="investhryApp.newDasboardAllCompletedStats.total">Total</span></dt><dd><span>{{vm.newDasboardAllCompletedStats.total}}</span></dd><dt><span data-translate="investhryApp.newDasboardAllCompletedStats.totalEmployment">Total Employment</span></dt><dd><span>{{vm.newDasboardAllCompletedStats.totalEmployment}}</span></dd><dt><span data-translate="investhryApp.newDasboardAllCompletedStats.totalInvestment">Total Investment</span></dt><dd><span>{{vm.newDasboardAllCompletedStats.totalInvestment}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="new-dasboard-all-completed-stats-detail.edit({id:vm.newDasboardAllCompletedStats.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/new-dasboard-all-completed-stats/new-dasboard-all-completed-stats-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNewDasboardAllCompletedStatsLabel" data-translate="investhryApp.newDasboardAllCompletedStats.home.createOrEditLabel">Create or edit a New Dasboard All Completed Stats</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.newDasboardAllCompletedStats.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.newDasboardAllCompletedStats.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.newDasboardAllCompletedStats.caftype" for="field_caftype">Caftype</label><input type="text" class="form-control" name="caftype" id="field_caftype" ng-model="vm.newDasboardAllCompletedStats.caftype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.newDasboardAllCompletedStats.projectLevel" for="field_projectLevel">Project Level</label><input type="text" class="form-control" name="projectLevel" id="field_projectLevel" ng-model="vm.newDasboardAllCompletedStats.projectLevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.newDasboardAllCompletedStats.total" for="field_total">Total</label><input type="number" class="form-control" name="total" id="field_total" ng-model="vm.newDasboardAllCompletedStats.total"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.newDasboardAllCompletedStats.totalEmployment" for="field_totalEmployment">Total Employment</label><input type="number" class="form-control" name="totalEmployment" id="field_totalEmployment" ng-model="vm.newDasboardAllCompletedStats.totalEmployment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.newDasboardAllCompletedStats.totalInvestment" for="field_totalInvestment">Total Investment</label><input type="number" class="form-control" name="totalInvestment" id="field_totalInvestment" ng-model="vm.newDasboardAllCompletedStats.totalInvestment"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/new-dasboard-all-completed-stats/new-dasboard-all-completed-stats.html','<div><h2 data-translate="investhryApp.newDasboardAllCompletedStats.home.title">New Dasboard All Completed Stats</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="new-dasboard-all-completed-stats.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.newDasboardAllCompletedStats.home.createLabel">Create new New Dasboard All Completed Stats</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.newDasboardAllCompletedStats.caftype">Caftype</span></th><th><span data-translate="investhryApp.newDasboardAllCompletedStats.projectLevel">Project Level</span></th><th><span data-translate="investhryApp.newDasboardAllCompletedStats.total">Total</span></th><th><span data-translate="investhryApp.newDasboardAllCompletedStats.totalEmployment">Total Employment</span></th><th><span data-translate="investhryApp.newDasboardAllCompletedStats.totalInvestment">Total Investment</span></th><th></th></tr></thead><tbody><tr ng-repeat="newDasboardAllCompletedStats in vm.newDasboardAllCompletedStats track by newDasboardAllCompletedStats.id"><td><a ui-sref="new-dasboard-all-completed-stats-detail({id:newDasboardAllCompletedStats.id})">{{newDasboardAllCompletedStats.id}}</a></td><td>{{newDasboardAllCompletedStats.caftype}}</td><td>{{newDasboardAllCompletedStats.projectLevel}}</td><td>{{newDasboardAllCompletedStats.total}}</td><td>{{newDasboardAllCompletedStats.totalEmployment}}</td><td>{{newDasboardAllCompletedStats.totalInvestment}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="new-dasboard-all-completed-stats-detail({id:newDasboardAllCompletedStats.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="new-dasboard-all-completed-stats.edit({id:newDasboardAllCompletedStats.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="new-dasboard-all-completed-stats.delete({id:newDasboardAllCompletedStats.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/new-dasboard-stats/new-dasboard-stats-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.newDasboardStats.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.newDasboardStats.delete.question" translate-values="{id: \'{{vm.newDasboardStats.id}}\'}">Are you sure you want to delete this New Dasboard Stats?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/new-dasboard-stats/new-dasboard-stats-detail.html','<div><h2><span data-translate="investhryApp.newDasboardStats.detail.title">New Dasboard Stats</span> {{vm.newDasboardStats.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.newDasboardStats.projectType">Project Type</span></dt><dd><span>{{vm.newDasboardStats.projectType}}</span></dd><dt><span data-translate="investhryApp.newDasboardStats.projectLevel">Project Level</span></dt><dd><span>{{vm.newDasboardStats.projectLevel}}</span></dd><dt><span data-translate="investhryApp.newDasboardStats.total">Total</span></dt><dd><span>{{vm.newDasboardStats.total}}</span></dd><dt><span data-translate="investhryApp.newDasboardStats.totalInvestment">Total Investment</span></dt><dd><span>{{vm.newDasboardStats.totalInvestment}}</span></dd><dt><span data-translate="investhryApp.newDasboardStats.totalEmployment">Total Employment</span></dt><dd><span>{{vm.newDasboardStats.totalEmployment}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="new-dasboard-stats-detail.edit({id:vm.newDasboardStats.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/new-dasboard-stats/new-dasboard-stats-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNewDasboardStatsLabel" data-translate="investhryApp.newDasboardStats.home.createOrEditLabel">Create or edit a New Dasboard Stats</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.newDasboardStats.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.newDasboardStats.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.newDasboardStats.projectType" for="field_projectType">Project Type</label><input type="text" class="form-control" name="projectType" id="field_projectType" ng-model="vm.newDasboardStats.projectType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.newDasboardStats.projectLevel" for="field_projectLevel">Project Level</label><input type="text" class="form-control" name="projectLevel" id="field_projectLevel" ng-model="vm.newDasboardStats.projectLevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.newDasboardStats.total" for="field_total">Total</label><input type="number" class="form-control" name="total" id="field_total" ng-model="vm.newDasboardStats.total"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.newDasboardStats.totalInvestment" for="field_totalInvestment">Total Investment</label><input type="number" class="form-control" name="totalInvestment" id="field_totalInvestment" ng-model="vm.newDasboardStats.totalInvestment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.newDasboardStats.totalEmployment" for="field_totalEmployment">Total Employment</label><input type="number" class="form-control" name="totalEmployment" id="field_totalEmployment" ng-model="vm.newDasboardStats.totalEmployment"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/new-dasboard-stats/new-dasboard-stats.html','<div><h2 data-translate="investhryApp.newDasboardStats.home.title">New Dasboard Stats</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="new-dasboard-stats.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.newDasboardStats.home.createLabel">Create new New Dasboard Stats</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.newDasboardStats.projectType">Project Type</span></th><th><span data-translate="investhryApp.newDasboardStats.projectLevel">Project Level</span></th><th><span data-translate="investhryApp.newDasboardStats.total">Total</span></th><th><span data-translate="investhryApp.newDasboardStats.totalInvestment">Total Investment</span></th><th><span data-translate="investhryApp.newDasboardStats.totalEmployment">Total Employment</span></th><th></th></tr></thead><tbody><tr ng-repeat="newDasboardStats in vm.newDasboardStats track by newDasboardStats.id"><td><a ui-sref="new-dasboard-stats-detail({id:newDasboardStats.id})">{{newDasboardStats.id}}</a></td><td>{{newDasboardStats.projectType}}</td><td>{{newDasboardStats.projectLevel}}</td><td>{{newDasboardStats.total}}</td><td>{{newDasboardStats.totalInvestment}}</td><td>{{newDasboardStats.totalEmployment}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="new-dasboard-stats-detail({id:newDasboardStats.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="new-dasboard-stats.edit({id:newDasboardStats.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="new-dasboard-stats.delete({id:newDasboardStats.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/newsandgallery/newsandgalleries.html','<div><h2 data-translate="investhryApp.newsandgallery.home.title">Newsandgalleries</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="newsandgallery.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.newsandgallery.home.createLabel">Create new Newsandgallery</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.newsandgallery.description">Description</span></th><th><span data-translate="investhryApp.newsandgallery.lastmodified">Lastmodified</span></th><th></th></tr></thead><tbody><tr ng-repeat="newsandgallery in vm.newsandgalleries | orderBy: \'-lastmodified\'"><td><a ui-sref="newsandgallery-detail({id:newsandgallery.id})">{{newsandgallery.id}}</a></td><td>{{newsandgallery.description}}</td><td>{{newsandgallery.lastmodified | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="newsandgallery-detail({id:newsandgallery.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="newsandgallery.edit({id:newsandgallery.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="newsandgallery.delete({id:newsandgallery.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/newsandgallery/newsandgallery-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.newsandgallery.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.newsandgallery.delete.question" translate-values="{id: \'{{vm.newsandgallery.id}}\'}">Are you sure you want to delete this Newsandgallery?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/newsandgallery/newsandgallery-detail.html','<div><h2><span data-translate="investhryApp.newsandgallery.detail.title">Newsandgallery</span> {{vm.newsandgallery.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.newsandgallery.description">Description</span></dt><dd><span>{{vm.newsandgallery.description}}</span></dd><dt><span data-translate="investhryApp.newsandgallery.lastmodified">Lastmodified</span></dt><dd><span>{{vm.newsandgallery.lastmodified | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="newsandgallery-detail.edit({id:vm.newsandgallery.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/newsandgallery/newsandgallery-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.addfileattachment()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNewsandgalleryLabel" data-translate="investhryApp.newsandgallery.home.createOrEditLabel">Create or edit a Newsandgallery</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.newsandgallery.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.newsandgallery.id" readonly="readonly"></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.newsandgallery.description" for="field_description">Description</label>--><!--<input type="text" class="form-control" name="description" id="field_description"--><!--ng-model="vm.newsandgallery.description"--><!--/>--><!--</div>--><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.newsandgallery.lastmodified" for="field_lastmodified">Lastmodified</label>--><!--<div class="input-group">--><!--<input id="field_lastmodified" type="text" class="form-control" name="lastmodified" datetime-picker="{{dateformat}}" ng-model="vm.newsandgallery.lastmodified" is-open="vm.datePickerOpenStatus.lastmodified"--><!--/>--><!--<span class="input-group-btn">--><!--<button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastmodified\')"><i class="glyphicon glyphicon-calendar"></i></button>--><!--</span>--><!--</div>--><!--</div>--><div class="col-lg-7"><input type="file" id="browsefile" class="form-control" file-model="vm.imageFile" accept="image/*"><p ng-show="file.maxSizeError"><font size="2px" color="red">Max file size exceeded (1 MB)</font></p>{{vm.serviceformfile.maxSizeError}}</div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button ng-hide="file.maxSizeError || (vm.imageFile.name == null)" type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/nma/nma-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.nma.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.nma.delete.question" translate-values="{id: \'{{vm.nma.id}}\'}">Are you sure you want to delete this Nma?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/nma/nma-detail.html','<div><h2><span data-translate="investhryApp.nma.detail.title">Nma</span> {{vm.nma.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.nma.department">Department</span></dt><dd><span>{{vm.nma.department}}</span></dd><dt><span data-translate="investhryApp.nma.architectName">Architect Name</span></dt><dd><span>{{vm.nma.architectName}}</span></dd><dt><span data-translate="investhryApp.nma.architectEmail">Architect Email</span></dt><dd><span>{{vm.nma.architectEmail}}</span></dd><dt><span data-translate="investhryApp.nma.architectMobile">Architect Mobile</span></dt><dd><span>{{vm.nma.architectMobile}}</span></dd><dt><span data-translate="investhryApp.nma.nocRequestScreen">Noc Request Screen</span></dt><dd><span>{{vm.nma.nocRequestScreen}}</span></dd><dt><span data-translate="investhryApp.nma.nameOfApplicant">Name Of Applicant</span></dt><dd><span>{{vm.nma.nameOfApplicant}}</span></dd><dt><span data-translate="investhryApp.nma.presentAddress">Present Address</span></dt><dd><span>{{vm.nma.presentAddress}}</span></dd><dt><span data-translate="investhryApp.nma.permanentAddress">Permanent Address</span></dt><dd><span>{{vm.nma.permanentAddress}}</span></dd><dt><span data-translate="investhryApp.nma.isOwner">Is Owner</span></dt><dd><span>{{vm.nma.isOwner}}</span></dd><dt><span data-translate="investhryApp.nma.nameOfOwner">Name Of Owner</span></dt><dd><span>{{vm.nma.nameOfOwner}}</span></dd><dt><span data-translate="investhryApp.nma.presentAddressOwner">Present Address Owner</span></dt><dd><span>{{vm.nma.presentAddressOwner}}</span></dd><dt><span data-translate="investhryApp.nma.permanentAddressOwner">Permanent Address Owner</span></dt><dd><span>{{vm.nma.permanentAddressOwner}}</span></dd><dt><span data-translate="investhryApp.nma.typeOwner1">Type Owner 1</span></dt><dd><span>{{vm.nma.typeOwner1}}</span></dd><dt><span data-translate="investhryApp.nma.typeOwner2">Type Owner 2</span></dt><dd><span>{{vm.nma.typeOwner2}}</span></dd><dt><span data-translate="investhryApp.nma.typeOwner3">Type Owner 3</span></dt><dd><span>{{vm.nma.typeOwner3}}</span></dd><dt><span data-translate="investhryApp.nma.plotNo">Plot No</span></dt><dd><span>{{vm.nma.plotNo}}</span></dd><dt><span data-translate="investhryApp.nma.state">State</span></dt><dd><span>{{vm.nma.state}}</span></dd><dt><span data-translate="investhryApp.nma.district">District</span></dt><dd><span>{{vm.nma.district}}</span></dd><dt><span data-translate="investhryApp.nma.taulk">Taulk</span></dt><dd><span>{{vm.nma.taulk}}</span></dd><dt><span data-translate="investhryApp.nma.locality">Locality</span></dt><dd><span>{{vm.nma.locality}}</span></dd><dt><span data-translate="investhryApp.nma.monumentName">Monument Name</span></dt><dd><span>{{vm.nma.monumentName}}</span></dd><dt><span data-translate="investhryApp.nma.stateMonument">State Monument</span></dt><dd><span>{{vm.nma.stateMonument}}</span></dd><dt><span data-translate="investhryApp.nma.districtMonument">District Monument</span></dt><dd><span>{{vm.nma.districtMonument}}</span></dd><dt><span data-translate="investhryApp.nma.taulkMonument">Taulk Monument</span></dt><dd><span>{{vm.nma.taulkMonument}}</span></dd><dt><span data-translate="investhryApp.nma.localityMonument">Locality Monument</span></dt><dd><span>{{vm.nma.localityMonument}}</span></dd><dt><span data-translate="investhryApp.nma.distance1">Distance 1</span></dt><dd><span>{{vm.nma.distance1}}</span></dd><dt><span data-translate="investhryApp.nma.distance2">Distance 2</span></dt><dd><span>{{vm.nma.distance2}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails1">Work Details 1</span></dt><dd><span>{{vm.nma.workDetails1}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails2">Work Details 2</span></dt><dd><span>{{vm.nma.workDetails2}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails3">Work Details 3</span></dt><dd><span>{{vm.nma.workDetails3}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails4">Work Details 4</span></dt><dd><span>{{vm.nma.workDetails4}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails5">Work Details 5</span></dt><dd><span>{{vm.nma.workDetails5}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails6">Work Details 6</span></dt><dd><span>{{vm.nma.workDetails6}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails7">Work Details 7</span></dt><dd><span>{{vm.nma.workDetails7}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails8">Work Details 8</span></dt><dd><span>{{vm.nma.workDetails8}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails9">Work Details 9</span></dt><dd><span>{{vm.nma.workDetails9}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails10">Work Details 10</span></dt><dd><span>{{vm.nma.workDetails10}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails11">Work Details 11</span></dt><dd><span>{{vm.nma.workDetails11}}</span></dd><dt><span data-translate="investhryApp.nma.workDetails12">Work Details 12</span></dt><dd><span>{{vm.nma.workDetails12}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails1">Other Work Details 1</span></dt><dd><span>{{vm.nma.otherWorkDetails1}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails2">Other Work Details 2</span></dt><dd><span>{{vm.nma.otherWorkDetails2}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails3">Other Work Details 3</span></dt><dd><span>{{vm.nma.otherWorkDetails3}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails4">Other Work Details 4</span></dt><dd><span>{{vm.nma.otherWorkDetails4}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails5">Other Work Details 5</span></dt><dd><span>{{vm.nma.otherWorkDetails5}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails6">Other Work Details 6</span></dt><dd><span>{{vm.nma.otherWorkDetails6}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails7">Other Work Details 7</span></dt><dd><span>{{vm.nma.otherWorkDetails7}}</span></dd><dt><span data-translate="investhryApp.nma.otherWorkDetails8">Other Work Details 8</span></dt><dd><span>{{vm.nma.otherWorkDetails8}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="nma-detail.edit({id:vm.nma.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/nma/nma-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNmaLabel" data-translate="investhryApp.nma.home.createOrEditLabel">Create or edit a Nma</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.nma.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.nma.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.department" for="field_department">Department</label><input type="text" class="form-control" name="department" id="field_department" ng-model="vm.nma.department"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.architectName" for="field_architectName">Architect Name</label><input type="text" class="form-control" name="architectName" id="field_architectName" ng-model="vm.nma.architectName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.architectEmail" for="field_architectEmail">Architect Email</label><input type="text" class="form-control" name="architectEmail" id="field_architectEmail" ng-model="vm.nma.architectEmail"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.architectMobile" for="field_architectMobile">Architect Mobile</label><input type="text" class="form-control" name="architectMobile" id="field_architectMobile" ng-model="vm.nma.architectMobile"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.nocRequestScreen" for="field_nocRequestScreen">Noc Request Screen</label><input type="text" class="form-control" name="nocRequestScreen" id="field_nocRequestScreen" ng-model="vm.nma.nocRequestScreen"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.nameOfApplicant" for="field_nameOfApplicant">Name Of Applicant</label><input type="text" class="form-control" name="nameOfApplicant" id="field_nameOfApplicant" ng-model="vm.nma.nameOfApplicant"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.presentAddress" for="field_presentAddress">Present Address</label><input type="text" class="form-control" name="presentAddress" id="field_presentAddress" ng-model="vm.nma.presentAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.permanentAddress" for="field_permanentAddress">Permanent Address</label><input type="text" class="form-control" name="permanentAddress" id="field_permanentAddress" ng-model="vm.nma.permanentAddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.isOwner" for="field_isOwner">Is Owner</label><input type="text" class="form-control" name="isOwner" id="field_isOwner" ng-model="vm.nma.isOwner"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.nameOfOwner" for="field_nameOfOwner">Name Of Owner</label><input type="text" class="form-control" name="nameOfOwner" id="field_nameOfOwner" ng-model="vm.nma.nameOfOwner"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.presentAddressOwner" for="field_presentAddressOwner">Present Address Owner</label><input type="text" class="form-control" name="presentAddressOwner" id="field_presentAddressOwner" ng-model="vm.nma.presentAddressOwner"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.permanentAddressOwner" for="field_permanentAddressOwner">Permanent Address Owner</label><input type="text" class="form-control" name="permanentAddressOwner" id="field_permanentAddressOwner" ng-model="vm.nma.permanentAddressOwner"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.typeOwner1" for="field_typeOwner1">Type Owner 1</label><input type="text" class="form-control" name="typeOwner1" id="field_typeOwner1" ng-model="vm.nma.typeOwner1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.typeOwner2" for="field_typeOwner2">Type Owner 2</label><input type="text" class="form-control" name="typeOwner2" id="field_typeOwner2" ng-model="vm.nma.typeOwner2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.typeOwner3" for="field_typeOwner3">Type Owner 3</label><input type="text" class="form-control" name="typeOwner3" id="field_typeOwner3" ng-model="vm.nma.typeOwner3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.plotNo" for="field_plotNo">Plot No</label><input type="text" class="form-control" name="plotNo" id="field_plotNo" ng-model="vm.nma.plotNo"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.state" for="field_state">State</label><input type="text" class="form-control" name="state" id="field_state" ng-model="vm.nma.state"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.nma.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.taulk" for="field_taulk">Taulk</label><input type="text" class="form-control" name="taulk" id="field_taulk" ng-model="vm.nma.taulk"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.locality" for="field_locality">Locality</label><input type="text" class="form-control" name="locality" id="field_locality" ng-model="vm.nma.locality"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.monumentName" for="field_monumentName">Monument Name</label><input type="text" class="form-control" name="monumentName" id="field_monumentName" ng-model="vm.nma.monumentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.stateMonument" for="field_stateMonument">State Monument</label><input type="text" class="form-control" name="stateMonument" id="field_stateMonument" ng-model="vm.nma.stateMonument"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.districtMonument" for="field_districtMonument">District Monument</label><input type="text" class="form-control" name="districtMonument" id="field_districtMonument" ng-model="vm.nma.districtMonument"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.taulkMonument" for="field_taulkMonument">Taulk Monument</label><input type="text" class="form-control" name="taulkMonument" id="field_taulkMonument" ng-model="vm.nma.taulkMonument"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.localityMonument" for="field_localityMonument">Locality Monument</label><input type="text" class="form-control" name="localityMonument" id="field_localityMonument" ng-model="vm.nma.localityMonument"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.distance1" for="field_distance1">Distance 1</label><input type="text" class="form-control" name="distance1" id="field_distance1" ng-model="vm.nma.distance1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.distance2" for="field_distance2">Distance 2</label><input type="text" class="form-control" name="distance2" id="field_distance2" ng-model="vm.nma.distance2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails1" for="field_workDetails1">Work Details 1</label><input type="text" class="form-control" name="workDetails1" id="field_workDetails1" ng-model="vm.nma.workDetails1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails2" for="field_workDetails2">Work Details 2</label><input type="text" class="form-control" name="workDetails2" id="field_workDetails2" ng-model="vm.nma.workDetails2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails3" for="field_workDetails3">Work Details 3</label><input type="text" class="form-control" name="workDetails3" id="field_workDetails3" ng-model="vm.nma.workDetails3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails4" for="field_workDetails4">Work Details 4</label><input type="text" class="form-control" name="workDetails4" id="field_workDetails4" ng-model="vm.nma.workDetails4"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails5" for="field_workDetails5">Work Details 5</label><input type="text" class="form-control" name="workDetails5" id="field_workDetails5" ng-model="vm.nma.workDetails5"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails6" for="field_workDetails6">Work Details 6</label><input type="text" class="form-control" name="workDetails6" id="field_workDetails6" ng-model="vm.nma.workDetails6"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails7" for="field_workDetails7">Work Details 7</label><input type="text" class="form-control" name="workDetails7" id="field_workDetails7" ng-model="vm.nma.workDetails7"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails8" for="field_workDetails8">Work Details 8</label><input type="text" class="form-control" name="workDetails8" id="field_workDetails8" ng-model="vm.nma.workDetails8"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails9" for="field_workDetails9">Work Details 9</label><input type="text" class="form-control" name="workDetails9" id="field_workDetails9" ng-model="vm.nma.workDetails9"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails10" for="field_workDetails10">Work Details 10</label><input type="text" class="form-control" name="workDetails10" id="field_workDetails10" ng-model="vm.nma.workDetails10"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails11" for="field_workDetails11">Work Details 11</label><input type="text" class="form-control" name="workDetails11" id="field_workDetails11" ng-model="vm.nma.workDetails11"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.workDetails12" for="field_workDetails12">Work Details 12</label><input type="text" class="form-control" name="workDetails12" id="field_workDetails12" ng-model="vm.nma.workDetails12"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.otherWorkDetails1" for="field_otherWorkDetails1">Other Work Details 1</label><input type="text" class="form-control" name="otherWorkDetails1" id="field_otherWorkDetails1" ng-model="vm.nma.otherWorkDetails1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.otherWorkDetails2" for="field_otherWorkDetails2">Other Work Details 2</label><input type="text" class="form-control" name="otherWorkDetails2" id="field_otherWorkDetails2" ng-model="vm.nma.otherWorkDetails2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.otherWorkDetails3" for="field_otherWorkDetails3">Other Work Details 3</label><input type="text" class="form-control" name="otherWorkDetails3" id="field_otherWorkDetails3" ng-model="vm.nma.otherWorkDetails3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.otherWorkDetails4" for="field_otherWorkDetails4">Other Work Details 4</label><input type="text" class="form-control" name="otherWorkDetails4" id="field_otherWorkDetails4" ng-model="vm.nma.otherWorkDetails4"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.otherWorkDetails5" for="field_otherWorkDetails5">Other Work Details 5</label><input type="text" class="form-control" name="otherWorkDetails5" id="field_otherWorkDetails5" ng-model="vm.nma.otherWorkDetails5"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.otherWorkDetails6" for="field_otherWorkDetails6">Other Work Details 6</label><input type="text" class="form-control" name="otherWorkDetails6" id="field_otherWorkDetails6" ng-model="vm.nma.otherWorkDetails6"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.otherWorkDetails7" for="field_otherWorkDetails7">Other Work Details 7</label><input type="text" class="form-control" name="otherWorkDetails7" id="field_otherWorkDetails7" ng-model="vm.nma.otherWorkDetails7"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nma.otherWorkDetails8" for="field_otherWorkDetails8">Other Work Details 8</label><input type="text" class="form-control" name="otherWorkDetails8" id="field_otherWorkDetails8" ng-model="vm.nma.otherWorkDetails8"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/nma/nmas.html','<div><h2 data-translate="investhryApp.nma.home.title">Nmas</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="nma.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.nma.home.createLabel">Create new Nma</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.nma.department">Department</span></th><th><span data-translate="investhryApp.nma.architectName">Architect Name</span></th><th><span data-translate="investhryApp.nma.architectEmail">Architect Email</span></th><th><span data-translate="investhryApp.nma.architectMobile">Architect Mobile</span></th><th><span data-translate="investhryApp.nma.nocRequestScreen">Noc Request Screen</span></th><th><span data-translate="investhryApp.nma.nameOfApplicant">Name Of Applicant</span></th><th><span data-translate="investhryApp.nma.presentAddress">Present Address</span></th><th><span data-translate="investhryApp.nma.permanentAddress">Permanent Address</span></th><th><span data-translate="investhryApp.nma.isOwner">Is Owner</span></th><th><span data-translate="investhryApp.nma.nameOfOwner">Name Of Owner</span></th><th><span data-translate="investhryApp.nma.presentAddressOwner">Present Address Owner</span></th><th><span data-translate="investhryApp.nma.permanentAddressOwner">Permanent Address Owner</span></th><th><span data-translate="investhryApp.nma.typeOwner1">Type Owner 1</span></th><th><span data-translate="investhryApp.nma.typeOwner2">Type Owner 2</span></th><th><span data-translate="investhryApp.nma.typeOwner3">Type Owner 3</span></th><th><span data-translate="investhryApp.nma.plotNo">Plot No</span></th><th><span data-translate="investhryApp.nma.state">State</span></th><th><span data-translate="investhryApp.nma.district">District</span></th><th><span data-translate="investhryApp.nma.taulk">Taulk</span></th><th><span data-translate="investhryApp.nma.locality">Locality</span></th><th><span data-translate="investhryApp.nma.monumentName">Monument Name</span></th><th><span data-translate="investhryApp.nma.stateMonument">State Monument</span></th><th><span data-translate="investhryApp.nma.districtMonument">District Monument</span></th><th><span data-translate="investhryApp.nma.taulkMonument">Taulk Monument</span></th><th><span data-translate="investhryApp.nma.localityMonument">Locality Monument</span></th><th><span data-translate="investhryApp.nma.distance1">Distance 1</span></th><th><span data-translate="investhryApp.nma.distance2">Distance 2</span></th><th><span data-translate="investhryApp.nma.workDetails1">Work Details 1</span></th><th><span data-translate="investhryApp.nma.workDetails2">Work Details 2</span></th><th><span data-translate="investhryApp.nma.workDetails3">Work Details 3</span></th><th><span data-translate="investhryApp.nma.workDetails4">Work Details 4</span></th><th><span data-translate="investhryApp.nma.workDetails5">Work Details 5</span></th><th><span data-translate="investhryApp.nma.workDetails6">Work Details 6</span></th><th><span data-translate="investhryApp.nma.workDetails7">Work Details 7</span></th><th><span data-translate="investhryApp.nma.workDetails8">Work Details 8</span></th><th><span data-translate="investhryApp.nma.workDetails9">Work Details 9</span></th><th><span data-translate="investhryApp.nma.workDetails10">Work Details 10</span></th><th><span data-translate="investhryApp.nma.workDetails11">Work Details 11</span></th><th><span data-translate="investhryApp.nma.workDetails12">Work Details 12</span></th><th><span data-translate="investhryApp.nma.otherWorkDetails1">Other Work Details 1</span></th><th><span data-translate="investhryApp.nma.otherWorkDetails2">Other Work Details 2</span></th><th><span data-translate="investhryApp.nma.otherWorkDetails3">Other Work Details 3</span></th><th><span data-translate="investhryApp.nma.otherWorkDetails4">Other Work Details 4</span></th><th><span data-translate="investhryApp.nma.otherWorkDetails5">Other Work Details 5</span></th><th><span data-translate="investhryApp.nma.otherWorkDetails6">Other Work Details 6</span></th><th><span data-translate="investhryApp.nma.otherWorkDetails7">Other Work Details 7</span></th><th><span data-translate="investhryApp.nma.otherWorkDetails8">Other Work Details 8</span></th><th></th></tr></thead><tbody><tr ng-repeat="nma in vm.nmas track by nma.id"><td><a ui-sref="nma-detail({id:nma.id})">{{nma.id}}</a></td><td>{{nma.department}}</td><td>{{nma.architectName}}</td><td>{{nma.architectEmail}}</td><td>{{nma.architectMobile}}</td><td>{{nma.nocRequestScreen}}</td><td>{{nma.nameOfApplicant}}</td><td>{{nma.presentAddress}}</td><td>{{nma.permanentAddress}}</td><td>{{nma.isOwner}}</td><td>{{nma.nameOfOwner}}</td><td>{{nma.presentAddressOwner}}</td><td>{{nma.permanentAddressOwner}}</td><td>{{nma.typeOwner1}}</td><td>{{nma.typeOwner2}}</td><td>{{nma.typeOwner3}}</td><td>{{nma.plotNo}}</td><td>{{nma.state}}</td><td>{{nma.district}}</td><td>{{nma.taulk}}</td><td>{{nma.locality}}</td><td>{{nma.monumentName}}</td><td>{{nma.stateMonument}}</td><td>{{nma.districtMonument}}</td><td>{{nma.taulkMonument}}</td><td>{{nma.localityMonument}}</td><td>{{nma.distance1}}</td><td>{{nma.distance2}}</td><td>{{nma.workDetails1}}</td><td>{{nma.workDetails2}}</td><td>{{nma.workDetails3}}</td><td>{{nma.workDetails4}}</td><td>{{nma.workDetails5}}</td><td>{{nma.workDetails6}}</td><td>{{nma.workDetails7}}</td><td>{{nma.workDetails8}}</td><td>{{nma.workDetails9}}</td><td>{{nma.workDetails10}}</td><td>{{nma.workDetails11}}</td><td>{{nma.workDetails12}}</td><td>{{nma.otherWorkDetails1}}</td><td>{{nma.otherWorkDetails2}}</td><td>{{nma.otherWorkDetails3}}</td><td>{{nma.otherWorkDetails4}}</td><td>{{nma.otherWorkDetails5}}</td><td>{{nma.otherWorkDetails6}}</td><td>{{nma.otherWorkDetails7}}</td><td>{{nma.otherWorkDetails8}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="nma-detail({id:nma.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="nma.edit({id:nma.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="nma.delete({id:nma.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/nmatoken/nmatoken-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.nmatoken.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.nmatoken.delete.question" translate-values="{id: \'{{vm.nmatoken.id}}\'}">Are you sure you want to delete this Nmatoken?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/nmatoken/nmatoken-detail.html','<div><h2><span data-translate="investhryApp.nmatoken.detail.title">Nmatoken</span> {{vm.nmatoken.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.nmatoken.nmatoken">Nmatoken</span></dt><dd><span>{{vm.nmatoken.nmatoken}}</span></dd><dt><span data-translate="investhryApp.nmatoken.cafpin">Cafpin</span></dt><dd><span>{{vm.nmatoken.cafpin}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="nmatoken-detail.edit({id:vm.nmatoken.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/nmatoken/nmatoken-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNmatokenLabel" data-translate="investhryApp.nmatoken.home.createOrEditLabel">Create or edit a Nmatoken</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.nmatoken.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.nmatoken.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nmatoken.nmatoken" for="field_nmatoken">Nmatoken</label><input type="text" class="form-control" name="nmatoken" id="field_nmatoken" ng-model="vm.nmatoken.nmatoken"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nmatoken.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.nmatoken.cafpin"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/nmatoken/nmatokens.html','<div><h2 data-translate="investhryApp.nmatoken.home.title">Nmatokens</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="nmatoken.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.nmatoken.home.createLabel">Create new Nmatoken</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.nmatoken.nmatoken">Nmatoken</span></th><th><span data-translate="investhryApp.nmatoken.cafpin">Cafpin</span></th><th></th></tr></thead><tbody><tr ng-repeat="nmatoken in vm.nmatokens track by nmatoken.id"><td><a ui-sref="nmatoken-detail({id:nmatoken.id})">{{nmatoken.id}}</a></td><td>{{nmatoken.nmatoken}}</td><td>{{nmatoken.cafpin}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="nmatoken-detail({id:nmatoken.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="nmatoken.edit({id:nmatoken.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="nmatoken.delete({id:nmatoken.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/notification/notification-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.notification.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.notification.delete.question" translate-values="{id: \'{{vm.notification.id}}\'}">Are you sure you want to delete this Notification?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/notification/notification-detail.html','<div><h2><span data-translate="investhryApp.notification.detail.title">Notification</span> {{vm.notification.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.notification.projectid">Projectid</span></dt><dd><span>{{vm.notification.projectid}}</span></dd><dt><span data-translate="investhryApp.notification.serviceid">Serviceid</span></dt><dd><span>{{vm.notification.serviceid}}</span></dd><dt><span data-translate="investhryApp.notification.nodalofficer">Nodalofficer</span></dt><dd><span>{{vm.notification.nodalofficer}}</span></dd><dt><span data-translate="investhryApp.notification.fieldofficer">Fieldofficer</span></dt><dd><span>{{vm.notification.fieldofficer}}</span></dd><dt><span data-translate="investhryApp.notification.accountofficer">Accountofficer</span></dt><dd><span>{{vm.notification.accountofficer}}</span></dd><dt><span data-translate="investhryApp.notification.investor">Investor</span></dt><dd><span>{{vm.notification.investor}}</span></dd><dt><span data-translate="investhryApp.notification.deskofficer">Deskofficer</span></dt><dd><span>{{vm.notification.deskofficer}}</span></dd><dt><span data-translate="investhryApp.notification.rm">Rm</span></dt><dd><span>{{vm.notification.rm}}</span></dd><dt><span data-translate="investhryApp.notification.executive">Executive</span></dt><dd><span>{{vm.notification.executive}}</span></dd><dt><span data-translate="investhryApp.notification.admin">Admin</span></dt><dd><span>{{vm.notification.admin}}</span></dd><dt><span data-translate="investhryApp.notification.latestaction">Latestaction</span></dt><dd><span>{{vm.notification.latestaction}}</span></dd><dt><span data-translate="investhryApp.notification.latestactiondate">Latestactiondate</span></dt><dd><span>{{vm.notification.latestactiondate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.notification.action">Action</span></dt><dd><span>{{vm.notification.action}}</span></dd><dt><span data-translate="investhryApp.notification.latestactionby">Latestactionby</span></dt><dd><span>{{vm.notification.latestactionby}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="notification-detail.edit({id:vm.notification.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/notification/notification-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNotificationLabel" data-translate="investhryApp.notification.home.createOrEditLabel">Create or edit a Notification</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.notification.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.notification.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.notification.projectid" required><div ng-show="editForm.projectid.$invalid"><p class="help-block" ng-show="editForm.projectid.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.notification.serviceid" required><div ng-show="editForm.serviceid.$invalid"><p class="help-block" ng-show="editForm.serviceid.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.nodalofficer" for="field_nodalofficer">Nodalofficer</label><input type="text" class="form-control" name="nodalofficer" id="field_nodalofficer" ng-model="vm.notification.nodalofficer"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.fieldofficer" for="field_fieldofficer">Fieldofficer</label><input type="text" class="form-control" name="fieldofficer" id="field_fieldofficer" ng-model="vm.notification.fieldofficer"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.accountofficer" for="field_accountofficer">Accountofficer</label><input type="text" class="form-control" name="accountofficer" id="field_accountofficer" ng-model="vm.notification.accountofficer" required><div ng-show="editForm.accountofficer.$invalid"><p class="help-block" ng-show="editForm.accountofficer.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.investor" for="field_investor">Investor</label><input type="text" class="form-control" name="investor" id="field_investor" ng-model="vm.notification.investor"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.deskofficer" for="field_deskofficer">Deskofficer</label><input type="text" class="form-control" name="deskofficer" id="field_deskofficer" ng-model="vm.notification.deskofficer"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.rm" for="field_rm">Rm</label><input type="text" class="form-control" name="rm" id="field_rm" ng-model="vm.notification.rm"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.executive" for="field_executive">Executive</label><input type="text" class="form-control" name="executive" id="field_executive" ng-model="vm.notification.executive"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.admin" for="field_admin">Admin</label><input type="text" class="form-control" name="admin" id="field_admin" ng-model="vm.notification.admin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.latestaction" for="field_latestaction">Latestaction</label><input type="text" class="form-control" name="latestaction" id="field_latestaction" ng-model="vm.notification.latestaction"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.latestactiondate" for="field_latestactiondate">Latestactiondate</label><div class="input-group"><input id="field_latestactiondate" type="text" class="form-control" name="latestactiondate" datetime-picker="{{dateformat}}" ng-model="vm.notification.latestactiondate" is-open="vm.datePickerOpenStatus.latestactiondate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'latestactiondate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.action" for="field_action">Action</label><input type="text" class="form-control" name="action" id="field_action" ng-model="vm.notification.action"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.notification.latestactionby" for="field_latestactionby">Latestactionby</label><input type="text" class="form-control" name="latestactionby" id="field_latestactionby" ng-model="vm.notification.latestactionby"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/notification/notifications.html','<div><h2 data-translate="investhryApp.notification.home.title">Notifications</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="notification.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.notification.home.createLabel">Create new Notification</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.notification.projectid">Projectid</span></th><th><span data-translate="investhryApp.notification.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.notification.nodalofficer">Nodalofficer</span></th><th><span data-translate="investhryApp.notification.fieldofficer">Fieldofficer</span></th><th><span data-translate="investhryApp.notification.accountofficer">Accountofficer</span></th><th><span data-translate="investhryApp.notification.investor">Investor</span></th><th><span data-translate="investhryApp.notification.deskofficer">Deskofficer</span></th><th><span data-translate="investhryApp.notification.rm">Rm</span></th><th><span data-translate="investhryApp.notification.executive">Executive</span></th><th><span data-translate="investhryApp.notification.admin">Admin</span></th><th><span data-translate="investhryApp.notification.latestaction">Latestaction</span></th><th><span data-translate="investhryApp.notification.latestactiondate">Latestactiondate</span></th><th><span data-translate="investhryApp.notification.action">Action</span></th><th><span data-translate="investhryApp.notification.latestactionby">Latestactionby</span></th><th></th></tr></thead><tbody><tr ng-repeat="notification in vm.notifications track by notification.id"><td><a ui-sref="notification-detail({id:notification.id})">{{notification.id}}</a></td><td>{{notification.projectid}}</td><td>{{notification.serviceid}}</td><td>{{notification.nodalofficer}}</td><td>{{notification.fieldofficer}}</td><td>{{notification.accountofficer}}</td><td>{{notification.investor}}</td><td>{{notification.deskofficer}}</td><td>{{notification.rm}}</td><td>{{notification.executive}}</td><td>{{notification.admin}}</td><td>{{notification.latestaction}}</td><td>{{notification.latestactiondate | date:\'medium\'}}</td><td>{{notification.action}}</td><td>{{notification.latestactionby}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="notification-detail({id:notification.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="notification.edit({id:notification.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="notification.delete({id:notification.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/nsws-user-details/nsws-user-details-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.nswsUserDetails.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.nswsUserDetails.delete.question" translate-values="{id: \'{{vm.nswsUserDetails.id}}\'}">Are you sure you want to delete this Nsws User Details?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/nsws-user-details/nsws-user-details-detail.html','<div><h2><span data-translate="investhryApp.nswsUserDetails.detail.title">Nsws User Details</span> {{vm.nswsUserDetails.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.nswsUserDetails.mobile">Mobile</span></dt><dd><span>{{vm.nswsUserDetails.mobile}}</span></dd><dt><span data-translate="investhryApp.nswsUserDetails.email">Email</span></dt><dd><span>{{vm.nswsUserDetails.email}}</span></dd><dt><span data-translate="investhryApp.nswsUserDetails.investorSwsId">Investor Sws Id</span></dt><dd><span>{{vm.nswsUserDetails.investorSwsId}}</span></dd><dt><span data-translate="investhryApp.nswsUserDetails.firstName">First Name</span></dt><dd><span>{{vm.nswsUserDetails.firstName}}</span></dd><dt><span data-translate="investhryApp.nswsUserDetails.lastName">Last Name</span></dt><dd><span>{{vm.nswsUserDetails.lastName}}</span></dd><dt><span data-translate="investhryApp.nswsUserDetails.projectId">Project Id</span></dt><dd><span>{{vm.nswsUserDetails.projectId}}</span></dd><dt><span data-translate="investhryApp.nswsUserDetails.investorreqId">Investorreq Id</span></dt><dd><span>{{vm.nswsUserDetails.investorreqId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="nsws-user-details-detail.edit({id:vm.nswsUserDetails.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/nsws-user-details/nsws-user-details-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myNswsUserDetailsLabel" data-translate="investhryApp.nswsUserDetails.home.createOrEditLabel">Create or edit a Nsws User Details</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.nswsUserDetails.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.nswsUserDetails.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nswsUserDetails.mobile" for="field_mobile">Mobile</label><input type="text" class="form-control" name="mobile" id="field_mobile" ng-model="vm.nswsUserDetails.mobile"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nswsUserDetails.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.nswsUserDetails.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nswsUserDetails.investorSwsId" for="field_investorSwsId">Investor Sws Id</label><input type="text" class="form-control" name="investorSwsId" id="field_investorSwsId" ng-model="vm.nswsUserDetails.investorSwsId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nswsUserDetails.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.nswsUserDetails.firstName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nswsUserDetails.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.nswsUserDetails.lastName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nswsUserDetails.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.nswsUserDetails.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.nswsUserDetails.investorreqId" for="field_investorreqId">Investorreq Id</label><input type="text" class="form-control" name="investorreqId" id="field_investorreqId" ng-model="vm.nswsUserDetails.investorreqId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/nsws-user-details/nsws-user-details.html','<div><h2 data-translate="investhryApp.nswsUserDetails.home.title">Nsws User Details</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="nsws-user-details.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.nswsUserDetails.home.createLabel">Create new Nsws User Details</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.nswsUserDetails.mobile">Mobile</span></th><th><span data-translate="investhryApp.nswsUserDetails.email">Email</span></th><th><span data-translate="investhryApp.nswsUserDetails.investorSwsId">Investor Sws Id</span></th><th><span data-translate="investhryApp.nswsUserDetails.firstName">First Name</span></th><th><span data-translate="investhryApp.nswsUserDetails.lastName">Last Name</span></th><th><span data-translate="investhryApp.nswsUserDetails.projectId">Project Id</span></th><th><span data-translate="investhryApp.nswsUserDetails.investorreqId">Investorreq Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="nswsUserDetails in vm.nswsUserDetails track by nswsUserDetails.id"><td><a ui-sref="nsws-user-details-detail({id:nswsUserDetails.id})">{{nswsUserDetails.id}}</a></td><td>{{nswsUserDetails.mobile}}</td><td>{{nswsUserDetails.email}}</td><td>{{nswsUserDetails.investorSwsId}}</td><td>{{nswsUserDetails.firstName}}</td><td>{{nswsUserDetails.lastName}}</td><td>{{nswsUserDetails.projectId}}</td><td>{{nswsUserDetails.investorreqId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="nsws-user-details-detail({id:nswsUserDetails.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="nsws-user-details.edit({id:nswsUserDetails.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="nsws-user-details.delete({id:nswsUserDetails.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/particular/particular-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.particular.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.particular.delete.question" translate-values="{id: \'{{vm.particular.id}}\'}">Are you sure you want to delete this Particular?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/particular/particular-detail.html','<div class="container"><h2><span data-translate="investhryApp.particular.detail.title">Particular</span> {{vm.particular.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.particular.particulars">Particulars</span></dt><dd><span>{{vm.particular.particulars}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="particular-detail.edit({id:vm.particular.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/particular/particular-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myParticularLabel" data-translate="investhryApp.particular.home.createOrEditLabel">Create or edit a Particular</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.particular.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.particular.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.particular.particulars" for="field_particulars">Particulars</label><input type="text" class="form-control" name="particulars" id="field_particulars" ng-model="vm.particular.particulars" required><div ng-show="editForm.particulars.$invalid"><p class="help-block" ng-show="editForm.particulars.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/particular/particulars.html','<div class="container"><h2 data-translate="investhryApp.particular.home.title">Particulars</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="particular.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.particular.home.createLabel">Create new Particular</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.particular.particulars">Particulars</span></th><th></th></tr></thead><tbody><tr ng-repeat="particular in vm.particulars track by particular.id"><td><a ui-sref="particular-detail({id:particular.id})">{{particular.id}}</a></td><td>{{particular.particulars}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="particular-detail({id:particular.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="particular.edit({id:particular.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="particular.delete({id:particular.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/policy-details/policy-details-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.policyDetails.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.policyDetails.delete.question" translate-values="{id: \'{{vm.policyDetails.id}}\'}">Are you sure you want to delete this Policy Details?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/policy-details/policy-details-detail.html','<div><h2><span data-translate="investhryApp.policyDetails.detail.title">Policy Details</span> {{vm.policyDetails.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.policyDetails.name">Name</span></dt><dd><span>{{vm.policyDetails.name}}</span></dd><dt><span data-translate="investhryApp.policyDetails.file">File</span></dt><dd><span>{{vm.policyDetails.file}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="policy-details-detail.edit({id:vm.policyDetails.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/policy-details/policy-details-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPolicyDetailsLabel" data-translate="investhryApp.policyDetails.home.createOrEditLabel">Create or edit a Policy Details</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.policyDetails.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.policyDetails.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.policyDetails.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.policyDetails.name"></div><div class="form-group"><label class="control-label" for="field_file">Policy file (in ".pdf" format)</label><input type="file" class="form-control" name="field_file" id="field_file" file-model="vm.fileAttachemnt" required><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/policy-details/policy-details.html','<div><h2 data-translate="investhryApp.policyDetails.home.title">Policy Details</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="policy-details.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.policyDetails.home.createLabel">Create new Policy Details</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.policyDetails.name">Name</span></th><th><span data-translate="investhryApp.policyDetails.file">File</span></th><th></th></tr></thead><tbody><tr ng-repeat="policyDetails in vm.policyDetails track by policyDetails.id"><td><a ui-sref="policy-details-detail({id:policyDetails.id})">{{policyDetails.id}}</a></td><td>{{policyDetails.name}}</td><td>{{policyDetails.file}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="policy-details-detail({id:policyDetails.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="policy-details.edit({id:policyDetails.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="policy-details.delete({id:policyDetails.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/project/project-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.project.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.project.delete.question" translate-values="{id: \'{{vm.project.id}}\'}">Are you sure you want to delete this Project?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/project/project-detail.html','<div><h2><span data-translate="investhryApp.project.detail.title">Project</span> {{vm.project.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.project.mouapplicable">Mouapplicable</span></dt><dd><span>{{vm.project.mouapplicable}}</span></dd><dt><span data-translate="investhryApp.project.mousignyear">Mousignyear</span></dt><dd><span>{{vm.project.mousignyear}}</span></dd><dt><span data-translate="investhryApp.project.mouidnumber">Mouidnumber</span></dt><dd><span>{{vm.project.mouidnumber}}</span></dd><dt><span data-translate="investhryApp.project.firstname">Firstname</span></dt><dd><span>{{vm.project.firstname}}</span></dd><dt><span data-translate="investhryApp.project.middlename">Middlename</span></dt><dd><span>{{vm.project.middlename}}</span></dd><dt><span data-translate="investhryApp.project.lastname">Lastname</span></dt><dd><span>{{vm.project.lastname}}</span></dd><dt><span data-translate="investhryApp.project.address1">Address 1</span></dt><dd><span>{{vm.project.address1}}</span></dd><dt><span data-translate="investhryApp.project.address2">Address 2</span></dt><dd><span>{{vm.project.address2}}</span></dd><dt><span data-translate="investhryApp.project.address3">Address 3</span></dt><dd><span>{{vm.project.address3}}</span></dd><dt><span data-translate="investhryApp.project.emailprimary">Emailprimary</span></dt><dd><span>{{vm.project.emailprimary}}</span></dd><dt><span data-translate="investhryApp.project.emailsecondary">Emailsecondary</span></dt><dd><span>{{vm.project.emailsecondary}}</span></dd><dt><span data-translate="investhryApp.project.userlogin">Userlogin</span></dt><dd><span>{{vm.project.userlogin}}</span></dd><dt><span data-translate="investhryApp.project.cityname">Cityname</span></dt><dd><span>{{vm.project.cityname}}</span></dd><dt><span data-translate="investhryApp.project.countryname">Countryname</span></dt><dd><span>{{vm.project.countryname}}</span></dd><dt><span data-translate="investhryApp.project.statename">Statename</span></dt><dd><span>{{vm.project.statename}}</span></dd><dt><span data-translate="investhryApp.project.createdate">Createdate</span></dt><dd><span>{{vm.project.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project.updatedate">Updatedate</span></dt><dd><span>{{vm.project.updatedate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project.cafpin">Cafpin</span></dt><dd><span>{{vm.project.cafpin}}</span></dd><dt><span data-translate="investhryApp.project.pincode">Pincode</span></dt><dd><span>{{vm.project.pincode}}</span></dd><dt><span data-translate="investhryApp.project.phonenumber">Phonenumber</span></dt><dd><span>{{vm.project.phonenumber}}</span></dd><dt><span data-translate="investhryApp.project.mobilenumber">Mobilenumber</span></dt><dd><span>{{vm.project.mobilenumber}}</span></dd><dt><span data-translate="investhryApp.project.promoter_md_director">Promoter Md Director</span></dt><dd><span>{{vm.project.promoter_md_director}}</span></dd><dt><span data-translate="investhryApp.project.designation">Designation</span></dt><dd><span>{{vm.project.designation}}</span></dd><dt><span data-translate="investhryApp.project.businessentity">Businessentity</span></dt><dd><span>{{vm.project.businessentity}}</span></dd><dt><span data-translate="investhryApp.project.director_promoter_md_ceo_number">Director Promoter Md Ceo Number</span></dt><dd><span>{{vm.project.director_promoter_md_ceo_number}}</span></dd><dt><span data-translate="investhryApp.project.pan_number">Pan Number</span></dt><dd><span>{{vm.project.pan_number}}</span></dd><dt><span data-translate="investhryApp.project.aadhar_number">Aadhar Number</span></dt><dd><span>{{vm.project.aadhar_number}}</span></dd><dt><span data-translate="investhryApp.project.nri">Nri</span></dt><dd><span>{{vm.project.nri}}</span></dd><dt><span data-translate="investhryApp.project.tin_vat_number">Tin Vat Number</span></dt><dd><span>{{vm.project.tin_vat_number}}</span></dd><dt><span data-translate="investhryApp.project.cst_number">Cst Number</span></dt><dd><span>{{vm.project.cst_number}}</span></dd><dt><span data-translate="investhryApp.project.businessentitytype">Businessentitytype</span></dt><dd><span>{{vm.project.businessentitytype}}</span></dd><dt><span data-translate="investhryApp.project.gstnumber">Gstnumber</span></dt><dd><span>{{vm.project.gstnumber}}</span></dd><dt><span data-translate="investhryApp.project.siteaddress">Siteaddress</span></dt><dd><span>{{vm.project.siteaddress}}</span></dd><dt><span data-translate="investhryApp.project.multyvillageinvolved">Multyvillageinvolved</span></dt><dd><span>{{vm.project.multyvillageinvolved}}</span></dd><dt><span data-translate="investhryApp.project.villageinvolved">Villageinvolved</span></dt><dd><span>{{vm.project.villageinvolved}}</span></dd><dt><span data-translate="investhryApp.project.falls_in_aravalli">Falls In Aravalli</span></dt><dd><span>{{vm.project.falls_in_aravalli}}</span></dd><dt><span data-translate="investhryApp.project.islandprocured">Islandprocured</span></dt><dd><span>{{vm.project.islandprocured}}</span></dd><dt><span data-translate="investhryApp.project.allotedbyhsiidc">Allotedbyhsiidc</span></dt><dd><span>{{vm.project.allotedbyhsiidc}}</span></dd><dt><span data-translate="investhryApp.project.estate">Estate</span></dt><dd><span>{{vm.project.estate}}</span></dd><dt><span data-translate="investhryApp.project.cluster">Cluster</span></dt><dd><span>{{vm.project.cluster}}</span></dd><dt><span data-translate="investhryApp.project.phase">Phase</span></dt><dd><span>{{vm.project.phase}}</span></dd><dt><span data-translate="investhryApp.project.sector">Sector</span></dt><dd><span>{{vm.project.sector}}</span></dd><dt><span data-translate="investhryApp.project.plotno">Plotno</span></dt><dd><span>{{vm.project.plotno}}</span></dd><dt><span data-translate="investhryApp.project.hadbastno">Hadbastno</span></dt><dd><span>{{vm.project.hadbastno}}</span></dd><dt><span data-translate="investhryApp.project.liesunder_mc">Liesunder Mc</span></dt><dd><span>{{vm.project.liesunder_mc}}</span></dd><dt><span data-translate="investhryApp.project.distance_from_mc">Distance From Mc</span></dt><dd><span>{{vm.project.distance_from_mc}}</span></dd><dt><span data-translate="investhryApp.project.islocated_in_urban">Islocated In Urban</span></dt><dd><span>{{vm.project.islocated_in_urban}}</span></dd><dt><span data-translate="investhryApp.project.totalproposedprojectarea">Totalproposedprojectarea</span></dt><dd><span>{{vm.project.totalproposedprojectarea}}</span></dd><dt><span data-translate="investhryApp.project.proposedbuilt_up_area">Proposedbuilt Up Area</span></dt><dd><span>{{vm.project.proposedbuilt_up_area}}</span></dd><dt><span data-translate="investhryApp.project.certifiedownership">Certifiedownership</span></dt><dd><span>{{vm.project.certifiedownership}}</span></dd><dt><span data-translate="investhryApp.project.leaseapplicable">Leaseapplicable</span></dt><dd><span>{{vm.project.leaseapplicable}}</span></dd><dt><span data-translate="investhryApp.project.landagreementapplicable">Landagreementapplicable</span></dt><dd><span>{{vm.project.landagreementapplicable}}</span></dd><dt><span data-translate="investhryApp.project.intersectiondistance">Intersectiondistance</span></dt><dd><span>{{vm.project.intersectiondistance}}</span></dd><dt><span data-translate="investhryApp.project.railwaydistance">Railwaydistance</span></dt><dd><span>{{vm.project.railwaydistance}}</span></dd><dt><span data-translate="investhryApp.project.confirmitylanduse">Confirmitylanduse</span></dt><dd><span>{{vm.project.confirmitylanduse}}</span></dd><dt><span data-translate="investhryApp.project.existing_building_applicable">Existing Building Applicable</span></dt><dd><span>{{vm.project.existing_building_applicable}}</span></dd><dt><span data-translate="investhryApp.project.site_situated_in_controlled_area">Site Situated In Controlled Area</span></dt><dd><span>{{vm.project.site_situated_in_controlled_area}}</span></dd><dt><span data-translate="investhryApp.project.buildingexisted">Buildingexisted</span></dt><dd><span>{{vm.project.buildingexisted}}</span></dd><dt><span data-translate="investhryApp.project.district">District</span></dt><dd><span>{{vm.project.district}}</span></dd><dt><span data-translate="investhryApp.project.block">Block</span></dt><dd><span>{{vm.project.block}}</span></dd><dt><span data-translate="investhryApp.project.city_town_village">City Town Village</span></dt><dd><span>{{vm.project.city_town_village}}</span></dd><dt><span data-translate="investhryApp.project.connectingroad">Connectingroad</span></dt><dd><span>{{vm.project.connectingroad}}</span></dd><dt><span data-translate="investhryApp.project.landzoneuse_type">Landzoneuse Type</span></dt><dd><span>{{vm.project.landzoneuse_type}}</span></dd><dt><span data-translate="investhryApp.project.tehsil_subtehsil">Tehsil Subtehsil</span></dt><dd><span>{{vm.project.tehsil_subtehsil}}</span></dd><dt><span data-translate="investhryApp.project.clurequired">Clurequired</span></dt><dd><span>{{vm.project.clurequired}}</span></dd><dt><span data-translate="investhryApp.project.land_cost">Land Cost</span></dt><dd><span>{{vm.project.land_cost}}</span></dd><dt><span data-translate="investhryApp.project.building_cost">Building Cost</span></dt><dd><span>{{vm.project.building_cost}}</span></dd><dt><span data-translate="investhryApp.project.machinery_cost">Machinery Cost</span></dt><dd><span>{{vm.project.machinery_cost}}</span></dd><dt><span data-translate="investhryApp.project.misc_assests">Misc Assests</span></dt><dd><span>{{vm.project.misc_assests}}</span></dd><dt><span data-translate="investhryApp.project.total_project_cost">Total Project Cost</span></dt><dd><span>{{vm.project.total_project_cost}}</span></dd><dt><span data-translate="investhryApp.project.isfdi">Isfdi</span></dt><dd><span>{{vm.project.isfdi}}</span></dd><dt><span data-translate="investhryApp.project.fdivalue">Fdivalue</span></dt><dd><span>{{vm.project.fdivalue}}</span></dd><dt><span data-translate="investhryApp.project.project_construction_start_date">Project Construction Start Date</span></dt><dd><span>{{vm.project.project_construction_start_date | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project.commercial_activity_start_date">Commercial Activity Start Date</span></dt><dd><span>{{vm.project.commercial_activity_start_date | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project.fdi_country">Fdi Country</span></dt><dd><span>{{vm.project.fdi_country}}</span></dd><dt><span data-translate="investhryApp.project.foreign_funding_source">Foreign Funding Source</span></dt><dd><span>{{vm.project.foreign_funding_source}}</span></dd><dt><span data-translate="investhryApp.project.totalpurposedemployment">Totalpurposedemployment</span></dt><dd><span>{{vm.project.totalpurposedemployment}}</span></dd><dt><span data-translate="investhryApp.project.projectrawmaterialid">Projectrawmaterialid</span></dt><dd><span>{{vm.project.projectrawmaterialid}}</span></dd><dt><span data-translate="investhryApp.project.productid">Productid</span></dt><dd><span>{{vm.project.productid}}</span></dd><dt><span data-translate="investhryApp.project.processid">Processid</span></dt><dd><span>{{vm.project.processid}}</span></dd><dt><span data-translate="investhryApp.project.manufacturing_flow_document">Manufacturing Flow Document</span></dt><dd><span>{{vm.project.manufacturing_flow_document}}</span></dd><dt><span data-translate="investhryApp.project.temporaryrequired">Temporaryrequired</span></dt><dd><span>{{vm.project.temporaryrequired}}</span></dd><dt><span data-translate="investhryApp.project.tem_load_existing">Tem Load Existing</span></dt><dd><span>{{vm.project.tem_load_existing}}</span></dd><dt><span data-translate="investhryApp.project.tem_account_number">Tem Account Number</span></dt><dd><span>{{vm.project.tem_account_number}}</span></dd><dt><span data-translate="investhryApp.project.temp_existing_load_demand_kw">Temp Existing Load Demand Kw</span></dt><dd><span>{{vm.project.temp_existing_load_demand_kw}}</span></dd><dt><span data-translate="investhryApp.project.temp_existing_load_demand_kva">Temp Existing Load Demand Kva</span></dt><dd><span>{{vm.project.temp_existing_load_demand_kva}}</span></dd><dt><span data-translate="investhryApp.project.temp_new_load_demand_kw">Temp New Load Demand Kw</span></dt><dd><span>{{vm.project.temp_new_load_demand_kw}}</span></dd><dt><span data-translate="investhryApp.project.temp_new_load_demand_kva">Temp New Load Demand Kva</span></dt><dd><span>{{vm.project.temp_new_load_demand_kva}}</span></dd><dt><span data-translate="investhryApp.project.temp_load_demand_date">Temp Load Demand Date</span></dt><dd><span>{{vm.project.temp_load_demand_date | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project.regular_load_required">Regular Load Required</span></dt><dd><span>{{vm.project.regular_load_required}}</span></dd><dt><span data-translate="investhryApp.project.regular_existing_connection">Regular Existing Connection</span></dt><dd><span>{{vm.project.regular_existing_connection}}</span></dd><dt><span data-translate="investhryApp.project.regular_account_number">Regular Account Number</span></dt><dd><span>{{vm.project.regular_account_number}}</span></dd><dt><span data-translate="investhryApp.project.regular_existing_load_ifany_kw">Regular Existing Load Ifany Kw</span></dt><dd><span>{{vm.project.regular_existing_load_ifany_kw}}</span></dd><dt><span data-translate="investhryApp.project.regular_existing_load_ifany_kva">Regular Existing Load Ifany Kva</span></dt><dd><span>{{vm.project.regular_existing_load_ifany_kva}}</span></dd><dt><span data-translate="investhryApp.project.regular_new_load_demand_kw">Regular New Load Demand Kw</span></dt><dd><span>{{vm.project.regular_new_load_demand_kw}}</span></dd><dt><span data-translate="investhryApp.project.regular_new_load_demand_kva">Regular New Load Demand Kva</span></dt><dd><span>{{vm.project.regular_new_load_demand_kva}}</span></dd><dt><span data-translate="investhryApp.project.regular_load_demand_date">Regular Load Demand Date</span></dt><dd><span>{{vm.project.regular_load_demand_date | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project.customertype">Customertype</span></dt><dd><span>{{vm.project.customertype}}</span></dd><dt><span data-translate="investhryApp.project.source_of_water_supply">Source Of Water Supply</span></dt><dd><span>{{vm.project.source_of_water_supply}}</span></dd><dt><span data-translate="investhryApp.project.mode_of_disposal_for_discharge">Mode Of Disposal For Discharge</span></dt><dd><span>{{vm.project.mode_of_disposal_for_discharge}}</span></dd><dt><span data-translate="investhryApp.project.recycling_process">Recycling Process</span></dt><dd><span>{{vm.project.recycling_process}}</span></dd><dt><span data-translate="investhryApp.project.recycling_cooling">Recycling Cooling</span></dt><dd><span>{{vm.project.recycling_cooling}}</span></dd><dt><span data-translate="investhryApp.project.recycling_domestic">Recycling Domestic</span></dt><dd><span>{{vm.project.recycling_domestic}}</span></dd><dt><span data-translate="investhryApp.project.recycling_other">Recycling Other</span></dt><dd><span>{{vm.project.recycling_other}}</span></dd><dt><span data-translate="investhryApp.project.sourcewatersupplyother">Sourcewatersupplyother</span></dt><dd><span>{{vm.project.sourcewatersupplyother}}</span></dd><dt><span data-translate="investhryApp.project.modedisposalother">Modedisposalother</span></dt><dd><span>{{vm.project.modedisposalother}}</span></dd><dt><span data-translate="investhryApp.project.water_process">Water Process</span></dt><dd><span>{{vm.project.water_process}}</span></dd><dt><span data-translate="investhryApp.project.water_cooling">Water Cooling</span></dt><dd><span>{{vm.project.water_cooling}}</span></dd><dt><span data-translate="investhryApp.project.water_domestic">Water Domestic</span></dt><dd><span>{{vm.project.water_domestic}}</span></dd><dt><span data-translate="investhryApp.project.water_other">Water Other</span></dt><dd><span>{{vm.project.water_other}}</span></dd><dt><span data-translate="investhryApp.project.waste_water_process">Waste Water Process</span></dt><dd><span>{{vm.project.waste_water_process}}</span></dd><dt><span data-translate="investhryApp.project.waste_water_cooling">Waste Water Cooling</span></dt><dd><span>{{vm.project.waste_water_cooling}}</span></dd><dt><span data-translate="investhryApp.project.waste_water_domesting">Waste Water Domesting</span></dt><dd><span>{{vm.project.waste_water_domesting}}</span></dd><dt><span data-translate="investhryApp.project.waste_water_other">Waste Water Other</span></dt><dd><span>{{vm.project.waste_water_other}}</span></dd><dt><span data-translate="investhryApp.project.acceptance">Acceptance</span></dt><dd><span>{{vm.project.acceptance}}</span></dd><dt><span data-translate="investhryApp.project.applicationdate">Applicationdate</span></dt><dd><span>{{vm.project.applicationdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project.place">Place</span></dt><dd><span>{{vm.project.place}}</span></dd><dt><span data-translate="investhryApp.project.projectpurpose">Projectpurpose</span></dt><dd><span>{{vm.project.projectpurpose}}</span></dd><dt><span data-translate="investhryApp.project.niccode">Niccode</span></dt><dd><span>{{vm.project.niccode}}</span></dd><dt><span data-translate="investhryApp.project.existing_regulatory_approval">Existing Regulatory Approval</span></dt><dd><span>{{vm.project.existing_regulatory_approval}}</span></dd><dt><span data-translate="investhryApp.project.edc_sif_clu_fee_paid_applicable">Edc Sif Clu Fee Paid Applicable</span></dt><dd><span>{{vm.project.edc_sif_clu_fee_paid_applicable}}</span></dd><dt><span data-translate="investhryApp.project.approval_application_form">Approval Application Form</span></dt><dd><span>{{vm.project.approval_application_form}}</span></dd><dt><span data-translate="investhryApp.project.category_of_project">Category Of Project</span></dt><dd><span>{{vm.project.category_of_project}}</span></dd><dt><span data-translate="investhryApp.project.collaboration_with_foreign_country">Collaboration With Foreign Country</span></dt><dd><span>{{vm.project.collaboration_with_foreign_country}}</span></dd><dt><span data-translate="investhryApp.project.projectype">Projectype</span></dt><dd><span>{{vm.project.projectype}}</span></dd><dt><span data-translate="investhryApp.project.sectorname">Sectorname</span></dt><dd><span>{{vm.project.sectorname}}</span></dd><dt><span data-translate="investhryApp.project.size_of_industry">Size Of Industry</span></dt><dd><span>{{vm.project.size_of_industry}}</span></dd><dt><span data-translate="investhryApp.project.sectorother">Sectorother</span></dt><dd><span>{{vm.project.sectorother}}</span></dd><dt><span data-translate="investhryApp.project.assignedRM">Assigned RM</span></dt><dd><span>{{vm.project.assignedRM}}</span></dd><dt><span data-translate="investhryApp.project.isdeactivated">Isdeactivated</span></dt><dd><span>{{vm.project.isdeactivated}}</span></dd><dt><span data-translate="investhryApp.project.deactivatedby">Deactivatedby</span></dt><dd><span>{{vm.project.deactivatedby}}</span></dd><dt><span data-translate="investhryApp.project.deactivateddate">Deactivateddate</span></dt><dd><span>{{vm.project.deactivateddate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project.projectlevel">Projectlevel</span></dt><dd><span>{{vm.project.projectlevel}}</span></dd><dt><span data-translate="investhryApp.project.isdraft">Isdraft</span></dt><dd><span>{{vm.project.isdraft}}</span></dd><dt><span data-translate="investhryApp.project.caftype">Caftype</span></dt><dd><span>{{vm.project.caftype}}</span></dd><dt><span data-translate="investhryApp.project.landrequired">Landrequired</span></dt><dd><span>{{vm.project.landrequired}}</span></dd><dt><span data-translate="investhryApp.project.plotsize">Plotsize</span></dt><dd><span>{{vm.project.plotsize}}</span></dd><dt><span data-translate="investhryApp.project.estatename">Estatename</span></dt><dd><span>{{vm.project.estatename}}</span></dd><dt><span data-translate="investhryApp.project.purchaserate">Purchaserate</span></dt><dd><span>{{vm.project.purchaserate}}</span></dd><dt><span data-translate="investhryApp.project.estatelocation">Estatelocation</span></dt><dd><span>{{vm.project.estatelocation}}</span></dd><dt><span data-translate="investhryApp.project.agencyname">Agencyname</span></dt><dd><span>{{vm.project.agencyname}}</span></dd><dt><span data-translate="investhryApp.project.village">Village</span></dt><dd><span>{{vm.project.village}}</span></dd><dt><span data-translate="investhryApp.project.tehsil">Tehsil</span></dt><dd><span>{{vm.project.tehsil}}</span></dd><dt><span data-translate="investhryApp.project.landusetype">Landusetype</span></dt><dd><span>{{vm.project.landusetype}}</span></dd><dt><span data-translate="investhryApp.project.landrequirementindistrict">Landrequirementindistrict</span></dt><dd><span>{{vm.project.landrequirementindistrict}}</span></dd><dt><span data-translate="investhryApp.project.product">Product</span></dt><dd><span>{{vm.project.product}}</span></dd><dt><span data-translate="investhryApp.project.uamnumber">Uamnumber</span></dt><dd><span>{{vm.project.uamnumber}}</span></dd><dt><span data-translate="investhryApp.project.nri_investment">Nri Investment</span></dt><dd><span>{{vm.project.nri_investment}}</span></dd><dt><span data-translate="investhryApp.project.foreign_investment">Foreign Investment</span></dt><dd><span>{{vm.project.foreign_investment}}</span></dd><dt><span data-translate="investhryApp.project.isulb">Isulb</span></dt><dd><span>{{vm.project.isulb}}</span></dd><dt><span data-translate="investhryApp.project.mc">Mc</span></dt><dd><span>{{vm.project.mc}}</span></dd><dt><span data-translate="investhryApp.project.blockCategory">Block Category</span></dt><dd><span>{{vm.project.blockCategory}}</span></dd><dt><span data-translate="investhryApp.project.investmentType">Investment Type</span></dt><dd><span>{{vm.project.investmentType}}</span></dd><dt><span data-translate="investhryApp.project.otherInvestmetType">Other Investmet Type</span></dt><dd><span>{{vm.project.otherInvestmetType}}</span></dd><dt><span data-translate="investhryApp.project.otherFDI">Other FDI</span></dt><dd><span>{{vm.project.otherFDI}}</span></dd><dt><span data-translate="investhryApp.project.prodctionStartDate">Prodction Start Date</span></dt><dd><span>{{vm.project.prodctionStartDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project.haryanadomicile">Haryanadomicile</span></dt><dd><span>{{vm.project.haryanadomicile}}</span></dd><dt><span data-translate="investhryApp.project.nonharyanadomicile">Nonharyanadomicile</span></dt><dd><span>{{vm.project.nonharyanadomicile}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="project-detail.edit({id:vm.project.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/project/project-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectLabel" data-translate="investhryApp.project.home.createOrEditLabel">Create or edit a Project</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.project.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.project.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.mouapplicable" for="field_mouapplicable">Mouapplicable</label><input type="checkbox" name="mouapplicable" id="field_mouapplicable" ng-model="vm.project.mouapplicable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.mousignyear" for="field_mousignyear">Mousignyear</label><input type="number" class="form-control" name="mousignyear" id="field_mousignyear" ng-model="vm.project.mousignyear"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.mouidnumber" for="field_mouidnumber">Mouidnumber</label><input type="text" class="form-control" name="mouidnumber" id="field_mouidnumber" ng-model="vm.project.mouidnumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.firstname" for="field_firstname">Firstname</label><input type="text" class="form-control" name="firstname" id="field_firstname" ng-model="vm.project.firstname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.middlename" for="field_middlename">Middlename</label><input type="text" class="form-control" name="middlename" id="field_middlename" ng-model="vm.project.middlename"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.lastname" for="field_lastname">Lastname</label><input type="text" class="form-control" name="lastname" id="field_lastname" ng-model="vm.project.lastname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.address1" for="field_address1">Address 1</label><input type="text" class="form-control" name="address1" id="field_address1" ng-model="vm.project.address1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.address2" for="field_address2">Address 2</label><input type="text" class="form-control" name="address2" id="field_address2" ng-model="vm.project.address2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.address3" for="field_address3">Address 3</label><input type="text" class="form-control" name="address3" id="field_address3" ng-model="vm.project.address3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.emailprimary" for="field_emailprimary">Emailprimary</label><input type="text" class="form-control" name="emailprimary" id="field_emailprimary" ng-model="vm.project.emailprimary"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.emailsecondary" for="field_emailsecondary">Emailsecondary</label><input type="text" class="form-control" name="emailsecondary" id="field_emailsecondary" ng-model="vm.project.emailsecondary"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.userlogin" for="field_userlogin">Userlogin</label><input type="text" class="form-control" name="userlogin" id="field_userlogin" ng-model="vm.project.userlogin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.cityname" for="field_cityname">Cityname</label><input type="text" class="form-control" name="cityname" id="field_cityname" ng-model="vm.project.cityname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.countryname" for="field_countryname">Countryname</label><input type="text" class="form-control" name="countryname" id="field_countryname" ng-model="vm.project.countryname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.statename" for="field_statename">Statename</label><input type="text" class="form-control" name="statename" id="field_statename" ng-model="vm.project.statename"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.project.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.project.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.project.cafpin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.pincode" for="field_pincode">Pincode</label><input type="text" class="form-control" name="pincode" id="field_pincode" ng-model="vm.project.pincode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.phonenumber" for="field_phonenumber">Phonenumber</label><input type="text" class="form-control" name="phonenumber" id="field_phonenumber" ng-model="vm.project.phonenumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.mobilenumber" for="field_mobilenumber">Mobilenumber</label><input type="text" class="form-control" name="mobilenumber" id="field_mobilenumber" ng-model="vm.project.mobilenumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.promoter_md_director" for="field_promoter_md_director">Promoter Md Director</label><input type="text" class="form-control" name="promoter_md_director" id="field_promoter_md_director" ng-model="vm.project.promoter_md_director"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.designation" for="field_designation">Designation</label><input type="text" class="form-control" name="designation" id="field_designation" ng-model="vm.project.designation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.businessentity" for="field_businessentity">Businessentity</label><input type="text" class="form-control" name="businessentity" id="field_businessentity" ng-model="vm.project.businessentity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.director_promoter_md_ceo_number" for="field_director_promoter_md_ceo_number">Director Promoter Md Ceo Number</label><input type="number" class="form-control" name="director_promoter_md_ceo_number" id="field_director_promoter_md_ceo_number" ng-model="vm.project.director_promoter_md_ceo_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.pan_number" for="field_pan_number">Pan Number</label><input type="text" class="form-control" name="pan_number" id="field_pan_number" ng-model="vm.project.pan_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.aadhar_number" for="field_aadhar_number">Aadhar Number</label><input type="text" class="form-control" name="aadhar_number" id="field_aadhar_number" ng-model="vm.project.aadhar_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.nri" for="field_nri">Nri</label><input type="checkbox" name="nri" id="field_nri" ng-model="vm.project.nri"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.tin_vat_number" for="field_tin_vat_number">Tin Vat Number</label><input type="text" class="form-control" name="tin_vat_number" id="field_tin_vat_number" ng-model="vm.project.tin_vat_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.cst_number" for="field_cst_number">Cst Number</label><input type="text" class="form-control" name="cst_number" id="field_cst_number" ng-model="vm.project.cst_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.businessentitytype" for="field_businessentitytype">Businessentitytype</label><input type="text" class="form-control" name="businessentitytype" id="field_businessentitytype" ng-model="vm.project.businessentitytype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.gstnumber" for="field_gstnumber">Gstnumber</label><input type="text" class="form-control" name="gstnumber" id="field_gstnumber" ng-model="vm.project.gstnumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.siteaddress" for="field_siteaddress">Siteaddress</label><input type="text" class="form-control" name="siteaddress" id="field_siteaddress" ng-model="vm.project.siteaddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.multyvillageinvolved" for="field_multyvillageinvolved">Multyvillageinvolved</label><input type="checkbox" name="multyvillageinvolved" id="field_multyvillageinvolved" ng-model="vm.project.multyvillageinvolved"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.villageinvolved" for="field_villageinvolved">Villageinvolved</label><input type="text" class="form-control" name="villageinvolved" id="field_villageinvolved" ng-model="vm.project.villageinvolved"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.falls_in_aravalli" for="field_falls_in_aravalli">Falls In Aravalli</label><input type="checkbox" name="falls_in_aravalli" id="field_falls_in_aravalli" ng-model="vm.project.falls_in_aravalli"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.islandprocured" for="field_islandprocured">Islandprocured</label><input type="checkbox" name="islandprocured" id="field_islandprocured" ng-model="vm.project.islandprocured"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.allotedbyhsiidc" for="field_allotedbyhsiidc">Allotedbyhsiidc</label><input type="checkbox" name="allotedbyhsiidc" id="field_allotedbyhsiidc" ng-model="vm.project.allotedbyhsiidc"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.estate" for="field_estate">Estate</label><input type="text" class="form-control" name="estate" id="field_estate" ng-model="vm.project.estate"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.cluster" for="field_cluster">Cluster</label><input type="text" class="form-control" name="cluster" id="field_cluster" ng-model="vm.project.cluster"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.phase" for="field_phase">Phase</label><input type="text" class="form-control" name="phase" id="field_phase" ng-model="vm.project.phase"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.sector" for="field_sector">Sector</label><input type="text" class="form-control" name="sector" id="field_sector" ng-model="vm.project.sector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.plotno" for="field_plotno">Plotno</label><input type="text" class="form-control" name="plotno" id="field_plotno" ng-model="vm.project.plotno"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.hadbastno" for="field_hadbastno">Hadbastno</label><input type="text" class="form-control" name="hadbastno" id="field_hadbastno" ng-model="vm.project.hadbastno"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.liesunder_mc" for="field_liesunder_mc">Liesunder Mc</label><input type="checkbox" name="liesunder_mc" id="field_liesunder_mc" ng-model="vm.project.liesunder_mc"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.distance_from_mc" for="field_distance_from_mc">Distance From Mc</label><input type="number" class="form-control" name="distance_from_mc" id="field_distance_from_mc" ng-model="vm.project.distance_from_mc"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.islocated_in_urban" for="field_islocated_in_urban">Islocated In Urban</label><input type="checkbox" name="islocated_in_urban" id="field_islocated_in_urban" ng-model="vm.project.islocated_in_urban"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.totalproposedprojectarea" for="field_totalproposedprojectarea">Totalproposedprojectarea</label><input type="number" class="form-control" name="totalproposedprojectarea" id="field_totalproposedprojectarea" ng-model="vm.project.totalproposedprojectarea"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.proposedbuilt_up_area" for="field_proposedbuilt_up_area">Proposedbuilt Up Area</label><input type="number" class="form-control" name="proposedbuilt_up_area" id="field_proposedbuilt_up_area" ng-model="vm.project.proposedbuilt_up_area"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.certifiedownership" for="field_certifiedownership">Certifiedownership</label><input type="checkbox" name="certifiedownership" id="field_certifiedownership" ng-model="vm.project.certifiedownership"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.leaseapplicable" for="field_leaseapplicable">Leaseapplicable</label><input type="checkbox" name="leaseapplicable" id="field_leaseapplicable" ng-model="vm.project.leaseapplicable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.landagreementapplicable" for="field_landagreementapplicable">Landagreementapplicable</label><input type="checkbox" name="landagreementapplicable" id="field_landagreementapplicable" ng-model="vm.project.landagreementapplicable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.intersectiondistance" for="field_intersectiondistance">Intersectiondistance</label><input type="checkbox" name="intersectiondistance" id="field_intersectiondistance" ng-model="vm.project.intersectiondistance"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.railwaydistance" for="field_railwaydistance">Railwaydistance</label><input type="checkbox" name="railwaydistance" id="field_railwaydistance" ng-model="vm.project.railwaydistance"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.confirmitylanduse" for="field_confirmitylanduse">Confirmitylanduse</label><input type="checkbox" name="confirmitylanduse" id="field_confirmitylanduse" ng-model="vm.project.confirmitylanduse"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.existing_building_applicable" for="field_existing_building_applicable">Existing Building Applicable</label><input type="checkbox" name="existing_building_applicable" id="field_existing_building_applicable" ng-model="vm.project.existing_building_applicable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.site_situated_in_controlled_area" for="field_site_situated_in_controlled_area">Site Situated In Controlled Area</label><input type="checkbox" name="site_situated_in_controlled_area" id="field_site_situated_in_controlled_area" ng-model="vm.project.site_situated_in_controlled_area"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.buildingexisted" for="field_buildingexisted">Buildingexisted</label><input type="text" class="form-control" name="buildingexisted" id="field_buildingexisted" ng-model="vm.project.buildingexisted"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.project.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.block" for="field_block">Block</label><input type="text" class="form-control" name="block" id="field_block" ng-model="vm.project.block"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.city_town_village" for="field_city_town_village">City Town Village</label><input type="text" class="form-control" name="city_town_village" id="field_city_town_village" ng-model="vm.project.city_town_village"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.connectingroad" for="field_connectingroad">Connectingroad</label><input type="text" class="form-control" name="connectingroad" id="field_connectingroad" ng-model="vm.project.connectingroad"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.landzoneuse_type" for="field_landzoneuse_type">Landzoneuse Type</label><input type="text" class="form-control" name="landzoneuse_type" id="field_landzoneuse_type" ng-model="vm.project.landzoneuse_type"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.tehsil_subtehsil" for="field_tehsil_subtehsil">Tehsil Subtehsil</label><input type="text" class="form-control" name="tehsil_subtehsil" id="field_tehsil_subtehsil" ng-model="vm.project.tehsil_subtehsil"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.clurequired" for="field_clurequired">Clurequired</label><input type="checkbox" name="clurequired" id="field_clurequired" ng-model="vm.project.clurequired"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.land_cost" for="field_land_cost">Land Cost</label><input type="number" class="form-control" name="land_cost" id="field_land_cost" ng-model="vm.project.land_cost"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.building_cost" for="field_building_cost">Building Cost</label><input type="number" class="form-control" name="building_cost" id="field_building_cost" ng-model="vm.project.building_cost"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.machinery_cost" for="field_machinery_cost">Machinery Cost</label><input type="number" class="form-control" name="machinery_cost" id="field_machinery_cost" ng-model="vm.project.machinery_cost"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.misc_assests" for="field_misc_assests">Misc Assests</label><input type="number" class="form-control" name="misc_assests" id="field_misc_assests" ng-model="vm.project.misc_assests"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.total_project_cost" for="field_total_project_cost">Total Project Cost</label><input type="number" class="form-control" name="total_project_cost" id="field_total_project_cost" ng-model="vm.project.total_project_cost"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.isfdi" for="field_isfdi">Isfdi</label><input type="checkbox" name="isfdi" id="field_isfdi" ng-model="vm.project.isfdi"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.fdivalue" for="field_fdivalue">Fdivalue</label><input type="number" class="form-control" name="fdivalue" id="field_fdivalue" ng-model="vm.project.fdivalue"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.project_construction_start_date" for="field_project_construction_start_date">Project Construction Start Date</label><div class="input-group"><input id="field_project_construction_start_date" type="text" class="form-control" name="project_construction_start_date" datetime-picker="{{dateformat}}" ng-model="vm.project.project_construction_start_date" is-open="vm.datePickerOpenStatus.project_construction_start_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'project_construction_start_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.commercial_activity_start_date" for="field_commercial_activity_start_date">Commercial Activity Start Date</label><div class="input-group"><input id="field_commercial_activity_start_date" type="text" class="form-control" name="commercial_activity_start_date" datetime-picker="{{dateformat}}" ng-model="vm.project.commercial_activity_start_date" is-open="vm.datePickerOpenStatus.commercial_activity_start_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'commercial_activity_start_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.fdi_country" for="field_fdi_country">Fdi Country</label><input type="text" class="form-control" name="fdi_country" id="field_fdi_country" ng-model="vm.project.fdi_country"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.foreign_funding_source" for="field_foreign_funding_source">Foreign Funding Source</label><input type="text" class="form-control" name="foreign_funding_source" id="field_foreign_funding_source" ng-model="vm.project.foreign_funding_source"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.totalpurposedemployment" for="field_totalpurposedemployment">Totalpurposedemployment</label><input type="number" class="form-control" name="totalpurposedemployment" id="field_totalpurposedemployment" ng-model="vm.project.totalpurposedemployment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.projectrawmaterialid" for="field_projectrawmaterialid">Projectrawmaterialid</label><input type="text" class="form-control" name="projectrawmaterialid" id="field_projectrawmaterialid" ng-model="vm.project.projectrawmaterialid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.productid" for="field_productid">Productid</label><input type="text" class="form-control" name="productid" id="field_productid" ng-model="vm.project.productid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.processid" for="field_processid">Processid</label><input type="text" class="form-control" name="processid" id="field_processid" ng-model="vm.project.processid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.manufacturing_flow_document" for="field_manufacturing_flow_document">Manufacturing Flow Document</label><input type="text" class="form-control" name="manufacturing_flow_document" id="field_manufacturing_flow_document" ng-model="vm.project.manufacturing_flow_document"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.temporaryrequired" for="field_temporaryrequired">Temporaryrequired</label><input type="checkbox" name="temporaryrequired" id="field_temporaryrequired" ng-model="vm.project.temporaryrequired"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.tem_load_existing" for="field_tem_load_existing">Tem Load Existing</label><input type="checkbox" name="tem_load_existing" id="field_tem_load_existing" ng-model="vm.project.tem_load_existing"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.tem_account_number" for="field_tem_account_number">Tem Account Number</label><input type="text" class="form-control" name="tem_account_number" id="field_tem_account_number" ng-model="vm.project.tem_account_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.temp_existing_load_demand_kw" for="field_temp_existing_load_demand_kw">Temp Existing Load Demand Kw</label><input type="number" class="form-control" name="temp_existing_load_demand_kw" id="field_temp_existing_load_demand_kw" ng-model="vm.project.temp_existing_load_demand_kw"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.temp_existing_load_demand_kva" for="field_temp_existing_load_demand_kva">Temp Existing Load Demand Kva</label><input type="number" class="form-control" name="temp_existing_load_demand_kva" id="field_temp_existing_load_demand_kva" ng-model="vm.project.temp_existing_load_demand_kva"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.temp_new_load_demand_kw" for="field_temp_new_load_demand_kw">Temp New Load Demand Kw</label><input type="number" class="form-control" name="temp_new_load_demand_kw" id="field_temp_new_load_demand_kw" ng-model="vm.project.temp_new_load_demand_kw"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.temp_new_load_demand_kva" for="field_temp_new_load_demand_kva">Temp New Load Demand Kva</label><input type="number" class="form-control" name="temp_new_load_demand_kva" id="field_temp_new_load_demand_kva" ng-model="vm.project.temp_new_load_demand_kva"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.temp_load_demand_date" for="field_temp_load_demand_date">Temp Load Demand Date</label><div class="input-group"><input id="field_temp_load_demand_date" type="text" class="form-control" name="temp_load_demand_date" datetime-picker="{{dateformat}}" ng-model="vm.project.temp_load_demand_date" is-open="vm.datePickerOpenStatus.temp_load_demand_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'temp_load_demand_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.regular_load_required" for="field_regular_load_required">Regular Load Required</label><input type="checkbox" name="regular_load_required" id="field_regular_load_required" ng-model="vm.project.regular_load_required"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.regular_existing_connection" for="field_regular_existing_connection">Regular Existing Connection</label><input type="checkbox" name="regular_existing_connection" id="field_regular_existing_connection" ng-model="vm.project.regular_existing_connection"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.regular_account_number" for="field_regular_account_number">Regular Account Number</label><input type="text" class="form-control" name="regular_account_number" id="field_regular_account_number" ng-model="vm.project.regular_account_number"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.regular_existing_load_ifany_kw" for="field_regular_existing_load_ifany_kw">Regular Existing Load Ifany Kw</label><input type="number" class="form-control" name="regular_existing_load_ifany_kw" id="field_regular_existing_load_ifany_kw" ng-model="vm.project.regular_existing_load_ifany_kw"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.regular_existing_load_ifany_kva" for="field_regular_existing_load_ifany_kva">Regular Existing Load Ifany Kva</label><input type="number" class="form-control" name="regular_existing_load_ifany_kva" id="field_regular_existing_load_ifany_kva" ng-model="vm.project.regular_existing_load_ifany_kva"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.regular_new_load_demand_kw" for="field_regular_new_load_demand_kw">Regular New Load Demand Kw</label><input type="number" class="form-control" name="regular_new_load_demand_kw" id="field_regular_new_load_demand_kw" ng-model="vm.project.regular_new_load_demand_kw"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.regular_new_load_demand_kva" for="field_regular_new_load_demand_kva">Regular New Load Demand Kva</label><input type="number" class="form-control" name="regular_new_load_demand_kva" id="field_regular_new_load_demand_kva" ng-model="vm.project.regular_new_load_demand_kva"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.regular_load_demand_date" for="field_regular_load_demand_date">Regular Load Demand Date</label><div class="input-group"><input id="field_regular_load_demand_date" type="text" class="form-control" name="regular_load_demand_date" datetime-picker="{{dateformat}}" ng-model="vm.project.regular_load_demand_date" is-open="vm.datePickerOpenStatus.regular_load_demand_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'regular_load_demand_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.customertype" for="field_customertype">Customertype</label><input type="text" class="form-control" name="customertype" id="field_customertype" ng-model="vm.project.customertype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.source_of_water_supply" for="field_source_of_water_supply">Source Of Water Supply</label><input type="text" class="form-control" name="source_of_water_supply" id="field_source_of_water_supply" ng-model="vm.project.source_of_water_supply"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.mode_of_disposal_for_discharge" for="field_mode_of_disposal_for_discharge">Mode Of Disposal For Discharge</label><input type="text" class="form-control" name="mode_of_disposal_for_discharge" id="field_mode_of_disposal_for_discharge" ng-model="vm.project.mode_of_disposal_for_discharge"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.recycling_process" for="field_recycling_process">Recycling Process</label><input type="text" class="form-control" name="recycling_process" id="field_recycling_process" ng-model="vm.project.recycling_process"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.recycling_cooling" for="field_recycling_cooling">Recycling Cooling</label><input type="text" class="form-control" name="recycling_cooling" id="field_recycling_cooling" ng-model="vm.project.recycling_cooling"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.recycling_domestic" for="field_recycling_domestic">Recycling Domestic</label><input type="text" class="form-control" name="recycling_domestic" id="field_recycling_domestic" ng-model="vm.project.recycling_domestic"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.recycling_other" for="field_recycling_other">Recycling Other</label><input type="text" class="form-control" name="recycling_other" id="field_recycling_other" ng-model="vm.project.recycling_other"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.sourcewatersupplyother" for="field_sourcewatersupplyother">Sourcewatersupplyother</label><input type="text" class="form-control" name="sourcewatersupplyother" id="field_sourcewatersupplyother" ng-model="vm.project.sourcewatersupplyother"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.modedisposalother" for="field_modedisposalother">Modedisposalother</label><input type="text" class="form-control" name="modedisposalother" id="field_modedisposalother" ng-model="vm.project.modedisposalother"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.water_process" for="field_water_process">Water Process</label><input type="number" class="form-control" name="water_process" id="field_water_process" ng-model="vm.project.water_process"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.water_cooling" for="field_water_cooling">Water Cooling</label><input type="number" class="form-control" name="water_cooling" id="field_water_cooling" ng-model="vm.project.water_cooling"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.water_domestic" for="field_water_domestic">Water Domestic</label><input type="number" class="form-control" name="water_domestic" id="field_water_domestic" ng-model="vm.project.water_domestic"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.water_other" for="field_water_other">Water Other</label><input type="text" class="form-control" name="water_other" id="field_water_other" ng-model="vm.project.water_other"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.waste_water_process" for="field_waste_water_process">Waste Water Process</label><input type="number" class="form-control" name="waste_water_process" id="field_waste_water_process" ng-model="vm.project.waste_water_process"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.waste_water_cooling" for="field_waste_water_cooling">Waste Water Cooling</label><input type="number" class="form-control" name="waste_water_cooling" id="field_waste_water_cooling" ng-model="vm.project.waste_water_cooling"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.waste_water_domesting" for="field_waste_water_domesting">Waste Water Domesting</label><input type="number" class="form-control" name="waste_water_domesting" id="field_waste_water_domesting" ng-model="vm.project.waste_water_domesting"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.waste_water_other" for="field_waste_water_other">Waste Water Other</label><input type="text" class="form-control" name="waste_water_other" id="field_waste_water_other" ng-model="vm.project.waste_water_other"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.acceptance" for="field_acceptance">Acceptance</label><input type="checkbox" name="acceptance" id="field_acceptance" ng-model="vm.project.acceptance"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.applicationdate" for="field_applicationdate">Applicationdate</label><div class="input-group"><input id="field_applicationdate" type="text" class="form-control" name="applicationdate" datetime-picker="{{dateformat}}" ng-model="vm.project.applicationdate" is-open="vm.datePickerOpenStatus.applicationdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'applicationdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.place" for="field_place">Place</label><input type="text" class="form-control" name="place" id="field_place" ng-model="vm.project.place"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.projectpurpose" for="field_projectpurpose">Projectpurpose</label><input type="text" class="form-control" name="projectpurpose" id="field_projectpurpose" ng-model="vm.project.projectpurpose"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.niccode" for="field_niccode">Niccode</label><input type="text" class="form-control" name="niccode" id="field_niccode" ng-model="vm.project.niccode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.existing_regulatory_approval" for="field_existing_regulatory_approval">Existing Regulatory Approval</label><input type="checkbox" name="existing_regulatory_approval" id="field_existing_regulatory_approval" ng-model="vm.project.existing_regulatory_approval"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.edc_sif_clu_fee_paid_applicable" for="field_edc_sif_clu_fee_paid_applicable">Edc Sif Clu Fee Paid Applicable</label><input type="checkbox" name="edc_sif_clu_fee_paid_applicable" id="field_edc_sif_clu_fee_paid_applicable" ng-model="vm.project.edc_sif_clu_fee_paid_applicable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.approval_application_form" for="field_approval_application_form">Approval Application Form</label><input type="text" class="form-control" name="approval_application_form" id="field_approval_application_form" ng-model="vm.project.approval_application_form"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.category_of_project" for="field_category_of_project">Category Of Project</label><input type="text" class="form-control" name="category_of_project" id="field_category_of_project" ng-model="vm.project.category_of_project"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.collaboration_with_foreign_country" for="field_collaboration_with_foreign_country">Collaboration With Foreign Country</label><input type="text" class="form-control" name="collaboration_with_foreign_country" id="field_collaboration_with_foreign_country" ng-model="vm.project.collaboration_with_foreign_country"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.projectype" for="field_projectype">Projectype</label><input type="text" class="form-control" name="projectype" id="field_projectype" ng-model="vm.project.projectype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.sectorname" for="field_sectorname">Sectorname</label><input type="text" class="form-control" name="sectorname" id="field_sectorname" ng-model="vm.project.sectorname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.size_of_industry" for="field_size_of_industry">Size Of Industry</label><input type="text" class="form-control" name="size_of_industry" id="field_size_of_industry" ng-model="vm.project.size_of_industry"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.sectorother" for="field_sectorother">Sectorother</label><input type="text" class="form-control" name="sectorother" id="field_sectorother" ng-model="vm.project.sectorother"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.assignedRM" for="field_assignedRM">Assigned RM</label><input type="text" class="form-control" name="assignedRM" id="field_assignedRM" ng-model="vm.project.assignedRM"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.isdeactivated" for="field_isdeactivated">Isdeactivated</label><input type="checkbox" name="isdeactivated" id="field_isdeactivated" ng-model="vm.project.isdeactivated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.deactivatedby" for="field_deactivatedby">Deactivatedby</label><input type="text" class="form-control" name="deactivatedby" id="field_deactivatedby" ng-model="vm.project.deactivatedby"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.deactivateddate" for="field_deactivateddate">Deactivateddate</label><div class="input-group"><input id="field_deactivateddate" type="text" class="form-control" name="deactivateddate" datetime-picker="{{dateformat}}" ng-model="vm.project.deactivateddate" is-open="vm.datePickerOpenStatus.deactivateddate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'deactivateddate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.projectlevel" for="field_projectlevel">Projectlevel</label><input type="text" class="form-control" name="projectlevel" id="field_projectlevel" ng-model="vm.project.projectlevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.isdraft" for="field_isdraft">Isdraft</label><input type="checkbox" name="isdraft" id="field_isdraft" ng-model="vm.project.isdraft"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.caftype" for="field_caftype">Caftype</label><input type="text" class="form-control" name="caftype" id="field_caftype" ng-model="vm.project.caftype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.landrequired" for="field_landrequired">Landrequired</label><input type="text" class="form-control" name="landrequired" id="field_landrequired" ng-model="vm.project.landrequired"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.plotsize" for="field_plotsize">Plotsize</label><input type="text" class="form-control" name="plotsize" id="field_plotsize" ng-model="vm.project.plotsize"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.estatename" for="field_estatename">Estatename</label><input type="text" class="form-control" name="estatename" id="field_estatename" ng-model="vm.project.estatename"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.purchaserate" for="field_purchaserate">Purchaserate</label><input type="text" class="form-control" name="purchaserate" id="field_purchaserate" ng-model="vm.project.purchaserate"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.estatelocation" for="field_estatelocation">Estatelocation</label><input type="text" class="form-control" name="estatelocation" id="field_estatelocation" ng-model="vm.project.estatelocation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.agencyname" for="field_agencyname">Agencyname</label><input type="text" class="form-control" name="agencyname" id="field_agencyname" ng-model="vm.project.agencyname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.village" for="field_village">Village</label><input type="text" class="form-control" name="village" id="field_village" ng-model="vm.project.village"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.tehsil" for="field_tehsil">Tehsil</label><input type="text" class="form-control" name="tehsil" id="field_tehsil" ng-model="vm.project.tehsil"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.landusetype" for="field_landusetype">Landusetype</label><input type="text" class="form-control" name="landusetype" id="field_landusetype" ng-model="vm.project.landusetype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.landrequirementindistrict" for="field_landrequirementindistrict">Landrequirementindistrict</label><input type="text" class="form-control" name="landrequirementindistrict" id="field_landrequirementindistrict" ng-model="vm.project.landrequirementindistrict"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.product" for="field_product">Product</label><input type="text" class="form-control" name="product" id="field_product" ng-model="vm.project.product"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.uamnumber" for="field_uamnumber">Uamnumber</label><input type="text" class="form-control" name="uamnumber" id="field_uamnumber" ng-model="vm.project.uamnumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.nri_investment" for="field_nri_investment">Nri Investment</label><input type="number" class="form-control" name="nri_investment" id="field_nri_investment" ng-model="vm.project.nri_investment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.foreign_investment" for="field_foreign_investment">Foreign Investment</label><input type="number" class="form-control" name="foreign_investment" id="field_foreign_investment" ng-model="vm.project.foreign_investment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.isulb" for="field_isulb">Isulb</label><input type="checkbox" name="isulb" id="field_isulb" ng-model="vm.project.isulb"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.mc" for="field_mc">Mc</label><input type="text" class="form-control" name="mc" id="field_mc" ng-model="vm.project.mc"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.blockCategory" for="field_blockCategory">Block Category</label><input type="text" class="form-control" name="blockCategory" id="field_blockCategory" ng-model="vm.project.blockCategory"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.investmentType" for="field_investmentType">Investment Type</label><input type="text" class="form-control" name="investmentType" id="field_investmentType" ng-model="vm.project.investmentType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.otherInvestmetType" for="field_otherInvestmetType">Other Investmet Type</label><input type="text" class="form-control" name="otherInvestmetType" id="field_otherInvestmetType" ng-model="vm.project.otherInvestmetType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.otherFDI" for="field_otherFDI">Other FDI</label><input type="text" class="form-control" name="otherFDI" id="field_otherFDI" ng-model="vm.project.otherFDI"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.prodctionStartDate" for="field_prodctionStartDate">Prodction Start Date</label><div class="input-group"><input id="field_prodctionStartDate" type="text" class="form-control" name="prodctionStartDate" datetime-picker="{{dateformat}}" ng-model="vm.project.prodctionStartDate" is-open="vm.datePickerOpenStatus.prodctionStartDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'prodctionStartDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.haryanadomicile" for="field_haryanadomicile">Haryanadomicile</label><input type="number" class="form-control" name="haryanadomicile" id="field_haryanadomicile" ng-model="vm.project.haryanadomicile"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project.nonharyanadomicile" for="field_nonharyanadomicile">Nonharyanadomicile</label><input type="number" class="form-control" name="nonharyanadomicile" id="field_nonharyanadomicile" ng-model="vm.project.nonharyanadomicile"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/project/projects.html','<!--<div>--><!--<h2 data-translate="investhryApp.seachedProject.home.title">Projects</h2>--><!--<jhi-alert></jhi-alert>--><!--<div class="container-fluid">--><!--<div class="row">--><!--<div class="col-xs-4 no-padding-left">--><!--<button class="btn btn-primary" ui-sref="seachedProject.new" >--><!--<span class="glyphicon glyphicon-plus"></span>--><!--<span  data-translate="investhryApp.seachedProject.home.createLabel">--><!--Create new Project--><!--</span>--><!--</button>--><!--</div>--><!--</div>--><!--</div>--><!--<br/>--><!--<div class="table-responsive">--><!--<table class="jh-table table table-striped">--><!--<thead>--><!--<tr>--><!--<th><span data-translate="global.field.id">ID</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.mouapplicable">Mouapplicable</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.mousignyear">Mousignyear</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.mouidnumber">Mouidnumber</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.firstname">Firstname</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.middlename">Middlename</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.lastname">Lastname</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.address1">Address 1</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.address2">Address 2</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.address3">Address 3</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.emailprimary">Emailprimary</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.emailsecondary">Emailsecondary</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.userlogin">Userlogin</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.cityname">Cityname</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.countryname">Countryname</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.statename">Statename</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.createdate">Createdate</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.updatedate">Updatedate</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.cafpin">Cafpin</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.pincode">Pincode</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.phonenumber">Phonenumber</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.mobilenumber">Mobilenumber</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.promoter_md_director">Promoter Md Director</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.designation">Designation</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.businessentity">Businessentity</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.director_promoter_md_ceo_number">Director Promoter Md Ceo Number</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.pan_number">Pan Number</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.aadhar_number">Aadhar Number</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.nri">Nri</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.tin_vat_number">Tin Vat Number</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.cst_number">Cst Number</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.businessentitytype">Businessentitytype</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.gstnumber">Gstnumber</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.siteaddress">Siteaddress</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.multyvillageinvolved">Multyvillageinvolved</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.villageinvolved">Villageinvolved</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.falls_in_aravalli">Falls In Aravalli</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.islandprocured">Islandprocured</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.allotedbyhsiidc">Allotedbyhsiidc</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.estate">Estate</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.cluster">Cluster</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.phase">Phase</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.sector">Sector</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.plotno">Plotno</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.hadbastno">Hadbastno</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.liesunder_mc">Liesunder Mc</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.distance_from_mc">Distance From Mc</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.islocated_in_urban">Islocated In Urban</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.totalproposedprojectarea">Totalproposedprojectarea</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.proposedbuilt_up_area">Proposedbuilt Up Area</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.certifiedownership">Certifiedownership</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.leaseapplicable">Leaseapplicable</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.landagreementapplicable">Landagreementapplicable</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.intersectiondistance">Intersectiondistance</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.railwaydistance">Railwaydistance</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.confirmitylanduse">Confirmitylanduse</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.existing_building_applicable">Existing Building Applicable</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.site_situated_in_controlled_area">Site Situated In Controlled Area</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.buildingexisted">Buildingexisted</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.district">District</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.block">Block</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.city_town_village">City Town Village</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.connectingroad">Connectingroad</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.landzoneuse_type">Landzoneuse Type</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.tehsil_subtehsil">Tehsil Subtehsil</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.clurequired">Clurequired</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.land_cost">Land Cost</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.building_cost">Building Cost</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.machinery_cost">Machinery Cost</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.misc_assests">Misc Assests</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.total_project_cost">Total Project Cost</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.isfdi">Isfdi</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.fdivalue">Fdivalue</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.project_construction_start_date">Project Construction Start Date</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.commercial_activity_start_date">Commercial Activity Start Date</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.fdi_country">Fdi Country</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.foreign_funding_source">Foreign Funding Source</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.totalpurposedemployment">Totalpurposedemployment</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.projectrawmaterialid">Projectrawmaterialid</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.productid">Productid</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.processid">Processid</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.manufacturing_flow_document">Manufacturing Flow Document</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.temporaryrequired">Temporaryrequired</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.tem_load_existing">Tem Load Existing</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.tem_account_number">Tem Account Number</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.temp_existing_load_demand_kw">Temp Existing Load Demand Kw</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.temp_existing_load_demand_kva">Temp Existing Load Demand Kva</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.temp_new_load_demand_kw">Temp New Load Demand Kw</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.temp_new_load_demand_kva">Temp New Load Demand Kva</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.temp_load_demand_date">Temp Load Demand Date</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.regular_load_required">Regular Load Required</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.regular_existing_connection">Regular Existing Connection</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.regular_account_number">Regular Account Number</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.regular_existing_load_ifany_kw">Regular Existing Load Ifany Kw</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.regular_existing_load_ifany_kva">Regular Existing Load Ifany Kva</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.regular_new_load_demand_kw">Regular New Load Demand Kw</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.regular_new_load_demand_kva">Regular New Load Demand Kva</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.regular_load_demand_date">Regular Load Demand Date</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.customertype">Customertype</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.source_of_water_supply">Source Of Water Supply</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.mode_of_disposal_for_discharge">Mode Of Disposal For Discharge</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.recycling_process">Recycling Process</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.recycling_cooling">Recycling Cooling</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.recycling_domestic">Recycling Domestic</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.recycling_other">Recycling Other</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.sourcewatersupplyother">Sourcewatersupplyother</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.modedisposalother">Modedisposalother</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.water_process">Water Process</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.water_cooling">Water Cooling</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.water_domestic">Water Domestic</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.water_other">Water Other</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.waste_water_process">Waste Water Process</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.waste_water_cooling">Waste Water Cooling</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.waste_water_domesting">Waste Water Domesting</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.waste_water_other">Waste Water Other</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.acceptance">Acceptance</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.applicationdate">Applicationdate</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.place">Place</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.projectpurpose">Projectpurpose</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.niccode">Niccode</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.existing_regulatory_approval">Existing Regulatory Approval</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.edc_sif_clu_fee_paid_applicable">Edc Sif Clu Fee Paid Applicable</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.approval_application_form">Approval Application Form</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.category_of_project">Category Of Project</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.collaboration_with_foreign_country">Collaboration With Foreign Country</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.projectype">Projectype</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.sectorname">Sectorname</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.size_of_industry">Size Of Industry</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.sectorother">Sectorother</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.assignedRM">Assigned RM</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.isdeactivated">Isdeactivated</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.deactivatedby">Deactivatedby</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.deactivateddate">Deactivateddate</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.projectlevel">Projectlevel</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.isdraft">Isdraft</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.caftype">Caftype</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.landrequired">Landrequired</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.plotsize">Plotsize</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.estatename">Estatename</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.purchaserate">Purchaserate</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.estatelocation">Estatelocation</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.agencyname">Agencyname</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.village">Village</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.tehsil">Tehsil</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.landusetype">Landusetype</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.landrequirementindistrict">Landrequirementindistrict</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.product">Product</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.uamnumber">Uamnumber</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.nri_investment">Nri Investment</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.foreign_investment">Foreign Investment</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.isulb">Isulb</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.mc">Mc</span></th>--><!--<th><span data-translate="investhryApp.seachedProject.blockCategory">Block Category</span></th>--><!--<th></th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr ng-repeat="project in vm.projects track by seachedProject.id">--><!--<td><a ui-sref="project-detail({id:seachedProject.id})">{{seachedProject.id}}</a></td>--><!--<td>{{seachedProject.mouapplicable}}</td>--><!--<td>{{seachedProject.mousignyear}}</td>--><!--<td>{{seachedProject.mouidnumber}}</td>--><!--<td>{{seachedProject.firstname}}</td>--><!--<td>{{seachedProject.middlename}}</td>--><!--<td>{{seachedProject.lastname}}</td>--><!--<td>{{seachedProject.address1}}</td>--><!--<td>{{seachedProject.address2}}</td>--><!--<td>{{seachedProject.address3}}</td>--><!--<td>{{seachedProject.emailprimary}}</td>--><!--<td>{{seachedProject.emailsecondary}}</td>--><!--<td>{{seachedProject.userlogin}}</td>--><!--<td>{{seachedProject.cityname}}</td>--><!--<td>{{seachedProject.countryname}}</td>--><!--<td>{{seachedProject.statename}}</td>--><!--<td>{{seachedProject.createdate | date:\'medium\'}}</td>--><!--<td>{{seachedProject.updatedate | date:\'medium\'}}</td>--><!--<td>{{seachedProject.cafpin}}</td>--><!--<td>{{seachedProject.pincode}}</td>--><!--<td>{{seachedProject.phonenumber}}</td>--><!--<td>{{seachedProject.mobilenumber}}</td>--><!--<td>{{seachedProject.promoter_md_director}}</td>--><!--<td>{{seachedProject.designation}}</td>--><!--<td>{{seachedProject.businessentity}}</td>--><!--<td>{{seachedProject.director_promoter_md_ceo_number}}</td>--><!--<td>{{seachedProject.pan_number}}</td>--><!--<td>{{seachedProject.aadhar_number}}</td>--><!--<td>{{seachedProject.nri}}</td>--><!--<td>{{seachedProject.tin_vat_number}}</td>--><!--<td>{{seachedProject.cst_number}}</td>--><!--<td>{{seachedProject.businessentitytype}}</td>--><!--<td>{{seachedProject.gstnumber}}</td>--><!--<td>{{seachedProject.siteaddress}}</td>--><!--<td>{{seachedProject.multyvillageinvolved}}</td>--><!--<td>{{seachedProject.villageinvolved}}</td>--><!--<td>{{seachedProject.falls_in_aravalli}}</td>--><!--<td>{{seachedProject.islandprocured}}</td>--><!--<td>{{seachedProject.allotedbyhsiidc}}</td>--><!--<td>{{seachedProject.estate}}</td>--><!--<td>{{seachedProject.cluster}}</td>--><!--<td>{{seachedProject.phase}}</td>--><!--<td>{{seachedProject.sector}}</td>--><!--<td>{{seachedProject.plotno}}</td>--><!--<td>{{seachedProject.hadbastno}}</td>--><!--<td>{{seachedProject.liesunder_mc}}</td>--><!--<td>{{seachedProject.distance_from_mc}}</td>--><!--<td>{{seachedProject.islocated_in_urban}}</td>--><!--<td>{{seachedProject.totalproposedprojectarea}}</td>--><!--<td>{{seachedProject.proposedbuilt_up_area}}</td>--><!--<td>{{seachedProject.certifiedownership}}</td>--><!--<td>{{seachedProject.leaseapplicable}}</td>--><!--<td>{{seachedProject.landagreementapplicable}}</td>--><!--<td>{{seachedProject.intersectiondistance}}</td>--><!--<td>{{seachedProject.railwaydistance}}</td>--><!--<td>{{seachedProject.confirmitylanduse}}</td>--><!--<td>{{seachedProject.existing_building_applicable}}</td>--><!--<td>{{seachedProject.site_situated_in_controlled_area}}</td>--><!--<td>{{seachedProject.buildingexisted}}</td>--><!--<td>{{seachedProject.district}}</td>--><!--<td>{{seachedProject.block}}</td>--><!--<td>{{seachedProject.city_town_village}}</td>--><!--<td>{{seachedProject.connectingroad}}</td>--><!--<td>{{seachedProject.landzoneuse_type}}</td>--><!--<td>{{seachedProject.tehsil_subtehsil}}</td>--><!--<td>{{seachedProject.clurequired}}</td>--><!--<td>{{seachedProject.land_cost}}</td>--><!--<td>{{seachedProject.building_cost}}</td>--><!--<td>{{seachedProject.machinery_cost}}</td>--><!--<td>{{seachedProject.misc_assests}}</td>--><!--<td>{{seachedProject.total_project_cost}}</td>--><!--<td>{{seachedProject.isfdi}}</td>--><!--<td>{{seachedProject.fdivalue}}</td>--><!--<td>{{seachedProject.project_construction_start_date | date:\'medium\'}}</td>--><!--<td>{{seachedProject.commercial_activity_start_date | date:\'medium\'}}</td>--><!--<td>{{seachedProject.fdi_country}}</td>--><!--<td>{{seachedProject.foreign_funding_source}}</td>--><!--<td>{{seachedProject.totalpurposedemployment}}</td>--><!--<td>{{seachedProject.projectrawmaterialid}}</td>--><!--<td>{{seachedProject.productid}}</td>--><!--<td>{{seachedProject.processid}}</td>--><!--<td>{{seachedProject.manufacturing_flow_document}}</td>--><!--<td>{{seachedProject.temporaryrequired}}</td>--><!--<td>{{seachedProject.tem_load_existing}}</td>--><!--<td>{{seachedProject.tem_account_number}}</td>--><!--<td>{{seachedProject.temp_existing_load_demand_kw}}</td>--><!--<td>{{seachedProject.temp_existing_load_demand_kva}}</td>--><!--<td>{{seachedProject.temp_new_load_demand_kw}}</td>--><!--<td>{{seachedProject.temp_new_load_demand_kva}}</td>--><!--<td>{{seachedProject.temp_load_demand_date | date:\'medium\'}}</td>--><!--<td>{{seachedProject.regular_load_required}}</td>--><!--<td>{{seachedProject.regular_existing_connection}}</td>--><!--<td>{{seachedProject.regular_account_number}}</td>--><!--<td>{{seachedProject.regular_existing_load_ifany_kw}}</td>--><!--<td>{{seachedProject.regular_existing_load_ifany_kva}}</td>--><!--<td>{{seachedProject.regular_new_load_demand_kw}}</td>--><!--<td>{{seachedProject.regular_new_load_demand_kva}}</td>--><!--<td>{{seachedProject.regular_load_demand_date | date:\'medium\'}}</td>--><!--<td>{{seachedProject.customertype}}</td>--><!--<td>{{seachedProject.source_of_water_supply}}</td>--><!--<td>{{seachedProject.mode_of_disposal_for_discharge}}</td>--><!--<td>{{seachedProject.recycling_process}}</td>--><!--<td>{{seachedProject.recycling_cooling}}</td>--><!--<td>{{seachedProject.recycling_domestic}}</td>--><!--<td>{{seachedProject.recycling_other}}</td>--><!--<td>{{seachedProject.sourcewatersupplyother}}</td>--><!--<td>{{seachedProject.modedisposalother}}</td>--><!--<td>{{seachedProject.water_process}}</td>--><!--<td>{{seachedProject.water_cooling}}</td>--><!--<td>{{seachedProject.water_domestic}}</td>--><!--<td>{{seachedProject.water_other}}</td>--><!--<td>{{seachedProject.waste_water_process}}</td>--><!--<td>{{seachedProject.waste_water_cooling}}</td>--><!--<td>{{seachedProject.waste_water_domesting}}</td>--><!--<td>{{seachedProject.waste_water_other}}</td>--><!--<td>{{seachedProject.acceptance}}</td>--><!--<td>{{seachedProject.applicationdate | date:\'medium\'}}</td>--><!--<td>{{seachedProject.place}}</td>--><!--<td>{{seachedProject.projectpurpose}}</td>--><!--<td>{{seachedProject.niccode}}</td>--><!--<td>{{seachedProject.existing_regulatory_approval}}</td>--><!--<td>{{seachedProject.edc_sif_clu_fee_paid_applicable}}</td>--><!--<td>{{seachedProject.approval_application_form}}</td>--><!--<td>{{seachedProject.category_of_project}}</td>--><!--<td>{{seachedProject.collaboration_with_foreign_country}}</td>--><!--<td>{{seachedProject.projectype}}</td>--><!--<td>{{seachedProject.sectorname}}</td>--><!--<td>{{seachedProject.size_of_industry}}</td>--><!--<td>{{seachedProject.sectorother}}</td>--><!--<td>{{seachedProject.assignedRM}}</td>--><!--<td>{{seachedProject.isdeactivated}}</td>--><!--<td>{{seachedProject.deactivatedby}}</td>--><!--<td>{{seachedProject.deactivateddate | date:\'medium\'}}</td>--><!--<td>{{seachedProject.projectlevel}}</td>--><!--<td>{{seachedProject.isdraft}}</td>--><!--<td>{{seachedProject.caftype}}</td>--><!--<td>{{seachedProject.landrequired}}</td>--><!--<td>{{seachedProject.plotsize}}</td>--><!--<td>{{seachedProject.estatename}}</td>--><!--<td>{{seachedProject.purchaserate}}</td>--><!--<td>{{seachedProject.estatelocation}}</td>--><!--<td>{{seachedProject.agencyname}}</td>--><!--<td>{{seachedProject.village}}</td>--><!--<td>{{seachedProject.tehsil}}</td>--><!--<td>{{seachedProject.landusetype}}</td>--><!--<td>{{seachedProject.landrequirementindistrict}}</td>--><!--<td>{{seachedProject.product}}</td>--><!--<td>{{seachedProject.uamnumber}}</td>--><!--<td>{{seachedProject.nri_investment}}</td>--><!--<td>{{seachedProject.foreign_investment}}</td>--><!--<td>{{seachedProject.isulb}}</td>--><!--<td>{{seachedProject.mc}}</td>--><!--<td>{{seachedProject.blockCategory}}</td>--><!--<td class="text-right">--><!--<div class="btn-group flex-btn-group-container">--><!--<button type="submit"--><!--ui-sref="project-detail({id:seachedProject.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="seachedProject.edit({id:seachedProject.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="seachedProject.delete({id:seachedProject.id})"--><!--class="btn btn-danger btn-sm">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--><!--</button>--><!--</div>--><!--</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div>--><!--</div>--><div ng-cloak><div class="container"><div class="row"><div class="col-sm-4"><input type="text" ng-model="vm.CAFPIN" class="form-control" id="searchQuery" placeholder="CAF PIN or Project ID or User Login or Email"></div><div class="btn-group col-sm-4"><button type="submit" ng-click="vm.getProject()" class="btn btn-info" has-any-authority="ROLE_USER, ROLE_ADMIN, ROLE_SUB_ADMIN,ROLE_MONITORING_OFFICER,ROLE_DESK_OFFICER,ROLE_DEPT_CHANGE,ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT">Search</button></div></div><div class="row" ng-show="vm.showtable"><table class="table table-striped table-hover"><thead><tr class="headerGrid"><th>ID</th><th>Mouapplicable</th><th>Mousignyear</th><th>Mouidnumber</th><th>Firstname</th><th>Middlename</th><th>Lastname</th><th>Address 1</th><th>Address 2</th><th>Address 3</th><th>Emailprimary</th><th>Emailsecondary</th><th>Userlogin</th><th>Cityname</th><th>Countryname</th><th>Statename</th><th>Createdate</th><th>Updatedate</th><th>Cafpin</th><th>Pincode</th><th>Phonenumber</th><th>Mobilenumber</th><th>Promoter Md Director</th><th>Designation</th><th>Businessentity</th><th>Director Promoter Md Ceo Number</th><th>Pan Number</th><th>Aadhar Number</th><th>Nri</th><th>Tin Vat Number</th><th>Cst Number</th><th>Businessentitytype</th><th>Gstnumber</th><th>Siteaddress</th><th>Multyvillageinvolved</th><th>Villageinvolved</th><th>Falls In Aravalli</th><th>Islandprocured</th><th>Allotedbyhsiidc</th><th>Estate</th><th>Cluster</th><th>Phase</th><th>Sector</th><th>Plotno</th><th>Hadbastno</th><th>Liesunder Mc</th><th>Distance From Mc</th><th>Islocated In Urban</th><th>Totalproposedprojectarea</th><th>Proposedbuilt Up Area</th><th>Certifiedownership</th><th>Leaseapplicable</th><th>Landagreementapplicable</th><th>Intersectiondistance</th><th>Railwaydistance</th><th>Confirmitylanduse</th><th>Existing Building Applicable</th><th>Site Situated In Controlled Area</th><th>Buildingexisted</th><th>District</th><th>Block</th><th>City Town Village</th><th>Connectingroad</th><th>Landzoneuse Type</th><th>Tehsil Subtehsil</th><th>Clurequired</th><th>Land Cost</th><th>Building Cost</th><th>Machinery Cost</th><th>Misc Assests</th><th>Total Project Cost</th><th>Isfdi</th><th>Fdivalue</th><th>Project Construction Start Date</th><th>Commercial Activity Start Date</th><th>Fdi Country</th><th>Foreign Funding Source</th><th>Totalpurposedemployment</th><th>Projectrawmaterialid</th><th>Productid</th><th>Processid</th><th>Manufacturing Flow Document</th><th>Temporaryrequired</th><th>Tem Load Existing</th><th>Tem Account Number</th><th>Temp Existing Load Demand Kw</th><th>Temp Existing Load Demand Kva</th><th>Temp New Load Demand Kw</th><th>Temp New Load Demand Kva</th><th>Temp Load Demand Date</th><th>Regular Load Required</th><th>Regular Existing Connection</th><th>Regular Account Number</th><th>Regular Existing Load Ifany Kw</th><th>Regular Existing Load Ifany Kva</th><th>Regular New Load Demand Kw</th><th>Regular New Load Demand Kva</th><th>Regular Load Demand Date</th><th>Customertype</th><th>Source Of Water Supply</th><th>Mode Of Disposal For Discharge</th><th>Recycling Process</th><th>Recycling Cooling</th><th>Recycling Domestic</th><th>Recycling Other</th><th>Sourcewatersupplyother</th><th>Modedisposalother</th><th>Water Process</th><th>Water Cooling</th><th>Water Domestic</th><th>Water Other</th><th>Waste Water Process</th><th>Waste Water Cooling</th><th>Waste Water Domesting</th><th>Waste Water Other</th><th>Acceptance</th><th>Applicationdate</th><th>Place</th><th>Projectpurpose</th><th>Niccode</th><th>Existing Regulatory Approval</th><th>Edc Sif Clu Fee Paid Applicable</th><th>Approval Application Form</th><th>Category Of Project</th><th>Collaboration With Foreign Country</th><th>Projectype</th><th>Sectorname</th><th>Size Of Industry</th><th>Sectorother</th><th>Assigned RM</th><th>Isdeactivated</th><th>Deactivatedby</th><th>Deactivateddate</th><th>Projectlevel</th><th>Isdraft</th><th>Caftype</th><th>Landrequired</th><th>Plotsize</th><th>Estatename</th><th>Purchaserate</th><th>Estatelocation</th><th>Agencyname</th><th>Village</th><th>Tehsil</th><th>Landusetype</th><th>Landrequirementindistrict</th><th>Product</th><th>Uamnumber</th><th>Nri Investment</th><th>Foreign Investment</th><th>Isulb</th><th>Mc</th><th>Block Category</th><th></th></tr></thead><tbody><tr ng-repeat="seachedProject in vm.seachedProject"><td>{{seachedProject.id}}</td><td>{{seachedProject.mouapplicable}}</td><td>{{seachedProject.mousignyear}}</td><td>{{seachedProject.mouidnumber}}</td><td>{{seachedProject.firstname}}</td><td>{{seachedProject.middlename}}</td><td>{{seachedProject.lastname}}</td><td>{{seachedProject.address1}}</td><td>{{seachedProject.address2}}</td><td>{{seachedProject.address3}}</td><td>{{seachedProject.emailprimary}}</td><td>{{seachedProject.emailsecondary}}</td><td>{{seachedProject.userlogin}}</td><td>{{seachedProject.cityname}}</td><td>{{seachedProject.countryname}}</td><td>{{seachedProject.statename}}</td><td>{{seachedProject.createdate | date:\'medium\'}}</td><td>{{seachedProject.updatedate | date:\'medium\'}}</td><td>{{seachedProject.cafpin}}</td><td>{{seachedProject.pincode}}</td><td>{{seachedProject.phonenumber}}</td><td>{{seachedProject.mobilenumber}}</td><td>{{seachedProject.promoter_md_director}}</td><td>{{seachedProject.designation}}</td><td>{{seachedProject.businessentity}}</td><td>{{seachedProject.director_promoter_md_ceo_number}}</td><td>{{seachedProject.pan_number}}</td><td>{{seachedProject.aadhar_number}}</td><td>{{seachedProject.nri}}</td><td>{{seachedProject.tin_vat_number}}</td><td>{{seachedProject.cst_number}}</td><td>{{seachedProject.businessentitytype}}</td><td>{{seachedProject.gstnumber}}</td><td>{{seachedProject.siteaddress}}</td><td>{{seachedProject.multyvillageinvolved}}</td><td>{{seachedProject.villageinvolved}}</td><td>{{seachedProject.falls_in_aravalli}}</td><td>{{seachedProject.islandprocured}}</td><td>{{seachedProject.allotedbyhsiidc}}</td><td>{{seachedProject.estate}}</td><td>{{seachedProject.cluster}}</td><td>{{seachedProject.phase}}</td><td>{{seachedProject.sector}}</td><td>{{seachedProject.plotno}}</td><td>{{seachedProject.hadbastno}}</td><td>{{seachedProject.liesunder_mc}}</td><td>{{seachedProject.distance_from_mc}}</td><td>{{seachedProject.islocated_in_urban}}</td><td>{{seachedProject.totalproposedprojectarea}}</td><td>{{seachedProject.proposedbuilt_up_area}}</td><td>{{seachedProject.certifiedownership}}</td><td>{{seachedProject.leaseapplicable}}</td><td>{{seachedProject.landagreementapplicable}}</td><td>{{seachedProject.intersectiondistance}}</td><td>{{seachedProject.railwaydistance}}</td><td>{{seachedProject.confirmitylanduse}}</td><td>{{seachedProject.existing_building_applicable}}</td><td>{{seachedProject.site_situated_in_controlled_area}}</td><td>{{seachedProject.buildingexisted}}</td><td>{{seachedProject.district}}</td><td>{{seachedProject.block}}</td><td>{{seachedProject.city_town_village}}</td><td>{{seachedProject.connectingroad}}</td><td>{{seachedProject.landzoneuse_type}}</td><td>{{seachedProject.tehsil_subtehsil}}</td><td>{{seachedProject.clurequired}}</td><td>{{seachedProject.land_cost}}</td><td>{{seachedProject.building_cost}}</td><td>{{seachedProject.machinery_cost}}</td><td>{{seachedProject.misc_assests}}</td><td>{{seachedProject.total_project_cost}}</td><td>{{seachedProject.isfdi}}</td><td>{{seachedProject.fdivalue}}</td><td>{{seachedProject.project_construction_start_date | date:\'medium\'}}</td><td>{{seachedProject.commercial_activity_start_date | date:\'medium\'}}</td><td>{{seachedProject.fdi_country}}</td><td>{{seachedProject.foreign_funding_source}}</td><td>{{seachedProject.totalpurposedemployment}}</td><td>{{seachedProject.projectrawmaterialid}}</td><td>{{seachedProject.productid}}</td><td>{{seachedProject.processid}}</td><td>{{seachedProject.manufacturing_flow_document}}</td><td>{{seachedProject.temporaryrequired}}</td><td>{{seachedProject.tem_load_existing}}</td><td>{{seachedProject.tem_account_number}}</td><td>{{seachedProject.temp_existing_load_demand_kw}}</td><td>{{seachedProject.temp_existing_load_demand_kva}}</td><td>{{seachedProject.temp_new_load_demand_kw}}</td><td>{{seachedProject.temp_new_load_demand_kva}}</td><td>{{seachedProject.temp_load_demand_date | date:\'medium\'}}</td><td>{{seachedProject.regular_load_required}}</td><td>{{seachedProject.regular_existing_connection}}</td><td>{{seachedProject.regular_account_number}}</td><td>{{seachedProject.regular_existing_load_ifany_kw}}</td><td>{{seachedProject.regular_existing_load_ifany_kva}}</td><td>{{seachedProject.regular_new_load_demand_kw}}</td><td>{{seachedProject.regular_new_load_demand_kva}}</td><td>{{seachedProject.regular_load_demand_date | date:\'medium\'}}</td><td>{{seachedProject.customertype}}</td><td>{{seachedProject.source_of_water_supply}}</td><td>{{seachedProject.mode_of_disposal_for_discharge}}</td><td>{{seachedProject.recycling_process}}</td><td>{{seachedProject.recycling_cooling}}</td><td>{{seachedProject.recycling_domestic}}</td><td>{{seachedProject.recycling_other}}</td><td>{{seachedProject.sourcewatersupplyother}}</td><td>{{seachedProject.modedisposalother}}</td><td>{{seachedProject.water_process}}</td><td>{{seachedProject.water_cooling}}</td><td>{{seachedProject.water_domestic}}</td><td>{{seachedProject.water_other}}</td><td>{{seachedProject.waste_water_process}}</td><td>{{seachedProject.waste_water_cooling}}</td><td>{{seachedProject.waste_water_domesting}}</td><td>{{seachedProject.waste_water_other}}</td><td>{{seachedProject.acceptance}}</td><td>{{seachedProject.applicationdate | date:\'medium\'}}</td><td>{{seachedProject.place}}</td><td>{{seachedProject.projectpurpose}}</td><td>{{seachedProject.niccode}}</td><td>{{seachedProject.existing_regulatory_approval}}</td><td>{{seachedProject.edc_sif_clu_fee_paid_applicable}}</td><td>{{seachedProject.approval_application_form}}</td><td>{{seachedProject.category_of_project}}</td><td>{{seachedProject.collaboration_with_foreign_country}}</td><td>{{seachedProject.projectype}}</td><td>{{seachedProject.sectorname}}</td><td>{{seachedProject.size_of_industry}}</td><td>{{seachedProject.sectorother}}</td><td>{{seachedProject.assignedRM}}</td><td>{{seachedProject.isdeactivated}}</td><td>{{seachedProject.deactivatedby}}</td><td>{{seachedProject.deactivateddate | date:\'medium\'}}</td><td>{{seachedProject.projectlevel}}</td><td>{{seachedProject.isdraft}}</td><td>{{seachedProject.caftype}}</td><td>{{seachedProject.landrequired}}</td><td>{{seachedProject.plotsize}}</td><td>{{seachedProject.estatename}}</td><td>{{seachedProject.purchaserate}}</td><td>{{seachedProject.estatelocation}}</td><td>{{seachedProject.agencyname}}</td><td>{{seachedProject.village}}</td><td>{{seachedProject.tehsil}}</td><td>{{seachedProject.landusetype}}</td><td>{{seachedProject.landrequirementindistrict}}</td><td>{{seachedProject.product}}</td><td>{{seachedProject.uamnumber}}</td><td>{{seachedProject.nri_investment}}</td><td>{{seachedProject.foreign_investment}}</td><td>{{seachedProject.isulb}}</td><td>{{seachedProject.mc}}</td><td>{{seachedProject.blockCategory}}</td><!--<td> <a ui-sref="project-detail({id:seachedProject.id})" class="btn btn-primary">View</a></td>--><!--<td><a type="submit" ui-sref="project.delete({id:seachedProject.id})">--><!--<span class="hidden-sm-down" data-translate="entity.action.delete">delete</span>--><!--</a>--><!--</td>--></tr></tbody></table></div><!--<div ng-show="!vm.showtable">--><!--No Projects Right Now.--><!--</div>--></div></div>');
$templateCache.put('app/entities/project-attachemnt/project-attachemnt-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectAttachemnt.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectAttachemnt.delete.question" translate-values="{id: \'{{vm.projectAttachemnt.id}}\'}">Are you sure you want to delete this Project Attachemnt?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/project-attachemnt/project-attachemnt-detail.html','<div><h2><span data-translate="investhryApp.projectAttachemnt.detail.title">Project Attachemnt</span> {{vm.projectAttachemnt.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectAttachemnt.fileName">File Name</span></dt><dd><span>{{vm.projectAttachemnt.fileName}}</span></dd><dt><span data-translate="investhryApp.projectAttachemnt.description">Description</span></dt><dd><span>{{vm.projectAttachemnt.description}}</span></dd><dt><span data-translate="investhryApp.projectAttachemnt.fileExtension">File Extension</span></dt><dd><span>{{vm.projectAttachemnt.fileExtension}}</span></dd><dt><span data-translate="investhryApp.projectAttachemnt.serverFileName">Server File Name</span></dt><dd><span>{{vm.projectAttachemnt.serverFileName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="project-attachemnt-detail.edit({id:vm.projectAttachemnt.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/project-attachemnt/project-attachemnt-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectAttachemntLabel" data-translate="investhryApp.projectAttachemnt.home.createOrEditLabel">Create or edit a Project Attachemnt</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectAttachemnt.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectAttachemnt.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectAttachemnt.fileName" for="field_fileName">File Name</label><input type="text" class="form-control" name="fileName" id="field_fileName" ng-model="vm.projectAttachemnt.fileName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectAttachemnt.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.projectAttachemnt.description"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectAttachemnt.fileExtension" for="field_fileExtension">File Extension</label><input type="text" class="form-control" name="fileExtension" id="field_fileExtension" ng-model="vm.projectAttachemnt.fileExtension"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectAttachemnt.serverFileName" for="field_serverFileName">Server File Name</label><input type="text" class="form-control" name="serverFileName" id="field_serverFileName" ng-model="vm.projectAttachemnt.serverFileName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/project-attachemnt/project-attachemnts.html','<div class="container"><h2 data-translate="investhryApp.projectAttachemnt.home.title">Project Attachemnts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="project-attachemnt.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectAttachemnt.home.createLabel">Create new Project Attachemnt</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectAttachemnt.fileName">File Name</span></th><th><span data-translate="investhryApp.projectAttachemnt.description">Description</span></th><th><span data-translate="investhryApp.projectAttachemnt.fileExtension">File Extension</span></th><th><span data-translate="investhryApp.projectAttachemnt.serverFileName">Server File Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectAttachemnt in vm.projectAttachemnts track by projectAttachemnt.id"><td><a ui-sref="project-attachemnt-detail({id:projectAttachemnt.id})">{{projectAttachemnt.id}}</a></td><td>{{projectAttachemnt.fileName}}</td><td>{{projectAttachemnt.description}}</td><td>{{projectAttachemnt.fileExtension}}</td><td>{{projectAttachemnt.serverFileName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="project-attachemnt-detail({id:projectAttachemnt.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="project-attachemnt.edit({id:projectAttachemnt.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="project-attachemnt.delete({id:projectAttachemnt.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/project-finance-investment/project-finance-investment-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.project_finance_investment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.project_finance_investment.delete.question" translate-values="{id: \'{{vm.project_finance_investment.id}}\'}">Are you sure you want to delete this Project Finance Investment?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/project-finance-investment/project-finance-investment-detail.html','<div><h2><span data-translate="investhryApp.project_finance_investment.detail.title">Project Finance Investment</span> {{vm.project_finance_investment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.project_finance_investment.land_cost">Land Cost</span></dt><dd><span>{{vm.project_finance_investment.land_cost}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.building_cost">Building Cost</span></dt><dd><span>{{vm.project_finance_investment.building_cost}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.machinery_cost">Machinery Cost</span></dt><dd><span>{{vm.project_finance_investment.machinery_cost}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.misc_assests">Misc Assests</span></dt><dd><span>{{vm.project_finance_investment.misc_assests}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.total_project_cost">Total Project Cost</span></dt><dd><span>{{vm.project_finance_investment.total_project_cost}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.isfdi">Isfdi</span></dt><dd><span>{{vm.project_finance_investment.isfdi}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.fdivalue">Fdivalue</span></dt><dd><span>{{vm.project_finance_investment.fdivalue}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.project_construction_start_date">Project Construction Start Date</span></dt><dd><span>{{vm.project_finance_investment.project_construction_start_date | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.commercial_activity_start_date">Commercial Activity Start Date</span></dt><dd><span>{{vm.project_finance_investment.commercial_activity_start_date | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.fdi_country">Fdi Country</span></dt><dd><span>{{vm.project_finance_investment.fdi_country}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.foreign_funding_source">Foreign Funding Source</span></dt><dd><span>{{vm.project_finance_investment.foreign_funding_source}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.totalpurposedemployment">Totalpurposedemployment</span></dt><dd><span>{{vm.project_finance_investment.totalpurposedemployment}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.createdate">Createdate</span></dt><dd><span>{{vm.project_finance_investment.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project_finance_investment.updatedate">Updatedate</span></dt><dd><span>{{vm.project_finance_investment.updatedate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="project-finance-investment-detail.edit({id:vm.project_finance_investment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/project-finance-investment/project-finance-investment-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProject_finance_investmentLabel" data-translate="investhryApp.project_finance_investment.home.createOrEditLabel">Create or edit a Project Finance Investment</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.project_finance_investment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.project_finance_investment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.land_cost" for="field_land_cost">Land Cost</label><input type="number" class="form-control" name="land_cost" id="field_land_cost" ng-model="vm.project_finance_investment.land_cost"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.building_cost" for="field_building_cost">Building Cost</label><input type="number" class="form-control" name="building_cost" id="field_building_cost" ng-model="vm.project_finance_investment.building_cost"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.machinery_cost" for="field_machinery_cost">Machinery Cost</label><input type="number" class="form-control" name="machinery_cost" id="field_machinery_cost" ng-model="vm.project_finance_investment.machinery_cost"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.misc_assests" for="field_misc_assests">Misc Assests</label><input type="number" class="form-control" name="misc_assests" id="field_misc_assests" ng-model="vm.project_finance_investment.misc_assests"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.total_project_cost" for="field_total_project_cost">Total Project Cost</label><input type="number" class="form-control" name="total_project_cost" id="field_total_project_cost" ng-model="vm.project_finance_investment.total_project_cost"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.isfdi" for="field_isfdi">Isfdi</label><input type="checkbox" class="form-control" name="isfdi" id="field_isfdi" ng-model="vm.project_finance_investment.isfdi"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.fdivalue" for="field_fdivalue">Fdivalue</label><input type="number" class="form-control" name="fdivalue" id="field_fdivalue" ng-model="vm.project_finance_investment.fdivalue"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.project_construction_start_date" for="field_project_construction_start_date">Project Construction Start Date</label><div class="input-group"><input id="field_project_construction_start_date" type="text" class="form-control" name="project_construction_start_date" datetime-picker="{{dateformat}}" ng-model="vm.project_finance_investment.project_construction_start_date" is-open="vm.datePickerOpenStatus.project_construction_start_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'project_construction_start_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.commercial_activity_start_date" for="field_commercial_activity_start_date">Commercial Activity Start Date</label><div class="input-group"><input id="field_commercial_activity_start_date" type="text" class="form-control" name="commercial_activity_start_date" datetime-picker="{{dateformat}}" ng-model="vm.project_finance_investment.commercial_activity_start_date" is-open="vm.datePickerOpenStatus.commercial_activity_start_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'commercial_activity_start_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.fdi_country" for="field_fdi_country">Fdi Country</label><input type="text" class="form-control" name="fdi_country" id="field_fdi_country" ng-model="vm.project_finance_investment.fdi_country"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.foreign_funding_source" for="field_foreign_funding_source">Foreign Funding Source</label><input type="text" class="form-control" name="foreign_funding_source" id="field_foreign_funding_source" ng-model="vm.project_finance_investment.foreign_funding_source"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.totalpurposedemployment" for="field_totalpurposedemployment">Totalpurposedemployment</label><input type="number" class="form-control" name="totalpurposedemployment" id="field_totalpurposedemployment" ng-model="vm.project_finance_investment.totalpurposedemployment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.project_finance_investment.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_finance_investment.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.project_finance_investment.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/project-finance-investment/project-finance-investments.html','<div class="container"><h2 data-translate="investhryApp.project_finance_investment.home.title">Project Finance Investments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="project-finance-investment.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.project_finance_investment.home.createLabel">Create new Project Finance Investment</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.project_finance_investment.land_cost">Land Cost</span></th><th><span data-translate="investhryApp.project_finance_investment.building_cost">Building Cost</span></th><th><span data-translate="investhryApp.project_finance_investment.machinery_cost">Machinery Cost</span></th><th><span data-translate="investhryApp.project_finance_investment.misc_assests">Misc Assests</span></th><th><span data-translate="investhryApp.project_finance_investment.total_project_cost">Total Project Cost</span></th><th><span data-translate="investhryApp.project_finance_investment.isfdi">Isfdi</span></th><th><span data-translate="investhryApp.project_finance_investment.fdivalue">Fdivalue</span></th><th><span data-translate="investhryApp.project_finance_investment.project_construction_start_date">Project Construction Start Date</span></th><th><span data-translate="investhryApp.project_finance_investment.commercial_activity_start_date">Commercial Activity Start Date</span></th><th><span data-translate="investhryApp.project_finance_investment.fdi_country">Fdi Country</span></th><th><span data-translate="investhryApp.project_finance_investment.foreign_funding_source">Foreign Funding Source</span></th><th><span data-translate="investhryApp.project_finance_investment.totalpurposedemployment">Totalpurposedemployment</span></th><th><span data-translate="investhryApp.project_finance_investment.createdate">Createdate</span></th><th><span data-translate="investhryApp.project_finance_investment.updatedate">Updatedate</span></th><th></th></tr></thead><tbody><tr ng-repeat="project_finance_investment in vm.project_finance_investments track by project_finance_investment.id"><td><a ui-sref="project-finance-investment-detail({id:project_finance_investment.id})">{{project_finance_investment.id}}</a></td><td>{{project_finance_investment.land_cost}}</td><td>{{project_finance_investment.building_cost}}</td><td>{{project_finance_investment.machinery_cost}}</td><td>{{project_finance_investment.misc_assests}}</td><td>{{project_finance_investment.total_project_cost}}</td><td>{{project_finance_investment.isfdi}}</td><td>{{project_finance_investment.fdivalue}}</td><td>{{project_finance_investment.project_construction_start_date | date:\'medium\'}}</td><td>{{project_finance_investment.commercial_activity_start_date | date:\'medium\'}}</td><td>{{project_finance_investment.fdi_country}}</td><td>{{project_finance_investment.foreign_funding_source}}</td><td>{{project_finance_investment.totalpurposedemployment}}</td><td>{{project_finance_investment.createdate | date:\'medium\'}}</td><td>{{project_finance_investment.updatedate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="project-finance-investment-detail({id:project_finance_investment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="project-finance-investment.edit({id:project_finance_investment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="project-finance-investment.delete({id:project_finance_investment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/project-log-new-caf/project-log-new-caf-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectLogNewCaf.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectLogNewCaf.delete.question" translate-values="{id: \'{{vm.projectLogNewCaf.id}}\'}">Are you sure you want to delete this Project Log New Caf?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/project-log-new-caf/project-log-new-caf-detail.html','<div><h2><span data-translate="investhryApp.projectLogNewCaf.detail.title">Project Log New Caf</span> {{vm.projectLogNewCaf.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.projectLogNewCaf.projectId">Project Id</span></dt><dd><span>{{vm.projectLogNewCaf.projectId}}</span></dd><dt><span data-translate="investhryApp.projectLogNewCaf.actionTaken">Action Taken</span></dt><dd><span>{{vm.projectLogNewCaf.actionTaken}}</span></dd><dt><span data-translate="investhryApp.projectLogNewCaf.actionTakenBy">Action Taken By</span></dt><dd><span>{{vm.projectLogNewCaf.actionTakenBy}}</span></dd><dt><span data-translate="investhryApp.projectLogNewCaf.actionTakenDate">Action Taken Date</span></dt><dd><span>{{vm.projectLogNewCaf.actionTakenDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectLogNewCaf.actionType">Action Type</span></dt><dd><span>{{vm.projectLogNewCaf.actionType}}</span></dd><dt><span data-translate="investhryApp.projectLogNewCaf.fieldUpdated">Field Updated</span></dt><dd><span>{{vm.projectLogNewCaf.fieldUpdated}}</span></dd><dt><span data-translate="investhryApp.projectLogNewCaf.oldValue">Old Value</span></dt><dd><span>{{vm.projectLogNewCaf.oldValue}}</span></dd><dt><span data-translate="investhryApp.projectLogNewCaf.newValue">New Value</span></dt><dd><span>{{vm.projectLogNewCaf.newValue}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="project-log-new-caf-detail.edit({id:vm.projectLogNewCaf.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/project-log-new-caf/project-log-new-caf-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectLogNewCafLabel" data-translate="investhryApp.projectLogNewCaf.home.createOrEditLabel">Create or edit a Project Log New Caf</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectLogNewCaf.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectLogNewCaf.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectLogNewCaf.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.projectLogNewCaf.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectLogNewCaf.actionTaken" for="field_actionTaken">Action Taken</label><input type="text" class="form-control" name="actionTaken" id="field_actionTaken" ng-model="vm.projectLogNewCaf.actionTaken"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectLogNewCaf.actionTakenBy" for="field_actionTakenBy">Action Taken By</label><input type="text" class="form-control" name="actionTakenBy" id="field_actionTakenBy" ng-model="vm.projectLogNewCaf.actionTakenBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectLogNewCaf.actionTakenDate" for="field_actionTakenDate">Action Taken Date</label><div class="input-group"><input id="field_actionTakenDate" type="text" class="form-control" name="actionTakenDate" datetime-picker="{{dateformat}}" ng-model="vm.projectLogNewCaf.actionTakenDate" is-open="vm.datePickerOpenStatus.actionTakenDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'actionTakenDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectLogNewCaf.actionType" for="field_actionType">Action Type</label><input type="text" class="form-control" name="actionType" id="field_actionType" ng-model="vm.projectLogNewCaf.actionType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectLogNewCaf.fieldUpdated" for="field_fieldUpdated">Field Updated</label><input type="text" class="form-control" name="fieldUpdated" id="field_fieldUpdated" ng-model="vm.projectLogNewCaf.fieldUpdated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectLogNewCaf.oldValue" for="field_oldValue">Old Value</label><input type="text" class="form-control" name="oldValue" id="field_oldValue" ng-model="vm.projectLogNewCaf.oldValue"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectLogNewCaf.newValue" for="field_newValue">New Value</label><input type="text" class="form-control" name="newValue" id="field_newValue" ng-model="vm.projectLogNewCaf.newValue"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/project-log-new-caf/project-log-new-cafs.html','<div><h2 data-translate="investhryApp.projectLogNewCaf.home.title">Project Log New Cafs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="project-log-new-caf.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectLogNewCaf.home.createLabel">Create new Project Log New Caf</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectLogNewCaf.projectId">Project Id</span></th><th><span data-translate="investhryApp.projectLogNewCaf.actionTaken">Action Taken</span></th><th><span data-translate="investhryApp.projectLogNewCaf.actionTakenBy">Action Taken By</span></th><th><span data-translate="investhryApp.projectLogNewCaf.actionTakenDate">Action Taken Date</span></th><th><span data-translate="investhryApp.projectLogNewCaf.actionType">Action Type</span></th><th><span data-translate="investhryApp.projectLogNewCaf.fieldUpdated">Field Updated</span></th><th><span data-translate="investhryApp.projectLogNewCaf.oldValue">Old Value</span></th><th><span data-translate="investhryApp.projectLogNewCaf.newValue">New Value</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectLogNewCaf in vm.projectLogNewCafs track by projectLogNewCaf.id"><td><a ui-sref="project-log-new-caf-detail({id:projectLogNewCaf.id})">{{projectLogNewCaf.id}}</a></td><td>{{projectLogNewCaf.projectId}}</td><td>{{projectLogNewCaf.actionTaken}}</td><td>{{projectLogNewCaf.actionTakenBy}}</td><td>{{projectLogNewCaf.actionTakenDate | date:\'medium\'}}</td><td>{{projectLogNewCaf.actionType}}</td><td>{{projectLogNewCaf.fieldUpdated}}</td><td>{{projectLogNewCaf.oldValue}}</td><td>{{projectLogNewCaf.newValue}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="project-log-new-caf-detail({id:projectLogNewCaf.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="project-log-new-caf.edit({id:projectLogNewCaf.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="project-log-new-caf.delete({id:projectLogNewCaf.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/project-phase/project-phase-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.project_phase.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.project_phase.delete.question" translate-values="{id: \'{{vm.project_phase.id}}\'}">Are you sure you want to delete this Project Phase?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/project-phase/project-phase-detail.html','<div><h2><span data-translate="investhryApp.project_phase.detail.title">Project Phase</span> {{vm.project_phase.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.project_phase.projectid">Projectid</span></dt><dd><span>{{vm.project_phase.projectid}}</span></dd><dt><span data-translate="investhryApp.project_phase.phase">Phase</span></dt><dd><span>{{vm.project_phase.phase}}</span></dd><dt><span data-translate="investhryApp.project_phase.productcategory">Productcategory</span></dt><dd><span>{{vm.project_phase.productcategory}}</span></dd><dt><span data-translate="investhryApp.project_phase.fci">Fci</span></dt><dd><span>{{vm.project_phase.fci}}</span></dd><dt><span data-translate="investhryApp.project_phase.implementationdate">Implementationdate</span></dt><dd><span>{{vm.project_phase.implementationdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project_phase.createdate">Createdate</span></dt><dd><span>{{vm.project_phase.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.project_phase.updatedate">Updatedate</span></dt><dd><span>{{vm.project_phase.updatedate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="project-phase-detail.edit({id:vm.project_phase.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/project-phase/project-phase-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProject_phaseLabel" data-translate="investhryApp.project_phase.home.createOrEditLabel">Create or edit a Project Phase</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.project_phase.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.project_phase.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_phase.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.project_phase.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_phase.phase" for="field_phase">Phase</label><input type="text" class="form-control" name="phase" id="field_phase" ng-model="vm.project_phase.phase"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_phase.productcategory" for="field_productcategory">Productcategory</label><input type="text" class="form-control" name="productcategory" id="field_productcategory" ng-model="vm.project_phase.productcategory"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_phase.fci" for="field_fci">Fci</label><input type="text" class="form-control" name="fci" id="field_fci" ng-model="vm.project_phase.fci"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_phase.implementationdate" for="field_implementationdate">Implementationdate</label><div class="input-group"><input id="field_implementationdate" type="text" class="form-control" name="implementationdate" datetime-picker="{{dateformat}}" ng-model="vm.project_phase.implementationdate" is-open="vm.datePickerOpenStatus.implementationdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'implementationdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_phase.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.project_phase.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.project_phase.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.project_phase.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/project-phase/project-phases.html','<div class="container"><h2 data-translate="investhryApp.project_phase.home.title">Project Phases</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="project-phase.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.project_phase.home.createLabel">Create new Project Phase</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.project_phase.projectid">Projectid</span></th><th><span data-translate="investhryApp.project_phase.phase">Phase</span></th><th><span data-translate="investhryApp.project_phase.productcategory">Productcategory</span></th><th><span data-translate="investhryApp.project_phase.fci">Fci</span></th><th><span data-translate="investhryApp.project_phase.implementationdate">Implementationdate</span></th><th><span data-translate="investhryApp.project_phase.createdate">Createdate</span></th><th><span data-translate="investhryApp.project_phase.updatedate">Updatedate</span></th><th></th></tr></thead><tbody><tr ng-repeat="project_phase in vm.project_phases track by project_phase.id"><td><a ui-sref="project-phase-detail({id:project_phase.id})">{{project_phase.id}}</a></td><td>{{project_phase.projectid}}</td><td>{{project_phase.phase}}</td><td>{{project_phase.productcategory}}</td><td>{{project_phase.fci}}</td><td>{{project_phase.implementationdate | date:\'medium\'}}</td><td>{{project_phase.createdate | date:\'medium\'}}</td><td>{{project_phase.updatedate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="project-phase-detail({id:project_phase.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="project-phase.edit({id:project_phase.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="project-phase.delete({id:project_phase.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/project-service-log/project-service-log-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectServiceLog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectServiceLog.delete.question" translate-values="{id: \'{{vm.projectServiceLog.id}}\'}">Are you sure you want to delete this Project Service Log?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/project-service-log/project-service-log-detail.html','<div><h2><span data-translate="investhryApp.projectServiceLog.detail.title">Project Service Log</span> {{vm.projectServiceLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectServiceLog.projectid">Projectid</span></dt><dd><span>{{vm.projectServiceLog.projectid}}</span></dd><dt><span data-translate="investhryApp.projectServiceLog.serviceid">Serviceid</span></dt><dd><span>{{vm.projectServiceLog.serviceid}}</span></dd><dt><span data-translate="investhryApp.projectServiceLog.comments">Comments</span></dt><dd><span>{{vm.projectServiceLog.comments}}</span></dd><dt><span data-translate="investhryApp.projectServiceLog.commentDate">Comment Date</span></dt><dd><span>{{vm.projectServiceLog.commentDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectServiceLog.commentByUserLogin">Comment By User Login</span></dt><dd><span>{{vm.projectServiceLog.commentByUserLogin}}</span></dd><dt><span data-translate="investhryApp.projectServiceLog.actionTaken">Action Taken</span></dt><dd><span>{{vm.projectServiceLog.actionTaken}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="project-service-log-detail.edit({id:vm.projectServiceLog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/project-service-log/project-service-log-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectServiceLogLabel" data-translate="investhryApp.projectServiceLog.home.createOrEditLabel">Create or edit a Project Service Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectServiceLog.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectServiceLog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceLog.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.projectServiceLog.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceLog.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.projectServiceLog.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceLog.comments" for="field_comments">Comments</label><input type="text" class="form-control" name="comments" id="field_comments" ng-model="vm.projectServiceLog.comments"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceLog.commentDate" for="field_commentDate">Comment Date</label><div class="input-group"><input id="field_commentDate" type="text" class="form-control" name="commentDate" datetime-picker="{{dateformat}}" ng-model="vm.projectServiceLog.commentDate" is-open="vm.datePickerOpenStatus.commentDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'commentDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceLog.commentByUserLogin" for="field_commentByUserLogin">Comment By User Login</label><input type="text" class="form-control" name="commentByUserLogin" id="field_commentByUserLogin" ng-model="vm.projectServiceLog.commentByUserLogin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceLog.actionTaken" for="field_actionTaken">Action Taken</label><input type="text" class="form-control" name="actionTaken" id="field_actionTaken" ng-model="vm.projectServiceLog.actionTaken"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/project-service-log/project-service-logs.html','<div><h2 data-translate="investhryApp.projectServiceLog.home.title">Project Service Logs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="project-service-log.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectServiceLog.home.createLabel">Create new Project Service Log</span></button></div></div></div><br><br><div class="container"><form name="form1"><div class="row form-group"><div class="col-sm-4 col-sm-offset-2"><input type="text" class="form-control" placeholder="Enter Project id" name="projectid" ng-model="vm.projectServiceLog.projectid" required></div><div class="btn-group col-sm-4"><button class="btn btn-primary" ng-disabled="form1.projectid.$invalid" ng-click="vm.loadByProjectid()">Find Records</button></div></div></form></div><br><br><div class="table-responsive" ng-hide="vm.projectServiceLogs==undefined"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectServiceLog.projectid">Projectid</span></th><th><span data-translate="investhryApp.projectServiceLog.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.projectServiceLog.comments">Comments</span></th><th><span data-translate="investhryApp.projectServiceLog.commentDate">Comment Date</span></th><th><span data-translate="investhryApp.projectServiceLog.commentByUserLogin">Comment By User Login</span></th><th><span data-translate="investhryApp.projectServiceLog.actionTaken">Action Taken</span></th><th><span data-translate="investhryApp.projectServiceLog.rejectionReason">Rejection Reason</span></th><th><span data-translate="investhryApp.projectServiceLog.reasonCategory">Reason Category</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectServiceLog in vm.projectServiceLogs track by projectServiceLog.id"><td><a ui-sref="project-service-log-detail({id:projectServiceLog.id})">{{projectServiceLog.id}}</a></td><td>{{projectServiceLog.projectid}}</td><td>{{projectServiceLog.serviceid}}</td><td>{{projectServiceLog.comments}}</td><td>{{projectServiceLog.commentDate | date:\'medium\'}}</td><td>{{projectServiceLog.commentByUserLogin}}</td><td>{{projectServiceLog.actionTaken}}</td><td>{{projectServiceLog.rejectionReason}}</td><td>{{projectServiceLog.reasonCategory}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="project-service-log-detail({id:projectServiceLog.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="project-service-log.edit({id:projectServiceLog.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="project-service-log.delete({id:projectServiceLog.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/project-service-payment-details/project-service-payment-details-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectServicePaymentDetails.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectServicePaymentDetails.delete.question" translate-values="{id: \'{{vm.projectServicePaymentDetails.id}}\'}">Are you sure you want to delete this Project Service Payment Details?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/project-service-payment-details/project-service-payment-details-detail.html','<div><h2><span data-translate="investhryApp.projectServicePaymentDetails.detail.title">Project Service Payment Details</span> {{vm.projectServicePaymentDetails.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectServicePaymentDetails.projectid">Projectid</span></dt><dd><span>{{vm.projectServicePaymentDetails.projectid}}</span></dd><dt><span data-translate="investhryApp.projectServicePaymentDetails.serviceid">Serviceid</span></dt><dd><span>{{vm.projectServicePaymentDetails.serviceid}}</span></dd><dt><span data-translate="investhryApp.projectServicePaymentDetails.paymentMadeBy">Payment Made By</span></dt><dd><span>{{vm.projectServicePaymentDetails.paymentMadeBy}}</span></dd><dt><span data-translate="investhryApp.projectServicePaymentDetails.paymentDate">Payment Date</span></dt><dd><span>{{vm.projectServicePaymentDetails.paymentDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectServicePaymentDetails.transactionId">Transaction Id</span></dt><dd><span>{{vm.projectServicePaymentDetails.transactionId}}</span></dd><dt><span data-translate="investhryApp.projectServicePaymentDetails.paymentResponse">Payment Response</span></dt><dd><span>{{vm.projectServicePaymentDetails.paymentResponse}}</span></dd><dt><span data-translate="investhryApp.projectServicePaymentDetails.paymentStatus">Payment Status</span></dt><dd><span>{{vm.projectServicePaymentDetails.paymentStatus}}</span></dd><dt><span data-translate="investhryApp.projectServicePaymentDetails.paymentMade">Payment Made</span></dt><dd><span>{{vm.projectServicePaymentDetails.paymentMade}}</span></dd><dt><span data-translate="investhryApp.projectServicePaymentDetails.feeDescription">Fee Description</span></dt><dd><span>{{vm.projectServicePaymentDetails.feeDescription}}</span></dd><dt><span data-translate="investhryApp.projectServicePaymentDetails.paymentdisbursed">Paymentdisbursed</span></dt><dd><span>{{vm.projectServicePaymentDetails.paymentdisbursed}}</span></dd><dt><span data-translate="investhryApp.projectServicePaymentDetails.disbursedby">Disbursedby</span></dt><dd><span>{{vm.projectServicePaymentDetails.disbursedby}}</span></dd><dt><span data-translate="investhryApp.projectServicePaymentDetails.disbursementdate">Disbursementdate</span></dt><dd><span>{{vm.projectServicePaymentDetails.disbursementdate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="project-service-payment-details-detail.edit({id:vm.projectServicePaymentDetails.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/project-service-payment-details/project-service-payment-details-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectServicePaymentDetailsLabel" data-translate="investhryApp.projectServicePaymentDetails.home.createOrEditLabel">Create or edit a Project Service Payment Details</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectServicePaymentDetails.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectServicePaymentDetails.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.projectServicePaymentDetails.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.projectServicePaymentDetails.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.paymentMadeBy" for="field_paymentMadeBy">Payment Made By</label><input type="text" class="form-control" name="paymentMadeBy" id="field_paymentMadeBy" ng-model="vm.projectServicePaymentDetails.paymentMadeBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.paymentDate" for="field_paymentDate">Payment Date</label><div class="input-group"><input id="field_paymentDate" type="text" class="form-control" name="paymentDate" datetime-picker="{{dateformat}}" ng-model="vm.projectServicePaymentDetails.paymentDate" is-open="vm.datePickerOpenStatus.paymentDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'paymentDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.transactionId" for="field_transactionId">Transaction Id</label><input type="text" class="form-control" name="transactionId" id="field_transactionId" ng-model="vm.projectServicePaymentDetails.transactionId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.paymentResponse" for="field_paymentResponse">Payment Response</label><input type="text" class="form-control" name="paymentResponse" id="field_paymentResponse" ng-model="vm.projectServicePaymentDetails.paymentResponse"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.paymentStatus" for="field_paymentStatus">Payment Status</label><input type="text" class="form-control" name="paymentStatus" id="field_paymentStatus" ng-model="vm.projectServicePaymentDetails.paymentStatus"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.paymentMade" for="field_paymentMade">Payment Made</label><input type="number" class="form-control" name="paymentMade" id="field_paymentMade" ng-model="vm.projectServicePaymentDetails.paymentMade"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.feeDescription" for="field_feeDescription">Fee Description</label><input type="text" class="form-control" name="feeDescription" id="field_feeDescription" ng-model="vm.projectServicePaymentDetails.feeDescription"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.paymentdisbursed" for="field_paymentdisbursed">Paymentdisbursed</label><input type="checkbox" class="form-control" name="paymentdisbursed" id="field_paymentdisbursed" ng-model="vm.projectServicePaymentDetails.paymentdisbursed"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.disbursedby" for="field_disbursedby">Disbursedby</label><input type="text" class="form-control" name="disbursedby" id="field_disbursedby" ng-model="vm.projectServicePaymentDetails.disbursedby"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServicePaymentDetails.disbursementdate" for="field_disbursementdate">Disbursementdate</label><div class="input-group"><input id="field_disbursementdate" type="text" class="form-control" name="disbursementdate" datetime-picker="{{dateformat}}" ng-model="vm.projectServicePaymentDetails.disbursementdate" is-open="vm.datePickerOpenStatus.disbursementdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'disbursementdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/project-service-payment-details/project-service-payment-details.html','<div><h2 data-translate="investhryApp.projectServicePaymentDetails.home.title">Project Service Payment Details</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="project-service-payment-details.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectServicePaymentDetails.home.createLabel">Create new Project Service Payment Details</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.projectid">Projectid</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.paymentMadeBy">Payment Made By</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.paymentDate">Payment Date</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.transactionId">Transaction Id</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.paymentResponse">Payment Response</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.paymentStatus">Payment Status</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.paymentMade">Payment Made</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.feeDescription">Fee Description</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.paymentdisbursed">Paymentdisbursed</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.disbursedby">Disbursedby</span></th><th><span data-translate="investhryApp.projectServicePaymentDetails.disbursementdate">Disbursementdate</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectServicePaymentDetails in vm.projectServicePaymentDetails track by projectServicePaymentDetails.id"><td><a ui-sref="project-service-payment-details-detail({id:projectServicePaymentDetails.id})">{{projectServicePaymentDetails.id}}</a></td><td>{{projectServicePaymentDetails.projectid}}</td><td>{{projectServicePaymentDetails.serviceid}}</td><td>{{projectServicePaymentDetails.paymentMadeBy}}</td><td>{{projectServicePaymentDetails.paymentDate | date:\'medium\'}}</td><td>{{projectServicePaymentDetails.transactionId}}</td><td>{{projectServicePaymentDetails.paymentResponse}}</td><td>{{projectServicePaymentDetails.paymentStatus}}</td><td>{{projectServicePaymentDetails.paymentMade}}</td><td>{{projectServicePaymentDetails.feeDescription}}</td><td>{{projectServicePaymentDetails.paymentdisbursed}}</td><td>{{projectServicePaymentDetails.disbursedby}}</td><td>{{projectServicePaymentDetails.disbursementdate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="project-service-payment-details-detail({id:projectServicePaymentDetails.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="project-service-payment-details.edit({id:projectServicePaymentDetails.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="project-service-payment-details.delete({id:projectServicePaymentDetails.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/project-service-report-info/project-service-report-info-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectServiceReportInfo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectServiceReportInfo.delete.question" translate-values="{id: \'{{vm.projectServiceReportInfo.id}}\'}">Are you sure you want to delete this Project Service Report Info?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/project-service-report-info/project-service-report-info-detail.html','<div><h2><span data-translate="investhryApp.projectServiceReportInfo.detail.title">Project Service Report Info</span> {{vm.projectServiceReportInfo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectServiceReportInfo.projectid">Projectid</span></dt><dd><span>{{vm.projectServiceReportInfo.projectid}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.projecttype">Projecttype</span></dt><dd><span>{{vm.projectServiceReportInfo.projecttype}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.departmentname">Departmentname</span></dt><dd><span>{{vm.projectServiceReportInfo.departmentname}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.servicename">Servicename</span></dt><dd><span>{{vm.projectServiceReportInfo.servicename}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.assignDate">Assign Date</span></dt><dd><span>{{vm.projectServiceReportInfo.assignDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.requireDate">Require Date</span></dt><dd><span>{{vm.projectServiceReportInfo.requireDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.status">Status</span></dt><dd><span>{{vm.projectServiceReportInfo.status}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.stage">Stage</span></dt><dd><span>{{vm.projectServiceReportInfo.stage}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.investorName">Investor Name</span></dt><dd><span>{{vm.projectServiceReportInfo.investorName}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.cafPin">Caf Pin</span></dt><dd><span>{{vm.projectServiceReportInfo.cafPin}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.finalAction">Final Action</span></dt><dd><span>{{vm.projectServiceReportInfo.finalAction}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.finalActionDate">Final Action Date</span></dt><dd><span>{{vm.projectServiceReportInfo.finalActionDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.projectInvestment">Project Investment</span></dt><dd><span>{{vm.projectServiceReportInfo.projectInvestment}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.projectEmployment">Project Employment</span></dt><dd><span>{{vm.projectServiceReportInfo.projectEmployment}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.proposedprojectarea">Proposedprojectarea</span></dt><dd><span>{{vm.projectServiceReportInfo.proposedprojectarea}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.confirmitylanduse">Confirmitylanduse</span></dt><dd><span>{{vm.projectServiceReportInfo.confirmitylanduse}}</span></dd><dt><span data-translate="investhryApp.projectServiceReportInfo.landzoneusetype">Landzoneusetype</span></dt><dd><span>{{vm.projectServiceReportInfo.landzoneusetype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="project-service-report-info-detail.edit({id:vm.projectServiceReportInfo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/project-service-report-info/project-service-report-info-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectServiceReportInfoLabel" data-translate="investhryApp.projectServiceReportInfo.home.createOrEditLabel">Create or edit a Project Service Report Info</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectServiceReportInfo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectServiceReportInfo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.projectServiceReportInfo.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.projecttype" for="field_projecttype">Projecttype</label><input type="text" class="form-control" name="projecttype" id="field_projecttype" ng-model="vm.projectServiceReportInfo.projecttype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.departmentname" for="field_departmentname">Departmentname</label><input type="text" class="form-control" name="departmentname" id="field_departmentname" ng-model="vm.projectServiceReportInfo.departmentname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.servicename" for="field_servicename">Servicename</label><input type="text" class="form-control" name="servicename" id="field_servicename" ng-model="vm.projectServiceReportInfo.servicename"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.assignDate" for="field_assignDate">Assign Date</label><div class="input-group"><input id="field_assignDate" type="text" class="form-control" name="assignDate" datetime-picker="{{dateformat}}" ng-model="vm.projectServiceReportInfo.assignDate" is-open="vm.datePickerOpenStatus.assignDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'assignDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.requireDate" for="field_requireDate">Require Date</label><div class="input-group"><input id="field_requireDate" type="text" class="form-control" name="requireDate" datetime-picker="{{dateformat}}" ng-model="vm.projectServiceReportInfo.requireDate" is-open="vm.datePickerOpenStatus.requireDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'requireDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.projectServiceReportInfo.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.stage" for="field_stage">Stage</label><input type="text" class="form-control" name="stage" id="field_stage" ng-model="vm.projectServiceReportInfo.stage"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.investorName" for="field_investorName">Investor Name</label><input type="text" class="form-control" name="investorName" id="field_investorName" ng-model="vm.projectServiceReportInfo.investorName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.cafPin" for="field_cafPin">Caf Pin</label><input type="text" class="form-control" name="cafPin" id="field_cafPin" ng-model="vm.projectServiceReportInfo.cafPin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.finalAction" for="field_finalAction">Final Action</label><input type="text" class="form-control" name="finalAction" id="field_finalAction" ng-model="vm.projectServiceReportInfo.finalAction"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.finalActionDate" for="field_finalActionDate">Final Action Date</label><div class="input-group"><input id="field_finalActionDate" type="text" class="form-control" name="finalActionDate" datetime-picker="{{dateformat}}" ng-model="vm.projectServiceReportInfo.finalActionDate" is-open="vm.datePickerOpenStatus.finalActionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'finalActionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.projectInvestment" for="field_projectInvestment">Project Investment</label><input type="number" class="form-control" name="projectInvestment" id="field_projectInvestment" ng-model="vm.projectServiceReportInfo.projectInvestment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.projectEmployment" for="field_projectEmployment">Project Employment</label><input type="text" class="form-control" name="projectEmployment" id="field_projectEmployment" ng-model="vm.projectServiceReportInfo.projectEmployment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.proposedprojectarea" for="field_proposedprojectarea">Proposedprojectarea</label><input type="text" class="form-control" name="proposedprojectarea" id="field_proposedprojectarea" ng-model="vm.projectServiceReportInfo.proposedprojectarea"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.confirmitylanduse" for="field_confirmitylanduse">Confirmitylanduse</label><input type="checkbox" class="form-control" name="confirmitylanduse" id="field_confirmitylanduse" ng-model="vm.projectServiceReportInfo.confirmitylanduse"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectServiceReportInfo.landzoneusetype" for="field_landzoneusetype">Landzoneusetype</label><input type="text" class="form-control" name="landzoneusetype" id="field_landzoneusetype" ng-model="vm.projectServiceReportInfo.landzoneusetype"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/project-service-report-info/project-service-report-infos.html','<div><h2 data-translate="investhryApp.projectServiceReportInfo.home.title">Project Service Report Infos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="project-service-report-info.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectServiceReportInfo.home.createLabel">Create new Project Service Report Info</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.projectid">Projectid</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.projecttype">Projecttype</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.departmentname">Departmentname</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.servicename">Servicename</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.assignDate">Assign Date</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.requireDate">Require Date</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.status">Status</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.stage">Stage</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.investorName">Investor Name</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.cafPin">Caf Pin</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.finalAction">Final Action</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.finalActionDate">Final Action Date</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.projectInvestment">Project Investment</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.projectEmployment">Project Employment</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.proposedprojectarea">Proposedprojectarea</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.confirmitylanduse">Confirmitylanduse</span></th><th><span data-translate="investhryApp.projectServiceReportInfo.landzoneusetype">Landzoneusetype</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectServiceReportInfo in vm.projectServiceReportInfos track by projectServiceReportInfo.id"><td><a ui-sref="project-service-report-info-detail({id:projectServiceReportInfo.id})">{{projectServiceReportInfo.id}}</a></td><td>{{projectServiceReportInfo.projectid}}</td><td>{{projectServiceReportInfo.projecttype}}</td><td>{{projectServiceReportInfo.departmentname}}</td><td>{{projectServiceReportInfo.servicename}}</td><td>{{projectServiceReportInfo.assignDate | date:\'medium\'}}</td><td>{{projectServiceReportInfo.requireDate | date:\'medium\'}}</td><td>{{projectServiceReportInfo.status}}</td><td>{{projectServiceReportInfo.stage}}</td><td>{{projectServiceReportInfo.investorName}}</td><td>{{projectServiceReportInfo.cafPin}}</td><td>{{projectServiceReportInfo.finalAction}}</td><td>{{projectServiceReportInfo.finalActionDate | date:\'medium\'}}</td><td>{{projectServiceReportInfo.projectInvestment}}</td><td>{{projectServiceReportInfo.projectEmployment}}</td><td>{{projectServiceReportInfo.proposedprojectarea}}</td><td>{{projectServiceReportInfo.confirmitylanduse}}</td><td>{{projectServiceReportInfo.landzoneusetype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="project-service-report-info-detail({id:projectServiceReportInfo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="project-service-report-info.edit({id:projectServiceReportInfo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="project-service-report-info.delete({id:projectServiceReportInfo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/project-skills/project-skills-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectSkills.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectSkills.delete.question" translate-values="{id: \'{{vm.projectSkills.id}}\'}">Are you sure you want to delete this Project Skills?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/project-skills/project-skills-detail.html','<div><h2><span data-translate="investhryApp.projectSkills.detail.title">Project Skills</span> {{vm.projectSkills.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.projectSkills.district">District</span></dt><dd><span>{{vm.projectSkills.district}}</span></dd><dt><span data-translate="investhryApp.projectSkills.sector">Sector</span></dt><dd><span>{{vm.projectSkills.sector}}</span></dd><dt><span data-translate="investhryApp.projectSkills.jobRole">Job Role</span></dt><dd><span>{{vm.projectSkills.jobRole}}</span></dd><dt><span data-translate="investhryApp.projectSkills.requiredLabour">Required Labour</span></dt><dd><span>{{vm.projectSkills.requiredLabour}}</span></dd><dt><span data-translate="investhryApp.projectSkills.cafPin">Caf Pin</span></dt><dd><span>{{vm.projectSkills.cafPin}}</span></dd><dt><span data-translate="investhryApp.projectSkills.projectId">Project Id</span></dt><dd><span>{{vm.projectSkills.projectId}}</span></dd><dt><span data-translate="investhryApp.projectSkills.creationDate">Creation Date</span></dt><dd><span>{{vm.projectSkills.creationDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="project-skills-detail.edit({id:vm.projectSkills.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/project-skills/project-skills-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectSkillsLabel" data-translate="investhryApp.projectSkills.home.createOrEditLabel">Create or edit a Project Skills</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectSkills.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectSkills.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectSkills.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.projectSkills.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectSkills.sector" for="field_sector">Sector</label><input type="text" class="form-control" name="sector" id="field_sector" ng-model="vm.projectSkills.sector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectSkills.jobRole" for="field_jobRole">Job Role</label><input type="text" class="form-control" name="jobRole" id="field_jobRole" ng-model="vm.projectSkills.jobRole"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectSkills.requiredLabour" for="field_requiredLabour">Required Labour</label><input type="text" class="form-control" name="requiredLabour" id="field_requiredLabour" ng-model="vm.projectSkills.requiredLabour"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectSkills.cafPin" for="field_cafPin">Caf Pin</label><input type="text" class="form-control" name="cafPin" id="field_cafPin" ng-model="vm.projectSkills.cafPin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectSkills.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.projectSkills.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectSkills.creationDate" for="field_creationDate">Creation Date</label><div class="input-group"><input id="field_creationDate" type="text" class="form-control" name="creationDate" datetime-picker="{{dateformat}}" ng-model="vm.projectSkills.creationDate" is-open="vm.datePickerOpenStatus.creationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/project-skills/project-skills.html','<div><h2 data-translate="investhryApp.projectSkills.home.title">Project Skills</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="project-skills.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectSkills.home.createLabel">Create new Project Skills</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectSkills.district">District</span></th><th><span data-translate="investhryApp.projectSkills.sector">Sector</span></th><th><span data-translate="investhryApp.projectSkills.jobRole">Job Role</span></th><th><span data-translate="investhryApp.projectSkills.requiredLabour">Required Labour</span></th><th><span data-translate="investhryApp.projectSkills.cafPin">Caf Pin (Composite Application Form)</span></th><th><span data-translate="investhryApp.projectSkills.projectId">Project Id</span></th><th><span data-translate="investhryApp.projectSkills.creationDate">Creation Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectSkills in vm.projectSkills track by projectSkills.id"><td><a ui-sref="project-skills-detail({id:projectSkills.id})">{{projectSkills.id}}</a></td><td>{{projectSkills.district}}</td><td>{{projectSkills.sector}}</td><td>{{projectSkills.jobRole}}</td><td>{{projectSkills.requiredLabour}}</td><td>{{projectSkills.cafPin}}</td><td>{{projectSkills.projectId}}</td><td>{{projectSkills.creationDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="project-skills-detail({id:projectSkills.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="project-skills.edit({id:projectSkills.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="project-skills.delete({id:projectSkills.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/projectcategory/projectcategories.html','<div class="container"><h2 data-translate="investhryApp.projectcategory.home.title">Projectcategories</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="projectcategory.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectcategory.home.createLabel">Create new Projectcategory</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectcategory.categorytype">Categorytype</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectcategory in vm.projectcategories track by projectcategory.id"><td><a ui-sref="projectcategory-detail({id:projectcategory.id})">{{projectcategory.id}}</a></td><td>{{projectcategory.categorytype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="projectcategory-detail({id:projectcategory.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="projectcategory.edit({id:projectcategory.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="projectcategory.delete({id:projectcategory.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/projectcategory/projectcategory-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectcategory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectcategory.delete.question" translate-values="{id: \'{{vm.projectcategory.id}}\'}">Are you sure you want to delete this Projectcategory?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/projectcategory/projectcategory-detail.html','<div class="container"><h2><span data-translate="investhryApp.projectcategory.detail.title">Projectcategory</span> {{vm.projectcategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectcategory.categorytype">Categorytype</span></dt><dd><span>{{vm.projectcategory.categorytype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="projectcategory-detail.edit({id:vm.projectcategory.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/projectcategory/projectcategory-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectcategoryLabel" data-translate="investhryApp.projectcategory.home.createOrEditLabel">Create or edit a Projectcategory</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectcategory.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectcategory.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectcategory.categorytype" for="field_categorytype">Categorytype</label><input type="text" class="form-control" name="categorytype" id="field_categorytype" ng-model="vm.projectcategory.categorytype" required><div ng-show="editForm.categorytype.$invalid"><p class="help-block" ng-show="editForm.categorytype.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/projectdetail/projectdetail-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectdetail.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectdetail.delete.question" translate-values="{id: \'{{vm.projectdetail.id}}\'}">Are you sure you want to delete this Projectdetail?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/projectdetail/projectdetail-detail.html','<div><h2><span data-translate="investhryApp.projectdetail.detail.title">Projectdetail</span> {{vm.projectdetail.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectdetail.projectpurpose">Projectpurpose</span></dt><dd><span>{{vm.projectdetail.projectpurpose}}</span></dd><dt><span data-translate="investhryApp.projectdetail.niccode">Niccode</span></dt><dd><span>{{vm.projectdetail.niccode}}</span></dd><dt><span data-translate="investhryApp.projectdetail.existing_regulatory_approval">Existing Regulatory Approval</span></dt><dd><span>{{vm.projectdetail.existing_regulatory_approval}}</span></dd><dt><span data-translate="investhryApp.projectdetail.edc_sif_clu_fee_paid_applicable">Edc Sif Clu Fee Paid Applicable</span></dt><dd><span>{{vm.projectdetail.edc_sif_clu_fee_paid_applicable}}</span></dd><dt><span data-translate="investhryApp.projectdetail.approval_application_form">Approval Application Form</span></dt><dd><span>{{vm.projectdetail.approval_application_form}}</span></dd><dt><span data-translate="investhryApp.projectdetail.category_of_project">Category Of Project</span></dt><dd><span>{{vm.projectdetail.category_of_project}}</span></dd><dt><span data-translate="investhryApp.projectdetail.collaboration_with_foreign_country">Collaboration With Foreign Country</span></dt><dd><span>{{vm.projectdetail.collaboration_with_foreign_country}}</span></dd><dt><span data-translate="investhryApp.projectdetail.projectype">Projectype</span></dt><dd><span>{{vm.projectdetail.projectype}}</span></dd><dt><span data-translate="investhryApp.projectdetail.sectorname">Sectorname</span></dt><dd><span>{{vm.projectdetail.sectorname}}</span></dd><dt><span data-translate="investhryApp.projectdetail.size_of_industry">Size Of Industry</span></dt><dd><span>{{vm.projectdetail.size_of_industry}}</span></dd><dt><span data-translate="investhryApp.projectdetail.createdate">Createdate</span></dt><dd><span>{{vm.projectdetail.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectdetail.updatedate">Updatedate</span></dt><dd><span>{{vm.projectdetail.updatedate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectdetail.sectorother">Sectorother</span></dt><dd><span>{{vm.projectdetail.sectorother}}</span></dd><dt><span data-translate="investhryApp.projectdetail.assignedRM">Assigned RM</span></dt><dd><span>{{vm.projectdetail.assignedRM}}</span></dd><dt><span data-translate="investhryApp.projectdetail.isdeactivated">Isdeactivated</span></dt><dd><span>{{vm.projectdetail.isdeactivated}}</span></dd><dt><span data-translate="investhryApp.projectdetail.deactivatedby">Deactivatedby</span></dt><dd><span>{{vm.projectdetail.deactivatedby}}</span></dd><dt><span data-translate="investhryApp.projectdetail.deactivateddate">Deactivateddate</span></dt><dd><span>{{vm.projectdetail.deactivateddate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectdetail.projectlevel">Projectlevel</span></dt><dd><span>{{vm.projectdetail.projectlevel}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="projectdetail-detail.edit({id:vm.projectdetail.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/projectdetail/projectdetail-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectdetailLabel" data-translate="investhryApp.projectdetail.home.createOrEditLabel">Create or edit a Projectdetail</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectdetail.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectdetail.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.projectpurpose" for="field_projectpurpose">Projectpurpose</label><input type="text" class="form-control" name="projectpurpose" id="field_projectpurpose" ng-model="vm.projectdetail.projectpurpose"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.niccode" for="field_niccode">Niccode</label><input type="text" class="form-control" name="niccode" id="field_niccode" ng-model="vm.projectdetail.niccode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.existing_regulatory_approval" for="field_existing_regulatory_approval">Existing Regulatory Approval</label><input type="checkbox" class="form-control" name="existing_regulatory_approval" id="field_existing_regulatory_approval" ng-model="vm.projectdetail.existing_regulatory_approval"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.edc_sif_clu_fee_paid_applicable" for="field_edc_sif_clu_fee_paid_applicable">Edc Sif Clu Fee Paid Applicable</label><input type="checkbox" class="form-control" name="edc_sif_clu_fee_paid_applicable" id="field_edc_sif_clu_fee_paid_applicable" ng-model="vm.projectdetail.edc_sif_clu_fee_paid_applicable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.approval_application_form" for="field_approval_application_form">Approval Application Form</label><input type="text" class="form-control" name="approval_application_form" id="field_approval_application_form" ng-model="vm.projectdetail.approval_application_form"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.category_of_project" for="field_category_of_project">Category Of Project</label><input type="text" class="form-control" name="category_of_project" id="field_category_of_project" ng-model="vm.projectdetail.category_of_project"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.collaboration_with_foreign_country" for="field_collaboration_with_foreign_country">Collaboration With Foreign Country</label><input type="text" class="form-control" name="collaboration_with_foreign_country" id="field_collaboration_with_foreign_country" ng-model="vm.projectdetail.collaboration_with_foreign_country"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.projectype" for="field_projectype">Projectype</label><input type="text" class="form-control" name="projectype" id="field_projectype" ng-model="vm.projectdetail.projectype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.sectorname" for="field_sectorname">Sectorname</label><input type="text" class="form-control" name="sectorname" id="field_sectorname" ng-model="vm.projectdetail.sectorname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.size_of_industry" for="field_size_of_industry">Size Of Industry</label><input type="text" class="form-control" name="size_of_industry" id="field_size_of_industry" ng-model="vm.projectdetail.size_of_industry"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.projectdetail.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.projectdetail.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.sectorother" for="field_sectorother">Sectorother</label><input type="text" class="form-control" name="sectorother" id="field_sectorother" ng-model="vm.projectdetail.sectorother"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.assignedRM" for="field_assignedRM">Assigned RM</label><input type="text" class="form-control" name="assignedRM" id="field_assignedRM" ng-model="vm.projectdetail.assignedRM"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.isdeactivated" for="field_isdeactivated">Isdeactivated</label><input type="checkbox" class="form-control" name="isdeactivated" id="field_isdeactivated" ng-model="vm.projectdetail.isdeactivated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.deactivatedby" for="field_deactivatedby">Deactivatedby</label><input type="text" class="form-control" name="deactivatedby" id="field_deactivatedby" ng-model="vm.projectdetail.deactivatedby"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.deactivateddate" for="field_deactivateddate">Deactivateddate</label><div class="input-group"><input id="field_deactivateddate" type="text" class="form-control" name="deactivateddate" datetime-picker="{{dateformat}}" ng-model="vm.projectdetail.deactivateddate" is-open="vm.datePickerOpenStatus.deactivateddate" required> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'deactivateddate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.deactivateddate.$invalid"><p class="help-block" ng-show="editForm.deactivateddate.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.deactivateddate.$error.ZonedDateTimelocal" data-translate="entity.validation.ZonedDateTimelocal">This field should be a date and time.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetail.projectlevel" for="field_projectlevel">Projectlevel</label><input type="text" class="form-control" name="projectlevel" id="field_projectlevel" ng-model="vm.projectdetail.projectlevel"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/projectdetail/projectdetails.html','<div><h2 data-translate="investhryApp.projectdetail.home.title">Projectdetails</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="projectdetail.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectdetail.home.createLabel">Create new Projectdetail</span></button> <button class="btn btn-primary" ui-sref="project"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectdetail.home.createLabel">Create new Projectdetail</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectdetail.projectpurpose">Projectpurpose</span></th><th><span data-translate="investhryApp.projectdetail.niccode">Niccode</span></th><th><span data-translate="investhryApp.projectdetail.existing_regulatory_approval">Existing Regulatory Approval</span></th><th><span data-translate="investhryApp.projectdetail.edc_sif_clu_fee_paid_applicable">Edc Sif Clu Fee Paid Applicable</span></th><th><span data-translate="investhryApp.projectdetail.approval_application_form">Approval Application Form</span></th><th><span data-translate="investhryApp.projectdetail.category_of_project">Category Of Project</span></th><th><span data-translate="investhryApp.projectdetail.collaboration_with_foreign_country">Collaboration With Foreign Country</span></th><th><span data-translate="investhryApp.projectdetail.projectype">Projectype</span></th><th><span data-translate="investhryApp.projectdetail.sectorname">Sectorname</span></th><th><span data-translate="investhryApp.projectdetail.size_of_industry">Size Of Industry</span></th><th><span data-translate="investhryApp.projectdetail.createdate">Createdate</span></th><th><span data-translate="investhryApp.projectdetail.updatedate">Updatedate</span></th><th><span data-translate="investhryApp.projectdetail.sectorother">Sectorother</span></th><th><span data-translate="investhryApp.projectdetail.assignedRM">Assigned RM</span></th><th><span data-translate="investhryApp.projectdetail.isdeactivated">Isdeactivated</span></th><th><span data-translate="investhryApp.projectdetail.deactivatedby">Deactivatedby</span></th><th><span data-translate="investhryApp.projectdetail.deactivateddate">Deactivateddate</span></th><th><span data-translate="investhryApp.projectdetail.projectlevel">Projectlevel</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectdetail in vm.projectdetails track by projectdetail.id"><td><a ui-sref="projectdetail-detail({id:projectdetail.id})">{{projectdetail.id}}</a></td><td>{{projectdetail.projectpurpose}}</td><td>{{projectdetail.niccode}}</td><td>{{projectdetail.existing_regulatory_approval}}</td><td>{{projectdetail.edc_sif_clu_fee_paid_applicable}}</td><td>{{projectdetail.approval_application_form}}</td><td>{{projectdetail.category_of_project}}</td><td>{{projectdetail.collaboration_with_foreign_country}}</td><td>{{projectdetail.projectype}}</td><td>{{projectdetail.sectorname}}</td><td>{{projectdetail.size_of_industry}}</td><td>{{projectdetail.createdate | date:\'medium\'}}</td><td>{{projectdetail.updatedate | date:\'medium\'}}</td><td>{{projectdetail.sectorother}}</td><td>{{projectdetail.assignedRM}}</td><td>{{projectdetail.isdeactivated}}</td><td>{{projectdetail.deactivatedby}}</td><td>{{projectdetail.deactivateddate | date:\'medium\'}}</td><td>{{projectdetail.projectlevel}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="projectdetail-detail({id:projectdetail.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="projectdetail.edit({id:projectdetail.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="projectdetail.delete({id:projectdetail.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/projectdetailcombinecodes/projectdetailcombinecodes-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectdetailcombinecodes.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectdetailcombinecodes.delete.question" translate-values="{id: \'{{vm.projectdetailcombinecodes.id}}\'}">Are you sure you want to delete this Projectdetailcombinecodes?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/projectdetailcombinecodes/projectdetailcombinecodes-detail.html','<div><h2><span data-translate="investhryApp.projectdetailcombinecodes.detail.title">Projectdetailcombinecodes</span> {{vm.projectdetailcombinecodes.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectdetailcombinecodes.investorid">Investorid</span></dt><dd><span>{{vm.projectdetailcombinecodes.investorid}}</span></dd><dt><span data-translate="investhryApp.projectdetailcombinecodes.companydetailid">Companydetailid</span></dt><dd><span>{{vm.projectdetailcombinecodes.companydetailid}}</span></dd><dt><span data-translate="investhryApp.projectdetailcombinecodes.projectsitedetailid">Projectsitedetailid</span></dt><dd><span>{{vm.projectdetailcombinecodes.projectsitedetailid}}</span></dd><dt><span data-translate="investhryApp.projectdetailcombinecodes.projectfinanceid">Projectfinanceid</span></dt><dd><span>{{vm.projectdetailcombinecodes.projectfinanceid}}</span></dd><dt><span data-translate="investhryApp.projectdetailcombinecodes.manufacturingid">Manufacturingid</span></dt><dd><span>{{vm.projectdetailcombinecodes.manufacturingid}}</span></dd><dt><span data-translate="investhryApp.projectdetailcombinecodes.electricityrequirementid">Electricityrequirementid</span></dt><dd><span>{{vm.projectdetailcombinecodes.electricityrequirementid}}</span></dd><dt><span data-translate="investhryApp.projectdetailcombinecodes.environmentimpactdetailid">Environmentimpactdetailid</span></dt><dd><span>{{vm.projectdetailcombinecodes.environmentimpactdetailid}}</span></dd><dt><span data-translate="investhryApp.projectdetailcombinecodes.termdeclarationacceptid">Termdeclarationacceptid</span></dt><dd><span>{{vm.projectdetailcombinecodes.termdeclarationacceptid}}</span></dd><dt><span data-translate="investhryApp.projectdetailcombinecodes.isprojectrenewable">Isprojectrenewable</span></dt><dd><span>{{vm.projectdetailcombinecodes.isprojectrenewable}}</span></dd><dt><span data-translate="investhryApp.projectdetailcombinecodes.projectshop">Projectshop</span></dt><dd><span>{{vm.projectdetailcombinecodes.projectshop}}</span></dd><dt><span data-translate="investhryApp.projectdetailcombinecodes.landrequirementcaf">Landrequirementcaf</span></dt><dd><span>{{vm.projectdetailcombinecodes.landrequirementcaf}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="projectdetailcombinecodes-detail.edit({id:vm.projectdetailcombinecodes.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/projectdetailcombinecodes/projectdetailcombinecodes-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectdetailcombinecodesLabel" data-translate="investhryApp.projectdetailcombinecodes.home.createOrEditLabel">Create or edit a Projectdetailcombinecodes</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectdetailcombinecodes.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectdetailcombinecodes.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetailcombinecodes.investorid" for="field_investorid">Investorid</label><input type="text" class="form-control" name="investorid" id="field_investorid" ng-model="vm.projectdetailcombinecodes.investorid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetailcombinecodes.companydetailid" for="field_companydetailid">Companydetailid</label><input type="text" class="form-control" name="companydetailid" id="field_companydetailid" ng-model="vm.projectdetailcombinecodes.companydetailid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetailcombinecodes.projectsitedetailid" for="field_projectsitedetailid">Projectsitedetailid</label><input type="text" class="form-control" name="projectsitedetailid" id="field_projectsitedetailid" ng-model="vm.projectdetailcombinecodes.projectsitedetailid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetailcombinecodes.projectfinanceid" for="field_projectfinanceid">Projectfinanceid</label><input type="text" class="form-control" name="projectfinanceid" id="field_projectfinanceid" ng-model="vm.projectdetailcombinecodes.projectfinanceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetailcombinecodes.manufacturingid" for="field_manufacturingid">Manufacturingid</label><input type="text" class="form-control" name="manufacturingid" id="field_manufacturingid" ng-model="vm.projectdetailcombinecodes.manufacturingid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetailcombinecodes.electricityrequirementid" for="field_electricityrequirementid">Electricityrequirementid</label><input type="text" class="form-control" name="electricityrequirementid" id="field_electricityrequirementid" ng-model="vm.projectdetailcombinecodes.electricityrequirementid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetailcombinecodes.environmentimpactdetailid" for="field_environmentimpactdetailid">Environmentimpactdetailid</label><input type="text" class="form-control" name="environmentimpactdetailid" id="field_environmentimpactdetailid" ng-model="vm.projectdetailcombinecodes.environmentimpactdetailid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetailcombinecodes.termdeclarationacceptid" for="field_termdeclarationacceptid">Termdeclarationacceptid</label><input type="text" class="form-control" name="termdeclarationacceptid" id="field_termdeclarationacceptid" ng-model="vm.projectdetailcombinecodes.termdeclarationacceptid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetailcombinecodes.isprojectrenewable" for="field_isprojectrenewable">Isprojectrenewable</label><input type="checkbox" class="form-control" name="isprojectrenewable" id="field_isprojectrenewable" ng-model="vm.projectdetailcombinecodes.isprojectrenewable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetailcombinecodes.projectshop" for="field_projectshop">Projectshop</label><input type="checkbox" class="form-control" name="projectshop" id="field_projectshop" ng-model="vm.projectdetailcombinecodes.projectshop"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectdetailcombinecodes.landrequirementcaf" for="field_landrequirementcaf">Landrequirementcaf</label><input type="checkbox" class="form-control" name="landrequirementcaf" id="field_landrequirementcaf" ng-model="vm.projectdetailcombinecodes.landrequirementcaf"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/projectdetailcombinecodes/projectdetailcombinecodes.html','<div><h2 data-translate="investhryApp.projectdetailcombinecodes.home.title">Projectdetailcombinecodes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="projectdetailcombinecodes.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectdetailcombinecodes.home.createLabel">Create new Projectdetailcombinecodes</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectdetailcombinecodes.investorid">Investorid</span></th><th><span data-translate="investhryApp.projectdetailcombinecodes.companydetailid">Companydetailid</span></th><th><span data-translate="investhryApp.projectdetailcombinecodes.projectsitedetailid">Projectsitedetailid</span></th><th><span data-translate="investhryApp.projectdetailcombinecodes.projectfinanceid">Projectfinanceid</span></th><th><span data-translate="investhryApp.projectdetailcombinecodes.manufacturingid">Manufacturingid</span></th><th><span data-translate="investhryApp.projectdetailcombinecodes.electricityrequirementid">Electricityrequirementid</span></th><th><span data-translate="investhryApp.projectdetailcombinecodes.environmentimpactdetailid">Environmentimpactdetailid</span></th><th><span data-translate="investhryApp.projectdetailcombinecodes.termdeclarationacceptid">Termdeclarationacceptid</span></th><th><span data-translate="investhryApp.projectdetailcombinecodes.isprojectrenewable">Isprojectrenewable</span></th><th><span data-translate="investhryApp.projectdetailcombinecodes.projectshop">Projectshop</span></th><th><span data-translate="investhryApp.projectdetailcombinecodes.landrequirementcaf">Landrequirementcaf</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectdetailcombinecodes in vm.projectdetailcombinecodes track by projectdetailcombinecodes.id"><td><a ui-sref="projectdetailcombinecodes-detail({id:projectdetailcombinecodes.id})">{{projectdetailcombinecodes.id}}</a></td><td>{{projectdetailcombinecodes.investorid}}</td><td>{{projectdetailcombinecodes.companydetailid}}</td><td>{{projectdetailcombinecodes.projectsitedetailid}}</td><td>{{projectdetailcombinecodes.projectfinanceid}}</td><td>{{projectdetailcombinecodes.manufacturingid}}</td><td>{{projectdetailcombinecodes.electricityrequirementid}}</td><td>{{projectdetailcombinecodes.environmentimpactdetailid}}</td><td>{{projectdetailcombinecodes.termdeclarationacceptid}}</td><td>{{projectdetailcombinecodes.isprojectrenewable}}</td><td>{{projectdetailcombinecodes.projectshop}}</td><td>{{projectdetailcombinecodes.landrequirementcaf}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="projectdetailcombinecodes-detail({id:projectdetailcombinecodes.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="projectdetailcombinecodes.edit({id:projectdetailcombinecodes.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="projectdetailcombinecodes.delete({id:projectdetailcombinecodes.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/projectlog/projectlog-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectlog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectlog.delete.question" translate-values="{id: \'{{vm.projectlog.id}}\'}">Are you sure you want to delete this Projectlog?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/projectlog/projectlog-detail.html','<div><h2><span data-translate="investhryApp.projectlog.detail.title">Projectlog</span> {{vm.projectlog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectlog.projectid">Projectid</span></dt><dd><span>{{vm.projectlog.projectid}}</span></dd><dt><span data-translate="investhryApp.projectlog.actiontaken">Actiontaken</span></dt><dd><span>{{vm.projectlog.actiontaken}}</span></dd><dt><span data-translate="investhryApp.projectlog.actiontakenby">Actiontakenby</span></dt><dd><span>{{vm.projectlog.actiontakenby}}</span></dd><dt><span data-translate="investhryApp.projectlog.actiontakendate">Actiontakendate</span></dt><dd><span>{{vm.projectlog.actiontakendate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectlog.actiontype">Actiontype</span></dt><dd><span>{{vm.projectlog.actiontype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="projectlog-detail.edit({id:vm.projectlog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/projectlog/projectlog-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectlogLabel" data-translate="investhryApp.projectlog.home.createOrEditLabel">Create or edit a Projectlog</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectlog.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectlog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectlog.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.projectlog.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectlog.actiontaken" for="field_actiontaken">Actiontaken</label><input type="text" class="form-control" name="actiontaken" id="field_actiontaken" ng-model="vm.projectlog.actiontaken"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectlog.actiontakenby" for="field_actiontakenby">Actiontakenby</label><input type="text" class="form-control" name="actiontakenby" id="field_actiontakenby" ng-model="vm.projectlog.actiontakenby"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectlog.actiontakendate" for="field_actiontakendate">Actiontakendate</label><div class="input-group"><input id="field_actiontakendate" type="text" class="form-control" name="actiontakendate" datetime-picker="{{dateformat}}" ng-model="vm.projectlog.actiontakendate" is-open="vm.datePickerOpenStatus.actiontakendate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'actiontakendate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectlog.actiontype" for="field_actiontype">Actiontype</label><input type="text" class="form-control" name="actiontype" id="field_actiontype" ng-model="vm.projectlog.actiontype"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/projectlog/projectlogs.html','<div><h2 data-translate="investhryApp.projectlog.home.title">Projectlogs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="projectlog.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectlog.home.createLabel">Create new Projectlog</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectlog.projectid">Projectid</span></th><th><span data-translate="investhryApp.projectlog.actiontaken">Actiontaken</span></th><th><span data-translate="investhryApp.projectlog.actiontakenby">Actiontakenby</span></th><th><span data-translate="investhryApp.projectlog.actiontakendate">Actiontakendate</span></th><th><span data-translate="investhryApp.projectlog.actiontype">Actiontype</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectlog in vm.projectlogs track by projectlog.id"><td><a ui-sref="projectlog-detail({id:projectlog.id})">{{projectlog.id}}</a></td><td>{{projectlog.projectid}}</td><td>{{projectlog.actiontaken}}</td><td>{{projectlog.actiontakenby}}</td><td>{{projectlog.actiontakendate | date:\'medium\'}}</td><td>{{projectlog.actiontype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="projectlog-detail({id:projectlog.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="projectlog.edit({id:projectlog.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="projectlog.delete({id:projectlog.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/projectprocessflowsteps/projectprocessflowsteps-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectprocessflowsteps.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectprocessflowsteps.delete.question" translate-values="{id: \'{{vm.projectprocessflowsteps.id}}\'}">Are you sure you want to delete this Projectprocessflowsteps?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/projectprocessflowsteps/projectprocessflowsteps-detail.html','<div><h2><span data-translate="investhryApp.projectprocessflowsteps.detail.title">Projectprocessflowsteps</span> {{vm.projectprocessflowsteps.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectprocessflowsteps.steps">Steps</span></dt><dd><span>{{vm.projectprocessflowsteps.steps}}</span></dd><dt><span data-translate="investhryApp.projectprocessflowsteps.createdate">Createdate</span></dt><dd><span>{{vm.projectprocessflowsteps.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectprocessflowsteps.updatedate">Updatedate</span></dt><dd><span>{{vm.projectprocessflowsteps.updatedate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectprocessflowsteps.projectid">Projectid</span></dt><dd><span>{{vm.projectprocessflowsteps.projectid}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="projectprocessflowsteps-detail.edit({id:vm.projectprocessflowsteps.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/projectprocessflowsteps/projectprocessflowsteps-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectprocessflowstepsLabel" data-translate="investhryApp.projectprocessflowsteps.home.createOrEditLabel">Create or edit a Projectprocessflowsteps</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectprocessflowsteps.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectprocessflowsteps.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectprocessflowsteps.steps" for="field_steps">Steps</label><input type="text" class="form-control" name="steps" id="field_steps" ng-model="vm.projectprocessflowsteps.steps"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectprocessflowsteps.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.projectprocessflowsteps.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectprocessflowsteps.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.projectprocessflowsteps.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectprocessflowsteps.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.projectprocessflowsteps.projectid"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/projectprocessflowsteps/projectprocessflowsteps.html','<div class="container"><h2 data-translate="investhryApp.projectprocessflowsteps.home.title">Projectprocessflowsteps</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="projectprocessflowsteps.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectprocessflowsteps.home.createLabel">Create new Projectprocessflowsteps</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectprocessflowsteps.steps">Steps</span></th><th><span data-translate="investhryApp.projectprocessflowsteps.createdate">Createdate</span></th><th><span data-translate="investhryApp.projectprocessflowsteps.updatedate">Updatedate</span></th><th><span data-translate="investhryApp.projectprocessflowsteps.projectid">Projectid</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectprocessflowsteps in vm.projectprocessflowsteps track by projectprocessflowsteps.id"><td><a ui-sref="projectprocessflowsteps-detail({id:projectprocessflowsteps.id})">{{projectprocessflowsteps.id}}</a></td><td>{{projectprocessflowsteps.steps}}</td><td>{{projectprocessflowsteps.createdate | date:\'medium\'}}</td><td>{{projectprocessflowsteps.updatedate | date:\'medium\'}}</td><td>{{projectprocessflowsteps.projectid}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="projectprocessflowsteps-detail({id:projectprocessflowsteps.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="projectprocessflowsteps.edit({id:projectprocessflowsteps.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="projectprocessflowsteps.delete({id:projectprocessflowsteps.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/projectproduct/projectproduct-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectproduct.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectproduct.delete.question" translate-values="{id: \'{{vm.projectproduct.id}}\'}">Are you sure you want to delete this Projectproduct?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/projectproduct/projectproduct-detail.html','<div><h2><span data-translate="investhryApp.projectproduct.detail.title">Projectproduct</span> {{vm.projectproduct.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectproduct.mainproduct">Mainproduct</span></dt><dd><span>{{vm.projectproduct.mainproduct}}</span></dd><dt><span data-translate="investhryApp.projectproduct.quantity">Quantity</span></dt><dd><span>{{vm.projectproduct.quantity}}</span></dd><dt><span data-translate="investhryApp.projectproduct.units">Units</span></dt><dd><span>{{vm.projectproduct.units}}</span></dd><dt><span data-translate="investhryApp.projectproduct.createdate">Createdate</span></dt><dd><span>{{vm.projectproduct.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectproduct.updatedate">Updatedate</span></dt><dd><span>{{vm.projectproduct.updatedate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectproduct.projectid">Projectid</span></dt><dd><span>{{vm.projectproduct.projectid}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="projectproduct-detail.edit({id:vm.projectproduct.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/projectproduct/projectproduct-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectproductLabel" data-translate="investhryApp.projectproduct.home.createOrEditLabel">Create or edit a Projectproduct</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectproduct.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectproduct.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectproduct.mainproduct" for="field_mainproduct">Mainproduct</label><input type="text" class="form-control" name="mainproduct" id="field_mainproduct" ng-model="vm.projectproduct.mainproduct"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectproduct.quantity" for="field_quantity">Quantity</label><input type="number" class="form-control" name="quantity" id="field_quantity" ng-model="vm.projectproduct.quantity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectproduct.units" for="field_units">Units</label><input type="text" class="form-control" name="units" id="field_units" ng-model="vm.projectproduct.units"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectproduct.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.projectproduct.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectproduct.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.projectproduct.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectproduct.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.projectproduct.projectid"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/projectproduct/projectproducts.html','<div class="container"><h2 data-translate="investhryApp.projectproduct.home.title">Projectproducts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="projectproduct.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectproduct.home.createLabel">Create new Projectproduct</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectproduct.mainproduct">Mainproduct</span></th><th><span data-translate="investhryApp.projectproduct.quantity">Quantity</span></th><th><span data-translate="investhryApp.projectproduct.units">Units</span></th><th><span data-translate="investhryApp.projectproduct.createdate">Createdate</span></th><th><span data-translate="investhryApp.projectproduct.updatedate">Updatedate</span></th><th><span data-translate="investhryApp.projectproduct.projectid">Projectid</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectproduct in vm.projectproducts track by projectproduct.id"><td><a ui-sref="projectproduct-detail({id:projectproduct.id})">{{projectproduct.id}}</a></td><td>{{projectproduct.mainproduct}}</td><td>{{projectproduct.quantity}}</td><td>{{projectproduct.units}}</td><td>{{projectproduct.createdate | date:\'medium\'}}</td><td>{{projectproduct.updatedate | date:\'medium\'}}</td><td>{{projectproduct.projectid}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="projectproduct-detail({id:projectproduct.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="projectproduct.edit({id:projectproduct.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="projectproduct.delete({id:projectproduct.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/projectrawmaterial/projectrawmaterial-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectrawmaterial.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectrawmaterial.delete.question" translate-values="{id: \'{{vm.projectrawmaterial.id}}\'}">Are you sure you want to delete this Projectrawmaterial?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/projectrawmaterial/projectrawmaterial-detail.html','<div><h2><span data-translate="investhryApp.projectrawmaterial.detail.title">Projectrawmaterial</span> {{vm.projectrawmaterial.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectrawmaterial.rawmaterial">Rawmaterial</span></dt><dd><span>{{vm.projectrawmaterial.rawmaterial}}</span></dd><dt><span data-translate="investhryApp.projectrawmaterial.quantity">Quantity</span></dt><dd><span>{{vm.projectrawmaterial.quantity}}</span></dd><dt><span data-translate="investhryApp.projectrawmaterial.units">Units</span></dt><dd><span>{{vm.projectrawmaterial.units}}</span></dd><dt><span data-translate="investhryApp.projectrawmaterial.createdate">Createdate</span></dt><dd><span>{{vm.projectrawmaterial.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectrawmaterial.updatedate">Updatedate</span></dt><dd><span>{{vm.projectrawmaterial.updatedate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectrawmaterial.projectid">Projectid</span></dt><dd><span>{{vm.projectrawmaterial.projectid}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="projectrawmaterial-detail.edit({id:vm.projectrawmaterial.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/projectrawmaterial/projectrawmaterial-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectrawmaterialLabel" data-translate="investhryApp.projectrawmaterial.home.createOrEditLabel">Create or edit a Projectrawmaterial</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectrawmaterial.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectrawmaterial.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectrawmaterial.rawmaterial" for="field_rawmaterial">Rawmaterial</label><input type="text" class="form-control" name="rawmaterial" id="field_rawmaterial" ng-model="vm.projectrawmaterial.rawmaterial"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectrawmaterial.quantity" for="field_quantity">Quantity</label><input type="number" class="form-control" name="quantity" id="field_quantity" ng-model="vm.projectrawmaterial.quantity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectrawmaterial.units" for="field_units">Units</label><input type="text" class="form-control" name="units" id="field_units" ng-model="vm.projectrawmaterial.units"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectrawmaterial.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.projectrawmaterial.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectrawmaterial.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.projectrawmaterial.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectrawmaterial.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.projectrawmaterial.projectid"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/projectrawmaterial/projectrawmaterials.html','<div class="container"><h2 data-translate="investhryApp.projectrawmaterial.home.title">Projectrawmaterials</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="projectrawmaterial.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectrawmaterial.home.createLabel">Create new Projectrawmaterial</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectrawmaterial.rawmaterial">Rawmaterial</span></th><th><span data-translate="investhryApp.projectrawmaterial.quantity">Quantity</span></th><th><span data-translate="investhryApp.projectrawmaterial.units">Units</span></th><th><span data-translate="investhryApp.projectrawmaterial.createdate">Createdate</span></th><th><span data-translate="investhryApp.projectrawmaterial.updatedate">Updatedate</span></th><th><span data-translate="investhryApp.projectrawmaterial.projectid">Projectid</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectrawmaterial in vm.projectrawmaterials track by projectrawmaterial.id"><td><a ui-sref="projectrawmaterial-detail({id:projectrawmaterial.id})">{{projectrawmaterial.id}}</a></td><td>{{projectrawmaterial.rawmaterial}}</td><td>{{projectrawmaterial.quantity}}</td><td>{{projectrawmaterial.units}}</td><td>{{projectrawmaterial.createdate | date:\'medium\'}}</td><td>{{projectrawmaterial.updatedate | date:\'medium\'}}</td><td>{{projectrawmaterial.projectid}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="projectrawmaterial-detail({id:projectrawmaterial.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="projectrawmaterial.edit({id:projectrawmaterial.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="projectrawmaterial.delete({id:projectrawmaterial.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/projectservicedetail/projectservicedetail-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectservicedetail.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectservicedetail.delete.question" translate-values="{id: \'{{vm.projectservicedetail.id}}\'}">Are you sure you want to delete this Projectservicedetail?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/projectservicedetail/projectservicedetail-detail.html','<div><h2><span data-translate="investhryApp.projectservicedetail.detail.title">Projectservicedetail</span> {{vm.projectservicedetail.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectservicedetail.projectid">Projectid</span></dt><dd><span>{{vm.projectservicedetail.projectid}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.serviceid">Serviceid</span></dt><dd><span>{{vm.projectservicedetail.serviceid}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.isRequired">Is Required</span></dt><dd><span>{{vm.projectservicedetail.isRequired}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.requireMarkedOnDate">Require Marked On Date</span></dt><dd><span>{{vm.projectservicedetail.requireMarkedOnDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.requireMarkedBy">Require Marked By</span></dt><dd><span>{{vm.projectservicedetail.requireMarkedBy}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.isAssigned">Is Assigned</span></dt><dd><span>{{vm.projectservicedetail.isAssigned}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.assigOnDate">Assig On Date</span></dt><dd><span>{{vm.projectservicedetail.assigOnDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.assignBy">Assign By</span></dt><dd><span>{{vm.projectservicedetail.assignBy}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.formFilledStatus">Form Filled Status</span></dt><dd><span>{{vm.projectservicedetail.formFilledStatus}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.isPaymentMade">Is Payment Made</span></dt><dd><span>{{vm.projectservicedetail.isPaymentMade}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.isPaymentVerified">Is Payment Verified</span></dt><dd><span>{{vm.projectservicedetail.isPaymentVerified}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.formFilledOnDate">Form Filled On Date</span></dt><dd><span>{{vm.projectservicedetail.formFilledOnDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.formFilledBy">Form Filled By</span></dt><dd><span>{{vm.projectservicedetail.formFilledBy}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.paymentMadeOnDate">Payment Made On Date</span></dt><dd><span>{{vm.projectservicedetail.paymentMadeOnDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.status">Status</span></dt><dd><span>{{vm.projectservicedetail.status}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.latestComments">Latest Comments</span></dt><dd><span>{{vm.projectservicedetail.latestComments}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.departmentName">Department Name</span></dt><dd><span>{{vm.projectservicedetail.departmentName}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.serviceName">Service Name</span></dt><dd><span>{{vm.projectservicedetail.serviceName}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.serviceStage">Service Stage</span></dt><dd><span>{{vm.projectservicedetail.serviceStage}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.isDimmed">Is Dimmed</span></dt><dd><span>{{vm.projectservicedetail.isDimmed}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.serviceDuration">Service Duration</span></dt><dd><span>{{vm.projectservicedetail.serviceDuration}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.serviceFee">Service Fee</span></dt><dd><span>{{vm.projectservicedetail.serviceFee}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.lastactiondate">Lastactiondate</span></dt><dd><span>{{vm.projectservicedetail.lastactiondate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.statusdate">Statusdate</span></dt><dd><span>{{vm.projectservicedetail.statusdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.isIntegrated">Is Integrated</span></dt><dd><span>{{vm.projectservicedetail.isIntegrated}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.integrationDate">Integration Date</span></dt><dd><span>{{vm.projectservicedetail.integrationDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.isDateExceeded">Is Date Exceeded</span></dt><dd><span>{{vm.projectservicedetail.isDateExceeded}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.url">Url</span></dt><dd><span>{{vm.projectservicedetail.url}}</span></dd><dt><span data-translate="investhryApp.projectservicedetail.isShowchoosedept">Is Showchoosedept</span></dt><dd><span>{{vm.projectservicedetail.isShowchoosedept}}</span></dd><dt>Cleared Date</dt><dd><span>{{vm.projectservicedetail.clearedDate | date:\'medium\'}}</span></dd><dt>Deemed Cleared Date</dt><dd><span>{{vm.projectservicedetail.deemedClearedDate | date:\'medium\'}}</span></dd><dt>Rejection Date</dt><dd><span>{{vm.projectservicedetail.rejectionDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="projectservicedetail-detail.edit({id:vm.projectservicedetail.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/projectservicedetail/projectservicedetail-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectservicedetailLabel" data-translate="investhryApp.projectservicedetail.home.createOrEditLabel">Create or edit a Projectservicedetail</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectservicedetail.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectservicedetail.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.projectservicedetail.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.projectservicedetail.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.isRequired" for="field_isRequired">Is Required</label><input type="checkbox" class="form-control" name="isRequired" id="field_isRequired" ng-model="vm.projectservicedetail.isRequired"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.requireMarkedOnDate" for="field_requireMarkedOnDate">Require Marked On Date</label><div class="input-group"><input id="field_requireMarkedOnDate" type="text" class="form-control" name="requireMarkedOnDate" datetime-picker="{{dateformat}}" ng-model="vm.projectservicedetail.requireMarkedOnDate" is-open="vm.datePickerOpenStatus.requireMarkedOnDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'requireMarkedOnDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.requireMarkedBy" for="field_requireMarkedBy">Require Marked By</label><input type="text" class="form-control" name="requireMarkedBy" id="field_requireMarkedBy" ng-model="vm.projectservicedetail.requireMarkedBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.isAssigned" for="field_isAssigned">Is Assigned</label><input type="checkbox" class="form-control" name="isAssigned" id="field_isAssigned" ng-model="vm.projectservicedetail.isAssigned"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.assigOnDate" for="field_assigOnDate">Assig On Date</label><div class="input-group"><input id="field_assigOnDate" type="text" class="form-control" name="assigOnDate" datetime-picker="{{dateformat}}" ng-model="vm.projectservicedetail.assigOnDate" is-open="vm.datePickerOpenStatus.assigOnDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'assigOnDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.assignBy" for="field_assignBy">Assign By</label><input type="text" class="form-control" name="assignBy" id="field_assignBy" ng-model="vm.projectservicedetail.assignBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.formFilledStatus" for="field_formFilledStatus">Form Filled Status</label><input type="checkbox" class="form-control" name="formFilledStatus" id="field_formFilledStatus" ng-model="vm.projectservicedetail.formFilledStatus"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.isPaymentMade" for="field_isPaymentMade">Is Payment Made</label><input type="checkbox" class="form-control" name="isPaymentMade" id="field_isPaymentMade" ng-model="vm.projectservicedetail.isPaymentMade"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.isPaymentVerified" for="field_isPaymentVerified">Is Payment Verified</label><input type="checkbox" class="form-control" name="isPaymentVerified" id="field_isPaymentVerified" ng-model="vm.projectservicedetail.isPaymentVerified"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.formFilledOnDate" for="field_formFilledOnDate">Form Filled On Date</label><div class="input-group"><input id="field_formFilledOnDate" type="text" class="form-control" name="formFilledOnDate" datetime-picker="{{dateformat}}" ng-model="vm.projectservicedetail.formFilledOnDate" is-open="vm.datePickerOpenStatus.formFilledOnDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'formFilledOnDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.formFilledBy" for="field_formFilledBy">Form Filled By</label><input type="text" class="form-control" name="formFilledBy" id="field_formFilledBy" ng-model="vm.projectservicedetail.formFilledBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.paymentMadeOnDate" for="field_paymentMadeOnDate">Payment Made On Date</label><div class="input-group"><input id="field_paymentMadeOnDate" type="text" class="form-control" name="paymentMadeOnDate" datetime-picker="{{dateformat}}" ng-model="vm.projectservicedetail.paymentMadeOnDate" is-open="vm.datePickerOpenStatus.paymentMadeOnDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'paymentMadeOnDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.projectservicedetail.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.latestComments" for="field_latestComments">Latest Comments</label><input type="text" class="form-control" name="latestComments" id="field_latestComments" ng-model="vm.projectservicedetail.latestComments"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.projectservicedetail.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.projectservicedetail.serviceName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.serviceStage" for="field_serviceStage">Service Stage</label><input type="text" class="form-control" name="serviceStage" id="field_serviceStage" ng-model="vm.projectservicedetail.serviceStage"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.isDimmed" for="field_isDimmed">Is Dimmed</label><input type="checkbox" class="form-control" name="isDimmed" id="field_isDimmed" ng-model="vm.projectservicedetail.isDimmed"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.serviceDuration" for="field_serviceDuration">Service Duration</label><input type="number" class="form-control" name="serviceDuration" id="field_serviceDuration" ng-model="vm.projectservicedetail.serviceDuration"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.serviceFee" for="field_serviceFee">Service Fee</label><input type="number" class="form-control" name="serviceFee" id="field_serviceFee" ng-model="vm.projectservicedetail.serviceFee"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.lastactiondate" for="field_lastactiondate">Lastactiondate</label><div class="input-group"><input id="field_lastactiondate" type="text" class="form-control" name="lastactiondate" datetime-picker="{{dateformat}}" ng-model="vm.projectservicedetail.lastactiondate" is-open="vm.datePickerOpenStatus.lastactiondate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastactiondate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.statusdate" for="field_statusdate">Statusdate</label><div class="input-group"><input id="field_statusdate" type="text" class="form-control" name="statusdate" datetime-picker="{{dateformat}}" ng-model="vm.projectservicedetail.statusdate" is-open="vm.datePickerOpenStatus.statusdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'statusdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.isIntegrated" for="field_isIntegrated">Is Integrated</label><input type="checkbox" class="form-control" name="isIntegrated" id="field_isIntegrated" ng-model="vm.projectservicedetail.isIntegrated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.integrationDate" for="field_integrationDate">Integration Date</label><div class="input-group"><input id="field_integrationDate" type="text" class="form-control" name="integrationDate" datetime-picker="{{dateformat}}" ng-model="vm.projectservicedetail.integrationDate" is-open="vm.datePickerOpenStatus.integrationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'integrationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.isDateExceeded" for="field_isDateExceeded">Is Date Exceeded</label><input type="checkbox" class="form-control" name="isDateExceeded" id="field_isDateExceeded" ng-model="vm.projectservicedetail.isDateExceeded"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.url" for="field_url">Url</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.projectservicedetail.url"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectservicedetail.isShowchoosedept" for="field_isShowchoosedept">Is Showchoosedept</label><input type="checkbox" class="form-control" name="isShowchoosedept" id="field_isShowchoosedept" ng-model="vm.projectservicedetail.isShowchoosedept"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/projectservicedetail/projectservicedetails.html','<div><h2 data-translate="investhryApp.projectservicedetail.home.title">Projectservicedetails</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="projectservicedetail.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectservicedetail.home.createLabel">Create new Projectservicedetail</span></button></div></div></div><br><br><div class="container"><form name="form1"><div class="row form-group"><div class="col-sm-4 col-sm-offset-2"><input type="text" class="form-control" placeholder="Enter Project id" name="projectid" ng-model="vm.projectservicedetail.projectid" required></div><div class="btn-group col-sm-4"><button class="btn btn-primary" ng-disabled="form1.projectid.$invalid" ng-click="vm.loadByProjectid()">Find Records</button></div></div></form></div><br><br><div class="table-responsive" ng-hide="vm.projectservicedetails==undefined"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectservicedetail.projectid">Projectid</span></th><th><span data-translate="investhryApp.projectservicedetail.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.projectservicedetail.isRequired">Is Required</span></th><th><span data-translate="investhryApp.projectservicedetail.requireMarkedOnDate">Require Marked On Date</span></th><th><span data-translate="investhryApp.projectservicedetail.requireMarkedBy">Require Marked By</span></th><th><span data-translate="investhryApp.projectservicedetail.isAssigned">Is Assigned</span></th><th><span data-translate="investhryApp.projectservicedetail.assigOnDate">Assig On Date</span></th><th><span data-translate="investhryApp.projectservicedetail.assignBy">Assign By</span></th><th><span data-translate="investhryApp.projectservicedetail.formFilledStatus">Form Filled Status</span></th><th><span data-translate="investhryApp.projectservicedetail.isPaymentMade">Is Payment Made</span></th><th><span data-translate="investhryApp.projectservicedetail.isPaymentVerified">Is Payment Verified</span></th><th><span data-translate="investhryApp.projectservicedetail.formFilledOnDate">Form Filled On Date</span></th><th><span data-translate="investhryApp.projectservicedetail.formFilledBy">Form Filled By</span></th><th><span data-translate="investhryApp.projectservicedetail.paymentMadeOnDate">Payment Made On Date</span></th><th><span data-translate="investhryApp.projectservicedetail.status">Status</span></th><th><span data-translate="investhryApp.projectservicedetail.latestComments">Latest Comments</span></th><th><span data-translate="investhryApp.projectservicedetail.departmentName">Department Name</span></th><th><span data-translate="investhryApp.projectservicedetail.serviceName">Service Name</span></th><th><span data-translate="investhryApp.projectservicedetail.serviceStage">Service Stage</span></th><th><span data-translate="investhryApp.projectservicedetail.isDimmed">Is Dimmed</span></th><th><span data-translate="investhryApp.projectservicedetail.serviceDuration">Service Duration</span></th><th><span data-translate="investhryApp.projectservicedetail.serviceFee">Service Fee</span></th><th><span data-translate="investhryApp.projectservicedetail.lastactiondate">Lastactiondate</span></th><th><span data-translate="investhryApp.projectservicedetail.statusdate">Statusdate</span></th><th><span data-translate="investhryApp.projectservicedetail.isIntegrated">Is Integrated</span></th><th><span data-translate="investhryApp.projectservicedetail.integrationDate">Integration Date</span></th><th><span data-translate="investhryApp.projectservicedetail.isDateExceeded">Is Date Exceeded</span></th><th><span data-translate="investhryApp.projectservicedetail.url">Url</span></th><th><span data-translate="investhryApp.projectservicedetail.isShowchoosedept">Is Showchoosedept</span></th><th><span>Re-Apply Counter</span></th><th><span>Cleared Date</span></th><th><span>Deemed Cleared Date</span></th><th><span>Rejection Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectservicedetail in vm.projectservicedetails track by projectservicedetail.id"><td><a ui-sref="projectservicedetail-detail({id:projectservicedetail.id})">{{projectservicedetail.id}}</a></td><td>{{projectservicedetail.projectid}}</td><td>{{projectservicedetail.serviceid}}</td><td>{{projectservicedetail.isRequired}}</td><td>{{projectservicedetail.requireMarkedOnDate | date:\'medium\'}}</td><td>{{projectservicedetail.requireMarkedBy}}</td><td>{{projectservicedetail.isAssigned}}</td><td>{{projectservicedetail.assigOnDate | date:\'medium\'}}</td><td>{{projectservicedetail.assignBy}}</td><td>{{projectservicedetail.formFilledStatus}}</td><td>{{projectservicedetail.isPaymentMade}}</td><td>{{projectservicedetail.isPaymentVerified}}</td><td>{{projectservicedetail.formFilledOnDate | date:\'medium\'}}</td><td>{{projectservicedetail.formFilledBy}}</td><td>{{projectservicedetail.paymentMadeOnDate | date:\'medium\'}}</td><td>{{projectservicedetail.status}}</td><td>{{projectservicedetail.latestComments}}</td><td>{{projectservicedetail.departmentName}}</td><td>{{projectservicedetail.serviceName}}</td><td>{{projectservicedetail.serviceStage}}</td><td>{{projectservicedetail.isDimmed}}</td><td>{{projectservicedetail.serviceDuration}}</td><td>{{projectservicedetail.serviceFee}}</td><td>{{projectservicedetail.lastactiondate | date:\'medium\'}}</td><td>{{projectservicedetail.statusdate | date:\'medium\'}}</td><td>{{projectservicedetail.isIntegrated}}</td><td>{{projectservicedetail.integrationDate | date:\'medium\'}}</td><td>{{projectservicedetail.isDateExceeded}}</td><td>{{projectservicedetail.url}}</td><td>{{projectservicedetail.isShowchoosedept}}</td><td>{{projectservicedetail.reApplyCounter}}</td><td>{{projectservicedetail.clearedDate | date:\'medium\'}}</td><td>{{projectservicedetail.deemedClearedDate | date:\'medium\'}}</td><td>{{projectservicedetail.rejectionDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="projectservicedetail-detail({id:projectservicedetail.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="projectservicedetail.edit({id:projectservicedetail.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="projectservicedetail.delete({id:projectservicedetail.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/projectserviceformfielddata/projectserviceformfielddata-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectserviceformfielddata.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectserviceformfielddata.delete.question" translate-values="{id: \'{{vm.projectserviceformfielddata.id}}\'}">Are you sure you want to delete this Projectserviceformfielddata?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/projectserviceformfielddata/projectserviceformfielddata-detail.html','<div><h2><span data-translate="investhryApp.projectserviceformfielddata.detail.title">Projectserviceformfielddata</span> {{vm.projectserviceformfielddata.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectserviceformfielddata.serviceid">Serviceid</span></dt><dd><span>{{vm.projectserviceformfielddata.serviceid}}</span></dd><dt><span data-translate="investhryApp.projectserviceformfielddata.formfieldvalue">Formfieldvalue</span></dt><dd><span>{{vm.projectserviceformfielddata.formfieldvalue}}</span></dd><dt><span data-translate="investhryApp.projectserviceformfielddata.projectid">Projectid</span></dt><dd><span>{{vm.projectserviceformfielddata.projectid}}</span></dd><dt><span data-translate="investhryApp.projectserviceformfielddata.formfieldName">Formfield Name</span></dt><dd><span>{{vm.projectserviceformfielddata.formfieldName}}</span></dd><dt><span data-translate="investhryApp.projectserviceformfielddata.serviceformfieldid">Serviceformfieldid</span></dt><dd><span>{{vm.projectserviceformfielddata.serviceformfieldid}}</span></dd><dt><span data-translate="investhryApp.projectserviceformfielddata.formfieldtype">Formfieldtype</span></dt><dd><span>{{vm.projectserviceformfielddata.formfieldtype}}</span></dd><dt><span data-translate="investhryApp.projectserviceformfielddata.formfieldOrder">Formfield Order</span></dt><dd><span>{{vm.projectserviceformfielddata.formfieldOrder}}</span></dd><dt><span data-translate="investhryApp.projectserviceformfielddata.formtypeOption">Formtype Option</span></dt><dd><span>{{vm.projectserviceformfielddata.formtypeOption}}</span></dd><dt><span data-translate="investhryApp.projectserviceformfielddata.isRequired">Is Required</span></dt><dd><span>{{vm.projectserviceformfielddata.isRequired}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="projectserviceformfielddata-detail.edit({id:vm.projectserviceformfielddata.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/projectserviceformfielddata/projectserviceformfielddata-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectserviceformfielddataLabel" data-translate="investhryApp.projectserviceformfielddata.home.createOrEditLabel">Create or edit a Projectserviceformfielddata</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectserviceformfielddata.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectserviceformfielddata.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectserviceformfielddata.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.projectserviceformfielddata.serviceid" required><div ng-show="editForm.serviceid.$invalid"><p class="help-block" ng-show="editForm.serviceid.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectserviceformfielddata.formfieldvalue" for="field_formfieldvalue">Formfieldvalue</label><input type="text" class="form-control" name="formfieldvalue" id="field_formfieldvalue" ng-model="vm.projectserviceformfielddata.formfieldvalue"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectserviceformfielddata.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.projectserviceformfielddata.projectid" required><div ng-show="editForm.projectid.$invalid"><p class="help-block" ng-show="editForm.projectid.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectserviceformfielddata.formfieldName" for="field_formfieldName">Formfield Name</label><input type="text" class="form-control" name="formfieldName" id="field_formfieldName" ng-model="vm.projectserviceformfielddata.formfieldName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectserviceformfielddata.serviceformfieldid" for="field_serviceformfieldid">Serviceformfieldid</label><input type="text" class="form-control" name="serviceformfieldid" id="field_serviceformfieldid" ng-model="vm.projectserviceformfielddata.serviceformfieldid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectserviceformfielddata.formfieldtype" for="field_formfieldtype">Formfieldtype</label><input type="text" class="form-control" name="formfieldtype" id="field_formfieldtype" ng-model="vm.projectserviceformfielddata.formfieldtype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectserviceformfielddata.formfieldOrder" for="field_formfieldOrder">Formfield Order</label><input type="number" class="form-control" name="formfieldOrder" id="field_formfieldOrder" ng-model="vm.projectserviceformfielddata.formfieldOrder"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectserviceformfielddata.formtypeOption" for="field_formtypeOption">Formtype Option</label><input type="text" class="form-control" name="formtypeOption" id="field_formtypeOption" ng-model="vm.projectserviceformfielddata.formtypeOption"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectserviceformfielddata.isRequired" for="field_isRequired">Is Required</label><input type="checkbox" class="form-control" name="isRequired" id="field_isRequired" ng-model="vm.projectserviceformfielddata.isRequired"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/projectserviceformfielddata/projectserviceformfielddata.html','<div><h2 data-translate="investhryApp.projectserviceformfielddata.home.title">Projectserviceformfielddata</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="projectserviceformfielddata.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectserviceformfielddata.home.createLabel">Create new Projectserviceformfielddata</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectserviceformfielddata.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.projectserviceformfielddata.formfieldvalue">Formfieldvalue</span></th><th><span data-translate="investhryApp.projectserviceformfielddata.projectid">Projectid</span></th><th><span data-translate="investhryApp.projectserviceformfielddata.formfieldName">Formfield Name</span></th><th><span data-translate="investhryApp.projectserviceformfielddata.serviceformfieldid">Serviceformfieldid</span></th><th><span data-translate="investhryApp.projectserviceformfielddata.formfieldtype">Formfieldtype</span></th><th><span data-translate="investhryApp.projectserviceformfielddata.formfieldOrder">Formfield Order</span></th><th><span data-translate="investhryApp.projectserviceformfielddata.formtypeOption">Formtype Option</span></th><th><span data-translate="investhryApp.projectserviceformfielddata.isRequired">Is Required</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectserviceformfielddata in vm.projectserviceformfielddata track by projectserviceformfielddata.id"><td><a ui-sref="projectserviceformfielddata-detail({id:projectserviceformfielddata.id})">{{projectserviceformfielddata.id}}</a></td><td>{{projectserviceformfielddata.serviceid}}</td><td>{{projectserviceformfielddata.formfieldvalue}}</td><td>{{projectserviceformfielddata.projectid}}</td><td>{{projectserviceformfielddata.formfieldName}}</td><td>{{projectserviceformfielddata.serviceformfieldid}}</td><td>{{projectserviceformfielddata.formfieldtype}}</td><td>{{projectserviceformfielddata.formfieldOrder}}</td><td>{{projectserviceformfielddata.formtypeOption}}</td><td>{{projectserviceformfielddata.isRequired}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="projectserviceformfielddata-detail({id:projectserviceformfielddata.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="projectserviceformfielddata.edit({id:projectserviceformfielddata.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="projectserviceformfielddata.delete({id:projectserviceformfielddata.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/projectsitedetail/projectsitedetail-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectsitedetail.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectsitedetail.delete.question" translate-values="{id: \'{{vm.projectsitedetail.id}}\'}">Are you sure you want to delete this Projectsitedetail?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/projectsitedetail/projectsitedetail-detail.html','<div><h2><span data-translate="investhryApp.projectsitedetail.detail.title">Projectsitedetail</span> {{vm.projectsitedetail.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectsitedetail.siteaddress">Siteaddress</span></dt><dd><span>{{vm.projectsitedetail.siteaddress}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.multyvillageinvolved">Multyvillageinvolved</span></dt><dd><span>{{vm.projectsitedetail.multyvillageinvolved}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.villageinvolved">Villageinvolved</span></dt><dd><span>{{vm.projectsitedetail.villageinvolved}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.falls_in_aravalli">Falls In Aravalli</span></dt><dd><span>{{vm.projectsitedetail.falls_in_aravalli}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.islandprocured">Islandprocured</span></dt><dd><span>{{vm.projectsitedetail.islandprocured}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.allotedbyhsiidc">Allotedbyhsiidc</span></dt><dd><span>{{vm.projectsitedetail.allotedbyhsiidc}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.estate">Estate</span></dt><dd><span>{{vm.projectsitedetail.estate}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.cluster">Cluster</span></dt><dd><span>{{vm.projectsitedetail.cluster}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.phase">Phase</span></dt><dd><span>{{vm.projectsitedetail.phase}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.sector">Sector</span></dt><dd><span>{{vm.projectsitedetail.sector}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.plotno">Plotno</span></dt><dd><span>{{vm.projectsitedetail.plotno}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.hadbastno">Hadbastno</span></dt><dd><span>{{vm.projectsitedetail.hadbastno}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.liesunder_mc">Liesunder Mc</span></dt><dd><span>{{vm.projectsitedetail.liesunder_mc}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.distance_from_mc">Distance From Mc</span></dt><dd><span>{{vm.projectsitedetail.distance_from_mc}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.islocated_in_urban">Islocated In Urban</span></dt><dd><span>{{vm.projectsitedetail.islocated_in_urban}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.totalproposedprojectarea">Totalproposedprojectarea</span></dt><dd><span>{{vm.projectsitedetail.totalproposedprojectarea}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.proposedbuilt_up_area">Proposedbuilt Up Area</span></dt><dd><span>{{vm.projectsitedetail.proposedbuilt_up_area}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.certifiedownership">Certifiedownership</span></dt><dd><span>{{vm.projectsitedetail.certifiedownership}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.leaseapplicable">Leaseapplicable</span></dt><dd><span>{{vm.projectsitedetail.leaseapplicable}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.landagreementapplicable">Landagreementapplicable</span></dt><dd><span>{{vm.projectsitedetail.landagreementapplicable}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.intersectiondistance">Intersectiondistance</span></dt><dd><span>{{vm.projectsitedetail.intersectiondistance}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.railwaydistance">Railwaydistance</span></dt><dd><span>{{vm.projectsitedetail.railwaydistance}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.confirmitylanduse">Confirmitylanduse</span></dt><dd><span>{{vm.projectsitedetail.confirmitylanduse}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.existing_building_applicable">Existing Building Applicable</span></dt><dd><span>{{vm.projectsitedetail.existing_building_applicable}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.site_situated_in_controlled_area">Site Situated In Controlled Area</span></dt><dd><span>{{vm.projectsitedetail.site_situated_in_controlled_area}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.buildingexisted">Buildingexisted</span></dt><dd><span>{{vm.projectsitedetail.buildingexisted}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.district">District</span></dt><dd><span>{{vm.projectsitedetail.district}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.block">Block</span></dt><dd><span>{{vm.projectsitedetail.block}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.city_town_village">City Town Village</span></dt><dd><span>{{vm.projectsitedetail.city_town_village}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.connectingroad">Connectingroad</span></dt><dd><span>{{vm.projectsitedetail.connectingroad}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.landzoneuse_type">Landzoneuse Type</span></dt><dd><span>{{vm.projectsitedetail.landzoneuse_type}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.tehsil_subtehsil">Tehsil Subtehsil</span></dt><dd><span>{{vm.projectsitedetail.tehsil_subtehsil}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.createdate">Createdate</span></dt><dd><span>{{vm.projectsitedetail.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.updatedate">Updatedate</span></dt><dd><span>{{vm.projectsitedetail.updatedate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.projectsitedetail.clurequired">Clurequired</span></dt><dd><span>{{vm.projectsitedetail.clurequired}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="projectsitedetail-detail.edit({id:vm.projectsitedetail.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/projectsitedetail/projectsitedetail-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectsitedetailLabel" data-translate="investhryApp.projectsitedetail.home.createOrEditLabel">Create or edit a Projectsitedetail</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectsitedetail.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectsitedetail.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.siteaddress" for="field_siteaddress">Siteaddress</label><input type="text" class="form-control" name="siteaddress" id="field_siteaddress" ng-model="vm.projectsitedetail.siteaddress"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.multyvillageinvolved" for="field_multyvillageinvolved">Multyvillageinvolved</label><input type="checkbox" class="form-control" name="multyvillageinvolved" id="field_multyvillageinvolved" ng-model="vm.projectsitedetail.multyvillageinvolved"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.villageinvolved" for="field_villageinvolved">Villageinvolved</label><input type="text" class="form-control" name="villageinvolved" id="field_villageinvolved" ng-model="vm.projectsitedetail.villageinvolved"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.falls_in_aravalli" for="field_falls_in_aravalli">Falls In Aravalli</label><input type="checkbox" class="form-control" name="falls_in_aravalli" id="field_falls_in_aravalli" ng-model="vm.projectsitedetail.falls_in_aravalli"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.islandprocured" for="field_islandprocured">Islandprocured</label><input type="checkbox" class="form-control" name="islandprocured" id="field_islandprocured" ng-model="vm.projectsitedetail.islandprocured"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.allotedbyhsiidc" for="field_allotedbyhsiidc">Allotedbyhsiidc</label><input type="checkbox" class="form-control" name="allotedbyhsiidc" id="field_allotedbyhsiidc" ng-model="vm.projectsitedetail.allotedbyhsiidc"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.estate" for="field_estate">Estate</label><input type="text" class="form-control" name="estate" id="field_estate" ng-model="vm.projectsitedetail.estate"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.cluster" for="field_cluster">Cluster</label><input type="text" class="form-control" name="cluster" id="field_cluster" ng-model="vm.projectsitedetail.cluster"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.phase" for="field_phase">Phase</label><input type="text" class="form-control" name="phase" id="field_phase" ng-model="vm.projectsitedetail.phase"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.sector" for="field_sector">Sector</label><input type="text" class="form-control" name="sector" id="field_sector" ng-model="vm.projectsitedetail.sector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.plotno" for="field_plotno">Plotno</label><input type="text" class="form-control" name="plotno" id="field_plotno" ng-model="vm.projectsitedetail.plotno"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.hadbastno" for="field_hadbastno">Hadbastno</label><input type="text" class="form-control" name="hadbastno" id="field_hadbastno" ng-model="vm.projectsitedetail.hadbastno"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.liesunder_mc" for="field_liesunder_mc">Liesunder Mc</label><input type="checkbox" class="form-control" name="liesunder_mc" id="field_liesunder_mc" ng-model="vm.projectsitedetail.liesunder_mc"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.distance_from_mc" for="field_distance_from_mc">Distance From Mc</label><input type="number" class="form-control" name="distance_from_mc" id="field_distance_from_mc" ng-model="vm.projectsitedetail.distance_from_mc"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.islocated_in_urban" for="field_islocated_in_urban">Islocated In Urban</label><input type="checkbox" class="form-control" name="islocated_in_urban" id="field_islocated_in_urban" ng-model="vm.projectsitedetail.islocated_in_urban"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.totalproposedprojectarea" for="field_totalproposedprojectarea">Totalproposedprojectarea</label><input type="number" class="form-control" name="totalproposedprojectarea" id="field_totalproposedprojectarea" ng-model="vm.projectsitedetail.totalproposedprojectarea"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.proposedbuilt_up_area" for="field_proposedbuilt_up_area">Proposedbuilt Up Area</label><input type="number" class="form-control" name="proposedbuilt_up_area" id="field_proposedbuilt_up_area" ng-model="vm.projectsitedetail.proposedbuilt_up_area"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.certifiedownership" for="field_certifiedownership">Certifiedownership</label><input type="checkbox" class="form-control" name="certifiedownership" id="field_certifiedownership" ng-model="vm.projectsitedetail.certifiedownership"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.leaseapplicable" for="field_leaseapplicable">Leaseapplicable</label><input type="checkbox" class="form-control" name="leaseapplicable" id="field_leaseapplicable" ng-model="vm.projectsitedetail.leaseapplicable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.landagreementapplicable" for="field_landagreementapplicable">Landagreementapplicable</label><input type="checkbox" class="form-control" name="landagreementapplicable" id="field_landagreementapplicable" ng-model="vm.projectsitedetail.landagreementapplicable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.intersectiondistance" for="field_intersectiondistance">Intersectiondistance</label><input type="checkbox" class="form-control" name="intersectiondistance" id="field_intersectiondistance" ng-model="vm.projectsitedetail.intersectiondistance"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.railwaydistance" for="field_railwaydistance">Railwaydistance</label><input type="checkbox" class="form-control" name="railwaydistance" id="field_railwaydistance" ng-model="vm.projectsitedetail.railwaydistance"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.confirmitylanduse" for="field_confirmitylanduse">Confirmitylanduse</label><input type="checkbox" class="form-control" name="confirmitylanduse" id="field_confirmitylanduse" ng-model="vm.projectsitedetail.confirmitylanduse"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.existing_building_applicable" for="field_existing_building_applicable">Existing Building Applicable</label><input type="checkbox" class="form-control" name="existing_building_applicable" id="field_existing_building_applicable" ng-model="vm.projectsitedetail.existing_building_applicable"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.site_situated_in_controlled_area" for="field_site_situated_in_controlled_area">Site Situated In Controlled Area</label><input type="checkbox" class="form-control" name="site_situated_in_controlled_area" id="field_site_situated_in_controlled_area" ng-model="vm.projectsitedetail.site_situated_in_controlled_area"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.buildingexisted" for="field_buildingexisted">Buildingexisted</label><input type="text" class="form-control" name="buildingexisted" id="field_buildingexisted" ng-model="vm.projectsitedetail.buildingexisted"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.projectsitedetail.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.block" for="field_block">Block</label><input type="text" class="form-control" name="block" id="field_block" ng-model="vm.projectsitedetail.block"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.city_town_village" for="field_city_town_village">City Town Village</label><input type="text" class="form-control" name="city_town_village" id="field_city_town_village" ng-model="vm.projectsitedetail.city_town_village"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.connectingroad" for="field_connectingroad">Connectingroad</label><input type="text" class="form-control" name="connectingroad" id="field_connectingroad" ng-model="vm.projectsitedetail.connectingroad"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.landzoneuse_type" for="field_landzoneuse_type">Landzoneuse Type</label><input type="text" class="form-control" name="landzoneuse_type" id="field_landzoneuse_type" ng-model="vm.projectsitedetail.landzoneuse_type"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.tehsil_subtehsil" for="field_tehsil_subtehsil">Tehsil Subtehsil</label><input type="text" class="form-control" name="tehsil_subtehsil" id="field_tehsil_subtehsil" ng-model="vm.projectsitedetail.tehsil_subtehsil"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.projectsitedetail.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.projectsitedetail.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectsitedetail.clurequired" for="field_clurequired">Clurequired</label><input type="checkbox" class="form-control" name="clurequired" id="field_clurequired" ng-model="vm.projectsitedetail.clurequired"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/projectsitedetail/projectsitedetails.html','<div><h2 data-translate="investhryApp.projectsitedetail.home.title">Projectsitedetails</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="projectsitedetail.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectsitedetail.home.createLabel">Create new Projectsitedetail</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectsitedetail.siteaddress">Siteaddress</span></th><th><span data-translate="investhryApp.projectsitedetail.multyvillageinvolved">Multyvillageinvolved</span></th><th><span data-translate="investhryApp.projectsitedetail.villageinvolved">Villageinvolved</span></th><th><span data-translate="investhryApp.projectsitedetail.falls_in_aravalli">Falls In Aravalli</span></th><th><span data-translate="investhryApp.projectsitedetail.islandprocured">Islandprocured</span></th><th><span data-translate="investhryApp.projectsitedetail.allotedbyhsiidc">Allotedbyhsiidc</span></th><th><span data-translate="investhryApp.projectsitedetail.estate">Estate</span></th><th><span data-translate="investhryApp.projectsitedetail.cluster">Cluster</span></th><th><span data-translate="investhryApp.projectsitedetail.phase">Phase</span></th><th><span data-translate="investhryApp.projectsitedetail.sector">Sector</span></th><th><span data-translate="investhryApp.projectsitedetail.plotno">Plotno</span></th><th><span data-translate="investhryApp.projectsitedetail.hadbastno">Hadbastno</span></th><th><span data-translate="investhryApp.projectsitedetail.liesunder_mc">Liesunder Mc</span></th><th><span data-translate="investhryApp.projectsitedetail.distance_from_mc">Distance From Mc</span></th><th><span data-translate="investhryApp.projectsitedetail.islocated_in_urban">Islocated In Urban</span></th><th><span data-translate="investhryApp.projectsitedetail.totalproposedprojectarea">Totalproposedprojectarea</span></th><th><span data-translate="investhryApp.projectsitedetail.proposedbuilt_up_area">Proposedbuilt Up Area</span></th><th><span data-translate="investhryApp.projectsitedetail.certifiedownership">Certifiedownership</span></th><th><span data-translate="investhryApp.projectsitedetail.leaseapplicable">Leaseapplicable</span></th><th><span data-translate="investhryApp.projectsitedetail.landagreementapplicable">Landagreementapplicable</span></th><th><span data-translate="investhryApp.projectsitedetail.intersectiondistance">Intersectiondistance</span></th><th><span data-translate="investhryApp.projectsitedetail.railwaydistance">Railwaydistance</span></th><th><span data-translate="investhryApp.projectsitedetail.confirmitylanduse">Confirmitylanduse</span></th><th><span data-translate="investhryApp.projectsitedetail.existing_building_applicable">Existing Building Applicable</span></th><th><span data-translate="investhryApp.projectsitedetail.site_situated_in_controlled_area">Site Situated In Controlled Area</span></th><th><span data-translate="investhryApp.projectsitedetail.buildingexisted">Buildingexisted</span></th><th><span data-translate="investhryApp.projectsitedetail.district">District</span></th><th><span data-translate="investhryApp.projectsitedetail.block">Block</span></th><th><span data-translate="investhryApp.projectsitedetail.city_town_village">City Town Village</span></th><th><span data-translate="investhryApp.projectsitedetail.connectingroad">Connectingroad</span></th><th><span data-translate="investhryApp.projectsitedetail.landzoneuse_type">Landzoneuse Type</span></th><th><span data-translate="investhryApp.projectsitedetail.tehsil_subtehsil">Tehsil Subtehsil</span></th><th><span data-translate="investhryApp.projectsitedetail.createdate">Createdate</span></th><th><span data-translate="investhryApp.projectsitedetail.updatedate">Updatedate</span></th><th><span data-translate="investhryApp.projectsitedetail.clurequired">Clurequired</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectsitedetail in vm.projectsitedetails track by projectsitedetail.id"><td><a ui-sref="projectsitedetail-detail({id:projectsitedetail.id})">{{projectsitedetail.id}}</a></td><td>{{projectsitedetail.siteaddress}}</td><td>{{projectsitedetail.multyvillageinvolved}}</td><td>{{projectsitedetail.villageinvolved}}</td><td>{{projectsitedetail.falls_in_aravalli}}</td><td>{{projectsitedetail.islandprocured}}</td><td>{{projectsitedetail.allotedbyhsiidc}}</td><td>{{projectsitedetail.estate}}</td><td>{{projectsitedetail.cluster}}</td><td>{{projectsitedetail.phase}}</td><td>{{projectsitedetail.sector}}</td><td>{{projectsitedetail.plotno}}</td><td>{{projectsitedetail.hadbastno}}</td><td>{{projectsitedetail.liesunder_mc}}</td><td>{{projectsitedetail.distance_from_mc}}</td><td>{{projectsitedetail.islocated_in_urban}}</td><td>{{projectsitedetail.totalproposedprojectarea}}</td><td>{{projectsitedetail.proposedbuilt_up_area}}</td><td>{{projectsitedetail.certifiedownership}}</td><td>{{projectsitedetail.leaseapplicable}}</td><td>{{projectsitedetail.landagreementapplicable}}</td><td>{{projectsitedetail.intersectiondistance}}</td><td>{{projectsitedetail.railwaydistance}}</td><td>{{projectsitedetail.confirmitylanduse}}</td><td>{{projectsitedetail.existing_building_applicable}}</td><td>{{projectsitedetail.site_situated_in_controlled_area}}</td><td>{{projectsitedetail.buildingexisted}}</td><td>{{projectsitedetail.district}}</td><td>{{projectsitedetail.block}}</td><td>{{projectsitedetail.city_town_village}}</td><td>{{projectsitedetail.connectingroad}}</td><td>{{projectsitedetail.landzoneuse_type}}</td><td>{{projectsitedetail.tehsil_subtehsil}}</td><td>{{projectsitedetail.createdate | date:\'medium\'}}</td><td>{{projectsitedetail.updatedate | date:\'medium\'}}</td><td>{{projectsitedetail.clurequired}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="projectsitedetail-detail({id:projectsitedetail.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="projectsitedetail.edit({id:projectsitedetail.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="projectsitedetail.delete({id:projectsitedetail.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/projectype/projectype-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.projectype.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.projectype.delete.question" translate-values="{id: \'{{vm.projectype.id}}\'}">Are you sure you want to delete this Projectype?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/projectype/projectype-detail.html','<div class="container"><h2><span data-translate="investhryApp.projectype.detail.title">Projectype</span> {{vm.projectype.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.projectype.projectypes">Projectypes</span></dt><dd><span>{{vm.projectype.projectypes}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="projectype-detail.edit({id:vm.projectype.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/projectype/projectype-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myProjectypeLabel" data-translate="investhryApp.projectype.home.createOrEditLabel">Create or edit a Projectype</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.projectype.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.projectype.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.projectype.projectypes" for="field_projectypes">Projectypes</label><input type="text" class="form-control" name="projectypes" id="field_projectypes" ng-model="vm.projectype.projectypes" required><div ng-show="editForm.projectypes.$invalid"><p class="help-block" ng-show="editForm.projectypes.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/projectype/projectypes.html','<div class="container"><h2 data-translate="investhryApp.projectype.home.title">Projectypes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="projectype.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.projectype.home.createLabel">Create new Projectype</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.projectype.projectypes">Projectypes</span></th><th></th></tr></thead><tbody><tr ng-repeat="projectype in vm.projectypes track by projectype.id"><td><a ui-sref="projectype-detail({id:projectype.id})">{{projectype.id}}</a></td><td>{{projectype.projectypes}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="projectype-detail({id:projectype.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="projectype.edit({id:projectype.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="projectype.delete({id:projectype.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/public-holiday/public-holiday-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.publicHoliday.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.publicHoliday.delete.question" translate-values="{id: \'{{vm.publicHoliday.id}}\'}">Are you sure you want to delete this Public Holiday?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/public-holiday/public-holiday-detail.html','<div><h2><span data-translate="investhryApp.publicHoliday.detail.title">Public Holiday</span> {{vm.publicHoliday.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.publicHoliday.holidayTitle">Holiday Title</span></dt><dd><span>{{vm.publicHoliday.holidayTitle}}</span></dd><dt><span data-translate="investhryApp.publicHoliday.holidayDate">Holiday Date</span></dt><dd><span>{{vm.publicHoliday.holidayDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.publicHoliday.dayOfWeek">Day Of Week</span></dt><dd><span>{{vm.publicHoliday.dayOfWeek}}</span></dd><dt><span data-translate="investhryApp.publicHoliday.additionalNote">Additional Note</span></dt><dd><span>{{vm.publicHoliday.additionalNote}}</span></dd><dt><span data-translate="investhryApp.publicHoliday.financialYear">Financial Year</span></dt><dd><span>{{vm.publicHoliday.financialYear}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="public-holiday-detail.edit({id:vm.publicHoliday.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/public-holiday/public-holiday-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myPublicHolidayLabel" data-translate="investhryApp.publicHoliday.home.createOrEditLabel">Create or edit a Public Holiday</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.publicHoliday.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.publicHoliday.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.publicHoliday.holidayTitle" for="field_holidayTitle">Holiday Title</label><input type="text" class="form-control" name="holidayTitle" id="field_holidayTitle" ng-model="vm.publicHoliday.holidayTitle"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.publicHoliday.holidayDate" for="field_holidayDate">Holiday Date</label><div class="input-group"><input id="field_holidayDate" type="text" class="form-control" name="holidayDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.publicHoliday.holidayDate" is-open="vm.datePickerOpenStatus.holidayDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'holidayDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.publicHoliday.dayOfWeek" for="field_dayOfWeek">Day Of Week</label><input type="text" class="form-control" name="dayOfWeek" id="field_dayOfWeek" ng-model="vm.publicHoliday.dayOfWeek"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.publicHoliday.additionalNote" for="field_additionalNote">Additional Note</label><input type="text" class="form-control" name="additionalNote" id="field_additionalNote" ng-model="vm.publicHoliday.additionalNote"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.publicHoliday.financialYear" for="field_financialYear">Financial Year</label><input type="text" class="form-control" name="financialYear" id="field_financialYear" ng-model="vm.publicHoliday.financialYear"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/public-holiday/public-holidays.html','<div><h2 data-translate="investhryApp.publicHoliday.home.title">Public Holidays</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="public-holiday.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.publicHoliday.home.createLabel">Create new Public Holiday</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.publicHoliday.holidayTitle">Holiday Title</span></th><th><span data-translate="investhryApp.publicHoliday.holidayDate">Holiday Date</span></th><th><span data-translate="investhryApp.publicHoliday.dayOfWeek">Day Of Week</span></th><th><span data-translate="investhryApp.publicHoliday.additionalNote">Additional Note</span></th><th><span data-translate="investhryApp.publicHoliday.financialYear">Financial Year</span></th><th></th></tr></thead><tbody><tr ng-repeat="publicHoliday in vm.publicHolidays track by publicHoliday.id"><td><a ui-sref="public-holiday-detail({id:publicHoliday.id})">{{publicHoliday.id}}</a></td><td>{{publicHoliday.holidayTitle}}</td><td>{{publicHoliday.holidayDate | date:\'mediumDate\'}}</td><td>{{publicHoliday.dayOfWeek}}</td><td>{{publicHoliday.additionalNote}}</td><td>{{publicHoliday.financialYear}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="public-holiday-detail({id:publicHoliday.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="public-holiday.edit({id:publicHoliday.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="public-holiday.delete({id:publicHoliday.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/ras-credentials/ras-credentials-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rasCredentials.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.rasCredentials.delete.question" translate-values="{id: \'{{vm.rasCredentials.id}}\'}">Are you sure you want to delete this Ras Credentials?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ras-credentials/ras-credentials-detail.html','<div><h2><span data-translate="investhryApp.rasCredentials.detail.title">Ras Credentials</span> {{vm.rasCredentials.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.rasCredentials.serviceId">Service Id</span></dt><dd><span>{{vm.rasCredentials.serviceId}}</span></dd><dt><span data-translate="investhryApp.rasCredentials.rasDeptId">Ras Dept Id</span></dt><dd><span>{{vm.rasCredentials.rasDeptId}}</span></dd><dt><span data-translate="investhryApp.rasCredentials.rasServiceId">Ras Service Id</span></dt><dd><span>{{vm.rasCredentials.rasServiceId}}</span></dd><dt><span data-translate="investhryApp.rasCredentials.deptName">Dept Name</span></dt><dd><span>{{vm.rasCredentials.deptName}}</span></dd><dt><span data-translate="investhryApp.rasCredentials.serviceName">Service Name</span></dt><dd><span>{{vm.rasCredentials.serviceName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ras-credentials-detail.edit({id:vm.rasCredentials.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ras-credentials/ras-credentials-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRasCredentialsLabel" data-translate="investhryApp.rasCredentials.home.createOrEditLabel">Create or edit a Ras Credentials</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rasCredentials.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rasCredentials.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rasCredentials.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.rasCredentials.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rasCredentials.rasDeptId" for="field_rasDeptId">Ras Dept Id</label><input type="text" class="form-control" name="rasDeptId" id="field_rasDeptId" ng-model="vm.rasCredentials.rasDeptId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rasCredentials.rasServiceId" for="field_rasServiceId">Ras Service Id</label><input type="text" class="form-control" name="rasServiceId" id="field_rasServiceId" ng-model="vm.rasCredentials.rasServiceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rasCredentials.deptName" for="field_deptName">Dept Name</label><input type="text" class="form-control" name="deptName" id="field_deptName" ng-model="vm.rasCredentials.deptName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rasCredentials.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.rasCredentials.serviceName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ras-credentials/ras-credentials.html','<div><h2 data-translate="investhryApp.rasCredentials.home.title">Ras Credentials</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ras-credentials.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.rasCredentials.home.createLabel">Create new Ras Credentials</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.rasCredentials.serviceId">Service Id</span></th><th><span data-translate="investhryApp.rasCredentials.rasDeptId">Ras Dept Id</span></th><th><span data-translate="investhryApp.rasCredentials.rasServiceId">Ras Service Id</span></th><th><span data-translate="investhryApp.rasCredentials.deptName">Dept Name</span></th><th><span data-translate="investhryApp.rasCredentials.serviceName">Service Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="rasCredentials in vm.rasCredentials track by rasCredentials.id"><td><a ui-sref="ras-credentials-detail({id:rasCredentials.id})">{{rasCredentials.id}}</a></td><td>{{rasCredentials.serviceId}}</td><td>{{rasCredentials.rasDeptId}}</td><td>{{rasCredentials.rasServiceId}}</td><td>{{rasCredentials.deptName}}</td><td>{{rasCredentials.serviceName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ras-credentials-detail({id:rasCredentials.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="ras-credentials.edit({id:rasCredentials.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="ras-credentials.delete({id:rasCredentials.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/rating/rating-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rating.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.rating.delete.question" translate-values="{id: \'{{vm.rating.id}}\'}">Are you sure you want to delete this Rating?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/rating/rating-detail.html','<div><h2><span data-translate="investhryApp.rating.detail.title">Rating</span> {{vm.rating.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.rating.projectId">Project Id</span></dt><dd><span>{{vm.rating.projectId}}</span></dd><dt><span data-translate="investhryApp.rating.serviceId">Service Id</span></dt><dd><span>{{vm.rating.serviceId}}</span></dd><dt><span data-translate="investhryApp.rating.cafPin">Caf Pin</span></dt><dd><span>{{vm.rating.cafPin}}</span></dd><dt><span data-translate="investhryApp.rating.userName">User Name</span></dt><dd><span>{{vm.rating.userName}}</span></dd><dt><span data-translate="investhryApp.rating.departmentName">Department Name</span></dt><dd><span>{{vm.rating.departmentName}}</span></dd><dt><span data-translate="investhryApp.rating.serviceName">Service Name</span></dt><dd><span>{{vm.rating.serviceName}}</span></dd><dt><span data-translate="investhryApp.rating.rating">Rating</span></dt><dd><span>{{vm.rating.rating}}</span></dd><dt><span data-translate="investhryApp.rating.departmentId">Department Id</span></dt><dd><span>{{vm.rating.departmentId}}</span></dd><dt><span data-translate="investhryApp.rating.investorEmail">Investor Email</span></dt><dd><span>{{vm.rating.investorEmail}}</span></dd><dt><span data-translate="investhryApp.rating.investorContact">Investor Contact</span></dt><dd><span>{{vm.rating.investorContact}}</span></dd><dt><span data-translate="investhryApp.rating.comment">Comment</span></dt><dd><span>{{vm.rating.comment}}</span></dd><dt><span data-translate="investhryApp.rating.name">Name</span></dt><dd><span>{{vm.rating.name}}</span></dd><dt><span data-translate="investhryApp.rating.businessEntity">Business Entity</span></dt><dd><span>{{vm.rating.businessEntity}}</span></dd><dt><span data-translate="investhryApp.rating.lastUpadte">Last Upadte</span></dt><dd><span>{{vm.rating.lastUpadte | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.rating.district">District</span></dt><dd><span>{{vm.rating.district}}</span></dd><dt><span data-translate="investhryApp.rating.appliedDate">Applied Date</span></dt><dd><span>{{vm.rating.appliedDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.rating.clearedDate">Cleared Date</span></dt><dd><span>{{vm.rating.clearedDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.rating.projectLevel">Project Level</span></dt><dd><span>{{vm.rating.projectLevel}}</span></dd><dt><span data-translate="investhryApp.rating.actionTaken">Action Taken</span></dt><dd><span>{{vm.rating.actionTaken}}</span></dd><dt><span data-translate="investhryApp.rating.actionTakenDate">Action Taken Date</span></dt><dd><span>{{vm.rating.actionTakenDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.rating.isResolved">Is Resolved</span></dt><dd><span>{{vm.rating.isResolved}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="rating-detail.edit({id:vm.rating.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/rating/rating-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRatingLabel" data-translate="investhryApp.rating.home.createOrEditLabel">Create or edit a Rating</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rating.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rating.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.rating.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.rating.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.cafPin" for="field_cafPin">Caf Pin</label><input type="text" class="form-control" name="cafPin" id="field_cafPin" ng-model="vm.rating.cafPin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.userName" for="field_userName">User Name</label><input type="text" class="form-control" name="userName" id="field_userName" ng-model="vm.rating.userName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.rating.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.rating.serviceName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.rating" for="field_rating">Rating</label><input type="text" class="form-control" name="rating" id="field_rating" ng-model="vm.rating.rating"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.departmentId" for="field_departmentId">Department Id</label><input type="text" class="form-control" name="departmentId" id="field_departmentId" ng-model="vm.rating.departmentId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.investorEmail" for="field_investorEmail">Investor Email</label><input type="text" class="form-control" name="investorEmail" id="field_investorEmail" ng-model="vm.rating.investorEmail"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.investorContact" for="field_investorContact">Investor Contact</label><input type="text" class="form-control" name="investorContact" id="field_investorContact" ng-model="vm.rating.investorContact"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.rating.comment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.rating.name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.businessEntity" for="field_businessEntity">Business Entity</label><input type="text" class="form-control" name="businessEntity" id="field_businessEntity" ng-model="vm.rating.businessEntity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.lastUpadte" for="field_lastUpadte">Last Upadte</label><div class="input-group"><input id="field_lastUpadte" type="text" class="form-control" name="lastUpadte" datetime-picker="{{dateformat}}" ng-model="vm.rating.lastUpadte" is-open="vm.datePickerOpenStatus.lastUpadte"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastUpadte\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.rating.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.appliedDate" for="field_appliedDate">Applied Date</label><div class="input-group"><input id="field_appliedDate" type="text" class="form-control" name="appliedDate" datetime-picker="{{dateformat}}" ng-model="vm.rating.appliedDate" is-open="vm.datePickerOpenStatus.appliedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'appliedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.clearedDate" for="field_clearedDate">Cleared Date</label><div class="input-group"><input id="field_clearedDate" type="text" class="form-control" name="clearedDate" datetime-picker="{{dateformat}}" ng-model="vm.rating.clearedDate" is-open="vm.datePickerOpenStatus.clearedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'clearedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.projectLevel" for="field_projectLevel">Project Level</label><input type="text" class="form-control" name="projectLevel" id="field_projectLevel" ng-model="vm.rating.projectLevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.actionTaken" for="field_actionTaken">Action Taken</label><input type="text" class="form-control" name="actionTaken" id="field_actionTaken" ng-model="vm.rating.actionTaken"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.actionTakenDate" for="field_actionTakenDate">Action Taken Date</label><div class="input-group"><input id="field_actionTakenDate" type="text" class="form-control" name="actionTakenDate" datetime-picker="{{dateformat}}" ng-model="vm.rating.actionTakenDate" is-open="vm.datePickerOpenStatus.actionTakenDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'actionTakenDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rating.isResolved" for="field_isResolved">Is Resolved</label><input type="checkbox" name="isResolved" id="field_isResolved" ng-model="vm.rating.isResolved"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/rating/ratings.html','<div><h2 data-translate="investhryApp.rating.home.title">Ratings</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="rating.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.rating.home.createLabel">Create new Rating</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.rating.projectId">Project Id</span></th><th><span data-translate="investhryApp.rating.serviceId">Service Id</span></th><th><span data-translate="investhryApp.rating.cafPin">Caf Pin</span></th><th><span data-translate="investhryApp.rating.userName">User Name</span></th><th><span data-translate="investhryApp.rating.departmentName">Department Name</span></th><th><span data-translate="investhryApp.rating.serviceName">Service Name</span></th><th><span data-translate="investhryApp.rating.rating">Rating</span></th><th><span data-translate="investhryApp.rating.departmentId">Department Id</span></th><th><span data-translate="investhryApp.rating.investorEmail">Investor Email</span></th><th><span data-translate="investhryApp.rating.investorContact">Investor Contact</span></th><th><span data-translate="investhryApp.rating.comment">Comment</span></th><th><span data-translate="investhryApp.rating.name">Name</span></th><th><span data-translate="investhryApp.rating.businessEntity">Business Entity</span></th><th><span data-translate="investhryApp.rating.lastUpadte">Last Upadte</span></th><th><span data-translate="investhryApp.rating.district">District</span></th><th><span data-translate="investhryApp.rating.appliedDate">Applied Date</span></th><th><span data-translate="investhryApp.rating.clearedDate">Cleared Date</span></th><th><span data-translate="investhryApp.rating.projectLevel">Project Level</span></th><th><span data-translate="investhryApp.rating.actionTaken">Action Taken</span></th><th><span data-translate="investhryApp.rating.actionTakenDate">Action Taken Date</span></th><th><span data-translate="investhryApp.rating.isResolved">Is Resolved</span></th><th></th></tr></thead><tbody><tr ng-repeat="rating in vm.ratings track by rating.id"><td><a ui-sref="rating-detail({id:rating.id})">{{rating.id}}</a></td><td>{{rating.projectId}}</td><td>{{rating.serviceId}}</td><td>{{rating.cafPin}}</td><td>{{rating.userName}}</td><td>{{rating.departmentName}}</td><td>{{rating.serviceName}}</td><td>{{rating.rating}}</td><td>{{rating.departmentId}}</td><td>{{rating.investorEmail}}</td><td>{{rating.investorContact}}</td><td>{{rating.comment}}</td><td>{{rating.name}}</td><td>{{rating.businessEntity}}</td><td>{{rating.lastUpadte | date:\'medium\'}}</td><td>{{rating.district}}</td><td>{{rating.appliedDate | date:\'medium\'}}</td><td>{{rating.clearedDate | date:\'medium\'}}</td><td>{{rating.projectLevel}}</td><td>{{rating.actionTaken}}</td><td>{{rating.actionTakenDate | date:\'medium\'}}</td><td>{{rating.isResolved}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="rating-detail({id:rating.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="rating.edit({id:rating.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="rating.delete({id:rating.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/re-apply-dashboard/re-apply-dashboard-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.reApplyDashboard.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.reApplyDashboard.delete.question" translate-values="{id: \'{{vm.reApplyDashboard.id}}\'}">Are you sure you want to delete this Re Apply Dashboard?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/re-apply-dashboard/re-apply-dashboard-detail.html','<div><h2><span data-translate="investhryApp.reApplyDashboard.detail.title">Re Apply Dashboard</span> {{vm.reApplyDashboard.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.reApplyDashboard.cafpin">Cafpin</span></dt><dd><span>{{vm.reApplyDashboard.cafpin}}</span></dd><dt><span data-translate="investhryApp.reApplyDashboard.projectservicedetailId">Projectservicedetail Id</span></dt><dd><span>{{vm.reApplyDashboard.projectservicedetailId}}</span></dd><dt><span data-translate="investhryApp.reApplyDashboard.previousStatus">Previous Status</span></dt><dd><span>{{vm.reApplyDashboard.previousStatus}}</span></dd><dt><span data-translate="investhryApp.reApplyDashboard.reApplyDate">Re Apply Date</span></dt><dd><span>{{vm.reApplyDashboard.reApplyDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reApplyDashboard.projectId">Project Id</span></dt><dd><span>{{vm.reApplyDashboard.projectId}}</span></dd><dt><span data-translate="investhryApp.reApplyDashboard.serviceId">Service Id</span></dt><dd><span>{{vm.reApplyDashboard.serviceId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="re-apply-dashboard-detail.edit({id:vm.reApplyDashboard.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/re-apply-dashboard/re-apply-dashboard-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReApplyDashboardLabel" data-translate="investhryApp.reApplyDashboard.home.createOrEditLabel">Create or edit a Re Apply Dashboard</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.reApplyDashboard.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.reApplyDashboard.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reApplyDashboard.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.reApplyDashboard.cafpin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reApplyDashboard.projectservicedetailId" for="field_projectservicedetailId">Projectservicedetail Id</label><input type="text" class="form-control" name="projectservicedetailId" id="field_projectservicedetailId" ng-model="vm.reApplyDashboard.projectservicedetailId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reApplyDashboard.previousStatus" for="field_previousStatus">Previous Status</label><input type="text" class="form-control" name="previousStatus" id="field_previousStatus" ng-model="vm.reApplyDashboard.previousStatus"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reApplyDashboard.reApplyDate" for="field_reApplyDate">Re Apply Date</label><div class="input-group"><input id="field_reApplyDate" type="text" class="form-control" name="reApplyDate" datetime-picker="{{dateformat}}" ng-model="vm.reApplyDashboard.reApplyDate" is-open="vm.datePickerOpenStatus.reApplyDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'reApplyDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reApplyDashboard.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.reApplyDashboard.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reApplyDashboard.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.reApplyDashboard.serviceId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/re-apply-dashboard/re-apply-dashboards.html','<div><h2 data-translate="investhryApp.reApplyDashboard.home.title">Re Apply Dashboards</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="re-apply-dashboard.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.reApplyDashboard.home.createLabel">Create new Re Apply Dashboard</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.reApplyDashboard.cafpin">Cafpin</span></th><th><span data-translate="investhryApp.reApplyDashboard.projectservicedetailId">Projectservicedetail Id</span></th><th><span data-translate="investhryApp.reApplyDashboard.previousStatus">Previous Status</span></th><th><span data-translate="investhryApp.reApplyDashboard.reApplyDate">Re Apply Date</span></th><th><span data-translate="investhryApp.reApplyDashboard.projectId">Project Id</span></th><th><span data-translate="investhryApp.reApplyDashboard.serviceId">Service Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="reApplyDashboard in vm.reApplyDashboards track by reApplyDashboard.id"><td><a ui-sref="re-apply-dashboard-detail({id:reApplyDashboard.id})">{{reApplyDashboard.id}}</a></td><td>{{reApplyDashboard.cafpin}}</td><td>{{reApplyDashboard.projectservicedetailId}}</td><td>{{reApplyDashboard.previousStatus}}</td><td>{{reApplyDashboard.reApplyDate | date:\'medium\'}}</td><td>{{reApplyDashboard.projectId}}</td><td>{{reApplyDashboard.serviceId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="re-apply-dashboard-detail({id:reApplyDashboard.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="re-apply-dashboard.edit({id:reApplyDashboard.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="re-apply-dashboard.delete({id:reApplyDashboard.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/reappliedservices/reappliedservices-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.reappliedservices.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.reappliedservices.delete.question" translate-values="{id: \'{{vm.reappliedservices.id}}\'}">Are you sure you want to delete this Reappliedservices?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/reappliedservices/reappliedservices-detail.html','<div><h2><span data-translate="investhryApp.reappliedservices.detail.title">Reappliedservices</span> {{vm.reappliedservices.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.reappliedservices.projectid">Projectid</span></dt><dd><span>{{vm.reappliedservices.projectid}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.serviceid">Serviceid</span></dt><dd><span>{{vm.reappliedservices.serviceid}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.isRequired">Is Required</span></dt><dd><span>{{vm.reappliedservices.isRequired}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.requireMarkedOnDate">Require Marked On Date</span></dt><dd><span>{{vm.reappliedservices.requireMarkedOnDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.requireMarkedBy">Require Marked By</span></dt><dd><span>{{vm.reappliedservices.requireMarkedBy}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.isAssigned">Is Assigned</span></dt><dd><span>{{vm.reappliedservices.isAssigned}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.assigOnDate">Assig On Date</span></dt><dd><span>{{vm.reappliedservices.assigOnDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.assignBy">Assign By</span></dt><dd><span>{{vm.reappliedservices.assignBy}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.formFilledStatus">Form Filled Status</span></dt><dd><span>{{vm.reappliedservices.formFilledStatus}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.isPaymentMade">Is Payment Made</span></dt><dd><span>{{vm.reappliedservices.isPaymentMade}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.isPaymentVerified">Is Payment Verified</span></dt><dd><span>{{vm.reappliedservices.isPaymentVerified}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.formFilledOnDate">Form Filled On Date</span></dt><dd><span>{{vm.reappliedservices.formFilledOnDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.formFilledBy">Form Filled By</span></dt><dd><span>{{vm.reappliedservices.formFilledBy}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.paymentMadeOnDate">Payment Made On Date</span></dt><dd><span>{{vm.reappliedservices.paymentMadeOnDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.status">Status</span></dt><dd><span>{{vm.reappliedservices.status}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.latestComments">Latest Comments</span></dt><dd><span>{{vm.reappliedservices.latestComments}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.departmentName">Department Name</span></dt><dd><span>{{vm.reappliedservices.departmentName}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.serviceName">Service Name</span></dt><dd><span>{{vm.reappliedservices.serviceName}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.serviceStage">Service Stage</span></dt><dd><span>{{vm.reappliedservices.serviceStage}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.isDimmed">Is Dimmed</span></dt><dd><span>{{vm.reappliedservices.isDimmed}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.serviceDuration">Service Duration</span></dt><dd><span>{{vm.reappliedservices.serviceDuration}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.serviceFee">Service Fee</span></dt><dd><span>{{vm.reappliedservices.serviceFee}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.lastactiondate">Lastactiondate</span></dt><dd><span>{{vm.reappliedservices.lastactiondate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.statusdate">Statusdate</span></dt><dd><span>{{vm.reappliedservices.statusdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.isIntegrated">Is Integrated</span></dt><dd><span>{{vm.reappliedservices.isIntegrated}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.integrationDate">Integration Date</span></dt><dd><span>{{vm.reappliedservices.integrationDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.isDateExceeded">Is Date Exceeded</span></dt><dd><span>{{vm.reappliedservices.isDateExceeded}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.url">Url</span></dt><dd><span>{{vm.reappliedservices.url}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.isShowchoosedept">Is Showchoosedept</span></dt><dd><span>{{vm.reappliedservices.isShowchoosedept}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.reApply">Re Apply</span></dt><dd><span>{{vm.reappliedservices.reApply}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.constructionPermit">Construction Permit</span></dt><dd><span>{{vm.reappliedservices.constructionPermit}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.reApplyCounter">Re Apply Counter</span></dt><dd><span>{{vm.reappliedservices.reApplyCounter}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.clearedDate">Cleared Date</span></dt><dd><span>{{vm.reappliedservices.clearedDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.rejectionDate">Rejection Date</span></dt><dd><span>{{vm.reappliedservices.rejectionDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.deemedClearedDate">Deemed Cleared Date</span></dt><dd><span>{{vm.reappliedservices.deemedClearedDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.reAppliedDate">Re Applied Date</span></dt><dd><span>{{vm.reappliedservices.reAppliedDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.projectservicedetailId">Projectservicedetail Id</span></dt><dd><span>{{vm.reappliedservices.projectservicedetailId}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.cafpin">Cafpin</span></dt><dd><span>{{vm.reappliedservices.cafpin}}</span></dd><dt><span data-translate="investhryApp.reappliedservices.projectservicelogid">Projectservicelogid</span></dt><dd><span>{{vm.reappliedservices.projectservicelogid}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="reappliedservices-detail.edit({id:vm.reappliedservices.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/reappliedservices/reappliedservices-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReappliedservicesLabel" data-translate="investhryApp.reappliedservices.home.createOrEditLabel">Create or edit a Reappliedservices</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.reappliedservices.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.reappliedservices.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.reappliedservices.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.reappliedservices.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.isRequired" for="field_isRequired">Is Required</label><input type="checkbox" name="isRequired" id="field_isRequired" ng-model="vm.reappliedservices.isRequired"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.requireMarkedOnDate" for="field_requireMarkedOnDate">Require Marked On Date</label><div class="input-group"><input id="field_requireMarkedOnDate" type="text" class="form-control" name="requireMarkedOnDate" datetime-picker="{{dateformat}}" ng-model="vm.reappliedservices.requireMarkedOnDate" is-open="vm.datePickerOpenStatus.requireMarkedOnDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'requireMarkedOnDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.requireMarkedBy" for="field_requireMarkedBy">Require Marked By</label><input type="text" class="form-control" name="requireMarkedBy" id="field_requireMarkedBy" ng-model="vm.reappliedservices.requireMarkedBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.isAssigned" for="field_isAssigned">Is Assigned</label><input type="checkbox" name="isAssigned" id="field_isAssigned" ng-model="vm.reappliedservices.isAssigned"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.assigOnDate" for="field_assigOnDate">Assig On Date</label><div class="input-group"><input id="field_assigOnDate" type="text" class="form-control" name="assigOnDate" datetime-picker="{{dateformat}}" ng-model="vm.reappliedservices.assigOnDate" is-open="vm.datePickerOpenStatus.assigOnDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'assigOnDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.assignBy" for="field_assignBy">Assign By</label><input type="text" class="form-control" name="assignBy" id="field_assignBy" ng-model="vm.reappliedservices.assignBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.formFilledStatus" for="field_formFilledStatus">Form Filled Status</label><input type="checkbox" name="formFilledStatus" id="field_formFilledStatus" ng-model="vm.reappliedservices.formFilledStatus"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.isPaymentMade" for="field_isPaymentMade">Is Payment Made</label><input type="checkbox" name="isPaymentMade" id="field_isPaymentMade" ng-model="vm.reappliedservices.isPaymentMade"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.isPaymentVerified" for="field_isPaymentVerified">Is Payment Verified</label><input type="checkbox" name="isPaymentVerified" id="field_isPaymentVerified" ng-model="vm.reappliedservices.isPaymentVerified"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.formFilledOnDate" for="field_formFilledOnDate">Form Filled On Date</label><div class="input-group"><input id="field_formFilledOnDate" type="text" class="form-control" name="formFilledOnDate" datetime-picker="{{dateformat}}" ng-model="vm.reappliedservices.formFilledOnDate" is-open="vm.datePickerOpenStatus.formFilledOnDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'formFilledOnDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.formFilledBy" for="field_formFilledBy">Form Filled By</label><input type="text" class="form-control" name="formFilledBy" id="field_formFilledBy" ng-model="vm.reappliedservices.formFilledBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.paymentMadeOnDate" for="field_paymentMadeOnDate">Payment Made On Date</label><div class="input-group"><input id="field_paymentMadeOnDate" type="text" class="form-control" name="paymentMadeOnDate" datetime-picker="{{dateformat}}" ng-model="vm.reappliedservices.paymentMadeOnDate" is-open="vm.datePickerOpenStatus.paymentMadeOnDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'paymentMadeOnDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.reappliedservices.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.latestComments" for="field_latestComments">Latest Comments</label><input type="text" class="form-control" name="latestComments" id="field_latestComments" ng-model="vm.reappliedservices.latestComments"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.reappliedservices.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.reappliedservices.serviceName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.serviceStage" for="field_serviceStage">Service Stage</label><input type="text" class="form-control" name="serviceStage" id="field_serviceStage" ng-model="vm.reappliedservices.serviceStage"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.isDimmed" for="field_isDimmed">Is Dimmed</label><input type="checkbox" name="isDimmed" id="field_isDimmed" ng-model="vm.reappliedservices.isDimmed"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.serviceDuration" for="field_serviceDuration">Service Duration</label><input type="number" class="form-control" name="serviceDuration" id="field_serviceDuration" ng-model="vm.reappliedservices.serviceDuration"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.serviceFee" for="field_serviceFee">Service Fee</label><input type="number" class="form-control" name="serviceFee" id="field_serviceFee" ng-model="vm.reappliedservices.serviceFee"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.lastactiondate" for="field_lastactiondate">Lastactiondate</label><div class="input-group"><input id="field_lastactiondate" type="text" class="form-control" name="lastactiondate" datetime-picker="{{dateformat}}" ng-model="vm.reappliedservices.lastactiondate" is-open="vm.datePickerOpenStatus.lastactiondate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'lastactiondate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.statusdate" for="field_statusdate">Statusdate</label><div class="input-group"><input id="field_statusdate" type="text" class="form-control" name="statusdate" datetime-picker="{{dateformat}}" ng-model="vm.reappliedservices.statusdate" is-open="vm.datePickerOpenStatus.statusdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'statusdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.isIntegrated" for="field_isIntegrated">Is Integrated</label><input type="checkbox" name="isIntegrated" id="field_isIntegrated" ng-model="vm.reappliedservices.isIntegrated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.integrationDate" for="field_integrationDate">Integration Date</label><div class="input-group"><input id="field_integrationDate" type="text" class="form-control" name="integrationDate" datetime-picker="{{dateformat}}" ng-model="vm.reappliedservices.integrationDate" is-open="vm.datePickerOpenStatus.integrationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'integrationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.isDateExceeded" for="field_isDateExceeded">Is Date Exceeded</label><input type="checkbox" name="isDateExceeded" id="field_isDateExceeded" ng-model="vm.reappliedservices.isDateExceeded"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.url" for="field_url">Url</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.reappliedservices.url"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.isShowchoosedept" for="field_isShowchoosedept">Is Showchoosedept</label><input type="checkbox" name="isShowchoosedept" id="field_isShowchoosedept" ng-model="vm.reappliedservices.isShowchoosedept"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.reApply" for="field_reApply">Re Apply</label><input type="checkbox" name="reApply" id="field_reApply" ng-model="vm.reappliedservices.reApply"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.constructionPermit" for="field_constructionPermit">Construction Permit</label><input type="text" class="form-control" name="constructionPermit" id="field_constructionPermit" ng-model="vm.reappliedservices.constructionPermit"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.reApplyCounter" for="field_reApplyCounter">Re Apply Counter</label><input type="number" class="form-control" name="reApplyCounter" id="field_reApplyCounter" ng-model="vm.reappliedservices.reApplyCounter"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.clearedDate" for="field_clearedDate">Cleared Date</label><div class="input-group"><input id="field_clearedDate" type="text" class="form-control" name="clearedDate" datetime-picker="{{dateformat}}" ng-model="vm.reappliedservices.clearedDate" is-open="vm.datePickerOpenStatus.clearedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'clearedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.rejectionDate" for="field_rejectionDate">Rejection Date</label><div class="input-group"><input id="field_rejectionDate" type="text" class="form-control" name="rejectionDate" datetime-picker="{{dateformat}}" ng-model="vm.reappliedservices.rejectionDate" is-open="vm.datePickerOpenStatus.rejectionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'rejectionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.deemedClearedDate" for="field_deemedClearedDate">Deemed Cleared Date</label><div class="input-group"><input id="field_deemedClearedDate" type="text" class="form-control" name="deemedClearedDate" datetime-picker="{{dateformat}}" ng-model="vm.reappliedservices.deemedClearedDate" is-open="vm.datePickerOpenStatus.deemedClearedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'deemedClearedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.reAppliedDate" for="field_reAppliedDate">Re Applied Date</label><div class="input-group"><input id="field_reAppliedDate" type="text" class="form-control" name="reAppliedDate" datetime-picker="{{dateformat}}" ng-model="vm.reappliedservices.reAppliedDate" is-open="vm.datePickerOpenStatus.reAppliedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'reAppliedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.projectservicedetailId" for="field_projectservicedetailId">Projectservicedetail Id</label><input type="text" class="form-control" name="projectservicedetailId" id="field_projectservicedetailId" ng-model="vm.reappliedservices.projectservicedetailId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.reappliedservices.cafpin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reappliedservices.projectservicelogid" for="field_projectservicelogid">Projectservicelogid</label><input type="text" class="form-control" name="projectservicelogid" id="field_projectservicelogid" ng-model="vm.reappliedservices.projectservicelogid"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/reappliedservices/reappliedservices.html','<div><h2 data-translate="investhryApp.reappliedservices.home.title">Reappliedservices</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><!--<div class="col-xs-4 no-padding-left">--><!--<button class="btn btn-primary" ui-sref="reappliedservices.new" >--><!--<span class="glyphicon glyphicon-plus"></span>--><!--<span  data-translate="investhryApp.reappliedservices.home.createLabel">--><!--Create new Reappliedservices--><!--</span>--><!--</button>--><!--</div>--></div></div><br><br><div class="container"><form name="form1"><div class="row form-group"><div class="col-sm-4 col-sm-offset-2"><input type="text" class="form-control" placeholder="Enter Projectservicedetail id" name="projectservicedetailid" ng-model="vm.projectservicedetailid" required></div><div class="btn-group col-sm-4"><button class="btn btn-primary" ng-disabled="form1.projectservicedetailid.$invalid" ng-click="vm.loadByProjectservicedetailid(vm.projectservicedetailid)">Find Records</button></div></div></form></div><br><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th>S. No.</th><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.reappliedservices.projectid">Projectid</span></th><th><span data-translate="investhryApp.reappliedservices.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.reappliedservices.isRequired">Is Required</span></th><th><span data-translate="investhryApp.reappliedservices.requireMarkedOnDate">Require Marked On Date</span></th><th><span data-translate="investhryApp.reappliedservices.requireMarkedBy">Require Marked By</span></th><th><span data-translate="investhryApp.reappliedservices.isAssigned">Is Assigned</span></th><th><span data-translate="investhryApp.reappliedservices.assigOnDate">Assig On Date</span></th><th><span data-translate="investhryApp.reappliedservices.assignBy">Assign By</span></th><th><span data-translate="investhryApp.reappliedservices.formFilledStatus">Form Filled Status</span></th><th><span data-translate="investhryApp.reappliedservices.isPaymentMade">Is Payment Made</span></th><th><span data-translate="investhryApp.reappliedservices.isPaymentVerified">Is Payment Verified</span></th><th><span data-translate="investhryApp.reappliedservices.formFilledOnDate">Form Filled On Date</span></th><th><span data-translate="investhryApp.reappliedservices.formFilledBy">Form Filled By</span></th><th><span data-translate="investhryApp.reappliedservices.paymentMadeOnDate">Payment Made On Date</span></th><th><span data-translate="investhryApp.reappliedservices.status">Status</span></th><th><span data-translate="investhryApp.reappliedservices.latestComments">Latest Comments</span></th><th><span data-translate="investhryApp.reappliedservices.departmentName">Department Name</span></th><th><span data-translate="investhryApp.reappliedservices.serviceName">Service Name</span></th><th><span data-translate="investhryApp.reappliedservices.serviceStage">Service Stage</span></th><th><span data-translate="investhryApp.reappliedservices.isDimmed">Is Dimmed</span></th><th><span data-translate="investhryApp.reappliedservices.serviceDuration">Service Duration</span></th><th><span data-translate="investhryApp.reappliedservices.serviceFee">Service Fee</span></th><th><span data-translate="investhryApp.reappliedservices.lastactiondate">Lastactiondate</span></th><th><span data-translate="investhryApp.reappliedservices.statusdate">Statusdate</span></th><th><span data-translate="investhryApp.reappliedservices.isIntegrated">Is Integrated</span></th><th><span data-translate="investhryApp.reappliedservices.integrationDate">Integration Date</span></th><th><span data-translate="investhryApp.reappliedservices.isDateExceeded">Is Date Exceeded</span></th><th><span data-translate="investhryApp.reappliedservices.url">Url</span></th><th><span data-translate="investhryApp.reappliedservices.isShowchoosedept">Is Showchoosedept</span></th><th><span data-translate="investhryApp.reappliedservices.reApply">Re Apply</span></th><th><span data-translate="investhryApp.reappliedservices.constructionPermit">Construction Permit</span></th><th><span data-translate="investhryApp.reappliedservices.reApplyCounter">Re Apply Counter</span></th><th><span data-translate="investhryApp.reappliedservices.clearedDate">Cleared Date</span></th><th><span data-translate="investhryApp.reappliedservices.rejectionDate">Rejection Date</span></th><th><span data-translate="investhryApp.reappliedservices.deemedClearedDate">Deemed Cleared Date</span></th><th><span data-translate="investhryApp.reappliedservices.reAppliedDate">Re Applied Date</span></th><th><span data-translate="investhryApp.reappliedservices.projectservicedetailId">Projectservicedetail Id</span></th><th><span data-translate="investhryApp.reappliedservices.cafpin">Cafpin</span></th><th><span data-translate="investhryApp.reappliedservices.projectservicelogid">Projectservicelogid</span></th><th></th></tr></thead><tbody><tr ng-repeat="reappliedservices in vm.reappliedservices track by reappliedservices.id"><td>{{$index+1}}</td><td><a ui-sref="reappliedservices-detail({id:reappliedservices.id})">{{reappliedservices.id}}</a></td><td>{{reappliedservices.projectid}}</td><td>{{reappliedservices.serviceid}}</td><td>{{reappliedservices.isRequired}}</td><td>{{reappliedservices.requireMarkedOnDate | date:\'medium\'}}</td><td>{{reappliedservices.requireMarkedBy}}</td><td>{{reappliedservices.isAssigned}}</td><td>{{reappliedservices.assigOnDate | date:\'medium\'}}</td><td>{{reappliedservices.assignBy}}</td><td>{{reappliedservices.formFilledStatus}}</td><td>{{reappliedservices.isPaymentMade}}</td><td>{{reappliedservices.isPaymentVerified}}</td><td>{{reappliedservices.formFilledOnDate | date:\'medium\'}}</td><td>{{reappliedservices.formFilledBy}}</td><td>{{reappliedservices.paymentMadeOnDate | date:\'medium\'}}</td><td>{{reappliedservices.status}}</td><td>{{reappliedservices.latestComments}}</td><td>{{reappliedservices.departmentName}}</td><td>{{reappliedservices.serviceName}}</td><td>{{reappliedservices.serviceStage}}</td><td>{{reappliedservices.isDimmed}}</td><td>{{reappliedservices.serviceDuration}}</td><td>{{reappliedservices.serviceFee}}</td><td>{{reappliedservices.lastactiondate | date:\'medium\'}}</td><td>{{reappliedservices.statusdate | date:\'medium\'}}</td><td>{{reappliedservices.isIntegrated}}</td><td>{{reappliedservices.integrationDate | date:\'medium\'}}</td><td>{{reappliedservices.isDateExceeded}}</td><td>{{reappliedservices.url}}</td><td>{{reappliedservices.isShowchoosedept}}</td><td>{{reappliedservices.reApply}}</td><td>{{reappliedservices.constructionPermit}}</td><td>{{reappliedservices.reApplyCounter}}</td><td>{{reappliedservices.clearedDate | date:\'medium\'}}</td><td>{{reappliedservices.rejectionDate | date:\'medium\'}}</td><td>{{reappliedservices.deemedClearedDate | date:\'medium\'}}</td><td>{{reappliedservices.reAppliedDate | date:\'medium\'}}</td><td>{{reappliedservices.projectservicedetailId}}</td><td>{{reappliedservices.cafpin}}</td><td>{{reappliedservices.projectservicelogid}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="reappliedservices-detail({id:reappliedservices.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="reappliedservices.edit({id:reappliedservices.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="reappliedservices.delete({id:reappliedservices.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/reason-category/reason-categories.html','<div><h2 data-translate="investhryApp.reasonCategory.home.title">Reason Categories</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="reason-category.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.reasonCategory.home.createLabel">Create new Reason Category</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.reasonCategory.category">Category</span></th><th></th></tr></thead><tbody><tr ng-repeat="reasonCategory in vm.reasonCategories track by reasonCategory.id"><td><a ui-sref="reason-category-detail({id:reasonCategory.id})">{{reasonCategory.id}}</a></td><td>{{reasonCategory.category}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="reason-category-detail({id:reasonCategory.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="reason-category.edit({id:reasonCategory.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="reason-category.delete({id:reasonCategory.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/reason-category/reason-category-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.reasonCategory.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.reasonCategory.delete.question" translate-values="{id: \'{{vm.reasonCategory.id}}\'}">Are you sure you want to delete this Reason Category?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/reason-category/reason-category-detail.html','<div><h2><span data-translate="investhryApp.reasonCategory.detail.title">Reason Category</span> {{vm.reasonCategory.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.reasonCategory.category">Category</span></dt><dd><span>{{vm.reasonCategory.category}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="reason-category-detail.edit({id:vm.reasonCategory.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/reason-category/reason-category-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myReasonCategoryLabel" data-translate="investhryApp.reasonCategory.home.createOrEditLabel">Create or edit a Reason Category</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.reasonCategory.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.reasonCategory.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.reasonCategory.category" for="field_category">Category</label><input type="text" class="form-control" name="category" id="field_category" ng-model="vm.reasonCategory.category"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/regular-electrict-load-type/regular-electrict-load-type-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.regular_electrict_load_type.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.regular_electrict_load_type.delete.question" translate-values="{id: \'{{vm.regular_electrict_load_type.id}}\'}">Are you sure you want to delete this Regular Electrict Load Type?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/regular-electrict-load-type/regular-electrict-load-type-detail.html','<div class="container"><h2><span data-translate="investhryApp.regular_electrict_load_type.detail.title">Regular Electrict Load Type</span> {{vm.regular_electrict_load_type.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.regular_electrict_load_type.typeofload">Typeofload</span></dt><dd><span>{{vm.regular_electrict_load_type.typeofload}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="regular-electrict-load-type-detail.edit({id:vm.regular_electrict_load_type.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/regular-electrict-load-type/regular-electrict-load-type-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRegular_electrict_load_typeLabel" data-translate="investhryApp.regular_electrict_load_type.home.createOrEditLabel">Create or edit a Regular Electrict Load Type</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.regular_electrict_load_type.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.regular_electrict_load_type.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.regular_electrict_load_type.typeofload" for="field_typeofload">Typeofload</label><input type="text" class="form-control" name="typeofload" id="field_typeofload" ng-model="vm.regular_electrict_load_type.typeofload" required><div ng-show="editForm.typeofload.$invalid"><p class="help-block" ng-show="editForm.typeofload.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/regular-electrict-load-type/regular-electrict-load-types.html','<div class="container"><h2 data-translate="investhryApp.regular_electrict_load_type.home.title">Regular Electrict Load Types</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="regular-electrict-load-type.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.regular_electrict_load_type.home.createLabel">Create new Regular Electrict Load Type</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.regular_electrict_load_type.typeofload">Typeofload</span></th><th></th></tr></thead><tbody><tr ng-repeat="regular_electrict_load_type in vm.regular_electrict_load_types track by regular_electrict_load_type.id"><td><a ui-sref="regular-electrict-load-type-detail({id:regular_electrict_load_type.id})">{{regular_electrict_load_type.id}}</a></td><td>{{regular_electrict_load_type.typeofload}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="regular-electrict-load-type-detail({id:regular_electrict_load_type.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="regular-electrict-load-type.edit({id:regular_electrict_load_type.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="regular-electrict-load-type.delete({id:regular_electrict_load_type.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/rejected-project-service-log/rejected-project-service-log-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rejectedProjectServiceLog.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.rejectedProjectServiceLog.delete.question" translate-values="{id: \'{{vm.rejectedProjectServiceLog.id}}\'}">Are you sure you want to delete this Rejected Project Service Log?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/rejected-project-service-log/rejected-project-service-log-detail.html','<div><h2><span data-translate="investhryApp.rejectedProjectServiceLog.detail.title">Rejected Project Service Log</span> {{vm.rejectedProjectServiceLog.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.rejectedProjectServiceLog.projectServiceLogId">Project Service Log Id</span></dt><dd><span>{{vm.rejectedProjectServiceLog.projectServiceLogId}}</span></dd><dt><span data-translate="investhryApp.rejectedProjectServiceLog.reasonCode">Reason Code</span></dt><dd><span>{{vm.rejectedProjectServiceLog.reasonCode}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="rejected-project-service-log-detail.edit({id:vm.rejectedProjectServiceLog.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/rejected-project-service-log/rejected-project-service-log-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRejectedProjectServiceLogLabel" data-translate="investhryApp.rejectedProjectServiceLog.home.createOrEditLabel">Create or edit a Rejected Project Service Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rejectedProjectServiceLog.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rejectedProjectServiceLog.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectedProjectServiceLog.projectServiceLogId" for="field_projectServiceLogId">Project Service Log Id</label><input type="text" class="form-control" name="projectServiceLogId" id="field_projectServiceLogId" ng-model="vm.rejectedProjectServiceLog.projectServiceLogId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectedProjectServiceLog.reasonCode" for="field_reasonCode">Reason Code</label><input type="text" class="form-control" name="reasonCode" id="field_reasonCode" ng-model="vm.rejectedProjectServiceLog.reasonCode"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/rejected-project-service-log/rejected-project-service-logs.html','<div><h2 data-translate="investhryApp.rejectedProjectServiceLog.home.title">Rejected Project Service Logs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="rejected-project-service-log.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.rejectedProjectServiceLog.home.createLabel">Create new Rejected Project Service Log</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.rejectedProjectServiceLog.projectServiceLogId">Project Service Log Id</span></th><th><span data-translate="investhryApp.rejectedProjectServiceLog.reasonCode">Reason Code</span></th><th></th></tr></thead><tbody><tr ng-repeat="rejectedProjectServiceLog in vm.rejectedProjectServiceLogs track by rejectedProjectServiceLog.id"><td><a ui-sref="rejected-project-service-log-detail({id:rejectedProjectServiceLog.id})">{{rejectedProjectServiceLog.id}}</a></td><td>{{rejectedProjectServiceLog.projectServiceLogId}}</td><td>{{rejectedProjectServiceLog.reasonCode}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="rejected-project-service-log-detail({id:rejectedProjectServiceLog.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="rejected-project-service-log.edit({id:rejectedProjectServiceLog.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="rejected-project-service-log.delete({id:rejectedProjectServiceLog.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/rejected-services/rejected-services-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rejectedServices.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.rejectedServices.delete.question" translate-values="{id: \'{{vm.rejectedServices.id}}\'}">Are you sure you want to delete this Rejected Services?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/rejected-services/rejected-services-detail.html','<div><h2><span data-translate="investhryApp.rejectedServices.detail.title">Rejected Services</span> {{vm.rejectedServices.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.rejectedServices.rejectionDate">Rejection Date</span></dt><dd><span>{{vm.rejectedServices.rejectionDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.rejectedServices.serviceId">Service Id</span></dt><dd><span>{{vm.rejectedServices.serviceId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="rejected-services-detail.edit({id:vm.rejectedServices.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/rejected-services/rejected-services-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRejectedServicesLabel" data-translate="investhryApp.rejectedServices.home.createOrEditLabel">Create or edit a Rejected Services</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rejectedServices.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rejectedServices.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectedServices.rejectionDate" for="field_rejectionDate">Rejection Date</label><div class="input-group"><input id="field_rejectionDate" type="text" class="form-control" name="rejectionDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.rejectedServices.rejectionDate" is-open="vm.datePickerOpenStatus.rejectionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'rejectionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectedServices.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.rejectedServices.serviceId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/rejected-services/rejected-services.html','<div><h2 data-translate="investhryApp.rejectedServices.home.title">Rejected Services</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="rejected-services.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.rejectedServices.home.createLabel">Create new Rejected Services</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.rejectedServices.rejectionDate">Rejection Date</span></th><th><span data-translate="investhryApp.rejectedServices.serviceId">Service Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="rejectedServices in vm.rejectedServices track by rejectedServices.id"><td><a ui-sref="rejected-services-detail({id:rejectedServices.id})">{{rejectedServices.id}}</a></td><td>{{rejectedServices.rejectionDate | date:\'mediumDate\'}}</td><td>{{rejectedServices.serviceId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="rejected-services-detail({id:rejectedServices.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="rejected-services.edit({id:rejectedServices.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="rejected-services.delete({id:rejectedServices.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/rejection-bucket/rejection-bucket-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rejectionBucket.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.rejectionBucket.delete.question" translate-values="{id: \'{{vm.rejectionBucket.id}}\'}">Are you sure you want to delete this Rejection Bucket?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/rejection-bucket/rejection-bucket-detail.html','<div><h2><span data-translate="investhryApp.rejectionBucket.detail.title">Rejection Bucket</span> {{vm.rejectionBucket.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.rejectionBucket.projectId">Project Id</span></dt><dd><span>{{vm.rejectionBucket.projectId}}</span></dd><dt><span data-translate="investhryApp.rejectionBucket.serviceId">Service Id</span></dt><dd><span>{{vm.rejectionBucket.serviceId}}</span></dd><dt><span data-translate="investhryApp.rejectionBucket.projectServiceDetailId">Project Service Detail Id</span></dt><dd><span>{{vm.rejectionBucket.projectServiceDetailId}}</span></dd><dt><span data-translate="investhryApp.rejectionBucket.serviceName">Service Name</span></dt><dd><span>{{vm.rejectionBucket.serviceName}}</span></dd><dt><span data-translate="investhryApp.rejectionBucket.departmentName">Department Name</span></dt><dd><span>{{vm.rejectionBucket.departmentName}}</span></dd><dt><span data-translate="investhryApp.rejectionBucket.reApplyCounter">Re Apply Counter</span></dt><dd><span>{{vm.rejectionBucket.reApplyCounter}}</span></dd><dt><span data-translate="investhryApp.rejectionBucket.rejectionReason">Rejection Reason</span></dt><dd><span>{{vm.rejectionBucket.rejectionReason}}</span></dd><dt><span data-translate="investhryApp.rejectionBucket.rejectionDate">Rejection Date</span></dt><dd><span>{{vm.rejectionBucket.rejectionDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.rejectionBucket.cafPin">Caf Pin</span></dt><dd><span>{{vm.rejectionBucket.cafPin}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="rejection-bucket-detail.edit({id:vm.rejectionBucket.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/rejection-bucket/rejection-bucket-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRejectionBucketLabel" data-translate="investhryApp.rejectionBucket.home.createOrEditLabel">Create or edit a Rejection Bucket</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rejectionBucket.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rejectionBucket.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectionBucket.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.rejectionBucket.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectionBucket.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.rejectionBucket.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectionBucket.projectServiceDetailId" for="field_projectServiceDetailId">Project Service Detail Id</label><input type="text" class="form-control" name="projectServiceDetailId" id="field_projectServiceDetailId" ng-model="vm.rejectionBucket.projectServiceDetailId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectionBucket.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.rejectionBucket.serviceName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectionBucket.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.rejectionBucket.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectionBucket.reApplyCounter" for="field_reApplyCounter">Re Apply Counter</label><input type="number" class="form-control" name="reApplyCounter" id="field_reApplyCounter" ng-model="vm.rejectionBucket.reApplyCounter"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectionBucket.rejectionReason" for="field_rejectionReason">Rejection Reason</label><input type="text" class="form-control" name="rejectionReason" id="field_rejectionReason" ng-model="vm.rejectionBucket.rejectionReason"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectionBucket.rejectionDate" for="field_rejectionDate">Rejection Date</label><div class="input-group"><input id="field_rejectionDate" type="text" class="form-control" name="rejectionDate" datetime-picker="{{dateformat}}" ng-model="vm.rejectionBucket.rejectionDate" is-open="vm.datePickerOpenStatus.rejectionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'rejectionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rejectionBucket.cafPin" for="field_cafPin">Caf Pin</label><input type="text" class="form-control" name="cafPin" id="field_cafPin" ng-model="vm.rejectionBucket.cafPin"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/rejection-bucket/rejection-buckets.html','<div><h2 data-translate="investhryApp.rejectionBucket.home.title">Rejection Buckets</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="rejection-bucket.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.rejectionBucket.home.createLabel">Create new Rejection Bucket</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.rejectionBucket.projectId">Project Id</span></th><th><span data-translate="investhryApp.rejectionBucket.serviceId">Service Id</span></th><th><span data-translate="investhryApp.rejectionBucket.projectServiceDetailId">Project Service Detail Id</span></th><th><span data-translate="investhryApp.rejectionBucket.serviceName">Service Name</span></th><th><span data-translate="investhryApp.rejectionBucket.departmentName">Department Name</span></th><th><span data-translate="investhryApp.rejectionBucket.reApplyCounter">Re Apply Counter</span></th><th><span data-translate="investhryApp.rejectionBucket.rejectionReason">Rejection Reason</span></th><th><span data-translate="investhryApp.rejectionBucket.rejectionDate">Rejection Date</span></th><th><span data-translate="investhryApp.rejectionBucket.cafPin">Caf Pin</span></th><th></th></tr></thead><tbody><tr ng-repeat="rejectionBucket in vm.rejectionBuckets track by rejectionBucket.id"><td><a ui-sref="rejection-bucket-detail({id:rejectionBucket.id})">{{rejectionBucket.id}}</a></td><td>{{rejectionBucket.projectId}}</td><td>{{rejectionBucket.serviceId}}</td><td>{{rejectionBucket.projectServiceDetailId}}</td><td>{{rejectionBucket.serviceName}}</td><td>{{rejectionBucket.departmentName}}</td><td>{{rejectionBucket.reApplyCounter}}</td><td>{{rejectionBucket.rejectionReason}}</td><td>{{rejectionBucket.rejectionDate | date:\'medium\'}}</td><td>{{rejectionBucket.cafPin}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="rejection-bucket-detail({id:rejectionBucket.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="rejection-bucket.edit({id:rejectionBucket.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="rejection-bucket.delete({id:rejectionBucket.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/rmlist/rmlist-delete-dialog.html','<form><div name="deleteForm"><div ng-show="!vm.showConfirmation"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><div class="form-group" ng-show="vm.replacement"><p>Please replace <b>{{vm.rmlist.rmlogin}}</b> before deletion.</p><label class="control-label">New Rm Login</label><input type="text" class="form-control" ng-model="vm.replacementRm" name="newRM" list="newRmList"><datalist id="newRmList"><select name="newRM" id="field_replacement" ng-model="vm.replacementRm" class="form-control" ng-options="x.rmlogin as x.rmlogin for x in vm.rmloginList track by x.rmlogin"><option value="">Select</option></select></datalist></div><div class="form-group" ng-show="vm.showRMStatus"><p style="color:maroon">There is no such RM. Please enter correct login</p></div><div class="form-group" ng-show="vm.rmForbidden"><p style="color:maroon">This Rm cannot replace {{vm.rmlist.rmlogin}}. Please use correct login.</p></div><p ng-show="!vm.replacement" data-translate="investhryApp.rmlist.delete.question" translate-values="{id: \'{{vm.rmlist.id}}\'}">Are you sure you want to delete this Rmlist?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger" ng-show="!vm.replacement"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button> <button class="btn btn-danger" ng-show="vm.replacement" ng-click="vm.replaceRm(vm.rmlist.id,vm.replacementRm)">Replace and Delete</button></div></div></div><div class="form-group confirmation" ng-show="vm.showConfirmation" id="confirmation"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">RM Replaced</h4></div><div class="modal-body"><div class="form-group"><h4 style="color:maroon" align="middle">{{vm.rmlist.rmlogin}} is successfully replaced by {{vm.replacementRm}}</h4></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">OK</button></div></div></form>');
$templateCache.put('app/entities/rmlist/rmlist-detail.html','<div class="container"><h2><span data-translate="investhryApp.rmlist.detail.title">Rmlist</span> {{vm.rmlist.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.rmlist.rmlogin">Rmlogin</span></dt><dd><span>{{vm.rmlist.rmlogin}}</span></dd><dt><span data-translate="investhryApp.rmlist.district">District</span></dt><dd><span>{{vm.rmlist.district}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="rmlist-detail.edit({id:vm.rmlist.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/rmlist/rmlist-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRmlistLabel" data-translate="investhryApp.rmlist.home.createOrEditLabel">Create or edit a Rmlist</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rmlist.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rmlist.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rmlist.rmlogin" for="field_rmlogin">Rmlogin</label><input type="text" class="form-control" name="rmlogin" id="field_rmlogin" ng-model="vm.rmlist.rmlogin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rmlist.district" for="field_district">District</label><select id="field_district" ng-model="vm.rmlist.district" class="form-control" ng-options="x.districtname as x.districtname for x in vm.districts"><option value="">Select</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/rmlist/rmlists.html','<div><h2 data-translate="investhryApp.rmlist.home.title">Rmlists</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="rmlist.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.rmlist.home.createLabel">Create new Rmlist</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.rmlist.rmlogin">Rmlogin</span></th><th><span data-translate="investhryApp.rmlist.district">District</span></th><th></th></tr></thead><tbody><tr ng-repeat="rmlist in vm.rmlists track by rmlist.id"><td><a ui-sref="rmlist-detail({id:rmlist.id})">{{rmlist.id}}</a></td><td>{{rmlist.rmlogin}}</td><td>{{rmlist.district}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="rmlist-detail({id:rmlist.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="rmlist.edit({id:rmlist.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="rmlist.delete({id:rmlist.id})" ng-show="rmlist.district==\'Haryana\'" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/row-business-entity/row-business-entities.html','<div><h2 data-translate="investhryApp.rowBusinessEntity.home.title">Row Business Entities</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="row-business-entity.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.rowBusinessEntity.home.createLabel">Create new Row Business Entity</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.rowBusinessEntity.name">Name</span></th><th><span data-translate="investhryApp.rowBusinessEntity.be_code">Be Code</span></th><th><span data-translate="investhryApp.rowBusinessEntity.createdDate">Created Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="rowBusinessEntity in vm.rowBusinessEntities track by rowBusinessEntity.id"><td><a ui-sref="row-business-entity-detail({id:rowBusinessEntity.id})">{{rowBusinessEntity.id}}</a></td><td>{{rowBusinessEntity.name}}</td><td>{{rowBusinessEntity.be_code}}</td><td>{{rowBusinessEntity.createdDate | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="row-business-entity-detail({id:rowBusinessEntity.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="row-business-entity.edit({id:rowBusinessEntity.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="row-business-entity.delete({id:rowBusinessEntity.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/row-business-entity/row-business-entity-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.rowBusinessEntity.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.rowBusinessEntity.delete.question" translate-values="{id: \'{{vm.rowBusinessEntity.id}}\'}">Are you sure you want to delete this Row Business Entity?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/row-business-entity/row-business-entity-detail.html','<div><h2><span data-translate="investhryApp.rowBusinessEntity.detail.title">Row Business Entity</span> {{vm.rowBusinessEntity.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.rowBusinessEntity.name">Name</span></dt><dd><span>{{vm.rowBusinessEntity.name}}</span></dd><dt><span data-translate="investhryApp.rowBusinessEntity.be_code">Be Code</span></dt><dd><span>{{vm.rowBusinessEntity.be_code}}</span></dd><dt><span data-translate="investhryApp.rowBusinessEntity.createdDate">Created Date</span></dt><dd><span>{{vm.rowBusinessEntity.createdDate | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="row-business-entity-detail.edit({id:vm.rowBusinessEntity.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/row-business-entity/row-business-entity-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myRowBusinessEntityLabel" data-translate="investhryApp.rowBusinessEntity.home.createOrEditLabel">Create or edit a Row Business Entity</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.rowBusinessEntity.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.rowBusinessEntity.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rowBusinessEntity.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.rowBusinessEntity.name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rowBusinessEntity.be_code" for="field_be_code">Be Code</label><input type="text" class="form-control" name="be_code" id="field_be_code" ng-model="vm.rowBusinessEntity.be_code"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rowBusinessEntity.createdDate" for="field_createdDate">Created Date</label><div class="input-group"><input id="field_createdDate" type="text" class="form-control" name="createdDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.rowBusinessEntity.createdDate" is-open="vm.datePickerOpenStatus.createdDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/scheduled-visits/scheduled-visits-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.scheduledVisits.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.scheduledVisits.delete.question" translate-values="{id: \'{{vm.scheduledVisits.id}}\'}">Are you sure you want to delete this Scheduled Visits?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/scheduled-visits/scheduled-visits-detail.html','<div><h2><span data-translate="investhryApp.scheduledVisits.detail.title">Scheduled Visits</span> {{vm.scheduledVisits.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.scheduledVisits.projectId">Project Id</span></dt><dd><span>{{vm.scheduledVisits.projectId}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.serviceId">Service Id</span></dt><dd><span>{{vm.scheduledVisits.serviceId}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.status">Status</span></dt><dd><span>{{vm.scheduledVisits.status}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.scheduledDate">Scheduled Date</span></dt><dd><span>{{vm.scheduledVisits.scheduledDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.assignedToOfficer">Assigned To Officer</span></dt><dd><span>{{vm.scheduledVisits.assignedToOfficer}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.assignedOfficerMail">Assigned Officer Mail</span></dt><dd><span>{{vm.scheduledVisits.assignedOfficerMail}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.officerContact">Officer Contact</span></dt><dd><span>{{vm.scheduledVisits.officerContact}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.userName">User Name</span></dt><dd><span>{{vm.scheduledVisits.userName}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.userEmail">User Email</span></dt><dd><span>{{vm.scheduledVisits.userEmail}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.userContact">User Contact</span></dt><dd><span>{{vm.scheduledVisits.userContact}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.cafPin">Caf Pin</span></dt><dd><span>{{vm.scheduledVisits.cafPin}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.serviceName">Service Name</span></dt><dd><span>{{vm.scheduledVisits.serviceName}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.businessEntity">Business Entity</span></dt><dd><span>{{vm.scheduledVisits.businessEntity}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.district">District</span></dt><dd><span>{{vm.scheduledVisits.district}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.departmentName">Department Name</span></dt><dd><span>{{vm.scheduledVisits.departmentName}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.ocDepartmentName">Oc Department Name</span></dt><dd><span>{{vm.scheduledVisits.ocDepartmentName}}</span></dd><dt><span data-translate="investhryApp.scheduledVisits.ocServiceId">Oc Service Id</span></dt><dd><span>{{vm.scheduledVisits.ocServiceId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="scheduled-visits-detail.edit({id:vm.scheduledVisits.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/scheduled-visits/scheduled-visits-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myScheduledVisitsLabel" data-translate="investhryApp.scheduledVisits.home.createOrEditLabel">Create or edit a Scheduled Visits</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.scheduledVisits.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.scheduledVisits.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.scheduledVisits.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.scheduledVisits.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.scheduledVisits.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.scheduledDate" for="field_scheduledDate">Scheduled Date</label><div class="input-group"><input id="field_scheduledDate" type="text" class="form-control" name="scheduledDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.scheduledVisits.scheduledDate" is-open="vm.datePickerOpenStatus.scheduledDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'scheduledDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.assignedToOfficer" for="field_assignedToOfficer">Assigned To Officer</label><input type="text" class="form-control" name="assignedToOfficer" id="field_assignedToOfficer" ng-model="vm.scheduledVisits.assignedToOfficer"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.assignedOfficerMail" for="field_assignedOfficerMail">Assigned Officer Mail</label><input type="text" class="form-control" name="assignedOfficerMail" id="field_assignedOfficerMail" ng-model="vm.scheduledVisits.assignedOfficerMail"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.officerContact" for="field_officerContact">Officer Contact</label><input type="text" class="form-control" name="officerContact" id="field_officerContact" ng-model="vm.scheduledVisits.officerContact"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.userName" for="field_userName">User Name</label><input type="text" class="form-control" name="userName" id="field_userName" ng-model="vm.scheduledVisits.userName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.userEmail" for="field_userEmail">User Email</label><input type="text" class="form-control" name="userEmail" id="field_userEmail" ng-model="vm.scheduledVisits.userEmail"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.userContact" for="field_userContact">User Contact</label><input type="text" class="form-control" name="userContact" id="field_userContact" ng-model="vm.scheduledVisits.userContact"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.cafPin" for="field_cafPin">Caf Pin</label><input type="text" class="form-control" name="cafPin" id="field_cafPin" ng-model="vm.scheduledVisits.cafPin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.scheduledVisits.serviceName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.businessEntity" for="field_businessEntity">Business Entity</label><input type="text" class="form-control" name="businessEntity" id="field_businessEntity" ng-model="vm.scheduledVisits.businessEntity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.scheduledVisits.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.scheduledVisits.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.ocDepartmentName" for="field_ocDepartmentName">Oc Department Name</label><input type="text" class="form-control" name="ocDepartmentName" id="field_ocDepartmentName" ng-model="vm.scheduledVisits.ocDepartmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.scheduledVisits.ocServiceId" for="field_ocServiceId">Oc Service Id</label><input type="text" class="form-control" name="ocServiceId" id="field_ocServiceId" ng-model="vm.scheduledVisits.ocServiceId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/scheduled-visits/scheduled-visits.html','<div><h2 data-translate="investhryApp.scheduledVisits.home.title">Scheduled Visits</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="scheduled-visits.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.scheduledVisits.home.createLabel">Create new Scheduled Visits</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.scheduledVisits.projectId">Project Id</span></th><th><span data-translate="investhryApp.scheduledVisits.serviceId">Service Id</span></th><th><span data-translate="investhryApp.scheduledVisits.status">Status</span></th><th><span data-translate="investhryApp.scheduledVisits.scheduledDate">Scheduled Date</span></th><th><span data-translate="investhryApp.scheduledVisits.assignedToOfficer">Assigned To Officer</span></th><th><span data-translate="investhryApp.scheduledVisits.assignedOfficerMail">Assigned Officer Mail</span></th><th><span data-translate="investhryApp.scheduledVisits.officerContact">Officer Contact</span></th><th><span data-translate="investhryApp.scheduledVisits.userName">User Name</span></th><th><span data-translate="investhryApp.scheduledVisits.userEmail">User Email</span></th><th><span data-translate="investhryApp.scheduledVisits.userContact">User Contact</span></th><th><span data-translate="investhryApp.scheduledVisits.cafPin">Caf Pin</span></th><th><span data-translate="investhryApp.scheduledVisits.serviceName">Service Name</span></th><th><span data-translate="investhryApp.scheduledVisits.businessEntity">Business Entity</span></th><th><span data-translate="investhryApp.scheduledVisits.district">District</span></th><th><span data-translate="investhryApp.scheduledVisits.departmentName">Department Name</span></th><th><span data-translate="investhryApp.scheduledVisits.ocDepartmentName">Oc Department Name</span></th><th><span data-translate="investhryApp.scheduledVisits.ocServiceId">Oc Service Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="scheduledVisits in vm.scheduledVisits track by scheduledVisits.id"><td><a ui-sref="scheduled-visits-detail({id:scheduledVisits.id})">{{scheduledVisits.id}}</a></td><td>{{scheduledVisits.projectId}}</td><td>{{scheduledVisits.serviceId}}</td><td>{{scheduledVisits.status}}</td><td>{{scheduledVisits.scheduledDate | date:\'mediumDate\'}}</td><td>{{scheduledVisits.assignedToOfficer}}</td><td>{{scheduledVisits.assignedOfficerMail}}</td><td>{{scheduledVisits.officerContact}}</td><td>{{scheduledVisits.userName}}</td><td>{{scheduledVisits.userEmail}}</td><td>{{scheduledVisits.userContact}}</td><td>{{scheduledVisits.cafPin}}</td><td>{{scheduledVisits.serviceName}}</td><td>{{scheduledVisits.businessEntity}}</td><td>{{scheduledVisits.district}}</td><td>{{scheduledVisits.departmentName}}</td><td>{{scheduledVisits.ocDepartmentName}}</td><td>{{scheduledVisits.ocServiceId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="scheduled-visits-detail({id:scheduledVisits.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="scheduled-visits.edit({id:scheduledVisits.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="scheduled-visits.delete({id:scheduledVisits.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/sector/sector-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sector.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.sector.delete.question" translate-values="{id: \'{{vm.sector.id}}\'}">Are you sure you want to delete this Sector?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/sector/sector-detail.html','<div class="container"><h2><span data-translate="investhryApp.sector.detail.title">Sector</span> {{vm.sector.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.sector.sectortype">Sectortype</span></dt><dd><span>{{vm.sector.sectortype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="sector-detail.edit({id:vm.sector.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/sector/sector-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySectorLabel" data-translate="investhryApp.sector.home.createOrEditLabel">Create or edit a Sector</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sector.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sector.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.sector.sectortype" for="field_sectortype">Sectortype</label><input type="text" class="form-control" name="sectortype" id="field_sectortype" ng-model="vm.sector.sectortype" required><div ng-show="editForm.sectortype.$invalid"><p class="help-block" ng-show="editForm.sectortype.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/sector/sectors.html','<div class="container"><h2 data-translate="investhryApp.sector.home.title">Sectors</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="sector.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.sector.home.createLabel">Create new Sector</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.sector.sectortype">Sectortype</span></th><th></th></tr></thead><tbody><tr ng-repeat="sector in vm.sectors track by sector.id"><td><a ui-sref="sector-detail({id:sector.id})">{{sector.id}}</a></td><td>{{sector.sectortype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sector-detail({id:sector.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="sector.edit({id:sector.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="sector.delete({id:sector.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/service-dashboard-output/service-dashboard-output-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.service_dashboard_output.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.service_dashboard_output.delete.question" translate-values="{id: \'{{vm.service_dashboard_output.id}}\'}">Are you sure you want to delete this Service Dashboard Output?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/service-dashboard-output/service-dashboard-output-detail.html','<div><h2><span data-translate="investhryApp.service_dashboard_output.detail.title">Service Dashboard Output</span> {{vm.service_dashboard_output.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.service_dashboard_output.department_name">Department Name</span></dt><dd><span>{{vm.service_dashboard_output.department_name}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.service_name">Service Name</span></dt><dd><span>{{vm.service_dashboard_output.service_name}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.required">Required</span></dt><dd><span>{{vm.service_dashboard_output.required}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.applied">Applied</span></dt><dd><span>{{vm.service_dashboard_output.applied}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.pending_total">Pending Total</span></dt><dd><span>{{vm.service_dashboard_output.pending_total}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.pending_30days">Pending 30 Days</span></dt><dd><span>{{vm.service_dashboard_output.pending_30days}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.pending_45days">Pending 45 Days</span></dt><dd><span>{{vm.service_dashboard_output.pending_45days}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.cleared">Cleared</span></dt><dd><span>{{vm.service_dashboard_output.cleared}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.deactivated">Deactivated</span></dt><dd><span>{{vm.service_dashboard_output.deactivated}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.deemed_cleared">Deemed Cleared</span></dt><dd><span>{{vm.service_dashboard_output.deemed_cleared}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.rejected">Rejected</span></dt><dd><span>{{vm.service_dashboard_output.rejected}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.service_id">Service Id</span></dt><dd><span>{{vm.service_dashboard_output.service_id}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.departmentorder">Departmentorder</span></dt><dd><span>{{vm.service_dashboard_output.departmentorder}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.pending_60days">Pending 60 Days</span></dt><dd><span>{{vm.service_dashboard_output.pending_60days}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.pending_75days">Pending 75 Days</span></dt><dd><span>{{vm.service_dashboard_output.pending_75days}}</span></dd><dt><span data-translate="investhryApp.service_dashboard_output.pending_90days">Pending 90 Days</span></dt><dd><span>{{vm.service_dashboard_output.pending_90days}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="service-dashboard-output-detail.edit({id:vm.service_dashboard_output.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/service-dashboard-output/service-dashboard-output-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myService_dashboard_outputLabel" data-translate="investhryApp.service_dashboard_output.home.createOrEditLabel">Create or edit a Service Dashboard Output</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.service_dashboard_output.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.service_dashboard_output.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.department_name" for="field_department_name">Department Name</label><input type="text" class="form-control" name="department_name" id="field_department_name" ng-model="vm.service_dashboard_output.department_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.service_name" for="field_service_name">Service Name</label><input type="text" class="form-control" name="service_name" id="field_service_name" ng-model="vm.service_dashboard_output.service_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.required" for="field_required">Required</label><input type="text" class="form-control" name="required" id="field_required" ng-model="vm.service_dashboard_output.required"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.applied" for="field_applied">Applied</label><input type="text" class="form-control" name="applied" id="field_applied" ng-model="vm.service_dashboard_output.applied"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.pending_total" for="field_pending_total">Pending Total</label><input type="text" class="form-control" name="pending_total" id="field_pending_total" ng-model="vm.service_dashboard_output.pending_total"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.pending_30days" for="field_pending_30days">Pending 30 Days</label><input type="text" class="form-control" name="pending_30days" id="field_pending_30days" ng-model="vm.service_dashboard_output.pending_30days"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.pending_45days" for="field_pending_45days">Pending 45 Days</label><input type="text" class="form-control" name="pending_45days" id="field_pending_45days" ng-model="vm.service_dashboard_output.pending_45days"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.cleared" for="field_cleared">Cleared</label><input type="text" class="form-control" name="cleared" id="field_cleared" ng-model="vm.service_dashboard_output.cleared"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.deactivated" for="field_deactivated">Deactivated</label><input type="text" class="form-control" name="deactivated" id="field_deactivated" ng-model="vm.service_dashboard_output.deactivated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.deemed_cleared" for="field_deemed_cleared">Deemed Cleared</label><input type="text" class="form-control" name="deemed_cleared" id="field_deemed_cleared" ng-model="vm.service_dashboard_output.deemed_cleared"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.rejected" for="field_rejected">Rejected</label><input type="text" class="form-control" name="rejected" id="field_rejected" ng-model="vm.service_dashboard_output.rejected"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.service_id" for="field_service_id">Service Id</label><input type="text" class="form-control" name="service_id" id="field_service_id" ng-model="vm.service_dashboard_output.service_id"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.departmentorder" for="field_departmentorder">Departmentorder</label><input type="number" class="form-control" name="departmentorder" id="field_departmentorder" ng-model="vm.service_dashboard_output.departmentorder"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.pending_60days" for="field_pending_60days">Pending 60 Days</label><input type="text" class="form-control" name="pending_60days" id="field_pending_60days" ng-model="vm.service_dashboard_output.pending_60days"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.pending_75days" for="field_pending_75days">Pending 75 Days</label><input type="text" class="form-control" name="pending_75days" id="field_pending_75days" ng-model="vm.service_dashboard_output.pending_75days"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.service_dashboard_output.pending_90days" for="field_pending_90days">Pending 90 Days</label><input type="text" class="form-control" name="pending_90days" id="field_pending_90days" ng-model="vm.service_dashboard_output.pending_90days"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/service-dashboard-output/service-dashboard-outputs.html','<div><h2 data-translate="investhryApp.service_dashboard_output.home.title">Service Dashboard Outputs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="service-dashboard-output.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.service_dashboard_output.home.createLabel">Create new Service Dashboard Output</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.service_dashboard_output.department_name">Department Name</span></th><th><span data-translate="investhryApp.service_dashboard_output.service_name">Service Name</span></th><th><span data-translate="investhryApp.service_dashboard_output.required">Required</span></th><th><span data-translate="investhryApp.service_dashboard_output.applied">Applied</span></th><th><span data-translate="investhryApp.service_dashboard_output.pending_total">Pending Total</span></th><th><span data-translate="investhryApp.service_dashboard_output.pending_30days">Pending 30 Days</span></th><th><span data-translate="investhryApp.service_dashboard_output.pending_45days">Pending 45 Days</span></th><th><span data-translate="investhryApp.service_dashboard_output.cleared">Cleared</span></th><th><span data-translate="investhryApp.service_dashboard_output.deactivated">Deactivated</span></th><th><span data-translate="investhryApp.service_dashboard_output.deemed_cleared">Deemed Cleared</span></th><th><span data-translate="investhryApp.service_dashboard_output.rejected">Rejected</span></th><th><span data-translate="investhryApp.service_dashboard_output.service_id">Service Id</span></th><th><span data-translate="investhryApp.service_dashboard_output.departmentorder">Departmentorder</span></th><th><span data-translate="investhryApp.service_dashboard_output.pending_60days">Pending 60 Days</span></th><th><span data-translate="investhryApp.service_dashboard_output.pending_75days">Pending 75 Days</span></th><th><span data-translate="investhryApp.service_dashboard_output.pending_90days">Pending 90 Days</span></th><th></th></tr></thead><tbody><tr ng-repeat="service_dashboard_output in vm.service_dashboard_outputs track by service_dashboard_output.id"><td><a ui-sref="service-dashboard-output-detail({id:service_dashboard_output.id})">{{service_dashboard_output.id}}</a></td><td>{{service_dashboard_output.department_name}}</td><td>{{service_dashboard_output.service_name}}</td><td>{{service_dashboard_output.required}}</td><td>{{service_dashboard_output.applied}}</td><td>{{service_dashboard_output.pending_total}}</td><td>{{service_dashboard_output.pending_30days}}</td><td>{{service_dashboard_output.pending_45days}}</td><td>{{service_dashboard_output.cleared}}</td><td>{{service_dashboard_output.deactivated}}</td><td>{{service_dashboard_output.deemed_cleared}}</td><td>{{service_dashboard_output.rejected}}</td><td>{{service_dashboard_output.service_id}}</td><td>{{service_dashboard_output.departmentorder}}</td><td>{{service_dashboard_output.pending_60days}}</td><td>{{service_dashboard_output.pending_75days}}</td><td>{{service_dashboard_output.pending_90days}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="service-dashboard-output-detail({id:service_dashboard_output.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="service-dashboard-output.edit({id:service_dashboard_output.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="service-dashboard-output.delete({id:service_dashboard_output.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/service-dashboard-stats/service-dashboard-stats-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.serviceDashboardStats.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.serviceDashboardStats.delete.question" translate-values="{id: \'{{vm.serviceDashboardStats.id}}\'}">Are you sure you want to delete this Service Dashboard Stats?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/service-dashboard-stats/service-dashboard-stats-detail.html','<div><h2><span data-translate="investhryApp.serviceDashboardStats.detail.title">Service Dashboard Stats</span> {{vm.serviceDashboardStats.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.serviceDashboardStats.department_name">Department Name</span></dt><dd><span>{{vm.serviceDashboardStats.department_name}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.service_name">Service Name</span></dt><dd><span>{{vm.serviceDashboardStats.service_name}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.required">Required</span></dt><dd><span>{{vm.serviceDashboardStats.required}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.applied">Applied</span></dt><dd><span>{{vm.serviceDashboardStats.applied}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.pending_total">Pending Total</span></dt><dd><span>{{vm.serviceDashboardStats.pending_total}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.pending_30days">Pending 30 Days</span></dt><dd><span>{{vm.serviceDashboardStats.pending_30days}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.pending_45days">Pending 45 Days</span></dt><dd><span>{{vm.serviceDashboardStats.pending_45days}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.cleared">Cleared</span></dt><dd><span>{{vm.serviceDashboardStats.cleared}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.deactivated">Deactivated</span></dt><dd><span>{{vm.serviceDashboardStats.deactivated}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.deemed_cleared">Deemed Cleared</span></dt><dd><span>{{vm.serviceDashboardStats.deemed_cleared}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.rejected">Rejected</span></dt><dd><span>{{vm.serviceDashboardStats.rejected}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.service_id">Service Id</span></dt><dd><span>{{vm.serviceDashboardStats.service_id}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.departmentorder">Departmentorder</span></dt><dd><span>{{vm.serviceDashboardStats.departmentorder}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.pending_60days">Pending 60 Days</span></dt><dd><span>{{vm.serviceDashboardStats.pending_60days}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.pending_75days">Pending 75 Days</span></dt><dd><span>{{vm.serviceDashboardStats.pending_75days}}</span></dd><dt><span data-translate="investhryApp.serviceDashboardStats.pending_90days">Pending 90 Days</span></dt><dd><span>{{vm.serviceDashboardStats.pending_90days}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="service-dashboard-stats-detail.edit({id:vm.serviceDashboardStats.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/service-dashboard-stats/service-dashboard-stats-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myServiceDashboardStatsLabel" data-translate="investhryApp.serviceDashboardStats.home.createOrEditLabel">Create or edit a Service Dashboard Stats</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.serviceDashboardStats.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.serviceDashboardStats.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.department_name" for="field_department_name">Department Name</label><input type="text" class="form-control" name="department_name" id="field_department_name" ng-model="vm.serviceDashboardStats.department_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.service_name" for="field_service_name">Service Name</label><input type="text" class="form-control" name="service_name" id="field_service_name" ng-model="vm.serviceDashboardStats.service_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.required" for="field_required">Required</label><input type="text" class="form-control" name="required" id="field_required" ng-model="vm.serviceDashboardStats.required"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.applied" for="field_applied">Applied</label><input type="text" class="form-control" name="applied" id="field_applied" ng-model="vm.serviceDashboardStats.applied"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.pending_total" for="field_pending_total">Pending Total</label><input type="text" class="form-control" name="pending_total" id="field_pending_total" ng-model="vm.serviceDashboardStats.pending_total"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.pending_30days" for="field_pending_30days">Pending 30 Days</label><input type="text" class="form-control" name="pending_30days" id="field_pending_30days" ng-model="vm.serviceDashboardStats.pending_30days"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.pending_45days" for="field_pending_45days">Pending 45 Days</label><input type="text" class="form-control" name="pending_45days" id="field_pending_45days" ng-model="vm.serviceDashboardStats.pending_45days"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.cleared" for="field_cleared">Cleared</label><input type="text" class="form-control" name="cleared" id="field_cleared" ng-model="vm.serviceDashboardStats.cleared"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.deactivated" for="field_deactivated">Deactivated</label><input type="text" class="form-control" name="deactivated" id="field_deactivated" ng-model="vm.serviceDashboardStats.deactivated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.deemed_cleared" for="field_deemed_cleared">Deemed Cleared</label><input type="text" class="form-control" name="deemed_cleared" id="field_deemed_cleared" ng-model="vm.serviceDashboardStats.deemed_cleared"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.rejected" for="field_rejected">Rejected</label><input type="text" class="form-control" name="rejected" id="field_rejected" ng-model="vm.serviceDashboardStats.rejected"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.service_id" for="field_service_id">Service Id</label><input type="text" class="form-control" name="service_id" id="field_service_id" ng-model="vm.serviceDashboardStats.service_id"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.departmentorder" for="field_departmentorder">Departmentorder</label><input type="number" class="form-control" name="departmentorder" id="field_departmentorder" ng-model="vm.serviceDashboardStats.departmentorder"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.pending_60days" for="field_pending_60days">Pending 60 Days</label><input type="text" class="form-control" name="pending_60days" id="field_pending_60days" ng-model="vm.serviceDashboardStats.pending_60days"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.pending_75days" for="field_pending_75days">Pending 75 Days</label><input type="text" class="form-control" name="pending_75days" id="field_pending_75days" ng-model="vm.serviceDashboardStats.pending_75days"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceDashboardStats.pending_90days" for="field_pending_90days">Pending 90 Days</label><input type="text" class="form-control" name="pending_90days" id="field_pending_90days" ng-model="vm.serviceDashboardStats.pending_90days"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/service-dashboard-stats/service-dashboard-stats.html','<div><h2 data-translate="investhryApp.serviceDashboardStats.home.title">Service Dashboard Stats</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="service-dashboard-stats.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.serviceDashboardStats.home.createLabel">Create new Service Dashboard Stats</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.serviceDashboardStats.department_name">Department Name</span></th><th><span data-translate="investhryApp.serviceDashboardStats.service_name">Service Name</span></th><th><span data-translate="investhryApp.serviceDashboardStats.required">Required</span></th><th><span data-translate="investhryApp.serviceDashboardStats.applied">Applied</span></th><th><span data-translate="investhryApp.serviceDashboardStats.pending_total">Pending Total</span></th><th><span data-translate="investhryApp.serviceDashboardStats.pending_30days">Pending 30 Days</span></th><th><span data-translate="investhryApp.serviceDashboardStats.pending_45days">Pending 45 Days</span></th><th><span data-translate="investhryApp.serviceDashboardStats.cleared">Cleared</span></th><th><span data-translate="investhryApp.serviceDashboardStats.deactivated">Deactivated</span></th><th><span data-translate="investhryApp.serviceDashboardStats.deemed_cleared">Deemed Cleared</span></th><th><span data-translate="investhryApp.serviceDashboardStats.rejected">Rejected</span></th><th><span data-translate="investhryApp.serviceDashboardStats.service_id">Service Id</span></th><th><span data-translate="investhryApp.serviceDashboardStats.departmentorder">Departmentorder</span></th><th><span data-translate="investhryApp.serviceDashboardStats.pending_60days">Pending 60 Days</span></th><th><span data-translate="investhryApp.serviceDashboardStats.pending_75days">Pending 75 Days</span></th><th><span data-translate="investhryApp.serviceDashboardStats.pending_90days">Pending 90 Days</span></th><th></th></tr></thead><tbody><tr ng-repeat="serviceDashboardStats in vm.serviceDashboardStats track by serviceDashboardStats.id"><td><a ui-sref="service-dashboard-stats-detail({id:serviceDashboardStats.id})">{{serviceDashboardStats.id}}</a></td><td>{{serviceDashboardStats.department_name}}</td><td>{{serviceDashboardStats.service_name}}</td><td>{{serviceDashboardStats.required}}</td><td>{{serviceDashboardStats.applied}}</td><td>{{serviceDashboardStats.pending_total}}</td><td>{{serviceDashboardStats.pending_30days}}</td><td>{{serviceDashboardStats.pending_45days}}</td><td>{{serviceDashboardStats.cleared}}</td><td>{{serviceDashboardStats.deactivated}}</td><td>{{serviceDashboardStats.deemed_cleared}}</td><td>{{serviceDashboardStats.rejected}}</td><td>{{serviceDashboardStats.service_id}}</td><td>{{serviceDashboardStats.departmentorder}}</td><td>{{serviceDashboardStats.pending_60days}}</td><td>{{serviceDashboardStats.pending_75days}}</td><td>{{serviceDashboardStats.pending_90days}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="service-dashboard-stats-detail({id:serviceDashboardStats.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="service-dashboard-stats.edit({id:serviceDashboardStats.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="service-dashboard-stats.delete({id:serviceDashboardStats.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/service-form-attachments/service-form-attachments-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.serviceFormAttachments.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.serviceFormAttachments.delete.question" translate-values="{id: \'{{vm.serviceFormAttachments.id}}\'}">Are you sure you want to delete this Service Form Attachments?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/service-form-attachments/service-form-attachments-detail.html','<div><h2><span data-translate="investhryApp.serviceFormAttachments.detail.title">Service Form Attachments</span> {{vm.serviceFormAttachments.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.serviceFormAttachments.description">Description</span></dt><dd><span>{{vm.serviceFormAttachments.description}}</span></dd><dt><span data-translate="investhryApp.serviceFormAttachments.clientfilename">Clientfilename</span></dt><dd><span>{{vm.serviceFormAttachments.clientfilename}}</span></dd><dt><span data-translate="investhryApp.serviceFormAttachments.serviceID">Service ID</span></dt><dd><span>{{vm.serviceFormAttachments.serviceID}}</span></dd><dt><span data-translate="investhryApp.serviceFormAttachments.projectID">Project ID</span></dt><dd><span>{{vm.serviceFormAttachments.projectID}}</span></dd><dt><span data-translate="investhryApp.serviceFormAttachments.serverfilename">Serverfilename</span></dt><dd><span>{{vm.serviceFormAttachments.serverfilename}}</span></dd><dt><span data-translate="investhryApp.serviceFormAttachments.downloadfilename">Downloadfilename</span></dt><dd><span>{{vm.serviceFormAttachments.downloadfilename}}</span></dd><dt><span data-translate="investhryApp.serviceFormAttachments.isSaved">Is Saved</span></dt><dd><span>{{vm.serviceFormAttachments.isSaved}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="service-form-attachments-detail.edit({id:vm.serviceFormAttachments.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/service-form-attachments/service-form-attachments-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myServiceFormAttachmentsLabel" data-translate="investhryApp.serviceFormAttachments.home.createOrEditLabel">Create or edit a Service Form Attachments</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.serviceFormAttachments.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.serviceFormAttachments.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormAttachments.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.serviceFormAttachments.description" required><div ng-show="editForm.description.$invalid"><p class="help-block" ng-show="editForm.description.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormAttachments.clientfilename" for="field_clientfilename">Clientfilename</label><input type="text" class="form-control" name="clientfilename" id="field_clientfilename" ng-model="vm.serviceFormAttachments.clientfilename" required><div ng-show="editForm.clientfilename.$invalid"><p class="help-block" ng-show="editForm.clientfilename.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormAttachments.serviceID" for="field_serviceID">Service ID</label><input type="text" class="form-control" name="serviceID" id="field_serviceID" ng-model="vm.serviceFormAttachments.serviceID"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormAttachments.projectID" for="field_projectID">Project ID</label><input type="text" class="form-control" name="projectID" id="field_projectID" ng-model="vm.serviceFormAttachments.projectID"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormAttachments.serverfilename" for="field_serverfilename">Serverfilename</label><input type="text" class="form-control" name="serverfilename" id="field_serverfilename" ng-model="vm.serviceFormAttachments.serverfilename"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormAttachments.downloadfilename" for="field_downloadfilename">Downloadfilename</label><input type="text" class="form-control" name="downloadfilename" id="field_downloadfilename" ng-model="vm.serviceFormAttachments.downloadfilename"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormAttachments.isSaved" for="field_isSaved">Is Saved</label><input type="checkbox" name="isSaved" id="field_isSaved" ng-model="vm.serviceFormAttachments.isSaved"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/service-form-attachments/service-form-attachments.html','<div><h2 data-translate="investhryApp.serviceFormAttachments.home.title">Service Form Attachments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="service-form-attachments.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.serviceFormAttachments.home.createLabel">Create new Service Form Attachments</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.serviceFormAttachments.description">Description</span></th><th><span data-translate="investhryApp.serviceFormAttachments.clientfilename">Clientfilename</span></th><th><span data-translate="investhryApp.serviceFormAttachments.serviceID">Service ID</span></th><th><span data-translate="investhryApp.serviceFormAttachments.projectID">Project ID</span></th><th><span data-translate="investhryApp.serviceFormAttachments.serverfilename">Serverfilename</span></th><th><span data-translate="investhryApp.serviceFormAttachments.downloadfilename">Downloadfilename</span></th><th><span data-translate="investhryApp.serviceFormAttachments.isSaved">Is Saved</span></th><th></th></tr></thead><tbody><tr ng-repeat="serviceFormAttachments in vm.serviceFormAttachments track by serviceFormAttachments.id"><td><a ui-sref="service-form-attachments-detail({id:serviceFormAttachments.id})">{{serviceFormAttachments.id}}</a></td><td>{{serviceFormAttachments.description}}</td><td>{{serviceFormAttachments.clientfilename}}</td><td>{{serviceFormAttachments.serviceID}}</td><td>{{serviceFormAttachments.projectID}}</td><td>{{serviceFormAttachments.serverfilename}}</td><td>{{serviceFormAttachments.downloadfilename}}</td><td>{{serviceFormAttachments.isSaved}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="service-form-attachments-detail({id:serviceFormAttachments.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="service-form-attachments.edit({id:serviceFormAttachments.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="service-form-attachments.delete({id:serviceFormAttachments.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/service-form-field/service-form-field-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.serviceFormField.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.serviceFormField.delete.question" translate-values="{id: \'{{vm.serviceFormField.id}}\'}">Are you sure you want to delete this Service Form Field?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/service-form-field/service-form-field-detail.html','<div><h2><span data-translate="investhryApp.serviceFormField.detail.title">Service Form Field</span> {{vm.serviceFormField.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.serviceFormField.fieldName">Field Name</span></dt><dd><span>{{vm.serviceFormField.fieldName}}</span></dd><dt><span data-translate="investhryApp.serviceFormField.fieldType">Field Type</span></dt><dd><span>{{vm.serviceFormField.fieldType}}</span></dd><dt><span data-translate="investhryApp.serviceFormField.serviceID">Service ID</span></dt><dd><span>{{vm.serviceFormField.serviceID}}</span></dd><dt><span data-translate="investhryApp.serviceFormField.fieldTypeOption">Field Type Option</span></dt><dd><span>{{vm.serviceFormField.fieldTypeOption}}</span></dd><dt><span data-translate="investhryApp.serviceFormField.fieldRenderingOrder">Field Rendering Order</span></dt><dd><span>{{vm.serviceFormField.fieldRenderingOrder}}</span></dd><dt><span data-translate="investhryApp.serviceFormField.autofillflag">Autofillflag</span></dt><dd><span>{{vm.serviceFormField.autofillflag}}</span></dd><dt><span data-translate="investhryApp.serviceFormField.isRequired">Is Required</span></dt><dd><span>{{vm.serviceFormField.isRequired}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="service-form-field-detail.edit({id:vm.serviceFormField.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/service-form-field/service-form-field-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myServiceFormFieldLabel" data-translate="investhryApp.serviceFormField.home.createOrEditLabel">Create or edit a Service Form Field</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.serviceFormField.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.serviceFormField.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormField.fieldName" for="field_fieldName">Field Name</label><input type="text" class="form-control" name="fieldName" id="field_fieldName" ng-model="vm.serviceFormField.fieldName" required><div ng-show="editForm.fieldName.$invalid"><p class="help-block" ng-show="editForm.fieldName.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormField.fieldType" for="field_fieldType">Field Type</label><input type="text" class="form-control" name="fieldType" id="field_fieldType" ng-model="vm.serviceFormField.fieldType" required><div ng-show="editForm.fieldType.$invalid"><p class="help-block" ng-show="editForm.fieldType.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormField.serviceID" for="field_serviceID">Service ID</label><input type="text" class="form-control" name="serviceID" id="field_serviceID" ng-model="vm.serviceFormField.serviceID" required><div ng-show="editForm.serviceID.$invalid"><p class="help-block" ng-show="editForm.serviceID.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormField.fieldTypeOption" for="field_fieldTypeOption">Field Type Option</label><input type="text" class="form-control" name="fieldTypeOption" id="field_fieldTypeOption" ng-model="vm.serviceFormField.fieldTypeOption"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormField.fieldRenderingOrder" for="field_fieldRenderingOrder">Field Rendering Order</label><input type="number" class="form-control" name="fieldRenderingOrder" id="field_fieldRenderingOrder" ng-model="vm.serviceFormField.fieldRenderingOrder"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormField.autofillflag" for="field_autofillflag">Autofillflag</label><input type="text" class="form-control" name="autofillflag" id="field_autofillflag" ng-model="vm.serviceFormField.autofillflag"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceFormField.isRequired" for="field_isRequired">Is Required</label><input type="checkbox" class="form-control" name="isRequired" id="field_isRequired" ng-model="vm.serviceFormField.isRequired"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/service-form-field/service-form-fields.html','<div><h2 data-translate="investhryApp.serviceFormField.home.title">Service Form Fields</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="service-form-field.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.serviceFormField.home.createLabel">Create new Service Form Field</span></button></div></div><div class="row"><br><div class="col-lg-1"><label class="control-label">Service Name *</label></div><div class="col-lg-4"><select class="form-control" ng-model="selectedservice" ng-options="departmentService.serviceName for departmentService in vm.departmentServices" ng-change="vm.updateDepartmentName()"></select></div><div class="col-lg-7"><label class="control-label pull-left" ng-show="vm.selectedservicedepartment">Department : {{vm.selectedservicedepartment}}</label></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.serviceFormField.fieldName">Field Name</span></th><th><span data-translate="investhryApp.serviceFormField.fieldType">Field Type</span></th><th><span data-translate="investhryApp.serviceFormField.serviceID">Service ID</span></th><th><span data-translate="investhryApp.serviceFormField.fieldTypeOption">Field Type Option</span></th><th><span data-translate="investhryApp.serviceFormField.fieldRenderingOrder">Field Rendering Order</span></th><th><span data-translate="investhryApp.serviceFormField.autofillflag">Autofillflag</span></th><th></th></tr></thead><tbody><tr ng-repeat="serviceFormField in vm.serviceFormFields | orderBy: \'fieldRenderingOrder\'"><td><a ui-sref="service-form-field-detail({id:serviceFormField.id})">{{serviceFormField.id}}</a></td><td>{{serviceFormField.fieldName}}</td><td>{{serviceFormField.fieldType}}</td><td>{{serviceFormField.serviceID}}</td><td>{{serviceFormField.fieldTypeOption}}</td><td>{{serviceFormField.fieldRenderingOrder}}</td><td>{{serviceFormField.autofillflag}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="service-form-field-detail({id:serviceFormField.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="service-form-field.edit({id:serviceFormField.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="service-form-field.delete({id:serviceFormField.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/service-level/service-level-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.serviceLevel.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.serviceLevel.delete.question" translate-values="{id: \'{{vm.serviceLevel.id}}\'}">Are you sure you want to delete this Service Level?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/service-level/service-level-detail.html','<div><h2><span data-translate="investhryApp.serviceLevel.detail.title">Service Level</span> {{vm.serviceLevel.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.serviceLevel.serviceId">Service Id</span></dt><dd><span>{{vm.serviceLevel.serviceId}}</span></dd><dt><span data-translate="investhryApp.serviceLevel.serviceName">Service Name</span></dt><dd><span>{{vm.serviceLevel.serviceName}}</span></dd><dt><span data-translate="investhryApp.serviceLevel.departmentName">Department Name</span></dt><dd><span>{{vm.serviceLevel.departmentName}}</span></dd><dt><span data-translate="investhryApp.serviceLevel.levelDescription">Level Description</span></dt><dd><span>{{vm.serviceLevel.levelDescription}}</span></dd><dt><span data-translate="investhryApp.serviceLevel.level">Level</span></dt><dd><span>{{vm.serviceLevel.level}}</span></dd><dt><span data-translate="investhryApp.serviceLevel.departmentId">Department Id</span></dt><dd><span>{{vm.serviceLevel.departmentId}}</span></dd><dt><span data-translate="investhryApp.serviceLevel.projectLevel">Project Level</span></dt><dd><span>{{vm.serviceLevel.projectLevel}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="service-level-detail.edit({id:vm.serviceLevel.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/service-level/service-level-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myServiceLevelLabel" data-translate="investhryApp.serviceLevel.home.createOrEditLabel">Create or edit a Service Level</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.serviceLevel.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.serviceLevel.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceLevel.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.serviceLevel.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceLevel.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.serviceLevel.serviceName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceLevel.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.serviceLevel.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceLevel.levelDescription" for="field_levelDescription">Level Description</label><input type="text" class="form-control" name="levelDescription" id="field_levelDescription" ng-model="vm.serviceLevel.levelDescription"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceLevel.level" for="field_level">Level</label><input type="number" class="form-control" name="level" id="field_level" ng-model="vm.serviceLevel.level"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceLevel.departmentId" for="field_departmentId">Department Id</label><input type="text" class="form-control" name="departmentId" id="field_departmentId" ng-model="vm.serviceLevel.departmentId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceLevel.projectLevel" for="field_projectLevel">Project Level</label><input type="text" class="form-control" name="projectLevel" id="field_projectLevel" ng-model="vm.serviceLevel.projectLevel"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/service-level/service-levels.html','<div><h2 data-translate="investhryApp.serviceLevel.home.title">Service Levels</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="service-level.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.serviceLevel.home.createLabel">Create new Service Level</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.serviceLevel.serviceId">Service Id</span></th><th><span data-translate="investhryApp.serviceLevel.serviceName">Service Name</span></th><th><span data-translate="investhryApp.serviceLevel.departmentName">Department Name</span></th><th><span data-translate="investhryApp.serviceLevel.levelDescription">Level Description</span></th><th><span data-translate="investhryApp.serviceLevel.level">Level</span></th><th><span data-translate="investhryApp.serviceLevel.departmentId">Department Id</span></th><th><span data-translate="investhryApp.serviceLevel.projectLevel">Project Level</span></th><th></th></tr></thead><tbody><tr ng-repeat="serviceLevel in vm.serviceLevels track by serviceLevel.id"><td><a ui-sref="service-level-detail({id:serviceLevel.id})">{{serviceLevel.id}}</a></td><td>{{serviceLevel.serviceId}}</td><td>{{serviceLevel.serviceName}}</td><td>{{serviceLevel.departmentName}}</td><td>{{serviceLevel.levelDescription}}</td><td>{{serviceLevel.level}}</td><td>{{serviceLevel.departmentId}}</td><td>{{serviceLevel.projectLevel}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="service-level-detail({id:serviceLevel.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="service-level.edit({id:serviceLevel.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="service-level.delete({id:serviceLevel.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/service-status/service-status-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.serviceStatus.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.serviceStatus.delete.question" translate-values="{id: \'{{vm.serviceStatus.id}}\'}">Are you sure you want to delete this Service Status?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/service-status/service-status-detail.html','<div><h2><span data-translate="investhryApp.serviceStatus.detail.title">Service Status</span> {{vm.serviceStatus.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.serviceStatus.cafPin">Caf Pin</span></dt><dd><span>{{vm.serviceStatus.cafPin}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.projectId">Project Id</span></dt><dd><span>{{vm.serviceStatus.projectId}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.serviceId">Service Id</span></dt><dd><span>{{vm.serviceStatus.serviceId}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.serviceName">Service Name</span></dt><dd><span>{{vm.serviceStatus.serviceName}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level1">Level 1</span></dt><dd><span>{{vm.serviceStatus.level1}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level2">Level 2</span></dt><dd><span>{{vm.serviceStatus.level2}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level3">Level 3</span></dt><dd><span>{{vm.serviceStatus.level3}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level4">Level 4</span></dt><dd><span>{{vm.serviceStatus.level4}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level5">Level 5</span></dt><dd><span>{{vm.serviceStatus.level5}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level6">Level 6</span></dt><dd><span>{{vm.serviceStatus.level6}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level7">Level 7</span></dt><dd><span>{{vm.serviceStatus.level7}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level8">Level 8</span></dt><dd><span>{{vm.serviceStatus.level8}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level9">Level 9</span></dt><dd><span>{{vm.serviceStatus.level9}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level10">Level 10</span></dt><dd><span>{{vm.serviceStatus.level10}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.reApplyCounter">Re Apply Counter</span></dt><dd><span>{{vm.serviceStatus.reApplyCounter}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.percentageCompleted">Percentage Completed</span></dt><dd><span>{{vm.serviceStatus.percentageCompleted}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.departmentName">Department Name</span></dt><dd><span>{{vm.serviceStatus.departmentName}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.previousLevel">Previous Level</span></dt><dd><span>{{vm.serviceStatus.previousLevel}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.projectLevel">Project Level</span></dt><dd><span>{{vm.serviceStatus.projectLevel}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level0">Level 0</span></dt><dd><span>{{vm.serviceStatus.level0}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level1Date">Level 1 Date</span></dt><dd><span>{{vm.serviceStatus.level1Date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level2Date">Level 2 Date</span></dt><dd><span>{{vm.serviceStatus.level2Date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level3Date">Level 3 Date</span></dt><dd><span>{{vm.serviceStatus.level3Date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level4Date">Level 4 Date</span></dt><dd><span>{{vm.serviceStatus.level4Date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level5Date">Level 5 Date</span></dt><dd><span>{{vm.serviceStatus.level5Date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level6Date">Level 6 Date</span></dt><dd><span>{{vm.serviceStatus.level6Date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level7Date">Level 7 Date</span></dt><dd><span>{{vm.serviceStatus.level7Date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level8Date">Level 8 Date</span></dt><dd><span>{{vm.serviceStatus.level8Date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level9Date">Level 9 Date</span></dt><dd><span>{{vm.serviceStatus.level9Date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level10Date">Level 10 Date</span></dt><dd><span>{{vm.serviceStatus.level10Date | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.serviceStatus.level0Date">Level 0 Date</span></dt><dd><span>{{vm.serviceStatus.level0Date | date:\'mediumDate\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="service-status-detail.edit({id:vm.serviceStatus.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/service-status/service-status-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myServiceStatusLabel" data-translate="investhryApp.serviceStatus.home.createOrEditLabel">Create or edit a Service Status</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.serviceStatus.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.serviceStatus.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.cafPin" for="field_cafPin">Caf Pin</label><input type="text" class="form-control" name="cafPin" id="field_cafPin" ng-model="vm.serviceStatus.cafPin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.serviceStatus.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.serviceStatus.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.serviceName" for="field_serviceName">Service Name</label><input type="text" class="form-control" name="serviceName" id="field_serviceName" ng-model="vm.serviceStatus.serviceName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level1" for="field_level1">Level 1</label><input type="text" class="form-control" name="level1" id="field_level1" ng-model="vm.serviceStatus.level1"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level2" for="field_level2">Level 2</label><input type="text" class="form-control" name="level2" id="field_level2" ng-model="vm.serviceStatus.level2"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level3" for="field_level3">Level 3</label><input type="text" class="form-control" name="level3" id="field_level3" ng-model="vm.serviceStatus.level3"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level4" for="field_level4">Level 4</label><input type="text" class="form-control" name="level4" id="field_level4" ng-model="vm.serviceStatus.level4"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level5" for="field_level5">Level 5</label><input type="text" class="form-control" name="level5" id="field_level5" ng-model="vm.serviceStatus.level5"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level6" for="field_level6">Level 6</label><input type="text" class="form-control" name="level6" id="field_level6" ng-model="vm.serviceStatus.level6"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level7" for="field_level7">Level 7</label><input type="text" class="form-control" name="level7" id="field_level7" ng-model="vm.serviceStatus.level7"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level8" for="field_level8">Level 8</label><input type="text" class="form-control" name="level8" id="field_level8" ng-model="vm.serviceStatus.level8"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level9" for="field_level9">Level 9</label><input type="text" class="form-control" name="level9" id="field_level9" ng-model="vm.serviceStatus.level9"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level10" for="field_level10">Level 10</label><input type="text" class="form-control" name="level10" id="field_level10" ng-model="vm.serviceStatus.level10"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.reApplyCounter" for="field_reApplyCounter">Re Apply Counter</label><input type="number" class="form-control" name="reApplyCounter" id="field_reApplyCounter" ng-model="vm.serviceStatus.reApplyCounter"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.percentageCompleted" for="field_percentageCompleted">Percentage Completed</label><input type="number" class="form-control" name="percentageCompleted" id="field_percentageCompleted" ng-model="vm.serviceStatus.percentageCompleted"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.serviceStatus.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.previousLevel" for="field_previousLevel">Previous Level</label><input type="number" class="form-control" name="previousLevel" id="field_previousLevel" ng-model="vm.serviceStatus.previousLevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.projectLevel" for="field_projectLevel">Project Level</label><input type="text" class="form-control" name="projectLevel" id="field_projectLevel" ng-model="vm.serviceStatus.projectLevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level0" for="field_level0">Level 0</label><input type="text" class="form-control" name="level0" id="field_level0" ng-model="vm.serviceStatus.level0"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level1Date" for="field_level1Date">Level 1 Date</label><div class="input-group"><input id="field_level1Date" type="text" class="form-control" name="level1Date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.serviceStatus.level1Date" is-open="vm.datePickerOpenStatus.level1Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'level1Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level2Date" for="field_level2Date">Level 2 Date</label><div class="input-group"><input id="field_level2Date" type="text" class="form-control" name="level2Date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.serviceStatus.level2Date" is-open="vm.datePickerOpenStatus.level2Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'level2Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level3Date" for="field_level3Date">Level 3 Date</label><div class="input-group"><input id="field_level3Date" type="text" class="form-control" name="level3Date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.serviceStatus.level3Date" is-open="vm.datePickerOpenStatus.level3Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'level3Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level4Date" for="field_level4Date">Level 4 Date</label><div class="input-group"><input id="field_level4Date" type="text" class="form-control" name="level4Date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.serviceStatus.level4Date" is-open="vm.datePickerOpenStatus.level4Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'level4Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level5Date" for="field_level5Date">Level 5 Date</label><div class="input-group"><input id="field_level5Date" type="text" class="form-control" name="level5Date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.serviceStatus.level5Date" is-open="vm.datePickerOpenStatus.level5Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'level5Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level6Date" for="field_level6Date">Level 6 Date</label><div class="input-group"><input id="field_level6Date" type="text" class="form-control" name="level6Date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.serviceStatus.level6Date" is-open="vm.datePickerOpenStatus.level6Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'level6Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level7Date" for="field_level7Date">Level 7 Date</label><div class="input-group"><input id="field_level7Date" type="text" class="form-control" name="level7Date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.serviceStatus.level7Date" is-open="vm.datePickerOpenStatus.level7Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'level7Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level8Date" for="field_level8Date">Level 8 Date</label><div class="input-group"><input id="field_level8Date" type="text" class="form-control" name="level8Date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.serviceStatus.level8Date" is-open="vm.datePickerOpenStatus.level8Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'level8Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level9Date" for="field_level9Date">Level 9 Date</label><div class="input-group"><input id="field_level9Date" type="text" class="form-control" name="level9Date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.serviceStatus.level9Date" is-open="vm.datePickerOpenStatus.level9Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'level9Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level10Date" for="field_level10Date">Level 10 Date</label><div class="input-group"><input id="field_level10Date" type="text" class="form-control" name="level10Date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.serviceStatus.level10Date" is-open="vm.datePickerOpenStatus.level10Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'level10Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceStatus.level0Date" for="field_level0Date">Level 0 Date</label><div class="input-group"><input id="field_level0Date" type="text" class="form-control" name="level0Date" uib-datepicker-popup="{{dateformat}}" ng-model="vm.serviceStatus.level0Date" is-open="vm.datePickerOpenStatus.level0Date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'level0Date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/service-status/service-statuses.html','<div><h2 data-translate="investhryApp.serviceStatus.home.title">Service Statuses</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="service-status.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.serviceStatus.home.createLabel">Create new Service Status</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.serviceStatus.cafPin">Caf Pin</span></th><th><span data-translate="investhryApp.serviceStatus.projectId">Project Id</span></th><th><span data-translate="investhryApp.serviceStatus.serviceId">Service Id</span></th><th><span data-translate="investhryApp.serviceStatus.serviceName">Service Name</span></th><th><span data-translate="investhryApp.serviceStatus.level1">Level 1</span></th><th><span data-translate="investhryApp.serviceStatus.level2">Level 2</span></th><th><span data-translate="investhryApp.serviceStatus.level3">Level 3</span></th><th><span data-translate="investhryApp.serviceStatus.level4">Level 4</span></th><th><span data-translate="investhryApp.serviceStatus.level5">Level 5</span></th><th><span data-translate="investhryApp.serviceStatus.level6">Level 6</span></th><th><span data-translate="investhryApp.serviceStatus.level7">Level 7</span></th><th><span data-translate="investhryApp.serviceStatus.level8">Level 8</span></th><th><span data-translate="investhryApp.serviceStatus.level9">Level 9</span></th><th><span data-translate="investhryApp.serviceStatus.level10">Level 10</span></th><th><span data-translate="investhryApp.serviceStatus.reApplyCounter">Re Apply Counter</span></th><th><span data-translate="investhryApp.serviceStatus.percentageCompleted">Percentage Completed</span></th><th><span data-translate="investhryApp.serviceStatus.departmentName">Department Name</span></th><th><span data-translate="investhryApp.serviceStatus.previousLevel">Previous Level</span></th><th><span data-translate="investhryApp.serviceStatus.projectLevel">Project Level</span></th><th><span data-translate="investhryApp.serviceStatus.level0">Level 0</span></th><th><span data-translate="investhryApp.serviceStatus.level1Date">Level 1 Date</span></th><th><span data-translate="investhryApp.serviceStatus.level2Date">Level 2 Date</span></th><th><span data-translate="investhryApp.serviceStatus.level3Date">Level 3 Date</span></th><th><span data-translate="investhryApp.serviceStatus.level4Date">Level 4 Date</span></th><th><span data-translate="investhryApp.serviceStatus.level5Date">Level 5 Date</span></th><th><span data-translate="investhryApp.serviceStatus.level6Date">Level 6 Date</span></th><th><span data-translate="investhryApp.serviceStatus.level7Date">Level 7 Date</span></th><th><span data-translate="investhryApp.serviceStatus.level8Date">Level 8 Date</span></th><th><span data-translate="investhryApp.serviceStatus.level9Date">Level 9 Date</span></th><th><span data-translate="investhryApp.serviceStatus.level10Date">Level 10 Date</span></th><th><span data-translate="investhryApp.serviceStatus.level0Date">Level 0 Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="serviceStatus in vm.serviceStatuses track by serviceStatus.id"><td><a ui-sref="service-status-detail({id:serviceStatus.id})">{{serviceStatus.id}}</a></td><td>{{serviceStatus.cafPin}}</td><td>{{serviceStatus.projectId}}</td><td>{{serviceStatus.serviceId}}</td><td>{{serviceStatus.serviceName}}</td><td>{{serviceStatus.level1}}</td><td>{{serviceStatus.level2}}</td><td>{{serviceStatus.level3}}</td><td>{{serviceStatus.level4}}</td><td>{{serviceStatus.level5}}</td><td>{{serviceStatus.level6}}</td><td>{{serviceStatus.level7}}</td><td>{{serviceStatus.level8}}</td><td>{{serviceStatus.level9}}</td><td>{{serviceStatus.level10}}</td><td>{{serviceStatus.reApplyCounter}}</td><td>{{serviceStatus.percentageCompleted}}</td><td>{{serviceStatus.departmentName}}</td><td>{{serviceStatus.previousLevel}}</td><td>{{serviceStatus.projectLevel}}</td><td>{{serviceStatus.level0}}</td><td>{{serviceStatus.level1Date | date:\'mediumDate\'}}</td><td>{{serviceStatus.level2Date | date:\'mediumDate\'}}</td><td>{{serviceStatus.level3Date | date:\'mediumDate\'}}</td><td>{{serviceStatus.level4Date | date:\'mediumDate\'}}</td><td>{{serviceStatus.level5Date | date:\'mediumDate\'}}</td><td>{{serviceStatus.level6Date | date:\'mediumDate\'}}</td><td>{{serviceStatus.level7Date | date:\'mediumDate\'}}</td><td>{{serviceStatus.level8Date | date:\'mediumDate\'}}</td><td>{{serviceStatus.level9Date | date:\'mediumDate\'}}</td><td>{{serviceStatus.level10Date | date:\'mediumDate\'}}</td><td>{{serviceStatus.level0Date | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="service-status-detail({id:serviceStatus.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="service-status.edit({id:serviceStatus.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="service-status.delete({id:serviceStatus.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/serviceformdocs/serviceformdocs-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.serviceformdocs.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.serviceformdocs.delete.question" translate-values="{id: \'{{vm.serviceformdocs.id}}\'}">Are you sure you want to delete this Serviceformdocs?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/serviceformdocs/serviceformdocs-detail.html','<div><h2><span data-translate="investhryApp.serviceformdocs.detail.title">Serviceformdocs</span> {{vm.serviceformdocs.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.serviceformdocs.serviceid">Serviceid</span></dt><dd><span>{{vm.serviceformdocs.serviceid}}</span></dd><dt><span data-translate="investhryApp.serviceformdocs.docname">Docname</span></dt><dd><span>{{vm.serviceformdocs.docname}}</span></dd><dt><span data-translate="investhryApp.serviceformdocs.docdescription">Docdescription</span></dt><dd><span>{{vm.serviceformdocs.docdescription}}</span></dd><dt><span data-translate="investhryApp.serviceformdocs.downloadfilename">Downloadfilename</span></dt><dd><span>{{vm.serviceformdocs.downloadfilename}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="serviceformdocs-detail.edit({id:vm.serviceformdocs.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/serviceformdocs/serviceformdocs-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myServiceformdocsLabel" data-translate="investhryApp.serviceformdocs.home.createOrEditLabel">Create or edit a Serviceformdocs</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.serviceformdocs.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.serviceformdocs.id" readonly="readonly"></div><div class="form-group"><label class="control-label">Service Name *</label><select class="form-control" ng-model="selectedservice" ng-options="departmentService.serviceName for departmentService in vm.departmentServices" ng-change="vm.updateDepartmentName()" required></select><label class="control-label pull-right" ng-show="vm.selectedservicedepartment">Department : {{vm.selectedservicedepartment}}</label></div><!--<div class="form-group">--><!--<label class="control-label" data-translate="investhryApp.serviceformdocs.serviceid" for="field_serviceid">Serviceid</label>--><!--<input type="text" class="form-control" name="serviceid" id="field_serviceid"--><!--ng-model="vm.serviceformdocs.serviceid"--><!--/>--><!--</div>--><div class="form-group"><label class="control-label" for="field_docname">Docname*</label><input type="text" class="form-control" name="docname" id="field_docname" maxlength="30" ng-model="vm.serviceformdocs.docname" required></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceformdocs.docdescription" for="field_docdescription">Docdescription</label><input type="text" class="form-control" name="docdescription" id="field_docdescription" ng-model="vm.serviceformdocs.docdescription"></div><div class="form-group"><label class="control-label">Select File *</label><input type="file" class="form-control" file-model="vm.servicedoc.file" accept=".xlsx,.xls,image/*,.doc, .docx,.ppt, .pptx,.txt,.pdf"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p><!--<input type="text" class="form-control" name="downloadfilename" id="field_downloadfilename"--><!--ng-model="vm.serviceformdocs.downloadfilename"--><!--/>--></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving || file.maxSizeError || vm.servicedoc.file==undefined" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/serviceformdocs/serviceformdocs.html','<div><h2 data-translate="investhryApp.serviceformdocs.home.title">Serviceformdocs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="serviceformdocs.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.serviceformdocs.home.createLabel">Create new Serviceformdocs</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.serviceformdocs.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.serviceformdocs.docname">Docname</span></th><th><span data-translate="investhryApp.serviceformdocs.docdescription">Docdescription</span></th><th><span data-translate="investhryApp.serviceformdocs.downloadfilename">Downloadfilename</span></th><th></th></tr></thead><tbody><tr ng-repeat="serviceformdocs in vm.serviceformdocs track by serviceformdocs.id"><td><a ui-sref="serviceformdocs-detail({id:serviceformdocs.id})">{{serviceformdocs.id}}</a></td><td>{{serviceformdocs.serviceid}}</td><td>{{serviceformdocs.docname}}</td><td>{{serviceformdocs.docdescription}}</td><td>{{serviceformdocs.downloadfilename}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><!--<button type="submit"--><!--ui-sref="serviceformdocs-detail({id:serviceformdocs.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="serviceformdocs.edit({id:serviceformdocs.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--> <button type="submit" ui-sref="serviceformdocs.delete({id:serviceformdocs.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/serviceformdraftsaved/serviceformdraftsaved-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.serviceformdraftsaved.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.serviceformdraftsaved.delete.question" translate-values="{id: \'{{vm.serviceformdraftsaved.id}}\'}">Are you sure you want to delete this Serviceformdraftsaved?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/serviceformdraftsaved/serviceformdraftsaved-detail.html','<div><h2><span data-translate="investhryApp.serviceformdraftsaved.detail.title">Serviceformdraftsaved</span> {{vm.serviceformdraftsaved.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.serviceformdraftsaved.draftsaved">Draftsaved</span></dt><dd><span>{{vm.serviceformdraftsaved.draftsaved}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="serviceformdraftsaved-detail.edit({id:vm.serviceformdraftsaved.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/serviceformdraftsaved/serviceformdraftsaved-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myServiceformdraftsavedLabel" data-translate="investhryApp.serviceformdraftsaved.home.createOrEditLabel">Create or edit a Serviceformdraftsaved</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.serviceformdraftsaved.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.serviceformdraftsaved.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.serviceformdraftsaved.draftsaved" for="field_draftsaved">Draftsaved</label><input type="checkbox" name="draftsaved" id="field_draftsaved" ng-model="vm.serviceformdraftsaved.draftsaved"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/serviceformdraftsaved/serviceformdraftsaveds.html','<div><h2 data-translate="investhryApp.serviceformdraftsaved.home.title">Serviceformdraftsaveds</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="serviceformdraftsaved.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.serviceformdraftsaved.home.createLabel">Create new Serviceformdraftsaved</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.serviceformdraftsaved.draftsaved">Draftsaved</span></th><th></th></tr></thead><tbody><tr ng-repeat="serviceformdraftsaved in vm.serviceformdraftsaveds track by serviceformdraftsaved.id"><td><a ui-sref="serviceformdraftsaved-detail({id:serviceformdraftsaved.id})">{{serviceformdraftsaved.id}}</a></td><td>{{serviceformdraftsaved.draftsaved}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="serviceformdraftsaved-detail({id:serviceformdraftsaved.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="serviceformdraftsaved.edit({id:serviceformdraftsaved.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="serviceformdraftsaved.delete({id:serviceformdraftsaved.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/servicetoken/servicetoken-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.servicetoken.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.servicetoken.delete.question" translate-values="{id: \'{{vm.servicetoken.id}}\'}">Are you sure you want to delete this Servicetoken?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/servicetoken/servicetoken-detail.html','<div><h2><span data-translate="investhryApp.servicetoken.detail.title">Servicetoken</span> {{vm.servicetoken.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.servicetoken.uniqueid">Uniqueid</span></dt><dd><span>{{vm.servicetoken.uniqueid}}</span></dd><dt><span data-translate="investhryApp.servicetoken.tokennumber">Tokennumber</span></dt><dd><span>{{vm.servicetoken.tokennumber}}</span></dd><dt><span data-translate="investhryApp.servicetoken.nocurl">Nocurl</span></dt><dd><span>{{vm.servicetoken.nocurl}}</span></dd><dt><span data-translate="investhryApp.servicetoken.currentstatus">Currentstatus</span></dt><dd><span>{{vm.servicetoken.currentstatus}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="servicetoken-detail.edit({id:vm.servicetoken.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/servicetoken/servicetoken-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myServicetokenLabel" data-translate="investhryApp.servicetoken.home.createOrEditLabel">Create or edit a Servicetoken</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.servicetoken.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.servicetoken.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.servicetoken.uniqueid" for="field_uniqueid">Uniqueid</label><input type="text" class="form-control" name="uniqueid" id="field_uniqueid" ng-model="vm.servicetoken.uniqueid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.servicetoken.tokennumber" for="field_tokennumber">Tokennumber</label><input type="text" class="form-control" name="tokennumber" id="field_tokennumber" ng-model="vm.servicetoken.tokennumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.servicetoken.nocurl" for="field_nocurl">Nocurl</label><input type="text" class="form-control" name="nocurl" id="field_nocurl" ng-model="vm.servicetoken.nocurl"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.servicetoken.currentstatus" for="field_currentstatus">Currentstatus</label><input type="text" class="form-control" name="currentstatus" id="field_currentstatus" ng-model="vm.servicetoken.currentstatus"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/servicetoken/servicetokens.html','<div><h2 data-translate="investhryApp.servicetoken.home.title">Servicetokens</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="servicetoken.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.servicetoken.home.createLabel">Create new Servicetoken</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.servicetoken.uniqueid">Uniqueid</span></th><th><span data-translate="investhryApp.servicetoken.tokennumber">Tokennumber</span></th><th><span data-translate="investhryApp.servicetoken.nocurl">Nocurl</span></th><th><span data-translate="investhryApp.servicetoken.currentstatus">Currentstatus</span></th><th></th></tr></thead><tbody><tr ng-repeat="servicetoken in vm.servicetokens track by servicetoken.id"><td><a ui-sref="servicetoken-detail({id:servicetoken.id})">{{servicetoken.id}}</a></td><td>{{servicetoken.uniqueid}}</td><td>{{servicetoken.tokennumber}}</td><td>{{servicetoken.nocurl}}</td><td>{{servicetoken.currentstatus}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="servicetoken-detail({id:servicetoken.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="servicetoken.edit({id:servicetoken.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="servicetoken.delete({id:servicetoken.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/shared-pending-caf/shared-pending-caf-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sharedPendingCAF.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.sharedPendingCAF.delete.question" translate-values="{id: \'{{vm.sharedPendingCAF.id}}\'}">Are you sure you want to delete this Shared Pending CAF?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/shared-pending-caf/shared-pending-caf-detail.html','<div><h2><span data-translate="investhryApp.sharedPendingCAF.detail.title">Shared Pending CAF</span> {{vm.sharedPendingCAF.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.sharedPendingCAF.projectId">Project Id</span></dt><dd><span>{{vm.sharedPendingCAF.projectId}}</span></dd><dt><span data-translate="investhryApp.sharedPendingCAF.cafPin">Caf Pin</span></dt><dd><span>{{vm.sharedPendingCAF.cafPin}}</span></dd><dt><span data-translate="investhryApp.sharedPendingCAF.responseCode">Response Code</span></dt><dd><span>{{vm.sharedPendingCAF.responseCode}}</span></dd><dt><span data-translate="investhryApp.sharedPendingCAF.returnMsg">Return Msg</span></dt><dd><span>{{vm.sharedPendingCAF.returnMsg}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="shared-pending-caf-detail.edit({id:vm.sharedPendingCAF.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/shared-pending-caf/shared-pending-caf-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySharedPendingCAFLabel" data-translate="investhryApp.sharedPendingCAF.home.createOrEditLabel">Create or edit a Shared Pending CAF</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sharedPendingCAF.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sharedPendingCAF.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.sharedPendingCAF.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.sharedPendingCAF.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.sharedPendingCAF.cafPin" for="field_cafPin">Caf Pin</label><input type="text" class="form-control" name="cafPin" id="field_cafPin" ng-model="vm.sharedPendingCAF.cafPin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.sharedPendingCAF.responseCode" for="field_responseCode">Response Code</label><input type="text" class="form-control" name="responseCode" id="field_responseCode" ng-model="vm.sharedPendingCAF.responseCode"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.sharedPendingCAF.returnMsg" for="field_returnMsg">Return Msg</label><input type="text" class="form-control" name="returnMsg" id="field_returnMsg" ng-model="vm.sharedPendingCAF.returnMsg"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/shared-pending-caf/shared-pending-cafs.html','<div><h2 data-translate="investhryApp.sharedPendingCAF.home.title">Shared Pending CAFS</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="shared-pending-caf.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.sharedPendingCAF.home.createLabel">Create new Shared Pending CAF</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.sharedPendingCAF.projectId">Project Id</span></th><th><span data-translate="investhryApp.sharedPendingCAF.cafPin">Caf Pin</span></th><th><span data-translate="investhryApp.sharedPendingCAF.responseCode">Response Code</span></th><th><span data-translate="investhryApp.sharedPendingCAF.returnMsg">Return Msg</span></th><th></th></tr></thead><tbody><tr ng-repeat="sharedPendingCAF in vm.sharedPendingCAFS track by sharedPendingCAF.id"><td><a ui-sref="shared-pending-caf-detail({id:sharedPendingCAF.id})">{{sharedPendingCAF.id}}</a></td><td>{{sharedPendingCAF.projectId}}</td><td>{{sharedPendingCAF.cafPin}}</td><td>{{sharedPendingCAF.responseCode}}</td><td>{{sharedPendingCAF.returnMsg}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="shared-pending-caf-detail({id:sharedPendingCAF.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="shared-pending-caf.edit({id:sharedPendingCAF.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="shared-pending-caf.delete({id:sharedPendingCAF.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/shop-u-lb-department-logs/shop-u-lb-department-logs-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.shopULbDepartmentLogs.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.shopULbDepartmentLogs.delete.question" translate-values="{id: \'{{vm.shopULbDepartmentLogs.id}}\'}">Are you sure you want to delete this Shop U Lb Department Logs?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/shop-u-lb-department-logs/shop-u-lb-department-logs-detail.html','<div><h2><span data-translate="investhryApp.shopULbDepartmentLogs.detail.title">Shop U Lb Department Logs</span> {{vm.shopULbDepartmentLogs.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.shopULbDepartmentLogs.actionTaken">Action Taken</span></dt><dd><span>{{vm.shopULbDepartmentLogs.actionTaken}}</span></dd><dt><span data-translate="investhryApp.shopULbDepartmentLogs.commentByUserLogin">Comment By User Login</span></dt><dd><span>{{vm.shopULbDepartmentLogs.commentByUserLogin}}</span></dd><dt><span data-translate="investhryApp.shopULbDepartmentLogs.commentDate">Comment Date</span></dt><dd><span>{{vm.shopULbDepartmentLogs.commentDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.shopULbDepartmentLogs.comments">Comments</span></dt><dd><span>{{vm.shopULbDepartmentLogs.comments}}</span></dd><dt><span data-translate="investhryApp.shopULbDepartmentLogs.projectId">Project Id</span></dt><dd><span>{{vm.shopULbDepartmentLogs.projectId}}</span></dd><dt><span data-translate="investhryApp.shopULbDepartmentLogs.serviceId">Service Id</span></dt><dd><span>{{vm.shopULbDepartmentLogs.serviceId}}</span></dd><dt><span data-translate="investhryApp.shopULbDepartmentLogs.reapplycounter">Reapplycounter</span></dt><dd><span>{{vm.shopULbDepartmentLogs.reapplycounter}}</span></dd><dt><span data-translate="investhryApp.shopULbDepartmentLogs.rejectionreason">Rejectionreason</span></dt><dd><span>{{vm.shopULbDepartmentLogs.rejectionreason}}</span></dd><dt><span data-translate="investhryApp.shopULbDepartmentLogs.departmentName">Department Name</span></dt><dd><span>{{vm.shopULbDepartmentLogs.departmentName}}</span></dd><dt><span data-translate="investhryApp.shopULbDepartmentLogs.projectServiceDetailId">Project Service Detail Id</span></dt><dd><span>{{vm.shopULbDepartmentLogs.projectServiceDetailId}}</span></dd><dt><span data-translate="investhryApp.shopULbDepartmentLogs.dashboardBetweenDatesCafId">Dashboard Between Dates Caf Id</span></dt><dd><span>{{vm.shopULbDepartmentLogs.dashboardBetweenDatesCafId}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="shop-u-lb-department-logs-detail.edit({id:vm.shopULbDepartmentLogs.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/shop-u-lb-department-logs/shop-u-lb-department-logs-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myShopULbDepartmentLogsLabel" data-translate="investhryApp.shopULbDepartmentLogs.home.createOrEditLabel">Create or edit a Shop U Lb Department Logs</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.shopULbDepartmentLogs.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.shopULbDepartmentLogs.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.shopULbDepartmentLogs.actionTaken" for="field_actionTaken">Action Taken</label><input type="text" class="form-control" name="actionTaken" id="field_actionTaken" ng-model="vm.shopULbDepartmentLogs.actionTaken"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.shopULbDepartmentLogs.commentByUserLogin" for="field_commentByUserLogin">Comment By User Login</label><input type="text" class="form-control" name="commentByUserLogin" id="field_commentByUserLogin" ng-model="vm.shopULbDepartmentLogs.commentByUserLogin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.shopULbDepartmentLogs.commentDate" for="field_commentDate">Comment Date</label><div class="input-group"><input id="field_commentDate" type="text" class="form-control" name="commentDate" datetime-picker="{{dateformat}}" ng-model="vm.shopULbDepartmentLogs.commentDate" is-open="vm.datePickerOpenStatus.commentDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'commentDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.shopULbDepartmentLogs.comments" for="field_comments">Comments</label><input type="text" class="form-control" name="comments" id="field_comments" ng-model="vm.shopULbDepartmentLogs.comments"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.shopULbDepartmentLogs.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.shopULbDepartmentLogs.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.shopULbDepartmentLogs.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.shopULbDepartmentLogs.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.shopULbDepartmentLogs.reapplycounter" for="field_reapplycounter">Reapplycounter</label><input type="number" class="form-control" name="reapplycounter" id="field_reapplycounter" ng-model="vm.shopULbDepartmentLogs.reapplycounter"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.shopULbDepartmentLogs.rejectionreason" for="field_rejectionreason">Rejectionreason</label><input type="text" class="form-control" name="rejectionreason" id="field_rejectionreason" ng-model="vm.shopULbDepartmentLogs.rejectionreason"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.shopULbDepartmentLogs.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.shopULbDepartmentLogs.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.shopULbDepartmentLogs.projectServiceDetailId" for="field_projectServiceDetailId">Project Service Detail Id</label><input type="text" class="form-control" name="projectServiceDetailId" id="field_projectServiceDetailId" ng-model="vm.shopULbDepartmentLogs.projectServiceDetailId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.shopULbDepartmentLogs.dashboardBetweenDatesCafId" for="field_dashboardBetweenDatesCafId">Dashboard Between Dates Caf Id</label><input type="text" class="form-control" name="dashboardBetweenDatesCafId" id="field_dashboardBetweenDatesCafId" ng-model="vm.shopULbDepartmentLogs.dashboardBetweenDatesCafId"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/shop-u-lb-department-logs/shop-u-lb-department-logs.html','<div><h2 data-translate="investhryApp.shopULbDepartmentLogs.home.title">Shop U Lb Department Logs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="shop-u-lb-department-logs.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.shopULbDepartmentLogs.home.createLabel">Create new Shop U Lb Department Logs</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.shopULbDepartmentLogs.actionTaken">Action Taken</span></th><th><span data-translate="investhryApp.shopULbDepartmentLogs.commentByUserLogin">Comment By User Login</span></th><th><span data-translate="investhryApp.shopULbDepartmentLogs.commentDate">Comment Date</span></th><th><span data-translate="investhryApp.shopULbDepartmentLogs.comments">Comments</span></th><th><span data-translate="investhryApp.shopULbDepartmentLogs.projectId">Project Id</span></th><th><span data-translate="investhryApp.shopULbDepartmentLogs.serviceId">Service Id</span></th><th><span data-translate="investhryApp.shopULbDepartmentLogs.reapplycounter">Reapplycounter</span></th><th><span data-translate="investhryApp.shopULbDepartmentLogs.rejectionreason">Rejectionreason</span></th><th><span data-translate="investhryApp.shopULbDepartmentLogs.departmentName">Department Name</span></th><th><span data-translate="investhryApp.shopULbDepartmentLogs.projectServiceDetailId">Project Service Detail Id</span></th><th><span data-translate="investhryApp.shopULbDepartmentLogs.dashboardBetweenDatesCafId">Dashboard Between Dates Caf Id</span></th><th></th></tr></thead><tbody><tr ng-repeat="shopULbDepartmentLogs in vm.shopULbDepartmentLogs track by shopULbDepartmentLogs.id"><td><a ui-sref="shop-u-lb-department-logs-detail({id:shopULbDepartmentLogs.id})">{{shopULbDepartmentLogs.id}}</a></td><td>{{shopULbDepartmentLogs.actionTaken}}</td><td>{{shopULbDepartmentLogs.commentByUserLogin}}</td><td>{{shopULbDepartmentLogs.commentDate | date:\'medium\'}}</td><td>{{shopULbDepartmentLogs.comments}}</td><td>{{shopULbDepartmentLogs.projectId}}</td><td>{{shopULbDepartmentLogs.serviceId}}</td><td>{{shopULbDepartmentLogs.reapplycounter}}</td><td>{{shopULbDepartmentLogs.rejectionreason}}</td><td>{{shopULbDepartmentLogs.departmentName}}</td><td>{{shopULbDepartmentLogs.projectServiceDetailId}}</td><td>{{shopULbDepartmentLogs.dashboardBetweenDatesCafId}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="shop-u-lb-department-logs-detail({id:shopULbDepartmentLogs.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="shop-u-lb-department-logs.edit({id:shopULbDepartmentLogs.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="shop-u-lb-department-logs.delete({id:shopULbDepartmentLogs.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/skills-data/skills-data-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.skillsData.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.skillsData.delete.question" translate-values="{id: \'{{vm.skillsData.id}}\'}">Are you sure you want to delete this Skills Data?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/skills-data/skills-data-detail.html','<div><h2><span data-translate="investhryApp.skillsData.detail.title">Skills Data</span> {{vm.skillsData.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.skillsData.district">District</span></dt><dd><span>{{vm.skillsData.district}}</span></dd><dt><span data-translate="investhryApp.skillsData.sector">Sector</span></dt><dd><span>{{vm.skillsData.sector}}</span></dd><dt><span data-translate="investhryApp.skillsData.jobRole">Job Role</span></dt><dd><span>{{vm.skillsData.jobRole}}</span></dd><dt><span data-translate="investhryApp.skillsData.requiredLabour">Required Labour</span></dt><dd><span>{{vm.skillsData.requiredLabour}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="skills-data-detail.edit({id:vm.skillsData.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/skills-data/skills-data-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySkillsDataLabel" data-translate="investhryApp.skillsData.home.createOrEditLabel">Create or edit a Skills Data</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.skillsData.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.skillsData.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.skillsData.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.skillsData.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.skillsData.sector" for="field_sector">Sector</label><input type="text" class="form-control" name="sector" id="field_sector" ng-model="vm.skillsData.sector"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.skillsData.jobRole" for="field_jobRole">Job Role</label><input type="text" class="form-control" name="jobRole" id="field_jobRole" ng-model="vm.skillsData.jobRole"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.skillsData.requiredLabour" for="field_requiredLabour">Required Labour</label><input type="text" class="form-control" name="requiredLabour" id="field_requiredLabour" ng-model="vm.skillsData.requiredLabour"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/skills-data/skills-data.html','<div><h2 data-translate="investhryApp.skillsData.home.title">Skills Data</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="skills-data.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.skillsData.home.createLabel">Create new Skills Data</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.skillsData.district">District</span></th><th><span data-translate="investhryApp.skillsData.sector">Sector</span></th><th><span data-translate="investhryApp.skillsData.jobRole">Job Role</span></th><th><span data-translate="investhryApp.skillsData.requiredLabour">Required Labour</span></th><th></th></tr></thead><tbody><tr ng-repeat="skillsData in vm.skillsData track by skillsData.id"><td><a ui-sref="skills-data-detail({id:skillsData.id})">{{skillsData.id}}</a></td><td>{{skillsData.district}}</td><td>{{skillsData.sector}}</td><td>{{skillsData.jobRole}}</td><td>{{skillsData.requiredLabour}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="skills-data-detail({id:skillsData.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="skills-data.edit({id:skillsData.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="skills-data.delete({id:skillsData.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/state/state-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.state.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.state.delete.question" translate-values="{id: \'{{vm.state.id}}\'}">Are you sure you want to delete this State?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/state/state-detail.html','<div><h2><span data-translate="investhryApp.state.detail.title">State</span> {{vm.state.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.state.statename">Statename</span></dt><dd><span>{{vm.state.statename}}</span></dd><dt><span data-translate="investhryApp.state.countryname">Countryname</span></dt><dd><span>{{vm.state.countryname}}</span></dd><dt><span data-translate="investhryApp.state.countryID">Country ID</span></dt><dd><span>{{vm.state.countryID}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="state-detail.edit({id:vm.state.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/state/state-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myStateLabel" data-translate="investhryApp.state.home.createOrEditLabel">Create or edit a State</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.state.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.state.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.state.statename" for="field_statename">Statename</label><input type="text" class="form-control" name="statename" id="field_statename" ng-model="vm.state.statename" required><div ng-show="editForm.statename.$invalid"><p class="help-block" ng-show="editForm.statename.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.state.countryname" for="field_countryname">Countryname</label><select class="form-control" name="countryname" id="field_countryname" ng-options="country.countryname for country in vm.countries track by country.id" ng-model="selected"></div><div class="form-group hidden"><label class="control-label" data-translate="investhryApp.state.countryID" for="field_countryID">Country ID</label><input type="text" class="form-control" name="countryID" id="field_countryID" ng-model="vm.state.countryID"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/state/states.html','<div><h2 data-translate="investhryApp.state.home.title">States</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="state.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.state.home.createLabel">Create new State</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.state.statename">Statename</span></th><th><span data-translate="investhryApp.state.countryname">Countryname</span></th><th><span data-translate="investhryApp.state.countryID">Country ID</span></th><th></th></tr></thead><tbody><tr ng-repeat="state in vm.states track by state.id"><td><a ui-sref="state-detail({id:state.id})">{{state.id}}</a></td><td>{{state.statename}}</td><td>{{state.countryname}}</td><td>{{state.countryID}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="state-detail({id:state.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="state.edit({id:state.id, countryID:state.countryID})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="state.delete({id:state.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/supply-and-disposal/supply-and-disposal-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.supplyAndDisposal.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.supplyAndDisposal.delete.question" translate-values="{id: \'{{vm.supplyAndDisposal.id}}\'}">Are you sure you want to delete this Supply And Disposal?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/supply-and-disposal/supply-and-disposal-detail.html','<div><h2><span data-translate="investhryApp.supplyAndDisposal.detail.title">Supply And Disposal</span> {{vm.supplyAndDisposal.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.supplyAndDisposal.applicationNumber">Application Number</span></dt><dd><span>{{vm.supplyAndDisposal.applicationNumber}}</span></dd><dt><span data-translate="investhryApp.supplyAndDisposal.name">Name</span></dt><dd><span>{{vm.supplyAndDisposal.name}}</span></dd><dt><span data-translate="investhryApp.supplyAndDisposal.appliedDate">Applied Date</span></dt><dd><span>{{vm.supplyAndDisposal.appliedDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.supplyAndDisposal.rejectedDate">Rejected Date</span></dt><dd><span>{{vm.supplyAndDisposal.rejectedDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.supplyAndDisposal.clearedDate">Cleared Date</span></dt><dd><span>{{vm.supplyAndDisposal.clearedDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.supplyAndDisposal.lastAction">Last Action</span></dt><dd><span>{{vm.supplyAndDisposal.lastAction}}</span></dd><dt><span data-translate="investhryApp.supplyAndDisposal.lastActionBy">Last Action By</span></dt><dd><span>{{vm.supplyAndDisposal.lastActionBy}}</span></dd><dt><span data-translate="investhryApp.supplyAndDisposal.appliedBy">Applied By</span></dt><dd><span>{{vm.supplyAndDisposal.appliedBy}}</span></dd><dt><span data-translate="investhryApp.supplyAndDisposal.status">Status</span></dt><dd><span>{{vm.supplyAndDisposal.status}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="supply-and-disposal-detail.edit({id:vm.supplyAndDisposal.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/supply-and-disposal/supply-and-disposal-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySupplyAndDisposalLabel" data-translate="investhryApp.supplyAndDisposal.home.createOrEditLabel">Create or edit a Supply And Disposal</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.supplyAndDisposal.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.supplyAndDisposal.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.supplyAndDisposal.applicationNumber" for="field_applicationNumber">Application Number</label><input type="text" class="form-control" name="applicationNumber" id="field_applicationNumber" ng-model="vm.supplyAndDisposal.applicationNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.supplyAndDisposal.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.supplyAndDisposal.name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.supplyAndDisposal.appliedDate" for="field_appliedDate">Applied Date</label><div class="input-group"><input id="field_appliedDate" type="text" class="form-control" name="appliedDate" datetime-picker="{{dateformat}}" ng-model="vm.supplyAndDisposal.appliedDate" is-open="vm.datePickerOpenStatus.appliedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'appliedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.supplyAndDisposal.rejectedDate" for="field_rejectedDate">Rejected Date</label><div class="input-group"><input id="field_rejectedDate" type="text" class="form-control" name="rejectedDate" datetime-picker="{{dateformat}}" ng-model="vm.supplyAndDisposal.rejectedDate" is-open="vm.datePickerOpenStatus.rejectedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'rejectedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.supplyAndDisposal.clearedDate" for="field_clearedDate">Cleared Date</label><div class="input-group"><input id="field_clearedDate" type="text" class="form-control" name="clearedDate" datetime-picker="{{dateformat}}" ng-model="vm.supplyAndDisposal.clearedDate" is-open="vm.datePickerOpenStatus.clearedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'clearedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.supplyAndDisposal.lastAction" for="field_lastAction">Last Action</label><input type="text" class="form-control" name="lastAction" id="field_lastAction" ng-model="vm.supplyAndDisposal.lastAction"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.supplyAndDisposal.lastActionBy" for="field_lastActionBy">Last Action By</label><input type="text" class="form-control" name="lastActionBy" id="field_lastActionBy" ng-model="vm.supplyAndDisposal.lastActionBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.supplyAndDisposal.appliedBy" for="field_appliedBy">Applied By</label><input type="text" class="form-control" name="appliedBy" id="field_appliedBy" ng-model="vm.supplyAndDisposal.appliedBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.supplyAndDisposal.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.supplyAndDisposal.status"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/supply-and-disposal/supply-and-disposals.html','<div><h2 data-translate="investhryApp.supplyAndDisposal.home.title">Supply And Disposals</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="supply-and-disposal.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.supplyAndDisposal.home.createLabel">Create new Supply And Disposal</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.supplyAndDisposal.applicationNumber">Application Number</span></th><th><span data-translate="investhryApp.supplyAndDisposal.name">Name</span></th><th><span data-translate="investhryApp.supplyAndDisposal.appliedDate">Applied Date</span></th><th><span data-translate="investhryApp.supplyAndDisposal.rejectedDate">Rejected Date</span></th><th><span data-translate="investhryApp.supplyAndDisposal.clearedDate">Cleared Date</span></th><th><span data-translate="investhryApp.supplyAndDisposal.lastAction">Last Action</span></th><th><span data-translate="investhryApp.supplyAndDisposal.lastActionBy">Last Action By</span></th><th><span data-translate="investhryApp.supplyAndDisposal.appliedBy">Applied By</span></th><th><span data-translate="investhryApp.supplyAndDisposal.status">Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="supplyAndDisposal in vm.supplyAndDisposals track by supplyAndDisposal.id"><td><a ui-sref="supply-and-disposal-detail({id:supplyAndDisposal.id})">{{supplyAndDisposal.id}}</a></td><td>{{supplyAndDisposal.applicationNumber}}</td><td>{{supplyAndDisposal.name}}</td><td>{{supplyAndDisposal.appliedDate | date:\'medium\'}}</td><td>{{supplyAndDisposal.rejectedDate | date:\'medium\'}}</td><td>{{supplyAndDisposal.clearedDate | date:\'medium\'}}</td><td>{{supplyAndDisposal.lastAction}}</td><td>{{supplyAndDisposal.lastActionBy}}</td><td>{{supplyAndDisposal.appliedBy}}</td><td>{{supplyAndDisposal.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="supply-and-disposal-detail({id:supplyAndDisposal.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="supply-and-disposal.edit({id:supplyAndDisposal.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="supply-and-disposal.delete({id:supplyAndDisposal.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/survey/survey-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.survey.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.survey.delete.question" translate-values="{id: \'{{vm.survey.id}}\'}">Are you sure you want to delete this Survey?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/survey/survey-detail.html','<div><h2><span data-translate="investhryApp.survey.detail.title">Survey</span> {{vm.survey.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.survey.investmentDate">Investment Date</span></dt><dd><span>{{vm.survey.investmentDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.survey.groundedInvestment">Grounded Investment</span></dt><dd><span>{{vm.survey.groundedInvestment}}</span></dd><dt><span data-translate="investhryApp.survey.groundedEmployement">Grounded Employement</span></dt><dd><span>{{vm.survey.groundedEmployement}}</span></dd><dt><span data-translate="investhryApp.survey.isEmployed">Is Employed</span></dt><dd><span>{{vm.survey.isEmployed}}</span></dd><dt><span data-translate="investhryApp.survey.isSubsidy">Is Subsidy</span></dt><dd><span>{{vm.survey.isSubsidy}}</span></dd><dt><span data-translate="investhryApp.survey.isAppliedSubsidy">Is Applied Subsidy</span></dt><dd><span>{{vm.survey.isAppliedSubsidy}}</span></dd><dt><span data-translate="investhryApp.survey.isKnowledgePolicy">Is Knowledge Policy</span></dt><dd><span>{{vm.survey.isKnowledgePolicy}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="survey-detail.edit({id:vm.survey.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/survey/survey-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySurveyLabel" data-translate="investhryApp.survey.home.createOrEditLabel">Create or edit a Survey</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.survey.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.survey.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.survey.investmentDate" for="field_investmentDate">Investment Date</label><div class="input-group"><input id="field_investmentDate" type="text" class="form-control" name="investmentDate" datetime-picker="{{dateformat}}" ng-model="vm.survey.investmentDate" is-open="vm.datePickerOpenStatus.investmentDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'investmentDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.survey.groundedInvestment" for="field_groundedInvestment">Grounded Investment</label><input type="text" class="form-control" name="groundedInvestment" id="field_groundedInvestment" ng-model="vm.survey.groundedInvestment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.survey.groundedEmployement" for="field_groundedEmployement">Grounded Employement</label><input type="text" class="form-control" name="groundedEmployement" id="field_groundedEmployement" ng-model="vm.survey.groundedEmployement"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.survey.isEmployed" for="field_isEmployed">Is Employed</label><input type="checkbox" name="isEmployed" id="field_isEmployed" ng-model="vm.survey.isEmployed"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.survey.isSubsidy" for="field_isSubsidy">Is Subsidy</label><input type="checkbox" name="isSubsidy" id="field_isSubsidy" ng-model="vm.survey.isSubsidy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.survey.isAppliedSubsidy" for="field_isAppliedSubsidy">Is Applied Subsidy</label><input type="checkbox" name="isAppliedSubsidy" id="field_isAppliedSubsidy" ng-model="vm.survey.isAppliedSubsidy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.survey.isKnowledgePolicy" for="field_isKnowledgePolicy">Is Knowledge Policy</label><input type="checkbox" name="isKnowledgePolicy" id="field_isKnowledgePolicy" ng-model="vm.survey.isKnowledgePolicy"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/survey/surveys.html','<div class="container-fluid"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-md-8"><h2 data-translate="investhryApp.survey.home.title">Surveys</h2><!--<button class="btn btn-primary" ui-sref="survey.new" >--><!--<span class="glyphicon glyphicon-plus"></span>--><!--<span  data-translate="investhryApp.survey.home.createLabel">--><!--Create new Survey--><!--</span>--><!--</button>--></div><div class="col-md-4" style="padding-top: 1%"><button ng-show="vm.show" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm pull-right">Download&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div></div><br><div class="table-responsive"><table id="result_table" class="jh-table table table-striped"><thead><tr><th><span>#</span></th><th><span>Caf Pin (Composite Application Form)</span></th><th><span>District</span></th><th><span>Business Entity</span></th><th><span>Product</span></th><th><span>Block</span></th><th><span>Sector</span></th><th><span>Investment Type</span></th><th><span>FDI</span></th><th><span>Site Address</span></th><th><span>Production Start Date</span></th><th><span data-translate="investhryApp.survey.investmentDate">Investment Date</span></th><th><span data-translate="investhryApp.survey.groundedInvestment">Grounded Investment</span></th><th><span data-translate="investhryApp.survey.groundedEmployement">Grounded Employement</span></th><th><span data-translate="investhryApp.survey.isEmployed">Is Employed</span></th><th><span data-translate="investhryApp.survey.isSubsidy">Is Subsidy</span></th><th><span data-translate="investhryApp.survey.isAppliedSubsidy">Is Applied Subsidy</span></th><th><span data-translate="investhryApp.survey.isKnowledgePolicy">Is Knowledge Policy</span></th><th></th></tr></thead><tbody><tr ng-repeat="survey in vm.surveys track by survey.id"><!--<td><a ui-sref="survey-detail({id:survey.id})">{{survey.id}}</a></td>--><td>{{$index+1}}</td><td>{{survey.cafPin}}</td><td>{{survey.district}}</td><td>{{survey.businessEntity}}</td><td>{{survey.product}}</td><td>{{survey.block}}</td><td>{{survey.sector === \'Other Industries\' ? survey.sector + " - "+ survey.sectorOther : survey.sector}}</td><td>{{survey.investmentType === \'Other\' ? survey.investmentType + " - "+ survey.otherInvestmentType : survey.investmentType}}</td><td>{{survey.fdi !== null ? survey.fdi : \'NA\'}}</td><td>{{survey.siteAddress}}</td><td>{{survey.productionStartDate | date:\'dd.MM.y\'}}</td><td>{{survey.investmentDate | date:\'dd.MM.y\'}}</td><td>{{survey.groundedInvestment}}</td><td>{{survey.groundedEmployement}}</td><td>{{survey.isEmployed}}</td><td>{{survey.isSubsidy}}</td><td>{{survey.isAppliedSubsidy}}</td><td>{{survey.isKnowledgePolicy}}</td><!--<td class="text-right">--><!--<div class="btn-group flex-btn-group-container">--><!--<button type="submit"--><!--ui-sref="survey-detail({id:survey.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="survey.edit({id:survey.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="survey.delete({id:survey.id})"--><!--class="btn btn-danger btn-sm">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--><!--</button>--><!--</div>--><!--</td>--></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tehsil-subtehsil/tehsil-subtehsil-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tehsil_subtehsil.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.tehsil_subtehsil.delete.question" translate-values="{id: \'{{vm.tehsil_subtehsil.id}}\'}">Are you sure you want to delete this Tehsil Subtehsil?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tehsil-subtehsil/tehsil-subtehsil-detail.html','<div class="container"><h2><span data-translate="investhryApp.tehsil_subtehsil.detail.title">Tehsil Subtehsil</span> {{vm.tehsil_subtehsil.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.tehsil_subtehsil.tehsil_subtehsilname">Tehsil Subtehsilname</span></dt><dd><span>{{vm.tehsil_subtehsil.tehsil_subtehsilname}}</span></dd><dt><span data-translate="investhryApp.tehsil_subtehsil.districtname">Districtname</span></dt><dd><span>{{vm.tehsil_subtehsil.districtname}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tehsil-subtehsil-detail.edit({id:vm.tehsil_subtehsil.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tehsil-subtehsil/tehsil-subtehsil-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTehsil_subtehsilLabel" data-translate="investhryApp.tehsil_subtehsil.home.createOrEditLabel">Create or edit a Tehsil Subtehsil</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tehsil_subtehsil.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tehsil_subtehsil.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tehsil_subtehsil.tehsil_subtehsilname" for="field_tehsil_subtehsilname">Tehsil Subtehsilname</label><input type="text" class="form-control" name="tehsil_subtehsilname" id="field_tehsil_subtehsilname" ng-model="vm.tehsil_subtehsil.tehsil_subtehsilname" required><div ng-show="editForm.tehsil_subtehsilname.$invalid"><p class="help-block" ng-show="editForm.tehsil_subtehsilname.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tehsil_subtehsil.districtname" for="field_districtname">Districtname</label><input type="text" class="form-control" name="districtname" id="field_districtname" ng-model="vm.tehsil_subtehsil.districtname"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tehsil-subtehsil/tehsil-subtehsils.html','<div class="container"><h2 data-translate="investhryApp.tehsil_subtehsil.home.title">Tehsil Subtehsils</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tehsil-subtehsil.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.tehsil_subtehsil.home.createLabel">Create new Tehsil Subtehsil</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.tehsil_subtehsil.tehsil_subtehsilname">Tehsil Subtehsilname</span></th><th><span data-translate="investhryApp.tehsil_subtehsil.districtname">Districtname</span></th><th></th></tr></thead><tbody><tr ng-repeat="tehsil_subtehsil in vm.tehsil_subtehsils track by tehsil_subtehsil.id"><td><a ui-sref="tehsil-subtehsil-detail({id:tehsil_subtehsil.id})">{{tehsil_subtehsil.id}}</a></td><td>{{tehsil_subtehsil.tehsil_subtehsilname}}</td><td>{{tehsil_subtehsil.districtname}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tehsil-subtehsil-detail({id:tehsil_subtehsil.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tehsil-subtehsil.edit({id:tehsil_subtehsil.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tehsil-subtehsil.delete({id:tehsil_subtehsil.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/term-declaration-accept/term-declaration-accept-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.term_declaration_accept.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.term_declaration_accept.delete.question" translate-values="{id: \'{{vm.term_declaration_accept.id}}\'}">Are you sure you want to delete this Term Declaration Accept?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/term-declaration-accept/term-declaration-accept-detail.html','<div><h2><span data-translate="investhryApp.term_declaration_accept.detail.title">Term Declaration Accept</span> {{vm.term_declaration_accept.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.term_declaration_accept.acceptance">Acceptance</span></dt><dd><span>{{vm.term_declaration_accept.acceptance}}</span></dd><dt><span data-translate="investhryApp.term_declaration_accept.applicationdate">Applicationdate</span></dt><dd><span>{{vm.term_declaration_accept.applicationdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.term_declaration_accept.place">Place</span></dt><dd><span>{{vm.term_declaration_accept.place}}</span></dd><dt><span data-translate="investhryApp.term_declaration_accept.createdate">Createdate</span></dt><dd><span>{{vm.term_declaration_accept.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.term_declaration_accept.updatedate">Updatedate</span></dt><dd><span>{{vm.term_declaration_accept.updatedate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="term-declaration-accept-detail.edit({id:vm.term_declaration_accept.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/term-declaration-accept/term-declaration-accept-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTerm_declaration_acceptLabel" data-translate="investhryApp.term_declaration_accept.home.createOrEditLabel">Create or edit a Term Declaration Accept</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.term_declaration_accept.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.term_declaration_accept.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.term_declaration_accept.acceptance" for="field_acceptance">Acceptance</label><input type="checkbox" class="form-control" name="acceptance" id="field_acceptance" ng-model="vm.term_declaration_accept.acceptance"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.term_declaration_accept.applicationdate" for="field_applicationdate">Applicationdate</label><div class="input-group"><input id="field_applicationdate" type="text" class="form-control" name="applicationdate" datetime-picker="{{dateformat}}" ng-model="vm.term_declaration_accept.applicationdate" is-open="vm.datePickerOpenStatus.applicationdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'applicationdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.term_declaration_accept.place" for="field_place">Place</label><input type="text" class="form-control" name="place" id="field_place" ng-model="vm.term_declaration_accept.place"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.term_declaration_accept.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.term_declaration_accept.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.term_declaration_accept.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.term_declaration_accept.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/term-declaration-accept/term-declaration-accepts.html','<div><h2 data-translate="investhryApp.term_declaration_accept.home.title">Term Declaration Accepts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="term-declaration-accept.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.term_declaration_accept.home.createLabel">Create new Term Declaration Accept</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.term_declaration_accept.acceptance">Acceptance</span></th><th><span data-translate="investhryApp.term_declaration_accept.applicationdate">Applicationdate</span></th><th><span data-translate="investhryApp.term_declaration_accept.place">Place</span></th><th><span data-translate="investhryApp.term_declaration_accept.createdate">Createdate</span></th><th><span data-translate="investhryApp.term_declaration_accept.updatedate">Updatedate</span></th><th></th></tr></thead><tbody><tr ng-repeat="term_declaration_accept in vm.term_declaration_accepts track by term_declaration_accept.id"><td><a ui-sref="term-declaration-accept-detail({id:term_declaration_accept.id})">{{term_declaration_accept.id}}</a></td><td>{{term_declaration_accept.acceptance}}</td><td>{{term_declaration_accept.applicationdate | date:\'medium\'}}</td><td>{{term_declaration_accept.place}}</td><td>{{term_declaration_accept.createdate | date:\'medium\'}}</td><td>{{term_declaration_accept.updatedate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="term-declaration-accept-detail({id:term_declaration_accept.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="term-declaration-accept.edit({id:term_declaration_accept.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="term-declaration-accept.delete({id:term_declaration_accept.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/ticket-departments/ticket-departments-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticketDepartments.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.ticketDepartments.delete.question" translate-values="{id: \'{{vm.ticketDepartments.id}}\'}">Are you sure you want to delete this Ticket Departments?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ticket-departments/ticket-departments-detail.html','<div><h2><span data-translate="investhryApp.ticketDepartments.detail.title">Ticket Departments</span> {{vm.ticketDepartments.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.ticketDepartments.departmentName">Department Name</span></dt><dd><span>{{vm.ticketDepartments.departmentName}}</span></dd><dt><span data-translate="investhryApp.ticketDepartments.hodLogin">Hod Login</span></dt><dd><span>{{vm.ticketDepartments.hodLogin}}</span></dd><dt><span data-translate="investhryApp.ticketDepartments.nodalLogin">Nodal Login</span></dt><dd><span>{{vm.ticketDepartments.nodalLogin}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ticket-departments-detail.edit({id:vm.ticketDepartments.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ticket-departments/ticket-departments-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicketDepartmentsLabel" data-translate="investhryApp.ticketDepartments.home.createOrEditLabel">Create or edit a Ticket Departments</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ticketDepartments.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ticketDepartments.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketDepartments.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.ticketDepartments.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketDepartments.hodLogin" for="field_hodLogin">Hod Login</label><input type="text" class="form-control" name="hodLogin" id="field_hodLogin" ng-model="vm.ticketDepartments.hodLogin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketDepartments.nodalLogin" for="field_nodalLogin">Nodal Login</label><input type="text" class="form-control" name="nodalLogin" id="field_nodalLogin" ng-model="vm.ticketDepartments.nodalLogin"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ticket-departments/ticket-departments.html','<div><h2 data-translate="investhryApp.ticketDepartments.home.title">Ticket Departments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ticket-departments.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.ticketDepartments.home.createLabel">Create new Ticket Departments</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.ticketDepartments.departmentName">Department Name</span></th><th><span data-translate="investhryApp.ticketDepartments.hodLogin">Hod Login</span></th><th><span data-translate="investhryApp.ticketDepartments.nodalLogin">Nodal Login</span></th><th></th></tr></thead><tbody><tr ng-repeat="ticketDepartments in vm.ticketDepartments track by ticketDepartments.id"><td><a ui-sref="ticket-departments-detail({id:ticketDepartments.id})">{{ticketDepartments.id}}</a></td><td>{{ticketDepartments.departmentName}}</td><td>{{ticketDepartments.hodLogin}}</td><td>{{ticketDepartments.nodalLogin}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ticket-departments-detail({id:ticketDepartments.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="ticket-departments.edit({id:ticketDepartments.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="ticket-departments.delete({id:ticketDepartments.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/ticket-member/ticket-member-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticketMember.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.ticketMember.delete.question" translate-values="{id: \'{{vm.ticketMember.id}}\'}">Are you sure you want to delete this Ticket Member?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/ticket-member/ticket-member-detail.html','<div><h2><span data-translate="investhryApp.ticketMember.detail.title">Ticket Member</span> {{vm.ticketMember.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.ticketMember.login">Login</span></dt><dd><span>{{vm.ticketMember.login}}</span></dd><dt><span data-translate="investhryApp.ticketMember.firstName">First Name</span></dt><dd><span>{{vm.ticketMember.firstName}}</span></dd><dt><span data-translate="investhryApp.ticketMember.lastName">Last Name</span></dt><dd><span>{{vm.ticketMember.lastName}}</span></dd><dt><span data-translate="investhryApp.ticketMember.email">Email</span></dt><dd><span>{{vm.ticketMember.email}}</span></dd><dt><span data-translate="investhryApp.ticketMember.authorities">Authorities</span></dt><dd><span>{{vm.ticketMember.authorities}}</span></dd><dt><span data-translate="investhryApp.ticketMember.mobile">Mobile</span></dt><dd><span>{{vm.ticketMember.mobile}}</span></dd><dt><span data-translate="investhryApp.ticketMember.address">Address</span></dt><dd><span>{{vm.ticketMember.address}}</span></dd><dt><span data-translate="investhryApp.ticketMember.departmentName">Department Name</span></dt><dd><span>{{vm.ticketMember.departmentName}}</span></dd><dt><span data-translate="investhryApp.ticketMember.departmentId">Department Id</span></dt><dd><span>{{vm.ticketMember.departmentId}}</span></dd><dt><span data-translate="investhryApp.ticketMember.departmentList">Department List</span></dt><dd><span>{{vm.ticketMember.departmentList}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="ticket-member-detail.edit({id:vm.ticketMember.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/ticket-member/ticket-member-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicketMemberLabel" data-translate="investhryApp.ticketMember.home.createOrEditLabel">Create or edit a Ticket Member</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ticketMember.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ticketMember.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketMember.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.ticketMember.login"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketMember.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.ticketMember.firstName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketMember.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.ticketMember.lastName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketMember.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.ticketMember.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketMember.authorities" for="field_authorities">Authorities</label><input type="text" class="form-control" name="authorities" id="field_authorities" ng-model="vm.ticketMember.authorities"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketMember.mobile" for="field_mobile">Mobile</label><input type="text" class="form-control" name="mobile" id="field_mobile" ng-model="vm.ticketMember.mobile"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketMember.address" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.ticketMember.address"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketMember.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.ticketMember.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketMember.departmentId" for="field_departmentId">Department Id</label><input type="text" class="form-control" name="departmentId" id="field_departmentId" ng-model="vm.ticketMember.departmentId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketMember.departmentList" for="field_departmentList">Department List</label><input type="text" class="form-control" name="departmentList" id="field_departmentList" ng-model="vm.ticketMember.departmentList"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ticket-member/ticket-members.html','<div><h2 data-translate="investhryApp.ticketMember.home.title">Ticket Members</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="ticket-member.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.ticketMember.home.createLabel">Create new Ticket Member</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.ticketMember.login">Login</span></th><th><span data-translate="investhryApp.ticketMember.firstName">First Name</span></th><th><span data-translate="investhryApp.ticketMember.lastName">Last Name</span></th><th><span data-translate="investhryApp.ticketMember.email">Email</span></th><th><span data-translate="investhryApp.ticketMember.authorities">Authorities</span></th><th><span data-translate="investhryApp.ticketMember.mobile">Mobile</span></th><th><span data-translate="investhryApp.ticketMember.address">Address</span></th><th><span data-translate="investhryApp.ticketMember.departmentName">Department Name</span></th><th><span data-translate="investhryApp.ticketMember.departmentId">Department Id</span></th><th><span data-translate="investhryApp.ticketMember.departmentList">Department List</span></th><th></th></tr></thead><tbody><tr ng-repeat="ticketMember in vm.ticketMembers track by ticketMember.id"><td><a ui-sref="ticket-member-detail({id:ticketMember.id})">{{ticketMember.id}}</a></td><td>{{ticketMember.login}}</td><td>{{ticketMember.firstName}}</td><td>{{ticketMember.lastName}}</td><td>{{ticketMember.email}}</td><td>{{ticketMember.authorities}}</td><td>{{ticketMember.mobile}}</td><td>{{ticketMember.address}}</td><td>{{ticketMember.departmentName}}</td><td>{{ticketMember.departmentId}}</td><td>{{ticketMember.departmentList}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ticket-member-detail({id:ticketMember.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="ticket-member.edit({id:ticketMember.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="ticket-member.delete({id:ticketMember.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tickets/tickets-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tickets.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.tickets.delete.question" translate-values="{id: \'{{vm.tickets.id}}\'}">Are you sure you want to delete this Tickets?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tickets/tickets-detail.html','<div><h2><span data-translate="investhryApp.tickets.detail.title">Tickets</span> {{vm.tickets.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.tickets.ticketNumber">Ticket Number</span></dt><dd><span>{{vm.tickets.ticketNumber}}</span></dd><dt><span data-translate="investhryApp.tickets.cafpin">Cafpin</span></dt><dd><span>{{vm.tickets.cafpin}}</span></dd><dt><span data-translate="investhryApp.tickets.investorDetail">Investor Detail</span></dt><dd><span>{{vm.tickets.investorDetail}}</span></dd><dt><span data-translate="investhryApp.tickets.latestRemark">Latest Remark</span></dt><dd><span>{{vm.tickets.latestRemark}}</span></dd><dt><span data-translate="investhryApp.tickets.creationDate">Creation Date</span></dt><dd><span>{{vm.tickets.creationDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.tickets.resolveDate">Resolve Date</span></dt><dd><span>{{vm.tickets.resolveDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.tickets.assignDate">Assign Date</span></dt><dd><span>{{vm.tickets.assignDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.tickets.assignedDepartmentId">Assigned Department Id</span></dt><dd><span>{{vm.tickets.assignedDepartmentId}}</span></dd><dt><span data-translate="investhryApp.tickets.assignedDepartmentName">Assigned Department Name</span></dt><dd><span>{{vm.tickets.assignedDepartmentName}}</span></dd><dt><span data-translate="investhryApp.tickets.assignedMemberId">Assigned Member Id</span></dt><dd><span>{{vm.tickets.assignedMemberId}}</span></dd><dt><span data-translate="investhryApp.tickets.assignedMemberName">Assigned Member Name</span></dt><dd><span>{{vm.tickets.assignedMemberName}}</span></dd><dt><span data-translate="investhryApp.tickets.subject">Subject</span></dt><dd><span>{{vm.tickets.subject}}</span></dd><dt><span data-translate="investhryApp.tickets.description">Description</span></dt><dd><span>{{vm.tickets.description}}</span></dd><dt><span data-translate="investhryApp.tickets.status">Status</span></dt><dd><span>{{vm.tickets.status}}</span></dd><dt><span data-translate="investhryApp.tickets.projectid">Projectid</span></dt><dd><span>{{vm.tickets.projectid}}</span></dd><dt><span data-translate="investhryApp.tickets.serviceid">Serviceid</span></dt><dd><span>{{vm.tickets.serviceid}}</span></dd><dt><span data-translate="investhryApp.tickets.priority">Priority</span></dt><dd><span>{{vm.tickets.priority}}</span></dd><dt><span data-translate="investhryApp.tickets.incidentCategory">Incident Category</span></dt><dd><span>{{vm.tickets.incidentCategory}}</span></dd><dt><span data-translate="investhryApp.tickets.level">Level</span></dt><dd><span>{{vm.tickets.level}}</span></dd><dt><span data-translate="investhryApp.tickets.investorType">Investor Type</span></dt><dd><span>{{vm.tickets.investorType}}</span></dd><dt><span data-translate="investhryApp.tickets.nextLevelMember">Next Level Member</span></dt><dd><span>{{vm.tickets.nextLevelMember}}</span></dd><dt><span data-translate="investhryApp.tickets.timeLeft">Time Left</span></dt><dd><span>{{vm.tickets.timeLeft}}</span></dd><dt><span data-translate="investhryApp.tickets.expectedResoluation">Expected Resoluation</span></dt><dd><span>{{vm.tickets.expectedResoluation | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.tickets.nextLevelMemberId">Next Level Member Id</span></dt><dd><span>{{vm.tickets.nextLevelMemberId}}</span></dd><dt><span data-translate="investhryApp.tickets.createdBy">Created By</span></dt><dd><span>{{vm.tickets.createdBy}}</span></dd><dt><span data-translate="investhryApp.tickets.attachment">Attachment</span></dt><dd><span>{{vm.tickets.attachment}}</span></dd><dt><span data-translate="investhryApp.tickets.assignedMemberUserName">Assigned Member User Name</span></dt><dd><span>{{vm.tickets.assignedMemberUserName}}</span></dd><dt><span data-translate="investhryApp.tickets.nextLevelMemberName">Next Level Member Name</span></dt><dd><span>{{vm.tickets.nextLevelMemberName}}</span></dd><dt><span data-translate="investhryApp.tickets.createdByName">Created By Name</span></dt><dd><span>{{vm.tickets.createdByName}}</span></dd><dt><span data-translate="investhryApp.tickets.isOpen">Is Open</span></dt><dd><span>{{vm.tickets.isOpen}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tickets-detail.edit({id:vm.tickets.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tickets/tickets-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicketsLabel" data-translate="investhryApp.tickets.home.createOrEditLabel">Create or edit a Tickets</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tickets.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tickets.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.ticketNumber" for="field_ticketNumber">Ticket Number</label><input type="text" class="form-control" name="ticketNumber" id="field_ticketNumber" ng-model="vm.tickets.ticketNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.tickets.cafpin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.investorDetail" for="field_investorDetail">Investor Detail</label><input type="text" class="form-control" name="investorDetail" id="field_investorDetail" ng-model="vm.tickets.investorDetail"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.latestRemark" for="field_latestRemark">Latest Remark</label><input type="text" class="form-control" name="latestRemark" id="field_latestRemark" ng-model="vm.tickets.latestRemark"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.creationDate" for="field_creationDate">Creation Date</label><div class="input-group"><input id="field_creationDate" type="text" class="form-control" name="creationDate" datetime-picker="{{dateformat}}" ng-model="vm.tickets.creationDate" is-open="vm.datePickerOpenStatus.creationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.resolveDate" for="field_resolveDate">Resolve Date</label><div class="input-group"><input id="field_resolveDate" type="text" class="form-control" name="resolveDate" datetime-picker="{{dateformat}}" ng-model="vm.tickets.resolveDate" is-open="vm.datePickerOpenStatus.resolveDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'resolveDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.assignDate" for="field_assignDate">Assign Date</label><div class="input-group"><input id="field_assignDate" type="text" class="form-control" name="assignDate" datetime-picker="{{dateformat}}" ng-model="vm.tickets.assignDate" is-open="vm.datePickerOpenStatus.assignDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'assignDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.assignedDepartmentId" for="field_assignedDepartmentId">Assigned Department Id</label><input type="text" class="form-control" name="assignedDepartmentId" id="field_assignedDepartmentId" ng-model="vm.tickets.assignedDepartmentId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.assignedDepartmentName" for="field_assignedDepartmentName">Assigned Department Name</label><input type="text" class="form-control" name="assignedDepartmentName" id="field_assignedDepartmentName" ng-model="vm.tickets.assignedDepartmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.assignedMemberId" for="field_assignedMemberId">Assigned Member Id</label><input type="text" class="form-control" name="assignedMemberId" id="field_assignedMemberId" ng-model="vm.tickets.assignedMemberId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.assignedMemberName" for="field_assignedMemberName">Assigned Member Name</label><input type="text" class="form-control" name="assignedMemberName" id="field_assignedMemberName" ng-model="vm.tickets.assignedMemberName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.subject" for="field_subject">Subject</label><input type="text" class="form-control" name="subject" id="field_subject" ng-model="vm.tickets.subject"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.description" for="field_description">Description</label><input type="text" class="form-control" name="description" id="field_description" ng-model="vm.tickets.description"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.tickets.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.tickets.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.tickets.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.priority" for="field_priority">Priority</label><input type="text" class="form-control" name="priority" id="field_priority" ng-model="vm.tickets.priority"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.incidentCategory" for="field_incidentCategory">Incident Category</label><input type="text" class="form-control" name="incidentCategory" id="field_incidentCategory" ng-model="vm.tickets.incidentCategory"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.level" for="field_level">Level</label><input type="text" class="form-control" name="level" id="field_level" ng-model="vm.tickets.level"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.investorType" for="field_investorType">Investor Type</label><input type="text" class="form-control" name="investorType" id="field_investorType" ng-model="vm.tickets.investorType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.nextLevelMember" for="field_nextLevelMember">Next Level Member</label><input type="text" class="form-control" name="nextLevelMember" id="field_nextLevelMember" ng-model="vm.tickets.nextLevelMember"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.timeLeft" for="field_timeLeft">Time Left</label><input type="number" class="form-control" name="timeLeft" id="field_timeLeft" ng-model="vm.tickets.timeLeft"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.expectedResoluation" for="field_expectedResoluation">Expected Resoluation</label><div class="input-group"><input id="field_expectedResoluation" type="text" class="form-control" name="expectedResoluation" datetime-picker="{{dateformat}}" ng-model="vm.tickets.expectedResoluation" is-open="vm.datePickerOpenStatus.expectedResoluation"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'expectedResoluation\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.nextLevelMemberId" for="field_nextLevelMemberId">Next Level Member Id</label><input type="text" class="form-control" name="nextLevelMemberId" id="field_nextLevelMemberId" ng-model="vm.tickets.nextLevelMemberId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.createdBy" for="field_createdBy">Created By</label><input type="text" class="form-control" name="createdBy" id="field_createdBy" ng-model="vm.tickets.createdBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.attachment" for="field_attachment">Attachment</label><input type="text" class="form-control" name="attachment" id="field_attachment" ng-model="vm.tickets.attachment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.assignedMemberUserName" for="field_assignedMemberUserName">Assigned Member User Name</label><input type="text" class="form-control" name="assignedMemberUserName" id="field_assignedMemberUserName" ng-model="vm.tickets.assignedMemberUserName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.nextLevelMemberName" for="field_nextLevelMemberName">Next Level Member Name</label><input type="text" class="form-control" name="nextLevelMemberName" id="field_nextLevelMemberName" ng-model="vm.tickets.nextLevelMemberName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.createdByName" for="field_createdByName">Created By Name</label><input type="text" class="form-control" name="createdByName" id="field_createdByName" ng-model="vm.tickets.createdByName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tickets.isOpen" for="field_isOpen">Is Open</label><input type="checkbox" name="isOpen" id="field_isOpen" ng-model="vm.tickets.isOpen"></div><div class="form-group"><label class="control-label" for="field_isSaveWithLogs">Is Save With Logs</label><input type="checkbox" name="isOpen" id="field_isSaveWithLogs" ng-model="vm.saveWithLogs"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tickets/tickets.html','<div><br><h2 class="col-md-offset-2" data-translate="investhryApp.tickets.home.title">Search Ticket</h2><jhi-alert></jhi-alert><div class="col-md-6 col-md-offset-2 form-group"><input type="text" class="form-control" ng-model="vm.value" placeholder="Search Ticket by Ticket Number "></div><div class="col-md-2"><span class="col-md-10"><button type="button" class="btn btn-primary" ng-click="vm.searchTicket(vm.value)" ng-disabled="vm.value==null">Search</button></span></div><br><br><br><br><br><br><div ng-show="vm.search"><div class="card-content" ng-show="vm.tickets.length==0"><h3 class="jumbotron text-center">No Ticket found</h3></div><div class="table-responsive" ng-show="vm.tickets.length!=0"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.tickets.ticketNumber">Ticket Number</span></th><th><span data-translate="investhryApp.tickets.cafpin">Cafpin</span></th><th><span data-translate="investhryApp.tickets.investorDetail">Investor Detail</span></th><th><span data-translate="investhryApp.tickets.latestRemark">Latest Remark</span></th><th><span data-translate="investhryApp.tickets.creationDate">Creation Date</span></th><th><span data-translate="investhryApp.tickets.resolveDate">Resolve Date</span></th><th><span data-translate="investhryApp.tickets.assignDate">Assign Date</span></th><th><span data-translate="investhryApp.tickets.assignedDepartmentId">Assigned Department Id</span></th><th><span data-translate="investhryApp.tickets.assignedDepartmentName">Assigned Department Name</span></th><th><span data-translate="investhryApp.tickets.assignedMemberId">Assigned Member Id</span></th><th><span data-translate="investhryApp.tickets.assignedMemberName">Assigned Member Name</span></th><th><span data-translate="investhryApp.tickets.subject">Subject</span></th><th><span data-translate="investhryApp.tickets.description">Description</span></th><th><span data-translate="investhryApp.tickets.status">Status</span></th><th><span data-translate="investhryApp.tickets.projectid">Projectid</span></th><th><span data-translate="investhryApp.tickets.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.tickets.priority">Priority</span></th><th><span data-translate="investhryApp.tickets.incidentCategory">Incident Category</span></th><th><span data-translate="investhryApp.tickets.level">Level</span></th><th><span data-translate="investhryApp.tickets.investorType">Investor Type</span></th><th><span data-translate="investhryApp.tickets.nextLevelMember">Next Level Member</span></th><th><span data-translate="investhryApp.tickets.timeLeft">Time Left</span></th><th><span data-translate="investhryApp.tickets.expectedResoluation">Expected Resoluation</span></th><th><span data-translate="investhryApp.tickets.nextLevelMemberId">Next Level Member Id</span></th><th><span data-translate="investhryApp.tickets.createdBy">Created By</span></th><th><span data-translate="investhryApp.tickets.attachment">Attachment</span></th><th><span data-translate="investhryApp.tickets.assignedMemberUserName">Assigned Member User Name</span></th><th><span data-translate="investhryApp.tickets.nextLevelMemberName">Next Level Member Name</span></th><th><span data-translate="investhryApp.tickets.createdByName">Created By Name</span></th><th><span data-translate="investhryApp.tickets.isOpen">Is Open</span></th><th></th></tr></thead><tbody><tr ng-repeat="tickets in vm.tickets track by tickets.id"><td><a ui-sref="tickets-detail({id:tickets.id})">{{tickets.id}}</a></td><td>{{tickets.ticketNumber}}</td><td>{{tickets.cafpin}}</td><td>{{tickets.investorDetail}}</td><td>{{tickets.latestRemark}}</td><td>{{tickets.creationDate | date:\'medium\'}}</td><td>{{tickets.resolveDate | date:\'medium\'}}</td><td>{{tickets.assignDate | date:\'medium\'}}</td><td>{{tickets.assignedDepartmentId}}</td><td>{{tickets.assignedDepartmentName}}</td><td>{{tickets.assignedMemberId}}</td><td>{{tickets.assignedMemberName}}</td><td>{{tickets.subject}}</td><td>{{tickets.description}}</td><td>{{tickets.status}}</td><td>{{tickets.projectid}}</td><td>{{tickets.serviceid}}</td><td>{{tickets.priority}}</td><td>{{tickets.incidentCategory}}</td><td>{{tickets.level}}</td><td>{{tickets.investorType}}</td><td>{{tickets.nextLevelMember}}</td><td>{{tickets.timeLeft}}</td><td>{{tickets.expectedResoluation | date:\'medium\'}}</td><td>{{tickets.nextLevelMemberId}}</td><td>{{tickets.createdBy}}</td><td>{{tickets.attachment}}</td><td>{{tickets.assignedMemberUserName}}</td><td>{{tickets.nextLevelMemberName}}</td><td>{{tickets.createdByName}}</td><td>{{tickets.isOpen}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tickets-detail({id:tickets.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tickets.edit({id:tickets.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tickets.delete({id:tickets.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><br><br><br><br><br><br></div></div>');
$templateCache.put('app/entities/tickets-customer/tickets-customer-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticketsCustomer.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.ticketsCustomer.delete.question" translate-values="{id: \'{{vm.ticketsCustomer.id}}\'}">Are you sure you want to delete this Tickets Customer?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tickets-customer/tickets-customer-detail.html','<div><h2><span data-translate="investhryApp.ticketsCustomer.detail.title">Tickets Customer</span> {{vm.ticketsCustomer.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.ticketsCustomer.firstName">First Name</span></dt><dd><span>{{vm.ticketsCustomer.firstName}}</span></dd><dt><span data-translate="investhryApp.ticketsCustomer.lastName">Last Name</span></dt><dd><span>{{vm.ticketsCustomer.lastName}}</span></dd><dt><span data-translate="investhryApp.ticketsCustomer.mobileNumber">Mobile Number</span></dt><dd><span>{{vm.ticketsCustomer.mobileNumber}}</span></dd><dt><span data-translate="investhryApp.ticketsCustomer.email">Email</span></dt><dd><span>{{vm.ticketsCustomer.email}}</span></dd><dt><span data-translate="investhryApp.ticketsCustomer.district">District</span></dt><dd><span>{{vm.ticketsCustomer.district}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tickets-customer-detail.edit({id:vm.ticketsCustomer.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tickets-customer/tickets-customer-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicketsCustomerLabel" data-translate="investhryApp.ticketsCustomer.home.createOrEditLabel">Create or edit a Tickets Customer</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ticketsCustomer.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ticketsCustomer.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsCustomer.firstName" for="field_firstName">First Name</label><input type="text" class="form-control" name="firstName" id="field_firstName" ng-model="vm.ticketsCustomer.firstName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsCustomer.lastName" for="field_lastName">Last Name</label><input type="text" class="form-control" name="lastName" id="field_lastName" ng-model="vm.ticketsCustomer.lastName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsCustomer.mobileNumber" for="field_mobileNumber">Mobile Number</label><input type="text" class="form-control" name="mobileNumber" id="field_mobileNumber" ng-model="vm.ticketsCustomer.mobileNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsCustomer.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.ticketsCustomer.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsCustomer.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.ticketsCustomer.district"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tickets-customer/tickets-customers.html','<div><h2 data-translate="investhryApp.ticketsCustomer.home.title">Tickets Customers</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tickets-customer.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.ticketsCustomer.home.createLabel">Create new Tickets Customer</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.ticketsCustomer.firstName">First Name</span></th><th><span data-translate="investhryApp.ticketsCustomer.lastName">Last Name</span></th><th><span data-translate="investhryApp.ticketsCustomer.mobileNumber">Mobile Number</span></th><th><span data-translate="investhryApp.ticketsCustomer.email">Email</span></th><th><span data-translate="investhryApp.ticketsCustomer.district">District</span></th><th></th></tr></thead><tbody><tr ng-repeat="ticketsCustomer in vm.ticketsCustomers track by ticketsCustomer.id"><td><a ui-sref="tickets-customer-detail({id:ticketsCustomer.id})">{{ticketsCustomer.id}}</a></td><td>{{ticketsCustomer.firstName}}</td><td>{{ticketsCustomer.lastName}}</td><td>{{ticketsCustomer.mobileNumber}}</td><td>{{ticketsCustomer.email}}</td><td>{{ticketsCustomer.district}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tickets-customer-detail({id:ticketsCustomer.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tickets-customer.edit({id:ticketsCustomer.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tickets-customer.delete({id:ticketsCustomer.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tickets-feedback/tickets-feedback-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticketsFeedback.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.ticketsFeedback.delete.question" translate-values="{id: \'{{vm.ticketsFeedback.id}}\'}">Are you sure you want to delete this Tickets Feedback?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tickets-feedback/tickets-feedback-detail.html','<div><h2><span data-translate="investhryApp.ticketsFeedback.detail.title">Tickets Feedback</span> {{vm.ticketsFeedback.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.ticketsFeedback.ticketNumber">Ticket Number</span></dt><dd><span>{{vm.ticketsFeedback.ticketNumber}}</span></dd><dt><span data-translate="investhryApp.ticketsFeedback.category">Category</span></dt><dd><span>{{vm.ticketsFeedback.category}}</span></dd><dt><span data-translate="investhryApp.ticketsFeedback.investorDetail">Investor Detail</span></dt><dd><span>{{vm.ticketsFeedback.investorDetail}}</span></dd><dt><span data-translate="investhryApp.ticketsFeedback.investorName">Investor Name</span></dt><dd><span>{{vm.ticketsFeedback.investorName}}</span></dd><dt><span data-translate="investhryApp.ticketsFeedback.rating">Rating</span></dt><dd><span>{{vm.ticketsFeedback.rating}}</span></dd><dt><span data-translate="investhryApp.ticketsFeedback.ratingRemark">Rating Remark</span></dt><dd><span>{{vm.ticketsFeedback.ratingRemark}}</span></dd><dt><span data-translate="investhryApp.ticketsFeedback.ratingDate">Rating Date</span></dt><dd><span>{{vm.ticketsFeedback.ratingDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.ticketsFeedback.departmentName">Department Name</span></dt><dd><span>{{vm.ticketsFeedback.departmentName}}</span></dd><dt><span data-translate="investhryApp.ticketsFeedback.closedBy">Closed By</span></dt><dd><span>{{vm.ticketsFeedback.closedBy}}</span></dd><dt><span data-translate="investhryApp.ticketsFeedback.closingDate">Closing Date</span></dt><dd><span>{{vm.ticketsFeedback.closingDate | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tickets-feedback-detail.edit({id:vm.ticketsFeedback.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tickets-feedback/tickets-feedback-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicketsFeedbackLabel" data-translate="investhryApp.ticketsFeedback.home.createOrEditLabel">Create or edit a Tickets Feedback</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ticketsFeedback.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ticketsFeedback.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsFeedback.ticketNumber" for="field_ticketNumber">Ticket Number</label><input type="text" class="form-control" name="ticketNumber" id="field_ticketNumber" ng-model="vm.ticketsFeedback.ticketNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsFeedback.category" for="field_category">Category</label><input type="text" class="form-control" name="category" id="field_category" ng-model="vm.ticketsFeedback.category"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsFeedback.investorDetail" for="field_investorDetail">Investor Detail</label><input type="text" class="form-control" name="investorDetail" id="field_investorDetail" ng-model="vm.ticketsFeedback.investorDetail"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsFeedback.investorName" for="field_investorName">Investor Name</label><input type="text" class="form-control" name="investorName" id="field_investorName" ng-model="vm.ticketsFeedback.investorName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsFeedback.rating" for="field_rating">Rating</label><input type="text" class="form-control" name="rating" id="field_rating" ng-model="vm.ticketsFeedback.rating"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsFeedback.ratingRemark" for="field_ratingRemark">Rating Remark</label><input type="text" class="form-control" name="ratingRemark" id="field_ratingRemark" ng-model="vm.ticketsFeedback.ratingRemark"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsFeedback.ratingDate" for="field_ratingDate">Rating Date</label><div class="input-group"><input id="field_ratingDate" type="text" class="form-control" name="ratingDate" datetime-picker="{{dateformat}}" ng-model="vm.ticketsFeedback.ratingDate" is-open="vm.datePickerOpenStatus.ratingDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'ratingDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsFeedback.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.ticketsFeedback.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsFeedback.closedBy" for="field_closedBy">Closed By</label><input type="text" class="form-control" name="closedBy" id="field_closedBy" ng-model="vm.ticketsFeedback.closedBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsFeedback.closingDate" for="field_closingDate">Closing Date</label><div class="input-group"><input id="field_closingDate" type="text" class="form-control" name="closingDate" datetime-picker="{{dateformat}}" ng-model="vm.ticketsFeedback.closingDate" is-open="vm.datePickerOpenStatus.closingDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'closingDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tickets-feedback/tickets-feedbacks.html','<div><h2 data-translate="investhryApp.ticketsFeedback.home.title">Tickets Feedbacks</h2><br><br><br><jhi-alert></jhi-alert><!--<div class="container-fluid"><br><br><br>--><!--<div class="row">--><!--&lt;!&ndash;<div class="col-xs-4 no-padding-left">&ndash;&gt;--><!--&lt;!&ndash;<button class="btn btn-primary" ui-sref="tickets-feedback.new" >&ndash;&gt;--><!--&lt;!&ndash;<span class="glyphicon glyphicon-plus"></span>&ndash;&gt;--><!--&lt;!&ndash;<span  data-translate="investhryApp.ticketsFeedback.home.createLabel">&ndash;&gt;--><!--&lt;!&ndash;Create new Tickets Feedback&ndash;&gt;--><!--&lt;!&ndash;</span>&ndash;&gt;--><!--&lt;!&ndash;</button>&ndash;&gt;--><!--&lt;!&ndash;</div>&ndash;&gt;--><!--</div>--><!--</div>--><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.ticketsFeedback.ticketNumber">Ticket Number</span></th><th><span data-translate="investhryApp.ticketsFeedback.category">Category</span></th><th><span data-translate="investhryApp.ticketsFeedback.investorDetail">Investor Detail</span></th><th><span data-translate="investhryApp.ticketsFeedback.investorName">Investor Name</span></th><th><span data-translate="investhryApp.ticketsFeedback.rating">Rating</span></th><th><span data-translate="investhryApp.ticketsFeedback.ratingRemark">Rating Remark</span></th><th><span data-translate="investhryApp.ticketsFeedback.ratingDate">Rating Date</span></th><th><span data-translate="investhryApp.ticketsFeedback.departmentName">Department Name</span></th><th><span data-translate="investhryApp.ticketsFeedback.closedBy">Closed By</span></th><th><span data-translate="investhryApp.ticketsFeedback.closingDate">Closing Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="ticketsFeedback in vm.ticketsFeedbacks"><td><a ui-sref="tickets-feedback-detail({id:ticketsFeedback.id})">{{ticketsFeedback.id}}</a></td><td>{{ticketsFeedback.ticketNumber}}</td><td>{{ticketsFeedback.category}}</td><td>{{ticketsFeedback.investorDetail}}</td><td>{{ticketsFeedback.investorName}}</td><td>{{ticketsFeedback.rating}}</td><td>{{ticketsFeedback.ratingRemark}}</td><td>{{ticketsFeedback.ratingDate | date:\'medium\'}}</td><td>{{ticketsFeedback.departmentName}}</td><td>{{ticketsFeedback.closedBy}}</td><td>{{ticketsFeedback.closingDate | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><!--<button type="submit"--><!--ui-sref="tickets-feedback-detail({id:ticketsFeedback.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="tickets-feedback.edit({id:ticketsFeedback.id})"--><!--class="btn btn-primary btn-sm">--><!--<span class="glyphicon glyphicon-pencil"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.edit"></span>--><!--</button>--><!--<button type="submit"--><!--ui-sref="tickets-feedback.delete({id:ticketsFeedback.id})"--><!--class="btn btn-danger btn-sm">--><!--<span class="glyphicon glyphicon-remove-circle"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.delete"></span>--><!--</button>--> <button type="button" data-target="#deleteTicketFeedback" data-toggle="modal" class="btn btn-danger btn-sm" ng-click="vm.selectedFeedback(ticketsFeedback)"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><div id="deleteTicketFeedback" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Confirm Delete Operation</h4></div><div class="modal-body"><p>Are you sure want to delete feedback with id: {{vm.ticketFeedback.id}}</p></div><div class="modal-footer"><button type="button" class="btn btn-primary" data-dismiss="modal">Cancel</button> <button type="button" class="btn btn-danger" data-dismiss="modal" ng-click="vm.deleteFeedback(vm.ticketFeedback)">Delete</button></div></div></div></div>');
$templateCache.put('app/entities/tickets-logs/tickets-logs-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.ticketsLogs.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.ticketsLogs.delete.question" translate-values="{id: \'{{vm.ticketsLogs.id}}\'}">Are you sure you want to delete this Tickets Logs?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tickets-logs/tickets-logs-detail.html','<div><h2><span data-translate="investhryApp.ticketsLogs.detail.title">Tickets Logs</span> {{vm.ticketsLogs.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.ticketsLogs.ticketId">Ticket Id</span></dt><dd><span>{{vm.ticketsLogs.ticketId}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.ticketNumber">Ticket Number</span></dt><dd><span>{{vm.ticketsLogs.ticketNumber}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.creationDate">Creation Date</span></dt><dd><span>{{vm.ticketsLogs.creationDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.actionBy">Action By</span></dt><dd><span>{{vm.ticketsLogs.actionBy}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.actionDate">Action Date</span></dt><dd><span>{{vm.ticketsLogs.actionDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.actionType">Action Type</span></dt><dd><span>{{vm.ticketsLogs.actionType}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.departmentName">Department Name</span></dt><dd><span>{{vm.ticketsLogs.departmentName}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.departmentId">Department Id</span></dt><dd><span>{{vm.ticketsLogs.departmentId}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.projectid">Projectid</span></dt><dd><span>{{vm.ticketsLogs.projectid}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.serviceid">Serviceid</span></dt><dd><span>{{vm.ticketsLogs.serviceid}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.remark">Remark</span></dt><dd><span>{{vm.ticketsLogs.remark}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.cafpin">Cafpin</span></dt><dd><span>{{vm.ticketsLogs.cafpin}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.status">Status</span></dt><dd><span>{{vm.ticketsLogs.status}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.assignedMember">Assigned Member</span></dt><dd><span>{{vm.ticketsLogs.assignedMember}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.attachment">Attachment</span></dt><dd><span>{{vm.ticketsLogs.attachment}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.actionByName">Action By Name</span></dt><dd><span>{{vm.ticketsLogs.actionByName}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.assignedMemberName">Assigned Member Name</span></dt><dd><span>{{vm.ticketsLogs.assignedMemberName}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.lastAssigned">Last Assigned</span></dt><dd><span>{{vm.ticketsLogs.lastAssigned}}</span></dd><dt><span data-translate="investhryApp.ticketsLogs.lastAssignedName">Last Assigned Name</span></dt><dd><span>{{vm.ticketsLogs.lastAssignedName}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tickets-logs-detail.edit({id:vm.ticketsLogs.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tickets-logs/tickets-logs-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTicketsLogsLabel" data-translate="investhryApp.ticketsLogs.home.createOrEditLabel">Create or edit a Tickets Logs</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ticketsLogs.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ticketsLogs.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.ticketId" for="field_ticketId">Ticket Id</label><input type="text" class="form-control" name="ticketId" id="field_ticketId" ng-model="vm.ticketsLogs.ticketId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.ticketNumber" for="field_ticketNumber">Ticket Number</label><input type="text" class="form-control" name="ticketNumber" id="field_ticketNumber" ng-model="vm.ticketsLogs.ticketNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.creationDate" for="field_creationDate">Creation Date</label><div class="input-group"><input id="field_creationDate" type="text" class="form-control" name="creationDate" datetime-picker="{{dateformat}}" ng-model="vm.ticketsLogs.creationDate" is-open="vm.datePickerOpenStatus.creationDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'creationDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.actionBy" for="field_actionBy">Action By</label><input type="text" class="form-control" name="actionBy" id="field_actionBy" ng-model="vm.ticketsLogs.actionBy"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.actionDate" for="field_actionDate">Action Date</label><div class="input-group"><input id="field_actionDate" type="text" class="form-control" name="actionDate" datetime-picker="{{dateformat}}" ng-model="vm.ticketsLogs.actionDate" is-open="vm.datePickerOpenStatus.actionDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'actionDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.actionType" for="field_actionType">Action Type</label><input type="text" class="form-control" name="actionType" id="field_actionType" ng-model="vm.ticketsLogs.actionType"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.departmentName" for="field_departmentName">Department Name</label><input type="text" class="form-control" name="departmentName" id="field_departmentName" ng-model="vm.ticketsLogs.departmentName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.departmentId" for="field_departmentId">Department Id</label><input type="text" class="form-control" name="departmentId" id="field_departmentId" ng-model="vm.ticketsLogs.departmentId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.ticketsLogs.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.ticketsLogs.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.remark" for="field_remark">Remark</label><input type="text" class="form-control" name="remark" id="field_remark" ng-model="vm.ticketsLogs.remark"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.ticketsLogs.cafpin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.ticketsLogs.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.assignedMember" for="field_assignedMember">Assigned Member</label><input type="text" class="form-control" name="assignedMember" id="field_assignedMember" ng-model="vm.ticketsLogs.assignedMember"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.attachment" for="field_attachment">Attachment</label><input type="text" class="form-control" name="attachment" id="field_attachment" ng-model="vm.ticketsLogs.attachment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.actionByName" for="field_actionByName">Action By Name</label><input type="text" class="form-control" name="actionByName" id="field_actionByName" ng-model="vm.ticketsLogs.actionByName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.assignedMemberName" for="field_assignedMemberName">Assigned Member Name</label><input type="text" class="form-control" name="assignedMemberName" id="field_assignedMemberName" ng-model="vm.ticketsLogs.assignedMemberName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.lastAssigned" for="field_lastAssigned">Last Assigned</label><input type="text" class="form-control" name="lastAssigned" id="field_lastAssigned" ng-model="vm.ticketsLogs.lastAssigned"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.ticketsLogs.lastAssignedName" for="field_lastAssignedName">Last Assigned Name</label><input type="text" class="form-control" name="lastAssignedName" id="field_lastAssignedName" ng-model="vm.ticketsLogs.lastAssignedName"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tickets-logs/tickets-logs.html','<div><br><br><h2 class="col-md-offset-2" data-translate="investhryApp.ticketsLogs.home.title">Tickets Logs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="col-md-6 col-md-offset-2 form-group"><input type="text" class="form-control" ng-model="vm.value" placeholder="Search Ticket Logs by Ticket Number "></div><div class="col-md-2"><span class="col-md-10"><button type="button" class="btn btn-primary" ng-click="vm.searchTicketLogs(vm.value)" ng-disabled="vm.value==null">Search</button></span></div><br><br><br><br><br><br></div><br><div ng-show="vm.search"><div class="text-center" ng-show="vm.ticketsLogs.length ==0 "><h2>No Logs found</h2></div><div class="table-responsive" ng-show="vm.ticketsLogs.length !=0 "><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.ticketsLogs.ticketId">Ticket Id</span></th><th><span data-translate="investhryApp.ticketsLogs.ticketNumber">Ticket Number</span></th><th><span data-translate="investhryApp.ticketsLogs.creationDate">Creation Date</span></th><th><span data-translate="investhryApp.ticketsLogs.actionBy">Action By</span></th><th><span data-translate="investhryApp.ticketsLogs.actionDate">Action Date</span></th><th><span data-translate="investhryApp.ticketsLogs.actionType">Action Type</span></th><th><span data-translate="investhryApp.ticketsLogs.departmentName">Department Name</span></th><th><span data-translate="investhryApp.ticketsLogs.departmentId">Department Id</span></th><th><span data-translate="investhryApp.ticketsLogs.projectid">Projectid</span></th><th><span data-translate="investhryApp.ticketsLogs.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.ticketsLogs.remark">Remark</span></th><th><span data-translate="investhryApp.ticketsLogs.cafpin">Cafpin</span></th><th><span data-translate="investhryApp.ticketsLogs.status">Status</span></th><th><span data-translate="investhryApp.ticketsLogs.assignedMember">Assigned Member</span></th><th><span data-translate="investhryApp.ticketsLogs.attachment">Attachment</span></th><th><span data-translate="investhryApp.ticketsLogs.actionByName">Action By Name</span></th><th><span data-translate="investhryApp.ticketsLogs.assignedMemberName">Assigned Member Name</span></th><th><span data-translate="investhryApp.ticketsLogs.lastAssigned">Last Assigned</span></th><th><span data-translate="investhryApp.ticketsLogs.lastAssignedName">Last Assigned Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="ticketsLogs in vm.ticketsLogs track by ticketsLogs.id"><td><a ui-sref="tickets-logs-detail({id:ticketsLogs.id})">{{ticketsLogs.id}}</a></td><td>{{ticketsLogs.ticketId}}</td><td>{{ticketsLogs.ticketNumber}}</td><td>{{ticketsLogs.creationDate | date:\'medium\'}}</td><td>{{ticketsLogs.actionBy}}</td><td>{{ticketsLogs.actionDate | date:\'medium\'}}</td><td>{{ticketsLogs.actionType}}</td><td>{{ticketsLogs.departmentName}}</td><td>{{ticketsLogs.departmentId}}</td><td>{{ticketsLogs.projectid}}</td><td>{{ticketsLogs.serviceid}}</td><td>{{ticketsLogs.remark}}</td><td>{{ticketsLogs.cafpin}}</td><td>{{ticketsLogs.status}}</td><td>{{ticketsLogs.assignedMember}}</td><td>{{ticketsLogs.attachment}}</td><td>{{ticketsLogs.actionByName}}</td><td>{{ticketsLogs.assignedMemberName}}</td><td>{{ticketsLogs.lastAssigned}}</td><td>{{ticketsLogs.lastAssignedName}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tickets-logs-detail({id:ticketsLogs.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tickets-logs.edit({id:ticketsLogs.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tickets-logs.delete({id:ticketsLogs.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div><br><br><br><br><br></div>');
$templateCache.put('app/entities/totalservicedashboarddetails/totalservicedashboarddetails-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.totalservicedashboarddetails.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.totalservicedashboarddetails.delete.question" translate-values="{id: \'{{vm.totalservicedashboarddetails.id}}\'}">Are you sure you want to delete this Totalservicedashboarddetails?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/totalservicedashboarddetails/totalservicedashboarddetails-detail.html','<div><h2><span data-translate="investhryApp.totalservicedashboarddetails.detail.title">Totalservicedashboarddetails</span> {{vm.totalservicedashboarddetails.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.totalservicedashboarddetails.projectid">Projectid</span></dt><dd><span>{{vm.totalservicedashboarddetails.projectid}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.serviceid">Serviceid</span></dt><dd><span>{{vm.totalservicedashboarddetails.serviceid}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.cafpin">Cafpin</span></dt><dd><span>{{vm.totalservicedashboarddetails.cafpin}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.businessentity">Businessentity</span></dt><dd><span>{{vm.totalservicedashboarddetails.businessentity}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.district">District</span></dt><dd><span>{{vm.totalservicedashboarddetails.district}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.projectlevel">Projectlevel</span></dt><dd><span>{{vm.totalservicedashboarddetails.projectlevel}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.proposedemployement">Proposedemployement</span></dt><dd><span>{{vm.totalservicedashboarddetails.proposedemployement}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.projectinvestment">Projectinvestment</span></dt><dd><span>{{vm.totalservicedashboarddetails.projectinvestment}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.deactivated">Deactivated</span></dt><dd><span>{{vm.totalservicedashboarddetails.deactivated}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.status">Status</span></dt><dd><span>{{vm.totalservicedashboarddetails.status}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.formfilleddate">Formfilleddate</span></dt><dd><span>{{vm.totalservicedashboarddetails.formfilleddate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.formfilledstatus">Formfilledstatus</span></dt><dd><span>{{vm.totalservicedashboarddetails.formfilledstatus}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.isapplied">Isapplied</span></dt><dd><span>{{vm.totalservicedashboarddetails.isapplied}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.servicename">Servicename</span></dt><dd><span>{{vm.totalservicedashboarddetails.servicename}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.departmentname">Departmentname</span></dt><dd><span>{{vm.totalservicedashboarddetails.departmentname}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.investorName">Investor Name</span></dt><dd><span>{{vm.totalservicedashboarddetails.investorName}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.investorEmail">Investor Email</span></dt><dd><span>{{vm.totalservicedashboarddetails.investorEmail}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.investorContact">Investor Contact</span></dt><dd><span>{{vm.totalservicedashboarddetails.investorContact}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.serviceAppliedDate">Service Applied Date</span></dt><dd><span>{{vm.totalservicedashboarddetails.serviceAppliedDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.serviceClearedDate">Service Cleared Date</span></dt><dd><span>{{vm.totalservicedashboarddetails.serviceClearedDate | date:\'mediumDate\'}}</span></dd><dt><span data-translate="investhryApp.totalservicedashboarddetails.address">Address</span></dt><dd><span>{{vm.totalservicedashboarddetails.address}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="totalservicedashboarddetails-detail.edit({id:vm.totalservicedashboarddetails.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/totalservicedashboarddetails/totalservicedashboarddetails-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTotalservicedashboarddetailsLabel" data-translate="investhryApp.totalservicedashboarddetails.home.createOrEditLabel">Create or edit a Totalservicedashboarddetails</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.totalservicedashboarddetails.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.totalservicedashboarddetails.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.totalservicedashboarddetails.projectid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.serviceid" for="field_serviceid">Serviceid</label><input type="text" class="form-control" name="serviceid" id="field_serviceid" ng-model="vm.totalservicedashboarddetails.serviceid"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.cafpin" for="field_cafpin">Cafpin</label><input type="text" class="form-control" name="cafpin" id="field_cafpin" ng-model="vm.totalservicedashboarddetails.cafpin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.businessentity" for="field_businessentity">Businessentity</label><input type="text" class="form-control" name="businessentity" id="field_businessentity" ng-model="vm.totalservicedashboarddetails.businessentity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.district" for="field_district">District</label><input type="text" class="form-control" name="district" id="field_district" ng-model="vm.totalservicedashboarddetails.district"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.projectlevel" for="field_projectlevel">Projectlevel</label><input type="text" class="form-control" name="projectlevel" id="field_projectlevel" ng-model="vm.totalservicedashboarddetails.projectlevel"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.proposedemployement" for="field_proposedemployement">Proposedemployement</label><input type="number" class="form-control" name="proposedemployement" id="field_proposedemployement" ng-model="vm.totalservicedashboarddetails.proposedemployement"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.projectinvestment" for="field_projectinvestment">Projectinvestment</label><input type="number" class="form-control" name="projectinvestment" id="field_projectinvestment" ng-model="vm.totalservicedashboarddetails.projectinvestment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.deactivated" for="field_deactivated">Deactivated</label><input type="checkbox" name="deactivated" id="field_deactivated" ng-model="vm.totalservicedashboarddetails.deactivated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.totalservicedashboarddetails.status"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.formfilleddate" for="field_formfilleddate">Formfilleddate</label><div class="input-group"><input id="field_formfilleddate" type="text" class="form-control" name="formfilleddate" datetime-picker="{{dateformat}}" ng-model="vm.totalservicedashboarddetails.formfilleddate" is-open="vm.datePickerOpenStatus.formfilleddate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'formfilleddate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.formfilledstatus" for="field_formfilledstatus">Formfilledstatus</label><input type="checkbox" name="formfilledstatus" id="field_formfilledstatus" ng-model="vm.totalservicedashboarddetails.formfilledstatus"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.isapplied" for="field_isapplied">Isapplied</label><input type="checkbox" name="isapplied" id="field_isapplied" ng-model="vm.totalservicedashboarddetails.isapplied"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.servicename" for="field_servicename">Servicename</label><input type="text" class="form-control" name="servicename" id="field_servicename" ng-model="vm.totalservicedashboarddetails.servicename"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.departmentname" for="field_departmentname">Departmentname</label><input type="text" class="form-control" name="departmentname" id="field_departmentname" ng-model="vm.totalservicedashboarddetails.departmentname"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.investorName" for="field_investorName">Investor Name</label><input type="text" class="form-control" name="investorName" id="field_investorName" ng-model="vm.totalservicedashboarddetails.investorName"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.investorEmail" for="field_investorEmail">Investor Email</label><input type="text" class="form-control" name="investorEmail" id="field_investorEmail" ng-model="vm.totalservicedashboarddetails.investorEmail"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.investorContact" for="field_investorContact">Investor Contact</label><input type="text" class="form-control" name="investorContact" id="field_investorContact" ng-model="vm.totalservicedashboarddetails.investorContact"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.serviceAppliedDate" for="field_serviceAppliedDate">Service Applied Date</label><div class="input-group"><input id="field_serviceAppliedDate" type="text" class="form-control" name="serviceAppliedDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.totalservicedashboarddetails.serviceAppliedDate" is-open="vm.datePickerOpenStatus.serviceAppliedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'serviceAppliedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.serviceClearedDate" for="field_serviceClearedDate">Service Cleared Date</label><div class="input-group"><input id="field_serviceClearedDate" type="text" class="form-control" name="serviceClearedDate" uib-datepicker-popup="{{dateformat}}" ng-model="vm.totalservicedashboarddetails.serviceClearedDate" is-open="vm.datePickerOpenStatus.serviceClearedDate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'serviceClearedDate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.totalservicedashboarddetails.address" for="field_address">Address</label><input type="text" class="form-control" name="address" id="field_address" ng-model="vm.totalservicedashboarddetails.address"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/totalservicedashboarddetails/totalservicedashboarddetails.html','<div><h2 data-translate="investhryApp.totalservicedashboarddetails.home.title">Totalservicedashboarddetails</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="totalservicedashboarddetails.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.totalservicedashboarddetails.home.createLabel">Create new Totalservicedashboarddetails</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.projectid">Projectid</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.serviceid">Serviceid</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.cafpin">Cafpin</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.businessentity">Businessentity</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.district">District</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.projectlevel">Projectlevel</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.proposedemployement">Proposedemployement</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.projectinvestment">Projectinvestment</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.deactivated">Deactivated</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.status">Status</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.formfilleddate">Formfilleddate</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.formfilledstatus">Formfilledstatus</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.isapplied">Isapplied</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.servicename">Servicename</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.departmentname">Departmentname</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.investorName">Investor Name</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.investorEmail">Investor Email</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.investorContact">Investor Contact</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.serviceAppliedDate">Service Applied Date</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.serviceClearedDate">Service Cleared Date</span></th><th><span data-translate="investhryApp.totalservicedashboarddetails.address">Address</span></th><th></th></tr></thead><tbody><tr ng-repeat="totalservicedashboarddetails in vm.totalservicedashboarddetails track by totalservicedashboarddetails.id"><td><a ui-sref="totalservicedashboarddetails-detail({id:totalservicedashboarddetails.id})">{{totalservicedashboarddetails.id}}</a></td><td>{{totalservicedashboarddetails.projectid}}</td><td>{{totalservicedashboarddetails.serviceid}}</td><td>{{totalservicedashboarddetails.cafpin}}</td><td>{{totalservicedashboarddetails.businessentity}}</td><td>{{totalservicedashboarddetails.district}}</td><td>{{totalservicedashboarddetails.projectlevel}}</td><td>{{totalservicedashboarddetails.proposedemployement}}</td><td>{{totalservicedashboarddetails.projectinvestment}}</td><td>{{totalservicedashboarddetails.deactivated}}</td><td>{{totalservicedashboarddetails.status}}</td><td>{{totalservicedashboarddetails.formfilleddate | date:\'medium\'}}</td><td>{{totalservicedashboarddetails.formfilledstatus}}</td><td>{{totalservicedashboarddetails.isapplied}}</td><td>{{totalservicedashboarddetails.servicename}}</td><td>{{totalservicedashboarddetails.departmentname}}</td><td>{{totalservicedashboarddetails.investorName}}</td><td>{{totalservicedashboarddetails.investorEmail}}</td><td>{{totalservicedashboarddetails.investorContact}}</td><td>{{totalservicedashboarddetails.serviceAppliedDate | date:\'mediumDate\'}}</td><td>{{totalservicedashboarddetails.serviceClearedDate | date:\'mediumDate\'}}</td><td>{{totalservicedashboarddetails.address}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="totalservicedashboarddetails-detail({id:totalservicedashboarddetails.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="totalservicedashboarddetails.edit({id:totalservicedashboarddetails.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="totalservicedashboarddetails.delete({id:totalservicedashboarddetails.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tower-dc/tower-dc-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tower_dc.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.tower_dc.delete.question" translate-values="{id: \'{{vm.tower_dc.id}}\'}">Are you sure you want to delete this Tower Dc?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tower-dc/tower-dc-detail.html','<div><h2><span data-translate="investhryApp.tower_dc.detail.title">Tower Dc</span> {{vm.tower_dc.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.tower_dc.username_dc">Username Dc</span></dt><dd><span>{{vm.tower_dc.username_dc}}</span></dd><dt><span data-translate="investhryApp.tower_dc.district">District</span></dt><dd><span>{{vm.tower_dc.district}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tower-dc-detail.edit({id:vm.tower_dc.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tower-dc/tower-dc-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTower_dcLabel" data-translate="investhryApp.tower_dc.home.createOrEditLabel">Create or edit a Tower Dc</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tower_dc.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tower_dc.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_dc.username_dc" for="field_username_dc">Username Dc</label><input type="text" class="form-control" name="username_dc" id="field_username_dc" ng-model="vm.tower_dc.username_dc" required></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_dc.district" for="field_district">District</label><select type="text" class="form-control" name="district" id="field_district" ng-model="vm.tower_dc.district"><option ng-repeat="district in vm.districts">{{district.districtname}}</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tower-dc/tower-dcs.html','<div><h2 data-translate="investhryApp.tower_dc.home.title">Tower Dcs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tower-dc.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.tower_dc.home.createLabel">Create new Tower Dc</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.tower_dc.username_dc">Username Dc</span></th><th><span data-translate="investhryApp.tower_dc.district">District</span></th><th></th></tr></thead><tbody><tr ng-repeat="tower_dc in vm.tower_dcs track by tower_dc.id"><td><a ui-sref="tower-dc-detail({id:tower_dc.id})">{{tower_dc.id}}</a></td><td>{{tower_dc.username_dc}}</td><td>{{tower_dc.district}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tower-dc-detail({id:tower_dc.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tower-dc.edit({id:tower_dc.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tower-dc.delete({id:tower_dc.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tower-log/tower-log-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tower_log.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.tower_log.delete.question" translate-values="{id: \'{{vm.tower_log.id}}\'}">Are you sure you want to delete this Tower Log?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tower-log/tower-log-detail.html','<div><h2><span data-translate="investhryApp.tower_log.detail.title">Tower Log</span> {{vm.tower_log.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.tower_log.action">Action</span></dt><dd><span>{{vm.tower_log.action}}</span></dd><dt><span data-translate="investhryApp.tower_log.action_by">Action By</span></dt><dd><span>{{vm.tower_log.action_by}}</span></dd><dt><span data-translate="investhryApp.tower_log.comment">Comment</span></dt><dd><span>{{vm.tower_log.comment}}</span></dd><dt><span data-translate="investhryApp.tower_log.tower_id">Tower Id</span></dt><dd><span>{{vm.tower_log.tower_id}}</span></dd><dt><span data-translate="investhryApp.tower_log.action_date">Action Date</span></dt><dd><span>{{vm.tower_log.action_date | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tower-log-detail.edit({id:vm.tower_log.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tower-log/tower-log-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTower_logLabel" data-translate="investhryApp.tower_log.home.createOrEditLabel">Create or edit a Tower Log</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tower_log.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tower_log.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_log.action" for="field_action">Action</label><input type="text" class="form-control" name="action" id="field_action" ng-model="vm.tower_log.action"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_log.action_by" for="field_action_by">Action By</label><input type="text" class="form-control" name="action_by" id="field_action_by" ng-model="vm.tower_log.action_by"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_log.comment" for="field_comment">Comment</label><input type="text" class="form-control" name="comment" id="field_comment" ng-model="vm.tower_log.comment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_log.tower_id" for="field_tower_id">Tower Id</label><input type="text" class="form-control" name="tower_id" id="field_tower_id" ng-model="vm.tower_log.tower_id"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_log.action_date" for="field_action_date">Action Date</label><div class="input-group"><input id="field_action_date" type="text" class="form-control" name="action_date" datetime-picker="{{dateformat}}" ng-model="vm.tower_log.action_date" is-open="vm.datePickerOpenStatus.action_date"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'action_date\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tower-log/tower-logs.html','<div><h2 data-translate="investhryApp.tower_log.home.title">Tower Logs</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tower-log.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.tower_log.home.createLabel">Create new Tower Log</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.tower_log.action">Action</span></th><th><span data-translate="investhryApp.tower_log.action_by">Action By</span></th><th><span data-translate="investhryApp.tower_log.comment">Comment</span></th><th><span data-translate="investhryApp.tower_log.tower_id">Tower Id</span></th><th><span data-translate="investhryApp.tower_log.action_date">Action Date</span></th><th></th></tr></thead><tbody><tr ng-repeat="tower_log in vm.tower_logs track by tower_log.id"><td><a ui-sref="tower-log-detail({id:tower_log.id})">{{tower_log.id}}</a></td><td>{{tower_log.action}}</td><td>{{tower_log.action_by}}</td><td>{{tower_log.comment}}</td><td>{{tower_log.tower_id}}</td><td>{{tower_log.action_date | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tower-log-detail({id:tower_log.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tower-log.edit({id:tower_log.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tower-log.delete({id:tower_log.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tower-rejection-reason/tower-rejection-reason-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.towerRejectionReason.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.towerRejectionReason.delete.question" translate-values="{id: \'{{vm.towerRejectionReason.id}}\'}">Are you sure you want to delete this Tower Rejection Reason?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tower-rejection-reason/tower-rejection-reason-detail.html','<div><h2><span data-translate="investhryApp.towerRejectionReason.detail.title">Tower Rejection Reason</span> {{vm.towerRejectionReason.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.towerRejectionReason.code">Code</span></dt><dd><span>{{vm.towerRejectionReason.code}}</span></dd><dt><span data-translate="investhryApp.towerRejectionReason.category">Category</span></dt><dd><span>{{vm.towerRejectionReason.category}}</span></dd><dt><span data-translate="investhryApp.towerRejectionReason.reason">Reason</span></dt><dd><span>{{vm.towerRejectionReason.reason}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tower-rejection-reason-detail.edit({id:vm.towerRejectionReason.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tower-rejection-reason/tower-rejection-reason-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTowerRejectionReasonLabel" data-translate="investhryApp.towerRejectionReason.home.createOrEditLabel">Create or edit a Tower Rejection Reason</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.towerRejectionReason.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.towerRejectionReason.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerRejectionReason.code" for="field_code">Code</label><input type="text" class="form-control" name="code" id="field_code" ng-model="vm.towerRejectionReason.code"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerRejectionReason.category" for="field_category">Category</label><input type="text" class="form-control" name="category" id="field_category" ng-model="vm.towerRejectionReason.category"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerRejectionReason.reason" for="field_reason">Reason</label><input type="text" class="form-control" name="reason" id="field_reason" ng-model="vm.towerRejectionReason.reason"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tower-rejection-reason/tower-rejection-reasons.html','<div><h2 data-translate="investhryApp.towerRejectionReason.home.title">Tower Rejection Reasons</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tower-rejection-reason.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.towerRejectionReason.home.createLabel">Create new Tower Rejection Reason</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.towerRejectionReason.code">Code</span></th><th><span data-translate="investhryApp.towerRejectionReason.category">Category</span></th><th><span data-translate="investhryApp.towerRejectionReason.reason">Reason</span></th><th></th></tr></thead><tbody><tr ng-repeat="towerRejectionReason in vm.towerRejectionReasons track by towerRejectionReason.id"><td><a ui-sref="tower-rejection-reason-detail({id:towerRejectionReason.id})">{{towerRejectionReason.id}}</a></td><td>{{towerRejectionReason.code}}</td><td>{{towerRejectionReason.category}}</td><td>{{towerRejectionReason.reason}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tower-rejection-reason-detail({id:towerRejectionReason.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tower-rejection-reason.edit({id:towerRejectionReason.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tower-rejection-reason.delete({id:towerRejectionReason.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tower-service-dashboard/tower-service-dashboard-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.tower_service_dashboard.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.tower_service_dashboard.delete.question" translate-values="{id: \'{{vm.tower_service_dashboard.id}}\'}">Are you sure you want to delete this Tower Service Dashboard?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tower-service-dashboard/tower-service-dashboard-detail.html','<div><h2><span data-translate="investhryApp.tower_service_dashboard.detail.title">Tower Service Dashboard</span> {{vm.tower_service_dashboard.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.tower_service_dashboard.service_name">Service Name</span></dt><dd><span>{{vm.tower_service_dashboard.service_name}}</span></dd><dt><span data-translate="investhryApp.tower_service_dashboard.department_name">Department Name</span></dt><dd><span>{{vm.tower_service_dashboard.department_name}}</span></dd><dt><span data-translate="investhryApp.tower_service_dashboard.required">Required</span></dt><dd><span>{{vm.tower_service_dashboard.required}}</span></dd><dt><span data-translate="investhryApp.tower_service_dashboard.applied">Applied</span></dt><dd><span>{{vm.tower_service_dashboard.applied}}</span></dd><dt><span data-translate="investhryApp.tower_service_dashboard.pending_total">Pending Total</span></dt><dd><span>{{vm.tower_service_dashboard.pending_total}}</span></dd><dt><span data-translate="investhryApp.tower_service_dashboard.pending_30">Pending 30</span></dt><dd><span>{{vm.tower_service_dashboard.pending_30}}</span></dd><dt><span data-translate="investhryApp.tower_service_dashboard.pending_45">Pending 45</span></dt><dd><span>{{vm.tower_service_dashboard.pending_45}}</span></dd><dt><span data-translate="investhryApp.tower_service_dashboard.cleared">Cleared</span></dt><dd><span>{{vm.tower_service_dashboard.cleared}}</span></dd><dt><span data-translate="investhryApp.tower_service_dashboard.deactivated">Deactivated</span></dt><dd><span>{{vm.tower_service_dashboard.deactivated}}</span></dd><dt><span data-translate="investhryApp.tower_service_dashboard.deemed">Deemed</span></dt><dd><span>{{vm.tower_service_dashboard.deemed}}</span></dd><dt><span data-translate="investhryApp.tower_service_dashboard.rejected">Rejected</span></dt><dd><span>{{vm.tower_service_dashboard.rejected}}</span></dd><dt><span data-translate="investhryApp.tower_service_dashboard.departmentOrder">Department Order</span></dt><dd><span>{{vm.tower_service_dashboard.departmentOrder}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tower-service-dashboard-detail.edit({id:vm.tower_service_dashboard.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tower-service-dashboard/tower-service-dashboard-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTower_service_dashboardLabel" data-translate="investhryApp.tower_service_dashboard.home.createOrEditLabel">Create or edit a Tower Service Dashboard</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.tower_service_dashboard.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.tower_service_dashboard.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.service_name" for="field_service_name">Service Name</label><input type="text" class="form-control" name="service_name" id="field_service_name" ng-model="vm.tower_service_dashboard.service_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.department_name" for="field_department_name">Department Name</label><input type="text" class="form-control" name="department_name" id="field_department_name" ng-model="vm.tower_service_dashboard.department_name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.required" for="field_required">Required</label><input type="text" class="form-control" name="required" id="field_required" ng-model="vm.tower_service_dashboard.required"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.applied" for="field_applied">Applied</label><input type="text" class="form-control" name="applied" id="field_applied" ng-model="vm.tower_service_dashboard.applied"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.pending_total" for="field_pending_total">Pending Total</label><input type="text" class="form-control" name="pending_total" id="field_pending_total" ng-model="vm.tower_service_dashboard.pending_total"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.pending_30" for="field_pending_30">Pending 30</label><input type="text" class="form-control" name="pending_30" id="field_pending_30" ng-model="vm.tower_service_dashboard.pending_30"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.pending_45" for="field_pending_45">Pending 45</label><input type="text" class="form-control" name="pending_45" id="field_pending_45" ng-model="vm.tower_service_dashboard.pending_45"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.cleared" for="field_cleared">Cleared</label><input type="text" class="form-control" name="cleared" id="field_cleared" ng-model="vm.tower_service_dashboard.cleared"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.deactivated" for="field_deactivated">Deactivated</label><input type="text" class="form-control" name="deactivated" id="field_deactivated" ng-model="vm.tower_service_dashboard.deactivated"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.deemed" for="field_deemed">Deemed</label><input type="text" class="form-control" name="deemed" id="field_deemed" ng-model="vm.tower_service_dashboard.deemed"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.rejected" for="field_rejected">Rejected</label><input type="text" class="form-control" name="rejected" id="field_rejected" ng-model="vm.tower_service_dashboard.rejected"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.tower_service_dashboard.departmentOrder" for="field_departmentOrder">Department Order</label><input type="number" class="form-control" name="departmentOrder" id="field_departmentOrder" ng-model="vm.tower_service_dashboard.departmentOrder"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tower-service-dashboard/tower-service-dashboards.html','<div><h2 data-translate="investhryApp.tower_service_dashboard.home.title">Tower Service Dashboards</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tower-service-dashboard.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.tower_service_dashboard.home.createLabel">Create new Tower Service Dashboard</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.tower_service_dashboard.service_name">Service Name</span></th><th><span data-translate="investhryApp.tower_service_dashboard.department_name">Department Name</span></th><th><span data-translate="investhryApp.tower_service_dashboard.required">Required</span></th><th><span data-translate="investhryApp.tower_service_dashboard.applied">Applied</span></th><th><span data-translate="investhryApp.tower_service_dashboard.pending_total">Pending Total</span></th><th><span data-translate="investhryApp.tower_service_dashboard.pending_30">Pending 30</span></th><th><span data-translate="investhryApp.tower_service_dashboard.pending_45">Pending 45</span></th><th><span data-translate="investhryApp.tower_service_dashboard.cleared">Cleared</span></th><th><span data-translate="investhryApp.tower_service_dashboard.deactivated">Deactivated</span></th><th><span data-translate="investhryApp.tower_service_dashboard.deemed">Deemed</span></th><th><span data-translate="investhryApp.tower_service_dashboard.rejected">Rejected</span></th><th><span data-translate="investhryApp.tower_service_dashboard.departmentOrder">Department Order</span></th><th></th></tr></thead><tbody><tr ng-repeat="tower_service_dashboard in vm.tower_service_dashboards track by tower_service_dashboard.id"><td><a ui-sref="tower-service-dashboard-detail({id:tower_service_dashboard.id})">{{tower_service_dashboard.id}}</a></td><td>{{tower_service_dashboard.service_name}}</td><td>{{tower_service_dashboard.department_name}}</td><td>{{tower_service_dashboard.required}}</td><td>{{tower_service_dashboard.applied}}</td><td>{{tower_service_dashboard.pending_total}}</td><td>{{tower_service_dashboard.pending_30}}</td><td>{{tower_service_dashboard.pending_45}}</td><td>{{tower_service_dashboard.cleared}}</td><td>{{tower_service_dashboard.deactivated}}</td><td>{{tower_service_dashboard.deemed}}</td><td>{{tower_service_dashboard.rejected}}</td><td>{{tower_service_dashboard.departmentOrder}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tower-service-dashboard-detail({id:tower_service_dashboard.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tower-service-dashboard.edit({id:tower_service_dashboard.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tower-service-dashboard.delete({id:tower_service_dashboard.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tower-service-no-require/tower-service-no-require-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.towerServiceNoRequire.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.towerServiceNoRequire.delete.question" translate-values="{id: \'{{vm.towerServiceNoRequire.id}}\'}">Are you sure you want to delete this Tower Service No Require?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tower-service-no-require/tower-service-no-require-detail.html','<div><h2><span data-translate="investhryApp.towerServiceNoRequire.detail.title">Tower Service No Require</span> {{vm.towerServiceNoRequire.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.towerServiceNoRequire.projectId">Project Id</span></dt><dd><span>{{vm.towerServiceNoRequire.projectId}}</span></dd><dt><span data-translate="investhryApp.towerServiceNoRequire.serviceId">Service Id</span></dt><dd><span>{{vm.towerServiceNoRequire.serviceId}}</span></dd><dt><span data-translate="investhryApp.towerServiceNoRequire.officerList">Officer List</span></dt><dd><span>{{vm.towerServiceNoRequire.officerList}}</span></dd><dt><span data-translate="investhryApp.towerServiceNoRequire.subname">Subname</span></dt><dd><span>{{vm.towerServiceNoRequire.subname}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tower-service-no-require-detail.edit({id:vm.towerServiceNoRequire.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tower-service-no-require/tower-service-no-require-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTowerServiceNoRequireLabel" data-translate="investhryApp.towerServiceNoRequire.home.createOrEditLabel">Create or edit a Tower Service No Require</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.towerServiceNoRequire.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.towerServiceNoRequire.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerServiceNoRequire.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.towerServiceNoRequire.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerServiceNoRequire.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.towerServiceNoRequire.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerServiceNoRequire.officerList" for="field_officerList">Officer List</label><input type="text" class="form-control" name="officerList" id="field_officerList" ng-model="vm.towerServiceNoRequire.officerList"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerServiceNoRequire.subname" for="field_subname">Subname</label><input type="text" class="form-control" name="subname" id="field_subname" ng-model="vm.towerServiceNoRequire.subname"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tower-service-no-require/tower-service-no-requires.html','<div><h2 data-translate="investhryApp.towerServiceNoRequire.home.title">Tower Service No Requires</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tower-service-no-require.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.towerServiceNoRequire.home.createLabel">Create new Tower Service No Require</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.towerServiceNoRequire.projectId">Project Id</span></th><th><span data-translate="investhryApp.towerServiceNoRequire.serviceId">Service Id</span></th><th><span data-translate="investhryApp.towerServiceNoRequire.officerList">Officer List</span></th><th><span data-translate="investhryApp.towerServiceNoRequire.subname">Subname</span></th><th></th></tr></thead><tbody><tr ng-repeat="towerServiceNoRequire in vm.towerServiceNoRequires track by towerServiceNoRequire.id"><td><a ui-sref="tower-service-no-require-detail({id:towerServiceNoRequire.id})">{{towerServiceNoRequire.id}}</a></td><td>{{towerServiceNoRequire.projectId}}</td><td>{{towerServiceNoRequire.serviceId}}</td><td>{{towerServiceNoRequire.officerList}}</td><td>{{towerServiceNoRequire.subname}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tower-service-no-require-detail({id:towerServiceNoRequire.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tower-service-no-require.edit({id:towerServiceNoRequire.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tower-service-no-require.delete({id:towerServiceNoRequire.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/tower-update-department/tower-update-department-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.towerUpdateDepartment.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.towerUpdateDepartment.delete.question" translate-values="{id: \'{{vm.towerUpdateDepartment.id}}\'}">Are you sure you want to delete this Tower Update Department?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/tower-update-department/tower-update-department-detail.html','<div><h2><span data-translate="investhryApp.towerUpdateDepartment.detail.title">Tower Update Department</span> {{vm.towerUpdateDepartment.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.towerUpdateDepartment.projectId">Project Id</span></dt><dd><span>{{vm.towerUpdateDepartment.projectId}}</span></dd><dt><span data-translate="investhryApp.towerUpdateDepartment.serviceId">Service Id</span></dt><dd><span>{{vm.towerUpdateDepartment.serviceId}}</span></dd><dt><span data-translate="investhryApp.towerUpdateDepartment.oldDepartment">Old Department</span></dt><dd><span>{{vm.towerUpdateDepartment.oldDepartment}}</span></dd><dt><span data-translate="investhryApp.towerUpdateDepartment.newDepartment">New Department</span></dt><dd><span>{{vm.towerUpdateDepartment.newDepartment}}</span></dd><dt><span data-translate="investhryApp.towerUpdateDepartment.updatedAt">Updated At</span></dt><dd><span>{{vm.towerUpdateDepartment.updatedAt | date:\'medium\'}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="tower-update-department-detail.edit({id:vm.towerUpdateDepartment.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/tower-update-department/tower-update-department-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTowerUpdateDepartmentLabel" data-translate="investhryApp.towerUpdateDepartment.home.createOrEditLabel">Create or edit a Tower Update Department</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.towerUpdateDepartment.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.towerUpdateDepartment.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerUpdateDepartment.projectId" for="field_projectId">Project Id</label><input type="text" class="form-control" name="projectId" id="field_projectId" ng-model="vm.towerUpdateDepartment.projectId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerUpdateDepartment.serviceId" for="field_serviceId">Service Id</label><input type="text" class="form-control" name="serviceId" id="field_serviceId" ng-model="vm.towerUpdateDepartment.serviceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerUpdateDepartment.oldDepartment" for="field_oldDepartment">Old Department</label><input type="text" class="form-control" name="oldDepartment" id="field_oldDepartment" ng-model="vm.towerUpdateDepartment.oldDepartment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerUpdateDepartment.newDepartment" for="field_newDepartment">New Department</label><input type="text" class="form-control" name="newDepartment" id="field_newDepartment" ng-model="vm.towerUpdateDepartment.newDepartment"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerUpdateDepartment.updatedAt" for="field_updatedAt">Updated At</label><div class="input-group"><input id="field_updatedAt" type="text" class="form-control" name="updatedAt" datetime-picker="{{dateformat}}" ng-model="vm.towerUpdateDepartment.updatedAt" is-open="vm.datePickerOpenStatus.updatedAt"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedAt\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/tower-update-department/tower-update-departments.html','<div><h2 data-translate="investhryApp.towerUpdateDepartment.home.title">Tower Update Departments</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="tower-update-department.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.towerUpdateDepartment.home.createLabel">Create new Tower Update Department</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.towerUpdateDepartment.projectId">Project Id</span></th><th><span data-translate="investhryApp.towerUpdateDepartment.serviceId">Service Id</span></th><th><span data-translate="investhryApp.towerUpdateDepartment.oldDepartment">Old Department</span></th><th><span data-translate="investhryApp.towerUpdateDepartment.newDepartment">New Department</span></th><th><span data-translate="investhryApp.towerUpdateDepartment.updatedAt">Updated At</span></th><th></th></tr></thead><tbody><tr ng-repeat="towerUpdateDepartment in vm.towerUpdateDepartments track by towerUpdateDepartment.id"><td><a ui-sref="tower-update-department-detail({id:towerUpdateDepartment.id})">{{towerUpdateDepartment.id}}</a></td><td>{{towerUpdateDepartment.projectId}}</td><td>{{towerUpdateDepartment.serviceId}}</td><td>{{towerUpdateDepartment.oldDepartment}}</td><td>{{towerUpdateDepartment.newDepartment}}</td><td>{{towerUpdateDepartment.updatedAt | date:\'medium\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="tower-update-department-detail({id:towerUpdateDepartment.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="tower-update-department.edit({id:towerUpdateDepartment.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="tower-update-department.delete({id:towerUpdateDepartment.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/towerdclist/towerdclist-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.towerdclist.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.towerdclist.delete.question" translate-values="{id: \'{{vm.towerdclist.id}}\'}">Are you sure you want to delete this Towerdclist?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/towerdclist/towerdclist-detail.html','<div><h2><span data-translate="investhryApp.towerdclist.detail.title">Towerdclist</span> {{vm.towerdclist.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.towerdclist.towerdc_login">Towerdc Login</span></dt><dd><span>{{vm.towerdclist.towerdc_login}}</span></dd><dt><span data-translate="investhryApp.towerdclist.district">District</span></dt><dd><span>{{vm.towerdclist.district}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="towerdclist-detail.edit({id:vm.towerdclist.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/towerdclist/towerdclist-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTowerdclistLabel" data-translate="investhryApp.towerdclist.home.createOrEditLabel">Create or edit a Towerdclist</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.towerdclist.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.towerdclist.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerdclist.towerdc_login" for="field_towerdc_login">Towerdc Login</label><input type="text" class="form-control" name="towerdc_login" id="field_towerdc_login" ng-model="vm.towerdclist.towerdc_login"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.rmlist.district" for="field_district">District</label><select id="field_district" ng-model="vm.towerdclist.district" class="form-control" ng-options="x.districtname as x.districtname for x in vm.districts"><option value="">Select</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/towerdclist/towerdclists.html','<div><h2 data-translate="investhryApp.towerdclist.home.title">Towerdclists</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="towerdclist.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.towerdclist.home.createLabel">Create new Towerdclist</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.towerdclist.towerdc_login">Towerdc Login</span></th><th><span data-translate="investhryApp.towerdclist.district">District</span></th><th></th></tr></thead><tbody><tr ng-repeat="towerdclist in vm.towerdclists track by towerdclist.id"><td><a ui-sref="towerdclist-detail({id:towerdclist.id})">{{towerdclist.id}}</a></td><td>{{towerdclist.towerdc_login}}</td><td>{{towerdclist.district}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="towerdclist-detail({id:towerdclist.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="towerdclist.edit({id:towerdclist.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="towerdclist.delete({id:towerdclist.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/towerdiolist/towerdiolist-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.towerdiolist.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.towerdiolist.delete.question" translate-values="{id: \'{{vm.towerdiolist.id}}\'}">Are you sure you want to delete this Towerdiolist?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/towerdiolist/towerdiolist-detail.html','<div><h2><span data-translate="investhryApp.towerdiolist.detail.title">Towerdiolist</span> {{vm.towerdiolist.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.towerdiolist.towerdioLogin">Towerdio Login</span></dt><dd><span>{{vm.towerdiolist.towerdioLogin}}</span></dd><dt><span data-translate="investhryApp.towerdiolist.district">District</span></dt><dd><span>{{vm.towerdiolist.district}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="towerdiolist-detail.edit({id:vm.towerdiolist.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/towerdiolist/towerdiolist-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTowerdiolistLabel" data-translate="investhryApp.towerdiolist.home.createOrEditLabel">Create or edit a Towerdiolist</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.towerdiolist.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.towerdiolist.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerdiolist.towerdioLogin" for="field_towerdioLogin">Towerdio Login</label><input type="text" class="form-control" name="towerdioLogin" id="field_towerdioLogin" ng-model="vm.towerdiolist.towerdioLogin"></div><div class="form-group"><label class="control-label" for="field_district">District</label><select id="field_district" ng-model="vm.towerdiolist.district" class="form-control" ng-options="x.districtname as x.districtname for x in vm.districts"><option value="">Select</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/towerdiolist/towerdiolists.html','<div><h2 data-translate="investhryApp.towerdiolist.home.title">Towerdiolists</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="towerdiolist.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.towerdiolist.home.createLabel">Create new Towerdiolist</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.towerdiolist.towerdioLogin">Towerdio Login</span></th><th><span data-translate="investhryApp.towerdiolist.district">District</span></th><th></th></tr></thead><tbody><tr ng-repeat="towerdiolist in vm.towerdiolists track by towerdiolist.id"><td><a ui-sref="towerdiolist-detail({id:towerdiolist.id})">{{towerdiolist.id}}</a></td><td>{{towerdiolist.towerdioLogin}}</td><td>{{towerdiolist.district}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="towerdiolist-detail({id:towerdiolist.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="towerdiolist.edit({id:towerdiolist.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="towerdiolist.delete({id:towerdiolist.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/towerofficerlist/towerofficerlist-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.towerofficerlist.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.towerofficerlist.delete.question" translate-values="{id: \'{{vm.towerofficerlist.id}}\'}">Are you sure you want to delete this Towerofficerlist?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/towerofficerlist/towerofficerlist-detail.html','<div><h2><span data-translate="investhryApp.towerofficerlist.detail.title">Towerofficerlist</span> {{vm.towerofficerlist.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.towerofficerlist.towerofficerLogin">Towerofficer Login</span></dt><dd><span>{{vm.towerofficerlist.towerofficerLogin}}</span></dd><dt><span data-translate="investhryApp.towerofficerlist.district">District</span></dt><dd><span>{{vm.towerofficerlist.district}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="towerofficerlist-detail.edit({id:vm.towerofficerlist.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/towerofficerlist/towerofficerlist-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTowerofficerlistLabel" data-translate="investhryApp.towerofficerlist.home.createOrEditLabel">Create or edit a Towerofficerlist</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.towerofficerlist.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.towerofficerlist.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerofficerlist.towerofficerLogin" for="field_towerofficerLogin">Towerofficer Login</label><input type="text" class="form-control" name="towerofficerLogin" id="field_towerofficerLogin" ng-model="vm.towerofficerlist.towerofficerLogin"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerofficerlist.district" for="field_district">District</label><select class="form-control" name="district" id="field_district" ng-model="vm.towerofficerlist.district" ng-options="district.districtname as district.districtname for district in vm.districts" required><option value="" disabled="disabled">Select District</option></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/towerofficerlist/towerofficerlists.html','<div><h2 data-translate="investhryApp.towerofficerlist.home.title">Towerofficerlists</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="towerofficerlist.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.towerofficerlist.home.createLabel">Create new Towerofficerlist</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.towerofficerlist.towerofficerLogin">Towerofficer Login</span></th><th><span data-translate="investhryApp.towerofficerlist.district">District</span></th><th></th></tr></thead><tbody><tr ng-repeat="towerofficerlist in vm.towerofficerlists track by towerofficerlist.id"><td><a ui-sref="towerofficerlist-detail({id:towerofficerlist.id})">{{towerofficerlist.id}}</a></td><td>{{towerofficerlist.towerofficerLogin}}</td><td>{{towerofficerlist.district}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="towerofficerlist-detail({id:towerofficerlist.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="towerofficerlist.edit({id:towerofficerlist.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="towerofficerlist.delete({id:towerofficerlist.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/towerservice-no/towerservice-no-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.towerserviceNO.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.towerserviceNO.delete.question" translate-values="{id: \'{{vm.towerserviceNO.id}}\'}">Are you sure you want to delete this Towerservice NO?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/towerservice-no/towerservice-no-detail.html','<div><h2><span data-translate="investhryApp.towerserviceNO.detail.title">Towerservice NO</span> {{vm.towerserviceNO.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.towerserviceNO.nodal_officer">Nodal Officer</span></dt><dd><span>{{vm.towerserviceNO.nodal_officer}}</span></dd><dt><span data-translate="investhryApp.towerserviceNO.projectdetailId">Projectdetail Id</span></dt><dd><span>{{vm.towerserviceNO.projectdetailId}}</span></dd><dt><span data-translate="investhryApp.towerserviceNO.subname">Sub Name</span></dt><dd><span>{{vm.towerserviceNO.subname}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="towerservice-no-detail.edit({id:vm.towerserviceNO.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/towerservice-no/towerservice-no-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myTowerserviceNOLabel" data-translate="investhryApp.towerserviceNO.home.createOrEditLabel">Create or edit a Towerservice NO</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.towerserviceNO.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.towerserviceNO.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerserviceNO.nodal_officer" for="field_nodal_officer">Nodal Officer</label><input type="text" class="form-control" name="nodal_officer" id="field_nodal_officer" ng-model="vm.towerserviceNO.nodal_officer"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.towerserviceNO.projectdetailId" for="field_projectdetailId">Projectdetail Id</label><input type="text" class="form-control" name="projectdetailId" id="field_projectdetailId" ng-model="vm.towerserviceNO.projectdetailId"></div><div class="form-group"><label class="control-label" for="field_subName">Sub Name</label><input type="text" class="form-control" name="subName" id="field_subName" ng-model="vm.towerserviceNO.subname"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/towerservice-no/towerservice-nos.html','<div><jhi-alert></jhi-alert><div class="container"><div class="row"><!--<h2 data-translate="investhryApp.towerserviceNO.home.title">Towerservice NOS</h2>--><br><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="towerservice-no.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.towerserviceNO.home.createLabel">Create new Towerservice NO</span></button></div><div class="col-sm-4"><input type="text" ng-model="vm.projectdetailid" class="form-control" placeholder="Enter Project Service Detail ID"></div><div class="btn-group col-sm-4"><button type="submit" ng-click="vm.getProject()" class="btn btn-info">Search</button></div></div><br><div class="row" ng-show="vm.show"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.towerserviceNO.nodal_officer">Nodal Officer</span></th><th><span data-translate="investhryApp.towerserviceNO.projectdetailId">Projectdetail Id</span></th><th>Sub Name</th><th></th></tr></thead><tbody><tr ng-repeat="towerserviceNO in vm.towerserviceNOS track by towerserviceNO.id"><td><a ui-sref="towerservice-no-detail({id:towerserviceNO.id})">{{towerserviceNO.id}}</a></td><td>{{towerserviceNO.nodal_officer}}</td><td>{{towerserviceNO.projectdetailId}}</td><td>{{towerserviceNO.subname}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="towerservice-no-detail({id:towerserviceNO.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="towerservice-no.edit({id:towerserviceNO.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="towerservice-no.delete({id:towerserviceNO.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div></div>');
$templateCache.put('app/entities/user-authorization/user-authorization-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.userAuthorization.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.userAuthorization.delete.question" translate-values="{id: \'{{vm.userAuthorization.id}}\'}">Are you sure you want to delete this User Authorization?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/user-authorization/user-authorization-detail.html','<div><h2><span data-translate="investhryApp.userAuthorization.detail.title">User Authorization</span> {{vm.userAuthorization.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.userAuthorization.clientId">Client Id</span></dt><dd><span>{{vm.userAuthorization.clientId}}</span></dd><dt><span data-translate="investhryApp.userAuthorization.clientSecret">Client Secret</span></dt><dd><span>{{vm.userAuthorization.clientSecret}}</span></dd><dt><span data-translate="investhryApp.userAuthorization.generationDate">Generation Date</span></dt><dd><span>{{vm.userAuthorization.generationDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.userAuthorization.expirationDate">Expiration Date</span></dt><dd><span>{{vm.userAuthorization.expirationDate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.userAuthorization.department">Department</span></dt><dd><span>{{vm.userAuthorization.department}}</span></dd><dt><span data-translate="investhryApp.userAuthorization.refreshToken">Refresh Token</span></dt><dd><span>{{vm.userAuthorization.refreshToken}}</span></dd><dt><span data-translate="investhryApp.userAuthorization.login">Login</span></dt><dd><span>{{vm.userAuthorization.login}}</span></dd><dt><span data-translate="investhryApp.userAuthorization.password">Password</span></dt><dd><span>{{vm.userAuthorization.password}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="user-authorization-detail.edit({id:vm.userAuthorization.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/user-authorization/user-authorization-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserAuthorizationLabel" data-translate="investhryApp.userAuthorization.home.createOrEditLabel">Create or edit a User Authorization</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group"><label class="control-label" data-translate="investhryApp.userAuthorization.department" for="field_department">Department</label><select class="form-control" name="department" id="field_department" ng-model="vm.userAuthorization.selectedDepartment" ng-options="department.departmentname for department in vm.departments" required><option value="">--Select Department--</option></select></div><div class="form-group"><label class="control-label" data-translate="investhryApp.userAuthorization.login" for="field_login">Login</label><input type="text" class="form-control" name="login" id="field_login" ng-model="vm.userAuthorization.login"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.userAuthorization.password" for="field_password">Password</label><input type="text" class="form-control" name="password" id="field_password" ng-model="vm.userAuthorization.password"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.userAuthorization.clientSecret" for="field_clientSecret">Client Secret</label><input type="text" class="form-control" name="clientSecret" id="field_clientSecret" ng-model="vm.userAuthorization.clientSecret" placeholder="8-digit random string" required><div ng-show="editForm.clientSecret.$invalid"><p class="help-block" ng-show="editForm.clientSecret.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/user-authorization/user-authorizations.html','<div><h2 data-translate="investhryApp.userAuthorization.home.title">User Authorizations</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="user-authorization.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.userAuthorization.home.createLabel">Create new User Authorization</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="investhryApp.userAuthorization.login">Login</span></th><th><span data-translate="investhryApp.userAuthorization.clientId">Client Id</span></th><th><span data-translate="investhryApp.userAuthorization.generationDate">Generation Date</span></th><th><span data-translate="investhryApp.userAuthorization.expirationDate">Expiration Date</span></th><th><span data-translate="investhryApp.userAuthorization.department">Department</span></th><th><span data-translate="investhryApp.userAuthorization.refreshToken">Refresh Token</span></th><th></th></tr></thead><tbody><tr ng-repeat="userAuthorization in vm.userAuthorizations track by userAuthorization.id"><td>{{userAuthorization.login}}</td><td>{{userAuthorization.clientId}}</td><td>{{userAuthorization.generationDate | date:\'medium\'}}</td><td>{{userAuthorization.expirationDate | date:\'medium\'}}</td><td>{{userAuthorization.department}}</td><td>{{userAuthorization.refreshToken}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><!--<button type="submit"--><!--ui-sref="user-authorization-detail({id:userAuthorization.id})"--><!--class="btn btn-info btn-sm">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--<span class="hidden-sm-down" data-translate="entity.action.view"></span>--><!--</button>--> <button type="submit" ui-sref="user-authorization.edit({id:userAuthorization.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-authorization.delete({id:userAuthorization.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/user-feedback/user-feedback-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.userFeedback.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.userFeedback.delete.question" translate-values="{id: \'{{vm.userFeedback.id}}\'}">Are you sure you want to delete this User Feedback?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/user-feedback/user-feedback-detail.html','<div><h2><span data-translate="investhryApp.userFeedback.detail.title">User Feedback</span> {{vm.userFeedback.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.userFeedback.name">Name</span></dt><dd><span>{{vm.userFeedback.name}}</span></dd><dt><span data-translate="investhryApp.userFeedback.contactNumber">Contact Number</span></dt><dd><span>{{vm.userFeedback.contactNumber}}</span></dd><dt><span data-translate="investhryApp.userFeedback.email">Email</span></dt><dd><span>{{vm.userFeedback.email}}</span></dd><dt><span data-translate="investhryApp.userFeedback.stateId">State Id</span></dt><dd><span>{{vm.userFeedback.stateId}}</span></dd><dt><span data-translate="investhryApp.userFeedback.rasDeptId">Ras Dept Id</span></dt><dd><span>{{vm.userFeedback.rasDeptId}}</span></dd><dt><span data-translate="investhryApp.userFeedback.rasServiceId">Ras Service Id</span></dt><dd><span>{{vm.userFeedback.rasServiceId}}</span></dd><dt><span data-translate="investhryApp.userFeedback.status">Status</span></dt><dd><span>{{vm.userFeedback.status}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="user-feedback-detail.edit({id:vm.userFeedback.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/user-feedback/user-feedback-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myUserFeedbackLabel" data-translate="investhryApp.userFeedback.home.createOrEditLabel">Create or edit a User Feedback</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.userFeedback.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.userFeedback.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.userFeedback.name" for="field_name">Name</label><input type="text" class="form-control" name="name" id="field_name" ng-model="vm.userFeedback.name"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.userFeedback.contactNumber" for="field_contactNumber">Contact Number</label><input type="text" class="form-control" name="contactNumber" id="field_contactNumber" ng-model="vm.userFeedback.contactNumber"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.userFeedback.email" for="field_email">Email</label><input type="text" class="form-control" name="email" id="field_email" ng-model="vm.userFeedback.email"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.userFeedback.stateId" for="field_stateId">State Id</label><input type="text" class="form-control" name="stateId" id="field_stateId" ng-model="vm.userFeedback.stateId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.userFeedback.rasDeptId" for="field_rasDeptId">Ras Dept Id</label><input type="text" class="form-control" name="rasDeptId" id="field_rasDeptId" ng-model="vm.userFeedback.rasDeptId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.userFeedback.rasServiceId" for="field_rasServiceId">Ras Service Id</label><input type="text" class="form-control" name="rasServiceId" id="field_rasServiceId" ng-model="vm.userFeedback.rasServiceId"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.userFeedback.status" for="field_status">Status</label><input type="text" class="form-control" name="status" id="field_status" ng-model="vm.userFeedback.status"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/user-feedback/user-feedbacks.html','<div><h2 data-translate="investhryApp.userFeedback.home.title">User Feedbacks</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="user-feedback.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.userFeedback.home.createLabel">Create new User Feedback</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.userFeedback.name">Name</span></th><th><span data-translate="investhryApp.userFeedback.contactNumber">Contact Number</span></th><th><span data-translate="investhryApp.userFeedback.email">Email</span></th><th><span data-translate="investhryApp.userFeedback.stateId">State Id</span></th><th><span data-translate="investhryApp.userFeedback.rasDeptId">Ras Dept Id</span></th><th><span data-translate="investhryApp.userFeedback.rasServiceId">Ras Service Id</span></th><th><span data-translate="investhryApp.userFeedback.status">Status</span></th><th></th></tr></thead><tbody><tr ng-repeat="userFeedback in vm.userFeedbacks track by userFeedback.id"><td><a ui-sref="user-feedback-detail({id:userFeedback.id})">{{userFeedback.id}}</a></td><td>{{userFeedback.name}}</td><td>{{userFeedback.contactNumber}}</td><td>{{userFeedback.email}}</td><td>{{userFeedback.stateId}}</td><td>{{userFeedback.rasDeptId}}</td><td>{{userFeedback.rasServiceId}}</td><td>{{userFeedback.status}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-feedback-detail({id:userFeedback.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="user-feedback.edit({id:userFeedback.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="user-feedback.delete({id:userFeedback.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/visitor-count/visitor-count-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.visitor_count.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.visitor_count.delete.question" translate-values="{id: \'{{vm.visitor_count.id}}\'}">Are you sure you want to delete this Visitor Count?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/visitor-count/visitor-count-detail.html','<div><h2><span data-translate="investhryApp.visitor_count.detail.title">Visitor Count</span> {{vm.visitor_count.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="dl-horizontal jh-entity-details"><dt><span data-translate="investhryApp.visitor_count.count">Count</span></dt><dd><span>{{vm.visitor_count.count}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="visitor-count-detail.edit({id:vm.visitor_count.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/visitor-count/visitor-count-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myVisitor_countLabel" data-translate="investhryApp.visitor_count.home.createOrEditLabel">Create or edit a Visitor Count</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.visitor_count.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.visitor_count.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.visitor_count.count" for="field_count">Count</label><input type="text" class="form-control" name="count" id="field_count" ng-model="vm.visitor_count.count"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/visitor-count/visitor-counts.html','<div><h2 data-translate="investhryApp.visitor_count.home.title">Visitor Counts</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="visitor-count.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.visitor_count.home.createLabel">Create new Visitor Count</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.visitor_count.count">Count</span></th><th></th></tr></thead><tbody><tr ng-repeat="visitor_count in vm.visitor_counts track by visitor_count.id"><td><a ui-sref="visitor-count-detail({id:visitor_count.id})">{{visitor_count.id}}</a></td><td>{{visitor_count.count}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="visitor-count-detail({id:visitor_count.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="visitor-count.edit({id:visitor_count.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="visitor-count.delete({id:visitor_count.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/waste-water-disposal-mode/waste-water-disposal-mode-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.waste_water_disposal_mode.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.waste_water_disposal_mode.delete.question" translate-values="{id: \'{{vm.waste_water_disposal_mode.id}}\'}">Are you sure you want to delete this Waste Water Disposal Mode?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/waste-water-disposal-mode/waste-water-disposal-mode-detail.html','<div class="container"><h2><span data-translate="investhryApp.waste_water_disposal_mode.detail.title">Waste Water Disposal Mode</span> {{vm.waste_water_disposal_mode.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.waste_water_disposal_mode.mode_of_disposal">Mode Of Disposal</span></dt><dd><span>{{vm.waste_water_disposal_mode.mode_of_disposal}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="waste-water-disposal-mode-detail.edit({id:vm.waste_water_disposal_mode.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/waste-water-disposal-mode/waste-water-disposal-mode-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myWaste_water_disposal_modeLabel" data-translate="investhryApp.waste_water_disposal_mode.home.createOrEditLabel">Create or edit a Waste Water Disposal Mode</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.waste_water_disposal_mode.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.waste_water_disposal_mode.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.waste_water_disposal_mode.mode_of_disposal" for="field_mode_of_disposal">Mode Of Disposal</label><input type="text" class="form-control" name="mode_of_disposal" id="field_mode_of_disposal" ng-model="vm.waste_water_disposal_mode.mode_of_disposal" required><div ng-show="editForm.mode_of_disposal.$invalid"><p class="help-block" ng-show="editForm.mode_of_disposal.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/waste-water-disposal-mode/waste-water-disposal-modes.html','<div class="container"><h2 data-translate="investhryApp.waste_water_disposal_mode.home.title">Waste Water Disposal Modes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="waste-water-disposal-mode.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.waste_water_disposal_mode.home.createLabel">Create new Waste Water Disposal Mode</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.waste_water_disposal_mode.mode_of_disposal">Mode Of Disposal</span></th><th></th></tr></thead><tbody><tr ng-repeat="waste_water_disposal_mode in vm.waste_water_disposal_modes track by waste_water_disposal_mode.id"><td><a ui-sref="waste-water-disposal-mode-detail({id:waste_water_disposal_mode.id})">{{waste_water_disposal_mode.id}}</a></td><td>{{waste_water_disposal_mode.mode_of_disposal}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="waste-water-disposal-mode-detail({id:waste_water_disposal_mode.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="waste-water-disposal-mode.edit({id:waste_water_disposal_mode.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="waste-water-disposal-mode.delete({id:waste_water_disposal_mode.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/waste-water-naturetype/waste-water-naturetype-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.waste_water_naturetype.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.waste_water_naturetype.delete.question" translate-values="{id: \'{{vm.waste_water_naturetype.id}}\'}">Are you sure you want to delete this Waste Water Naturetype?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/waste-water-naturetype/waste-water-naturetype-detail.html','<div class="container"><h2><span data-translate="investhryApp.waste_water_naturetype.detail.title">Waste Water Naturetype</span> {{vm.waste_water_naturetype.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.waste_water_naturetype.naturetype">Naturetype</span></dt><dd><span>{{vm.waste_water_naturetype.naturetype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="waste-water-naturetype-detail.edit({id:vm.waste_water_naturetype.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/waste-water-naturetype/waste-water-naturetype-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myWaste_water_naturetypeLabel" data-translate="investhryApp.waste_water_naturetype.home.createOrEditLabel">Create or edit a Waste Water Naturetype</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.waste_water_naturetype.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.waste_water_naturetype.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.waste_water_naturetype.naturetype" for="field_naturetype">Naturetype</label><input type="text" class="form-control" name="naturetype" id="field_naturetype" ng-model="vm.waste_water_naturetype.naturetype" required><div ng-show="editForm.naturetype.$invalid"><p class="help-block" ng-show="editForm.naturetype.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/waste-water-naturetype/waste-water-naturetypes.html','<div class="container"><h2 data-translate="investhryApp.waste_water_naturetype.home.title">Waste Water Naturetypes</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="waste-water-naturetype.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.waste_water_naturetype.home.createLabel">Create new Waste Water Naturetype</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.waste_water_naturetype.naturetype">Naturetype</span></th><th></th></tr></thead><tbody><tr ng-repeat="waste_water_naturetype in vm.waste_water_naturetypes track by waste_water_naturetype.id"><td><a ui-sref="waste-water-naturetype-detail({id:waste_water_naturetype.id})">{{waste_water_naturetype.id}}</a></td><td>{{waste_water_naturetype.naturetype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="waste-water-naturetype-detail({id:waste_water_naturetype.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="waste-water-naturetype.edit({id:waste_water_naturetype.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="waste-water-naturetype.delete({id:waste_water_naturetype.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/wastewaterdetail/wastewaterdetail-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.wastewaterdetail.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.wastewaterdetail.delete.question" translate-values="{id: \'{{vm.wastewaterdetail.id}}\'}">Are you sure you want to delete this Wastewaterdetail?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/wastewaterdetail/wastewaterdetail-detail.html','<div><h2><span data-translate="investhryApp.wastewaterdetail.detail.title">Wastewaterdetail</span> {{vm.wastewaterdetail.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.wastewaterdetail.source_of_generation">Source Of Generation</span></dt><dd><span>{{vm.wastewaterdetail.source_of_generation}}</span></dd><dt><span data-translate="investhryApp.wastewaterdetail.quantity">Quantity</span></dt><dd><span>{{vm.wastewaterdetail.quantity}}</span></dd><dt><span data-translate="investhryApp.wastewaterdetail.naturetype">Naturetype</span></dt><dd><span>{{vm.wastewaterdetail.naturetype}}</span></dd><dt><span data-translate="investhryApp.wastewaterdetail.mode_of_disposal">Mode Of Disposal</span></dt><dd><span>{{vm.wastewaterdetail.mode_of_disposal}}</span></dd><dt><span data-translate="investhryApp.wastewaterdetail.createdate">Createdate</span></dt><dd><span>{{vm.wastewaterdetail.createdate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.wastewaterdetail.updatedate">Updatedate</span></dt><dd><span>{{vm.wastewaterdetail.updatedate | date:\'medium\'}}</span></dd><dt><span data-translate="investhryApp.wastewaterdetail.projectid">Projectid</span></dt><dd><span>{{vm.wastewaterdetail.projectid}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="wastewaterdetail-detail.edit({id:vm.wastewaterdetail.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/wastewaterdetail/wastewaterdetail-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myWastewaterdetailLabel" data-translate="investhryApp.wastewaterdetail.home.createOrEditLabel">Create or edit a Wastewaterdetail</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.wastewaterdetail.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.wastewaterdetail.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.wastewaterdetail.source_of_generation" for="field_source_of_generation">Source Of Generation</label><input type="text" class="form-control" name="source_of_generation" id="field_source_of_generation" ng-model="vm.wastewaterdetail.source_of_generation"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.wastewaterdetail.quantity" for="field_quantity">Quantity</label><input type="number" class="form-control" name="quantity" id="field_quantity" ng-model="vm.wastewaterdetail.quantity"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.wastewaterdetail.naturetype" for="field_naturetype">Naturetype</label><input type="text" class="form-control" name="naturetype" id="field_naturetype" ng-model="vm.wastewaterdetail.naturetype"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.wastewaterdetail.mode_of_disposal" for="field_mode_of_disposal">Mode Of Disposal</label><input type="text" class="form-control" name="mode_of_disposal" id="field_mode_of_disposal" ng-model="vm.wastewaterdetail.mode_of_disposal"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.wastewaterdetail.createdate" for="field_createdate">Createdate</label><div class="input-group"><input id="field_createdate" type="text" class="form-control" name="createdate" datetime-picker="{{dateformat}}" ng-model="vm.wastewaterdetail.createdate" is-open="vm.datePickerOpenStatus.createdate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'createdate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.wastewaterdetail.updatedate" for="field_updatedate">Updatedate</label><div class="input-group"><input id="field_updatedate" type="text" class="form-control" name="updatedate" datetime-picker="{{dateformat}}" ng-model="vm.wastewaterdetail.updatedate" is-open="vm.datePickerOpenStatus.updatedate"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'updatedate\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="investhryApp.wastewaterdetail.projectid" for="field_projectid">Projectid</label><input type="text" class="form-control" name="projectid" id="field_projectid" ng-model="vm.wastewaterdetail.projectid"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/wastewaterdetail/wastewaterdetails.html','<div><h2 data-translate="investhryApp.wastewaterdetail.home.title">Wastewaterdetails</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="wastewaterdetail.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.wastewaterdetail.home.createLabel">Create new Wastewaterdetail</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.wastewaterdetail.source_of_generation">Source Of Generation</span></th><th><span data-translate="investhryApp.wastewaterdetail.quantity">Quantity</span></th><th><span data-translate="investhryApp.wastewaterdetail.naturetype">Naturetype</span></th><th><span data-translate="investhryApp.wastewaterdetail.mode_of_disposal">Mode Of Disposal</span></th><th><span data-translate="investhryApp.wastewaterdetail.createdate">Createdate</span></th><th><span data-translate="investhryApp.wastewaterdetail.updatedate">Updatedate</span></th><th><span data-translate="investhryApp.wastewaterdetail.projectid">Projectid</span></th><th></th></tr></thead><tbody><tr ng-repeat="wastewaterdetail in vm.wastewaterdetails track by wastewaterdetail.id"><td><a ui-sref="wastewaterdetail-detail({id:wastewaterdetail.id})">{{wastewaterdetail.id}}</a></td><td>{{wastewaterdetail.source_of_generation}}</td><td>{{wastewaterdetail.quantity}}</td><td>{{wastewaterdetail.naturetype}}</td><td>{{wastewaterdetail.mode_of_disposal}}</td><td>{{wastewaterdetail.createdate | date:\'medium\'}}</td><td>{{wastewaterdetail.updatedate | date:\'medium\'}}</td><td>{{wastewaterdetail.projectid}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="wastewaterdetail-detail({id:wastewaterdetail.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="wastewaterdetail.edit({id:wastewaterdetail.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="wastewaterdetail.delete({id:wastewaterdetail.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/watersupplysource/watersupplysource-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.watersupplysource.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.watersupplysource.delete.question" translate-values="{id: \'{{vm.watersupplysource.id}}\'}">Are you sure you want to delete this Watersupplysource?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/watersupplysource/watersupplysource-detail.html','<div class="container"><h2><span data-translate="investhryApp.watersupplysource.detail.title">Watersupplysource</span> {{vm.watersupplysource.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.watersupplysource.watersupplysourcetype">Watersupplysourcetype</span></dt><dd><span>{{vm.watersupplysource.watersupplysourcetype}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="watersupplysource-detail.edit({id:vm.watersupplysource.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/watersupplysource/watersupplysource-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myWatersupplysourceLabel" data-translate="investhryApp.watersupplysource.home.createOrEditLabel">Create or edit a Watersupplysource</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.watersupplysource.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.watersupplysource.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.watersupplysource.watersupplysourcetype" for="field_watersupplysourcetype">Watersupplysourcetype</label><input type="text" class="form-control" name="watersupplysourcetype" id="field_watersupplysourcetype" ng-model="vm.watersupplysource.watersupplysourcetype" required><div ng-show="editForm.watersupplysourcetype.$invalid"><p class="help-block" ng-show="editForm.watersupplysourcetype.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/watersupplysource/watersupplysources.html','<div class="container"><h2 data-translate="investhryApp.watersupplysource.home.title">Watersupplysources</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="watersupplysource.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.watersupplysource.home.createLabel">Create new Watersupplysource</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.watersupplysource.watersupplysourcetype">Watersupplysourcetype</span></th><th></th></tr></thead><tbody><tr ng-repeat="watersupplysource in vm.watersupplysources track by watersupplysource.id"><td><a ui-sref="watersupplysource-detail({id:watersupplysource.id})">{{watersupplysource.id}}</a></td><td>{{watersupplysource.watersupplysourcetype}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="watersupplysource-detail({id:watersupplysource.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="watersupplysource.edit({id:watersupplysource.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="watersupplysource.delete({id:watersupplysource.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/wwtreatmentone/wwtreatmentone-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.wwtreatmentone.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.wwtreatmentone.delete.question" translate-values="{id: \'{{vm.wwtreatmentone.id}}\'}">Are you sure you want to delete this Wwtreatmentone?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/wwtreatmentone/wwtreatmentone-detail.html','<div class="container"><h2><span data-translate="investhryApp.wwtreatmentone.detail.title">Wwtreatmentone</span> {{vm.wwtreatmentone.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.wwtreatmentone.treatment1">Treatment 1</span></dt><dd><span>{{vm.wwtreatmentone.treatment1}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="wwtreatmentone-detail.edit({id:vm.wwtreatmentone.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/wwtreatmentone/wwtreatmentone-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myWwtreatmentoneLabel" data-translate="investhryApp.wwtreatmentone.home.createOrEditLabel">Create or edit a Wwtreatmentone</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.wwtreatmentone.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.wwtreatmentone.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.wwtreatmentone.treatment1" for="field_treatment1">Treatment 1</label><input type="text" class="form-control" name="treatment1" id="field_treatment1" ng-model="vm.wwtreatmentone.treatment1"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/wwtreatmentone/wwtreatmentones.html','<div class="container"><h2 data-translate="investhryApp.wwtreatmentone.home.title">Wwtreatmentones</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="wwtreatmentone.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.wwtreatmentone.home.createLabel">Create new Wwtreatmentone</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.wwtreatmentone.treatment1">Treatment 1</span></th><th></th></tr></thead><tbody><tr ng-repeat="wwtreatmentone in vm.wwtreatmentones track by wwtreatmentone.id"><td><a ui-sref="wwtreatmentone-detail({id:wwtreatmentone.id})">{{wwtreatmentone.id}}</a></td><td>{{wwtreatmentone.treatment1}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="wwtreatmentone-detail({id:wwtreatmentone.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="wwtreatmentone.edit({id:wwtreatmentone.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="wwtreatmentone.delete({id:wwtreatmentone.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/wwtreatmentthree/wwtreatmentthree-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.wwtreatmentthree.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.wwtreatmentthree.delete.question" translate-values="{id: \'{{vm.wwtreatmentthree.id}}\'}">Are you sure you want to delete this Wwtreatmentthree?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/wwtreatmentthree/wwtreatmentthree-detail.html','<div class="container"><h2><span data-translate="investhryApp.wwtreatmentthree.detail.title">Wwtreatmentthree</span> {{vm.wwtreatmentthree.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.wwtreatmentthree.treatment3">Treatment 3</span></dt><dd><span>{{vm.wwtreatmentthree.treatment3}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="wwtreatmentthree-detail.edit({id:vm.wwtreatmentthree.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/wwtreatmentthree/wwtreatmentthree-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myWwtreatmentthreeLabel" data-translate="investhryApp.wwtreatmentthree.home.createOrEditLabel">Create or edit a Wwtreatmentthree</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.wwtreatmentthree.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.wwtreatmentthree.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.wwtreatmentthree.treatment3" for="field_treatment3">Treatment 3</label><input type="text" class="form-control" name="treatment3" id="field_treatment3" ng-model="vm.wwtreatmentthree.treatment3"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/wwtreatmentthree/wwtreatmentthrees.html','<div class="container"><h2 data-translate="investhryApp.wwtreatmentthree.home.title">Wwtreatmentthrees</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="wwtreatmentthree.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.wwtreatmentthree.home.createLabel">Create new Wwtreatmentthree</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.wwtreatmentthree.treatment3">Treatment 3</span></th><th></th></tr></thead><tbody><tr ng-repeat="wwtreatmentthree in vm.wwtreatmentthrees track by wwtreatmentthree.id"><td><a ui-sref="wwtreatmentthree-detail({id:wwtreatmentthree.id})">{{wwtreatmentthree.id}}</a></td><td>{{wwtreatmentthree.treatment3}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="wwtreatmentthree-detail({id:wwtreatmentthree.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="wwtreatmentthree.edit({id:wwtreatmentthree.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="wwtreatmentthree.delete({id:wwtreatmentthree.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/wwtreatmenttwo/wwtreatmenttwo-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.wwtreatmenttwo.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.wwtreatmenttwo.delete.question" translate-values="{id: \'{{vm.wwtreatmenttwo.id}}\'}">Are you sure you want to delete this Wwtreatmenttwo?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/wwtreatmenttwo/wwtreatmenttwo-detail.html','<div class="container"><h2><span data-translate="investhryApp.wwtreatmenttwo.detail.title">Wwtreatmenttwo</span> {{vm.wwtreatmenttwo.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.wwtreatmenttwo.treatment2">Treatment 2</span></dt><dd><span>{{vm.wwtreatmenttwo.treatment2}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="wwtreatmenttwo-detail.edit({id:vm.wwtreatmenttwo.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/wwtreatmenttwo/wwtreatmenttwo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myWwtreatmenttwoLabel" data-translate="investhryApp.wwtreatmenttwo.home.createOrEditLabel">Create or edit a Wwtreatmenttwo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.wwtreatmenttwo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.wwtreatmenttwo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.wwtreatmenttwo.treatment2" for="field_treatment2">Treatment 2</label><input type="text" class="form-control" name="treatment2" id="field_treatment2" ng-model="vm.wwtreatmenttwo.treatment2"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/wwtreatmenttwo/wwtreatmenttwos.html','<div class="container"><h2 data-translate="investhryApp.wwtreatmenttwo.home.title">Wwtreatmenttwos</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="wwtreatmenttwo.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.wwtreatmenttwo.home.createLabel">Create new Wwtreatmenttwo</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.wwtreatmenttwo.treatment2">Treatment 2</span></th><th></th></tr></thead><tbody><tr ng-repeat="wwtreatmenttwo in vm.wwtreatmenttwos track by wwtreatmenttwo.id"><td><a ui-sref="wwtreatmenttwo-detail({id:wwtreatmenttwo.id})">{{wwtreatmenttwo.id}}</a></td><td>{{wwtreatmenttwo.treatment2}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="wwtreatmenttwo-detail({id:wwtreatmenttwo.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="wwtreatmenttwo.edit({id:wwtreatmenttwo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="wwtreatmenttwo.delete({id:wwtreatmenttwo.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/entities/zone/zone-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.zone.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="investhryApp.zone.delete.question" translate-values="{id: \'{{vm.zone.id}}\'}">Are you sure you want to delete this Zone?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/zone/zone-detail.html','<div><h2><span data-translate="investhryApp.zone.detail.title">Zone</span> {{vm.zone.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="investhryApp.zone.zone_name">Zone Name</span></dt><dd><span>{{vm.zone.zone_name}}</span></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="zone-detail.edit({id:vm.zone.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/zone/zone-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myZoneLabel" data-translate="investhryApp.zone.home.createOrEditLabel">Create or edit a Zone</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.zone.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.zone.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="investhryApp.zone.zone_name" for="field_zone_name">Zone Name</label><input type="text" class="form-control" name="zone_name" id="field_zone_name" ng-model="vm.zone.zone_name"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/zone/zones.html','<div><h2 data-translate="investhryApp.zone.home.title">Zones</h2><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="zone.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="investhryApp.zone.home.createLabel">Create new Zone</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th><span data-translate="global.field.id">ID</span></th><th><span data-translate="investhryApp.zone.zone_name">Zone Name</span></th><th></th></tr></thead><tbody><tr ng-repeat="zone in vm.zones track by zone.id"><td><a ui-sref="zone-detail({id:zone.id})">{{zone.id}}</a></td><td>{{zone.zone_name}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="zone-detail({id:zone.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" ui-sref="zone.edit({id:zone.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ui-sref="zone.delete({id:zone.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div>');
$templateCache.put('app/hepcTickets/feedBack/ticketFeedBack.html','<div class="container"><div class="cardFeedback col-md-10 col-md-offset-1"><div class="card-header"><h3 class="text-info text-center">Rate Us</h3></div><div style="padding: 20px 5%; border: 1px solid white"><form name="feedBackFrom" role="form" novalidate ng-submit="vm.saveFeedback()"><div class="row"><div class="col-md-4 form-group"><label>Ticket Number</label><span class="form-control">{{vm.ticketDetail.ticketNumber}}</span></div><div class="col-md-4 form-group"><label>Logged On</label><span class="form-control">{{vm.ticketDetail.creationDate | date:\'dd-MMM-yyyy h:mm a\'}}</span></div><div class="col-md-4 form-group"><label>Resolved On</label><span class="form-control">{{vm.ticketDetail.resolveDate | date:\'dd-MMM-yyyy h:mm a\'}}</span></div><div class="col-md-12 form-group"><label>Resolving Remark</label><textarea type="text" class="form-control" ng-model="vm.ticketDetail.latestRemark" readonly="readonly"></textarea></div><div class="col-md-6 form-group"><span class="col-md-3 pull-left" style="font-size:14px; padding-top: 4px"><b>Rating</b>:</span><div class="radio-group rating" style="border: 2px Solid whitesmoke; padding: 14px"><input type="radio" id="star5" name="rating" ng-model="vm.rating" value="Excellent"><label for="star5" title="Excellent">5 stars</label><input type="radio" id="star4" name="rating" ng-model="vm.rating" value="Very Good"><label for="star4" title="Very Good">4 stars</label><input type="radio" id="star3" name="rating" ng-model="vm.rating" value="Good"><label for="star3" title="Good">3 stars</label><input type="radio" id="star2" name="rating" ng-model="vm.rating" value="Average"><label for="star2" title="Average">2 stars</label><input type="radio" id="star1" name="rating" ng-model="vm.rating" value="Poor" required><label for="star1" title="Poor">1 stars</label></div></div><div class="col-md-6 form-group"><label>Add Your Remark Here<span ng-show="vm.rating==\'Poor\' || vm.rating==\'Average\' || vm.rating==\'Good\'" class="text-danger">*</span></label><textarea type="text" maxlength="250" class="form-control" ng-model="vm.ratingRemark" ng-required="vm.rating==\'Poor\' || vm.rating==\'Average\' || vm.rating==\'Good\'"></textarea></div></div><div class="pull-right"><button type="submit" class="btn btn-info" ng-disabled="feedBackFrom.$invalid || vm.isSaving">Submit</button></div><br><br></form></div></div></div>');
$templateCache.put('app/hepcTickets/hepcDashboard/hepcDashBoard.html','<div class="container-fluid"><div class="row"><h5 class="pull-right text-danger" style="padding-right:2px"><b>*Dashboard updated on {{ CurrentDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</b></h5><div class="card"><div class="col-md-4" style="border-style: outset"><h3 style="color: red"><b>{{vm.tickets1.allTickets}}</b></h3><h4 class="card-description">Total Tickets</h4></div><div class="col-md-4" style="border-style: outset"><h3 style="color: red"><b>{{vm.tickets1.openTickets}}</b></h3><h4 class="card-description">Open Tickets</h4></div><div class="col-md-4" style="border-style: outset"><h3 style="color: red"><b>{{vm.tickets1.closedTickets}}</b></h3><h4 class="card-description">Closed Tickets</h4></div><div class="col-md-12"><br><div class="col-md-3 col-sm-12"><span><b>Filter by: &nbsp; </b></span><input type="radio" name="filterType" value="Status" ng-model="vm.filterType" ng-init="vm.filterType=\'Status\'" ng-change="vm.filterAll(\'All\')"> Status &nbsp; &nbsp; <input type="radio" name="filterType" value="Category" ng-model="vm.filterType" ng-change="vm.filterAll(\'All\')"> Category</div><div class="col-md-2 col-sm-12" ng-show="vm.filterType == \'Status\'"><select class="form-control" id="filter" ng-model="vm.filterBy" ng-change="vm.filterAll(vm.filterBy)"><option value="All" selected="selected">All</option><option value="Open">Open</option><option value="Closed">Closed</option><option value="Timeout">Timeout</option></select></div><div class="col-md-2 col-sm-12" ng-show="vm.filterType == \'Category\'"><select class="form-control" id="filters" ng-model="vm.filterBy" ng-change="vm.filterAll(vm.filterBy)"><option value="All" selected="selected">All</option><option value="Technical">Technical</option><option value="Grievances">Grievances</option><option value="Incentives">Incentives</option><option value="Process Related">Process Related</option><option value="General Enquiry">General Enquiry</option><option value="HOBPAS">HOBPAS</option><option value="Suggestion/Feedback">Suggestion/Feedback &nbsp; &nbsp;</option></select></div><div class="col-md-5"><button style="margin-bottom: 12px" ng-click="vm.download_all_table_data(vm.ticketList1)" type="button" class="btn btn-success btn-sm pull-right btn-marginTop"><span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-2 col-sm-12"><input type="search" class="form-control pull-right" placeholder="Search Ticket" ng-model="name"></div><br><br><div class="card-content" ng-show="vm.ticketList.length==0"><br><h3 class="jumbotron text-center">No Tickets</h3></div></div><div class="card-content table-responsive" ng-hide="vm.ticketList.length==0"><table id="result_table" class="table table-stripped table-hover"><thead><tr class="theadRowColor"><th class="text-center"><span><b>S.No</b></span></th><th class="text-center"><span><b>Ticket Number</b></span></th><th class="text-center"><span><b>Subject</b></span></th><th class="text-center"><span><b>Category</b></span></th><th class="text-center"><span><b>Department</b></span></th><th class="text-center"><span><b>Assigned<br>Member</b></span></th><th class="text-center"><span><b>Priority</b></span></th><th class="text-center"><span><b>Creation By</b></span></th><th class="text-center"><span><b>Creation On</b></span></th><th class="text-center"><span><b>Closing Date</b></span></th><th class="text-center"><span><b>Ticket Status</b></span></th><th class="text-center"><span><b>Action</b></span></th></tr></thead><tbody class="text-center"><tr style="cursor: pointer" ng-class="{AutoAssignTickets: tickets.latestRemark == \'Auto Assign To \'+tickets.level}" ng-repeat="tickets in vm.ticketList | orderBy: \'-creationDate\' | filter: name"><td><span ng-hide="true">\'</span>{{$index+1}}<span ng-hide="true">\'</span></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})"><span ng-hide="true">\'</span>{{tickets.ticketNumber}}<span ng-hide="true">\'</span></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.subject}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.incidentCategory}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})"><span ng-if="tickets.assignedDepartmentName!=null">{{tickets.assignedDepartmentName}}</span> <span ng-if="tickets.assignedDepartmentName==null">--</span></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})"><span ng-if="tickets.assignedMemberUserName!=null">{{tickets.assignedMemberUserName}}</span> <span ng-if="tickets.assignedMemberUserName==null">{{tickets.assignedMemberName}}</span></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.priority}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})"><span ng-if="tickets.createdByName!=null">{{tickets.createdByName}}</span> <span ng-if="tickets.createdByName==null">{{tickets.createdBy}}</span><br></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})"><span>{{tickets.creationDate | date:\'dd-MMM-yyyy\'}}</span></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})"><span ng-if="tickets.resolveDate!=null">{{tickets.resolveDate | date:\'dd-MMM-yyyy\'}}</span> <span ng-if="tickets.resolveDate==null">--</span></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})"><span ng-if="tickets.status==\'Open\'" style="color: darkgreen">Open</span> <span title="on {{tickets.resolveDate | date:\'dd-MMM-yyyy\'}}" ng-if="tickets.status==\'Closed\'" style="color: darkred">Closed<br></span></td><td><button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#logsModal" ng-click="vm.getLogs(tickets)"><b>Logs</b></button></td></tr></tbody></table><button class="btn btn-blue" ng-click="vm.loadAllTickets(vm.page - 1)">Previous</button> <button class="btn btn-blue" ng-click="vm.loadAllTickets(vm.page + 1)">Next</button></div></div></div></div><div id="logsModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Logs <span class="pull-right">Ticket No - {{vm.ticketsLogs[0].ticketNumber}} &nbsp; &nbsp;</span></h4></div><div class="modal-body table-responsive"><table class="table table-bordered"><thead><tr class="theadRowColor"><th class="text-center">#</th><th class="text-center">Action Type</th><th class="text-center">Action By</th><th class="text-center">Action Date</th><th class="text-center">Remark</th><th class="text-center">Attachment</th></tr></thead><tbody><tr class="text-center" ng-repeat="ticketLogs in vm.ticketsLogs | orderBy: \'-actionDate\'"><td>{{$index+1}}</td><td>{{ticketLogs.actionType}}</td><td ng-show="ticketLogs.actionByName!=null">{{ticketLogs.actionByName}}</td><td ng-show="ticketLogs.actionByName==null">{{ticketLogs.actionBy}}</td><td>{{ticketLogs.actionDate | date: \'dd-MMM-yyyy h:mm a\'}}</td><td>{{ticketLogs.remark}}</td><td ng-show="ticketLogs.attachment!=null"><button id="download-btn" ng-click="vm.downloadAttachment(ticketLogs.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></td><td ng-show="ticketLogs.attachment==null">--</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/hepcTickets/hepcDashboard/hepcOpenDashBoard.html','<section class="page_breadcrumbs ds background_cover overlay_color section_padding_top_40 section_padding_bottom_25"><div class="container"><div class="row"><div class="col-sm-12 text-center text-md-left"><h1 class="small">Ticketing/Query Dashboard</h1></div></div><ol class="breadcrumb bottom_breadcrumbs"><li><a ui-sref="home">Home</a></li><li><span>Investor Services</span></li><li class="active"><span>Ticketing/Query Dashboard</span></li></ol></div></section><h5 class="pull-left text-danger" style="padding-right:5px">*Department of Industries & Commerce/ HEPC doesn\u2019t charge any fees for processing Queries.</h5><h5 class="pull-right text-danger" style="padding-right:5px">*Dashboard updated on {{ CurrentDate | date:\'dd/MM/yyyy HH:mm:ss\'}}</h5><br><div class="container-fluid"><div class="col-md-12 row"><div class="card"><div class="col-md-2" style="border-style: outset;height: 130px"><h4 class="card-description">Total Tickets</h4><h3 style="color: red;margin-top: 70px"><b>{{vm.tickets1.allTickets}}</b></h3></div><div class="col-md-2" style="border-style: outset;height: 130px"><h4 class="card-description">Open Tickets</h4><h3 style="color: red; margin-top: 70px"><b>{{vm.tickets1.openTickets}}</b></h3></div><div class="col-md-2" style="border-style: outset;height: 130px"><h4 class="card-description">Closed Tickets</h4><h3 style="color: red;margin-top: 70px"><b>{{vm.tickets1.closedTickets}}</b></h3></div><div class="col-md-3" style="border-style: outset;height: 130px"><h4 class="card-description">Average (Mean)/ Median (in days)</h4><h3 style="color: red"><b>{{vm.tickets1.mean}} / {{vm.tickets1.median}}</b></h3></div><div class="col-md-2" style="border-style: outset;height: 130px"><h4 class="card-description">Min. Time/ Max. Time</h4><h3 style="color: red"><b>1 / {{vm.tickets1.maxTime}}</b></h3></div><div class="col-md-1" style="border-style: outset;height: 130px"><h4 class="card-description">RTS Days</h4><h3 style="color: red"><b>5</b></h3></div><div class="card-content table-responsive" ng-hide="vm.ticketList.length==0"><table id="result_table" class="table table-stripped table-hover"><thead><tr class="theadRowColor"><th class="text-center"><span><b>S.No</b></span></th><th class="text-center"><span><b>Ticket Number</b></span></th><th class="text-center"><span><b>Subject</b></span></th><th class="text-center"><span><b>Category</b></span></th><th class="text-center"><span><b>Department</b></span></th><th class="text-center"><span><b>Cost Incurred (Not Applicable)</b></span></th><th class="text-center"><span><b>Creation By</b></span></th><th class="text-center"><span><b>Creation On</b></span></th><th class="text-center"><span><b>Closing Date</b></span></th><th class="text-center"><span><b>Ticket Status</b></span></th></tr></thead><tbody class="text-center"><tr style="cursor: pointer" ng-class="{AutoAssignTickets: tickets.latestRemark == \'Auto Assign To \'+tickets.level}" ng-repeat="tickets in vm.ticketList | orderBy: \'-creationDate\' | filter: name"><td><span ng-hide="true">\'</span>{{$index+1}}<span ng-hide="true">\'</span></td><td><span ng-hide="true">\'</span>{{tickets.ticketNumber}}<span ng-hide="true">\'</span></td><td>{{tickets.subject}}</td><td>{{tickets.incidentCategory}}</td><td><span ng-if="tickets.assignedDepartmentName!=null">{{tickets.assignedDepartmentName}}</span> <span ng-if="tickets.assignedDepartmentName==null">--</span></td><td><span>0</span></td><td><span ng-if="tickets.createdByName!=null">{{tickets.createdByName}}</span> <span ng-if="tickets.createdByName==null">{{tickets.createdBy}}</span><br></td><td><span>{{tickets.creationDate | date:\'dd-MMM-yyyy\'}}</span></td><td><span ng-if="tickets.resolveDate!=null">{{tickets.resolveDate | date:\'dd-MMM-yyyy\'}}</span> <span ng-if="tickets.resolveDate==null">--</span></td><td><span ng-if="tickets.status==\'Open\'" style="color: darkgreen">Open</span> <span title="on {{tickets.resolveDate | date:\'dd-MMM-yyyy\'}}" ng-if="tickets.status==\'Closed\'" style="color: darkred">Closed<br></span></td></tr></tbody></table><button class="btn btn-blue" ng-click="vm.loadAllTickets(vm.page - 1)">Previous</button> <button class="btn btn-blue" ng-click="vm.loadAllTickets(vm.page + 1)">Next</button></div></div></div></div><div id="logsModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Logs <span class="pull-right">Ticket No - {{vm.ticketsLogs[0].ticketNumber}} &nbsp; &nbsp;</span></h4></div><div class="modal-body table-responsive"><table class="table table-bordered"><thead><tr class="theadRowColor"><th class="text-center">#</th><th class="text-center">Action Type</th><th class="text-center">Action By</th><th class="text-center">Action Date</th><th class="text-center">Remark</th><th class="text-center">Attachment</th></tr></thead><tbody><tr class="text-center" ng-repeat="ticketLogs in vm.ticketsLogs | orderBy: \'-actionDate\'"><td>{{$index+1}}</td><td>{{ticketLogs.actionType}}</td><td ng-show="ticketLogs.actionByName!=null">{{ticketLogs.actionByName}}</td><td ng-show="ticketLogs.actionByName==null">{{ticketLogs.actionBy}}</td><td>{{ticketLogs.actionDate | date: \'dd-MMM-yyyy h:mm a\'}}</td><td>{{ticketLogs.remark}}</td><td ng-show="ticketLogs.attachment!=null"><button id="download-btn" ng-click="vm.downloadAttachment(ticketLogs.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></td><td ng-show="ticketLogs.attachment==null">--</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/hepcTickets/hepcTktSidebar/hepcTktSidebar.html','<div id="nav-side-menu" class="myAffix affix-top" data-spy="affix" style="position: -webkit-sticky;position: sticky;top: 0" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_TICKET_ADMIN,ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_DEPARTMENT_HEAD,ROLE_L2_INCENTIVES,ROLE_TICKET_OPERATION_MANAGER,ROLE_TICKET_NODAL_OFFICER,ROLE_NODAL_OFFICER,ROLE_TICKET_HOBPAS"><div class="brand">TICKETING</div><hr><i class="fa fa-bars fa-2x toggle-btn" data-toggle="collapse" data-target="#menu-content"></i><div class="menu-list"><ul id="menu-content" class="menu-content collapse out"><li class="uk-hidden-touch" ui-sref="hepcDashboard" ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_TICKET_ADMIN"><a ng-click="vm.collapseNavbar()"><span><i class="fa fa-dashboard fa-lg"></i></span>&nbsp;&nbsp;&nbsp; <span>Dashboard</span></a></li><li class="uk-hidden-touch" ui-sref="ticket-generate" ui-sref-active="active" has-any-authority="ROLE_L1_SUPPORT,ROLE_TICKET_OPERATION_MANAGER,ROLE_TICKET_HOBPAS"><a ng-click="vm.collapseNavbar()"><i class="fa fa-ticket fa-lg" aria-hidden="true"></i> &nbsp;&nbsp;&nbsp;Add New Ticket</a></li><li class="uk-hidden-touch" ui-sref="allticketview" ui-sref-active="active" has-any-authority="ROLE_L1_SUPPORT,ROLE_TICKET_OPERATION_MANAGER, ROLE_TICKET_HOBPAS"><a ng-click="vm.collapseNavbar()"><i class="fa fa-bookmark-o fa-lg"></i> &nbsp;&nbsp;&nbsp;Generated Tickets</a></li><li class="uk-hidden-touch" ui-sref="timeoutTickets" ui-sref-active="active" has-any-authority="ROLE_L2_DEPARTMENT_HEAD"><a ng-click="vm.collapseNavbar()"><i class="fa fa-eye fa-lg"></i> &nbsp;&nbsp;&nbsp;Timeout Tickets</a></li><li class="uk-hidden-touch" ui-sref="ticketview" ui-sref-active="active" has-any-authority="ROLE_L1_SUPPORT, ROLE_L2_IT_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_DEPARTMENT_HEAD, ROLE_L2_INCENTIVES,ROLE_TICKET_OPERATION_MANAGER, ROLE_TICKET_NODAL_OFFICER, ROLE_NODAL_OFFICER,ROLE_TICKET_HOBPAS"><a ng-click="vm.collapseNavbar()"><i class="fa fa-eye fa-lg"></i> &nbsp;&nbsp;&nbsp;My Open Tickets</a></li><li class="uk-hidden-touch" ui-sref="closedticketview" ui-sref-active="active" has-any-authority="ROLE_L1_SUPPORT, ROLE_L2_IT_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_DEPARTMENT_HEAD, ROLE_L2_INCENTIVES, ROLE_TICKET_OPERATION_MANAGER, ROLE_TICKET_NODAL_OFFICER, ROLE_NODAL_OFFICER, ROLE_TICKET_HOBPAS"><a ng-click="vm.collapseNavbar()"><i class="fa fa-close fa-lg"></i> &nbsp;&nbsp;&nbsp;My Closed Tickets</a></li><li class="uk-hidden-touch" ui-sref="depTicketsView" ui-sref-active="active" has-any-authority="ROLE_L2_DEPARTMENT_HEAD"><a ng-click="vm.collapseNavbar()"><i class="fa fa-folder-o fa-lg"></i> &nbsp;&nbsp;&nbsp;Pending Tickets</a></li><li class="uk-hidden-touch" ui-sref="sentTickets" ui-sref-active="active" has-any-authority="ROLE_L1_SUPPORT, ROLE_L2_IT_MANAGER, ROLE_L2_DEPARTMENT, ROLE_L2_INCENTIVES, ROLE_TICKET_OPERATION_MANAGER"><a ng-click="vm.collapseNavbar()"><i class="fa fa-send-o fa-lg"></i> &nbsp;&nbsp;&nbsp;My Sent Tickets</a></li><li class="uk-hidden-touch" ui-sref="hepcticketadmin" ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_TICKET_ADMIN,ROLE_TICKET_OPERATION_MANAGER"><a ng-click="vm.collapseNavbar()"><i class="fa fa-list fa-lg"></i> &nbsp;&nbsp;&nbsp;All Tickets</a></li><li class="uk-hidden-touch" ui-sref="ratingViewAdmin" ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_TICKET_ADMIN"><a ng-click="vm.collapseNavbar()"><i class="fa fa-commenting fa-lg"></i> &nbsp;&nbsp;&nbsp;View FeedBack</a></li><li class="uk-hidden-touch" ui-sref="ticketsearch" ui-sref-active="active"><a ng-click="vm.collapseNavbar()"><i class="fa fa-search fa-lg" aria-hidden="true"></i> &nbsp;&nbsp;&nbsp;Search Ticket</a></li><li class="uk-hidden-touch" ui-sref-active="active"><a target="_blank" ui-sref="searchCAF" ng-click="vm.collapseNavbar()">&nbsp; &nbsp;<span class="glyphicon glyphicon-inbox"></span> &nbsp;&nbsp; &nbsp;Search CAF&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</a></li><li class="uk-hidden-touch" ui-sref-active="active" has-any-authority="ROLE_TICKET_OPERATION_MANAGER,ROLE_L1_SUPPORT"><a target="_blank" ui-sref="project" ng-click="vm.collapseNavbar()">&nbsp; &nbsp;<span class="glyphicon glyphicon-inbox"></span> &nbsp;&nbsp; &nbsp;Search Project Detail&nbsp; &nbsp; &nbsp; &nbsp; &nbsp;</a></li><li class="uk-hidden-touch" ui-sref="view-member" ui-sref-active="active" has-any-authority="ROLE_TICKET_OPERATION_MANAGER,ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_TICKET_ADMIN"><hr><a ng-click="vm.collapseNavbar()"><i class="fa fa-address-card fa-lg"></i> &nbsp;&nbsp;&nbsp;All Members</a></li></ul></div></div>');
$templateCache.put('app/hepcTickets/searchTicket/searchTicket.html','<div class="container-fluid"><div class="card"><div class="col-md-12"><div class="card-header"><h3 class="text-success">Search Tickets</h3><div class="row"><div class="col-md-3 form-group"><select class="form-control" id="UserBy" ng-model="vm.searchBy" required><option value="" disabled="disabled" selected="selected">--Select Search By--</option><option value="cafpin">Caf Pin (Composite Application Form)</option><option value="ticketNumber">Ticket Number</option></select></div><div class="col-md-6 form-group"><input type="text" class="form-control" ng-disabled="vm.searchBy==null" ng-model="vm.value" placeholder="Enter Cafpin or Ticket Number"></div><div class="col-md-2"><span class="col-md-10"><button type="button" class="btn btn-primary" ng-click="vm.searchTicket(vm.searchBy,vm.value)" ng-disabled="vm.value==null">Search</button></span></div></div><hr></div><div ng-show="vm.search"><div class="card-content" ng-show="vm.tickets.length==0"><h3 class="jumbotron text-center">No Ticket found</h3></div><div class="card-content table-responsive" ng-hide="vm.tickets.length==0"><table class="table table-bordered text-center"><thead class="text-center"><tr class="theadRowColor"><th class="text-center">Ticket Number</th><th class="text-center">Created By</th><th class="text-center">Subject</th><th class="text-center">Creation Date</th><th class="text-center">Action Logs</th></tr></thead><tbody><tr style="cursor: pointer" ng-repeat="tickets in vm.tickets | orderBy: \'creationDate\'"><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.ticketNumber}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.createdByName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.subject}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.creationDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td><button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#logsModal" ng-click="vm.getLogs(tickets)"><b>Logs</b></button></td></tr></tbody></table></div></div></div></div></div><div id="logsModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Logs <span class="pull-right">Ticket No - {{vm.ticketsLogs[0].ticketNumber}} &nbsp; &nbsp;</span></h4></div><div class="modal-body table-responsive"><table class="table table-bordered"><thead><tr class="theadRowColor"><th class="text-center">#</th><th class="text-center">Action Type</th><th class="text-center">Action By</th><th class="text-center">Action Date</th><th class="text-center">Remark</th><th class="text-center">Attachment</th></tr></thead><tbody><tr class="text-center" ng-repeat="ticketLogs in vm.ticketsLogs | orderBy: \'-actionDate\'"><td>{{$index+1}}</td><td>{{ticketLogs.actionType}}</td><td ng-show="ticketLogs.actionByName!=null">{{ticketLogs.actionByName}}</td><td ng-show="ticketLogs.actionByName==null">{{ticketLogs.actionBy}}</td><td>{{ticketLogs.actionDate | date: \'dd-MMM-yyyy h:mm a\'}}</td><td>{{ticketLogs.remark}}</td><td ng-show="ticketLogs.attachment!=null"><button id="download-btn" ng-click="vm.downloadAttachment(ticketLogs.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></td><td ng-show="ticketLogs.attachment==null">--</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/hepcTickets/sendTickets/sentTickets.html','<div class="container-fluid"><div class="card"><div class="card-header card-header-icon" data-background-color="green"><i class="fa fa-eye fa-lg fa-2x"></i></div><div class="card-header"><h4 class="card-title col-md-5 col-sm-12"><b>My Sent Tickets</b> <small class="form-group form-group-md ng-hide" aria-hidden="true">&nbsp;(TOTAL TICKETS = <b>{{vm.tickets.length}}</b>)</small></h4><div class="col-md-4 col-sm-12"><input type="search" class="form-control pull-right" placeholder="Search Ticket" ng-model="name"></div><div class="col-md-1"><button ng-show="vm.sentTicketsLogs.length!=0" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm pull-right">&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div><hr><div class="card-content" ng-show="vm.sentTicketsLogs.length==0"><br><h3 class="jumbotron text-center">No Sent Tickets</h3></div><div class="card-content" ng-show="vm.sentTicketsLogs.length!=0"><div class="table-responsive"><table id="result_table" class="table table-stripped table-hover"><thead><tr class="theadRowColor"><th>#</th><th><span><b>Ticket Number</b></span></th><th><span><b>Creation Date</b></span></th><th><span><b>Assigned To</b></span></th><th><span><b>Date</b></span></th><th><span><b>Status</b></span></th><th><span><b>Action</b></span></th></tr></thead><tbody><tr style="cursor: pointer" ng-repeat="sentTickets in vm.sentTicketsLogs | orderBy: \'-creationDate\' | filter: name" ng-class="{ AutoAssignTickets: sentTickets.actionBy == \'Auto Assign\' }"><td><i ng-show="sentTickets.status==\'Open\'" class="fa fa-circle text-success"></i> <i ng-show="sentTickets.status==\'Closed\'" class="fa fa-circle text-danger"></i></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:sentTickets.ticketId})">{{sentTickets.ticketNumber}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:sentTickets.ticketId})">{{sentTickets.creationDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:sentTickets.ticketId})" ng-if="sentTickets.assignedMemberName!=null">{{sentTickets.assignedMemberName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:sentTickets.ticketId})" ng-if="sentTickets.assignedMemberName==null">{{sentTickets.assignedMember}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:sentTickets.ticketId})">{{sentTickets.actionDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td ng-if="sentTickets.status==\'Open\'" ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:sentTickets.ticketId})"><b style="color: darkgreen">Open</b></td><td ng-if="sentTickets.status==\'Closed\'" ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:sentTickets.ticketId})"><b style="color: darkred">Closed</b></td><td><button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#logsModal" ng-click="vm.getLogs(sentTickets)"><b>Logs</b></button></td></tr></tbody></table></div></div></div></div><div id="logsModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Logs <span class="pull-right">Ticket No - {{vm.ticketsLogs[0].ticketNumber}} &nbsp; &nbsp;</span></h4></div><div class="modal-body table-responsive"><table class="table table-bordered"><thead><tr class="theadRowColor"><th class="text-center">#</th><th class="text-center">Action Type</th><th class="text-center">Action By</th><th class="text-center">Action Date</th><th class="text-center">Remark</th><th class="text-center">Attachment</th></tr></thead><tbody><tr class="text-center" ng-repeat="ticketLogs in vm.ticketsLogs | orderBy: \'-actionDate\'"><td>{{$index+1}}</td><td>{{ticketLogs.actionType}}</td><td ng-show="ticketLogs.actionByName!=null">{{ticketLogs.actionByName}}</td><td ng-show="ticketLogs.actionByName==null">{{ticketLogs.actionBy}}</td><td>{{ticketLogs.actionDate | date: \'dd-MMM-yyyy h:mm a\'}}</td><td>{{ticketLogs.remark}}</td><td ng-show="ticketLogs.attachment!=null"><button id="download-btn" ng-click="vm.downloadAttachment(ticketLogs.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></td><td ng-show="ticketLogs.attachment==null">--</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/hepcTickets/ticket-generate/ticket-generate.html','<div class="container-fluid"><br><div class="card"><div class="card-header card-header-icon" data-background-color="green"><i class="fa fa-ticket fa-lg fa-2x"></i></div><div class="card-header"><h3 class="card-title"><b>Generate Tickets</b></h3></div><br><div class="card-content"><jhi-alert-error></jhi-alert-error><form class="form" ng-submit="vm.uploadFile()" name="generateTicket" novalidate><div class="row"><div class="col-md-4 col-sm-12 form-group"><label for="userBy">User By <span class="text-danger">*</span></label><select class="form-control" id="UserBy" ng-model="vm.searchBy" ng-required="!vm.newCustomer && !vm.isSearchedCustomerAdded" ng-change="vm.changeUserBy()" ng-disabled="vm.newCustomer || vm.isSearchedCustomerAdded"><option value="" disabled="disabled">--Select--</option><option value="cafPin">Caf Pin (Composite Application Form)</option><option value="email">Email</option></select></div><div class="col-md-4 col-sm-12 form-group"><label>Value <span class="text-danger">*</span></label><input type="text" class="form-control" ng-model="vm.searchValue" placeholder="Enter Value" ng-disabled="vm.searchBy==null || vm.newCustomer || vm.isSearchResult" ng-required="!vm.newCustomer && !vm.isSearchedCustomerAdded"></div><div class="col-md-4 form-group" style="padding-top: 23px"><span class="col-md-3"><button type="button" class="btn btn-warning" ng-click="vm.search(vm.searchBy,vm.searchValue)" ng-disabled="vm.searchBy==null || vm.searchValue==null || vm.newCustomer || vm.isSearchResult">Search</button> </span><span class="col-md-3"><button type="button" class="btn btn-md btn-danger" ng-click="vm.clear()">Reset</button> </span><span class="col-md-6 text-right"><button type="button" data-target="#addCustomer" data-toggle="modal" class="btn btn-info" ng-disabled="vm.isSearchResult || vm.newCustomer || vm.isSearchedCustomerAdded">Add New</button></span></div></div><!--<h4 ng-show="vm.registered.email!=null" class="text-success"><button class="glyphicon glyphicon-ok btn btn-xs"></button> Registered</h4>--><div class="row"><div class="col-md-12 well table-responsive" ng-show="vm.isSearchResult"><table class="table table-bordered"><thead><tr><td ng-show="vm.registered.cafpin!=null" class="text-center"><b>Cafpin</b></td><td ng-show="vm.registered.firstName!=null" class="text-center"><b>Name</b></td><td ng-show="vm.registered.email!=null" class="text-center"><b>Email</b></td><td ng-show="vm.registered.mobileNumber!=null" class="text-center"><b>Mobile</b></td><td ng-show="vm.registered.district!=null" class="text-center"><b>District</b></td></tr></thead><tbody class="text-center"><tr><td ng-show="vm.registered.cafpin!=null">{{vm.registered.cafpin}}</td><td ng-show="vm.registered.firstName!=null">{{vm.registered.firstName}} &nbsp; {{vm.registered.lastName}}</td><td ng-show="vm.registered.email!=null">{{vm.registered.email}}</td><td ng-show="vm.registered.mobileNumber!=null">{{vm.registered.mobileNumber}}</td><td ng-show="vm.registered.district!=null">{{vm.registered.district}}</td></tr></tbody></table></div><div class="col-md-12 well table-responsive" ng-show="vm.isSearchedCustomerAdded"><table class="table table-bordered"><thead><tr><td ng-show="vm.oldTicketCustomer.firstName!=null" class="text-center"><b>Name</b></td><td ng-show="vm.oldTicketCustomer.email!=null" class="text-center"><b>Email</b></td><td ng-show="vm.oldTicketCustomer.mobileNumber!=null" class="text-center"><b>Mobile</b></td><td ng-show="vm.oldTicketCustomer.district!=null" class="text-center"><b>District</b></td></tr></thead><tbody class="text-center"><tr><td ng-show="vm.oldTicketCustomer.firstName!=null">{{vm.oldTicketCustomer.firstName}} &nbsp; {{vm.oldTicketCustomer.lastName}}</td><td ng-show="vm.oldTicketCustomer.email!=null">{{vm.oldTicketCustomer.email}}</td><td ng-show="vm.oldTicketCustomer.mobileNumber!=null">{{vm.oldTicketCustomer.mobileNumber}}</td><td ng-show="vm.oldTicketCustomer.district!=null">{{vm.oldTicketCustomer.district}}</td></tr></tbody></table></div><div class="col-md-12 form-group well table-responsive" ng-show="vm.newCustomer"><table class="table table-bordered text-center"><thead><tr><td><b>Name</b></td><td><b>Email</b></td><td><b>Mobile</b></td><td><b>District</b></td></tr></thead><tbody><tr><td>{{vm.ticketsCustomer.firstName}}&nbsp;{{vm.ticketsCustomer.lastName}}</td><td ng-show="vm.ticketsCustomer.email!=null">{{vm.ticketsCustomer.email}}</td><td ng-show="vm.ticketsCustomer.email==null">--</td><td ng-show="vm.ticketsCustomer.mobileNumber!=null">{{vm.ticketsCustomer.mobileNumber}}</td><td ng-show="vm.ticketsCustomer.mobileNumber==null">--</td><td><span ng-show="vm.ticketsCustomer.district!=\'Other\'">{{vm.ticketsCustomer.district}}</span> <span ng-show="vm.ticketsCustomer.district==\'Other\'">{{vm.otherField}}</span></td></tr></tbody></table></div></div><div class="row"><div class="col-md-6 col-sm-12 form-group"><label for="subject">Subject <span class="text-danger">*</span></label><input type="text" class="form-control" name="subject" id="subject" ng-model="vm.tickets.subject" maxlength="40" placeholder="Enter Subject" required> <span ng-show="form.subject.$dirty && form.subject.$error.required">Subject is required!</span> <span ng-show="form.subject.$error.maxlength">Maximum Length is 30</span></div><div class="col-md-2 col-sm-12 form-group"><label for="priority">Priority <span class="text-danger">*</span></label><select class="form-control" id="priority" ng-model="vm.tickets.priority" required><option value="" disabled="disabled">-Select Priority-</option><option value="low">Low</option><option value="normal">Normal</option><option value="high">High</option><option value="urgent">Urgent</option></select></div><div class="col-md-4 col-sm-12 form-group"><label for="incidentCat">Incident Category <span class="text-danger">*</span></label><select class="form-control" id="incidentCat" ng-model="vm.tickets.incidentCategory" required><option value="" disabled="disabled">--Select Incident Category--</option><option value="Technical">Technical</option><option value="Process Related">Process Related</option><option value="Grievances">Grievances</option><option value="Suggestion/Feedback">Suggestion/Feedback</option><option value="General Enquiry">General Enquiry</option><option value="Incentives">Incentives</option><option value="HOBPAS">HOBPAS</option></select></div><div class="col-md-6 col-sm-12 form-group" ng-hide="vm.tickets.incidentCategory==\'Technical\'"><label for="department">Department <span class="text-danger" ng-show="vm.tickets.incidentCategory==\'Process Related\' || vm.tickets.incidentCategory==\'Grievances\' || vm.tickets.incidentCategory==\'HOBPAS\'">*</span></label><select class="form-control" id="department" ng-options="department as department.departmentName for department in vm.deparment" ng-model="vm.departmentDetail" ng-change="vm.departmnetService(vm.departmentDetail)" ng-disabled="vm.tickets.incidentCategory!=\'Process Related\' && vm.tickets.incidentCategory!=\'Grievances\' && vm.tickets.incidentCategory!=\'HOBPAS\'" ng-required="vm.tickets.incidentCategory==\'Process Related\' || vm.tickets.incidentCategory==\'Grievances\' || vm.tickets.incidentCategory==\'HOBPAS\'"><option value="" disabled="disabled">--Select Deparment--</option></select></div><div class="col-md-6 col-sm-12 form-group" ng-show="vm.tickets.incidentCategory==\'Technical\'"><label for="ticketMember">IT Manager <span class="text-danger" ng-show="vm.tickets.incidentCategory==\'Technical\'">*</span></label><select class="form-control" id="ticketMember" ng-options="ticketsMember as ticketsMember.firstName+\' \'+ticketsMember.lastName +\' (\'+ticketsMember.email+\')\' for ticketsMember in vm.ticketsMember" ng-model="vm.ticketsMemberDetail" ng-disabled="vm.tickets.incidentCategory!=\'Technical\'" ng-required="vm.tickets.incidentCategory==\'Technical\'"><option value="" disabled="disabled">--Select IT Manager--</option></select></div><div class="col-md-6 col-sm-12 form-group"><label for="departmentService">Service</label><select class="form-control" id="departmentService" ng-options="services as services.serviceName for services in vm.services" ng-model="vm.serviceDetails" ng-disabled="vm.tickets.incidentCategory!= \'Process Related\' && vm.tickets.incidentCategory!= \'Grievances\' || vm.departmentDetail.id==null"><option value="" disabled="disabled" ng-selected="">--Select Services--</option></select></div><div class="col-md-6 col-sm-12 form-group" ng-show="vm.tickets.incidentCategory==\'HOBPAS\'"><label for="ticketMember">Select HOBPAS Authority <span class="text-danger" ng-show="vm.tickets.incidentCategory==\'HOBPAS\'">*</span></label><select class="form-control" id="ticketMember12" ng-options="ticketsMember as ticketsMember.firstName+\' \'+ticketsMember.lastName +\' (\'+ticketsMember.email+\')\' for ticketsMember in vm.HOBPASRole" ng-model="vm.ticketsMemberDetail" ng-disabled="vm.tickets.incidentCategory!=\'HOBPAS\'" ng-required="vm.tickets.incidentCategory==\'HOBPAS\'"><option value="" disabled="disabled">--Select HOBPAS Authority--</option></select></div><div class="col-md-6 col-sm-12 form-group" ng-show="vm.tickets.incidentCategory==\'Incentives\'"><label for="ticketMember">Select Incentives Ticket Type <span class="text-danger" ng-show="vm.tickets.incidentCategory==\'Incentives\'">*</span></label><select class="form-control" id="incentiveSubCategory" ng-model="vm.tickets.incentiveSubCategory" ng-disabled="vm.tickets.incidentCategory!=\'Incentives\'" ng-required="vm.tickets.incidentCategory==\'Incentives\'"><option value="" disabled="disabled">--Select--</option><option value="incentiveTechnical">Incentive IT</option><option value="incentiveDisbursement">Incentive Payment Disbursement</option></select></div><div class="col-md-6 col-sm-12 form-group" ng-show="vm.tickets.incidentCategory==\'Incentives\'"><label for="ticketMember">Select Incentives Authority <span class="text-danger" ng-show="vm.tickets.incidentCategory==\'Incentives\'">*</span></label><select class="form-control" id="ticketMember1" ng-options="ticketsMember as ticketsMember.firstName+\' \'+ticketsMember.lastName +\' (\'+ticketsMember.email+\')\' for ticketsMember in vm.incentivesRole" ng-model="vm.ticketsMemberDetail" ng-disabled="vm.tickets.incidentCategory!=\'Incentives\'" ng-required="vm.tickets.incidentCategory==\'Incentives\'"><option value="" disabled="disabled">--Select Incentives Authority--</option></select></div><div class="col-md-12 col-sm-12 form-group"><label>Description <span class="text-danger">*</span></label><div text-angular ng-model="vm.tickets.description" required></div></div><div class="col-md-6 form-group"><div class="row"><div class="col-md-4"><label>Select Attachment :</label></div><div class="col-md-8"><input type="file" class="form-control" file-model="vm.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div></div></div></div><hr><div class="col-md-12 form-group"><button type="submit" class="btn btn-lg btn-primary pull-right" ng-disabled="!vm.isSearchedCustomerAdded && !vm.isSearchResult && !vm.newCustomer  || generateTicket.$invalid || vm.isSaving || file.maxSizeError">Generate</button></div><br><br></form></div></div></div><div id="addCustomer" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content"><form class="form" name="addCustomer" role="form"><div class="modal-header"><button type="button" class="close" ng-click="vm.clear()" data-dismiss="modal">&times;</button><h4 class="modal-title text-success">Add Customer</h4></div><div class="modal-body"><div class="row"><jhi-alert-error></jhi-alert-error><div class="col-md-12"><input type="checkbox" ng-model="vm.isShowSearchByMobile"> <span class="text-info">Search for existing customer with mobile number</span><div class="row" ng-show="vm.isShowSearchByMobile"><span class="text-dark-blue"></span><div class="col-md-6"><div class="form-group bmd-form-group"><input type="search" class="col-md-6 form-control" name="searchMobileNumber" ng-maxlength="10" ng-minlength="10" ng-pattern="/^[0-9]*$/" ng-model="vm.customerMobile" placeholder="Search By Mobile Number Here" ng-disabled="vm.isCustomerMobileSearch"><div ng-show="addCustomer.mobileNumber.$invalid"><p class="help-block" ng-show="addCustomer.searchMobileNumber.$error.maxlength">Your Mobile cannot be longer than 10 characters.</p><p class="help-block" ng-show="addCustomer.searchMobileNumber.$error.minlength">Your Mobile cannot be less than 10 characters.</p><p class="help-block" ng-show="addCustomer.searchMobileNumber.$error.pattern">Your Mobile can only contain numbers.</p></div></div></div><div class="col-md-4"><button class="btn btn-md btn-success" type="button" ng-disabled="addCustomer.searchMobileNumber.$invalid || vm.customerMobile == null" ng-click="vm.searchByMobile(\'mobileNumber\', vm.customerMobile)">Search</button></div></div></div></div><br><div class="row"><div class="col-md-12" ng-hide="vm.isShowSearchByMobile"><div class="row"><div class="col-md-6"><div class="form-group bmd-form-group"><label class="bmd-label-floating">First Name &nbsp; <span class="text-danger">*</span></label><input type="text" name="firstName" ng-model="vm.ticketsCustomer.firstName" class="form-control" required ng-disabled="vm.isCustomerMobileSearch"></div></div><div class="col-md-6"><div class="form-group bmd-form-group"><label class="bmd-label-floating">Last Name &nbsp; <span class="text-danger">*</span></label><input type="text" name="lastName" ng-model="vm.ticketsCustomer.lastName" class="form-control" ng-disabled="vm.isCustomerMobileSearch" required></div></div></div><div class="row"><div class="col-md-6"><div class="form-group bmd-form-group"><label class="bmd-label-floating">Email address</label><input type="email" name="email" ng-model="vm.ticketsCustomer.email" class="form-control" ng-required="vm.ticketsCustomer.mobileNumber==null" ng-disabled="vm.isCustomerMobileSearch"><div ng-show="addCustomer.email.$invalid"><p class="help-block" ng-show="addCustomer.email.$error">Invalid Email address..</p></div></div></div><div class="col-md-6"><div class="form-group bmd-form-group"><label for="district">District &nbsp; <span class="text-danger">*</span></label><select class="form-control" id="district" ng-options="districts.districtname as districts.districtname for districts in vm.districts" ng-model="vm.ticketsCustomer.district" required ng-disabled="vm.isCustomerMobileSearch"><option value="" disabled="disabled" ng-selected="">--Select District--</option></select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group bmd-form-group"><label class="bmd-label-floating">Mobile No.</label><input type="number" name="mobileNumber" id="mobileNumber" ng-maxlength="10" ng-minlength="10" ng-pattern="/^[0-9]*$/" ng-model="vm.ticketsCustomer.mobileNumber" class="form-control" ng-required="vm.ticketsCustomer.email==null" ng-disabled="vm.isCustomerMobileSearch"><div ng-show="addCustomer.mobileNumber.$invalid"><p class="help-block" ng-show="addCustomer.mobileNumber.$error.maxlength">Your Mobile cannot be longer than 10 characters.</p><p class="help-block" ng-show="addCustomer.mobileNumber.$error.minlength">Your Mobile cannot be less than 10 characters.</p><p class="help-block" ng-show="addCustomer.mobileNumber.$error.pattern">Your Mobile can only contain numbers.</p></div></div></div><div class="col-md-6"><div class="form-group bmd-form-group" ng-show="vm.ticketsCustomer.district == \'Other\'"><label class="bmd-label-floating">Other</label><input type="text" name="otherField" ng-model="vm.otherField" class="form-control" ng-required="vm.ticketsCustomer.district == \'Other\'"></div></div></div></div><div class="col-md-12" ng-show="vm.isShowSearchByMobile && vm.isCustomerMobileSearch"><div class="row"><div class="col-md-6"><div class="form-group bmd-form-group"><label class="bmd-label-floating">First Name &nbsp;</label><input type="text" name="oldFirstName" ng-model="vm.oldTicketCustomer.firstName" class="form-control" disabled="disabled"></div></div><div class="col-md-6"><div class="form-group bmd-form-group"><label class="bmd-label-floating">Last Name &nbsp;</label><input type="text" name="oldLastName" ng-model="vm.oldTicketCustomer.lastName" class="form-control" disabled="disabled"></div></div></div><div class="row"><div class="col-md-6"><div class="form-group bmd-form-group"><label class="bmd-label-floating">Email address</label><input type="email" name="oldEmail" ng-model="vm.oldTicketCustomer.email" class="form-control" disabled="disabled"></div></div><div class="col-md-6"><div class="form-group bmd-form-group"><label for="district">District &nbsp;</label><select class="form-control" id="oldDistrict" ng-options="districts.districtname as districts.districtname for districts in vm.districts" ng-model="vm.oldTicketCustomer.district" disabled="disabled"><option value="" disabled="disabled" ng-selected="">--Select District--</option></select></div></div></div><div class="row"><div class="col-md-6"><div class="form-group bmd-form-group"><label class="bmd-label-floating">Mobile No.</label><input type="number" name="oldMobileNumber" id="oldMobileNumber" ng-maxlength="10" ng-minlength="10" ng-pattern="/^[0-9]*$/" ng-model="vm.oldTicketCustomer.mobileNumber" class="form-control" disabled="disabled"><div ng-show="addCustomer.oldMobileNumber.$invalid"><p class="help-block" ng-show="addCustomer.oldMobileNumber.$error.maxlength">Your Mobile cannot be longer than 10 characters.</p><p class="help-block" ng-show="addCustomer.oldMobileNumber.$error.minlength">Your Mobile cannot be less than 10 characters.</p><p class="help-block" ng-show="addCustomer.oldMobileNumber.$error.pattern">Your Mobile can only contain numbers.</p></div></div></div></div></div></div></div><div class="modal-footer text-right"><button type="button" class="btn btn-md btn-primary" ng-click="vm.addCustomer(vm.ticketsCustomer)" ng-disabled="addCustomer.$invalid" ng-show="!vm.isCustomerMobileSearch">Add</button> <button type="button" class="btn btn-md btn-success" ng-click="vm.addCustomerSearchByMobile()" ng-show="vm.isCustomerMobileSearch">Ok</button> <button type="button" class="btn btn-md btn-danger" ng-click="vm.clear()">Clear</button></div></form></div></div></div>');
$templateCache.put('app/hepcTickets/ticketMember/viewMembers.html','<div class="container-fluid"><div class="card"><div class="card-header card-header-icon" data-background-color="green"><i class="fa fa-eye fa-lg fa-2x"></i></div><div class="card-header"><h4 class="card-title col-md-6 col-sm-12"><b>All Members</b> <small class="form-group form-group-md ng-hide" aria-hidden="true">&nbsp;(TOTAL MEMBERS = <b>{{vm.ticketMembers.length}}</b>)</small></h4><div class="col-md-4 col-sm-12"><input type="search" class="form-control pull-right" placeholder="Search Member" ng-model="name"></div></div><hr><div class="card-content" ng-show="vm.ticketMembers.length==0"><br><h3 class="jumbotron text-center">No Members</h3></div><div class="card-content" ng-hide="vm.ticketMembers.length==0"><div class="table-responsive"><table class="table table-stripped table-hover"><thead><tr class="theadRowColor"><th><b>Login</b></th><!--<th><b>Name</b></th>--><th><b>Email</b></th><th><b>Authorities</b></th><!--<th><b>Mobile</b></th>--><th><b>Details</b></th><!--<th ng-show="vm.account.authorities.includes(\'ROLE_ADMIN\')">Select Dept</th>--></tr></thead><tbody><tr ng-repeat="ticketMember in vm.ticketMembers | filter: name"><td>{{ticketMember.login}}</td><!--<td>{{ticketMember.firstName}}&nbsp;{{ticketMember.lastName}}</td>--><td>{{ticketMember.email}}</td><td><span ng-show="ticketMember.authorities.includes(\'ROLE_L1_SUPPORT\')">L1 Support<br></span><span ng-show="ticketMember.authorities.includes(\'ROLE_L2_IT_MANAGER\')">L2 IT Support<br></span><span ng-show="ticketMember.authorities.includes(\'ROLE_L2_DEPARTMENT\')">L2 DEPARTMENT Support<br></span><span ng-show="ticketMember.authorities.includes(\'ROLE_L2_DEPARTMENT_HEAD\')">DEPARTMENT HOD<br></span><span ng-show="ticketMember.authorities.includes(\'ROLE_L2_INCENTIVES\')">L2 INCENTIVES<br></span><span ng-show="ticketMember.authorities.includes(\'ROLE_ADMIN\') || ticketMember.authorities.includes(\'ROLE_SUB_ADMIN\') ">ADMIN<br></span><span ng-show="ticketMember.authorities.includes(\'ROLE_TICKET_OPERATION_MANAGER\')">Helpdesk Operations Manager<br></span><span ng-show="ticketMember.authorities.includes(\'ROLE_TICKET_NODAL_OFFICER\')">Helpdesk Nodal Officer<br></span><span ng-show="ticketMember.authorities.includes(\'ROLE_TICKET_ADMIN\')">Ticket ADMIN<br></span></td><!--<td>{{ticketMember.mobile}}</td>--><td><span>{{ticketMember.firstName}}&nbsp;{{ticketMember.lastName}}</span><br><span>{{ticketMember.address}}</span><br><span ng-show="ticketMember.mobile!=null"><b>Mob</b>: <span>{{ticketMember.mobile}}</span></span></td><td ng-show="(vm.account.authorities.includes(\'ROLE_ADMIN\') || vm.account.authorities.includes(\'ROLE_SUB_ADMIN\')) && ticketMember.authorities.includes(\'ROLE_L2_DEPARTMENT_HEAD\')"><button type="button" title="Add or View Department" class="btn btn-md btn-info" data-toggle="modal" data-target="#AssigndepartmentModel" ng-click="vm.selectedMember(ticketMember)">Dept.</button></td></tr></tbody></table></div></div></div></div><div id="AssigndepartmentModel" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><form name="memberForm" role="form" novalidate ng-submit="vm.addDeparmentHead()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title" ng-show="vm.selectedTicketMember.departmentList==null">Assign Department to Member</h4><h4 class="modal-title" ng-show="vm.selectedTicketMember.departmentList!=null">View Departments</h4></div><div class="modal-body"><div class="form-group" ng-show="vm.selectedTicketMember.departmentList==null"><label>Department <span class="text-danger">*</span></label><select class="form-control" multiple="multiple" name="selectedDepartment" ng-options="department as department.departmentname for department in vm.deparment" ng-model="vm.departmentDetail" required><option value="" disabled="disabled">--Select Deparment--</option></select></div><div class="form-group" ng-show="vm.selectedTicketMember.departmentList!=null"><label>Departments:</label><ul><li ng-repeat="member in vm.selectedTicketMember.departmentList">{{member}}</li></ul></div></div><div class="modal-footer"><button type="submit" class="btn btn-success" ng-disabled="memberForm.$invalid" ng-show="vm.selectedTicketMember.departmentList==null">Assign</button> <button type="button" class="btn btn-success" data-dismiss="modal" ng-show="vm.selectedTicketMember.departmentList!=null">Ok</button></div></form></div></div></div>');
$templateCache.put('app/hepcTickets/ticketsFeedBackView/viewTicketFeedBack.html','<div class="container-fluid"><div class="card"><div class="card-header"><div class="row"><div class="col-md-3"><h3 class="text-info">Rated Tickets</h3></div><div class="col-md-3 col-md-offset-5"><select class="form-control pull-right" id="UserBy" ng-model="vm.searchBy" ng-change="vm.changeUserBy(vm.searchBy)"><option value="All" selected="selected">All</option><option value="Excellent">5 Star</option><option value="Very Good">4 Star</option><option value="Good">3 Star</option><option value="Average">2 Star</option><option value="Poor">1 Star</option></select></div><div class="col-md-1"><button id="download-btn" ng-click="vm.download(vm.feedbacks,vm.status)" type="button" class="btn btn-primary btn-sm">&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div><!--<div class="col">--><!--<button ng-show="vm.feedbacks.length!=0" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm btn-marginTop">&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button>--><!--</div>--></div></div><div class="card-content"><div class="col-md-12" ng-show="vm.feedbacks.length==0"><h3 class="text-dark-blue text-center">No Feedback Found</h3><br></div><div class="table-responsive" ng-show="vm.feedbacks.length!=0"><table class="table table-bordered table-hover"><thead><tr><th>S.No</th><th>TicketNumber</th><th>Category</th><th>Closed By</th><th>Closing Date</th><th>Investor Name</th><th>Rating</th><th>View</th></tr></thead><tbody><tr style="cursor: pointer" ng-repeat="feedback in vm.feedbacks | orderBy: \'-closingDate\'"><td>{{$index+1}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketFeedbackdetail({id:feedback.ticketNumber})">{{feedback.ticketNumber}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketFeedbackdetail({id:feedback.ticketNumber})">{{feedback.category}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketFeedbackdetail({id:feedback.ticketNumber})">{{feedback.closedBy}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketFeedbackdetail({id:feedback.ticketNumber})">{{feedback.closingDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketFeedbackdetail({id:feedback.ticketNumber})">{{feedback.investorName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketFeedbackdetail({id:feedback.ticketNumber})"><span title="Poor" ng-class="{\'fa fa-star rated\': feedback.rating==\'Excellent\' || feedback.rating==\'Very Good\' || feedback.rating==\'Good\' || feedback.rating==\'Average\' || feedback.rating==\'Poor\' , \'fa fa-star-o\': !(feedback.rating==\'Excellent\' || feedback.rating==\'Very Good\' || feedback.rating==\'Good\' || feedback.rating==\'Average\' || feedback.rating==\'Poor\')}"></span> <span title="Average" ng-class="{\'fa fa-star rated\': feedback.rating==\'Excellent\' || feedback.rating==\'Very Good\' || feedback.rating==\'Good\' || feedback.rating==\'Average\', \'fa fa-star-o\': !(feedback.rating==\'Excellent\' || feedback.rating==\'Very Good\' || feedback.rating==\'Good\' || feedback.rating==\'Average\')}"></span> <span title="Good" ng-class="{\'fa fa-star rated\': feedback.rating==\'Excellent\' || feedback.rating==\'Very Good\' || feedback.rating==\'Good\' , \'fa fa-star-o\': !(feedback.rating==\'Excellent\' || feedback.rating==\'Very Good\' || feedback.rating==\'Good\')}"></span> <span title="Very Good" ng-class="{\'fa fa-star rated\': feedback.rating==\'Excellent\' || feedback.rating==\'Very Good\' , \'fa fa-star-o\': !(feedback.rating==\'Excellent\' || feedback.rating==\'Very Good\')}"></span> <span title="Excellent" ng-class="{\'fa fa-star rated\': feedback.rating==\'Excellent\' , \'fa fa-star-o\': !(feedback.rating==\'Excellent\')}"></span></td><td><button type="button" title="Remark" class="btn btn-info" data-target="#ratingRemark" data-toggle="modal" ng-click="vm.selectedFeedback(feedback)"><span class="fa fa-eye"></span></button></td></tr></tbody></table></div></div></div></div><div id="ratingRemark" class="modal fade" role="dialog"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><h4 class="modal-title">Investor Remark <button type="button" class="btn btn-sm pull-right" data-dismiss="modal">X</button></h4></div><div class="modal-body col-md-12"><div class="form-group"><div class="row"><span class="col-md-2"><b>Rating</b>:</span><div class="col-md-8"><span title="Poor" class="fa fa-3x" ng-class="{\'fa fa-star rated\': vm.feed.rating==\'Excellent\' || vm.feed.rating==\'Very Good\' || vm.feed.rating==\'Good\' || vm.feed.rating==\'Average\' || vm.feed.rating==\'Poor\' , \'fa fa-star-o\': !(vm.feed.rating==\'Excellent\' || vm.feed.rating==\'Very Good\' || vm.feed.rating==\'Good\' || vm.feed.rating==\'Average\' || vm.feed.rating==\'Poor\')}"></span> <span title="Average" class="fa fa-3x" ng-class="{\'fa fa-star rated\': vm.feed.rating==\'Excellent\' || vm.feed.rating==\'Very Good\' || vm.feed.rating==\'Good\' || vm.feed.rating==\'Average\', \'fa fa-star-o\': !(vm.feed.rating==\'Excellent\' || vm.feed.rating==\'Very Good\' || vm.feed.rating==\'Good\' || vm.feed.rating==\'Average\')}"></span> <span title="Good" class="fa fa-3x" ng-class="{\'fa fa-star rated\': vm.feed.rating==\'Excellent\' || vm.feed.rating==\'Very Good\' || vm.feed.rating==\'Good\' , \'fa fa-star-o\': !(vm.feed.rating==\'Excellent\' || vm.feed.rating==\'Very Good\' || vm.feed.rating==\'Good\')}"></span> <span title="Very Good" class="fa fa-3x" ng-class="{\'fa fa-star rated\': vm.feed.rating==\'Excellent\' || vm.feed.rating==\'Very Good\' , \'fa fa-star-o\': !(vm.feed.rating==\'Excellent\' || vm.feed.rating==\'Very Good\')}"></span> <span title="Excellent" class="fa fa-3x" ng-class="{\'fa fa-star rated\': vm.feed.rating==\'Excellent\' , \'fa fa-star-o\': !(vm.feed.rating==\'Excellent\')}"></span></div></div></div><div class="row form-group"><label class="col-md-2" style="padding-bottom: 10px">Remarks: &nbsp;&nbsp;&nbsp;</label><textarea rows="8" cols="400" class="col-md-8" type="text" name="comment" ng-model="vm.feed.ratingRemark" readonly="readonly"></textarea></div></div><div class="modal-footer"><span class="col-md-7"><button type="button" class="btn btn-warning" data-dismiss="modal">Close</button></span></div></div></div></div>');
$templateCache.put('app/hepcTickets/ticketsFeedBackView/viewTicketFeedBackDetail.html','<div class="container-fluid"><div class="row"><div class="col-md-8"><div class="card"><div class="card-content"><div class="row"><div class="col-md-6 col-sm-12 pull-left"><h4 class="card-title text-success text-left"><b>Ticket Details</b></h4></div><div class="col-md-2 col-sm-12" ng-show="vm.timeStatus"><label class="text-danger" for="hi" style="padding-top: 24px; font-size: 14px">Time Left :</label></div><div class="col-md-4 col-sm-12 pull-right" ng-show="vm.timeStatus"><span id="hi" class="flip-clock countDown"></span></div></div><hr><div class="row"><div class="col-md-6"><label class="label-floating">Current Status:</label><i ng-show="vm.tickets.status==\'Open\'" class="fa fa-circle text-success"></i> <i ng-show="vm.tickets.status==\'Closed\'" class="fa fa-circle text-danger"></i> <span>{{vm.tickets.status}}</span></div><div class="col-md-6 text-right" ng-show="vm.tickets.assignedMemberName == vm.account.login"><button class="btn btn-sm btn-info" ng-hide="vm.tickets.status==\'Closed\' || vm.tickets.incidentCategory==\'Grievances\' || vm.tickets.incidentCategory==\'Suggestion/Feedback\' || vm.tickets.level==\'LEVEL_3\' || vm.tickets.level==\'LEVEL_2\' || vm.tickets.level==\'LEVEL_OPERATION_MANAGER\'" data-toggle="modal" data-target="#changeLevel" ng-disabled="!vm.workingStatus"><b>Assign to next level</b></button> <button class="btn btn-sm btn-success" ng-show="vm.tickets.status==\'Open\'" data-toggle="modal" data-target="#setStatus" ng-disabled="!vm.workingStatus"><b>Close</b></button></div><div class="col-md-6 text-right" has-authority="ROLE_TICKET_OPERATION_MANAGER" ng-show="vm.tickets.assignedMemberName != vm.account.login && vm.tickets.level == \'LEVEL_1\' && vm.tickets.status != \'Closed\'"><button class="btn btn-sm btn-info" data-toggle="modal" data-target="#changeLevel" ng-disabled="!vm.workingStatus"><b>Assign to level 2</b></button> <button class="btn btn-sm btn-success" data-toggle="modal" data-target="#setStatus" ng-disabled="!vm.workingStatus"><b>Close</b></button></div></div><br><div class="row"><div class="col-md-6 form-group"><label>Ticket Number</label><span type="text" class="form-control">{{vm.tickets.ticketNumber}}</span></div><div class="col-md-6 form-group"><label>Creation Date</label><span class="form-control">{{vm.tickets.creationDate | date : \'dd-MMM-yyyy h:mm a\'}}</span></div><div class="col-md-6 form-group"><label>Priority</label><span class="form-control">{{vm.tickets.priority}}</span></div><div class="col-md-6 form-group"><label>Incident Category</label><span class="form-control">{{vm.tickets.incidentCategory}}</span></div><div class="col-md-6 form-group"><label>Assigned Member</label><span ng-show="vm.tickets.assignedMemberUserName!=null" class="form-control">{{vm.tickets.assignedMemberUserName}}</span> <span ng-show="vm.tickets.assignedMemberUserName==null" class="form-control">{{vm.tickets.assignedMemberName}}</span></div><div class="col-md-6"><label>Assigned Department</label><div><span class="form-control" ng-hide="vm.tickets.assignedDepartmentName==null">{{vm.tickets.assignedDepartmentName}}</span> <span class="form-control" ng-show="vm.tickets.assignedDepartmentName==null">--</span></div><br></div><!--<div class="col-md-12 form-group">--><!--<label> Latest Remark </label>--><!--<span class="form-control">{{vm.tickets.latestRemark}}</span>--><!--</div>--><div class="col-md-8 form-group label-floating"><label>Subject</label><span class="form-control">{{vm.tickets.subject}}</span></div><div class="col-md-4" ng-show="vm.tickets.assignedMemberName == vm.account.login"><button style="margin-top: 22px" class="btn btn-sm btn-warning" ng-hide="vm.tickets.status==\'Closed\'" data-toggle="modal" data-target="#commentUpload" ng-disabled="!vm.workingStatus"><b>Comment / Upload</b></button></div><br></div></div></div></div><div class="col-md-4"><div class="card"><div class="card-header card-header-icon" data-background-color="green"><i class="fa fa-address-book-o fa-2x"></i></div><h4 class="card-title text-default"><b>Investor Details</b></h4><div class="card-content"><div class="col-md-12 form-group"><label>Name :</label><span class="form-control">{{vm.complainant.firstName}}&nbsp;{{vm.complainant.lastName}}</span></div><div class="col-md-12 form-group" ng-show="vm.complainant.cafpin!=null"><label>Cafpin</label><span class="form-control">{{vm.complainant.cafpin}}</span></div><div class="col-md-12 form-group"><label>E-Mail</label><span class="form-control">{{vm.complainant.email}}</span></div><div class="col-md-12 form-group" ng-show="vm.complainant.mobileNumber!=null && vm.complainant.cafpin==null"><label>Mobile Number</label><span class="form-control">{{vm.complainant.mobileNumber}}</span></div><!--<div class="col-md-12">--><!--<label class=" control-label label-floating">District</label>--><!--<span class="form-control">{{vm.tickets.district}}</span>--><!--<br>--><!--</div>--></div></div></div></div><div class="card"><div class="card-header"><h4 class="text-success"><div class="col-md-5"><span class="pull-left"><b>Ticket Description</b></span></div><div class="col-md-4"><span ng-show="vm.tickets.createdByName!=null"><small class="text-center">CreatedBy: {{vm.tickets.createdByName}}</small></span> <span ng-show="vm.tickets.createdByName==null"><small class="text-center">CreatedBy: {{vm.tickets.createdBy}}</small></span></div><div class="col-md-3"><span class="pull-right" ng-show="vm.tickets.attachment != null">Attachment : <button id="download-btn" ng-click="vm.downloadAttachment(vm.tickets.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></span></div></h4></div><hr><div class="card-content"><div ta-bind ng-model="vm.tickets.description" class="editorTextView" name="description" id="field_description" contenteditable="false"></div></div></div><div class="card"><div class="card-header"><h4 class="card-title text-default"><b>Latest Remark</b></h4></div><div class="card-content"><div class="col-md-12 form-group"><textarea type="text" name="comment" class="form-control" ng-model="vm.tickets.latestRemark" style="height: 70px" disabled="disabled"></textarea></div></div></div></div><div id="setStatus" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content"><form class="form" name="closeTicket" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Number: <b>{{vm.tickets.ticketNumber}}</b></h4></div><div class="modal-body"><h5 class="text-center" style="border-style: ridge">Please provide the reason for the status update:</h5><div class="form-group"><textarea type="text" name="comment" class="form-control" ng-model="vm.latestRemark" maxlength="250" placeholder="Enter Remark" required></textarea></div></div><div class="modal-footer"><button type="button" ng-click="vm.changeStatus()" ng-disabled="closeTicket.$invalid || vm.statusChange" class="btn btn-success">Change Status</button></div></form></div></div></div><div id="changeLevel" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content"><form class="form" name="assignTicket" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Number: <b>{{vm.tickets.ticketNumber}}</b></h4></div><div class="modal-body"><h5 class="text-center" style="border-style: ridge">Please provide the reason:</h5><div class="form-group"><textarea type="text" name="comment" class="form-control" ng-model="vm.latestRemark" maxlength="110" placeholder="Enter Remark" required></textarea></div></div><div class="modal-footer"><button type="button" ng-click="vm.changeLevel()" ng-disabled="assignTicket.$invalid || vm.levelChange" class="btn btn-success">Assign</button></div></form></div></div></div><div id="commentUpload" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content"><form class="form" name="uploadComment" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Number: <b>{{vm.tickets.ticketNumber}}</b></h4></div><div class="modal-body"><h5 class="text-center" style="border-style: ridge">Please provide the comment:</h5><div class="form-group"><textarea type="text" name="ticketComment" class="form-control" ng-model="vm.ticketComment" maxlength="110" placeholder="Enter Comment" required></textarea></div><input type="file" class="form-control" file-model="vm.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div><div class="modal-footer"><button type="button" ng-click="vm.uploadFile()" ng-disabled="uploadComment.$invalid || file.maxSizeError" class="btn btn-success">Save</button></div></form></div></div></div>');
$templateCache.put('app/hepcTickets/viewTicket/adminTicketView.html','<div class="container-fluid"><div class="card"><div class="card-header card-header-icon" data-background-color="green"><i class="fa fa-eye fa-lg fa-2x"></i></div><div class="card-header"><h4 class="card-title col-md-6 col-sm-12"><b>All Tickets</b> <small class="form-group form-group-md ng-hide" aria-hidden="true">&nbsp;(TOTAL TICKETS = <b>{{vm.allTickets.length}}</b>)</small></h4><div class="col-md-4 col-sm-12 pull-right"><input type="search" class="form-control pull-right" placeholder="Search Ticket" ng-model="name"></div><br><div class="col-md-5"><button style="margin-bottom: 12px" ng-click="vm.download_all_table_data(vm.ticketList1)" type="button" class="btn btn-success btn-sm pull-right btn-marginTop"><span class="glyphicon glyphicon-download-alt"></span></button></div><div class="col-md-12 col-sm-12 text-right"><i class="fa fa-circle text-success"></i> Open &nbsp; &nbsp; <i class="fa fa-circle text-danger"></i> Closed</div></div><hr><div class="card-content" ng-show="vm.allTickets.length==0"><br><h3 class="jumbotron text-center">No Tickets</h3></div><div class="card-content" ng-hide="vm.allTickets.length==0"><table class="table table-stripped table-hover"><thead><tr class="theadRowColor"><th>#</th><th class="text-center"><span><b>Ticket Number</b></span></th><th class="text-center"><span><b>Subject</b></span></th><th class="text-center"><span><b>Department</b></span></th><th class="text-center"><span><b>Assigned Member</b></span></th><th class="text-center"><span><b>Priority</b></span></th><th class="text-center"><span><b>Created By</b></span></th><th class="text-center"><span><b>Creation Date</b></span></th><th class="text-center"><span><b>Action</b></span></th></tr></thead><tbody class="text-center"><tr style="cursor: pointer" ng-class="{AutoAssignTickets: tickets.latestRemark == \'Auto Assign To \'+tickets.level}" ng-repeat="tickets in vm.allTickets | orderBy: \'-creationDate\' | filter: name"><td><i ng-show="tickets.status==\'Open\'" class="fa fa-circle text-success"></i> <i ng-show="tickets.status==\'Closed\'" class="fa fa-circle text-danger"></i></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.ticketNumber}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.subject}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-if="tickets.assignedDepartmentName!=null">{{tickets.assignedDepartmentName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-if="tickets.assignedDepartmentName==null">--</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.assignedMemberUserName!=null">{{tickets.assignedMemberUserName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.assignedMemberUserName==null">{{tickets.assignedMemberName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.priority}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.createdByName!=null">{{tickets.createdByName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.createdByName==null">{{tickets.createdBy}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.creationDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td><button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#logsModal" ng-click="vm.getLogs(tickets)"><b>Logs</b></button></td></tr></tbody></table><button class="btn btn-blue" ng-click="vm.loadAll(vm.page - 1)">Previous</button> <button class="btn btn-blue" ng-click="vm.loadAll(vm.page + 1)">Next</button></div></div></div><div id="logsModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Logs <span class="pull-right">Ticket No - {{vm.ticketsLogs[0].ticketNumber}} &nbsp; &nbsp;</span></h4></div><div class="modal-body table-responsive"><table class="table table-bordered"><thead><tr class="theadRowColor"><th class="text-center">#</th><th class="text-center">Action Type</th><th class="text-center">Action By</th><th class="text-center">Action Date</th><th class="text-center">Remark</th><th class="text-center">Last Assigned</th><th class="text-center">Attachment</th></tr></thead><tbody><tr class="text-center" ng-repeat="ticketLogs in vm.ticketsLogs | orderBy: \'-actionDate\'"><td>{{$index+1}}</td><td>{{ticketLogs.actionType}}</td><td title="{{ticketLogs.actionBy}}" ng-show="ticketLogs.actionByName!=null">{{ticketLogs.actionByName}}</td><td ng-show="ticketLogs.actionByName==null">{{ticketLogs.actionBy}}</td><td>{{ticketLogs.actionDate | date: \'dd-MMM-yyyy h:mm a\'}}</td><td>{{ticketLogs.remark}}</td><td title="{{ticketLogs.lastAssigned}}" ng-show="ticketLogs.lastAssignedName!=null">{{ticketLogs.lastAssignedName}}</td><td ng-show="ticketLogs.lastAssignedName==null">{{ticketLogs.lastAssigned}}</td><td><span ng-show="ticketLogs.attachment!=null"><button id="download-btn" ng-click="vm.downloadAttachment(ticketLogs.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></span> <span ng-show="ticketLogs.attachment==null">--</span></td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/hepcTickets/viewTicket/departmentTickets.html','<div class="container-fluid"><div class="card"><div class="card-header card-header-icon" data-background-color="green"><i class="fa fa-eye fa-lg fa-2x"></i></div><div class="card-header"><div class="row"><div class="col-md-6 col-sm-12"><h3 class="card-title"><b>Pending Tickets</b> <small class="form-group form-group-md" aria-hidden="true">&nbsp;(TOTAL TICKETS = <b>{{vm.pendingDepartmentTickets.length}}</b>)</small></h3></div><div class="col-md-4 col-sm-12 pull-right"><input type="search" class="form-control pull-right" placeholder="Search Ticket" ng-model="name"></div></div></div><!--<div class="card-content" ng-show="vm.ticketmember.departmentList!=null">--><!--<div class="row">--><!--<div class="col-md-6 form-group">--><!--<select class="form-control" id="department" ng-model="vm.deptKey" ng-change="vm.getTicketByDepartment(vm.deptKey)">--><!--<option value="" disabled selected>&#45;&#45;Select Department&#45;&#45;</option>--><!--<option ng-repeat="(key, value) in vm.ticketmember.departmentList" value="{{key}}">{{value}}</option>--><!--</select>--><!--</div>--><!--<div class="col-md-6 col-sm-12 text-right">--><!--<i class="fa fa-circle text-success"></i> Open &nbsp; &nbsp;--><!--<i class="fa fa-circle text-danger"></i> Closed--><!--</div>--><!--</div>--><!--</div>--><div class="card-content" ng-show="vm.pendingDepartmentTickets.length==0"><h3 class="jumbotron text-center">No Tickets</h3></div><div class="card-content" ng-show="vm.pendingDepartmentTickets.length!=0"><table class="table table-stripped table-hover"><thead><tr class="theadRowColor"><th>#</th><th class="text-center"><span><b>Ticket Number</b></span></th><th class="text-center"><span><b>Subject</b></span></th><th class="text-center"><span><b>Assigned Member</b></span></th><th class="text-center"><span><b>Assign Date</b></span></th><th class="text-center"><span><b>Priority</b></span></th><th class="text-center"><span><b>Created By</b></span></th><th class="text-center"><span><b>Creation Date</b></span></th><th class="text-center"><span><b>Action</b></span></th></tr></thead><tbody class="text-center"><tr style="cursor: pointer" ng-class="{AutoAssignTickets: tickets.latestRemark == \'Auto Assign To \'+tickets.level}" ng-repeat="tickets in vm.pendingDepartmentTickets | orderBy: \'-creationDate\' | filter: name"><td><i ng-show="tickets.status==\'Open\'" class="fa fa-circle text-success"></i> <i ng-show="tickets.status==\'Closed\'" class="fa fa-circle text-danger"></i></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.ticketNumber}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.subject}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.assignedMemberUserName!=null">{{tickets.assignedMemberUserName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.assignedMemberUserName==null">{{tickets.assignedMemberName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.assignDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.priority}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.createdByName!=null">{{tickets.createdByName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.createdByName==null">{{tickets.createdBy}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.creationDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td><button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#logsModal" ng-click="vm.getLogs(tickets)"><b>Logs</b></button></td></tr></tbody></table></div></div></div><div id="logsModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Logs <span class="pull-right">Ticket No - {{vm.ticketsLogs[0].ticketNumber}} &nbsp; &nbsp;</span></h4></div><div class="modal-body table-responsive"><table class="table table-bordered"><thead><tr class="theadRowColor"><th class="text-center">#</th><th class="text-center">Action Type</th><th class="text-center">Action By</th><th class="text-center">Action Date</th><th class="text-center">Remark</th><th class="text-center">Last Assigned</th><th class="text-center">Attachment</th></tr></thead><tbody><tr class="text-center" ng-repeat="ticketLogs in vm.ticketsLogs | orderBy: \'-actionDate\'"><td>{{$index+1}}</td><td>{{ticketLogs.actionType}}</td><td title="{{ticketLogs.actionBy}}" ng-show="ticketLogs.actionByName!=null">{{ticketLogs.actionByName}}</td><td ng-show="ticketLogs.actionByName==null">{{ticketLogs.actionBy}}</td><td>{{ticketLogs.actionDate | date: \'dd-MMM-yyyy h:mm a\'}}</td><td>{{ticketLogs.remark}}</td><td title="{{ticketLogs.lastAssigned}}" ng-show="ticketLogs.lastAssignedName!=null">{{ticketLogs.lastAssignedName}}</td><td ng-show="ticketLogs.lastAssignedName==null">{{ticketLogs.lastAssigned}}</td><td ng-show="ticketLogs.attachment!=null"><button id="download-btn" ng-click="vm.downloadAttachment(ticketLogs.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></td><td ng-show="ticketLogs.attachment==null">--</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/hepcTickets/viewTicket/escalatedTickets.html','<div class="container-fluid"><div class="card"><div class="card-header card-header-icon" data-background-color="green"><i class="fa fa-eye fa-lg fa-2x"></i></div><div class="card-header"><h4 class="card-title col-md-6 col-sm-12"><b>Timeout Tickets</b> <small class="form-group form-group-md" aria-hidden="true">&nbsp;(TOTAL TICKETS = <b>{{vm.allEscalatedTickets.length}}</b>)</small></h4><div class="col-md-4 col-sm-12 pull-right"><input type="search" class="form-control pull-right" placeholder="Search Ticket" ng-model="name"></div></div><hr><div class="card-content" ng-show="vm.ticketmember.departmentList!=null"><div class="row"><div class="col-md-6 form-group"><select class="form-control" id="department" ng-model="vm.deptKey" ng-change="vm.getTicketByDepartment(vm.deptKey)"><option value="" disabled="disabled" selected="selected">--Select Department--</option><option ng-repeat="(key, value) in vm.ticketmember.departmentList" value="{{key}}">{{value}}</option></select></div><div class="col-md-6 col-sm-12 text-right"><i class="fa fa-circle text-success"></i> Open &nbsp; &nbsp; <i class="fa fa-circle text-danger"></i> Closed</div></div></div><div class="card-content" ng-show="vm.allEscalatedTickets.length==0"><h3 class="jumbotron text-center">No Tickets</h3></div><div class="card-content" ng-show="vm.allEscalatedTickets.length!=0"><table class="table table-stripped table-hover"><thead><tr class="theadRowColor"><th>#</th><th class="text-center"><span><b>Ticket Number</b></span></th><th class="text-center"><span><b>Subject</b></span></th><th class="text-center"><span><b>Assigned Member</b></span></th><th class="text-center"><span><b>Assign Date</b></span></th><th class="text-center"><span><b>Priority</b></span></th><th class="text-center"><span><b>Created By</b></span></th><th class="text-center"><span><b>Creation Date</b></span></th><th class="text-center"><span><b>Action</b></span></th></tr></thead><tbody class="text-center"><tr style="cursor: pointer" ng-class="{AutoAssignTickets: tickets.latestRemark == \'Auto Assign To \'+tickets.level}" ng-repeat="tickets in vm.allEscalatedTickets | orderBy: \'-creationDate\' | filter: name"><td><i ng-show="tickets.status==\'Open\'" class="fa fa-circle text-success"></i> <i ng-show="tickets.status==\'Closed\'" class="fa fa-circle text-danger"></i></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.ticketNumber}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.subject}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.assignedMemberUserName!=null">{{tickets.assignedMemberUserName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.assignedMemberUserName==null">{{tickets.assignedMemberName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.assignDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.priority}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.createdByName!=null">{{tickets.createdByName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.createdByName==null">{{tickets.createdBy}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.creationDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td><button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#logsModal" ng-click="vm.getLogs(tickets)"><b>Logs</b></button></td></tr></tbody></table></div></div></div><div id="logsModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Logs <span class="pull-right">Ticket No - {{vm.ticketsLogs[0].ticketNumber}} &nbsp; &nbsp;</span></h4></div><div class="modal-body table-responsive"><table class="table table-bordered"><thead><tr class="theadRowColor"><th class="text-center">#</th><th class="text-center">Action Type</th><th class="text-center">Action By</th><th class="text-center">Action Date</th><th class="text-center">Remark</th><th class="text-center">Last Assigned</th><th class="text-center">Attachment</th></tr></thead><tbody><tr class="text-center" ng-repeat="ticketLogs in vm.ticketsLogs | orderBy: \'-actionDate\'"><td>{{$index+1}}</td><td>{{ticketLogs.actionType}}</td><td title="{{ticketLogs.actionBy}}" ng-show="ticketLogs.actionByName!=null">{{ticketLogs.actionByName}}</td><td ng-show="ticketLogs.actionByName==null">{{ticketLogs.actionBy}}</td><td>{{ticketLogs.actionDate | date: \'dd-MMM-yyyy h:mm a\'}}</td><td>{{ticketLogs.remark}}</td><td title="{{ticketLogs.lastAssigned}}" ng-show="ticketLogs.lastAssignedName!=null">{{ticketLogs.lastAssignedName}}</td><td ng-show="ticketLogs.lastAssignedName==null">{{ticketLogs.lastAssigned}}</td><td ng-show="ticketLogs.attachment!=null"><button id="download-btn" ng-click="vm.downloadAttachment(ticketLogs.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></td><td ng-show="ticketLogs.attachment==null">--</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/hepcTickets/viewTicket/viewClosedTicket.html','<div class="container-fluid"><div class="card"><div class="card-header card-header-icon" data-background-color="green"><i class="fa fa-eye fa-lg fa-2x"></i></div><div class="card-header"><h4 class="card-title col-md-6 col-sm-12"><b>My Closed Tickets</b> <small class="form-group form-group-md ng-hide" aria-hidden="true">&nbsp;(TOTAL TICKETS = <b>{{vm.tickets.length}}</b>)</small></h4><div class="col-md-4 col-sm-12"><input type="search" class="form-control pull-right" placeholder="Search Ticket" ng-model="name"></div></div><hr><div class="card-content" ng-show="vm.tickets.length==0"><br><h3 class="jumbotron text-center">No Closed Tickets</h3></div><div class="card-content" ng-show="vm.tickets.length!=0"><div class="table-responsive"><table class="table table-stripped table-hover"><thead><tr class="theadRowColor"><th>#</th><th><span><b>Ticket Number</b></span></th><th><span><b>Subject</b></span></th><th><span><b>Member</b></span></th><th><span><b>Priority</b></span></th><th><span><b>Created By</b></span></th><th><span><b>Creation Date</b></span></th><th><span><b>Status</b></span></th><th><span><b>Action</b></span></th></tr></thead><tbody><tr style="cursor: pointer" ng-repeat="tickets in vm.tickets | orderBy: \'-creationDate\' | filter: name"><td><i ng-show="tickets.status==\'Open\'" class="fa fa-circle text-success"></i> <i ng-show="tickets.status==\'Closed\'" class="fa fa-circle text-danger"></i></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.ticketNumber}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.subject}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.assignedMemberUserName!=null">{{tickets.assignedMemberUserName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.assignedMemberUserName==null">{{tickets.assignedMemberName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.priority}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.createdByName!=null">{{tickets.createdByName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.createdByName==null">{{tickets.createdBy}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.creationDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td ng-show="tickets.status==\'Open\'" ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})"><b style="color: darkgreen">Open</b></td><td ng-show="tickets.status==\'Closed\'" ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})"><b style="color: darkred">Closed</b></td><td><button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#logsModal" ng-click="vm.getLogs(tickets)"><b>Logs</b></button></td></tr></tbody></table></div></div></div></div><div id="logsModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Logs <span class="pull-right">Ticket No - {{vm.ticketsLogs[0].ticketNumber}} &nbsp; &nbsp;</span></h4></div><div class="modal-body table-responsive"><table class="table table-bordered"><thead><tr class="theadRowColor"><th class="text-center">#</th><th class="text-center">Action Type</th><th class="text-center">Action By</th><th class="text-center">Action Date</th><th class="text-center">Remark</th><th class="text-center">Last Assigned</th><th class="text-center">Attachment</th></tr></thead><tbody><tr class="text-center" ng-repeat="ticketLogs in vm.ticketsLogs | orderBy: \'-actionDate\'"><td>{{$index+1}}</td><td>{{ticketLogs.actionType}}</td><td title="{{ticketLogs.actionBy}}" ng-show="ticketLogs.actionByName!=null">{{ticketLogs.actionByName}}</td><td ng-show="ticketLogs.actionByName==null">{{ticketLogs.actionBy}}</td><td>{{ticketLogs.actionDate | date: \'dd-MMM-yyyy h:mm a\'}}</td><td>{{ticketLogs.remark}}</td><td title="{{ticketLogs.lastAssigned}}" ng-show="ticketLogs.lastAssignedName!=null">{{ticketLogs.lastAssignedName}}</td><td ng-show="ticketLogs.lastAssignedName==null">{{ticketLogs.lastAssigned}}</td><td ng-show="ticketLogs.attachment!=null"><button id="download-btn" ng-click="vm.downloadAttachment(ticketLogs.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></td><td ng-show="ticketLogs.attachment==null">--</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/hepcTickets/viewTicket/viewMyOpenTicket.html','<div class="container-fluid"><div class="card"><div class="card-header card-header-icon" data-background-color="green"><i class="fa fa-eye fa-lg fa-2x"></i></div><div class="card-header"><h4 class="card-title col-md-5 col-sm-12"><b>My Open Tickets</b> <small class="form-group form-group-md ng-hide" ng-show="vm.tickets.length==0" aria-hidden="true">&nbsp;(TOTAL TICKETS = <b>0</b>)</small> <small class="form-group form-group-md ng-hide" ng-show="vm.tickets.length!=0" aria-hidden="true">&nbsp;(TOTAL TICKETS = <b>{{vm.tickets.length}}</b>)</small></h4><div class="col-md-4 col-sm-12"><input type="search" class="form-control pull-right" placeholder="Search Ticket" ng-model="name"></div><div class="col-md-1"><button ng-if="!vm.tickets.length==0" id="download-btn" onclick="download_table_data()" type="button" class="btn btn-primary btn-sm pull-right">&nbsp;<span class="glyphicon glyphicon-download-alt"></span></button></div></div><hr><div class="card-content" ng-if="vm.tickets.length==0"><br><h3 class="jumbotron text-center">No Open Tickets</h3></div><div class="card-content" ng-if="!vm.tickets.length==0"><div class="table-responsive"><table id="result_table" class="table table-stripped table-hover"><thead><tr class="theadRowColor"><th>#</th><th><span><b>Ticket Number</b></span></th><th><span><b>Subject</b></span></th><th><span><b>Category</b></span></th><th><span><b>Member</b></span></th><th><span><b>Priority</b></span></th><th><span><b>Created By</b></span></th><th><span><b>Creation Date</b></span></th><th><span><b>Status</b></span></th><th><span><b>Action</b></span></th></tr></thead><tbody><tr style="cursor: pointer" ng-class="{AutoAssignTickets: tickets.latestRemark == \'Auto Assign To \'+tickets.level, \'validation\': !tickets.isOpen}" ng-repeat="tickets in vm.tickets | orderBy: \'-creationDate\' | filter: name"><td><i ng-show="tickets.status==\'Open\'" class="fa fa-circle text-success"></i> <i ng-show="tickets.status==\'Closed\'" class="fa fa-circle text-danger"></i></td><td ng-click="vm.redirect(tickets)">{{tickets.ticketNumber}}</td><td ng-click="vm.redirect(tickets)">{{tickets.subject}}</td><td ng-click="vm.redirect(tickets)">{{tickets.incidentCategory}}</td><td ng-click="vm.redirect(tickets)" ng-if="tickets.assignedMemberUserName!=null">{{tickets.assignedMemberUserName}}</td><td ng-click="vm.redirect(tickets)" ng-if="tickets.assignedMemberUserName==null">{{tickets.assignedMemberName}}</td><td ng-click="vm.redirect(tickets)">{{tickets.priority}}</td><td ng-click="vm.redirect(tickets)" ng-if="tickets.createdByName!=null">{{tickets.createdByName}}</td><td ng-click="vm.redirect(tickets)" ng-if="tickets.createdByName==null">{{tickets.createdBy}}</td><td ng-click="vm.redirect(tickets)">{{tickets.creationDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td ng-if="tickets.status==\'Open\'" ng-click="vm.redirect(tickets)"><b style="color: darkgreen">Open</b></td><td ng-if="tickets.status==\'Closed\'" ng-click="vm.redirect(tickets)"><b style="color: darkred">Closed</b></td><td><button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#logsModal" ng-click="vm.getLogs(tickets)"><b>Logs</b></button></td></tr></tbody></table></div></div></div></div><div id="logsModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Logs <span class="pull-right">Ticket No - {{vm.ticketsLogs[0].ticketNumber}} &nbsp; &nbsp;</span></h4></div><div class="modal-body table-responsive"><table class="table table-bordered"><thead><tr class="theadRowColor"><th class="text-center">#</th><th class="text-center">Action Type</th><th class="text-center">Action By</th><th class="text-center">Action Date</th><th class="text-center">Remark</th><th class="text-center">Last Assigned</th><th class="text-center">Attachment</th></tr></thead><tbody><tr class="text-center" ng-repeat="ticketLogs in vm.ticketsLogs | orderBy: \'-actionDate\'"><td>{{$index+1}}</td><td>{{ticketLogs.actionType}}</td><td title="{{ticketLogs.actionBy}}" ng-show="ticketLogs.actionByName!=null">{{ticketLogs.actionByName}}</td><td ng-show="ticketLogs.actionByName==null">{{ticketLogs.actionBy}}</td><td>{{ticketLogs.actionDate | date: \'dd-MMM-yyyy h:mm a\'}}</td><td>{{ticketLogs.remark}}</td><td title="{{ticketLogs.lastAssigned}}" ng-show="ticketLogs.lastAssignedName!=null">{{ticketLogs.lastAssignedName}}</td><td ng-show="ticketLogs.lastAssignedName==null">{{ticketLogs.lastAssigned}}</td><td ng-show="ticketLogs.attachment!=null"><button id="download-btn" ng-click="vm.downloadAttachment(ticketLogs.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></td><td ng-show="ticketLogs.attachment==null">--</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/hepcTickets/viewTicket/viewTicketCreatedBy.html','<div class="container-fluid"><div class="card"><div class="card-header card-header-icon" data-background-color="green"><i class="fa fa-eye fa-lg fa-2x"></i></div><div class="card-header"><h4 class="card-title col-md-6 col-sm-12"><b>Generated Tickets</b> <small class="form-group form-group-md ng-hide" aria-hidden="true">&nbsp;(TOTAL TICKETS = <b>{{vm.allTickets.length}}</b>)</small></h4><div class="col-md-4 col-sm-12"><input type="search" class="form-control pull-right" placeholder="Search Ticket" ng-model="name"></div></div><hr><div class="card-content" ng-show="vm.allTickets.length==0"><br><h3 class="jumbotron text-center">No Open Tickets</h3></div><div class="card-content" ng-hide="vm.allTickets.length==0"><div class="table-responsive"><table class="table table-stripped table-hover"><thead><tr class="theadRowColor"><th>#</th><th><span><b>Ticket Number</b></span></th><th><span><b>Subject</b></span></th><th><span><b>Category</b></span></th><th><span><b>Member</b></span></th><th><span><b>Priority</b></span></th><th><span><b>Creation Date</b></span></th><th><span><b>Status</b></span></th><th><span><b>Action</b></span></th></tr></thead><tbody><tr style="cursor: pointer" ng-class="{AutoAssignTickets: tickets.latestRemark == \'Auto Assign To \'+tickets.level}" ng-repeat="tickets in vm.allTickets | orderBy: \'-creationDate\' | filter: name"><td><i ng-show="tickets.status==\'Open\'" class="fa fa-circle text-success"></i> <i ng-show="tickets.status==\'Closed\'" class="fa fa-circle text-danger"></i></td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.ticketNumber}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.subject}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.incidentCategory}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.assignedMemberUserName!=null">{{tickets.assignedMemberUserName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})" ng-show="tickets.assignedMemberUserName==null">{{tickets.assignedMemberName}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.priority}}</td><td ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})">{{tickets.creationDate | date:\'dd-MMM-yyyy h:mm a\'}}</td><td ng-show="tickets.status==\'Open\'" ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})"><b style="color: darkgreen">Open</b></td><td ng-show="tickets.status==\'Closed\'" ui-sref-opts="{reload: true, notify: true}" ui-sref="ticketdetail({id:tickets.id})"><b style="color: darkred">Closed</b></td><td><button class="btn btn-sm btn-primary" data-toggle="modal" data-target="#logsModal" ng-click="vm.getLogs(tickets)"><b>Logs</b></button></td></tr></tbody></table></div></div></div></div><div id="logsModal" class="modal fade" role="dialog"><div class="modal-dialog modal-lg"><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Logs <span class="pull-right">Ticket No - {{vm.ticketsLogs[0].ticketNumber}} &nbsp; &nbsp;</span></h4></div><div class="modal-body table-responsive"><table class="table table-bordered"><thead><tr class="theadRowColor"><th class="text-center">#</th><th class="text-center">Action Type</th><th class="text-center">Action By</th><th class="text-center">Action Date</th><th class="text-center">Remark</th><th class="text-center">Last Assigned</th><th class="text-center">Attachment</th></tr></thead><tbody><tr class="text-center" ng-repeat="ticketLogs in vm.ticketsLogs | orderBy: \'-actionDate\'"><td>{{$index+1}}</td><td>{{ticketLogs.actionType}}</td><td title="{{ticketLogs.actionBy}}" ng-show="ticketLogs.actionByName!=null">{{ticketLogs.actionByName}}</td><td ng-show="ticketLogs.actionByName==null">{{ticketLogs.actionBy}}</td><td>{{ticketLogs.actionDate | date: \'dd-MMM-yyyy h:mm a\'}}</td><td>{{ticketLogs.remark}}</td><td title="{{ticketLogs.lastAssigned}}" ng-show="ticketLogs.lastAssignedName!=null">{{ticketLogs.lastAssignedName}}</td><td ng-show="ticketLogs.lastAssignedName==null">{{ticketLogs.lastAssigned}}</td><td ng-show="ticketLogs.attachment!=null"><button id="download-btn" ng-click="vm.downloadAttachment(ticketLogs.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></td><td ng-show="ticketLogs.attachment==null">--</td></tr></tbody></table></div><div class="modal-footer"><button type="button" class="btn btn-danger" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/hepcTickets/viewTicket/viewTicketDetail.html','<div class="container-fluid"><div class="row"><div class="col-md-8"><div class="card"><div class="card-content"><div class="row"><div class="col-md-6 col-sm-12 pull-left"><h4 class="card-title text-success text-left"><b>Ticket Details</b></h4></div><div class="col-md-2 col-sm-12" ng-show="vm.timeStatus"><label class="text-danger" for="hi" style="padding-top: 24px; font-size: 14px">Time Left :</label></div><div class="col-md-4 col-sm-12 pull-right" ng-show="vm.timeStatus"><span id="hi" class="flip-clock countDown"></span></div></div><hr><div class="row"><div class="col-md-6"><label class="label-floating">Current Status:</label><i ng-show="vm.tickets.status==\'Open\'" class="fa fa-circle text-success"></i> <i ng-show="vm.tickets.status==\'Closed\'" class="fa fa-circle text-danger"></i> <span>{{vm.tickets.status}}</span></div><div class="col-md-6 text-right" ng-show="vm.tickets.assignedMemberName == vm.account.login"><button class="btn btn-sm btn-info" ng-hide="vm.tickets.status==\'Closed\' || vm.tickets.incidentCategory==\'Grievances\' || vm.tickets.incidentCategory==\'HOBPAS\' || vm.tickets.incidentCategory==\'Suggestion/Feedback\' || vm.tickets.level==\'LEVEL_3\' || vm.tickets.level==\'LEVEL_2\' || vm.tickets.level==\'LEVEL_OPERATION_MANAGER\'" data-toggle="modal" data-target="#changeLevel" ng-disabled="!vm.workingStatus"><b>Assign to next level</b></button> <button class="btn btn-sm btn-success" ng-show="vm.tickets.status==\'Open\'" data-toggle="modal" data-target="#setStatus" ng-disabled="!vm.workingStatus"><b>Close</b></button></div><div class="col-md-6 text-right" has-authority="ROLE_TICKET_OPERATION_MANAGER" ng-show="vm.tickets.assignedMemberName != vm.account.login && vm.tickets.level == \'LEVEL_1\' && vm.tickets.status != \'Closed\'"><button class="btn btn-sm btn-info" data-toggle="modal" data-target="#changeLevel" ng-disabled="!vm.workingStatus"><b>Assign to level 2</b></button> <button class="btn btn-sm btn-success" data-toggle="modal" data-target="#setStatus" ng-disabled="!vm.workingStatus"><b>Close</b></button></div></div><br><div class="row"><div class="col-md-6 form-group"><label>Ticket Number</label><span type="text" class="form-control">{{vm.tickets.ticketNumber}}</span></div><div class="col-md-6 form-group"><label>Creation Date</label><span class="form-control">{{vm.tickets.creationDate | date : \'dd-MMM-yyyy h:mm a\'}}</span></div><div class="col-md-6 form-group"><label>Priority</label><span class="form-control">{{vm.tickets.priority}}</span></div><div class="col-md-6 form-group"><label>Incident Category</label><span class="form-control">{{vm.tickets.incidentCategory}}</span></div><div class="col-md-6 form-group"><label>Assigned Member</label><span ng-show="vm.tickets.assignedMemberUserName!=null" class="form-control">{{vm.tickets.assignedMemberUserName}}</span> <span ng-show="vm.tickets.assignedMemberUserName==null" class="form-control">{{vm.tickets.assignedMemberName}}</span></div><div class="col-md-6"><label>Assigned Department</label><div><span class="form-control" ng-hide="vm.tickets.assignedDepartmentName==null">{{vm.tickets.assignedDepartmentName}}</span> <span class="form-control" ng-show="vm.tickets.assignedDepartmentName==null">--</span></div><br></div><!--<div class="col-md-12 form-group">--><!--<label> Latest Remark </label>--><!--<span class="form-control">{{vm.tickets.latestRemark}}</span>--><!--</div>--><div class="col-md-8 form-group label-floating"><label>Subject</label><span class="form-control">{{vm.tickets.subject}}</span></div><div ng-if="vm.service.serviceName" class="col-md-8 form-group label-floating"><label>Service Name</label><textarea type="text" name="servicename" class="form-control" style="height: 70px" readonly="readonly">{{vm.service.serviceName}}</textarea></div><div class="col-md-4" ng-show="vm.tickets.assignedMemberName == vm.account.login"><button style="margin-top: 22px" class="btn btn-sm btn-warning" ng-hide="vm.tickets.status==\'Closed\'" data-toggle="modal" data-target="#commentUpload" ng-disabled="!vm.workingStatus"><b>Comment / Upload</b></button></div><br></div></div></div></div><div class="col-md-4"><div class="card"><div class="card-header card-header-icon" data-background-color="green"><i class="fa fa-address-book-o fa-2x"></i></div><h4 class="card-title text-default"><b>Investor Details</b></h4><div class="card-content"><div class="col-md-12 form-group"><label>Name :</label><span class="form-control">{{vm.complainant.firstName}}&nbsp;{{vm.complainant.lastName}}</span></div><div class="col-md-12 form-group" ng-show="vm.complainant.cafpin!=null"><label>Cafpin</label><span class="form-control">{{vm.complainant.cafpin}}</span></div><div class="col-md-12 form-group"><label>E-Mail</label><span ng-show="vm.complainant.email==null" class="form-control">--</span> <span ng-show="vm.complainant.email!=null" class="form-control">{{vm.complainant.email}}</span></div><div class="col-md-12 form-group" ng-show="vm.complainant.mobileNumber!=null && vm.complainant.cafpin==null"><label>Mobile Number</label><span class="form-control">{{vm.complainant.mobileNumber}}</span></div><!--<div class="col-md-12">--><!--<label class=" control-label label-floating">District</label>--><!--<span class="form-control">{{vm.tickets.district}}</span>--><!--<br>--><!--</div>--></div></div><div class="card" ng-show="vm.tickets.status!=\'Closed\'"><div class="card-header"><h4 class="card-title text-default"><b>Latest Remark</b></h4></div><div class="card-content"><div class="col-md-12 form-group"><textarea type="text" name="comment" class="form-control" ng-model="vm.tickets.latestRemark" style="height: 70px" disabled="disabled"></textarea></div></div></div></div></div><div class="card"><div class="card-header"><h4 class="text-success"><div class="col-md-5"><span class="pull-left"><b>Ticket Description</b></span></div><div class="col-md-4"><span ng-show="vm.tickets.createdByName!=null"><small class="text-center">CreatedBy: {{vm.tickets.createdByName}}</small></span> <span ng-show="vm.tickets.createdByName==null"><small class="text-center">CreatedBy: {{vm.tickets.createdBy}}</small></span></div><div class="col-md-3"><span class="pull-right" ng-show="vm.tickets.attachment != null">Attachment : <button id="download-btn" ng-click="vm.downloadAttachment(vm.tickets.attachment)" type="button" class="btn btn-success btn-sm"><span class="glyphicon glyphicon-download-alt"></span></button></span></div></h4></div><hr><div class="card-content"><div ta-bind ng-model="vm.tickets.description" class="editorTextView" name="description" id="field_description" contenteditable="false"></div></div></div><div class="card" ng-show="vm.tickets.status==\'Closed\'"><div class="card-header"><h4 class="card-title text-default"><b>Closing Remark</b></h4></div><div class="card-content"><div class="col-md-12 form-group"><textarea type="text" name="comment" class="form-control" ng-model="vm.tickets.latestRemark" style="height: 70px" disabled="disabled"></textarea></div></div></div></div><div id="setStatus" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content"><form class="form" name="closeTicket" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Number: <b>{{vm.tickets.ticketNumber}}</b></h4></div><div class="modal-body"><h5 class="text-center" style="border-style: ridge">Please provide the reason for the status update:</h5><div class="form-group"><textarea type="text" name="comment" rows="6" class="form-control" ng-model="vm.latestRemark" maxlength="250" placeholder="Enter Remark" required></textarea></div></div><div class="modal-footer"><button type="button" ng-click="vm.changeStatus()" ng-disabled="closeTicket.$invalid || vm.statusChange" class="btn btn-success">Change Status</button></div></form></div></div></div><div id="changeLevel" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content"><form class="form" name="assignTicket" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Number: <b>{{vm.tickets.ticketNumber}}</b></h4></div><div class="modal-body"><h5 class="text-center" style="border-style: ridge">Please provide the reason:</h5><div class="form-group"><textarea type="text" name="comment" class="form-control" ng-model="vm.latestRemark" maxlength="110" placeholder="Enter Remark" required></textarea></div></div><div class="modal-footer"><button type="button" ng-click="vm.changeLevel()" ng-disabled="assignTicket.$invalid || vm.levelChange" class="btn btn-success">Assign</button></div></form></div></div></div><div id="commentUpload" class="modal fade" role="dialog"><div class="modal-dialog"><div class="modal-content"><form class="form" name="uploadComment" novalidate><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Ticket Number: <b>{{vm.tickets.ticketNumber}}</b></h4></div><div class="modal-body"><h5 class="text-center" style="border-style: ridge">Please provide the comment:</h5><div class="form-group"><textarea type="text" name="ticketComment" class="form-control" ng-model="vm.ticketComment" rows="6" maxlength="250" placeholder="Enter Comment" required></textarea></div><input type="file" class="form-control" file-model="vm.file"><p ng-show="file.maxSizeError"><font color="red">Max file size exceeded (1 MB)</font></p></div><div class="modal-footer"><button type="button" ng-click="vm.uploadFile()" ng-disabled="uploadComment.$invalid || file.maxSizeError" class="btn btn-success">Save</button></div></form></div></div></div>');
$templateCache.put('app/home/Untitled Folder/Goi_Approvals.html','<html lang="en"><br><script src="//code.jquery.com/jquery-1.10.2.js"></script><!--<link rel="import" type="text/html" href="../investhar/header.html"> --><body class="main_first"><div id="header"></div><div class="container"><div class="row"><div class="col-md-12 col-xs-12 col-sm-12 col-lg-12"><table class="table table-bordered goi_table" style="width: 100%; background-color: #EFEFEF"><thead><tr class="goi_tr"><th class="goi_td_main text-center">S.No</th><th class="goi_td_main text-center">Approvals (GoI)</th><th class="goi_td_main text-center">Ministry/Department</th></tr></thead><tbody><tr class="goi_tr spacer"><td class="goi_td_sub text-center">1</td><td class="goi_td_sub text-justify">Permanent Account Number (PAN)</td><td class="goi_td_sub text-center">Central Board of Direct Taxes</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">2</td><td class="goi_td_sub text-justify">Excise Tax Registration</td><td class="goi_td_sub text-center spacer" rowspan="2">Central Board of Excise and Customs</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">3</td><td class="goi_td_sub text-justify">Service Tax Registration</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">4</td><td class="goi_td_sub text-justify">Industrial Entrepreneur Memorandum</td><td class="goi_td_sub text-center spacer" rowspan="2">DIPP, Ministry of Commerce &amp; Industry</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">5</td><td class="goi_td_sub text-justify">Industrial License</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">6</td><td class="goi_td_sub text-justify">Employer Registration</td><td class="goi_td_sub text-center">Employee Provident Fund Organization</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">7</td><td class="goi_td_sub text-justify">Importer Exporter Code</td><td class="goi_td_sub text-center">Directorate General of Foreign Trade</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">8</td><td class="goi_td_sub text-justify">Name Availability of the organization</td><td class="goi_td_sub text-center spacer3" rowspan="4">Ministry of Corporate Affairs</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">9</td><td class="goi_td_sub text-justify">Director Identification Number(DIN)</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">10</td><td class="goi_td_sub text-justify">Certificate of Incorporation</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">11</td><td class="goi_td_sub text-justify">Certificate for Commencement of Business</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">12</td><td class="goi_td_sub text-justify">Foreign collaboration - General Permission Rule (Reporting of Forex Transaction)</td><td class="goi_td_sub text-center spacer" rowspan="2">Reserve Bank of India</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">13</td><td class="goi_td_sub text-justify">Advance Foreign Remittance</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">14</td><td class="goi_td_sub text-justify">ESIC Filing</td><td class="goi_td_sub text-center">Employee State Insurance Corporation</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">15</td><td class="goi_td_sub text-justify">Annual return by the companies (under section 92 of Company\'s Act 1956)</td><td class="goi_td_sub text-center">Ministry of Corporate Affairs</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">16</td><td class="goi_td_sub text-justify">Environmental Clearance</td><td class="goi_td_sub text-center">Ministry of Environment, Forest and Climate Change</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">17</td><td class="goi_td_sub text-justify">Issue of Explosive license</td><td class="goi_td_sub text-center">The Petroleum and Explosives Safety Organization</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">18</td><td class="goi_td_sub text-justify">Custom Duty Concession Certificate</td><td class="goi_td_sub text-center">Central Board of Excise and Customs</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">19</td><td class="goi_td_sub text-justify">Approval of pressure parts materials for Boilers made outside the country under Regulation 393 (b) of the Indian Boiler Regulations, 1950.</td><td class="goi_td_sub text-center spacer5">DIPP, Ministry of Commerce &amp; Industry</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">20</td><td class="goi_td_sub text-justify">Miscellaneous approvals/clarifications under the Boilers Act, 1923/ Indian Boiler Regulations, 1950</td><td class="goi_td_sub text-center spacer6">DIPP, Ministry of Commerce &amp; Industry</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">21</td><td class="goi_td_sub text-justify">Essentiality Certificate for projects in Consumer Industry</td><td class="goi_td_sub text-center">DIPP, Ministry of Commerce &amp; Industry</td></tr><tr class="goi_tr"><td class="goi_td_sub text-center">22</td><td class="goi_td_sub text-justify">Essentiality Certificate for projects in Light Engineering Industry</td><td class="goi_td_sub text-center">DIPP, Ministry of Commerce &amp; Industry</td></tr></tbody></table></div></div></div><div id="footer"></div></body><script>$(function(){\n  $("#header").load("header.html");\n  $("#footer").load("footer.html");\n});</script></html>');
$templateCache.put('app/home/Untitled Folder/about_haryana.html','<html lang="en"><br><div class="container"><script src="//code.jquery.com/jquery-1.10.2.js"></script><!--<link rel="import" type="text/html" href="../investhar/header.html"> --><body class="main_first"><div id="header"></div><!--cm messeges,fact about haryana,districs,vision column start--><div class="container"><div class="row all_colms text-center"><div class="col-md-12 col-sm-12 col-xs-12 col-lg-12"><a href="#" class="about_1"><span>CM\'s Message</span></a><span class="about_2"> |</span> <a href="#" class="about_1"><span>Facts about Haryana</span></a><span class="about_2"> |</span> <a href="#" class="about_1"><span>Districts</span></a><span class="about_2"> |</span> <a href="#" class="about_1"><span>Vision</span></a></div></div></div><!--cm messeges,fact about haryana,districs,vision column end--><!-- cm messeges start   --><div class="container"><div class="row cm_msgs"><div class="col-md-3 col-lg-3 col-xs-12 col-sm-12"><!--<img class="img-responsive cm_pic" src="content/images/cm_khattar.jpg" />--></div><div class="col-md-9 col-lg-9 col-xs-12 col-sm-12"><span class="msgs text-left" id="msgs1">Haryana is a leading state in the country on both the industrial and agricultural front. It possesses a locational advantage of being the focal point of the entire northern region of the country and thus, plays a significant role in the socio-economic growth of the entire belt.</span><br><span class="msgs text-left" id="msgs2">I am hopeful that a whole generation of PRANETAs would come up through our scheme for Professional and New Entrepreneur\'s Task Assistance and lead to the long overdue VISTAAR of enterprises across the sacred land of Gita. Come, invest in Haryana. We aim to kick start Haryana\'s economy by achieving 8% GDP growth, generate more than 4 lakhs jobs and attract investments of one lakh crore.</span><br><span class="msgs text-left" id="msgs3">The state has invested in the development of world class infrastructure facilities such as special economic zones (SEZs), Kundli-Manesar-Palwal (KMP) global corridor and Delhi- Mumbai Industrial Corridor (DMIC). In addition, the state will play a crucial role in the development of the proposed Amritsar-Kolkata Industrial Corridor as well.<br><span class="msgs text-left" id="msgs4">The Happening Haryana Global Investor Summit 2016 is an initiative towards our resolve.</span><br><sapn class="msgs text-left" id="msgs5">I, welcome you to the historical land of Haryana.</sapn></span><br><div class="msgs text-right" id="msgs6">Shri Manohar Lal,<br>Chief Minister, Haryana</div></div></div></div><!-- cm messeges end   --><div class="container"><div class="row text-center fact_main"><span class="fact_main1">FACT ABOUT HARYANA</span></div></div><!-- fact haryana start --><div class="container"><div class="row fact_har"><div class="col-md-12 col-xs-12 col-sm-12 col-lg-12"><table class="table table-bordered"><thead><tr><th class="aboutbg_color">ITEM</th><th class="aboutbg_color">PERIOD/ YEAR</th><th class="aboutbg_color">UNIT</th><th class="aboutbg_color">STATUS HARYANA</th><th class="aboutbg_color">STATUS INDIA</th></tr></thead><tbody><tr class="aboutbg_color2"><td class="aboutbg_color2">GEOGRAPHICAL AREA</td><td class="aboutbg_color2"></td><td class="aboutbg_color2">Sq. Km.</td><td class="aboutbg_color2">44,212</td><td class="aboutbg_color2">32,87,469</td></tr><tr class="aboutbg_color"><td class="aboutbg_color">ADMINISTRATIVE SET UP</td><td class="aboutbg_color">February, 2017</td><td class="aboutbg_color"></td><td class="aboutbg_color"></td><td class="aboutbg_color"></td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">Divisions</td><td class="aboutbg_color2"></td><td class="aboutbg_color2"></td><td class="aboutbg_color2">6</td><td class="aboutbg_color2"></td></tr><tr class="aboutbg_color"><td class="aboutbg_color">Districts</td><td class="aboutbg_color"></td><td class="aboutbg_color"></td><td class="aboutbg_color">22</td><td class="aboutbg_color"></td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">Sub-Divisions</td><td class="aboutbg_color2"></td><td class="aboutbg_color2"></td><td class="aboutbg_color2">71</td><td class="aboutbg_color2"></td></tr><tr class="aboutbg_color"><td class="aboutbg_color">Tehsils</td><td class="aboutbg_color"></td><td class="aboutbg_color"></td><td class="aboutbg_color">93</td><td class="aboutbg_color"></td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">Sub-Tehsils</td><td class="aboutbg_color2"></td><td class="aboutbg_color2"></td><td class="aboutbg_color2">49</td><td class="aboutbg_color2"></td></tr><tr class="aboutbg_color"><td class="aboutbg_color">Blocks</td><td class="aboutbg_color"></td><td class="aboutbg_color"></td><td class="aboutbg_color">140</td><td class="aboutbg_color">6,374</td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">Towns</td><td class="aboutbg_color2">Population Census 2011</td><td class="aboutbg_color2"></td><td class="aboutbg_color2">154</td><td class="aboutbg_color2">5,161</td></tr><tr class="aboutbg_color"><td class="aboutbg_color">STATE INCOME (At Current Prices)</td><td class="aboutbg_color">2015-16 (Quick Estimates)</td><td class="aboutbg_color">Rupees Crore</td><td class="aboutbg_color"></td><td class="aboutbg_color"></td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">(a) Gross State Domestic Product (GSDP)</td><td class="aboutbg_color2"></td><td class="aboutbg_color2"></td><td class="aboutbg_color2">4,85,184</td><td class="aboutbg_color2">1,36,75,331</td></tr><tr class="aboutbg_color"><td class="aboutbg_color">(b) Gross State Value Added (GSVA)</td><td class="aboutbg_color"></td><td class="aboutbg_color"></td><td class="aboutbg_color">4,38,095</td><td class="aboutbg_color">1,24,51,938</td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">(c) Agriculture and Allied Sector GSVA</td><td class="aboutbg_color2"></td><td class="aboutbg_color2"></td><td class="aboutbg_color2">83,967</td><td class="aboutbg_color2">21,72,910</td></tr><tr class="aboutbg_color"><td class="aboutbg_color">(d) Industry Sector GSVA</td><td class="aboutbg_color"></td><td class="aboutbg_color"></td><td class="aboutbg_color">1,39,025</td><td class="aboutbg_color">36,83,358</td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">(e) Services Sector GSVA</td><td class="aboutbg_color2"></td><td class="aboutbg_color2"></td><td class="aboutbg_color2">2,15,103</td><td class="aboutbg_color2">65,95,670</td></tr><tr class="aboutbg_color"><td class="aboutbg_color">(f) Per Capita Income</td><td class="aboutbg_color"></td><td class="aboutbg_color">Rupees</td><td class="aboutbg_color">1,62,034</td><td class="aboutbg_color">94,178</td></tr></tbody></table></div></div></div><div class="row"></div><div class="container"><div class="row fact_scnd"><div class="col-md-12 col-xs-12 col-sm-12 col-lg-12"><table class="table table-bordered"><tbody><tr><th class="aboutbg_color2">Capital City</th><td class="aboutbg_color2">Chandigarh</td></tr><tr><th class="aboutbg_color">Largest City</th><td class="aboutbg_color">Faridabad</td></tr><tr><th class="aboutbg_color2">Key Industries</th><td class="aboutbg_color2">Automotive, agro-based industry, IT and ITeS, textiles, oil refining, biotechnology and petrochemicals</td></tr></tbody></table></div></div></div><!-- fact haryana end --><!-- distric div start --><div class="container"><div class="row text-left fact_main"><div class="col-md-12 col-xs-12 col-sm-12 col-lg-12"><span class="fact_main1">DISTRICTS</span></div></div></div><div class="container"><div class="row har_map"><div class="col-md-12 col-xs-12 col-sm-12 col-lg-12"><div class="col-lg-12 col-sm-12 col-xs-12 col-md-offset-4"><img class="img-tesponsive" src="content/images/haryanamap.png"></div></div></div></div><!-- distric div end --><!-- vision start --><div class="container"><div class="row text-left fact_main"><div class="col-md-12 col-xs-12 col-sm-12 col-lg-12"><span class="fact_main1">VISION:</span></div></div></div><div class="container"><div class="row text-justify vision_txt"><div class="col-md-12 col-lg-12 col-xs-12 col-sm-12"><p class="vision_text">To position Haryana as a pre-eminent investment destination and facilitate balanced regional and sustainable development supported by a dynamic governance system, wide scale adoption of innovation & technology, and skill development for nurturing entrepreneurship and generating employment opportunities.</p><br><ul class="vision_text"><li>Reposition Haryana as a \'Preferred Destination\' then Ease of Doing business and Cost of Doing Business</li><li>Facilitate State GDP growth rate in excess of 8%</li><li>Generate more than 4 lakh jobs</li><li>Attract investments over INR 1 lakh crore</li><li>Increase contribution of secondary sector in the State GDP from 27% to 32% in tandem with the Government of India\'s National Manufacturing Policy and make in India initiative</li><li>Promote balanced regional development through geographical dispersal of Industry</li><li>Increasing the competitiveness of MSMEs through cluster development adoption of Zero Defect Zero Effect manufacturing practices</li></ul></div></div></div><!-- vision end --><div id="footer"></div></body><!--<script>--><!--$(function(){--><!--$("#header").load("header.html");--><!--$("#footer").load("footer.html");--><!--});--><!--</script>--></div></html>');
$templateCache.put('app/home/Untitled Folder/departments.html','<html lang="en"><script src="//code.jquery.com/jquery-1.10.2.js"></script><!--<link rel="import" type="text/html" href="../investhar/header.html"> --><body class="main_first"><div id="header"></div><div class="container"><div class="row fact_har"><div class="col-md-12 col-xs-12 col-sm-12 col-lg-12"><table class="table table-bordered"><thead><tr><th class="aboutbg_color">Sr. No</th><th class="aboutbg_color">Department</th></tr></thead><tbody><tr class="aboutbg_color2"><td class="aboutbg_color2">1.</td><td class="aboutbg_color2">Uttar/Dakshin Haryana Bijli Vitran Nigam</td></tr><tr class="aboutbg_color"><td class="aboutbg_color">2.</td><td class="aboutbg_color">Town and Country Planning</td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">3.</td><td class="aboutbg_color2">Environment Department/Haryana State Pollution Control Board</td></tr><tr class="aboutbg_color"><td class="aboutbg_color">4.</td><td class="aboutbg_color">Labour Department/Chief inspector of Factories</td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">5.</td><td class="aboutbg_color2">Industries and Commerce Department</td></tr><tr class="aboutbg_color"><td class="aboutbg_color">6.</td><td class="aboutbg_color">Directorate of Health Services</td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">7.</td><td class="aboutbg_color2">Excise and Taxation</td></tr><tr class="aboutbg_color"><td class="aboutbg_color">8.</td><td class="aboutbg_color">Haryana State Industrial Development Corporation Ltd</td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">9.</td><td class="aboutbg_color2">Haryana Urban Local Bodies Department</td></tr><tr class="aboutbg_color"><td class="aboutbg_color">10.</td><td class="aboutbg_color">Revenue Department</td></tr><tr class="aboutbg_color2"><td class="aboutbg_color2">11.</td><td class="aboutbg_color2">Non-Conventional Energy/Renewal Energy Department</td></tr><tr class="aboutbg_color"><td class="aboutbg_color">12.</td><td class="aboutbg_color">Food and Supply Department</td></tr></tbody></table></div></div></div><div id="footer"></div></body><script>$(function(){\n  $("#header").load("header.html"); \n  $("#footer").load("footer.html"); \n});</script></html>');
$templateCache.put('app/home/Untitled Folder/home2.html','<div class="container"><html lang="en"><!--<script src="//code.jquery.com/jquery-1.10.2.js"></script>--><!--<link rel="import" type="text/html" href="../investhar/header.html"> --><body class="main_first"><div id="header"></div><div class="container"><!--<div class="row main_upper margin-bottom-5">--><!--<div class="col-sm-12 col-xs-12 col-md-3 col-lg-3 upper_slide1 text-center">--><!--<a href="#" class="nounderline">--><!--&lt;!&ndash; <img src="../investhar/images/icon_home1.png" style="padding-left: 10px; padding-right: 10px;--><!--height: 50px;">--><!--<span class="col-12 cont_li"> &ndash;&gt;--><!--<span id="Label2">Why Invest In Haryana</span>--><!--</a>--><!--</div>--><!--<div class="col-sm-12 col-xs-12 col-md-3 col-lg-3 upper_slide2 text-center">--><!--<a href="#" class="nounderline">--><!--<span id="Label16">Apply For Approvals</span>--><!--</a>--><!--</div>--><!--<div class="col-sm-12 col-xs-12 col-md-3 col-lg-3 upper_slide3 text-center">--><!--<a  href="#" target="_blank" class="nounderline" >--><!--<div style="width: 100%;">--><!--<span class="col-12 cont_li" >--><!--<span id="Label17">Grievance Redressal</span></span>--><!--</div>--><!--</a>--><!--</div>--><!--<div class="col-sm-12 col-xs-12 col-md-3 col-lg-3 upper_slide4 text-center">--><!--<a href="#" class="nounderline">--><!--<div style="width: 100%;">--><!--<span class="col-12 cont_li" >--><!--<span id="Label18">Investor Services</span></span>--><!--</div>--><!--</a>--><!--</div>--><!--</div>--></div><div class="container"><div class="row"><div class="col-md-12"><div id="myCarousel" class="carousel slide" data-ride="carousel"><!-- Indicators --><ol class="carousel-indicators"><li data-target="#myCarousel" data-slide-to="0" class="active"></li><li data-target="#myCarousel" data-slide-to="1"></li><li data-target="#myCarousel" data-slide-to="2"></li></ol><!-- Wrapper for slides --><div class="carousel-inner"><div class="item active"><img src="content/images/ban_img1.png" class="img-responsive" alt="Los Angeles" style="width:100%"></div><div class="item"><img src="content/images/ban_img2.png" class="img-responsive" alt="Chicago" style="width:100%"></div><div class="item"><img src="content/images/ban_img3.png" class="img-responsive" alt="New york" style="width:100%"></div></div><!-- Left and right controls --> <a class="left carousel-control" href="#myCarousel" data-slide="prev"><span class="glyphicon glyphicon-chevron-left"></span> <span class="sr-only">Previous</span> </a><a class="right carousel-control" href="#myCarousel" data-slide="next"><span class="glyphicon glyphicon-chevron-right"></span> <span class="sr-only">Next</span></a></div></div><!--<div class="col-md-3">\n           <ul class="nav navbar-nav" style="margin-top: 0px  !important;">\n                                       <li class="dropdown slidemenu side_li" style="background-color: #F29200; " id="whyhar"><a href="#" class="dropdown-toggle" data-toggle="dropdown">\n                                               <div style="width: 100%;">\n\n\n                                                          <!-- <img src="../investhar/images/icon_home1.png" style="padding-left: 10px; padding-right: 10px;\n                                                               height: 50px;">\n\n                                                           <span class="col-12 cont_li">\n                                                               <span id="Label2">Why Invest In Haryana</span></span>\n\n\n                                               </div>\n                                           </a></li>\n                                       <li class="dropdown slidemenu side_li" style="background-color: #fab500;"><a href="#" class="dropdown-toggle" data-toggle="dropdown">\n                                               <div class="col-12">\n\n                                                           <div id="divEntrepreneurLogin">\n                                                               <span class="col-12 cont_li" >\n                                                                   <span id="Label16">Apply for Approvals</span>\n                                                               </span>\n                                                           </div>\n\n                                                   </div>\n                                           </a></li>\n                                       <li class="dropdown slidemenu side_li" style="background-color: #fed468; "><a href="http://www.ap.meeseva.gov.in/CIMS/UserInterface/LoginForm.aspx" target="_blank" class="dropdown-toggle" data-toggle="dropdown" onclick="window.open(\'http://www.ap.meeseva.gov.in/CIMS/UserInterface/LoginForm.aspx\');">\n                                               <div style="width: 100%;">\n\n                                                           <span class="col-12 cont_li" >\n                                                               <span id="Label17">GOI APPROVALS -<br>FACILITATION DESK</span></span>\n                                                       </div>\n                                           </a></li>\n                                       <li class="dropdown slidemenu side_li" style="background-color: #f7b401;"><a href="#" class="dropdown-toggle" data-toggle="dropdown">\n                                               <div style="width: 100%;">\n\n                                                           <span class="col-12 cont_li" >\n                                                               <span id="Label18">Grievance Redressal</span></span>\n                                                      </div>\n                                           </a>\n\n                                       </li>\n\n\n                                   </ul>\n           </div> --></div></div><!---------div for second slider ------------------><!-- <div class="container">\n\n       <div class="row">\n        <div class="col-md-12">\n          <div class="carousel carousel-showmanymoveone slide" id="carousel123">\n            <div class="carousel-inner">\n              <div class="item rohit active">\n                <div class="col-xs-12 col-sm-6 col-md-3"><a href="#"><img src="../investhar/images/automobile_bg.jpg" class="img-responsive"></a></div>\n              </div>\n              <div class="item rohit">\n                <div class="col-xs-12 col-sm-6 col-md-3"><a href="#"><img src="../investhar/images/life_sciences_bg.jpg" class="img-responsive"></a></div>\n              </div>\n              <div class="item rohit">\n                <div class="col-xs-12 col-sm-6 col-md-3"><a href="#"><img src="../investhar/images/electonics_bg.jpg" class="img-responsive"></a></div>\n              </div>\n              <div class="item rohit">\n                <div class="col-xs-12 col-sm-6 col-md-3"><a href="#"><img src="../investhar/images/Energy_bg.jpg" class="img-responsive"></a></div>\n              </div>\n              <div class="item rohit">\n                <div class="col-xs-12 col-sm-6 col-md-3"><a href="#"><img src="../investhar/images/food_processing.jpg" class="img-responsive"></a></div>\n              </div>\n              <div class="item rohit">\n                <div class="col-xs-12 col-sm-6 col-md-3"><a href="#"><img src="../investhar/images/life_sciences_bg.jpg" class="img-responsive"></a></div>\n              </div>\n              <div class="item rohit">\n                <div class="col-xs-12 col-sm-6 col-md-3"><a href="#"><img src="../investhar/images/PETROLEUM_bg.jpg" class="img-responsive"></a></div>\n              </div>\n              <div class="item rohit">\n                <div class="col-xs-12 col-sm-6 col-md-3"><a href="#"><img src="../investhar/images/Textiles_bg.jpg" class="img-responsive"></a></div>\n              </div>\n            </div>\n            <a class="left carousel-control" href="#carousel123" data-slide="prev"><i class="glyphicon glyphicon-chevron-left"></i></a>\n            <a class="right carousel-control" href="#carousel123" data-slide="next"><i class="glyphicon glyphicon-chevron-right"></i></a>\n          </div>\n        </div>\n      </div>\n\n    </div> --><!--- div end second slider --><!--<div class="container">--><!--<div class="row after_slider">--><!--<div class="col-md-3 col-sm-3 col-xs-6 img_first">--><!--<a href="#"><img src="content/images/newsandgallery.png" class="img-responsive"></a></div>--><!--<div class="col-md-3 col-sm-3 col-xs-6 img_second">--><!--<a href="#"><img src="content/images/Social_Reforms.png" class="img-responsive"></a></div>--><!--<div class="col-md-3 col-sm-3 col-xs-6 img_third">--><!--<a href="#"><img src="content/images/focus_sectors.png" class="img-responsive"></a></div>--><!--<div class="col-md-3 col-sm-3 col-xs-6 img_fourth">--><!--<a href="#"><img src="content/images/dashboard.png" class="img-responsive"></a></div>--><!--</div>--><!--</div>--><div id="footer"></div><!-- script for second slider ---><!--<script>\n    (function(){\n      // setup your carousels as you normally would using JS\n      // or via data attributes according to the documentation\n      // http://getbootstrap.com/javascript/#carousel\n      $(\'#carousel123\').carousel({ interval: 2000 });\n    }());\n\n    (function(){\n      $(\'.carousel-showmanymoveone .rohit\').each(function(){\n        var itemToClone = $(this);\n\n        for (var i=1;i<4;i++) {\n          itemToClone = itemToClone.next();\n\n          // wrap around if at end of item collection\n          if (!itemToClone.length) {\n            itemToClone = $(this).siblings(\':first\');\n          }\n\n          // grab item, clone, add marker class, add to collection\n          itemToClone.children(\':first-child\').clone()\n            .addClass("cloneditem-"+(i))\n            .appendTo($(this));\n        }\n      });\n    }());\n\n\n    </script> --><!--- script end second slider --></body><!--<script>--><!--$(function(){--><!--$("#header").load("header.html");--><!--$("#footer").load("footer.html");--><!--});--><!--</script>--></html><div class="container"><div class="row footer_menu"><div class="row after_first_menu top-buffer"><div class="col-xs-12 col-sm-7"><span id="Label108">Copyright \xA9 2017 Department of Industries, Government of Haryana, All Rights Reserved</span></div><div class="col-xs-12 col-sm-5" style="text-align: right"><a href="mailto:md@hsiidc.org.in">md@hsiidc.org.in</a></div><div class="col-xs-12 col-sm-12 text-left"><span><span id="Label59">Content of this website is published and managed by Department of Industries &amp; Commerce, Government of Haryana. For any query regarding this website, Contact the</span> <a href="#" id="A9"><span id="Label36">Web Information Manager</span></a></span></div></div><div class="row for_dotted"></div><div class="row"><div class="col-xs-12 col-sm-4"><h4 style="font-family: Lato !important"><!--<p>--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/Disclaimer.aspx" class="ftrmenu" style="font-size: 16px;">--><!--<span id="Label111">Disclaimer</span></a>--><!--</p>--><!--<p>--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/Policies.aspx?type=PrivacyPolicy" class="ftrmenu" style="font-size: 16px;">--><!--<span id="Label112">Privacy policy</span>--><!--</a>--><!--</p>--><!--<p>--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/Policies.aspx?type=HyperlinkingPolicy" class="ftrmenu" style="font-size: 16px;">--><!--<span id="Label300">Hyperlinking policy</span>--><!--</a>--><!--</p>--><!--<p>--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/Policies.aspx?type=copyrightstatement" class="ftrmenu" style="font-size: 16px;">--><!--<span id="Label113">Copyright statement</span></a>--><!--</p>--><!--<p>--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/Policies.aspx?type=Termsofuse" class="ftrmenu" style="font-size: 16px;">--><!--<span id="Label153">Terms of Use</span></a>--><!--</p>--><!--<p>--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/Sitemap.aspx" class="ftrmenu" style="font-size: 16px;">--><!--<span id="Label114">Sitemap</span>--><!--</a>--><!--</p>--></h4></div><div class="col-xs-12 col-sm-4"><!--<h4 style="font-family: Lato !important; text-align: left;">--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/CitizenCorner.aspx" class="ftrmenu" style="font-size: 16px;">--><!--<span id="Label115" style="font-weight:normal;">Citizen Corner</span></a></h4>--><!--<h4 style="font-family: Lato !important; text-align: left;">--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/CitizenCorner.aspx#viewfeedback" id="lnkfeedback" class="ftrmenu" style="font-size: 16px;">--><!--<span id="Label154" style="font-weight:normal;">Feedback</span></a></h4>--><!--<h4 style="font-family: Lato !important; text-align: left;">--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/Policies.aspx?type=contentreviewpolicy" class="ftrmenu" id="A5" style="font-size: 16px;">--><!--<span id="Label155" style="font-weight:normal;">Content Review Policy</span></a></h4>--><!--<h4 style="font-family: Lato !important; text-align: left;">--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/Policies.aspx?type=contentapprovalpolicy" class="ftrmenu" id="A6" style="font-size: 16px;">--><!--<span id="Label156" style="font-weight:normal;">Content Approval</span></a></h4>--><!--<h4 style="font-family: Lato !important; text-align: left;">--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/Policies.aspx?type=contentarchivalpolicy" class="ftrmenu" id="A7" style="font-size: 16px;">--><!--<span id="Label158" style="font-weight:normal;">Content Archival</span></a></h4>--><!--<h4 style="font-family: Lato !important; text-align: left;">--><!--<a href="UserInterface/SingleWindowServicesApplication/Public/FAQ.aspx" class="ftrmenu" id="A8" style="font-size: 16px;">--><!--<span id="Label159" style="font-weight:normal;">FAQ\'s</span></a></h4>--><p><a href="#">&nbsp;</a></p></div><div class="col-xs-12 col-sm-4"><a href="https://india.gov.in/" target="_blank"><img src="content/images/india_logo.png" class="img-responsive india_logo"></a><p></p><div><!--<span id="Label117">Visitors Count:</span>--><!--<img src=\'http://www.hit-counts.com/counter.php?t=MTQxMTkyMQ==\' border=\'0\' alt=\'Visitor Counter\'>--></div><!--<div>--><!--<span id="Label118"><b>Last updated on : </b> </span>--><!--9-June-2017--><!--<br>--><!--<span id="Label119"><b>Site best viewed in</b> Google Chrome, IE9 &amp; IE 10</span>--><!--<br>--><!--<span id="Label152">Developed &amp; Maintained by</span>--><!--<a href="http://rmsquare.in" target="_blank">--><!--&lt;!&ndash;<span id="Label125">RMSQUARE TECHNOLOGIES PVT. LTD.</span></a>&ndash;&gt;--><!--<p></p>--><!--</a>--><!--</div>--></div></div></div></div></div>');
$templateCache.put('app/home/Untitled Folder/incentives.html','<html lang="en"><script src="//code.jquery.com/jquery-1.10.2.js"></script><!--<link rel="import" type="text/html" href="../investhar/header.html"> --><body class="main_first"><div id="header"></div><div class="container"><div class="row"><div class="col-md-12 col-lg-12 col-xs-12 col-sm-12"><div class="medium-3 large-3 columns LeftBoxPad"><div class="firstMenubox"><div class="blackBox"><a href="#" class="head_white">Welcome : Guest</a></div><nav class="top-bar leftNavBar2 topNavBar" data-topbar=""><nav data-topbar="" class="top-bar leftNavBar2 topNavBar"></nav><section class="top-bar-section left-bar-section2"><!-- Right Nav Section --><ul class="left topLink"><li><a class="check_list" target="_blank" href="app/home/pdf/AllServicesBoilers.pdf">Checklist and procedure for Registration of Boiler</a></li><li><a class="check_list" target="_blank" href="app/home/pdf/checklist%20for%20incentive.pdf">Checklist and procedure for Incentive Schemes</a></li><li><a class="check_list" target="_blank" href="app/home/pdf/Firms_services_manual1.pdf">Checklist and procedure for Registration of Firms</a></li><li><a class="check_list" target="_blank" href="app/home/pdf/societies_services_manual1.pdf">Checklist and procedure for Registration of Societies</a></li><!--<li><a class="check_list" href="#" role="button">Mandatory Annual Returns Filing Under Societies Act,  2012</a></li>--><!--<li><a class="check_list" href="#" > Benefits of Filing of Udyog Aadhar Memorandum (UAM)</a></li>--><!--li><a target="_blank" href="/msme/Industry_User_Manual_84597.pdf">User Manual</a></li>\n\t\t\t\t\t\t\t<li><a target="_blank" href="/help-desk">Help Desk</a></li--><!--<li><a class="check_list" href="#">Login</a></li>--></ul></section></nav></div></div></div></div></div><div id="footer"></div></body><!--<script>--><!--$(function(){--><!--$("#header").load("header.html");--><!--$("#footer").load("footer.html");--><!--});--><!--</script>--></html>');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak><div class="row"><div class="col-md-4"><span class="hipster img-responsive img-rounded"></span></div><div class="col-md-8"><h1 data-translate="error.title">Error Page!</h1><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div>');
$templateCache.put('app/layouts/footer/footer.html','<footer class="page_footer ds section_padding_top_40 section_padding_bottom_40 columns_padding_30 columns_margin_bottom_40"><div class="container"><div class="row"><div class="col-xs-12 col-lg-4 text-center text-sm-left"><div class="widget widget_about"><!--<div class="logo bottommargin_5"> <img src="../../../content/used-images-new/logo-dark.jpg" alt=""> </div>--><p data-translate="global.menu.We at HEPC are inspired by a goal to make Haryana the most investor friendly destination in India.">We at HEPC are inspired by a goal to make Haryana the most investor friendly destination in India.</p><iframe width="350" height="220" src="https://www.youtube.com/embed/361gPm3xH7Y" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><div class="page_social topmargin_25"><a href="https://www.facebook.com/investharyana/" class="social-icon bg-icon rounded-icon socicon-facebook"></a> <a href="https://twitter.com/investharyana" class="social-icon bg-icon rounded-icon socicon-twitter"></a> <a href="https://www.linkedin.com/company/investharyana/" class="social-icon bg-icon rounded-icon socicon-linkedin"></a></div></div></div><div class="col-xs-12 col-lg-4 text-sm-left"><div class="widget widget_nav_menu highlghtlinks"><h3 class="widget-title" data-translate="global.menu.Useful Links">Useful Links</h3><a href="http://haryana.gov.in" target="_blank" data-translate="global.menu.Haryana State Portal">Haryana State Portal</a><br><br><a href="http://www.hvpn.org.in" target="_blank" data-translate="global.menu.Solar power projects: Guidelines">Solar power projects: Guidelines</a><br><br><a data-toggle="modal" ng-click="vm.usefullLink = \'sdw\'" data-target="#usefullModal" data-translate="global.menu.State Departmental Websites">State Departmental Websites</a><br><br><a data-toggle="modal" ng-click="vm.usefullLink = \'ia\'" data-target="#usefullModal" data-translate="global.menu.Industry Associations">Industry Associations</a></div></div><div class="col-xs-12 col-lg-4 text-center text-sm-left"><div class="widget widget_text"><h3 class="widget-title" data-translate="global.menu.Office Address">Office Address</h3><p class="bottommargin_15"><span data-translate="global.menu.Haryana Enterprises Promotion Centre">Haryana Enterprises Promotion Centre</span><br><span data-translate="global.menu.Bay No. 63-66, Level-II, Sector 2, Panchkula 134112">Bay No. 63-66, Level-II, Sector 2, Panchkula 134112</span><br><span data-translate="global.menu.Email:">Email:</span> <a href="mailto:#">hepc[dot]helpdesk[at]gmail[dot]com</a><br><br><span data-translate="global.menu.Toll Free:">Toll Free:</span> 1800-180-2132<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p><p><span data-translate="global.menu.Timings:">Timings:</span><br><span data-translate="global.menu.Mon - Fri: 09:00 AM - 05:00 PM">Mon - Fri: 09:00 AM - 05:00 PM</span><br><span data-translate="global.menu.Sat & Sun: Closed">Sat & Sun: Closed</span></p></div></div><!--<div class="col-xs-12 col-sm-4 col-lg-4 text-center text-sm-left">--><!--<div class="widget widget_nav_menu highlghtlinks">--><!--<h3 class="widget-title">Quick Contact</h3>--><!--<div class="toppadding_20"></div>--><!--<form class="contact-form" method="post" action="#">--><!--<p class="form-group"> <label for="footer-name">Full Name <span class="required">*</span></label> <i class="fa fa-user highlight"></i> <input type="text" aria-required="true" size="30" value="" name="name" id="footer-name" class="form-control with_icon" placeholder="Name">\t\t\t\t\t\t\t\t\t\t</p>--><!--<p class="form-group"> <label for="footer-email">Email address<span class="required">*</span></label> <i class="fa fa-envelope highlight"></i> <input type="email" aria-required="true" size="30" value="" name="email" id="footer-email" class="form-control with_icon"--><!--placeholder="Email Address"> </p>--><!--<p class="form-group"> <label for="footer-message">Message</label> <i class="fa fa-pencil highlight"></i> <textarea aria-required="true" rows="3" cols="45" name="message" id="footer-message" class="form-control with_icon" placeholder="Message"></textarea> </p>--><!--<p class="contact-form-submit topmargin_40">--><!--<button type="submit" id="footer_contact_form_submit" name="contact_submit" class="theme_button min_width_button">Send message</button> </p>--><!--</form>--><!--</div>--><!--</div>--></div></div></footer><section class="page_copyright ds section_padding_top_15 section_padding_bottom_15"><div class="container"><div class="row"><div class="col-xs-12"><p data-translate="global.menu.\xA9 2019 Haryana Enterprises Promotion Centre. All Rights Reserved. Designed by The Co-ordinators">&copy; 2019 Haryana Enterprises Promotion Centre. All Rights Reserved. Designed by <a href="http://www.theco-ordinators.com" target="_blank">The Co-ordinators</a></p></div></div></div></section><div class="side-container"><div class="side-inner ls with_padding_new"><div class="container"><div class="row"><div class="col-12 col-sm-12 text-center"><i class="fa fa-envelope highlight2 rightpadding_5" aria-hidden="true"></i> <a href="mailto:hepc.helpdesk@gmail.com">hepc[dot]helpdesk[at]gmail[dot]com</a><br><i class="fa fa-phone highlight2 rightpadding_5" aria-hidden="true"></i> <span class="big">1800-180-2132</span> <i class="fa fa-globe highlight2 rightpadding_5" aria-hidden="true"></i> <a href="https://www.investharyana.in">https://www.investharyana.in</a><br><div class="page_social toppadding_5"><a href="https://www.facebook.com/investharyana/" class="social-icon bg-icon rounded-icon socicon-facebook"></a> <a href="https://twitter.com/investharyana" class="social-icon bg-icon rounded-icon socicon-twitter"></a> <a href="https://www.linkedin.com/company/investharyana/" class="social-icon bg-icon rounded-icon socicon-linkedin"></a></div></div></div><div class="row"><div class="col-6 col-xs-6 text-center gradient_bg_color1"><a href="http://cisharyana.in/" target="_blank"><div class="teaser_icon round size_small"><i class="fa fa-user fontsize_18"></i></div><p class="small">Central Inspection System</p></a></div><div class="col-6 col-xs-6 text-center gradient_bg_color1"><a ui-sref="servicedashboardyearly"><div class="teaser_icon round size_small"><i class="fa fa-money fontsize_18"></i></div><p class="small">Service Dashboard</p></a></div></div><div class="row"><div class="col-6 col-xs-6 text-center gradient_bg_color1"><a ui-sref="Questionnaire"><div class="teaser_icon round size_small"><i class="fa fa-location-arrow fontsize_18"></i></div><p class="small">Know Your Approvals</p></a></div><div class="col-6 col-xs-6 text-center gradient_bg_color1"><a ui-sref="newincentiveswizard"><div class="teaser_icon round size_small"><i class="fa fa-check-circle fontsize_18"></i></div><p class="small">Know Your Incentives</p></a></div></div><div class="row"><div class="col-6 col-xs-6 text-center gradient_bg_color1"><a href="http://125.99.73.119:8001/bpamsclient/" target="_blank"><div class="teaser_icon round size_small"><i class="fa fa-location-arrow fontsize_18"></i></div><p class="small">Building Plan Status</p></a></div><div class="col-6 col-xs-6 text-center gradient_bg_color1"><a ui-sref="tracklicense"><div class="teaser_icon round size_small"><i class="fa fa-check-circle fontsize_18"></i></div><p class="small">Track Licenses</p></a></div></div><div class="row"><div class="col-6 col-xs-6 text-center gradient_bg_color1"><a href="http://hsiidcgis.org.in/hsiidcgis/" target="_blank"><div class="teaser_icon round size_small"><i class="fa fa-building fontsize_18"></i></div><p class="small">Land Availability</p></a></div><div class="col-6 col-xs-6 text-center gradient_bg_color1"><a href="https://grs.investharyana.in" target="_blank"><div class="teaser_icon round size_small"><i class="fa fa-pencil-square-o fontsize_18"></i></div><p class="small">Grievance Redressal</p></a></div><!--<div class="col-6 col-xs-6 text-center gradient_bg_color1">--><!--<a href="#"><div class="teaser_icon round size_small"><i class="fa fa-support fontsize_18"></i></div>--><!--<p class="small">Grievance Redressal</p></a>--><!--</div>--></div></div><div class="side-container-close gradient_bg_color1"><span class="fa fa-close"></span></div></div><div class="side-container-open gradient_bg_color3"><span class="large-text">Investor Services</span></div></div><div class="modal fade" id="usefullModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true"><div class="modal-dialog" role="document"><div class="modal-content"><div class="modal-header"><h5 class="modal-title" id="exampleModalLabel">Usefull Links</h5><button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button></div><div class="modal-body"><ul class="menu" ng-if="vm.usefullLink === \'sdw\'"><li><a target="_blank" href="https://haryanaindustries.gov.in/">Department of Industries & Commerce, Haryana</a></li><li><a target="_blank" href="http://hrylabour.gov.in">Labour Department, Haryana</a></li><li><a target="_blank" href="http://tcpharyana.gov.in/">Town and Country Planning Department Haryana</a></li><li><a target="_blank" href="https://haryanatax.gov.in/HEX/appmanager/HexPortal/HaryanaExcise?JSESSIONID=zXTFc32Ph2CbLwGdxPQyWTyhtQTlCXpcFGhDT4syMdJMHnPGFXCt!1554934346">Excise and Taxation Department, Government of Haryana</a></li><li><a target="_blank" href="http://www.hsiidc.org/">Haryana State Industrial & Infrastructure Development Corporation (HSIIDC)</a></li><li><a target="_blank" href="http://www.uhbvn.com/">Uttar Haryana Bijli Vitran Nigam</a></li><li><a target="_blank" href="http://www.dhbvn.com/">Dakshin Haryana Bijli Vitran Nigam</a></li><li><a target="_blank" href="http://hspcb.gov.in">Haryana State Pollution Control Board</a></li><li><a target="_blank" href="https://ulbharyana.gov.in/">Urban Local Bodies, Haryana</a></li></ul><ul class="menu" ng-if="vm.usefullLink === \'ia\'"><li><a target="_blank" href="https://dipp.gov.in/">DIPP</a></li><li><a target="_blank" href="https://msme.gov.in/">MSME</a></li><li><a target="_blank" href="https://www.investindia.gov.in/">Invest India</a></li><li><a target="_blank" href="https://www.cii.in/States.aspx?enc=5WcSaM0yzEfRFlFUNeIvYGPI9xL9HypQH+qrcmYEmb4T1+T4I56xaYnyYCd4HNjyUPzzJ+O0kj95uMYZjflXDA==">CII Haryana</a></li><li><a target="_blank" href="http://www.phdcci.in/states/haryana-chapter/">PHD Chamber</a></li></ul></div><div class="modal-footer"><button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button></div></div></div></div>');
$templateCache.put('app/layouts/navbar/navbar.html','<!--<header class="page_header header_white tall_header toggler_xs_right" ng-switch="vm.isAuthenticated()">--><!--<div class="container-fluid" style="padding: 10px !important; margin: 10px !important;">--><!--<div class="row">--><!--<div class="col-sm-12 display-flex v-center">--><!--<div class="col-md-3 pull-left">--><!--<div class="header_left_logo"> <a ui-sref="home" class="logo">--><!--<img src="../../../content/images/logo.jpg" alt="Home" title="Home">--><!--</a> </div>--><!--</div>--><!--<div class="col-md-2 pull-left">--><!--<div class="header_left_logo"> <a ui-sref="home" class="logo">--><!--<img src="../../../content/images/bipp_logo.png" alt="Home" title="Home">--><!--</a> </div>--><!--</div>--><!--<div class="col-md-7">--><!--<img src="../../../content/images/govt_haryana_logo.jpg" class="leftpadding_10 pull-right" />--><!--</div>--><!--</div>--><!--<div class="col-md-12 display-flex v-center text-center" style="background-color: #A0233D; color: white">--><!--<div class="header_mainmenu">--><!--&lt;!&ndash; main nav start &ndash;&gt;--><!--<nav class="mainmenu_wrapper">--><!--<ul class="mainmenu nav sf-menu">--><!--<li ui-sref-active="active">--><!--<a ui-sref="viewServiceStatus" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--View Service Status--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="feedbacksbyofficer" has-authority="ROLE_FEEDBACK_OFFICER" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--Feedbacks--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="viewUserServiceStatus" ng-hide="vm.account.authorities.indexOf(\'ROLE_ADMIN,ROLE_SUB_ADMIN\')>-1" has-authority="ROLE_USER" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--View Service Status--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="scheduledList" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-eye-open"></span>--><!--Single Inspection System--><!--</a>--><!--</li>--><!--&lt;!&ndash;ROLE_ACCOUNT_OFFICER,&ndash;&gt;--><!--<li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_ACCOUNT_OFFICER">--><!--<a ui-sref="viewpayments({disbursed:false})" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-piggy-bank"></span>--><!--<span>View Payments</span>--><!--</a>--><!--</li>--><!--<li uib-dropdown has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_ASSIGNRM_OFFICER">--><!--<a uib-dropdown-toggle href="">--><!--<span>--><!--<span>--><!--Assign Users--><!--</span>--><!--</span>--><!--</a>--><!--<ul class="gradient_bg_color1">--><!--<li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_ASSIGNRM_OFFICER">--><!--<a ui-sref="assignProjectToRM" ng-click="vm.collapseNavbar()">--><!--<span>Assign Project To RM</span>--><!--</a>--><!--</li>--><!--&lt;!&ndash;<li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">&ndash;&gt;--><!--&lt;!&ndash;<a ui-sref="assignFieldOfficerToDepartment" ng-click="vm.collapseNavbar()">&ndash;&gt;--><!--&lt;!&ndash;<span class="glyphicon glyphicon-briefcase"></span>&ndash;&gt;--><!--&lt;!&ndash;<span data-translate="">Assign FieldOfficer To Department</span>&ndash;&gt;--><!--&lt;!&ndash;</a>&ndash;&gt;--><!--&lt;!&ndash;</li>&ndash;&gt;--><!--</ul>--><!--</li>--><!--<li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">--><!--&lt;!&ndash;<a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu">&ndash;&gt;--><!--&lt;!&ndash;<span>&ndash;&gt;--><!--&lt;!&ndash;<span class="glyphicon glyphicon-th-list"></span>&ndash;&gt;--><!--&lt;!&ndash;<span data-translate="global.menu.entities.main">&ndash;&gt;--><!--&lt;!&ndash;Entities&ndash;&gt;--><!--&lt;!&ndash;</span>&ndash;&gt;--><!--&lt;!&ndash;<b class="caret"></b>&ndash;&gt;--><!--&lt;!&ndash;</span>&ndash;&gt;--><!--&lt;!&ndash;</a>&ndash;&gt;--><!--<ul class="gradient_bg_color1">--><!--<li ui-sref-active="active">--><!--<a ui-sref="department" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span>Department</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="assign-service-fee" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span>Assign Service Fee</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="department-service" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span>Department Service</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="service-form-field" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.serviceFormField">Service Form Field</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="country" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.country">Country</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="state" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.state">State</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="district" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.district">District</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="block" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.block">Block</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="city-town-village" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.cityTownVillage">City Town Village</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="tehsil-subtehsil" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.tehsilSubtehsil">Tehsil Subtehsil</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="connectingroad" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.connectingroad">Connectingroad</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="landusezoneclassification" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.landusezoneclassification">Landusezoneclassification</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="sector" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.sector">Sector</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="industrysize" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.industrysize">Industrysize</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectype" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectype">Projectype</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectcategory" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectcategory">Projectcategory</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="approvalforms" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.approvalforms">Approvalforms</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="foreignfundingresource" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.foreignfundingresource">Foreignfundingresource</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="manufacturingunits" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.manufacturingunits">Manufacturingunits</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="watersupplysource" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.watersupplysource">Watersupplysource</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="modeofdisposalfor-discharge" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.modeofdisposalforDischarge">Modeofdisposalfor Discharge</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="particular" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.particular">Particular</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="emmision-fuel-type" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.emmisionFuelType">Emmision Fuel Type</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="emmision-pollution-controll" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.emmisionPollutionControll">Emmision Pollution Controll</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="waste-water-naturetype" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.wasteWaterNaturetype">Waste Water Naturetype</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="waste-water-disposal-mode" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.wasteWaterDisposalMode">Waste Water Disposal Mode</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="regular-electrict-load-type" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.regularElectrictLoadType">Regular Electrict Load Type</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="investor" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.investor">Investor</span>--><!--</a>--><!--</li>--><!--&lt;!&ndash;<li ui-sref-active="active">&ndash;&gt;--><!--&lt;!&ndash;<a ui-sref="businessentity" ng-click="vm.collapseNavbar()">&ndash;&gt;--><!--&lt;!&ndash;<span class="glyphicon glyphicon-asterisk"></span>&nbsp;&ndash;&gt;--><!--&lt;!&ndash;<span data-translate="global.menu.entities.businessentity">Businessentity</span>&ndash;&gt;--><!--&lt;!&ndash;</a>&ndash;&gt;--><!--&lt;!&ndash;</li>&ndash;&gt;--><!--<li ui-sref-active="active">--><!--<a ui-sref="companydetail" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.companydetail">Companydetail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectdetail" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectdetail">Projectdetail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectsitedetail" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectsitedetail">Projectsitedetail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="project-finance-investment" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectFinanceInvestment">Project Finance Investment</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="project-phase" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectPhase">Project Phase</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectrawmaterial" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectrawmaterial">Projectrawmaterial</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectproduct" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectproduct">Projectproduct</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectprocessflowsteps" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectprocessflowsteps">Projectprocessflowsteps</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="manufacturingdetail" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.manufacturingdetail">Manufacturingdetail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="emissiondetail" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.emissiondetail">Emissiondetail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="wastewaterdetail" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.wastewaterdetail">Wastewaterdetail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="environment-impactdetail" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.environmentImpactdetail">Environment Impactdetail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="electricrequirement" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.electricrequirement">Electricrequirement</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="term-declaration-accept" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.termDeclarationAccept">Term Declaration Accept</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectdetailcombinecodes" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectdetailcombinecodes">Projectdetailcombinecodes</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="wwtreatmentone" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.wwtreatmentone">Wwtreatmentone</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="wwtreatmenttwo" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.wwtreatmenttwo">Wwtreatmenttwo</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="wwtreatmentthree" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.wwtreatmentthree">Wwtreatmentthree</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectservicedetail" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.projectservicedetail">Projectservicedetail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="departmentservice" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.departmentservice">Departmentservice</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="businessentitys" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.businessentitys">Businessentitys</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="project-service-report-info" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectServiceReportInfo">Project Service Report Info</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectserviceformfielddata" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectserviceformfielddata">Projectserviceformfielddata</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="project-attachemnt" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.projectAttachemnt">Project Attachemnt</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="project-service-log" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.projectServiceLog">Project Service Log</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="project-service-payment-details" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectServicePaymentDetails">Project Service Payment Details</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="assign-project-to-rm" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.assignProjectToRm">Assign Project To Rm</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="extended-user-information" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.extendedUserInformation">Extended User Information</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="assign-field-officer-to-department" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.assignFieldOfficerToDepartment">Assign Field Officer To Department</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="caf-attachment" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.cafAttachment">Caf Attachment</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="district-nodal-officer" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.districtNodalOfficer">District Nodal Officer</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="district-field-officer" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.districtFieldOfficer">District Field Officer</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="customertype" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.customertype">Customertype</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="district-desk-officer" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span--><!--data-translate="global.menu.entities.districtDeskOfficer">District Desk Officer</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectlog" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectlog">Projectlog</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="notification" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.notification">Notification</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="service-form-attachments" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.serviceFormAttachments">Service Form Attachments</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="serviceformdocs" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.serviceformdocs">Serviceformdocs</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="service-form-field" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.serviceFormField">Service Form Field</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="minutesofmeeting" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.minutesofmeeting">Minutesofmeeting</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="grievance" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.grievance">Grievance</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="grievance-assign" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.grievanceAssign">Grievance Assign</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="grievance-log" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.grievanceLog">Grievance Log</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="renewable-caf" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.renewableCaf">Renewable Caf</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="department-service" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.departmentService">Department Service</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="landrequirementcaf" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.landrequirementcaf">Landrequirementcaf</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="projectservicedetail" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectservicedetail">Projectservicedetail</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="acknowledgements" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.acknowledgements">Acknowledgements</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="above-ground" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.aboveGround">Above Ground</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="below-ground" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.belowGround">Below Ground</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="project" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.project">Project</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="tower-log" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.towerLog">Tower Log</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="zone" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.zone">Zone</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="tower-dc" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.towerDc">Tower Dc</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="service-dashboard-output" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span>Service Dashboard Output</span></a>--><!--<a ui-sref="rmlist" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span>Rmlist</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="deemed-clearance-approval" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.deemedClearanceApproval">Deemed Clearance Approval</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="meeting-attendance" ng-click="vm.collapseNavbar()">--><!--<span>Meeting Attendance</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="meeting-attendee" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span>Meeting Attendee</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="grievance-dashboard-output" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.grievanceDashboardOutput">Grievance Dashboard Output</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="towerservice-no" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.towerserviceNo">Towerservice No</span>--><!--</a>--><!--<a ui-sref="towerdclist" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.towerdclist">Towerdclist</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="towerservice-no" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.towerserviceNo">Towerservice No</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="construction-permit-approval-steps" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.constructionPermitApprovalSteps">Construction Permit Approval Steps</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="aai" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.aai">Aai</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="nma" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.nma">Nma</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="construction-permit-log" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.constructionPermitLog">Construction Permit Log</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="inspection-report" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.inspectionReport">Inspection Report</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="factoty-plan" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.factotyPlan">Factoty Plan</span>--><!--</a>--><!--<a ui-sref="towerdiolist" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.towerdiolist">Towerdiolist</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="hudaform-oc" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.hudaformOc">Hudaform Oc</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="huda-form" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.hudaForm">Huda Form</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="totalservicedashboarddetails" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.totalservicedashboarddetails">Totalservicedashboarddetails</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="cafsfornodalofficer" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.cafsfornodalofficer">Cafsfornodalofficer</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="visitor-count" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.visitorCount">Visitor Count</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="landexchange" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.landexchange">Landexchange</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="municipality" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.municipality">Municipality</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="tower-service-dashboard" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.towerServiceDashboard">Tower Service Dashboard</span>--><!--</a>--><!--<a ui-sref="towerofficerlist" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.towerofficerlist">Towerofficerlist</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="new-dasboard-stats" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.newDasboardStats">New Dasboard Stats</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="new-dasboard-all-completed-stats" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.newDasboardAllCompletedStats">New Dasboard All Completed Stats</span>--><!--</a>--><!--<a ui-sref="service-dashboard-output" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.serviceDashboardOutput">Service Dashboard Output</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="checklist" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.checklist">Checklist</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="user-authorization" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.userAuthorization">User Authorization</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="re-apply-dashboard" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.reApplyDashboard">Re Apply Dashboard</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="project-service-log" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.projectServiceLog">Project Service Log</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="survey" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.survey">Survey</span>--><!--</a>--><!--<a ui-sref="draft-policy" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.draftPolicy">Draft Policy</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="policy-details" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.policyDetails">Policy Details</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="district-village-block-mapping" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.districtVillageBlockMapping">District Village Block Mapping</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="rating" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.rating">Rating</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="service-status" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.serviceStatus">Service Status</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="service-level" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.serviceLevel">Service Level</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="tickets" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.tickets">Tickets</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="tickets-logs" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.ticketsLogs">Tickets Logs</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="tickets-customer" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.ticketsCustomer">Tickets Customer</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="nmatoken" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.nmatoken">Nmatoken</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="serviceformdraftsaved" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.serviceformdraftsaved">Serviceformdraftsaved</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="applicationstatus" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.applicationstatus">Applicationstatus</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="scheduled-visits" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.scheduledVisits">Scheduled Visits</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="inspector-details" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.inspectorDetails">Inspector Details</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="feedback-officer" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.feedbackOfficer">Feedback Officer</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="hepc-recruitment" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.hepcRecruitment">Hepc Recruitment</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="hepc-recruitment-qualifications" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.hepcRecruitmentQualifications">Hepc Recruitment Qualifications</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="hepc-recruitment-experience" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.hepcRecruitmentExperience">Hepc Recruitment Experience</span>--><!--</a>--><!--</li>--><!--&lt;!&ndash; jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here &ndash;&gt;--><!--</ul>--><!--</li>--><!--<li has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER" ui-sref-active="active"><a ui-sref="meeting-attendance">Attendance</a></li>--><!--<li has-authority="ROLE_API_VIEWER">--><!--<a ui-sref="docs" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-book"></span>&nbsp;--><!--<span data-translate="global.menu.admin.apidocs">API</span>--><!--</a>--><!--</li>--><!--<li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true"--><!--has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN" uib-dropdown>--><!--<a uib-dropdown-toggle href="" id="admin-menu">--><!--<span>--><!--<span data-translate="global.menu.admin.main">Administration</span>--><!--</span>--><!--</a>--><!--<ul class="gradient_bg_color1">--><!--<li ui-sref-active="active">--><!--<a ui-sref="user-management" ng-click="vm.collapseNavbar()">--><!--&nbsp;--><!--<span>User management</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-dashboard"></span>&nbsp;--><!--<span data-translate="global.menu.admin.metrics">Metrics</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="jhi-health" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-heart"></span>&nbsp;--><!--<span data-translate="global.menu.admin.health">Health</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-list-alt"></span>&nbsp;--><!--<span data-translate="global.menu.admin.configuration">Configuration</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="audits" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-bell"></span>&nbsp;--><!--<span data-translate="global.menu.admin.audits">Audits</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="logs" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-tasks"></span>&nbsp;--><!--<span data-translate="global.menu.admin.logs">Logs</span>--><!--</a>--><!--</li>--><!--<li ng-show="vm.swaggerEnabled" ui-sref-active="active">--><!--<a ui-sref="docs" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-book"></span>&nbsp;--><!--<span data-translate="global.menu.admin.apidocs">API</span>--><!--</a>--><!--</li>--><!--&lt;!&ndash; jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here &ndash;&gt;--><!--</ul>--><!--</li>--><!--<li has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN" ui-sref-active="active" uib-dropdown--><!--ng-controller="JhiLanguageController as languageVm">--><!--&lt;!&ndash;<a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1">&ndash;&gt;--><!--&lt;!&ndash;<span>&ndash;&gt;--><!--&lt;!&ndash;<span class="glyphicon glyphicon-flag"></span>&ndash;&gt;--><!--&lt;!&ndash;<span data-translate="global.menu.language">Language</span>&ndash;&gt;--><!--&lt;!&ndash;<b class="caret"></b>&ndash;&gt;--><!--&lt;!&ndash;</span>&ndash;&gt;--><!--&lt;!&ndash;</a>&ndash;&gt;--><!--<ul class="gradient_bg_color1" ng-if="languageVm.languages.length > 1">--><!--<li active-menu="{{language}}" ng-repeat="language in languageVm.languages">--><!--<a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language--><!--| findLanguageFromKey}}</a>--><!--</li>--><!--</ul>--><!--</li>--><!--</ul>--><!--</nav>--><!--&lt;!&ndash; eof main nav &ndash;&gt;--><!--&lt;!&ndash; header toggler &ndash;&gt;<span class="toggle_menu"><span></span></span>--><!--</div>--><!--</div>--><!--</div>--><!--</div>--><!--</header>--><section class="page_topline ls columns_margin_0"><div class="container-fluid"><div class="row"><div class="col-md-3 pull-left text-center"><img src="../../../content/used-images-new/govt_haryana_logo.png" width="80" height="80"> <span class="small-text text-center" style="font-size:12px; line-height:12px"><br>Department of Industries & Commerce<br>Government of Haryana</span></div><div class="col-md-5"><p class="small-text text-center" style="padding-top:30px;font-family: -apple-system, BlinkMacSystemFont, \'Segoe UI\', Roboto, \'Helvetica Neue\', Arial, sans-serif; font-size:25px"><strong>Invest Haryana</strong></p></div><div class="col-md-2 pull-right"><div class="header_left_logo"><a ui-sref="home" class="logo"><img src="../../../content/used-images-new/logo.jpg" alt="Home" title="Home"></a></div></div><div class="col-md-2"><div class="header_left_logo pull-right"><a ui-sref="home" class="logo"><a href="http://www.bippharyana.in/" target="_blank"><img src="../../../content/used-images-new/bipp_logo.png" alt="Home" width="100px" title="Home" style="padding-top:12px; padding-bottom:15px"></a></a></div></div><div class="col-md-2"><select ng-change="changeLanguage(selectedLanguage)" ng-model="selectedLanguage"><option value="en">English</option><option value="hi">Hindi</option></select></div><div ng-show="vm.isAuthenticated() && vm.currentuser!=null" class="font14 pull-right" style="margin-top:15px"><h4><b>Welcome {{vm.currentuser}} !</b></h4></div></div><!--<div class="row flex-wrap v-center">--><!--<div class="col-xs-12 col-md-6 col-lg-4 text-center text-md-left">--><!--<div class="inline-content grey"> </div>--><!--</div>--><!--<div class="col-xs-12 col-md-6 col-lg-4 col-lg-push-4 text-center text-md-right">--><!--<div class="inline-content grey"> <span>--><!--<p class="small-text">&lt;!&ndash;<a href="#0" class="button" data-toggle="modal" data-target="#login-modal">Login/Register</a>&ndash;&gt;</p>--><!--</span> </div>--><!--</div>--><!----><!--</div>--></div></section><div ng-switch="vm.isAuthenticated()"><div ng-switch-when="true"><html lang="en"><head><link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.7/css/bootstrap.min.css"><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"></head><body class="main_first1"><div ng-switch="vm.isAuthenticated()"><nav class="navbar navbar-inverse" style="margin-bottom: 5px;background:#A0233D" ng-switch-when="true"><div class="container" ng-switch="vm.isAuthenticated()"><div class="row pull-left"><button type="button" class="navbar-toggle" style="background:#A0233D" ng-click="vm.toggleNavbar()" style="background: #2d7fef"><span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span></button><div class="navbar-collapse" uib-collapse="vm.isNavbarCollapsed" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-right"><li ui-sref-active="active"><a class="nav-bar1" ui-sref="home" ng-click="vm.collapseNavbar()"><!--<span class="glyphicon glyphicon-home"></span>--> <span class="hidden-sm" data-translate="global.menu.home">Home</span></a></li><li has-any-authority="ROLE_ADMIN, ROLE_STATE_NODAL_OFFICER" ng-show="vm.isAuthenticated()"><a class="nav-bar1" ui-sref="deativatedCafs" ng-click="vm.collapseNavbar()"><!--<span class="glyphicon glyphicon-home"></span>--> <span class="hidden-sm">Deactivated Cafs</span></a></li><li has-any-authority="ROLE_ADMIN, ROLE_STATE_NODAL_OFFICER" ng-show="vm.isAuthenticated()"><a class="nav-bar1" ui-sref="temporary-tower-apply" ng-click="vm.collapseNavbar()"><!--<span class="glyphicon glyphicon-home"></span>--> <span class="hidden-sm">Temporary Tower</span></a></li><li has-any-authority="ROLE_ADMIN, ROLE_STATE_NODAL_OFFICER" ng-show="vm.isAuthenticated()"><a class="nav-bar1" ui-sref="force-majeure" ng-click="vm.collapseNavbar()"><!--<span class="glyphicon glyphicon-home"></span>--> <span class="hidden-sm">Force Majeure</span></a></li><li has-any-authority="ROLE_ADMIN, ROLE_STATE_NODAL_OFFICER" ng-show="vm.isAuthenticated()"><a class="nav-bar1" ui-sref="tower-removal-apply" ng-click="vm.collapseNavbar()"><!--<span class="glyphicon glyphicon-home"></span>--> <span class="hidden-sm">Tower Removal</span></a></li><li ui-sref-active="active" ng-show="vm.isAuthenticated()"><a class="nav-bar1" ui-sref="temp-tower-by-user" ng-click="vm.collapseNavbar()"><span class="hidden-sm">Temp Tower BY User</span></a></li><li has-any-authority="ROLE_USER,ROLE_ADMIN, ROLE_SUB_ADMIN" ng-show="vm.isAuthenticated()"><a class="nav-bar1" ui-sref="edit-caf-requests" ng-click="vm.collapseNavbar()"><!--<span class="glyphicon glyphicon-home"></span>--> <span class="hidden-sm">CAF Change Requests</span></a></li><li ng-show="vm.isAuthenticated()" ui-sref-active="active" ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') ||vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_TICKET_ADMIN\')" has-authority="ROLE_L2_DEPARTMENT_HEAD"><a class="nav-bar1" ui-sref="dashboardHod" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="">Dashboard</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="evPolicies" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.EV Policy 2022">EV Policy 2022</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="startupPolicies" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.Haryana State Startup Policy 2022">Haryana State Startup Policy 2022</span></a></li><!--                                <li ui-sref-active="active">--><!--                                    <a class="nav-bar1" ui-sref="conversionOfBoiler" ng-click="vm.collapseNavbar()">--><!--                                        <span class="hidden-sm">CAQM</span>--><!--                                    </a>--><!--                                </li>--><li ng-show="vm.isAuthenticated()" ui-sref-active="active" ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') ||vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_TICKET_ADMIN\') || vm.account.authorities.includes(\'ROLE_L2_DEPARTMENT_HEAD\')" has-any-authority="ROLE_L1_SUPPORT,ROLE_L2_IT_MANAGER,ROLE_L2_DEPARTMENT,ROLE_L2_INCENTIVES,ROLE_TICKET_NODAL_OFFICER,ROLE_TICKET_OPERATION_MANAGER,ROLE_TICKET_HOBPAS"><a class="nav-bar1" ui-sref="hepcticket" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="">HEPC Ticket</span></a></li><li ng-show="vm.isAuthenticated()" ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_TICKET_ADMIN"><a class="nav-bar1" ui-sref="hepcticketadmin" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="">HEPC Ticket</span></a></li><li ng-show="vm.isAuthenticated()" ui-sref-active="active" has-any-authority="ROLE_ADMIN"><a class="nav-bar1" ui-sref="supplyDisposal" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="">Supply & Disposal Dashboard</span></a></li><li ng-show="vm.isAuthenticated()" ui-sref-active="active" ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') ||vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_TICKET_ADMIN\')" has-authority="ROLE_L2_DEPARTMENT_HEAD"><a class="nav-bar1" ui-sref="timeoutTickets" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="">HEPC Ticket</span></a></li><li ng-show="vm.isAuthenticated()" ui-sref-active="active" ng-hide="vm.account.authorities.includes(\'ROLE_ADMIN\') ||vm.account.authorities.includes(\'ROLE_SUB_ADMIN\') || vm.account.authorities.includes(\'ROLE_TICKET_ADMIN\')" has-authority="ROLE_L2_DEPARTMENT_HEAD"><a class="nav-bar1" ui-sref="servicedashboardhod" ng-click="vm.collapseNavbar()"><span class="hidden-sm">Service Status</span></a></li><!---Start Menu Bar----><!-- jhipster-needle-add-element-to-menu - JHipster will add new menu items here --><!--<li><a ui-sref="about" class="nav-bar1" ng-show="isActive(\'/\')">About Us</a></li>--><li ng-show="vm.isAuthenticated()==false" uib-dropdown class="dropdown pointer"><a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href=""><span><!--<span class="glyphicon glyphicon-user"></span>--> <span class="hidden-sm">About Us </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="about" ng-click="vm.collapseNavbar()"><span class="hidden-sm">About HEPC</span></a></li><!--<li ui-sref-active="active">--><!--<a ui-sref="CM_Message" ng-click="vm.collapseNavbar()">--><!--<span class="hidden-sm">CM Message</span>--><!--</a>--><!--</li>--><li ui-sref-active="active"><a ui-sref="mission" ng-click="vm.collapseNavbar()"><span class="hidden-sm">Mission & Vision</span></a></li><li ui-sref-active="active"><a ui-sref="participating_department" ng-click="vm.collapseNavbar()"><span class="hidden-sm">Participating Department</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/ContactList.xlsx"><span>Contact List</span></a></li></ul></li><li ng-show="vm.isAuthenticated()==false" uib-dropdown class="dropdown pointer"><a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href=""><span><!--<span class="glyphicon glyphicon-user"></span>--> <span class="hidden-sm">Haryana </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="haryana" ng-click="vm.collapseNavbar()"><span class="hidden-sm">Fact File</span></a></li><li ui-sref-active="active"><a ui-sref="states" ng-click="vm.collapseNavbar()"><span class="hidden-sm">States</span></a></li><li ui-sref-active="active"><a ui-sref="Enabling_infrastructure" ng-click="vm.collapseNavbar()"><span class="hidden-sm">Enabling Infrastructure</span></a></li><li ui-sref-active="active"><a ui-sref="urban_infrastructure" ng-click="vm.collapseNavbar()"><span class="hidden-sm">Urban Infrastructure</span></a></li><li ui-sref-active="active"><a ui-sref="industrial_powerhouse" ng-click="vm.collapseNavbar()"><span class="hidden-sm">Industrial Powerhouse</span></a></li></ul></li><li ng-show="vm.isAuthenticated()==false" uib-dropdown class="dropdown pointer"><a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href=""><span><!--<span class="glyphicon glyphicon-user"></span>--> <span class="hidden-sm">Investor Service </span><b class="caret"></b></span></a><ul class="dropdown-menu multi-level" role="menu" aria-labelledby="dropdownMenu"><li ui-sref-active="active"><a ng-click="vm.collapseNavbar()" ui-sref="investorfacilitationcell">How to apply - Application Procedure</a></li><li ui-sref-active="active"><a ng-click="vm.login()">Investor Login/Registration</a></li><li ui-sref-active="active"><a target="_blank" href="../../../content/images/UserManualForAvailingService.pdf">User Manual</a></li><li ui-sref-active="active"><a target="_blank" href="content/images/BookletConstructionPermitGuide.pdf">Construction Permit Ready Reckoner</a></li><li ui-sref-active="active"><a ui-sref="Questionnaire" ng-click="vm.collapseNavbar()">Know Your Clearances</a></li><li ui-sref-active="active"><a ui-sref="servicedashboardyearly" ng-click="vm.collapseNavbar()">Service Dashboard</a></li><li ui-sref-active="active"><a ui-sref="eodbpublicdashboard" ng-click="vm.collapseNavbar()">EODB Public Dashboard</a></li><li ui-sref-active="active"><a ui-sref="newdeptservicedashboard" ng-click="vm.collapseNavbar()">Other Department Dashboard</a></li><li ui-sref-active="active"><a ui-sref="incentivedashboard" ng-click="vm.collapseNavbar()">Incentives Dashboard</a></li><li class="divider"></li><li class="dropdown-submenu"><a tabindex="-1" href="">HSPCB</a><ul class="dropdown-menu"><li><a target="_blank" ng-click="vm.downloadFile(\'ConsentManualCTE.pptx\',\'ConsentManualCTE.pptx\')">Consent Manual CTE</a></li><li><a target="_blank" ng-click="vm.downloadFile(\'Consent_Manual_CTO.pptx\',\'Consent_Manual_CTO.pptx\')">Consent Manual CTO</a></li><li><a target="_blank" ng-click="vm.downloadFile(\'HEPC_BMW_authorization.pptx\',\'HEPC_BMW_authorization.pptx\')">HEPC BMW authorization</a></li><li><a target="_blank" ng-click="vm.downloadFile(\'HEPC_HWM.pptx\',\'HEPC_HWM.pptx\')">HEPC HWM</a></li></ul></li><li class="dropdown-submenu"><a tabindex="-2" href="">DHBVN/UHBVN</a><ul class="dropdown-menu"><li><a target="_blank" ng-click="vm.downloadFile(\'TemporaryElectricityConnection.pdf\',\'Temporary ElectricityConnection(DHBVN,UHBVN).pdf\')">Temporary Electricity Connection (DHBVN,UHBVN)</a></li><li><a target="_blank" ng-click="vm.downloadFile(\'RegularElectricityConnection.pdf\',\'Regular Electricity Connection(DHBVN,UHBVN).pdf\')">Regular Electricity Connection (DHBVN,UHBVN)</a></li></ul></li></ul></li><li ng-show="vm.isAuthenticated()==false" uib-dropdown class="dropdown pointer"><a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href=""><span><!--<span class="glyphicon glyphicon-user"></span>--> <span class="hidden-sm">Information </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><!--<li ui-sref-active="active">--><!--<a target="_blank" href="https://www.huda.org.in/_layouts/Ease/Informataion_on_landBank_for_Ind_use.pdf" ng-click="vm.collapseNavbar()">--><!--<span class="hidden-sm">HUDA Land Bank</span>--><!--</a>--><!--</li>--><li ui-sref-active="active"><a target="_blank" href="http://hsiidc.org.in/sites/default/files/E%20Documents/Estate%20Availability.pdf" ng-click="vm.collapseNavbar()"><span class="hidden-sm">HSIIDC Land Bank</span></a></li><li ui-sref-active="active"><a ng-click="vm.collapseNavbar()"><span class="hidden-sm">Forms/Fees</span></a></li><li ui-sref-active="active"><a ng-click="vm.collapseNavbar()"><span class="hidden-sm">Comprehensive List of Approvals</span></a></li><li ui-sref-active="active"><a ui-sref="focusarea" ng-click="vm.collapseNavbar()"><span class="hidden-sm">Focus Area</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/checklistforincentive.pdf"><span class="hidden-sm">Incentive Checklist</span></a></li><li ui-sref-active="active"><a ui-sref="imposedlevies"><span class="hidden-sm">LEVIES IMPOSED BY STATE AND LOCAL BODIES</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/RMREList.xls"><span class="hidden-sm">RMs & REs List</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/Pharma_policy.pdf"><span class="hidden-sm">Pharma Policy Draft</span></a></li><li ui-sref-active="active"><a ng-click="vm.collapseNavbar()"><span class="hidden-sm">FAQs</span></a></li></ul></li><li ng-show="vm.isAuthenticated()==false" uib-dropdown class="dropdown pointer"><a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href=""><span><!--<span class="glyphicon glyphicon-user"></span>--> <span class="hidden-sm">Minutes of Meetings </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a data-toggle="modal" data-target="#mm_meeting" ng-click="vm.meeting_view(\'HEPB\')"><span class="hidden-sm">HEPB</span></a></li><li ui-sref-active="active"><a data-toggle="modal" data-target="#mm_meeting" ng-click="vm.meeting_view(\'EEC\')"><span class="hidden-sm">EEC</span></a></li></ul></li><li ng-show="vm.isAuthenticated()==false" ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href=""><span><span></span> <span class="hidden-sm">Acts & Notifications </span><b class="caret"></b></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a target="_blank" href="content/images/Haryana_Book_Final1.pdf"><span>EPP</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/Haryana_Enterprises_Promotion_Act2016.pdf"><span>HEPA</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/HEPR2016.pdf"><span>HEPR</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/draft_business_regulation_mandate.pdf"><span>Draft Business Regulation Mandate</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/HARYANASOLARPOLICY-2016.pdf"><span>Haryana Solar Policy - 2016</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/hareda366111561.pdf"><span>HAREDA-Notification</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/ConsolidatedNotifiedServices.pdf"><span>Right to Service Act</span></a></li><li ui-sref-active="active"><a target="_blank" href="http://csharyana.gov.in/WriteReadData/Act/Administrative%20Reforms/4297.pdf"><span>RTS - Mar 26,2014</span></a></li><li ui-sref-active="active"><a target="_blank" href="http://www.egazetteharyana.gov.in/Gazette/Extra-Ordinary/2017/192-2017-Ext/5020.pdf"><span>HSPCB timeline link</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/The-Haryana-Building-Code-2017.pdf"><span>Uniform building Code2017</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/TheHaryanaBuildingCode20172ndAmendmentforEODB.pdf"><span>Amended Uniform Building Code 2017</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/Notification05.07.2018.pdf"><span>Delegation of Power to NOs</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/NewDoc2018-11-28.pdf"><span>Exemption from renewals under Shops and<br>Commercial Estab. Act</span></a></li><li ui-sref-active="active"><a target="_blank" href="content/images/Haryana_RFP_Document.pdf"><span>RFP for Appointment of Knowledge Partner for<br>Investment Promotion, Policy Implementation,<br>and Business Climate Reforms Services</span></a></li></ul></li><!--<li><a ui-sref="information" class="nav-bar1">Information</a></li>--><li ng-show="vm.isAuthenticated()==false"><a ui-sref="news_gallery" class="nav-bar1">News &amp; Gallery</a></li><!--<li><a class="nav-bar1" ng-show="isActive(\'/\')">Login</a></li>--><li uib-dropdown class="dropdown pointer"><!--<a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href="" id="investor"--><!--ng-show="isActive(\'/\')">--><!--<span>--><!--&lt;!&ndash;<span class="glyphicon glyphicon-th-list"></span>&ndash;&gt;--><!--<span class="hidden-sm">--><!--Investor Services--><!--</span>--><!--<b class="caret"></b>--><!--</span>--><!--</a>--><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="contact" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Single Desk Portal-Registration</span></a></li><li ui-sref-active="active"><a ui-sref="item" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Single Desk Portal-Enterpreneur Login</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Apply For Approvals</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Apply For Industrial Incentives</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">GOI Facilitation Desk</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Grievance Redressal</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Approvals Verification</span></a></li><li ui-sref-active="active"><a ui-sref="Questionnaire" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Know Your Approvals</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Sick Industries Registration</span></a></li><li ui-sref-active="active"><a ui-sref="servicedashboard" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">HEPC Performance Dashboard</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li uib-dropdown class="dropdown pointer"><!--<a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href="" id="department"--><!--ng-show="isActive(\'/\')">--><!--<span>--><!--&lt;!&ndash;<span class="glyphicon glyphicon-th-list"></span>&ndash;&gt;--><!--<span class="hidden-sm">--><!--Department--><!--</span>--><!--<b class="caret"></b>--><!--</span>--><!--</a>--><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="contact" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Single Window Login</span></a></li><li ui-sref-active="active"><a ui-sref="item" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Investment Tracker</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">SDP Performance Report</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Incentives Department Login</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li uib-dropdown class="dropdown pointer"><!--<a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href="" id="information"--><!--ng-show="isActive(\'/\')">--><!--<span>--><!--&lt;!&ndash;<span class="glyphicon glyphicon-th-list"></span>&ndash;&gt;--><!--<span class="hidden-sm">--><!--Information--><!--</span>--><!--<b class="caret"></b>--><!--</span>--><!--</a>--><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="Goi_Approvals" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">GOI Approvals</span></a></li><li ui-sref-active="active"><a ui-sref="incentives" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Incentives</span></a></li><li ui-sref-active="active"><a ui-sref="departments" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Departments</span></a></li><!--<li ui-sref-active="active">--><!--<a ui-sref="Goi_Approvals" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="">GOI Approvals</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="invoice" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="">Investor Handbook</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="invoice" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="">State policies</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="invoice" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="">HEPA Act</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="incentives" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="">State Schemes & Incentives</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="invoice" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="">Single Desk Bureau</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="invoice" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="">Government Orders and Circulars</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="invoice" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="">User Manuals</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="invoice" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="">Important Links</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active">--><!--<a ui-sref="invoice" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="">Other Documents</span>--><!--</a>--><!--</li>--><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li uib-dropdown class="dropdown pointer"><!--<a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href="" id="about-menu"--><!--ng-show="isActive(\'/\')">--><!--<span>--><!--&lt;!&ndash;<span class="glyphicon glyphicon-th-list"></span>&ndash;&gt;--><!--<span class="hidden-sm">--><!--Sections on Website--><!--</span>--><!--<b class="caret"></b>--><!--</span>--><!--</a>--><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="contact" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Testimonials</span></a></li><li ui-sref-active="active"><a ui-sref="item" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Events</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Gallery/News</span></a></li><li ui-sref-active="active"><a ui-sref="invoice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="">Registration/Login</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><!---End Menu Bar----><!-- Add Project --><li ui-sref-active="active" has-any-authority="ROLE_USER,ROLE_ADMIN,ROLE_SUB_ADMIN"><a class="nav-bar1" ui-sref="caftype" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm" data-translate="global.menu.Add CAF">Add CAF</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_NODAL_OFFICER,ROLE_TOWER_OFFICER"><a class="nav-bar1" ui-sref="decriminalization-form" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="">Penal Provision Acts/Rules</span></a></li><!--                                <li ui-sref-active="active">--><!--                                    <a class="nav-bar1" ui-sref="evPolicies" ng-click="vm.collapseNavbar()">--><!--                                        <span class="hidden-sm">EV Policy 2022</span>--><!--                                    </a>--><!--                                </li>--><!--<li ui-sref-active="active" has-any-authority="ROLE_USER,ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER">--><!--<a class="nav-bar1" ui-sref="projecttype" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-plus"></span>--><!--<span class="hidden-sm" data-translate="">Add CAF</span>--><!--</a>--><!--</li>--><li ui-sref-active="active" ng-hide="vm.username==\'admin\' || vm.checkSubAdmin == true" has-authority="ROLE_USER"><a class="nav-bar1" ui-sref="listproject" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="global.menu.View CAFs">View CAFs</span></a></li><li ui-sref-active="active" ng-hide="vm.username==\'admin\' || vm.checkSubAdmin == true" has-authority="ROLE_USER"><a class="nav-bar1" ui-sref="temporary-tower-view" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm">Temporary Tower</span></a></li><li ui-sref-active="active" ng-hide="vm.username==\'admin\' || vm.checkSubAdmin == true" has-authority="ROLE_USER"><a class="nav-bar1" ui-sref="tower-removal-view" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm">Tower Removal</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_CENTRAL_USER"><a class="nav-bar1" ui-sref="backtocentral" ng-click="vm.collapseNavbar()"><span class="fa fa-arrow-left"></span> <span class="hidden-sm" data-translate="">Back To Central Portal</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN, ROLE_HOME_CTM, ROLE_HOME_SUPERINTENDENT, ROLE_HOME_DC, ROLE_HOME_ASSISTANT"><a class="nav-bar1" ui-sref="projects-home" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="">Show Project</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_TOWER_MONITORING_OFFICER,ROLE_ADMIN"><a class="nav-bar1" ui-sref="towerServiceCAF" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="">Tower Pending Cases</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_TOWER_DC"><a class="nav-bar1" ui-sref="projects" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="">Show Projects</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_CAF_STATUS_OFFICER"><a class="nav-bar1" ui-sref="CAFwithNoService" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="">CAFs Having No Service</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_TOWER_DIO"><a class="nav-bar1" ui-sref="projects-towerdio" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="">Show Projects</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_TOWER_OFFICER"><a class="nav-bar1" ui-sref="showprojectsTowerofficer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="">Show Projects</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER,ROLE_DEPT_CHANGE"><a class="nav-bar1" ui-sref="searchCAF" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="">Search CAF</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_STATE_NODAL_OFFICER"><a class="nav-bar1" ui-sref="searchBusinessEntity" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="">Search Business Entity</span></a></li><!--                                <li ui-sref-active="active" has-any-authority="ROLE_USER">--><!--                                    <a class="nav-bar1" ui-sref="grievancelist" ng-click="vm.collapseNavbar()">--><!--                                        <span class="glyphicon glyphicon-plus"></span>--><!--                                        <span class="hidden-sm">My Grievances</span>--><!--                                    </a>--><!--                                </li>--><li ui-sref-active="active" has-any-authority="ROLE_USER"><a class="nav-bar1" ui-sref="myDisputes" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-plus"></span> <span class="hidden-sm" data-translate="global.menu.My Disputes">My Disputes</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DISPUTE_OFFICER"><a class="nav-bar1" ui-sref="disputes" ng-click="vm.collapseNavbar()"><span class="hidden-sm">Disputes</span></a></li><!--                                <li ui-sref-active="active">--><!--                                    <a class="nav-bar1" ui-sref="incentiveform"  class="dropdown-toggle" uib-dropdown-toggle href="" ng-click="vm.collapseNavbar()"--><!--                                       has-any-authority="ROLE_USER">--><!--                                        <span class="glyphicon glyphicon-folder-close"></span>--><!--                                        <span class="hidden-sm">Large/MSMEs Incentives</span>--><!--                                    </a>--><!--                                </li>--><li class="dropdown pointer" ng-class="{ \'open\': showLargeMsmeDropdown }" ng-mouseleave="showLargeMsmeDropdown = false"><a class="nav-bar1 dropdown-toggle" href="" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER"><span class="glyphicon glyphicon-folder-close"></span> <span class="hidden-sm" data-translate="global.menu.MSME Policies">MSME Policies</span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-click="showLargeMsmeDropdown = false"><a ui-sref="conversionOfBoiler" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.CAQM">CAQM</span></a></li><li ui-sref-active="active" ng-click="showLargeMsmeDropdown = false"><a ui-sref="msmePolicies" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER"><span class="hidden-sm" data-translate="global.menu.New Haryana Atamnirbhar policy schemes">New Haryana Atamnirbhar policy schemes</span></a></li><li class="dropdown-submenu" ng-mouseenter="showLargeMsmeDropdown = true" ng-mouseleave="showLargeMsmeDropdown = false"><a class="submenu-toggle" href="#"><span data-translate="global.menu.Large/MSMEs Incentives">Large/MSMEs Incentives</span></a><ul class="dropdown-menu sub-dropdown-menu" ng-show="showLargeMsmeDropdown" ng-mouseenter="showLargeMsmeDropdown = true" ng-mouseleave="showLargeMsmeDropdown = false"><li ui-sref-active="active" ng-click="showLargeMsmeDropdown = false"><a ui-sref="incentiveform" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER"><span class="hidden-sm" data-translate="global.menu.Incentives under Enterprise Promotion Policy, 2015">Incentives under Enterprise Promotion Policy, 2015</span></a></li><li ui-sref-active="active" ng-click="showLargeMsmeDropdown = false"><a ui-sref="incentiveforms({param:\'warehousing\'})" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER"><span class="hidden-sm" data-translate="global.menu.Incentives under Haryana Logistics, Warehousing & Retail Policy, 2019">Incentives under Haryana Logistics, Warehousing & Retail Policy, 2019</span></a></li><li ui-sref-active="active" ng-click="showLargeMsmeDropdown = false"><a ui-sref="incentiveforms({param:\'agriculture\'})" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER"><span class="hidden-sm" data-translate="global.menu.Incentives under Haryana Agribusiness & Food Processing Policy, 2018">Incentives under Haryana Agribusiness & Food Processing Policy, 2018</span></a></li><li ui-sref-active="active" ng-click="showLargeMsmeDropdown = false"><a ui-sref="incentiveforms({param:\'policy2019\'})" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER"><span class="hidden-sm" data-translate="global.menu.MSME Policy,2019">MSME Policy, 2019</span></a></li><li ui-sref-active="active" ng-click="showLargeMsmeDropdown = false"><a ui-sref="incentiveforms({param:\'policy2020\'})" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER"><span class="hidden-sm" data-translate="global.menu.Haryana Enterprises & Employment Policy 2020">Haryana Enterprises & Employment Policy 2020</span></a></li></ul></li></ul></li><!--                                <li  uib-dropdown class="dropdown pointer">--><!--                                    <a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href="" ng-click="vm.collapseNavbar()"--><!--                                       has-any-authority="ROLE_USER">--><!--                                        <span class="glyphicon glyphicon-folder-close"></span>--><!--                                        <span class="hidden-sm">Large/MSMEs Incentives</span>--><!--                                    </a>--><!--                                    <ul class="dropdown-menu" uib-dropdown-menu>--><!--                                        <li ui-sref-active="active">--><!--                                            <a ui-sref="incentiveform" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER">--><!--                                                <span class="hidden-sm">Incentives under Enterprise Promotion Policy, 2015</span>--><!--                                            </a>--><!--                                        </li>--><!--                                        &lt;!&ndash;<li ui-sref-active="active">&ndash;&gt;--><!--                                        &lt;!&ndash;<a ui-sref="CM_Message" ng-click="vm.collapseNavbar()">&ndash;&gt;--><!--                                        &lt;!&ndash;<span class="hidden-sm">CM Message</span>&ndash;&gt;--><!--                                        &lt;!&ndash;</a>&ndash;&gt;--><!--                                        &lt;!&ndash;</li>&ndash;&gt;--><!--                                        <li ui-sref-active="active">--><!--                                            <a ui-sref="incentiveforms({param:\'warehousing\'})" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER">--><!--                                                <span class="hidden-sm">Incentives under Haryana Logistics, Warehousing & Retail Policy, 2019</span>--><!--                                            </a>--><!--                                        </li>--><!--                                        <li ui-sref-active="active">--><!--                                            <a ui-sref="incentiveforms({param:\'agriculture\'})" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER">--><!--                                                <span class="hidden-sm">Incentives under Haryana Agribusiness & Food Processing Policy, 2018</span>--><!--                                            </a>--><!--                                        </li>--><!--                                        <li ui-sref-active="active">--><!--                                            <a ui-sref="incentiveforms({param:\'policy2019\'})" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER">--><!--                                                <span class="hidden-sm">MSME Policy,2019</span>--><!--                                            </a>--><!--                                        </li>--><!--                                        <li ui-sref-active="active">--><!--                                            <a ui-sref="incentiveforms({param:\'policy2020\'})" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER">--><!--                                                <span class="hidden-sm">Haryana Enterprises & Employment Policy 2020</span>--><!--                                            </a>--><!--                                        </li>--><!--                                    </ul>--><!--                                </li>--><li ui-sref-active="active"><a class="nav-bar1" ui-sref="incentiveformsmega" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_USER"><span class="glyphicon glyphicon-folder-close"></span> <span class="hidden-sm" data-translate="global.menu.Mega Project Incentives">Mega Project Incentives</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a class="nav-bar1" ui-sref="tracklicense" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-zoom-out"></span> <span class="hidden-sm">Track Licenses</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a class="nav-bar1" href="http://125.99.73.119:8001/bpamsclient/" target="_blank" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-file"></span> <span class="hidden-sm">Building Plan Status</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a class="nav-bar1" href="http://cisharyana.in/" target="_blank" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-file"></span> <span class="hidden-sm">Central Inspection System</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a class="nav-bar1" ui-sref="incentiveswizard" ng-click="vm.collapseNavbar()"><span><i class="fa fa-laptop"></i></span> <span class="hidden-sm">Incentive Wizard</span></a></li><!--<li ng-hide="vm.account.authorities.indexOf(\'ROLE_TOWER_ADMIN\')>-1" ui-sref-active="active" has-any-authority="ROLE_TOWER_USER">--><!--<a class="nav-bar1" uk-toggle="target: #modal-example" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-signal"></span>&nbsp;--><!--<span class="hidden-sm">Communication and Connectivity Permissions</span>--><!--</a>--><!--</li>--><!--<li ui-sref-active="active" has-any-authority="ROLE_TOWER_DC,ROLE_TOWER_DEPARTMENT,ROLE_TOWER_NODAL_OFFICER">--><!--<a class="nav-bar1"  ui-sref="towerInstallation" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-signal"></span>&nbsp;--><!--<span class="hidden-sm">Communication and Connectivity Permissions</span>--><!--</a>--><!--</li>--><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER"><a class="nav-bar1" ui-sref="cafservicestatus" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm">Caf Service Status</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_RM,ROLE_FIELD_OFFICER,ROLE_DESK_OFFICER"><a class="nav-bar1" ui-sref="viewprojectdetail({status:\'Pending\'})"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm" data-translate="global.menu.viewproject">View Project</span></a></li><li ui-sref-active="active" has-any-authority="ROLE_NODAL_OFFICER,ROLE_FILM_OFFICER,ROLE_FILM_SUBOFFICER"><a class="nav-bar1" ui-sref="nodalofficerviewprojectdetail({status:\'Pending\'})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-inbox"></span> <span class="hidden-sm">Show Projects</span></a></li><!--<li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER">--><!--<a class="nav-bar1" ui-sref="dashboard" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-briefcase"></span>--><!--<span class="hidden-sm" data-translate="global.menu.dashboard">Dashboard</span>--><!--</a>--><!--</li>--><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_HEPC_MONITORING_OFFICER,ROLE_DESK_OFFICER"><a class="nav-bar1" ui-sref="newservicedashboard" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm" data-translate="">Average Service Clearance</span></a></li><!--<li ui-sref-active="active" has-any-authority="ROLE_USER">--><!--<a class="nav-bar1" ui-sref="grievancelist" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-plus"></span>--><!--<span class="hidden-sm" data-translate="global.menu.grievanceuser">My Grievances</span>--><!--</a>--><!--</li>--><!--                                <li ui-sref-active="active" has-any-authority="ROLE_GRIEVANCE_ADMIN">--><!--                                    <a class="nav-bar1" ui-sref="grievancelistadmin" ng-click="vm.collapseNavbar()">--><!--                                        <span class="glyphicon glyphicon-plus"></span>--><!--                                        <span class="hidden-sm" data-translate="global.menu.grievanceadmin">Grievance Redressal</span>--><!--                                    </a>--><!--                                </li>--><!--                                <li ui-sref-active="active" has-any-authority="ROLE_GRIEVANCE_OFFICER">--><!--                                    <a class="nav-bar1" ui-sref="grievancelistofficer" ng-click="vm.collapseNavbar()">--><!--                                        <span class="glyphicon glyphicon-plus"></span>--><!--                                        <span class="hidden-sm" data-translate="global.menu.grievanceofficer">Grievance Redressal</span>--><!--                                    </a>--><!--                                </li>--><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_HEPC_MONITORING_OFFICER"><a class="nav-bar1" ui-sref="datewiseDeptDashboard" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm">Datewise Dept Dashboard</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="servicedashboardyearly" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm">Service Dashboard</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="newservicedashboardyearly" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm">New Service Dashboard</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="intent-to-invest-dashboard" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm">Intent To Invest Dashboard</span></a></li><!-- EODB Dashboard link hidden - the state itself is untouched and still reachable at #/service-dashboard-yearly\n                                <li ui-sref-active="active">\n                                    <a class="nav-bar1" ui-sref="eodbdashboardyearly" ng-click="vm.collapseNavbar()"\n                                       has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_NODAL_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER">\n                                        <span class="glyphicon glyphicon-briefcase"></span>\n                                        <span class="hidden-sm">EODB Dashboard</span>\n                                    </a>\n                                </li>\n                                --><!-- Public dashboard: intentionally not role gated, it is reachable logged out too --><li ui-sref-active="active"><a class="nav-bar1" ui-sref="eodbpublicdashboard" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm">EODB Public Dashboard</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="pstowerdashboard" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm" data-translate="global.menu.CCIP Dashboard">CCIP Dashboard</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="viewsurveyformfortowerofficer" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_TOWER_OFFICER"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm">Survey Form Dashboard</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="viewsurveyformfordc" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_TOWER_DC"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm">Survey Form Dashboard</span></a></li><li ui-sref-active="active"><a has-any-authority="ROLE_USER" class="nav-bar1" ui-sref="listcompliances" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm" data-translate="global.menu.Compliance Dashboard">Compliance Dashboard</span></a></li><!--<li ui-sref-active="active">--><!--<a class="nav-bar1" ui-sref="servicedashboard" ng-click="vm.collapseNavbar()"--><!--has-any-authority="ROLE_ADMIN">--><!--<span class="glyphicon glyphicon-briefcase"></span>--><!--<span class="hidden-sm">Service Dashboard</span>--><!--</a>--><!--</li>--><!--                                <li ui-sref-active="active">--><!--                                    <a class="nav-bar1" ui-sref="grievancedashboard" ng-click="vm.collapseNavbar()"--><!--                                       has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER,ROLE_MONITORING_OFFICER,ROLE_HEPC_MONITORING_OFFICER">--><!--                                        <span class="glyphicon glyphicon-briefcase"></span>--><!--                                        <span class="hidden-sm">Grievance Dashboard</span>--><!--                                    </a>--><!--                                </li>--><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DISPUTE_OFFICER"><a class="nav-bar1" ui-sref="disputeDashboard" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-briefcase"></span> <span class="hidden-sm">Dispute Dashboard</span></a></li><!--<li ui-sref-active="active">--><!--<a class="nav-bar1" ui-sref="powerdashboard" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-briefcase"></span>--><!--<span class="hidden-sm">Power Dashboard</span>--><!--</a>--><!--</li>--><li ui-sref-active="active"><a class="nav-bar1" ui-sref="draft-policy" ng-click="vm.collapseNavbar()" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_HEPC_MONITORING_OFFICER"><span class="glyphicon glyphicon-file"></span> <span class="hidden-sm">Draft Policy</span></a></li><li ng-switch-when="false"><a class="nav-bar1" ui-sref="policyFeedbackDashboard" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span> Policy Feedback</a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="viewServiceStatus" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span> <span data-translate="global.menu.View Service Status">View Service Status</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="shopMoveCaf" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span> Shop Move Data To Excise</a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="totalSkills" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_SKILLS_REQUIREMENT_OFFICER" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span> Skills Required</a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="feedbacksbyofficer" has-any-authority="ROLE_FEEDBACK_OFFICER,ROLE_NODAL_OFFICER" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span> Feedbacks</a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="viewUserServiceStatus" ng-hide="vm.account.authorities.indexOf(\'ROLE_ADMIN\')>-1 || vm.account.authorities.indexOf(\'ROLE_SUB_ADMIN\')>-1" has-authority="ROLE_USER" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span> <span data-translate="global.menu.View Service Status">View Service Status</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="scheduledList" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-eye-open"></span> Single Inspection System</a></li><!--ROLE_ACCOUNT_OFFICER,--><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_ACCOUNT_OFFICER,ROLE_HEPC_MONITORING_OFFICER"><a class="nav-bar1" ui-sref="viewpayments({disbursed:false})" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-piggy-bank"></span> <span class="hidden-sm">View Payments</span></a></li><li uib-dropdown class="dropdown pointer" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_ASSIGNRM_OFFICER"><a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href=""><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">Assign Users</span></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_ASSIGNRM_OFFICER"><a ui-sref="assignProjectToRM" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm">Assign Project To RM</span></a></li><!--<li ui-sref-active="active" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN">--><!--<a ui-sref="assignFieldOfficerToDepartment" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-briefcase"></span>--><!--<span class="hidden-sm" data-translate="">Assign FieldOfficer To Department</span>--><!--</a>--><!--</li>--></ul></li><li ng-class="{active: vm.$state.includes(\'entity\')}" ng-switch-when="true" uib-dropdown class="dropdown pointer" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN"><!--<a class="dropdown-toggle" uib-dropdown-toggle href="" id="entity-menu">--><!--<span>--><!--<span class="glyphicon glyphicon-th-list"></span>--><!--<span class="hidden-sm" data-translate="global.menu.entities.main">--><!--Entities--><!--</span>--><!--<b class="caret"></b>--><!--</span>--><!--</a>--><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="department" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.department">Department</span></a></li><li ui-sref-active="active"><a ui-sref="assign-service-fee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.assignServiceFee">Assign Service Fee</span></a></li><li ui-sref-active="active"><a ui-sref="department-service" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.departmentService">Department Service</span></a></li><li ui-sref-active="active"><a ui-sref="service-form-field" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.serviceFormField">Service Form Field</span></a></li><li ui-sref-active="active"><a ui-sref="country" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.country">Country</span></a></li><li ui-sref-active="active"><a ui-sref="state" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.state">State</span></a></li><li ui-sref-active="active"><a ui-sref="district" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.district">District</span></a></li><li ui-sref-active="active"><a ui-sref="block" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.block">Block</span></a></li><li ui-sref-active="active"><a ui-sref="city-town-village" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.cityTownVillage">City Town Village</span></a></li><li ui-sref-active="active"><a ui-sref="tehsil-subtehsil" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.tehsilSubtehsil">Tehsil Subtehsil</span></a></li><li ui-sref-active="active"><a ui-sref="connectingroad" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.connectingroad">Connectingroad</span></a></li><li ui-sref-active="active"><a ui-sref="landusezoneclassification" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.landusezoneclassification">Landusezoneclassification</span></a></li><li ui-sref-active="active"><a ui-sref="sector" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.sector">Sector</span></a></li><li ui-sref-active="active"><a ui-sref="industrysize" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.industrysize">Industrysize</span></a></li><li ui-sref-active="active"><a ui-sref="projectype" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectype">Projectype</span></a></li><li ui-sref-active="active"><a ui-sref="projectcategory" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectcategory">Projectcategory</span></a></li><li ui-sref-active="active"><a ui-sref="approvalforms" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.approvalforms">Approvalforms</span></a></li><li ui-sref-active="active"><a ui-sref="foreignfundingresource" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.foreignfundingresource">Foreignfundingresource</span></a></li><li ui-sref-active="active"><a ui-sref="manufacturingunits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.manufacturingunits">Manufacturingunits</span></a></li><li ui-sref-active="active"><a ui-sref="watersupplysource" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.watersupplysource">Watersupplysource</span></a></li><li ui-sref-active="active"><a ui-sref="modeofdisposalfor-discharge" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.modeofdisposalforDischarge">Modeofdisposalfor Discharge</span></a></li><li ui-sref-active="active"><a ui-sref="particular" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.particular">Particular</span></a></li><li ui-sref-active="active"><a ui-sref="emmision-fuel-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.emmisionFuelType">Emmision Fuel Type</span></a></li><li ui-sref-active="active"><a ui-sref="emmision-pollution-controll" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.emmisionPollutionControll">Emmision Pollution Controll</span></a></li><li ui-sref-active="active"><a ui-sref="waste-water-naturetype" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.wasteWaterNaturetype">Waste Water Naturetype</span></a></li><li ui-sref-active="active"><a ui-sref="waste-water-disposal-mode" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.wasteWaterDisposalMode">Waste Water Disposal Mode</span></a></li><li ui-sref-active="active"><a ui-sref="regular-electrict-load-type" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.regularElectrictLoadType">Regular Electrict Load Type</span></a></li><li ui-sref-active="active"><a ui-sref="investor" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.investor">Investor</span></a></li><!--<li ui-sref-active="active">--><!--<a ui-sref="businessentity" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-asterisk"></span>&nbsp;--><!--<span data-translate="global.menu.entities.businessentity">Businessentity</span>--><!--</a>--><!--</li>--><li ui-sref-active="active"><a ui-sref="companydetail" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.companydetail">Companydetail</span></a></li><li ui-sref-active="active"><a ui-sref="projectdetail" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectdetail">Projectdetail</span></a></li><li ui-sref-active="active"><a ui-sref="projectsitedetail" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectsitedetail">Projectsitedetail</span></a></li><li ui-sref-active="active"><a ui-sref="project-finance-investment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectFinanceInvestment">Project Finance Investment</span></a></li><li ui-sref-active="active"><a ui-sref="project-phase" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectPhase">Project Phase</span></a></li><li ui-sref-active="active"><a ui-sref="projectrawmaterial" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectrawmaterial">Projectrawmaterial</span></a></li><li ui-sref-active="active"><a ui-sref="projectproduct" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectproduct">Projectproduct</span></a></li><li ui-sref-active="active"><a ui-sref="projectprocessflowsteps" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectprocessflowsteps">Projectprocessflowsteps</span></a></li><li ui-sref-active="active"><a ui-sref="manufacturingdetail" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.manufacturingdetail">Manufacturingdetail</span></a></li><li ui-sref-active="active"><a ui-sref="emissiondetail" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.emissiondetail">Emissiondetail</span></a></li><li ui-sref-active="active"><a ui-sref="wastewaterdetail" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.wastewaterdetail">Wastewaterdetail</span></a></li><li ui-sref-active="active"><a ui-sref="environment-impactdetail" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.environmentImpactdetail">Environment Impactdetail</span></a></li><li ui-sref-active="active"><a ui-sref="electricrequirement" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.electricrequirement">Electricrequirement</span></a></li><li ui-sref-active="active"><a ui-sref="term-declaration-accept" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.termDeclarationAccept">Term Declaration Accept</span></a></li><li ui-sref-active="active"><a ui-sref="projectdetailcombinecodes" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectdetailcombinecodes">Projectdetailcombinecodes</span></a></li><li ui-sref-active="active"><a ui-sref="wwtreatmentone" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.wwtreatmentone">Wwtreatmentone</span></a></li><li ui-sref-active="active"><a ui-sref="wwtreatmenttwo" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.wwtreatmenttwo">Wwtreatmenttwo</span></a></li><li ui-sref-active="active"><a ui-sref="wwtreatmentthree" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.wwtreatmentthree">Wwtreatmentthree</span></a></li><li ui-sref-active="active"><a ui-sref="projectservicedetail" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectservicedetail">Projectservicedetail</span></a></li><li ui-sref-active="active"><a ui-sref="departmentservice" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.departmentservice">Departmentservice</span></a></li><li ui-sref-active="active"><a ui-sref="businessentitys" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.businessentitys">Businessentitys</span></a></li><li ui-sref-active="active"><a ui-sref="project-service-report-info" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectServiceReportInfo">Project Service Report Info</span></a></li><li ui-sref-active="active"><a ui-sref="projectserviceformfielddata" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectserviceformfielddata">Projectserviceformfielddata</span></a></li><li ui-sref-active="active"><a ui-sref="project-attachemnt" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectAttachemnt">Project Attachemnt</span></a></li><li ui-sref-active="active"><a ui-sref="project-service-log" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectServiceLog">Project Service Log</span></a></li><li ui-sref-active="active"><a ui-sref="project-service-payment-details" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectServicePaymentDetails">Project Service Payment Details</span></a></li><li ui-sref-active="active"><a ui-sref="assign-project-to-rm" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.assignProjectToRm">Assign Project To Rm</span></a></li><li ui-sref-active="active"><a ui-sref="extended-user-information" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.extendedUserInformation">Extended User Information</span></a></li><li ui-sref-active="active"><a ui-sref="assign-field-officer-to-department" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.assignFieldOfficerToDepartment">Assign Field Officer To Department</span></a></li><li ui-sref-active="active"><a ui-sref="caf-attachment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.cafAttachment">Caf Attachment</span></a></li><li ui-sref-active="active"><a ui-sref="district-nodal-officer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.districtNodalOfficer">District Nodal Officer</span></a></li><li ui-sref-active="active"><a ui-sref="district-field-officer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.districtFieldOfficer">District Field Officer</span></a></li><li ui-sref-active="active"><a ui-sref="customertype" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.customertype">Customertype</span></a></li><li ui-sref-active="active"><a ui-sref="district-desk-officer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.districtDeskOfficer">District Desk Officer</span></a></li><li ui-sref-active="active"><a ui-sref="projectlog" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectlog">Projectlog</span></a></li><li ui-sref-active="active"><a ui-sref="notification" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.notification">Notification</span></a></li><li ui-sref-active="active"><a ui-sref="service-form-attachments" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.serviceFormAttachments">Service Form Attachments</span></a></li><li ui-sref-active="active"><a ui-sref="serviceformdocs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.serviceformdocs">Serviceformdocs</span></a></li><li ui-sref-active="active"><a ui-sref="service-form-field" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.serviceFormField">Service Form Field</span></a></li><li ui-sref-active="active"><a ui-sref="minutesofmeeting" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.minutesofmeeting">Minutesofmeeting</span></a></li><li ui-sref-active="active"><a ui-sref="grievance" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.grievance">Grievance</span></a></li><li ui-sref-active="active"><a ui-sref="grievance-assign" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.grievanceAssign">Grievance Assign</span></a></li><li ui-sref-active="active"><a ui-sref="grievance-log" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.grievanceLog">Grievance Log</span></a></li><li ui-sref-active="active"><a ui-sref="renewable-caf" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.renewableCaf">Renewable Caf</span></a></li><li ui-sref-active="active"><a ui-sref="department-service" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.departmentService">Department Service</span></a></li><li ui-sref-active="active"><a ui-sref="landrequirementcaf" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.landrequirementcaf">Landrequirementcaf</span></a></li><li ui-sref-active="active"><a ui-sref="projectservicedetail" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectservicedetail">Projectservicedetail</span></a></li><li ui-sref-active="active"><a ui-sref="acknowledgements" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.acknowledgements">Acknowledgements</span></a></li><li ui-sref-active="active"><a ui-sref="above-ground" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.aboveGround">Above Ground</span></a></li><li ui-sref-active="active"><a ui-sref="below-ground" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.belowGround">Below Ground</span></a></li><li ui-sref-active="active"><a ui-sref="project" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.project">Project</span></a></li><li ui-sref-active="active"><a ui-sref="tower-log" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.towerLog">Tower Log</span></a></li><li ui-sref-active="active"><a ui-sref="zone" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.zone">Zone</span></a></li><li ui-sref-active="active"><a ui-sref="tower-dc" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.towerDc">Tower Dc</span></a></li><li ui-sref-active="active"><a ui-sref="service-dashboard-output" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.serviceDashboardOutput">Service Dashboard Output</span></a> <a ui-sref="rmlist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.rmlist">Rmlist</span></a></li><li ui-sref-active="active"><a ui-sref="deemed-clearance-approval" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.deemedClearanceApproval">Deemed Clearance Approval</span></a></li><li ui-sref-active="active"><a ui-sref="meeting-attendance" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.meetingAttendance">Meeting Attendance</span></a></li><li ui-sref-active="active"><a ui-sref="meeting-attendee" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.meetingAttendee">Meeting Attendee</span></a></li><li ui-sref-active="active"><a ui-sref="grievance-dashboard-output" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.grievanceDashboardOutput">Grievance Dashboard Output</span></a></li><li ui-sref-active="active"><a ui-sref="towerservice-no" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.towerserviceNo">Towerservice No</span> </a><a ui-sref="towerdclist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.towerdclist">Towerdclist</span></a></li><li ui-sref-active="active"><a ui-sref="towerservice-no" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.towerserviceNo">Towerservice No</span></a></li><li ui-sref-active="active"><a ui-sref="construction-permit-approval-steps" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.constructionPermitApprovalSteps">Construction Permit Approval Steps</span></a></li><li ui-sref-active="active"><a ui-sref="aai" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.aai">Aai</span></a></li><li ui-sref-active="active"><a ui-sref="nma" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.nma">Nma</span></a></li><li ui-sref-active="active"><a ui-sref="construction-permit-log" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.constructionPermitLog">Construction Permit Log</span></a></li><li ui-sref-active="active"><a ui-sref="inspection-report" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.inspectionReport">Inspection Report</span></a></li><li ui-sref-active="active"><a ui-sref="factoty-plan" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.factotyPlan">Factoty Plan</span> </a><a ui-sref="towerdiolist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.towerdiolist">Towerdiolist</span></a></li><li ui-sref-active="active"><a ui-sref="hudaform-oc" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.hudaformOc">Hudaform Oc</span></a></li><li ui-sref-active="active"><a ui-sref="huda-form" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.hudaForm">Huda Form</span></a></li><li ui-sref-active="active"><a ui-sref="totalservicedashboarddetails" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.totalservicedashboarddetails">Totalservicedashboarddetails</span></a></li><li ui-sref-active="active"><a ui-sref="cafsfornodalofficer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.cafsfornodalofficer">Cafsfornodalofficer</span></a></li><li ui-sref-active="active"><a ui-sref="visitor-count" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.visitorCount">Visitor Count</span></a></li><li ui-sref-active="active"><a ui-sref="landexchange" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.landexchange">Landexchange</span></a></li><li ui-sref-active="active"><a ui-sref="municipality" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.municipality">Municipality</span></a></li><li ui-sref-active="active"><a ui-sref="tower-service-dashboard" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.towerServiceDashboard">Tower Service Dashboard</span> </a><a ui-sref="towerofficerlist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.towerofficerlist">Towerofficerlist</span></a></li><li ui-sref-active="active"><a ui-sref="new-dasboard-stats" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.newDasboardStats">New Dasboard Stats</span></a></li><li ui-sref-active="active"><a ui-sref="new-dasboard-all-completed-stats" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.newDasboardAllCompletedStats">New Dasboard All Completed Stats</span> </a><a ui-sref="service-dashboard-output" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.serviceDashboardOutput">Service Dashboard Output</span></a></li><li ui-sref-active="active"><a ui-sref="checklist" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.checklist">Checklist</span></a></li><li ui-sref-active="active"><a ui-sref="user-authorization" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.userAuthorization">User Authorization</span></a></li><li ui-sref-active="active"><a ui-sref="re-apply-dashboard" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.reApplyDashboard">Re Apply Dashboard</span></a></li><li ui-sref-active="active"><a ui-sref="project-service-log" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectServiceLog">Project Service Log</span></a></li><li ui-sref-active="active"><a ui-sref="survey" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.survey">Survey</span> </a><a ui-sref="draft-policy" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.draftPolicy">Draft Policy</span></a></li><li ui-sref-active="active"><a ui-sref="policy-details" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.policyDetails">Policy Details</span></a></li><li ui-sref-active="active"><a ui-sref="district-village-block-mapping" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.districtVillageBlockMapping">District Village Block Mapping</span></a></li><li ui-sref-active="active"><a ui-sref="rating" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.rating">Rating</span></a></li><li ui-sref-active="active"><a ui-sref="service-status" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.serviceStatus">Service Status</span></a></li><li ui-sref-active="active"><a ui-sref="service-level" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.serviceLevel">Service Level</span></a></li><li ui-sref-active="active"><a ui-sref="tickets" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.tickets">Tickets</span></a></li><li ui-sref-active="active"><a ui-sref="tickets-logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ticketsLogs">Tickets Logs</span></a></li><li ui-sref-active="active"><a ui-sref="tickets-customer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.ticketsCustomer">Tickets Customer</span></a></li><li ui-sref-active="active"><a ui-sref="nmatoken" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.nmatoken">Nmatoken</span></a></li><li ui-sref-active="active"><a ui-sref="serviceformdraftsaved" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.serviceformdraftsaved">Serviceformdraftsaved</span></a></li><li ui-sref-active="active"><a ui-sref="applicationstatus" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.applicationstatus">Applicationstatus</span></a></li><li ui-sref-active="active"><a ui-sref="scheduled-visits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.scheduledVisits">Scheduled Visits</span></a></li><li ui-sref-active="active"><a ui-sref="inspector-details" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.inspectorDetails">Inspector Details</span></a></li><li ui-sref-active="active"><a ui-sref="feedback-officer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.feedbackOfficer">Feedback Officer</span></a></li><li ui-sref-active="active"><a ui-sref="hepc-recruitment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.hepcRecruitment">Hepc Recruitment</span></a></li><li ui-sref-active="active"><a ui-sref="hepc-recruitment-qualifications" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.hepcRecruitmentQualifications">Hepc Recruitment Qualifications</span></a></li><li ui-sref-active="active"><a ui-sref="hepc-recruitment-experience" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.hepcRecruitmentExperience">Hepc Recruitment Experience</span></a></li><li ui-sref-active="active"><a ui-sref="estate-manager" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.estateManager">Estate Manager</span></a></li><li ui-sref-active="active"><a ui-sref="estate" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.estate">Estate</span></a></li><li ui-sref-active="active"><a ui-sref="project" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.project">Project</span></a></li><li ui-sref-active="active"><a ui-sref="cafsfornodalofficer" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.cafsfornodalofficer">Cafsfornodalofficer</span></a></li><li ui-sref-active="active"><a ui-sref="municipals" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.municipals">Municipals</span></a></li><li ui-sref-active="active"><a ui-sref="dispute" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.dispute">Dispute</span></a></li><li ui-sref-active="active"><a ui-sref="dispute-attachment" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.disputeAttachment">Dispute Attachment</span></a></li><li ui-sref-active="active"><a ui-sref="disputelog" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.disputelog">Disputelog</span></a></li><li ui-sref-active="active"><a ui-sref="skills-data" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.skillsData">Skills Data</span></a></li><li ui-sref-active="active"><a ui-sref="project-skills" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.projectSkills">Project Skills</span></a></li><li ui-sref-active="active"><a ui-sref="caf-otp" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.cafOtp">Caf Otp</span></a></li><li ui-sref-active="active"><a ui-sref="caf-with-no-service" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.cafWithNoService">Caf With No Service</span></a></li><li ui-sref-active="active"><a ui-sref="municipal-payment-params" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.municipalPaymentParams">Municipal Payment Params</span></a></li><li ui-sref-active="active"><a ui-sref="supply-and-disposal" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.supplyAndDisposal">Supply And Disposal</span></a></li><li ui-sref-active="active"><a ui-sref="home-project-service-details" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.homeProjectServiceDetails">Home Project Service Details</span></a></li><li ui-sref-active="active"><a ui-sref="shop-u-lb-department-logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.shopULbDepartmentLogs">Shop U Lb Department Logs</span></a></li><li ui-sref-active="active"><a ui-sref="excise-service-form-filled" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.exciseServiceFormFilled">Excise Service Form Filled</span></a></li><li ui-sref-active="active"><a ui-sref="backup-project-service-log" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.backupProjectServiceLog">Backup Project Service Log</span></a></li><li ui-sref-active="active"><a ui-sref="incentive-wizard-rule" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.incentiveWizardRule">Incentive Wizard Rule</span></a></li><li ui-sref-active="active"><a ui-sref="incentive-block-mapping" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.incentiveBlockMapping">Incentive Block Mapping</span></a></li><li ui-sref-active="active"><a ui-sref="center-tower-user-data" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.centerTowerUserData">Center Tower User Data</span></a></li><li ui-sref-active="active"><a ui-sref="row-business-entity" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.rowBusinessEntity">Row Business Entity</span></a></li><li ui-sref-active="active"><a ui-sref="nsws-user-details" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.nswsUserDetails">Nsws User Details</span></a></li><li ui-sref-active="active"><a ui-sref="tower-service-no-require" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.towerServiceNoRequire">Tower Service No Require</span></a></li><li ui-sref-active="active"><a ui-sref="tower-update-department" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-asterisk"></span>&nbsp; <span data-translate="global.menu.entities.towerUpdateDepartment">Tower Update Department</span></a></li><!-- jhipster-needle-add-entity-to-menu - JHipster will add entities to the menu here --></ul></li><li ng-show="vm.isAuthenticated()==false"><a target="_blank" href="http://hsiidcgis.org.in/hsiidcgis/" class="nav-bar1">Land Bank</a></li><li ng-class="{active: vm.$state.includes(\'account\')}" uib-dropdown class="dropdown pointer"><a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href="" id="account-menu"><span><span class="glyphicon glyphicon-user"></span> <span class="hidden-sm" data-translate="global.menu.account.main">Account</span></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="settings" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-wrench"></span>&nbsp; <span data-translate="global.menu.account.settings">Settings</span></a></li><li ui-sref-active="active" ng-switch-when="true"><a ui-sref="password" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-lock"></span>&nbsp; <span data-translate="global.menu.account.password"></span></a></li><li ui-sref-active="active" ng-switch-when="true"><a href="" ng-click="vm.logout()" id="logout"><span class="glyphicon glyphicon-log-out"></span>&nbsp; <span data-translate="global.menu.account.logout">Sign out</span></a></li><li ui-sref-active="active" ng-switch-when="false"><a href="" ng-click="vm.login()" id="login"><span class="glyphicon glyphicon-log-in"></span>&nbsp; <span data-translate="global.menu.account.login">Sign in</span></a></li><!--<li ui-sref-active="active" ng-switch-when="false">--><!--<a ui-sref="register" ng-click="vm.collapseNavbar()">--><!--<span class="glyphicon glyphicon-plus-sign"></span>&nbsp;--><!--<span data-translate="global.menu.account.register">Register</span>--><!--</a>--><!--</li>--></ul></li><li ng-switch-when="false" ui-sref-active="active" style="border-right: 1px solid transparent"><a ui-sref="eodb" class="nav-bar1">EODB</a></li><li has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN,ROLE_DESK_OFFICER" ui-sref-active="active" style="border-right: 1px solid transparent"><a ui-sref="meeting-attendance" class="nav-bar1">Attendance</a></li><li has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN" ui-sref-active="active" style="border-right: 1px solid transparent"><a ui-sref="moveCaf({type:\'caf\'})" class="nav-bar1">Move Data</a></li><li ng-switch-when="false" style="border-right: 1px solid transparent"><a ui-sref="contact_us" class="nav-bar1">Contact Us</a></li><li has-authority="ROLE_API_VIEWER"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><li ng-class="{active: vm.$state.includes(\'admin\')}" ng-switch-when="true" has-any-authority="ROLE_ADMIN,ROLE_SUB_ADMIN" uib-dropdown class="dropdown pointer"><a class="nav-bar1" class="dropdown-toggle" uib-dropdown-toggle href="" id="admin-menu"><span><span class="glyphicon glyphicon-tower"></span> <span class="hidden-sm" data-translate="global.menu.admin.main">Administration</span></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active"><a ui-sref="user-management" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-user"></span>&nbsp; <span data-translate="global.menu.admin.userManagement">User management</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="jhi-metrics" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-dashboard"></span>&nbsp; <span data-translate="global.menu.admin.metrics">Metrics</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="jhi-health" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-heart"></span>&nbsp; <span data-translate="global.menu.admin.health">Health</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="jhi-configuration" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-list-alt"></span>&nbsp; <span data-translate="global.menu.admin.configuration">Configuration</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="audits" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-bell"></span>&nbsp; <span data-translate="global.menu.admin.audits">Audits</span></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="logs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-tasks"></span>&nbsp; <span data-translate="global.menu.admin.logs">Logs</span></a></li><li ng-show="vm.swaggerEnabled" ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="docs" ng-click="vm.collapseNavbar()"><span class="glyphicon glyphicon-book"></span>&nbsp; <span data-translate="global.menu.admin.apidocs">API</span></a></li><!-- jhipster-needle-add-element-to-admin-menu - JHipster will add entities to the admin menu here --></ul></li><li><a class="nav-bar1" ui-sref="document-center" ng-click="vm.collapseNavbar()"><!--<span class="glyphicon glyphicon-home"></span>--> <span class="hidden-sm">Document Center</span></a></li><li has-any-authority="ROLE_ADMIN" ui-sref-active="active" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"><!--<a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1">--><!--<span>--><!--<span class="glyphicon glyphicon-flag"></span>--><!--<span class="hidden-sm" data-translate="global.menu.language">Language</span>--><!--<b class="caret"></b>--><!--</span>--><!--</a>--><ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"><li active-menu="{{language}}" ng-repeat="language in languageVm.languages"><a href="" ng-click="languageVm.changeLanguage(language);vm.collapseNavbar();">{{language | findLanguageFromKey}}</a></li></ul></li></ul></div></div></div></nav></div></body></html></div><!--    <nav class="mainmenu_wrapper" style="margin-bottom: 5px; max-height: 60px; background:#A0233D !important;" ng-switch-when="false">--><!--        <header class="page_header">--><!--            <div class="navbar-collapse">--><!--                <ul ng-click="vm.toggleMenu()" class="mainmenu nav sf-menu" style="margin-top: 15px; display: ruby-text">--><!--                    <li><a ui-sref="home"><span style="padding-left: 120px; font-size: medium;">Home</span></a></li>--><!--                    <li><a ui-sref="aboutHEPC"><span style="font-size: medium">About Us</span></a>--><!--                        <ul class="gradient_bg_color1">--><!--                            <li ui-sref-active="active">--><!--                                <a ui-sref="about" ng-click="vm.collapseNavbar()">--><!--                                    <span>About HEPC</span>--><!--                                </a>--><!--                            </li>--><!--                            <li ui-sref-active="active">--><!--                                <a target="_blank"--><!--                                   href="../../../content/pdfs/List of Officers and Employees of HEPC.pdf">HEPC Staff--><!--                                </a></li>--><!--                            &lt;!&ndash;<li ui-sref-active="active">&ndash;&gt;--><!--                            &lt;!&ndash;<a ui-sref="CM_Message" ng-click="vm.collapseNavbar()">&ndash;&gt;--><!--                            &lt;!&ndash;<span>CM Message</span>&ndash;&gt;--><!--                            &lt;!&ndash;</a>&ndash;&gt;--><!--                            &lt;!&ndash;</li>&ndash;&gt;--><!--                            <li ui-sref-active="active">--><!--                                <a ui-sref="mission" ng-click="vm.collapseNavbar()">--><!--                                    <span>Mission & Vision</span>--><!--                                </a>--><!--                            </li>--><!--                            <li ui-sref-active="active">--><!--                                <a ui-sref="org_structure" ng-click="vm.collapseNavbar()">--><!--                                    <span>Organization Structure</span>--><!--                                </a>--><!--                            </li>--><!--                            <li ui-sref-active="active">--><!--                                <a ui-sref="eodb" ng-click="vm.collapseNavbar()">--><!--                                    <span class="hidden-sm">EODB</span>--><!--                                </a>--><!--                            </li>--><!--                        </ul>--><!--                    </li>--><!--                    <li><a style="font-size: medium">Why Haryana</a>--><!--                        <ul class="gradient_bg_color2">--><!--                            <li><a ui-sref="booming_economy"><span>Booming Economy</span></a></li>--><!--                            <li><a ui-sref="conducive_ecosystem"><span>Conducive Ecosystem</span></a></li>--><!--                            <li><a ui-sref="industrial_powerhouse"><span>Industrial Powerhouse</span></a></li>--><!--                            <li><a href="../../../content/pdfs/KnewmoreaboutHEPC.pdf" target="_blank">Know more about HEPC</a></li>--><!--                            <li><a ui-sref="qualityOfLife"><span>Quality Of Life</span></a></li>--><!--                            <li><a href="../../../content/pdfs/HEPC-25_Reasons_To_invest_in_Haryana_Booklet.pdf" target="_blank">Reasons To Invest In Haryana</a></li>--><!--                            <li><a ui-sref="supportive_government"><span>Supportive Government</span></a></li>--><!--                            <li><a><span>Thrust Sector</span></a>--><!--                                <ul class="dropdown-submenu gradient_bg_color1">--><!--                                    <li><a ui-sref="agriculture">Agro & Food Processing</a></li>--><!--                                    <li><a>Auto & Auto Components</a></li>--><!--                                    <li><a ui-sref="defence">Defence & Aerospace</a></li>--><!--                                    <li><a ui-sref="electronicsAndInfo">Electronics & IT/ITES</a></li>--><!--                                    <li><a ui-sref="footwearAndAccessory">Footwear & Accessories</a></li>--><!--                                    <li><a ui-sref="pharmaceuticalAndChemical">Pharmaceutical & Chemical</a></li>--><!--                                    <li><a ui-sref="renewable">Renewable Energy & Solar Parks</a></li>--><!--                                    <li><a ui-sref="textile">Textiles & Apparels</a></li>--><!--                                </ul>--><!--                            </li>--><!--                            &lt;!&ndash;                                                <li><a href="../../../content/pdfs/HEPC-Invest-haryana.pdf"><span>What Investors Speak</span></a></li>&ndash;&gt;--><!--                        </ul>--><!--                    </li>--><!--                    <li><a style="font-size: medium">Investor Services</a>--><!--                        <ul class="gradient_bg_color3">--><!--                            <li><a ui-sref="investorfacilitationcell"><span>Apply for services</span></a></li>--><!--                            <li><a href="http://125.99.73.119:8001/bpamsclient/" target="_blank"><span>Building Plan Status</span></a></li>--><!--                            <li><a href="http://cisharyana.in/"--><!--                                   target="_blank"><span>Central Inspection System</span></a></li>--><!--                            &lt;!&ndash;                                                <li><a href="http://dcmsme.gov.in/dips/state_wise_profile_16-17/HARYANA%20State%20Profile.pdf" target="_blank">Haryana State Industrial Profile</a></li>&ndash;&gt;--><!--                            &lt;!&ndash;                                                <li><a href=" http://haryanacsr.org/" target="_blank">Haryana CSR Advisory Board</a></li>&ndash;&gt;--><!--                            <li><a href="../../../content/pdfs/UserManualForAvailingService.pdf"><span>Investor User Manual</span></a></li>--><!--                            &lt;!&ndash;                                                <li><a href="../../../content/pdfs/HEPC-Investors-Handbook.pdf"><span>Investors Handbook</span></a></li>&ndash;&gt;--><!--                            <li><a ui-sref="Questionnaire"><span>Know Your Clearance</span></a></li>--><!--                            <li><a ui-sref="procedures&Checklist"><span>Procedures and Checklists</span></a></li>--><!--                            &lt;!&ndash;                                                <li><a ui-sref="searchTowerCAF" ng-click="vm.collapseNavbar()">Tower Services Clearance Status By CAF PIN</a></li>&ndash;&gt;--><!--                            <li><a ui-sref="incentiveswizard"><span>Know Your Incentives</span></a></li>--><!--                            <li><a href="http://hsiidcgis.org.in/hsiidcgis/" target="_blank"><span>Land Bank Availability</span></a></li>--><!--                            <li><a><span>Levies Imposed By State & Local Bodies</span></a>--><!--                                <ul class="dropdown-submenu gradient_bg_color1">--><!--                                    <li><a href="../../../content/pdfs/Professional Tax- Haryana.pdf">Professional Tax- Haryana</a></li>--><!--                                    <li><a href="../../../content/pdfs/Taxes and Levies in Haryana.pdf">State Levies</a></li>--><!--                                    &lt;!&ndash;<li><a href="../../../content/pdfs/State Excise Duty-Department of Excise & Taxation.pdf">State Excise Duty-Department of Excise & Taxation</a></li>&ndash;&gt;--><!--                                    &lt;!&ndash;<li><a href="http://uhbvn.org.in/staticContent/documents/circular/SC2000/SC_U_12_2000.pdf" target="_blank"><span>Taxes & Duties on Electricity</span></a></li>&ndash;&gt;--><!--                                    &lt;!&ndash;<li><a><span>Stamp & Registration Fee</span></a>&ndash;&gt;--><!--                                    &lt;!&ndash;<ul class="dropdown-submenu gradient_bg_color1">&ndash;&gt;--><!--                                    &lt;!&ndash;<li><a href="http://jamabandi.nic.in/Docs/SDRates.pdf" target="_blank"><span>Rates of Stamp Duty Calculation</span></a></li>&ndash;&gt;--><!--                                    &lt;!&ndash;<li><a href="http://jamabandi.nic.in/Docs/Registration%20Fee.pdf" target="_blank"><span>Rates of Registration Fee Calculation</span></a></li>&ndash;&gt;--><!--                                    &lt;!&ndash;<li><a href="http://jamabandi.nic.in/StampDuty.aspx" target="_blank"><span>Auto Calculation of Stamp Duty Fee</span></a></li>&ndash;&gt;--><!--                                    &lt;!&ndash;</ul>&ndash;&gt;--><!--                                    &lt;!&ndash;</li>&ndash;&gt;--><!--                                </ul>--><!--                            </li>--><!--                            <li><a ui-sref="meetOurExperts">Meet Our Experts</a></li>--><!--                            &lt;!&ndash;                                                <li><a ui-sref="policyFeedbackDashboard"><span>Policy Feedback</span></a></li>&ndash;&gt;--><!--                            &lt;!&ndash;                                                <li><a ui-sref="servicedashboardyearly"><span>Service Dashboard</span></a></li>&ndash;&gt;--><!--                            &lt;!&ndash;                                                <li><a ui-sref="tracklicense"><span>Track Licenses</span></a></li>&ndash;&gt;--><!--                            &lt;!&ndash;<li> <a ui-sref=""><span>FAQ\'s</span></a> </li>&ndash;&gt;--><!--                        </ul>--><!--                    </li>--><!--                    <li><a><span style="font-size: medium">Dashboards</span></a>--><!--                        <ul class="gradient_bg_color2">--><!--                            <li><a ui-sref="servicedashboardyearly"><span>Service Dashboard</span></a></li>--><!--                            <li><a ui-sref="investorfacilitationcell"><span>Grievance Dashboard</span></a></li>--><!--                            <li><a ui-sref="hepcdashboard"><span>Enquiry Dashboard</span></a></li>--><!--                        </ul>--><!--                    </li>--><!--                    <li><a><span style="font-size: medium">Downloads</span></a>--><!--                        <ul class="gradient_bg_color1">--><!--                            <li>--><!--                                <a><span>Acts</span></a>--><!--                                <ul class="dropdown-submenu gradient_bg_color3">--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Haryana_Enterprises_Promotion_Act2016.pdf">Haryana Enterprises Promotion Act (HEPA)</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Haryana Enterprises Promotiom (Amendment) Bill, 2021-Notification.pdf">Haryana Enterprises Promotiom (Amendment) Bill, 2021-Notification</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Haryana Enterprises Promotion (Second Amendment) Act, 2021.pdf">Haryana Enterprises Promotion (Second Amendment) Act, 2021</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/HEPR2016.pdf">Haryana Enterprises Promotion Rules (HEPR)</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/ConsolidatedNotifiedServices.pdf">Right to Service Act , 2014</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="http://csharyana.gov.in/WriteReadData/Act/Administrative%20Reforms/4297.pdf">RTS</a>--><!--                                    </li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/The-Haryana-Building-Code-2017.pdf">The Building Code, 2017</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/TheHaryanaBuildingCode20172ndAmendmentforEODB.pdf">The Building Code, 2017 0 - Amended</a></li>--><!--                                </ul>--><!--                            </li>--><!--                            <li>--><!--                                <a><span>EoDB Notifications 2020</span></a>--><!--                                <ul class="dropdown-submenu gradient_bg_color3">--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Registration of Travel Agency & Hotels by Tourism Department, GoH.pdf" ng-click="vm.collapseNavbar()">--><!--                                        <span>Registration of Travel Agency & Hotels by Tourism Department, GoH</span>--><!--                                    </a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/NotificationFIlmShooting.pdf" ng-click="vm.collapseNavbar()">--><!--                                        <span>Notification-Film Shooting</span>--><!--                                    </a></li>--><!--                                </ul>--><!--                            </li>--><!--                            <li>--><!--                                <a><span>Minutes of Meeting</span></a>--><!--                                <ul class="dropdown-submenu gradient_bg_color3">--><!--                                    <li ui-sref-active="active">--><!--                                        <a data-toggle="modal" data-target="#mm_meeting" ng-click="vm.meeting_view(\'EEC\')">--><!--                                            <span>EEC</span>--><!--                                        </a>--><!--                                    </li>--><!--                                    <li ui-sref-active="active">--><!--                                        <a data-toggle="modal" data-target="#mm_meeting" ng-click="vm.meeting_view(\'HEPB\')">--><!--                                            <span>HEPB</span>--><!--                                        </a>--><!--                                    </li>--><!--                                </ul>--><!--                            </li>--><!--                            <li>--><!--                                <a><span>Notices</span></a>--><!--                                <ul class="dropdown-submenu pull-left gradient_bg_color3">--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Notification05.07.2018.pdf">Delegation of power to Nos</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/LabourDepartmentNotification.pdf">Exemption from renewals under Shops and Commercial Establishment Act</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/hareda366111561.pdf">HAREDA - Notification</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="http://www.egazetteharyana.gov.in/Gazette/Extra-Ordinary/2017/192-2017-Ext/5020.pdf">HSPCB Timeline</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/NMACircular.pdf">NMA Circular</a></li>--><!--                                    &lt;!&ndash;                                                        <li><a target="_blank"&ndash;&gt;--><!--                                    &lt;!&ndash;                                                               href="../../../content/pdfs/Ad_DeputyCOO_BIPP_v4.pdf">Recruitment Notice \u2013 Deputy COO, BIPP</a></li>&ndash;&gt;--><!--                                    <li class="dropdown-submenu pull-left"><a><span>Urban Local Bodies - Notifications</span></a>--><!--                                        <ul class="dropdown-menu gradient_bg_color1">--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/Amendment in Haryana Municipal ( Communication and Connectivity Infrastructure) Bye laws 2013.pdf">Amendment in Haryana Municipal Bye laws 2013</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/Amendment in Haryana Municipal Corporation ( Communication and Connectivity Infrastructure) Bye laws 2013.pdf">Amendment in Haryana Municipal Corporation Bye laws 2013</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/tower bye-laws corporation.pdf">Tower Bye-Laws Corporation</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/tower bye-laws councilc-committee.pdf">Tower Bye-Laws Council-Committee</a>--><!--                                            </li>--><!--                                        </ul>--><!--                                    </li>--><!--                                </ul>--><!--                            </li>--><!--                            <li>--><!--                                <a><span>Policies/Schemes</span></a>--><!--                                <ul class="dropdown-submenu gradient_bg_color3">--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/CCIP Policy 2017.pdf">CCI policy,2017</a></li>--><!--                                    <li><a data-toggle="modal" data-target="#EPP2015">--><!--                                        Enterprise--><!--                                        Promotion Policy, 2015</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/HARYANASOLARPOLICY-2016.pdf">Haryana--><!--                                        Solar Power Policy-2016</a></li>--><!--                                    <li><a data-toggle="modal" data-target="#Agriculture">Haryana Agri Business and Food Processing Policy 2018</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/IT ESDM.pdf">IT & ESDM Policy,2017</a></li>--><!--                                    <li><a data-toggle="modal" data-target="#Logistics">Logistics, Warehousing & Retail Policy, 2019</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MSME policy.pdf">MSME Policy, 2019</a>--><!--                                    </li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Notification- Haryana Covid emergency credit scheme.pdf">Haryana Covid Emergency Credit Scheme</a>--><!--                                    </li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Notified Pharma policy.pdf">Pharmaceutical Policy,2019</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/SIIDSscheme.pdf">SIIDS Scheme--><!--                                    </a>--><!--                                    </li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Textile Policy 2019.pdf">Textile Policy 2019</a></li>--><!--                                </ul>--><!--                            </li>--><!--                            <li>--><!--                                <a><span>SOPs</span></a>--><!--                                <ul class="dropdown-submenu gradient_bg_color3">--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/SOPforGrievanceRedressal.pdf">SOP for Grievance Redressal</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/ConceptNoteHelpdeskatHEPC.docx">SOP for handling Investor Queries</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/SOPforHelpdeskatHEPC.pdf">SOP for Helpdesk at HEPC</a></li>--><!--                                </ul>--><!--                            </li>--><!--                            <li>--><!--                                <a><span>Tenders</span></a>--><!--                                <ul class="dropdown-submenu gradient_bg_color3">--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/124229_Corrigendum.pdf">Corrigendum No. 1</a>--><!--                                    </li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Corrigendum - 2_V1.0.pdf">Corrigendum No. 2</a>--><!--                                    </li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Corrigendum - 21.06.2019.pdf">Corrigendum No. 3</a>--><!--                                    </li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Corrigendum - 4.pdf">Corrigendum No. 4</a>--><!--                                    </li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/RFP for data analytics V2.0.pdf">RFP for Data Analytics</a>--><!--                                    </li>--><!--                                </ul>--><!--                            </li>--><!--                            <li><a><span>Orders for Essential Services (Lockdown)</span></a>--><!--                                <ul class="dropdown-submenu gradient_bg_color3">--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Order dated 02.05.2021 Lockdown (1).pdf">--><!--                                        Order dated 02.05.2021 Lockdown--><!--                                    </a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/new guidelines dated 01.06.2020.pdf">--><!--                                        New Guidelines dated 01.06.2020 for Industry and other establishments - Unlock 1.0--><!--                                    </a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MHA Order Dt. 30.5.2020 with guidelines on extension of LD in Containment Zones and phased reopening.pdf">--><!--                                        MHA GoI order dated 30.05.2020--><!--                                    </a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/New Guidelines Industry 05-19-2020.pdf">--><!--                                        New guidelines dated 18.05.2020 for industries</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MHAOrderextension_1752020.pdf">--><!--                                        MHA GoI order dated 17-05-2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/New Guidelines dated 06-05-2020 PS Industries.pdf">--><!--                                        New Guidelines dated 06-05-2020 PS Industries</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Haryana Guidelines - 03.05.2020.pdf">--><!--                                        New guidelines dated 03.05.2020 for industries and other establishments</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/GoH Guidelines 19 April 2020.pdf">--><!--                                        GoH Guidelines 19 April 2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/GoH Revised Guidelines 30 Apr 2020.pdf">--><!--                                        GoH Revised Guidelines 30 Apr 2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MHA 01 May 2020.pdf">--><!--                                        MHA 01 May 2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/DO Lr. Dt. 23.4.2020 to Chief Secretaries with clarification on misplaced apprehensions of Industry..pdf">--><!--                                        DO Lr. Dt. 23.4.2020 to Chief Secretaries with clarification on misplaced apprehensions of Industry</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MHA Order Dt. 29.4.2020 on movement of migrant workers, pilgrims, tourists, students and other persons.pdf">--><!--                                        MHA Order Dt. 29.4.2020 on movement of migrant workers, pilgrims, tourists, students and other persons</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MHA Do Ltr Dt. 30.4.2020 to allow unhindered movement of trucks carrying goods.pdf">--><!--                                        MHA GoI DO Ltr Dt. 30.4.2020 to allow unhindered movement of trucks carrying goods</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Scan frozen period.pdf">--><!--                                        Scan Frozen Period</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MHA GoI dated 24-03-2020.pdf">MHA GoI letter dated 24.03.2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MHA order dated 25.03.2020 with addendum to Guidelines Dated 24.3.2020.pdf">MHA order dated 25.03.2020 with addendum in Dated 24.3.2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Second Addendum (27.03.2020) to MHA Order on Lockdown Measures.pdf">Second Addendum (27.03.2020) to MHA Order on Lockdown Measures</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MHA GoI letter dated 29.03.2020.pdf">MHA GoI letter dated 29.03.2020</a></li>--><!--                                    &lt;!&ndash;                                                        <li><a target="_blank"&ndash;&gt;--><!--                                    &lt;!&ndash;                                                               href="../../../content/pdfs/Ad_DeputyCOO_BIPP_v4.pdf">Recruitment Notice \u2013 Deputy COO, BIPP</a></li>&ndash;&gt;--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MoS GoI dated 24-03-2020.pdf">Ministry of Steel, GoI letter dated 24.03.2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Chief Secys of States - MHA Letter (29.3.2020) reg consolidated guidelines and migrant labourers.pdf">--><!--                                        Chief Secys of States reg. consolidated guidelines and migrant labourers</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/DG Shipping dated 29-03-2020.pdf">Directorate General of Shipping, GoI letter dated 29.03.2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/ACS Agriculture letter dated 27.03.2020.PDF">ACS Agriculture letter dated 27.03.2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/advisory industries.pdf">Advisory dated 25.03.2020 for Industries during lockdown</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/DO Letter dated 3.4.2020 to Chief Secretaries with clarification on smooth flow of essential goods and services.pdf">--><!--                                        DO Letter dated 3.4.2020 to Chief Secretaries on smooth flow of essential goods and services</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/CS letter dated 5-4-2020.pdf">--><!--                                        Chief Secretary letter dated 05-04-2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MHA_Consolidated_Guidelines_03042020.PDF">--><!--                                        MHA GoI Consolidated Guidelines</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MHA order dt 15.04.2020, with Revised Consolidated Guidelines.pdf">--><!--                                        MHA order dated 15.04.2020, with Revised Consolidated Guidelines</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/D.O. to States reg. containment of Hotspots.pdf">--><!--                                        D.O. to States reg. containment of Hotspots</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/MHA GoI oder dated 19.04.2020.pdf">--><!--                                        MHA GoI order dated 19.04.2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Revenue and Disaster Managment Deptt Haryana order dated 19.04.2020.pdf">--><!--                                        Revenue and Disaster Management Deptt Haryana order dated 19.04.2020</a></li>--><!--                                    <li><a target="_blank"--><!--                                           href="../../../content/pdfs/Industries & Commerce Deptt order dated 19.04.2020.pdf">--><!--                                        Industries & Commerce Deptt order dated 19.04.2020</a></li>--><!--                                </ul>--><!--                            </li>--><!--                            <li><a target="_blank" href="../../../content/pdfs/HEPC-Investors-Handbook.pdf"><span>Investors Handbook</span></a></li>--><!--                            <li><a ui-sref="advertisement"><span>HSIIDC Advertisement</span></a>--><!--                            <li><a><span>Regulatory Compliance</span></a>--><!--                                <ul class="gradient_bg_color2">--><!--                                    <li>--><!--                                        <a><span>Team Lease Data 05.07.2021</span></a>--><!--                                        <ul class="dropdown-submenu gradient_bg_color3">--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D1_Health_Irrigation_HSPCB_ULB.pdf">D1_Health_Irrigation_HSPCB_ULB</a></li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D2 CEI_ULB.pdf">D2 CEI_ULB</a></li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D3_Excise, FCS,Power, TCP, Transport.pdf">D3_Excise,FCS,Power,TCP,Transport</a></li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D4_Excise, Transport.pdf">D4_Excise,Transport</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D5 Health, School_ Industries.pdf">D5 Health, School_ Industries</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D6_Home.pdf">D6_Home</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D7_FDA.pdf">D7_FDA</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D8_TCP -RERA.pdf">D8_TCP -RERA</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D9_ULB.pdf">D9_ULB</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D10_LABOUR -HOME 1_6.pdf">D10_LABOUR -HOME 1_6</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D10_LABOUR_HOME 2_6.pdf">D10_LABOUR_HOME 2_6</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D10_LABOUR_HOME 3_6.pdf">D10_LABOUR_HOME 3_6</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D10_LABOUR_HOME 4_6.pdf">D10_LABOUR_HOME 4_6</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D10_LABOUR_HOME 5_6.pdf">D10_LABOUR_HOME 5_6</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/D10_LABOUR_HOME 6_6.pdf">D10_LABOUR_HOME 6_6</a>--><!--                                            </li>--><!--                                        </ul>--><!--                                    </li>--><!--                                </ul>--><!--                            </li>--><!--                        </ul>--><!--                    </li>--><!--                    &lt;!&ndash;                                        <li ui-sref-active="active">&ndash;&gt;--><!--                    &lt;!&ndash;                                            <a ui-sref="eodb">EODB</a>&ndash;&gt;--><!--                    &lt;!&ndash;                                        </li>&ndash;&gt;--><!--                    &lt;!&ndash;                                        <li><a target="_blank"&ndash;&gt;--><!--                    &lt;!&ndash;                                               href="../../../content/pdfs/COVID-19 Passesv2.pdf">&ndash;&gt;--><!--                    &lt;!&ndash;                                            <span class="badge-warning blink_me">Procedure-COVID 19 Grievances</span></a></li>&ndash;&gt;--><!--                    <li ui-sref-active="active">--><!--                        <a href="https://grs.hartron.io" target="_blank" style="font-size: medium">Grievance Redressal</a>--><!--                    </li>--><!--                    &lt;!&ndash;                                        <li><a ui-sref="hepcdashboard"><span>Ticketing/Query Dashboard</span></a></li>&ndash;&gt;--><!--                    &lt;!&ndash;                                        <li><a ui-sref="searchHomeCAF"><span>Third Party Verification</span></a></li>&ndash;&gt;--><!--                    <li><a ui-sref="searchHomeCAF"><span style="font-size: medium">Third Party Verification</span></a>--><!--                        <ul class="gradient_bg_color2">--><!--                            <li><a ui-sref="searchTowerCAF" ng-click="vm.collapseNavbar()">Tower Services Clearance Status By CAF PIN</a></li>--><!--                        </ul>--><!--                    </li>--><!--                    <li><a ui-sref="contact_us"><span style="font-size: medium">Contact Us</span></a></li>--><!--                    <li>--><!--                        <a ng-click="vm.login()"><span style="font-size: medium"><strong>Login/Register</strong></span></a>--><!--                    </li>--><!--                    &lt;!&ndash;<li class="pull-right"></li>&ndash;&gt;--><!--                </ul>--><!--            </div>--><!--        </header>--><!--    </nav>--><!--    <div class="container-fluid" style="background-color: #f2f2f2 !important;" ng-switch-when="false">--><!--                <div class="col-md-12">--><!--                    <header class="page_header header_white tall_header toggler_xs_right">--><!--                            <div class="header_mainmenu">--><!--                                &lt;!&ndash; main nav start &ndash;&gt;--><!--                                <nav class="mainmenu_wrapper">--><!--                                    <ul ng-click="vm.toggleMenu()" class="mainmenu nav sf-menu">--><!--                                        <li><a ui-sref="home"><span style="padding-left: 10px;">Home</span></a></li>--><!--                                        <li><a ui-sref="aboutHEPC"><span>About Us</span></a>--><!--                                            <ul class="gradient_bg_color1">--><!--                                                <li ui-sref-active="active">--><!--                                                    <a ui-sref="about" ng-click="vm.collapseNavbar()">--><!--                                                        <span>About HEPC</span>--><!--                                                    </a>--><!--                                                </li>--><!--                                                <li ui-sref-active="active">--><!--                                                    <a target="_blank"--><!--                                                       href="../../../content/pdfs/List of Officers and Employees of HEPC.pdf">HEPC Staff--><!--                                                    </a></li>--><!--                                                &lt;!&ndash;<li ui-sref-active="active">&ndash;&gt;--><!--                                                    &lt;!&ndash;<a ui-sref="CM_Message" ng-click="vm.collapseNavbar()">&ndash;&gt;--><!--                                                        &lt;!&ndash;<span>CM Message</span>&ndash;&gt;--><!--                                                    &lt;!&ndash;</a>&ndash;&gt;--><!--                                                &lt;!&ndash;</li>&ndash;&gt;--><!--                                                <li ui-sref-active="active">--><!--                                                    <a ui-sref="mission" ng-click="vm.collapseNavbar()">--><!--                                                        <span>Mission & Vision</span>--><!--                                                    </a>--><!--                                                </li>--><!--                                                <li ui-sref-active="active">--><!--                                                    <a ui-sref="org_structure" ng-click="vm.collapseNavbar()">--><!--                                                        <span>Organization Structure</span>--><!--                                                    </a>--><!--                                                </li>--><!--                                                <li ui-sref-active="active">--><!--                                                    <a ui-sref="eodb" ng-click="vm.collapseNavbar()">--><!--                                                        <span class="hidden-sm">EODB</span>--><!--                                                    </a>--><!--                                                </li>--><!--                                            </ul>--><!--                                        </li>--><!--                                        <li><a>Why Haryana</a>--><!--                                            <ul class="gradient_bg_color2">--><!--                                                <li><a ui-sref="booming_economy"><span>Booming Economy</span></a></li>--><!--                                                <li><a ui-sref="conducive_ecosystem"><span>Conducive Ecosystem</span></a></li>--><!--                                                <li><a ui-sref="industrial_powerhouse"><span>Industrial Powerhouse</span></a></li>--><!--                                                <li><a href="../../../content/pdfs/KnewmoreaboutHEPC.pdf" target="_blank">Know more about HEPC</a></li>--><!--                                                <li><a ui-sref="qualityOfLife"><span>Quality Of Life</span></a></li>--><!--                                                <li><a href="../../../content/pdfs/HEPC-25_Reasons_To_invest_in_Haryana_Booklet.pdf" target="_blank">Reasons To Invest In Haryana</a></li>--><!--                                                <li><a ui-sref="supportive_government"><span>Supportive Government</span></a></li>--><!--                                                <li><a><span>Thrust Sector</span></a>--><!--                                                    <ul class="dropdown-submenu gradient_bg_color1">--><!--                                                        <li><a ui-sref="agriculture">Agro & Food Processing</a></li>--><!--                                                        <li><a>Auto & Auto Components</a></li>--><!--                                                        <li><a ui-sref="defence">Defence & Aerospace</a></li>--><!--                                                        <li><a ui-sref="electronicsAndInfo">Electronics & IT/ITES</a></li>--><!--                                                        <li><a ui-sref="footwearAndAccessory">Footwear & Accessories</a></li>--><!--                                                        <li><a ui-sref="pharmaceuticalAndChemical">Pharmaceutical & Chemical</a></li>--><!--                                                        <li><a ui-sref="renewable">Renewable Energy & Solar Parks</a></li>--><!--                                                        <li><a ui-sref="textile">Textiles & Apparels</a></li>--><!--                                                    </ul>--><!--                                                </li>--><!--                                                &lt;!&ndash;                                                <li><a href="../../../content/pdfs/HEPC-Invest-haryana.pdf"><span>What Investors Speak</span></a></li>&ndash;&gt;--><!--                                            </ul>--><!--                                        </li>--><!--                                        <li><a>Investor Services</a>--><!--                                            <ul class="gradient_bg_color3">--><!--                                                <li><a ui-sref="investorfacilitationcell"><span>Apply for services</span></a></li>--><!--                                                <li><a href="http://125.99.73.119:8001/bpamsclient/" target="_blank"><span>Building Plan Status</span></a></li>--><!--                                                <li><a href="http://cisharyana.in/"--><!--                                                       target="_blank"><span>Central Inspection System</span></a></li>--><!--&lt;!&ndash;                                                <li><a href="http://dcmsme.gov.in/dips/state_wise_profile_16-17/HARYANA%20State%20Profile.pdf" target="_blank">Haryana State Industrial Profile</a></li>&ndash;&gt;--><!--&lt;!&ndash;                                                <li><a href=" http://haryanacsr.org/" target="_blank">Haryana CSR Advisory Board</a></li>&ndash;&gt;--><!--                                                <li><a href="../../../content/pdfs/UserManualForAvailingService.pdf"><span>Investor User Manual</span></a></li>--><!--&lt;!&ndash;                                                <li><a href="../../../content/pdfs/HEPC-Investors-Handbook.pdf"><span>Investors Handbook</span></a></li>&ndash;&gt;--><!--                                                <li><a ui-sref="Questionnaire"><span>Know Your Clearance</span></a></li>--><!--                                                <li><a ui-sref="procedures&Checklist"><span>Procedures and Checklists</span></a></li>--><!--&lt;!&ndash;                                                <li><a ui-sref="searchTowerCAF" ng-click="vm.collapseNavbar()">Tower Services Clearance Status By CAF PIN</a></li>&ndash;&gt;--><!--                                                <li><a ui-sref="incentiveswizard"><span>Know Your Incentives</span></a></li>--><!--                                                <li><a href="http://hsiidcgis.org.in/hsiidcgis/" target="_blank"><span>Land Bank Availability</span></a></li>--><!--                                                <li><a><span>Levies Imposed By State & Local Bodies</span></a>--><!--                                                    <ul class="dropdown-submenu gradient_bg_color1">--><!--                                                        <li><a href="../../../content/pdfs/Professional Tax- Haryana.pdf">Professional Tax- Haryana</a></li>--><!--                                                        <li><a href="../../../content/pdfs/Taxes and Levies in Haryana.pdf">State Levies</a></li>--><!--                                                        &lt;!&ndash;<li><a href="../../../content/pdfs/State Excise Duty-Department of Excise & Taxation.pdf">State Excise Duty-Department of Excise & Taxation</a></li>&ndash;&gt;--><!--                                                        &lt;!&ndash;<li><a href="http://uhbvn.org.in/staticContent/documents/circular/SC2000/SC_U_12_2000.pdf" target="_blank"><span>Taxes & Duties on Electricity</span></a></li>&ndash;&gt;--><!--                                                        &lt;!&ndash;<li><a><span>Stamp & Registration Fee</span></a>&ndash;&gt;--><!--                                                            &lt;!&ndash;<ul class="dropdown-submenu gradient_bg_color1">&ndash;&gt;--><!--                                                                &lt;!&ndash;<li><a href="http://jamabandi.nic.in/Docs/SDRates.pdf" target="_blank"><span>Rates of Stamp Duty Calculation</span></a></li>&ndash;&gt;--><!--                                                                &lt;!&ndash;<li><a href="http://jamabandi.nic.in/Docs/Registration%20Fee.pdf" target="_blank"><span>Rates of Registration Fee Calculation</span></a></li>&ndash;&gt;--><!--                                                                &lt;!&ndash;<li><a href="http://jamabandi.nic.in/StampDuty.aspx" target="_blank"><span>Auto Calculation of Stamp Duty Fee</span></a></li>&ndash;&gt;--><!--                                                            &lt;!&ndash;</ul>&ndash;&gt;--><!--                                                        &lt;!&ndash;</li>&ndash;&gt;--><!--                                                    </ul>--><!--                                                </li>--><!--                                                <li><a ui-sref="meetOurExperts">Meet Our Experts</a></li>--><!--&lt;!&ndash;                                                <li><a ui-sref="policyFeedbackDashboard"><span>Policy Feedback</span></a></li>&ndash;&gt;--><!--&lt;!&ndash;                                                <li><a ui-sref="servicedashboardyearly"><span>Service Dashboard</span></a></li>&ndash;&gt;--><!--&lt;!&ndash;                                                <li><a ui-sref="tracklicense"><span>Track Licenses</span></a></li>&ndash;&gt;--><!--                                                &lt;!&ndash;<li> <a ui-sref=""><span>FAQ\'s</span></a> </li>&ndash;&gt;--><!--                                            </ul>--><!--                                        </li>--><!--                                        <li><a><span>Dashboards</span></a>--><!--                                            <ul class="gradient_bg_color2">--><!--                                                <li><a ui-sref="servicedashboardyearly"><span>Service Dashboard</span></a></li>--><!--                                                <li><a ui-sref="investorfacilitationcell"><span>Grievance Dashboard</span></a></li>--><!--                                                <li><a ui-sref="hepcdashboard"><span>Enquiry Dashboard</span></a></li>--><!--                                            </ul>--><!--                                        </li>--><!--                                        <li><a><span>Downloads</span></a>--><!--                                            <ul class="gradient_bg_color1">--><!--                                                <li>--><!--                                                    <a><span>Acts</span></a>--><!--                                                    <ul class="dropdown-submenu gradient_bg_color3">--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Haryana_Enterprises_Promotion_Act2016.pdf">Haryana Enterprises Promotion Act (HEPA)</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Haryana Enterprises Promotiom (Amendment) Bill, 2021-Notification.pdf">Haryana Enterprises Promotiom (Amendment) Bill, 2021-Notification</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Haryana Enterprises Promotion (Second Amendment) Act, 2021.pdf">Haryana Enterprises Promotion (Second Amendment) Act, 2021</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/HEPR2016.pdf">Haryana Enterprises Promotion Rules (HEPR)</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/ConsolidatedNotifiedServices.pdf">Right to Service Act , 2014</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="http://csharyana.gov.in/WriteReadData/Act/Administrative%20Reforms/4297.pdf">RTS</a>--><!--                                                        </li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/The-Haryana-Building-Code-2017.pdf">The Building Code, 2017</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/TheHaryanaBuildingCode20172ndAmendmentforEODB.pdf">The Building Code, 2017 0 - Amended</a></li>--><!--                                                    </ul>--><!--                                                </li>--><!--                                                <li>--><!--                                                    <a><span>EoDB Notifications 2020</span></a>--><!--                                                    <ul class="dropdown-submenu gradient_bg_color3">--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Registration of Travel Agency & Hotels by Tourism Department, GoH.pdf" ng-click="vm.collapseNavbar()">--><!--                                                                <span>Registration of Travel Agency & Hotels by Tourism Department, GoH</span>--><!--                                                            </a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/NotificationFIlmShooting.pdf" ng-click="vm.collapseNavbar()">--><!--                                                            <span>Notification-Film Shooting</span>--><!--                                                        </a></li>--><!--                                                    </ul>--><!--                                                </li>--><!--                                                <li>--><!--                                                    <a><span>Minutes of Meeting</span></a>--><!--                                                    <ul class="dropdown-submenu gradient_bg_color3">--><!--                                                        <li ui-sref-active="active">--><!--                                                            <a data-toggle="modal" data-target="#mm_meeting" ng-click="vm.meeting_view(\'EEC\')">--><!--                                                                <span>EEC</span>--><!--                                                            </a>--><!--                                                        </li>--><!--                                                        <li ui-sref-active="active">--><!--                                                            <a data-toggle="modal" data-target="#mm_meeting" ng-click="vm.meeting_view(\'HEPB\')">--><!--                                                                <span>HEPB</span>--><!--                                                            </a>--><!--                                                        </li>--><!--                                                    </ul>--><!--                                                </li>--><!--                                                <li>--><!--                                                    <a><span>Notices</span></a>--><!--                                                    <ul class="dropdown-submenu pull-left gradient_bg_color3">--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Notification05.07.2018.pdf">Delegation of power to Nos</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/LabourDepartmentNotification.pdf">Exemption from renewals under Shops and Commercial Establishment Act</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/hareda366111561.pdf">HAREDA - Notification</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="http://www.egazetteharyana.gov.in/Gazette/Extra-Ordinary/2017/192-2017-Ext/5020.pdf">HSPCB Timeline</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/NMACircular.pdf">NMA Circular</a></li>--><!--&lt;!&ndash;                                                        <li><a target="_blank"&ndash;&gt;--><!--&lt;!&ndash;                                                               href="../../../content/pdfs/Ad_DeputyCOO_BIPP_v4.pdf">Recruitment Notice \u2013 Deputy COO, BIPP</a></li>&ndash;&gt;--><!--                                                        <li class="dropdown-submenu pull-left"><a><span>Urban Local Bodies - Notifications</span></a>--><!--                                                            <ul class="dropdown-menu gradient_bg_color1">--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/Amendment in Haryana Municipal ( Communication and Connectivity Infrastructure) Bye laws 2013.pdf">Amendment in Haryana Municipal Bye laws 2013</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/Amendment in Haryana Municipal Corporation ( Communication and Connectivity Infrastructure) Bye laws 2013.pdf">Amendment in Haryana Municipal Corporation Bye laws 2013</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/tower bye-laws corporation.pdf">Tower Bye-Laws Corporation</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/tower bye-laws councilc-committee.pdf">Tower Bye-Laws Council-Committee</a>--><!--                                                                </li>--><!--                                                            </ul>--><!--                                                        </li>--><!--                                                    </ul>--><!--                                                </li>--><!--                                                <li>--><!--                                                    <a><span>Policies/Schemes</span></a>--><!--                                                    <ul class="dropdown-submenu gradient_bg_color3">--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/CCIP Policy 2017.pdf">CCI policy,2017</a></li>--><!--                                                        <li><a data-toggle="modal" data-target="#EPP2015">--><!--                                                            Enterprise--><!--                                                            Promotion Policy, 2015</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/HARYANASOLARPOLICY-2016.pdf">Haryana--><!--                                                            Solar Power Policy-2016</a></li>--><!--                                                        <li><a data-toggle="modal" data-target="#Agriculture">Haryana Agri Business and Food Processing Policy 2018</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/IT ESDM.pdf">IT & ESDM Policy,2017</a></li>--><!--                                                        <li><a data-toggle="modal" data-target="#Logistics">Logistics, Warehousing & Retail Policy, 2019</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MSME policy.pdf">MSME Policy, 2019</a>--><!--                                                        </li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Notification- Haryana Covid emergency credit scheme.pdf">Haryana Covid Emergency Credit Scheme</a>--><!--                                                        </li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Notified Pharma policy.pdf">Pharmaceutical Policy,2019</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/SIIDSscheme.pdf">SIIDS Scheme--><!--                                                        </a>--><!--                                                        </li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Textile Policy 2019.pdf">Textile Policy 2019</a></li>--><!--                                                    </ul>--><!--                                                </li>--><!--                                                <li>--><!--                                                    <a><span>SOPs</span></a>--><!--                                                    <ul class="dropdown-submenu gradient_bg_color3">--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/SOPforGrievanceRedressal.pdf">SOP for Grievance Redressal</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/ConceptNoteHelpdeskatHEPC.docx">SOP for handling Investor Queries</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/SOPforHelpdeskatHEPC.pdf">SOP for Helpdesk at HEPC</a></li>--><!--                                                    </ul>--><!--                                                </li>--><!--                                                <li>--><!--                                                    <a><span>Tenders</span></a>--><!--                                                    <ul class="dropdown-submenu gradient_bg_color3">--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/124229_Corrigendum.pdf">Corrigendum No. 1</a>--><!--                                                        </li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Corrigendum - 2_V1.0.pdf">Corrigendum No. 2</a>--><!--                                                        </li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Corrigendum - 21.06.2019.pdf">Corrigendum No. 3</a>--><!--                                                        </li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Corrigendum - 4.pdf">Corrigendum No. 4</a>--><!--                                                        </li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/RFP for data analytics V2.0.pdf">RFP for Data Analytics</a>--><!--                                                        </li>--><!--                                                    </ul>--><!--                                                </li>--><!--                                                <li><a><span>Orders for Essential Services (Lockdown)</span></a>--><!--                                                    <ul class="dropdown-submenu gradient_bg_color3">--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Order dated 02.05.2021 Lockdown (1).pdf">--><!--                                                            Order dated 02.05.2021 Lockdown--><!--                                                        </a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/new guidelines dated 01.06.2020.pdf">--><!--                                                            New Guidelines dated 01.06.2020 for Industry and other establishments - Unlock 1.0--><!--                                                        </a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MHA Order Dt. 30.5.2020 with guidelines on extension of LD in Containment Zones and phased reopening.pdf">--><!--                                                            MHA GoI order dated 30.05.2020--><!--                                                        </a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/New Guidelines Industry 05-19-2020.pdf">--><!--                                                            New guidelines dated 18.05.2020 for industries</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MHAOrderextension_1752020.pdf">--><!--                                                            MHA GoI order dated 17-05-2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/New Guidelines dated 06-05-2020 PS Industries.pdf">--><!--                                                            New Guidelines dated 06-05-2020 PS Industries</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Haryana Guidelines - 03.05.2020.pdf">--><!--                                                            New guidelines dated 03.05.2020 for industries and other establishments</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/GoH Guidelines 19 April 2020.pdf">--><!--                                                            GoH Guidelines 19 April 2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/GoH Revised Guidelines 30 Apr 2020.pdf">--><!--                                                            GoH Revised Guidelines 30 Apr 2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MHA 01 May 2020.pdf">--><!--                                                            MHA 01 May 2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/DO Lr. Dt. 23.4.2020 to Chief Secretaries with clarification on misplaced apprehensions of Industry..pdf">--><!--                                                            DO Lr. Dt. 23.4.2020 to Chief Secretaries with clarification on misplaced apprehensions of Industry</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MHA Order Dt. 29.4.2020 on movement of migrant workers, pilgrims, tourists, students and other persons.pdf">--><!--                                                            MHA Order Dt. 29.4.2020 on movement of migrant workers, pilgrims, tourists, students and other persons</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MHA Do Ltr Dt. 30.4.2020 to allow unhindered movement of trucks carrying goods.pdf">--><!--                                                            MHA GoI DO Ltr Dt. 30.4.2020 to allow unhindered movement of trucks carrying goods</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Scan frozen period.pdf">--><!--                                                            Scan Frozen Period</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MHA GoI dated 24-03-2020.pdf">MHA GoI letter dated 24.03.2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MHA order dated 25.03.2020 with addendum to Guidelines Dated 24.3.2020.pdf">MHA order dated 25.03.2020 with addendum in Dated 24.3.2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Second Addendum (27.03.2020) to MHA Order on Lockdown Measures.pdf">Second Addendum (27.03.2020) to MHA Order on Lockdown Measures</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MHA GoI letter dated 29.03.2020.pdf">MHA GoI letter dated 29.03.2020</a></li>--><!--                                                        &lt;!&ndash;                                                        <li><a target="_blank"&ndash;&gt;--><!--                                                        &lt;!&ndash;                                                               href="../../../content/pdfs/Ad_DeputyCOO_BIPP_v4.pdf">Recruitment Notice \u2013 Deputy COO, BIPP</a></li>&ndash;&gt;--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MoS GoI dated 24-03-2020.pdf">Ministry of Steel, GoI letter dated 24.03.2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Chief Secys of States - MHA Letter (29.3.2020) reg consolidated guidelines and migrant labourers.pdf">--><!--                                                            Chief Secys of States reg. consolidated guidelines and migrant labourers</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/DG Shipping dated 29-03-2020.pdf">Directorate General of Shipping, GoI letter dated 29.03.2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/ACS Agriculture letter dated 27.03.2020.PDF">ACS Agriculture letter dated 27.03.2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/advisory industries.pdf">Advisory dated 25.03.2020 for Industries during lockdown</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/DO Letter dated 3.4.2020 to Chief Secretaries with clarification on smooth flow of essential goods and services.pdf">--><!--                                                            DO Letter dated 3.4.2020 to Chief Secretaries on smooth flow of essential goods and services</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/CS letter dated 5-4-2020.pdf">--><!--                                                            Chief Secretary letter dated 05-04-2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MHA_Consolidated_Guidelines_03042020.PDF">--><!--                                                            MHA GoI Consolidated Guidelines</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MHA order dt 15.04.2020, with Revised Consolidated Guidelines.pdf">--><!--                                                            MHA order dated 15.04.2020, with Revised Consolidated Guidelines</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/D.O. to States reg. containment of Hotspots.pdf">--><!--                                                            D.O. to States reg. containment of Hotspots</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/MHA GoI oder dated 19.04.2020.pdf">--><!--                                                            MHA GoI order dated 19.04.2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Revenue and Disaster Managment Deptt Haryana order dated 19.04.2020.pdf">--><!--                                                            Revenue and Disaster Management Deptt Haryana order dated 19.04.2020</a></li>--><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Industries & Commerce Deptt order dated 19.04.2020.pdf">--><!--                                                            Industries & Commerce Deptt order dated 19.04.2020</a></li>--><!--                                                    </ul>--><!--                                                </li>--><!--                                                <li><a target="_blank" href="../../../content/pdfs/HEPC-Investors-Handbook.pdf"><span>Investors Handbook</span></a></li>--><!--                                                <li><a ui-sref="advertisement"><span>HSIIDC Advertisement</span></a>--><!--                                                <li><a><span>Regulatory Compliance</span></a>--><!--                                                    <ul class="gradient_bg_color2">--><!--                                                        <li>--><!--                                                            <a><span>Team Lease Data 05.07.2021</span></a>--><!--                                                            <ul class="dropdown-submenu gradient_bg_color3">--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D1_Health_Irrigation_HSPCB_ULB.pdf">D1_Health_Irrigation_HSPCB_ULB</a></li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D2 CEI_ULB.pdf">D2 CEI_ULB</a></li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D3_Excise, FCS,Power, TCP, Transport.pdf">D3_Excise,FCS,Power,TCP,Transport</a></li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D4_Excise, Transport.pdf">D4_Excise,Transport</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D5 Health, School_ Industries.pdf">D5 Health, School_ Industries</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D6_Home.pdf">D6_Home</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D7_FDA.pdf">D7_FDA</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D8_TCP -RERA.pdf">D8_TCP -RERA</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D9_ULB.pdf">D9_ULB</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D10_LABOUR -HOME 1_6.pdf">D10_LABOUR -HOME 1_6</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D10_LABOUR_HOME 2_6.pdf">D10_LABOUR_HOME 2_6</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D10_LABOUR_HOME 3_6.pdf">D10_LABOUR_HOME 3_6</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D10_LABOUR_HOME 4_6.pdf">D10_LABOUR_HOME 4_6</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D10_LABOUR_HOME 5_6.pdf">D10_LABOUR_HOME 5_6</a>--><!--                                                                </li>--><!--                                                                <li><a target="_blank"--><!--                                                                       href="../../../content/pdfs/D10_LABOUR_HOME 6_6.pdf">D10_LABOUR_HOME 6_6</a>--><!--                                                                </li>--><!--                                                            </ul>--><!--                                                        </li>--><!--                                                    </ul>--><!--                                                </li>--><!--                                            </ul>--><!--                                        </li>--><!--&lt;!&ndash;                                        <li ui-sref-active="active">&ndash;&gt;--><!--&lt;!&ndash;                                            <a ui-sref="eodb">EODB</a>&ndash;&gt;--><!--&lt;!&ndash;                                        </li>&ndash;&gt;--><!--&lt;!&ndash;                                        <li><a target="_blank"&ndash;&gt;--><!--&lt;!&ndash;                                               href="../../../content/pdfs/COVID-19 Passesv2.pdf">&ndash;&gt;--><!--&lt;!&ndash;                                            <span class="badge-warning blink_me">Procedure-COVID 19 Grievances</span></a></li>&ndash;&gt;--><!--                                        <li ui-sref-active="active">--><!--                                            <a href="https://grs.hartron.io" target="_blank">Grievance Redressal</a>--><!--                                        </li>--><!--&lt;!&ndash;                                        <li><a ui-sref="hepcdashboard"><span>Ticketing/Query Dashboard</span></a></li>&ndash;&gt;--><!--&lt;!&ndash;                                        <li><a ui-sref="searchHomeCAF"><span>Third Party Verification</span></a></li>&ndash;&gt;--><!--                                        <li><a ui-sref="searchHomeCAF"><span>Third Party Verification</span></a>--><!--                                            <ul class="gradient_bg_color2">--><!--                                                <li><a ui-sref="searchTowerCAF" ng-click="vm.collapseNavbar()">Tower Services Clearance Status By CAF PIN</a></li>--><!--                                            </ul>--><!--                                        </li>--><!--                                        <li><a ui-sref="contact_us"><span>Contact Us</span></a></li>--><!--                                        <li>--><!--                                            <a ng-click="vm.login()"><span><strong>Login/Register</strong></span></a>--><!--                                        </li>--><!--                                        &lt;!&ndash;<li class="pull-right"></li>&ndash;&gt;--><!--                                    </ul>--><!--                                </nav>--><!--                            </div>--><!--                        <span class="toggle_menu" ng-click="vm.toggleMenu()"><span></span></span>--><!--                    </header>--><!--                </div>--><!--    </div>--><div class="container-fluid" style="background:#A0233D !important" ng-switch-when="false"><div class="col-md-12"><header class="page_header"><div class="header_mainmenu"><!-- main nav start --><nav class="mainmenu_wrapper"><ul ng-click="vm.toggleMenu()" class="mainmenu nav sf-menu"><li><a ui-sref="home"><span style="font-size: medium" data-translate="global.menu.home">Home</span></a></li><li><a ui-sref="aboutHEPC"><span style="font-size: medium" data-translate="global.menu.About Us">About Us</span></a><ul class="gradient_bg_color1"><li ui-sref-active="active"><a ui-sref="about" ng-click="vm.collapseNavbar()"><span data-translate="global.menu.About HEPC">About HEPC</span></a></li><li ui-sref-active="active"><!--                                        <a target="_blank" href="../../../content/pdfs/New HEPC Staff List.pdf">--> <a target="_blank" href="../../../content/pdfs/Hepc staff list updated.pdf"><span data-translate="global.menu.HEPC Staff">HEPC Staff</span></a></li><!--<li ui-sref-active="active">--><!--<a ui-sref="CM_Message" ng-click="vm.collapseNavbar()">--><!--<span>CM Message</span>--><!--</a>--><!--</li>--><li ui-sref-active="active"><a ui-sref="mission" ng-click="vm.collapseNavbar()"><span data-translate="global.menu.Mission & Vision">Mission & Vision</span></a></li><li ui-sref-active="active"><a ui-sref="org_structure" ng-click="vm.collapseNavbar()"><span data-translate="global.menu.Organization Structure">Organization Structure</span></a></li><li ui-sref-active="active"><a ui-sref="eodb" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.EODB">EODB</span></a></li></ul></li><li><a ui-sref="gallery"><span style="font-size: medium" data-translate="global.menu.Gallery">Gallery</span></a></li><li><a style="font-size: medium" data-translate="global.menu.Why Haryana">Why Haryana</a><ul class="gradient_bg_color2"><li><a ui-sref="booming_economy"><span data-translate="global.menu.Booming Economy">Booming Economy</span></a></li><li><a ui-sref="conducive_ecosystem"><span data-translate="global.menu.Conducive Ecosystem">Conducive Ecosystem</span></a></li><li><a ui-sref="industrial_powerhouse"><span data-translate="global.menu.Industrial Powerhouse">Industrial Powerhouse</span></a></li><li><a href="#" target="_blank" data-translate="global.menu.Know more about HEPC">Know more about HEPC</a></li><li><a ui-sref="qualityOfLife"><span data-translate="global.menu.Quality Of Life">Quality Of Life</span></a></li><li><a href="#" target="_blank" data-translate="global.menu.Reasons To Invest In Haryana">Reasons To Invest In Haryana</a></li><li><a ui-sref="supportive_government" data-translate="global.menu.Supportive Government"><span>Supportive Government</span></a></li><li><a><span data-translate="global.menu.Thrust Sector">Thrust Sector</span></a><ul class="dropdown-submenu gradient_bg_color1"><li><a ui-sref="agriculture" data-translate="global.menu.Agro & Food Processing">Agro & Food Processing</a></li><li><a data-translate="global.menu.Auto & Auto Components">Auto & Auto Components</a></li><li><a ui-sref="defence" data-translate="global.menu.Defence & Aerospace">Defence & Aerospace</a></li><li><a ui-sref="electronicsAndInfo" data-translate="global.menu.Electronics & IT/ITES">Electronics & IT/ITES</a></li><li><a ui-sref="footwearAndAccessory" data-translate="global.menu.Footwear & Accessories">Footwear & Accessories</a></li><li><a ui-sref="pharmaceuticalAndChemical" data-translate="global.menu.Pharmaceutical & Chemical">Pharmaceutical & Chemical</a></li><li><a ui-sref="renewable" data-translate="global.menu.Renewable Energy & Solar Parks">Renewable Energy & Solar Parks</a></li><li><a ui-sref="textile" data-translate="global.menu.Textiles & Apparels">Textiles & Apparels</a></li></ul></li><!--                                                <li><a href="../../../content/pdfs/HEPC-Invest-haryana.pdf"><span>What Investors Speak</span></a></li>--></ul></li><!--                            <li><a ui-sref="evPolicies"><span style="font-size: medium;"data-translate="global.menu.EV Policy 2022">EV Policy 2022</span></a></li>--><li><a class="nav-bar1" ui-sref="withoutlogin" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.Haryana State Startup Policy 2022">Haryana State Startup Policy 2022</span></a></li><li><a ui-sref="rating-summary"><span data-translate="global.menu.investor_feedback">Investor Feedback</span></a></li><!--                            <li><a target="_blank" href="../../../content/pdfs/2020_HEEP.pdf"><span data-translate="global.menu.HEEP 2020">HEEP 2020</span></a></li>--><li ui-sref-active="active"><a class="nav-bar1" ui-sref="view-decriminalization-form" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.Penal Provision Acts/Rules">Penal Provision Acts/Rules</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="checklistAvailability" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.Know Your Checklist">Know Your Checklist</span></a></li><li><a style="font-size: medium" data-translate="global.menu.Investor Services">Investor Services</a><ul class="gradient_bg_color3"><li><a ui-sref="intent-to-invest"><span>Intent To Invest</span></a></li><li has-any-authority="ROLE_ADMIN, ROLE_SUB_ADMIN"><a ui-sref="view-intent-to-invest"><span>Intent To Invest Dashboard</span></a></li><li><a ui-sref="investorfacilitationcell"><span data-translate="global.menu.Apply for services">Apply for services</span></a></li><li><a href="http://125.99.73.119:8001/bpamsclient/" target="_blank"><span data-translate="global.menu.Building Plan Status">Building Plan Status</span></a></li><li><a href="http://cisharyana.in/" target="_blank"><span data-translate="global.menu.Central Inspection System">Central Inspection System</span></a></li><!--                                                <li><a href="http://dcmsme.gov.in/dips/state_wise_profile_16-17/HARYANA%20State%20Profile.pdf" target="_blank">Haryana State Industrial Profile</a></li>--><!--                                                <li><a href=" http://haryanacsr.org/" target="_blank">Haryana CSR Advisory Board</a></li>--><li><a href="../../../content/pdfs/User Manual of Availing Services-HEPC.pdf"><span data-translate="global.menu.Investor User Manual">Investor User Manual</span></a></li><!--                                                <li><a href="../../../content/pdfs/HEPC-Investors-Handbook.pdf"><span>Investors Handbook</span></a></li>--><li><a ui-sref="Questionnaire"><span data-translate="global.menu.Know Your Approval">Know Your Approval</span></a></li><li><a ui-sref="procedures&Checklist"><span data-translate="global.menu.Procedures and Checklists">Procedures and Checklists</span></a></li><!--                                                <li><a ui-sref="searchTowerCAF" ng-click="vm.collapseNavbar()">Tower Services Clearance Status By CAF PIN</a></li>--><li><a ui-sref="incentiveswizard"><span data-translate="global.menu.Know Your Incentives">Know Your Incentives</span></a></li><li><a href="http://hsiidcgis.org.in/hsiidcgis/" target="_blank"><span data-translate="global.menu.Land Bank Availability">Land Bank Availability</span></a></li><li><a><span data-translate="global.menu.Levies Imposed By State & Local Bodies">Levies Imposed By State & Local Bodies</span></a><ul class="dropdown-submenu gradient_bg_color1"><li><a href="../../../content/pdfs/Professional Tax- Haryana.pdf" data-translate="global.menu.Professional Tax- Haryana">Professional Tax- Haryana</a></li><li><a href="../../../content/pdfs/Taxes and Levies in Haryana1.pdf" data-translate="global.menu.State Levies">State Levies</a></li><!--<li><a href="../../../content/pdfs/State Excise Duty-Department of Excise & Taxation.pdf">State Excise Duty-Department of Excise & Taxation</a></li>--><!--<li><a href="http://uhbvn.org.in/staticContent/documents/circular/SC2000/SC_U_12_2000.pdf" target="_blank"><span>Taxes & Duties on Electricity</span></a></li>--><!--<li><a><span>Stamp & Registration Fee</span></a>--><!--<ul class="dropdown-submenu gradient_bg_color1">--><!--<li><a href="http://jamabandi.nic.in/Docs/SDRates.pdf" target="_blank"><span>Rates of Stamp Duty Calculation</span></a></li>--><!--<li><a href="http://jamabandi.nic.in/Docs/Registration%20Fee.pdf" target="_blank"><span>Rates of Registration Fee Calculation</span></a></li>--><!--<li><a href="http://jamabandi.nic.in/StampDuty.aspx" target="_blank"><span>Auto Calculation of Stamp Duty Fee</span></a></li>--><!--</ul>--><!--</li>--></ul></li><!--                                    <li><a ui-sref="meetOurExperts">Meet Our Experts</a></li>--><!--                                                <li><a ui-sref="policyFeedbackDashboard"><span>Policy Feedback</span></a></li>--><!--                                                <li><a ui-sref="servicedashboardyearly"><span>Service Dashboard</span></a></li>--><!--                                                <li><a ui-sref="tracklicense"><span>Track Licenses</span></a></li>--><!--<li> <a ui-sref=""><span>FAQ\'s</span></a> </li>--></ul></li><li><a><span style="font-size: medium" data-translate="global.menu.dashboard">Dashboards</span></a><ul class="gradient_bg_color2"><li><a ui-sref="policy-dashboard"><span>Policy Dashboard</span></a></li><li><a ui-sref="servicedashboardyearly"><span data-translate="global.menu.Service Dashboard">Service Dashboard</span></a></li><!-- EODB Dashboard link hidden\n                                    <li><a ui-sref="eodbdashboardyearly"><span data-translate="global.menu.EODB Dashboard">EODB Dashboard</span></a></li>\n                                    --><li><a href="https://grs.investharyana.in" target="_blank"><span data-translate="global.menu.Grievance Dashboard">Grievance Dashboard</span></a></li><li><a ui-sref="hepcdashboard"><span data-translate="global.menu.Enquiry Dashboard">Enquiry Dashboard</span></a></li><li><a ui-sref="pstowerdashboard"><span data-translate="global.menu.CCIP Dashboard">CCIP Dashboard</span></a></li></ul></li><li><a><span style="font-size: medium" data-translate="global.menu.MSME Policies">MSME Policies</span></a><ul class="gradient_bg_color1"><li ui-sref-active="active"><a class="nav-bar1" ui-sref="conversionOfBoiler" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.CAQM">CAQM</span></a></li><li ui-sref-active="active"><a class="nav-bar1" ui-sref="msmePolicies" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.New Haryana Atamnirbhar policy schemes">New Haryana Atamnirbhar policy schemes</span></a></li><li><a><span data-translate="global.menu.Large/MSMEs Incentives">Large/MSMEs Incentives</span></a><ul class="dropdown-submenu gradient_bg_color3"><li ui-sref-active="active"><a ui-sref="incentiveform" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.Incentives under Enterprise Promotion Policy, 2015">Incentives under Enterprise Promotion Policy, 2015</span></a></li><li ui-sref-active="active"><a ui-sref="incentiveforms({param:\'warehousing\'})" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.Incentives under Haryana Logistics, Warehousing & Retail Policy, 2019">Incentives under Haryana Logistics, Warehousing & Retail Policy, 2019</span></a></li><li ui-sref-active="active"><a ui-sref="incentiveforms({param:\'agriculture\'})" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.Incentives under Haryana Agribusiness & Food Processing Policy, 2018">Incentives under Haryana Agribusiness & Food Processing Policy, 2018</span></a></li><li ui-sref-active="active"><a ui-sref="incentiveforms({param:\'policy2019\'})" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.MSME Policy,2019">MSME Policy,2019</span></a></li><li ui-sref-active="active"><a ui-sref="incentiveforms({param:\'policy2020\'})" ng-click="vm.collapseNavbar()"><span class="hidden-sm" data-translate="global.menu.Haryana Enterprises & Employment Policy 2020">Haryana Enterprises & Employment Policy 2020</span></a></li></ul></li></ul></li><li><a><span style="font-size: medium" data-translate="global.menu.Downloads">Downloads</span></a><ul class="gradient_bg_color1"><li><a><span data-translate="global.menu.Acts">Acts</span></a><ul class="dropdown-submenu gradient_bg_color3"><li><a target="_blank" href="../../../content/pdfs/Haryana_Enterprises_Promotion_Act2016.pdf" data-translate="global.menu.Haryana Enterprises Promotion Act (HEPA)">Haryana Enterprises Promotion Act (HEPA)</a></li><li><a target="_blank" href="../../../content/pdfs/Haryana Enterprises Promotiom (Amendment) Bill, 2021-Notification.pdf" data-translate="global.menu.Haryana Enterprises Promotion (Amendment) Bill, 2021-Notification">Haryana Enterprises Promotion (Amendment) Bill, 2021-Notification</a></li><li><a target="_blank" href="../../../content/pdfs/Haryana Enterprises Promotion (Second Amendment) Act, 2021.pdf" data-translate="global.menu.Haryana Enterprises Promotion (Second Amendment) Act, 2021">Haryana Enterprises Promotion (Second Amendment) Act, 2021</a></li><li><a target="_blank" href="../../../content/pdfs/HEPR2016.pdf" data-translate="global.menu.Haryana Enterprises Promotion Rules (HEPR)">Haryana Enterprises Promotion Rules (HEPR)</a></li><li><a target="_blank" href="../../../content/pdfs/HEP Rules(Amendment)2022.pdf" data-translate="global.menu.Haryana Enterprises Promotion (Amendment) Rules, 2022">Haryana Enterprises Promotion (Amendment) Rules, 2022</a></li><li><a target="_blank" href="../../../content/pdfs/Haryana Enterprises Promotion Rules (2nd Amendment)-2022.pdf" data-translate="global.menu.Haryana Enterprises Promotion (Second Amendment) Rules, 2022">Haryana Enterprises Promotion (Second Amendment) Rules, 2022</a></li><li><a target="_blank" href="../../../content/pdfs/ConsolidatedNotifiedServices.pdf" data-translate="global.menu.Right to Service Act , 2014">Right to Service Act , 2014</a></li><li><a target="_blank" href="http://csharyana.gov.in/WriteReadData/Act/Administrative%20Reforms/4297.pdf" data-translate="global.menu.RTS">RTS</a></li><li><a target="_blank" href="../../../content/pdfs/The-Haryana-Building-Code-2017.pdf" data-translate="global.menu.The Building Code, 2017">The Building Code, 2017</a></li><li><a target="_blank" href="../../../content/pdfs/TheHaryanaBuildingCode20172ndAmendmentforEODB.pdf" data-translate="global.menu.The Building Code, 2017 0 - Amended">The Building Code, 2017 0 - Amended</a></li></ul></li><li><a target="_blank" href="../../../content/pdfs/Haryana-SWS-Relationship Manager.pdf"><span data-translate="global.menu.RM List">RM List</span></a></li><li><a ui-sref="export"><span data-translate="global.menu.Export">Export</span></a></li><li><a ui-sref="eodb-notifications"><span data-translate="global.menu.EoDB_Notifications_2024">EoDB Notifications 2024</span></a></li><li><a ui-sref="third-party-inspection"><span data-translate="global.menu.Third_Party_Inspection">List of Authorized Third Party Inspection Agencies</span></a></li><li><a ui-sref="startup-support"><span data-translate="global.menu.Startup_Support">Startup Support under EoDB</span></a></li><li><a ui-sref="department-best-practices"><span data-translate="global.menu.DepartmentBestPractice">Department\'s Best Practices</span></a></li><li><a><span data-translate="global.menu.EoDB_Notifications_2020">EoDB Notifications 2020</span></a><ul class="dropdown-submenu gradient_bg_color3"><li><a target="_blank" href="../../../content/pdfs/Registration of Travel Agency & Hotels by Tourism Department, GoH.pdf" ng-click="vm.collapseNavbar()"><span data-translate="global.menu.Registration of Travel Agency & Hotels by Tourism Department, GoH">Registration of Travel Agency & Hotels by Tourism Department, GoH</span></a></li><li><a target="_blank" href="../../../content/pdfs/NotificationFIlmShooting.pdf" ng-click="vm.collapseNavbar()"><span data-translate="global.menu.Notification-Film Shooting">Notification-Film Shooting</span></a></li></ul></li><li><a><span data-translate="global.menu.Minutes of Meeting">Minutes of Meeting</span></a><ul class="dropdown-submenu gradient_bg_color3"><li ui-sref-active="active"><a data-toggle="modal" data-target="#mm_meeting" ng-click="vm.meeting_view(\'EEC\')"><span data-translate="global.menu.EEC">EEC</span></a></li><li ui-sref-active="active"><a data-toggle="modal" data-target="#mm_meeting" ng-click="vm.meeting_view(\'HEPB\')"><span data-translate="global.menu.HEPB">HEPB</span></a></li></ul></li><li><a><span data-translate="global.menu.Notices">Notices</span></a><ul class="dropdown-submenu pull-left gradient_bg_color3"><li><a target="_blank" href="../../../content/pdfs/Notification05.07.2018.pdf" data-translate="global.menu.Delegation of power to Nos">Delegation of power to Nos</a></li><li><a target="_blank" href="../../../content/pdfs/LabourDepartmentNotification.pdf" data-translate="global.menu.Exemption from renewals under Shops and Commercial Establishment Act">Exemption from renewals under Shops and Commercial Establishment Act</a></li><li><a target="_blank" href="../../../content/pdfs/hareda366111561.pdf" data-translate="global.menu.HAREDA - Notification">HAREDA - Notification</a></li><li><a target="_blank" href="http://www.egazetteharyana.gov.in/Gazette/Extra-Ordinary/2017/192-2017-Ext/5020.pdf" data-translate="global.menu.HSPCB Timeline">HSPCB Timeline</a></li><li><a target="_blank" href="../../../content/pdfs/NMACircular.pdf" data-translate="global.menu.NMA Circular">NMA Circular</a></li><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Ad_DeputyCOO_BIPP_v4.pdf">Recruitment Notice \u2013 Deputy COO, BIPP</a></li>--><li class="dropdown-submenu pull-left"><a><span data-translate="global.menu.Urban Local Bodies - Notifications">Urban Local Bodies - Notifications</span></a><ul class="dropdown-menu gradient_bg_color1"><li><a target="_blank" href="../../../content/pdfs/Amendment in Haryana Municipal ( Communication and Connectivity Infrastructure) Bye laws 2013.pdf" data-translate="global.menu.Amendment in Haryana Municipal bye laws 2013">Amendment in Haryana Municipal Bye laws 2013</a></li><li><a target="_blank" href="../../../content/pdfs/Amendment in Haryana Municipal Corporation ( Communication and Connectivity Infrastructure) Bye laws 2013.pdf" data-translate="global.menu.Amendment in Haryana Municipal Corporation bye laws 2013">Amendment in Haryana Municipal Corporation Bye laws 2013</a></li><li><a target="_blank" href="../../../content/pdfs/tower bye-laws corporation.pdf" data-translate="global.menu.Tower Bye-Laws Corporation">Tower Bye-Laws Corporation</a></li><li><a target="_blank" href="../../../content/pdfs/tower bye-laws councilc-committee.pdf" data-translate="global.menu.Tower Bye-Laws Council-Committee">Tower Bye-Laws Council-Committee</a></li></ul></li></ul></li><li><a><span data-translate="global.menu.Policies/Schemes">Policies/Schemes</span></a><ul class="dropdown-submenu gradient_bg_color3"><li><a target="_blank" href="../../../content/pdfs/2020_HEEP.pdf" data-translate="global.menu.Haryana Enterprises and Employment Policy 2020">Haryana Enterprises and Employment Policy 2020</a></li><li><a target="_blank" href="../../../content/pdfs/EV Policy 2022.pdf" data-translate="global.menu.EV policy, 2022">EV policy, 2022</a></li><li><a target="_blank" href="../../../content/pdfs/CCIP Policy 2017.pdf" data-translate="global.menu.CCI policy,2017">CCI policy,2017</a></li><li><a data-toggle="modal" data-target="#EPP2015" data-translate="global.menu.Enterprise Promotion Policy, 2015">Enterprise Promotion Policy, 2015</a></li><li><a target="_blank" href="../../../content/pdfs/HARYANASOLARPOLICY-2016.pdf" data-translate="global.menu.Haryana Solar Power Policy-2016">Haryana Solar Power Policy-2016</a></li><li><a data-toggle="modal" data-target="#Agriculture" data-translate="global.menu.Haryana Agri Business and Food Processing Policy 2018">Haryana Agri Business and Food Processing Policy 2018</a></li><li><a target="_blank" href="../../../content/pdfs/IT ESDM.pdf" data-translate="global.menu.IT & ESDM Policy,2017">IT & ESDM Policy,2017</a></li><li><a data-toggle="modal" data-target="#Logistics" data-translate="global.menu.Logistics, Warehousing & Retail Policy, 2019">Logistics, Warehousing & Retail Policy, 2019</a></li><li><a target="_blank" href="../../../content/pdfs/MSME policy.pdf" data-translate="global.menu.MSME Policy, 2019">MSME Policy, 2019</a></li><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/Notification- Haryana Covid emergency credit scheme.pdf">Haryana Covid Emergency Credit Scheme</a>--><!--                                            </li>--><li><a target="_blank" href="../../../content/pdfs/Notified Pharma policy.pdf" data-translate="global.menu.Pharmaceutical Policy,2019">Pharmaceutical Policy,2019</a></li><li><a target="_blank" href="../../../content/pdfs/SIIDSscheme.pdf" data-translate="global.menu.SIIDS Scheme">SIIDS Scheme</a></li><li><a target="_blank" href="../../../content/pdfs/Textile Policy 2019.pdf" data-translate="global.menu.Textile Policy 2019">Textile Policy 2019</a></li></ul></li><li><a><span data-translate="global.menu.SOPs">SOPs</span></a><ul class="dropdown-submenu gradient_bg_color3"><li><a target="_blank" href="../../../content/pdfs/SOPforGrievanceRedressal.pdf" data-translate="global.menu.SOP for Grievance Redressal">SOP for Grievance Redressal</a></li><li><a target="_blank" href="../../../content/pdfs/SOPforInvestorHandlingQueries.pdf" data-translate="global.menu.SOP for handling Investor Queries">SOP for handling Investor Queries</a></li><li><a target="_blank" href="../../../content/pdfs/SOPforHelpdeskatHEPC.pdf" data-translate="global.menu.SOP for Helpdesk at HEPC">SOP for Helpdesk at HEPC</a></li></ul></li><li><a><span data-translate="global.menu.Tenders">Tenders</span></a><ul class="dropdown-submenu gradient_bg_color3"><li><a target="_blank" href="../../../content/pdfs/SWS-DNIT-27-11-2025.pdf">RFP-Invest Haryana</a></li><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/Corrigendum-I.pdf" data-translate="global.menu.Corrigendum No. 1">Corrigendum-I</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/Corrigendum-II.pdf" data-translate="global.menu.Corrigendum No. 2">Corrigendum-II</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/Corrigendum-III.pdf" >Corrigendum No. 3</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/Corrigendum - 21.06.2019.pdf" data-translate="global.menu.Corrigendum No. 3">Corrigendum No. 3</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/Corrigendum - 4.pdf" data-translate="global.menu.Corrigendum No. 4">Corrigendum No. 4</a>--><!--                                            </li>--><!--                                            <li><a target="_blank"--><!--                                                   href="../../../content/pdfs/RFP for data analytics V2.0.pdf" data-translate="global.menu.RFP for Data Analytics">RFP for Data Analytics</a>--><!--                                            </li>--></ul></li><li><a><span data-translate="global.menu.Orders for Essential Services (Lockdown)">Orders for Essential Services (Lockdown)</span></a><ul class="dropdown-submenu gradient_bg_color3"><li><a target="_blank" href="../../../content/pdfs/Order dated 02.05.2021 Lockdown (1).pdf" data-translate="global.menu.Order dated 02.05.2021 Lockdown">Order dated 02.05.2021 Lockdown</a></li><li><a target="_blank" href="../../../content/pdfs/new guidelines dated 01.06.2020.pdf" data-translate="global.menu.New Guidelines dated 01.06.2020 for Industry and other establishments - Unlock 1.0">New Guidelines dated 01.06.2020 for Industry and other establishments - Unlock 1.0</a></li><li><a target="_blank" href="../../../content/pdfs/MHA Order Dt. 30.5.2020 with guidelines on extension of LD in Containment Zones and phased reopening.pdf" data-translate="global.menu.MHA GoI order dated 30.05.2020">MHA GoI order dated 30.05.2020</a></li><li><a target="_blank" href="../../../content/pdfs/New Guidelines Industry 05-19-2020.pdf" data-translate="global.menu.New guidelines dated 18.05.2020 for industries">New guidelines dated 18.05.2020 for industries</a></li><li><a target="_blank" href="../../../content/pdfs/MHAOrderextension_1752020.pdf" data-translate="global.menu.MHA GoI order dated 17-05-2020">MHA GoI order dated 17-05-2020</a></li><li><a target="_blank" href="../../../content/pdfs/New Guidelines dated 06-05-2020 PS Industries.pdf" data-translate="global.menu.New Guidelines dated 06-05-2020 PS Industries">New Guidelines dated 06-05-2020 PS Industries</a></li><li><a target="_blank" href="../../../content/pdfs/Haryana Guidelines - 03.05.2020.pdf" data-translate="global.menu.New guidelines dated 03.05.2020 for industries and other establishments">New guidelines dated 03.05.2020 for industries and other establishments</a></li><li><a target="_blank" href="../../../content/pdfs/GoH Guidelines 19 April 2020.pdf" data-translate="global.menu.GoH Guidelines 19 April 2020">GoH Guidelines 19 April 2020</a></li><li><a target="_blank" href="../../../content/pdfs/GoH Revised Guidelines 30 Apr 2020.pdf" data-translate="global.menu.GoH Revised Guidelines 30 Apr 2020">GoH Revised Guidelines 30 Apr 2020</a></li><li><a target="_blank" href="../../../content/pdfs/MHA 01 May 2020.pdf" data-translate="global.menu.MHA 01 May 2020">MHA 01 May 2020</a></li><li><a target="_blank" href="../../../content/pdfs/DO Lr. Dt. 23.4.2020 to Chief Secretaries with clarification on misplaced apprehensions of Industry..pdf" data-translate="global.menu.DO Lr. Dt. 23.4.2020 to Chief Secretaries with clarification on misplaced apprehensions of Industry">DO Lr. Dt. 23.4.2020 to Chief Secretaries with clarification on misplaced apprehensions of Industry</a></li><li><a target="_blank" href="../../../content/pdfs/MHA Order Dt. 29.4.2020 on movement of migrant workers, pilgrims, tourists, students and other persons.pdf" data-translate="global.menu.MHA Order Dt. 29.4.2020 on movement of migrant workers, pilgrims, tourists, students and other persons">MHA Order Dt. 29.4.2020 on movement of migrant workers, pilgrims, tourists, students and other persons</a></li><li><a target="_blank" href="../../../content/pdfs/MHA Do Ltr Dt. 30.4.2020 to allow unhindered movement of trucks carrying goods.pdf" data-translate="global.menu.MHA GoI DO Ltr Dt. 30.4.2020 to allow unhindered movement of trucks carrying goods">MHA GoI DO Ltr Dt. 30.4.2020 to allow unhindered movement of trucks carrying goods</a></li><li><a target="_blank" href="../../../content/pdfs/Scan frozen period.pdf" data-translate="global.menu.Scan Frozen Period">Scan Frozen Period</a></li><li><a target="_blank" href="../../../content/pdfs/MHA GoI dated 24-03-2020.pdf" data-translate="global.menu.MHA GoI letter dated 24.03.2020">MHA GoI letter dated 24.03.2020</a></li><li><a target="_blank" href="../../../content/pdfs/MHA order dated 25.03.2020 with addendum to Guidelines Dated 24.3.2020.pdf" data-translate="global.menu.MHA order dated 25.03.2020 with addendum in Dated 24.3.2020">MHA order dated 25.03.2020 with addendum in Dated 24.3.2020</a></li><li><a target="_blank" href="../../../content/pdfs/Second Addendum (27.03.2020) to MHA Order on Lockdown Measures.pdf" data-translate="global.menu.Second Addendum (27.03.2020) to MHA Order on Lockdown Measures">Second Addendum (27.03.2020) to MHA Order on Lockdown Measures</a></li><li><a target="_blank" href="../../../content/pdfs/MHA GoI letter dated 29.03.2020.pdf" data-translate="global.menu.MHA GoI letter dated 29.03.2020">MHA GoI letter dated 29.03.2020</a></li><!--                                                        <li><a target="_blank"--><!--                                                               href="../../../content/pdfs/Ad_DeputyCOO_BIPP_v4.pdf">Recruitment Notice \u2013 Deputy COO, BIPP</a></li>--><li><a target="_blank" href="../../../content/pdfs/MoS GoI dated 24-03-2020.pdf" data-translate="global.menu.Ministry of Steel, GoI letter dated 24.03.2020">Ministry of Steel, GoI letter dated 24.03.2020</a></li><li><a target="_blank" href="../../../content/pdfs/Chief Secys of States - MHA Letter (29.3.2020) reg consolidated guidelines and migrant labourers.pdf" data-translate="global.menu.Chief Secys of States reg. consolidated guidelines and migrant labourers">Chief Secys of States reg. consolidated guidelines and migrant labourers</a></li><li><a target="_blank" href="../../../content/pdfs/DG Shipping dated 29-03-2020.pdf" data-translate="global.menu.Directorate General of Shipping, GoI letter dated 29.03.2020">Directorate General of Shipping, GoI letter dated 29.03.2020</a></li><li><a target="_blank" href="../../../content/pdfs/ACS Agriculture letter dated 27.03.2020.PDF" data-translate="global.menu.ACS Agriculture letter dated 27.03.2020">ACS Agriculture letter dated 27.03.2020</a></li><li><a target="_blank" href="../../../content/pdfs/advisory industries.pdf" data-translate="global.menu.Advisory dated 25.03.2020 for Industries during lockdown">Advisory dated 25.03.2020 for Industries during lockdown</a></li><li><a target="_blank" href="../../../content/pdfs/DO Letter dated 3.4.2020 to Chief Secretaries with clarification on smooth flow of essential goods and services.pdf" data-translate="global.menu.DO Letter dated 3.4.2020 to Chief Secretaries on smooth flow of essential goods and services">DO Letter dated 3.4.2020 to Chief Secretaries on smooth flow of essential goods and services</a></li><li><a target="_blank" href="../../../content/pdfs/CS letter dated 5-4-2020.pdf" data-translate="global.menu.Chief Secretary letter dated 05-04-2020">Chief Secretary letter dated 05-04-2020</a></li><li><a target="_blank" href="../../../content/pdfs/MHA_Consolidated_Guidelines_03042020.PDF" data-translate="global.menu.MHA GoI Consolidated Guidelines">MHA GoI Consolidated Guidelines</a></li><li><a target="_blank" href="../../../content/pdfs/MHA order dt 15.04.2020, with Revised Consolidated Guidelines.pdf" data-translate="global.menu.MHA order dated 15.04.2020, with Revised Consolidated Guidelines">MHA order dated 15.04.2020, with Revised Consolidated Guidelines</a></li><li><a target="_blank" href="../../../content/pdfs/D.O. to States reg. containment of Hotspots.pdf" data-translate="global.menu.D.O. to States reg. containment of Hotspots">D.O. to States reg. containment of Hotspots</a></li><li><a target="_blank" href="../../../content/pdfs/MHA GoI oder dated 19.04.2020.pdf" data-translate="global.menu.MHA GoI order dated 19.04.2020">MHA GoI order dated 19.04.2020</a></li><li><a target="_blank" href="../../../content/pdfs/Revenue and Disaster Managment Deptt Haryana order dated 19.04.2020.pdf" data-translate="global.menu.Revenue and Disaster Management Deptt Haryana order dated 19.04.2020">Revenue and Disaster Management Deptt Haryana order dated 19.04.2020</a></li><li><a target="_blank" href="../../../content/pdfs/Industries & Commerce Deptt order dated 19.04.2020.pdf" data-translate="global.menu.Industries & Commerce Deptt order dated 19.04.2020">Industries & Commerce Deptt order dated 19.04.2020</a></li></ul></li><li><a target="_blank" href="../../../content/pdfs/HEPC-Investors-Handbook.pdf"><span data-translate="global.menu.Investors Handbook">Investors Handbook</span></a></li><li><a ui-sref="advertisement"><span data-translate="global.menu.HSIIDC Advertisement">HSIIDC Advertisement</span></a></li><li><a><span data-translate="global.menu.Regulatory Compliance">Regulatory Compliance</span></a><ul class="gradient_bg_color2"><li><a><span data-translate="global.menu.Team Lease Data 05.07.2021">Team Lease Data 05.07.2021</span></a><ul class="dropdown-submenu gradient_bg_color3"><li><a target="_blank" href="../../../content/pdfs/D1_Health_Irrigation_HSPCB_ULB.pdf" data-translate="global.menu.D1_Health_Irrigation_HSPCB_ULB">D1_Health_Irrigation_HSPCB_ULB</a></li><li><a target="_blank" href="../../../content/pdfs/D2 CEI_ULB.pdf" data-translate="global.menu.D2 CEI_ULB">D2 CEI_ULB</a></li><li><a target="_blank" href="../../../content/pdfs/D3_Excise, FCS,Power, TCP, Transport.pdf" data-translate="global.menu.D3_Excise,FCS,Power,TCP,Transport">D3_Excise,FCS,Power,TCP,Transport</a></li><li><a target="_blank" href="../../../content/pdfs/D4_Excise, Transport.pdf" data-translate="global.menu.D4_Excise,Transport">D4_Excise,Transport</a></li><li><a target="_blank" href="../../../content/pdfs/D5 Health, School_ Industries.pdf" data-translate="global.menu.D5 Health, School_ Industries">D5 Health, School_ Industries</a></li><li><a target="_blank" href="../../../content/pdfs/D6_Home.pdf" data-translate="global.menu.D6_Home">D6_Home</a></li><li><a target="_blank" href="../../../content/pdfs/D7_FDA.pdf" data-translate="global.menu.D7_FDA">D7_FDA</a></li><li><a target="_blank" href="../../../content/pdfs/D8_TCP -RERA.pdf" data-translate="global.menu.D8_TCP -RERA">D8_TCP -RERA</a></li><li><a target="_blank" href="../../../content/pdfs/D9_ULB.pdf" data-translate="global.menu.D9_ULB">D9_ULB</a></li><li><a target="_blank" href="../../../content/pdfs/D10_LABOUR -HOME 1_6.pdf" data-translate="global.menu.D10_LABOUR -HOME 1_6">D10_LABOUR -HOME 1_6</a></li><li><a target="_blank" href="../../../content/pdfs/D10_LABOUR_HOME 2_6.pdf" data-translate="global.menu.D10_LABOUR_HOME 2_6">D10_LABOUR_HOME 2_6</a></li><li><a target="_blank" href="../../../content/pdfs/D10_LABOUR_HOME 3_6.pdf" data-translate="global.menu.D10_LABOUR_HOME 3_6">D10_LABOUR_HOME 3_6</a></li><li><a target="_blank" href="../../../content/pdfs/D10_LABOUR_HOME 4_6.pdf" data-translate="global.menu.D10_LABOUR_HOME 4_6">D10_LABOUR_HOME 4_6</a></li><li><a target="_blank" href="../../../content/pdfs/D10_LABOUR_HOME 5_6.pdf" data-translate="global.menu.D10_LABOUR_HOME 5_6">D10_LABOUR_HOME 5_6</a></li><li><a target="_blank" href="../../../content/pdfs/D10_LABOUR_HOME 6_6.pdf" data-translate="global.menu.D10_LABOUR_HOME 6_6">D10_LABOUR_HOME 6_6</a></li></ul></li></ul></li></ul></li><!--                                        <li ui-sref-active="active">--><!--                                            <a ui-sref="eodb">EODB</a>--><!--                                        </li>--><!--                                        <li><a target="_blank"--><!--                                               href="../../../content/pdfs/COVID-19 Passesv2.pdf">--><!--                                            <span class="badge-warning blink_me">Procedure-COVID 19 Grievances</span></a></li>--><li ui-sref-active="active"><a href="https://grs.investharyana.in" target="_blank" style="font-size: medium" data-translate="global.menu.Grievance Redressal">Grievance Redressal</a></li><!--                                        <li><a ui-sref="hepcdashboard"><span>Ticketing/Query Dashboard</span></a></li>--><!--                                        <li><a ui-sref="searchHomeCAF"><span>Third Party Verification</span></a></li>--><li><a ui-sref="searchHomeCAF"><span style="font-size: medium" data-translate="global.menu.Third Party Verification">Third Party Verification</span></a><ul class="gradient_bg_color2"><li><a ui-sref="searchTowerCAF" ng-click="vm.collapseNavbar()" data-translate="global.menu.Tower Services Clearance Status By CAF PIN">Tower Services Clearance Status By CAF PIN</a></li></ul>.</li><li><a ui-sref="contact_us"><span style="font-size: medium" data-translate="global.menu.Contact Us">Contact Us</span></a></li><li><a ng-click="vm.login()"><span style="font-size: medium" data-translate="global.menu.Login/Register"><strong>Login/Register</strong></span></a></li><!--<li class="pull-right"></li>--></ul></nav></div><span class="toggle_menu" ng-click="vm.toggleMenu()"><span></span></span></header></div></div></div><div id="mm_meeting" class="modal fade" role="dialog" style="z-index: 1024"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title">Minutes of Meetings</h4></div><div class="modal-body"><div ng-show="vm.show"><p class="text-center" ng-repeat="minutesofmeeting in vm.minutesofmeetings | orderBy: \'date\':true" ng-show="minutesofmeeting.meeting_type===\'HEPB\'"><a target="_blank" ng-click="vm.downloadFile(minutesofmeeting.serverfilename,minutesofmeeting.downloadfilename)"><span>{{minutesofmeeting.momdescription}}</span></a></p></div><div ng-show="vm.show1"><p class="text-center" ng-repeat="minutesofmeeting in vm.minutesofmeetings | orderBy: \'date\':true" ng-show="minutesofmeeting.meeting_type===\'EEC\'"><a target="_blank" ng-click="vm.downloadFile(minutesofmeeting.serverfilename,minutesofmeeting.downloadfilename)"><span>{{minutesofmeeting.momdescription}}</span></a></p></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div><!-- Modal --><div id="EPP2015" class="modal fade" role="dialog" tabindex="-1" style="z-index: 1024"><div class="modal-dialog" style="width:850px"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title"><b>Enterprise Promotion Policy, 2015</b></h4></div><div class="modal-body"><div class="col-md-12"><div class="col-md-6"><li><a>MSME Award Schemes</a> <span ng-if="!vm.isShowEPP" class="btn-sm" ng-click="vm.more(\'true\')"><i class="glyphicon glyphicon-circle-arrow-down"></i> </span><span ng-if="vm.isShowEPP" class="btn-sm" ng-click="vm.more(\'false\')"><i class="glyphicon glyphicon-circle-arrow-up"></i></span><ul ng-if="vm.isShowEPP"><li><a target="_blank" href="../../../content/pdfs/Scheme_Form_Enterpreneurship_Innovation.PDF">Scheme for Entrepreneurship Innovation</a></li><li><a target="_blank" href="../../../content/pdfs/Scheme_Form_Enterpreneurship_Lean_Manufacturing.PDF">Scheme for Entrepreneurship Lean Manufacturing</a></li><li><a target="_blank" href="../../../content/pdfs/Scheme_Form_Enterpreneurship_Manufacturing.PDF">Scheme for Entrepreneurship Manufacturing</a></li><li><a target="_blank" href="../../../content/pdfs/Scheme_Form_Enterpreneurship_Quality.PDF">Scheme for Entrepreneurship Quality</a></li><li><a target="_blank" href="../../../content/pdfs/Scheme_Form_Enterpreneurship__Service.PDF">Scheme for Entrepreneurship Service</a></li></ul></li><br><li><a target="_blank" href="../../../content/pdfs/Notification_EnterprisesPromotionPolicy2015.pdf">Notification Enterprises Promotion Policy - 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Haryana_Book_Final1.pdf">Enterprise Promotion Policy, 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Re-categorization of blocks 15.11.2018.pdf">Notification of Categorization of Blocks under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/NEGATIVE_LIST.pdf">Notification of Restrictive List under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Notification_HEPB_sws-Final.PDF">Notification of Haryana Enterprise Promotion Board (HEPB) under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Notification_Bureau_of_Industrial_Promotion.PDF">Notification of Bureau of Industrial Policy and Promotion (BIPP) under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/notification_Grievance_Redressal.PDF">Notification of Three Tier Grievances Redressal Committee under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Dispute Settlement Notification.pdf">Notification of Dispute Settlement Committee under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/notification_PMMC.PDF">Notification of Policy Monitoring Mechanism Committee under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/tourism.pdf">Notification of Tourism Sector</a></li><li><a target="_blank" href="../../../content/pdfs/Assistance for Environment Compliance-2015.pdf">Notification of Assistance for Environment Compliance Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Formatted_Final_Draft CLCSS_Tech upgradation.pdf">Notification of modified Credit Linked Interest Subsidy Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Design_Clinic_Scheme_2015.pdf">Notification of Design Clinic Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Energy_Audit_Scheme-2015.pdf">Notification of Energy Audit Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/MDA Market developmnt assistance 2017.pdf">Notification of Market Development Assistance Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Testing_equipment_assistance_Scheme-2015.pdf">Notification of Testing Equipment Assistance Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/State Export Award Scheme - Notification 2015 -1-.pdf">Notification of State Export Award Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Critical Infrastructure Development Scheme.pdf">Notification of Critical Infrastructure Development Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Assistance_for_technology_acquisition-2015.PDF">Notification of Assistance for Technology Acquisition Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Credit_Rating_Scheme_2015.PDF">Notification of Credit Rating Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Electricity_Duty_Exemption_2015.PDF">Notification of Electricity Duty Exemption under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Latest_Handicraft_Awards_Scheme_Notification_2015.PDF">Notification of Handicraft Award Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Patent_Registration_Scheme-2015.PDF">Notification of Patent Registration Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Quality_Certification_Scheme.PDF">Notification of Quality Certification Scheme under EPP 2015</a></li></div><div class="col-md-6"><li><a target="_blank" href="../../../content/pdfs/Safety_Audit_Scheme-2015.PDF">Notification of Safety Audit Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Scheme_for_Setting_up_of_Primary_Processing_Centres.PDF">Notification of scheme for setting up Primary Processing Centres under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Start-ups-scheme2015.pdf">Notification of Start-ups Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Water_Audit_Scheme_2015.PDF">Notification of Water Audit scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/E-commerce_portal_for_MSME.PDF">Notification of E-commerce portal for MSMEs Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Employment_Generation_Subsidy_2015 (1).PDF">Notification of Employment Generation Subsidy Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Frieght Scheme Notification 2016-17.pdf">Notification of Freight Assistance Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/interest_subsidy_2015 (1).PDF">Notification of Interest Subsidy Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/State_Mini_Cluster_Development_Scheme-2015 (1).PDF">Notification of State Mini Cluster Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Interest_Subsidy_for_artisans-2015_Latest.PDF">Notification of Interest subsidy for Artisans Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Marketing_Promotion_Asssistance_Scheme_for_artisan_-2015.PDF">Notification of Marketing Promotion Assistance for Artisans Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/Stamp_Duty_Scheme.PDF">Notification of Stamp Duty Scheme under EPP 2015</a></li><li><a target="_blank" href="../../../content/pdfs/investment subsidy on VAT-2015.pdf">Notification of Investment Subsidy on VAT Scheme</a></li><li><a target="_blank" href="../../../content/pdfs/ASIDE_Scheme_2015_(1) (1).PDF">Notification of ASIDE Scheme</a></li><li><a target="_blank" href="../../../content/pdfs/Infrastructure_Industrial_Development_Scheme-2015_(1).PDF">Notification of Industrial Infrastructure Development Scheme</a></li><li><a target="_blank" href="../../../content/pdfs/Affidavit Declaration Attest notification.pdf">Notification of Affidavit Declaration Attest</a></li><li><a target="_blank" href="../../../content/pdfs/Power Tariff 25.06.2019.pdf">Notification of Power Tariff Subsidy Scheme</a></li><li><a target="_blank" href="../../../content/pdfs/SIIDSscheme.pdf">Notification of SIIDS Scheme</a></li><li><a target="_blank" href="../../../content/pdfs/Notification152.pdf">Notification regarding timelines for Processing of Incentive Applications</a></li><li><a target="_blank" href="../../../content/pdfs/Incentive Timelines Office Order.pdf">Important Circular regarding Incentive Timelines</a></li><li><a target="_blank" href="../../../content/pdfs/Amendment in Freight Assistance scheme.pdf">Amendment in Freight Assistance Scheme</a></li><li><a target="_blank" href="../../../content/pdfs/Market Fee Exemption on pulses and dals .pdf">Notification of Market Fee exemption on pulses</a></li><li><a target="_blank" href="../../../content/pdfs/Revised SGST scheme 08012020.pdf">Notification dated 08.01.2020 of Revised scheme of Investment subsidy on VAT/SGST</a></li><li><a target="_blank" href="../../../content/pdfs/Power to condone delay.pdf">Notification of Power to Condone Delay</a></li><li><a target="_blank" href="../../../content/pdfs/Revised Energy Audit Scheme.pdf">Notification of Revised Energy Audit Scheme</a></li><li><a target="_blank" href="../../../content/pdfs/Haryana MSME Revival Interest Benefit Scheme (1).pdf">Notification of Haryana MSME Revival Interest Benefit Scheme</a></li><li><a target="_blank" href="../../../content/pdfs/notification oversight committee.pdf">Constitution of Oversight Committee for Haryana MSME Revival Interest Benefit Scheme</a></li></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div><div id="Agriculture" class="modal fade" role="dialog" tabindex="-1" data-tab-size="500px" style="z-index: 1024"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title"><b>Haryana Agri Business and Food Processing Policy 2018</b></h4></div><div class="col-md-12"><li><a target="_blank" href="../../../content/pdfs/Haryana Agri Business and Food Processing Policy 2018 .pdf">Haryana Agri-Business and Food Processing Policy 2018</a></li><li><a target="_blank" href="../../../content/pdfs/Haryana Backward and Forward Linkage scheme (1) (1).pdf">Notification of Haryana Backward and Forward Linkage scheme</a></li><li><a target="_blank" href="../../../content/pdfs/Cold Chain Scheme (1).pdf">Notification of Cold Chain Scheme</a></li><li><a target="_blank" href="../../../content/pdfs/Creation Expansion Diversification of Individual Agro and Food Processing Units (1).pdf">Notification of Creation Expansion Diversification of Individual Agro and Food Processing Units</a></li><li><a target="_blank" href="../../../content/pdfs/Integrated Mini food park scheme (1).pdf">Notification of Integrated Mini food park scheme</a></li></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div><div id="Logistics" class="modal fade" role="dialog" tabindex="-1" data-tab-size="500px" style="z-index: 1024"><div class="modal-dialog"><!-- Modal content--><div class="modal-content"><div class="modal-header"><button type="button" class="close" data-dismiss="modal">&times;</button><h4 class="modal-title"><b>Logistics, Warehousing & Retail Policy, 2019</b></h4></div><div class="modal-body"><div class="col-md-12"><li><a target="_blank" href="../../../content/pdfs/Notified LWR policy.pdf">Logistics, Warehousing & Retail Policy, 2019</a></li><li><a target="_blank" href="../../../content/pdfs/Capital subsidy under Pharma.pdf">Capital subsidy under Pharma</a></li><li><a target="_blank" href="../../../content/pdfs/Logistic Policy 2019.pdf">Logistic Policy 2019</a></li><li><a target="_blank" href="../../../content/pdfs/Notification of schemes under LWR Policy2019.pdf">Notification of schemes under LWR Policy2019</a></li></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal">Close</button></div></div></div></div><style>.badge-warning { background-color: red!important;\n        display: inline-block;\n        min-width: 10px;\n        padding: 3px 7px;\n        font-size: 14px;\n        font-weight: bold;\n        line-height: 1;\n        color: #fff;\n        text-align: center;\n        white-space: nowrap;\n        vertical-align: middle;\n        background-color: #777;\n        border-radius: 10px;\n    }\n    .blink_me {\n        animation: blinker 3s linear infinite !important;\n        color:white\n    }\n\n    @keyframes blinker {\n        30% { opacity: 0; color: red; }\n        60% { opacity: 0; color: yellow; }\n    }\n\n    .tooltip .tooltiptext::after {\n        content: "";\n        position: absolute;\n        top: 100%;\n        left: 50%;\n        margin-left: -5px;\n        border-width: 5px;\n        border-style: solid;\n        border-color: black transparent transparent transparent;\n    }\n\n    .sf-menu>li>a {\n        padding-top: 5px; padding-bottom: 55px;\n        margin-top: 15px; margin-bottom: -50px; !important;\n    }\n\n    @-moz-document url-prefix() {\n        .sf-menu>li>a {\n            padding-top: 50px; margin-top: -30px; margin-bottom: -30px; !important;\n        }\n    }\n\n    .dropdown:hover .dropdown-menu {\n        display: block;\n    }\n\n    /*.dropdown-submenu .submenu-toggle {*/\n    /*    position: relative;*/\n    /*}*/\n\n    /*.dropdown-submenu {*/\n    /*    position: relative;*/\n    /*}*/\n\n    .dropdown-submenu .submenu-toggle::after {\n        content: \'\\f0da\';\n        position: absolute;\n        top: 80%;\n        right: 10px;\n        transform: translateY(-50%);\n        font-family: \'FontAwesome\';\n    }\n\n    .dropdown-submenu .sub-dropdown-menu {\n        position: absolute;\n        top: 0;\n        left: 100%;\n        z-index: 1000;\n        min-width: 480px; /* Adjust the minimum width as needed */\n        white-space: normal; /* Allow the submenu items to wrap */\n    }</style>');
$templateCache.put('app/questionnaire/table/dradm.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Registration of Land/Property</td></tr><tr><td>2</td><td>Department</td><td>Department of Revenue and Disaster Management</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>1 day</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Applicable stamp duty to be paid online on the State Treasuries web portal https://egrashry.nic.in/<br>Applicable registration fee to be paid online on the State Treasuries web portal https://egrashry.nic.in/</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Fard Of Jamabandi/Certified Copy Of Original Old Sale Deed/Assessment Of MC/Mutation<br>\u2022 ID Proofs of the parties involved alongwith the ID proofs of witnesses<br>\u2022 Map Plan and Description of Immovable Property.<br>\u2022 Incase of a building/plot, digital photograph of Building/Plot.<br>\u2022 Sale deed along with e-Stamp</td></tr><tr><td>8</td><td>Form submission</td><td>www.jamabandi.nic.in</td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>1. Logon to http://jamabandi.nic.in/DeedTemplates.aspx and download the desired deed template.<br>2. The deeds in word format are editable and can be edited on a computer. Alternately, deeds can also be prepared by registered deed writers in respective tehsil.<br>3. Pay stamp duty (as applicable) in the form of E-Stamp and fill the requisite fields in the respective deed template. Stamp duty can be paid online over the website https://egrashry.nic.in/<br>4. This deed can be used to take appointment for e-registration. Please note that e-Stamp is necessary for taking appointment for deed registration.<br>5. Citizen can book an appointment from respective E-Registration Helpdesk, which are established in all tehsil/sub-tehsil across the state, by showing the deed and choose date and time according to his/her convenience.<br>6. Citizens have to visit the Sub Registrar Office on the requisite date and time alongwith the deed and 2 witnesses<br>7. Based on the comments of Registration Clerk, the Sub-Registrar marks or denies the registration.<br>8. On marking, the deed is fetched into the HARIS, and deed data are recorded in the system. Photograph of party are also recorded into the system, and deed is regularized.<br>9. The regularized deed is presented to the Sub-Registrar, who will sign and deliver the deed to the party</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/questionnaire/table/factlicense.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><!--<i class="icon-th-list"></i>--><!--<h3>8.4 LABOUR DEPARTMENT</h3>--></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Factories License under Factories Act, 1948</td></tr><tr><td>2</td><td>Department</td><td>Labour</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This service can be used by any user for registration, licensing or renewal under Factories Act 1948</td></tr><tr><td>4</td><td>Stage</td><td>Post Establishment.</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>See Annexure:1</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022Signed & scanned copy of Form 2<br>\u2022Copy of factory building plans approval letter<br>\u2022 List of director/ partners<br>\u2022 AOA/MOA/Partnership Deed, only relevant pages may be uploaded<br>\u2022 Board resolution authorizing the Occupier<br>\u2022 Sanctioned load from HVPNL/Latest Electricity Bill<br></td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedur</td><td>\u2022The User has to create his/her Login ID on the Department web Portal by Using his/her operational e-mail ID and password.<br>\u2022After using his/her login ID , the user has to fill the basic information Performa(BIP).This Performa contains all the basic information of the factory like address ,workers, amount of power used, Details of occupier /manager, Manufacturing process & declaration etc.<br>\u2022Forwarding letter-You may state your contentions by writing in text area or uploaded already prepared documents.<br>\u2022Application in Form No. 2-The online application in form no 2 ( system generate form) is submitted, it uses all the data already filled in BIP wherever required.<br>\u2022Automatic fee calculation, information of already fee payments.<br>\u2022Attachment of Documents in addition to copy of Treasury Challans The scanned copy of the documents should be legible and size of the document not to be more than 2 MB.<br>\u2022Actual payment of license fee, if due. Next step is to make payment of balance fee. The system at this steps shows the calculation of fee year wise and enable you to make the payment of balance fee via Online using Debit/Credit Cards / Offline payments.<br>\u2022<a href="https://www.hsiidcesewa.org.in/hsiidcprod/welcomeLink.action#" target="_blank">Click Here </a>and then go to Registration, Grant of factory license, it\'s renewal and amendment under The Factories Act, 1948 and Rules framed thereunder.<br></td></tr></table></div><!-- /widget-content --></div><!-- /widget --></div><br><div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><i class="icon-th-list"></i><h3>ANNEXURE:-1</h3></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Horse Power Install</th><th>Up to 20</th><th rowspan="2">From 21 to 40 (Rs.)</th><th rowspan="2">From 41 to 150(Rs.)</th><th rowspan="2">From 151 to 250 (Rs.)</th><th rowspan="2">From 251 to 500 (Rs.)</th><th rowspan="2">From 501 to 1000 (Rs.)</th><th rowspan="2">From 1001 to 2000 (Rs.)</th><th rowspan="2">From 2001 to 3000</th><th rowspan="2">From 3001 & above</th></tr><tr><th>(Max HP)</th><th>(Rs.)</th></tr></thead><tbody><tr><td>Nil</td><td>1500</td><td>3000</td><td>4500</td><td>6000</td><td>7500</td><td>9000</td><td>10500</td><td>12000</td><td>13500</td></tr><tr><td>Upto 10</td><td>3000</td><td>6000</td><td>9000</td><td>12000</td><td>15000</td><td>18000</td><td>21000</td><td>24000</td><td>27000</td></tr><tr><td>Above 10 Up to 50</td><td>4500</td><td>9000</td><td>13500</td><td>18000</td><td>22500</td><td>27000</td><td>31500</td><td>36000</td><td>40500</td></tr><tr><td>Above 50 Up to 100</td><td>6000</td><td>12000</td><td>18000</td><td>24000</td><td>30000</td><td>36000</td><td>42000</td><td>48000</td><td>54000</td></tr><tr><td>Above 100 Up to 500</td><td>7500</td><td>15000</td><td>22500</td><td>30000</td><td>37500</td><td>45000</td><td>52500</td><td>60000</td><td>67500</td></tr><tr><td>Above 500 Up to 1000</td><td>9000</td><td>18000</td><td>27000</td><td>36000</td><td>45000</td><td>54000</td><td>63000</td><td>72000</td><td>81000</td></tr><tr><td>Above 1000 Up to 2000</td><td>10500</td><td>21000</td><td>31500</td><td>42000</td><td>52500</td><td>63000</td><td>73500</td><td>84000</td><td>94500</td></tr><tr><td>Above 2000</td><td>12000</td><td>24000</td><td>36000</td><td>48000</td><td>60000</td><td>72000</td><td>84000</td><td>96000</td><td>108000</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/forest2.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>5. Forest Department</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Tree felling irrespective of location of land under Punjab Land Preservation Act, 1900</td></tr><tr><td>2</td><td>Department</td><td>Forest Department ( Haryana)</td></tr><tr><td>3</td><td>Applicability criteria</td><td>Permission for tree felling in areas closed under Punjab Land Preservation Act, 1900 (PLPA) and NOC/ Clarification if an area is Reserved or Restricted forest or closed under PLPA.</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Service Charges: Rs. 30/- per application at CSC/e-Disha counter Departmental charges: NIL(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Current Jamabandi clearly mentioning type of land<br>\u2022Consent of all shareholders on affidavit in case of co-Partners<br>\u2022Copy of mutation (only for Agricultural Land)<br>\u2022Copy of Purpose/Administrative sanction for which the trees are to be felled<br></td></tr><tr><td>8</td><td>Form submission</td><td><a href="http://forestsclearance.nic.in/">http://forestsclearance.nic.in/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application.<br>\u2022 Pay fee<br>\u2022 <a href="http://haryanaforest.gov.in/en-us/Forest-Clearance/Forest-Clearances-Instructions/Procedure-and-comprehensive-checklist-of-NOC-in-respect-of-Punjab-Land-Preservation-Act-1900-PLPA-1900-or-Forest-or-Restricted-Lands-Permission-of-Felling-of-Trees" target="_blank">http://haryanaforest.gov.in/en-us/Forest-Clearance/Forest-Clearances-Instructions/Procedure-and-comprehensive-checklist-of-NOC-in-respect-of-Punjab-Land-Preservation-Act-1900-PLPA-1900-or-Forest-or-Restricted-Lands-Permission-of-Felling-of-Trees</a><br>\u2022 Registration under The Building and other Construction Workers ( Regulation of Employment and Conditions of Service) Act, 1996</td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget -->');
$templateCache.put('app/questionnaire/table/hsiidc1.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/ Noc/ License/Registration</td><td>Issue of completion/occupation certificate for factory Building</td></tr><tr><td>2</td><td>Department</td><td>HSIIDC</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all Enterprises.</td></tr><tr><td>4</td><td>Stage</td><td>Post operation</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Online Through HEPC Portal</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 BR-IV-B<br>\u2022 Inspection Report by Architect<br>\u2022 Structure Stability Certificate from Structural Engineer.<br>\u2022 NOC from concerned Fire Office.<br>\u2022 Copy of Regular Letter of Allotment (R.L.A).<br>\u2022 Copy of Possession Letter.<br>\u2022 Marking on copy of Approved Building Plans.<br>\u2022 Photographs of front, rear, and side setbacks and essential areas like cut outs and shafts from Roof top with uneditable CD<br>\u2022 Installation of solar water heating and Solar photovoltaic power plant and NOC from Haryana govt. Renewable energy Department, if applicable<br>\u2022 Clearance from Deptt. Environment under MOEF, GOI notification no. 1533 dated 14.09.2006.<br>\u2022 Undertaking to comply with the provisions of Energy conservation Act, 2001</td></tr><tr><td>8</td><td>Mode of submission of Application for the service .</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022 Architect shall submit documents (as mentioned in the checklist) for grant of Occupation certificate.<br>\u2022 The concerned field office shall inspect the subject building in reference to the site report submitted by the Architect.<br>\u2022 After the site inspection, the case is placed before Building Plan Approval Committee (BPAC). If the Committee observes that the case is clear from Planning, Public Health & Estate point of view then show cause-cum-Demand notice is issued to the allottee mentioning that either he may remove the deviations (if any) done at site from Sanctioned building plans or pay composition fee. If the Committee does not find the case fit for granting the Occupation certificate then observations of the Committee is conveyed to the allottee<br>\u2022 After receiving the composition fee, O.C. is granted by the concerned DTP/STP</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right" ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/hsiidc2.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/ Noc/ License/ Registration</td><td>Building Plan Approval</td></tr><tr><td>2</td><td>Department</td><td>HSIIDC</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre operation</td></tr><tr><td>5</td><td>Given Time Limits</td><td>30 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Scrutiny fees @ 10/- per Sq. mtrs.(only on total proposed covered area) + Malba Fees (For mlaba fees See Annexure)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 In case of plotted industrial and residential building self-certification \u2013 Building Plan Approval Letter from registered Architect.<br>\u2022 In case of all other building submission of Building plans in form BR-I and approval on BR- III required<br>\u2022 Scrutiny Fee Challan<br>\u2022 Malba Fees.<br>\u2022 Regular Letter of Allotment (R.L.A).<br>\u2022 Possession Letter.<br>\u2022 BR \u2013 I<br>\u2022 BR \u2013II<br>\u2022 BR-V A1 / A2<br>\u2022 In case of revised building plans under self-certification then<br>\u2022 Attested legible copy of earlier approved / acknowledged plans<br>\u2022 In case of construction at site, then photographs of the front, rear and side setback and essential areas as cut out, shafts from roof with un-editable CD<br>\u2022 With BR-III / acknowledgment.<br>\u2022 Violation / changes to be compounded<br>\u2022 Occupation certificate granted area.<br>\u2022 Self-certified copy of qualification of structure engineer.<br>\u2022 Acknowledgment shall be conveyed subject to approval of Estate and IA Division</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022 The empanelled architect on receiving request from the allottee will complete the requirements of Rule-39 with regard to submission of building plans and issue permission as prescribed in Rule-44 after ascertaining that proposed building plans are in consonance with provisions of building Bye Laws as contained in Part-VII of the Punjab Scheduled Roads and Controlled Areas Restrictions of Unregulated Development Rules, 1965, zoning plan approved by the Director alongwith other amendments/instructions issued from time to time by the Director in this regard<br>\u2022 Before conveying the approval of building plans to the owner, the Architect, will submit a complete set of building plans alongwith all the necessary documents and scrutiny fee/cess (as mentioned in check list). After submission the Building Plans duly approved by the Registered Architect, the concerned DTP/STP will check the following three components of the proposed building plans:-<br>\u2022 The submission of requisite documents, scrutiny fees/cess and validity of plot.<br>\u2022 The provision of set back and gate position in accordance with approved zoning plan.<br>\u2022 The proposed ground coverage and overall covered area including FAR and maximum height as per building Bye-Laws.<br>\u2022 The concerned DTP/STP within a period prescribed in the Right to Service Act, shall convey deficiencies in writing and through e-mail, if any noticed with regard to above three components, failing which the same shall be considered as having been accepted. In case any errors found at subsequent stage, the concerned dealing official and DTP/STP shall be fully responsible for penal action along with concerned Architect.<br>\u2022 The concerned Architect will issue the approval after receiving the confirmation from concerned DTP/STP, as explained above. In case, no intimation with regard to deficiencies or confirmation is received within prescribed time period in the Right to Service Act, it will be considered as confirmed and the concerned Architect will issue the permission as per Rule-44 to the owner. The Architect will submit a complete set of documents of the permission issued by him, in the O/o concerned DTP/STP.<br>\u2022 <a href="https://www.hsiidcesewa.org.in/hsiidcprod/welcomeLink.action#" target="_blank">Click Here </a>and then go to How to Apply>Building Plan Approval>Procedure for One Time Registration on OBPAS.</td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget --></div><div class="container"><div class="widget-header"><i class="icon-th-list"></i><h3>ANNEXURE:Malba Fees:-</h3></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr No</th><th>Plot Size</th><th>Fees for Approval</th></tr></thead><tbody><tr><td>1</td><td>For plot of size up to 500sqm.</td><td>5000/-</td></tr><tr><td>2</td><td>For plot of size 501 to 1000sqm</td><td>10000/-</td></tr><tr><td>3</td><td>For plot of size 1001 to 4000sqm.</td><td>15000/-</td></tr><tr><td>4</td><td>For plot of size 4001 to 20,000sqm.</td><td>25000/-</td></tr><tr><td>5</td><td>For plot of size 20,001 and above</td><td>50000/-</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right" ui-sref="clearances">Back</button>--></div></div></div><!-- /widget -->');
$templateCache.put('app/questionnaire/table/hsiidc3.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Issuance of permanent water connection</td></tr><tr><td>2</td><td>Department</td><td>HSIIDC</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>See Annexure</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 RLA by Estate Div.<br>\u2022 Plot verification & Physical possession by IA Div.<br>\u2022 Building Plan Approval by IP Div. have been approved/completed on the esewa portal.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application.<br>\u2022 Pay fees<br>\u2022 <a href="https://www.hsiidcesewa.org.in/hsiidcprod/welcomeLink.action#" target="_blank">Click Here </a>and then go to HowToApply>Procedure for obtaining Water Connection.</td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget --></div><div class="container"><div class="widget-header"><i class="icon-th-list"></i><h3>ANNEXURE:-</h3></div><!-- /widget-header --><h3>Water Charges</h3><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr No</th><th>Description</th><th>Tariff C-III</th><th>Tariff C-II</th><th>Tariff C-I</th><th class="td-actions"></th></tr></thead><tbody><tr><td>1</td><td>Industrial/Commercial/institutional</td><td>10/-per KL</td><td>11/-per KL</td><td>12/-per KL</td></tr></tbody></table><h3>Categorization of areas is as under:-</h3><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Category</th><th>Area</th><th class="td-actions"></th></tr></thead><tbody><tr><td>C-I</td><td>Gurgaon, Rewari, Mewat & Faridabad District</td></tr><tr><td>C-II</td><td>Sonepat, Rohtak & Jhajjar District</td></tr><td>C-III</td><td>Rest of the area in the State</td></tbody></table><h3>Minimum monthly charges of 500/- per connection for Industrial/ Commercial/institutional.</h3><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr No</th><th>Description</th><th>Tariff for Industrial/ Commercial/ Institutional</th><th class="td-actions"></th></tr></thead><tbody><tr><td>1</td><td>Water Connection fees</td><td>Rs. 3000/- upto 450 Sqm<br>Rs. 5000/- above 450 Sqm to \xBD acres<br>Rs. 10000/- above \xBD acres to 10 acres<br>Rs. 25000/- above 10 acres</td></tr><tr><td>2</td><td>Water Connection security</td><td>Upto 1 acres:- 10000/-<br>Above 1 acres but upto 5 acres:- 25000/-<br>Above 5 acres:- 50000/-</td></tr></tbody></table><h3>Rate for Industrial/ Commercial/institutional:-</h3><body>The flat rate for Industrial/ Commercial/institutional shall be charged @ 150% of the flat rates for residential/domestic water supply. For the plot area more than 1 acres, the flat rates shall be charged @Rs.15000/- plus 5000/- per additional acres or part thereof per month.</body><h3>Flat Rate for Domestic water supply:-</h3><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr No</th><th>Description</th><th>Tariff Rate per month</th><th class="td-actions"></th></tr></thead><tr><td>1</td><td>EWS, 2M, 3M, single story & more than one story</td><td>100/-</td></tr><tr><td>2</td><td>4 Marla Single Story</td><td>120/-</td></tr><tr><td>3</td><td>4 Marla more than one story</td><td>180/-</td></tr><tr><td>4</td><td>6 Marla Single Story</td><td>180/-</td></tr><tr><td>5</td><td>6 Marla more than one story</td><td>270/-</td></tr><tr><td>6</td><td>8 Marla Single Story</td><td>240/-</td></tr><tr><td>7</td><td>8 Marla more than one story</td><td>360/-</td></tr><tr><td>8</td><td>10 Marla Single Story</td><td>300/-</td></tr><tr><td>9</td><td>10 Marla more than one story</td><td>450/-</td></tr><tr><td>10</td><td>14 Marla Single Story</td><td>400/-</td></tr><tr><td>11</td><td>14 Marla more than one story</td><td>600/-</td></tr><tr><td>12</td><td>1 Kanal Single Story</td><td>500/-</td></tr><tr><td>13</td><td>1Kanal more than single story</td><td>7500/-</td></tr><tr><td>14</td><td>2 Kanal Single Story</td><td>1400/-</td></tr><tr><td>15</td><td>2 Kanal more than single story</td><td>2000/-</td></tr><tr><td>16</td><td>1 acre Single story</td><td>6000/-</td></tr><tr><td>17</td><td>1 acre more than single story</td><td>10000/-</td></tr></table><h3>Road Cutting Charges for water supply:-</h3><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr No</th><th>Description ( Width of Right of Way)</th><th>Amount</th><th class="td-actions"></th></tr></thead><tr><td>1</td><td>12m</td><td>12000/-</td></tr><tr><td>2</td><td>15m</td><td>15000/-</td></tr><tr><td>3</td><td>18m</td><td>18000/-</td></tr><tr><td>4</td><td>24m</td><td>24000/-</td></tr><tr><td>5</td><td>30m</td><td>30000/-</td></tr><tr><td>6</td><td>45m</td><td>45000/-</td></tr><tr><td>7</td><td>60m</td><td>60000/-</td></tr></table></div></div></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right" ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div></div>');
$templateCache.put('app/questionnaire/table/hsiidc4.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-hover"><tbody class="table table-striped table-bordered"><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Issuance of sewerage connection</td></tr><tr><td>2</td><td>Department</td><td>HSIIDC</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre operation</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>See Annexure</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 RLA by Estate Div.;<br>\u2022 Plot verification & Physical possession by IA Div.;<br>\u2022 Building Plan Approval by IP Div. have been approved/completed on the esewa portal.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application.<br>\u2022Pay fees<br>\u2022 <a href="https://www.hsiidcesewa.org.in/hsiidcprod/welcomeLink.action#" target="_blank">Click Here </a>and then go to HowToApply>Procedure for obtaining Sewerage Connection</td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget --></div><div class="container"><div class="widget-header"><i class="icon-th-list"></i><h3>ANNEXURE:-</h3></div><!-- /widget-header --><h3>Sewer Charges</h3><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr No</th><th>Description</th><th>Tariff</th></tr></thead><tbody><tr><td>1</td><td>Industrial/Commercial/institutional</td><td>Per W.C :- 15/- Per month Per Urinal:- 5/- per month Waste water Charges:- Rs. 6/- per KL of 70% of water consumed</td></tr></tbody></table><h3>Sewer Connection Fee & security fee:-</h3><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr No</th><th>Description</th><th>Tariff for Industrial/ Commercial/ Institutional</th><th class="td-actions"></th></tr></thead><tbody><tr><td>1</td><td>Sewer Connection fees</td><td>Rs. 2000/-</td></tr><tr><td>2</td><td>Sewer Connection security</td><td>Upto 1 acre:- 5000/- Above 1 acre but upto 5 acre:- 10000/- Above 5 acre:- 25000/-</td></tr></tbody></table><h3>Cutting Charges for water supply:-</h3><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr No</th><th>Description ( Width of Right of Way)</th><th>Amount</th><th class="td-actions"></th></tr></thead><tbody><tr><td>1</td><td>12m</td><td>12000/-</td></tr><tr><td>2</td><td>15m</td><td>15000/-</td></tr><tr><td>3</td><td>18m</td><td>18000/-</td></tr><tr><td>4</td><td>24m</td><td>24000/-</td></tr><tr><td>5</td><td>30m</td><td>30000/-</td></tr><tr><td>6</td><td>45m</td><td>45000/-</td></tr><tr><td>7</td><td>60m</td><td>60000/-</td></tr></tbody></table><h3>Unauthorized Sewerage connection detected, if any penalty of Rs. 10000/-</h3></div></div></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget -->');
$templateCache.put('app/questionnaire/table/hsiidc5.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Land/Plot allotment</td></tr><tr><td>2</td><td>Department</td><td>HSIIDC</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Online (E-sewa portal )</td></tr><tr><td>7</td><td>Documents Required</td><td><br>\u2022 Project report<br>\u2022 CA certificate of past performance<br>\u2022 CA Certificate of resources of applicant/ promoters<br>\u2022 Photograph<br>\u2022 Copy of Pan Card.<br>\u2022 Scheduled Caste declaration (If applicable)<br>\u2022 Persons with disability declaration (If applicable)</td></tr><tr><td>8</td><td>Form submission</td><td>www.hsiidcesewa.org.in</td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td><br>1. The user can open the home page through the link: www.hsiidcesewa.org.in.<br>2. Press the \'login\' link provided on the upper right corner of the home page.<br>3. The user can now login alongwith the credentials provided to him/her at the time of registration process.<br>4. After successful login the user will be redirected to the user dashboard where the user can see the menu on the left hand side. Which contains info such as:-<br>a. User information<br>b. Advertisement details<br>c. Applied/Allotted plots -<br>d. Download the application<br>5. The application money including processing fee(non-refundable) is required to be deposited through payment gateway/ system generated challan. Payment through any other mode shall not be accepted. Deposit of Lesser amount than the required amount will result in non acceptance/rejection of the application. Please refer to the procedure for making payment for further details.<br>6. The application submission process consists of 4 sections:<br>7. a. Section 1 -Additional information: Information about applicant/ proposal. After completing this section, applicant can either proceed to next section by clicking \'Proceed to bank details\' or can exit for completing the other sections later on by clicking \'Save & Exit\'.<br>b. Section 2- Bank Details: Details of Bank Account for refund of Earnest money in case the applicant is un-successful in allotment of plot. After filling in the details the applicant shall require to accept the terms and conditions for allotment of plot/shed/FF shed. After completing this section, applicant can either proceed to next section by clicking \'Save & Continue\' or can exit for completing the other sections later on by clicking \'Save & Exit\'.<br>c. Section 3- Undertakings: Accept all undertakings. After completing this section, applicant can proceed to next section by clicking \'Save & Continue\'. For completing Section 4, applicant is required to first download the forms required to be uploaded in Section-4 through the \'Download the application documents\' menu on the left hand side of applicant dashboard.<br>d. Section 4- Project report, CA certificate confirming past performance details of applicant/ sister concern, CA Certificate of resources of applicant/ promoters, Scheduled Caste declaration, Persons with disability declaration prepared through the download link alongwith other relevant documents can be uploaded through this section. The documents can be uploaded in one go or in piecemeal. After uploading all the required documents and completing this section, use \'Save & proceed to payment\' button. In case, complete documents have not been uploaded in one go or application is not intended to be submitted at this stage, use \'Save & Exit\' button for completing this section later on by uploading the rest of the documents.<br>8. After successful submission of the application, the applicant shall be taken to the make payment link. The applicant can make either on-line payment through payment gateway or can generate prefilled challan through the system for making payment in offline mode (NEFT/RTGS). The applicant can also use the make payment link available in Applicant/Allottee dashboard. The applicant shall be required to download the acknowledgement through applicant dashboard. The applicant shall be required to send a signed copy of the acknowledgement to HSIIDC within prescribed period as per instructions given in the acknowledgement. The application shall be processed by HSIIDC only after receipt of signed copy of the printed acknowledgement.<br>9. Once the application has been submitted successfully, the applicant will not be allowed to modify/update the data/information. However, provision for re-uploading of documents is allowed in case the same not found in order at the time of scrutiny of application by HSIIDC. Also, the user will be allowed to update some information w.r.t. change of address, E-mail ID, password, bank account details for refund using the Applicant dashboard.<br>\u2022 <a href="https://www.hsiidcesewa.org.in/hsiidcprod/welcomeLink.action#" target="_blank">Click Here </a>and then go to HowToApply>Allotment of Industrial Plots> Procedure for filing the Online Application For Allotment of Industrial Plot.</td></tr></tbody></table></div></div></div>');
$templateCache.put('app/questionnaire/table/inds1.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/ Noc/License/Registration</td><td>Registration under Boiler Act and renewals act 1923.</td></tr><tr><td>2</td><td>Department</td><td>Industries & Commerce Department</td></tr><tr class=""><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr class=""><td>4</td><td>Stage</td><td>Post establishment</td></tr><tr class=""><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr class=""><td>6</td><td>Fee & mode of payment</td><td>As per heating surface area of Boiler and Steam pipeline according to IBR regulation 533 through online mode (See Annexure)</td></tr><tr class=""><td>7</td><td>Documents Required</td><td>MSME/ UAM REGISTRATION NUMBER.<br>Form II<br>Form III<br>Form III C<br>Form IV<br>Radiography report(if any)<br>Ownership Performa<br>Ownership Declaration<br>Boiler Drawing<br>Steam Pipeline drawing<br>Copy of Certificate of Incorporation/ Partnership Deed<br>Inspection fee<br>Purchase bill<br>Material test certificates of pipe and fittings<br>Consent letter of IBR approved boiler erector<br>Consent letter of boiler owner for awarding the work to boiler erector<br></td></tr><tr class=""><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr class=""><td>9</td><td>Acceptance criteria/Procedure</td><td>The application is submitted online by boiler owner with all the prescribed documents as per IBR 1950.<br>Online application along with documents submitted is checked and verified by the CIB<br>If any discrepancy is found in the application and documents, the case is put on hold with intimation to the applicant.<br>The applicant will revert to on hold application and submit the requisite information within 15 days failing which the application will liable to be rejected<br>After completion of online application and documents the Permission letter for start the erection work of boiler and Steam pipeline issue to the applicant.<br>After completing the erection work of boiler and steam pipeline satisfactory the applicant will submit the completion report of boiler owner and boiler erector.<br>Inspection notice issued to the boiler owner for inspection/hydraulic test of boiler and steam pipeline within 10 working days.<br>After inspection Provisional Order/Form V for running the boiler is issued within 03 working days by the CIB<br>Applicant apply for steam test within 30 days after issuing the Provisional order Steam test notice issued to the applicant<br>After steam test Registration no. and Regular Certificate for 12 months will be issued within 07 working days<br><a href="https://haryanaindustries.gov.in/msme/Boiler%20manual.pdf">https://haryanaindustries.gov.in/msme/Boiler%20manual.pdf</a></td></tr></tbody></table></div></div></div><div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><h2>Annexure:-<h2><h3>A:- Fees for Annual Inspection for renewal of certificate</h3><thead><tr><th>Sr No</th><th>Heating Surface Area of Boiler</th><th>Amount of fee</th></tr></thead><tbody class="table table-striped table-bordered"><tr class=""><td>1</td><td>For Boiler rating not exceeding 10 sq.mtrs</td><td>720/-</td></tr><tr class=""><td>2</td><td>For Boiler rating exceeding 10 sq.mtrs but not exceeding 30 sq.mtrs</td><td>960/-</td></tr><tr class=""><td>3</td><td>For Boiler rating exceeding 30sq.mtrs but not exceeding 50sq.mtrs</td><td>1080/-</td></tr><tr class=""><td>4</td><td>For Boiler rating exceeding 50sq.mtrs but not exceeding 70sq.mtrs</td><td>1320/-</td></tr><tr class=""><td>5</td><td>For Boiler rating exceeding 70sq.mtrs but not exceeding 90sq.mtrs</td><td>1560/-</td></tr><tr class=""><td>6</td><td>For Boiler rating exceeding 90sq.mtrs but not exceeding 110sq.mtrs</td><td>1800/-</td></tr><tr class=""><td>7</td><td>For Boiler rating exceeding 110sq.mtrs but not exceeding 200sq.mtrs</td><td>2040/-</td></tr><tr class=""><td>8</td><td>For Boiler rating exceeding 200sq.mtrs but not exceeding 400 sq.mtrs</td><td>2280/-</td></tr><tr class=""><td>9</td><td>For Boiler rating exceeding 400sq.mtrs but not exceeding 600 sq.mtrs</td><td>2640/-</td></tr><tr class=""><td>10</td><td>For Boiler rating exceeding 600sq.mtrs but not exceeding 800sq.mtrs</td><td>2880/-</td></tr><tr class=""><td>11</td><td>For Boiler rating exceeding 800sq.mtrs but not exceeding 1000sq.mtrs</td><td>3240/-</td></tr><tr class=""><td>12</td><td>For Boiler rating exceeding 1000sq.mtrs but not exceeding 1200sq.mtrs</td><td>3840/-</td></tr><tr class=""><td>13</td><td>For Boiler rating exceeding 1200sq.mtrs but not exceeding 1400sq.mtrs</td><td>4320/-</td></tr><tr class=""><td>14</td><td>For Boiler rating exceeding 1400sq.mtrs but not exceeding 1600sq.mtrs</td><td>5040/-</td></tr><tr class=""><td>15</td><td>For Boiler rating exceeding 1600sq.mtrs but not exceeding 1800sq.mtrs</td><td>5400/-</td></tr><tr class=""><td>16</td><td>For Boiler rating exceeding mtrs.1800sq but not exceeding 2000sq.mtrs</td><td>6000/-</td></tr><tr class=""><td>17</td><td>For Boiler rating exceeding 2000sq.mtrs but not exceeding 2200sq.mtrs</td><td>6480/-</td></tr><tr class=""><td>18</td><td>For Boiler rating exceeding 2200sq.mtrs but not exceeding 2400sq.mtrs</td><td>7200/-</td></tr><tr class=""><td>19</td><td>For Boiler rating exceeding 2400sq.mtrs but not exceeding 2600sq.mtrs</td><td>7560/-</td></tr><tr class=""><td>20</td><td>For Boiler rating exceeding 2600sq.mtrs but not exceeding 2800sq.mtrs</td><td>8160/-</td></tr><tr class=""><td>21</td><td>For Boiler rating exceeding 2800sq.mtrs but not exceeding 3000sq.mtrs</td><td>8640/-</td></tr></tbody></h2></h2></table><p><b>Above 3000 Sq.mtrs for every 200 Sq.mtrs or part thereof an addition fee of Rs.600/- shall be charged.</b></p><p><b>B:-Registration of New Boiler</b></p><p><b>1) The fee for inspection of Boilers at the site of construction shall be charge at the rate of Four time the fees for renewal of certificate for a boiler as prescribe in Regulation 385-A</b></p><p><b>2) The fees for examination of plan and the particular of material design and construction of steam pipe at the rate of Rs.200/- for 30 meter of piping or part thereof.</b></p><p><b>3) For heat recovery steam generators with finned tubes, the fee shall be calculated on heating surface area of bare tubes and on one fourth of heating surface area of fins.</b></p></div></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right" ui-sref="clearances">Back</button>--></div></div></div>');
$templateCache.put('app/questionnaire/table/inds2.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-hover"><tbody class="table table-striped table-bordered"><tr><td>Name of approval/ Noc/License/Registration</td><td>Licence to carry on trading of finished lubricating oils/greases/specialists (Regular)</td></tr><tr><td>Department</td><td>Industries & Commerce Department</td></tr><tr class=""><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr class=""><td>Stage</td><td>Post establishment</td></tr><tr class=""><td>Given Time Limits</td><td>45 Days</td></tr><tr class=""><td>Fee & mode of payment</td><td>Rs. 25 in form of DD(Online Through HEPC Portal)</td></tr><tr class=""><td>Documents Required</td><td>Application Form-1 clearly indicating the IS Specification of all the products to be manufactured.<br>List of Lab Equipments.<br>List of Plant & machinery.<br>Manufacturing Process & Flow Chart.<br>Copy of bills of machinery and equipments<br>Copy of allotment letter of HSIIDC/rent agreement/land registry paper in the name of firm as address proof.<br>Valid consent Establish unit from pollution angle issued by Haryana State Pollution Control Board.<br>List of Technical staff with qualification.</td></tr><tr class=""><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr class=""><td>Acceptance criteria/Procedure</td><td>As per Govt. Regulations & Process:<br>Applicant can apply for Manufacturing, Blending, Trading, Packaging or Re-refining services under<br>Lubricating Oils & Grease in the following two categories:<br>If Investment of Applicant is below 10 crores, then flow for the proposed system will be as under:<br>Applicant request will go to the District Industries Centre via online system.<br>The DIC will either approve or disapprove the request based on the verification result.<br>If the request is approved, then License will be issued to the applicant & notification for the same will go to the Headquarter for their records.<br>If the request is disapproved, then the notification will go to the applicant with comments.<br>Then user can do the requested changes or attach the missing documents &amp; same will be sent back to DIC.<br>If Investment of Applicant is above 10 crores, then flow for the proposed system will be as under:<br>Applicant request will go to the Head office via online system.<br>The Head Office will send the request of applicant with documents to the DIC for verification.<br>If the documents are verified, the DIC will forward the request to Head Office with comments &amp; Head Office will issue the License to the applicant.<br>If the request is disapproved by the DIC, then the notification will go back to the applicant<br>Then user can do the requested changes or attach the missing documents & same will be sent back to the DIC for verification.<br>If approved, then DIC will forward the request to Head Office with comments.<br>In case, Head Office found any discrepancy, then same will be intimated to the applicant via online system.<br>Then user can do the requested changes or attach the missing documents & same will be sent back to the Head Office.<br>And Head Office will issue the license.</td></tr></tbody></table></div></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right" ui-sref="clearances">Back</button>--></div></div></div>');
$templateCache.put('app/questionnaire/table/inds3.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-hover"><tbody class="table table-striped table-bordered"><tr><td>Name of approval/ Noc/License/Registration</td><td>Lubricating License for Processing, Manufacturing, Blending, Refining, Compounding, Packaging, Re-refining of Lubricant and grease (provisional)</td></tr><tr><td>Department</td><td>Industries & Commerce Department</td></tr><tr class=""><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr class=""><td>Stage</td><td>Pre establishment</td></tr><tr class=""><td>Given Time Limits</td><td>45 Days</td></tr><tr class=""><td>Fee & mode of payment</td><td>Rs. 25 in form of DD(Online Through HEPC Portal)</td></tr><tr class=""><td>Documents Required</td><td>Application Form-1 clearly indicating the IS Specification of all the products to be manufactured.<br>List of Lab Equipments.<br>List of Plant & machinery.<br>Manufacturing Process & Flow Chart.<br>Copy of bills of machinery and equipments<br>Copy of allotment letter of HSIIDC/rent agreement/land registry paper in the name of firm as address proof.<br>Valid consent Establish unit from pollution angle issued by Haryana State Pollution Control Board.<br>List of Technical staff with qualification.</td></tr><tr class=""><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr class=""><td>Acceptance criteria/Procedure</td><td>As per Govt Regulations & Process:<br>Applicant can apply for Manufacturing, Blending, Trading, Packaging or Re-refining services under<br>Lubricating Oils & Grease in the following two categories:<br>If Investment of Applicant is below 10 crores, then flow for the proposed system will be as under:<br>Applicant request will go to the District Industries Centre via online system.<br>The DIC will either approve or disapprove the request based on the verification result.<br>If the request is approved, then License will be issued to the applicant & notification for the same will go to the Headquarter for their records.<br>If the request is disapproved, then the notification will go to the applicant with comments.<br>Then user can do the requested changes or attach the missing documents &amp; same will be sent back to DIC.<br>If Investment of Applicant is above 10 crores, then flow for the proposed system will be as under:<br>Applicant request will go to the Head office via online system.<br>The Head Office will send the request of applicant with documents to the DIC for verification.<br>If the documents are verified, the DIC will forward the request to Head Office with comments &amp; Head Office will issue the License to the applicant.<br>If the request is disapproved by the DIC, then the notification will go back to the applicant<br>Then user can do the requested changes or attach the missing documents & same will be sent back to the DIC for verification.<br>If approved, then DIC will forward the request to Head Office with comments.<br>In case, Head Office found any discrepancy, then same will be intimated to the applicant via online system.<br>Then user can do the requested changes or attach the missing documents & same will be sent back to the Head Office.<br>And Head Office will issue the license.</td></tr></tbody></table></div></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right" ui-sref="clearances">Back</button>--></div></div></div>');
$templateCache.put('app/questionnaire/table/inds4.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-hover"><tbody class="table table-striped table-bordered"><tr><td>Name of approval/ Noc/License/Registration</td><td>Registration of Firms under Indian Partnership Act. 1932</td></tr><tr><td>Department</td><td>Industries & Commerce Department</td></tr><tr class=""><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr class=""><td>Stage</td><td>Pre establishment</td></tr><tr class=""><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr class=""><td>Fee & mode of payment</td><td>10/-(Online Through HEPC Portal)</td></tr><tr class=""><td>Documents Required</td><td>Proof for principal place of work (Sale deed/Rent deed/Lease deed/ Allotment letter) View Download Verified<br>Partnership Deed (Duly signed and Attested) View Download Verified<br>Application form along with Undertaking of all partners</td></tr><tr class=""><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr class=""><td>Acceptance criteria/Procedure</td><td>The application is submitted online with all the required documents.<br>Online application submitted is checked and verified by concern District Registrar.<br>If any discrepancy is found in the application, the case is put on hold with intimation to the applicant.<br>The applicant will revert to on hold application and submit the requisite information within 07 days failing which the application will liable to be rejected.<br>After completion of online application the final certificate is issued to the applicant.<br>Checklist and procedure for Registration of Firms <a href="https://haryanaindustries.gov.in/msme" target="_blank">Click Here</a></td></tr></tbody></table></div></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right" ui-sref="clearances">Back</button>--></div></div></div>');
$templateCache.put('app/questionnaire/table/inds5.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-hover"><tbody class="table table-striped table-bordered"><tr><td>Name of approval/ Noc/License/Registration</td><td>Licence to carry on trading of finished lubricating oils/greases/specialists (Regular)</td></tr><tr><td>Department</td><td>Industries & Commerce Department</td></tr><tr class=""><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr class=""><td>Stage</td><td>Pre establishment</td></tr><tr class=""><td>Given Time Limits</td><td>45 Days</td></tr><tr class=""><td>Fee & mode of payment</td><td>Rs. 25 in form of DD(Online Through HEPC Portal)</td></tr><tr class=""><td>Details Required</td><td>Application Form-1A.<br>Authority letter of the manufacturer/supplier.<br>Copy of allotment letter of HSIIDC/rent agreement/land paper as address proof.<br>Sale Purchase record of last years<br>Previous lubricating licence in original</td></tr><tr class=""><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr class=""><td>Acceptance criteria/Procedure</td><td>As per Govt. Regulations & Process:<br>Applicant can apply for to carry on trading of finished lubricating oils/greases/specialists under<br>Lubricating Oils & Grease in the following two categories:<br>If Investment of Applicant is below 10 crores, then flow for the proposed system will be as under:<br>Applicant request will go to the District Industries Centre via online system.<br>The DIC will either approve or disapprove the request based on the verification result.<br>If the request is approved, then License will be issued to the applicant & notification for the same will go to the Headquarter for their records.<br>If the request is disapproved, then the notification will go to the applicant with comments.<br>Then user can do the requested changes or attach the missing documents &amp; same will be sent back to DIC.<br>If Investment of Applicant is above 10 crores, then flow for the proposed system will be as under:<br>Applicant request will go to the Head office via online system.<br>The Head Office will send the request of applicant with documents to the DIC for verification.<br>If the documents are verified, the DIC will forward the request to Head Office with comments &amp; Head Office will issue the License to the applicant.<br>If the request is disapproved by the DIC, then the notification will go back to the applicant.<br>Then user can do the requested changes or attach the missing documents & same will be sent back to the DIC for verification.<br>If approved, then DIC will forward the request to Head Office with comments.<br>In case, Head Office found any discrepancy, then same will be intimated to the applicant via online system.<br>Then user can do the requested changes or attach the missing documents & same will be sent back to the Head Office. And Head Office will issue the license.</td></tr></tbody></table></div></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right" ui-sref="clearances">Back</button>--></div></div></div>');
$templateCache.put('app/questionnaire/table/inds6.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-hover"><tbody class="table table-striped table-bordered"><tr><td>Name of approval/ Noc/License/Registration</td><td>Licence to carry on trading of finished lubricating oils/greases/specialists (Provisional)</td></tr><tr><td>Department</td><td>Industries & Commerce Department</td></tr><tr class=""><td>Applicability criteria</td><td>This is applicable for those who are doing trading business of lubricant finished goods</td></tr><tr class=""><td>Stage</td><td>Pre establishment</td></tr><tr class=""><td>Given Time Limits</td><td>45 Days</td></tr><tr class=""><td>Fee & mode of payment</td><td>Rs. 25 in form of DD(Online Through HEPC Portal)</td></tr><tr class=""><td>Details Required</td><td>Application Form-1A.<br>Authority letter of the manufacturer/supplier.<br>Copy of allotment letter of HSIIDC/rent agreement/land paper as address proof.</td></tr><tr class=""><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr class=""><td>Acceptance criteria/Procedure</td><td>As per Govt. Regulations & Process:<br>Applicant can apply for to carry on trading of finished lubricating oils/greases/specialists under<br>Lubricating Oils & Grease in the following two categories:<br>If Investment of Applicant is below 10 crores, then flow for the proposed system will be as under:<br>Applicant request will go to the District Industries Centre via online system.<br>The DIC will either approve or disapprove the request based on the verification result.<br>If the request is approved, then License will be issued to the applicant & notification for the same will go to the Headquarter for their records.<br>If the request is disapproved, then the notification will go to the applicant with comments<br>Then user can do the requested changes or attach the missing documents &amp; same will be sent back to DIC.<br>If Investment of Applicant is above 10 crores, then flow for the proposed system will be as under:<br>Applicant request will go to the Head office via online system.<br>The Head Office will send the request of applicant with documents to the DIC for verification.<br>If the documents are verified, the DIC will forward the request to Head Office with comments &amp; Head Office will issue the License to the applicant.<br>If the request is disapproved by the DIC, then the notification will go back to the applicant.<br>Then user can do the requested changes or attach the missing documents & same will be sent back to the DIC for verification.<br>If approved, then DIC will forward the request to Head Office with comments.<br>In case, Head Office found any discrepancy, then same will be intimated to the applicant via online system.<br>Then user can do the requested changes or attach the missing documents & same will be sent back to the Head Office.<br>And Head Office will issue the license.</td></tr></tbody></table></div></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right" ui-sref="clearances">Back</button>--></div></div></div>');
$templateCache.put('app/questionnaire/table/inds7.html','<script src="../questionnaire.controller.js"></script><div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-hover"><tbody class="table table-striped table-bordered"><tr><td>Name of approval/ Noc/License/Registration</td><td>Approval for modification, alteration, repair of boiler under</td></tr><tr><td>Department</td><td>Industries & Commerce Department</td></tr><tr class=""><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr class=""><td>Stage</td><td>Pre establishment</td></tr><tr class=""><td>Given Time Limits</td><td>45 Days</td></tr><tr class=""><td>Fee & mode of payment</td><td>As per heating surface area of Boiler and Steam pipeline according to IBR regulation 533 through online mode( See Annexure)</td></tr><tr class=""><td>Documents Required</td><td>MSME/ UAM Registration number.<br>Last working certificate in the shape of Form V/ Form VI<br>Radiography report(if any)<br>Modified Boiler drawing (if any)<br>Modified Steam Pipeline drawing(if any)<br>Inspection fee<br>Material test certificates of pipe, tube, plate and fittings as per drawing.<br>Consent letter of IBR approved boiler erector<br>Consent letter of boiler owner for awarding the work to boiler erector.</td></tr><tr class=""><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr class=""><td>Acceptance criteria/Procedure</td><td>The application is submitted online by boiler owner with all the prescribed documents<br>Online application along with documents submitted is checked and verified by the CIB.<br>If any discrepancy is found in the application and documents, the case is put on hold with intimation to the applicant.<br>The applicant will revert to on hold application and submit the requisite information within 10 days failing which the application will liable to be rejected.<br>After completion of online application and documents the Permission letter for start the repair/structural alteration work of boiler and steam pipeline issue to the applicant.<br>After completing the repair/structural alteration work of boiler and steam pipeline satisfactory the applicant will submit the completion report of boiler owner and boiler erector.<br>Inspection notice issued to the boiler owner for inspection/hydraulic test of boiler and steam pipeline within 10 working days<br>After inspection Provisional Order/Form V for running the boiler is issued within 03 working days by the CIB.<br>Applicant apply for steam test within 30 days after issuing the Provisional order<br>Steam test notice issued to the applicant<br>After steam test Regular Certificate will be issued within 07 working days.<br></td></tr></tbody></table><table><h2>Annexure:-<h2><h3>A:- Fees for Annual Inspection for renewal of certificate</h3><thead><tr><th>Heating Surface Area of Boiler</th><th>Amount of fee</th></tr></thead><tbody><tr class=""><td>For Boiler rating not exceeding 10 sq.mtrs</td><td>720/-</td></tr><tr class=""><td>For Boiler rating exceeding 10 sq.mtrs but not exceeding 30 sq.mtrs</td><td>960/-</td></tr><tr class=""><td>For Boiler rating exceeding 30sq.mtrs but not exceeding 50sq.mtrs</td><td>1080/-</td></tr><tr class=""><td>For Boiler rating exceeding 50sq.mtrs but not exceeding 70sq.mtrs</td><td>1320/-</td></tr><tr class=""><td>For Boiler rating exceeding 70sq.mtrs but not exceeding 90sq.mtrs</td><td>1560/-</td></tr><tr class=""><td>For Boiler rating exceeding 90sq.mtrs but not exceeding 110sq.mtrs</td><td>1800/-</td></tr><tr class=""><td>For Boiler rating exceeding 110sq.mtrs but not exceeding 200sq.mtrs</td><td>2040/-</td></tr><tr class=""><td>For Boiler rating exceeding 200sq.mtrs but not exceeding 400 sq.mtrs</td><td>2280/-</td></tr><tr class=""><td>For Boiler rating exceeding 400sq.mtrs but not exceeding 600 sq.mtrs</td><td>2640/-</td></tr><tr class=""><td>For Boiler rating exceeding 600sq.mtrs but not exceeding 800sq.mtrs</td><td>2880/-</td></tr><tr class=""><td>For Boiler rating exceeding 800sq.mtrs but not exceeding 1000sq.mtrs</td><td>3240/-</td></tr><tr class=""><td>For Boiler rating exceeding 1000sq.mtrs but not exceeding 1200sq.mtrs</td><td>3840/-</td></tr><tr class=""><td>For Boiler rating exceeding 1200sq.mtrs but not exceeding 1400sq.mtrs</td><td>4320/-</td></tr><tr class=""><td>For Boiler rating exceeding 1400sq.mtrs but not exceeding 1600sq.mtrs</td><td>5040/-</td></tr><tr class=""><td>For Boiler rating exceeding 1600sq.mtrs but not exceeding 1800sq.mtrs</td><td>5400/-</td></tr><tr class=""><td>For Boiler rating exceeding mtrs.1800sq but not exceeding 2000sq.mtrs</td><td>6000/-</td></tr><tr class=""><td>For Boiler rating exceeding 2000sq.mtrs but not exceeding 2200sq.mtrs</td><td>6480/-</td></tr><tr class=""><td>For Boiler rating exceeding 2200sq.mtrs but not exceeding 2400sq.mtrs</td><td>7200/-</td></tr><tr class=""><td>For Boiler rating exceeding 2400sq.mtrs but not exceeding 2600sq.mtrs</td><td>7560/-</td></tr><tr class=""><td>For Boiler rating exceeding 2600sq.mtrs but not exceeding 2800sq.mtrs</td><td>8160/-</td></tr><tr class=""><td>For Boiler rating exceeding 2800sq.mtrs but not exceeding 3000sq.mtrs</td><td>8640/-</td></tr></tbody></h2></h2></table><p><b>Above 3000 Sq.mtrs for every 200 Sq.mtrs or part thereof an addition fee of Rs.600/- shall be charged.</b></p><p><b>B:-Registration of New Boiler</b></p><p><b>1) The fee for inspection of Boilers at the site of construction shall be charge at the rate of Four time the fees for renewal of certificate for a boiler as prescribe in Regulation 385-A</b></p><p><b>2) The fees for examination of plan and the particular of material design and construction of steam pipe at the rate of Rs.200/- for 30 meter of piping or part thereof.</b></p><p><b>3) For heat recovery steam generators with finned tubes, the fee shall be calculated on heating surface area of bare tubes and on one fourth of heating surface area of fins.</b></p></div></div><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right" ui-sref="clearances">Back</button>--></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control password" id="password" name="password" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="6" ng-maxlength="50" ng-pattern="/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,50}$/" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 6 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p><p class="help-block">Your password must contain atleast one uppercase letter(A-Z), one lowercase letter(a-z), one digit(0-9) and one special character.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" autocomplete="off" readonly="readonly" onfocus="this.removeAttribute(\'readonly\');" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="6" ng-maxlength="50" ng-pattern="/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{6,50}$/" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p><p class="help-block">Your password must contain atleast one uppercase letter(A-Z), one lowercase letter(a-z), one digit(0-9) and one special character.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/questionnaire/table/page1/page1.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>1. Haryana State Pollution Control Board</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Consent for establishment under Water Act, 1974 and the Air Act, 1981</td></tr><tr><td>2</td><td>Department</td><td>Haryana State pollution control board</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all Enterprises(Except White Category industries)</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td><a href="https://hspcb.gov.in/content/Fee.pdf">https://hspcb.gov.in/content/Fee.pdf(Online Through HEPC Portal)</a></td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Site plan/location plan of industry<br>\u2022 Partnership deed/ memorandum of article of association/proprietorship certificate/resolution of board of director<br>\u2022 Land documents such as registration deed/ jamabandi / Rent Deed / lease deed indicating detail of the property.<br>\u2022 Allotment letter of the designated authority if the site of the project is located in the industrial area.<br>\u2022 Brief project report with manufacturing process flow sheet.<br>\u2022 Compliance report of previous consent to operate conditions in a noted from (in case of modernization/expansion only).<br>\u2022 CA certificate regarding capital investment cost w.r.t. land building, plant, and machinery of the proposed project.<br>\u2022 Feasibility report/ scheme of effluent treatment plant/sewage treatment plant, air pollution control devices /HWM with Hydraulic Design calculations based upon the pollution load and prescribed parameter as applicable. \u2022 Clearance / permission in case of the projects falling in the revenue estates covered in the notification no 191(E)</td></tr><tr><td>8</td><td>Form submission</td><td>https://investharyana.in/#/</td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application.<br>\u2022 Pay fees & performance security<br>\u2022 <a href="https://hspcb.gov.in/CTE_NEW_UNITS">https://hspcb.gov.in/CTE_NEW_UNITS</a></td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget --></div><div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>PERFORMANCE SECURITY:-</h3><br>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><h3>Performance Security Fees</h3><table class="table table-striped table-bordered"><tbody><tr><th>Sr No</th><th>Investments & Industries</th><th>Red Category</th><th>Orange/Green category</th></tr><td>1</td><td>Upto 0.5 Crore</td><td>25000/-</td><td>12500/-</td><tr><td>2</td><td>Above 0.5 crore Upto 1.00 crore</td><td>50000/-</td><td>25000/-</td></tr><tr><td>3</td><td>Above 1.00 crore Upto 5.00 crore</td><td>100000/-</td><td>75000/-</td></tr><tr><td>4</td><td>Above 5.00 crore Upto 10.00 crore</td><td>200000/-</td><td>150000/-</td></tr><tr><td>5</td><td>Above 10.00 crore Upto 50.00 crore</td><td>300000/-</td><td>200000/-</td></tr><tr><td>6</td><td>Above 50.00 crore Upto 100.00 crore</td><td>400000/-</td><td>250000/-</td></tr><tr><td>7</td><td>Above 100.00 crore</td><td>500000/-</td><td>300000/-</td></tr><tr><td>8</td><td>Stone crusher/Screening Plant/Hot mbc plant</td><td>50000/-</td><td></td></tr><tr><td>9</td><td>Brick Kilns</td><td>25000/-</td><td></td></tr><tr><td>10</td><td>Mining<br>a)More Than 10 Hectares<br>b)5 to 10 Hectares<br>c)Less than 5 Hectare</td><td><br>500000/-<br>250000/-<br>100000/-</td><td></td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page14/page14.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>2.1 UHBVN DEPARTMENT</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval /Noc/License/Registration</td><td>Release of permanent/regular electric connection,Indian electricity Act, 2003</td></tr><tr><td>2</td><td>Department</td><td>UHBVN/DHBVN</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries( Optional)</td></tr><tr><td>4</td><td>Stage</td><td>Post operation</td></tr><tr><td>5</td><td>Given Time Limits</td><td>See annexure:-</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>HT ISC Connection (Above 50 KW Load) HT 11 KV Connection ADVANCE CONSUMPTION DEPOSIT (SECURITY) Rs. 1000/- per KW Processing Charges Rs. 25/- KW Service connection Charges = Rs.2000/- Per KVA (as per latest norms of the Nigam )(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Proof of Ownership / Legal occupation of the premises.<br>Copy of sale deed/allotment letter or lease deed or rent deed in the name of the applicant<br>Property tax receipt or tax demand notice as proof of ownership and rent deed or any other legal proof of being a tenant and paying rent as proof of occupancy.<br>For agriculture supply connection\u2010 a copy of Khasra Girdawari/Jamabandi in the name of applicant<br>\u2022Proof of identity<br>Electoral identity card.<br>Passport<br>Driving license<br>Ration card<br>Photo identity card issued by a Govt. Agency<br>Pan card<br>Aadhar card<br>\u2022 Where the applicant is a Company, Trust, Educational Institution, Govt. Deptt., the application form shall be signed by an authorized person along with a relevant resolution/authority letter of the company/institution concerned. In case of a registered company all the Directors shall be jointly and severely liable.<br></td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application.<br>\u2022 Payment of Fees</td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget --></div><br><div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><i class="icon-th-list"></i><h3>Annexure:-</h3><h4><b>Time Lines for Release of Connection</b></h4></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><th rowspan="2">Sr no.</th><th rowspan="2">Activity</th><th colspan="4">Time allowed (in days) for connections on</th></tr><tr><td>LT</td><td>11KV</td><td>33KV</td><td>Above 33KV</td></tr><tr><td>1</td><td>Acknowledgement of receipt of complete Application<br>Intimating Deficiencies to the applicant Attending Deficiencies by the applicant.</td><td colspan="4">Immediate<br>Within 2 days from the date of receipt of Application<br>Within 7 Days</td></tr><tr><td>2</td><td>Inspection of consumer premises</td><td colspan="4">Within 7 days from the date of receipt of complete application.</td></tr><tr><td>3</td><td>To issue the demand notice</td><td>7</td><td>14</td><td>20</td><td>25</td></tr><tr><td>4</td><td>Time limit for complying with the demand notice by the applicant</td><td colspan="4">Valid for 2 months in case of LT connections and 3 months in case of HT & AP connections, which may be further extended as per the Electricity Supply code on the request of consumer after paying the extension charges</td></tr><tr><td>5</td><td>To carry out inspection and Testing of consumer\u2019s installation by the licensee.</td><td>5</td><td>15</td><td>20</td><td>25</td></tr><tr><td>6</td><td>To issue service connection order.</td><td>5</td><td>5</td><td>5</td><td>10</td></tr><tr><td>7</td><td>Time limit for licensee/ applicant to complete the work required for Providing electric supply.</td><td>10</td><td>30</td><td>45</td><td>100</td></tr><tr><td>8</td><td>Time limit for release of connection to the applicant after completion of the work.</td><td>3</td><td>7</td><td>7</td><td>7</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page16/page16.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval /Noc/License/Registration</td><td>Change Of Land Use Under Controlled Area under Act\u201D1963\u201D</td></tr><tr><td>2</td><td>Department</td><td>Town & Country Planning</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable for those industries who have their own land under controlled area. Then it is required</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>10/- per sq. m & , Conversion charges, scrutiny fees( as per potential zone )(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022Prescribed Form CLU-I<br>\u2022Name of applicant<br>\u2022Address, Email, Aadhar<br>\u2022Memorandum and Article of Association in case of company<br>\u2022Board Resolution of company and authority letter in favour of authorized signatory<br>\u2022Purpose for which CLU permission is sought<br>\u2022Jamabandi<br>\u2022Mutation<br>\u2022Takseem Intkal<br>\u2022Ex-shajra Plan issued by Halka Patwari<br>\u2022Area in Sqm/acres<br>\u2022Village<br>\u2022Controlled Area and date of notification<br>\u2022Development plan<br>\u2022Zone/Sector No<br>\u2022Width of approach<br>\u2022Access permission, if site is situated on scheduled road / National Highway/ State Highway<br>\u2022Area falling within road widening, green/restricted belt, if any<br>\u2022Scrutiny fee<br>\u2022Status of construction at site<br>\u2022HT Line/Gas pipeline passing through the site, if any<br>\u2022Any other issues involved e.g. Notification 07.05.1992 and PLPA<br>\u2022Distance from KMP Express Highway if any applicable<br>\u2022Status of NCZ area vis-\xE0-vis SRP and RRP<br>\u2022Status w.r.t. land acquisition proceedings, if any<br>\u2022Total estimated cost of the project.<br>\u2022Comments on the documents submitted in support of Means of finance<br><b>Industrial Purpose:-</b><br>\u2022Registration of SSI or Medium or Large Industry<br>\u2022Whether polluted or not polluted<br>\u2022NOC from pollution<br><b>Institutional (School, College, Hospital or Religious):-</b><br>\u2022Genuineness certificate<br>\u2022Technical capacity to run the institution<br>\u2022Past experience etc<br>\u2022Recommendation of Health Department in case of Hospital with Collage<br><b>Petrol Pump:-</b><br>\u2022LOI of Oil Company<br>\u2022Distance from existing road junction<br>\u2022Distance from existing Petrol Pump<br></td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Duly filled application form.<br>\u2022 List of supporting documents attached with the application as per requirement.<br>\u2022 pay scrutiny fees.<br>\u2022 Workflow & Checklist for Change of land use(CLU) <a href="https://tcpharyana.gov.in/Order_building_plan.htm">Click Here</a></td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page17/page17.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>3.1 TOWN & COUNTRY PLANNING</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval /Noc/License/Registration</td><td>License of brick kilns , charcoal kilns, stone crusher</td></tr><tr><td>2</td><td>Department</td><td>Town & Country Planning</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable for those who wants to manufacturer, sell or supply bricks.</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>1500 for (new & renewal)(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Applicant & Authorized contact person detail.<br>\u2022 Address detail.<br>\u2022 Site parameter and other detail.<br>\u2022 Ownership & land detail.<br>\u2022 Location of the proposed bricks kilns.<br>\u2022Killa no.<br>\u2022 Khavt number, khasra number.<br></td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Dully filled application form.<br>\u2022 List of supporting documents attached with the application as per requirement.<br>\u2022 pay fees.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page2/page2.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>PERFORMANCE SECURITY:-</h3><br>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><th>Sr No</th><th>Investments & Industries</th><th>Red Category</th><th>Orange/Green category</th></tr><td>1</td><td>Upto 0.5 Crore</td><td>25000/-</td><td>12500/-</td><tr><td>2</td><td>Above 0.5 crore Upto 1.00 crore</td><td>50000/-</td><td>25000/-</td></tr><tr><td>3</td><td>Above 1.00 crore Upto 5.00 crore</td><td>100000/-</td><td>75000/-</td></tr><tr><td>4</td><td>Above 5.00 crore Upto 10.00 crore</td><td>200000/-</td><td>150000/-</td></tr><tr><td>5</td><td>Above 10.00 crore Upto 50.00 crore</td><td>300000/-</td><td>200000/-</td></tr><tr><td>6</td><td>Above 50.00 crore Upto 100.00 crore</td><td>400000/-</td><td>250000/-</td></tr><tr><td>7</td><td>Above 100.00 crore</td><td>500000/-</td><td>300000/-</td></tr><tr><td>8</td><td>Stone crusher/Screening Plant/Hot mbc plant</td><td>50000/-</td><td></td></tr><tr><td>9</td><td>Brick Kilns</td><td>25000/-</td><td></td></tr><tr><td>10</td><td>Mining<br>a)More Than 10 Hectares<br>b)5 to 10 Hectares<br>c)Less than 5 Hectare</td><td><br>500000/-<br>250000/-<br>100000/-</td><td></td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page21/page21.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>3.2 TOWN & COUNTRY PLANNING</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>NOC For Unit Outside controlled / Urban Area</td></tr><tr><td>2</td><td>Department</td><td>Town & Country Planning</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable for those industries who have their land falling outside controlled area/Urban area</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>No Fees</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Applicant & Authorized contact person detail.<br>\u2022 Address detail.<br>\u2022 Site parameter and other detail.<br>\u2022 Ownership & land detail.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Dully filled application form.<br>\u2022 List of supporting documents attached with the application as per requirement.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page22/page22.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>3.3 TOWN & COUNTRY PLANNING</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>NOC For Unit Under Urban Area Act \u201C1975\u201D</td></tr><tr><td>2</td><td>Department</td><td>Town & Country Planning</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable for those who have their land falling under urban area.</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days( from the date of receipt of complete documents)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>No Fees</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Applicant & Authorized contact person detail. \u2022 Address detail. \u2022 Site parameter and other detail. \u2022 Ownership & land detail.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Dully filled application form. \u2022 List of supporting documents attached with the application as per requirement.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page23/page23.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>3.4 TOWN & COUNTRY PLANNING</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Completion certificate/Occupation Certificate</td></tr><tr><td>2</td><td>Department</td><td>Town & Country Planning</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable for all.</td></tr><tr><td>4</td><td>Stage</td><td>Post Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>08 Days ( 07 Days for inspection & 01 Day for OC issuance)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>\u2022 Fees @ Rs. 10/- Sqm. of the total built-up area<br>\u2022 Labour cess @ Rs. 600/- Sqft. for RCC and Rs. 450/- Sqft for shed on total built-up area(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Application on prescribed Form BR-IV.<br>\u2022 Name of the Applicant / Company<br>\u2022 Date of CLU<br>\u2022 Area in Sqm./Acres<br>\u2022 Validity of CLU<br>\u2022 Structural Certificate on prescribed BR-V(1) for a height upto 14.50 metres and Form-BR-V(2) for height above 14.50 metres alongwith copy of qualification /degree of the certifying Engineer<br>\u2022 Scrutiny fees @ Rs. 10/- Sqm. of the total built-up area<br>\u2022 Labour cess @ Rs. 600/- Sqft. for RCC and Rs. 450/- Sqft. for shed on total built-up area<br>\u2022 No dues certificate regarding Labour Cess<br>\u2022 Approval of Building plans and verification of services laid down at site<br>\u2022 Compliance of the CLU Conditions<br>\u2022 Status of payment of EDC<br>\u2022 Status of development works carried out at site alongwith photograph and video CD/DVD<br>\u2022 Approval from any other authorities, as required<br>\u2022 NOC from MOEF, if built-up area is more than 20,000 Sqm<br>\u2022 NOC regarding Fire safety, if applicable<br>\u2022 NOC from HAREDA regarding installation of Solar Water Heating System, if applicable<br>\u2022 Access permission taken from XEN or NHAI, if the site abuts on Schedule road or NH<br>\u2022 As-built drawing duly singed by Owner and Architect</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Dully filled application form.<br>\u2022 List of supporting documents attached with the application as per requirement.<br>\u2022 pay fees.<br>\u2022 <a href="https://tcpharyana.gov.in/Notifications_Judgements/Workflow_OccupationCertificate.pdf">https://tcpharyana.gov.in/Notifications_Judgements/Workflow_OccupationCertificate.pdf</a></td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page24/page24.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>3.5 TOWN & COUNTRY PLANNING</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Building Plan Approval</td></tr><tr><td>2</td><td>Department</td><td>Town & Country Planning</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable for all.</td></tr><tr><td>4</td><td>Stage</td><td>Pre Operational</td></tr><tr><td>5</td><td>Given Time Limits</td><td>30 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Fees @ Rs. 10/- Sqm. of the total built-up area/ Labour cess @ Rs. 600/- Sqft. for RCC and Rs. 450/- Sqft. for shed on total built-up area(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Date of application on prescribed BR-I & BR-II submitted for approval of building plans.<br>\u2022 Name of the Applicant / Company<br>\u2022 Date of CLU<br>\u2022 Area in Sqm./Acres<br>\u2022 Validity of CLU<br>\u2022 Structural Certificate on prescribed BR-V(1) for a height upto 14.50 metres and Form-BR-V(2) for height above 14.50 metres alongwith copy of qualification /degree of the certifying Engineer<br>\u2022 Scrutiny fees @ Rs. 10/- Sqm. of the total built-up area<br>\u2022 Structural drawings duly signed by Structural Engineer<br>\u2022 Status of payment of EDC<br>\u2022 Approval from any other authorities, as required<br>\u2022 Three sets of building plans:- (1) The site plan shall be drawn to a scale not less than:- a) 1:200 for sites upto 1000 Sqm b) 1:400 for sites above 1000 Sqm. and upto 4500 Sqm. c) 1:800 for sites of 4500 Sqm. and above (2) The building plans shall be drawn to a scale not less than:- a) 1:50 for sites upto 1000 Sqm b) 1:100 for sites above 1000 Sqm. but less than 2000 Sqm c) 1:200 for sites above 2000 Sqm (3) The Public Health Services should be earmarked on the plans (4) Two sets should be cloth mounted /laminated duly signed by Owner and Architect</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Dully filled application form.<br>\u2022 List of supporting documents attached with the application as per requirement.<br>\u2022 pay fees.<br>\u2022 <a href="https://tcpharyana.gov.in/Notifications_Judgements/Workflow_Building%20Plan.pdf">https://tcpharyana.gov.in/Notifications_Judgements/Workflow_Building%20Plan.pdf</a></td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page25/page25.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>4. EXCISE & TAXATION DEPARTMENT</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>GST/VAT/CST Registration</td></tr><tr><td>2</td><td>Department</td><td>Excise & Taxation Department</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre Operational</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>500/- For Vat registration & 25/- for CST registration(Through Online on haryanatax.gov.in)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Copy of Partnership Deed, Memorandum and Articles of Association, as the case may be<br>\u2022 Proof of permanent residential address.<br>\u2022 Antecedents of Proprietor / Partners or Directors.<br>\u2022 Copy of ownership deed / rent receipts of place of business/place of residence, leave and license agreement or consent letter if sub- tenant.<br>\u2022 Copy of rationing card of Proprietor/Partners with photocopy of the first and last pages.<br>\u2022 Two latest passport size photographs of the Applicant. \u2022 Copy of PAN Card.<br>\u2022 Latest Returns / Challans position in case of shifting of place of business and change in the constitution.<br>\u2022 Required Court Fee Stamp for CST Registration Certificate application except for shifting.<br>\u2022 Challan in original in payment of registration fees.<br>\u2022 Requirement specific for registration on account of change in the constitution or transfer of business: Copy of Partnership Deed, Dissolution Deed, or Transfer Deed as the case may be Latest Returns / Challans position.<br>A copy of the last assessment order<br>No dues certificate from the dealer</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Dully filled application form.<br>\u2022 List of supporting documents attached with the application as per requirement.<br>\u2022 Pay Fees</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page26/page26.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>5. Forest Department</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Forest clearance for approach public entry/exit and diversion of forest land- under Forest Conservation Act, 1980</td></tr><tr><td>2</td><td>Department</td><td>Forest Department ( Haryana)</td></tr><tr><td>3</td><td>Applicability criteria</td><td>Every user agency, who wants to use any forest land for non-forest purposes needs to apply seeking prior approval by State Government under FCA act 1980</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Fees:- See Annexure (Through Challan Auto generated on the website of department after submit application)(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Form A<br>\u2022 Site plan/location plan of industry<br>\u2022 Demand letter of the project authority/ applicant, if submitted<br>\u2022 Map of the project site/forest area required clearly showing forest boundaries and adjoining<br>\u2022 Layout plan of project site approved by competent authority. In case of linear diversion of forest land,<br>\u2022 Certificate from the Collector/Deputy Commissioner that no alternative suitable non-forest land is available for the project in Question.<br>\u2022 Justification for locating the project in forest area to be submitted by User Agency and countersigned by DFO<br>\u2022 In case of proposal which requires entry/exit through Protected Forest strips along roads/railway lines/canals, the following information/documents must be given :-<br>i> No Objection Certificate (NOC) of the land owning agency i.e. NHAI/PWD, Railways or Canal/ Irrigation Department<br>ii> Change of Land Use certificate from Town and Country Planning/ any other competent authority.<br>iii> Forest land layout plan<br>iv> Own land layout plan<br>v> Digital map<br>vi> Service sheet/topo sheet<br>* If area more than 20 acre , environment noc required</td></tr><tr><td>8</td><td>Form submission</td><td><a href="http://forestsclearance.nic.in/">http://forestsclearance.nic.in/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Duly filled form( Online)<br>\u2022 List of supporting documents attached with the application.<br>\u2022 Generating Challan<br>\u2022 Pay fee</td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget --></div><br><div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><i class="icon-th-list"></i><h3>ANNEXURE:-</h3><br><h3>NPV & CA cost to be deposited by UA For Non-Forestry use/ Diversion of Forest Land:-</h3></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><th>Sr No</th><th>Particular</th><th>Fees</th></tr><td>1</td><td>NPV for All Forest Land except National Parks and Sanctuaries</td><td>8,87,000/- per hectare</td><tr><td>2</td><td>NPV for Forest Lands falling in NP<br>(Permission to be given only in case of unavoidable circumstances</td><td>10 times of above(8,87,000*10)</td></tr><tr><td>3</td><td>NPV for Forest Lands falling in Sanctuary Area</td><td>5 times of above(8,87,000*10)</td></tr><tr><td>4</td><td>The UA has to plant twice the no. of plants felled for the project and the CA cost</td><td>371/- per plant</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page3/page3.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>1.1 Haryana State Pollution Control Board</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Consent to operate under Water Act, 1974 and the Air Act, 1981</td></tr><tr><td>2</td><td>Department</td><td>Haryana State pollution control board</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all Enterprises</td></tr><tr><td>4</td><td>Stage</td><td>Post Operation</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td><a href="https://hspcb.gov.in/content/Fee.pdf">https://hspcb.gov.in/content/Fee.pdf(Online Through HEPC Portal)</a></td></tr><tr><td>7</td><td>Documents Required</td><td><b>A ) Industrial project</b><br>\u2022 Consent to operate application in prescribed format online \u2022 Adequate fees prescribed for obtaining consent to operate, along with latest audited balance sheet<br>\u2022 Compliance to the conditions stipulated in consent to establish (CTE) issued by the Board for 1st time consent to operate case. \u2022. In case of renewal of consent to operate (CTO), compliance status to the conditions stipulated in previous consent to operate order/ conditions of bank guarantee (if any) issued by the Board / directions if any issued for time bound compliance<br>\u2022 Copy of Environmental Clearance of Ministry of Environment, Forest & Climate Change (MOEF&CC)/State Environmental Impact Assessment Authority (SEIAA) (if applicable).. \u2022 Latest layout map of the factory<br>\u2022 Copy of latest environmental statement. \u2022 Process flow chart and detailed manufacturing process<br><b>B) Mining Project</b> \u2022Consent to operate application in prescribed format online.<br>\u2022 Adequate fees prescribed for obtaining consent to operate. \u2022 Copy of Environmental Clearance of Ministry of Environment, Forest & Climate Change (MoEF & CC) / State Environmental Impact Assessment Authority (SEIAA) (if applicable).<br>\u2022 Copy of Consent to Establish order. \u2022 In case of consideration of fresh consent to operate, compliance status of the conditions stipulated in consent to establish (CTE) issued by the Board.<br>\u2022 In case of renewal of consent to operate (CTO), compliance status to the conditions stipulated in previous consent to operate order issued by the Board. \u2022 Copy of lease deed/renewal executed.<br>\u2022 Copy of latest approved mining plan & mine closure plan. \u2022 Copy of Forest Clearance/Temporary Working Permission order.<br>\u2022 Copy of last IBM return. \u2022 Copy of last Environmental Statement</td></tr><tr><td>8</td><td>Form submission</td><td>https://investharyana.in/#/</td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application.<br>\u2022 Pay fees<br>\u2022 <a href="https://hspcb.gov.in/CTO_NEW_UNITS">https://hspcb.gov.in/CTO_NEW_UNITS</a></td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page4/page4.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>1.2 Haryana State Pollution Control Board</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Registration/ Authorization under e-waste (Management & Handing) Rules, 2011</td></tr><tr><td>2</td><td>Department</td><td>Haryana State pollution control board</td></tr><tr><td>3</td><td>Applicability criteria</td><td>Those who involved E- waste in their project</td></tr><tr><td>4</td><td>Stage</td><td>Post Operation</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>No Fees</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Dully Filled up application form -1<br>\u2022 Copy of Consent to establishment (CTE) granted by the board<br>\u2022 Copy of valid Consent to operate ( CTO) under water Act,1974 And Air Act, 1981 granted by the board.<br>\u2022 Occupier/Authorized person certified issued by the management Of the applicant industry.<br>\u2022 Copy of emergency response plan regarding procedure for dealing with emergency situations (viz. spillage or release or fire) as specified in the guideline of CPCB(refer column no .4 of part A of application form)<br>\u2022 Undertaking or deceleration to comply with all provisions including the scope of submitting bank guarantee in the spillage ,leakage or fire while handling the hazardous and Other waste.<br>\u2022 Plan showing the detail of secured storage of waste With storage capacity including mode of disposal.<br>\u2022 Process flow sheet indicating equipment detail</td></tr><tr><td>8</td><td>Form submission</td><td>https://investharyana.in/#/</td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Duly filled form<br>\u2022 After the receipt of the complete case, inspection shall be carried out by a team of officers of the Regional office concerned consisting of the regional officer and concerned AEE/Scientist B of the region to verify the whether the applicant is utilizing environmentally sound technologies and possesses adequate technical capabilities, requisite facilities and equipment as per guideline /standard operating procedures issued by CPCB.<br>\u2022 The regional officer will submit the verification report on the prescribed format given at Annexure \u2013ii along with one copy of form -1 and all original documents submitted by the applicant ,within 21 days to the head office giving definite recommendations for refusal or grant of authorization as the case may be ,on the merit of the case.<br>\u2022The authorization shall be issued in the prescribed form-2 along with the prescribed passbook as per the pattern of CPCB to maintain the records of waste procured by the applicant for processing for reuse/recycling/recovery/preprocessing/utilization including co-processing and copy of field inspection report signed by the concerned officer of the board indicating the adequacy of facilities for processing the waste as per rule 3 or will be refused after following the due procedure as the case may be , based upon the recommendations of regional officers with the approval of the competent Authority. \u2022 The status of unit authorized by the Board of actual users of waste will be displayed on the website of the board under the heading \u201CAuthorization Actual user of hazardous and other waste of Haryana( except for the recycler of waste Listed in Schedule-IV) immediately after Authorization is issued by the Board.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page5/page5.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>1.3 Haryana State Pollution Control Board</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Registration for Recycle/ reprocessing under Hazardous waste (Management Handling and Trans Boundary and Movement) Rules, 2016</td></tr><tr><td>2</td><td>Department</td><td>Haryana State pollution control board</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Post Operation</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>No Fees</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Dully Filled up application form -1<br>\u2022 Copy of Consent to establishment (CTE) granted by the board<br>\u2022 Copy of valid Consent to operate ( CTO) under water Act,1974 And Air Act, 1981 granted by the board.<br>\u2022 Occupier/Authorized person certified issued by the management Of the applicant industry.<br>\u2022 Copy of emergency response plan regarding procedure for dealing with emergency situations (viz. spillage or release or fire) as specified in the guideline of CPCB(refer column no .4 of part A of application form)<br>\u2022 Undertaking or deceleration to comply with all provisions including the scope of submitting bank guarantee in the spillage ,leakage or fire while handling the hazardous and Other waste.<br>\u2022 Plan showing the detail of secured storage of hazardous waste With storage capacity including mode of disposal.<br>\u2022 Process flow sheet indicating equipment detail, inputs outputs (raw material, chemicals, products, by products, Wastes, emissions, waste water etc.)</td></tr><tr><td>8</td><td>Form submission</td><td>https://investharyana.in/#/</td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022 Duly filled form<br>\u2022 After the receipt of the complete case, inspection shall be carried out by a team of officers of the Regional office concerned consisting of the regional officer and concerned AEE/Scientist B of the region to verify the whether the applicant is utilizing environmentally sound technologies and possesses adequate technical capabilities, requisite facilities and equipment as per guideline /standard operating procedures issued by CPCB.<br>\u2022 The regional officer will submit the verification report on the prescribed format given at Annexure \u2013ii along with one copy of form -1 and all original documents submitted by the applicant ,within 21 days to the head office giving definite recommendations for refusal or grant of authorization as the case may be ,on the merit of the case.<br>\u2022 The authorization shall be issued in the prescribed form-2 along with the prescribed passbook as per the pattern of CPCB to maintain the records of hazardous and other waste procured by the applicant for processing for reuse/recycling/recovery/preprocessing/utilization including co-processing and copy of field inspection report signed by the concerned officer of the board indicating the adequacy of facilities for processing the hazardous and other waste as per rule 3 or will be refused after following the due procedure as the case may be , based upon the recommendations of regional officers with the approval of the competent Authority.<br>\u2022 The status of unit authorized by the Board of actual users of Hazardous and other waste will be displayed on the website of the board under the heading \u201CAuthorization Actual user of hazardous and other waste of Haryana (except for the recycler of hazardous waste Listed in Schedule-IV) immediately after Authorization is issued by the Board.<br>\u2022 <a href="https://hspcb.gov.in/content/procedureHazardousWaste.pdf">https://hspcb.gov.in/content/procedureHazardousWaste.pdf</a></td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page56/page56.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>10. ENVIRONMENT DEPARTMENT </h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval /Noc/License/Registration</td><td>Environmental clearance (EC) under Aravali Notification 1992 & 1999</td></tr><tr><td>2</td><td>Department</td><td>Environment Department</td></tr><tr><td>3</td><td>Applicability criteria</td><td>Land Attracts Aravali Notified areas</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days( After the completion of all documents)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>No Fees</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 EMP \u2022 Form-A</td></tr><tr><td>8</td><td>Form submission</td><td><a href="http://environmentclearance.nic.in/">http://environmentclearance.nic.in/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Dully filled application form.<br>\u2022 List of supporting documents attached with the application as per requirement.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page57/page57.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>10.1 ENVIRONMENT DEPARTMENT </h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval /Noc/License/Registration</td><td>Environment clearance plan from State/Central Environment Impact Assessment Authority- EIA notification 2006.</td></tr><tr><td>2</td><td>Department</td><td>Environment Department</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>\u2022Project B2(where public hearing is not required ) 105<br>\u2022 Project B1( where public hearing is requited) 105 + 45<br>\u202260 Days for SEAC( State Expert appraisal committee)<br>\u202245 Days for SEIAA( State Environment impact assessment authority</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>No Fees</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 EIA Report \u2022 EMP \u2022 Form-A</td></tr><tr><td>8</td><td>Form submission</td><td><a href="http://environmentclearance.nic.in/">http://environmentclearance.nic.in/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Dully filled application form.<br>\u2022 List of supporting documents attached with the application as per requirement( B1 type project approved by Govt. Of India Only & B2 type project approved at state level govt.).</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page58/page58.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>11 AYUSH DEPARTMENT</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval /Noc/License/Registration</td><td>Manufacturing licence for ASU (Ayurvedic Siddha Unani) drugs</td></tr><tr><td>2</td><td>Department</td><td>Ayush Department</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable for who manufacturing ASU (Ayurvedic Siddha Unani) drugs</td></tr><tr><td>4</td><td>Stage</td><td>Post Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>New Licence :- 1000/- Renewal of licence:-1200/- (Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022Form-24D<br>\u2022Two copies of map of premises (Blue print) showing area of each room and indicating the purpose for which these are to be used.Form-24D<br>\u2022Two copies of map of premises (Blue print) showing area of each room and indicating the purpose for which these are to be used.<br>\u2022Two copies of the equipment/machinery installed for manufacturing purposes. The list of laboratory equipment\u2019s shall also be submitted in two copies<br>\u2022An attested copies of the latest two photograph and qualifications/experiences/registrations etc. of the technical staff appointed for manufacturing and testing purpose as prescribed in Schedule \u2018T\u2019 of Drugs and Cosmetics Rules, 1945<br>\u2022The affidavit of technical staff with regard to the certification that they will work in firm as full time employee and they have never been convicted under Drugs and Cosmetic Rules or any law of the land<br>\u2022A copy of memorandum in case of limited or private limited or copy of the partnership deed (if applicable) on Rs. 10/- stamp paper duly attested First Class Magistrate or Public Notary<br>\u2022Proof of ownership of the building or rent deed (if on rent).<br>\u2022An affidavit on Rs. 3/- non judicial paper duly attested by Notary of each partner/owner that they have never been convicted under the Drugs and Cosmetics Act, 1940 and Rules made thereunder.<br>\u2022Five typed copies of list of item to be manufacture shall be submitted along with proof of concept and testing protocols (Quality Control References) and clinical trial report on at least 20 patients performed in two Govt. institutions and by one leading qualified Doctors in Ayurveda,Siddha and Unani.<br>\u2022Qualification certificates & photograph.<br>\u2022Two copies of the equipment/machinery installed for manufacturing purposes. The list of laboratory equipment\u2019s shall also be submitted in two copies<br>\u2022An attested copies of the latest two photograph and qualifications/experiences/registrations etc. of the technical staff appointed for manufacturing and testing purpose as prescribed in Schedule \u2018T\u2019 of Drugs and Cosmetics Rules, 1945<br>\u2022The affidavit of technical staff with regard to the certification that they will work in firm as full time employee and they have never been convicted under Drugs and Cosmetic Rules or any law of the land<br>\u2022A copy of memorandum in case of limited or private limited or copy of the partnership deed (if applicable) on Rs. 10/- stamp paper duly attested First Class Magistrate or Public Notary<br>\u2022Proof of ownership of the building or rent deed (if on rent).<br>\u2022An affidavit on Rs. 3/- non judicial paper duly attested by Notary of each partner/owner that they have never been convicted under the Drugs and Cosmetics Act, 1940 and Rules made thereunder.<br>\u2022Five typed copies of list of item to be manufacture shall be submitted along with proof of concept and testing protocols (Quality Control References) and clinical trial report on at least 20 patients performed in two Govt. institutions and by one leading qualified Doctors in Ayurveda,Siddha and Unani.<br>\u2022Qualification certificates & photograph.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Fill application form along with all documents \u2022 Pay fees</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page6/page6.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>1.4 Haryana State Pollution Control Board</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Registration under Plastic Manufacture, Sale and Usage Rules, 2016</td></tr><tr><td>2</td><td>Department</td><td>Haryana State pollution control board</td></tr><tr><td>3</td><td>Applicability criteria</td><td>Those who use Plastic as a Raw material for manufacturing</td></tr><tr><td>4</td><td>Stage</td><td>Pre Operation</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>No Fees</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Form- I-For Producers or Brand Owner<br>\u2022 Form-II- For Units engaged in Processing or Recycling of Plastic Waste.<br>\u2022 Form-III- For Manufacturers of Plastic Raw Materials<br>\u2022 Copy of Valid Consent to Operate/Renewal obtained from PCC<br>\u2022 Copy of DIC registration of products.<br>\u2022 Copy of manufacturing process details.<br>\u2022 Copy of Flow diagram of the products.</td></tr><tr><td>8</td><td>Form submission</td><td>https://investharyana.in/#/</td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application..</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/page60/page60.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>12. DEPARTMENT OF HEALTH SERVICES</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Drug License for Allopathic Medicine</td></tr><tr><td>2</td><td>Department</td><td>Food and Drug Administration</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable for manufacturing of Allopathic medicine</td></tr><tr><td>4</td><td>Stage</td><td>Post establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>See Annexure</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Blue print with site plan of the premises, duly signed by firm\u2019s Prop/partner/Director.<br>\u2022 Rent receipt and lease deed of the premises (original or attested photocopies)<br>\u2022 Photostat attested copy of partnership deed it is partnership firm. Or Memorandum and Article of Association if it is Limited or Pvt. Ltd. firm duly signed by Directors of the firm \u2022 List of present directors of the firm showing their complete name and residential address.<br>\u2022 In case of change in Directors (registration, addition, replacement) firm the original, their attested photocopy of Form 32 in respect of such outgoing incoming director. \u2022 Full particulars of the competent technical staff /registered persons along with copies of their educational qualification, experience and registration certificates.<br>\u2022 Non-conviction affidavit of approved technical staff as per required which should also finds mention the defaults of his/her academic qualification & approval. \u2022 Photostat attested copies of academic qualification & approval of technical staff as per conditions lay down in Drugs & Cosmetics Act, 1940 & Rules, 1945<br>\u2022 List of machinery \u2022 List of lab equipment<br>\u2022 Purchase bills of machinery and equipment (original or attested photocopies) \u2022 NOC of firefighting/NOC of pollution control if applicable (original or attested photocopy)<br>\u2022 Proof of HSEB load sanction (original or attested photocopy) \u2022 Attested photocopy of allotment/occupation certificate form HSIDC/HUDA etc. Whichever is applicable<br>\u2022 Declaration in this form of affidavit about sleeping/active partner/Director responsible for day to day work and conduct of the company along with declaration as to whether such prop/partner/director has been convicted under Drugs & Cosmetics Act, 1940 & Rules, 1945 or not. \u2022 Resolution of Board of Directors regarding appointment of authorized signatory.<br>\u2022 Non-conviction affidavit of authorized signatory, if appointed any by the firm.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application.<br>\u2022 Pay fee<br>\u2022 <a href="http://fdaharyana.gov.in/DrugManufacturing.aspx">http://fdaharyana.gov.in/DrugManufacturing.aspx</a></td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget --></div><div class="container"><div class="widget-header"><i class="icon-th-list"></i><h3>ANNEXURE:-</h3></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr No</th><th>Particular</th></tr></thead><tbody><tr><td>1</td><td>Application form on Form 24 for Non-biological drugs manufacturing license with a fee of Rs. 7500/- for ten items per category and Rs. 300/- per item for more than 10 products per category and application on Form 27 for manufacturing of Biological drugs with a fee of Rs. 7500/- for tem items per category and Rs. 300/- per item for items more than 10 items per category</td></tr><tr><td>2</td><td>Application form on Form 24B for repacking of license with a fee of Rs. 700/- upto 10 items per category and Rs. 100/- per item if the items are more than 10 items</td></tr><tr><td>3</td><td>Application form on Form 24C for Homeopathic manufacturing license with a fee of Rs. 300/- for mother tincture Rs. 300/- for potentised preparations and Rs. 300/- for potentised and Rs. 50/- for additional item if the items are more than 10.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget -->');
$templateCache.put('app/questionnaire/table/page7/page7.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>1.5 Haryana State Pollution Control Board</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Authorization under Bio Medical Waste (Management & Handing) Rules, 1998</td></tr><tr><td>2</td><td>Department</td><td>Haryana State pollution control board</td></tr><tr><td>3</td><td>Applicability criteria</td><td>Those who involves Bio Medical waste in their project</td></tr><tr><td>4</td><td>Stage</td><td>Post Operation</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>No Fees</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Site plan/location plan of industry<br>\u2022 Duly filled in prescribed application form (Form-I) for authorization under Biomedical Waste (Management and Handling) Rules, 1998 and amendment Thereafter.<br>\u2022 Authorization fees as prescribed by the Board<br>\u2022 Land documents like Registration/lease/rent deed<br>\u2022 Map of biomedical waste disposal site in case of health care establishment having own biomedical waste treatment and disposal facility.<br>\u2022 Layout map showing drainage network<br>\u2022 Flow chart of Effluent Treatment Plant in case of Health Care Establishments(HCEs) having 100 beds & more<br>\u2022 Copy of last authorization order issued by the Board (in case of Renewal).<br>\u2022 Compliance to the conditions stipulated in authorization order issued by the Board (in case of renewal cases only).<br>\u2022 Copy of Annual Report in Form-II as prescribed under Biomedical Waste (Management and Handling) Rules, 1998 and amendment thereafter (For renewal cases only).</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Duly filled form<br>\u2022 After the receipt of the complete case, inspection shall be carried out by a team of officers of the Regional office concerned consisting of the regional officer and concerned AEE/Scientist B of the region to verify the whether the applicant is utilizing environmentally sound technologies and possesses adequate technical capabilities, requisite facilities and equipment as per guideline /standard operating procedures issued by CPCB.<br>\u2022 The regional officer will submit the verification report on the prescribed format given at Annexure \u2013ii along with one copy of form -1 and all original documents submitted by the applicant ,within 21 days to the head office giving definite recommendations for refusal or grant of authorization as the case may be ,on the merit of the case.<br>\u2022 The authorization shall be issued in the prescribed form-2 along with the prescribed passbook as per the pattern of CPCB to maintain the records of waste procured by the applicant for processing for reuse/recycling/recovery/preprocessing/utilization including co-processing and copy of field inspection report signed by the concerned officer of the board indicating the adequacy of facilities for processing the waste as per rule 3 or will be refused after following the due procedure as the case may be , based upon the recommendations of regional officers with the approval of the competent Authority.<br>\u2022 The status of unit authorized by the Board of actual users of waste will be displayed on the website of the board under the heading \u201CAuthorization Actual user of hazardous and other waste of Haryana( except for the recycler of waste Listed in Schedule-IV) immediately after Authorization is issued by the Board.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table31/table31.html','<div class="span7"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>6. Public Health Engineering Department</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><!--<thead>--><!--<tr>--><!--<th>SR.no</th>--><!--<th class="td-actions"></th>--><!--</tr>--><!--</thead>--><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Issuance of permanent water connection</td></tr><tr><td>2</td><td>Department</td><td>Public Health Engineering Deptt.</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>12 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>i. Industrial Rs. 2000/- per connection<br>ii. Commercial Rs. 1000/- per connection<br>iii. Institutional Rs. 1000/- per connection + road cutting charges business road: 1277/- cement & concrete road:- 2552/-</td></tr><tr><td>7</td><td>Documents Required</td><td>1. Application form<br>2. Residence Certificate<br>3. Copy of Registry<br>4. Copy of house tax bill<br>5. Building plan & copy of allotment letter issued by M.C.<br>6. In case of Huda/Residence society/Govt. House attested copy of allotment letter<br>7. Electricity bill/Telephone bill/Mobile bill<br>8. Voter card<br>9. If water meter purchase by the consumer then copy of bill. In case of Huda/other residence society copy of position certificate.</td></tr><tr><td>8</td><td>Form submission</td><td>Online</td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022 All the applications received for sanction of new connections will also now be processed online through BISWAS. The facility has been provided for citizens to apply online at (https;//services.phedharvana.gov.inl) or, in Common Services Centers (CSCs) or through Mobile App for sanction of new connections. Such online applications are being received automatically in BISWAS by concerned Sub-divisions at tl1e login of SDE<br>\u2022 All the applications received for sanction of new connections will also now be processed online through BISWAS. The facility has been provided for citizens to apply online at (https;//services.phedharvana.gov.inl) or, in Common Services Centers (CSCs) or through Mobile App for sanction of new connections. Such online applications are being received automatically in BISWAS by concerned Sub-divisions at tl1e login of SDE<br>\u2022 The copy of application will be handed over to the concerned JE for checking feasibility at site and entry of status / updation will be made, in BISWAS \u2022JE will submit feasibility report to SDE. Further, the feasibility. status of the connection will be updated online by concerned JE/SDE in charge from the login ID of SDE concerned.<br>\u2022if connection is found feasible, SMS will be sent to consumer at registered mobile number and will be informed to deposit necessary connection charges & for verification of original documents.<br>\u2022As and when all charges such as connection fee, meter testing & sealing charges and road cut charges etc. are paid by applicant then the sanction letter can be generated electronically. The new sanction letter can be printed either by department from login of SDE or by the applicant from his own login ID.t . Accordingly, a new consumer ID/ connection number will be generated Automatically. It will not be out of place to mention here that " as per Right t6 Service, the period for sanctioning of connections is 12 working days & competent authority is Sub Divisional Engineer.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table32/table32.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>6.1 Public Health Engineering Department</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><!--<thead>--><!--<tr>--><!--<th>SR.no</th>--><!--<th class="td-actions"></th>--><!--</tr>--><!--</thead>--><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Issuance of sewerage connection</td></tr><tr><td>2</td><td>Department</td><td>Public Health Engineering Deptt.</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre Operation</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>The requisition form is available free of cost Initial connection fees for Sewerage Connection<br>i. Domestic- Rs. 500/- per connection<br>ii. Industrial- Rs. 2000/- per connection<br>iii. Commercial- Rs. 1000/- per connection<br>iv. Institutional- Rs. 1000/- per connection<br>+<br>Road Cutting Charges<br>Cement Concrete Road:- 3750/-<br>Other Business Road :- 2500/ (Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>1. Application Form<br>2. Residence Proof<br>3. Copy of Registry of Property where connection is sought<br>4. Copy of up to date house tax bill paid<br>5. Copy of Building Plan & Completion Certificate (For commercial connection)<br>6. Copy of Building Plan (For residential connection).<br>7. Electricity Bill/Telephone bill (For Address proof)<br>8. Voter Card/ Aadhar Card(For Id Proof) of applicant<br>9. Copy of Water meter bill purchased by Consumer.<br>10. Affidavit for New Water and Sewer Connection.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application<br>\u2022 Pay Fees</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table33/table33.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>7. Urban Local Bodies</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><!--<thead>--><!--<tr>--><!--<th>SR.no</th>--><!--<th class="td-actions"></th>--><!--</tr>--><!--</thead>--><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Approval of Fire NOC from Fire Department</td></tr><tr><td>2</td><td>Department</td><td>Urban Local Bodies</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>No Fees</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Approval of Fire Fighting Scheme from Competent Authority<br>\u2022 Permission Letter/BR-III<br>\u2022 Detail of dedicated fire staff, with name, Qualification & Contact Nos.<br>\u2022 Detail of Building<br>\u2022 Total tower approved<br>\u2022 Applied for Nos. of towers (With tower nos. & name)<br>\u2022 Remaining for Nos. of towers (With tower nos. & name)<br>\u2022 Detail of already issued NOC (With tower nos. & name)<br>\u2022 Authorization letter with Employee ID proof<br>\u2022 Photographs of the fire system in working condition<br>\u2022 Checklist as per NBC 2005</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application<br>\u2022 <a href="https://ulbharyana.gov.in/approval-renewal-of-fire-noc.html" target="_blank">https://ulbharyana.gov.in/approval-renewal-of-fire-noc.html</a></td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table34/table34.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>7.1 Urban Local Bodies</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><!--<thead>--><!--<tr>--><!--<th>SR.no</th>--><!--<th class="td-actions"></th>--><!--</tr>--><!--</thead>--><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>"Issuance of Trade License Under section 330 for factory, workshop or trade remises. In which it is intended to employ steam, electricity, water or other mechanical power".</td></tr><tr><td>2</td><td>Department</td><td>Urban & Local bodies</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>See Annexure</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Document of Actual turnover of Previous financial Year<br>\u2022 NOC from Fire Dept.<br>\u2022 Firm Registration No<br>\u2022 Property tax Receipt (G-8)<br>\u2022 Letter Of Sanctioned Building plan / Occupation Certified<br>\u2022 Rent/Lease/agreement/Ownership proof<br>\u2022 Photograph of Applicant / Authorized Signatory<br>\u2022 Copy of the Previous License (if already granted)</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application<br>\u2022Pay Fees<br>\u2022<a href="https://ulbharyana.gov.in/approval-of-business-licenses.html">https://ulbharyana.gov.in/approval-of-business-licenses.html</a></td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget --></div><br><div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><i class="icon-th-list"></i><h3>ANNEXURE:-</h3></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>SR.no</th><th>Turnover</th><th>Fees</th><th class="td-actions"></th></tr></thead><tbody><tr><td>1</td><td>Turnover up to Rs. 50,000/</td><td>300/-</td></tr><tr><td>2</td><td>Turnover up to Rs. 01 Lacs</td><td>400/-</td></tr><tr><td>3</td><td>Turnover up to Rs. 10 Lacs</td><td>700/-</td></tr><tr><td>4</td><td>Turnover up to Rs. 25Lacs</td><td>1200/-</td></tr><tr><td>5</td><td>Turnover up to Rs. 50Lacs</td><td>3000/-</td></tr><tr><td>6</td><td>Turnover up to Rs. 01 Crores</td><td>5000/-</td></tr><tr><td>7</td><td>Turnover up to Rs. 05 Crores</td><td>10000/-</td></tr><tr><td>8</td><td>Turnover up to Rs. 10 Crores</td><td>15000/-</td></tr><tr><td>9</td><td>Turnover up to Rs. 15 Crores</td><td>18000/-</td></tr><tr><td>10</td><td>Turnover up to Rs. 20 Crores</td><td>21000/-</td></tr><tr><td>11</td><td>Turnover up to Rs. 50 Crores</td><td>40000/-</td></tr><tr><td>12</td><td>Turnover up to Rs. 100 Crores</td><td>70000/-</td></tr><tr><td>13</td><td>Turnover up to Rs. 150 Crores</td><td>100000/-</td></tr><tr><td>14</td><td>Turnover above Rs.150 Crores</td><td>3000/- will be charged on each additional 5 Crore at every stage</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table36/table36.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>7.2 Urban Local Bodies</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><!--<thead>--><!--<tr>--><!--<th>SR.no</th>--><!--<th class="td-actions"></th>--><!--</tr>--><!--</thead>--><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Occupation Certificate</td></tr><tr><td>2</td><td>Department</td><td>Urban & Local bodies</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Post Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Regarding composition of illegal construction raised without or contrary to the sanction of building plans within the Municipal Corporation limits issued vide letter dated 12.02.2014(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>1.Application on prescribed from BR-IV.<br>2.Name of the applicant/ company<br>3.Date of CLU<br>4.Area in sqmt/acres<br>5.validity of CLU.<br>6.Structural certificate on prescribed BR-V (1) for a height upto 14.50 meters and form BR- V (2) for height above 14.50 meters alongwith copy of qualification/ degree of the certificate engineer.<br>7.Scrutiny fees @ RS.10/- sq.mt. of the total built up area.<br>8.Labour Cess @ 10/- sqft for RCC and Rs. 450/- sqft for shed on total built up area.<br>9.No dues certificate regarding labour cess.<br>10.Approval of building plan verification of service laid down at site.<br>11.Compliance of CLU conditions.<br>12.Status of payment of EDC.<br>13.Status of development works carried out at site alongwith photographs and video CD/DVD.<br>14.Public Health Services Plan.<br>15.Approval from any others authorities as required.<br>16.NOC from MoEF, if built area is more than 20,000 sqm.<br>17.NoC regarding fire safety<br>18.NoC from HAREA regarding installation of Solar water heating system, if applicable.<br>19.Acess permission taken from XEN, or NHAI, if the site abuts on schedule road or NH.<br>20.As built drawing duly singed by Owner and Architect.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022 Duly filled form V along with BR-VII<br>\u2022 That before the Inspection of the building the concerned municipality will intimate to the applicant in advance about the site inspection date and time<br>\u2022After intimation to the application about the time and date of inspection the building will be inspected by the concerned officers/officials as authorized by the Commissioner, Municipal Corporation, E.O., Municipal Council, Secretary, Municipal Committee And fill the report on the prescribed Performa.<br>\u2022The concerned officer/official will submit the Inspection report to the Commissioner, Municipal Corporation, E.O. Municipal Council and Secretary, Municipal Committee along with the report on Document submitted by the applicant.<br>\u2022The Commissioner, Municipal Corporation, E.O. Municipal Council and Secretary, Municipal Committee on the basis of site inspection report and office report grant or reject the occupation certificate within 60days from the date of receipt of The application.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table37/table37.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>7.3 Urban Local Bodies</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><!--<thead>--><!--<tr>--><!--<th>SR.no</th>--><!--<th class="td-actions"></th>--><!--</tr>--><!--</thead>--><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Building Plan approval</td></tr><tr><td>2</td><td>Department</td><td>Urban & Local bodies</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>In case of extended limits charges shall be applicable as per decided by Government Town and Country Planning(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>1.Date of Application on prescribed BR-I & BR-II submitted for approval of building plan.<br>2.Name of the applicant/ company 3.Date of CLU 4.Area in sqmt/acres 5.validity of CLU. 6.Structural certificate on prescribed BR-V (1) for a height upto 14.50 meters and form BR- V (2) for height above 14.50 meters along with copy of qualification/ degree of the certificate engineer. 7.Scrutiny fees @ RS.10/- sq.mt. of the total built up area. 8.Three set of building plans i.The site plan shall be down to scale not less than (a) 1:200 for sites upto 1000sqm (b)1:400 for sites above 1000 sqm and upto 4500sqm.<br>(c)1:800 for sites of 4500 sqm and above.<br>ii.The building Plans shall be drawn to a scale not less than (a)1:50 for site upto 1000 sqm. (b)1:100 for site above 1000 sqm but less than 2000 sqm. (c)1:200 for sites above 200sqm 9.Structural drawings duly signed by structural engineer. 10.Status of payment of EDC 11.approval from any other authorizes, as required</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022Duly filled form<br>\u2022List of supporting documents attached with the application.<br>\u2022Pay fees</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table41/table41.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><!--<i class="icon-th-list"></i>--><!--<h3> Urban Local Bodies</h3>--></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Issuance of sewerage connection</td></tr><tr><td>2</td><td>Department</td><td>Urban & Local bodies</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>\u2022The fee will be calculated by the concerned officer of the concerned Municipal Corporation on following grounds<br>\u2022Connection charges<br>\u2022Road cut charges<br>\u2022Meter testing fees<br>\u2022Penalty/charges for regularization of unauthorized Connections.(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Application Form<br>\u2022 Residence Proof<br>\u2022 Copy of Registry of Property where connection is sought<br>\u2022 Copy of Building Plan & Completion Certificate (For commercial connection<br>\u2022 Copy of Water meter bill purchased by Consumer<br>\u2022 Affidavit for New Water and Sewer Connection.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application<br>\u2022 Pay Fees<br>\u2022 <a href="https://ulbharyana.gov.in/water-and-sewer-connection-services.html" target="_blank">https://ulbharyana.gov.in/water-and-sewer-connection-services.html</a></td></tr></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table42/table42.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Registration of Establishment engaged in Building & other Construction activity under Building and Other Construction Workers (RE&CS) Act, 1996.</td></tr><tr><td>2</td><td>Department</td><td>Labour</td></tr><tr><td>3</td><td>Applicability criteria</td><td>For all ( except central govt. Establishments)</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Up to 100 workers- Rs 2000/-<br>Exceeds 100 but under 500 - Rs 5000/-<br>Exceeds 500 worker - Rs 10,000/-(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Form No-1 ( Under BOCW Act,1996)<br>\u2022 Proof of Ownership<br>\u2022 Estimated Project Cost( Excluding Land & Machinery Cost)<br>\u2022 Approval Of project from the concerned local Authority</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Procedure</td><td>\u2022Duly filled form<br>\u2022List of supporting documents attached with the application.<br>\u2022Pay fees<br>\u2022 <a target="_blank" href="https://hrylabour.gov.in/content/ease_doing_bus">https://hrylabour.gov.in/content/ease_doing_bus</a></td></tr></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table43/table43.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Registration of Principal Employers establishment and License for contractor under provision of Contract Labor Act, 1970-Labour Wing</td></tr><tr><td>2</td><td>Department</td><td>Labour</td></tr><tr><td>3</td><td>Applicability criteria</td><td>As per provisions of Section 7 of the Contract Labour (Regulation and Abolition) Act, 1970, every Principal Employer engaging 20 or more contract labourers in his establishment has to apply for registration of his establishment.</td></tr><tr><td>4</td><td>Stage</td><td>Post Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>See Annexure:-2</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Form No-1<br>\u2022 Form 4-5</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Procedure</td><td>\u2022The Labour Commissioner is the Registering Officer who will grant registration under the Act.<br>\u2022 The employer has to apply in Form No.1 in triplicate to the Registering Officer along with Treasury Challan in support of deposit of prescribed fee. The applications shall be either personally delivered to the Registering Officer or sent to him by registered post.<br>\u2022The employer has to submit documents in support of his identity as well as existence of his establishment along with the application, by attaching a copy of registration under the Factories Act, 1948 or Punjab Shops & Commercial Establishments Act or the Building and other Construction Workers Act; or else being a Govt. establishment, the relevant details have to be provided<br>\u2022 The employer who desires to have registration certificate amended shall make an application in Form No.1 to the above authority stating therein the nature of amendment required and reasons thereof along with the registration certificate and treasury challan in support of deposit of differential amount of fees if the no. of contract laborers proposed to be engaged is more than the no. for which he had taken the Registration Certificate for necessary amendment<br>\u2022The duplicate certificate can be issued in case the Registration Certificate is lost, defaced, or accidentally destroyed on making an application for the purpose.<br>\u2022<a href="https://hrylabour.gov.in/content/ease_doing_bus" target="_blank">Click Here </a>and then go to Registration and Amendment of principal employer\'s establishment under provision of The Contracts Labour (Regulation and Abolition) Act, 1970</td></tr></table></div><!-- /widget-content --></div><!-- /widget --></div><br><div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><i class="icon-th-list"></i><h3>ANNEXURE:-2</h3></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr. No.</th><th>No. of workers employed</th><th>Fees for registration</th></tr></thead><tbody><tr><td>1</td><td>Up to 20</td><td>20/-</td></tr><tr><td>2</td><td>Between 21 to 50</td><td>50/-</td></tr><tr><td>3</td><td>Between 51 to 100</td><td>100/-</td></tr><tr><td>4</td><td>Between 101 to 200</td><td>200/-</td></tr><tr><td>5</td><td>Between 201 to 400</td><td>400/-</td></tr><tr><td>6</td><td>401 and above</td><td>500/-</td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget --></div><br><div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><i class="icon-th-list"></i><h3>For Contractor:-</h3></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr. No.</th><th>No. of workers employed</th><th>Fees for registration</th></tr></thead><tbody><tr><td>1</td><td>Up to 20</td><td>5/-</td></tr><tr><td>2</td><td>Between 21 to 50</td><td>12.50/-</td></tr><tr><td>3</td><td>Between 51 to 100</td><td>25/-</td></tr><tr><td>4</td><td>Between 101 to 200</td><td>50/-</td></tr><tr><td>5</td><td>Between 201 to 400</td><td>100/-</td></tr><tr><td>6</td><td>401 and above</td><td>1250/-</td></tr></tbody></table><h3>Security shall be deposit in the treasury at the rate of 30/- per worker ( For contractor only)</h3></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table44/table44.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><i class="icon-th-list"></i><h3>ANNEXURE:-2</h3></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr. No.</th><th>No. of workers employed</th><th>Fees for registration</th></tr></thead><tbody><tr><td>1</td><td>Up to 20</td><td>20/-</td></tr><tr><td>2</td><td>Between 21 to 50</td><td>50/-</td></tr><tr><td>3</td><td>Between 51 to 100</td><td>100/-</td></tr><tr><td>4</td><td>Between 101 to 200</td><td>200/-</td></tr><tr><td>5</td><td>Between 201 to 400</td><td>400/-</td></tr><tr><td>6</td><td>401 and above</td><td>500/-</td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget --></div><br><div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><i class="icon-th-list"></i><h3>For Contractor:-</h3></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr. No.</th><th>No. of workers employed</th><th>Fees for registration</th></tr></thead><tbody><tr><td>1</td><td>Up to 20</td><td>5/-</td></tr><tr><td>2</td><td>Between 21 to 50</td><td>12.50/-</td></tr><tr><td>3</td><td>Between 51 to 100</td><td>25/-</td></tr><tr><td>4</td><td>Between 101 to 200</td><td>50/-</td></tr><tr><td>5</td><td>Between 201 to 400</td><td>100/-</td></tr><tr><td>6</td><td>401 and above</td><td>1250/-</td></tr></tbody></table><h3>Security shall be deposit in the treasury at the rate of 30/- per worker ( For contractor only)</h3></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table45/table45.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Approval of factory plan under the Factories Act, 1948-Safety Wing</td></tr><tr><td>2</td><td>Department</td><td>Labour</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This on-line can be used by any Registered factory owner for approval of Factory building plan under the Factories Act, 1948.</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>No Fees</td></tr><tr><td>7</td><td>Documents Required/Checklist</td><td>\u2022 Form No.-1(Application)<br>\u2022 Form-1A (Details of work rooms)<br>\u2022 Form -1A Questionnaire annexed<br>\u2022 Form 1B Stability certificate signed by the competent engineer (After completion of factory Building<br>\u2022 List of Directors of company/Firm approved by ROC<br>\u2022 List of partners along with partnership deed<br>\u2022 The scaled Blue prints of factory Building plan, Site plan with indications of surrounding road, drain, the position of plant & machinery, aisles & passage ways, etc, sectional elevation, cross section, details such as Natural lighting, ventilation, means of escape, etc.<br>\u2022 Flow chart with brief description of manufacturing process<br>\u2022 NOC from Local authority<br>\u2022 NOC from fire department<br>\u2022 NOC/Consent from pollution control Board<br>\u2022 List of plant/machinery installed and chemicals used in the factory along with their safety report & MSDS<br>\u2022 Proof of registration of establishment under the BOCW Act, 1996<br>\u2022 Proof of payment of Cess i.e. @ 1 % of the cost of construction under the BOCW cess, Act, 1996</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedur</td><td>\u2022 The applicant has to submit the application (in Quadruplicate) along with the required document signed by the Occupier to HEPC, SCO- 62-66, Sector- 2, Panchkula<br>\u2022 Approval of factory building plan and permission to construct/extend/or take into use any building as a factory under the Factories Act, 1948 <a target="_blank" href="https://hrylabour.gov.in/content/ease_doing_bus">Click Here</a></td></tr></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table46/table46.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Approval of factory plan under the Factories Act, 1948-Safety Wing</td></tr><tr><td>2</td><td>Department</td><td>Labour</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This on-line can be used by any Registered factory owner for approval of Factory building plan under the Factories Act, 1948.</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>No Fees</td></tr><tr><td>7</td><td>Documents Required/Checklist</td><td>\u2022 Form No.-1(Application)<br>\u2022 Form-1A (Details of work rooms)<br>\u2022 Form -1A Questionnaire annexed<br>\u2022 Form 1B Stability certificate signed by the competent engineer (After completion of factory Building<br>\u2022 List of Directors of company/Firm approved by ROC<br>\u2022 List of partners along with partnership deed<br>\u2022 The scaled Blue prints of factory Building plan, Site plan with indications of surrounding road, drain, the position of plant & machinery, aisles & passage ways, etc, sectional elevation, cross section, details such as Natural lighting, ventilation, means of escape, etc.<br>\u2022 Flow chart with brief description of manufacturing process<br>\u2022 NOC from Local authority<br>\u2022 NOC from fire department<br>\u2022 NOC/Consent from pollution control Board<br>\u2022 List of plant/machinery installed and chemicals used in the factory along with their safety report & MSDS<br>\u2022 Proof of registration of establishment under the BOCW Act, 1996<br>\u2022 Proof of payment of Cess i.e. @ 1 % of the cost of construction under the BOCW cess, Act, 1996</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedur</td><td>\u2022 The applicant has to submit the application (in Quadruplicate) along with the required document signed by the Occupier to HEPC, SCO- 62-66, Sector- 2, Panchkula</td></tr></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div><br><!--<div class="container">--><!--<div class="widget stacked widget-table action-table">--><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>ANNEXURE:-1</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><!--<div class="widget-content">--><!--<table class="table table-striped table-bordered">--><!--<thead>--><!--<tr>--><!--<th>Horse Power Install--><!--(Max HP)--><!--</th>--><!--<th>Up to 20--><!--(Rs.)--><!--</th>--><!--<th>From 21  to 40 (Rs.)</th>--><!--<th>From 41  to 150(Rs.)</th>--><!--<th>From 151  to 250 (Rs.)</th>--><!--<th>From 251  to 500 (Rs.)</th>--><!--<th>From 501  to 1000 (Rs.)</th>--><!--<th>From 1001  to 2000 (Rs.)</th>--><!--<th>From 2001 to 3000</th>--><!--<th>From  3001 & above</th>--><!--</tr>--><!--</thead>--><!--<tbody>--><!--<tr>--><!--<td><b>Nil</b></td>--><!--<td>1500</td>--><!--<td>3000</td>--><!--<td>4500</td>--><!--<td>6000</td>--><!--<td>7500</td>--><!--<td>9000</td>--><!--<td>10500</td>--><!--<td>12000</td>--><!--<td>13500</td>--><!--</tr>--><!--<tr>--><!--<td><b>Upto 10</b></td>--><!--<td>3000</td>--><!--<td>6000</td>--><!--<td>9000</td>--><!--<td>12000</td>--><!--<td>15000</td>--><!--<td>18000</td>--><!--<td>21000</td>--><!--<td>24000</td>--><!--<td>27000</td>--><!--</tr>--><!--<tr>--><!--<td><b>Above 10 Up to 50</b></td>--><!--<td>4500</td>--><!--<td>9000</td>--><!--<td>13500</td>--><!--<td>18000</td>--><!--<td>22500</td>--><!--<td>27000</td>--><!--<td>31500</td>--><!--<td>36000</td>--><!--<td>40500</td>--><!--</tr>--><!--<tr>--><!--<td><b>Above 50 Up to 100</b></td>--><!--<td>6000</td>--><!--<td>12000</td>--><!--<td>18000</td>--><!--<td>24000</td>--><!--<td>30000</td>--><!--<td>36000</td>--><!--<td>42000</td>--><!--<td>48000</td>--><!--<td>54000</td>--><!--</tr>--><!--<tr>--><!--<td><b>Above 100 Up to 500</b></td>--><!--<td>7500</td>--><!--<td>15000</td>--><!--<td>22500</td>--><!--<td>30000</td>--><!--<td>37500</td>--><!--<td>45000</td>--><!--<td>52500</td>--><!--<td>60000</td>--><!--<td>67500</td>--><!--</tr>--><!--<tr>--><!--<td><b>Above 500 Up to 1000</b></td>--><!--<td>9000</td>--><!--<td>18000</td>--><!--<td>27000</td>--><!--<td>36000</td>--><!--<td>45000</td>--><!--<td>54000</td>--><!--<td>63000</td>--><!--<td>72000</td>--><!--<td>81000</td>--><!--</tr>--><!--<tr>--><!--<td><b>Above 1000 Up to 2000</b></td>--><!--<td>10500</td>--><!--<td>21000</td>--><!--<td>31500</td>--><!--<td>42000</td>--><!--<td>52500</td>--><!--<td>63000</td>--><!--<td>73500</td>--><!--<td>84000</td>--><!--<td>94500</td>--><!--</tr>--><!--<tr>--><!--<td><b>Above 2000</b></td>--><!--<td>12000</td>--><!--<td>24000</td>--><!--<td>36000</td>--><!--<td>48000</td>--><!--<td>60000</td>--><!--<td>72000</td>--><!--<td>84000</td>--><!--<td>96000</td>--><!--<td>108000</td>--><!--</tr>--><!--</tbody>--><!--</table>--><!--</div> &lt;!&ndash; /widget-content &ndash;&gt;--><!--</div> &lt;!&ndash; /widget &ndash;&gt;--><!--</div>-->');
$templateCache.put('app/questionnaire/table/table47/table47.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><!--<i class="icon-th-list"></i>--><!--<h3>8.4 LABOUR DEPARTMENT</h3>--></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Shop registration under Shops and Establishment Act-1958 Labour Wing</td></tr><tr><td>2</td><td>Department</td><td>Labour</td></tr><tr><td>3</td><td>Applicability criteria</td><td>Every employer is required to register his/her Shop / Commercial Establishment through on-line Registration system. The Authority to register any shop or commercial establishment shall lie with the Registering Authority/ Labour Inspector of the area concerned.</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>01 Day (On the spot)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>See Annexure:-2</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022Detail of shop as per Form F & B.<br>\u2022Scanned copy of proof of establishment i.e. Lease deed/Rent deed/Registration deed or any other proof of possession of shop/commercial Establishment like electricity bill/Telephone bill/Bank account and Affidavit etc.<br>\u2022Front Photo of shop or commercial establishment covering the surrounding of the said establishment.<br>\u2022Applicant has to fill the workers detail and pay the contribution.<br>\u2022Scanned copy of treasury challan if fee is already paid using the Treasury Challan.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedur</td><td>\u2022 The applicant shall first fill-up the Form F and after successful filling up the Information under Form F; the applicant shall be directed to fill Form B.<br>\u2022 List of supporting documents attached with the application as per requirement.<br>\u2022Pay Fees<br>\u2022<a target="_blank" href="https://hrylabour.gov.in/shops/front/shop_terms">Click here</a> to Registration and renewal under The Shops and Establishments Act, 1958</td></tr></table></div><!-- /widget-content --></div><!-- /widget --></div><br><div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><i class="icon-th-list"></i><h3>ANNEXURE:-2</h3></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr. No.</th><th>Type of establishment</th><th>Registration fee for 3 years</th></tr></thead><tbody><tr><td><b>1</b></td><td>Starred hotels, cinema houses, banks, insurance companies, financial institutions and/or Information Technology and Information Technology Enabled Establishments and Telecommunication establishments Employing 10 or more employees.</td><td>5000/-</td></tr><tr><td><b>2</b></td><td>Nursing homes, Privately managed Educational Institutions/Universities and Petrol Pumps</td><td>1000/-</td></tr><tr><td><b>3</b></td><td>4500Workshops, automobiles service stations (not covered under the Factories Act, 1948), Computer Training Centers, Shorthand and type institutions, Health & Fitness Clubs, clinics, Medical laboratories, restaurants, un-starred hotels, and/or all Establishments employing 10 or more employees.</td><td>500/-</td></tr><tr><td><b>4</b></td><td>All Shops and commercial establishments not covered under and above three categories and employing less than 10 employees.</td><td>200/-</td></tr><tr><td><b>5</b></td><td>All Shops and commercial Establishments owned and/or managed by the shopkeepers himself/herself and not employing and employee.</td><td>100/-</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table48/table48.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Registration certificate of Establishment Inter State Migrant Workmen(RE&CS)Act,1979 (License of Contractor Establishment)</td></tr><tr><td>2</td><td>Department</td><td>Labour</td></tr><tr><td>3</td><td>Applicability criteria</td><td>To every establishment employing 5 or more interstate migrant worker man under contractor, he has to establish his enterprises under interstate migrant worker man Act.</td></tr><tr><td>4</td><td>Stage</td><td>Post Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days ( 30 Days + 15 Days for document submission)</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Fees automatically calculated based on number of workers.(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Address proof of the establishment attached<br>\u2022 ID Proof of the Principle Employer attached<br>\u2022Details of the manager of the contractor at the worksite mentioned<br>\u2022Details of the directors/partners (in case of companies/firms) mentioned<br>\u2022 Details of the other person in-charge responsible for the supervision and control of the establishment<br>\u2022Wok-order agreement with contractor attached<br>\u2022Contractor\u2019s details mentioned<br>\u2022Number of migrant workmen employed through each contractor mentioned<br>\u2022Affidavit/declaration on stamp paper<br>\u2022The Challan/fee receipt<br>\u2022 Form-1</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedur</td><td>\u2022 Dully filled application form.<br>\u2022 List of supporting documents attached with the application as per requirement.<br>\u2022Pay Fees.<br>\u2022<a href="https://hrylabour.gov.in/content/ease_doing_bus" target="_blank">Click Here </a>and then go to Registration and renewal under The Interstate Migrant Workmen (RE&CS) Act, 1979</td></tr></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div><br>');
$templateCache.put('app/questionnaire/table/table49/table49.html','<div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><!--<i class="icon-th-list"></i>--><!--<h3>8.6 LABOUR DEPARTMENT</h3>--></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Registration under the Motor Transport Workers Act-1961</td></tr><tr><td>2</td><td>Department</td><td>Labour</td></tr><tr><td>3</td><td>Applicability criteria</td><td>As per provision of act registration of employee of every motor transport who have five or more motor transport worker</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>See Annexure:-</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Form -1 under rule 4</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedur</td><td>\u2022 Dully filled application form.<br>\u2022 List of supporting documents attached with the application as per requirement.<br>\u2022Py Fees</td></tr></table></div><!-- /widget-content --></div><!-- /widget --></div><br><div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><i class="icon-th-list"></i><h3>ANNEXURE:</h3></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><thead><tr><th>Sr. No.</th><th>Type of establishment</th><th>Registration fee for 3 years</th></tr></thead><tbody><tr><td><b>1</b></td><td>Not more than 10</td><td>10/-</td></tr><tr><td><b>2</b></td><td>More than 10 but not more than 25:-</td><td>25/-</td></tr><tr><td><b>3</b></td><td>More than 25 but not more than 50:-</td><td>50/-</td></tr><tr><td><b>4</b></td><td>More than 50 but not more than 100:-</td><td>100/-</td></tr><tr><td><b>5</b></td><td>More than 100 but not more than 250:-</td><td>250/-</td></tr><tr><td><b>6</b></td><td>More than 250 but not more than 500:-</td><td>500/-</td></tr><tr><td><b>7</b></td><td>More than 500 but not more than 750:-</td><td>750/-</td></tr><tr><td><b>8</b></td><td>More than 750 but not more than 1000:-</td><td>1000/-</td></tr><tr><td><b>9</b></td><td>More than 1000:-</td><td>1000/-</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table52/table52.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>9. AGRICULTURE DEPARTMENT</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><!--<thead>--><!--<tr>--><!--<th>SR.no</th>--><!--<th class="td-actions"></th>--><!--</tr>--><!--</thead>--><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Certificate of registration for manufacturing of physical/granulated mixture of macro and micro nutrient fertilizer and renewal thereof.</td></tr><tr><td>2</td><td>Department</td><td>Agriculture and Farmers Welfare Department, Haryana, Panchkula.</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries engaged in manufacturing of physical/granulated mixture of macro and micro nutrient fertilizer.</td></tr><tr><td>4</td><td>Stage</td><td>Pre establishment for new industry and post establishment for renewal.</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>1.Rs. 1000/- to be paid online both for new and renewal cases.<br>2.Late fee of Rs. 100/- shall also be payable, if renewal applied after the date of expiry but within 1 month of date of expiry of the certificate.(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>1. Application in Form \u2018D\u2019 in duplicate.<br>2. Online payment of prescribed fee.<br>3. List of laboratory equipment/machinery prescribed under Clause 21 A of FCO, 1985.<br>4. In case of renewal, application thereof needs to be made before the expiry of the certificate.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>Application complete in all respect is accepted, processed and after finding the application fulfilling the prescribed documents/fee, the certificate of manufacture is issued by the Director/Director General, Agriculture and Farmer Welfare Department, Haryana, Panchkula.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table53/table53.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>9.1. AGRICULTURE DEPARTMENT</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><!--<thead>--><!--<tr>--><!--<th>SR.no</th>--><!--<th class="td-actions"></th>--><!--</tr>--><!--</thead>--><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>Certificate of manufacture in respect of special mixture of fertilizer.</td></tr><tr><td>2</td><td>Department</td><td>Agriculture and Farmers Welfare Department, Haryana, Panchkula.</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries engaged in manufacturing of Special mixture of fertilizers.</td></tr><tr><td>4</td><td>Stage</td><td>Post establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Rs. 500/- to be paid online.(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>1. Application in Form \u2018D\u2019 in duplicate.<br>2. Online payment of prescribed fee.<br>3. Attested copy of the requisition of the purchaser.<br>4. List of laboratory equipment/machinery prescribed under Clause 21 A of FCO, 1985.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>Application complete in all respect is accepted, processed and after finding the application fulfilling the prescribed documents/fee, the certificate of manufacture is issued by the Director/Director General, Agriculture and Farmer Welfare Department, Haryana, Panchkula notified as the Registering Authority under FCO, 1985.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/table54/table54.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>9.2. AGRICULTURE DEPARTMENT</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><!--<thead>--><!--<tr>--><!--<th>SR.no</th>--><!--<th class="td-actions"></th>--><!--</tr>--><!--</thead>--><tbody><tr><td>1</td><td>Name of approval/Noc/License/Registration</td><td>License to manufacture Insecticides/Pesticides.</td></tr><tr><td>2</td><td>Department</td><td>Agriculture and Farmers Welfare Department, Haryana, Panchkula.</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries engaged in manufacturing of Insecticides/Pesticides.</td></tr><tr><td>4</td><td>Stage</td><td>Post establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>45 Days</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>Online payment of fee @ Rs. 2000/- for every insecticide with a maximum of Rs. 20,000/- for all insecticides for which the license is applied.(Online Through HEPC Portl)</td></tr><tr><td>7</td><td>Documents Required</td><td>1. Application in Form-V<br>2. Self-attested copy of every certificate of registration of the Insecticide issued by CIB&RC.<br>3. For manufacture of Technical Grade pesticides \u2013 Self-attested copy of certificate of prescribed qualification of Doctorate in Chemistry/Agriculture Chemistry or M.Tech. /M.S. in Chemical Engineering.<br>4. For manufacture of pesticide formulations \u2013 Self-attested copy of certificate of prescribed qualification of Graduate Degree in Agriculture/Science with Chemistry as one of the subjects.<br>5. List of plant & Machineries.<br>6. List of Laboratory Equipment\u2019s.<br>7. Consent of medical doctor required under Rules 37 of Insecticides Rules, 1971.<br>8. List of First aid measures required under Rules 38 of insecticides Rules, 1971.</td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria/Procedure</td><td>Application complete in all respect is accepted, processed, unit is got inspected by the authorised Insecticide Inspector to ascertain existence of all prescribed equipment\u2019s/machinery/infrastructure etc. and, thereafter, licence to manufacture is issued by the Director/Director General, Agriculture and Farmer Welfare Department, Haryana, Panchkula notified as the Licensing Officer under the Insecticides Act, 1968.</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');
$templateCache.put('app/questionnaire/table/uhbvn2/uhbvn2.html','<div class="container"><div class="widget stacked widget-table action-table"><!--<div class="widget-header">--><!--<i class="icon-th-list"></i>--><!--<h3>2. UHBVN DEPARTMENT</h3>--><!--</div> &lt;!&ndash; /widget-header &ndash;&gt;--><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><td>1</td><td>Name of approval /Noc/License/Registration</td><td>Release of Temporary Connection</td></tr><tr><td>2</td><td>Department</td><td>UHBVN/DHBVN</td></tr><tr><td>3</td><td>Applicability criteria</td><td>This is applicable to all industries( Optional)</td></tr><tr><td>4</td><td>Stage</td><td>Pre Establishment</td></tr><tr><td>5</td><td>Given Time Limits</td><td>See annexure:-</td></tr><tr><td>6</td><td>Fee & mode of payment</td><td>HT ISC Connection (Above 50 KW Load) HT 11 KV Connection ADVANCE CONSUMPTION DEPOSIT (SECURITY) Rs. 4000/- per KW Processing Charges Rs. 25/- KW Service connection Charges = Rs.2000/- Per KVA (as per latest norms of the Nigam )(Online Through HEPC Portal)</td></tr><tr><td>7</td><td>Documents Required</td><td>\u2022 Proof of Ownership / Legal occupation of the premises.<br>Copy of sale deed/allotment letter or lease deed or rent deed in the name of the applicant<br>Property tax receipt or tax demand notice as proof of ownership and rent deed or any other legal proof of being a tenant and paying rent as proof of occupancy.<br>For agriculture supply connection\u2010 a copy of Khasra Girdawari/Jamabandi in the name of applicant<br>\u2022Proof of identity<br>Electoral identity card.<br>Passport<br>Driving license<br>Ration card<br>Photo identity card issued by a Govt. Agency<br>Pan card<br>Aadhar card<br>\u2022 Where the applicant is a Company, Trust, Educational Institution, Govt. Deptt., the application form shall be signed by an authorized person along with a relevant resolution/authority letter of the company/institution concerned. In case of a registered company all the Directors shall be jointly and severely liable.<br></td></tr><tr><td>8</td><td>Form submission</td><td><a href="https://investharyana.in/#/">https://investharyana.in/#/</a></td></tr><tr><td>9</td><td>Acceptance criteria</td><td>\u2022 Duly filled form<br>\u2022 List of supporting documents attached with the application.<br>\u2022 Payment of Fees</td></tr></tbody></table></div><!-- /widget-content --></div><!-- /widget --></div><br><div class="container"><div class="widget stacked widget-table action-table"><div class="widget-header"><i class="icon-th-list"></i><h3>Annexure:-</h3><h4><b>Time Lines for Release of Connection</b></h4></div><!-- /widget-header --><div class="widget-content"><table class="table table-striped table-bordered"><tbody><tr><th rowspan="2">Sr no.</th><th rowspan="2">Activity</th><th colspan="4">Time allowed (in days) for connections on</th></tr><tr><td>LT</td><td>11KV</td><td>33KV</td><td>Above 33KV</td></tr><tr><td>1</td><td>Acknowledgement of receipt of complete Application<br>Intimating Deficiencies to the applicant Attending Deficiencies by the applicant.</td><td colspan="4">Immediate<br>Within 2 days from the date of receipt of Application<br>Within 7 Days</td></tr><tr><td>2</td><td>Inspection of consumer premises</td><td colspan="4">Within 7 days from the date of receipt of complete application.</td></tr><tr><td>3</td><td>To issue the demand notice</td><td colspan="4">This is applicable to all industries( Optional)</td></tr><tr><td>4</td><td>Time limit for complying with the demand notice by the applicant</td><td colspan="4">Valid for 2 months in case of LT connections and 3 months in case of HT & AP connections, which may be further extended as per the Electricity Supply code on the request of consumer after paying the extension charges</td></tr><tr><td>5</td><td>To carry out inspection and Testing of consumer\u2019s installation by the licensee.</td><td>5</td><td>15</td><td>20</td><td>25</td></tr><tr><td>6</td><td>To issue service connection order.</td><td>5</td><td>5</td><td>5</td><td>10</td></tr><tr><td>7</td><td>Time limit for licensee/ applicant to complete the work required for Providing electric supply.</td><td>10</td><td>30</td><td>45</td><td>100</td></tr><tr><td>8</td><td>Time limit for release of connection to the applicant after completion of the work.</td><td>3</td><td>7</td><td>7</td><td>7</td></tr></tbody></table></div><!-- /widget-content --><div class="row footer"><div class="col-lg-12"><hr class="footer-line"><!--<button type="submit" class="btn btn-primary pull-right"  ui-sref="clearances">Back</button>--></div></div></div><!-- /widget --></div>');}]);})();